(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2888],{

/***/ 48260:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=CryptoOperation.js.map

/***/ }),

/***/ 16665:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=Key.js.map

/***/ }),

/***/ 35470:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=KeyOperation.js.map

/***/ }),

/***/ 30969:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
//# sourceMappingURL=MsSubtleCrypto.js.map

/***/ }),

/***/ 55287:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isMsWindow = void 0;
var msSubtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function quacksLikeAnMsWindow(window) {
    return "MSInputMethodContext" in window && "msCrypto" in window;
}
/**
 * Determines if the provided window is (or is like) the window object one would
 * expect to encounter in Internet Explorer 11.
 */
function isMsWindow(window) {
    if (quacksLikeAnMsWindow(window) && window.msCrypto.subtle !== undefined) {
        var _a = window.msCrypto, getRandomValues = _a.getRandomValues, subtle_1 = _a.subtle;
        return msSubtleCryptoMethods
            .map(function (methodName) { return subtle_1[methodName]; })
            .concat(getRandomValues)
            .every(function (method) { return typeof method === "function"; });
    }
    return false;
}
exports.isMsWindow = isMsWindow;
//# sourceMappingURL=MsWindow.js.map

/***/ }),

/***/ 40087:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var tslib_1 = __webpack_require__(11980);
tslib_1.__exportStar(__webpack_require__(48260), exports);
tslib_1.__exportStar(__webpack_require__(16665), exports);
tslib_1.__exportStar(__webpack_require__(35470), exports);
tslib_1.__exportStar(__webpack_require__(30969), exports);
tslib_1.__exportStar(__webpack_require__(55287), exports);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 11980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__assign": function() { return /* binding */ __assign; },
/* harmony export */   "__asyncDelegator": function() { return /* binding */ __asyncDelegator; },
/* harmony export */   "__asyncGenerator": function() { return /* binding */ __asyncGenerator; },
/* harmony export */   "__asyncValues": function() { return /* binding */ __asyncValues; },
/* harmony export */   "__await": function() { return /* binding */ __await; },
/* harmony export */   "__awaiter": function() { return /* binding */ __awaiter; },
/* harmony export */   "__classPrivateFieldGet": function() { return /* binding */ __classPrivateFieldGet; },
/* harmony export */   "__classPrivateFieldSet": function() { return /* binding */ __classPrivateFieldSet; },
/* harmony export */   "__createBinding": function() { return /* binding */ __createBinding; },
/* harmony export */   "__decorate": function() { return /* binding */ __decorate; },
/* harmony export */   "__exportStar": function() { return /* binding */ __exportStar; },
/* harmony export */   "__extends": function() { return /* binding */ __extends; },
/* harmony export */   "__generator": function() { return /* binding */ __generator; },
/* harmony export */   "__importDefault": function() { return /* binding */ __importDefault; },
/* harmony export */   "__importStar": function() { return /* binding */ __importStar; },
/* harmony export */   "__makeTemplateObject": function() { return /* binding */ __makeTemplateObject; },
/* harmony export */   "__metadata": function() { return /* binding */ __metadata; },
/* harmony export */   "__param": function() { return /* binding */ __param; },
/* harmony export */   "__read": function() { return /* binding */ __read; },
/* harmony export */   "__rest": function() { return /* binding */ __rest; },
/* harmony export */   "__spread": function() { return /* binding */ __spread; },
/* harmony export */   "__spreadArrays": function() { return /* binding */ __spreadArrays; },
/* harmony export */   "__values": function() { return /* binding */ __values; }
/* harmony export */ });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),

/***/ 57333:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.EMPTY_DATA_SHA_256 = exports.SHA_256_HMAC_ALGO = exports.SHA_256_HASH = void 0;
exports.SHA_256_HASH = { name: "SHA-256" };
exports.SHA_256_HMAC_ALGO = {
    name: "HMAC",
    hash: exports.SHA_256_HASH
};
exports.EMPTY_DATA_SHA_256 = new Uint8Array([
    227,
    176,
    196,
    66,
    152,
    252,
    28,
    20,
    154,
    251,
    244,
    200,
    153,
    111,
    185,
    36,
    39,
    174,
    65,
    228,
    100,
    155,
    147,
    76,
    164,
    149,
    153,
    27,
    120,
    82,
    184,
    85
]);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY29uc3RhbnRzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2NvbnN0YW50cy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBYSxRQUFBLFlBQVksR0FBd0IsRUFBRSxJQUFJLEVBQUUsU0FBUyxFQUFFLENBQUM7QUFFeEQsUUFBQSxpQkFBaUIsR0FBZ0Q7SUFDNUUsSUFBSSxFQUFFLE1BQU07SUFDWixJQUFJLEVBQUUsb0JBQVk7Q0FDbkIsQ0FBQztBQUVXLFFBQUEsa0JBQWtCLEdBQUcsSUFBSSxVQUFVLENBQUM7SUFDL0MsR0FBRztJQUNILEdBQUc7SUFDSCxHQUFHO0lBQ0gsRUFBRTtJQUNGLEdBQUc7SUFDSCxHQUFHO0lBQ0gsRUFBRTtJQUNGLEVBQUU7SUFDRixHQUFHO0lBQ0gsR0FBRztJQUNILEdBQUc7SUFDSCxHQUFHO0lBQ0gsR0FBRztJQUNILEdBQUc7SUFDSCxHQUFHO0lBQ0gsRUFBRTtJQUNGLEVBQUU7SUFDRixHQUFHO0lBQ0gsRUFBRTtJQUNGLEdBQUc7SUFDSCxHQUFHO0lBQ0gsR0FBRztJQUNILEdBQUc7SUFDSCxFQUFFO0lBQ0YsR0FBRztJQUNILEdBQUc7SUFDSCxHQUFHO0lBQ0gsRUFBRTtJQUNGLEdBQUc7SUFDSCxFQUFFO0lBQ0YsR0FBRztJQUNILEVBQUU7Q0FDSCxDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJleHBvcnQgY29uc3QgU0hBXzI1Nl9IQVNIOiB7IG5hbWU6IFwiU0hBLTI1NlwiIH0gPSB7IG5hbWU6IFwiU0hBLTI1NlwiIH07XG5cbmV4cG9ydCBjb25zdCBTSEFfMjU2X0hNQUNfQUxHTzogeyBuYW1lOiBcIkhNQUNcIjsgaGFzaDogeyBuYW1lOiBcIlNIQS0yNTZcIiB9IH0gPSB7XG4gIG5hbWU6IFwiSE1BQ1wiLFxuICBoYXNoOiBTSEFfMjU2X0hBU0hcbn07XG5cbmV4cG9ydCBjb25zdCBFTVBUWV9EQVRBX1NIQV8yNTYgPSBuZXcgVWludDhBcnJheShbXG4gIDIyNyxcbiAgMTc2LFxuICAxOTYsXG4gIDY2LFxuICAxNTIsXG4gIDI1MixcbiAgMjgsXG4gIDIwLFxuICAxNTQsXG4gIDI1MSxcbiAgMjQ0LFxuICAyMDAsXG4gIDE1MyxcbiAgMTExLFxuICAxODUsXG4gIDM2LFxuICAzOSxcbiAgMTc0LFxuICA2NSxcbiAgMjI4LFxuICAxMDAsXG4gIDE1NSxcbiAgMTQ3LFxuICA3NixcbiAgMTY0LFxuICAxNDksXG4gIDE1MyxcbiAgMjcsXG4gIDEyMCxcbiAgODIsXG4gIDE4NCxcbiAgODVcbl0pO1xuIl19

/***/ }),

/***/ 52769:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Sha256 = void 0;
var ie11Sha256_1 = __webpack_require__(63479);
var webCryptoSha256_1 = __webpack_require__(38889);
var sha256_js_1 = __webpack_require__(41938);
var supports_web_crypto_1 = __webpack_require__(21);
var ie11_detection_1 = __webpack_require__(40087);
var util_locate_window_1 = __webpack_require__(56495);
var Sha256 = /** @class */ (function () {
    function Sha256(secret) {
        if ((0, supports_web_crypto_1.supportsWebCrypto)((0, util_locate_window_1.locateWindow)())) {
            this.hash = new webCryptoSha256_1.Sha256(secret);
        }
        else if ((0, ie11_detection_1.isMsWindow)((0, util_locate_window_1.locateWindow)())) {
            this.hash = new ie11Sha256_1.Sha256(secret);
        }
        else {
            this.hash = new sha256_js_1.Sha256(secret);
        }
    }
    Sha256.prototype.update = function (data, encoding) {
        this.hash.update(data, encoding);
    };
    Sha256.prototype.digest = function () {
        return this.hash.digest();
    };
    return Sha256;
}());
exports.Sha256 = Sha256;
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 63479:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Sha256 = void 0;
var isEmptyData_1 = __webpack_require__(38036);
var constants_1 = __webpack_require__(57333);
var util_utf8_browser_1 = __webpack_require__(19193);
var util_locate_window_1 = __webpack_require__(56495);
var Sha256 = /** @class */ (function () {
    function Sha256(secret) {
        if (secret) {
            this.operation = getKeyPromise(secret).then(function (keyData) {
                return (0, util_locate_window_1.locateWindow)().msCrypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, keyData);
            });
            this.operation.catch(function () { });
        }
        else {
            this.operation = Promise.resolve((0, util_locate_window_1.locateWindow)().msCrypto.subtle.digest("SHA-256"));
        }
    }
    Sha256.prototype.update = function (toHash) {
        var _this = this;
        if ((0, isEmptyData_1.isEmptyData)(toHash)) {
            return;
        }
        this.operation = this.operation.then(function (operation) {
            operation.onerror = function () {
                _this.operation = Promise.reject(new Error("Error encountered updating hash"));
            };
            operation.process(toArrayBufferView(toHash));
            return operation;
        });
        this.operation.catch(function () { });
    };
    Sha256.prototype.digest = function () {
        return this.operation.then(function (operation) {
            return new Promise(function (resolve, reject) {
                operation.onerror = function () {
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.oncomplete = function () {
                    if (operation.result) {
                        resolve(new Uint8Array(operation.result));
                    }
                    reject(new Error("Error encountered finalizing hash"));
                };
                operation.finish();
            });
        });
    };
    return Sha256;
}());
exports.Sha256 = Sha256;
function getKeyPromise(secret) {
    return new Promise(function (resolve, reject) {
        var keyOperation = (0, util_locate_window_1.locateWindow)().msCrypto.subtle.importKey("raw", toArrayBufferView(secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"]);
        keyOperation.oncomplete = function () {
            if (keyOperation.result) {
                resolve(keyOperation.result);
            }
            reject(new Error("ImportKey completed without importing key."));
        };
        keyOperation.onerror = function () {
            reject(new Error("ImportKey failed to import key."));
        };
    });
}
function toArrayBufferView(data) {
    if (typeof data === "string") {
        return (0, util_utf8_browser_1.fromUtf8)(data);
    }
    if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    }
    return new Uint8Array(data);
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 77643:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.WebCryptoSha256 = exports.Ie11Sha256 = void 0;
var tslib_1 = __webpack_require__(75789);
(0, tslib_1.__exportStar)(__webpack_require__(52769), exports);
var ie11Sha256_1 = __webpack_require__(63479);
Object.defineProperty(exports, "Ie11Sha256", ({ enumerable: true, get: function () { return ie11Sha256_1.Sha256; } }));
var webCryptoSha256_1 = __webpack_require__(38889);
Object.defineProperty(exports, "WebCryptoSha256", ({ enumerable: true, get: function () { return webCryptoSha256_1.Sha256; } }));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7OztBQUFBLHFFQUFzQztBQUN0QywyQ0FBb0Q7QUFBM0Msd0dBQUEsTUFBTSxPQUFjO0FBQzdCLHFEQUE4RDtBQUFyRCxrSEFBQSxNQUFNLE9BQW1CIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0ICogZnJvbSBcIi4vY3Jvc3NQbGF0Zm9ybVNoYTI1NlwiO1xuZXhwb3J0IHsgU2hhMjU2IGFzIEllMTFTaGEyNTYgfSBmcm9tIFwiLi9pZTExU2hhMjU2XCI7XG5leHBvcnQgeyBTaGEyNTYgYXMgV2ViQ3J5cHRvU2hhMjU2IH0gZnJvbSBcIi4vd2ViQ3J5cHRvU2hhMjU2XCI7XG4iXX0=

/***/ }),

/***/ 38036:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") {
        return data.length === 0;
    }
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaXNFbXB0eURhdGEuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaXNFbXB0eURhdGEudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRUEsU0FBZ0IsV0FBVyxDQUFDLElBQWdCO0lBQzFDLElBQUksT0FBTyxJQUFJLEtBQUssUUFBUSxFQUFFO1FBQzVCLE9BQU8sSUFBSSxDQUFDLE1BQU0sS0FBSyxDQUFDLENBQUM7S0FDMUI7SUFFRCxPQUFPLElBQUksQ0FBQyxVQUFVLEtBQUssQ0FBQyxDQUFDO0FBQy9CLENBQUM7QUFORCxrQ0FNQyIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IFNvdXJjZURhdGEgfSBmcm9tIFwiQGF3cy1zZGsvdHlwZXNcIjtcblxuZXhwb3J0IGZ1bmN0aW9uIGlzRW1wdHlEYXRhKGRhdGE6IFNvdXJjZURhdGEpOiBib29sZWFuIHtcbiAgaWYgKHR5cGVvZiBkYXRhID09PSBcInN0cmluZ1wiKSB7XG4gICAgcmV0dXJuIGRhdGEubGVuZ3RoID09PSAwO1xuICB9XG5cbiAgcmV0dXJuIGRhdGEuYnl0ZUxlbmd0aCA9PT0gMDtcbn1cbiJdfQ==

/***/ }),

/***/ 38889:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Sha256 = void 0;
var util_1 = __webpack_require__(17658);
var constants_1 = __webpack_require__(57333);
var util_locate_window_1 = __webpack_require__(56495);
var Sha256 = /** @class */ (function () {
    function Sha256(secret) {
        this.toHash = new Uint8Array(0);
        if (secret !== void 0) {
            this.key = new Promise(function (resolve, reject) {
                (0, util_locate_window_1.locateWindow)()
                    .crypto.subtle.importKey("raw", (0, util_1.convertToBuffer)(secret), constants_1.SHA_256_HMAC_ALGO, false, ["sign"])
                    .then(resolve, reject);
            });
            this.key.catch(function () { });
        }
    }
    Sha256.prototype.update = function (data) {
        if ((0, util_1.isEmptyData)(data)) {
            return;
        }
        var update = (0, util_1.convertToBuffer)(data);
        var typedArray = new Uint8Array(this.toHash.byteLength + update.byteLength);
        typedArray.set(this.toHash, 0);
        typedArray.set(update, this.toHash.byteLength);
        this.toHash = typedArray;
    };
    Sha256.prototype.digest = function () {
        var _this = this;
        if (this.key) {
            return this.key.then(function (key) {
                return (0, util_locate_window_1.locateWindow)()
                    .crypto.subtle.sign(constants_1.SHA_256_HMAC_ALGO, key, _this.toHash)
                    .then(function (data) { return new Uint8Array(data); });
            });
        }
        if ((0, util_1.isEmptyData)(this.toHash)) {
            return Promise.resolve(constants_1.EMPTY_DATA_SHA_256);
        }
        return Promise.resolve()
            .then(function () {
            return (0, util_locate_window_1.locateWindow)().crypto.subtle.digest(constants_1.SHA_256_HASH, _this.toHash);
        })
            .then(function (data) { return Promise.resolve(new Uint8Array(data)); });
    };
    return Sha256;
}());
exports.Sha256 = Sha256;
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 75789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__assign": function() { return /* binding */ __assign; },
/* harmony export */   "__asyncDelegator": function() { return /* binding */ __asyncDelegator; },
/* harmony export */   "__asyncGenerator": function() { return /* binding */ __asyncGenerator; },
/* harmony export */   "__asyncValues": function() { return /* binding */ __asyncValues; },
/* harmony export */   "__await": function() { return /* binding */ __await; },
/* harmony export */   "__awaiter": function() { return /* binding */ __awaiter; },
/* harmony export */   "__classPrivateFieldGet": function() { return /* binding */ __classPrivateFieldGet; },
/* harmony export */   "__classPrivateFieldSet": function() { return /* binding */ __classPrivateFieldSet; },
/* harmony export */   "__createBinding": function() { return /* binding */ __createBinding; },
/* harmony export */   "__decorate": function() { return /* binding */ __decorate; },
/* harmony export */   "__exportStar": function() { return /* binding */ __exportStar; },
/* harmony export */   "__extends": function() { return /* binding */ __extends; },
/* harmony export */   "__generator": function() { return /* binding */ __generator; },
/* harmony export */   "__importDefault": function() { return /* binding */ __importDefault; },
/* harmony export */   "__importStar": function() { return /* binding */ __importStar; },
/* harmony export */   "__makeTemplateObject": function() { return /* binding */ __makeTemplateObject; },
/* harmony export */   "__metadata": function() { return /* binding */ __metadata; },
/* harmony export */   "__param": function() { return /* binding */ __param; },
/* harmony export */   "__read": function() { return /* binding */ __read; },
/* harmony export */   "__rest": function() { return /* binding */ __rest; },
/* harmony export */   "__spread": function() { return /* binding */ __spread; },
/* harmony export */   "__spreadArrays": function() { return /* binding */ __spreadArrays; },
/* harmony export */   "__values": function() { return /* binding */ __values; }
/* harmony export */ });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),

/***/ 10914:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.RawSha256 = void 0;
var constants_1 = __webpack_require__(89945);
/**
 * @internal
 */
var RawSha256 = /** @class */ (function () {
    function RawSha256() {
        this.state = Int32Array.from(constants_1.INIT);
        this.temp = new Int32Array(64);
        this.buffer = new Uint8Array(64);
        this.bufferLength = 0;
        this.bytesHashed = 0;
        /**
         * @internal
         */
        this.finished = false;
    }
    RawSha256.prototype.update = function (data) {
        if (this.finished) {
            throw new Error("Attempted to update an already finished hash.");
        }
        var position = 0;
        var byteLength = data.byteLength;
        this.bytesHashed += byteLength;
        if (this.bytesHashed * 8 > constants_1.MAX_HASHABLE_LENGTH) {
            throw new Error("Cannot hash more than 2^53 - 1 bits");
        }
        while (byteLength > 0) {
            this.buffer[this.bufferLength++] = data[position++];
            byteLength--;
            if (this.bufferLength === constants_1.BLOCK_SIZE) {
                this.hashBuffer();
                this.bufferLength = 0;
            }
        }
    };
    RawSha256.prototype.digest = function () {
        if (!this.finished) {
            var bitsHashed = this.bytesHashed * 8;
            var bufferView = new DataView(this.buffer.buffer, this.buffer.byteOffset, this.buffer.byteLength);
            var undecoratedLength = this.bufferLength;
            bufferView.setUint8(this.bufferLength++, 0x80);
            // Ensure the final block has enough room for the hashed length
            if (undecoratedLength % constants_1.BLOCK_SIZE >= constants_1.BLOCK_SIZE - 8) {
                for (var i = this.bufferLength; i < constants_1.BLOCK_SIZE; i++) {
                    bufferView.setUint8(i, 0);
                }
                this.hashBuffer();
                this.bufferLength = 0;
            }
            for (var i = this.bufferLength; i < constants_1.BLOCK_SIZE - 8; i++) {
                bufferView.setUint8(i, 0);
            }
            bufferView.setUint32(constants_1.BLOCK_SIZE - 8, Math.floor(bitsHashed / 0x100000000), true);
            bufferView.setUint32(constants_1.BLOCK_SIZE - 4, bitsHashed);
            this.hashBuffer();
            this.finished = true;
        }
        // The value in state is little-endian rather than big-endian, so flip
        // each word into a new Uint8Array
        var out = new Uint8Array(constants_1.DIGEST_LENGTH);
        for (var i = 0; i < 8; i++) {
            out[i * 4] = (this.state[i] >>> 24) & 0xff;
            out[i * 4 + 1] = (this.state[i] >>> 16) & 0xff;
            out[i * 4 + 2] = (this.state[i] >>> 8) & 0xff;
            out[i * 4 + 3] = (this.state[i] >>> 0) & 0xff;
        }
        return out;
    };
    RawSha256.prototype.hashBuffer = function () {
        var _a = this, buffer = _a.buffer, state = _a.state;
        var state0 = state[0], state1 = state[1], state2 = state[2], state3 = state[3], state4 = state[4], state5 = state[5], state6 = state[6], state7 = state[7];
        for (var i = 0; i < constants_1.BLOCK_SIZE; i++) {
            if (i < 16) {
                this.temp[i] =
                    ((buffer[i * 4] & 0xff) << 24) |
                        ((buffer[i * 4 + 1] & 0xff) << 16) |
                        ((buffer[i * 4 + 2] & 0xff) << 8) |
                        (buffer[i * 4 + 3] & 0xff);
            }
            else {
                var u = this.temp[i - 2];
                var t1_1 = ((u >>> 17) | (u << 15)) ^ ((u >>> 19) | (u << 13)) ^ (u >>> 10);
                u = this.temp[i - 15];
                var t2_1 = ((u >>> 7) | (u << 25)) ^ ((u >>> 18) | (u << 14)) ^ (u >>> 3);
                this.temp[i] =
                    ((t1_1 + this.temp[i - 7]) | 0) + ((t2_1 + this.temp[i - 16]) | 0);
            }
            var t1 = ((((((state4 >>> 6) | (state4 << 26)) ^
                ((state4 >>> 11) | (state4 << 21)) ^
                ((state4 >>> 25) | (state4 << 7))) +
                ((state4 & state5) ^ (~state4 & state6))) |
                0) +
                ((state7 + ((constants_1.KEY[i] + this.temp[i]) | 0)) | 0)) |
                0;
            var t2 = ((((state0 >>> 2) | (state0 << 30)) ^
                ((state0 >>> 13) | (state0 << 19)) ^
                ((state0 >>> 22) | (state0 << 10))) +
                ((state0 & state1) ^ (state0 & state2) ^ (state1 & state2))) |
                0;
            state7 = state6;
            state6 = state5;
            state5 = state4;
            state4 = (state3 + t1) | 0;
            state3 = state2;
            state2 = state1;
            state1 = state0;
            state0 = (t1 + t2) | 0;
        }
        state[0] += state0;
        state[1] += state1;
        state[2] += state2;
        state[3] += state3;
        state[4] += state4;
        state[5] += state5;
        state[6] += state6;
        state[7] += state7;
    };
    return RawSha256;
}());
exports.RawSha256 = RawSha256;
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 89945:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.MAX_HASHABLE_LENGTH = exports.INIT = exports.KEY = exports.DIGEST_LENGTH = exports.BLOCK_SIZE = void 0;
/**
 * @internal
 */
exports.BLOCK_SIZE = 64;
/**
 * @internal
 */
exports.DIGEST_LENGTH = 32;
/**
 * @internal
 */
exports.KEY = new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
/**
 * @internal
 */
exports.INIT = [
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
];
/**
 * @internal
 */
exports.MAX_HASHABLE_LENGTH = Math.pow(2, 53) - 1;
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 41938:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var tslib_1 = __webpack_require__(73541);
(0, tslib_1.__exportStar)(__webpack_require__(65430), exports);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsMERBQTJCIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0ICogZnJvbSBcIi4vanNTaGEyNTZcIjtcbiJdfQ==

/***/ }),

/***/ 65430:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.Sha256 = void 0;
var tslib_1 = __webpack_require__(73541);
var constants_1 = __webpack_require__(89945);
var RawSha256_1 = __webpack_require__(10914);
var util_1 = __webpack_require__(17658);
var Sha256 = /** @class */ (function () {
    function Sha256(secret) {
        this.hash = new RawSha256_1.RawSha256();
        if (secret) {
            this.outer = new RawSha256_1.RawSha256();
            var inner = bufferFromSecret(secret);
            var outer = new Uint8Array(constants_1.BLOCK_SIZE);
            outer.set(inner);
            for (var i = 0; i < constants_1.BLOCK_SIZE; i++) {
                inner[i] ^= 0x36;
                outer[i] ^= 0x5c;
            }
            this.hash.update(inner);
            this.outer.update(outer);
            // overwrite the copied key in memory
            for (var i = 0; i < inner.byteLength; i++) {
                inner[i] = 0;
            }
        }
    }
    Sha256.prototype.update = function (toHash) {
        if ((0, util_1.isEmptyData)(toHash) || this.error) {
            return;
        }
        try {
            this.hash.update((0, util_1.convertToBuffer)(toHash));
        }
        catch (e) {
            this.error = e;
        }
    };
    /* This synchronous method keeps compatibility
     * with the v2 aws-sdk.
     */
    Sha256.prototype.digestSync = function () {
        if (this.error) {
            throw this.error;
        }
        if (this.outer) {
            if (!this.outer.finished) {
                this.outer.update(this.hash.digest());
            }
            return this.outer.digest();
        }
        return this.hash.digest();
    };
    /* The underlying digest method here is synchronous.
     * To keep the same interface with the other hash functions
     * the default is to expose this as an async method.
     * However, it can sometimes be useful to have a sync method.
     */
    Sha256.prototype.digest = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                return [2 /*return*/, this.digestSync()];
            });
        });
    };
    return Sha256;
}());
exports.Sha256 = Sha256;
function bufferFromSecret(secret) {
    var input = (0, util_1.convertToBuffer)(secret);
    if (input.byteLength > constants_1.BLOCK_SIZE) {
        var bufferHash = new RawSha256_1.RawSha256();
        bufferHash.update(input);
        input = bufferHash.digest();
    }
    var buffer = new Uint8Array(constants_1.BLOCK_SIZE);
    buffer.set(input);
    return buffer;
}
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 73541:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__assign": function() { return /* binding */ __assign; },
/* harmony export */   "__asyncDelegator": function() { return /* binding */ __asyncDelegator; },
/* harmony export */   "__asyncGenerator": function() { return /* binding */ __asyncGenerator; },
/* harmony export */   "__asyncValues": function() { return /* binding */ __asyncValues; },
/* harmony export */   "__await": function() { return /* binding */ __await; },
/* harmony export */   "__awaiter": function() { return /* binding */ __awaiter; },
/* harmony export */   "__classPrivateFieldGet": function() { return /* binding */ __classPrivateFieldGet; },
/* harmony export */   "__classPrivateFieldSet": function() { return /* binding */ __classPrivateFieldSet; },
/* harmony export */   "__createBinding": function() { return /* binding */ __createBinding; },
/* harmony export */   "__decorate": function() { return /* binding */ __decorate; },
/* harmony export */   "__exportStar": function() { return /* binding */ __exportStar; },
/* harmony export */   "__extends": function() { return /* binding */ __extends; },
/* harmony export */   "__generator": function() { return /* binding */ __generator; },
/* harmony export */   "__importDefault": function() { return /* binding */ __importDefault; },
/* harmony export */   "__importStar": function() { return /* binding */ __importStar; },
/* harmony export */   "__makeTemplateObject": function() { return /* binding */ __makeTemplateObject; },
/* harmony export */   "__metadata": function() { return /* binding */ __metadata; },
/* harmony export */   "__param": function() { return /* binding */ __param; },
/* harmony export */   "__read": function() { return /* binding */ __read; },
/* harmony export */   "__rest": function() { return /* binding */ __rest; },
/* harmony export */   "__spread": function() { return /* binding */ __spread; },
/* harmony export */   "__spreadArrays": function() { return /* binding */ __spreadArrays; },
/* harmony export */   "__values": function() { return /* binding */ __values; }
/* harmony export */ });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),

/***/ 21:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
var tslib_1 = __webpack_require__(57840);
tslib_1.__exportStar(__webpack_require__(97787), exports);
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsOERBQW9DIiwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0ICogZnJvbSBcIi4vc3VwcG9ydHNXZWJDcnlwdG9cIjtcbiJdfQ==

/***/ }),

/***/ 97787:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.supportsZeroByteGCM = exports.supportsSubtleCrypto = exports.supportsSecureRandom = exports.supportsWebCrypto = void 0;
var tslib_1 = __webpack_require__(57840);
var subtleCryptoMethods = [
    "decrypt",
    "digest",
    "encrypt",
    "exportKey",
    "generateKey",
    "importKey",
    "sign",
    "verify"
];
function supportsWebCrypto(window) {
    if (supportsSecureRandom(window) &&
        typeof window.crypto.subtle === "object") {
        var subtle = window.crypto.subtle;
        return supportsSubtleCrypto(subtle);
    }
    return false;
}
exports.supportsWebCrypto = supportsWebCrypto;
function supportsSecureRandom(window) {
    if (typeof window === "object" && typeof window.crypto === "object") {
        var getRandomValues = window.crypto.getRandomValues;
        return typeof getRandomValues === "function";
    }
    return false;
}
exports.supportsSecureRandom = supportsSecureRandom;
function supportsSubtleCrypto(subtle) {
    return (subtle &&
        subtleCryptoMethods.every(function (methodName) { return typeof subtle[methodName] === "function"; }));
}
exports.supportsSubtleCrypto = supportsSubtleCrypto;
function supportsZeroByteGCM(subtle) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var key, zeroByteAuthTag, _a;
        return tslib_1.__generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!supportsSubtleCrypto(subtle))
                        return [2 /*return*/, false];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, , 5]);
                    return [4 /*yield*/, subtle.generateKey({ name: "AES-GCM", length: 128 }, false, ["encrypt"])];
                case 2:
                    key = _b.sent();
                    return [4 /*yield*/, subtle.encrypt({
                            name: "AES-GCM",
                            iv: new Uint8Array(Array(12)),
                            additionalData: new Uint8Array(Array(16)),
                            tagLength: 128
                        }, key, new Uint8Array(0))];
                case 3:
                    zeroByteAuthTag = _b.sent();
                    return [2 /*return*/, zeroByteAuthTag.byteLength === 16];
                case 4:
                    _a = _b.sent();
                    return [2 /*return*/, false];
                case 5: return [2 /*return*/];
            }
        });
    });
}
exports.supportsZeroByteGCM = supportsZeroByteGCM;
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 57840:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__assign": function() { return /* binding */ __assign; },
/* harmony export */   "__asyncDelegator": function() { return /* binding */ __asyncDelegator; },
/* harmony export */   "__asyncGenerator": function() { return /* binding */ __asyncGenerator; },
/* harmony export */   "__asyncValues": function() { return /* binding */ __asyncValues; },
/* harmony export */   "__await": function() { return /* binding */ __await; },
/* harmony export */   "__awaiter": function() { return /* binding */ __awaiter; },
/* harmony export */   "__classPrivateFieldGet": function() { return /* binding */ __classPrivateFieldGet; },
/* harmony export */   "__classPrivateFieldSet": function() { return /* binding */ __classPrivateFieldSet; },
/* harmony export */   "__createBinding": function() { return /* binding */ __createBinding; },
/* harmony export */   "__decorate": function() { return /* binding */ __decorate; },
/* harmony export */   "__exportStar": function() { return /* binding */ __exportStar; },
/* harmony export */   "__extends": function() { return /* binding */ __extends; },
/* harmony export */   "__generator": function() { return /* binding */ __generator; },
/* harmony export */   "__importDefault": function() { return /* binding */ __importDefault; },
/* harmony export */   "__importStar": function() { return /* binding */ __importStar; },
/* harmony export */   "__makeTemplateObject": function() { return /* binding */ __makeTemplateObject; },
/* harmony export */   "__metadata": function() { return /* binding */ __metadata; },
/* harmony export */   "__param": function() { return /* binding */ __param; },
/* harmony export */   "__read": function() { return /* binding */ __read; },
/* harmony export */   "__rest": function() { return /* binding */ __rest; },
/* harmony export */   "__spread": function() { return /* binding */ __spread; },
/* harmony export */   "__spreadArrays": function() { return /* binding */ __spreadArrays; },
/* harmony export */   "__values": function() { return /* binding */ __values; }
/* harmony export */ });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}

function __exportStar(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result.default = mod;
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, privateMap) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to get private field on non-instance");
    }
    return privateMap.get(receiver);
}

function __classPrivateFieldSet(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) {
        throw new TypeError("attempted to set private field on non-instance");
    }
    privateMap.set(receiver, value);
    return value;
}


/***/ }),

/***/ 51106:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];

// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.convertToBuffer = void 0;
var util_utf8_browser_1 = __webpack_require__(19193);
// Quick polyfill
var fromUtf8 = typeof Buffer !== "undefined" && Buffer.from
    ? function (input) { return Buffer.from(input, "utf8"); }
    : util_utf8_browser_1.fromUtf8;
function convertToBuffer(data) {
    // Already a Uint8, do nothing
    if (data instanceof Uint8Array)
        return data;
    if (typeof data === "string") {
        return fromUtf8(data);
    }
    if (ArrayBuffer.isView(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength / Uint8Array.BYTES_PER_ELEMENT);
    }
    return new Uint8Array(data);
}
exports.convertToBuffer = convertToBuffer;
//# sourceMappingURL=convertToBuffer.js.map

/***/ }),

/***/ 17658:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.uint32ArrayFrom = exports.numToUint8 = exports.isEmptyData = exports.convertToBuffer = void 0;
var convertToBuffer_1 = __webpack_require__(51106);
Object.defineProperty(exports, "convertToBuffer", ({ enumerable: true, get: function () { return convertToBuffer_1.convertToBuffer; } }));
var isEmptyData_1 = __webpack_require__(84304);
Object.defineProperty(exports, "isEmptyData", ({ enumerable: true, get: function () { return isEmptyData_1.isEmptyData; } }));
var numToUint8_1 = __webpack_require__(22174);
Object.defineProperty(exports, "numToUint8", ({ enumerable: true, get: function () { return numToUint8_1.numToUint8; } }));
var uint32ArrayFrom_1 = __webpack_require__(81558);
Object.defineProperty(exports, "uint32ArrayFrom", ({ enumerable: true, get: function () { return uint32ArrayFrom_1.uint32ArrayFrom; } }));
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 84304:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.isEmptyData = void 0;
function isEmptyData(data) {
    if (typeof data === "string") {
        return data.length === 0;
    }
    return data.byteLength === 0;
}
exports.isEmptyData = isEmptyData;
//# sourceMappingURL=isEmptyData.js.map

/***/ }),

/***/ 22174:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.numToUint8 = void 0;
function numToUint8(num) {
    return new Uint8Array([
        (num & 0xff000000) >> 24,
        (num & 0x00ff0000) >> 16,
        (num & 0x0000ff00) >> 8,
        num & 0x000000ff,
    ]);
}
exports.numToUint8 = numToUint8;
//# sourceMappingURL=numToUint8.js.map

/***/ }),

/***/ 81558:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// Copyright Amazon.com Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", ({ value: true }));
exports.uint32ArrayFrom = void 0;
// IE 11 does not support Array.from, so we do it manually
function uint32ArrayFrom(a_lookUpTable) {
    if (!Uint32Array.from) {
        var return_array = new Uint32Array(a_lookUpTable.length);
        var a_index = 0;
        while (a_index < a_lookUpTable.length) {
            return_array[a_index] = a_lookUpTable[a_index];
            a_index += 1;
        }
        return return_array;
    }
    return Uint32Array.from(a_lookUpTable);
}
exports.uint32ArrayFrom = uint32ArrayFrom;
//# sourceMappingURL=uint32ArrayFrom.js.map

/***/ }),

/***/ 56495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "locateWindow": function() { return /* binding */ locateWindow; }
/* harmony export */ });
const fallbackWindow = {};
function locateWindow() {
    if (typeof window !== "undefined") {
        return window;
    }
    else if (typeof self !== "undefined") {
        return self;
    }
    return fallbackWindow;
}


/***/ }),

/***/ 19193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "fromUtf8": function() { return /* binding */ dist_es_fromUtf8; },
  "toUtf8": function() { return /* binding */ dist_es_toUtf8; }
});

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-utf8-browser/dist-es/pureJs.js
const fromUtf8 = (input) => {
    const bytes = [];
    for (let i = 0, len = input.length; i < len; i++) {
        const value = input.charCodeAt(i);
        if (value < 0x80) {
            bytes.push(value);
        }
        else if (value < 0x800) {
            bytes.push((value >> 6) | 0b11000000, (value & 0b111111) | 0b10000000);
        }
        else if (i + 1 < input.length && (value & 0xfc00) === 0xd800 && (input.charCodeAt(i + 1) & 0xfc00) === 0xdc00) {
            const surrogatePair = 0x10000 + ((value & 0b1111111111) << 10) + (input.charCodeAt(++i) & 0b1111111111);
            bytes.push((surrogatePair >> 18) | 0b11110000, ((surrogatePair >> 12) & 0b111111) | 0b10000000, ((surrogatePair >> 6) & 0b111111) | 0b10000000, (surrogatePair & 0b111111) | 0b10000000);
        }
        else {
            bytes.push((value >> 12) | 0b11100000, ((value >> 6) & 0b111111) | 0b10000000, (value & 0b111111) | 0b10000000);
        }
    }
    return Uint8Array.from(bytes);
};
const toUtf8 = (input) => {
    let decoded = "";
    for (let i = 0, len = input.length; i < len; i++) {
        const byte = input[i];
        if (byte < 0x80) {
            decoded += String.fromCharCode(byte);
        }
        else if (0b11000000 <= byte && byte < 0b11100000) {
            const nextByte = input[++i];
            decoded += String.fromCharCode(((byte & 0b11111) << 6) | (nextByte & 0b111111));
        }
        else if (0b11110000 <= byte && byte < 0b101101101) {
            const surrogatePair = [byte, input[++i], input[++i], input[++i]];
            const encoded = "%" + surrogatePair.map((byteValue) => byteValue.toString(16)).join("%");
            decoded += decodeURIComponent(encoded);
        }
        else {
            decoded += String.fromCharCode(((byte & 0b1111) << 12) | ((input[++i] & 0b111111) << 6) | (input[++i] & 0b111111));
        }
    }
    return decoded;
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-utf8-browser/dist-es/whatwgEncodingApi.js
function whatwgEncodingApi_fromUtf8(input) {
    return new TextEncoder().encode(input);
}
function whatwgEncodingApi_toUtf8(input) {
    return new TextDecoder("utf-8").decode(input);
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-utf8-browser/dist-es/index.js


const dist_es_fromUtf8 = (input) => typeof TextEncoder === "function" ? whatwgEncodingApi_fromUtf8(input) : fromUtf8(input);
const dist_es_toUtf8 = (input) => typeof TextDecoder === "function" ? whatwgEncodingApi_toUtf8(input) : toUtf8(input);


/***/ }),

/***/ 15501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ AppHolder; }
/* harmony export */ });
class AppHolder {
    static setInstance(name, app) {
        AppHolder._apps[name] = app;
    }
    static getInstance(name) {
        const app = AppHolder._apps[name];
        if (!app) {
            throw Error(`[${name}] FronteggApp not found`);
        }
        return app;
    }
}
AppHolder._apps = {};




/***/ }),

/***/ 11277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "F": function() { return /* binding */ FronteggApp; },
/* harmony export */   "R": function() { return /* binding */ React; },
/* harmony export */   "_": function() { return /* binding */ __extends; },
/* harmony export */   "a": function() { return /* binding */ ReactDom; },
/* harmony export */   "b": function() { return /* binding */ __read; },
/* harmony export */   "c": function() { return /* binding */ __values; },
/* harmony export */   "d": function() { return /* binding */ __assign; },
/* harmony export */   "e": function() { return /* binding */ __spread; },
/* harmony export */   "f": function() { return /* binding */ __rest; },
/* harmony export */   "g": function() { return /* binding */ __awaiter; },
/* harmony export */   "h": function() { return /* binding */ reactDom; },
/* harmony export */   "r": function() { return /* binding */ react; }
/* harmony export */ });
/* harmony import */ var _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5850);
/* harmony import */ var _frontegg_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36539);
/* harmony import */ var _utils_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95555);
/* harmony import */ var _AppHolder_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15501);
/* harmony import */ var _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32205);
/* harmony import */ var _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__);






/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var react = {exports: {}};

var react_production_min = {};

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/** @license React v17.0.1
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var l=objectAssign,n=60103,p=60106;react_production_min.Fragment=60107;react_production_min.StrictMode=60108;react_production_min.Profiler=60114;var q=60109,r$1=60110,t=60112;react_production_min.Suspense=60113;var u=60115,v=60116;
if("function"===typeof Symbol&&Symbol.for){var w=Symbol.for;n=w("react.element");p=w("react.portal");react_production_min.Fragment=w("react.fragment");react_production_min.StrictMode=w("react.strict_mode");react_production_min.Profiler=w("react.profiler");q=w("react.provider");r$1=w("react.context");t=w("react.forward_ref");react_production_min.Suspense=w("react.suspense");u=w("react.memo");v=w("react.lazy");}var x="function"===typeof Symbol&&Symbol.iterator;
function y$1(a){if(null===a||"object"!==typeof a)return null;a=x&&a[x]||a["@@iterator"];return "function"===typeof a?a:null}function z(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return "Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var A={isMounted:function(){return !1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},B$1={};function C(a,b,c){this.props=a;this.context=b;this.refs=B$1;this.updater=c||A;}C.prototype.isReactComponent={};C.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(z(85));this.updater.enqueueSetState(this,a,b,"setState");};C.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate");};
function D$1(){}D$1.prototype=C.prototype;function E$1(a,b,c){this.props=a;this.context=b;this.refs=B$1;this.updater=c||A;}var F$1=E$1.prototype=new D$1;F$1.constructor=E$1;l(F$1,C.prototype);F$1.isPureReactComponent=!0;var G$1={current:null},H$1=Object.prototype.hasOwnProperty,I$1={key:!0,ref:!0,__self:!0,__source:!0};
function J(a,b,c){var e,d={},k=null,h=null;if(null!=b)for(e in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(k=""+b.key),b)H$1.call(b,e)&&!I$1.hasOwnProperty(e)&&(d[e]=b[e]);var g=arguments.length-2;if(1===g)d.children=c;else if(1<g){for(var f=Array(g),m=0;m<g;m++)f[m]=arguments[m+2];d.children=f;}if(a&&a.defaultProps)for(e in g=a.defaultProps,g)void 0===d[e]&&(d[e]=g[e]);return {$$typeof:n,type:a,key:k,ref:h,props:d,_owner:G$1.current}}
function K(a,b){return {$$typeof:n,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function L(a){return "object"===typeof a&&null!==a&&a.$$typeof===n}function escape(a){var b={"=":"=0",":":"=2"};return "$"+a.replace(/[=:]/g,function(a){return b[a]})}var M$1=/\/+/g;function N$1(a,b){return "object"===typeof a&&null!==a&&null!=a.key?escape(""+a.key):b.toString(36)}
function O$1(a,b,c,e,d){var k=typeof a;if("undefined"===k||"boolean"===k)a=null;var h=!1;if(null===a)h=!0;else switch(k){case "string":case "number":h=!0;break;case "object":switch(a.$$typeof){case n:case p:h=!0;}}if(h)return h=a,d=d(h),a=""===e?"."+N$1(h,0):e,Array.isArray(d)?(c="",null!=a&&(c=a.replace(M$1,"$&/")+"/"),O$1(d,b,c,"",function(a){return a})):null!=d&&(L(d)&&(d=K(d,c+(!d.key||h&&h.key===d.key?"":(""+d.key).replace(M$1,"$&/")+"/")+a)),b.push(d)),1;h=0;e=""===e?".":e+":";if(Array.isArray(a))for(var g=
0;g<a.length;g++){k=a[g];var f=e+N$1(k,g);h+=O$1(k,b,c,f,d);}else if(f=y$1(a),"function"===typeof f)for(a=f.call(a),g=0;!(k=a.next()).done;)k=k.value,f=e+N$1(k,g++),h+=O$1(k,b,c,f,d);else if("object"===k)throw b=""+a,Error(z(31,"[object Object]"===b?"object with keys {"+Object.keys(a).join(", ")+"}":b));return h}function P$1(a,b,c){if(null==a)return a;var e=[],d=0;O$1(a,e,"","",function(a){return b.call(c,a,d++)});return e}
function Q(a){if(-1===a._status){var b=a._result;b=b();a._status=0;a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b);},function(b){0===a._status&&(a._status=2,a._result=b);});}if(1===a._status)return a._result;throw a._result;}var R$1={current:null};function S$1(){var a=R$1.current;if(null===a)throw Error(z(321));return a}var T$1={ReactCurrentDispatcher:R$1,ReactCurrentBatchConfig:{transition:0},ReactCurrentOwner:G$1,IsSomeRendererActing:{current:!1},assign:l};
react_production_min.Children={map:P$1,forEach:function(a,b,c){P$1(a,function(){b.apply(this,arguments);},c);},count:function(a){var b=0;P$1(a,function(){b++;});return b},toArray:function(a){return P$1(a,function(a){return a})||[]},only:function(a){if(!L(a))throw Error(z(143));return a}};react_production_min.Component=C;react_production_min.PureComponent=E$1;react_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=T$1;
react_production_min.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(z(267,a));var e=l({},a.props),d=a.key,k=a.ref,h=a._owner;if(null!=b){void 0!==b.ref&&(k=b.ref,h=G$1.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var g=a.type.defaultProps;for(f in b)H$1.call(b,f)&&!I$1.hasOwnProperty(f)&&(e[f]=void 0===b[f]&&void 0!==g?g[f]:b[f]);}var f=arguments.length-2;if(1===f)e.children=c;else if(1<f){g=Array(f);for(var m=0;m<f;m++)g[m]=arguments[m+2];e.children=g;}return {$$typeof:n,type:a.type,
key:d,ref:k,props:e,_owner:h}};react_production_min.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:r$1,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:q,_context:a};return a.Consumer=a};react_production_min.createElement=J;react_production_min.createFactory=function(a){var b=J.bind(null,a);b.type=a;return b};react_production_min.createRef=function(){return {current:null}};react_production_min.forwardRef=function(a){return {$$typeof:t,render:a}};react_production_min.isValidElement=L;
react_production_min.lazy=function(a){return {$$typeof:v,_payload:{_status:-1,_result:a},_init:Q}};react_production_min.memo=function(a,b){return {$$typeof:u,type:a,compare:void 0===b?null:b}};react_production_min.useCallback=function(a,b){return S$1().useCallback(a,b)};react_production_min.useContext=function(a,b){return S$1().useContext(a,b)};react_production_min.useDebugValue=function(){};react_production_min.useEffect=function(a,b){return S$1().useEffect(a,b)};react_production_min.useImperativeHandle=function(a,b,c){return S$1().useImperativeHandle(a,b,c)};
react_production_min.useLayoutEffect=function(a,b){return S$1().useLayoutEffect(a,b)};react_production_min.useMemo=function(a,b){return S$1().useMemo(a,b)};react_production_min.useReducer=function(a,b,c){return S$1().useReducer(a,b,c)};react_production_min.useRef=function(a){return S$1().useRef(a)};react_production_min.useState=function(a){return S$1().useState(a)};react_production_min.version="17.0.1";

{
  react.exports = react_production_min;
}

var React = react.exports;

var reactDom = {exports: {}};

var reactDom_production_min = {};

var scheduler = {exports: {}};

var scheduler_production_min = {};

/** @license React v0.20.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

(function (exports) {
var f,g,h,k;if("object"===typeof performance&&"function"===typeof performance.now){var l=performance;exports.unstable_now=function(){return l.now()};}else {var p=Date,q=p.now();exports.unstable_now=function(){return p.now()-q};}
if("undefined"===typeof window||"function"!==typeof MessageChannel){var t=null,u=null,w=function(){if(null!==t)try{var a=exports.unstable_now();t(!0,a);t=null;}catch(b){throw setTimeout(w,0),b;}};f=function(a){null!==t?setTimeout(f,0,a):(t=a,setTimeout(w,0));};g=function(a,b){u=setTimeout(a,b);};h=function(){clearTimeout(u);};exports.unstable_shouldYield=function(){return !1};k=exports.unstable_forceFrameRate=function(){};}else {var x=window.setTimeout,y=window.clearTimeout;if("undefined"!==typeof console){var z=
window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");"function"!==typeof z&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://reactjs.org/link/react-polyfills");}var A=!1,B=null,C=-1,D=5,E=0;exports.unstable_shouldYield=function(){return exports.unstable_now()>=
E};k=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"):D=0<a?Math.floor(1E3/a):5;};var F=new MessageChannel,G=F.port2;F.port1.onmessage=function(){if(null!==B){var a=exports.unstable_now();E=a+D;try{B(!0,a)?G.postMessage(null):(A=!1,B=null);}catch(b){throw G.postMessage(null),b;}}else A=!1;};f=function(a){B=a;A||(A=!0,G.postMessage(null));};g=function(a,b){C=
x(function(){a(exports.unstable_now());},b);};h=function(){y(C);C=-1;};}function H(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<I(e,b))a[d]=b,a[c]=e,c=d;else break a}}function J(a){a=a[0];return void 0===a?null:a}
function K(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>I(n,c))void 0!==r&&0>I(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>I(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function I(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var L=[],M=[],N=1,O=null,P=3,Q=!1,R=!1,S=!1;
function T(a){for(var b=J(M);null!==b;){if(null===b.callback)K(M);else if(b.startTime<=a)K(M),b.sortIndex=b.expirationTime,H(L,b);else break;b=J(M);}}function U(a){S=!1;T(a);if(!R)if(null!==J(L))R=!0,f(V);else {var b=J(M);null!==b&&g(U,b.startTime-a);}}
function V(a,b){R=!1;S&&(S=!1,h());Q=!0;var c=P;try{T(b);for(O=J(L);null!==O&&(!(O.expirationTime>b)||a&&!exports.unstable_shouldYield());){var d=O.callback;if("function"===typeof d){O.callback=null;P=O.priorityLevel;var e=d(O.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?O.callback=e:O===J(L)&&K(L);T(b);}else K(L);O=J(L);}if(null!==O)var m=!0;else {var n=J(M);null!==n&&g(U,n.startTime-b);m=!1;}return m}finally{O=null,P=c,Q=!1;}}var W=k;exports.unstable_IdlePriority=5;
exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null;};exports.unstable_continueExecution=function(){R||Q||(R=!0,f(V));};exports.unstable_getCurrentPriorityLevel=function(){return P};exports.unstable_getFirstCallbackNode=function(){return J(L)};
exports.unstable_next=function(a){switch(P){case 1:case 2:case 3:var b=3;break;default:b=P;}var c=P;P=b;try{return a()}finally{P=c;}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=W;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3;}var c=P;P=a;try{return b()}finally{P=c;}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();"object"===typeof c&&null!==c?(c=c.delay,c="number"===typeof c&&0<c?d+c:d):c=d;switch(a){case 1:var e=-1;break;case 2:e=250;break;case 5:e=1073741823;break;case 4:e=1E4;break;default:e=5E3;}e=c+e;a={id:N++,callback:b,priorityLevel:a,startTime:c,expirationTime:e,sortIndex:-1};c>d?(a.sortIndex=c,H(M,a),null===J(L)&&a===J(M)&&(S?h():S=!0,g(U,c-d))):(a.sortIndex=e,H(L,a),R||Q||(R=!0,f(V)));return a};
exports.unstable_wrapCallback=function(a){var b=P;return function(){var c=P;P=b;try{return a.apply(this,arguments)}finally{P=c;}}};
}(scheduler_production_min));

{
  scheduler.exports = scheduler_production_min;
}

/** @license React v17.0.1
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var aa=react.exports,m=objectAssign,r=scheduler.exports;function y(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return "Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(y(227));var ba=new Set,ca={};function da(a,b){ea(a,b);ea(a+"Capture",b);}
function ea(a,b){ca[a]=b;for(a=0;a<b.length;a++)ba.add(b[a]);}
var fa=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),ha=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,ia=Object.prototype.hasOwnProperty,
ja={},ka={};function la(a){if(ia.call(ka,a))return !0;if(ia.call(ja,a))return !1;if(ha.test(a))return ka[a]=!0;ja[a]=!0;return !1}function ma(a,b,c,d){if(null!==c&&0===c.type)return !1;switch(typeof b){case "function":case "symbol":return !0;case "boolean":if(d)return !1;if(null!==c)return !c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return "data-"!==a&&"aria-"!==a;default:return !1}}
function na(a,b,c,d){if(null===b||"undefined"===typeof b||ma(a,b,c,d))return !0;if(d)return !1;if(null!==c)switch(c.type){case 3:return !b;case 4:return !1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return !1}function B(a,b,c,d,e,f,g){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f;this.removeEmptyString=g;}var D={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){D[a]=new B(a,0,!1,a,null,!1,!1);});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];D[b]=new B(b,1,!1,a[1],null,!1,!1);});["contentEditable","draggable","spellCheck","value"].forEach(function(a){D[a]=new B(a,2,!1,a.toLowerCase(),null,!1,!1);});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){D[a]=new B(a,2,!1,a,null,!1,!1);});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){D[a]=new B(a,3,!1,a.toLowerCase(),null,!1,!1);});
["checked","multiple","muted","selected"].forEach(function(a){D[a]=new B(a,3,!0,a,null,!1,!1);});["capture","download"].forEach(function(a){D[a]=new B(a,4,!1,a,null,!1,!1);});["cols","rows","size","span"].forEach(function(a){D[a]=new B(a,6,!1,a,null,!1,!1);});["rowSpan","start"].forEach(function(a){D[a]=new B(a,5,!1,a.toLowerCase(),null,!1,!1);});var oa=/[\-:]([a-z])/g;function pa(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(oa,
pa);D[b]=new B(b,1,!1,a,null,!1,!1);});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(oa,pa);D[b]=new B(b,1,!1,a,"http://www.w3.org/1999/xlink",!1,!1);});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(oa,pa);D[b]=new B(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1,!1);});["tabIndex","crossOrigin"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!1,!1);});
D.xlinkHref=new B("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0,!1);["src","href","action","formAction"].forEach(function(a){D[a]=new B(a,1,!1,a.toLowerCase(),null,!0,!0);});
function qa(a,b,c,d){var e=D.hasOwnProperty(b)?D[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(na(b,c,e,d)&&(c=null),d||null===e?la(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))));}
var ra=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,sa=60103,ta=60106,ua=60107,wa=60108,xa=60114,ya=60109,za=60110,Aa=60112,Ba=60113,Ca=60120,Da=60115,Ea=60116,Fa=60121,Ga=60128,Ha=60129,Ia=60130,Ja=60131;
if("function"===typeof Symbol&&Symbol.for){var E=Symbol.for;sa=E("react.element");ta=E("react.portal");ua=E("react.fragment");wa=E("react.strict_mode");xa=E("react.profiler");ya=E("react.provider");za=E("react.context");Aa=E("react.forward_ref");Ba=E("react.suspense");Ca=E("react.suspense_list");Da=E("react.memo");Ea=E("react.lazy");Fa=E("react.block");E("react.scope");Ga=E("react.opaque.id");Ha=E("react.debug_trace_mode");Ia=E("react.offscreen");Ja=E("react.legacy_hidden");}
var Ka="function"===typeof Symbol&&Symbol.iterator;function La(a){if(null===a||"object"!==typeof a)return null;a=Ka&&a[Ka]||a["@@iterator"];return "function"===typeof a?a:null}var Ma;function Na(a){if(void 0===Ma)try{throw Error();}catch(c){var b=c.stack.trim().match(/\n( *(at )?)/);Ma=b&&b[1]||"";}return "\n"+Ma+a}var Oa=!1;
function Pa(a,b){if(!a||Oa)return "";Oa=!0;var c=Error.prepareStackTrace;Error.prepareStackTrace=void 0;try{if(b)if(b=function(){throw Error();},Object.defineProperty(b.prototype,"props",{set:function(){throw Error();}}),"object"===typeof Reflect&&Reflect.construct){try{Reflect.construct(b,[]);}catch(k){var d=k;}Reflect.construct(a,[],b);}else {try{b.call();}catch(k){d=k;}a.call(b.prototype);}else {try{throw Error();}catch(k){d=k;}a();}}catch(k){if(k&&d&&"string"===typeof k.stack){for(var e=k.stack.split("\n"),
f=d.stack.split("\n"),g=e.length-1,h=f.length-1;1<=g&&0<=h&&e[g]!==f[h];)h--;for(;1<=g&&0<=h;g--,h--)if(e[g]!==f[h]){if(1!==g||1!==h){do if(g--,h--,0>h||e[g]!==f[h])return "\n"+e[g].replace(" at new "," at ");while(1<=g&&0<=h)}break}}}finally{Oa=!1,Error.prepareStackTrace=c;}return (a=a?a.displayName||a.name:"")?Na(a):""}
function Qa(a){switch(a.tag){case 5:return Na(a.type);case 16:return Na("Lazy");case 13:return Na("Suspense");case 19:return Na("SuspenseList");case 0:case 2:case 15:return a=Pa(a.type,!1),a;case 11:return a=Pa(a.type.render,!1),a;case 22:return a=Pa(a.type._render,!1),a;case 1:return a=Pa(a.type,!0),a;default:return ""}}
function Ra(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ua:return "Fragment";case ta:return "Portal";case xa:return "Profiler";case wa:return "StrictMode";case Ba:return "Suspense";case Ca:return "SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case za:return (a.displayName||"Context")+".Consumer";case ya:return (a._context.displayName||"Context")+".Provider";case Aa:var b=a.render;b=b.displayName||b.name||"";
return a.displayName||(""!==b?"ForwardRef("+b+")":"ForwardRef");case Da:return Ra(a.type);case Fa:return Ra(a._render);case Ea:b=a._payload;a=a._init;try{return Ra(a(b))}catch(c){}}return null}function Sa(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return ""}}function Ta(a){var b=a.type;return (a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function Ua(a){var b=Ta(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a);}});Object.defineProperty(a,b,{enumerable:c.enumerable});return {getValue:function(){return d},setValue:function(a){d=""+a;},stopTracking:function(){a._valueTracker=
null;delete a[b];}}}}function Va(a){a._valueTracker||(a._valueTracker=Ua(a));}function Wa(a){if(!a)return !1;var b=a._valueTracker;if(!b)return !0;var c=b.getValue();var d="";a&&(d=Ta(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function Xa(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}
function Ya(a,b){var c=b.checked;return m({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}function Za(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=Sa(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value};}function $a(a,b){b=b.checked;null!=b&&qa(a,"checked",b,!1);}
function ab(a,b){$a(a,b);var c=Sa(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c;}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?bb(a,b.type,c):b.hasOwnProperty("defaultValue")&&bb(a,b.type,Sa(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked);}
function cb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b;}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c);}
function bb(a,b,c){if("number"!==b||Xa(a.ownerDocument)!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c);}function db(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a);});return b}function eb(a,b){a=m({children:void 0},b);if(b=db(b.children))a.children=b;return a}
function fb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0);}else {c=""+Sa(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e]);}null!==b&&(b.selected=!0);}}
function gb(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(y(91));return m({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function hb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(y(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(y(93));c=c[0];}b=c;}null==b&&(b="");c=b;}a._wrapperState={initialValue:Sa(c)};}
function ib(a,b){var c=Sa(b.value),d=Sa(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d);}function jb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b);}var kb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function lb(a){switch(a){case "svg":return "http://www.w3.org/2000/svg";case "math":return "http://www.w3.org/1998/Math/MathML";default:return "http://www.w3.org/1999/xhtml"}}function mb(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?lb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var nb,ob=function(a){return "undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)});}:a}(function(a,b){if(a.namespaceURI!==kb.svg||"innerHTML"in a)a.innerHTML=b;else {nb=nb||document.createElement("div");nb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=nb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild);}});
function pb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b;}
var qb={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},rb=["Webkit","ms","Moz","O"];Object.keys(qb).forEach(function(a){rb.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);qb[b]=qb[a];});});function sb(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||qb.hasOwnProperty(a)&&qb[a]?(""+b).trim():b+"px"}
function tb(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=sb(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e;}}var ub=m({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function vb(a,b){if(b){if(ub[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(y(137,a));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(y(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(y(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(y(62));}}
function wb(a,b){if(-1===a.indexOf("-"))return "string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return !1;default:return !0}}function xb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}var yb=null,zb=null,Ab=null;
function Bb(a){if(a=Cb(a)){if("function"!==typeof yb)throw Error(y(280));var b=a.stateNode;b&&(b=Db(b),yb(a.stateNode,a.type,b));}}function Eb(a){zb?Ab?Ab.push(a):Ab=[a]:zb=a;}function Fb(){if(zb){var a=zb,b=Ab;Ab=zb=null;Bb(a);if(b)for(a=0;a<b.length;a++)Bb(b[a]);}}function Gb(a,b){return a(b)}function Hb(a,b,c,d,e){return a(b,c,d,e)}function Ib(){}var Jb=Gb,Kb=!1,Lb=!1;function Mb(){if(null!==zb||null!==Ab)Ib(),Fb();}
function Nb(a,b,c){if(Lb)return a(b,c);Lb=!0;try{return Jb(a,b,c)}finally{Lb=!1,Mb();}}
function Ob(a,b){var c=a.stateNode;if(null===c)return null;var d=Db(c);if(null===d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1;}if(a)return null;if(c&&"function"!==
typeof c)throw Error(y(231,b,typeof c));return c}var Pb=!1;if(fa)try{var Qb={};Object.defineProperty(Qb,"passive",{get:function(){Pb=!0;}});window.addEventListener("test",Qb,Qb);window.removeEventListener("test",Qb,Qb);}catch(a){Pb=!1;}function Rb(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l);}catch(n){this.onError(n);}}var Sb=!1,Tb=null,Ub=!1,Vb=null,Wb={onError:function(a){Sb=!0;Tb=a;}};function Xb(a,b,c,d,e,f,g,h,k){Sb=!1;Tb=null;Rb.apply(Wb,arguments);}
function Yb(a,b,c,d,e,f,g,h,k){Xb.apply(this,arguments);if(Sb){if(Sb){var l=Tb;Sb=!1;Tb=null;}else throw Error(y(198));Ub||(Ub=!0,Vb=l);}}function Zb(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else {a=b;do b=a,0!==(b.flags&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function $b(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function ac(a){if(Zb(a)!==a)throw Error(y(188));}
function bc(a){var b=a.alternate;if(!b){b=Zb(a);if(null===b)throw Error(y(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return ac(e),a;if(f===d)return ac(e),b;f=f.sibling;}throw Error(y(188));}if(c.return!==d.return)c=e,d=f;else {for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling;}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling;}if(!g)throw Error(y(189));}}if(c.alternate!==d)throw Error(y(190));}if(3!==c.tag)throw Error(y(188));return c.stateNode.current===c?a:b}function cc(a){a=bc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else {if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return;}b.sibling.return=b.return;b=b.sibling;}}return null}
function dc(a,b){for(var c=a.alternate;null!==b;){if(b===a||b===c)return !0;b=b.return;}return !1}var ec,fc,gc,hc,ic=!1,jc=[],kc=null,lc=null,mc=null,nc=new Map,oc=new Map,pc=[],qc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function rc(a,b,c,d,e){return {blockedOn:a,domEventName:b,eventSystemFlags:c|16,nativeEvent:e,targetContainers:[d]}}function sc(a,b){switch(a){case "focusin":case "focusout":kc=null;break;case "dragenter":case "dragleave":lc=null;break;case "mouseover":case "mouseout":mc=null;break;case "pointerover":case "pointerout":nc.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":oc.delete(b.pointerId);}}
function tc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=rc(b,c,d,e,f),null!==b&&(b=Cb(b),null!==b&&fc(b)),a;a.eventSystemFlags|=d;b=a.targetContainers;null!==e&&-1===b.indexOf(e)&&b.push(e);return a}
function uc(a,b,c,d,e){switch(b){case "focusin":return kc=tc(kc,a,b,c,d,e),!0;case "dragenter":return lc=tc(lc,a,b,c,d,e),!0;case "mouseover":return mc=tc(mc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;nc.set(f,tc(nc.get(f)||null,a,b,c,d,e));return !0;case "gotpointercapture":return f=e.pointerId,oc.set(f,tc(oc.get(f)||null,a,b,c,d,e)),!0}return !1}
function vc(a){var b=wc(a.target);if(null!==b){var c=Zb(b);if(null!==c)if(b=c.tag,13===b){if(b=$b(c),null!==b){a.blockedOn=b;hc(a.lanePriority,function(){r.unstable_runWithPriority(a.priority,function(){gc(c);});});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null;}
function xc(a){if(null!==a.blockedOn)return !1;for(var b=a.targetContainers;0<b.length;){var c=yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c)return b=Cb(c),null!==b&&fc(b),a.blockedOn=c,!1;b.shift();}return !0}function zc(a,b,c){xc(a)&&c.delete(b);}
function Ac(){for(ic=!1;0<jc.length;){var a=jc[0];if(null!==a.blockedOn){a=Cb(a.blockedOn);null!==a&&ec(a);break}for(var b=a.targetContainers;0<b.length;){var c=yc(a.domEventName,a.eventSystemFlags,b[0],a.nativeEvent);if(null!==c){a.blockedOn=c;break}b.shift();}null===a.blockedOn&&jc.shift();}null!==kc&&xc(kc)&&(kc=null);null!==lc&&xc(lc)&&(lc=null);null!==mc&&xc(mc)&&(mc=null);nc.forEach(zc);oc.forEach(zc);}
function Bc(a,b){a.blockedOn===b&&(a.blockedOn=null,ic||(ic=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Ac)));}
function Cc(a){function b(b){return Bc(b,a)}if(0<jc.length){Bc(jc[0],a);for(var c=1;c<jc.length;c++){var d=jc[c];d.blockedOn===a&&(d.blockedOn=null);}}null!==kc&&Bc(kc,a);null!==lc&&Bc(lc,a);null!==mc&&Bc(mc,a);nc.forEach(b);oc.forEach(b);for(c=0;c<pc.length;c++)d=pc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<pc.length&&(c=pc[0],null===c.blockedOn);)vc(c),null===c.blockedOn&&pc.shift();}
function Dc(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Ec={animationend:Dc("Animation","AnimationEnd"),animationiteration:Dc("Animation","AnimationIteration"),animationstart:Dc("Animation","AnimationStart"),transitionend:Dc("Transition","TransitionEnd")},Fc={},Gc={};
fa&&(Gc=document.createElement("div").style,"AnimationEvent"in window||(delete Ec.animationend.animation,delete Ec.animationiteration.animation,delete Ec.animationstart.animation),"TransitionEvent"in window||delete Ec.transitionend.transition);function Hc(a){if(Fc[a])return Fc[a];if(!Ec[a])return a;var b=Ec[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Gc)return Fc[a]=b[c];return a}
var Ic=Hc("animationend"),Jc=Hc("animationiteration"),Kc=Hc("animationstart"),Lc=Hc("transitionend"),Mc=new Map,Nc=new Map,Oc=["abort","abort",Ic,"animationEnd",Jc,"animationIteration",Kc,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart",
"lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking","seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",Lc,"transitionEnd","waiting","waiting"];function Pc(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1];e="on"+(e[0].toUpperCase()+e.slice(1));Nc.set(d,b);Mc.set(d,e);da(e,[d]);}}var Qc=r.unstable_now;Qc();var F=8;
function Rc(a){if(0!==(1&a))return F=15,1;if(0!==(2&a))return F=14,2;if(0!==(4&a))return F=13,4;var b=24&a;if(0!==b)return F=12,b;if(0!==(a&32))return F=11,32;b=192&a;if(0!==b)return F=10,b;if(0!==(a&256))return F=9,256;b=3584&a;if(0!==b)return F=8,b;if(0!==(a&4096))return F=7,4096;b=4186112&a;if(0!==b)return F=6,b;b=62914560&a;if(0!==b)return F=5,b;if(a&67108864)return F=4,67108864;if(0!==(a&134217728))return F=3,134217728;b=805306368&a;if(0!==b)return F=2,b;if(0!==(1073741824&a))return F=1,1073741824;
F=8;return a}function Sc(a){switch(a){case 99:return 15;case 98:return 10;case 97:case 96:return 8;case 95:return 2;default:return 0}}function Tc(a){switch(a){case 15:case 14:return 99;case 13:case 12:case 11:case 10:return 98;case 9:case 8:case 7:case 6:case 4:case 5:return 97;case 3:case 2:case 1:return 95;case 0:return 90;default:throw Error(y(358,a));}}
function Uc(a,b){var c=a.pendingLanes;if(0===c)return F=0;var d=0,e=0,f=a.expiredLanes,g=a.suspendedLanes,h=a.pingedLanes;if(0!==f)d=f,e=F=15;else if(f=c&134217727,0!==f){var k=f&~g;0!==k?(d=Rc(k),e=F):(h&=f,0!==h&&(d=Rc(h),e=F));}else f=c&~g,0!==f?(d=Rc(f),e=F):0!==h&&(d=Rc(h),e=F);if(0===d)return 0;d=31-Vc(d);d=c&((0>d?0:1<<d)<<1)-1;if(0!==b&&b!==d&&0===(b&g)){Rc(b);if(e<=F)return b;F=e;}b=a.entangledLanes;if(0!==b)for(a=a.entanglements,b&=d;0<b;)c=31-Vc(b),e=1<<c,d|=a[c],b&=~e;return d}
function Wc(a){a=a.pendingLanes&-1073741825;return 0!==a?a:a&1073741824?1073741824:0}function Xc(a,b){switch(a){case 15:return 1;case 14:return 2;case 12:return a=Yc(24&~b),0===a?Xc(10,b):a;case 10:return a=Yc(192&~b),0===a?Xc(8,b):a;case 8:return a=Yc(3584&~b),0===a&&(a=Yc(4186112&~b),0===a&&(a=512)),a;case 2:return b=Yc(805306368&~b),0===b&&(b=268435456),b}throw Error(y(358,a));}function Yc(a){return a&-a}function Zc(a){for(var b=[],c=0;31>c;c++)b.push(a);return b}
function $c(a,b,c){a.pendingLanes|=b;var d=b-1;a.suspendedLanes&=d;a.pingedLanes&=d;a=a.eventTimes;b=31-Vc(b);a[b]=c;}var Vc=Math.clz32?Math.clz32:ad,bd=Math.log,cd=Math.LN2;function ad(a){return 0===a?32:31-(bd(a)/cd|0)|0}var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function gd(a,b,c,d){Kb||Ib();var e=hd,f=Kb;Kb=!0;try{Hb(e,a,b,c,d);}finally{(Kb=f)||Mb();}}function id(a,b,c,d){ed(dd,hd.bind(null,a,b,c,d));}
function hd(a,b,c,d){if(fd){var e;if((e=0===(b&4))&&0<jc.length&&-1<qc.indexOf(a))a=rc(null,a,b,c,d),jc.push(a);else {var f=yc(a,b,c,d);if(null===f)e&&sc(a,d);else {if(e){if(-1<qc.indexOf(a)){a=rc(f,a,b,c,d);jc.push(a);return}if(uc(f,a,b,c,d))return;sc(a,d);}jd(a,b,d,null,c);}}}}
function yc(a,b,c,d){var e=xb(d);e=wc(e);if(null!==e){var f=Zb(e);if(null===f)e=null;else {var g=f.tag;if(13===g){e=$b(f);if(null!==e)return e;e=null;}else if(3===g){if(f.stateNode.hydrate)return 3===f.tag?f.stateNode.containerInfo:null;e=null;}else f!==e&&(e=null);}}jd(a,b,d,e,c);return null}var kd=null,ld=null,md=null;
function nd(){if(md)return md;var a,b=ld,c=b.length,d,e="value"in kd?kd.value:kd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return md=e.slice(a,1<d?1-d:void 0)}function od(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}function pd(){return !0}function qd(){return !1}
function rd(a){function b(b,d,e,f,g){this._reactName=b;this._targetInst=e;this.type=d;this.nativeEvent=f;this.target=g;this.currentTarget=null;for(var c in a)a.hasOwnProperty(c)&&(b=a[c],this[c]=b?b(f):f[c]);this.isDefaultPrevented=(null!=f.defaultPrevented?f.defaultPrevented:!1===f.returnValue)?pd:qd;this.isPropagationStopped=qd;return this}m(b.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&
(a.returnValue=!1),this.isDefaultPrevented=pd);},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=pd);},persist:function(){},isPersistent:pd});return b}
var sd={eventPhase:0,bubbles:0,cancelable:0,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:0,isTrusted:0},td=rd(sd),ud=m({},sd,{view:0,detail:0}),vd=rd(ud),wd,xd,yd,Ad=m({},ud,{screenX:0,screenY:0,clientX:0,clientY:0,pageX:0,pageY:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,getModifierState:zd,button:0,buttons:0,relatedTarget:function(a){return void 0===a.relatedTarget?a.fromElement===a.srcElement?a.toElement:a.fromElement:a.relatedTarget},movementX:function(a){if("movementX"in
a)return a.movementX;a!==yd&&(yd&&"mousemove"===a.type?(wd=a.screenX-yd.screenX,xd=a.screenY-yd.screenY):xd=wd=0,yd=a);return wd},movementY:function(a){return "movementY"in a?a.movementY:xd}}),Bd=rd(Ad),Cd=m({},Ad,{dataTransfer:0}),Dd=rd(Cd),Ed=m({},ud,{relatedTarget:0}),Fd=rd(Ed),Gd=m({},sd,{animationName:0,elapsedTime:0,pseudoElement:0}),Hd=rd(Gd),Id=m({},sd,{clipboardData:function(a){return "clipboardData"in a?a.clipboardData:window.clipboardData}}),Jd=rd(Id),Kd=m({},sd,{data:0}),Ld=rd(Kd),Md={Esc:"Escape",
Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},Nd={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",116:"F5",117:"F6",118:"F7",
119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},Od={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pd(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Od[a])?!!b[a]:!1}function zd(){return Pd}
var Qd=m({},ud,{key:function(a){if(a.key){var b=Md[a.key]||a.key;if("Unidentified"!==b)return b}return "keypress"===a.type?(a=od(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?Nd[a.keyCode]||"Unidentified":""},code:0,location:0,ctrlKey:0,shiftKey:0,altKey:0,metaKey:0,repeat:0,locale:0,getModifierState:zd,charCode:function(a){return "keypress"===a.type?od(a):0},keyCode:function(a){return "keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return "keypress"===
a.type?od(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),Rd=rd(Qd),Sd=m({},Ad,{pointerId:0,width:0,height:0,pressure:0,tangentialPressure:0,tiltX:0,tiltY:0,twist:0,pointerType:0,isPrimary:0}),Td=rd(Sd),Ud=m({},ud,{touches:0,targetTouches:0,changedTouches:0,altKey:0,metaKey:0,ctrlKey:0,shiftKey:0,getModifierState:zd}),Vd=rd(Ud),Wd=m({},sd,{propertyName:0,elapsedTime:0,pseudoElement:0}),Xd=rd(Wd),Yd=m({},Ad,{deltaX:function(a){return "deltaX"in a?a.deltaX:"wheelDeltaX"in a?-a.wheelDeltaX:0},
deltaY:function(a){return "deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:0,deltaMode:0}),Zd=rd(Yd),$d=[9,13,27,32],ae=fa&&"CompositionEvent"in window,be=null;fa&&"documentMode"in document&&(be=document.documentMode);var ce=fa&&"TextEvent"in window&&!be,de=fa&&(!ae||be&&8<be&&11>=be),ee=String.fromCharCode(32),fe=!1;
function ge(a,b){switch(a){case "keyup":return -1!==$d.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "focusout":return !0;default:return !1}}function he(a){a=a.detail;return "object"===typeof a&&"data"in a?a.data:null}var ie=!1;function je(a,b){switch(a){case "compositionend":return he(b);case "keypress":if(32!==b.which)return null;fe=!0;return ee;case "textInput":return a=b.data,a===ee&&fe?null:a;default:return null}}
function ke(a,b){if(ie)return "compositionend"===a||!ae&&ge(a,b)?(a=nd(),md=ld=kd=null,ie=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return de&&"ko"!==b.locale?null:b.data;default:return null}}
var le={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function me(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return "input"===b?!!le[a.type]:"textarea"===b?!0:!1}function ne(a,b,c,d){Eb(d);b=oe(b,"onChange");0<b.length&&(c=new td("onChange","change",null,c,d),a.push({event:c,listeners:b}));}var pe=null,qe=null;function re(a){se(a,0);}function te(a){var b=ue(a);if(Wa(b))return a}
function ve(a,b){if("change"===a)return b}var we=!1;if(fa){var xe;if(fa){var ye="oninput"in document;if(!ye){var ze=document.createElement("div");ze.setAttribute("oninput","return;");ye="function"===typeof ze.oninput;}xe=ye;}else xe=!1;we=xe&&(!document.documentMode||9<document.documentMode);}function Ae(){pe&&(pe.detachEvent("onpropertychange",Be),qe=pe=null);}function Be(a){if("value"===a.propertyName&&te(qe)){var b=[];ne(b,qe,a,xb(a));a=re;if(Kb)a(b);else {Kb=!0;try{Gb(a,b);}finally{Kb=!1,Mb();}}}}
function Ce(a,b,c){"focusin"===a?(Ae(),pe=b,qe=c,pe.attachEvent("onpropertychange",Be)):"focusout"===a&&Ae();}function De(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return te(qe)}function Ee(a,b){if("click"===a)return te(b)}function Fe(a,b){if("input"===a||"change"===a)return te(b)}function Ge(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var He="function"===typeof Object.is?Object.is:Ge,Ie=Object.prototype.hasOwnProperty;
function Je(a,b){if(He(a,b))return !0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return !1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return !1;for(d=0;d<c.length;d++)if(!Ie.call(b,c[d])||!He(a[c[d]],b[c[d]]))return !1;return !0}function Ke(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
function Le(a,b){var c=Ke(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return {node:c,offset:b-a};a=d;}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode;}c=void 0;}c=Ke(c);}}function Me(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Me(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
function Ne(){for(var a=window,b=Xa();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href;}catch(d){c=!1;}if(c)a=b.contentWindow;else break;b=Xa(a.document);}return b}function Oe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
var Pe=fa&&"documentMode"in document&&11>=document.documentMode,Qe=null,Re=null,Se=null,Te=!1;
function Ue(a,b,c){var d=c.window===c?c.document:9===c.nodeType?c:c.ownerDocument;Te||null==Qe||Qe!==Xa(d)||(d=Qe,"selectionStart"in d&&Oe(d)?d={start:d.selectionStart,end:d.selectionEnd}:(d=(d.ownerDocument&&d.ownerDocument.defaultView||window).getSelection(),d={anchorNode:d.anchorNode,anchorOffset:d.anchorOffset,focusNode:d.focusNode,focusOffset:d.focusOffset}),Se&&Je(Se,d)||(Se=d,d=oe(Re,"onSelect"),0<d.length&&(b=new td("onSelect","select",null,b,c),a.push({event:b,listeners:d}),b.target=Qe)));}
Pc("cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focusin focus focusout blur input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),
0);Pc("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);Pc(Oc,2);for(var Ve="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),We=0;We<Ve.length;We++)Nc.set(Ve[We],0);ea("onMouseEnter",["mouseout","mouseover"]);
ea("onMouseLeave",["mouseout","mouseover"]);ea("onPointerEnter",["pointerout","pointerover"]);ea("onPointerLeave",["pointerout","pointerover"]);da("onChange","change click focusin focusout input keydown keyup selectionchange".split(" "));da("onSelect","focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));da("onBeforeInput",["compositionend","keypress","textInput","paste"]);da("onCompositionEnd","compositionend focusout keydown keypress keyup mousedown".split(" "));
da("onCompositionStart","compositionstart focusout keydown keypress keyup mousedown".split(" "));da("onCompositionUpdate","compositionupdate focusout keydown keypress keyup mousedown".split(" "));var Xe="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),Ye=new Set("cancel close invalid load scroll toggle".split(" ").concat(Xe));
function Ze(a,b,c){var d=a.type||"unknown-event";a.currentTarget=c;Yb(d,b,void 0,a);a.currentTarget=null;}
function se(a,b){b=0!==(b&4);for(var c=0;c<a.length;c++){var d=a[c],e=d.event;d=d.listeners;a:{var f=void 0;if(b)for(var g=d.length-1;0<=g;g--){var h=d[g],k=h.instance,l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;Ze(e,h,l);f=k;}else for(g=0;g<d.length;g++){h=d[g];k=h.instance;l=h.currentTarget;h=h.listener;if(k!==f&&e.isPropagationStopped())break a;Ze(e,h,l);f=k;}}}if(Ub)throw a=Vb,Ub=!1,Vb=null,a;}
function G(a,b){var c=$e(b),d=a+"__bubble";c.has(d)||(af(b,a,2,!1),c.add(d));}var bf="_reactListening"+Math.random().toString(36).slice(2);function cf(a){a[bf]||(a[bf]=!0,ba.forEach(function(b){Ye.has(b)||df(b,!1,a,null);df(b,!0,a,null);}));}
function df(a,b,c,d){var e=4<arguments.length&&void 0!==arguments[4]?arguments[4]:0,f=c;"selectionchange"===a&&9!==c.nodeType&&(f=c.ownerDocument);if(null!==d&&!b&&Ye.has(a)){if("scroll"!==a)return;e|=2;f=d;}var g=$e(f),h=a+"__"+(b?"capture":"bubble");g.has(h)||(b&&(e|=4),af(f,a,e,b),g.add(h));}
function af(a,b,c,d){var e=Nc.get(b);switch(void 0===e?2:e){case 0:e=gd;break;case 1:e=id;break;default:e=hd;}c=e.bind(null,b,c,a);e=void 0;!Pb||"touchstart"!==b&&"touchmove"!==b&&"wheel"!==b||(e=!0);d?void 0!==e?a.addEventListener(b,c,{capture:!0,passive:e}):a.addEventListener(b,c,!0):void 0!==e?a.addEventListener(b,c,{passive:e}):a.addEventListener(b,c,!1);}
function jd(a,b,c,d,e){var f=d;if(0===(b&1)&&0===(b&2)&&null!==d)a:for(;;){if(null===d)return;var g=d.tag;if(3===g||4===g){var h=d.stateNode.containerInfo;if(h===e||8===h.nodeType&&h.parentNode===e)break;if(4===g)for(g=d.return;null!==g;){var k=g.tag;if(3===k||4===k)if(k=g.stateNode.containerInfo,k===e||8===k.nodeType&&k.parentNode===e)return;g=g.return;}for(;null!==h;){g=wc(h);if(null===g)return;k=g.tag;if(5===k||6===k){d=f=g;continue a}h=h.parentNode;}}d=d.return;}Nb(function(){var d=f,e=xb(c),g=[];
a:{var h=Mc.get(a);if(void 0!==h){var k=td,x=a;switch(a){case "keypress":if(0===od(c))break a;case "keydown":case "keyup":k=Rd;break;case "focusin":x="focus";k=Fd;break;case "focusout":x="blur";k=Fd;break;case "beforeblur":case "afterblur":k=Fd;break;case "click":if(2===c.button)break a;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":k=Bd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":k=
Dd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":k=Vd;break;case Ic:case Jc:case Kc:k=Hd;break;case Lc:k=Xd;break;case "scroll":k=vd;break;case "wheel":k=Zd;break;case "copy":case "cut":case "paste":k=Jd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":k=Td;}var w=0!==(b&4),z=!w&&"scroll"===a,u=w?null!==h?h+"Capture":null:h;w=[];for(var t=d,q;null!==
t;){q=t;var v=q.stateNode;5===q.tag&&null!==v&&(q=v,null!==u&&(v=Ob(t,u),null!=v&&w.push(ef(t,v,q))));if(z)break;t=t.return;}0<w.length&&(h=new k(h,x,null,c,e),g.push({event:h,listeners:w}));}}if(0===(b&7)){a:{h="mouseover"===a||"pointerover"===a;k="mouseout"===a||"pointerout"===a;if(h&&0===(b&16)&&(x=c.relatedTarget||c.fromElement)&&(wc(x)||x[ff]))break a;if(k||h){h=e.window===e?e:(h=e.ownerDocument)?h.defaultView||h.parentWindow:window;if(k){if(x=c.relatedTarget||c.toElement,k=d,x=x?wc(x):null,null!==
x&&(z=Zb(x),x!==z||5!==x.tag&&6!==x.tag))x=null;}else k=null,x=d;if(k!==x){w=Bd;v="onMouseLeave";u="onMouseEnter";t="mouse";if("pointerout"===a||"pointerover"===a)w=Td,v="onPointerLeave",u="onPointerEnter",t="pointer";z=null==k?h:ue(k);q=null==x?h:ue(x);h=new w(v,t+"leave",k,c,e);h.target=z;h.relatedTarget=q;v=null;wc(e)===d&&(w=new w(u,t+"enter",x,c,e),w.target=q,w.relatedTarget=z,v=w);z=v;if(k&&x)b:{w=k;u=x;t=0;for(q=w;q;q=gf(q))t++;q=0;for(v=u;v;v=gf(v))q++;for(;0<t-q;)w=gf(w),t--;for(;0<q-t;)u=
gf(u),q--;for(;t--;){if(w===u||null!==u&&w===u.alternate)break b;w=gf(w);u=gf(u);}w=null;}else w=null;null!==k&&hf(g,h,k,w,!1);null!==x&&null!==z&&hf(g,z,x,w,!0);}}}a:{h=d?ue(d):window;k=h.nodeName&&h.nodeName.toLowerCase();if("select"===k||"input"===k&&"file"===h.type)var J=ve;else if(me(h))if(we)J=Fe;else {J=De;var K=Ce;}else (k=h.nodeName)&&"input"===k.toLowerCase()&&("checkbox"===h.type||"radio"===h.type)&&(J=Ee);if(J&&(J=J(a,d))){ne(g,J,c,e);break a}K&&K(a,h,d);"focusout"===a&&(K=h._wrapperState)&&
K.controlled&&"number"===h.type&&bb(h,"number",h.value);}K=d?ue(d):window;switch(a){case "focusin":if(me(K)||"true"===K.contentEditable)Qe=K,Re=d,Se=null;break;case "focusout":Se=Re=Qe=null;break;case "mousedown":Te=!0;break;case "contextmenu":case "mouseup":case "dragend":Te=!1;Ue(g,c,e);break;case "selectionchange":if(Pe)break;case "keydown":case "keyup":Ue(g,c,e);}var Q;if(ae)b:{switch(a){case "compositionstart":var L="onCompositionStart";break b;case "compositionend":L="onCompositionEnd";break b;
case "compositionupdate":L="onCompositionUpdate";break b}L=void 0;}else ie?ge(a,c)&&(L="onCompositionEnd"):"keydown"===a&&229===c.keyCode&&(L="onCompositionStart");L&&(de&&"ko"!==c.locale&&(ie||"onCompositionStart"!==L?"onCompositionEnd"===L&&ie&&(Q=nd()):(kd=e,ld="value"in kd?kd.value:kd.textContent,ie=!0)),K=oe(d,L),0<K.length&&(L=new Ld(L,a,null,c,e),g.push({event:L,listeners:K}),Q?L.data=Q:(Q=he(c),null!==Q&&(L.data=Q))));if(Q=ce?je(a,c):ke(a,c))d=oe(d,"onBeforeInput"),0<d.length&&(e=new Ld("onBeforeInput",
"beforeinput",null,c,e),g.push({event:e,listeners:d}),e.data=Q);}se(g,b);});}function ef(a,b,c){return {instance:a,listener:b,currentTarget:c}}function oe(a,b){for(var c=b+"Capture",d=[];null!==a;){var e=a,f=e.stateNode;5===e.tag&&null!==f&&(e=f,f=Ob(a,c),null!=f&&d.unshift(ef(a,f,e)),f=Ob(a,b),null!=f&&d.push(ef(a,f,e)));a=a.return;}return d}function gf(a){if(null===a)return null;do a=a.return;while(a&&5!==a.tag);return a?a:null}
function hf(a,b,c,d,e){for(var f=b._reactName,g=[];null!==c&&c!==d;){var h=c,k=h.alternate,l=h.stateNode;if(null!==k&&k===d)break;5===h.tag&&null!==l&&(h=l,e?(k=Ob(c,f),null!=k&&g.unshift(ef(c,k,h))):e||(k=Ob(c,f),null!=k&&g.push(ef(c,k,h))));c=c.return;}0!==g.length&&a.push({event:b,listeners:g});}function jf(){}var kf=null,lf=null;function mf(a,b){switch(a){case "button":case "input":case "select":case "textarea":return !!b.autoFocus}return !1}
function nf(a,b){return "textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var of="function"===typeof setTimeout?setTimeout:void 0,pf="function"===typeof clearTimeout?clearTimeout:void 0;function qf(a){1===a.nodeType?a.textContent="":9===a.nodeType&&(a=a.body,null!=a&&(a.textContent=""));}
function rf(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}function sf(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if("$"===c||"$!"===c||"$?"===c){if(0===b)return a;b--;}else "/$"===c&&b++;}a=a.previousSibling;}return null}var tf=0;function uf(a){return {$$typeof:Ga,toString:a,valueOf:a}}var vf=Math.random().toString(36).slice(2),wf="__reactFiber$"+vf,xf="__reactProps$"+vf,ff="__reactContainer$"+vf,yf="__reactEvents$"+vf;
function wc(a){var b=a[wf];if(b)return b;for(var c=a.parentNode;c;){if(b=c[ff]||c[wf]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=sf(a);null!==a;){if(c=a[wf])return c;a=sf(a);}return b}a=c;c=a.parentNode;}return null}function Cb(a){a=a[wf]||a[ff];return !a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function ue(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(y(33));}function Db(a){return a[xf]||null}
function $e(a){var b=a[yf];void 0===b&&(b=a[yf]=new Set);return b}var zf=[],Af=-1;function Bf(a){return {current:a}}function H(a){0>Af||(a.current=zf[Af],zf[Af]=null,Af--);}function I(a,b){Af++;zf[Af]=a.current;a.current=b;}var Cf={},M=Bf(Cf),N=Bf(!1),Df=Cf;
function Ef(a,b){var c=a.type.contextTypes;if(!c)return Cf;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function Ff(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Gf(){H(N);H(M);}function Hf(a,b,c){if(M.current!==Cf)throw Error(y(168));I(M,b);I(N,c);}
function If(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(y(108,Ra(b)||"Unknown",e));return m({},c,d)}function Jf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Cf;Df=M.current;I(M,a);I(N,N.current);return !0}function Kf(a,b,c){var d=a.stateNode;if(!d)throw Error(y(169));c?(a=If(a,b,Df),d.__reactInternalMemoizedMergedChildContext=a,H(N),H(M),I(M,a)):H(N);I(N,c);}
var Lf=null,Mf=null,Nf=r.unstable_runWithPriority,Of=r.unstable_scheduleCallback,Pf=r.unstable_cancelCallback,Qf=r.unstable_shouldYield,Rf=r.unstable_requestPaint,Sf=r.unstable_now,Tf=r.unstable_getCurrentPriorityLevel,Uf=r.unstable_ImmediatePriority,Vf=r.unstable_UserBlockingPriority,Wf=r.unstable_NormalPriority,Xf=r.unstable_LowPriority,Yf=r.unstable_IdlePriority,Zf={},$f=void 0!==Rf?Rf:function(){},ag=null,bg=null,cg=!1,dg=Sf(),O=1E4>dg?Sf:function(){return Sf()-dg};
function eg(){switch(Tf()){case Uf:return 99;case Vf:return 98;case Wf:return 97;case Xf:return 96;case Yf:return 95;default:throw Error(y(332));}}function fg(a){switch(a){case 99:return Uf;case 98:return Vf;case 97:return Wf;case 96:return Xf;case 95:return Yf;default:throw Error(y(332));}}function gg(a,b){a=fg(a);return Nf(a,b)}function hg(a,b,c){a=fg(a);return Of(a,b,c)}function ig(){if(null!==bg){var a=bg;bg=null;Pf(a);}jg();}
function jg(){if(!cg&&null!==ag){cg=!0;var a=0;try{var b=ag;gg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});ag=null;}catch(c){throw null!==ag&&(ag=ag.slice(a+1)),Of(Uf,ig),c;}finally{cg=!1;}}}var kg=ra.ReactCurrentBatchConfig;function lg(a,b){if(a&&a.defaultProps){b=m({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c]);return b}return b}var mg=Bf(null),ng=null,og=null,pg=null;function qg(){pg=og=ng=null;}
function rg(a){var b=mg.current;H(mg);a.type._context._currentValue=b;}function sg(a,b){for(;null!==a;){var c=a.alternate;if((a.childLanes&b)===b)if(null===c||(c.childLanes&b)===b)break;else c.childLanes|=b;else a.childLanes|=b,null!==c&&(c.childLanes|=b);a=a.return;}}function tg(a,b){ng=a;pg=og=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(0!==(a.lanes&b)&&(ug=!0),a.firstContext=null);}
function vg(a,b){if(pg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)pg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===og){if(null===ng)throw Error(y(308));og=b;ng.dependencies={lanes:0,firstContext:b,responders:null};}else og=og.next=b;}return a._currentValue}var wg=!1;function xg(a){a.updateQueue={baseState:a.memoizedState,firstBaseUpdate:null,lastBaseUpdate:null,shared:{pending:null},effects:null};}
function yg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,firstBaseUpdate:a.firstBaseUpdate,lastBaseUpdate:a.lastBaseUpdate,shared:a.shared,effects:a.effects});}function zg(a,b){return {eventTime:a,lane:b,tag:0,payload:null,callback:null,next:null}}function Ag(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b;}}
function Bg(a,b){var c=a.updateQueue,d=a.alternate;if(null!==d&&(d=d.updateQueue,c===d)){var e=null,f=null;c=c.firstBaseUpdate;if(null!==c){do{var g={eventTime:c.eventTime,lane:c.lane,tag:c.tag,payload:c.payload,callback:c.callback,next:null};null===f?e=f=g:f=f.next=g;c=c.next;}while(null!==c);null===f?e=f=b:f=f.next=b;}else e=f=b;c={baseState:d.baseState,firstBaseUpdate:e,lastBaseUpdate:f,shared:d.shared,effects:d.effects};a.updateQueue=c;return}a=c.lastBaseUpdate;null===a?c.firstBaseUpdate=b:a.next=
b;c.lastBaseUpdate=b;}
function Cg(a,b,c,d){var e=a.updateQueue;wg=!1;var f=e.firstBaseUpdate,g=e.lastBaseUpdate,h=e.shared.pending;if(null!==h){e.shared.pending=null;var k=h,l=k.next;k.next=null;null===g?f=l:g.next=l;g=k;var n=a.alternate;if(null!==n){n=n.updateQueue;var A=n.lastBaseUpdate;A!==g&&(null===A?n.firstBaseUpdate=l:A.next=l,n.lastBaseUpdate=k);}}if(null!==f){A=e.baseState;g=0;n=l=k=null;do{h=f.lane;var p=f.eventTime;if((d&h)===h){null!==n&&(n=n.next={eventTime:p,lane:0,tag:f.tag,payload:f.payload,callback:f.callback,
next:null});a:{var C=a,x=f;h=b;p=c;switch(x.tag){case 1:C=x.payload;if("function"===typeof C){A=C.call(p,A,h);break a}A=C;break a;case 3:C.flags=C.flags&-4097|64;case 0:C=x.payload;h="function"===typeof C?C.call(p,A,h):C;if(null===h||void 0===h)break a;A=m({},A,h);break a;case 2:wg=!0;}}null!==f.callback&&(a.flags|=32,h=e.effects,null===h?e.effects=[f]:h.push(f));}else p={eventTime:p,lane:h,tag:f.tag,payload:f.payload,callback:f.callback,next:null},null===n?(l=n=p,k=A):n=n.next=p,g|=h;f=f.next;if(null===
f)if(h=e.shared.pending,null===h)break;else f=h.next,h.next=null,e.lastBaseUpdate=h,e.shared.pending=null;}while(1);null===n&&(k=A);e.baseState=k;e.firstBaseUpdate=l;e.lastBaseUpdate=n;Dg|=g;a.lanes=g;a.memoizedState=A;}}function Eg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=c;if("function"!==typeof e)throw Error(y(191,e));e.call(d);}}}var Fg=(new aa.Component).refs;
function Gg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:m({},b,c);a.memoizedState=c;0===a.lanes&&(a.updateQueue.baseState=c);}
var Kg={isMounted:function(a){return (a=a._reactInternals)?Zb(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternals;var d=Hg(),e=Ig(a),f=zg(d,e);f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Ag(a,f);Jg(a,e,d);},enqueueReplaceState:function(a,b,c){a=a._reactInternals;var d=Hg(),e=Ig(a),f=zg(d,e);f.tag=1;f.payload=b;void 0!==c&&null!==c&&(f.callback=c);Ag(a,f);Jg(a,e,d);},enqueueForceUpdate:function(a,b){a=a._reactInternals;var c=Hg(),d=Ig(a),e=zg(c,d);e.tag=2;void 0!==b&&null!==b&&(e.callback=
b);Ag(a,e);Jg(a,d,c);}};function Lg(a,b,c,d,e,f,g){a=a.stateNode;return "function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!Je(c,d)||!Je(e,f):!0}
function Mg(a,b,c){var d=!1,e=Cf;var f=b.contextType;"object"===typeof f&&null!==f?f=vg(f):(e=Ff(b)?Df:M.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Ef(a,e):Cf);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Kg;a.stateNode=b;b._reactInternals=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Ng(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Kg.enqueueReplaceState(b,b.state,null);}
function Og(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Fg;xg(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=vg(f):(f=Ff(b)?Df:M.current,e.context=Ef(a,f));Cg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Gg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Kg.enqueueReplaceState(e,e.state,null),Cg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.flags|=4);}var Pg=Array.isArray;
function Qg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(y(309));var d=c.stateNode;}if(!d)throw Error(y(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Fg&&(b=d.refs={});null===a?delete b[e]:b[e]=a;};b._stringRef=e;return b}if("string"!==typeof a)throw Error(y(284));if(!c._owner)throw Error(y(290,a));}return a}
function Rg(a,b){if("textarea"!==a.type)throw Error(y(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b));}
function Sg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.flags=8;}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Tg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.flags=2,
c):d;b.flags=2;return c}function g(b){a&&null===b.alternate&&(b.flags=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Ug(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Qg(a,b,c),d.return=a,d;d=Vg(c.type,c.key,c.props,null,a.mode,d);d.ref=Qg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==c.implementation)return b=
Wg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function n(a,b,c,d,f){if(null===b||7!==b.tag)return b=Xg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function A(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Ug(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case sa:return c=Vg(b.type,b.key,b.props,null,a.mode,c),c.ref=Qg(a,null,b),c.return=a,c;case ta:return b=Wg(b,a.mode,c),b.return=a,b}if(Pg(b)||La(b))return b=Xg(b,
a.mode,c,null),b.return=a,b;Rg(a,b);}return null}function p(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case sa:return c.key===e?c.type===ua?n(a,b,c.props.children,d,e):k(a,b,c,d):null;case ta:return c.key===e?l(a,b,c,d):null}if(Pg(c)||La(c))return null!==e?null:n(a,b,c,d,null);Rg(a,c);}return null}function C(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=a.get(c)||
null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case sa:return a=a.get(null===d.key?c:d.key)||null,d.type===ua?n(b,a,d.props.children,e,d.key):k(b,a,d,e);case ta:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Pg(d)||La(d))return a=a.get(c)||null,n(b,a,d,e,null);Rg(b,d);}return null}function x(e,g,h,k){for(var l=null,t=null,u=g,z=g=0,q=null;null!==u&&z<h.length;z++){u.index>z?(q=u,u=null):q=u.sibling;var n=p(e,u,h[z],k);if(null===n){null===u&&(u=q);break}a&&u&&null===
n.alternate&&b(e,u);g=f(n,g,z);null===t?l=n:t.sibling=n;t=n;u=q;}if(z===h.length)return c(e,u),l;if(null===u){for(;z<h.length;z++)u=A(e,h[z],k),null!==u&&(g=f(u,g,z),null===t?l=u:t.sibling=u,t=u);return l}for(u=d(e,u);z<h.length;z++)q=C(u,e,z,h[z],k),null!==q&&(a&&null!==q.alternate&&u.delete(null===q.key?z:q.key),g=f(q,g,z),null===t?l=q:t.sibling=q,t=q);a&&u.forEach(function(a){return b(e,a)});return l}function w(e,g,h,k){var l=La(h);if("function"!==typeof l)throw Error(y(150));h=l.call(h);if(null==
h)throw Error(y(151));for(var t=l=null,u=g,z=g=0,q=null,n=h.next();null!==u&&!n.done;z++,n=h.next()){u.index>z?(q=u,u=null):q=u.sibling;var w=p(e,u,n.value,k);if(null===w){null===u&&(u=q);break}a&&u&&null===w.alternate&&b(e,u);g=f(w,g,z);null===t?l=w:t.sibling=w;t=w;u=q;}if(n.done)return c(e,u),l;if(null===u){for(;!n.done;z++,n=h.next())n=A(e,n.value,k),null!==n&&(g=f(n,g,z),null===t?l=n:t.sibling=n,t=n);return l}for(u=d(e,u);!n.done;z++,n=h.next())n=C(u,e,z,n.value,k),null!==n&&(a&&null!==n.alternate&&
u.delete(null===n.key?z:n.key),g=f(n,g,z),null===t?l=n:t.sibling=n,t=n);a&&u.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ua&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case sa:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ua){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,k.sibling);
d=e(k,f.props);d.ref=Qg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling;}f.type===ua?(d=Xg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Vg(f.type,f.key,f.props,null,a.mode,h),h.ref=Qg(a,d,f),h.return=a,a=h);}return g(a);case ta:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else {c(a,d);break}else b(a,d);d=d.sibling;}d=
Wg(f,a.mode,h);d.return=a;a=d;}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Ug(f,a.mode,h),d.return=a,a=d),g(a);if(Pg(f))return x(a,d,f,h);if(La(f))return w(a,d,f,h);l&&Rg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 22:case 0:case 11:case 15:throw Error(y(152,Ra(a.type)||"Component"));}return c(a,d)}}var Yg=Sg(!0),Zg=Sg(!1),$g={},ah=Bf($g),bh=Bf($g),ch=Bf($g);
function dh(a){if(a===$g)throw Error(y(174));return a}function eh(a,b){I(ch,b);I(bh,a);I(ah,$g);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:mb(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=mb(b,a);}H(ah);I(ah,b);}function fh(){H(ah);H(bh);H(ch);}function gh(a){dh(ch.current);var b=dh(ah.current);var c=mb(b,a.type);b!==c&&(I(bh,a),I(ah,c));}function hh(a){bh.current===a&&(H(ah),H(bh));}var P=Bf(0);
function ih(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||"$?"===c.data||"$!"===c.data))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.flags&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return;}b.sibling.return=b.return;b=b.sibling;}return null}var jh=null,kh=null,lh=!1;
function mh(a,b){var c=nh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.flags=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c;}function oh(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return !1;default:return !1}}
function ph(a){if(lh){var b=kh;if(b){var c=b;if(!oh(a,b)){b=rf(c.nextSibling);if(!b||!oh(a,b)){a.flags=a.flags&-1025|2;lh=!1;jh=a;return}mh(jh,c);}jh=a;kh=rf(b.firstChild);}else a.flags=a.flags&-1025|2,lh=!1,jh=a;}}function qh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;jh=a;}
function rh(a){if(a!==jh)return !1;if(!lh)return qh(a),lh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!nf(b,a.memoizedProps))for(b=kh;b;)mh(a,b),b=rf(b.nextSibling);qh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(y(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if("/$"===c){if(0===b){kh=rf(a.nextSibling);break a}b--;}else "$"!==c&&"$!"!==c&&"$?"!==c||b++;}a=a.nextSibling;}kh=null;}}else kh=jh?rf(a.stateNode.nextSibling):null;return !0}
function sh(){kh=jh=null;lh=!1;}var th=[];function uh(){for(var a=0;a<th.length;a++)th[a]._workInProgressVersionPrimary=null;th.length=0;}var vh=ra.ReactCurrentDispatcher,wh=ra.ReactCurrentBatchConfig,xh=0,R=null,S=null,T=null,yh=!1,zh=!1;function Ah(){throw Error(y(321));}function Bh(a,b){if(null===b)return !1;for(var c=0;c<b.length&&c<a.length;c++)if(!He(a[c],b[c]))return !1;return !0}
function Ch(a,b,c,d,e,f){xh=f;R=b;b.memoizedState=null;b.updateQueue=null;b.lanes=0;vh.current=null===a||null===a.memoizedState?Dh:Eh;a=c(d,e);if(zh){f=0;do{zh=!1;if(!(25>f))throw Error(y(301));f+=1;T=S=null;b.updateQueue=null;vh.current=Fh;a=c(d,e);}while(zh)}vh.current=Gh;b=null!==S&&null!==S.next;xh=0;T=S=R=null;yh=!1;if(b)throw Error(y(300));return a}function Hh(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===T?R.memoizedState=T=a:T=T.next=a;return T}
function Ih(){if(null===S){var a=R.alternate;a=null!==a?a.memoizedState:null;}else a=S.next;var b=null===T?R.memoizedState:T.next;if(null!==b)T=b,S=a;else {if(null===a)throw Error(y(310));S=a;a={memoizedState:S.memoizedState,baseState:S.baseState,baseQueue:S.baseQueue,queue:S.queue,next:null};null===T?R.memoizedState=T=a:T=T.next=a;}return T}function Jh(a,b){return "function"===typeof b?b(a):b}
function Kh(a){var b=Ih(),c=b.queue;if(null===c)throw Error(y(311));c.lastRenderedReducer=a;var d=S,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g;}d.baseQueue=e=f;c.pending=null;}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.lane;if((xh&l)===l)null!==h&&(h=h.next={lane:0,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),d=k.eagerReducer===a?k.eagerState:a(d,k.action);else {var n={lane:l,action:k.action,eagerReducer:k.eagerReducer,
eagerState:k.eagerState,next:null};null===h?(g=h=n,f=d):h=h.next=n;R.lanes|=l;Dg|=l;}k=k.next;}while(null!==k&&k!==e);null===h?f=d:h.next=g;He(d,b.memoizedState)||(ug=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d;}return [b.memoizedState,c.dispatch]}
function Lh(a){var b=Ih(),c=b.queue;if(null===c)throw Error(y(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);He(f,b.memoizedState)||(ug=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f;}return [f,d]}
function Mh(a,b,c){var d=b._getVersion;d=d(b._source);var e=b._workInProgressVersionPrimary;if(null!==e)a=e===d;else if(a=a.mutableReadLanes,a=(xh&a)===a)b._workInProgressVersionPrimary=d,th.push(b);if(a)return c(b._source);th.push(b);throw Error(y(350));}
function Nh(a,b,c,d){var e=U;if(null===e)throw Error(y(349));var f=b._getVersion,g=f(b._source),h=vh.current,k=h.useState(function(){return Mh(e,b,c)}),l=k[1],n=k[0];k=T;var A=a.memoizedState,p=A.refs,C=p.getSnapshot,x=A.source;A=A.subscribe;var w=R;a.memoizedState={refs:p,source:b,subscribe:d};h.useEffect(function(){p.getSnapshot=c;p.setSnapshot=l;var a=f(b._source);if(!He(g,a)){a=c(b._source);He(n,a)||(l(a),a=Ig(w),e.mutableReadLanes|=a&e.pendingLanes);a=e.mutableReadLanes;e.entangledLanes|=a;for(var d=
e.entanglements,h=a;0<h;){var k=31-Vc(h),v=1<<k;d[k]|=a;h&=~v;}}},[c,b,d]);h.useEffect(function(){return d(b._source,function(){var a=p.getSnapshot,c=p.setSnapshot;try{c(a(b._source));var d=Ig(w);e.mutableReadLanes|=d&e.pendingLanes;}catch(q){c(function(){throw q;});}})},[b,d]);He(C,c)&&He(x,b)&&He(A,d)||(a={pending:null,dispatch:null,lastRenderedReducer:Jh,lastRenderedState:n},a.dispatch=l=Oh.bind(null,R,a),k.queue=a,k.baseQueue=null,n=Mh(e,b,c),k.memoizedState=k.baseState=n);return n}
function Ph(a,b,c){var d=Ih();return Nh(d,a,b,c)}function Qh(a){var b=Hh();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:Jh,lastRenderedState:a};a=a.dispatch=Oh.bind(null,R,a);return [b.memoizedState,a]}
function Rh(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=R.updateQueue;null===b?(b={lastEffect:null},R.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}function Sh(a){var b=Hh();a={current:a};return b.memoizedState=a}function Th(){return Ih().memoizedState}function Uh(a,b,c,d){var e=Hh();R.flags|=a;e.memoizedState=Rh(1|b,c,void 0,void 0===d?null:d);}
function Vh(a,b,c,d){var e=Ih();d=void 0===d?null:d;var f=void 0;if(null!==S){var g=S.memoizedState;f=g.destroy;if(null!==d&&Bh(d,g.deps)){Rh(b,c,f,d);return}}R.flags|=a;e.memoizedState=Rh(1|b,c,f,d);}function Wh(a,b){return Uh(516,4,a,b)}function Xh(a,b){return Vh(516,4,a,b)}function Yh(a,b){return Vh(4,2,a,b)}function Zh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null);};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null;}}
function $h(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Vh(4,2,Zh.bind(null,b,a),c)}function ai(){}function bi(a,b){var c=Ih();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Bh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}function ci(a,b){var c=Ih();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&Bh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}
function di(a,b){var c=eg();gg(98>c?98:c,function(){a(!0);});gg(97<c?97:c,function(){var c=wh.transition;wh.transition=1;try{a(!1),b();}finally{wh.transition=c;}});}
function Oh(a,b,c){var d=Hg(),e=Ig(a),f={lane:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.pending;null===g?f.next=f:(f.next=g.next,g.next=f);b.pending=f;g=a.alternate;if(a===R||null!==g&&g===R)zh=yh=!0;else {if(0===a.lanes&&(null===g||0===g.lanes)&&(g=b.lastRenderedReducer,null!==g))try{var h=b.lastRenderedState,k=g(h,c);f.eagerReducer=g;f.eagerState=k;if(He(k,h))return}catch(l){}finally{}Jg(a,e,d);}}
var Gh={readContext:vg,useCallback:Ah,useContext:Ah,useEffect:Ah,useImperativeHandle:Ah,useLayoutEffect:Ah,useMemo:Ah,useReducer:Ah,useRef:Ah,useState:Ah,useDebugValue:Ah,useDeferredValue:Ah,useTransition:Ah,useMutableSource:Ah,useOpaqueIdentifier:Ah,unstable_isNewReconciler:!1},Dh={readContext:vg,useCallback:function(a,b){Hh().memoizedState=[a,void 0===b?null:b];return a},useContext:vg,useEffect:Wh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Uh(4,2,Zh.bind(null,
b,a),c)},useLayoutEffect:function(a,b){return Uh(4,2,a,b)},useMemo:function(a,b){var c=Hh();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=Hh();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=Oh.bind(null,R,a);return [d.memoizedState,a]},useRef:Sh,useState:Qh,useDebugValue:ai,useDeferredValue:function(a){var b=Qh(a),c=b[0],d=b[1];Wh(function(){var b=wh.transition;
wh.transition=1;try{d(a);}finally{wh.transition=b;}},[a]);return c},useTransition:function(){var a=Qh(!1),b=a[0];a=di.bind(null,a[1]);Sh(a);return [a,b]},useMutableSource:function(a,b,c){var d=Hh();d.memoizedState={refs:{getSnapshot:b,setSnapshot:null},source:a,subscribe:c};return Nh(d,a,b,c)},useOpaqueIdentifier:function(){if(lh){var a=!1,b=uf(function(){a||(a=!0,c("r:"+(tf++).toString(36)));throw Error(y(355));}),c=Qh(b)[1];0===(R.mode&2)&&(R.flags|=516,Rh(5,function(){c("r:"+(tf++).toString(36));},
void 0,null));return b}b="r:"+(tf++).toString(36);Qh(b);return b},unstable_isNewReconciler:!1},Eh={readContext:vg,useCallback:bi,useContext:vg,useEffect:Xh,useImperativeHandle:$h,useLayoutEffect:Yh,useMemo:ci,useReducer:Kh,useRef:Th,useState:function(){return Kh(Jh)},useDebugValue:ai,useDeferredValue:function(a){var b=Kh(Jh),c=b[0],d=b[1];Xh(function(){var b=wh.transition;wh.transition=1;try{d(a);}finally{wh.transition=b;}},[a]);return c},useTransition:function(){var a=Kh(Jh)[0];return [Th().current,
a]},useMutableSource:Ph,useOpaqueIdentifier:function(){return Kh(Jh)[0]},unstable_isNewReconciler:!1},Fh={readContext:vg,useCallback:bi,useContext:vg,useEffect:Xh,useImperativeHandle:$h,useLayoutEffect:Yh,useMemo:ci,useReducer:Lh,useRef:Th,useState:function(){return Lh(Jh)},useDebugValue:ai,useDeferredValue:function(a){var b=Lh(Jh),c=b[0],d=b[1];Xh(function(){var b=wh.transition;wh.transition=1;try{d(a);}finally{wh.transition=b;}},[a]);return c},useTransition:function(){var a=Lh(Jh)[0];return [Th().current,
a]},useMutableSource:Ph,useOpaqueIdentifier:function(){return Lh(Jh)[0]},unstable_isNewReconciler:!1},ei=ra.ReactCurrentOwner,ug=!1;function fi(a,b,c,d){b.child=null===a?Zg(b,null,c,d):Yg(b,a.child,c,d);}function gi(a,b,c,d,e){c=c.render;var f=b.ref;tg(b,e);d=Ch(a,b,c,d,f,e);if(null!==a&&!ug)return b.updateQueue=a.updateQueue,b.flags&=-517,a.lanes&=~e,hi(a,b,e);b.flags|=1;fi(a,b,d,e);return b.child}
function ii(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!ji(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ki(a,b,g,d,e,f);a=Vg(c.type,null,d,b,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(0===(e&f)&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:Je,c(e,d)&&a.ref===b.ref))return hi(a,b,f);b.flags|=1;a=Tg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ki(a,b,c,d,e,f){if(null!==a&&Je(a.memoizedProps,d)&&a.ref===b.ref)if(ug=!1,0!==(f&e))0!==(a.flags&16384)&&(ug=!0);else return b.lanes=a.lanes,hi(a,b,f);return li(a,b,c,d,f)}
function mi(a,b,c){var d=b.pendingProps,e=d.children,f=null!==a?a.memoizedState:null;if("hidden"===d.mode||"unstable-defer-without-hiding"===d.mode)if(0===(b.mode&4))b.memoizedState={baseLanes:0},ni(b,c);else if(0!==(c&1073741824))b.memoizedState={baseLanes:0},ni(b,null!==f?f.baseLanes:c);else return a=null!==f?f.baseLanes|c:c,b.lanes=b.childLanes=1073741824,b.memoizedState={baseLanes:a},ni(b,a),null;else null!==f?(d=f.baseLanes|c,b.memoizedState=null):d=c,ni(b,d);fi(a,b,e,c);return b.child}
function oi(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.flags|=128;}function li(a,b,c,d,e){var f=Ff(c)?Df:M.current;f=Ef(b,f);tg(b,e);c=Ch(a,b,c,d,f,e);if(null!==a&&!ug)return b.updateQueue=a.updateQueue,b.flags&=-517,a.lanes&=~e,hi(a,b,e);b.flags|=1;fi(a,b,c,e);return b.child}
function pi(a,b,c,d,e){if(Ff(c)){var f=!0;Jf(b);}else f=!1;tg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2),Mg(b,c,d),Og(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=vg(l):(l=Ff(c)?Df:M.current,l=Ef(b,l));var n=c.getDerivedStateFromProps,A="function"===typeof n||"function"===typeof g.getSnapshotBeforeUpdate;A||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Ng(b,g,d,l);wg=!1;var p=b.memoizedState;g.state=p;Cg(b,d,g,e);k=b.memoizedState;h!==d||p!==k||N.current||wg?("function"===typeof n&&(Gg(b,c,n,d),k=b.memoizedState),(h=wg||Lg(b,c,h,d,p,k,l))?(A||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.flags|=4)):("function"===typeof g.componentDidMount&&(b.flags|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.flags|=4),d=!1);}else {g=b.stateNode;yg(a,b);h=b.memoizedProps;l=b.type===b.elementType?h:lg(b.type,h);g.props=l;A=b.pendingProps;p=g.context;k=c.contextType;"object"===typeof k&&null!==k?k=vg(k):(k=Ff(c)?Df:M.current,k=Ef(b,k));var C=c.getDerivedStateFromProps;(n="function"===typeof C||
"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==A||p!==k)&&Ng(b,g,d,k);wg=!1;p=b.memoizedState;g.state=p;Cg(b,d,g,e);var x=b.memoizedState;h!==A||p!==x||N.current||wg?("function"===typeof C&&(Gg(b,c,C,d),x=b.memoizedState),(l=wg||Lg(b,c,l,d,p,x,k))?(n||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,k)),"function"===typeof g.componentDidUpdate&&(b.flags|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.flags|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=k,d=l):("function"!==typeof g.componentDidUpdate||
h===a.memoizedProps&&p===a.memoizedState||(b.flags|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&p===a.memoizedState||(b.flags|=256),d=!1);}return qi(a,b,c,d,f,e)}
function qi(a,b,c,d,e,f){oi(a,b);var g=0!==(b.flags&64);if(!d&&!g)return e&&Kf(b,c,!1),hi(a,b,f);d=b.stateNode;ei.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.flags|=1;null!==a&&g?(b.child=Yg(b,a.child,null,f),b.child=Yg(b,null,h,f)):fi(a,b,h,f);b.memoizedState=d.state;e&&Kf(b,c,!0);return b.child}function ri(a){var b=a.stateNode;b.pendingContext?Hf(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Hf(a,b.context,!1);eh(a,b.containerInfo);}
var si={dehydrated:null,retryLane:0};
function ti(a,b,c){var d=b.pendingProps,e=P.current,f=!1,g;(g=0!==(b.flags&64))||(g=null!==a&&null===a.memoizedState?!1:0!==(e&2));g?(f=!0,b.flags&=-65):null!==a&&null===a.memoizedState||void 0===d.fallback||!0===d.unstable_avoidThisFallback||(e|=1);I(P,e&1);if(null===a){void 0!==d.fallback&&ph(b);a=d.children;e=d.fallback;if(f)return a=ui(b,a,e,c),b.child.memoizedState={baseLanes:c},b.memoizedState=si,a;if("number"===typeof d.unstable_expectedLoadTime)return a=ui(b,a,e,c),b.child.memoizedState={baseLanes:c},
b.memoizedState=si,b.lanes=33554432,a;c=vi({mode:"visible",children:a},b.mode,c,null);c.return=b;return b.child=c}if(null!==a.memoizedState){if(f)return d=wi(a,b,d.children,d.fallback,c),f=b.child,e=a.child.memoizedState,f.memoizedState=null===e?{baseLanes:c}:{baseLanes:e.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=si,d;c=xi(a,b,d.children,c);b.memoizedState=null;return c}if(f)return d=wi(a,b,d.children,d.fallback,c),f=b.child,e=a.child.memoizedState,f.memoizedState=null===e?{baseLanes:c}:
{baseLanes:e.baseLanes|c},f.childLanes=a.childLanes&~c,b.memoizedState=si,d;c=xi(a,b,d.children,c);b.memoizedState=null;return c}function ui(a,b,c,d){var e=a.mode,f=a.child;b={mode:"hidden",children:b};0===(e&2)&&null!==f?(f.childLanes=0,f.pendingProps=b):f=vi(b,e,0,null);c=Xg(c,e,d,null);f.return=a;c.return=a;f.sibling=c;a.child=f;return c}
function xi(a,b,c,d){var e=a.child;a=e.sibling;c=Tg(e,{mode:"visible",children:c});0===(b.mode&2)&&(c.lanes=d);c.return=b;c.sibling=null;null!==a&&(a.nextEffect=null,a.flags=8,b.firstEffect=b.lastEffect=a);return b.child=c}
function wi(a,b,c,d,e){var f=b.mode,g=a.child;a=g.sibling;var h={mode:"hidden",children:c};0===(f&2)&&b.child!==g?(c=b.child,c.childLanes=0,c.pendingProps=h,g=c.lastEffect,null!==g?(b.firstEffect=c.firstEffect,b.lastEffect=g,g.nextEffect=null):b.firstEffect=b.lastEffect=null):c=Tg(g,h);null!==a?d=Tg(a,d):(d=Xg(d,f,e,null),d.flags|=2);d.return=b;c.return=b;c.sibling=d;b.child=c;return d}function yi(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);sg(a.return,b);}
function zi(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailMode=e,g.lastEffect=f);}
function Ai(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;fi(a,b,d.children,c);d=P.current;if(0!==(d&2))d=d&1|2,b.flags|=64;else {if(null!==a&&0!==(a.flags&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&yi(a,c);else if(19===a.tag)yi(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return;}a.sibling.return=a.return;a=a.sibling;}d&=1;}I(P,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===ih(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);zi(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===ih(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a;}zi(b,!0,c,null,f,b.lastEffect);break;case "together":zi(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null;}return b.child}
function hi(a,b,c){null!==a&&(b.dependencies=a.dependencies);Dg|=b.lanes;if(0!==(c&b.childLanes)){if(null!==a&&b.child!==a.child)throw Error(y(153));if(null!==b.child){a=b.child;c=Tg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Tg(a,a.pendingProps),c.return=b;c.sibling=null;}return b.child}return null}var Bi,Ci,Di,Ei;
Bi=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return;}c.sibling.return=c.return;c=c.sibling;}};Ci=function(){};
Di=function(a,b,c,d){var e=a.memoizedProps;if(e!==d){a=b.stateNode;dh(ah.current);var f=null;switch(c){case "input":e=Ya(a,e);d=Ya(a,d);f=[];break;case "option":e=eb(a,e);d=eb(a,d);f=[];break;case "select":e=m({},e,{value:void 0});d=m({},d,{value:void 0});f=[];break;case "textarea":e=gb(a,e);d=gb(a,d);f=[];break;default:"function"!==typeof e.onClick&&"function"===typeof d.onClick&&(a.onclick=jf);}vb(c,d);var g;c=null;for(l in e)if(!d.hasOwnProperty(l)&&e.hasOwnProperty(l)&&null!=e[l])if("style"===
l){var h=e[l];for(g in h)h.hasOwnProperty(g)&&(c||(c={}),c[g]="");}else "dangerouslySetInnerHTML"!==l&&"children"!==l&&"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ca.hasOwnProperty(l)?f||(f=[]):(f=f||[]).push(l,null));for(l in d){var k=d[l];h=null!=e?e[l]:void 0;if(d.hasOwnProperty(l)&&k!==h&&(null!=k||null!=h))if("style"===l)if(h){for(g in h)!h.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(c||(c={}),c[g]="");for(g in k)k.hasOwnProperty(g)&&h[g]!==k[g]&&(c||
(c={}),c[g]=k[g]);}else c||(f||(f=[]),f.push(l,c)),c=k;else "dangerouslySetInnerHTML"===l?(k=k?k.__html:void 0,h=h?h.__html:void 0,null!=k&&h!==k&&(f=f||[]).push(l,k)):"children"===l?"string"!==typeof k&&"number"!==typeof k||(f=f||[]).push(l,""+k):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&(ca.hasOwnProperty(l)?(null!=k&&"onScroll"===l&&G("scroll",a),f||h===k||(f=[])):"object"===typeof k&&null!==k&&k.$$typeof===Ga?k.toString():(f=f||[]).push(l,k));}c&&(f=f||[]).push("style",
c);var l=f;if(b.updateQueue=l)b.flags|=4;}};Ei=function(a,b,c,d){c!==d&&(b.flags|=4);};function Fi(a,b){if(!lh)switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null;}}
function Gi(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return Ff(b.type)&&Gf(),null;case 3:fh();H(N);H(M);uh();d=b.stateNode;d.pendingContext&&(d.context=d.pendingContext,d.pendingContext=null);if(null===a||null===a.child)rh(b)?b.flags|=4:d.hydrate||(b.flags|=256);Ci(b);return null;case 5:hh(b);var e=dh(ch.current);c=b.type;if(null!==a&&null!=b.stateNode)Di(a,b,c,d,e),a.ref!==b.ref&&(b.flags|=128);else {if(!d){if(null===
b.stateNode)throw Error(y(166));return null}a=dh(ah.current);if(rh(b)){d=b.stateNode;c=b.type;var f=b.memoizedProps;d[wf]=b;d[xf]=f;switch(c){case "dialog":G("cancel",d);G("close",d);break;case "iframe":case "object":case "embed":G("load",d);break;case "video":case "audio":for(a=0;a<Xe.length;a++)G(Xe[a],d);break;case "source":G("error",d);break;case "img":case "image":case "link":G("error",d);G("load",d);break;case "details":G("toggle",d);break;case "input":Za(d,f);G("invalid",d);break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};G("invalid",d);break;case "textarea":hb(d,f),G("invalid",d);}vb(c,f);a=null;for(var g in f)f.hasOwnProperty(g)&&(e=f[g],"children"===g?"string"===typeof e?d.textContent!==e&&(a=["children",e]):"number"===typeof e&&d.textContent!==""+e&&(a=["children",""+e]):ca.hasOwnProperty(g)&&null!=e&&"onScroll"===g&&G("scroll",d));switch(c){case "input":Va(d);cb(d,f,!0);break;case "textarea":Va(d);jb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&(d.onclick=
jf);}d=a;b.updateQueue=d;null!==d&&(b.flags|=4);}else {g=9===e.nodeType?e:e.ownerDocument;a===kb.html&&(a=lb(c));a===kb.html?"script"===c?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(c,{is:d.is}):(a=g.createElement(c),"select"===c&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,c);a[wf]=b;a[xf]=d;Bi(a,b,!1,!1);b.stateNode=a;g=wb(c,d);switch(c){case "dialog":G("cancel",a);G("close",a);
e=d;break;case "iframe":case "object":case "embed":G("load",a);e=d;break;case "video":case "audio":for(e=0;e<Xe.length;e++)G(Xe[e],a);e=d;break;case "source":G("error",a);e=d;break;case "img":case "image":case "link":G("error",a);G("load",a);e=d;break;case "details":G("toggle",a);e=d;break;case "input":Za(a,d);e=Ya(a,d);G("invalid",a);break;case "option":e=eb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};e=m({},d,{value:void 0});G("invalid",a);break;case "textarea":hb(a,d);e=
gb(a,d);G("invalid",a);break;default:e=d;}vb(c,e);var h=e;for(f in h)if(h.hasOwnProperty(f)){var k=h[f];"style"===f?tb(a,k):"dangerouslySetInnerHTML"===f?(k=k?k.__html:void 0,null!=k&&ob(a,k)):"children"===f?"string"===typeof k?("textarea"!==c||""!==k)&&pb(a,k):"number"===typeof k&&pb(a,""+k):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(ca.hasOwnProperty(f)?null!=k&&"onScroll"===f&&G("scroll",a):null!=k&&qa(a,f,k,g));}switch(c){case "input":Va(a);cb(a,d,!1);
break;case "textarea":Va(a);jb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+Sa(d.value));break;case "select":a.multiple=!!d.multiple;f=d.value;null!=f?fb(a,!!d.multiple,f,!1):null!=d.defaultValue&&fb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof e.onClick&&(a.onclick=jf);}mf(c,d)&&(b.flags|=4);}null!==b.ref&&(b.flags|=128);}return null;case 6:if(a&&null!=b.stateNode)Ei(a,b,a.memoizedProps,d);else {if("string"!==typeof d&&null===b.stateNode)throw Error(y(166));
c=dh(ch.current);dh(ah.current);rh(b)?(d=b.stateNode,c=b.memoizedProps,d[wf]=b,d.nodeValue!==c&&(b.flags|=4)):(d=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),d[wf]=b,b.stateNode=d);}return null;case 13:H(P);d=b.memoizedState;if(0!==(b.flags&64))return b.lanes=c,b;d=null!==d;c=!1;null===a?void 0!==b.memoizedProps.fallback&&rh(b):c=null!==a.memoizedState;if(d&&!c&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(P.current&1))0===V&&(V=3);else {if(0===V||3===V)V=
4;null===U||0===(Dg&134217727)&&0===(Hi&134217727)||Ii(U,W);}if(d||c)b.flags|=4;return null;case 4:return fh(),Ci(b),null===a&&cf(b.stateNode.containerInfo),null;case 10:return rg(b),null;case 17:return Ff(b.type)&&Gf(),null;case 19:H(P);d=b.memoizedState;if(null===d)return null;f=0!==(b.flags&64);g=d.rendering;if(null===g)if(f)Fi(d,!1);else {if(0!==V||null!==a&&0!==(a.flags&64))for(a=b.child;null!==a;){g=ih(a);if(null!==g){b.flags|=64;Fi(d,!1);f=g.updateQueue;null!==f&&(b.updateQueue=f,b.flags|=4);
null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;d=c;for(c=b.child;null!==c;)f=c,a=d,f.flags&=2,f.nextEffect=null,f.firstEffect=null,f.lastEffect=null,g=f.alternate,null===g?(f.childLanes=0,f.lanes=a,f.child=null,f.memoizedProps=null,f.memoizedState=null,f.updateQueue=null,f.dependencies=null,f.stateNode=null):(f.childLanes=g.childLanes,f.lanes=g.lanes,f.child=g.child,f.memoizedProps=g.memoizedProps,f.memoizedState=g.memoizedState,f.updateQueue=g.updateQueue,f.type=g.type,a=g.dependencies,
f.dependencies=null===a?null:{lanes:a.lanes,firstContext:a.firstContext}),c=c.sibling;I(P,P.current&1|2);return b.child}a=a.sibling;}null!==d.tail&&O()>Ji&&(b.flags|=64,f=!0,Fi(d,!1),b.lanes=33554432);}else {if(!f)if(a=ih(g),null!==a){if(b.flags|=64,f=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.flags|=4),Fi(d,!0),null===d.tail&&"hidden"===d.tailMode&&!g.alternate&&!lh)return b=b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*O()-d.renderingStartTime>Ji&&1073741824!==c&&(b.flags|=
64,f=!0,Fi(d,!1),b.lanes=33554432);d.isBackwards?(g.sibling=b.child,b.child=g):(c=d.last,null!==c?c.sibling=g:b.child=g,d.last=g);}return null!==d.tail?(c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=O(),c.sibling=null,b=P.current,I(P,f?b&1|2:b&1),c):null;case 23:case 24:return Ki(),null!==a&&null!==a.memoizedState!==(null!==b.memoizedState)&&"unstable-defer-without-hiding"!==d.mode&&(b.flags|=4),null}throw Error(y(156,b.tag));}
function Li(a){switch(a.tag){case 1:Ff(a.type)&&Gf();var b=a.flags;return b&4096?(a.flags=b&-4097|64,a):null;case 3:fh();H(N);H(M);uh();b=a.flags;if(0!==(b&64))throw Error(y(285));a.flags=b&-4097|64;return a;case 5:return hh(a),null;case 13:return H(P),b=a.flags,b&4096?(a.flags=b&-4097|64,a):null;case 19:return H(P),null;case 4:return fh(),null;case 10:return rg(a),null;case 23:case 24:return Ki(),null;default:return null}}
function Mi(a,b){try{var c="",d=b;do c+=Qa(d),d=d.return;while(d);var e=c;}catch(f){e="\nError generating stack: "+f.message+"\n"+f.stack;}return {value:a,source:b,stack:e}}function Ni(a,b){try{console.error(b.value);}catch(c){setTimeout(function(){throw c;});}}var Oi="function"===typeof WeakMap?WeakMap:Map;function Pi(a,b,c){c=zg(-1,c);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Qi||(Qi=!0,Ri=d);Ni(a,b);};return c}
function Si(a,b,c){c=zg(-1,c);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ni(a,b);return d(e)};}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Ti?Ti=new Set([this]):Ti.add(this),Ni(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""});});return c}var Ui="function"===typeof WeakSet?WeakSet:Set;
function Vi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null);}catch(c){Wi(a,c);}else b.current=null;}function Xi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.flags&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:lg(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b;}return;case 3:b.flags&256&&qf(b.stateNode.containerInfo);return;case 5:case 6:case 4:case 17:return}throw Error(y(163));}
function Yi(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{if(3===(a.tag&3)){var d=a.create;a.destroy=d();}a=a.next;}while(a!==b)}b=c.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){a=b=b.next;do{var e=a;d=e.next;e=e.tag;0!==(e&4)&&0!==(e&1)&&(Zi(c,a),$i(c,a));a=d;}while(a!==b)}return;case 1:a=c.stateNode;c.flags&4&&(null===b?a.componentDidMount():(d=c.elementType===c.type?b.memoizedProps:lg(c.type,b.memoizedProps),a.componentDidUpdate(d,
b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)));b=c.updateQueue;null!==b&&Eg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode;}Eg(c,b,a);}return;case 5:a=c.stateNode;null===b&&c.flags&4&&mf(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Cc(c))));
return;case 19:case 17:case 20:case 21:case 23:case 24:return}throw Error(y(163));}
function aj(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d=d.style,"function"===typeof d.setProperty?d.setProperty("display","none","important"):d.display="none";else {d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=sb("display",e);}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if((23!==c.tag&&24!==c.tag||null===c.memoizedState||c===a)&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===
a)break;for(;null===c.sibling;){if(null===c.return||c.return===a)return;c=c.return;}c.sibling.return=c.return;c=c.sibling;}}
function bj(a,b){if(Mf&&"function"===typeof Mf.onCommitFiberUnmount)try{Mf.onCommitFiberUnmount(Lf,b);}catch(f){}switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var c=a=a.next;do{var d=c,e=d.destroy;d=d.tag;if(void 0!==e)if(0!==(d&4))Zi(b,c);else {d=b;try{e();}catch(f){Wi(d,f);}}c=c.next;}while(c!==a)}break;case 1:Vi(b);a=b.stateNode;if("function"===typeof a.componentWillUnmount)try{a.props=b.memoizedProps,a.state=b.memoizedState,a.componentWillUnmount();}catch(f){Wi(b,
f);}break;case 5:Vi(b);break;case 4:cj(a,b);}}function dj(a){a.alternate=null;a.child=null;a.dependencies=null;a.firstEffect=null;a.lastEffect=null;a.memoizedProps=null;a.memoizedState=null;a.pendingProps=null;a.return=null;a.updateQueue=null;}function ej(a){return 5===a.tag||3===a.tag||4===a.tag}
function fj(a){a:{for(var b=a.return;null!==b;){if(ej(b))break a;b=b.return;}throw Error(y(160));}var c=b;b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(y(161));}c.flags&16&&(pb(b,""),c.flags&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||ej(c.return)){c=null;break a}c=c.return;}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.flags&2)continue b;if(null===
c.child||4===c.tag)continue b;else c.child.return=c,c=c.child;}if(!(c.flags&2)){c=c.stateNode;break a}}d?gj(a,c,b):hj(a,c,b);}
function gj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=jf));else if(4!==d&&(a=a.child,null!==a))for(gj(a,b,c),a=a.sibling;null!==a;)gj(a,b,c),a=a.sibling;}
function hj(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(hj(a,b,c),a=a.sibling;null!==a;)hj(a,b,c),a=a.sibling;}
function cj(a,b){for(var c=b,d=!1,e,f;;){if(!d){d=c.return;a:for(;;){if(null===d)throw Error(y(160));e=d.stateNode;switch(d.tag){case 5:f=!1;break a;case 3:e=e.containerInfo;f=!0;break a;case 4:e=e.containerInfo;f=!0;break a}d=d.return;}d=!0;}if(5===c.tag||6===c.tag){a:for(var g=a,h=c,k=h;;)if(bj(g,k),null!==k.child&&4!==k.tag)k.child.return=k,k=k.child;else {if(k===h)break a;for(;null===k.sibling;){if(null===k.return||k.return===h)break a;k=k.return;}k.sibling.return=k.return;k=k.sibling;}f?(g=e,h=c.stateNode,
8===g.nodeType?g.parentNode.removeChild(h):g.removeChild(h)):e.removeChild(c.stateNode);}else if(4===c.tag){if(null!==c.child){e=c.stateNode.containerInfo;f=!0;c.child.return=c;c=c.child;continue}}else if(bj(a,c),null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return;4===c.tag&&(d=!1);}c.sibling.return=c.return;c=c.sibling;}}
function ij(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:var c=b.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do 3===(d.tag&3)&&(a=d.destroy,d.destroy=void 0,void 0!==a&&a()),d=d.next;while(d!==c)}return;case 1:return;case 5:c=b.stateNode;if(null!=c){d=b.memoizedProps;var e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[xf]=d;"input"===a&&"radio"===d.type&&null!=d.name&&$a(c,d);wb(a,e);b=wb(a,d);for(e=0;e<f.length;e+=
2){var g=f[e],h=f[e+1];"style"===g?tb(c,h):"dangerouslySetInnerHTML"===g?ob(c,h):"children"===g?pb(c,h):qa(c,g,h,b);}switch(a){case "input":ab(c,d);break;case "textarea":ib(c,d);break;case "select":a=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,f=d.value,null!=f?fb(c,!!d.multiple,f,!1):a!==!!d.multiple&&(null!=d.defaultValue?fb(c,!!d.multiple,d.defaultValue,!0):fb(c,!!d.multiple,d.multiple?[]:"",!1));}}}return;case 6:if(null===b.stateNode)throw Error(y(162));b.stateNode.nodeValue=
b.memoizedProps;return;case 3:c=b.stateNode;c.hydrate&&(c.hydrate=!1,Cc(c.containerInfo));return;case 12:return;case 13:null!==b.memoizedState&&(jj=O(),aj(b.child,!0));kj(b);return;case 19:kj(b);return;case 17:return;case 23:case 24:aj(b,null!==b.memoizedState);return}throw Error(y(163));}function kj(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Ui);b.forEach(function(b){var d=lj.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d));});}}
function mj(a,b){return null!==a&&(a=a.memoizedState,null===a||null!==a.dehydrated)?(b=b.memoizedState,null!==b&&null===b.dehydrated):!1}var nj=Math.ceil,oj=ra.ReactCurrentDispatcher,pj=ra.ReactCurrentOwner,X=0,U=null,Y=null,W=0,qj=0,rj=Bf(0),V=0,sj=null,tj=0,Dg=0,Hi=0,uj=0,vj=null,jj=0,Ji=Infinity;function wj(){Ji=O()+500;}var Z=null,Qi=!1,Ri=null,Ti=null,xj=!1,yj=null,zj=90,Aj=[],Bj=[],Cj=null,Dj=0,Ej=null,Fj=-1,Gj=0,Hj=0,Ij=null,Jj=!1;function Hg(){return 0!==(X&48)?O():-1!==Fj?Fj:Fj=O()}
function Ig(a){a=a.mode;if(0===(a&2))return 1;if(0===(a&4))return 99===eg()?1:2;0===Gj&&(Gj=tj);if(0!==kg.transition){0!==Hj&&(Hj=null!==vj?vj.pendingLanes:0);a=Gj;var b=4186112&~Hj;b&=-b;0===b&&(a=4186112&~a,b=a&-a,0===b&&(b=8192));return b}a=eg();0!==(X&4)&&98===a?a=Xc(12,Gj):(a=Sc(a),a=Xc(a,Gj));return a}
function Jg(a,b,c){if(50<Dj)throw Dj=0,Ej=null,Error(y(185));a=Kj(a,b);if(null===a)return null;$c(a,b,c);a===U&&(Hi|=b,4===V&&Ii(a,W));var d=eg();1===b?0!==(X&8)&&0===(X&48)?Lj(a):(Mj(a,c),0===X&&(wj(),ig())):(0===(X&4)||98!==d&&99!==d||(null===Cj?Cj=new Set([a]):Cj.add(a)),Mj(a,c));vj=a;}function Kj(a,b){a.lanes|=b;var c=a.alternate;null!==c&&(c.lanes|=b);c=a;for(a=a.return;null!==a;)a.childLanes|=b,c=a.alternate,null!==c&&(c.childLanes|=b),c=a,a=a.return;return 3===c.tag?c.stateNode:null}
function Mj(a,b){for(var c=a.callbackNode,d=a.suspendedLanes,e=a.pingedLanes,f=a.expirationTimes,g=a.pendingLanes;0<g;){var h=31-Vc(g),k=1<<h,l=f[h];if(-1===l){if(0===(k&d)||0!==(k&e)){l=b;Rc(k);var n=F;f[h]=10<=n?l+250:6<=n?l+5E3:-1;}}else l<=b&&(a.expiredLanes|=k);g&=~k;}d=Uc(a,a===U?W:0);b=F;if(0===d)null!==c&&(c!==Zf&&Pf(c),a.callbackNode=null,a.callbackPriority=0);else {if(null!==c){if(a.callbackPriority===b)return;c!==Zf&&Pf(c);}15===b?(c=Lj.bind(null,a),null===ag?(ag=[c],bg=Of(Uf,jg)):ag.push(c),
c=Zf):14===b?c=hg(99,Lj.bind(null,a)):(c=Tc(b),c=hg(c,Nj.bind(null,a)));a.callbackPriority=b;a.callbackNode=c;}}
function Nj(a){Fj=-1;Hj=Gj=0;if(0!==(X&48))throw Error(y(327));var b=a.callbackNode;if(Oj()&&a.callbackNode!==b)return null;var c=Uc(a,a===U?W:0);if(0===c)return null;var d=c;var e=X;X|=16;var f=Pj();if(U!==a||W!==d)wj(),Qj(a,d);do try{Rj();break}catch(h){Sj(a,h);}while(1);qg();oj.current=f;X=e;null!==Y?d=0:(U=null,W=0,d=V);if(0!==(tj&Hi))Qj(a,0);else if(0!==d){2===d&&(X|=64,a.hydrate&&(a.hydrate=!1,qf(a.containerInfo)),c=Wc(a),0!==c&&(d=Tj(a,c)));if(1===d)throw b=sj,Qj(a,0),Ii(a,c),Mj(a,O()),b;a.finishedWork=
a.current.alternate;a.finishedLanes=c;switch(d){case 0:case 1:throw Error(y(345));case 2:Uj(a);break;case 3:Ii(a,c);if((c&62914560)===c&&(d=jj+500-O(),10<d)){if(0!==Uc(a,0))break;e=a.suspendedLanes;if((e&c)!==c){Hg();a.pingedLanes|=a.suspendedLanes&e;break}a.timeoutHandle=of(Uj.bind(null,a),d);break}Uj(a);break;case 4:Ii(a,c);if((c&4186112)===c)break;d=a.eventTimes;for(e=-1;0<c;){var g=31-Vc(c);f=1<<g;g=d[g];g>e&&(e=g);c&=~f;}c=e;c=O()-c;c=(120>c?120:480>c?480:1080>c?1080:1920>c?1920:3E3>c?3E3:4320>
c?4320:1960*nj(c/1960))-c;if(10<c){a.timeoutHandle=of(Uj.bind(null,a),c);break}Uj(a);break;case 5:Uj(a);break;default:throw Error(y(329));}}Mj(a,O());return a.callbackNode===b?Nj.bind(null,a):null}function Ii(a,b){b&=~uj;b&=~Hi;a.suspendedLanes|=b;a.pingedLanes&=~b;for(a=a.expirationTimes;0<b;){var c=31-Vc(b),d=1<<c;a[c]=-1;b&=~d;}}
function Lj(a){if(0!==(X&48))throw Error(y(327));Oj();if(a===U&&0!==(a.expiredLanes&W)){var b=W;var c=Tj(a,b);0!==(tj&Hi)&&(b=Uc(a,b),c=Tj(a,b));}else b=Uc(a,0),c=Tj(a,b);0!==a.tag&&2===c&&(X|=64,a.hydrate&&(a.hydrate=!1,qf(a.containerInfo)),b=Wc(a),0!==b&&(c=Tj(a,b)));if(1===c)throw c=sj,Qj(a,0),Ii(a,b),Mj(a,O()),c;a.finishedWork=a.current.alternate;a.finishedLanes=b;Uj(a);Mj(a,O());return null}
function Vj(){if(null!==Cj){var a=Cj;Cj=null;a.forEach(function(a){a.expiredLanes|=24&a.pendingLanes;Mj(a,O());});}ig();}function Wj(a,b){var c=X;X|=1;try{return a(b)}finally{X=c,0===X&&(wj(),ig());}}function Xj(a,b){var c=X;X&=-2;X|=8;try{return a(b)}finally{X=c,0===X&&(wj(),ig());}}function ni(a,b){I(rj,qj);qj|=b;tj|=b;}function Ki(){qj=rj.current;H(rj);}
function Qj(a,b){a.finishedWork=null;a.finishedLanes=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,pf(c));if(null!==Y)for(c=Y.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Gf();break;case 3:fh();H(N);H(M);uh();break;case 5:hh(d);break;case 4:fh();break;case 13:H(P);break;case 19:H(P);break;case 10:rg(d);break;case 23:case 24:Ki();}c=c.return;}U=a;Y=Tg(a.current,null);W=qj=tj=b;V=0;sj=null;uj=Hi=Dg=0;}
function Sj(a,b){do{var c=Y;try{qg();vh.current=Gh;if(yh){for(var d=R.memoizedState;null!==d;){var e=d.queue;null!==e&&(e.pending=null);d=d.next;}yh=!1;}xh=0;T=S=R=null;zh=!1;pj.current=null;if(null===c||null===c.return){V=1;sj=b;Y=null;break}a:{var f=a,g=c.return,h=c,k=b;b=W;h.flags|=2048;h.firstEffect=h.lastEffect=null;if(null!==k&&"object"===typeof k&&"function"===typeof k.then){var l=k;if(0===(h.mode&2)){var n=h.alternate;n?(h.updateQueue=n.updateQueue,h.memoizedState=n.memoizedState,h.lanes=n.lanes):
(h.updateQueue=null,h.memoizedState=null);}var A=0!==(P.current&1),p=g;do{var C;if(C=13===p.tag){var x=p.memoizedState;if(null!==x)C=null!==x.dehydrated?!0:!1;else {var w=p.memoizedProps;C=void 0===w.fallback?!1:!0!==w.unstable_avoidThisFallback?!0:A?!1:!0;}}if(C){var z=p.updateQueue;if(null===z){var u=new Set;u.add(l);p.updateQueue=u;}else z.add(l);if(0===(p.mode&2)){p.flags|=64;h.flags|=16384;h.flags&=-2981;if(1===h.tag)if(null===h.alternate)h.tag=17;else {var t=zg(-1,1);t.tag=2;Ag(h,t);}h.lanes|=1;break a}k=
void 0;h=b;var q=f.pingCache;null===q?(q=f.pingCache=new Oi,k=new Set,q.set(l,k)):(k=q.get(l),void 0===k&&(k=new Set,q.set(l,k)));if(!k.has(h)){k.add(h);var v=Yj.bind(null,f,l,h);l.then(v,v);}p.flags|=4096;p.lanes=b;break a}p=p.return;}while(null!==p);k=Error((Ra(h.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display.");}5!==V&&(V=2);k=Mi(k,h);p=
g;do{switch(p.tag){case 3:f=k;p.flags|=4096;b&=-b;p.lanes|=b;var J=Pi(p,f,b);Bg(p,J);break a;case 1:f=k;var K=p.type,Q=p.stateNode;if(0===(p.flags&64)&&("function"===typeof K.getDerivedStateFromError||null!==Q&&"function"===typeof Q.componentDidCatch&&(null===Ti||!Ti.has(Q)))){p.flags|=4096;b&=-b;p.lanes|=b;var L=Si(p,f,b);Bg(p,L);break a}}p=p.return;}while(null!==p)}Zj(c);}catch(va){b=va;Y===c&&null!==c&&(Y=c=c.return);continue}break}while(1)}
function Pj(){var a=oj.current;oj.current=Gh;return null===a?Gh:a}function Tj(a,b){var c=X;X|=16;var d=Pj();U===a&&W===b||Qj(a,b);do try{ak();break}catch(e){Sj(a,e);}while(1);qg();X=c;oj.current=d;if(null!==Y)throw Error(y(261));U=null;W=0;return V}function ak(){for(;null!==Y;)bk(Y);}function Rj(){for(;null!==Y&&!Qf();)bk(Y);}function bk(a){var b=ck(a.alternate,a,qj);a.memoizedProps=a.pendingProps;null===b?Zj(a):Y=b;pj.current=null;}
function Zj(a){var b=a;do{var c=b.alternate;a=b.return;if(0===(b.flags&2048)){c=Gi(c,b,qj);if(null!==c){Y=c;return}c=b;if(24!==c.tag&&23!==c.tag||null===c.memoizedState||0!==(qj&1073741824)||0===(c.mode&4)){for(var d=0,e=c.child;null!==e;)d|=e.lanes|e.childLanes,e=e.sibling;c.childLanes=d;}null!==a&&0===(a.flags&2048)&&(null===a.firstEffect&&(a.firstEffect=b.firstEffect),null!==b.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=b.firstEffect),a.lastEffect=b.lastEffect),1<b.flags&&(null!==
a.lastEffect?a.lastEffect.nextEffect=b:a.firstEffect=b,a.lastEffect=b));}else {c=Li(b);if(null!==c){c.flags&=2047;Y=c;return}null!==a&&(a.firstEffect=a.lastEffect=null,a.flags|=2048);}b=b.sibling;if(null!==b){Y=b;return}Y=b=a;}while(null!==b);0===V&&(V=5);}function Uj(a){var b=eg();gg(99,dk.bind(null,a,b));return null}
function dk(a,b){do Oj();while(null!==yj);if(0!==(X&48))throw Error(y(327));var c=a.finishedWork;if(null===c)return null;a.finishedWork=null;a.finishedLanes=0;if(c===a.current)throw Error(y(177));a.callbackNode=null;var d=c.lanes|c.childLanes,e=d,f=a.pendingLanes&~e;a.pendingLanes=e;a.suspendedLanes=0;a.pingedLanes=0;a.expiredLanes&=e;a.mutableReadLanes&=e;a.entangledLanes&=e;e=a.entanglements;for(var g=a.eventTimes,h=a.expirationTimes;0<f;){var k=31-Vc(f),l=1<<k;e[k]=0;g[k]=-1;h[k]=-1;f&=~l;}null!==
Cj&&0===(d&24)&&Cj.has(a)&&Cj.delete(a);a===U&&(Y=U=null,W=0);1<c.flags?null!==c.lastEffect?(c.lastEffect.nextEffect=c,d=c.firstEffect):d=c:d=c.firstEffect;if(null!==d){e=X;X|=32;pj.current=null;kf=fd;g=Ne();if(Oe(g)){if("selectionStart"in g)h={start:g.selectionStart,end:g.selectionEnd};else a:if(h=(h=g.ownerDocument)&&h.defaultView||window,(l=h.getSelection&&h.getSelection())&&0!==l.rangeCount){h=l.anchorNode;f=l.anchorOffset;k=l.focusNode;l=l.focusOffset;try{h.nodeType,k.nodeType;}catch(va){h=null;
break a}var n=0,A=-1,p=-1,C=0,x=0,w=g,z=null;b:for(;;){for(var u;;){w!==h||0!==f&&3!==w.nodeType||(A=n+f);w!==k||0!==l&&3!==w.nodeType||(p=n+l);3===w.nodeType&&(n+=w.nodeValue.length);if(null===(u=w.firstChild))break;z=w;w=u;}for(;;){if(w===g)break b;z===h&&++C===f&&(A=n);z===k&&++x===l&&(p=n);if(null!==(u=w.nextSibling))break;w=z;z=w.parentNode;}w=u;}h=-1===A||-1===p?null:{start:A,end:p};}else h=null;h=h||{start:0,end:0};}else h=null;lf={focusedElem:g,selectionRange:h};fd=!1;Ij=null;Jj=!1;Z=d;do try{ek();}catch(va){if(null===
Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect;}while(null!==Z);Ij=null;Z=d;do try{for(g=a;null!==Z;){var t=Z.flags;t&16&&pb(Z.stateNode,"");if(t&128){var q=Z.alternate;if(null!==q){var v=q.ref;null!==v&&("function"===typeof v?v(null):v.current=null);}}switch(t&1038){case 2:fj(Z);Z.flags&=-3;break;case 6:fj(Z);Z.flags&=-3;ij(Z.alternate,Z);break;case 1024:Z.flags&=-1025;break;case 1028:Z.flags&=-1025;ij(Z.alternate,Z);break;case 4:ij(Z.alternate,Z);break;case 8:h=Z;cj(g,h);var J=h.alternate;dj(h);null!==
J&&dj(J);}Z=Z.nextEffect;}}catch(va){if(null===Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect;}while(null!==Z);v=lf;q=Ne();t=v.focusedElem;g=v.selectionRange;if(q!==t&&t&&t.ownerDocument&&Me(t.ownerDocument.documentElement,t)){null!==g&&Oe(t)&&(q=g.start,v=g.end,void 0===v&&(v=q),"selectionStart"in t?(t.selectionStart=q,t.selectionEnd=Math.min(v,t.value.length)):(v=(q=t.ownerDocument||document)&&q.defaultView||window,v.getSelection&&(v=v.getSelection(),h=t.textContent.length,J=Math.min(g.start,h),g=void 0===
g.end?J:Math.min(g.end,h),!v.extend&&J>g&&(h=g,g=J,J=h),h=Le(t,J),f=Le(t,g),h&&f&&(1!==v.rangeCount||v.anchorNode!==h.node||v.anchorOffset!==h.offset||v.focusNode!==f.node||v.focusOffset!==f.offset)&&(q=q.createRange(),q.setStart(h.node,h.offset),v.removeAllRanges(),J>g?(v.addRange(q),v.extend(f.node,f.offset)):(q.setEnd(f.node,f.offset),v.addRange(q))))));q=[];for(v=t;v=v.parentNode;)1===v.nodeType&&q.push({element:v,left:v.scrollLeft,top:v.scrollTop});"function"===typeof t.focus&&t.focus();for(t=
0;t<q.length;t++)v=q[t],v.element.scrollLeft=v.left,v.element.scrollTop=v.top;}fd=!!kf;lf=kf=null;a.current=c;Z=d;do try{for(t=a;null!==Z;){var K=Z.flags;K&36&&Yi(t,Z.alternate,Z);if(K&128){q=void 0;var Q=Z.ref;if(null!==Q){var L=Z.stateNode;switch(Z.tag){case 5:q=L;break;default:q=L;}"function"===typeof Q?Q(q):Q.current=q;}}Z=Z.nextEffect;}}catch(va){if(null===Z)throw Error(y(330));Wi(Z,va);Z=Z.nextEffect;}while(null!==Z);Z=null;$f();X=e;}else a.current=c;if(xj)xj=!1,yj=a,zj=b;else for(Z=d;null!==Z;)b=
Z.nextEffect,Z.nextEffect=null,Z.flags&8&&(K=Z,K.sibling=null,K.stateNode=null),Z=b;d=a.pendingLanes;0===d&&(Ti=null);1===d?a===Ej?Dj++:(Dj=0,Ej=a):Dj=0;c=c.stateNode;if(Mf&&"function"===typeof Mf.onCommitFiberRoot)try{Mf.onCommitFiberRoot(Lf,c,void 0,64===(c.current.flags&64));}catch(va){}Mj(a,O());if(Qi)throw Qi=!1,a=Ri,Ri=null,a;if(0!==(X&8))return null;ig();return null}
function ek(){for(;null!==Z;){var a=Z.alternate;Jj||null===Ij||(0!==(Z.flags&8)?dc(Z,Ij)&&(Jj=!0):13===Z.tag&&mj(a,Z)&&dc(Z,Ij)&&(Jj=!0));var b=Z.flags;0!==(b&256)&&Xi(a,Z);0===(b&512)||xj||(xj=!0,hg(97,function(){Oj();return null}));Z=Z.nextEffect;}}function Oj(){if(90!==zj){var a=97<zj?97:zj;zj=90;return gg(a,fk)}return !1}function $i(a,b){Aj.push(b,a);xj||(xj=!0,hg(97,function(){Oj();return null}));}function Zi(a,b){Bj.push(b,a);xj||(xj=!0,hg(97,function(){Oj();return null}));}
function fk(){if(null===yj)return !1;var a=yj;yj=null;if(0!==(X&48))throw Error(y(331));var b=X;X|=32;var c=Bj;Bj=[];for(var d=0;d<c.length;d+=2){var e=c[d],f=c[d+1],g=e.destroy;e.destroy=void 0;if("function"===typeof g)try{g();}catch(k){if(null===f)throw Error(y(330));Wi(f,k);}}c=Aj;Aj=[];for(d=0;d<c.length;d+=2){e=c[d];f=c[d+1];try{var h=e.create;e.destroy=h();}catch(k){if(null===f)throw Error(y(330));Wi(f,k);}}for(h=a.current.firstEffect;null!==h;)a=h.nextEffect,h.nextEffect=null,h.flags&8&&(h.sibling=
null,h.stateNode=null),h=a;X=b;ig();return !0}function gk(a,b,c){b=Mi(c,b);b=Pi(a,b,1);Ag(a,b);b=Hg();a=Kj(a,1);null!==a&&($c(a,1,b),Mj(a,b));}
function Wi(a,b){if(3===a.tag)gk(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){gk(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Ti||!Ti.has(d))){a=Mi(b,a);var e=Si(c,a,1);Ag(c,e);e=Hg();c=Kj(c,1);if(null!==c)$c(c,1,e),Mj(c,e);else if("function"===typeof d.componentDidCatch&&(null===Ti||!Ti.has(d)))try{d.componentDidCatch(b,a);}catch(f){}break}}c=c.return;}}
function Yj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);b=Hg();a.pingedLanes|=a.suspendedLanes&c;U===a&&(W&c)===c&&(4===V||3===V&&(W&62914560)===W&&500>O()-jj?Qj(a,0):uj|=c);Mj(a,b);}function lj(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=a.mode,0===(b&2)?b=1:0===(b&4)?b=99===eg()?1:2:(0===Gj&&(Gj=tj),b=Yc(62914560&~Gj),0===b&&(b=4194304)));c=Hg();a=Kj(a,b);null!==a&&($c(a,b,c),Mj(a,c));}var ck;
ck=function(a,b,c){var d=b.lanes;if(null!==a)if(a.memoizedProps!==b.pendingProps||N.current)ug=!0;else if(0!==(c&d))ug=0!==(a.flags&16384)?!0:!1;else {ug=!1;switch(b.tag){case 3:ri(b);sh();break;case 5:gh(b);break;case 1:Ff(b.type)&&Jf(b);break;case 4:eh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;var e=b.type._context;I(mg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){if(0!==(c&b.child.childLanes))return ti(a,b,c);I(P,P.current&1);b=hi(a,b,c);return null!==
b?b.sibling:null}I(P,P.current&1);break;case 19:d=0!==(c&b.childLanes);if(0!==(a.flags&64)){if(d)return Ai(a,b,c);b.flags|=64;}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null,e.lastEffect=null);I(P,P.current);if(d)break;else return null;case 23:case 24:return b.lanes=0,mi(a,b,c)}return hi(a,b,c)}else ug=!1;b.lanes=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);a=b.pendingProps;e=Ef(b,M.current);tg(b,c);e=Ch(null,b,d,a,e,c);b.flags|=1;if("object"===
typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(Ff(d)){var f=!0;Jf(b);}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;xg(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Gg(b,d,g,a);e.updater=Kg;b.stateNode=e;e._reactInternals=b;Og(b,d,a,c);b=qi(null,b,d,!0,f,c);}else b.tag=0,fi(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;a:{null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2);
a=b.pendingProps;f=e._init;e=f(e._payload);b.type=e;f=b.tag=hk(e);a=lg(e,a);switch(f){case 0:b=li(null,b,e,a,c);break a;case 1:b=pi(null,b,e,a,c);break a;case 11:b=gi(null,b,e,a,c);break a;case 14:b=ii(null,b,e,lg(e.type,a),d,c);break a}throw Error(y(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),li(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),pi(a,b,d,e,c);case 3:ri(b);d=b.updateQueue;if(null===a||null===d)throw Error(y(282));
d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;yg(a,b);Cg(b,d,null,c);d=b.memoizedState.element;if(d===e)sh(),b=hi(a,b,c);else {e=b.stateNode;if(f=e.hydrate)kh=rf(b.stateNode.containerInfo.firstChild),jh=b,f=lh=!0;if(f){a=e.mutableSourceEagerHydrationData;if(null!=a)for(e=0;e<a.length;e+=2)f=a[e],f._workInProgressVersionPrimary=a[e+1],th.push(f);c=Zg(b,null,d,c);for(b.child=c;c;)c.flags=c.flags&-3|1024,c=c.sibling;}else fi(a,b,d,c),sh();b=b.child;}return b;case 5:return gh(b),null===a&&
ph(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,g=e.children,nf(d,e)?g=null:null!==f&&nf(d,f)&&(b.flags|=16),oi(a,b),fi(a,b,g,c),b.child;case 6:return null===a&&ph(b),null;case 13:return ti(a,b,c);case 4:return eh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Yg(b,null,d,c):fi(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),gi(a,b,d,e,c);case 7:return fi(a,b,b.pendingProps,c),b.child;case 8:return fi(a,b,b.pendingProps.children,
c),b.child;case 12:return fi(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(mg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=He(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!N.current){b=hi(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==k){g=h.child;for(var l=
k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=zg(-1,c&-c),l.tag=2,Ag(h,l));h.lanes|=c;l=h.alternate;null!==l&&(l.lanes|=c);sg(h.return,c);k.lanes|=c;break}l=l.next;}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return;}h=g;}fi(a,b,e.children,c);b=b.child;}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,tg(b,c),e=vg(e,
f.unstable_observedBits),d=d(e),b.flags|=1,fi(a,b,d,c),b.child;case 14:return e=b.type,f=lg(e,b.pendingProps),f=lg(e.type,f),ii(a,b,e,f,d,c);case 15:return ki(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:lg(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.flags|=2),b.tag=1,Ff(d)?(a=!0,Jf(b)):a=!1,tg(b,c),Mg(b,d,e),Og(b,d,e,c),qi(null,b,d,!0,a,c);case 19:return Ai(a,b,c);case 23:return mi(a,b,c);case 24:return mi(a,b,c)}throw Error(y(156,b.tag));
};function ik(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.flags=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childLanes=this.lanes=0;this.alternate=null;}function nh(a,b,c,d){return new ik(a,b,c,d)}function ji(a){a=a.prototype;return !(!a||!a.isReactComponent)}
function hk(a){if("function"===typeof a)return ji(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===Aa)return 11;if(a===Da)return 14}return 2}
function Tg(a,b){var c=a.alternate;null===c?(c=nh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.type=a.type,c.flags=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childLanes=a.childLanes;c.lanes=a.lanes;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{lanes:b.lanes,firstContext:b.firstContext};
c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Vg(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)ji(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ua:return Xg(c.children,e,f,b);case Ha:g=8;e|=16;break;case wa:g=8;e|=1;break;case xa:return a=nh(12,c,b,e|8),a.elementType=xa,a.type=xa,a.lanes=f,a;case Ba:return a=nh(13,c,b,e),a.type=Ba,a.elementType=Ba,a.lanes=f,a;case Ca:return a=nh(19,c,b,e),a.elementType=Ca,a.lanes=f,a;case Ia:return vi(c,e,f,b);case Ja:return a=nh(24,c,b,e),a.elementType=Ja,a.lanes=f,a;default:if("object"===
typeof a&&null!==a)switch(a.$$typeof){case ya:g=10;break a;case za:g=9;break a;case Aa:g=11;break a;case Da:g=14;break a;case Ea:g=16;d=null;break a;case Fa:g=22;break a}throw Error(y(130,null==a?a:typeof a,""));}b=nh(g,c,b,e);b.elementType=a;b.type=d;b.lanes=f;return b}function Xg(a,b,c,d){a=nh(7,a,d,b);a.lanes=c;return a}function vi(a,b,c,d){a=nh(23,a,d,b);a.elementType=Ia;a.lanes=c;return a}function Ug(a,b,c){a=nh(6,a,null,b);a.lanes=c;return a}
function Wg(a,b,c){b=nh(4,null!==a.children?a.children:[],a.key,b);b.lanes=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function jk(a,b,c){this.tag=b;this.containerInfo=a;this.finishedWork=this.pingCache=this.current=this.pendingChildren=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=0;this.eventTimes=Zc(0);this.expirationTimes=Zc(-1);this.entangledLanes=this.finishedLanes=this.mutableReadLanes=this.expiredLanes=this.pingedLanes=this.suspendedLanes=this.pendingLanes=0;this.entanglements=Zc(0);this.mutableSourceEagerHydrationData=null;}
function kk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return {$$typeof:ta,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
function lk(a,b,c,d){var e=b.current,f=Hg(),g=Ig(e);a:if(c){c=c._reactInternals;b:{if(Zb(c)!==c||1!==c.tag)throw Error(y(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(Ff(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return;}while(null!==h);throw Error(y(171));}if(1===c.tag){var k=c.type;if(Ff(k)){c=If(c,k,h);break a}}c=h;}else c=Cf;null===b.context?b.context=c:b.pendingContext=c;b=zg(f,g);b.payload={element:a};d=void 0===d?null:d;null!==
d&&(b.callback=d);Ag(e,b);Jg(e,g,f);return g}function mk(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function nk(a,b){a=a.memoizedState;if(null!==a&&null!==a.dehydrated){var c=a.retryLane;a.retryLane=0!==c&&c<b?c:b;}}function ok(a,b){nk(a,b);(a=a.alternate)&&nk(a,b);}function pk(){return null}
function qk(a,b,c){var d=null!=c&&null!=c.hydrationOptions&&c.hydrationOptions.mutableSources||null;c=new jk(a,b,null!=c&&!0===c.hydrate);b=nh(3,null,null,2===b?7:1===b?3:0);c.current=b;b.stateNode=c;xg(b);a[ff]=c.current;cf(8===a.nodeType?a.parentNode:a);if(d)for(a=0;a<d.length;a++){b=d[a];var e=b._getVersion;e=e(b._source);null==c.mutableSourceEagerHydrationData?c.mutableSourceEagerHydrationData=[b,e]:c.mutableSourceEagerHydrationData.push(b,e);}this._internalRoot=c;}
qk.prototype.render=function(a){lk(a,this._internalRoot,null,null);};qk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;lk(null,a,null,function(){b[ff]=null;});};function rk(a){return !(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}
function sk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new qk(a,0,b?{hydrate:!0}:void 0)}
function tk(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=mk(g);h.call(a);};}lk(b,g,a,e);}else {f=c._reactRootContainer=sk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=mk(g);k.call(a);};}Xj(function(){lk(b,g,a,e);});}return mk(g)}ec=function(a){if(13===a.tag){var b=Hg();Jg(a,4,b);ok(a,4);}};fc=function(a){if(13===a.tag){var b=Hg();Jg(a,67108864,b);ok(a,67108864);}};
gc=function(a){if(13===a.tag){var b=Hg(),c=Ig(a);Jg(a,c,b);ok(a,c);}};hc=function(a,b){return b()};
yb=function(a,b,c){switch(b){case "input":ab(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Db(d);if(!e)throw Error(y(90));Wa(d);ab(d,e);}}}break;case "textarea":ib(a,c);break;case "select":b=c.value,null!=b&&fb(a,!!c.multiple,b,!1);}};Gb=Wj;
Hb=function(a,b,c,d,e){var f=X;X|=4;try{return gg(98,a.bind(null,b,c,d,e))}finally{X=f,0===X&&(wj(),ig());}};Ib=function(){0===(X&49)&&(Vj(),Oj());};Jb=function(a,b){var c=X;X|=2;try{return a(b)}finally{X=c,0===X&&(wj(),ig());}};function uk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!rk(b))throw Error(y(200));return kk(a,b,null,c)}var vk={Events:[Cb,ue,Db,Eb,Fb,Oj,{current:!1}]},wk={findFiberByHostInstance:wc,bundleType:0,version:"17.0.1",rendererPackageName:"react-dom"};
var xk={bundleType:wk.bundleType,version:wk.version,rendererPackageName:wk.rendererPackageName,rendererConfig:wk.rendererConfig,overrideHookState:null,overrideHookStateDeletePath:null,overrideHookStateRenamePath:null,overrideProps:null,overridePropsDeletePath:null,overridePropsRenamePath:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:ra.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=cc(a);return null===a?null:a.stateNode},findFiberByHostInstance:wk.findFiberByHostInstance||
pk,findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null};if("undefined"!==typeof __REACT_DEVTOOLS_GLOBAL_HOOK__){var yk=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(!yk.isDisabled&&yk.supportsFiber)try{Lf=yk.inject(xk),Mf=yk;}catch(a){}}reactDom_production_min.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=vk;reactDom_production_min.createPortal=uk;
reactDom_production_min.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternals;if(void 0===b){if("function"===typeof a.render)throw Error(y(188));throw Error(y(268,Object.keys(a)));}a=cc(b);a=null===a?null:a.stateNode;return a};reactDom_production_min.flushSync=function(a,b){var c=X;if(0!==(c&48))return a(b);X|=1;try{if(a)return gg(99,a.bind(null,b))}finally{X=c,ig();}};reactDom_production_min.hydrate=function(a,b,c){if(!rk(b))throw Error(y(200));return tk(null,a,b,!0,c)};
reactDom_production_min.render=function(a,b,c){if(!rk(b))throw Error(y(200));return tk(null,a,b,!1,c)};reactDom_production_min.unmountComponentAtNode=function(a){if(!rk(a))throw Error(y(40));return a._reactRootContainer?(Xj(function(){tk(null,null,a,!1,function(){a._reactRootContainer=null;a[ff]=null;});}),!0):!1};reactDom_production_min.unstable_batchedUpdates=Wj;reactDom_production_min.unstable_createPortal=function(a,b){return uk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
reactDom_production_min.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!rk(c))throw Error(y(200));if(null==a||void 0===a._reactInternals)throw Error(y(38));return tk(a,b,c,!1,d)};reactDom_production_min.version="17.0.1";

function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

{
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  reactDom.exports = reactDom_production_min;
}

var ReactDom = reactDom.exports;

class FronteggApp {
    constructor(_options, name, iframeRendering = false) {
        var _a, _b, _c, _d;
        this.loading = true;
        this.customElementName = '';
        this.loadingListeners = [];
        this.loadAdminBoxMetadata = () => __awaiter(this, void 0, void 0, function* () {
            var _e, _f, _g;
            const { Get } = _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__.fetch;
            if (!this.options.metadata) {
                try {
                    const data = yield Get(`/metadata`, { entityName: 'adminBox' });
                    this.options.metadata = (_g = (_f = (_e = data === null || data === void 0 ? void 0 : data.rows) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.configuration) !== null && _g !== void 0 ? _g : {};
                }
                catch (e) {
                    console.error('failed to get admin portal metadata', e);
                }
            }
            _frontegg_types__WEBPACK_IMPORTED_MODULE_1__.Metadata.set(this.options.metadata, this.name);
        });
        this.requestAuthorize = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.options.hostedLoginBox && !this.options.builderMode && this.options.framework !== 'nextjs') {
                this.store.dispatch({
                    type: 'auth/requestAuthorize',
                    payload: true,
                });
            }
        });
        this.updateLocalizationsSetter = (localizationUpdateFn) => {
            this.updateLocalizations = localizationUpdateFn;
        };
        let appName = (0,_utils_js__WEBPACK_IMPORTED_MODULE_4__/* .formatName */ .K)(name);
        let customElementName = `frontegg-app-${appName}`;
        this.iframeRendering = iframeRendering;
        this.name = appName;
        this.options = Object.assign(Object.assign({}, _options), { contextOptions: Object.assign({ requestCredentials: 'include' }, _options.contextOptions) });
        this.customElementName = customElementName;
        this.store = (_a = this.options.store) !== null && _a !== void 0 ? _a : (0,_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_0__/* .createFronteggStore */ .iv)({ context: this.options.contextOptions }, this, this.options.previewMode, (_b = this.options.authOptions) !== null && _b !== void 0 ? _b : {}, {
            auth: (_c = this.options.authOptions) !== null && _c !== void 0 ? _c : {},
            audits: (_d = this.options.auditsOptions) !== null && _d !== void 0 ? _d : {},
        });
        _AppHolder_js__WEBPACK_IMPORTED_MODULE_2__/* .AppHolder.setInstance */ .V.setInstance(appName, this);
    }
    initContainers(elements) {
        return __awaiter(this, void 0, void 0, function* () {
            this.adminPortalEl = elements.adminPortalEl;
            this.loginBoxEl = elements.loginBoxEl;
            this.checkoutDialogEl = elements.checkoutDialogEl;
            this.adminPortalContainer = elements.adminPortalContainer;
            this.loginBoxContainer = elements.loginBoxContainer;
            this.checkoutDialogContainer = elements.checkoutDialogContainer;
            try {
                document.body.classList.add('frontegg-loading');
            }
            catch (e) { }
            yield Promise.all([this.loadAdminBoxMetadata(), this.requestAuthorize()]);
            if (!this.options.previewMode && !this.options.customLoginBox) {
                setTimeout(() => {
                    const loginBoxComponent = React.lazy(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 51261)));
                    const loginBox = React.createElement(loginBoxComponent, {
                        options: this.options,
                        injector: this,
                    });
                    const wrapper = React.createElement(React.Suspense, { fallback: '' }, loginBox);
                    ReactDom.render(wrapper, this.loginBoxEl);
                    this.loading = false;
                    this.loadingListeners.forEach((listener) => {
                        try {
                            listener();
                        }
                        catch (e) { }
                    });
                    this.loadingListeners = [];
                });
            }
        });
    }
    updateMetadata(metadata) {
        var _a;
        _frontegg_types__WEBPACK_IMPORTED_MODULE_1__.Metadata.set(metadata, this.name);
        if (metadata === null || metadata === void 0 ? void 0 : metadata.localizations) {
            (_a = this.updateLocalizations) === null || _a === void 0 ? void 0 : _a.call(this, metadata.localizations);
        }
    }
    addOnLoadedListener(listener) {
        if (!this.loading) {
            listener();
            return;
        }
        this.loadingListeners.push(listener);
    }
    showAdminPortal() {
        const adminPortalComponent = React.lazy(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 88768)));
        const adminPortal = React.createElement(adminPortalComponent, {
            options: this.options,
            injector: this,
        });
        const wrapper = React.createElement(React.Suspense, { fallback: '' }, adminPortal);
        ReactDom.render(wrapper, this.adminPortalEl);
    }
    hideAdminPortal() {
        ReactDom.unmountComponentAtNode(this.adminPortalEl);
    }
    showCheckoutDialog(opts) {
        const checkoutDialogComponent = React.lazy(() => Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 88768)).then(({ CheckoutDialog }) => ({ default: CheckoutDialog })));
        const checkoutDialog = React.createElement(checkoutDialogComponent, Object.assign(Object.assign({}, opts), { options: this.options, injector: this }));
        const wrapper = React.createElement(React.Suspense, { fallback: '' }, checkoutDialog);
        ReactDom.render(wrapper, this.checkoutDialogEl);
    }
    hideCheckoutDialog() {
        ReactDom.unmountComponentAtNode(this.checkoutDialogEl);
    }
    close() {
        ReactDom.unmountComponentAtNode(this.adminPortalEl);
        ReactDom.unmountComponentAtNode(this.checkoutDialogEl);
    }
}




/***/ }),

/***/ 25618:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useForgotPasswordState; },
/* harmony export */   "A": function() { return /* binding */ Alert$1; },
/* harmony export */   "B": function() { return /* binding */ Box$1; },
/* harmony export */   "C": function() { return /* binding */ Card$1; },
/* harmony export */   "D": function() { return /* binding */ Divider$1; },
/* harmony export */   "E": function() { return /* binding */ InnerThemeProvider; },
/* harmony export */   "F": function() { return /* binding */ useTheme; },
/* harmony export */   "G": function() { return /* binding */ Grid$1; },
/* harmony export */   "H": function() { return /* binding */ useSocialLoginState; },
/* harmony export */   "I": function() { return /* binding */ Input$1; },
/* harmony export */   "J": function() { return /* binding */ useAuth; },
/* harmony export */   "K": function() { return /* binding */ useAuthRoutes; },
/* harmony export */   "L": function() { return /* binding */ Link$1; },
/* harmony export */   "M": function() { return /* binding */ useTranslation; },
/* harmony export */   "N": function() { return /* binding */ FronteggStoreContext; },
/* harmony export */   "O": function() { return /* binding */ Loader$1; },
/* harmony export */   "P": function() { return /* binding */ Provider; },
/* harmony export */   "Q": function() { return /* binding */ useOnRedirectTo; },
/* harmony export */   "R": function() { return /* binding */ RenderAsSlot; },
/* harmony export */   "S": function() { return /* binding */ ShadowDomContext; },
/* harmony export */   "T": function() { return /* binding */ Typography$1; },
/* harmony export */   "U": function() { return /* binding */ useLoginActions; },
/* harmony export */   "V": function() { return /* binding */ useAuthActions; },
/* harmony export */   "W": function() { return /* binding */ useIsAuthenticated; },
/* harmony export */   "X": function() { return /* binding */ useAuthUserOrNull; },
/* harmony export */   "Y": function() { return /* binding */ useActivateAccountState; },
/* harmony export */   "Z": function() { return /* binding */ useActivateAccountActions; },
/* harmony export */   "_": function() { return /* binding */ useSecurityPolicyState; },
/* harmony export */   "a": function() { return /* binding */ styledEngine; },
/* harmony export */   "a$": function() { return /* binding */ generateUtilityClass; },
/* harmony export */   "a0": function() { return /* binding */ useForgotPasswordActions; },
/* harmony export */   "a1": function() { return /* binding */ useSSOState; },
/* harmony export */   "a2": function() { return /* binding */ useSSOActions; },
/* harmony export */   "a3": function() { return /* binding */ LoginMessage; },
/* harmony export */   "a4": function() { return /* binding */ useLoginState; },
/* harmony export */   "a5": function() { return /* binding */ useResetPhoneNumberState; },
/* harmony export */   "a6": function() { return /* binding */ useSecurityPolicyActions; },
/* harmony export */   "a7": function() { return /* binding */ useSocialLoginActions; },
/* harmony export */   "a8": function() { return /* binding */ useTheme$1; },
/* harmony export */   "a9": function() { return /* binding */ useAcceptInvitationActions; },
/* harmony export */   "aA": function() { return /* binding */ OneTouchIcon; },
/* harmony export */   "aB": function() { return /* binding */ UsbIcon; },
/* harmony export */   "aC": function() { return /* binding */ QrIcon; },
/* harmony export */   "aD": function() { return /* binding */ Collapse$1; },
/* harmony export */   "aE": function() { return /* binding */ LogInIcon; },
/* harmony export */   "aF": function() { return /* binding */ OTCInput$1; },
/* harmony export */   "aG": function() { return /* binding */ FormControlLabel$1; },
/* harmony export */   "aH": function() { return /* binding */ callbackToPromise; },
/* harmony export */   "aI": function() { return /* binding */ FormHelperText$1; },
/* harmony export */   "aJ": function() { return /* binding */ SmsIcon; },
/* harmony export */   "aK": function() { return /* binding */ usePublicAuthStrategiesPolicySettings; },
/* harmony export */   "aL": function() { return /* binding */ InputCopy$1; },
/* harmony export */   "aM": function() { return /* binding */ useSelector; },
/* harmony export */   "aN": function() { return /* binding */ shallowEqual$1; },
/* harmony export */   "aO": function() { return /* binding */ useDispatch; },
/* harmony export */   "aP": function() { return /* binding */ createSvgIcon$1; },
/* harmony export */   "aQ": function() { return /* binding */ jsxRuntime; },
/* harmony export */   "aR": function() { return /* binding */ easing; },
/* harmony export */   "aS": function() { return /* binding */ duration; },
/* harmony export */   "aT": function() { return /* binding */ _objectWithoutPropertiesLoose$6; },
/* harmony export */   "aU": function() { return /* binding */ useForkRef; },
/* harmony export */   "aV": function() { return /* binding */ debounce$1; },
/* harmony export */   "aW": function() { return /* binding */ ownerWindow; },
/* harmony export */   "aX": function() { return /* binding */ _extends$a; },
/* harmony export */   "aY": function() { return /* binding */ Transition$1; },
/* harmony export */   "aZ": function() { return /* binding */ getTransitionProps; },
/* harmony export */   "a_": function() { return /* binding */ reflow; },
/* harmony export */   "aa": function() { return /* binding */ useAcceptInvitationState; },
/* harmony export */   "ab": function() { return /* binding */ validateSchema; },
/* harmony export */   "ac": function() { return /* binding */ validatePasswordUsingOWASP; },
/* harmony export */   "ad": function() { return /* binding */ validateConfirmPassword; },
/* harmony export */   "ae": function() { return /* binding */ validateEmail; },
/* harmony export */   "af": function() { return /* binding */ Owasp; },
/* harmony export */   "ag": function() { return /* binding */ useSignUpState; },
/* harmony export */   "ah": function() { return /* binding */ useResetPhoneNumberActions; },
/* harmony export */   "ai": function() { return /* binding */ validationPhone; },
/* harmony export */   "aj": function() { return /* binding */ useVendorState; },
/* harmony export */   "ak": function() { return /* binding */ SvgIcon$1; },
/* harmony export */   "al": function() { return /* binding */ Formik; },
/* harmony export */   "am": function() { return /* binding */ Form; },
/* harmony export */   "an": function() { return /* binding */ AnimatedCardCarousel$1; },
/* harmony export */   "ao": function() { return /* binding */ useMuiMediaQuery; },
/* harmony export */   "ap": function() { return /* binding */ validateLength; },
/* harmony export */   "aq": function() { return /* binding */ useMfaState; },
/* harmony export */   "ar": function() { return /* binding */ useMfaActions; },
/* harmony export */   "as": function() { return /* binding */ validateTwoFactorCode; },
/* harmony export */   "at": function() { return /* binding */ useField; },
/* harmony export */   "au": function() { return /* binding */ InputPassword$1; },
/* harmony export */   "av": function() { return /* binding */ PasswordStrengthChecker; },
/* harmony export */   "aw": function() { return /* binding */ useSignUpActions; },
/* harmony export */   "ax": function() { return /* binding */ validateMinLength; },
/* harmony export */   "ay": function() { return /* binding */ validateRequiredBoolean; },
/* harmony export */   "az": function() { return /* binding */ Carousel; },
/* harmony export */   "b": function() { return /* binding */ propertyExpr; },
/* harmony export */   "b$": function() { return /* binding */ useAuthUser; },
/* harmony export */   "b0": function() { return /* binding */ generateUtilityClasses; },
/* harmony export */   "b1": function() { return /* binding */ Modal$1; },
/* harmony export */   "b2": function() { return /* binding */ rootShouldForwardProp$1; },
/* harmony export */   "b3": function() { return /* binding */ Paper$1; },
/* harmony export */   "b4": function() { return /* binding */ capitalize$2; },
/* harmony export */   "b5": function() { return /* binding */ useThemeProps; },
/* harmony export */   "b6": function() { return /* binding */ composeClasses; },
/* harmony export */   "b7": function() { return /* binding */ clsx; },
/* harmony export */   "b8": function() { return /* binding */ InputBaseRoot; },
/* harmony export */   "b9": function() { return /* binding */ rootOverridesResolver; },
/* harmony export */   "bA": function() { return /* binding */ AmericanExpressIcon; },
/* harmony export */   "bB": function() { return /* binding */ MasterCardIcon; },
/* harmony export */   "bC": function() { return /* binding */ DinersCardIcon; },
/* harmony export */   "bD": function() { return /* binding */ GenericCardIcon; },
/* harmony export */   "bE": function() { return /* binding */ enhanceAdminBoxTheme; },
/* harmony export */   "bF": function() { return /* binding */ useMediaQuery; },
/* harmony export */   "bG": function() { return /* binding */ Dialog$1; },
/* harmony export */   "bH": function() { return /* binding */ usePublicPolicySettings; },
/* harmony export */   "bI": function() { return /* binding */ EditIcon; },
/* harmony export */   "bJ": function() { return /* binding */ _inheritsLoose; },
/* harmony export */   "bK": function() { return /* binding */ createSvgIcon; },
/* harmony export */   "bL": function() { return /* binding */ interopRequireDefault; },
/* harmony export */   "bM": function() { return /* binding */ MuiDialog; },
/* harmony export */   "bN": function() { return /* binding */ Skeleton$1; },
/* harmony export */   "bO": function() { return /* binding */ shallowEqual; },
/* harmony export */   "bP": function() { return /* binding */ Avatar$1$1; },
/* harmony export */   "bQ": function() { return /* binding */ IconButton$1; },
/* harmony export */   "bR": function() { return /* binding */ useAuthTeamState; },
/* harmony export */   "bS": function() { return /* binding */ Select$1; },
/* harmony export */   "bT": function() { return /* binding */ CheckIcon$1; },
/* harmony export */   "bU": function() { return /* binding */ LinkIcon; },
/* harmony export */   "bV": function() { return /* binding */ useRolesState; },
/* harmony export */   "bW": function() { return /* binding */ useRolesActions; },
/* harmony export */   "bX": function() { return /* binding */ validateNotEmpty; },
/* harmony export */   "bY": function() { return /* binding */ RadioList; },
/* harmony export */   "bZ": function() { return /* binding */ DeleteIcon; },
/* harmony export */   "b_": function() { return /* binding */ DoubleArrowRightIcon; },
/* harmony export */   "ba": function() { return /* binding */ InputBaseComponent; },
/* harmony export */   "bb": function() { return /* binding */ inputOverridesResolver; },
/* harmony export */   "bc": function() { return /* binding */ deepmerge$2; },
/* harmony export */   "bd": function() { return /* binding */ InputBase$1; },
/* harmony export */   "be": function() { return /* binding */ isMuiElement; },
/* harmony export */   "bf": function() { return /* binding */ isAdornedStart; },
/* harmony export */   "bg": function() { return /* binding */ isFilled; },
/* harmony export */   "bh": function() { return /* binding */ FormControlContext$1; },
/* harmony export */   "bi": function() { return /* binding */ useFormControl; },
/* harmony export */   "bj": function() { return /* binding */ formControlState; },
/* harmony export */   "bk": function() { return /* binding */ slotShouldForwardProp; },
/* harmony export */   "bl": function() { return /* binding */ useControlled; },
/* harmony export */   "bm": function() { return /* binding */ ownerDocument; },
/* harmony export */   "bn": function() { return /* binding */ formatMuiErrorMessage; },
/* harmony export */   "bo": function() { return /* binding */ MuiMenu; },
/* harmony export */   "bp": function() { return /* binding */ MuiOutlinedInput; },
/* harmony export */   "bq": function() { return /* binding */ BaseSchema; },
/* harmony export */   "br": function() { return /* binding */ ValidationError; },
/* harmony export */   "bs": function() { return /* binding */ runTests; },
/* harmony export */   "bt": function() { return /* binding */ isSchema; },
/* harmony export */   "bu": function() { return /* binding */ printValue; },
/* harmony export */   "bv": function() { return /* binding */ array; },
/* harmony export */   "bw": function() { return /* binding */ isAbsent; },
/* harmony export */   "bx": function() { return /* binding */ PropTypes; },
/* harmony export */   "by": function() { return /* binding */ UI; },
/* harmony export */   "bz": function() { return /* binding */ VisaCardIcon; },
/* harmony export */   "c": function() { return /* binding */ createTheme$1; },
/* harmony export */   "c$": function() { return /* binding */ Menu$1; },
/* harmony export */   "c0": function() { return /* binding */ AddIcon; },
/* harmony export */   "c1": function() { return /* binding */ InfoIcon; },
/* harmony export */   "c2": function() { return /* binding */ TableUserAvatarCell; },
/* harmony export */   "c3": function() { return /* binding */ useApiTokensState; },
/* harmony export */   "c4": function() { return /* binding */ useApiTokensActions; },
/* harmony export */   "c5": function() { return /* binding */ Chip; },
/* harmony export */   "c6": function() { return /* binding */ CheckedIcon; },
/* harmony export */   "c7": function() { return /* binding */ Table; },
/* harmony export */   "c8": function() { return /* binding */ TableDateCell; },
/* harmony export */   "c9": function() { return /* binding */ Fade$1; },
/* harmony export */   "cA": function() { return /* binding */ useAuthTeamActions; },
/* harmony export */   "cB": function() { return /* binding */ useTenantsActions; },
/* harmony export */   "cC": function() { return /* binding */ Alert$1$1; },
/* harmony export */   "cD": function() { return /* binding */ useProfileState; },
/* harmony export */   "cE": function() { return /* binding */ reloadProfileIfNeeded; },
/* harmony export */   "cF": function() { return /* binding */ SearchIcon; },
/* harmony export */   "cG": function() { return /* binding */ TableAvatarCell; },
/* harmony export */   "cH": function() { return /* binding */ TableTextCell; },
/* harmony export */   "cI": function() { return /* binding */ TableChipsCell; },
/* harmony export */   "cJ": function() { return /* binding */ ResendIcon; },
/* harmony export */   "cK": function() { return /* binding */ GroupUsersIcon; },
/* harmony export */   "cL": function() { return /* binding */ SearchBigIcon; },
/* harmony export */   "cM": function() { return /* binding */ TablePlaceholder; },
/* harmony export */   "cN": function() { return /* binding */ TableSwitchCell; },
/* harmony export */   "cO": function() { return /* binding */ Switch$1; },
/* harmony export */   "cP": function() { return /* binding */ TableSwitchCellLeft; },
/* harmony export */   "cQ": function() { return /* binding */ TableCopyCell; },
/* harmony export */   "cR": function() { return /* binding */ TableSeverityCell; },
/* harmony export */   "cS": function() { return /* binding */ TableJsonCell; },
/* harmony export */   "cT": function() { return /* binding */ TableIpCell; },
/* harmony export */   "cU": function() { return /* binding */ isValid; },
/* harmony export */   "cV": function() { return /* binding */ format; },
/* harmony export */   "cW": function() { return /* binding */ TableExpandableRow; },
/* harmony export */   "cX": function() { return /* binding */ CrossBtnIcon; },
/* harmony export */   "cY": function() { return /* binding */ useProfileActions; },
/* harmony export */   "cZ": function() { return /* binding */ UploadIcon; },
/* harmony export */   "c_": function() { return /* binding */ PencilIcon; },
/* harmony export */   "ca": function() { return /* binding */ WarningIcon; },
/* harmony export */   "cb": function() { return /* binding */ StatusChip; },
/* harmony export */   "cc": function() { return /* binding */ validateWellKnown; },
/* harmony export */   "cd": function() { return /* binding */ useTenantsState; },
/* harmony export */   "ce": function() { return /* binding */ ProfileIcon; },
/* harmony export */   "cf": function() { return /* binding */ PrivacyIcon; },
/* harmony export */   "cg": function() { return /* binding */ PersonalTokensIcon; },
/* harmony export */   "ch": function() { return /* binding */ UsageIcon; },
/* harmony export */   "ci": function() { return /* binding */ AccountDetailsIcon; },
/* harmony export */   "cj": function() { return /* binding */ UsersIcon; },
/* harmony export */   "ck": function() { return /* binding */ RolesIcon; },
/* harmony export */   "cl": function() { return /* binding */ SecurityIcon; },
/* harmony export */   "cm": function() { return /* binding */ SSOIcon; },
/* harmony export */   "cn": function() { return /* binding */ AuditLogsIcon; },
/* harmony export */   "co": function() { return /* binding */ WebhooksIcon; },
/* harmony export */   "cp": function() { return /* binding */ APITokenIcon; },
/* harmony export */   "cq": function() { return /* binding */ SubscriptionIcon; },
/* harmony export */   "cr": function() { return /* binding */ Navigation; },
/* harmony export */   "cs": function() { return /* binding */ PageHeaderProvider; },
/* harmony export */   "ct": function() { return /* binding */ PageHeader; },
/* harmony export */   "cu": function() { return /* binding */ Avatar$1; },
/* harmony export */   "cv": function() { return /* binding */ PageHeaderUpdater; },
/* harmony export */   "cw": function() { return /* binding */ HelpMessage; },
/* harmony export */   "cx": function() { return /* binding */ Switch$3; },
/* harmony export */   "cy": function() { return /* binding */ SettingsList; },
/* harmony export */   "cz": function() { return /* binding */ getOptions; },
/* harmony export */   "d": function() { return /* binding */ clone$1; },
/* harmony export */   "d0": function() { return /* binding */ UploadPhoto; },
/* harmony export */   "d1": function() { return /* binding */ validationPhoneOptional; },
/* harmony export */   "d2": function() { return /* binding */ validationPostCodeOptional; },
/* harmony export */   "d3": function() { return /* binding */ validatePositiveNumber; },
/* harmony export */   "d4": function() { return /* binding */ validateHistorySize; },
/* harmony export */   "d5": function() { return /* binding */ create; },
/* harmony export */   "d6": function() { return /* binding */ create$4; },
/* harmony export */   "d7": function() { return /* binding */ validateFile; },
/* harmony export */   "d8": function() { return /* binding */ validateUrl; },
/* harmony export */   "d9": function() { return /* binding */ validateDomain; },
/* harmony export */   "da": function() { return /* binding */ create$2; },
/* harmony export */   "db": function() { return /* binding */ Popup$1; },
/* harmony export */   "dc": function() { return /* binding */ validateMinLengthOptional; },
/* harmony export */   "dd": function() { return /* binding */ Chip$1$1; },
/* harmony export */   "de": function() { return /* binding */ Tree; },
/* harmony export */   "df": function() { return /* binding */ copy; },
/* harmony export */   "dg": function() { return /* binding */ RadioGroup$1; },
/* harmony export */   "dh": function() { return /* binding */ Radio$1; },
/* harmony export */   "di": function() { return /* binding */ DropZoneElement; },
/* harmony export */   "dj": function() { return /* binding */ SelectTree$1; },
/* harmony export */   "dk": function() { return /* binding */ PdfIcon; },
/* harmony export */   "e": function() { return /* binding */ extendSxProp; },
/* harmony export */   "f": function() { return /* binding */ styled$1; },
/* harmony export */   "g": function() { return /* binding */ getAugmentedNamespace; },
/* harmony export */   "h": function() { return /* binding */ has$1; },
/* harmony export */   "i": function() { return /* binding */ isobject; },
/* harmony export */   "j": function() { return /* binding */ createStyled; },
/* harmony export */   "k": function() { return /* binding */ CheckCircleFilledIcon; },
/* harmony export */   "l": function() { return /* binding */ Button$1; },
/* harmony export */   "m": function() { return /* binding */ mapValues$1; },
/* harmony export */   "n": function() { return /* binding */ deepmerge$4; },
/* harmony export */   "o": function() { return /* binding */ Checkbox$1; },
/* harmony export */   "p": function() { return /* binding */ propTypes; },
/* harmony export */   "q": function() { return /* binding */ enhanceTheme; },
/* harmony export */   "r": function() { return /* binding */ require$$4; },
/* harmony export */   "s": function() { return /* binding */ styleFunctionSx; },
/* harmony export */   "t": function() { return /* binding */ themes$1; },
/* harmony export */   "u": function() { return /* binding */ useFormikContext; },
/* harmony export */   "v": function() { return /* binding */ useShadowDom; },
/* harmony export */   "w": function() { return /* binding */ initGlobalTheme; },
/* harmony export */   "x": function() { return /* binding */ I18nProvider$1; },
/* harmony export */   "y": function() { return /* binding */ GlobalThemeProvider; },
/* harmony export */   "z": function() { return /* binding */ ThemeContext; }
/* harmony export */ });
/* harmony import */ var _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11277);
/* harmony import */ var _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5850);
/* harmony import */ var _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32205);
/* harmony import */ var _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_frontegg_rest_api__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _frontegg_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36539);
/* module decorator */ module = __webpack_require__.hmd(module);





var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {};

function getDefaultExportFromCjs (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function getAugmentedNamespace(n) {
	if (n.__esModule) return n;
	var a = Object.defineProperty({}, '__esModule', {value: true});
	Object.keys(n).forEach(function (k) {
		var d = Object.getOwnPropertyDescriptor(n, k);
		Object.defineProperty(a, k, d.get ? d : {
			enumerable: true,
			get: function () {
				return n[k];
			}
		});
	});
	return a;
}

var propTypes = {exports: {}};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$1 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$1;

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret = ReactPropTypesSecret_1;

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

{
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = factoryWithThrowingShims();
}

var PropTypes = propTypes.exports;

var ReactReduxContext = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createContext(null);

// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};

// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var Subscription = /*#__PURE__*/function () {
  function Subscription(store, parentSub) {
    this.store = store;
    this.parentSub = parentSub;
    this.unsubscribe = null;
    this.listeners = nullListeners;
    this.handleChangeWrapper = this.handleChangeWrapper.bind(this);
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.handleChangeWrapper = function handleChangeWrapper() {
    if (this.onStateChange) {
      this.onStateChange();
    }
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.handleChangeWrapper) : this.store.subscribe(this.handleChangeWrapper);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();

// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect$1 = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useLayoutEffect : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect;

function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(function () {
    var subscription = new Subscription(store);
    subscription.onStateChange = subscription.notifyNestedSubs;
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(function () {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect$1(function () {
    var subscription = contextValue.subscription;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || ReactReduxContext;
  return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

function _extends$c() {
  _extends$c = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$c.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$7(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual$1(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext() {
  var contextValue = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(ReactReduxContext);

  return contextValue;
}

/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext$1 = context === ReactReduxContext ? useReduxContext : function () {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext$1(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore = /*#__PURE__*/createStoreHook();

/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useStore$1 = context === ReactReduxContext ? useStore : createStoreHook(context);
  return function useDispatch() {
    var store = useStore$1();
    return store.dispatch;
  };
}

var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useReducer(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(function () {
    return new Subscription(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();
  var latestSelector = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();
  var latestStoreState = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();
  var latestSelectedState = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();
  var storeState = store.getState();
  var selectedState;

  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references

      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
        selectedState = newSelectedState;
      } else {
        selectedState = latestSelectedState.current;
      }
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  useIsomorphicLayoutEffect$1(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect$1(function () {
    function checkForUpdates() {
      try {
        var newStoreState = store.getState();

        var _newSelectedState = latestSelector.current(newStoreState);

        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = _newSelectedState;
        latestStoreState.current = newStoreState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext$1 = context === ReactReduxContext ? useReduxContext : function () {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    var _useReduxContext = useReduxContext$1(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useDebugValue(selectedState);
    return selectedState;
  };
}

setBatch(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.h.exports.unstable_batchedUpdates);

const FronteggStoreContext = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createContext(null);
const useSelector = createSelectorHook(FronteggStoreContext);
const useDispatch = createDispatchHook(FronteggStoreContext);
createStoreHook(FronteggStoreContext);

const ShadowDomContext = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createContext({});
const useShadowDom = () => {
    const context = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(ShadowDomContext);
    const { urlStrategy = 'path', onRedirectTo = urlStrategy === 'path'
        ? (path) => window.history.pushState(null, '', path)
        : (path) => window.history.pushState(null, '', `#${path}`), renderByRoute = false, customLoader = false, customStyles, contextOptions } = context, rest = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(context, ["urlStrategy", "onRedirectTo", "renderByRoute", "customLoader", "customStyles", "contextOptions"]);
    return Object.assign({ isShadowDom: true, onRedirectTo,
        renderByRoute,
        customLoader,
        customStyles,
        urlStrategy, contextOptions: Object.assign({ requestCredentials: 'include' }, contextOptions) }, rest);
};

const defaultMapper = {
    state: (state) => state,
    actions: (actions) => actions,
};
const useAuth = (stateMapper = defaultMapper.state) => {
    return useSelector((state) => stateMapper(state[_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .authStoreName */ .Y2]), shallowEqual$1);
};
const useAuthActions = () => {
    const dispatch = useDispatch();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .bindActionCreators */ .DE)(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .authActions */ .YV, dispatch), [_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .authActions */ .YV]);
};
const useOnRedirectTo = () => {
    var _a;
    const context = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(ShadowDomContext);
    return (_a = context === null || context === void 0 ? void 0 : context.onRedirectTo) !== null && _a !== void 0 ? _a : _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_2__.ContextHolder.onRedirectTo;
};
const useAuthRoutes = () => useAuth((state) => (Object.assign({}, state.routes)));
/**
 * ```jsx
 * export const MyFunctionComponent = () => {
 *   const isAuthenticated  = useIsAuthenticated();
 *   return isAuthenticated ? <div>Hello User</div> : <Redirect to={'/login'}/>
 * }
 * ```
 *
 * use this frontegg hook function to get if user is "Authenticated"
 */
const useIsAuthenticated = () => useSelector(({ [_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .authStoreName */ .Y2]: { isAuthenticated } }) => isAuthenticated, shallowEqual$1);
/**
 * ```jsx
 * export const MyFunctionComponent = () => {
 *   const user = useAuthUser();
 *   return user ? <div>Hello {user.name}!</div> : <div>Hello Guest!</div>
 * }
 * ```
 *
 * use this frontegg hook function to get the authenticated user
 * the return user is null if not authenticated
 */
const useAuthUser = () => {
    const routes = useAuthRoutes();
    const onRedirectTo = useOnRedirectTo();
    const user = useAuthUserOrNull();
    if (user == null) {
        onRedirectTo(routes.loginUrl, { refresh: true });
        return {};
    }
    return user;
};
const useAuthUserOrNull = () => {
    const { user } = useSelector(({ [_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .authStoreName */ .Y2]: { user } }) => ({ user }), shallowEqual$1);
    return user || null;
};
/**
 * hooks helpers
 */
const sliceReducerActionsBy = (reducer) => {
    const reducerKeys = Object.keys(reducer);
    const reducerActions = reducerKeys.map((key) => ({ [key]: _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .authActions */ .YV[key] }));
    return reducerActions.reduce((p, n) => (Object.assign(Object.assign({}, p), n)), {});
};
const stateHookGenerator = (stateMapper, subState) => {
    return useSelector((state) => { var _a; return (_a = stateMapper === null || stateMapper === void 0 ? void 0 : stateMapper(state[_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .authStoreName */ .Y2][subState])) !== null && _a !== void 0 ? _a : state[_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .authStoreName */ .Y2][subState]; }, shallowEqual$1);
};
const reducerActionsGenerator = (actions, reducers) => {
    const dispatch = useDispatch();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .bindActionCreators */ .DE)(Object.assign(Object.assign({}, actions), sliceReducerActionsBy(reducers)), dispatch), [dispatch]);
};

const useAcceptInvitationState = (stateMapper) => stateHookGenerator(stateMapper, 'acceptInvitationState');
const useAcceptInvitationActions = () => reducerActionsGenerator(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .acceptInvitationActions */ .kX, _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .acceptInvitationReducers */ .YQ);

const useActivateAccountState = (stateMapper) => stateHookGenerator(stateMapper, 'activateState');
const useActivateAccountActions = () => reducerActionsGenerator(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .activateAccountActions */ .pf, _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .activateAccountReducers */ .iJ);

const useApiTokensState = (stateMapper) => stateHookGenerator(stateMapper, 'apiTokensState');
const useApiTokensActions = () => reducerActionsGenerator(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .apiTokensActions */ .UY, _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .apiTokensReducers */ .Ol);

const useForgotPasswordState = (stateMapper) => stateHookGenerator(stateMapper, 'forgotPasswordState');
const useForgotPasswordActions = () => reducerActionsGenerator(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .forgotPasswordActions */ .ZK, _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .forgotPasswordReducers */ .Mc);

const useResetPhoneNumberState = (stateMapper) => stateHookGenerator(stateMapper, 'resetPhoneNumberState');
const useResetPhoneNumberActions = () => reducerActionsGenerator(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .resetPhoneNumberActions */ .ng, _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .resetPhoneNumberReducers */ .TK);

const useLoginState = (stateMapper) => stateHookGenerator(stateMapper, 'loginState');
const useLoginActions = () => reducerActionsGenerator(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .loginActions */ .BK, _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .loginReducers */ .fv);

const useMfaState = (stateMapper) => stateHookGenerator(stateMapper, 'mfaState');
const useMfaActions = () => reducerActionsGenerator(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .mfaActions */ .rg, _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .mfaReducers */ .a4);

const reloadProfileIfNeeded = () => {
    const { loading } = useProfileState();
    const { loadProfile } = useProfileActions();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        !loading && loadProfile();
    }, []);
};
const useProfileState = (stateMapper) => stateHookGenerator(stateMapper, 'profileState');
const useProfileActions = () => reducerActionsGenerator(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .profileActions */ .ef, _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .profileReducers */ .i1);

const useSignUpState = (stateMapper) => stateHookGenerator(stateMapper, 'signUpState');
const useSignUpActions = () => reducerActionsGenerator(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .signUpActions */ .j0, _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .signUpReducers */ ._A);

const useSocialLoginState = (stateMapper) => stateHookGenerator(stateMapper, 'socialLoginState');
const useSocialLoginActions = () => reducerActionsGenerator(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .socialLoginsActions */ .ak, _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .socialLoginsReducer */ .BP);

const useAuthTeamState = (stateMapper) => stateHookGenerator(stateMapper, 'teamState');
const useAuthTeamActions = () => reducerActionsGenerator(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .teamActions */ .L2, _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .teamReducers */ .vy);

const useSSOState = (stateMapper) => stateHookGenerator(stateMapper, 'ssoState');
const useSSOActions = () => reducerActionsGenerator(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .ssoActions */ .E1, _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .ssoReducers */ .rw);

const useSecurityPolicyState = (stateMapper) => stateHookGenerator(stateMapper, 'securityPolicyState');
const useSecurityPolicyActions = () => reducerActionsGenerator(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .securityPolicyActions */ .yr, _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .securityPolicyReducers */ ._);
const usePublicPolicySettings = (loadOnMount = false) => {
    const { loading, policy, saving, error } = useSecurityPolicyState(state => state.publicPolicy);
    const { loadPublicSecurityPolicy } = useSecurityPolicyActions();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        (loadOnMount || !policy) && loadPublicSecurityPolicy();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadOnMount, loadPublicSecurityPolicy]);
    return { loading, saving, error, policy };
};
const usePublicAuthStrategiesPolicySettings = (loadOnMount = false) => {
    const { loading, policy, saving, error } = useSecurityPolicyState(state => state.publicAuthStrategyPolicy);
    const { loadPublicAuthStrategiesPolicy } = useSecurityPolicyActions();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        (loadOnMount || !policy) && loadPublicAuthStrategiesPolicy();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadOnMount, loadPublicAuthStrategiesPolicy]);
    return { loading, saving, error, policy };
};

const useTenantsState = (stateMapper) => stateHookGenerator(stateMapper, 'tenantsState');
const useTenantsActions = () => reducerActionsGenerator(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .tenantsActions */ .Q_, _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .tenantsReducers */ .Y);

const useRolesState = (stateMapper) => stateHookGenerator(stateMapper, 'rolesState');
const useRolesActions = () => reducerActionsGenerator(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .rolesActions */ .$3, _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .rolesReducers */ .Az);

const useVendorState = (stateMapper) => {
    return useSelector((state) => { var _a; return (_a = stateMapper === null || stateMapper === void 0 ? void 0 : stateMapper(state[_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .vendorStoreName */ .wv])) !== null && _a !== void 0 ? _a : state[_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_1__/* .vendorStoreName */ .wv]; }, shallowEqual$1);
};

function _defineProperty$3(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var defineProperty$4 = _defineProperty$3;

var _defineProperty$4 = defineProperty$4;

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

var classCallCheck = _classCallCheck$1;

var _classCallCheck$2 = classCallCheck;

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

var createClass = _createClass$1;

var _createClass$2 = createClass;

function ownKeys$2(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$3(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$2(Object(source), true).forEach(function (key) { _defineProperty$4(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$2(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
var defaultOptions = {
  bindI18n: 'languageChanged',
  bindI18nStore: '',
  transEmptyNodeValue: '',
  transSupportBasicHtmlNodes: true,
  transKeepBasicHtmlNodesFor: ['br', 'strong', 'i', 'p'],
  useSuspense: true
};
var i18nInstance;
var I18nContext = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createContext();
function setDefaults() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  defaultOptions = _objectSpread$3(_objectSpread$3({}, defaultOptions), options);
}
function getDefaults() {
  return defaultOptions;
}
var ReportNamespaces = function () {
  function ReportNamespaces() {
    _classCallCheck$2(this, ReportNamespaces);

    this.usedNamespaces = {};
  }

  _createClass$2(ReportNamespaces, [{
    key: "addUsedNamespaces",
    value: function addUsedNamespaces(namespaces) {
      var _this = this;

      namespaces.forEach(function (ns) {
        if (!_this.usedNamespaces[ns]) _this.usedNamespaces[ns] = true;
      });
    }
  }, {
    key: "getUsedNamespaces",
    value: function getUsedNamespaces() {
      return Object.keys(this.usedNamespaces);
    }
  }]);

  return ReportNamespaces;
}();
function setI18n(instance) {
  i18nInstance = instance;
}
function getI18n() {
  return i18nInstance;
}
var initReactI18next = {
  type: '3rdParty',
  init: function init(instance) {
    setDefaults(instance.options.react);
    setI18n(instance);
  }
};

function warn() {
  if (console && console.warn) {
    var _console;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (typeof args[0] === 'string') args[0] = "react-i18next:: ".concat(args[0]);

    (_console = console).warn.apply(_console, args);
  }
}
var alreadyWarned = {};
function warnOnce() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (typeof args[0] === 'string' && alreadyWarned[args[0]]) return;
  if (typeof args[0] === 'string') alreadyWarned[args[0]] = new Date();
  warn.apply(void 0, args);
}
function loadNamespaces(i18n, ns, cb) {
  i18n.loadNamespaces(ns, function () {
    if (i18n.isInitialized) {
      cb();
    } else {
      var initialized = function initialized() {
        setTimeout(function () {
          i18n.off('initialized', initialized);
        }, 0);
        cb();
      };

      i18n.on('initialized', initialized);
    }
  });
}
function hasLoadedNamespace(ns, i18n) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!i18n.languages || !i18n.languages.length) {
    warnOnce('i18n.languages were undefined or empty', i18n.languages);
    return true;
  }

  var lng = i18n.languages[0];
  var fallbackLng = i18n.options ? i18n.options.fallbackLng : false;
  var lastLng = i18n.languages[i18n.languages.length - 1];
  if (lng.toLowerCase() === 'cimode') return true;

  var loadNotPending = function loadNotPending(l, n) {
    var loadState = i18n.services.backendConnector.state["".concat(l, "|").concat(n)];
    return loadState === -1 || loadState === 2;
  };

  if (options.bindI18n && options.bindI18n.indexOf('languageChanging') > -1 && i18n.services.backendConnector.backend && i18n.isLanguageChangingTo && !loadNotPending(i18n.isLanguageChangingTo, ns)) return false;
  if (i18n.hasResourceBundle(lng, ns)) return true;
  if (!i18n.services.backendConnector.backend) return true;
  if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
  return false;
}

function _arrayWithHoles$2(arr) {
  if (Array.isArray(arr)) return arr;
}

var arrayWithHoles$1 = _arrayWithHoles$2;

function _iterableToArrayLimit$2(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

var iterableToArrayLimit$1 = _iterableToArrayLimit$2;

function _arrayLikeToArray$2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

var arrayLikeToArray$1 = _arrayLikeToArray$2;

var arrayLikeToArray = arrayLikeToArray$1;

function _unsupportedIterableToArray$2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}

var unsupportedIterableToArray$1 = _unsupportedIterableToArray$2;

function _nonIterableRest$2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var nonIterableRest$1 = _nonIterableRest$2;

var arrayWithHoles = arrayWithHoles$1;

var iterableToArrayLimit = iterableToArrayLimit$1;

var unsupportedIterableToArray = unsupportedIterableToArray$1;

var nonIterableRest = nonIterableRest$1;

function _slicedToArray$2(arr, i) {
  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || unsupportedIterableToArray(arr, i) || nonIterableRest();
}

var slicedToArray = _slicedToArray$2;

var _slicedToArray$3 = slicedToArray;

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$2(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys$1(Object(source), true).forEach(function (key) { _defineProperty$4(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }
function useTranslation(ns) {
  var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var i18nFromProps = props.i18n;

  var _ref = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(I18nContext) || {},
      i18nFromContext = _ref.i18n,
      defaultNSFromContext = _ref.defaultNS;

  var i18n = i18nFromProps || i18nFromContext || getI18n();
  if (i18n && !i18n.reportNamespaces) i18n.reportNamespaces = new ReportNamespaces();

  if (!i18n) {
    warnOnce('You will need to pass in an i18next instance by using initReactI18next');

    var notReadyT = function notReadyT(k) {
      return Array.isArray(k) ? k[k.length - 1] : k;
    };

    var retNotReady = [notReadyT, {}, false];
    retNotReady.t = notReadyT;
    retNotReady.i18n = {};
    retNotReady.ready = false;
    return retNotReady;
  }

  var i18nOptions = _objectSpread$2(_objectSpread$2(_objectSpread$2({}, getDefaults()), i18n.options.react), props);

  var useSuspense = i18nOptions.useSuspense;
  var namespaces = ns || defaultNSFromContext || i18n.options && i18n.options.defaultNS;
  namespaces = typeof namespaces === 'string' ? [namespaces] : namespaces || ['translation'];
  if (i18n.reportNamespaces.addUsedNamespaces) i18n.reportNamespaces.addUsedNamespaces(namespaces);
  var ready = (i18n.isInitialized || i18n.initializedStoreOnce) && namespaces.every(function (n) {
    return hasLoadedNamespace(n, i18n, i18nOptions);
  });

  function getT() {
    return {
      t: i18n.getFixedT(null, i18nOptions.nsMode === 'fallback' ? namespaces : namespaces[0])
    };
  }

  var _useState = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(getT()),
      _useState2 = _slicedToArray$3(_useState, 2),
      t = _useState2[0],
      setT = _useState2[1];

  var isMounted = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(true);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(function () {
    var bindI18n = i18nOptions.bindI18n,
        bindI18nStore = i18nOptions.bindI18nStore;
    isMounted.current = true;

    if (!ready && !useSuspense) {
      loadNamespaces(i18n, namespaces, function () {
        if (isMounted.current) setT(getT());
      });
    }

    function boundReset() {
      if (isMounted.current) setT(getT());
    }

    if (bindI18n && i18n) i18n.on(bindI18n, boundReset);
    if (bindI18nStore && i18n) i18n.store.on(bindI18nStore, boundReset);
    return function () {
      isMounted.current = false;
      if (bindI18n && i18n) bindI18n.split(' ').forEach(function (e) {
        return i18n.off(e, boundReset);
      });
      if (bindI18nStore && i18n) bindI18nStore.split(' ').forEach(function (e) {
        return i18n.store.off(e, boundReset);
      });
    };
  }, [namespaces.join()]);
  var ret = [t.t, i18n, ready];
  ret.t = t.t;
  ret.i18n = i18n;
  ret.ready = ready;
  if (ready) return ret;
  if (!ready && !useSuspense) return ret;
  throw new Promise(function (resolve) {
    loadNamespaces(i18n, namespaces, function () {
      resolve();
    });
  });
}

function I18nextProvider(_ref) {
  var i18n = _ref.i18n,
      defaultNS = _ref.defaultNS,
      children = _ref.children;
  var value = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(function () {
    return {
      i18n: i18n,
      defaultNS: defaultNS
    };
  }, [i18n, defaultNS]);
  return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createElement(I18nContext.Provider, {
    value: value
  }, children);
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty$2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectSpread$1(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);

    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }

    ownKeys.forEach(function (key) {
      _defineProperty$2(target, key, source[key]);
    });
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$1(self);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

var consoleLogger = {
  type: 'logger',
  log: function log(args) {
    this.output('log', args);
  },
  warn: function warn(args) {
    this.output('warn', args);
  },
  error: function error(args) {
    this.output('error', args);
  },
  output: function output(type, args) {
    if (console && console[type]) console[type].apply(console, args);
  }
};

var Logger = function () {
  function Logger(concreteLogger) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Logger);

    this.init(concreteLogger, options);
  }

  _createClass(Logger, [{
    key: "init",
    value: function init(concreteLogger) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.prefix = options.prefix || 'i18next:';
      this.logger = concreteLogger || consoleLogger;
      this.options = options;
      this.debug = options.debug;
    }
  }, {
    key: "setDebug",
    value: function setDebug(bool) {
      this.debug = bool;
    }
  }, {
    key: "log",
    value: function log() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return this.forward(args, 'log', '', true);
    }
  }, {
    key: "warn",
    value: function warn() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return this.forward(args, 'warn', '', true);
    }
  }, {
    key: "error",
    value: function error() {
      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        args[_key3] = arguments[_key3];
      }

      return this.forward(args, 'error', '');
    }
  }, {
    key: "deprecate",
    value: function deprecate() {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      return this.forward(args, 'warn', 'WARNING DEPRECATED: ', true);
    }
  }, {
    key: "forward",
    value: function forward(args, lvl, prefix, debugOnly) {
      if (debugOnly && !this.debug) return null;
      if (typeof args[0] === 'string') args[0] = "".concat(prefix).concat(this.prefix, " ").concat(args[0]);
      return this.logger[lvl](args);
    }
  }, {
    key: "create",
    value: function create(moduleName) {
      return new Logger(this.logger, _objectSpread$1({}, {
        prefix: "".concat(this.prefix, ":").concat(moduleName, ":")
      }, this.options));
    }
  }]);

  return Logger;
}();

var baseLogger = new Logger();

var EventEmitter = function () {
  function EventEmitter() {
    _classCallCheck(this, EventEmitter);

    this.observers = {};
  }

  _createClass(EventEmitter, [{
    key: "on",
    value: function on(events, listener) {
      var _this = this;

      events.split(' ').forEach(function (event) {
        _this.observers[event] = _this.observers[event] || [];

        _this.observers[event].push(listener);
      });
      return this;
    }
  }, {
    key: "off",
    value: function off(event, listener) {
      if (!this.observers[event]) return;

      if (!listener) {
        delete this.observers[event];
        return;
      }

      this.observers[event] = this.observers[event].filter(function (l) {
        return l !== listener;
      });
    }
  }, {
    key: "emit",
    value: function emit(event) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      if (this.observers[event]) {
        var cloned = [].concat(this.observers[event]);
        cloned.forEach(function (observer) {
          observer.apply(void 0, args);
        });
      }

      if (this.observers['*']) {
        var _cloned = [].concat(this.observers['*']);

        _cloned.forEach(function (observer) {
          observer.apply(observer, [event].concat(args));
        });
      }
    }
  }]);

  return EventEmitter;
}();

function defer() {
  var res;
  var rej;
  var promise = new Promise(function (resolve, reject) {
    res = resolve;
    rej = reject;
  });
  promise.resolve = res;
  promise.reject = rej;
  return promise;
}
function makeString(object) {
  if (object == null) return '';
  return '' + object;
}
function copy$2(a, s, t) {
  a.forEach(function (m) {
    if (s[m]) t[m] = s[m];
  });
}

function getLastOfPath(object, path, Empty) {
  function cleanKey(key) {
    return key && key.indexOf('###') > -1 ? key.replace(/###/g, '.') : key;
  }

  function canNotTraverseDeeper() {
    return !object || typeof object === 'string';
  }

  var stack = typeof path !== 'string' ? [].concat(path) : path.split('.');

  while (stack.length > 1) {
    if (canNotTraverseDeeper()) return {};
    var key = cleanKey(stack.shift());
    if (!object[key] && Empty) object[key] = new Empty();

    if (Object.prototype.hasOwnProperty.call(object, key)) {
      object = object[key];
    } else {
      object = {};
    }
  }

  if (canNotTraverseDeeper()) return {};
  return {
    obj: object,
    k: cleanKey(stack.shift())
  };
}

function setPath(object, path, newValue) {
  var _getLastOfPath = getLastOfPath(object, path, Object),
      obj = _getLastOfPath.obj,
      k = _getLastOfPath.k;

  obj[k] = newValue;
}
function pushPath(object, path, newValue, concat) {
  var _getLastOfPath2 = getLastOfPath(object, path, Object),
      obj = _getLastOfPath2.obj,
      k = _getLastOfPath2.k;

  obj[k] = obj[k] || [];
  if (concat) obj[k] = obj[k].concat(newValue);
  if (!concat) obj[k].push(newValue);
}
function getPath$1(object, path) {
  var _getLastOfPath3 = getLastOfPath(object, path),
      obj = _getLastOfPath3.obj,
      k = _getLastOfPath3.k;

  if (!obj) return undefined;
  return obj[k];
}
function getPathWithDefaults(data, defaultData, key) {
  var value = getPath$1(data, key);

  if (value !== undefined) {
    return value;
  }

  return getPath$1(defaultData, key);
}
function deepExtend(target, source, overwrite) {
  for (var prop in source) {
    if (prop !== '__proto__' && prop !== 'constructor') {
      if (prop in target) {
        if (typeof target[prop] === 'string' || target[prop] instanceof String || typeof source[prop] === 'string' || source[prop] instanceof String) {
          if (overwrite) target[prop] = source[prop];
        } else {
          deepExtend(target[prop], source[prop], overwrite);
        }
      } else {
        target[prop] = source[prop];
      }
    }
  }

  return target;
}
function regexEscape(str) {
  return str.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&');
}
var _entityMap = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;',
  '/': '&#x2F;'
};
function escape(data) {
  if (typeof data === 'string') {
    return data.replace(/[&<>"'\/]/g, function (s) {
      return _entityMap[s];
    });
  }

  return data;
}
var isIE10 = typeof window !== 'undefined' && window.navigator && window.navigator.userAgent && window.navigator.userAgent.indexOf('MSIE') > -1;

var ResourceStore = function (_EventEmitter) {
  _inherits(ResourceStore, _EventEmitter);

  function ResourceStore(data) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      ns: ['translation'],
      defaultNS: 'translation'
    };

    _classCallCheck(this, ResourceStore);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResourceStore).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }

    _this.data = data || {};
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    return _this;
  }

  _createClass(ResourceStore, [{
    key: "addNamespaces",
    value: function addNamespaces(ns) {
      if (this.options.ns.indexOf(ns) < 0) {
        this.options.ns.push(ns);
      }
    }
  }, {
    key: "removeNamespaces",
    value: function removeNamespaces(ns) {
      var index = this.options.ns.indexOf(ns);

      if (index > -1) {
        this.options.ns.splice(index, 1);
      }
    }
  }, {
    key: "getResource",
    value: function getResource(lng, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var path = [lng, ns];
      if (key && typeof key !== 'string') path = path.concat(key);
      if (key && typeof key === 'string') path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
      }

      return getPath$1(this.data, path);
    }
  }, {
    key: "addResource",
    value: function addResource(lng, ns, key, value) {
      var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
        silent: false
      };
      var keySeparator = this.options.keySeparator;
      if (keySeparator === undefined) keySeparator = '.';
      var path = [lng, ns];
      if (key) path = path.concat(keySeparator ? key.split(keySeparator) : key);

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        value = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      setPath(this.data, path, value);
      if (!options.silent) this.emit('added', lng, ns, key, value);
    }
  }, {
    key: "addResources",
    value: function addResources(lng, ns, resources) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {
        silent: false
      };

      for (var m in resources) {
        if (typeof resources[m] === 'string' || Object.prototype.toString.apply(resources[m]) === '[object Array]') this.addResource(lng, ns, m, resources[m], {
          silent: true
        });
      }

      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "addResourceBundle",
    value: function addResourceBundle(lng, ns, resources, deep, overwrite) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {
        silent: false
      };
      var path = [lng, ns];

      if (lng.indexOf('.') > -1) {
        path = lng.split('.');
        deep = resources;
        resources = ns;
        ns = path[1];
      }

      this.addNamespaces(ns);
      var pack = getPath$1(this.data, path) || {};

      if (deep) {
        deepExtend(pack, resources, overwrite);
      } else {
        pack = _objectSpread$1({}, pack, resources);
      }

      setPath(this.data, path, pack);
      if (!options.silent) this.emit('added', lng, ns, resources);
    }
  }, {
    key: "removeResourceBundle",
    value: function removeResourceBundle(lng, ns) {
      if (this.hasResourceBundle(lng, ns)) {
        delete this.data[lng][ns];
      }

      this.removeNamespaces(ns);
      this.emit('removed', lng, ns);
    }
  }, {
    key: "hasResourceBundle",
    value: function hasResourceBundle(lng, ns) {
      return this.getResource(lng, ns) !== undefined;
    }
  }, {
    key: "getResourceBundle",
    value: function getResourceBundle(lng, ns) {
      if (!ns) ns = this.options.defaultNS;
      if (this.options.compatibilityAPI === 'v1') return _objectSpread$1({}, {}, this.getResource(lng, ns));
      return this.getResource(lng, ns);
    }
  }, {
    key: "getDataByLanguage",
    value: function getDataByLanguage(lng) {
      return this.data[lng];
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return this.data;
    }
  }]);

  return ResourceStore;
}(EventEmitter);

var postProcessor = {
  processors: {},
  addPostProcessor: function addPostProcessor(module) {
    this.processors[module.name] = module;
  },
  handle: function handle(processors, value, key, options, translator) {
    var _this = this;

    processors.forEach(function (processor) {
      if (_this.processors[processor]) value = _this.processors[processor].process(value, key, options, translator);
    });
    return value;
  }
};

var checkedLoadedFor = {};

var Translator = function (_EventEmitter) {
  _inherits(Translator, _EventEmitter);

  function Translator(services) {
    var _this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Translator);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Translator).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }

    copy$2(['resourceStore', 'languageUtils', 'pluralResolver', 'interpolator', 'backendConnector', 'i18nFormat', 'utils'], services, _assertThisInitialized$1(_this));
    _this.options = options;

    if (_this.options.keySeparator === undefined) {
      _this.options.keySeparator = '.';
    }

    _this.logger = baseLogger.create('translator');
    return _this;
  }

  _createClass(Translator, [{
    key: "changeLanguage",
    value: function changeLanguage(lng) {
      if (lng) this.language = lng;
    }
  }, {
    key: "exists",
    value: function exists(key) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        interpolation: {}
      };
      var resolved = this.resolve(key, options);
      return resolved && resolved.res !== undefined;
    }
  }, {
    key: "extractFromKey",
    value: function extractFromKey(key, options) {
      var nsSeparator = options.nsSeparator !== undefined ? options.nsSeparator : this.options.nsSeparator;
      if (nsSeparator === undefined) nsSeparator = ':';
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;
      var namespaces = options.ns || this.options.defaultNS;

      if (nsSeparator && key.indexOf(nsSeparator) > -1) {
        var m = key.match(this.interpolator.nestingRegexp);

        if (m && m.length > 0) {
          return {
            key: key,
            namespaces: namespaces
          };
        }

        var parts = key.split(nsSeparator);
        if (nsSeparator !== keySeparator || nsSeparator === keySeparator && this.options.ns.indexOf(parts[0]) > -1) namespaces = parts.shift();
        key = parts.join(keySeparator);
      }

      if (typeof namespaces === 'string') namespaces = [namespaces];
      return {
        key: key,
        namespaces: namespaces
      };
    }
  }, {
    key: "translate",
    value: function translate(keys, options, lastKey) {
      var _this2 = this;

      if (_typeof(options) !== 'object' && this.options.overloadTranslationOptionHandler) {
        options = this.options.overloadTranslationOptionHandler(arguments);
      }

      if (!options) options = {};
      if (keys === undefined || keys === null) return '';
      if (!Array.isArray(keys)) keys = [String(keys)];
      var keySeparator = options.keySeparator !== undefined ? options.keySeparator : this.options.keySeparator;

      var _this$extractFromKey = this.extractFromKey(keys[keys.length - 1], options),
          key = _this$extractFromKey.key,
          namespaces = _this$extractFromKey.namespaces;

      var namespace = namespaces[namespaces.length - 1];
      var lng = options.lng || this.language;
      var appendNamespaceToCIMode = options.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;

      if (lng && lng.toLowerCase() === 'cimode') {
        if (appendNamespaceToCIMode) {
          var nsSeparator = options.nsSeparator || this.options.nsSeparator;
          return namespace + nsSeparator + key;
        }

        return key;
      }

      var resolved = this.resolve(keys, options);
      var res = resolved && resolved.res;
      var resUsedKey = resolved && resolved.usedKey || key;
      var resExactUsedKey = resolved && resolved.exactUsedKey || key;
      var resType = Object.prototype.toString.apply(res);
      var noObject = ['[object Number]', '[object Function]', '[object RegExp]'];
      var joinArrays = options.joinArrays !== undefined ? options.joinArrays : this.options.joinArrays;
      var handleAsObjectInI18nFormat = !this.i18nFormat || this.i18nFormat.handleAsObject;
      var handleAsObject = typeof res !== 'string' && typeof res !== 'boolean' && typeof res !== 'number';

      if (handleAsObjectInI18nFormat && res && handleAsObject && noObject.indexOf(resType) < 0 && !(typeof joinArrays === 'string' && resType === '[object Array]')) {
        if (!options.returnObjects && !this.options.returnObjects) {
          this.logger.warn('accessing an object - but returnObjects options is not enabled!');
          return this.options.returnedObjectHandler ? this.options.returnedObjectHandler(resUsedKey, res, options) : "key '".concat(key, " (").concat(this.language, ")' returned an object instead of string.");
        }

        if (keySeparator) {
          var resTypeIsArray = resType === '[object Array]';
          var copy = resTypeIsArray ? [] : {};
          var newKeyToUse = resTypeIsArray ? resExactUsedKey : resUsedKey;

          for (var m in res) {
            if (Object.prototype.hasOwnProperty.call(res, m)) {
              var deepKey = "".concat(newKeyToUse).concat(keySeparator).concat(m);
              copy[m] = this.translate(deepKey, _objectSpread$1({}, options, {
                joinArrays: false,
                ns: namespaces
              }));
              if (copy[m] === deepKey) copy[m] = res[m];
            }
          }

          res = copy;
        }
      } else if (handleAsObjectInI18nFormat && typeof joinArrays === 'string' && resType === '[object Array]') {
        res = res.join(joinArrays);
        if (res) res = this.extendTranslation(res, keys, options, lastKey);
      } else {
        var usedDefault = false;
        var usedKey = false;

        if (!this.isValidLookup(res) && options.defaultValue !== undefined) {
          usedDefault = true;

          if (options.count !== undefined) {
            var suffix = this.pluralResolver.getSuffix(lng, options.count);
            res = options["defaultValue".concat(suffix)];
          }

          if (!res) res = options.defaultValue;
        }

        if (!this.isValidLookup(res)) {
          usedKey = true;
          res = key;
        }

        var updateMissing = options.defaultValue && options.defaultValue !== res && this.options.updateMissing;

        if (usedKey || usedDefault || updateMissing) {
          this.logger.log(updateMissing ? 'updateKey' : 'missingKey', lng, namespace, key, updateMissing ? options.defaultValue : res);

          if (keySeparator) {
            var fk = this.resolve(key, _objectSpread$1({}, options, {
              keySeparator: false
            }));
            if (fk && fk.res) this.logger.warn('Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.');
          }

          var lngs = [];
          var fallbackLngs = this.languageUtils.getFallbackCodes(this.options.fallbackLng, options.lng || this.language);

          if (this.options.saveMissingTo === 'fallback' && fallbackLngs && fallbackLngs[0]) {
            for (var i = 0; i < fallbackLngs.length; i++) {
              lngs.push(fallbackLngs[i]);
            }
          } else if (this.options.saveMissingTo === 'all') {
            lngs = this.languageUtils.toResolveHierarchy(options.lng || this.language);
          } else {
            lngs.push(options.lng || this.language);
          }

          var send = function send(l, k) {
            if (_this2.options.missingKeyHandler) {
              _this2.options.missingKeyHandler(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
            } else if (_this2.backendConnector && _this2.backendConnector.saveMissing) {
              _this2.backendConnector.saveMissing(l, namespace, k, updateMissing ? options.defaultValue : res, updateMissing, options);
            }

            _this2.emit('missingKey', l, namespace, k, res);
          };

          if (this.options.saveMissing) {
            var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';

            if (this.options.saveMissingPlurals && needsPluralHandling) {
              lngs.forEach(function (l) {
                var plurals = _this2.pluralResolver.getPluralFormsOfKey(l, key);

                plurals.forEach(function (p) {
                  return send([l], p);
                });
              });
            } else {
              send(lngs, key);
            }
          }
        }

        res = this.extendTranslation(res, keys, options, resolved, lastKey);
        if (usedKey && res === key && this.options.appendNamespaceToMissingKey) res = "".concat(namespace, ":").concat(key);
        if (usedKey && this.options.parseMissingKeyHandler) res = this.options.parseMissingKeyHandler(res);
      }

      return res;
    }
  }, {
    key: "extendTranslation",
    value: function extendTranslation(res, key, options, resolved, lastKey) {
      var _this3 = this;

      if (this.i18nFormat && this.i18nFormat.parse) {
        res = this.i18nFormat.parse(res, options, resolved.usedLng, resolved.usedNS, resolved.usedKey, {
          resolved: resolved
        });
      } else if (!options.skipInterpolation) {
        if (options.interpolation) this.interpolator.init(_objectSpread$1({}, options, {
          interpolation: _objectSpread$1({}, this.options.interpolation, options.interpolation)
        }));
        var skipOnVariables = options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
        var nestBef;

        if (skipOnVariables) {
          var nb = res.match(this.interpolator.nestingRegexp);
          nestBef = nb && nb.length;
        }

        var data = options.replace && typeof options.replace !== 'string' ? options.replace : options;
        if (this.options.interpolation.defaultVariables) data = _objectSpread$1({}, this.options.interpolation.defaultVariables, data);
        res = this.interpolator.interpolate(res, data, options.lng || this.language, options);

        if (skipOnVariables) {
          var na = res.match(this.interpolator.nestingRegexp);
          var nestAft = na && na.length;
          if (nestBef < nestAft) options.nest = false;
        }

        if (options.nest !== false) res = this.interpolator.nest(res, function () {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          if (lastKey && lastKey[0] === args[0] && !options.context) {
            _this3.logger.warn("It seems you are nesting recursively key: ".concat(args[0], " in key: ").concat(key[0]));

            return null;
          }

          return _this3.translate.apply(_this3, args.concat([key]));
        }, options);
        if (options.interpolation) this.interpolator.reset();
      }

      var postProcess = options.postProcess || this.options.postProcess;
      var postProcessorNames = typeof postProcess === 'string' ? [postProcess] : postProcess;

      if (res !== undefined && res !== null && postProcessorNames && postProcessorNames.length && options.applyPostProcessor !== false) {
        res = postProcessor.handle(postProcessorNames, res, key, this.options && this.options.postProcessPassResolved ? _objectSpread$1({
          i18nResolved: resolved
        }, options) : options, this);
      }

      return res;
    }
  }, {
    key: "resolve",
    value: function resolve(keys) {
      var _this4 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var found;
      var usedKey;
      var exactUsedKey;
      var usedLng;
      var usedNS;
      if (typeof keys === 'string') keys = [keys];
      keys.forEach(function (k) {
        if (_this4.isValidLookup(found)) return;

        var extracted = _this4.extractFromKey(k, options);

        var key = extracted.key;
        usedKey = key;
        var namespaces = extracted.namespaces;
        if (_this4.options.fallbackNS) namespaces = namespaces.concat(_this4.options.fallbackNS);
        var needsPluralHandling = options.count !== undefined && typeof options.count !== 'string';
        var needsContextHandling = options.context !== undefined && typeof options.context === 'string' && options.context !== '';
        var codes = options.lngs ? options.lngs : _this4.languageUtils.toResolveHierarchy(options.lng || _this4.language, options.fallbackLng);
        namespaces.forEach(function (ns) {
          if (_this4.isValidLookup(found)) return;
          usedNS = ns;

          if (!checkedLoadedFor["".concat(codes[0], "-").concat(ns)] && _this4.utils && _this4.utils.hasLoadedNamespace && !_this4.utils.hasLoadedNamespace(usedNS)) {
            checkedLoadedFor["".concat(codes[0], "-").concat(ns)] = true;

            _this4.logger.warn("key \"".concat(usedKey, "\" for languages \"").concat(codes.join(', '), "\" won't get resolved as namespace \"").concat(usedNS, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
          }

          codes.forEach(function (code) {
            if (_this4.isValidLookup(found)) return;
            usedLng = code;
            var finalKey = key;
            var finalKeys = [finalKey];

            if (_this4.i18nFormat && _this4.i18nFormat.addLookupKeys) {
              _this4.i18nFormat.addLookupKeys(finalKeys, key, code, ns, options);
            } else {
              var pluralSuffix;
              if (needsPluralHandling) pluralSuffix = _this4.pluralResolver.getSuffix(code, options.count);
              if (needsPluralHandling && needsContextHandling) finalKeys.push(finalKey + pluralSuffix);
              if (needsContextHandling) finalKeys.push(finalKey += "".concat(_this4.options.contextSeparator).concat(options.context));
              if (needsPluralHandling) finalKeys.push(finalKey += pluralSuffix);
            }

            var possibleKey;

            while (possibleKey = finalKeys.pop()) {
              if (!_this4.isValidLookup(found)) {
                exactUsedKey = possibleKey;
                found = _this4.getResource(code, ns, possibleKey, options);
              }
            }
          });
        });
      });
      return {
        res: found,
        usedKey: usedKey,
        exactUsedKey: exactUsedKey,
        usedLng: usedLng,
        usedNS: usedNS
      };
    }
  }, {
    key: "isValidLookup",
    value: function isValidLookup(res) {
      return res !== undefined && !(!this.options.returnNull && res === null) && !(!this.options.returnEmptyString && res === '');
    }
  }, {
    key: "getResource",
    value: function getResource(code, ns, key) {
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      if (this.i18nFormat && this.i18nFormat.getResource) return this.i18nFormat.getResource(code, ns, key, options);
      return this.resourceStore.getResource(code, ns, key, options);
    }
  }]);

  return Translator;
}(EventEmitter);

function capitalize$3(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

var LanguageUtil = function () {
  function LanguageUtil(options) {
    _classCallCheck(this, LanguageUtil);

    this.options = options;
    this.whitelist = this.options.supportedLngs || false;
    this.supportedLngs = this.options.supportedLngs || false;
    this.logger = baseLogger.create('languageUtils');
  }

  _createClass(LanguageUtil, [{
    key: "getScriptPartFromCode",
    value: function getScriptPartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return null;
      var p = code.split('-');
      if (p.length === 2) return null;
      p.pop();
      if (p[p.length - 1].toLowerCase() === 'x') return null;
      return this.formatLanguageCode(p.join('-'));
    }
  }, {
    key: "getLanguagePartFromCode",
    value: function getLanguagePartFromCode(code) {
      if (!code || code.indexOf('-') < 0) return code;
      var p = code.split('-');
      return this.formatLanguageCode(p[0]);
    }
  }, {
    key: "formatLanguageCode",
    value: function formatLanguageCode(code) {
      if (typeof code === 'string' && code.indexOf('-') > -1) {
        var specialCases = ['hans', 'hant', 'latn', 'cyrl', 'cans', 'mong', 'arab'];
        var p = code.split('-');

        if (this.options.lowerCaseLng) {
          p = p.map(function (part) {
            return part.toLowerCase();
          });
        } else if (p.length === 2) {
          p[0] = p[0].toLowerCase();
          p[1] = p[1].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize$3(p[1].toLowerCase());
        } else if (p.length === 3) {
          p[0] = p[0].toLowerCase();
          if (p[1].length === 2) p[1] = p[1].toUpperCase();
          if (p[0] !== 'sgn' && p[2].length === 2) p[2] = p[2].toUpperCase();
          if (specialCases.indexOf(p[1].toLowerCase()) > -1) p[1] = capitalize$3(p[1].toLowerCase());
          if (specialCases.indexOf(p[2].toLowerCase()) > -1) p[2] = capitalize$3(p[2].toLowerCase());
        }

        return p.join('-');
      }

      return this.options.cleanCode || this.options.lowerCaseLng ? code.toLowerCase() : code;
    }
  }, {
    key: "isWhitelisted",
    value: function isWhitelisted(code) {
      this.logger.deprecate('languageUtils.isWhitelisted', 'function "isWhitelisted" will be renamed to "isSupportedCode" in the next major - please make sure to rename it\'s usage asap.');
      return this.isSupportedCode(code);
    }
  }, {
    key: "isSupportedCode",
    value: function isSupportedCode(code) {
      if (this.options.load === 'languageOnly' || this.options.nonExplicitSupportedLngs) {
        code = this.getLanguagePartFromCode(code);
      }

      return !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(code) > -1;
    }
  }, {
    key: "getBestMatchFromCodes",
    value: function getBestMatchFromCodes(codes) {
      var _this = this;

      if (!codes) return null;
      var found;
      codes.forEach(function (code) {
        if (found) return;

        var cleanedLng = _this.formatLanguageCode(code);

        if (!_this.options.supportedLngs || _this.isSupportedCode(cleanedLng)) found = cleanedLng;
      });

      if (!found && this.options.supportedLngs) {
        codes.forEach(function (code) {
          if (found) return;

          var lngOnly = _this.getLanguagePartFromCode(code);

          if (_this.isSupportedCode(lngOnly)) return found = lngOnly;
          found = _this.options.supportedLngs.find(function (supportedLng) {
            if (supportedLng.indexOf(lngOnly) === 0) return supportedLng;
          });
        });
      }

      if (!found) found = this.getFallbackCodes(this.options.fallbackLng)[0];
      return found;
    }
  }, {
    key: "getFallbackCodes",
    value: function getFallbackCodes(fallbacks, code) {
      if (!fallbacks) return [];
      if (typeof fallbacks === 'function') fallbacks = fallbacks(code);
      if (typeof fallbacks === 'string') fallbacks = [fallbacks];
      if (Object.prototype.toString.apply(fallbacks) === '[object Array]') return fallbacks;
      if (!code) return fallbacks["default"] || [];
      var found = fallbacks[code];
      if (!found) found = fallbacks[this.getScriptPartFromCode(code)];
      if (!found) found = fallbacks[this.formatLanguageCode(code)];
      if (!found) found = fallbacks[this.getLanguagePartFromCode(code)];
      if (!found) found = fallbacks["default"];
      return found || [];
    }
  }, {
    key: "toResolveHierarchy",
    value: function toResolveHierarchy(code, fallbackCode) {
      var _this2 = this;

      var fallbackCodes = this.getFallbackCodes(fallbackCode || this.options.fallbackLng || [], code);
      var codes = [];

      var addCode = function addCode(c) {
        if (!c) return;

        if (_this2.isSupportedCode(c)) {
          codes.push(c);
        } else {
          _this2.logger.warn("rejecting language code not found in supportedLngs: ".concat(c));
        }
      };

      if (typeof code === 'string' && code.indexOf('-') > -1) {
        if (this.options.load !== 'languageOnly') addCode(this.formatLanguageCode(code));
        if (this.options.load !== 'languageOnly' && this.options.load !== 'currentOnly') addCode(this.getScriptPartFromCode(code));
        if (this.options.load !== 'currentOnly') addCode(this.getLanguagePartFromCode(code));
      } else if (typeof code === 'string') {
        addCode(this.formatLanguageCode(code));
      }

      fallbackCodes.forEach(function (fc) {
        if (codes.indexOf(fc) < 0) addCode(_this2.formatLanguageCode(fc));
      });
      return codes;
    }
  }]);

  return LanguageUtil;
}();

var sets = [{
  lngs: ['ach', 'ak', 'am', 'arn', 'br', 'fil', 'gun', 'ln', 'mfe', 'mg', 'mi', 'oc', 'pt', 'pt-BR', 'tg', 'ti', 'tr', 'uz', 'wa'],
  nr: [1, 2],
  fc: 1
}, {
  lngs: ['af', 'an', 'ast', 'az', 'bg', 'bn', 'ca', 'da', 'de', 'dev', 'el', 'en', 'eo', 'es', 'et', 'eu', 'fi', 'fo', 'fur', 'fy', 'gl', 'gu', 'ha', 'hi', 'hu', 'hy', 'ia', 'it', 'kn', 'ku', 'lb', 'mai', 'ml', 'mn', 'mr', 'nah', 'nap', 'nb', 'ne', 'nl', 'nn', 'no', 'nso', 'pa', 'pap', 'pms', 'ps', 'pt-PT', 'rm', 'sco', 'se', 'si', 'so', 'son', 'sq', 'sv', 'sw', 'ta', 'te', 'tk', 'ur', 'yo'],
  nr: [1, 2],
  fc: 2
}, {
  lngs: ['ay', 'bo', 'cgg', 'fa', 'ht', 'id', 'ja', 'jbo', 'ka', 'kk', 'km', 'ko', 'ky', 'lo', 'ms', 'sah', 'su', 'th', 'tt', 'ug', 'vi', 'wo', 'zh'],
  nr: [1],
  fc: 3
}, {
  lngs: ['be', 'bs', 'cnr', 'dz', 'hr', 'ru', 'sr', 'uk'],
  nr: [1, 2, 5],
  fc: 4
}, {
  lngs: ['ar'],
  nr: [0, 1, 2, 3, 11, 100],
  fc: 5
}, {
  lngs: ['cs', 'sk'],
  nr: [1, 2, 5],
  fc: 6
}, {
  lngs: ['csb', 'pl'],
  nr: [1, 2, 5],
  fc: 7
}, {
  lngs: ['cy'],
  nr: [1, 2, 3, 8],
  fc: 8
}, {
  lngs: ['fr'],
  nr: [1, 2],
  fc: 9
}, {
  lngs: ['ga'],
  nr: [1, 2, 3, 7, 11],
  fc: 10
}, {
  lngs: ['gd'],
  nr: [1, 2, 3, 20],
  fc: 11
}, {
  lngs: ['is'],
  nr: [1, 2],
  fc: 12
}, {
  lngs: ['jv'],
  nr: [0, 1],
  fc: 13
}, {
  lngs: ['kw'],
  nr: [1, 2, 3, 4],
  fc: 14
}, {
  lngs: ['lt'],
  nr: [1, 2, 10],
  fc: 15
}, {
  lngs: ['lv'],
  nr: [1, 2, 0],
  fc: 16
}, {
  lngs: ['mk'],
  nr: [1, 2],
  fc: 17
}, {
  lngs: ['mnk'],
  nr: [0, 1, 2],
  fc: 18
}, {
  lngs: ['mt'],
  nr: [1, 2, 11, 20],
  fc: 19
}, {
  lngs: ['or'],
  nr: [2, 1],
  fc: 2
}, {
  lngs: ['ro'],
  nr: [1, 2, 20],
  fc: 20
}, {
  lngs: ['sl'],
  nr: [5, 1, 2, 3],
  fc: 21
}, {
  lngs: ['he', 'iw'],
  nr: [1, 2, 20, 21],
  fc: 22
}];
var _rulesPluralsTypes = {
  1: function _(n) {
    return Number(n > 1);
  },
  2: function _(n) {
    return Number(n != 1);
  },
  3: function _(n) {
    return 0;
  },
  4: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  5: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : n == 2 ? 2 : n % 100 >= 3 && n % 100 <= 10 ? 3 : n % 100 >= 11 ? 4 : 5);
  },
  6: function _(n) {
    return Number(n == 1 ? 0 : n >= 2 && n <= 4 ? 1 : 2);
  },
  7: function _(n) {
    return Number(n == 1 ? 0 : n % 10 >= 2 && n % 10 <= 4 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  8: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n != 8 && n != 11 ? 2 : 3);
  },
  9: function _(n) {
    return Number(n >= 2);
  },
  10: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n < 7 ? 2 : n < 11 ? 3 : 4);
  },
  11: function _(n) {
    return Number(n == 1 || n == 11 ? 0 : n == 2 || n == 12 ? 1 : n > 2 && n < 20 ? 2 : 3);
  },
  12: function _(n) {
    return Number(n % 10 != 1 || n % 100 == 11);
  },
  13: function _(n) {
    return Number(n !== 0);
  },
  14: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : n == 3 ? 2 : 3);
  },
  15: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n % 10 >= 2 && (n % 100 < 10 || n % 100 >= 20) ? 1 : 2);
  },
  16: function _(n) {
    return Number(n % 10 == 1 && n % 100 != 11 ? 0 : n !== 0 ? 1 : 2);
  },
  17: function _(n) {
    return Number(n == 1 || n % 10 == 1 && n % 100 != 11 ? 0 : 1);
  },
  18: function _(n) {
    return Number(n == 0 ? 0 : n == 1 ? 1 : 2);
  },
  19: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 1 && n % 100 < 11 ? 1 : n % 100 > 10 && n % 100 < 20 ? 2 : 3);
  },
  20: function _(n) {
    return Number(n == 1 ? 0 : n == 0 || n % 100 > 0 && n % 100 < 20 ? 1 : 2);
  },
  21: function _(n) {
    return Number(n % 100 == 1 ? 1 : n % 100 == 2 ? 2 : n % 100 == 3 || n % 100 == 4 ? 3 : 0);
  },
  22: function _(n) {
    return Number(n == 1 ? 0 : n == 2 ? 1 : (n < 0 || n > 10) && n % 10 == 0 ? 2 : 3);
  }
};

function createRules() {
  var rules = {};
  sets.forEach(function (set) {
    set.lngs.forEach(function (l) {
      rules[l] = {
        numbers: set.nr,
        plurals: _rulesPluralsTypes[set.fc]
      };
    });
  });
  return rules;
}

var PluralResolver = function () {
  function PluralResolver(languageUtils) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, PluralResolver);

    this.languageUtils = languageUtils;
    this.options = options;
    this.logger = baseLogger.create('pluralResolver');
    this.rules = createRules();
  }

  _createClass(PluralResolver, [{
    key: "addRule",
    value: function addRule(lng, obj) {
      this.rules[lng] = obj;
    }
  }, {
    key: "getRule",
    value: function getRule(code) {
      return this.rules[code] || this.rules[this.languageUtils.getLanguagePartFromCode(code)];
    }
  }, {
    key: "needsPlural",
    value: function needsPlural(code) {
      var rule = this.getRule(code);
      return rule && rule.numbers.length > 1;
    }
  }, {
    key: "getPluralFormsOfKey",
    value: function getPluralFormsOfKey(code, key) {
      var _this = this;

      var ret = [];
      var rule = this.getRule(code);
      if (!rule) return ret;
      rule.numbers.forEach(function (n) {
        var suffix = _this.getSuffix(code, n);

        ret.push("".concat(key).concat(suffix));
      });
      return ret;
    }
  }, {
    key: "getSuffix",
    value: function getSuffix(code, count) {
      var _this2 = this;

      var rule = this.getRule(code);

      if (rule) {
        var idx = rule.noAbs ? rule.plurals(count) : rule.plurals(Math.abs(count));
        var suffix = rule.numbers[idx];

        if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          if (suffix === 2) {
            suffix = 'plural';
          } else if (suffix === 1) {
            suffix = '';
          }
        }

        var returnSuffix = function returnSuffix() {
          return _this2.options.prepend && suffix.toString() ? _this2.options.prepend + suffix.toString() : suffix.toString();
        };

        if (this.options.compatibilityJSON === 'v1') {
          if (suffix === 1) return '';
          if (typeof suffix === 'number') return "_plural_".concat(suffix.toString());
          return returnSuffix();
        } else if (this.options.compatibilityJSON === 'v2') {
          return returnSuffix();
        } else if (this.options.simplifyPluralSuffix && rule.numbers.length === 2 && rule.numbers[0] === 1) {
          return returnSuffix();
        }

        return this.options.prepend && idx.toString() ? this.options.prepend + idx.toString() : idx.toString();
      }

      this.logger.warn("no plural rule found for: ".concat(code));
      return '';
    }
  }]);

  return PluralResolver;
}();

var Interpolator = function () {
  function Interpolator() {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, Interpolator);

    this.logger = baseLogger.create('interpolator');
    this.options = options;

    this.format = options.interpolation && options.interpolation.format || function (value) {
      return value;
    };

    this.init(options);
  }

  _createClass(Interpolator, [{
    key: "init",
    value: function init() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      if (!options.interpolation) options.interpolation = {
        escapeValue: true
      };
      var iOpts = options.interpolation;
      this.escape = iOpts.escape !== undefined ? iOpts.escape : escape;
      this.escapeValue = iOpts.escapeValue !== undefined ? iOpts.escapeValue : true;
      this.useRawValueToEscape = iOpts.useRawValueToEscape !== undefined ? iOpts.useRawValueToEscape : false;
      this.prefix = iOpts.prefix ? regexEscape(iOpts.prefix) : iOpts.prefixEscaped || '{{';
      this.suffix = iOpts.suffix ? regexEscape(iOpts.suffix) : iOpts.suffixEscaped || '}}';
      this.formatSeparator = iOpts.formatSeparator ? iOpts.formatSeparator : iOpts.formatSeparator || ',';
      this.unescapePrefix = iOpts.unescapeSuffix ? '' : iOpts.unescapePrefix || '-';
      this.unescapeSuffix = this.unescapePrefix ? '' : iOpts.unescapeSuffix || '';
      this.nestingPrefix = iOpts.nestingPrefix ? regexEscape(iOpts.nestingPrefix) : iOpts.nestingPrefixEscaped || regexEscape('$t(');
      this.nestingSuffix = iOpts.nestingSuffix ? regexEscape(iOpts.nestingSuffix) : iOpts.nestingSuffixEscaped || regexEscape(')');
      this.nestingOptionsSeparator = iOpts.nestingOptionsSeparator ? iOpts.nestingOptionsSeparator : iOpts.nestingOptionsSeparator || ',';
      this.maxReplaces = iOpts.maxReplaces ? iOpts.maxReplaces : 1000;
      this.alwaysFormat = iOpts.alwaysFormat !== undefined ? iOpts.alwaysFormat : false;
      this.resetRegExp();
    }
  }, {
    key: "reset",
    value: function reset() {
      if (this.options) this.init(this.options);
    }
  }, {
    key: "resetRegExp",
    value: function resetRegExp() {
      var regexpStr = "".concat(this.prefix, "(.+?)").concat(this.suffix);
      this.regexp = new RegExp(regexpStr, 'g');
      var regexpUnescapeStr = "".concat(this.prefix).concat(this.unescapePrefix, "(.+?)").concat(this.unescapeSuffix).concat(this.suffix);
      this.regexpUnescape = new RegExp(regexpUnescapeStr, 'g');
      var nestingRegexpStr = "".concat(this.nestingPrefix, "(.+?)").concat(this.nestingSuffix);
      this.nestingRegexp = new RegExp(nestingRegexpStr, 'g');
    }
  }, {
    key: "interpolate",
    value: function interpolate(str, data, lng, options) {
      var _this = this;

      var match;
      var value;
      var replaces;
      var defaultData = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {};

      function regexSafe(val) {
        return val.replace(/\$/g, '$$$$');
      }

      var handleFormat = function handleFormat(key) {
        if (key.indexOf(_this.formatSeparator) < 0) {
          var path = getPathWithDefaults(data, defaultData, key);
          return _this.alwaysFormat ? _this.format(path, undefined, lng) : path;
        }

        var p = key.split(_this.formatSeparator);
        var k = p.shift().trim();
        var f = p.join(_this.formatSeparator).trim();
        return _this.format(getPathWithDefaults(data, defaultData, k), f, lng, options);
      };

      this.resetRegExp();
      var missingInterpolationHandler = options && options.missingInterpolationHandler || this.options.missingInterpolationHandler;
      var skipOnVariables = options && options.interpolation && options.interpolation.skipOnVariables || this.options.interpolation.skipOnVariables;
      var todos = [{
        regex: this.regexpUnescape,
        safeValue: function safeValue(val) {
          return regexSafe(val);
        }
      }, {
        regex: this.regexp,
        safeValue: function safeValue(val) {
          return _this.escapeValue ? regexSafe(_this.escape(val)) : regexSafe(val);
        }
      }];
      todos.forEach(function (todo) {
        replaces = 0;

        while (match = todo.regex.exec(str)) {
          value = handleFormat(match[1].trim());

          if (value === undefined) {
            if (typeof missingInterpolationHandler === 'function') {
              var temp = missingInterpolationHandler(str, match, options);
              value = typeof temp === 'string' ? temp : '';
            } else if (skipOnVariables) {
              value = match[0];
              continue;
            } else {
              _this.logger.warn("missed to pass in variable ".concat(match[1], " for interpolating ").concat(str));

              value = '';
            }
          } else if (typeof value !== 'string' && !_this.useRawValueToEscape) {
            value = makeString(value);
          }

          str = str.replace(match[0], todo.safeValue(value));
          todo.regex.lastIndex = 0;
          replaces++;

          if (replaces >= _this.maxReplaces) {
            break;
          }
        }
      });
      return str;
    }
  }, {
    key: "nest",
    value: function nest(str, fc) {
      var _this2 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var match;
      var value;

      var clonedOptions = _objectSpread$1({}, options);

      clonedOptions.applyPostProcessor = false;
      delete clonedOptions.defaultValue;

      function handleHasOptions(key, inheritedOptions) {
        var sep = this.nestingOptionsSeparator;
        if (key.indexOf(sep) < 0) return key;
        var c = key.split(new RegExp("".concat(sep, "[ ]*{")));
        var optionsString = "{".concat(c[1]);
        key = c[0];
        optionsString = this.interpolate(optionsString, clonedOptions);
        optionsString = optionsString.replace(/'/g, '"');

        try {
          clonedOptions = JSON.parse(optionsString);
          if (inheritedOptions) clonedOptions = _objectSpread$1({}, inheritedOptions, clonedOptions);
        } catch (e) {
          this.logger.warn("failed parsing options string in nesting for key ".concat(key), e);
          return "".concat(key).concat(sep).concat(optionsString);
        }

        delete clonedOptions.defaultValue;
        return key;
      }

      while (match = this.nestingRegexp.exec(str)) {
        var formatters = [];
        var doReduce = false;

        if (match[0].includes(this.formatSeparator) && !/{.*}/.test(match[1])) {
          var r = match[1].split(this.formatSeparator).map(function (elem) {
            return elem.trim();
          });
          match[1] = r.shift();
          formatters = r;
          doReduce = true;
        }

        value = fc(handleHasOptions.call(this, match[1].trim(), clonedOptions), clonedOptions);
        if (value && match[0] === str && typeof value !== 'string') return value;
        if (typeof value !== 'string') value = makeString(value);

        if (!value) {
          this.logger.warn("missed to resolve ".concat(match[1], " for nesting ").concat(str));
          value = '';
        }

        if (doReduce) {
          value = formatters.reduce(function (v, f) {
            return _this2.format(v, f, options.lng, options);
          }, value.trim());
        }

        str = str.replace(match[0], value);
        this.regexp.lastIndex = 0;
      }

      return str;
    }
  }]);

  return Interpolator;
}();

function remove(arr, what) {
  var found = arr.indexOf(what);

  while (found !== -1) {
    arr.splice(found, 1);
    found = arr.indexOf(what);
  }
}

var Connector = function (_EventEmitter) {
  _inherits(Connector, _EventEmitter);

  function Connector(backend, store, services) {
    var _this;

    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    _classCallCheck(this, Connector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Connector).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }

    _this.backend = backend;
    _this.store = store;
    _this.services = services;
    _this.languageUtils = services.languageUtils;
    _this.options = options;
    _this.logger = baseLogger.create('backendConnector');
    _this.state = {};
    _this.queue = [];

    if (_this.backend && _this.backend.init) {
      _this.backend.init(services, options.backend, options);
    }

    return _this;
  }

  _createClass(Connector, [{
    key: "queueLoad",
    value: function queueLoad(languages, namespaces, options, callback) {
      var _this2 = this;

      var toLoad = [];
      var pending = [];
      var toLoadLanguages = [];
      var toLoadNamespaces = [];
      languages.forEach(function (lng) {
        var hasAllNamespaces = true;
        namespaces.forEach(function (ns) {
          var name = "".concat(lng, "|").concat(ns);

          if (!options.reload && _this2.store.hasResourceBundle(lng, ns)) {
            _this2.state[name] = 2;
          } else if (_this2.state[name] < 0) ; else if (_this2.state[name] === 1) {
            if (pending.indexOf(name) < 0) pending.push(name);
          } else {
            _this2.state[name] = 1;
            hasAllNamespaces = false;
            if (pending.indexOf(name) < 0) pending.push(name);
            if (toLoad.indexOf(name) < 0) toLoad.push(name);
            if (toLoadNamespaces.indexOf(ns) < 0) toLoadNamespaces.push(ns);
          }
        });
        if (!hasAllNamespaces) toLoadLanguages.push(lng);
      });

      if (toLoad.length || pending.length) {
        this.queue.push({
          pending: pending,
          loaded: {},
          errors: [],
          callback: callback
        });
      }

      return {
        toLoad: toLoad,
        pending: pending,
        toLoadLanguages: toLoadLanguages,
        toLoadNamespaces: toLoadNamespaces
      };
    }
  }, {
    key: "loaded",
    value: function loaded(name, err, data) {
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      if (err) this.emit('failedLoading', lng, ns, err);

      if (data) {
        this.store.addResourceBundle(lng, ns, data);
      }

      this.state[name] = err ? -1 : 2;
      var loaded = {};
      this.queue.forEach(function (q) {
        pushPath(q.loaded, [lng], ns);
        remove(q.pending, name);
        if (err) q.errors.push(err);

        if (q.pending.length === 0 && !q.done) {
          Object.keys(q.loaded).forEach(function (l) {
            if (!loaded[l]) loaded[l] = [];

            if (q.loaded[l].length) {
              q.loaded[l].forEach(function (ns) {
                if (loaded[l].indexOf(ns) < 0) loaded[l].push(ns);
              });
            }
          });
          q.done = true;

          if (q.errors.length) {
            q.callback(q.errors);
          } else {
            q.callback();
          }
        }
      });
      this.emit('loaded', loaded);
      this.queue = this.queue.filter(function (q) {
        return !q.done;
      });
    }
  }, {
    key: "read",
    value: function read(lng, ns, fcName) {
      var _this3 = this;

      var tried = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var wait = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 350;
      var callback = arguments.length > 5 ? arguments[5] : undefined;
      if (!lng.length) return callback(null, {});
      return this.backend[fcName](lng, ns, function (err, data) {
        if (err && data && tried < 5) {
          setTimeout(function () {
            _this3.read.call(_this3, lng, ns, fcName, tried + 1, wait * 2, callback);
          }, wait);
          return;
        }

        callback(err, data);
      });
    }
  }, {
    key: "prepareLoading",
    value: function prepareLoading(languages, namespaces) {
      var _this4 = this;

      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var callback = arguments.length > 3 ? arguments[3] : undefined;

      if (!this.backend) {
        this.logger.warn('No backend was added via i18next.use. Will not load resources.');
        return callback && callback();
      }

      if (typeof languages === 'string') languages = this.languageUtils.toResolveHierarchy(languages);
      if (typeof namespaces === 'string') namespaces = [namespaces];
      var toLoad = this.queueLoad(languages, namespaces, options, callback);

      if (!toLoad.toLoad.length) {
        if (!toLoad.pending.length) callback();
        return null;
      }

      toLoad.toLoad.forEach(function (name) {
        _this4.loadOne(name);
      });
    }
  }, {
    key: "load",
    value: function load(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {}, callback);
    }
  }, {
    key: "reload",
    value: function reload(languages, namespaces, callback) {
      this.prepareLoading(languages, namespaces, {
        reload: true
      }, callback);
    }
  }, {
    key: "loadOne",
    value: function loadOne(name) {
      var _this5 = this;

      var prefix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var s = name.split('|');
      var lng = s[0];
      var ns = s[1];
      this.read(lng, ns, 'read', undefined, undefined, function (err, data) {
        if (err) _this5.logger.warn("".concat(prefix, "loading namespace ").concat(ns, " for language ").concat(lng, " failed"), err);
        if (!err && data) _this5.logger.log("".concat(prefix, "loaded namespace ").concat(ns, " for language ").concat(lng), data);

        _this5.loaded(name, err, data);
      });
    }
  }, {
    key: "saveMissing",
    value: function saveMissing(languages, namespace, key, fallbackValue, isUpdate) {
      var options = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : {};

      if (this.services.utils && this.services.utils.hasLoadedNamespace && !this.services.utils.hasLoadedNamespace(namespace)) {
        this.logger.warn("did not save key \"".concat(key, "\" as the namespace \"").concat(namespace, "\" was not yet loaded"), 'This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!');
        return;
      }

      if (key === undefined || key === null || key === '') return;

      if (this.backend && this.backend.create) {
        this.backend.create(languages, namespace, key, fallbackValue, null, _objectSpread$1({}, options, {
          isUpdate: isUpdate
        }));
      }

      if (!languages || !languages[0]) return;
      this.store.addResource(languages[0], namespace, key, fallbackValue);
    }
  }]);

  return Connector;
}(EventEmitter);

function get$2() {
  return {
    debug: false,
    initImmediate: true,
    ns: ['translation'],
    defaultNS: ['translation'],
    fallbackLng: ['dev'],
    fallbackNS: false,
    whitelist: false,
    nonExplicitWhitelist: false,
    supportedLngs: false,
    nonExplicitSupportedLngs: false,
    load: 'all',
    preload: false,
    simplifyPluralSuffix: true,
    keySeparator: '.',
    nsSeparator: ':',
    pluralSeparator: '_',
    contextSeparator: '_',
    partialBundledLanguages: false,
    saveMissing: false,
    updateMissing: false,
    saveMissingTo: 'fallback',
    saveMissingPlurals: true,
    missingKeyHandler: false,
    missingInterpolationHandler: false,
    postProcess: false,
    postProcessPassResolved: false,
    returnNull: true,
    returnEmptyString: true,
    returnObjects: false,
    joinArrays: false,
    returnedObjectHandler: false,
    parseMissingKeyHandler: false,
    appendNamespaceToMissingKey: false,
    appendNamespaceToCIMode: false,
    overloadTranslationOptionHandler: function handle(args) {
      var ret = {};
      if (_typeof(args[1]) === 'object') ret = args[1];
      if (typeof args[1] === 'string') ret.defaultValue = args[1];
      if (typeof args[2] === 'string') ret.tDescription = args[2];

      if (_typeof(args[2]) === 'object' || _typeof(args[3]) === 'object') {
        var options = args[3] || args[2];
        Object.keys(options).forEach(function (key) {
          ret[key] = options[key];
        });
      }

      return ret;
    },
    interpolation: {
      escapeValue: true,
      format: function format(value, _format, lng, options) {
        return value;
      },
      prefix: '{{',
      suffix: '}}',
      formatSeparator: ',',
      unescapePrefix: '-',
      nestingPrefix: '$t(',
      nestingSuffix: ')',
      nestingOptionsSeparator: ',',
      maxReplaces: 1000,
      skipOnVariables: false
    }
  };
}
function transformOptions(options) {
  if (typeof options.ns === 'string') options.ns = [options.ns];
  if (typeof options.fallbackLng === 'string') options.fallbackLng = [options.fallbackLng];
  if (typeof options.fallbackNS === 'string') options.fallbackNS = [options.fallbackNS];

  if (options.whitelist) {
    if (options.whitelist && options.whitelist.indexOf('cimode') < 0) {
      options.whitelist = options.whitelist.concat(['cimode']);
    }

    options.supportedLngs = options.whitelist;
  }

  if (options.nonExplicitWhitelist) {
    options.nonExplicitSupportedLngs = options.nonExplicitWhitelist;
  }

  if (options.supportedLngs && options.supportedLngs.indexOf('cimode') < 0) {
    options.supportedLngs = options.supportedLngs.concat(['cimode']);
  }

  return options;
}

function noop$1() {}

var I18n = function (_EventEmitter) {
  _inherits(I18n, _EventEmitter);

  function I18n() {
    var _this;

    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var callback = arguments.length > 1 ? arguments[1] : undefined;

    _classCallCheck(this, I18n);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(I18n).call(this));

    if (isIE10) {
      EventEmitter.call(_assertThisInitialized$1(_this));
    }

    _this.options = transformOptions(options);
    _this.services = {};
    _this.logger = baseLogger;
    _this.modules = {
      external: []
    };

    if (callback && !_this.isInitialized && !options.isClone) {
      if (!_this.options.initImmediate) {
        _this.init(options, callback);

        return _possibleConstructorReturn(_this, _assertThisInitialized$1(_this));
      }

      setTimeout(function () {
        _this.init(options, callback);
      }, 0);
    }

    return _this;
  }

  _createClass(I18n, [{
    key: "init",
    value: function init() {
      var _this2 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;

      if (typeof options === 'function') {
        callback = options;
        options = {};
      }

      if (options.whitelist && !options.supportedLngs) {
        this.logger.deprecate('whitelist', 'option "whitelist" will be renamed to "supportedLngs" in the next major - please make sure to rename this option asap.');
      }

      if (options.nonExplicitWhitelist && !options.nonExplicitSupportedLngs) {
        this.logger.deprecate('whitelist', 'options "nonExplicitWhitelist" will be renamed to "nonExplicitSupportedLngs" in the next major - please make sure to rename this option asap.');
      }

      this.options = _objectSpread$1({}, get$2(), this.options, transformOptions(options));
      this.format = this.options.interpolation.format;
      if (!callback) callback = noop$1;

      function createClassOnDemand(ClassOrObject) {
        if (!ClassOrObject) return null;
        if (typeof ClassOrObject === 'function') return new ClassOrObject();
        return ClassOrObject;
      }

      if (!this.options.isClone) {
        if (this.modules.logger) {
          baseLogger.init(createClassOnDemand(this.modules.logger), this.options);
        } else {
          baseLogger.init(null, this.options);
        }

        var lu = new LanguageUtil(this.options);
        this.store = new ResourceStore(this.options.resources, this.options);
        var s = this.services;
        s.logger = baseLogger;
        s.resourceStore = this.store;
        s.languageUtils = lu;
        s.pluralResolver = new PluralResolver(lu, {
          prepend: this.options.pluralSeparator,
          compatibilityJSON: this.options.compatibilityJSON,
          simplifyPluralSuffix: this.options.simplifyPluralSuffix
        });
        s.interpolator = new Interpolator(this.options);
        s.utils = {
          hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
        };
        s.backendConnector = new Connector(createClassOnDemand(this.modules.backend), s.resourceStore, s, this.options);
        s.backendConnector.on('*', function (event) {
          for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
            args[_key - 1] = arguments[_key];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });

        if (this.modules.languageDetector) {
          s.languageDetector = createClassOnDemand(this.modules.languageDetector);
          s.languageDetector.init(s, this.options.detection, this.options);
        }

        if (this.modules.i18nFormat) {
          s.i18nFormat = createClassOnDemand(this.modules.i18nFormat);
          if (s.i18nFormat.init) s.i18nFormat.init(this);
        }

        this.translator = new Translator(this.services, this.options);
        this.translator.on('*', function (event) {
          for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          _this2.emit.apply(_this2, [event].concat(args));
        });
        this.modules.external.forEach(function (m) {
          if (m.init) m.init(_this2);
        });
      }

      if (this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
        var codes = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
        if (codes.length > 0 && codes[0] !== 'dev') this.options.lng = codes[0];
      }

      if (!this.services.languageDetector && !this.options.lng) {
        this.logger.warn('init: no languageDetector is used and no lng is defined');
      }

      var storeApi = ['getResource', 'hasResourceBundle', 'getResourceBundle', 'getDataByLanguage'];
      storeApi.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store;

          return (_this2$store = _this2.store)[fcName].apply(_this2$store, arguments);
        };
      });
      var storeApiChained = ['addResource', 'addResources', 'addResourceBundle', 'removeResourceBundle'];
      storeApiChained.forEach(function (fcName) {
        _this2[fcName] = function () {
          var _this2$store2;

          (_this2$store2 = _this2.store)[fcName].apply(_this2$store2, arguments);

          return _this2;
        };
      });
      var deferred = defer();

      var load = function load() {
        _this2.changeLanguage(_this2.options.lng, function (err, t) {
          _this2.isInitialized = true;
          if (!_this2.options.isClone) _this2.logger.log('initialized', _this2.options);

          _this2.emit('initialized', _this2.options);

          deferred.resolve(t);
          callback(err, t);
        });
      };

      if (this.options.resources || !this.options.initImmediate) {
        load();
      } else {
        setTimeout(load, 0);
      }

      return deferred;
    }
  }, {
    key: "loadResources",
    value: function loadResources(language) {
      var _this3 = this;

      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$1;
      var usedCallback = callback;
      var usedLng = typeof language === 'string' ? language : this.language;
      if (typeof language === 'function') usedCallback = language;

      if (!this.options.resources || this.options.partialBundledLanguages) {
        if (usedLng && usedLng.toLowerCase() === 'cimode') return usedCallback();
        var toLoad = [];

        var append = function append(lng) {
          if (!lng) return;

          var lngs = _this3.services.languageUtils.toResolveHierarchy(lng);

          lngs.forEach(function (l) {
            if (toLoad.indexOf(l) < 0) toLoad.push(l);
          });
        };

        if (!usedLng) {
          var fallbacks = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
          fallbacks.forEach(function (l) {
            return append(l);
          });
        } else {
          append(usedLng);
        }

        if (this.options.preload) {
          this.options.preload.forEach(function (l) {
            return append(l);
          });
        }

        this.services.backendConnector.load(toLoad, this.options.ns, usedCallback);
      } else {
        usedCallback(null);
      }
    }
  }, {
    key: "reloadResources",
    value: function reloadResources(lngs, ns, callback) {
      var deferred = defer();
      if (!lngs) lngs = this.languages;
      if (!ns) ns = this.options.ns;
      if (!callback) callback = noop$1;
      this.services.backendConnector.reload(lngs, ns, function (err) {
        deferred.resolve();
        callback(err);
      });
      return deferred;
    }
  }, {
    key: "use",
    value: function use(module) {
      if (!module) throw new Error('You are passing an undefined module! Please check the object you are passing to i18next.use()');
      if (!module.type) throw new Error('You are passing a wrong module! Please check the object you are passing to i18next.use()');

      if (module.type === 'backend') {
        this.modules.backend = module;
      }

      if (module.type === 'logger' || module.log && module.warn && module.error) {
        this.modules.logger = module;
      }

      if (module.type === 'languageDetector') {
        this.modules.languageDetector = module;
      }

      if (module.type === 'i18nFormat') {
        this.modules.i18nFormat = module;
      }

      if (module.type === 'postProcessor') {
        postProcessor.addPostProcessor(module);
      }

      if (module.type === '3rdParty') {
        this.modules.external.push(module);
      }

      return this;
    }
  }, {
    key: "changeLanguage",
    value: function changeLanguage(lng, callback) {
      var _this4 = this;

      this.isLanguageChangingTo = lng;
      var deferred = defer();
      this.emit('languageChanging', lng);

      var done = function done(err, l) {
        if (l) {
          _this4.language = l;
          _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);

          _this4.translator.changeLanguage(l);

          _this4.isLanguageChangingTo = undefined;

          _this4.emit('languageChanged', l);

          _this4.logger.log('languageChanged', l);
        } else {
          _this4.isLanguageChangingTo = undefined;
        }

        deferred.resolve(function () {
          return _this4.t.apply(_this4, arguments);
        });
        if (callback) callback(err, function () {
          return _this4.t.apply(_this4, arguments);
        });
      };

      var setLng = function setLng(lngs) {
        var l = typeof lngs === 'string' ? lngs : _this4.services.languageUtils.getBestMatchFromCodes(lngs);

        if (l) {
          if (!_this4.language) {
            _this4.language = l;
            _this4.languages = _this4.services.languageUtils.toResolveHierarchy(l);
          }

          if (!_this4.translator.language) _this4.translator.changeLanguage(l);
          if (_this4.services.languageDetector) _this4.services.languageDetector.cacheUserLanguage(l);
        }

        _this4.loadResources(l, function (err) {
          done(err, l);
        });
      };

      if (!lng && this.services.languageDetector && !this.services.languageDetector.async) {
        setLng(this.services.languageDetector.detect());
      } else if (!lng && this.services.languageDetector && this.services.languageDetector.async) {
        this.services.languageDetector.detect(setLng);
      } else {
        setLng(lng);
      }

      return deferred;
    }
  }, {
    key: "getFixedT",
    value: function getFixedT(lng, ns) {
      var _this5 = this;

      var fixedT = function fixedT(key, opts) {
        var options;

        if (_typeof(opts) !== 'object') {
          for (var _len3 = arguments.length, rest = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
            rest[_key3 - 2] = arguments[_key3];
          }

          options = _this5.options.overloadTranslationOptionHandler([key, opts].concat(rest));
        } else {
          options = _objectSpread$1({}, opts);
        }

        options.lng = options.lng || fixedT.lng;
        options.lngs = options.lngs || fixedT.lngs;
        options.ns = options.ns || fixedT.ns;
        return _this5.t(key, options);
      };

      if (typeof lng === 'string') {
        fixedT.lng = lng;
      } else {
        fixedT.lngs = lng;
      }

      fixedT.ns = ns;
      return fixedT;
    }
  }, {
    key: "t",
    value: function t() {
      var _this$translator;

      return this.translator && (_this$translator = this.translator).translate.apply(_this$translator, arguments);
    }
  }, {
    key: "exists",
    value: function exists() {
      var _this$translator2;

      return this.translator && (_this$translator2 = this.translator).exists.apply(_this$translator2, arguments);
    }
  }, {
    key: "setDefaultNamespace",
    value: function setDefaultNamespace(ns) {
      this.options.defaultNS = ns;
    }
  }, {
    key: "hasLoadedNamespace",
    value: function hasLoadedNamespace(ns) {
      var _this6 = this;

      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (!this.isInitialized) {
        this.logger.warn('hasLoadedNamespace: i18next was not initialized', this.languages);
        return false;
      }

      if (!this.languages || !this.languages.length) {
        this.logger.warn('hasLoadedNamespace: i18n.languages were undefined or empty', this.languages);
        return false;
      }

      var lng = this.languages[0];
      var fallbackLng = this.options ? this.options.fallbackLng : false;
      var lastLng = this.languages[this.languages.length - 1];
      if (lng.toLowerCase() === 'cimode') return true;

      var loadNotPending = function loadNotPending(l, n) {
        var loadState = _this6.services.backendConnector.state["".concat(l, "|").concat(n)];

        return loadState === -1 || loadState === 2;
      };

      if (options.precheck) {
        var preResult = options.precheck(this, loadNotPending);
        if (preResult !== undefined) return preResult;
      }

      if (this.hasResourceBundle(lng, ns)) return true;
      if (!this.services.backendConnector.backend) return true;
      if (loadNotPending(lng, ns) && (!fallbackLng || loadNotPending(lastLng, ns))) return true;
      return false;
    }
  }, {
    key: "loadNamespaces",
    value: function loadNamespaces(ns, callback) {
      var _this7 = this;

      var deferred = defer();

      if (!this.options.ns) {
        callback && callback();
        return Promise.resolve();
      }

      if (typeof ns === 'string') ns = [ns];
      ns.forEach(function (n) {
        if (_this7.options.ns.indexOf(n) < 0) _this7.options.ns.push(n);
      });
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "loadLanguages",
    value: function loadLanguages(lngs, callback) {
      var deferred = defer();
      if (typeof lngs === 'string') lngs = [lngs];
      var preloaded = this.options.preload || [];
      var newLngs = lngs.filter(function (lng) {
        return preloaded.indexOf(lng) < 0;
      });

      if (!newLngs.length) {
        if (callback) callback();
        return Promise.resolve();
      }

      this.options.preload = preloaded.concat(newLngs);
      this.loadResources(function (err) {
        deferred.resolve();
        if (callback) callback(err);
      });
      return deferred;
    }
  }, {
    key: "dir",
    value: function dir(lng) {
      if (!lng) lng = this.languages && this.languages.length > 0 ? this.languages[0] : this.language;
      if (!lng) return 'rtl';
      var rtlLngs = ['ar', 'shu', 'sqr', 'ssh', 'xaa', 'yhd', 'yud', 'aao', 'abh', 'abv', 'acm', 'acq', 'acw', 'acx', 'acy', 'adf', 'ads', 'aeb', 'aec', 'afb', 'ajp', 'apc', 'apd', 'arb', 'arq', 'ars', 'ary', 'arz', 'auz', 'avl', 'ayh', 'ayl', 'ayn', 'ayp', 'bbz', 'pga', 'he', 'iw', 'ps', 'pbt', 'pbu', 'pst', 'prp', 'prd', 'ug', 'ur', 'ydd', 'yds', 'yih', 'ji', 'yi', 'hbo', 'men', 'xmn', 'fa', 'jpr', 'peo', 'pes', 'prs', 'dv', 'sam'];
      return rtlLngs.indexOf(this.services.languageUtils.getLanguagePartFromCode(lng)) >= 0 ? 'rtl' : 'ltr';
    }
  }, {
    key: "createInstance",
    value: function createInstance() {
      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 ? arguments[1] : undefined;
      return new I18n(options, callback);
    }
  }, {
    key: "cloneInstance",
    value: function cloneInstance() {
      var _this8 = this;

      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop$1;

      var mergedOptions = _objectSpread$1({}, this.options, options, {
        isClone: true
      });

      var clone = new I18n(mergedOptions);
      var membersToCopy = ['store', 'services', 'language'];
      membersToCopy.forEach(function (m) {
        clone[m] = _this8[m];
      });
      clone.services = _objectSpread$1({}, this.services);
      clone.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      clone.translator = new Translator(clone.services, clone.options);
      clone.translator.on('*', function (event) {
        for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
          args[_key4 - 1] = arguments[_key4];
        }

        clone.emit.apply(clone, [event].concat(args));
      });
      clone.init(mergedOptions, callback);
      clone.translator.options = clone.options;
      clone.translator.backendConnector.services.utils = {
        hasLoadedNamespace: clone.hasLoadedNamespace.bind(clone)
      };
      return clone;
    }
  }]);

  return I18n;
}(EventEmitter);

var i18next = new I18n();

var i18n = i18next;

var isMergeableObject$1 = function isMergeableObject(value) {
	return isNonNullObject$1(value)
		&& !isSpecial$1(value)
};

function isNonNullObject$1(value) {
	return !!value && typeof value === 'object'
}

function isSpecial$1(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement$1(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol$1 = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE$1 = canUseSymbol$1 ? Symbol.for('react.element') : 0xeac7;

function isReactElement$1(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE$1
}

function emptyTarget$1(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified$1(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge$3(emptyTarget$1(value), value, options)
		: value
}

function defaultArrayMerge$1(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified$1(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge$3
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge$3
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject$1(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified$1(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified$1(source[key], options);
		}
	});
	return destination
}

function deepmerge$3(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge$1;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject$1;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified$1;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified$1(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject$1(target, source, options)
	}
}

deepmerge$3.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge$3(prev, next, options)
	}, {})
};

var deepmerge_1$1 = deepmerge$3;

var cjs = deepmerge_1$1;

var deepmerge$4 = cjs;

const loginLocalization = {
    login: {
        title: 'Sign In',
        signUpMessage: "Don't have an account?",
        signUpLink: 'Sign up',
        forgotPassword: 'Forgot Password?',
        emailInputLabel: 'Email',
        emailInputPlaceholder: 'name@example.com',
        passwordInputLabel: 'Password',
        passwordInputPlaceholder: 'Enter Your Password',
        login: 'Login',
        continue: 'Continue',
        emailMustBeValid: 'Must be a valid email',
        emailIsRequired: 'Email is required',
        passwordMustBeCharacters: 'Password must be at least {{length}} characters',
        passwordIsRequired: 'Password is required',
        invalidTitle: 'Couldn’t sign you in',
        signInWithSocialLogin: 'Or sign in with',
        backToLogin: 'Back to Login',
        mfaTitle: 'Two-Factor authentication',
        mfaInputLabel: 'Please enter the 6 digit code from your authenticator app',
        mfaCodeIsRequired: 'Code is required',
        mfaCodeLengthAtLeast6: 'Code must be at least 6 characters',
        mfaRememberThisDevice: `Don't ask again on this device for {{count}} day`,
        disableMultiFactorTitle: 'Having trouble?',
        disableMultiFactorMessage: 'to disable Multi-Factor with recovery code',
        recoverMfaTitle: 'Recover MFA',
        disabledMultiFactorClickHereButton: 'Click here',
        enterRecoveryCode: 'Please enter your MFA recovery code',
        disabledMultiFactorButton: 'Disable MFA',
        twoFactorCodeIsRequired: 'Code is required',
        twoFactorCodeLengthAtLeast8: 'Min length is 8 characters',
        missingPolicyErrorMessage: 'Seems like we are having trouble loading your configuration',
        magicLinkTitle: 'Magic link sent!',
        magicLinkText: 'We have sent an email to {{email}} with a link to get you signed in quickly.',
        magicLinkResend: 'Resend',
        invalidMagicLinkTitle: 'Couldn’t sign you in',
        invalidMagicLinkText: 'A magic link can only be used once.',
        smsOtcTitle: 'Verify that it’s you',
        smsOtcMessage: 'Please enter the six-digit code we have sent to {{phoneNumber}}',
        smsOtcChangePhoneMessage: '(not your number? change it here)',
        otcTitle: 'Check your email',
        otcMessage: 'We sent you a six digit code to {{email}}',
        otcInputLabel: 'Enter the generated 6-digit code below',
        otcInputPlaceholder: '6 - digit code',
        otcCodeIsRequired: '',
        otcContinue: 'Continue',
        otcHaventReceivedCode: 'Haven’t received it?',
        otcResend: 'Resend a new code',
        otcInvalidLengthCode: 'The code should have the 6 letter',
        ssoRedirectToMessage: 'Being redirected to your SSO provider...',
        failedOicdLoginTitle: 'Failed to Login with SSO, try again later.',
        failedOicdBackToLogin: 'Back to login',
        failedSamlBackToLogin: 'Back to login',
        failedSamlDefaultError: 'Failed to login with SSO, please try again later.',
        joinTenantTitle: "Join {{tenantName}}'s Account",
        failedJoinTenantTitle: 'This invite link is not active',
        failedJoinTenantBackButton: 'Back to login',
        forceMfaTitle: 'Enable multi-factor to get an extra layer of security.',
        forceMfaMessage: 'Multi-Factor authentication is required in order to access the account.',
        forceMfaScanQueryDescription1: 'Use your phone to scan the following QR code with ',
        forceMfaScanQueryDescription2: ' or other authenticator apps.',
        forceMfaInputLabel: 'Enter the generated 6-digit code below.',
        forceMfaInputPlaceholder: 'Ex. 1 2 3 4 5 6',
        forceMfaVerifyButton: 'Verify',
        forceMfaRememberThisDevice: `Don't ask again on this device for {{count}} day`,
        splitLogin: {
            titleDescriptionComponent: {
                companyName: '{company name}',
                titleBeforeCompanyName: 'With',
                titleAfterCompanyName: 'you can start building',
                description: 'Create your account and start use it today! It only takes a few seconds so sign in.'
            },
            testimonialComponent: {
                testimonial1: {
                    label: 'Nadav Nuni',
                    subtitle: 'Software developer @KOVRR',
                    text: 'We integrated Frontegg in just a few hours. We literally just needed to check the boxes to get started. Our dev team loves it.',
                },
            },
            valuesComponent: {
                value1: 'Every day, {company name} makes thousands of customers happy.',
                value2: 'Create your account and start your journey with us.',
                value3: '{company name} helps you grow! Signup and choose your plan.',
            },
        },
        disclaimerText: 'I agree with the',
        termsLinkText: 'Terms',
        termsLink: 'https://frontegg.com',
        privacyLinkText: 'Privacy Policy',
        privacyLink: 'https://frontegg.com',
        termsAndPrivacyConjunctionText: 'and',
        oneTouchLoginTitle: 'Log in with Touch ID',
        oneTouchLoginMessage: 'Log in with the touch of your finger',
        oneTouchLoginButton: 'Log in with Touch ID',
        touchId: 'Touch ID',
        androidLoginTitle: 'Log in with Android',
        androidLoginMessage: 'Get a notification on your Android',
        androidLoginButton: 'Log in with Android',
        android: 'Android',
        usbLoginTitle: 'Log in with USB key',
        usbLoginMessage: 'Plug in your USB key to log in',
        usbLoginButton: 'Log in with USB key',
        usb: 'USB Key',
        smsLoginTitle: 'Log in with SMS',
        smsLoginMessage: 'Enter your phone number to get a pin',
        smsLoginButton: 'Log in with SMS',
        smsLoginChangePhoneTitle: 'What’s your number?',
        smsLoginChangePhoneMessage: 'Enter your phone number to get a pin',
        smsLoginChangePhoneInputLabel: 'Phone number',
        smsLoginChangePhoneButton: 'Send me an SMS',
        smsLoginPinTitle: 'Verify that it’s you',
        smsLoginPinMessage: 'Please enter the six-digit code we have sent to {{phoneNumber}}',
        smsLoginPinButton: 'Verify',
        sms: 'SMS',
        loginWelcomeTitle: 'Welcome back',
        loginWelcomeSubtitleSubtitle: 'How would you like to log in?',
        loginWelcomeKnownUserSubtitle: 'Quickly log back into your account',
        registerNewQuickLoginTitle: 'Great choice! But first, please log in with email or social',
        registerNewQuickLoginSubtitle: 'Then we’ll set up login with {{type}} for you',
        phoneIsRequired: 'Phone number is required',
        phoneIsInvalid: 'Must be a valid phone number',
    },
};

const acceptInvitationLocalization = {
    acceptInvitation: {
        title: 'Accept Invitation',
        successTitle: 'Joined successfully!',
        successMessage: "You’ve joined the tenant’s account. You will be signed in automatically in a few seconds.",
        invalidTitle: 'This invite link is no longer active',
        invalidMessage: 'A sign in link can only be used once. For a new link, please contact the person who shared it with you.',
        invalidBackToLoginButton: 'Back to login',
    },
};

const activateAccountLocalization = {
    activateAccount: {
        title: 'Activate your account',
        newPasswordInputLabel: 'New password',
        newPasswordInputPlaceholder: 'Enter your password',
        newPasswordIsRequired: 'Password is required',
        confirmPasswordInputLabel: 'Confirm new password',
        confirmPasswordInputPlaceholder: 'Enter your password again',
        confirmPasswordIsRequired: 'Confirm password is required',
        confirmPasswordMustMatch: 'Passwords must match',
        activateButton: 'Activate',
        successTitle: 'Successfully activated!',
        successMessage: 'Now you can use your new password to log in to your account. The login page will appear automatically in a few seconds.',
        failedTitle: 'Activation failed',
        failedMessage: 'Please double check your activation url',
        linkExpiredTitle: 'Activation link expired',
        linkExpiredMessage: 'An activation link can only be used once',
        linkFailedTitle: 'Activation failed',
        linkFailedMessage: 'Please double check your activation url',
        failedBackToLoginButton: 'Back to login',
    },
};

const recoveryMfaLocalization = {
    recoveryMfa: {
        title: 'Recovery code can be used to disable multi-factor authentication in case you lose your phone.',
        recoveryCodeLabel: 'Your recovery code',
        copyAndSaveCode: 'Copy and save the code, because we won\'t show it again.',
        continueButton: 'Continue',
    },
};

const forgetPasswordLocalization = {
    forgetPassword: {
        title: 'Forgot your password?',
        description: 'Enter the email address associated with your account and we\'ll send you a link to reset your password',
        emailInputLabel: 'Email',
        emailInputPlaceholder: 'name@example.com',
        emailIsRequired: 'Email is required',
        emailMustBeValid: 'Must be a valid email',
        submitButtonText: 'Remind Me',
        backToLogin: 'Back to login',
        resetEmailSentTitle: 'Check your inbox',
        resetEmailSentMessage: "We've sent an email to {{email}} with instructions for resetting your password.",
    },
};

const resetPhoneNumberLocalization = {
    resetPhoneNumber: {
        emailInputLabel: 'Email',
        emailInputPlaceholder: 'name@example.com',
        emailIsRequired: 'Email is required',
        emailMustBeValid: 'Must be a valid email',
        continue: 'Continue',
        resetPhoneNumberTitle: 'Change phone number',
        resetPhoneOtcTitle: `Verify that it’s you`,
        resetPhoneOtcMessage: 'Please enter the six-digit code we have sent to your email',
        changePhoneNumberTitle: 'Enter your phone number',
        changePhoneNumberMessage: 'Please enter your phone number below',
        phoneInputLabel: 'Phone number',
        phoneInputPlaceholder: 'Enter your phone number',
        phoneIsRequired: 'Phone number is required',
        phoneIsInvalid: 'Must be a valid phone number',
        backToLogin: 'Back to login',
    },
};

const resetPasswordLocalization = {
    resetPassword: {
        title: 'Reset password',
        description: '',
        newPasswordInputLabel: 'New password',
        newPasswordInputPlaceholder: 'Enter your password',
        newPasswordIsRequired: 'New password is required',
        confirmPasswordInputLabel: 'Confirm new password',
        confirmPasswordInputPlaceholder: 'Enter your password again',
        confirmPasswordIsRequired: 'Confirm password is required',
        confirmPasswordMustMatch: 'Passwords must match',
        resetPasswordButton: 'Reset Password',
        successTitle: 'Password changed!',
        successMessage: 'Now you can use your new password to log in to your account. The login page will appear automatically in a few seconds.',
        failedTitle: 'Reset Password Failed',
        failedMessage: 'Please double check your reset url',
        failedBackToLoginButton: 'Back to login',
    },
};

const signupBase = {
    nameInputLabel: 'Name',
    nameInputPlaceholder: 'Enter your name',
    nameIsRequired: 'Name is required',
    nameMinLengthIs3: 'Name must be at least 3 characters',
    emailInputLabel: 'Email',
    emailInputPlaceholder: 'Enter your email',
    emailIsRequired: 'Email is required',
    emailMustBeValid: 'Must be a valid email',
    passwordInputLabel: 'Password',
    passwordInputPlaceholder: 'Enter your password',
    passwordIsRequired: 'Password is required',
    phoneInputLabel: 'Phone number',
    phoneInputPlaceholder: 'Enter your phone number',
    phoneIsRequired: 'Phone number is required',
    phoneIsInvalid: 'Must be a valid phone number',
    companyNameInputLabel: 'Company name',
    companyNameInputPlaceholder: 'Enter your company name',
    companyNameIsRequired: 'Company name is required',
    companyNameMinLengthIs3: 'Company name must be at least 3 characters',
    disclaimerText: 'By signing up, I agree with the',
    disclaimerCheckboxLabel: 'I agree to the',
    disclaimerTextRequired: 'Please agree in order to continue',
    termsLinkText: 'Terms',
    termsLink: 'https://frontegg.com',
    privacyLinkText: 'Privacy Policy',
    privacyLink: 'https://frontegg.com',
    termsAndPrivacyConjunctionText: 'and',
    signUpWithSocialLogin: 'Or sign up with',
    loginMessage: 'Already have an account?',
    loginLink: 'Log in',
    signupButtonText: 'Sign up',
    failedJoinTenantTitle: 'This invite link is not active',
    failedJoinTenantBackButton: 'Back to signup',
    successTitle: 'Thanks for signing up!',
    successActivateMessage: 'Please check your email. In a few moments, you will receive a verification email to confirm your account..',
    backToLoginLink: 'Back to login',
    successGoToLoginMessage: 'You have signed up successfully. Click on the button below to continue.',
    successGoToLoginButton: 'Go to login',
    splitSignUp: {
        titleDescriptionComponent: {
            companyName: '{company name}',
            titleBeforeCompanyName: 'With',
            titleAfterCompanyName: 'you can start building',
            description: 'Create your account and start use it today! It only takes a few seconds so sign in.',
        },
        testimonialComponent: {
            testimonial1: {
                label: 'Carol Von Trapp',
                subtitle: 'Software developer @KOVRR',
                text: 'We integrated Frontegg in just a few hours. We literally just needed to check the boxes to get started. Our dev team loves it.',
            },
            testimonial2: {
                label: 'Rebekka Von Gap',
                subtitle: 'Software developer @KOVRR',
                text: 'We integrated Frontegg in just a few hours. We literally just needed to check the boxes to get started.',
            },
        },
        valuesComponent: {
            value1: 'Every day, {company name} makes thousands of customers happy.',
            value2: 'Create your account and start your journey with us.',
            value3: '{company name} helps you grow! Signup and choose your plan.',
        },
    },
};
const signupLocalization = {
    signup: Object.assign(Object.assign({}, signupBase), { account: Object.assign(Object.assign({}, signupBase), { title: 'Account Sign Up' }), user: Object.assign(Object.assign({}, signupBase), { title: 'User Sign Up' }) }),
};

const socialLoginsLocalization = {
    socialLogins: {
        loginButtonText: 'Continue with {{providerName}}',
        signupButtonText: 'Login with {{providerName}}',
        activationButtonText: 'Sign up with {{providerName}}',
        invalidTitle: 'Couldn’t sign you in',
        failedInvalidCallbackUrl: 'Invalid callback url',
        failedBackToLogin: 'Back to login',
    },
};

const loginBoxLocalization = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, loginLocalization), acceptInvitationLocalization), activateAccountLocalization), recoveryMfaLocalization), forgetPasswordLocalization), resetPhoneNumberLocalization), resetPasswordLocalization), signupLocalization), socialLoginsLocalization);

const navigationLocalization = {
    navigation: {
        workspace: 'Workspace',
        allAccounts: 'All Accounts',
        poweredBy: 'Powered by',
        profile: 'Profile',
        privacy: 'Privacy & Security',
        personalApiTokens: 'Personal Tokens',
        usage: 'Usage',
        account: 'Account Details',
        users: 'Users',
        allUsers: 'All Users',
        roles: 'Roles',
        security: 'Security',
        sso: 'SSO',
        multipleSSO: 'SSO',
        audits: 'Audit Logs',
        webhooks: 'Webhooks',
        apiTokens: 'API Tokens',
        subscriptions: 'Subscription',
        login: 'Login',
    },
};

const profileLocalization = {
    profile: {
        pageTitle: 'Profile',
        name: 'Name',
        email: 'Email',
        phone: 'Phone Number',
        address: 'Address',
        jobTitle: 'Job Title',
        informationTitle: 'Basic Profile Information',
        uploadImage: 'Upload Image',
        removeImage: 'Remove Image?',
        removeImageTitle: 'Remove Image?',
        removeImageMessage: 'Are you sure you want to remove your image?',
        removeImageButton: 'Remove',
        removeImageCancelButton: 'Cancel',
    },
    profile_EditName: {
        title: 'Edit Name',
        displayNameInputLabel: 'Display Name',
        firstNameInputLabel: 'First Name',
        firstNameIsRequired: 'First name is required',
        lastNameInputLabel: 'Last Name',
        nameTitle: 'Title',
        nameTitle_mr: 'Mr',
        nameTitle_mrs: 'Mrs',
        nameTitle_miss: 'Miss',
        nameTitle_ms: 'Ms',
        nameTitle_dr: 'Dr',
        nameTitle_phd: 'PhD',
        cancel: 'Cancel',
        save: 'Save',
    },
    profile_EditJobTitle: {
        title: 'Edit Job Title',
        jobTitleInputLabel: 'Job Title',
        cancel: 'Cancel',
        save: 'Save',
    },
    profile_EditPhone: {
        title: 'Edit Phone Number',
        phoneInputLabel: 'Phone Number',
        phoneIsRequired: 'Phone number is required',
        phoneIsInvalid: 'Must be a valid phone number',
        cancel: 'Cancel',
        save: 'Save',
    },
    profile_EditAddress: {
        title: 'Edit Address',
        address1InputLabel: 'Address 1',
        address1IsRequired: 'Address 1 is required',
        address2InputLabel: 'Address 2',
        address2IsRequired: 'Address 2 is required',
        cityInputLabel: 'City',
        cityIsRequired: 'City is required',
        stateInputLabel: 'State',
        stateInputIsRequired: 'State is required',
        postCodeInputLabel: 'Postcode',
        postCodeIsInvalid: 'Must be a valid post code',
        postCodeIsRequired: 'Postcode is required',
        countryInputLabel: 'Country',
        countryInputPlaceholder: 'Select your Country',
        countryIsRequired: 'Country is required',
        cancel: 'Cancel',
        save: 'Save',
    },
};

const personalTokensLocalization = {
    personalTokens: {
        pageTitle: 'Personal Access Tokens',
        searchInputPlaceholder: 'Search for any text...',
        generateTokenButton: 'Generate Token',
        noApiTokensYet: 'You don\'t have any \nAPI tokens yet.',
        noApiTokensYetDescription: 'Add new api token to see the results in your table',
        noResultFound: 'No Result found',
        noResultFoundDescription: 'It seems we can’t find any results based on your search.',
        clientIdHeader: 'Client ID',
        createdOnHeader: 'Created On',
        deleteApiTokenAction: 'Delete API Token',
    },
    personalTokens_AddToken: {
        title: 'Generate Token',
        successTitle: 'Your API key was successfully generated!',
        descriptionInputLabel: 'Description',
        descriptionIsRequired: 'Description is required',
        clientId: 'Client ID',
        secretKey: 'Secret Key',
        copyAndSaveId: 'Copy and save the ID and Secret below because we won\'t show it again.',
        cancel: 'Cancel',
        create: 'Create',
        done: 'Done',
    },
    personalTokens_DeleteToken: {
        title: 'Delete API Token?',
        areYouSureDeleteApiToken1: 'Are you sure you want to delete',
        areYouSureDeleteApiToken2: 'you won\'t be able to undo this process',
        cancel: 'Cancel',
        delete: 'Delete',
    },
};

const auditLogsLocalization = {
    auditLogs: {
        pageTitle: 'Audit Logs',
        searchInputPlaceholder: 'Search for any text...',
        downloadCsv: 'Download CSV',
        downloadCsvPrimaryButton: 'Download',
        noResultFound: 'No Result found',
        noResultFoundDescription: 'It seems we can’t find any results based on your search.',
        searchingPlaceholder: 'Searching...',
        clear: 'Clear',
        cancel: 'Cancel',
        filter: 'Filter',
        filterBy: 'Filter By',
    },
};

const apiTokensLocalization = {
    apiTokens: {
        pageTitle: 'API Tokens',
        searchInputPlaceholder: 'Search for any text...',
        generateTokenButton: 'Generate Token',
        noApiTokensYet: 'You don\'t have any \nAPI tokens yet.',
        noApiTokensYetDescription: 'Add new api token to see the results in your table',
        noResultFound: 'No Result found',
        noResultFoundDescription: 'It seems we can’t find any results based on your search.',
        clientIdHeader: 'Client ID',
        createdOnHeader: 'Created On',
        createdByHeader: 'Created By',
        rolesHeader: 'Roles',
        deleteApiTokenAction: 'Delete API Token',
    },
    apiTokens_AddToken: {
        title: 'Generate Token',
        successTitle: 'Your API key was successfully generated!',
        descriptionInputLabel: 'Description',
        descriptionIsRequired: 'Description is required',
        clientId: 'Client ID',
        secretKey: 'Secret Key',
        copyAndSaveId: 'Copy and save the ID and Secret below because we won\'t show it again.',
        rolesInputLabel: 'Roles',
        rolesInputPlaceholder: 'Select Role',
        rolesIsRequired: 'At least one role is required',
        cancel: 'Cancel',
        create: 'Create',
        done: 'Done',
    },
    apiTokens_DeleteToken: {
        title: 'Delete API Token?',
        areYouSureDeleteApiToken1: 'Are you sure you want to delete',
        areYouSureDeleteApiToken2: 'you won\'t be able to undo this process',
        cancel: 'Cancel',
        delete: 'Delete',
    },
};

const accountSettingsLocalization = {
    accountSettings: {
        pageTitle: 'Account Details',
        subtitle: 'Settings',
        companyName: 'Company Name',
        address: 'Address',
        website: 'Website',
        timezone: 'Timezone',
        currency: 'Currency',
        addCompanyButton: 'Add company name',
        addAddressButton: 'Add company address',
        addWebsiteButton: 'Add website',
        setTimezoneButton: 'Set default timezone',
        setCurrencyButton: 'Set default currency',
    },
    accountSettings_EditAddress: {
        title: 'Edit Address',
        address1InputLabel: 'Address 1',
        address1IsRequired: 'Address 1 is required',
        address2InputLabel: 'Address 2',
        address2IsRequired: 'Address 2 is required',
        cityInputLabel: 'City',
        cityIsRequired: 'City is required',
        stateInputLabel: 'State',
        stateInputIsRequired: 'State is required',
        postCodeInputLabel: 'Postcode',
        postCodeIsInvalid: 'Must be a valid post code',
        postCodeIsRequired: 'Postcode is required',
        countryInputLabel: 'Country',
        countryInputPlaceholder: 'Select your Country',
        countryIsRequired: 'Country is required',
        cancel: 'Cancel',
        save: 'Save',
    },
    accountSettings_EditCompanyName: {
        title: 'Edit Name',
        companyNameLabel: 'Company Name',
        companyNameIsRequired: 'Company name is required',
        save: 'Save',
        cancel: 'Cancel',
    },
    accountSettings_EditWebsite: {
        title: 'Edit Website',
        websiteInputLabel: 'Website URL',
        save: 'Save',
        cancel: 'Cancel',
    },
    accountSettings_EditTimezone: {
        title: 'Edit Timezone',
        timezoneInputLabel: 'Timezone',
        save: 'Save',
        cancel: 'Cancel',
    },
    accountSettings_EditCurrency: {
        title: 'Edit Currency',
        currencyLabel: 'Currency',
        save: 'Save',
        cancel: 'Cancel',
    },
};

const privacyLocalization = {
    privacy: {
        pageTitle: 'Privacy & Security',
        basicSettings: 'Basic Settings',
        passwordTitle: 'Password',
        mfaTitle: 'Multi-Factor Authentication',
        mfaRequired: 'Required',
        mfaHelpMessage: 'Multi-factor authentication is required for at least one organization you are affiliated with.',
        mfaEnabled: 'Enabled',
        mfaDisabled: 'Disabled',
    },
    privacy_ChangePassword: {
        title: 'Change Password',
        currentPasswordInputLabel: 'Current password',
        currentPasswordIsRequired: 'Current password is required',
        newPasswordInputLabel: 'New password',
        newPasswordIsRequired: 'New password is required',
        confirmPasswordInputLabel: 'Confirm new password',
        confirmPasswordIsRequired: 'Confirm password is required',
        confirmPasswordMustMatch: 'Passwords must match',
        changePassword: 'Change Password',
        cancel: 'Cancel',
    },
    privacy_DisableMfa: {
        title: 'Disable multi-factor authentication',
        description: 'Disabling multi-factor will remove an extra layer of security.',
        tokenInputLabel: 'Enter the generated 6-digit code below',
        tokenInputLabelPlaceholder: '6-digit code',
        codeIsRequired: 'Code is required',
        codeLengthAtLeast6: 'Min length is 6 characters',
        cancel: 'Cancel',
        disable: 'Disable',
    },
    privacy_EnableMfa: {
        title: 'Multi-Factor Authentication',
        subtitle: 'Enable MFA to get an extra layer of security.',
        scanDescription1: 'Use your phone to scan the following QR code with',
        scanDescription2: 'or other authenticator apps.',
        codeInputLabel: 'Enter the generated 6-digit code below',
        codeInputPlaceholder: '6-digit code',
        codeIsRequired: 'Code is required',
        codeLengthAtLeast6: 'Min length is 6 characters',
        recoveryCodeTitle: 'Recovery code can be used to disable multi-factor authentication in case you lose your phone.',
        recoveryCodeLabel: 'Your recovery code',
        recoveryCodeInstructions: 'Copy and save the code, because we won\'t show it again.',
        cancel: 'Cancel',
        verify: 'Verify',
        close: 'Close',
    },
};

const securityLocalization = {
    security: {
        pageTitle: 'Security',
        subtitle: 'Settings',
        mfaTitle: 'MFA',
        mfaPolicyDontForceDescription: 'MFA is allowed but not enforced',
        mfaPolicyForceDescription: 'All users will be forced to enable MFA',
        mfaPolicyForceExceptSAMLDescription: 'All non-SAML users will be forced to enable MFA',
        lockoutTitle: 'User Lockout',
        lockoutNotConfigured: 'Lockout not configured',
        lockoutEnabledMaxAttempts1: 'User is locked after',
        lockoutEnabledMaxAttempts2: 'wrong password attempts',
        lockoutDisabled: 'Lockout Disabled',
        passwordHistoryTitle: 'Password History',
        passwordHistoryNotConfigured: 'Password history not configured',
        passwordHistoryEnabledHistorySize1: 'Reject passwords that are identical to',
        passwordHistoryEnabledHistorySize2: 'recently used password.',
        passwordHistoryDisabled: 'Password History Disabled',
    },
    security_EditMfaPolicy: {
        title: 'MFA Policy',
        dontForceTitle: 'Don\'t Force',
        dontForceDescription: 'MFA is allowed but not enforced',
        forceTitle: 'Force',
        forceDescription: 'All users will be forced to enable MFA',
        forceExceptSAMLTitle: 'Force except SAML users',
        forceExceptSAMLDescription: 'All non-SAML users will be forced to enable MFA',
        cancel: 'Cancel',
        save: 'Save',
    },
    security_EditLockoutPolicy: {
        title: 'User Lockout Policy',
        attemptsInputLabel: 'Maximum invalid login attempts',
        attemptsInputPlaceholder: 'Ex. after 5 wrong password attempts',
        attemptsInputErrorMessage: 'Must be a positive number',
        cancel: 'Cancel',
        save: 'Save',
    },
    security_EditPasswordHistoryPolicy: {
        title: 'Password History Policy',
        sizeInputLabel: 'History Size',
        sizeInputPlaceholder: '',
        sizeIsRequired: 'History size is required',
        sizeMustBeNumber: 'Must be a positive number',
        sizeMustBeGt0: 'Must be greater than or equal to 0',
        sizeMustBelt10: 'Must be less than or equal to 10',
        cancel: 'Cancel',
        save: 'Save',
    },
};

const rolesLocalization = {
    roles: {
        pageTitle: 'Roles & Permissions',
        actionsHeader: 'Actions',
        addNewRoleButton: 'Add Role',
        searchInputPlaceholder: 'Search for any text...',
        searchingPlaceholder: 'Searching roles...',
        noRolesYet: 'You didn\'t add \nroles yet',
        noRolesYetDescription: 'Add new roles to see the results in your table',
        noResultFound: 'No Result found',
        noResultFoundDescription: 'It seems we can’t find any results based on your search.',
    },
    roles_AddRole: {
        title: 'Add New Role',
        nameInputLabel: 'Role name',
        nameIsRequired: 'Role name is required',
        keyInputLabel: 'Role key',
        keyIsRequired: 'Role key is required',
        descriptionInputLabel: 'Role description',
        inheritPermissionInputLabel: 'Default role to inherit permissions from:',
        inheritPermissionInputPlaceholder: 'Select role',
        cancel: 'Cancel',
        create: 'Create',
    },
};

const ssoLocalization = {
    sso: {
        pageTitle: 'Single Sign On',
        enableAlert: 'Please notice, you must configure all SSO steps before you enable it.',
        subtitle: 'Configuration',
        stepOneTitle: 'Configure Your IDP',
        stepOne: 'Step 1',
        stepTwoTitle: 'Claim Domain',
        stepTwo: 'Step 2',
        stepThreeTitle: 'Manage Authorization',
        stepThree: 'Step 3',
        enableTitle: 'Enable Single Sign On',
        switchProviderAlert: '{{provider}} authentication is not supported anymore.',
    },
    sso_Header: {
        title: 'SSO Connections',
        addNew: 'Add New'
    },
    sso_Table: {
        editSSOConfig: 'Edit',
        deleteSSOConfig: 'Delete',
        areYouSureDeleteSSOConfig: `Are you sure you want to delete this sso connection? you won\'t be able to undo this process`,
        deleteSSOConfigTitle: 'Delete SSO Connection?',
        noSSOConfigsYet: 'You haven\’t configured SSO yet',
        noSSOConfigsYetDescription: 'Add new sso connection to see the results in your table',
        cancel: 'Cancel',
        back: 'Back',
        done: 'Done',
        proceed: 'Proceed',
        skip: 'Skip',
        rolesColumnName: 'Roles',
        domainsColumnName: 'Domains',
        idpColumnName: 'Type',
        statusColumnName: 'Status',
    },
    sso_ClaimDomain: {
        claimDomainText: 'Copy this info into a new TXT record in your DNS file:',
        title: 'Step 1 - Claim Domain',
        domainInputLabel: 'Domain Name',
        domainInputPlaceholder: 'Enter SSO domain',
        domainIsRequired: 'Domain name is required',
        domainMustBeValid: 'Must be a valid domain',
        domainValidatedMessage: 'Domain Validated',
        recordNameLabel: 'Record Name',
        recordValueLabel: 'Record Value',
        validate: 'Validate',
        proceed: 'Proceed',
        save: 'Save',
        close: 'Close',
        next: 'Next',
        saveAndEnable: 'Save and enable SSO',
        cancel: 'Cancel',
    },
    sso_ConfigureIdp: {
        title: 'Step 2 - Configure Your IDP',
        enabled: 'Enabled',
        successfullyEnabledMessage: 'Single Sign on is',
        successfullyIdpConfigured: 'IDP Configured',
        radioAutomaticLabel: 'AUTOMATIC',
        radioManualLabel: 'MANUAL',
        metadataFileLabel: 'Metadata File',
        metadataFileDescription: 'XML file with your configurations',
        metadataFileTypeErrorMessage: 'This file type is invalid. Please insert an xml',
        metadataFileIsRequired: 'Metadata file is required',
        idpSelectLabel: 'Select your connection type',
        acsUrlInputLabel: 'ACS URL',
        entityIdInputLabel: 'Entity ID',
        endpointInputLabel: 'SSO Endpoint',
        endpointInputPlaceholder: 'Url from the SSO',
        endpointIsRequired: 'Endpoint is required',
        endpointUrlIsInvalid: 'Endpoint must be valid URL',
        issuerUrlInputLabel: 'Issuer URL',
        issuerUrlIsRequired: 'Issuer url is required',
        issuerUrlIsInvalid: 'Issuer url must be valid URL',
        issuerUrlInputHelpMessage: 'The Open ID Connect “well known” url provided by the IDP',
        ssoWellKnownError: 'We couldn\'t verify your issuer URL',
        publicCertificateInputLabel: 'Public Certificate',
        publicCertificateInputPlaceholder: 'Provide Public Certificate',
        publicCertificateIsRequired: 'Public certificate is required',
        clientIdInputLabel: 'Client Id',
        clientIdInputPlaceholder: 'Client Id',
        clientIdIsRequired: 'Client id is requied',
        secretInputLabel: 'Secret Key',
        secretInputPlaceholder: 'Secret Key',
        secretIsRequired: 'Secret key is required',
        redirectUriInputLabel: 'Redirect URI',
        validate: 'Validate',
        proceed: 'Proceed',
        save: 'Save',
        close: 'Close',
        next: 'Next',
        saveAndEnable: 'Save and enable SSO',
        cancel: 'Cancel',
    },
    sso_ManageAuthorization: {
        title: 'Step 3 - Manage Authorization',
        enabled: 'Enabled',
        rolesIsRequired: 'At least one role is required',
        selectRolesLabel: 'Default SSO roles',
        rolesInputLabel: 'Roles',
        rolesInputPlaceholder: 'Select Role',
        // TODO: add missing localizations
        selectRolesHelpMessage: 'These roles will be assigned by default to users who sign up via SSO',
        successfullyAuthorizationManaged: '',
        successfullyEnabledMessage: 'Single Sign on is',
        addMapping: 'Add mapping',
        group: 'Group',
        roles: 'Roles',
        rolesGroupsMappingTitle: 'Roles Groups Mapping',
        rolesGroupsMappingDescription: 'Automatically assign additional roles according to your identity provider groups',
        rolesGroupsMappingError: 'Group must have at least 1 role',
        rolesGroupsNameEmptyError: 'Group name cannot be empty',
        rolesGroupsNameDuplicateError: 'Group name must be unique',
        ssoAddMapping: 'Add mapping',
        validate: 'Validate',
        proceed: 'Proceed',
        save: 'Save',
        close: 'Close',
        next: 'Next',
        saveAndEnable: 'Save and enable SSO',
        cancel: 'Cancel',
    },
};

const usersLocalization = {
    users: {
        pageTitle: 'Users',
        inviteUserButton: 'Invite User',
        searchInputPlaceholder: 'Search for any text...',
        searchingPlaceholder: 'Searching...',
        meTooltip: 'Me',
        userHeader: 'User',
        rolesHeader: 'Roles',
        organizationHeader: 'Organization',
        joinedHeader: 'Joined',
        lastSeenHeader: 'Last Seen',
        editRolesAction: 'Edit roles',
        pendingApprovalStatus: 'Pending approval',
        pendingActivationStatus: 'Not activated',
        resendInvitationAction: 'Resend invitation email',
        resendActivationAction: 'Resend activation email',
        leaveTeamAction: 'Leave Team',
        deleteUserAction: 'Delete User',
        noUsersYet: 'You didn\'t add \nusers yet',
        noUsersYetDescription: 'Add new users to see the results in your table',
        noResultFound: 'No Result found',
        noResultFoundDescription: 'It seems we can’t find any results based on your search.',
    },
    users_DeleteUser: {
        title: 'Delete User',
        areYouSureDeleteUser1: 'Are you sure you want to delete',
        areYouSureDeleteUser2: 'you won\'t be able to undo this process.',
        cancel: 'Cancel',
        delete: 'Delete',
    },
    users_EditUserRoles: {
        title: 'Edit Roles',
        selectRolesLabel: 'Select role',
        selectRolesPlaceholder: 'Select default roles for user',
        cancel: 'Cancel',
        update: 'Update',
    },
    users_InviteUser: {
        title: 'Invite User',
        inviteWithLinkSettings: 'Invite with link settings',
        firstNameInputLabel: 'First Name',
        firstNameIsRequired: 'First name is required',
        lastNameInputLabel: 'Last Name',
        lastNameIsRequired: 'Last name is required',
        emailInputLabel: 'Email',
        emailIsRequired: 'Email is required',
        emailMustBeValid: 'Must be a valid email',
        phoneInputLabel: 'Phone Number',
        phoneIsRequired: 'Phone number is required',
        phoneIsInvalid: 'Must be a valid phone number',
        rolesInputLabel: 'Roles',
        rolesIsRequired: 'At least one role is required',
        rolesInputPlaceholder: 'Select roles',
        cancel: 'Cancel',
        invite: 'Invite',
    },
    users_EditInvitationLink: {
        title: 'Invite with link settings',
        inviteWithLinkTitle: 'Invite with link',
        expirationInputLabel: 'Expiration',
        expirationInputPlaceholder: 'Please select an option',
        linkExpiration: 'Link will be expired in {{days}}',
        sendMeNotification: 'Send me an email each time someone joins using this invitation link',
        notification: 'Notification',
        deactivateLink: 'Deactivate link',
        back: 'Back',
        save: 'Save',
        copyInviteLink: 'Copy invite link',
        day: 'day',
        days: 'days',
        edit: 'Edit',
    },
    users_DeactivateInvitationLink: {
        title: 'Deactivate link',
        areYouSureDeleteInviteLink: 'Are you sure you want to deactivate invite link?',
        cancel: 'Cancel',
        deactivate: 'Deactivate',
    },
};

const webhooksLocalization = {
    webhooks: {
        pageTitle: 'Webhooks',
        searchInputPlaceholder: 'Search for any text...',
        addWebhook: 'Add Webhook',
        searchingPlaceholder: 'Webhook searching...',
        noResultFound: 'No Result found',
        noResultFoundDescription: 'It seems we can’t find any results based on your search.',
        noWebhooksYet: 'You haven\'t created any webhooks yet',
        noWebhooksYetDescription: 'Add new webhooks to see the results in your table',
        editWebhook: 'Edit webhook',
        deleteWebhook: 'Delete webhook',
        nameHeader: 'Name',
        statusHeader: 'Status',
    },
    webhooks_AddEditWebhook: {
        addTitle: 'Add New Webhook',
        editTitle: 'Edit Webhook',
        nameInputLabel: 'Name',
        nameInputPlaceholder: 'Enter webhook name',
        nameIsRequired: 'Webhook name is required',
        urlInputLabel: 'URL',
        urlInputPlaceholder: 'https://',
        urlIsRequired: 'Webhook url is required',
        urlIsInvalid: 'Must be valid URL',
        secretKeyInputLabel: 'Secret Key',
        secretKeyInputPlaceholder: 'Enter secret key',
        secretKeyLengthAtLeast8: 'Min length is 8 characters',
        eventsInputLabel: 'Events',
        eventsInputPlaceholder: 'Select events',
        eventsIsRequired: 'At least one event is required',
        cancel: 'Cancel',
        create: 'Create',
        edit: 'Update',
    },
    webhooks_DeleteWebhook: {
        title: 'Delete Webhook?',
        areYouSureDeleteWebhook1: 'Do you really want to delete ',
        areYouSureDeleteWebhook2: `webhook? if you delete it you won’t be able to undo the process.`,
        cancel: 'Cancel',
        delete: 'Delete',
    },
};

const subscriptionsLocalization = {
    subscriptions: {
        pageTitle: 'Subscription',
        externallyManaged: 'Your plan is managed by an external contract, contact us to change it',
        currentPlan: 'Current Plan',
        selectedPlan: 'Selected Plan',
        pricingLink: 'Pricing',
        paymentMethodTitle: 'Payment Method',
        invoices: 'Invoices',
        downloadPdf: 'Download PDF',
        cancel: 'Cancel',
        confirm: 'Confirm',
        update: 'Update',
        updatePaymentMethod: 'Update payment method',
        dialogCheckoutTitle: 'Checkout',
        dialogSelectionTitle: 'Update your plan',
        dialogUpdateBillingDetailsTitle: 'Update billing information',
        dialogCancellationTitle: 'Cancel Plan',
        dialogRenewalTitle: 'Renew Plan',
        expires: 'Expires',
        noBillingDetails: 'No billing information set',
        setupBillingDetails: 'Setup billing information',
        emailInputLabel: 'Email',
        emailInputPlaceholder: 'name@email.com',
        emailIsRequired: 'Email is required',
        emailMustBeValid: 'Must be a valid email',
        address1InputLabel: 'Address 1',
        address1InputPlaceholder: 'Address 1',
        address1IsRequired: 'Address 1 is required',
        address2InputLabel: 'Address 2',
        address2InputPlaceholder: 'address 2',
        address2IsRequired: 'Address 2 is required',
        cityInputLabel: 'City',
        cityInputPlaceholder: 'City',
        cityIsRequired: 'City is required',
        stateInputLabel: 'State',
        stateInputPlaceholder: 'State',
        stateInputIsRequired: 'State is required',
        postCodeInputLabel: 'Postcode',
        postCodeInputPlaceholder: 'Postal Code',
        postCodeIsInvalid: 'Must be a valid post code',
        postCodeIsRequired: 'Postcode is required',
        countryInputLabel: 'Country',
        countryInputPlaceholder: 'Country',
        countryIsRequired: 'Country is required',
    },
    subscriptions_CurrentPlan: {
        title: 'Current Plan',
        priceSubtitle: '{{price}} per month',
        yourPlanWillBeCanceled: 'Your plan will be canceled on {{periodEnd}}',
        yourPlanWillBeRenewed: 'Your plan renews on {{periodEnd}}',
        yourPlanIsTrialing: 'Your trial ends on {{periodEnd}}',
        renewalDefault: 'Unknown renewal date',
        canceled: 'Canceled',
        trialing: 'On Trial',
        trialEnded: 'Trial Ended',
        cancelButton: 'Cancel Plan',
        renewButton: 'Renew Plan',
        updateButton: 'Update Plan',
        buyNowButton: 'Buy Now',
        unknownPlan: 'Unknown Plan',
    },
    subscriptions_DialogSelection: {
        title: 'Update your plan',
        currentPlan: 'Current Plan',
        continue: 'Continue',
        selectPlanPricePerRecurringInterval: '{{currency}}{{price}} per {{interval}}',
    },
    subscriptions_Billing: {
        title: 'Update Billing Information',
        intervalTitle: 'per each {{interval}}',
        intervalMonth: 'month',
        intervalYear: 'year',
        unknownDate: 'unknown date',
        unknown: 'Billing Unstated',
        monthly: 'Billed Monthly',
        paymentMethod: 'PAYMENT METHOD',
        confirmError: 'Unable to process payment method: {{error}}',
        invalidCardStatusError: 'Invalid card status: {{status}}',
        confirmGenericError: 'Unable to setup new payment method',
    },
    subscriptions_Checkout: {
        title: 'Checkout',
        paymentMethod: 'PAYMENT METHOD',
        paymentMethodError: 'Unable to use payment method with checkout',
        nameOnCard: 'Name on card',
        cardNumber: 'Card Number',
        expiryDate: 'Expiry Date',
        cvc: 'CVC Security Number',
        selectedPlan: 'SELECTED PLAN',
        priceIntervalMonthly: 'Billed Monthly',
    },
    subscriptions_Cancellation: {
        title: 'Cancel Plan',
        unknownDate: 'Unknown date',
        description: 'If you cancel now, you\'ll still enjoy all the features of your paid plan until {{expirationDate}}. You can resubscribe or switch to another paid plan anytime.',
    },
    subscriptions_Renewal: {
        title: 'Renew Plan',
        unknownDate: 'Unknown date',
        description: 'This plan will no longer be canceled. It will renew on {{renewalDate}}.',
    },
    subscriptions_CheckoutDialog: {
        errorPlanNotFound: 'Plan was not found.',
    },
};

const allUsersLocalization = {
    allUsers: {
        pageTitle: 'All Users',
        inviteUserButton: 'Invite User',
        searchInputPlaceholder: 'Search for any text...',
        searchingPlaceholder: 'Searching...',
        meTooltip: 'Me',
        userHeader: 'User',
        rolesHeader: 'Roles',
        accountsHeader: 'Accounts',
        joinedHeader: 'Joined',
        lastSeenHeader: 'Last Seen',
        manageAction: 'Manage',
        pendingApprovalStatus: 'Pending approval',
        pendingActivationStatus: 'Not activated',
        resendInvitationAction: 'Resend invitation email',
        resendActivationAction: 'Resend activation email',
        leaveTeamAction: 'Leave Team',
        deleteUserAction: 'Delete',
        lockUserAction: 'Lock',
        noUsersYet: "You didn't add \nusers yet",
        noUsersYetDescription: 'Add new users to see the results in your table',
        noResultFound: 'No Result found',
        noResultFoundDescription: 'It seems we can’t find any results based on your search.',
    },
    allUsers_DeleteUser: {
        title: 'Delete {{name}} from all accounts?',
        areYouSureDeleteUser1: 'You are about to delete {{name}} from all accounts.',
        areYouSureDeleteUser2: "If you delete it, you won't be able to undo",
        cancel: 'Cancel',
        delete: 'Delete',
    },
    allUsers_LockUser: {
        title: 'Lock {{name}}?',
        areYouSureLockUser1: 'Do you really want to lock {{name}}?',
        cancel: 'Cancel',
        lock: 'Lock',
    },
    allUsers_InviteUser: {
        title: 'Invite User',
        inviteWithLinkSettings: 'Invite with link settings',
        fullNameInputLabel: 'Full Name',
        fullNameIsRequired: 'Full name is required',
        emailInputLabel: 'Email',
        emailIsRequired: 'Email is required',
        emailMustBeValid: 'Must be a valid email',
        rolesInputLabel: 'Roles',
        rolesIsRequired: 'At least one role is required',
        rolesInputPlaceholder: 'Select roles',
        cancel: 'Cancel',
        invite: 'Invite',
        save: 'Save',
        selected: 'Selected',
        accountsCount_one: '{{count}} Account',
        accountsCount_other: '{{count}} Accounts',
        assignRole: 'Assign role',
        accounts: 'Accounts',
        role: 'Role',
    },
    allUsers_EditInvitationLink: {
        title: 'Invite with link settings',
        inviteWithLinkTitle: 'Invite with link',
        expirationInputLabel: 'Expiration',
        expirationInputPlaceholder: 'Please select an option',
        linkExpiration: 'Link will be expired in {{days}}',
        sendMeNotification: 'Send me an email each time someone joins using this invitation link',
        notification: 'Notification',
        deactivateLink: 'Deactivate link',
        back: 'Back',
        save: 'Save',
        copyInviteLink: 'Copy invite link',
        day: 'day',
        days: 'days',
        edit: 'Edit',
    },
    allUsers_DeactivateInvitationLink: {
        title: 'Deactivate link',
        areYouSureDeleteInviteLink: 'Are you sure you want to deactivate invite link?',
        cancel: 'Cancel',
        deactivate: 'Deactivate',
    },
};

const adminPortalLocalization = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, navigationLocalization), profileLocalization), personalTokensLocalization), auditLogsLocalization), apiTokensLocalization), accountSettingsLocalization), privacyLocalization), securityLocalization), rolesLocalization), ssoLocalization), usersLocalization), webhooksLocalization), subscriptionsLocalization), allUsersLocalization);

const validations = {
    passwordMinLength: '{{length}} characters minimum',
    passwordMaxLength: '{{length}} characters maximum',
    passwordThreeRepeatedChars: 'avoid 3 or more recurring characters',
    passwordAtLeastOneLowerLetter: '1 lowercase letter',
    passwordAtLeastOneUpperLetter: '1 capital letter',
    passwordAtLeastOneNumber: '1 number',
    passwordAtLeastOneSpecialChar: '1 special character',
};

const en = {
    validations,
    loginBox: loginBoxLocalization,
    adminPortal: adminPortalLocalization,
    custom: {},
};
var en$1 = en;

const getUserLanguage = () => {
    var _a;
    try {
        return JSON.parse((_a = _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_2__.ContextHolder.getUser()) === null || _a === void 0 ? void 0 : _a.metadata).preferredLanguage;
    }
    catch (e) {
        return null;
    }
};
const getLanguage = () => {
    return window.localStorage.getItem('frontegg-language') || getUserLanguage() || 'en';
};
const initI18n = (overrides, metadata) => {
    var _a;
    const mergedOverrides = deepmerge$4((_a = metadata === null || metadata === void 0 ? void 0 : metadata.localizations) !== null && _a !== void 0 ? _a : {}, overrides !== null && overrides !== void 0 ? overrides : {});
    const overrideTranslations = mergedOverrides
        ? Object.keys(mergedOverrides).reduce((p, key) => (Object.assign(Object.assign({}, p), { [key]: { translation: mergedOverrides[key] } })), {})
        : {};
    const resources = deepmerge$4({ en: { translation: en$1 } }, overrideTranslations);
    return i18n.use(initReactI18next).createInstance({
        lng: getLanguage(),
        resources,
        keySeparator: '.',
        interpolation: {
            escapeValue: false,
        },
        react: { bindI18nStore: 'added' },
    });
};
var initI18n$1 = initI18n;

const I18nProvider = ({ children }) => {
    const { localizations, metadata, injector } = useShadowDom();
    const [initialized, setInitialized] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const i18n = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => initI18n$1(localizations, metadata), [localizations, metadata]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        i18n.init().then(() => setInitialized(true));
    }, [i18n]);
    const updateLocalizations = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((localizations) => {
        const resources = localizations[i18n.language];
        i18n.addResourceBundle(i18n.language, 'translation', resources, true, true);
    }, [i18n]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        var _a;
        (_a = injector === null || injector === void 0 ? void 0 : injector.updateLocalizationsSetter) === null || _a === void 0 ? void 0 : _a.call(injector, updateLocalizations);
    }, [updateLocalizations, injector]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(I18nextProvider, { i18n: i18n }, initialized ? children : null);
};
var I18nProvider$1 = I18nProvider;

var colorManipulator = {};

function chainPropTypes(propType1, propType2) {
  {
    return () => null;
  }
}

function _extends$b() {
  _extends$b = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$b.apply(this, arguments);
}

function isPlainObject$1(item) {
  return item !== null && typeof item === 'object' && // TS thinks `item is possibly null` even though this was our first guard.
  // @ts-expect-error
  item.constructor === Object;
}
function deepmerge$2(target, source, options = {
  clone: true
}) {
  const output = options.clone ? _extends$b({}, target) : target;

  if (isPlainObject$1(target) && isPlainObject$1(source)) {
    Object.keys(source).forEach(key => {
      // Avoid prototype pollution
      if (key === '__proto__') {
        return;
      }

      if (isPlainObject$1(source[key]) && key in target && isPlainObject$1(target[key])) {
        // Since `output` is a clone of `target` and we have narrowed `target` in this block we can cast to the same type.
        output[key] = deepmerge$2(target[key], source[key], options);
      } else {
        output[key] = source[key];
      }
    });
  }

  return output;
}

const elementAcceptingRef = chainPropTypes(PropTypes.element);
elementAcceptingRef.isRequired = chainPropTypes(PropTypes.element.isRequired);
var elementAcceptingRef$1 = elementAcceptingRef;

var elementTypeAcceptingRef = chainPropTypes(PropTypes.elementType);

function exactProp(propTypes) {
  {
    return propTypes;
  }
}

/**
 * WARNING: Don't import this directly.
 * Use `MuiError` from `@mui/utils/macros/MuiError.macro` instead.
 * @param {number} code
 */
function formatMuiErrorMessage(code) {
  // Apply babel-plugin-transform-template-literals in loose mode
  // loose mode is safe iff we're concatenating primitives
  // see https://babeljs.io/docs/en/babel-plugin-transform-template-literals#loose

  /* eslint-disable prefer-template */
  let url = 'https://mui.com/production-error/?code=' + code;

  for (let i = 1; i < arguments.length; i += 1) {
    // rest params over-transpile for this case
    // eslint-disable-next-line prefer-rest-params
    url += '&args[]=' + encodeURIComponent(arguments[i]);
  }

  return 'Minified MUI error #' + code + '; visit ' + url + ' for the full message.';
  /* eslint-enable prefer-template */
}

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$2=60103,c$2=60106,d$2=60107,e$1=60108,f$3=60114,g$3=60109,h$3=60110,k$2=60112,l$2=60113,m$3=60120,n$2=60115,p$3=60116,q$3=60121,r$2=60122,u$2=60117,v$2=60129,w$2=60131;
if("function"===typeof Symbol&&Symbol.for){var x$2=Symbol.for;b$2=x$2("react.element");c$2=x$2("react.portal");d$2=x$2("react.fragment");e$1=x$2("react.strict_mode");f$3=x$2("react.profiler");g$3=x$2("react.provider");h$3=x$2("react.context");k$2=x$2("react.forward_ref");l$2=x$2("react.suspense");m$3=x$2("react.suspense_list");n$2=x$2("react.memo");p$3=x$2("react.lazy");q$3=x$2("react.block");r$2=x$2("react.server.block");u$2=x$2("react.fundamental");v$2=x$2("react.debug_trace_mode");w$2=x$2("react.legacy_hidden");}
function y$2(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b$2:switch(a=a.type,a){case d$2:case f$3:case e$1:case l$2:case m$3:return a;default:switch(a=a&&a.$$typeof,a){case h$3:case k$2:case p$3:case n$2:case g$3:return a;default:return t}}case c$2:return t}}}var z$2=g$3,A$2=b$2,B$2=k$2,C$2=d$2,D$2=p$3,E$2=n$2,F$2=c$2,G$2=f$3,H$2=e$1,I$2=l$2;reactIs_production_min.ContextConsumer=h$3;reactIs_production_min.ContextProvider=z$2;reactIs_production_min.Element=A$2;reactIs_production_min.ForwardRef=B$2;reactIs_production_min.Fragment=C$2;reactIs_production_min.Lazy=D$2;reactIs_production_min.Memo=E$2;reactIs_production_min.Portal=F$2;reactIs_production_min.Profiler=G$2;reactIs_production_min.StrictMode=H$2;
reactIs_production_min.Suspense=I$2;reactIs_production_min.isAsyncMode=function(){return !1};reactIs_production_min.isConcurrentMode=function(){return !1};reactIs_production_min.isContextConsumer=function(a){return y$2(a)===h$3};reactIs_production_min.isContextProvider=function(a){return y$2(a)===g$3};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b$2};reactIs_production_min.isForwardRef=function(a){return y$2(a)===k$2};reactIs_production_min.isFragment=function(a){return y$2(a)===d$2};reactIs_production_min.isLazy=function(a){return y$2(a)===p$3};reactIs_production_min.isMemo=function(a){return y$2(a)===n$2};
reactIs_production_min.isPortal=function(a){return y$2(a)===c$2};reactIs_production_min.isProfiler=function(a){return y$2(a)===f$3};reactIs_production_min.isStrictMode=function(a){return y$2(a)===e$1};reactIs_production_min.isSuspense=function(a){return y$2(a)===l$2};reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d$2||a===f$3||a===v$2||a===e$1||a===l$2||a===m$3||a===w$2||"object"===typeof a&&null!==a&&(a.$$typeof===p$3||a.$$typeof===n$2||a.$$typeof===g$3||a.$$typeof===h$3||a.$$typeof===k$2||a.$$typeof===u$2||a.$$typeof===q$3||a[0]===r$2)?!0:!1};
reactIs_production_min.typeOf=y$2;

{
  reactIs.exports = reactIs_production_min;
}

// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3

const fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
function getFunctionName(fn) {
  const match = `${fn}`.match(fnNameMatchRegex);
  const name = match && match[1];
  return name || '';
}

function getFunctionComponentName(Component, fallback = '') {
  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
}

function getWrappedName(outerType, innerType, wrapperName) {
  const functionName = getFunctionComponentName(innerType);
  return outerType.displayName || (functionName !== '' ? `${wrapperName}(${functionName})` : wrapperName);
}
/**
 * cherry-pick from
 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
 * originally forked from recompose/getDisplayName with added IE11 support
 */


function getDisplayName(Component) {
  if (Component == null) {
    return undefined;
  }

  if (typeof Component === 'string') {
    return Component;
  }

  if (typeof Component === 'function') {
    return getFunctionComponentName(Component, 'Component');
  } // TypeScript can't have components as objects but they exist in the form of `memo` or `Suspense`


  if (typeof Component === 'object') {
    switch (Component.$$typeof) {
      case reactIs.exports.ForwardRef:
        return getWrappedName(Component, Component.render, 'ForwardRef');

      case reactIs.exports.Memo:
        return getWrappedName(Component, Component.type, 'memo');

      default:
        return undefined;
    }
  }

  return undefined;
}

function HTMLElementType(props, propName, componentName, location, propFullName) {
  {
    return null;
  }
}

/* eslint-disable */
// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var ponyfillGlobal = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();

const refType = PropTypes.oneOfType([PropTypes.func, PropTypes.object]);
var refType$1 = refType;

// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
//
// A strict capitalization should uppercase the first letter of each word in the sentence.
// We only handle the first word.
function capitalize$2(string) {
  if (typeof string !== 'string') {
    throw new Error(formatMuiErrorMessage(7));
  }

  return string.charAt(0).toUpperCase() + string.slice(1);
}

/**
 * Safe chained function.
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 */
function createChainedFunction(...funcs) {
  return funcs.reduce((acc, func) => {
    if (func == null) {
      return acc;
    }

    return function chainedFunction(...args) {
      acc.apply(this, args);
      func.apply(this, args);
    };
  }, () => {});
}

// Corresponds to 10 frames at 60 Hz.
// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
function debounce$1(func, wait = 166) {
  let timeout;

  function debounced(...args) {
    const later = () => {
      func.apply(this, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  }

  debounced.clear = () => {
    clearTimeout(timeout);
  };

  return debounced;
}

function deprecatedPropType(validator, reason) {
  {
    return () => null;
  }
}

function isMuiElement(element, muiNames) {
  return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
}

function ownerDocument(node) {
  return node && node.ownerDocument || document;
}

function ownerWindow(node) {
  const doc = ownerDocument(node);
  return doc.defaultView || window;
}

function requirePropFactory(componentNameInError, Component) {
  {
    return () => null;
  } // eslint-disable-next-line react/forbid-foreign-prop-types
}

/**
 * TODO v5: consider making it private
 *
 * passes {value} to {ref}
 *
 * WARNING: Be sure to only call this inside a callback that is passed as a ref.
 * Otherwise, make sure to cleanup the previous {ref} if it changes. See
 * https://github.com/mui-org/material-ui/issues/13539
 *
 * Useful if you want to expose the ref of an inner component to the public API
 * while still using it inside the component.
 * @param ref A ref callback or ref object. If anything falsy, this is a no-op.
 */
function setRef(ref, value) {
  if (typeof ref === 'function') {
    ref(value);
  } else if (ref) {
    ref.current = value;
  }
}

const useEnhancedEffect = typeof window !== 'undefined' ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useLayoutEffect : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect;
var useEnhancedEffect$1 = useEnhancedEffect;

function useId(idOverride) {
  const [defaultId, setDefaultId] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(idOverride);
  const id = idOverride || defaultId;
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    if (defaultId == null) {
      // Fallback to this default id when possible.
      // Use the random value for client-side rendering only.
      // We can't use it server-side.
      setDefaultId(`mui-${Math.round(Math.random() * 1e9)}`);
    }
  }, [defaultId]);
  return id;
}

function unsupportedProp(props, propName, componentName, location, propFullName) {
  {
    return null;
  }
}

/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
function useControlled({
  controlled,
  default: defaultProp,
  name,
  state = 'value'
}) {
  // isControlled is ignored in the hook dependency lists as it should never change.
  const {
    current: isControlled
  } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(controlled !== undefined);
  const [valueState, setValue] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(defaultProp);
  const value = isControlled ? controlled : valueState;

  const setValueIfUncontrolled = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(newValue => {
    if (!isControlled) {
      setValue(newValue);
    }
  }, []);
  return [value, setValueIfUncontrolled];
}

/**
 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
 */

function useEventCallback$1(fn) {
  const ref = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(fn);
  useEnhancedEffect$1(() => {
    ref.current = fn;
  });
  return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((...args) => // @ts-expect-error hide `this`
  // tslint:disable-next-line:ban-comma-operator
  (0, ref.current)(...args), []);
}

function useForkRef(refA, refB) {
  /**
   * This will create a new function if the ref props change and are defined.
   * This means react will call the old forkRef with `null` and the new forkRef
   * with the ref. Cleanup naturally emerges from this behavior.
   */
  return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
    if (refA == null && refB == null) {
      return null;
    }

    return refValue => {
      setRef(refA, refValue);
      setRef(refB, refValue);
    };
  }, [refA, refB]);
}

// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
let hadKeyboardEvent = true;
let hadFocusVisibleRecently = false;
let hadFocusVisibleRecentlyTimeout = null;
const inputTypesWhitelist = {
  text: true,
  search: true,
  url: true,
  tel: true,
  email: true,
  password: true,
  number: true,
  date: true,
  month: true,
  week: true,
  time: true,
  datetime: true,
  'datetime-local': true
};
/**
 * Computes whether the given element should automatically trigger the
 * `focus-visible` class being added, i.e. whether it should always match
 * `:focus-visible` when focused.
 * @param {Element} node
 * @returns {boolean}
 */

function focusTriggersKeyboardModality(node) {
  const {
    type,
    tagName
  } = node;

  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
    return true;
  }

  if (tagName === 'TEXTAREA' && !node.readOnly) {
    return true;
  }

  if (node.isContentEditable) {
    return true;
  }

  return false;
}
/**
 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
 * If the most recent user interaction was via the keyboard;
 * and the key press did not include a meta, alt/option, or control key;
 * then the modality is keyboard. Otherwise, the modality is not keyboard.
 * @param {KeyboardEvent} event
 */


function handleKeyDown(event) {
  if (event.metaKey || event.altKey || event.ctrlKey) {
    return;
  }

  hadKeyboardEvent = true;
}
/**
 * If at any point a user clicks with a pointing device, ensure that we change
 * the modality away from keyboard.
 * This avoids the situation where a user presses a key on an already focused
 * element, and then clicks on a different element, focusing it with a
 * pointing device, while we still think we're in keyboard modality.
 */


function handlePointerDown() {
  hadKeyboardEvent = false;
}

function handleVisibilityChange() {
  if (this.visibilityState === 'hidden') {
    // If the tab becomes active again, the browser will handle calling focus
    // on the element (Safari actually calls it twice).
    // If this tab change caused a blur on an element with focus-visible,
    // re-apply the class when the user switches back to the tab.
    if (hadFocusVisibleRecently) {
      hadKeyboardEvent = true;
    }
  }
}

function prepare(doc) {
  doc.addEventListener('keydown', handleKeyDown, true);
  doc.addEventListener('mousedown', handlePointerDown, true);
  doc.addEventListener('pointerdown', handlePointerDown, true);
  doc.addEventListener('touchstart', handlePointerDown, true);
  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
}

function isFocusVisible(event) {
  const {
    target
  } = event;

  try {
    return target.matches(':focus-visible');
  } catch (error) {// Browsers not implementing :focus-visible will throw a SyntaxError.
    // We use our own heuristic for those browsers.
    // Rethrow might be better if it's not the expected error but do we really
    // want to crash if focus-visible malfunctioned?
  } // No need for validFocusTarget check. The user does that by attaching it to
  // focusable events only.


  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
}

function useIsFocusVisible() {
  const ref = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(node => {
    if (node != null) {
      prepare(node.ownerDocument);
    }
  }, []);
  const isFocusVisibleRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(false);
  /**
   * Should be called if a blur event is fired
   */

  function handleBlurVisible() {
    // checking against potential state variable does not suffice if we focus and blur synchronously.
    // React wouldn't have time to trigger a re-render so `focusVisible` would be stale.
    // Ideally we would adjust `isFocusVisible(event)` to look at `relatedTarget` for blur events.
    // This doesn't work in IE11 due to https://github.com/facebook/react/issues/3751
    // TODO: check again if React releases their internal changes to focus event handling (https://github.com/facebook/react/pull/19186).
    if (isFocusVisibleRef.current) {
      // To detect a tab/window switch, we look for a blur event followed
      // rapidly by a visibility change.
      // If we don't see a visibility change within 100ms, it's probably a
      // regular focus change.
      hadFocusVisibleRecently = true;
      window.clearTimeout(hadFocusVisibleRecentlyTimeout);
      hadFocusVisibleRecentlyTimeout = window.setTimeout(() => {
        hadFocusVisibleRecently = false;
      }, 100);
      isFocusVisibleRef.current = false;
      return true;
    }

    return false;
  }
  /**
   * Should be called if a blur event is fired
   */


  function handleFocusVisible(event) {
    if (isFocusVisible(event)) {
      isFocusVisibleRef.current = true;
      return true;
    }

    return false;
  }

  return {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref
  };
}

// A change of the browser zoom change the scrollbar size.
// Credit https://github.com/twbs/bootstrap/blob/488fd8afc535ca3a6ad4dc581f5e89217b6a36ac/js/src/util/scrollbar.js#L14-L18
function getScrollbarSize(doc) {
  // https://developer.mozilla.org/en-US/docs/Web/API/Window/innerWidth#usage_notes
  const documentWidth = doc.documentElement.clientWidth;
  return Math.abs(window.innerWidth - documentWidth);
}

// Source from https://github.com/alitaheri/normalize-scroll-left
let cachedType;
/**
 * Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
 *
 * Types of scrollLeft, assuming scrollWidth=100 and direction is rtl.
 *
 * Type             | <- Most Left | Most Right -> | Initial
 * ---------------- | ------------ | ------------- | -------
 * default          | 0            | 100           | 100
 * negative (spec*) | -100         | 0             | 0
 * reverse          | 100          | 0             | 0
 *
 * Edge 85: default
 * Safari 14: negative
 * Chrome 85: negative
 * Firefox 81: negative
 * IE11: reverse
 *
 * spec* https://drafts.csswg.org/cssom-view/#dom-window-scroll
 */

function detectScrollType() {
  if (cachedType) {
    return cachedType;
  }

  const dummy = document.createElement('div');
  const container = document.createElement('div');
  container.style.width = '10px';
  container.style.height = '1px';
  dummy.appendChild(container);
  dummy.dir = 'rtl';
  dummy.style.fontSize = '14px';
  dummy.style.width = '4px';
  dummy.style.height = '1px';
  dummy.style.position = 'absolute';
  dummy.style.top = '-1000px';
  dummy.style.overflow = 'scroll';
  document.body.appendChild(dummy);
  cachedType = 'reverse';

  if (dummy.scrollLeft > 0) {
    cachedType = 'default';
  } else {
    dummy.scrollLeft = 1;

    if (dummy.scrollLeft === 0) {
      cachedType = 'negative';
    }
  }

  document.body.removeChild(dummy);
  return cachedType;
} // Based on https://stackoverflow.com/a/24394376

function getNormalizedScrollLeft(element, direction) {
  const scrollLeft = element.scrollLeft; // Perform the calculations only when direction is rtl to avoid messing up the ltr behavior

  if (direction !== 'rtl') {
    return scrollLeft;
  }

  const type = detectScrollType();

  switch (type) {
    case 'negative':
      return element.scrollWidth - element.clientWidth + scrollLeft;

    case 'reverse':
      return element.scrollWidth - element.clientWidth - scrollLeft;

    default:
      return scrollLeft;
  }
}

const usePreviousProps = value => {
  const ref = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef({});
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

var usePreviousProps$1 = usePreviousProps;

const visuallyHidden = {
  border: 0,
  clip: 'rect(0 0 0 0)',
  height: '1px',
  margin: -1,
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: '1px'
};
var visuallyHidden$1 = visuallyHidden;

function validatorNoop() {
  return null;
}
validatorNoop.isRequired = validatorNoop;
var integerPropType = validatorNoop ;

var esm = /*#__PURE__*/Object.freeze({
	__proto__: null,
	chainPropTypes: chainPropTypes,
	deepmerge: deepmerge$2,
	elementAcceptingRef: elementAcceptingRef$1,
	elementTypeAcceptingRef: elementTypeAcceptingRef,
	exactProp: exactProp,
	formatMuiErrorMessage: formatMuiErrorMessage,
	getDisplayName: getDisplayName,
	HTMLElementType: HTMLElementType,
	ponyfillGlobal: ponyfillGlobal,
	refType: refType$1,
	unstable_capitalize: capitalize$2,
	unstable_createChainedFunction: createChainedFunction,
	unstable_debounce: debounce$1,
	unstable_deprecatedPropType: deprecatedPropType,
	unstable_isMuiElement: isMuiElement,
	unstable_ownerDocument: ownerDocument,
	unstable_ownerWindow: ownerWindow,
	unstable_requirePropFactory: requirePropFactory,
	unstable_setRef: setRef,
	unstable_useEnhancedEffect: useEnhancedEffect$1,
	unstable_useId: useId,
	unstable_unsupportedProp: unsupportedProp,
	unstable_useControlled: useControlled,
	unstable_useEventCallback: useEventCallback$1,
	unstable_useForkRef: useForkRef,
	unstable_useIsFocusVisible: useIsFocusVisible,
	unstable_getScrollbarSize: getScrollbarSize,
	unstable_detectScrollType: detectScrollType,
	unstable_getNormalizedScrollLeft: getNormalizedScrollLeft,
	usePreviousProps: usePreviousProps$1,
	visuallyHidden: visuallyHidden$1,
	integerPropType: integerPropType
});

var require$$4 = /*@__PURE__*/getAugmentedNamespace(esm);

Object.defineProperty(colorManipulator, "__esModule", {
  value: true
});
colorManipulator.hexToRgb = hexToRgb$1;
colorManipulator.decomposeColor = decomposeColor$1;
colorManipulator.recomposeColor = recomposeColor$1;
colorManipulator.rgbToHex = rgbToHex;
colorManipulator.hslToRgb = hslToRgb$1;
colorManipulator.getLuminance = getLuminance$1;
colorManipulator.getContrastRatio = getContrastRatio$1;
var alpha_1 = colorManipulator.alpha = alpha$1;
colorManipulator.darken = darken$1;
colorManipulator.lighten = lighten$1;
colorManipulator.emphasize = emphasize;

var _utils = require$$4;

/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp$1(value, min = 0, max = 1) {

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb$1(color) {
  color = color.substr(1);
  const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
  let colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(n => n + n);
  }

  return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index) => {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', ')})` : '';
}

function intToHex(int) {
  const hex = int.toString(16);
  return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */


function decomposeColor$1(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor$1(hexToRgb$1(color));
  }

  const marker = color.indexOf('(');
  const type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla', 'color'].indexOf(type) === -1) {
    throw new Error((0, _utils.formatMuiErrorMessage)(9, color));
  }

  let values = color.substring(marker + 1, color.length - 1);
  let colorSpace;

  if (type === 'color') {
    values = values.split(' ');
    colorSpace = values.shift();

    if (values.length === 4 && values[3].charAt(0) === '/') {
      values[3] = values[3].substr(1);
    }

    if (['srgb', 'display-p3', 'a98-rgb', 'prophoto-rgb', 'rec-2020'].indexOf(colorSpace) === -1) {
      throw new Error((0, _utils.formatMuiErrorMessage)(10, colorSpace));
    }
  } else {
    values = values.split(',');
  }

  values = values.map(value => parseFloat(value));
  return {
    type,
    values,
    colorSpace
  };
}
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */


function recomposeColor$1(color) {
  const {
    type,
    colorSpace
  } = color;
  let {
    values
  } = color;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i) => i < 3 ? parseInt(n, 10) : n);
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = `${values[1]}%`;
    values[2] = `${values[2]}%`;
  }

  if (type.indexOf('color') !== -1) {
    values = `${colorSpace} ${values.join(' ')}`;
  } else {
    values = `${values.join(', ')}`;
  }

  return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */


function rgbToHex(color) {
  // Idempotent
  if (color.indexOf('#') === 0) {
    return color;
  }

  const {
    values
  } = decomposeColor$1(color);
  return `#${values.map((n, i) => intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */


function hslToRgb$1(color) {
  color = decomposeColor$1(color);
  const {
    values
  } = color;
  const h = values[0];
  const s = values[1] / 100;
  const l = values[2] / 100;
  const a = s * Math.min(l, 1 - l);

  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);

  let type = 'rgb';
  const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor$1({
    type,
    values: rgb
  });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */


function getLuminance$1(color) {
  color = decomposeColor$1(color);
  let rgb = color.type === 'hsl' ? decomposeColor$1(hslToRgb$1(color)).values : color.values;
  rgb = rgb.map(val => {
    if (color.type !== 'color') {
      val /= 255; // normalized
    }

    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */


function getContrastRatio$1(foreground, background) {
  const lumA = getLuminance$1(foreground);
  const lumB = getLuminance$1(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function alpha$1(color, value) {
  color = decomposeColor$1(color);
  value = clamp$1(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  if (color.type === 'color') {
    color.values[3] = `/${value}`;
  } else {
    color.values[3] = value;
  }

  return recomposeColor$1(color);
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function darken$1(color, coefficient) {
  color = decomposeColor$1(color);
  coefficient = clamp$1(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor$1(color);
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function lighten$1(color, coefficient) {
  color = decomposeColor$1(color);
  coefficient = clamp$1(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  } else if (color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (1 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor$1(color);
}
/**
 * Darken or lighten a color, depending on its luminance.
 * Light colors are darkened, dark colors are lightened.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */


function emphasize(color, coefficient = 0.15) {
  return getLuminance$1(color) > 0.5 ? darken$1(color, coefficient) : lighten$1(color, coefficient);
}

function _extends$a() {
  _extends$a = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$a.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$6(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function toVal(mix) {
	var k, y, str='';

	if (typeof mix === 'string' || typeof mix === 'number') {
		str += mix;
	} else if (typeof mix === 'object') {
		if (Array.isArray(mix)) {
			for (k=0; k < mix.length; k++) {
				if (mix[k]) {
					if (y = toVal(mix[k])) {
						str && (str += ' ');
						str += y;
					}
				}
			}
		} else {
			for (k in mix) {
				if (mix[k]) {
					str && (str += ' ');
					str += k;
				}
			}
		}
	}

	return str;
}

function clsx () {
	var i=0, tmp, x, str='';
	while (i < arguments.length) {
		if (tmp = arguments[i++]) {
			if (x = toVal(tmp)) {
				str && (str += ' ');
				str += x;
			}
		}
	}
	return str;
}

function _extends$9() {
  _extends$9 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$9.apply(this, arguments);
}

function _objectWithoutPropertiesLoose$5(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function composeClasses(slots, getUtilityClass, classes) {
  const output = {};
  Object.keys(slots).forEach( // `Objet.keys(slots)` can't be wider than `T` because we infer `T` from `slots`.
  // @ts-expect-error https://github.com/microsoft/TypeScript/pull/12253#issuecomment-263132208
  slot => {
    output[slot] = slots[slot].reduce((acc, key) => {
      if (key) {
        if (classes && classes[key]) {
          acc.push(classes[key]);
        }

        acc.push(getUtilityClass(key));
      }

      return acc;
    }, []).join(' ');
  });
  return output;
}

/**
 * Determines if a given element is a DOM element name (i.e. not a React component).
 */
function isHostComponent(element) {
  return typeof element === 'string';
}

const globalStateClassesMapping = {
  active: 'Mui-active',
  checked: 'Mui-checked',
  completed: 'Mui-completed',
  disabled: 'Mui-disabled',
  error: 'Mui-error',
  expanded: 'Mui-expanded',
  focused: 'Mui-focused',
  focusVisible: 'Mui-focusVisible',
  required: 'Mui-required',
  selected: 'Mui-selected'
};
function generateUtilityClass(componentName, slot) {
  const globalStateClass = globalStateClassesMapping[slot];
  return globalStateClass || `${componentName}-${slot}`;
}

function generateUtilityClasses(componentName, slots) {
  const result = {};
  slots.forEach(slot => {
    result[slot] = generateUtilityClass(componentName, slot);
  });
  return result;
}

function getBackdropUtilityClass(slot) {
  return generateUtilityClass('MuiBackdrop', slot);
}
generateUtilityClasses('MuiBackdrop', ['root', 'invisible']);

var jsxRuntime = {exports: {}};

var reactJsxRuntime_production_min = {};

/** @license React v17.0.1
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var f$2=_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports,g$2=60103;reactJsxRuntime_production_min.Fragment=60107;if("function"===typeof Symbol&&Symbol.for){var h$2=Symbol.for;g$2=h$2("react.element");reactJsxRuntime_production_min.Fragment=h$2("react.fragment");}var m$2=f$2.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner,n$1=Object.prototype.hasOwnProperty,p$2={key:!0,ref:!0,__self:!0,__source:!0};
function q$2(c,a,k){var b,d={},e=null,l=null;void 0!==k&&(e=""+k);void 0!==a.key&&(e=""+a.key);void 0!==a.ref&&(l=a.ref);for(b in a)n$1.call(a,b)&&!p$2.hasOwnProperty(b)&&(d[b]=a[b]);if(c&&c.defaultProps)for(b in a=c.defaultProps,a)void 0===d[b]&&(d[b]=a[b]);return {$$typeof:g$2,type:c,key:e,ref:l,props:d,_owner:m$2.current}}reactJsxRuntime_production_min.jsx=q$2;reactJsxRuntime_production_min.jsxs=q$2;

{
  jsxRuntime.exports = reactJsxRuntime_production_min;
}

const _excluded$18 = ["classes", "className", "invisible", "component", "components", "componentsProps", "theme"];

const useUtilityClasses$P = ownerState => {
  const {
    classes,
    invisible
  } = ownerState;
  const slots = {
    root: ['root', invisible && 'invisible']
  };
  return composeClasses(slots, getBackdropUtilityClass, classes);
};

const BackdropUnstyled = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function BackdropUnstyled(props, ref) {
  const {
    classes: classesProp,
    className,
    invisible = false,
    component = 'div',
    components = {},
    componentsProps = {},

    /* eslint-disable react/prop-types */
    theme
  } = props,
        other = _objectWithoutPropertiesLoose$5(props, _excluded$18);

  const ownerState = _extends$9({}, props, {
    classes: classesProp,
    invisible
  });

  const classes = useUtilityClasses$P(ownerState);
  const Root = components.Root || component;
  const rootProps = componentsProps.root || {};
  return /*#__PURE__*/jsxRuntime.exports.jsx(Root, _extends$9({
    "aria-hidden": true
  }, rootProps, !isHostComponent(Root) && {
    as: component,
    ownerState: _extends$9({}, ownerState, rootProps.ownerState),
    theme
  }, {
    ref: ref
  }, other, {
    className: clsx(classes.root, rootProps.className, className)
  }));
});
var BackdropUnstyled$1 = BackdropUnstyled;

/**
 * Appends the ownerState object to the props, merging with the existing one if necessary.
 *
 * @param elementType Type of the element that owns the `existingProps`. If the element is a DOM node, `ownerState` are not applied.
 * @param existingProps Props of the element.
 * @param ownerState
 */

function appendOwnerState(elementType, existingProps, ownerState) {
  if (isHostComponent(elementType)) {
    return existingProps;
  }

  return _extends$9({}, existingProps, {
    ownerState: _extends$9({}, existingProps.ownerState, ownerState)
  });
}

function getContainer$1(container) {
  return typeof container === 'function' ? container() : container;
}
/**
 * Portals provide a first-class way to render children into a DOM node
 * that exists outside the DOM hierarchy of the parent component.
 */


const Portal = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Portal(props, ref) {
  const {
    children,
    container,
    disablePortal = false
  } = props;
  const [mountNode, setMountNode] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(null);
  const handleRef = useForkRef( /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.isValidElement(children) ? children.ref : null, ref);
  useEnhancedEffect$1(() => {
    if (!disablePortal) {
      setMountNode(getContainer$1(container) || document.body);
    }
  }, [container, disablePortal]);
  useEnhancedEffect$1(() => {
    if (mountNode && !disablePortal) {
      setRef(ref, mountNode);
      return () => {
        setRef(ref, null);
      };
    }

    return undefined;
  }, [ref, mountNode, disablePortal]);

  if (disablePortal) {
    if ( /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.isValidElement(children)) {
      return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(children, {
        ref: handleRef
      });
    }

    return children;
  }

  return mountNode ? /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.h.exports.createPortal(children, mountNode) : mountNode;
});

var Portal$1 = Portal;

// Is a vertical scrollbar displayed?
function isOverflowing(container) {
  const doc = ownerDocument(container);

  if (doc.body === container) {
    return ownerWindow(container).innerWidth > doc.documentElement.clientWidth;
  }

  return container.scrollHeight > container.clientHeight;
}

function ariaHidden(element, show) {
  if (show) {
    element.setAttribute('aria-hidden', 'true');
  } else {
    element.removeAttribute('aria-hidden');
  }
}

function getPaddingRight(element) {
  return parseInt(ownerWindow(element).getComputedStyle(element).paddingRight, 10) || 0;
}

function ariaHiddenSiblings(container, mountElement, currentElement, elementsToExclude = [], show) {
  const blacklist = [mountElement, currentElement, ...elementsToExclude];
  const blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
  [].forEach.call(container.children, element => {
    if (blacklist.indexOf(element) === -1 && blacklistTagNames.indexOf(element.tagName) === -1) {
      ariaHidden(element, show);
    }
  });
}

function findIndexOf(items, callback) {
  let idx = -1;
  items.some((item, index) => {
    if (callback(item)) {
      idx = index;
      return true;
    }

    return false;
  });
  return idx;
}

function handleContainer(containerInfo, props) {
  const restoreStyle = [];
  const container = containerInfo.container;

  if (!props.disableScrollLock) {
    if (isOverflowing(container)) {
      // Compute the size before applying overflow hidden to avoid any scroll jumps.
      const scrollbarSize = getScrollbarSize(ownerDocument(container));
      restoreStyle.push({
        value: container.style.paddingRight,
        property: 'padding-right',
        el: container
      }); // Use computed style, here to get the real padding to add our scrollbar width.

      container.style.paddingRight = `${getPaddingRight(container) + scrollbarSize}px`; // .mui-fixed is a global helper.

      const fixedElements = ownerDocument(container).querySelectorAll('.mui-fixed');
      [].forEach.call(fixedElements, element => {
        restoreStyle.push({
          value: element.style.paddingRight,
          property: 'padding-right',
          el: element
        });
        element.style.paddingRight = `${getPaddingRight(element) + scrollbarSize}px`;
      });
    } // Improve Gatsby support
    // https://css-tricks.com/snippets/css/force-vertical-scrollbar/


    const parent = container.parentElement;
    const containerWindow = ownerWindow(container);
    const scrollContainer = (parent == null ? void 0 : parent.nodeName) === 'HTML' && containerWindow.getComputedStyle(parent).overflowY === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
    // screensize shrink.

    restoreStyle.push({
      value: scrollContainer.style.overflow,
      property: 'overflow',
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowX,
      property: 'overflow-x',
      el: scrollContainer
    }, {
      value: scrollContainer.style.overflowY,
      property: 'overflow-y',
      el: scrollContainer
    });
    scrollContainer.style.overflow = 'hidden';
  }

  const restore = () => {
    restoreStyle.forEach(({
      value,
      el,
      property
    }) => {
      if (value) {
        el.style.setProperty(property, value);
      } else {
        el.style.removeProperty(property);
      }
    });
  };

  return restore;
}

function getHiddenSiblings(container) {
  const hiddenSiblings = [];
  [].forEach.call(container.children, element => {
    if (element.getAttribute('aria-hidden') === 'true') {
      hiddenSiblings.push(element);
    }
  });
  return hiddenSiblings;
}

/**
 * @ignore - do not document.
 *
 * Proper state management for containers and the modals in those containers.
 * Simplified, but inspired by react-overlay's ModalManager class.
 * Used by the Modal to ensure proper styling of containers.
 */
class ModalManager {
  constructor() {
    this.containers = void 0;
    this.modals = void 0;
    this.modals = [];
    this.containers = [];
  }

  add(modal, container) {
    let modalIndex = this.modals.indexOf(modal);

    if (modalIndex !== -1) {
      return modalIndex;
    }

    modalIndex = this.modals.length;
    this.modals.push(modal); // If the modal we are adding is already in the DOM.

    if (modal.modalRef) {
      ariaHidden(modal.modalRef, false);
    }

    const hiddenSiblings = getHiddenSiblings(container);
    ariaHiddenSiblings(container, modal.mount, modal.modalRef, hiddenSiblings, true);
    const containerIndex = findIndexOf(this.containers, item => item.container === container);

    if (containerIndex !== -1) {
      this.containers[containerIndex].modals.push(modal);
      return modalIndex;
    }

    this.containers.push({
      modals: [modal],
      container,
      restore: null,
      hiddenSiblings
    });
    return modalIndex;
  }

  mount(modal, props) {
    const containerIndex = findIndexOf(this.containers, item => item.modals.indexOf(modal) !== -1);
    const containerInfo = this.containers[containerIndex];

    if (!containerInfo.restore) {
      containerInfo.restore = handleContainer(containerInfo, props);
    }
  }

  remove(modal) {
    const modalIndex = this.modals.indexOf(modal);

    if (modalIndex === -1) {
      return modalIndex;
    }

    const containerIndex = findIndexOf(this.containers, item => item.modals.indexOf(modal) !== -1);
    const containerInfo = this.containers[containerIndex];
    containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
    this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.

    if (containerInfo.modals.length === 0) {
      // The modal might be closed before it had the chance to be mounted in the DOM.
      if (containerInfo.restore) {
        containerInfo.restore();
      }

      if (modal.modalRef) {
        // In case the modal wasn't in the DOM yet.
        ariaHidden(modal.modalRef, true);
      }

      ariaHiddenSiblings(containerInfo.container, modal.mount, modal.modalRef, containerInfo.hiddenSiblings, false);
      this.containers.splice(containerIndex, 1);
    } else {
      // Otherwise make sure the next top modal is visible to a screen reader.
      const nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
      // aria-hidden because the dom element doesn't exist either
      // when modal was unmounted before modalRef gets null

      if (nextTop.modalRef) {
        ariaHidden(nextTop.modalRef, false);
      }
    }

    return modalIndex;
  }

  isTopModal(modal) {
    return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
  }

}

/* eslint-disable @typescript-eslint/naming-convention, consistent-return, jsx-a11y/no-noninteractive-tabindex */
const candidatesSelector = ['input', 'select', 'textarea', 'a[href]', 'button', '[tabindex]', 'audio[controls]', 'video[controls]', '[contenteditable]:not([contenteditable="false"])'].join(',');

function getTabIndex(node) {
  const tabindexAttr = parseInt(node.getAttribute('tabindex'), 10);

  if (!Number.isNaN(tabindexAttr)) {
    return tabindexAttr;
  } // Browsers do not return `tabIndex` correctly for contentEditable nodes;
  // https://bugs.chromium.org/p/chromium/issues/detail?id=661108&q=contenteditable%20tabindex&can=2
  // so if they don't have a tabindex attribute specifically set, assume it's 0.
  // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
  //  `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
  //  yet they are still part of the regular tab order; in FF, they get a default
  //  `tabIndex` of 0; since Chrome still puts those elements in the regular tab
  //  order, consider their tab index to be 0.


  if (node.contentEditable === 'true' || (node.nodeName === 'AUDIO' || node.nodeName === 'VIDEO' || node.nodeName === 'DETAILS') && node.getAttribute('tabindex') === null) {
    return 0;
  }

  return node.tabIndex;
}

function isNonTabbableRadio(node) {
  if (node.tagName !== 'INPUT' || node.type !== 'radio') {
    return false;
  }

  if (!node.name) {
    return false;
  }

  const getRadio = selector => node.ownerDocument.querySelector(`input[type="radio"]${selector}`);

  let roving = getRadio(`[name="${node.name}"]:checked`);

  if (!roving) {
    roving = getRadio(`[name="${node.name}"]`);
  }

  return roving !== node;
}

function isNodeMatchingSelectorFocusable(node) {
  if (node.disabled || node.tagName === 'INPUT' && node.type === 'hidden' || isNonTabbableRadio(node)) {
    return false;
  }

  return true;
}

function defaultGetTabbable(root) {
  const regularTabNodes = [];
  const orderedTabNodes = [];
  Array.from(root.querySelectorAll(candidatesSelector)).forEach((node, i) => {
    const nodeTabIndex = getTabIndex(node);

    if (nodeTabIndex === -1 || !isNodeMatchingSelectorFocusable(node)) {
      return;
    }

    if (nodeTabIndex === 0) {
      regularTabNodes.push(node);
    } else {
      orderedTabNodes.push({
        documentOrder: i,
        tabIndex: nodeTabIndex,
        node
      });
    }
  });
  return orderedTabNodes.sort((a, b) => a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex).map(a => a.node).concat(regularTabNodes);
}

function defaultIsEnabled() {
  return true;
}
/**
 * Utility component that locks focus inside the component.
 */


function Unstable_TrapFocus(props) {
  const {
    children,
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableRestoreFocus = false,
    getTabbable = defaultGetTabbable,
    isEnabled = defaultIsEnabled,
    open
  } = props;
  const ignoreNextEnforceFocus = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();
  const sentinelStart = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const sentinelEnd = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const nodeToRestore = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const reactFocusEventTarget = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null); // This variable is useful when disableAutoFocus is true.
  // It waits for the active element to move into the component to activate.

  const activated = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(false);
  const rootRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const handleRef = useForkRef(children.ref, rootRef);
  const lastKeydown = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }

    activated.current = !disableAutoFocus;
  }, [disableAutoFocus, open]);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }

    const doc = ownerDocument(rootRef.current);

    if (!rootRef.current.contains(doc.activeElement)) {
      if (!rootRef.current.hasAttribute('tabIndex')) {

        rootRef.current.setAttribute('tabIndex', -1);
      }

      if (activated.current) {
        rootRef.current.focus();
      }
    }

    return () => {
      // restoreLastFocus()
      if (!disableRestoreFocus) {
        // In IE11 it is possible for document.activeElement to be null resulting
        // in nodeToRestore.current being null.
        // Not all elements in IE11 have a focus method.
        // Once IE11 support is dropped the focus() call can be unconditional.
        if (nodeToRestore.current && nodeToRestore.current.focus) {
          ignoreNextEnforceFocus.current = true;
          nodeToRestore.current.focus();
        }

        nodeToRestore.current = null;
      }
    }; // Missing `disableRestoreFocus` which is fine.
    // We don't support changing that prop on an open TrapFocus
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    // We might render an empty child.
    if (!open || !rootRef.current) {
      return;
    }

    const doc = ownerDocument(rootRef.current);

    const contain = nativeEvent => {
      const {
        current: rootElement
      } = rootRef; // Cleanup functions are executed lazily in React 17.
      // Contain can be called between the component being unmounted and its cleanup function being run.

      if (rootElement === null) {
        return;
      }

      if (!doc.hasFocus() || disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
        ignoreNextEnforceFocus.current = false;
        return;
      }

      if (!rootElement.contains(doc.activeElement)) {
        // if the focus event is not coming from inside the children's react tree, reset the refs
        if (nativeEvent && reactFocusEventTarget.current !== nativeEvent.target || doc.activeElement !== reactFocusEventTarget.current) {
          reactFocusEventTarget.current = null;
        } else if (reactFocusEventTarget.current !== null) {
          return;
        }

        if (!activated.current) {
          return;
        }

        let tabbable = [];

        if (doc.activeElement === sentinelStart.current || doc.activeElement === sentinelEnd.current) {
          tabbable = getTabbable(rootRef.current);
        }

        if (tabbable.length > 0) {
          var _lastKeydown$current, _lastKeydown$current2;

          const isShiftTab = Boolean(((_lastKeydown$current = lastKeydown.current) == null ? void 0 : _lastKeydown$current.shiftKey) && ((_lastKeydown$current2 = lastKeydown.current) == null ? void 0 : _lastKeydown$current2.key) === 'Tab');
          const focusNext = tabbable[0];
          const focusPrevious = tabbable[tabbable.length - 1];

          if (isShiftTab) {
            focusPrevious.focus();
          } else {
            focusNext.focus();
          }
        } else {
          rootElement.focus();
        }
      }
    };

    const loopFocus = nativeEvent => {
      lastKeydown.current = nativeEvent;

      if (disableEnforceFocus || !isEnabled() || nativeEvent.key !== 'Tab') {
        return;
      } // Make sure the next tab starts from the right place.
      // doc.activeElement referes to the origin.


      if (doc.activeElement === rootRef.current && nativeEvent.shiftKey) {
        // We need to ignore the next contain as
        // it will try to move the focus back to the rootRef element.
        ignoreNextEnforceFocus.current = true;
        sentinelEnd.current.focus();
      }
    };

    doc.addEventListener('focusin', contain);
    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area.
    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
    // Instead, we can look if the active element was restored on the BODY element.
    //
    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.

    const interval = setInterval(() => {
      if (doc.activeElement.tagName === 'BODY') {
        contain();
      }
    }, 50);
    return () => {
      clearInterval(interval);
      doc.removeEventListener('focusin', contain);
      doc.removeEventListener('keydown', loopFocus, true);
    };
  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open, getTabbable]);

  const onFocus = event => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }

    activated.current = true;
    reactFocusEventTarget.current = event.target;
    const childrenPropsHandler = children.props.onFocus;

    if (childrenPropsHandler) {
      childrenPropsHandler(event);
    }
  };

  const handleFocusSentinel = event => {
    if (nodeToRestore.current === null) {
      nodeToRestore.current = event.relatedTarget;
    }

    activated.current = true;
  };

  return /*#__PURE__*/jsxRuntime.exports.jsxs(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.exports.jsx("div", {
      tabIndex: 0,
      onFocus: handleFocusSentinel,
      ref: sentinelStart,
      "data-test": "sentinelStart"
    }), /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(children, {
      ref: handleRef,
      onFocus
    }), /*#__PURE__*/jsxRuntime.exports.jsx("div", {
      tabIndex: 0,
      onFocus: handleFocusSentinel,
      ref: sentinelEnd,
      "data-test": "sentinelEnd"
    })]
  });
}

function getModalUtilityClass(slot) {
  return generateUtilityClass('MuiModal', slot);
}
generateUtilityClasses('MuiModal', ['root', 'hidden']);

const _excluded$17 = ["BackdropComponent", "BackdropProps", "children", "classes", "className", "closeAfterTransition", "component", "components", "componentsProps", "container", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onKeyDown", "open", "theme", "onTransitionEnter", "onTransitionExited"];

const useUtilityClasses$O = ownerState => {
  const {
    open,
    exited,
    classes
  } = ownerState;
  const slots = {
    root: ['root', !open && exited && 'hidden']
  };
  return composeClasses(slots, getModalUtilityClass, classes);
};

function getContainer(container) {
  return typeof container === 'function' ? container() : container;
}

function getHasTransition(props) {
  return props.children ? props.children.props.hasOwnProperty('in') : false;
} // A modal manager used to track and manage the state of open Modals.
// Modals don't open on the server so this won't conflict with concurrent requests.


const defaultManager = new ModalManager();
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */

const ModalUnstyled = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function ModalUnstyled(props, ref) {
  const {
    BackdropComponent,
    BackdropProps,
    children,
    classes: classesProp,
    className,
    closeAfterTransition = false,
    component = 'div',
    components = {},
    componentsProps = {},
    container,
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableEscapeKeyDown = false,
    disablePortal = false,
    disableRestoreFocus = false,
    disableScrollLock = false,
    hideBackdrop = false,
    keepMounted = false,
    // private
    // eslint-disable-next-line react/prop-types
    manager = defaultManager,
    onBackdropClick,
    onClose,
    onKeyDown,
    open,

    /* eslint-disable react/prop-types */
    theme,
    onTransitionEnter,
    onTransitionExited
  } = props,
        other = _objectWithoutPropertiesLoose$5(props, _excluded$17);

  const [exited, setExited] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(true);
  const modal = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef({});
  const mountNodeRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const modalRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const handleRef = useForkRef(modalRef, ref);
  const hasTransition = getHasTransition(props);

  const getDoc = () => ownerDocument(mountNodeRef.current);

  const getModal = () => {
    modal.current.modalRef = modalRef.current;
    modal.current.mountNode = mountNodeRef.current;
    return modal.current;
  };

  const handleMounted = () => {
    manager.mount(getModal(), {
      disableScrollLock
    }); // Fix a bug on Chrome where the scroll isn't initially 0.

    modalRef.current.scrollTop = 0;
  };

  const handleOpen = useEventCallback$1(() => {
    const resolvedContainer = getContainer(container) || getDoc().body;
    manager.add(getModal(), resolvedContainer); // The element was already mounted.

    if (modalRef.current) {
      handleMounted();
    }
  });
  const isTopModal = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => manager.isTopModal(getModal()), [manager]);
  const handlePortalRef = useEventCallback$1(node => {
    mountNodeRef.current = node;

    if (!node) {
      return;
    }

    if (open && isTopModal()) {
      handleMounted();
    } else {
      ariaHidden(modalRef.current, true);
    }
  });
  const handleClose = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
    manager.remove(getModal());
  }, [manager]);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    return () => {
      handleClose();
    };
  }, [handleClose]);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    if (open) {
      handleOpen();
    } else if (!hasTransition || !closeAfterTransition) {
      handleClose();
    }
  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);

  const ownerState = _extends$9({}, props, {
    classes: classesProp,
    closeAfterTransition,
    disableAutoFocus,
    disableEnforceFocus,
    disableEscapeKeyDown,
    disablePortal,
    disableRestoreFocus,
    disableScrollLock,
    exited,
    hideBackdrop,
    keepMounted
  });

  const classes = useUtilityClasses$O(ownerState);

  if (!keepMounted && !open && (!hasTransition || exited)) {
    return null;
  }

  const handleEnter = () => {
    setExited(false);

    if (onTransitionEnter) {
      onTransitionEnter();
    }
  };

  const handleExited = () => {
    setExited(true);

    if (onTransitionExited) {
      onTransitionExited();
    }

    if (closeAfterTransition) {
      handleClose();
    }
  };

  const handleBackdropClick = event => {
    if (event.target !== event.currentTarget) {
      return;
    }

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (onClose) {
      onClose(event, 'backdropClick');
    }
  };

  const handleKeyDown = event => {
    if (onKeyDown) {
      onKeyDown(event);
    } // The handler doesn't take event.defaultPrevented into account:
    //
    // event.preventDefault() is meant to stop default behaviors like
    // clicking a checkbox to check it, hitting a button to submit a form,
    // and hitting left arrow to move the cursor in a text input etc.
    // Only special HTML elements have these default behaviors.


    if (event.key !== 'Escape' || !isTopModal()) {
      return;
    }

    if (!disableEscapeKeyDown) {
      // Swallow the event, in case someone is listening for the escape key on the body.
      event.stopPropagation();

      if (onClose) {
        onClose(event, 'escapeKeyDown');
      }
    }
  };

  const childProps = {};

  if (children.props.tabIndex === undefined) {
    childProps.tabIndex = '-1';
  } // It's a Transition like component


  if (hasTransition) {
    childProps.onEnter = createChainedFunction(handleEnter, children.props.onEnter);
    childProps.onExited = createChainedFunction(handleExited, children.props.onExited);
  }

  const Root = components.Root || component;
  const rootProps = componentsProps.root || {};
  return /*#__PURE__*/jsxRuntime.exports.jsx(Portal$1, {
    ref: handlePortalRef,
    container: container,
    disablePortal: disablePortal,
    children: /*#__PURE__*/jsxRuntime.exports.jsxs(Root, _extends$9({
      role: "presentation"
    }, rootProps, !isHostComponent(Root) && {
      as: component,
      ownerState: _extends$9({}, ownerState, rootProps.ownerState),
      theme
    }, other, {
      ref: handleRef,
      onKeyDown: handleKeyDown,
      className: clsx(classes.root, rootProps.className, className),
      children: [!hideBackdrop && BackdropComponent ? /*#__PURE__*/jsxRuntime.exports.jsx(BackdropComponent, _extends$9({
        open: open,
        onClick: handleBackdropClick
      }, BackdropProps)) : null, /*#__PURE__*/jsxRuntime.exports.jsx(Unstable_TrapFocus, {
        disableEnforceFocus: disableEnforceFocus,
        disableAutoFocus: disableAutoFocus,
        disableRestoreFocus: disableRestoreFocus,
        isEnabled: isTopModal,
        open: open,
        children: /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(children, childProps)
      })]
    }))
  });
});
var ModalUnstyled$1 = ModalUnstyled;

function _extends$8() {
  _extends$8 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$8.apply(this, arguments);
}

function memoize$4(fn) {
  var cache = Object.create(null);
  return function (arg) {
    if (cache[arg] === undefined) cache[arg] = fn(arg);
    return cache[arg];
  };
}

var reactPropsRegex = /^((children|dangerouslySetInnerHTML|key|ref|autoFocus|defaultValue|defaultChecked|innerHTML|suppressContentEditableWarning|suppressHydrationWarning|valueLink|accept|acceptCharset|accessKey|action|allow|allowUserMedia|allowPaymentRequest|allowFullScreen|allowTransparency|alt|async|autoComplete|autoPlay|capture|cellPadding|cellSpacing|challenge|charSet|checked|cite|classID|className|cols|colSpan|content|contentEditable|contextMenu|controls|controlsList|coords|crossOrigin|data|dateTime|decoding|default|defer|dir|disabled|disablePictureInPicture|download|draggable|encType|form|formAction|formEncType|formMethod|formNoValidate|formTarget|frameBorder|headers|height|hidden|high|href|hrefLang|htmlFor|httpEquiv|id|inputMode|integrity|is|keyParams|keyType|kind|label|lang|list|loading|loop|low|marginHeight|marginWidth|max|maxLength|media|mediaGroup|method|min|minLength|multiple|muted|name|nonce|noValidate|open|optimum|pattern|placeholder|playsInline|poster|preload|profile|radioGroup|readOnly|referrerPolicy|rel|required|reversed|role|rows|rowSpan|sandbox|scope|scoped|scrolling|seamless|selected|shape|size|sizes|slot|span|spellCheck|src|srcDoc|srcLang|srcSet|start|step|style|summary|tabIndex|target|title|translate|type|useMap|value|width|wmode|wrap|about|datatype|inlist|prefix|property|resource|typeof|vocab|autoCapitalize|autoCorrect|autoSave|color|fallback|inert|itemProp|itemScope|itemType|itemID|itemRef|on|option|results|security|unselectable|accentHeight|accumulate|additive|alignmentBaseline|allowReorder|alphabetic|amplitude|arabicForm|ascent|attributeName|attributeType|autoReverse|azimuth|baseFrequency|baselineShift|baseProfile|bbox|begin|bias|by|calcMode|capHeight|clip|clipPathUnits|clipPath|clipRule|colorInterpolation|colorInterpolationFilters|colorProfile|colorRendering|contentScriptType|contentStyleType|cursor|cx|cy|d|decelerate|descent|diffuseConstant|direction|display|divisor|dominantBaseline|dur|dx|dy|edgeMode|elevation|enableBackground|end|exponent|externalResourcesRequired|fill|fillOpacity|fillRule|filter|filterRes|filterUnits|floodColor|floodOpacity|focusable|fontFamily|fontSize|fontSizeAdjust|fontStretch|fontStyle|fontVariant|fontWeight|format|from|fr|fx|fy|g1|g2|glyphName|glyphOrientationHorizontal|glyphOrientationVertical|glyphRef|gradientTransform|gradientUnits|hanging|horizAdvX|horizOriginX|ideographic|imageRendering|in|in2|intercept|k|k1|k2|k3|k4|kernelMatrix|kernelUnitLength|kerning|keyPoints|keySplines|keyTimes|lengthAdjust|letterSpacing|lightingColor|limitingConeAngle|local|markerEnd|markerMid|markerStart|markerHeight|markerUnits|markerWidth|mask|maskContentUnits|maskUnits|mathematical|mode|numOctaves|offset|opacity|operator|order|orient|orientation|origin|overflow|overlinePosition|overlineThickness|panose1|paintOrder|pathLength|patternContentUnits|patternTransform|patternUnits|pointerEvents|points|pointsAtX|pointsAtY|pointsAtZ|preserveAlpha|preserveAspectRatio|primitiveUnits|r|radius|refX|refY|renderingIntent|repeatCount|repeatDur|requiredExtensions|requiredFeatures|restart|result|rotate|rx|ry|scale|seed|shapeRendering|slope|spacing|specularConstant|specularExponent|speed|spreadMethod|startOffset|stdDeviation|stemh|stemv|stitchTiles|stopColor|stopOpacity|strikethroughPosition|strikethroughThickness|string|stroke|strokeDasharray|strokeDashoffset|strokeLinecap|strokeLinejoin|strokeMiterlimit|strokeOpacity|strokeWidth|surfaceScale|systemLanguage|tableValues|targetX|targetY|textAnchor|textDecoration|textRendering|textLength|to|transform|u1|u2|underlinePosition|underlineThickness|unicode|unicodeBidi|unicodeRange|unitsPerEm|vAlphabetic|vHanging|vIdeographic|vMathematical|values|vectorEffect|version|vertAdvY|vertOriginX|vertOriginY|viewBox|viewTarget|visibility|widths|wordSpacing|writingMode|x|xHeight|x1|x2|xChannelSelector|xlinkActuate|xlinkArcrole|xlinkHref|xlinkRole|xlinkShow|xlinkTitle|xlinkType|xmlBase|xmlns|xmlnsXlink|xmlLang|xmlSpace|y|y1|y2|yChannelSelector|z|zoomAndPan|for|class|autofocus)|(([Dd][Aa][Tt][Aa]|[Aa][Rr][Ii][Aa]|x)-.*))$/; // https://esbench.com/bench/5bfee68a4cd7e6009ef61d23

var isPropValid = /* #__PURE__ */memoize$4(function (prop) {
  return reactPropsRegex.test(prop) || prop.charCodeAt(0) === 111
  /* o */
  && prop.charCodeAt(1) === 110
  /* n */
  && prop.charCodeAt(2) < 91;
}
/* Z+1 */
);

var isPropValid$1 = isPropValid;

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag$1(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement$1(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet$1 = /*#__PURE__*/function () {
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        before = _this.prepend ? _this.container.firstChild : _this.before;
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement$1(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag$1(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

var MS = '-ms-';
var MOZ = '-moz-';
var WEBKIT = '-webkit-';

var COMMENT = 'comm';
var RULESET = 'rule';
var DECLARATION = 'decl';
var IMPORT = '@import';
var KEYFRAMES = '@keyframes';

/**
 * @param {number}
 * @return {number}
 */
var abs = Math.abs;

/**
 * @param {number}
 * @return {string}
 */
var from = String.fromCharCode;

/**
 * @param {string} value
 * @param {number} length
 * @return {number}
 */
function hash$2 (value, length) {
	return (((((((length << 2) ^ charat(value, 0)) << 2) ^ charat(value, 1)) << 2) ^ charat(value, 2)) << 2) ^ charat(value, 3)
}

/**
 * @param {string} value
 * @return {string}
 */
function trim$1 (value) {
	return value.trim()
}

/**
 * @param {string} value
 * @param {RegExp} pattern
 * @return {string?}
 */
function match$1 (value, pattern) {
	return (value = pattern.exec(value)) ? value[0] : value
}

/**
 * @param {string} value
 * @param {(string|RegExp)} pattern
 * @param {string} replacement
 * @return {string}
 */
function replace (value, pattern, replacement) {
	return value.replace(pattern, replacement)
}

/**
 * @param {string} value
 * @param {string} value
 * @return {number}
 */
function indexof (value, search) {
	return value.indexOf(search)
}

/**
 * @param {string} value
 * @param {number} index
 * @return {number}
 */
function charat (value, index) {
	return value.charCodeAt(index) | 0
}

/**
 * @param {string} value
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function substr (value, begin, end) {
	return value.slice(begin, end)
}

/**
 * @param {string} value
 * @return {number}
 */
function strlen (value) {
	return value.length
}

/**
 * @param {any[]} value
 * @return {number}
 */
function sizeof (value) {
	return value.length
}

/**
 * @param {any} value
 * @param {any[]} array
 * @return {any}
 */
function append (value, array) {
	return array.push(value), value
}

/**
 * @param {string[]} array
 * @param {function} callback
 * @return {string}
 */
function combine (array, callback) {
	return array.map(callback).join('')
}

var line = 1;
var column = 1;
var length = 0;
var position$1 = 0;
var character = 0;
var characters = '';

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string} type
 * @param {string[]} props
 * @param {object[]} children
 * @param {number} length
 */
function node (value, root, parent, type, props, children, length) {
	return {value: value, root: root, parent: parent, type: type, props: props, children: children, line: line, column: column, length: length, return: ''}
}

/**
 * @param {string} value
 * @param {object} root
 * @param {string} type
 */
function copy$1 (value, root, type) {
	return node(value, root.root, root.parent, type, root.props, root.children, 0)
}

/**
 * @return {number}
 */
function char () {
	return character
}

/**
 * @return {number}
 */
function next () {
	character = position$1 < length ? charat(characters, position$1++) : 0;

	if (column++, character === 10)
		column = 1, line++;

	return character
}

/**
 * @return {number}
 */
function peek () {
	return charat(characters, position$1)
}

/**
 * @return {number}
 */
function caret () {
	return position$1
}

/**
 * @param {number} begin
 * @param {number} end
 * @return {string}
 */
function slice (begin, end) {
	return substr(characters, begin, end)
}

/**
 * @param {number} type
 * @return {number}
 */
function token (type) {
	switch (type) {
		// \0 \t \n \r \s whitespace token
		case 0: case 9: case 10: case 13: case 32:
			return 5
		// ! + , / > @ ~ isolate token
		case 33: case 43: case 44: case 47: case 62: case 64: case 126:
		// ; { } / breakpoint token
		case 59: case 123: case 125:
			return 4
		// : accompanied token
		case 58:
			return 3
		// " ' ( [ opening delimit token
		case 34: case 39: case 40: case 91:
			return 2
		// ) ] closing delimit token
		case 41: case 93:
			return 1
	}

	return 0
}

/**
 * @param {string} value
 * @return {any[]}
 */
function alloc (value) {
	return line = column = 1, length = strlen(characters = value), position$1 = 0, []
}

/**
 * @param {any} value
 * @return {any}
 */
function dealloc (value) {
	return characters = '', value
}

/**
 * @param {number} type
 * @return {string}
 */
function delimit (type) {
	return trim$1(slice(position$1 - 1, delimiter(type === 91 ? type + 2 : type === 40 ? type + 1 : type)))
}

/**
 * @param {number} type
 * @return {string}
 */
function whitespace (type) {
	while (character = peek())
		if (character < 33)
			next();
		else
			break

	return token(type) > 2 || token(character) > 3 ? '' : ' '
}

/**
 * @param {number} type
 * @return {number}
 */
function delimiter (type) {
	while (next())
		switch (character) {
			// ] ) " '
			case type:
				return position$1
			// " '
			case 34: case 39:
				return delimiter(type === 34 || type === 39 ? type : character)
			// (
			case 40:
				if (type === 41)
					delimiter(type);
				break
			// \
			case 92:
				next();
				break
		}

	return position$1
}

/**
 * @param {number} type
 * @param {number} index
 * @return {number}
 */
function commenter (type, index) {
	while (next())
		// //
		if (type + character === 47 + 10)
			break
		// /*
		else if (type + character === 42 + 42 && peek() === 47)
			break

	return '/*' + slice(index, position$1 - 1) + '*' + from(type === 47 ? type : next())
}

/**
 * @param {number} index
 * @return {string}
 */
function identifier (index) {
	while (!token(peek()))
		next();

	return slice(index, position$1)
}

/**
 * @param {string} value
 * @return {object[]}
 */
function compile (value) {
	return dealloc(parse('', null, null, null, [''], value = alloc(value), 0, [0], value))
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {string[]} rule
 * @param {string[]} rules
 * @param {string[]} rulesets
 * @param {number[]} pseudo
 * @param {number[]} points
 * @param {string[]} declarations
 * @return {object}
 */
function parse (value, root, parent, rule, rules, rulesets, pseudo, points, declarations) {
	var index = 0;
	var offset = 0;
	var length = pseudo;
	var atrule = 0;
	var property = 0;
	var previous = 0;
	var variable = 1;
	var scanning = 1;
	var ampersand = 1;
	var character = 0;
	var type = '';
	var props = rules;
	var children = rulesets;
	var reference = rule;
	var characters = type;

	while (scanning)
		switch (previous = character, character = next()) {
			// " ' [ (
			case 34: case 39: case 91: case 40:
				characters += delimit(character);
				break
			// \t \n \r \s
			case 9: case 10: case 13: case 32:
				characters += whitespace(previous);
				break
			// /
			case 47:
				switch (peek()) {
					case 42: case 47:
						append(comment(commenter(next(), caret()), root, parent), declarations);
						break
					default:
						characters += '/';
				}
				break
			// {
			case 123 * variable:
				points[index++] = strlen(characters) * ampersand;
			// } ; \0
			case 125 * variable: case 59: case 0:
				switch (character) {
					// \0 }
					case 0: case 125: scanning = 0;
					// ;
					case 59 + offset:
						if (property > 0 && (strlen(characters) - length))
							append(property > 32 ? declaration(characters + ';', rule, parent, length - 1) : declaration(replace(characters, ' ', '') + ';', rule, parent, length - 2), declarations);
						break
					// @ ;
					case 59: characters += ';';
					// { rule/at-rule
					default:
						append(reference = ruleset(characters, root, parent, index, offset, rules, points, type, props = [], children = [], length), rulesets);

						if (character === 123)
							if (offset === 0)
								parse(characters, root, reference, reference, props, rulesets, length, points, children);
							else
								switch (atrule) {
									// d m s
									case 100: case 109: case 115:
										parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules, points, type, rules, props = [], length), children), rules, children, length, points, rule ? props : children);
										break
									default:
										parse(characters, reference, reference, reference, [''], children, length, points, children);
								}
				}

				index = offset = property = 0, variable = ampersand = 1, type = characters = '', length = pseudo;
				break
			// :
			case 58:
				length = 1 + strlen(characters), property = previous;
			default:
				switch (characters += from(character), character * variable) {
					// &
					case 38:
						ampersand = offset > 0 ? 1 : (characters += '\f', -1);
						break
					// ,
					case 44:
						points[index++] = (strlen(characters) - 1) * ampersand, ampersand = 1;
						break
					// @
					case 64:
						// -
						if (peek() === 45)
							characters += delimit(next());

						atrule = peek(), offset = strlen(type = characters += identifier(caret())), character++;
						break
					// -
					case 45:
						if (previous === 45 && strlen(characters) == 2)
							variable = 0;
				}
		}

	return rulesets
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} index
 * @param {number} offset
 * @param {string[]} rules
 * @param {number[]} points
 * @param {string} type
 * @param {string[]} props
 * @param {string[]} children
 * @param {number} length
 * @return {object}
 */
function ruleset (value, root, parent, index, offset, rules, points, type, props, children, length) {
	var post = offset - 1;
	var rule = offset === 0 ? rules : [''];
	var size = sizeof(rule);

	for (var i = 0, j = 0, k = 0; i < index; ++i)
		for (var x = 0, y = substr(value, post + 1, post = abs(j = points[i])), z = value; x < size; ++x)
			if (z = trim$1(j > 0 ? rule[x] + ' ' + y : replace(y, /&\f/g, rule[x])))
				props[k++] = z;

	return node(value, root, parent, offset === 0 ? RULESET : type, props, children, length)
}

/**
 * @param {number} value
 * @param {object} root
 * @param {object?} parent
 * @return {object}
 */
function comment (value, root, parent) {
	return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0)
}

/**
 * @param {string} value
 * @param {object} root
 * @param {object?} parent
 * @param {number} length
 * @return {object}
 */
function declaration (value, root, parent, length) {
	return node(value, root, parent, DECLARATION, substr(value, 0, length), substr(value, length + 1, -1), length)
}

/**
 * @param {string} value
 * @param {number} length
 * @return {string}
 */
function prefix (value, length) {
	switch (hash$2(value, length)) {
		// animation, animation-(delay|direction|duration|fill-mode|iteration-count|name|play-state|timing-function)
		case 5737: case 4201: case 3177: case 3433: case 1641: case 4457: case 2921:
		// text-decoration, filter, clip-path, backface-visibility, column, box-decoration-break
		case 5572: case 6356: case 5844: case 3191: case 6645: case 3005:
		// mask, mask-image, mask-(mode|clip|size), mask-(repeat|origin), mask-position, mask-composite,
		case 6391: case 5879: case 5623: case 6135: case 4599: case 4855:
		// background-clip, columns, column-(count|fill|gap|rule|rule-color|rule-style|rule-width|span|width)
		case 4215: case 6389: case 5109: case 5365: case 5621: case 3829:
			return WEBKIT + value + value
		// appearance, user-select, transform, hyphens, text-size-adjust
		case 5349: case 4246: case 4810: case 6968: case 2756:
			return WEBKIT + value + MOZ + value + MS + value + value
		// flex, flex-direction
		case 6828: case 4268:
			return WEBKIT + value + MS + value + value
		// order
		case 6165:
			return WEBKIT + value + MS + 'flex-' + value + value
		// align-items
		case 5187:
			return WEBKIT + value + replace(value, /(\w+).+(:[^]+)/, WEBKIT + 'box-$1$2' + MS + 'flex-$1$2') + value
		// align-self
		case 5443:
			return WEBKIT + value + MS + 'flex-item-' + replace(value, /flex-|-self/, '') + value
		// align-content
		case 4675:
			return WEBKIT + value + MS + 'flex-line-pack' + replace(value, /align-content|flex-|-self/, '') + value
		// flex-shrink
		case 5548:
			return WEBKIT + value + MS + replace(value, 'shrink', 'negative') + value
		// flex-basis
		case 5292:
			return WEBKIT + value + MS + replace(value, 'basis', 'preferred-size') + value
		// flex-grow
		case 6060:
			return WEBKIT + 'box-' + replace(value, '-grow', '') + WEBKIT + value + MS + replace(value, 'grow', 'positive') + value
		// transition
		case 4554:
			return WEBKIT + replace(value, /([^-])(transform)/g, '$1' + WEBKIT + '$2') + value
		// cursor
		case 6187:
			return replace(replace(replace(value, /(zoom-|grab)/, WEBKIT + '$1'), /(image-set)/, WEBKIT + '$1'), value, '') + value
		// background, background-image
		case 5495: case 3959:
			return replace(value, /(image-set\([^]*)/, WEBKIT + '$1' + '$`$1')
		// justify-content
		case 4968:
			return replace(replace(value, /(.+:)(flex-)?(.*)/, WEBKIT + 'box-pack:$3' + MS + 'flex-pack:$3'), /s.+-b[^;]+/, 'justify') + WEBKIT + value + value
		// (margin|padding)-inline-(start|end)
		case 4095: case 3583: case 4068: case 2532:
			return replace(value, /(.+)-inline(.+)/, WEBKIT + '$1$2') + value
		// (min|max)?(width|height|inline-size|block-size)
		case 8116: case 7059: case 5753: case 5535:
		case 5445: case 5701: case 4933: case 4677:
		case 5533: case 5789: case 5021: case 4765:
			// stretch, max-content, min-content, fill-available
			if (strlen(value) - 1 - length > 6)
				switch (charat(value, length + 1)) {
					// (f)ill-available, (f)it-content
					case 102: length = charat(value, length + 3);
					// (m)ax-content, (m)in-content
					case 109:
						return replace(value, /(.+:)(.+)-([^]+)/, '$1' + WEBKIT + '$2-$3' + '$1' + MOZ + (length == 108 ? '$3' : '$2-$3')) + value
					// (s)tretch
					case 115:
						return ~indexof(value, 'stretch') ? prefix(replace(value, 'stretch', 'fill-available'), length) + value : value
				}
			break
		// position: sticky
		case 4949:
			// (s)ticky?
			if (charat(value, length + 1) !== 115)
				break
		// display: (flex|inline-flex|inline-box)
		case 6444:
			switch (charat(value, strlen(value) - 3 - (~indexof(value, '!important') && 10))) {
				// stic(k)y, inline-b(o)x
				case 107: case 111:
					return replace(value, value, WEBKIT + value) + value
				// (inline-)?fl(e)x
				case 101:
					return replace(value, /(.+:)([^;!]+)(;|!.+)?/, '$1' + WEBKIT + (charat(value, 14) === 45 ? 'inline-' : '') + 'box$3' + '$1' + WEBKIT + '$2$3' + '$1' + MS + '$2box$3') + value
			}
			break
		// writing-mode
		case 5936:
			switch (charat(value, length + 11)) {
				// vertical-l(r)
				case 114:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb') + value
				// vertical-r(l)
				case 108:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'tb-rl') + value
				// horizontal(-)tb
				case 45:
					return WEBKIT + value + MS + replace(value, /[svh]\w+-[tblr]{2}/, 'lr') + value
			}

			return WEBKIT + value + MS + value + value
	}

	return value
}

/**
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function serialize (children, callback) {
	var output = '';
	var length = sizeof(children);

	for (var i = 0; i < length; i++)
		output += callback(children[i], i, children, callback) || '';

	return output
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 * @return {string}
 */
function stringify (element, index, children, callback) {
	switch (element.type) {
		case IMPORT: case DECLARATION: return element.return = element.return || element.value
		case COMMENT: return ''
		case RULESET: element.value = element.props.join(',');
	}

	return strlen(children = serialize(element.children, callback)) ? element.return = element.value + '{' + children + '}' : ''
}

/**
 * @param {function[]} collection
 * @return {function}
 */
function middleware (collection) {
	var length = sizeof(collection);

	return function (element, index, children, callback) {
		var output = '';

		for (var i = 0; i < length; i++)
			output += collection[i](element, index, children, callback) || '';

		return output
	}
}

/**
 * @param {function} callback
 * @return {function}
 */
function rulesheet (callback) {
	return function (element) {
		if (!element.root)
			if (element = element.return)
				callback(element);
	}
}

/**
 * @param {object} element
 * @param {number} index
 * @param {object[]} children
 * @param {function} callback
 */
function prefixer (element, index, children, callback) {
	if (!element.return)
		switch (element.type) {
			case DECLARATION: element.return = prefix(element.value, element.length);
				break
			case KEYFRAMES:
				return serialize([copy$1(replace(element.value, '@', '@' + WEBKIT), element, '')], callback)
			case RULESET:
				if (element.length)
					return combine(element.props, function (value) {
						switch (match$1(value, /(::plac\w+|:read-\w+)/)) {
							// :read-(only|write)
							case ':read-only': case ':read-write':
								return serialize([copy$1(replace(value, /:(read-\w+)/, ':' + MOZ + '$1'), element, '')], callback)
							// :placeholder
							case '::placeholder':
								return serialize([
									copy$1(replace(value, /:(plac\w+)/, ':' + WEBKIT + 'input-$1'), element, ''),
									copy$1(replace(value, /:(plac\w+)/, ':' + MOZ + '$1'), element, ''),
									copy$1(replace(value, /:(plac\w+)/, MS + 'input-$1'), element, '')
								], callback)
						}

						return ''
					})
		}
}

var weakMemoize = function weakMemoize(func) {
  // $FlowFixMe flow doesn't include all non-primitive types as allowed for weakmaps
  var cache = new WeakMap();
  return function (arg) {
    if (cache.has(arg)) {
      // $FlowFixMe
      return cache.get(arg);
    }

    var ret = func(arg);
    cache.set(arg, ret);
    return ret;
  };
};

var weakMemoize$1 = weakMemoize;

var toRules = function toRules(parsed, points) {
  // pretend we've started with a comma
  var index = -1;
  var character = 44;

  do {
    switch (token(character)) {
      case 0:
        // &\f
        if (character === 38 && peek() === 12) {
          // this is not 100% correct, we don't account for literal sequences here - like for example quoted strings
          // stylis inserts \f after & to know when & where it should replace this sequence with the context selector
          // and when it should just concatenate the outer and inner selectors
          // it's very unlikely for this sequence to actually appear in a different context, so we just leverage this fact here
          points[index] = 1;
        }

        parsed[index] += identifier(position$1 - 1);
        break;

      case 2:
        parsed[index] += delimit(character);
        break;

      case 4:
        // comma
        if (character === 44) {
          // colon
          parsed[++index] = peek() === 58 ? '&\f' : '';
          points[index] = parsed[index].length;
          break;
        }

      // fallthrough

      default:
        parsed[index] += from(character);
    }
  } while (character = next());

  return parsed;
};

var getRules = function getRules(value, points) {
  return dealloc(toRules(alloc(value), points));
}; // WeakSet would be more appropriate, but only WeakMap is supported in IE11


var fixedElements = /* #__PURE__ */new WeakMap();
var compat = function compat(element) {
  if (element.type !== 'rule' || !element.parent || // .length indicates if this rule contains pseudo or not
  !element.length) {
    return;
  }

  var value = element.value,
      parent = element.parent;
  var isImplicitRule = element.column === parent.column && element.line === parent.line;

  while (parent.type !== 'rule') {
    parent = parent.parent;
    if (!parent) return;
  } // short-circuit for the simplest case


  if (element.props.length === 1 && value.charCodeAt(0) !== 58
  /* colon */
  && !fixedElements.get(parent)) {
    return;
  } // if this is an implicitly inserted rule (the one eagerly inserted at the each new nested level)
  // then the props has already been manipulated beforehand as they that array is shared between it and its "rule parent"


  if (isImplicitRule) {
    return;
  }

  fixedElements.set(element, true);
  var points = [];
  var rules = getRules(value, points);
  var parentRules = parent.props;

  for (var i = 0, k = 0; i < rules.length; i++) {
    for (var j = 0; j < parentRules.length; j++, k++) {
      element.props[k] = points[i] ? rules[i].replace(/&\f/g, parentRules[j]) : parentRules[j] + " " + rules[i];
    }
  }
};
var removeLabel = function removeLabel(element) {
  if (element.type === 'decl') {
    var value = element.value;

    if ( // charcode for l
    value.charCodeAt(0) === 108 && // charcode for b
    value.charCodeAt(2) === 98) {
      // this ignores label
      element["return"] = '';
      element.value = '';
    }
  }
};

var isBrowser$4 = typeof document !== 'undefined';
var getServerStylisCache = isBrowser$4 ? undefined : weakMemoize$1(function () {
  return memoize$4(function () {
    var cache = {};
    return function (name) {
      return cache[name];
    };
  });
});
var defaultStylisPlugins = [prefixer];

var createCache = function createCache(options) {
  var key = options.key;

  if (isBrowser$4 && key === 'css') {
    var ssrStyles = document.querySelectorAll("style[data-emotion]:not([data-s])"); // get SSRed styles out of the way of React's hydration
    // document.head is a safe place to move them to(though note document.head is not necessarily the last place they will be)
    // note this very very intentionally targets all style elements regardless of the key to ensure
    // that creating a cache works inside of render of a React component

    Array.prototype.forEach.call(ssrStyles, function (node) {
      // we want to only move elements which have a space in the data-emotion attribute value
      // because that indicates that it is an Emotion 11 server-side rendered style elements
      // while we will already ignore Emotion 11 client-side inserted styles because of the :not([data-s]) part in the selector
      // Emotion 10 client-side inserted styles did not have data-s (but importantly did not have a space in their data-emotion attributes)
      // so checking for the space ensures that loading Emotion 11 after Emotion 10 has inserted some styles
      // will not result in the Emotion 10 styles being destroyed
      var dataEmotionAttribute = node.getAttribute('data-emotion');

      if (dataEmotionAttribute.indexOf(' ') === -1) {
        return;
      }
      document.head.appendChild(node);
      node.setAttribute('data-s', '');
    });
  }

  var stylisPlugins = options.stylisPlugins || defaultStylisPlugins;

  var inserted = {}; // $FlowFixMe

  var container;
  var nodesToHydrate = [];

  if (isBrowser$4) {
    container = options.container || document.head;
    Array.prototype.forEach.call( // this means we will ignore elements which don't have a space in them which
    // means that the style elements we're looking at are only Emotion 11 server-rendered style elements
    document.querySelectorAll("style[data-emotion^=\"" + key + " \"]"), function (node) {
      var attrib = node.getAttribute("data-emotion").split(' '); // $FlowFixMe

      for (var i = 1; i < attrib.length; i++) {
        inserted[attrib[i]] = true;
      }

      nodesToHydrate.push(node);
    });
  }

  var _insert;

  var omnipresentPlugins = [compat, removeLabel];

  if (isBrowser$4) {
    var currentSheet;
    var finalizingPlugins = [stringify, rulesheet(function (rule) {
      currentSheet.insert(rule);
    })];
    var serializer = middleware(omnipresentPlugins.concat(stylisPlugins, finalizingPlugins));

    var stylis = function stylis(styles) {
      return serialize(compile(styles), serializer);
    };

    _insert = function insert(selector, serialized, sheet, shouldCache) {
      currentSheet = sheet;

      stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);

      if (shouldCache) {
        cache.inserted[serialized.name] = true;
      }
    };
  } else {
    var _finalizingPlugins = [stringify];

    var _serializer = middleware(omnipresentPlugins.concat(stylisPlugins, _finalizingPlugins));

    var _stylis = function _stylis(styles) {
      return serialize(compile(styles), _serializer);
    }; // $FlowFixMe


    var serverStylisCache = getServerStylisCache(stylisPlugins)(key);

    var getRules = function getRules(selector, serialized) {
      var name = serialized.name;

      if (serverStylisCache[name] === undefined) {
        serverStylisCache[name] = _stylis(selector ? selector + "{" + serialized.styles + "}" : serialized.styles);
      }

      return serverStylisCache[name];
    };

    _insert = function _insert(selector, serialized, sheet, shouldCache) {
      var name = serialized.name;
      var rules = getRules(selector, serialized);

      {
        // in regular mode, we don't set the styles on the inserted cache
        // since we don't need to and that would be wasting memory
        // we return them so that they are rendered in a style tag
        if (shouldCache) {
          cache.inserted[name] = true;
        }

        return rules;
      }
    };
  }

  var cache = {
    key: key,
    sheet: new StyleSheet$1({
      key: key,
      container: container,
      nonce: options.nonce,
      speedy: options.speedy,
      prepend: options.prepend
    }),
    nonce: options.nonce,
    inserted: inserted,
    registered: {},
    insert: _insert
  };
  cache.sheet.hydrate(nodesToHydrate);
  return cache;
};

var createCache$1 = createCache;

var isBrowser$3 = typeof document !== 'undefined';
var insertStyles$1 = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$3 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$3 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$3 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

/* eslint-disable */
// Inspired by https://github.com/garycourt/murmurhash-js
// Ported from https://github.com/aappleby/smhasher/blob/61a0530f28277f2e850bfc39600ce61d02b518de/src/MurmurHash2.cpp#L37-L86
function murmur2(str) {
  // 'm' and 'r' are mixing constants generated offline.
  // They're not really 'magic', they just happen to work well.
  // const m = 0x5bd1e995;
  // const r = 24;
  // Initialize the hash
  var h = 0; // Mix 4 bytes at a time into the hash

  var k,
      i = 0,
      len = str.length;

  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;
    k =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16);
    k ^=
    /* k >>> r: */
    k >>> 24;
    h =
    /* Math.imul(k, m): */
    (k & 0xffff) * 0x5bd1e995 + ((k >>> 16) * 0xe995 << 16) ^
    /* Math.imul(h, m): */
    (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Handle the last few bytes of the input array


  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;

    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;

    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h =
      /* Math.imul(h, m): */
      (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  } // Do a few final mixes of the hash to ensure the last few
  // bytes are well-incorporated.


  h ^= h >>> 13;
  h =
  /* Math.imul(h, m): */
  (h & 0xffff) * 0x5bd1e995 + ((h >>> 16) * 0xe995 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}

var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};

var unitless = unitlessKeys;

var hyphenateRegex$1 = /[A-Z]|^ms/g;
var animationRegex$1 = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty$1 = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue$1 = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName$1 = /* #__PURE__ */memoize$4(function (styleName) {
  return isCustomProperty$1(styleName) ? styleName : styleName.replace(hyphenateRegex$1, '-$&').toLowerCase();
});

var processStyleValue$1 = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex$1, function (match, p1, p2) {
            cursor$1 = {
              name: p1,
              styles: p2,
              next: cursor$1
            };
            return p1;
          });
        }
      }
  }

  if (unitless[key] !== 1 && !isCustomProperty$1(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

function handleInterpolation$1(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor$1 = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor$1
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor$1 = {
                name: next.name,
                styles: next.styles,
                next: cursor$1
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          return styles;
        }

        return createStringFromObject$1(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor$1;
          var result = interpolation(mergedProps);
          cursor$1 = previousCursor;
          return handleInterpolation$1(mergedProps, registered, result);
        }

        break;
      }
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject$1(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation$1(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue$1(value)) {
          string += processStyleName$1(_key) + ":" + processStyleValue$1(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue$1(value[_i])) {
              string += processStyleName$1(_key) + ":" + processStyleValue$1(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation$1(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName$1(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern$1 = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list


var cursor$1;
var serializeStyles$1 = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor$1 = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation$1(mergedProps, registered, strings);
  } else {

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation$1(mergedProps, registered, args[i]);

    if (stringMode) {

      styles += strings[i];
    }
  }


  labelPattern$1.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern$1.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  return {
    name: name,
    styles: styles,
    next: cursor$1
  };
};

var isBrowser$2 = typeof document !== 'undefined';

var EmotionCacheContext = /* #__PURE__ */_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createContext( // we're doing this to avoid preconstruct's dead code elimination in this one case
// because this module is primarily intended for the browser and node
// but it's also required in react native and similar environments sometimes
// and we could have a special build just for that
// but this is much easier and the native packages
// might use a different theme context in the future anyway
typeof HTMLElement !== 'undefined' ? /* #__PURE__ */createCache$1({
  key: 'css'
}) : null);

var CacheProvider = EmotionCacheContext.Provider;

var withEmotionCache = function withEmotionCache(func) {
  // $FlowFixMe
  return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function (props, ref) {
    // the cache will never be null in the browser
    var cache = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(EmotionCacheContext);
    return func(props, cache, ref);
  });
};

if (!isBrowser$2) {
  withEmotionCache = function withEmotionCache(func) {
    return function (props) {
      var cache = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(EmotionCacheContext);

      if (cache === null) {
        // yes, we're potentially creating this on every render
        // it doesn't actually matter though since it's only on the server
        // so there will only every be a single render
        // that could change in the future because of suspense and etc. but for now,
        // this works and i don't want to optimise for a future thing that we aren't sure about
        cache = createCache$1({
          key: 'css'
        });
        return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createElement(EmotionCacheContext.Provider, {
          value: cache
        }, func(props, cache));
      } else {
        return func(props, cache);
      }
    };
  };
}

var ThemeContext$3 = /* #__PURE__ */_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createContext({});

/*

Based off glamor's StyleSheet, thanks Sunil ❤️

high performance StyleSheet for css-in-js systems

- uses multiple style tags behind the scenes for millions of rules
- uses `insertRule` for appending in production for *much* faster performance

// usage

import { StyleSheet } from '@emotion/sheet'

let styleSheet = new StyleSheet({ key: '', container: document.head })

styleSheet.insert('#box { border: 1px solid red; }')
- appends a css rule into the stylesheet

styleSheet.flush()
- empties the stylesheet of all its contents

*/
// $FlowFixMe
function sheetForTag(tag) {
  if (tag.sheet) {
    // $FlowFixMe
    return tag.sheet;
  } // this weirdness brought to you by firefox

  /* istanbul ignore next */


  for (var i = 0; i < document.styleSheets.length; i++) {
    if (document.styleSheets[i].ownerNode === tag) {
      // $FlowFixMe
      return document.styleSheets[i];
    }
  }
}

function createStyleElement(options) {
  var tag = document.createElement('style');
  tag.setAttribute('data-emotion', options.key);

  if (options.nonce !== undefined) {
    tag.setAttribute('nonce', options.nonce);
  }

  tag.appendChild(document.createTextNode(''));
  tag.setAttribute('data-s', '');
  return tag;
}

var StyleSheet = /*#__PURE__*/function () {
  function StyleSheet(options) {
    var _this = this;

    this._insertTag = function (tag) {
      var before;

      if (_this.tags.length === 0) {
        before = _this.prepend ? _this.container.firstChild : _this.before;
      } else {
        before = _this.tags[_this.tags.length - 1].nextSibling;
      }

      _this.container.insertBefore(tag, before);

      _this.tags.push(tag);
    };

    this.isSpeedy = options.speedy === undefined ? "production" === 'production' : options.speedy;
    this.tags = [];
    this.ctr = 0;
    this.nonce = options.nonce; // key is the value of the data-emotion attribute, it's used to identify different sheets

    this.key = options.key;
    this.container = options.container;
    this.prepend = options.prepend;
    this.before = null;
  }

  var _proto = StyleSheet.prototype;

  _proto.hydrate = function hydrate(nodes) {
    nodes.forEach(this._insertTag);
  };

  _proto.insert = function insert(rule) {
    // the max length is how many rules we have per style tag, it's 65000 in speedy mode
    // it's 1 in dev because we insert source maps that map a single rule to a location
    // and you can only have one source map per style tag
    if (this.ctr % (this.isSpeedy ? 65000 : 1) === 0) {
      this._insertTag(createStyleElement(this));
    }

    var tag = this.tags[this.tags.length - 1];

    if (this.isSpeedy) {
      var sheet = sheetForTag(tag);

      try {
        // this is the ultrafast version, works across browsers
        // the big drawback is that the css won't be editable in devtools
        sheet.insertRule(rule, sheet.cssRules.length);
      } catch (e) {
      }
    } else {
      tag.appendChild(document.createTextNode(rule));
    }

    this.ctr++;
  };

  _proto.flush = function flush() {
    // $FlowFixMe
    this.tags.forEach(function (tag) {
      return tag.parentNode.removeChild(tag);
    });
    this.tags = [];
    this.ctr = 0;
  };

  return StyleSheet;
}();

// initial render from browser, insertBefore context.sheet.tags[0] or if a style hasn't been inserted there yet, appendChild
// initial client-side render from SSR, use place of hydrating tag

var Global = /* #__PURE__ */withEmotionCache(function (props, cache) {

  var styles = props.styles;
  var serialized = serializeStyles$1([styles], undefined, _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(ThemeContext$3));

  if (!isBrowser$2) {
    var _ref;

    var serializedNames = serialized.name;
    var serializedStyles = serialized.styles;
    var next = serialized.next;

    while (next !== undefined) {
      serializedNames += ' ' + next.name;
      serializedStyles += next.styles;
      next = next.next;
    }

    var shouldCache = cache.compat === true;
    var rules = cache.insert("", {
      name: serializedNames,
      styles: serializedStyles
    }, cache.sheet, shouldCache);

    if (shouldCache) {
      return null;
    }

    return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + "-global " + serializedNames, _ref.dangerouslySetInnerHTML = {
      __html: rules
    }, _ref.nonce = cache.sheet.nonce, _ref));
  } // yes, i know these hooks are used conditionally
  // but it is based on a constant that will never change at runtime
  // it's effectively like having two implementations and switching them out
  // so it's not actually breaking anything


  var sheetRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useLayoutEffect(function () {
    var key = cache.key + "-global";
    var sheet = new StyleSheet({
      key: key,
      nonce: cache.sheet.nonce,
      container: cache.sheet.container,
      speedy: cache.sheet.isSpeedy
    });
    var rehydrating = false; // $FlowFixMe

    var node = document.querySelector("style[data-emotion=\"" + key + " " + serialized.name + "\"]");

    if (cache.sheet.tags.length) {
      sheet.before = cache.sheet.tags[0];
    }

    if (node !== null) {
      rehydrating = true; // clear the hash so this node won't be recognizable as rehydratable by other <Global/>s

      node.setAttribute('data-emotion', key);
      sheet.hydrate([node]);
    }

    sheetRef.current = [sheet, rehydrating];
    return function () {
      sheet.flush();
    };
  }, [cache]);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useLayoutEffect(function () {
    var sheetRefCurrent = sheetRef.current;
    var sheet = sheetRefCurrent[0],
        rehydrating = sheetRefCurrent[1];

    if (rehydrating) {
      sheetRefCurrent[1] = false;
      return;
    }

    if (serialized.next !== undefined) {
      // insert keyframes
      insertStyles$1(cache, serialized.next, true);
    }

    if (sheet.tags.length) {
      // if this doesn't exist then it will be null so the style element will be appended
      var element = sheet.tags[sheet.tags.length - 1].nextElementSibling;
      sheet.before = element;
      sheet.flush();
    }

    cache.insert("", serialized, sheet, false);
  }, [cache, serialized.name]);
  return null;
});

function css() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return serializeStyles$1(args);
}

var keyframes = function keyframes() {
  var insertable = css.apply(void 0, arguments);
  var name = "animation-" + insertable.name; // $FlowFixMe

  return {
    name: name,
    styles: "@keyframes " + name + "{" + insertable.styles + "}",
    anim: 1,
    toString: function toString() {
      return "_EMO_" + this.name + "_" + this.styles + "_EMO_";
    }
  };
};

var isBrowser$1 = typeof document !== 'undefined';
function getRegisteredStyles(registered, registeredStyles, classNames) {
  var rawClassName = '';
  classNames.split(' ').forEach(function (className) {
    if (registered[className] !== undefined) {
      registeredStyles.push(registered[className] + ";");
    } else {
      rawClassName += className + " ";
    }
  });
  return rawClassName;
}
var insertStyles = function insertStyles(cache, serialized, isStringTag) {
  var className = cache.key + "-" + serialized.name;

  if ( // we only need to add the styles to the registered cache if the
  // class name could be used further down
  // the tree but if it's a string tag, we know it won't
  // so we don't have to add it to registered cache.
  // this improves memory usage since we can avoid storing the whole style string
  (isStringTag === false || // we need to always store it if we're in compat mode and
  // in node since emotion-server relies on whether a style is in
  // the registered cache to know whether a style is global or not
  // also, note that this check will be dead code eliminated in the browser
  isBrowser$1 === false && cache.compat !== undefined) && cache.registered[className] === undefined) {
    cache.registered[className] = serialized.styles;
  }

  if (cache.inserted[serialized.name] === undefined) {
    var stylesForSSR = '';
    var current = serialized;

    do {
      var maybeStyles = cache.insert(serialized === current ? "." + className : '', current, cache.sheet, true);

      if (!isBrowser$1 && maybeStyles !== undefined) {
        stylesForSSR += maybeStyles;
      }

      current = current.next;
    } while (current !== undefined);

    if (!isBrowser$1 && stylesForSSR.length !== 0) {
      return stylesForSSR;
    }
  }
};

var hyphenateRegex = /[A-Z]|^ms/g;
var animationRegex = /_EMO_([^_]+?)_([^]*?)_EMO_/g;

var isCustomProperty = function isCustomProperty(property) {
  return property.charCodeAt(1) === 45;
};

var isProcessableValue = function isProcessableValue(value) {
  return value != null && typeof value !== 'boolean';
};

var processStyleName = /* #__PURE__ */memoize$4(function (styleName) {
  return isCustomProperty(styleName) ? styleName : styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});

var processStyleValue = function processStyleValue(key, value) {
  switch (key) {
    case 'animation':
    case 'animationName':
      {
        if (typeof value === 'string') {
          return value.replace(animationRegex, function (match, p1, p2) {
            cursor = {
              name: p1,
              styles: p2,
              next: cursor
            };
            return p1;
          });
        }
      }
  }

  if (unitless[key] !== 1 && !isCustomProperty(key) && typeof value === 'number' && value !== 0) {
    return value + 'px';
  }

  return value;
};

function handleInterpolation(mergedProps, registered, interpolation) {
  if (interpolation == null) {
    return '';
  }

  if (interpolation.__emotion_styles !== undefined) {

    return interpolation;
  }

  switch (typeof interpolation) {
    case 'boolean':
      {
        return '';
      }

    case 'object':
      {
        if (interpolation.anim === 1) {
          cursor = {
            name: interpolation.name,
            styles: interpolation.styles,
            next: cursor
          };
          return interpolation.name;
        }

        if (interpolation.styles !== undefined) {
          var next = interpolation.next;

          if (next !== undefined) {
            // not the most efficient thing ever but this is a pretty rare case
            // and there will be very few iterations of this generally
            while (next !== undefined) {
              cursor = {
                name: next.name,
                styles: next.styles,
                next: cursor
              };
              next = next.next;
            }
          }

          var styles = interpolation.styles + ";";

          return styles;
        }

        return createStringFromObject(mergedProps, registered, interpolation);
      }

    case 'function':
      {
        if (mergedProps !== undefined) {
          var previousCursor = cursor;
          var result = interpolation(mergedProps);
          cursor = previousCursor;
          return handleInterpolation(mergedProps, registered, result);
        }

        break;
      }
  } // finalize string values (regular strings and functions interpolated into css calls)


  if (registered == null) {
    return interpolation;
  }

  var cached = registered[interpolation];
  return cached !== undefined ? cached : interpolation;
}

function createStringFromObject(mergedProps, registered, obj) {
  var string = '';

  if (Array.isArray(obj)) {
    for (var i = 0; i < obj.length; i++) {
      string += handleInterpolation(mergedProps, registered, obj[i]) + ";";
    }
  } else {
    for (var _key in obj) {
      var value = obj[_key];

      if (typeof value !== 'object') {
        if (registered != null && registered[value] !== undefined) {
          string += _key + "{" + registered[value] + "}";
        } else if (isProcessableValue(value)) {
          string += processStyleName(_key) + ":" + processStyleValue(_key, value) + ";";
        }
      } else {
        if (_key === 'NO_COMPONENT_SELECTOR' && "production" !== 'production') {}

        if (Array.isArray(value) && typeof value[0] === 'string' && (registered == null || registered[value[0]] === undefined)) {
          for (var _i = 0; _i < value.length; _i++) {
            if (isProcessableValue(value[_i])) {
              string += processStyleName(_key) + ":" + processStyleValue(_key, value[_i]) + ";";
            }
          }
        } else {
          var interpolated = handleInterpolation(mergedProps, registered, value);

          switch (_key) {
            case 'animation':
            case 'animationName':
              {
                string += processStyleName(_key) + ":" + interpolated + ";";
                break;
              }

            default:
              {

                string += _key + "{" + interpolated + "}";
              }
          }
        }
      }
    }
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*(;|$)/g;
// keyframes are stored on the SerializedStyles object as a linked list


var cursor;
var serializeStyles = function serializeStyles(args, registered, mergedProps) {
  if (args.length === 1 && typeof args[0] === 'object' && args[0] !== null && args[0].styles !== undefined) {
    return args[0];
  }

  var stringMode = true;
  var styles = '';
  cursor = undefined;
  var strings = args[0];

  if (strings == null || strings.raw === undefined) {
    stringMode = false;
    styles += handleInterpolation(mergedProps, registered, strings);
  } else {

    styles += strings[0];
  } // we start at 1 since we've already handled the first arg


  for (var i = 1; i < args.length; i++) {
    styles += handleInterpolation(mergedProps, registered, args[i]);

    if (stringMode) {

      styles += strings[i];
    }
  }


  labelPattern.lastIndex = 0;
  var identifierName = '';
  var match; // https://esbench.com/bench/5b809c2cf2949800a0f61fb5

  while ((match = labelPattern.exec(styles)) !== null) {
    identifierName += '-' + // $FlowFixMe we know it's not null
    match[1];
  }

  var name = murmur2(styles) + identifierName;

  return {
    name: name,
    styles: styles,
    next: cursor
  };
};

var testOmitPropsOnStringTag = isPropValid$1;

var testOmitPropsOnComponent = function testOmitPropsOnComponent(key) {
  return key !== 'theme';
};

var getDefaultShouldForwardProp = function getDefaultShouldForwardProp(tag) {
  return typeof tag === 'string' && // 96 is one less than the char code
  // for "a" so this is checking that
  // it's a lowercase character
  tag.charCodeAt(0) > 96 ? testOmitPropsOnStringTag : testOmitPropsOnComponent;
};
var composeShouldForwardProps = function composeShouldForwardProps(tag, options, isReal) {
  var shouldForwardProp;

  if (options) {
    var optionsShouldForwardProp = options.shouldForwardProp;
    shouldForwardProp = tag.__emotion_forwardProp && optionsShouldForwardProp ? function (propName) {
      return tag.__emotion_forwardProp(propName) && optionsShouldForwardProp(propName);
    } : optionsShouldForwardProp;
  }

  if (typeof shouldForwardProp !== 'function' && isReal) {
    shouldForwardProp = tag.__emotion_forwardProp;
  }

  return shouldForwardProp;
};
var isBrowser = typeof document !== 'undefined';

var createStyled$1 = function createStyled(tag, options) {

  var isReal = tag.__emotion_real === tag;
  var baseTag = isReal && tag.__emotion_base || tag;
  var identifierName;
  var targetClassName;

  if (options !== undefined) {
    identifierName = options.label;
    targetClassName = options.target;
  }

  var shouldForwardProp = composeShouldForwardProps(tag, options, isReal);
  var defaultShouldForwardProp = shouldForwardProp || getDefaultShouldForwardProp(baseTag);
  var shouldUseAs = !defaultShouldForwardProp('as');
  return function () {
    var args = arguments;
    var styles = isReal && tag.__emotion_styles !== undefined ? tag.__emotion_styles.slice(0) : [];

    if (identifierName !== undefined) {
      styles.push("label:" + identifierName + ";");
    }

    if (args[0] == null || args[0].raw === undefined) {
      styles.push.apply(styles, args);
    } else {

      styles.push(args[0][0]);
      var len = args.length;
      var i = 1;

      for (; i < len; i++) {

        styles.push(args[i], args[0][i]);
      }
    } // $FlowFixMe: we need to cast StatelessFunctionalComponent to our PrivateStyledComponent class


    var Styled = withEmotionCache(function (props, cache, ref) {
      var finalTag = shouldUseAs && props.as || baseTag;
      var className = '';
      var classInterpolations = [];
      var mergedProps = props;

      if (props.theme == null) {
        mergedProps = {};

        for (var key in props) {
          mergedProps[key] = props[key];
        }

        mergedProps.theme = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(ThemeContext$3);
      }

      if (typeof props.className === 'string') {
        className = getRegisteredStyles(cache.registered, classInterpolations, props.className);
      } else if (props.className != null) {
        className = props.className + " ";
      }

      var serialized = serializeStyles(styles.concat(classInterpolations), cache.registered, mergedProps);
      var rules = insertStyles(cache, serialized, typeof finalTag === 'string');
      className += cache.key + "-" + serialized.name;

      if (targetClassName !== undefined) {
        className += " " + targetClassName;
      }

      var finalShouldForwardProp = shouldUseAs && shouldForwardProp === undefined ? getDefaultShouldForwardProp(finalTag) : defaultShouldForwardProp;
      var newProps = {};

      for (var _key in props) {
        if (shouldUseAs && _key === 'as') continue;

        if ( // $FlowFixMe
        finalShouldForwardProp(_key)) {
          newProps[_key] = props[_key];
        }
      }

      newProps.className = className;
      newProps.ref = ref;
      var ele = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createElement(finalTag, newProps);

      if (!isBrowser && rules !== undefined) {
        var _ref;

        var serializedNames = serialized.name;
        var next = serialized.next;

        while (next !== undefined) {
          serializedNames += ' ' + next.name;
          next = next.next;
        }

        return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Fragment, null, /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createElement("style", (_ref = {}, _ref["data-emotion"] = cache.key + " " + serializedNames, _ref.dangerouslySetInnerHTML = {
          __html: rules
        }, _ref.nonce = cache.sheet.nonce, _ref)), ele);
      }

      return ele;
    });
    Styled.displayName = identifierName !== undefined ? identifierName : "Styled(" + (typeof baseTag === 'string' ? baseTag : baseTag.displayName || baseTag.name || 'Component') + ")";
    Styled.defaultProps = tag.defaultProps;
    Styled.__emotion_real = Styled;
    Styled.__emotion_base = baseTag;
    Styled.__emotion_styles = styles;
    Styled.__emotion_forwardProp = shouldForwardProp;
    Object.defineProperty(Styled, 'toString', {
      value: function value() {
        if (targetClassName === undefined && "production" !== 'production') {} // $FlowFixMe: coerce undefined to string


        return "." + targetClassName;
      }
    });

    Styled.withComponent = function (nextTag, nextOptions) {
      return createStyled(nextTag, _extends$8({}, options, nextOptions, {
        shouldForwardProp: composeShouldForwardProps(Styled, nextOptions, true)
      })).apply(void 0, styles);
    };

    return Styled;
  };
};

var createStyled$2 = createStyled$1;

var tags = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr', // SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

var newStyled = createStyled$2.bind();
tags.forEach(function (tagName) {
  // $FlowFixMe: we can ignore this because its exposed type is defined by the CreateStyled type
  newStyled[tagName] = newStyled(tagName);
});

var emStyled = newStyled;

const cache$1 = createCache$1({
  key: 'css',
  prepend: true
});
function StyledEngineProvider(props) {
  const {
    injectFirst,
    children
  } = props;
  return injectFirst ? /*#__PURE__*/jsxRuntime.exports.jsx(CacheProvider, {
    value: cache$1,
    children: children
  }) : children;
}

function isEmpty$2(obj) {
  return obj === undefined || obj === null || Object.keys(obj).length === 0;
}

function GlobalStyles$1(props) {
  const {
    styles,
    defaultTheme = {}
  } = props;
  const globalStyles = typeof styles === 'function' ? themeInput => styles(isEmpty$2(themeInput) ? defaultTheme : themeInput) : styles;
  return /*#__PURE__*/jsxRuntime.exports.jsx(Global, {
    styles: globalStyles
  });
}

/** @license MUI v5.0.1
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
function styled$2(tag, options) {
  const stylesFactory = emStyled(tag, options);

  return stylesFactory;
}

var styledEngine = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': styled$2,
	ThemeContext: ThemeContext$3,
	keyframes: keyframes,
	css: css,
	StyledEngineProvider: StyledEngineProvider,
	GlobalStyles: GlobalStyles$1
});

function _extends$7() {
  _extends$7 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$7.apply(this, arguments);
}

function merge(acc, item) {
  if (!item) {
    return acc;
  }

  return deepmerge$2(acc, item, {
    clone: false // No need to clone deep, it's way faster.

  });
}

// For instance with the first breakpoint xs: [xs, sm[.

const values$1 = {
  xs: 0,
  // phone
  sm: 600,
  // tablets
  md: 900,
  // small laptop
  lg: 1200,
  // desktop
  xl: 1536 // large screens

};
const defaultBreakpoints = {
  // Sorted ASC by size. That's important.
  // It can't be configured as it's used statically for propTypes.
  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
  up: key => `@media (min-width:${values$1[key]}px)`
};
function handleBreakpoints(props, propValue, styleFromPropValue) {
  const theme = props.theme || {};

  if (Array.isArray(propValue)) {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return propValue.reduce((acc, item, index) => {
      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
      return acc;
    }, {});
  }

  if (typeof propValue === 'object') {
    const themeBreakpoints = theme.breakpoints || defaultBreakpoints;
    return Object.keys(propValue).reduce((acc, breakpoint) => {
      // key is breakpoint
      if (Object.keys(themeBreakpoints.values || values$1).indexOf(breakpoint) !== -1) {
        const mediaKey = themeBreakpoints.up(breakpoint);
        acc[mediaKey] = styleFromPropValue(propValue[breakpoint], breakpoint);
      } else {
        const cssKey = breakpoint;
        acc[cssKey] = propValue[cssKey];
      }

      return acc;
    }, {});
  }

  const output = styleFromPropValue(propValue);
  return output;
}

function createEmptyBreakpointObject(breakpointsInput = {}) {
  var _breakpointsInput$key;

  const breakpointsInOrder = breakpointsInput == null ? void 0 : (_breakpointsInput$key = breakpointsInput.keys) == null ? void 0 : _breakpointsInput$key.reduce((acc, key) => {
    const breakpointStyleKey = breakpointsInput.up(key);
    acc[breakpointStyleKey] = {};
    return acc;
  }, {});
  return breakpointsInOrder || {};
}
function removeUnusedBreakpoints(breakpointKeys, style) {
  return breakpointKeys.reduce((acc, key) => {
    const breakpointOutput = acc[key];
    const isBreakpointUnused = Object.keys(breakpointOutput).length === 0;

    if (isBreakpointUnused) {
      delete acc[key];
    }

    return acc;
  }, style);
}
function resolveBreakpointValues({
  values: breakpointValues,
  base
}) {
  const keys = Object.keys(base);

  if (keys.length === 0) {
    return breakpointValues;
  }

  let previous;
  return keys.reduce((acc, breakpoint) => {
    if (typeof breakpointValues === 'object') {
      acc[breakpoint] = breakpointValues[breakpoint] != null ? breakpointValues[breakpoint] : breakpointValues[previous];
    } else {
      acc[breakpoint] = breakpointValues;
    }

    previous = breakpoint;
    return acc;
  }, {});
}

function getPath(obj, path) {
  if (!path || typeof path !== 'string') {
    return null;
  }

  return path.split('.').reduce((acc, item) => acc && acc[item] ? acc[item] : null, obj);
}

function getValue$6(themeMapping, transform, propValueFinal, userValue = propValueFinal) {
  let value;

  if (typeof themeMapping === 'function') {
    value = themeMapping(propValueFinal);
  } else if (Array.isArray(themeMapping)) {
    value = themeMapping[propValueFinal] || userValue;
  } else {
    value = getPath(themeMapping, propValueFinal) || userValue;
  }

  if (transform) {
    value = transform(value);
  }

  return value;
}

function style$1(options) {
  const {
    prop,
    cssProperty = options.prop,
    themeKey,
    transform
  } = options;

  const fn = props => {
    if (props[prop] == null) {
      return null;
    }

    const propValue = props[prop];
    const theme = props.theme;
    const themeMapping = getPath(theme, themeKey) || {};

    const styleFromPropValue = propValueFinal => {
      let value = getValue$6(themeMapping, transform, propValueFinal);

      if (propValueFinal === value && typeof propValueFinal === 'string') {
        // Haven't found value
        value = getValue$6(themeMapping, transform, `${prop}${propValueFinal === 'default' ? '' : capitalize$2(propValueFinal)}`, propValueFinal);
      }

      if (cssProperty === false) {
        return value;
      }

      return {
        [cssProperty]: value
      };
    };

    return handleBreakpoints(props, propValue, styleFromPropValue);
  };

  fn.propTypes = {};
  fn.filterProps = [prop];
  return fn;
}

function compose(...styles) {
  const handlers = styles.reduce((acc, style) => {
    style.filterProps.forEach(prop => {
      acc[prop] = style;
    });
    return acc;
  }, {});

  const fn = props => {
    return Object.keys(props).reduce((acc, prop) => {
      if (handlers[prop]) {
        return merge(acc, handlers[prop](props));
      }

      return acc;
    }, {});
  };

  fn.propTypes = {};
  fn.filterProps = styles.reduce((acc, style) => acc.concat(style.filterProps), []);
  return fn;
}

function memoize$3(fn) {
  const cache = {};
  return arg => {
    if (cache[arg] === undefined) {
      cache[arg] = fn(arg);
    }

    return cache[arg];
  };
}

const properties = {
  m: 'margin',
  p: 'padding'
};
const directions = {
  t: 'Top',
  r: 'Right',
  b: 'Bottom',
  l: 'Left',
  x: ['Left', 'Right'],
  y: ['Top', 'Bottom']
};
const aliases = {
  marginX: 'mx',
  marginY: 'my',
  paddingX: 'px',
  paddingY: 'py'
}; // memoize() impact:
// From 300,000 ops/sec
// To 350,000 ops/sec

const getCssProperties = memoize$3(prop => {
  // It's not a shorthand notation.
  if (prop.length > 2) {
    if (aliases[prop]) {
      prop = aliases[prop];
    } else {
      return [prop];
    }
  }

  const [a, b] = prop.split('');
  const property = properties[a];
  const direction = directions[b] || '';
  return Array.isArray(direction) ? direction.map(dir => property + dir) : [property + direction];
});
const marginKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'marginInline', 'marginInlineStart', 'marginInlineEnd', 'marginBlock', 'marginBlockStart', 'marginBlockEnd'];
const paddingKeys = ['p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY', 'paddingInline', 'paddingInlineStart', 'paddingInlineEnd', 'paddingBlock', 'paddingBlockStart', 'paddingBlockEnd'];
const spacingKeys = [...marginKeys, ...paddingKeys];
function createUnaryUnit(theme, themeKey, defaultValue, propName) {
  const themeSpacing = getPath(theme, themeKey) || defaultValue;

  if (typeof themeSpacing === 'number') {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }

      return themeSpacing * abs;
    };
  }

  if (Array.isArray(themeSpacing)) {
    return abs => {
      if (typeof abs === 'string') {
        return abs;
      }

      return themeSpacing[abs];
    };
  }

  if (typeof themeSpacing === 'function') {
    return themeSpacing;
  }

  return () => undefined;
}
function createUnarySpacing(theme) {
  return createUnaryUnit(theme, 'spacing', 8);
}
function getValue$5(transformer, propValue) {
  if (typeof propValue === 'string' || propValue == null) {
    return propValue;
  }

  const abs = Math.abs(propValue);
  const transformed = transformer(abs);

  if (propValue >= 0) {
    return transformed;
  }

  if (typeof transformed === 'number') {
    return -transformed;
  }

  return `-${transformed}`;
}
function getStyleFromPropValue(cssProperties, transformer) {
  return propValue => cssProperties.reduce((acc, cssProperty) => {
    acc[cssProperty] = getValue$5(transformer, propValue);
    return acc;
  }, {});
}

function resolveCssProperty(props, keys, prop, transformer) {
  // Using a hash computation over an array iteration could be faster, but with only 28 items,
  // it's doesn't worth the bundle size.
  if (keys.indexOf(prop) === -1) {
    return null;
  }

  const cssProperties = getCssProperties(prop);
  const styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
  const propValue = props[prop];
  return handleBreakpoints(props, propValue, styleFromPropValue);
}

function style(props, keys) {
  const transformer = createUnarySpacing(props.theme);
  return Object.keys(props).map(prop => resolveCssProperty(props, keys, prop, transformer)).reduce(merge, {});
}

function spacing$2(props) {
  return style(props, spacingKeys);
}

spacing$2.propTypes = {};
spacing$2.filterProps = spacingKeys;

function getBorder(value) {
  if (typeof value !== 'number') {
    return value;
  }

  return `${value}px solid`;
}

const border = style$1({
  prop: 'border',
  themeKey: 'borders',
  transform: getBorder
});
const borderTop = style$1({
  prop: 'borderTop',
  themeKey: 'borders',
  transform: getBorder
});
const borderRight = style$1({
  prop: 'borderRight',
  themeKey: 'borders',
  transform: getBorder
});
const borderBottom = style$1({
  prop: 'borderBottom',
  themeKey: 'borders',
  transform: getBorder
});
const borderLeft = style$1({
  prop: 'borderLeft',
  themeKey: 'borders',
  transform: getBorder
});
const borderColor = style$1({
  prop: 'borderColor',
  themeKey: 'palette'
});
const borderTopColor = style$1({
  prop: 'borderTopColor',
  themeKey: 'palette'
});
const borderRightColor = style$1({
  prop: 'borderRightColor',
  themeKey: 'palette'
});
const borderBottomColor = style$1({
  prop: 'borderBottomColor',
  themeKey: 'palette'
});
const borderLeftColor = style$1({
  prop: 'borderLeftColor',
  themeKey: 'palette'
});
const borderRadius = props => {
  if (props.borderRadius !== undefined && props.borderRadius !== null) {
    const transformer = createUnaryUnit(props.theme, 'shape.borderRadius', 4);

    const styleFromPropValue = propValue => ({
      borderRadius: getValue$5(transformer, propValue)
    });

    return handleBreakpoints(props, props.borderRadius, styleFromPropValue);
  }

  return null;
};
borderRadius.propTypes = {};
borderRadius.filterProps = ['borderRadius'];
const borders = compose(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderTopColor, borderRightColor, borderBottomColor, borderLeftColor, borderRadius);
var borders$1 = borders;

const displayPrint = style$1({
  prop: 'displayPrint',
  cssProperty: false,
  transform: value => ({
    '@media print': {
      display: value
    }
  })
});
const displayRaw = style$1({
  prop: 'display'
});
const overflow = style$1({
  prop: 'overflow'
});
const textOverflow = style$1({
  prop: 'textOverflow'
});
const visibility = style$1({
  prop: 'visibility'
});
const whiteSpace = style$1({
  prop: 'whiteSpace'
});
var display$1 = compose(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace);

const flexBasis = style$1({
  prop: 'flexBasis'
});
const flexDirection = style$1({
  prop: 'flexDirection'
});
const flexWrap = style$1({
  prop: 'flexWrap'
});
const justifyContent = style$1({
  prop: 'justifyContent'
});
const alignItems = style$1({
  prop: 'alignItems'
});
const alignContent = style$1({
  prop: 'alignContent'
});
const order$1 = style$1({
  prop: 'order'
});
const flex = style$1({
  prop: 'flex'
});
const flexGrow = style$1({
  prop: 'flexGrow'
});
const flexShrink = style$1({
  prop: 'flexShrink'
});
const alignSelf = style$1({
  prop: 'alignSelf'
});
const justifyItems = style$1({
  prop: 'justifyItems'
});
const justifySelf = style$1({
  prop: 'justifySelf'
});
const flexbox = compose(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order$1, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
var flexbox$1 = flexbox;

const gap = props => {
  if (props.gap !== undefined && props.gap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8);

    const styleFromPropValue = propValue => ({
      gap: getValue$5(transformer, propValue)
    });

    return handleBreakpoints(props, props.gap, styleFromPropValue);
  }

  return null;
};
gap.propTypes = {};
gap.filterProps = ['gap'];
const columnGap = props => {
  if (props.columnGap !== undefined && props.columnGap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8);

    const styleFromPropValue = propValue => ({
      columnGap: getValue$5(transformer, propValue)
    });

    return handleBreakpoints(props, props.columnGap, styleFromPropValue);
  }

  return null;
};
columnGap.propTypes = {};
columnGap.filterProps = ['columnGap'];
const rowGap = props => {
  if (props.rowGap !== undefined && props.rowGap !== null) {
    const transformer = createUnaryUnit(props.theme, 'spacing', 8);

    const styleFromPropValue = propValue => ({
      rowGap: getValue$5(transformer, propValue)
    });

    return handleBreakpoints(props, props.rowGap, styleFromPropValue);
  }

  return null;
};
rowGap.propTypes = {};
rowGap.filterProps = ['rowGap'];
const gridColumn = style$1({
  prop: 'gridColumn'
});
const gridRow = style$1({
  prop: 'gridRow'
});
const gridAutoFlow = style$1({
  prop: 'gridAutoFlow'
});
const gridAutoColumns = style$1({
  prop: 'gridAutoColumns'
});
const gridAutoRows = style$1({
  prop: 'gridAutoRows'
});
const gridTemplateColumns = style$1({
  prop: 'gridTemplateColumns'
});
const gridTemplateRows = style$1({
  prop: 'gridTemplateRows'
});
const gridTemplateAreas = style$1({
  prop: 'gridTemplateAreas'
});
const gridArea = style$1({
  prop: 'gridArea'
});
const grid = compose(gap, columnGap, rowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
var grid$1 = grid;

const color = style$1({
  prop: 'color',
  themeKey: 'palette'
});
const bgcolor = style$1({
  prop: 'bgcolor',
  cssProperty: 'backgroundColor',
  themeKey: 'palette'
});
const backgroundColor = style$1({
  prop: 'backgroundColor',
  themeKey: 'palette'
});
const palette$2 = compose(color, bgcolor, backgroundColor);
var palette$3 = palette$2;

const position = style$1({
  prop: 'position'
});
const zIndex$2 = style$1({
  prop: 'zIndex',
  themeKey: 'zIndex'
});
const top$1 = style$1({
  prop: 'top'
});
const right$1 = style$1({
  prop: 'right'
});
const bottom$1 = style$1({
  prop: 'bottom'
});
const left$1 = style$1({
  prop: 'left'
});
var positions = compose(position, zIndex$2, top$1, right$1, bottom$1, left$1);

const boxShadow = style$1({
  prop: 'boxShadow',
  themeKey: 'shadows'
});
var shadows$4 = boxShadow;

function transform(value) {
  return value <= 1 && value !== 0 ? `${value * 100}%` : value;
}

const width = style$1({
  prop: 'width',
  transform
});
const maxWidth = props => {
  if (props.maxWidth !== undefined && props.maxWidth !== null) {
    const styleFromPropValue = propValue => {
      var _props$theme, _props$theme$breakpoi, _props$theme$breakpoi2;

      const breakpoint = ((_props$theme = props.theme) == null ? void 0 : (_props$theme$breakpoi = _props$theme.breakpoints) == null ? void 0 : (_props$theme$breakpoi2 = _props$theme$breakpoi.values) == null ? void 0 : _props$theme$breakpoi2[propValue]) || values$1[propValue];
      return {
        maxWidth: breakpoint || transform(propValue)
      };
    };

    return handleBreakpoints(props, props.maxWidth, styleFromPropValue);
  }

  return null;
};
maxWidth.filterProps = ['maxWidth'];
const minWidth = style$1({
  prop: 'minWidth',
  transform
});
const height = style$1({
  prop: 'height',
  transform
});
const maxHeight = style$1({
  prop: 'maxHeight',
  transform
});
const minHeight = style$1({
  prop: 'minHeight',
  transform
});
style$1({
  prop: 'size',
  cssProperty: 'width',
  transform
});
style$1({
  prop: 'size',
  cssProperty: 'height',
  transform
});
const boxSizing = style$1({
  prop: 'boxSizing'
});
const sizing = compose(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
var sizing$1 = sizing;

const fontFamily = style$1({
  prop: 'fontFamily',
  themeKey: 'typography'
});
const fontSize = style$1({
  prop: 'fontSize',
  themeKey: 'typography'
});
const fontStyle = style$1({
  prop: 'fontStyle',
  themeKey: 'typography'
});
const fontWeight = style$1({
  prop: 'fontWeight',
  themeKey: 'typography'
});
const letterSpacing = style$1({
  prop: 'letterSpacing'
});
const lineHeight = style$1({
  prop: 'lineHeight'
});
const textAlign = style$1({
  prop: 'textAlign'
});
const typographyVariant = style$1({
  prop: 'typography',
  cssProperty: false,
  themeKey: 'typography'
});
const typography$2 = compose(typographyVariant, fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign);
var typography$3 = typography$2;

const filterPropsMapping = {
  borders: borders$1.filterProps,
  display: display$1.filterProps,
  flexbox: flexbox$1.filterProps,
  grid: grid$1.filterProps,
  positions: positions.filterProps,
  palette: palette$3.filterProps,
  shadows: shadows$4.filterProps,
  sizing: sizing$1.filterProps,
  spacing: spacing$2.filterProps,
  typography: typography$3.filterProps
};
const styleFunctionMapping = {
  borders: borders$1,
  display: display$1,
  flexbox: flexbox$1,
  grid: grid$1,
  positions,
  palette: palette$3,
  shadows: shadows$4,
  sizing: sizing$1,
  spacing: spacing$2,
  typography: typography$3
};
const propToStyleFunction = Object.keys(filterPropsMapping).reduce((acc, styleFnName) => {
  filterPropsMapping[styleFnName].forEach(propName => {
    acc[propName] = styleFunctionMapping[styleFnName];
  });
  return acc;
}, {});

function getThemeValue(prop, value, theme) {
  const inputProps = {
    [prop]: value,
    theme
  };
  const styleFunction = propToStyleFunction[prop];
  return styleFunction ? styleFunction(inputProps) : {
    [prop]: value
  };
}

function objectsHaveSameKeys(...objects) {
  const allKeys = objects.reduce((keys, object) => keys.concat(Object.keys(object)), []);
  const union = new Set(allKeys);
  return objects.every(object => union.size === Object.keys(object).length);
}

function callIfFn(maybeFn, arg) {
  return typeof maybeFn === 'function' ? maybeFn(arg) : maybeFn;
}

function styleFunctionSx(props) {
  const {
    sx: styles,
    theme = {}
  } = props || {};

  if (!styles) {
    return null;
  }

  if (typeof styles === 'function') {
    return styles(theme);
  }

  if (typeof styles !== 'object') {
    // value
    return styles;
  }

  const emptyBreakpoints = createEmptyBreakpointObject(theme.breakpoints);
  const breakpointsKeys = Object.keys(emptyBreakpoints);
  let css = emptyBreakpoints;
  Object.keys(styles).forEach(styleKey => {
    const value = callIfFn(styles[styleKey], theme);

    if (typeof value === 'object') {
      if (propToStyleFunction[styleKey]) {
        css = merge(css, getThemeValue(styleKey, value, theme));
      } else {
        const breakpointsValues = handleBreakpoints({
          theme
        }, value, x => ({
          [styleKey]: x
        }));

        if (objectsHaveSameKeys(breakpointsValues, value)) {
          css[styleKey] = styleFunctionSx({
            sx: value,
            theme
          });
        } else {
          css = merge(css, breakpointsValues);
        }
      }
    } else {
      css = merge(css, getThemeValue(styleKey, value, theme));
    }
  });
  return removeUnusedBreakpoints(breakpointsKeys, css);
}

styleFunctionSx.filterProps = ['sx'];

function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

const _excluded$16 = ["sx"];

const splitProps = props => {
  const result = {
    systemProps: {},
    otherProps: {}
  };
  Object.keys(props).forEach(prop => {
    if (propToStyleFunction[prop]) {
      result.systemProps[prop] = props[prop];
    } else {
      result.otherProps[prop] = props[prop];
    }
  });
  return result;
};

function extendSxProp(props) {
  const {
    sx: inSx
  } = props,
        other = _objectWithoutPropertiesLoose$4(props, _excluded$16);

  const {
    systemProps,
    otherProps
  } = splitProps(other);
  return _extends$7({}, otherProps, {
    sx: _extends$7({}, systemProps, inSx)
  });
}

const _excluded$15 = ["values", "unit", "step"];

function createBreakpoints(breakpoints) {
  const {
    // The breakpoint **start** at this value.
    // For instance with the first breakpoint xs: [xs, sm).
    values = {
      xs: 0,
      // phone
      sm: 600,
      // tablets
      md: 900,
      // small laptop
      lg: 1200,
      // desktop
      xl: 1536 // large screens

    },
    unit = 'px',
    step = 5
  } = breakpoints,
        other = _objectWithoutPropertiesLoose$4(breakpoints, _excluded$15);

  const keys = Object.keys(values);

  function up(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (min-width:${value}${unit})`;
  }

  function down(key) {
    const value = typeof values[key] === 'number' ? values[key] : key;
    return `@media (max-width:${value - step / 100}${unit})`;
  }

  function between(start, end) {
    const endIndex = keys.indexOf(end);
    return `@media (min-width:${typeof values[start] === 'number' ? values[start] : start}${unit}) and ` + `(max-width:${(endIndex !== -1 && typeof values[keys[endIndex]] === 'number' ? values[keys[endIndex]] : end) - step / 100}${unit})`;
  }

  function only(key) {
    if (keys.indexOf(key) + 1 < keys.length) {
      return between(key, keys[keys.indexOf(key) + 1]);
    }

    return up(key);
  }

  return _extends$7({
    keys,
    values,
    up,
    down,
    between,
    only,
    unit
  }, other);
}

const shape = {
  borderRadius: 4
};
var shape$1 = shape;

/* tslint:enable:unified-signatures */
function createSpacing(spacingInput = 8) {
  // Already transformed.
  if (spacingInput.mui) {
    return spacingInput;
  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid, which aligns both spacing and the overall layout.
  // Smaller components, such as icons, can align to a 4dp grid.
  // https://material.io/design/layout/understanding-layout.html#usage


  const transform = createUnarySpacing({
    spacing: spacingInput
  });

  const spacing = (...argsInput) => {

    const args = argsInput.length === 0 ? [1] : argsInput;
    return args.map(argument => {
      const output = transform(argument);
      return typeof output === 'number' ? `${output}px` : output;
    }).join(' ');
  };

  spacing.mui = true;
  return spacing;
}

const _excluded$14 = ["breakpoints", "palette", "spacing", "shape"];

function createTheme$1(options = {}, ...args) {
  const {
    breakpoints: breakpointsInput = {},
    palette: paletteInput = {},
    spacing: spacingInput,
    shape: shapeInput = {}
  } = options,
        other = _objectWithoutPropertiesLoose$4(options, _excluded$14);

  const breakpoints = createBreakpoints(breakpointsInput);
  const spacing = createSpacing(spacingInput);
  let muiTheme = deepmerge$2({
    breakpoints,
    direction: 'ltr',
    components: {},
    // Inject component definitions.
    palette: _extends$7({
      mode: 'light'
    }, paletteInput),
    spacing,
    shape: _extends$7({}, shape$1, shapeInput)
  }, other);
  muiTheme = args.reduce((acc, argument) => deepmerge$2(acc, argument), muiTheme);
  return muiTheme;
}

function _extends$6() {
  _extends$6 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$6.apply(this, arguments);
}

const ThemeContext$1 = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createContext(null);

var ThemeContext$2 = ThemeContext$1;

function useTheme$3() {
  const theme = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(ThemeContext$2);

  return theme;
}

const hasSymbol = typeof Symbol === 'function' && Symbol.for;
var nested = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';

function mergeOuterLocalTheme(outerTheme, localTheme) {
  if (typeof localTheme === 'function') {
    const mergedTheme = localTheme(outerTheme);

    return mergedTheme;
  }

  return _extends$6({}, outerTheme, localTheme);
}
/**
 * This component takes a `theme` prop.
 * It makes the `theme` available down the React tree thanks to React context.
 * This component should preferably be used at **the root of your component tree**.
 */


function ThemeProvider$1(props) {
  const {
    children,
    theme: localTheme
  } = props;
  const outerTheme = useTheme$3();

  const theme = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
    const output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);

    if (output != null) {
      output[nested] = outerTheme !== null;
    }

    return output;
  }, [localTheme, outerTheme]);
  return /*#__PURE__*/jsxRuntime.exports.jsx(ThemeContext$2.Provider, {
    value: theme,
    children: children
  });
}

function isObjectEmpty(obj) {
  return Object.keys(obj).length === 0;
}

function useTheme$2(defaultTheme = null) {
  const contextTheme = useTheme$3();
  return !contextTheme || isObjectEmpty(contextTheme) ? defaultTheme : contextTheme;
}

const systemDefaultTheme$1 = createTheme$1();

function useTheme$1(defaultTheme = systemDefaultTheme$1) {
  return useTheme$2(defaultTheme);
}

const _excluded$13 = ["className", "component"];
function createBox(options = {}) {
  const {
    defaultTheme
  } = options;
  const BoxRoot = styled$2('div')(styleFunctionSx);
  const Box = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Box(inProps, ref) {
    const theme = useTheme$1(defaultTheme);

    const _extendSxProp = extendSxProp(inProps),
          {
      className,
      component = 'div'
    } = _extendSxProp,
          other = _objectWithoutPropertiesLoose$4(_extendSxProp, _excluded$13);

    return /*#__PURE__*/jsxRuntime.exports.jsx(BoxRoot, _extends$7({
      as: component,
      ref: ref,
      className: clsx(className, 'MuiBox-root'),
      theme: theme
    }, other));
  });
  return Box;
}

const _excluded$12 = ["variant"];

function isEmpty$1(string) {
  return string.length === 0;
}
/**
 * Generates string classKey based on the properties provided. It starts with the
 * variant if defined, and then it appends all other properties in alphabetical order.
 * @param {object} props - the properties for which the classKey should be created.
 */


function propsToClassKey(props) {
  const {
    variant
  } = props,
        other = _objectWithoutPropertiesLoose$4(props, _excluded$12);

  let classKey = variant || '';
  Object.keys(other).sort().forEach(key => {
    if (key === 'color') {
      classKey += isEmpty$1(classKey) ? props[key] : capitalize$2(props[key]);
    } else {
      classKey += `${isEmpty$1(classKey) ? key : capitalize$2(key)}${capitalize$2(props[key].toString())}`;
    }
  });
  return classKey;
}

const _excluded$11 = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"],
      _excluded2$4 = ["theme"],
      _excluded3 = ["theme"];

function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

const getStyleOverrides = (name, theme) => {
  if (theme.components && theme.components[name] && theme.components[name].styleOverrides) {
    return theme.components[name].styleOverrides;
  }

  return null;
};

const getVariantStyles = (name, theme) => {
  let variants = [];

  if (theme && theme.components && theme.components[name] && theme.components[name].variants) {
    variants = theme.components[name].variants;
  }

  const variantsStyles = {};
  variants.forEach(definition => {
    const key = propsToClassKey(definition.props);
    variantsStyles[key] = definition.style;
  });
  return variantsStyles;
};

const variantsResolver = (props, styles, theme, name) => {
  var _theme$components, _theme$components$nam;

  const {
    ownerState = {}
  } = props;
  const variantsStyles = [];
  const themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;

  if (themeVariants) {
    themeVariants.forEach(themeVariant => {
      let isMatch = true;
      Object.keys(themeVariant.props).forEach(key => {
        if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) {
          isMatch = false;
        }
      });

      if (isMatch) {
        variantsStyles.push(styles[propsToClassKey(themeVariant.props)]);
      }
    });
  }

  return variantsStyles;
};

function shouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}
const systemDefaultTheme = createTheme$1();

function createStyled(input = {}) {
  const {
    defaultTheme = systemDefaultTheme,
    rootShouldForwardProp = shouldForwardProp,
    slotShouldForwardProp = shouldForwardProp
  } = input;
  return (tag, inputOptions = {}) => {
    const {
      name: componentName,
      slot: componentSlot,
      skipVariantsResolver: inputSkipVariantsResolver,
      skipSx: inputSkipSx,
      overridesResolver
    } = inputOptions,
          options = _objectWithoutPropertiesLoose$4(inputOptions, _excluded$11); // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.


    const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : componentSlot && componentSlot !== 'Root' || false;
    const skipSx = inputSkipSx || false;
    let label;

    let shouldForwardPropOption = shouldForwardProp;

    if (componentSlot === 'Root') {
      shouldForwardPropOption = rootShouldForwardProp;
    } else if (componentSlot) {
      // any other slot specified
      shouldForwardPropOption = slotShouldForwardProp;
    }

    const defaultStyledResolver = styled$2(tag, _extends$7({
      shouldForwardProp: shouldForwardPropOption,
      label
    }, options));

    const muiStyledResolver = (styleArg, ...expressions) => {
      const expressionsWithDefaultTheme = expressions ? expressions.map(stylesArg => {
        return typeof stylesArg === 'function' ? _ref => {
          let {
            theme: themeInput
          } = _ref,
              other = _objectWithoutPropertiesLoose$4(_ref, _excluded2$4);

          return stylesArg(_extends$7({
            theme: isEmpty(themeInput) ? defaultTheme : themeInput
          }, other));
        } : stylesArg;
      }) : [];
      let transformedStyleArg = styleArg;

      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = isEmpty(props.theme) ? defaultTheme : props.theme;
          const styleOverrides = getStyleOverrides(componentName, theme);

          if (styleOverrides) {
            return overridesResolver(props, styleOverrides);
          }

          return null;
        });
      }

      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = isEmpty(props.theme) ? defaultTheme : props.theme;
          return variantsResolver(props, getVariantStyles(componentName, theme), theme, componentName);
        });
      }

      if (!skipSx) {
        expressionsWithDefaultTheme.push(props => {
          const theme = isEmpty(props.theme) ? defaultTheme : props.theme;
          return styleFunctionSx(_extends$7({}, props, {
            theme
          }));
        });
      }

      const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;

      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        const placeholders = new Array(numOfCustomFnsApplied).fill(''); // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.

        transformedStyleArg = [...styleArg, ...placeholders];
        transformedStyleArg.raw = [...styleArg.raw, ...placeholders];
      } else if (typeof styleArg === 'function') {
        // If the type is function, we need to define the default theme.
        transformedStyleArg = _ref2 => {
          let {
            theme: themeInput
          } = _ref2,
              other = _objectWithoutPropertiesLoose$4(_ref2, _excluded3);

          return styleArg(_extends$7({
            theme: isEmpty(themeInput) ? defaultTheme : themeInput
          }, other));
        };
      }

      const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);

      return Component;
    };

    return muiStyledResolver;
  };
}

/* eslint-disable no-restricted-syntax */
function getThemeProps(params) {
  const {
    theme,
    name,
    props
  } = params;

  if (!theme || !theme.components || !theme.components[name] || !theme.components[name].defaultProps) {
    return props;
  }

  const output = _extends$7({}, props); // Resolve default props, code borrow from React source.
  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221


  const defaultProps = theme.components[name].defaultProps;
  let propName;

  for (propName in defaultProps) {
    if (output[propName] === undefined) {
      output[propName] = defaultProps[propName];
    }
  }

  return output;
}

function useThemeProps$1({
  props,
  name,
  defaultTheme
}) {
  const theme = useTheme$1(defaultTheme);
  const mergedProps = getThemeProps({
    theme,
    name,
    props
  });
  return mergedProps;
}

/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value, min = 0, max = 1) {

  return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */


function hexToRgb(color) {
  color = color.substr(1);
  const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
  let colors = color.match(re);

  if (colors && colors[0].length === 1) {
    colors = colors.map(n => n + n);
  }

  return colors ? `rgb${colors.length === 4 ? 'a' : ''}(${colors.map((n, index) => {
    return index < 3 ? parseInt(n, 16) : Math.round(parseInt(n, 16) / 255 * 1000) / 1000;
  }).join(', ')})` : '';
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */


function decomposeColor(color) {
  // Idempotent
  if (color.type) {
    return color;
  }

  if (color.charAt(0) === '#') {
    return decomposeColor(hexToRgb(color));
  }

  const marker = color.indexOf('(');
  const type = color.substring(0, marker);

  if (['rgb', 'rgba', 'hsl', 'hsla', 'color'].indexOf(type) === -1) {
    throw new Error(formatMuiErrorMessage(9, color));
  }

  let values = color.substring(marker + 1, color.length - 1);
  let colorSpace;

  if (type === 'color') {
    values = values.split(' ');
    colorSpace = values.shift();

    if (values.length === 4 && values[3].charAt(0) === '/') {
      values[3] = values[3].substr(1);
    }

    if (['srgb', 'display-p3', 'a98-rgb', 'prophoto-rgb', 'rec-2020'].indexOf(colorSpace) === -1) {
      throw new Error(formatMuiErrorMessage(10, colorSpace));
    }
  } else {
    values = values.split(',');
  }

  values = values.map(value => parseFloat(value));
  return {
    type,
    values,
    colorSpace
  };
}
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */

function recomposeColor(color) {
  const {
    type,
    colorSpace
  } = color;
  let {
    values
  } = color;

  if (type.indexOf('rgb') !== -1) {
    // Only convert the first 3 values to int (i.e. not alpha)
    values = values.map((n, i) => i < 3 ? parseInt(n, 10) : n);
  } else if (type.indexOf('hsl') !== -1) {
    values[1] = `${values[1]}%`;
    values[2] = `${values[2]}%`;
  }

  if (type.indexOf('color') !== -1) {
    values = `${colorSpace} ${values.join(' ')}`;
  } else {
    values = `${values.join(', ')}`;
  }

  return `${type}(${values})`;
}
/**
 * Converts a color from hsl format to rgb format.
 * @param {string} color - HSL color values
 * @returns {string} rgb color values
 */

function hslToRgb(color) {
  color = decomposeColor(color);
  const {
    values
  } = color;
  const h = values[0];
  const s = values[1] / 100;
  const l = values[2] / 100;
  const a = s * Math.min(l, 1 - l);

  const f = (n, k = (n + h / 30) % 12) => l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);

  let type = 'rgb';
  const rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];

  if (color.type === 'hsla') {
    type += 'a';
    rgb.push(values[3]);
  }

  return recomposeColor({
    type,
    values: rgb
  });
}
/**
 * The relative brightness of any point in a color space,
 * normalized to 0 for darkest black and 1 for lightest white.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @returns {number} The relative brightness of the color in the range 0 - 1
 */

function getLuminance(color) {
  color = decomposeColor(color);
  let rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
  rgb = rgb.map(val => {
    if (color.type !== 'color') {
      val /= 255; // normalized
    }

    return val <= 0.03928 ? val / 12.92 : ((val + 0.055) / 1.055) ** 2.4;
  }); // Truncate at 3 digits

  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
}
/**
 * Calculates the contrast ratio between two colors.
 *
 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {number} A contrast ratio value in the range 0 - 21.
 */

function getContrastRatio(foreground, background) {
  const lumA = getLuminance(foreground);
  const lumB = getLuminance(background);
  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
}
/**
 * Sets the absolute transparency of a color.
 * Any existing alpha values are overwritten.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} value - value to set the alpha channel to in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function alpha(color, value) {
  color = decomposeColor(color);
  value = clamp(value);

  if (color.type === 'rgb' || color.type === 'hsl') {
    color.type += 'a';
  }

  if (color.type === 'color') {
    color.values[3] = `/${value}`;
  } else {
    color.values[3] = value;
  }

  return recomposeColor(color);
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function darken(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] *= 1 - coefficient;
  } else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] *= 1 - coefficient;
    }
  }

  return recomposeColor(color);
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */

function lighten(color, coefficient) {
  color = decomposeColor(color);
  coefficient = clamp(coefficient);

  if (color.type.indexOf('hsl') !== -1) {
    color.values[2] += (100 - color.values[2]) * coefficient;
  } else if (color.type.indexOf('rgb') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (255 - color.values[i]) * coefficient;
    }
  } else if (color.type.indexOf('color') !== -1) {
    for (let i = 0; i < 3; i += 1) {
      color.values[i] += (1 - color.values[i]) * coefficient;
    }
  }

  return recomposeColor(color);
}

function InnerThemeProvider$1(props) {
  const theme = useTheme$1();
  return /*#__PURE__*/jsxRuntime.exports.jsx(ThemeContext$3.Provider, {
    value: typeof theme === 'object' ? theme : {},
    children: props.children
  });
}
/**
 * This component makes the `theme` available down the React tree.
 * It should preferably be used at **the root of your component tree**.
 */

function ThemeProvider(props) {
  const {
    children,
    theme: localTheme
  } = props;
  return /*#__PURE__*/jsxRuntime.exports.jsx(ThemeProvider$1, {
    theme: localTheme,
    children: /*#__PURE__*/jsxRuntime.exports.jsx(InnerThemeProvider$1, {
      children: children
    })
  });
}

function createMixins(breakpoints, spacing, mixins) {
  return _extends$a({
    toolbar: {
      minHeight: 56,
      [`${breakpoints.up('xs')} and (orientation: landscape)`]: {
        minHeight: 48
      },
      [breakpoints.up('sm')]: {
        minHeight: 64
      }
    }
  }, mixins);
}

const common = {
  black: '#000',
  white: '#fff'
};
var common$1 = common;

const grey = {
  50: '#fafafa',
  100: '#f5f5f5',
  200: '#eeeeee',
  300: '#e0e0e0',
  400: '#bdbdbd',
  500: '#9e9e9e',
  600: '#757575',
  700: '#616161',
  800: '#424242',
  900: '#212121',
  A100: '#f5f5f5',
  A200: '#eeeeee',
  A400: '#bdbdbd',
  A700: '#616161'
};
var grey$1 = grey;

const purple = {
  50: '#f3e5f5',
  100: '#e1bee7',
  200: '#ce93d8',
  300: '#ba68c8',
  400: '#ab47bc',
  500: '#9c27b0',
  600: '#8e24aa',
  700: '#7b1fa2',
  800: '#6a1b9a',
  900: '#4a148c',
  A100: '#ea80fc',
  A200: '#e040fb',
  A400: '#d500f9',
  A700: '#aa00ff'
};
var purple$1 = purple;

const red = {
  50: '#ffebee',
  100: '#ffcdd2',
  200: '#ef9a9a',
  300: '#e57373',
  400: '#ef5350',
  500: '#f44336',
  600: '#e53935',
  700: '#d32f2f',
  800: '#c62828',
  900: '#b71c1c',
  A100: '#ff8a80',
  A200: '#ff5252',
  A400: '#ff1744',
  A700: '#d50000'
};
var red$1 = red;

const orange = {
  50: '#fff3e0',
  100: '#ffe0b2',
  200: '#ffcc80',
  300: '#ffb74d',
  400: '#ffa726',
  500: '#ff9800',
  600: '#fb8c00',
  700: '#f57c00',
  800: '#ef6c00',
  900: '#e65100',
  A100: '#ffd180',
  A200: '#ffab40',
  A400: '#ff9100',
  A700: '#ff6d00'
};
var orange$1 = orange;

const blue = {
  50: '#e3f2fd',
  100: '#bbdefb',
  200: '#90caf9',
  300: '#64b5f6',
  400: '#42a5f5',
  500: '#2196f3',
  600: '#1e88e5',
  700: '#1976d2',
  800: '#1565c0',
  900: '#0d47a1',
  A100: '#82b1ff',
  A200: '#448aff',
  A400: '#2979ff',
  A700: '#2962ff'
};
var blue$1 = blue;

const lightBlue = {
  50: '#e1f5fe',
  100: '#b3e5fc',
  200: '#81d4fa',
  300: '#4fc3f7',
  400: '#29b6f6',
  500: '#03a9f4',
  600: '#039be5',
  700: '#0288d1',
  800: '#0277bd',
  900: '#01579b',
  A100: '#80d8ff',
  A200: '#40c4ff',
  A400: '#00b0ff',
  A700: '#0091ea'
};
var lightBlue$1 = lightBlue;

const green = {
  50: '#e8f5e9',
  100: '#c8e6c9',
  200: '#a5d6a7',
  300: '#81c784',
  400: '#66bb6a',
  500: '#4caf50',
  600: '#43a047',
  700: '#388e3c',
  800: '#2e7d32',
  900: '#1b5e20',
  A100: '#b9f6ca',
  A200: '#69f0ae',
  A400: '#00e676',
  A700: '#00c853'
};
var green$1 = green;

const _excluded$10 = ["mode", "contrastThreshold", "tonalOffset"];
const light = {
  // The colors used to style the text.
  text: {
    // The most important text.
    primary: 'rgba(0, 0, 0, 0.87)',
    // Secondary text.
    secondary: 'rgba(0, 0, 0, 0.6)',
    // Disabled text have even lower visual prominence.
    disabled: 'rgba(0, 0, 0, 0.38)'
  },
  // The color used to divide different elements.
  divider: 'rgba(0, 0, 0, 0.12)',
  // The background colors used to style the surfaces.
  // Consistency between these values is important.
  background: {
    paper: common$1.white,
    default: common$1.white
  },
  // The colors used to style the action elements.
  action: {
    // The color of an active action like an icon button.
    active: 'rgba(0, 0, 0, 0.54)',
    // The color of an hovered action.
    hover: 'rgba(0, 0, 0, 0.04)',
    hoverOpacity: 0.04,
    // The color of a selected action.
    selected: 'rgba(0, 0, 0, 0.08)',
    selectedOpacity: 0.08,
    // The color of a disabled action.
    disabled: 'rgba(0, 0, 0, 0.26)',
    // The background color of a disabled action.
    disabledBackground: 'rgba(0, 0, 0, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(0, 0, 0, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.12
  }
};
const dark = {
  text: {
    primary: common$1.white,
    secondary: 'rgba(255, 255, 255, 0.7)',
    disabled: 'rgba(255, 255, 255, 0.5)',
    icon: 'rgba(255, 255, 255, 0.5)'
  },
  divider: 'rgba(255, 255, 255, 0.12)',
  background: {
    paper: '#121212',
    default: '#121212'
  },
  action: {
    active: common$1.white,
    hover: 'rgba(255, 255, 255, 0.08)',
    hoverOpacity: 0.08,
    selected: 'rgba(255, 255, 255, 0.16)',
    selectedOpacity: 0.16,
    disabled: 'rgba(255, 255, 255, 0.3)',
    disabledBackground: 'rgba(255, 255, 255, 0.12)',
    disabledOpacity: 0.38,
    focus: 'rgba(255, 255, 255, 0.12)',
    focusOpacity: 0.12,
    activatedOpacity: 0.24
  }
};

function addLightOrDark(intent, direction, shade, tonalOffset) {
  const tonalOffsetLight = tonalOffset.light || tonalOffset;
  const tonalOffsetDark = tonalOffset.dark || tonalOffset * 1.5;

  if (!intent[direction]) {
    if (intent.hasOwnProperty(shade)) {
      intent[direction] = intent[shade];
    } else if (direction === 'light') {
      intent.light = lighten(intent.main, tonalOffsetLight);
    } else if (direction === 'dark') {
      intent.dark = darken(intent.main, tonalOffsetDark);
    }
  }
}

function getDefaultPrimary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: blue$1[200],
      light: blue$1[50],
      dark: blue$1[400]
    };
  }

  return {
    main: blue$1[700],
    light: blue$1[400],
    dark: blue$1[800]
  };
}

function getDefaultSecondary(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: purple$1[200],
      light: purple$1[50],
      dark: purple$1[400]
    };
  }

  return {
    main: purple$1[500],
    light: purple$1[300],
    dark: purple$1[700]
  };
}

function getDefaultError(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: red$1[500],
      light: red$1[300],
      dark: red$1[700]
    };
  }

  return {
    main: red$1[700],
    light: red$1[400],
    dark: red$1[800]
  };
}

function getDefaultInfo(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: lightBlue$1[400],
      light: lightBlue$1[300],
      dark: lightBlue$1[700]
    };
  }

  return {
    main: lightBlue$1[700],
    light: lightBlue$1[500],
    dark: lightBlue$1[900]
  };
}

function getDefaultSuccess(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: green$1[400],
      light: green$1[300],
      dark: green$1[700]
    };
  }

  return {
    main: green$1[800],
    light: green$1[500],
    dark: green$1[900]
  };
}

function getDefaultWarning(mode = 'light') {
  if (mode === 'dark') {
    return {
      main: orange$1[400],
      light: orange$1[300],
      dark: orange$1[700]
    };
  }

  return {
    main: '#ED6C02',
    // closest to orange[800] that pass 3:1.
    light: orange$1[500],
    dark: orange$1[900]
  };
}

function createPalette(palette) {
  const {
    mode = 'light',
    contrastThreshold = 3,
    tonalOffset = 0.2
  } = palette,
        other = _objectWithoutPropertiesLoose$6(palette, _excluded$10);

  const primary = palette.primary || getDefaultPrimary(mode);
  const secondary = palette.secondary || getDefaultSecondary(mode);
  const error = palette.error || getDefaultError(mode);
  const info = palette.info || getDefaultInfo(mode);
  const success = palette.success || getDefaultSuccess(mode);
  const warning = palette.warning || getDefaultWarning(mode); // Use the same logic as
  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54

  function getContrastText(background) {
    const contrastText = getContrastRatio(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;

    return contrastText;
  }

  const augmentColor = ({
    color,
    name,
    mainShade = 500,
    lightShade = 300,
    darkShade = 700
  }) => {
    color = _extends$a({}, color);

    if (!color.main && color[mainShade]) {
      color.main = color[mainShade];
    }

    if (!color.hasOwnProperty('main')) {
      throw new Error(formatMuiErrorMessage(11, name ? ` (${name})` : '', mainShade));
    }

    if (typeof color.main !== 'string') {
      throw new Error(formatMuiErrorMessage(12, name ? ` (${name})` : '', JSON.stringify(color.main)));
    }

    addLightOrDark(color, 'light', lightShade, tonalOffset);
    addLightOrDark(color, 'dark', darkShade, tonalOffset);

    if (!color.contrastText) {
      color.contrastText = getContrastText(color.main);
    }

    return color;
  };

  const modes = {
    dark,
    light
  };

  const paletteOutput = deepmerge$2(_extends$a({
    // A collection of common colors.
    common: common$1,
    // The palette mode, can be light or dark.
    mode,
    // The colors used to represent primary interface elements for a user.
    primary: augmentColor({
      color: primary,
      name: 'primary'
    }),
    // The colors used to represent secondary interface elements for a user.
    secondary: augmentColor({
      color: secondary,
      name: 'secondary',
      mainShade: 'A400',
      lightShade: 'A200',
      darkShade: 'A700'
    }),
    // The colors used to represent interface elements that the user should be made aware of.
    error: augmentColor({
      color: error,
      name: 'error'
    }),
    // The colors used to represent potentially dangerous actions or important messages.
    warning: augmentColor({
      color: warning,
      name: 'warning'
    }),
    // The colors used to present information to the user that is neutral and not necessarily important.
    info: augmentColor({
      color: info,
      name: 'info'
    }),
    // The colors used to indicate the successful completion of an action that user triggered.
    success: augmentColor({
      color: success,
      name: 'success'
    }),
    // The grey colors.
    grey: grey$1,
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold,
    // Takes a background color and returns the text color that maximizes the contrast.
    getContrastText,
    // Generate a rich color object.
    augmentColor,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset
  }, modes[mode]), other);
  return paletteOutput;
}

const _excluded$$ = ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"];

function round$1(value) {
  return Math.round(value * 1e5) / 1e5;
}

const caseAllCaps = {
  textTransform: 'uppercase'
};
const defaultFontFamily$1 = '"Roboto", "Helvetica", "Arial", sans-serif';
/**
 * @see @link{https://material.io/design/typography/the-type-system.html}
 * @see @link{https://material.io/design/typography/understanding-typography.html}
 */

function createTypography(palette, typography) {
  const _ref = typeof typography === 'function' ? typography(palette) : typography,
        {
    fontFamily = defaultFontFamily$1,
    // The default font size of the Material Specification.
    fontSize = 14,
    // px
    fontWeightLight = 300,
    fontWeightRegular = 400,
    fontWeightMedium = 500,
    fontWeightBold = 700,
    // Tell MUI what's the font-size on the html element.
    // 16px is the default font-size used by browsers.
    htmlFontSize = 16,
    // Apply the CSS properties to all the variants.
    allVariants,
    pxToRem: pxToRem2
  } = _ref,
        other = _objectWithoutPropertiesLoose$6(_ref, _excluded$$);

  const coef = fontSize / 14;

  const pxToRem = pxToRem2 || (size => `${size / htmlFontSize * coef}rem`);

  const buildVariant = (fontWeight, size, lineHeight, letterSpacing, casing) => _extends$a({
    fontFamily,
    fontWeight,
    fontSize: pxToRem(size),
    // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
    lineHeight
  }, fontFamily === defaultFontFamily$1 ? {
    letterSpacing: `${round$1(letterSpacing / size)}em`
  } : {}, casing, allVariants);

  const variants = {
    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
  };
  return deepmerge$2(_extends$a({
    htmlFontSize,
    pxToRem,
    fontFamily,
    fontSize,
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightBold
  }, variants), other, {
    clone: false // No need to clone deep

  });
}

const shadowKeyUmbraOpacity = 0.2;
const shadowKeyPenumbraOpacity = 0.14;
const shadowAmbientShadowOpacity = 0.12;

function createShadow$1(...px) {
  return [`${px[0]}px ${px[1]}px ${px[2]}px ${px[3]}px rgba(0,0,0,${shadowKeyUmbraOpacity})`, `${px[4]}px ${px[5]}px ${px[6]}px ${px[7]}px rgba(0,0,0,${shadowKeyPenumbraOpacity})`, `${px[8]}px ${px[9]}px ${px[10]}px ${px[11]}px rgba(0,0,0,${shadowAmbientShadowOpacity})`].join(',');
} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss


const shadows$2 = ['none', createShadow$1(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow$1(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow$1(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow$1(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow$1(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow$1(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow$1(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow$1(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow$1(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow$1(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow$1(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow$1(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow$1(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow$1(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow$1(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow$1(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow$1(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow$1(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow$1(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow$1(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow$1(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow$1(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow$1(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow$1(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
var shadows$3 = shadows$2;

const _excluded$_ = ["duration", "easing", "delay"];
// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
// to learn the context in which each easing should be used.
const easing = {
  // This is the most common easing curve.
  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
  // Objects enter the screen at full velocity from off-screen and
  // slowly decelerate to a resting point.
  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
  // The sharp curve is used by objects that may return to the screen at any time.
  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
// to learn when use what timing

const duration = {
  shortest: 150,
  shorter: 200,
  short: 250,
  // most basic recommended timing
  standard: 300,
  // this is to be used in complex animations
  complex: 375,
  // recommended when something is entering screen
  enteringScreen: 225,
  // recommended when something is leaving screen
  leavingScreen: 195
};

function formatMs(milliseconds) {
  return `${Math.round(milliseconds)}ms`;
}

function getAutoHeightDuration(height) {
  if (!height) {
    return 0;
  }

  const constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10

  return Math.round((4 + 15 * constant ** 0.25 + constant / 5) * 10);
}

function createTransitions(inputTransitions) {
  const mergedEasing = _extends$a({}, easing, inputTransitions.easing);

  const mergedDuration = _extends$a({}, duration, inputTransitions.duration);

  const create = (props = ['all'], options = {}) => {
    const {
      duration: durationOption = mergedDuration.standard,
      easing: easingOption = mergedEasing.easeInOut,
      delay = 0
    } = options;
          _objectWithoutPropertiesLoose$6(options, _excluded$_);

    return (Array.isArray(props) ? props : [props]).map(animatedProp => `${animatedProp} ${typeof durationOption === 'string' ? durationOption : formatMs(durationOption)} ${easingOption} ${typeof delay === 'string' ? delay : formatMs(delay)}`).join(',');
  };

  return _extends$a({
    getAutoHeightDuration,
    create
  }, inputTransitions, {
    easing: mergedEasing,
    duration: mergedDuration
  });
}

// We need to centralize the zIndex definitions as they work
// like global values in the browser.
const zIndex = {
  mobileStepper: 1000,
  speedDial: 1050,
  appBar: 1100,
  drawer: 1200,
  modal: 1300,
  snackbar: 1400,
  tooltip: 1500
};
var zIndex$1 = zIndex;

const _excluded$Z = ["breakpoints", "mixins", "spacing", "palette", "transitions", "typography", "shape"];

function createTheme(options = {}, ...args) {
  const {
    mixins: mixinsInput = {},
    palette: paletteInput = {},
    transitions: transitionsInput = {},
    typography: typographyInput = {}
  } = options,
        other = _objectWithoutPropertiesLoose$6(options, _excluded$Z);

  const palette = createPalette(paletteInput);
  const systemTheme = createTheme$1(options);
  let muiTheme = deepmerge$2(systemTheme, {
    mixins: createMixins(systemTheme.breakpoints, systemTheme.spacing, mixinsInput),
    palette,
    // Don't use [...shadows] until you've verified its transpiled code is not invoking the iterator protocol.
    shadows: shadows$3.slice(),
    typography: createTypography(palette, typographyInput),
    transitions: createTransitions(transitionsInput),
    zIndex: _extends$a({}, zIndex$1)
  });
  muiTheme = deepmerge$2(muiTheme, other);
  muiTheme = args.reduce((acc, argument) => deepmerge$2(acc, argument), muiTheme);

  return muiTheme;
}

const defaultTheme$1 = createTheme();
var defaultTheme$2 = defaultTheme$1;

function useThemeProps({
  props,
  name
}) {
  return useThemeProps$1({
    props,
    name,
    defaultTheme: defaultTheme$2
  });
}

const rootShouldForwardProp$1 = prop => shouldForwardProp(prop) && prop !== 'classes';
const slotShouldForwardProp = shouldForwardProp;
const styled = createStyled({
  defaultTheme: defaultTheme$2,
  rootShouldForwardProp: rootShouldForwardProp$1
});
var styled$1 = styled;

function getSvgIconUtilityClass(slot) {
  return generateUtilityClass('MuiSvgIcon', slot);
}
generateUtilityClasses('MuiSvgIcon', ['root', 'colorPrimary', 'colorSecondary', 'colorAction', 'colorError', 'colorDisabled', 'fontSizeInherit', 'fontSizeSmall', 'fontSizeMedium', 'fontSizeLarge']);

const _excluded$Y = ["children", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"];

const useUtilityClasses$N = ownerState => {
  const {
    color,
    fontSize,
    classes
  } = ownerState;
  const slots = {
    root: ['root', color !== 'inherit' && `color${capitalize$2(color)}`, `fontSize${capitalize$2(fontSize)}`]
  };
  return composeClasses(slots, getSvgIconUtilityClass, classes);
};

const SvgIconRoot = styled$1('svg', {
  name: 'MuiSvgIcon',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'inherit' && styles[`color${capitalize$2(ownerState.color)}`], styles[`fontSize${capitalize$2(ownerState.fontSize)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  var _theme$palette$ownerS, _theme$palette$ownerS2;

  return {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter
    }),
    fontSize: {
      inherit: 'inherit',
      small: theme.typography.pxToRem(20),
      medium: theme.typography.pxToRem(24),
      large: theme.typography.pxToRem(35)
    }[ownerState.fontSize],
    // TODO v5 deprecate, v6 remove for sx
    color: (_theme$palette$ownerS = (_theme$palette$ownerS2 = theme.palette[ownerState.color]) == null ? void 0 : _theme$palette$ownerS2.main) != null ? _theme$palette$ownerS : {
      action: theme.palette.action.active,
      disabled: theme.palette.action.disabled,
      inherit: undefined
    }[ownerState.color]
  };
});
const SvgIcon = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function SvgIcon(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiSvgIcon'
  });

  const {
    children,
    className,
    color = 'inherit',
    component = 'svg',
    fontSize = 'medium',
    htmlColor,
    titleAccess,
    viewBox = '0 0 24 24'
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$Y);

  const ownerState = _extends$a({}, props, {
    color,
    component,
    fontSize,
    viewBox
  });

  const classes = useUtilityClasses$N(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsxs(SvgIconRoot, _extends$a({
    as: component,
    className: clsx(classes.root, className),
    ownerState: ownerState,
    focusable: "false",
    viewBox: viewBox,
    color: htmlColor,
    "aria-hidden": titleAccess ? undefined : true,
    role: titleAccess ? 'img' : undefined,
    ref: ref
  }, other, {
    children: [children, titleAccess ? /*#__PURE__*/jsxRuntime.exports.jsx("title", {
      children: titleAccess
    }) : null]
  }));
});
SvgIcon.muiName = 'SvgIcon';
var SvgIcon$1 = SvgIcon;

/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2017, Jon Schlinkert.
 * Released under the MIT License.
 */

var isobject = function isObject(val) {
  return val != null && typeof val === 'object' && Array.isArray(val) === false;
};

/*!
 * get-value <https://github.com/jonschlinkert/get-value>
 *
 * Copyright (c) 2014-2018, Jon Schlinkert.
 * Released under the MIT License.
 */

const isObject$7 = isobject;

var getValue$3 = function(target, path, options) {
  if (!isObject$7(options)) {
    options = { default: options };
  }

  if (!isValidObject(target)) {
    return typeof options.default !== 'undefined' ? options.default : target;
  }

  if (typeof path === 'number') {
    path = String(path);
  }

  const isArray = Array.isArray(path);
  const isString = typeof path === 'string';
  const splitChar = options.separator || '.';
  const joinChar = options.joinChar || (typeof splitChar === 'string' ? splitChar : '.');

  if (!isString && !isArray) {
    return target;
  }

  if (isString && path in target) {
    return isValid$2(path, target, options) ? target[path] : options.default;
  }

  let segs = isArray ? path : split$1(path, splitChar, options);
  let len = segs.length;
  let idx = 0;

  do {
    let prop = segs[idx];
    if (typeof prop === 'number') {
      prop = String(prop);
    }

    while (prop && prop.slice(-1) === '\\') {
      prop = join([prop.slice(0, -1), segs[++idx] || ''], joinChar, options);
    }

    if (prop in target) {
      if (!isValid$2(prop, target, options)) {
        return options.default;
      }

      target = target[prop];
    } else {
      let hasProp = false;
      let n = idx + 1;

      while (n < len) {
        prop = join([prop, segs[n++]], joinChar, options);

        if ((hasProp = prop in target)) {
          if (!isValid$2(prop, target, options)) {
            return options.default;
          }

          target = target[prop];
          idx = n - 1;
          break;
        }
      }

      if (!hasProp) {
        return options.default;
      }
    }
  } while (++idx < len && isValidObject(target));

  if (idx === len) {
    return target;
  }

  return options.default;
};

function join(segs, joinChar, options) {
  if (typeof options.join === 'function') {
    return options.join(segs);
  }
  return segs[0] + joinChar + segs[1];
}

function split$1(path, splitChar, options) {
  if (typeof options.split === 'function') {
    return options.split(path);
  }
  return path.split(splitChar);
}

function isValid$2(key, target, options) {
  if (typeof options.isValid === 'function') {
    return options.isValid(key, target);
  }
  return true;
}

function isValidObject(val) {
  return isObject$7(val) || Array.isArray(val) || typeof val === 'function';
}

var getValue$4 = getValue$3;

function useTheme() {
  const theme = useTheme$1(defaultTheme$2);

  return theme;
}

function getPaperUtilityClass(slot) {
  return generateUtilityClass('MuiPaper', slot);
}
generateUtilityClasses('MuiPaper', ['root', 'rounded', 'outlined', 'elevation', 'elevation0', 'elevation1', 'elevation2', 'elevation3', 'elevation4', 'elevation5', 'elevation6', 'elevation7', 'elevation8', 'elevation9', 'elevation10', 'elevation11', 'elevation12', 'elevation13', 'elevation14', 'elevation15', 'elevation16', 'elevation17', 'elevation18', 'elevation19', 'elevation20', 'elevation21', 'elevation22', 'elevation23', 'elevation24']);

const _excluded$X = ["className", "component", "elevation", "square", "variant"];

const getOverlayAlpha = elevation => {
  let alphaValue;

  if (elevation < 1) {
    alphaValue = 5.11916 * elevation ** 2;
  } else {
    alphaValue = 4.5 * Math.log(elevation + 1) + 2;
  }

  return (alphaValue / 100).toFixed(2);
};

const useUtilityClasses$M = ownerState => {
  const {
    square,
    elevation,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, !square && 'rounded', variant === 'elevation' && `elevation${elevation}`]
  };
  return composeClasses(slots, getPaperUtilityClass, classes);
};

const PaperRoot = styled$1('div', {
  name: 'MuiPaper',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], !ownerState.square && styles.rounded, ownerState.variant === 'elevation' && styles[`elevation${ownerState.elevation}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$a({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
  transition: theme.transitions.create('box-shadow')
}, !ownerState.square && {
  borderRadius: theme.shape.borderRadius
}, ownerState.variant === 'outlined' && {
  border: `1px solid ${theme.palette.divider}`
}, ownerState.variant === 'elevation' && _extends$a({
  boxShadow: theme.shadows[ownerState.elevation]
}, theme.palette.mode === 'dark' && {
  backgroundImage: `linear-gradient(${alpha('#fff', getOverlayAlpha(ownerState.elevation))}, ${alpha('#fff', getOverlayAlpha(ownerState.elevation))})`
})));
const Paper = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Paper(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPaper'
  });

  const {
    className,
    component = 'div',
    elevation = 1,
    square = false,
    variant = 'elevation'
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$X);

  const ownerState = _extends$a({}, props, {
    component,
    elevation,
    square,
    variant
  });

  const classes = useUtilityClasses$M(ownerState);

  return /*#__PURE__*/jsxRuntime.exports.jsx(PaperRoot, _extends$a({
    as: component,
    ownerState: ownerState,
    className: clsx(classes.root, className),
    ref: ref
  }, other));
});
var Paper$1 = Paper;

function getAlertUtilityClass(slot) {
  return generateUtilityClass('MuiAlert', slot);
}
const alertClasses = generateUtilityClasses('MuiAlert', ['root', 'action', 'icon', 'message', 'filled', 'filledSuccess', 'filledInfo', 'filledWarning', 'filledError', 'outlined', 'outlinedSuccess', 'outlinedInfo', 'outlinedWarning', 'outlinedError', 'standard', 'standardSuccess', 'standardInfo', 'standardWarning', 'standardError']);
var alertClasses$1 = alertClasses;

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var config = {
  disabled: false
};

var TransitionGroupContext = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createContext(null);

var UNMOUNTED = 'unmounted';
var EXITED = 'exited';
var ENTERING = 'entering';
var ENTERED = 'entered';
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

var Transition = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  } // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }
  ;

  var _proto = Transition.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      if (nextStatus === ENTERING) {
        this.performEnter(mounting);
      } else {
        this.performExit();
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context ? this.context.isMounting : mounting;

    var _ref2 = this.props.nodeRef ? [appearing] : [_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.a.findDOMNode(this), appearing],
        maybeNode = _ref2[0],
        maybeAppearing = _ref2[1];

    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter || config.disabled) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(maybeNode);
      });
      return;
    }

    this.props.onEnter(maybeNode, maybeAppearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(maybeNode, maybeAppearing);

      _this2.onTransitionEnd(enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(maybeNode, maybeAppearing);
        });
      });
    });
  };

  _proto.performExit = function performExit() {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts();
    var maybeNode = this.props.nodeRef ? undefined : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.a.findDOMNode(this); // no exit animation skip right to EXITED

    if (!exit || config.disabled) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(maybeNode);
      });
      return;
    }

    this.props.onExit(maybeNode);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(maybeNode);

      _this3.onTransitionEnd(timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(maybeNode);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
    this.setNextCallback(handler);
    var node = this.props.nodeRef ? this.props.nodeRef.current : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.a.findDOMNode(this);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      var _ref3 = this.props.nodeRef ? [this.nextCallback] : [node, this.nextCallback],
          maybeNode = _ref3[0],
          maybeNextCallback = _ref3[1];

      this.props.addEndListener(maybeNode, maybeNextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children;
        _this$props.in;
        _this$props.mountOnEnter;
        _this$props.unmountOnExit;
        _this$props.appear;
        _this$props.enter;
        _this$props.exit;
        _this$props.timeout;
        _this$props.addEndListener;
        _this$props.onEnter;
        _this$props.onEntering;
        _this$props.onEntered;
        _this$props.onExit;
        _this$props.onExiting;
        _this$props.onExited;
        _this$props.nodeRef;
        var childProps = _objectWithoutPropertiesLoose$7(_this$props, ["children", "in", "mountOnEnter", "unmountOnExit", "appear", "enter", "exit", "timeout", "addEndListener", "onEnter", "onEntering", "onEntered", "onExit", "onExiting", "onExited", "nodeRef"]);

    return (
      /*#__PURE__*/
      // allows for nested Transitions
      _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TransitionGroupContext.Provider, {
        value: null
      }, typeof children === 'function' ? children(status, childProps) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.cloneElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Children.only(children), childProps))
    );
  };

  return Transition;
}(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Component);

Transition.contextType = TransitionGroupContext;
Transition.propTypes = {}; // Name the function so it is clearer in the documentation

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = UNMOUNTED;
Transition.EXITED = EXITED;
Transition.ENTERING = ENTERING;
Transition.ENTERED = ENTERED;
Transition.EXITING = EXITING;
var Transition$1 = Transition;

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

/**
 * Given `this.props.children`, return an object mapping key to child.
 *
 * @param {*} children `this.props.children`
 * @return {object} Mapping of key to child
 */

function getChildMapping(children, mapFn) {
  var mapper = function mapper(child) {
    return mapFn && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.isValidElement(child) ? mapFn(child) : child;
  };

  var result = Object.create(null);
  if (children) _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Children.map(children, function (c) {
    return c;
  }).forEach(function (child) {
    // run the map function here instead so that the key is the computed one
    result[child.key] = mapper(child);
  });
  return result;
}
/**
 * When you're adding or removing children some may be added or removed in the
 * same render pass. We want to show *both* since we want to simultaneously
 * animate elements in and out. This function takes a previous set of keys
 * and a new set of keys and merges them with its best guess of the correct
 * ordering. In the future we may expose some of the utilities in
 * ReactMultiChild to make this easy, but for now React itself does not
 * directly have this concept of the union of prevChildren and nextChildren
 * so we implement it here.
 *
 * @param {object} prev prev children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @param {object} next next children as returned from
 * `ReactTransitionChildMapping.getChildMapping()`.
 * @return {object} a key set that contains all keys in `prev` and all keys
 * in `next` in a reasonable order.
 */

function mergeChildMappings(prev, next) {
  prev = prev || {};
  next = next || {};

  function getValueForKey(key) {
    return key in next ? next[key] : prev[key];
  } // For each key of `next`, the list of keys to insert before that key in
  // the combined list


  var nextKeysPending = Object.create(null);
  var pendingKeys = [];

  for (var prevKey in prev) {
    if (prevKey in next) {
      if (pendingKeys.length) {
        nextKeysPending[prevKey] = pendingKeys;
        pendingKeys = [];
      }
    } else {
      pendingKeys.push(prevKey);
    }
  }

  var i;
  var childMapping = {};

  for (var nextKey in next) {
    if (nextKeysPending[nextKey]) {
      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
        var pendingNextKey = nextKeysPending[nextKey][i];
        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
      }
    }

    childMapping[nextKey] = getValueForKey(nextKey);
  } // Finally, add the keys which didn't appear before any key in `next`


  for (i = 0; i < pendingKeys.length; i++) {
    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
  }

  return childMapping;
}

function getProp(child, prop, props) {
  return props[prop] != null ? props[prop] : child.props[prop];
}

function getInitialChildMapping(props, onExited) {
  return getChildMapping(props.children, function (child) {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(child, {
      onExited: onExited.bind(null, child),
      in: true,
      appear: getProp(child, 'appear', props),
      enter: getProp(child, 'enter', props),
      exit: getProp(child, 'exit', props)
    });
  });
}
function getNextChildMapping(nextProps, prevChildMapping, onExited) {
  var nextChildMapping = getChildMapping(nextProps.children);
  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
  Object.keys(children).forEach(function (key) {
    var child = children[key];
    if (!_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.isValidElement(child)) return;
    var hasPrev = (key in prevChildMapping);
    var hasNext = (key in nextChildMapping);
    var prevChild = prevChildMapping[key];
    var isLeaving = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.isValidElement(prevChild) && !prevChild.props.in; // item is new (entering)

    if (hasNext && (!hasPrev || isLeaving)) {
      // console.log('entering', key)
      children[key] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: true,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    } else if (!hasNext && hasPrev && !isLeaving) {
      // item is old (exiting)
      // console.log('leaving', key)
      children[key] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(child, {
        in: false
      });
    } else if (hasNext && hasPrev && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.isValidElement(prevChild)) {
      // item hasn't changed transition states
      // copy over the last transition props;
      // console.log('unchanged', key)
      children[key] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(child, {
        onExited: onExited.bind(null, child),
        in: prevChild.props.in,
        exit: getProp(child, 'exit', nextProps),
        enter: getProp(child, 'enter', nextProps)
      });
    }
  });
  return children;
}

var values = Object.values || function (obj) {
  return Object.keys(obj).map(function (k) {
    return obj[k];
  });
};

var defaultProps$1 = {
  component: 'div',
  childFactory: function childFactory(child) {
    return child;
  }
};
/**
 * The `<TransitionGroup>` component manages a set of transition components
 * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
 * components, `<TransitionGroup>` is a state machine for managing the mounting
 * and unmounting of components over time.
 *
 * Consider the example below. As items are removed or added to the TodoList the
 * `in` prop is toggled automatically by the `<TransitionGroup>`.
 *
 * Note that `<TransitionGroup>`  does not define any animation behavior!
 * Exactly _how_ a list item animates is up to the individual transition
 * component. This means you can mix and match animations across different list
 * items.
 */

var TransitionGroup = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(TransitionGroup, _React$Component);

  function TransitionGroup(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;

    var handleExited = _this.handleExited.bind(_assertThisInitialized(_this)); // Initial children should all be entering, dependent on appear


    _this.state = {
      contextValue: {
        isMounting: true
      },
      handleExited: handleExited,
      firstRender: true
    };
    return _this;
  }

  var _proto = TransitionGroup.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this.mounted = true;
    this.setState({
      contextValue: {
        isMounting: false
      }
    });
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.mounted = false;
  };

  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
    var prevChildMapping = _ref.children,
        handleExited = _ref.handleExited,
        firstRender = _ref.firstRender;
    return {
      children: firstRender ? getInitialChildMapping(nextProps, handleExited) : getNextChildMapping(nextProps, prevChildMapping, handleExited),
      firstRender: false
    };
  } // node is `undefined` when user provided `nodeRef` prop
  ;

  _proto.handleExited = function handleExited(child, node) {
    var currentChildMapping = getChildMapping(this.props.children);
    if (child.key in currentChildMapping) return;

    if (child.props.onExited) {
      child.props.onExited(node);
    }

    if (this.mounted) {
      this.setState(function (state) {
        var children = _extends$c({}, state.children);

        delete children[child.key];
        return {
          children: children
        };
      });
    }
  };

  _proto.render = function render() {
    var _this$props = this.props,
        Component = _this$props.component,
        childFactory = _this$props.childFactory,
        props = _objectWithoutPropertiesLoose$7(_this$props, ["component", "childFactory"]);

    var contextValue = this.state.contextValue;
    var children = values(this.state.children).map(childFactory);
    delete props.appear;
    delete props.enter;
    delete props.exit;

    if (Component === null) {
      return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TransitionGroupContext.Provider, {
        value: contextValue
      }, children);
    }

    return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TransitionGroupContext.Provider, {
      value: contextValue
    }, /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Component, props, children));
  };

  return TransitionGroup;
}(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Component);

TransitionGroup.propTypes = {};
TransitionGroup.defaultProps = defaultProps$1;
var TransitionGroup$1 = TransitionGroup;

function Ripple(props) {
  const {
    className,
    classes,
    pulsate = false,
    rippleX,
    rippleY,
    rippleSize,
    in: inProp,
    onExited,
    timeout
  } = props;
  const [leaving, setLeaving] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
  const rippleClassName = clsx(className, classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
  const rippleStyles = {
    width: rippleSize,
    height: rippleSize,
    top: -(rippleSize / 2) + rippleY,
    left: -(rippleSize / 2) + rippleX
  };
  const childClassName = clsx(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);

  if (!inProp && !leaving) {
    setLeaving(true);
  }

  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    if (!inProp && onExited != null) {
      // react-transition-group#onExited
      const timeoutId = setTimeout(onExited, timeout);
      return () => {
        clearTimeout(timeoutId);
      };
    }

    return undefined;
  }, [onExited, inProp, timeout]);
  return /*#__PURE__*/jsxRuntime.exports.jsx("span", {
    className: rippleClassName,
    style: rippleStyles,
    children: /*#__PURE__*/jsxRuntime.exports.jsx("span", {
      className: childClassName
    })
  });
}

const touchRippleClasses = generateUtilityClasses('MuiTouchRipple', ['root', 'ripple', 'rippleVisible', 'ripplePulsate', 'child', 'childLeaving', 'childPulsate']);
var touchRippleClasses$1 = touchRippleClasses;

const _excluded$W = ["center", "classes", "className"];

let _$5 = t => t,
    _t$4,
    _t2$3,
    _t3$3,
    _t4$3;
const DURATION = 550;
const DELAY_RIPPLE = 80;
const enterKeyframe = keyframes(_t$4 || (_t$4 = _$5`
  0% {
    transform: scale(0);
    opacity: 0.1;
  }

  100% {
    transform: scale(1);
    opacity: 0.3;
  }
`));
const exitKeyframe = keyframes(_t2$3 || (_t2$3 = _$5`
  0% {
    opacity: 1;
  }

  100% {
    opacity: 0;
  }
`));
const pulsateKeyframe = keyframes(_t3$3 || (_t3$3 = _$5`
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(0.92);
  }

  100% {
    transform: scale(1);
  }
`));
const TouchRippleRoot = styled$1('span', {
  name: 'MuiTouchRipple',
  slot: 'Root',
  skipSx: true
})({
  overflow: 'hidden',
  pointerEvents: 'none',
  position: 'absolute',
  zIndex: 0,
  top: 0,
  right: 0,
  bottom: 0,
  left: 0,
  borderRadius: 'inherit'
}); // This `styled()` function invokes keyframes. `styled-components` only supports keyframes
// in string templates. Do not convert these styles in JS object as it will break.

const TouchRippleRipple = styled$1(Ripple, {
  name: 'MuiTouchRipple',
  slot: 'Ripple'
})(_t4$3 || (_t4$3 = _$5`
  opacity: 0;
  position: absolute;

  &.${0} {
    opacity: 0.3;
    transform: scale(1);
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  &.${0} {
    animation-duration: ${0}ms;
  }

  & .${0} {
    opacity: 1;
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: currentColor;
  }

  & .${0} {
    opacity: 0;
    animation-name: ${0};
    animation-duration: ${0}ms;
    animation-timing-function: ${0};
  }

  & .${0} {
    position: absolute;
    /* @noflip */
    left: 0px;
    top: 0;
    animation-name: ${0};
    animation-duration: 2500ms;
    animation-timing-function: ${0};
    animation-iteration-count: infinite;
    animation-delay: 200ms;
  }
`), touchRippleClasses$1.rippleVisible, enterKeyframe, DURATION, ({
  theme
}) => theme.transitions.easing.easeInOut, touchRippleClasses$1.ripplePulsate, ({
  theme
}) => theme.transitions.duration.shorter, touchRippleClasses$1.child, touchRippleClasses$1.childLeaving, exitKeyframe, DURATION, ({
  theme
}) => theme.transitions.easing.easeInOut, touchRippleClasses$1.childPulsate, pulsateKeyframe, ({
  theme
}) => theme.transitions.easing.easeInOut);
/**
 * @ignore - internal component.
 *
 * TODO v5: Make private
 */

const TouchRipple = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function TouchRipple(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTouchRipple'
  });

  const {
    center: centerProp = false,
    classes = {},
    className
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$W);

  const [ripples, setRipples] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState([]);
  const nextKey = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(0);
  const rippleCallback = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    if (rippleCallback.current) {
      rippleCallback.current();
      rippleCallback.current = null;
    }
  }, [ripples]); // Used to filter out mouse emulated events on mobile.

  const ignoringMouseDown = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
  // We don't want to display the ripple for touch scroll events.

  const startTimer = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null); // This is the hook called once the previous timeout is ready.

  const startTimerCommit = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const container = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    return () => {
      clearTimeout(startTimer.current);
    };
  }, []);
  const startCommit = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(params => {
    const {
      pulsate,
      rippleX,
      rippleY,
      rippleSize,
      cb
    } = params;
    setRipples(oldRipples => [...oldRipples, /*#__PURE__*/jsxRuntime.exports.jsx(TouchRippleRipple, {
      classes: {
        ripple: clsx(classes.ripple, touchRippleClasses$1.ripple),
        rippleVisible: clsx(classes.rippleVisible, touchRippleClasses$1.rippleVisible),
        ripplePulsate: clsx(classes.ripplePulsate, touchRippleClasses$1.ripplePulsate),
        child: clsx(classes.child, touchRippleClasses$1.child),
        childLeaving: clsx(classes.childLeaving, touchRippleClasses$1.childLeaving),
        childPulsate: clsx(classes.childPulsate, touchRippleClasses$1.childPulsate)
      },
      timeout: DURATION,
      pulsate: pulsate,
      rippleX: rippleX,
      rippleY: rippleY,
      rippleSize: rippleSize
    }, nextKey.current)]);
    nextKey.current += 1;
    rippleCallback.current = cb;
  }, [classes]);
  const start = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((event = {}, options = {}, cb) => {
    const {
      pulsate = false,
      center = centerProp || options.pulsate,
      fakeElement = false // For test purposes

    } = options;

    if (event.type === 'mousedown' && ignoringMouseDown.current) {
      ignoringMouseDown.current = false;
      return;
    }

    if (event.type === 'touchstart') {
      ignoringMouseDown.current = true;
    }

    const element = fakeElement ? null : container.current;
    const rect = element ? element.getBoundingClientRect() : {
      width: 0,
      height: 0,
      left: 0,
      top: 0
    }; // Get the size of the ripple

    let rippleX;
    let rippleY;
    let rippleSize;

    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
      rippleX = Math.round(rect.width / 2);
      rippleY = Math.round(rect.height / 2);
    } else {
      const {
        clientX,
        clientY
      } = event.touches ? event.touches[0] : event;
      rippleX = Math.round(clientX - rect.left);
      rippleY = Math.round(clientY - rect.top);
    }

    if (center) {
      rippleSize = Math.sqrt((2 * rect.width ** 2 + rect.height ** 2) / 3); // For some reason the animation is broken on Mobile Chrome if the size is even.

      if (rippleSize % 2 === 0) {
        rippleSize += 1;
      }
    } else {
      const sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
      const sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
      rippleSize = Math.sqrt(sizeX ** 2 + sizeY ** 2);
    } // Touche devices


    if (event.touches) {
      // check that this isn't another touchstart due to multitouch
      // otherwise we will only clear a single timer when unmounting while two
      // are running
      if (startTimerCommit.current === null) {
        // Prepare the ripple effect.
        startTimerCommit.current = () => {
          startCommit({
            pulsate,
            rippleX,
            rippleY,
            rippleSize,
            cb
          });
        }; // Delay the execution of the ripple effect.


        startTimer.current = setTimeout(() => {
          if (startTimerCommit.current) {
            startTimerCommit.current();
            startTimerCommit.current = null;
          }
        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
      }
    } else {
      startCommit({
        pulsate,
        rippleX,
        rippleY,
        rippleSize,
        cb
      });
    }
  }, [centerProp, startCommit]);
  const pulsate = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
    start({}, {
      pulsate: true
    });
  }, [start]);
  const stop = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((event, cb) => {
    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
    // We still want to show ripple effect.

    if (event.type === 'touchend' && startTimerCommit.current) {
      startTimerCommit.current();
      startTimerCommit.current = null;
      startTimer.current = setTimeout(() => {
        stop(event, cb);
      });
      return;
    }

    startTimerCommit.current = null;
    setRipples(oldRipples => {
      if (oldRipples.length > 0) {
        return oldRipples.slice(1);
      }

      return oldRipples;
    });
    rippleCallback.current = cb;
  }, []);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useImperativeHandle(ref, () => ({
    pulsate,
    start,
    stop
  }), [pulsate, start, stop]);
  return /*#__PURE__*/jsxRuntime.exports.jsx(TouchRippleRoot, _extends$a({
    className: clsx(classes.root, touchRippleClasses$1.root, className),
    ref: container
  }, other, {
    children: /*#__PURE__*/jsxRuntime.exports.jsx(TransitionGroup$1, {
      component: null,
      exit: true,
      children: ripples
    })
  }));
});
var TouchRipple$1 = TouchRipple;

function getButtonBaseUtilityClass(slot) {
  return generateUtilityClass('MuiButtonBase', slot);
}
const buttonBaseClasses = generateUtilityClasses('MuiButtonBase', ['root', 'disabled', 'focusVisible']);
var buttonBaseClasses$1 = buttonBaseClasses;

const _excluded$V = ["action", "centerRipple", "children", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "LinkComponent", "onBlur", "onClick", "onContextMenu", "onDragLeave", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "tabIndex", "TouchRippleProps", "type"];

const useUtilityClasses$L = ownerState => {
  const {
    disabled,
    focusVisible,
    focusVisibleClassName,
    classes
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', focusVisible && 'focusVisible']
  };
  const composedClasses = composeClasses(slots, getButtonBaseUtilityClass, classes);

  if (focusVisible && focusVisibleClassName) {
    composedClasses.root += ` ${focusVisibleClassName}`;
  }

  return composedClasses;
};

const ButtonBaseRoot = styled$1('button', {
  name: 'MuiButtonBase',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  boxSizing: 'border-box',
  WebkitTapHighlightColor: 'transparent',
  backgroundColor: 'transparent',
  // Reset default value
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  border: 0,
  margin: 0,
  // Remove the margin in Safari
  borderRadius: 0,
  padding: 0,
  // Remove the padding in Firefox
  cursor: 'pointer',
  userSelect: 'none',
  verticalAlign: 'middle',
  MozAppearance: 'none',
  // Reset
  WebkitAppearance: 'none',
  // Reset
  textDecoration: 'none',
  // So we take precedent over the style of a native <a /> element.
  color: 'inherit',
  '&::-moz-focus-inner': {
    borderStyle: 'none' // Remove Firefox dotted outline.

  },
  [`&.${buttonBaseClasses$1.disabled}`]: {
    pointerEvents: 'none',
    // Disable link interactions
    cursor: 'default'
  },
  '@media print': {
    colorAdjust: 'exact'
  }
});
/**
 * `ButtonBase` contains as few styles as possible.
 * It aims to be a simple building block for creating a button.
 * It contains a load of style reset and some focus/ripple logic.
 */

const ButtonBase = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function ButtonBase(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiButtonBase'
  });

  const {
    action,
    centerRipple = false,
    children,
    className,
    component = 'button',
    disabled = false,
    disableRipple = false,
    disableTouchRipple = false,
    focusRipple = false,
    LinkComponent = 'a',
    onBlur,
    onClick,
    onContextMenu,
    onDragLeave,
    onFocus,
    onFocusVisible,
    onKeyDown,
    onKeyUp,
    onMouseDown,
    onMouseLeave,
    onMouseUp,
    onTouchEnd,
    onTouchMove,
    onTouchStart,
    tabIndex = 0,
    TouchRippleProps,
    type
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$V);

  const buttonRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const rippleRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const {
    isFocusVisibleRef,
    onFocus: handleFocusVisible,
    onBlur: handleBlurVisible,
    ref: focusVisibleRef
  } = useIsFocusVisible();
  const [focusVisible, setFocusVisible] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);

  if (disabled && focusVisible) {
    setFocusVisible(false);
  }

  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useImperativeHandle(action, () => ({
    focusVisible: () => {
      setFocusVisible(true);
      buttonRef.current.focus();
    }
  }), []);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    if (focusVisible && focusRipple && !disableRipple) {
      rippleRef.current.pulsate();
    }
  }, [disableRipple, focusRipple, focusVisible]);

  function useRippleHandler(rippleAction, eventCallback, skipRippleAction = disableTouchRipple) {
    return useEventCallback$1(event => {
      if (eventCallback) {
        eventCallback(event);
      }

      const ignore = skipRippleAction;

      if (!ignore && rippleRef.current) {
        rippleRef.current[rippleAction](event);
      }

      return true;
    });
  }

  const handleMouseDown = useRippleHandler('start', onMouseDown);
  const handleContextMenu = useRippleHandler('stop', onContextMenu);
  const handleDragLeave = useRippleHandler('stop', onDragLeave);
  const handleMouseUp = useRippleHandler('stop', onMouseUp);
  const handleMouseLeave = useRippleHandler('stop', event => {
    if (focusVisible) {
      event.preventDefault();
    }

    if (onMouseLeave) {
      onMouseLeave(event);
    }
  });
  const handleTouchStart = useRippleHandler('start', onTouchStart);
  const handleTouchEnd = useRippleHandler('stop', onTouchEnd);
  const handleTouchMove = useRippleHandler('stop', onTouchMove);
  const handleBlur = useRippleHandler('stop', event => {
    handleBlurVisible(event);

    if (isFocusVisibleRef.current === false) {
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  }, false);
  const handleFocus = useEventCallback$1(event => {
    // Fix for https://github.com/facebook/react/issues/7769
    if (!buttonRef.current) {
      buttonRef.current = event.currentTarget;
    }

    handleFocusVisible(event);

    if (isFocusVisibleRef.current === true) {
      setFocusVisible(true);

      if (onFocusVisible) {
        onFocusVisible(event);
      }
    }

    if (onFocus) {
      onFocus(event);
    }
  });

  const isNonNativeButton = () => {
    const button = buttonRef.current;
    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
  };
  /**
   * IE11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
   */


  const keydownRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(false);
  const handleKeyDown = useEventCallback$1(event => {
    // Check if key is already down to avoid repeats being counted as multiple activations
    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
      keydownRef.current = true;
      rippleRef.current.stop(event, () => {
        rippleRef.current.start(event);
      });
    }

    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    } // Keyboard accessibility for non interactive elements


    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
      event.preventDefault();

      if (onClick) {
        onClick(event);
      }
    }
  });
  const handleKeyUp = useEventCallback$1(event => {
    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
      keydownRef.current = false;
      rippleRef.current.stop(event, () => {
        rippleRef.current.pulsate(event);
      });
    }

    if (onKeyUp) {
      onKeyUp(event);
    } // Keyboard accessibility for non interactive elements


    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
      onClick(event);
    }
  });
  let ComponentProp = component;

  if (ComponentProp === 'button' && (other.href || other.to)) {
    ComponentProp = LinkComponent;
  }

  const buttonProps = {};

  if (ComponentProp === 'button') {
    buttonProps.type = type === undefined ? 'button' : type;
    buttonProps.disabled = disabled;
  } else {
    if (!other.href && !other.to) {
      buttonProps.role = 'button';
    }

    if (disabled) {
      buttonProps['aria-disabled'] = disabled;
    }
  }

  const handleOwnRef = useForkRef(focusVisibleRef, buttonRef);
  const handleRef = useForkRef(ref, handleOwnRef);
  const [mountedState, setMountedState] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    setMountedState(true);
  }, []);
  const enableTouchRipple = mountedState && !disableRipple && !disabled;

  const ownerState = _extends$a({}, props, {
    centerRipple,
    component,
    disabled,
    disableRipple,
    disableTouchRipple,
    focusRipple,
    tabIndex,
    focusVisible
  });

  const classes = useUtilityClasses$L(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsxs(ButtonBaseRoot, _extends$a({
    as: ComponentProp,
    className: clsx(classes.root, className),
    ownerState: ownerState,
    onBlur: handleBlur,
    onClick: onClick,
    onContextMenu: handleContextMenu,
    onFocus: handleFocus,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    onMouseDown: handleMouseDown,
    onMouseLeave: handleMouseLeave,
    onMouseUp: handleMouseUp,
    onDragLeave: handleDragLeave,
    onTouchEnd: handleTouchEnd,
    onTouchMove: handleTouchMove,
    onTouchStart: handleTouchStart,
    ref: handleRef,
    tabIndex: disabled ? -1 : tabIndex,
    type: type
  }, buttonProps, other, {
    children: [children, enableTouchRipple ?
    /*#__PURE__*/

    /* TouchRipple is only needed client-side, x2 boost on the server. */
    jsxRuntime.exports.jsx(TouchRipple$1, _extends$a({
      ref: rippleRef,
      center: centerRipple
    }, TouchRippleProps)) : null]
  }));
});
var ButtonBase$1 = ButtonBase;

function getIconButtonUtilityClass(slot) {
  return generateUtilityClass('MuiIconButton', slot);
}
const iconButtonClasses = generateUtilityClasses('MuiIconButton', ['root', 'disabled', 'colorInherit', 'colorPrimary', 'colorSecondary', 'edgeStart', 'edgeEnd', 'sizeSmall', 'sizeMedium', 'sizeLarge']);
var iconButtonClasses$1 = iconButtonClasses;

const _excluded$U = ["edge", "children", "className", "color", "disabled", "disableFocusRipple", "size"];

const useUtilityClasses$K = ownerState => {
  const {
    classes,
    disabled,
    color,
    edge,
    size
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', color !== 'default' && `color${capitalize$2(color)}`, edge && `edge${capitalize$2(edge)}`, `size${capitalize$2(size)}`]
  };
  return composeClasses(slots, getIconButtonUtilityClass, classes);
};

const IconButtonRoot = styled$1(ButtonBase$1, {
  name: 'MuiIconButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.color !== 'default' && styles[`color${capitalize$2(ownerState.color)}`], ownerState.edge && styles[`edge${capitalize$2(ownerState.edge)}`], styles[`size${capitalize$2(ownerState.size)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$a({
  textAlign: 'center',
  flex: '0 0 auto',
  fontSize: theme.typography.pxToRem(24),
  padding: 8,
  borderRadius: '50%',
  overflow: 'visible',
  // Explicitly set the default value to solve a bug on IE11.
  color: theme.palette.action.active,
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  }),
  '&:hover': {
    backgroundColor: alpha(theme.palette.action.active, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.edge === 'start' && {
  marginLeft: ownerState.size === 'small' ? -3 : -12
}, ownerState.edge === 'end' && {
  marginRight: ownerState.size === 'small' ? -3 : -12
}), ({
  theme,
  ownerState
}) => _extends$a({}, ownerState.color === 'inherit' && {
  color: 'inherit'
}, ownerState.color !== 'inherit' && ownerState.color !== 'default' && {
  color: theme.palette[ownerState.color].main,
  '&:hover': {
    backgroundColor: alpha(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.size === 'small' && {
  padding: 5,
  fontSize: theme.typography.pxToRem(18)
}, ownerState.size === 'large' && {
  padding: 12,
  fontSize: theme.typography.pxToRem(28)
}, {
  [`&.${iconButtonClasses$1.disabled}`]: {
    backgroundColor: 'transparent',
    color: theme.palette.action.disabled
  }
}));
/**
 * Refer to the [Icons](/components/icons/) section of the documentation
 * regarding the available icon options.
 */

const IconButton = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function IconButton(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiIconButton'
  });

  const {
    edge = false,
    children,
    className,
    color = 'default',
    disabled = false,
    disableFocusRipple = false,
    size = 'medium'
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$U);

  const ownerState = _extends$a({}, props, {
    edge,
    color,
    disabled,
    disableFocusRipple,
    size
  });

  const classes = useUtilityClasses$K(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(IconButtonRoot, _extends$a({
    className: clsx(classes.root, className),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: children
  }));
});
var IconButton$1 = IconButton;

function createSvgIcon$1(path, displayName) {
  const Component = (props, ref) => /*#__PURE__*/jsxRuntime.exports.jsx(SvgIcon$1, _extends$a({
    "data-testid": `${displayName}Icon`,
    ref: ref
  }, props, {
    children: path
  }));

  Component.muiName = SvgIcon$1.muiName;
  return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo( /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(Component));
}

var SuccessOutlinedIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M20,12A8,8 0 0,1 12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4C12.76,4 13.5,4.11 14.2, 4.31L15.77,2.74C14.61,2.26 13.34,2 12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0, 0 22,12M7.91,10.08L6.5,11.5L11,16L21,6L19.59,4.58L11,13.17L7.91,10.08Z"
}), 'SuccessOutlined');

var ReportProblemOutlinedIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M12 5.99L19.53 19H4.47L12 5.99M12 2L1 21h22L12 2zm1 14h-2v2h2v-2zm0-6h-2v4h2v-4z"
}), 'ReportProblemOutlined');

var ErrorOutlineIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'ErrorOutline');

var InfoOutlinedIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M11,9H13V7H11M12,20C7.59,20 4,16.41 4,12C4,7.59 7.59,4 12,4C16.41,4 20,7.59 20, 12C20,16.41 16.41,20 12,20M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10, 10 0 0,0 12,2M11,17H13V11H11V17Z"
}), 'InfoOutlined');

var ClearIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}), 'Close');

var _CloseIcon;

const _excluded$T = ["action", "children", "className", "closeText", "color", "icon", "iconMapping", "onClose", "role", "severity", "variant"];

const useUtilityClasses$J = ownerState => {
  const {
    variant,
    color,
    severity,
    classes
  } = ownerState;
  const slots = {
    root: ['root', `${variant}${capitalize$2(color || severity)}`, `${variant}`],
    icon: ['icon'],
    message: ['message'],
    action: ['action']
  };
  return composeClasses(slots, getAlertUtilityClass, classes);
};

const AlertRoot = styled$1(Paper$1, {
  name: 'MuiAlert',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`${ownerState.variant}${capitalize$2(ownerState.color || ownerState.severity)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  const getColor = theme.palette.mode === 'light' ? darken : lighten;
  const getBackgroundColor = theme.palette.mode === 'light' ? lighten : darken;
  const color = ownerState.color || ownerState.severity;
  return _extends$a({}, theme.typography.body2, {
    borderRadius: theme.shape.borderRadius,
    backgroundColor: 'transparent',
    display: 'flex',
    padding: '6px 16px'
  }, color && ownerState.variant === 'standard' && {
    color: getColor(theme.palette[color].light, 0.6),
    backgroundColor: getBackgroundColor(theme.palette[color].light, 0.9),
    [`& .${alertClasses$1.icon}`]: {
      color: theme.palette.mode === 'dark' ? theme.palette[color].main : theme.palette[color].light
    }
  }, color && ownerState.variant === 'outlined' && {
    color: getColor(theme.palette[color].light, 0.6),
    border: `1px solid ${theme.palette[color].light}`,
    [`& .${alertClasses$1.icon}`]: {
      color: theme.palette.mode === 'dark' ? theme.palette[color].main : theme.palette[color].light
    }
  }, color && ownerState.variant === 'filled' && {
    color: '#fff',
    fontWeight: theme.typography.fontWeightMedium,
    backgroundColor: theme.palette.mode === 'dark' ? theme.palette[color].dark : theme.palette[color].main
  });
});
const AlertIcon = styled$1('div', {
  name: 'MuiAlert',
  slot: 'Icon',
  overridesResolver: (props, styles) => styles.icon
})({
  marginRight: 12,
  padding: '7px 0',
  display: 'flex',
  fontSize: 22,
  opacity: 0.9
});
const AlertMessage = styled$1('div', {
  name: 'MuiAlert',
  slot: 'Message',
  overridesResolver: (props, styles) => styles.message
})({
  padding: '8px 0'
});
const AlertAction = styled$1('div', {
  name: 'MuiAlert',
  slot: 'Action',
  overridesResolver: (props, styles) => styles.action
})({
  display: 'flex',
  alignItems: 'flex-start',
  padding: '4px 0 0 16px',
  marginLeft: 'auto',
  marginRight: -8
});
const defaultIconMapping = {
  success: /*#__PURE__*/jsxRuntime.exports.jsx(SuccessOutlinedIcon, {
    fontSize: "inherit"
  }),
  warning: /*#__PURE__*/jsxRuntime.exports.jsx(ReportProblemOutlinedIcon, {
    fontSize: "inherit"
  }),
  error: /*#__PURE__*/jsxRuntime.exports.jsx(ErrorOutlineIcon, {
    fontSize: "inherit"
  }),
  info: /*#__PURE__*/jsxRuntime.exports.jsx(InfoOutlinedIcon, {
    fontSize: "inherit"
  })
};
const Alert$2 = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Alert(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiAlert'
  });

  const {
    action,
    children,
    className,
    closeText = 'Close',
    color,
    icon,
    iconMapping = defaultIconMapping,
    onClose,
    role = 'alert',
    severity = 'success',
    variant = 'standard'
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$T);

  const ownerState = _extends$a({}, props, {
    color,
    severity,
    variant
  });

  const classes = useUtilityClasses$J(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsxs(AlertRoot, _extends$a({
    role: role,
    square: true,
    elevation: 0,
    ownerState: ownerState,
    className: clsx(classes.root, className),
    ref: ref
  }, other, {
    children: [icon !== false ? /*#__PURE__*/jsxRuntime.exports.jsx(AlertIcon, {
      ownerState: ownerState,
      className: classes.icon,
      children: icon || iconMapping[severity] || defaultIconMapping[severity]
    }) : null, /*#__PURE__*/jsxRuntime.exports.jsx(AlertMessage, {
      ownerState: ownerState,
      className: classes.message,
      children: children
    }), action != null ? /*#__PURE__*/jsxRuntime.exports.jsx(AlertAction, {
      className: classes.action,
      children: action
    }) : null, action == null && onClose ? /*#__PURE__*/jsxRuntime.exports.jsx(AlertAction, {
      ownerState: ownerState,
      className: classes.action,
      children: /*#__PURE__*/jsxRuntime.exports.jsx(IconButton$1, {
        size: "small",
        "aria-label": closeText,
        title: closeText,
        color: "inherit",
        onClick: onClose,
        children: _CloseIcon || (_CloseIcon = /*#__PURE__*/jsxRuntime.exports.jsx(ClearIcon, {
          fontSize: "small"
        }))
      })
    }) : null]
  }));
});
var Alert$1$1 = Alert$2;

var Person = createSvgIcon$1( /*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
}), 'Person');

function getAvatarUtilityClass(slot) {
  return generateUtilityClass('MuiAvatar', slot);
}
generateUtilityClasses('MuiAvatar', ['root', 'colorDefault', 'circular', 'rounded', 'square', 'img', 'fallback']);

const _excluded$S = ["alt", "children", "className", "component", "imgProps", "sizes", "src", "srcSet", "variant"];

const useUtilityClasses$I = ownerState => {
  const {
    classes,
    variant,
    colorDefault
  } = ownerState;
  const slots = {
    root: ['root', variant, colorDefault && 'colorDefault'],
    img: ['img'],
    fallback: ['fallback']
  };
  return composeClasses(slots, getAvatarUtilityClass, classes);
};

const AvatarRoot = styled$1('div', {
  name: 'MuiAvatar',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], ownerState.colorDefault && styles.colorDefault];
  }
})(({
  theme,
  ownerState
}) => _extends$a({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  width: 40,
  height: 40,
  fontFamily: theme.typography.fontFamily,
  fontSize: theme.typography.pxToRem(20),
  lineHeight: 1,
  borderRadius: '50%',
  overflow: 'hidden',
  userSelect: 'none'
}, ownerState.variant === 'rounded' && {
  borderRadius: theme.shape.borderRadius
}, ownerState.variant === 'square' && {
  borderRadius: 0
}, ownerState.colorDefault && {
  color: theme.palette.background.default,
  backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
}));
const AvatarImg = styled$1('img', {
  name: 'MuiAvatar',
  slot: 'Img',
  overridesResolver: (props, styles) => styles.img
})({
  width: '100%',
  height: '100%',
  textAlign: 'center',
  // Handle non-square image. The property isn't supported by IE11.
  objectFit: 'cover',
  // Hide alt text.
  color: 'transparent',
  // Hide the image broken icon, only works on Chrome.
  textIndent: 10000
});
const AvatarFallback = styled$1(Person, {
  name: 'MuiAvatar',
  slot: 'Fallback',
  overridesResolver: (props, styles) => styles.fallback
})({
  width: '75%',
  height: '75%'
});

function useLoaded({
  crossOrigin,
  referrerPolicy,
  src,
  srcSet
}) {
  const [loaded, setLoaded] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    if (!src && !srcSet) {
      return undefined;
    }

    setLoaded(false);
    let active = true;
    const image = new Image();

    image.onload = () => {
      if (!active) {
        return;
      }

      setLoaded('loaded');
    };

    image.onerror = () => {
      if (!active) {
        return;
      }

      setLoaded('error');
    };

    image.crossOrigin = crossOrigin;
    image.referrerPolicy = referrerPolicy;
    image.src = src;

    if (srcSet) {
      image.srcset = srcSet;
    }

    return () => {
      active = false;
    };
  }, [crossOrigin, referrerPolicy, src, srcSet]);
  return loaded;
}

const Avatar$2 = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Avatar(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiAvatar'
  });

  const {
    alt,
    children: childrenProp,
    className,
    component = 'div',
    imgProps,
    sizes,
    src,
    srcSet,
    variant = 'circular'
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$S);

  let children = null; // Use a hook instead of onError on the img element to support server-side rendering.

  const loaded = useLoaded(_extends$a({}, imgProps, {
    src,
    srcSet
  }));
  const hasImg = src || srcSet;
  const hasImgNotFailing = hasImg && loaded !== 'error';

  const ownerState = _extends$a({}, props, {
    colorDefault: !hasImgNotFailing,
    component,
    variant
  });

  const classes = useUtilityClasses$I(ownerState);

  if (hasImgNotFailing) {
    children = /*#__PURE__*/jsxRuntime.exports.jsx(AvatarImg, _extends$a({
      alt: alt,
      src: src,
      srcSet: srcSet,
      sizes: sizes,
      ownerState: ownerState,
      className: classes.img
    }, imgProps));
  } else if (childrenProp != null) {
    children = childrenProp;
  } else if (hasImg && alt) {
    children = alt[0];
  } else {
    children = /*#__PURE__*/jsxRuntime.exports.jsx(AvatarFallback, {
      className: classes.fallback
    });
  }

  return /*#__PURE__*/jsxRuntime.exports.jsx(AvatarRoot, _extends$a({
    as: component,
    ownerState: ownerState,
    className: clsx(classes.root, className),
    ref: ref
  }, other, {
    children: children
  }));
});
var Avatar$1$1 = Avatar$2;

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _extends$5() {
  _extends$5 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$5.apply(this, arguments);
}

var utils = /*#__PURE__*/Object.freeze({
	__proto__: null,
	capitalize: capitalize$2,
	createChainedFunction: createChainedFunction,
	createSvgIcon: createSvgIcon$1,
	debounce: debounce$1,
	deprecatedPropType: deprecatedPropType,
	isMuiElement: isMuiElement,
	ownerDocument: ownerDocument,
	ownerWindow: ownerWindow,
	requirePropFactory: requirePropFactory,
	setRef: setRef,
	unstable_useEnhancedEffect: useEnhancedEffect$1,
	unstable_useId: useId,
	unsupportedProp: unsupportedProp,
	useControlled: useControlled,
	useEventCallback: useEventCallback$1,
	useForkRef: useForkRef,
	useIsFocusVisible: useIsFocusVisible
});

// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
// Emulate the sass function "unit"

function getUnit(input) {
  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
} // Emulate the sass function "unitless"

function toUnitless(length) {
  return parseFloat(length);
} // Convert any CSS <length> or <percentage> value to any another.

function getButtonUtilityClass(slot) {
  return generateUtilityClass('MuiButton', slot);
}
const buttonClasses = generateUtilityClasses('MuiButton', ['root', 'text', 'textInherit', 'textPrimary', 'textSecondary', 'outlined', 'outlinedInherit', 'outlinedPrimary', 'outlinedSecondary', 'contained', 'containedInherit', 'containedPrimary', 'containedSecondary', 'disableElevation', 'focusVisible', 'disabled', 'colorInherit', 'textSizeSmall', 'textSizeMedium', 'textSizeLarge', 'outlinedSizeSmall', 'outlinedSizeMedium', 'outlinedSizeLarge', 'containedSizeSmall', 'containedSizeMedium', 'containedSizeLarge', 'sizeMedium', 'sizeSmall', 'sizeLarge', 'fullWidth', 'startIcon', 'endIcon', 'iconSizeSmall', 'iconSizeMedium', 'iconSizeLarge']);
var buttonClasses$1 = buttonClasses;

const _excluded$R = ["children", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"];

const useUtilityClasses$H = ownerState => {
  const {
    color,
    disableElevation,
    fullWidth,
    size,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, `${variant}${capitalize$2(color)}`, `size${capitalize$2(size)}`, `${variant}Size${capitalize$2(size)}`, color === 'inherit' && 'colorInherit', disableElevation && 'disableElevation', fullWidth && 'fullWidth'],
    label: ['label'],
    startIcon: ['startIcon', `iconSize${capitalize$2(size)}`],
    endIcon: ['endIcon', `iconSize${capitalize$2(size)}`]
  };
  const composedClasses = composeClasses(slots, getButtonUtilityClass, classes);
  return _extends$a({}, classes, composedClasses);
};

const commonIconStyles = ownerState => _extends$a({}, ownerState.size === 'small' && {
  '& > *:nth-of-type(1)': {
    fontSize: 18
  }
}, ownerState.size === 'medium' && {
  '& > *:nth-of-type(1)': {
    fontSize: 20
  }
}, ownerState.size === 'large' && {
  '& > *:nth-of-type(1)': {
    fontSize: 22
  }
});

const ButtonRoot = styled$1(ButtonBase$1, {
  shouldForwardProp: prop => rootShouldForwardProp$1(prop) || prop === 'classes',
  name: 'MuiButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`${ownerState.variant}${capitalize$2(ownerState.color)}`], styles[`size${capitalize$2(ownerState.size)}`], styles[`${ownerState.variant}Size${capitalize$2(ownerState.size)}`], ownerState.color === 'inherit' && styles.colorInherit, ownerState.disableElevation && styles.disableElevation, ownerState.fullWidth && styles.fullWidth];
  }
})(({
  theme,
  ownerState
}) => _extends$a({}, theme.typography.button, {
  minWidth: 64,
  padding: '6px 16px',
  borderRadius: theme.shape.borderRadius,
  transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color', 'color'], {
    duration: theme.transitions.duration.short
  }),
  '&:hover': _extends$a({
    textDecoration: 'none',
    backgroundColor: alpha(theme.palette.text.primary, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
    backgroundColor: alpha(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
    border: `1px solid ${theme.palette[ownerState.color].main}`,
    backgroundColor: alpha(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }, ownerState.variant === 'contained' && {
    backgroundColor: theme.palette.grey.A100,
    boxShadow: theme.shadows[4],
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      boxShadow: theme.shadows[2],
      backgroundColor: theme.palette.grey[300]
    }
  }, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
    backgroundColor: theme.palette[ownerState.color].dark,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: theme.palette[ownerState.color].main
    }
  }),
  '&:active': _extends$a({}, ownerState.variant === 'contained' && {
    boxShadow: theme.shadows[8]
  }),
  [`&.${buttonClasses$1.focusVisible}`]: _extends$a({}, ownerState.variant === 'contained' && {
    boxShadow: theme.shadows[6]
  }),
  [`&.${buttonClasses$1.disabled}`]: _extends$a({
    color: theme.palette.action.disabled
  }, ownerState.variant === 'outlined' && {
    border: `1px solid ${theme.palette.action.disabledBackground}`
  }, ownerState.variant === 'outlined' && ownerState.color === 'secondary' && {
    border: `1px solid ${theme.palette.action.disabled}`
  }, ownerState.variant === 'contained' && {
    color: theme.palette.action.disabled,
    boxShadow: theme.shadows[0],
    backgroundColor: theme.palette.action.disabledBackground
  })
}, ownerState.variant === 'text' && {
  padding: '6px 8px'
}, ownerState.variant === 'text' && ownerState.color !== 'inherit' && {
  color: theme.palette[ownerState.color].main
}, ownerState.variant === 'outlined' && {
  padding: '5px 15px',
  border: `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`
}, ownerState.variant === 'outlined' && ownerState.color !== 'inherit' && {
  color: theme.palette[ownerState.color].main,
  border: `1px solid ${alpha(theme.palette[ownerState.color].main, 0.5)}`
}, ownerState.variant === 'contained' && {
  color: theme.palette.getContrastText(theme.palette.grey[300]),
  backgroundColor: theme.palette.grey[300],
  boxShadow: theme.shadows[2]
}, ownerState.variant === 'contained' && ownerState.color !== 'inherit' && {
  color: theme.palette[ownerState.color].contrastText,
  backgroundColor: theme.palette[ownerState.color].main
}, ownerState.color === 'inherit' && {
  color: 'inherit',
  borderColor: 'currentColor'
}, ownerState.size === 'small' && ownerState.variant === 'text' && {
  padding: '4px 5px',
  fontSize: theme.typography.pxToRem(13)
}, ownerState.size === 'large' && ownerState.variant === 'text' && {
  padding: '8px 11px',
  fontSize: theme.typography.pxToRem(15)
}, ownerState.size === 'small' && ownerState.variant === 'outlined' && {
  padding: '3px 9px',
  fontSize: theme.typography.pxToRem(13)
}, ownerState.size === 'large' && ownerState.variant === 'outlined' && {
  padding: '7px 21px',
  fontSize: theme.typography.pxToRem(15)
}, ownerState.size === 'small' && ownerState.variant === 'contained' && {
  padding: '4px 10px',
  fontSize: theme.typography.pxToRem(13)
}, ownerState.size === 'large' && ownerState.variant === 'contained' && {
  padding: '8px 22px',
  fontSize: theme.typography.pxToRem(15)
}, ownerState.fullWidth && {
  width: '100%'
}), ({
  ownerState
}) => ownerState.disableElevation && {
  boxShadow: 'none',
  '&:hover': {
    boxShadow: 'none'
  },
  [`&.${buttonClasses$1.focusVisible}`]: {
    boxShadow: 'none'
  },
  '&:active': {
    boxShadow: 'none'
  },
  [`&.${buttonClasses$1.disabled}`]: {
    boxShadow: 'none'
  }
});
const ButtonStartIcon = styled$1('span', {
  name: 'MuiButton',
  slot: 'StartIcon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.startIcon, styles[`iconSize${capitalize$2(ownerState.size)}`]];
  }
})(({
  ownerState
}) => _extends$a({
  display: 'inherit',
  marginRight: 8,
  marginLeft: -4
}, ownerState.size === 'small' && {
  marginLeft: -2
}, commonIconStyles(ownerState)));
const ButtonEndIcon = styled$1('span', {
  name: 'MuiButton',
  slot: 'EndIcon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.endIcon, styles[`iconSize${capitalize$2(ownerState.size)}`]];
  }
})(({
  ownerState
}) => _extends$a({
  display: 'inherit',
  marginRight: -4,
  marginLeft: 8
}, ownerState.size === 'small' && {
  marginRight: -2
}, commonIconStyles(ownerState)));
const Button$2 = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Button(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiButton'
  });

  const {
    children,
    color = 'primary',
    component = 'button',
    disabled = false,
    disableElevation = false,
    disableFocusRipple = false,
    endIcon: endIconProp,
    focusVisibleClassName,
    fullWidth = false,
    size = 'medium',
    startIcon: startIconProp,
    type,
    variant = 'text'
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$R);

  const ownerState = _extends$a({}, props, {
    color,
    component,
    disabled,
    disableElevation,
    disableFocusRipple,
    fullWidth,
    size,
    type,
    variant
  });

  const classes = useUtilityClasses$H(ownerState);

  const startIcon = startIconProp && /*#__PURE__*/jsxRuntime.exports.jsx(ButtonStartIcon, {
    className: classes.startIcon,
    ownerState: ownerState,
    children: startIconProp
  });

  const endIcon = endIconProp && /*#__PURE__*/jsxRuntime.exports.jsx(ButtonEndIcon, {
    className: classes.endIcon,
    ownerState: ownerState,
    children: endIconProp
  });

  return /*#__PURE__*/jsxRuntime.exports.jsxs(ButtonRoot, _extends$a({
    ownerState: ownerState,
    component: component,
    disabled: disabled,
    focusRipple: !disableFocusRipple,
    focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
    ref: ref,
    type: type
  }, other, {
    classes: classes,
    children: [startIcon, children, endIcon]
  }));
});
var Button$3 = Button$2;

function getCircularProgressUtilityClass(slot) {
  return generateUtilityClass('MuiCircularProgress', slot);
}
generateUtilityClasses('MuiCircularProgress', ['root', 'determinate', 'indeterminate', 'colorPrimary', 'colorSecondary', 'svg', 'circle', 'circleDeterminate', 'circleIndeterminate', 'circleDisableShrink']);

const _excluded$Q = ["className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"];

let _$4 = t => t,
    _t$3,
    _t2$2,
    _t3$2,
    _t4$2;
const SIZE = 44;
const circularRotateKeyframe = keyframes(_t$3 || (_t$3 = _$4`
  0% {
    transform: rotate(0deg);
  }

  100% {
    transform: rotate(360deg);
  }
`));
const circularDashKeyframe = keyframes(_t2$2 || (_t2$2 = _$4`
  0% {
    stroke-dasharray: 1px, 200px;
    stroke-dashoffset: 0;
  }

  50% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -15px;
  }

  100% {
    stroke-dasharray: 100px, 200px;
    stroke-dashoffset: -125px;
  }
`));

const useUtilityClasses$G = ownerState => {
  const {
    classes,
    variant,
    color,
    disableShrink
  } = ownerState;
  const slots = {
    root: ['root', variant, `color${capitalize$2(color)}`],
    svg: ['svg'],
    circle: ['circle', `circle${capitalize$2(variant)}`, disableShrink && 'circleDisableShrink']
  };
  return composeClasses(slots, getCircularProgressUtilityClass, classes);
};

const CircularProgressRoot = styled$1('span', {
  name: 'MuiCircularProgress',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`color${capitalize$2(ownerState.color)}`]];
  }
})(({
  ownerState,
  theme
}) => _extends$a({
  display: 'inline-block'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('transform')
}, ownerState.color !== 'inherit' && {
  color: theme.palette[ownerState.color].main
}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && css(_t3$2 || (_t3$2 = _$4`
      animation: ${0} 1.4s linear infinite;
    `), circularRotateKeyframe));
const CircularProgressSVG = styled$1('svg', {
  name: 'MuiCircularProgress',
  slot: 'Svg',
  overridesResolver: (props, styles) => styles.svg
})({
  display: 'block' // Keeps the progress centered

});
const CircularProgressCircle = styled$1('circle', {
  name: 'MuiCircularProgress',
  slot: 'Circle',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.circle, styles[`circle${capitalize$2(ownerState.variant)}`], ownerState.disableShrink && styles.circleDisableShrink];
  }
})(({
  ownerState,
  theme
}) => _extends$a({
  stroke: 'currentColor'
}, ownerState.variant === 'determinate' && {
  transition: theme.transitions.create('stroke-dashoffset')
}, ownerState.variant === 'indeterminate' && {
  // Some default value that looks fine waiting for the animation to kicks in.
  strokeDasharray: '80px, 200px',
  strokeDashoffset: 0 // Add the unit to fix a Edge 16 and below bug.

}), ({
  ownerState
}) => ownerState.variant === 'indeterminate' && !ownerState.disableShrink && css(_t4$2 || (_t4$2 = _$4`
      animation: ${0} 1.4s ease-in-out infinite;
    `), circularDashKeyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

const CircularProgress = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function CircularProgress(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiCircularProgress'
  });

  const {
    className,
    color = 'primary',
    disableShrink = false,
    size = 40,
    style,
    thickness = 3.6,
    value = 0,
    variant = 'indeterminate'
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$Q);

  const ownerState = _extends$a({}, props, {
    color,
    disableShrink,
    size,
    thickness,
    value,
    variant
  });

  const classes = useUtilityClasses$G(ownerState);
  const circleStyle = {};
  const rootStyle = {};
  const rootProps = {};

  if (variant === 'determinate') {
    const circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
    circleStyle.strokeDasharray = circumference.toFixed(3);
    rootProps['aria-valuenow'] = Math.round(value);
    circleStyle.strokeDashoffset = `${((100 - value) / 100 * circumference).toFixed(3)}px`;
    rootStyle.transform = 'rotate(-90deg)';
  }

  return /*#__PURE__*/jsxRuntime.exports.jsx(CircularProgressRoot, _extends$a({
    className: clsx(classes.root, className),
    style: _extends$a({
      width: size,
      height: size
    }, rootStyle, style),
    ownerState: ownerState,
    ref: ref,
    role: "progressbar"
  }, rootProps, other, {
    children: /*#__PURE__*/jsxRuntime.exports.jsx(CircularProgressSVG, {
      className: classes.svg,
      ownerState: ownerState,
      viewBox: `${SIZE / 2} ${SIZE / 2} ${SIZE} ${SIZE}`,
      children: /*#__PURE__*/jsxRuntime.exports.jsx(CircularProgressCircle, {
        className: classes.circle,
        style: circleStyle,
        ownerState: ownerState,
        cx: SIZE,
        cy: SIZE,
        r: (SIZE - thickness) / 2,
        fill: "none",
        strokeWidth: thickness
      })
    })
  }));
});
var CircularProgress$1 = CircularProgress;

function getLoadingButtonUtilityClass(slot) {
  return generateUtilityClass('MuiLoadingButton', slot);
}
const loadingButtonClasses = generateUtilityClasses('MuiLoadingButton', ['root', 'loading', 'loadingIndicator', 'loadingIndicatorCenter', 'loadingIndicatorStart', 'loadingIndicatorEnd', 'endIconLoadingEnd', 'startIconLoadingStart']);
var loadingButtonClasses$1 = loadingButtonClasses;

const _excluded$P = ["children", "disabled", "loading", "loadingIndicator", "loadingPosition"];

const useUtilityClasses$F = ownerState => {
  const {
    loading,
    loadingPosition,
    classes
  } = ownerState;
  const slots = {
    root: ['root', loading && 'loading'],
    startIcon: [loading && `startIconLoading${capitalize$2(loadingPosition)}`],
    endIcon: [loading && `endIconLoading${capitalize$2(loadingPosition)}`],
    loadingIndicator: ['loadingIndicator', loading && `loadingIndicator${capitalize$2(loadingPosition)}`]
  };
  const composedClasses = composeClasses(slots, getLoadingButtonUtilityClass, classes);
  return _extends$5({}, classes, composedClasses);
}; // TODO use `import { rootShouldForwardProp } from '../styles/styled';` once move to core


const rootShouldForwardProp = prop => prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as' && prop !== 'classes';

const LoadingButtonRoot = styled$1(Button$3, {
  shouldForwardProp: prop => rootShouldForwardProp(prop) || prop === 'classes',
  name: 'MuiLoadingButton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    return [styles.root, styles.startIconLoadingStart && {
      [`& .${loadingButtonClasses$1.startIconLoadingStart}`]: styles.startIconLoadingStart
    }, styles.endIconLoadingEnd && {
      [`& .${loadingButtonClasses$1.endIconLoadingEnd}`]: styles.endIconLoadingEnd
    }];
  }
})(({
  ownerState,
  theme
}) => _extends$5({
  [`& .${loadingButtonClasses$1.startIconLoadingStart}, & .${loadingButtonClasses$1.endIconLoadingEnd}`]: {
    transition: theme.transitions.create(['opacity'], {
      duration: theme.transitions.duration.short
    }),
    opacity: 0
  }
}, ownerState.loadingPosition === 'center' && {
  transition: theme.transitions.create(['background-color', 'box-shadow', 'border-color'], {
    duration: theme.transitions.duration.short
  }),
  [`&.${loadingButtonClasses$1.loading}`]: {
    color: 'transparent'
  }
}));
const LoadingButtonLoadingIndicator = styled$1('div', {
  name: 'MuiLoadingButton',
  slot: 'LoadingIndicator',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.loadingIndicator, styles[`loadingIndicator${capitalize$2(ownerState.loadingPosition)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$5({
  position: 'absolute',
  visibility: 'visible',
  display: 'flex'
}, ownerState.loadingPosition === 'start' && {
  left: 14
}, ownerState.loadingPosition === 'center' && {
  left: '50%',
  transform: 'translate(-50%)',
  color: theme.palette.action.disabled
}, ownerState.loadingPosition === 'end' && {
  right: 14
}));

const LoadingIndicator = /*#__PURE__*/jsxRuntime.exports.jsx(CircularProgress$1, {
  color: "inherit",
  size: 16
});

const LoadingButton = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function LoadingButton(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiLoadingButton'
  });

  const {
    children,
    disabled = false,
    loading = false,
    loadingIndicator = LoadingIndicator,
    loadingPosition = 'center'
  } = props,
        other = _objectWithoutPropertiesLoose$3(props, _excluded$P);

  const ownerState = _extends$5({}, props, {
    disabled,
    loading,
    loadingIndicator,
    loadingPosition
  });

  const classes = useUtilityClasses$F(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsxs(LoadingButtonRoot, _extends$5({
    disabled: disabled || loading,
    ref: ref
  }, other, {
    classes: classes,
    ownerState: ownerState,
    children: [loading && /*#__PURE__*/jsxRuntime.exports.jsx(LoadingButtonLoadingIndicator, {
      className: classes.loadingIndicator,
      ownerState: ownerState,
      children: loadingIndicator
    }), children]
  }));
});
var MuiLoadingButton = LoadingButton;

const reflow = node => node.scrollTop;
function getTransitionProps(props, options) {
  var _style$transitionDura, _style$transitionTimi;

  const {
    timeout,
    easing,
    style = {}
  } = props;
  return {
    duration: (_style$transitionDura = style.transitionDuration) != null ? _style$transitionDura : typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
    easing: (_style$transitionTimi = style.transitionTimingFunction) != null ? _style$transitionTimi : typeof easing === 'object' ? easing[options.mode] : easing,
    delay: style.transitionDelay
  };
}

const _excluded$O = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];
const styles$2 = {
  entering: {
    opacity: 1
  },
  entered: {
    opacity: 1
  }
};
const defaultTimeout = {
  enter: duration.enteringScreen,
  exit: duration.leavingScreen
};
/**
 * The Fade transition is used by the [Modal](/components/modal/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

const Fade = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Fade(props, ref) {
  const {
    addEndListener,
    appear = true,
    children,
    easing,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    style,
    timeout = defaultTimeout,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Transition$1
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$O);

  const theme = useTheme();
  const nodeRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const foreignRef = useForkRef(children.ref, ref);
  const handleRef = useForkRef(nodeRef, foreignRef);

  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.

      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };

  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    reflow(node); // So the animation always start from the start.

    const transitionProps = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
    node.style.transition = theme.transitions.create('opacity', transitionProps);

    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);

  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };

  return /*#__PURE__*/jsxRuntime.exports.jsx(TransitionComponent, _extends$a({
    appear: appear,
    in: inProp,
    nodeRef: nodeRef ,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(children, _extends$a({
        style: _extends$a({
          opacity: 0,
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, styles$2[state], style, children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
var Fade$1 = Fade;

const _excluded$N = ["children", "components", "componentsProps", "className", "invisible", "open", "transitionDuration", "TransitionComponent"];

const extendUtilityClasses$1 = ownerState => {
  const {
    classes
  } = ownerState;
  return classes;
};

const BackdropRoot = styled$1('div', {
  name: 'MuiBackdrop',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.invisible && styles.invisible];
  }
})(({
  ownerState
}) => _extends$a({
  position: 'fixed',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  right: 0,
  bottom: 0,
  top: 0,
  left: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  WebkitTapHighlightColor: 'transparent'
}, ownerState.invisible && {
  backgroundColor: 'transparent'
}));
const Backdrop = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Backdrop(inProps, ref) {
  var _componentsProps$root;

  const props = useThemeProps({
    props: inProps,
    name: 'MuiBackdrop'
  });

  const {
    children,
    components = {},
    componentsProps = {},
    className,
    invisible = false,
    open,
    transitionDuration,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Fade$1
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$N);

  const ownerState = _extends$a({}, props, {
    invisible
  });

  const classes = extendUtilityClasses$1(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(TransitionComponent, _extends$a({
    in: open,
    timeout: transitionDuration
  }, other, {
    children: /*#__PURE__*/jsxRuntime.exports.jsx(BackdropUnstyled$1, {
      className: className,
      invisible: invisible,
      components: _extends$a({
        Root: BackdropRoot
      }, components),
      componentsProps: {
        root: _extends$a({}, componentsProps.root, (!components.Root || !isHostComponent(components.Root)) && {
          ownerState: _extends$a({}, (_componentsProps$root = componentsProps.root) == null ? void 0 : _componentsProps$root.ownerState)
        })
      },
      classes: classes,
      ref: ref,
      children: children
    })
  }));
});
var Backdrop$1 = Backdrop;

const _excluded$M = ["BackdropComponent", "closeAfterTransition", "children", "components", "componentsProps", "disableAutoFocus", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted"];

const extendUtilityClasses = ownerState => {
  return ownerState.classes;
};

const ModalRoot = styled$1('div', {
  name: 'MuiModal',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.open && ownerState.exited && styles.hidden];
  }
})(({
  theme,
  ownerState
}) => _extends$a({
  position: 'fixed',
  zIndex: theme.zIndex.modal,
  right: 0,
  bottom: 0,
  top: 0,
  left: 0
}, !ownerState.open && ownerState.exited && {
  visibility: 'hidden'
}));
const ModalBackdrop = styled$1(Backdrop$1, {
  name: 'MuiModal',
  slot: 'Backdrop',
  overridesResolver: (props, styles) => {
    return styles.backdrop;
  }
})({
  zIndex: -1
});
/**
 * Modal is a lower-level construct that is leveraged by the following components:
 *
 * - [Dialog](/api/dialog/)
 * - [Drawer](/api/drawer/)
 * - [Menu](/api/menu/)
 * - [Popover](/api/popover/)
 *
 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
 * rather than directly using Modal.
 *
 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
 */

const Modal = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Modal(inProps, ref) {
  var _componentsProps$root;

  const props = useThemeProps({
    name: 'MuiModal',
    props: inProps
  });

  const {
    BackdropComponent = ModalBackdrop,
    closeAfterTransition = false,
    children,
    components = {},
    componentsProps = {},
    disableAutoFocus = false,
    disableEnforceFocus = false,
    disableEscapeKeyDown = false,
    disablePortal = false,
    disableRestoreFocus = false,
    disableScrollLock = false,
    hideBackdrop = false,
    keepMounted = false
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$M);

  const [exited, setExited] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(true);
  const commonProps = {
    closeAfterTransition,
    disableAutoFocus,
    disableEnforceFocus,
    disableEscapeKeyDown,
    disablePortal,
    disableRestoreFocus,
    disableScrollLock,
    hideBackdrop,
    keepMounted
  };

  const ownerState = _extends$a({}, props, commonProps, {
    exited
  });

  const classes = extendUtilityClasses(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(ModalUnstyled$1, _extends$a({
    components: _extends$a({
      Root: ModalRoot
    }, components),
    componentsProps: {
      root: _extends$a({}, componentsProps.root, (!components.Root || !isHostComponent(components.Root)) && {
        ownerState: _extends$a({}, (_componentsProps$root = componentsProps.root) == null ? void 0 : _componentsProps$root.ownerState)
      })
    },
    BackdropComponent: BackdropComponent,
    onTransitionEnter: () => setExited(false),
    onTransitionExited: () => setExited(true),
    ref: ref
  }, other, {
    classes: classes
  }, commonProps, {
    children: children
  }));
});
var Modal$1 = Modal;

function getDialogUtilityClass(slot) {
  return generateUtilityClass('MuiDialog', slot);
}
const dialogClasses = generateUtilityClasses('MuiDialog', ['root', 'scrollPaper', 'scrollBody', 'container', 'paper', 'paperScrollPaper', 'paperScrollBody', 'paperWidthFalse', 'paperWidthXs', 'paperWidthSm', 'paperWidthMd', 'paperWidthLg', 'paperWidthXl', 'paperFullWidth', 'paperFullScreen']);
var dialogClasses$1 = dialogClasses;

const DialogContext = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createContext({});

var DialogContext$1 = DialogContext;

const _excluded$L = ["aria-describedby", "aria-labelledby", "BackdropComponent", "BackdropProps", "children", "className", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps"];
const DialogBackdrop = styled$1(Backdrop$1, {
  name: 'MuiDialog',
  slot: 'Backdrop',
  overrides: (props, styles) => styles.backdrop
})({
  // Improve scrollable dialog support.
  zIndex: -1
});

const useUtilityClasses$E = ownerState => {
  const {
    classes,
    scroll,
    maxWidth,
    fullWidth,
    fullScreen
  } = ownerState;
  const slots = {
    root: ['root'],
    container: ['container', `scroll${capitalize$2(scroll)}`],
    paper: ['paper', `paperScroll${capitalize$2(scroll)}`, `paperWidth${capitalize$2(String(maxWidth))}`, fullWidth && 'paperFullWidth', fullScreen && 'paperFullScreen']
  };
  return composeClasses(slots, getDialogUtilityClass, classes);
};

const DialogRoot = styled$1(Modal$1, {
  name: 'MuiDialog',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  '@media print': {
    // Use !important to override the Modal inline-style.
    position: 'absolute !important'
  }
});
const DialogContainer$1 = styled$1('div', {
  name: 'MuiDialog',
  slot: 'Container',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.container, styles[`scroll${capitalize$2(ownerState.scroll)}`]];
  }
})(({
  ownerState
}) => _extends$a({
  height: '100%',
  '@media print': {
    height: 'auto'
  },
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}, ownerState.scroll === 'body' && {
  overflowY: 'auto',
  overflowX: 'hidden',
  textAlign: 'center',
  '&:after': {
    content: '""',
    display: 'inline-block',
    verticalAlign: 'middle',
    height: '100%',
    width: '0'
  }
}));
const DialogPaper = styled$1(Paper$1, {
  name: 'MuiDialog',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`scrollPaper${capitalize$2(ownerState.scroll)}`], styles[`paperWidth${capitalize$2(String(ownerState.maxWidth))}`], ownerState.fullWidth && styles.paperFullWidth, ownerState.fullScreen && styles.paperFullScreen];
  }
})(({
  theme,
  ownerState
}) => _extends$a({
  margin: 32,
  position: 'relative',
  overflowY: 'auto',
  // Fix IE11 issue, to remove at some point.
  '@media print': {
    overflowY: 'visible',
    boxShadow: 'none'
  }
}, ownerState.scroll === 'paper' && {
  display: 'flex',
  flexDirection: 'column',
  maxHeight: 'calc(100% - 64px)'
}, ownerState.scroll === 'body' && {
  display: 'inline-block',
  verticalAlign: 'middle',
  textAlign: 'left' // 'initial' doesn't work on IE11

}, !ownerState.maxWidth && {
  maxWidth: 'calc(100% - 64px)'
}, ownerState.maxWidth === 'xs' && {
  maxWidth: theme.breakpoints.unit === 'px' ? Math.max(theme.breakpoints.values.xs, 444) : `${theme.breakpoints.values.xs}${theme.breakpoints.unit}`,
  [`&.${dialogClasses$1.paperScrollBody}`]: {
    [theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.maxWidth !== 'xs' && {
  maxWidth: `${theme.breakpoints.values[ownerState.maxWidth]}${theme.breakpoints.unit}`,
  [`&.${dialogClasses$1.paperScrollBody}`]: {
    [theme.breakpoints.down(theme.breakpoints.values[ownerState.maxWidth] + 32 * 2)]: {
      maxWidth: 'calc(100% - 64px)'
    }
  }
}, ownerState.fullWidth && {
  width: 'calc(100% - 64px)'
}, ownerState.fullScreen && {
  margin: 0,
  width: '100%',
  maxWidth: '100%',
  height: '100%',
  maxHeight: 'none',
  borderRadius: 0,
  [`&.${dialogClasses$1.paperScrollBody}`]: {
    margin: 0,
    maxWidth: '100%'
  }
}));
const defaultTransitionDuration = {
  enter: duration.enteringScreen,
  exit: duration.leavingScreen
};
/**
 * Dialogs are overlaid modal paper based components with a backdrop.
 */

const Dialog$2 = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Dialog(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiDialog'
  });

  const {
    'aria-describedby': ariaDescribedby,
    'aria-labelledby': ariaLabelledbyProp,
    BackdropComponent,
    BackdropProps,
    children,
    className,
    disableEscapeKeyDown = false,
    fullScreen = false,
    fullWidth = false,
    maxWidth = 'sm',
    onBackdropClick,
    onClose,
    open,
    PaperComponent = Paper$1,
    PaperProps = {},
    scroll = 'paper',
    TransitionComponent = Fade$1,
    transitionDuration = defaultTransitionDuration,
    TransitionProps
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$L);

  const ownerState = _extends$a({}, props, {
    disableEscapeKeyDown,
    fullScreen,
    fullWidth,
    maxWidth,
    scroll
  });

  const classes = useUtilityClasses$E(ownerState);
  const backdropClick = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();

  const handleMouseDown = event => {
    // We don't want to close the dialog when clicking the dialog content.
    // Make sure the event starts and ends on the same DOM element.
    backdropClick.current = event.target === event.currentTarget;
  };

  const handleBackdropClick = event => {
    // Ignore the events not coming from the "backdrop".
    if (!backdropClick.current) {
      return;
    }

    backdropClick.current = null;

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (onClose) {
      onClose(event, 'backdropClick');
    }
  };

  const ariaLabelledby = useId(ariaLabelledbyProp);
  const dialogContextValue = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
    return {
      titleId: ariaLabelledby
    };
  }, [ariaLabelledby]);
  return /*#__PURE__*/jsxRuntime.exports.jsx(DialogRoot, _extends$a({
    className: clsx(classes.root, className),
    BackdropProps: _extends$a({
      transitionDuration,
      as: BackdropComponent
    }, BackdropProps),
    closeAfterTransition: true,
    BackdropComponent: DialogBackdrop,
    disableEscapeKeyDown: disableEscapeKeyDown,
    onClose: onClose,
    open: open,
    ref: ref,
    onClick: handleBackdropClick,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/jsxRuntime.exports.jsx(TransitionComponent, _extends$a({
      appear: true,
      in: open,
      timeout: transitionDuration,
      role: "presentation"
    }, TransitionProps, {
      children: /*#__PURE__*/jsxRuntime.exports.jsx(DialogContainer$1, {
        className: clsx(classes.container),
        onMouseDown: handleMouseDown,
        ownerState: ownerState,
        children: /*#__PURE__*/jsxRuntime.exports.jsx(DialogPaper, _extends$a({
          as: PaperComponent,
          elevation: 24,
          role: "dialog",
          "aria-describedby": ariaDescribedby,
          "aria-labelledby": ariaLabelledby
        }, PaperProps, {
          className: clsx(classes.paper, PaperProps.className),
          ownerState: ownerState,
          children: /*#__PURE__*/jsxRuntime.exports.jsx(DialogContext$1.Provider, {
            value: dialogContextValue,
            children: children
          })
        }))
      })
    }))
  }));
});
var MuiDialog = Dialog$2;

function getTypographyUtilityClass(slot) {
  return generateUtilityClass('MuiTypography', slot);
}
generateUtilityClasses('MuiTypography', ['root', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'inherit', 'button', 'caption', 'overline', 'alignLeft', 'alignRight', 'alignCenter', 'alignJustify', 'noWrap', 'gutterBottom', 'paragraph']);

const _excluded$K = ["align", "className", "component", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"];

const useUtilityClasses$D = ownerState => {
  const {
    align,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    classes
  } = ownerState;
  const slots = {
    root: ['root', variant, ownerState.align !== 'inherit' && `align${capitalize$2(align)}`, gutterBottom && 'gutterBottom', noWrap && 'noWrap', paragraph && 'paragraph']
  };
  return composeClasses(slots, getTypographyUtilityClass, classes);
};

const TypographyRoot = styled$1('span', {
  name: 'MuiTypography',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.variant && styles[ownerState.variant], ownerState.align !== 'inherit' && styles[`align${capitalize$2(ownerState.align)}`], ownerState.noWrap && styles.noWrap, ownerState.gutterBottom && styles.gutterBottom, ownerState.paragraph && styles.paragraph];
  }
})(({
  theme,
  ownerState
}) => _extends$a({
  margin: 0
}, ownerState.variant && theme.typography[ownerState.variant], ownerState.align !== 'inherit' && {
  textAlign: ownerState.align
}, ownerState.noWrap && {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}, ownerState.gutterBottom && {
  marginBottom: '0.35em'
}, ownerState.paragraph && {
  marginBottom: 16
}));
const defaultVariantMapping = {
  h1: 'h1',
  h2: 'h2',
  h3: 'h3',
  h4: 'h4',
  h5: 'h5',
  h6: 'h6',
  subtitle1: 'h6',
  subtitle2: 'h6',
  body1: 'p',
  body2: 'p',
  inherit: 'p'
}; // TODO v6: deprecate these color values in v5.x and remove the transformation in v6

const colorTransformations$1 = {
  primary: 'primary.main',
  textPrimary: 'text.primary',
  secondary: 'secondary.main',
  textSecondary: 'text.secondary',
  error: 'error.main'
};

const transformDeprecatedColors$1 = color => {
  return colorTransformations$1[color] || color;
};

const Typography = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Typography(inProps, ref) {
  const themeProps = useThemeProps({
    props: inProps,
    name: 'MuiTypography'
  });
  const color = transformDeprecatedColors$1(themeProps.color);
  const props = extendSxProp(_extends$a({}, themeProps, {
    color
  }));

  const {
    align = 'inherit',
    className,
    component,
    gutterBottom = false,
    noWrap = false,
    paragraph = false,
    variant = 'body1',
    variantMapping = defaultVariantMapping
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$K);

  const ownerState = _extends$a({}, props, {
    align,
    color,
    className,
    component,
    gutterBottom,
    noWrap,
    paragraph,
    variant,
    variantMapping
  });

  const Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
  const classes = useUtilityClasses$D(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(TypographyRoot, _extends$a({
    as: Component,
    ref: ref,
    ownerState: ownerState,
    className: clsx(classes.root, className)
  }, other));
});
var Typography$1 = Typography;

/**
 * @ignore - internal component.
 */

const GridContext = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createContext();

var GridContext$1 = GridContext;

function getGridUtilityClass(slot) {
  return generateUtilityClass('MuiGrid', slot);
}
const SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
const DIRECTIONS = ['column-reverse', 'column', 'row-reverse', 'row'];
const WRAPS = ['nowrap', 'wrap-reverse', 'wrap'];
const GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
const gridClasses = generateUtilityClasses('MuiGrid', ['root', 'container', 'item', 'zeroMinWidth', // spacings
...SPACINGS.map(spacing => `spacing-xs-${spacing}`), // direction values
...DIRECTIONS.map(direction => `direction-xs-${direction}`), // wrap values
...WRAPS.map(wrap => `wrap-xs-${wrap}`), // grid sizes for all breakpoints
...GRID_SIZES.map(size => `grid-xs-${size}`), ...GRID_SIZES.map(size => `grid-sm-${size}`), ...GRID_SIZES.map(size => `grid-md-${size}`), ...GRID_SIZES.map(size => `grid-lg-${size}`), ...GRID_SIZES.map(size => `grid-xl-${size}`)]);

const _excluded$J = ["className", "columns", "columnSpacing", "component", "container", "direction", "item", "lg", "md", "rowSpacing", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"];

function getOffset(val) {
  const parse = parseFloat(val);
  return `${parse}${String(val).replace(String(parse), '') || 'px'}`;
}

function generateGrid(globalStyles, theme, breakpoint, ownerState) {
  const size = ownerState[breakpoint];

  if (!size) {
    return;
  }

  let styles = {};

  if (size === true) {
    // For the auto layouting
    styles = {
      flexBasis: 0,
      flexGrow: 1,
      maxWidth: '100%'
    };
  } else if (size === 'auto') {
    styles = {
      flexBasis: 'auto',
      flexGrow: 0,
      flexShrink: 0,
      maxWidth: 'none',
      width: 'auto'
    };
  } else {
    const columnsBreakpointValues = resolveBreakpointValues({
      values: ownerState.columns,
      base: theme.breakpoints.values
    }); // Keep 7 significant numbers.

    const width = `${Math.round(size / columnsBreakpointValues[breakpoint] * 10e7) / 10e5}%`;
    let more = {};

    if (ownerState.container && ownerState.item && ownerState.columnSpacing !== 0) {
      const themeSpacing = theme.spacing(ownerState.columnSpacing);

      if (themeSpacing !== '0px') {
        const fullWidth = `calc(${width} + ${getOffset(themeSpacing)})`;
        more = {
          flexBasis: fullWidth,
          maxWidth: fullWidth
        };
      }
    } // Close to the bootstrap implementation:
    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41


    styles = _extends$a({
      flexBasis: width,
      flexGrow: 0,
      maxWidth: width
    }, more);
  } // No need for a media query for the first size.


  if (theme.breakpoints.values[breakpoint] === 0) {
    Object.assign(globalStyles, styles);
  } else {
    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
  }
}

function generateDirection({
  theme,
  ownerState
}) {
  return handleBreakpoints({
    theme
  }, ownerState.direction, propValue => {
    const output = {
      flexDirection: propValue
    };

    if (propValue.indexOf('column') === 0) {
      output[`& > .${gridClasses.item}`] = {
        maxWidth: 'none'
      };
    }

    return output;
  });
}

function generateRowGap({
  theme,
  ownerState
}) {
  const {
    container,
    rowSpacing
  } = ownerState;
  let styles = {};

  if (container && rowSpacing !== 0) {
    styles = handleBreakpoints({
      theme
    }, rowSpacing, propValue => {
      const themeSpacing = theme.spacing(propValue);

      if (themeSpacing !== '0px') {
        return {
          marginTop: `-${getOffset(themeSpacing)}`,
          [`& > .${gridClasses.item}`]: {
            paddingTop: getOffset(themeSpacing)
          }
        };
      }

      return {};
    });
  }

  return styles;
}
function generateColumnGap({
  theme,
  ownerState
}) {
  const {
    container,
    columnSpacing
  } = ownerState;
  let styles = {};

  if (container && columnSpacing !== 0) {
    styles = handleBreakpoints({
      theme
    }, columnSpacing, propValue => {
      const themeSpacing = theme.spacing(propValue);

      if (themeSpacing !== '0px') {
        return {
          width: `calc(100% + ${getOffset(themeSpacing)})`,
          marginLeft: `-${getOffset(themeSpacing)}`,
          [`& > .${gridClasses.item}`]: {
            paddingLeft: getOffset(themeSpacing)
          }
        };
      }

      return {};
    });
  }

  return styles;
} // Default CSS values
// flex: '0 1 auto',
// flexDirection: 'row',
// alignItems: 'flex-start',
// flexWrap: 'nowrap',
// justifyContent: 'flex-start',

const GridRoot = styled$1('div', {
  name: 'MuiGrid',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      container,
      direction,
      item,
      lg,
      md,
      sm,
      spacing,
      wrap,
      xl,
      xs,
      zeroMinWidth
    } = props.ownerState;
    return [styles.root, container && styles.container, item && styles.item, zeroMinWidth && styles.zeroMinWidth, container && spacing !== 0 && styles[`spacing-xs-${String(spacing)}`], direction !== 'row' && styles[`direction-xs-${String(direction)}`], wrap !== 'wrap' && styles[`wrap-xs-${String(wrap)}`], xs !== false && styles[`grid-xs-${String(xs)}`], sm !== false && styles[`grid-sm-${String(sm)}`], md !== false && styles[`grid-md-${String(md)}`], lg !== false && styles[`grid-lg-${String(lg)}`], xl !== false && styles[`grid-xl-${String(xl)}`]];
  }
})(({
  ownerState
}) => _extends$a({
  boxSizing: 'border-box'
}, ownerState.container && {
  display: 'flex',
  flexWrap: 'wrap',
  width: '100%'
}, ownerState.item && {
  margin: 0 // For instance, it's useful when used with a `figure` element.

}, ownerState.zeroMinWidth && {
  minWidth: 0
}, ownerState.wrap === 'nowrap' && {
  flexWrap: 'nowrap'
}, ownerState.wrap === 'reverse' && {
  flexWrap: 'wrap-reverse'
}), generateDirection, generateRowGap, generateColumnGap, ({
  theme,
  ownerState
}) => theme.breakpoints.keys.reduce((globalStyles, breakpoint) => {
  // Use side effect over immutability for better performance.
  generateGrid(globalStyles, theme, breakpoint, ownerState);
  return globalStyles;
}, {}));

const useUtilityClasses$C = ownerState => {
  const {
    classes,
    container,
    direction,
    item,
    lg,
    md,
    sm,
    spacing,
    wrap,
    xl,
    xs,
    zeroMinWidth
  } = ownerState;
  const slots = {
    root: ['root', container && 'container', item && 'item', zeroMinWidth && 'zeroMinWidth', container && spacing !== 0 && `spacing-xs-${String(spacing)}`, direction !== 'row' && `direction-xs-${String(direction)}`, wrap !== 'wrap' && `wrap-xs-${String(wrap)}`, xs !== false && `grid-xs-${String(xs)}`, sm !== false && `grid-sm-${String(sm)}`, md !== false && `grid-md-${String(md)}`, lg !== false && `grid-lg-${String(lg)}`, xl !== false && `grid-xl-${String(xl)}`]
  };
  return composeClasses(slots, getGridUtilityClass, classes);
};

const Grid = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Grid(inProps, ref) {
  const themeProps = useThemeProps({
    props: inProps,
    name: 'MuiGrid'
  });
  const props = extendSxProp(themeProps);

  const {
    className,
    columns: columnsProp = 12,
    columnSpacing: columnSpacingProp,
    component = 'div',
    container = false,
    direction = 'row',
    item = false,
    lg = false,
    md = false,
    rowSpacing: rowSpacingProp,
    sm = false,
    spacing = 0,
    wrap = 'wrap',
    xl = false,
    xs = false,
    zeroMinWidth = false
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$J);

  const rowSpacing = rowSpacingProp || spacing;
  const columnSpacing = columnSpacingProp || spacing;
  const columns = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(GridContext$1) || columnsProp;

  const ownerState = _extends$a({}, props, {
    columns,
    container,
    direction,
    item,
    lg,
    md,
    sm,
    rowSpacing,
    columnSpacing,
    wrap,
    xl,
    xs,
    zeroMinWidth
  });

  const classes = useUtilityClasses$C(ownerState);

  const wrapChild = element => columns !== 12 ? /*#__PURE__*/jsxRuntime.exports.jsx(GridContext$1.Provider, {
    value: columns,
    children: element
  }) : element;

  return wrapChild( /*#__PURE__*/jsxRuntime.exports.jsx(GridRoot, _extends$a({
    ownerState: ownerState,
    className: clsx(classes.root, className),
    as: component,
    ref: ref
  }, other)));
});

var Grid$1 = Grid;

function getDialogTitleUtilityClass(slot) {
  return generateUtilityClass('MuiDialogTitle', slot);
}
generateUtilityClasses('MuiDialogTitle', ['root']);

const _excluded$I = ["className", "id"];

const useUtilityClasses$B = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getDialogTitleUtilityClass, classes);
};

const DialogTitleRoot = styled$1(Typography$1, {
  name: 'MuiDialogTitle',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  padding: '16px 24px',
  flex: '0 0 auto'
});
const DialogTitle = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function DialogTitle(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiDialogTitle'
  });

  const {
    className,
    id: idProp
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$I);

  const ownerState = props;
  const classes = useUtilityClasses$B(ownerState);
  const {
    titleId: id = idProp
  } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(DialogContext$1);
  return /*#__PURE__*/jsxRuntime.exports.jsx(DialogTitleRoot, _extends$a({
    component: "h2",
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref,
    variant: "h6",
    id: id
  }, other));
});
var MuiDialogTitle = DialogTitle;

function getDialogActionsUtilityClass(slot) {
  return generateUtilityClass('MuiDialogActions', slot);
}
generateUtilityClasses('MuiDialogActions', ['root', 'spacing']);

const _excluded$H = ["className", "disableSpacing"];

const useUtilityClasses$A = ownerState => {
  const {
    classes,
    disableSpacing
  } = ownerState;
  const slots = {
    root: ['root', !disableSpacing && 'spacing']
  };
  return composeClasses(slots, getDialogActionsUtilityClass, classes);
};

const DialogActionsRoot = styled$1('div', {
  name: 'MuiDialogActions',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.disableSpacing && styles.spacing];
  }
})(({
  ownerState
}) => _extends$a({
  display: 'flex',
  alignItems: 'center',
  padding: 8,
  justifyContent: 'flex-end',
  flex: '0 0 auto'
}, !ownerState.disableSpacing && {
  '& > :not(:first-of-type)': {
    marginLeft: 8
  }
}));
const DialogActions = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function DialogActions(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiDialogActions'
  });

  const {
    className,
    disableSpacing = false
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$H);

  const ownerState = _extends$a({}, props, {
    disableSpacing
  });

  const classes = useUtilityClasses$A(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(DialogActionsRoot, _extends$a({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
var MuiDialogActions = DialogActions;

function getDialogContentUtilityClass(slot) {
  return generateUtilityClass('MuiDialogContent', slot);
}
generateUtilityClasses('MuiDialogContent', ['root', 'dividers']);

const _excluded$G = ["className", "dividers"];

const useUtilityClasses$z = ownerState => {
  const {
    classes,
    dividers
  } = ownerState;
  const slots = {
    root: ['root', dividers && 'dividers']
  };
  return composeClasses(slots, getDialogContentUtilityClass, classes);
};

const DialogContentRoot = styled$1('div', {
  name: 'MuiDialogContent',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.dividers && styles.dividers];
  }
})(({
  theme,
  ownerState
}) => _extends$a({
  flex: '1 1 auto',
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  overflowY: 'auto',
  padding: '20px 24px'
}, ownerState.dividers ? {
  padding: '16px 24px',
  borderTop: `1px solid ${theme.palette.divider}`,
  borderBottom: `1px solid ${theme.palette.divider}`
} : {
  '.MuiDialogTitle-root + &': {
    paddingTop: 0
  }
}));
const DialogContent = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function DialogContent(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiDialogContent'
  });

  const {
    className,
    dividers = false
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$G);

  const ownerState = _extends$a({}, props, {
    dividers
  });

  const classes = useUtilityClasses$z(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(DialogContentRoot, _extends$a({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
var MuiDialogContent = DialogContent;

const defaultTheme = createTheme();
/**
 * @ignore - do not document.
 */

const Box = createBox({
  defaultTheme
});
var Box$1 = Box;

const _excluded$F = ["children", "classes", "className", "label", "notched"];
const NotchedOutlineRoot$1 = styled$1('fieldset')({
  textAlign: 'left',
  position: 'absolute',
  bottom: 0,
  right: 0,
  top: -5,
  left: 0,
  margin: 0,
  padding: '0 8px',
  pointerEvents: 'none',
  borderRadius: 'inherit',
  borderStyle: 'solid',
  borderWidth: 1,
  overflow: 'hidden',
  minWidth: '0%'
});
const NotchedOutlineLegend = styled$1('legend', {
  skipSx: true
})(({
  ownerState,
  theme
}) => _extends$a({}, ownerState.label === undefined && {
  padding: 0,
  lineHeight: '11px',
  // sync with `height` in `legend` styles
  transition: theme.transitions.create('width', {
    duration: 150,
    easing: theme.transitions.easing.easeOut
  })
}, ownerState.label !== undefined && _extends$a({
  display: 'block',
  width: 'auto',
  padding: 0,
  height: 11,
  // sync with `lineHeight` in `legend` styles
  fontSize: '0.75em',
  visibility: 'hidden',
  maxWidth: 0.01,
  transition: theme.transitions.create('max-width', {
    duration: 50,
    easing: theme.transitions.easing.easeOut
  }),
  '& > span': {
    paddingLeft: 5,
    paddingRight: 5,
    display: 'inline-block'
  }
}, ownerState.notched && {
  maxWidth: '100%',
  transition: theme.transitions.create('max-width', {
    duration: 100,
    easing: theme.transitions.easing.easeOut,
    delay: 50
  })
})));
/**
 * @ignore - internal component.
 */

function NotchedOutline(props) {
  const {
    className,
    label,
    notched
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$F);

  const ownerState = _extends$a({}, props, {
    notched,
    label
  });

  return /*#__PURE__*/jsxRuntime.exports.jsx(NotchedOutlineRoot$1, _extends$a({
    "aria-hidden": true,
    className: className,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/jsxRuntime.exports.jsx(NotchedOutlineLegend, {
      ownerState: ownerState,
      children: label ? /*#__PURE__*/jsxRuntime.exports.jsx("span", {
        children: label
      }) :
      /*#__PURE__*/
      // notranslate needed while Google Translate will not fix zero-width space issue
      // eslint-disable-next-line react/no-danger
      jsxRuntime.exports.jsx("span", {
        className: "notranslate",
        dangerouslySetInnerHTML: {
          __html: '&#8203;'
        }
      })
    })
  }));
}

function getOutlinedInputUtilityClass(slot) {
  return generateUtilityClass('MuiOutlinedInput', slot);
}
const outlinedInputClasses = generateUtilityClasses('MuiOutlinedInput', ['root', 'colorSecondary', 'focused', 'disabled', 'adornedStart', 'adornedEnd', 'error', 'sizeSmall', 'multiline', 'notchedOutline', 'input', 'inputSizeSmall', 'inputMultiline', 'inputAdornedStart', 'inputAdornedEnd']);
var outlinedInputClasses$1 = outlinedInputClasses;

function formControlState({
  props,
  states,
  muiFormControl
}) {
  return states.reduce((acc, state) => {
    acc[state] = props[state];

    if (muiFormControl) {
      if (typeof props[state] === 'undefined') {
        acc[state] = muiFormControl[state];
      }
    }

    return acc;
  }, {});
}

/**
 * @ignore - internal component.
 */

const FormControlContext = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createContext();

var FormControlContext$1 = FormControlContext;

function useFormControl() {
  return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(FormControlContext$1);
}

const _excluded$E = ["onChange", "maxRows", "minRows", "style", "value"];

function getStyleValue(computedStyle, property) {
  return parseInt(computedStyle[property], 10) || 0;
}

const styles$1 = {
  shadow: {
    // Visibility needed to hide the extra text area on iPads
    visibility: 'hidden',
    // Remove from the content flow
    position: 'absolute',
    // Ignore the scrollbar width
    overflow: 'hidden',
    height: 0,
    top: 0,
    left: 0,
    // Create a new layer, increase the isolation of the computed values
    transform: 'translateZ(0)'
  }
};
const TextareaAutosize = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function TextareaAutosize(props, ref) {
  const {
    onChange,
    maxRows,
    minRows = 1,
    style,
    value
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$E);

  const {
    current: isControlled
  } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(value != null);
  const inputRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const handleRef = useForkRef(ref, inputRef);
  const shadowRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const renders = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(0);
  const [state, setState] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState({});
  const syncHeight = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
    const input = inputRef.current;
    const containerWindow = ownerWindow(input);
    const computedStyle = containerWindow.getComputedStyle(input); // If input's width is shrunk and it's not visible, don't sync height.

    if (computedStyle.width === '0px') {
      return;
    }

    const inputShallow = shadowRef.current;
    inputShallow.style.width = computedStyle.width;
    inputShallow.value = input.value || props.placeholder || 'x';

    if (inputShallow.value.slice(-1) === '\n') {
      // Certain fonts which overflow the line height will cause the textarea
      // to report a different scrollHeight depending on whether the last line
      // is empty. Make it non-empty to avoid this issue.
      inputShallow.value += ' ';
    }

    const boxSizing = computedStyle['box-sizing'];
    const padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
    const border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content

    const innerHeight = inputShallow.scrollHeight; // Measure height of a textarea with a single row

    inputShallow.value = 'x';
    const singleRowHeight = inputShallow.scrollHeight; // The height of the outer content

    let outerHeight = innerHeight;

    if (minRows) {
      outerHeight = Math.max(Number(minRows) * singleRowHeight, outerHeight);
    }

    if (maxRows) {
      outerHeight = Math.min(Number(maxRows) * singleRowHeight, outerHeight);
    }

    outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.

    const outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
    const overflow = Math.abs(outerHeight - innerHeight) <= 1;
    setState(prevState => {
      // Need a large enough difference to update the height.
      // This prevents infinite rendering loop.
      if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
        renders.current += 1;
        return {
          overflow,
          outerHeightStyle
        };
      }

      return prevState;
    });
  }, [maxRows, minRows, props.placeholder]);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    const handleResize = debounce$1(() => {
      renders.current = 0;
      syncHeight();
    });
    const containerWindow = ownerWindow(inputRef.current);
    containerWindow.addEventListener('resize', handleResize);
    let resizeObserver;

    if (typeof ResizeObserver !== 'undefined') {
      resizeObserver = new ResizeObserver(handleResize);
      resizeObserver.observe(inputRef.current);
    }

    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);

      if (resizeObserver) {
        resizeObserver.disconnect();
      }
    };
  }, [syncHeight]);
  useEnhancedEffect$1(() => {
    syncHeight();
  });
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    renders.current = 0;
  }, [value]);

  const handleChange = event => {
    renders.current = 0;

    if (!isControlled) {
      syncHeight();
    }

    if (onChange) {
      onChange(event);
    }
  };

  return /*#__PURE__*/jsxRuntime.exports.jsxs(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Fragment, {
    children: [/*#__PURE__*/jsxRuntime.exports.jsx("textarea", _extends$a({
      value: value,
      onChange: handleChange,
      ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
      ,
      rows: minRows,
      style: _extends$a({
        height: state.outerHeightStyle,
        // Need a large enough difference to allow scrolling.
        // This prevents infinite rendering loop.
        overflow: state.overflow ? 'hidden' : null
      }, style)
    }, other)), /*#__PURE__*/jsxRuntime.exports.jsx("textarea", {
      "aria-hidden": true,
      className: props.className,
      readOnly: true,
      ref: shadowRef,
      tabIndex: -1,
      style: _extends$a({}, styles$1.shadow, style, {
        padding: 0
      })
    })]
  });
});
var TextareaAutosize$1 = TextareaAutosize;

function GlobalStyles(props) {
  return /*#__PURE__*/jsxRuntime.exports.jsx(GlobalStyles$1, _extends$a({}, props, {
    defaultTheme: defaultTheme$2
  }));
}

// Supports determination of isControlled().
// Controlled input accepts its current value as a prop.
//
// @see https://facebook.github.io/react/docs/forms.html#controlled-components
// @param value
// @returns {boolean} true if string (including '') or number (including zero)
function hasValue(value) {
  return value != null && !(Array.isArray(value) && value.length === 0);
} // Determine if field is empty or filled.
// Response determines if label is presented above field or as placeholder.
//
// @param obj
// @param SSR
// @returns {boolean} False when not present or empty string.
//                    True when any number or string with length.

function isFilled(obj, SSR = false) {
  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
} // Determine if an Input is adorned on start.
// It's corresponding to the left with LTR.
//
// @param obj
// @returns {boolean} False when no adornments.
//                    True when adorned at the start.

function isAdornedStart(obj) {
  return obj.startAdornment;
}

function getInputBaseUtilityClass(slot) {
  return generateUtilityClass('MuiInputBase', slot);
}
const inputBaseClasses = generateUtilityClasses('MuiInputBase', ['root', 'formControl', 'focused', 'disabled', 'adornedStart', 'adornedEnd', 'error', 'sizeSmall', 'multiline', 'colorSecondary', 'fullWidth', 'hiddenLabel', 'input', 'inputSizeSmall', 'inputMultiline', 'inputTypeSearch', 'inputAdornedStart', 'inputAdornedEnd', 'inputHiddenLabel']);
var inputBaseClasses$1 = inputBaseClasses;

const _excluded$D = ["aria-describedby", "autoComplete", "autoFocus", "className", "color", "components", "componentsProps", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "size", "startAdornment", "type", "value"];
const rootOverridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.formControl && styles.formControl, ownerState.startAdornment && styles.adornedStart, ownerState.endAdornment && styles.adornedEnd, ownerState.error && styles.error, ownerState.size === 'small' && styles.sizeSmall, ownerState.multiline && styles.multiline, ownerState.color && styles[`color${capitalize$2(ownerState.color)}`], ownerState.fullWidth && styles.fullWidth, ownerState.hiddenLabel && styles.hiddenLabel];
};
const inputOverridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.input, ownerState.size === 'small' && styles.inputSizeSmall, ownerState.multiline && styles.inputMultiline, ownerState.type === 'search' && styles.inputTypeSearch, ownerState.startAdornment && styles.inputAdornedStart, ownerState.endAdornment && styles.inputAdornedEnd, ownerState.hiddenLabel && styles.inputHiddenLabel];
};

const useUtilityClasses$y = ownerState => {
  const {
    classes,
    color,
    disabled,
    error,
    endAdornment,
    focused,
    formControl,
    fullWidth,
    hiddenLabel,
    multiline,
    size,
    startAdornment,
    type
  } = ownerState;
  const slots = {
    root: ['root', `color${capitalize$2(color)}`, disabled && 'disabled', error && 'error', fullWidth && 'fullWidth', focused && 'focused', formControl && 'formControl', size === 'small' && 'sizeSmall', multiline && 'multiline', startAdornment && 'adornedStart', endAdornment && 'adornedEnd', hiddenLabel && 'hiddenLabel'],
    input: ['input', disabled && 'disabled', type === 'search' && 'inputTypeSearch', multiline && 'inputMultiline', size === 'small' && 'inputSizeSmall', hiddenLabel && 'inputHiddenLabel', startAdornment && 'inputAdornedStart', endAdornment && 'inputAdornedEnd']
  };
  return composeClasses(slots, getInputBaseUtilityClass, classes);
};

const InputBaseRoot = styled$1('div', {
  name: 'MuiInputBase',
  slot: 'Root',
  overridesResolver: rootOverridesResolver
})(({
  theme,
  ownerState
}) => _extends$a({}, theme.typography.body1, {
  color: theme.palette.text.primary,
  lineHeight: '1.4375em',
  // 23px
  boxSizing: 'border-box',
  // Prevent padding issue with fullWidth.
  position: 'relative',
  cursor: 'text',
  display: 'inline-flex',
  alignItems: 'center',
  [`&.${inputBaseClasses$1.disabled}`]: {
    color: theme.palette.text.disabled,
    cursor: 'default'
  }
}, ownerState.multiline && _extends$a({
  padding: '4px 0 5px'
}, ownerState.size === 'small' && {
  paddingTop: 1
}), ownerState.fullWidth && {
  width: '100%'
}));
const InputBaseComponent = styled$1('input', {
  name: 'MuiInputBase',
  slot: 'Input',
  overridesResolver: inputOverridesResolver
})(({
  theme,
  ownerState
}) => {
  const light = theme.palette.mode === 'light';
  const placeholder = {
    color: 'currentColor',
    opacity: light ? 0.42 : 0.5,
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter
    })
  };
  const placeholderHidden = {
    opacity: '0 !important'
  };
  const placeholderVisible = {
    opacity: light ? 0.42 : 0.5
  };
  return _extends$a({
    font: 'inherit',
    letterSpacing: 'inherit',
    color: 'currentColor',
    padding: '4px 0 5px',
    border: 0,
    boxSizing: 'content-box',
    background: 'none',
    height: '1.4375em',
    // Reset 23pxthe native input line-height
    margin: 0,
    // Reset for Safari
    WebkitTapHighlightColor: 'transparent',
    display: 'block',
    // Make the flex item shrink with Firefox
    minWidth: 0,
    width: '100%',
    // Fix IE11 width issue
    animationName: 'mui-auto-fill-cancel',
    animationDuration: '10ms',
    '&::-webkit-input-placeholder': placeholder,
    '&::-moz-placeholder': placeholder,
    // Firefox 19+
    '&:-ms-input-placeholder': placeholder,
    // IE11
    '&::-ms-input-placeholder': placeholder,
    // Edge
    '&:focus': {
      outline: 0
    },
    // Reset Firefox invalid required input style
    '&:invalid': {
      boxShadow: 'none'
    },
    '&::-webkit-search-decoration': {
      // Remove the padding when type=search.
      WebkitAppearance: 'none'
    },
    // Show and hide the placeholder logic
    [`label[data-shrink=false] + .${inputBaseClasses$1.formControl} &`]: {
      '&::-webkit-input-placeholder': placeholderHidden,
      '&::-moz-placeholder': placeholderHidden,
      // Firefox 19+
      '&:-ms-input-placeholder': placeholderHidden,
      // IE11
      '&::-ms-input-placeholder': placeholderHidden,
      // Edge
      '&:focus::-webkit-input-placeholder': placeholderVisible,
      '&:focus::-moz-placeholder': placeholderVisible,
      // Firefox 19+
      '&:focus:-ms-input-placeholder': placeholderVisible,
      // IE11
      '&:focus::-ms-input-placeholder': placeholderVisible // Edge

    },
    [`&.${inputBaseClasses$1.disabled}`]: {
      opacity: 1,
      // Reset iOS opacity
      WebkitTextFillColor: theme.palette.text.disabled // Fix opacity Safari bug

    },
    '&:-webkit-autofill': {
      animationDuration: '5000s',
      animationName: 'mui-auto-fill'
    }
  }, ownerState.size === 'small' && {
    paddingTop: 1
  }, ownerState.multiline && {
    height: 'auto',
    resize: 'none',
    padding: 0,
    paddingTop: 0
  }, ownerState.type === 'search' && {
    // Improve type search style.
    MozAppearance: 'textfield',
    WebkitAppearance: 'textfield'
  });
});

const inputGlobalStyles = /*#__PURE__*/jsxRuntime.exports.jsx(GlobalStyles, {
  styles: {
    '@keyframes mui-auto-fill': {
      from: {
        display: 'block'
      }
    },
    '@keyframes mui-auto-fill-cancel': {
      from: {
        display: 'block'
      }
    }
  }
});
/**
 * `InputBase` contains as few styles as possible.
 * It aims to be a simple building block for creating an input.
 * It contains a load of style reset and some state logic.
 */


const InputBase = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function InputBase(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiInputBase'
  });

  const {
    'aria-describedby': ariaDescribedby,
    autoComplete,
    autoFocus,
    className,
    components = {},
    componentsProps = {},
    defaultValue,
    disabled,
    endAdornment,
    fullWidth = false,
    id,
    inputComponent = 'input',
    inputProps: inputPropsProp = {},
    inputRef: inputRefProp,
    maxRows,
    minRows,
    multiline = false,
    name,
    onBlur,
    onChange,
    onClick,
    onFocus,
    onKeyDown,
    onKeyUp,
    placeholder,
    readOnly,
    renderSuffix,
    rows,
    startAdornment,
    type = 'text',
    value: valueProp
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$D);

  const theme = useTheme();
  const value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
  const {
    current: isControlled
  } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(value != null);
  const inputRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();
  const handleInputRefWarning = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(instance => {
  }, []);
  const handleInputPropsRefProp = useForkRef(inputPropsProp.ref, handleInputRefWarning);
  const handleInputRefProp = useForkRef(inputRefProp, handleInputPropsRefProp);
  const handleInputRef = useForkRef(inputRef, handleInputRefProp);
  const [focused, setFocused] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
  const muiFormControl = useFormControl();

  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['color', 'disabled', 'error', 'hiddenLabel', 'size', 'required', 'filled']
  });
  fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
  // We need to book keep the focused state manually.

  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    if (!muiFormControl && disabled && focused) {
      setFocused(false);

      if (onBlur) {
        onBlur();
      }
    }
  }, [muiFormControl, disabled, focused, onBlur]);
  const onFilled = muiFormControl && muiFormControl.onFilled;
  const onEmpty = muiFormControl && muiFormControl.onEmpty;
  const checkDirty = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(obj => {
    if (isFilled(obj)) {
      if (onFilled) {
        onFilled();
      }
    } else if (onEmpty) {
      onEmpty();
    }
  }, [onFilled, onEmpty]);
  useEnhancedEffect$1(() => {
    if (isControlled) {
      checkDirty({
        value
      });
    }
  }, [value, checkDirty, isControlled]);

  const handleFocus = event => {
    // Fix a bug with IE11 where the focus/blur events are triggered
    // while the component is disabled.
    if (fcs.disabled) {
      event.stopPropagation();
      return;
    }

    if (onFocus) {
      onFocus(event);
    }

    if (inputPropsProp.onFocus) {
      inputPropsProp.onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    } else {
      setFocused(true);
    }
  };

  const handleBlur = event => {
    if (onBlur) {
      onBlur(event);
    }

    if (inputPropsProp.onBlur) {
      inputPropsProp.onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    } else {
      setFocused(false);
    }
  };

  const handleChange = (event, ...args) => {
    if (!isControlled) {
      const element = event.target || inputRef.current;

      if (element == null) {
        throw new Error(formatMuiErrorMessage(1));
      }

      checkDirty({
        value: element.value
      });
    }

    if (inputPropsProp.onChange) {
      inputPropsProp.onChange(event, ...args);
    } // Perform in the willUpdate


    if (onChange) {
      onChange(event, ...args);
    }
  }; // Check the input state on mount, in case it was filled by the user
  // or auto filled by the browser before the hydration (for SSR).


  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    checkDirty(inputRef.current); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClick = event => {
    if (inputRef.current && event.currentTarget === event.target) {
      inputRef.current.focus();
    }

    if (onClick) {
      onClick(event);
    }
  };

  let InputComponent = inputComponent;
  let inputProps = inputPropsProp;

  if (multiline && InputComponent === 'input') {
    if (rows) {

      inputProps = _extends$a({
        type: undefined,
        minRows: rows,
        maxRows: rows
      }, inputProps);
    } else {
      inputProps = _extends$a({
        type: undefined,
        maxRows,
        minRows
      }, inputProps);
    }

    InputComponent = TextareaAutosize$1;
  }

  const handleAutoFill = event => {
    // Provide a fake value as Chrome might not let you access it for security reasons.
    checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
      value: 'x'
    });
  };

  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    if (muiFormControl) {
      muiFormControl.setAdornedStart(Boolean(startAdornment));
    }
  }, [muiFormControl, startAdornment]);

  const ownerState = _extends$a({}, props, {
    color: fcs.color || 'primary',
    disabled: fcs.disabled,
    endAdornment,
    error: fcs.error,
    focused: fcs.focused,
    formControl: muiFormControl,
    fullWidth,
    hiddenLabel: fcs.hiddenLabel,
    multiline,
    size: fcs.size,
    startAdornment,
    type
  });

  const classes = useUtilityClasses$y(ownerState);
  const Root = components.Root || InputBaseRoot;
  const rootProps = componentsProps.root || {};
  const Input = components.Input || InputBaseComponent;
  inputProps = _extends$a({}, inputProps, componentsProps.input);
  return /*#__PURE__*/jsxRuntime.exports.jsxs(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Fragment, {
    children: [inputGlobalStyles, /*#__PURE__*/jsxRuntime.exports.jsxs(Root, _extends$a({}, rootProps, !isHostComponent(Root) && {
      ownerState: _extends$a({}, ownerState, rootProps.ownerState),
      theme
    }, {
      ref: ref,
      onClick: handleClick
    }, other, {
      className: clsx(classes.root, rootProps.className, className),
      children: [startAdornment, /*#__PURE__*/jsxRuntime.exports.jsx(FormControlContext$1.Provider, {
        value: null,
        children: /*#__PURE__*/jsxRuntime.exports.jsx(Input, _extends$a({
          ownerState: ownerState,
          "aria-invalid": fcs.error,
          "aria-describedby": ariaDescribedby,
          autoComplete: autoComplete,
          autoFocus: autoFocus,
          defaultValue: defaultValue,
          disabled: fcs.disabled,
          id: id,
          onAnimationStart: handleAutoFill,
          name: name,
          placeholder: placeholder,
          readOnly: readOnly,
          required: fcs.required,
          rows: rows,
          value: value,
          onKeyDown: onKeyDown,
          onKeyUp: onKeyUp,
          type: type
        }, inputProps, !isHostComponent(Input) && {
          as: InputComponent,
          ownerState: _extends$a({}, ownerState, inputProps.ownerState),
          theme
        }, {
          ref: handleInputRef,
          className: clsx(classes.input, inputProps.className, inputPropsProp.className),
          onBlur: handleBlur,
          onChange: handleChange,
          onFocus: handleFocus
        }))
      }), endAdornment, renderSuffix ? renderSuffix(_extends$a({}, fcs, {
        startAdornment
      })) : null]
    }))]
  });
});
var InputBase$1 = InputBase;

const _excluded$C = ["components", "fullWidth", "inputComponent", "label", "multiline", "notched", "type"];

const useUtilityClasses$x = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    notchedOutline: ['notchedOutline'],
    input: ['input']
  };
  const composedClasses = composeClasses(slots, getOutlinedInputUtilityClass, classes);
  return _extends$a({}, classes, composedClasses);
};

const OutlinedInputRoot = styled$1(InputBaseRoot, {
  shouldForwardProp: prop => rootShouldForwardProp$1(prop) || prop === 'classes',
  name: 'MuiOutlinedInput',
  slot: 'Root',
  overridesResolver: rootOverridesResolver
})(({
  theme,
  ownerState
}) => {
  const borderColor = theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
  return _extends$a({
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    [`&:hover .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: theme.palette.text.primary
    },
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      [`&:hover .${outlinedInputClasses$1.notchedOutline}`]: {
        borderColor
      }
    },
    [`&.${outlinedInputClasses$1.focused} .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: theme.palette[ownerState.color].main,
      borderWidth: 2
    },
    [`&.${outlinedInputClasses$1.error} .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: theme.palette.error.main
    },
    [`&.${outlinedInputClasses$1.disabled} .${outlinedInputClasses$1.notchedOutline}`]: {
      borderColor: theme.palette.action.disabled
    }
  }, ownerState.startAdornment && {
    paddingLeft: 14
  }, ownerState.endAdornment && {
    paddingRight: 14
  }, ownerState.multiline && _extends$a({
    padding: '16.5px 14px'
  }, ownerState.size === 'small' && {
    padding: '8.5px 14px'
  }));
});
const NotchedOutlineRoot = styled$1(NotchedOutline, {
  name: 'MuiOutlinedInput',
  slot: 'NotchedOutline',
  overridesResolver: (props, styles) => styles.notchedOutline
})(({
  theme
}) => ({
  borderColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'
}));
const OutlinedInputInput = styled$1(InputBaseComponent, {
  name: 'MuiOutlinedInput',
  slot: 'Input',
  overridesResolver: inputOverridesResolver
})(({
  theme,
  ownerState
}) => _extends$a({
  padding: '16.5px 14px',
  '&:-webkit-autofill': {
    WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
    WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
    caretColor: theme.palette.mode === 'light' ? null : '#fff',
    borderRadius: 'inherit'
  }
}, ownerState.size === 'small' && {
  padding: '8.5px 14px'
}, ownerState.multiline && {
  padding: 0
}, ownerState.startAdornment && {
  paddingLeft: 0
}, ownerState.endAdornment && {
  paddingRight: 0
}));
const OutlinedInput = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function OutlinedInput(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiOutlinedInput'
  });

  const {
    components = {},
    fullWidth = false,
    inputComponent = 'input',
    label,
    multiline = false,
    notched,
    type = 'text'
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$C);

  const classes = useUtilityClasses$x(props);
  return /*#__PURE__*/jsxRuntime.exports.jsx(InputBase$1, _extends$a({
    components: _extends$a({
      Root: OutlinedInputRoot,
      Input: OutlinedInputInput
    }, components),
    renderSuffix: state => /*#__PURE__*/jsxRuntime.exports.jsx(NotchedOutlineRoot, {
      className: classes.notchedOutline,
      label: label,
      notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
    }),
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other, {
    classes: _extends$a({}, classes, {
      notchedOutline: null
    })
  }));
});
OutlinedInput.muiName = 'Input';
var MuiOutlinedInput = OutlinedInput;

function getFormHelperTextUtilityClasses(slot) {
  return generateUtilityClass('MuiFormHelperText', slot);
}
const formHelperTextClasses = generateUtilityClasses('MuiFormHelperText', ['root', 'error', 'disabled', 'sizeSmall', 'sizeMedium', 'contained', 'focused', 'filled', 'required']);
var formHelperTextClasses$1 = formHelperTextClasses;

const _excluded$B = ["children", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"];

const useUtilityClasses$w = ownerState => {
  const {
    classes,
    contained,
    size,
    disabled,
    error,
    filled,
    focused,
    required
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', error && 'error', size && `size${capitalize$2(size)}`, contained && 'contained', focused && 'focused', filled && 'filled', required && 'required']
  };
  return composeClasses(slots, getFormHelperTextUtilityClasses, classes);
};

const FormHelperTextRoot = styled$1('p', {
  name: 'MuiFormHelperText',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.size && styles[`size${capitalize$2(ownerState.size)}`], ownerState.contained && styles.contained, ownerState.filled && styles.filled];
  }
})(({
  theme,
  ownerState
}) => _extends$a({
  color: theme.palette.text.secondary
}, theme.typography.caption, {
  textAlign: 'left',
  marginTop: 3,
  marginRight: 0,
  marginBottom: 0,
  marginLeft: 0,
  [`&.${formHelperTextClasses$1.disabled}`]: {
    color: theme.palette.text.disabled
  },
  [`&.${formHelperTextClasses$1.error}`]: {
    color: theme.palette.error.main
  }
}, ownerState.size === 'small' && {
  marginTop: 4
}, ownerState.contained && {
  marginLeft: 14,
  marginRight: 14
}));
const FormHelperText = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function FormHelperText(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiFormHelperText'
  });

  const {
    children,
    className,
    component = 'p'
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$B);

  const muiFormControl = useFormControl();
  const fcs = formControlState({
    props,
    muiFormControl,
    states: ['variant', 'size', 'disabled', 'error', 'filled', 'focused', 'required']
  });

  const ownerState = _extends$a({}, props, {
    component,
    contained: fcs.variant === 'filled' || fcs.variant === 'outlined',
    variant: fcs.variant,
    size: fcs.size,
    disabled: fcs.disabled,
    error: fcs.error,
    filled: fcs.filled,
    focused: fcs.focused,
    required: fcs.required
  });

  const classes = useUtilityClasses$w(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(FormHelperTextRoot, _extends$a({
    as: component,
    ownerState: ownerState,
    className: clsx(classes.root, className),
    ref: ref
  }, other, {
    children: children === ' ' ?
    /*#__PURE__*/
    // notranslate needed while Google Translate will not fix zero-width space issue
    // eslint-disable-next-line react/no-danger
    jsxRuntime.exports.jsx("span", {
      className: "notranslate",
      dangerouslySetInnerHTML: {
        __html: '&#8203;'
      }
    }) : children
  }));
});
var FormHelperText$1 = FormHelperText;

function mapEventPropToEvent(eventProp) {
  return eventProp.substring(2).toLowerCase();
}

function clickedRootScrollbar(event, doc) {
  return doc.documentElement.clientWidth < event.clientX || doc.documentElement.clientHeight < event.clientY;
}

/**
 * Listen for click events that occur somewhere in the document, outside of the element itself.
 * For instance, if you need to hide a menu when people click anywhere else on your page.
 *
 * Demos:
 *
 * - [Click Away Listener](https://mui.com/components/click-away-listener/)
 * - [Menus](https://mui.com/components/menus/)
 *
 * API:
 *
 * - [ClickAwayListener API](https://mui.com/api/click-away-listener/)
 */
function ClickAwayListener(props) {
  const {
    children,
    disableReactTree = false,
    mouseEvent = 'onClick',
    onClickAway,
    touchEvent = 'onTouchEnd'
  } = props;
  const movedRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(false);
  const nodeRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const activatedRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(false);
  const syntheticEventRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(false);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    // Ensure that this component is not "activated" synchronously.
    // https://github.com/facebook/react/issues/20074
    setTimeout(() => {
      activatedRef.current = true;
    }, 0);
    return () => {
      activatedRef.current = false;
    };
  }, []);
  const handleRef = useForkRef( // @ts-expect-error TODO upstream fix
  children.ref, nodeRef); // The handler doesn't take event.defaultPrevented into account:
  //
  // event.preventDefault() is meant to stop default behaviors like
  // clicking a checkbox to check it, hitting a button to submit a form,
  // and hitting left arrow to move the cursor in a text input etc.
  // Only special HTML elements have these default behaviors.

  const handleClickAway = useEventCallback$1(event => {
    // Given developers can stop the propagation of the synthetic event,
    // we can only be confident with a positive value.
    const insideReactTree = syntheticEventRef.current;
    syntheticEventRef.current = false;
    const doc = ownerDocument(nodeRef.current); // 1. IE11 support, which trigger the handleClickAway even after the unbind
    // 2. The child might render null.
    // 3. Behave like a blur listener.

    if (!activatedRef.current || !nodeRef.current || 'clientX' in event && clickedRootScrollbar(event, doc)) {
      return;
    } // Do not act if user performed touchmove


    if (movedRef.current) {
      movedRef.current = false;
      return;
    }

    let insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js

    if (event.composedPath) {
      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
    } else {
      insideDOM = !doc.documentElement.contains( // @ts-expect-error returns `false` as intended when not dispatched from a Node
      event.target) || nodeRef.current.contains( // @ts-expect-error returns `false` as intended when not dispatched from a Node
      event.target);
    }

    if (!insideDOM && (disableReactTree || !insideReactTree)) {
      onClickAway(event);
    }
  }); // Keep track of mouse/touch events that bubbled up through the portal.

  const createHandleSynthetic = handlerName => event => {
    syntheticEventRef.current = true;
    const childrenPropsHandler = children.props[handlerName];

    if (childrenPropsHandler) {
      childrenPropsHandler(event);
    }
  };

  const childrenProps = {
    ref: handleRef
  };

  if (touchEvent !== false) {
    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
  }

  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    if (touchEvent !== false) {
      const mappedTouchEvent = mapEventPropToEvent(touchEvent);
      const doc = ownerDocument(nodeRef.current);

      const handleTouchMove = () => {
        movedRef.current = true;
      };

      doc.addEventListener(mappedTouchEvent, handleClickAway);
      doc.addEventListener('touchmove', handleTouchMove);
      return () => {
        doc.removeEventListener(mappedTouchEvent, handleClickAway);
        doc.removeEventListener('touchmove', handleTouchMove);
      };
    }

    return undefined;
  }, [handleClickAway, touchEvent]);

  if (mouseEvent !== false) {
    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
  }

  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    if (mouseEvent !== false) {
      const mappedMouseEvent = mapEventPropToEvent(mouseEvent);
      const doc = ownerDocument(nodeRef.current);
      doc.addEventListener(mappedMouseEvent, handleClickAway);
      return () => {
        doc.removeEventListener(mappedMouseEvent, handleClickAway);
      };
    }

    return undefined;
  }, [handleClickAway, mouseEvent]);
  return /*#__PURE__*/jsxRuntime.exports.jsx(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Fragment, {
    children: /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(children, childrenProps)
  });
}

const _excluded$A = ["addEndListener", "appear", "children", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];

function getScale(value) {
  return `scale(${value}, ${value ** 2})`;
}

const styles = {
  entering: {
    opacity: 1,
    transform: getScale(1)
  },
  entered: {
    opacity: 1,
    transform: 'none'
  }
};
/**
 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
 * [Popover](/components/popover/) components.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

const Grow = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Grow(props, ref) {
  const {
    addEndListener,
    appear = true,
    children,
    easing,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    style,
    timeout = 'auto',
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Transition$1
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$A);

  const timer = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();
  const autoTimeout = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();
  const theme = useTheme();
  const nodeRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const foreignRef = useForkRef(children.ref, ref);
  const handleRef = useForkRef(nodeRef, foreignRef);

  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.

      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };

  const handleEntering = normalizedTransitionCallback(onEntering);
  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    reflow(node); // So the animation always start from the start.

    const {
      duration: transitionDuration,
      delay,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });
    let duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration,
      delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay,
      easing: transitionTimingFunction
    })].join(',');

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const {
      duration: transitionDuration,
      delay,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });
    let duration;

    if (timeout === 'auto') {
      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
      autoTimeout.current = duration;
    } else {
      duration = transitionDuration;
    }

    node.style.transition = [theme.transitions.create('opacity', {
      duration,
      delay
    }), theme.transitions.create('transform', {
      duration: duration * 0.666,
      delay: delay || duration * 0.333,
      easing: transitionTimingFunction
    })].join(',');
    node.style.opacity = '0';
    node.style.transform = getScale(0.75);

    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);

  const handleAddEndListener = next => {
    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTimeout.current || 0);
    }

    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };

  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);
  return /*#__PURE__*/jsxRuntime.exports.jsx(TransitionComponent, _extends$a({
    appear: appear,
    in: inProp,
    nodeRef: nodeRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    timeout: timeout === 'auto' ? null : timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(children, _extends$a({
        style: _extends$a({
          opacity: 0,
          transform: getScale(0.75),
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, styles[state], style, children.props.style),
        ref: handleRef
      }, childProps));
    }
  }));
});
Grow.muiSupportAuto = true;
var Grow$1 = Grow;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

/*:: import type { Window } from '../types'; */

/*:: declare function getWindow(node: Node | Window): Window; */
function getWindow(node) {
  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

/*:: declare function isElement(node: mixed): boolean %checks(node instanceof
  Element); */

function isElement(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}
/*:: declare function isHTMLElement(node: mixed): boolean %checks(node instanceof
  HTMLElement); */


function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}
/*:: declare function isShadowRoot(node: mixed): boolean %checks(node instanceof
  ShadowRoot); */


function isShadowRoot(node) {
  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

// Returns the layout rect of an element relative to its offsetParent. Layout
// means it doesn't take into account transforms.
function getLayoutRect(element) {
  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: element.offsetWidth,
    height: element.offsetHeight
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle$1(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || // DOM Element detected
    // $FlowFixMe[incompatible-return]: need a better way to handle this...
    element.host || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$1(element).position === 'fixed') {
    return null;
  }

  var offsetParent = element.offsetParent;

  if (offsetParent) {
    var html = getDocumentElement(offsetParent);

    if (getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static' && getComputedStyle$1(html).position !== 'static') {
      return html;
    }
  }

  return offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var currentNode = getParentNode(element);

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$1(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.

    if (css.transform !== 'none' || css.perspective !== 'none' || css.willChange && css.willChange !== 'auto') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$1(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && getNodeName(offsetParent) === 'body' && getComputedStyle$1(offsetParent).position === 'static') {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min, value, max) {
  return Math.max(min, Math.min(value, max));
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign(Object.assign({}, getFreshSideObject()), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = state.modifiersData[name + "#persistent"].padding;
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element,
      _options$padding = options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {

    return;
  }

  state.elements.arrow = arrowElement;
  state.modifiersData[name + "#persistent"] = {
    padding: mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements))
  };
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: Math.round(x * dpr) / dpr || 0,
    y: Math.round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets;

  var _ref3 = roundOffsets ? roundOffsetsByDPR(offsets) : offsets,
      _ref3$x = _ref3.x,
      x = _ref3$x === void 0 ? 0 : _ref3$x,
      _ref3$y = _ref3.y,
      y = _ref3$y === void 0 ? 0 : _ref3$y;

  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it

    /*:: offsetParent = (offsetParent: Element); */


    if (placement === top) {
      sideY = bottom;
      y -= offsetParent.clientHeight - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left) {
      sideX = right;
      x -= offsetParent.clientWidth - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign(Object.assign({}, commonStyles), {}, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) < 2 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign(Object.assign({}, commonStyles), {}, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref4) {
  var state = _ref4.state,
      options = _ref4.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  var commonStyles = {
    placement: getBasePlacement(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign(Object.assign({}, state.styles.popper), mapToStyles(Object.assign(Object.assign({}, commonStyles), {}, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign(Object.assign({}, state.styles.arrow), mapToStyles(Object.assign(Object.assign({}, commonStyles), {}, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign(Object.assign({}, state.attributes.popper), {}, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getBoundingClientRect(element) {
  var rect = element.getBoundingClientRect();
  return {
    width: rect.width,
    height: rect.height,
    top: rect.top,
    right: rect.right,
    bottom: rect.bottom,
    left: rect.left,
    x: rect.left,
    y: rect.top
  };
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0; // NB: This isn't supported on iOS <= 12. If the keyboard is open, the popper
  // can be obscured underneath it.
  // Also, `html.clientHeight` adds the bottom bar height in Safari iOS, even
  // if it isn't open, so if this isn't available, the popper will be detected
  // to overflow the bottom of the screen too early.

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height; // Uses Layout Viewport (like Chrome; Safari does not currently)
    // In Chrome, it returns a value very close to 0 (+/-) but contains rounding
    // errors due to floating point numbers, so we need to check precision.
    // Safari returns a number <= 0, usually < -1 when pinch-zoomed
    // Feature detection fails in mobile emulation mode in Chrome.
    // Math.abs(win.innerWidth / visualViewport.scale - visualViewport.width) <
    // 0.001
    // Fallback here: "Not Safari" userAgent

    if (!/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = element.ownerDocument.body;
  var width = Math.max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = Math.max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$1(body || html).direction === 'rtl') {
    x += Math.max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$1(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = getNodeName(scrollParent) === 'body';
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign(Object.assign({}, rect), {}, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element) {
  var rect = getBoundingClientRect(element);
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element)) : isHTMLElement(clippingParent) ? getInnerBoundingClientRect(clippingParent) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$1(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent);
    accRect.top = Math.max(rect.top, accRect.top);
    accRect.right = Math.min(rect.right, accRect.right);
    accRect.bottom = Math.min(rect.bottom, accRect.bottom);
    accRect.left = Math.max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function getVariation(placement) {
  return placement.split('-')[1];
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var referenceElement = state.elements.reference;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary);
  var referenceClientRect = getBoundingClientRect(referenceElement);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign(Object.assign({}, popperRect), popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

/*:: type OverflowsMap = { [ComputedPlacement]: number }; */

/*;; type OverflowsMap = { [key in ComputedPlacement]: number }; */
function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign(Object.assign({}, state.attributes.popper), {}, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign(Object.assign({}, rects), {}, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign(Object.assign({}, state.rects), {}, {
    placement: state.placement
  })) : tetherOffset;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min = popperOffsets[mainAxis] + overflow[mainSide];
    var max = popperOffsets[mainAxis] - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - tetherOffsetValue : minLen - arrowLen - arrowPaddingMin - tetherOffsetValue;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + tetherOffsetValue : maxLen + arrowLen + arrowPaddingMax + tetherOffsetValue;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = state.modifiersData.offset ? state.modifiersData.offset[state.placement][mainAxis] : 0;
    var tetherMin = popperOffsets[mainAxis] + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = popperOffsets[mainAxis] + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? Math.min(min, tetherMin) : min, offset, tether ? Math.max(max, tetherMax) : max);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var _preventedOffset = within(_min, _offset, _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

// Composite means it takes into account transforms as well as layout.

function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement);
  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign(Object.assign(Object.assign({}, existing), current), {}, {
      options: Object.assign(Object.assign({}, existing.options), current.options),
      data: Object.assign(Object.assign({}, existing.data), current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign(Object.assign({}, DEFAULT_OPTIONS), defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(options) {
        cleanupModifierEffects();
        state.options = Object.assign(Object.assign(Object.assign({}, defaultOptions), state.options), options);
        state.scrollParents = {
          reference: isElement(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

const _excluded$z = ["anchorEl", "children", "disablePortal", "modifiers", "open", "placement", "popperOptions", "popperRef", "TransitionProps"],
      _excluded2$3 = ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"];

function flipPlacement(placement, theme) {
  const direction = theme && theme.direction || 'ltr';

  if (direction === 'ltr') {
    return placement;
  }

  switch (placement) {
    case 'bottom-end':
      return 'bottom-start';

    case 'bottom-start':
      return 'bottom-end';

    case 'top-end':
      return 'top-start';

    case 'top-start':
      return 'top-end';

    default:
      return placement;
  }
}

function resolveAnchorEl$1(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

const defaultPopperOptions = {};
/* eslint-disable react/prop-types */

const PopperTooltip = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function PopperTooltip(props, ref) {
  const {
    anchorEl,
    children,
    disablePortal,
    modifiers,
    open,
    placement: initialPlacement,
    popperOptions,
    popperRef: popperRefProp,
    TransitionProps
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$z);

  const tooltipRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const ownRef = useForkRef(tooltipRef, ref);
  const popperRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const handlePopperRef = useForkRef(popperRef, popperRefProp);
  const handlePopperRefRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(handlePopperRef);
  useEnhancedEffect$1(() => {
    handlePopperRefRef.current = handlePopperRef;
  }, [handlePopperRef]);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useImperativeHandle(popperRefProp, () => popperRef.current, []);
  const theme = useTheme$2();
  const rtlPlacement = flipPlacement(initialPlacement, theme);
  /**
   * placement initialized from prop but can change during lifetime if modifiers.flip.
   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
   */

  const [placement, setPlacement] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(rtlPlacement);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    if (popperRef.current) {
      popperRef.current.forceUpdate();
    }
  });
  useEnhancedEffect$1(() => {
    if (!anchorEl || !open) {
      return undefined;
    }

    const handlePopperUpdate = data => {
      setPlacement(data.placement);
    };

    resolveAnchorEl$1(anchorEl);

    let popperModifiers = [{
      name: 'preventOverflow',
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: 'flip',
      options: {
        altBoundary: disablePortal
      }
    }, {
      name: 'onUpdate',
      enabled: true,
      phase: 'afterWrite',
      fn: ({
        state
      }) => {
        handlePopperUpdate(state);
      }
    }];

    if (modifiers != null) {
      popperModifiers = popperModifiers.concat(modifiers);
    }

    if (popperOptions && popperOptions.modifiers != null) {
      popperModifiers = popperModifiers.concat(popperOptions.modifiers);
    }

    const popper = createPopper(resolveAnchorEl$1(anchorEl), tooltipRef.current, _extends$a({
      placement: rtlPlacement
    }, popperOptions, {
      modifiers: popperModifiers
    }));
    handlePopperRefRef.current(popper);
    return () => {
      popper.destroy();
      handlePopperRefRef.current(null);
    };
  }, [anchorEl, disablePortal, modifiers, open, popperOptions, rtlPlacement]);
  const childProps = {
    placement
  };

  if (TransitionProps !== null) {
    childProps.TransitionProps = TransitionProps;
  }

  return /*#__PURE__*/jsxRuntime.exports.jsx("div", _extends$a({
    ref: ownRef,
    role: "tooltip"
  }, other, {
    children: typeof children === 'function' ? children(childProps) : children
  }));
});
/* eslint-enable react/prop-types */

/**
 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v2/) for positioning.
 */

const Popper = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Popper(props, ref) {
  const {
    anchorEl,
    children,
    container: containerProp,
    disablePortal = false,
    keepMounted = false,
    modifiers,
    open,
    placement = 'bottom',
    popperOptions = defaultPopperOptions,
    popperRef,
    style,
    transition = false
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded2$3);

  const [exited, setExited] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(true);

  const handleEnter = () => {
    setExited(false);
  };

  const handleExited = () => {
    setExited(true);
  };

  if (!keepMounted && !open && (!transition || exited)) {
    return null;
  } // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container


  const container = containerProp || (anchorEl ? ownerDocument(resolveAnchorEl$1(anchorEl)).body : undefined);
  return /*#__PURE__*/jsxRuntime.exports.jsx(Portal$1, {
    disablePortal: disablePortal,
    container: container,
    children: /*#__PURE__*/jsxRuntime.exports.jsx(PopperTooltip, _extends$a({
      anchorEl: anchorEl,
      disablePortal: disablePortal,
      modifiers: modifiers,
      ref: ref,
      open: transition ? !exited : open,
      placement: placement,
      popperOptions: popperOptions,
      popperRef: popperRef
    }, other, {
      style: _extends$a({
        // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
        position: 'fixed',
        // Fix Popper.js display issue
        top: 0,
        left: 0,
        display: !open && keepMounted && !transition ? 'none' : null
      }, style),
      TransitionProps: transition ? {
        in: open,
        onEnter: handleEnter,
        onExited: handleExited
      } : null,
      children: children
    }))
  });
});
var Popper$1 = Popper;

function getTooltipUtilityClass(slot) {
  return generateUtilityClass('MuiTooltip', slot);
}
const tooltipClasses = generateUtilityClasses('MuiTooltip', ['popper', 'popperInteractive', 'popperArrow', 'popperClose', 'tooltip', 'tooltipArrow', 'touch', 'tooltipPlacementLeft', 'tooltipPlacementRight', 'tooltipPlacementTop', 'tooltipPlacementBottom', 'arrow']);
var tooltipClasses$1 = tooltipClasses;

const _excluded$y = ["arrow", "children", "classes", "components", "componentsProps", "describeChild", "disableFocusListener", "disableHoverListener", "disableInteractive", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "followCursor", "id", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperComponent", "PopperProps", "title", "TransitionComponent", "TransitionProps"];

function round(value) {
  return Math.round(value * 1e5) / 1e5;
}

const useUtilityClasses$v = ownerState => {
  const {
    classes,
    disableInteractive,
    arrow,
    touch,
    placement
  } = ownerState;
  const slots = {
    popper: ['popper', !disableInteractive && 'popperInteractive', arrow && 'popperArrow'],
    tooltip: ['tooltip', arrow && 'tooltipArrow', touch && 'touch', `tooltipPlacement${capitalize$2(placement.split('-')[0])}`],
    arrow: ['arrow']
  };
  return composeClasses(slots, getTooltipUtilityClass, classes);
};

const TooltipPopper = styled$1(Popper$1, {
  name: 'MuiTooltip',
  slot: 'Popper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.popper, !ownerState.disableInteractive && styles.popperInteractive, ownerState.arrow && styles.popperArrow, !ownerState.open && styles.popperClose];
  }
})(({
  theme,
  ownerState,
  open
}) => _extends$a({
  zIndex: theme.zIndex.tooltip,
  pointerEvents: 'none'
}, !ownerState.disableInteractive && {
  pointerEvents: 'auto'
}, !open && {
  pointerEvents: 'none'
}, ownerState.arrow && {
  [`&[data-popper-placement*="bottom"] .${tooltipClasses$1.arrow}`]: {
    top: 0,
    marginTop: '-0.71em',
    '&::before': {
      transformOrigin: '0 100%'
    }
  },
  [`&[data-popper-placement*="top"] .${tooltipClasses$1.arrow}`]: {
    bottom: 0,
    marginBottom: '-0.71em',
    '&::before': {
      transformOrigin: '100% 0'
    }
  },
  [`&[data-popper-placement*="right"] .${tooltipClasses$1.arrow}`]: _extends$a({}, !ownerState.isRtl ? {
    left: 0,
    marginLeft: '-0.71em'
  } : {
    right: 0,
    marginRight: '-0.71em'
  }, {
    height: '1em',
    width: '0.71em',
    '&::before': {
      transformOrigin: '100% 100%'
    }
  }),
  [`&[data-popper-placement*="left"] .${tooltipClasses$1.arrow}`]: _extends$a({}, !ownerState.isRtl ? {
    right: 0,
    marginRight: '-0.71em'
  } : {
    left: 0,
    marginLeft: '-0.71em'
  }, {
    height: '1em',
    width: '0.71em',
    '&::before': {
      transformOrigin: '0 0'
    }
  })
}));
const TooltipTooltip = styled$1('div', {
  name: 'MuiTooltip',
  slot: 'Tooltip',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.tooltip, ownerState.touch && styles.touch, ownerState.arrow && styles.tooltipArrow, styles[`tooltipPlacement${capitalize$2(ownerState.placement.split('-')[0])}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$a({
  backgroundColor: alpha(theme.palette.grey[700], 0.92),
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.common.white,
  fontFamily: theme.typography.fontFamily,
  padding: '4px 8px',
  fontSize: theme.typography.pxToRem(11),
  maxWidth: 300,
  margin: 2,
  wordWrap: 'break-word',
  fontWeight: theme.typography.fontWeightMedium
}, ownerState.arrow && {
  position: 'relative',
  margin: 0
}, ownerState.touch && {
  padding: '8px 16px',
  fontSize: theme.typography.pxToRem(14),
  lineHeight: `${round(16 / 14)}em`,
  fontWeight: theme.typography.fontWeightRegular
}, {
  [`.${tooltipClasses$1.popper}[data-popper-placement*="left"] &`]: _extends$a({
    transformOrigin: 'right center'
  }, !ownerState.isRtl ? _extends$a({
    marginRight: '14px'
  }, ownerState.touch && {
    marginRight: '24px'
  }) : _extends$a({
    marginLeft: '14px'
  }, ownerState.touch && {
    marginLeft: '24px'
  })),
  [`.${tooltipClasses$1.popper}[data-popper-placement*="right"] &`]: _extends$a({
    transformOrigin: 'left center'
  }, !ownerState.isRtl ? _extends$a({
    marginLeft: '14px'
  }, ownerState.touch && {
    marginLeft: '24px'
  }) : _extends$a({
    marginRight: '14px'
  }, ownerState.touch && {
    marginRight: '24px'
  })),
  [`.${tooltipClasses$1.popper}[data-popper-placement*="top"] &`]: _extends$a({
    transformOrigin: 'center bottom',
    marginBottom: '14px'
  }, ownerState.touch && {
    marginBottom: '24px'
  }),
  [`.${tooltipClasses$1.popper}[data-popper-placement*="bottom"] &`]: _extends$a({
    transformOrigin: 'center top',
    marginTop: '14px'
  }, ownerState.touch && {
    marginTop: '24px'
  })
}));
const TooltipArrow = styled$1('span', {
  name: 'MuiTooltip',
  slot: 'Arrow',
  overridesResolver: (props, styles) => styles.arrow
})(({
  theme
}) => ({
  overflow: 'hidden',
  position: 'absolute',
  width: '1em',
  height: '0.71em'
  /* = width / sqrt(2) = (length of the hypotenuse) */
  ,
  boxSizing: 'border-box',
  color: alpha(theme.palette.grey[700], 0.9),
  '&::before': {
    content: '""',
    margin: 'auto',
    display: 'block',
    width: '100%',
    height: '100%',
    backgroundColor: 'currentColor',
    transform: 'rotate(45deg)'
  }
}));
let hystersisOpen = false;
let hystersisTimer = null;

function composeEventHandler(handler, eventHandler) {
  return event => {
    if (eventHandler) {
      eventHandler(event);
    }

    handler(event);
  };
} // TODO (v6) Remove PopperComponent, PopperProps, TransitionComponent and TransitionProps.


const Tooltip = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Tooltip(inProps, ref) {
  var _components$Popper, _ref, _components$Tooltip, _components$Arrow, _componentsProps$popp;

  const props = useThemeProps({
    props: inProps,
    name: 'MuiTooltip'
  });

  const {
    arrow = false,
    children,
    components = {},
    componentsProps = {},
    describeChild = false,
    disableFocusListener = false,
    disableHoverListener = false,
    disableInteractive: disableInteractiveProp = false,
    disableTouchListener = false,
    enterDelay = 100,
    enterNextDelay = 0,
    enterTouchDelay = 700,
    followCursor = false,
    id: idProp,
    leaveDelay = 0,
    leaveTouchDelay = 1500,
    onClose,
    onOpen,
    open: openProp,
    placement = 'bottom',
    PopperComponent: PopperComponentProp,
    PopperProps = {},
    title,
    TransitionComponent: TransitionComponentProp = Grow$1,
    TransitionProps
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$y);

  const theme = useTheme();
  const isRtl = theme.direction === 'rtl';
  const [childNode, setChildNode] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState();
  const [arrowRef, setArrowRef] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(null);
  const ignoreNonTouchEvents = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(false);
  const disableInteractive = disableInteractiveProp || followCursor;
  const closeTimer = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();
  const enterTimer = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();
  const leaveTimer = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();
  const touchTimer = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();
  const [openState, setOpenState] = useControlled({
    controlled: openProp,
    default: false,
    name: 'Tooltip',
    state: 'open'
  });
  let open = openState;

  const id = useId(idProp);
  const prevUserSelect = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();
  const stopTouchInteraction = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
    if (prevUserSelect.current !== undefined) {
      document.body.style.WebkitUserSelect = prevUserSelect.current;
      prevUserSelect.current = undefined;
    }

    clearTimeout(touchTimer.current);
  }, []);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    return () => {
      clearTimeout(closeTimer.current);
      clearTimeout(enterTimer.current);
      clearTimeout(leaveTimer.current);
      stopTouchInteraction();
    };
  }, [stopTouchInteraction]);

  const handleOpen = event => {
    clearTimeout(hystersisTimer);
    hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
    // We can skip rerendering when the tooltip is already open.
    // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.

    setOpenState(true);

    if (onOpen && !open) {
      onOpen(event);
    }
  };

  const handleClose = useEventCallback$1(
  /**
   * @param {React.SyntheticEvent | Event} event
   */
  event => {
    clearTimeout(hystersisTimer);
    hystersisTimer = setTimeout(() => {
      hystersisOpen = false;
    }, 800 + leaveDelay);
    setOpenState(false);

    if (onClose && open) {
      onClose(event);
    }

    clearTimeout(closeTimer.current);
    closeTimer.current = setTimeout(() => {
      ignoreNonTouchEvents.current = false;
    }, theme.transitions.duration.shortest);
  });

  const handleEnter = event => {
    if (ignoreNonTouchEvents.current && event.type !== 'touchstart') {
      return;
    } // Remove the title ahead of time.
    // We don't want to wait for the next render commit.
    // We would risk displaying two tooltips at the same time (native + this one).


    if (childNode) {
      childNode.removeAttribute('title');
    }

    clearTimeout(enterTimer.current);
    clearTimeout(leaveTimer.current);

    if (enterDelay || hystersisOpen && enterNextDelay) {
      enterTimer.current = setTimeout(() => {
        handleOpen(event);
      }, hystersisOpen ? enterNextDelay : enterDelay);
    } else {
      handleOpen(event);
    }
  };

  const handleLeave = event => {
    clearTimeout(enterTimer.current);
    clearTimeout(leaveTimer.current);
    leaveTimer.current = setTimeout(() => {
      handleClose(event);
    }, leaveDelay);
  };

  const {
    isFocusVisibleRef,
    onBlur: handleBlurVisible,
    onFocus: handleFocusVisible,
    ref: focusVisibleRef
  } = useIsFocusVisible(); // We don't necessarily care about the focusVisible state (which is safe to access via ref anyway).
  // We just need to re-render the Tooltip if the focus-visible state changes.

  const [, setChildIsFocusVisible] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);

  const handleBlur = event => {
    handleBlurVisible(event);

    if (isFocusVisibleRef.current === false) {
      setChildIsFocusVisible(false);
      handleLeave(event);
    }
  };

  const handleFocus = event => {
    // Workaround for https://github.com/facebook/react/issues/7769
    // The autoFocus of React might trigger the event before the componentDidMount.
    // We need to account for this eventuality.
    if (!childNode) {
      setChildNode(event.currentTarget);
    }

    handleFocusVisible(event);

    if (isFocusVisibleRef.current === true) {
      setChildIsFocusVisible(true);
      handleEnter(event);
    }
  };

  const detectTouchStart = event => {
    ignoreNonTouchEvents.current = true;
    const childrenProps = children.props;

    if (childrenProps.onTouchStart) {
      childrenProps.onTouchStart(event);
    }
  };

  const handleMouseOver = handleEnter;
  const handleMouseLeave = handleLeave;

  const handleTouchStart = event => {
    detectTouchStart(event);
    clearTimeout(leaveTimer.current);
    clearTimeout(closeTimer.current);
    stopTouchInteraction();
    prevUserSelect.current = document.body.style.WebkitUserSelect; // Prevent iOS text selection on long-tap.

    document.body.style.WebkitUserSelect = 'none';
    touchTimer.current = setTimeout(() => {
      document.body.style.WebkitUserSelect = prevUserSelect.current;
      handleEnter(event);
    }, enterTouchDelay);
  };

  const handleTouchEnd = event => {
    if (children.props.onTouchEnd) {
      children.props.onTouchEnd(event);
    }

    stopTouchInteraction();
    clearTimeout(leaveTimer.current);
    leaveTimer.current = setTimeout(() => {
      handleClose(event);
    }, leaveTouchDelay);
  };

  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    if (!open) {
      return undefined;
    }
    /**
     * @param {KeyboardEvent} nativeEvent
     */


    function handleKeyDown(nativeEvent) {
      // IE11, Edge (prior to using Bink?) use 'Esc'
      if (nativeEvent.key === 'Escape' || nativeEvent.key === 'Esc') {
        handleClose(nativeEvent);
      }
    }

    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleClose, open]);
  const handleUseRef = useForkRef(setChildNode, ref);
  const handleFocusRef = useForkRef(focusVisibleRef, handleUseRef);
  const handleRef = useForkRef(children.ref, handleFocusRef); // There is no point in displaying an empty tooltip.

  if (title === '') {
    open = false;
  }

  const positionRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef({
    x: 0,
    y: 0
  });
  const popperRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();

  const handleMouseMove = event => {
    const childrenProps = children.props;

    if (childrenProps.onMouseMove) {
      childrenProps.onMouseMove(event);
    }

    positionRef.current = {
      x: event.clientX,
      y: event.clientY
    };

    if (popperRef.current) {
      popperRef.current.update();
    }
  };

  const nameOrDescProps = {};
  const titleIsString = typeof title === 'string';

  if (describeChild) {
    nameOrDescProps.title = !open && titleIsString && !disableHoverListener ? title : null;
    nameOrDescProps['aria-describedby'] = open ? id : null;
  } else {
    nameOrDescProps['aria-label'] = titleIsString ? title : null;
    nameOrDescProps['aria-labelledby'] = open && !titleIsString ? id : null;
  }

  const childrenProps = _extends$a({}, nameOrDescProps, other, children.props, {
    className: clsx(other.className, children.props.className),
    onTouchStart: detectTouchStart,
    ref: handleRef
  }, followCursor ? {
    onMouseMove: handleMouseMove
  } : {});

  const interactiveWrapperListeners = {};

  if (!disableTouchListener) {
    childrenProps.onTouchStart = handleTouchStart;
    childrenProps.onTouchEnd = handleTouchEnd;
  }

  if (!disableHoverListener) {
    childrenProps.onMouseOver = composeEventHandler(handleMouseOver, childrenProps.onMouseOver);
    childrenProps.onMouseLeave = composeEventHandler(handleMouseLeave, childrenProps.onMouseLeave);

    if (!disableInteractive) {
      interactiveWrapperListeners.onMouseOver = handleMouseOver;
      interactiveWrapperListeners.onMouseLeave = handleMouseLeave;
    }
  }

  if (!disableFocusListener) {
    childrenProps.onFocus = composeEventHandler(handleFocus, childrenProps.onFocus);
    childrenProps.onBlur = composeEventHandler(handleBlur, childrenProps.onBlur);

    if (!disableInteractive) {
      interactiveWrapperListeners.onFocus = handleFocus;
      interactiveWrapperListeners.onBlur = handleBlur;
    }
  }

  const popperOptions = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
    var _PopperProps$popperOp;

    let tooltipModifiers = [{
      name: 'arrow',
      enabled: Boolean(arrowRef),
      options: {
        element: arrowRef,
        padding: 4
      }
    }];

    if ((_PopperProps$popperOp = PopperProps.popperOptions) != null && _PopperProps$popperOp.modifiers) {
      tooltipModifiers = tooltipModifiers.concat(PopperProps.popperOptions.modifiers);
    }

    return _extends$a({}, PopperProps.popperOptions, {
      modifiers: tooltipModifiers
    });
  }, [arrowRef, PopperProps]);

  const ownerState = _extends$a({}, props, {
    isRtl,
    arrow,
    disableInteractive,
    placement,
    PopperComponentProp,
    touch: ignoreNonTouchEvents.current
  });

  const classes = useUtilityClasses$v(ownerState);
  const PopperComponent = (_components$Popper = components.Popper) != null ? _components$Popper : TooltipPopper;
  const TransitionComponent = (_ref = TransitionComponentProp != null ? TransitionComponentProp : components.Transition) != null ? _ref : Grow$1;
  const TooltipComponent = (_components$Tooltip = components.Tooltip) != null ? _components$Tooltip : TooltipTooltip;
  const ArrowComponent = (_components$Arrow = components.Arrow) != null ? _components$Arrow : TooltipArrow;
  const popperProps = appendOwnerState(PopperComponent, _extends$a({}, PopperProps, componentsProps.popper), ownerState);
  const transitionProps = appendOwnerState(TransitionComponent, _extends$a({}, TransitionProps, componentsProps.transition), ownerState);
  const tooltipProps = appendOwnerState(TooltipComponent, _extends$a({}, componentsProps.tooltip), ownerState);
  const tooltipArrowProps = appendOwnerState(ArrowComponent, _extends$a({}, componentsProps.arrow), ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsxs(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Fragment, {
    children: [/*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(children, childrenProps), /*#__PURE__*/jsxRuntime.exports.jsx(PopperComponent, _extends$a({
      as: PopperComponentProp != null ? PopperComponentProp : Popper$1,
      placement: placement,
      anchorEl: followCursor ? {
        getBoundingClientRect: () => ({
          top: positionRef.current.y,
          left: positionRef.current.x,
          right: positionRef.current.x,
          bottom: positionRef.current.y,
          width: 0,
          height: 0
        })
      } : childNode,
      popperRef: popperRef,
      open: childNode ? open : false,
      id: id,
      transition: true
    }, interactiveWrapperListeners, popperProps, {
      className: clsx(classes.popper, (_componentsProps$popp = componentsProps.popper) == null ? void 0 : _componentsProps$popp.className),
      popperOptions: popperOptions,
      children: ({
        TransitionProps: TransitionPropsInner
      }) => {
        var _componentsProps$tool, _componentsProps$arro;

        return /*#__PURE__*/jsxRuntime.exports.jsx(TransitionComponent, _extends$a({
          timeout: theme.transitions.duration.shorter
        }, TransitionPropsInner, transitionProps, {
          children: /*#__PURE__*/jsxRuntime.exports.jsxs(TooltipComponent, _extends$a({}, tooltipProps, {
            className: clsx(classes.tooltip, (_componentsProps$tool = componentsProps.tooltip) == null ? void 0 : _componentsProps$tool.className),
            children: [title, arrow ? /*#__PURE__*/jsxRuntime.exports.jsx(ArrowComponent, _extends$a({}, tooltipArrowProps, {
              className: clsx(classes.arrow, (_componentsProps$arro = componentsProps.arrow) == null ? void 0 : _componentsProps$arro.className),
              ref: setArrowRef
            })) : null]
          }))
        }));
      }
    }))]
  });
});
var Tooltip$1 = Tooltip;

/*! clipboard-copy. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */

/* global DOMException */

var clipboardCopy_1 = clipboardCopy;

function makeError () {
  return new DOMException('The request is not allowed', 'NotAllowedError')
}

async function copyClipboardApi (text) {
  // Use the Async Clipboard API when available. Requires a secure browsing
  // context (i.e. HTTPS)
  if (!navigator.clipboard) {
    throw makeError()
  }
  return navigator.clipboard.writeText(text)
}

async function copyExecCommand (text) {
  // Put the text to copy into a <span>
  const span = document.createElement('span');
  span.textContent = text;

  // Preserve consecutive spaces and newlines
  span.style.whiteSpace = 'pre';
  span.style.webkitUserSelect = 'auto';
  span.style.userSelect = 'all';

  // Add the <span> to the page
  document.body.appendChild(span);

  // Make a selection object representing the range of text selected by the user
  const selection = window.getSelection();
  const range = window.document.createRange();
  selection.removeAllRanges();
  range.selectNode(span);
  selection.addRange(range);

  // Copy text to the clipboard
  let success = false;
  try {
    success = window.document.execCommand('copy');
  } finally {
    // Cleanup
    selection.removeAllRanges();
    window.document.body.removeChild(span);
  }

  if (!success) throw makeError()
}

async function clipboardCopy (text) {
  try {
    await copyClipboardApi(text);
  } catch (err) {
    // ...Otherwise, use document.execCommand() fallback
    try {
      await copyExecCommand(text);
    } catch (err2) {
      throw (err2 || err || makeError())
    }
  }
}

var copy = clipboardCopy_1;

function getInputAdornmentUtilityClass(slot) {
  return generateUtilityClass('MuiInputAdornment', slot);
}
const inputAdornmentClasses = generateUtilityClasses('MuiInputAdornment', ['root', 'filled', 'standard', 'outlined', 'positionStart', 'positionEnd', 'disablePointerEvents', 'hiddenLabel', 'sizeSmall']);
var inputAdornmentClasses$1 = inputAdornmentClasses;

const _excluded$x = ["children", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"];

const overridesResolver$4 = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, styles[`position${capitalize$2(ownerState.position)}`], ownerState.disablePointerEvents === true && styles.disablePointerEvents, styles[ownerState.variant]];
};

const useUtilityClasses$u = ownerState => {
  const {
    classes,
    disablePointerEvents,
    hiddenLabel,
    position,
    size,
    variant
  } = ownerState;
  const slots = {
    root: ['root', disablePointerEvents && 'disablePointerEvents', position && `position${capitalize$2(position)}`, variant, hiddenLabel && 'hiddenLabel', size && `size${capitalize$2(size)}`]
  };
  return composeClasses(slots, getInputAdornmentUtilityClass, classes);
};

const InputAdornmentRoot = styled$1('div', {
  name: 'MuiInputAdornment',
  slot: 'Root',
  overridesResolver: overridesResolver$4
})(({
  theme,
  ownerState
}) => _extends$a({
  display: 'flex',
  height: '0.01em',
  // Fix IE11 flexbox alignment. To remove at some point.
  maxHeight: '2em',
  alignItems: 'center',
  whiteSpace: 'nowrap',
  color: theme.palette.action.active
}, ownerState.variant === 'filled' && {
  // Styles applied to the root element if `variant="filled"`.
  [`&.${inputAdornmentClasses$1.positionStart}&:not(.${inputAdornmentClasses$1.hiddenLabel})`]: {
    marginTop: 16
  }
}, ownerState.position === 'start' && {
  // Styles applied to the root element if `position="start"`.
  marginRight: 8
}, ownerState.position === 'end' && {
  // Styles applied to the root element if `position="end"`.
  marginLeft: 8
}, ownerState.disablePointerEvents === true && {
  // Styles applied to the root element if `disablePointerEvents={true}`.
  pointerEvents: 'none'
}));
const InputAdornment = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function InputAdornment(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiInputAdornment'
  });

  const {
    children,
    className,
    component = 'div',
    disablePointerEvents = false,
    disableTypography = false,
    position,
    variant: variantProp
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$x);

  const muiFormControl = useFormControl() || {};
  let variant = variantProp;

  if (variantProp && muiFormControl.variant) ;

  if (muiFormControl && !variant) {
    variant = muiFormControl.variant;
  }

  const ownerState = _extends$a({}, props, {
    hiddenLabel: muiFormControl.hiddenLabel,
    size: muiFormControl.size,
    disablePointerEvents,
    position,
    variant
  });

  const classes = useUtilityClasses$u(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(FormControlContext$1.Provider, {
    value: null,
    children: /*#__PURE__*/jsxRuntime.exports.jsx(InputAdornmentRoot, _extends$a({
      as: component,
      ownerState: ownerState,
      className: clsx(classes.root, className),
      ref: ref
    }, other, {
      children: typeof children === 'string' && !disableTypography ? /*#__PURE__*/jsxRuntime.exports.jsx(Typography$1, {
        color: "text.secondary",
        children: children
      }) : /*#__PURE__*/jsxRuntime.exports.jsxs(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Fragment, {
        children: [position === 'start' ?
        /*#__PURE__*/

        /* notranslate needed while Google Translate will not fix zero-width space issue */

        /* eslint-disable-next-line react/no-danger */
        jsxRuntime.exports.jsx("span", {
          className: "notranslate",
          dangerouslySetInnerHTML: {
            __html: '&#8203;'
          }
        }) : null, children]
      })
    }))
  });
});
var InputAdornment$1 = InputAdornment;

/**
 * @ignore - internal component.
 */

const ListContext = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createContext({});

var ListContext$1 = ListContext;

function getListUtilityClass(slot) {
  return generateUtilityClass('MuiList', slot);
}
generateUtilityClasses('MuiList', ['root', 'padding', 'dense', 'subheader']);

const _excluded$w = ["children", "className", "component", "dense", "disablePadding", "subheader"];

const useUtilityClasses$t = ownerState => {
  const {
    classes,
    disablePadding,
    dense,
    subheader
  } = ownerState;
  const slots = {
    root: ['root', !disablePadding && 'padding', dense && 'dense', subheader && 'subheader']
  };
  return composeClasses(slots, getListUtilityClass, classes);
};

const ListRoot = styled$1('ul', {
  name: 'MuiList',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, !ownerState.disablePadding && styles.padding, ownerState.dense && styles.dense, ownerState.subheader && styles.subheader];
  }
})(({
  ownerState
}) => _extends$a({
  listStyle: 'none',
  margin: 0,
  padding: 0,
  position: 'relative'
}, !ownerState.disablePadding && {
  paddingTop: 8,
  paddingBottom: 8
}, ownerState.subheader && {
  paddingTop: 0
}));
const List = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function List(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiList'
  });

  const {
    children,
    className,
    component = 'ul',
    dense = false,
    disablePadding = false,
    subheader
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$w);

  const context = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
    dense
  }), [dense]);

  const ownerState = _extends$a({}, props, {
    component,
    dense,
    disablePadding
  });

  const classes = useUtilityClasses$t(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(ListContext$1.Provider, {
    value: context,
    children: /*#__PURE__*/jsxRuntime.exports.jsxs(ListRoot, _extends$a({
      as: component,
      className: clsx(classes.root, className),
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: [subheader, children]
    }))
  });
});
var List$1 = List;

const _excluded$v = ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"];

function nextItem(list, item, disableListWrap) {
  if (list === item) {
    return list.firstChild;
  }

  if (item && item.nextElementSibling) {
    return item.nextElementSibling;
  }

  return disableListWrap ? null : list.firstChild;
}

function previousItem(list, item, disableListWrap) {
  if (list === item) {
    return disableListWrap ? list.firstChild : list.lastChild;
  }

  if (item && item.previousElementSibling) {
    return item.previousElementSibling;
  }

  return disableListWrap ? null : list.lastChild;
}

function textCriteriaMatches(nextFocus, textCriteria) {
  if (textCriteria === undefined) {
    return true;
  }

  let text = nextFocus.innerText;

  if (text === undefined) {
    // jsdom doesn't support innerText
    text = nextFocus.textContent;
  }

  text = text.trim().toLowerCase();

  if (text.length === 0) {
    return false;
  }

  if (textCriteria.repeating) {
    return text[0] === textCriteria.keys[0];
  }

  return text.indexOf(textCriteria.keys.join('')) === 0;
}

function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
  let wrappedOnce = false;
  let nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);

  while (nextFocus) {
    // Prevent infinite loop.
    if (nextFocus === list.firstChild) {
      if (wrappedOnce) {
        return false;
      }

      wrappedOnce = true;
    } // Same logic as useAutocomplete.js


    const nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';

    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
      // Move to the next element.
      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
    } else {
      nextFocus.focus();
      return true;
    }
  }

  return false;
}
/**
 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
 * It's exposed to help customization of the [`Menu`](/api/menu/) component if you
 * use it separately you need to move focus into the component manually. Once
 * the focus is placed inside the component it is fully keyboard accessible.
 */


const MenuList = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function MenuList(props, ref) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions,
    autoFocus = false,
    autoFocusItem = false,
    children,
    className,
    disabledItemsFocusable = false,
    disableListWrap = false,
    onKeyDown,
    variant = 'selectedMenu'
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$v);

  const listRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const textCriteriaRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef({
    keys: [],
    repeating: true,
    previousKeyMatched: true,
    lastTime: null
  });
  useEnhancedEffect$1(() => {
    if (autoFocus) {
      listRef.current.focus();
    }
  }, [autoFocus]);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useImperativeHandle(actions, () => ({
    adjustStyleForScrollbar: (containerElement, theme) => {
      // Let's ignore that piece of logic if users are already overriding the width
      // of the menu.
      const noExplicitWidth = !listRef.current.style.width;

      if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
        const scrollbarSize = `${getScrollbarSize(ownerDocument(containerElement))}px`;
        listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
        listRef.current.style.width = `calc(100% + ${scrollbarSize})`;
      }

      return listRef.current;
    }
  }), []);

  const handleKeyDown = event => {
    const list = listRef.current;
    const key = event.key;
    /**
     * @type {Element} - will always be defined since we are in a keydown handler
     * attached to an element. A keydown event is either dispatched to the activeElement
     * or document.body or document.documentElement. Only the first case will
     * trigger this specific handler.
     */

    const currentFocus = ownerDocument(list).activeElement;

    if (key === 'ArrowDown') {
      // Prevent scroll of the page
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'ArrowUp') {
      event.preventDefault();
      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key === 'Home') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
    } else if (key === 'End') {
      event.preventDefault();
      moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
    } else if (key.length === 1) {
      const criteria = textCriteriaRef.current;
      const lowerKey = key.toLowerCase();
      const currTime = performance.now();

      if (criteria.keys.length > 0) {
        // Reset
        if (currTime - criteria.lastTime > 500) {
          criteria.keys = [];
          criteria.repeating = true;
          criteria.previousKeyMatched = true;
        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
          criteria.repeating = false;
        }
      }

      criteria.lastTime = currTime;
      criteria.keys.push(lowerKey);
      const keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);

      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
        event.preventDefault();
      } else {
        criteria.previousKeyMatched = false;
      }
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  const handleRef = useForkRef(listRef, ref);
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */

  let activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Children.forEach(children, (child, index) => {
    if (! /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.isValidElement(child)) {
      return;
    }

    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  const items = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Children.map(children, (child, index) => {
    if (index === activeItemIndex) {
      const newChildProps = {};

      if (autoFocusItem) {
        newChildProps.autoFocus = true;
      }

      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
        newChildProps.tabIndex = 0;
      }

      return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(child, newChildProps);
    }

    return child;
  });
  return /*#__PURE__*/jsxRuntime.exports.jsx(List$1, _extends$a({
    role: "menu",
    ref: handleRef,
    className: className,
    onKeyDown: handleKeyDown,
    tabIndex: autoFocus ? 0 : -1
  }, other, {
    children: items
  }));
});
var MenuList$1 = MenuList;

function getPopoverUtilityClass(slot) {
  return generateUtilityClass('MuiPopover', slot);
}
generateUtilityClasses('MuiPopover', ['root', 'paper']);

const _excluded$u = ["onEntering"],
      _excluded2$2 = ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "className", "container", "elevation", "marginThreshold", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"];
function getOffsetTop(rect, vertical) {
  let offset = 0;

  if (typeof vertical === 'number') {
    offset = vertical;
  } else if (vertical === 'center') {
    offset = rect.height / 2;
  } else if (vertical === 'bottom') {
    offset = rect.height;
  }

  return offset;
}
function getOffsetLeft(rect, horizontal) {
  let offset = 0;

  if (typeof horizontal === 'number') {
    offset = horizontal;
  } else if (horizontal === 'center') {
    offset = rect.width / 2;
  } else if (horizontal === 'right') {
    offset = rect.width;
  }

  return offset;
}

function getTransformOriginValue(transformOrigin) {
  return [transformOrigin.horizontal, transformOrigin.vertical].map(n => typeof n === 'number' ? `${n}px` : n).join(' ');
}

function resolveAnchorEl(anchorEl) {
  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
}

const useUtilityClasses$s = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    paper: ['paper']
  };
  return composeClasses(slots, getPopoverUtilityClass, classes);
};

const PopoverRoot = styled$1(Modal$1, {
  name: 'MuiPopover',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
const PopoverPaper = styled$1(Paper$1, {
  name: 'MuiPopover',
  slot: 'Paper',
  overridesResolver: (props, styles) => styles.paper
})({
  position: 'absolute',
  overflowY: 'auto',
  overflowX: 'hidden',
  // So we see the popover when it's empty.
  // It's most likely on issue on userland.
  minWidth: 16,
  minHeight: 16,
  maxWidth: 'calc(100% - 32px)',
  maxHeight: 'calc(100% - 32px)',
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
});
const Popover = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Popover(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPopover'
  });

  const {
    action,
    anchorEl,
    anchorOrigin = {
      vertical: 'top',
      horizontal: 'left'
    },
    anchorPosition,
    anchorReference = 'anchorEl',
    children,
    className,
    container: containerProp,
    elevation = 8,
    marginThreshold = 16,
    open,
    PaperProps = {},
    transformOrigin = {
      vertical: 'top',
      horizontal: 'left'
    },
    TransitionComponent = Grow$1,
    transitionDuration: transitionDurationProp = 'auto',
    TransitionProps: {
      onEntering
    } = {}
  } = props,
        TransitionProps = _objectWithoutPropertiesLoose$6(props.TransitionProps, _excluded$u),
        other = _objectWithoutPropertiesLoose$6(props, _excluded2$2);

  const paperRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();
  const handlePaperRef = useForkRef(paperRef, PaperProps.ref);

  const ownerState = _extends$a({}, props, {
    anchorOrigin,
    anchorReference,
    elevation,
    marginThreshold,
    PaperProps,
    transformOrigin,
    TransitionComponent,
    transitionDuration: transitionDurationProp,
    TransitionProps
  });

  const classes = useUtilityClasses$s(ownerState); // Returns the top/left offset of the position
  // to attach to on the anchor element (or body if none is provided)

  const getAnchorOffset = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
    if (anchorReference === 'anchorPosition') {

      return anchorPosition;
    }

    const resolvedAnchorEl = resolveAnchorEl(anchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover

    const anchorElement = resolvedAnchorEl && resolvedAnchorEl.nodeType === 1 ? resolvedAnchorEl : ownerDocument(paperRef.current).body;
    const anchorRect = anchorElement.getBoundingClientRect();

    return {
      top: anchorRect.top + getOffsetTop(anchorRect, anchorOrigin.vertical),
      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
    };
  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]); // Returns the base transform origin using the element

  const getTransformOrigin = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(elemRect => {
    return {
      vertical: getOffsetTop(elemRect, transformOrigin.vertical),
      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
    };
  }, [transformOrigin.horizontal, transformOrigin.vertical]);
  const getPositioningStyle = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(element => {
    const elemRect = {
      width: element.offsetWidth,
      height: element.offsetHeight
    }; // Get the transform origin point on the element itself

    const elemTransformOrigin = getTransformOrigin(elemRect);

    if (anchorReference === 'none') {
      return {
        top: null,
        left: null,
        transformOrigin: getTransformOriginValue(elemTransformOrigin)
      };
    } // Get the offset of the anchoring element


    const anchorOffset = getAnchorOffset(); // Calculate element positioning

    let top = anchorOffset.top - elemTransformOrigin.vertical;
    let left = anchorOffset.left - elemTransformOrigin.horizontal;
    const bottom = top + elemRect.height;
    const right = left + elemRect.width; // Use the parent window of the anchorEl if provided

    const containerWindow = ownerWindow(resolveAnchorEl(anchorEl)); // Window thresholds taking required margin into account

    const heightThreshold = containerWindow.innerHeight - marginThreshold;
    const widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting

    if (top < marginThreshold) {
      const diff = top - marginThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    } else if (bottom > heightThreshold) {
      const diff = bottom - heightThreshold;
      top -= diff;
      elemTransformOrigin.vertical += diff;
    }


    if (left < marginThreshold) {
      const diff = left - marginThreshold;
      left -= diff;
      elemTransformOrigin.horizontal += diff;
    } else if (right > widthThreshold) {
      const diff = right - widthThreshold;
      left -= diff;
      elemTransformOrigin.horizontal += diff;
    }

    return {
      top: `${Math.round(top)}px`,
      left: `${Math.round(left)}px`,
      transformOrigin: getTransformOriginValue(elemTransformOrigin)
    };
  }, [anchorEl, anchorReference, getAnchorOffset, getTransformOrigin, marginThreshold]);
  const setPositioningStyles = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
    const element = paperRef.current;

    if (!element) {
      return;
    }

    const positioning = getPositioningStyle(element);

    if (positioning.top !== null) {
      element.style.top = positioning.top;
    }

    if (positioning.left !== null) {
      element.style.left = positioning.left;
    }

    element.style.transformOrigin = positioning.transformOrigin;
  }, [getPositioningStyle]);

  const handleEntering = (element, isAppearing) => {
    if (onEntering) {
      onEntering(element, isAppearing);
    }

    setPositioningStyles();
  };

  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    if (open) {
      setPositioningStyles();
    }
  });
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useImperativeHandle(action, () => open ? {
    updatePosition: () => {
      setPositioningStyles();
    }
  } : null, [open, setPositioningStyles]);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    if (!open) {
      return undefined;
    }

    const handleResize = debounce$1(() => {
      setPositioningStyles();
    });
    const containerWindow = ownerWindow(anchorEl);
    containerWindow.addEventListener('resize', handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [anchorEl, open, setPositioningStyles]);
  let transitionDuration = transitionDurationProp;

  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
    transitionDuration = undefined;
  } // If the container prop is provided, use that
  // If the anchorEl prop is provided, use its parent body element as the container
  // If neither are provided let the Modal take care of choosing the container


  const container = containerProp || (anchorEl ? ownerDocument(resolveAnchorEl(anchorEl)).body : undefined);
  return /*#__PURE__*/jsxRuntime.exports.jsx(PopoverRoot, _extends$a({
    BackdropProps: {
      invisible: true
    },
    className: clsx(classes.root, className),
    container: container,
    open: open,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/jsxRuntime.exports.jsx(TransitionComponent, _extends$a({
      appear: true,
      in: open,
      onEntering: handleEntering,
      timeout: transitionDuration
    }, TransitionProps, {
      children: /*#__PURE__*/jsxRuntime.exports.jsx(PopoverPaper, _extends$a({
        elevation: elevation
      }, PaperProps, {
        ref: handlePaperRef,
        className: clsx(classes.paper, PaperProps.className),
        children: children
      }))
    }))
  }));
});
var Popover$1 = Popover;

function getMenuUtilityClass(slot) {
  return generateUtilityClass('MuiMenu', slot);
}
generateUtilityClasses('MuiMenu', ['root', 'paper', 'list']);

const _excluded$t = ["onEntering"],
      _excluded2$1 = ["autoFocus", "children", "disableAutoFocusItem", "MenuListProps", "onClose", "open", "PaperProps", "PopoverClasses", "transitionDuration", "TransitionProps", "variant"];
const RTL_ORIGIN = {
  vertical: 'top',
  horizontal: 'right'
};
const LTR_ORIGIN = {
  vertical: 'top',
  horizontal: 'left'
};

const useUtilityClasses$r = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root'],
    paper: ['paper'],
    list: ['list']
  };
  return composeClasses(slots, getMenuUtilityClass, classes);
};

const MenuRoot = styled$1(Popover$1, {
  shouldForwardProp: prop => rootShouldForwardProp$1(prop) || prop === 'classes',
  name: 'MuiMenu',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
const MenuPaper = styled$1(Paper$1, {
  name: 'MuiMenu',
  slot: 'Paper',
  overridesResolver: (props, styles) => styles.paper
})({
  // specZ: The maximum height of a simple menu should be one or more rows less than the view
  // height. This ensures a tapable area outside of the simple menu with which to dismiss
  // the menu.
  maxHeight: 'calc(100% - 96px)',
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch'
});
const MenuMenuList = styled$1(MenuList$1, {
  name: 'MuiMenu',
  slot: 'List',
  overridesResolver: (props, styles) => styles.list
})({
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0
});
const Menu$2 = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Menu(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiMenu'
  });

  const {
    autoFocus = true,
    children,
    disableAutoFocusItem = false,
    MenuListProps = {},
    onClose,
    open,
    PaperProps = {},
    PopoverClasses,
    transitionDuration = 'auto',
    TransitionProps: {
      onEntering
    } = {},
    variant = 'selectedMenu'
  } = props,
        TransitionProps = _objectWithoutPropertiesLoose$6(props.TransitionProps, _excluded$t),
        other = _objectWithoutPropertiesLoose$6(props, _excluded2$1);

  const theme = useTheme();
  const isRtl = theme.direction === 'rtl';

  const ownerState = _extends$a({}, props, {
    autoFocus,
    disableAutoFocusItem,
    MenuListProps,
    onEntering,
    PaperProps,
    transitionDuration,
    TransitionProps,
    variant
  });

  const classes = useUtilityClasses$r(ownerState);
  const autoFocusItem = autoFocus && !disableAutoFocusItem && open;
  const menuListActionsRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);

  const handleEntering = (element, isAppearing) => {
    if (menuListActionsRef.current) {
      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
    }

    if (onEntering) {
      onEntering(element, isAppearing);
    }
  };

  const handleListKeyDown = event => {
    if (event.key === 'Tab') {
      event.preventDefault();

      if (onClose) {
        onClose(event, 'tabKeyDown');
      }
    }
  };
  /**
   * the index of the item should receive focus
   * in a `variant="selectedMenu"` it's the first `selected` item
   * otherwise it's the very first item.
   */


  let activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
  // to check if there is a `selected` item. We're looking for the last `selected`
  // item and use the first valid item as a fallback

  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Children.map(children, (child, index) => {
    if (! /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.isValidElement(child)) {
      return;
    }

    if (!child.props.disabled) {
      if (variant === 'selectedMenu' && child.props.selected) {
        activeItemIndex = index;
      } else if (activeItemIndex === -1) {
        activeItemIndex = index;
      }
    }
  });
  return /*#__PURE__*/jsxRuntime.exports.jsx(MenuRoot, _extends$a({
    classes: PopoverClasses,
    onClose: onClose,
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: isRtl ? 'right' : 'left'
    },
    transformOrigin: isRtl ? RTL_ORIGIN : LTR_ORIGIN,
    PaperProps: _extends$a({
      component: MenuPaper
    }, PaperProps, {
      classes: _extends$a({}, PaperProps.classes, {
        root: classes.paper
      })
    }),
    className: classes.root,
    open: open,
    ref: ref,
    transitionDuration: transitionDuration,
    TransitionProps: _extends$a({
      onEntering: handleEntering
    }, TransitionProps),
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/jsxRuntime.exports.jsx(MenuMenuList, _extends$a({
      onKeyDown: handleListKeyDown,
      actions: menuListActionsRef,
      autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
      autoFocusItem: autoFocusItem,
      variant: variant
    }, MenuListProps, {
      className: clsx(classes.list, MenuListProps.className),
      children: children
    }))
  }));
});
var MuiMenu = Menu$2;

function getDividerUtilityClass(slot) {
  return generateUtilityClass('MuiDivider', slot);
}
const dividerClasses = generateUtilityClasses('MuiDivider', ['root', 'absolute', 'fullWidth', 'inset', 'middle', 'flexItem', 'light', 'vertical', 'withChildren', 'withChildrenVertical', 'textAlignRight', 'textAlignLeft', 'wrapper', 'wrapperVertical']);

const _excluded$s = ["absolute", "children", "className", "component", "flexItem", "light", "orientation", "role", "textAlign", "variant"];

const useUtilityClasses$q = ownerState => {
  const {
    absolute,
    children,
    classes,
    flexItem,
    light,
    orientation,
    textAlign,
    variant
  } = ownerState;
  const slots = {
    root: ['root', absolute && 'absolute', variant, light && 'light', orientation === 'vertical' && 'vertical', flexItem && 'flexItem', children && 'withChildren', children && orientation === 'vertical' && 'withChildrenVertical', textAlign === 'right' && orientation !== 'vertical' && 'textAlignRight', textAlign === 'left' && orientation !== 'vertical' && 'textAlignLeft'],
    wrapper: ['wrapper', orientation === 'vertical' && 'wrapperVertical']
  };
  return composeClasses(slots, getDividerUtilityClass, classes);
};

const DividerRoot = styled$1('div', {
  name: 'MuiDivider',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.absolute && styles.absolute, styles[ownerState.variant], ownerState.light && styles.light, ownerState.orientation === 'vertical' && styles.vertical, ownerState.flexItem && styles.flexItem, ownerState.children && styles.withChildren, ownerState.children && ownerState.orientation === 'vertical' && styles.withChildrenVertical, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && styles.textAlignRight, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && styles.textAlignLeft];
  }
})(({
  theme,
  ownerState
}) => _extends$a({
  margin: 0,
  // Reset browser default style.
  flexShrink: 0,
  borderWidth: 0,
  borderStyle: 'solid',
  borderColor: theme.palette.divider,
  borderBottomWidth: 'thin'
}, ownerState.absolute && {
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%'
}, ownerState.light && {
  borderColor: alpha(theme.palette.divider, 0.08)
}, ownerState.variant === 'inset' && {
  marginLeft: 72
}, ownerState.variant === 'middle' && ownerState.orientation === 'horizontal' && {
  marginLeft: theme.spacing(2),
  marginRight: theme.spacing(2)
}, ownerState.variant === 'middle' && ownerState.orientation === 'vertical' && {
  marginTop: theme.spacing(1),
  marginBottom: theme.spacing(1)
}, ownerState.orientation === 'vertical' && {
  height: '100%',
  borderBottomWidth: 0,
  borderRightWidth: 'thin'
}, ownerState.flexItem && {
  alignSelf: 'stretch',
  height: 'auto'
}), ({
  theme,
  ownerState
}) => _extends$a({}, ownerState.children && {
  display: 'flex',
  whiteSpace: 'nowrap',
  textAlign: 'center',
  border: 0,
  '&::before, &::after': {
    position: 'relative',
    width: '100%',
    borderTop: `thin solid ${theme.palette.divider}`,
    top: '50%',
    content: '""',
    transform: 'translateY(50%)'
  }
}), ({
  theme,
  ownerState
}) => _extends$a({}, ownerState.children && ownerState.orientation === 'vertical' && {
  flexDirection: 'column',
  '&::before, &::after': {
    height: '100%',
    top: '0%',
    left: '50%',
    borderTop: 0,
    borderLeft: `thin solid ${theme.palette.divider}`,
    transform: 'translateX(0%)'
  }
}), ({
  ownerState
}) => _extends$a({}, ownerState.textAlign === 'right' && ownerState.orientation !== 'vertical' && {
  '&::before': {
    width: '90%'
  },
  '&::after': {
    width: '10%'
  }
}, ownerState.textAlign === 'left' && ownerState.orientation !== 'vertical' && {
  '&::before': {
    width: '10%'
  },
  '&::after': {
    width: '90%'
  }
}));
const DividerWrapper = styled$1('span', {
  name: 'MuiDivider',
  slot: 'Wrapper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.wrapper, ownerState.orientation === 'vertical' && styles.wrapperVertical];
  }
})(({
  theme,
  ownerState
}) => _extends$a({
  display: 'inline-block',
  paddingLeft: theme.spacing(1.2),
  paddingRight: theme.spacing(1.2)
}, ownerState.orientation === 'vertical' && {
  paddingTop: theme.spacing(1.2),
  paddingBottom: theme.spacing(1.2)
}));
const Divider = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Divider(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiDivider'
  });

  const {
    absolute = false,
    children,
    className,
    component = children ? 'div' : 'hr',
    flexItem = false,
    light = false,
    orientation = 'horizontal',
    role = component !== 'hr' ? 'separator' : undefined,
    textAlign = 'center',
    variant = 'fullWidth'
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$s);

  const ownerState = _extends$a({}, props, {
    absolute,
    component,
    flexItem,
    light,
    orientation,
    role,
    textAlign,
    variant
  });

  const classes = useUtilityClasses$q(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(DividerRoot, _extends$a({
    as: component,
    className: clsx(classes.root, className),
    role: role,
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: children ? /*#__PURE__*/jsxRuntime.exports.jsx(DividerWrapper, {
      className: classes.wrapper,
      ownerState: ownerState,
      children: children
    }) : null
  }));
});
var Divider$1 = Divider;

function getListItemIconUtilityClass(slot) {
  return generateUtilityClass('MuiListItemIcon', slot);
}
const listItemIconClasses = generateUtilityClasses('MuiListItemIcon', ['root', 'alignItemsFlexStart']);
var listItemIconClasses$1 = listItemIconClasses;

const _excluded$r = ["className"];

const useUtilityClasses$p = ownerState => {
  const {
    alignItems,
    classes
  } = ownerState;
  const slots = {
    root: ['root', alignItems === 'flex-start' && 'alignItemsFlexStart']
  };
  return composeClasses(slots, getListItemIconUtilityClass, classes);
};

const ListItemIconRoot = styled$1('div', {
  name: 'MuiListItemIcon',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart];
  }
})(({
  theme,
  ownerState
}) => _extends$a({
  minWidth: 56,
  color: theme.palette.action.active,
  flexShrink: 0,
  display: 'inline-flex'
}, ownerState.alignItems === 'flex-start' && {
  marginTop: 8
}));
/**
 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
 */

const ListItemIcon = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function ListItemIcon(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiListItemIcon'
  });

  const {
    className
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$r);

  const context = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(ListContext$1);

  const ownerState = _extends$a({}, props, {
    alignItems: context.alignItems
  });

  const classes = useUtilityClasses$p(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(ListItemIconRoot, _extends$a({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
var ListItemIcon$1 = ListItemIcon;

function getListItemTextUtilityClass(slot) {
  return generateUtilityClass('MuiListItemText', slot);
}
const listItemTextClasses = generateUtilityClasses('MuiListItemText', ['root', 'multiline', 'dense', 'inset', 'primary', 'secondary']);
var listItemTextClasses$1 = listItemTextClasses;

const _excluded$q = ["children", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"];

const useUtilityClasses$o = ownerState => {
  const {
    classes,
    inset,
    primary,
    secondary,
    dense
  } = ownerState;
  const slots = {
    root: ['root', inset && 'inset', dense && 'dense', primary && secondary && 'multiline'],
    primary: ['primary'],
    secondary: ['secondary']
  };
  return composeClasses(slots, getListItemTextUtilityClass, classes);
};

const ListItemTextRoot = styled$1('div', {
  name: 'MuiListItemText',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${listItemTextClasses$1.primary}`]: styles.primary
    }, {
      [`& .${listItemTextClasses$1.secondary}`]: styles.secondary
    }, styles.root, ownerState.inset && styles.inset, ownerState.primary && ownerState.secondary && styles.multiline, ownerState.dense && styles.dense];
  }
})(({
  ownerState
}) => _extends$a({
  flex: '1 1 auto',
  minWidth: 0,
  marginTop: 4,
  marginBottom: 4
}, ownerState.primary && ownerState.secondary && {
  marginTop: 6,
  marginBottom: 6
}, ownerState.inset && {
  paddingLeft: 56
}));
const ListItemText = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function ListItemText(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiListItemText'
  });

  const {
    children,
    className,
    disableTypography = false,
    inset = false,
    primary: primaryProp,
    primaryTypographyProps,
    secondary: secondaryProp,
    secondaryTypographyProps
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$q);

  const {
    dense
  } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(ListContext$1);
  let primary = primaryProp != null ? primaryProp : children;
  let secondary = secondaryProp;

  const ownerState = _extends$a({}, props, {
    disableTypography,
    inset,
    primary: !!primary,
    secondary: !!secondary,
    dense
  });

  const classes = useUtilityClasses$o(ownerState);

  if (primary != null && primary.type !== Typography$1 && !disableTypography) {
    primary = /*#__PURE__*/jsxRuntime.exports.jsx(Typography$1, _extends$a({
      variant: dense ? 'body2' : 'body1',
      className: classes.primary,
      component: "span",
      display: "block"
    }, primaryTypographyProps, {
      children: primary
    }));
  }

  if (secondary != null && secondary.type !== Typography$1 && !disableTypography) {
    secondary = /*#__PURE__*/jsxRuntime.exports.jsx(Typography$1, _extends$a({
      variant: "body2",
      className: classes.secondary,
      color: "text.secondary",
      display: "block"
    }, secondaryTypographyProps, {
      children: secondary
    }));
  }

  return /*#__PURE__*/jsxRuntime.exports.jsxs(ListItemTextRoot, _extends$a({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [primary, secondary]
  }));
});
var ListItemText$1 = ListItemText;

function getMenuItemUtilityClass(slot) {
  return generateUtilityClass('MuiMenuItem', slot);
}
const menuItemClasses = generateUtilityClasses('MuiMenuItem', ['root', 'focusVisible', 'dense', 'disabled', 'divider', 'gutters', 'selected']);
var menuItemClasses$1 = menuItemClasses;

const _excluded$p = ["autoFocus", "component", "dense", "divider", "disableGutters", "focusVisibleClassName", "role", "tabIndex"];
const overridesResolver$3 = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.dense && styles.dense, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters];
};

const useUtilityClasses$n = ownerState => {
  const {
    disabled,
    dense,
    divider,
    disableGutters,
    selected,
    classes
  } = ownerState;
  const slots = {
    root: ['root', dense && 'dense', disabled && 'disabled', !disableGutters && 'gutters', divider && 'divider', selected && 'selected']
  };
  const composedClasses = composeClasses(slots, getMenuItemUtilityClass, classes);
  return _extends$a({}, classes, composedClasses);
};

const MenuItemRoot = styled$1(ButtonBase$1, {
  shouldForwardProp: prop => rootShouldForwardProp$1(prop) || prop === 'classes',
  name: 'MuiMenuItem',
  slot: 'Root',
  overridesResolver: overridesResolver$3
})(({
  theme,
  ownerState
}) => _extends$a({}, theme.typography.body1, {
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  position: 'relative',
  textDecoration: 'none',
  minHeight: 48,
  paddingTop: 6,
  paddingBottom: 6,
  boxSizing: 'border-box',
  whiteSpace: 'nowrap'
}, !ownerState.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, ownerState.divider && {
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundClip: 'padding-box'
}, {
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: theme.palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  [`&.${menuItemClasses$1.selected}`]: {
    backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    [`&.${menuItemClasses$1.focusVisible}`]: {
      backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  },
  [`&.${menuItemClasses$1.selected}:hover`]: {
    backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }
  },
  [`&.${menuItemClasses$1.focusVisible}`]: {
    backgroundColor: theme.palette.action.focus
  },
  [`&.${menuItemClasses$1.disabled}`]: {
    opacity: theme.palette.action.disabledOpacity
  },
  [`& + .${dividerClasses.root}`]: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1)
  },
  [`& + .${dividerClasses.inset}`]: {
    marginLeft: 52
  },
  [`& .${listItemTextClasses$1.root}`]: {
    marginTop: 0,
    marginBottom: 0
  },
  [`& .${listItemTextClasses$1.inset}`]: {
    paddingLeft: 36
  },
  [`& .${listItemIconClasses$1.root}`]: {
    minWidth: 36
  }
}, !ownerState.dense && {
  [theme.breakpoints.up('sm')]: {
    minHeight: 'auto'
  }
}, ownerState.dense && _extends$a({
  minHeight: 36
}, theme.typography.body2, {
  [`& .${listItemIconClasses$1.root} svg`]: {
    fontSize: '1.25rem'
  }
})));
const MenuItem = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function MenuItem(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiMenuItem'
  });

  const {
    autoFocus = false,
    component = 'li',
    dense = false,
    divider = false,
    disableGutters = false,
    focusVisibleClassName,
    role = 'menuitem',
    tabIndex: tabIndexProp
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$p);

  const context = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(ListContext$1);
  const childContext = {
    dense: dense || context.dense || false,
    disableGutters
  };
  const menuItemRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  useEnhancedEffect$1(() => {
    if (autoFocus) {
      if (menuItemRef.current) {
        menuItemRef.current.focus();
      }
    }
  }, [autoFocus]);

  const ownerState = _extends$a({}, props, {
    dense: childContext.dense,
    divider,
    disableGutters
  });

  const classes = useUtilityClasses$n(props);
  const handleRef = useForkRef(menuItemRef, ref);
  let tabIndex;

  if (!props.disabled) {
    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
  }

  return /*#__PURE__*/jsxRuntime.exports.jsx(ListContext$1.Provider, {
    value: childContext,
    children: /*#__PURE__*/jsxRuntime.exports.jsx(MenuItemRoot, _extends$a({
      ref: handleRef,
      role: role,
      tabIndex: tabIndex,
      component: component,
      focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName)
    }, other, {
      ownerState: ownerState,
      classes: classes
    }))
  });
});
var MenuItem$1 = MenuItem;

function getListItemUtilityClass(slot) {
  return generateUtilityClass('MuiListItem', slot);
}
const listItemClasses = generateUtilityClasses('MuiListItem', ['root', 'container', 'focusVisible', 'dense', 'alignItemsFlexStart', 'disabled', 'divider', 'gutters', 'padding', 'button', 'secondaryAction', 'selected']);
var listItemClasses$1 = listItemClasses;

function getListItemButtonUtilityClass(slot) {
  return generateUtilityClass('MuiListItemButton', slot);
}
const listItemButtonClasses = generateUtilityClasses('MuiListItemButton', ['root', 'focusVisible', 'dense', 'alignItemsFlexStart', 'disabled', 'divider', 'gutters', 'selected']);
var listItemButtonClasses$1 = listItemButtonClasses;

const _excluded$o = ["alignItems", "autoFocus", "component", "children", "dense", "disableGutters", "divider", "focusVisibleClassName", "selected"];
const overridesResolver$2 = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.dense && styles.dense, ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters];
};

const useUtilityClasses$m = ownerState => {
  const {
    alignItems,
    classes,
    dense,
    disabled,
    disableGutters,
    divider,
    selected
  } = ownerState;
  const slots = {
    root: ['root', dense && 'dense', !disableGutters && 'gutters', divider && 'divider', disabled && 'disabled', alignItems === 'flex-start' && 'alignItemsFlexStart', selected && 'selected']
  };
  const composedClasses = composeClasses(slots, getListItemButtonUtilityClass, classes);
  return _extends$a({}, classes, composedClasses);
};

const ListItemButtonRoot = styled$1(ButtonBase$1, {
  shouldForwardProp: prop => rootShouldForwardProp$1(prop) || prop === 'classes',
  name: 'MuiListItemButton',
  slot: 'Root',
  overridesResolver: overridesResolver$2
})(({
  theme,
  ownerState
}) => _extends$a({
  display: 'flex',
  flexGrow: 1,
  justifyContent: 'flex-start',
  alignItems: 'center',
  position: 'relative',
  textDecoration: 'none',
  boxSizing: 'border-box',
  textAlign: 'left',
  paddingTop: 8,
  paddingBottom: 8,
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  }),
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: theme.palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  [`&.${listItemButtonClasses$1.selected}`]: {
    backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    [`&.${listItemButtonClasses$1.focusVisible}`]: {
      backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  },
  [`&.${listItemButtonClasses$1.selected}:hover`]: {
    backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }
  },
  [`&.${listItemButtonClasses$1.focusVisible}`]: {
    backgroundColor: theme.palette.action.focus
  },
  [`&.${listItemButtonClasses$1.disabled}`]: {
    opacity: theme.palette.action.disabledOpacity
  }
}, ownerState.divider && {
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundClip: 'padding-box'
}, ownerState.alignItems === 'flex-start' && {
  alignItems: 'flex-start'
}, !ownerState.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, ownerState.dense && {
  paddingTop: 4,
  paddingBottom: 4
}));
const ListItemButton = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function ListItemButton(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiListItemButton'
  });

  const {
    alignItems = 'center',
    autoFocus = false,
    component = 'div',
    children,
    dense = false,
    disableGutters = false,
    divider = false,
    focusVisibleClassName,
    selected = false
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$o);

  const context = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(ListContext$1);
  const childContext = {
    dense: dense || context.dense || false,
    alignItems,
    disableGutters
  };
  const listItemRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  useEnhancedEffect$1(() => {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      }
    }
  }, [autoFocus]);

  const ownerState = _extends$a({}, props, {
    alignItems,
    dense: childContext.dense,
    disableGutters,
    divider,
    selected
  });

  const classes = useUtilityClasses$m(ownerState);
  const handleRef = useForkRef(listItemRef, ref);
  return /*#__PURE__*/jsxRuntime.exports.jsx(ListContext$1.Provider, {
    value: childContext,
    children: /*#__PURE__*/jsxRuntime.exports.jsx(ListItemButtonRoot, _extends$a({
      ref: handleRef,
      component: component,
      focusVisibleClassName: clsx(classes.focusVisible, focusVisibleClassName),
      ownerState: ownerState
    }, other, {
      classes: classes,
      children: children
    }))
  });
});
var ListItemButton$1 = ListItemButton;

function getListItemSecondaryActionClassesUtilityClass(slot) {
  return generateUtilityClass('MuiListItemSecondaryAction', slot);
}
generateUtilityClasses('MuiListItemSecondaryAction', ['root', 'disableGutters']);

const _excluded$n = ["className"];

const useUtilityClasses$l = ownerState => {
  const {
    disableGutters,
    classes
  } = ownerState;
  const slots = {
    root: ['root', disableGutters && 'disableGutters']
  };
  return composeClasses(slots, getListItemSecondaryActionClassesUtilityClass, classes);
};

const ListItemSecondaryActionRoot = styled$1('div', {
  name: 'MuiListItemSecondaryAction',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.disableGutters && styles.disableGutters];
  }
})(({
  ownerState
}) => _extends$a({
  position: 'absolute',
  right: 16,
  top: '50%',
  transform: 'translateY(-50%)'
}, ownerState.disableGutters && {
  right: 0
}));
/**
 * Must be used as the last child of ListItem to function properly.
 */

const ListItemSecondaryAction = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function ListItemSecondaryAction(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiListItemSecondaryAction'
  });

  const {
    className
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$n);

  const context = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(ListContext$1);

  const ownerState = _extends$a({}, props, {
    disableGutters: context.disableGutters
  });

  const classes = useUtilityClasses$l(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(ListItemSecondaryActionRoot, _extends$a({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
var ListItemSecondaryAction$1 = ListItemSecondaryAction;

const _excluded$m = ["className"],
      _excluded2 = ["alignItems", "autoFocus", "button", "children", "className", "component", "components", "componentsProps", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "disablePadding", "divider", "focusVisibleClassName", "secondaryAction", "selected"];
const overridesResolver$1 = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, ownerState.dense && styles.dense, ownerState.alignItems === 'flex-start' && styles.alignItemsFlexStart, ownerState.divider && styles.divider, !ownerState.disableGutters && styles.gutters, !ownerState.disablePadding && styles.padding, ownerState.button && styles.button, ownerState.hasSecondaryAction && styles.secondaryAction];
};

const useUtilityClasses$k = ownerState => {
  const {
    alignItems,
    button,
    classes,
    dense,
    disabled,
    disableGutters,
    disablePadding,
    divider,
    hasSecondaryAction,
    selected
  } = ownerState;
  const slots = {
    root: ['root', dense && 'dense', !disableGutters && 'gutters', !disablePadding && 'padding', divider && 'divider', disabled && 'disabled', button && 'button', alignItems === 'flex-start' && 'alignItemsFlexStart', hasSecondaryAction && 'secondaryAction', selected && 'selected'],
    container: ['container']
  };
  return composeClasses(slots, getListItemUtilityClass, classes);
};

const ListItemRoot = styled$1('div', {
  name: 'MuiListItem',
  slot: 'Root',
  overridesResolver: overridesResolver$1
})(({
  theme,
  ownerState
}) => _extends$a({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  position: 'relative',
  textDecoration: 'none',
  width: '100%',
  boxSizing: 'border-box',
  textAlign: 'left'
}, !ownerState.disablePadding && _extends$a({
  paddingTop: 8,
  paddingBottom: 8
}, ownerState.dense && {
  paddingTop: 4,
  paddingBottom: 4
}, !ownerState.disableGutters && {
  paddingLeft: 16,
  paddingRight: 16
}, !!ownerState.secondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}), !!ownerState.secondaryAction && {
  [`& > .${listItemButtonClasses$1.root}`]: {
    paddingRight: 48
  }
}, {
  [`&.${listItemClasses$1.focusVisible}`]: {
    backgroundColor: theme.palette.action.focus
  },
  [`&.${listItemClasses$1.selected}`]: {
    backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    [`&.${listItemClasses$1.focusVisible}`]: {
      backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  },
  [`&.${listItemClasses$1.disabled}`]: {
    opacity: theme.palette.action.disabledOpacity
  }
}, ownerState.alignItems === 'flex-start' && {
  alignItems: 'flex-start'
}, ownerState.divider && {
  borderBottom: `1px solid ${theme.palette.divider}`,
  backgroundClip: 'padding-box'
}, ownerState.button && {
  transition: theme.transitions.create('background-color', {
    duration: theme.transitions.duration.shortest
  }),
  '&:hover': {
    textDecoration: 'none',
    backgroundColor: theme.palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  [`&.${listItemClasses$1.selected}:hover`]: {
    backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity)
    }
  }
}, ownerState.hasSecondaryAction && {
  // Add some space to avoid collision as `ListItemSecondaryAction`
  // is absolutely positioned.
  paddingRight: 48
}));
const ListItemContainer = styled$1('li', {
  name: 'MuiListItem',
  slot: 'Container',
  overridesResolver: (props, styles) => styles.container
})({
  position: 'relative'
});
/**
 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
 */

const ListItem = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function ListItem(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiListItem'
  });

  const {
    alignItems = 'center',
    autoFocus = false,
    button = false,
    children: childrenProp,
    className,
    component: componentProp,
    components = {},
    componentsProps = {},
    ContainerComponent = 'li',
    ContainerProps: {
      className: ContainerClassName
    } = {},
    dense = false,
    disabled = false,
    disableGutters = false,
    disablePadding = false,
    divider = false,
    focusVisibleClassName,
    secondaryAction,
    selected = false
  } = props,
        ContainerProps = _objectWithoutPropertiesLoose$6(props.ContainerProps, _excluded$m),
        other = _objectWithoutPropertiesLoose$6(props, _excluded2);

  const context = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(ListContext$1);
  const childContext = {
    dense: dense || context.dense || false,
    alignItems,
    disableGutters
  };
  const listItemRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  useEnhancedEffect$1(() => {
    if (autoFocus) {
      if (listItemRef.current) {
        listItemRef.current.focus();
      }
    }
  }, [autoFocus]);
  const children = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Children.toArray(childrenProp); // v4 implementation, deprecated in v5, will be removed in v6

  const hasSecondaryAction = children.length && isMuiElement(children[children.length - 1], ['ListItemSecondaryAction']);

  const ownerState = _extends$a({}, props, {
    alignItems,
    autoFocus,
    button,
    dense: childContext.dense,
    disabled,
    disableGutters,
    disablePadding,
    divider,
    hasSecondaryAction,
    selected
  });

  const classes = useUtilityClasses$k(ownerState);
  const handleRef = useForkRef(listItemRef, ref);
  const Root = components.Root || ListItemRoot;
  const rootProps = componentsProps.root || {};

  const componentProps = _extends$a({
    className: clsx(classes.root, rootProps.className, className),
    disabled
  }, other);

  let Component = componentProp || 'li';

  if (button) {
    componentProps.component = componentProp || 'div';
    componentProps.focusVisibleClassName = clsx(listItemClasses$1.focusVisible, focusVisibleClassName);
    Component = ButtonBase$1;
  } // v4 implementation, deprecated in v5, will be removed in v6


  if (hasSecondaryAction) {
    // Use div by default.
    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.

    if (ContainerComponent === 'li') {
      if (Component === 'li') {
        Component = 'div';
      } else if (componentProps.component === 'li') {
        componentProps.component = 'div';
      }
    }

    return /*#__PURE__*/jsxRuntime.exports.jsx(ListContext$1.Provider, {
      value: childContext,
      children: /*#__PURE__*/jsxRuntime.exports.jsxs(ListItemContainer, _extends$a({
        as: ContainerComponent,
        className: clsx(classes.container, ContainerClassName),
        ref: handleRef,
        ownerState: ownerState
      }, ContainerProps, {
        children: [/*#__PURE__*/jsxRuntime.exports.jsx(Root, _extends$a({}, rootProps, !isHostComponent(Root) && {
          as: Component,
          ownerState: _extends$a({}, ownerState, rootProps.ownerState)
        }, componentProps, {
          children: children
        })), children.pop()]
      }))
    });
  }

  return /*#__PURE__*/jsxRuntime.exports.jsx(ListContext$1.Provider, {
    value: childContext,
    children: /*#__PURE__*/jsxRuntime.exports.jsxs(Root, _extends$a({}, rootProps, {
      as: Component,
      ref: handleRef,
      ownerState: ownerState
    }, !isHostComponent(Root) && {
      ownerState: _extends$a({}, ownerState, rootProps.ownerState)
    }, componentProps, {
      children: [children, secondaryAction && /*#__PURE__*/jsxRuntime.exports.jsx(ListItemSecondaryAction$1, {
        children: secondaryAction
      })]
    }))
  });
});
var ListItem$1 = ListItem;

function getSwitchBaseUtilityClass(slot) {
  return generateUtilityClass('PrivateSwitchBase', slot);
}
generateUtilityClasses('PrivateSwitchBase', ['root', 'checked', 'disabled', 'input', 'edgeStart', 'edgeEnd']);

const _excluded$l = ["autoFocus", "checked", "checkedIcon", "className", "defaultChecked", "disabled", "disableFocusRipple", "edge", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"];

const useUtilityClasses$j = ownerState => {
  const {
    classes,
    checked,
    disabled,
    edge
  } = ownerState;
  const slots = {
    root: ['root', checked && 'checked', disabled && 'disabled', edge && `edge${capitalize$2(edge)}`],
    input: ['input']
  };
  return composeClasses(slots, getSwitchBaseUtilityClass, classes);
};

const SwitchBaseRoot = styled$1(ButtonBase$1, {
  skipSx: true
})(({
  ownerState
}) => _extends$a({
  padding: 9,
  borderRadius: '50%'
}, ownerState.edge === 'start' && {
  marginLeft: ownerState.size === 'small' ? -3 : -12
}, ownerState.edge === 'end' && {
  marginRight: ownerState.size === 'small' ? -3 : -12
}));
const SwitchBaseInput = styled$1('input', {
  skipSx: true
})({
  cursor: 'inherit',
  position: 'absolute',
  opacity: 0,
  width: '100%',
  height: '100%',
  top: 0,
  left: 0,
  margin: 0,
  padding: 0,
  zIndex: 1
});
/**
 * @ignore - internal component.
 */

const SwitchBase = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function SwitchBase(props, ref) {
  const {
    autoFocus,
    checked: checkedProp,
    checkedIcon,
    className,
    defaultChecked,
    disabled: disabledProp,
    disableFocusRipple = false,
    edge = false,
    icon,
    id,
    inputProps,
    inputRef,
    name,
    onBlur,
    onChange,
    onFocus,
    readOnly,
    required,
    tabIndex,
    type,
    value
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$l);

  const [checked, setCheckedState] = useControlled({
    controlled: checkedProp,
    default: Boolean(defaultChecked),
    name: 'SwitchBase',
    state: 'checked'
  });
  const muiFormControl = useFormControl();

  const handleFocus = event => {
    if (onFocus) {
      onFocus(event);
    }

    if (muiFormControl && muiFormControl.onFocus) {
      muiFormControl.onFocus(event);
    }
  };

  const handleBlur = event => {
    if (onBlur) {
      onBlur(event);
    }

    if (muiFormControl && muiFormControl.onBlur) {
      muiFormControl.onBlur(event);
    }
  };

  const handleInputChange = event => {
    // Workaround for https://github.com/facebook/react/issues/9023
    if (event.nativeEvent.defaultPrevented) {
      return;
    }

    const newChecked = event.target.checked;
    setCheckedState(newChecked);

    if (onChange) {
      // TODO v6: remove the second argument.
      onChange(event, newChecked);
    }
  };

  let disabled = disabledProp;

  if (muiFormControl) {
    if (typeof disabled === 'undefined') {
      disabled = muiFormControl.disabled;
    }
  }

  const hasLabelFor = type === 'checkbox' || type === 'radio';

  const ownerState = _extends$a({}, props, {
    checked,
    disabled,
    disableFocusRipple,
    edge
  });

  const classes = useUtilityClasses$j(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsxs(SwitchBaseRoot, _extends$a({
    component: "span",
    className: clsx(classes.root, className),
    centerRipple: true,
    focusRipple: !disableFocusRipple,
    disabled: disabled,
    tabIndex: null,
    role: undefined,
    onFocus: handleFocus,
    onBlur: handleBlur,
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [/*#__PURE__*/jsxRuntime.exports.jsx(SwitchBaseInput, _extends$a({
      autoFocus: autoFocus,
      checked: checkedProp,
      defaultChecked: defaultChecked,
      className: classes.input,
      disabled: disabled,
      id: hasLabelFor && id,
      name: name,
      onChange: handleInputChange,
      readOnly: readOnly,
      ref: inputRef,
      required: required,
      ownerState: ownerState,
      tabIndex: tabIndex,
      type: type
    }, type === 'checkbox' && value === undefined ? {} : {
      value
    }, inputProps)), checked ? checkedIcon : icon]
  }));
}); // NB: If changed, please update Checkbox, Switch and Radio
var SwitchBase$1 = SwitchBase;

var CheckBoxOutlineBlankIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
}), 'CheckBoxOutlineBlank');

var CheckBoxIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
}), 'CheckBox');

var IndeterminateCheckBoxIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
}), 'IndeterminateCheckBox');

function getCheckboxUtilityClass(slot) {
  return generateUtilityClass('MuiCheckbox', slot);
}
const checkboxClasses = generateUtilityClasses('MuiCheckbox', ['root', 'checked', 'disabled', 'indeterminate', 'colorPrimary', 'colorSecondary']);
var checkboxClasses$1 = checkboxClasses;

const _excluded$k = ["checkedIcon", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size"];

const useUtilityClasses$i = ownerState => {
  const {
    classes,
    indeterminate,
    color
  } = ownerState;
  const slots = {
    root: ['root', indeterminate && 'indeterminate', `color${capitalize$2(color)}`]
  };
  const composedClasses = composeClasses(slots, getCheckboxUtilityClass, classes);
  return _extends$a({}, classes, composedClasses);
};

const CheckboxRoot = styled$1(SwitchBase$1, {
  shouldForwardProp: prop => rootShouldForwardProp$1(prop) || prop === 'classes',
  name: 'MuiCheckbox',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.indeterminate && styles.indeterminate, ownerState.color !== 'default' && styles[`color${capitalize$2(ownerState.color)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$a({
  color: theme.palette.text.secondary
}, !ownerState.disableRipple && {
  '&:hover': {
    backgroundColor: alpha(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.color !== 'default' && {
  [`&.${checkboxClasses$1.checked}, &.${checkboxClasses$1.indeterminate}`]: {
    color: theme.palette[ownerState.color].main
  },
  [`&.${checkboxClasses$1.disabled}`]: {
    color: theme.palette.action.disabled
  }
}));

const defaultCheckedIcon$1 = /*#__PURE__*/jsxRuntime.exports.jsx(CheckBoxIcon, {});

const defaultIcon$1 = /*#__PURE__*/jsxRuntime.exports.jsx(CheckBoxOutlineBlankIcon, {});

const defaultIndeterminateIcon = /*#__PURE__*/jsxRuntime.exports.jsx(IndeterminateCheckBoxIcon, {});

const Checkbox = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Checkbox(inProps, ref) {
  var _icon$props$fontSize, _indeterminateIcon$pr;

  const props = useThemeProps({
    props: inProps,
    name: 'MuiCheckbox'
  });

  const {
    checkedIcon = defaultCheckedIcon$1,
    color = 'primary',
    icon: iconProp = defaultIcon$1,
    indeterminate = false,
    indeterminateIcon: indeterminateIconProp = defaultIndeterminateIcon,
    inputProps,
    size = 'medium'
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$k);

  const icon = indeterminate ? indeterminateIconProp : iconProp;
  const indeterminateIcon = indeterminate ? indeterminateIconProp : checkedIcon;

  const ownerState = _extends$a({}, props, {
    color,
    indeterminate,
    size
  });

  const classes = useUtilityClasses$i(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(CheckboxRoot, _extends$a({
    type: "checkbox",
    inputProps: _extends$a({
      'data-indeterminate': indeterminate
    }, inputProps),
    icon: /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(icon, {
      fontSize: (_icon$props$fontSize = icon.props.fontSize) != null ? _icon$props$fontSize : size
    }),
    checkedIcon: /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(indeterminateIcon, {
      fontSize: (_indeterminateIcon$pr = indeterminateIcon.props.fontSize) != null ? _indeterminateIcon$pr : size
    }),
    ownerState: ownerState,
    ref: ref
  }, other, {
    classes: classes
  }));
});
var Checkbox$1 = Checkbox;

var CancelIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
}), 'Cancel');

function getChipUtilityClass(slot) {
  return generateUtilityClass('MuiChip', slot);
}
const chipClasses = generateUtilityClasses('MuiChip', ['root', 'sizeSmall', 'sizeMedium', 'colorPrimary', 'colorSecondary', 'disabled', 'clickable', 'clickableColorPrimary', 'clickableColorSecondary', 'deletable', 'deletableColorPrimary', 'deletableColorSecondary', 'outlined', 'filled', 'outlinedPrimary', 'outlinedSecondary', 'avatar', 'avatarSmall', 'avatarMedium', 'avatarColorPrimary', 'avatarColorSecondary', 'icon', 'iconSmall', 'iconMedium', 'iconColorPrimary', 'iconColorSecondary', 'label', 'labelSmall', 'labelMedium', 'deleteIcon', 'deleteIconSmall', 'deleteIconMedium', 'deleteIconColorPrimary', 'deleteIconColorSecondary', 'deleteIconOutlinedColorPrimary', 'deleteIconOutlinedColorSecondary', 'focusVisible']);
var chipClasses$1 = chipClasses;

const _excluded$j = ["avatar", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"];

const useUtilityClasses$h = ownerState => {
  const {
    classes,
    disabled,
    size,
    color,
    onDelete,
    clickable,
    variant
  } = ownerState;
  const slots = {
    root: ['root', variant, disabled && 'disabled', `size${capitalize$2(size)}`, `color${capitalize$2(color)}`, clickable && 'clickable', clickable && `clickableColor${capitalize$2(color)}`, onDelete && 'deletable', onDelete && `deletableColor${capitalize$2(color)}`, `${variant}${capitalize$2(color)}`],
    label: ['label', `label${capitalize$2(size)}`],
    avatar: ['avatar', `avatar${capitalize$2(size)}`, `avatarColor${capitalize$2(color)}`],
    icon: ['icon', `icon${capitalize$2(size)}`, `iconColor${capitalize$2(color)}`],
    deleteIcon: ['deleteIcon', `deleteIcon${capitalize$2(size)}`, `deleteIconColor${capitalize$2(color)}`, `deleteIconOutlinedColor${capitalize$2(color)}`]
  };
  return composeClasses(slots, getChipUtilityClass, classes);
};

const ChipRoot = styled$1('div', {
  name: 'MuiChip',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const {
      color,
      clickable,
      onDelete,
      size,
      variant
    } = ownerState;
    return [{
      [`& .${chipClasses$1.avatar}`]: styles.avatar
    }, {
      [`& .${chipClasses$1.avatar}`]: styles[`avatar${capitalize$2(size)}`]
    }, {
      [`& .${chipClasses$1.avatar}`]: styles[`avatarColor${capitalize$2(color)}`]
    }, {
      [`& .${chipClasses$1.icon}`]: styles.icon
    }, {
      [`& .${chipClasses$1.icon}`]: styles[`icon${capitalize$2(size)}`]
    }, {
      [`& .${chipClasses$1.icon}`]: styles[`iconColor${capitalize$2(color)}`]
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: styles.deleteIcon
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: styles[`deleteIcon${capitalize$2(size)}`]
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: styles[`deleteIconColor${capitalize$2(color)}`]
    }, {
      [`& .${chipClasses$1.deleteIcon}`]: styles[`deleteIconOutlinedColor${capitalize$2(color)}`]
    }, styles.root, styles[`size${capitalize$2(size)}`], styles[`color${capitalize$2(color)}`], clickable && styles.clickable, clickable && color !== 'default' && styles[`clickableColor${capitalize$2(color)})`], onDelete && styles.deletable, onDelete && color !== 'default' && styles[`deletableColor${capitalize$2(color)}`], styles[variant], variant === 'outlined' && styles[`outlined${capitalize$2(color)}`]];
  }
})(({
  theme,
  ownerState
}) => {
  const deleteIconColor = alpha(theme.palette.text.primary, 0.26);
  return _extends$a({
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.pxToRem(13),
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: 32,
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.action.selected,
    borderRadius: 32 / 2,
    whiteSpace: 'nowrap',
    transition: theme.transitions.create(['background-color', 'box-shadow']),
    // label will inherit this from root, then `clickable` class overrides this for both
    cursor: 'default',
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    textDecoration: 'none',
    border: 0,
    // Remove `button` border
    padding: 0,
    // Remove `button` padding
    verticalAlign: 'middle',
    boxSizing: 'border-box',
    [`&.${chipClasses$1.disabled}`]: {
      opacity: theme.palette.action.disabledOpacity,
      pointerEvents: 'none'
    },
    [`& .${chipClasses$1.avatar}`]: {
      marginLeft: 5,
      marginRight: -6,
      width: 24,
      height: 24,
      color: theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      fontSize: theme.typography.pxToRem(12)
    },
    [`& .${chipClasses$1.avatarColorPrimary}`]: {
      color: theme.palette.primary.contrastText,
      backgroundColor: theme.palette.primary.dark
    },
    [`& .${chipClasses$1.avatarColorSecondary}`]: {
      color: theme.palette.secondary.contrastText,
      backgroundColor: theme.palette.secondary.dark
    },
    [`& .${chipClasses$1.avatarSmall}`]: {
      marginLeft: 4,
      marginRight: -4,
      width: 18,
      height: 18,
      fontSize: theme.typography.pxToRem(10)
    },
    [`& .${chipClasses$1.icon}`]: _extends$a({
      color: theme.palette.mode === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
      marginLeft: 5,
      marginRight: -6
    }, ownerState.size === 'small' && {
      fontSize: 18,
      marginLeft: 4,
      marginRight: -4
    }, ownerState.color !== 'default' && {
      color: 'inherit'
    }),
    [`& .${chipClasses$1.deleteIcon}`]: _extends$a({
      WebkitTapHighlightColor: 'transparent',
      color: deleteIconColor,
      fontSize: 22,
      cursor: 'pointer',
      margin: '0 5px 0 -6px',
      '&:hover': {
        color: alpha(deleteIconColor, 0.4)
      }
    }, ownerState.size === 'small' && {
      fontSize: 16,
      marginRight: 4,
      marginLeft: -4
    }, ownerState.color !== 'default' && {
      color: alpha(theme.palette[ownerState.color].contrastText, 0.7),
      '&:hover, &:active': {
        color: theme.palette[ownerState.color].contrastText
      }
    })
  }, ownerState.size === 'small' && {
    height: 24
  }, ownerState.color !== 'default' && {
    backgroundColor: theme.palette[ownerState.color].main,
    color: theme.palette[ownerState.color].contrastText
  }, ownerState.onDelete && {
    [`&.${chipClasses$1.focusVisible}`]: {
      backgroundColor: alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    }
  }, ownerState.onDelete && ownerState.color !== 'default' && {
    [`&.${chipClasses$1.focusVisible}`]: {
      backgroundColor: theme.palette[ownerState.color].dark
    }
  });
}, ({
  theme,
  ownerState
}) => _extends$a({}, ownerState.clickable && {
  userSelect: 'none',
  WebkitTapHighlightColor: 'transparent',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
  },
  [`&.${chipClasses$1.focusVisible}`]: {
    backgroundColor: alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
  },
  '&:active': {
    boxShadow: theme.shadows[1]
  }
}, ownerState.clickable && ownerState.color !== 'default' && {
  [`&:hover, &.${chipClasses$1.focusVisible}`]: {
    backgroundColor: theme.palette[ownerState.color].dark
  }
}), ({
  theme,
  ownerState
}) => _extends$a({}, ownerState.variant === 'outlined' && {
  backgroundColor: 'transparent',
  border: `1px solid ${theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[700]}`,
  [`&.${chipClasses$1.clickable}:hover`]: {
    backgroundColor: theme.palette.action.hover
  },
  [`&.${chipClasses$1.focusVisible}`]: {
    backgroundColor: theme.palette.action.focus
  },
  [`& .${chipClasses$1.avatar}`]: {
    marginLeft: 4
  },
  [`& .${chipClasses$1.avatarSmall}`]: {
    marginLeft: 2
  },
  [`& .${chipClasses$1.icon}`]: {
    marginLeft: 4
  },
  [`& .${chipClasses$1.iconSmall}`]: {
    marginLeft: 2
  },
  [`& .${chipClasses$1.deleteIcon}`]: {
    marginRight: 5
  },
  [`& .${chipClasses$1.deleteIconSmall}`]: {
    marginRight: 3
  }
}, ownerState.variant === 'outlined' && ownerState.color !== 'default' && {
  color: theme.palette[ownerState.color].main,
  border: `1px solid ${alpha(theme.palette[ownerState.color].main, 0.7)}`,
  [`&.${chipClasses$1.clickable}:hover`]: {
    backgroundColor: alpha(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity)
  },
  [`&.${chipClasses$1.focusVisible}`]: {
    backgroundColor: alpha(theme.palette[ownerState.color].main, theme.palette.action.focusOpacity)
  },
  [`& .${chipClasses$1.deleteIcon}`]: {
    color: alpha(theme.palette[ownerState.color].main, 0.7),
    '&:hover, &:active': {
      color: theme.palette[ownerState.color].main
    }
  }
}));
const ChipLabel = styled$1('span', {
  name: 'MuiChip',
  slot: 'Label',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    const {
      size
    } = ownerState;
    return [styles.label, styles[`label${capitalize$2(size)}`]];
  }
})(({
  ownerState
}) => _extends$a({
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  paddingLeft: 12,
  paddingRight: 12,
  whiteSpace: 'nowrap'
}, ownerState.size === 'small' && {
  paddingLeft: 8,
  paddingRight: 8
}));

function isDeleteKeyboardEvent(keyboardEvent) {
  return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
}
/**
 * Chips represent complex entities in small blocks, such as a contact.
 */


const Chip$1 = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Chip(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiChip'
  });

  const {
    avatar: avatarProp,
    className,
    clickable: clickableProp,
    color = 'default',
    component: ComponentProp,
    deleteIcon: deleteIconProp,
    disabled = false,
    icon: iconProp,
    label,
    onClick,
    onDelete,
    onKeyDown,
    onKeyUp,
    size = 'medium',
    variant = 'filled'
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$j);

  const chipRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const handleRef = useForkRef(chipRef, ref);

  const handleDeleteIconClick = event => {
    // Stop the event from bubbling up to the `Chip`
    event.stopPropagation();

    if (onDelete) {
      onDelete(event);
    }
  };

  const handleKeyDown = event => {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
      // Will be handled in keyUp, otherwise some browsers
      // might init navigation
      event.preventDefault();
    }

    if (onKeyDown) {
      onKeyDown(event);
    }
  };

  const handleKeyUp = event => {
    // Ignore events from children of `Chip`.
    if (event.currentTarget === event.target) {
      if (onDelete && isDeleteKeyboardEvent(event)) {
        onDelete(event);
      } else if (event.key === 'Escape' && chipRef.current) {
        chipRef.current.blur();
      }
    }

    if (onKeyUp) {
      onKeyUp(event);
    }
  };

  const clickable = clickableProp !== false && onClick ? true : clickableProp;
  const small = size === 'small';
  const component = clickable || onDelete ? ButtonBase$1 : ComponentProp || 'div';

  const ownerState = _extends$a({}, props, {
    component,
    disabled,
    size,
    color,
    onDelete: !!onDelete,
    clickable,
    variant
  });

  const classes = useUtilityClasses$h(ownerState);
  const moreProps = component === ButtonBase$1 ? {
    component: ComponentProp || 'div',
    focusVisibleClassName: classes.focusVisible,
    disableRipple: Boolean(onDelete)
  } : {};
  let deleteIcon = null;

  if (onDelete) {
    const customClasses = clsx(color !== 'default' && (variant === 'outlined' ? classes[`deleteIconOutlinedColor${capitalize$2(color)}`] : classes[`deleteIconColor${capitalize$2(color)}`]), small && classes.deleteIconSmall);
    deleteIcon = deleteIconProp && /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.isValidElement(deleteIconProp) ? /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(deleteIconProp, {
      className: clsx(deleteIconProp.props.className, classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    }) : /*#__PURE__*/jsxRuntime.exports.jsx(CancelIcon, {
      className: clsx(classes.deleteIcon, customClasses),
      onClick: handleDeleteIconClick
    });
  }

  let avatar = null;

  if (avatarProp && /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.isValidElement(avatarProp)) {
    avatar = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(avatarProp, {
      className: clsx(classes.avatar, avatarProp.props.className)
    });
  }

  let icon = null;

  if (iconProp && /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.isValidElement(iconProp)) {
    icon = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(iconProp, {
      className: clsx(classes.icon, iconProp.props.className)
    });
  }

  return /*#__PURE__*/jsxRuntime.exports.jsxs(ChipRoot, _extends$a({
    as: component,
    className: clsx(classes.root, className),
    disabled: clickable && disabled ? true : undefined,
    onClick: onClick,
    onKeyDown: handleKeyDown,
    onKeyUp: handleKeyUp,
    ref: handleRef,
    ownerState: ownerState
  }, moreProps, other, {
    children: [avatar || icon, /*#__PURE__*/jsxRuntime.exports.jsx(ChipLabel, {
      className: clsx(classes.label),
      ownerState: ownerState,
      children: label
    }), deleteIcon]
  }));
});
var Chip$1$1 = Chip$1;

function getCollapseUtilityClass(slot) {
  return generateUtilityClass('MuiCollapse', slot);
}
generateUtilityClasses('MuiCollapse', ['root', 'horizontal', 'vertical', 'entered', 'hidden', 'wrapper', 'wrapperInner']);

const _excluded$i = ["addEndListener", "children", "className", "collapsedSize", "component", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "orientation", "style", "timeout", "TransitionComponent"];

const useUtilityClasses$g = ownerState => {
  const {
    orientation,
    classes
  } = ownerState;
  const slots = {
    root: ['root', `${orientation}`],
    entered: ['entered'],
    hidden: ['hidden'],
    wrapper: ['wrapper', `${orientation}`],
    wrapperInner: ['wrapperInner', `${orientation}`]
  };
  return composeClasses(slots, getCollapseUtilityClass, classes);
};

const CollapseRoot = styled$1('div', {
  name: 'MuiCollapse',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.orientation], ownerState.state === 'entered' && styles.entered, ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && styles.hidden];
  }
})(({
  theme,
  ownerState
}) => _extends$a({
  height: 0,
  overflow: 'hidden',
  transition: theme.transitions.create('height')
}, ownerState.orientation === 'horizontal' && {
  height: 'auto',
  width: 0,
  transition: theme.transitions.create('width')
}, ownerState.state === 'entered' && _extends$a({
  height: 'auto',
  overflow: 'visible'
}, ownerState.orientation === 'horizontal' && {
  width: 'auto'
}), ownerState.state === 'exited' && !ownerState.in && ownerState.collapsedSize === '0px' && {
  visibility: 'hidden'
}));
const CollapseWrapper = styled$1('div', {
  name: 'MuiCollapse',
  slot: 'Wrapper',
  overridesResolver: (props, styles) => styles.wrapper
})(({
  ownerState
}) => _extends$a({
  // Hack to get children with a negative margin to not falsify the height computation.
  display: 'flex',
  width: '100%'
}, ownerState.orientation === 'horizontal' && {
  width: 'auto',
  height: '100%'
}));
const CollapseWrapperInner = styled$1('div', {
  name: 'MuiCollapse',
  slot: 'WrapperInner',
  overridesResolver: (props, styles) => styles.wrapperInner
})(({
  ownerState
}) => _extends$a({
  width: '100%'
}, ownerState.orientation === 'horizontal' && {
  width: 'auto',
  height: '100%'
}));
/**
 * The Collapse transition is used by the
 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

const Collapse = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Collapse(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiCollapse'
  });

  const {
    addEndListener,
    children,
    className,
    collapsedSize: collapsedSizeProp = '0px',
    component,
    easing,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    orientation = 'vertical',
    style,
    timeout = duration.standard,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Transition$1
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$i);

  const ownerState = _extends$a({}, props, {
    orientation,
    collapsedSize: collapsedSizeProp
  });

  const classes = useUtilityClasses$g(ownerState);
  const theme = useTheme();
  const timer = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();
  const wrapperRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const autoTransitionDuration = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();
  const collapsedSize = typeof collapsedSizeProp === 'number' ? `${collapsedSizeProp}px` : collapsedSizeProp;
  const isHorizontal = orientation === 'horizontal';
  const size = isHorizontal ? 'width' : 'height';
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    return () => {
      clearTimeout(timer.current);
    };
  }, []);
  const nodeRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const handleRef = useForkRef(ref, nodeRef);

  const normalizedTransitionCallback = callback => maybeIsAppearing => {
    if (callback) {
      const node = nodeRef.current; // onEnterXxx and onExitXxx callbacks have a different arguments.length value.

      if (maybeIsAppearing === undefined) {
        callback(node);
      } else {
        callback(node, maybeIsAppearing);
      }
    }
  };

  const getWrapperSize = () => wrapperRef.current ? wrapperRef.current[isHorizontal ? 'clientWidth' : 'clientHeight'] : 0;

  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    if (wrapperRef.current && isHorizontal) {
      // Set absolute position to get the size of collapsed content
      wrapperRef.current.style.position = 'absolute';
    }

    node.style[size] = collapsedSize;

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntering = normalizedTransitionCallback((node, isAppearing) => {
    const wrapperSize = getWrapperSize();

    if (wrapperRef.current && isHorizontal) {
      // After the size is read reset the position back to default
      wrapperRef.current.style.position = '';
    }

    const {
      duration: transitionDuration,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'enter'
    });

    if (timeout === 'auto') {
      const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
      node.style.transitionDuration = `${duration2}ms`;
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
    }

    node.style[size] = `${wrapperSize}px`;
    node.style.transitionTimingFunction = transitionTimingFunction;

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback((node, isAppearing) => {
    node.style[size] = 'auto';

    if (onEntered) {
      onEntered(node, isAppearing);
    }
  });
  const handleExit = normalizedTransitionCallback(node => {
    node.style[size] = `${getWrapperSize()}px`;

    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(onExited);
  const handleExiting = normalizedTransitionCallback(node => {
    const wrapperSize = getWrapperSize();
    const {
      duration: transitionDuration,
      easing: transitionTimingFunction
    } = getTransitionProps({
      style,
      timeout,
      easing
    }, {
      mode: 'exit'
    });

    if (timeout === 'auto') {
      // TODO: rename getAutoHeightDuration to something more generic (width support)
      // Actually it just calculates animation duration based on size
      const duration2 = theme.transitions.getAutoHeightDuration(wrapperSize);
      node.style.transitionDuration = `${duration2}ms`;
      autoTransitionDuration.current = duration2;
    } else {
      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : `${transitionDuration}ms`;
    }

    node.style[size] = collapsedSize;
    node.style.transitionTimingFunction = transitionTimingFunction;

    if (onExiting) {
      onExiting(node);
    }
  });

  const handleAddEndListener = next => {
    if (timeout === 'auto') {
      timer.current = setTimeout(next, autoTransitionDuration.current || 0);
    }

    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(nodeRef.current, next);
    }
  };

  return /*#__PURE__*/jsxRuntime.exports.jsx(TransitionComponent, _extends$a({
    in: inProp,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    nodeRef: nodeRef,
    timeout: timeout === 'auto' ? null : timeout
  }, other, {
    children: (state, childProps) => /*#__PURE__*/jsxRuntime.exports.jsx(CollapseRoot, _extends$a({
      as: component,
      className: clsx(classes.root, className, {
        'entered': classes.entered,
        'exited': !inProp && collapsedSize === '0px' && classes.hidden
      }[state]),
      style: _extends$a({
        [isHorizontal ? 'minWidth' : 'minHeight']: collapsedSize
      }, style),
      ownerState: _extends$a({}, ownerState, {
        state
      }),
      ref: handleRef
    }, childProps, {
      children: /*#__PURE__*/jsxRuntime.exports.jsx(CollapseWrapper, {
        ownerState: _extends$a({}, ownerState, {
          state
        }),
        className: classes.wrapper,
        ref: wrapperRef,
        children: /*#__PURE__*/jsxRuntime.exports.jsx(CollapseWrapperInner, {
          ownerState: _extends$a({}, ownerState, {
            state
          }),
          className: classes.wrapperInner,
          children: children
        })
      })
    }))
  }));
});
Collapse.muiSupportAuto = true;
var Collapse$1 = Collapse;

function getSwitchUtilityClass(slot) {
  return generateUtilityClass('MuiSwitch', slot);
}
const switchClasses = generateUtilityClasses('MuiSwitch', ['root', 'edgeStart', 'edgeEnd', 'switchBase', 'colorPrimary', 'colorSecondary', 'sizeSmall', 'sizeMedium', 'checked', 'disabled', 'input', 'thumb', 'track']);
var switchClasses$1 = switchClasses;

const _excluded$h = ["className", "color", "edge", "size", "sx"];

const useUtilityClasses$f = ownerState => {
  const {
    classes,
    edge,
    size,
    color,
    checked,
    disabled
  } = ownerState;
  const slots = {
    root: ['root', edge && `edge${capitalize$2(edge)}`, `size${capitalize$2(size)}`],
    switchBase: ['switchBase', `color${capitalize$2(color)}`, checked && 'checked', disabled && 'disabled'],
    thumb: ['thumb'],
    track: ['track'],
    input: ['input']
  };
  const composedClasses = composeClasses(slots, getSwitchUtilityClass, classes);
  return _extends$a({}, classes, composedClasses);
};

const SwitchRoot = styled$1('span', {
  name: 'MuiSwitch',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.edge && styles[`edge${capitalize$2(ownerState.edge)}`], styles[`size${capitalize$2(ownerState.size)}`]];
  }
})(({
  ownerState
}) => _extends$a({
  display: 'inline-flex',
  width: 34 + 12 * 2,
  height: 14 + 12 * 2,
  overflow: 'hidden',
  padding: 12,
  boxSizing: 'border-box',
  position: 'relative',
  flexShrink: 0,
  zIndex: 0,
  // Reset the stacking context.
  verticalAlign: 'middle',
  // For correct alignment with the text.
  '@media print': {
    colorAdjust: 'exact'
  }
}, ownerState.edge === 'start' && {
  marginLeft: -8
}, ownerState.edge === 'end' && {
  marginRight: -8
}, ownerState.size === 'small' && {
  width: 40,
  height: 24,
  padding: 7,
  [`& .${switchClasses$1.thumb}`]: {
    width: 16,
    height: 16
  },
  [`& .${switchClasses$1.switchBase}`]: {
    padding: 4,
    [`&.${switchClasses$1.checked}`]: {
      transform: 'translateX(16px)'
    }
  }
}));
const SwitchSwitchBase = styled$1(SwitchBase$1, {
  name: 'MuiSwitch',
  slot: 'SwitchBase',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.switchBase, {
      [`& .${switchClasses$1.input}`]: styles.input
    }, ownerState.color !== 'default' && styles[`color${capitalize$2(ownerState.color)}`]];
  }
})(({
  theme
}) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  zIndex: 1,
  // Render above the focus ripple.
  color: theme.palette.mode === 'light' ? theme.palette.common.white : theme.palette.grey[300],
  transition: theme.transitions.create(['left', 'transform'], {
    duration: theme.transitions.duration.shortest
  }),
  [`&.${switchClasses$1.checked}`]: {
    transform: 'translateX(20px)'
  },
  [`&.${switchClasses$1.disabled}`]: {
    color: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[600]
  },
  [`&.${switchClasses$1.checked} + .${switchClasses$1.track}`]: {
    opacity: 0.5
  },
  [`&.${switchClasses$1.disabled} + .${switchClasses$1.track}`]: {
    opacity: theme.palette.mode === 'light' ? 0.12 : 0.2
  },
  [`& .${switchClasses$1.input}`]: {
    left: '-100%',
    width: '300%'
  }
}), ({
  theme,
  ownerState
}) => _extends$a({
  '&:hover': {
    backgroundColor: alpha(theme.palette.action.active, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.color !== 'default' && {
  [`&.${switchClasses$1.checked}`]: {
    color: theme.palette[ownerState.color].main,
    '&:hover': {
      backgroundColor: alpha(theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    },
    [`&.${switchClasses$1.disabled}`]: {
      color: theme.palette.mode === 'light' ? lighten(theme.palette[ownerState.color].main, 0.62) : darken(theme.palette[ownerState.color].main, 0.55)
    }
  },
  [`&.${switchClasses$1.checked} + .${switchClasses$1.track}`]: {
    backgroundColor: theme.palette[ownerState.color].main
  }
}));
const SwitchTrack = styled$1('span', {
  name: 'MuiSwitch',
  slot: 'Track',
  overridesResolver: (props, styles) => styles.track
})(({
  theme
}) => ({
  height: '100%',
  width: '100%',
  borderRadius: 14 / 2,
  zIndex: -1,
  transition: theme.transitions.create(['opacity', 'background-color'], {
    duration: theme.transitions.duration.shortest
  }),
  backgroundColor: theme.palette.mode === 'light' ? theme.palette.common.black : theme.palette.common.white,
  opacity: theme.palette.mode === 'light' ? 0.38 : 0.3
}));
const SwitchThumb = styled$1('span', {
  name: 'MuiSwitch',
  slot: 'Thumb',
  overridesResolver: (props, styles) => styles.thumb
})(({
  theme
}) => ({
  boxShadow: theme.shadows[1],
  backgroundColor: 'currentColor',
  width: 20,
  height: 20,
  borderRadius: '50%'
}));
const Switch$2 = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Switch(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiSwitch'
  });

  const {
    className,
    color = 'primary',
    edge = false,
    size = 'medium',
    sx
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$h);

  const ownerState = _extends$a({}, props, {
    color,
    edge,
    size
  });

  const classes = useUtilityClasses$f(ownerState);

  const icon = /*#__PURE__*/jsxRuntime.exports.jsx(SwitchThumb, {
    className: classes.thumb,
    ownerState: ownerState
  });

  return /*#__PURE__*/jsxRuntime.exports.jsxs(SwitchRoot, {
    className: clsx(classes.root, className),
    sx: sx,
    ownerState: ownerState,
    children: [/*#__PURE__*/jsxRuntime.exports.jsx(SwitchSwitchBase, _extends$a({
      type: "checkbox",
      icon: icon,
      checkedIcon: icon,
      ref: ref,
      ownerState: ownerState
    }, other, {
      classes: _extends$a({}, classes, {
        root: classes.switchBase
      })
    })), /*#__PURE__*/jsxRuntime.exports.jsx(SwitchTrack, {
      className: classes.track,
      ownerState: ownerState
    })]
  });
});
var Switch$3 = Switch$2;

function getCardUtilityClass(slot) {
  return generateUtilityClass('MuiCard', slot);
}
generateUtilityClasses('MuiCard', ['root']);

const _excluded$g = ["className", "raised"];

const useUtilityClasses$e = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getCardUtilityClass, classes);
};

const CardRoot = styled$1(Paper$1, {
  name: 'MuiCard',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(() => {
  return {
    overflow: 'hidden'
  };
});
const Card = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Card(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiCard'
  });

  const {
    className,
    raised = false
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$g);

  const ownerState = _extends$a({}, props, {
    raised
  });

  const classes = useUtilityClasses$e(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(CardRoot, _extends$a({
    className: clsx(classes.root, className),
    elevation: raised ? 8 : undefined,
    ref: ref,
    ownerState: ownerState
  }, other));
});
var Card$1 = Card;

function getFormControlLabelUtilityClasses(slot) {
  return generateUtilityClass('MuiFormControlLabel', slot);
}
const formControlLabelClasses = generateUtilityClasses('MuiFormControlLabel', ['root', 'labelPlacementStart', 'labelPlacementTop', 'labelPlacementBottom', 'disabled', 'label']);
var formControlLabelClasses$1 = formControlLabelClasses;

const _excluded$f = ["checked", "className", "componentsProps", "control", "disabled", "disableTypography", "inputRef", "label", "labelPlacement", "name", "onChange", "value"];

const useUtilityClasses$d = ownerState => {
  const {
    classes,
    disabled,
    labelPlacement
  } = ownerState;
  const slots = {
    root: ['root', disabled && 'disabled', `labelPlacement${capitalize$2(labelPlacement)}`],
    label: ['label', disabled && 'disabled']
  };
  return composeClasses(slots, getFormControlLabelUtilityClasses, classes);
};

const FormControlLabelRoot = styled$1('label', {
  name: 'MuiFormControlLabel',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${formControlLabelClasses$1.label}`]: styles.label
    }, styles.root, styles[`labelPlacement${capitalize$2(ownerState.labelPlacement)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$a({
  display: 'inline-flex',
  alignItems: 'center',
  cursor: 'pointer',
  // For correct alignment with the text.
  verticalAlign: 'middle',
  WebkitTapHighlightColor: 'transparent',
  marginLeft: -11,
  marginRight: 16,
  // used for row presentation of radio/checkbox
  [`&.${formControlLabelClasses$1.disabled}`]: {
    cursor: 'default'
  }
}, ownerState.labelPlacement === 'start' && {
  flexDirection: 'row-reverse',
  marginLeft: 16,
  // used for row presentation of radio/checkbox
  marginRight: -11
}, ownerState.labelPlacement === 'top' && {
  flexDirection: 'column-reverse',
  marginLeft: 16
}, ownerState.labelPlacement === 'bottom' && {
  flexDirection: 'column',
  marginLeft: 16
}, {
  [`& .${formControlLabelClasses$1.label}`]: {
    [`&.${formControlLabelClasses$1.disabled}`]: {
      color: theme.palette.text.disabled
    }
  }
}));
/**
 * Drop-in replacement of the `Radio`, `Switch` and `Checkbox` component.
 * Use this component if you want to display an extra label.
 */

const FormControlLabel = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function FormControlLabel(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiFormControlLabel'
  });

  const {
    className,
    componentsProps = {},
    control,
    disabled: disabledProp,
    disableTypography,
    label,
    labelPlacement = 'end'
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$f);

  const muiFormControl = useFormControl();
  let disabled = disabledProp;

  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
    disabled = control.props.disabled;
  }

  if (typeof disabled === 'undefined' && muiFormControl) {
    disabled = muiFormControl.disabled;
  }

  const controlProps = {
    disabled
  };
  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(key => {
    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
      controlProps[key] = props[key];
    }
  });

  const ownerState = _extends$a({}, props, {
    disabled,
    label,
    labelPlacement
  });

  const classes = useUtilityClasses$d(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsxs(FormControlLabelRoot, _extends$a({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [/*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(control, controlProps), label.type === Typography$1 || disableTypography ? label : /*#__PURE__*/jsxRuntime.exports.jsx(Typography$1, _extends$a({
      component: "span",
      className: classes.label
    }, componentsProps.typography, {
      children: label
    }))]
  }));
});
var FormControlLabel$1 = FormControlLabel;

function getFormGroupUtilityClass(slot) {
  return generateUtilityClass('MuiFormGroup', slot);
}
generateUtilityClasses('MuiFormGroup', ['root', 'row']);

const _excluded$e = ["className", "row"];

const useUtilityClasses$c = ownerState => {
  const {
    classes,
    row
  } = ownerState;
  const slots = {
    root: ['root', row && 'row']
  };
  return composeClasses(slots, getFormGroupUtilityClass, classes);
};

const FormGroupRoot = styled$1('div', {
  name: 'MuiFormGroup',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.row && styles.row];
  }
})(({
  ownerState
}) => _extends$a({
  display: 'flex',
  flexDirection: 'column',
  flexWrap: 'wrap'
}, ownerState.row && {
  flexDirection: 'row'
}));
/**
 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
 * It provides compact row layout.
 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
 */

const FormGroup = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function FormGroup(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiFormGroup'
  });

  const {
    className,
    row = false
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$e);

  const ownerState = _extends$a({}, props, {
    row
  });

  const classes = useUtilityClasses$c(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(FormGroupRoot, _extends$a({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other));
});
var FormGroup$1 = FormGroup;

/**
 * @deprecated Not used internally. Use `MediaQueryListEvent` from lib.dom.d.ts instead.
 */

function useMediaQuery(queryInput, options = {}) {
  const theme = useTheme$2(); // Wait for jsdom to support the match media feature.
  // All the browsers MUI support have this built-in.
  // This defensive check is here for simplicity.
  // Most of the time, the match media logic isn't central to people tests.

  const supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
  const {
    defaultMatches = false,
    matchMedia = supportMatchMedia ? window.matchMedia : null,
    noSsr = false,
    ssrMatchMedia = null
  } = getThemeProps({
    name: 'MuiUseMediaQuery',
    props: options,
    theme
  });

  let query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
  query = query.replace(/^@media( ?)/m, '');
  const [match, setMatch] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(() => {
    if (noSsr && supportMatchMedia) {
      return matchMedia(query).matches;
    }

    if (ssrMatchMedia) {
      return ssrMatchMedia(query).matches;
    } // Once the component is mounted, we rely on the
    // event listeners to return the correct matches value.


    return defaultMatches;
  });
  useEnhancedEffect$1(() => {
    let active = true;

    if (!supportMatchMedia) {
      return undefined;
    }

    const queryList = matchMedia(query);

    const updateMatch = () => {
      // Workaround Safari wrong implementation of matchMedia
      // TODO can we remove it?
      // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
      if (active) {
        setMatch(queryList.matches);
      }
    };

    updateMatch();
    queryList.addListener(updateMatch);
    return () => {
      active = false;
      queryList.removeListener(updateMatch);
    };
  }, [query, matchMedia, supportMatchMedia]);

  return match;
}

function getLinearProgressUtilityClass(slot) {
  return generateUtilityClass('MuiLinearProgress', slot);
}
generateUtilityClasses('MuiLinearProgress', ['root', 'colorPrimary', 'colorSecondary', 'determinate', 'indeterminate', 'buffer', 'query', 'dashed', 'dashedColorPrimary', 'dashedColorSecondary', 'bar', 'barColorPrimary', 'barColorSecondary', 'bar1Indeterminate', 'bar1Determinate', 'bar1Buffer', 'bar2Indeterminate', 'bar2Buffer']);

const _excluded$d = ["className", "color", "value", "valueBuffer", "variant"];

let _$3 = t => t,
    _t$2,
    _t2$1,
    _t3$1,
    _t4$1,
    _t5,
    _t6;
const TRANSITION_DURATION = 4; // seconds

const indeterminate1Keyframe = keyframes(_t$2 || (_t$2 = _$3`
  0% {
    left: -35%;
    right: 100%;
  }

  60% {
    left: 100%;
    right: -90%;
  }

  100% {
    left: 100%;
    right: -90%;
  }
`));
const indeterminate2Keyframe = keyframes(_t2$1 || (_t2$1 = _$3`
  0% {
    left: -200%;
    right: 100%;
  }

  60% {
    left: 107%;
    right: -8%;
  }

  100% {
    left: 107%;
    right: -8%;
  }
`));
const bufferKeyframe = keyframes(_t3$1 || (_t3$1 = _$3`
  0% {
    opacity: 1;
    background-position: 0 -23px;
  }

  60% {
    opacity: 0;
    background-position: 0 -23px;
  }

  100% {
    opacity: 1;
    background-position: -200px -23px;
  }
`));

const useUtilityClasses$b = ownerState => {
  const {
    classes,
    variant,
    color
  } = ownerState;
  const slots = {
    root: ['root', `color${capitalize$2(color)}`, variant],
    dashed: ['dashed', `dashedColor${capitalize$2(color)}`],
    bar1: ['bar', `barColor${capitalize$2(color)}`, (variant === 'indeterminate' || variant === 'query') && 'bar1Indeterminate', variant === 'determinate' && 'bar1Determinate', variant === 'buffer' && 'bar1Buffer'],
    bar2: ['bar', variant !== 'buffer' && `barColor${capitalize$2(color)}`, variant === 'buffer' && `color${capitalize$2(color)}`, (variant === 'indeterminate' || variant === 'query') && 'bar2Indeterminate', variant === 'buffer' && 'bar2Buffer']
  };
  return composeClasses(slots, getLinearProgressUtilityClass, classes);
};

const getColorShade = (theme, color) => {
  if (color === 'inherit') {
    return 'currentColor';
  }

  return theme.palette.mode === 'light' ? lighten(theme.palette[color].main, 0.62) : darken(theme.palette[color].main, 0.5);
};

const LinearProgressRoot = styled$1('span', {
  name: 'MuiLinearProgress',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`color${capitalize$2(ownerState.color)}`], styles[ownerState.variant]];
  }
})(({
  ownerState,
  theme
}) => _extends$a({
  position: 'relative',
  overflow: 'hidden',
  display: 'block',
  height: 4,
  zIndex: 0,
  // Fix Safari's bug during composition of different paint.
  '@media print': {
    colorAdjust: 'exact'
  },
  backgroundColor: getColorShade(theme, ownerState.color)
}, ownerState.color === 'inherit' && ownerState.variant !== 'buffer' && {
  backgroundColor: 'none',
  '&::before': {
    content: '""',
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'currentColor',
    opacity: 0.3
  }
}, ownerState.variant === 'buffer' && {
  backgroundColor: 'transparent'
}, ownerState.variant === 'query' && {
  transform: 'rotate(180deg)'
}));
const LinearProgressDashed = styled$1('span', {
  name: 'MuiLinearProgress',
  slot: 'Dashed',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.dashed, styles[`dashedColor${capitalize$2(ownerState.color)}`]];
  }
})(({
  ownerState,
  theme
}) => {
  const backgroundColor = getColorShade(theme, ownerState.color);
  return _extends$a({
    position: 'absolute',
    marginTop: 0,
    height: '100%',
    width: '100%'
  }, ownerState.color === 'inherit' && {
    opacity: 0.3
  }, {
    backgroundImage: `radial-gradient(${backgroundColor} 0%, ${backgroundColor} 16%, transparent 42%)`,
    backgroundSize: '10px 10px',
    backgroundPosition: '0 -23px'
  });
}, css(_t4$1 || (_t4$1 = _$3`
    animation: ${0} 3s infinite linear;
  `), bufferKeyframe));
const LinearProgressBar1 = styled$1('span', {
  name: 'MuiLinearProgress',
  slot: 'Bar1',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.bar, styles[`barColor${capitalize$2(ownerState.color)}`], (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar1Indeterminate, ownerState.variant === 'determinate' && styles.bar1Determinate, ownerState.variant === 'buffer' && styles.bar1Buffer];
  }
})(({
  ownerState,
  theme
}) => _extends$a({
  width: '100%',
  position: 'absolute',
  left: 0,
  bottom: 0,
  top: 0,
  transition: 'transform 0.2s linear',
  transformOrigin: 'left',
  backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : theme.palette[ownerState.color].main
}, ownerState.variant === 'determinate' && {
  transition: `transform .${TRANSITION_DURATION}s linear`
}, ownerState.variant === 'buffer' && {
  zIndex: 1,
  transition: `transform .${TRANSITION_DURATION}s linear`
}), ({
  ownerState
}) => (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && css(_t5 || (_t5 = _$3`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite;
    `), indeterminate1Keyframe));
const LinearProgressBar2 = styled$1('span', {
  name: 'MuiLinearProgress',
  slot: 'Bar2',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.bar, styles[`barColor${capitalize$2(ownerState.color)}`], (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && styles.bar2Indeterminate, ownerState.variant === 'buffer' && styles.bar2Buffer];
  }
})(({
  ownerState,
  theme
}) => _extends$a({
  width: '100%',
  position: 'absolute',
  left: 0,
  bottom: 0,
  top: 0,
  transition: 'transform 0.2s linear',
  transformOrigin: 'left'
}, ownerState.variant !== 'buffer' && {
  backgroundColor: ownerState.color === 'inherit' ? 'currentColor' : theme.palette[ownerState.color].main
}, ownerState.color === 'inherit' && {
  opacity: 0.3
}, ownerState.variant === 'buffer' && {
  backgroundColor: getColorShade(theme, ownerState.color),
  transition: `transform .${TRANSITION_DURATION}s linear`
}), ({
  ownerState
}) => (ownerState.variant === 'indeterminate' || ownerState.variant === 'query') && css(_t6 || (_t6 = _$3`
      width: auto;
      animation: ${0} 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite;
    `), indeterminate2Keyframe));
/**
 * ## ARIA
 *
 * If the progress bar is describing the loading progress of a particular region of a page,
 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
 * attribute to `true` on that region until it has finished loading.
 */

const LinearProgress = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function LinearProgress(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiLinearProgress'
  });

  const {
    className,
    color = 'primary',
    value,
    valueBuffer,
    variant = 'indeterminate'
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$d);

  const ownerState = _extends$a({}, props, {
    color,
    variant
  });

  const classes = useUtilityClasses$b(ownerState);
  const theme = useTheme();
  const rootProps = {};
  const inlineStyles = {
    bar1: {},
    bar2: {}
  };

  if (variant === 'determinate' || variant === 'buffer') {
    if (value !== undefined) {
      rootProps['aria-valuenow'] = Math.round(value);
      rootProps['aria-valuemin'] = 0;
      rootProps['aria-valuemax'] = 100;
      let transform = value - 100;

      if (theme.direction === 'rtl') {
        transform = -transform;
      }

      inlineStyles.bar1.transform = `translateX(${transform}%)`;
    }
  }

  if (variant === 'buffer') {
    if (valueBuffer !== undefined) {
      let transform = (valueBuffer || 0) - 100;

      if (theme.direction === 'rtl') {
        transform = -transform;
      }

      inlineStyles.bar2.transform = `translateX(${transform}%)`;
    }
  }

  return /*#__PURE__*/jsxRuntime.exports.jsxs(LinearProgressRoot, _extends$a({
    className: clsx(classes.root, className),
    ownerState: ownerState,
    role: "progressbar"
  }, rootProps, {
    ref: ref
  }, other, {
    children: [variant === 'buffer' ? /*#__PURE__*/jsxRuntime.exports.jsx(LinearProgressDashed, {
      className: classes.dashed,
      ownerState: ownerState
    }) : null, /*#__PURE__*/jsxRuntime.exports.jsx(LinearProgressBar1, {
      className: classes.bar1,
      ownerState: ownerState,
      style: inlineStyles.bar1
    }), variant === 'determinate' ? null : /*#__PURE__*/jsxRuntime.exports.jsx(LinearProgressBar2, {
      className: classes.bar2,
      ownerState: ownerState,
      style: inlineStyles.bar2
    })]
  }));
});
var LinearProgress$1 = LinearProgress;

function getLinkUtilityClass(slot) {
  return generateUtilityClass('MuiLink', slot);
}
const linkClasses = generateUtilityClasses('MuiLink', ['root', 'underlineNone', 'underlineHover', 'underlineAlways', 'button', 'focusVisible']);
var linkClasses$1 = linkClasses;

const _excluded$c = ["className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"];
const colorTransformations = {
  primary: 'primary.main',
  textPrimary: 'text.primary',
  secondary: 'secondary.main',
  textSecondary: 'text.secondary',
  error: 'error.main'
};

const transformDeprecatedColors = color => {
  return colorTransformations[color] || color;
};

const useUtilityClasses$a = ownerState => {
  const {
    classes,
    component,
    focusVisible,
    underline
  } = ownerState;
  const slots = {
    root: ['root', `underline${capitalize$2(underline)}`, component === 'button' && 'button', focusVisible && 'focusVisible']
  };
  return composeClasses(slots, getLinkUtilityClass, classes);
};

const LinkRoot = styled$1(Typography$1, {
  name: 'MuiLink',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`underline${capitalize$2(ownerState.underline)}`], ownerState.component === 'button' && styles.button];
  }
})(({
  theme,
  ownerState
}) => {
  const color = getPath(theme, `palette.${transformDeprecatedColors(ownerState.color)}`) || ownerState.color;
  return _extends$a({}, ownerState.underline === 'none' && {
    textDecoration: 'none'
  }, ownerState.underline === 'hover' && {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }, ownerState.underline === 'always' && {
    textDecoration: 'underline',
    textDecorationColor: color !== 'inherit' ? alpha(color, 0.4) : undefined,
    '&:hover': {
      textDecorationColor: 'inherit'
    }
  }, ownerState.component === 'button' && {
    position: 'relative',
    WebkitTapHighlightColor: 'transparent',
    backgroundColor: 'transparent',
    // Reset default value
    // We disable the focus ring for mouse, touch and keyboard users.
    outline: 0,
    border: 0,
    margin: 0,
    // Remove the margin in Safari
    borderRadius: 0,
    padding: 0,
    // Remove the padding in Firefox
    cursor: 'pointer',
    userSelect: 'none',
    verticalAlign: 'middle',
    MozAppearance: 'none',
    // Reset
    WebkitAppearance: 'none',
    // Reset
    '&::-moz-focus-inner': {
      borderStyle: 'none' // Remove Firefox dotted outline.

    },
    [`&.${linkClasses$1.focusVisible}`]: {
      outline: 'auto'
    }
  });
});
const Link = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Link(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiLink'
  });

  const {
    className,
    color = 'primary',
    component = 'a',
    onBlur,
    onFocus,
    TypographyClasses,
    underline = 'always',
    variant = 'inherit'
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$c);

  const {
    isFocusVisibleRef,
    onBlur: handleBlurVisible,
    onFocus: handleFocusVisible,
    ref: focusVisibleRef
  } = useIsFocusVisible();
  const [focusVisible, setFocusVisible] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
  const handlerRef = useForkRef(ref, focusVisibleRef);

  const handleBlur = event => {
    handleBlurVisible(event);

    if (isFocusVisibleRef.current === false) {
      setFocusVisible(false);
    }

    if (onBlur) {
      onBlur(event);
    }
  };

  const handleFocus = event => {
    handleFocusVisible(event);

    if (isFocusVisibleRef.current === true) {
      setFocusVisible(true);
    }

    if (onFocus) {
      onFocus(event);
    }
  };

  const ownerState = _extends$a({}, props, {
    color,
    component,
    focusVisible,
    underline,
    variant
  });

  const classes = useUtilityClasses$a(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(LinkRoot, _extends$a({
    className: clsx(classes.root, className),
    classes: TypographyClasses,
    color: color,
    component: component,
    onBlur: handleBlur,
    onFocus: handleFocus,
    ref: handlerRef,
    ownerState: ownerState,
    variant: variant
  }, other));
});
var Link$1 = Link;

function getPaginationUtilityClass(slot) {
  return generateUtilityClass('MuiPagination', slot);
}
generateUtilityClasses('MuiPagination', ['root', 'ul', 'outlined', 'text']);

const _excluded$b = ["boundaryCount", "componentName", "count", "defaultPage", "disabled", "hideNextButton", "hidePrevButton", "onChange", "page", "showFirstButton", "showLastButton", "siblingCount"];
function usePagination(props = {}) {
  // keep default values in sync with @default tags in Pagination.propTypes
  const {
    boundaryCount = 1,
    componentName = 'usePagination',
    count = 1,
    defaultPage = 1,
    disabled = false,
    hideNextButton = false,
    hidePrevButton = false,
    onChange: handleChange,
    page: pageProp,
    showFirstButton = false,
    showLastButton = false,
    siblingCount = 1
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$b);

  const [page, setPageState] = useControlled({
    controlled: pageProp,
    default: defaultPage,
    name: componentName,
    state: 'page'
  });

  const handleClick = (event, value) => {
    if (!pageProp) {
      setPageState(value);
    }

    if (handleChange) {
      handleChange(event, value);
    }
  }; // https://dev.to/namirsab/comment/2050


  const range = (start, end) => {
    const length = end - start + 1;
    return Array.from({
      length
    }, (_, i) => start + i);
  };

  const startPages = range(1, Math.min(boundaryCount, count));
  const endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
  const siblingsStart = Math.max(Math.min( // Natural start
  page - siblingCount, // Lower boundary when page is high
  count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
  boundaryCount + 2);
  const siblingsEnd = Math.min(Math.max( // Natural end
  page + siblingCount, // Upper boundary when page is low
  boundaryCount + siblingCount * 2 + 2), // Less than endPages
  endPages.length > 0 ? endPages[0] - 2 : count - 1); // Basic list of items to render
  // e.g. itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']

  const itemList = [...(showFirstButton ? ['first'] : []), ...(hidePrevButton ? [] : ['previous']), ...startPages, // Start ellipsis
  // eslint-disable-next-line no-nested-ternary
  ...(siblingsStart > boundaryCount + 2 ? ['start-ellipsis'] : boundaryCount + 1 < count - boundaryCount ? [boundaryCount + 1] : []), // Sibling pages
  ...range(siblingsStart, siblingsEnd), // End ellipsis
  // eslint-disable-next-line no-nested-ternary
  ...(siblingsEnd < count - boundaryCount - 1 ? ['end-ellipsis'] : count - boundaryCount > boundaryCount ? [count - boundaryCount] : []), ...endPages, ...(hideNextButton ? [] : ['next']), ...(showLastButton ? ['last'] : [])]; // Map the button type to its page number

  const buttonPage = type => {
    switch (type) {
      case 'first':
        return 1;

      case 'previous':
        return page - 1;

      case 'next':
        return page + 1;

      case 'last':
        return count;

      default:
        return null;
    }
  }; // Convert the basic item list to PaginationItem props objects


  const items = itemList.map(item => {
    return typeof item === 'number' ? {
      onClick: event => {
        handleClick(event, item);
      },
      type: 'page',
      page: item,
      selected: item === page,
      disabled,
      'aria-current': item === page ? 'true' : undefined
    } : {
      onClick: event => {
        handleClick(event, buttonPage(item));
      },
      type: item,
      page: buttonPage(item),
      selected: false,
      disabled: disabled || item.indexOf('ellipsis') === -1 && (item === 'next' || item === 'last' ? page >= count : page <= 1)
    };
  });
  return _extends$a({
    items
  }, other);
}

function getPaginationItemUtilityClass(slot) {
  return generateUtilityClass('MuiPaginationItem', slot);
}
const paginationItemClasses = generateUtilityClasses('MuiPaginationItem', ['root', 'page', 'sizeSmall', 'sizeLarge', 'text', 'textPrimary', 'textSecondary', 'outlined', 'outlinedPrimary', 'outlinedSecondary', 'rounded', 'ellipsis', 'firstLast', 'previousNext', 'focusVisible', 'disabled', 'selected', 'icon']);
var paginationItemClasses$1 = paginationItemClasses;

var FirstPageIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');

var LastPageIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');

var NavigateBeforeIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');

var NavigateNextIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');

const _excluded$a = ["className", "color", "component", "disabled", "page", "selected", "shape", "size", "type", "variant"];

const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, styles[ownerState.variant], styles[`size${capitalize$2(ownerState.size)}`], ownerState.variant === 'text' && styles[`text${capitalize$2(ownerState.color)}`], ownerState.variant === 'outlined' && styles[`outlined${capitalize$2(ownerState.color)}`], ownerState.shape === 'rounded' && styles.rounded, ownerState.type === 'page' && styles.page, (ownerState.type === 'start-ellipsis' || ownerState.type === 'end-ellipsis') && styles.ellipsis, (ownerState.type === 'previous' || ownerState.type === 'next') && styles.previousNext, (ownerState.type === 'first' || ownerState.type === 'last') && styles.firstLast];
};

const useUtilityClasses$9 = ownerState => {
  const {
    classes,
    color,
    disabled,
    selected,
    size,
    shape,
    type,
    variant
  } = ownerState;
  const slots = {
    root: ['root', `size${capitalize$2(size)}`, variant, shape, color !== 'standard' && `${variant}${capitalize$2(color)}`, disabled && 'disabled', selected && 'selected', {
      page: 'page',
      first: 'firstLast',
      last: 'firstLast',
      'start-ellipsis': 'ellipsis',
      'end-ellipsis': 'ellipsis',
      previous: 'previousNext',
      next: 'previousNext'
    }[type]],
    icon: ['icon']
  };
  return composeClasses(slots, getPaginationItemUtilityClass, classes);
};

const PaginationItemEllipsis = styled$1('div', {
  name: 'MuiPaginationItem',
  slot: 'Root',
  overridesResolver
})(({
  theme,
  ownerState
}) => _extends$a({}, theme.typography.body2, {
  borderRadius: 32 / 2,
  textAlign: 'center',
  boxSizing: 'border-box',
  minWidth: 32,
  padding: '0 6px',
  margin: '0 3px',
  color: theme.palette.text.primary,
  height: 'auto',
  [`&.${paginationItemClasses$1.disabled}`]: {
    opacity: theme.palette.action.disabledOpacity
  }
}, ownerState.size === 'small' && {
  minWidth: 26,
  borderRadius: 26 / 2,
  margin: '0 1px',
  padding: '0 4px'
}, ownerState.size === 'large' && {
  minWidth: 40,
  borderRadius: 40 / 2,
  padding: '0 10px',
  fontSize: theme.typography.pxToRem(15)
}));
const PaginationItemPage = styled$1(ButtonBase$1, {
  name: 'MuiPaginationItem',
  slot: 'Root',
  overridesResolver
})(({
  theme,
  ownerState
}) => _extends$a({}, theme.typography.body2, {
  borderRadius: 32 / 2,
  textAlign: 'center',
  boxSizing: 'border-box',
  minWidth: 32,
  height: 32,
  padding: '0 6px',
  margin: '0 3px',
  color: theme.palette.text.primary,
  [`&.${paginationItemClasses$1.focusVisible}`]: {
    backgroundColor: theme.palette.action.focus
  },
  [`&.${paginationItemClasses$1.disabled}`]: {
    opacity: theme.palette.action.disabledOpacity
  },
  transition: theme.transitions.create(['color', 'background-color'], {
    duration: theme.transitions.duration.short
  }),
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  },
  [`&.${paginationItemClasses$1.selected}`]: {
    backgroundColor: theme.palette.action.selected,
    '&:hover': {
      backgroundColor: alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: theme.palette.action.selected
      }
    },
    [`&.${paginationItemClasses$1.focusVisible}`]: {
      backgroundColor: alpha(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.focusOpacity)
    },
    [`&.${paginationItemClasses$1.disabled}`]: {
      opacity: 1,
      color: theme.palette.action.disabled,
      backgroundColor: theme.palette.action.selected
    }
  }
}, ownerState.size === 'small' && {
  minWidth: 26,
  height: 26,
  borderRadius: 26 / 2,
  margin: '0 1px',
  padding: '0 4px'
}, ownerState.size === 'large' && {
  minWidth: 40,
  height: 40,
  borderRadius: 40 / 2,
  padding: '0 10px',
  fontSize: theme.typography.pxToRem(15)
}, ownerState.shape === 'rounded' && {
  borderRadius: theme.shape.borderRadius
}), ({
  theme,
  ownerState
}) => _extends$a({}, ownerState.variant === 'text' && {
  [`&.${paginationItemClasses$1.selected}`]: _extends$a({}, ownerState.color !== 'standard' && {
    color: theme.palette[ownerState.color].contrastText,
    backgroundColor: theme.palette[ownerState.color].main,
    '&:hover': {
      backgroundColor: theme.palette[ownerState.color].dark,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: theme.palette[ownerState.color].main
      }
    },
    [`&.${paginationItemClasses$1.focusVisible}`]: {
      backgroundColor: theme.palette[ownerState.color].dark
    }
  }, {
    [`&.${paginationItemClasses$1.disabled}`]: {
      color: theme.palette.action.disabled
    }
  })
}, ownerState.variant === 'outlined' && {
  border: `1px solid ${theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'}`,
  [`&.${paginationItemClasses$1.selected}`]: _extends$a({}, ownerState.color !== 'standard' && {
    color: theme.palette[ownerState.color].main,
    border: `1px solid ${alpha(theme.palette[ownerState.color].main, 0.5)}`,
    backgroundColor: alpha(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity),
    '&:hover': {
      backgroundColor: alpha(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity),
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor: 'transparent'
      }
    },
    [`&.${paginationItemClasses$1.focusVisible}`]: {
      backgroundColor: alpha(theme.palette[ownerState.color].main, theme.palette.action.activatedOpacity + theme.palette.action.focusOpacity)
    }
  }, {
    [`&.${paginationItemClasses$1.disabled}`]: {
      borderColor: theme.palette.action.disabledBackground,
      color: theme.palette.action.disabled
    }
  })
}));
const PaginationItemPageIcon = styled$1('div', {
  name: 'MuiPaginationItem',
  slot: 'Icon',
  overridesResolver: (props, styles) => styles.icon
})(({
  theme,
  ownerState
}) => _extends$a({
  fontSize: theme.typography.pxToRem(20),
  margin: '0 -8px'
}, ownerState.size === 'small' && {
  fontSize: theme.typography.pxToRem(18)
}, ownerState.size === 'large' && {
  fontSize: theme.typography.pxToRem(22)
}));
const PaginationItem = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function PaginationItem(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPaginationItem'
  });

  const {
    className,
    color = 'standard',
    component,
    disabled = false,
    page,
    selected = false,
    shape = 'circular',
    size = 'medium',
    type = 'page',
    variant = 'text'
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$a);

  const ownerState = _extends$a({}, props, {
    color,
    disabled,
    selected,
    shape,
    size,
    type,
    variant
  });

  const theme = useTheme();
  const classes = useUtilityClasses$9(ownerState);
  const normalizedIcons = theme.direction === 'rtl' ? {
    previous: NavigateNextIcon,
    next: NavigateBeforeIcon,
    last: FirstPageIcon,
    first: LastPageIcon
  } : {
    previous: NavigateBeforeIcon,
    next: NavigateNextIcon,
    first: FirstPageIcon,
    last: LastPageIcon
  };
  const Icon = normalizedIcons[type];
  return type === 'start-ellipsis' || type === 'end-ellipsis' ? /*#__PURE__*/jsxRuntime.exports.jsx(PaginationItemEllipsis, _extends$a({
    ref: ref,
    ownerState: ownerState,
    className: clsx(classes.root, className)
  }, other, {
    children: "\u2026"
  })) : /*#__PURE__*/jsxRuntime.exports.jsxs(PaginationItemPage, _extends$a({
    ref: ref,
    ownerState: ownerState,
    component: component,
    disabled: disabled,
    className: clsx(classes.root, className)
  }, other, {
    children: [type === 'page' && page, Icon ? /*#__PURE__*/jsxRuntime.exports.jsx(PaginationItemPageIcon, {
      as: Icon,
      ownerState: ownerState,
      className: classes.icon
    }) : null]
  }));
});
var PaginationItem$1 = PaginationItem;

const _excluded$9 = ["boundaryCount", "className", "color", "count", "defaultPage", "disabled", "getItemAriaLabel", "hideNextButton", "hidePrevButton", "onChange", "page", "renderItem", "shape", "showFirstButton", "showLastButton", "siblingCount", "size", "variant"];

const useUtilityClasses$8 = ownerState => {
  const {
    classes,
    variant
  } = ownerState;
  const slots = {
    root: ['root', variant],
    ul: ['ul']
  };
  return composeClasses(slots, getPaginationUtilityClass, classes);
};

const PaginationRoot = styled$1('nav', {
  name: 'MuiPagination',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant]];
  }
})({});
const PaginationUl = styled$1('ul', {
  name: 'MuiPagination',
  slot: 'Ul',
  overridesResolver: (props, styles) => styles.ul
})({
  display: 'flex',
  flexWrap: 'wrap',
  alignItems: 'center',
  padding: 0,
  margin: 0,
  listStyle: 'none'
});

function defaultGetAriaLabel(type, page, selected) {
  if (type === 'page') {
    return `${selected ? '' : 'Go to '}page ${page}`;
  }

  return `Go to ${type} page`;
}

const Pagination = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Pagination(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiPagination'
  });

  const {
    boundaryCount = 1,
    className,
    color = 'standard',
    count = 1,
    defaultPage = 1,
    disabled = false,
    getItemAriaLabel = defaultGetAriaLabel,
    hideNextButton = false,
    hidePrevButton = false,
    renderItem = item => /*#__PURE__*/jsxRuntime.exports.jsx(PaginationItem$1, _extends$a({}, item)),
    shape = 'circular',
    showFirstButton = false,
    showLastButton = false,
    siblingCount = 1,
    size = 'medium',
    variant = 'text'
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$9);

  const {
    items
  } = usePagination(_extends$a({}, props, {
    componentName: 'Pagination'
  }));

  const ownerState = _extends$a({}, props, {
    boundaryCount,
    color,
    count,
    defaultPage,
    disabled,
    getItemAriaLabel,
    hideNextButton,
    hidePrevButton,
    renderItem,
    shape,
    showFirstButton,
    showLastButton,
    siblingCount,
    size,
    variant
  });

  const classes = useUtilityClasses$8(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(PaginationRoot, _extends$a({
    "aria-label": "pagination navigation",
    className: clsx(classes.root, className),
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: /*#__PURE__*/jsxRuntime.exports.jsx(PaginationUl, {
      className: classes.ul,
      ownerState: ownerState,
      children: items.map((item, index) => /*#__PURE__*/jsxRuntime.exports.jsx("li", {
        children: renderItem(_extends$a({}, item, {
          color,
          'aria-label': getItemAriaLabel(item.type, item.page, item.selected),
          shape,
          size,
          variant
        }))
      }, index))
    })
  }));
}); // @default tags synced with default values from usePagination
var Pagination$1 = Pagination;

var RadioButtonUncheckedIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
}), 'RadioButtonUnchecked');

var RadioButtonCheckedIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
}), 'RadioButtonChecked');

const RadioButtonIconRoot = styled$1('span')({
  position: 'relative',
  display: 'flex'
});
const RadioButtonIconBackground = styled$1(RadioButtonUncheckedIcon, {
  skipSx: true
})({
  // Scale applied to prevent dot misalignment in Safari
  transform: 'scale(1)'
});
const RadioButtonIconDot = styled$1(RadioButtonCheckedIcon, {
  skipSx: true
})(({
  theme,
  ownerState
}) => _extends$a({
  left: 0,
  position: 'absolute',
  transform: 'scale(0)',
  transition: theme.transitions.create('transform', {
    easing: theme.transitions.easing.easeIn,
    duration: theme.transitions.duration.shortest
  })
}, ownerState.checked && {
  transform: 'scale(1)',
  transition: theme.transitions.create('transform', {
    easing: theme.transitions.easing.easeOut,
    duration: theme.transitions.duration.shortest
  })
}));
/**
 * @ignore - internal component.
 */

function RadioButtonIcon(props) {
  const {
    checked = false,
    classes = {},
    fontSize
  } = props;

  const ownerState = _extends$a({}, props, {
    checked
  });

  return /*#__PURE__*/jsxRuntime.exports.jsxs(RadioButtonIconRoot, {
    className: classes.root,
    ownerState: ownerState,
    children: [/*#__PURE__*/jsxRuntime.exports.jsx(RadioButtonIconBackground, {
      fontSize: fontSize,
      className: classes.background,
      ownerState: ownerState
    }), /*#__PURE__*/jsxRuntime.exports.jsx(RadioButtonIconDot, {
      fontSize: fontSize,
      className: classes.dot,
      ownerState: ownerState
    })]
  });
}

/**
 * @ignore - internal component.
 */

const RadioGroupContext = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createContext();

var RadioGroupContext$1 = RadioGroupContext;

function useRadioGroup() {
  return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(RadioGroupContext$1);
}

function getRadioUtilityClass(slot) {
  return generateUtilityClass('MuiRadio', slot);
}
const radioClasses = generateUtilityClasses('MuiRadio', ['root', 'checked', 'disabled', 'colorPrimary', 'colorSecondary']);
var radioClasses$1 = radioClasses;

const _excluded$8 = ["checked", "checkedIcon", "color", "icon", "name", "onChange", "size"];

const useUtilityClasses$7 = ownerState => {
  const {
    classes,
    color
  } = ownerState;
  const slots = {
    root: ['root', `color${capitalize$2(color)}`]
  };
  return _extends$a({}, classes, composeClasses(slots, getRadioUtilityClass, classes));
};

const RadioRoot = styled$1(SwitchBase$1, {
  shouldForwardProp: prop => rootShouldForwardProp$1(prop) || prop === 'classes',
  name: 'MuiRadio',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[`color${capitalize$2(ownerState.color)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$a({
  color: theme.palette.text.secondary,
  '&:hover': {
    backgroundColor: alpha(ownerState.color === 'default' ? theme.palette.action.active : theme.palette[ownerState.color].main, theme.palette.action.hoverOpacity),
    // Reset on touch devices, it doesn't add specificity
    '@media (hover: none)': {
      backgroundColor: 'transparent'
    }
  }
}, ownerState.color !== 'default' && {
  [`&.${radioClasses$1.checked}`]: {
    color: theme.palette[ownerState.color].main
  }
}, {
  [`&.${radioClasses$1.disabled}`]: {
    color: theme.palette.action.disabled
  }
}));

function areEqualValues(a, b) {
  if (typeof b === 'object' && b !== null) {
    return a === b;
  } // The value could be a number, the DOM will stringify it anyway.


  return String(a) === String(b);
}

const defaultCheckedIcon = /*#__PURE__*/jsxRuntime.exports.jsx(RadioButtonIcon, {
  checked: true
});

const defaultIcon = /*#__PURE__*/jsxRuntime.exports.jsx(RadioButtonIcon, {});

const Radio = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Radio(inProps, ref) {
  var _defaultIcon$props$fo, _defaultCheckedIcon$p;

  const props = useThemeProps({
    props: inProps,
    name: 'MuiRadio'
  });

  const {
    checked: checkedProp,
    checkedIcon = defaultCheckedIcon,
    color = 'primary',
    icon = defaultIcon,
    name: nameProp,
    onChange: onChangeProp,
    size = 'medium'
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$8);

  const ownerState = _extends$a({}, props, {
    color,
    size
  });

  const classes = useUtilityClasses$7(ownerState);
  const radioGroup = useRadioGroup();
  let checked = checkedProp;
  const onChange = createChainedFunction(onChangeProp, radioGroup && radioGroup.onChange);
  let name = nameProp;

  if (radioGroup) {
    if (typeof checked === 'undefined') {
      checked = areEqualValues(radioGroup.value, props.value);
    }

    if (typeof name === 'undefined') {
      name = radioGroup.name;
    }
  }

  return /*#__PURE__*/jsxRuntime.exports.jsx(RadioRoot, _extends$a({
    type: "radio",
    icon: /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(icon, {
      fontSize: (_defaultIcon$props$fo = defaultIcon.props.fontSize) != null ? _defaultIcon$props$fo : size
    }),
    checkedIcon: /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(checkedIcon, {
      fontSize: (_defaultCheckedIcon$p = defaultCheckedIcon.props.fontSize) != null ? _defaultCheckedIcon$p : size
    }),
    ownerState: ownerState,
    classes: classes,
    name: name,
    checked: checked,
    onChange: onChange,
    ref: ref
  }, other));
});
var Radio$1 = Radio;

const _excluded$7 = ["actions", "children", "defaultValue", "name", "onChange", "value"];
const RadioGroup = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function RadioGroup(props, ref) {
  const {
    // private
    // eslint-disable-next-line react/prop-types
    actions,
    children,
    defaultValue,
    name: nameProp,
    onChange,
    value: valueProp
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$7);

  const rootRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const [value, setValueState] = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: 'RadioGroup'
  });
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useImperativeHandle(actions, () => ({
    focus: () => {
      let input = rootRef.current.querySelector('input:not(:disabled):checked');

      if (!input) {
        input = rootRef.current.querySelector('input:not(:disabled)');
      }

      if (input) {
        input.focus();
      }
    }
  }), []);
  const handleRef = useForkRef(ref, rootRef);

  const handleChange = event => {
    setValueState(event.target.value);

    if (onChange) {
      onChange(event, event.target.value);
    }
  };

  const name = useId(nameProp);
  return /*#__PURE__*/jsxRuntime.exports.jsx(RadioGroupContext$1.Provider, {
    value: {
      name,
      onChange: handleChange,
      value
    },
    children: /*#__PURE__*/jsxRuntime.exports.jsx(FormGroup$1, _extends$a({
      role: "radiogroup",
      ref: handleRef
    }, other, {
      children: children
    }))
  });
});
var RadioGroup$1 = RadioGroup;

function getSkeletonUtilityClass(slot) {
  return generateUtilityClass('MuiSkeleton', slot);
}
generateUtilityClasses('MuiSkeleton', ['root', 'text', 'rectangular', 'circular', 'pulse', 'wave', 'withChildren', 'fitContent', 'heightAuto']);

const _excluded$6 = ["animation", "className", "component", "height", "style", "variant", "width"];

let _$2 = t => t,
    _t$1,
    _t2,
    _t3,
    _t4;

const useUtilityClasses$6 = ownerState => {
  const {
    classes,
    variant,
    animation,
    hasChildren,
    width,
    height
  } = ownerState;
  const slots = {
    root: ['root', variant, animation, hasChildren && 'withChildren', hasChildren && !width && 'fitContent', hasChildren && !height && 'heightAuto']
  };
  return composeClasses(slots, getSkeletonUtilityClass, classes);
};

const pulseKeyframe = keyframes(_t$1 || (_t$1 = _$2`
  0% {
    opacity: 1;
  }

  50% {
    opacity: 0.4;
  }

  100% {
    opacity: 1;
  }
`));
const waveKeyframe = keyframes(_t2 || (_t2 = _$2`
  0% {
    transform: translateX(-100%);
  }

  50% {
    /* +0.5s of delay between each loop */
    transform: translateX(100%);
  }

  100% {
    transform: translateX(100%);
  }
`));
const SkeletonRoot = styled$1('span', {
  name: 'MuiSkeleton',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], ownerState.animation !== false && styles[ownerState.animation], ownerState.hasChildren && styles.withChildren, ownerState.hasChildren && !ownerState.width && styles.fitContent, ownerState.hasChildren && !ownerState.height && styles.heightAuto];
  }
})(({
  theme,
  ownerState
}) => {
  const radiusUnit = getUnit(theme.shape.borderRadius) || 'px';
  const radiusValue = toUnitless(theme.shape.borderRadius);
  return _extends$a({
    display: 'block',
    // Create a "on paper" color with sufficient contrast retaining the color
    backgroundColor: alpha(theme.palette.text.primary, theme.palette.mode === 'light' ? 0.11 : 0.13),
    height: '1.2em'
  }, ownerState.variant === 'text' && {
    marginTop: 0,
    marginBottom: 0,
    height: 'auto',
    transformOrigin: '0 55%',
    transform: 'scale(1, 0.60)',
    borderRadius: `${radiusValue}${radiusUnit}/${Math.round(radiusValue / 0.6 * 10) / 10}${radiusUnit}`,
    '&:empty:before': {
      content: '"\\00a0"'
    }
  }, ownerState.variant === 'circular' && {
    borderRadius: '50%'
  }, ownerState.hasChildren && {
    '& > *': {
      visibility: 'hidden'
    }
  }, ownerState.hasChildren && !ownerState.width && {
    maxWidth: 'fit-content'
  }, ownerState.hasChildren && !ownerState.height && {
    height: 'auto'
  });
}, ({
  ownerState
}) => ownerState.animation === 'pulse' && css(_t3 || (_t3 = _$2`
      animation: ${0} 1.5s ease-in-out 0.5s infinite;
    `), pulseKeyframe), ({
  ownerState,
  theme
}) => ownerState.animation === 'wave' && css(_t4 || (_t4 = _$2`
      position: relative;
      overflow: hidden;

      /* Fix bug in Safari https://bugs.webkit.org/show_bug.cgi?id=68196 */
      -webkit-mask-image: -webkit-radial-gradient(white, black);

      &::after {
        animation: ${0} 1.6s linear 0.5s infinite;
        background: linear-gradient(90deg, transparent, ${0}, transparent);
        content: '';
        position: absolute;
        transform: translateX(-100%); /* Avoid flash during server-side hydration */
        bottom: 0;
        left: 0;
        right: 0;
        top: 0;
      }
    `), waveKeyframe, theme.palette.action.hover));
const Skeleton = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Skeleton(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiSkeleton'
  });

  const {
    animation = 'pulse',
    className,
    component = 'span',
    height,
    style,
    variant = 'text',
    width
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$6);

  const ownerState = _extends$a({}, props, {
    animation,
    component,
    variant,
    hasChildren: Boolean(other.children)
  });

  const classes = useUtilityClasses$6(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(SkeletonRoot, _extends$a({
    as: component,
    ref: ref,
    className: clsx(classes.root, className),
    ownerState: ownerState
  }, other, {
    style: _extends$a({
      width,
      height
    }, style)
  }));
});
var Skeleton$1 = Skeleton;

/**
 * @ignore - internal component.
 */

const TableContext = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createContext();

var TableContext$1 = TableContext;

function getTableUtilityClass(slot) {
  return generateUtilityClass('MuiTable', slot);
}
generateUtilityClasses('MuiTable', ['root', 'stickyHeader']);

const _excluded$5 = ["className", "component", "padding", "size", "stickyHeader"];

const useUtilityClasses$5 = ownerState => {
  const {
    classes,
    stickyHeader
  } = ownerState;
  const slots = {
    root: ['root', stickyHeader && 'stickyHeader']
  };
  return composeClasses(slots, getTableUtilityClass, classes);
};

const TableRoot = styled$1('table', {
  name: 'MuiTable',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.stickyHeader && styles.stickyHeader];
  }
})(({
  theme,
  ownerState
}) => _extends$a({
  display: 'table',
  width: '100%',
  borderCollapse: 'collapse',
  borderSpacing: 0,
  '& caption': _extends$a({}, theme.typography.body2, {
    padding: theme.spacing(2),
    color: theme.palette.text.secondary,
    textAlign: 'left',
    captionSide: 'bottom'
  })
}, ownerState.stickyHeader && {
  borderCollapse: 'separate'
}));
const defaultComponent$3 = 'table';
const Table$1 = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Table(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTable'
  });

  const {
    className,
    component = defaultComponent$3,
    padding = 'normal',
    size = 'medium',
    stickyHeader = false
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$5);

  const ownerState = _extends$a({}, props, {
    component,
    padding,
    size,
    stickyHeader
  });

  const classes = useUtilityClasses$5(ownerState);
  const table = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
    padding,
    size,
    stickyHeader
  }), [padding, size, stickyHeader]);
  return /*#__PURE__*/jsxRuntime.exports.jsx(TableContext$1.Provider, {
    value: table,
    children: /*#__PURE__*/jsxRuntime.exports.jsx(TableRoot, _extends$a({
      as: component,
      role: component === defaultComponent$3 ? null : 'table',
      ref: ref,
      className: clsx(classes.root, className),
      ownerState: ownerState
    }, other))
  });
});
var MuiTable = Table$1;

/**
 * @ignore - internal component.
 */

const Tablelvl2Context = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createContext();

var Tablelvl2Context$1 = Tablelvl2Context;

function getTableBodyUtilityClass(slot) {
  return generateUtilityClass('MuiTableBody', slot);
}
generateUtilityClasses('MuiTableBody', ['root']);

const _excluded$4 = ["className", "component"];

const useUtilityClasses$4 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getTableBodyUtilityClass, classes);
};

const TableBodyRoot = styled$1('tbody', {
  name: 'MuiTableBody',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'table-row-group'
});
const tablelvl2$1 = {
  variant: 'body'
};
const defaultComponent$2 = 'tbody';
const TableBody$1 = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function TableBody(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTableBody'
  });

  const {
    className,
    component = defaultComponent$2
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$4);

  const ownerState = _extends$a({}, props, {
    component
  });

  const classes = useUtilityClasses$4(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(Tablelvl2Context$1.Provider, {
    value: tablelvl2$1,
    children: /*#__PURE__*/jsxRuntime.exports.jsx(TableBodyRoot, _extends$a({
      className: clsx(classes.root, className),
      as: component,
      ref: ref,
      role: component === defaultComponent$2 ? null : 'rowgroup',
      ownerState: ownerState
    }, other))
  });
});
var MuiTableBody = TableBody$1;

function getTableCellUtilityClass(slot) {
  return generateUtilityClass('MuiTableCell', slot);
}
const tableCellClasses = generateUtilityClasses('MuiTableCell', ['root', 'head', 'body', 'footer', 'sizeSmall', 'sizeMedium', 'paddingCheckbox', 'paddingNone', 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'stickyHeader']);
var tableCellClasses$1 = tableCellClasses;

const _excluded$3 = ["align", "className", "component", "padding", "scope", "size", "sortDirection", "variant"];

const useUtilityClasses$3 = ownerState => {
  const {
    classes,
    variant,
    align,
    padding,
    size,
    stickyHeader
  } = ownerState;
  const slots = {
    root: ['root', variant, stickyHeader && 'stickyHeader', align !== 'inherit' && `align${capitalize$2(align)}`, padding !== 'normal' && `padding${capitalize$2(padding)}`, `size${capitalize$2(size)}`]
  };
  return composeClasses(slots, getTableCellUtilityClass, classes);
};

const TableCellRoot = styled$1('td', {
  name: 'MuiTableCell',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.variant], styles[`size${capitalize$2(ownerState.size)}`], ownerState.padding !== 'normal' && styles[`padding${capitalize$2(ownerState.padding)}`], ownerState.align !== 'inherit' && styles[`align${capitalize$2(ownerState.align)}`], ownerState.stickyHeader && styles.stickyHeader];
  }
})(({
  theme,
  ownerState
}) => _extends$a({}, theme.typography.body2, {
  display: 'table-cell',
  verticalAlign: 'inherit',
  // Workaround for a rendering bug with spanned columns in Chrome 62.0.
  // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
  borderBottom: `1px solid
    ${theme.palette.mode === 'light' ? lighten(alpha(theme.palette.divider, 1), 0.88) : darken(alpha(theme.palette.divider, 1), 0.68)}`,
  textAlign: 'left',
  padding: 16
}, ownerState.variant === 'head' && {
  color: theme.palette.text.primary,
  lineHeight: theme.typography.pxToRem(24),
  fontWeight: theme.typography.fontWeightMedium
}, ownerState.variant === 'body' && {
  color: theme.palette.text.primary
}, ownerState.variant === 'footer' && {
  color: theme.palette.text.secondary,
  lineHeight: theme.typography.pxToRem(21),
  fontSize: theme.typography.pxToRem(12)
}, ownerState.size === 'small' && {
  padding: '6px 16px',
  [`&.${tableCellClasses$1.paddingCheckbox}`]: {
    width: 24,
    // prevent the checkbox column from growing
    padding: '0 12px 0 16px',
    '& > *': {
      padding: 0
    }
  }
}, ownerState.padding === 'checkbox' && {
  width: 48,
  // prevent the checkbox column from growing
  padding: '0 0 0 4px'
}, ownerState.padding === 'none' && {
  padding: 0
}, ownerState.align === 'left' && {
  textAlign: 'left'
}, ownerState.align === 'center' && {
  textAlign: 'center'
}, ownerState.align === 'right' && {
  textAlign: 'right',
  flexDirection: 'row-reverse'
}, ownerState.align === 'justify' && {
  textAlign: 'justify'
}, ownerState.stickyHeader && {
  position: 'sticky',
  top: 0,
  zIndex: 2,
  backgroundColor: theme.palette.background.default
}));
/**
 * The component renders a `<th>` element when the parent context is a header
 * or otherwise a `<td>` element.
 */

const TableCell = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function TableCell(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTableCell'
  });

  const {
    align = 'inherit',
    className,
    component: componentProp,
    padding: paddingProp,
    scope: scopeProp,
    size: sizeProp,
    sortDirection,
    variant: variantProp
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$3);

  const table = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(TableContext$1);
  const tablelvl2 = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(Tablelvl2Context$1);
  const isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
  let component;

  if (componentProp) {
    component = componentProp;
  } else {
    component = isHeadCell ? 'th' : 'td';
  }

  let scope = scopeProp;

  if (!scope && isHeadCell) {
    scope = 'col';
  }

  const variant = variantProp || tablelvl2 && tablelvl2.variant;

  const ownerState = _extends$a({}, props, {
    align,
    component,
    padding: paddingProp || (table && table.padding ? table.padding : 'normal'),
    size: sizeProp || (table && table.size ? table.size : 'medium'),
    sortDirection,
    stickyHeader: variant === 'head' && table && table.stickyHeader,
    variant
  });

  const classes = useUtilityClasses$3(ownerState);
  let ariaSort = null;

  if (sortDirection) {
    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
  }

  return /*#__PURE__*/jsxRuntime.exports.jsx(TableCellRoot, _extends$a({
    as: component,
    ref: ref,
    className: clsx(classes.root, className),
    "aria-sort": ariaSort,
    scope: scope,
    ownerState: ownerState
  }, other));
});
var TableCell$1 = TableCell;

function getTableHeadUtilityClass(slot) {
  return generateUtilityClass('MuiTableHead', slot);
}
generateUtilityClasses('MuiTableHead', ['root']);

const _excluded$2 = ["className", "component"];

const useUtilityClasses$2 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return composeClasses(slots, getTableHeadUtilityClass, classes);
};

const TableHeadRoot = styled$1('thead', {
  name: 'MuiTableHead',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({
  display: 'table-header-group'
});
const tablelvl2 = {
  variant: 'head'
};
const defaultComponent$1 = 'thead';
const TableHead = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function TableHead(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTableHead'
  });

  const {
    className,
    component = defaultComponent$1
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$2);

  const ownerState = _extends$a({}, props, {
    component
  });

  const classes = useUtilityClasses$2(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(Tablelvl2Context$1.Provider, {
    value: tablelvl2,
    children: /*#__PURE__*/jsxRuntime.exports.jsx(TableHeadRoot, _extends$a({
      as: component,
      className: clsx(classes.root, className),
      ref: ref,
      role: component === defaultComponent$1 ? null : 'rowgroup',
      ownerState: ownerState
    }, other))
  });
});
var TableHead$1 = TableHead;

function getTableRowUtilityClass(slot) {
  return generateUtilityClass('MuiTableRow', slot);
}
const tableRowClasses = generateUtilityClasses('MuiTableRow', ['root', 'selected', 'hover', 'head', 'footer']);
var tableRowClasses$1 = tableRowClasses;

const _excluded$1 = ["className", "component", "hover", "selected"];

const useUtilityClasses$1 = ownerState => {
  const {
    classes,
    selected,
    hover,
    head,
    footer
  } = ownerState;
  const slots = {
    root: ['root', selected && 'selected', hover && 'hover', head && 'head', footer && 'footer']
  };
  return composeClasses(slots, getTableRowUtilityClass, classes);
};

const TableRowRoot = styled$1('tr', {
  name: 'MuiTableRow',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.head && styles.head, ownerState.footer && styles.footer];
  }
})(({
  theme
}) => ({
  color: 'inherit',
  display: 'table-row',
  verticalAlign: 'middle',
  // We disable the focus ring for mouse, touch and keyboard users.
  outline: 0,
  [`&.${tableRowClasses$1.hover}:hover`]: {
    backgroundColor: theme.palette.action.hover
  },
  [`&.${tableRowClasses$1.selected}`]: {
    backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
    '&:hover': {
      backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity)
    }
  }
}));
const defaultComponent = 'tr';
/**
 * Will automatically set dynamic row height
 * based on the material table element parent (head, body, etc).
 */

const TableRow = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function TableRow(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTableRow'
  });

  const {
    className,
    component = defaultComponent,
    hover = false,
    selected = false
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded$1);

  const tablelvl2 = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(Tablelvl2Context$1);

  const ownerState = _extends$a({}, props, {
    component,
    hover,
    selected,
    head: tablelvl2 && tablelvl2.variant === 'head',
    footer: tablelvl2 && tablelvl2.variant === 'footer'
  });

  const classes = useUtilityClasses$1(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsx(TableRowRoot, _extends$a({
    as: component,
    ref: ref,
    className: clsx(classes.root, className),
    role: component === defaultComponent ? null : 'row',
    ownerState: ownerState
  }, other));
});
var TableRow$1 = TableRow;

var ArrowDownwardIcon = createSvgIcon$1( /*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
}), 'ArrowDownward');

function getTableSortLabelUtilityClass(slot) {
  return generateUtilityClass('MuiTableSortLabel', slot);
}
const tableSortLabelClasses = generateUtilityClasses('MuiTableSortLabel', ['root', 'active', 'icon', 'iconDirectionDesc', 'iconDirectionAsc']);
var tableSortLabelClasses$1 = tableSortLabelClasses;

const _excluded = ["active", "children", "className", "direction", "hideSortIcon", "IconComponent"];

const useUtilityClasses = ownerState => {
  const {
    classes,
    direction,
    active
  } = ownerState;
  const slots = {
    root: ['root', active && 'active'],
    icon: ['icon', `iconDirection${capitalize$2(direction)}`]
  };
  return composeClasses(slots, getTableSortLabelUtilityClass, classes);
};

const TableSortLabelRoot = styled$1(ButtonBase$1, {
  name: 'MuiTableSortLabel',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, ownerState.active && styles.active];
  }
})(({
  theme
}) => ({
  cursor: 'pointer',
  display: 'inline-flex',
  justifyContent: 'flex-start',
  flexDirection: 'inherit',
  alignItems: 'center',
  '&:focus': {
    color: theme.palette.text.secondary
  },
  '&:hover': {
    color: theme.palette.text.secondary,
    [`& .${tableSortLabelClasses$1.icon}`]: {
      opacity: 0.5
    }
  },
  [`&.${tableSortLabelClasses$1.active}`]: {
    color: theme.palette.text.primary,
    [`& .${tableSortLabelClasses$1.icon}`]: {
      opacity: 1,
      color: theme.palette.text.secondary
    }
  }
}));
const TableSortLabelIcon = styled$1('span', {
  name: 'MuiTableSortLabel',
  slot: 'Icon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.icon, styles[`iconDirection${capitalize$2(ownerState.direction)}`]];
  }
})(({
  theme,
  ownerState
}) => _extends$a({
  fontSize: 18,
  marginRight: 4,
  marginLeft: 4,
  opacity: 0,
  transition: theme.transitions.create(['opacity', 'transform'], {
    duration: theme.transitions.duration.shorter
  }),
  userSelect: 'none'
}, ownerState.direction === 'desc' && {
  transform: 'rotate(0deg)'
}, ownerState.direction === 'asc' && {
  transform: 'rotate(180deg)'
}));
/**
 * A button based label for placing inside `TableCell` for column sorting.
 */

const TableSortLabel = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function TableSortLabel(inProps, ref) {
  const props = useThemeProps({
    props: inProps,
    name: 'MuiTableSortLabel'
  });

  const {
    active = false,
    children,
    className,
    direction = 'asc',
    hideSortIcon = false,
    IconComponent = ArrowDownwardIcon
  } = props,
        other = _objectWithoutPropertiesLoose$6(props, _excluded);

  const ownerState = _extends$a({}, props, {
    active,
    direction,
    hideSortIcon,
    IconComponent
  });

  const classes = useUtilityClasses(ownerState);
  return /*#__PURE__*/jsxRuntime.exports.jsxs(TableSortLabelRoot, _extends$a({
    className: clsx(classes.root, className),
    component: "span",
    disableRipple: true,
    ownerState: ownerState,
    ref: ref
  }, other, {
    children: [children, hideSortIcon && !active ? null : /*#__PURE__*/jsxRuntime.exports.jsx(TableSortLabelIcon, {
      as: IconComponent,
      className: clsx(classes.icon),
      ownerState: ownerState
    })]
  }));
});
var TableSortLabel$1 = TableSortLabel;

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

var COMMON_MIME_TYPES = new Map([
    ['avi', 'video/avi'],
    ['gif', 'image/gif'],
    ['ico', 'image/x-icon'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['mp4', 'video/mp4'],
    ['pdf', 'application/pdf'],
    ['png', 'image/png'],
    ['zip', 'application/zip'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}

var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, isDragEvt(evt) && evt.dataTransfer
                    ? getDataTransferFiles(evt.dataTransfer, evt.type)
                    : getInputFiles(evt)];
        });
    });
}
function isDragEvt(value) {
    return !!value.dataTransfer;
}
function getInputFiles(evt) {
    var files = isInput(evt.target)
        ? evt.target.files
            ? fromList(evt.target.files)
            : []
        : [];
    return files.map(function (file) { return toFileWithPath(file); });
}
function isInput(value) {
    return value !== null;
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spread(acc, (Array.isArray(files) ? flatten(files) : [files])); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject(item + " is not a File");
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}

var es = {};

es.__esModule = true;

var _default$6 = es.default = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');
    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

var FILE_INVALID_TYPE = 'file-invalid-type';
var FILE_TOO_LARGE = 'file-too-large';
var FILE_TOO_SMALL = 'file-too-small';
var TOO_MANY_FILES = 'too-many-files'; // File Errors

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(', ')) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " bytes")
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " bytes")
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: 'Too many files'
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === 'application/x-moz-file' || _default$6(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}

function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray$1(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    return accepted && sizeMatch;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === 'function') {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== 'undefined') {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty$1(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$2(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$2(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties(_ref, ["children"]);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties(_useDropzone, ["open"]);

  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Fragment, null, children(_objectSpread(_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = 'Dropzone'; // Add default props for react-docgen

var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes.func,

  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes.func,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes.func,

  /**
   * Custom validation function 
   * @param {File} file
   * @returns {FileError|FileError[]}
   */
  validator: PropTypes.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {string|string[]} [props.accept] Set accepted file types.
 * See https://github.com/okonet/attr-accept for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all.
 * See: https://github.com/react-dropzone/react-dropzone/issues/276
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 *
 * @returns {DropzoneState}
 */

function useDropzone() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$options = _objectSpread(_objectSpread({}, defaultProps), options),
      accept = _defaultProps$options.accept,
      disabled = _defaultProps$options.disabled,
      getFilesFromEvent = _defaultProps$options.getFilesFromEvent,
      maxSize = _defaultProps$options.maxSize,
      minSize = _defaultProps$options.minSize,
      multiple = _defaultProps$options.multiple,
      maxFiles = _defaultProps$options.maxFiles,
      onDragEnter = _defaultProps$options.onDragEnter,
      onDragLeave = _defaultProps$options.onDragLeave,
      onDragOver = _defaultProps$options.onDragOver,
      onDrop = _defaultProps$options.onDrop,
      onDropAccepted = _defaultProps$options.onDropAccepted,
      onDropRejected = _defaultProps$options.onDropRejected,
      onFileDialogCancel = _defaultProps$options.onFileDialogCancel,
      preventDropOnDocument = _defaultProps$options.preventDropOnDocument,
      noClick = _defaultProps$options.noClick,
      noKeyboard = _defaultProps$options.noKeyboard,
      noDrag = _defaultProps$options.noDrag,
      noDragEventsBubbling = _defaultProps$options.noDragEventsBubbling,
      validator = _defaultProps$options.validator;

  var rootRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  var inputRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);

  var _useReducer = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive,
      draggedFiles = state.draggedFiles; // Fn for opening the file dialog programmatically

  var openFileDialog = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function () {
    if (inputRef.current) {
      dispatch({
        type: 'openDialog'
      });
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch]); // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: 'closeDialog'
            });

            if (typeof onFileDialogCancel === 'function') {
              onFileDialogCancel();
            }
          }
        }
      }, 300);
    }
  };

  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(function () {
    window.addEventListener('focus', onWindowFocus, false);
    return function () {
      window.removeEventListener('focus', onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancel]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, inputRef]); // Update focus state for the dropzone

  var onFocusCb = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function () {
    dispatch({
      type: 'focus'
    });
  }, []);
  var onBlurCb = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function () {
    dispatch({
      type: 'blur'
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [inputRef, noClick]);
  var dragTargetsRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener('dragover', onDocumentDragOver, false);
      document.addEventListener('drop', onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener('dragover', onDocumentDragOver);
        document.removeEventListener('drop', onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (draggedFiles) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        dispatch({
          draggedFiles: draggedFiles,
          isDragActive: true,
          type: 'setDraggedFiles'
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = 'copy';
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      isDragActive: false,
      type: 'setDraggedFiles',
      draggedFiles: []
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var onDropCb = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        var acceptedFiles = [];
        var fileRejections = [];
        files.forEach(function (file) {
          var _fileAccepted = fileAccepted(file, accept),
              _fileAccepted2 = _slicedToArray(_fileAccepted, 2),
              accepted = _fileAccepted2[0],
              acceptError = _fileAccepted2[1];

          var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
              _fileMatchSize2 = _slicedToArray(_fileMatchSize, 2),
              sizeMatch = _fileMatchSize2[0],
              sizeError = _fileMatchSize2[1];

          var customErrors = validator ? validator(file) : null;

          if (accepted && sizeMatch && !customErrors) {
            acceptedFiles.push(file);
          } else {
            var errors = [acceptError, sizeError];

            if (customErrors) {
              errors = errors.concat(customErrors);
            }

            fileRejections.push({
              file: file,
              errors: errors.filter(function (e) {
                return e;
              })
            });
          }
        });

        if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
          // Reject everything and empty accepted files
          acceptedFiles.forEach(function (file) {
            fileRejections.push({
              file: file,
              errors: [TOO_MANY_FILES_REJECTION]
            });
          });
          acceptedFiles.splice(0);
        }

        dispatch({
          acceptedFiles: acceptedFiles,
          fileRejections: fileRejections,
          type: 'setFiles'
        });

        if (onDrop) {
          onDrop(acceptedFiles, fileRejections, event);
        }

        if (fileRejections.length > 0 && onDropRejected) {
          onDropRejected(fileRejections, event);
        }

        if (acceptedFiles.length > 0 && onDropAccepted) {
          onDropAccepted(acceptedFiles, event);
        }
      });
    }

    dispatch({
      type: 'reset'
    });
  }, [multiple, accept, minSize, maxSize, maxFiles, getFilesFromEvent, onDrop, onDropAccepted, onDropRejected, noDragEventsBubbling, validator]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties(_ref2, ["refKey", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"]);

      return _objectSpread(_objectSpread(_defineProperty$1({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb))
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties(_ref3, ["refKey", "onChange", "onClick"]);

      var inputProps = _defineProperty$1({
        accept: accept,
        multiple: multiple,
        type: 'file',
        style: {
          display: 'none'
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        autoComplete: 'off',
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread(_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isDragAccept = fileCount > 0 && allFilesAccepted({
    files: draggedFiles,
    accept: accept,
    minSize: minSize,
    maxSize: maxSize,
    multiple: multiple,
    maxFiles: maxFiles
  });
  var isDragReject = fileCount > 0 && !isDragAccept;
  return _objectSpread(_objectSpread({}, state), {}, {
    isDragAccept: isDragAccept,
    isDragReject: isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case 'focus':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: true
      });

    case 'blur':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: false
      });

    case 'openDialog':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: true
      });

    case 'closeDialog':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });

    case 'setDraggedFiles':
      /* eslint no-case-declarations: 0 */
      var isDragActive = action.isDragActive,
          draggedFiles = action.draggedFiles;
      return _objectSpread(_objectSpread({}, state), {}, {
        draggedFiles: draggedFiles,
        isDragActive: isDragActive
      });

    case 'setFiles':
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case 'reset':
      return _objectSpread({}, initialState);

    default:
      return state;
  }
}

var reactTable = {exports: {}};

var reactTable_production_min = {exports: {}};

(function (module, exports) {
!function(e,t){t(exports,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports);}(commonjsGlobal,(function(e,t){function n(e,t,n,o,r,i,u){try{var l=e[i](u),s=l.value;}catch(e){return void n(e)}l.done?t(s):Promise.resolve(s).then(o,r);}function o(e){return function(){var t=this,o=arguments;return new Promise((function(r,i){var u=e.apply(t,o);function l(e){n(u,r,i,l,s,"next",e);}function s(e){n(u,r,i,l,s,"throw",e);}l(void 0);}))}}function r(){return (r=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var n=arguments[t];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(e[o]=n[o]);}return e}).apply(this,arguments)}function i(e,t){if(null==e)return {};var n,o,r={},i=Object.keys(e);for(o=0;o<i.length;o++)n=i[o],t.indexOf(n)>=0||(r[n]=e[n]);return r}function u(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var n=e[Symbol.toPrimitive];if(void 0!==n){var o=n.call(e,t||"default");if("object"!=typeof o)return o;throw new TypeError("@@toPrimitive must return a primitive value.")}return ("string"===t?String:Number)(e)}(e,"string");return "symbol"==typeof t?t:String(t)}t=t&&Object.prototype.hasOwnProperty.call(t,"default")?t.default:t;var l={init:"init"},s=function(e){var t=e.value;return void 0===t?"":t},a=function(){return t.createElement(t.Fragment,null," ")},c={Cell:s,width:150,minWidth:0,maxWidth:Number.MAX_SAFE_INTEGER};function d(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return t.reduce((function(e,t){var n=t.style,o=t.className;return e=r({},e,{},i(t,["style","className"])),n&&(e.style=e.style?r({},e.style||{},{},n||{}):n),o&&(e.className=e.className?e.className+" "+o:o),""===e.className&&delete e.className,e}),{})}var f=function(e,t){return void 0===t&&(t={}),function(n){return void 0===n&&(n={}),[].concat(e,[n]).reduce((function(e,o){return function e(t,n,o){return "function"==typeof n?e({},n(t,o)):Array.isArray(n)?d.apply(void 0,[t].concat(n)):d(t,n)}(e,o,r({},t,{userProps:n}))}),{})}},p=function(e,t,n,o){return void 0===n&&(n={}),e.reduce((function(e,t){return t(e,n)}),t)},g=function(e,t,n){return void 0===n&&(n={}),e.forEach((function(e){e(t,n);}))};function v(e,t,n,o){e.findIndex((function(e){return e.pluginName===n}));t.forEach((function(t){e.findIndex((function(e){return e.pluginName===t}));}));}function m(e,t){return "function"==typeof e?e(t):e}function h(e){var n=t.useRef();return n.current=e,t.useCallback((function(){return n.current}),[])}var y="undefined"!=typeof document?t.useLayoutEffect:t.useEffect;function w(e,n){var o=t.useRef(!1);y((function(){o.current&&e(),o.current=!0;}),n);}function R(e,t,n){return void 0===n&&(n={}),function(o,i){void 0===i&&(i={});var u="string"==typeof o?t[o]:o;if(void 0===u)throw console.info(t),new Error("Renderer Error ☝️");return b(u,r({},e,{column:t},n,{},i))}}function b(e,n){return function(e){return "function"==typeof e&&((t=Object.getPrototypeOf(e)).prototype&&t.prototype.isReactComponent);var t;}(o=e)||"function"==typeof o||function(e){return "object"==typeof e&&"symbol"==typeof e.$$typeof&&["react.memo","react.forward_ref"].includes(e.$$typeof.description)}(o)?t.createElement(e,n):e;var o;}function S(e,t,n){return void 0===n&&(n=0),e.map((function(e){return x(e=r({},e,{parent:t,depth:n})),e.columns&&(e.columns=S(e.columns,e,n+1)),e}))}function C(e){return G(e,"columns")}function x(e){var t=e.id,n=e.accessor,o=e.Header;if("string"==typeof n){t=t||n;var r=n.split(".");n=function(e){return function(e,t,n){if(!t)return e;var o,r="function"==typeof t?t:JSON.stringify(t),i=E.get(r)||function(){var e=function(e){return function e(t,n){void 0===n&&(n=[]);if(Array.isArray(t))for(var o=0;o<t.length;o+=1)e(t[o],n);else n.push(t);return n}(e).map((function(e){return String(e).replace(".","_")})).join(".").replace(W,".").replace(O,"").split(".")}(t);return E.set(r,e),e}();try{o=i.reduce((function(e,t){return e[t]}),e);}catch(e){}return void 0!==o?o:n}(e,r)};}if(!t&&"string"==typeof o&&o&&(t=o),!t&&e.columns)throw console.error(e),new Error('A column ID (or unique "Header" value) is required!');if(!t)throw console.error(e),new Error("A column ID (or string accessor) is required!");return Object.assign(e,{id:t,accessor:n}),e}function P(e,t){if(!t)throw new Error;return Object.assign(e,r({Header:a,Footer:a},c,{},t,{},e)),Object.assign(e,{originalWidth:e.width}),e}function B(e,t,n){void 0===n&&(n=function(){return {}});for(var o=[],i=e,u=0,l=function(){return u++},s=function(){var e={headers:[]},u=[],s=i.some((function(e){return e.parent}));i.forEach((function(o){var i,a=[].concat(u).reverse()[0];if(s){if(o.parent)i=r({},o.parent,{originalId:o.parent.id,id:o.parent.id+"_"+l(),headers:[o]},n(o));else i=P(r({originalId:o.id+"_placeholder",id:o.id+"_placeholder_"+l(),placeholderOf:o,headers:[o]},n(o)),t);a&&a.originalId===i.originalId?a.headers.push(o):u.push(i);}e.headers.push(o);})),o.push(e),i=u;};i.length;)s();return o.reverse()}var E=new Map;function I(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];for(var o=0;o<t.length;o+=1)if(void 0!==t[o])return t[o]}function F(e){if("function"==typeof e)return e}function G(e,t){var n=[];return function e(o){o.forEach((function(o){o[t]?e(o[t]):n.push(o);}));}(e),n}function A(e,t){var n=t.manualExpandedKey,o=t.expanded,r=t.expandSubRows,i=void 0===r||r,u=[];return e.forEach((function(e){return function e(t,r){void 0===r&&(r=!0),t.isExpanded=t.original&&t.original[n]||o[t.id],t.canExpand=t.subRows&&!!t.subRows.length,r&&u.push(t),t.subRows&&t.subRows.length&&t.isExpanded&&t.subRows.forEach((function(t){return e(t,i)}));}(e)})),u}function k(e,t,n){return F(e)||t[e]||n[e]||n.text}function H(e,t,n){return e?e(t,n):void 0===t}function T(){throw new Error("React-Table: You have not called prepareRow(row) one or more rows you are attempting to render.")}var z=null;var W=/\[/g,O=/\]/g;var M=function(e){return r({role:"table"},e)},j=function(e){return r({role:"rowgroup"},e)},N=function(e,t){var n=t.column;return r({key:"header_"+n.id,colSpan:n.totalVisibleHeaderCount,role:"columnheader"},e)},L=function(e,t){var n=t.column;return r({key:"footer_"+n.id,colSpan:n.totalVisibleHeaderCount},e)},D=function(e,t){return r({key:"headerGroup_"+t.index,role:"row"},e)},V=function(e,t){return r({key:"footerGroup_"+t.index},e)},_=function(e,t){return r({key:"row_"+t.row.id,role:"row"},e)},X=function(e,t){var n=t.cell;return r({key:"cell_"+n.row.id+"_"+n.column.id,role:"cell"},e)};function q(){return {useOptions:[],stateReducers:[],useControlledState:[],columns:[],columnsDeps:[],allColumns:[],allColumnsDeps:[],accessValue:[],materializedColumns:[],materializedColumnsDeps:[],useInstanceAfterData:[],visibleColumns:[],visibleColumnsDeps:[],headerGroups:[],headerGroupsDeps:[],useInstanceBeforeDimensions:[],useInstance:[],prepareRow:[],getTableProps:[M],getTableBodyProps:[j],getHeaderGroupProps:[D],getFooterGroupProps:[V],getHeaderProps:[N],getFooterProps:[L],getRowProps:[_],getCellProps:[X],useFinalInstance:[]}}l.resetHiddenColumns="resetHiddenColumns",l.toggleHideColumn="toggleHideColumn",l.setHiddenColumns="setHiddenColumns",l.toggleHideAllColumns="toggleHideAllColumns";var K=function(e){e.getToggleHiddenProps=[U],e.getToggleHideAllColumnsProps=[$],e.stateReducers.push(J),e.useInstanceBeforeDimensions.push(Y),e.headerGroupsDeps.push((function(e,t){var n=t.instance;return [].concat(e,[n.state.hiddenColumns])})),e.useInstance.push(Q);};K.pluginName="useColumnVisibility";var U=function(e,t){var n=t.column;return [e,{onChange:function(e){n.toggleHidden(!e.target.checked);},style:{cursor:"pointer"},checked:n.isVisible,title:"Toggle Column Visible"}]},$=function(e,t){var n=t.instance;return [e,{onChange:function(e){n.toggleHideAllColumns(!e.target.checked);},style:{cursor:"pointer"},checked:!n.allColumnsHidden&&!n.state.hiddenColumns.length,title:"Toggle All Columns Hidden",indeterminate:!n.allColumnsHidden&&n.state.hiddenColumns.length}]};function J(e,t,n,o){if(t.type===l.init)return r({hiddenColumns:[]},e);if(t.type===l.resetHiddenColumns)return r({},e,{hiddenColumns:o.initialState.hiddenColumns||[]});if(t.type===l.toggleHideColumn){var i=(void 0!==t.value?t.value:!e.hiddenColumns.includes(t.columnId))?[].concat(e.hiddenColumns,[t.columnId]):e.hiddenColumns.filter((function(e){return e!==t.columnId}));return r({},e,{hiddenColumns:i})}return t.type===l.setHiddenColumns?r({},e,{hiddenColumns:m(t.value,e.hiddenColumns)}):t.type===l.toggleHideAllColumns?r({},e,{hiddenColumns:(void 0!==t.value?t.value:!e.hiddenColumns.length)?o.allColumns.map((function(e){return e.id})):[]}):void 0}function Y(e){var n=e.headers,o=e.state.hiddenColumns;t.useRef(!1).current;var r=0;n.forEach((function(e){return r+=function e(t,n){t.isVisible=n&&!o.includes(t.id);var r=0;return t.headers&&t.headers.length?t.headers.forEach((function(n){return r+=e(n,t.isVisible)})):r=t.isVisible?1:0,t.totalVisibleHeaderCount=r,r}(e,!0)}));}function Q(e){var n=e.columns,o=e.flatHeaders,r=e.dispatch,i=e.allColumns,u=e.getHooks,s=e.state.hiddenColumns,a=e.autoResetHiddenColumns,c=void 0===a||a,d=h(e),p=i.length===s.length,g=t.useCallback((function(e,t){return r({type:l.toggleHideColumn,columnId:e,value:t})}),[r]),v=t.useCallback((function(e){return r({type:l.setHiddenColumns,value:e})}),[r]),m=t.useCallback((function(e){return r({type:l.toggleHideAllColumns,value:e})}),[r]),y=f(u().getToggleHideAllColumnsProps,{instance:d()});o.forEach((function(e){e.toggleHidden=function(t){r({type:l.toggleHideColumn,columnId:e.id,value:t});},e.getToggleHiddenProps=f(u().getToggleHiddenProps,{instance:d(),column:e});}));var R=h(c);w((function(){R()&&r({type:l.resetHiddenColumns});}),[r,n]),Object.assign(e,{allColumnsHidden:p,toggleHideColumn:g,setHiddenColumns:v,toggleHideAllColumns:m,getToggleHideAllColumnsProps:y});}var Z={},ee={},te=function(e,t,n){return e},ne=function(e,t){return e.subRows||[]},oe=function(e,t,n){return ""+(n?[n.id,t].join("."):t)},re=function(e){return e};function ie(e){var t=e.initialState,n=void 0===t?Z:t,o=e.defaultColumn,u=void 0===o?ee:o,l=e.getSubRows,s=void 0===l?ne:l,a=e.getRowId,c=void 0===a?oe:a,d=e.stateReducer,f=void 0===d?te:d,p=e.useControlledState,g=void 0===p?re:p;return r({},i(e,["initialState","defaultColumn","getSubRows","getRowId","stateReducer","useControlledState"]),{initialState:n,defaultColumn:u,getSubRows:s,getRowId:c,stateReducer:f,useControlledState:g})}function ue(e,t){void 0===t&&(t=0);var n=0,o=0,r=0,i=0;return e.forEach((function(e){var u=e.headers;if(e.totalLeft=t,u&&u.length){var l=ue(u,t),s=l[0],a=l[1],c=l[2],d=l[3];e.totalMinWidth=s,e.totalWidth=a,e.totalMaxWidth=c,e.totalFlexWidth=d;}else e.totalMinWidth=e.minWidth,e.totalWidth=Math.min(Math.max(e.minWidth,e.width),e.maxWidth),e.totalMaxWidth=e.maxWidth,e.totalFlexWidth=e.canResize?e.totalWidth:0;e.isVisible&&(t+=e.totalWidth,n+=e.totalMinWidth,o+=e.totalWidth,r+=e.totalMaxWidth,i+=e.totalFlexWidth);})),[n,o,r,i]}function le(e){var t=e.data,n=e.rows,o=e.flatRows,r=e.rowsById,i=e.column,u=e.getRowId,l=e.getSubRows,s=e.accessValueHooks,a=e.getInstance;t.forEach((function(e,c){return function e(n,c,d,f,g){void 0===d&&(d=0);var v=n,m=u(n,c,f),h=r[m];if(h)h.subRows&&h.originalSubRows.forEach((function(t,n){return e(t,n,d+1,h)}));else if((h={id:m,original:v,index:c,depth:d,cells:[{}]}).cells.map=T,h.cells.filter=T,h.cells.forEach=T,h.cells[0].getCellProps=T,h.values={},g.push(h),o.push(h),r[m]=h,h.originalSubRows=l(n,c),h.originalSubRows){var y=[];h.originalSubRows.forEach((function(t,n){return e(t,n,d+1,h,y)})),h.subRows=y;}i.accessor&&(h.values[i.id]=i.accessor(n,c,h,g,t)),h.values[i.id]=p(s,h.values[i.id],{row:h,column:i,instance:a()});}(e,c,0,void 0,n)}));}l.resetExpanded="resetExpanded",l.toggleRowExpanded="toggleRowExpanded",l.toggleAllRowsExpanded="toggleAllRowsExpanded";var se=function(e){e.getToggleAllRowsExpandedProps=[ae],e.getToggleRowExpandedProps=[ce],e.stateReducers.push(de),e.useInstance.push(fe),e.prepareRow.push(pe);};se.pluginName="useExpanded";var ae=function(e,t){var n=t.instance;return [e,{onClick:function(e){n.toggleAllRowsExpanded();},style:{cursor:"pointer"},title:"Toggle All Rows Expanded"}]},ce=function(e,t){var n=t.row;return [e,{onClick:function(){n.toggleRowExpanded();},style:{cursor:"pointer"},title:"Toggle Row Expanded"}]};function de(e,t,n,o){if(t.type===l.init)return r({expanded:{}},e);if(t.type===l.resetExpanded)return r({},e,{expanded:o.initialState.expanded||{}});if(t.type===l.toggleAllRowsExpanded){var s=t.value,a=o.isAllRowsExpanded,c=o.rowsById;if(void 0!==s?s:!a){var d={};return Object.keys(c).forEach((function(e){d[e]=!0;})),r({},e,{expanded:d})}return r({},e,{expanded:{}})}if(t.type===l.toggleRowExpanded){var f,p=t.id,g=t.value,v=e.expanded[p],m=void 0!==g?g:!v;if(!v&&m)return r({},e,{expanded:r({},e.expanded,(f={},f[p]=!0,f))});if(v&&!m){var h=e.expanded;h[p];return r({},e,{expanded:i(h,[p].map(u))})}return e}}function fe(e){var n=e.data,o=e.rows,r=e.rowsById,i=e.manualExpandedKey,u=void 0===i?"expanded":i,s=e.paginateExpandedRows,a=void 0===s||s,c=e.expandSubRows,d=void 0===c||c,p=e.autoResetExpanded,g=void 0===p||p,m=e.getHooks,y=e.plugins,R=e.state.expanded,b=e.dispatch;v(y,["useSortBy","useGroupBy","usePivotColumns","useGlobalFilter"],"useExpanded");var S=h(g),C=Boolean(Object.keys(r).length&&Object.keys(R).length);C&&Object.keys(r).some((function(e){return !R[e]}))&&(C=!1),w((function(){S()&&b({type:l.resetExpanded});}),[b,n]);var x=t.useCallback((function(e,t){b({type:l.toggleRowExpanded,id:e,value:t});}),[b]),P=t.useCallback((function(e){return b({type:l.toggleAllRowsExpanded,value:e})}),[b]),B=t.useMemo((function(){return a?A(o,{manualExpandedKey:u,expanded:R,expandSubRows:d}):o}),[a,o,u,R,d]),E=t.useMemo((function(){return function(e){var t=0;return Object.keys(e).forEach((function(e){var n=e.split(".");t=Math.max(t,n.length);})),t}(R)}),[R]),I=h(e),F=f(m().getToggleAllRowsExpandedProps,{instance:I()});Object.assign(e,{preExpandedRows:o,expandedRows:B,rows:B,expandedDepth:E,isAllRowsExpanded:C,toggleRowExpanded:x,toggleAllRowsExpanded:P,getToggleAllRowsExpandedProps:F});}function pe(e,t){var n=t.instance.getHooks,o=t.instance;e.toggleRowExpanded=function(t){return o.toggleRowExpanded(e.id,t)},e.getToggleRowExpandedProps=f(n().getToggleRowExpandedProps,{instance:o,row:e});}var ge=function(e,t,n){return e=e.filter((function(e){return t.some((function(t){var o=e.values[t];return String(o).toLowerCase().includes(String(n).toLowerCase())}))}))};ge.autoRemove=function(e){return !e};var ve=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return void 0===o||String(o).toLowerCase()===String(n).toLowerCase()}))}))};ve.autoRemove=function(e){return !e};var me=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return void 0===o||String(o)===String(n)}))}))};me.autoRemove=function(e){return !e};var he=function(e,t,n){return e.filter((function(e){return t.some((function(t){return e.values[t].includes(n)}))}))};he.autoRemove=function(e){return !e||!e.length};var ye=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return o&&o.length&&n.every((function(e){return o.includes(e)}))}))}))};ye.autoRemove=function(e){return !e||!e.length};var we=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return o&&o.length&&n.some((function(e){return o.includes(e)}))}))}))};we.autoRemove=function(e){return !e||!e.length};var Re=function(e,t,n){return e.filter((function(e){return t.some((function(t){var o=e.values[t];return n.includes(o)}))}))};Re.autoRemove=function(e){return !e||!e.length};var be=function(e,t,n){return e.filter((function(e){return t.some((function(t){return e.values[t]===n}))}))};be.autoRemove=function(e){return void 0===e};var Se=function(e,t,n){return e.filter((function(e){return t.some((function(t){return e.values[t]==n}))}))};Se.autoRemove=function(e){return null==e};var Ce=function(e,t,n){var o=n||[],r=o[0],i=o[1];if((r="number"==typeof r?r:-1/0)>(i="number"==typeof i?i:1/0)){var u=r;r=i,i=u;}return e.filter((function(e){return t.some((function(t){var n=e.values[t];return n>=r&&n<=i}))}))};Ce.autoRemove=function(e){return !e||"number"!=typeof e[0]&&"number"!=typeof e[1]};var xe=Object.freeze({__proto__:null,text:ge,exactText:ve,exactTextCase:me,includes:he,includesAll:ye,includesSome:we,includesValue:Re,exact:be,equals:Se,between:Ce});l.resetFilters="resetFilters",l.setFilter="setFilter",l.setAllFilters="setAllFilters";var Pe=function(e){e.stateReducers.push(Be),e.useInstance.push(Ee);};function Be(e,t,n,o){if(t.type===l.init)return r({filters:[]},e);if(t.type===l.resetFilters)return r({},e,{filters:o.initialState.filters||[]});if(t.type===l.setFilter){var i=t.columnId,u=t.filterValue,s=o.allColumns,a=o.filterTypes,c=s.find((function(e){return e.id===i}));if(!c)throw new Error("React-Table: Could not find a column with id: "+i);var d=k(c.filter,a||{},xe),f=e.filters.find((function(e){return e.id===i})),p=m(u,f&&f.value);return H(d.autoRemove,p,c)?r({},e,{filters:e.filters.filter((function(e){return e.id!==i}))}):r({},e,f?{filters:e.filters.map((function(e){return e.id===i?{id:i,value:p}:e}))}:{filters:[].concat(e.filters,[{id:i,value:p}])})}if(t.type===l.setAllFilters){var g=t.filters,v=o.allColumns,h=o.filterTypes;return r({},e,{filters:m(g,e.filters).filter((function(e){var t=v.find((function(t){return t.id===e.id}));return !H(k(t.filter,h||{},xe).autoRemove,e.value,t)}))})}}function Ee(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.rowsById,u=e.allColumns,s=e.filterTypes,a=e.manualFilters,c=e.defaultCanFilter,d=void 0!==c&&c,f=e.disableFilters,p=e.state.filters,g=e.dispatch,v=e.autoResetFilters,m=void 0===v||v,y=t.useCallback((function(e,t){g({type:l.setFilter,columnId:e,filterValue:t});}),[g]),R=t.useCallback((function(e){g({type:l.setAllFilters,filters:e});}),[g]);u.forEach((function(e){var t=e.id,n=e.accessor,o=e.defaultCanFilter,r=e.disableFilters;e.canFilter=n?I(!0!==r&&void 0,!0!==f&&void 0,!0):I(o,d,!1),e.setFilter=function(t){return y(e.id,t)};var i=p.find((function(e){return e.id===t}));e.filterValue=i&&i.value;}));var b=t.useMemo((function(){if(a||!p.length)return [o,r,i];var e=[],t={};return [function n(o,r){void 0===r&&(r=0);var i=o;return (i=p.reduce((function(e,t){var n=t.id,o=t.value,i=u.find((function(e){return e.id===n}));if(!i)return e;0===r&&(i.preFilteredRows=e);var l=k(i.filter,s||{},xe);return l?(i.filteredRows=l(e,[n],o),i.filteredRows):(console.warn("Could not find a valid 'column.filter' for column with the ID: "+i.id+"."),e)}),o)).forEach((function(o){e.push(o),t[o.id]=o,o.subRows&&(o.subRows=o.subRows&&o.subRows.length>0?n(o.subRows,r+1):o.subRows);})),i}(o),e,t]}),[a,p,o,r,i,u,s]),S=b[0],C=b[1],x=b[2];t.useMemo((function(){u.filter((function(e){return !p.find((function(t){return t.id===e.id}))})).forEach((function(e){e.preFilteredRows=S,e.filteredRows=S;}));}),[S,p,u]);var P=h(m);w((function(){P()&&g({type:l.resetFilters});}),[g,a?null:n]),Object.assign(e,{preFilteredRows:o,preFilteredFlatRows:r,preFilteredRowsById:i,filteredRows:S,filteredFlatRows:C,filteredRowsById:x,rows:S,flatRows:C,rowsById:x,setFilter:y,setAllFilters:R});}Pe.pluginName="useFilters",l.resetGlobalFilter="resetGlobalFilter",l.setGlobalFilter="setGlobalFilter";var Ie=function(e){e.stateReducers.push(Fe),e.useInstance.push(Ge);};function Fe(e,t,n,o){if(t.type===l.resetGlobalFilter)return r({},e,{globalFilter:o.initialState.globalFilter||void 0});if(t.type===l.setGlobalFilter){var u=t.filterValue,s=o.userFilterTypes,a=k(o.globalFilter,s||{},xe),c=m(u,e.globalFilter);if(H(a.autoRemove,c)){e.globalFilter;return i(e,["globalFilter"])}return r({},e,{globalFilter:c})}}function Ge(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.rowsById,u=e.allColumns,s=e.filterTypes,a=e.globalFilter,c=e.manualGlobalFilter,d=e.state.globalFilter,f=e.dispatch,p=e.autoResetGlobalFilter,g=void 0===p||p,v=e.disableGlobalFilter,m=t.useCallback((function(e){f({type:l.setGlobalFilter,filterValue:e});}),[f]),y=t.useMemo((function(){if(c||void 0===d)return [o,r,i];var e=[],t={},n=k(a,s||{},xe);if(!n)return console.warn("Could not find a valid 'globalFilter' option."),o;u.forEach((function(e){var t=e.disableGlobalFilter;e.canFilter=I(!0!==t&&void 0,!0!==v&&void 0,!0);}));var l=u.filter((function(e){return !0===e.canFilter}));return [function o(r){return (r=n(r,l.map((function(e){return e.id})),d)).forEach((function(n){e.push(n),t[n.id]=n,n.subRows=n.subRows&&n.subRows.length?o(n.subRows):n.subRows;})),r}(o),e,t]}),[c,d,a,s,u,o,r,i,v]),R=y[0],b=y[1],S=y[2],C=h(g);w((function(){C()&&f({type:l.resetGlobalFilter});}),[f,c?null:n]),Object.assign(e,{preGlobalFilteredRows:o,preGlobalFilteredFlatRows:r,preGlobalFilteredRowsById:i,globalFilteredRows:R,globalFilteredFlatRows:b,globalFilteredRowsById:S,rows:R,flatRows:b,rowsById:S,setGlobalFilter:m,disableGlobalFilter:v});}function Ae(e,t){return t.reduce((function(e,t){return e+("number"==typeof t?t:0)}),0)}Ie.pluginName="useGlobalFilter";var ke=Object.freeze({__proto__:null,sum:Ae,min:function(e){var t=e[0]||0;return e.forEach((function(e){"number"==typeof e&&(t=Math.min(t,e));})),t},max:function(e){var t=e[0]||0;return e.forEach((function(e){"number"==typeof e&&(t=Math.max(t,e));})),t},minMax:function(e){var t=e[0]||0,n=e[0]||0;return e.forEach((function(e){"number"==typeof e&&(t=Math.min(t,e),n=Math.max(n,e));})),t+".."+n},average:function(e){return Ae(0,e)/e.length},median:function(e){if(!e.length)return null;var t=Math.floor(e.length/2),n=[].concat(e).sort((function(e,t){return e-t}));return e.length%2!=0?n[t]:(n[t-1]+n[t])/2},unique:function(e){return Array.from(new Set(e).values())},uniqueCount:function(e){return new Set(e).size},count:function(e){return e.length}}),He=[],Te={};l.resetGroupBy="resetGroupBy",l.setGroupBy="setGroupBy",l.toggleGroupBy="toggleGroupBy";var ze=function(e){e.getGroupByToggleProps=[We],e.stateReducers.push(Oe),e.visibleColumnsDeps.push((function(e,t){var n=t.instance;return [].concat(e,[n.state.groupBy])})),e.visibleColumns.push(Me),e.useInstance.push(Ne),e.prepareRow.push(Le);};ze.pluginName="useGroupBy";var We=function(e,t){var n=t.header;return [e,{onClick:n.canGroupBy?function(e){e.persist(),n.toggleGroupBy();}:void 0,style:{cursor:n.canGroupBy?"pointer":void 0},title:"Toggle GroupBy"}]};function Oe(e,t,n,o){if(t.type===l.init)return r({groupBy:[]},e);if(t.type===l.resetGroupBy)return r({},e,{groupBy:o.initialState.groupBy||[]});if(t.type===l.setGroupBy)return r({},e,{groupBy:t.value});if(t.type===l.toggleGroupBy){var i=t.columnId,u=t.value,s=void 0!==u?u:!e.groupBy.includes(i);return r({},e,s?{groupBy:[].concat(e.groupBy,[i])}:{groupBy:e.groupBy.filter((function(e){return e!==i}))})}}function Me(e,t){var n=t.instance.state.groupBy,o=n.map((function(t){return e.find((function(e){return e.id===t}))})).filter(Boolean),r=e.filter((function(e){return !n.includes(e.id)}));return (e=[].concat(o,r)).forEach((function(e){e.isGrouped=n.includes(e.id),e.groupedIndex=n.indexOf(e.id);})),e}var je={};function Ne(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.rowsById,u=e.allColumns,s=e.flatHeaders,a=e.groupByFn,c=void 0===a?De:a,d=e.manualGroupBy,p=e.aggregations,g=void 0===p?je:p,m=e.plugins,y=e.state.groupBy,R=e.dispatch,b=e.autoResetGroupBy,S=void 0===b||b,C=e.disableGroupBy,x=e.defaultCanGroupBy,P=e.getHooks;v(m,["useColumnOrder","useFilters"],"useGroupBy");var B=h(e);u.forEach((function(t){var n=t.accessor,o=t.defaultGroupBy,r=t.disableGroupBy;t.canGroupBy=n?I(t.canGroupBy,!0!==r&&void 0,!0!==C&&void 0,!0):I(t.canGroupBy,o,x,!1),t.canGroupBy&&(t.toggleGroupBy=function(){return e.toggleGroupBy(t.id)}),t.Aggregated=t.Aggregated||t.Cell;}));var E=t.useCallback((function(e,t){R({type:l.toggleGroupBy,columnId:e,value:t});}),[R]),F=t.useCallback((function(e){R({type:l.setGroupBy,value:e});}),[R]);s.forEach((function(e){e.getGroupByToggleProps=f(P().getGroupByToggleProps,{instance:B(),header:e});}));var A=t.useMemo((function(){if(d||!y.length)return [o,r,i,He,Te,r,i];var e=y.filter((function(e){return u.find((function(t){return t.id===e}))})),t=[],n={},l=[],s={},a=[],f={},p=function o(r,i,d){if(void 0===i&&(i=0),i===e.length)return r;var p=e[i],v=c(r,p);return Object.entries(v).map((function(r,c){var v=r[0],m=r[1],h=p+":"+v,y=o(m,i+1,h=d?d+">"+h:h),w=i?G(m,"leafRows"):m,R=function(t,n,o){var r={};return u.forEach((function(i){if(e.includes(i.id))r[i.id]=n[0]?n[0].values[i.id]:null;else {var u="function"==typeof i.aggregate?i.aggregate:g[i.aggregate]||ke[i.aggregate];if(u){var l=n.map((function(e){return e.values[i.id]})),s=t.map((function(e){var t=e.values[i.id];if(!o&&i.aggregateValue){var n="function"==typeof i.aggregateValue?i.aggregateValue:g[i.aggregateValue]||ke[i.aggregateValue];if(!n)throw console.info({column:i}),new Error("React Table: Invalid column.aggregateValue option for column listed above");t=n(t,e,i);}return t}));r[i.id]=u(s,l);}else {if(i.aggregate)throw console.info({column:i}),new Error("React Table: Invalid column.aggregate option for column listed above");r[i.id]=null;}}})),r}(w,m,i),b={id:h,isGrouped:!0,groupByID:p,groupByVal:v,values:R,subRows:y,leafRows:w,depth:i,index:c};return y.forEach((function(e){t.push(e),n[e.id]=e,e.isGrouped?(l.push(e),s[e.id]=e):(a.push(e),f[e.id]=e);})),b}))}(o);return p.forEach((function(e){t.push(e),n[e.id]=e,e.isGrouped?(l.push(e),s[e.id]=e):(a.push(e),f[e.id]=e);})),[p,t,n,l,s,a,f]}),[d,y,o,r,i,u,g,c]),k=A[0],H=A[1],T=A[2],z=A[3],W=A[4],O=A[5],M=A[6],j=h(S);w((function(){j()&&R({type:l.resetGroupBy});}),[R,d?null:n]),Object.assign(e,{preGroupedRows:o,preGroupedFlatRow:r,preGroupedRowsById:i,groupedRows:k,groupedFlatRows:H,groupedRowsById:T,onlyGroupedFlatRows:z,onlyGroupedRowsById:W,nonGroupedFlatRows:O,nonGroupedRowsById:M,rows:k,flatRows:H,rowsById:T,toggleGroupBy:E,setGroupBy:F});}function Le(e){e.allCells.forEach((function(t){var n;t.isGrouped=t.column.isGrouped&&t.column.id===e.groupByID,t.isPlaceholder=!t.isGrouped&&t.column.isGrouped,t.isAggregated=!t.isGrouped&&!t.isPlaceholder&&(null==(n=e.subRows)?void 0:n.length);}));}function De(e,t){return e.reduce((function(e,n,o){var r=""+n.values[t];return e[r]=Array.isArray(e[r])?e[r]:[],e[r].push(n),e}),{})}var Ve=/([0-9]+)/gm;function _e(e,t){return e===t?0:e>t?1:-1}function Xe(e,t,n){return [e.values[n],t.values[n]]}function qe(e){return "number"==typeof e?isNaN(e)||e===1/0||e===-1/0?"":String(e):"string"==typeof e?e:""}var Ke=Object.freeze({__proto__:null,alphanumeric:function(e,t,n){var o=Xe(e,t,n),r=o[0],i=o[1];for(r=qe(r),i=qe(i),r=r.split(Ve).filter(Boolean),i=i.split(Ve).filter(Boolean);r.length&&i.length;){var u=r.shift(),l=i.shift(),s=parseInt(u,10),a=parseInt(l,10),c=[s,a].sort();if(isNaN(c[0])){if(u>l)return 1;if(l>u)return -1}else {if(isNaN(c[1]))return isNaN(s)?-1:1;if(s>a)return 1;if(a>s)return -1}}return r.length-i.length},datetime:function(e,t,n){var o=Xe(e,t,n),r=o[0],i=o[1];return _e(r=r.getTime(),i=i.getTime())},basic:function(e,t,n){var o=Xe(e,t,n);return _e(o[0],o[1])},string:function(e,t,n){var o=Xe(e,t,n),r=o[0],i=o[1];for(r=r.split("").filter(Boolean),i=i.split("").filter(Boolean);r.length&&i.length;){var u=r.shift(),l=i.shift(),s=u.toLowerCase(),a=l.toLowerCase();if(s>a)return 1;if(a>s)return -1;if(u>l)return 1;if(l>u)return -1}return r.length-i.length},number:function(e,t,n){var o=Xe(e,t,n),r=o[0],i=o[1],u=/[^0-9.]/gi;return _e(r=Number(String(r).replace(u,"")),i=Number(String(i).replace(u,"")))}});l.resetSortBy="resetSortBy",l.setSortBy="setSortBy",l.toggleSortBy="toggleSortBy",l.clearSortBy="clearSortBy",c.sortType="alphanumeric",c.sortDescFirst=!1;var Ue=function(e){e.getSortByToggleProps=[$e],e.stateReducers.push(Je),e.useInstance.push(Ye);};Ue.pluginName="useSortBy";var $e=function(e,t){var n=t.instance,o=t.column,r=n.isMultiSortEvent,i=void 0===r?function(e){return e.shiftKey}:r;return [e,{onClick:o.canSort?function(e){e.persist(),o.toggleSortBy(void 0,!n.disableMultiSort&&i(e));}:void 0,style:{cursor:o.canSort?"pointer":void 0},title:o.canSort?"Toggle SortBy":void 0}]};function Je(e,t,n,o){if(t.type===l.init)return r({sortBy:[]},e);if(t.type===l.resetSortBy)return r({},e,{sortBy:o.initialState.sortBy||[]});if(t.type===l.clearSortBy)return r({},e,{sortBy:e.sortBy.filter((function(e){return e.id!==t.columnId}))});if(t.type===l.setSortBy)return r({},e,{sortBy:t.sortBy});if(t.type===l.toggleSortBy){var i,u=t.columnId,s=t.desc,a=t.multi,c=o.allColumns,d=o.disableMultiSort,f=o.disableSortRemove,p=o.disableMultiRemove,g=o.maxMultiSortColCount,v=void 0===g?Number.MAX_SAFE_INTEGER:g,m=e.sortBy,h=c.find((function(e){return e.id===u})).sortDescFirst,y=m.find((function(e){return e.id===u})),w=m.findIndex((function(e){return e.id===u})),R=null!=s,b=[];return "toggle"!==(i=!d&&a?y?"toggle":"add":w!==m.length-1||1!==m.length?"replace":y?"toggle":"replace")||f||R||a&&p||!(y&&y.desc&&!h||!y.desc&&h)||(i="remove"),"replace"===i?b=[{id:u,desc:R?s:h}]:"add"===i?(b=[].concat(m,[{id:u,desc:R?s:h}])).splice(0,b.length-v):"toggle"===i?b=m.map((function(e){return e.id===u?r({},e,{desc:R?s:!y.desc}):e})):"remove"===i&&(b=m.filter((function(e){return e.id!==u}))),r({},e,{sortBy:b})}}function Ye(e){var n=e.data,o=e.rows,r=e.flatRows,i=e.allColumns,u=e.orderByFn,s=void 0===u?Qe:u,a=e.sortTypes,c=e.manualSortBy,d=e.defaultCanSort,p=e.disableSortBy,g=e.flatHeaders,m=e.state.sortBy,y=e.dispatch,R=e.plugins,b=e.getHooks,S=e.autoResetSortBy,C=void 0===S||S;v(R,["useFilters","useGlobalFilter","useGroupBy","usePivotColumns"],"useSortBy");var x=t.useCallback((function(e){y({type:l.setSortBy,sortBy:e});}),[y]),P=t.useCallback((function(e,t,n){y({type:l.toggleSortBy,columnId:e,desc:t,multi:n});}),[y]),B=h(e);g.forEach((function(e){var t=e.accessor,n=e.canSort,o=e.disableSortBy,r=e.id,i=t?I(!0!==o&&void 0,!0!==p&&void 0,!0):I(d,n,!1);e.canSort=i,e.canSort&&(e.toggleSortBy=function(t,n){return P(e.id,t,n)},e.clearSortBy=function(){y({type:l.clearSortBy,columnId:e.id});}),e.getSortByToggleProps=f(b().getSortByToggleProps,{instance:B(),column:e});var u=m.find((function(e){return e.id===r}));e.isSorted=!!u,e.sortedIndex=m.findIndex((function(e){return e.id===r})),e.isSortedDesc=e.isSorted?u.desc:void 0;}));var E=t.useMemo((function(){if(c||!m.length)return [o,r];var e=[],t=m.filter((function(e){return i.find((function(t){return t.id===e.id}))}));return [function n(o){var r=s(o,t.map((function(e){var t=i.find((function(t){return t.id===e.id}));if(!t)throw new Error("React-Table: Could not find a column with id: "+e.id+" while sorting");var n=t.sortType,o=F(n)||(a||{})[n]||Ke[n];if(!o)throw new Error("React-Table: Could not find a valid sortType of '"+n+"' for column '"+e.id+"'.");return function(t,n){return o(t,n,e.id,e.desc)}})),t.map((function(e){var t=i.find((function(t){return t.id===e.id}));return t&&t.sortInverted?e.desc:!e.desc})));return r.forEach((function(t){e.push(t),t.subRows&&0!==t.subRows.length&&(t.subRows=n(t.subRows));})),r}(o),e]}),[c,m,o,r,i,s,a]),G=E[0],A=E[1],k=h(C);w((function(){k()&&y({type:l.resetSortBy});}),[c?null:n]),Object.assign(e,{preSortedRows:o,preSortedFlatRows:r,sortedRows:G,sortedFlatRows:A,rows:G,flatRows:A,setSortBy:x,toggleSortBy:P});}function Qe(e,t,n){return [].concat(e).sort((function(e,o){for(var r=0;r<t.length;r+=1){var i=t[r],u=!1===n[r]||"desc"===n[r],l=i(e,o);if(0!==l)return u?-l:l}return n[0]?e.index-o.index:o.index-e.index}))}l.resetPage="resetPage",l.gotoPage="gotoPage",l.setPageSize="setPageSize";var Ze=function(e){e.stateReducers.push(et),e.useInstance.push(tt);};function et(e,t,n,o){if(t.type===l.init)return r({pageSize:10,pageIndex:0},e);if(t.type===l.resetPage)return r({},e,{pageIndex:o.initialState.pageIndex||0});if(t.type===l.gotoPage){var i=o.pageCount,u=o.page,s=m(t.pageIndex,e.pageIndex),a=!1;return s>e.pageIndex?a=-1===i?u.length>=e.pageSize:s<i:s<e.pageIndex&&(a=s>-1),a?r({},e,{pageIndex:s}):e}if(t.type===l.setPageSize){var c=t.pageSize,d=e.pageSize*e.pageIndex;return r({},e,{pageIndex:Math.floor(d/c),pageSize:c})}}function tt(e){var n=e.rows,o=e.autoResetPage,r=void 0===o||o,i=e.manualExpandedKey,u=void 0===i?"expanded":i,s=e.plugins,a=e.pageCount,c=e.paginateExpandedRows,d=void 0===c||c,f=e.expandSubRows,p=void 0===f||f,g=e.state,m=g.pageSize,y=g.pageIndex,R=g.expanded,b=g.globalFilter,S=g.filters,C=g.groupBy,x=g.sortBy,P=e.dispatch,B=e.data,E=e.manualPagination;v(s,["useGlobalFilter","useFilters","useGroupBy","useSortBy","useExpanded"],"usePagination");var I=h(r);w((function(){I()&&P({type:l.resetPage});}),[P,E?null:B,b,S,C,x]);var F=E?a:Math.ceil(n.length/m),G=t.useMemo((function(){return F>0?[].concat(new Array(F)).fill(null).map((function(e,t){return t})):[]}),[F]),k=t.useMemo((function(){var e;if(E)e=n;else {var t=m*y,o=t+m;e=n.slice(t,o);}return d?e:A(e,{manualExpandedKey:u,expanded:R,expandSubRows:p})}),[p,R,u,E,y,m,d,n]),H=y>0,T=-1===F?k.length>=m:y<F-1,z=t.useCallback((function(e){P({type:l.gotoPage,pageIndex:e});}),[P]),W=t.useCallback((function(){return z((function(e){return e-1}))}),[z]),O=t.useCallback((function(){return z((function(e){return e+1}))}),[z]),M=t.useCallback((function(e){P({type:l.setPageSize,pageSize:e});}),[P]);Object.assign(e,{pageOptions:G,pageCount:F,page:k,canPreviousPage:H,canNextPage:T,gotoPage:z,previousPage:W,nextPage:O,setPageSize:M});}Ze.pluginName="usePagination",l.resetPivot="resetPivot",l.togglePivot="togglePivot";var nt=function(e){e.getPivotToggleProps=[rt],e.stateReducers.push(it),e.useInstanceAfterData.push(ut),e.allColumns.push(lt),e.accessValue.push(st),e.materializedColumns.push(at),e.materializedColumnsDeps.push(ct),e.visibleColumns.push(dt),e.visibleColumnsDeps.push(ft),e.useInstance.push(pt),e.prepareRow.push(gt);};nt.pluginName="usePivotColumns";var ot=[],rt=function(e,t){var n=t.header;return [e,{onClick:n.canPivot?function(e){e.persist(),n.togglePivot();}:void 0,style:{cursor:n.canPivot?"pointer":void 0},title:"Toggle Pivot"}]};function it(e,t,n,o){if(t.type===l.init)return r({pivotColumns:ot},e);if(t.type===l.resetPivot)return r({},e,{pivotColumns:o.initialState.pivotColumns||ot});if(t.type===l.togglePivot){var i=t.columnId,u=t.value,s=void 0!==u?u:!e.pivotColumns.includes(i);return r({},e,s?{pivotColumns:[].concat(e.pivotColumns,[i])}:{pivotColumns:e.pivotColumns.filter((function(e){return e!==i}))})}}function ut(e){e.allColumns.forEach((function(t){t.isPivotSource=e.state.pivotColumns.includes(t.id);}));}function lt(e,t){var n=t.instance;return e.forEach((function(e){e.isPivotSource=n.state.pivotColumns.includes(e.id),e.uniqueValues=new Set;})),e}function st(e,t){var n=t.column;return n.uniqueValues&&void 0!==e&&n.uniqueValues.add(e),e}function at(e,t){var n=t.instance,o=n.allColumns,i=n.state;if(!i.pivotColumns.length||!i.groupBy||!i.groupBy.length)return e;var u=i.pivotColumns.map((function(e){return o.find((function(t){return t.id===e}))})).filter(Boolean),l=o.filter((function(e){return !e.isPivotSource&&!i.groupBy.includes(e.id)&&!i.pivotColumns.includes(e.id)})),s=C(function e(t,n,o){void 0===t&&(t=0),void 0===o&&(o=[]);var i=u[t];return i?Array.from(i.uniqueValues).sort().map((function(u){var l=r({},i,{Header:i.PivotHeader||"string"==typeof i.header?i.Header+": "+u:u,isPivotGroup:!0,parent:n,depth:t,id:n?n.id+"."+i.id+"."+u:i.id+"."+u,pivotValue:u});return l.columns=e(t+1,l,[].concat(o,[function(e){return e.values[i.id]===u}])),l})):l.map((function(e){return r({},e,{canPivot:!1,isPivoted:!0,parent:n,depth:t,id:""+(n?n.id+"."+e.id:e.id),accessor:function(t,n,r){if(o.every((function(e){return e(r)})))return r.values[e.id]}})}))}());return [].concat(e,s)}function ct(e,t){var n=t.instance.state,o=n.pivotColumns,r=n.groupBy;return [].concat(e,[o,r])}function dt(e,t){var n=t.instance.state;return e=e.filter((function(e){return !e.isPivotSource})),n.pivotColumns.length&&n.groupBy&&n.groupBy.length&&(e=e.filter((function(e){return e.isGrouped||e.isPivoted}))),e}function ft(e,t){var n=t.instance;return [].concat(e,[n.state.pivotColumns,n.state.groupBy])}function pt(e){var t=e.columns,n=e.allColumns,o=e.flatHeaders,r=e.getHooks,i=e.plugins,u=e.dispatch,s=e.autoResetPivot,a=void 0===s||s,c=e.manaulPivot,d=e.disablePivot,p=e.defaultCanPivot;v(i,["useGroupBy"],"usePivotColumns");var g=h(e);n.forEach((function(t){var n=t.accessor,o=t.defaultPivot,r=t.disablePivot;t.canPivot=n?I(t.canPivot,!0!==r&&void 0,!0!==d&&void 0,!0):I(t.canPivot,o,p,!1),t.canPivot&&(t.togglePivot=function(){return e.togglePivot(t.id)}),t.Aggregated=t.Aggregated||t.Cell;}));o.forEach((function(e){e.getPivotToggleProps=f(r().getPivotToggleProps,{instance:g(),header:e});}));var m=h(a);w((function(){m()&&u({type:l.resetPivot});}),[u,c?null:t]),Object.assign(e,{togglePivot:function(e,t){u({type:l.togglePivot,columnId:e,value:t});}});}function gt(e){e.allCells.forEach((function(e){e.isPivoted=e.column.isPivoted;}));}l.resetSelectedRows="resetSelectedRows",l.toggleAllRowsSelected="toggleAllRowsSelected",l.toggleRowSelected="toggleRowSelected",l.toggleAllPageRowsSelected="toggleAllPageRowsSelected";var vt=function(e){e.getToggleRowSelectedProps=[mt],e.getToggleAllRowsSelectedProps=[ht],e.getToggleAllPageRowsSelectedProps=[yt],e.stateReducers.push(wt),e.useInstance.push(Rt),e.prepareRow.push(bt);};vt.pluginName="useRowSelect";var mt=function(e,t){var n=t.instance,o=t.row,r=n.manualRowSelectedKey,i=void 0===r?"isSelected":r;return [e,{onChange:function(e){o.toggleRowSelected(e.target.checked);},style:{cursor:"pointer"},checked:!(!o.original||!o.original[i])||o.isSelected,title:"Toggle Row Selected",indeterminate:o.isSomeSelected}]},ht=function(e,t){var n=t.instance;return [e,{onChange:function(e){n.toggleAllRowsSelected(e.target.checked);},style:{cursor:"pointer"},checked:n.isAllRowsSelected,title:"Toggle All Rows Selected",indeterminate:Boolean(!n.isAllRowsSelected&&Object.keys(n.state.selectedRowIds).length)}]},yt=function(e,t){var n=t.instance;return [e,{onChange:function(e){n.toggleAllPageRowsSelected(e.target.checked);},style:{cursor:"pointer"},checked:n.isAllPageRowsSelected,title:"Toggle All Current Page Rows Selected",indeterminate:Boolean(!n.isAllPageRowsSelected&&n.page.some((function(e){var t=e.id;return n.state.selectedRowIds[t]})))}]};function wt(e,t,n,o){if(t.type===l.init)return r({selectedRowIds:{}},e);if(t.type===l.resetSelectedRows)return r({},e,{selectedRowIds:o.initialState.selectedRowIds||{}});if(t.type===l.toggleAllRowsSelected){var i=t.value,u=o.isAllRowsSelected,s=o.rowsById,a=o.nonGroupedRowsById,c=void 0===a?s:a,d=void 0!==i?i:!u,f=Object.assign({},e.selectedRowIds);return d?Object.keys(c).forEach((function(e){f[e]=!0;})):Object.keys(c).forEach((function(e){delete f[e];})),r({},e,{selectedRowIds:f})}if(t.type===l.toggleRowSelected){var p=t.id,g=t.value,v=o.rowsById,m=o.selectSubRows,h=void 0===m||m,y=o.getSubRows,w=e.selectedRowIds[p],R=void 0!==g?g:!w;if(w===R)return e;var b=r({},e.selectedRowIds);return function e(t){var n=v[t];if(n.isGrouped||(R?b[t]=!0:delete b[t]),h&&y(n))return y(n).forEach((function(t){return e(t.id)}))}(p),r({},e,{selectedRowIds:b})}if(t.type===l.toggleAllPageRowsSelected){var S=t.value,C=o.page,x=o.rowsById,P=o.selectSubRows,B=void 0===P||P,E=o.isAllPageRowsSelected,I=o.getSubRows,F=void 0!==S?S:!E,G=r({},e.selectedRowIds);return C.forEach((function(e){return function e(t){var n=x[t];if(n.isGrouped||(F?G[t]=!0:delete G[t]),B&&I(n))return I(n).forEach((function(t){return e(t.id)}))}(e.id)})),r({},e,{selectedRowIds:G})}return e}function Rt(e){var n=e.data,o=e.rows,r=e.getHooks,i=e.plugins,u=e.rowsById,s=e.nonGroupedRowsById,a=void 0===s?u:s,c=e.autoResetSelectedRows,d=void 0===c||c,p=e.state.selectedRowIds,g=e.selectSubRows,m=void 0===g||g,y=e.dispatch,R=e.page,b=e.getSubRows;v(i,["useFilters","useGroupBy","useSortBy","useExpanded","usePagination"],"useRowSelect");var S=t.useMemo((function(){var e=[];return o.forEach((function(t){var n=m?function e(t,n,o){if(n[t.id])return !0;var r=o(t);if(r&&r.length){var i=!0,u=!1;return r.forEach((function(t){u&&!i||(e(t,n,o)?u=!0:i=!1);})),!!i||!!u&&null}return !1}(t,p,b):!!p[t.id];t.isSelected=!!n,t.isSomeSelected=null===n,n&&e.push(t);})),e}),[o,m,p,b]),C=Boolean(Object.keys(a).length&&Object.keys(p).length),x=C;C&&Object.keys(a).some((function(e){return !p[e]}))&&(C=!1),C||R&&R.length&&R.some((function(e){var t=e.id;return !p[t]}))&&(x=!1);var P=h(d);w((function(){P()&&y({type:l.resetSelectedRows});}),[y,n]);var B=t.useCallback((function(e){return y({type:l.toggleAllRowsSelected,value:e})}),[y]),E=t.useCallback((function(e){return y({type:l.toggleAllPageRowsSelected,value:e})}),[y]),I=t.useCallback((function(e,t){return y({type:l.toggleRowSelected,id:e,value:t})}),[y]),F=h(e),G=f(r().getToggleAllRowsSelectedProps,{instance:F()}),A=f(r().getToggleAllPageRowsSelectedProps,{instance:F()});Object.assign(e,{selectedFlatRows:S,isAllRowsSelected:C,isAllPageRowsSelected:x,toggleRowSelected:I,toggleAllRowsSelected:B,getToggleAllRowsSelectedProps:G,getToggleAllPageRowsSelectedProps:A,toggleAllPageRowsSelected:E});}function bt(e,t){var n=t.instance;e.toggleRowSelected=function(t){return n.toggleRowSelected(e.id,t)},e.getToggleRowSelectedProps=f(n.getHooks().getToggleRowSelectedProps,{instance:n,row:e});}var St=function(e){return {}},Ct=function(e){return {}};l.setRowState="setRowState",l.setCellState="setCellState",l.resetRowState="resetRowState";var xt=function(e){e.stateReducers.push(Pt),e.useInstance.push(Bt),e.prepareRow.push(Et);};function Pt(e,t,n,o){var i=o.initialRowStateAccessor,u=void 0===i?St:i,s=o.initialCellStateAccessor,a=void 0===s?Ct:s,c=o.rowsById;if(t.type===l.init)return r({rowState:{}},e);if(t.type===l.resetRowState)return r({},e,{rowState:o.initialState.rowState||{}});if(t.type===l.setRowState){var d,f=t.rowId,p=t.value,g=void 0!==e.rowState[f]?e.rowState[f]:u(c[f]);return r({},e,{rowState:r({},e.rowState,(d={},d[f]=m(p,g),d))})}if(t.type===l.setCellState){var v,h,y,w,R,b=t.rowId,S=t.columnId,C=t.value,x=void 0!==e.rowState[b]?e.rowState[b]:u(c[b]),P=void 0!==(null==x?void 0:null==(v=x.cellState)?void 0:v[S])?x.cellState[S]:a(null==(h=c[b])?void 0:null==(y=h.cells)?void 0:y.find((function(e){return e.column.id===S})));return r({},e,{rowState:r({},e.rowState,(R={},R[b]=r({},x,{cellState:r({},x.cellState||{},(w={},w[S]=m(C,P),w))}),R))})}}function Bt(e){var n=e.autoResetRowState,o=void 0===n||n,r=e.data,i=e.dispatch,u=t.useCallback((function(e,t){return i({type:l.setRowState,rowId:e,value:t})}),[i]),s=t.useCallback((function(e,t,n){return i({type:l.setCellState,rowId:e,columnId:t,value:n})}),[i]),a=h(o);w((function(){a()&&i({type:l.resetRowState});}),[r]),Object.assign(e,{setRowState:u,setCellState:s});}function Et(e,t){var n=t.instance,o=n.initialRowStateAccessor,r=void 0===o?St:o,i=n.initialCellStateAccessor,u=void 0===i?Ct:i,l=n.state.rowState;e&&(e.state=void 0!==l[e.id]?l[e.id]:r(e),e.setState=function(t){return n.setRowState(e.id,t)},e.cells.forEach((function(t){e.state.cellState||(e.state.cellState={}),t.state=void 0!==e.state.cellState[t.column.id]?e.state.cellState[t.column.id]:u(t),t.setState=function(o){return n.setCellState(e.id,t.column.id,o)};})));}xt.pluginName="useRowState",l.resetColumnOrder="resetColumnOrder",l.setColumnOrder="setColumnOrder";var It=function(e){e.stateReducers.push(Ft),e.visibleColumnsDeps.push((function(e,t){var n=t.instance;return [].concat(e,[n.state.columnOrder])})),e.visibleColumns.push(Gt),e.useInstance.push(At);};function Ft(e,t,n,o){return t.type===l.init?r({columnOrder:[]},e):t.type===l.resetColumnOrder?r({},e,{columnOrder:o.initialState.columnOrder||[]}):t.type===l.setColumnOrder?r({},e,{columnOrder:m(t.columnOrder,e.columnOrder)}):void 0}function Gt(e,t){var n=t.instance.state.columnOrder;if(!n||!n.length)return e;for(var o=[].concat(n),r=[].concat(e),i=[],u=function(){var e=o.shift(),t=r.findIndex((function(t){return t.id===e}));t>-1&&i.push(r.splice(t,1)[0]);};r.length&&o.length;)u();return [].concat(i,r)}function At(e){var n=e.dispatch;e.setColumnOrder=t.useCallback((function(e){return n({type:l.setColumnOrder,columnOrder:e})}),[n]);}It.pluginName="useColumnOrder",c.canResize=!0,l.columnStartResizing="columnStartResizing",l.columnResizing="columnResizing",l.columnDoneResizing="columnDoneResizing",l.resetResize="resetResize";var kt=function(e){e.getResizerProps=[Ht],e.getHeaderProps.push({style:{position:"relative"}}),e.stateReducers.push(Tt),e.useInstance.push(Wt),e.useInstanceBeforeDimensions.push(zt);},Ht=function(e,t){var n=t.instance,o=t.header,r=n.dispatch,i=function(e,t){var n=!1;if("touchstart"===e.type){if(e.touches&&e.touches.length>1)return;n=!0;}var o=function(e){var t=[];return function e(n){n.columns&&n.columns.length&&n.columns.map(e);t.push(n);}(e),t}(t).map((function(e){return [e.id,e.totalWidth]})),i=n?Math.round(e.touches[0].clientX):e.clientX,u=function(e){r({type:l.columnResizing,clientX:e});},s=function(){return r({type:l.columnDoneResizing})},a={mouse:{moveEvent:"mousemove",moveHandler:function(e){return u(e.clientX)},upEvent:"mouseup",upHandler:function(e){document.removeEventListener("mousemove",a.mouse.moveHandler),document.removeEventListener("mouseup",a.mouse.upHandler),s();}},touch:{moveEvent:"touchmove",moveHandler:function(e){return e.cancelable&&(e.preventDefault(),e.stopPropagation()),u(e.touches[0].clientX),!1},upEvent:"touchend",upHandler:function(e){document.removeEventListener(a.touch.moveEvent,a.touch.moveHandler),document.removeEventListener(a.touch.upEvent,a.touch.moveHandler),s();}}},c=n?a.touch:a.mouse,d=!!function(){if("boolean"==typeof z)return z;var e=!1;try{var t={get passive(){return e=!0,!1}};window.addEventListener("test",null,t),window.removeEventListener("test",null,t);}catch(t){e=!1;}return z=e}()&&{passive:!1};document.addEventListener(c.moveEvent,c.moveHandler,d),document.addEventListener(c.upEvent,c.upHandler,d),r({type:l.columnStartResizing,columnId:t.id,columnWidth:t.totalWidth,headerIdWidths:o,clientX:i});};return [e,{onMouseDown:function(e){return e.persist()||i(e,o)},onTouchStart:function(e){return e.persist()||i(e,o)},style:{cursor:"col-resize"},draggable:!1,role:"separator"}]};function Tt(e,t){if(t.type===l.init)return r({columnResizing:{columnWidths:{}}},e);if(t.type===l.resetResize)return r({},e,{columnResizing:{columnWidths:{}}});if(t.type===l.columnStartResizing){var n=t.clientX,o=t.columnId,i=t.columnWidth,u=t.headerIdWidths;return r({},e,{columnResizing:r({},e.columnResizing,{startX:n,headerIdWidths:u,columnWidth:i,isResizingColumn:o})})}if(t.type===l.columnResizing){var s=t.clientX,a=e.columnResizing,c=a.startX,d=a.columnWidth,f=a.headerIdWidths,p=(s-c)/d,g={};return (void 0===f?[]:f).forEach((function(e){var t=e[0],n=e[1];g[t]=Math.max(n+n*p,0);})),r({},e,{columnResizing:r({},e.columnResizing,{columnWidths:r({},e.columnResizing.columnWidths,{},g)})})}return t.type===l.columnDoneResizing?r({},e,{columnResizing:r({},e.columnResizing,{startX:null,isResizingColumn:null})}):void 0}kt.pluginName="useResizeColumns";var zt=function(e){var t=e.flatHeaders,n=e.disableResizing,o=e.getHooks,r=e.state.columnResizing,i=h(e);t.forEach((function(e){var t=I(!0!==e.disableResizing&&void 0,!0!==n&&void 0,!0);e.canResize=t,e.width=r.columnWidths[e.id]||e.originalWidth||e.width,e.isResizing=r.isResizingColumn===e.id,t&&(e.getResizerProps=f(o().getResizerProps,{instance:i(),header:e}));}));};function Wt(e){var n=e.plugins,o=e.dispatch,r=e.autoResetResize,i=void 0===r||r,u=e.columns;v(n,["useAbsoluteLayout"],"useResizeColumns");var s=h(i);w((function(){s()&&o({type:l.resetResize});}),[u]);var a=t.useCallback((function(){return o({type:l.resetResize})}),[o]);Object.assign(e,{resetResizing:a});}var Ot={position:"absolute",top:0},Mt=function(e){e.getTableBodyProps.push(jt),e.getRowProps.push(jt),e.getHeaderGroupProps.push(jt),e.getFooterGroupProps.push(jt),e.getHeaderProps.push((function(e,t){var n=t.column;return [e,{style:r({},Ot,{left:n.totalLeft+"px",width:n.totalWidth+"px"})}]})),e.getCellProps.push((function(e,t){var n=t.cell;return [e,{style:r({},Ot,{left:n.column.totalLeft+"px",width:n.column.totalWidth+"px"})}]})),e.getFooterProps.push((function(e,t){var n=t.column;return [e,{style:r({},Ot,{left:n.totalLeft+"px",width:n.totalWidth+"px"})}]}));};Mt.pluginName="useAbsoluteLayout";var jt=function(e,t){return [e,{style:{position:"relative",width:t.instance.totalColumnsWidth+"px"}}]},Nt={display:"inline-block",boxSizing:"border-box"},Lt=function(e,t){return [e,{style:{display:"flex",width:t.instance.totalColumnsWidth+"px"}}]},Dt=function(e){e.getRowProps.push(Lt),e.getHeaderGroupProps.push(Lt),e.getFooterGroupProps.push(Lt),e.getHeaderProps.push((function(e,t){var n=t.column;return [e,{style:r({},Nt,{width:n.totalWidth+"px"})}]})),e.getCellProps.push((function(e,t){var n=t.cell;return [e,{style:r({},Nt,{width:n.column.totalWidth+"px"})}]})),e.getFooterProps.push((function(e,t){var n=t.column;return [e,{style:r({},Nt,{width:n.totalWidth+"px"})}]}));};function Vt(e){e.getTableProps.push(_t),e.getRowProps.push(Xt),e.getHeaderGroupProps.push(Xt),e.getFooterGroupProps.push(Xt),e.getHeaderProps.push(qt),e.getCellProps.push(Kt),e.getFooterProps.push(Ut);}Dt.pluginName="useBlockLayout",Vt.pluginName="useFlexLayout";var _t=function(e,t){return [e,{style:{minWidth:t.instance.totalColumnsMinWidth+"px"}}]},Xt=function(e,t){return [e,{style:{display:"flex",flex:"1 0 auto",minWidth:t.instance.totalColumnsMinWidth+"px"}}]},qt=function(e,t){var n=t.column;return [e,{style:{boxSizing:"border-box",flex:n.totalFlexWidth?n.totalFlexWidth+" 0 auto":void 0,minWidth:n.totalMinWidth+"px",width:n.totalWidth+"px"}}]},Kt=function(e,t){var n=t.cell;return [e,{style:{boxSizing:"border-box",flex:n.column.totalFlexWidth+" 0 auto",minWidth:n.column.totalMinWidth+"px",width:n.column.totalWidth+"px"}}]},Ut=function(e,t){var n=t.column;return [e,{style:{boxSizing:"border-box",flex:n.totalFlexWidth?n.totalFlexWidth+" 0 auto":void 0,minWidth:n.totalMinWidth+"px",width:n.totalWidth+"px"}}]};function $t(e){e.stateReducers.push(Qt),e.getTableProps.push(Jt),e.getHeaderProps.push(Yt);}$t.pluginName="useGridLayout";var Jt=function(e,t){return [e,{style:{display:"grid",gridTemplateColumns:t.instance.state.gridLayout.columnWidths.map((function(e){return e})).join(" ")}}]},Yt=function(e,t){return [e,{id:"header-cell-"+t.column.id,style:{position:"sticky"}}]};function Qt(e,t,n,o){if("init"===t.type)return r({gridLayout:{columnWidths:o.columns.map((function(){return "auto"}))}},e);if("columnStartResizing"===t.type){var i=t.columnId,u=o.visibleColumns.findIndex((function(e){return e.id===i})),l=function(e){var t,n=null==(t=document.getElementById("header-cell-"+e))?void 0:t.offsetWidth;if(void 0!==n)return n}(i);return void 0!==l?r({},e,{gridLayout:r({},e.gridLayout,{columnId:i,columnIndex:u,startingWidth:l})}):e}if("columnResizing"===t.type){var s=e.gridLayout,a=s.columnIndex,c=s.startingWidth,d=s.columnWidths,f=c-(e.columnResizing.startX-t.clientX),p=[].concat(d);return p[a]=f+"px",r({},e,{gridLayout:r({},e.gridLayout,{columnWidths:p})})}}e._UNSTABLE_usePivotColumns=nt,e.actions=l,e.defaultColumn=c,e.defaultGroupByFn=De,e.defaultOrderByFn=Qe,e.defaultRenderer=s,e.emptyRenderer=a,e.ensurePluginOrder=v,e.flexRender=b,e.functionalUpdate=m,e.loopHooks=g,e.makePropGetter=f,e.makeRenderer=R,e.reduceHooks=p,e.safeUseLayoutEffect=y,e.useAbsoluteLayout=Mt,e.useAsyncDebounce=function(e,n){void 0===n&&(n=0);var r=t.useRef({}),i=h(e),u=h(n);return t.useCallback(function(){var e=o(regeneratorRuntime.mark((function e(){var t,n,l,s=arguments;return regeneratorRuntime.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:for(t=s.length,n=new Array(t),l=0;l<t;l++)n[l]=s[l];return r.current.promise||(r.current.promise=new Promise((function(e,t){r.current.resolve=e,r.current.reject=t;}))),r.current.timeout&&clearTimeout(r.current.timeout),r.current.timeout=setTimeout(o(regeneratorRuntime.mark((function e(){return regeneratorRuntime.wrap((function(e){for(;;)switch(e.prev=e.next){case 0:return delete r.current.timeout,e.prev=1,e.t0=r.current,e.next=5,i().apply(void 0,n);case 5:e.t1=e.sent,e.t0.resolve.call(e.t0,e.t1),e.next=12;break;case 9:e.prev=9,e.t2=e.catch(1),r.current.reject(e.t2);case 12:return e.prev=12,delete r.current.promise,e.finish(12);case 15:case"end":return e.stop()}}),e,null,[[1,9,12,15]])}))),u()),e.abrupt("return",r.current.promise);case 5:case"end":return e.stop()}}),e)})));return function(){return e.apply(this,arguments)}}(),[i,u])},e.useBlockLayout=Dt,e.useColumnOrder=It,e.useExpanded=se,e.useFilters=Pe,e.useFlexLayout=Vt,e.useGetLatest=h,e.useGlobalFilter=Ie,e.useGridLayout=$t,e.useGroupBy=ze,e.useMountedLayoutEffect=w,e.usePagination=Ze,e.useResizeColumns=kt,e.useRowSelect=vt,e.useRowState=xt,e.useSortBy=Ue,e.useTable=function(e){for(var n=arguments.length,o=new Array(n>1?n-1:0),i=1;i<n;i++)o[i-1]=arguments[i];e=ie(e),o=[K].concat(o);var u=t.useRef({}),s=h(u.current);Object.assign(s(),r({},e,{plugins:o,hooks:q()})),o.filter(Boolean).forEach((function(e){e(s().hooks);}));var a=h(s().hooks);s().getHooks=a,delete s().hooks,Object.assign(s(),p(a().useOptions,ie(e)));var c=s(),d=c.data,v=c.columns,m=c.initialState,y=c.defaultColumn,w=c.getSubRows,b=c.getRowId,E=c.stateReducer,I=c.useControlledState,F=h(E),G=t.useCallback((function(e,t){if(!t.type)throw console.info({action:t}),new Error("Unknown Action 👆");return [].concat(a().stateReducers,Array.isArray(F())?F():[F()]).reduce((function(n,o){return o(n,t,e,s())||n}),e)}),[a,F,s]),A=t.useReducer(G,void 0,(function(){return G(m,{type:l.init})})),k=A[0],H=A[1],T=p([].concat(a().useControlledState,[I]),k,{instance:s()});Object.assign(s(),{state:T,dispatch:H});var z=t.useMemo((function(){return S(p(a().columns,v,{instance:s()}))}),[a,s,v].concat(p(a().columnsDeps,[],{instance:s()})));s().columns=z;var W=t.useMemo((function(){return p(a().allColumns,C(z),{instance:s()}).map(x)}),[z,a,s].concat(p(a().allColumnsDeps,[],{instance:s()})));s().allColumns=W;var O=t.useMemo((function(){for(var e=[],t=[],n={},o=[].concat(W);o.length;){var r=o.shift();le({data:d,rows:e,flatRows:t,rowsById:n,column:r,getRowId:b,getSubRows:w,accessValueHooks:a().accessValue,getInstance:s});}return [e,t,n]}),[W,d,b,w,a,s]),M=O[0],j=O[1],N=O[2];Object.assign(s(),{rows:M,initialRows:[].concat(M),flatRows:j,rowsById:N}),g(a().useInstanceAfterData,s());var L=t.useMemo((function(){return p(a().visibleColumns,W,{instance:s()}).map((function(e){return P(e,y)}))}),[a,W,s,y].concat(p(a().visibleColumnsDeps,[],{instance:s()})));W=t.useMemo((function(){var e=[].concat(L);return W.forEach((function(t){e.find((function(e){return e.id===t.id}))||e.push(t);})),e}),[W,L]),s().allColumns=W;var D=t.useMemo((function(){return p(a().headerGroups,B(L,y),s())}),[a,L,y,s].concat(p(a().headerGroupsDeps,[],{instance:s()})));s().headerGroups=D;var V=t.useMemo((function(){return D.length?D[0].headers:[]}),[D]);s().headers=V,s().flatHeaders=D.reduce((function(e,t){return [].concat(e,t.headers)}),[]),g(a().useInstanceBeforeDimensions,s());var _=L.filter((function(e){return e.isVisible})).map((function(e){return e.id})).sort().join("_");L=t.useMemo((function(){return L.filter((function(e){return e.isVisible}))}),[L,_]),s().visibleColumns=L;var X=ue(V),U=X[0],$=X[1],J=X[2];return s().totalColumnsMinWidth=U,s().totalColumnsWidth=$,s().totalColumnsMaxWidth=J,g(a().useInstance,s()),[].concat(s().flatHeaders,s().allColumns).forEach((function(e){e.render=R(s(),e),e.getHeaderProps=f(a().getHeaderProps,{instance:s(),column:e}),e.getFooterProps=f(a().getFooterProps,{instance:s(),column:e});})),s().headerGroups=t.useMemo((function(){return D.filter((function(e,t){return e.headers=e.headers.filter((function(e){return e.headers?function e(t){return t.filter((function(t){return t.headers?e(t.headers):t.isVisible})).length}(e.headers):e.isVisible})),!!e.headers.length&&(e.getHeaderGroupProps=f(a().getHeaderGroupProps,{instance:s(),headerGroup:e,index:t}),e.getFooterGroupProps=f(a().getFooterGroupProps,{instance:s(),headerGroup:e,index:t}),!0)}))}),[D,s,a]),s().footerGroups=[].concat(s().headerGroups).reverse(),s().prepareRow=t.useCallback((function(e){e.getRowProps=f(a().getRowProps,{instance:s(),row:e}),e.allCells=W.map((function(t){var n=e.values[t.id],o={column:t,row:e,value:n};return o.getCellProps=f(a().getCellProps,{instance:s(),cell:o}),o.render=R(s(),t,{row:e,cell:o,value:n}),o})),e.cells=L.map((function(t){return e.allCells.find((function(e){return e.column.id===t.id}))})),g(a().prepareRow,e,{instance:s()});}),[a,s,W,L]),s().getTableProps=f(a().getTableProps,{instance:s()}),s().getTableBodyProps=f(a().getTableBodyProps,{instance:s()}),g(a().useFinalInstance,s()),s()},Object.defineProperty(e,"__esModule",{value:!0});}));

}(reactTable_production_min, reactTable_production_min.exports));

{
  reactTable.exports = reactTable_production_min.exports;
}

var format$1 = {exports: {}};

var isValid$1 = {exports: {}};

var toDate = {exports: {}};

var requiredArgs = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = requiredArgs;

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

module.exports = exports.default;
}(requiredArgs, requiredArgs.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toDate;

var _index = _interopRequireDefault(requiredArgs.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  (0, _index.default)(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

module.exports = exports.default;
}(toDate, toDate.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = isValid;

var _index = _interopRequireDefault(toDate.exports);

var _index2 = _interopRequireDefault(requiredArgs.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  return !isNaN(date);
}

module.exports = exports.default;
}(isValid$1, isValid$1.exports));

var isValid = /*@__PURE__*/getDefaultExportFromCjs(isValid$1.exports);

var enUS = {exports: {}};

var formatDistance = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatDistance;
var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};

function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
}

module.exports = exports.default;
}(formatDistance, formatDistance.exports));

var formatLong = {exports: {}};

var buildFormatLongFn = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildFormatLongFn;

function buildFormatLongFn(args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

module.exports = exports.default;
}(buildFormatLongFn, buildFormatLongFn.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(buildFormatLongFn.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: (0, _index.default)({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: (0, _index.default)({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: (0, _index.default)({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var _default = formatLong;
exports.default = _default;
module.exports = exports.default;
}(formatLong, formatLong.exports));

var formatRelative = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatRelative;
var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};

function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

module.exports = exports.default;
}(formatRelative, formatRelative.exports));

var localize = {exports: {}};

var buildLocalizeFn = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildLocalizeFn;

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

module.exports = exports.default;
}(buildLocalizeFn, buildLocalizeFn.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(buildLocalizeFn.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.

};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: (0, _index.default)({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: (0, _index.default)({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: (0, _index.default)({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: (0, _index.default)({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: (0, _index.default)({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var _default = localize;
exports.default = _default;
module.exports = exports.default;
}(localize, localize.exports));

var match = {exports: {}};

var buildMatchPatternFn = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildMatchPatternFn;

function buildMatchPatternFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var matchResult = string.match(args.matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);

    if (!parseResult) {
      return null;
    }

    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

module.exports = exports.default;
}(buildMatchPatternFn, buildMatchPatternFn.exports));

var buildMatchFn = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = buildMatchFn;

function buildMatchFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var value;

    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
      value = findIndex(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      });
    } else {
      value = findKey(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      });
    }

    value = args.valueCallback ? args.valueCallback(value) : value;
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
}

module.exports = exports.default;
}(buildMatchFn, buildMatchFn.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(buildMatchPatternFn.exports);

var _index2 = _interopRequireDefault(buildMatchFn.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: (0, _index.default)({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: (0, _index2.default)({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: (0, _index2.default)({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: (0, _index2.default)({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: (0, _index2.default)({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: (0, _index2.default)({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var _default = match;
exports.default = _default;
module.exports = exports.default;
}(match, match.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(formatDistance.exports);

var _index2 = _interopRequireDefault(formatLong.exports);

var _index3 = _interopRequireDefault(formatRelative.exports);

var _index4 = _interopRequireDefault(localize.exports);

var _index5 = _interopRequireDefault(match.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale = {
  code: 'en-US',
  formatDistance: _index.default,
  formatLong: _index2.default,
  formatRelative: _index3.default,
  localize: _index4.default,
  match: _index5.default,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var _default = locale;
exports.default = _default;
module.exports = exports.default;
}(enUS, enUS.exports));

var subMilliseconds = {exports: {}};

var toInteger = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toInteger;

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

module.exports = exports.default;
}(toInteger, toInteger.exports));

var addMilliseconds = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addMilliseconds;

var _index = _interopRequireDefault(toInteger.exports);

var _index2 = _interopRequireDefault(toDate.exports);

var _index3 = _interopRequireDefault(requiredArgs.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var timestamp = (0, _index2.default)(dirtyDate).getTime();
  var amount = (0, _index.default)(dirtyAmount);
  return new Date(timestamp + amount);
}

module.exports = exports.default;
}(addMilliseconds, addMilliseconds.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = subMilliseconds;

var _index = _interopRequireDefault(toInteger.exports);

var _index2 = _interopRequireDefault(addMilliseconds.exports);

var _index3 = _interopRequireDefault(requiredArgs.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  (0, _index3.default)(2, arguments);
  var amount = (0, _index.default)(dirtyAmount);
  return (0, _index2.default)(dirtyDate, -amount);
}

module.exports = exports.default;
}(subMilliseconds, subMilliseconds.exports));

var formatters = {exports: {}};

var lightFormatters = {exports: {}};

var addLeadingZeros = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = addLeadingZeros;

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

module.exports = exports.default;
}(addLeadingZeros, addLeadingZeros.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(addLeadingZeros.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return (0, _index.default)(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : (0, _index.default)(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return (0, _index.default)(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return (0, _index.default)(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return (0, _index.default)(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return (0, _index.default)(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return (0, _index.default)(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return (0, _index.default)(fractionalSeconds, token.length);
  }
};
var _default = formatters;
exports.default = _default;
module.exports = exports.default;
}(lightFormatters, lightFormatters.exports));

var getUTCDayOfYear = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getUTCDayOfYear;

var _index = _interopRequireDefault(toDate.exports);

var _index2 = _interopRequireDefault(requiredArgs.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

module.exports = exports.default;
}(getUTCDayOfYear, getUTCDayOfYear.exports));

var getUTCISOWeek = {exports: {}};

var startOfUTCISOWeek = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = startOfUTCISOWeek;

var _index = _interopRequireDefault(toDate.exports);

var _index2 = _interopRequireDefault(requiredArgs.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeek(dirtyDate) {
  (0, _index2.default)(1, arguments);
  var weekStartsOn = 1;
  var date = (0, _index.default)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

module.exports = exports.default;
}(startOfUTCISOWeek, startOfUTCISOWeek.exports));

var startOfUTCISOWeekYear = {exports: {}};

var getUTCISOWeekYear = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getUTCISOWeekYear;

var _index = _interopRequireDefault(toDate.exports);

var _index2 = _interopRequireDefault(startOfUTCISOWeek.exports);

var _index3 = _interopRequireDefault(requiredArgs.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCISOWeekYear(dirtyDate) {
  (0, _index3.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0, _index2.default)(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0, _index2.default)(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

module.exports = exports.default;
}(getUTCISOWeekYear, getUTCISOWeekYear.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = startOfUTCISOWeekYear;

var _index = _interopRequireDefault(getUTCISOWeekYear.exports);

var _index2 = _interopRequireDefault(startOfUTCISOWeek.exports);

var _index3 = _interopRequireDefault(requiredArgs.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCISOWeekYear(dirtyDate) {
  (0, _index3.default)(1, arguments);
  var year = (0, _index.default)(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = (0, _index2.default)(fourthOfJanuary);
  return date;
}

module.exports = exports.default;
}(startOfUTCISOWeekYear, startOfUTCISOWeekYear.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getUTCISOWeek;

var _index = _interopRequireDefault(toDate.exports);

var _index2 = _interopRequireDefault(startOfUTCISOWeek.exports);

var _index3 = _interopRequireDefault(startOfUTCISOWeekYear.exports);

var _index4 = _interopRequireDefault(requiredArgs.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  (0, _index4.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var diff = (0, _index2.default)(date).getTime() - (0, _index3.default)(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

module.exports = exports.default;
}(getUTCISOWeek, getUTCISOWeek.exports));

var getUTCWeek = {exports: {}};

var startOfUTCWeek = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = startOfUTCWeek;

var _index = _interopRequireDefault(toInteger.exports);

var _index2 = _interopRequireDefault(toDate.exports);

var _index3 = _interopRequireDefault(requiredArgs.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCWeek(dirtyDate, dirtyOptions) {
  (0, _index3.default)(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index.default)(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = (0, _index2.default)(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

module.exports = exports.default;
}(startOfUTCWeek, startOfUTCWeek.exports));

var startOfUTCWeekYear = {exports: {}};

var getUTCWeekYear = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getUTCWeekYear;

var _index = _interopRequireDefault(toInteger.exports);

var _index2 = _interopRequireDefault(toDate.exports);

var _index3 = _interopRequireDefault(startOfUTCWeek.exports);

var _index4 = _interopRequireDefault(requiredArgs.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function getUTCWeekYear(dirtyDate, dirtyOptions) {
  (0, _index4.default)(1, arguments);
  var date = (0, _index2.default)(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index.default)(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = (0, _index3.default)(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = (0, _index3.default)(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

module.exports = exports.default;
}(getUTCWeekYear, getUTCWeekYear.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = startOfUTCWeekYear;

var _index = _interopRequireDefault(toInteger.exports);

var _index2 = _interopRequireDefault(getUTCWeekYear.exports);

var _index3 = _interopRequireDefault(startOfUTCWeek.exports);

var _index4 = _interopRequireDefault(requiredArgs.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376
function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  (0, _index4.default)(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index.default)(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index.default)(options.firstWeekContainsDate);
  var year = (0, _index2.default)(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = (0, _index3.default)(firstWeek, dirtyOptions);
  return date;
}

module.exports = exports.default;
}(startOfUTCWeekYear, startOfUTCWeekYear.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getUTCWeek;

var _index = _interopRequireDefault(toDate.exports);

var _index2 = _interopRequireDefault(startOfUTCWeek.exports);

var _index3 = _interopRequireDefault(startOfUTCWeekYear.exports);

var _index4 = _interopRequireDefault(requiredArgs.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  (0, _index4.default)(1, arguments);
  var date = (0, _index.default)(dirtyDate);
  var diff = (0, _index2.default)(date, options).getTime() - (0, _index3.default)(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

module.exports = exports.default;
}(getUTCWeek, getUTCWeek.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(lightFormatters.exports);

var _index2 = _interopRequireDefault(getUTCDayOfYear.exports);

var _index3 = _interopRequireDefault(getUTCISOWeek.exports);

var _index4 = _interopRequireDefault(getUTCISOWeekYear.exports);

var _index5 = _interopRequireDefault(getUTCWeek.exports);

var _index6 = _interopRequireDefault(getUTCWeekYear.exports);

var _index7 = _interopRequireDefault(addLeadingZeros.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
   * |  d  | Day of month                   |  D  | Day of year                    |
   * |  e  | Local day of week              |  E  | Day of week                    |
   * |  f  |                                |  F* | Day of week in month           |
   * |  g* | Modified Julian day            |  G  | Era                            |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  i! | ISO day of week                |  I! | ISO week of year               |
   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
   * |  m  | Minute                         |  M  | Month                          |
   * |  n  |                                |  N  |                                |
   * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
   * |  p! | Long localized time            |  P! | Long localized date            |
   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
   * |  u  | Extended year                  |  U* | Cyclic year                    |
   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
   * |  w  | Local week of year             |  W* | Week of month                  |
   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
   * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   *
   * Letters marked by ! are non-standard, but implemented by date-fns:
   * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
   *   i.e. 7 for Sunday, 1 for Monday, etc.
   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
   *   `R` is supposed to be used in conjunction with `I` and `i`
   *   for universal ISO week-numbering date, whereas
   *   `Y` is supposed to be used in conjunction with `w` and `e`
   *   for week-numbering date specific to the locale.
   * - `P` is long localized date format
   * - `p` is long localized time format
   */

};
var formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return _index.default.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = (0, _index6.default)(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return (0, _index7.default)(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return (0, _index7.default)(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = (0, _index4.default)(date); // Padding

    return (0, _index7.default)(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return (0, _index7.default)(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return (0, _index7.default)(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return (0, _index7.default)(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return _index.default.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return (0, _index7.default)(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = (0, _index5.default)(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return (0, _index7.default)(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = (0, _index3.default)(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return (0, _index7.default)(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return _index.default.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = (0, _index2.default)(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return (0, _index7.default)(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return (0, _index7.default)(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return (0, _index7.default)(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return (0, _index7.default)(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return _index.default.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return _index.default.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return (0, _index7.default)(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return (0, _index7.default)(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return _index.default.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return _index.default.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return _index.default.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return (0, _index7.default)(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return (0, _index7.default)(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + (0, _index7.default)(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + (0, _index7.default)(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = (0, _index7.default)(Math.floor(absOffset / 60), 2);
  var minutes = (0, _index7.default)(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

var _default = formatters;
exports.default = _default;
module.exports = exports.default;
}(formatters, formatters.exports));

var longFormatters = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var _default = longFormatters;
exports.default = _default;
module.exports = exports.default;
}(longFormatters, longFormatters.exports));

var getTimezoneOffsetInMilliseconds = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getTimezoneOffsetInMilliseconds;
var MILLISECONDS_IN_MINUTE = 60000;

function getDateMillisecondsPart(date) {
  return date.getTime() % MILLISECONDS_IN_MINUTE;
}
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */


function getTimezoneOffsetInMilliseconds(dirtyDate) {
  var date = new Date(dirtyDate.getTime());
  var baseTimezoneOffset = Math.ceil(date.getTimezoneOffset());
  date.setSeconds(0, 0);
  var hasNegativeUTCOffset = baseTimezoneOffset > 0;
  var millisecondsPartOfTimezoneOffset = hasNegativeUTCOffset ? (MILLISECONDS_IN_MINUTE + getDateMillisecondsPart(date)) % MILLISECONDS_IN_MINUTE : getDateMillisecondsPart(date);
  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset;
}

module.exports = exports.default;
}(getTimezoneOffsetInMilliseconds, getTimezoneOffsetInMilliseconds.exports));

var protectedTokens = {};

Object.defineProperty(protectedTokens, "__esModule", {
  value: true
});
protectedTokens.isProtectedDayOfYearToken = isProtectedDayOfYearToken;
protectedTokens.isProtectedWeekYearToken = isProtectedWeekYearToken;
protectedTokens.throwProtectedError = throwProtectedError;
var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];

function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}

function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}

function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = format;

var _index = _interopRequireDefault(isValid$1.exports);

var _index2 = _interopRequireDefault(enUS.exports);

var _index3 = _interopRequireDefault(subMilliseconds.exports);

var _index4 = _interopRequireDefault(toDate.exports);

var _index5 = _interopRequireDefault(formatters.exports);

var _index6 = _interopRequireDefault(longFormatters.exports);

var _index7 = _interopRequireDefault(getTimezoneOffsetInMilliseconds.exports);

var _index8 = protectedTokens;

var _index9 = _interopRequireDefault(toInteger.exports);

var _index10 = _interopRequireDefault(requiredArgs.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// This RegExp consists of three parts separated by `|`:
// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  (0, _index10.default)(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || _index2.default;
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : (0, _index9.default)(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : (0, _index9.default)(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : (0, _index9.default)(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : (0, _index9.default)(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = (0, _index4.default)(dirtyDate);

  if (!(0, _index.default)(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = (0, _index7.default)(originalDate);
  var utcDate = (0, _index3.default)(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = _index6.default[firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = _index5.default[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && (0, _index8.isProtectedWeekYearToken)(substring)) {
        (0, _index8.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && (0, _index8.isProtectedDayOfYearToken)(substring)) {
        (0, _index8.throwProtectedError)(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

module.exports = exports.default;
}(format$1, format$1.exports));

var format = /*@__PURE__*/getDefaultExportFromCjs(format$1.exports);

var formatDistanceStrict$1 = {exports: {}};

var compareAsc = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = compareAsc;

var _index = _interopRequireDefault(toDate.exports);

var _index2 = _interopRequireDefault(requiredArgs.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name compareAsc
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * const result = compareAsc(new Date(1987, 1, 11), new Date(1989, 6, 10))
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * const result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc(dirtyDateLeft, dirtyDateRight) {
  (0, _index2.default)(2, arguments);
  var dateLeft = (0, _index.default)(dirtyDateLeft);
  var dateRight = (0, _index.default)(dirtyDateRight);
  var diff = dateLeft.getTime() - dateRight.getTime();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}

module.exports = exports.default;
}(compareAsc, compareAsc.exports));

var differenceInSeconds = {exports: {}};

var differenceInMilliseconds = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = differenceInMilliseconds;

var _index = _interopRequireDefault(toDate.exports);

var _index2 = _interopRequireDefault(requiredArgs.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * var result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) {
  (0, _index2.default)(2, arguments);
  var dateLeft = (0, _index.default)(dirtyDateLeft);
  var dateRight = (0, _index.default)(dirtyDateRight);
  return dateLeft.getTime() - dateRight.getTime();
}

module.exports = exports.default;
}(differenceInMilliseconds, differenceInMilliseconds.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = differenceInSeconds;

var _index = _interopRequireDefault(differenceInMilliseconds.exports);

var _index2 = _interopRequireDefault(requiredArgs.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @name differenceInSeconds
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of seconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * var result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds(dirtyDateLeft, dirtyDateRight) {
  (0, _index2.default)(2, arguments);
  var diff = (0, _index.default)(dirtyDateLeft, dirtyDateRight) / 1000;
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
}

module.exports = exports.default;
}(differenceInSeconds, differenceInSeconds.exports));

var cloneObject = {exports: {}};

var assign = {exports: {}};

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = assign;

function assign(target, dirtyObject) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }

  dirtyObject = dirtyObject || {};

  for (var property in dirtyObject) {
    if (dirtyObject.hasOwnProperty(property)) {
      target[property] = dirtyObject[property];
    }
  }

  return target;
}

module.exports = exports.default;
}(assign, assign.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = cloneObject;

var _index = _interopRequireDefault(assign.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function cloneObject(dirtyObject) {
  return (0, _index.default)({}, dirtyObject);
}

module.exports = exports.default;
}(cloneObject, cloneObject.exports));

(function (module, exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = formatDistanceStrict;

var _index = _interopRequireDefault(getTimezoneOffsetInMilliseconds.exports);

var _index2 = _interopRequireDefault(compareAsc.exports);

var _index3 = _interopRequireDefault(toDate.exports);

var _index4 = _interopRequireDefault(differenceInSeconds.exports);

var _index5 = _interopRequireDefault(cloneObject.exports);

var _index6 = _interopRequireDefault(enUS.exports);

var _index7 = _interopRequireDefault(requiredArgs.exports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MINUTES_IN_DAY = 1440;
var MINUTES_IN_MONTH = 43200;
var MINUTES_IN_YEAR = 525600;
/**
 * @name formatDistanceStrict
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `formatDistance`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The function was renamed from `distanceInWordsStrict` to `formatDistanceStrict`
 *   to make its name consistent with `format` and `formatRelative`.
 *
 * - The order of arguments is swapped to make the function
 *   consistent with `differenceIn...` functions.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   distanceInWordsStrict(
 *     new Date(2015, 0, 2),
 *     new Date(2014, 6, 2)
 *   ) //=> '6 months'
 *
 *   // v2.0.0 onward
 *
 *   formatDistanceStrict(
 *     new Date(2014, 6, 2),
 *     new Date(2015, 0, 2)
 *   ) //=> '6 months'
 *   ```
 *
 * - `partialMethod` option is renamed to `roundingMethod`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   distanceInWordsStrict(
 *     new Date(1986, 3, 4, 10, 32, 0),
 *     new Date(1986, 3, 4, 10, 33, 1),
 *     { partialMethod: 'ceil' }
 *   ) //=> '2 minutes'
 *
 *   // v2.0.0 onward
 *
 *   formatDistanceStrict(
 *     new Date(1986, 3, 4, 10, 33, 1),
 *     new Date(1986, 3, 4, 10, 32, 0),
 *     { roundingMethod: 'ceil' }
 *   ) //=> '2 minutes'
 *   ```
 *
 * - If `roundingMethod` is not specified, it now defaults to `round` instead of `floor`.
 *
 * - `unit` option now accepts one of the strings:
 *   'second', 'minute', 'hour', 'day', 'month' or 'year' instead of 's', 'm', 'h', 'd', 'M' or 'Y'
 *
 *   ```javascript
 *   // Before v2.0.0
 *
 *   distanceInWordsStrict(
 *     new Date(1986, 3, 4, 10, 32, 0),
 *     new Date(1986, 3, 4, 10, 33, 1),
 *     { unit: 'm' }
 *   )
 *
 *   // v2.0.0 onward
 *
 *   formatDistanceStrict(
 *     new Date(1986, 3, 4, 10, 33, 1),
 *     new Date(1986, 3, 4, 10, 32, 0),
 *     { unit: 'minute' }
 *   )
 *   ```
 *
 * @param {Date|Number} date - the date
 * @param {Date|Number} baseDate - the date to compare with
 * @param {Object} [options] - an object with options.
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'second'|'minute'|'hour'|'day'|'month'|'year'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.roundingMethod='round'] - which way to round partial units
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @returns {String} the distance in words
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `baseDate` must not be Invalid Date
 * @throws {RangeError} `options.roundingMethod` must be 'floor', 'ceil' or 'round'
 * @throws {RangeError} `options.unit` must be 'second', 'minute', 'hour', 'day', 'month' or 'year'
 * @throws {RangeError} `options.locale` must contain `formatDistance` property
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = formatDistanceStrict(new Date(2014, 6, 2), new Date(2015, 0, 2))
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * var result = formatDistanceStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0)
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = formatDistanceStrict(new Date(2015, 0, 1), new Date(2016, 0, 1), {
 *   addSuffix: true
 * })
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * var result = formatDistanceStrict(new Date(2016, 0, 1), new Date(2015, 0, 1), {
 *   unit: 'minute'
 * })
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2015
 * // to 28 January 2015, in months, rounded up?
 * var result = formatDistanceStrict(new Date(2015, 0, 28), new Date(2015, 0, 1), {
 *   unit: 'month',
 *   roundingMethod: 'ceil'
 * })
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = formatDistanceStrict(new Date(2016, 7, 1), new Date(2015, 0, 1), {
 *   locale: eoLocale
 * })
 * //=> '1 jaro'
 */

function formatDistanceStrict(dirtyDate, dirtyBaseDate, dirtyOptions) {
  (0, _index7.default)(2, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale || _index6.default;

  if (!locale.formatDistance) {
    throw new RangeError('locale must contain localize.formatDistance property');
  }

  var comparison = (0, _index2.default)(dirtyDate, dirtyBaseDate);

  if (isNaN(comparison)) {
    throw new RangeError('Invalid time value');
  }

  var localizeOptions = (0, _index5.default)(options);
  localizeOptions.addSuffix = Boolean(options.addSuffix);
  localizeOptions.comparison = comparison;
  var dateLeft;
  var dateRight;

  if (comparison > 0) {
    dateLeft = (0, _index3.default)(dirtyBaseDate);
    dateRight = (0, _index3.default)(dirtyDate);
  } else {
    dateLeft = (0, _index3.default)(dirtyDate);
    dateRight = (0, _index3.default)(dirtyBaseDate);
  }

  var roundingMethod = options.roundingMethod == null ? 'round' : String(options.roundingMethod);
  var roundingMethodFn;

  if (roundingMethod === 'floor') {
    roundingMethodFn = Math.floor;
  } else if (roundingMethod === 'ceil') {
    roundingMethodFn = Math.ceil;
  } else if (roundingMethod === 'round') {
    roundingMethodFn = Math.round;
  } else {
    throw new RangeError("roundingMethod must be 'floor', 'ceil' or 'round'");
  }

  var seconds = (0, _index4.default)(dateRight, dateLeft);
  var offsetInSeconds = ((0, _index.default)(dateRight) - (0, _index.default)(dateLeft)) / 1000;
  var minutes = roundingMethodFn((seconds - offsetInSeconds) / 60);
  var unit;

  if (options.unit == null) {
    if (minutes < 1) {
      unit = 'second';
    } else if (minutes < 60) {
      unit = 'minute';
    } else if (minutes < MINUTES_IN_DAY) {
      unit = 'hour';
    } else if (minutes < MINUTES_IN_MONTH) {
      unit = 'day';
    } else if (minutes < MINUTES_IN_YEAR) {
      unit = 'month';
    } else {
      unit = 'year';
    }
  } else {
    unit = String(options.unit);
  } // 0 up to 60 seconds


  if (unit === 'second') {
    return locale.formatDistance('xSeconds', seconds, localizeOptions); // 1 up to 60 mins
  } else if (unit === 'minute') {
    return locale.formatDistance('xMinutes', minutes, localizeOptions); // 1 up to 24 hours
  } else if (unit === 'hour') {
    var hours = roundingMethodFn(minutes / 60);
    return locale.formatDistance('xHours', hours, localizeOptions); // 1 up to 30 days
  } else if (unit === 'day') {
    var days = roundingMethodFn(minutes / MINUTES_IN_DAY);
    return locale.formatDistance('xDays', days, localizeOptions); // 1 up to 12 months
  } else if (unit === 'month') {
    var months = roundingMethodFn(minutes / MINUTES_IN_MONTH);
    return locale.formatDistance('xMonths', months, localizeOptions); // 1 year up to max Date
  } else if (unit === 'year') {
    var years = roundingMethodFn(minutes / MINUTES_IN_YEAR);
    return locale.formatDistance('xYears', years, localizeOptions);
  }

  throw new RangeError("unit must be 'second', 'minute', 'hour', 'day', 'month' or 'year'");
}

module.exports = exports.default;
}(formatDistanceStrict$1, formatDistanceStrict$1.exports));

var formatDistanceStrict = /*@__PURE__*/getDefaultExportFromCjs(formatDistanceStrict$1.exports);

var eventemitter3 = {exports: {}};

(function (module) {

var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Add a listener for a given event.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} context The context to invoke the listener with.
 * @param {Boolean} once Specify if the listener is a one-time listener.
 * @returns {EventEmitter}
 * @private
 */
function addListener(emitter, event, fn, context, once) {
  if (typeof fn !== 'function') {
    throw new TypeError('The listener must be a function');
  }

  var listener = new EE(fn, context || emitter, once)
    , evt = prefix ? prefix + event : event;

  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
  else emitter._events[evt] = [emitter._events[evt], listener];

  return emitter;
}

/**
 * Clear event by name.
 *
 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
 * @param {(String|Symbol)} evt The Event name.
 * @private
 */
function clearEvent(emitter, evt) {
  if (--emitter._eventsCount === 0) emitter._events = new Events();
  else delete emitter._events[evt];
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Array} The registered listeners.
 * @public
 */
EventEmitter.prototype.listeners = function listeners(event) {
  var evt = prefix ? prefix + event : event
    , handlers = this._events[evt];

  if (!handlers) return [];
  if (handlers.fn) return [handlers.fn];

  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
    ee[i] = handlers[i].fn;
  }

  return ee;
};

/**
 * Return the number of listeners listening to a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Number} The number of listeners.
 * @public
 */
EventEmitter.prototype.listenerCount = function listenerCount(event) {
  var evt = prefix ? prefix + event : event
    , listeners = this._events[evt];

  if (!listeners) return 0;
  if (listeners.fn) return 1;
  return listeners.length;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  return addListener(this, event, fn, context, false);
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn The listener function.
 * @param {*} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  return addListener(this, event, fn, context, true);
};

/**
 * Remove the listeners of a given event.
 *
 * @param {(String|Symbol)} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {*} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    clearEvent(this, evt);
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
      listeners.fn === fn &&
      (!once || listeners.once) &&
      (!context || listeners.context === context)
    ) {
      clearEvent(this, evt);
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
        listeners[i].fn !== fn ||
        (once && !listeners[i].once) ||
        (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else clearEvent(this, evt);
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {(String|Symbol)} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) clearEvent(this, evt);
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
{
  module.exports = EventEmitter;
}
}(eventemitter3));

var r$1 = eventemitter3.exports;

// do not edit .js files directly - edit src/index.jst



var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ID = "__googleMapsScriptId";
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then(() => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */
class Loader$2 {
    /**
     * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
     * using this library, instead the defaults are set by the Google Maps
     * JavaScript API server.
     *
     * ```
     * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
     * ```
     */
    constructor({ apiKey, channel, client, id = DEFAULT_ID, libraries = [], language, region, version, mapIds, nonce, retries = 3, url = "https://maps.googleapis.com/maps/api/js", }) {
        this.CALLBACK = "__googleMapsCallback";
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.version = version;
        this.apiKey = apiKey;
        this.channel = channel;
        this.client = client;
        this.id = id || DEFAULT_ID; // Do not allow empty string
        this.libraries = libraries;
        this.language = language;
        this.region = region;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.retries = retries;
        this.url = url;
        if (Loader$2.instance) {
            if (!fastDeepEqual(this.options, Loader$2.instance.options)) {
                throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(Loader$2.instance.options)}`);
            }
            return Loader$2.instance;
        }
        Loader$2.instance = this;
    }
    get options() {
        return {
            version: this.version,
            apiKey: this.apiKey,
            channel: this.channel,
            client: this.client,
            id: this.id,
            libraries: this.libraries,
            language: this.language,
            region: this.region,
            mapIds: this.mapIds,
            nonce: this.nonce,
            url: this.url,
        };
    }
    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     */
    createUrl() {
        let url = this.url;
        url += `?callback=${this.CALLBACK}`;
        if (this.apiKey) {
            url += `&key=${this.apiKey}`;
        }
        if (this.channel) {
            url += `&channel=${this.channel}`;
        }
        if (this.client) {
            url += `&client=${this.client}`;
        }
        if (this.libraries.length > 0) {
            url += `&libraries=${this.libraries.join(",")}`;
        }
        if (this.language) {
            url += `&language=${this.language}`;
        }
        if (this.region) {
            url += `&region=${this.region}`;
        }
        if (this.version) {
            url += `&v=${this.version}`;
        }
        if (this.mapIds) {
            url += `&map_ids=${this.mapIds.join(",")}`;
        }
        return url;
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     */
    load() {
        return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     */
    loadPromise() {
        return new Promise((resolve, reject) => {
            this.loadCallback((err) => {
                if (!err) {
                    resolve();
                }
                else {
                    reject(err);
                }
            });
        });
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     */
    loadCallback(fn) {
        this.callbacks.push(fn);
        this.execute();
    }
    /**
     * Set the script on document.
     */
    setScript() {
        if (document.getElementById(this.id)) {
            // TODO wrap onerror callback for cases where the script was loaded elsewhere
            this.callback();
            return;
        }
        const url = this.createUrl();
        const script = document.createElement("script");
        script.id = this.id;
        script.type = "text/javascript";
        script.src = url;
        script.onerror = this.loadErrorCallback.bind(this);
        script.defer = true;
        script.async = true;
        if (this.nonce) {
            script.nonce = this.nonce;
        }
        document.head.appendChild(script);
    }
    deleteScript() {
        const script = document.getElementById(this.id);
        if (script) {
            script.remove();
        }
    }
    resetIfRetryingFailed() {
        const possibleAttempts = this.retries + 1;
        if (this.done && !this.loading && this.errors.length >= possibleAttempts) {
            this.deleteScript();
            this.done = false;
            this.loading = false;
            this.errors = [];
            this.onerrorEvent = null;
        }
    }
    loadErrorCallback(e) {
        this.errors.push(e);
        if (this.errors.length <= this.retries) {
            const delay = this.errors.length * Math.pow(2, this.errors.length);
            console.log(`Failed to load Google Maps script, retrying in ${delay} ms.`);
            setTimeout(() => {
                this.deleteScript();
                this.setScript();
            }, delay);
        }
        else {
            this.onerrorEvent = e;
            this.callback();
        }
    }
    setCallback() {
        window.__googleMapsCallback = this.callback.bind(this);
    }
    callback() {
        this.done = true;
        this.loading = false;
        this.callbacks.forEach((cb) => {
            cb(this.onerrorEvent);
        });
        this.callbacks = [];
    }
    execute() {
        if (window.google && window.google.maps && window.google.maps.version) {
            console.warn("Google Maps already loaded outside @googlemaps/js-api-loader." +
                "This may result in undesirable behavior as options and script parameters may not match.");
            this.callback();
        }
        this.resetIfRetryingFailed();
        if (this.done) {
            this.callback();
        }
        else {
            if (this.loading) ;
            else {
                this.loading = true;
                this.setCallback();
                this.setScript();
            }
        }
    }
}

var pointGeometry = Point;

/**
 * A standalone point geometry with useful accessor, comparison, and
 * modification methods.
 *
 * @class Point
 * @param {Number} x the x-coordinate. this could be longitude or screen
 * pixels, or any other sort of unit.
 * @param {Number} y the y-coordinate. this could be latitude or screen
 * pixels, or any other sort of unit.
 * @example
 * var point = new Point(-77, 38);
 */
function Point(x, y) {
    this.x = x;
    this.y = y;
}

Point.prototype = {

    /**
     * Clone this point, returning a new point that can be modified
     * without affecting the old one.
     * @return {Point} the clone
     */
    clone: function() { return new Point(this.x, this.y); },

    /**
     * Add this point's x & y coordinates to another point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    add:     function(p) { return this.clone()._add(p); },

    /**
     * Subtract this point's x & y coordinates to from point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    sub:     function(p) { return this.clone()._sub(p); },

    /**
     * Multiply this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    multByPoint:    function(p) { return this.clone()._multByPoint(p); },

    /**
     * Divide this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    divByPoint:     function(p) { return this.clone()._divByPoint(p); },

    /**
     * Multiply this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {Point} k factor
     * @return {Point} output point
     */
    mult:    function(k) { return this.clone()._mult(k); },

    /**
     * Divide this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {Point} k factor
     * @return {Point} output point
     */
    div:     function(k) { return this.clone()._div(k); },

    /**
     * Rotate this point around the 0, 0 origin by an angle a,
     * given in radians
     * @param {Number} a angle to rotate around, in radians
     * @return {Point} output point
     */
    rotate:  function(a) { return this.clone()._rotate(a); },

    /**
     * Rotate this point around p point by an angle a,
     * given in radians
     * @param {Number} a angle to rotate around, in radians
     * @param {Point} p Point to rotate around
     * @return {Point} output point
     */
    rotateAround:  function(a,p) { return this.clone()._rotateAround(a,p); },

    /**
     * Multiply this point by a 4x1 transformation matrix
     * @param {Array<Number>} m transformation matrix
     * @return {Point} output point
     */
    matMult: function(m) { return this.clone()._matMult(m); },

    /**
     * Calculate this point but as a unit vector from 0, 0, meaning
     * that the distance from the resulting point to the 0, 0
     * coordinate will be equal to 1 and the angle from the resulting
     * point to the 0, 0 coordinate will be the same as before.
     * @return {Point} unit vector point
     */
    unit:    function() { return this.clone()._unit(); },

    /**
     * Compute a perpendicular point, where the new y coordinate
     * is the old x coordinate and the new x coordinate is the old y
     * coordinate multiplied by -1
     * @return {Point} perpendicular point
     */
    perp:    function() { return this.clone()._perp(); },

    /**
     * Return a version of this point with the x & y coordinates
     * rounded to integers.
     * @return {Point} rounded point
     */
    round:   function() { return this.clone()._round(); },

    /**
     * Return the magitude of this point: this is the Euclidean
     * distance from the 0, 0 coordinate to this point's x and y
     * coordinates.
     * @return {Number} magnitude
     */
    mag: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    },

    /**
     * Judge whether this point is equal to another point, returning
     * true or false.
     * @param {Point} other the other point
     * @return {boolean} whether the points are equal
     */
    equals: function(other) {
        return this.x === other.x &&
               this.y === other.y;
    },

    /**
     * Calculate the distance from this point to another point
     * @param {Point} p the other point
     * @return {Number} distance
     */
    dist: function(p) {
        return Math.sqrt(this.distSqr(p));
    },

    /**
     * Calculate the distance from this point to another point,
     * without the square root step. Useful if you're comparing
     * relative distances.
     * @param {Point} p the other point
     * @return {Number} distance
     */
    distSqr: function(p) {
        var dx = p.x - this.x,
            dy = p.y - this.y;
        return dx * dx + dy * dy;
    },

    /**
     * Get the angle from the 0, 0 coordinate to this point, in radians
     * coordinates.
     * @return {Number} angle
     */
    angle: function() {
        return Math.atan2(this.y, this.x);
    },

    /**
     * Get the angle from this point to another point, in radians
     * @param {Point} b the other point
     * @return {Number} angle
     */
    angleTo: function(b) {
        return Math.atan2(this.y - b.y, this.x - b.x);
    },

    /**
     * Get the angle between this point and another point, in radians
     * @param {Point} b the other point
     * @return {Number} angle
     */
    angleWith: function(b) {
        return this.angleWithSep(b.x, b.y);
    },

    /*
     * Find the angle of the two vectors, solving the formula for
     * the cross product a x b = |a||b|sin(θ) for θ.
     * @param {Number} x the x-coordinate
     * @param {Number} y the y-coordinate
     * @return {Number} the angle in radians
     */
    angleWithSep: function(x, y) {
        return Math.atan2(
            this.x * y - this.y * x,
            this.x * x + this.y * y);
    },

    _matMult: function(m) {
        var x = m[0] * this.x + m[1] * this.y,
            y = m[2] * this.x + m[3] * this.y;
        this.x = x;
        this.y = y;
        return this;
    },

    _add: function(p) {
        this.x += p.x;
        this.y += p.y;
        return this;
    },

    _sub: function(p) {
        this.x -= p.x;
        this.y -= p.y;
        return this;
    },

    _mult: function(k) {
        this.x *= k;
        this.y *= k;
        return this;
    },

    _div: function(k) {
        this.x /= k;
        this.y /= k;
        return this;
    },

    _multByPoint: function(p) {
        this.x *= p.x;
        this.y *= p.y;
        return this;
    },

    _divByPoint: function(p) {
        this.x /= p.x;
        this.y /= p.y;
        return this;
    },

    _unit: function() {
        this._div(this.mag());
        return this;
    },

    _perp: function() {
        var y = this.y;
        this.y = this.x;
        this.x = -y;
        return this;
    },

    _rotate: function(angle) {
        var cos = Math.cos(angle),
            sin = Math.sin(angle),
            x = cos * this.x - sin * this.y,
            y = sin * this.x + cos * this.y;
        this.x = x;
        this.y = y;
        return this;
    },

    _rotateAround: function(angle, p) {
        var cos = Math.cos(angle),
            sin = Math.sin(angle),
            x = p.x + cos * (this.x - p.x) - sin * (this.y - p.y),
            y = p.y + sin * (this.x - p.x) + cos * (this.y - p.y);
        this.x = x;
        this.y = y;
        return this;
    },

    _round: function() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
};

/**
 * Construct a point from an array if necessary, otherwise if the input
 * is already a Point, or an unknown type, return it unchanged
 * @param {Array<Number>|Point|*} a any kind of input value
 * @return {Point} constructed point, or passed-through value.
 * @example
 * // this
 * var point = Point.convert([0, 1]);
 * // is equivalent to
 * var point = new Point(0, 1);
 */
Point.convert = function (a) {
    if (a instanceof Point) {
        return a;
    }
    if (Array.isArray(a)) {
        return new Point(a[0], a[1]);
    }
    return a;
};

var s$1 = pointGeometry;

function a$1(){return (a$1=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var n in o)Object.prototype.hasOwnProperty.call(o,n)&&(e[n]=o[n]);}return e}).apply(this,arguments)}function p$1(e,t){e.prototype=Object.create(t.prototype),e.prototype.constructor=e,e.__proto__=t;}function l$1(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var u$1={width:"100%",height:"100%",left:0,top:0,margin:0,padding:0,position:"absolute"},h$1=function(t){function o(){return t.apply(this,arguments)||this}p$1(o,t);var n=o.prototype;return n.shouldComponentUpdate=function(){return !1},n.render=function(){return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("div",{ref:this.props.registerChild,style:u$1})},o}(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Component),c$1=function(e){function t(t){var o;return (o=e.call(this)||this).gmapInstance=t,o}p$1(t,e);var o=t.prototype;return o.getChildren=function(){return this.gmapInstance.props.children},o.getMousePosition=function(){return this.gmapInstance.mouse_},o.getUpdateCounter=function(){return this.gmapInstance.updateCounter_},o.dispose=function(){this.gmapInstance=null,this.removeAllListeners();},t}(r$1),d$1=function(e,t){for(var o=a$1({},e),n=0;n<t.length;n++){var r=t[n];r in o&&delete o[r];}return o},m$1=Object.prototype.hasOwnProperty;function g$1(e,t){return e===t?0!==e||0!==t||1/e==1/t:e!=e&&t!=t}function _$1(e,t){if(g$1(e,t))return !0;if("object"!=typeof e||null===e||"object"!=typeof t||null===t)return !1;var o=Object.keys(e),n=Object.keys(t);if(o.length!==n.length)return !1;for(var r=0;r<o.length;r++)if(!m$1.call(t,o[r])||!g$1(e[o[r]],t[o[r]]))return !1;return !0}var f$1={width:"100%",height:"100%",left:0,top:0,margin:0,padding:0,position:"absolute"},v$1={width:0,height:0,left:0,top:0,backgroundColor:"transparent",position:"absolute"},M$1=function(t){function o(o){var n;return (n=t.call(this,o)||this)._getState=function(){return {children:n.props.dispatcher.getChildren(),updateCounter:n.props.dispatcher.getUpdateCounter()}},n._onChangeHandler=function(){if(n.dimensionsCache_){var e=(n.state.children||[]).length,t=n._getState();n.setState(t,function(){return (t.children||[]).length!==e&&n._onMouseChangeHandler()});}},n._onChildClick=function(){n.props.onChildClick&&n.hoverChildProps_&&n.props.onChildClick(n.hoverKey_,n.hoverChildProps_);},n._onChildMouseDown=function(){n.props.onChildMouseDown&&n.hoverChildProps_&&n.props.onChildMouseDown(n.hoverKey_,n.hoverChildProps_);},n._onChildMouseEnter=function(e,t){n.dimensionsCache_&&(n.props.onChildMouseEnter&&n.props.onChildMouseEnter(e,t),n.hoverChildProps_=t,n.hoverKey_=e,n.setState({hoverKey:e}));},n._onChildMouseLeave=function(){if(n.dimensionsCache_){var e=n.hoverKey_;null!=e&&(n.props.onChildMouseLeave&&n.props.onChildMouseLeave(e,n.hoverChildProps_),n.hoverKey_=null,n.hoverChildProps_=null,n.setState({hoverKey:null}));}},n._onMouseAllow=function(e){e||n._onChildMouseLeave(),n.allowMouse_=e;},n._onMouseChangeHandler=function(){n.allowMouse_&&n._onMouseChangeHandlerRaf();},n._onMouseChangeHandlerRaf=function(){if(n.dimensionsCache_){var t=n.props.dispatcher.getMousePosition();if(t){var o=[],r=n.props.getHoverDistance();if(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Children.forEach(n.state.children,function(e,i){if(e&&(void 0!==e.props.latLng||void 0!==e.props.lat||void 0!==e.props.lng)){var s=null!=e.key?e.key:i,a=n.props.distanceToMouse(n.dimensionsCache_[s],t,e.props);a<r&&o.push({key:s,dist:a,props:e.props});}}),o.length){o.sort(function(e,t){return e.dist-t.dist});var i=o[0].key,s=o[0].props;n.hoverKey_!==i&&(n._onChildMouseLeave(),n._onChildMouseEnter(i,s));}else n._onChildMouseLeave();}else n._onChildMouseLeave();}},n._getDimensions=function(e){return n.dimensionsCache_[e]},n.dimensionsCache_={},n.hoverKey_=null,n.hoverChildProps_=null,n.allowMouse_=!0,n.state=a$1({},n._getState(),{hoverKey:null}),n}p$1(o,t);var n=o.prototype;return n.componentDidMount=function(){this.props.dispatcher.on("kON_CHANGE",this._onChangeHandler),this.props.dispatcher.on("kON_MOUSE_POSITION_CHANGE",this._onMouseChangeHandler),this.props.dispatcher.on("kON_CLICK",this._onChildClick),this.props.dispatcher.on("kON_MDOWN",this._onChildMouseDown);},n.shouldComponentUpdate=function(e,t){return !0===this.props.experimental?!_$1(this.props,e)||!_$1(d$1(this.state,["hoverKey"]),d$1(t,["hoverKey"])):!_$1(this.props,e)||!_$1(this.state,t)},n.componentWillUnmount=function(){this.props.dispatcher.removeListener("kON_CHANGE",this._onChangeHandler),this.props.dispatcher.removeListener("kON_MOUSE_POSITION_CHANGE",this._onMouseChangeHandler),this.props.dispatcher.removeListener("kON_CLICK",this._onChildClick),this.props.dispatcher.removeListener("kON_MDOWN",this._onChildMouseDown),this.dimensionsCache_=null;},n.render=function(){var t=this,o=this.props.style||f$1;this.dimensionsCache_={};var n=_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Children.map(this.state.children,function(o,n){if(o){if(void 0===o.props.latLng&&void 0===o.props.lat&&void 0===o.props.lng)return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.cloneElement(o,{$geoService:t.props.geoService,$onMouseAllow:t._onMouseAllow,$prerender:t.props.prerender});var r=void 0!==o.props.latLng?o.props.latLng:{lat:o.props.lat,lng:o.props.lng},i=t.props.insideMapPanes?t.props.geoService.fromLatLngToDivPixel(r):t.props.geoService.fromLatLngToCenterPixel(r),s={left:i.x,top:i.y};if(void 0!==o.props.seLatLng||void 0!==o.props.seLat&&void 0!==o.props.seLng){var p=void 0!==o.props.seLatLng?o.props.seLatLng:{lat:o.props.seLat,lng:o.props.seLng},l=t.props.insideMapPanes?t.props.geoService.fromLatLngToDivPixel(p):t.props.geoService.fromLatLngToCenterPixel(p);s.width=l.x-i.x,s.height=l.y-i.y;}var u=t.props.geoService.fromLatLngToContainerPixel(r),h=null!=o.key?o.key:n;return t.dimensionsCache_[h]=a$1({x:u.x,y:u.y},r),_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("div",{key:h,style:a$1({},v$1,s),className:o.props.$markerHolderClassName},_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.cloneElement(o,{$hover:h===t.state.hoverKey,$getDimensions:t._getDimensions,$dimensionKey:h,$geoService:t.props.geoService,$onMouseAllow:t._onMouseAllow,$prerender:t.props.prerender}))}});return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("div",{style:o},n)},o}(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Component);M$1.propTypes={geoService:PropTypes.any,style:PropTypes.any,distanceToMouse:PropTypes.func,dispatcher:PropTypes.any,onChildClick:PropTypes.func,onChildMouseDown:PropTypes.func,onChildMouseLeave:PropTypes.func,onChildMouseEnter:PropTypes.func,getHoverDistance:PropTypes.func,insideMapPanes:PropTypes.bool,prerender:PropTypes.bool},M$1.defaultProps={insideMapPanes:!1,prerender:!1};var y$1={width:"50%",height:"50%",left:"50%",top:"50%",margin:0,padding:0,position:"absolute"};function C$1(t){return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("div",{style:y$1},_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(M$1,a$1({},t,{prerender:!0})))}var w$1,L$1,b$1,D$1=new Promise(function(e){b$1=e;}),z$1=function(e,t){if(!e)return D$1;if(L$1)return L$1;e.libraries||(e.libraries=[]);var o=[].concat(e.libraries);if(t&&(0!==o.length&&o.includes("visualization")||o.push("visualization"),console.warn("heatmapLibrary will be deprecated in the future. Please use { libraries: ['visualization'] } in bootstrapURLKeys property instead")),"production"!=="production");if("undefined"==typeof window)throw new Error("google map cannot be loaded outside browser env");var r=e.key,s=function(e,t){if(null==e)return {};var o,n,r={},i=Object.keys(e);for(n=0;n<i.length;n++)t.indexOf(o=i[n])>=0||(r[o]=e[o]);return r}(e,["key"]);return w$1||(w$1=new Loader$2(a$1({apiKey:r||""},s,{libraries:o}))),L$1=w$1.load().then(function(){return b$1(window.google.maps),window.google.maps}),b$1(L$1),L$1};function k$1(e,t,o){var n=o-t;return e===o?e:((e-t)%n+n)%n+t}var O$1=function(){function e(e,t){if(isNaN(e)||isNaN(t))throw new Error("Invalid LatLng object: ("+e+", "+t+")");this.lat=+e,this.lng=+t;}return e.prototype.wrap=function(){return new e(this.lat,k$1(this.lng,-180,180))},e}();O$1.convert=function(e){return e instanceof O$1?e:Array.isArray(e)?new O$1(e[0],e[1]):"lng"in e&&"lat"in e?new O$1(e.lat,e.lng):e};var x$1=function(){function e(e,t,o){this.tileSize=e||512,this._minZoom=t||0,this._maxZoom=o||52,this.latRange=[-85.05113,85.05113],this.width=0,this.height=0,this.zoom=0,this.center=new O$1(0,0),this.angle=0;}var t,o=e.prototype;return o.zoomScale=function(e){return Math.pow(2,e)},o.scaleZoom=function(e){return Math.log(e)/Math.LN2},o.project=function(e,t){return new s$1(this.lngX(e.lng,t),this.latY(e.lat,t))},o.unproject=function(e,t){return new O$1(this.yLat(e.y,t),this.xLng(e.x,t))},o.lngX=function(e,t){return (180+e)*(t||this.worldSize)/360},o.latY=function(e,t){return (180-180/Math.PI*Math.log(Math.tan(Math.PI/4+e*Math.PI/360)))*(t||this.worldSize)/360},o.xLng=function(e,t){return 360*e/(t||this.worldSize)-180},o.yLat=function(e,t){return 360/Math.PI*Math.atan(Math.exp((180-360*e/(t||this.worldSize))*Math.PI/180))-90},o.locationPoint=function(e){var t=this.project(e);return this.centerPoint._sub(this.point._sub(t)._rotate(this.angle))},o.pointLocation=function(e){var t=this.centerPoint._sub(e)._rotate(-this.angle);return this.unproject(this.point.sub(t))},(t=[{key:"minZoom",get:function(){return this._minZoom},set:function(e){this._minZoom=e,this.zoom=Math.max(this.zoom,e);}},{key:"maxZoom",get:function(){return this._maxZoom},set:function(e){this._maxZoom=e,this.zoom=Math.min(this.zoom,e);}},{key:"worldSize",get:function(){return this.tileSize*this.scale}},{key:"centerPoint",get:function(){return new s$1(0,0)}},{key:"size",get:function(){return new s$1(this.width,this.height)}},{key:"bearing",get:function(){return -this.angle/Math.PI*180},set:function(e){this.angle=-k$1(e,-180,180)*Math.PI/180;}},{key:"zoom",get:function(){return this._zoom},set:function(e){var t=Math.min(Math.max(e,this.minZoom),this.maxZoom);this._zoom=t,this.scale=this.zoomScale(t),this.tileZoom=Math.floor(t),this.zoomFraction=t-this.tileZoom;}},{key:"x",get:function(){return this.lngX(this.center.lng)}},{key:"y",get:function(){return this.latY(this.center.lat)}},{key:"point",get:function(){return new s$1(this.x,this.y)}}])&&function(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}(e.prototype,t),e}(),T$1=function(){function e(e){this.hasSize_=!1,this.hasView_=!1,this.transform_=new x$1(e||512);}var t=e.prototype;return t.setView=function(e,t,o){this.transform_.center=O$1.convert(e),this.transform_.zoom=+t,this.transform_.bearing=+o,this.hasView_=!0;},t.setViewSize=function(e,t){this.transform_.width=e,this.transform_.height=t,this.hasSize_=!0;},t.setMapCanvasProjection=function(e,t){this.maps_=e,this.mapCanvasProjection_=t;},t.canProject=function(){return this.hasSize_&&this.hasView_},t.hasSize=function(){return this.hasSize_},t.fromLatLngToCenterPixel=function(e){return this.transform_.locationPoint(O$1.convert(e))},t.fromLatLngToDivPixel=function(e){if(this.mapCanvasProjection_){var t=new this.maps_.LatLng(e.lat,e.lng);return this.mapCanvasProjection_.fromLatLngToDivPixel(t)}return this.fromLatLngToCenterPixel(e)},t.fromLatLngToContainerPixel=function(e){if(this.mapCanvasProjection_){var t=new this.maps_.LatLng(e.lat,e.lng);return this.mapCanvasProjection_.fromLatLngToContainerPixel(t)}var o=this.fromLatLngToCenterPixel(e);return o.x-=this.transform_.worldSize*Math.round(o.x/this.transform_.worldSize),o.x+=this.transform_.width/2,o.y+=this.transform_.height/2,o},t.fromContainerPixelToLatLng=function(e){if(this.mapCanvasProjection_){var t=this.mapCanvasProjection_.fromContainerPixelToLatLng(e);return {lat:t.lat(),lng:t.lng()}}var o=a$1({},e);o.x-=this.transform_.width/2,o.y-=this.transform_.height/2;var n=this.transform_.pointLocation(s$1.convert(o));return n.lng-=360*Math.round(n.lng/360),n},t.getWidth=function(){return this.transform_.width},t.getHeight=function(){return this.transform_.height},t.getZoom=function(){return this.transform_.zoom},t.getCenter=function(){return this.transform_.pointLocation({x:0,y:0})},t.getBounds=function(e,t){var o=e&&e[0]||0,n=e&&e[1]||0,r=e&&e[2]||0,i=e&&e[3]||0;if(this.getWidth()-n-i>0&&this.getHeight()-o-r>0){var a=this.transform_.pointLocation(s$1.convert({x:i-this.getWidth()/2,y:o-this.getHeight()/2})),p=this.transform_.pointLocation(s$1.convert({x:this.getWidth()/2-n,y:this.getHeight()/2-r})),l=[a.lat,a.lng,p.lat,p.lng,p.lat,a.lng,a.lat,p.lng];return t&&(l=l.map(function(e){return Math.round(e*t)/t})),l}return [0,0,0,0]},e}();function S$1(e){if(window.requestAnimationFrame)return window.requestAnimationFrame(e);var t=window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame;return t?t(e):window.setTimeout(e,1e3/60)}var E$1=Math.log2?Math.log2:function(e){return Math.log(e)/Math.LN2};function P$1(e,t){return Object.keys(e).reduce(function(o,n){return t(e[n])&&(o[n]=e[n]),o},{})}var A$1=function(e){if(null!==e&&"object"==typeof e){if(0===Object.keys(e).length)return !0}else if(null==e||""===e)return !0;return !1},I$1=Object.prototype.toString;function N$1(e){return "number"==typeof e||function(e){return !!e&&"object"==typeof e}(e)&&"[object Number]"===I$1.call(e)}var Z$1=null;function j$1(){if(Z$1)return Z$1;if("undefined"!=typeof navigator){var e=navigator.userAgent.indexOf("MSIE")>-1,t=navigator.userAgent.indexOf("Firefox")>-1,o=navigator.userAgent.toLowerCase().indexOf("op")>-1,n=navigator.userAgent.indexOf("Chrome")>-1,r=navigator.userAgent.indexOf("Safari")>-1;return n&&r&&(r=!1),n&&o&&(n=!1),Z$1={isExplorer:e,isFirefox:t,isOpera:o,isChrome:n,isSafari:r}}return Z$1={isChrome:!0,isExplorer:!1,isFirefox:!1,isOpera:!1,isSafari:!1}}var U$1=function(e){return Function.prototype.toString.call(e)};function H$1(e){if(!e||"object"!=typeof e)return !1;var t="function"==typeof e.constructor?Object.getPrototypeOf(e):Object.prototype;if(null===t)return !0;var o=t.constructor;return "function"==typeof o&&o instanceof o&&U$1(o)===U$1(Object)}function K$1(e,t,o,n){e.addEventListener(t,o,function(){var e=!1;try{var t=Object.defineProperty({},"passive",{get:function(){e=!0;}});window.addEventListener("test",t,t),window.removeEventListener("test",t,t);}catch(t){e=!1;}return e}()?{capture:n,passive:!0}:n);}var R$1,G$1=!("undefined"==typeof window||!window.document||!window.document.createElement);R$1=G$1?window:"undefined"!=typeof self?self:void 0;var B$1,W$1="undefined"!=typeof document&&document.attachEvent,V$1=!1;if(G$1&&!W$1){var F$1=function(){var e=R$1.requestAnimationFrame||R$1.mozRequestAnimationFrame||R$1.webkitRequestAnimationFrame||function(e){return R$1.setTimeout(e,20)};return function(t){return e(t)}}(),$$1=(B$1=R$1.cancelAnimationFrame||R$1.mozCancelAnimationFrame||R$1.webkitCancelAnimationFrame||R$1.clearTimeout,function(e){return B$1(e)}),q$1=function(e){var t=e.__resizeTriggers__,o=t.firstElementChild,n=t.lastElementChild,r=o.firstElementChild;n.scrollLeft=n.scrollWidth,n.scrollTop=n.scrollHeight,r.style.width=o.offsetWidth+1+"px",r.style.height=o.offsetHeight+1+"px",o.scrollLeft=o.scrollWidth,o.scrollTop=o.scrollHeight;},Y$1=function(e){var t=this;q$1(this),this.__resizeRAF__&&$$1(this.__resizeRAF__),this.__resizeRAF__=F$1(function(){(function(e){return e.offsetWidth!=e.__resizeLast__.width||e.offsetHeight!=e.__resizeLast__.height})(t)&&(t.__resizeLast__.width=t.offsetWidth,t.__resizeLast__.height=t.offsetHeight,t.__resizeListeners__.forEach(function(o){o.call(t,e);}));});},X$1=!1,J$1="",Q$1="animationstart",ee$1="Webkit Moz O ms".split(" "),te$1="webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" ");if(G$1){var oe$1=document.createElement("fakeelement");if(void 0!==oe$1.style.animationName&&(X$1=!0),!1===X$1)for(var ne$1=0;ne$1<ee$1.length;ne$1++)if(void 0!==oe$1.style[ee$1[ne$1]+"AnimationName"]){J$1="-"+ee$1[ne$1].toLowerCase()+"-",Q$1=te$1[ne$1],X$1=!0;break}}var re$1="resizeanim",ie$1="@"+J$1+"keyframes "+re$1+" { from { opacity: 0; } to { opacity: 0; } } ",se$1=J$1+"animation: 1ms "+re$1+"; ";}var ae$1=void 0!==_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.a.createPortal,pe$1=ae$1?_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.a.createPortal:_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.a.unstable_renderSubtreeIntoContainer,le$1=function(e){return H$1(e)?e:{lat:e[0],lng:e[1]}},ue$1=function(e,t){return t<e?e:t},he$1=function(t){function o(o){var r;if((r=t.call(this,o)||this)._getMinZoom=function(){if(r.geoService_.getWidth()>0||r.geoService_.getHeight()>0){var e=Math.ceil(r.geoService_.getWidth()/256)+2,t=Math.ceil(r.geoService_.getHeight()/256)+2,o=Math.max(e,t);return Math.ceil(E$1(o))}return 3},r._computeMinZoom=function(e){return A$1(e)?r._getMinZoom():e},r._mapDomResizeCallback=function(){if(r.resetSizeOnIdle_=!0,r.maps_){var e=r.props.center||r.props.defaultCenter,t=r.map_.getCenter();r.maps_.event.trigger(r.map_,"resize"),r.map_.setCenter(r.props.resetBoundsOnResize?e:t);}},r._setLayers=function(e){e.forEach(function(e){r.layers_[e]=new r.maps_[e],r.layers_[e].setMap(r.map_);});},r._renderPortal=function(){return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(M$1,{experimental:r.props.experimental,onChildClick:r._onChildClick,onChildMouseDown:r._onChildMouseDown,onChildMouseEnter:r._onChildMouseEnter,onChildMouseLeave:r._onChildMouseLeave,geoService:r.geoService_,insideMapPanes:!0,distanceToMouse:r.props.distanceToMouse,getHoverDistance:r._getHoverDistance,dispatcher:r.markersDispatcher_})},r._initMap=function(){if(!r.initialized_){r.initialized_=!0;var e=le$1(r.props.center||r.props.defaultCenter);r.geoService_.setView(e,r.props.zoom||r.props.defaultZoom,0),r._onBoundsChanged();var t=a$1({},r.props.apiKey&&{key:r.props.apiKey},r.props.bootstrapURLKeys);r.props.googleMapLoader(t,r.props.heatmapLibrary).then(function(e){if(r.mounted_){var t,o,i=r.geoService_.getCenter(),s={zoom:r.props.zoom||r.props.defaultZoom,center:new e.LatLng(i.lat,i.lng)};r.props.heatmap.positions&&(Object.assign(l$1(r),{heatmap:(t=e,o=r.props.heatmap,new t.visualization.HeatmapLayer({data:o.positions.reduce(function(e,o){var n=o.weight,r=void 0===n?1:n;return e.push({location:new t.LatLng(o.lat,o.lng),weight:r}),e},[])}))}),function(e,t){var o=t.options,n=void 0===o?{}:o;Object.keys(n).map(function(t){return e.set(t,n[t])});}(r.heatmap,r.props.heatmap));var p=P$1(e,H$1),u="function"==typeof r.props.options?r.props.options(p):r.props.options,h=!A$1(r.props.draggable)&&{draggable:r.props.draggable},c=r._computeMinZoom(u.minZoom);r.minZoom_=c;var d=a$1({},{overviewMapControl:!1,streetViewControl:!1,rotateControl:!0,mapTypeControl:!1,styles:[{featureType:"poi",elementType:"labels",stylers:[{visibility:"off"}]}],minZoom:3},{minZoom:c},u,s);r.defaultDraggableOption_=A$1(d.draggable)?r.defaultDraggableOption_:d.draggable;var m=a$1({},d,h);m.minZoom=ue$1(m.minZoom,c);var g=new e.Map(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.a.findDOMNode(r.googleMapDom_),m);r.map_=g,r.maps_=e,r._setLayers(r.props.layerTypes);var _=e.version.match(/^3\.(\d+)\./),f=_&&Number(_[1]),v=l$1(r),M=Object.assign(new e.OverlayView,{onAdd:function(){var t="undefined"!=typeof screen?screen.width+"px":"2000px",o="undefined"!=typeof screen?screen.height+"px":"2000px",n=document.createElement("div");if(n.style.backgroundColor="transparent",n.style.position="absolute",n.style.left="0px",n.style.top="0px",n.style.width=t,n.style.height=o,v.props.overlayViewDivStyle){var r=v.props.overlayViewDivStyle;"object"==typeof r&&Object.keys(r).forEach(function(e){n.style[e]=r[e];});}this.getPanes().overlayMouseTarget.appendChild(n),v.geoService_.setMapCanvasProjection(e,M.getProjection()),ae$1?v.setState({overlay:n}):pe$1(v,v._renderPortal(),n,function(){return v.setState({overlay:n})});},onRemove:function(){var e=v.state.overlay;e&&!ae$1&&_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.a.unmountComponentAtNode(e),v.setState({overlay:null});},draw:function(){if(v.updateCounter_++,v._onBoundsChanged(g,e,!v.props.debounced),v.googleApiLoadedCalled_||(v._onGoogleApiLoaded({map:g,maps:e,ref:v.googleMapDom_}),v.googleApiLoadedCalled_=!0),v.mouse_){var t=v.geoService_.fromContainerPixelToLatLng(v.mouse_);v.mouse_.lat=t.lat,v.mouse_.lng=t.lng;}v._onChildMouseMove(),v.markersDispatcher_&&(v.markersDispatcher_.emit("kON_CHANGE"),v.fireMouseEventOnIdle_&&v.markersDispatcher_.emit("kON_MOUSE_POSITION_CHANGE"));}});r.overlay_=M,M.setMap(g),r.props.heatmap.positions&&r.heatmap.setMap(g),r.props.onTilesLoaded&&e.event.addListener(g,"tilesloaded",function(){v._onTilesLoaded();}),e.event.addListener(g,"zoom_changed",function(){v.geoService_.getZoom()!==g.getZoom()&&(v.zoomAnimationInProgress_||(v.zoomAnimationInProgress_=!0,v._onZoomAnimationStart(g.zoom)),f<32)&&((new Date).getTime()-r.zoomControlClickTime_<300?S$1(function(){return S$1(function(){v.updateCounter_++,v._onBoundsChanged(g,e);})}):(v.updateCounter_++,v._onBoundsChanged(g,e)));}),e.event.addListener(g,"idle",function(){if(r.resetSizeOnIdle_){r._setViewSize();var t=r._computeMinZoom(u.minZoom);t!==r.minZoom_&&(r.minZoom_=t,g.setOptions({minZoom:t})),r.resetSizeOnIdle_=!1;}v.zoomAnimationInProgress_&&(v.zoomAnimationInProgress_=!1,v._onZoomAnimationEnd(g.zoom)),v.updateCounter_++,v._onBoundsChanged(g,e),v.dragTime_=0,v.markersDispatcher_&&v.markersDispatcher_.emit("kON_CHANGE");}),e.event.addListener(g,"mouseover",function(){v.mouseInMap_=!0;}),e.event.addListener(g,"click",function(){v.mouseInMap_=!0;}),e.event.addListener(g,"mouseout",function(){v.mouseInMap_=!1,v.mouse_=null,v.markersDispatcher_.emit("kON_MOUSE_POSITION_CHANGE");}),e.event.addListener(g,"drag",function(){v.dragTime_=(new Date).getTime(),v._onDrag(g);}),e.event.addListener(g,"dragend",function(){var t=e.event.addListener(g,"idle",function(){e.event.removeListener(t),v._onDragEnd(g);});}),e.event.addListener(g,"maptypeid_changed",function(){v._onMapTypeIdChange(g.getMapTypeId());});}}).catch(function(e){throw r._onGoogleApiLoaded({map:null,maps:null,ref:r.googleMapDom_}),console.error(e),e});}},r._onGoogleApiLoaded=function(){var e;r.props.onGoogleApiLoaded&&((e=r.props).onGoogleApiLoaded.apply(e,arguments));},r._getHoverDistance=function(){return r.props.hoverDistance},r._onDrag=function(){var e;return r.props.onDrag&&(e=r.props).onDrag.apply(e,arguments)},r._onDragEnd=function(){var e;return r.props.onDragEnd&&(e=r.props).onDragEnd.apply(e,arguments)},r._onMapTypeIdChange=function(){var e;return r.props.onMapTypeIdChange&&(e=r.props).onMapTypeIdChange.apply(e,arguments)},r._onZoomAnimationStart=function(){var e;return r.props.onZoomAnimationStart&&(e=r.props).onZoomAnimationStart.apply(e,arguments)},r._onZoomAnimationEnd=function(){var e;return r.props.onZoomAnimationEnd&&(e=r.props).onZoomAnimationEnd.apply(e,arguments)},r._onTilesLoaded=function(){return r.props.onTilesLoaded&&r.props.onTilesLoaded()},r._onChildClick=function(){var e;if(r.props.onChildClick)return (e=r.props).onChildClick.apply(e,arguments)},r._onChildMouseDown=function(e,t){r.childMouseDownArgs_=[e,t],r.props.onChildMouseDown&&r.props.onChildMouseDown(e,t,a$1({},r.mouse_));},r._onChildMouseUp=function(){var e;r.childMouseDownArgs_&&(r.props.onChildMouseUp&&(e=r.props).onChildMouseUp.apply(e,r.childMouseDownArgs_.concat([a$1({},r.mouse_)])),r.childMouseDownArgs_=null,r.childMouseUpTime_=(new Date).getTime());},r._onChildMouseMove=function(){var e;r.childMouseDownArgs_&&r.props.onChildMouseMove&&(e=r.props).onChildMouseMove.apply(e,r.childMouseDownArgs_.concat([a$1({},r.mouse_)]));},r._onChildMouseEnter=function(){var e;if(r.props.onChildMouseEnter)return (e=r.props).onChildMouseEnter.apply(e,arguments)},r._onChildMouseLeave=function(){var e;if(r.props.onChildMouseLeave)return (e=r.props).onChildMouseLeave.apply(e,arguments)},r._setViewSize=function(){if(r.mounted_){if(document.fullscreen||document.webkitIsFullScreen||document.mozFullScreen||document.msFullscreenElement)r.geoService_.setViewSize(window.innerWidth,window.innerHeight);else {var e=_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.a.findDOMNode(r.googleMapDom_);r.geoService_.setViewSize(e.clientWidth,e.clientHeight);}r._onBoundsChanged();}},r._onWindowResize=function(){r.resetSizeOnIdle_=!0;},r._onMapMouseMove=function(e){if(r.mouseInMap_){var t=(new Date).getTime();t-r.mouseMoveTime_>50&&(r.boundingRect_=e.currentTarget.getBoundingClientRect()),r.mouseMoveTime_=t;var o=e.clientX-r.boundingRect_.left,n=e.clientY-r.boundingRect_.top;r.mouse_||(r.mouse_={x:0,y:0,lat:0,lng:0}),r.mouse_.x=o,r.mouse_.y=n;var i=r.geoService_.fromContainerPixelToLatLng(r.mouse_);r.mouse_.lat=i.lat,r.mouse_.lng=i.lng,r._onChildMouseMove(),t-r.dragTime_<100?r.fireMouseEventOnIdle_=!0:(r.markersDispatcher_.emit("kON_MOUSE_POSITION_CHANGE"),r.fireMouseEventOnIdle_=!1);}},r._onClick=function(){var e;return r.props.onClick&&!r.childMouseDownArgs_&&(new Date).getTime()-r.childMouseUpTime_>300&&0===r.dragTime_&&(e=r.props).onClick.apply(e,arguments)},r._onMapClick=function(e){r.markersDispatcher_&&(r._onMapMouseMove(e),(new Date).getTime()-r.dragTime_>100&&(r.mouse_&&r._onClick(a$1({},r.mouse_,{event:e})),r.markersDispatcher_.emit("kON_CLICK",e)));},r._onMapMouseDownNative=function(e){r.mouseInMap_&&r._onMapMouseDown(e);},r._onMapMouseDown=function(e){r.markersDispatcher_&&(new Date).getTime()-r.dragTime_>100&&(r._onMapMouseMove(e),r.markersDispatcher_.emit("kON_MDOWN",e));},r._onMapMouseDownCapture=function(){j$1().isChrome&&(r.zoomControlClickTime_=(new Date).getTime());},r._onKeyDownCapture=function(){j$1().isChrome&&(r.zoomControlClickTime_=(new Date).getTime());},r._isCenterDefined=function(e){return e&&(H$1(e)&&N$1(e.lat)&&N$1(e.lng)||2===e.length&&N$1(e[0])&&N$1(e[1]))},r._onBoundsChanged=function(e,t,o){if(e){var n=e.getCenter();r.geoService_.setView([n.lat(),n.lng()],e.getZoom(),0);}if((r.props.onChange||r.props.onBoundsChange)&&r.geoService_.canProject()){var i=r.geoService_.getZoom(),s=r.geoService_.getBounds(),p=r.geoService_.getCenter();if(!function(e,t,o){if(e&&t){for(var n=0;n!==e.length;++n)if(Math.abs(e[n]-t[n])>1e-5)return !1;return !0}return !1}(s,r.prevBounds_)&&!1!==o){var l=r.geoService_.getBounds(r.props.margin);r.props.onBoundsChange&&r.props.onBoundsChange(r.centerIsObject_?a$1({},p):[p.lat,p.lng],i,s,l),r.props.onChange&&r.props.onChange({center:a$1({},p),zoom:i,bounds:{nw:{lat:s[0],lng:s[1]},se:{lat:s[2],lng:s[3]},sw:{lat:s[4],lng:s[5]},ne:{lat:s[6],lng:s[7]}},marginBounds:{nw:{lat:l[0],lng:l[1]},se:{lat:l[2],lng:l[3]},sw:{lat:l[4],lng:l[5]},ne:{lat:l[6],lng:l[7]}},size:r.geoService_.hasSize()?{width:r.geoService_.getWidth(),height:r.geoService_.getHeight()}:{width:0,height:0}}),r.prevBounds_=s;}}},r._registerChild=function(e){r.googleMapDom_=e;},r.mounted_=!1,r.initialized_=!1,r.googleApiLoadedCalled_=!1,r.map_=null,r.maps_=null,r.prevBounds_=null,r.heatmap=null,r.layers_={},r.mouse_=null,r.mouseMoveTime_=0,r.boundingRect_=null,r.mouseInMap_=!0,r.dragTime_=0,r.fireMouseEventOnIdle_=!1,r.updateCounter_=0,r.markersDispatcher_=new c$1(l$1(r)),r.geoService_=new T$1(256),r.centerIsObject_=H$1(r.props.center),r.minZoom_=3,r.defaultDraggableOption_=!0,r.zoomControlClickTime_=0,r.childMouseDownArgs_=null,r.childMouseUpTime_=0,r.googleMapDom_=null,r._isCenterDefined(r.props.center||r.props.defaultCenter)){var i=le$1(r.props.center||r.props.defaultCenter);r.geoService_.setView(i,r.props.zoom||r.props.defaultZoom,0);}return r.zoomAnimationInProgress_=!1,r.state={overlay:null},r}p$1(o,t);var r=o.prototype;return r.componentDidMount=function(){var e=this;this.mounted_=!0,K$1(window,"resize",this._onWindowResize,!1),K$1(window,"keydown",this._onKeyDownCapture,!0);var t=_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.a.findDOMNode(this.googleMapDom_);t&&K$1(t,"mousedown",this._onMapMouseDownNative,!0),K$1(window,"mouseup",this._onChildMouseUp,!1);var o=a$1({},this.props.apiKey&&{key:this.props.apiKey},this.props.bootstrapURLKeys);this.props.googleMapLoader(o,this.props.heatmapLibrary),setTimeout(function(){e._setViewSize(),e._isCenterDefined(e.props.center||e.props.defaultCenter)&&e._initMap();},0,this),this.props.resetBoundsOnResize&&function(e,t){if(void 0===e.parentNode){var o=document.createElement("div");e.parentNode=o;}e=e.parentNode,W$1?e.attachEvent("onresize",t):(e.__resizeTriggers__||("static"==getComputedStyle(e).position&&(e.style.position="relative"),function(){if(!V$1){var e=(ie$1||"")+".resize-triggers { "+(se$1||"")+'visibility: hidden; opacity: 0; } .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',t=document.head||document.getElementsByTagName("head")[0],o=document.createElement("style");o.type="text/css",o.styleSheet?o.styleSheet.cssText=e:o.appendChild(document.createTextNode(e)),t.appendChild(o),V$1=!0;}}(),e.__resizeLast__={},e.__resizeListeners__=[],(e.__resizeTriggers__=document.createElement("div")).className="resize-triggers",e.__resizeTriggers__.innerHTML='<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>',e.appendChild(e.__resizeTriggers__),q$1(e),K$1(e,"scroll",Y$1,!0),Q$1&&e.__resizeTriggers__.addEventListener(Q$1,function(t){t.animationName==re$1&&q$1(e);})),e.__resizeListeners__.push(t));}(t,this._mapDomResizeCallback);},r.shouldComponentUpdate=function(e,t){return !_$1(d$1(this.props,["draggable"]),d$1(e,["draggable"]))||!_$1(this.state,t)},r.componentDidUpdate=function(e){var t=this;if(!this._isCenterDefined(e.center)&&this._isCenterDefined(this.props.center)&&setTimeout(function(){return t._initMap()},0),this.map_){var o=this.geoService_.getCenter();if(this._isCenterDefined(this.props.center)){var n=le$1(this.props.center),r=this._isCenterDefined(e.center)?le$1(e.center):null;(!r||Math.abs(n.lat-r.lat)+Math.abs(n.lng-r.lng)>1e-5)&&Math.abs(n.lat-o.lat)+Math.abs(n.lng-o.lng)>1e-5&&this.map_.panTo({lat:n.lat,lng:n.lng});}if(A$1(this.props.zoom)||Math.abs(this.props.zoom-e.zoom)>0&&this.map_.setZoom(this.props.zoom),!A$1(e.draggable)&&A$1(this.props.draggable)?this.map_.setOptions({draggable:this.defaultDraggableOption_}):_$1(e.draggable,this.props.draggable)||this.map_.setOptions({draggable:this.props.draggable}),!A$1(this.props.options)&&!_$1(e.options,this.props.options)){var i=P$1(this.maps_,H$1),s="function"==typeof this.props.options?this.props.options(i):this.props.options;if("minZoom"in(s=d$1(s,["zoom","center","draggable"]))){var a=this._computeMinZoom(s.minZoom);s.minZoom=ue$1(s.minZoom,a);}this.map_.setOptions(s);}_$1(this.props.layerTypes,e.layerTypes)||(Object.keys(this.layers_).forEach(function(e){t.layers_[e].setMap(null),delete t.layers_[e];}),this._setLayers(this.props.layerTypes)),this.heatmap&&!_$1(this.props.heatmap.positions,e.heatmap.positions)&&this.heatmap.setData(this.props.heatmap.positions.map(function(e){return {location:new t.maps_.LatLng(e.lat,e.lng),weight:e.weight}})),this.heatmap&&!_$1(this.props.heatmap.options,e.heatmap.options)&&Object.keys(this.props.heatmap.options).forEach(function(e){t.heatmap.set(e,t.props.heatmap.options[e]);});}this.markersDispatcher_.emit("kON_CHANGE"),_$1(this.props.hoverDistance,e.hoverDistance)||this.markersDispatcher_.emit("kON_MOUSE_POSITION_CHANGE");},r.componentWillUnmount=function(){this.mounted_=!1;var e,t,o=_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.a.findDOMNode(this.googleMapDom_);o&&o.removeEventListener("mousedown",this._onMapMouseDownNative,!0),window.removeEventListener("resize",this._onWindowResize),window.removeEventListener("keydown",this._onKeyDownCapture),window.removeEventListener("mouseup",this._onChildMouseUp,!1),this.props.resetBoundsOnResize&&(t=this._mapDomResizeCallback,e=(e=o).parentNode,W$1?e.detachEvent("onresize",t):(e.__resizeListeners__.splice(e.__resizeListeners__.indexOf(t),1),e.__resizeListeners__.length||(e.removeEventListener("scroll",Y$1),e.__resizeTriggers__=!e.removeChild(e.__resizeTriggers__)))),this.overlay_&&this.overlay_.setMap(null),this.maps_&&this.map_&&this.props.shouldUnregisterMapOnUnmount&&(this.map_.setOptions({scrollwheel:!1}),this.maps_.event.clearInstanceListeners(this.map_)),this.props.shouldUnregisterMapOnUnmount&&(this.map_=null,this.maps_=null),this.markersDispatcher_.dispose(),this.resetSizeOnIdle_=!1,this.props.shouldUnregisterMapOnUnmount&&(delete this.map_,delete this.markersDispatcher_);},r.render=function(){var t=this.state.overlay,o=t?null:_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(C$1,{experimental:this.props.experimental,onChildClick:this._onChildClick,onChildMouseDown:this._onChildMouseDown,onChildMouseEnter:this._onChildMouseEnter,onChildMouseLeave:this._onChildMouseLeave,geoService:this.geoService_,insideMapPanes:!1,distanceToMouse:this.props.distanceToMouse,getHoverDistance:this._getHoverDistance,dispatcher:this.markersDispatcher_});return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("div",{style:this.props.style,onMouseMove:this._onMapMouseMove,onMouseDownCapture:this._onMapMouseDownCapture,onClick:this._onMapClick},_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(h$1,{registerChild:this._registerChild}),ae$1&&t&&pe$1(this._renderPortal(),t),o)},o}(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Component);he$1.propTypes={apiKey:PropTypes.string,bootstrapURLKeys:PropTypes.any,defaultCenter:PropTypes.oneOfType([PropTypes.array,PropTypes.shape({lat:PropTypes.number,lng:PropTypes.number})]),center:PropTypes.oneOfType([PropTypes.array,PropTypes.shape({lat:PropTypes.number,lng:PropTypes.number})]),defaultZoom:PropTypes.number,zoom:PropTypes.number,onBoundsChange:PropTypes.func,onChange:PropTypes.func,onClick:PropTypes.func,onChildClick:PropTypes.func,onChildMouseDown:PropTypes.func,onChildMouseUp:PropTypes.func,onChildMouseMove:PropTypes.func,onChildMouseEnter:PropTypes.func,onChildMouseLeave:PropTypes.func,onZoomAnimationStart:PropTypes.func,onZoomAnimationEnd:PropTypes.func,onDrag:PropTypes.func,onDragEnd:PropTypes.func,onMapTypeIdChange:PropTypes.func,onTilesLoaded:PropTypes.func,options:PropTypes.any,distanceToMouse:PropTypes.func,hoverDistance:PropTypes.number,debounced:PropTypes.bool,margin:PropTypes.array,googleMapLoader:PropTypes.any,onGoogleApiLoaded:PropTypes.func,yesIWantToUseGoogleMapApiInternals:PropTypes.bool,draggable:PropTypes.bool,style:PropTypes.any,resetBoundsOnResize:PropTypes.bool,layerTypes:PropTypes.arrayOf(PropTypes.string),shouldUnregisterMapOnUnmount:PropTypes.bool},he$1.defaultProps={distanceToMouse:function(e,t){return Math.sqrt((e.x-t.x)*(e.x-t.x)+(e.y-t.y)*(e.y-t.y))},hoverDistance:30,debounced:!0,options:function(){return {overviewMapControl:!1,streetViewControl:!1,rotateControl:!0,mapTypeControl:!1,styles:[{featureType:"poi",elementType:"labels",stylers:[{visibility:"off"}]}],minZoom:3}},googleMapLoader:z$1,yesIWantToUseGoogleMapApiInternals:!1,style:{width:"100%",height:"100%",margin:0,padding:0,position:"relative"},layerTypes:[],heatmap:{},heatmapLibrary:!1,shouldUnregisterMapOnUnmount:!0},he$1.googleMapLoader=z$1;var GoogleMapReact = he$1;

const e=(e,t,a)=>{const[n,r]=e.split("/"),[o,i]=r.split(":");return Date.UTC(a,n-1,o,i)-36e5*t};var t=(t,a,n,r,o)=>{const i=new Date(t).getUTCFullYear(),s=e(a,o,i),u=e(n,r,i);return t>=s&&t<u};var a=e=>{let a=e.timezones[e.tz];if(void 0===a)return console.warn("Warning: couldn't find timezone "+e.tz),0;if(void 0===a.dst)return a.offset;let n=a.offset,r=a.offset+1;"n"===a.hem&&(r=n-1);let o=a.dst.split("->");return !0===t(e.epoch,o[0],o[1],n,r)?n:r};var n,r=(n=Object.freeze({__proto__:null,default:{"9|s":"2/dili,2/jayapura","9|n":"2/chita,2/khandyga,2/pyongyang,2/seoul,2/tokyo,11/palau","9.5|s|04/04:03->10/03:02":"4/adelaide,4/broken_hill,4/south,4/yancowinna","9.5|s":"4/darwin,4/north","8|s|03/08:01->10/04:00":"12/casey","8|s":"2/kuala_lumpur,2/makassar,2/singapore,4/perth,2/ujung_pandang,4/west","8|n":"2/brunei,2/choibalsan,2/hong_kong,2/irkutsk,2/kuching,2/macau,2/manila,2/shanghai,2/taipei,2/ulaanbaatar,2/chongqing,2/chungking,2/harbin,2/macao,2/ulan_bator","8.75|s":"4/eucla","7|s":"12/davis,2/jakarta,9/christmas","7|n":"2/bangkok,2/barnaul,2/hovd,2/krasnoyarsk,2/novokuznetsk,2/novosibirsk,2/phnom_penh,2/pontianak,2/saigon,2/tomsk,2/vientiane,2/ho_chi_minh","6|s":"12/vostok","6|n":"2/almaty,2/bishkek,2/dhaka,2/omsk,2/qyzylorda,2/qostanay,2/thimphu,2/urumqi,9/chagos,2/dacca,2/kashgar,2/thimbu","6.5|n":"2/rangoon,9/cocos,2/yangon","5|s":"12/mawson,9/kerguelen","5|n":"2/aqtau,2/aqtobe,2/ashgabat,2/atyrau,2/baku,2/dushanbe,2/karachi,2/oral,2/samarkand,2/tashkent,2/yekaterinburg,9/maldives,2/ashkhabad","5.75|n":"2/katmandu,2/kathmandu","5.5|n":"2/calcutta,2/colombo,2/kolkata","4|s":"9/reunion","4|n":"2/dubai,2/muscat,2/tbilisi,2/yerevan,8/astrakhan,8/samara,8/saratov,8/ulyanovsk,8/volgograd,2/volgograd,9/mahe,9/mauritius","4.5|n|03/22:00->09/21:24":"2/tehran","4.5|n":"2/kabul","3|s":"12/syowa,9/antananarivo","3|n|03/28:03->10/31:04":"2/famagusta,2/nicosia,8/athens,8/bucharest,8/helsinki,8/kiev,8/mariehamn,8/riga,8/sofia,8/tallinn,8/uzhgorod,8/vilnius,8/zaporozhye,8/nicosia","3|n|03/28:02->10/31:03":"8/chisinau,8/tiraspol","3|n|03/28:00->10/30:24":"2/beirut","3|n|03/27:00->10/30:01":"2/gaza,2/hebron","3|n|03/26:02->10/31:02":"2/jerusalem,2/tel_aviv","3|n|03/26:00->10/29:01":"2/amman","3|n|03/26:00->10/28:24":"2/damascus","3|n":"0/addis_ababa,0/asmera,0/dar_es_salaam,0/djibouti,0/juba,0/kampala,0/mogadishu,0/nairobi,2/aden,2/baghdad,2/bahrain,2/kuwait,2/qatar,2/riyadh,8/istanbul,8/kirov,8/minsk,8/moscow,8/simferopol,9/comoro,9/mayotte,0/asmara,2/istanbul","2|s|03/28:02->10/31:02":"12/troll","2|s":"0/gaborone,0/harare,0/johannesburg,0/lubumbashi,0/lusaka,0/maputo,0/maseru,0/mbabane","2|n|03/28:02->10/31:03":"0/ceuta,arctic/longyearbyen,8/amsterdam,8/andorra,8/belgrade,8/berlin,8/bratislava,8/brussels,8/budapest,8/busingen,8/copenhagen,8/gibraltar,8/ljubljana,8/luxembourg,8/madrid,8/malta,8/monaco,8/oslo,8/paris,8/podgorica,8/prague,8/rome,8/san_marino,8/sarajevo,8/skopje,8/stockholm,8/tirane,8/vaduz,8/vatican,8/vienna,8/warsaw,8/zagreb,8/zurich,3/jan_mayen","2|n":"0/blantyre,0/bujumbura,0/cairo,0/khartoum,0/kigali,0/tripoli,8/kaliningrad","1|s":"0/brazzaville,0/kinshasa,0/luanda,0/windhoek","1|n|04/11:03->05/16:02":"0/casablanca,0/el_aaiun","1|n|03/28:01->10/31:02":"3/canary,3/faeroe,3/madeira,8/dublin,8/guernsey,8/isle_of_man,8/jersey,8/lisbon,8/london,3/faroe,8/belfast","1|n":"0/algiers,0/bangui,0/douala,0/lagos,0/libreville,0/malabo,0/ndjamena,0/niamey,0/porto-novo,0/tunis","14|n":"11/kiritimati","13|s|04/04:04->09/26:03":"11/apia","13|s|01/15:02->11/05:03":"11/tongatapu","13|n":"11/enderbury,11/fakaofo","12|s|04/04:03->09/26:02":"12/mcmurdo,11/auckland,12/south_pole","12|s|01/17:03->11/14:02":"11/fiji","12|n":"2/anadyr,2/kamchatka,2/srednekolymsk,11/funafuti,11/kwajalein,11/majuro,11/nauru,11/tarawa,11/wake,11/wallis","12.75|s|04/04:03->09/26:02":"11/chatham","11|s|04/04:03->10/03:02":"12/macquarie","11|s":"11/bougainville","11|n":"2/magadan,2/sakhalin,11/efate,11/guadalcanal,11/kosrae,11/noumea,11/ponape,11/pohnpei","11.5|n|04/04:03->10/03:02":"11/norfolk","10|s|04/04:03->10/03:02":"4/currie,4/hobart,4/melbourne,4/sydney,4/act,4/canberra,4/nsw,4/tasmania,4/victoria","10|s":"12/dumontdurville,4/brisbane,4/lindeman,11/port_moresby,4/queensland","10|n":"2/ust-nera,2/vladivostok,2/yakutsk,11/guam,11/saipan,11/truk,11/chuuk,11/yap","10.5|s|04/04:01->10/03:02":"4/lord_howe,4/lhi","0|n|03/28:00->10/31:01":"1/scoresbysund,3/azores","0|n":"0/abidjan,0/accra,0/bamako,0/banjul,0/bissau,0/conakry,0/dakar,0/freetown,0/lome,0/monrovia,0/nouakchott,0/ouagadougou,0/sao_tome,1/danmarkshavn,3/reykjavik,3/st_helena,13/gmt,13/utc,0/timbuktu,13/gmt-0,13/gmt+0,13/gmt0,13/greenwich,13/uct,13/universal,13/zulu","-9|n|03/14:02->11/07:02":"1/adak,1/atka,us/aleutian","-9|n":"11/gambier","-9.5|n":"11/marquesas","-8|n|03/14:02->11/07:02":"1/anchorage,1/juneau,1/metlakatla,1/nome,1/sitka,1/yakutat,us/alaska","-8|n":"11/pitcairn","-7|n|03/14:02->11/07:02":"1/los_angeles,1/santa_isabel,1/tijuana,1/vancouver,1/ensenada,6/pacific,10/bajanorte,us/pacific-new,us/pacific","-7|n|03/08:02->11/01:01":"1/dawson,1/whitehorse,6/yukon","-7|n":"1/creston,1/dawson_creek,1/fort_nelson,1/hermosillo,1/phoenix,us/arizona","-6|s|04/03:22->09/04:22":"11/easter,7/easterisland","-6|n|04/04:02->10/31:02":"1/chihuahua,1/mazatlan,10/bajasur","-6|n|03/14:02->11/07:02":"1/boise,1/cambridge_bay,1/denver,1/edmonton,1/inuvik,1/ojinaga,1/yellowknife,1/shiprock,6/mountain,us/mountain","-6|n":"1/belize,1/costa_rica,1/el_salvador,1/guatemala,1/managua,1/regina,1/swift_current,1/tegucigalpa,11/galapagos,6/east-saskatchewan,6/saskatchewan","-5|s":"1/lima,1/rio_branco,1/porto_acre,5/acre","-5|n|04/04:02->10/31:02":"1/bahia_banderas,1/merida,1/mexico_city,1/monterrey,10/general","-5|n|03/14:02->11/07:02":"1/chicago,1/matamoros,1/menominee,1/rainy_river,1/rankin_inlet,1/resolute,1/winnipeg,1/indiana/knox,1/indiana/tell_city,1/north_dakota/beulah,1/north_dakota/center,1/north_dakota/new_salem,1/knox_in,6/central,us/central,us/indiana-starke","-5|n|03/12:03->11/05:01":"1/north_dakota","-5|n":"1/bogota,1/cancun,1/cayman,1/coral_harbour,1/eirunepe,1/guayaquil,1/jamaica,1/panama,1/atikokan","-4|s|05/13:23->08/13:01":"12/palmer","-4|s|04/03:24->09/05:00":"1/santiago,7/continental","-4|s|03/27:24->10/03:00":"1/asuncion","-4|s|02/16:24->11/03:00":"1/campo_grande,1/cuiaba","-4|s":"1/la_paz,1/manaus,5/west","-4|n|03/14:02->11/07:02":"1/detroit,1/grand_turk,1/indianapolis,1/iqaluit,1/louisville,1/montreal,1/nassau,1/new_york,1/nipigon,1/pangnirtung,1/port-au-prince,1/thunder_bay,1/toronto,1/indiana/marengo,1/indiana/petersburg,1/indiana/vevay,1/indiana/vincennes,1/indiana/winamac,1/kentucky/monticello,1/fort_wayne,1/indiana/indianapolis,1/kentucky/louisville,6/eastern,us/east-indiana,us/eastern,us/michigan","-4|n|03/14:00->11/07:01":"1/havana","-4|n|03/12:03->11/05:01":"1/indiana,1/kentucky","-4|n":"1/anguilla,1/antigua,1/aruba,1/barbados,1/blanc-sablon,1/boa_vista,1/caracas,1/curacao,1/dominica,1/grenada,1/guadeloupe,1/guyana,1/kralendijk,1/lower_princes,1/marigot,1/martinique,1/montserrat,1/port_of_spain,1/porto_velho,1/puerto_rico,1/santo_domingo,1/st_barthelemy,1/st_kitts,1/st_lucia,1/st_thomas,1/st_vincent,1/tortola,1/virgin","-3|s":"1/argentina,1/buenos_aires,1/catamarca,1/cordoba,1/fortaleza,1/jujuy,1/mendoza,1/montevideo,1/punta_arenas,1/sao_paulo,12/rothera,3/stanley,1/argentina/la_rioja,1/argentina/rio_gallegos,1/argentina/salta,1/argentina/san_juan,1/argentina/san_luis,1/argentina/tucuman,1/argentina/ushuaia,1/argentina/buenos_aires,1/argentina/catamarca,1/argentina/comodrivadavia,1/argentina/cordoba,1/argentina/jujuy,1/argentina/mendoza,1/rosario,5/east","-3|n|03/14:02->11/07:02":"1/glace_bay,1/goose_bay,1/halifax,1/moncton,1/thule,3/bermuda,6/atlantic","-3|n":"1/araguaina,1/bahia,1/belem,1/cayenne,1/maceio,1/paramaribo,1/recife,1/santarem","-2|n|03/27:22->10/30:23":"1/godthab,1/nuuk","-2|n|03/14:02->11/07:02":"1/miquelon","-2|n":"1/noronha,3/south_georgia,5/denoronha","-2.5|n|03/14:02->11/07:02":"1/st_johns,6/newfoundland","-1|n":"3/cape_verde","-11|n":"11/midway,11/niue,11/pago_pago,11/samoa,us/samoa","-10|n":"11/honolulu,11/johnston,11/rarotonga,11/tahiti,us/hawaii"}}))&&n.default||n,o=["africa","america","asia","atlantic","australia","brazil","canada","chile","europe","indian","mexico","pacific","antarctica","etc"];let i={};Object.keys(r).forEach(e=>{let t=e.split("|"),a={offset:Number(t[0]),hem:t[1]};t[2]&&(a.dst=t[2]),r[e].split(",").forEach(e=>{e=e.replace(/(^[0-9]+)\//,(e,t)=>(t=Number(t),o[t]+"/")),i[e]=a;});}),i.utc={offset:0,hem:"n"};for(let e=-14;e<=14;e+=.5){let t=e;t>0&&(t="+"+t);let a="etc/gmt"+t;i[a]={offset:-1*e,hem:"n"},a="utc/gmt"+t,i[a]={offset:-1*e,hem:"n"};}const s=/(\-?[0-9]+)h(rs)?/i,u=/(\-?[0-9]+)/,l=/utc([\-+]?[0-9]+)/i,h=/gmt([\-+]?[0-9]+)/i,c=function(e){return (e=Number(e))>=-13&&e<=13?"etc/gmt"+(e=((e*=-1)>0?"+":"")+e):null};var d=i,m=function(e){let t=e.match(s);if(null!==t)return c(t[1]);if(t=e.match(l),null!==t)return c(t[1]);if(t=e.match(h),null!==t){let e=-1*Number(t[1]);return c(e)}return t=e.match(u),null!==t?c(t[1]):null};const p=(()=>{let e=(()=>{if("undefined"==typeof Intl||void 0===Intl.DateTimeFormat)return null;let e=Intl.DateTimeFormat();if(void 0===e||void 0===e.resolvedOptions)return null;let t=e.resolvedOptions().timeZone;return t?t.toLowerCase():null})();return null===e?"utc":e})(),f=Object.keys(d).reduce((e,t)=>{let a=t.split("/")[1]||"";return a=a.replace(/_/g," "),e[a]=t,e},{});var y,g=(e,t)=>{if(!e)return p;"string"!=typeof e&&console.error("Timezone must be a string - recieved: '",e,"'\n");let a=e.trim();if(a=a.toLowerCase(),!0===t.hasOwnProperty(a))return a;if(a=(e=>(e=(e=(e=(e=(e=e.replace(/ time/g,"")).replace(/ (standard|daylight|summer)/g,"")).replace(/\b(east|west|north|south)ern/g,"$1")).replace(/\b(africa|america|australia)n/g,"$1")).replace(/\beuropean/g,"europe")).replace(/\islands/g,"island"))(a),!0===t.hasOwnProperty(a))return a;if(!0===f.hasOwnProperty(a))return f[a];if(!0===/[0-9]/.test(a)){let e=m(a);if(e)return e}throw new Error("Spacetime: Cannot find timezone named: '"+e+"'. Please enter an IANA timezone id.")},b=(function(e,t){t.isLeapYear=e=>e%4==0&&e%100!=0||e%400==0,t.isDate=e=>"[object Date]"===Object.prototype.toString.call(e)&&!isNaN(e.valueOf()),t.isArray=e=>"[object Array]"===Object.prototype.toString.call(e),t.isObject=e=>"[object Object]"===Object.prototype.toString.call(e),t.isBoolean=e=>"[object Boolean]"===Object.prototype.toString.call(e),t.zeroPad=(e,t=2)=>(e+="").length>=t?e:new Array(t-e.length+1).join("0")+e,t.titleCase=e=>e?e[0].toUpperCase()+e.substr(1):"",t.ordinal=e=>{let t=e%10,a=e%100;return 1===t&&11!==a?e+"st":2===t&&12!==a?e+"nd":3===t&&13!==a?e+"rd":e+"th"},t.toCardinal=e=>(e=(e=String(e)).replace(/([0-9])(st|nd|rd|th)$/i,"$1"),parseInt(e,10)),t.normalize=(e="")=>"day"===(e=(e=(e=(e=e.toLowerCase().trim()).replace(/ies$/,"y")).replace(/s$/,"")).replace(/-/g,""))||"days"===e?"date":"min"===e||"mins"===e?"minute":e,t.getEpoch=e=>"number"==typeof e?e:t.isDate(e)?e.getTime():e.epoch?e.epoch:null,t.beADate=(e,a)=>!1===t.isObject(e)?a.clone().set(e):e,t.formatTimezone=(e,a="")=>{const n=e>0?"+":"-",r=Math.abs(e);return `${n}${t.zeroPad(parseInt(""+r,10))}${a}${t.zeroPad(r%1*60)}`};}(y={exports:{}},y.exports),y.exports);b.isLeapYear,b.isDate,b.isArray,b.isObject,b.isBoolean,b.zeroPad,b.titleCase,b.ordinal,b.toCardinal,b.normalize,b.getEpoch,b.beADate,b.formatTimezone;const k={year:(new Date).getFullYear(),month:0,date:1};var w={parseArray:(e,t,a)=>{if(0===t.length)return e;let n=["year","month","date","hour","minute","second","millisecond"];for(let r=0;r<n.length;r++){let o=t[r]||a[n[r]]||k[n[r]]||0;e=e[n[r]](o);}return e},parseObject:(e,t,a)=>{if(0===Object.keys(t).length)return e;t=Object.assign({},k,a,t);let n=Object.keys(t);for(let r=0;r<n.length;r++){let o=n[r];if(void 0===e[o]||"function"!=typeof e[o])continue;if(null===t[o]||void 0===t[o]||""===t[o])continue;let i=t[o]||a[o]||k[o]||0;e=e[o](i);}return e},parseNumber:function(e,t){return t>0&&t<25e8&&!1===e.silent&&(console.warn("  - Warning: You are setting the date to January 1970."),console.warn("       -   did input seconds instead of milliseconds?")),e.epoch=t,e}};const v=function(e){return e.epoch=Date.now(),Object.keys(e._today||{}).forEach(t=>{"function"==typeof e[t]&&(e=e[t](e._today[t]));}),e},z={now:e=>v(e),today:e=>v(e),tonight:e=>e=(e=v(e)).hour(18),tomorrow:e=>e=(e=(e=v(e)).add(1,"day")).startOf("day"),yesterday:e=>e=(e=(e=v(e)).subtract(1,"day")).startOf("day"),christmas:e=>{let t=v(e).year();return e=e.set([t,11,25,18,0,0])},"new years":e=>{let t=v(e).year();return e=e.set([t,11,31,18,0,0])}};z["new years eve"]=z["new years"];var _=z;var j=function(e){return e=(e=(e=(e=e.replace(/\b(mon|tues?|wed|wednes|thur?s?|fri|sat|satur|sun)(day)?\b/i,"")).replace(/([0-9])(th|rd|st|nd)/,"$1")).replace(/,/g,"")).replace(/ +/g," ").trim()};let O={millisecond:1,second:1e3,minute:6e4,hour:36e5,day:864e5};O.date=O.day,O.month=25488e5,O.week=6048e5,O.year=3154e7,Object.keys(O).forEach(e=>{O[e+"s"]=O[e];});var $=O;const D=(e,t,a,n,r)=>{let o=e.d[a]();if(o===t)return;let i=null===r?null:e.d[r](),s=e.epoch,u=t-o;e.epoch+=$[n]*u,"day"===n&&Math.abs(u)>28&&t<28&&(e.epoch+=$.hour),null!==r&&i!==e.d[r]()&&(e.epoch=s);const l=$[n]/2;for(;e.d[a]()<t;)e.epoch+=l;for(;e.d[a]()>t;)e.epoch-=l;null!==r&&i!==e.d[r]()&&(e.epoch=s);},M={year:{valid:e=>e>-4e3&&e<4e3,walkTo:(e,t)=>D(e,t,"getFullYear","year",null)},month:{valid:e=>e>=0&&e<=11,walkTo:(e,t)=>{let a=e.d,n=a.getMonth(),r=e.epoch,o=a.getFullYear();if(n===t)return;let i=t-n;for(e.epoch+=$.day*(28*i),o!==e.d.getFullYear()&&(e.epoch=r);e.d.getMonth()<t;)e.epoch+=$.day;for(;e.d.getMonth()>t;)e.epoch-=$.day;}},date:{valid:e=>e>0&&e<=31,walkTo:(e,t)=>D(e,t,"getDate","day","getMonth")},hour:{valid:e=>e>=0&&e<24,walkTo:(e,t)=>D(e,t,"getHours","hour","getDate")},minute:{valid:e=>e>=0&&e<60,walkTo:(e,t)=>D(e,t,"getMinutes","minute","getHours")},second:{valid:e=>e>=0&&e<60,walkTo:(e,t)=>{e.epoch=e.seconds(t).epoch;}},millisecond:{valid:e=>e>=0&&e<1e3,walkTo:(e,t)=>{e.epoch=e.milliseconds(t).epoch;}}};var P=(e,t)=>{let a=Object.keys(M),n=e.clone();for(let r=0;r<a.length;r++){let o=a[r],i=t[o];if(void 0===i&&(i=n[o]()),"string"==typeof i&&(i=parseInt(i,10)),!M[o].valid(i))return e.epoch=null,void(!1===e.silent&&console.warn("invalid "+o+": "+i));M[o].walkTo(e,i);}};let S=["jan","feb","mar","apr","may","jun","jul","aug","sept","oct","nov","dec"],q=["january","february","march","april","may","june","july","august","september","october","november","december"];var T=[31,28,31,30,31,30,31,31,30,31,30,31],E=b,N={short:()=>S,long:()=>q,mapping:()=>function(){const e={sep:8};for(let t=0;t<S.length;t++)e[S[t]]=t;for(let t=0;t<q.length;t++)e[q[t]]=t;return e}(),set:e=>{S=e.short||S,q=e.long||q;}},C=(e,t)=>{if(!t)return e;"Z"!==t&&"z"!==t||(t="+0000");let a=0;/^[\+-]?[0-9]{2}:[0-9]{2}$/.test(t)&&(!0===/:00/.test(t)&&(t=t.replace(/:00/,"")),!0===/:30/.test(t)&&(t=t.replace(/:30/,".5"))),/^[\+-]?[0-9]{4}$/.test(t)&&(t=t.replace(/30$/,".5")),a=parseFloat(t),Math.abs(a)>100&&(a/=100),a*=-1,a>=0&&(a="+"+a);let n="etc/gmt"+a;return e.timezones[n]&&(e.tz=n),e},I=(e,t="")=>{let a=(t=t.replace(/^\s+/,"").toLowerCase()).match(/([0-9]{1,2}):([0-9]{1,2}):?([0-9]{1,2})?[:\.]?([0-9]{1,4})?/);if(null!==a){let n=Number(a[1]);if(n<0||n>24)return e.startOf("day");let r=Number(a[2]);if(a[2].length<2||r<0||r>59)return e.startOf("day");a[4]>999&&(a[4]=parseInt((""+a[4]).substring(0,3),10)),e=(e=(e=(e=e.hour(n)).minute(r)).seconds(a[3]||0)).millisecond(a[4]||0);let o=t.match(/[\b0-9] ?(am|pm)\b/);return null!==o&&o[1]&&(e=e.ampm(o[1])),e}if(a=t.match(/([0-9]+) ?(am|pm)/),null!==a&&a[1]){let t=Number(a[1]);return t>12||t<1?e.startOf("day"):e=(e=(e=e.hour(a[1]||0)).ampm(a[2])).startOf("hour")}return e=e.startOf("day")};const Y=E.isLeapYear,A=N.mapping();var x=P,L={parseOffset:C,parseTime:I,parseYear:(e="",t)=>{if(e=e.trim(),!0===/^'[0-9][0-9]$/.test(e)){let t=Number(e.replace(/'/,""));return t>50?1900+t:2e3+t}let a=parseInt(e,10);return !a&&t&&(a=t.year),a=a||(new Date).getFullYear(),a},parseMonth:function(e){return e=e.toLowerCase().trim(),A[e]},validate:e=>{if(!0!==T.hasOwnProperty(e.month))return !1;if(1===e.month)return !!(Y(e.year)&&e.date<=29)||e.date<=28;let t=T[e.month]||0;return e.date<=t}};const{validate:F,parseTime:B,parseYear:Z,parseMonth:H,parseOffset:Q}=L;var G=[{reg:/^(\-?0?0?[0-9]{3,4})-([0-9]{1,2})-([0-9]{1,2})[T| ]([0-9.:]+)(Z|[0-9\-\+:]+)?$/i,parse:(e,t)=>{let a={year:t[1],month:parseInt(t[2],10)-1,date:t[3]};return !1===F(a)?(e.epoch=null,e):(Q(e,t[5]),x(e,a),e=B(e,t[4]))}},{reg:/^([0-9]{4})[\-\/\. ]([0-9]{1,2})[\-\/\. ]([0-9]{1,2})( [0-9]{1,2}(:[0-9]{0,2})?(:[0-9]{0,3})? ?(am|pm)?)?$/i,parse:(e,t)=>{let a={year:t[1],month:parseInt(t[2],10)-1,date:parseInt(t[3],10)};return a.month>=12&&(a.date=parseInt(t[2],10),a.month=parseInt(t[3],10)-1),!1===F(a)?(e.epoch=null,e):(x(e,a),e=B(e,t[4]))}},{reg:/^([0-9]{4})[\-\/\. ]([a-z]+)[\-\/\. ]([0-9]{1,2})( [0-9]{1,2}(:[0-9]{0,2})?(:[0-9]{0,3})? ?(am|pm)?)?$/i,parse:(e,t)=>{let a={year:Z(t[1],e._today),month:H(t[2]),date:E.toCardinal(t[3]||"")};return !1===F(a)?(e.epoch=null,e):(x(e,a),e=B(e,t[4]))}}];const{validate:U,parseTime:V,parseYear:W,parseMonth:J}=L;var K=[{reg:/^([0-9]{1,2})[\-\/.]([0-9]{1,2})[\-\/.]?([0-9]{4})?( [0-9]{1,2}:[0-9]{2}:?[0-9]{0,2}? ?(am|pm|gmt))?$/i,parse:(e,t)=>{let a=parseInt(t[1],10)-1,n=parseInt(t[2],10);(e.british||a>=12)&&(n=parseInt(t[1],10),a=parseInt(t[2],10)-1);let r={date:n,month:a,year:W(t[3],e._today)||(new Date).getFullYear()};return !1===U(r)?(e.epoch=null,e):(x(e,r),e=V(e,t[4]))}},{reg:/^([a-z]+)[\-\/\. ]([0-9]{1,2})[\-\/\. ]?([0-9]{4}|'[0-9]{2})?( [0-9]{1,2}(:[0-9]{0,2})?(:[0-9]{0,3})? ?(am|pm)?)?$/i,parse:(e,t)=>{let a={year:W(t[3],e._today),month:J(t[1]),date:E.toCardinal(t[2]||"")};return !1===U(a)?(e.epoch=null,e):(x(e,a),e=V(e,t[4]))}},{reg:/^([a-z]+) ([0-9]{1,2})( [0-9]{4})?( ([0-9:]+( ?am| ?pm| ?gmt)?))?$/i,parse:(e,t)=>{let a={year:W(t[3],e._today),month:J(t[1]),date:E.toCardinal(t[2]||"")};return !1===U(a)?(e.epoch=null,e):(x(e,a),e=V(e,t[4]))}},{reg:/^([a-z]+) ([0-9]{1,2})( [0-9:]+)?( \+[0-9]{4})?( [0-9]{4})?$/i,parse:(e,t)=>{let a={year:W(t[5],e._today),month:J(t[1]),date:E.toCardinal(t[2]||"")};return !1===U(a)?(e.epoch=null,e):(x(e,a),e=V(e,t[3]))}}];const{validate:R,parseTime:X,parseYear:ee,parseMonth:te}=L;var ae=[{reg:/^([0-9]{1,2})[\-\/]([a-z]+)[\-\/]?([0-9]{4})?$/i,parse:(e,t)=>{let a={year:ee(t[3],e._today),month:te(t[2]),date:E.toCardinal(t[1]||"")};return !1===R(a)?(e.epoch=null,e):(x(e,a),e=X(e,t[4]))}},{reg:/^([0-9]{1,2})( [a-z]+)( [0-9]{4}| '[0-9]{2})? ?([0-9]{1,2}:[0-9]{2}:?[0-9]{0,2}? ?(am|pm|gmt))?$/i,parse:(e,t)=>{let a={year:ee(t[3],e._today),month:te(t[2]),date:E.toCardinal(t[1])};return a.month&&!1!==R(a)?(x(e,a),e=X(e,t[4])):(e.epoch=null,e)}},{reg:/^([0-9]{1,2})[\. -/]([a-z]+)[\. -/]([0-9]{4})?( [0-9]{1,2}(:[0-9]{0,2})?(:[0-9]{0,3})? ?(am|pm)?)?$/i,parse:(e,t)=>{let a={date:Number(t[1]),month:te(t[2]),year:Number(t[3])};return !1===R(a)?(e.epoch=null,e):(x(e,a),e=e.startOf("day"),e=X(e,t[4]))}}];const{validate:ne,parseTime:re,parseYear:oe,parseMonth:ie}=L;var se=[].concat(G,K,ae,[{reg:/^([0-9]{4})[\-\/]([0-9]{2})$/i,parse:(e,t)=>{let a={year:t[1],month:parseInt(t[2],10)-1,date:1};return !1===ne(a)?(e.epoch=null,e):(x(e,a),e=re(e,t[4]))}},{reg:/^([a-z]+) ([0-9]{4})$/i,parse:(e,t)=>{let a={year:oe(t[2],e._today),month:ie(t[1]),date:e._today.date||1};return !1===ne(a)?(e.epoch=null,e):(x(e,a),e=re(e,t[4]))}},{reg:/^(q[0-9])( of)?( [0-9]{4})?/i,parse:(e,t)=>{let a=t[1]||"";e=e.quarter(a);let n=t[3]||"";return n&&(n=n.trim(),e=e.year(n)),e}},{reg:/^(spring|summer|winter|fall|autumn)( of)?( [0-9]{4})?/i,parse:(e,t)=>{let a=t[1]||"";e=e.season(a);let n=t[3]||"";return n&&(n=n.trim(),e=e.year(n)),e}},{reg:/^[0-9,]+ ?b\.?c\.?$/i,parse:(e,t)=>{let a=t[0]||"";a=a.replace(/^([0-9,]+) ?b\.?c\.?$/i,"-$1");let n=new Date,r={year:parseInt(a.trim(),10),month:n.getMonth(),date:n.getDate()};return !1===ne(r)?(e.epoch=null,e):(x(e,r),e=re(e))}},{reg:/^[0-9,]+ ?(a\.?d\.?|c\.?e\.?)$/i,parse:(e,t)=>{let a=t[0]||"";a=a.replace(/,/g,"");let n=new Date,r={year:parseInt(a.trim(),10),month:n.getMonth(),date:n.getDate()};return !1===ne(r)?(e.epoch=null,e):(x(e,r),e=re(e))}},{reg:/^[0-9]{4}( ?a\.?d\.?)?$/i,parse:(e,t)=>{let a=e._today;a.month&&!a.date&&(a.date=1);let n=new Date,r={year:oe(t[0],a),month:a.month||n.getMonth(),date:a.date||n.getDate()};return !1===ne(r)?(e.epoch=null,e):(x(e,r),e=re(e))}}]);var ue=w,le=_,he=j,ce=function(e,t,a){for(let n=0;n<se.length;n++){let r=t.match(se[n].reg);if(r){let t=se[n].parse(e,r,a);if(null!==t&&t.isValid())return t}}return !1===e.silent&&console.warn("Warning: couldn't parse date-string: '"+t+"'"),e.epoch=null,e};const{parseArray:de,parseObject:me,parseNumber:pe}=ue,fe={year:(new Date).getFullYear(),month:0,date:1};var ye=(e,t)=>{let a=e._today||fe;if("number"==typeof t)return pe(e,t);if(e.epoch=Date.now(),e._today&&E.isObject(e._today)&&Object.keys(e._today).length>0){let t=me(e,a,fe);t.isValid()&&(e.epoch=t.epoch);}return null==t||""===t?e:!0===E.isDate(t)?(e.epoch=t.getTime(),e):!0===E.isArray(t)?e=de(e,t,a):!0===E.isObject(t)?t.epoch?(e.epoch=t.epoch,e.tz=t.tz,e):e=me(e,t,a):"string"!=typeof t?e:(t=he(t),!0===le.hasOwnProperty(t)?e=le[t](e):ce(e,t))};let ge=["sun","mon","tue","wed","thu","fri","sat"],be=["sunday","monday","tuesday","wednesday","thursday","friday","saturday"];let ke=!0;var we={short:()=>ge,long:()=>be,set:e=>{ge=e.short||ge,be=e.long||be;},aliases:{mo:1,tu:2,we:3,th:4,fr:5,sa:6,su:7,tues:2,weds:3,wedn:3,thur:4,thurs:4}},ve={useTitleCase:()=>ke,set:e=>{ke=e;}},ze=e=>{let t=e.timezone().current.offset;return t?E.formatTimezone(t,":"):"Z"};const _e=e=>ve.useTitleCase()?E.titleCase(e):e,je={day:e=>_e(e.dayName()),"day-short":e=>_e(we.short()[e.day()]),"day-number":e=>e.day(),"day-ordinal":e=>E.ordinal(e.day()),"day-pad":e=>E.zeroPad(e.day()),date:e=>e.date(),"date-ordinal":e=>E.ordinal(e.date()),"date-pad":e=>E.zeroPad(e.date()),month:e=>_e(e.monthName()),"month-short":e=>_e(N.short()[e.month()]),"month-number":e=>e.month(),"month-ordinal":e=>E.ordinal(e.month()),"month-pad":e=>E.zeroPad(e.month()),"iso-month":e=>E.zeroPad(e.month()+1),year:e=>{let t=e.year();return t>0?t:(t=Math.abs(t),t+" BC")},"year-short":e=>{let t=e.year();return t>0?"'"+String(e.year()).substr(2,4):(t=Math.abs(t),t+" BC")},"iso-year":e=>{let t=e.year(),a=t<0,n=E.zeroPad(Math.abs(t),4);return a&&(n=E.zeroPad(n,6),n="-"+n),n},time:e=>e.time(),"time-24":e=>`${e.hour24()}:${E.zeroPad(e.minute())}`,hour:e=>e.hour12(),"hour-pad":e=>E.zeroPad(e.hour12()),"hour-24":e=>e.hour24(),"hour-24-pad":e=>E.zeroPad(e.hour24()),minute:e=>e.minute(),"minute-pad":e=>E.zeroPad(e.minute()),second:e=>e.second(),"second-pad":e=>E.zeroPad(e.second()),millisecond:e=>e.millisecond(),"millisecond-pad":e=>E.zeroPad(e.millisecond(),3),ampm:e=>e.ampm(),quarter:e=>"Q"+e.quarter(),season:e=>e.season(),era:e=>e.era(),json:e=>e.json(),timezone:e=>e.timezone().name,offset:e=>ze(e),numeric:e=>`${e.year()}/${E.zeroPad(e.month()+1)}/${E.zeroPad(e.date())}`,"numeric-us":e=>`${E.zeroPad(e.month()+1)}/${E.zeroPad(e.date())}/${e.year()}`,"numeric-uk":e=>`${E.zeroPad(e.date())}/${E.zeroPad(e.month()+1)}/${e.year()}`,"mm/dd":e=>`${E.zeroPad(e.month()+1)}/${E.zeroPad(e.date())}`,iso:e=>`${e.format("iso-year")}-${E.zeroPad(e.month()+1)}-${E.zeroPad(e.date())}T${E.zeroPad(e.h24())}:${E.zeroPad(e.minute())}:${E.zeroPad(e.second())}.${E.zeroPad(e.millisecond(),3)}${ze(e)}`,"iso-short":e=>{let t=E.zeroPad(e.month()+1),a=E.zeroPad(e.date());var n;return `${(n=e.year())>=0?E.zeroPad(n,4):(n=Math.abs(n),"-"+E.zeroPad(n,4))}-${t}-${a}`},"iso-utc":e=>new Date(e.epoch).toISOString(),nice:e=>`${N.short()[e.month()]} ${E.ordinal(e.date())}, ${e.time()}`,"nice-24":e=>`${N.short()[e.month()]} ${E.ordinal(e.date())}, ${e.hour24()}:${E.zeroPad(e.minute())}`,"nice-year":e=>`${N.short()[e.month()]} ${E.ordinal(e.date())}, ${e.year()}`,"nice-day":e=>`${we.short()[e.day()]} ${_e(N.short()[e.month()])} ${E.ordinal(e.date())}`,"nice-full":e=>`${e.dayName()} ${_e(e.monthName())} ${E.ordinal(e.date())}, ${e.time()}`,"nice-full-24":e=>`${e.dayName()} ${_e(e.monthName())} ${E.ordinal(e.date())}, ${e.hour24()}:${E.zeroPad(e.minute())}`},Oe={"day-name":"day","month-name":"month","iso 8601":"iso","time-h24":"time-24","time-12":"time","time-h12":"time",tz:"timezone","day-num":"day-number","month-num":"month-number","month-iso":"iso-month","year-iso":"iso-year","nice-short":"nice","nice-short-24":"nice-24",mdy:"numeric-us",dmy:"numeric-uk",ymd:"numeric","yyyy/mm/dd":"numeric","mm/dd/yyyy":"numeric-us","dd/mm/yyyy":"numeric-us","little-endian":"numeric-uk","big-endian":"numeric","day-nice":"nice-day"};Object.keys(Oe).forEach(e=>je[e]=je[Oe[e]]);var $e=(e,t="")=>{if(!0!==e.isValid())return "";if(je.hasOwnProperty(t)){let a=je[t](e)||"";return "json"!==t&&(a=String(a),"ampm"!==t&&(a=_e(a))),a}if(-1!==t.indexOf("{")){let a=/\{(.+?)\}/g;return t=t.replace(a,(t,a)=>{if(a=a.toLowerCase().trim(),je.hasOwnProperty(a)){let t=String(je[a](e));return "ampm"!==a?_e(t):t}return ""})}return e.format("iso-short")};const De=E.zeroPad,Me=E.formatTimezone,Pe={G:e=>e.era(),GG:e=>e.era(),GGG:e=>e.era(),GGGG:e=>"AD"===e.era()?"Anno Domini":"Before Christ",y:e=>e.year(),yy:e=>parseInt(String(e.year()).substr(2,4),10),yyy:e=>e.year(),yyyy:e=>e.year(),yyyyy:e=>"0"+e.year(),Q:e=>e.quarter(),QQ:e=>e.quarter(),QQQ:e=>e.quarter(),QQQQ:e=>e.quarter(),M:e=>e.month()+1,MM:e=>De(e.month()+1),MMM:e=>e.format("month-short"),MMMM:e=>e.format("month"),w:e=>e.week(),ww:e=>De(e.week()),d:e=>e.date(),dd:e=>De(e.date()),D:e=>e.dayOfYear(),DD:e=>De(e.dayOfYear()),DDD:e=>De(e.dayOfYear(),3),E:e=>e.format("day-short"),EE:e=>e.format("day-short"),EEE:e=>e.format("day-short"),EEEE:e=>e.format("day"),EEEEE:e=>e.format("day")[0],e:e=>e.day(),ee:e=>e.day(),eee:e=>e.format("day-short"),eeee:e=>e.format("day"),eeeee:e=>e.format("day")[0],a:e=>e.ampm().toUpperCase(),aa:e=>e.ampm().toUpperCase(),aaa:e=>e.ampm().toUpperCase(),aaaa:e=>e.ampm().toUpperCase(),h:e=>e.h12(),hh:e=>De(e.h12()),H:e=>e.hour(),HH:e=>De(e.hour()),m:e=>e.minute(),mm:e=>De(e.minute()),s:e=>e.second(),ss:e=>De(e.second()),SSS:e=>De(e.millisecond(),3),A:e=>e.epoch-e.startOf("day").epoch,z:e=>e.timezone().name,zz:e=>e.timezone().name,zzz:e=>e.timezone().name,zzzz:e=>e.timezone().name,Z:e=>Me(e.timezone().current.offset),ZZ:e=>Me(e.timezone().current.offset),ZZZ:e=>Me(e.timezone().current.offset),ZZZZ:e=>Me(e.timezone().current.offset,":")},Se=(e,t,a)=>{let n=e,r=t;for(let o=0;o<a;o+=1)Pe[n]=Pe[r],n+=e,r+=t;};Se("q","Q",4),Se("L","M",4),Se("Y","y",4),Se("c","e",4),Se("k","H",2),Se("K","h",2),Se("S","s",2),Se("v","z",4),Se("V","Z",4);var qe=(e,t)=>{let a=t.split("");return a=function(e){for(let t=0;t<e.length;t+=1)if("'"===e[t])for(let a=t+1;a<e.length;a+=1){if(e[a]&&(e[t]+=e[a]),"'"===e[a]){e[a]=null;break}e[a]=null;}return e.filter(e=>e)}(a),a=function(e){for(let t=0;t<e.length;t+=1){let a=e[t];for(let n=t+1;n<e.length&&e[n]===a;n+=1)e[t]+=e[n],e[n]=null;}return (e=e.filter(e=>e)).map(e=>("''"===e&&(e="'"),e))}(a),a.reduce((t,a)=>(void 0!==Pe[a]?t+=Pe[a](e)||"":(/^'.{1,}'$/.test(a)&&(a=a.replace(/'/g,"")),t+=a),t),"")};const Te=["year","season","quarter","month","week","day","quarterHour","hour","minute"],Ee=function(e,t){let a=e.clone().startOf(t),n=e.clone().endOf(t).epoch-a.epoch,r=(e.epoch-a.epoch)/n;return parseFloat(r.toFixed(2))};var Ne=(e,t)=>{if(t)return t=E.normalize(t),Ee(e,t);let a={};return Te.forEach(t=>{a[t]=Ee(e,t);}),a};var Ce=(e,t)=>{let a=e.progress();return "quarterhour"===(t=E.normalize(t))&&(t="quarterHour"),void 0!==a[t]?(a[t]>.5&&(e=e.add(1,t)),e=e.startOf(t)):!1===e.silent&&console.warn("no known unit '"+t+"'"),e};const Ie=(e,t,a)=>{let n=0;for(e=e.clone();e.isBefore(t);)e=e.add(1,a),n+=1;return e.isAfter(t,a)&&(n-=1),n};var Ye=(e,t,a)=>e.isBefore(t)?Ie(e,t,a):-1*Ie(t,e,a);var Ae=function(e,t){let a=t.epoch-e.epoch,n={milliseconds:a,seconds:parseInt(a/1e3,10)};n.minutes=parseInt(n.seconds/60,10),n.hours=parseInt(n.minutes/60,10);let r=e.clone();return n.years=((e,t)=>{let a=t.year()-e.year();return (e=e.year(t.year())).isAfter(t)&&(a-=1),a})(r,t),r=e.add(n.years,"year"),n.months=12*n.years,r=e.add(n.months,"month"),n.months+=Ye(r,t,"month"),n.weeks=52*n.years,r=e.add(n.weeks,"week"),n.weeks+=Ye(r,t,"week"),n.days=7*n.weeks,r=e.add(n.days,"day"),n.days+=Ye(r,t,"day"),n};var xe=function(e,t,a){t=E.beADate(t,e);let n=!1;if(e.isAfter(t)){let a=e;e=t,t=a,n=!0;}let r=Ae(e,t);return n&&(r=function(e){return Object.keys(e).forEach(t=>{e[t]*=-1;}),e}(r)),a?(a=E.normalize(a),!0!==/s$/.test(a)&&(a+="s"),"dates"===a&&(a="days"),r[a]):r};const Le={months:{almost:10,over:4},days:{almost:25,over:10},hours:{almost:20,over:8},minutes:{almost:50,over:20},seconds:{almost:50,over:20}};function Fe(e,t){return 1===e&&(t=t.slice(0,-1)),e+" "+t}var Be=(e,t)=>{const a=function(e,t){const a=e.isBefore(t),n=a?t:e;let r=a?e:t;r=r.clone();const o={years:0,months:0,days:0,hours:0,minutes:0,seconds:0};return Object.keys(o).forEach(e=>{if(r.isSame(n,e))return;let t=r.diff(n,e);r=r.add(t,e),o[e]=t;}),a&&Object.keys(o).forEach(e=>{0!==o[e]&&(o[e]*=-1);}),o}(e,t=E.beADate(t,e));if(!0===Object.keys(a).every(e=>!a[e]))return {diff:a,rounded:"now",qualified:"now",precise:"now"};let n,r,o,i=[];return Object.keys(a).forEach((e,t,o)=>{const s=Math.abs(a[e]);if(0===s)return;const u=Fe(s,e);if(i.push(u),!n){if(n=r=u,t>4)return;const i=o[t+1],l=Math.abs(a[i]);l>Le[i].almost?(n=Fe(s+1,e),r="almost "+n):l>Le[i].over&&(r="over "+u);}}),o=i.splice(0,2).join(", "),!0===e.isAfter(t)?(n+=" ago",r+=" ago",o+=" ago"):(n="in "+n,r="in "+r,o="in "+o),{diff:a,rounded:n,qualified:r,precise:o}},Ze={north:[["spring",2,1],["summer",5,1],["fall",8,1],["autumn",8,1],["winter",11,1]],south:[["fall",2,1],["autumn",2,1],["winter",5,1],["spring",8,1],["summer",11,1]]},He=[null,[0,1],[3,1],[6,1],[9,1]];const Qe={minute:e=>(x(e,{second:0,millisecond:0}),e),quarterhour:e=>{let t=e.minutes();return e=t>=45?e.minutes(45):t>=30?e.minutes(30):t>=15?e.minutes(15):e.minutes(0),x(e,{second:0,millisecond:0}),e},hour:e=>(x(e,{minute:0,second:0,millisecond:0}),e),day:e=>(x(e,{hour:0,minute:0,second:0,millisecond:0}),e),week:e=>{let t=e.clone();return (e=e.day(e._weekStart)).isAfter(t)&&(e=e.subtract(1,"week")),x(e,{hour:0,minute:0,second:0,millisecond:0}),e},month:e=>(x(e,{date:1,hour:0,minute:0,second:0,millisecond:0}),e),quarter:e=>{let t=e.quarter();return He[t]&&x(e,{month:He[t][0],date:He[t][1],hour:0,minute:0,second:0,millisecond:0}),e},season:e=>{let t=e.season(),a="north";"South"===e.hemisphere()&&(a="south");for(let n=0;n<Ze[a].length;n++)if(Ze[a][n][0]===t){let r=e.year();return "winter"===t&&e.month()<3&&(r-=1),x(e,{year:r,month:Ze[a][n][1],date:Ze[a][n][2],hour:0,minute:0,second:0,millisecond:0}),e}return e},year:e=>(x(e,{month:0,date:1,hour:0,minute:0,second:0,millisecond:0}),e),decade:e=>{let t=(e=e.startOf("year")).year(),a=10*parseInt(t/10,10);return e=e.year(a)},century:e=>{let t=(e=e.startOf("year")).year(),a=100*parseInt(t/100,10);return e=e.year(a)}};Qe.date=Qe.day;var Ge=g;var Ue=$e,Ve=qe,We=Ne,Je=Ce,Ke=xe,Re=Be,Xe={startOf:(e,t)=>{let a=e.clone();return t=E.normalize(t),Qe[t]?Qe[t](a):"summer"===t||"winter"===t?(a=a.season(t),Qe.season(a)):a},endOf:(e,t)=>{let a=e.clone();return t=E.normalize(t),Qe[t]?(a=Qe[t](a),a=a.add(1,t),a=a.subtract(1,"millisecond"),a):a}},et=function(e,t="",a){if(!t||!a)return [];if(t=E.normalize(t),a=e.clone().set(a),e.isAfter(a)){let t=e;e=a,a=t;}let n=e.clone();!function(e){return !!we.short().find(t=>t===e)||!!we.long().find(t=>t===e)}(t)?n=n.next(t):(n=n.next(t),t="week");let r=[];for(;n.isBefore(a);)r.push(n),n=n.add(1,t);return r},tt=e=>{let a=e.timezones,n=e.tz;if(!1===a.hasOwnProperty(n)&&(n=Ge(e.tz,a)),null===n)return !1===e.silent&&console.warn("Warn: could not find given or local timezone - '"+e.tz+"'"),{current:{epochShift:0}};let r=a[n],o={name:(i=n,i=(i=(i=i[0].toUpperCase()+i.substr(1)).replace(/\/gmt/,"/GMT")).replace(/[\/_]([a-z])/gi,e=>e.toUpperCase())),hasDst:Boolean(r.dst),default_offset:r.offset,hemisphere:"s"===r.hem?"South":"North",current:{}};var i,s;if(o.hasDst){let e=(s=r.dst)?s.split("->"):[];o.change={start:e[0],back:e[1]};}let u=r.offset,l=u;return !0===o.hasDst&&(l="North"===o.hemisphere?u-1:r.offset+1),!1===o.hasDst?(o.current.offset=u,o.current.isDST=!1):!0===t(e.epoch,o.change.start,o.change.back,u,l)?(o.current.offset=u,o.current.isDST="North"===o.hemisphere):(o.current.offset=l,o.current.isDST="South"===o.hemisphere),o},at=ye;const nt=["century","decade","year","month","date","day","hour","minute","second","millisecond"],rt={set:function(e,t){let a=this.clone();return a=at(a,e),t&&(this.tz=Ge(t)),a},timezone:function(){return tt(this)},isDST:function(){return tt(this).current.isDST},hasDST:function(){return tt(this).hasDst},offset:function(){return 60*tt(this).current.offset},hemisphere:function(){return tt(this).hemisphere},format:function(e){return Ue(this,e)},unixFmt:function(e){return Ve(this,e)},startOf:function(e){return Xe.startOf(this,e)},endOf:function(e){return Xe.endOf(this,e)},leapYear:function(){let e=this.year();return E.isLeapYear(e)},progress:function(e){return We(this,e)},nearest:function(e){return Je(this,e)},diff:function(e,t){return Ke(this,e,t)},since:function(e){return e||(e=this.clone().set()),Re(this,e)},next:function(e){return this.add(1,e).startOf(e)},last:function(e){return this.subtract(1,e).startOf(e)},isValid:function(){return !(!this.epoch&&0!==this.epoch)&&!isNaN(this.d.getTime())},goto:function(e){let t=this.clone();return t.tz=Ge(e,t.timezones),t},every:function(e,t){if("object"==typeof e&&"string"==typeof t){let a=t;t=e,e=a;}return et(this,e,t)},isAwake:function(){let e=this.hour();return !(e<8||e>22)},isAsleep:function(){return !this.isAwake()},daysInMonth:function(){switch(this.month()){case 0:return 31;case 1:return this.leapYear()?29:28;case 2:return 31;case 3:return 30;case 4:return 31;case 5:return 30;case 6:case 7:return 31;case 8:return 30;case 9:return 31;case 10:return 30;case 11:return 31;default:throw new Error("Invalid Month state.")}},log:function(){return console.log(""),console.log(Ue(this,"nice-short")),this},logYear:function(){return console.log(""),console.log(Ue(this,"full-short")),this},json:function(){return nt.reduce((e,t)=>(e[t]=this[t](),e),{})},debug:function(){let e=this.timezone(),t=this.format("MM")+" "+this.format("date-ordinal")+" "+this.year();return t+="\n     - "+this.format("time"),console.log("\n\n",t+"\n     - "+e.name+" ("+e.current.offset+")"),this},from:function(e){return (e=this.clone().set(e)).since(this)},fromNow:function(){return this.clone().set(Date.now()).since(this)},weekStart:function(e){if("number"==typeof e)return this._weekStart=e,this;if("string"==typeof e){e=e.toLowerCase().trim();let t=we.short().indexOf(e);-1===t&&(t=we.long().indexOf(e)),-1===t&&(t=1),this._weekStart=t;}else console.warn("Spacetime Error: Cannot understand .weekStart() input:",e);return this}};rt.inDST=rt.isDST,rt.round=rt.nearest,rt.each=rt.every;var ot=rt;const it=E.isLeapYear,st=e=>("string"==typeof e&&(e=parseInt(e,10)),e),ut=["year","month","date","hour","minute","second","millisecond"],lt=(e,t,a)=>{let n=ut.indexOf(a),r=ut.slice(n,ut.length);for(let a=0;a<r.length;a++){let n=t[r[a]]();e[r[a]](n);}return e},ht=function(e,t,a,n){return !0===a&&e.isBefore(t)?e=e.add(1,n):!1===a&&e.isAfter(t)&&(e=e.minus(1,n)),e};var ct={milliseconds:(e,t)=>{t=st(t);let a=e.millisecond()-t;return e.epoch-a},seconds:(e,t,a)=>{t=st(t);let n=e.clone(),r=(e.second()-t)*$.second;return e.epoch=e.epoch-r,(e=ht(e,n,a,"minute")).epoch},minutes:(e,t,a)=>{t=st(t);let n=e.clone(),r=(e.minute()-t)*$.minute;return e.epoch-=r,lt(e,n,"second"),(e=ht(e,n,a,"hour")).epoch},hours:(e,t,a)=>{(t=st(t))>=24?t=24:t<0&&(t=0);let n=e.clone(),r=e.hour()-t,o=r*$.hour;return e.epoch-=o,e.date()!==n.date()&&(e=n.clone(),r>1&&(r-=1),r<1&&(r+=1),o=r*$.hour,e.epoch-=o),x(e,{hour:t}),lt(e,n,"minute"),(e=ht(e,n,a,"day")).epoch},time:(e,t,a)=>{let n=t.match(/([0-9]{1,2})[:h]([0-9]{1,2})(:[0-9]{1,2})? ?(am|pm)?/);if(!n){if(n=t.match(/([0-9]{1,2}) ?(am|pm)/),!n)return e.epoch;n.splice(2,0,"0"),n.splice(3,0,"");}let r=!1,o=parseInt(n[1],10),i=parseInt(n[2],10);i>=60&&(i=59),o>12&&(r=!0),!1===r&&("am"===n[4]&&12===o&&(o=0),"pm"===n[4]&&o<12&&(o+=12)),n[3]=n[3]||"",n[3]=n[3].replace(/:/,"");let s=parseInt(n[3],10)||0,u=e.clone();return e=(e=(e=(e=e.hour(o)).minute(i)).second(s)).millisecond(0),(e=ht(e,u,a,"day")).epoch},date:(e,t,a)=>{if((t=st(t))>28){let a=e.month(),n=T[a];1===a&&29===t&&it(e.year())&&(n=29),t>n&&(t=n);}t<=0&&(t=1);let n=e.clone();return x(e,{date:t}),(e=ht(e,n,a,"month")).epoch},month:(e,t,a)=>{"string"==typeof t&&(t=N.mapping()[t.toLowerCase()]),(t=st(t))>=12&&(t=11),t<=0&&(t=0);let n=e.date();n>T[t]&&(n=T[t]);let r=e.clone();return x(e,{month:t,date:n}),(e=ht(e,r,a,"year")).epoch},year:(e,t)=>("string"==typeof t&&/^'[0-9]{2}$/.test(t)&&(t=t.replace(/'/,"").trim(),t=(t=Number(t))>30?1900+t:2e3+t),t=st(t),x(e,{year:t}),e.epoch),week:(e,t,a)=>{let n=e.clone();return t=st(t),"december"===(e=(e=(e=e.month(0)).date(1)).day("monday")).monthName()&&e.date()>=28&&(e=e.add(1,"week")),t-=1,e=e.add(t,"weeks"),(e=ht(e,n,a,"year")).epoch},dayOfYear:(e,t,a)=>{t=st(t);let n=e.clone();return (t-=1)<=0?t=0:t>=365&&(t=364),e=(e=e.startOf("year")).add(t,"day"),lt(e,n,"hour"),(e=ht(e,n,a,"year")).epoch}};const dt=e=>e=(e=(e=e.minute(0)).second(0)).millisecond(1);var mt={millisecond:function(e){if(void 0!==e){let t=this.clone();return t.epoch=ct.milliseconds(t,e),t}return this.d.getMilliseconds()},second:function(e,t){if(void 0!==e){let a=this.clone();return a.epoch=ct.seconds(a,e,t),a}return this.d.getSeconds()},minute:function(e,t){if(void 0!==e){let a=this.clone();return a.epoch=ct.minutes(a,e,t),a}return this.d.getMinutes()},hour:function(e,t){let a=this.d;if(void 0!==e){let a=this.clone();return a.epoch=ct.hours(a,e,t),a}return a.getHours()},hourFloat:function(e,t){if(void 0!==e){let a=this.clone(),n=e%1;n*=60;let r=parseInt(e,10);return a.epoch=ct.hours(a,r,t),a.epoch=ct.minutes(a,n,t),a}let a=this.d,n=a.getHours(),r=a.getMinutes();return r/=60,n+r},hour12:function(e,t){let a=this.d;if(void 0!==e){let a=this.clone(),n=(e=""+e).match(/^([0-9]+)(am|pm)$/);if(n){let e=parseInt(n[1],10);"pm"===n[2]&&(e+=12),a.epoch=ct.hours(a,e,t);}return a}let n=a.getHours();return n>12&&(n-=12),0===n&&(n=12),n},time:function(e,t){if(void 0!==e){let a=this.clone();return e=e.toLowerCase().trim(),a.epoch=ct.time(a,e,t),a}return `${this.h12()}:${E.zeroPad(this.minute())}${this.ampm()}`},ampm:function(e,t){let a="am",n=this.hour();if(n>=12&&(a="pm"),"string"!=typeof e)return a;let r=this.clone();return e=e.toLowerCase().trim(),n>=12&&"am"===e?(n-=12,r.hour(n,t)):n<12&&"pm"===e?(n+=12,r.hour(n,t)):r},dayTime:function(e,t){if(void 0!==e){const a={morning:"7:00am",breakfast:"7:00am",noon:"12:00am",lunch:"12:00pm",afternoon:"2:00pm",evening:"6:00pm",dinner:"6:00pm",night:"11:00pm",midnight:"23:59pm"};let n=this.clone();return e=(e=e||"").toLowerCase(),!0===a.hasOwnProperty(e)&&(n=n.time(a[e],t)),n}let a=this.hour();return a<6?"night":a<12?"morning":a<17?"afternoon":a<22?"evening":"night"},iso:function(e){return void 0!==e?this.set(e):this.format("iso")}},pt={date:function(e,t){if(void 0!==e){let a=this.clone();return (e=parseInt(e,10))&&(a.epoch=ct.date(a,e,t)),a}return this.d.getDate()},day:function(e,t){if(void 0===e)return this.d.getDay();let a=this.clone(),n=e;"string"==typeof e&&(e=e.toLowerCase(),we.aliases.hasOwnProperty(e)?n=we.aliases[e]:(n=we.short().indexOf(e),-1===n&&(n=we.long().indexOf(e))));let r=this.d.getDay()-n;!0===t&&r>0&&(r-=7),!1===t&&r<0&&(r+=7);let o=this.subtract(r,"days");return x(o,{hour:a.hour(),minute:a.minute(),second:a.second()}),o},dayName:function(e,t){if(void 0===e)return we.long()[this.day()];let a=this.clone();return a=a.day(e,t),a}},ft={dayOfYear:function(e,t){if(void 0!==e){let a=this.clone();return a.epoch=ct.dayOfYear(a,e,t),a}let a,n=0,r=this.d.getMonth();for(let e=1;e<=r;e++)a=new Date,a.setDate(1),a.setFullYear(this.d.getFullYear()),a.setHours(1),a.setMinutes(1),a.setMonth(e),a.setHours(-2),n+=a.getDate();return n+this.d.getDate()},week:function(e,t){if(void 0!==e){let a=this.clone();return a.epoch=ct.week(this,e,t),a=dt(a),a}let a=this.clone();a=a.month(0),a=a.date(1),a=dt(a),a=a.day("monday"),"december"===a.monthName()&&a.date()>=28&&(a=a.add(1,"week"));let n=1;1===a.date()&&(n=0),a=a.minus(1,"second");const r=this.epoch;if(a.epoch>r)return 1;let o=0,i=4*this.month();for(a.epoch+=$.week*i,o+=i;o<=52;o++){if(a.epoch>r)return o+n;a=a.add(1,"week");}return 52},month:function(e,t){if(void 0!==e){let a=this.clone();return a.epoch=ct.month(a,e,t),a}return this.d.getMonth()},monthName:function(e,t){if(void 0!==e){let a=this.clone();return a=a.month(e,t),a}return N.long()[this.month()]},quarter:function(e,t){if(void 0!==e&&("string"==typeof e&&(e=e.replace(/^q/i,""),e=parseInt(e,10)),He[e])){let a=this.clone(),n=He[e][0];return a=a.month(n,t),a=a.date(1,t),a=a.startOf("day"),a}let a=this.d.getMonth();for(let e=1;e<He.length;e++)if(a<He[e][0])return e-1;return 4},season:function(e,t){let a="north";if("South"===this.hemisphere()&&(a="south"),void 0!==e){let n=this.clone();for(let r=0;r<Ze[a].length;r++)e===Ze[a][r][0]&&(n=n.month(Ze[a][r][1],t),n=n.date(1),n=n.startOf("day"));return n}let n=this.d.getMonth();for(let e=0;e<Ze[a].length-1;e++)if(n>=Ze[a][e][1]&&n<Ze[a][e+1][1])return Ze[a][e][0];return "winter"},year:function(e){if(void 0!==e){let t=this.clone();return t.epoch=ct.year(t,e),t}return this.d.getFullYear()},era:function(e){if(void 0!==e){let t=this.clone();e=e.toLowerCase();let a=t.d.getFullYear();return "bc"===e&&a>0&&(t.epoch=ct.year(t,-1*a)),"ad"===e&&a<0&&(t.epoch=ct.year(t,-1*a)),t}return this.d.getFullYear()<0?"BC":"AD"},decade:function(e){if(void 0!==e){if(!(e=(e=(e=String(e)).replace(/([0-9])'?s$/,"$1")).replace(/([0-9])(th|rd|st|nd)/,"$1")))return console.warn("Spacetime: Invalid decade input"),this;2===e.length&&/[0-9][0-9]/.test(e)&&(e="19"+e);let t=Number(e);return isNaN(t)?this:(t=10*Math.floor(t/10),this.year(t))}return this.startOf("decade").year()},century:function(e){if(void 0!==e){"string"==typeof e&&(e=(e=(e=e.replace(/([0-9])(th|rd|st|nd)/,"$1")).replace(/([0-9]+) ?(b\.?c\.?|a\.?d\.?)/i,(e,t,a)=>(a.match(/b\.?c\.?/i)&&(t="-"+t),t))).replace(/c$/,""));let t=Number(e);return isNaN(e)?(console.warn("Spacetime: Invalid century input"),this):(0===t&&(t=1),t=t>=0?100*(t-1):100*(t+1),this.year(t))}let t=this.startOf("century").year();return t=Math.floor(t/100),t<0?t-1:t+1},millenium:function(e){if(void 0!==e){if("string"==typeof e&&(e=e.replace(/([0-9])(th|rd|st|nd)/,"$1"),e=Number(e),isNaN(e)))return console.warn("Spacetime: Invalid millenium input"),this;e>0&&(e-=1);let t=1e3*e;return 0===t&&(t=1),this.year(t)}let t=Math.floor(this.year()/1e3);return t>=0&&(t+=1),t}};const yt=Object.assign({},mt,pt,ft);yt.milliseconds=yt.millisecond,yt.seconds=yt.second,yt.minutes=yt.minute,yt.hours=yt.hour,yt.hour24=yt.hour,yt.h12=yt.hour12,yt.h24=yt.hour24,yt.days=yt.day;var gt=e=>{Object.keys(yt).forEach(t=>{e.prototype[t]=yt[t];});};const bt=E.isLeapYear,kt=function(e,t){return 1===e&&bt(t)?29:T[e]};var wt={months:(e,t)=>{if(e.month>0){let a=parseInt(e.month/12,10);e.year=t.year()+a,e.month=e.month%12;}else if(e.month<0){let a=Math.floor(Math.abs(e.month)/13,10);a=Math.abs(a)+1,e.year=t.year()-a,e.month=e.month%12,e.month=e.month+12,12===e.month&&(e.month=0);}return e},days:(e,t,a)=>{let n=t.year(),r=t.month(),o=kt(r,n);for(;a>o;)a-=o,r+=1,r>=12&&(r-=12,n+=1),o=kt(r,n);return e.month=r,e.date=a,e},daysBack:(e,t,a)=>{e.year=t.year(),e.month=t.month();let n=t.date();for(e.date=n-Math.abs(a);e.date<1;){e.month-=1,e.month<0&&(e.month=11,e.year-=1);let t=kt(e.month,e.year);e.date+=t;}return e}};const vt=["millisecond","second","minute","hour","date","month"];let zt={second:vt.slice(0,1),minute:vt.slice(0,2),quarterhour:vt.slice(0,2),hour:vt.slice(0,3),date:vt.slice(0,4),month:vt.slice(0,4),quarter:vt.slice(0,4),season:vt.slice(0,4),year:vt,decade:vt,century:vt};zt.week=zt.hour,zt.season=zt.date,zt.quarter=zt.date;const _t={year:!0,quarter:!0,season:!0,month:!0,week:!0,date:!0},jt={month:!0,quarter:!0,season:!0,year:!0};var Ot=e=>{e.prototype.add=function(e,t){let a=this.clone();if(!t||0===e)return a;let n=this.clone();if("millisecond"===(t=E.normalize(t)))return a.epoch+=e,a;"fortnight"===t&&(e*=2,t="week"),$[t]?a.epoch+=$[t]*e:"week"===t||"weekend"===t?a.epoch+=$.day*(7*e):"quarter"===t||"season"===t?a.epoch+=$.month*(3*e):"quarterhour"===t&&(a.epoch+=15*$.minute*e);let r={};if(zt[t]&&zt[t].forEach(e=>{r[e]=n[e]();}),_t[t]){const e=n.timezone().current.offset-a.timezone().current.offset;a.epoch+=3600*e*1e3;}if("month"===t&&(r.month=n.month()+e,r=wt.months(r,n)),"week"===t){let t=n.date()+7*e;t<=28&&t>1&&(r.date=t);}if("weekend"===t&&"saturday"!==a.dayName())a=a.day("saturday",!0);else if("date"===t){if(e<0)r=wt.daysBack(r,n,e);else {let t=n.date()+e;r=wt.days(r,n,t);}0!==e&&n.isSame(a,"day")&&(r.date=n.date()+e);}else if("quarter"===t){if(r.month=n.month()+3*e,r.year=n.year(),r.month<0){let e=Math.floor(r.month/12),t=r.month+12*Math.abs(e);r.month=t,r.year+=e;}else if(r.month>=12){let e=Math.floor(r.month/12);r.month=r.month%12,r.year+=e;}r.date=n.date();}else if("year"===t){let t=n.year()+e,r=a.year();if(r<t){let t=Math.floor(e/4)||1;a.epoch+=Math.abs($.day*t);}else if(r>t){let t=Math.floor(e/4)||1;a.epoch+=$.day*t;}}else "decade"===t?r.year=a.year()+10:"century"===t&&(r.year=a.year()+100);if(jt[t]){let e=T[r.month];r.date=n.date(),r.date>e&&(r.date=e);}return Object.keys(r).length>1&&x(a,r),a},e.prototype.subtract=function(e,t){return this.clone().add(-1*e,t)},e.prototype.minus=e.prototype.subtract,e.prototype.plus=e.prototype.add;};const $t={millisecond:e=>e.epoch,second:e=>[e.year(),e.month(),e.date(),e.hour(),e.minute(),e.second()].join("-"),minute:e=>[e.year(),e.month(),e.date(),e.hour(),e.minute()].join("-"),hour:e=>[e.year(),e.month(),e.date(),e.hour()].join("-"),day:e=>[e.year(),e.month(),e.date()].join("-"),week:e=>[e.year(),e.week()].join("-"),month:e=>[e.year(),e.month()].join("-"),quarter:e=>[e.year(),e.quarter()].join("-"),year:e=>e.year()};$t.date=$t.day;var Dt=e=>{const t={isAfter:function(e){e=E.beADate(e,this);let t=E.getEpoch(e);return null===t?null:this.epoch>t},isBefore:function(e){e=E.beADate(e,this);let t=E.getEpoch(e);return null===t?null:this.epoch<t},isEqual:function(e){e=E.beADate(e,this);let t=E.getEpoch(e);return null===t?null:this.epoch===t},isBetween:function(e,t,a=!1){e=E.beADate(e,this),t=E.beADate(t,this);let n=E.getEpoch(e);if(null===n)return null;let r=E.getEpoch(t);return null===r?null:a?this.isBetween(e,t)||this.isEqual(e)||this.isEqual(t):n<this.epoch&&this.epoch<r}};Object.keys(t).forEach(a=>{e.prototype[a]=t[a];});};var Mt=e=>{const t={i18n:e=>{E.isObject(e.days)&&we.set(e.days),E.isObject(e.months)&&N.set(e.months),E.isBoolean(e.useTitleCase)&&ve.set(e.useTitleCase);}};Object.keys(t).forEach(a=>{e.prototype[a]=t[a];});},Pt=a,St=ot,qt=gt,Tt=Ot,Et=e=>{e.prototype.isSame=function(t,a,n=!0){let r=this;if(!a)return null;if("string"==typeof t&&"object"==typeof a){let e=t;t=a,a=e;}return "string"!=typeof t&&"number"!=typeof t||(t=new e(t,this.timezone.name)),a=a.replace(/s$/,""),!0===n&&r.tz!==t.tz&&((t=t.clone()).tz=r.tz),$t[a]?$t[a](r)===$t[a](t):null};},Nt=Dt,Ct=Mt;let It=d;const Yt=function(e,t,a={}){this.epoch=null,this.tz=Ge(t,It),this.silent=a.silent||!0,this.british=a.dmy||a.british,this._weekStart=1,void 0!==a.weekStart&&(this._weekStart=a.weekStart),this._today={},void 0!==a.today&&(this._today=a.today),Object.defineProperty(this,"d",{get:function(){let e=Pt(this),t=(new Date(this.epoch).getTimezoneOffset()||0)+60*e;t=60*t*1e3;let a=this.epoch+t;return new Date(a)}}),Object.defineProperty(this,"timezones",{get:()=>It,set:e=>(It=e,e)});let n=at(this,e);this.epoch=n.epoch;};Object.keys(St).forEach(e=>{Yt.prototype[e]=St[e];}),Yt.prototype.clone=function(){return new Yt(this.epoch,this.tz,{silent:this.silent,weekStart:this._weekStart,today:this._today,parsers:this.parsers})},Yt.prototype.toLocalDate=function(){return this.toNativeDate()},Yt.prototype.toNativeDate=function(){return new Date(this.epoch)},qt(Yt),Tt(Yt),Et(Yt),Nt(Yt),Ct(Yt);var At=Yt;var xt=(e,t)=>{let a=new At(null),n=new At(null);a=a.time(e),n=t?n.time(t):a.add(59,"minutes");let r=a.hour(),o=n.hour();return Object.keys(a.timezones).filter(e=>{if(-1===e.indexOf("/"))return !1;let t=new At(null,e),i=t.hour();return i>=r&&i<=o&&(!(i===r&&t.minute()<a.minute())&&!(i===o&&t.minute()>n.minute()))})};const Lt=(e,t,a)=>new At(e,t,a),Ft=function(e){let t=e._today||{};return Object.keys(t).forEach(a=>{e=e[a](t[a]);}),e};Lt.now=(e,t)=>{let a=new At((new Date).getTime(),e,t);return a=Ft(a),a},Lt.today=(e,t)=>{let a=new At((new Date).getTime(),e,t);return a=Ft(a),a.startOf("day")},Lt.tomorrow=(e,t)=>{let a=new At((new Date).getTime(),e,t);return a=Ft(a),a.add(1,"day").startOf("day")},Lt.yesterday=(e,t)=>{let a=new At((new Date).getTime(),e,t);return a=Ft(a),a.subtract(1,"day").startOf("day")},Lt.extend=function(e={}){return Object.keys(e).forEach(t=>{At.prototype[t]=e[t];}),this},Lt.timezones=function(){return (new At).timezones},Lt.max=function(e,t){let a=new At(null,e,t);return a.epoch=864e13,a},Lt.min=function(e,t){let a=new At(null,e,t);return a.epoch=-864e13,a},Lt.whereIts=xt,Lt.version="6.16.3",Lt.plugin=Lt.extend;var Bt=Lt;

var _data = "Africa/Abidjan¦a2bouake,daloa,san ped1t0yamoussouk1;g,ogo;ro;b1frica/0;abi1timbuktu;i0obo;djan|Africa/Accra¦a2gh1kumasi,ta0;koradi,male;!ana;c0frica/ac0tsiaman;cra|Africa/Addis_Ababa¦a0dire dawa,mek'ele,nazret;ddis ababa,frica/addis0;|Africa/Algiers¦a5b3c2dz,oran,s1t0;ebessa,iaret;etif,idi bel abbes;hlef,onstantine;a0iskra,lida,oumerdas;b ezzouar,tna;frica/algi1lg0nnaba;eria,i0;ers|Africa/Asmera¦a0;frica/asma0sme0;ra|Africa/Asmara¦asmara|Africa/Nairobi¦africa/6e2kisumu,m1na0thika,yt;i6kuru;ayotte,ombasa;a0ldoret;st0t; africa0ern africa;! time,n;asmera,nai0;robi|Africa/Bamako¦africa/b0b0;amako|Africa/Bangui¦africa/b0b0;angui|Africa/Banjul¦africa/b0b0serekunda;anjul|Africa/Bissau¦africa/b1b1g0;uinea b0w;issau|Africa/Blantyre¦africa/b0b0lilongwe,mzuzu;lantyre|Africa/Brazzaville¦africa/b0b0pointe noire;razzaville|Africa/Bujumbura¦africa/b0b0;ujumbura|Africa/Cairo¦a3bani suwayf,cBdamanhur,eg2giza,halw5i1kafr ad dawwar,luxor,new cBport said,qina,s0tanta,zagazig;hibin al kawm,ohag,uez;dku,smail5;!ypt;frica/c7l2s0;w0yut;an; 1exandr0;ia;fayyum,m0;a0inya;hallah al kubra,nsurah;airo|Africa/Casablanca¦a9cAf8kenit7m4oujda angad,rabat,sa2t0;angier,e0;ma5touan;fi,le0;! al jadida;a1ekn3o0;hammedia,rocco;!rrakesh;ra;es;frica/c0gadir,l hoceima;asablanca|Africa/Ceuta¦africa/ceuta,ceuta0;!melilla|Africa/Conakry¦africa/co1c0;amayenne,o0;nakry|Africa/Dakar¦africa/d2d2pikine,t0;hies0ouba;! nones;akar|Africa/Dar_Es_Salaam¦africa/dar0;|Africa/Dar_es_Salaam¦arusha,d1m0tanga,zanzibar;beya,orogoro,wanza;ar es salaam,odoma|Africa/Djibouti¦africa/d0d0;jibouti|Africa/Douala¦africa/d4b1d4edea,gar2kousseri,loum,m0ngaoundere,yaounde;ar1okolo;a1ert0;oua;foussam,menda;ouala|Africa/El_Aaiun¦africa/el1e0laayoune,western sahara;h,l aaiun;|Africa/Freetown¦africa/f0etc,f0greenwich standard time;reetown|Africa/Gaborone¦africa/g0g0;aborone|Africa/Harare¦africa/h0bulawayo,chitungwiza,h0mut1;ar0;are|Africa/Johannesburg¦africa/jIbFcBdAeast londCjIk8newcastEp7r6s2tembisa,uitenhage,v1w0za;elkom,itbank;anderbijlpark,ereeniging;ast,o0prings;uth0weto; africa0ern africa;! standard time,n;andCichards bay,oodepoort;aarl,ietermaritzBort elizabeth,retoria;lerk0ruger0;sdorp;iepsloot,urb5;a1enturi0;on;pe town,rletonvil0;le;enoni,loemfontein,o1rakp0;an;ks1tshabelo;ohannes0;burg|Africa/Juba¦africa/j1j1s0winejok;outh sudan,s;uba|Africa/Kampala¦africa/k0k0;ampala|Africa/Khartoum¦a7c5el 4k2ny3omdurm1port sud1s0wad medani;d,inga,ud0;an;ass0h5osti;ala;dae4fasher,obeid;at,entral africa0;! time;d damaz1frica/kh0l qadarif;artoum;in|Africa/Kigali¦africa/k0k0;igali|Africa/Kinshasa¦africa/kin4c3ki2m0;a0bandaka;sina,tadi;kwit,n1;d,ongo;shasa|Africa/Lagos¦aUbScReQgPiLjKkaIlGmDnBo8port harcourt,s7u6w0zarC;a4est0; africa0ern africa;! 0n;standard t0t0;ime;r9st,t;gep,muah5yo;a9hagamu,okoto;kFn1w0yo;er5o;do,itsha;g,iger0newi;ia;a0in5ubi;idugu0kurdi;ri;aFek0;ki;du0no,tsi0;na;imeFos;badan,jebu ode,k1l0seBwo;a orangun,esa,or6;eBi7ot ekp0;ene;ombe,usau;bute ikorodu,fon alaaye,nugu;alabar,hakwama;auchi,en0;in;b3do2frica/la1ku0tani;re;gos; ekiti;a,eoku1u0;ja;ta|Africa/Libreville¦africa/l0l0;ibreville|Africa/Lome¦africa/l0l0;ome|Africa/Luanda¦africa/lu1huambo,l0n'dalatando;obito,u0;anda|Africa/Lubumbashi¦africa/lu5b3k2l1m0tshikapa;buji mayi,wene ditu;ikasi,u3;ananga,isanga1olwezi;e0ukavu;ni;bumbashi|Africa/Lusaka¦africa/l2k0l2ndola;ab0it0;we;usaka|Africa/Malabo¦africa/m0m0;alabo|Africa/Maputo¦africa/map4beira,chimoio,ma2na1quelimane,z0;imbabwe,w;ca1mpu1;p1to0;la;uto|Africa/Maseru¦africa/m0m0;aseru|Africa/Mbabane¦africa/m0m0;babane|Africa/Mogadishu¦africa/mo1berbera,hargeysa,jamaame,kismayo,m0;arka,o0;gadishu|Africa/Monrovia¦africa/m1l0m1;iber1r;onrov0;ia|Africa/Ndjamena¦africa/nd1chad,n0td;'d0d0;jamena|Africa/Niamey¦africa/n0n0zinder;iamey|Africa/Nouakchott¦africa/n0n0;ouakchott|Africa/Ouagadougou¦africa/o0bobo dioulasso,o0;uagadougou|Africa/Porto-novo¦africa/porto-novo|Africa/Porto-Novo¦abomey calavi,coton0djoug0porto novo;ou|Africa/Sao_Tome¦africa/sao1s0;ao tome,t;|Africa/Timbuktu¦timbuktu|Africa/Tripoli¦a3benghazi,l1misrat4t0zawi2;arhuna,r4;ib0y;ya;frica/tr1l khums,z zawiy0;ah;ipoli|Africa/Tunis¦africa/tunis,sfax,t0;n,unis0;!ia|Africa/Windhoek¦africa/w1na0w1;!mibia;indhoek|America/Adak¦a0us/aleutian;d1leutian islands,merica/a0;d0tka;ak|America/Anchorage¦a0us/alaska;h4k4laska1merica/an0n0;chorage;! (most areas),n 0;daylight0standard0; time;dt,st|America/Anguilla¦a0;merica/an0n0;guilla|America/Antigua¦a0;merica/an0n0;tigua|America/Araguaina¦a0palmas,tocantins;merica/ar0r0;aguaina|America/Argentina¦aNbKcHformosa,jGla EmBneuquen,pAquilmJr9sa1t0;ierra del fuego (tLucumán (tm);lta6n0; 2t0;a 0iago del estero;cruz (sc),fe;juan1luis0miguel de tQsalvador de jM;! (sl);! (sj);! (salpnqrn);esistencRoH;araEilar,osadas;ar del p3e0oron;ndoza0rlo;! (mz);p0rioja (lr);laH;ose c paz,ujuy (jy);atamarca (ct) chubut (ch),or0;dHrient0;es;ahia blanIuenos aires0;! (bac0;f);merica/2r0;!genti0;na;argentina3bDc2j1mendoza,ro0;sario;ujuy;a8ord6;!/0;b8c2sal1t0;ucuman;ta;a3o0;modrivadav1rd0;oba;ia;tamar0;ca;uenos0;|America/Aruba¦a0;merica/ar0r0;uba|America/Asuncion¦a6c5p0san lorenzo;araguay1y0;!st,t;! 0;summer t0t0;ime;apiata,iudad del este;merica/as0s0;uncion|America/Coral_Harbour¦america/atikokan,coral harbour|America/Atikokan¦a0est - on (atikokan) nu (coral h);merica/coral0tikokan;|America/Atka¦atka|America/Bahia¦america/b1b1camacari,feira de santa0itabu0salvador,vitoria da conquista;na;ahia|America/Bahia_Banderas¦america/bahia1bahia0central time - bahía de0; banderas;|America/Barbados¦america/ba1b0;a0b;rbados|America/Belem¦a1b2macapa,par0;auapebas,á (east) amapá;merica/b0nanindeua;elem|America/Belize¦america/be1b0;e0z;lize|America/Blanc-sablon¦america/blanc-0blanc 0;sablon|America/Boa_Vista¦america/boa0boa vista,roraima;|America/Bogota¦america/boFbBc7dosquebradas,floridablanca,i6m5neiva,p3s1v0;alledupar,illavicencio;anta marEincelejo,o0;acha,ledad;a0erei9opayan;lmi8sto;anizales,edellin,onteria;bague,taguei;a2o0ucu8;!lombia0t;! time,n;li,rtagena;arran2ello,o3u0;caramanga,enaventu0;ra;cabermeja,quilla;go0;ta|America/Boise¦america/b0b0mountain - id (south) or (east);oise|America/Cambridge_Bay¦america/cambridge0cambridge bay,mountain - nu (west);|America/Campo_Grande¦america/campo0campo grande,mato grosso do sul;|America/Cancun¦america/c0c0eastern standard time - quintana roo;ancun|America/Caracas¦aHbarGcAgua8m5p4san3turmeCv0;alencia,e0;!nezuela0t;!n standard time; cristobal,ta teresa del tuy;eta4uerto la cruz;a0ucumpiz;raca0turin;ibo,y;renAti0;re;a4iudad 2o1u0;a,m2;ro;bolivar,guay0;ana;bim3r2;in2quisimeto,uta;lto barin1merica/car0;ac0;as|America/Catamarca¦catamarca|America/Cayenne¦america/c1c1french guiana,gf0;!t;ayenne|America/Cayman¦america/c0c0;ayman|America/Chicago¦aVbScPdOfort worth,gNhMiKkZlHmAn6o5plano,s2t1us/central,wi0;chiEsconsV;exYulsa;a0hreveport,ou4t 1;int 0n antonio;louGpaul;klahoXmaha,verland park;ashMe1or0;th dako7;braska,w 0;orleans,south me6;adisNe5i1o0;biIntgomery;lwaukee,nne1ss0;issippi,ouri;apol6so0;ta;mph4;aredo,i0ouisiana,ubb1;ncoln,ttle r0;ock;llino0owa,rving;is;oustBunts6;arland,rand prairie;allBes moines;entral 0hCorpus christi;(most areas),daylight0standard0; time;aton rouge,rowns0;vil0;le;laba7m5r1ust0;in;k1lingt0;on;ans0;as;arillo,erica/ch0;icago;ma|America/Chihuahua¦america/c0c0mountain time - chihuahua (most areas);hihuahua|America/Costa_Rica¦america/costa1c0;osta rica,r;|America/Creston¦america/c0c0mst - bc (creston);reston|America/Cuiaba¦america/c0c0mato grosso,varzea grande;uiaba|America/Curacao¦america/c1c1s0;t maarten,x;uracao|America/Danmarkshavn¦america/d0d0national park (east coast);anmarkshavn|America/Dawson¦america/d0d0pacific - yukon (north);awson|America/Dawson_Creek¦america/dawson0dawson creek,mst - bc (dawson crft st john);|America/Denver¦a3colorado springs,d5el paso,m0navajo,salt lake,us/mountain;dt,ountain 0st;(most areas),daylight0standard0; time;lbuquerque,merica/0urora;d0shiprock;enver|America/Detroit¦america/d0d0eastern - mi (most areas),grand rapids,us/michigan;etroit|America/Dominica¦america/d0d0;ominica|America/Edmonton¦a1ca0e2mountain - ab bc (e) sk (w);lgary,nada/mountain;lberta,merica/e0;dmonton|America/Eirunepe¦a0e2;c2m0;azonas (west),erica/e0;irunepe;re time,t|America/El_Salvador¦america/el2el1s0;an0oyapango,v; salvador;|America/Tijuana¦america/1e4mexic0pacific time us - baja california,t2;ali,o/bajanorte;e2santa1t0;ijuana;;nsenada|America/Indiana¦america/6central - in (4eastern - in (1fort wayne,i9us/0;east-indiana,indiana-starke;crawfor1dadukmn),most areas),p0switzerlan1;i2ulaski);d);perry),star0;ke);fort4indiana0knox4;!/0p2;i0knox;ndianap0;olis;|America/Fortaleza¦america/f3ca2f3imperatriz,j1m0natal,sao luis,teresina;aracanau,ossoro;oao pessoa,uazeiro do norte;mpina grande,ucaia;ortaleza|America/Glace_Bay¦a0glace bay;merica/glace0tlantic - ns (cape breton);|America/Godthab¦america/go4g2w0;est greenland,g0;st,t;l,o1reenland0;! (most areas);dthab|America/Goose_Bay¦a0goose bay;merica/goose0tlantic - labrador (most areas);|America/Grand_Turk¦america/grand1grand turk,t0;c,urks and caicos;|America/Grenada¦america/g0g0;renada|America/Guadeloupe¦america/g0g0;uadeloupe|America/Guatemala¦america/gu1g0mixco,villa nueva;t,u0;atemala|America/Guayaquil¦america/g3cuenca,ec1g3ma0quito,santo domingo de los colorados;chala,nta;!uador0;! (mainland);uayaquil|America/Guyana¦america/gu2g0;eorgetown,u1y0;!t;yana|America/Halifax¦a2canada/atlantic,h5n1p0;ei,rince edward island;ew brunswick,ova scotia;dt,merica/h2tlantic 0;- ns (most areas) pe,daylight0standard0; time;alifax|America/Havana¦aCb9c2diez de octubre,guantanBh1las tunas,pinar del rio,sant0;a clara,iago de cuba;aBolguin;amaguey,dt,i4st,u0;!ba0;! 0n;daylight0standard0; time;e0udad camilo cie0;nfueg1;ay1oyer0;os;amo;merica/ha0rroyo naranjo;vana|America/Hermosillo¦america/h0ciudad obregon,h0mountain standard time - sonora,nogales;ermosillo|America/New_York¦a0Lb0Ic0Bd0Ae06f03greensboro,hialeah,i00jacks01kZlexingtonYmUnNoLpIquHrDsAt7u5v3w0yonkers;ashington1est 0inston salem,orcD;raEvirginI;! dc;ermont,irginia0;! beach;nited states,s0;!/eastern;a0enne1he bronx,oleE;llaha0mpa;ssee;outh 1t0;. petersburg,aten3;bo06cD;a2hode1ichmo00och0;ester; isX;lei2;eens,intana roo;ennsylvan1hiladelph1ittsbur0rovidence;gh;ia;hio,rlan0;do;ew3or1y0;!c;folk,th c0;aroliB; 0ark,port news;hampshiRjersey,york0;! staN;a1eads,i0;ami,chig1;ine,nhatt0ryGssachusetts;an;! fayetI;entucky,nox4;ndia1r0;on2;na;ayette0lorida,ort lauderda1;vil0;le;ast0dt,st; flatbush,ern 0;(most areas),daylight0standard0; time;elawa9urham;ape coral,h3incinnati,leve1o0;lumbus,nnecticut;la0;nd;a0esapeake;rlot0ttanooga;te;altimo1o0rooklyn,uffalo;st3;re;kr1merica/new0tlanta;;on|America/Inuvik¦america/i0i0mountain - nt (west);nuvik|America/Iqaluit¦america/i0eastern - nu (most east areas),i0;qaluit|America/Jamaica¦america/ja2j1k0new k0;ingston;a0m;maica|America/Jujuy¦america/argentina/j0j0;ujuy|America/Juneau¦a0j1;laska - juneau area,merica/j0;uneau|America/Kentucky¦america/1eastern - ky (0l3;louisville area),wayne);kentucky0l1;!/l0;ouisville|America/Knox_In¦knox in|America/Kralendijk¦america/k0k0;ralendijk|America/La_Paz¦america/la3bo1cochabamba,la paz,oruro,s0;anta cruz de la sierra,ucre;!livia0t;! time,n;|America/Lima¦aAc6huanc9i5juliaca,lCp2sant1t0;acna,rujillo;a anita   los ficus,iago de sur5;e0iura,ucall8;!ru0t;! time;ca,quitos;allao,hi1us0;co;cl0mbote;ayo;merica/l1requi0;pa;ima|America/Los_Angeles¦a01baZcXfTgarden grove,hQirviPlLmoInHoEp9r8s1tacoma,us/pacific0washington state;!-new;a1eattle,f,p0tocktQunrise manor;okaMringG;cramenGn0; 1ta 0;aQclariS;bernardiOdiego,fran0jo4;!cisco;ancho cucamonga,eMiver6;a0dt,ort6st;cific 1radi0;se;daylight0standard0; time;ak1cean0regDxnard;side;land;evada,orth las6;des1reno0; valley;to;a1o0;ng4s angeles;!s0; vegas;ne;enders1untington0; beach;on;onta2re0;mont,s0;no;na;a2hula vis0;ta;ja ca0kersfield;lifornia;merica/los0naheim;|America/Lower_Princes¦america/lower0lower princes;|America/Maceio¦a0m1;lagoassergipe,merica/m0racaju;aceio|America/Managua¦america/m1m1ni0;!car1;an0;agua|America/Manaus¦am0brazil/west,m1;azon1erica/m0t;anaus; time,as (east),ian|America/Marigot¦america/m0m0;arigot|America/Martinique¦america/ma1m0;a0q;rtinique|America/Matamoros¦america/m0central time us - coahuilanuevo leóntamaulipas (us border),heroica m0m0nuevo laredo,reynosa;atamoros|America/Mazatlan¦america/ma1culiac2los mochis,m0tepic;a0exico/bajasur,ountain time - baja california surnayaritsinaloa;zatl0;an|America/Menominee¦america/m0central - mi (wisconsin border),m0;enominee|America/Merida¦america/m1c0m1;ampeche,entral time - campecheyucatán;erida|America/Metlakatla¦a0m1;laska - annette island,merica/m0;etlakatla|America/Mexico_City¦a0Eb0CcVduran09ecatepec de morel07guQhPiNjalis0Gleon de los alda03mInHoGpEqDs9t4uruap01v2x1yucat01za0;catec09pop00;alapa de enriqu0Ji0Eochimil0E;e0illahermosa;nustiano carranza,racruz;a3e7la1o0uxt00;luRnaZ;huac,l0quepaque,xcaY;nepantXpT;bas07maulip01pachuW;an0oledad de graciano sanch0B; luis potosi,t0;a maria chimal0iago de q1;huN;ueretaD;achuca de soFoza rica de6ue0;bPrto vallarX;axaGjo de agua;aucalpan01icolas rome9uevo le00;agdalena contrerRexico3i1orel0x;ia,os;choFguel0; h3;! city,/general;rap5xtapalu9zta0;cQpalapa;idalJ;a1erre0stavo adolfo made0;ro;dalajara,naj0;ua0;to;eFhiCiudad Ao3u0;au1ernava0;ca;htemoc,titlan izcalli;a4l2yo0;ac0;an;i0onia del valle;ma;cAhui0tzacoalc2;la;lopez mate0nezahualcoyotl;os;ap1lpancin0;go;as;laya,ntral time;enito7uenavis0;ta;capulco4guascalientes,lvaro obreg3merica/mexico2zcapotz0;al0;co;;on; de0; juar0;ez|America/Miquelon¦america/m0m0pm,st pierre and m0;iquelon|America/Moncton¦a0m1;merica/m0tlantic - new brunswick;oncton|America/Monterrey¦america/mont7c5g4mon3sa1t0victoria de durango;ampico,orreon;ltillo,n0; nicolas de los garza,ta catarina;clova,t3;omez palacio,uadalupe;entral time - durango coahuilanuevo leóntamaulipas (most areas),iudad 0;apodaca,general escobedo,madero,victoria;errey|America/Montevideo¦america/m3m3u0;ruguay1y0;!t;! time;ontevideo|America/Toronto¦america/Bb9ca7eastern - onqc (most areas),gatineau,hamilAkitchener,l4m3nepe2o0quebec,richmond hill,tCvaugh2windsor;n5sh0tt0;awa;an;arkham,ississauga,o9;av9on0;don on0gueuil;tario;!nada0;!/eastern;arrie,ramp0;ton;mo1t0;oronto;ntre0;al|America/Montserrat¦america/m0m0;ontserrat|America/Nassau¦america/n1b0n1;ahamas,s;assau|America/Nipigon¦america/n0n0;ipigon|America/Nome¦a0n1;laska (west),merica/n0;ome|America/Noronha¦a0brazil/den1n1;merica/n0tlantic islands;oronha|America/North_Dakota¦america/north3central - nd (0;m0oliv1;erc0orton rural);er);|America/Ojinaga¦america/o0ciudad juarez,mountain time us - chihuahua (us border),o0;jinaga|America/Panama¦america/pan1pa0san miguelito;!n0;ama|America/Pangnirtung¦america/p0eastern - nu (pangnirtung),p0;angnirtung|America/Paramaribo¦america/p2p2s0;r0uriname;!t;aramaribo|America/Phoenix¦a8c7g5idaho,m4n3pBs2t1u0wyoming;s/ar8tah;empe,ucson;cottsd3inaloa,onora;ayarit,ew mexico;aryv1esa,onta5st - arizona (except navajo);ilbert,lend0;ale;handler,olorado;merica/p2r0;izo0;na;hoenix|America/Port-au-prince¦america/port-au-prince,h0;aiti,t|America/Port-au-Prince¦c2p0;etionville,ort 0;au prince,de paix;arrefour,roix des bouquets|America/Port_Of_Spain¦america/1port of spa2vi0;!rgin islands;port1virg0;in;|America/Rio_Branco¦a0brazil/ac3rio branco;c2merica/0;porto0rio0;;re|America/Porto_Acre¦porto acre|America/Porto_Velho¦america/porto0porto velho,rondônia;|America/Puerto_Rico¦america/puerto1bayamon,p0;r,uerto rico;|America/Punta_Arenas¦america/punta4c0punta arenas,region of magallanes;hile s1l0;dt,st;tandard0ummer0; time;|America/Rainy_River¦america/rainy0central - on (rainy rft frances),rainy river;|America/Rankin_Inlet¦america/rankin0central - nu (central),rankin inlet;|America/Recife¦america/r3caruaru,jaboatao2olinda,p0r3;aulista,e0;rnambuco,trolina;! dos guararapes;ecife|America/Regina¦america/r5c1r5saskat0;c3oon;anada/0st - sk (most areas);east-s0s0;askatc0;hewan;egina|America/Resolute¦america/r0central - nu (resolute),r0;esolute|America/Santa_Isabel¦santa isabel|America/Santarem¦america/s0pará (west),s0;antarem|America/Santiago¦a7c4iquique,la pintana,puente alto,rancagua,san3t1v0;alparaiso,ina del mar;alca0emuco;!huano; bernardo,t4;hile1l0oncepcion;!t;! (most areas),/continental;merica/sant0ntofagasta,rica;iago|America/Santo_Domingo¦america/santo6bella vista,do5la romana,san0; pedro de macoris,t0;iago de los caballeros,o domingo0;! 0;e0oe0;ste;!minican republic;|America/Sao_Paulo¦a12b0Sc0Ld0Iembu,f0Gg0Bhortol0Ai06j03l01mXnVosasco,pLriFs4ta3uber2v0;i0olta redon17;amao,la velha,tor12;a0Ll07;boao da ser01uba0W;a2e1oroNu0;maLzano;rYte lago0K;nt4o 0;bernardo do campo,carl04jo0leopolLpaulo,vicE;ao de meriti,se0;! do0; rio p8s camp01;a 1o0; andDs;barbara d'oes0Lluz0Pmar0P;beirao 3o0;! 0;cla0de janei0g6ver7;ro;das nev06p0;reto;asso fun8e7iraci6lanaltGo4r0;aia g1esidente prud0;en0C;ran0;de;nta grossa,rto aleg0;re;caV;lotXtro0B;do;iteroi,ov0;aKo hamburgo;a1o0;gi das cruzRntes clarE;ri0ua;l03n7;imei3ondr0;ina;acarei,oinville,u0;iz de fo0ndi9;ra;ndaia2patin1ta0;bor6pevi,quaquece1;ga;tuE;andT;o3ravat2uaru0;ja,lh0;os;ai;iNvernador valadarA;loria3oz do0ranca; iguacu;i0uque de caxi8;adema,vi0;noK;a1o0uriti2;ntagem,tH;choeiro de itapemirAmp1no3rapicui0scavel,xias do sul;ba;in1os dos goytacaz0;es;as;a8e4lumenau,r0;!a0st,t;s1zil0;! time,/east,ian;il7íl7;l1t0;im;ford roxo,o horizon0;te;rueri,uru;lvora5merica3na2parecida de goi0;an0;ia;polis;/sao0na;;da|America/Scoresbysund¦america/scoresbysu3e1scoresbysund0;!/ittoqqortoormiit;ast greenla1g0;st,t;nd|America/Shiprock¦shiprock|America/Sitka¦a0s1;laska - sitka area,merica/s0;itka|America/St_Barthelemy¦america/st0st barthelemy;|America/St_Johns¦america/st4canada/newfoundland,n0st johns;d2ewfoundland 0st,t;daylight0labrador (southeast),standard0; time;dt,t;|America/St_Kitts¦america/st0st kitts;|America/St_Lucia¦america/st0st lucia;|America/St_Thomas¦america/st0st thomas;|America/St_Vincent¦america/st0st vincent;|America/Swift_Current¦america/swift0cst - sk (midwest),swift current;|America/Tegucigalpa¦america/t1h0san pedro sula,t1;n,onduras;egucigalpa|America/Thule¦america/thule,thule0;!/pituffik|America/Thunder_Bay¦america/thunder0eastern - on (thunder bay),thunder bay;|America/Tortola¦america/t0t0;ortola|America/Vancouver¦america/va3b1canada/pacific,ladn4okanagan,pacific - bc (most areas),surrey,v0yukon;a2ictor1;ritish columb0urnaby;ia;ncouv0;er|America/Virgin¦virgin|America/Whitehorse¦america/w0canada/yukon,pacific - yukon (south),w0;hitehorse|America/Winnipeg¦america/w2c0m1w2;anada/central,entral - on (west) m0;anitoba;innipeg|America/Yakutat¦a0y1;laska - y0merica/y0;akutat|America/Yellowknife¦america/y0mountain - nt (central),y0;ellowknife|Antarctica/Casey¦antarctica/c0c0;asey|Antarctica/Davis¦a0d2;ntarctica0q;!/d0;avis|Antarctica/Dumontdurville¦antarctica/d0d0;umontdurville|Antarctica/Macquarie¦antarctica/macquarie,macquarie0;! island|Antarctica/Mawson¦antarctica/m0m0;awson|Antarctica/Mcmurdo¦antarctica/m0m0;cmurdo|Antarctica/Palmer¦antarctica/p0p0;almer|Antarctica/Rothera¦antarctica/r0r0;othera|Pacific/Auckland¦a6christchurch,manukau,n0pacific/au7wellington;ew zealand1orth shore,z0;!dt,mt,st;! 0;daylight0standard0t1; t0;ime;ntarctica/south1u0;ckland;|Antarctica/South_Pole¦south pole|Antarctica/Syowa¦antarctica/s0s0;yowa|Antarctica/Troll¦antarctica/t0t0;roll|Antarctica/Vostok¦antarctica/vostok,vost0;!ok|Arctic/Longyearbyen¦arctic/l0l0;ongyearbyen|Asia/Aden¦a0ibb,mukalla,sanaa,taiz;d0l hudaydah,sia/ad0;en|Asia/Almaty¦a5k2nur sultan,p1s0taraz,ust kamenogorsk;emey,hymkent;avlodar,etropavl;a0z;ragandy,zakhstan0;! (most areas);lm0sia/almaty;a0t; ata,-ata time,ty|Asia/Amman¦a1irbid,jo0russeifa,wadi as sir,zarqa;!rd1;mm0sia/amm0;an|Asia/Anadyr¦a0;na0sia/anadyr;dyr0t;! time|Asia/Aqtau¦a0mangghystaū/mankis1;q0sia/aq0;tau|Asia/Aqtobe¦a0;k1qt0sia/aq1;o1öbe/ak0;to0;be|Asia/Ashgabat¦as4t0;m2urkmen0;a4istan0;! time;!t;hga1ia/ash0;ga0khabad;bat|Asia/Ashkhabad¦ashkhabad|Asia/Atyrau¦a0;sia/atyrau,tyra0;u,ū/atirau/gur'yev|Asia/Baghdad¦a4ba3dihok,erbil,i2k1mosul,na0ramadi;jaf,sirA;arbala,irkuk;q,raq;g2sr8;bu ghurayb,d diw5l 4rab2s0; sulaym4ia/bag0t;hdad;!ic0;! standard time;amar2basrah al qadim2falluj2hill2kut,mawsil al jadid2;an0;iy0;ah|Asia/Bahrain¦asia/b0b0;ahrain|Asia/Baku¦a0b3ganja,lankaran,sumqayit;sia/b2z0;!erbaijan0t;! time;aku|Asia/Bangkok¦asia/b9b9ch6h4i2mueang nontha7na1pak kret,s0udon thani;amut prakan,i racha,outh east asia;khon ratchasima,m dinh;ct,ndochina 0;(most areas),time;a0ue;iphong,noi,t y2;iang m1on 0;buri;ai;angkok|Asia/Barnaul¦asia/ba1b0;a0iysk;rnaul|Asia/Beirut¦asia/b1b1l0ra's bay2;b,ebanon;ei0;rut|Asia/Bishkek¦asia/b3b3k0osh;g1yrgyzstan0;! time;!t;ishkek|Asia/Brunei¦asia/brunei,b0;dt,n1runei0;! darussalam time;!t|Asia/Kolkata¦0:3D;1:3L;2:2D;3:3M;4:3J;a35b2Dc24d1We1Uf1Sg1Fh1Ci18j13k0Pl0Km0Cn05odis3KpVquthbull3DrNsFt9u8v5warang2Myamun1P;a6el1Ui5;jayawa2Vsakha0HzianagC;doda2Orana11;daip0jja23lhasn1ttar pradesh;a8eXh7iru5umk0;chirap0Mnelve2p5vottiy0;a39p0;ane,iruvananthapur0Noothuku2Yriss0;mb5njo1X;ar0L;aBecunder4h9i8lst,o7r1Fu5;jan37r5;at,endr1C;l2Znip2N;k3liguKngrau2rJ;ahj1Zi5ri2Oya0L;mo1Mvaji07;har1Xlem,mbh24ng2t04ug0Y;a6e0Eoh5;iItak;ebare2i9j7m5nc1Gtl0Aurke37;ag5g5p0;und08;a5kot;hmund26sth2A;ch0p0;a9imp8roddat0u5;ducher23n5rn17;a5e;sa;ri;li,n7rbha6t5;ia2Vna;ni;chku2Ti5;ha2Gp21;a7e6izam4o5;i1Vwrang2B;l0Sw del0Y;di2Kg7i0Ejaf2Fn5re2Oshik,vi mumb15;ded,g5;i,loi j1V;ercoil,p0;a8eerut,irz25o7u5yso0Y;lugu,mb10rwa1Izaffar5;n1p0;nghyr,rad4;chili7d6harasht1Fleg07n5thu1Fu;ga0Iip0;hya,ur0V;patnG;a7u5;cknow,dhia5;na;l bahadur5t0; n1;aDhaBo8u5;kat6lt5rno1P;a2i;pal2;l5rWta,zhikode;h1Nka1Kl5;am;nd5ragp0;wa;kina13l8marOnp0r5shmir,tih3;i6na5ol ba18;l,tV;mn1;lakuric03y11;a6han5odNunagadh;si;b0Rip0l6m5;mu,n1shedp0;andh3gGna;chalkaranji,mph0In5;!d5;ia5o00;! standard time,n;a6is3ospet,u5;b2g2;o0Hp0ridw3;aChazi4o9reater noi0Mu6wali5y04;or;jar0OlbarQnt0rg6wa5;ha12;aon;rak6sa5;ba;hp0;juw8n5ya;dh6g5;an1;in1;aka;ar5iroz4;id4rukh4;l5taw0M;loF;aAe8h6indigul,ombOurg5;!ap0;anb0Uul5;ia;hra dun,l5was;hi;rbhan5vange8;ga;a09h8o5uttack;ch6imbato5;re;in;a6enn5;ai;nd5pL;a5i0C;!nn1;aNeKhBi9or7rahm04u5;landshahr,rh5;anp0;iv2;li;d3har sharif,jZkan07l5;asp0imoC;aAi7op6u5;baneshw3sav5;al;l6wan5;di,i;ai,wa6;g6ratp0tpa5vn1yand3;ra;alp0;l5ngaluru;gaum,la5;ry;hAli,r6thin5;da;a6ddham5eilly;an;n1s5;at;a6rai5;gh;ramp0;gQhmLizawl,jmKkoRlHmDnantCrrBs6urang4va5;di;ans8ia/5;ca5kolka6;lcut5;ta;ol;ah;ap0;arnath,batt0r5;ava5its3o9;ti;ur;appuz6i5lah4w3;garh;ha;er;adn1ed4;ab5;ad;ag3;ar;arta5ra;la|Asia/Chita¦asia/c0c0;hita|Asia/Choibalsan¦asia/c0c0dornodsükhbaatar;hoibalsan|Asia/Shanghai¦0:3J;1:37;2:35;3:38;4:3D;a3Db31c2Md2He30f2Cg26h1Qji1Ek1Bl0Ym0Wn0Tordos,p0Pq0Lrizh10s08t01wSxLyEz5;aoCh6i5ouc3unyi;bo,go0;a7en6ouk2u5; c3h3CmaWzh2;g2Vj1Izh2;b1Ung5o3E;jiakou5zh2;! shi xuanhua qu;ya0z27;an9i7u5;ci,e18n5;c3fu;b4c9n5ya0;cZgk2;c3g5ji,t31;j17qu1sh16zh2;i6uc5;ha0;a6n5uyi0;di,gt2Wh1Fi0pu,t2Wx13ya0;m17n5;!g5ni0t0Eya0;t1ya0;aBe9u5;h6so0w1Bx5zh2;i,ue;a5u;i,n;i0Hn5;sh1zh2;fang5nxi1;di1;a8i6ong5;chuans0XhDli02sh1;an5eli0;j4sh0Z;i6ng5;gu,sh1;an,hec1Wyu1zh2;anmi0hAi8u5;i5zh2;h5zh2;ua;c5pi0;hu1;a7en6i5uangya14;jiaz15qi,y1;gli,ya0zh0G;n6o5s0I;gu1xi0;g5t2;h20qiu,rKyu;i5uan1J;aFn5o1Xqih0N;g5huangdH;dGh1W;an0Ting7rc,u5;ti1yang5;! H;ding0QxZ;an5eijYingbo;ch5ji0ni0to0ya0;a0o0;entoug2ianRuda5;njU;aEi8u5;anc3o6qi5;ao;he,ya0;a7jPn5upansh01;fTxia 5yi;chengguanI;n0Do5;c3y5;a0u1;i0Wn5ohek2;g5zh2;fa0;ai6un5;mi0sh1;fe0yu1;'1aAe9l4n6u5xi;jCt15;an,c3g5i0zh2;de5li0zh2;zhE;ya0;musi,n8o5xi0;j6z5;uo;ia0;g5shF;m7xi;aFeBohhot,u5;a6i0Dlan ergi,m5n1;en;i7ng5y4;ga0s5;hi;'1b8n1;bi,f7ga0ng5ze;sh5ya0;ui;ei;i7n5rb4;d1g5;u,zh2;c3k2l5;ar;a9u5;an6i5li;l4ya0zh2;g5k2;do0yu1zh2;nsu,opi0;en7o6u5;ji1shQx4zh2;sh1;d2g5;hua0;a6eNong5;gu1h02;d6lian5ndo0qi0to0;!g;oYuk2;angIh5n,t;aBen8i5o00uH;fe0n5;a5ese;! standard K;g5zh2;d5zho0;e,u;ng6o5;ya0zh2;ch7de,sh6zh5;i,ou;a,u;un;zh2;aAe5;i6n5;gbu,xi;'1hGjing5;! 5;time;i7o5yan nur;di0t2;ou;c3sh1y4;an;he0;nCsia/5;ch8harb4sha5;ngh5;ai;in;o5ungki0;ng5;qi0;da,qi0sh5ya0;an,un;ng|Asia/Chungking¦chungking|Asia/Colombo¦asia/c0c0dehiwala mount lavinia,lk,moratuwa,sri lanka;olombo|Asia/Dhaka¦asia/dFbDcBd9jess8khul7mymensingh,na4pa3ra2s1t0;angail,ungi;aid8hib4ylhet;jshahi,ng7;b3ltan,r naogaon;gar5r0t3;ayan0singdi;ganj;na;ore;h6inaj0;pur;hattogram,o0;milla,x's bazar;a0d,ogra;gerhat,ngladesh,rishal;acca,h0;aka|Asia/Dacca¦dacca|Asia/Damascus¦a4d3h2latak1sy0;!r0;ia;am3oms;a1eir ez zor;leppo,r raqq1sia/da0;mascus;ah|Asia/Dili¦asia/d1d1east timor,tl0;!t;ili|Asia/Dubai¦a4d5g2musaff1om0ras al khaim1sharj1uae;!an;ah;st,ulf0;! standard time;bu dhabi,jman,sia/d0;ubai|Asia/Dushanbe¦asia/d2d2t0;ajikistan,j0;!t;ushanbe|Asia/Gaza¦asia/gaza,gaza1p0;alestine,s;! strip|Asia/Hebron¦asia/h0east jerusalem,h0west bank;ebron|Asia/Saigon¦asia/ho0saigon;|Asia/Ho_Chi_Minh¦asia/saig4bien hoa,can tho,da 2ho chi minh,nha tr3qui nh4rach gia,sa dec,thi xa phu my,v0;ietnam0n,ung tau;! (south);lat,n0;ang;on|Asia/Hong_Kong¦asia/hong4h0kowloon,tsuen wan;k2ong0; kong0kong;! time;!t;|Asia/Hovd¦asia/hovd,bayan-ölgiigovi-altaihovduvszavkhan,hov0;d,t|Asia/Irkutsk¦a1brat2irk0ulan ude;t,ut1;ngar0sia/irkut0;sk|Europe/Istanbul¦aZbTcRdPeMgLiJkHmCosmBs5t1u0v08zeytinburnu;eskuedXmrA;arsus,r2urk0;ey0ish;! standard time;!abzon,t;a3i1ultan0;beyJgazi;sIv0;as,erek;msun,n0;cakt5liurfa;aniye;a1er0uratpaH;kezefendi,sin;l0niF;atQt0;epe;a0irikkale,onOutahO;hramanmaras,rabaglFyseR;sJzmi0;r,t;aziantep,ebze;lazig,rzurum,s0uropeF;en0kiC;l8yurt;eniz0iyarbakB;li;ankaEor0;lu,um;a1ur0;sa;gcil2hcelievl1likes5sak4t0;ikent,mB;er;ar;d7n4rnavutkoey,sia2ta0;seh0;ir;/is0;tanbul;kara,ta0;k0l0;ya;a1iyam0;an;na,paza0;ri|Asia/Jakarta¦asia/jXbRcPdepOiMjKkediri,lJmGpArengasdengklOs4t2w0yogyX;est0ib; inLern indonesian time;a0egal;n4sikmal3;ema4itubondo,outh tan3u0;kabumi,medaQra0;b0kR;aya;ge0;raM;a4e1robolinggo,urw0;akMokerto;ka1ma0rcut;laItangsiantar;long2nbaru;daGl3mulaGruG;a1ed0;an;diun,laD;embaC;a0ember;kCmbi,vasumatra;d,n0;donesia;ok;i0urug;ampea,bino5leungsir,mahi,putat,rebon;a1e0injai,ogor;kasi,ngkulu;nd0tam;a0u1; aceh,r lampu0;ng;ak0;arta|Asia/Jayapura¦a0east indonesia,j1new guinea (west papua / irian jaya) malukus/moluccas,wit;mbon,sia/j0;ayapura|Asia/Jerusalem¦as7beersheba,haifa,i1j0petah tiqwa,rishon leziyyon,tel aviv,west jeA;e9mt;d4l,s0;rael0t;! 0i;daylight0standard0; time;dt,t;hdod,ia/0;je1tel0;;rusalem|Asia/Kabul¦a1herat,jalalabad,ka0mazar e sharif;b1ndahar;f1sia/kab0;ul;!ghanistan0t;! time|Asia/Kamchatka¦asia/kamchatka,kamchatka1pet0;ropavlovsk kamchatsky,t;! time|Asia/Karachi¦asia/karObKchiniJdera ghaziHfaisalGgujraFhyderGislamGjhang sadr,kDlaCm7nawabshah,okaAp4quetta,ra3s0;a1h0ialkIukkM;ahkHekhupu8;ddiqDhiwal,rgodha;him yarDwalpindi;akistan1eshawar,k0;!t;! standard time;a3i1u0;lt9zaffar7;ngo0rpur khas;ra;lir cantonment,rd6;hore,rkana;a0otli;moke,r9s8;n5t;abad; kh0;an;ot;a1himber,ure0;wala;hawalp0ttagram;ur;achi|Asia/Urumqi¦a6changji,huoche5k3shihezi,turp2u8xin1zh0;anjia4ongsh1;jiang time,yu0;an;a0orla;ramay,s4;ng;ksu,ral,sia/0;kas1u0;rumqi;hgar|Asia/Katmandu¦asia/kath1kat1n0;epal time,pt;mandu|Asia/Kathmandu¦asia/kat2biratnagar,kath2n1p0;atan,okhara;epal,p;mandu|Asia/Khandyga¦asia/k0k0;handyga|Asia/Krasnoyarsk¦asia/krasnoyarsk,kra0;snoyarsk0t;! time|Asia/Kuala_Lumpur¦aGbukit mertajFgeorge town,ipoh,johor bahEk9m4petali3s0taipiD;e1hah alEu0;ba1ngai petani;paAremb8;ng jaya;ala1y0;!t;cca,ysia0;! 0;(peninsula),time;ampung baru suba3la3ota bha4ua0;la 1nt0;an;lumpur,terengganu;ng;ru;am;lor setar,sia/kuala0;|Asia/Kuching¦asia/ku3k2miri,s0tawau;a0ibu;bahsarawak,ndakan;ota kinabalu,u0;ching|Asia/Kuwait¦a0k1;l ahmadi,sia/k0;uwait|Asia/Macau¦asia/maca1m0;acau,o;o,u|Asia/Macao¦macao|Asia/Magadan¦asia/maga1mag0;a0t;dan|Asia/Makassar¦asia/9b5c3denpaCk2l1ma0palu,samarinda,wita;kAnado,taram;abuan bajo,oa jan6;endari,upang;entral indonesia0ity of bal3;!n time;a0orneo (eastsouth) sulawesi/celebesbalinusa tengarra timor (west);l0njarmasin;ikpap0;an;mak1ujung0;;as0;sar|Asia/Manila¦a04bWcRdaPgeneral santOiMlJmCnaBoAp4quezIsan1ta0zamboanga;clobZguig,rlac,ytE; 1t0;a ro2ol;fernando,jose del monte,pab03;a3h1uerto prince0;sa;!ilippine0t; time,s;gadiRnalanoy,s0;ay,ig;longapo,rmoc;ga,votQ;a0eycauayN;balacat,gugpo poblaci4kati,l3n0;da1iQsilingLtamp0;ay;luyong,ue;ingDol6;on;a1egaspi,i0ucena;bertad,pa;pu lapu,s p4;l0mus;igCoiJ;os;smar0v5;inB;a0ebu,otabato;b1gayan de oro,in5l0;amba,ooc6;anatu5uy0;ao;a4inan2u0;d0tu2;ta;!gon0;an;co1guio,tang0;as;lod,or;n1sia/mani0;la;geles,tipo0;lo|Asia/Muscat¦asia/m0m0seeb;uscat|Asia/Nicosia¦asia2cy0europe2n3;!prus0;! (most areas);/n0;icosia|Asia/Novokuznetsk¦asia/n0kemerovo,n0prokop'yev1;ovokuznet0;sk|Asia/Novosibirsk¦asia/novo1nov0siberia;o0t;sibirsk|Asia/Omsk¦asia/omsk,oms0;k,t|Asia/Oral¦asia/oral,ora0west kazakhstan;l0t;! time|Asia/Phnom_Penh¦asia/phnom0phnom penh,takeo;|Asia/Pontianak¦asia/p0borneo (westcentral),p0tanjung pinang;ontianak|Asia/Pyongyang¦asia/p9chongjin,h5k3n2p9s0won6;ariw0inui7unch'0;on;amp'o,orth korea;a0p;eso5nggye;a1ungnam,ye0;san;e0mhu2;ju;yongya0;ng|Asia/Qatar¦a1doha,qa0;!t1;r rayyan,sia/qat0;ar|Asia/Qyzylorda¦asia/q1k1qyzylorda0;!/kyzylorda/kzyl-1;yzyl0;orda|Asia/Yangon¦asia/rango3b2kyain seikgyi township,m0nay pyi taw,pathein,sittwe,yang3;a0eiktila,m,onywa,yanmar;ndalay,wlamyine;ago,urma;on|Asia/Rangoon¦asia/yang1m0rango1;mt,yanmar time;on|Asia/Riyadh¦a6burayd5dammam,ha4jedd5khamis mushait,me3najran,r7sultan5ta2y0;anbu,e0;!men;'if,buk;cca,dina;'il,far al batin;ah;bha,l 1sia/r0;iyadh;hufuf,jubayl,kharj,mubarraz|Asia/Sakhalin¦asia/sakh1sak0yuzhno sakhalinsk;h0t;alin|Asia/Samarkand¦asia/s2bukhara,nukus,qarshi,s2uz0;bekistan 0t;(west),time;amarkand|Asia/Seoul¦aObuLchGdaeFgBhwaseoQiAje9k7m6pohaErok,s2u1wonIy0;aBeosu;ijeongbuPlsK;e1outh korea,u0;nDwG;jo9o0;ngnamLul;asFokpo;imhae,orea0r,st,wangmyo6;! standard time,n;ju,on8;cCksBn6;angneu2oyaEu1wa0;ng5;mi,ns8riD;ng;gu,je4;angw3eon2in1un0;che2;ju;an,gju7;on;c1s0;an;heon3;n0sia/seoul;san1ya0;ng0; si|Asia/Singapore¦asia/singapore,s0woodlands;g1ingapore0;! time;!t|Asia/Srednekolymsk¦asia/sred1sre0;d0t;nekolymsk|Asia/Taipei¦asia/taip7banqiao,h6k4roc,t0;a0w;i0oyu1;ch2n0p4w0;an;aohsi0eel0;ung;sinchu,ualien;ei|Asia/Tashkent¦a2namangan,qo`q4t3uz0;!bekistan0;! (east);ndij1sia/t0;ashkent;on|Asia/Tbilisi¦asia/t2ge0kuta3t2;!orgia0t;! standard time;bil0;isi|Asia/Tehran¦aTbPgorg00hamZiKkCmaBn8orumiy7pasragad branch,q4rasht,s2t1varam6yazd,za0;hedZnjZ;abHeT;a0hirVirjX;bzevar,nandEri,v3;a0om;rchak,zv0;in;eh;a0eyshabur;jaf0zar0;ab4;layer,shh3;a4erman3ho0;meyni sGrram0wy;ab0sF;ad;!shah;h1r0;aj;riz;r0sfahF;!an0dt,st;! 0iD;daylight0standard0; time;a2irjand,o0ukA;jnu0ruje0;rd;b4ndar abbas;b5hv4m3r2sia/te1zads0;hahr;hr4;ak,dabil;ol;az;ad0;an|Asia/Thimphu¦asia/thim1b0thimp2;hutan,t;bu,p0;hu|Asia/Thimbu¦btt,thimbu|Asia/Tokyo¦0:11;1:1A;2:10;a18ch16fu0Zgifu14h0Oi0Ij0FkZmTnMoKsFt9u8waka05y3;a6o3;k3no;kaic1Co3;ha2su0;maKo;ji,tsun0F;aka7o3sukuba;k5makom05y3;a2o3;hOna0ta;oro03us0Qyo;m0Jrazu0sa1tsu1;a5end00hi4o0u3;i10zu0;monose1zuo0;ita2k3ppoLsebo;ai,u06;dawa05i0Wka3sa0t0E;ya2za1;a6eyaga0Qi3umazu;i4shi3; tokyo0Inomiya ha2;ga0R;g3ha,ra0G;a3oX;no,o0sa1;a5i3orio0;na3to,yaza1;mirinkan,to;chiDeb4tsu3;do,m8ya2;as0J;aBi9o7u3y6;mam5r4shi3;ro;ashi1e,uH;oto;be,c0Dfu,ri3shigaK;ya2;shiwa3takyushu;da;gosVkogawacho honmKmirenjaku,na8s5wa3;g3sa1;oe,uc07;hi01u3;g3kabe;ai;zaY;apan3oetJp,st;! standard ti3;me;bara1chi4ta3wa1zu3;mi;ha5n3;omi3;ya;ra;a8i3oncho;meBr4t3;acR;a4os3;a1hi2;kaNtsu0;chi5kodate,mam3;at3;su;nohe,o3;ji;ji8ku3;i6o0s3ya2;hi2;ma;ka; sD;!sa7;i3ofu;ba,g6;geoshimo,k7mag5njo,omori,s3tsugi;ahika3ia/tokyo;wa;asa1;ki;as4i3;ta;hi|Asia/Tomsk¦asia/t0t0;omsk|Asia/Ujung_Pandang¦ujung pandang|Asia/Ulaanbaatar¦asia/ula4m2ula0;anbaatar0n bator,t;! time;n,ongolia0;! (most areas);anbaatar,n0;|Asia/Ust-nera¦asia/ust-0ust 0;nera|Asia/Vientiane¦asia/v0v0;ientiane|Asia/Vladivostok¦asia/vladivostok,k2vla0;divostok0t;! time;habarovsk0omsomolsk on amur;! vtoroy|Asia/Yakutsk¦asia/yakut2blagoveshchen2yak0;t,utsk0;! time;sk|Asia/Yekaterinburg¦asia/yeka6chelyabin5k4magnitogor5nizhn3or2perm,s1tyumen,ufa,yek0zlatoust;a5t;terlitamak,urgut;e4sk;evartov1y tagil;amensk ural'skiy,urgan;sk;teri0;nburg|Asia/Yerevan¦a0y1;m,rmenia,sia/y0;erevan|Asia/Volgograd¦asia/volgograd|Europe/Volgograd¦europe/volgograd,vol0;gograd0t,zhskiy;! time|Atlantic/Azores¦a0hmt;tlantic/azor1zo0;r0st,t;es|Atlantic/Bermuda¦atlantic/be1b0;e0m;rmuda|Atlantic/Canary¦atlantic/canary,canary0las palmas de gran canaria,santa cruz de tenerife;! islands|Atlantic/Cape_Verde¦atlantic/cape2c0;ape verde,v0;!t;|atlantic/Faroe¦atlantic/faeroe|Atlantic/Faeroe¦faeroe|atlantic/Faeroe¦atlantic/faroe|Atlantic/Faroe¦f0;aroe0o;! islands|Europe/Oslo¦atlantic/jan3berg2europe/o1o1s0;j,valbard and jan may1;slo;en;|Atlantic/Jan_Mayen¦jan mayen|Atlantic/Madeira¦atlantic/madeira,madeira0;! islands|Atlantic/Reykjavik¦atlantic/r0is,r0;eykjavik|Atlantic/South_Georgia¦atlantic/south0gs,south georgia;|Atlantic/St_Helena¦atlantic/st0st helena;|Atlantic/Stanley¦atlantic/s3f0s3;alkland island1k0;!st;!s;tanley|Australia/Sydney¦au0c4new south wales (most areas),s3wollongong;!stralia0;!/0;act,c1nsw,s0;ydney;anberra|Australia/Adelaide¦a0south australia;c6d5ustralia0; central,/3n central0;! 0;daylight0standard0; time;ad0south;elaide;dt,st|Australia/Brisbane¦a1b7gold co8logan,queensland0townsville;! (most areas);e7ustralia0; e5/3n east0;!ern 0;daylight0standard0; time;b0queensland;risbane;ast;dt,st|Australia/Broken_Hill¦australia/0broken hill,new south wales (yancowinna);broken0yancowinna;|Australia/Currie¦australia/c0c0tasmania (king island);urrie|Australia/Darwin¦australia/0d1northern territory;d0north;arwin|Australia/Eucla¦a0cw4e3western australia (eucla);cw3ustralia0; central we2/e1n central western0;! standard time;ucla;st|Australia/Hobart¦australia/1h2tasmania0;! (most areas);h0tasmania;obart|Australia/Lord_Howe¦australia/l5l0;h3ord howe0;! 0;daylight0island,standard0; time;dt,st;hi,ord0;|Australia/Lhi¦lhi|Australia/Lindeman¦australia/l0l0queensland (whitsunday islands);indeman|Australia/Melbourne¦australia/0geelong,m1;m0victoria;elbourne|Australia/Nsw¦nsw|Australia/North¦north|Australia/Perth¦a0p7western australia (most areas);ustralia1w0;dt,st; w5/3n west0;!ern 0;daylight0standard0; time;p0w1;erth;est|Australia/South¦south|Europe/Lisbon¦amadora,europe/l8l8p5we0;st0t;! europe,ern europe0;!an 0;summer t0t0;ime;ort0t;o,ugal0;! (mainland);isbon|Australia/Yancowinna¦yancowinna|Brazil/Denoronha¦denoronha|Chile/EasterIsland¦e0;as0mt;st,t0;!er0; island0island;! s0;tandard0ummer0; time|Canada/Atlantic¦atlantic|Canada/Central¦central|Canada/East-saskatchewan¦east saskatchewan|Canada/Eastern¦eastern|Canada/Mountain¦mountain|Canada/Newfoundland¦newfoundland|Canada/Pacific¦pacific|Chile/Continental¦continental|Pacific/Easter¦chile/easterisland,e0pacific/e0;aster|Europe/Amsterdam¦a4e2groning3n1rot5t0utrecht;he hague,ilburg;etherlands,l;indhov0urope/ams2;en;lmere stad,ms0;terdam|Europe/Andorra¦a0europe/an1;d,n0;dorra|Europe/Astrakhan¦a0europe/a0;strakhan|Europe/Athens¦a1europe/a1gr0thessaloniki;!eece;thens|Europe/London¦a0Kb06c03d00eVgShQiOjeNkingston upon hull,lJmHnBoxRp9reading,s1w0yF;arwick06igan,olverha7;heffield,o3t2u1w0;an4iU;ffolk,nderland,sVttU;afMoke on tre08;meVuth0;a1end on 0;sea;mptP;ly0orts0restO;mouth;ew4o0;r0ttinghamP;th0wB; y0amptonN;orkR;castle upon tyne,port;ancheMi0;dlan3lton keynes;ancaNdn,e1i0oDutE;ncolnMverT;e0icesterG;ds;!rsU;psw0slingt9;ich;ampGert0;fordF;b1l0;asgow,oucesterD;!-eD;dinburgh,s3urope/0;belMlo0;nd0;on;sex;erby1o0udlH;rset;!sh5;a1ity of westmin0oventry,rawlE;ster;mbridge1rdiff;eAir9lack7r2st,uckingham0;sh0;ire;adford,e3i0;st4t0;ain,ish0;! summer time;nt;po0;ol;kenhead,mingham;l1xl0;ey;fast;berdeen,rchway|Europe/Belgrade¦b2europe/b2n1pristina,s0;i,lovenia;is,ovi sad;elgrade|Europe/Berlin¦a05bWcRdPeNfrMgeKhaFkDlBm5n4oberhaus09ro3s1w0;andsbek,iesbad08uppert9;a0tuttgaM;arbrueck06xony;mance,sto8;eue neustadt,uernbe02;a3e2iddle european,oenchengladba1u0;enst9ni0;ch;st,t;gdeWinz,nnheim,rienth0;al;eipzMuebe0;ck;a0iNoeln,rO;rlsruhe,ssM;gTlle (saale),m1nnov0rQ;er;burg0m;! 0;mitte,nord;lsenkirNrmany0;! (most areas);ankfurt am maHeiJ;imsbuettDrfu0ssLurope/beF;rt;e,ortmund,resdJu0;esseldorf,isF;e0hemnitz;ntral europe0st,t;!an 0;summer t0t0;ime;avaria,e6iel5o2r0;aunschwe0emB;ig;chum0nn;! hord0;el;efeld;rl0;in;a2ltona,ugs0;bu0;rg;ch0;en|Europe/Bratislava¦b0europe/b0kosice;ratislava|Europe/Brussels¦antwerpen,b0charleroi,europe/br1gent,liege;e1r0;ussels;!lgium|Europe/Bucharest¦b3c2europe/bu4gala1iasi,oradea,ploies1ro0timisoara;!mania;ti;luj napoca,onstanta,raiova;ra1u0;charest;ila,sov|Europe/Budapest¦b1debrecen,europe/b1hu0;!ngary;udapest|Europe/Busingen¦b0europe/b0;usingen|Europe/Chisinau¦c2europe/1m0;d,oldova;c0tiraspol;hisinau|Europe/Copenhagen¦arhus,c1d0europe/c1;enmark,k;openhagen|Europe/Dublin¦cork,d3e2i0;e,r0;eland,ish summer time;ire,urope/d0;ublin|Europe/Gibraltar¦europe/gib1gi0;!b0;raltar|Europe/Guernsey¦europe/g0g0;uernsey|Europe/Helsinki¦e2fi1h3t0vantaa;ampere,urku;!nland;spoo,urope/h0;elsinki|Europe/Isle_Of_Man¦europe/isle0isle of man;|Europe/Jersey¦europe/jersey|Europe/Kaliningrad¦europe/k0k0;aliningrad|Europe/Kirov¦europe/k0k0;irov|Europe/Kiev¦bila tserkIcherFdDeurope/kiChorlBivano frankivEk7l6m4odessa,poltaIrivne,sumy,ternopil,u2vinnyts1z0;aporizhzh0hytomyr;ya;a,kraine0;! (most areas);a0ykolayC;ki5riupol;ut7vA;amyanske,h1i4r0y9;emenchuk,opyv1yvyy rih;ark7erson,mel0;nytskyy;ivka;ev;nipro,onet0;sk;kasy,ni0;h0vtsi;iv;va|Europe/Ljubljana¦europe/l0l0;jubljana|Europe/Luxembourg¦europe/lux1lu0;!x0;embourg|Europe/Madrid¦aMbJcHeFfuenCgBjerez de la frontera,lAm8ovieEp6s1terrassa,v0zaragoza;alladolFigo;a1evilla,pain0;! (mainland);badell,n0; sebastian,t0; marti,ander,s montjuic;a0uente de vallecas;lma,mpD;a0ostolGurcF;dr6laga;atiFeganE;asteiz / vitorCijon,ran1;carral el par1labr0;ada;do;ixample,lche,s,urope/madr0;id;a0iudad lineal;rabanchel,stello de la pla7;a0ilbao,urgos;da0rce0sque;lo4; coru3l0;cala de henar1icante,mer0;ia;es;na|Europe/Malta¦europe/ma1m0;a0t;lta|Europe/Mariehamn¦europe/m0m0;ariehamn|Europe/Minsk¦b2europe/min3h1m0viteb3;ahilyow,in2;omyel,rodna;abruy0elarus,rest,y;sk|Europe/Monaco¦europe/mo1m0;c,o0;naco|Europe/Moscow¦ar0Bb08c05dzerzh04europe/mo03fet,grozn02ivano01kVlipet0DmQnMorel,pJrEs7t5v2w-su,y0zelenograd;a0oshkar oT;roslavl,seneZ;asyl'evsky ostrHelikiLladi1o0ykhino zhulebQ;logda,ronezh;kavkaz,m07;a0uOver;ganrog,mbD;a4ever3hakhty,molen05ochi,t0yktyvkP; 4a0;ryy osk0vrop0;ol;nQodvS;int 0rW;petersburg;ostov na donu,u1y0;azJbO;!ssia0;!n0;! standard time;e1odolTsk0;ov;nza,trozavodR;a2izhn0ovorossiyQ;ekamPi0;y novL;berezhnyye chelny,l'chik;a1dst,oCs0urmI;d,k;khachka1r'0;ino;la;a2himki,ostroma,rasno0urH;d0gvargeisky;ar;l1z0;an;ininsk6uga;vo;yy;scow;in8;entraln1he0;boksary,repovets;iy;el1ry0;an3;gorod;khangel'1mav0;ir;sk|Europe/Paris¦bordeaux,cergy pontoiCeurope/pBfr9l7m6n4pBre3s0toulouC;aint 1t0; 0rasbourg;etienne;ims,nn1;ant0i5ormandy;es;arsei1ontpellier;e havre,i0yon;lle;!an0;ce;aris;se|Europe/Podgorica¦europe/p0p0;odgorica|Europe/Prague¦brno,europe/p1ostrava,p1s0;k,lovakia;rague|Europe/Riga¦e1kalt,l0r2;atvia,v;ast2e1urope/r0;iga;st,t; europe,ern europe0;!an 0;summer t0t0;ime|Europe/Rome¦bAc9europe/r8florence,genoa,m7naples,p4r8sicily,t2v0;a0eroB;!tican city;aran2rieste,u0;rin,scany;a1ra0;to;dova,lermo;essi4ilan;ome;atan1orsica;ari,olog1resc0;ia;na|Europe/Samara¦europe/sama2izhevsk,s0togliatti on the volga;am0yzran;a0t;ra|Europe/Saratov¦balakovo,europe/s0s0;aratov|Europe/San_Marino¦europe/san0san marino;|Europe/Sarajevo¦banja luka,europe/s0s0;arajevo|Europe/Simferopol¦europe/s0s0;imferopol|Europe/Skopje¦europe/s0s0;kopje|Europe/Sofia¦b1europe/s0plovdiv,s0varna;of2;g,u0;lgar0rgas;ia|Europe/Stockholm¦europe/st1goeteborg,malmoe,s0;e,t0weden;ockholm|Europe/Tallinn¦e0t1;e,stonia,urope/t0;allinn|Europe/Tirane¦al1europe/tirane,tiran0;a,e;!bania|Europe/Tiraspol¦tiraspol|Europe/Ulyanovsk¦europe/u0u0;lyanovsk|Europe/Uzhgorod¦europe/u0ruthenia,u0;zhgorod|Europe/Vaduz¦europe/v0v0;aduz|Europe/Vatican¦europe/v0v0;atican|Europe/Vienna¦a1donaustadt,europe/v0favoriten,graz,linz,v0;ienna;t,ustria|Europe/Vilnius¦europe/v2k1l0v2;ithuania,t;aunas,laipeda;ilnius|Europe/Warsaw¦bEczestochowa,europe/waCg8k6l4mokot7p2radGs1torun,w0zabrze;aBroclC;osnowiec,zczec3;l,o0raga poludnie;land,znan;odz,ubl0;in;ato2iel3rak0;ow;d2li0;wi0;ce;ansk,ynia;rs0;aw;i2y0;dgoszcz,t0;om;alystok,elsko biala|Europe/Zagreb¦europe/z0split,z0;agreb|Europe/Zaporozhye¦europe/zaporozhye,luhansk,sevastopol,zaporozh0;'ye/zaporizhia lugansk/luhansk (east),ye|Europe/Zurich¦europe/z1geneve,li0swiss time,z1;!echtenstein;urich|Indian/Antananarivo¦ant0indian/anta1toamasina;a0sirabe;nanarivo|Indian/Chagos¦british indian ocean territory,c3i0;ndian1o0;!t; c0/c0;hagos|Indian/Christmas¦c0indian/christmas;hristmas1x0;!t;! island|Indian/Cocos¦c0indian/cocos;c2ocos0;! island0;!s;!t|Indian/Comoro¦c0indian/c0;omoro|Indian/Kerguelen¦french southern and antarctic2indian/kerguelen,kerguelen1tf0;!t;!st paul islandamsterdam island;! lands|Indian/Mahe¦indian/m1m1s0;c,eychelles;ahe|Indian/Maldives¦indian/maldives,m0;aldives1v0;!t;! time|Indian/Mauritius¦indian/mauritius,m0;auritius1u0;!t;! time|Indian/Mayotte¦indian/mayotte|Indian/Reunion¦indian/reu2r0;e0éunioncrozetscattered islands;t,u0;nion|Mexico/Bajanorte¦bajanorte|Mexico/Bajasur¦bajasur|Pacific/Apia¦a2pacific/a2s1w0;estern s0s;amoa;pia|Pacific/Bougainville¦b2p0;a0gt;cific/b0pua new guinea time;ougainville|Pacific/Chatham¦cha0nz-chat,pacific/chatham;dt,st,tham0;! island0; 0s;daylight0standard0; time|Pacific/Truk¦pacific/chu0tr0;uk|Pacific/Chuuk¦chuuk1pacific/0;truk,y1;!/truky0;ap|Pacific/Efate¦e1pacific/e1v0;anuatu,u;fate|Pacific/Enderbury¦e1p0;acific/e0hoenix islands;nderbury|Pacific/Fakaofo¦f2pacific/f2t0;k0okelau;!t;akaofo|Pacific/Fiji¦f0pacific/fi2;i1j0;!st,t;ji|Pacific/Funafuti¦f1pacific/f1t0;uvalu,v;unafuti|Pacific/Galapagos¦gal0pacific/gala1;a0t,ápagos islands;pagos|Pacific/Gambier¦gambier0pacific/gambier;! islands|Pacific/Guadalcanal¦g1pacific/g1s0;b,olomon islands;uadalcanal|Pacific/Guam¦ch1g0mp,northern mariana islands,pacific/g0;uam;amorro standard time,st|Pacific/Honolulu¦aleutian,h1pacific/0us/hawaii;ho1johnston;awaii1o0st;nolulu;!an standard time|Pacific/Johnston¦johnston|Pacific/Kiritimati¦ki0line islands,pacific/kirit2;!ri0;b1t0;im0;ati|Pacific/Kosrae¦k0pacific/k0;osrae|Pacific/Kwajalein¦k1m0pacific/k1;arshall islands time,ht;wajalein|Pacific/Majuro¦m0pacific/maj3;a0h;j1rshall islands0;! (most areas);uro|Pacific/Marquesas¦marquesas0pacific/marquesas;! islands|Pacific/Midway¦m1pacific/m1s0;amoa standard time,dt,omoan,st;idway|Pacific/Nauru¦n0pacific/na1;a0r;uru|Pacific/Niue¦n0pacific/ni2;i1u0;!t;ue|Pacific/Norfolk¦n0pacific/norfolk;f,orfolk island|Pacific/Noumea¦n0pacific/no1;c,ew caledonia,o0;umea|Pacific/Pago_Pago¦pa0samoamidway,us/s2;cific/0go pago;pago1s0;amoa;|Pacific/Palau¦p0;a0w;cific/pal0l0;au|Pacific/Pitcairn¦p0;acific/pi0i0n;tcairn|Pacific/Ponape¦p0;acific/pohnpei,onape|Pacific/Pohnpei¦f3micro4p0;acific/1f,ohnpei0;!/0;ponape;m,rench poly0;nesia|Pacific/Port_Moresby¦p0;a0g,ort moresby;cific/port1pua new guinea0;! (most areas);|Pacific/Rarotonga¦c1pacific/r0r0;arotonga;k0ook islands;!t|Pacific/Saipan¦pacific/s0s0;aipan|Pacific/Tahiti¦pacific/t0society islands,t0;ahiti|Pacific/Tarawa¦gilbert islands,pacific/t0t0;arawa|Pacific/Tongatapu¦pacific/tongat2to0;!nga0;!t0;apu|Pacific/Wake¦pacific/wake,u1wake0;! island;m,s minor outlying islands|Pacific/Wallis¦pacific/wallis,w0;allis0f;! and futuna|Pacific/Yap¦yap|ETC/GMT¦etc/gmt|etc/Gmt¦etc/gr1g0;mt,r0;eenwich|ETC/UTC¦etc/utc|Etc/Utc¦etc/2u1z0;!u2;ct,tc;u1zu0;lu;ct,niversal|etc/Utc¦universal|Antarctica/DumontDUrville¦dumont-d'urville|America/Blanc-Sablon¦ast - qc (lower north shore)|America/Fort_Nelson¦mst - bc (ft nelson)|Asia/Famagusta¦northern cyprus|Asia/Qostanay¦kostanay|atlantic/Reykjavik¦iceland|America/Mendoza¦america/argentina/mendoza|America/Buenos_Aires¦ar0;gentin0t;a time,ian";

// strings that don't pack properly
var misc = {
  'gmt+0': 'etc/Gmt',
  'gmt-0': 'etc/Gmt',
  gmt0: 'etc/Gmt',
  'etc/gmt+0': 'Etc/Gmt',
  'etc/gmt-0': 'Etc/Gmt',
  'etc/gmt0': 'Etc/Gmt',
  'msk-01 - kaliningrad': 'Europe/Kaliningrad',
  'msk+00 - moscow area': 'Europe/Moscow',
  'msk+00 - crimea': 'Europe/Simferopol',
  'msk+00 - volgograd': 'Europe/Volgograd',
  'msk+00 - kirov': 'Europe/Kirov',
  'msk+01 - astrakhan': 'Europe/Astrakhan',
  'msk+01 - saratov': 'Europe/Saratov',
  'msk+01 - ulyanovsk': 'Europe/Ulyanovsk',
  'msk+01 - samaraudmurtia': 'Europe/Samara',
  'msk+02 - urals': 'Asia/Yekaterinburg',
  'msk+03 - omsk': 'Asia/Omsk',
  'msk+04 - novosibirsk': 'Asia/Novosibirsk',
  'msk+04 - altai': 'Asia/Barnaul',
  'msk+04 - tomsk': 'Asia/Tomsk',
  'msk+04 - kemerovo': 'Asia/Novokuznetsk',
  'msk+04 - krasnoyarsk area': 'Asia/Krasnoyarsk',
  'msk+05 - irkutskburyatia': 'Asia/Irkutsk',
  'msk+06 - zabaykalsky': 'Asia/Chita',
  'msk+06 - lena river': 'Asia/Yakutsk',
  'msk+06 - tomponskyust-maysky': 'Asia/Khandyga',
  'msk+07 - amur river': 'Asia/Vladivostok',
  'msk+07 - oymyakonsky': 'Asia/Ust-Nera',
  'msk+08 - magadan': 'Asia/Magadan',
  'msk+08 - sakhalin island': 'Asia/Sakhalin',
  'msk+08 - sakha (e) north kuril is': 'Asia/Srednekolymsk',
  'msk+09 - kamchatka': 'Asia/Kamchatka',
  'msk+09 - bering sea': 'Asia/Anadyr'
};

var seq = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    cache = seq.split("").reduce(function (n, o, e) {
  return n[o] = e, n;
}, {}),
    toAlphaCode = function toAlphaCode(n) {
  if (void 0 !== seq[n]) return seq[n];
  var o = 1,
      e = 36,
      t = "";

  for (; n >= e; n -= e, o++, e *= 36) {
  }

  for (; o--;) {
    var _o = n % 36;

    t = String.fromCharCode((_o < 10 ? 48 : 55) + _o) + t, n = (n - _o) / 36;
  }

  return t;
},
    fromAlphaCode = function fromAlphaCode(n) {
  if (void 0 !== cache[n]) return cache[n];
  var o = 0,
      e = 1,
      t = 36,
      r = 1;

  for (; e < n.length; o += t, e++, t *= 36) {
  }

  for (var _e = n.length - 1; _e >= 0; _e--, r *= 36) {
    var _t = n.charCodeAt(_e) - 48;

    _t > 10 && (_t -= 7), o += _t * r;
  }

  return o;
};

var encoding = {
  toAlphaCode: toAlphaCode,
  fromAlphaCode: fromAlphaCode
},
    symbols = function symbols(n) {
  var o = new RegExp("([0-9A-Z]+):([0-9A-Z]+)");

  for (var e = 0; e < n.nodes.length; e++) {
    var t = o.exec(n.nodes[e]);

    if (!t) {
      n.symCount = e;
      break;
    }

    n.syms[encoding.fromAlphaCode(t[1])] = encoding.fromAlphaCode(t[2]);
  }

  n.nodes = n.nodes.slice(n.symCount, n.nodes.length);
};

var indexFromRef = function indexFromRef(n, o, e) {
  var t = encoding.fromAlphaCode(o);
  return t < n.symCount ? n.syms[t] : e + t + 1 - n.symCount;
},
    toArray$1 = function toArray(n) {
  var o = [],
      e = function e(t, r) {
    var s = n.nodes[t];
    "!" === s[0] && (o.push(r), s = s.slice(1));
    var c = s.split(/([A-Z0-9,]+)/g);

    for (var _s = 0; _s < c.length; _s += 2) {
      var u = c[_s],
          i = c[_s + 1];
      if (!u) continue;
      var l = r + u;

      if ("," === i || void 0 === i) {
        o.push(l);
        continue;
      }

      var f = indexFromRef(n, i, t);
      e(f, l);
    }
  };

  return e(0, ""), o;
},
    unpack = function unpack(n) {
  var o = {
    nodes: n.split(";"),
    syms: [],
    symCount: 0
  };
  return n.match(":") && symbols(o), toArray$1(o);
};

var unpack_1 = unpack,
    unpack_1$1 = function unpack_1$1(n) {
  var o = n.split("|").reduce(function (n, o) {
    var e = o.split("¦");
    return n[e[0]] = e[1], n;
  }, {}),
      e = {};
  return Object.keys(o).forEach(function (n) {
    var t = unpack_1(o[n]);
    "true" === n && (n = !0);

    for (var _o2 = 0; _o2 < t.length; _o2++) {
      var r = t[_o2];
      !0 === e.hasOwnProperty(r) ? !1 === Array.isArray(e[r]) ? e[r] = [e[r], n] : e[r].push(n) : e[r] = n;
    }
  }), e;
};

var efrtUnpack_min = unpack_1$1;

var isOffset = /(\-?[0-9]+)h(rs)?/i;
var isNumber = /(\-?[0-9]+)/;
var utcOffset = /utc([\-+]?[0-9]+)/i;
var gmtOffset = /gmt([\-+]?[0-9]+)/i;

var toIana = function toIana(num) {
  num = Number(num);

  if (num > -13 && num < 13) {
    num = num * -1; //it's opposite!

    num = (num > 0 ? '+' : '') + num; //add plus sign

    return 'Etc/GMT' + num;
  }

  return null;
};

var parseOffset = function parseOffset(tz) {
  // '+5hrs'
  var m = tz.match(isOffset);

  if (m !== null) {
    return toIana(m[1]);
  } // 'utc+5'


  m = tz.match(utcOffset);

  if (m !== null) {
    return toIana(m[1]);
  } // 'GMT-5' (not opposite)


  m = tz.match(gmtOffset);

  if (m !== null) {
    var num = Number(m[1]) * -1;
    return toIana(num);
  } // '+5'


  m = tz.match(isNumber);

  if (m !== null) {
    return toIana(m[1]);
  }

  return null;
};

var parseOffset_1 = parseOffset;

var lexicon = efrtUnpack_min(_data);
lexicon = Object.assign(lexicon, misc); // add some redundant data that didn't pack properly

Object.keys(lexicon).filter(function (k) {
  var val = lexicon[k].toLowerCase();

  if (lexicon[val] === undefined) {
    lexicon[val] = lexicon[k];
  }
}); //try to match these against iana form

var normalizeOne = function normalizeOne(tz) {
  tz = tz.replace(/^in /g, '');
  tz = tz.replace(/ time/g, '');
  tz = tz.replace(/ (standard|daylight|summer)/g, '');
  tz = tz.replace(/ - .*/g, ''); //`Eastern Time - US & Canada`

  tz = tz.replace(/, .*/g, ''); //`mumbai, india`

  return tz.trim();
}; //some more aggressive transformations


var normalizeTwo = function normalizeTwo(tz) {
  tz = tz.replace(/\b(east|west|north|south)ern/g, '$1');
  tz = tz.replace(/\b(africa|america|australia)n/g, '$1');
  tz = tz.replace(/\beuropean/g, 'europe');
  tz = tz.replace(/\islands/g, 'island');
  tz = tz.replace(/.*\//g, '');
  return tz.trim();
}; // even-more agressive


var normalizeThree = function normalizeThree(tz) {
  tz = tz.replace(/\(.*\)/, '');
  return tz.trim();
}; //


var find = function find(str) {
  if (!str) {
    return null;
  }

  str = str.toLowerCase().trim(); // lookup known abbreviations

  if (lexicon.hasOwnProperty(str)) {
    return lexicon[str];
  } // -8hrs


  if (/[0-9]/.test(str)) {
    var etc = parseOffset_1(str);

    if (etc) {
      return etc;
    }
  } // start fuzzy-match against iana timezones


  str = normalizeOne(str);

  if (lexicon.hasOwnProperty(str)) {
    return lexicon[str];
  } // 'eastern daylight'


  var tmp = str + ' time';

  if (lexicon.hasOwnProperty(tmp)) {
    return lexicon[tmp];
  } // 'pacific'


  tmp = str + ' standard time';

  if (lexicon.hasOwnProperty(tmp)) {
    return lexicon[tmp];
  } // -- harder normalizations --


  str = normalizeTwo(str);

  if (lexicon.hasOwnProperty(str)) {
    return lexicon[str];
  } // -- HARDER normalizations --


  str = normalizeThree(str);

  if (lexicon.hasOwnProperty(str)) {
    return lexicon[str];
  } // 'eastern daylight'


  tmp = str + ' time';

  if (lexicon.hasOwnProperty(tmp)) {
    return lexicon[tmp];
  } // 'pacific'


  tmp = str + ' standard time';

  if (lexicon.hasOwnProperty(tmp)) {
    return lexicon[tmp];
  }

  return null;
};

var find_1 = find;

//From https://Github.com/Mj1856/Timezonenames
// and from  https://Github.com/Nodatime/Nodatime/Blob/Master/Data/Cldr/Windowszones-35.xml
var _05Metazones = [//gmt-0, with daylight savings
{
  standard: {
    name: 'Greenwich Standard Time',
    abbrev: 'GMT'
  },
  daylight: {
    name: 'British Summer Time',
    abbrev: 'BST'
  },
  alias: ['british', 'britain'],
  pick: 'Europe/London',
  zones: ['Europe/Guernsey', 'Europe/Isle_Of_Man', 'Europe/Jersey', 'Europe/London']
}, {
  standard: {
    name: 'Greenwich Standard Time',
    abbrev: 'GMT'
  },
  daylight: {
    name: 'Irish Summer Time',
    abbrev: 'IST'
  },
  alias: ['ireland'],
  zones: ['Europe/Dublin']
}, //gmt-0, no daylight savings
{
  standard: {
    name: 'Greenwich Standard Time',
    abbrev: 'GMT'
  },
  pick: 'Africa/Freetown',
  alias: ['etc', 'utc'],
  zones: ['Africa/Abidjan', 'Africa/Accra', 'Africa/Bamako', 'Africa/Banjul', 'Africa/Bissau', 'Africa/Conakry', 'Africa/Dakar', 'Africa/Freetown', 'Africa/Lome', 'Africa/Monrovia', 'Africa/Nouakchott', 'Africa/Ouagadougou', 'Africa/Sao_Tome', 'America/Danmarkshavn', 'Antarctica/Troll', 'Atlantic/Reykjavik', 'Atlantic/St_Helena', 'ETC/GMT']
}, //North america
{
  standard: {
    name: 'Central Standard Time',
    abbrev: 'CST'
  },
  daylight: {
    name: 'Central Daylight Time',
    abbrev: 'CDT'
  },
  pick: 'America/Chicago',
  zones: ['America/Bahia_Banderas', 'America/Belize', 'America/Chicago', 'America/Costa_Rica', 'America/El_Salvador', 'America/Guatemala', 'America/Indiana', 'America/Managua', 'America/Matamoros', 'America/Menominee', 'America/Merida', 'America/Mexico_City', 'America/Monterrey', 'America/North_Dakota', 'America/North_Dakota', 'America/North_Dakota', 'America/Rainy_River', 'America/Rankin_Inlet', 'America/Regina', 'America/Resolute', 'America/Swift_Current', 'America/Tegucigalpa', 'America/Winnipeg']
}, {
  standard: {
    name: 'Mountain Standard Time',
    abbrev: 'MST'
  },
  daylight: {
    name: 'Mountain Daylight Time',
    abbrev: 'MDT'
  },
  pick: 'America/Denver',
  zones: ['America/Boise', 'America/Cambridge_Bay', 'America/Creston', 'America/Dawson_Creek', 'America/Denver', 'America/Edmonton', 'America/Fort_Nelson', 'America/Inuvik', 'America/Ojinaga', 'America/Phoenix', 'America/Yellowknife', // add mexico
  'America/Chihuahua', 'America/Hermosillo', 'America/Mazatlan']
}, {
  standard: {
    name: 'Atlantic Standard Time',
    abbrev: 'AST'
  },
  daylight: {
    name: 'Atlantic Daylight Time',
    abbrev: 'ADT'
  },
  pick: 'America/Halifax',
  zones: ['America/Anguilla', 'America/Antigua', 'America/Aruba', 'America/Barbados', 'America/Blanc-sablon', 'America/Curacao', 'America/Dominica', 'America/Glace_Bay', 'America/Goose_Bay', 'America/Grenada', 'America/Guadeloupe', 'America/Halifax', 'America/Kralendijk', 'America/Lower_Princes', 'America/Marigot', 'America/Martinique', 'America/Moncton', 'America/Montserrat', 'America/Port_Of_Spain', 'America/Puerto_Rico', 'America/Santo_Domingo', 'America/St_Barthelemy', 'America/St_Kitts', 'America/St_Lucia', 'America/St_Thomas', 'America/St_Vincent', 'America/Thule', 'America/Tortola', 'Atlantic/Bermuda']
}, {
  standard: {
    name: 'Eastern Standard Time',
    abbrev: 'EST'
  },
  daylight: {
    name: 'Eastern Daylight Time',
    abbrev: 'EDT'
  },
  pick: 'America/New_York',
  zones: ['America/Cancun', 'America/Cayman', 'America/Coral_Harbour', 'America/Detroit', 'America/Grand_Turk', 'America/Indiana', 'America/Indianapolis', 'America/Iqaluit', 'America/Jamaica', 'America/Kentucky', 'America/Louisville', 'America/Nassau', 'America/New_York', 'America/Nipigon', 'America/Panama', 'America/Pangnirtung', 'America/Port-au-prince', 'America/Thunder_Bay', 'America/Toronto', 'America/Montreal']
}, {
  standard: {
    name: 'Pacific Standard Time',
    abbrev: 'PST'
  },
  daylight: {
    name: 'Pacific Daylight Time',
    abbrev: 'PDT'
  },
  pick: 'America/Los_Angeles',
  zones: ['America/Dawson', 'America/Los_Angeles', 'America/Tijuana', 'America/Vancouver', 'America/Whitehorse']
}, {
  standard: {
    name: 'Alaskan Standard Time',
    abbrev: 'AHST'
  },
  daylight: {
    name: 'Alaskan Daylight Time',
    abbrev: 'AHDT'
  },
  pick: 'America/Anchorage',
  zones: ['America/Anchorage', 'America/Juneau', 'America/Metlakatla', 'America/Nome', 'America/Sitka', 'America/Yakutat']
}, {
  standard: {
    name: 'Hawaiian Standard Time',
    abbrev: 'HST'
  },
  alias: ['aleutian', 'hawaii'],
  pick: 'Pacific/Honolulu',
  zones: ['America/Adak', 'Pacific/Honolulu', 'Pacific/Johnston']
}, {
  standard: {
    name: 'Newfoundland Standard Time',
    abbrev: 'NST'
  },
  daylight: {
    name: 'Newfoundland Daylight Time',
    abbrev: 'NDT'
  },
  pick: 'America/St_Johns',
  zones: ['America/St_Johns']
}, ///Europe
{
  standard: {
    name: 'Central European Time',
    abbrev: 'CET'
  },
  daylight: {
    name: 'Central European Summer Time',
    abbrev: 'CEST'
  },
  alias: ['romance', 'central europe'],
  pick: 'Europe/Berlin',
  zones: ['Africa/Algiers', 'Africa/Ceuta', 'Africa/Tunis', 'arctic/Longyearbyen', 'Europe/Amsterdam', 'Europe/Andorra', 'Europe/Belgrade', 'Europe/Berlin', 'Europe/Bratislava', 'Europe/Brussels', 'Europe/Budapest', 'Europe/Busingen', 'Europe/Copenhagen', 'Europe/Gibraltar', 'Europe/Ljubljana', 'Europe/Luxembourg', 'Europe/Madrid', 'Europe/Malta', 'Europe/Monaco', 'Europe/Oslo', 'Europe/Paris', 'Europe/Podgorica', 'Europe/Prague', 'Europe/Rome', 'Europe/San_Marino', 'Europe/Sarajevo', 'Europe/Skopje', 'Europe/Stockholm', 'Europe/Tirane', 'Europe/Vaduz', 'Europe/Vatican', 'Europe/Vienna', 'Europe/Warsaw', 'Europe/Zagreb', 'Europe/Zurich']
}, {
  standard: {
    name: 'Eastern European Time',
    abbrev: 'EET'
  },
  daylight: {
    name: 'Eastern European Summer Time',
    abbrev: 'EEST'
  },
  alias: ['eastern europe'],
  pick: 'Europe/Riga',
  zones: ['Africa/Cairo', 'Africa/Tripoli', 'Asia/Amman', 'Asia/Beirut', 'Asia/Damascus', 'Asia/Famagusta', 'Asia/Gaza', 'Asia/Hebron', 'Asia/Nicosia', 'Europe/Athens', 'Europe/Bucharest', 'Europe/Chisinau', 'Europe/Helsinki', 'Europe/Kaliningrad', 'Europe/Kiev', 'Europe/Mariehamn', 'Europe/Riga', 'Europe/Sofia', 'Europe/Tallinn', 'Europe/Uzhgorod', 'Europe/Vilnius', 'Europe/Zaporozhye']
}, {
  standard: {
    name: 'Western European Time',
    abbrev: 'WET'
  },
  daylight: {
    name: 'Western European Summer Time',
    abbrev: 'WEST'
  },
  alias: ['western europe'],
  pick: 'Europe/Lisbon',
  zones: ['Africa/Casablanca', 'Africa/El_Aaiun', 'Atlantic/Canary', 'Atlantic/Faeroe', 'Atlantic/Madeira', 'Europe/Lisbon']
}, {
  standard: {
    name: 'Turkey Standard Time',
    abbrev: 'TRT'
  },
  alias: ['turkish'],
  pick: 'Europe/Istanbul',
  zones: ['Europe/Istanbul']
}, // samara: ['Europe/Samara', 'Europe/Saratov'],
//Africa
{
  standard: {
    name: 'East Africa Time',
    abbrev: 'EAT'
  },
  alias: ['east african', 'eastern africa'],
  pick: 'Africa/Nairobi',
  zones: ['Africa/Addis_Ababa', 'Africa/Asmera', 'Africa/Dar_Es_Salaam', 'Africa/Djibouti', 'Africa/Juba', 'Africa/Kampala', 'Africa/Mogadishu', 'Africa/Nairobi', 'Indian/Antananarivo', 'Indian/Comoro', 'Indian/Mayotte']
}, {
  standard: {
    name: 'Central Africa Time',
    abbrev: 'CAT'
  },
  pick: 'Africa/Khartoum',
  alias: ['central africa'],
  zones: ['Africa/Blantyre', 'Africa/Bujumbura', 'Africa/Gaborone', 'Africa/Harare', 'Africa/Khartoum', 'Africa/Kigali', 'Africa/Lubumbashi', 'Africa/Lusaka', 'Africa/Maputo', 'Africa/Windhoek']
}, {
  standard: {
    name: 'South Africa Standard Time',
    abbrev: 'SAST'
  },
  alias: ['southern africa', 'south african'],
  pick: 'Africa/Johannesburg',
  zones: ['Africa/Johannesburg', 'Africa/Maseru', 'Africa/Mbabane']
}, {
  standard: {
    name: 'West Africa Standard Time',
    abbrev: 'WAT'
  },
  alias: ['western africa', 'west african'],
  pick: 'Africa/Lagos',
  zones: ['Africa/Bangui', 'Africa/Brazzaville', 'Africa/Douala', 'Africa/Kinshasa', 'Africa/Lagos', 'Africa/Libreville', 'Africa/Luanda', 'Africa/Malabo', 'Africa/Ndjamena', 'Africa/Niamey', 'Africa/Porto-novo']
}, //Australia
{
  standard: {
    name: 'Australian Central Standard Time',
    abbrev: 'ACST'
  },
  daylight: {
    name: 'Australian Central Daylight Time',
    abbrev: 'ACDT'
  },
  alias: ['australia central'],
  pick: 'Australia/Adelaide',
  zones: ['Australia/Adelaide', 'Australia/Broken_Hill', 'Australia/Darwin']
}, {
  standard: {
    name: 'Australian Eastern Standard Time',
    abbrev: 'AEST'
  },
  daylight: {
    name: 'Australian Eastern Daylight Time',
    abbrev: 'AEDT'
  },
  alias: ['australia east'],
  pick: 'Australia/Brisbane',
  zones: ['Australia/Brisbane', 'Australia/Currie', 'Australia/Hobart', 'Australia/Lindeman', 'Australia/Melbourne', 'Australia/Sydney']
}, {
  standard: {
    name: 'Australian Western Standard Time',
    abbrev: 'AWST'
  },
  daylight: {
    name: 'Australian Western Daylight Time',
    abbrev: 'AWDT'
  },
  alias: ['australia west'],
  pick: 'Australia/Perth',
  zones: ['Antarctica/Casey', 'Australia/Perth']
}, {
  standard: {
    name: 'Australian Central Western Standard Time',
    abbrev: 'ACWST'
  },
  alias: ['australia central west'],
  pick: 'Australia/Eucla',
  zones: ['Australia/Eucla']
}, {
  standard: {
    name: 'Lord Howe Standard Time',
    abbrev: 'LHST'
  },
  daylight: {
    name: 'Lord Howe Daylight Time',
    abbrev: 'LHDT'
  },
  pick: 'Australia/Lord_Howe',
  zones: ['Australia/Lord_Howe']
}, {
  standard: {
    name: 'New Zealand Standard Time',
    abbrev: 'NZST'
  },
  daylight: {
    name: 'New Zealand Daylight Time',
    abbrev: 'NZDT'
  },
  pick: 'Pacific/Auckland',
  zones: ['Antarctica/Mcmurdo', 'Pacific/Auckland']
}, {
  standard: {
    name: 'Chatham Island Standard Time',
    abbrev: 'CHAST'
  },
  daylight: {
    name: 'Chatham Island Daylight Time',
    abbrev: 'CHADT'
  },
  pick: 'Pacific/Chatham',
  zones: ['Pacific/Chatham']
}, //Russia
{
  standard: {
    name: 'Russian Standard Time',
    abbrev: 'MSK'
  },
  alias: ['russian'],
  pick: 'Europe/Moscow',
  zones: ['Europe/Astrakhan', 'Europe/Minsk', 'Europe/Moscow', 'Europe/Simferopol', 'Europe/Ulyanovsk', 'Europe/Kirov']
}, {
  standard: {
    name: 'Volgograd Time',
    abbrev: 'VOLT'
  },
  zones: ['Europe/Volgograd']
}, //South america
{
  standard: {
    name: 'Brazil Time',
    abbrev: 'BRT'
  },
  alias: ['brasília', 'brasilia', 'brazilian'],
  pick: 'America/Sao_Paulo',
  zones: ['America/Araguaina', 'America/Bahia', 'America/Belem', 'America/Fortaleza', 'America/Maceio', 'America/Recife', 'America/Santarem', 'America/Sao_Paulo']
}, {
  standard: {
    name: 'Argentina Time',
    abbrev: 'ART'
  },
  alias: ['argentinian'],
  pick: 'America/Buenos_Aires',
  zones: ['America/Argentina', 'America/Buenos_Aires', 'America/Catamarca', 'America/Cordoba', 'America/Jujuy', 'America/Mendoza']
}, {
  standard: {
    name: 'Amazon Time',
    abbrev: 'AMT'
  },
  alias: ['amazonian'],
  pick: 'America/Manaus',
  zones: ['America/Boa_Vista', 'America/Campo_Grande', 'America/Cuiaba', //Has dst?
  'America/Manaus', 'America/Porto_Velho']
}, {
  standard: {
    name: 'Easter Island Standard Time',
    abbrev: 'EAST'
  },
  daylight: {
    name: 'Easter Island Summer Time',
    abbrev: 'EASST'
  },
  zones: ['Chile/EasterIsland']
}, {
  standard: {
    name: 'Venezuelan Standard Time',
    abbrev: 'VET'
  },
  alias: ['venezuela'],
  zones: ['America/Caracas']
}, {
  standard: {
    name: 'Paraguay Time',
    abbrev: 'PYT'
  },
  daylight: {
    name: 'Paraguay Summer Time',
    abbrev: 'PYST'
  },
  zones: ['America/Asuncion']
}, {
  standard: {
    name: 'Cuba Standard Time',
    abbrev: 'CST'
  },
  daylight: {
    name: 'Cuba Daylight Time',
    abbrev: 'CDT'
  },
  alias: ['cuban'],
  zones: ['America/Havana']
}, {
  standard: {
    name: 'Bolivia Time',
    abbrev: 'BOT'
  },
  alias: ['bolivian'],
  zones: ['America/La_Paz']
}, {
  standard: {
    name: 'Colombia Time',
    abbrev: 'COT'
  },
  alias: ['colombian'],
  zones: ['America/Bogota']
}, {
  standard: {
    name: 'Acre Time',
    abbrev: 'ACT'
  },
  pick: null,
  zones: ['America/Eirunepe', 'America/Rio_Branco']
}, {
  standard: {
    name: 'Peru Time',
    abbrev: 'PET'
  },
  zones: ['America/Lima']
}, {
  standard: {
    name: 'Chile Standard Time',
    abbrev: 'CLST'
  },
  daylight: {
    name: 'Chile Summer Time',
    abbrev: 'CLDT'
  },
  pick: null,
  zones: ['America/Punta_Arenas', 'America/Santiago', 'Antarctica/Palmer']
}, {
  standard: {
    name: 'Uruguay Time',
    abbrev: 'UYT'
  },
  zones: ['America/Montevideo']
}, // argentina_Western: ['America/Argentina/San_Luis'],
// french_Guiana: ['America/Cayenne'],
// greenland_Western: ['America/Godthab'],
// ecuador: ['America/Guayaquil'],
// guyana: ['America/Guyana'],
// pierre_Miquelon: ['America/Miquelon'],
// noronha: ['America/Noronha'],
// suriname: ['America/Paramaribo'],
// mexico_Northwest: ['America/Santa_Isabel'],
//Middle-east
{
  standard: {
    name: 'Arabic Standard Time',
    abbrev: 'AST'
  },
  pick: 'Asia/Baghdad',
  alias: ['arabic', 'arab'],
  zones: ['Asia/Aden', 'Asia/Baghdad', 'Asia/Bahrain', 'Asia/Kuwait', 'Asia/Qatar', 'Asia/Riyadh']
}, {
  standard: {
    name: 'Iran Standard Time',
    abbrev: 'IRST'
  },
  daylight: {
    name: 'Iran Daylight Time',
    abbrev: 'IRDT'
  },
  alias: ['iranian'],
  pick: 'Asia/Tehran',
  zones: ['Asia/Tehran']
}, {
  standard: {
    name: 'Pakistan Standard Time',
    abbrev: 'PKT'
  },
  pick: 'Asia/Karachi',
  zones: ['Asia/Karachi']
}, {
  standard: {
    name: 'India Standard Time',
    abbrev: 'IST'
  },
  alias: ['indian'],
  pick: 'Asia/Kolkata',
  zones: ['Asia/Kolkata', 'Asia/Colombo']
}, {
  standard: {
    name: 'Indochina Time',
    abbrev: 'ICT'
  },
  alias: ['South East Asia'],
  pick: 'Asia/Bangkok',
  zones: ['Asia/Bangkok', 'Asia/Phnom_Penh', 'Asia/Saigon', 'Asia/Vientiane']
}, {
  standard: {
    name: 'China Standard Time',
    abbrev: 'CT'
  },
  //cst?
  alias: ['chinese'],
  pick: 'Asia/Shanghai',
  zones: ['Asia/Macau', 'Asia/Shanghai', 'Asia/Taipei']
}, {
  standard: {
    name: 'Alma-Ata Time',
    abbrev: 'ALMT'
  },
  pick: 'Asia/Almaty',
  zones: ['Asia/Almaty', 'Asia/Qostanay']
}, {
  standard: {
    name: 'Oral Time',
    abbrev: 'ORAT'
  },
  pick: 'Asia/Oral',
  zones: ['Asia/Aqtau', 'Asia/Aqtobe', 'Asia/Atyrau', 'Asia/Oral', 'Asia/Qyzylorda']
}, {
  standard: {
    name: 'Yakutsk Time',
    abbrev: 'YAKT'
  },
  pick: 'Asia/Yakutsk',
  zones: ['Asia/Chita', 'Asia/Khandyga', 'Asia/Yakutsk']
}, {
  standard: {
    name: 'Gulf Standard Time',
    abbrev: 'GST'
  },
  pick: 'Asia/Dubai',
  alias: ['uae'],
  zones: ['Asia/Dubai', 'Asia/Muscat']
}, {
  standard: {
    name: 'Hong Kong Time',
    abbrev: 'HKT'
  },
  zones: ['Asia/Hong_Kong']
}, {
  standard: {
    name: 'Western Indonesian Time',
    abbrev: 'WIB'
  },
  alias: ['indonesia'],
  //most of it
  zones: ['Asia/Jakarta', 'Asia/Pontianak', 'Asia/Jayapura']
}, {
  standard: {
    name: 'Central Indonesian Time',
    abbrev: 'WITA'
  },
  zones: ['Asia/Makassar']
}, {
  standard: {
    name: 'Israel Daylight Time',
    abbrev: 'IDT'
  },
  daylight: {
    name: 'Israel Standard Time',
    abbrev: 'IST'
  },
  alias: ['israeli'],
  zones: ['Asia/Jerusalem']
}, {
  standard: {
    name: 'Krasnoyarsk Time',
    abbrev: 'KRAT'
  },
  zones: ['Asia/Krasnoyarsk', 'Asia/Novokuznetsk', 'Asia/Barnaul']
}, {
  standard: {
    name: 'Malaysia Time',
    abbrev: 'MYT'
  },
  zones: ['Asia/Kuala_Lumpur', 'Asia/Kuching']
}, {
  standard: {
    name: 'Singapore Time',
    abbrev: 'SGT'
  },
  zones: ['Asia/Singapore']
}, {
  standard: {
    name: 'Korea Standard Time',
    abbrev: 'KST'
  },
  pick: 'Asia/Seoul',
  alias: ['korean'],
  zones: ['Asia/Pyongyang', 'Asia/Seoul']
}, {
  standard: {
    name: 'Uzbekistan Time',
    abbrev: 'UZT'
  },
  zones: ['Asia/Samarkand', 'Asia/Tashkent']
}, {
  standard: {
    name: 'Vladivostok Time',
    abbrev: 'VLAT'
  },
  pick: 'Asia/Vladivostok',
  zones: ['Asia/Ust-nera', 'Asia/Vladivostok']
}, {
  standard: {
    name: 'Anadyr Time',
    abbrev: 'ANAT'
  },
  zones: ['Asia/Anadyr']
}, {
  standard: {
    name: 'Turkmenistan Time',
    abbrev: 'TMT'
  },
  zones: ['Asia/Ashgabat']
}, {
  standard: {
    name: 'Azerbaijan Time',
    abbrev: 'AZT'
  },
  zones: ['Asia/Baku']
}, {
  standard: {
    name: 'Kyrgyzstan Time',
    abbrev: 'KGT'
  },
  zones: ['Asia/Bishkek']
}, {
  standard: {
    name: 'Brunei Darussalam Time',
    abbrev: 'BNT'
  },
  zones: ['Asia/Brunei']
}, // choibalsan: ['Asia/Choibalsan'],
// { standard: { name: 'Bangladesh Standard Time', abbrev: 'BST' }, zones: ['Asia/Dhaka'] },
// east_Timor: ['Asia/Dili'],
// tajikistan: ['Asia/Dushanbe'],
// hovd: ['Asia/Hovd'],
// irkutsk: ['Asia/Irkutsk'],
{
  standard: {
    name: 'Afghanistan Time',
    abbrev: 'AFT'
  },
  zones: ['Asia/Kabul']
}, {
  standard: {
    name: 'Kamchatka Time',
    abbrev: 'PETT'
  },
  zones: ['Asia/Kamchatka']
}, {
  standard: {
    name: 'Nepal Time',
    abbrev: 'NPT'
  },
  zones: ['Asia/Katmandu']
}, // magadan: ['Asia/Magadan'],
{
  standard: {
    name: 'Philippine Time',
    abbrev: 'PHT'
  },
  zones: ['Asia/Manila']
}, // novosibirsk: ['Asia/Novosibirsk'],
// omsk: ['Asia/Omsk'],
{
  standard: {
    name: 'Myanmar Time',
    abbrev: 'MMT'
  },
  zones: ['Asia/Rangoon']
}, // sakhalin: ['Asia/Sakhalin'],
// srednekolymsk: ['Asia/Srednekolymsk'],
{
  standard: {
    name: 'Georgia Standard Time',
    abbrev: 'GET'
  },
  zones: ['Asia/Tbilisi']
}, // bhutan: ['Asia/Thimphu'],
{
  standard: {
    name: 'Japan Standard Time',
    abbrev: 'JST'
  },
  zones: ['Asia/Tokyo']
}, {
  standard: {
    name: 'Ulaanbaatar Time',
    abbrev: 'ULAT'
  },
  zones: ['Asia/Ulaanbaatar']
}, // urumqi: ['Asia/Urumqi'],
// yekaterinburg: ['Asia/Yekaterinburg'],
// armenia: ['Asia/Yerevan'],
// azores: ['Atlantic/Azores'],
// cape_Verde: ['Atlantic/Cape_Verde'],
// south_Georgia: ['Atlantic/South_Georgia'],
// falkland: ['Atlantic/Stanley'],
//India
{
  standard: {
    name: 'Maldives Time',
    abbrev: 'MVT'
  },
  zones: ['Indian/Maldives']
}, {
  standard: {
    name: 'Mauritius Time',
    abbrev: 'MUT'
  },
  zones: ['Indian/Mauritius']
}, {
  standard: {
    name: 'Marshall Islands Time',
    abbrev: 'MHT'
  },
  zones: ['Pacific/Kwajalein', 'Pacific/Majuro']
}, {
  standard: {
    name: 'Samoa Standard Time',
    abbrev: 'SST'
  },
  alias: ['somoan'],
  zones: ['Pacific/Midway', 'Pacific/Pago_Pago']
}, {
  standard: {
    name: 'Chamorro Standard Time',
    abbrev: 'CHST'
  },
  zones: ['Pacific/Guam', 'Pacific/Saipan']
}, {
  standard: {
    name: 'Papua New Guinea Time',
    abbrev: 'PGT'
  },
  zones: ['Pacific/Bougainville', 'Pacific/Port_Moresby']
} // indian_Ocean: ['Indian/Chagos'],
// christmas: ['Indian/Christmas'],
// cocos: ['Indian/Cocos'],
// french_Southern: ['Indian/Kerguelen'],
// seychelles: ['Indian/Mahe'],
// reunion: ['Indian/Reunion'],
//Pacific
// apia: ['Pacific/Apia'],
// easter: ['Pacific/Easter'],
// vanuatu: ['Pacific/Efate'],
// phoenix_Islands: ['Pacific/Enderbury'],
// tokelau: ['Pacific/Fakaofo'],
// fiji: ['Pacific/Fiji'],
// tuvalu: ['Pacific/Funafuti'],
// galapagos: ['Pacific/Galapagos'],
// gambier: ['Pacific/Gambier'],
// solomon: ['Pacific/Guadalcanal'],
// line_Islands: ['Pacific/Kiritimati'],
// kosrae: ['Pacific/Kosrae'],
// marquesas: ['Pacific/Marquesas'],
// nauru: ['Pacific/Nauru'],
// niue: ['Pacific/Niue'],
// norfolk: ['Pacific/Norfolk'],
// new_Caledonia: ['Pacific/Noumea'],
// palau: ['Pacific/Palau'],
// pitcairn: ['Pacific/Pitcairn'],
// ponape: ['Pacific/Ponape'],
// cook: ['Pacific/Rarotonga'],
// tahiti: ['Pacific/Tahiti'],
// gilbert_Islands: ['Pacific/Tarawa'],
// tonga: ['Pacific/Tongatapu'],
// truk: ['Pacific/Truk'],
// wake: ['Pacific/Wake'],
// wallis: ['Pacific/Wallis'],
// tomsk: ['Asia/Tomsk']
// antarctic
// greenland_Eastern: ['America/Scoresbysund'],
// davis: ['Antarctica/Davis'],
// dumontdurville: ['Antarctica/Dumontdurville'],
// macquarie: ['Antarctica/Macquarie'],
// mawson: ['Antarctica/Mawson'],
// rothera: ['Antarctica/Rothera'],
// syowa: ['Antarctica/Syowa'],
// vostok: ['Antarctica/Vostok'],
];

var display = function display(str) {
  var id = find_1(str);

  if (!id) {
    return null;
  }

  var meta = _05Metazones.find(function (obj) {
    return obj.zones.find(function (tz) {
      return tz === id;
    });
  });

  if (!meta) {
    meta = {
      standard: {
        name: id,
        abbrev: id
      } // 'Etc/GMT+5'

    };
  }

  return {
    iana: id,
    standard: meta.standard,
    daylight: meta.daylight
  };
};

var display_1 = display;

var _version = '0.6.1';

var src = {
  find: find_1,
  display: display_1,
  version: _version
};
var src_2 = src.display;

var AutoFixHighOutlined = {};

var interopRequireDefault = {exports: {}};

(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;
}(interopRequireDefault));

var createSvgIcon = {};

var require$$0 = /*@__PURE__*/getAugmentedNamespace(utils);

(function (exports) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function () {
    return _utils.createSvgIcon;
  }
});

var _utils = require$$0;
}(createSvgIcon));

var _interopRequireDefault$5 = interopRequireDefault.exports;

Object.defineProperty(AutoFixHighOutlined, "__esModule", {
  value: true
});
var default_1$5 = AutoFixHighOutlined.default = void 0;

var _createSvgIcon$5 = _interopRequireDefault$5(createSvgIcon);

var _jsxRuntime$5 = jsxRuntime.exports;

var _default$5 = (0, _createSvgIcon$5.default)( /*#__PURE__*/(0, _jsxRuntime$5.jsx)("path", {
  d: "m20 7 .94-2.06L23 4l-2.06-.94L20 1l-.94 2.06L17 4l2.06.94zM8.5 7l.94-2.06L11.5 4l-2.06-.94L8.5 1l-.94 2.06L5.5 4l2.06.94zM20 12.5l-.94 2.06-2.06.94 2.06.94.94 2.06.94-2.06L23 15.5l-2.06-.94zm-2.29-3.38-2.83-2.83c-.2-.19-.45-.29-.71-.29-.26 0-.51.1-.71.29L2.29 17.46c-.39.39-.39 1.02 0 1.41l2.83 2.83c.2.2.45.3.71.3s.51-.1.71-.29l11.17-11.17c.39-.39.39-1.03 0-1.42zm-3.54-.7 1.41 1.41L14.41 11 13 9.59l1.17-1.17zM5.83 19.59l-1.41-1.41L11.59 11 13 12.41l-7.17 7.18z"
}), 'AutoFixHighOutlined');

default_1$5 = AutoFixHighOutlined.default = _default$5;

var AutoFixOffOutlined = {};

var _interopRequireDefault$4 = interopRequireDefault.exports;

Object.defineProperty(AutoFixOffOutlined, "__esModule", {
  value: true
});
var default_1$4 = AutoFixOffOutlined.default = void 0;

var _createSvgIcon$4 = _interopRequireDefault$4(createSvgIcon);

var _jsxRuntime$4 = jsxRuntime.exports;

var _default$4 = (0, _createSvgIcon$4.default)( /*#__PURE__*/(0, _jsxRuntime$4.jsx)("path", {
  d: "m20 7 .94-2.06L23 4l-2.06-.94L20 1l-.94 2.06L17 4l2.06.94zm-5.83 1.42 1.41 1.41-1.46 1.46 1.41 1.41 2.17-2.17c.39-.39.39-1.02 0-1.41l-2.83-2.83c-.19-.19-.44-.29-.7-.29-.26 0-.51.1-.71.29l-2.17 2.17 1.41 1.41 1.47-1.45zM1.39 4.22l7.07 7.07-6.17 6.17c-.39.39-.39 1.02 0 1.41l2.83 2.83c.2.2.45.3.71.3s.51-.1.71-.29l6.17-6.17 7.07 7.07 1.41-1.41L2.81 2.81 1.39 4.22zm9.9 9.9-5.46 5.46-1.41-1.41 5.46-5.46 1.41 1.41z"
}), 'AutoFixOffOutlined');

default_1$4 = AutoFixOffOutlined.default = _default$4;

var CelebrationOutlined = {};

var _interopRequireDefault$3 = interopRequireDefault.exports;

Object.defineProperty(CelebrationOutlined, "__esModule", {
  value: true
});
var default_1$3 = CelebrationOutlined.default = void 0;

var _createSvgIcon$3 = _interopRequireDefault$3(createSvgIcon);

var _jsxRuntime$3 = jsxRuntime.exports;

var _default$3 = (0, _createSvgIcon$3.default)( /*#__PURE__*/(0, _jsxRuntime$3.jsx)("path", {
  d: "m2 22 14-5-9-9-5 14zm10.35-5.82L5.3 18.7l2.52-7.05 4.53 4.53zm2.18-3.65 5.59-5.59c.49-.49 1.28-.49 1.77 0l.59.59 1.06-1.06-.59-.59c-1.07-1.07-2.82-1.07-3.89 0l-5.59 5.59 1.06 1.06zm-4.47-5.65-.59.59 1.06 1.06.59-.59c1.07-1.07 1.07-2.82 0-3.89l-.59-.59-1.06 1.07.59.59c.48.48.48 1.28 0 1.76zm7 5-1.59 1.59 1.06 1.06 1.59-1.59c.49-.49 1.28-.49 1.77 0l1.61 1.61 1.06-1.06-1.61-1.61c-1.08-1.07-2.82-1.07-3.89 0zm-2-6-3.59 3.59 1.06 1.06 3.59-3.59c1.07-1.07 1.07-2.82 0-3.89l-1.59-1.59-1.06 1.06 1.59 1.59c.48.49.48 1.29 0 1.77z"
}), 'CelebrationOutlined');

default_1$3 = CelebrationOutlined.default = _default$3;

var FiberManualRecord = {};

var _interopRequireDefault$2 = interopRequireDefault.exports;

Object.defineProperty(FiberManualRecord, "__esModule", {
  value: true
});
var default_1$2 = FiberManualRecord.default = void 0;

var _createSvgIcon$2 = _interopRequireDefault$2(createSvgIcon);

var _jsxRuntime$2 = jsxRuntime.exports;

var _default$2 = (0, _createSvgIcon$2.default)( /*#__PURE__*/(0, _jsxRuntime$2.jsx)("circle", {
  cx: "12",
  cy: "12",
  r: "8"
}), 'FiberManualRecord');

default_1$2 = FiberManualRecord.default = _default$2;

var NavigateBefore = {};

var _interopRequireDefault$1 = interopRequireDefault.exports;

Object.defineProperty(NavigateBefore, "__esModule", {
  value: true
});
var default_1$1 = NavigateBefore.default = void 0;

var _createSvgIcon$1 = _interopRequireDefault$1(createSvgIcon);

var _jsxRuntime$1 = jsxRuntime.exports;

var _default$1 = (0, _createSvgIcon$1.default)( /*#__PURE__*/(0, _jsxRuntime$1.jsx)("path", {
  d: "M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');

default_1$1 = NavigateBefore.default = _default$1;

var NavigateNext = {};

var _interopRequireDefault = interopRequireDefault.exports;

Object.defineProperty(NavigateNext, "__esModule", {
  value: true
});
var default_1 = NavigateNext.default = void 0;

var _createSvgIcon = _interopRequireDefault(createSvgIcon);

var _jsxRuntime = jsxRuntime.exports;

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');

default_1 = NavigateNext.default = _default;

var ChevronRight = createSvgIcon$1( /*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M10 6 8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'ChevronRight');

var ExpandMore = createSvgIcon$1( /*#__PURE__*/jsxRuntime.exports.jsx("path", {
  d: "M16.59 8.59 12 13.17 7.41 8.59 6 10l6 6 6-6z"
}), 'ExpandMore');

// ES6 Map
var map;
try {
  map = Map;
} catch (_) { }
var set;

// ES6 Set
try {
  set = Set;
} catch (_) { }

function baseClone$1 (src, circulars, clones) {
  // Null/undefined/functions/etc
  if (!src || typeof src !== 'object' || typeof src === 'function') {
    return src
  }

  // DOM Node
  if (src.nodeType && 'cloneNode' in src) {
    return src.cloneNode(true)
  }

  // Date
  if (src instanceof Date) {
    return new Date(src.getTime())
  }

  // RegExp
  if (src instanceof RegExp) {
    return new RegExp(src)
  }

  // Arrays
  if (Array.isArray(src)) {
    return src.map(clone$1)
  }

  // ES6 Maps
  if (map && src instanceof map) {
    return new Map(Array.from(src.entries()))
  }

  // ES6 Sets
  if (set && src instanceof set) {
    return new Set(Array.from(src.values()))
  }

  // Object
  if (src instanceof Object) {
    circulars.push(src);
    var obj = Object.create(src);
    clones.push(obj);
    for (var key in src) {
      var idx = circulars.findIndex(function (i) {
        return i === src[key]
      });
      obj[key] = idx > -1 ? clones[idx] : baseClone$1(src[key], circulars, clones);
    }
    return obj
  }

  // ???
  return src
}

function clone$1 (src) {
  return baseClone$1(src, [], [])
}

const toString$7 = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString$2 = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false) return '' + val;
  const typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString$2.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  const tag = toString$7.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    let result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

let mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    let isCast = originalValue != null && originalValue !== value;
    let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${printValue(value, true)}\`` + (isCast ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : '.');

    if (value === null) {
      msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
    }

    return msg;
  },
  defined: '${path} must be defined'
};
let string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
let number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
let date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
let boolean = {
  isValue: '${path} field must be ${value}'
};
let object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must be have ${length} items'
};
Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean
});

/** Used for built-in method references. */

var objectProto$q = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$k = objectProto$q.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas$1(object, key) {
  return object != null && hasOwnProperty$k.call(object, key);
}

var _baseHas = baseHas$1;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */

var isArray$b = Array.isArray;

var isArray_1 = isArray$b;

/** Detect free variable `global` from Node.js. */

var freeGlobal$3 = typeof commonjsGlobal == 'object' && commonjsGlobal && commonjsGlobal.Object === Object && commonjsGlobal;

var _freeGlobal = freeGlobal$3;

var freeGlobal$2 = _freeGlobal;

/** Detect free variable `self`. */
var freeSelf$1 = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root$a = freeGlobal$2 || freeSelf$1 || Function('return this')();

var _root = root$a;

var root$9 = _root;

/** Built-in value references. */
var Symbol$7 = root$9.Symbol;

var _Symbol = Symbol$7;

var Symbol$6 = _Symbol;

/** Used for built-in method references. */
var objectProto$p = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$j = objectProto$p.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$3 = objectProto$p.toString;

/** Built-in value references. */
var symToStringTag$3 = Symbol$6 ? Symbol$6.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag$2(value) {
  var isOwn = hasOwnProperty$j.call(value, symToStringTag$3),
      tag = value[symToStringTag$3];

  try {
    value[symToStringTag$3] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$3.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$3] = tag;
    } else {
      delete value[symToStringTag$3];
    }
  }
  return result;
}

var _getRawTag = getRawTag$2;

/** Used for built-in method references. */

var objectProto$o = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$2 = objectProto$o.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString$2(value) {
  return nativeObjectToString$2.call(value);
}

var _objectToString = objectToString$2;

var Symbol$5 = _Symbol,
    getRawTag$1 = _getRawTag,
    objectToString$1 = _objectToString;

/** `Object#toString` result references. */
var nullTag$1 = '[object Null]',
    undefinedTag$1 = '[object Undefined]';

/** Built-in value references. */
var symToStringTag$2 = Symbol$5 ? Symbol$5.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag$6(value) {
  if (value == null) {
    return value === undefined ? undefinedTag$1 : nullTag$1;
  }
  return (symToStringTag$2 && symToStringTag$2 in Object(value))
    ? getRawTag$1(value)
    : objectToString$1(value);
}

var _baseGetTag = baseGetTag$6;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */

function isObjectLike$6(value) {
  return value != null && typeof value == 'object';
}

var isObjectLike_1 = isObjectLike$6;

var baseGetTag$5 = _baseGetTag,
    isObjectLike$5 = isObjectLike_1;

/** `Object#toString` result references. */
var symbolTag$4 = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol$4(value) {
  return typeof value == 'symbol' ||
    (isObjectLike$5(value) && baseGetTag$5(value) == symbolTag$4);
}

var isSymbol_1 = isSymbol$4;

var isArray$a = isArray_1,
    isSymbol$3 = isSymbol_1;

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey$3(value, object) {
  if (isArray$a(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol$3(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

var _isKey = isKey$3;

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */

function isObject$6(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

var isObject_1 = isObject$6;

var baseGetTag$4 = _baseGetTag,
    isObject$5 = isObject_1;

/** `Object#toString` result references. */
var asyncTag$1 = '[object AsyncFunction]',
    funcTag$4 = '[object Function]',
    genTag$2 = '[object GeneratorFunction]',
    proxyTag$1 = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$4(value) {
  if (!isObject$5(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag$4(value);
  return tag == funcTag$4 || tag == genTag$2 || tag == asyncTag$1 || tag == proxyTag$1;
}

var isFunction_1 = isFunction$4;

var root$8 = _root;

/** Used to detect overreaching core-js shims. */
var coreJsData$3 = root$8['__core-js_shared__'];

var _coreJsData = coreJsData$3;

var coreJsData$2 = _coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey$1 = (function() {
  var uid = /[^.]+$/.exec(coreJsData$2 && coreJsData$2.keys && coreJsData$2.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked$2(func) {
  return !!maskSrcKey$1 && (maskSrcKey$1 in func);
}

var _isMasked = isMasked$2;

/** Used for built-in method references. */

var funcProto$4 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$4 = funcProto$4.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource$3(func) {
  if (func != null) {
    try {
      return funcToString$4.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

var _toSource = toSource$3;

var isFunction$3 = isFunction_1,
    isMasked$1 = _isMasked,
    isObject$4 = isObject_1,
    toSource$2 = _toSource;

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar$1 = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor$1 = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto$3 = Function.prototype,
    objectProto$n = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$3 = funcProto$3.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$i = objectProto$n.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative$1 = RegExp('^' +
  funcToString$3.call(hasOwnProperty$i).replace(reRegExpChar$1, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative$2(value) {
  if (!isObject$4(value) || isMasked$1(value)) {
    return false;
  }
  var pattern = isFunction$3(value) ? reIsNative$1 : reIsHostCtor$1;
  return pattern.test(toSource$2(value));
}

var _baseIsNative = baseIsNative$2;

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */

function getValue$2(object, key) {
  return object == null ? undefined : object[key];
}

var _getValue = getValue$2;

var baseIsNative$1 = _baseIsNative,
    getValue$1 = _getValue;

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative$8(object, key) {
  var value = getValue$1(object, key);
  return baseIsNative$1(value) ? value : undefined;
}

var _getNative = getNative$8;

var getNative$7 = _getNative;

/* Built-in method references that are verified to be native. */
var nativeCreate$6 = getNative$7(Object, 'create');

var _nativeCreate = nativeCreate$6;

var nativeCreate$5 = _nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear$2() {
  this.__data__ = nativeCreate$5 ? nativeCreate$5(null) : {};
  this.size = 0;
}

var _hashClear = hashClear$2;

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function hashDelete$2(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

var _hashDelete = hashDelete$2;

var nativeCreate$4 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$4 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$m = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$h = objectProto$m.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet$2(key) {
  var data = this.__data__;
  if (nativeCreate$4) {
    var result = data[key];
    return result === HASH_UNDEFINED$4 ? undefined : result;
  }
  return hasOwnProperty$h.call(data, key) ? data[key] : undefined;
}

var _hashGet = hashGet$2;

var nativeCreate$3 = _nativeCreate;

/** Used for built-in method references. */
var objectProto$l = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$g = objectProto$l.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas$2(key) {
  var data = this.__data__;
  return nativeCreate$3 ? (data[key] !== undefined) : hasOwnProperty$g.call(data, key);
}

var _hashHas = hashHas$2;

var nativeCreate$2 = _nativeCreate;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$3 = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet$2(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate$2 && value === undefined) ? HASH_UNDEFINED$3 : value;
  return this;
}

var _hashSet = hashSet$2;

var hashClear$1 = _hashClear,
    hashDelete$1 = _hashDelete,
    hashGet$1 = _hashGet,
    hashHas$1 = _hashHas,
    hashSet$1 = _hashSet;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash$2(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash$2.prototype.clear = hashClear$1;
Hash$2.prototype['delete'] = hashDelete$1;
Hash$2.prototype.get = hashGet$1;
Hash$2.prototype.has = hashHas$1;
Hash$2.prototype.set = hashSet$1;

var _Hash = Hash$2;

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */

function listCacheClear$2() {
  this.__data__ = [];
  this.size = 0;
}

var _listCacheClear = listCacheClear$2;

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */

function eq$3(value, other) {
  return value === other || (value !== value && other !== other);
}

var eq_1 = eq$3;

var eq$2 = eq_1;

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf$5(array, key) {
  var length = array.length;
  while (length--) {
    if (eq$2(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

var _assocIndexOf = assocIndexOf$5;

var assocIndexOf$4 = _assocIndexOf;

/** Used for built-in method references. */
var arrayProto$1 = Array.prototype;

/** Built-in value references. */
var splice$1 = arrayProto$1.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete$2(key) {
  var data = this.__data__,
      index = assocIndexOf$4(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice$1.call(data, index, 1);
  }
  --this.size;
  return true;
}

var _listCacheDelete = listCacheDelete$2;

var assocIndexOf$3 = _assocIndexOf;

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet$2(key) {
  var data = this.__data__,
      index = assocIndexOf$3(data, key);

  return index < 0 ? undefined : data[index][1];
}

var _listCacheGet = listCacheGet$2;

var assocIndexOf$2 = _assocIndexOf;

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas$2(key) {
  return assocIndexOf$2(this.__data__, key) > -1;
}

var _listCacheHas = listCacheHas$2;

var assocIndexOf$1 = _assocIndexOf;

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet$2(key, value) {
  var data = this.__data__,
      index = assocIndexOf$1(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

var _listCacheSet = listCacheSet$2;

var listCacheClear$1 = _listCacheClear,
    listCacheDelete$1 = _listCacheDelete,
    listCacheGet$1 = _listCacheGet,
    listCacheHas$1 = _listCacheHas,
    listCacheSet$1 = _listCacheSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache$5(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache$5.prototype.clear = listCacheClear$1;
ListCache$5.prototype['delete'] = listCacheDelete$1;
ListCache$5.prototype.get = listCacheGet$1;
ListCache$5.prototype.has = listCacheHas$1;
ListCache$5.prototype.set = listCacheSet$1;

var _ListCache = ListCache$5;

var getNative$6 = _getNative,
    root$7 = _root;

/* Built-in method references that are verified to be native. */
var Map$6 = getNative$6(root$7, 'Map');

var _Map = Map$6;

var Hash$1 = _Hash,
    ListCache$4 = _ListCache,
    Map$5 = _Map;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear$2() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash$1,
    'map': new (Map$5 || ListCache$4),
    'string': new Hash$1
  };
}

var _mapCacheClear = mapCacheClear$2;

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */

function isKeyable$2(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

var _isKeyable = isKeyable$2;

var isKeyable$1 = _isKeyable;

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData$5(map, key) {
  var data = map.__data__;
  return isKeyable$1(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

var _getMapData = getMapData$5;

var getMapData$4 = _getMapData;

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete$2(key) {
  var result = getMapData$4(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

var _mapCacheDelete = mapCacheDelete$2;

var getMapData$3 = _getMapData;

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet$2(key) {
  return getMapData$3(this, key).get(key);
}

var _mapCacheGet = mapCacheGet$2;

var getMapData$2 = _getMapData;

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas$2(key) {
  return getMapData$2(this, key).has(key);
}

var _mapCacheHas = mapCacheHas$2;

var getMapData$1 = _getMapData;

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet$2(key, value) {
  var data = getMapData$1(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

var _mapCacheSet = mapCacheSet$2;

var mapCacheClear$1 = _mapCacheClear,
    mapCacheDelete$1 = _mapCacheDelete,
    mapCacheGet$1 = _mapCacheGet,
    mapCacheHas$1 = _mapCacheHas,
    mapCacheSet$1 = _mapCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache$4(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache$4.prototype.clear = mapCacheClear$1;
MapCache$4.prototype['delete'] = mapCacheDelete$1;
MapCache$4.prototype.get = mapCacheGet$1;
MapCache$4.prototype.has = mapCacheHas$1;
MapCache$4.prototype.set = mapCacheSet$1;

var _MapCache = MapCache$4;

var MapCache$3 = _MapCache;

/** Error message constants. */
var FUNC_ERROR_TEXT$1 = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize$2(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT$1);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize$2.Cache || MapCache$3);
  return memoized;
}

// Expose `MapCache`.
memoize$2.Cache = MapCache$3;

var memoize_1 = memoize$2;

var memoize$1 = memoize_1;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE$1 = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped$2(func) {
  var result = memoize$1(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE$1) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

var _memoizeCapped = memoizeCapped$2;

var memoizeCapped$1 = _memoizeCapped;

/** Used to match property names within property paths. */
var rePropName$1 = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar$1 = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath$3 = memoizeCapped$1(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName$1, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar$1, '$1') : (number || match));
  });
  return result;
});

var _stringToPath = stringToPath$3;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */

function arrayMap$2(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

var _arrayMap = arrayMap$2;

var Symbol$4 = _Symbol,
    arrayMap$1 = _arrayMap,
    isArray$9 = isArray_1,
    isSymbol$2 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$3 = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto$3 = Symbol$4 ? Symbol$4.prototype : undefined,
    symbolToString$1 = symbolProto$3 ? symbolProto$3.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString$2(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$9(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap$1(value, baseToString$2) + '';
  }
  if (isSymbol$2(value)) {
    return symbolToString$1 ? symbolToString$1.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$3) ? '-0' : result;
}

var _baseToString = baseToString$2;

var baseToString$1 = _baseToString;

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString$6(value) {
  return value == null ? '' : baseToString$1(value);
}

var toString_1 = toString$6;

var isArray$8 = isArray_1,
    isKey$2 = _isKey,
    stringToPath$2 = _stringToPath,
    toString$5 = toString_1;

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath$2(value, object) {
  if (isArray$8(value)) {
    return value;
  }
  return isKey$2(value, object) ? [value] : stringToPath$2(toString$5(value));
}

var _castPath = castPath$2;

var baseGetTag$3 = _baseGetTag,
    isObjectLike$4 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$5 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments$2(value) {
  return isObjectLike$4(value) && baseGetTag$3(value) == argsTag$5;
}

var _baseIsArguments = baseIsArguments$2;

var baseIsArguments$1 = _baseIsArguments,
    isObjectLike$3 = isObjectLike_1;

/** Used for built-in method references. */
var objectProto$k = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$f = objectProto$k.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$3 = objectProto$k.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments$4 = baseIsArguments$1(function() { return arguments; }()) ? baseIsArguments$1 : function(value) {
  return isObjectLike$3(value) && hasOwnProperty$f.call(value, 'callee') &&
    !propertyIsEnumerable$3.call(value, 'callee');
};

var isArguments_1 = isArguments$4;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$3 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint$1 = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex$3(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$3 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint$1.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

var _isIndex = isIndex$3;

/** Used as references for various `Number` constants. */

var MAX_SAFE_INTEGER$2 = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength$4(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER$2;
}

var isLength_1 = isLength$4;

var isSymbol$1 = isSymbol_1;

/** Used as references for various `Number` constants. */
var INFINITY$2 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey$5(value) {
  if (typeof value == 'string' || isSymbol$1(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$2) ? '-0' : result;
}

var _toKey = toKey$5;

var castPath$1 = _castPath,
    isArguments$3 = isArguments_1,
    isArray$7 = isArray_1,
    isIndex$2 = _isIndex,
    isLength$3 = isLength_1,
    toKey$4 = _toKey;

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath$2(object, path, hasFunc) {
  path = castPath$1(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey$4(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength$3(length) && isIndex$2(key, length) &&
    (isArray$7(object) || isArguments$3(object));
}

var _hasPath = hasPath$2;

var baseHas = _baseHas,
    hasPath$1 = _hasPath;

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath$1(object, path, baseHas);
}

var has_1 = has;

var has$1 = has_1;

var isSchema = (obj => obj && obj.__isYupSchema__);

class Condition {
  constructor(refs, options) {
    this.refs = refs;
    this.refs = refs;

    if (typeof options === 'function') {
      this.fn = options;
      return;
    }

    if (!has$1(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
    if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    let {
      is,
      then,
      otherwise
    } = options;
    let check = typeof is === 'function' ? is : (...values) => values.every(value => value === is);

    this.fn = function (...args) {
      let options = args.pop();
      let schema = args.pop();
      let branch = check(...args) ? then : otherwise;
      if (!branch) return undefined;
      if (typeof branch === 'function') return branch(schema);
      return schema.concat(branch.resolve(options));
    };
  }

  resolve(base, options) {
    let values = this.refs.map(ref => ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn.apply(base, values.concat(base, options));
    if (schema === undefined || schema === base) return base;
    if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  }

}

var Condition$1 = Condition;

function toArray(value) {
  return value == null ? [] : [].concat(value);
}

function _extends$4() { _extends$4 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
let strReg = /\$\{\s*(\w+)\s*\}/g;
class ValidationError extends Error {
  static formatError(message, params) {
    const path = params.label || params.path || 'this';
    if (path !== params.path) params = _extends$4({}, params, {
      path
    });
    if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === 'function') return message(params);
    return message;
  }

  static isError(err) {
    return err && err.name === 'ValidationError';
  }

  constructor(errorOrErrors, value, field, type) {
    super();
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach(err => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        this.inner = this.inner.concat(err.inner.length ? err.inner : err);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
  }

}

const once = cb => {
  let fired = false;
  return (...args) => {
    if (fired) return;
    fired = true;
    cb(...args);
  };
};

function runTests(options, cb) {
  let {
    endEarly,
    tests,
    args,
    value,
    errors,
    sort,
    path
  } = options;
  let callback = once(cb);
  let count = tests.length;
  const nestedErrors = [];
  errors = errors ? errors : [];
  if (!count) return errors.length ? callback(new ValidationError(errors, value, path)) : callback(null, value);

  for (let i = 0; i < tests.length; i++) {
    const test = tests[i];
    test(args, function finishTestRun(err) {
      if (err) {
        // always return early for non validation errors
        if (!ValidationError.isError(err)) {
          return callback(err, value);
        }

        if (endEarly) {
          err.value = value;
          return callback(err, value);
        }

        nestedErrors.push(err);
      }

      if (--count <= 0) {
        if (nestedErrors.length) {
          if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

          if (errors.length) nestedErrors.push(...errors);
          errors = nestedErrors;
        }

        if (errors.length) {
          callback(new ValidationError(errors, value, path), value);
          return;
        }

        callback(null, value);
      }
    });
  }
}

var getNative$5 = _getNative;

var defineProperty$3 = (function() {
  try {
    var func = getNative$5(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var _defineProperty = defineProperty$3;

var defineProperty$2 = _defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue$3(object, key, value) {
  if (key == '__proto__' && defineProperty$2) {
    defineProperty$2(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

var _baseAssignValue = baseAssignValue$3;

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */

function createBaseFor$1(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

var _createBaseFor = createBaseFor$1;

var createBaseFor = _createBaseFor;

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor$1 = createBaseFor();

var _baseFor = baseFor$1;

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */

function baseTimes$2(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

var _baseTimes = baseTimes$2;

var isBuffer$4 = {exports: {}};

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */

function stubFalse$1() {
  return false;
}

var stubFalse_1 = stubFalse$1;

(function (module, exports) {
var root = _root,
    stubFalse = stubFalse_1;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;
}(isBuffer$4, isBuffer$4.exports));

var baseGetTag$2 = _baseGetTag,
    isLength$2 = isLength_1,
    isObjectLike$2 = isObjectLike_1;

/** `Object#toString` result references. */
var argsTag$4 = '[object Arguments]',
    arrayTag$3 = '[object Array]',
    boolTag$4 = '[object Boolean]',
    dateTag$4 = '[object Date]',
    errorTag$3 = '[object Error]',
    funcTag$3 = '[object Function]',
    mapTag$7 = '[object Map]',
    numberTag$4 = '[object Number]',
    objectTag$6 = '[object Object]',
    regexpTag$4 = '[object RegExp]',
    setTag$7 = '[object Set]',
    stringTag$4 = '[object String]',
    weakMapTag$4 = '[object WeakMap]';

var arrayBufferTag$4 = '[object ArrayBuffer]',
    dataViewTag$6 = '[object DataView]',
    float32Tag$3 = '[object Float32Array]',
    float64Tag$3 = '[object Float64Array]',
    int8Tag$3 = '[object Int8Array]',
    int16Tag$3 = '[object Int16Array]',
    int32Tag$3 = '[object Int32Array]',
    uint8Tag$3 = '[object Uint8Array]',
    uint8ClampedTag$3 = '[object Uint8ClampedArray]',
    uint16Tag$3 = '[object Uint16Array]',
    uint32Tag$3 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags$1 = {};
typedArrayTags$1[float32Tag$3] = typedArrayTags$1[float64Tag$3] =
typedArrayTags$1[int8Tag$3] = typedArrayTags$1[int16Tag$3] =
typedArrayTags$1[int32Tag$3] = typedArrayTags$1[uint8Tag$3] =
typedArrayTags$1[uint8ClampedTag$3] = typedArrayTags$1[uint16Tag$3] =
typedArrayTags$1[uint32Tag$3] = true;
typedArrayTags$1[argsTag$4] = typedArrayTags$1[arrayTag$3] =
typedArrayTags$1[arrayBufferTag$4] = typedArrayTags$1[boolTag$4] =
typedArrayTags$1[dataViewTag$6] = typedArrayTags$1[dateTag$4] =
typedArrayTags$1[errorTag$3] = typedArrayTags$1[funcTag$3] =
typedArrayTags$1[mapTag$7] = typedArrayTags$1[numberTag$4] =
typedArrayTags$1[objectTag$6] = typedArrayTags$1[regexpTag$4] =
typedArrayTags$1[setTag$7] = typedArrayTags$1[stringTag$4] =
typedArrayTags$1[weakMapTag$4] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray$2(value) {
  return isObjectLike$2(value) &&
    isLength$2(value.length) && !!typedArrayTags$1[baseGetTag$2(value)];
}

var _baseIsTypedArray = baseIsTypedArray$2;

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */

function baseUnary$2(func) {
  return function(value) {
    return func(value);
  };
}

var _baseUnary = baseUnary$2;

var _nodeUtil = {exports: {}};

(function (module, exports) {
var freeGlobal = _freeGlobal;

/** Detect free variable `exports`. */
var freeExports = exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && 'object' == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;
}(_nodeUtil, _nodeUtil.exports));

var baseIsTypedArray$1 = _baseIsTypedArray,
    baseUnary$1 = _baseUnary,
    nodeUtil$2 = _nodeUtil.exports;

/* Node.js helper references. */
var nodeIsTypedArray$1 = nodeUtil$2 && nodeUtil$2.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray$4 = nodeIsTypedArray$1 ? baseUnary$1(nodeIsTypedArray$1) : baseIsTypedArray$1;

var isTypedArray_1 = isTypedArray$4;

var baseTimes$1 = _baseTimes,
    isArguments$2 = isArguments_1,
    isArray$6 = isArray_1,
    isBuffer$3 = isBuffer$4.exports,
    isIndex$1 = _isIndex,
    isTypedArray$3 = isTypedArray_1;

/** Used for built-in method references. */
var objectProto$j = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$e = objectProto$j.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys$2(value, inherited) {
  var isArr = isArray$6(value),
      isArg = !isArr && isArguments$2(value),
      isBuff = !isArr && !isArg && isBuffer$3(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$3(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes$1(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$e.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex$1(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

var _arrayLikeKeys = arrayLikeKeys$2;

/** Used for built-in method references. */

var objectProto$i = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype$2(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$i;

  return value === proto;
}

var _isPrototype = isPrototype$2;

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */

function overArg$2(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

var _overArg = overArg$2;

var overArg$1 = _overArg;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys$3 = overArg$1(Object.keys, Object);

var _nativeKeys = nativeKeys$3;

var isPrototype$1 = _isPrototype,
    nativeKeys$2 = _nativeKeys;

/** Used for built-in method references. */
var objectProto$h = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$d = objectProto$h.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys$2(object) {
  if (!isPrototype$1(object)) {
    return nativeKeys$2(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$d.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

var _baseKeys = baseKeys$2;

var isFunction$2 = isFunction_1,
    isLength$1 = isLength_1;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike$2(value) {
  return value != null && isLength$1(value.length) && !isFunction$2(value);
}

var isArrayLike_1 = isArrayLike$2;

var arrayLikeKeys$1 = _arrayLikeKeys,
    baseKeys$1 = _baseKeys,
    isArrayLike$1 = isArrayLike_1;

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys$4(object) {
  return isArrayLike$1(object) ? arrayLikeKeys$1(object) : baseKeys$1(object);
}

var keys_1 = keys$4;

var baseFor = _baseFor,
    keys$3 = keys_1;

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn$2(object, iteratee) {
  return object && baseFor(object, iteratee, keys$3);
}

var _baseForOwn = baseForOwn$2;

var ListCache$3 = _ListCache;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear$2() {
  this.__data__ = new ListCache$3;
  this.size = 0;
}

var _stackClear = stackClear$2;

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */

function stackDelete$2(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

var _stackDelete = stackDelete$2;

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */

function stackGet$2(key) {
  return this.__data__.get(key);
}

var _stackGet = stackGet$2;

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function stackHas$2(key) {
  return this.__data__.has(key);
}

var _stackHas = stackHas$2;

var ListCache$2 = _ListCache,
    Map$4 = _Map,
    MapCache$2 = _MapCache;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE$1 = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet$2(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache$2) {
    var pairs = data.__data__;
    if (!Map$4 || (pairs.length < LARGE_ARRAY_SIZE$1 - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache$2(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

var _stackSet = stackSet$2;

var ListCache$1 = _ListCache,
    stackClear$1 = _stackClear,
    stackDelete$1 = _stackDelete,
    stackGet$1 = _stackGet,
    stackHas$1 = _stackHas,
    stackSet$1 = _stackSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack$3(entries) {
  var data = this.__data__ = new ListCache$1(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack$3.prototype.clear = stackClear$1;
Stack$3.prototype['delete'] = stackDelete$1;
Stack$3.prototype.get = stackGet$1;
Stack$3.prototype.has = stackHas$1;
Stack$3.prototype.set = stackSet$1;

var _Stack = Stack$3;

/** Used to stand-in for `undefined` hash values. */

var HASH_UNDEFINED$2 = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd$1(value) {
  this.__data__.set(value, HASH_UNDEFINED$2);
  return this;
}

var _setCacheAdd = setCacheAdd$1;

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */

function setCacheHas$1(value) {
  return this.__data__.has(value);
}

var _setCacheHas = setCacheHas$1;

var MapCache$1 = _MapCache,
    setCacheAdd = _setCacheAdd,
    setCacheHas = _setCacheHas;

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache$1(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache$1;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache$1.prototype.add = SetCache$1.prototype.push = setCacheAdd;
SetCache$1.prototype.has = setCacheHas;

var _SetCache = SetCache$1;

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */

function arraySome$1(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

var _arraySome = arraySome$1;

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */

function cacheHas$1(cache, key) {
  return cache.has(key);
}

var _cacheHas = cacheHas$1;

var SetCache = _SetCache,
    arraySome = _arraySome,
    cacheHas = _cacheHas;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$5 = 1,
    COMPARE_UNORDERED_FLAG$3 = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays$2(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$5,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG$3) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

var _equalArrays = equalArrays$2;

var root$6 = _root;

/** Built-in value references. */
var Uint8Array$3 = root$6.Uint8Array;

var _Uint8Array = Uint8Array$3;

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */

function mapToArray$1(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

var _mapToArray = mapToArray$1;

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */

function setToArray$1(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

var _setToArray = setToArray$1;

var Symbol$3 = _Symbol,
    Uint8Array$2 = _Uint8Array,
    eq$1 = eq_1,
    equalArrays$1 = _equalArrays,
    mapToArray = _mapToArray,
    setToArray = _setToArray;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$4 = 1,
    COMPARE_UNORDERED_FLAG$2 = 2;

/** `Object#toString` result references. */
var boolTag$3 = '[object Boolean]',
    dateTag$3 = '[object Date]',
    errorTag$2 = '[object Error]',
    mapTag$6 = '[object Map]',
    numberTag$3 = '[object Number]',
    regexpTag$3 = '[object RegExp]',
    setTag$6 = '[object Set]',
    stringTag$3 = '[object String]',
    symbolTag$3 = '[object Symbol]';

var arrayBufferTag$3 = '[object ArrayBuffer]',
    dataViewTag$5 = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto$2 = Symbol$3 ? Symbol$3.prototype : undefined,
    symbolValueOf$1 = symbolProto$2 ? symbolProto$2.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag$1(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag$5:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag$3:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array$2(object), new Uint8Array$2(other))) {
        return false;
      }
      return true;

    case boolTag$3:
    case dateTag$3:
    case numberTag$3:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq$1(+object, +other);

    case errorTag$2:
      return object.name == other.name && object.message == other.message;

    case regexpTag$3:
    case stringTag$3:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag$6:
      var convert = mapToArray;

    case setTag$6:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG$4;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG$2;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays$1(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag$3:
      if (symbolValueOf$1) {
        return symbolValueOf$1.call(object) == symbolValueOf$1.call(other);
      }
  }
  return false;
}

var _equalByTag = equalByTag$1;

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */

function arrayPush$2(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

var _arrayPush = arrayPush$2;

var arrayPush$1 = _arrayPush,
    isArray$5 = isArray_1;

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys$2(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$5(object) ? result : arrayPush$1(result, symbolsFunc(object));
}

var _baseGetAllKeys = baseGetAllKeys$2;

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */

function arrayFilter$2(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

var _arrayFilter = arrayFilter$2;

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */

function stubArray$2() {
  return [];
}

var stubArray_1 = stubArray$2;

var arrayFilter$1 = _arrayFilter,
    stubArray$1 = stubArray_1;

/** Used for built-in method references. */
var objectProto$g = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable$2 = objectProto$g.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$2 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols$3 = !nativeGetSymbols$2 ? stubArray$1 : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter$1(nativeGetSymbols$2(object), function(symbol) {
    return propertyIsEnumerable$2.call(object, symbol);
  });
};

var _getSymbols = getSymbols$3;

var baseGetAllKeys$1 = _baseGetAllKeys,
    getSymbols$2 = _getSymbols,
    keys$2 = keys_1;

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys$2(object) {
  return baseGetAllKeys$1(object, keys$2, getSymbols$2);
}

var _getAllKeys = getAllKeys$2;

var getAllKeys$1 = _getAllKeys;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$3 = 1;

/** Used for built-in method references. */
var objectProto$f = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$c = objectProto$f.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects$1(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG$3,
      objProps = getAllKeys$1(object),
      objLength = objProps.length,
      othProps = getAllKeys$1(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty$c.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

var _equalObjects = equalObjects$1;

var getNative$4 = _getNative,
    root$5 = _root;

/* Built-in method references that are verified to be native. */
var DataView$3 = getNative$4(root$5, 'DataView');

var _DataView = DataView$3;

var getNative$3 = _getNative,
    root$4 = _root;

/* Built-in method references that are verified to be native. */
var Promise$4 = getNative$3(root$4, 'Promise');

var _Promise = Promise$4;

var getNative$2 = _getNative,
    root$3 = _root;

/* Built-in method references that are verified to be native. */
var Set$4 = getNative$2(root$3, 'Set');

var _Set = Set$4;

var getNative$1 = _getNative,
    root$2 = _root;

/* Built-in method references that are verified to be native. */
var WeakMap$4 = getNative$1(root$2, 'WeakMap');

var _WeakMap = WeakMap$4;

var DataView$2 = _DataView,
    Map$3 = _Map,
    Promise$3 = _Promise,
    Set$3 = _Set,
    WeakMap$3 = _WeakMap,
    baseGetTag$1 = _baseGetTag,
    toSource$1 = _toSource;

/** `Object#toString` result references. */
var mapTag$5 = '[object Map]',
    objectTag$5 = '[object Object]',
    promiseTag$1 = '[object Promise]',
    setTag$5 = '[object Set]',
    weakMapTag$3 = '[object WeakMap]';

var dataViewTag$4 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString$1 = toSource$1(DataView$2),
    mapCtorString$1 = toSource$1(Map$3),
    promiseCtorString$1 = toSource$1(Promise$3),
    setCtorString$1 = toSource$1(Set$3),
    weakMapCtorString$1 = toSource$1(WeakMap$3);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag$3 = baseGetTag$1;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView$2 && getTag$3(new DataView$2(new ArrayBuffer(1))) != dataViewTag$4) ||
    (Map$3 && getTag$3(new Map$3) != mapTag$5) ||
    (Promise$3 && getTag$3(Promise$3.resolve()) != promiseTag$1) ||
    (Set$3 && getTag$3(new Set$3) != setTag$5) ||
    (WeakMap$3 && getTag$3(new WeakMap$3) != weakMapTag$3)) {
  getTag$3 = function(value) {
    var result = baseGetTag$1(value),
        Ctor = result == objectTag$5 ? value.constructor : undefined,
        ctorString = Ctor ? toSource$1(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString$1: return dataViewTag$4;
        case mapCtorString$1: return mapTag$5;
        case promiseCtorString$1: return promiseTag$1;
        case setCtorString$1: return setTag$5;
        case weakMapCtorString$1: return weakMapTag$3;
      }
    }
    return result;
  };
}

var _getTag = getTag$3;

var Stack$2 = _Stack,
    equalArrays = _equalArrays,
    equalByTag = _equalByTag,
    equalObjects = _equalObjects,
    getTag$2 = _getTag,
    isArray$4 = isArray_1,
    isBuffer$2 = isBuffer$4.exports,
    isTypedArray$2 = isTypedArray_1;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$2 = 1;

/** `Object#toString` result references. */
var argsTag$3 = '[object Arguments]',
    arrayTag$2 = '[object Array]',
    objectTag$4 = '[object Object]';

/** Used for built-in method references. */
var objectProto$e = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$b = objectProto$e.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep$1(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray$4(object),
      othIsArr = isArray$4(other),
      objTag = objIsArr ? arrayTag$2 : getTag$2(object),
      othTag = othIsArr ? arrayTag$2 : getTag$2(other);

  objTag = objTag == argsTag$3 ? objectTag$4 : objTag;
  othTag = othTag == argsTag$3 ? objectTag$4 : othTag;

  var objIsObj = objTag == objectTag$4,
      othIsObj = othTag == objectTag$4,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer$2(object)) {
    if (!isBuffer$2(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack$2);
    return (objIsArr || isTypedArray$2(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG$2)) {
    var objIsWrapped = objIsObj && hasOwnProperty$b.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty$b.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack$2);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack$2);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

var _baseIsEqualDeep = baseIsEqualDeep$1;

var baseIsEqualDeep = _baseIsEqualDeep,
    isObjectLike$1 = isObjectLike_1;

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual$2(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike$1(value) && !isObjectLike$1(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual$2, stack);
}

var _baseIsEqual = baseIsEqual$2;

var Stack$1 = _Stack,
    baseIsEqual$1 = _baseIsEqual;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG$1 = 1,
    COMPARE_UNORDERED_FLAG$1 = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch$1(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack$1;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual$1(srcValue, objValue, COMPARE_PARTIAL_FLAG$1 | COMPARE_UNORDERED_FLAG$1, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

var _baseIsMatch = baseIsMatch$1;

var isObject$3 = isObject_1;

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable$2(value) {
  return value === value && !isObject$3(value);
}

var _isStrictComparable = isStrictComparable$2;

var isStrictComparable$1 = _isStrictComparable,
    keys$1 = keys_1;

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData$1(object) {
  var result = keys$1(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable$1(value)];
  }
  return result;
}

var _getMatchData = getMatchData$1;

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */

function matchesStrictComparable$2(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

var _matchesStrictComparable = matchesStrictComparable$2;

var baseIsMatch = _baseIsMatch,
    getMatchData = _getMatchData,
    matchesStrictComparable$1 = _matchesStrictComparable;

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches$1(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable$1(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

var _baseMatches = baseMatches$1;

var castPath = _castPath,
    toKey$3 = _toKey;

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet$2(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey$3(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

var _baseGet = baseGet$2;

var baseGet$1 = _baseGet;

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get$1(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet$1(object, path);
  return result === undefined ? defaultValue : result;
}

var get_1 = get$1;

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */

function baseHasIn$1(object, key) {
  return object != null && key in Object(object);
}

var _baseHasIn = baseHasIn$1;

var baseHasIn = _baseHasIn,
    hasPath = _hasPath;

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn$1(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

var hasIn_1 = hasIn$1;

var baseIsEqual = _baseIsEqual,
    get = get_1,
    hasIn = hasIn_1,
    isKey$1 = _isKey,
    isStrictComparable = _isStrictComparable,
    matchesStrictComparable = _matchesStrictComparable,
    toKey$2 = _toKey;

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty$1(path, srcValue) {
  if (isKey$1(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey$2(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

var _baseMatchesProperty = baseMatchesProperty$1;

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */

function identity$1(value) {
  return value;
}

var identity_1 = identity$1;

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */

function baseProperty$1(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

var _baseProperty = baseProperty$1;

var baseGet = _baseGet;

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep$1(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

var _basePropertyDeep = basePropertyDeep$1;

var baseProperty = _baseProperty,
    basePropertyDeep = _basePropertyDeep,
    isKey = _isKey,
    toKey$1 = _toKey;

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property$1(path) {
  return isKey(path) ? baseProperty(toKey$1(path)) : basePropertyDeep(path);
}

var property_1 = property$1;

var baseMatches = _baseMatches,
    baseMatchesProperty = _baseMatchesProperty,
    identity = identity_1,
    isArray$3 = isArray_1,
    property = property_1;

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee$2(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray$3(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

var _baseIteratee = baseIteratee$2;

var baseAssignValue$2 = _baseAssignValue,
    baseForOwn$1 = _baseForOwn,
    baseIteratee$1 = _baseIteratee;

/**
 * Creates an object with the same keys as `object` and values generated
 * by running each own enumerable string keyed property of `object` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapKeys
 * @example
 *
 * var users = {
 *   'fred':    { 'user': 'fred',    'age': 40 },
 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
 * };
 *
 * _.mapValues(users, function(o) { return o.age; });
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 *
 * // The `_.property` iteratee shorthand.
 * _.mapValues(users, 'age');
 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
 */
function mapValues(object, iteratee) {
  var result = {};
  iteratee = baseIteratee$1(iteratee, 3);

  baseForOwn$1(object, function(value, key, object) {
    baseAssignValue$2(result, key, iteratee(value, key, object));
  });
  return result;
}

var mapValues_1 = mapValues;

var mapValues$1 = mapValues_1;

/**
 * Based on Kendo UI Core expression code <https://github.com/telerik/kendo-ui-core#license-information>
 */

function Cache(maxSize) {
  this._maxSize = maxSize;
  this.clear();
}
Cache.prototype.clear = function () {
  this._size = 0;
  this._values = Object.create(null);
};
Cache.prototype.get = function (key) {
  return this._values[key]
};
Cache.prototype.set = function (key, value) {
  this._size >= this._maxSize && this.clear();
  if (!(key in this._values)) this._size++;

  return (this._values[key] = value)
};

var SPLIT_REGEX = /[^.^\]^[]+|(?=\[\]|\.\.)/g,
  DIGIT_REGEX = /^\d+$/,
  LEAD_DIGIT_REGEX = /^\d/,
  SPEC_CHAR_REGEX = /[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g,
  CLEAN_QUOTES_REGEX = /^\s*(['"]?)(.*?)(\1)\s*$/,
  MAX_CACHE_SIZE = 512;

var pathCache = new Cache(MAX_CACHE_SIZE),
  setCache = new Cache(MAX_CACHE_SIZE),
  getCache = new Cache(MAX_CACHE_SIZE);

var propertyExpr = {
  Cache: Cache,

  split: split,

  normalizePath: normalizePath,

  setter: function (path) {
    var parts = normalizePath(path);

    return (
      setCache.get(path) ||
      setCache.set(path, function setter(obj, value) {
        var index = 0;
        var len = parts.length;
        var data = obj;

        while (index < len - 1) {
          var part = parts[index];
          if (
            part === '__proto__' ||
            part === 'constructor' ||
            part === 'prototype'
          ) {
            return obj
          }

          data = data[parts[index++]];
        }
        data[parts[index]] = value;
      })
    )
  },

  getter: function (path, safe) {
    var parts = normalizePath(path);
    return (
      getCache.get(path) ||
      getCache.set(path, function getter(data) {
        var index = 0,
          len = parts.length;
        while (index < len) {
          if (data != null || !safe) data = data[parts[index++]];
          else return
        }
        return data
      })
    )
  },

  join: function (segments) {
    return segments.reduce(function (path, part) {
      return (
        path +
        (isQuoted(part) || DIGIT_REGEX.test(part)
          ? '[' + part + ']'
          : (path ? '.' : '') + part)
      )
    }, '')
  },

  forEach: function (path, cb, thisArg) {
    forEach(Array.isArray(path) ? path : split(path), cb, thisArg);
  },
};

function normalizePath(path) {
  return (
    pathCache.get(path) ||
    pathCache.set(
      path,
      split(path).map(function (part) {
        return part.replace(CLEAN_QUOTES_REGEX, '$2')
      })
    )
  )
}

function split(path) {
  return path.match(SPLIT_REGEX)
}

function forEach(parts, iter, thisArg) {
  var len = parts.length,
    part,
    idx,
    isArray,
    isBracket;

  for (idx = 0; idx < len; idx++) {
    part = parts[idx];

    if (part) {
      if (shouldBeQuoted(part)) {
        part = '"' + part + '"';
      }

      isBracket = isQuoted(part);
      isArray = !isBracket && /^\d+$/.test(part);

      iter.call(thisArg, part, isBracket, isArray, idx, parts);
    }
  }
}

function isQuoted(str) {
  return (
    typeof str === 'string' && str && ["'", '"'].indexOf(str.charAt(0)) !== -1
  )
}

function hasLeadingNumber(part) {
  return part.match(LEAD_DIGIT_REGEX) && !part.match(DIGIT_REGEX)
}

function hasSpecialChars(part) {
  return SPEC_CHAR_REGEX.test(part)
}

function shouldBeQuoted(part) {
  return !isQuoted(part) && (hasLeadingNumber(part) || hasSpecialChars(part))
}

const prefixes = {
  context: '$',
  value: '.'
};
function create$5(key, options) {
  return new Reference(key, options);
}
class Reference {
  constructor(key, options = {}) {
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && propertyExpr.getter(this.path, true);
    this.map = options.map;
  }

  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */


  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }

  resolve() {
    return this;
  }

  describe() {
    return {
      type: 'ref',
      key: this.key
    };
  }

  toString() {
    return `Ref(${this.key})`;
  }

  static isRef(value) {
    return value && value.__isYupRef;
  }

} // @ts-ignore

Reference.prototype.__isYupRef = true;

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function createValidation(config) {
  function validate(_ref, cb) {
    let {
      value,
      path = '',
      label,
      options,
      originalValue,
      sync
    } = _ref,
        rest = _objectWithoutPropertiesLoose$1(_ref, ["value", "path", "label", "options", "originalValue", "sync"]);

    const {
      name,
      test,
      params,
      message
    } = config;
    let {
      parent,
      context
    } = options;

    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }

    function createError(overrides = {}) {
      const nextParams = mapValues$1(_extends$3({
        value,
        originalValue,
        label,
        path: overrides.path || path
      }, params, overrides.params), resolve);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
      error.params = nextParams;
      return error;
    }

    let ctx = _extends$3({
      path,
      parent,
      type: name,
      createError,
      resolve,
      options,
      originalValue
    }, rest);

    if (!sync) {
      try {
        Promise.resolve(test.call(ctx, value, ctx)).then(validOrError => {
          if (ValidationError.isError(validOrError)) cb(validOrError);else if (!validOrError) cb(createError());else cb(null, validOrError);
        });
      } catch (err) {
        cb(err);
      }

      return;
    }

    let result;

    try {
      var _ref2;

      result = test.call(ctx, value, ctx);

      if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') {
        throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
      }
    } catch (err) {
      cb(err);
      return;
    }

    if (ValidationError.isError(result)) cb(result);else if (!result) cb(createError());else cb(null, result);
  }

  validate.OPTIONS = config;
  return validate;
}

let trim = part => part.substr(0, part.length - 1).substr(1);

function getIn$1(schema, path, value, context = value) {
  let parent, lastPart, lastPartDebug; // root path: ''

  if (!path) return {
    parent,
    parentPath: path,
    schema
  };
  propertyExpr.forEach(path, (_part, isBracket, isArray) => {
    let part = isBracket ? trim(_part) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });

    if (schema.innerType) {
      let idx = isArray ? parseInt(part, 10) : 0;

      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
      }

      parent = value;
      value = value && value[idx];
      schema = schema.innerType;
    } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal


    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }

    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}

class ReferenceSet {
  constructor() {
    this.list = new Set();
    this.refs = new Map();
  }

  get size() {
    return this.list.size + this.refs.size;
  }

  describe() {
    const description = [];

    for (const item of this.list) description.push(item);

    for (const [, ref] of this.refs) description.push(ref.describe());

    return description;
  }

  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }

  add(value) {
    Reference.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  }

  delete(value) {
    Reference.isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
  }

  has(value, resolve) {
    if (this.list.has(value)) return true;
    let item,
        values = this.refs.values();

    while (item = values.next(), !item.done) if (resolve(item.value) === value) return true;

    return false;
  }

  clone() {
    const next = new ReferenceSet();
    next.list = new Set(this.list);
    next.refs = new Map(this.refs);
    return next;
  }

  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.list.forEach(value => next.add(value));
    newItems.refs.forEach(value => next.add(value));
    removeItems.list.forEach(value => next.delete(value));
    removeItems.refs.forEach(value => next.delete(value));
    return next;
  }

}

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
class BaseSchema {
  constructor(options) {
    this.deps = [];
    this.conditions = [];
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = (options == null ? void 0 : options.type) || 'mixed';
    this.spec = _extends$2({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      nullable: false,
      presence: 'optional'
    }, options == null ? void 0 : options.spec);
  } // TODO: remove


  get _type() {
    return this.type;
  }

  _typeCheck(_value) {
    return true;
  }

  clone(spec) {
    if (this._mutate) {
      if (spec) Object.assign(this.spec, spec);
      return this;
    } // if the nested value is a schema we can skip cloning, since
    // they are already immutable


    const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly

    next.type = this.type;
    next._typeError = this._typeError;
    next._whitelistError = this._whitelistError;
    next._blacklistError = this._blacklistError;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.exclusiveTests = _extends$2({}, this.exclusiveTests); // @ts-expect-error this is readonly

    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = clone$1(_extends$2({}, this.spec, spec));
    return next;
  }

  label(label) {
    var next = this.clone();
    next.spec.label = label;
    return next;
  }

  meta(...args) {
    if (args.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  } // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }


  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }

  concat(schema) {
    if (!schema || schema === this) return this;
    if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();

    const mergedSpec = _extends$2({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
    //   mergedSpec.nullable = base.spec.nullable;
    // if (combined.spec.presence === UNSET)
    //   mergedSpec.presence = base.spec.presence;


    combined.spec = mergedSpec;
    combined._typeError || (combined._typeError = base._typeError);
    combined._whitelistError || (combined._whitelistError = base._whitelistError);
    combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)

    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests

    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
    // the deduping logic is consistent

    combined.withMutation(next => {
      schema.tests.forEach(fn => {
        next.test(fn.OPTIONS);
      });
    });
    return combined;
  }

  isType(v) {
    if (this.spec.nullable && v === null) return true;
    return this._typeCheck(v);
  }

  resolve(options) {
    let schema = this;

    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((schema, condition) => condition.resolve(schema, options), schema);
      schema = schema.resolve(options);
    }

    return schema;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */


  cast(value, options = {}) {
    let resolvedSchema = this.resolve(_extends$2({
      value
    }, options));

    let result = resolvedSchema._cast(value, options);

    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
    }

    return result;
  }

  _cast(rawValue, _options) {
    let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn) => fn.call(this, value, rawValue, this), rawValue);

    if (value === undefined) {
      value = this.getDefault();
    }

    return value;
  }

  _validate(_value, options = {}, cb) {
    let {
      sync,
      path,
      from = [],
      originalValue = _value,
      strict = this.spec.strict,
      abortEarly = this.spec.abortEarly
    } = options;
    let value = _value;

    if (!strict) {
      // this._validating = true;
      value = this._cast(value, _extends$2({
        assert: false
      }, options)); // this._validating = false;
    } // value is cast, we can check if it meets type requirements


    let args = {
      value,
      path,
      options,
      originalValue,
      schema: this,
      label: this.spec.label,
      sync,
      from
    };
    let initialTests = [];
    if (this._typeError) initialTests.push(this._typeError);
    if (this._whitelistError) initialTests.push(this._whitelistError);
    if (this._blacklistError) initialTests.push(this._blacklistError);
    runTests({
      args,
      value,
      path,
      sync,
      tests: initialTests,
      endEarly: abortEarly
    }, err => {
      if (err) return void cb(err, value);
      runTests({
        tests: this.tests,
        args,
        path,
        sync,
        value,
        endEarly: abortEarly
      }, cb);
    });
  }

  validate(value, options, maybeCb) {
    let schema = this.resolve(_extends$2({}, options, {
      value
    })); // callback case is for nested validations

    return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject) => schema._validate(value, options, (err, value) => {
      if (err) reject(err);else resolve(value);
    }));
  }

  validateSync(value, options) {
    let schema = this.resolve(_extends$2({}, options, {
      value
    }));
    let result;

    schema._validate(value, _extends$2({}, options, {
      sync: true
    }), (err, value) => {
      if (err) throw err;
      result = value;
    });

    return result;
  }

  isValid(value, options) {
    return this.validate(value, options).then(() => true, err => {
      if (ValidationError.isError(err)) return false;
      throw err;
    });
  }

  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err)) return false;
      throw err;
    }
  }

  _getDefault() {
    let defaultValue = this.spec.default;

    if (defaultValue == null) {
      return defaultValue;
    }

    return typeof defaultValue === 'function' ? defaultValue.call(this) : clone$1(defaultValue);
  }

  getDefault(options) {
    let schema = this.resolve(options || {});
    return schema._getDefault();
  }

  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }

    let next = this.clone({
      default: def
    });
    return next;
  }

  strict(isStrict = true) {
    var next = this.clone();
    next.spec.strict = isStrict;
    return next;
  }

  _isPresent(value) {
    return value != null;
  }

  defined(message = mixed.defined) {
    return this.test({
      message,
      name: 'defined',
      exclusive: true,

      test(value) {
        return value !== undefined;
      }

    });
  }

  required(message = mixed.required) {
    return this.clone({
      presence: 'required'
    }).withMutation(s => s.test({
      message,
      name: 'required',
      exclusive: true,

      test(value) {
        return this.schema._isPresent(value);
      }

    }));
  }

  notRequired() {
    var next = this.clone({
      presence: 'optional'
    });
    next.tests = next.tests.filter(test => test.OPTIONS.name !== 'required');
    return next;
  }

  nullable(isNullable = true) {
    var next = this.clone({
      nullable: isNullable !== false
    });
    return next;
  }

  transform(fn) {
    var next = this.clone();
    next.transforms.push(fn);
    return next;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */


  test(...args) {
    let opts;

    if (args.length === 1) {
      if (typeof args[0] === 'function') {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }

    if (opts.message === undefined) opts.message = mixed.default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;

    if (opts.exclusive) {
      if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }

    if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(fn => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }

      return true;
    });
    next.tests.push(validate);
    return next;
  }

  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== 'string') {
      options = keys;
      keys = '.';
    }

    let next = this.clone();
    let deps = toArray(keys).map(key => new Reference(key));
    deps.forEach(dep => {
      // @ts-ignore
      if (dep.isSibling) next.deps.push(dep.key);
    });
    next.conditions.push(new Condition$1(deps, options));
    return next;
  }

  typeError(message) {
    var next = this.clone();
    next._typeError = createValidation({
      message,
      name: 'typeError',

      test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }

    });
    return next;
  }

  oneOf(enums, message = mixed.oneOf) {
    var next = this.clone();
    enums.forEach(val => {
      next._whitelist.add(val);

      next._blacklist.delete(val);
    });
    next._whitelistError = createValidation({
      message,
      name: 'oneOf',

      test(value) {
        if (value === undefined) return true;
        let valids = this.schema._whitelist;
        return valids.has(value, this.resolve) ? true : this.createError({
          params: {
            values: valids.toArray().join(', ')
          }
        });
      }

    });
    return next;
  }

  notOneOf(enums, message = mixed.notOneOf) {
    var next = this.clone();
    enums.forEach(val => {
      next._blacklist.add(val);

      next._whitelist.delete(val);
    });
    next._blacklistError = createValidation({
      message,
      name: 'notOneOf',

      test(value) {
        let invalids = this.schema._blacklist;
        if (invalids.has(value, this.resolve)) return this.createError({
          params: {
            values: invalids.toArray().join(', ')
          }
        });
        return true;
      }

    });
    return next;
  }

  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }

  describe() {
    const next = this.clone();
    const {
      label,
      meta
    } = next.spec;
    const description = {
      meta,
      label,
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map(fn => ({
        name: fn.OPTIONS.name,
        params: fn.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex(c => c.name === n.name) === idx)
    };
    return description;
  }

}
// @ts-expect-error
BaseSchema.prototype.__isYupSchema__ = true;

for (const method of ['validate', 'validateSync']) BaseSchema.prototype[`${method}At`] = function (path, value, options = {}) {
  const {
    parent,
    parentPath,
    schema
  } = getIn$1(this, path, value, options.context);
  return schema[method](parent && parent[parentPath], _extends$2({}, options, {
    parent,
    path
  }));
};

for (const alias of ['equals', 'is']) BaseSchema.prototype[alias] = BaseSchema.prototype.oneOf;

for (const alias of ['not', 'nope']) BaseSchema.prototype[alias] = BaseSchema.prototype.notOneOf;

BaseSchema.prototype.optional = BaseSchema.prototype.notRequired;

const Mixed = BaseSchema;
function create$4() {
  return new Mixed();
} // XXX: this is using the Base schema so that `addMethod(mixed)` works as a base class

create$4.prototype = Mixed.prototype;

var isAbsent = (value => value == null);

function create$3() {
  return new BooleanSchema();
}
class BooleanSchema extends BaseSchema {
  constructor() {
    super({
      type: 'boolean'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (!this.isType(value)) {
          if (/^(true|1)$/i.test(String(value))) return true;
          if (/^(false|0)$/i.test(String(value))) return false;
        }

        return value;
      });
    });
  }

  _typeCheck(v) {
    if (v instanceof Boolean) v = v.valueOf();
    return typeof v === 'boolean';
  }

  isTrue(message = boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'true'
      },

      test(value) {
        return isAbsent(value) || value === true;
      }

    });
  }

  isFalse(message = boolean.isValue) {
    return this.test({
      message,
      name: 'is-value',
      exclusive: true,
      params: {
        value: 'false'
      },

      test(value) {
        return isAbsent(value) || value === false;
      }

    });
  }

}
create$3.prototype = BooleanSchema.prototype;

let rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

let rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line

let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

let isTrimmed = value => isAbsent(value) || value === value.trim();

let objStringTag = {}.toString();
function create$2() {
  return new StringSchema();
}
class StringSchema extends BaseSchema {
  constructor() {
    super({
      type: 'string'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        if (Array.isArray(value)) return value;
        const strValue = value != null && value.toString ? value.toString() : value;
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
  }

  _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();
    return typeof value === 'string';
  }

  _isPresent(value) {
    return super._isPresent(value) && !!value.length;
  }

  length(length, message = string.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },

      test(value) {
        return isAbsent(value) || value.length === this.resolve(length);
      }

    });
  }

  min(min, message = string.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return isAbsent(value) || value.length >= this.resolve(min);
      }

    });
  }

  max(max, message = string.max) {
    return this.test({
      name: 'max',
      exclusive: true,
      message,
      params: {
        max
      },

      test(value) {
        return isAbsent(value) || value.length <= this.resolve(max);
      }

    });
  }

  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name;

    if (options) {
      if (typeof options === 'object') {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options);
      } else {
        message = options;
      }
    }

    return this.test({
      name: name || 'matches',
      message: message || string.matches,
      params: {
        regex
      },
      test: value => isAbsent(value) || value === '' && excludeEmptyString || value.search(regex) !== -1
    });
  }

  email(message = string.email) {
    return this.matches(rEmail, {
      name: 'email',
      message,
      excludeEmptyString: true
    });
  }

  url(message = string.url) {
    return this.matches(rUrl, {
      name: 'url',
      message,
      excludeEmptyString: true
    });
  }

  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: 'uuid',
      message,
      excludeEmptyString: false
    });
  } //-- transforms --


  ensure() {
    return this.default('').transform(val => val === null ? '' : val);
  }

  trim(message = string.trim) {
    return this.transform(val => val != null ? val.trim() : val).test({
      message,
      name: 'trim',
      test: isTrimmed
    });
  }

  lowercase(message = string.lowercase) {
    return this.transform(value => !isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => isAbsent(value) || value === value.toLowerCase()
    });
  }

  uppercase(message = string.uppercase) {
    return this.transform(value => !isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => isAbsent(value) || value === value.toUpperCase()
    });
  }

}
create$2.prototype = StringSchema.prototype; //
// String Interfaces
//

let isNaN$1 = value => value != +value;

function create$1() {
  return new NumberSchema();
}
class NumberSchema extends BaseSchema {
  constructor() {
    super({
      type: 'number'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        let parsed = value;

        if (typeof parsed === 'string') {
          parsed = parsed.replace(/\s/g, '');
          if (parsed === '') return NaN; // don't use parseFloat to avoid positives on alpha-numeric strings

          parsed = +parsed;
        }

        if (this.isType(parsed)) return parsed;
        return parseFloat(parsed);
      });
    });
  }

  _typeCheck(value) {
    if (value instanceof Number) value = value.valueOf();
    return typeof value === 'number' && !isNaN$1(value);
  }

  min(min, message = number.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return isAbsent(value) || value >= this.resolve(min);
      }

    });
  }

  max(max, message = number.max) {
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },

      test(value) {
        return isAbsent(value) || value <= this.resolve(max);
      }

    });
  }

  lessThan(less, message = number.lessThan) {
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        less
      },

      test(value) {
        return isAbsent(value) || value < this.resolve(less);
      }

    });
  }

  moreThan(more, message = number.moreThan) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        more
      },

      test(value) {
        return isAbsent(value) || value > this.resolve(more);
      }

    });
  }

  positive(msg = number.positive) {
    return this.moreThan(0, msg);
  }

  negative(msg = number.negative) {
    return this.lessThan(0, msg);
  }

  integer(message = number.integer) {
    return this.test({
      name: 'integer',
      message,
      test: val => isAbsent(val) || Number.isInteger(val)
    });
  }

  truncate() {
    return this.transform(value => !isAbsent(value) ? value | 0 : value);
  }

  round(method) {
    var _method;

    var avail = ['ceil', 'floor', 'round', 'trunc'];
    method = ((_method = method) == null ? void 0 : _method.toLowerCase()) || 'round'; // this exists for symemtry with the new Math.trunc

    if (method === 'trunc') return this.truncate();
    if (avail.indexOf(method.toLowerCase()) === -1) throw new TypeError('Only valid options for round() are: ' + avail.join(', '));
    return this.transform(value => !isAbsent(value) ? Math[method](value) : value);
  }

}
create$1.prototype = NumberSchema.prototype; //
// Number Interfaces
//

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */

function arrayReduce$1(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

var _arrayReduce = arrayReduce$1;

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */

function basePropertyOf$1(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

var _basePropertyOf = basePropertyOf$1;

var basePropertyOf = _basePropertyOf;

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter$1 = basePropertyOf(deburredLetters);

var _deburrLetter = deburrLetter$1;

var deburrLetter = _deburrLetter,
    toString$4 = toString_1;

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange$3 = '\\u0300-\\u036f',
    reComboHalfMarksRange$3 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$3 = '\\u20d0-\\u20ff',
    rsComboRange$3 = rsComboMarksRange$3 + reComboHalfMarksRange$3 + rsComboSymbolsRange$3;

/** Used to compose unicode capture groups. */
var rsCombo$2 = '[' + rsComboRange$3 + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo$2, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr$1(string) {
  string = toString$4(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

var deburr_1 = deburr$1;

/** Used to match words composed of alphanumeric characters. */

var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords$1(string) {
  return string.match(reAsciiWord) || [];
}

var _asciiWords = asciiWords$1;

/** Used to detect strings that need a more robust regexp to match words. */

var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord$1(string) {
  return reHasUnicodeWord.test(string);
}

var _hasUnicodeWord = hasUnicodeWord$1;

/** Used to compose unicode character classes. */

var rsAstralRange$2 = '\\ud800-\\udfff',
    rsComboMarksRange$2 = '\\u0300-\\u036f',
    reComboHalfMarksRange$2 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$2 = '\\u20d0-\\u20ff',
    rsComboRange$2 = rsComboMarksRange$2 + reComboHalfMarksRange$2 + rsComboSymbolsRange$2,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange$2 = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos$1 = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo$1 = '[' + rsComboRange$2 + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange$2 + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz$1 = '\\ud83c[\\udffb-\\udfff]',
    rsModifier$1 = '(?:' + rsCombo$1 + '|' + rsFitz$1 + ')',
    rsNonAstral$1 = '[^' + rsAstralRange$2 + ']',
    rsRegional$1 = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair$1 = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ$2 = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos$1 + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos$1 + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod$1 = rsModifier$1 + '?',
    rsOptVar$1 = '[' + rsVarRange$2 + ']?',
    rsOptJoin$1 = '(?:' + rsZWJ$2 + '(?:' + [rsNonAstral$1, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsOptVar$1 + reOptMod$1 + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq$1 = rsOptVar$1 + reOptMod$1 + rsOptJoin$1,
    rsEmoji = '(?:' + [rsDingbat, rsRegional$1, rsSurrPair$1].join('|') + ')' + rsSeq$1;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords$1(string) {
  return string.match(reUnicodeWord) || [];
}

var _unicodeWords = unicodeWords$1;

var asciiWords = _asciiWords,
    hasUnicodeWord = _hasUnicodeWord,
    toString$3 = toString_1,
    unicodeWords = _unicodeWords;

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words$1(string, pattern, guard) {
  string = toString$3(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

var words_1 = words$1;

var arrayReduce = _arrayReduce,
    deburr = deburr_1,
    words = words_1;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder$2(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

var _createCompounder = createCompounder$2;

var createCompounder$1 = _createCompounder;

/**
 * Converts `string` to
 * [snake case](https://en.wikipedia.org/wiki/Snake_case).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the snake cased string.
 * @example
 *
 * _.snakeCase('Foo Bar');
 * // => 'foo_bar'
 *
 * _.snakeCase('fooBar');
 * // => 'foo_bar'
 *
 * _.snakeCase('--FOO-BAR--');
 * // => 'foo_bar'
 */
var snakeCase = createCompounder$1(function(result, word, index) {
  return result + (index ? '_' : '') + word.toLowerCase();
});

var snakeCase_1 = snakeCase;

var snakeCase$1 = snakeCase_1;

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */

function baseSlice$1(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

var _baseSlice = baseSlice$1;

var baseSlice = _baseSlice;

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice$1(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

var _castSlice = castSlice$1;

/** Used to compose unicode character classes. */

var rsAstralRange$1 = '\\ud800-\\udfff',
    rsComboMarksRange$1 = '\\u0300-\\u036f',
    reComboHalfMarksRange$1 = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange$1 = '\\u20d0-\\u20ff',
    rsComboRange$1 = rsComboMarksRange$1 + reComboHalfMarksRange$1 + rsComboSymbolsRange$1,
    rsVarRange$1 = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ$1 = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ$1 + rsAstralRange$1  + rsComboRange$1 + rsVarRange$1 + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode$2(string) {
  return reHasUnicode.test(string);
}

var _hasUnicode = hasUnicode$2;

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */

function asciiToArray$1(string) {
  return string.split('');
}

var _asciiToArray = asciiToArray$1;

/** Used to compose unicode character classes. */

var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray$1(string) {
  return string.match(reUnicode) || [];
}

var _unicodeToArray = unicodeToArray$1;

var asciiToArray = _asciiToArray,
    hasUnicode$1 = _hasUnicode,
    unicodeToArray = _unicodeToArray;

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray$1(string) {
  return hasUnicode$1(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

var _stringToArray = stringToArray$1;

var castSlice = _castSlice,
    hasUnicode = _hasUnicode,
    stringToArray = _stringToArray,
    toString$2 = toString_1;

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst$1(methodName) {
  return function(string) {
    string = toString$2(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

var _createCaseFirst = createCaseFirst$1;

var createCaseFirst = _createCaseFirst;

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst$1 = createCaseFirst('toUpperCase');

var upperFirst_1 = upperFirst$1;

var toString$1 = toString_1,
    upperFirst = upperFirst_1;

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize$1(string) {
  return upperFirst(toString$1(string).toLowerCase());
}

var capitalize_1 = capitalize$1;

var capitalize = capitalize_1,
    createCompounder = _createCompounder;

/**
 * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the camel cased string.
 * @example
 *
 * _.camelCase('Foo Bar');
 * // => 'fooBar'
 *
 * _.camelCase('--foo-bar--');
 * // => 'fooBar'
 *
 * _.camelCase('__FOO_BAR__');
 * // => 'fooBar'
 */
var camelCase = createCompounder(function(result, word, index) {
  word = word.toLowerCase();
  return result + (index ? capitalize(word) : word);
});

var camelCase_1 = camelCase;

var camelCase$1 = camelCase_1;

var baseAssignValue$1 = _baseAssignValue,
    baseForOwn = _baseForOwn,
    baseIteratee = _baseIteratee;

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue$1(result, iteratee(value, key, object), value);
  });
  return result;
}

var mapKeys_1 = mapKeys;

var mapKeys$1 = mapKeys_1;

var toposort$2 = {exports: {}};

/**
 * Topological sorting function
 *
 * @param {Array} edges
 * @returns {Array}
 */

toposort$2.exports = function(edges) {
  return toposort(uniqueNodes(edges), edges)
};

toposort$2.exports.array = toposort;

function toposort(nodes, edges) {
  var cursor = nodes.length
    , sorted = new Array(cursor)
    , visited = {}
    , i = cursor
    // Better data structures make algorithm much faster.
    , outgoingEdges = makeOutgoingEdges(edges)
    , nodesHash = makeNodesHash(nodes);

  // check for unknown nodes
  edges.forEach(function(edge) {
    if (!nodesHash.has(edge[0]) || !nodesHash.has(edge[1])) {
      throw new Error('Unknown node. There is an unknown node in the supplied edges.')
    }
  });

  while (i--) {
    if (!visited[i]) visit(nodes[i], i, new Set());
  }

  return sorted

  function visit(node, i, predecessors) {
    if(predecessors.has(node)) {
      var nodeRep;
      try {
        nodeRep = ", node was:" + JSON.stringify(node);
      } catch(e) {
        nodeRep = "";
      }
      throw new Error('Cyclic dependency' + nodeRep)
    }

    if (!nodesHash.has(node)) {
      throw new Error('Found unknown node. Make sure to provided all involved nodes. Unknown node: '+JSON.stringify(node))
    }

    if (visited[i]) return;
    visited[i] = true;

    var outgoing = outgoingEdges.get(node) || new Set();
    outgoing = Array.from(outgoing);

    if (i = outgoing.length) {
      predecessors.add(node);
      do {
        var child = outgoing[--i];
        visit(child, nodesHash.get(child), predecessors);
      } while (i)
      predecessors.delete(node);
    }

    sorted[--cursor] = node;
  }
}

function uniqueNodes(arr){
  var res = new Set();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    res.add(edge[0]);
    res.add(edge[1]);
  }
  return Array.from(res)
}

function makeOutgoingEdges(arr){
  var edges = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    var edge = arr[i];
    if (!edges.has(edge[0])) edges.set(edge[0], new Set());
    if (!edges.has(edge[1])) edges.set(edge[1], new Set());
    edges.get(edge[0]).add(edge[1]);
  }
  return edges
}

function makeNodesHash(arr){
  var res = new Map();
  for (var i = 0, len = arr.length; i < len; i++) {
    res.set(arr[i], i);
  }
  return res
}

var toposort$1 = toposort$2.exports;

function sortFields(fields, excludes = []) {
  let edges = [];
  let nodes = [];

  function addNode(depPath, key) {
    var node = propertyExpr.split(depPath)[0];
    if (!~nodes.indexOf(node)) nodes.push(node);
    if (!~excludes.indexOf(`${key}-${node}`)) edges.push([key, node]);
  }

  for (const key in fields) if (has$1(fields, key)) {
    let value = fields[key];
    if (!~nodes.indexOf(key)) nodes.push(key);
    if (Reference.isRef(value) && value.isSibling) addNode(value.path, key);else if (isSchema(value) && 'deps' in value) value.deps.forEach(path => addNode(path, key));
  }

  return toposort$1.array(nodes, edges).reverse();
}

function findIndex(arr, err) {
  let idx = Infinity;
  arr.some((key, ii) => {
    var _err$path;

    if (((_err$path = err.path) == null ? void 0 : _err$path.indexOf(key)) !== -1) {
      idx = ii;
      return true;
    }
  });
  return idx;
}

function sortByKeyOrder(keys) {
  return (a, b) => {
    return findIndex(keys, a) - findIndex(keys, b);
  };
}

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

let isObject$2 = obj => Object.prototype.toString.call(obj) === '[object Object]';

function unknown(ctx, value) {
  let known = Object.keys(ctx.fields);
  return Object.keys(value).filter(key => known.indexOf(key) === -1);
}

const defaultSort = sortByKeyOrder([]);
class ObjectSchema extends BaseSchema {
  constructor(spec) {
    super({
      type: 'object'
    });
    this.fields = Object.create(null);
    this._sortErrors = defaultSort;
    this._nodes = [];
    this._excludedEdges = [];
    this.withMutation(() => {
      this.transform(function coerce(value) {
        if (typeof value === 'string') {
          try {
            value = JSON.parse(value);
          } catch (err) {
            value = null;
          }
        }

        if (this.isType(value)) return value;
        return null;
      });

      if (spec) {
        this.shape(spec);
      }
    });
  }

  _typeCheck(value) {
    return isObject$2(value) || typeof value === 'function';
  }

  _cast(_value, options = {}) {
    var _options$stripUnknown;

    let value = super._cast(_value, options); //should ignore nulls here


    if (value === undefined) return this.getDefault();
    if (!this._typeCheck(value)) return value;
    let fields = this.fields;
    let strip = (_options$stripUnknown = options.stripUnknown) != null ? _options$stripUnknown : this.spec.noUnknown;

    let props = this._nodes.concat(Object.keys(value).filter(v => this._nodes.indexOf(v) === -1));

    let intermediateValue = {}; // is filled during the transform below

    let innerOptions = _extends$1({}, options, {
      parent: intermediateValue,
      __validating: options.__validating || false
    });

    let isChanged = false;

    for (const prop of props) {
      let field = fields[prop];
      let exists = has$1(value, prop);

      if (field) {
        let fieldValue;
        let inputValue = value[prop]; // safe to mutate since this is fired in sequence

        innerOptions.path = (options.path ? `${options.path}.` : '') + prop; // innerOptions.value = value[prop];

        field = field.resolve({
          value: inputValue,
          context: options.context,
          parent: intermediateValue
        });
        let fieldSpec = 'spec' in field ? field.spec : undefined;
        let strict = fieldSpec == null ? void 0 : fieldSpec.strict;

        if (fieldSpec == null ? void 0 : fieldSpec.strip) {
          isChanged = isChanged || prop in value;
          continue;
        }

        fieldValue = !options.__validating || !strict ? // TODO: use _cast, this is double resolving
        field.cast(value[prop], innerOptions) : value[prop];

        if (fieldValue !== undefined) {
          intermediateValue[prop] = fieldValue;
        }
      } else if (exists && !strip) {
        intermediateValue[prop] = value[prop];
      }

      if (intermediateValue[prop] !== value[prop]) {
        isChanged = true;
      }
    }

    return isChanged ? intermediateValue : value;
  }

  _validate(_value, opts = {}, callback) {
    let errors = [];
    let {
      sync,
      from = [],
      originalValue = _value,
      abortEarly = this.spec.abortEarly,
      recursive = this.spec.recursive
    } = opts;
    from = [{
      schema: this,
      value: originalValue
    }, ...from]; // this flag is needed for handling `strict` correctly in the context of
    // validation vs just casting. e.g strict() on a field is only used when validating

    opts.__validating = true;
    opts.originalValue = originalValue;
    opts.from = from;

    super._validate(_value, opts, (err, value) => {
      if (err) {
        if (!ValidationError.isError(err) || abortEarly) {
          return void callback(err, value);
        }

        errors.push(err);
      }

      if (!recursive || !isObject$2(value)) {
        callback(errors[0] || null, value);
        return;
      }

      originalValue = originalValue || value;

      let tests = this._nodes.map(key => (_, cb) => {
        let path = key.indexOf('.') === -1 ? (opts.path ? `${opts.path}.` : '') + key : `${opts.path || ''}["${key}"]`;
        let field = this.fields[key];

        if (field && 'validate' in field) {
          field.validate(value[key], _extends$1({}, opts, {
            // @ts-ignore
            path,
            from,
            // inner fields are always strict:
            // 1. this isn't strict so the casting will also have cast inner values
            // 2. this is strict in which case the nested values weren't cast either
            strict: true,
            parent: value,
            originalValue: originalValue[key]
          }), cb);
          return;
        }

        cb(null);
      });

      runTests({
        sync,
        tests,
        value,
        errors,
        endEarly: abortEarly,
        sort: this._sortErrors,
        path: opts.path
      }, callback);
    });
  }

  clone(spec) {
    const next = super.clone(spec);
    next.fields = _extends$1({}, this.fields);
    next._nodes = this._nodes;
    next._excludedEdges = this._excludedEdges;
    next._sortErrors = this._sortErrors;
    return next;
  }

  concat(schema) {
    let next = super.concat(schema);
    let nextFields = next.fields;

    for (let [field, schemaOrRef] of Object.entries(this.fields)) {
      const target = nextFields[field];

      if (target === undefined) {
        nextFields[field] = schemaOrRef;
      } else if (target instanceof BaseSchema && schemaOrRef instanceof BaseSchema) {
        nextFields[field] = schemaOrRef.concat(target);
      }
    }

    return next.withMutation(() => next.shape(nextFields));
  }

  getDefaultFromShape() {
    let dft = {};

    this._nodes.forEach(key => {
      const field = this.fields[key];
      dft[key] = 'default' in field ? field.getDefault() : undefined;
    });

    return dft;
  }

  _getDefault() {
    if ('default' in this.spec) {
      return super._getDefault();
    } // if there is no default set invent one


    if (!this._nodes.length) {
      return undefined;
    }

    return this.getDefaultFromShape();
  }

  shape(additions, excludes = []) {
    let next = this.clone();
    let fields = Object.assign(next.fields, additions);
    next.fields = fields;
    next._sortErrors = sortByKeyOrder(Object.keys(fields));

    if (excludes.length) {
      if (!Array.isArray(excludes[0])) excludes = [excludes];
      let keys = excludes.map(([first, second]) => `${first}-${second}`);
      next._excludedEdges = next._excludedEdges.concat(keys);
    }

    next._nodes = sortFields(fields, next._excludedEdges);
    return next;
  }

  pick(keys) {
    const picked = {};

    for (const key of keys) {
      if (this.fields[key]) picked[key] = this.fields[key];
    }

    return this.clone().withMutation(next => {
      next.fields = {};
      return next.shape(picked);
    });
  }

  omit(keys) {
    const next = this.clone();
    const fields = next.fields;
    next.fields = {};

    for (const key of keys) {
      delete fields[key];
    }

    return next.withMutation(() => next.shape(fields));
  }

  from(from, to, alias) {
    let fromGetter = propertyExpr.getter(from, true);
    return this.transform(obj => {
      if (obj == null) return obj;
      let newObj = obj;

      if (has$1(obj, from)) {
        newObj = _extends$1({}, obj);
        if (!alias) delete newObj[from];
        newObj[to] = fromGetter(obj);
      }

      return newObj;
    });
  }

  noUnknown(noAllow = true, message = object.noUnknown) {
    if (typeof noAllow === 'string') {
      message = noAllow;
      noAllow = true;
    }

    let next = this.test({
      name: 'noUnknown',
      exclusive: true,
      message: message,

      test(value) {
        if (value == null) return true;
        const unknownKeys = unknown(this.schema, value);
        return !noAllow || unknownKeys.length === 0 || this.createError({
          params: {
            unknown: unknownKeys.join(', ')
          }
        });
      }

    });
    next.spec.noUnknown = noAllow;
    return next;
  }

  unknown(allow = true, message = object.noUnknown) {
    return this.noUnknown(!allow, message);
  }

  transformKeys(fn) {
    return this.transform(obj => obj && mapKeys$1(obj, (_, key) => fn(key)));
  }

  camelCase() {
    return this.transformKeys(camelCase$1);
  }

  snakeCase() {
    return this.transformKeys(snakeCase$1);
  }

  constantCase() {
    return this.transformKeys(key => snakeCase$1(key).toUpperCase());
  }

  describe() {
    let base = super.describe();
    base.fields = mapValues$1(this.fields, value => value.describe());
    return base;
  }

}
function create(spec) {
  return new ObjectSchema(spec);
}
create.prototype = ObjectSchema.prototype;

const ProfileIcon = (props) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 16 16' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M8 8C10.2091 8 12 6.20914 12 4C12 1.79086 10.2091 0 8 0C5.79086 0 4 1.79086 4 4C4 6.20914 5.79086 8 8 8Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M16 13.1999C16.0017 12.8171 15.8928 12.4419 15.6865 12.1194C15.4802 11.797 15.1853 11.5409 14.837 11.3819C12.6811 10.4438 10.351 9.97278 8.00002 9.99989C5.64902 9.97278 3.31892 10.4438 1.16302 11.3819C0.814771 11.5409 0.519799 11.797 0.313505 12.1194C0.107211 12.4419 -0.00163935 12.8171 1.86626e-05 13.1999V15.9999H16V13.1999Z" }));
const PrivacyIcon = (props) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 16 16' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M1 15C1 15.6 1.4 16 2 16H14C14.6 16 15 15.6 15 15V6C15 5.4 14.6 5 14 5H12H6V4C6 2.9 6.9 2 8 2C8.6 2 9.1 2.2 9.5 2.7L10.2 3.4L11.7 2.1L11 1.3C10.2 0.5 9.1 0 8 0C5.8 0 4 1.8 4 4V5H2C1.4 5 1 5.4 1 6V15ZM8 8C9.1 8 10 8.9 10 10C10 10.7 9.6 11.4 9 11.7V13H7V11.7C6.4 11.4 6 10.7 6 10C6 8.9 6.9 8 8 8Z" }));
const PersonalTokensIcon = (props) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 16 16' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { clipPath: "url(#clip0)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M8 8C10.2091 8 12 6.20914 12 4C12 1.79086 10.2091 0 8 0C5.79086 0 4 1.79086 4 4C4 6.20914 5.79086 8 8 8Z" }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M7 13.171L10.054 10.117C9.414 10.046 8.732 10 8 10C4.808 10 2.461 10.795 1.163 11.382C0.45 11.705 0 12.417 0 13.2V16H7V13.171Z" }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M9.8255 16.2055C9.90102 16.2234 9.97987 16.2217 10.0545 16.2005C10.1292 16.1793 10.1972 16.1394 10.2521 16.0845L13.0045 13.3322C13.3915 13.4359 13.8018 13.409 14.172 13.2556C14.5421 13.1023 14.8513 12.8312 15.0516 12.4842C15.252 12.1372 15.3322 11.7339 15.2799 11.3367C15.2276 10.9395 15.0457 10.5706 14.7624 10.2873C14.4791 10.004 14.1103 9.82213 13.7131 9.76983C13.3159 9.71754 12.9125 9.79777 12.5655 9.99809C12.2186 10.1984 11.9474 10.5076 11.7941 10.8778C11.6408 11.2479 11.6139 11.6583 11.7176 12.0453L10.8956 12.8673L10.0912 13.0281L9.93038 13.8324L9.28693 14.4759C9.22712 14.5357 9.18514 14.6109 9.1657 14.6932C9.14627 14.7755 9.15014 14.8615 9.1769 14.9418L9.49863 15.9069C9.52318 15.9804 9.5661 16.0464 9.6233 16.0986C9.6805 16.1509 9.7501 16.1877 9.8255 16.2055ZM13.4694 10.9369C13.533 10.8733 13.6141 10.8299 13.7023 10.8124C13.7906 10.7948 13.8821 10.8038 13.9652 10.8383C14.0483 10.8727 14.1194 10.931 14.1694 11.0059C14.2194 11.0807 14.2461 11.1686 14.2461 11.2586C14.2461 11.3486 14.2194 11.4366 14.1694 11.5114C14.1194 11.5862 14.0483 11.6446 13.9652 11.679C13.8821 11.7134 13.7906 11.7224 13.7023 11.7049C13.6141 11.6873 13.533 11.644 13.4694 11.5804C13.384 11.495 13.3361 11.3793 13.3361 11.2586C13.3361 11.138 13.384 11.0222 13.4694 10.9369Z" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("defs", null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("clipPath", { id: "clip0" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "16", height: "16", fill: "white" }))));
const AccountDetailsIcon = (props) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 16 16' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M15 3H11C10.4 3 10 3.4 10 4C10 4.6 10.4 5 11 5H15C15.6 5 16 4.6 16 4C16 3.4 15.6 3 15 3Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M5 1C3.7 1 2.6 1.9 2.2 3C2.1 3 2.1 3 2 3H1C0.4 3 0 3.4 0 4C0 4.6 0.4 5 1 5H2C2.1 5 2.1 5 2.2 5C2.6 6.1 3.7 7 5 7C6.7 7 8 5.7 8 4C8 2.3 6.7 1 5 1Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M1 13H5C5.6 13 6 12.6 6 12C6 11.4 5.6 11 5 11H1C0.4 11 0 11.4 0 12C0 12.6 0.4 13 1 13Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M15 11H14C13.9 11 13.9 11 13.8 11C13.4 9.8 12.3 9 11 9C9.3 9 8 10.3 8 12C8 13.7 9.3 15 11 15C12.3 15 13.4 14.1 13.8 13C13.9 13 13.9 13 14 13H15C15.6 13 16 12.6 16 12C16 11.4 15.6 11 15 11Z" }));
const UsageIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 16 16' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M15 0H1C0.4 0 0 0.4 0 1V15C0 15.6 0.4 16 1 16H15C15.6 16 16 15.6 16 15V1C16 0.4 15.6 0 15 0ZM10.1 10.3L6 7.2L2.7 9.4L1.6 7.7L6 4.8L9.9 7.7L13 4.6L14.4 6L10.1 10.3Z" }));
const UsersIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 16 16' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M15.2748 10.2929L13.0868 9.6679C12.91 9.61734 12.7505 9.51899 12.626 9.38367C12.5014 9.24835 12.4166 9.08131 12.3808 8.9009L12.2468 8.2259C12.7694 7.98708 13.2124 7.60324 13.5231 7.12C13.8339 6.63675 13.9993 6.07444 13.9998 5.4999V4.1259C14.012 3.33035 13.7161 2.56089 13.1742 1.97833C12.6323 1.39578 11.8862 1.04521 11.0918 0.9999C10.4988 0.982008 9.91388 1.14033 9.41086 1.45484C8.90785 1.76936 8.50938 2.22595 8.26582 2.7669C8.74287 3.46118 8.99874 4.28352 8.99982 5.1259V6.4999C8.99803 6.86367 8.94587 7.22544 8.84482 7.5749C9.10406 7.84684 9.41206 8.06767 9.75282 8.2259L9.61882 8.8999C9.58306 9.08031 9.49823 9.24735 9.37368 9.38267C9.24912 9.51799 9.08966 9.61634 8.91282 9.6669L8.06982 9.9079L9.54982 10.3309C9.96702 10.4514 10.3339 10.704 10.5953 11.0507C10.8568 11.3975 10.9987 11.8196 10.9998 12.2539V14.4999C10.9982 14.6706 10.967 14.8398 10.9078 14.9999H15.4998C15.6324 14.9999 15.7596 14.9472 15.8534 14.8535C15.9471 14.7597 15.9998 14.6325 15.9998 14.4999V11.2539C15.9997 11.0367 15.9289 10.8255 15.7981 10.6521C15.6673 10.4787 15.4836 10.3526 15.2748 10.2929Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M9.275 11.2929L7.087 10.6679C6.91004 10.6173 6.75049 10.5188 6.62592 10.3833C6.50135 10.2478 6.4166 10.0805 6.381 9.89995L6.247 9.22495C6.7694 8.9862 7.21228 8.60251 7.52303 8.11946C7.83377 7.63641 7.99932 7.07431 8 6.49995V5.12595C8.01213 4.33039 7.71632 3.56093 7.17439 2.97838C6.63246 2.39583 5.88636 2.04526 5.092 1.99995C4.69036 1.98762 4.29034 2.05611 3.91568 2.20135C3.54101 2.34659 3.19935 2.56561 2.91095 2.84542C2.62256 3.12524 2.39332 3.46013 2.23683 3.83024C2.08035 4.20035 1.99981 4.59812 2 4.99995V6.49995C2.00049 7.07448 2.16595 7.6368 2.4767 8.12004C2.78746 8.60328 3.23045 8.98713 3.753 9.22595L3.619 9.89995C3.58323 10.0804 3.49841 10.2474 3.37385 10.3827C3.24929 10.518 3.08983 10.6164 2.913 10.6669L0.725 11.2919C0.516025 11.3517 0.332214 11.478 0.201397 11.6515C0.0705796 11.8251 -0.000120636 12.0366 1.54521e-07 12.2539V14.4999C1.54521e-07 14.6326 0.0526786 14.7597 0.146447 14.8535C0.240215 14.9473 0.367392 14.9999 0.5 14.9999H9.5C9.63261 14.9999 9.75979 14.9473 9.85355 14.8535C9.94732 14.7597 10 14.6326 10 14.4999V12.2539C9.9999 12.0368 9.9291 11.8255 9.7983 11.6521C9.6675 11.4788 9.48381 11.3527 9.275 11.2929Z" }));
const RolesIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 16 16' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M2 2H5V0H1C0.447 0 0 0.447 0 1V5H2V2Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M15 0H11V2H14V5H16V1C16 0.447 15.553 0 15 0Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M14 14H11V16H15C15.553 16 16 15.553 16 15V11H14V14Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M2 11H0V15C0 15.553 0.447 16 1 16H5V14H2V11Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M4 10V12H12V10C12 10 11 8 8 8C5 8 4 10 4 10Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M8 7C9.10457 7 10 6.10457 10 5C10 3.89543 9.10457 3 8 3C6.89543 3 6 3.89543 6 5C6 6.10457 6.89543 7 8 7Z" }));
const SecurityIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 24 24' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM10 17L6 13L7.41 11.59L10 14.17L16.59 7.58L18 9L10 17Z" }));
const SSOIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 16 16' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M15 2H13C12.4 2 12 2.4 12 3C12 3.6 11.6 4 11 4C10.4 4 10 3.6 10 3C10 2.4 9.6 2 9 2H7C6.4 2 6 2.4 6 3C6 3.6 5.6 4 5 4C4.4 4 4 3.6 4 3C4 2.4 3.6 2 3 2H1C0.4 2 0 2.4 0 3V13C0 13.6 0.4 14 1 14H15C15.6 14 16 13.6 16 13V3C16 2.4 15.6 2 15 2ZM7 11H3V7H7V11ZM13 11H9V10H13V11ZM13 8H9V7H13V8Z" }));
const AuditLogsIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 16 16' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M13 0H3C2.46957 0 1.96086 0.210714 1.58579 0.585786C1.21071 0.960859 1 1.46957 1 2V14C1 14.5304 1.21071 15.0391 1.58579 15.4142C1.96086 15.7893 2.46957 16 3 16H13C13.5304 16 14.0391 15.7893 14.4142 15.4142C14.7893 15.0391 15 14.5304 15 14V2C15 1.46957 14.7893 0.960859 14.4142 0.585786C14.0391 0.210714 13.5304 0 13 0V0ZM9 11H4V10H9V11ZM12 8H4V7H12V8ZM12 5H4V4H12V5Z" }));
const WebhooksIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 16 16' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.49844 6.25922C6.83288 7.38088 6.19521 8.4671 5.54428 9.54513C5.37712 9.82187 5.2944 10.0473 5.42796 10.3991C5.79664 11.371 5.27654 12.3167 4.29897 12.5734C3.37707 12.8156 2.47887 12.2082 2.29595 11.2187C2.13387 10.3428 2.81183 9.48421 3.77502 9.34732C3.85576 9.33576 3.9381 9.3344 4.07377 9.3242C4.54575 8.53076 5.02927 7.71805 5.53895 6.86107C4.61743 5.94244 4.06893 4.86852 4.19034 3.53787C4.27615 2.59723 4.64508 1.78439 5.31945 1.11813C6.61102 -0.157691 8.58143 -0.364319 10.1022 0.614989C11.5628 1.55563 12.2317 3.38793 11.6615 4.95617C11.2315 4.8393 10.7986 4.72144 10.3227 4.59202C10.5017 3.72013 10.3693 2.93713 9.78272 2.2664C9.39518 1.82355 8.8979 1.59144 8.33241 1.5059C7.19883 1.33421 6.08584 2.06437 5.7556 3.17981C5.38071 4.44581 5.94806 5.47995 7.49844 6.25922Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.39911 4.93289C9.86799 5.76214 10.3441 6.60394 10.8159 7.43804C13.2009 6.69831 14.9991 8.02187 15.6442 9.43892C16.4233 11.1506 15.8907 13.178 14.3604 14.234C12.7897 15.3181 10.8033 15.1329 9.41163 13.7403C9.7663 13.4427 10.1227 13.1437 10.5035 12.8243C11.8781 13.7168 13.0802 13.6748 13.9727 12.6179C14.7338 11.7163 14.7173 10.372 13.9342 9.48928C13.0304 8.47068 11.8198 8.4396 10.3565 9.41742C9.74944 8.33778 9.13187 7.26672 8.54406 6.17925C8.34589 5.81274 8.12701 5.60014 7.68032 5.52256C6.93428 5.39289 6.45262 4.75063 6.42372 4.03104C6.39533 3.3194 6.81349 2.67615 7.46715 2.42551C8.11461 2.17723 8.87442 2.37764 9.30995 2.92952C9.66586 3.38045 9.77895 3.88794 9.5917 4.44405C9.53961 4.59908 9.47215 4.74914 9.39911 4.93289Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10.5199 11.7114C9.57677 11.7114 8.63019 11.7114 7.64877 11.7114C7.3736 12.8461 6.77921 13.7623 5.75501 14.3449C4.95886 14.7977 4.10071 14.9512 3.18737 14.8034C1.50579 14.5315 0.130759 13.0139 0.00972502 11.3049C-0.127307 9.36903 1.19998 7.64825 2.96911 7.26172C3.09126 7.70643 3.21465 8.15537 3.3368 8.59896C1.71363 9.4292 1.15186 10.4753 1.60611 11.7833C2.00605 12.9344 3.14198 13.5654 4.37539 13.3213C5.63497 13.0722 6.27003 12.0227 6.19252 10.3385C7.38662 10.3385 8.58171 10.3261 9.77593 10.3446C10.2422 10.3519 10.6022 10.3035 10.9535 9.89132C11.5319 9.21312 12.5964 9.27429 13.2193 9.91481C13.8559 10.5694 13.8254 11.6227 13.1517 12.2496C12.5018 12.8546 11.475 12.8223 10.867 12.1704C10.742 12.036 10.6435 11.8765 10.5199 11.7114Z" }));
const APITokenIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 16 16' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M10 0H6V4H10V0Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M16 12H12V16H16V12Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M4 12H0V16H4V12Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M3 9H13V11H15V8C15 7.4 14.6 7 14 7H9V5H7V7H2C1.4 7 1 7.4 1 8V11H3V9Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M11 13H5V15H11V13Z" }));
const SubscriptionIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ width: "16", height: "16", viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M16 5V3C16 2.4 15.6 2 15 2H1C0.4 2 0 2.4 0 3V5H16Z", fill: "#ADBCD2" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M0 7V13C0 13.6 0.4 14 1 14H15C15.6 14 16 13.6 16 13V7H0ZM6 11H2V10H6V11ZM14 11H12V10H14V11Z", fill: "#ADBCD2" }));
const DrawerIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 24 24' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M3 18h13v-2H3v2zm0-5h10v-2H3v2zm0-7v2h13V6H3zm18 9.59L17.42 12 21 8.41 19.59 7l-5 5 5 5L21 15.59z" }));
const EyeIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 16 10' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M8.13582 0C4.80249 0 1.95582 2.07333 0.80249 5C1.95582 7.92667 4.80249 10 8.13582 10C11.4692 10 14.3158 7.92667 15.4692 5C14.3158 2.07333 11.4692 0 8.13582 0ZM8.13582 8.33333C6.29582 8.33333 4.80249 6.84 4.80249 5C4.80249 3.16 6.29582 1.66667 8.13582 1.66667C9.97582 1.66667 11.4692 3.16 11.4692 5C11.4692 6.84 9.97582 8.33333 8.13582 8.33333ZM8.13582 3C7.02916 3 6.13582 3.89333 6.13582 5C6.13582 6.10667 7.02916 7 8.13582 7C9.24249 7 10.1358 6.10667 10.1358 5C10.1358 3.89333 9.24249 3 8.13582 3Z" }));
const EyeVisibleIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 16 16' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M7.9999 14C11.5999 14 14.3999 10.9 15.5999 9.1C16.0999 8.4 16.0999 7.5 15.5999 6.8C14.3999 5.1 11.5999 2 7.9999 2C4.3999 2 1.5999 5.1 0.399902 6.9C-0.100098 7.6 -0.100098 8.5 0.399902 9.1C1.5999 10.9 4.3999 14 7.9999 14ZM7.9999 5C9.6999 5 10.9999 6.3 10.9999 8C10.9999 9.7 9.6999 11 7.9999 11C6.2999 11 4.9999 9.7 4.9999 8C4.9999 6.3 6.2999 5 7.9999 5Z" }));
const EyeInVisibleIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 16 16' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M14.5999 5.6L6.3999 13.8C6.8999 13.9 7.4999 14 7.9999 14C11.5999 14 14.3999 10.9 15.5999 9.1C16.0999 8.4 16.0999 7.5 15.5999 6.8C15.3999 6.5 14.9999 6.1 14.5999 5.6Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M14.3 0.3L11.6 3C10.5 2.4 9.3 2 8 2C4.4 2 1.6 5.1 0.4 6.9C-0.1 7.6 -0.1 8.5 0.4 9.1C0.9 9.9 1.8 10.9 2.8 11.8L0.3 14.3C-0.1 14.7 -0.1 15.3 0.3 15.7C0.5 15.9 0.7 16 1 16C1.3 16 1.5 15.9 1.7 15.7L15.7 1.7C16.1 1.3 16.1 0.7 15.7 0.3C15.3 -0.1 14.7 -0.1 14.3 0.3ZM5.3 9.3C5.1 8.9 5 8.5 5 8C5 6.3 6.3 5 8 5C8.5 5 8.9 5.1 9.3 5.3L5.3 9.3Z" }));
const CheckCircleFilledIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 24 24' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" }));
const CheckCircleOutlinedIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 24 24' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm4.59-12.42L10 14.17l-2.59-2.58L6 13l4 4 8-8z" }));
const CheckIcon$1 = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 8 7' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M6.86211 0.861946L2.66678 5.05728L1.13811 3.52861C1.01237 3.40717 0.843972 3.33998 0.669175 3.3415C0.494377 3.34302 0.327168 3.41313 0.203563 3.53673C0.0799575 3.66034 0.00984493 3.82755 0.00832598 4.00234C0.00680704 4.17714 0.0740033 4.34554 0.195442 4.47128L2.19544 6.47128C2.32046 6.59626 2.49 6.66647 2.66678 6.66647C2.84355 6.66647 3.01309 6.59626 3.13811 6.47128L7.80478 1.80461C7.92621 1.67888 7.99341 1.51048 7.99189 1.33568C7.99037 1.16088 7.92026 0.993672 7.79665 0.870067C7.67305 0.746461 7.50584 0.676349 7.33104 0.67483C7.15624 0.673311 6.98784 0.740507 6.86211 0.861946Z" }));
const LinkIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 16 16' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M2.60001 7.99984C2.60001 6.85984 3.52668 5.93317 4.66668 5.93317H7.33334V4.6665H4.66668C2.82668 4.6665 1.33334 6.15984 1.33334 7.99984C1.33334 9.83984 2.82668 11.3332 4.66668 11.3332H7.33334V10.0665H4.66668C3.52668 10.0665 2.60001 9.13984 2.60001 7.99984ZM5.33334 8.6665H10.6667V7.33317H5.33334V8.6665ZM11.3333 4.6665H8.66668V5.93317H11.3333C12.4733 5.93317 13.4 6.85984 13.4 7.99984C13.4 9.13984 12.4733 10.0665 11.3333 10.0665H8.66668V11.3332H11.3333C13.1733 11.3332 14.6667 9.83984 14.6667 7.99984C14.6667 6.15984 13.1733 4.6665 11.3333 4.6665Z" }));
const WarningIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 24 24' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M12 0C5.383 0 0 5.383 0 12C0 18.617 5.383 24 12 24C18.617 24 24 18.617 24 12C24 5.383 18.617 0 12 0ZM13.645 5L13 14H11L10.392 5H13.645ZM12 20C10.895 20 10 19.105 10 18C10 16.895 10.895 16 12 16C13.105 16 14 16.895 14 18C14 19.105 13.105 20 12 20Z" }));
const InfoIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 24 24' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M12 0C5.383 0 0 5.383 0 12C0 18.617 5.383 24 12 24C18.617 24 24 18.617 24 12C24 5.383 18.617 0 12 0ZM11.5 19C10.672 19 10 18.328 10 17.5C10 16.672 10.672 16 11.5 16C12.328 16 13 16.672 13 17.5C13 18.328 12.328 19 11.5 19ZM15.811 10.127C15.502 10.622 14.915 11.178 14.049 11.796C12.648 12.832 12.686 13.062 12.686 14H10.229C10.229 13.267 10.213 12.704 10.609 12.019C10.862 11.58 11.326 11.113 12 10.619C12.809 10.041 13.595 9.484 13.595 8.514C13.595 7.605 12.817 7.281 11.908 7.281C10.981 7.281 9.924 7.584 8.737 8.19L7.726 6.16C9.883 4.951 13.287 4.404 15.148 5.919C16.514 7.032 16.522 8.989 15.811 10.127Z" }));
const SuccessIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 24 24' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M12 0C9.62663 0 7.30655 0.703788 5.33316 2.02236C3.35977 3.34094 1.8217 5.21509 0.913451 7.4078C0.00519943 9.60051 -0.232441 12.0133 0.230582 14.3411C0.693605 16.6689 1.83649 18.8071 3.51472 20.4853C5.19295 22.1635 7.33115 23.3064 9.65892 23.7694C11.9867 24.2324 14.3995 23.9948 16.5922 23.0866C18.7849 22.1783 20.6591 20.6402 21.9776 18.6668C23.2962 16.6935 24 14.3734 24 12C23.9908 8.82024 22.7235 5.77336 20.4751 3.52492C18.2266 1.27648 15.1798 0.00923395 12 0V0ZM10 17.414L4.58601 12L6.00001 10.586L10 14.586L18 6.586L19.414 8L10 17.414Z" }));
const HorizontalMoreIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 12 12' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M6 7.5C6.82843 7.5 7.5 6.82843 7.5 6C7.5 5.17157 6.82843 4.5 6 4.5C5.17157 4.5 4.5 5.17157 4.5 6C4.5 6.82843 5.17157 7.5 6 7.5Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M10.5 7.5C11.3284 7.5 12 6.82843 12 6C12 5.17157 11.3284 4.5 10.5 4.5C9.67157 4.5 9 5.17157 9 6C9 6.82843 9.67157 7.5 10.5 7.5Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M1.5 7.5C2.32843 7.5 3 6.82843 3 6C3 5.17157 2.32843 4.5 1.5 4.5C0.671573 4.5 0 5.17157 0 6C0 6.82843 0.671573 7.5 1.5 7.5Z" }));
const GroupUsersIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 32 32' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M25 25C27.2091 25 29 23.2091 29 21C29 18.7909 27.2091 17 25 17C22.7909 17 21 18.7909 21 21C21 23.2091 22.7909 25 25 25Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M7 25C9.20914 25 11 23.2091 11 21C11 18.7909 9.20914 17 7 17C4.79086 17 3 18.7909 3 21C3 23.2091 4.79086 25 7 25Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M23 13.018C23 11.961 22.435 10.97 21.526 10.433C20.422 9.779 18.567 9 16 9C13.399 9 11.553 9.777 10.462 10.429C9.561 10.967 9 11.955 9 13.007V15H23V13.018Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M12.526 27.433C11.422 26.779 9.567 26 7 26C4.399 26 2.553 26.777 1.462 27.429C0.561 27.967 0 28.955 0 30.007V32H14V30.018C14 28.96 13.435 27.97 12.526 27.433Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M30.526 27.433C29.422 26.779 27.567 26 25 26C22.399 26 20.553 26.777 19.462 27.429C18.561 27.967 18 28.955 18 30.007V32H32V30.018C32 28.96 31.435 27.97 30.526 27.433Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M16 8C18.2091 8 20 6.20914 20 4C20 1.79086 18.2091 0 16 0C13.7909 0 12 1.79086 12 4C12 6.20914 13.7909 8 16 8Z" }));
const GlobeIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 32 32' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: 'M15.5,0C6.939,0,0,6.939,0,15.5S6.939,31,15.5,31S31,24.061,31,15.5S24.061,0,15.5,0z M28.975,15  h-5.996c-0.055-2.215-0.449-4.331-1.148-6.268c1.35-0.563,2.598-1.312,3.736-2.197C27.59,8.806,28.855,11.755,28.975,15z   M14.947,28.972c-1.662-1.384-3.056-3.181-4.076-5.268c1.309-0.409,2.696-0.633,4.129-0.679v5.949  C14.982,28.974,14.965,28.973,14.947,28.972z M16.051,2.028c1.886,1.57,3.425,3.673,4.466,6.126c-1.426,0.487-2.941,0.77-4.518,0.82  V2.025C16.018,2.026,16.034,2.027,16.051,2.028z M17.717,2.198c2.76,0.459,5.236,1.748,7.164,3.614  c-1.047,0.803-2.191,1.483-3.428,1.998C20.543,5.653,19.266,3.746,17.717,2.198z M15,2.025v6.949  c-1.577-0.051-3.093-0.333-4.518-0.82c1.041-2.453,2.58-4.556,4.466-6.126C14.966,2.027,14.982,2.026,15,2.025z M9.546,7.811  c-1.235-0.515-2.38-1.195-3.427-1.998c1.927-1.866,4.404-3.155,7.164-3.614C11.733,3.746,10.457,5.653,9.546,7.811z M10.105,9.076  C11.647,9.611,13.29,9.923,15,9.975V15H9.021C9.075,12.906,9.446,10.905,10.105,9.076z M15,16v6.025  c-1.577,0.048-3.102,0.306-4.539,0.769C9.595,20.732,9.084,18.435,9.021,16H15z M13.283,28.802  c-2.473-0.411-4.719-1.488-6.545-3.052c0.985-0.683,2.05-1.261,3.188-1.7C10.798,25.858,11.939,27.463,13.283,28.802z M16,28.975  v-5.949c1.432,0.046,2.82,0.27,4.129,0.679c-1.021,2.087-2.414,3.884-4.076,5.268C16.036,28.973,16.018,28.974,16,28.975z   M21.074,24.05c1.137,0.439,2.201,1.018,3.188,1.7c-1.826,1.563-4.072,2.641-6.545,3.052C19.061,27.463,20.201,25.858,21.074,24.05z   M20.539,22.794c-1.438-0.463-2.963-0.721-4.539-0.769V16h5.979C21.916,18.435,21.404,20.732,20.539,22.794z M16,15V9.975  c1.709-0.052,3.352-0.363,4.895-0.898c0.658,1.829,1.029,3.83,1.084,5.924H16z M5.434,6.535C6.572,7.42,7.82,8.169,9.169,8.732  C8.47,10.669,8.076,12.785,8.021,15H2.025C2.145,11.755,3.41,8.806,5.434,6.535z M2.025,16h5.996  c0.062,2.555,0.596,4.968,1.503,7.137c-1.267,0.494-2.448,1.152-3.538,1.931C3.638,22.731,2.156,19.536,2.025,16z M25.014,25.067  c-1.09-0.778-2.271-1.437-3.539-1.931c0.908-2.169,1.441-4.582,1.504-7.137h5.996C28.844,19.536,27.361,22.731,25.014,25.067z', fill: '#333332' }));
const PdfIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 21 21' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { transform: 'translate(0 0)' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: 'M22.267,14.586a.909.909,0,0,0-.895.895V26.124a1.611,1.611,0,0,1-1.6,1.6H7.319a1.611,1.611,0,0,1-1.6-1.6V13.667a1.611,1.611,0,0,1,1.6-1.6H17.744a.895.895,0,0,0,0-1.79H7.319a3.4,3.4,0,0,0-3.386,3.386V26.124A3.4,3.4,0,0,0,7.319,29.51H19.776a3.4,3.4,0,0,0,3.386-3.386V15.481A.893.893,0,0,0,22.267,14.586Z', transform: 'translate(-3.933 -8.032)' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: 'M37.119,3.864a.895.895,0,0,0,0,1.79h3.048L31.821,14a.906.906,0,0,0,0,1.258.876.876,0,0,0,1.258,0l8.441-8.441V9.863a.895.895,0,1,0,1.79,0v-6Z', transform: 'translate(-21.88 -3.864)' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: 'M12.834,40.572H14.7a3.351,3.351,0,0,1,.726.073,1.513,1.513,0,0,1,.6.242,1.256,1.256,0,0,1,.411.46,1.887,1.887,0,0,1,0,1.451,1.273,1.273,0,0,1-.387.484,1.556,1.556,0,0,1-.581.242,3.352,3.352,0,0,1-.726.073h-.8V45.53H12.858V40.572Zm1.088,2.1h.726a1.178,1.178,0,0,0,.29-.024.724.724,0,0,0,.242-.1.448.448,0,0,0,.169-.194.516.516,0,0,0,.073-.29.5.5,0,0,0-.314-.484.67.67,0,0,0-.314-.073c-.121,0-.218-.024-.314-.024h-.556v1.185Z', transform: 'translate(-9.714 -27.704)' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: 'M25.461,40.572h1.645a4.439,4.439,0,0,1,1.137.145,2.823,2.823,0,0,1,.943.435,1.98,1.98,0,0,1,.629.774,2.426,2.426,0,0,1,.242,1.161,2.46,2.46,0,0,1-.218,1.064,2.393,2.393,0,0,1-.6.774,2.906,2.906,0,0,1-.895.484,3.915,3.915,0,0,1-1.064.169h-1.79V40.572Zm1.088,3.967h.581a3.283,3.283,0,0,0,.7-.073,1.326,1.326,0,0,0,.556-.266,1.113,1.113,0,0,0,.387-.484,1.615,1.615,0,0,0,.145-.726,1.272,1.272,0,0,0-.145-.629,1.3,1.3,0,0,0-.363-.435,1.7,1.7,0,0,0-.556-.266,2.7,2.7,0,0,0-.653-.073h-.653Z', transform: 'translate(-17.914 -27.704)' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: 'M40.848,40.572h3.338v1.016H41.936V42.6h2.08V43.62h-2.08v1.935H40.848Z', transform: 'translate(-27.908 -27.704)' })));

const UploadIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 12 12' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M10 7V10H2V7H0V11C0 11.2652 0.105357 11.5196 0.292893 11.7071C0.48043 11.8946 0.734784 12 1 12H11C11.2652 12 11.5196 11.8946 11.7071 11.7071C11.8946 11.5196 12 11.2652 12 11V7H10Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M5 8H7V4H9.5L6 0L2.5 4H5V8Z" }));
const SearchIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 16 16' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M7 14C3.14 14 0 10.86 0 7C0 3.14 3.14 0 7 0C10.86 0 14 3.14 14 7C14 10.86 10.86 14 7 14ZM7 2C4.243 2 2 4.243 2 7C2 9.757 4.243 12 7 12C9.757 12 12 9.757 12 7C12 4.243 9.757 2 7 2Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M15.7074 14.2929L13.3144 11.8999C12.9034 12.4289 12.4294 12.9029 11.9004 13.3139L14.2934 15.7069C14.4884 15.9019 14.7444 15.9999 15.0004 15.9999C15.2564 15.9999 15.5124 15.9019 15.7074 15.7069C16.0984 15.3159 16.0984 14.6839 15.7074 14.2929Z" }));
const SearchBigIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 32 32' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M7 13H5C5.00238 10.879 5.846 8.84555 7.34578 7.34578C8.84555 5.846 10.879 5.00238 13 5V7C11.4092 7.00159 9.88399 7.63424 8.75911 8.75911C7.63424 9.88399 7.00159 11.4092 7 13Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M30.414 27.5861L24.2 21.3691C23.3959 22.4428 22.4426 23.3961 21.369 24.2001L27.586 30.4171C27.9632 30.7815 28.4684 30.983 28.9928 30.9785C29.5172 30.9739 30.0188 30.7636 30.3896 30.3928C30.7605 30.022 30.9708 29.5203 30.9754 28.9959C30.9799 28.4715 30.7783 27.9663 30.414 27.5891V27.5861Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M13 25C10.6266 25 8.30655 24.2962 6.33316 22.9776C4.35977 21.6591 2.8217 19.7849 1.91345 17.5922C1.0052 15.3995 0.767559 12.9867 1.23058 10.6589C1.6936 8.33115 2.83649 6.19295 4.51472 4.51472C6.19295 2.83649 8.33115 1.6936 10.6589 1.23058C12.9867 0.767559 15.3995 1.0052 17.5922 1.91345C19.7849 2.8217 21.6591 4.35977 22.9776 6.33316C24.2962 8.30655 25 10.6266 25 13C24.9966 16.1815 23.7312 19.2318 21.4815 21.4815C19.2318 23.7312 16.1815 24.9966 13 25ZM13 3.00001C11.0222 3.00001 9.08879 3.58649 7.4443 4.68531C5.79981 5.78412 4.51809 7.34591 3.76121 9.17317C3.00433 11.0004 2.8063 13.0111 3.19215 14.9509C3.578 16.8907 4.53041 18.6725 5.92894 20.0711C7.32746 21.4696 9.10929 22.422 11.0491 22.8079C12.9889 23.1937 14.9996 22.9957 16.8268 22.2388C18.6541 21.4819 20.2159 20.2002 21.3147 18.5557C22.4135 16.9112 23 14.9778 23 13C22.9971 10.3487 21.9426 7.80689 20.0679 5.93215C18.1931 4.05742 15.6513 3.00292 13 3.00001Z" }));
const EditIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 12 12' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M9 10H2V3H4V1H1C0.734784 1 0.48043 1.10536 0.292893 1.29289C0.105357 1.48043 0 1.73478 0 2L0 11C0 11.2652 0.105357 11.5196 0.292893 11.7071C0.48043 11.8946 0.734784 12 1 12H10C10.2652 12 10.5196 11.8946 10.7071 11.7071C10.8946 11.5196 11 11.2652 11 11V8H9V10Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M11.581 0.412885C11.4501 0.281842 11.2947 0.177882 11.1236 0.106951C10.9526 0.036021 10.7692 -0.000488281 10.584 -0.000488281C10.3988 -0.000488281 10.2154 0.036021 10.0444 0.106951C9.87328 0.177882 9.71786 0.281842 9.587 0.412885L5 4.99989L4 7.99989L7 6.99989L11.587 2.41289C11.718 2.28202 11.822 2.12661 11.8929 1.95553C11.9639 1.78446 12.0004 1.60108 12.0004 1.41589C12.0004 1.23069 11.9639 1.04731 11.8929 0.876236C11.822 0.705161 11.718 0.549748 11.587 0.418885L11.581 0.412885Z" }));
const PencilIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 19 19' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M0 15.2501V19.0001H3.75L14.81 7.94006L11.06 4.19006L0 15.2501ZM17.71 5.04006C18.1 4.65006 18.1 4.02006 17.71 3.63006L15.37 1.29006C14.98 0.900059 14.35 0.900059 13.96 1.29006L12.13 3.12006L15.88 6.87006L17.71 5.04006Z" }));
const CloseIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ "data-test-id": "X-btn", viewBox: '0 0 8 8' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M7.13797 0.862061C7.01295 0.73708 6.84342 0.66687 6.66664 0.66687C6.48986 0.66687 6.32032 0.73708 6.19531 0.862061L3.99997 3.05739L1.80464 0.862061C1.6789 0.740622 1.5105 0.673426 1.33571 0.674945C1.16091 0.676464 0.993699 0.746577 0.870094 0.870182C0.746488 0.993787 0.676376 1.161 0.674857 1.33579C0.673338 1.51059 0.740534 1.67899 0.861973 1.80473L3.05731 4.00006L0.861973 6.19539C0.798299 6.25689 0.747511 6.33046 0.712572 6.41179C0.677632 6.49313 0.659242 6.58061 0.658472 6.66913C0.657703 6.75765 0.674571 6.84543 0.708092 6.92736C0.741612 7.00929 0.791114 7.08373 0.853709 7.14632C0.916304 7.20892 0.990739 7.25842 1.07267 7.29194C1.1546 7.32546 1.24239 7.34233 1.33091 7.34156C1.41943 7.34079 1.50691 7.3224 1.58824 7.28746C1.66958 7.25252 1.74314 7.20173 1.80464 7.13806L3.99997 4.94273L6.19531 7.13806C6.32104 7.2595 6.48944 7.3267 6.66424 7.32518C6.83904 7.32366 7.00625 7.25355 7.12985 7.12994C7.25346 7.00633 7.32357 6.83913 7.32509 6.66433C7.32661 6.48953 7.25941 6.32113 7.13797 6.19539L4.94264 4.00006L7.13797 1.80473C7.26295 1.67971 7.33316 1.51017 7.33316 1.33339C7.33316 1.15662 7.26295 0.98708 7.13797 0.862061Z" }));
const CopyIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 12 12' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M9 1C9 0.734784 8.89464 0.48043 8.70711 0.292893C8.51957 0.105357 8.26522 0 8 0L1 0C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.48043 0 0.734784 0 1L0 9C0 9.26522 0.105357 9.51957 0.292893 9.70711C0.48043 9.89464 0.734784 10 1 10H4.5V4.5C4.5 4.23478 4.60536 3.98043 4.79289 3.79289C4.98043 3.60536 5.23478 3.5 5.5 3.5H9V1Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M11.5 5H6.5C6.22386 5 6 5.22386 6 5.5V11.5C6 11.7761 6.22386 12 6.5 12H11.5C11.7761 12 12 11.7761 12 11.5V5.5C12 5.22386 11.7761 5 11.5 5Z" }));
const CheckedIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 12 12' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M10.293 1.29298L4 7.58598L1.707 5.29298C1.5184 5.11082 1.26579 5.01003 1.0036 5.01231C0.741401 5.01458 0.490589 5.11975 0.30518 5.30516C0.119772 5.49057 0.0146034 5.74138 0.0123249 6.00358C0.0100465 6.26578 0.110841 6.51838 0.292999 6.70698L3.293 9.70698C3.48053 9.89445 3.73483 9.99977 4 9.99977C4.26516 9.99977 4.51947 9.89445 4.707 9.70698L11.707 2.70698C11.8892 2.51838 11.99 2.26578 11.9877 2.00358C11.9854 1.74138 11.8802 1.49057 11.6948 1.30516C11.5094 1.11975 11.2586 1.01458 10.9964 1.01231C10.7342 1.01003 10.4816 1.11082 10.293 1.29298Z" }));
const MoreIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 4 16' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4ZM2 6C0.9 6 0 6.9 0 8C0 9.1 0.9 10 2 10C3.1 10 4 9.1 4 8C4 6.9 3.1 6 2 6ZM2 12C0.9 12 0 12.9 0 14C0 15.1 0.9 16 2 16C3.1 16 4 15.1 4 14C4 12.9 3.1 12 2 12Z" }));
const DeleteIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 12 12' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M8 0H4V2H1V4H11V2H8V0Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M8 10H4V6H2V11C2 11.2652 2.10536 11.5196 2.29289 11.7071C2.48043 11.8946 2.73478 12 3 12H9C9.26522 12 9.51957 11.8946 9.70711 11.7071C9.89464 11.5196 10 11.2652 10 11V6H8V10Z" }));
const ResendIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 12 12' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M8 0H6V2H8C8.53043 2 9.03914 2.21071 9.41421 2.58579C9.78929 2.96086 10 3.46957 10 4C10 4.53043 9.78929 5.03914 9.41421 5.41421C9.03914 5.78929 8.53043 6 8 6H5V3L0 7L5 11V8H8C9.06087 8 10.0783 7.57857 10.8284 6.82843C11.5786 6.07828 12 5.06087 12 4C12 2.93913 11.5786 1.92172 10.8284 1.17157C10.0783 0.421427 9.06087 0 8 0V0Z" }));
const CrossIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 11 11' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M10.7071 0.292786C10.5196 0.105315 10.2652 0 10.0001 0C9.73492 0 9.48061 0.105315 9.29308 0.292786L6.00008 3.58579L2.70708 0.292786C2.51848 0.110628 2.26588 0.00983408 2.00368 0.0121125C1.74148 0.0143909 1.49067 0.11956 1.30526 0.304968C1.11985 0.490376 1.01469 0.741188 1.01241 1.00339C1.01013 1.26558 1.11092 1.51818 1.29308 1.70679L4.58608 4.99979L1.29308 8.29279C1.19757 8.38503 1.12139 8.49538 1.06898 8.61738C1.01657 8.73939 0.988985 8.87061 0.987831 9.00339C0.986677 9.13616 1.01198 9.26784 1.06226 9.39074C1.11254 9.51364 1.18679 9.62529 1.28069 9.71918C1.37458 9.81307 1.48623 9.88733 1.60913 9.93761C1.73202 9.98789 1.8637 10.0132 1.99648 10.012C2.12926 10.0109 2.26048 9.9833 2.38249 9.93089C2.50449 9.87848 2.61483 9.8023 2.70708 9.70679L6.00008 6.41379L9.29308 9.70679C9.48168 9.88894 9.73429 9.98974 9.99648 9.98746C10.2587 9.98518 10.5095 9.88001 10.6949 9.6946C10.8803 9.5092 10.9855 9.25838 10.9878 8.99619C10.99 8.73399 10.8892 8.48139 10.7071 8.29279L7.41408 4.99979L10.7071 1.70679C10.8946 1.51926 10.9999 1.26495 10.9999 0.999786C10.9999 0.734622 10.8946 0.480314 10.7071 0.292786Z" }));
const CrossBtnIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 12 12' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M6 0C2.7 0 0 2.7 0 6C0 9.3 2.7 12 6 12C9.3 12 12 9.3 12 6C12 2.7 9.3 0 6 0ZM8.625 7.575L7.575 8.625L6 7.05L4.425 8.625L3.375 7.575L4.95 6L3.375 4.425L4.425 3.375L6 4.95L7.575 3.375L8.625 4.425L7.05 6L8.625 7.575Z" }));
const FilterIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 12 12' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M0.5 1.5H11.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M5 10.5H7", strokeLinecap: "round", strokeLinejoin: "round" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M2 4.5H10", strokeLinecap: "round", strokeLinejoin: "round" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M3.5 7.5H8.5", strokeLinecap: "round", strokeLinejoin: "round" }));
const AddIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 12 12' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M11 5H7V1C7 0.734784 6.89464 0.48043 6.70711 0.292893C6.51957 0.105357 6.26522 0 6 0C5.73478 0 5.48043 0.105357 5.29289 0.292893C5.10536 0.48043 5 0.734784 5 1V5H1C0.734784 5 0.48043 5.10536 0.292893 5.29289C0.105357 5.48043 0 5.73478 0 6C0 6.26522 0.105357 6.51957 0.292893 6.70711C0.48043 6.89464 0.734784 7 1 7H5V11C5 11.2652 5.10536 11.5196 5.29289 11.7071C5.48043 11.8946 5.73478 12 6 12C6.26522 12 6.51957 11.8946 6.70711 11.7071C6.89464 11.5196 7 11.2652 7 11V7H11C11.2652 7 11.5196 6.89464 11.7071 6.70711C11.8946 6.51957 12 6.26522 12 6C12 5.73478 11.8946 5.48043 11.7071 5.29289C11.5196 5.10536 11.2652 5 11 5Z" }));

const ArrowDownIcon = (props) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 12 12' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M10.293 3.29299L6.00001 7.58599L1.70701 3.29299C1.51841 3.11083 1.26581 3.01004 1.00361 3.01232C0.741412 3.01459 0.4906 3.11976 0.305192 3.30517C0.119784 3.49058 0.0146148 3.74139 0.0123364 4.00359C0.010058 4.26579 0.110852 4.51839 0.29301 4.70699L5.29301 9.70699C5.48054 9.89446 5.73485 9.99978 6.00001 9.99978C6.26517 9.99978 6.51948 9.89446 6.70701 9.70699L11.707 4.70699C11.8025 4.61474 11.8787 4.5044 11.9311 4.38239C11.9835 4.26039 12.0111 4.12917 12.0123 3.99639C12.0134 3.86361 11.9881 3.73193 11.9378 3.60904C11.8876 3.48614 11.8133 3.37449 11.7194 3.28059C11.6255 3.1867 11.5139 3.11245 11.391 3.06217C11.2681 3.01189 11.1364 2.98659 11.0036 2.98774C10.8708 2.98889 10.7396 3.01648 10.6176 3.06889C10.4956 3.1213 10.3853 3.19748 10.293 3.29299Z" }));
const ArrowRightIcon = (props) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '4 4 16 16' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" }));
const DoubleArrowRightIcon = (props) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 8 8' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M4.47171 3.52829L1.13838 0.194954C1.01264 0.073515 0.844243 0.00631876 0.669446 0.0078377C0.494648 0.00935665 0.327439 0.0794693 0.203834 0.203075C0.0802285 0.32668 0.0101159 0.493888 0.00859695 0.668686C0.007078 0.843484 0.0742743 1.01189 0.195713 1.13762L3.05771 3.99962L0.195713 6.86162C0.13204 6.92312 0.0812514 6.99668 0.046312 7.07802C0.0113727 7.15935 -0.00701812 7.24683 -0.00778733 7.33535C-0.00855654 7.42387 0.00831127 7.51166 0.0418319 7.59359C0.0753524 7.67552 0.124855 7.74996 0.18745 7.81255C0.250045 7.87515 0.324479 7.92465 0.40641 7.95817C0.488341 7.99169 0.576128 8.00856 0.664647 8.00779C0.753167 8.00702 0.840647 7.98863 0.921983 7.95369C1.00332 7.91875 1.07688 7.86796 1.13838 7.80429L4.47171 4.47095C4.59669 4.34594 4.6669 4.1764 4.6669 3.99962C4.6669 3.82284 4.59669 3.65331 4.47171 3.52829Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M4.47236 0.194954C4.34663 0.073515 4.17823 0.00631876 4.00343 0.0078377C3.82863 0.00935665 3.66142 0.0794693 3.53782 0.203075C3.41421 0.32668 3.3441 0.493888 3.34258 0.668686C3.34106 0.843484 3.40826 1.01189 3.5297 1.13762L6.3917 3.99962L3.5297 6.86162C3.46602 6.92312 3.41524 6.99668 3.3803 7.07802C3.34536 7.15935 3.32697 7.24683 3.3262 7.33535C3.32543 7.42387 3.3423 7.51166 3.37582 7.59359C3.40934 7.67552 3.45884 7.74996 3.52143 7.81255C3.58403 7.87515 3.65846 7.92465 3.74039 7.95817C3.82233 7.99169 3.91011 8.00856 3.99863 8.00779C4.08715 8.00702 4.17463 7.98863 4.25597 7.95369C4.3373 7.91875 4.41087 7.86796 4.47236 7.80429L7.8057 4.47095C7.93068 4.34594 8.00089 4.1764 8.00089 3.99962C8.00089 3.82284 7.93068 3.65331 7.8057 3.52829L4.47236 0.194954Z" }));
const DoubleArrowLeftIcon = (props) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 8 8', transform: 'rotate(180)' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M4.47171 3.52829L1.13838 0.194954C1.01264 0.073515 0.844243 0.00631876 0.669446 0.0078377C0.494648 0.00935665 0.327439 0.0794693 0.203834 0.203075C0.0802285 0.32668 0.0101159 0.493888 0.00859695 0.668686C0.007078 0.843484 0.0742743 1.01189 0.195713 1.13762L3.05771 3.99962L0.195713 6.86162C0.13204 6.92312 0.0812514 6.99668 0.046312 7.07802C0.0113727 7.15935 -0.00701812 7.24683 -0.00778733 7.33535C-0.00855654 7.42387 0.00831127 7.51166 0.0418319 7.59359C0.0753524 7.67552 0.124855 7.74996 0.18745 7.81255C0.250045 7.87515 0.324479 7.92465 0.40641 7.95817C0.488341 7.99169 0.576128 8.00856 0.664647 8.00779C0.753167 8.00702 0.840647 7.98863 0.921983 7.95369C1.00332 7.91875 1.07688 7.86796 1.13838 7.80429L4.47171 4.47095C4.59669 4.34594 4.6669 4.1764 4.6669 3.99962C4.6669 3.82284 4.59669 3.65331 4.47171 3.52829Z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M4.47236 0.194954C4.34663 0.073515 4.17823 0.00631876 4.00343 0.0078377C3.82863 0.00935665 3.66142 0.0794693 3.53782 0.203075C3.41421 0.32668 3.3441 0.493888 3.34258 0.668686C3.34106 0.843484 3.40826 1.01189 3.5297 1.13762L6.3917 3.99962L3.5297 6.86162C3.46602 6.92312 3.41524 6.99668 3.3803 7.07802C3.34536 7.15935 3.32697 7.24683 3.3262 7.33535C3.32543 7.42387 3.3423 7.51166 3.37582 7.59359C3.40934 7.67552 3.45884 7.74996 3.52143 7.81255C3.58403 7.87515 3.65846 7.92465 3.74039 7.95817C3.82233 7.99169 3.91011 8.00856 3.99863 8.00779C4.08715 8.00702 4.17463 7.98863 4.25597 7.95369C4.3373 7.91875 4.41087 7.86796 4.47236 7.80429L7.8057 4.47095C7.93068 4.34594 8.00089 4.1764 8.00089 3.99962C8.00089 3.82284 7.93068 3.65331 7.8057 3.52829L4.47236 0.194954Z" }));
const SortArrows = (props) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 12 12' }, props, { fill: "none" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M9.5 8.5L6 11.5L2.5 8.5", stroke: "#ADBCD2", strokeLinecap: "round", strokeLinejoin: "round" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M2.5 3.5L6 0.5L9.5 3.5", stroke: "#ADBCD2", strokeLinecap: "round", strokeLinejoin: "round" }));
const SortArrowsDown = (props) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 12 12' }, props, { fill: "none" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M9.5 8.5L6 11.5L2.5 8.5", stroke: "#3C4A5A", strokeLinecap: "round", strokeLinejoin: "round" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M2.5 3.5L6 0.5L9.5 3.5", stroke: "#ADBCD2", strokeLinecap: "round", strokeLinejoin: "round" }));
const SortArrowsUp = (props) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 12 12' }, props, { fill: "none" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M9.5 8.5L6 11.5L2.5 8.5", stroke: "#ADBCD2", strokeLinecap: "round", strokeLinejoin: "round" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M2.5 3.5L6 0.5L9.5 3.5", stroke: "#3C4A5A", strokeLinecap: "round", strokeLinejoin: "round" }));

const CheckboxBaseIcon = (props) => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: "0 0 24 24" }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { x: "1", y: "1", width: "22", height: "22", rx: "3", strokeWidth: "2" })));
const CheckboxCheckedIcon = (props) => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: "0 0 24 25" }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { filter: "url(#filter0_d)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "24", height: "24", rx: "4" }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { x: "0.5", y: "0.5", width: "23", height: "23", rx: "3.5" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M16.2929 7.293L9.99992 13.586L7.70692 11.293C7.51832 11.1108 7.26571 11.01 7.00352 11.0123C6.74132 11.0146 6.49051 11.1198 6.3051 11.3052C6.11969 11.4906 6.01452 11.7414 6.01224 12.0036C6.00997 12.2658 6.11076 12.5184 6.29292 12.707L9.29292 15.707C9.48045 15.8945 9.73475 15.9998 9.99992 15.9998C10.2651 15.9998 10.5194 15.8945 10.7069 15.707L17.7069 8.707C17.8891 8.5184 17.9899 8.2658 17.9876 8.0036C17.9853 7.7414 17.8801 7.49059 17.6947 7.30518C17.5093 7.11977 17.2585 7.0146 16.9963 7.01233C16.7341 7.01005 16.4815 7.11084 16.2929 7.293Z", fill: "white" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("defs", null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("filter", { id: "filter0_d", x: "0", y: "0", width: "24", height: "25", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feOffset", { dy: "1" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.937255 0 0 0 0 0.94902 0 0 0 0 0.960784 0 0 0 1 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow", result: "shape" })))));
const CheckboxIndeterminateIcon = (props) => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: "0 0 24 25" }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { filter: "url(#filter0_d)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "24", height: "24", rx: "4", fill: "#43BB7A" }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { x: "0.5", y: "0.5", width: "23", height: "23", rx: "3.5", stroke: "#36A76A" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { x: "5", y: "11", width: "14", height: "2.5", rx: "1", fill: "white" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("defs", null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("filter", { id: "filter0_d", x: "0", y: "0", width: "24", height: "25", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feOffset", { dy: "1" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0.937255 0 0 0 0 0.94902 0 0 0 0 0.960784 0 0 0 1 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow", result: "shape" })))));

const RadioCheckedIcon = (props) => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: "0 0 16 16" }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { x: "1", y: "1", width: "14", height: "14", rx: "7", fill: "white", stroke: "currentColor", strokeWidth: "2" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { x: "4", y: "4", width: "8", height: "8", rx: "4", fill: "currentColor" }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { x: "4.5", y: "4.5", width: "7", height: "7", rx: "3.5", stroke: "currentColor" }))));
const RadioIcon = (props) => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: "0 0 16 16" }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { x: "1", y: "1", width: "14", height: "14", rx: "7", strokeWidth: "2" })));

const VisaCardIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 40 24' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M0 4C0 1.79086 1.79086 0 4 0H36C38.2091 0 40 1.79086 40 4V20C40 22.2091 38.2091 24 36 24H4C1.79086 24 0 22.2091 0 20V4Z", fill: "#172B85" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.7503 15.938H10.4136L8.66138 9.73185C8.57821 9.44637 8.40162 9.19399 8.14186 9.07503C7.49361 8.7761 6.77927 8.5382 6 8.41821V8.17928H9.76421C10.2837 8.17928 10.6734 8.5382 10.7383 8.95505L11.6475 13.4318L13.983 8.17928H16.2547L12.7503 15.938ZM17.5533 15.938H15.3465L17.1637 8.17928H19.3705L17.5533 15.938ZM22.2257 10.3283C22.2907 9.91047 22.6803 9.67153 23.1349 9.67153C23.8492 9.61154 24.6273 9.73152 25.2767 10.0294L25.6664 8.35892C25.017 8.11999 24.3026 8 23.6544 8C21.5125 8 19.954 9.0747 19.954 10.5663C19.954 11.7009 21.0579 12.2967 21.8372 12.6557C22.6803 13.0136 23.005 13.2525 22.9401 13.6104C22.9401 14.1472 22.2907 14.3862 21.6424 14.3862C20.8631 14.3862 20.0839 14.2072 19.3707 13.9083L18.981 15.5798C19.7603 15.8777 20.6034 15.9977 21.3826 15.9977C23.7843 16.0566 25.2767 14.983 25.2767 13.3714C25.2767 11.342 22.2257 11.2231 22.2257 10.3283ZM32.9999 15.938L31.2477 8.17928H29.3656C28.9759 8.17928 28.5863 8.41821 28.4564 8.7761L25.2117 15.938H27.4835L27.9369 14.8044H30.7282L30.9879 15.938H32.9999ZM29.6903 10.2688L30.3386 13.1929H28.5214L29.6903 10.2688Z", fill: "white" }));
const AmericanExpressIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 40 24' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M2.05128 0H37.9487C39.0816 0 40 0.859632 40 1.92V22.08C40 23.1404 39.0816 24 37.9487 24H2.05128C0.91841 24 0 23.1404 0 22.08V1.92C0 0.859632 0.91841 0 2.05128 0Z", fill: "#2557D6" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M0.000256578 11.2676H1.92157L2.35478 10.2694H3.32464L3.75672 11.2676H7.53705V10.5045L7.8745 11.2709H9.83697L10.1744 10.4932V11.2676H19.5693L19.5649 9.62917H19.7467C19.8739 9.63341 19.9111 9.64462 19.9111 9.84537V11.2676H24.7702V10.8862C25.1622 11.0868 25.7717 11.2676 26.5738 11.2676H28.618L29.0555 10.2695H30.0253L30.4532 11.2676H34.3924V10.3195L34.989 11.2676H38.1457V5H35.0216V5.74018L34.5843 5H31.3785V5.74018L30.9768 5H26.6468C25.9221 5 25.285 5.09664 24.7703 5.36595V5H21.7822V5.36595C21.4546 5.08835 21.0084 5 20.5121 5H9.59522L8.86274 6.61876L8.1105 5H4.67209V5.74018L4.29431 5H1.36187L0 7.97987V11.2675H0.000153947L0.000256578 11.2676ZM12.1282 10.3636H10.9755L10.9712 6.84406L9.34064 10.3635H8.35333L6.71851 6.84094V10.3635H4.43137L3.99929 9.36119H1.65791L1.22147 10.3635H0.000102632L2.01378 5.86977H3.68457L5.59706 10.1244V5.86977H7.43242L8.90405 8.91825L10.2559 5.86977H12.1282L12.1282 10.3636ZM3.61494 8.42854L2.8453 6.63707L2.07993 8.42854H3.61494ZM16.7158 10.3635H12.9594V5.86972H16.7158V6.80549H14.0839V7.61551H16.6528V8.53664H14.0839V9.43409H16.7158L16.7158 10.3635ZM22.0096 7.08001C22.0096 7.79646 21.509 8.16665 21.2173 8.27777C21.4633 8.3672 21.6736 8.52529 21.7736 8.6562C21.9323 8.87972 21.9597 9.07935 21.9597 9.4807V10.3635H20.8255L20.8212 9.79677C20.8212 9.52639 20.8483 9.13752 20.6438 8.92132C20.4794 8.76323 20.229 8.72895 19.8241 8.72895H18.617V10.3635H17.4925V5.86972H20.0788C20.6535 5.86972 21.077 5.8842 21.4405 6.08495C21.7963 6.2857 22.0096 6.57875 22.0096 7.08001ZM20.5882 7.74724C20.4336 7.83688 20.2509 7.83984 20.0319 7.83984H18.6658V6.84171H20.0504C20.2464 6.84171 20.4509 6.8501 20.5838 6.92275C20.7296 6.98823 20.8199 7.12754 20.8199 7.32001C20.8199 7.51646 20.734 7.67449 20.5882 7.74724ZM23.8131 10.3635H22.6657V5.86972H23.8131V10.3635ZM37.1326 10.3635H35.5391L33.4077 6.99064V10.3635H31.1176L30.68 9.36114H28.344L27.9196 10.3635H26.6035C26.057 10.3635 25.3648 10.248 24.973 9.86645C24.5778 9.48489 24.3722 8.96808 24.3722 8.1509C24.3722 7.48443 24.4951 6.87517 24.9783 6.3937C25.3419 6.03507 25.9113 5.86972 26.6861 5.86972H27.7748V6.8326H26.7089C26.2985 6.8326 26.0668 6.89093 25.8436 7.09879C25.652 7.28803 25.5204 7.64569 25.5204 8.11672C25.5204 8.59814 25.6206 8.94531 25.8295 9.17205C26.0026 9.34988 26.3173 9.40381 26.6132 9.40381H27.1183L28.7031 5.86987H30.3881L32.292 10.1203V5.86993H34.0042L35.9808 8.99959V5.86993H37.1326V10.3635ZM30.2973 8.42859L29.5191 6.63712L28.7452 8.42859H30.2973ZM39.998 17.5392C39.7249 17.9207 39.1927 18.1141 38.4721 18.1141H36.3005V17.1503H38.4633C38.6778 17.1503 38.8279 17.1233 38.9184 17.039C39.0038 16.9636 39.052 16.8572 39.0513 16.7459C39.0513 16.6149 38.9967 16.5109 38.914 16.4486C38.8324 16.3799 38.7136 16.3488 38.5177 16.3488C37.4619 16.3146 36.1446 16.3799 36.1446 14.9576C36.1446 14.3057 36.5779 13.6194 37.758 13.6194H39.9978V12.7252H37.9166C37.2887 12.7252 36.8324 12.869 36.5093 13.0922V12.7252H33.4311C32.9387 12.7252 32.361 12.8418 32.0877 13.0922V12.7252H26.5908V13.0922C26.1534 12.7908 25.4152 12.7252 25.0745 12.7252H21.4487V13.0922C21.1026 12.7721 20.333 12.7252 19.8638 12.7252H15.8059L14.8774 13.6851L14.0076 12.7252H7.94568V18.9969H13.8932L14.85 18.0217L15.7514 18.9969L19.4175 19V17.5246H19.7778C20.2642 17.5318 20.8379 17.513 21.3441 17.304V18.9967H24.368V17.362H24.5138C24.7 17.362 24.7183 17.3694 24.7183 17.547V18.9965H33.9044C34.4875 18.9965 35.0971 18.8539 35.4348 18.5951V18.9965H38.3485C38.9548 18.9965 39.5469 18.9153 39.9975 18.7075L39.9976 17.539L39.998 17.5392ZM21.784 15.1267C21.784 16.3753 20.8088 16.6331 19.8259 16.6331H18.4228V18.1408H16.2372L14.8525 16.6527L13.4135 18.1408H8.95916V13.6459H13.4819L14.8654 15.1193L16.2958 13.6459H19.889C20.7813 13.6459 21.784 13.8819 21.784 15.1267ZM12.8438 17.1953H10.079V16.3011H12.5478V15.384H10.079V14.5667H12.8983L14.1282 15.8766L12.8438 17.1953ZM17.2985 17.71L15.5721 15.879L17.2985 14.1063V17.71ZM19.8519 15.7114H18.3987V14.5667H19.8649C20.2709 14.5667 20.5527 14.7248 20.5527 15.1178C20.5527 15.5066 20.2839 15.7114 19.8519 15.7114ZM27.4651 13.6459H31.2182V14.5755H28.5849V15.3927H31.1539V16.3097H28.5849V17.204L31.2181 17.2081V18.1408H27.465L27.4651 13.6459ZM26.0221 16.0519C26.2724 16.1402 26.477 16.2983 26.5729 16.4292C26.7318 16.6487 26.7547 16.8535 26.7593 17.2497V18.1408H25.6302V17.5784C25.6302 17.308 25.6575 16.9076 25.4484 16.6986C25.2842 16.5376 25.0337 16.4991 24.6235 16.4991H23.4217V18.1408H22.2917V13.6459H24.888C25.4572 13.6459 25.8719 13.67 26.241 13.8581C26.5958 14.0629 26.8191 14.3434 26.8191 14.8562C26.819 15.5736 26.318 15.9397 26.0221 16.0519ZM25.3866 15.4837C25.2361 15.569 25.0501 15.5763 24.8314 15.5763H23.4653V14.5668H24.8499C25.0501 14.5668 25.2505 14.5709 25.3866 14.648C25.5323 14.7208 25.6194 14.8601 25.6194 15.0523C25.6194 15.2446 25.5322 15.3995 25.3866 15.4837ZM35.5378 15.77C35.757 15.9864 35.8742 16.2597 35.8742 16.7223C35.8742 17.6892 35.2418 18.1406 34.1076 18.1406H31.9175V17.1767H34.0989C34.3122 17.1767 34.4634 17.1498 34.5582 17.0654C34.6356 16.996 34.691 16.8949 34.691 16.7723C34.691 16.6413 34.631 16.5374 34.5538 16.475C34.4678 16.4065 34.3492 16.3753 34.1533 16.3753C33.1017 16.3411 31.7848 16.4065 31.7848 14.9842C31.7848 14.3322 32.2135 13.6459 33.3925 13.6459H35.6469V14.6026H33.5841C33.3797 14.6026 33.2467 14.6101 33.1336 14.6838C33.0104 14.7566 32.9648 14.8646 32.9648 15.0071C32.9648 15.1767 33.0693 15.2921 33.2108 15.342C33.3294 15.3814 33.4569 15.3929 33.6483 15.3929L34.2537 15.4086C34.8641 15.4227 35.2832 15.5236 35.5378 15.77ZM40 14.5667H37.9506C37.746 14.5667 37.6099 14.5741 37.4955 14.6479C37.3769 14.7207 37.3312 14.8287 37.3312 14.9713C37.3312 15.1409 37.4313 15.2562 37.5771 15.3061C37.6957 15.3456 37.8231 15.3571 38.0104 15.3571L38.6199 15.3726C39.2348 15.3872 39.6453 15.4882 39.8956 15.7345C39.9413 15.7687 39.9686 15.8072 39.9999 15.8457V14.5667H40Z", fill: "white" }));
const DinersCardIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 40 24' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M2.05128 0H37.9487C39.0816 0 40 0.859632 40 1.92V22.08C40 23.1404 39.0816 24 37.9487 24H2.05128C0.91841 24 0 23.1404 0 22.08V1.92C0 0.859632 0.91841 0 2.05128 0Z", fill: "#0079BE" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M30.1539 12.0688C30.1539 7.29688 26.1708 3.99856 21.8067 4H18.051C13.6349 3.99842 10 7.29784 10 12.0688C10 16.4334 13.6349 20.0195 18.051 19.9984H21.8067C26.1705 20.0193 30.1539 16.4323 30.1539 12.0688Z", fill: "white" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M18.0749 4.67578C14.0395 4.67708 10.7698 7.95456 10.7688 11.9996C10.7698 16.044 14.0397 19.3211 18.0749 19.3225C22.1112 19.3212 25.3819 16.044 25.3824 11.9996C25.3818 7.95456 22.1112 4.67722 18.0749 4.67578Z", fill: "#0079BE" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M13.4568 11.9807C13.4606 10.004 14.6926 8.31847 16.4299 7.64873V16.3118C14.6926 15.6423 13.4606 13.9576 13.4568 11.9807ZM19.7448 16.3139V7.64844C21.4827 8.3166 22.7167 10.0032 22.7198 11.9808C22.7167 13.9589 21.4827 15.6442 19.7448 16.3137V16.3139Z", fill: "white" }));
const MasterCardIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 40 24' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M2.05128 0H37.9487C39.0816 0 40 0.859632 40 1.92V22.08C40 23.1404 39.0816 24 37.9487 24H2.05128C0.91841 24 0 23.1404 0 22.08V1.92C0 0.859632 0.91841 0 2.05128 0Z", fill: "#16366F" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M22.5525 12C22.5525 16.7589 18.6948 20.616 13.9361 20.616C9.17735 20.616 5.32007 16.7587 5.32007 12C5.32007 7.24165 9.17744 3.38403 13.9361 3.38403C18.6946 3.38403 22.5525 7.24179 22.5525 12Z", fill: "#D9222A" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M25.5035 3.38379C23.2772 3.38379 21.2486 4.2284 19.7195 5.61416C19.4079 5.89683 19.1172 6.20153 18.8495 6.52596H20.5902C20.8286 6.81574 21.048 7.12059 21.2471 7.43859H18.1926C18.0089 7.7324 17.8432 8.0371 17.6963 8.35097H21.7432C21.8821 8.64785 22.0039 8.95241 22.108 9.26317H17.3315C17.2311 9.56245 17.1475 9.86705 17.0811 10.1756H22.3582C22.4872 10.7751 22.5523 11.3867 22.5521 12C22.5521 12.9568 22.3959 13.8774 22.1079 14.7369H17.3314C17.4352 15.0479 17.557 15.3525 17.6959 15.6494H21.7431C21.5961 15.9633 21.4302 16.2681 21.2465 16.562H18.1925C18.3919 16.8802 18.6115 17.185 18.8494 17.4739H20.5898C20.3224 17.7989 20.0315 18.1039 19.7195 18.3864C21.2488 19.772 23.2772 20.6162 25.5035 20.6162C30.2621 20.6162 34.12 16.7588 34.12 12.0002C34.12 7.24198 30.2622 3.38422 25.5035 3.38422", fill: "#EE9F2D" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M32.9719 16.8028C32.9719 16.6492 33.0963 16.5244 33.2501 16.5244C33.4039 16.5244 33.5283 16.6492 33.5283 16.8028C33.5283 16.9564 33.4039 17.0812 33.2501 17.0812C33.0964 17.0811 32.9718 16.9565 32.9719 16.8028ZM33.2501 17.0144C33.367 17.0144 33.4616 16.9196 33.4617 16.8028C33.4617 16.686 33.367 16.5914 33.2503 16.5914H33.2501C33.1335 16.5912 33.0389 16.6857 33.0387 16.8023V16.8029C33.0385 16.9196 33.1331 17.0144 33.2498 17.0145C33.2499 17.0144 33.25 17.0144 33.2501 17.0144ZM33.2125 16.9251H33.1555V16.6806H33.2586C33.2802 16.6806 33.3022 16.6806 33.3213 16.6928C33.3411 16.7062 33.3523 16.7298 33.3523 16.7542C33.3523 16.7815 33.3361 16.8072 33.3099 16.8171L33.3549 16.9251H33.2917L33.2543 16.8284H33.2125V16.9251H33.2125ZM33.2125 16.7864H33.2441C33.2559 16.7864 33.2683 16.7874 33.2789 16.7816C33.2883 16.7756 33.2931 16.7644 33.2931 16.7536C33.2931 16.7442 33.2873 16.7334 33.2793 16.7288C33.2693 16.7225 33.2535 16.724 33.2429 16.724H33.2125V16.7864ZM11.9245 12.9434C11.8263 12.932 11.7831 12.9289 11.7157 12.9289C11.1855 12.9289 10.9171 13.1108 10.9171 13.4698C10.9171 13.6911 11.0482 13.832 11.2525 13.832C11.6335 13.832 11.9081 13.4691 11.9245 12.9434ZM12.6047 14.5272H11.8297L11.8475 14.1587C11.6111 14.45 11.2957 14.5883 10.8671 14.5883C10.3601 14.5883 10.0125 14.1923 10.0125 13.6174C10.0125 12.7522 10.6171 12.2474 11.6549 12.2474C11.7609 12.2474 11.8969 12.257 12.0361 12.2747C12.0651 12.1576 12.0727 12.1074 12.0727 12.0443C12.0727 11.8088 11.9097 11.7209 11.4727 11.7209C11.0151 11.7157 10.6377 11.8299 10.4827 11.8809C10.4925 11.8219 10.6123 11.0814 10.6123 11.0814C11.0785 10.9448 11.3859 10.8933 11.7319 10.8933C12.5351 10.8933 12.9605 11.2539 12.9598 11.9355C12.9613 12.1182 12.9311 12.3435 12.8839 12.6397C12.8027 13.1548 12.6286 14.2582 12.6047 14.5272ZM9.62113 14.5272H8.6857L9.22153 11.1673L8.02513 14.5272H7.38769L7.30897 11.1865L6.74573 14.5272H5.87012L6.60154 10.1566H7.9465L8.0281 12.603L8.84852 10.1566H10.3445L9.62113 14.5272ZM26.6602 12.9434C26.5624 12.932 26.519 12.9289 26.4517 12.9289C25.9218 12.9289 25.6533 13.1108 25.6533 13.4698C25.6533 13.6911 25.7842 13.832 25.9885 13.832C26.3696 13.832 26.6444 13.4691 26.6602 12.9434ZM27.3409 14.5272H26.566L26.5835 14.1587C26.3471 14.45 26.0315 14.5883 25.6033 14.5883C25.0962 14.5883 24.749 14.1923 24.749 13.6174C24.749 12.7522 25.3531 12.2474 26.3911 12.2474C26.4971 12.2474 26.6329 12.257 26.772 12.2747C26.8009 12.1576 26.8086 12.1074 26.8086 12.0443C26.8086 11.8088 26.6458 11.7209 26.2088 11.7209C25.7512 11.7157 25.3741 11.8299 25.2185 11.8809C25.2284 11.8219 25.3486 11.0814 25.3486 11.0814C25.8148 10.9448 26.122 10.8933 26.4675 10.8933C27.2711 10.8933 27.6965 11.2539 27.6958 11.9355C27.6973 12.1182 27.6671 12.3435 27.6199 12.6397C27.5392 13.1548 27.3646 14.2582 27.3409 14.5272ZM16.7622 14.4732C16.5062 14.5538 16.3066 14.5883 16.0902 14.5883C15.612 14.5883 15.351 14.3135 15.351 13.8075C15.3442 13.6506 15.4198 13.2373 15.4792 12.8602C15.5332 12.5281 15.8848 10.4347 15.8848 10.4347H16.8146L16.706 10.9727H17.2676L17.1408 11.8269H16.5771C16.4691 12.5029 16.3154 13.345 16.3136 13.4566C16.3136 13.6398 16.4113 13.7197 16.6337 13.7197C16.7403 13.7197 16.8229 13.7089 16.886 13.6861L16.7622 14.4732ZM19.613 14.4444C19.2936 14.542 18.9854 14.5892 18.6588 14.5884C17.618 14.5874 17.0754 14.0438 17.0754 13.0029C17.0754 11.7878 17.7657 10.8934 18.7026 10.8934C19.4692 10.8934 19.9588 11.3942 19.9588 12.1796C19.9588 12.4402 19.9252 12.6946 19.8442 13.0538H17.9926C17.93 13.5694 18.26 13.7842 18.8008 13.7842C19.1337 13.7842 19.4338 13.7156 19.7676 13.5604L19.613 14.4444ZM19.0904 12.3372C19.0956 12.2631 19.189 11.7028 18.6578 11.7028C18.3616 11.7028 18.1498 11.9286 18.0636 12.3372H19.0904ZM13.1663 12.0964C13.1663 12.546 13.3842 12.856 13.8786 13.0888C14.2574 13.2669 14.3161 13.3197 14.3161 13.481C14.3161 13.7026 14.149 13.8026 13.7788 13.8026C13.4999 13.8026 13.2403 13.759 12.9409 13.6624C12.9409 13.6624 12.8178 14.4458 12.8122 14.4833C13.0249 14.5296 13.2145 14.5726 13.7857 14.5884C14.7726 14.5884 15.2284 14.2126 15.2284 13.4004C15.2284 12.912 15.0376 12.6254 14.5691 12.41C14.1769 12.23 14.1318 12.1898 14.1318 12.0238C14.1318 11.8316 14.2873 11.7336 14.5897 11.7336C14.7733 11.7336 15.0241 11.7532 15.2617 11.787L15.3949 10.9626C15.1526 10.9242 14.7854 10.8934 14.5717 10.8934C13.5253 10.8934 13.163 11.44 13.1663 12.0964ZM24.1626 10.9868C24.4224 10.9868 24.6646 11.055 24.9984 11.223L25.1514 10.2744C25.0144 10.2206 24.532 9.90479 24.1234 9.90479C23.4974 9.90479 22.9682 10.2153 22.5961 10.728C22.0532 10.5482 21.83 10.9116 21.5564 11.2736L21.3134 11.3302C21.3318 11.211 21.3485 11.0926 21.3429 10.9728H20.4839C20.3665 12.0728 20.1585 13.187 19.9957 14.2884L19.9532 14.5272H20.889C21.0452 13.5124 21.1309 12.8626 21.1828 12.4228L21.5353 12.2268C21.5879 12.0309 21.7526 11.9648 22.0832 11.9728C22.0388 12.2132 22.0166 12.4571 22.0168 12.7016C22.0168 13.8644 22.6442 14.5884 23.6512 14.5884C23.9106 14.5884 24.1333 14.5542 24.4778 14.4609L24.6425 13.4644C24.3325 13.617 24.078 13.6888 23.8476 13.6888C23.3039 13.6888 22.9748 13.2874 22.9748 12.624C22.9748 11.6616 23.4642 10.9868 24.1626 10.9868Z", fill: "black" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M9.89017 14.2672H8.9546L9.49077 10.9078L8.29436 14.2672H7.65683L7.57801 10.927L7.01483 14.2672H6.13916L6.87059 9.89722H8.21555L8.25337 12.6026L9.16076 9.89722H10.6136L9.89017 14.2672Z", fill: "white" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M32.0809 10.1567L31.8736 11.4195C31.6178 11.0829 31.343 10.8393 30.9802 10.8393C30.5082 10.8393 30.0786 11.1971 29.7974 11.7237C29.4058 11.6425 29.0008 11.5047 29.0008 11.5047L29.0006 11.5079C29.0322 11.2136 29.0447 11.0339 29.0419 10.9729H28.1827C28.0658 12.0729 27.8578 13.1872 27.6952 14.2885L27.6523 14.5274H28.588C28.7143 13.7067 28.8112 13.0253 28.8823 12.4849C29.202 12.1961 29.362 11.9441 29.685 11.9609C29.542 12.3068 29.4582 12.7051 29.4582 13.1137C29.4582 14.0024 29.9078 14.5885 30.5878 14.5885C30.9306 14.5885 31.1935 14.4704 31.4502 14.1964L31.4064 14.5268H32.2912L33.0036 10.1567H32.0809ZM30.9112 13.706C30.5927 13.706 30.432 13.4703 30.432 13.0053C30.432 12.3068 30.733 11.8113 31.1574 11.8113C31.4787 11.8113 31.6527 12.0563 31.6527 12.5077C31.6528 13.2124 31.347 13.706 30.9112 13.706Z", fill: "black" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M12.1931 12.6845C12.0951 12.6732 12.0517 12.6701 11.9845 12.6701C11.4543 12.6701 11.1861 12.852 11.1861 13.211C11.1861 13.4319 11.3171 13.5732 11.5211 13.5732C11.9025 13.5732 12.1771 13.2104 12.1931 12.6845ZM12.8737 14.2678H12.0987L12.1163 13.8999C11.8801 14.1905 11.5643 14.3295 11.1361 14.3295C10.6289 14.3295 10.2815 13.9335 10.2815 13.3586C10.2815 12.493 10.8859 11.9885 11.9239 11.9885C12.0299 11.9885 12.1659 11.9981 12.3049 12.016C12.3339 11.8987 12.3415 11.8486 12.3415 11.7852C12.3415 11.5496 12.1787 11.4621 11.7417 11.4621C11.2839 11.4569 10.9067 11.5712 10.7515 11.6216C10.7613 11.5627 10.8811 10.823 10.8811 10.823C11.3471 10.6858 11.6549 10.6343 12.0005 10.6343C12.8039 10.6343 13.2295 10.9952 13.2287 11.6762C13.2301 11.8595 13.1997 12.0847 13.1527 12.3806C13.0717 12.8954 12.8973 13.9993 12.8737 14.2678ZM25.4199 10.0154L25.2667 10.9642C24.9331 10.7964 24.6907 10.728 24.4312 10.728C23.7327 10.728 23.2432 11.4028 23.2432 12.3651C23.2432 13.0285 23.5723 13.4298 24.116 13.4298C24.3464 13.4298 24.6006 13.3582 24.9105 13.2053L24.7464 14.2013C24.4016 14.2953 24.1792 14.3295 23.9195 14.3295C22.9127 14.3295 22.2851 13.6055 22.2851 12.4427C22.2851 10.8803 23.152 9.78833 24.3918 9.78833C24.8001 9.78838 25.2827 9.96156 25.4199 10.0154ZM26.9291 12.6845C26.8312 12.6732 26.788 12.6701 26.7205 12.6701C26.1905 12.6701 25.9221 12.852 25.9221 13.211C25.9221 13.4319 26.0531 13.5732 26.2573 13.5732C26.6383 13.5732 26.9131 13.2104 26.9291 12.6845ZM27.6097 14.2678H26.8345L26.8523 13.8999C26.6159 14.1905 26.3003 14.3295 25.8721 14.3295C25.3651 14.3295 25.0175 13.9335 25.0175 13.3586C25.0175 12.493 25.6221 11.9885 26.6597 11.9885C26.7659 11.9885 26.9017 11.9981 27.0409 12.016C27.0697 11.8987 27.0775 11.8486 27.0775 11.7852C27.0775 11.5496 26.9147 11.4621 26.4777 11.4621C26.0201 11.4569 25.6427 11.5712 25.4875 11.6216C25.4973 11.5627 25.6173 10.823 25.6173 10.823C26.0833 10.6858 26.3909 10.6343 26.7365 10.6343C27.5401 10.6343 27.9655 10.9952 27.9645 11.6762C27.9661 11.8595 27.9359 12.0847 27.8887 12.3806C27.8079 12.8954 27.6331 13.9993 27.6097 14.2678ZM17.031 14.2139C16.7748 14.2945 16.5752 14.3295 16.359 14.3295C15.8808 14.3295 15.6198 14.0547 15.6198 13.5488C15.6132 13.3913 15.6888 12.9785 15.7482 12.6014C15.802 12.2689 16.1536 10.1758 16.1536 10.1758H17.0832L16.9748 10.714H17.452L17.325 11.5678H16.8462C16.7382 12.2441 16.584 13.0855 16.5824 13.1973C16.5824 13.3812 16.6804 13.4605 16.9026 13.4605C17.0092 13.4605 17.0916 13.4501 17.1548 13.4273L17.031 14.2139ZM19.8818 14.1855C19.5626 14.2831 19.254 14.3302 18.9276 14.3295C17.8868 14.3285 17.3442 13.7849 17.3442 12.744C17.3442 11.5286 18.0345 10.6344 18.9714 10.6344C19.738 10.6344 20.2276 11.135 20.2276 11.9208C20.2276 12.1816 20.194 12.4359 20.1132 12.7949H18.2616C18.199 13.3105 18.5289 13.5255 19.0698 13.5255C19.4025 13.5255 19.7028 13.4567 20.0364 13.3011L19.8818 14.1855ZM19.359 12.0778C19.3646 12.004 19.4578 11.4434 18.9264 11.4434C18.6304 11.4434 18.4186 11.6698 18.3324 12.0778H19.359ZM13.4349 11.8376C13.4349 12.2871 13.6529 12.5967 14.1473 12.83C14.526 13.008 14.5846 13.061 14.5846 13.2221C14.5846 13.4438 14.4175 13.5437 14.0477 13.5437C13.7685 13.5437 13.5089 13.5002 13.2093 13.4036C13.2093 13.4036 13.0867 14.1869 13.0811 14.2244C13.2933 14.2708 13.483 14.3132 14.0542 14.3295C15.0415 14.3295 15.4971 13.9537 15.4971 13.1417C15.4971 12.6531 15.3065 12.3665 14.8377 12.1512C14.4456 11.9708 14.4003 11.9312 14.4003 11.765C14.4003 11.573 14.556 11.4742 14.8582 11.4742C15.0417 11.4742 15.2925 11.4943 15.5304 11.5282L15.6634 10.7035C15.4215 10.6651 15.0543 10.6344 14.8404 10.6344C13.7938 10.6344 13.4319 11.1806 13.4349 11.8376ZM32.5605 14.2678H31.6755L31.7195 13.9369C31.4628 14.2113 31.1999 14.3295 30.8571 14.3295C30.177 14.3295 29.7276 13.7433 29.7276 12.8547C29.7276 11.6725 30.4246 10.6759 31.2497 10.6759C31.6125 10.6759 31.8871 10.8241 32.1427 11.1605L32.3503 9.89772H33.2729L32.5605 14.2678ZM31.1807 13.4465C31.6163 13.4465 31.9223 12.953 31.9223 12.2488C31.9223 11.7974 31.7481 11.5524 31.4267 11.5524C31.0025 11.5524 30.7011 12.0476 30.7011 12.7464C30.7011 13.2113 30.8623 13.4465 31.1807 13.4465ZM28.4522 10.714C28.3352 11.814 28.1271 12.9282 27.9645 14.029L27.9217 14.2678H28.8573C29.1919 12.0946 29.2728 11.6702 29.7975 11.7233C29.8811 11.2786 30.0366 10.889 30.1526 10.6924C29.7608 10.6108 29.542 10.8322 29.2556 11.2528C29.2782 11.071 29.3196 10.8944 29.3114 10.714H28.4522ZM20.7521 10.714C20.6347 11.814 20.4266 12.9282 20.2641 14.029L20.2215 14.2678H21.1575C21.4917 12.0946 21.5725 11.6702 22.0968 11.7233C22.1808 11.2786 22.3364 10.889 22.452 10.6924C22.0606 10.6108 21.8416 10.8322 21.5554 11.2528C21.578 11.071 21.619 10.8944 21.6112 10.714H20.7521ZM32.9714 13.9896C32.9714 13.8353 33.096 13.7112 33.2496 13.7112C33.4031 13.711 33.5277 13.8353 33.5278 13.9888V13.9896C33.5278 14.1432 33.4032 14.2677 33.2496 14.2678C33.096 14.2677 32.9715 14.1432 32.9714 13.9896ZM33.2496 14.2009C33.3664 14.201 33.461 14.1064 33.461 13.9897V13.9896C33.4611 13.8728 33.3665 13.7781 33.2498 13.778H33.2496C33.1328 13.7781 33.0381 13.8728 33.038 13.9896C33.0382 14.1063 33.1329 14.2009 33.2496 14.2009ZM33.212 14.1112H33.155V13.8672H33.2584C33.2798 13.8672 33.302 13.8675 33.3206 13.8794C33.3406 13.8929 33.352 13.9162 33.352 13.9405C33.352 13.9681 33.3358 13.9939 33.3094 14.0037L33.3545 14.111H33.2912L33.2538 14.0147H33.212V14.111V14.1112ZM33.212 13.9729H33.2434C33.2552 13.9729 33.268 13.9738 33.2784 13.9681C33.2878 13.9622 33.2926 13.9508 33.2926 13.94C33.2921 13.9299 33.287 13.9206 33.2788 13.9148C33.269 13.9092 33.2528 13.9107 33.2421 13.9107H33.212V13.9729H33.212Z", fill: "white" }));
const GenericCardIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 40 24' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M2.05128 0H37.9487C39.0816 0 40 0.859632 40 1.92V22.08C40 23.1404 39.0816 24 37.9487 24H2.05128C0.91841 24 0 23.1404 0 22.08V1.92C0 0.859632 0.91841 0 2.05128 0Z", fill: "#172B85" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M7.50702 5.13135H4.21167C3.65939 5.13135 3.21167 5.57906 3.21167 6.13135V8.91594C3.21167 9.46823 3.65939 9.91594 4.21167 9.91594H7.50702C8.05931 9.91594 8.50702 9.46823 8.50702 8.91594V6.13135C8.50702 5.57906 8.05931 5.13135 7.50702 5.13135Z", fill: "#9D9400" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M4.5464 13.6392V13.4571H4.30079V12.9161H4.09928L4.07999 13.4571H3.53072L4.03856 12.2537L3.84815 12.1709L3.28784 13.4737V13.6392H4.0772V14.1029H4.30079V13.6392H4.5464ZM5.48653 12.1709C5.29333 12.1709 5.10839 12.2372 4.94831 12.3917L5.07253 12.5326C5.19949 12.4139 5.31263 12.3559 5.47549 12.3559C5.67695 12.3559 5.83703 12.4691 5.83703 12.6788C5.83703 12.9079 5.65765 13.0129 5.47549 13.0129H5.36231L5.33471 13.195H5.49479C5.71837 13.195 5.88949 13.2833 5.88949 13.5565C5.88949 13.7939 5.73215 13.9456 5.46445 13.9456C5.30989 13.9456 5.14981 13.8822 5.04215 13.7552L4.88759 13.8822C5.03111 14.0588 5.25743 14.1333 5.46997 14.1333C5.86189 14.1333 6.12959 13.885 6.12959 13.5565C6.12959 13.2612 5.91983 13.1067 5.69629 13.0901C5.89775 13.0513 6.06887 12.8774 6.06887 12.6485C6.06887 12.389 5.84255 12.1709 5.48653 12.1709ZM7.14143 12.1709C6.88477 12.1709 6.71365 12.262 6.56183 12.4442L6.72191 12.5656C6.84335 12.4248 6.94549 12.3641 7.13317 12.3641C7.34566 12.3641 7.47263 12.4966 7.47263 12.7092C7.47263 13.021 7.31807 13.228 6.60047 13.9153V14.1028H7.72933L7.75693 13.907H6.86269C7.48919 13.3356 7.71277 13.0514 7.71277 12.7037C7.71277 12.4001 7.50023 12.1709 7.14143 12.1709ZM9.48085 13.9152H9.08341V12.2041H8.88191L8.31887 12.5518L8.41823 12.7147L8.85431 12.4525V13.9153H8.38511V14.1029H9.48085V13.9152ZM12.821 13.6392V13.4571H12.5754V12.9161H12.3739L12.3546 13.4571H11.8053L12.3132 12.2537L12.1228 12.1709L11.5625 13.4737V13.6392H12.3518V14.1029H12.5754V13.6392H12.821ZM13.7611 12.1709C13.5679 12.1709 13.383 12.2372 13.2229 12.3917L13.3471 12.5326C13.4741 12.4139 13.5872 12.3559 13.7501 12.3559C13.9516 12.3559 14.1116 12.4691 14.1116 12.6788C14.1116 12.9079 13.9322 13.0129 13.7501 13.0129H13.6369L13.6093 13.195H13.7694C13.9929 13.195 14.1641 13.2833 14.1641 13.5565C14.1641 13.7939 14.0068 13.9456 13.739 13.9456C13.5845 13.9456 13.4244 13.8822 13.3168 13.7552L13.1622 13.8822C13.3057 14.0588 13.532 14.1333 13.7445 14.1333C14.1365 14.1333 14.4042 13.885 14.4042 13.5565C14.4042 13.2612 14.1944 13.1067 13.9709 13.0901C14.1724 13.0513 14.3435 12.8774 14.3435 12.6485C14.3435 12.389 14.1172 12.1709 13.7611 12.1709ZM15.416 12.1709C15.1593 12.1709 14.9882 12.262 14.8364 12.4442L14.9965 12.5656C15.118 12.4248 15.2201 12.3641 15.4077 12.3641C15.6203 12.3641 15.7472 12.4966 15.7472 12.7092C15.7472 13.021 15.5926 13.228 14.875 13.9153V14.1028H16.0039L16.0315 13.907H15.1373C15.7638 13.3356 15.9873 13.0514 15.9873 12.7037C15.9873 12.4001 15.7748 12.1709 15.416 12.1709ZM17.7554 13.9152H17.358V12.2041H17.1566L16.5936 12.5518L16.6929 12.7147L17.129 12.4525V13.9153H16.6598V14.1029H17.7555L17.7554 13.9152ZM21.0956 13.6392V13.4571H20.8499V12.9161H20.6485L20.6292 13.4571H20.08L20.5878 12.2537L20.3973 12.1709L19.837 13.4737V13.6392H20.6264V14.1029H20.8499V13.6392H21.0956ZM22.0357 12.1709C21.8426 12.1709 21.6576 12.2372 21.4975 12.3917L21.6217 12.5326C21.7487 12.4139 21.8618 12.3559 22.0247 12.3559C22.226 12.3559 22.3862 12.4691 22.3862 12.6788C22.3862 12.9079 22.2069 13.0129 22.0247 13.0129H21.9115L21.884 13.195H22.044C22.2676 13.195 22.4388 13.2833 22.4388 13.5565C22.4388 13.7939 22.2814 13.9456 22.0138 13.9456C21.8591 13.9456 21.6991 13.8822 21.5914 13.7552L21.4369 13.8822C21.5803 14.0588 21.8066 14.1333 22.0193 14.1333C22.4111 14.1333 22.6789 13.885 22.6789 13.5565C22.6789 13.2612 22.4691 13.1067 22.2456 13.0901C22.447 13.0513 22.6182 12.8774 22.6182 12.6485C22.6181 12.389 22.3917 12.1709 22.0357 12.1709ZM23.6907 12.1709C23.434 12.1709 23.2629 12.262 23.111 12.4442L23.2712 12.5656C23.3925 12.4248 23.4947 12.3641 23.6823 12.3641C23.8949 12.3641 24.0218 12.4966 24.0218 12.7092C24.0218 13.021 23.8673 13.228 23.1496 13.9153V14.1028H24.2785L24.3061 13.907H23.4118C24.0384 13.3356 24.262 13.0514 24.262 12.7037C24.262 12.4 24.0494 12.1709 23.6906 12.1709H23.6907ZM26.03 13.9152H25.6326V12.2041H25.4312L24.8682 12.5518L24.9675 12.7147L25.4036 12.4525V13.9153H24.9344V14.1029H26.0301L26.03 13.9152ZM29.3702 13.6392V13.4571H29.1246V12.9161H28.9232L28.9039 13.4571H28.3546L28.8625 12.2537L28.6721 12.1709L28.1118 13.4737V13.6392H28.9012V14.1029H29.1246V13.6392H29.3702ZM30.3103 12.1709C30.1172 12.1709 29.9322 12.2372 29.7721 12.3917L29.8964 12.5326C30.0234 12.4139 30.1364 12.3559 30.2994 12.3559C30.5008 12.3559 30.6609 12.4691 30.6609 12.6788C30.6609 12.9079 30.4815 13.0129 30.2994 13.0129H30.1862L30.1587 13.195H30.3187C30.5423 13.195 30.7135 13.2833 30.7135 13.5565C30.7135 13.7939 30.5562 13.9456 30.2884 13.9456C30.1339 13.9456 29.9738 13.8822 29.8662 13.7552L29.7115 13.8822C29.8551 14.0588 30.0814 14.1333 30.2939 14.1333C30.6859 14.1333 30.9536 13.885 30.9536 13.5565C30.9536 13.2612 30.7438 13.1067 30.5203 13.0901C30.7217 13.0513 30.8929 12.8774 30.8929 12.6485C30.8929 12.389 30.6666 12.1709 30.3105 12.1709H30.3103ZM31.9652 12.1709C31.7085 12.1709 31.5374 12.262 31.3856 12.4442L31.5457 12.5656C31.6672 12.4248 31.7693 12.3641 31.9569 12.3641C32.1695 12.3641 32.2964 12.4966 32.2964 12.7092C32.2964 13.021 32.1417 13.228 31.4242 13.9153V14.1028H32.5531L32.5807 13.907H31.6864C32.313 13.3356 32.5365 13.0514 32.5365 12.7037C32.5366 12.4001 32.324 12.1709 31.9652 12.1709ZM34.3047 13.9152H33.9073V12.2041H33.7057L33.1427 12.5518L33.242 12.7147L33.6781 12.4525V13.9153H33.2089V14.1029H34.3047V13.9152Z", fill: "white" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M3.46643 18.6815H3.77578V17.6137L3.43921 17.6812V17.5087L3.77391 17.4412H3.96327V18.6815H4.27268V18.8408H3.46643V18.6815ZM4.68889 18.6815H4.9983V17.6137L4.66172 17.6812V17.5087L4.99642 17.4412H5.18578V18.6815H5.49514V18.8408H4.68889V18.6815ZM6.65295 18.6815H7.31391V18.8408H6.42514V18.6815C6.497 18.6071 6.59483 18.5075 6.71862 18.3825C6.84299 18.2569 6.92108 18.1759 6.95295 18.1396C7.01358 18.0714 7.05577 18.014 7.07953 17.9671C7.10391 17.9196 7.1161 17.873 7.1161 17.8274C7.1161 17.753 7.08985 17.6924 7.03738 17.6455C6.9855 17.5986 6.91762 17.5752 6.83386 17.5752C6.77449 17.5752 6.7117 17.5855 6.64546 17.6062C6.57985 17.6268 6.50958 17.658 6.43455 17.6999V17.5086C6.51078 17.478 6.58201 17.4549 6.6483 17.4393C6.71454 17.4237 6.77516 17.416 6.83017 17.416C6.97518 17.416 7.09076 17.4522 7.17702 17.5247C7.26327 17.5973 7.30642 17.6941 7.30642 17.8153C7.30642 17.8729 7.29548 17.9276 7.27359 17.9794C7.25238 18.0307 7.2133 18.0913 7.15642 18.1613C7.14078 18.1794 7.0911 18.2319 7.00734 18.3188C6.92358 18.405 6.80545 18.5259 6.65295 18.6815ZM8.2861 18.0862C8.37673 18.1056 8.44734 18.1459 8.49798 18.2072C8.54919 18.2684 8.57482 18.3441 8.57482 18.4341C8.57482 18.5722 8.5273 18.6791 8.43236 18.7548C8.33737 18.8304 8.20234 18.8682 8.02734 18.8682C7.96859 18.8682 7.90796 18.8622 7.84546 18.8503C7.78359 18.8391 7.71956 18.8218 7.65327 18.7988V18.616C7.70574 18.6466 7.76329 18.6697 7.82578 18.6853C7.88828 18.7009 7.95361 18.7088 8.02172 18.7088C8.14047 18.7088 8.23081 18.6853 8.29268 18.6384C8.35518 18.5914 8.38642 18.5234 8.38642 18.434C8.38642 18.3514 8.35738 18.287 8.29921 18.2409C8.2417 18.194 8.16135 18.1706 8.05825 18.1706H7.89514V18.015H8.06578C8.1589 18.015 8.23019 17.9965 8.27953 17.9597C8.32892 17.9222 8.35359 17.8685 8.35359 17.7985C8.35359 17.7267 8.32796 17.6715 8.27674 17.6335C8.2261 17.5946 8.15329 17.5753 8.0583 17.5753C8.00641 17.5753 7.95078 17.5809 7.8914 17.5923C7.83203 17.6035 7.76675 17.621 7.69547 17.6447V17.4761C7.76737 17.456 7.83452 17.441 7.89706 17.431C7.96014 17.4211 8.01951 17.4161 8.07514 17.4161C8.2189 17.4161 8.33266 17.4488 8.41642 17.5144C8.50018 17.5794 8.54204 17.6675 8.54204 17.7788C8.54204 17.8563 8.51987 17.9218 8.47546 17.9757C8.43107 18.0287 8.36794 18.0656 8.2861 18.0862ZM9.54798 17.4412H10.2914V17.6005H9.72145V17.9436C9.74895 17.9343 9.77646 17.9273 9.80396 17.923C9.83146 17.918 9.85897 17.9155 9.88647 17.9155C10.0427 17.9155 10.1665 17.9584 10.2577 18.044C10.349 18.1295 10.3946 18.2455 10.3946 18.3918C10.3946 18.5424 10.3477 18.6595 10.254 18.7433C10.1602 18.8264 10.028 18.868 9.85738 18.868C9.79863 18.868 9.73863 18.863 9.67738 18.853C9.61676 18.8431 9.55398 18.828 9.48894 18.808V18.6177C9.54519 18.6484 9.60332 18.6711 9.66332 18.6861C9.72332 18.7012 9.78678 18.7087 9.85364 18.7087C9.96178 18.7087 10.0474 18.6801 10.1105 18.6234C10.1737 18.5666 10.2052 18.4893 10.2052 18.3918C10.2052 18.2943 10.1737 18.2171 10.1105 18.1603C10.0474 18.1034 9.96178 18.0751 9.85364 18.0751C9.803 18.0751 9.75241 18.0807 9.70177 18.092C9.6518 18.1032 9.60054 18.1208 9.54802 18.1444L9.54798 17.4412ZM11.1736 18.1762C11.0836 18.1762 11.0126 18.2003 10.9608 18.2485C10.9095 18.2966 10.8839 18.3629 10.8839 18.4472C10.8839 18.5316 10.9095 18.5978 10.9608 18.6459C11.0127 18.6941 11.0836 18.7182 11.1736 18.7182C11.2636 18.7182 11.3346 18.6941 11.3864 18.646C11.4383 18.5972 11.4642 18.531 11.4642 18.4472C11.4642 18.3629 11.4383 18.2966 11.3864 18.2485C11.3352 18.2003 11.2642 18.1762 11.1736 18.1762ZM10.9842 18.0956C10.903 18.0756 10.8395 18.0378 10.7939 17.9821C10.7489 17.9265 10.7264 17.8588 10.7264 17.7788C10.7264 17.6669 10.7661 17.5784 10.8455 17.5135C10.9255 17.4485 11.0348 17.4161 11.1736 17.4161C11.313 17.4161 11.4224 17.4486 11.5017 17.5134C11.5811 17.5784 11.6208 17.6669 11.6208 17.7788C11.6208 17.8588 11.598 17.9265 11.5524 17.9821C11.5073 18.0378 11.4445 18.0756 11.3639 18.0956C11.4551 18.1168 11.5261 18.1585 11.5767 18.2203C11.628 18.2821 11.6536 18.3578 11.6536 18.4472C11.6536 18.5828 11.612 18.6869 11.5289 18.7594C11.4464 18.8319 11.328 18.8682 11.1736 18.8682C11.0192 18.8682 10.9005 18.8319 10.8173 18.7594C10.7348 18.6869 10.6936 18.5828 10.6936 18.4472C10.6936 18.3578 10.7192 18.2822 10.7705 18.2203C10.8217 18.1584 10.8929 18.1169 10.9842 18.0956ZM10.9148 17.7966C10.9148 17.8691 10.9373 17.9256 10.9824 17.9662C11.028 18.0069 11.0917 18.0272 11.1736 18.0272C11.2549 18.0272 11.3183 18.0068 11.3639 17.9662C11.4101 17.9255 11.4333 17.8691 11.4333 17.7965C11.4333 17.724 11.4102 17.6675 11.3639 17.6268C11.3183 17.5862 11.2549 17.5658 11.1736 17.5658C11.0917 17.5658 11.028 17.5863 10.9824 17.6268C10.9373 17.6675 10.9148 17.724 10.9148 17.7966Z", fill: "white", "fill-opacity": "0.784" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M15.6215 18.6352H15.9308V17.5674L15.5942 17.6349V17.4624L15.9289 17.3949H16.1183V18.6352H16.4277V18.7946H15.6214L15.6215 18.6352ZM17.3849 18.0399C17.4756 18.0592 17.5462 18.0996 17.5968 18.1609C17.6481 18.2221 17.6737 18.2978 17.6737 18.3878C17.6737 18.5259 17.6263 18.6328 17.5312 18.7084C17.4362 18.784 17.3013 18.8218 17.1262 18.8218C17.0675 18.8218 17.0068 18.8159 16.9443 18.804C16.8825 18.7929 16.8184 18.7756 16.7521 18.7525V18.5696C16.8047 18.6003 16.8622 18.6234 16.9247 18.639C16.9872 18.6546 17.0525 18.6624 17.1206 18.6624C17.2394 18.6624 17.3296 18.639 17.3916 18.5921C17.4541 18.5452 17.4853 18.4771 17.4853 18.3877C17.4853 18.3052 17.4563 18.2408 17.3982 18.1946C17.3407 18.1477 17.2604 18.1243 17.1572 18.1243H16.9941V17.9687H17.1648C17.2579 17.9687 17.3292 17.9502 17.3785 17.9134C17.4279 17.8759 17.4526 17.8222 17.4526 17.7521C17.4526 17.6803 17.427 17.6253 17.3757 17.5871C17.325 17.5484 17.2523 17.5291 17.1573 17.5291C17.1054 17.5291 17.0497 17.5346 16.9903 17.5459C16.9309 17.5571 16.8656 17.5747 16.7944 17.5985V17.4296C16.8662 17.4097 16.9334 17.3946 16.9959 17.3846C17.059 17.3746 17.1184 17.3696 17.174 17.3696C17.3178 17.3696 17.4315 17.4026 17.5152 17.4682C17.599 17.5332 17.6408 17.6212 17.6408 17.7326C17.6408 17.81 17.6186 17.8756 17.5743 17.9295C17.53 17.9824 17.4668 18.0193 17.3849 18.0399ZM18.1968 18.6352H18.8578V18.7946H17.969V18.6352C18.0409 18.5608 18.1387 18.4611 18.2625 18.3362C18.3868 18.2106 18.4649 18.1296 18.4968 18.0934C18.5575 18.0252 18.5997 17.9678 18.6234 17.9209C18.6478 17.8733 18.66 17.8267 18.66 17.7812C18.66 17.7068 18.6337 17.6462 18.5813 17.5993C18.5294 17.5524 18.4616 17.529 18.3778 17.529C18.3185 17.529 18.2556 17.5393 18.1894 17.5599C18.1237 17.5806 18.0535 17.6118 17.9783 17.6537V17.4625C18.0546 17.4318 18.1258 17.4087 18.1921 17.3931C18.2583 17.3775 18.319 17.3697 18.374 17.3697C18.519 17.3697 18.6346 17.406 18.7209 17.4785C18.8071 17.551 18.8502 17.6478 18.8502 17.7692C18.8502 17.8265 18.8393 17.8813 18.8174 17.9332C18.7962 17.9844 18.7571 18.0451 18.7002 18.1151C18.6846 18.1332 18.6349 18.1857 18.5512 18.2725C18.4674 18.3587 18.3493 18.4796 18.1968 18.6352ZM19.289 18.6352H19.5984V17.5674L19.2618 17.6349V17.4624L19.5966 17.3949H19.7858V18.6352H20.0952V18.7946H19.2889L19.289 18.6352ZM21.6636 18.0399C21.7543 18.0592 21.8248 18.0996 21.8755 18.1609C21.9267 18.2221 21.9525 18.2978 21.9525 18.3878C21.9525 18.5259 21.905 18.6328 21.8099 18.7084C21.7149 18.784 21.5799 18.8218 21.4049 18.8218C21.3462 18.8218 21.2856 18.8159 21.223 18.804C21.1612 18.7929 21.0971 18.7756 21.0308 18.7525V18.5696C21.0834 18.6003 21.1409 18.6234 21.2034 18.639C21.2659 18.6546 21.3312 18.6624 21.3993 18.6624C21.5181 18.6624 21.6083 18.639 21.6703 18.5921C21.7328 18.5452 21.764 18.4771 21.764 18.3877C21.764 18.3052 21.735 18.2408 21.6769 18.1946C21.6194 18.1477 21.539 18.1243 21.4359 18.1243H21.2729V17.9687H21.4435C21.5366 17.9687 21.6079 17.9502 21.6572 17.9134C21.7066 17.8759 21.7313 17.8222 21.7313 17.7521C21.7313 17.6803 21.7057 17.6253 21.6544 17.5871C21.6037 17.5484 21.5311 17.5291 21.4359 17.5291C21.3841 17.5291 21.3285 17.5346 21.269 17.5459C21.2097 17.5571 21.1443 17.5747 21.0731 17.5985V17.4296C21.1449 17.4097 21.2121 17.3946 21.2747 17.3846C21.3378 17.3746 21.3972 17.3696 21.4527 17.3696C21.5965 17.3696 21.7102 17.4026 21.7939 17.4682C21.8778 17.5332 21.9196 17.6212 21.9196 17.7326C21.9196 17.81 21.8974 17.8756 21.853 17.9295C21.8087 17.9824 21.7456 18.0193 21.6636 18.0399ZM22.8327 17.5599L22.3547 18.3071H22.8327V17.5599ZM22.783 17.395H23.0211V18.3072H23.2207V18.4647H23.0211V18.7947H22.8327V18.4647H22.2007V18.2817L22.7831 17.3948H22.783V17.395ZM23.5369 17.395H24.2802V17.5543H23.7102V17.8973C23.7377 17.888 23.7652 17.8811 23.7928 17.8767C23.8203 17.8717 23.8478 17.8692 23.8753 17.8692C24.0316 17.8692 24.1553 17.9121 24.2465 17.9977C24.3377 18.0833 24.3834 18.1992 24.3834 18.3455C24.3834 18.4961 24.3365 18.6133 24.2427 18.697C24.149 18.7801 24.0168 18.8217 23.8461 18.8217C23.7874 18.8217 23.7274 18.8167 23.6661 18.8068C23.6056 18.7968 23.5428 18.7818 23.4777 18.7617V18.5714C23.5339 18.6021 23.5921 18.6248 23.6521 18.6399C23.7121 18.6549 23.7755 18.6624 23.8425 18.6624C23.9506 18.6624 24.0362 18.6339 24.0993 18.5772C24.1625 18.5202 24.194 18.4431 24.194 18.3456C24.194 18.2481 24.1625 18.1708 24.0993 18.1141C24.0363 18.0571 23.9506 18.0288 23.8425 18.0288C23.7918 18.0288 23.7413 18.0344 23.6906 18.0457C23.6406 18.0569 23.5893 18.0745 23.5369 18.0982V17.395ZM24.7592 17.395H25.5027V17.5543H24.9326V17.8973C24.9601 17.888 24.9876 17.8811 25.0152 17.8767C25.0426 17.8717 25.0702 17.8692 25.0977 17.8692C25.254 17.8692 25.3776 17.9121 25.4689 17.9977C25.5601 18.0833 25.6058 18.1992 25.6058 18.3455C25.6058 18.4961 25.5589 18.6133 25.4652 18.697C25.3714 18.7801 25.2392 18.8217 25.0685 18.8217C25.0097 18.8217 24.9497 18.8167 24.8885 18.8068C24.8279 18.7968 24.7651 18.7818 24.7001 18.7617V18.5714C24.7564 18.6021 24.8145 18.6248 24.8745 18.6399C24.9345 18.6549 24.9979 18.6624 25.0648 18.6624C25.1729 18.6624 25.2586 18.6339 25.3217 18.5772C25.3848 18.5202 25.4164 18.4431 25.4164 18.3456C25.4164 18.2481 25.3849 18.1708 25.3217 18.1141C25.2586 18.0571 25.1729 18.0288 25.0648 18.0288C25.0142 18.0288 24.9636 18.0344 24.9129 18.0457C24.8629 18.0569 24.8117 18.0745 24.7592 18.0982V17.395Z", fill: "white", "fill-opacity": "0.784" }));

const OneTouchIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 200 205' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { filter: "url(#filter0_d_7527_105419)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "130", height: "130", x: "39", y: "35", fill: "#fff", rx: "65" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "153", height: "153", x: "27.5", y: "23.5", className: 'custom-stroke', stroke: "#6267E2", opacity: "0.3", rx: "76.5" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "191", height: "191", x: "8.5", y: "4.5", className: 'custom-stroke', stroke: "#6267E2", opacity: "0.1", rx: "95.5" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { fill: "#6267E2", className: 'custom-fill', d: "M125.512 72.09a1.71 1.71 0 01-.846-.221c-7.066-3.643-13.174-5.189-20.498-5.189-7.286 0-14.204 1.73-20.497 5.189-.883.478-1.987.147-2.503-.736-.478-.883-.147-2.024.736-2.503C88.75 64.914 96.256 63 104.168 63c7.839 0 14.684 1.73 22.191 5.594a1.802 1.802 0 01.773 2.465c-.332.663-.957 1.03-1.62 1.03zm-52.66 19.32c-.368 0-.736-.11-1.068-.332-.846-.588-1.03-1.73-.441-2.576 3.643-5.152 8.28-9.2 13.8-12.033 11.555-5.962 26.349-5.999 37.941-.037 5.52 2.834 10.156 6.845 13.8 11.96.588.81.404 1.987-.442 2.576-.846.589-1.987.405-2.576-.442-3.312-4.636-7.507-8.28-12.475-10.819-10.562-5.41-24.067-5.41-34.592.037-5.005 2.576-9.2 6.256-12.512 10.893-.295.515-.847.773-1.435.773zm23 44.417c-.479 0-.957-.184-1.288-.552-3.202-3.201-4.932-5.262-7.397-9.715-2.54-4.526-3.864-10.046-3.864-15.971 0-10.93 9.347-19.835 20.829-19.835 11.481 0 20.828 8.905 20.828 19.835 0 1.03-.809 1.84-1.84 1.84-1.03 0-1.84-.81-1.84-1.84 0-8.906-7.691-16.155-17.148-16.155-9.458 0-17.15 7.249-17.15 16.155 0 5.299 1.178 10.193 3.423 14.168 2.355 4.232 3.975 6.035 6.808 8.905.7.736.7 1.877 0 2.613-.405.368-.883.552-1.361.552zm26.385-6.808c-4.379 0-8.243-1.104-11.408-3.275-5.483-3.717-8.758-9.752-8.758-16.155 0-1.031.809-1.84 1.84-1.84 1.03 0 1.84.809 1.84 1.84 0 5.189 2.649 10.083 7.139 13.101 2.613 1.766 5.667 2.612 9.347 2.612.883 0 2.355-.11 3.827-.368.994-.184 1.951.479 2.135 1.509.184.994-.479 1.951-1.509 2.135a25.195 25.195 0 01-4.453.441zm-7.397 7.581a2.14 2.14 0 01-.478-.074c-5.851-1.619-9.678-3.79-13.69-7.728-5.152-5.115-7.985-11.923-7.985-19.209 0-5.962 5.078-10.82 11.334-10.82 6.256 0 11.335 4.858 11.335 10.82 0 3.937 3.422 7.139 7.654 7.139 4.232 0 7.654-3.202 7.654-7.139 0-13.874-11.96-25.135-26.68-25.135-10.45 0-20.019 5.815-24.324 14.83-1.436 2.982-2.172 6.478-2.172 10.305 0 2.87.258 7.397 2.466 13.285.368.956-.11 2.024-1.067 2.355a1.825 1.825 0 01-2.355-1.067c-1.804-4.821-2.687-9.605-2.687-14.573 0-4.416.847-8.427 2.503-11.923 4.894-10.268 15.75-16.928 27.636-16.928 16.744 0 30.36 12.916 30.36 28.814 0 5.962-5.078 10.819-11.334 10.819-6.256 0-11.334-4.857-11.334-10.819 0-3.938-3.423-7.139-7.655-7.139s-7.654 3.201-7.654 7.139c0 6.293 2.429 12.181 6.881 16.597 3.496 3.459 6.845 5.373 12.034 6.808.994.257 1.546 1.288 1.288 2.245a1.796 1.796 0 01-1.73 1.398z", opacity: "0.95" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { filter: "url(#filter1_d_7527_105419)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("mask", { id: "mask0_7527_105419", style: { maskType: "alpha" }, width: "67", height: "74", x: "71", y: "63", maskUnits: "userSpaceOnUse" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { fill: "#fff", d: "M125.512 72.09a1.71 1.71 0 01-.846-.221c-7.066-3.643-13.174-5.189-20.498-5.189-7.286 0-14.204 1.73-20.497 5.189-.883.478-1.987.147-2.503-.736-.478-.883-.147-2.024.736-2.503C88.75 64.914 96.256 63 104.168 63c7.839 0 14.684 1.73 22.191 5.594a1.802 1.802 0 01.773 2.465c-.332.663-.957 1.03-1.62 1.03zm-52.66 19.32c-.368 0-.736-.11-1.068-.332-.846-.588-1.03-1.73-.441-2.576 3.643-5.152 8.28-9.2 13.8-12.033 11.555-5.962 26.349-5.999 37.941-.037 5.52 2.834 10.156 6.845 13.8 11.96.588.81.404 1.987-.442 2.576-.846.589-1.987.405-2.576-.442-3.312-4.636-7.507-8.28-12.475-10.819-10.562-5.41-24.067-5.41-34.592.037-5.005 2.576-9.2 6.256-12.512 10.893-.295.515-.847.773-1.435.773zm23 44.417c-.479 0-.957-.184-1.288-.552-3.202-3.201-4.932-5.262-7.397-9.715-2.54-4.526-3.864-10.046-3.864-15.971 0-10.93 9.347-19.835 20.829-19.835 11.481 0 20.828 8.905 20.828 19.835 0 1.03-.809 1.84-1.84 1.84-1.03 0-1.84-.81-1.84-1.84 0-8.906-7.691-16.155-17.148-16.155-9.458 0-17.15 7.249-17.15 16.155 0 5.299 1.178 10.193 3.423 14.168 2.355 4.232 3.975 6.035 6.808 8.905.7.736.7 1.877 0 2.613-.405.368-.883.552-1.361.552zm26.385-6.808c-4.379 0-8.243-1.104-11.408-3.275-5.483-3.717-8.758-9.752-8.758-16.155 0-1.031.809-1.84 1.84-1.84 1.03 0 1.84.809 1.84 1.84 0 5.189 2.649 10.083 7.139 13.101 2.613 1.766 5.667 2.612 9.347 2.612.883 0 2.355-.11 3.827-.368.994-.184 1.951.479 2.135 1.509.184.994-.479 1.951-1.509 2.135a25.195 25.195 0 01-4.453.441zm-7.397 7.581a2.14 2.14 0 01-.478-.074c-5.851-1.619-9.678-3.79-13.69-7.728-5.152-5.115-7.985-11.923-7.985-19.209 0-5.962 5.078-10.82 11.334-10.82 6.256 0 11.335 4.858 11.335 10.82 0 3.937 3.422 7.139 7.654 7.139 4.232 0 7.654-3.202 7.654-7.139 0-13.874-11.96-25.135-26.68-25.135-10.45 0-20.019 5.815-24.324 14.83-1.436 2.982-2.172 6.478-2.172 10.305 0 2.87.258 7.397 2.466 13.285.368.956-.11 2.024-1.067 2.355a1.825 1.825 0 01-2.355-1.067c-1.804-4.821-2.687-9.605-2.687-14.573 0-4.416.847-8.427 2.503-11.923 4.894-10.268 15.75-16.928 27.636-16.928 16.744 0 30.36 12.916 30.36 28.814 0 5.962-5.078 10.819-11.334 10.819-6.256 0-11.334-4.857-11.334-10.819 0-3.938-3.423-7.139-7.655-7.139s-7.654 3.201-7.654 7.139c0 6.293 2.429 12.181 6.881 16.597 3.496 3.459 6.845 5.373 12.034 6.808.994.257 1.546 1.288 1.288 2.245a1.796 1.796 0 01-1.73 1.398z" })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { mask: "url(#mask0_7527_105419)" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { fill: "#CDCDCD", d: "M161.617 150.439H276.817V192.60399999999998H161.617z", transform: "rotate(-180 161.617 150.439)" }))),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { filter: "url(#filter2_d_7527_105419)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { stroke: "#CDCDCD", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "5", d: "M55 106h98" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("defs", null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("filter", { id: "filter0_d_7527_105419", width: "190", height: "190", x: "9", y: "15", colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feOffset", { dy: "10" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feGaussianBlur", { stdDeviation: "15" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_7527_105419" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_7527_105419", result: "shape" })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("filter", { id: "filter1_d_7527_105419", width: "86.226", height: "48.325", x: "61", y: "98.275", colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feOffset", null),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feGaussianBlur", { stdDeviation: "5" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_7527_105419" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_7527_105419", result: "shape" })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("filter", { id: "filter2_d_7527_105419", width: "121", height: "23", x: "43.5", y: "100.5", colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feOffset", { dy: "6" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feGaussianBlur", { stdDeviation: "4.5" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_7527_105419" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_7527_105419", result: "shape" }))));
const UsbIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 200 205' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { filter: "url(#filter0_d_7527_105443)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "130", height: "130", x: "39", y: "35", fill: "#fff", rx: "65" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "153", height: "153", x: "27.5", y: "23.5", className: 'custom-stroke', stroke: "#6267E2", opacity: "0.3", rx: "76.5" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "191", height: "191", x: "8.5", y: "4.5", className: 'custom-stroke', stroke: "#6267E2", opacity: "0.1", rx: "95.5" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { filter: "url(#filter1_d_7527_105443)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { className: 'custom-fill', fill: "#6267E2", d: "M89.139 79.315c0-.733.594-1.327 1.326-1.327h27.07c.733 0 1.327.594 1.327 1.327v44.822c0 8.208-6.654 14.861-14.862 14.861-8.207 0-14.861-6.653-14.861-14.861V79.315z" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { fill: "#CDCDCD", fillOpacity: "0.7", fillRule: "evenodd", d: "M44.032 125.029c9.825 23.425 32.975 39.879 59.968 39.879 35.701 0 64.68-28.782 64.998-64.408H101.5l-57.468 24.529z", clipRule: "evenodd" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "21.901", height: "14.079", x: "93.049", y: "60", className: 'custom-stroke', stroke: "#6267E2", strokeWidth: "3", rx: "1" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "4.693", height: "4.693", x: "96.178", y: "64.691", className: 'custom-fill', fill: "#6267E2", rx: "1" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "4.693", height: "4.693", x: "107.129", y: "64.691", className: 'custom-fill', fill: "#6267E2", rx: "1" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { filter: "url(#filter2_d_7527_105443)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { stroke: "#CDCDCD", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "5", d: "M101 100h49" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("defs", null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("filter", { id: "filter0_d_7527_105443", width: "190", height: "190", x: "9", y: "15", colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feOffset", { dy: "10" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feGaussianBlur", { stdDeviation: "15" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_7527_105443" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_7527_105443", result: "shape" })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("filter", { id: "filter1_d_7527_105443", width: "89.723", height: "121.01", x: "59.139", y: "57.988", colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feOffset", { dy: "10" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feGaussianBlur", { stdDeviation: "15" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { values: "0 0 0 0 0.439216 0 0 0 0 0.458824 0 0 0 0 0.909804 0 0 0 0.5 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_7527_105443" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_7527_105443", result: "shape" })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("filter", { id: "filter2_d_7527_105443", width: "72", height: "23", x: "89.5", y: "94.5", colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feOffset", { dy: "6" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feGaussianBlur", { stdDeviation: "4.5" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_7527_105443" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_7527_105443", result: "shape" }))));
const QrIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 200 205' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { filter: "url(#filter0_d_7527_105420)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "130", height: "130", x: "39", y: "35", fill: "#fff", rx: "65" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "153", height: "153", x: "27.5", y: "23.5", className: 'custom-stroke', stroke: "#6267E2", opacity: "0.3", rx: "76.5" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "191", height: "191", x: "8.5", y: "4.5", className: 'custom-stroke', stroke: "#6267E2", opacity: "0.1", rx: "95.5" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { className: 'custom-fill', fill: "#6267E2", d: "M108.128 132.308v-7.179h7.179v7.179h-7.179zm-7.178-7.179v-17.946h7.178v17.946h-7.178zm28.713-10.767v-14.357h7.179v14.357h-7.179zm-7.178-14.357v-7.179h7.178v7.179h-7.178zm-43.07 7.178v-7.178h7.178v7.178h-7.179zm-7.18-7.178v-7.179h7.18v7.179h-7.18zM104.54 74.88v-7.178h7.178v7.178h-7.178zm-27.817 9.87h12.563V72.189H76.722v12.563zm-1.794 4.487c-.778 0-1.421-.254-1.93-.763-.508-.508-.762-1.151-.762-1.929V70.394c0-.778.254-1.421.763-1.93.508-.508 1.151-.762 1.929-.762h16.151c.778 0 1.421.254 1.93.762.508.509.762 1.152.762 1.93v16.151c0 .778-.254 1.42-.763 1.93-.508.508-1.151.762-1.929.762H74.928zm1.794 38.584h12.563v-12.562H76.722v12.562zm-1.794 4.487c-.778 0-1.421-.255-1.93-.763-.508-.508-.762-1.152-.762-1.929v-16.152c0-.777.254-1.42.763-1.929.508-.508 1.151-.763 1.929-.763h16.151c.778 0 1.421.255 1.93.763.508.509.762 1.152.762 1.929v16.152c0 .777-.254 1.421-.763 1.929-.508.508-1.151.763-1.929.763H74.928zm44.865-47.557h12.562V72.188h-12.562v12.563zm-1.795 4.486c-.777 0-1.42-.254-1.929-.763-.508-.508-.762-1.151-.762-1.929V70.394c0-.778.254-1.421.762-1.93.509-.508 1.152-.762 1.929-.762h16.152c.778 0 1.421.254 1.929.762.509.509.763 1.152.763 1.93v16.151c0 .778-.254 1.42-.763 1.93-.508.508-1.151.762-1.929.762h-16.152zm4.487 43.071V121.54h-7.178v-7.178h14.356v10.767h7.179v7.179h-14.357zm-14.357-25.125v-7.178h14.357v7.178h-14.357zm-14.357 0v-7.178h-7.178v-7.179h21.535v7.179h-7.178v7.178h-7.179zm3.59-17.946V74.88h7.178v7.179h7.178v7.178H97.36zm-17.05-8.076v-5.384h5.384v5.384h-5.383zm0 43.071v-5.384h5.384v5.384h-5.383zm43.071-43.07v-5.385h5.384v5.384h-5.384z" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { className: 'custom-stroke', stroke: "#6267E2", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M145 125.487V141h-14.406M145 74.513V59h-14.406M63 125.487V141h15.513M63 74.513V59h15.513" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("mask", { id: "mask0_7527_105420", style: { maskType: "alpha" }, width: "95", height: "42", x: "54", y: "100", maskUnits: "userSpaceOnUse" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { fill: "#D9D9D9", d: "M54 100H149V142H54z" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { mask: "url(#mask0_7527_105420)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { fill: "#CDCDCD", d: "M108.128 132.308v-7.179h7.179v7.179h-7.179zm-7.178-7.179v-17.946h7.178v17.946h-7.178zm28.713-10.767v-14.357h7.179v14.357h-7.179zm-7.178-14.357v-7.179h7.178v7.179h-7.178zm-43.07 7.178v-7.178h7.178v7.178h-7.179zm-7.18-7.178v-7.179h7.18v7.179h-7.18zM104.54 74.88v-7.178h7.178v7.178h-7.178zm-27.817 9.87h12.563V72.189H76.722v12.563zm-1.794 4.487c-.778 0-1.421-.254-1.93-.763-.508-.508-.762-1.151-.762-1.929V70.394c0-.778.254-1.421.763-1.93.508-.508 1.151-.762 1.929-.762h16.151c.778 0 1.421.254 1.93.762.508.509.762 1.152.762 1.93v16.151c0 .778-.254 1.42-.763 1.93-.508.508-1.151.762-1.929.762H74.928zm1.794 38.584h12.563v-12.562H76.722v12.562zm-1.794 4.487c-.778 0-1.421-.255-1.93-.763-.508-.508-.762-1.152-.762-1.929v-16.152c0-.777.254-1.42.763-1.929.508-.508 1.151-.763 1.929-.763h16.151c.778 0 1.421.255 1.93.763.508.509.762 1.152.762 1.929v16.152c0 .777-.254 1.421-.763 1.929-.508.508-1.151.763-1.929.763H74.928zm44.865-47.557h12.562V72.188h-12.562v12.563zm-1.795 4.486c-.777 0-1.42-.254-1.929-.763-.508-.508-.762-1.151-.762-1.929V70.394c0-.778.254-1.421.762-1.93.509-.508 1.152-.762 1.929-.762h16.152c.778 0 1.421.254 1.929.762.509.509.763 1.152.763 1.93v16.151c0 .778-.254 1.42-.763 1.93-.508.508-1.151.762-1.929.762h-16.152zm4.487 43.071V121.54h-7.178v-7.178h14.356v10.767h7.179v7.179h-14.357zm-14.357-25.125v-7.178h14.357v7.178h-14.357zm-14.357 0v-7.178h-7.178v-7.179h21.535v7.179h-7.178v7.178h-7.179zm3.59-17.946V74.88h7.178v7.179h7.178v7.178H97.36zm-17.05-8.076v-5.384h5.384v5.384h-5.383zm0 43.071v-5.384h5.384v5.384h-5.383zm43.071-43.07v-5.385h5.384v5.384h-5.384z" }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { stroke: "#CDCDCD", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", d: "M145 125.487V141h-14.406M63 125.487V141h15.513" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { filter: "url(#filter1_d_7527_105420)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { stroke: "#CDCDCD", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "5", d: "M55 100h98" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("defs", null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("filter", { id: "filter0_d_7527_105420", width: "190", height: "190", x: "9", y: "15", colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feOffset", { dy: "10" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feGaussianBlur", { stdDeviation: "15" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_7527_105420" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_7527_105420", result: "shape" })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("filter", { id: "filter1_d_7527_105420", width: "121", height: "23", x: "43.5", y: "94.5", colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feOffset", { dy: "6" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feGaussianBlur", { stdDeviation: "4.5" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_7527_105420" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_7527_105420", result: "shape" }))));
const LogInIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 80 80' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { filter: "url(#a)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("circle", { cx: 40, cy: 40, r: 20, fill: "#fff" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "m38.083 44.861-1.194-1.194 2.833-2.834H30v-1.666h9.667l-2.834-2.834 1.195-1.194 4.889 4.889-4.834 4.833ZM40.25 50v-1.667h8.083V31.667H40.25V30h8.083c.445 0 .834.167 1.167.5.333.333.5.722.5 1.167v16.666c0 .445-.167.834-.5 1.167-.333.333-.722.5-1.167.5H40.25Z", className: 'custom-fill', fill: "#6267E2" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("defs", null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("filter", { id: "a", x: 0, y: 0, width: 80, height: 80, filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feFlood", { floodOpacity: 0, result: "BackgroundImageFix" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { in: "SourceAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0", result: "hardAlpha" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feOffset", null),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feGaussianBlur", { stdDeviation: 10 }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_4409_4986" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_4409_4986", result: "shape" }))));
const SmsIcon = props => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ viewBox: '0 0 200 205' }, props),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { filter: "url(#filter0_d_7527_105460)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "130", height: "130", x: "39", y: "35", fill: "#fff", rx: "65" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "153", height: "153", x: "27.5", y: "23.5", className: 'custom-stroke', stroke: "#6267E2", opacity: "0.3", rx: "76.5" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "191", height: "191", x: "8.5", y: "4.5", className: 'custom-stroke', stroke: "#6267E2", opacity: "0.1", rx: "95.5" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { filter: "url(#filter1_d_7527_105460)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("circle", { cx: "69", cy: "121", r: "5", fill: "#CDCDCD" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { filter: "url(#filter2_d_7527_105460)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("circle", { cx: "82", cy: "121", r: "5", fill: "#CDCDCD" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { filter: "url(#filter3_d_7527_105460)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("circle", { cx: "95", cy: "121", r: "5", fill: "#CDCDCD" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { filter: "url(#filter4_d_7527_105460)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { className: 'custom-fill', fill: "#6267E2", fillRule: "evenodd", d: "M150 84.197c0-5.444-4.413-9.857-9.857-9.857H67.857c-5.444 0-9.857 4.413-9.857 9.857 0 5.444 4.413 9.857 9.857 9.857h.548v12.271c0 1.014 1.335 1.384 1.857.514l7.671-12.785h62.21c5.444 0 9.857-4.413 9.857-9.857z", clipRule: "evenodd" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { filter: "url(#filter5_d_7527_105460)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "64.071", height: "3.286", x: "75.524", y: "78.722", fill: "#fff", rx: "1.643" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { filter: "url(#filter6_d_7527_105460)" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "29.571", height: "3.286", x: "75.524", y: "86.389", fill: "#fff", rx: "1.643" })),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("defs", null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("filter", { id: "filter0_d_7527_105460", width: "190", height: "190", x: "9", y: "15", colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feOffset", { dy: "10" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feGaussianBlur", { stdDeviation: "15" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_7527_105460" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_7527_105460", result: "shape" })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("filter", { id: "filter1_d_7527_105460", width: "28", height: "28", x: "55", y: "113", colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feOffset", { dy: "6" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feGaussianBlur", { stdDeviation: "4.5" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_7527_105460" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_7527_105460", result: "shape" })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("filter", { id: "filter2_d_7527_105460", width: "28", height: "28", x: "68", y: "113", colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feOffset", { dy: "6" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feGaussianBlur", { stdDeviation: "4.5" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_7527_105460" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_7527_105460", result: "shape" })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("filter", { id: "filter3_d_7527_105460", width: "28", height: "28", x: "81", y: "113", colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feOffset", { dy: "6" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feGaussianBlur", { stdDeviation: "4.5" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_7527_105460" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_7527_105460", result: "shape" })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("filter", { id: "filter4_d_7527_105460", width: "110", height: "50.987", x: "49", y: "71.34", colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feOffset", { dy: "6" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feGaussianBlur", { stdDeviation: "4.5" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_7527_105460" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_7527_105460", result: "shape" })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("filter", { id: "filter5_d_7527_105460", width: "84.072", height: "23.286", x: "65.524", y: "68.722", colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feOffset", null),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feGaussianBlur", { stdDeviation: "5" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { values: "0 0 0 0 0.184861 0 0 0 0 0.366667 0 0 0 0 0.249373 0 0 0 0.3 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_7527_105460" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_7527_105460", result: "shape" })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("filter", { id: "filter6_d_7527_105460", width: "49.572", height: "23.286", x: "65.524", y: "76.389", colorInterpolationFilters: "sRGB", filterUnits: "userSpaceOnUse" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { in: "SourceAlpha", result: "hardAlpha", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feOffset", null),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feGaussianBlur", { stdDeviation: "5" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feComposite", { in2: "hardAlpha", operator: "out" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feColorMatrix", { values: "0 0 0 0 0.184861 0 0 0 0 0.366667 0 0 0 0 0.249373 0 0 0 0.3 0" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in2: "BackgroundImageFix", result: "effect1_dropShadow_7527_105460" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("feBlend", { in: "SourceGraphic", in2: "effect1_dropShadow_7527_105460", result: "shape" }))));

const iconStyle = {
    width: '1rem',
    height: '1rem',
};
const alertIcons = {
    error: styled$1(WarningIcon)(iconStyle),
    info: styled$1(InfoIcon)(iconStyle),
    success: styled$1(SuccessIcon)(iconStyle),
    warning: styled$1(WarningIcon)(iconStyle),
};
const Alert = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((props, ref) => {
    const { severity } = props;
    const Icon = alertIcons[severity !== null && severity !== void 0 ? severity : 'info'];
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Alert$1$1, Object.assign({ ref: ref, icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Icon, null) }, props), props.children);
});
var Alert$1 = Alert;

const getLetters = (name = '') => (name !== null && name !== void 0 ? name : '').split(' ').map(s => s.substring(0, 1).toUpperCase()).join('');
const StyledAvatar = styled$1(Avatar$1$1)(({ theme }) => ({
    background: theme.palette.grey[200],
    color: theme.palette.grey[600],
    fontWeight: 600,
    fontSize: '0.75rem',
    width: '2rem',
    height: '2rem',
}));
const Avatar = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((props, ref) => {
    const letters = getLetters(props.name);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StyledAvatar, Object.assign({ ref: ref, src: props.picture }, props), letters);
});
var Avatar$1 = Avatar;

const Button = styled$1(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((_a, ref) => {
    var { className } = _a, props = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["className"]);
    const generatedClassName = !props.children && props.startIcon ? `${className} Mui-iconOnly` : className;
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MuiLoadingButton, Object.assign({ ref: ref }, props, { className: generatedClassName }));
}))(({ theme }) => ({
    '&.MuiButton-containedDanger': {
        background: theme.palette.danger.main,
        borderColor: theme.palette.danger.main,
        '&:not(.Mui-disabled)': {
            background: theme.palette.danger.main,
        },
        '&.Mui-disabled': {
            backgroundColor: theme.palette.danger.light,
            color: theme.palette.danger.contrastText,
        },
        '&:not(.Mui-disabled).Mui-hovered, &:not(.Mui-disabled).Mui-focus, &:not(.Mui-disabled):hover, &:not(.Mui-disabled):focus': {
            // TODO: fix theme typings for hover
            background: theme.palette.danger.hover,
        },
        '&:not(.Mui-disabled).Mui-active, &:not(.Mui-disabled):active': {
            // TODO: fix theme typings for active
            background: theme.palette.danger.active,
        },
    },
    '&-text': {
        '&.Mui-hovered, &.Mui-focus, &:hover, &:focus': {
            // TODO: fix theme typings for grey 150
            backgroundColor: theme.palette.grey[150],
        },
        '&.Mui-active, &:active': {
            backgroundColor: theme.palette.grey[200],
        },
    },
}));
var Button$1 = Button;

styled$1('div')({
    display: 'flex',
    flexDirection: 'row',
});
const StepCircleContainer = styled$1('div')(({ theme }) => ({
    backgroundColor: theme.palette.grey[150],
    width: '1rem',
    height: '1rem',
    borderRadius: '50%',
    borderStyle: 'dashed',
    borderWidth: '1px',
    borderColor: '#D1DBEA',
}));
styled$1(StepCircleContainer)(({ theme }) => ({
    backgroundColor: theme.palette.success.main,
    borderStyle: 'solid',
    borderColor: theme.palette.success.main,
}));
styled$1(CheckIcon$1)({
    width: '0.5rem',
    height: '0.5rem',
    color: 'white',
    padding: '4px 6px 7px 4px',
});
styled$1('div')({
    paddingLeft: '1rem',
});

const palette$1 = (getter) => ({ theme }) => getValue$4(theme.palette, getter);
const spacing$1 = (...spacing) => ({ theme }) => theme.spacing(...spacing);
const linearGradient = (color1, color2) => ({ theme }) => `linear-gradient(180deg,${getValue$4(theme.palette, color1)} 0%,${getValue$4(theme.palette, color2)} 100%)`;
const forceLinearGradient = (color) => ({ theme }) => {
    const colorValue = getValue$4(theme.palette, color);
    if (colorValue.indexOf('gradient') !== -1) {
        return colorValue;
    }
    else {
        return `linear-gradient(180deg,${colorValue} 0%,${colorValue} 100%)`;
    }
};
const navigation$1 = (getter) => ({ theme }) => getValue$4(theme.navigate, getter);
var UI = {
    spacing: spacing$1,
    palette: palette$1,
    linearGradient,
    forceLinearGradient,
    navigation: navigation$1,
};

const getSeverityBackgroundColor = (severity) => {
    switch (severity) {
        case 'info':
            return UI.palette('info.light');
        case 'error':
            return UI.palette('error.light');
        case 'warning':
            return UI.palette('warning.light');
        default:
            return UI.palette('info.light');
    }
};
const getSeverityColor = (severity) => {
    switch (severity) {
        case 'info':
            return UI.palette('info.main');
        case 'error':
            return UI.palette('error.main');
        case 'warning':
            return UI.palette('warning.main');
        default:
            return UI.palette('info.main');
    }
};
const replaceSpacesWithDashes = (name) => {
    return name.replace(/ /g, "-");
};

const Chip = styled$1((props) => {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Chip$1$1, Object.assign({}, props, { onDelete: props.disabled ? undefined : props.onDelete }));
}) `
  &.MuiChip-root {
    .MuiChip-label {
      padding: ${UI.spacing(0, 3)};
    }
  }
`;
const SeverityChip = styled$1((props) => {
    const { color, ...chipProps } = props;
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Chip$1$1, Object.assign({}, chipProps, { color: 'default', onDelete: props.disabled ? undefined : props.onDelete }));
}) `
  &.MuiChip-root {
    color: ${({ severity }) => getSeverityColor(severity)};
    background-color: ${({ severity }) => getSeverityBackgroundColor(severity)};

    .MuiChip-label {
      padding: ${({ theme }) => `0 ${theme.spacing(3)}`};
    }
  }
`;
const StatusChip = styled$1((props) => {
    const { color, label, withIcons = true, status, ...chipProps } = props;
    const suffixIcon = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        switch (status) {
            case 'success':
                return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CheckIcon$1, null);
            case 'error':
                return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CrossIcon, null);
            default:
                return null;
        }
    }, [status]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Chip$1$1, Object.assign({}, chipProps, { color: status, deleteIcon: suffixIcon, label: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: 'body2Bold', color: 'inherit' }, label), onDelete: withIcons && suffixIcon ? () => null : null })));
}) `
  &.MuiChip-root {
    margin-right: ${UI.spacing(2)};
    margin-bottom: ${UI.spacing(2)};

    & .MuiSvgIcon-root {
      width: 0.5rem;
      margin-right: 10px;
      color: inherit;
    }

    .MuiChip-label {
      padding: ${({ theme }) => `0 ${theme.spacing(3)}`};
    }
  }
`;
styled$1((props) => {
    const { color, label, ...chipProps } = props;
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Chip$1$1, Object.assign({}, chipProps, { color: 'default', avatar: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EyeIcon, null), label: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: 'body2' }, label !== null && label !== void 0 ? label : 'Preview mode') })));
}) `
  &.MuiChip-root {
    background-color: #3f3f40;
    width: ${UI.spacing(43.25)};
    height: ${UI.spacing(10)};
    border-radius: 0;
    border-bottom-left-radius: ${UI.spacing(2)};
    border-bottom-right-radius: ${UI.spacing(2)};

    & .MuiTypography-root {
      color: ${UI.palette('common.white')};
      font-size: 14px;
    }

    & .MuiSvgIcon-root {
      width: 0.95rem;
      color: ${UI.palette('common.white')};
    }

    .MuiChip-label {
      padding: ${UI.spacing(3.5)};
    }
  }
`;

const DialogHeader = styled$1(({ ...props }) => {
    const { children, onClose, ...other } = props;
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MuiDialogTitle, Object.assign({}, other),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true, justifyContent: "center", alignItems: "center" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, xs: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: "dialogTitle", component: "div" }, children)),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(IconButton$1, { onClick: onClose },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CloseIcon, null))))));
}) `
  &.MuiDialogTitle-root {
    padding: ${({ theme }) => `${theme.spacing(5)} ${theme.spacing(6)}`};
    background-color: ${({ theme }) => theme.dialog.headerBackground};
    color: ${({ theme }) => theme.dialog.headerTextColor};
    min-height: 4rem;
    box-sizing: border-box;

    .MuiIconButton-root {
      margin: -0.375rem;

      .MuiSvgIcon-root {
        width: 0.75rem;
        height: 0.75rem;
        color: ${({ theme }) => theme.palette.grey[500]};
      }
    }
  }
`;

const DialogFooter = styled$1(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((props, ref) => {
    const { spaceBetween, ...footerProps } = props;
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MuiDialogActions, Object.assign({ ref: ref }, footerProps, { sx: { justifyContent: spaceBetween ? 'space-between' : 'flex-end' } }));
})) `
  &.MuiDialogActions-root {
    border-top: 1px solid ${({ theme }) => theme.palette.divider};
    padding: ${({ theme }) => `${theme.spacing(4)} ${theme.spacing(6)}`};
    background-color: ${({ theme }) => theme.dialog.footerBackground};
  }
`;

const DialogBody = styled$1(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(({ ...props }, ref) => {
    const { children, noPadding, ...other } = props;
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MuiDialogContent, Object.assign({ ref: ref }, other), children);
})) `
  &.MuiDialogContent {
    &-root {
      padding: ${({ theme }) => theme.spacing(6, 6, 8)}
    }

    ${({ noPadding }) => noPadding && `
      &-root {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        padding-left: 0 !important;
        padding-right: 0 !important;
      }
    `};

    &-dividers {
      border-top: 0;
    }
  }
`;

const DialogContainer = styled$1((props) => {
    const { children, open, dialogTitleDataTestId, title, footer, onClose, size, container, body, dataTestId, topGravity, ...modalProps } = props;
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MuiDialog, Object.assign({}, modalProps, { container: container, open: open, scroll: 'paper', fullWidth: true, "data-test-id": dataTestId, onClose: (e, reason) => reason !== 'backdropClick' && onClose(), maxWidth: size, "aria-labelledby": "fe-dialog-title" }),
        title && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DialogHeader, { "data-test-id": dialogTitleDataTestId, id: "fe-dialog-title", onClose: onClose }, title)),
        body && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DialogBody, { dividers: true }, children),
        footer && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DialogFooter, null, footer),
        !body && !footer ? children : null));
}) `
  & .MuiDialog-container {
    .MuiDialog-paper {
      position: relative;
      top: ${({ topGravity }) => topGravity ? '-4vh' : 0};
    }

    .MuiDialogContent-root:first-of-type {
      padding-top: ${({ theme }) => theme.spacing(6)};
      padding-bottom: ${({ theme }) => theme.spacing(8)};
      min-height: 4rem;
      background-color: ${({ theme }) => theme.dialog.bodyBackground};
      display: flex;
      flex-direction: column;
    }
  }

  & .MuiDialog-paperScrollPaper > form {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
  }
`;
DialogContainer.defaultProps = {
    topGravity: true,
};
const Dialog = DialogContainer;
Dialog.Header = DialogHeader;
Dialog.Body = DialogBody;
Dialog.Footer = DialogFooter;
var Dialog$1 = Dialog;

const DropZoneContainer$1 = styled$1(Box$1) `
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${UI.spacing(4)};
  background-color: ${UI.palette('grey.100')};
  width: 100%;
  height: 8.5rem;
  box-sizing: border-box;
  border-radius: 4px;
  margin: 0 auto;
`;

const ProgressZone = styled$1(Box$1) `
  border: 2px dashed ${UI.palette('grey.500')};
  border-radius: 4px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding: ${UI.spacing(7.5, 10)};
  text-align: start;
`;
const BorderLinearProgress = styled$1(LinearProgress$1) `
  width: 100%;
  border-radius: 8px;
  margin: ${UI.spacing(1)} 0;

  &.MuiLinearProgress-root {
    background-color: ${UI.palette('grey.300')};
  }

  &.MuiLinearProgress-bar {
    background-color: ${UI.palette('primary.main')};
  }
`;
const ProgressBar = ({ uploadProgress, fileName }) => {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DropZoneContainer$1, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ProgressZone, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: "uploadDropZoneProgressText" }, "Uploading..."),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(BorderLinearProgress, { variant: "determinate", value: uploadProgress }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true, justifyContent: "space-between" },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: "uploadDropZoneProgressText" }, fileName !== null && fileName !== void 0 ? fileName : 'file')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: "uploadDropZoneProgressText" },
                        uploadProgress,
                        "%")))));
};

const fileToBase64$1 = (file) => new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => null;
});
const DropZone = styled$1(Box$1) `
  border: 2px dashed ${UI.palette('grey.500')};
  border-radius: 4px;
  padding: ${UI.spacing(7, 26)};
  text-align: center;
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;
const Underlined = styled$1('span') `
  text-decoration: underline;
  font-weight: 600;
`;
const DropZoneElement = ({ uploadProgress, onDrop, fileType, description, value }) => {
    var _a;
    const [files, setFiles] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(value || []);
    const { getRootProps, getInputProps } = useDropzone({
        accept: fileType === 'image' ? `${fileType}/*` : fileType,
        onDrop: (acceptedFiles) => (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.g)(void 0, void 0, void 0, function* () {
            if (fileType === 'image') {
                const base64file = yield fileToBase64$1(acceptedFiles[0]);
                onDrop(acceptedFiles, base64file);
            }
            else {
                onDrop(acceptedFiles);
            }
            setFiles(acceptedFiles);
        }),
    });
    const dialogBodyContent = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        var _a, _b;
        return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DropZoneContainer$1, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DropZone, Object.assign({}, getRootProps(), { "data-test-id": "SSODropBox" }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("input", Object.assign({}, getInputProps(), { "data-test-id": "SSODropBox2" })),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: "uploadDropZoneDescription" }, (_b = (_a = files[0]) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Underlined, null, "Click"),
                    " or drop an ", description !== null && description !== void 0 ? description : `${fileType} file`))))));
    }, [getRootProps, getInputProps, files, description, fileType]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null, uploadProgress && uploadProgress > 0 ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ProgressBar, { uploadProgress: uploadProgress, fileName: (_a = files[0]) === null || _a === void 0 ? void 0 : _a.name }) : dialogBodyContent);
};

const PopupClick = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((props, ref) => {
    const { trigger, onOpen, onClose, children, disablePortal, mountNode } = props, popupProps = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(props, ["trigger", "onOpen", "onClose", "children", "disablePortal", "mountNode"]);
    const [open, setOpen] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useState(false);
    const handleClose = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setOpen(false);
        onClose === null || onClose === void 0 ? void 0 : onClose();
    }, [onClose, setOpen]);
    const handleOpen = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e) => {
        e.stopPropagation();
        setOpen(true);
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
    }, [onOpen, setOpen]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ClickAwayListener, { onClickAway: handleClose },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Tooltip$1, Object.assign({ PopperProps: {
                disablePortal: mountNode ? !mountNode : (disablePortal !== null && disablePortal !== void 0 ? disablePortal : true),
                container: mountNode !== null && mountNode !== void 0 ? mountNode : null,
                popperOptions: {
                    strategy: 'fixed',
                },
            }, open: open, title: children, disableFocusListener: true, disableHoverListener: true }, popupProps, { ref: ref !== null && ref !== void 0 ? ref : null }), _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.cloneElement(trigger, { onClick: handleOpen }))));
});

const PopupHover = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((props, ref) => {
    const { trigger, onOpen, onClose, children, disablePortal, mountNode } = props, popupProps = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(props, ["trigger", "onOpen", "onClose", "children", "disablePortal", "mountNode"]);
    const handleClose = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => onClose === null || onClose === void 0 ? void 0 : onClose(), [onClose]);
    const handleOpen = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => onOpen === null || onOpen === void 0 ? void 0 : onOpen(), [onOpen]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Tooltip$1, Object.assign({ PopperProps: {
            disablePortal: mountNode ? !mountNode : (disablePortal !== null && disablePortal !== void 0 ? disablePortal : true),
            container: mountNode !== null && mountNode !== void 0 ? mountNode : null,
            popperOptions: {
                strategy: 'fixed',
            },
        }, title: children, onOpen: handleOpen, onClose: handleClose, disableFocusListener: true, disableTouchListener: true }, popupProps, { ref: ref !== null && ref !== void 0 ? ref : null }), _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.cloneElement(trigger, { onClick: handleOpen, ref: ref })));
});

const PopupFocus = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((props, ref) => {
    const { trigger, onOpen, onClose, children, disablePortal, mountNode } = props, popupProps = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(props, ["trigger", "onOpen", "onClose", "children", "disablePortal", "mountNode"]);
    const handleClose = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => onClose === null || onClose === void 0 ? void 0 : onClose(), [onClose]);
    const handleOpen = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => onOpen === null || onOpen === void 0 ? void 0 : onOpen(), [onOpen]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Tooltip$1, Object.assign({ PopperProps: {
            disablePortal: mountNode ? !mountNode : (disablePortal !== null && disablePortal !== void 0 ? disablePortal : true),
            container: mountNode !== null && mountNode !== void 0 ? mountNode : null,
            popperOptions: {
                strategy: 'fixed',
            },
        }, title: children, onOpen: handleOpen, onClose: handleClose, disableHoverListener: true, disableTouchListener: true }, popupProps, { ref: ref }), _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.cloneElement(trigger, { onClick: handleOpen })));
});

const Popup = styled$1(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(({ ...props }, ref) => {
    const { action, children, ...popupProps } = props;
    const Component = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        switch (action) {
            case "click":
                return PopupClick;
            case "hover":
                return PopupHover;
            case "focus":
                return PopupFocus;
            default:
                return PopupClick;
        }
    }, [action]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Component, Object.assign({}, popupProps, { ref: ref }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("div", { className: 'MuiTooltip-content' }, children));
})) ``;
var Popup$1 = Popup;

const InputTipIcon = styled$1(({ error, ...props }) => {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InfoIcon, Object.assign({}, props));
}) `
  &.MuiSvgIcon-root {
    width: 0.75rem !important;
    height: 0.75rem !important;
    color: ${({ error }) => error && UI.palette('error.main')} !important;
  }
`;
const LabelAndButtonWrapper = (_a) => {
    var { label, button, error } = _a, typographyProps = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["label", "button", "error"]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { sx: { width: '100%', display: 'flex', justifyContent: 'space-between' } },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, Object.assign({ variant: 'label', color: error ? 'error' : undefined, component: 'span' }, typographyProps), label),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, Object.assign({ variant: 'label', color: error ? 'error' : undefined, component: 'span' }, typographyProps), button)));
};
const InputLabel = (props) => {
    const { label, error, tip, button } = props; (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(props, ["label", "error", "tip", "button"]);
    if (!!tip) {
        return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { component: Grid$1, mb: 2, sx: { position: 'relative' }, container: true, alignItems: 'center', spacing: 1 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(LabelAndButtonWrapper, Object.assign({}, props))),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Popup$1, { action: 'hover', arrow: true, trigger: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { display: 'flex' },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InputTipIcon, { error: !!error })), placement: 'right' },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null, tip)))));
    }
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { mb: 2, sx: { position: 'relative' } },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(LabelAndButtonWrapper, Object.assign({}, props))));
};
const InputErrorMessage = styled$1(({ ...props }) => {
    const { value, ...rest } = props;
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormHelperText$1, Object.assign({}, rest, { error: true }), value));
}) ``;
const Input = styled$1(({ ...props }) => {
    var _a;
    const { label, error, errorMessage, className, autoFocus, loading, tip, button, success, customContent, 'data-test-id': testId, ...inputProps } = props;
    const ref = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();
    const clonedContent = customContent
        ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.cloneElement(customContent, {
            inputRef: ref,
            ...inputProps,
            'data-test-id': testId,
            error,
            className: inputProps.inputClassName,
        })
        : null;
    if (loading) {
        inputProps.endAdornment = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CircularProgress$1, { size: 16, color: 'inherit' });
    }
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (autoFocus) {
            setTimeout(() => { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.focus(); }, 0);
        }
    }, []);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { mb: 4, className: className },
        (label || label === '') && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InputLabel, { tip: tip, label: label, error: error, button: button }),
        clonedContent ? (clonedContent) : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MuiOutlinedInput, Object.assign({ inputProps: { maxLength: !!inputProps.multiline ? 5000 : 200 }, inputRef: ref }, inputProps, { "data-test-id": testId, error: error, className: inputProps.inputClassName }))),
        error && errorMessage && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InputErrorMessage, { "data-test-id": `${(_a = testId !== null && testId !== void 0 ? testId : props.name) !== null && _a !== void 0 ? _a : label}_error`, value: errorMessage }))));
}) `
  & {
    .MuiSvgIcon-root {
      color: ${({ theme }) => theme.palette.icon.input};
      width: 1rem;
      height: 1rem;
      margin: 0 0.5rem;
    }

    .MuiIconButton-root {
      padding: 0.5rem;
      width: 2rem;
    }

    .MuiOutlinedInput-input {
      .MuiChip-root > .MuiSvgIcon-root {
        margin-left: -0.25rem;
        margin-right: 0.75rem;
        color: ${UI.palette('grey.600')};
        padding: 0.1rem;
        box-sizing: border-box;

        &:hover {
          color: inherit;
        }
      }
    }

    .MuiFormHelperText-root.Mui-error {
      margin-top: ${({ theme }) => theme.spacing(1)};
      font-family: ${({ theme }) => theme.authPage.inputError.fontFamily};
      font-size: ${({ theme }) => theme.authPage.inputError.fontSize};
      font-weight: ${({ theme }) => theme.authPage.inputError.fontWeight};
      padding: ${({ theme }) => theme.authPage.inputError.padding};
    }

    .MuiOutlinedInput-root.MuiInputBase-root {
      ${({ theme, error }) => error && `border-color: ${theme.palette.error.main}`};
      ${({ theme, success }) => success && `border: 2px solid ${theme.palette.success.main}`};

      &:hover,
      &:focus,
      &.Mui-focused,
      &.Mui-hovered {
        ${({ theme, error }) => error && `outline-color: ${theme.palette.error.main}`};
        ${({ theme, success }) => success && `outline-color: ${theme.palette.success.main}`};
      }
    }
  }
`;
var Input$1 = Input;

const InputCopy = styled$1((props) => {
    const { value, _copied } = props;
    const [copied, setCopied] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(_copied !== null && _copied !== void 0 ? _copied : false);
    const copyInputValue = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        var _a;
        copy((_a = value) !== null && _a !== void 0 ? _a : '').then(displayCopiedIcon).catch(e => {
            console.error("Failed to copy input value", e);
            if (window.Cypress) {
                // Copy to clipboard does not work in cypress
                displayCopiedIcon();
            }
        });
    }, [copied, setCopied]);
    const displayCopiedIcon = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 2000);
    }, [setCopied]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Input$1, Object.assign({}, props, { "data-test-id": `${props.testId}-box`, disabled: true, endAdornment: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InputAdornment$1, { "data-test-id": `${props.testId}-btn`, onClick: copyInputValue, position: "start" }, copied ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CheckedIcon, { "data-test-id": `${props.testId}-check-icon` }) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CopyIcon, null)) })));
}) `
  .MuiSvgIcon-root {
    width: 0.75rem;
    height: 0.75rem;
  }

  .MuiInputAdornment-root {
    cursor: pointer;
    padding: ${({ theme }) => theme.spacing(2.5)};
    margin-right: ${({ theme }) => theme.spacing(-1.25)};
  }
`;
var InputCopy$1 = InputCopy;

const InputPassword = styled$1((props) => {
    const [passwordVisible, setPasswordVisible] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const handleTogglePasswordVisible = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => setPasswordVisible(state => !state), [setPasswordVisible]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Input$1, Object.assign({ inputProps: {
            maxLength: 50,
        } }, props, { type: passwordVisible ? 'text' : 'password', endAdornment: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(IconButton$1, { onClick: handleTogglePasswordVisible, tabIndex: -1 }, passwordVisible ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EyeInVisibleIcon, null) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EyeVisibleIcon, null)) })));
}) `
`;
var InputPassword$1 = InputPassword;

const loaderAnimation = keyframes `
  0% {
    transform: translate(0, 0px) scale(1, 1);
    opacity: 1;
  }
  50% {
    transform: translate(0, 10px) scale(1, .4);
    opacity: .6;
  }
  100% {
    transform: translate(0, 0px) scale(1, 1);
    opacity: 1;
  }
`;
const Loader = styled$1((props) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SvgIcon$1, Object.assign({ "data-test-id": "loader" }, props, { viewBox: "0 0 32 32" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { x: "1", y: "6" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { x: "14", y: "6" }),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { x: "27", y: "6" }))) `
  & rect {
    fill: ${UI.palette('loader')};
    width: 0.25rem;
    height: 1.25rem;
    opacity: 1;
    transition: all 300ms;
    animation-name: ${loaderAnimation};
    animation-duration: 600ms;
    animation-iteration-count: infinite;

    &:nth-of-type(1) {
      transform: translate(0, 0) scale(1, 1);
    }

    &:nth-of-type(2) {
      transform: translate(0, 10px) scale(1, 0.4);
      opacity: .6;
      animation-delay: 300ms;
    }

    &:nth-of-type(3) {
      transform: translate(0, 0) scale(1, 1);
    }
  }
`;
var Loader$1 = Loader;

const Menu = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((_a, ref) => {
    var { items } = _a, props = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["items"]);
    const [loading, setLoading] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(null);
    const handleClick = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e, item) => (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.g)(void 0, void 0, void 0, function* () {
        var _b;
        setLoading(item);
        try {
            yield item.onClick(e, item);
        }
        catch (e) {
            console.error(e);
        }
        (_b = props.onClose) === null || _b === void 0 ? void 0 : _b.call(props, e, 'escapeKeyDown');
        setLoading(null);
    }), [setLoading, props.onClose]);
    const menuItems = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        return items.map((item, index) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MenuItem$1, { disabled: loading === item, classes: { root: item.negative ? 'Mui-negative' : undefined }, key: index, onClick: (e) => handleClick(e, item) },
            item.icon && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ListItemIcon$1, null,
                item.icon,
                loading === item && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CircularProgress$1, { color: 'inherit' })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ListItemText$1, { primary: item.text })));
    }, [items, loading]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MuiMenu, Object.assign({}, props, { ref: ref }), menuItems);
});
var Menu$1 = Menu;

const NavigationListItem = styled$1(ListItem$1) `
  &.MuiListItem-root {
    color: ${({ theme }) => theme.navigation.default.color};
    border: 1px solid ${({ theme }) => theme.navigation.default.borderColor};
    margin-bottom: ${({ theme }) => theme.spacing(2)};

    .MuiListItemText-root {
      //margin-top: 2px;
    }

    .MuiTypography-root {
      color: inherit;
      font-weight: 600;
      line-height: 1rem;
    }

    .MuiListItemIcon-root > .MuiSvgIcon-root {
      height: auto;
      width: 1rem;
    }

    .MuiListItemIcon-root > .MuiAvatar-root {
      height: 1.5rem;
      width: 1.5rem;
      left: -.25rem;
      font-size: .625rem;
    }

    &.Mui-selected, &.MuiButtonBase-root.MuiButton-root.Mui-focusVisible {
      color: ${({ theme }) => theme.navigation.selected.color};
      background-color: ${({ theme }) => theme.navigation.selected.background};
      border-color: ${({ theme }) => theme.navigation.selected.borderColor};

      .MuiListItemIcon-root > .MuiAvatar-root {
        background-color: ${({ theme }) => theme.navigation.selected.avatarBgColor};
        color: ${({ theme }) => theme.navigation.selected.avatarColor};
      }
    }

    &.MuiButtonBase-root.MuiButton-root:hover {
      background-color: ${({ theme }) => theme.navigation.hover.background};
    }
  }
`;
NavigationListItem.defaultProps = {
    color: 'default',
    component: Button$1,
    variant: 'text',
};
var NavigationListItem$1 = NavigationListItem;

class Owasp {
    constructor(config, t) {
        this.requiredTests = [
            this.checkMinLength.bind(this),
            this.checkMaxLength.bind(this),
            this.checkThreeRepeatedChars.bind(this),
        ];
        this.optionalTests = [
            this.checkAtLeastOneLowerLetter.bind(this),
            this.checkAtLeastOneUpperLetter.bind(this),
            this.checkAtLeastOneNumber.bind(this),
            this.checkAtLeastOneSpecialChar.bind(this),
        ];
        this.config = config;
        this.t = t;
    }
    static setConfig(_config, t, name = 'default') {
        if (!_config && Owasp.configs[name]) {
            return Owasp.configs[name];
        }
        const easyPassConfigObject = Object.assign(Object.assign({}, _config), { minOptionalTestsToPass: 1, minPhraseLength: 1 });
        const config = (_config === null || _config === void 0 ? void 0 : _config.minLength) !== 6 ? _config : easyPassConfigObject;
        const owasp = new Owasp(config, t);
        Owasp.configs[name] = owasp;
        return owasp;
    }
    static test(password, name = 'default') {
        const owasp = this.configs[name];
        if (!owasp) {
            throw Error('Owasp must be configured before using it, call Owasp.setConfig({OPTIONS})');
        }
        const result = {
            errors: [],
            failedTests: [],
            passedTests: [],
            requiredTestErrors: [],
            optionalTestErrors: [],
            isPassphrase: false,
            strong: true,
            optionalTestsPassed: 0,
        };
        // Always submit the password/passphrase to the required tests
        owasp.checkRequiredTests(password, result);
        // If configured to allow passphrases, and if the password is of a
        // sufficient length to consider it a passphrase, exempt it from the
        // optional tests.
        result.isPassphrase = owasp.config.allowPassphrases && password.length >= owasp.config.minPhraseLength;
        if (!result.isPassphrase) {
            owasp.checkIsPassphrase(password, result);
        }
        // If the password is not a passphrase, assert that it has passed a
        // sufficient number of the optional tests, per the configuration
        if (!result.isPassphrase && result.optionalTestsPassed < owasp.config.minOptionalTestsToPass) {
            result.strong = false;
        }
        // return the result
        return result;
    }
    checkRequiredTests(password, result) {
        let i = 0;
        this.requiredTests.forEach(function (test) {
            const err = test(password);
            if (typeof err === 'string') {
                result.strong = false;
                result.errors.push(err);
                result.requiredTestErrors.push(err);
                result.failedTests.push(i);
            }
            else {
                result.passedTests.push(i);
            }
            i++;
        });
    }
    checkIsPassphrase(password, result) {
        let j = this.requiredTests.length;
        this.optionalTests.forEach(function (test) {
            const err = test(password);
            if (typeof err === 'string') {
                result.errors.push(err);
                result.optionalTestErrors.push(err);
                result.failedTests.push(j);
            }
            else {
                result.optionalTestsPassed++;
                result.passedTests.push(j);
            }
            j++;
        });
    }
    checkMinLength(password) {
        if (password.length < this.config.minLength) {
            return this.t('validations.passwordMinLength', { length: this.config.minLength });
        }
    }
    checkMaxLength(password) {
        if (password.length > this.config.maxLength) {
            return this.t('validations.passwordMaxLength', { length: this.config.maxLength });
        }
    }
    checkThreeRepeatedChars(password) {
        if (/(.)\1{2,}/.test(password)) {
            return this.t('validations.passwordThreeRepeatedChars');
        }
    }
    checkAtLeastOneLowerLetter(password) {
        if (!/[a-z]/.test(password)) {
            return this.t('validations.passwordAtLeastOneLowerLetter');
        }
    }
    checkAtLeastOneUpperLetter(password) {
        if (!/[A-Z]/.test(password)) {
            return this.t('validations.passwordAtLeastOneUpperLetter');
        }
    }
    checkAtLeastOneNumber(password) {
        if (!/[0-9]/.test(password)) {
            return this.t('validations.passwordAtLeastOneNumber');
        }
    }
    checkAtLeastOneSpecialChar(password) {
        if (!/[^A-Za-z0-9]/.test(password)) {
            return this.t('validations.passwordAtLeastOneSpecialChar');
        }
    }
}
Owasp.configs = {};

const validateSchema = (props) => create(props);
const validateLength = (limit, requiredMessage, errorMessage) => create$2().length(limit, errorMessage).required(requiredMessage);
const validateTwoFactorCode = (invalidMessage, requiredMessage) => create$2().length(6, invalidMessage).required(requiredMessage);
// new validations
const validateEmailOptional = (invalidMessage) => create$2().email(invalidMessage);
const validateEmail = (invalidMessage, requiredMessage) => validateEmailOptional(invalidMessage).required(requiredMessage);
const validateNotEmpty = (requiredMessage) => create$2().required(requiredMessage);
const validateMinLengthOptional = (minLength, minLengthMessage) => create$2().min(minLength, minLengthMessage);
const validateMinLength = (minLength, requiredMessage, minLengthMessage) => validateMinLengthOptional(minLength, minLengthMessage).required(requiredMessage);
const validatePasswordUsingOWASP = (requiredMessage, owaspConfigName) => create$2()
    .required(requiredMessage)
    .test('validate_owasp', 'Invalid Password', function (value) {
    return (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.g)(this, void 0, void 0, function* () {
        if (value == null) {
            return true;
        }
        const { errors } = Owasp.test(value, owaspConfigName);
        if (errors === null || errors === void 0 ? void 0 : errors.length) {
            return this.createError({ message: errors[0] });
        }
        return true;
    });
});
const validateConfirmPassword = (requiredMessage, passwordMustMatchMessage, field = 'password') => create$2()
    .required(requiredMessage)
    .when(field, {
    is: (val) => val && val.length > 0,
    then: create$2().oneOf([create$5(field)], passwordMustMatchMessage),
});
const validationPhone = (requiredMessage, invalidPhoneMessage) => validationPhoneOptional(invalidPhoneMessage).required(requiredMessage);
const validationPhoneOptional = (invalidPhoneMessage) => create$2().matches(/^(\+)?(?=.[\0-9]{6,})(([+]{0,1}[0-9]{0,1}){0,1}([(]{1}[0-9]{3}[)]{1}){0,1}([-]{0,1}[0-9]{2,}){1,})$/, invalidPhoneMessage);
const validationPostCodeOptional = (invalidPostCodeMessage) => create$2()
    .nullable(true)
    .matches(/^(([0-9]{5,7}|[a-zA-Z][a-zA-Z]{0,49})|([\w]{1,2}[\d]{1,2}([\w])?\s?[\d]{1}[\w]{1,2}))$/, invalidPostCodeMessage);
const validateNumber = (requiredMessage, validNumberMessage) => create$1().typeError(validNumberMessage).required(requiredMessage);
const validateHistorySize = (requiredMessage, validNumberMessage, minLengthMessage, maxLengthMessage) => validateNumber(requiredMessage, validNumberMessage).min(0, minLengthMessage).max(10, maxLengthMessage);
const validateUrl = (requiredMessage, invalidUrlMessage) => create$2().url(invalidUrlMessage).required(requiredMessage);
const validateFile = (requiredMessage) => create$4().nullable().required(requiredMessage);
const validateDomain = (requiredMessage, mustBeValidMessage) => create$2()
    .matches(/^(?!:\/\/)(?=.{1,255}$)((.{1,63}\.){1,127}(?![0-9]*$)[a-z0-9-]+\.?)$/, mustBeValidMessage)
    .required(requiredMessage);
const validatePositiveNumber = (mustBePositiveMessage) => validateNumber(mustBePositiveMessage, mustBePositiveMessage).min(0, mustBePositiveMessage);
const WELL_KNOWN_URL = '/.well-known/openid-configuration';
const validateWellKnown = (issuerUrl, abortSignal) => (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.g)(void 0, void 0, void 0, function* () {
    return new Promise((resolve) => {
        let requestUrl = issuerUrl;
        if (!requestUrl.includes(WELL_KNOWN_URL)) {
            requestUrl += WELL_KNOWN_URL;
        }
        fetch(requestUrl, { signal: abortSignal })
            .then((res) => res.json())
            .then((data) => {
            if (!!(data === null || data === void 0 ? void 0 : data.authorization_endpoint) && !!(data === null || data === void 0 ? void 0 : data.token_endpoint)) {
                resolve(true);
            }
            resolve(false);
        })
            .catch((e) => resolve(false));
    });
});
const validateRequiredBoolean = (requiredMessage) => create$3().oneOf([true], requiredMessage);

const shallowEqual = (...keys) => (prevProps, nextProps) => {
    if (prevProps == null || nextProps == null || prevProps === nextProps) {
        return false;
    }
    return keys.reduce((p, n) => Boolean(p && getValue$4(prevProps, n) === getValue$4(nextProps, n)), true);
};
const shallowEqualPrefix = (prefix, ...keys) => shallowEqual(...keys.map(key => `${prefix}.${key}`));
const uniqueValues = (value, index, arr) => arr.indexOf(value) === index;
const fileToBase64 = (file) => new Promise((resolve) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = () => null;
});
const callbackToPromise = (resolve, reject, closeable) => (data, error) => {
    if (error) {
        if (typeof error === typeof Error) {
            reject(error);
        }
        else {
            reject(new Error(error));
        }
        return;
    }
    resolve(data);
    closeable === null || closeable === void 0 ? void 0 : closeable();
};

var keyboardKeys;
(function (keyboardKeys) {
    keyboardKeys[keyboardKeys["ARROW_DOWN_KEY"] = 40] = "ARROW_DOWN_KEY";
    keyboardKeys[keyboardKeys["ARROW_UP_KEY"] = 38] = "ARROW_UP_KEY";
    keyboardKeys[keyboardKeys["ENTER_KEY"] = 13] = "ENTER_KEY";
    keyboardKeys[keyboardKeys["SPACE_KEY"] = 32] = "SPACE_KEY";
    keyboardKeys[keyboardKeys["ESC_KEY"] = 27] = "ESC_KEY";
})(keyboardKeys || (keyboardKeys = {}));
const PopperContainer$1 = styled$1(Box$1) `
  box-sizing: border-box;
  max-height: 18rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin-top: ${UI.spacing(2)};
  background: ${UI.palette('common.white')};
  border: 1px solid ${UI.palette('grey.400')};
  box-shadow: 0 0.25rem 0.75rem rgba(10, 27, 62, 0.1);
  border-radius: 0.25rem;

  > * {
    flex: 1;
  }
`;
const PopperHeader$1 = styled$1(Grid$1) `
  padding: 0.75rem;
  border-bottom: 1px solid ${UI.palette('grey.300')};
`;
const PopperContent$1 = styled$1(Grid$1) `
  & {
    overflow: auto;
    background: ${UI.palette('common.white')};
    max-height: 25vh;
    padding: 0.5rem 0;

    ::-webkit-scrollbar {
      width: 0.75rem;
    }

    ::-webkit-scrollbar-track {
      background: ${UI.palette('grey.100')};
      border-left: 1px solid ${UI.palette('grey.300')};
    }

    ::-webkit-scrollbar-thumb {
      border: .25rem solid rgba(0, 0, 0, 0);
      background-clip: padding-box;
      -webkit-border-radius: 7px;
      background-color: ${UI.palette('grey.300')};
      cursor: pointer;
    }

    ::-webkit-scrollbar-thumb:hover {
      background-color: ${UI.palette('grey.400')};
    }

    ::-webkit-scrollbar-button {
      width: 0;
      height: 0;
      display: none;
    }

    ::-webkit-scrollbar-corner {
      background-color: transparent;
    }
  }
`;
const Option$1 = styled$1((props) => {
    const { label, value, className, onSelect, selected, withCheckbox, hovered, disabled } = props;
    const optionContainerRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        var _a;
        if (hovered) {
            (_a = optionContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
        }
    }, [optionContainerRef, hovered]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { "aria-selected": hovered, className: className, "data-test-id": label, ref: optionContainerRef, onClick: disabled ? undefined : () => onSelect(value) },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true, alignItems: 'flex-end' },
            withCheckbox && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Checkbox$1, { size: 'small', checked: !!selected, disabled: disabled })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: 'selectOption' }, label))));
}) `
  & {
    padding: ${UI.spacing(3)} ${UI.spacing(4)};
    cursor: ${({ disabled }) => disabled ? 'unset' : 'pointer'};

    ${({ theme, disabled }) => disabled ? `
      cursor: unset;
      opacity: 0.6;
    ` : `
      cursor: pointer;
      &:hover, &:focus {
        background: ${UI.palette('grey.150')({ theme })};
      }

      &:active {
        background: ${UI.palette('grey.200')({ theme })};
      }
    `};

    ${({ theme, selected, disabled }) => !disabled && selected ? `background: ${UI.palette('grey.200')({ theme })}` : ''};
    ${({ theme, hovered, disabled }) => !disabled && hovered ? `background: ${UI.palette('grey.150')({ theme })}` : ''};

    .MuiCheckbox-root {
      margin: -.375rem .125rem -.375rem -.375rem;
      padding: .375rem;
    }
  }
`;
const SelectPopup = (props) => {
    const { handleClose, popperWidth, options, onSearch, onSelect } = props;
    const inputRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
    const containerRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
    const [activeIndex, setActiveIndex] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(-1);
    const [searching, setSearching] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (props.in) {
            setTimeout(() => {
                var _a;
                props.onSearch && ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus());
            }, 200);
        }
    }, [props.in, props.onSearch, setActiveIndex]);
    const handleSearch = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((query) => (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.g)(void 0, void 0, void 0, function* () {
        setSearching(true);
        yield (onSearch === null || onSearch === void 0 ? void 0 : onSearch(query));
        setSearching(false);
    }), [onSearch, setSearching]);
    const optionsList = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => options
        .sort((a, b) => a.value > b.value ? 1 : -1)
        .sort((a, b) => a.disabled === b.disabled ? 0 : a.disabled ? 1 : -1)
        .map((optionProps, index) => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Option$1, Object.assign({ "data-test-id": props.value, key: index }, optionProps, { onSelect: onSelect, hovered: index === activeIndex }));
    }), [options, onSelect, activeIndex]);
    const handleKeyDown = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e) => {
        if (!props.in) {
            return;
        }
        let consumed = false;
        if (e.keyCode === keyboardKeys.ARROW_DOWN_KEY) {
            setActiveIndex(activeIndex < optionsList.length - 2 ? activeIndex + 1 : optionsList.length - 1);
            consumed = true;
        }
        else if (e.keyCode === keyboardKeys.ARROW_UP_KEY) {
            consumed = true;
            setActiveIndex(activeIndex > 1 ? activeIndex - 1 : 0);
        }
        else if (e.keyCode === keyboardKeys.ESC_KEY) {
            consumed = true;
            handleClose === null || handleClose === void 0 ? void 0 : handleClose(e);
        }
        else if (e.keyCode === keyboardKeys.ENTER_KEY || e.keyCode === keyboardKeys.SPACE_KEY) {
            consumed = true;
            if (options[activeIndex]) {
                onSelect(options[activeIndex].value);
            }
        }
        if (consumed) {
            e.preventDefault();
            e.stopPropagation();
        }
    }, [props.in, activeIndex, optionsList.length, handleClose, setActiveIndex]);
    const stopPropagation = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e) => {
        if (e.keyCode === keyboardKeys.ESC_KEY) {
            e.stopPropagation();
        }
    }, []);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        var _a, _b;
        (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.addEventListener('keyup', handleKeyDown);
        (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.addEventListener('keydown', stopPropagation);
        return () => {
            var _a, _b;
            (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.removeEventListener('keyup', handleKeyDown);
            (_b = containerRef.current) === null || _b === void 0 ? void 0 : _b.removeEventListener('keydown', stopPropagation);
        };
    }, [handleKeyDown, containerRef]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PopperContainer$1, { ref: containerRef, width: popperWidth },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ClickAwayListener, { mouseEvent: 'onMouseDown', onClickAway: handleClose },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true, direction: 'column', wrap: "nowrap", overflow: 'hidden' },
                onSearch && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PopperHeader$1, { item: true },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Input$1, { inputRef: inputRef, loading: searching, onChange: (e) => handleSearch(e.target.value), endAdornment: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SearchIcon, null), "data-test-id": "search", placeholder: 'Search for any text' })),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PopperContent$1, { tabIndex: 0, item: true }, optionsList))));
};

const Container$3 = styled$1(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(({ multi, open, size = 'medium', ...rest }, ref) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, Object.assign({}, rest, { ref: ref })))) `
  & {
    .MuiOutlinedInput-root {
      background: ${UI.palette('grey.100')};
      ${({ size }) => size === 'medium' ? 'min-width: 300px' : null};
      box-shadow: none;

      &.Mui-focused {
        outline: none;
      }

      &:hover {
        background: ${({ theme }) => `linear-gradient(180deg, ${theme.palette.grey[100]} 0%, ${theme.palette.default.hover} 100%)`};
      }

      ${({ open, theme, }) => open ? `background: linear-gradient(180deg, ${theme.palette.grey[100]} 0%, ${theme.palette.default.hover} 100%)` : ''};

      .MuiOutlinedInput-input {
        min-height: 1.25rem;
        height: unset;
        ${({ multi, theme }) => multi ? `padding-left: ${theme.spacing(2)}` : null};
        ${({ size }) => size === 'medium' ? 'padding: 12px 0px 12px 16px' : null};
      }

      .MuiSvgIcon-root {
        width: ${UI.spacing(3)};
      }

      .MuiChip-root {
        margin: -.3rem 0 -0.2rem;
      }
    }
  }
`;
const PlaceHolder$1 = styled$1('div') `
  color: ${UI.palette('grey.600')};
`;
const SelectInputContainer$1 = styled$1('div') `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const CloseButton$1 = styled$1(IconButton$1) `
  &.MuiIconButton-root {
    margin: -0.75rem 0;
    height: 2rem;
  }
`;
const SelectInputComponent$1 = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.forwardRef((props, ref) => {
    var _a;
    const { component: Component, children, renderSelectedOption, handleSelect } = props, other = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(props, ["component", "children", "renderSelectedOption", "handleSelect"]);
    const clearValue = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e) => {
        e.stopPropagation();
        e.preventDefault();
        handleSelect(null);
    }, [handleSelect]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Component, Object.assign({ tabIndex: 0 }, other, { ref: ref }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SelectInputContainer$1, null,
            other.value ? ((_a = renderSelectedOption === null || renderSelectedOption === void 0 ? void 0 : renderSelectedOption(other.value)) !== null && _a !== void 0 ? _a : other.value) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PlaceHolder$1, null, other.placeholder || ' '),
            other.value && other.clearable ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CloseButton$1, { "data-test-id": "clear-btn", onFocus: (e) => { e.stopPropagation(); }, onClick: clearValue },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CloseIcon, null)) : ''));
});
const RolesCounter = styled$1(Grid$1) `
  background-color: ${UI.palette('grey.800')};
  padding: 0.25rem 0.5rem !important;
  position: absolute;
  right: 2.25rem;
  border-radius: 4px;
`;
const Select = (props) => {
    const { size, options, optionType, container, value, onChange, onSearch, multi, oneLineMulti, renderSelectedOption, onOpen, onClose, clearable, customContent, minPopperWidth } = props, inputProps = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(props, ["size", "options", "optionType", "container", "value", "onChange", "onSearch", "multi", "oneLineMulti", "renderSelectedOption", "onOpen", "onClose", "clearable", "customContent", "minPopperWidth"]);
    const [anchorEl, setAnchorEl] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useState(null);
    const selectInputRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useRef(null);
    const [pendingValue, setPendingValue] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useState([]);
    const [popperWidth, setPopperWidth] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useState(0);
    const [currentWithOffset, setCurrentWithOffset] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useState(0);
    const leftOffset = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useMemo(() => minPopperWidth ? minPopperWidth - currentWithOffset : undefined, [minPopperWidth, currentWithOffset]);
    const open = Boolean(anchorEl);
    const handleClick = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((event) => {
        if (open || inputProps.disabled) {
            return;
        }
        setPendingValue(value);
        setPopperWidth(minPopperWidth || event.currentTarget.offsetWidth);
        setCurrentWithOffset(event.currentTarget.offsetWidth);
        setAnchorEl(event.currentTarget);
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
    }, [setPendingValue, setAnchorEl, setPopperWidth, value, open, onOpen, inputProps.disabled, minPopperWidth, setCurrentWithOffset]);
    const handleClose = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e) => {
        if ((e === null || e === void 0 ? void 0 : e.target) === selectInputRef.current) {
            return;
        }
        if (multi) {
            onChange === null || onChange === void 0 ? void 0 : onChange(pendingValue);
        }
        anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.focus();
        setAnchorEl(null);
        onClose === null || onClose === void 0 ? void 0 : onClose();
        onSearch === null || onSearch === void 0 ? void 0 : onSearch('');
    }, [multi, anchorEl, onClose, onSearch, onChange, pendingValue]);
    const handleSelect = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((option) => {
        if (multi) {
            if (pendingValue.find(p => p === option)) {
                !open && (onChange === null || onChange === void 0 ? void 0 : onChange(pendingValue.filter(p => p !== option)));
                setPendingValue(pendingValue => pendingValue.filter(p => p !== option));
            }
            else {
                setPendingValue(pendingValue => [...pendingValue, option]);
            }
        }
        else {
            onChange === null || onChange === void 0 ? void 0 : onChange(option);
            handleClose();
        }
    }, [multi, props.name, pendingValue, onChange, handleClose]);
    const selectedOptions = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        if (multi) {
            let values = (open ? pendingValue : value);
            return values
                .map(val => options.find(v => v.value === val))
                .filter(p => !!p);
        }
    }, [pendingValue, value]);
    const selectedValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        var _a, _b;
        if (multi) {
            if ((selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) == 0) {
                return null;
            }
            if (oneLineMulti && !!selectedOptions) {
                return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true, spacing: 2 },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { key: selectedOptions[0].value, item: true },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Chip, { label: (_a = selectedOptions[0]) === null || _a === void 0 ? void 0 : _a.label, tabIndex: -1, disabled: selectedOptions[0].disabled, onDelete: (e) => {
                                e.stopPropagation();
                                handleSelect(selectedOptions[0].value);
                            } })),
                    (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) > 1 &&
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
                            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { alignSelf: 'flex-end', item: true },
                                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: 'body2Bold' }, "... ")),
                            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RolesCounter, { alignSelf: 'flex-end', item: true },
                                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { color: 'white', variant: 'body2Bold' },
                                    " ",
                                    selectedOptions.length,
                                    " "))));
            }
            return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true, spacing: 2 }, (selectedOptions !== null && selectedOptions !== void 0 ? selectedOptions : [])
                .sort((a, b) => a.value > b.value ? 1 : -1)
                .sort((a, b) => a.disabled === b.disabled ? 0 : a.disabled ? -1 : 1)
                .map(({ label, value, disabled }) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { key: value, item: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Chip, { label: label, tabIndex: -1, disabled: disabled, onDelete: (e) => {
                        e.stopPropagation();
                        handleSelect(value);
                    } }))));
        }
        return (_b = options.find(v => v.value === value)) === null || _b === void 0 ? void 0 : _b.label;
    }, [multi, value, options, open, selectedOptions, handleSelect]);
    const preparedSelectOptions = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        if (multi) {
            return options.map((o) => {
                if (selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.find((s) => s.value === o.value)) {
                    return Object.assign(Object.assign({}, o), { selected: true });
                }
                return o;
            });
        }
        return options;
    }, [options, selectedOptions]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Container$3, { open: open, multi: !!multi, "data-test-id": props.label, size: size },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Input$1, Object.assign({}, inputProps, { onFocus: handleClick, inputComponent: SelectInputComponent$1, inputRef: selectInputRef, inputProps: { component: Box$1, renderSelectedOption, clearable, handleSelect }, endAdornment: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ArrowDownIcon, null), onClick: handleClick, value: selectedValues, customContent: customContent })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Popper$1, { open: open, container: container, anchorEl: anchorEl, placement: 'bottom-start', keepMounted: false, 
            //TODO: consider what to do
            style: { zIndex: 1501, left: leftOffset } },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SelectPopup, { handleClose: handleClose, popperWidth: popperWidth, multi: false, onSelect: handleSelect, value: pendingValue, options: preparedSelectOptions, onSearch: onSearch, optionType: optionType !== null && optionType !== void 0 ? optionType : 'standard' })));
};
var Select$1 = Select;

const ExpandableButton = styled$1(Box$1) `
  min-width: 1.75rem;
  max-width: 1.75rem;
  width: 1.75rem;
  padding-right: 0.5rem;
  margin-bottom: -0.2rem;
`;
const ExpandableIcon$1 = styled$1(({ isExpanded, ...props }) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ArrowRightIcon, Object.assign({}, props))) `
  &.MuiSvgIcon-root {
    font-size: 0.85rem;
    height: 0.85rem;
    width: 0.85rem;
    transition: all 300ms;
    color: ${UI.palette('grey.500')};
    transform: ${({ isExpanded }) => `rotate(${isExpanded ? 90 : 0}deg)`};
  }
`;
const PopperContainer = styled$1(Box$1) `
  box-sizing: border-box;
  max-height: 18rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  margin-top: ${UI.spacing(2)};
  background: ${UI.palette('common.white')};
  border: 1px solid ${UI.palette('grey.400')};
  box-shadow: 0 0.25rem 0.75rem rgba(10, 27, 62, 0.1);
  border-radius: 0.25rem;

  > * {
    flex: 1;
  }
`;
const PopperHeader = styled$1(Grid$1) `
  padding: 0.75rem;
  border-bottom: 1px solid ${UI.palette('grey.300')};
`;
const PopperContent = styled$1(Grid$1) `
  & {
    overflow: auto;
    background: ${UI.palette('common.white')};
    max-height: 25vh;
    padding: 0.5rem 0;

    ::-webkit-scrollbar {
      width: 0.75rem;
    }

    ::-webkit-scrollbar-track {
      background: ${UI.palette('grey.100')};
      border-left: 1px solid ${UI.palette('grey.300')};
    }

    ::-webkit-scrollbar-thumb {
      border: 0.25rem solid rgba(0, 0, 0, 0);
      background-clip: padding-box;
      -webkit-border-radius: 7px;
      background-color: ${UI.palette('grey.300')};
      cursor: pointer;
    }

    ::-webkit-scrollbar-thumb:hover {
      background-color: ${UI.palette('grey.400')};
    }

    ::-webkit-scrollbar-button {
      width: 0;
      height: 0;
      display: none;
    }

    ::-webkit-scrollbar-corner {
      background-color: transparent;
    }
  }
`;
const Option = styled$1((props) => {
    const { label, value, className, onSelect, selected, withCheckbox, hovered, disabled, expandable, onExpand, isExpanded, } = props;
    const optionContainerRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        var _a;
        if (hovered) {
            (_a = optionContainerRef.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({ behavior: 'smooth' });
        }
    }, [optionContainerRef, hovered]);
    const handleExpand = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e) => {
        e.stopPropagation();
        onExpand(value);
    }, [onExpand, value]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { "aria-selected": hovered, className: className, "data-test-id": label, ref: optionContainerRef, onClick: disabled ? undefined : () => onSelect(value) },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true, alignItems: 'flex-end' },
            expandable && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ExpandableButton, { display: 'flex' },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(IconButton$1, { onClick: handleExpand },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ExpandableIcon$1, { isExpanded: isExpanded })))),
            withCheckbox && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, paddingLeft: !expandable ? '4rem' : '0' },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Checkbox$1, { size: 'small', checked: !!selected, disabled: disabled }))),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: 'selectOption' }, label)))));
}) `
  & {
    padding: ${UI.spacing(3)} ${UI.spacing(4)};
    cursor: ${({ disabled }) => (disabled ? 'unset' : 'pointer')};

    ${({ theme, disabled }) => disabled
    ? `
      cursor: unset;
      opacity: 0.6;
    `
    : `
      cursor: pointer;
      &:hover, &:focus {
        background: ${UI.palette('grey.150')({ theme })};
      }

      &:active {
        background: ${UI.palette('grey.200')({ theme })};
      }
    `};

    ${({ theme, selected, disabled }) => !disabled && selected ? `background: ${UI.palette('grey.200')({ theme })}` : ''};
    ${({ theme, hovered, disabled }) => !disabled && hovered ? `background: ${UI.palette('grey.150')({ theme })}` : ''};

    .MuiCheckbox-root {
      margin: -0.375rem 0.125rem -0.375rem -0.375rem;
      padding: 0.375rem;
    }
  }
`;
const Container$2 = styled$1(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(({ open, ...rest }, ref) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, Object.assign({}, rest, { ref: ref })))) `
  & {
    .MuiOutlinedInput-root {
      background: ${UI.palette('grey.100')};
      min-width: 300px;
      box-shadow: none;

      &.Mui-focused {
        outline: none;
      }

      &:hover {
        background: ${({ theme }) => `linear-gradient(180deg, ${theme.palette.grey[100]} 0%, ${theme.palette.default.hover} 100%)`};
      }

      ${({ open, theme }) => open
    ? `background: linear-gradient(180deg, ${theme.palette.grey[100]} 0%, ${theme.palette.default.hover} 100%)`
    : ''};

      .MuiOutlinedInput-input {
        min-height: 1.25rem;
        height: unset;
        padding-left: ${UI.spacing(2)}
      }
    }

    .MuiSvgIcon-root {
      width: ${UI.spacing(3)};
    }

    .MuiChip-root {
      margin: -0.3rem 0 -0.2rem;
    }
  }
}
`;
const PlaceHolder = styled$1('div') `
  color: ${UI.palette('grey.600')};
`;
const SelectInputContainer = styled$1('div') `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-left: 0.5rem;
  padding-right: 0.5rem;
`;
const CloseButton = styled$1(IconButton$1) `
  &.MuiIconButton-root {
    margin: -0.75rem 0 -0.75rem;
    height: 2rem;
  }
`;
const SelectInputComponent = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.forwardRef((props, ref) => {
    var _a;
    const { component: Component, children, renderSelectedOption, handleSelect } = props, componentProps = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(props, ["component", "children", "renderSelectedOption", "handleSelect"]);
    const { value, placeholder, clearable } = componentProps;
    const clearValue = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e) => {
        e.stopPropagation();
        handleSelect(null);
    }, [handleSelect]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Component, Object.assign({ tabIndex: 0 }, componentProps, { ref: ref }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SelectInputContainer, null,
            value ? (_a = renderSelectedOption === null || renderSelectedOption === void 0 ? void 0 : renderSelectedOption(value)) !== null && _a !== void 0 ? _a : value : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PlaceHolder, null, placeholder || ' '),
            value && clearable ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CloseButton, { onFocus: (e) => {
                    e.stopPropagation();
                }, onClick: clearValue },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CloseIcon, null))) : (''))));
});

const SelectTreePopup = (props) => {
    const { handleClose, popperWidth, options, onSearch, onSelect, in: _in, onEnter, onExit } = props;
    const inputRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
    const containerRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
    const [searching, setSearching] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const [openCategories, setOpenCategories] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useState([]);
    const handleClick = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((val) => {
        if (openCategories.includes(val)) {
            setOpenCategories((openCategories) => [...openCategories.filter((i) => i !== val)]);
        }
        else {
            setOpenCategories((openCategories) => [...openCategories, val]);
        }
    }, [openCategories]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (_in) {
            setTimeout(() => {
                var _a;
                onSearch && ((_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus());
            }, 200);
        }
    }, [_in, onSearch]);
    const handleSearch = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e) => (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.g)(void 0, void 0, void 0, function* () {
        setSearching(true);
        yield (onSearch === null || onSearch === void 0 ? void 0 : onSearch(e.target.value));
        setSearching(false);
    }), [onSearch, setSearching]);
    const optionsListTree = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        const sortByValue = (a, b) => (a.value > b.value ? 1 : -1);
        const sortByDisabled = (a, b) => (a.value > b.value ? 1 : -1);
        return options
            .sort(sortByValue)
            .sort(sortByDisabled)
            .map((optionProps, index) => {
            const { categoryItems } = optionProps, optionProp = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(optionProps, ["categoryItems"]);
            const isExpanded = openCategories.includes(optionProp.value);
            return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, { key: index },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Option, Object.assign({}, optionProp, { onSelect: onSelect, isExpanded: isExpanded, expandable: true, onExpand: (val) => handleClick(val) })),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Collapse$1, { in: isExpanded, timeout: 'auto' }, categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.map(({ withCheckbox, selected, label, value }, idx) => {
                    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, null,
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Option, { key: idx, withCheckbox: withCheckbox, selected: selected, label: label, value: value, onSelect: onSelect })));
                }))));
        });
    }, [options, handleClick, onSelect, openCategories]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PopperContainer, { ref: containerRef, width: popperWidth },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ClickAwayListener, { mouseEvent: 'onMouseDown', onClickAway: handleClose },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true, direction: 'column', wrap: 'nowrap', overflow: 'hidden' },
                onSearch && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PopperHeader, { item: true },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Input$1, { inputRef: inputRef, loading: searching, onChange: handleSearch, endAdornment: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SearchIcon, null), "data-test-id": 'search', placeholder: 'Search for any text' }))),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PopperContent, { tabIndex: 0, item: true }, optionsListTree))));
};

const SelectTree = (props) => {
    const { options, container, value, onChange, onSearch, renderSelectedOption, onOpen, onClose, clearable } = props, inputProps = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(props, ["options", "container", "value", "onChange", "onSearch", "renderSelectedOption", "onOpen", "onClose", "clearable"]);
    const [anchorEl, setAnchorEl] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useState(null);
    const selectInputRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useRef(null);
    const [pendingValue, setPendingValue] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useState([]);
    const [popperWidth, setPopperWidth] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useState(0);
    const open = Boolean(anchorEl);
    const handleClick = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((event) => {
        if (open) {
            return;
        }
        setPendingValue(value !== null && value !== void 0 ? value : []);
        setPopperWidth(event.currentTarget.offsetWidth);
        setAnchorEl(event.currentTarget);
        onOpen === null || onOpen === void 0 ? void 0 : onOpen();
    }, [setPendingValue, setAnchorEl, setPopperWidth, value, open, onOpen]);
    const handleClose = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e) => {
        if ((e === null || e === void 0 ? void 0 : e.target) === selectInputRef.current) {
            return;
        }
        onChange === null || onChange === void 0 ? void 0 : onChange(pendingValue);
        anchorEl === null || anchorEl === void 0 ? void 0 : anchorEl.focus();
        setAnchorEl(null);
        onClose === null || onClose === void 0 ? void 0 : onClose();
        onSearch === null || onSearch === void 0 ? void 0 : onSearch('');
    }, [anchorEl, onClose, onSearch, onChange, pendingValue]);
    const handleSelect = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((optionId) => {
        var _a, _b;
        if (!optionId) {
            !open && (onChange === null || onChange === void 0 ? void 0 : onChange([]));
            setPendingValue([]);
        }
        else {
            const categoryOption = options.find((o) => o.value === optionId);
            const isOptionAlreadySelected = !!pendingValue.find((p) => p === optionId);
            const filterPendingValue = (pendingValue) => pendingValue.filter((val) => val !== optionId);
            const filterValues = () => {
                !open && (onChange === null || onChange === void 0 ? void 0 : onChange(filterPendingValue(pendingValue)));
                setPendingValue((pendingValue) => filterPendingValue(pendingValue));
            };
            if (!!categoryOption) {
                if (isOptionAlreadySelected) {
                    filterValues();
                }
                else {
                    const categoryOptions = (_b = (_a = categoryOption === null || categoryOption === void 0 ? void 0 : categoryOption.categoryItems) === null || _a === void 0 ? void 0 : _a.map((i) => i.value)) !== null && _b !== void 0 ? _b : [];
                    setPendingValue((pendingValue) => [...pendingValue, optionId, ...categoryOptions].filter(uniqueValues));
                }
            }
            else {
                if (isOptionAlreadySelected) {
                    filterValues();
                }
                else {
                    setPendingValue((pendingValue) => [...pendingValue, optionId]);
                }
                const selectedCategories = options.filter((o) => pendingValue.includes(o.value));
                selectedCategories.forEach(({ categoryItems, value }) => {
                    const filteredPendingValue = pendingValue.filter((p) => p !== optionId);
                    const catItemsInPending = categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.filter((c) => filteredPendingValue.includes(c.value));
                    if ((catItemsInPending === null || catItemsInPending === void 0 ? void 0 : catItemsInPending.length) !== (categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.length)) {
                        setPendingValue((pendingValue) => [...pendingValue.filter((p) => p !== value && p !== optionId)]);
                    }
                });
            }
        }
    }, [options, pendingValue, open, onChange]);
    const preparedOptions = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        let values = (open ? pendingValue : value);
        const preparedOptions = options.map((option) => {
            var _a, _b, _c;
            let dynamicOptionProperties = {};
            const categoryItems = (_a = option.categoryItems) === null || _a === void 0 ? void 0 : _a.map((i) => i.value);
            const filteredCategoryItems = values === null || values === void 0 ? void 0 : values.filter((s) => categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.includes(s));
            const preparedCategoryItems = (_b = option.categoryItems) === null || _b === void 0 ? void 0 : _b.map((i) => {
                if (filteredCategoryItems.includes(i.value)) {
                    return Object.assign(Object.assign({}, i), { selected: true });
                }
                return i;
            });
            if (values.includes(option.value)) {
                if (filteredCategoryItems.length === (categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.length) && option.selected) {
                    dynamicOptionProperties = { selected: false, categoryItems: preparedCategoryItems };
                }
                else {
                    const _categoryItems = (_c = option === null || option === void 0 ? void 0 : option.categoryItems) === null || _c === void 0 ? void 0 : _c.map((i) => (Object.assign(Object.assign({}, i), { selected: true })));
                    dynamicOptionProperties = { selected: true, categoryItems: _categoryItems };
                }
            }
            else if (values.find((v) => categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.includes(v))) {
                dynamicOptionProperties = { categoryItems: preparedCategoryItems };
            }
            return Object.assign(Object.assign({}, option), dynamicOptionProperties);
        });
        return preparedOptions;
    }, [open, options, pendingValue, value]);
    const selectedValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        const sortByValue = (a, b) => (a.value > b.value ? 1 : -1);
        const sortByDisabled = (a, b) => a.disabled === b.disabled ? 0 : a.disabled ? -1 : 1;
        const isEmptyValue = (open && (pendingValue === null || pendingValue === void 0 ? void 0 : pendingValue.length) === 0) || (!open && value && (value === null || value === void 0 ? void 0 : value.length) === 0);
        if (isEmptyValue) {
            return null;
        }
        return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true, spacing: 2 }, (preparedOptions !== null && preparedOptions !== void 0 ? preparedOptions : [])
            .sort(sortByValue)
            .sort(sortByDisabled)
            .map(({ label, value, disabled, category, categoryItems, selected }) => {
            if (category && selected) {
                return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { key: value, item: true },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Chip, { label: `${label}*`, tabIndex: -1, disabled: disabled, onDelete: (e) => {
                            e.stopPropagation();
                            handleSelect(value);
                        } })));
            }
            return categoryItems === null || categoryItems === void 0 ? void 0 : categoryItems.map(({ value, label, disabled, selected }) => {
                if (selected) {
                    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { key: value, item: true },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Chip, { label: label, tabIndex: -1, disabled: disabled, onDelete: (e) => {
                                e.stopPropagation();
                                handleSelect(value);
                            } })));
                }
                return null;
            });
        })));
    }, [open, pendingValue === null || pendingValue === void 0 ? void 0 : pendingValue.length, value, preparedOptions, handleSelect]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Container$2, { open: open, "data-test-id": props.label },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Input$1, Object.assign({}, inputProps, { onFocus: handleClick, inputComponent: SelectInputComponent, inputRef: selectInputRef, inputProps: { component: Box$1, renderSelectedOption, clearable, handleSelect }, endAdornment: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ArrowDownIcon, null), onClick: handleClick, value: selectedValues })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Popper$1, { open: open, container: container, anchorEl: anchorEl, placement: 'bottom-start', keepMounted: false, style: { zIndex: 1501 } },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SelectTreePopup, { handleClose: handleClose, popperWidth: popperWidth, tree: true, onSelect: handleSelect, value: pendingValue, options: preparedOptions, onSearch: onSearch }))));
};
var SelectTree$1 = SelectTree;

const Switch = (_a) => {
    var props = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, []);
    const { labels } = props;
    if (!!(labels === null || labels === void 0 ? void 0 : labels.length)) {
        return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true, alignItems: "center", justifyContent: "center", spacing: 3 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: "switchLabel" }, labels[0])),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Switch$3, Object.assign({}, props, { "data-test-id": labels }))),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: "switchLabel" }, labels[1]))));
    }
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Switch$3, Object.assign({}, props));
};
var Switch$1 = Switch;

const rotateArrayRight = (array, rotates) => {
    for (let i = 0; i < rotates; i++) {
        const item = array.pop();
        if (item) {
            array.unshift(item);
        }
    }
    return array;
};
const rotateArrayLeft = (array, rotates) => {
    for (let i = 0; i < rotates; i++) {
        const item = array.shift();
        if (item) {
            array.push(item);
        }
    }
    return array;
};
const activeItemClassName = 'item-3';
const initialClassNames = ['item-1', 'item-2', activeItemClassName, 'item-4', 'item-5'];
const getClassNames = (numberOfItems, initialIndex) => {
    let classNames = initialClassNames.slice(Math.floor(initialClassNames.length / 2) - Math.floor(numberOfItems / 2), Math.floor(initialClassNames.length / 2) + Math.ceil(numberOfItems / 2));
    if (initialIndex !== undefined) {
        const rotates = classNames.indexOf(activeItemClassName) - initialIndex;
        classNames = rotates < 0 ? rotateArrayRight([...classNames], Math.abs(rotates)) : rotateArrayLeft([...classNames], rotates);
    }
    return classNames;
};

const useMuiMediaQuery = (themeBreakpoints) => {
    const { iframeRendering, rootEl } = useShadowDom();
    const iframeWindowObj = iframeRendering && rootEl.ownerDocument ? rootEl.ownerDocument.defaultView : null;
    const mediaQueryOptions = iframeWindowObj ? { matchMedia: iframeWindowObj === null || iframeWindowObj === void 0 ? void 0 : iframeWindowObj.matchMedia } : undefined;
    return useMediaQuery(themeBreakpoints, mediaQueryOptions);
};

function usePrevious(value) {
    const ref = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}

const AnimatedCardCarouselNavigatorIconButton = styled$1(IconButton$1)(({ theme }) => (Object.assign({ position: 'absolute', zIndex: 200, '&.right': {
        right: '5%',
    }, '&.left': {
        left: '5%'
    } }, theme.carouselArrowsContainerStyle)));
const ActionsNavigatorIconButton = styled$1(IconButton$1)(({ theme }) => (Object.assign({}, theme.carouselArrowsContainerStyle)));
const AnimatedCardCarouselCardsContainer = styled$1(Box$1)(({ theme }) => ({
    alignItems: 'center',
    display: 'flex',
    margin: '0 auto',
    position: 'relative',
    width: '100%',
    [theme.breakpoints.up('sm')]: {
        minHeight: '32.5rem',
    }
}));
const Indicator = styled$1(Box$1)(({ theme }) => (Object.assign(Object.assign({ height: '0.625rem', width: '0.625rem', borderRadius: '50%', backgroundColor: 'grey', transition: 'all 0.3s ease-in-out' }, theme.carouselIndicatorStyle), { '&.active': Object.assign({ width: '2rem', backgroundColor: theme.palette.primary.main, borderRadius: '1.875rem' }, theme.carouselActiveIndicatorStyle) })));
const ActionsContainer = styled$1(Box$1)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    columnGap: '3rem',
    height: '2.5rem',
});
const IndicatorsContainer = styled$1(Box$1)({
    display: 'flex',
    justifyContent: 'center',
    minWidth: '6.25',
    columnGap: '0.25rem',
});
const AnimatedCardCarouselItem = styled$1(Box$1)(({ open, runMountAnimation, openCarouselAnimationDuration, closeCarouselAnimationDuration, runNavigationAnimation }) => ({
    position: 'absolute',
    transition: runNavigationAnimation ? 'all 0.3s ease-in-out' : 'initial',
    zIndex: 0,
    maxWidth: '90%',
    'div:first-of-type': {
        maxWidth: '100%',
    },
    '&.item-1': open ? {
        left: '25%',
        transform: 'translateX(-70%) scale(0.7)',
        width: '20rem',
        animation: runMountAnimation ? `swipe-left ${openCarouselAnimationDuration}s ease-in-out 1` : '',
        "@keyframes swipe-left": {
            "0%": {
                left: '50%',
            },
            "100%": {
                left: '25%'
            }
        },
    } : {
        left: '50%',
        opacity: 0,
        width: '20rem',
        transform: 'translateX(-70%) scale(0.7)',
        animation: `swipe-back ${closeCarouselAnimationDuration}s ease-in-out 1`,
        "@keyframes swipe-back": {
            "0%": {
                opacity: 1,
                left: '25%',
            },
            "100%": {
                opacity: 0,
                left: '50%'
            }
        },
    },
    '&.item-2': open ? {
        zIndex: 1,
        left: '37%',
        transform: 'translateX(-70%)',
        width: '20rem',
        animation: runMountAnimation ? `swipe-left-2 ${openCarouselAnimationDuration / 2}s ease-in-out 1` : '',
        "@keyframes swipe-left-2": {
            "0%": {
                left: '50%',
            },
            "100%": {
                left: '37%'
            }
        },
    } : {
        zIndex: 1,
        left: '50%',
        opacity: 0,
        width: '20rem',
        transform: 'translateX(-70%)',
        animation: `swipe-back-2 ${closeCarouselAnimationDuration}s ease-in-out 1`,
        "@keyframes swipe-back-2": {
            "0%": {
                opacity: 1,
                left: '37%',
            },
            "100%": {
                opacity: 0,
                left: '50%'
            }
        }
    },
    '&.item-3': {
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 2,
        width: '29rem',
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
    },
    '&.item-4': open ? {
        zIndex: 1,
        left: '63%',
        transform: 'translateX(-30%)',
        width: '20rem',
        animation: runMountAnimation ? `swipe-right ${openCarouselAnimationDuration / 2}s ease-in-out 1` : '',
        "@keyframes swipe-right": {
            "0%": {
                left: '50%',
            },
            "100%": {
                left: '63%'
            }
        },
    } : {
        zIndex: 1,
        left: '50%',
        opacity: 0,
        width: '20rem',
        transform: 'translateX(-30%)',
        animation: `swipe-back-3 ${closeCarouselAnimationDuration}s ease-in-out 1`,
        "@keyframes swipe-back-3": {
            "0%": {
                opacity: 1,
                left: '63%',
            },
            "100%": {
                opacity: 0,
                left: '50%'
            }
        }
    },
    '&.item-5': open ? {
        left: '75%',
        width: '20rem',
        transform: 'translateX(-30%) scale(0.7)',
        animation: runMountAnimation ? `swipe-right-2 ${openCarouselAnimationDuration}s ease-in-out 1` : '',
        "@keyframes swipe-right-2": {
            "0%": {
                left: '50%',
            },
            "100%": {
                left: '75%'
            }
        }
    } : {
        left: '50%',
        opacity: 0,
        width: '20rem',
        transform: 'translateX(-30%) scale(0.7)',
        animation: `swipe-back-4 ${closeCarouselAnimationDuration}s ease-in-out 1`,
        "@keyframes swipe-back-4": {
            "0%": {
                opacity: 1,
                left: '75%',
            },
            "100%": {
                opacity: 0,
                left: '50%'
            }
        }
    },
}));
const StyledArrowRightIcon = styled$1(ArrowRightIcon)(({ theme }) => (Object.assign({}, theme.carouselArrowsStyle)));
const StyledArrowLeftIcon = styled$1(ArrowRightIcon)(({ theme }) => (Object.assign({ transform: 'rotate(180deg)' }, theme.carouselArrowsStyle)));
const AnimatedCardCarousel = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ items, onActiveItemChange, activeIndex, open = true, openCarouselAnimationDuration = 2, closeCarouselAnimationDuration = 0.5, onOpenCarouselAnimationFinish, onCloseCarouselAnimationFinish }) => {
    const [runMountAnimation, setRunMountAnimation] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(true);
    const theme = useTheme();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        setTimeout(() => setRunMountAnimation(false), openCarouselAnimationDuration * 1000);
    }, [openCarouselAnimationDuration]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (!items[activeIndex]) {
            onActiveItemChange(0);
        }
    }, [onActiveItemChange, items.length, activeIndex]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        let timeout;
        if (open && onOpenCarouselAnimationFinish) {
            timeout = setTimeout(onOpenCarouselAnimationFinish, (openCarouselAnimationDuration * 1000) + 300);
        }
        else if (!open && onCloseCarouselAnimationFinish) {
            timeout = setTimeout(onCloseCarouselAnimationFinish, (closeCarouselAnimationDuration * 1000) + 300);
        }
        return () => clearTimeout(timeout);
    }, [open, onOpenCarouselAnimationFinish, onCloseCarouselAnimationFinish]);
    const onNextItemClick = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((rotates = 1) => {
        setRunMountAnimation(false);
        onActiveItemChange((activeIndex + rotates) % items.length);
    }, [setRunMountAnimation, onActiveItemChange, items.length]);
    const onPreviousItemClick = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((rotates = 1) => {
        setRunMountAnimation(false);
        onActiveItemChange(activeIndex - rotates >= 0 ? activeIndex - rotates : items.length - rotates);
    }, [setRunMountAnimation, onActiveItemChange, items.length, activeIndex]);
    const onItemClick = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((index) => {
        if (index < activeIndex) {
            onPreviousItemClick(activeIndex - index);
        }
        else {
            onNextItemClick(index - activeIndex);
        }
    }, [activeIndex, onPreviousItemClick, onNextItemClick]);
    const shouldDisplayCarouselNavigatorItems = useMuiMediaQuery(theme.breakpoints.up('xl'));
    const previousItemsLength = usePrevious(items.length);
    const runNavigationAnimation = previousItemsLength === items.length;
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AnimatedCardCarouselCardsContainer, null,
            getClassNames(items.length, activeIndex)
                .map((className, index) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AnimatedCardCarouselItem, { key: index, runNavigationAnimation: runNavigationAnimation, className: className, onClick: () => onItemClick(index), open: open, runMountAnimation: runMountAnimation, openCarouselAnimationDuration: openCarouselAnimationDuration, closeCarouselAnimationDuration: closeCarouselAnimationDuration }, items[index])),
            shouldDisplayCarouselNavigatorItems && items.length > 1 && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AnimatedCardCarouselNavigatorIconButton, { onClick: () => onNextItemClick(1), className: 'right' },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StyledArrowRightIcon, null)),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AnimatedCardCarouselNavigatorIconButton, { onClick: () => onPreviousItemClick(1), className: 'left' },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StyledArrowLeftIcon, null)))),
        items.length > 1 && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ActionsContainer, null,
            !shouldDisplayCarouselNavigatorItems && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ActionsNavigatorIconButton, { onClick: () => onPreviousItemClick(1) },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StyledArrowLeftIcon, null)),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(IndicatorsContainer, null, getClassNames(items.length, activeIndex).map((_, index) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Indicator, { onClick: () => onItemClick(index), key: index, className: index === activeIndex ? 'active' : '' }))),
            !shouldDisplayCarouselNavigatorItems && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ActionsNavigatorIconButton, { onClick: () => onNextItemClick(1) },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StyledArrowRightIcon, null)))));
}, shallowEqual('items', 'onActiveChange', 'activeIndex', 'open', 'openCarouselAnimationDuration', 'closeCarouselAnimationDuration', 'onOpenCarouselAnimationFinish', 'onCloseCarouselAnimationFinish'));
var AnimatedCardCarousel$1 = AnimatedCardCarousel;

const SingleOTCInput = (_a) => {
    var { focus, autoFocus } = _a, props = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["focus", "autoFocus"]);
    const inputRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
    const prevFocus = usePrevious(!!focus);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useLayoutEffect(() => {
        if (inputRef.current) {
            if (focus && autoFocus) {
                inputRef.current.focus();
            }
            if (focus && autoFocus && focus !== prevFocus) {
                inputRef.current.focus();
                inputRef.current.select();
            }
        }
    }, [autoFocus, focus, prevFocus]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Input$1, Object.assign({ inputProps: { sx: { textAlign: 'center' } }, inputRef: inputRef }, props));
};

const OTCInput = (props) => {
    const { length, isNumberInput, autoFocus, disabled, onChangeOTP, inputClassName, inputStyle } = props, rest = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(props, ["length", "isNumberInput", "autoFocus", "disabled", "onChangeOTP", "inputClassName", "inputStyle"]);
    const [activeInput, setActiveInput] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(0);
    const [otpValues, setOTPValues] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(Array(length).fill(''));
    const handleOtpChange = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((otp) => {
        const otpValue = otp.join('');
        onChangeOTP(otpValue);
    }, [onChangeOTP]);
    const getRightValue = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((str) => {
        let changedValue = str;
        if (!isNumberInput || !changedValue) {
            return changedValue;
        }
        return Number(changedValue) >= 0 ? changedValue : '';
    }, [isNumberInput]);
    const changeCodeAtFocus = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((str) => {
        const updatedOTPValues = [...otpValues];
        updatedOTPValues[activeInput] = str[0] || '';
        setOTPValues(updatedOTPValues);
        handleOtpChange(updatedOTPValues);
    }, [activeInput, handleOtpChange, otpValues]);
    const focusInput = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((inputIndex) => {
        const selectedIndex = Math.max(Math.min(length - 1, inputIndex), 0);
        setActiveInput(selectedIndex);
    }, [length]);
    const focusPrevInput = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        focusInput(activeInput - 1);
    }, [activeInput, focusInput]);
    const focusNextInput = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        focusInput(activeInput + 1);
    }, [activeInput, focusInput]);
    const handleOnFocus = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((index) => () => {
        focusInput(index);
    }, [focusInput]);
    const handleOnChange = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e) => {
        const val = getRightValue(e.currentTarget.value);
        if (!val) {
            e.preventDefault();
            return;
        }
        changeCodeAtFocus(val);
        focusNextInput();
    }, [changeCodeAtFocus, focusNextInput, getRightValue]);
    const onBlur = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setActiveInput(-1);
    }, []);
    const handleOnKeyDown = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e) => {
        const pressedKey = e.key;
        switch (pressedKey) {
            case 'Backspace':
            case 'Delete': {
                e.preventDefault();
                if (otpValues[activeInput]) {
                    changeCodeAtFocus('');
                }
                if (activeInput > 0) {
                    focusPrevInput();
                }
                break;
            }
            case 'ArrowLeft': {
                e.preventDefault();
                focusPrevInput();
                break;
            }
            case 'ArrowRight': {
                e.preventDefault();
                focusNextInput();
                break;
            }
            default: {
                if (pressedKey.match(/^[^a-zA-Z0-9]$/)) {
                    e.preventDefault();
                }
                break;
            }
        }
    }, [activeInput, changeCodeAtFocus, focusNextInput, focusPrevInput, otpValues]);
    const handleOnPaste = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e) => {
        e.preventDefault();
        const pastedData = e.clipboardData
            .getData('text/plain')
            .trim()
            .slice(0, length - activeInput)
            .split('');
        if (pastedData) {
            let nextFocusIndex = 0;
            const updatedOTPValues = [...otpValues];
            updatedOTPValues.forEach((val, index) => {
                if (index >= activeInput) {
                    const changedValue = getRightValue(pastedData.shift() || val);
                    if (changedValue) {
                        updatedOTPValues[index] = changedValue;
                        nextFocusIndex = index;
                    }
                }
            });
            setOTPValues(updatedOTPValues);
            handleOtpChange(updatedOTPValues);
            setActiveInput(Math.min(nextFocusIndex + 1, length - 1));
        }
    }, [activeInput, getRightValue, length, otpValues]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, Object.assign({ display: 'flex', columnGap: 3 }, rest), Array(length)
        .fill('')
        .map((_, index) => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SingleOTCInput, { key: `SingleInput-${index}`, type: isNumberInput ? 'number' : 'text', focus: activeInput === index, value: otpValues && otpValues[index], autoFocus: autoFocus, onFocus: handleOnFocus(index), onChange: handleOnChange, onKeyDown: handleOnKeyDown, onBlur: onBlur, onPaste: handleOnPaste, style: inputStyle, className: inputClassName, disabled: disabled })))));
};
var OTCInput$1 = OTCInput;

const DisplayBySize = (props) => {
    const theme = useTheme();
    const xl = useMediaQuery(theme.breakpoints.up('xl'));
    const lg = useMediaQuery(theme.breakpoints.up('lg'));
    const md = useMediaQuery(theme.breakpoints.up('md'));
    const sm = useMediaQuery(theme.breakpoints.up('sm'));
    const xs = useMediaQuery(theme.breakpoints.up('xs'));
    const queryIcon = [
        { id: 'xl', active: xl },
        { id: 'lg', active: lg },
        { id: 'md', active: md },
        { id: 'sm', active: sm },
        { id: 'xs', active: xs },
    ].find(size => {
        if (size.active && props[size.id]) {
            return props[size.id];
        }
    });
    if (queryIcon) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null, props[queryIcon.id]);
    }
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null, props.default);
};
const NavigationItem = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((props, ref) => {
    const icon = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        if (props.icon.default) {
            return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DisplayBySize, Object.assign({}, props.icon));
        }
        return props.icon;
    }, [props.icon]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(NavigationListItem$1, { ref: ref, selected: props.selected, disabled: props.disabled, onClick: props.onClick, "data-test-id": props.id },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ListItemIcon$1, null, icon),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ListItemText$1, { primary: props.title }));
});
const NavigationGroupTitle = styled$1(ListItem$1) `
  &.MuiListItem-root {
    padding: ${({ theme }) => `${theme.spacing(4)} ${theme.spacing(4)} ${theme.spacing(6)}`};

    .MuiTypography-root {
      text-transform: uppercase;
      font-weight: bold;
      line-height: 1rem;
      font-size: ${({ theme }) => theme.navigation.groupTitleSize};
      color: ${({ theme }) => theme.navigation.groupTitleColor};
      letter-spacing: 0.05em;
    }
  }
`;
const NavigationItemGroup = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((props, ref) => {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(NavigationGroupTitle, { button: false },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ListItemText$1, { primary: props.title }));
});

const NavigationListItemIcon = styled$1(ListItemIcon$1)(({ theme }) => ({
    width: '2rem',
    height: '2rem',
    opacity: '1',
    transition: 'width 300ms, opacity 200ms',
    margin: '6px 0.5rem auto -1rem',
    [theme.breakpoints.down('xl')]: {
        width: 0,
        opacity: 0,
        marginRight: '1.2rem',
    },
    '.MuiAvatar-root': {
        width: '2rem',
        height: '2rem',
        fontSize: '0.75rem',
        fontWeight: '600',
    },
}));
// TODO: fix theme
const NavigationListItemText = styled$1(ListItemText$1)(({ theme }) => ({
    '& > .MuiTypography-root': {
        fontSize: '0.75rem',
        color: theme.navigation.subHeaderColor,
        '&:first-of-type': {
            color: theme.navigation.headerColor,
            fontWeight: 'bold',
            fontSize: '0.875rem',
        },
    },
}));
const NavigationHeader = ({ user }) => {
    var _a, _b;
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ListItem$1, { component: Box$1, sx: { pt: 4, mb: 2 } },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(NavigationListItemIcon, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Avatar$1, { name: (_a = user === null || user === void 0 ? void 0 : user.name) !== null && _a !== void 0 ? _a : '', picture: user === null || user === void 0 ? void 0 : user.profilePictureUrl })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(NavigationListItemText, { disableTypography: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { noWrap: true, style: { fontWeight: 'bold' } }, (_b = user === null || user === void 0 ? void 0 : user.name) !== null && _b !== void 0 ? _b : 'Not Logged In'),
            (user === null || user === void 0 ? void 0 : user.email) && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { noWrap: true }, user.email)));
};

const Navigation = props => {
    const { user, items, children, onRedirectTo } = props;
    const handleClick = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(({ path }) => onRedirectTo(path), [onRedirectTo]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(List$1, { component: "nav" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(NavigationHeader, { user: user }),
        items.map((group, key) => {
            return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, { key: key },
                group.title && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(NavigationItemGroup, Object.assign({}, group)),
                group.items.map(item => { var _a; return (item === null || item === void 0 ? void 0 : item.visibility) === 'hidden' ? null : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(NavigationItem, Object.assign({ key: item.title }, item, { disabled: (_a = item.disabled) !== null && _a !== void 0 ? _a : !user, onClick: () => handleClick(item) })); }));
        }),
        children);
};

const PageHeaderContext = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createContext({ title: '', setState: () => { } });
const PageHeaderProvider = (props) => {
    const [state, setState] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState({ title: '' });
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageHeaderContext.Provider, { value: Object.assign(Object.assign({}, state), { setState }) }, props.children);
};
const PageHeaderUpdater = ({ title, children }) => {
    const context = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(PageHeaderContext);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        context.setState({ title, children });
    }, [title, children]);
    return null;
};

const Container$1 = styled$1(Grid$1)(({ theme }) => {
    var _a;
    return (Object.assign({ minHeight: theme.spacing(21.25), justifyContent: 'center', alignItems: 'center', paddingRight: '2rem', borderBottom: `1px solid ${theme.palette.divider}` }, (_a = theme === null || theme === void 0 ? void 0 : theme.pages) === null || _a === void 0 ? void 0 : _a.header));
});
Container$1.defaultProps = {
    container: true,
    spacing: 0,
};
const IconButtonStyle = styled$1(IconButton$1)(({ theme }) => ({
    marginTop: '-1.7em',
    marginRight: '-0.8em',
    '.MuiSvgIcon-root': {
        width: '1rem',
        height: '1rem',
        color: theme.palette.grey[500],
    },
}));
const PageHeader = (props) => {
    const { openDrawer, onClose } = props;
    const { title, children } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(PageHeaderContext);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Container$1, { "data-test-id": 'page-header-container' },
        openDrawer && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { pl: 2, item: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(IconButton$1, { onClick: openDrawer },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DrawerIcon, null))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, p: openDrawer ? 4 : 6, pb: openDrawer ? 4 : 6, pt: openDrawer ? 4 : 8 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: openDrawer ? 'pageTitleSmall' : 'pageTitle' }, title || ' ')),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, xs: true }),
        children && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true }, children),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(IconButtonStyle, { onClick: onClose },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CloseIcon, null))));
};

const ActionButton$1 = styled$1(IconButton$1) `
  &.MuiButtonBase-root.MuiIconButton-root {
    margin: -1rem -1rem -1rem 1.5rem;

    .MuiSvgIcon-root {
      width: .75rem;
      height: .75rem;
    }

    &:not(.Mui-disabled) {
      .MuiSvgIcon-root {
        color: ${({ theme }) => theme.palette.icon.action};
      }
    }
  }
`;
const CustomActions = styled$1(Grid$1) `
  &.MuiGrid-root {
    margin-right: -1.75rem;

    .MuiSwitch-root {
      margin: -0.8125rem 0;
      top: 2px;
    }
  }
`;
const Container = styled$1(({ disabledRow, ...props }) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, Object.assign({}, props))) `
  &{
    border-bottom: 1px solid ${({ theme }) => theme.palette.divider};
    justify-content: space-between;
    align-items: center;
    flex-wrap: nowrap;
    ${({ disabledRow }) => disabledRow ? 'opacity: 0.4' : `none`}

  }

  & .MuiChip-root {
    margin-top: -.5rem;
    margin-bottom: -.5rem;
  }
`;
const TitleWithCheckboxContainer = styled$1(Grid$1) `
  &.MuiGrid-root {
    margin-left: -1rem;
  }

  & .MuiCheckbox-root {
    margin-right: 16px;
    padding: 0;
  }
`;
const Title = ({ children }) => {
    return children ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, xs: 3, container: true, alignItems: 'center' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, xs: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: 'body1Bold' }, children))) : null;
};
const TitleWithCheckbox = ({ children }) => {
    return children ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TitleWithCheckboxContainer, { item: true, minWidth: 130, alignItems: 'center' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: 'body1Bold' }, children)) : null;
};
const Description$1 = ({ children }) => {
    return children ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, xs: true, container: true, alignItems: 'center' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, xs: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: 'body1' }, children))) : null;
};
const Value = ({ children, id }) => {
    if (!children) {
        return null;
    }
    if (typeof children === 'string') {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, xs: true, container: true, alignItems: 'center' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, xs: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { "data-test-id": `${id}-value`, variant: 'body1', component: 'span' }, children)));
    }
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, xs: true, container: true, alignItems: 'center' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, xs: true }, children));
};
const Action = ({ children }) => {
    return children ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CustomActions, { item: true }, children) : null;
};
const OnEditDialog = (props) => {
    return props.onEditClick ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ActionButton$1, { "data-test-id": `edit-${props.id}-btn`, onClick: () => { var _a; return (_a = props.onEditClick) === null || _a === void 0 ? void 0 : _a.call(props, props); }, disabled: props.disabled },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditIcon, null))) : null;
};
const SettingsListItem = (props) => {
    const { id, title, description, value, actions, titleWithCheckbox, disabledRow, testId } = props;
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Container, { disabledRow: disabledRow, container: true, pl: 10, pr: 10, spacing: 4, alignItems: 'center', height: 84, "data-test-id": testId || id },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TitleWithCheckbox, { children: titleWithCheckbox }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Title, { children: title }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Description$1, { children: description }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Value, { id: id, children: value }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Action, { children: actions }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(OnEditDialog, Object.assign({}, props)));
};

const SettingListTitle = styled$1(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((props, ref) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, Object.assign({ variant: 'subtitle1', ref: ref }, props)))) `
  & + * {
    margin-top: 1rem;
  }
`;
const SettingListCard = styled$1(Card$1) `
  &.MuiCard-root {
    padding: 0;
    background-color: ${({ theme }) => theme.rightPanel.elementBackground};
  }
`;
const SettingsList = props => {
    const { title, items } = props;
    const children = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => items.map((item) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SettingsListItem, Object.assign({ key: item.id, onEditClick: props.onEditClick }, item))), [items]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, null,
        title && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SettingListTitle, null, title),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SettingListCard, null, children));
};

const FilterButton = styled$1(Button$1) `
  &.MuiButtonBase-root {
    position: absolute;
    padding: 0;
    width: 28px;
    height: 56px;
    min-width: 0;
    right: 0;
    margin-top: -20px;
    border: none;
    border-radius: 0;
    box-shadow: none;
    background-color: ${({ filtered, opened }) => (filtered || opened ? UI.palette('grey.300') : UI.palette('grey.150'))};
    stroke: ${({ filtered, opened }) => (filtered ? UI.palette('switchButton.main') : opened ? UI.palette('grey.700') : UI.palette('grey.500'))};
  }

  &.MuiButtonBase-root:hover {
    background-color: ${UI.palette('grey.300')};
    stroke: ${UI.palette('grey.700')};
  }

  & .MuiSvgIcon-root {
    width: 0.75rem;
    height: 0.75rem;
  }
`;
const TableFilterColumn = ({ column, onFilterChange, container, }) => {
    var _a;
    const [filterValue, setFilterValue] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(column.filterValue);
    const [open, setOpen] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => setFilterValue(column.filterValue), [column.filterValue]);
    const closePopup = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => setOpen(false), [setOpen]);
    const openPopup = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => setOpen(true), [setOpen]);
    const handleSetFilterValue = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((value) => {
        onFilterChange === null || onFilterChange === void 0 ? void 0 : onFilterChange(column, value);
    }, [onFilterChange, column]);
    const FilterComponent = (_a = column.Filter) !== null && _a !== void 0 ? _a : '';
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Popup$1, { mountNode: container, onOpen: openPopup, onClose: closePopup, open: open, action: 'click', trigger: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FilterButton, { color: "inherit", filtered: column.filterValue ? column.filterValue : undefined },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FilterIcon, null)) },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("div", { onClick: (e) => {
                e.stopPropagation();
            } },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FilterComponent, { value: filterValue, closePopup: closePopup, setFilterValue: handleSetFilterValue }))));
};

const SortIcon = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ isSorted, isSortedDesc }) => {
    if (!isSorted) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SortArrows, null);
    }
    return isSortedDesc ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SortArrowsUp, null) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SortArrowsDown, null);
});
const TableHeaderCell = styled$1(({ children, isSorted, isSortedDesc, ...props }) => {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableCell$1, Object.assign({}, props), children);
}) `
  &.MuiTableCell-root {
    border-top: ${({ isSorted, isSortedDesc }) => (!isSorted ? 'none' : isSortedDesc ? `4px solid #E5EAF3` : 'none')};
    border-bottom: ${({ isSorted, isSortedDesc }) => (!isSorted ? 'none' : !isSortedDesc ? `4px solid #E5EAF3` : 'none')};
    background-color: ${({ theme }) => theme.rightPanel.tableHeaderBackground};
  }

  & .MuiTableSortLabel-root .MuiSvgIcon-root {
    fill: none;
    width: 12px;
    height: 12px;
    margin-left: 10px;
  }
`;
const ShadowCell = styled$1(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(({ pivotLeft, ...props }, ref) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableCell$1, Object.assign({ ref: ref }, props)))) `
  &.MuiTableCell-root.MuiTableCell-head,
  &.MuiTableCell-root.MuiTableCell-body {
    background: linear-gradient(90deg, rgba(0, 0, 0, 0.05) 0%, rgba(0, 0, 0, 0) 100%);
    position: sticky;
    left: ${({ pivotLeft }) => `${pivotLeft}px`};
    z-index: 1;
    padding: 0;

    transition: opacity 300ms;
    opacity: 0;
    width: 18px;
    margin-left: -18px;
  }

  .Mui-scrolled-horizontal &.MuiTableCell-root.MuiTableCell-head,
  .Mui-scrolled-horizontal &.MuiTableCell-root.MuiTableCell-body {
    opacity: 1;
  }
`;
const TableHeader = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ headerGroups, onSortChange, onFilterChange, container }) => {
    const theme = useTheme();
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableHead$1, null, headerGroups.map((headerGroup) => {
        let pivotLeft = 0;
        const pivotHeaders = headerGroup.headers.filter((c) => c.pivot);
        const headers = headerGroup.headers.filter((c) => !c.pivot);
        return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableRow$1, Object.assign({}, headerGroup.getHeaderGroupProps()),
            pivotHeaders.map((column, index) => {
                var _a, _b, _c;
                //TODO: Why onClick sort here? in pivot headers
                const props = column.getHeaderProps(column.getSortByToggleProps((p) => (Object.assign(Object.assign({}, p), { onClick: column.canSort ? (() => onSortChange === null || onSortChange === void 0 ? void 0 : onSortChange(column)) : undefined }))));
                const pivotStyle = column.pivot
                    ? {
                        left: pivotLeft,
                        position: 'sticky',
                        zIndex: 1,
                        background: theme.rightPanel.tableHeaderBackground,
                    }
                    : {};
                if (column.id === 'expandable-column') {
                    pivotStyle.paddingRight = '.75rem';
                    pivotStyle.marginRight = '-.75rem';
                }
                const tableCellStyleOverride = Object.assign(Object.assign(Object.assign({}, props.style), { maxWidth: (_a = column.maxWidth) !== null && _a !== void 0 ? _a : (_b = props.style) === null || _b === void 0 ? void 0 : _b.maxWidth, overflow: 'hidden' }), pivotStyle);
                pivotLeft += column.pivot ? (_c = column.maxWidth) !== null && _c !== void 0 ? _c : column.width : 0;
                return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, { key: props.key },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableHeaderCell, Object.assign({}, props, { isSorted: column.isSorted, isSortedDesc: !!column.isSortedDesc, style: tableCellStyleOverride }), column.canSort ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableSortLabel$1, { active: column.isSorted, IconComponent: () => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SortIcon, { isSorted: column.isSorted, isSortedDesc: !!column.isSortedDesc }) }, column.render('Header'))) : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null, column.render('Header')))),
                    index === pivotHeaders.length - 1 && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ShadowCell, { pivotLeft: pivotLeft })));
            }),
            headers.map((column) => {
                var _a, _b;
                const props = column.getHeaderProps(column.getSortByToggleProps((p) => (Object.assign(Object.assign({}, p), { onClick: column.canSort ? () => onSortChange === null || onSortChange === void 0 ? void 0 : onSortChange(column) : undefined }))));
                return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableHeaderCell, Object.assign({}, props, { isSorted: column.isSorted, isSortedDesc: !!column.isSortedDesc, style: Object.assign(Object.assign({}, props.style), { maxWidth: (_a = column.maxWidth) !== null && _a !== void 0 ? _a : (_b = props.style) === null || _b === void 0 ? void 0 : _b.maxWidth, overflow: 'hidden' }) }), column.canSort ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { display: "flex", justifyContent: "space-between", position: "relative", marginTop: !!column.isSortedDesc ? '-4px' : '0' },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableSortLabel$1, { active: column.isSorted, IconComponent: () => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SortIcon, { isSorted: column.isSorted, isSortedDesc: !!column.isSortedDesc }) }, column.render('Header')),
                    column.canFilter && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableFilterColumn, { column: column, onFilterChange: onFilterChange, container: container }))) : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { position: "relative" },
                    column.render('Header'),
                    column.canFilter && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableFilterColumn, { column: column, onFilterChange: onFilterChange, container: container })))));
            })));
    })));
});

const ExpandableCellButton = styled$1(Box$1) `
  min-width: 1.75rem;
  max-width: 1.75rem;
  width: 1.75rem;
  padding-right: 1.75rem;
  margin-left: -.75rem;
`;
const ExpandableIcon = styled$1(({ isExpanded, ...props }) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ArrowRightIcon, Object.assign({}, props))) `
  &.MuiSvgIcon-root {
    font-size: .75rem;
    height: 0.75rem;
    width: 0.75rem;
    transition: all 300ms;
    color: ${UI.palette('grey.500')};
    transform: ${({ isExpanded }) => `rotate(${isExpanded ? 90 : 0}deg)`};
  }
`;
const addExpandableColumn = (renderExpandedComponent) => renderExpandedComponent ? [{
        id: 'expandable-column',
        Header: () => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { width: '1rem' }),
        width: '3rem',
        maxWidth: 60,
        pivot: true,
        Cell: ({ cell }) => {
            const row = cell.row;
            return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ExpandableCellButton, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(IconButton$1, { onClick: () => row.toggleRowExpanded(!row.isExpanded) },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ExpandableIcon, { isExpanded: row.isExpanded })));
        },
    }] : [];
const addActionsColumn = (getRowActions) => getRowActions ? [{
        id: 'actions',
        accessor: 'id',
        Header: () => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { width: '3rem' }),
        width: '3rem',
        disableFilters: true,
        minWidth: 40,
        Cell: ({ row: { original } }) => {
            const { items, container } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => getRowActions(original), [getRowActions, original]);
            return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableActionsCell, { menuItems: items, container: container });
        },
    }] : [];
const TableActionsCell = ({ menuItems, container }) => {
    const [anchorEl, setAnchorEl] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useState(null);
    const handleOpen = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((event) => {
        setAnchorEl(event.currentTarget);
    }, [setAnchorEl]);
    const handleClose = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setAnchorEl(null);
    }, [setAnchorEl]);
    if (menuItems.length === 0) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { width: 28 });
    }
    const open = Boolean(anchorEl);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(IconButton$1, { onClick: handleOpen },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MoreIcon, { "data-test-id": "moreicon", color: open ? 'action' : 'disabled' })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Menu$1, { container: container, open: open, anchorEl: anchorEl, onClose: handleClose, items: menuItems }));
};

const TableTextCell = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ value: { title, description, container, multiLineDescription } }) => {
    const titleRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
    const descriptionRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
    const [tooltips, setTooltips] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState({ title: null, description: null });
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        const calculatedTooltips = { title: null, description: null };
        if (titleRef.current && titleRef.current.offsetWidth < titleRef.current.scrollWidth) {
            calculatedTooltips.title = title;
        }
        if (descriptionRef.current && descriptionRef.current.offsetWidth < descriptionRef.current.scrollWidth) {
            calculatedTooltips.description = description;
        }
        setTooltips(calculatedTooltips);
    }, [setTooltips, title, description]);
    let titleComponent = null;
    let descriptionComponent = null;
    if (title) {
        titleComponent = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { maxWidth: '100%' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { ref: titleRef, variant: "tableTitleCell" }, title));
        if (tooltips.title) {
            titleComponent = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PopupHover, { disablePortal: false, mountNode: container, arrow: true, trigger: titleComponent },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("div", { className: 'MuiTooltip-content' }, tooltips.title));
        }
    }
    if (description) {
        descriptionComponent = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { maxWidth: '100%', mt: 0.25 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { ref: descriptionRef, variant: "tableStandardCell", style: { whiteSpace: multiLineDescription ? 'pre-wrap' : 'nowrap' } }, description));
        if (tooltips.description) {
            descriptionComponent = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PopupHover, { disablePortal: false, mountNode: container, arrow: true, trigger: descriptionComponent },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("div", { className: 'MuiTooltip-content' }, tooltips.description));
        }
    }
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        titleComponent,
        descriptionComponent);
}, shallowEqualPrefix('value', 'title', 'description', 'container', 'multiLineDescription'));

const TableAvatarCell = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ value: { name, picture } }) => {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Avatar$1, { name: name !== null && name !== void 0 ? name : '', picture: picture });
}, shallowEqualPrefix('value', 'name', 'picture'));

const TableUserAvatarCell = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ value: { name = 'N/A', email, profilePictureUrl } }) => {
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true, alignItems: "center", spacing: 4, flexWrap: 'nowrap', overflow: 'hidden' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableAvatarCell, { value: { name, picture: profilePictureUrl } })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, overflow: 'hidden' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableTextCell, { value: { title: name, description: email } }))));
}, shallowEqualPrefix('value', 'name', 'email', 'profilePictureUrl'));

const TableDateCell = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ value: { date: dateProp, withAgo = true, format: formatProp = 'dd MMMM yyyy', }, }) => {
    const date = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => new Date(dateProp !== null && dateProp !== void 0 ? dateProp : 'Invalid Date'), [dateProp]);
    if (date.toString() === 'Invalid Date') {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableTextCell, { value: { description: '-' } });
    }
    const title = format(date, formatProp);
    const description = withAgo ? `${formatDistanceStrict(date, new Date())} ago` : undefined;
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableTextCell, { value: { title, description } });
}, shallowEqualPrefix('value', 'date', 'withAgo', 'format'));

const ActionButton = styled$1(IconButton$1) `
  &.MuiButtonBase-root.MuiIconButton-root {
    margin-right: 1rem;

    .MuiSvgIcon-root {
      width: 0.75rem;
      height: 0.75rem;
    }

    &:not(.Mui-disabled) {
      .MuiSvgIcon-root {
        color: ${({ theme }) => theme.palette.icon.action};
      }
    }
  }
`;
const TableCopyCell = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ value: { title, description, copyValue, testId } }) => {
    const [copied, setCopied] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const copyInputValue = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        var _a, _b;
        copy((_b = (_a = copyValue !== null && copyValue !== void 0 ? copyValue : title) !== null && _a !== void 0 ? _a : description) !== null && _b !== void 0 ? _b : '').then(displayCopiedIcon).then((e) => {
            console.log(e);
            if (window.Cypress) {
                // Copy to clipboard does not work in cypress
                displayCopiedIcon();
            }
        });
    }, [copied, setCopied, copyValue, title, description]);
    const displayCopiedIcon = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setCopied(true);
        setTimeout(() => {
            setCopied(false);
        }, 2000);
    }, [setCopied]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true, alignItems: "center", justifyContent: 'space-between', flexWrap: 'nowrap', overflow: 'hidden', spacing: 3, maxWidth: '360px' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, overflow: 'hidden' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableTextCell, { "data-test-id": `${testId}-value`, value: { title, description } })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, height: "100%", alignItems: 'flex-end', display: "flex" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ActionButton, { "data-test-id": `${testId}-value-btn`, onClick: copyInputValue }, copied ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CheckedIcon, null) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CopyIcon, null))));
}, shallowEqualPrefix('value', 'title', 'description', 'copyValue'));

const CellChip = styled$1(Chip) `
  border-radius: 0 !important;
`;
const SubItemCellChip = styled$1(CellChip) `
  border-radius: 0 !important;
  background-color: #CDDFEF
`;
const MoreButton = styled$1(Button$1) `
  &.MuiButton-root {
    padding: 0 0.75rem;
    height: 1.5rem;

    & .MuiButton-endIcon.MuiButton-iconSizeSmall .MuiSvgIcon-root {
      width: 0.75rem;
      height: 0.75rem;
    }
  }

`;
MoreButton.defaultProps = {
    size: 'small',
    color: 'inherit',
    variant: 'text',
};
const RoleTooltipItem = styled$1(Typography$1) `
  & {
    padding: ${UI.spacing(2, 6)};
    line-height: 1rem;
    min-width: 6rem;
    font-size: 0.75rem;
  }
`;
const ChipsMenuDropdown = ({ items, container, t }) => {
    var _a;
    const [open, setOpen] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const handleOpen = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => setOpen(true), [setOpen]);
    const handleClose = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => setOpen(false), [setOpen]);
    const roleItems = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        return items.map(({ text }, index) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RoleTooltipItem, { variant: 'body1', key: index }, text));
    }, [items]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Tooltip$1, { PopperProps: { container }, open: open, title: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ClickAwayListener, { onClickAway: handleClose },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { pt: 2, pb: 2 }, roleItems)), onClose: handleClose, placement: 'bottom-end', disableHoverListener: true, disableFocusListener: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MoreButton, { onClick: handleOpen, endIcon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ArrowDownIcon, { color: open ? 'action' : 'disabled' }) },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: "tableCountCell" },
                    items.length,
                    " ", (_a = t === null || t === void 0 ? void 0 : t('more')) !== null && _a !== void 0 ? _a : 'more'))));
};
const ChipsList = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ items, max, container, t }) => {
    const [chipsToShow, chipsToHide] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        return [items.slice(0, max), items.slice(max)];
    }, [items, max]);
    const chipsComponent = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, display: 'flex' }, chipsToShow.map((chip, index) => {
            var _a, _b, _c;
            const subItemsLength = ((_a = chip.subItems) === null || _a === void 0 ? void 0 : _a.length) || 0;
            const showSubItemsChip = subItemsLength > 0;
            const chipMaxSubItems = (_b = chip.maxSubItems) !== null && _b !== void 0 ? _b : 2;
            const extraText = subItemsLength > chipMaxSubItems ? ` +${subItemsLength - chipMaxSubItems}` : '';
            return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { key: index, mr: 2 }, showSubItemsChip
                ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CellChip, { label: chip.text }),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubItemCellChip, { label: `${(_c = chip.subItems) === null || _c === void 0 ? void 0 : _c.slice(0, chipMaxSubItems).join(', ')}${extraText}` }))
                : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Chip, { label: chip.text })));
        }));
    }, [chipsToShow]);
    const menuComponent = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        if (chipsToHide.length === 0) {
            return null;
        }
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ChipsMenuDropdown, { container: container, items: chipsToHide.map((item) => {
                var _a, _b;
                let text = item.text;
                if ((_a = item.subItems) === null || _a === void 0 ? void 0 : _a.length) {
                    text += ` - ${(_b = item.subItems) === null || _b === void 0 ? void 0 : _b.join(', ')}`;
                }
                return { text };
            }), t: t });
    }, [container, chipsToHide]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true, alignItems: "center", flexWrap: 'nowrap' },
        chipsComponent,
        menuComponent);
}, shallowEqual('value', 'items', 'max', 'container'));

const TableChipsCell = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ value: { items, max, container, t } }) => {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ChipsList, { items: items, max: max, container: container, t: t });
}, shallowEqual('value', 'items', 'max', 'container'));

const TableSwitchCell = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ value: { checked, onChange, containerStyle } }) => {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { display: 'block', width: '100%', textAlign: 'center', style: containerStyle },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Switch$1, { onChange: onChange, checked: checked }));
}, shallowEqualPrefix('value', 'checked', 'onChange', 'containerStyle'));
const TableSwitchCellLeft = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ value: { checked, onChange, containerStyle } }) => {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { display: 'block', width: '100%', textAlign: 'left', marginLeft: '-0.813rem', style: containerStyle },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Switch$1, { onChange: onChange, checked: checked }));
}, shallowEqualPrefix('value', 'checked', 'onChange', 'containerStyle'));

const EllipsisButton = styled$1((props) => {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("div", Object.assign({}, props, { tabIndex: 0, role: 'button' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(HorizontalMoreIcon, { className: 'Mui-hover-hidden' }),
        props.children);
}) `
  & {
    outline: none;
    cursor: pointer;
    min-width: 1.5rem;
    height: 1.75rem;
    position: relative;
    border-radius: 3px;

    .Mui-hover-hidden, .Mui-hover-visible {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
      margin: auto;
      opacity: 1;
      transition: opacity 300ms;
    }

    .Mui-hover-visible {
      opacity: 0;
    }

    .MuiSvgIcon-root.Mui-hover-visible {
      width: 0.5rem;
    }

    &:hover, &:focus {
      background-color: ${UI.palette('grey.150')};

      .Mui-hover-visible {
        opacity: 1;
      }

      .Mui-hover-hidden {
        opacity: 0;
      }
    }
  }
`;
const TablePagination = styled$1((props) => {
    var _a;
    if (((_a = props.count) !== null && _a !== void 0 ? _a : 0) <= 1) {
        return null;
    }
    const page = props.page + 1;
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Pagination$1, Object.assign({}, props, { page: page, renderItem: (params) => {
            if (params.type === 'start-ellipsis') {
                return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EllipsisButton, Object.assign({}, params, { onClick: e => { var _a; return (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e, page - 3); } }),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DoubleArrowLeftIcon, { className: 'Mui-hover-visible' }));
            }
            else if (params.type === 'end-ellipsis') {
                return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EllipsisButton, Object.assign({}, params, { onClick: e => { var _a; return (_a = props.onChange) === null || _a === void 0 ? void 0 : _a.call(props, e, page + 3); } }),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DoubleArrowRightIcon, { className: 'Mui-hover-visible' }));
            }
            return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PaginationItem$1, Object.assign({}, params));
        } })));
}) ``;

const JsonItem = styled$1(Box$1) `
  position: relative;
  padding: 0 5px;
  margin: 10px 0 10px 10px;

  &::before {
    content: '';
    position: absolute;
    border-radius: 4px;
    width: 2px;
    top: 0;
    bottom: 0;
    left: -10px;
    background-color: ${UI.palette('grey.300')};
  }
`;
const TableJsonCellPagination = styled$1(TablePagination) `
  &.MuiPagination-root {
    padding-left: ${UI.spacing(6)};
    margin-bottom: -2px;
  }
`;
const TableJsonCellHeader = styled$1(Box$1) `
  background-color: ${UI.palette('grey.150')};
  padding: ${UI.spacing(4, 6)};
  border-top-left-radius: 0.5rem;
  border-top-right-radius: 0.5rem;
`;
const TableJsonCellContent = styled$1(Box$1) `
  min-width: 350px;
  max-width: 350px;
`;
const TableJsonCellBody = styled$1(Box$1) `
  padding: ${UI.spacing(1, 6)};
`;
const TableJsonCellDivider = styled$1(Divider$1) `
  &.MuiDivider-root {
    margin: ${UI.spacing(1)} ${UI.spacing(-6)};
  }
`;
const TableJsonCellEmpty = styled$1(Box$1) `
  display: flex;
  height: 100px;
  width: 100%;
  justify-content: center;
  align-items: center;
`;
const pageSize = 2;
const TableJsonCell = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ value: { json = [], container } }) => {
    const [state, setState] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState({
        items: json.slice(0, pageSize),
        page: 1,
    });
    const { items, page } = state;
    const showPagination = json.length > pageSize;
    const totalPages = Math.ceil(json.length / pageSize);
    const showingItems = items.length >= 2 ? page * pageSize : page * pageSize - 1;
    const onPageChange = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((_e, pageNumber) => {
        setState({
            items: json.slice((pageNumber - 1) * pageSize, pageNumber * pageSize),
            page: pageNumber,
        });
    }, [json]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PopupClick, { mountNode: container, placement: 'bottom', trigger: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(IconButton$1, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EyeVisibleIcon, null)) },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableJsonCellContent, { onClick: (e) => e.stopPropagation() },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableJsonCellHeader, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: 'tablePopupTitle' },
                    json.length,
                    " total (showing ",
                    !items.length ? '0' : showingItems,
                    " out of ",
                    json.length,
                    ")")),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableJsonCellBody, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true, flexDirection: 'column' }, !items.length ?
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableJsonCellEmpty, null,
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: 'body2' }, "NO DATA"))
                    : items.map((object, idx) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, { key: idx },
                        idx !== 0 && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableJsonCellDivider, null),
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true }, typeof object === 'string' ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
                            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(JsonItem, null,
                                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableTextCell, { value: { title: (page - 1) * pageSize + (idx + 1), description: object, multiLineDescription: true } })))) : object != null ? (Object.keys(object).map((key) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, xs: 6 },
                            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(JsonItem, null,
                                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableTextCell, { value: { title: key, description: typeof object[key] === 'object' ? JSON.stringify(object[key]) : object[key] } }))))) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableJsonCellEmpty, null,
                            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: 'body2' }, "NO DATA"))))))),
            showPagination && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableJsonCellPagination, { page: page - 1, count: totalPages, onChange: onPageChange }))));
}, shallowEqualPrefix('value', 'json'));

const defaultCenter = {
    lat: 40.73061,
    lng: -73.935242,
};
const bootstrapURLKeys = { key: 'AIzaSyC588_3ox-RV9tt46VXdRkaPpSSZbSDAfE' };
const MapMark = () => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { width: "10px", height: "10px", borderRadius: "50%", style: { background: 'black' } });
const IpAddress = styled$1(({ ip, open, ...props }) => {
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, Object.assign({ variant: "tableIpCellText" }, props), ip));
}) `
  &.MuiTypography-root {
    color: ${({ open }) => (open ? UI.palette('grey.800') : UI.palette('grey.700'))};
  }

  &.MuiTypography-root:hover {
    color: ${UI.palette('grey.800')};
  }
`;
const PopupContainer = styled$1(Box$1) `
  min-width: 400px;
`;
const PopupBody = styled$1(Box$1) `
  padding: ${UI.spacing(4, 4, 4, 6)};
`;
const PopupItem = ({ title, desc, lastItem }) => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { marginBottom: lastItem ? 0 : 3 },
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { marginBottom: "4px" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: "tableIpPopupTitle" }, title)),
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: "tableIpPopupDesc" }, desc))));
const TableIpCell = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ value: { ip, container, getIpMetadata } }) => {
    var _a;
    const [open, setOpen] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const [ipMetadata, setIpMetadata] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState({
        loading: false,
        data: {
            latitude: 0,
            longitude: 0,
            city: null,
            country_name: null,
            country_code: null,
            zip: null,
            location: { country_flag: undefined, country_flag_emoji: undefined },
        },
    });
    const handleOpen = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => setOpen(true), [setOpen]);
    const handleClose = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => setOpen(false), [setOpen]);
    const loadIpAddressMetadata = () => (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.g)(void 0, void 0, void 0, function* () {
        try {
            setIpMetadata(Object.assign(Object.assign({}, ipMetadata), { loading: true }));
            const data = yield (getIpMetadata === null || getIpMetadata === void 0 ? void 0 : getIpMetadata(ip));
            setIpMetadata({ data, loading: false });
        }
        catch (e) {
            setIpMetadata(Object.assign(Object.assign({}, ipMetadata), { loading: false }));
        }
    });
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        loadIpAddressMetadata();
    }, []);
    const { data: { country_name, city, zip, latitude, longitude, location }, loading, } = ipMetadata;
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PopupClick, { mountNode: container, placement: "bottom", open: open, onOpen: handleOpen, onClose: handleClose, trigger: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true, spacing: 2, alignItems: "center", width: 'max-content' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, width: "25px", textAlign: "center" }, loading ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { width: '1.15rem', height: '1.15rem', display: 'flex', component: Loader$1, size: "small" }) : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: "tablePopupTitle", display: 'flex' }, (_a = location === null || location === void 0 ? void 0 : location.country_flag_emoji) !== null && _a !== void 0 ? _a : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { component: GlobeIcon, width: '0.75rem', height: '0.75rem' })))),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(IpAddress, { open: open, ip: ip }))) },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PopupContainer, { onClick: (e) => e.stopPropagation() },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DialogHeader, { onClose: handleClose },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: "tableIpPopupTitle" },
                    "IP Address ",
                    ip)),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PopupBody, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true, spacing: 6 },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, xs: true },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true, flexDirection: "column" },
                            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
                                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PopupItem, { title: "Country", desc: country_name !== null && country_name !== void 0 ? country_name : 'Unknown' })),
                            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
                                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true, justifyContent: "space-between" },
                                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
                                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PopupItem, { title: "City", desc: city !== null && city !== void 0 ? city : 'Unknown' })),
                                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
                                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PopupItem, { title: "Zip", desc: zip !== null && zip !== void 0 ? zip : 'Unknown' })))),
                            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true },
                                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PopupItem, { title: "Lattitude, Longitude", desc: `${latitude ? latitude.toFixed(4) : 'Unknown'}, ${longitude ? longitude.toFixed(4) : 'Unknown'}`, lastItem: true })))),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, xs: 7 },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(GoogleMapReact, { bootstrapURLKeys: bootstrapURLKeys, defaultCenter: {
                                lat: latitude !== null && latitude !== void 0 ? latitude : defaultCenter.lat,
                                lng: longitude !== null && longitude !== void 0 ? longitude : defaultCenter.lng,
                            }, defaultZoom: !!longitude ? 11 : 0 }, longitude && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MapMark
                        // @ts-ignore
                        , { 
                            // @ts-ignore
                            lat: latitude !== null && latitude !== void 0 ? latitude : defaultCenter.lat, lng: longitude !== null && longitude !== void 0 ? longitude : defaultCenter.lng })))))))));
}, shallowEqual('ip'));

const TableSeverityCell = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ value: { label, severity } }) => {
    if (!label) {
        return null;
    }
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SeverityChip, { label: label, severity: severity });
}, shallowEqualPrefix('value', 'label', 'severity'));

const ExpandedRow = styled$1(TableRow$1) `
  &.MuiTableRow-root {
    display: flex;
    flex: 1 0 auto;
    min-width: 1200px;
  }
`;
const ExpandedCell = styled$1(TableCell$1) `
  &.MuiTableCell-root.MuiTableCell-body {
    flex: 1 0 auto;
    padding-bottom: 0;
    padding-Top: 0;
    border-bottom: none;
    box-shadow: 0 -1px 0 0 ${UI.palette('divider')} inset;
    position: relative;
  }

  & .MuiCollapse-root {
    position: sticky;
    left: 32px;
  }
`;
const TableExpandable = (props) => {
    const { isExpanded, renderExpandedComponent, row } = props;
    if (!renderExpandedComponent) {
        return null;
    }
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ExpandedRow, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ExpandedCell, { colSpan: row.cells.length },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Collapse$1, { in: isExpanded, mountOnEnter: true, unmountOnExit: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, null, renderExpandedComponent === null || renderExpandedComponent === void 0 ? void 0 : renderExpandedComponent(row, row.index))))));
};

const TableCategoryRow = styled$1(TableRow$1) `
  & {
    position: sticky;
    top: 0;
    left: 0;
    z-index: 2;

    > td {
      height: 2rem;
      width: 100%;
      padding: 0;

      > * {
        position: sticky;
        left: 32px;
      }
    }
  }
`;
const TableBody = (_a) => {
    var { rows, prepareRow, loading, renderExpandedComponent } = _a, props = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["rows", "prepareRow", "loading", "renderExpandedComponent"]);
    const theme = useTheme();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MuiTableBody, Object.assign({}, props), rows.map((row, index) => {
        var _a;
        prepareRow(row);
        const props = row.getRowProps();
        if (row.original.__type === 'categoryRow') {
            return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableCategoryRow, Object.assign({}, props, { key: index }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableCell$1, { rowSpan: row.cells.length },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: 'tableCategory' }, row.original.title)));
        }
        let pivotLeft = 0;
        const pivotCell = row.cells.filter(({ column }) => column.pivot);
        const cells = row.cells.filter(({ column }) => !column.pivot);
        const rowClassName = `${(_a = props.className) !== null && _a !== void 0 ? _a : ''} ${row.isExpanded ? 'Mui-expanded-row' : ''}`;
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, { key: props.key },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableRow$1, Object.assign({}, props, { className: rowClassName }),
                pivotCell.map((cell, index) => {
                    var _a, _b, _c;
                    const props = cell.getCellProps();
                    const column = cell.column;
                    const pivotStyle = column.pivot ? {
                        left: pivotLeft,
                        position: 'sticky',
                        zIndex: 1,
                        background: theme.rightPanel.tableBodyBackground,
                    } : {};
                    pivotLeft += column.pivot ? (_a = column.maxWidth) !== null && _a !== void 0 ? _a : column.width : 0;
                    if (column.id === 'expandable-column') {
                        pivotStyle.paddingRight = '.75rem';
                        pivotStyle.marginRight = '-.75rem';
                    }
                    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, { key: props.key },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableCell$1, Object.assign({}, props, { style: Object.assign(Object.assign(Object.assign({}, props.style), { maxWidth: (_b = cell.column.maxWidth) !== null && _b !== void 0 ? _b : (_c = props.style) === null || _c === void 0 ? void 0 : _c.maxWidth, overflow: 'hidden' }), pivotStyle) }), cell.render('Cell')),
                        index === pivotCell.length - 1 && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ShadowCell, { pivotLeft: pivotLeft }));
                }),
                cells.map(cell => {
                    var _a, _b;
                    const props = cell.getCellProps();
                    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableCell$1, Object.assign({}, props, { "data-test-id": `${props.key}`.replace(/\s/g, '-').replace(/\_/g, '-').toLowerCase(), style: Object.assign(Object.assign({}, props.style), { maxWidth: (_a = cell.column.maxWidth) !== null && _a !== void 0 ? _a : (_b = props.style) === null || _b === void 0 ? void 0 : _b.maxWidth, overflow: 'hidden' }) }), cell.render('Cell')));
                })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableExpandable, { isExpanded: row.isExpanded, row: row, renderExpandedComponent: renderExpandedComponent }));
    }));
};

const useResponsiveTable = (forwardedKey) => {
    const headerRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
    const contentRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
    const scrollVisibleRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(false);
    const horizontalScrollVisibleRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(false);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        const thead = headerRef.current;
        const tbody = contentRef.current;
        if (thead && tbody) {
            let hasScrolledClass = false;
            const onScrollHeader = (e) => {
                const scrollLeft = e.target.scrollLeft;
                tbody.scrollLeft = scrollLeft;
                updateHorizontalScrolled(scrollLeft);
            };
            const onScrollBody = (e) => {
                const scrollLeft = e.target.scrollLeft;
                thead.scrollLeft = scrollLeft;
                updateHorizontalScrolled(scrollLeft);
            };
            tbody.addEventListener('scroll', onScrollBody);
            tbody.addEventListener('mouseenter', () => {
                // tbodyHovered = true;
                tbody.addEventListener('scroll', onScrollBody);
            });
            tbody.addEventListener('mouseleave', () => {
                // tbodyHovered = false;
                tbody.removeEventListener('scroll', onScrollBody);
            });
            thead.addEventListener('mouseenter', () => {
                // theadHovered = true;
                thead.addEventListener('scroll', onScrollHeader);
            });
            thead.addEventListener('mouseleave', () => {
                // theadHovered = false;
                thead.removeEventListener('scroll', onScrollHeader);
            });
            const updateHorizontalScrolled = (scrollLeft) => {
                if (scrollLeft > 0 && !hasScrolledClass) {
                    hasScrolledClass = true;
                    thead.parentElement.classList.add('Mui-scrolled-horizontal');
                }
                if (scrollLeft === 0 && hasScrolledClass) {
                    hasScrolledClass = false;
                    thead.parentElement.classList.remove('Mui-scrolled-horizontal');
                }
            };
        }
        const checkScroll = () => {
            let scrollVisible = (tbody === null || tbody === void 0 ? void 0 : tbody.scrollHeight) !== (tbody === null || tbody === void 0 ? void 0 : tbody.clientHeight);
            let horizontalScrollVisible = (tbody === null || tbody === void 0 ? void 0 : tbody.scrollWidth) !== (tbody === null || tbody === void 0 ? void 0 : tbody.clientWidth);
            if (scrollVisible !== scrollVisibleRef.current) {
                scrollVisibleRef.current = scrollVisible;
                if (thead === null || thead === void 0 ? void 0 : thead.classList.contains('Mui-scroll-visible')) {
                    thead === null || thead === void 0 ? void 0 : thead.classList.remove('Mui-scroll-visible');
                }
                else {
                    thead === null || thead === void 0 ? void 0 : thead.classList.add('Mui-scroll-visible');
                }
            }
            if (horizontalScrollVisible !== horizontalScrollVisibleRef.current) {
                horizontalScrollVisibleRef.current = horizontalScrollVisible;
                if (thead === null || thead === void 0 ? void 0 : thead.classList.contains('Mui-scroll-horizontal-visible')) {
                    thead === null || thead === void 0 ? void 0 : thead.classList.remove('Mui-scroll-horizontal-visible');
                }
                else {
                    thead === null || thead === void 0 ? void 0 : thead.classList.add('Mui-scroll-horizontal-visible');
                }
            }
        };
        checkScroll();
        const resizeInterval = setInterval(checkScroll, 500);
        return () => clearInterval(resizeInterval);
    }, [forwardedKey]);
    return [headerRef, contentRef];
};

const PlaceHolderIcon = styled$1(Box$1) `
  & {
    background: ${UI.palette('grey.150')};
    border-radius: 0.5rem;
    width: 5rem;
    height: 5rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .MuiSvgIcon-root {
      font-size: 2rem;
      color: ${UI.palette('grey.500')}
    }
  }
`;
const TablePlaceholderContent = (_a) => {
    var { show, title, description, icon, testId, IconWrapper = PlaceHolderIcon } = _a, props = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["show", "title", "description", "icon", "testId", "IconWrapper"]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Fade$1, { in: show },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, Object.assign({}, props, { "data-test-id": testId }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(IconWrapper, null, icon),
            title && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: 'tablePlaceholderTitle' }, title),
            description && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: 'tablePlaceholderDescription' }, description)));
};
const TablePlaceholder = styled$1(TablePlaceholderContent) `
  & {
    background: ${UI.palette('common.white')};
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    bottom: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    height: calc(100% - 57px);
    flex-direction: column;
  }
`;

const LoaderWrapper = styled$1(Box$1) `
  & {
    width: 5rem;
    height: 5rem;
    display: flex;
    justify-content: center;
    align-items: center;

    .MuiSvgIcon-root {
      font-size: 2rem;
      color: ${UI.palette('grey.500')}
    }
  }
`;
const Transparent = styled$1('span') `
  color: transparent;
`;
const TableLoader = ({ description, show }) => {
    const loader = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Loader$1, null);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TablePlaceholder, { show: show, IconWrapper: LoaderWrapper, icon: loader, description: description !== null && description !== void 0 ? description : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Transparent, null, "Loading") });
};

const TableContainer = styled$1(Paper$1) `
  max-height: 100%;
  position: ${(props) => (props.autoHeight ? 'absolute' : 'relative')};
  top: 0;
  left: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
  box-shadow: 0 1px 2px #d8dbe0;
  border: 1px solid ${UI.palette('grey.300')};
  overflow: hidden;

  &.MuiPaper-root {
    background-color: ${({ theme }) => theme.rightPanel.tableBodyBackground};
  }
`;
const TableAbsoluteContainer = styled$1(TableContainer) `
  position: absolute;
  max-height: 100%;
  overflow: hidden;
  top: 0;
  left: 0;
`;
const TableSizer = styled$1(Box$1) `
  flex: 1;
  position: relative;
`;
const TableContent = styled$1(Box$1) `
  flex: 1;
  overflow: auto;
  position: relative;
  background-color: ${({ theme }) => theme.rightPanel.tableBodyBackground};

  ::-webkit-scrollbar {
    width: 0.75rem;
    height: 0.75rem;
  }

  ::-webkit-scrollbar-track {
    background: ${UI.palette('common.white')};
    border-left: 1px solid ${UI.palette('grey.300')};
  }

  ::-webkit-scrollbar-track:horizontal {
    border-left: none;
    border-top: 1px solid ${UI.palette('grey.300')};
  }

  ::-webkit-scrollbar-thumb {
    border: 0.25rem solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    -webkit-border-radius: 7px;
    background-color: ${UI.palette('grey.300')};
    cursor: pointer;
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: ${UI.palette('grey.400')};
  }

  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }

  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }

  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);

  tr.MuiTableRow-root.Mui-expanded-row > td {
    transition: border-bottom-color 300ms;
    border-bottom-color: transparent;
  }
`;
const TableHeaderContent = styled$1(Box$1) `
  overflow: auto;
  position: relative;
  scrollbar-width: none;
  min-height: 56px;

  border-bottom: 1px solid ${UI.palette('grey.300')};

  ::-webkit-scrollbar {
    width: 0;
    height: 0;
  }

  & .MuiTableRow-head .MuiTableCell-head:last-child {
    padding-right: 0.25rem;
  }

  &.Mui-scroll-visible .MuiTableRow-root.MuiTableRow-head {
    padding-right: 0.75rem;
  }

  -webkit-transform: translate3d(0, 0, 0);
  -moz-transform: translate3d(0, 0, 0);
  -ms-transform: translate3d(0, 0, 0);
  -o-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
`;
const TableContentWidthContext = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createContext(0);
const Table = (props) => {
    var _a, _b, _c;
    const columns = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => [
        ...addExpandableColumn(props.renderExpandedComponent),
        ...props.columns.map((d) => (Object.assign({ disableFilters: !d.Filter }, d))),
        ...addActionsColumn(props.getRowActions),
    ].map((c) => (Object.assign({ disableSortBy: !c.sortable }, c))), [props.columns, props.getRowActions]);
    const { state, getTableProps, headerGroups, getTableBodyProps, prepareRow, rows: _rows, } = reactTable.exports.useTable({
        columns,
        data: props.data,
        manualExpandedKey: 'fe__expanded',
        manualSortBy: !!props.onSortChange,
        manualFilters: !!props.onFilterChange,
        defaultCanFilter: false,
        useControlledState: (prevState) => {
            var _a, _b, _c;
            return (Object.assign(Object.assign({}, prevState), { sortBy: (_a = props.sortBy) !== null && _a !== void 0 ? _a : prevState.sortBy, filters: (_c = (_b = props.filters) !== null && _b !== void 0 ? _b : prevState.filters) !== null && _c !== void 0 ? _c : [] }));
        },
    }, reactTable.exports.useFlexLayout, reactTable.exports.useFilters, reactTable.exports.useSortBy, reactTable.exports.useExpanded, reactTable.exports.usePagination);
    const tableState = state;
    const onSortChange = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((column) => {
        var _a, _b;
        if (props.hasOwnProperty('sortBy')) {
            const sortBy = props.isMultiSort ? tableState.sortBy.filter(({ id }) => id !== column.id) : [];
            if (!column.isSorted) {
                sortBy.push({ id: column.id, desc: false });
            }
            else if (!column.isSortedDesc) {
                sortBy.push({ id: column.id, desc: true });
            }
            (_a = props.onSortChange) === null || _a === void 0 ? void 0 : _a.call(props, sortBy);
        }
        else {
            if (column.isSorted && column.isSortedDesc) {
                column.clearSortBy();
            }
            else {
                column.toggleSortBy(column.isSorted, (_b = props.isMultiSort) !== null && _b !== void 0 ? _b : false);
            }
        }
    }, [props.onSortChange]);
    const onFilterChange = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((column, filterValue) => {
        var _a;
        if (props.hasOwnProperty('filters')) {
            const filters = tableState.filters.filter(({ id }) => id !== column.id);
            if (filterValue != null) {
                filters.push({ id: column.id, value: filterValue });
            }
            (_a = props.onFilterChange) === null || _a === void 0 ? void 0 : _a.call(props, filters);
        }
        else {
            column.setFilter(filterValue);
        }
    }, [props, tableState.filters]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        var _a;
        !props.hasOwnProperty('sortBy') && ((_a = props.onSortChange) === null || _a === void 0 ? void 0 : _a.call(props, tableState.sortBy));
    }, [props.sortBy, tableState.sortBy]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        var _a;
        !props.hasOwnProperty('filters') && ((_a = props.onFilterChange) === null || _a === void 0 ? void 0 : _a.call(props, tableState.filters));
    }, [props.filters, tableState.filters]);
    const [headerRef, contentRef] = useResponsiveTable(props.forwardedKey);
    const rows = _rows;
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        var _a, _b;
        props.loading && ((_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ top: 0, left: 0, behavior: 'smooth' }));
        props.loading && ((_b = headerRef.current) === null || _b === void 0 ? void 0 : _b.scrollTo({ top: 0, left: 0, behavior: 'smooth' }));
    }, [props.loading]);
    const shouldDisplayLoader = props.loading || !!props.searching;
    const semiHeight = props.loading && rows.length == 1;
    const fullHeight = !semiHeight && ((props.loading && rows.length == 0) || rows.length == 0);
    const tableComponent = (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableContentWidthContext.Provider, { value: ((_b = (_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.clientWidth) !== null && _b !== void 0 ? _b : 0) - 56 },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableHeaderContent, { ref: headerRef },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MuiTable, Object.assign({}, getTableProps()),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableHeader, { container: props.container, headerGroups: headerGroups, onSortChange: onSortChange, onFilterChange: onFilterChange }))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableContent, { ref: contentRef, maxHeight: props.contentMaxHeight },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MuiTable, Object.assign({}, getTableProps()),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableBody, Object.assign({}, getTableBodyProps(), { prepareRow: prepareRow, rows: rows, loading: props.loading, renderExpandedComponent: props.renderExpandedComponent })))),
        props.onPageChange && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TablePagination, { count: props.totalPages, page: (_c = props.pageOffset) !== null && _c !== void 0 ? _c : 0, onChange: props.onPageChange })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableLoader, { show: shouldDisplayLoader, description: props.loadingText }),
        props.children));
    if (props.inline) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableContainer, { sx: { height: fullHeight ? '100%' : semiHeight ? '15rem' : undefined }, autoHeight: props.autoHeight != null ? props.autoHeight : true }, tableComponent);
    }
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableSizer, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableAbsoluteContainer, { sx: { height: fullHeight ? '100%' : semiHeight ? '15rem' : undefined }, autoHeight: props.autoHeight != null ? props.autoHeight : true }, tableComponent));
};

const TableExpandableRowContainer = styled$1(Grid$1) `
  padding: ${UI.spacing(5, 8, 10, 8)};

  & > .MuiGrid-item {
    padding-top: 1.5rem;
  }
`;
const LeftBorder = styled$1(Box$1) `
  width: 4px;
  min-width: 4px;
  height: 100%;
  background-color: ${UI.palette('grey.300')};
  border-radius: 8px;
  margin-right: 20px;
`;
const TableExpandableRow = ({ row }) => {
    const contentWidth = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useContext(TableContentWidthContext);
    const { rootEl } = useShadowDom();
    const container = rootEl !== null && rootEl !== void 0 ? rootEl : document.body;
    if (!contentWidth) {
        return null;
    }
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { width: contentWidth, minWidth: 470 },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableExpandableRowContainer, { container: true, flexWrap: "wrap", justifyContent: 'start', spacing: 4 }, Object.keys(row).map((key) => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, key: key, minWidth: 300 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, minWidth: 4 },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(LeftBorder, null)),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, xs: true },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableTextCell, { value: { title: key, container } }),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { height: 4 }),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { maxWidth: 270 }, typeof row[key] === 'object'
                        ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableJsonCell, { value: { json: Array.isArray(row[key]) ? row[key] : [row[key]], container } })
                        : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableTextCell, { value: { description: row[key], container } }))))))))));
};

const PreviewImage = styled$1('div') `
  width: ${(p) => (p.type === 'circle' ? '6.5rem' : '25.625rem')};
  height: ${(p) => (p.type === 'circle' ? '6.5rem' : '8.5rem')};
  border-radius: ${(p) => (p.type === 'circle' ? '50%' : '4px')};
  background-image: ${(p) => `url(${p.img})`};
  background-size: cover;
  background-position: center;
`;
const DropZoneContainer = styled$1(Box$1) `
  width: 25.625rem;
  height: 8.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
`;
const PreviewImageContainer = styled$1(DropZoneContainer) `
  background-color: ${UI.palette('grey.100')};
  box-sizing: border-box;
  border-radius: 4px;
  padding: 0;
  position: relative;
`;
const UploadPhoto = (_a) => {
    var { openDownloadBrowse, uploadProgress, type, onSubmit, title, open } = _a, dialogProps = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["openDownloadBrowse", "uploadProgress", "type", "onSubmit", "title", "open"]);
    const [files, setFiles] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState([]);
    const [loading, setLoading] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const [previewImage, setPreviewImage] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState();
    const handleDrop = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((_files, img) => {
        setFiles(_files);
        setPreviewImage(img);
    }, [setFiles, setPreviewImage]);
    const { getInputProps, open: openBrowse } = useDropzone({
        noClick: true,
        noKeyboard: true,
        accept: '.png, .jpeg, .jpg',
        onDrop: (acceptedFiles) => (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.g)(void 0, void 0, void 0, function* () {
            const base64file = yield fileToBase64(acceptedFiles[0]);
            handleDrop(acceptedFiles, base64file);
            setFiles(acceptedFiles);
        }),
    });
    const handleSubmit = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setLoading(true);
        onSubmit(files[0]).then(() => {
            setLoading(false);
        }).catch(() => {
            setLoading(false);
        });
        setPreviewImage(undefined);
    }, [files, onSubmit]);
    const handleClose = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        dialogProps.onClose();
        setPreviewImage(undefined);
    }, [dialogProps]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (openDownloadBrowse) {
            openBrowse();
        }
    }, [openDownloadBrowse, openBrowse]);
    const dialogBodyContent = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PreviewImageContainer, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PreviewImage, { img: previewImage, type: type }));
    }, [previewImage, type]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("input", Object.assign({}, getInputProps())),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Dialog$1, Object.assign({}, dialogProps, { open: !!previewImage && open, title: title !== null && title !== void 0 ? title : 'Upload Photo', size: "sm" }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Dialog$1.Body, null, dialogBodyContent),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Dialog$1.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Button$1, { "data-test-id": "cancelBtn", color: "inherit", variant: "text", onClick: handleClose }, "Cancel"),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Button$1, { "data-test-id": "saveBtn", loading: loading, disabled: !files.length, onClick: handleSubmit }, "Save")))));
};

const RadioGroupListRow = styled$1(Grid$1) `
  border-bottom: 1px solid ${UI.palette('grey.300')};
  padding: 1.5rem;

  &:last-child {
    border-bottom: none;
  }
`;
const RadioList = (props) => {
    const { items } = props, radioGroupProps = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(props, ["items"]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RadioGroup$1, Object.assign({}, radioGroupProps), items.map((item, index) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RadioGroupListRow, { key: index, container: true, spacing: 2, alignItems: 'center' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, xs: 5 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormControlLabel$1, Object.assign({ control: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Radio$1, null) }, item))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, xs: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: 'subtitle2Light' }, item.description))))));
};

const i18nTimezones = {
    'Pacific/Midway': 'Midway Island, Samoa',
    'Pacific/Honolulu': 'Hawaii',
    'America/Juneau': 'Alaska',
    'America/Boise': 'Mountain Time',
    'America/Dawson': 'Dawson, Yukon',
    'America/Chihuahua': 'Chihuahua, La Paz, Mazatlan',
    'America/Phoenix': 'Arizona',
    'America/Chicago': 'Central Time',
    'America/Regina': 'Saskatchewan',
    'America/Mexico_City': 'Guadalajara, Mexico City, Monterrey',
    'America/Belize': 'Central America',
    'America/Detroit': 'Eastern Time',
    'America/Bogota': 'Bogota, Lima, Quito',
    'America/Caracas': 'Caracas, La Paz',
    'America/Santiago': 'Santiago',
    'America/St_Johns': 'Newfoundland and Labrador',
    'America/Sao_Paulo': 'Brasilia',
    'America/Tijuana': 'Tijuana, Pacific Time',
    'America/Argentina/Buenos_Aires': 'Buenos Aires, Georgetown',
    'America/Godthab': 'Greenland',
    'Atlantic/Azores': 'Azores',
    'Atlantic/Cape_Verde': 'Cape Verde Islands',
    GMT: 'Dublin, Edinburgh, Lisbon, London',
    'Africa/Casablanca': 'Casablanca, Monrovia',
    'Atlantic/Canary': 'Canary Islands',
    'Europe/Belgrade': 'Belgrade, Bratislava, Budapest, Ljubljana, Prague',
    'Europe/Sarajevo': 'Sarajevo, Skopje, Warsaw, Zagreb',
    'Europe/Brussels': 'Brussels, Copenhagen, Madrid, Paris',
    'Europe/Amsterdam': 'Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna',
    'Africa/Algiers': 'West Central Africa',
    'Europe/Bucharest': 'Bucharest',
    'Africa/Cairo': 'Cairo',
    'Europe/Helsinki': 'Helsinki, Kiev, Riga, Sofia, Tallinn, Vilnius',
    'Europe/Athens': 'Athens, Istanbul, Minsk',
    'Asia/Jerusalem': 'Jerusalem',
    'Africa/Harare': 'Harare, Pretoria',
    'Europe/Moscow': 'Moscow, St. Petersburg, Volgograd',
    'Asia/Kuwait': 'Kuwait, Riyadh',
    'Africa/Nairobi': 'Nairobi',
    'Asia/Baghdad': 'Baghdad',
    'Asia/Tehran': 'Tehran',
    'Asia/Dubai': 'Abu Dhabi, Muscat',
    'Asia/Baku': 'Baku, Tbilisi, Yerevan',
    'Asia/Kabul': 'Kabul',
    'Asia/Yekaterinburg': 'Ekaterinburg',
    'Asia/Karachi': 'Islamabad, Karachi, Tashkent',
    'Asia/Kolkata': 'Chennai, Kolkata, Mumbai, New Delhi',
    'Asia/Kathmandu': 'Kathmandu',
    'Asia/Dhaka': 'Astana, Dhaka',
    'Asia/Colombo': 'Sri Jayawardenepura',
    'Asia/Almaty': 'Almaty, Novosibirsk',
    'Asia/Rangoon': 'Yangon Rangoon',
    'Asia/Bangkok': 'Bangkok, Hanoi, Jakarta',
    'Asia/Krasnoyarsk': 'Krasnoyarsk',
    'Asia/Shanghai': 'Beijing, Chongqing, Hong Kong SAR, Urumqi',
    'Asia/Kuala_Lumpur': 'Kuala Lumpur, Singapore',
    'Asia/Taipei': 'Taipei',
    'Australia/Perth': 'Perth',
    'Asia/Irkutsk': 'Irkutsk, Ulaanbaatar',
    'Asia/Seoul': 'Seoul',
    'Asia/Tokyo': 'Osaka, Sapporo, Tokyo',
    'Asia/Yakutsk': 'Yakutsk',
    'Australia/Darwin': 'Darwin',
    'Australia/Adelaide': 'Adelaide',
    'Australia/Sydney': 'Canberra, Melbourne, Sydney',
    'Australia/Brisbane': 'Brisbane',
    'Australia/Hobart': 'Hobart',
    'Asia/Vladivostok': 'Vladivostok',
    'Pacific/Guam': 'Guam, Port Moresby',
    'Asia/Magadan': 'Magadan, Solomon Islands, New Caledonia',
    'Asia/Kamchatka': 'Kamchatka, Marshall Islands',
    'Pacific/Fiji': 'Fiji Islands',
    'Pacific/Auckland': 'Auckland, Wellington',
    'Pacific/Tongatapu': 'Nuku\'alofa',
};
const getOptions = () => {
    const options = [];
    Object.entries(i18nTimezones)
        .reduce((obj, entry) => {
        var _a, _b;
        const a = Bt.now().goto(entry[0]);
        const tz = a.timezone();
        const tzDisplay = src_2(entry[0]);
        let abbrev = entry[0];
        let altName = entry[0];
        if (tzDisplay && tzDisplay.daylight && tzDisplay.standard) {
            abbrev = (_a = (a.isDST()
                ? tzDisplay.daylight.abbrev
                : tzDisplay.standard.abbrev)) !== null && _a !== void 0 ? _a : '';
            altName = (_b = (a.isDST()
                ? tzDisplay.daylight.name
                : tzDisplay.standard.name)) !== null && _b !== void 0 ? _b : '';
        }
        obj.push({
            name: entry[0],
            label: entry[1],
            offset: tz.current.offset,
            abbrev: abbrev,
            altName: altName,
        });
        return obj;
    }, [])
        .sort((a, b) => {
        return a.offset - b.offset;
    })
        .forEach((tz) => {
        if (tz.offset === undefined)
            return false;
        const min = tz.offset * 60;
        const hr = `${(min / 60) ^ 0}:` + (min % 60 === 0 ? '00' : Math.abs(min % 60));
        const label = `(GMT${hr.includes('-') ? hr : `+${hr}`}) ${tz.label}`;
        options.push({
            value: tz.name,
            label: label,
            abbrev: tz.abbrev,
            altName: tz.altName,
        });
    });
    return options;
};

styled$1(Box$1) `
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 4em;
`;
styled$1(Typography$1) `
  &.MuiTypography-root {
    font-weight: 500;
    font-size: 1.75rem;
    line-height: 2.5rem;
    text-align: center;
  }
`;
const ErrorIconContainer = styled$1(IconButton$1) `
  &.MuiButtonBase-root {
    background: ${UI.palette('error.main')};
    margin: 1em;
    width: 3rem;
    height: 3rem;
    color: white;
  }
`;
styled$1(ErrorIconContainer) `
  &.MuiButtonBase-root {
    background: ${UI.palette('success.main')};
  }
`;

const InfoIconStyle = styled$1(InfoIcon) `
  &.MuiSvgIcon-root {
    width: 0.75em;
    height: 0.75em;
    margin-bottom: 0.1em;
  }
`;
const HelpMessage = ({ message }) => {
    const { rootEl } = useShadowDom();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Popup$1, { mountNode: rootEl !== null && rootEl !== void 0 ? rootEl : document.body, placement: 'right', action: 'hover', arrow: true, trigger: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(IconButton$1, { size: 'small' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InfoIconStyle, { fontSize: 'small' })) },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { variant: 'label' }, message));
};

const PasswordStrengthCheckerSkeleton = () => {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Skeleton$1, { height: 30, width: '40%' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Skeleton$1, { height: 30, width: '80%' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Skeleton$1, { height: 30, width: '70%' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Skeleton$1, { height: 30, width: '90%' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Skeleton$1, { height: 30, width: '90%' }));
};
const PasswordStrengthChecker = (props) => {
    const { t, value, isTouched, passwordConfig } = props;
    const passwordStrength = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        const easyPassConfigObject = Object.assign(Object.assign({}, passwordConfig), { minOptionalTestsToPass: 1, minPhraseLength: 1 });
        const _passwordConfig = passwordConfig.minLength !== 6 ? passwordConfig : easyPassConfigObject;
        Owasp.setConfig(_passwordConfig, t);
        const { errors: requirements } = Owasp.test('aaaaa');
        const { errors: fulfilled } = Owasp.test(value);
        return requirements.map((rule) => ({ title: rule, checked: fulfilled.indexOf(rule) === -1 }));
    }, [value, passwordConfig]);
    const statusRows = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        return passwordStrength.map(({ checked, title }) => {
            const getStatus = () => {
                return isTouched && value !== '' && checked ? 'success' : isTouched && value !== '' ? 'error' : 'default';
            };
            return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StatusChip, { tabIndex: -1, key: title, status: getStatus(), label: t(title), "data-test-id": replaceSpacesWithDashes(title) });
        });
    }, [t, isTouched, value, passwordStrength]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { mt: 2, mb: 2 }, props.loading ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PasswordStrengthCheckerSkeleton, { "data-test-id": 'changePasswordSkeleton' }) : statusRows);
};

const CheckIcon = styled$1(CheckCircleOutlinedIcon)({
    color: '#63B77A',
    width: '2.875rem',
    height: '2.875rem',
    marginBottom: '2rem'
});
const MagicLinkSentIcon = styled$1(default_1$5)(({ theme }) => ({
    color: theme.palette.primary.main,
    width: '2.875rem',
    height: '2.875rem',
    marginBottom: '2rem'
}));
const MagicLinkExpiredIcon = styled$1(default_1$4)(({ theme }) => ({
    color: theme.palette.primary.main,
    width: '2.875rem',
    height: '2.875rem',
    marginBottom: '2rem'
}));
const JoinTeamIcon = styled$1(default_1$3)(({ theme }) => ({
    color: theme.palette.primary.main,
    width: '2.875rem',
    height: '2.875rem',
    marginBottom: '2rem'
}));
const iconByKey = { check: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CheckIcon, null), magicLinkSent: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MagicLinkSentIcon, null), magicLinkExpired: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MagicLinkExpiredIcon, null), joinTeam: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(JoinTeamIcon, null), none: '' };

const MessageContainer = styled$1(Box$1)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
});
const Description = styled$1(Typography$1)(({ theme }) => ({
    color: theme.palette.grey[700],
}));
const LoginMessage = (props) => {
    const { title, description, iconKey = 'none', children, testId } = props;
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MessageContainer, null,
        iconByKey[iconKey],
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Typography$1, { mb: 6, align: 'center', variant: 'h3', "data-test-id": `${testId}-title` }, title),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Description, { align: 'center', variant: 'subtitle2', "data-test-id": `${testId}-description` }, description),
        children);
};

const CarouselItem = ({ state, index, child, height, setHeight, }) => {
    const divRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
    const checkAndSetHeight = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        if (index !== state.active)
            return;
        if (!divRef.current)
            return;
        if (divRef.current.offsetHeight === 0) {
            setTimeout(() => checkAndSetHeight(), 100);
        }
        else {
            setHeight(divRef.current.offsetHeight);
        }
    }, [setHeight, state.active, index, divRef]);
    // Set height on every child change
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        checkAndSetHeight();
    }, [checkAndSetHeight]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { ref: divRef, style: { height: height } }, child));
};

const StyledRoot = styled$1('div')({
    position: 'relative',
    overflow: 'hidden',
});
styled$1('div')({
    position: 'absolute',
    height: '100%',
    width: '100%',
});
const StyledItemWrapper = styled$1('div')({
    position: 'relative',
    width: '100%',
    height: '100%',
});
const StyledIndicators = styled$1('div')({
    width: '100%',
    marginTop: '2.5rem',
    textAlign: 'center',
});
const StyledFiberManualRecordIcon = styled$1(default_1$2)({
    fontSize: '15px',
});
const StyledIndicatorIconButton = styled$1(IconButton$1, {
    shouldForwardProp: (propName) => !propName.startsWith('$'),
})(({ $active }) => ({
    cursor: 'pointer',
    transition: '200ms',
    padding: 0,
    color: $active ? '#494949' : '#afafaf',
    '&:hover': {
        color: $active ? '#494949' : '#1f1f1f',
    },
    '&:active': {
        color: $active ? '#494949' : '#1f1f1f',
    },
}));
const StyledIconButton = styled$1(IconButton$1, {
    shouldForwardProp: (propName) => !propName.startsWith('$'),
})(({ $alwaysVisible }) => ({
    margin: '0 10px',
    position: 'relative',
    backgroundColor: '#494949',
    top: 'calc(50% - 20px) !important',
    color: 'white',
    fontSize: '30px',
    transition: '200ms',
    cursor: 'pointer',
    opacity: $alwaysVisible ? '1' : '0',
    '&:hover': {
        opacity: '0.6 !important',
    },
}));
const StyledButtonWrapper = styled$1('div', {
    shouldForwardProp: (propName) => !propName.startsWith('$'),
})(({ $next, $prev, $fullHeightHover }) => (Object.assign(Object.assign(Object.assign({ position: 'absolute', height: '100px', backgroundColor: 'transparent', zIndex: 1, top: 'calc(50% - 70px)', '&:hover': {
        '& button': {
            backgroundColor: 'black',
            filter: 'brightness(120%)',
            opacity: '0.4',
        },
    } }, ($fullHeightHover
    ? {
        height: '100%',
        top: '0',
    }
    : undefined)), ($next ? { right: 0 } : undefined)), ($prev ? { left: 0 } : undefined))));

const Indicators = (props) => {
    const IndicatorIcon = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (props.IndicatorIcon !== undefined ? props.IndicatorIcon : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StyledFiberManualRecordIcon, null)), [props.IndicatorIcon]);
    const completeListIfRequired = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((arrayOfIcons) => {
        while (arrayOfIcons.length < props.length) {
            let index = 0;
            arrayOfIcons.push(arrayOfIcons[index]);
            index += 1;
        }
    }, [props.length]);
    const _a = props.indicatorIconButtonProps, { className: indicatorIconButtonClass, style: indicatorIconButtonStyle } = _a, indicatorIconButtonProps = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["className", "style"]);
    const _b = props.activeIndicatorIconButtonProps, { className: activeIndicatorIconButtonClass, style: activeIndicatorIconButtonStyle } = _b, activeIndicatorIconButtonProps = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_b, ["className", "style"]);
    let indicators = [];
    for (let i = 0; i < props.length; i++) {
        const className = i === props.active
            ? `${indicatorIconButtonClass} ${activeIndicatorIconButtonClass}`
            : `${indicatorIconButtonClass}`;
        const style = i === props.active
            ? Object.assign({}, indicatorIconButtonStyle, activeIndicatorIconButtonStyle)
            : indicatorIconButtonStyle;
        let restProps = i === props.active
            ? Object.assign({}, indicatorIconButtonProps, activeIndicatorIconButtonProps)
            : indicatorIconButtonProps;
        if (restProps['aria-label'] === undefined)
            restProps['aria-label'] = 'carousel indicator';
        const createIndicator = (IndicatorIcon) => {
            return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StyledIndicatorIconButton, Object.assign({ "$active": i === props.active, key: i, className: className, style: style, onClick: () => {
                    props.press(i);
                } }, restProps, { "aria-label": `${restProps['aria-label']} ${i + 1}` }), IndicatorIcon));
        };
        Array.isArray(IndicatorIcon)
            ? indicators.push(createIndicator(IndicatorIcon[i])) && completeListIfRequired(IndicatorIcon)
            : indicators.push(createIndicator(IndicatorIcon));
    }
    const _c = props.indicatorContainerProps, { className: indicatorContainerClass, style: indicatorContainerStyle } = _c, indicatorContainerProps = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_c, ["className", "style"]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StyledIndicators, Object.assign({ className: indicatorContainerClass, style: indicatorContainerStyle }, indicatorContainerProps), indicators));
};

const sanitizeNavProps = (props) => {
    const _a = props || {}, rest = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["className", "style"]);
    return props !== undefined
        ? Object.assign({ style: props.style !== undefined ? props.style : {}, className: props.className !== undefined ? props.className : '' }, rest) : Object.assign({ style: {}, className: '' }, rest);
};
const sanitizeProps = (props) => {
    const animation = props.animation !== undefined ? props.animation : 'fade';
    const duration = props.duration !== undefined ? props.duration : animation === 'fade' ? 500 : 200;
    return {
        sx: props.sx !== undefined ? props.sx : {},
        className: props.className !== undefined ? props.className : '',
        children: props.children ? props.children : [],
        height: props.height,
        index: props.index !== undefined ? props.index : 0,
        strictIndexing: props.strictIndexing !== undefined ? props.strictIndexing : true,
        autoPlay: props.autoPlay !== undefined ? props.autoPlay : true,
        stopAutoPlayOnHover: props.stopAutoPlayOnHover !== undefined ? props.stopAutoPlayOnHover : true,
        interval: props.interval !== undefined ? props.interval : 8000,
        animation: animation,
        duration: duration,
        navButtonsAlwaysInvisible: props.navButtonsAlwaysInvisible !== undefined ? props.navButtonsAlwaysInvisible : false,
        navButtonsAlwaysVisible: props.navButtonsAlwaysVisible !== undefined ? props.navButtonsAlwaysVisible : false,
        cycleNavigation: props.cycleNavigation !== undefined ? props.cycleNavigation : true,
        fullHeightHover: props.fullHeightHover !== undefined ? props.fullHeightHover : true,
        navButtonsWrapperProps: sanitizeNavProps(props.navButtonsWrapperProps),
        navButtonsProps: sanitizeNavProps(props.navButtonsProps),
        NavButton: props.NavButton,
        NextIcon: props.NextIcon !== undefined ? props.NextIcon : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(default_1, null),
        PrevIcon: props.PrevIcon !== undefined ? props.PrevIcon : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(default_1$1, null),
        indicators: props.indicators !== undefined ? props.indicators : true,
        indicatorContainerProps: sanitizeNavProps(props.indicatorContainerProps),
        indicatorIconButtonProps: sanitizeNavProps(props.indicatorIconButtonProps),
        activeIndicatorIconButtonProps: sanitizeNavProps(props.activeIndicatorIconButtonProps),
        IndicatorIcon: props.IndicatorIcon,
        onChange: props.onChange !== undefined ? props.onChange : () => { },
        changeOnFirstRender: props.changeOnFirstRender !== undefined ? props.changeOnFirstRender : false,
        next: props.next !== undefined ? props.next : () => { },
        prev: props.prev !== undefined ? props.prev : () => { },
    };
};
const useInterval = (callback, delay) => {
    const savedCallback = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(() => { });
    // Remember the latest callback.
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);
    // Set up the interval.
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        function tick() {
            savedCallback.current();
        }
        if (delay !== null) {
            let id = setInterval(tick, delay);
            return () => clearInterval(id);
        }
        return () => { };
    }, [delay]);
};

const Carousel = (props) => {
    const [state, setState] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState({
        active: 0,
        prevActive: 0,
        next: true,
    });
    const [fadeIn, setFadeIn] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(true);
    /** Used to set carousel's height. It is being set by the CarouselItems */
    const [childrenHeight, setChildrenHeight] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState();
    const [paused, setPaused] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const sanitizedProps = sanitizeProps(props);
    const { children, sx, className, height, stopAutoPlayOnHover, 
    // animation, not supported yet
    duration, navButtonsAlwaysInvisible, navButtonsAlwaysVisible, cycleNavigation, fullHeightHover, navButtonsProps, navButtonsWrapperProps, NavButton, NextIcon, PrevIcon, indicators, indicatorContainerProps, indicatorIconButtonProps, activeIndicatorIconButtonProps, IndicatorIcon, } = sanitizedProps;
    // componentDidMount & onIndexChange
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        const { index, changeOnFirstRender } = sanitizedProps;
        setNext(index, true, changeOnFirstRender);
    }, [sanitizedProps.index]);
    useInterval(() => {
        const { autoPlay } = sanitizedProps;
        if (autoPlay && !paused) {
            next(undefined);
        }
    }, sanitizedProps.interval);
    const next = (event) => {
        const { children, cycleNavigation } = sanitizedProps;
        setFadeIn(false);
        let last = Array.isArray(children) ? children.length - 1 : 0;
        const nextActive = state.active + 1 > last ? (cycleNavigation ? 0 : state.active) : state.active + 1;
        setTimeout(() => {
            setFadeIn(true);
            setNext(nextActive, true);
        }, duration);
        if (event)
            event.stopPropagation();
    };
    const prev = (event) => {
        const { children, cycleNavigation } = sanitizedProps;
        let last = Array.isArray(children) ? children.length - 1 : 0;
        const nextActive = state.active - 1 < 0 ? (cycleNavigation ? last : state.active) : state.active - 1;
        setTimeout(() => {
            setFadeIn(true);
            setNext(nextActive, false);
        }, duration);
        if (event)
            event.stopPropagation();
    };
    const setNext = (index, isNext, runCallbacks = true) => {
        const { onChange, children, strictIndexing } = sanitizedProps;
        if (Array.isArray(children)) {
            if (strictIndexing && index > children.length - 1)
                index = children.length - 1;
            if (strictIndexing && index < 0)
                index = 0;
        }
        else {
            index = 0;
        }
        if (runCallbacks) {
            if (isNext !== undefined)
                isNext ? sanitizedProps.next(index, state.active) : sanitizedProps.prev(index, state.active);
            onChange(index, state.active);
        }
        if (isNext === undefined) {
            isNext = index > state.active;
        }
        setState({
            active: index,
            prevActive: state.active,
            next: isNext,
        });
    };
    const showButton = (next = true) => {
        if (cycleNavigation)
            return true;
        const last = Array.isArray(children) ? children.length - 1 : 0;
        if (next && state.active === last)
            return false;
        if (!next && state.active === 0)
            return false;
        return true;
    };
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StyledRoot, { sx: sx, className: className, onMouseOver: () => {
            stopAutoPlayOnHover && setPaused(true);
        }, onMouseOut: () => {
            stopAutoPlayOnHover && setPaused(false);
        }, onFocus: () => {
            stopAutoPlayOnHover && setPaused(true);
        }, onBlur: () => {
            stopAutoPlayOnHover && setPaused(false);
        } },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StyledItemWrapper, { style: { height: height ? height : childrenHeight } }, Array.isArray(children) && children.length >= 2 ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Fade$1, { in: fadeIn, unmountOnExit: true, timeout: duration },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("div", null, children
                .filter((_, index) => index === state.active)
                .map((child, index) => {
                return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CarouselItem, { key: `carousel-item${index}`, state: state, index: index, child: child, height: height, setHeight: setChildrenHeight }));
            })))) : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CarouselItem, { key: `carousel-item0`, state: state, index: 0, child: children, height: height, setHeight: setChildrenHeight }))),
        !navButtonsAlwaysInvisible && showButton(true) && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StyledButtonWrapper, Object.assign({ "$next": true, "$prev": false, "$fullHeightHover": fullHeightHover }, navButtonsWrapperProps), NavButton !== undefined ? (NavButton(Object.assign({ onClick: next, next: true, prev: false }, navButtonsProps))) : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StyledIconButton, Object.assign({ "$alwaysVisible": navButtonsAlwaysVisible, "$fullHeightHover": fullHeightHover, onClick: next, "aria-label": 'Next' }, navButtonsProps), NextIcon)))),
        !navButtonsAlwaysInvisible && showButton(false) && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StyledButtonWrapper, Object.assign({ "$next": false, "$prev": true, "$fullHeightHover": fullHeightHover }, navButtonsWrapperProps), NavButton !== undefined ? (NavButton(Object.assign({ onClick: prev, next: false, prev: true }, navButtonsProps))) : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StyledIconButton, Object.assign({ "$alwaysVisible": navButtonsAlwaysVisible, "$fullHeightHover": fullHeightHover, onClick: prev, "aria-label": 'Previous' }, navButtonsProps), PrevIcon)))),
        indicators ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Indicators, { length: Array.isArray(children) ? children.length : 0, active: state.active, press: setNext, indicatorContainerProps: indicatorContainerProps, indicatorIconButtonProps: indicatorIconButtonProps, activeIndicatorIconButtonProps: activeIndicatorIconButtonProps, IndicatorIcon: IndicatorIcon })) : null));
};

const getAllChild = (childNode, collectedNodes = []) => {
    if (childNode === null)
        return collectedNodes;
    collectedNodes.push(childNode.id);
    if (Array.isArray(childNode.children)) {
        for (const node of childNode.children) {
            getAllChild(node, collectedNodes);
        }
    }
    return collectedNodes;
};
const goThroughAllNodes = (nodes, map = {}) => {
    if (!nodes.children) {
        return {};
    }
    map[nodes.id] = getAllChild(nodes).splice(1);
    for (let childNode of nodes.children) {
        goThroughAllNodes(childNode, map);
    }
    return map;
};
const ListStyled = styled$1(List$1) `
  border: 0.5px solid ${UI.palette('grey.300')};
  padding-top: 0;
  padding-bottom: 0;
`;
const TreeNode = ({ node, ItemContent, itemProps, parentMap, onChange, selectedSet }) => {
    const [open, setOpen] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(true);
    const hasChildren = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => Array.isArray(node.children) && node.children.length, [node]);
    const handleClick = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setOpen(!open);
    }, [open]);
    const handleChange = (event) => {
        onChange(event.currentTarget.checked, node.id);
    };
    const checked = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => selectedSet.has(node.id) || false, [node, selectedSet]);
    const indeterminate = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => { var _a; return (!checked && ((_a = parentMap[node.id]) === null || _a === void 0 ? void 0 : _a.some((childNodeId) => selectedSet.has(childNodeId)))) || false; }, [node, selectedSet, parentMap]);
    const calculatedSx = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({ mr: 2, ml: 4 * node.level }), [node]);
    const icon = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (open ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ExpandMore, { sx: calculatedSx }) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ChevronRight, { sx: calculatedSx })), [
        open,
        calculatedSx,
    ]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ListItemButton$1, { key: node.id, onClick: handleClick, sx: { minHeight: 64, border: '0.5px solid #E5EAF3' } },
            hasChildren ? icon : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Box$1, { sx: Object.assign(Object.assign({}, calculatedSx), { pr: 8, width: 12 }) }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ListItemIcon$1, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Checkbox$1, { edge: 'start', checked: checked, onChange: handleChange, tabIndex: -1, indeterminate: indeterminate, disableRipple: true, inputProps: { 'aria-labelledby': node.id }, onClick: (e) => e.stopPropagation() })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { container: true, alignItems: 'center' },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, xs: 2 },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ListItemText$1, { id: node.id, primary: node.name || node.id })),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Grid$1, { item: true, xs: 10, onClick: (e) => e.stopPropagation() }, checked && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ItemContent, Object.assign({ id: node.id }, itemProps))))),
        hasChildren ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Collapse$1, { in: open, timeout: 'auto', unmountOnExit: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(List$1, { component: 'div', disablePadding: true }, Array.isArray(node.children) &&
                node.children.map((childNode) => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TreeNode, { node: childNode, itemProps: itemProps, ItemContent: ItemContent, parentMap: parentMap, onChange: onChange, selectedSet: selectedSet })))))) : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null))));
};
const Tree = ({ data, handleSelectedChange, ItemContent, itemProps, selected: initialSelected, }) => {
    const [selected, setSelected] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(initialSelected || []);
    const selectedSet = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => new Set(selected), [selected]);
    const parentMap = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        return goThroughAllNodes(data);
    }, [data]);
    const onChange = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((checked, nodeId) => {
        let array = checked ? [...selected, nodeId] : selected.filter((value) => nodeId !== value);
        setSelected(array);
        handleSelectedChange(array);
    }, [selected]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => initialSelected && setSelected(initialSelected), [initialSelected]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ListStyled, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TreeNode, { node: data, ItemContent: ItemContent, itemProps: itemProps, parentMap: parentMap, onChange: onChange, selectedSet: selectedSet })));
};

const navigation = (palette) => ({
    groupTitleColor: palette.grey[600],
    groupTitleSize: '0.625rem',
    background: palette.common.white,
    headerColor: palette.grey[800],
    subHeaderColor: palette.grey[700],
    default: {
        color: palette.grey[600],
        borderColor: 'transparent',
        avatarBgColor: '#FBFBFC',
        avatarColor: palette.grey[700],
    },
    hover: {
        color: palette.grey[700],
        background: palette.grey[150],
        borderColor: palette.grey[300],
        avatarColor: palette.grey[800],
        avatarBgColor: palette.common.white,
    },
    selected: {
        color: palette.grey[700],
        background: palette.grey[150],
        borderColor: palette.grey[300],
        avatarColor: palette.grey[800],
        avatarBgColor: palette.common.white,
    },
});
const dialog = (palette) => ({
    headerBackground: palette.grey[150],
    headerTextColor: palette.grey[800],
    bodyBackground: palette.common.white,
    footerBackground: palette.common.white,
});
const socialLogins = (palette) => ({
    rowLayout: false,
    google: {
        background: '#448aff',
        default: {
            color: palette.common.white,
        },
        hover: {
            color: palette.common.white,
            background: '#0054e2',
        },
        selected: {
            color: palette.common.white,
            background: '#0361ff',
        },
    },
    gitHub: {
        background: '#424242',
        default: {
            color: palette.common.white,
        },
        hover: {
            color: palette.common.white,
            background: '#2e2e2e',
        },
        selected: {
            color: palette.common.white,
            background: '#343434',
        },
    },
    facebook: {
        background: '#3b5998',
        default: {
            color: palette.common.white,
        },
        hover: {
            color: palette.common.white,
            background: '#2f4779',
        },
        selected: {
            color: palette.common.white,
            background: '#293e6a',
        },
    },
    microsoft: {
        background: '#42a5f5',
        default: {
            color: palette.common.white,
        },
        hover: {
            color: palette.common.white,
            background: '#0a77ce',
        },
        selected: {
            color: palette.common.white,
            background: '#0c88ec',
        },
    },
});
const rightPanel = (palette) => ({
    headerBackground: '#F5F6F8',
    pageBackground: '#F5F6F8',
    elementBackground: palette.common.white,
    profileHeader: palette.common.white,
    tableHeaderBackground: palette.grey[150],
    tableBodyBackground: palette.common.white,
});
const authPage = (palette) => ({
    loginBox: {
        width: '28rem',
        padding: '2rem 2rem',
        border: 'none',
        borderRadius: '9px',
        boxShadow: ' 0 0 43px 7px rgba(0, 0, 0, 0.12)',
        backgroundCard: palette.common.white,
    },
    loginSignupSwitch: {
        color: palette.secondary.contrastText,
        fontSize: '0.875rem',
        link: {
            color: palette.primary.main,
            decoration: 'underline',
        },
    },
    inputError: {
        fontSize: '0.75rem',
        fontWeight: 400,
    },
    subHeaderMsg: {
        fontSize: '1.5rem',
        fontWeight: 600,
        textAlign: 'start',
        color: 'Black',
    },
});

const defaultFontFamily = [
    'Manrope',
    'Nunito',
    '-apple-system',
    'BlinkMacSystemFont',
    '"Segoe UI"',
    'Roboto',
    '"Helvetica Neue"',
    'Arial',
    'sans-serif',
    '"Apple Color Emoji"',
    '"Segoe UI Emoji"',
    '"Segoe UI Symbol"',
].join(',');
const generateAppFontFamily = (fontFamily) => {
    const linkNode = document.createElement('link');
    linkNode.type = 'text/css';
    linkNode.rel = 'stylesheet';
    linkNode.href = `//fonts.googleapis.com/css2?family=${fontFamily || 'Manrope'}:wght@400;500;600;700;800&display=swap`;
    document.head.appendChild(linkNode);
    return () => {
        document.head.removeChild(linkNode);
    };
};
const RootStyle = ({ theme }) => {
    var _a, _b;
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        return generateAppFontFamily();
    }, []);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        var _a;
        if (!((_a = theme.typography) === null || _a === void 0 ? void 0 : _a.fontFamily) || theme.typography.fontFamily === defaultFontFamily)
            return;
        const formattedFontFamily = theme.typography.fontFamily.split(' ').join('+');
        return generateAppFontFamily(formattedFontFamily);
    }, [(_a = theme.typography) === null || _a === void 0 ? void 0 : _a.fontFamily]);
    const initGlobalStyles = `
  * {
    font-family: ${((_b = theme.typography) === null || _b === void 0 ? void 0 : _b.fontFamily) || defaultFontFamily};
  },
`;
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("style", { type: 'text/css', children: initGlobalStyles }));
};

const typography = (palette, _defaultTypographyStyle) => {
    const fontFamily = (_defaultTypographyStyle === null || _defaultTypographyStyle === void 0 ? void 0 : _defaultTypographyStyle.fontFamily) || defaultFontFamily;
    const defaultTypographyStyle = Object.assign({ display: 'block', lineHeight: 1.3, fontFamily, wordBreak: 'break-word', textRendering: 'geometricPrecision', color: palette.grey[800] }, _defaultTypographyStyle);
    return {
        fontFamily,
        fontSize: 14,
        fontWeightLight: 300,
        fontWeightRegular: 400,
        fontWeightMedium: 600,
        link: Object.assign(Object.assign({}, defaultTypographyStyle), { color: palette.info.dark, fontFamily }),
        h1: {
            fontFamily,
            fontSize: '2rem',
            fontWeight: 600,
            lineHeight: 1.2,
        },
        h2: {
            fontFamily,
            fontSize: '1.75rem',
            fontWeight: 600,
            lineHeight: 1.2,
        },
        h3: {
            fontFamily,
            fontSize: '1.5rem',
            fontWeight: 600,
            lineHeight: '2rem',
        },
        h4: {
            fontFamily,
            fontSize: '1.25rem',
            fontWeight: 700,
            lineHeight: '1.5rem',
            color: '#3C4A5A',
        },
        h5: {
            fontFamily,
            fontSize: '1.125rem',
            fontWeight: 600,
            lineHeight: 1.2,
        },
        h6: {
            fontFamily,
            fontSize: '1.0625rem',
            fontWeight: 600,
            lineHeight: 1.2,
        },
        pageTitle: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '1.5rem', fontWeight: 600, lineHeight: '2rem' }),
        pageTitleSmall: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '1.25rem', fontWeight: 700, lineHeight: '1.5rem' }),
        subtitle1: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '1rem', fontWeight: 600, lineHeight: 1.5 }),
        subtitle2: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '0.875rem', fontWeight: 600, lineHeight: '1.5rem' }),
        subtitle2Light: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '0.875rem', fontWeight: 400, lineHeight: '1.5rem' }),
        body1: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '0.875rem', fontWeight: 400, overflow: 'hidden', textOverflow: 'ellipsis' }),
        body2: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '0.75rem', fontWeight: 400 }),
        body1Bold: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '0.875rem', fontWeight: 600, overflow: 'hidden', textOverflow: 'ellipsis' }),
        body2Bold: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '0.75rem', fontWeight: 700 }),
        description: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '1rem', fontWeight: 400, lineHeight: 1.5 }),
        button: {
            fontFamily,
            textTransform: 'none',
        },
        label: Object.assign(Object.assign({}, defaultTypographyStyle), { fontWeight: 600, fontSize: '0.875rem', color: palette.grey[800] }),
        dialogTitle: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '1rem', fontWeight: 600, lineHeight: 1.5 }),
        selectOption: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '.875rem', fontWeight: 400, lineHeight: '1rem' }),
        tableTitleCell: Object.assign(Object.assign({}, defaultTypographyStyle), { fontWeight: 600, fontSize: '0.875rem', lineHeight: 1.3, overflow: 'hidden', textOverflow: 'ellipsis', width: '100%', whiteSpace: 'nowrap' }),
        tableSmallHeader: Object.assign(Object.assign({}, defaultTypographyStyle), { fontWeight: 600, fontSize: '0.75rem', lineHeight: 1.3, overflow: 'hidden', textOverflow: 'ellipsis', width: '100%', textAlign: 'center', whiteSpace: 'nowrap' }),
        tableStandardCell: Object.assign(Object.assign({}, defaultTypographyStyle), { color: palette.grey[700], fontSize: '0.875rem', fontWeight: 'normal', lineHeight: 1.3, overflow: 'hidden', textOverflow: 'ellipsis', width: '100%', whiteSpace: 'nowrap' }),
        tableCountCell: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '0.75rem', fontWeight: 'normal', lineHeight: '1.5rem' }),
        tableCategory: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '0.75rem', fontWeight: 600, lineHeight: '1rem', color: palette.grey[700] }),
        uploadDropZoneDescription: Object.assign(Object.assign({}, defaultTypographyStyle), { fontWeight: 400, fontSize: '0.875rem', lineHeight: '1.25rem' }),
        uploadDropZoneProgressText: Object.assign(Object.assign({}, defaultTypographyStyle), { fontWeight: 600, fontSize: '0.875rem', lineHeight: '1rem', color: palette.grey[700] }),
        tablePlaceholderTitle: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '1.5rem', fontWeight: 600, lineHeight: '2rem', color: palette.grey[800], textAlign: 'center', marginTop: '1.5rem', marginBottom: '.5rem' }),
        tablePlaceholderDescription: Object.assign(Object.assign({}, defaultTypographyStyle), { color: palette.grey[700], fontSize: '0.875rem', fontWeight: 400, lineHeight: '1.5rem', textAlign: 'center' }),
        switchLabel: Object.assign(Object.assign({}, defaultTypographyStyle), { color: palette.grey[700], fontSize: '0.625rem', fontWeight: 600, lineHeight: '1rem' }),
        tableIpCellText: Object.assign(Object.assign({}, defaultTypographyStyle), { color: palette.grey[700], fontSize: '0.75rem', lineHeight: '1rem', fontWeight: 'normal', textDecoration: 'underline', cursor: 'pointer' }),
        tableIpPopupTitle: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '0.75rem', lineHeight: '1rem', fontWeight: 'bold' }),
        tableIpPopupDesc: Object.assign(Object.assign({}, defaultTypographyStyle), { color: palette.grey[700], fontSize: '0.75rem', lineHeight: '1rem', fontWeight: 'normal' }),
        tablePopupTitle: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '0.75rem', lineHeight: '1rem', fontWeight: 600 }),
        tableFilterTitle: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '0.75rem', fontWeight: 600, lineHeight: '1rem' }),
        tableFilterChipInfo: Object.assign(Object.assign({}, defaultTypographyStyle), { color: palette.info['main'] }),
        tableHeaderTitle: Object.assign(Object.assign({}, defaultTypographyStyle), { fontWeight: 600, fontSize: '0.75rem', lineHeight: '1rem', color: palette.grey[700] }),
        testimonialTitle: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '1.25rem', fontWeight: 600, lineHeight: '1.5rem' }),
        testimonialSubtitle: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '0.875rem', fontWeight: 300, lineHeight: '1.5rem' }),
        testimonialDescription: Object.assign(Object.assign({}, defaultTypographyStyle), { fontSize: '1rem', fontWeight: 600, lineHeight: '1.5rem', style: 'italic' })
    };
};
var typography$1 = typography;

const breakpoints = {
    values: {
        xs: 0,
        sm: 800,
        md: 1000,
        lg: 1200,
        xl: 1400,
    },
};
var breakpoints$1 = breakpoints;

const components = (palette, spacing) => {
    var _a, _b, _c, _d;
    return ({
        MuiButtonBase: {
            defaultProps: {
                disableRipple: true,
            },
        },
        MuiButton: {
            defaultProps: {
                variant: 'contained',
                disableRipple: true,
                disableTouchRipple: true,
                focusRipple: false,
                centerRipple: false,
                color: 'primary',
                type: 'submit',
                classes: {
                    disabled: '',
                },
            },
            styleOverrides: {
                root: {
                    whiteSpace: 'nowrap',
                    padding: '0.5rem 1.5rem',
                    fontSize: '14px',
                    borderRadius: 4,
                    height: 40,
                    transition: 'all 300ms ease-in-out',
                    '&.Mui-disabled': {
                        boxShadow: 'none',
                    },
                    '&.Mui-iconOnly': {
                        '.MuiButton-startIcon': {
                            marginRight: 0,
                            marginLeft: 0,
                        },
                    },
                    '& .MuiSvgIcon, & svg': {
                        width: '1rem',
                        height: '1rem',
                        fontSize: '1rem',
                    },
                },
                sizeSmall: {
                    height: 36,
                },
                sizeLarge: {
                    height: 44,
                },
                containedPrimary: {
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: palette.primary.main,
                    color: palette.primary.contrastText,
                    backgroundColor: palette.primary.main,
                    '&:not(.Mui-disabled)': {
                        background: palette.primary.main,
                    },
                    '&.Mui-disabled': {
                        backgroundColor: palette.primary.light,
                        color: palette.primary.contrastText,
                    },
                    '&:not(.Mui-disabled).Mui-hovered, &:not(.Mui-disabled).Mui-focus, &:not(.Mui-disabled):hover, &:not(.Mui-disabled):focus': {
                        background: palette.primary.hover,
                    },
                    '&:not(.Mui-disabled).Mui-active, &:not(.Mui-disabled):active': {
                        background: palette.primary.active,
                    },
                },
                containedSecondary: {
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: palette.secondary.main,
                    color: palette.secondary.contrastText,
                    backgroundColor: palette.secondary.main,
                    '&:not(.Mui-disabled)': {
                        backgroundColor: palette.secondary.main,
                    },
                    '&.Mui-disabled': {
                        backgroundColor: palette.secondary.light,
                        color: palette.secondary.contrastText,
                    },
                    '&:not(.Mui-disabled).Mui-hovered, &:not(.Mui-disabled).Mui-focus, &:not(.Mui-disabled):hover, &:not(.Mui-disabled):focus': {
                        backgroundColor: palette.secondary.hover,
                    },
                    '&:not(.Mui-disabled).Mui-active, &:not(.Mui-disabled):active': {
                        backgroundColor: palette.secondary.active,
                    },
                },
                outlined: {
                    border: '1px solid rgba(0, 0, 0, .15)',
                },
                containedInherit: {
                    borderWidth: '1px',
                    borderStyle: 'solid',
                    borderColor: 'rgba(0, 0, 0, .15)',
                    backgroundColor: palette.grey[100],
                    color: palette.grey[800],
                    fontWeight: 600,
                    '&:hover, &:focus': {
                        backgroundColor: 'unset',
                    },
                },
                textInherit: {
                    lineHeight: '1rem',
                    color: palette.grey[800],
                    fontWeight: 600,
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    padding: spacing * 1.5,
                    '&.Mui-disabled': {
                        color: palette.grey[300],
                    },
                },
            },
        },
        MuiListItem: {
            styleOverrides: {
                root: {
                    padding: '0.75rem 1rem',
                },
            },
        },
        MuiOutlinedInput: {
            defaultProps: {
                fullWidth: true,
            },
            styleOverrides: {
                root: {
                    borderWidth: `1px`,
                    borderStyle: `solid`,
                    borderColor: palette.grey[400],
                    backgroundColor: palette.common.white,
                    borderRadius: '0.25rem',
                    fontSize: '0.875rem',
                    color: palette.grey[800],
                    transition: 'all 200ms ease-in-out',
                    '&:not(.Mui-disabled):hover, &:not(.Mui-disabled):focus, &:not(.Mui-disabled).Mui-focused, &:not(.Mui-disabled).Mui-hovered': {
                        boxShadow: 'none',
                        outlineColor: palette.primary.main,
                        outlineStyle: 'solid',
                        outlineWidth: '1px',
                        outlineOffset: '0px',
                    },
                    '&.Mui-disabled': {
                        opacity: 1,
                        boxShadow: 'none',
                        backgroundColor: palette.grey[200],
                    },
                    '& .MuiCircularProgress-root': {
                        width: '1rem',
                        height: '1rem',
                        overflow: 'hidden',
                        position: 'absolute',
                        right: '1rem',
                        color: palette.grey[600],
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                        border: 0,
                        display: 0,
                    },
                    '& input::placeholder': {
                        color: palette.grey[600],
                        opacity: 1,
                    },
                    '& input:-ms-input-placeholder': {
                        color: palette.grey[600],
                    },
                    '& input::-ms-input-placeholder': {
                        color: palette.grey[600],
                    },
                },
                input: {
                    fontWeight: 400,
                    borderRadius: '3px',
                    height: 'unset',
                    padding: 'calc(0.5rem + 1px) 1rem',
                },
                inputAdornedEnd: {
                    marginRight: '-2.5rem',
                    paddingRight: '2.75rem',
                    '& + .MuiInputAdornment-root': {
                        margin: 0,
                        padding: 0,
                    },
                },
                adornedEnd: {
                    paddingRight: '.5rem',
                },
            },
        },
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    color: 'inherit',
                    minWidth: 'initial',
                    width: '1rem',
                    height: '1.5rem',
                    marginRight: '1rem',
                    position: 'relative',
                    '& .MuiCircularProgress-indeterminate': {
                        width: '2rem !important',
                        height: '2rem !important',
                        position: 'absolute',
                        left: '-0.5rem',
                        bottom: 0,
                        top: 0,
                        margin: 'auto',
                    },
                    '& .MuiCircularProgress-indeterminate .MuiCircularProgress-circleIndeterminate': {
                        strokeWidth: 3,
                    },
                },
            },
        },
        MuiCard: {
            styleOverrides: {
                root: {
                    borderRadius: 3,
                    boxShadow: '0px 1px 2px rgba(0,0,0,.1)',
                    padding: '1.5rem',
                },
            },
        },
        MuiCardHeader: {
            defaultProps: {
                titleTypographyProps: { variant: 'h6' },
            },
            styleOverrides: {
                action: {
                    marginTop: '-4px',
                    marginRight: '-4px',
                },
            },
        },
        MuiAlert: {
            defaultProps: {
                variant: 'standard',
            },
            styleOverrides: {
                root: {
                    padding: `${spacing * 2}px ${spacing * 4}px`,
                    alignItems: 'center',
                    borderRadius: '4px',
                },
                message: {
                    padding: 0,
                    fontWeight: 600,
                    fontSize: '0.875rem',
                    lineHeight: '1.5rem',
                },
                icon: {
                    marginRight: spacing * 4,
                    opacity: 1,
                },
                standardInfo: {
                    backgroundColor: palette.info.light,
                    color: palette.info.main,
                    border: palette.info.border,
                    '.MuiAlert-icon': {
                        color: palette.info.main,
                    },
                },
                standardError: {
                    backgroundColor: palette.error.light,
                    color: palette.error.main,
                    border: palette.error.border,
                    '.MuiAlert-icon': {
                        color: palette.error.main,
                    },
                },
                standardSuccess: {
                    backgroundColor: palette.success.light,
                    color: palette.success.main,
                    border: palette.success.border,
                    '.MuiAlert-icon': {
                        color: palette.success.main,
                    },
                },
                standardWarning: {
                    backgroundColor: palette.warning.light,
                    color: palette.warning.main,
                    border: palette.warning.border,
                    '.MuiAlert-icon': {
                        color: palette.warning.main,
                    },
                },
            },
        },
        MuiChip: {
            defaultProps: {
                color: 'primary',
                size: 'small',
                deleteIcon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createElement(CloseIcon),
            },
            styleOverrides: {
                root: {
                    lineHeight: 1.2,
                    borderRadius: '4px',
                    '&.Mui-disabled': {
                        opacity: 0.6,
                    },
                },
                colorPrimary: {
                    color: palette.grey['800'],
                    backgroundColor: (_a = palette.common) === null || _a === void 0 ? void 0 : _a.cyanBlue,
                },
                colorSecondary: {
                    color: '#A79D7B',
                    backgroundColor: (_b = palette.common) === null || _b === void 0 ? void 0 : _b.paleLightYellow,
                },
                colorDefault: {
                    color: palette.grey[500],
                    backgroundColor: palette.grey[150],
                },
                colorError: {
                    color: palette.error.main,
                    backgroundColor: palette.error.light,
                },
                colorSuccess: {
                    color: palette.success.main,
                    backgroundColor: palette.success.light,
                },
                deleteIconColorPrimary: {
                    width: '12px',
                    height: '12px',
                    marginRight: '8px',
                    color: (_c = palette === null || palette === void 0 ? void 0 : palette.info) === null || _c === void 0 ? void 0 : _c.main,
                    '&:hover': {
                        color: (_d = palette === null || palette === void 0 ? void 0 : palette.info) === null || _d === void 0 ? void 0 : _d.main,
                    },
                },
            },
            variants: [{
                    props: {
                        size: 'small',
                    },
                    style: {
                        fontSize: '0.75rem',
                        fontWeight: 700,
                    },
                }],
        },
        MuiSwitch: {
            defaultProps: {
                color: 'default',
            },
            styleOverrides: {
                root: {
                    padding: '0.8125rem',
                    width: '3.5rem',
                    height: '2.375rem',
                },
                switchBase: {
                    margin: '0.3rem',
                    padding: '0.4rem',
                    '&.Mui-checked + .MuiSwitch-track': {
                        opacity: 1,
                        backgroundColor: palette.switchButton.light,
                    },
                    '&.Mui-checked': {
                        color: palette.switchButton.main,
                        transform: 'translateX(1.125rem)',
                    },
                    '&:not(.Mui-checked) + .MuiSwitch-track': {
                        backgroundColor: palette.grey[300],
                    },
                    '&:not(.Mui-checked)': {
                        color: palette.grey[400],
                    },
                    '&.Mui-disabled': {
                        opacity: 0.7,
                    },
                    '&.Mui-checked.Mui-disabled': {
                        color: palette.switchButton.light,
                    },
                    '&.Mui-disabled + .MuiSwitch-track': {
                        opacity: .5,
                    },
                },
                thumb: {
                    height: '1rem',
                    width: '1rem',
                },
                track: {
                    opacity: 1,
                    backgroundColor: palette.grey[300],
                },
            },
        },
        MuiDialog: {
            styleOverrides: {
                paperWidthSm: {
                    maxWidth: 600,
                },
                paperWidthMd: {
                    maxWidth: 800,
                },
            },
        },
        MuiFormHelperText: {
            styleOverrides: {
                root: {
                    '&.Mui-error': {
                        fontSize: '0.75rem',
                        fontWeight: 400,
                        lineHeight: '1rem',
                    },
                },
            },
        },
        MuiLink: {
            defaultProps: {
                underline: 'hover',
                display: 'inline',
            },
            styleOverrides: {
                root: {
                    cursor: 'pointer',
                },
            },
        },
        MuiTable: {
            styleOverrides: {
                root: {
                    borderRadius: '3px',
                },
            },
        },
        MuiTableBody: {
            styleOverrides: {
                root: {
                    transition: 'opacity 300ms',
                },
            },
        },
        MuiTableHead: {
            styleOverrides: {
                root: {
                    position: 'sticky',
                    top: '0px',
                    zIndex: 10,
                    '& > .MuiTableRow-head': {
                        position: 'sticky',
                        top: '0px',
                        zIndex: 10,
                    },
                    '& > .MuiTableCell-head': {
                        position: 'sticky',
                        zIndex: 10,
                        left: 0,
                        boxShadow: `-10px 0 10px 0px ${palette.grey[150]}`,
                        background: palette.grey[150],
                    },
                },
            },
        },
        MuiTableRow: {
            styleOverrides: {
                head: {
                    background: palette.grey[150],
                    minHeight: '56px',
                },
                root: {
                    // minHeight: '4.75rem',
                    alignItems: 'stretch',
                    '& .MuiTableCell-body': {
                        display: 'flex',
                        alignItems: 'start',
                        flexDirection: 'column',
                        justifyContent: 'center',
                    },
                    '&:last-child .MuiTableCell-body': {
                        borderBottom: 'none',
                    },
                },
            },
        },
        MuiTableCell: {
            styleOverrides: {
                head: {
                    paddingTop: spacing * 5,
                    paddingBottom: 0,
                    paddingLeft: spacing * 4,
                    paddingRight: 0,
                    fontSize: '0.875rem',
                    lineHeight: '1rem',
                    fontWeight: 600,
                    color: palette.grey[800],
                    boxShadow: 'none',
                    borderBottom: 'none',
                    '&:first-of-type': {
                        paddingLeft: spacing * 8,
                    },
                    '&:last-child': {
                        paddingRight: spacing * 4,
                    },
                },
                body: {
                    borderBottomColor: palette.grey[300],
                    paddingTop: spacing * 5,
                    paddingBottom: spacing * 5,
                    paddingLeft: spacing * 4,
                    paddingRight: 0,
                    '&:first-of-type': {
                        paddingLeft: spacing * 8,
                    },
                    '&:last-child': {
                        paddingRight: spacing * 6,
                    },
                    '& > .MuiButtonBase-root .MuiSvgIcon-root': {
                        width: '1rem',
                        height: '1rem',
                    },
                },
            },
        },
        MuiCheckbox: {
            defaultProps: {
                disableFocusRipple: true,
                disableTouchRipple: true,
                disableRipple: true,
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createElement(CheckboxBaseIcon),
                checkedIcon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createElement(CheckboxCheckedIcon),
                indeterminateIcon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createElement(CheckboxIndeterminateIcon),
                color: 'default',
            },
            styleOverrides: {
                root: {
                    color: palette.common.green,
                    '& .MuiSvgIcon-root': {
                        color: palette.common.white,
                    },
                    '&:not(.MuiCheckbox-indeterminate) .MuiSvgIcon-root': {
                        stroke: palette.grey[400],
                    },
                    '&:not(.MuiCheckbox-indeterminate).Mui-checked .MuiSvgIcon-root': {
                        color: palette.common.green,
                        stroke: 'none',
                    },
                    '&.MuiCheckbox-indeterminate .MuiSvgIcon-root': {
                        color: palette.common.green,
                        stroke: 'none',
                    },
                    '&.MuiIconButton-root:hover': {
                        background: 'none',
                    },
                    '&:not(.Mui-checked):not(.MuiCheckbox-indeterminate):hover .MuiSvgIcon-root': {
                        stroke: palette.grey[600],
                    },
                    '&:not(.Mui-checked):not(.MuiCheckbox-indeterminate).Mui-hovered .MuiSvgIcon-root': {
                        stroke: palette.grey[600],
                    },
                    '&.MuiCheckbox-indeterminate:hover .MuiSvgIcon-root': {
                        stroke: 'none',
                    },
                    '& .MuiSvgIcon-fontSizeMedium': {
                        width: '1.5rem',
                        height: '1.5rem',
                    },
                    '& .MuiSvgIcon-fontSizeSmall': {
                        width: '1rem',
                        height: '1rem',
                    },
                    '&:not(.Mui-checked):not(.MuiCheckbox-indeterminate) .MuiSvgIcon-fontSizeSmall rect': {
                        strokeWidth: 3.5,
                        rx: 3.5,
                    },
                },
            },
        },
        MuiRadio: {
            defaultProps: {
                disableFocusRipple: true,
                disableTouchRipple: true,
                disableRipple: true,
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createElement(RadioIcon),
                checkedIcon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createElement(RadioCheckedIcon),
                color: 'default',
            },
            styleOverrides: {
                root: {
                    '& .MuiSvgIcon-root': {
                        width: '1rem',
                        height: '1rem',
                        color: palette.common.white,
                        stroke: palette.grey[400],
                    },
                    '&:hover .MuiSvgIcon-root, &.Mui-hovered .MuiSvgIcon-root': {
                        stroke: palette.grey[600],
                    },
                    '&.MuiIconButton-root': {
                        marginRight: spacing * 2,
                    },
                    '&.MuiIconButton-root:hover': {
                        background: 'none',
                    },
                    '&.Mui-checked .MuiSvgIcon-root': {
                        color: palette.primary.main,
                        stroke: 'none',
                    },
                },
            },
        },
        MuiFormControlLabel: {
            styleOverrides: {
                label: {
                    fontWeight: 600,
                    fontSize: '0.875rem',
                    color: palette.grey[800],
                    lineHeight: '1rem',
                },
            },
        },
        MuiTooltip: {
            styleOverrides: {
                tooltip: {
                    color: 'inherit',
                    backgroundColor: palette.common.white,
                    border: `1px solid ${palette.grey[400]}`,
                    borderRadius: '0.5rem',
                    filter: 'drop-shadow(0px 4px 12px rgba(10, 27, 62, 0.11))',
                    padding: 0,
                    fontWeight: 400,
                    lineHeight: '1.25rem',
                    fontSize: '0.75rem',
                    maxWidth: 'unset',
                    '& .MuiTooltip-content': {
                        padding: `${spacing * 5}px ${spacing * 8}px 0`,
                    },
                    '& .MuiTooltip-content::after': {
                        content: `''`,
                        display: 'block',
                        height: `${spacing * 5}px`,
                    },
                },
                tooltipPlacementRight: {
                    ['@media (min-width: 800px)']: {
                        marginLeft: spacing * 2,
                    },
                },
                tooltipPlacementLeft: {
                    ['@media (min-width: 800px)']: {
                        marginRight: spacing * 2,
                    },
                },
                tooltipPlacementBottom: {
                    ['@media (min-width: 800px)']: {
                        marginTop: spacing * 2,
                    },
                },
                tooltipPlacementTop: {
                    ['@media (min-width: 800px)']: {
                        marginBottom: spacing * 2,
                    },
                },
                arrow: {
                    fontSize: '1rem',
                    '&::before': {
                        border: `1px solid ${palette.grey[400]}`,
                        backgroundColor: palette.common.white,
                        fontSize: '1rem',
                    },
                },
            },
        },
        MuiMenu: {
            defaultProps: {
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'right',
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'right',
                },
            },
            styleOverrides: {
                paper: {
                    color: 'inherit',
                    backgroundColor: palette.common.white,
                    border: `1px solid ${palette.grey[400]}`,
                    borderRadius: '0.5rem',
                    filter: 'drop-shadow(0px 4px 12px rgba(10, 27, 62, 0.11))',
                    marginTop: spacing * 2,
                },
                list: {
                    '& .MuiMenuItem-root': {
                        padding: `0.75rem 2.5rem 0.75rem 1.5rem`,
                        display: 'flex',
                        minWidth: '10rem',
                        boxSizing: 'content-box',
                    },
                    '& .MuiListItemIcon-root': {
                        width: '1rem',
                        height: '1rem',
                        fontSize: '1rem',
                        color: palette.grey[500],
                    },
                    '& .MuiListItemIcon-root .MuiSvgIcon-root': {
                        transition: 'color 300ms',
                        fontSize: 'inherit',
                        color: 'inherit',
                    },
                    '& .MuiListItemText-root > span': {
                        lineHeight: '1rem',
                        fontSize: '0.75rem',
                        color: palette.grey[800],
                    },
                    '& .MuiMenuItem-root:hover': {
                        backgroundColor: palette.grey[150],
                    },
                    '& .MuiMenuItem-root:hover .MuiListItemIcon-root': {
                        color: palette.grey[700],
                    },
                    '& .Mui-negative .MuiListItemIcon-root': {
                        color: palette.danger.main,
                    },
                    '& .Mui-negative .MuiListItemText-root > span': {
                        color: palette.danger.main,
                    },
                    '& .Mui-negative.MuiMenuItem-root:hover': {
                        backgroundColor: alpha_1(palette.danger.main, .05),
                    },
                    '& .MuiMenuItem-root.Mui-negative:hover .MuiListItemIcon-root': {
                        color: palette.danger.dark,
                    },
                    '& .MuiMenuItem-root.Mui-negative:hover  .MuiListItemText-root > span': {
                        color: palette.danger.dark,
                    },
                },
            },
        },
        MuiPagination: {
            defaultProps: {
                variant: 'outlined',
            },
            styleOverrides: {
                root: {
                    zIndex: 2,
                    borderTop: `1px solid ${palette.divider}`,
                    paddingLeft: spacing * 8,
                    minHeight: '3.5rem',
                    display: 'flex',
                    alignItems: 'center',
                },
                ul: {
                    '& .MuiPaginationItem-root': {
                        display: 'flex',
                        border: 'none',
                        width: 'auto',
                        padding: '0 0.25rem',
                        minWidth: '1.5rem',
                        height: '1.75rem',
                        color: palette.grey[500],
                        fontWeight: 800,
                        margin: 0,
                        background: 'none',
                        borderRadius: '3px',
                    },
                    '& .MuiPaginationItem-root:active': {
                        background: 'none',
                    },
                    '& .MuiPaginationItem-root:hover, & .MuiPaginationItem-root:focus': {
                        backgroundColor: palette.grey[150],
                    },
                    '& .MuiPaginationItem-root.Mui-selected': {
                        color: palette.grey[700],
                        backgroundColor: palette.grey[150],
                        border: `1px solid ${palette.grey[300]}`,
                    },
                    '& .MuiSvgIcon-root': {
                        width: '1.5rem',
                        height: '0.75rem',
                        color: palette.grey[500],
                    },
                    '& .MuiPaginationItem-root .MuiSvgIcon-root': {
                        width: '1.1rem',
                        height: '1.1rem',
                        marginBottom: '-0.1rem',
                    },
                },
            },
        },
    });
};
var components$1 = components;

function createShadow(px) {
    return `0 0 ${px}px 0 rgba(53,64,82,.05)`;
}
const shadows = [
    'none',
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
    createShadow(14),
];
var shadows$1 = shadows;

const palette = {
    default: {
        main: '#F7F3F3',
        light: '#FBFBFC',
        dark: '#F0F3F8',
        hover: '#F0F3F8',
        active: '#E6ECF4',
        contrastText: '#3C4A5A',
    },
    primary: {
        main: '#43BB7A',
        light: '#A2E1BF',
        dark: '#36A76A',
        hover: '#32A265',
        active: '#278854',
        contrastText: '#FFF',
    },
    secondary: {
        main: '#FBFBFC',
        light: '#FBFBFC',
        dark: '#E6ECF4',
        hover: '#F0F3F8',
        active: '#E6ECF4',
        contrastText: '#3C4A5A',
    },
    danger: {
        main: '#E1583E',
        light: '#C46654',
        dark: '#BB041C',
        hover: '#C53E25',
        active: '#AC2E16',
        contrastText: '#FFF',
    },
    error: {
        main: '#E1583E',
        light: '#FFEEEA',
        dark: '#ae402c',
        border: '1px solid #F1D1CA',
        contrastText: '#FFF',
    },
    info: {
        main: '#5587C0',
        light: '#E2EEF9',
        dark: '#3c6492',
        border: '1px solid #B1CAE7',
        contrastText: '#FFF',
    },
    success: {
        main: '#2CA744',
        light: '#E1F5E2',
        dark: '#1d7c30',
        border: '1px solid #A2E1BF',
        contrastText: '#FFF',
    },
    warning: {
        main: '#A79D7B',
        light: '#F9F4E2',
        dark: '#EAE1C2',
        border: '1px solid #EAE1C2',
        contrastText: '#FFF',
    },
    grey: {
        '100': '#FBFBFC',
        '150': '#F5F6F8',
        '200': '#EFF2F7',
        '300': '#E5EAF3',
        '400': '#D1DBEA',
        '500': '#ADBCD2',
        '600': '#8B9DB8',
        '700': '#717F94',
        '800': '#3C4A5A',
    },
    background: {
        default: '#F5F6F8',
    },
    icon: {
        input: '#ADBCD2',
        action: '#ADBCD2',
    },
    divider: '#E4E9EF',
    loader: '#B5B5B5',
    switchButton: {
        main: '#03A9F4',
        light: '#9AE0FF',
        dark: '#0092D3',
        contrastText: '#FFF',
        hover: '#03A9F4',
        active: '#03A9F4',
    },
    common: {
        cyanBlue: '#E2EEF9',
        white: '#FFF',
        green: '#43BB7A',
        paleLightYellow: '#F9F4E2',
        black: '#000',
    },
    text: {
        primary: '#3C4A5A',
        secondary: '#717F94',
        disabled: '#ADBCD2',
    },
};

const splitModeDefaults = {
    darkTheme: {
        dividerStyle: {
            color: '#FFFFFF',
            opacity: 0.4,
        },
        titleDescription: {
            titleDescriptionDescriptionStyle: {
                color: '#FFFFFF',
            },
            titleDescriptionTitleStyle: {
                color: '#FFFFFF',
            },
        },
        testimonials: {
            testimonialsTextStyle: {
                color: '#FFFFFF',
                fontStyle: 'italic',
            },
            testimonialsTitleStyle: {
                color: '#FFFFFF',
            },
            testtomonialsSubtitleStyle: {
                color: '#FFFFFF',
            },
            testimonialsActiveIndicatorStyle: {
                color: '#FFFFFF',
            },
        },
        values: {
            valuesTextStyle: {
                color: '#FFFFFF',
            },
        },
    },
    vividTheme: {
        dividerStyle: {
            color: '#FFFFFF',
            opacity: 0.4,
        },
        titleDescription: {
            titleDescriptionDescriptionStyle: {
                color: '#FFFFFF',
            },
            titleDescriptionTitleStyle: {
                color: '#FFFFFF',
            },
        },
        testimonials: {
            testimonialsTextStyle: {
                color: '#FFFFFF',
                fontStyle: 'italic',
            },
            testimonialsTitleStyle: {
                color: '#FFFFFF',
            },
            testtomonialsSubtitleStyle: {
                color: '#FFFFFF',
            },
            testimonialsActiveIndicatorStyle: {
                color: '#FFFFFF',
            },
        },
        values: {
            valuesTextStyle: {
                color: '#FFFFFF',
            },
        },
    },
    modernTheme: {
        dividerStyle: {
            color: '#000000',
            opacity: 0.2,
        },
        titleDescription: {
            titleDescriptionDescriptionStyle: {
                color: '#2A2C3A',
            },
            titleDescriptionTitleStyle: {
                color: '#2A2C3A',
            },
        },
        testimonials: {
            testimonialsTextStyle: {
                color: '#2A2C3A',
                fontStyle: 'italic',
            },
            testimonialsTitleStyle: {
                color: '#1E1F2B',
            },
            testtomonialsSubtitleStyle: {
                color: '#1E1F2B',
            },
        },
        values: {
            valuesTextStyle: {
                color: '#2A2C3A',
            },
        },
    },
    classicTheme: {
        dividerStyle: {
            color: '#000000',
            opacity: 0.4,
        },
        titleDescription: {
            titleDescriptionDescriptionStyle: {
                color: '#2A2C3A',
            },
            titleDescriptionTitleStyle: {
                color: '#2A2C3A',
            },
        },
        testimonials: {
            testimonialsTextStyle: {
                color: '#2A2C3A',
                fontStyle: 'italic',
            },
            testimonialsTitleStyle: {
                color: '#1E1F2B',
            },
            testtomonialsSubtitleStyle: {
                color: '#1E1F2B',
            },
        },
        values: {
            valuesTextStyle: {
                color: '#2A2C3A',
            },
        },
    },
};

const darkTheme = {
    loginBox: {
        poweredByPlacement: 'page',
        palette: {
            primary: {
                main: '#4BA976',
                dark: '#3E9D6A',
                light: '#98CDB0',
                hover: '#3E9D6A',
                active: '#2a7a4f',
                contrastText: '#FFF',
            },
            error: {
                main: '#DE6161',
                dark: '#C75151',
                light: '#EFB8B8',
            },
        },
        typography: {
            label: {
                color: '#fff',
            },
        },
        logo: {
            placement: 'page',
        },
        rootStyle: {
            backgroundImage: `url('https://ik.imagekit.io/themeoptionsimgs/DarkBackground.jpg?updatedAt=1636822153071')`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
        },
        pageStyle: {
            color: '#fff',
        },
        boxStyle: {
            flex: 1,
            marginTop: '2rem',
            backgroundColor: 'transparent',
            boxShadow: 'initial',
            maxWidth: '90%',
            width: '465px',
            color: '#fff',
        },
        boxHeader: null,
        boxMessageStyle: {
            color: '#fafafa',
        },
        socialLogins: {
            socialLoginsLayout: {
                mode: 'eventually',
                stackedButtonsStyle: {
                    hover: {
                        backgroundColor: 'rgba(255, 255, 255, 0.08)',
                        border: 'none',
                    },
                    focus: {
                        backgroundColor: 'rgba(255, 255, 255, 0.08)',
                        border: 'none',
                    },
                    active: {
                        backgroundColor: 'rgba(255, 255, 255, 0.08)',
                        border: 'none',
                    },
                },
            },
            dividerStyle: {
                color: 'rgba(255, 255, 255, 0.4);',
            },
            dividerTextStyle: {
                color: 'rgba(255, 255, 255, 0.4);',
                fontSize: '0.625rem',
                textTransform: 'uppercase',
            },
            buttonStyle: {
                base: {
                    color: 'rgba(255, 255, 255, 0.7)',
                    backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    border: '1px solid rgba(255, 255, 255, 0.32)',
                },
                icon: {
                    color: 'rgba(255, 255, 255, 0.8)',
                    fill: 'rgba(255, 255, 255, 0.8)',
                },
                hover: {
                    backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    border: '1px solid rgba(255, 255, 255, 1)',
                },
                focus: {
                    backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    border: '1px solid rgba(255, 255, 255, 1)',
                },
                active: {
                    backgroundColor: 'rgba(255, 255, 255, 0.15)',
                    border: '1px solid rgba(255, 255, 255, 1)',
                },
            },
        },
        inputTheme: {
            base: {
                color: '#fff',
                lineHeight: '1.75rem',
                backgroundColor: 'rgba(255, 255, 255, 0.08)',
                border: '1px solid rgba(255, 255, 255, 0.32)',
                placeholderColor: 'rgba(255, 255, 255, 0.56)',
                borderRadius: '8px',
            },
            hover: {
                outlineColor: '#fff',
            },
            focus: {
                outlineColor: '#fff',
            },
            disabled: {
                outlineColor: 'transparent',
                background: 'rgba(255, 255, 255, 0.08)',
            },
        },
        resetPassword: {
            components: {
                MuiChip: {
                    styleOverrides: {
                        colorDefault: {
                            color: 'rgba(255, 255, 255, 0.8)',
                            backgroundColor: 'rgba(255, 255, 255, 0.24)',
                        },
                    },
                },
            },
        },
        activateAccount: {
            components: {
                MuiChip: {
                    styleOverrides: {
                        colorDefault: {
                            color: 'rgba(255, 255, 255, 0.8)',
                            backgroundColor: 'rgba(255, 255, 255, 0.24)',
                        },
                    },
                },
            },
        },
        login: {
            containerStyle: {
                color: '#fff',
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
            },
            layout: {
                splitModeStyles: Object.assign({}, splitModeDefaults.darkTheme),
            },
        },
        signup: {
            layout: {
                splitModeStyles: Object.assign({}, splitModeDefaults.darkTheme),
            },
        },
    },
};

const darkThemeV2 = {
    loginBox: {
        palette: {
            primary: {
                main: '#4BA976',
                dark: '#3E9D6A',
                light: '#98CDB0',
                hover: '#3E9D6A',
                active: '#2a7a4f',
                contrastText: '#FFF',
            },
            error: {
                main: '#DE6161',
                dark: '#C75151',
                light: '#EFB8B8',
            },
        },
        typography: {
            label: {
                color: '#fff',
            },
        },
        rootStyle: {
            backgroundImage: `url('https://ik.imagekit.io/themeoptionsimgs/DarkBackground.jpg?updatedAt=1636822153071')`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
        },
        pageStyle: {
            color: '#fff',
        },
        boxHeader: null,
        boxMessageStyle: {
            color: '#ffffff',
        },
        socialLogins: {
            socialLoginsLayout: {
                placement: 'top',
                mode: 'stack',
                stackedButtonsStyle: {
                    hover: {
                        backgroundColor: 'rgba(255, 255, 255, 0.08)',
                        border: 'none',
                    },
                    focus: {
                        backgroundColor: 'rgba(255, 255, 255, 0.08)',
                        border: 'none',
                    },
                    active: {
                        backgroundColor: 'rgba(255, 255, 255, 0.08)',
                        border: 'none',
                    },
                },
            },
            dividerStyle: {
                color: 'rgba(255, 255, 255, 0.4);',
            },
            dividerTextStyle: {
                color: 'rgba(255, 255, 255, 0.4);',
                fontSize: '0.75rem',
                fontWeight: 600,
            },
            buttonStyle: {
                base: {
                    color: 'rgba(255, 255, 255, 0.7)',
                    backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    border: '1px solid rgba(255, 255, 255, 0.32)',
                },
                icon: {
                    color: 'rgba(255, 255, 255, 0.8)',
                    fill: 'rgba(255, 255, 255, 0.8)',
                },
                hover: {
                    backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    border: '1px solid rgba(255, 255, 255, 1)',
                },
                focus: {
                    backgroundColor: 'rgba(255, 255, 255, 0.08)',
                    border: '1px solid rgba(255, 255, 255, 1)',
                },
                active: {
                    backgroundColor: 'rgba(255, 255, 255, 0.15)',
                    border: '1px solid rgba(255, 255, 255, 1)',
                },
            },
        },
        inputTheme: {
            base: {
                color: '#fff',
                lineHeight: '1.75rem',
                backgroundColor: 'rgba(255, 255, 255, 0.08)',
                border: '1px solid rgba(255, 255, 255, 0.32)',
                placeholderColor: 'rgba(255, 255, 255, 0.56)',
                borderRadius: '8px',
            },
            hover: {
                outlineColor: '#fff',
            },
            focus: {
                outlineColor: '#fff',
            },
            disabled: {
                outlineColor: 'transparent',
                background: 'rgba(255, 255, 255, 0.08)',
            },
        },
        resetPassword: {
            components: {
                MuiChip: {
                    styleOverrides: {
                        colorDefault: {
                            color: 'rgba(255, 255, 255, 0.8)',
                            backgroundColor: 'rgba(255, 255, 255, 0.24)',
                        },
                    },
                },
            },
        },
        activateAccount: {
            components: {
                MuiChip: {
                    styleOverrides: {
                        colorDefault: {
                            color: 'rgba(255, 255, 255, 0.8)',
                            backgroundColor: 'rgba(255, 255, 255, 0.24)',
                        },
                    },
                },
            },
        },
        logo: {
            placement: 'page',
            style: {
                [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                    position: 'absolute',
                    top: '1rem',
                    left: '1.5rem',
                },
                width: 'fit-content',
                margin: 0
            }
        },
        poweredByPlacement: 'leftBottomCorner',
        boxStyle: {
            backgroundColor: '#292B2B',
            boxShadow: '0px 0px 109px rgba(0, 0, 0, 0.68)',
            color: '#fff',
            maxWidth: '90%',
        },
        login: {
            pageStyle: {
                rowGap: '2rem',
            },
            pageTitleStyle: {
                color: '#FFFFFF'
            },
            pageSubtitleStyle: {
                color: '#F5F7FF'
            },
            carouselArrowsContainerStyle: {
                borderRadius: '8px',
                backgroundColor: 'rgba(255, 255, 255, 0.08)',
                border: '2px solid rgba(255, 255, 255, 0.32)',
            },
            carouselArrowsStyle: {
                color: '#FFFFFF'
            },
            carouselIndicatorStyle: {
                border: '1px solid rgba(255, 255, 255, 0.32)',
                background: 'rgba(255, 255, 255, 0.08)',
                borderRadius: '2px',
            },
            carouselActiveIndicatorStyle: {
                borderRadius: '2px',
            },
            containerStyle: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                color: '#fff',
                flexDirection: 'column',
                rowGap: '2.5rem',
            },
            boxTitleStyle: {
                marginBottom: '0.5rem',
            },
            boxMessageStyle: {
                fontSize: '0.875rem',
                marginBottom: '2.5rem',
            },
            layout: {
                splitModeStyles: Object.assign({}, splitModeDefaults.darkTheme),
            },
            signupMessagePlacement: 'page',
            signupMessageStyle: {
                [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                    position: 'absolute',
                    top: '1rem',
                    right: '1.5rem',
                },
                color: '#FFFFFF',
                a: {
                    fontWeight: 'bold',
                    color: '#4BA976',
                    marginLeft: '0.25rem',
                },
            },
            disclaimer: {
                placement: 'page',
                textStyle: {
                    color: '#FFFFFF',
                    [`@media screen and (max-width: ${breakpoints$1.values.sm}px)`]: {
                        marginTop: 0,
                    }
                },
                terms: {},
                privacy: {},
                disclaimerContainerStyle: {
                    [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                        position: 'absolute',
                        bottom: '1.5rem',
                        right: '1.5rem',
                    }
                }
            }
        },
        signup: {
            pageStyle: {
                rowGap: '2rem',
            },
            loginMessagePlacement: 'page',
            loginMessageStyle: {
                [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                    position: 'absolute',
                    top: '1rem',
                    right: '1.5rem',
                },
                color: '#FFFFFF',
                a: {
                    fontWeight: 'bold',
                    color: '#4BA976',
                    marginLeft: '0.25rem',
                },
            },
            disclaimer: {
                hasCheckbox: false,
                textStyle: {
                    [`@media screen and (max-width: ${breakpoints$1.values.sm}px)`]: {
                        marginTop: 0,
                    },
                    color: '#FFFFFF',
                },
                terms: {},
                privacy: {},
                disclaimerContainerStyle: {
                    [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                        position: 'absolute',
                        bottom: '1.5rem',
                        right: '1.5rem',
                    }
                }
            },
            layout: {
                splitModeStyles: Object.assign({}, splitModeDefaults.darkTheme),
            },
        },
    },
};

const vividTheme = {
    loginBox: {
        palette: {
            primary: {
                main: '#3956FB',
                dark: '#2B48ED',
                light: '#8092FC',
                hover: '#2B48ED',
                active: '#1e39d6',
                contrastText: '#FFF',
            },
            error: {
                main: '#DE6161',
                dark: '#C75151',
                light: '#EFB8B8',
            },
        },
        rootStyle: {
            backgroundImage: `url('https://ik.imagekit.io/themeoptionsimgs/VividBackground.jpg?updatedAt=1636822173041')`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
        },
        boxStyle: {
            maxWidth: '90%',
            width: '465px',
            boxShadow: 'initial',
            backgroundColor: 'rgba(255, 255, 255, 0.95)',
            borderRadius: '0.5rem',
        },
        socialLogins: {
            socialLoginsLayout: {
                mode: 'eventually',
                stackedButtonsStyle: {
                    hover: {
                        backgroundColor: '#FFFFFF',
                        border: 'none',
                    },
                    focus: {
                        backgroundColor: '#FFFFFF',
                        border: 'none',
                    },
                    active: {
                        backgroundColor: '#FFFFFF',
                        border: 'none',
                    },
                },
            },
            dividerTextStyle: {
                fontSize: '0.625rem',
                textTransform: 'uppercase',
            },
            iconsOnly: true,
            buttonStyle: {
                base: {
                    flex: 'initial',
                    borderRadius: '0.25rem',
                    backgroundColor: '#FFF',
                    border: '1px solid #ECEDF8',
                    minWidth: 0,
                    height: '40px',
                    width: '40px',
                    boxShadow: 'none',
                },
                hover: {
                    backgroundColor: '#FFF',
                    border: '1px solid #3956FB',
                },
                focus: {
                    backgroundColor: '#FFF',
                    border: '1px solid #3956FB',
                },
                active: {
                    backgroundColor: '#FFF',
                    border: '1px solid #2B48ED',
                },
            },
        },
        submitButtonTheme: {
            base: {
                height: '48px',
            },
        },
        inputTheme: {
            base: {
                background: 'transparent',
                lineHeight: '1.875rem',
                color: '#9FA3BC',
            },
        },
        login: {
            containerStyle: {
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
            },
            layout: {
                splitModeStyles: Object.assign({}, splitModeDefaults.vividTheme),
            },
        },
        signup: {
            layout: {
                splitModeStyles: Object.assign({}, splitModeDefaults.vividTheme),
            },
        },
    },
};

const vividThemeV2 = {
    loginBox: {
        palette: {
            primary: {
                main: '#3956FB',
                dark: '#2B48ED',
                light: '#8092FC',
                hover: '#2B48ED',
                active: '#1e39d6',
                contrastText: '#FFF',
            },
            error: {
                main: '#DE6161',
                dark: '#C75151',
                light: '#EFB8B8',
            },
        },
        rootStyle: {
            backgroundImage: `url('https://ik.imagekit.io/themeoptionsimgs/VividBackground.jpg?updatedAt=1636822173041')`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
        },
        socialLogins: {
            socialLoginsLayout: {
                placement: 'top',
                mode: 'stack',
                stackedButtonsStyle: {
                    hover: {
                        backgroundColor: '#FFFFFF',
                        border: 'none',
                    },
                    focus: {
                        backgroundColor: '#FFFFFF',
                        border: 'none',
                    },
                    active: {
                        backgroundColor: '#FFFFFF',
                        border: 'none',
                    },
                },
            },
            dividerTextStyle: {
                fontSize: '0.75rem',
                fontWeight: 600,
            },
            iconsOnly: true,
            buttonStyle: {
                base: {
                    flex: 'initial',
                    borderRadius: '0.25rem',
                    backgroundColor: '#FFF',
                    border: '1px solid #ECEDF8',
                    minWidth: 0,
                    height: '40px',
                    width: '40px',
                    boxShadow: 'none',
                },
                hover: {
                    backgroundColor: '#FFF',
                    border: '1px solid #3956FB',
                },
                focus: {
                    backgroundColor: '#FFF',
                    border: '1px solid #3956FB',
                },
                active: {
                    backgroundColor: '#FFF',
                    border: '1px solid #2B48ED',
                },
            },
        },
        submitButtonTheme: {
            base: {
                height: '48px',
            },
        },
        inputTheme: {
            base: {
                background: 'transparent',
                lineHeight: '1.875rem',
                color: '#9FA3BC',
            },
        },
        logo: {
            placement: 'page',
            style: {
                [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                    position: 'absolute',
                    top: '1rem',
                    left: '1.5rem',
                },
                width: 'fit-content',
                margin: 0
            }
        },
        poweredByPlacement: 'leftBottomCorner',
        poweredByColor: 'white',
        boxStyle: {
            boxShadow: '0px 4px 24px rgba(157, 168, 189, 0.37)',
            backgroundColor: '#FFFFFF',
            maxWidth: '90%',
            borderRadius: '0.5rem',
        },
        login: {
            pageStyle: {
                rowGap: '2rem',
            },
            pageTitleStyle: {
                color: '#FFFFFF'
            },
            pageSubtitleStyle: {
                color: '#FFFFFF'
            },
            carouselArrowsContainerStyle: {
                borderRadius: '50%',
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                border: '2px solid #3956FB',
            },
            carouselArrowsStyle: {
                color: '#3956FB'
            },
            carouselIndicatorStyle: {
                background: '#ECEDF8',
                borderRadius: '50%',
            },
            containerStyle: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                flexDirection: 'column',
                rowGap: '2.5rem',
            },
            boxTitleStyle: {
                marginBottom: '0.5rem',
            },
            boxMessageStyle: {
                fontSize: '0.875rem',
                marginBottom: '2.5rem',
            },
            layout: {
                splitModeStyles: Object.assign({}, splitModeDefaults.vividTheme),
            },
            signupMessagePlacement: 'page',
            signupMessageStyle: {
                [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                    position: 'absolute',
                    top: '1rem',
                    right: '1.5rem',
                },
                color: '#FFFFFF',
                fontWeight: 'bold',
                a: {
                    fontWeight: 'bold',
                    color: '#FFFFFF',
                    marginLeft: '0.25rem',
                },
            },
            disclaimer: {
                placement: 'page',
                textStyle: {
                    [`@media screen and (max-width: ${breakpoints$1.values.sm}px)`]: {
                        marginTop: 0,
                    },
                    color: '#FFFFFF'
                },
                terms: {
                    linkStyle: {
                        color: '#FFFFFF',
                        fontWeight: 'bold',
                    }
                },
                privacy: {
                    linkStyle: {
                        color: '#FFFFFF',
                        fontWeight: 'bold',
                    }
                },
                disclaimerContainerStyle: {
                    [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                        position: 'absolute',
                        bottom: '1.5rem',
                        right: '1.5rem',
                    }
                }
            }
        },
        signup: {
            pageStyle: {
                rowGap: '2rem',
            },
            loginMessagePlacement: 'page',
            loginMessageStyle: {
                [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                    position: 'absolute',
                    top: '1rem',
                    right: '1.5rem',
                },
                color: '#FFFFFF',
                a: {
                    fontWeight: 'bold',
                    color: '#FFFFFF',
                    marginLeft: '0.25rem',
                },
            },
            disclaimer: {
                hasCheckbox: false,
                textStyle: {
                    [`@media screen and (max-width: ${breakpoints$1.values.sm}px)`]: {
                        marginTop: 0,
                    },
                    color: '#FFFFFF'
                },
                terms: {
                    linkStyle: {
                        color: '#FFFFFF',
                        fontWeight: 'bold',
                    }
                },
                privacy: {
                    linkStyle: {
                        color: '#FFFFFF',
                        fontWeight: 'bold',
                    }
                },
                disclaimerContainerStyle: {
                    [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                        position: 'absolute',
                        bottom: '1.5rem',
                        right: '1.5rem',
                    }
                }
            },
            layout: {
                splitModeStyles: Object.assign({}, splitModeDefaults.vividTheme),
            },
        },
    },
};

const modernTheme = {
    loginBox: {
        palette: {
            primary: {
                main: '#7075E8',
                dark: '#6267E2',
                light: '#ADAFEE',
                hover: '#6267E2',
                active: '#5257cb',
                contrastText: '#FFF',
            },
            error: {
                main: '#DE6161',
                dark: '#C75151',
                light: '#EFB8B8',
            },
        },
        rootStyle: {
            backgroundImage: `url('https://ik.imagekit.io/themeoptionsimgs/ModernBackground.jpg?updatedAt=1636822163526')`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
        },
        boxStyle: {
            backgroundColor: 'transparent',
            boxShadow: 'initial',
            maxWidth: '90%',
            width: '465px',
        },
        socialLogins: {
            socialLoginsLayout: {
                mode: 'eventually',
                stackedButtonsStyle: {
                    hover: {
                        backgroundColor: '#FFFFFF',
                    },
                    focus: {
                        backgroundColor: '#FFFFFF',
                    },
                    active: {
                        backgroundColor: '#FFFFFF',
                    },
                },
            },
            dividerTextStyle: {
                fontSize: '0.625rem',
                textTransform: 'uppercase',
            },
            buttonStyle: {
                base: {
                    backgroundColor: '#FFFFFF',
                    boxShadow: '0px 4px 8px rgba(171, 175, 201, 0.24)',
                    borderRadius: '8px',
                    border: 'none',
                },
                hover: {
                    backgroundColor: '#F1F1F1',
                },
                focus: {
                    backgroundColor: '#F1F1F1',
                },
                active: {
                    backgroundColor: '#e8e8e8',
                },
            },
        },
        inputTheme: {
            base: {
                background: '#EFF0F8',
                borderColor: '#EFF0F8',
                borderRadius: '4px',
                lineHeight: '1.875rem',
            },
        },
        buttonTheme: {
            base: {
                borderRadius: '4px',
            },
        },
        submitButtonTheme: {
            base: {
                borderRadius: '4px',
                height: '48px',
                boxShadow: '0px 8px 24px rgba(112, 117, 232, 0.24)',
            },
        },
        login: {
            containerStyle: {
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
            },
            layout: {
                splitModeStyles: Object.assign({}, splitModeDefaults.modernTheme),
            },
        },
        signup: {
            layout: {
                splitModeStyles: Object.assign({}, splitModeDefaults.modernTheme),
            },
        },
    },
};

const modernThemeV2 = {
    loginBox: {
        palette: {
            primary: {
                main: '#7075E8',
                dark: '#6267E2',
                light: '#ADAFEE',
                hover: '#6267E2',
                active: '#5257cb',
                contrastText: '#FFF',
            },
            error: {
                main: '#DE6161',
                dark: '#C75151',
                light: '#EFB8B8',
            },
        },
        rootStyle: {
            backgroundImage: `url('https://ik.imagekit.io/themeoptionsimgs/ModernBackground.jpg?updatedAt=1636822163526')`,
            backgroundSize: 'cover',
            backgroundRepeat: 'no-repeat',
            backgroundPosition: 'center',
        },
        socialLogins: {
            socialLoginsLayout: {
                placement: 'top',
                mode: 'stack',
                mainButtonStyle: {
                    base: {
                        boxShadow: 'none',
                        border: '1px solid #D2D4E3'
                    }
                },
                stackedButtonsStyle: {
                    hover: {
                        backgroundColor: '#F1F1F1',
                    },
                    focus: {
                        backgroundColor: '#F1F1F1',
                    },
                    active: {
                        backgroundColor: '#F1F1F1',
                    },
                },
            },
            dividerTextStyle: {
                fontSize: '0.75rem',
                fontWeight: 600,
            },
            buttonStyle: {
                base: {
                    backgroundColor: '#FFFFFF',
                    borderRadius: '8px',
                    boxShadow: 'none',
                    border: '1px solid #D2D4E3'
                },
                hover: {
                    backgroundColor: '#F1F1F1',
                },
                focus: {
                    backgroundColor: '#F1F1F1',
                },
                active: {
                    backgroundColor: '#e8e8e8',
                },
            },
        },
        inputTheme: {
            base: {
                background: '#EFF0F8',
                borderColor: '#EFF0F8',
                borderRadius: '4px',
                lineHeight: '1.875rem',
            },
        },
        buttonTheme: {
            base: {
                borderRadius: '4px',
            },
        },
        submitButtonTheme: {
            base: {
                borderRadius: '4px',
                height: '48px',
                boxShadow: '0px 8px 24px rgba(112, 117, 232, 0.24)',
            },
        },
        logo: {
            placement: 'page',
            style: {
                [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                    position: 'absolute',
                    top: '1rem',
                    left: '1.5rem',
                },
                width: 'fit-content',
                margin: 0
            }
        },
        poweredByPlacement: 'leftBottomCorner',
        boxTitleStyle: {
            marginBottom: '0.5rem',
        },
        login: {
            pageStyle: {
                rowGap: '2rem',
            },
            layout: {
                splitModeStyles: Object.assign({}, splitModeDefaults.modernTheme),
            },
            boxMessageStyle: {
                fontSize: '0.875rem',
                marginBottom: '2.5rem',
            },
            boxStyle: {
                maxWidth: '90%',
                backgroundColor: '#FFFFFF',
                boxShadow: '0px 4px 34px rgba(157, 168, 189, 0.37)',
            },
            signupMessagePlacement: 'page',
            signupMessageStyle: {
                [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                    position: 'absolute',
                    top: '1rem',
                    right: '1.5rem',
                },
                a: {
                    fontWeight: 'bold',
                    color: '#7075E8',
                    marginLeft: '0.25rem',
                },
            },
            containerStyle: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                flexDirection: 'column',
                rowGap: '2.5rem',
            },
            disclaimer: {
                placement: 'page',
                textStyle: {
                    [`@media screen and (max-width: ${breakpoints$1.values.sm}px)`]: {
                        marginTop: 0,
                    }
                },
                terms: {},
                privacy: {},
                disclaimerContainerStyle: {
                    [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                        position: 'absolute',
                        bottom: '1.5rem',
                        right: '1.5rem',
                    }
                }
            }
        },
        signup: {
            pageStyle: {
                rowGap: '2rem',
            },
            loginMessagePlacement: 'page',
            loginMessageStyle: {
                [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                    position: 'absolute',
                    top: '1rem',
                    right: '1.5rem',
                },
                a: {
                    fontWeight: 'bold',
                    color: '#4D7DFA',
                    marginLeft: '0.25rem',
                },
            },
            disclaimer: {
                hasCheckbox: false,
                textStyle: {
                    [`@media screen and (max-width: ${breakpoints$1.values.sm}px)`]: {
                        marginTop: 0,
                    }
                },
                terms: {},
                privacy: {},
                disclaimerContainerStyle: {
                    [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                        position: 'absolute',
                        bottom: '1.5rem',
                        right: '1.5rem',
                    }
                }
            },
            layout: {
                splitModeStyles: Object.assign({}, splitModeDefaults.modernTheme),
            },
        },
    },
};

const classicTheme = {
    loginBox: {
        palette: {
            primary: {
                main: '#4D7DFA',
                dark: '#3A6AE5',
                light: '#AAC1FC',
                hover: '#3A6AE5',
                active: '#2758d6',
                contrastText: '#FFF',
            },
            error: {
                main: '#DE6161',
                dark: '#C75151',
                light: '#EFB8B8',
            },
        },
        rootStyle: {
            backgroundColor: '#F9FAFC',
        },
        boxStyle: {
            backgroundColor: '#FFFFFF',
            boxShadow: '0px 4px 24px rgba(157, 168, 189, 0.17)',
            borderRadius: '24px',
            maxWidth: '90%',
            width: '465px',
        },
        socialLogins: {
            socialLoginsLayout: {
                mode: 'eventually',
                stackedButtonsStyle: {
                    hover: {
                        background: '#F3F5F9',
                        border: 'none',
                    },
                    focus: {
                        background: '#F3F5F9',
                        border: 'none',
                    },
                    active: {
                        background: '#F3F5F9',
                        border: 'none',
                    },
                },
            },
            dividerTextStyle: {
                fontSize: '0.625rem',
                textTransform: 'uppercase',
            },
            buttonStyle: {
                base: {
                    borderRadius: '0.5rem',
                    borderColor: 'transparent',
                    boxShadow: 'none',
                    background: '#F3F5F9',
                },
                hover: {
                    background: '#E9ECF3',
                },
                focus: {
                    background: '#E9ECF3',
                },
                active: {
                    background: '#dddfe5',
                },
            },
        },
        inputTheme: {
            base: {
                lineHeight: '1.75em',
            },
        },
        login: {
            containerStyle: {
                display: 'flex',
                flexDirection: 'column',
                width: '100%',
                alignItems: 'center',
                justifyContent: 'center',
            },
            layout: {
                splitModeStyles: Object.assign({}, splitModeDefaults.classicTheme),
            },
        },
        signup: {
            layout: {
                splitModeStyles: Object.assign({}, splitModeDefaults.classicTheme),
            },
        },
    },
};

const classicThemeV2 = {
    loginBox: {
        palette: {
            primary: {
                main: '#4D7DFA',
                dark: '#3A6AE5',
                light: '#AAC1FC',
                hover: '#3A6AE5',
                active: '#2758d6',
                contrastText: '#FFF',
            },
            error: {
                main: '#DE6161',
                dark: '#C75151',
                light: '#EFB8B8',
            },
        },
        rootStyle: {
            backgroundColor: '#F9FAFC',
        },
        boxStyle: {
            backgroundColor: '#FFFFFF',
            boxShadow: '0px 4px 24px rgba(157, 168, 189, 0.17)',
            borderRadius: '24px',
            maxWidth: '90%',
        },
        socialLogins: {
            socialLoginsLayout: {
                placement: 'top',
                mode: 'stack',
                stackedButtonsStyle: {
                    hover: {
                        background: '#F3F5F9',
                        border: 'none',
                    },
                    focus: {
                        background: '#F3F5F9',
                        border: 'none',
                    },
                    active: {
                        background: '#F3F5F9',
                        border: 'none',
                    },
                },
            },
            dividerTextStyle: {
                fontSize: '0.75rem',
                fontWeight: 600,
            },
            buttonStyle: {
                base: {
                    borderRadius: '0.5rem',
                    borderColor: 'transparent',
                    boxShadow: 'none',
                    background: '#F3F5F9',
                },
                hover: {
                    background: '#E9ECF3',
                },
                focus: {
                    background: '#E9ECF3',
                },
                active: {
                    background: '#dddfe5',
                },
            },
        },
        inputTheme: {
            base: {
                lineHeight: '1.75em',
            },
        },
        logo: {
            placement: 'page',
            style: {
                [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                    position: 'absolute',
                    top: '1rem',
                    left: '1.5rem',
                },
                width: 'fit-content',
                margin: 0
            }
        },
        poweredByPlacement: 'leftBottomCorner',
        login: {
            pageStyle: {
                rowGap: '2rem',
            },
            carouselArrowsContainerStyle: {
                borderRadius: '50%',
                backgroundColor: '#F3F5F9'
            },
            carouselArrowsStyle: {
                color: '#a19f9e'
            },
            carouselIndicatorStyle: {
                background: '#E1E3EF',
                borderRadius: '50%',
            },
            boxTitleStyle: {
                marginBottom: '0.5rem',
            },
            boxMessageStyle: {
                fontSize: '0.875rem',
                marginBottom: '2.5rem',
            },
            containerStyle: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                flexDirection: 'column',
                rowGap: '2.5rem',
            },
            layout: {
                splitModeStyles: Object.assign({}, splitModeDefaults.classicTheme),
            },
            signupMessagePlacement: 'page',
            signupMessageStyle: {
                [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                    position: 'absolute',
                    top: '1rem',
                    right: '1.5rem',
                },
                a: {
                    fontWeight: 'bold',
                    color: '#4D7DFA',
                    marginLeft: '0.25rem',
                },
            },
            disclaimer: {
                placement: 'page',
                textStyle: {
                    [`@media screen and (max-width: ${breakpoints$1.values.sm}px)`]: {
                        marginTop: 0,
                    }
                },
                terms: {},
                privacy: {},
                disclaimerContainerStyle: {
                    [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                        position: 'absolute',
                        bottom: '1.5rem',
                        right: '1.5rem',
                    }
                },
            }
        },
        signup: {
            pageStyle: {
                rowGap: '2rem',
            },
            loginMessagePlacement: 'page',
            loginMessageStyle: {
                [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                    position: 'absolute',
                    top: '1rem',
                    right: '1.5rem',
                },
                a: {
                    fontWeight: 'bold',
                    color: '#4D7DFA',
                    marginLeft: '0.25rem',
                },
            },
            disclaimer: {
                hasCheckbox: false,
                textStyle: {
                    [`@media screen and (max-width: ${breakpoints$1.values.sm}px)`]: {
                        marginTop: 0,
                    }
                },
                terms: {},
                privacy: {},
                disclaimerContainerStyle: {
                    [`@media screen and (min-width: ${breakpoints$1.values.sm}px)`]: {
                        position: 'absolute',
                        bottom: '1.5rem',
                        right: '1.5rem',
                    }
                }
            },
            layout: {
                splitModeStyles: Object.assign({}, splitModeDefaults.classicTheme),
            },
        },
    },
};

const themes = {
    classic: classicTheme,
    modern: modernTheme,
    vivid: vividTheme,
    dark: darkTheme,
    modernV2: modernThemeV2,
    darkV2: darkThemeV2,
    classicV2: classicThemeV2,
    vividV2: vividThemeV2,
};
var themes$1 = themes;

const mapPlaceholderTheme = (placeholderColor) => (placeholderColor ? {
    '& input::placeholder': {
        color: placeholderColor,
        opacity: 1,
    },
    '& input:-ms-input-placeholder': {
        color: placeholderColor,
    },
    '& input::-ms-input-placeholder': {
        color: placeholderColor,
    },
} : {});
const mapInputTheme = (theme) => {
    var _a, _b, _c, _d;
    return (theme ? {
        MuiOutlinedInput: {
            styleOverrides: {
                root: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, (((_a = theme.base) === null || _a === void 0 ? void 0 : _a.borderWidth) != null ? {
                    '&:not(.Mui-disabled):hover, &:not(.Mui-disabled):focus, &:not(.Mui-disabled).Mui-focused, &:not(.Mui-disabled).Mui-hovered': {
                        outlineWidth: (_b = theme.base) === null || _b === void 0 ? void 0 : _b.borderWidth,
                        outlineOffset: `-${(_c = theme.base) === null || _c === void 0 ? void 0 : _c.borderWidth}`,
                    },
                } : {})), theme.base), mapPlaceholderTheme((_d = theme.base) === null || _d === void 0 ? void 0 : _d.placeholderColor)), (theme.hover && Object.keys(theme.hover).length > 0 ? { '&:not(.Mui-disabled):hover, &:not(.Mui-disabled).Mui-hovered': theme.hover } : {})), (theme.focus && Object.keys(theme.focus).length > 0 ? { '&:not(.Mui-disabled):focus, &:not(.Mui-disabled).Mui-focused': theme.focus } : {})), (theme.active && Object.keys(theme.active).length > 0 ? { '&:not(.Mui-disabled):active, &:not(.Mui-disabled).Mui-active': theme.active } : {})), (theme.disabled && Object.keys(theme.disabled).length > 0 ? { '&.Mui-disabled': theme.disabled } : {})), (theme.error && Object.keys(theme.error).length > 0 ? { '&.Mui-error': theme.error } : {})),
            },
        },
        MuiTypography: {
            styleOverrides: {
                label: Object.assign({}, theme.label),
            },
        },
    } : {});
};
const mapButtonTheme = (theme) => (theme ? {
    MuiButton: {
        styleOverrides: Object.assign(Object.assign({}, (theme.submitButtonTheme ? {
            'containedPrimary': Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, theme.submitButtonTheme.base), theme.submitButtonTheme.base), { '&:not(.Mui-disabled)': Object.assign({}, theme.submitButtonTheme.base) }), (theme.submitButtonTheme.hover ? { '&:not(.Mui-disabled):hover, &:not(.Mui-disabled).Mui-hovered': theme.submitButtonTheme.hover } : {})), (theme.submitButtonTheme.focus ? { '&:not(.Mui-disabled):focus, &:not(.Mui-disabled).Mui-focused': theme.submitButtonTheme.focus } : {})), (theme.submitButtonTheme.active ? { '&:not(.Mui-disabled):active, &:not(.Mui-disabled).Mui-active': theme.submitButtonTheme.active } : {})), (theme.submitButtonTheme.disabled ? { '&.Mui-disabled': theme.submitButtonTheme.disabled } : {})),
        } : {})), (theme.buttonTheme ? {
            'containedSecondary': Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, theme.buttonTheme.base), { '&:not(.Mui-disabled)': Object.assign({}, theme.buttonTheme.base) }), (theme.buttonTheme.hover ? { '&:not(.Mui-disabled):hover, &:not(.Mui-disabled).Mui-hovered': theme.buttonTheme.hover } : {})), (theme.buttonTheme.focus ? { '&:not(.Mui-disabled):focus, &:not(.Mui-disabled).Mui-focused': theme.buttonTheme.focus } : {})), (theme.buttonTheme.active ? { '&:not(.Mui-disabled):active, &:not(.Mui-disabled).Mui-active': theme.buttonTheme.active } : {})), (theme.buttonTheme.disabled ? { '&.Mui-disabled': theme.buttonTheme.disabled } : {})),
        } : {})),
    },
} : {});
const mapLinkTheme = (theme) => (theme ? {
    MuiLink: {
        styleOverrides: {
            root: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, theme.base), (theme.hover ? { '&:not(.Mui-disabled):hover, &:not(.Mui-disabled).Mui-hovered': theme.hover } : {})), (theme.focus ? { '&:not(.Mui-disabled):focus, &:not(.Mui-disabled).Mui-focused': theme.focus } : {})), (theme.active ? { '&:not(.Mui-disabled):active, &:not(.Mui-disabled).Mui-active': theme.active } : {})), (theme.disabled ? { '&.Mui-disabled': theme.disabled } : {})),
        },
    },
} : {});
const buildThemeOptions = (themeOptions, fronteggAppOptions) => themeOptions ? (Object.assign(Object.assign({}, themeOptions), { rootStyle: Object.assign(Object.assign({ backgroundSize: 'cover', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }, themeOptions.rootStyle), ((fronteggAppOptions === null || fronteggAppOptions === void 0 ? void 0 : fronteggAppOptions.backgroundImage) ? { background: fronteggAppOptions === null || fronteggAppOptions === void 0 ? void 0 : fronteggAppOptions.backgroundImage, backgroundImage: undefined } : {})), components: Object.assign(Object.assign(Object.assign(Object.assign({}, themeOptions.components), mapInputTheme(themeOptions === null || themeOptions === void 0 ? void 0 : themeOptions.inputTheme)), mapButtonTheme(themeOptions)), mapLinkTheme(themeOptions === null || themeOptions === void 0 ? void 0 : themeOptions.linkButtonTheme)) })) : {};
const enhanceTheme = (defaultTheme, metadata, options, fronteggAppOptions) => {
    var _a, _b, _c, _d, _e;
    const loginBoxMetadataTheme = deepmerge$4((_b = (_a = metadata === null || metadata === void 0 ? void 0 : metadata.themeV2) === null || _a === void 0 ? void 0 : _a.loginBox) !== null && _b !== void 0 ? _b : {}, (_c = options === null || options === void 0 ? void 0 : options.loginBox) !== null && _c !== void 0 ? _c : {});
    const selectedTheme = themes$1[(_d = loginBoxMetadataTheme === null || loginBoxMetadataTheme === void 0 ? void 0 : loginBoxMetadataTheme.themeName) !== null && _d !== void 0 ? _d : defaultTheme].loginBox;
    const loginBoxTheme = deepmerge$4(selectedTheme !== null && selectedTheme !== void 0 ? selectedTheme : {}, loginBoxMetadataTheme);
    return Object.assign(Object.assign({}, options), { loginBox: Object.assign(Object.assign({}, buildThemeOptions(loginBoxTheme, fronteggAppOptions)), { logo: (fronteggAppOptions === null || fronteggAppOptions === void 0 ? void 0 : fronteggAppOptions.headerImage) ? Object.assign({ image: fronteggAppOptions.headerImage }, loginBoxTheme.logo) : loginBoxTheme.logo, themeName: (_e = loginBoxTheme === null || loginBoxTheme === void 0 ? void 0 : loginBoxTheme.themeName) !== null && _e !== void 0 ? _e : defaultTheme, acceptInvitation: buildThemeOptions(loginBoxTheme === null || loginBoxTheme === void 0 ? void 0 : loginBoxTheme.acceptInvitation), activateAccount: buildThemeOptions(loginBoxTheme === null || loginBoxTheme === void 0 ? void 0 : loginBoxTheme.activateAccount), forgotPassword: buildThemeOptions(loginBoxTheme === null || loginBoxTheme === void 0 ? void 0 : loginBoxTheme.forgotPassword), resetPassword: buildThemeOptions(loginBoxTheme === null || loginBoxTheme === void 0 ? void 0 : loginBoxTheme.resetPassword), login: buildThemeOptions(loginBoxTheme === null || loginBoxTheme === void 0 ? void 0 : loginBoxTheme.login), signup: buildThemeOptions(loginBoxTheme === null || loginBoxTheme === void 0 ? void 0 : loginBoxTheme.signup) }) });
};
const enhanceAdminBoxTheme = (metadata, themeOptions) => {
    var _a, _b, _c, _d;
    const adminPortalMetadataTheme = deepmerge$4((_b = (_a = metadata === null || metadata === void 0 ? void 0 : metadata.themeV2) === null || _a === void 0 ? void 0 : _a.adminPortal) !== null && _b !== void 0 ? _b : {}, (_c = themeOptions.adminPortal) !== null && _c !== void 0 ? _c : {});
    const newPalette = deepmerge$4(palette, (_d = adminPortalMetadataTheme.palette) !== null && _d !== void 0 ? _d : {});
    return Object.assign(Object.assign({}, themeOptions), { adminPortal: Object.assign(Object.assign(Object.assign({}, adminPortalMetadataTheme), themeOptions.adminPortal), { palette: Object.assign(Object.assign({}, palette), newPalette) }) });
};

const spacing = 4;
const themeOptions = (override) => {
    var _a, _b, _c;
    const palette$1 = deepmerge$4.all([palette, (_a = override === null || override === void 0 ? void 0 : override.palette) !== null && _a !== void 0 ? _a : {}]);
    return {
        spacing: (_b = override === null || override === void 0 ? void 0 : override.spacing) !== null && _b !== void 0 ? _b : spacing,
        palette: palette$1,
        breakpoints: breakpoints$1,
        components: components$1(palette$1, ((_c = override === null || override === void 0 ? void 0 : override.spacing) !== null && _c !== void 0 ? _c : spacing)),
        typography: typography$1(palette$1, override === null || override === void 0 ? void 0 : override.typographyStyleOptions),
        shadows: shadows$1,
        transitions: {
            duration: {
                shortest: 150,
                shorter: 200,
                short: 250,
                standard: 300,
                complex: 375,
                enteringScreen: 225,
                leavingScreen: 195,
            },
        },
        navigation: navigation(palette$1),
        dialog: dialog(palette$1),
        socialLogins: socialLogins(palette$1),
        rightPanel: rightPanel(palette$1),
        authPage: authPage(palette$1),
    };
};

const ThemeContext = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createContext({});

const GlobalThemeProvider = (_a) => {
    var { theme, isShadowDom, themeOptionKey } = _a, props = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["theme", "isShadowDom", "themeOptionKey"]);
    const { rootEl } = useShadowDom();
    const key = `fe-${themeOptionKey !== null && themeOptionKey !== void 0 ? themeOptionKey : 'root'}`;
    const styleRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        let styleElement = rootEl.querySelector(`#${key}`);
        if (!styleElement) {
            styleElement = document.createElement('div');
            styleElement.setAttribute('id', key);
            rootEl.prepend(styleElement);
        }
        return styleElement;
    }, [rootEl, themeOptionKey, key]);
    const emotionCache = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        return createCache$1({ container: styleRef, key });
    }, [styleRef]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        !themeOptionKey && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RootStyle, { theme: theme }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ThemeProvider, { theme: theme },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CacheProvider, { value: emotionCache }, props.children)));
};
const initGlobalTheme = (oldThemeOptions = false) => {
    const _a = useShadowDom(), { injector } = _a, _b = _a.themeOptions, _c = _b === void 0 ? {} : _b, { typographyStyleOptions = undefined, palette = undefined } = _c, customTheme = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_c, ["typographyStyleOptions", "palette"]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        var _a, _b;
        let theme = customTheme;
        let mergedPalette = palette;
        if (oldThemeOptions) {
            const _c = (_b = (_a = _frontegg_types__WEBPACK_IMPORTED_MODULE_3__.Metadata.getInstance(injector.name)) === null || _a === void 0 ? void 0 : _a.theme) !== null && _b !== void 0 ? _b : {}, { palette: metaDataThemePalette } = _c, restMetaDataTheme = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_c, ["palette"]);
            mergedPalette = deepmerge$4.all([metaDataThemePalette !== null && metaDataThemePalette !== void 0 ? metaDataThemePalette : {}, palette !== null && palette !== void 0 ? palette : {}]);
            theme = deepmerge$4.all([restMetaDataTheme !== null && restMetaDataTheme !== void 0 ? restMetaDataTheme : {}, customTheme !== null && customTheme !== void 0 ? customTheme : {}]);
        }
        const overrides = themeOptions({
            typographyStyleOptions,
            palette: mergedPalette,
        });
        return { calculatedTheme: createTheme(overrides, theme), theme, overrides };
    }, [typographyStyleOptions, palette, customTheme]);
};
const InnerThemeProvider = ({ themeOptionKey, children, withFallback }) => {
    const customTheme = useTheme();
    const { theme, overrides } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(ThemeContext);
    const { calculatedTheme, calculatedThemeOptions, calculatedThemeOverrides } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        const themeOptionsByKey = themeOptionKey && getValue$4(customTheme, themeOptionKey);
        if (themeOptionsByKey) {
            const { typographyStyleOptions = {}, palette = {} } = themeOptionsByKey, restTheme = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(themeOptionsByKey, ["typographyStyleOptions", "palette"]);
            const finalThemeObject = deepmerge$4.all([theme, restTheme !== null && restTheme !== void 0 ? restTheme : {}]);
            const finalOverridesObject = deepmerge$4.all([overrides, { palette, typographyStyleOptions }]);
            return {
                calculatedTheme: createTheme(themeOptions(finalOverridesObject), finalThemeObject),
                calculatedThemeOptions: finalThemeObject,
                calculatedThemeOverrides: finalOverridesObject,
            };
        }
        return [];
    }, [customTheme, theme, overrides, themeOptionKey, withFallback]);
    if (calculatedTheme || withFallback) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ThemeProvider, { theme: calculatedTheme || customTheme },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ThemeContext.Provider, { value: { theme: calculatedThemeOptions || theme, overrides: calculatedThemeOverrides || overrides } }, children));
    }
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null, children);
};
const RenderOutsideShadowDom = ({ name, containerStyle, children }) => {
    const [slotElement, setSlotElement] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(null);
    const { slotsContainer } = useShadowDom();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        const slot = document.createElement('div');
        slot.setAttribute('slot', name);
        slotsContainer.appendChild(slot);
        setSlotElement(slot);
        return () => {
            slotsContainer.removeChild(slot);
            setSlotElement(null);
        };
    }, [setSlotElement]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (slotElement && containerStyle) {
            Object.assign(slotElement.style, containerStyle);
        }
    }, [containerStyle]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("slot", { name: name }),
        slotElement && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.h.exports.createPortal(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null, children), slotElement));
};
const RenderAsSlot = (props) => {
    const { iframeRendering } = useShadowDom();
    if (iframeRendering) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null, props.children);
    }
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RenderOutsideShadowDom, Object.assign({}, props));
};

var isArray$2 = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray$2(a)
      , arrB = isArray$2(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var isEqual = reactFastCompare;

var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

var deepmerge$1 = deepmerge_1;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

var freeGlobal$1 = freeGlobal;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal$1 || freeSelf || Function('return this')();

var root$1 = root;

/** Built-in value references. */
var Symbol$1 = root$1.Symbol;

var Symbol$2 = Symbol$1;

/** Used for built-in method references. */
var objectProto$d = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$a = objectProto$d.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString$1 = objectProto$d.toString;

/** Built-in value references. */
var symToStringTag$1 = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty$a.call(value, symToStringTag$1),
      tag = value[symToStringTag$1];

  try {
    value[symToStringTag$1] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString$1.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag$1] = tag;
    } else {
      delete value[symToStringTag$1];
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$c = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto$c.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol$2 ? Symbol$2.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

var getPrototype$1 = getPrototype;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/** `Object#toString` result references. */
var objectTag$3 = '[object Object]';

/** Used for built-in method references. */
var funcProto$2 = Function.prototype,
    objectProto$b = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$2 = funcProto$2.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$9 = objectProto$b.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString$2.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag$3) {
    return false;
  }
  var proto = getPrototype$1(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty$9.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString$2.call(Ctor) == objectCtorString;
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject$1(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag$2 = '[object Function]',
    genTag$1 = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction$1(value) {
  if (!isObject$1(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag$2 || tag == genTag$1 || tag == asyncTag || tag == proxyTag;
}

/** Used to detect overreaching core-js shims. */
var coreJsData = root$1['__core-js_shared__'];

var coreJsData$1 = coreJsData;

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData$1 && coreJsData$1.keys && coreJsData$1.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/** Used for built-in method references. */
var funcProto$1 = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString$1 = funcProto$1.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString$1.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto$a = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty$8 = objectProto$a.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty$8).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject$1(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction$1(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/* Built-in method references that are verified to be native. */
var Map$1 = getNative(root$1, 'Map');

var Map$2 = Map$1;

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

var nativeCreate$1 = nativeCreate;

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate$1 ? nativeCreate$1(null) : {};
  this.size = 0;
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED$1 = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto$9 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$7 = objectProto$9.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate$1) {
    var result = data[key];
    return result === HASH_UNDEFINED$1 ? undefined : result;
  }
  return hasOwnProperty$7.call(data, key) ? data[key] : undefined;
}

/** Used for built-in method references. */
var objectProto$8 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$6 = objectProto$8.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate$1 ? (data[key] !== undefined) : hasOwnProperty$6.call(data, key);
}

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate$1 && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map$2 || ListCache),
    'string': new Hash
  };
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map$2 || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

var defineProperty$1 = defineProperty;

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty$1) {
    defineProperty$1(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

/** Used for built-in method references. */
var objectProto$7 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$5 = objectProto$7.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty$5.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/** `Object#toString` result references. */
var argsTag$2 = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag$2;
}

/** Used for built-in method references. */
var objectProto$6 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$4 = objectProto$6.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable$1 = objectProto$6.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty$4.call(value, 'callee') &&
    !propertyIsEnumerable$1.call(value, 'callee');
};

var isArguments$1 = isArguments;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

var isArray$1 = isArray;

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

/** Detect free variable `exports`. */
var freeExports$2 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$2 = freeExports$2 && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$2 = freeModule$2 && freeModule$2.exports === freeExports$2;

/** Built-in value references. */
var Buffer$1 = moduleExports$2 ? root$1.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer$1 ? Buffer$1.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

var isBuffer$1 = isBuffer;

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER$1 = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER$1 : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/** `Object#toString` result references. */
var argsTag$1 = '[object Arguments]',
    arrayTag$1 = '[object Array]',
    boolTag$2 = '[object Boolean]',
    dateTag$2 = '[object Date]',
    errorTag$1 = '[object Error]',
    funcTag$1 = '[object Function]',
    mapTag$4 = '[object Map]',
    numberTag$2 = '[object Number]',
    objectTag$2 = '[object Object]',
    regexpTag$2 = '[object RegExp]',
    setTag$4 = '[object Set]',
    stringTag$2 = '[object String]',
    weakMapTag$2 = '[object WeakMap]';

var arrayBufferTag$2 = '[object ArrayBuffer]',
    dataViewTag$3 = '[object DataView]',
    float32Tag$2 = '[object Float32Array]',
    float64Tag$2 = '[object Float64Array]',
    int8Tag$2 = '[object Int8Array]',
    int16Tag$2 = '[object Int16Array]',
    int32Tag$2 = '[object Int32Array]',
    uint8Tag$2 = '[object Uint8Array]',
    uint8ClampedTag$2 = '[object Uint8ClampedArray]',
    uint16Tag$2 = '[object Uint16Array]',
    uint32Tag$2 = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag$2] = typedArrayTags[float64Tag$2] =
typedArrayTags[int8Tag$2] = typedArrayTags[int16Tag$2] =
typedArrayTags[int32Tag$2] = typedArrayTags[uint8Tag$2] =
typedArrayTags[uint8ClampedTag$2] = typedArrayTags[uint16Tag$2] =
typedArrayTags[uint32Tag$2] = true;
typedArrayTags[argsTag$1] = typedArrayTags[arrayTag$1] =
typedArrayTags[arrayBufferTag$2] = typedArrayTags[boolTag$2] =
typedArrayTags[dataViewTag$3] = typedArrayTags[dateTag$2] =
typedArrayTags[errorTag$1] = typedArrayTags[funcTag$1] =
typedArrayTags[mapTag$4] = typedArrayTags[numberTag$2] =
typedArrayTags[objectTag$2] = typedArrayTags[regexpTag$2] =
typedArrayTags[setTag$4] = typedArrayTags[stringTag$2] =
typedArrayTags[weakMapTag$2] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

/** Detect free variable `exports`. */
var freeExports$1 = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule$1 = freeExports$1 && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports$1 = freeModule$1 && freeModule$1.exports === freeExports$1;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports$1 && freeGlobal$1.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule$1 && freeModule$1.require && freeModule$1.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

var nodeUtil$1 = nodeUtil;

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil$1 && nodeUtil$1.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

var isTypedArray$1 = isTypedArray;

/** Used for built-in method references. */
var objectProto$5 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$3 = objectProto$5.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray$1(value),
      isArg = !isArr && isArguments$1(value),
      isBuff = !isArr && !isArg && isBuffer$1(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray$1(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty$3.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$4 = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto$4;

  return value === proto;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

var nativeKeys$1 = nativeKeys;

/** Used for built-in method references. */
var objectProto$3 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$2 = objectProto$3.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys$1(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty$2.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction$1(value);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

/** Used for built-in method references. */
var objectProto$2 = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty$1 = objectProto$2.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject$1(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty$1.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root$1.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/** Used for built-in method references. */
var objectProto$1 = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto$1.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols$1 = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols$1 ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols$1(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

var getSymbols$1 = getSymbols;

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols$1(source), object);
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols$1(object));
    object = getPrototype$1(object);
  }
  return result;
};

var getSymbolsIn$1 = getSymbolsIn;

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn$1(source), object);
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray$1(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols$1);
}

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn$1);
}

/* Built-in method references that are verified to be native. */
var DataView = getNative(root$1, 'DataView');

var DataView$1 = DataView;

/* Built-in method references that are verified to be native. */
var Promise$1 = getNative(root$1, 'Promise');

var Promise$2 = Promise$1;

/* Built-in method references that are verified to be native. */
var Set$1 = getNative(root$1, 'Set');

var Set$2 = Set$1;

/* Built-in method references that are verified to be native. */
var WeakMap$1 = getNative(root$1, 'WeakMap');

var WeakMap$2 = WeakMap$1;

/** `Object#toString` result references. */
var mapTag$3 = '[object Map]',
    objectTag$1 = '[object Object]',
    promiseTag = '[object Promise]',
    setTag$3 = '[object Set]',
    weakMapTag$1 = '[object WeakMap]';

var dataViewTag$2 = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView$1),
    mapCtorString = toSource(Map$2),
    promiseCtorString = toSource(Promise$2),
    setCtorString = toSource(Set$2),
    weakMapCtorString = toSource(WeakMap$2);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView$1 && getTag(new DataView$1(new ArrayBuffer(1))) != dataViewTag$2) ||
    (Map$2 && getTag(new Map$2) != mapTag$3) ||
    (Promise$2 && getTag(Promise$2.resolve()) != promiseTag) ||
    (Set$2 && getTag(new Set$2) != setTag$3) ||
    (WeakMap$2 && getTag(new WeakMap$2) != weakMapTag$1)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag$1 ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag$2;
        case mapCtorString: return mapTag$3;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag$3;
        case weakMapCtorString: return weakMapTag$1;
      }
    }
    return result;
  };
}

var getTag$1 = getTag;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/** Built-in value references. */
var Uint8Array = root$1.Uint8Array;

var Uint8Array$1 = Uint8Array;

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array$1(result).set(new Uint8Array$1(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/** Used to convert symbols to primitives and strings. */
var symbolProto$1 = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolValueOf = symbolProto$1 ? symbolProto$1.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/** `Object#toString` result references. */
var boolTag$1 = '[object Boolean]',
    dateTag$1 = '[object Date]',
    mapTag$2 = '[object Map]',
    numberTag$1 = '[object Number]',
    regexpTag$1 = '[object RegExp]',
    setTag$2 = '[object Set]',
    stringTag$1 = '[object String]',
    symbolTag$2 = '[object Symbol]';

var arrayBufferTag$1 = '[object ArrayBuffer]',
    dataViewTag$1 = '[object DataView]',
    float32Tag$1 = '[object Float32Array]',
    float64Tag$1 = '[object Float64Array]',
    int8Tag$1 = '[object Int8Array]',
    int16Tag$1 = '[object Int16Array]',
    int32Tag$1 = '[object Int32Array]',
    uint8Tag$1 = '[object Uint8Array]',
    uint8ClampedTag$1 = '[object Uint8ClampedArray]',
    uint16Tag$1 = '[object Uint16Array]',
    uint32Tag$1 = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag$1:
      return cloneArrayBuffer(object);

    case boolTag$1:
    case dateTag$1:
      return new Ctor(+object);

    case dataViewTag$1:
      return cloneDataView(object, isDeep);

    case float32Tag$1: case float64Tag$1:
    case int8Tag$1: case int16Tag$1: case int32Tag$1:
    case uint8Tag$1: case uint8ClampedTag$1: case uint16Tag$1: case uint32Tag$1:
      return cloneTypedArray(object, isDeep);

    case mapTag$2:
      return new Ctor;

    case numberTag$1:
    case stringTag$1:
      return new Ctor(object);

    case regexpTag$1:
      return cloneRegExp(object);

    case setTag$2:
      return new Ctor;

    case symbolTag$2:
      return cloneSymbol(object);
  }
}

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject$1(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

var baseCreate$1 = baseCreate;

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate$1(getPrototype$1(object))
    : {};
}

/** `Object#toString` result references. */
var mapTag$1 = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag$1(value) == mapTag$1;
}

/* Node.js helper references. */
var nodeIsMap = nodeUtil$1 && nodeUtil$1.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

var isMap$1 = isMap;

/** `Object#toString` result references. */
var setTag$1 = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag$1(value) == setTag$1;
}

/* Node.js helper references. */
var nodeIsSet = nodeUtil$1 && nodeUtil$1.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

var isSet$1 = isSet;

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG$1 = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag$1 = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag$1] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG$1;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject$1(value)) {
    return value;
  }
  var isArr = isArray$1(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag$1(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer$1(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet$1(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap$1(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

/** Used to compose bitmasks for cloning. */
var CLONE_SYMBOLS_FLAG = 4;

/**
 * Creates a shallow clone of `value`.
 *
 * **Note:** This method is loosely based on the
 * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
 * and supports cloning arrays, array buffers, booleans, date objects, maps,
 * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
 * arrays. The own enumerable properties of `arguments` objects are cloned
 * as plain objects. An empty object is returned for uncloneable values such
 * as error objects, functions, DOM nodes, and WeakMaps.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to clone.
 * @returns {*} Returns the cloned value.
 * @see _.cloneDeep
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var shallow = _.clone(objects);
 * console.log(shallow[0] === objects[0]);
 * // => true
 */
function clone(value) {
  return baseClone(value, CLONE_SYMBOLS_FLAG);
}

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

var stringToPath$1 = stringToPath;

/** Used as references for various `Number` constants. */
var INFINITY$1 = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY$1) ? '-0' : result;
}

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol$2 ? Symbol$2.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray$1(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if (isArray$1(value)) {
    return arrayMap(value, toKey);
  }
  return isSymbol(value) ? [value] : copyArray(stringToPath$1(toString(value)));
}

var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}
/** @private is the given object a Function? */

var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};
/** @private is the given object an Object? */

var isObject = function isObject(obj) {
  return obj !== null && typeof obj === 'object';
};
/** @private is the given object an integer? */

var isInteger = function isInteger(obj) {
  return String(Math.floor(Number(obj))) === obj;
};
/** @private is the given object a string? */

var isString = function isString(obj) {
  return Object.prototype.toString.call(obj) === '[object String]';
};
/** @private Does a React component have exactly 0 children? */

var isEmptyChildren = function isEmptyChildren(children) {
  return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Children.count(children) === 0;
};
/** @private is the given object/value a promise? */

var isPromise = function isPromise(value) {
  return isObject(value) && isFunction(value.then);
};
/**
 * Deeply get a value from an object via its path.
 */

function getIn(obj, key, def, p) {
  if (p === void 0) {
    p = 0;
  }

  var path = toPath(key);

  while (obj && p < path.length) {
    obj = obj[path[p++]];
  }

  return obj === undefined ? def : obj;
}
/**
 * Deeply set a value from in object via it's path. If the value at `path`
 * has changed, return a shallow copy of obj with `value` set at `path`.
 * If `value` has not changed, return the original `obj`.
 *
 * Existing objects / arrays along `path` are also shallow copied. Sibling
 * objects along path retain the same internal js reference. Since new
 * objects / arrays are only created along `path`, we can test if anything
 * changed in a nested structure by comparing the object's reference in
 * the old and new object, similar to how russian doll cache invalidation
 * works.
 *
 * In earlier versions of this function, which used cloneDeep, there were
 * issues whereby settings a nested value would mutate the parent
 * instead of creating a new object. `clone` avoids that bug making a
 * shallow copy of the objects along the update path
 * so no object is mutated in place.
 *
 * Before changing this function, please read through the following
 * discussions.
 *
 * @see https://github.com/developit/linkstate
 * @see https://github.com/jaredpalmer/formik/pull/123
 */

function setIn(obj, path, value) {
  var res = clone(obj); // this keeps inheritance when obj is a class

  var resVal = res;
  var i = 0;
  var pathArray = toPath(path);

  for (; i < pathArray.length - 1; i++) {
    var currentPath = pathArray[i];
    var currentObj = getIn(obj, pathArray.slice(0, i + 1));

    if (currentObj && (isObject(currentObj) || Array.isArray(currentObj))) {
      resVal = resVal[currentPath] = clone(currentObj);
    } else {
      var nextPath = pathArray[i + 1];
      resVal = resVal[currentPath] = isInteger(nextPath) && Number(nextPath) >= 0 ? [] : {};
    }
  } // Return original object if new value is the same as current


  if ((i === 0 ? obj : resVal)[pathArray[i]] === value) {
    return obj;
  }

  if (value === undefined) {
    delete resVal[pathArray[i]];
  } else {
    resVal[pathArray[i]] = value;
  } // If the path array has a single element, the loop did not run.
  // Deleting on `resVal` had no effect in this scenario, so we delete on the result instead.


  if (i === 0 && value === undefined) {
    delete res[pathArray[i]];
  }

  return res;
}
/**
 * Recursively a set the same value for all keys and arrays nested object, cloning
 * @param object
 * @param value
 * @param visited
 * @param response
 */

function setNestedObjectValues(object, value, visited, response) {
  if (visited === void 0) {
    visited = new WeakMap();
  }

  if (response === void 0) {
    response = {};
  }

  for (var _i = 0, _Object$keys = Object.keys(object); _i < _Object$keys.length; _i++) {
    var k = _Object$keys[_i];
    var val = object[k];

    if (isObject(val)) {
      if (!visited.get(val)) {
        visited.set(val, true); // In order to keep array values consistent for both dot path  and
        // bracket syntax, we need to check if this is an array so that
        // this will output  { friends: [true] } and not { friends: { "0": true } }

        response[k] = Array.isArray(val) ? [] : {};
        setNestedObjectValues(val, value, visited, response[k]);
      }
    } else {
      response[k] = value;
    }
  }

  return response;
}

var FormikContext = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createContext(undefined);
var FormikProvider = FormikContext.Provider;
FormikContext.Consumer;
function useFormikContext() {
  var formik = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(FormikContext);
  !!!formik ? warning(false) : void 0;
  return formik;
}

function formikReducer(state, msg) {
  switch (msg.type) {
    case 'SET_VALUES':
      return _extends({}, state, {
        values: msg.payload
      });

    case 'SET_TOUCHED':
      return _extends({}, state, {
        touched: msg.payload
      });

    case 'SET_ERRORS':
      if (isEqual(state.errors, msg.payload)) {
        return state;
      }

      return _extends({}, state, {
        errors: msg.payload
      });

    case 'SET_STATUS':
      return _extends({}, state, {
        status: msg.payload
      });

    case 'SET_ISSUBMITTING':
      return _extends({}, state, {
        isSubmitting: msg.payload
      });

    case 'SET_ISVALIDATING':
      return _extends({}, state, {
        isValidating: msg.payload
      });

    case 'SET_FIELD_VALUE':
      return _extends({}, state, {
        values: setIn(state.values, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_TOUCHED':
      return _extends({}, state, {
        touched: setIn(state.touched, msg.payload.field, msg.payload.value)
      });

    case 'SET_FIELD_ERROR':
      return _extends({}, state, {
        errors: setIn(state.errors, msg.payload.field, msg.payload.value)
      });

    case 'RESET_FORM':
      return _extends({}, state, msg.payload);

    case 'SET_FORMIK_STATE':
      return msg.payload(state);

    case 'SUBMIT_ATTEMPT':
      return _extends({}, state, {
        touched: setNestedObjectValues(state.values, true),
        isSubmitting: true,
        submitCount: state.submitCount + 1
      });

    case 'SUBMIT_FAILURE':
      return _extends({}, state, {
        isSubmitting: false
      });

    case 'SUBMIT_SUCCESS':
      return _extends({}, state, {
        isSubmitting: false
      });

    default:
      return state;
  }
} // Initial empty states // objects


var emptyErrors = {};
var emptyTouched = {};
function useFormik(_ref) {
  var _ref$validateOnChange = _ref.validateOnChange,
      validateOnChange = _ref$validateOnChange === void 0 ? true : _ref$validateOnChange,
      _ref$validateOnBlur = _ref.validateOnBlur,
      validateOnBlur = _ref$validateOnBlur === void 0 ? true : _ref$validateOnBlur,
      _ref$validateOnMount = _ref.validateOnMount,
      validateOnMount = _ref$validateOnMount === void 0 ? false : _ref$validateOnMount,
      isInitialValid = _ref.isInitialValid,
      _ref$enableReinitiali = _ref.enableReinitialize,
      enableReinitialize = _ref$enableReinitiali === void 0 ? false : _ref$enableReinitiali,
      onSubmit = _ref.onSubmit,
      rest = _objectWithoutPropertiesLoose(_ref, ["validateOnChange", "validateOnBlur", "validateOnMount", "isInitialValid", "enableReinitialize", "onSubmit"]);

  var props = _extends({
    validateOnChange: validateOnChange,
    validateOnBlur: validateOnBlur,
    validateOnMount: validateOnMount,
    onSubmit: onSubmit
  }, rest);

  var initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(props.initialValues);
  var initialErrors = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(props.initialErrors || emptyErrors);
  var initialTouched = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(props.initialTouched || emptyTouched);
  var initialStatus = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(props.initialStatus);
  var isMounted = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(false);
  var fieldRegistry = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef({});

  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(function () {
    isMounted.current = true;
    return function () {
      isMounted.current = false;
    };
  }, []);

  var _React$useReducer = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useReducer(formikReducer, {
    values: props.initialValues,
    errors: props.initialErrors || emptyErrors,
    touched: props.initialTouched || emptyTouched,
    status: props.initialStatus,
    isSubmitting: false,
    isValidating: false,
    submitCount: 0
  }),
      state = _React$useReducer[0],
      dispatch = _React$useReducer[1];

  var runValidateHandler = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (values, field) {
    return new Promise(function (resolve, reject) {
      var maybePromisedErrors = props.validate(values, field);

      if (maybePromisedErrors == null) {
        // use loose null check here on purpose
        resolve(emptyErrors);
      } else if (isPromise(maybePromisedErrors)) {
        maybePromisedErrors.then(function (errors) {
          resolve(errors || emptyErrors);
        }, function (actualException) {

          reject(actualException);
        });
      } else {
        resolve(maybePromisedErrors);
      }
    });
  }, [props.validate]);
  /**
   * Run validation against a Yup schema and optionally run a function if successful
   */

  var runValidationSchema = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (values, field) {
    var validationSchema = props.validationSchema;
    var schema = isFunction(validationSchema) ? validationSchema(field) : validationSchema;
    var promise = field && schema.validateAt ? schema.validateAt(field, values) : validateYupSchema(values, schema);
    return new Promise(function (resolve, reject) {
      promise.then(function () {
        resolve(emptyErrors);
      }, function (err) {
        // Yup will throw a validation error if validation fails. We catch those and
        // resolve them into Formik errors. We can sniff if something is a Yup error
        // by checking error.name.
        // @see https://github.com/jquense/yup#validationerrorerrors-string--arraystring-value-any-path-string
        if (err.name === 'ValidationError') {
          resolve(yupToFormErrors(err));
        } else {

          reject(err);
        }
      });
    });
  }, [props.validationSchema]);
  var runSingleFieldLevelValidation = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (field, value) {
    return new Promise(function (resolve) {
      return resolve(fieldRegistry.current[field].validate(value));
    });
  }, []);
  var runFieldLevelValidations = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (values) {
    var fieldKeysWithValidation = Object.keys(fieldRegistry.current).filter(function (f) {
      return isFunction(fieldRegistry.current[f].validate);
    }); // Construct an array with all of the field validation functions

    var fieldValidations = fieldKeysWithValidation.length > 0 ? fieldKeysWithValidation.map(function (f) {
      return runSingleFieldLevelValidation(f, getIn(values, f));
    }) : [Promise.resolve('DO_NOT_DELETE_YOU_WILL_BE_FIRED')]; // use special case ;)

    return Promise.all(fieldValidations).then(function (fieldErrorsList) {
      return fieldErrorsList.reduce(function (prev, curr, index) {
        if (curr === 'DO_NOT_DELETE_YOU_WILL_BE_FIRED') {
          return prev;
        }

        if (curr) {
          prev = setIn(prev, fieldKeysWithValidation[index], curr);
        }

        return prev;
      }, {});
    });
  }, [runSingleFieldLevelValidation]); // Run all validations and return the result

  var runAllValidations = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (values) {
    return Promise.all([runFieldLevelValidations(values), props.validationSchema ? runValidationSchema(values) : {}, props.validate ? runValidateHandler(values) : {}]).then(function (_ref2) {
      var fieldErrors = _ref2[0],
          schemaErrors = _ref2[1],
          validateErrors = _ref2[2];
      var combinedErrors = deepmerge$1.all([fieldErrors, schemaErrors, validateErrors], {
        arrayMerge: arrayMerge
      });
      return combinedErrors;
    });
  }, [props.validate, props.validationSchema, runFieldLevelValidations, runValidateHandler, runValidationSchema]); // Run all validations methods and update state accordingly

  var validateFormWithHighPriority = useEventCallback(function (values) {
    if (values === void 0) {
      values = state.values;
    }

    dispatch({
      type: 'SET_ISVALIDATING',
      payload: true
    });
    return runAllValidations(values).then(function (combinedErrors) {
      if (!!isMounted.current) {
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });

        if (!isEqual(state.errors, combinedErrors)) {
          dispatch({
            type: 'SET_ERRORS',
            payload: combinedErrors
          });
        }
      }

      return combinedErrors;
    });
  });
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(function () {
    if (validateOnMount && isMounted.current === true && isEqual(initialValues.current, props.initialValues)) {
      validateFormWithHighPriority(initialValues.current);
    }
  }, [validateOnMount, validateFormWithHighPriority]);
  var resetForm = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (nextState) {
    var values = nextState && nextState.values ? nextState.values : initialValues.current;
    var errors = nextState && nextState.errors ? nextState.errors : initialErrors.current ? initialErrors.current : props.initialErrors || {};
    var touched = nextState && nextState.touched ? nextState.touched : initialTouched.current ? initialTouched.current : props.initialTouched || {};
    var status = nextState && nextState.status ? nextState.status : initialStatus.current ? initialStatus.current : props.initialStatus;
    initialValues.current = values;
    initialErrors.current = errors;
    initialTouched.current = touched;
    initialStatus.current = status;

    var dispatchFn = function dispatchFn() {
      dispatch({
        type: 'RESET_FORM',
        payload: {
          isSubmitting: !!nextState && !!nextState.isSubmitting,
          errors: errors,
          touched: touched,
          status: status,
          values: values,
          isValidating: !!nextState && !!nextState.isValidating,
          submitCount: !!nextState && !!nextState.submitCount && typeof nextState.submitCount === 'number' ? nextState.submitCount : 0
        }
      });
    };

    if (props.onReset) {
      var maybePromisedOnReset = props.onReset(state.values, imperativeMethods);

      if (isPromise(maybePromisedOnReset)) {
        maybePromisedOnReset.then(dispatchFn);
      } else {
        dispatchFn();
      }
    } else {
      dispatchFn();
    }
  }, [props.initialErrors, props.initialStatus, props.initialTouched]);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(function () {
    if (isMounted.current === true && !isEqual(initialValues.current, props.initialValues)) {
      if (enableReinitialize) {
        initialValues.current = props.initialValues;
        resetForm();
      }

      if (validateOnMount) {
        validateFormWithHighPriority(initialValues.current);
      }
    }
  }, [enableReinitialize, props.initialValues, resetForm, validateOnMount, validateFormWithHighPriority]);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !isEqual(initialErrors.current, props.initialErrors)) {
      initialErrors.current = props.initialErrors || emptyErrors;
      dispatch({
        type: 'SET_ERRORS',
        payload: props.initialErrors || emptyErrors
      });
    }
  }, [enableReinitialize, props.initialErrors]);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !isEqual(initialTouched.current, props.initialTouched)) {
      initialTouched.current = props.initialTouched || emptyTouched;
      dispatch({
        type: 'SET_TOUCHED',
        payload: props.initialTouched || emptyTouched
      });
    }
  }, [enableReinitialize, props.initialTouched]);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(function () {
    if (enableReinitialize && isMounted.current === true && !isEqual(initialStatus.current, props.initialStatus)) {
      initialStatus.current = props.initialStatus;
      dispatch({
        type: 'SET_STATUS',
        payload: props.initialStatus
      });
    }
  }, [enableReinitialize, props.initialStatus, props.initialTouched]);
  var validateField = useEventCallback(function (name) {
    // This will efficiently validate a single field by avoiding state
    // changes if the validation function is synchronous. It's different from
    // what is called when using validateForm.
    if (fieldRegistry.current[name] && isFunction(fieldRegistry.current[name].validate)) {
      var value = getIn(state.values, name);
      var maybePromise = fieldRegistry.current[name].validate(value);

      if (isPromise(maybePromise)) {
        // Only flip isValidating if the function is async.
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: true
        });
        return maybePromise.then(function (x) {
          return x;
        }).then(function (error) {
          dispatch({
            type: 'SET_FIELD_ERROR',
            payload: {
              field: name,
              value: error
            }
          });
          dispatch({
            type: 'SET_ISVALIDATING',
            payload: false
          });
        });
      } else {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: maybePromise
          }
        });
        return Promise.resolve(maybePromise);
      }
    } else if (props.validationSchema) {
      dispatch({
        type: 'SET_ISVALIDATING',
        payload: true
      });
      return runValidationSchema(state.values, name).then(function (x) {
        return x;
      }).then(function (error) {
        dispatch({
          type: 'SET_FIELD_ERROR',
          payload: {
            field: name,
            value: error[name]
          }
        });
        dispatch({
          type: 'SET_ISVALIDATING',
          payload: false
        });
      });
    }

    return Promise.resolve();
  });
  var registerField = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (name, _ref3) {
    var validate = _ref3.validate;
    fieldRegistry.current[name] = {
      validate: validate
    };
  }, []);
  var unregisterField = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (name) {
    delete fieldRegistry.current[name];
  }, []);
  var setTouched = useEventCallback(function (touched, shouldValidate) {
    dispatch({
      type: 'SET_TOUCHED',
      payload: touched
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var setErrors = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (errors) {
    dispatch({
      type: 'SET_ERRORS',
      payload: errors
    });
  }, []);
  var setValues = useEventCallback(function (values, shouldValidate) {
    var resolvedValues = isFunction(values) ? values(state.values) : values;
    dispatch({
      type: 'SET_VALUES',
      payload: resolvedValues
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(resolvedValues) : Promise.resolve();
  });
  var setFieldError = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (field, value) {
    dispatch({
      type: 'SET_FIELD_ERROR',
      payload: {
        field: field,
        value: value
      }
    });
  }, []);
  var setFieldValue = useEventCallback(function (field, value, shouldValidate) {
    dispatch({
      type: 'SET_FIELD_VALUE',
      payload: {
        field: field,
        value: value
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnChange : shouldValidate;
    return willValidate ? validateFormWithHighPriority(setIn(state.values, field, value)) : Promise.resolve();
  });
  var executeChange = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (eventOrTextValue, maybePath) {
    // By default, assume that the first argument is a string. This allows us to use
    // handleChange with React Native and React Native Web's onChangeText prop which
    // provides just the value of the input.
    var field = maybePath;
    var val = eventOrTextValue;
    var parsed; // If the first argument is not a string though, it has to be a synthetic React Event (or a fake one),
    // so we handle like we would a normal HTML change event.

    if (!isString(eventOrTextValue)) {
      // If we can, persist the event
      // @see https://reactjs.org/docs/events.html#event-pooling
      if (eventOrTextValue.persist) {
        eventOrTextValue.persist();
      }

      var target = eventOrTextValue.target ? eventOrTextValue.target : eventOrTextValue.currentTarget;
      var type = target.type,
          name = target.name,
          id = target.id,
          value = target.value,
          checked = target.checked,
          outerHTML = target.outerHTML,
          options = target.options,
          multiple = target.multiple;
      field = maybePath ? maybePath : name ? name : id;

      if (!field && "production" !== "production") {}

      val = /number|range/.test(type) ? (parsed = parseFloat(value), isNaN(parsed) ? '' : parsed) : /checkbox/.test(type) // checkboxes
      ? getValueForCheckbox(getIn(state.values, field), checked, value) : !!multiple // <select multiple>
      ? getSelectedValues(options) : value;
    }

    if (field) {
      // Set form fields by name
      setFieldValue(field, val);
    }
  }, [setFieldValue, state.values]);
  var handleChange = useEventCallback(function (eventOrPath) {
    if (isString(eventOrPath)) {
      return function (event) {
        return executeChange(event, eventOrPath);
      };
    } else {
      executeChange(eventOrPath);
    }
  });
  var setFieldTouched = useEventCallback(function (field, touched, shouldValidate) {
    if (touched === void 0) {
      touched = true;
    }

    dispatch({
      type: 'SET_FIELD_TOUCHED',
      payload: {
        field: field,
        value: touched
      }
    });
    var willValidate = shouldValidate === undefined ? validateOnBlur : shouldValidate;
    return willValidate ? validateFormWithHighPriority(state.values) : Promise.resolve();
  });
  var executeBlur = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (e, path) {
    if (e.persist) {
      e.persist();
    }

    var _e$target = e.target,
        name = _e$target.name,
        id = _e$target.id,
        outerHTML = _e$target.outerHTML;
    var field = path ? path : name ? name : id;

    if (!field && "production" !== "production") {}

    setFieldTouched(field, true);
  }, [setFieldTouched]);
  var handleBlur = useEventCallback(function (eventOrString) {
    if (isString(eventOrString)) {
      return function (event) {
        return executeBlur(event, eventOrString);
      };
    } else {
      executeBlur(eventOrString);
    }
  });
  var setFormikState = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (stateOrCb) {
    if (isFunction(stateOrCb)) {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: stateOrCb
      });
    } else {
      dispatch({
        type: 'SET_FORMIK_STATE',
        payload: function payload() {
          return stateOrCb;
        }
      });
    }
  }, []);
  var setStatus = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (status) {
    dispatch({
      type: 'SET_STATUS',
      payload: status
    });
  }, []);
  var setSubmitting = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (isSubmitting) {
    dispatch({
      type: 'SET_ISSUBMITTING',
      payload: isSubmitting
    });
  }, []);
  var submitForm = useEventCallback(function () {
    dispatch({
      type: 'SUBMIT_ATTEMPT'
    });
    return validateFormWithHighPriority().then(function (combinedErrors) {
      // In case an error was thrown and passed to the resolved Promise,
      // `combinedErrors` can be an instance of an Error. We need to check
      // that and abort the submit.
      // If we don't do that, calling `Object.keys(new Error())` yields an
      // empty array, which causes the validation to pass and the form
      // to be submitted.
      var isInstanceOfError = combinedErrors instanceof Error;
      var isActuallyValid = !isInstanceOfError && Object.keys(combinedErrors).length === 0;

      if (isActuallyValid) {
        // Proceed with submit...
        //
        // To respect sync submit fns, we can't simply wrap executeSubmit in a promise and
        // _always_ dispatch SUBMIT_SUCCESS because isSubmitting would then always be false.
        // This would be fine in simple cases, but make it impossible to disable submit
        // buttons where people use callbacks or promises as side effects (which is basically
        // all of v1 Formik code). Instead, recall that we are inside of a promise chain already,
        //  so we can try/catch executeSubmit(), if it returns undefined, then just bail.
        // If there are errors, throw em. Otherwise, wrap executeSubmit in a promise and handle
        // cleanup of isSubmitting on behalf of the consumer.
        var promiseOrUndefined;

        try {
          promiseOrUndefined = executeSubmit(); // Bail if it's sync, consumer is responsible for cleaning up
          // via setSubmitting(false)

          if (promiseOrUndefined === undefined) {
            return;
          }
        } catch (error) {
          throw error;
        }

        return Promise.resolve(promiseOrUndefined).then(function (result) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_SUCCESS'
            });
          }

          return result;
        })["catch"](function (_errors) {
          if (!!isMounted.current) {
            dispatch({
              type: 'SUBMIT_FAILURE'
            }); // This is a legit error rejected by the onSubmit fn
            // so we don't want to break the promise chain

            throw _errors;
          }
        });
      } else if (!!isMounted.current) {
        // ^^^ Make sure Formik is still mounted before updating state
        dispatch({
          type: 'SUBMIT_FAILURE'
        }); // throw combinedErrors;

        if (isInstanceOfError) {
          throw combinedErrors;
        }
      }

      return;
    });
  });
  var handleSubmit = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    } // Warn if form submission is triggered by a <button> without a

    submitForm()["catch"](function (reason) {
      console.warn("Warning: An unhandled error was caught from submitForm()", reason);
    });
  });
  var imperativeMethods = {
    resetForm: resetForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    setErrors: setErrors,
    setFieldError: setFieldError,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    setFormikState: setFormikState,
    submitForm: submitForm
  };
  var executeSubmit = useEventCallback(function () {
    return onSubmit(state.values, imperativeMethods);
  });
  var handleReset = useEventCallback(function (e) {
    if (e && e.preventDefault && isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (e && e.stopPropagation && isFunction(e.stopPropagation)) {
      e.stopPropagation();
    }

    resetForm();
  });
  var getFieldMeta = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (name) {
    return {
      value: getIn(state.values, name),
      error: getIn(state.errors, name),
      touched: !!getIn(state.touched, name),
      initialValue: getIn(initialValues.current, name),
      initialTouched: !!getIn(initialTouched.current, name),
      initialError: getIn(initialErrors.current, name)
    };
  }, [state.errors, state.touched, state.values]);
  var getFieldHelpers = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (name) {
    return {
      setValue: function setValue(value, shouldValidate) {
        return setFieldValue(name, value, shouldValidate);
      },
      setTouched: function setTouched(value, shouldValidate) {
        return setFieldTouched(name, value, shouldValidate);
      },
      setError: function setError(value) {
        return setFieldError(name, value);
      }
    };
  }, [setFieldValue, setFieldTouched, setFieldError]);
  var getFieldProps = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function (nameOrOptions) {
    var isAnObject = isObject(nameOrOptions);
    var name = isAnObject ? nameOrOptions.name : nameOrOptions;
    var valueState = getIn(state.values, name);
    var field = {
      name: name,
      value: valueState,
      onChange: handleChange,
      onBlur: handleBlur
    };

    if (isAnObject) {
      var type = nameOrOptions.type,
          valueProp = nameOrOptions.value,
          is = nameOrOptions.as,
          multiple = nameOrOptions.multiple;

      if (type === 'checkbox') {
        if (valueProp === undefined) {
          field.checked = !!valueState;
        } else {
          field.checked = !!(Array.isArray(valueState) && ~valueState.indexOf(valueProp));
          field.value = valueProp;
        }
      } else if (type === 'radio') {
        field.checked = valueState === valueProp;
        field.value = valueProp;
      } else if (is === 'select' && multiple) {
        field.value = field.value || [];
        field.multiple = true;
      }
    }

    return field;
  }, [handleBlur, handleChange, state.values]);
  var dirty = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(function () {
    return !isEqual(initialValues.current, state.values);
  }, [initialValues.current, state.values]);
  var isValid = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(function () {
    return typeof isInitialValid !== 'undefined' ? dirty ? state.errors && Object.keys(state.errors).length === 0 : isInitialValid !== false && isFunction(isInitialValid) ? isInitialValid(props) : isInitialValid : state.errors && Object.keys(state.errors).length === 0;
  }, [isInitialValid, dirty, state.errors, props]);

  var ctx = _extends({}, state, {
    initialValues: initialValues.current,
    initialErrors: initialErrors.current,
    initialTouched: initialTouched.current,
    initialStatus: initialStatus.current,
    handleBlur: handleBlur,
    handleChange: handleChange,
    handleReset: handleReset,
    handleSubmit: handleSubmit,
    resetForm: resetForm,
    setErrors: setErrors,
    setFormikState: setFormikState,
    setFieldTouched: setFieldTouched,
    setFieldValue: setFieldValue,
    setFieldError: setFieldError,
    setStatus: setStatus,
    setSubmitting: setSubmitting,
    setTouched: setTouched,
    setValues: setValues,
    submitForm: submitForm,
    validateForm: validateFormWithHighPriority,
    validateField: validateField,
    isValid: isValid,
    dirty: dirty,
    unregisterField: unregisterField,
    registerField: registerField,
    getFieldProps: getFieldProps,
    getFieldMeta: getFieldMeta,
    getFieldHelpers: getFieldHelpers,
    validateOnBlur: validateOnBlur,
    validateOnChange: validateOnChange,
    validateOnMount: validateOnMount
  });

  return ctx;
}
function Formik(props) {
  var formikbag = useFormik(props);
  var component = props.component,
      children = props.children,
      render = props.render,
      innerRef = props.innerRef; // This allows folks to pass a ref to <Formik />

  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useImperativeHandle(innerRef, function () {
    return formikbag;
  });

  return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createElement(FormikProvider, {
    value: formikbag
  }, component ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createElement(component, formikbag) : render ? render(formikbag) : children // children come last, always called
  ? isFunction(children) ? children(formikbag) : !isEmptyChildren(children) ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Children.only(children) : null : null);
}

function warnAboutMissingIdentifier(_ref4) {
  var htmlContent = _ref4.htmlContent,
      documentationAnchorLink = _ref4.documentationAnchorLink,
      handlerName = _ref4.handlerName;
  console.warn("Warning: Formik called `" + handlerName + "`, but you forgot to pass an `id` or `name` attribute to your input:\n    " + htmlContent + "\n    Formik cannot determine which value to update. For more info see https://formik.org/docs/api/formik#" + documentationAnchorLink + "\n  ");
}
/**
 * Transform Yup ValidationError to a more usable object
 */


function yupToFormErrors(yupError) {
  var errors = {};

  if (yupError.inner) {
    if (yupError.inner.length === 0) {
      return setIn(errors, yupError.path, yupError.message);
    }

    for (var _iterator = yupError.inner, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
      var _ref5;

      if (_isArray) {
        if (_i >= _iterator.length) break;
        _ref5 = _iterator[_i++];
      } else {
        _i = _iterator.next();
        if (_i.done) break;
        _ref5 = _i.value;
      }

      var err = _ref5;

      if (!getIn(errors, err.path)) {
        errors = setIn(errors, err.path, err.message);
      }
    }
  }

  return errors;
}
/**
 * Validate a yup schema.
 */

function validateYupSchema(values, schema, sync, context) {
  if (sync === void 0) {
    sync = false;
  }

  if (context === void 0) {
    context = {};
  }

  var validateData = prepareDataForValidation(values);
  return schema[sync ? 'validateSync' : 'validate'](validateData, {
    abortEarly: false,
    context: context
  });
}
/**
 * Recursively prepare values.
 */

function prepareDataForValidation(values) {
  var data = Array.isArray(values) ? [] : {};

  for (var k in values) {
    if (Object.prototype.hasOwnProperty.call(values, k)) {
      var key = String(k);

      if (Array.isArray(values[key]) === true) {
        data[key] = values[key].map(function (value) {
          if (Array.isArray(value) === true || isPlainObject(value)) {
            return prepareDataForValidation(value);
          } else {
            return value !== '' ? value : undefined;
          }
        });
      } else if (isPlainObject(values[key])) {
        data[key] = prepareDataForValidation(values[key]);
      } else {
        data[key] = values[key] !== '' ? values[key] : undefined;
      }
    }
  }

  return data;
}
/**
 * deepmerge array merging algorithm
 * https://github.com/KyleAMathews/deepmerge#combine-array
 */

function arrayMerge(target, source, options) {
  var destination = target.slice();
  source.forEach(function merge(e, i) {
    if (typeof destination[i] === 'undefined') {
      var cloneRequested = options.clone !== false;
      var shouldClone = cloneRequested && options.isMergeableObject(e);
      destination[i] = shouldClone ? deepmerge$1(Array.isArray(e) ? [] : {}, e, options) : e;
    } else if (options.isMergeableObject(e)) {
      destination[i] = deepmerge$1(target[i], e, options);
    } else if (target.indexOf(e) === -1) {
      destination.push(e);
    }
  });
  return destination;
}
/** Return multi select values based on an array of options */


function getSelectedValues(options) {
  return Array.from(options).filter(function (el) {
    return el.selected;
  }).map(function (el) {
    return el.value;
  });
}
/** Return the next value for a checkbox */


function getValueForCheckbox(currentValue, checked, valueProp) {
  // If the current value was a boolean, return a boolean
  if (typeof currentValue === 'boolean') {
    return Boolean(checked);
  } // If the currentValue was not a boolean we want to return an array


  var currentArrayOfValues = [];
  var isValueInArray = false;
  var index = -1;

  if (!Array.isArray(currentValue)) {
    // eslint-disable-next-line eqeqeq
    if (!valueProp || valueProp == 'true' || valueProp == 'false') {
      return Boolean(checked);
    }
  } else {
    // If the current value is already an array, use it
    currentArrayOfValues = currentValue;
    index = currentValue.indexOf(valueProp);
    isValueInArray = index >= 0;
  } // If the checkbox was checked and the value is not already present in the aray we want to add the new value to the array of values


  if (checked && valueProp && !isValueInArray) {
    return currentArrayOfValues.concat(valueProp);
  } // If the checkbox was unchecked and the value is not in the array, simply return the already existing array of values


  if (!isValueInArray) {
    return currentArrayOfValues;
  } // If the checkbox was unchecked and the value is in the array, remove the value and return the array


  return currentArrayOfValues.slice(0, index).concat(currentArrayOfValues.slice(index + 1));
} // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser.
// @see https://gist.github.com/gaearon/e7d97cdf38a2907924ea12e4ebdf3c85


var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useLayoutEffect : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect;

function useEventCallback(fn) {
  var ref = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(fn); // we copy a ref to the callback scoped to the current state/props on each render

  useIsomorphicLayoutEffect(function () {
    ref.current = fn;
  });
  return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return ref.current.apply(void 0, args);
  }, []);
}

function useField(propsOrFieldName) {
  var formik = useFormikContext();
  var getFieldProps = formik.getFieldProps,
      getFieldMeta = formik.getFieldMeta,
      getFieldHelpers = formik.getFieldHelpers,
      registerField = formik.registerField,
      unregisterField = formik.unregisterField;
  var isAnObject = isObject(propsOrFieldName); // Normalize propsOrFieldName to FieldHookConfig<Val>

  var props = isAnObject ? propsOrFieldName : {
    name: propsOrFieldName
  };
  var fieldName = props.name,
      validateFn = props.validate;
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(function () {
    if (fieldName) {
      registerField(fieldName, {
        validate: validateFn
      });
    }

    return function () {
      if (fieldName) {
        unregisterField(fieldName);
      }
    };
  }, [registerField, unregisterField, fieldName, validateFn]);

  !fieldName ? warning(false) : void 0;
  return [getFieldProps(props), getFieldMeta(fieldName), getFieldHelpers(fieldName)];
}

var Form = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function (props, ref) {
  // iOS needs an "action" attribute for nice input: https://stackoverflow.com/a/39485162/406725
  // We default the action to "#" in case the preventDefault fails (just updates the URL hash)
  var action = props.action,
      rest = _objectWithoutPropertiesLoose(props, ["action"]);

  var _action = action || '#';

  var _useFormikContext = useFormikContext(),
      handleReset = _useFormikContext.handleReset,
      handleSubmit = _useFormikContext.handleSubmit;

  return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createElement("form", Object.assign({
    onSubmit: handleSubmit,
    ref: ref,
    onReset: handleReset,
    action: _action
  }, rest));
});
Form.displayName = 'Form';




/***/ }),

/***/ 88768:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AdminPortal": function() { return /* binding */ AdminPortal; },
/* harmony export */   "AdminPortalPage": function() { return /* binding */ AdminPortalPage; },
/* harmony export */   "CheckoutDialog": function() { return /* binding */ CheckoutDialog$1; },
/* harmony export */   "default": function() { return /* binding */ AdminPortal; },
/* harmony export */   "defaultTheme": function() { return /* binding */ defaultTheme; }
/* harmony export */ });
/* harmony import */ var _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11277);
/* harmony import */ var _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25618);
/* harmony import */ var _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5850);
/* harmony import */ var _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32205);
/* harmony import */ var _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _frontegg_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36539);
/* harmony import */ var _AppHolder_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(15501);








const useAuditsActions = () => {
    const dispatch = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aO)();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .bindActionCreators */ .DE)(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .auditsActions */ .iN, dispatch), [_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .auditsActions */ .iN]);
};
/**
 * hooks helpers
 */
const sliceReducerActionsBy = (reducer) => {
    const reducerKeys = Object.keys(reducer);
    const reducerActions = reducerKeys.map((key) => ({ [key]: _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .auditsActions */ .iN[key] }));
    return reducerActions.reduce((p, n) => (Object.assign(Object.assign({}, p), n)), {});
};
const stateHookGenerator = (stateMapper, subState) => {
    return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aM)((state) => { var _a; return (_a = stateMapper === null || stateMapper === void 0 ? void 0 : stateMapper(state[_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .auditsStoreName */ .e_][subState])) !== null && _a !== void 0 ? _a : state[_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .auditsStoreName */ .e_][subState]; }, _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aN);
};
const reducerActionsGenerator = (actions, reducers) => {
    const dispatch = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aO)();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .bindActionCreators */ .DE)(Object.assign(Object.assign({}, actions), sliceReducerActionsBy(reducers)), dispatch), [dispatch]);
};

const useAuditLogsState = (stateMapper) => stateHookGenerator(stateMapper, 'auditLogsState');
const useAuditLogsActions = () => reducerActionsGenerator(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .auditLogsActions */ .u1, _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .auditLogsReducers */ .cG);

const useAuditsMetadataState = (stateMapper) => stateHookGenerator(stateMapper, 'auditsMetadataState');

const useConnectivityState = (stateMapper) => {
    return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aM)((state) => { var _a; return (_a = stateMapper === null || stateMapper === void 0 ? void 0 : stateMapper(state[_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .connectivityStoreName */ .S4])) !== null && _a !== void 0 ? _a : state[_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .connectivityStoreName */ .S4]; }, _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aN);
};
const useConnectivityActions = () => {
    const dispatch = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aO)();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .bindActionCreators */ .DE)(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .connectivityActions */ .W3, dispatch), [_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .connectivityActions */ .W3]);
};

function getSubscriptionState(state) {
    return state[_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionsStoreName */ .PP];
}
const usePaymentProvider = () => {
    return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aM)((state) => getSubscriptionState(state).config, _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aN);
};
const usePaymentProviderActions = () => {
    const dispatch = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aO)();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .bindActionCreators */ .DE)(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionActions.config */ .bP.config, dispatch), [dispatch]);
};
const usePlans = () => {
    return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aM)((state) => getSubscriptionState(state).plans, _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aN);
};
const usePlansActions = () => {
    const dispatch = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aO)();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .bindActionCreators */ .DE)(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionActions.plans */ .bP.plans, dispatch), [dispatch]);
};
const useCheckout = () => {
    return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aM)((state) => getSubscriptionState(state).checkout, _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aN);
};
const useCheckoutActions = () => {
    const dispatch = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aO)();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .bindActionCreators */ .DE)(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionActions.checkout */ .bP.checkout, dispatch), [dispatch]);
};
const useBillingActions = (billingKey) => {
    const dispatch = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aO)();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .bindActionCreators */ .DE)(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionActions.billing */ .bP.billing[billingKey], dispatch), [billingKey, dispatch]);
};
const useBillingInformation = () => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aM)((state) => getSubscriptionState(state).billing.information, _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aN);
const useBillingInformationActions = () => useBillingActions('information');
const usePaymentMethod = () => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aM)((state) => getSubscriptionState(state).billing.paymentMethod, _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aN);
const usePaymentMethodActions = () => useBillingActions('paymentMethod');
const useInvoices = () => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aM)((state) => getSubscriptionState(state).billing.invoices, _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aN);
const useInvoicesActions = () => useBillingActions('invoices');
const useStripeState = () => {
    return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aM)((state) => getSubscriptionState(state).stripe, _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aN);
};
const useStripeActions = () => {
    const dispatch = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aO)();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .bindActionCreators */ .DE)(_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .subscriptionActions.stripe */ .bP.stripe, dispatch), [dispatch]);
};
const useSubscriptionCancellation = () => {
    return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aM)((state) => getSubscriptionState(state).billing.subscription.cancellation, _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aN);
};
const useSubscriptionRenewal = () => {
    return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aM)((state) => getSubscriptionState(state).billing.subscription.renewal, _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aN);
};
const useSubscription = () => {
    return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aM)((state) => {
        const { billing: { subscription }, } = getSubscriptionState(state);
        return subscription;
    }, _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aN);
};

var ArrowDropDownIcon = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aP)( /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx("path", {
  d: "M7 10l5 5 5-5z"
}), 'ArrowDropDown');

const _excluded$f = ["addEndListener", "appear", "children", "container", "direction", "easing", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "style", "timeout", "TransitionComponent"];

function getTranslateValue(direction, node, resolvedContainer) {
  const rect = node.getBoundingClientRect();
  const containerRect = resolvedContainer && resolvedContainer.getBoundingClientRect();
  const containerWindow = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aW)(node);
  let transform;

  if (node.fakeTransform) {
    transform = node.fakeTransform;
  } else {
    const computedStyle = containerWindow.getComputedStyle(node);
    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
  }

  let offsetX = 0;
  let offsetY = 0;

  if (transform && transform !== 'none' && typeof transform === 'string') {
    const transformValues = transform.split('(')[1].split(')')[0].split(',');
    offsetX = parseInt(transformValues[4], 10);
    offsetY = parseInt(transformValues[5], 10);
  }

  if (direction === 'left') {
    if (containerRect) {
      return `translateX(${containerRect.right + offsetX - rect.left}px)`;
    }

    return `translateX(${containerWindow.innerWidth + offsetX - rect.left}px)`;
  }

  if (direction === 'right') {
    if (containerRect) {
      return `translateX(-${rect.right - containerRect.left - offsetX}px)`;
    }

    return `translateX(-${rect.left + rect.width - offsetX}px)`;
  }

  if (direction === 'up') {
    if (containerRect) {
      return `translateY(${containerRect.bottom + offsetY - rect.top}px)`;
    }

    return `translateY(${containerWindow.innerHeight + offsetY - rect.top}px)`;
  } // direction === 'down'


  if (containerRect) {
    return `translateY(-${rect.top - containerRect.top + rect.height - offsetY}px)`;
  }

  return `translateY(-${rect.top + rect.height - offsetY}px)`;
}

function resolveContainer(containerPropProp) {
  return typeof containerPropProp === 'function' ? containerPropProp() : containerPropProp;
}

function setTranslateValue(direction, node, containerProp) {
  const resolvedContainer = resolveContainer(containerProp);
  const transform = getTranslateValue(direction, node, resolvedContainer);

  if (transform) {
    node.style.webkitTransform = transform;
    node.style.transform = transform;
  }
}
const defaultEasing = {
  enter: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aR.easeOut,
  exit: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aR.sharp
};
const defaultTimeout = {
  enter: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aS.enteringScreen,
  exit: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aS.leavingScreen
};
/**
 * The Slide transition is used by the [Drawer](/components/drawers/) component.
 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
 */

const Slide = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Slide(props, ref) {
  const {
    addEndListener,
    appear = true,
    children,
    container: containerProp,
    direction = 'down',
    easing: easingProp = defaultEasing,
    in: inProp,
    onEnter,
    onEntered,
    onEntering,
    onExit,
    onExited,
    onExiting,
    style,
    timeout = defaultTimeout,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aY
  } = props,
        other = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aT)(props, _excluded$f);

  const theme = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.F)();
  const childrenRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const handleRefIntermediary = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aU)(children.ref, childrenRef);
  const handleRef = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aU)(handleRefIntermediary, ref);

  const normalizedTransitionCallback = callback => isAppearing => {
    if (callback) {
      // onEnterXxx and onExitXxx callbacks have a different arguments.length value.
      if (isAppearing === undefined) {
        callback(childrenRef.current);
      } else {
        callback(childrenRef.current, isAppearing);
      }
    }
  };

  const handleEnter = normalizedTransitionCallback((node, isAppearing) => {
    setTranslateValue(direction, node, containerProp);
    (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a_)(node);

    if (onEnter) {
      onEnter(node, isAppearing);
    }
  });
  const handleEntering = normalizedTransitionCallback((node, isAppearing) => {
    const transitionProps = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aZ)({
      timeout,
      style,
      easing: easingProp
    }, {
      mode: 'enter'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, transitionProps));
    node.style.transition = theme.transitions.create('transform', (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, transitionProps));
    node.style.webkitTransform = 'none';
    node.style.transform = 'none';

    if (onEntering) {
      onEntering(node, isAppearing);
    }
  });
  const handleEntered = normalizedTransitionCallback(onEntered);
  const handleExiting = normalizedTransitionCallback(onExiting);
  const handleExit = normalizedTransitionCallback(node => {
    const transitionProps = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aZ)({
      timeout,
      style,
      easing: easingProp
    }, {
      mode: 'exit'
    });
    node.style.webkitTransition = theme.transitions.create('-webkit-transform', transitionProps);
    node.style.transition = theme.transitions.create('transform', transitionProps);
    setTranslateValue(direction, node, containerProp);

    if (onExit) {
      onExit(node);
    }
  });
  const handleExited = normalizedTransitionCallback(node => {
    // No need for transitions when the component is hidden
    node.style.webkitTransition = '';
    node.style.transition = '';

    if (onExited) {
      onExited(node);
    }
  });

  const handleAddEndListener = next => {
    if (addEndListener) {
      // Old call signature before `react-transition-group` implemented `nodeRef`
      addEndListener(childrenRef.current, next);
    }
  };

  const updatePosition = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
    if (childrenRef.current) {
      setTranslateValue(direction, childrenRef.current, containerProp);
    }
  }, [direction, containerProp]);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    // Skip configuration where the position is screen size invariant.
    if (inProp || direction === 'down' || direction === 'right') {
      return undefined;
    }

    const handleResize = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aV)(() => {
      if (childrenRef.current) {
        setTranslateValue(direction, childrenRef.current, containerProp);
      }
    });
    const containerWindow = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aW)(childrenRef.current);
    containerWindow.addEventListener('resize', handleResize);
    return () => {
      handleResize.clear();
      containerWindow.removeEventListener('resize', handleResize);
    };
  }, [direction, inProp, containerProp]);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    if (!inProp) {
      // We need to update the position of the drawer when the direction change and
      // when it's hidden.
      updatePosition();
    }
  }, [inProp, updatePosition]);
  return /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(TransitionComponent, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
    nodeRef: childrenRef,
    onEnter: handleEnter,
    onEntered: handleEntered,
    onEntering: handleEntering,
    onExit: handleExit,
    onExited: handleExited,
    onExiting: handleExiting,
    addEndListener: handleAddEndListener,
    appear: appear,
    in: inProp,
    timeout: timeout
  }, other, {
    children: (state, childProps) => {
      return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(children, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
        ref: handleRef,
        style: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
          visibility: state === 'exited' && !inProp ? 'hidden' : undefined
        }, style, children.props.style)
      }, childProps));
    }
  }));
});
var Slide$1 = Slide;

function getDrawerUtilityClass(slot) {
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a$)('MuiDrawer', slot);
}
(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b0)('MuiDrawer', ['root', 'docked', 'paper', 'paperAnchorLeft', 'paperAnchorRight', 'paperAnchorTop', 'paperAnchorBottom', 'paperAnchorDockedLeft', 'paperAnchorDockedRight', 'paperAnchorDockedTop', 'paperAnchorDockedBottom', 'modal']);

const _excluded$e = ["BackdropProps"],
      _excluded2$1 = ["anchor", "BackdropProps", "children", "className", "elevation", "hideBackdrop", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "TransitionComponent", "transitionDuration", "variant"];

const overridesResolver = (props, styles) => {
  const {
    ownerState
  } = props;
  return [styles.root, (ownerState.variant === 'permanent' || ownerState.variant === 'persistent') && styles.docked, styles.modal];
};

const useUtilityClasses$e = ownerState => {
  const {
    classes,
    anchor,
    variant
  } = ownerState;
  const slots = {
    root: ['root'],
    docked: [(variant === 'permanent' || variant === 'persistent') && 'docked'],
    modal: ['modal'],
    paper: ['paper', `paperAnchor${(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b4)(anchor)}`, variant !== 'temporary' && `paperAnchorDocked${(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b4)(anchor)}`]
  };
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b6)(slots, getDrawerUtilityClass, classes);
};

const DrawerRoot = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b1, {
  name: 'MuiDrawer',
  slot: 'Root',
  overridesResolver
})(({
  theme
}) => ({
  zIndex: theme.zIndex.drawer
}));
const DrawerDockedRoot = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('div', {
  shouldForwardProp: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b2,
  name: 'MuiDrawer',
  slot: 'Docked',
  skipVariantsResolver: false,
  overridesResolver
})({
  flex: '0 0 auto'
});
const DrawerPaper = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b3, {
  name: 'MuiDrawer',
  slot: 'Paper',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.paper, styles[`paperAnchor${(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b4)(ownerState.anchor)}`], ownerState.variant !== 'temporary' && styles[`paperAnchorDocked${(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b4)(ownerState.anchor)}`]];
  }
})(({
  theme,
  ownerState
}) => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
  overflowY: 'auto',
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  flex: '1 0 auto',
  zIndex: theme.zIndex.drawer,
  // Add iOS momentum scrolling for iOS < 13.0
  WebkitOverflowScrolling: 'touch',
  // temporary style
  position: 'fixed',
  top: 0,
  // We disable the focus ring for mouse, touch and keyboard users.
  // At some point, it would be better to keep it for keyboard users.
  // :focus-ring CSS pseudo-class will help.
  outline: 0
}, ownerState.anchor === 'left' && {
  left: 0
}, ownerState.anchor === 'top' && {
  top: 0,
  left: 0,
  right: 0,
  height: 'auto',
  maxHeight: '100%'
}, ownerState.anchor === 'right' && {
  right: 0
}, ownerState.anchor === 'bottom' && {
  top: 'auto',
  left: 0,
  bottom: 0,
  right: 0,
  height: 'auto',
  maxHeight: '100%'
}, ownerState.anchor === 'left' && ownerState.variant !== 'temporary' && {
  borderRight: `1px solid ${theme.palette.divider}`
}, ownerState.anchor === 'top' && ownerState.variant !== 'temporary' && {
  borderBottom: `1px solid ${theme.palette.divider}`
}, ownerState.anchor === 'right' && ownerState.variant !== 'temporary' && {
  borderLeft: `1px solid ${theme.palette.divider}`
}, ownerState.anchor === 'bottom' && ownerState.variant !== 'temporary' && {
  borderTop: `1px solid ${theme.palette.divider}`
}));
const oppositeDirection = {
  left: 'right',
  right: 'left',
  top: 'down',
  bottom: 'up'
};
function isHorizontal(anchor) {
  return ['left', 'right'].indexOf(anchor) !== -1;
}
function getAnchor(theme, anchor) {
  return theme.direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
}
const defaultTransitionDuration = {
  enter: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aS.enteringScreen,
  exit: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aS.leavingScreen
};
/**
 * The props of the [Modal](/api/modal/) component are available
 * when `variant="temporary"` is set.
 */

const Drawer = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Drawer(inProps, ref) {
  const props = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b5)({
    props: inProps,
    name: 'MuiDrawer'
  });

  const {
    anchor: anchorProp = 'left',
    BackdropProps,
    children,
    className,
    elevation = 16,
    hideBackdrop = false,
    ModalProps: {
      BackdropProps: BackdropPropsProp
    } = {},
    onClose,
    open = false,
    PaperProps = {},
    SlideProps,
    // eslint-disable-next-line react/prop-types
    TransitionComponent = Slide$1,
    transitionDuration = defaultTransitionDuration,
    variant = 'temporary'
  } = props,
        ModalProps = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aT)(props.ModalProps, _excluded$e),
        other = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aT)(props, _excluded2$1);

  const theme = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.F)(); // Let's assume that the Drawer will always be rendered on user space.
  // We use this state is order to skip the appear transition during the
  // initial mount of the component.

  const mounted = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(false);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    mounted.current = true;
  }, []);
  const anchorInvariant = getAnchor(theme, anchorProp);
  const anchor = anchorProp;

  const ownerState = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, props, {
    anchor,
    elevation,
    open,
    variant
  }, other);

  const classes = useUtilityClasses$e(ownerState);

  const drawer = /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(DrawerPaper, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
    elevation: variant === 'temporary' ? elevation : 0,
    square: true
  }, PaperProps, {
    className: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b7)(classes.paper, PaperProps.className),
    ownerState: ownerState,
    children: children
  }));

  if (variant === 'permanent') {
    return /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(DrawerDockedRoot, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
      className: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b7)(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: drawer
    }));
  }

  const slidingDrawer = /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(TransitionComponent, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
    in: open,
    direction: oppositeDirection[anchorInvariant],
    timeout: transitionDuration,
    appear: mounted.current
  }, SlideProps, {
    children: drawer
  }));

  if (variant === 'persistent') {
    return /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(DrawerDockedRoot, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
      className: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b7)(classes.root, classes.docked, className),
      ownerState: ownerState,
      ref: ref
    }, other, {
      children: slidingDrawer
    }));
  } // variant === temporary


  return /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(DrawerRoot, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
    BackdropProps: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, BackdropProps, BackdropPropsProp, {
      transitionDuration
    }),
    className: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b7)(classes.root, classes.modal, className),
    open: open,
    ownerState: ownerState,
    onClose: onClose,
    hideBackdrop: hideBackdrop,
    ref: ref
  }, other, ModalProps, {
    children: slidingDrawer
  }));
});
var Drawer$1 = Drawer;

function getFilledInputUtilityClass(slot) {
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a$)('MuiFilledInput', slot);
}
const filledInputClasses = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b0)('MuiFilledInput', ['root', 'colorSecondary', 'underline', 'focused', 'disabled', 'adornedStart', 'adornedEnd', 'error', 'sizeSmall', 'multiline', 'hiddenLabel', 'input', 'inputSizeSmall', 'inputHiddenLabel', 'inputMultiline', 'inputAdornedStart', 'inputAdornedEnd']);
var filledInputClasses$1 = filledInputClasses;

const _excluded$d = ["disableUnderline", "components", "componentsProps", "fullWidth", "hiddenLabel", "inputComponent", "multiline", "type"];

const useUtilityClasses$d = ownerState => {
  const {
    classes,
    disableUnderline
  } = ownerState;
  const slots = {
    root: ['root', !disableUnderline && 'underline'],
    input: ['input']
  };
  const composedClasses = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b6)(slots, getFilledInputUtilityClass, classes);
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, classes, composedClasses);
};

const FilledInputRoot = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b8, {
  shouldForwardProp: prop => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b2)(prop) || prop === 'classes',
  name: 'MuiFilledInput',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [...(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b9)(props, styles), !ownerState.disableUnderline && styles.underline];
  }
})(({
  theme,
  ownerState
}) => {
  const light = theme.palette.mode === 'light';
  const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  const backgroundColor = light ? 'rgba(0, 0, 0, 0.06)' : 'rgba(255, 255, 255, 0.09)';
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
    position: 'relative',
    backgroundColor,
    borderTopLeftRadius: theme.shape.borderRadius,
    borderTopRightRadius: theme.shape.borderRadius,
    transition: theme.transitions.create('background-color', {
      duration: theme.transitions.duration.shorter,
      easing: theme.transitions.easing.easeOut
    }),
    '&:hover': {
      backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.13)',
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        backgroundColor
      }
    },
    [`&.${filledInputClasses$1.focused}`]: {
      backgroundColor
    },
    [`&.${filledInputClasses$1.disabled}`]: {
      backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
    }
  }, !ownerState.disableUnderline && {
    '&:after': {
      borderBottom: `2px solid ${theme.palette[ownerState.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: 'absolute',
      right: 0,
      transform: 'scaleX(0)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      pointerEvents: 'none' // Transparent to the hover style.

    },
    [`&.${filledInputClasses$1.focused}:after`]: {
      transform: 'scaleX(1)'
    },
    [`&.${filledInputClasses$1.error}:after`]: {
      borderBottomColor: theme.palette.error.main,
      transform: 'scaleX(1)' // error is always underlined in red

    },
    '&:before': {
      borderBottom: `1px solid ${bottomLineColor}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: 'absolute',
      right: 0,
      transition: theme.transitions.create('border-bottom-color', {
        duration: theme.transitions.duration.shorter
      }),
      pointerEvents: 'none' // Transparent to the hover style.

    },
    [`&:hover:not(.${filledInputClasses$1.disabled}):before`]: {
      borderBottom: `1px solid ${theme.palette.text.primary}`
    },
    [`&.${filledInputClasses$1.disabled}:before`]: {
      borderBottomStyle: 'dotted'
    }
  }, ownerState.startAdornment && {
    paddingLeft: 12
  }, ownerState.endAdornment && {
    paddingRight: 12
  }, ownerState.multiline && (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
    padding: '25px 12px 8px'
  }, ownerState.size === 'small' && {
    paddingTop: 21,
    paddingBottom: 4
  }, ownerState.hiddenLabel && {
    paddingTop: 16,
    paddingBottom: 17
  }));
});
const FilledInputInput = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ba, {
  name: 'MuiFilledInput',
  slot: 'Input',
  overridesResolver: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bb
})(({
  theme,
  ownerState
}) => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
  paddingTop: 25,
  paddingRight: 12,
  paddingBottom: 8,
  paddingLeft: 12,
  '&:-webkit-autofill': {
    WebkitBoxShadow: theme.palette.mode === 'light' ? null : '0 0 0 100px #266798 inset',
    WebkitTextFillColor: theme.palette.mode === 'light' ? null : '#fff',
    caretColor: theme.palette.mode === 'light' ? null : '#fff',
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit'
  }
}, ownerState.size === 'small' && {
  paddingTop: 21,
  paddingBottom: 4
}, ownerState.hiddenLabel && {
  paddingTop: 16,
  paddingBottom: 17
}, ownerState.multiline && {
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0
}, ownerState.startAdornment && {
  paddingLeft: 0
}, ownerState.endAdornment && {
  paddingRight: 0
}, ownerState.hiddenLabel && ownerState.size === 'small' && {
  paddingTop: 8,
  paddingBottom: 9
}));
const FilledInput = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function FilledInput(inProps, ref) {
  const props = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b5)({
    props: inProps,
    name: 'MuiFilledInput'
  });

  const {
    components = {},
    componentsProps: componentsPropsProp,
    fullWidth = false,
    // declare here to prevent spreading to DOM
    inputComponent = 'input',
    multiline = false,
    type = 'text'
  } = props,
        other = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aT)(props, _excluded$d);

  const ownerState = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, props, {
    fullWidth,
    inputComponent,
    multiline,
    type
  });

  const classes = useUtilityClasses$d(props);
  const filledInputComponentsProps = {
    root: {
      ownerState
    },
    input: {
      ownerState
    }
  };
  const componentsProps = componentsPropsProp ? (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bc)(componentsPropsProp, filledInputComponentsProps) : filledInputComponentsProps;
  return /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bd, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
    components: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
      Root: FilledInputRoot,
      Input: FilledInputInput
    }, components),
    componentsProps: componentsProps,
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other, {
    classes: classes
  }));
});
FilledInput.muiName = 'Input';
var FilledInput$1 = FilledInput;

function getFormControlUtilityClasses(slot) {
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a$)('MuiFormControl', slot);
}
(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b0)('MuiFormControl', ['root', 'marginNone', 'marginNormal', 'marginDense', 'fullWidth', 'disabled']);

const _excluded$c = ["children", "className", "color", "component", "disabled", "error", "focused", "fullWidth", "hiddenLabel", "margin", "required", "size", "variant"];

const useUtilityClasses$c = ownerState => {
  const {
    classes,
    margin,
    fullWidth
  } = ownerState;
  const slots = {
    root: ['root', margin !== 'none' && `margin${(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b4)(margin)}`, fullWidth && 'fullWidth']
  };
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b6)(slots, getFormControlUtilityClasses, classes);
};

const FormControlRoot = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('div', {
  name: 'MuiFormControl',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => {
    return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, styles.root, styles[`margin${(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b4)(ownerState.margin)}`], ownerState.fullWidth && styles.fullWidth);
  }
})(({
  ownerState
}) => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
  display: 'inline-flex',
  flexDirection: 'column',
  position: 'relative',
  // Reset fieldset default style.
  minWidth: 0,
  padding: 0,
  margin: 0,
  border: 0,
  verticalAlign: 'top'
}, ownerState.margin === 'normal' && {
  marginTop: 16,
  marginBottom: 8
}, ownerState.margin === 'dense' && {
  marginTop: 8,
  marginBottom: 4
}, ownerState.fullWidth && {
  width: '100%'
}));
/**
 * Provides context such as filled/focused/error/required for form inputs.
 * Relying on the context provides high flexibility and ensures that the state always stays
 * consistent across the children of the `FormControl`.
 * This context is used by the following components:
 *
 *  - FormLabel
 *  - FormHelperText
 *  - Input
 *  - InputLabel
 *
 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
 *
 * ```jsx
 * <FormControl>
 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
 *   <Input id="my-input" aria-describedby="my-helper-text" />
 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
 * </FormControl>
 * ```
 *
 * ⚠️ Only one `InputBase` can be used within a FormControl because it create visual inconsistencies.
 * For instance, only one input can be focused at the same time, the state shouldn't be shared.
 */

const FormControl = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function FormControl(inProps, ref) {
  const props = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b5)({
    props: inProps,
    name: 'MuiFormControl'
  });

  const {
    children,
    className,
    color = 'primary',
    component = 'div',
    disabled = false,
    error = false,
    focused: visuallyFocused,
    fullWidth = false,
    hiddenLabel = false,
    margin = 'none',
    required = false,
    size = 'medium',
    variant = 'outlined'
  } = props,
        other = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aT)(props, _excluded$c);

  const ownerState = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, props, {
    color,
    component,
    disabled,
    error,
    fullWidth,
    hiddenLabel,
    margin,
    required,
    size,
    variant
  });

  const classes = useUtilityClasses$c(ownerState);
  const [adornedStart, setAdornedStart] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(() => {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    let initialAdornedStart = false;

    if (children) {
      _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Children.forEach(children, child => {
        if (!(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.be)(child, ['Input', 'Select'])) {
          return;
        }

        const input = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.be)(child, ['Select']) ? child.props.input : child;

        if (input && (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bf)(input.props)) {
          initialAdornedStart = true;
        }
      });
    }

    return initialAdornedStart;
  });
  const [filled, setFilled] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(() => {
    // We need to iterate through the children and find the Input in order
    // to fully support server-side rendering.
    let initialFilled = false;

    if (children) {
      _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Children.forEach(children, child => {
        if (!(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.be)(child, ['Input', 'Select'])) {
          return;
        }

        if ((0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bg)(child.props, true)) {
          initialFilled = true;
        }
      });
    }

    return initialFilled;
  });
  const [focusedState, setFocused] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);

  if (disabled && focusedState) {
    setFocused(false);
  }

  const focused = visuallyFocused !== undefined && !disabled ? visuallyFocused : focusedState;
  let registerEffect;

  const onFilled = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
    setFilled(true);
  }, []);
  const onEmpty = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
    setFilled(false);
  }, []);
  const childContext = {
    adornedStart,
    setAdornedStart,
    color,
    disabled,
    error,
    filled,
    focused,
    fullWidth,
    hiddenLabel,
    size,
    onBlur: () => {
      setFocused(false);
    },
    onEmpty,
    onFilled,
    onFocus: () => {
      setFocused(true);
    },
    registerEffect,
    required,
    variant
  };
  return /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bh.Provider, {
    value: childContext,
    children: /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(FormControlRoot, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
      as: component,
      ownerState: ownerState,
      className: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b7)(classes.root, className),
      ref: ref
    }, other, {
      children: children
    }))
  });
});
var FormControl$1 = FormControl;

function getFormLabelUtilityClasses(slot) {
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a$)('MuiFormLabel', slot);
}
const formLabelClasses = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b0)('MuiFormLabel', ['root', 'colorSecondary', 'focused', 'disabled', 'error', 'filled', 'required', 'asterisk']);
var formLabelClasses$1 = formLabelClasses;

const _excluded$b = ["children", "className", "color", "component", "disabled", "error", "filled", "focused", "required"];

const useUtilityClasses$b = ownerState => {
  const {
    classes,
    color,
    focused,
    disabled,
    error,
    filled,
    required
  } = ownerState;
  const slots = {
    root: ['root', `color${(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b4)(color)}`, disabled && 'disabled', error && 'error', filled && 'filled', focused && 'focused', required && 'required'],
    asterisk: ['asterisk', error && 'error']
  };
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b6)(slots, getFormLabelUtilityClasses, classes);
};

const FormLabelRoot = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('label', {
  name: 'MuiFormLabel',
  slot: 'Root',
  overridesResolver: ({
    ownerState
  }, styles) => {
    return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, styles.root, ownerState.color === 'secondary' && styles.colorSecondary, ownerState.filled && styles.filled);
  }
})(({
  theme,
  ownerState
}) => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
  color: theme.palette.text.secondary
}, theme.typography.body1, {
  lineHeight: '1.4375em',
  padding: 0,
  position: 'relative',
  [`&.${formLabelClasses$1.focused}`]: {
    color: theme.palette[ownerState.color].main
  },
  [`&.${formLabelClasses$1.disabled}`]: {
    color: theme.palette.text.disabled
  },
  [`&.${formLabelClasses$1.error}`]: {
    color: theme.palette.error.main
  }
}));
const AsteriskComponent = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('span', {
  name: 'MuiFormLabel',
  slot: 'Asterisk',
  overridesResolver: (props, styles) => styles.asterisk
})(({
  theme
}) => ({
  [`&.${formLabelClasses$1.error}`]: {
    color: theme.palette.error.main
  }
}));
const FormLabel = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function FormLabel(inProps, ref) {
  const props = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b5)({
    props: inProps,
    name: 'MuiFormLabel'
  });

  const {
    children,
    className,
    component = 'label'
  } = props,
        other = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aT)(props, _excluded$b);

  const muiFormControl = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bi)();
  const fcs = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bj)({
    props,
    muiFormControl,
    states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
  });

  const ownerState = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, props, {
    color: fcs.color || 'primary',
    component,
    disabled: fcs.disabled,
    error: fcs.error,
    filled: fcs.filled,
    focused: fcs.focused,
    required: fcs.required
  });

  const classes = useUtilityClasses$b(ownerState);
  return /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsxs(FormLabelRoot, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
    as: component,
    ownerState: ownerState,
    className: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b7)(classes.root, className),
    ref: ref
  }, other, {
    children: [children, fcs.required && /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsxs(AsteriskComponent, {
      ownerState: ownerState,
      "aria-hidden": true,
      className: classes.asterisk,
      children: ["\u2009", '*']
    })]
  }));
});
var FormLabel$1 = FormLabel;

function getInputUtilityClass(slot) {
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a$)('MuiInput', slot);
}
const inputClasses = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b0)('MuiInput', ['root', 'formControl', 'focused', 'disabled', 'colorSecondary', 'underline', 'error', 'sizeSmall', 'multiline', 'fullWidth', 'input', 'inputSizeSmall', 'inputMultiline', 'inputTypeSearch']);
var inputClasses$1 = inputClasses;

const _excluded$a = ["disableUnderline", "components", "componentsProps", "fullWidth", "inputComponent", "multiline", "type"];

const useUtilityClasses$a = ownerState => {
  const {
    classes,
    disableUnderline
  } = ownerState;
  const slots = {
    root: ['root', !disableUnderline && 'underline'],
    input: ['input']
  };
  const composedClasses = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b6)(slots, getInputUtilityClass, classes);
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, classes, composedClasses);
};

const InputRoot = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b8, {
  shouldForwardProp: prop => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b2)(prop) || prop === 'classes',
  name: 'MuiInput',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [...(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b9)(props, styles), !ownerState.disableUnderline && styles.underline];
  }
})(({
  theme,
  ownerState
}) => {
  const light = theme.palette.mode === 'light';
  const bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
    position: 'relative'
  }, ownerState.formControl && {
    'label + &': {
      marginTop: 16
    }
  }, !ownerState.disableUnderline && {
    '&:after': {
      borderBottom: `2px solid ${theme.palette[ownerState.color].main}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '""',
      position: 'absolute',
      right: 0,
      transform: 'scaleX(0)',
      transition: theme.transitions.create('transform', {
        duration: theme.transitions.duration.shorter,
        easing: theme.transitions.easing.easeOut
      }),
      pointerEvents: 'none' // Transparent to the hover style.

    },
    [`&.${inputClasses$1.focused}:after`]: {
      transform: 'scaleX(1)'
    },
    [`&.${inputClasses$1.error}:after`]: {
      borderBottomColor: theme.palette.error.main,
      transform: 'scaleX(1)' // error is always underlined in red

    },
    '&:before': {
      borderBottom: `1px solid ${bottomLineColor}`,
      left: 0,
      bottom: 0,
      // Doing the other way around crash on IE11 "''" https://github.com/cssinjs/jss/issues/242
      content: '"\\00a0"',
      position: 'absolute',
      right: 0,
      transition: theme.transitions.create('border-bottom-color', {
        duration: theme.transitions.duration.shorter
      }),
      pointerEvents: 'none' // Transparent to the hover style.

    },
    [`&:hover:not(.${inputClasses$1.disabled}):before`]: {
      borderBottom: `2px solid ${theme.palette.text.primary}`,
      // Reset on touch devices, it doesn't add specificity
      '@media (hover: none)': {
        borderBottom: `1px solid ${bottomLineColor}`
      }
    },
    [`&.${inputClasses$1.disabled}:before`]: {
      borderBottomStyle: 'dotted'
    }
  });
});
const InputInput = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ba, {
  name: 'MuiInput',
  slot: 'Input',
  overridesResolver: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bb
})({});
const Input = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Input(inProps, ref) {
  const props = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b5)({
    props: inProps,
    name: 'MuiInput'
  });

  const {
    disableUnderline,
    components = {},
    componentsProps: componentsPropsProp,
    fullWidth = false,
    inputComponent = 'input',
    multiline = false,
    type = 'text'
  } = props,
        other = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aT)(props, _excluded$a);

  const classes = useUtilityClasses$a(props);
  const ownerState = {
    disableUnderline
  };
  const inputComponentsProps = {
    root: {
      ownerState
    }
  };
  const componentsProps = componentsPropsProp ? (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bc)(componentsPropsProp, inputComponentsProps) : inputComponentsProps;
  return /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bd, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
    components: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
      Root: InputRoot,
      Input: InputInput
    }, components),
    componentsProps: componentsProps,
    fullWidth: fullWidth,
    inputComponent: inputComponent,
    multiline: multiline,
    ref: ref,
    type: type
  }, other, {
    classes: classes
  }));
});
Input.muiName = 'Input';
var Input$1 = Input;

function getInputLabelUtilityClasses(slot) {
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a$)('MuiInputLabel', slot);
}
(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b0)('MuiInputLabel', ['root', 'focused', 'disabled', 'error', 'required', 'asterisk', 'formControl', 'sizeSmall', 'shrink', 'animated', 'standard', 'filled', 'outlined']);

const _excluded$9 = ["disableAnimation", "margin", "shrink", "variant"];

const useUtilityClasses$9 = ownerState => {
  const {
    classes,
    formControl,
    size,
    shrink,
    disableAnimation,
    variant,
    required
  } = ownerState;
  const slots = {
    root: ['root', formControl && 'formControl', !disableAnimation && 'animated', shrink && 'shrink', size === 'small' && 'sizeSmall', variant],
    asterisk: [required && 'asterisk']
  };
  const composedClasses = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b6)(slots, getInputLabelUtilityClasses, classes);
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, classes, composedClasses);
};

const InputLabelRoot = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(FormLabel$1, {
  shouldForwardProp: prop => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b2)(prop) || prop === 'classes',
  name: 'MuiInputLabel',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [{
      [`& .${formLabelClasses$1.asterisk}`]: styles.asterisk
    }, styles.root, ownerState.formControl && styles.formControl, ownerState.size === 'small' && styles.sizeSmall, ownerState.shrink && styles.shrink, !ownerState.disableAnimation && styles.animated, styles[ownerState.variant]];
  }
})(({
  theme,
  ownerState
}) => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
  display: 'block',
  transformOrigin: 'top left',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  maxWidth: '100%'
}, ownerState.formControl && {
  position: 'absolute',
  left: 0,
  top: 0,
  // slight alteration to spec spacing to match visual spec result
  transform: 'translate(0, 20px) scale(1)'
}, ownerState.size === 'small' && {
  // Compensation for the `Input.inputSizeSmall` style.
  transform: 'translate(0, 17px) scale(1)'
}, ownerState.shrink && {
  transform: 'translate(0, -1.5px) scale(0.75)',
  transformOrigin: 'top left',
  maxWidth: '133%'
}, !ownerState.disableAnimation && {
  transition: theme.transitions.create(['color', 'transform', 'max-width'], {
    duration: theme.transitions.duration.shorter,
    easing: theme.transitions.easing.easeOut
  })
}, ownerState.variant === 'filled' && (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
  // Chrome's autofill feature gives the input field a yellow background.
  // Since the input field is behind the label in the HTML tree,
  // the input field is drawn last and hides the label with an opaque background color.
  // zIndex: 1 will raise the label above opaque background-colors of input.
  zIndex: 1,
  pointerEvents: 'none',
  transform: 'translate(12px, 16px) scale(1)',
  maxWidth: 'calc(100% - 24px)'
}, ownerState.size === 'small' && {
  transform: 'translate(12px, 13px) scale(1)'
}, ownerState.shrink && (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
  transform: 'translate(12px, 7px) scale(0.75)',
  maxWidth: 'calc(133% - 24px)'
}, ownerState.size === 'small' && {
  transform: 'translate(12px, 4px) scale(0.75)'
})), ownerState.variant === 'outlined' && (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
  // see comment above on filled.zIndex
  zIndex: 1,
  pointerEvents: 'none',
  transform: 'translate(14px, 16px) scale(1)',
  maxWidth: 'calc(100% - 24px)'
}, ownerState.size === 'small' && {
  transform: 'translate(14px, 9px) scale(1)'
}, ownerState.shrink && {
  maxWidth: 'calc(133% - 24px)',
  transform: 'translate(14px, -9px) scale(0.75)'
})));
const InputLabel = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function InputLabel(inProps, ref) {
  const props = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b5)({
    name: 'MuiInputLabel',
    props: inProps
  });

  const {
    disableAnimation = false,
    shrink: shrinkProp
  } = props,
        other = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aT)(props, _excluded$9);

  const muiFormControl = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bi)();
  let shrink = shrinkProp;

  if (typeof shrink === 'undefined' && muiFormControl) {
    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
  }

  const fcs = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bj)({
    props,
    muiFormControl,
    states: ['size', 'variant', 'required']
  });

  const ownerState = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, props, {
    disableAnimation,
    formControl: muiFormControl,
    shrink,
    size: fcs.size,
    variant: fcs.variant,
    required: fcs.required
  });

  const classes = useUtilityClasses$9(ownerState);
  return /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(InputLabelRoot, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
    "data-shrink": shrink,
    ownerState: ownerState,
    ref: ref
  }, other, {
    classes: classes
  }));
});
var InputLabel$1 = InputLabel;

function getNativeSelectUtilityClasses(slot) {
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a$)('MuiNativeSelect', slot);
}
const nativeSelectClasses = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b0)('MuiNativeSelect', ['root', 'select', 'filled', 'outlined', 'standard', 'disabled', 'icon', 'iconOpen', 'iconFilled', 'iconOutlined', 'iconStandard', 'nativeInput']);

const _excluded$8 = ["className", "disabled", "IconComponent", "inputRef", "variant"];

const useUtilityClasses$8 = ownerState => {
  const {
    classes,
    variant,
    disabled,
    open
  } = ownerState;
  const slots = {
    select: ['select', variant, disabled && 'disabled'],
    icon: ['icon', `icon${(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b4)(variant)}`, open && 'iconOpen', disabled && 'disabled']
  };
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b6)(slots, getNativeSelectUtilityClasses, classes);
};

const nativeSelectSelectStyles = ({
  ownerState,
  theme
}) => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
  MozAppearance: 'none',
  // Reset
  WebkitAppearance: 'none',
  // Reset
  // When interacting quickly, the text can end up selected.
  // Native select can't be selected either.
  userSelect: 'none',
  borderRadius: 0,
  // Reset
  cursor: 'pointer',
  '&:focus': {
    // Show that it's not an text input
    backgroundColor: theme.palette.mode === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
    borderRadius: 0 // Reset Chrome style

  },
  // Remove IE11 arrow
  '&::-ms-expand': {
    display: 'none'
  },
  [`&.${nativeSelectClasses.disabled}`]: {
    cursor: 'default'
  },
  '&[multiple]': {
    height: 'auto'
  },
  '&:not([multiple]) option, &:not([multiple]) optgroup': {
    backgroundColor: theme.palette.background.paper
  },
  // Bump specificity to allow extending custom inputs
  '&&&': {
    paddingRight: 24,
    minWidth: 16 // So it doesn't collapse.

  }
}, ownerState.variant === 'filled' && {
  '&&&': {
    paddingRight: 32
  }
}, ownerState.variant === 'outlined' && {
  borderRadius: theme.shape.borderRadius,
  '&:focus': {
    borderRadius: theme.shape.borderRadius // Reset the reset for Chrome style

  },
  '&&&': {
    paddingRight: 32
  }
});
const NativeSelectSelect = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('select', {
  name: 'MuiNativeSelect',
  slot: 'Select',
  shouldForwardProp: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b2,
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.select, styles[ownerState.variant]];
  }
})(nativeSelectSelectStyles);
const nativeSelectIconStyles = ({
  ownerState,
  theme
}) => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
  // We use a position absolute over a flexbox in order to forward the pointer events
  // to the input and to support wrapping tags..
  position: 'absolute',
  right: 0,
  top: 'calc(50% - .5em)',
  // Center vertically, height is 1em
  pointerEvents: 'none',
  // Don't block pointer events on the select under the icon.
  color: theme.palette.action.active,
  [`&.${nativeSelectClasses.disabled}`]: {
    color: theme.palette.action.disabled
  }
}, ownerState.open && {
  transform: 'rotate(180deg)'
}, ownerState.variant === 'filled' && {
  right: 7
}, ownerState.variant === 'outlined' && {
  right: 7
});
const NativeSelectIcon = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('svg', {
  name: 'MuiNativeSelect',
  slot: 'Icon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.icon, ownerState.variant && styles[`icon${(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b4)(ownerState.variant)}`], ownerState.open && styles.iconOpen];
  }
})(nativeSelectIconStyles);
/**
 * @ignore - internal component.
 */

const NativeSelectInput = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function NativeSelectInput(props, ref) {
  const {
    className,
    disabled,
    IconComponent,
    inputRef,
    variant = 'standard'
  } = props,
        other = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aT)(props, _excluded$8);

  const ownerState = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, props, {
    disabled,
    variant
  });

  const classes = useUtilityClasses$8(ownerState);
  return /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsxs(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Fragment, {
    children: [/*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(NativeSelectSelect, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
      ownerState: ownerState,
      className: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b7)(classes.select, className),
      disabled: disabled,
      ref: inputRef || ref
    }, other)), props.multiple ? null : /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(NativeSelectIcon, {
      as: IconComponent,
      ownerState: ownerState,
      className: classes.icon
    })]
  });
});
var NativeSelectInput$1 = NativeSelectInput;

function getSelectUtilityClasses(slot) {
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a$)('MuiSelect', slot);
}
const selectClasses = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b0)('MuiSelect', ['root', 'select', 'filled', 'outlined', 'standard', 'disabled', 'focused', 'icon', 'iconOpen', 'iconFilled', 'iconOutlined', 'iconStandard', 'nativeInput']);

const _excluded$7 = ["aria-describedby", "aria-label", "autoFocus", "autoWidth", "children", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "SelectDisplayProps", "tabIndex", "type", "value", "variant"];
const SelectSelect = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('div', {
  name: 'MuiSelect',
  slot: 'Select',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [// Win specificity over the input base
    {
      [`&.${selectClasses.select}`]: styles.select
    }, {
      [`&.${selectClasses.select}`]: styles[ownerState.variant]
    }];
  }
})(nativeSelectSelectStyles, {
  // Win specificity over the input base
  [`&.${selectClasses.select}`]: {
    height: 'auto',
    // Resets for multiple select with chips
    minHeight: '1.4375em',
    // Required for select\text-field height consistency
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden'
  }
});
const SelectIcon = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('svg', {
  name: 'MuiSelect',
  slot: 'Icon',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.icon, ownerState.variant && styles[`icon${(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b4)(ownerState.variant)}`], ownerState.open && styles.iconOpen];
  }
})(nativeSelectIconStyles);
const SelectNativeInput = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('input', {
  shouldForwardProp: prop => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bk)(prop) && prop !== 'classes',
  name: 'MuiSelect',
  slot: 'NativeInput',
  overridesResolver: (props, styles) => styles.nativeInput
})({
  bottom: 0,
  left: 0,
  position: 'absolute',
  opacity: 0,
  pointerEvents: 'none',
  width: '100%',
  boxSizing: 'border-box'
});

function areEqualValues(a, b) {
  if (typeof b === 'object' && b !== null) {
    return a === b;
  } // The value could be a number, the DOM will stringify it anyway.


  return String(a) === String(b);
}

function isEmpty(display) {
  return display == null || typeof display === 'string' && !display.trim();
}

const useUtilityClasses$7 = ownerState => {
  const {
    classes,
    variant,
    disabled,
    open
  } = ownerState;
  const slots = {
    select: ['select', variant, disabled && 'disabled'],
    icon: ['icon', `icon${(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b4)(variant)}`, open && 'iconOpen', disabled && 'disabled'],
    nativeInput: ['nativeInput']
  };
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b6)(slots, getSelectUtilityClasses, classes);
};
/**
 * @ignore - internal component.
 */


const SelectInput = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function SelectInput(props, ref) {
  const {
    'aria-describedby': ariaDescribedby,
    'aria-label': ariaLabel,
    autoFocus,
    autoWidth,
    children,
    className,
    defaultValue,
    disabled,
    displayEmpty,
    IconComponent,
    inputRef: inputRefProp,
    labelId,
    MenuProps = {},
    multiple,
    name,
    onBlur,
    onChange,
    onClose,
    onFocus,
    onOpen,
    open: openProp,
    readOnly,
    renderValue,
    SelectDisplayProps = {},
    tabIndex: tabIndexProp,
    value: valueProp,
    variant = 'standard'
  } = props,
        other = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aT)(props, _excluded$7);

  const [value, setValueState] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bl)({
    controlled: valueProp,
    default: defaultValue,
    name: 'Select'
  });
  const inputRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const displayRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
  const [displayNode, setDisplayNode] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(null);
  const {
    current: isOpenControlled
  } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(openProp != null);
  const [menuMinWidthState, setMenuMinWidthState] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState();
  const [openState, setOpenState] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
  const handleRef = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aU)(ref, inputRefProp);
  const handleDisplayRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(node => {
    displayRef.current = node;

    if (node) {
      setDisplayNode(node);
    }
  }, []);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useImperativeHandle(handleRef, () => ({
    focus: () => {
      displayRef.current.focus();
    },
    node: inputRef.current,
    value
  }), [value]);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    if (autoFocus) {
      displayRef.current.focus();
    }
  }, [autoFocus]);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
    const label = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bm)(displayRef.current).getElementById(labelId);

    if (label) {
      const handler = () => {
        if (getSelection().isCollapsed) {
          displayRef.current.focus();
        }
      };

      label.addEventListener('click', handler);
      return () => {
        label.removeEventListener('click', handler);
      };
    }

    return undefined;
  }, [labelId]);

  const update = (open, event) => {
    if (open) {
      if (onOpen) {
        onOpen(event);
      }
    } else if (onClose) {
      onClose(event);
    }

    if (!isOpenControlled) {
      setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
      setOpenState(open);
    }
  };

  const handleMouseDown = event => {
    // Ignore everything but left-click
    if (event.button !== 0) {
      return;
    } // Hijack the default focus behavior.


    event.preventDefault();
    displayRef.current.focus();
    update(true, event);
  };

  const handleClose = event => {
    update(false, event);
  };

  const childrenArray = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Children.toArray(children); // Support autofill.

  const handleChange = event => {
    const index = childrenArray.map(child => child.props.value).indexOf(event.target.value);

    if (index === -1) {
      return;
    }

    const child = childrenArray[index];
    setValueState(child.props.value);

    if (onChange) {
      onChange(event, child);
    }
  };

  const handleItemClick = child => event => {
    let newValue; // We use the tabindex attribute to signal the available options.

    if (!event.currentTarget.hasAttribute('tabindex')) {
      return;
    }

    if (multiple) {
      newValue = Array.isArray(value) ? value.slice() : [];
      const itemIndex = value.indexOf(child.props.value);

      if (itemIndex === -1) {
        newValue.push(child.props.value);
      } else {
        newValue.splice(itemIndex, 1);
      }
    } else {
      newValue = child.props.value;
    }

    if (child.props.onClick) {
      child.props.onClick(event);
    }

    if (value !== newValue) {
      setValueState(newValue);

      if (onChange) {
        // Redefine target to allow name and value to be read.
        // This allows seamless integration with the most popular form libraries.
        // https://github.com/mui-org/material-ui/issues/13485#issuecomment-676048492
        // Clone the event to not override `target` of the original event.
        const nativeEvent = event.nativeEvent || event;
        const clonedEvent = new nativeEvent.constructor(nativeEvent.type, nativeEvent);
        Object.defineProperty(clonedEvent, 'target', {
          writable: true,
          value: {
            value: newValue,
            name
          }
        });
        onChange(clonedEvent, child);
      }
    }

    if (!multiple) {
      update(false, event);
    }
  };

  const handleKeyDown = event => {
    if (!readOnly) {
      const validKeys = [' ', 'ArrowUp', 'ArrowDown', // The native select doesn't respond to enter on MacOS, but it's recommended by
      // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
      'Enter'];

      if (validKeys.indexOf(event.key) !== -1) {
        event.preventDefault();
        update(true, event);
      }
    }
  };

  const open = displayNode !== null && (isOpenControlled ? openProp : openState);

  const handleBlur = event => {
    // if open event.stopImmediatePropagation
    if (!open && onBlur) {
      // Preact support, target is read only property on a native event.
      Object.defineProperty(event, 'target', {
        writable: true,
        value: {
          value,
          name
        }
      });
      onBlur(event);
    }
  };

  delete other['aria-invalid'];
  let display;
  let displaySingle;
  const displayMultiple = [];
  let computeDisplay = false;

  if ((0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bg)({
    value
  }) || displayEmpty) {
    if (renderValue) {
      display = renderValue(value);
    } else {
      computeDisplay = true;
    }
  }

  const items = childrenArray.map(child => {
    if (! /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.isValidElement(child)) {
      return null;
    }

    let selected;

    if (multiple) {
      if (!Array.isArray(value)) {
        throw new Error((0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bn)(2));
      }

      selected = value.some(v => areEqualValues(v, child.props.value));

      if (selected && computeDisplay) {
        displayMultiple.push(child.props.children);
      }
    } else {
      selected = areEqualValues(value, child.props.value);

      if (selected && computeDisplay) {
        displaySingle = child.props.children;
      }
    }

    return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(child, {
      'aria-selected': selected ? 'true' : undefined,
      onClick: handleItemClick(child),
      onKeyUp: event => {
        if (event.key === ' ') {
          // otherwise our MenuItems dispatches a click event
          // it's not behavior of the native <option> and causes
          // the select to close immediately since we open on space keydown
          event.preventDefault();
        }

        if (child.props.onKeyUp) {
          child.props.onKeyUp(event);
        }
      },
      role: 'option',
      selected,
      value: undefined,
      // The value is most likely not a valid HTML attribute.
      'data-value': child.props.value // Instead, we provide it as a data attribute.

    });
  });

  if (computeDisplay) {
    display = multiple ? displayMultiple.join(', ') : displaySingle;
  } // Avoid performing a layout computation in the render method.


  let menuMinWidth = menuMinWidthState;

  if (!autoWidth && isOpenControlled && displayNode) {
    menuMinWidth = displayNode.clientWidth;
  }

  let tabIndex;

  if (typeof tabIndexProp !== 'undefined') {
    tabIndex = tabIndexProp;
  } else {
    tabIndex = disabled ? null : 0;
  }

  const buttonId = SelectDisplayProps.id || (name ? `mui-component-select-${name}` : undefined);

  const ownerState = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, props, {
    variant,
    value,
    open
  });

  const classes = useUtilityClasses$7(ownerState);
  return /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsxs(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Fragment, {
    children: [/*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(SelectSelect, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
      ref: handleDisplayRef,
      tabIndex: tabIndex,
      role: "button",
      "aria-disabled": disabled ? 'true' : undefined,
      "aria-expanded": open ? 'true' : 'false',
      "aria-haspopup": "listbox",
      "aria-label": ariaLabel,
      "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
      "aria-describedby": ariaDescribedby,
      onKeyDown: handleKeyDown,
      onMouseDown: disabled || readOnly ? null : handleMouseDown,
      onBlur: handleBlur,
      onFocus: onFocus
    }, SelectDisplayProps, {
      ownerState: ownerState,
      className: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b7)(classes.select, className, SelectDisplayProps.className) // The id is required for proper a11y
      ,
      id: buttonId,
      children: isEmpty(display) ?
      /*#__PURE__*/
      // notranslate needed while Google Translate will not fix zero-width space issue
      // eslint-disable-next-line react/no-danger
      _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx("span", {
        className: "notranslate",
        dangerouslySetInnerHTML: {
          __html: '&#8203;'
        }
      }) : display
    })), /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(SelectNativeInput, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
      value: Array.isArray(value) ? value.join(',') : value,
      name: name,
      ref: inputRef,
      "aria-hidden": true,
      onChange: handleChange,
      tabIndex: -1,
      disabled: disabled,
      className: classes.nativeInput,
      autoFocus: autoFocus,
      ownerState: ownerState
    }, other)), /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(SelectIcon, {
      as: IconComponent,
      className: classes.icon,
      ownerState: ownerState
    }), /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bo, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
      id: `menu-${name || ''}`,
      anchorEl: displayNode,
      open: open,
      onClose: handleClose,
      anchorOrigin: {
        vertical: 'bottom',
        horizontal: 'center'
      },
      transformOrigin: {
        vertical: 'top',
        horizontal: 'center'
      }
    }, MenuProps, {
      MenuListProps: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
        'aria-labelledby': labelId,
        role: 'listbox',
        disableListWrap: true
      }, MenuProps.MenuListProps),
      PaperProps: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, MenuProps.PaperProps, {
        style: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
          minWidth: menuMinWidth
        }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
      }),
      children: items
    }))]
  });
});
var SelectInput$1 = SelectInput;

var _Input, _FilledInput;

const _excluded$6 = ["autoWidth", "children", "classes", "className", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"],
      _excluded2 = ["root"];

const useUtilityClasses$6 = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b6)(slots, getSelectUtilityClasses, classes);
};

const Select = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Select(inProps, ref) {
  const props = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b5)({
    name: 'MuiSelect',
    props: inProps
  });

  const {
    autoWidth = false,
    children,
    classes: classesProp = {},
    className,
    displayEmpty = false,
    IconComponent = ArrowDropDownIcon,
    id,
    input,
    inputProps,
    label,
    labelId,
    MenuProps,
    multiple = false,
    native = false,
    onClose,
    onOpen,
    open,
    renderValue,
    SelectDisplayProps,
    variant: variantProps = 'outlined'
  } = props,
        other = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aT)(props, _excluded$6);

  const inputComponent = native ? NativeSelectInput$1 : SelectInput$1;
  const muiFormControl = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bi)();
  const fcs = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bj)({
    props,
    muiFormControl,
    states: ['variant']
  });
  const variant = fcs.variant || variantProps;
  const InputComponent = input || {
    standard: _Input || (_Input = /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(Input$1, {})),
    outlined: /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bp, {
      label: label
    }),
    filled: _FilledInput || (_FilledInput = /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(FilledInput$1, {}))
  }[variant];

  const ownerState = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, props, {
    classes: classesProp
  });

  const classes = useUtilityClasses$6(ownerState);

  const otherClasses = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aT)(classesProp, _excluded2);

  const inputComponentRef = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aU)(ref, InputComponent.ref);
  return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(InputComponent, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
    // Most of the logic is implemented in `SelectInput`.
    // The `Select` component is a simple API wrapper to expose something better to play with.
    inputComponent,
    inputProps: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
      children,
      IconComponent,
      variant,
      type: undefined,
      // We render a select. We can ignore the type provided by the `Input`.
      multiple
    }, native ? {
      id
    } : {
      autoWidth,
      displayEmpty,
      labelId,
      MenuProps,
      onClose,
      onOpen,
      open,
      renderValue,
      SelectDisplayProps: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
        id
      }, SelectDisplayProps)
    }, inputProps, {
      classes: inputProps ? (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bc)(otherClasses, inputProps.classes) : otherClasses
    }, input ? input.props.inputProps : {})
  }, multiple && native && variant === 'outlined' ? {
    notched: true
  } : {}, {
    ref: inputComponentRef,
    className: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b7)(classes.root, InputComponent.props.className, className)
  }, other));
});
Select.muiName = 'Select';
var Select$1 = Select;

/**
 * @ignore - internal component.
 */

const StepperContext = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createContext({});

var StepperContext$1 = StepperContext;

/**
 * @ignore - internal component.
 */

const StepContext = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createContext({});

var StepContext$1 = StepContext;

function getStepUtilityClass(slot) {
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a$)('MuiStep', slot);
}
(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b0)('MuiStep', ['root', 'horizontal', 'vertical', 'alternativeLabel', 'completed']);

const _excluded$5 = ["active", "children", "className", "completed", "disabled", "expanded", "index", "last"];

const useUtilityClasses$5 = ownerState => {
  const {
    classes,
    orientation,
    alternativeLabel,
    completed
  } = ownerState;
  const slots = {
    root: ['root', orientation, alternativeLabel && 'alternativeLabel', completed && 'completed']
  };
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b6)(slots, getStepUtilityClass, classes);
};

const StepRoot = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('div', {
  name: 'MuiStep',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.orientation], ownerState.alternativeLabel && styles.alternativeLabel, ownerState.completed && styles.completed];
  }
})(({
  ownerState
}) => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, ownerState.orientation === 'horizontal' && {
  paddingLeft: 8,
  paddingRight: 8
}, ownerState.alternativeLabel && {
  flex: 1,
  position: 'relative'
}));
const Step = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Step(inProps, ref) {
  const props = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b5)({
    props: inProps,
    name: 'MuiStep'
  });

  const {
    active: activeProp,
    children,
    className,
    completed: completedProp,
    disabled: disabledProp,
    expanded = false,
    index,
    last
  } = props,
        other = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aT)(props, _excluded$5);

  const {
    activeStep,
    connector,
    alternativeLabel,
    orientation,
    nonLinear
  } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(StepperContext$1);
  let [active = false, completed = false, disabled = false] = [activeProp, completedProp, disabledProp];

  if (activeStep === index) {
    active = activeProp !== undefined ? activeProp : true;
  } else if (!nonLinear && activeStep > index) {
    completed = completedProp !== undefined ? completedProp : true;
  } else if (!nonLinear && activeStep < index) {
    disabled = disabledProp !== undefined ? disabledProp : true;
  }

  const contextValue = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
    index,
    last,
    expanded,
    icon: index + 1,
    active,
    completed,
    disabled
  }), [index, last, expanded, active, completed, disabled]);

  const ownerState = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, props, {
    active,
    orientation,
    alternativeLabel,
    completed,
    disabled,
    expanded
  });

  const classes = useUtilityClasses$5(ownerState);

  const newChildren = /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsxs(StepRoot, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
    className: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b7)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: [connector && alternativeLabel && index !== 0 ? connector : null, children]
  }));

  return /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(StepContext$1.Provider, {
    value: contextValue,
    children: connector && !alternativeLabel && index !== 0 ? /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsxs(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Fragment, {
      children: [connector, newChildren]
    }) : newChildren
  });
});
var Step$1 = Step;

var CheckCircle = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aP)( /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx("path", {
  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
}), 'CheckCircle');

var Warning = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aP)( /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx("path", {
  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
}), 'Warning');

function getStepIconUtilityClass(slot) {
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a$)('MuiStepIcon', slot);
}
const stepIconClasses = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b0)('MuiStepIcon', ['root', 'active', 'completed', 'error', 'text']);
var stepIconClasses$1 = stepIconClasses;

var _circle;

const _excluded$4 = ["active", "className", "completed", "error", "icon"];

const useUtilityClasses$4 = ownerState => {
  const {
    classes,
    active,
    completed,
    error
  } = ownerState;
  const slots = {
    root: ['root', active && 'active', completed && 'completed', error && 'error'],
    text: ['text']
  };
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b6)(slots, getStepIconUtilityClass, classes);
};

const StepIconRoot = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ak, {
  name: 'MuiStepIcon',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})(({
  theme
}) => ({
  display: 'block',
  transition: theme.transitions.create('color', {
    duration: theme.transitions.duration.shortest
  }),
  color: theme.palette.text.disabled,
  [`&.${stepIconClasses$1.completed}`]: {
    color: theme.palette.primary.main
  },
  [`&.${stepIconClasses$1.active}`]: {
    color: theme.palette.primary.main
  },
  [`&.${stepIconClasses$1.error}`]: {
    color: theme.palette.error.main
  }
}));
const StepIconText = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('text', {
  name: 'MuiStepIcon',
  slot: 'Text',
  overridesResolver: (props, styles) => styles.text
})(({
  theme
}) => ({
  fill: theme.palette.primary.contrastText,
  fontSize: theme.typography.caption.fontSize,
  fontFamily: theme.typography.fontFamily
}));
const StepIcon = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function StepIcon(inProps, ref) {
  const props = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b5)({
    props: inProps,
    name: 'MuiStepIcon'
  });

  const {
    active = false,
    className: classNameProp,
    completed = false,
    error = false,
    icon
  } = props,
        other = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aT)(props, _excluded$4);

  const ownerState = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, props, {
    active,
    completed,
    error
  });

  const classes = useUtilityClasses$4(ownerState);

  if (typeof icon === 'number' || typeof icon === 'string') {
    const className = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b7)(classNameProp, classes.root);

    if (error) {
      return /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(StepIconRoot, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
        as: Warning,
        className: className,
        ref: ref,
        ownerState: ownerState
      }, other));
    }

    if (completed) {
      return /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(StepIconRoot, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
        as: CheckCircle,
        className: className,
        ref: ref,
        ownerState: ownerState
      }, other));
    }

    return /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsxs(StepIconRoot, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
      className: className,
      ref: ref,
      ownerState: ownerState
    }, other, {
      children: [_circle || (_circle = /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx("circle", {
        cx: "12",
        cy: "12",
        r: "12"
      })), /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(StepIconText, {
        className: classes.text,
        x: "12",
        y: "16",
        textAnchor: "middle",
        ownerState: ownerState,
        children: icon
      })]
    }));
  }

  return icon;
});
var StepIcon$1 = StepIcon;

function getStepLabelUtilityClass(slot) {
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a$)('MuiStepLabel', slot);
}
const stepLabelClasses = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b0)('MuiStepLabel', ['root', 'horizontal', 'vertical', 'label', 'active', 'completed', 'error', 'disabled', 'iconContainer', 'alternativeLabel', 'labelContainer']);
var stepLabelClasses$1 = stepLabelClasses;

const _excluded$3 = ["children", "className", "componentsProps", "error", "icon", "optional", "StepIconComponent", "StepIconProps"];

const useUtilityClasses$3 = ownerState => {
  const {
    classes,
    orientation,
    active,
    completed,
    error,
    disabled,
    alternativeLabel
  } = ownerState;
  const slots = {
    root: ['root', orientation, error && 'error', disabled && 'disabled', alternativeLabel && 'alternativeLabel'],
    label: ['label', active && 'active', completed && 'completed', error && 'error', disabled && 'disabled', alternativeLabel && 'alternativeLabel'],
    iconContainer: ['iconContainer', alternativeLabel && 'alternativeLabel'],
    labelContainer: ['labelContainer']
  };
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b6)(slots, getStepLabelUtilityClass, classes);
};

const StepLabelRoot = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('span', {
  name: 'MuiStepLabel',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.orientation]];
  }
})(({
  ownerState
}) => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
  display: 'flex',
  alignItems: 'center',
  [`&.${stepLabelClasses$1.alternativeLabel}`]: {
    flexDirection: 'column'
  },
  [`&.${stepLabelClasses$1.disabled}`]: {
    cursor: 'default'
  }
}, ownerState.orientation === 'vertical' && {
  textAlign: 'left',
  padding: '8px 0'
}));
const StepLabelLabel = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('span', {
  name: 'MuiStepLabel',
  slot: 'Label',
  overridesResolver: (props, styles) => styles.label
})(({
  theme
}) => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, theme.typography.body2, {
  display: 'block',
  transition: theme.transitions.create('color', {
    duration: theme.transitions.duration.shortest
  }),
  [`&.${stepLabelClasses$1.active}`]: {
    color: theme.palette.text.primary,
    fontWeight: 500
  },
  [`&.${stepLabelClasses$1.completed}`]: {
    color: theme.palette.text.primary,
    fontWeight: 500
  },
  [`&.${stepLabelClasses$1.alternativeLabel}`]: {
    textAlign: 'center',
    marginTop: 16
  },
  [`&.${stepLabelClasses$1.error}`]: {
    color: theme.palette.error.main
  }
}));
const StepLabelIconContainer = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('span', {
  name: 'MuiStepLabel',
  slot: 'IconContainer',
  overridesResolver: (props, styles) => styles.iconContainer
})(() => ({
  flexShrink: 0,
  // Fix IE11 issue
  display: 'flex',
  paddingRight: 8,
  [`&.${stepLabelClasses$1.alternativeLabel}`]: {
    paddingRight: 0
  }
}));
const StepLabelLabelContainer = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('span', {
  name: 'MuiStepLabel',
  slot: 'LabelContainer',
  overridesResolver: (props, styles) => styles.labelContainer
})(({
  theme
}) => ({
  width: '100%',
  color: theme.palette.text.secondary
}));
const StepLabel = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function StepLabel(inProps, ref) {
  const props = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b5)({
    props: inProps,
    name: 'MuiStepLabel'
  });

  const {
    children,
    className,
    componentsProps = {},
    error = false,
    icon: iconProp,
    optional,
    StepIconComponent: StepIconComponentProp,
    StepIconProps
  } = props,
        other = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aT)(props, _excluded$3);

  const {
    alternativeLabel,
    orientation
  } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(StepperContext$1);
  const {
    active,
    disabled,
    completed,
    icon: iconContext
  } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(StepContext$1);
  const icon = iconProp || iconContext;
  let StepIconComponent = StepIconComponentProp;

  if (icon && !StepIconComponent) {
    StepIconComponent = StepIcon$1;
  }

  const ownerState = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, props, {
    active,
    alternativeLabel,
    completed,
    disabled,
    error,
    orientation
  });

  const classes = useUtilityClasses$3(ownerState);
  return /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsxs(StepLabelRoot, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
    className: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b7)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: [icon || StepIconComponent ? /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(StepLabelIconContainer, {
      className: classes.iconContainer,
      ownerState: ownerState,
      children: /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(StepIconComponent, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
        completed: completed,
        active: active,
        error: error,
        icon: icon
      }, StepIconProps))
    }) : null, /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsxs(StepLabelLabelContainer, {
      className: classes.labelContainer,
      ownerState: ownerState,
      children: [children ? /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(StepLabelLabel, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
        className: classes.label,
        ownerState: ownerState
      }, componentsProps.label, {
        children: children
      })) : null, optional]
    })]
  }));
});
StepLabel.muiName = 'StepLabel';
var StepLabel$1 = StepLabel;

function getStepConnectorUtilityClass(slot) {
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a$)('MuiStepConnector', slot);
}
(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b0)('MuiStepConnector', ['root', 'horizontal', 'vertical', 'alternativeLabel', 'active', 'completed', 'disabled', 'line', 'lineHorizontal', 'lineVertical']);

const _excluded$2 = ["className"];

const useUtilityClasses$2 = ownerState => {
  const {
    classes,
    orientation,
    alternativeLabel,
    active,
    completed,
    disabled
  } = ownerState;
  const slots = {
    root: ['root', orientation, alternativeLabel && 'alternativeLabel', active && 'active', completed && 'completed', disabled && 'disabled'],
    line: ['line', `line${(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b4)(orientation)}`]
  };
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b6)(slots, getStepConnectorUtilityClass, classes);
};

const StepConnectorRoot = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('div', {
  name: 'MuiStepConnector',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.orientation], ownerState.alternativeLabel && styles.alternativeLabel, ownerState.completed && styles.completed];
  }
})(({
  ownerState
}) => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
  flex: '1 1 auto'
}, ownerState.orientation === 'vertical' && {
  marginLeft: 12 // half icon

}, ownerState.alternativeLabel && {
  position: 'absolute',
  top: 8 + 4,
  left: 'calc(-50% + 20px)',
  right: 'calc(50% + 20px)'
}));
const StepConnectorLine = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('span', {
  name: 'MuiStepConnector',
  slot: 'Line',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.line, styles[`line${(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b4)(ownerState.orientation)}`]];
  }
})(({
  ownerState,
  theme
}) => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
  display: 'block',
  borderColor: theme.palette.mode === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
}, ownerState.orientation === 'horizontal' && {
  borderTopStyle: 'solid',
  borderTopWidth: 1
}, ownerState.orientation === 'vertical' && {
  borderLeftStyle: 'solid',
  borderLeftWidth: 1,
  minHeight: 24
}));
const StepConnector = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function StepConnector(inProps, ref) {
  const props = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b5)({
    props: inProps,
    name: 'MuiStepConnector'
  });

  const {
    className
  } = props,
        other = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aT)(props, _excluded$2);

  const {
    alternativeLabel,
    orientation = 'horizontal'
  } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(StepperContext$1);
  const {
    active,
    disabled,
    completed
  } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(StepContext$1);

  const ownerState = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, props, {
    alternativeLabel,
    orientation,
    active,
    completed,
    disabled
  });

  const classes = useUtilityClasses$2(ownerState);
  return /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(StepConnectorRoot, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
    className: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b7)(classes.root, className),
    ref: ref,
    ownerState: ownerState
  }, other, {
    children: /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(StepConnectorLine, {
      className: classes.line,
      ownerState: ownerState
    })
  }));
});
var StepConnector$1 = StepConnector;

function getStepperUtilityClass(slot) {
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a$)('MuiStepper', slot);
}
(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b0)('MuiStepper', ['root', 'horizontal', 'vertical', 'alternativeLabel']);

const _excluded$1 = ["activeStep", "alternativeLabel", "children", "className", "connector", "nonLinear", "orientation"];

const useUtilityClasses$1 = ownerState => {
  const {
    orientation,
    alternativeLabel,
    classes
  } = ownerState;
  const slots = {
    root: ['root', orientation, alternativeLabel && 'alternativeLabel']
  };
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b6)(slots, getStepperUtilityClass, classes);
};

const StepperRoot = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('div', {
  name: 'MuiStepper',
  slot: 'Root',
  overridesResolver: (props, styles) => {
    const {
      ownerState
    } = props;
    return [styles.root, styles[ownerState.orientation], ownerState.alternativeLabel && styles.alternativeLabel];
  }
})(({
  ownerState
}) => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
  display: 'flex'
}, ownerState.orientation === 'horizontal' && {
  flexDirection: 'row',
  alignItems: 'center'
}, ownerState.orientation === 'vertical' && {
  flexDirection: 'column'
}, ownerState.alternativeLabel && {
  alignItems: 'flex-start'
}));

const defaultConnector = /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(StepConnector$1, {});

const Stepper = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function Stepper(inProps, ref) {
  const props = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b5)({
    props: inProps,
    name: 'MuiStepper'
  });

  const {
    activeStep = 0,
    alternativeLabel = false,
    children,
    className,
    connector = defaultConnector,
    nonLinear = false,
    orientation = 'horizontal'
  } = props,
        other = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aT)(props, _excluded$1);

  const ownerState = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, props, {
    alternativeLabel,
    orientation
  });

  const classes = useUtilityClasses$1(ownerState);
  const childrenArray = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Children.toArray(children).filter(Boolean);
  const steps = childrenArray.map((step, index) => {
    return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.cloneElement(step, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
      index,
      last: index + 1 === childrenArray.length
    }, step.props));
  });
  const contextValue = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
    activeStep,
    alternativeLabel,
    connector,
    nonLinear,
    orientation
  }), [activeStep, alternativeLabel, connector, nonLinear, orientation]);
  return /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(StepperContext$1.Provider, {
    value: contextValue,
    children: /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(StepperRoot, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
      ownerState: ownerState,
      className: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b7)(classes.root, className),
      ref: ref
    }, other, {
      children: steps
    }))
  });
});
var Stepper$1 = Stepper;

function getTextFieldUtilityClass(slot) {
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a$)('MuiTextField', slot);
}
(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b0)('MuiTextField', ['root']);

const _excluded = ["autoComplete", "autoFocus", "children", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "maxRows", "minRows", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "select", "SelectProps", "type", "value", "variant"];
const variantComponent = {
  standard: Input$1,
  filled: FilledInput$1,
  outlined: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bp
};

const useUtilityClasses = ownerState => {
  const {
    classes
  } = ownerState;
  const slots = {
    root: ['root']
  };
  return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b6)(slots, getTextFieldUtilityClass, classes);
};

const TextFieldRoot = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(FormControl$1, {
  name: 'MuiTextField',
  slot: 'Root',
  overridesResolver: (props, styles) => styles.root
})({});
/**
 * The `TextField` is a convenience wrapper for the most common cases (80%).
 * It cannot be all things to all people, otherwise the API would grow out of control.
 *
 * ## Advanced Configuration
 *
 * It's important to understand that the text field is a simple abstraction
 * on top of the following components:
 *
 * - [FormControl](/api/form-control/)
 * - [InputLabel](/api/input-label/)
 * - [FilledInput](/api/filled-input/)
 * - [OutlinedInput](/api/outlined-input/)
 * - [Input](/api/input/)
 * - [FormHelperText](/api/form-helper-text/)
 *
 * If you wish to alter the props applied to the `input` element, you can do so as follows:
 *
 * ```jsx
 * const inputProps = {
 *   step: 300,
 * };
 *
 * return <TextField id="time" type="time" inputProps={inputProps} />;
 * ```
 *
 * For advanced cases, please look at the source of TextField by clicking on the
 * "Edit this page" button above. Consider either:
 *
 * - using the upper case props for passing values directly to the components
 * - using the underlying components directly as shown in the demos
 */

const TextField = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(function TextField(inProps, ref) {
  const props = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b5)({
    props: inProps,
    name: 'MuiTextField'
  });

  const {
    autoComplete,
    autoFocus = false,
    children,
    className,
    color = 'primary',
    defaultValue,
    disabled = false,
    error = false,
    FormHelperTextProps,
    fullWidth = false,
    helperText,
    id,
    InputLabelProps,
    inputProps,
    InputProps,
    inputRef,
    label,
    maxRows,
    minRows,
    multiline = false,
    name,
    onBlur,
    onChange,
    onFocus,
    placeholder,
    required = false,
    rows,
    select = false,
    SelectProps,
    type,
    value,
    variant = 'outlined'
  } = props,
        other = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aT)(props, _excluded);

  const ownerState = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({}, props, {
    autoFocus,
    color,
    disabled,
    error,
    fullWidth,
    multiline,
    required,
    select,
    variant
  });

  const classes = useUtilityClasses(ownerState);

  const InputMore = {};

  if (variant === 'outlined') {
    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
      InputMore.notched = InputLabelProps.shrink;
    }

    if (label) {
      var _InputLabelProps$requ;

      const displayRequired = (_InputLabelProps$requ = InputLabelProps == null ? void 0 : InputLabelProps.required) != null ? _InputLabelProps$requ : required;
      InputMore.label = /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsxs(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Fragment, {
        children: [label, displayRequired && '\u00a0*']
      });
    }
  }

  if (select) {
    // unset defaults from textbox inputs
    if (!SelectProps || !SelectProps.native) {
      InputMore.id = undefined;
    }

    InputMore['aria-describedby'] = undefined;
  }

  const helperTextId = helperText && id ? `${id}-helper-text` : undefined;
  const inputLabelId = label && id ? `${id}-label` : undefined;
  const InputComponent = variantComponent[variant];

  const InputElement = /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(InputComponent, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
    "aria-describedby": helperTextId,
    autoComplete: autoComplete,
    autoFocus: autoFocus,
    defaultValue: defaultValue,
    fullWidth: fullWidth,
    multiline: multiline,
    name: name,
    rows: rows,
    maxRows: maxRows,
    minRows: minRows,
    type: type,
    value: value,
    id: id,
    inputRef: inputRef,
    onBlur: onBlur,
    onChange: onChange,
    onFocus: onFocus,
    placeholder: placeholder,
    inputProps: inputProps
  }, InputMore, InputProps));

  return /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsxs(TextFieldRoot, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
    className: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b7)(classes.root, className),
    disabled: disabled,
    error: error,
    fullWidth: fullWidth,
    ref: ref,
    required: required,
    color: color,
    variant: variant,
    ownerState: ownerState
  }, other, {
    children: [label && /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(InputLabel$1, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
      htmlFor: id,
      id: inputLabelId
    }, InputLabelProps, {
      children: label
    })), select ? /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(Select$1, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
      "aria-describedby": helperTextId,
      id: id,
      labelId: inputLabelId,
      value: value,
      input: InputElement
    }, SelectProps, {
      children: children
    })) : InputElement, helperText && /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aI, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aX)({
      id: helperTextId
    }, FormHelperTextProps, {
      children: helperText
    }))]
  }));
});
var TextField$1 = TextField;

var ManageAccounts = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aP)([/*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx("circle", {
  cx: "10",
  cy: "8",
  r: "4"
}, "0"), /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx("path", {
  d: "M10.67 13.02c-.22-.01-.44-.02-.67-.02-2.42 0-4.68.67-6.61 1.82-.88.52-1.39 1.5-1.39 2.53V20h9.26c-.79-1.13-1.26-2.51-1.26-4 0-1.07.25-2.07.67-2.98zM20.75 16c0-.22-.03-.42-.06-.63l1.14-1.01-1-1.73-1.45.49c-.32-.27-.68-.48-1.08-.63L18 11h-2l-.3 1.49c-.4.15-.76.36-1.08.63l-1.45-.49-1 1.73 1.14 1.01c-.03.21-.06.41-.06.63s.03.42.06.63l-1.14 1.01 1 1.73 1.45-.49c.32.27.68.48 1.08.63L16 21h2l.3-1.49c.4-.15.76-.36 1.08-.63l1.45.49 1-1.73-1.14-1.01c.03-.21.06-.41.06-.63zM17 18c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z"
}, "1")], 'ManageAccounts');

var TuneRounded = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aP)( /*#__PURE__*/_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports.jsx("path", {
  d: "M3 18c0 .55.45 1 1 1h5v-2H4c-.55 0-1 .45-1 1zM3 6c0 .55.45 1 1 1h9V5H4c-.55 0-1 .45-1 1zm10 14v-1h7c.55 0 1-.45 1-1s-.45-1-1-1h-7v-1c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1s1-.45 1-1zM7 10v1H4c-.55 0-1 .45-1 1s.45 1 1 1h3v1c0 .55.45 1 1 1s1-.45 1-1v-4c0-.55-.45-1-1-1s-1 .45-1 1zm14 2c0-.55-.45-1-1-1h-9v2h9c.55 0 1-.45 1-1zm-5-3c.55 0 1-.45 1-1V7h3c.55 0 1-.45 1-1s-.45-1-1-1h-3V4c0-.55-.45-1-1-1s-1 .45-1 1v4c0 .55.45 1 1 1z"
}), 'TuneRounded');

function _extends$3() { _extends$3 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
function create(type) {
  return new ArraySchema(type);
}
class ArraySchema extends _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bq {
  constructor(type) {
    super({
      type: 'array'
    }); // `undefined` specifically means uninitialized, as opposed to
    // "no subtype"

    this.innerType = type;
    this.withMutation(() => {
      this.transform(function (values) {
        if (typeof values === 'string') try {
          values = JSON.parse(values);
        } catch (err) {
          values = null;
        }
        return this.isType(values) ? values : null;
      });
    });
  }

  _typeCheck(v) {
    return Array.isArray(v);
  }

  get _subType() {
    return this.innerType;
  }

  _cast(_value, _opts) {
    const value = super._cast(_value, _opts); //should ignore nulls here


    if (!this._typeCheck(value) || !this.innerType) return value;
    let isChanged = false;
    const castArray = value.map((v, idx) => {
      const castElement = this.innerType.cast(v, _extends$3({}, _opts, {
        path: `${_opts.path || ''}[${idx}]`
      }));

      if (castElement !== v) {
        isChanged = true;
      }

      return castElement;
    });
    return isChanged ? castArray : value;
  }

  _validate(_value, options = {}, callback) {
    var _options$abortEarly, _options$recursive;

    let errors = [];
    let sync = options.sync;
    let path = options.path;
    let innerType = this.innerType;
    let endEarly = (_options$abortEarly = options.abortEarly) != null ? _options$abortEarly : this.spec.abortEarly;
    let recursive = (_options$recursive = options.recursive) != null ? _options$recursive : this.spec.recursive;
    let originalValue = options.originalValue != null ? options.originalValue : _value;

    super._validate(_value, options, (err, value) => {
      if (err) {
        if (!_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.br.isError(err) || endEarly) {
          return void callback(err, value);
        }

        errors.push(err);
      }

      if (!recursive || !innerType || !this._typeCheck(value)) {
        callback(errors[0] || null, value);
        return;
      }

      originalValue = originalValue || value; // #950 Ensure that sparse array empty slots are validated

      let tests = new Array(value.length);

      for (let idx = 0; idx < value.length; idx++) {
        let item = value[idx];
        let path = `${options.path || ''}[${idx}]`; // object._validate note for isStrict explanation

        let innerOptions = _extends$3({}, options, {
          path,
          strict: true,
          parent: value,
          index: idx,
          originalValue: originalValue[idx]
        });

        tests[idx] = (_, cb) => innerType.validate(item, innerOptions, cb);
      }

      (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bs)({
        sync,
        path,
        value,
        errors,
        endEarly,
        tests
      }, callback);
    });
  }

  clone(spec) {
    const next = super.clone(spec);
    next.innerType = this.innerType;
    return next;
  }

  concat(schema) {
    let next = super.concat(schema);
    next.innerType = this.innerType;
    if (schema.innerType) next.innerType = next.innerType ? // @ts-expect-error Lazy doesn't have concat()
    next.innerType.concat(schema.innerType) : schema.innerType;
    return next;
  }

  of(schema) {
    // FIXME: this should return a new instance of array without the default to be
    let next = this.clone();
    if (!(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bt)(schema)) throw new TypeError('`array.of()` sub-schema must be a valid yup schema not: ' + (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bu)(schema)); // FIXME(ts):

    next.innerType = schema;
    return next;
  }

  length(length, message = _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bv.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },

      test(value) {
        return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bw)(value) || value.length === this.resolve(length);
      }

    });
  }

  min(min, message) {
    message = message || _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bv.min;
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      // FIXME(ts): Array<typeof T>
      test(value) {
        return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bw)(value) || value.length >= this.resolve(min);
      }

    });
  }

  max(max, message) {
    message = message || _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bv.max;
    return this.test({
      message,
      name: 'max',
      exclusive: true,
      params: {
        max
      },

      test(value) {
        return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bw)(value) || value.length <= this.resolve(max);
      }

    });
  }

  ensure() {
    return this.default(() => []).transform((val, original) => {
      // We don't want to return `null` for nullable schema
      if (this._typeCheck(val)) return val;
      return original == null ? [] : [].concat(original);
    });
  }

  compact(rejector) {
    let reject = !rejector ? v => !!v : (v, i, a) => !rejector(v, i, a);
    return this.transform(values => values != null ? values.filter(reject) : values);
  }

  describe() {
    let base = super.describe();
    if (this.innerType) base.innerType = this.innerType.describe();
    return base;
  }

  nullable(isNullable = true) {
    return super.nullable(isNullable);
  }

  defined() {
    return super.defined();
  }

  required(msg) {
    return super.required(msg);
  }

}
create.prototype = ArraySchema.prototype; //
// Interfaces
//

function _typeof$1(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof$1 = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof$1 = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof$1(obj);
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$2(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var isUnknownObject = function isUnknownObject(raw) {
  return raw !== null && _typeof$1(raw) === 'object';
};
var isPromise = function isPromise(raw) {
  return isUnknownObject(raw) && typeof raw.then === 'function';
}; // We are using types to enforce the `stripe` prop in this lib,
// but in an untyped integration `stripe` could be anything, so we need
// to do some sanity validation to prevent type errors.

var isStripe = function isStripe(raw) {
  return isUnknownObject(raw) && typeof raw.elements === 'function' && typeof raw.createToken === 'function' && typeof raw.createPaymentMethod === 'function' && typeof raw.confirmCardPayment === 'function';
};

var PLAIN_OBJECT_STR = '[object Object]';
var isEqual = function isEqual(left, right) {
  if (!isUnknownObject(left) || !isUnknownObject(right)) {
    return left === right;
  }

  var leftArray = Array.isArray(left);
  var rightArray = Array.isArray(right);
  if (leftArray !== rightArray) return false;
  var leftPlainObject = Object.prototype.toString.call(left) === PLAIN_OBJECT_STR;
  var rightPlainObject = Object.prototype.toString.call(right) === PLAIN_OBJECT_STR;
  if (leftPlainObject !== rightPlainObject) return false;
  if (!leftPlainObject && !leftArray) return false;
  var leftKeys = Object.keys(left);
  var rightKeys = Object.keys(right);
  if (leftKeys.length !== rightKeys.length) return false;
  var keySet = {};

  for (var i = 0; i < leftKeys.length; i += 1) {
    keySet[leftKeys[i]] = true;
  }

  for (var _i = 0; _i < rightKeys.length; _i += 1) {
    keySet[rightKeys[_i]] = true;
  }

  var allKeys = Object.keys(keySet);

  if (allKeys.length !== leftKeys.length) {
    return false;
  }

  var l = left;
  var r = right;

  var pred = function pred(key) {
    return isEqual(l[key], r[key]);
  };

  return allKeys.every(pred);
};

var usePrevious = function usePrevious(value) {
  var ref = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useRef(value);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useEffect(function () {
    ref.current = value;
  }, [value]);
  return ref.current;
};

var INVALID_STRIPE_ERROR = 'Invalid prop `stripe` supplied to `Elements`. We recommend using the `loadStripe` utility from `@stripe/stripe-js`. See https://stripe.com/docs/stripe-js/react#elements-props-stripe for details.'; // We are using types to enforce the `stripe` prop in this lib, but in a real
// integration `stripe` could be anything, so we need to do some sanity
// validation to prevent type errors.

var validateStripe = function validateStripe(maybeStripe) {
  if (maybeStripe === null || isStripe(maybeStripe)) {
    return maybeStripe;
  }

  throw new Error(INVALID_STRIPE_ERROR);
};

var parseStripeProp = function parseStripeProp(raw) {
  if (isPromise(raw)) {
    return {
      tag: 'async',
      stripePromise: Promise.resolve(raw).then(validateStripe)
    };
  }

  var stripe = validateStripe(raw);

  if (stripe === null) {
    return {
      tag: 'empty'
    };
  }

  return {
    tag: 'sync',
    stripe: stripe
  };
};

var ElementsContext = /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createContext(null);
ElementsContext.displayName = 'ElementsContext';
var parseElementsContext = function parseElementsContext(ctx, useCase) {
  if (!ctx) {
    throw new Error("Could not find Elements context; You need to wrap the part of your app that ".concat(useCase, " in an <Elements> provider."));
  }

  return ctx;
};
/**
 * The `Elements` provider allows you to use [Element components](https://stripe.com/docs/stripe-js/react#element-components) and access the [Stripe object](https://stripe.com/docs/js/initializing) in any nested component.
 * Render an `Elements` provider at the root of your React app so that it is available everywhere you need it.
 *
 * To use the `Elements` provider, call `loadStripe` from `@stripe/stripe-js` with your publishable key.
 * The `loadStripe` function will asynchronously load the Stripe.js script and initialize a `Stripe` object.
 * Pass the returned `Promise` to `Elements`.
 *
 * @docs https://stripe.com/docs/stripe-js/react#elements-provider
 */

var Elements = function Elements(_ref) {
  var rawStripeProp = _ref.stripe,
      options = _ref.options,
      children = _ref.children;

  var _final = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useRef(false);

  var isMounted = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useRef(true);
  var parsed = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useMemo(function () {
    return parseStripeProp(rawStripeProp);
  }, [rawStripeProp]);

  var _React$useState = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useState(function () {
    return {
      stripe: null,
      elements: null
    };
  }),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      ctx = _React$useState2[0],
      setContext = _React$useState2[1];

  var prevStripe = usePrevious(rawStripeProp);
  var prevOptions = usePrevious(options);

  if (prevStripe !== null) {
    if (prevStripe !== rawStripeProp) {
      console.warn('Unsupported prop change on Elements: You cannot change the `stripe` prop after setting it.');
    }

    if (!isEqual(options, prevOptions)) {
      console.warn('Unsupported prop change on Elements: You cannot change the `options` prop after setting the `stripe` prop.');
    }
  }

  if (!_final.current) {
    if (parsed.tag === 'sync') {
      _final.current = true;
      setContext({
        stripe: parsed.stripe,
        elements: parsed.stripe.elements(options)
      });
    }

    if (parsed.tag === 'async') {
      _final.current = true;
      parsed.stripePromise.then(function (stripe) {
        if (stripe && isMounted.current) {
          // Only update Elements context if the component is still mounted
          // and stripe is not null. We allow stripe to be null to make
          // handling SSR easier.
          setContext({
            stripe: stripe,
            elements: stripe.elements(options)
          });
        }
      });
    }
  }

  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useEffect(function () {
    return function () {
      isMounted.current = false;
    };
  }, []);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useEffect(function () {
    var anyStripe = ctx.stripe;

    if (!anyStripe || !anyStripe._registerWrapper || !anyStripe.registerAppInfo) {
      return;
    }

    anyStripe._registerWrapper({
      name: 'react-stripe-js',
      version: "1.4.1"
    });

    anyStripe.registerAppInfo({
      name: 'react-stripe-js',
      version: "1.4.1",
      url: 'https://stripe.com/docs/stripe-js/react'
    });
  }, [ctx.stripe]);
  return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ElementsContext.Provider, {
    value: ctx
  }, children);
};
Elements.propTypes = {
  stripe: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bx.any,
  options: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bx.object
};
var useElementsContextWithUseCase = function useElementsContextWithUseCase(useCaseMessage) {
  var ctx = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useContext(ElementsContext);
  return parseElementsContext(ctx, useCaseMessage);
};
/**
 * @docs https://stripe.com/docs/stripe-js/react#useelements-hook
 */

var useElements = function useElements() {
  var _useElementsContextWi = useElementsContextWithUseCase('calls useElements()'),
      elements = _useElementsContextWi.elements;

  return elements;
};
/**
 * @docs https://stripe.com/docs/stripe-js/react#usestripe-hook
 */

var useStripe = function useStripe() {
  var _useElementsContextWi2 = useElementsContextWithUseCase('calls useStripe()'),
      stripe = _useElementsContextWi2.stripe;

  return stripe;
};
/**
 * @docs https://stripe.com/docs/stripe-js/react#elements-consumer
 */

var ElementsConsumer = function ElementsConsumer(_ref2) {
  var children = _ref2.children;
  var ctx = useElementsContextWithUseCase('mounts <ElementsConsumer>'); // Assert to satisfy the busted React.FC return type (it should be ReactNode)

  return children(ctx);
};
ElementsConsumer.propTypes = {
  children: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bx.func.isRequired
};

var useCallbackReference = function useCallbackReference(cb) {
  var ref = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useRef(cb);
  _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useEffect(function () {
    ref.current = cb;
  }, [cb]);
  return function () {
    if (ref.current) {
      ref.current.apply(ref, arguments);
    }
  };
};

var extractUpdateableOptions = function extractUpdateableOptions(options) {
  if (!isUnknownObject(options)) {
    return {};
  }

  options.paymentRequest;
      var rest = _objectWithoutProperties(options, ["paymentRequest"]);

  return rest;
};

var noop$1 = function noop() {};

var capitalized = function capitalized(str) {
  return str.charAt(0).toUpperCase() + str.slice(1);
};

var createElementComponent = function createElementComponent(type, isServer) {
  var displayName = "".concat(capitalized(type), "Element");

  var ClientElement = function ClientElement(_ref) {
    var id = _ref.id,
        className = _ref.className,
        _ref$options = _ref.options,
        options = _ref$options === void 0 ? {} : _ref$options,
        _ref$onBlur = _ref.onBlur,
        onBlur = _ref$onBlur === void 0 ? noop$1 : _ref$onBlur,
        _ref$onFocus = _ref.onFocus,
        onFocus = _ref$onFocus === void 0 ? noop$1 : _ref$onFocus,
        _ref$onReady = _ref.onReady,
        onReady = _ref$onReady === void 0 ? noop$1 : _ref$onReady,
        _ref$onChange = _ref.onChange,
        onChange = _ref$onChange === void 0 ? noop$1 : _ref$onChange,
        _ref$onEscape = _ref.onEscape,
        onEscape = _ref$onEscape === void 0 ? noop$1 : _ref$onEscape,
        _ref$onClick = _ref.onClick,
        onClick = _ref$onClick === void 0 ? noop$1 : _ref$onClick;

    var _useElementsContextWi = useElementsContextWithUseCase("mounts <".concat(displayName, ">")),
        elements = _useElementsContextWi.elements;

    var elementRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useRef(null);
    var domNode = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useRef(null);
    var callOnReady = useCallbackReference(onReady);
    var callOnBlur = useCallbackReference(onBlur);
    var callOnFocus = useCallbackReference(onFocus);
    var callOnClick = useCallbackReference(onClick);
    var callOnChange = useCallbackReference(onChange);
    var callOnEscape = useCallbackReference(onEscape);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useLayoutEffect(function () {
      if (elementRef.current == null && elements && domNode.current != null) {
        var element = elements.create(type, options);
        elementRef.current = element;
        element.mount(domNode.current);
        element.on('ready', function () {
          return callOnReady(element);
        });
        element.on('change', callOnChange);
        element.on('blur', callOnBlur);
        element.on('focus', callOnFocus);
        element.on('escape', callOnEscape); // Users can pass an an onClick prop on any Element component
        // just as they could listen for the `click` event on any Element,
        // but only the PaymentRequestButton will actually trigger the event.

        element.on('click', callOnClick);
      }
    });
    var prevOptions = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useRef(options);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useEffect(function () {
      if (prevOptions.current && prevOptions.current.paymentRequest !== options.paymentRequest) {
        console.warn('Unsupported prop change: options.paymentRequest is not a customizable property.');
      }

      var updateableOptions = extractUpdateableOptions(options);

      if (Object.keys(updateableOptions).length !== 0 && !isEqual(updateableOptions, extractUpdateableOptions(prevOptions.current))) {
        if (elementRef.current) {
          elementRef.current.update(updateableOptions);
          prevOptions.current = options;
        }
      }
    }, [options]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useLayoutEffect(function () {
      return function () {
        if (elementRef.current) {
          elementRef.current.destroy();
        }
      };
    }, []);
    return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("div", {
      id: id,
      className: className,
      ref: domNode
    });
  }; // Only render the Element wrapper in a server environment.


  var ServerElement = function ServerElement(props) {
    // Validate that we are in the right context by calling useElementsContextWithUseCase.
    useElementsContextWithUseCase("mounts <".concat(displayName, ">"));
    var id = props.id,
        className = props.className;
    return /*#__PURE__*/_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("div", {
      id: id,
      className: className
    });
  };

  var Element = isServer ? ServerElement : ClientElement;
  Element.propTypes = {
    id: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bx.string,
    className: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bx.string,
    onChange: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bx.func,
    onBlur: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bx.func,
    onFocus: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bx.func,
    onReady: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bx.func,
    onClick: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bx.func,
    options: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bx.object
  };
  Element.displayName = displayName;
  Element.__elementType = type;
  return Element;
};

var isServer = typeof window === 'undefined';
/**
 * Requires beta access:
 * Contact [Stripe support](https://support.stripe.com/) for more information.
 *
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */

createElementComponent('auBankAccount', isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */

createElementComponent('card', isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */

var CardNumberElement = createElementComponent('cardNumber', isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */

var CardExpiryElement = createElementComponent('cardExpiry', isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */

var CardCvcElement = createElementComponent('cardCvc', isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */

createElementComponent('fpxBank', isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */

createElementComponent('iban', isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */

createElementComponent('idealBank', isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */

createElementComponent('p24Bank', isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */

createElementComponent('epsBank', isServer);
createElementComponent('payment', isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */

createElementComponent('paymentRequestButton', isServer);
/**
 * @docs https://stripe.com/docs/stripe-js/react#element-components
 */

createElementComponent('afterpayClearpayMessage', isServer);

var pure$1 = {};

Object.defineProperty(pure$1, '__esModule', { value: true });

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

var V3_URL = 'https://js.stripe.com/v3';
var V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var EXISTING_SCRIPT_MESSAGE = 'loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used';
var findScript = function findScript() {
  var scripts = document.querySelectorAll("script[src^=\"".concat(V3_URL, "\"]"));

  for (var i = 0; i < scripts.length; i++) {
    var script = scripts[i];

    if (!V3_URL_REGEX.test(script.src)) {
      continue;
    }

    return script;
  }

  return null;
};

var injectScript = function injectScript(params) {
  var queryString = params && !params.advancedFraudSignals ? '?advancedFraudSignals=false' : '';
  var script = document.createElement('script');
  script.src = "".concat(V3_URL).concat(queryString);
  var headOrBody = document.head || document.body;

  if (!headOrBody) {
    throw new Error('Expected document.body not to be null. Stripe.js requires a <body> element.');
  }

  headOrBody.appendChild(script);
  return script;
};

var registerWrapper = function registerWrapper(stripe, startTime) {
  if (!stripe || !stripe._registerWrapper) {
    return;
  }

  stripe._registerWrapper({
    name: 'stripe-js',
    version: "1.15.1",
    startTime: startTime
  });
};

var stripePromise = null;
var loadScript = function loadScript(params) {
  // Ensure that we only attempt to load Stripe.js at most once
  if (stripePromise !== null) {
    return stripePromise;
  }

  stripePromise = new Promise(function (resolve, reject) {
    if (typeof window === 'undefined') {
      // Resolve to null when imported server side. This makes the module
      // safe to import in an isomorphic code base.
      resolve(null);
      return;
    }

    if (window.Stripe && params) {
      console.warn(EXISTING_SCRIPT_MESSAGE);
    }

    if (window.Stripe) {
      resolve(window.Stripe);
      return;
    }

    try {
      var script = findScript();

      if (script && params) {
        console.warn(EXISTING_SCRIPT_MESSAGE);
      } else if (!script) {
        script = injectScript(params);
      }

      script.addEventListener('load', function () {
        if (window.Stripe) {
          resolve(window.Stripe);
        } else {
          reject(new Error('Stripe.js not available'));
        }
      });
      script.addEventListener('error', function () {
        reject(new Error('Failed to load Stripe.js'));
      });
    } catch (error) {
      reject(error);
      return;
    }
  });
  return stripePromise;
};
var initStripe = function initStripe(maybeStripe, args, startTime) {
  if (maybeStripe === null) {
    return null;
  }

  var stripe = maybeStripe.apply(undefined, args);
  registerWrapper(stripe, startTime);
  return stripe;
};
var validateLoadParams = function validateLoadParams(params) {
  var errorMessage = "invalid load parameters; expected object of shape\n\n    {advancedFraudSignals: boolean}\n\nbut received\n\n    ".concat(JSON.stringify(params), "\n");

  if (params === null || _typeof(params) !== 'object') {
    throw new Error(errorMessage);
  }

  if (Object.keys(params).length === 1 && typeof params.advancedFraudSignals === 'boolean') {
    return params;
  }

  throw new Error(errorMessage);
};

var loadParams;
var loadStripeCalled = false;
var loadStripe = function loadStripe() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  loadStripeCalled = true;
  var startTime = Date.now();
  return loadScript(loadParams).then(function (maybeStripe) {
    return initStripe(maybeStripe, args, startTime);
  });
};

loadStripe.setLoadParameters = function (params) {
  if (loadStripeCalled) {
    throw new Error('You cannot change load parameters after calling loadStripe');
  }

  loadParams = validateLoadParams(params);
};

pure$1.loadStripe = loadStripe;

var pure = pure$1;

const DrawerContext = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createContext({ opened: false, close: () => { }, open: () => { } });
const TableSearchContext = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createContext({
    searching: false,
    searchQuery: '',
    //TODO: not implemented
    onSearch: () => undefined,
    setSearching: () => null,
});

const useT = (root) => {
    const { t } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.M)();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((key, options, defaultValue) => {
        return t(`adminPortal.${root}.${key}`, options, defaultValue);
    }, [t]);
};
// export const useGlobalT = <T extends keyof Localization>(): UseTFunc<any> => {
const useGlobalT = () => {
    const { t } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.M)();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((key, options, defaultValue) => {
        return t(key, options, defaultValue);
    }, [t]);
};
const useTableSearch = () => {
    const context = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(TableSearchContext);
    return Object.assign(Object.assign({}, context), { onSearch: (str) => (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.g)(void 0, void 0, void 0, function* () {
            const searchQuery = str !== null && str !== void 0 ? str : '';
            context.setSearching(!!searchQuery);
            context.onSearch(searchQuery);
        }) });
};
const useMuiMediaQuery = (themeBreakpoints) => {
    const { iframeRendering, rootEl } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const iframeWindowObj = iframeRendering && rootEl.ownerDocument ? rootEl.ownerDocument.defaultView : null;
    const mediaQueryOptions = iframeWindowObj ? { matchMedia: iframeWindowObj === null || iframeWindowObj === void 0 ? void 0 : iframeWindowObj.matchMedia } : undefined;
    return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bF)(themeBreakpoints, mediaQueryOptions);
};

/**
 * Copyright 2017 Google Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * @fileoverview Listener to provide Shadow DOM focus events, even inside shadow roots
 *
 * Normally, listening for focus with Shadow DOM will just return the top-most 'host' with a shadow
 * root. That may not be a problem! But if you want to find the 'real' focused element...
 *
 * To use this library, add this after the script is included-
 *   document.addEventListener('focus', shadowFocusHandler, true);
 *
 * You can then listen for `-shadow-focus` events, which will return the furthest focused element-
 *   document.addEventListener('-shadow-focus', function(ev) {
 *     console.info('got focused element', ev.detail, '..inside outer-most shadow root', ev.target);
 *   });
 */
const shadowFocusHandler = (function () {
    if (typeof window === 'undefined') {
        return (event) => dispatch(event.target);
    }
    const eventName = '-shadow-focus';
    const dispatch = function (target) {
        const args = { composed: true, bubbles: true, detail: target };
        const customEvent = new CustomEvent(eventName, args);
        target.dispatchEvent(customEvent);
    };
    if (!window.WeakSet || !window.ShadowRoot) {
        return (event) => dispatch(event.target);
    }
    const focusHandlerSet = new WeakSet();
    /**
     * @param {Node} target to work on
     * @param {function(!FocusEvent)} callback to invoke on focus change
     */
    function _internal(target, callback) {
        let currentFocus = target; // save real focus
        // #1: get the nearest ShadowRoot
        while (!(target instanceof ShadowRoot)) {
            if (!target) {
                return;
            }
            target = target.parentNode;
        }
        // #2: are we already handling it?
        if (focusHandlerSet.has(target)) {
            return;
        }
        focusHandlerSet.add(target);
        // #3: setup focus/blur handlers
        const hostEl = target.host;
        const focusinHandler = function (ev) {
            if (ev.target !== currentFocus) { // prevent dup calls for same focus
                currentFocus = ev.target;
                callback(ev);
            }
        };
        const blurHandler = function (ev) {
            hostEl.removeEventListener('blur', blurHandler, false);
            target.removeEventListener('focusin', focusinHandler, true);
            focusHandlerSet.delete(target);
        };
        // #3: add blur handler to host element
        hostEl.addEventListener('blur', blurHandler, false);
        // #4: add focus handler within shadow root, to observe changes
        target.addEventListener('focusin', focusinHandler, true);
        // #5: find next parent SR, do it again
        _internal(target.host, callback);
    }
    /**
     * @param {!FocusEvent} event to process
     */
    function shadowFocusHandler(event) {
        const target = (event.composedPath ? event.composedPath()[0] : null) || event.target;
        _internal(target, shadowFocusHandler);
        dispatch(target);
    }
    return shadowFocusHandler;
}());

function toCurrencySymbol(currency) {
    switch (currency) {
        case 'nis':
            return '₪';
        case 'usd':
        default:
            return '$';
    }
}
function toPriceDisplay(price = 0) {
    return `${(price / 100).toFixed(2)}`;
}

const TextBreakLine = ({ text }) => {
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null, text
        .split('\\n')
        .map((str) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null, str))
        .reduce((prevList, curr) => {
        if (prevList.length === 0) {
            return [curr];
        }
        return prevList.concat(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("br", null), curr);
    }, [])));
};

const SubscriptionDialogFooter = ({ cancel, confirm }) => {
    var _a, _b;
    const t = useT('subscriptions');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, justifyContent: 'flex-end' },
        cancel && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { type: 'button', "data-test-id": "cancelBtn", color: 'inherit', variant: 'text', onClick: cancel.onClick, disabled: cancel.disabled }, t('cancel'))),
        confirm && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "confirmBtn", type: (_a = confirm.type) !== null && _a !== void 0 ? _a : 'button', color: (_b = confirm.color) !== null && _b !== void 0 ? _b : 'primary', onClick: confirm.onClick, disabled: confirm.disabled, loading: confirm.loading }, t(confirm.text)))));
};

const SubscriptionFormContext = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createContext({
    valid: false,
    setValid: (value) => { },
    registerSubmit: (cb) => { },
    unregisterSubmit: () => { },
    onSubmit: () => { },
});
const useSubscriptionFormContext = () => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(SubscriptionFormContext);
const SubscriptionFormContextProvider = ({ children }) => {
    const [{ onSubmit }, setState] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState({
        onSubmit: () => { },
    });
    const [valid, setValid] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionFormContext.Provider, { value: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
            valid,
            onSubmit,
            setValid,
            registerSubmit: (callback) => setState({ onSubmit: callback }),
            unregisterSubmit: () => setState({ onSubmit: () => { } }),
        }), [valid, onSubmit]) }, children));
};

const CheckoutDialogFooter = ({ shouldCreatePaymentMethod, onCancel, planId, }) => {
    const { loading } = useCheckout();
    const { paymentMethod } = usePaymentMethod();
    const { valid, onSubmit } = useSubscriptionFormContext();
    const { confirmCheckout } = useCheckoutActions();
    const handleConfirmCheckout = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        confirmCheckout({ paymentMethodId: paymentMethod.id, planId });
    }, [planId, paymentMethod, confirmCheckout]);
    return shouldCreatePaymentMethod ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionDialogFooter, { cancel: { onClick: onCancel, disabled: loading }, confirm: { onClick: onSubmit, disabled: !valid, loading, text: 'confirm' } })) : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionDialogFooter, { cancel: { onClick: onCancel, disabled: loading }, confirm: { onClick: handleConfirmCheckout, loading, text: 'confirm' } }));
};

const CheckoutDialogError = () => {
    const { error } = useCheckout();
    if (!error) {
        return null;
    }
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { p: 4 },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.A, { "data-test-id": error, severity: 'error' }, error)));
};

const SectionTitle = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B)(({ theme }) => ({
    color: theme.palette.grey[700],
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(16),
    padding: theme.spacing(4),
}));
const DialogSectionBox = ({ children, title }) => {
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { mb: 4 },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SectionTitle, null, title),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.D, null),
        children));
};

const PlanTitle$1 = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B)(({ theme }) => ({
    color: theme.palette.grey[800],
    fontWeight: 800,
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(24),
    marginBottom: theme.spacing(3),
}));
const PlanSubtitle = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B)(({ theme }) => ({
    color: theme.palette.grey[700],
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(16),
}));
const PlanPrice$1 = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B)(({ theme }) => ({
    color: theme.palette.grey[800],
    fontWeight: 800,
    fontSize: theme.typography.pxToRem(20),
    lineHeight: theme.typography.pxToRem(24),
    marginBottom: theme.spacing(3),
    textAlign: 'end',
}));
const PlanPriceInterval = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B)(({ theme }) => ({
    color: theme.palette.grey[700],
    fontWeight: 600,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(16),
    textAlign: 'end',
}));
const CheckoutSubscriptionPlanDetails = ({ title, subTitle, price, planInterval, }) => {
    const t = useT('subscriptions_Checkout');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DialogSectionBox, { title: t('selectedPlan') },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, p: 4, mt: 4, justifyContent: 'space-between' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PlanTitle$1, null, title),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PlanSubtitle, null,
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TextBreakLine, { text: subTitle }))),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, display: 'none' },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PlanPrice$1, null, `${price}`),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PlanPriceInterval, null, planInterval === 'month' ? 'per each month' : 'per each month')))));
};

const CheckoutDialogDetails = ({ planId }) => {
    const t = useT('subscriptions_Billing');
    const { plans } = usePlans();
    const plan = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => plans.find((item) => item.id === planId), [plans, planId]);
    if (!plan) {
        return null;
    }
    const price = `${toCurrencySymbol(plan.currency)}${toPriceDisplay(plan.price)}`;
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CheckoutSubscriptionPlanDetails, { title: plan.name, subTitle: plan.description || `${price} • ${t('monthly')}`, price: price, planInterval: t('intervalTitle', { interval: t('intervalMonth') }) }));
};

const StripeElementProvider = ({ stripeKey, children }) => {
    const loadStripePromise = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => pure.loadStripe(stripeKey), [stripeKey]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Elements, { stripe: loadStripePromise },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ElementsConsumer, null, ({ stripe, elements }) => {
            if (!stripe || !elements) {
                return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.O, null);
            }
            return children;
        })));
};

const StripeFormLabel = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(FormLabel$1) `
  color: ${_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.by.palette('grey.800')};
  font-size: ${({ theme }) => theme.typography.pxToRem(14)};
  line-height: ${({ theme }) => theme.typography.pxToRem(16)};
  font-weight: 600;
  margin-bottom: ${_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.by.spacing(2)};
`;
const StripeTextField = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(TextField$1) `
  width: 100%;
`;
const StripeInputWrapper = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('div')(({ theme }) => ({
    color: theme.palette.grey[800],
    border: `1px solid ${theme.palette.grey[400]}`,
    boxShadow: `inset 0px 1px 0px ${theme.palette.grey[200]}`,
    borderRadius: theme.spacing(1),
}));
const classes = {
    base: 'stripe-input-class-base',
    focus: 'stripe-input-class-focused',
    empty: 'stripe-input-class-empty',
    invalid: 'stripe-input-class-invalid',
};
const StripeForm = ({ disabled, cardHolderNameFieldRef, onValidChange }) => {
    const t = useT('subscriptions_Checkout');
    const theme = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.F)();
    const [validation, setValidation] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState({
        cardHolderName: false,
        cardNumber: false,
        cardExpiryDate: false,
        cardCvc: false,
    });
    const isFormValid = Object.values(validation).every((item) => item);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        onValidChange(isFormValid);
    }, [onValidChange, isFormValid]);
    const setValidationField = (key, value) => {
        setValidation((prevState) => (Object.assign(Object.assign({}, prevState), { [key]: value })));
    };
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.R, { name: 'StripeStyle' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("style", null, `
            .${classes.base} {
              height: unset;
              padding: ${theme.spacing(2.5)} ${theme.spacing(4)};
              font-weight: bold;
              font-size: ${theme.typography.body1.fontSize};
              font-family: ${theme.typography.body1.fontFamily};
              line-height: ${theme.typography.body1.lineHeight}
              color: ${theme.palette.grey[800]};
              box-shadow: inset 0px 1px 0px ${theme.palette.grey[100]};
            }
            .${classes.base}:hover {
              box-shadow: none;
              outline-color:  #889DB8;
              outline-style: solid;
              outline-width: 2px;
              outline-offset: 0px;
            }
            .${classes.empty} {
              color: ${theme.palette.grey[100]} !important;
            }
            .${classes.empty} input::placeholder {
              color: ${theme.palette.grey[100]} !important;
            }
            .${classes.invalid} {
              color: ${theme.palette.error.main};
              border: 1px solid ${theme.palette.error.main};
            }
            .${classes.invalid}:hover {
              color: ${theme.palette.error.main};
              border-color: ${theme.palette.error.main};
              outline-color: ${theme.palette.error.main};
            }
        `)),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, padding: 0, direction: 'column' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, mb: 4 },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StripeFormLabel, { "data-test-id": "nameOnCardBox" }, t('nameOnCard')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StripeTextField, { "data-test-id": "NameOnCardBox", inputRef: cardHolderNameFieldRef, disabled: disabled, placeholder: 'Enter your name', name: 'cardHolderName', onChange: (event) => {
                        setValidationField('cardHolderName', !!event.currentTarget.value && event.currentTarget.value.length > 0);
                    } })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, mb: 4 },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StripeFormLabel, null, t('cardNumber')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StripeInputWrapper, null,
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.R, { name: 'CardNumberElement' },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CardNumberElement, { "data-test-id": "cardNumberBox", onChange: (event) => {
                                setValidationField('cardNumber', event.complete);
                            }, options: {
                                disabled,
                                placeholder: '0000 0000 0000 0000',
                                classes,
                            } })))),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, container: true, mb: 4, spacing: 4 },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 6 },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StripeFormLabel, null, t('expiryDate')),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StripeInputWrapper, null,
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.R, { name: 'CardExpiryElement' },
                            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CardExpiryElement, { "data-test-id": "cardExpiryBox", onChange: (event) => {
                                    setValidationField('cardExpiryDate', event.complete);
                                }, options: {
                                    classes,
                                    disabled,
                                    placeholder: 'MM / YY',
                                } })))),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 6 },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StripeFormLabel, null, t('cvc')),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StripeInputWrapper, null,
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.R, { name: 'CardCardCvc' },
                            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CardCvcElement, { "data-test-id": "cardCvcBox", onChange: (event) => {
                                    setValidationField('cardCvc', event.complete);
                                }, options: {
                                    classes,
                                    disabled,
                                    placeholder: 'CVC Security Number',
                                } }))))))));
};

const BoxLoader = ({ height }) => {
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { height: height || 220, container: true, alignContent: 'center', justifyContent: 'center' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.O, null)));
};

const StripePaymentMethodForm = (_a) => {
    var { mode, apiKey } = _a, rest = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["mode", "apiKey"]);
    const { paymentMethod } = usePaymentMethod();
    const { cardSetupIntentSecret, error, loading } = useStripeState();
    const { createCardSetupIntentSecret } = useStripeActions();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (mode === 'create') {
            createCardSetupIntentSecret(null);
        }
        else {
            createCardSetupIntentSecret((paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.id) || null);
        }
    }, []);
    if (error) {
        // TODO
        return null;
    }
    if (loading || !cardSetupIntentSecret) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(BoxLoader, { height: 250 });
    }
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StripeElementProvider, { stripeKey: apiKey },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PaymentMethodForm$1, Object.assign({ cardSetupIntentSecret: cardSetupIntentSecret }, rest))));
};
const PaymentMethodForm$1 = ({ cardSetupIntentSecret, disabled, onSubmit, onError, onSuccess, }) => {
    const t = useT('subscriptions_Billing');
    const stripe = useStripe();
    const elements = useElements();
    const { setValid, registerSubmit, unregisterSubmit } = useSubscriptionFormContext();
    const cardHolderNameFieldRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(null);
    const handleSubmit = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.g)(void 0, void 0, void 0, function* () {
        var _a;
        if (!stripe || !elements) {
            return;
        }
        const cardNumber = elements.getElement(CardNumberElement);
        const cardNameHolder = (_a = cardHolderNameFieldRef.current) === null || _a === void 0 ? void 0 : _a.value;
        if (!cardNameHolder || !cardNumber) {
            return;
        }
        onSubmit();
        try {
            const { error, setupIntent } = yield stripe.confirmCardSetup(cardSetupIntentSecret, {
                payment_method: {
                    card: cardNumber,
                    //TODO: add metadata
                    // metadata: {}
                    billing_details: {
                        name: cardNameHolder,
                    },
                },
            });
            if (error) {
                onError(t('confirmError', { error: error.message, code: error.code }));
                return;
            }
            if ((setupIntent === null || setupIntent === void 0 ? void 0 : setupIntent.status) === 'succeeded' && setupIntent.payment_method) {
                onSuccess(setupIntent.payment_method);
            }
            else {
                onError(t('invalidCardStatusError', { status: setupIntent === null || setupIntent === void 0 ? void 0 : setupIntent.status }));
            }
        }
        catch (e) {
            console.debug('Failed to process payment method', e);
            onError(t('confirmGenericError'));
        }
    }), [t, stripe, elements, onSubmit, cardSetupIntentSecret, onError, onSuccess]);
    const handleValidation = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((status) => {
        setValid(status);
    }, [setValid]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        registerSubmit(handleSubmit);
        return () => {
            unregisterSubmit();
        };
    }, [registerSubmit, unregisterSubmit, handleSubmit]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StripeForm, { cardHolderNameFieldRef: cardHolderNameFieldRef, disabled: disabled, onValidChange: handleValidation })), [cardHolderNameFieldRef, disabled, handleValidation]);
};

const PaymentMethodForm = ({ mode, disabled, onError, onSuccess, onSubmit }) => {
    const { config } = usePaymentProvider();
    if ((config === null || config === void 0 ? void 0 : config.paymentProvider) === _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .PaymentProvider.STRIPE */ .OH.STRIPE) {
        const { apiKey } = config;
        return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StripePaymentMethodForm, { mode: mode, disabled: disabled, apiKey: apiKey, onError: onError, onSuccess: onSuccess, onSubmit: onSubmit }));
    }
    else {
        // TODO error or cancel action
        return null;
    }
};

const cardBrandIcons = {
    visa: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bz,
    amex: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bA,
    mastercard: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bB,
    diners: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bC,
    unknown: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bD
};

const UpdatePaymentMethod = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G)(({ theme, disabled }) => ({
    display: 'flex',
    alignItems: 'center',
    cursor: disabled ? 'default' : 'pointer',
    svg: {
        marginLeft: '24px',
        width: '0.75rem',
        height: '0.75rem',
        color: theme.palette.grey[500],
    },
}));
const CardInfo = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G) `
  display: flex;
  align-items: center;

  svg {
    width: 2.5rem;
    height: 1.5rem;
  }
`;
const PaymentMethodSelect = ({ disabled, onUpdate, brand, last4, expMonth, expYear, }) => {
    const t = useT('subscriptions');
    const BankIcon = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => cardBrandIcons[brand || 'unknown'], [brand]);
    const handleUpdate = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        if (!disabled && onUpdate) {
            onUpdate();
        }
    }, [disabled, onUpdate]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, justifyContent: 'space-between', alignItems: 'center', alignContent: 'center', p: 0 },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CardInfo, { item: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(BankIcon, null),
                last4 && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'label', ml: 4 },
                    "\u2022\u2022\u2022\u2022 ",
                    last4)))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: true }, expMonth && expYear && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'tableStandardCell', textAlign: 'center' },
            t('expires'),
            " ",
            expMonth,
            "/",
            expYear))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true }, onUpdate && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(UpdatePaymentMethod, { "data-test-id": 'updatePaymentMethodBtn', item: true, onClick: handleUpdate, disabled: disabled },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'body1' }, t('updatePaymentMethod')),
            " ",
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bI, null))))));
};

const CheckoutDialogPaymentMethod = ({ shouldCreatePaymentMethod, handleForcePaymentMethodCreation, planId, }) => {
    const t = useT('subscriptions_Billing');
    const { loading } = useCheckout();
    const { paymentMethod } = usePaymentMethod();
    const { confirmCheckout, errorCheckout, submitCheckout } = useCheckoutActions();
    const handleError = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((error) => {
        errorCheckout(error);
    }, [errorCheckout]);
    const handleSubmit = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        submitCheckout();
    }, [submitCheckout]);
    const handleConfirmPaymentMethod = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((newPaymentMethodId) => {
        confirmCheckout({ paymentMethodId: newPaymentMethodId, planId });
    }, [confirmCheckout, planId]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DialogSectionBox, { title: t('paymentMethod') },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { pt: 8, pb: 2, p: 4 }, shouldCreatePaymentMethod ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PaymentMethodForm, { disabled: loading, mode: paymentMethod ? 'update' : 'create', onError: handleError, onSubmit: handleSubmit, onSuccess: handleConfirmPaymentMethod })) : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PaymentMethodSelect, { disabled: loading, brand: paymentMethod.brand, last4: paymentMethod.last4, onUpdate: handleForcePaymentMethodCreation })))));
};

const CheckoutDialogBody = ({ planId, onClose, onSuccess, onError }) => {
    const { paymentMethod } = usePaymentMethod();
    const [forceNewPaymentMethod, setForcePaymentMethod] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(!paymentMethod);
    const { confirmed, error } = useCheckout();
    const { loadCheckout, resetCheckout } = useCheckoutActions();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        loadCheckout();
        return () => {
            resetCheckout();
        };
    }, [loadCheckout, resetCheckout]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (confirmed) {
            resetCheckout();
            onSuccess();
        }
    }, [confirmed, onSuccess, resetCheckout]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (error) {
            resetCheckout();
            onError(error);
        }
    }, [error, onError, resetCheckout]);
    const handleForcePaymentMethodCreation = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setForcePaymentMethod(true);
    }, [setForcePaymentMethod]);
    const handleClose = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        resetCheckout();
        onClose();
    }, [resetCheckout, onClose]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionFormContextProvider, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, { noPadding: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CheckoutDialogError, null),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CheckoutDialogDetails, { planId: planId }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CheckoutDialogPaymentMethod, { planId: planId, shouldCreatePaymentMethod: forceNewPaymentMethod, handleForcePaymentMethodCreation: handleForcePaymentMethodCreation })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CheckoutDialogFooter, { planId: planId, onCancel: handleClose, shouldCreatePaymentMethod: forceNewPaymentMethod }))));
};

const AuthWrapper = ({ children }) => {
    const { isLoading, isAuthenticated } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.J)(({ isLoading, isAuthenticated, tenantsState: { loading, tenants } }) => ({
        isLoading: isLoading || (loading && tenants.length === 0),
        isAuthenticated,
    }));
    const { loading: loadingPolicy } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bH)();
    const { injector, basename = '', urlStrategy } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const routes = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.K)();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            const calculatedBasename = basename.endsWith('/') ? basename.substring(0, basename.length - 1) : '';
            if (injector) {
                injector === null || injector === void 0 ? void 0 : injector.hideCheckoutDialog();
            }
            const path = calculatedBasename + routes.loginUrl;
            if (urlStrategy === 'path' && injector) {
                window.location.href = path;
            }
            else {
                window.location.hash = `#${path}`;
            }
        }
    }, [isLoading, isAuthenticated, routes, injector, urlStrategy, basename]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null, !isLoading && !loadingPolicy && children);
};

const CheckoutDialogSkeleton = () => {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(BoxLoader, { height: 450 });
};

const PaymentProviderWrapper = ({ children }) => {
    const { fetching } = usePaymentProvider();
    const { loadPaymentConfiguration } = usePaymentProviderActions();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        loadPaymentConfiguration();
    }, [loadPaymentConfiguration]);
    if (fetching) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CheckoutDialogSkeleton, null);
    }
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null, children);
};

const SubscriptionsWrapper = ({ children }) => {
    const { fetching: fetchingBillingInformation } = useBillingInformation();
    const { fetching: fetchingPlans } = usePlans();
    const { fetching: fetchingPaymentMethod } = usePaymentMethod();
    const { loadBillingInformation } = useBillingInformationActions();
    const { loadPlans } = usePlansActions();
    const { loadPaymentMethod } = usePaymentMethodActions();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        loadBillingInformation();
        loadPlans();
        loadPaymentMethod();
    }, [loadBillingInformation, loadPlans, loadPaymentMethod]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => !fetchingBillingInformation && !fetchingPlans && !fetchingPaymentMethod ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null, children)) : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CheckoutDialogSkeleton, null)), [children, fetchingBillingInformation, fetchingPlans, fetchingPaymentMethod]);
};

const CheckoutDialogAppContent = ({ plan: planSlug, onClose, onError, onSuccess, }) => {
    const t = useT('subscriptions_CheckoutDialog');
    const { plans } = usePlans();
    const planId = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => { var _a; return planSlug && ((_a = plans.find((plan) => plan.slug === planSlug)) === null || _a === void 0 ? void 0 : _a.id); }, [planSlug, plans]);
    if (!planId) {
        return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { p: 4 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.A, { "data-test-id": 'checkoutDialogPlanNotFound', severity: 'error' }, t('errorPlanNotFound'))));
    }
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CheckoutDialogBody, { planId: planId, onSuccess: onSuccess, onError: onError, onClose: onClose });
};
const CheckoutDialogApp = ({ plan, onClose, onError, onSuccess }) => {
    const t = useT('subscriptions');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const hideDialogWithTimeout = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setTimeout(() => {
            injector === null || injector === void 0 ? void 0 : injector.hideCheckoutDialog();
        }, 200);
    }, [injector]);
    const handleClose = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        onClose === null || onClose === void 0 ? void 0 : onClose();
        hideDialogWithTimeout();
    }, [onClose, hideDialogWithTimeout]);
    const handleSuccess = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
        hideDialogWithTimeout();
    }, [onSuccess, hideDialogWithTimeout]);
    const handleError = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((msg) => {
        onError === null || onError === void 0 ? void 0 : onError(msg);
        hideDialogWithTimeout();
    }, [onError, hideDialogWithTimeout]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, { open: true, onClose: handleClose, container: injector === null || injector === void 0 ? void 0 : injector.checkoutDialogEl, title: t('dialogCheckoutTitle'), onBackdropClick: handleClose },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PaymentProviderWrapper, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionsWrapper, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CheckoutDialogAppContent, { plan: plan, onClose: handleClose, onSuccess: handleSuccess, onError: handleError })))));
};

const AppWrapper = ({ children }) => {
    const { isShadowDom, injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        document.addEventListener('focus', shadowFocusHandler, true);
        const oldDocumentBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('focus', shadowFocusHandler, true);
            document.body.style.overflow = oldDocumentBodyOverflow;
            window.history.pushState('', document.title, window.location.pathname);
        };
    }, []);
    const { calculatedTheme, theme, overrides } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.w)(true);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.x, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.y, { theme: calculatedTheme, isShadowDom: isShadowDom },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.z.Provider, { value: { theme, overrides } },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.E, { themeOptionKey: 'adminPortal' },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.P, { context: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.N, store: injector.store },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AuthWrapper, null, children)))))));
};
const CheckoutDialog$1 = (_a) => {
    var _b, _c;
    var { injector, options } = _a, dialogProps = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["injector", "options"]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.S.Provider, { value: Object.assign(Object.assign({ iframeRendering: false }, options), { injector, themeOptions: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bE)((_b = options.metadata) !== null && _b !== void 0 ? _b : {}, (_c = options.themeOptions) !== null && _c !== void 0 ? _c : {}), slotsContainer: injector.checkoutDialogContainer, rootEl: injector.checkoutDialogEl }) },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AppWrapper, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CheckoutDialogApp, Object.assign({}, dialogProps)))));
};

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _inheritsLoose$1(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf$1(subClass, superClass);
}

function _extends$2() {
  _extends$2 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$2.apply(this, arguments);
}

function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ''));
}

function addLeadingSlash$1(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename$1(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = _extends$2({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = resolvePathname(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && valueEqual(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ? invariant(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash$1(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
    if (basename) path = stripBasename$1(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    _extends$2(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash$1
  },
  slash: {
    encodePath: addLeadingSlash$1,
    decodePath: addLeadingSlash$1
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ? invariant(false) : void 0;
  var globalHistory = window.history;
  supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash$1(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
    if (basename) path = stripBasename$1(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    _extends$2(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
        setState();
      }
    });
  }

  function replace(path, state) {
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    _extends$2(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}

var MAX_SIGNED_31_BIT_INT = 1073741823;
var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : {};

function getUniqueId() {
  var key = '__global_unique_id__';
  return commonjsGlobal[key] = (commonjsGlobal[key] || 0) + 1;
}

function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + getUniqueId() + '__';

  var Provider = /*#__PURE__*/function (_Component) {
    (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bJ)(Provider, _Component);

    function Provider() {
      var _this;

      _this = _Component.apply(this, arguments) || this;
      _this.emitter = createEventEmitter(_this.props.value);
      return _this;
    }

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0;
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    _proto.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bx.object.isRequired, _Provider$childContex);

  var Consumer = /*#__PURE__*/function (_Component2) {
    (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bJ)(Consumer, _Component2);

    function Consumer() {
      var _this2;

      _this2 = _Component2.apply(this, arguments) || this;
      _this2.state = {
        value: _this2.getValue()
      };

      _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;

        if ((observedBits & changedBits) !== 0) {
          _this2.setState({
            value: _this2.getValue()
          });
        }
      };

      return _this2;
    }

    var _proto2 = Consumer.prototype;

    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }

      var observedBits = this.props.observedBits;
      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
    };

    _proto2.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    _proto2.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    _proto2.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bx.object, _Consumer$contextType);
  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

var index = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createContext || createReactContext;

var createContext = index;

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

var pathToRegexp$2 = {exports: {}};

var isarray$1 = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

var isarray = isarray$1;

/**
 * Expose `pathToRegexp`.
 */
pathToRegexp$2.exports = pathToRegexp;
pathToRegexp$2.exports.parse = parse;
pathToRegexp$2.exports.compile = compile;
pathToRegexp$2.exports.tokensToFunction = tokensToFunction;
pathToRegexp$2.exports.tokensToRegExp = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options));
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

var pathToRegexp$1 = pathToRegexp$2.exports;

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext = function createNamedContext(name) {
  var context = createContext();
  context.displayName = name;
  return context;
};

var historyContext =
/*#__PURE__*/
createNamedContext("Router-History");

// TODO: Replace with React.createContext once we can assume React 16+

var createNamedContext$1 = function createNamedContext(name) {
  var context = createContext();
  context.displayName = name;
  return context;
};

var context =
/*#__PURE__*/
createNamedContext$1("Router");

/**
 * The public API for putting history on context.
 */

var Router =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose$1(Router, _React$Component);

  Router.computeRootMatch = function computeRootMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  function Router(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {
      location: props.history.location
    }; // This is a bit of a hack. We have to start listening for location
    // changes here in the constructor in case there are any <Redirect>s
    // on the initial render. If there are, they will replace/push when
    // they mount and since cDM fires in children before parents, we may
    // get a new location before the <Router> is mounted.

    _this._isMounted = false;
    _this._pendingLocation = null;

    if (!props.staticContext) {
      _this.unlisten = props.history.listen(function (location) {
        if (_this._isMounted) {
          _this.setState({
            location: location
          });
        } else {
          _this._pendingLocation = location;
        }
      });
    }

    return _this;
  }

  var _proto = Router.prototype;

  _proto.componentDidMount = function componentDidMount() {
    this._isMounted = true;

    if (this._pendingLocation) {
      this.setState({
        location: this._pendingLocation
      });
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.unlisten) this.unlisten();
  };

  _proto.render = function render() {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(context.Provider, {
      value: {
        history: this.props.history,
        location: this.state.location,
        match: Router.computeRootMatch(this.state.location.pathname),
        staticContext: this.props.staticContext
      }
    }, _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(historyContext.Provider, {
      children: this.props.children || null,
      value: this.props.history
    }));
  };

  return Router;
}(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Component);

/**
 * The public API for a <Router> that stores location in memory.
 */

/*#__PURE__*/
(function (_React$Component) {
  _inheritsLoose$1(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = createMemoryHistory(_this.props);
    return _this;
  }

  var _proto = MemoryRouter.prototype;

  _proto.render = function render() {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return MemoryRouter;
})(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Component);

var Lifecycle =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose$1(Lifecycle, _React$Component);

  function Lifecycle() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Lifecycle.prototype;

  _proto.componentDidMount = function componentDidMount() {
    if (this.props.onMount) this.props.onMount.call(this, this);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (this.props.onUpdate) this.props.onUpdate.call(this, this, prevProps);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    if (this.props.onUnmount) this.props.onUnmount.call(this, this);
  };

  _proto.render = function render() {
    return null;
  };

  return Lifecycle;
}(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Component);

var cache = {};
var cacheLimit = 10000;
var cacheCount = 0;

function compilePath(path) {
  if (cache[path]) return cache[path];
  var generator = pathToRegexp$1.compile(path);

  if (cacheCount < cacheLimit) {
    cache[path] = generator;
    cacheCount++;
  }

  return generator;
}
/**
 * Public API for generating a URL pathname from a path and parameters.
 */


function generatePath(path, params) {
  if (path === void 0) {
    path = "/";
  }

  if (params === void 0) {
    params = {};
  }

  return path === "/" ? path : compilePath(path)(params, {
    pretty: true
  });
}

/**
 * The public API for navigating programmatically with a component.
 */

function Redirect(_ref) {
  var computedMatch = _ref.computedMatch,
      to = _ref.to,
      _ref$push = _ref.push,
      push = _ref$push === void 0 ? false : _ref$push;
  return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(context.Consumer, null, function (context) {
    !context ? invariant(false) : void 0;
    var history = context.history,
        staticContext = context.staticContext;
    var method = push ? history.push : history.replace;
    var location = createLocation(computedMatch ? typeof to === "string" ? generatePath(to, computedMatch.params) : _extends$1({}, to, {
      pathname: generatePath(to.pathname, computedMatch.params)
    }) : to); // When rendering in a static context,
    // set the new location immediately.

    if (staticContext) {
      method(location);
      return null;
    }

    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Lifecycle, {
      onMount: function onMount() {
        method(location);
      },
      onUpdate: function onUpdate(self, prevProps) {
        var prevLocation = createLocation(prevProps.to);

        if (!locationsAreEqual(prevLocation, _extends$1({}, location, {
          key: prevLocation.key
        }))) {
          method(location);
        }
      },
      to: to
    });
  });
}

var cache$1 = {};
var cacheLimit$1 = 10000;
var cacheCount$1 = 0;

function compilePath$1(path, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var pathCache = cache$1[cacheKey] || (cache$1[cacheKey] = {});
  if (pathCache[path]) return pathCache[path];
  var keys = [];
  var regexp = pathToRegexp$1(path, keys, options);
  var result = {
    regexp: regexp,
    keys: keys
  };

  if (cacheCount$1 < cacheLimit$1) {
    pathCache[path] = result;
    cacheCount$1++;
  }

  return result;
}
/**
 * Public API for matching a URL pathname to a path.
 */


function matchPath(pathname, options) {
  if (options === void 0) {
    options = {};
  }

  if (typeof options === "string" || Array.isArray(options)) {
    options = {
      path: options
    };
  }

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === void 0 ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === void 0 ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === void 0 ? false : _options$sensitive;
  var paths = [].concat(path);
  return paths.reduce(function (matched, path) {
    if (!path && path !== "") return null;
    if (matched) return matched;

    var _compilePath = compilePath$1(path, {
      end: exact,
      strict: strict,
      sensitive: sensitive
    }),
        regexp = _compilePath.regexp,
        keys = _compilePath.keys;

    var match = regexp.exec(pathname);
    if (!match) return null;
    var url = match[0],
        values = match.slice(1);
    var isExact = pathname === url;
    if (exact && !isExact) return null;
    return {
      path: path,
      // the path used to match
      url: path === "/" && url === "" ? "/" : url,
      // the matched portion of the URL
      isExact: isExact,
      // whether or not we matched exactly
      params: keys.reduce(function (memo, key, index) {
        memo[key.name] = values[index];
        return memo;
      }, {})
    };
  }, null);
}
/**
 * The public API for matching a single path and rendering.
 */


var Route =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose$1(Route, _React$Component);

  function Route() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Route.prototype;

  _proto.render = function render() {
    var _this = this;

    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(context.Consumer, null, function (context$1) {
      !context$1 ? invariant(false) : void 0;
      var location = _this.props.location || context$1.location;
      var match = _this.props.computedMatch ? _this.props.computedMatch // <Switch> already computed the match for us
      : _this.props.path ? matchPath(location.pathname, _this.props) : context$1.match;

      var props = _extends$1({}, context$1, {
        location: location,
        match: match
      });

      var _this$props = _this.props,
          children = _this$props.children,
          component = _this$props.component,
          render = _this$props.render; // Preact uses an empty array as children by
      // default, so use null if that's the case.

      if (Array.isArray(children) && children.length === 0) {
        children = null;
      }

      return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(context.Provider, {
        value: props
      }, props.match ? children ? typeof children === "function" ? children(props) : children : component ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(component, props) : render ? render(props) : null : typeof children === "function" ? children(props) : null);
    });
  };

  return Route;
}(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Component);

function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
}

function addBasename(basename, location) {
  if (!basename) return location;
  return _extends$1({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
}

function stripBasename(basename, location) {
  if (!basename) return location;
  var base = addLeadingSlash(basename);
  if (location.pathname.indexOf(base) !== 0) return location;
  return _extends$1({}, location, {
    pathname: location.pathname.substr(base.length)
  });
}

function createURL(location) {
  return typeof location === "string" ? location : createPath(location);
}

function staticHandler(methodName) {
  return function () {
     invariant(false) ;
  };
}

function noop() {}
/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */


/*#__PURE__*/
(function (_React$Component) {
  _inheritsLoose$1(StaticRouter, _React$Component);

  function StaticRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _this.handlePush = function (location) {
      return _this.navigateTo(location, "PUSH");
    };

    _this.handleReplace = function (location) {
      return _this.navigateTo(location, "REPLACE");
    };

    _this.handleListen = function () {
      return noop;
    };

    _this.handleBlock = function () {
      return noop;
    };

    return _this;
  }

  var _proto = StaticRouter.prototype;

  _proto.navigateTo = function navigateTo(location, action) {
    var _this$props = this.props,
        _this$props$basename = _this$props.basename,
        basename = _this$props$basename === void 0 ? "" : _this$props$basename,
        _this$props$context = _this$props.context,
        context = _this$props$context === void 0 ? {} : _this$props$context;
    context.action = action;
    context.location = addBasename(basename, createLocation(location));
    context.url = createURL(context.location);
  };

  _proto.render = function render() {
    var _this$props2 = this.props,
        _this$props2$basename = _this$props2.basename,
        basename = _this$props2$basename === void 0 ? "" : _this$props2$basename,
        _this$props2$context = _this$props2.context,
        context = _this$props2$context === void 0 ? {} : _this$props2$context,
        _this$props2$location = _this$props2.location,
        location = _this$props2$location === void 0 ? "/" : _this$props2$location,
        rest = _objectWithoutPropertiesLoose$1(_this$props2, ["basename", "context", "location"]);

    var history = {
      createHref: function createHref(path) {
        return addLeadingSlash(basename + createURL(path));
      },
      action: "POP",
      location: stripBasename(basename, createLocation(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler(),
      goBack: staticHandler(),
      goForward: staticHandler(),
      listen: this.handleListen,
      block: this.handleBlock
    };
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Router, _extends$1({}, rest, {
      history: history,
      staticContext: context
    }));
  };

  return StaticRouter;
})(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Component);

/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose$1(Switch, _React$Component);

  function Switch() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = Switch.prototype;

  _proto.render = function render() {
    var _this = this;

    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(context.Consumer, null, function (context) {
      !context ? invariant(false) : void 0;
      var location = _this.props.location || context.location;
      var element, match; // We use React.Children.forEach instead of React.Children.toArray().find()
      // here because toArray adds keys to all child elements and we do not want
      // to trigger an unmount/remount for two <Route>s that render the same
      // component at different URLs.

      _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Children.forEach(_this.props.children, function (child) {
        if (match == null && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.isValidElement(child)) {
          element = child;
          var path = child.props.path || child.props.from;
          match = path ? matchPath(location.pathname, _extends$1({}, child.props, {
            path: path
          })) : context.match;
        }
      });
      return match ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.cloneElement(element, {
        location: location,
        computedMatch: match
      }) : null;
    });
  };

  return Switch;
}(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Component);

var useContext = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useContext;
function useHistory() {

  return useContext(historyContext);
}
function useLocation() {

  return useContext(context).location;
}
function useRouteMatch(path) {

  var location = useLocation();
  var match = useContext(context).match;
  return path ? matchPath(location.pathname, path) : match;
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

/**
 * The public API for a <Router> that uses HTML5 history.
 */

/*#__PURE__*/
(function (_React$Component) {
  _inheritsLoose(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = createBrowserHistory(_this.props);
    return _this;
  }

  var _proto = BrowserRouter.prototype;

  _proto.render = function render() {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return BrowserRouter;
})(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Component);

/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(HashRouter, _React$Component);

  function HashRouter() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
    _this.history = createHashHistory(_this.props);
    return _this;
  }

  var _proto = HashRouter.prototype;

  _proto.render = function render() {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Router, {
      history: this.history,
      children: this.props.children
    });
  };

  return HashRouter;
}(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Component);

var resolveToLocation = function resolveToLocation(to, currentLocation) {
  return typeof to === "function" ? to(currentLocation) : to;
};
var normalizeToLocation = function normalizeToLocation(to, currentLocation) {
  return typeof to === "string" ? createLocation(to, null, null, currentLocation) : to;
};

var forwardRefShim = function forwardRefShim(C) {
  return C;
};

var forwardRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.forwardRef;

if (typeof forwardRef === "undefined") {
  forwardRef = forwardRefShim;
}

function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}

var LinkAnchor = forwardRef(function (_ref, forwardedRef) {
  var innerRef = _ref.innerRef,
      navigate = _ref.navigate,
      _onClick = _ref.onClick,
      rest = _objectWithoutPropertiesLoose(_ref, ["innerRef", "navigate", "onClick"]);

  var target = rest.target;

  var props = _extends({}, rest, {
    onClick: function onClick(event) {
      try {
        if (_onClick) _onClick(event);
      } catch (ex) {
        event.preventDefault();
        throw ex;
      }

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && ( // ignore everything but left clicks
      !target || target === "_self") && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();
          navigate();
        }
    }
  }); // React 15 compat


  if (forwardRefShim !== forwardRef) {
    props.ref = forwardedRef || innerRef;
  } else {
    props.ref = innerRef;
  }
  /* eslint-disable-next-line jsx-a11y/anchor-has-content */


  return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("a", props);
});
/**
 * The public API for rendering a history-aware <a>.
 */


var Link = forwardRef(function (_ref2, forwardedRef) {
  var _ref2$component = _ref2.component,
      component = _ref2$component === void 0 ? LinkAnchor : _ref2$component,
      replace = _ref2.replace,
      to = _ref2.to,
      innerRef = _ref2.innerRef,
      rest = _objectWithoutPropertiesLoose(_ref2, ["component", "replace", "to", "innerRef"]);

  return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(context.Consumer, null, function (context) {
    !context ? invariant(false) : void 0;
    var history = context.history;
    var location = normalizeToLocation(resolveToLocation(to, context.location), context.location);
    var href = location ? history.createHref(location) : "";

    var props = _extends({}, rest, {
      href: href,
      navigate: function navigate() {
        var location = resolveToLocation(to, context.location);
        var method = replace ? history.replace : history.push;
        method(location);
      }
    }); // React 15 compat


    if (forwardRefShim !== forwardRef) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(component, props);
  });
});

var forwardRefShim$1 = function forwardRefShim(C) {
  return C;
};

var forwardRef$1 = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.forwardRef;

if (typeof forwardRef$1 === "undefined") {
  forwardRef$1 = forwardRefShim$1;
}

function joinClassnames() {
  for (var _len = arguments.length, classnames = new Array(_len), _key = 0; _key < _len; _key++) {
    classnames[_key] = arguments[_key];
  }

  return classnames.filter(function (i) {
    return i;
  }).join(" ");
}
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */


forwardRef$1(function (_ref, forwardedRef) {
  var _ref$ariaCurrent = _ref["aria-current"],
      ariaCurrent = _ref$ariaCurrent === void 0 ? "page" : _ref$ariaCurrent,
      _ref$activeClassName = _ref.activeClassName,
      activeClassName = _ref$activeClassName === void 0 ? "active" : _ref$activeClassName,
      activeStyle = _ref.activeStyle,
      classNameProp = _ref.className,
      exact = _ref.exact,
      isActiveProp = _ref.isActive,
      locationProp = _ref.location,
      sensitive = _ref.sensitive,
      strict = _ref.strict,
      styleProp = _ref.style,
      to = _ref.to,
      innerRef = _ref.innerRef,
      rest = _objectWithoutPropertiesLoose(_ref, ["aria-current", "activeClassName", "activeStyle", "className", "exact", "isActive", "location", "sensitive", "strict", "style", "to", "innerRef"]);

  return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(context.Consumer, null, function (context) {
    !context ? invariant(false) : void 0;
    var currentLocation = locationProp || context.location;
    var toLocation = normalizeToLocation(resolveToLocation(to, currentLocation), currentLocation);
    var path = toLocation.pathname; // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202

    var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
    var match = escapedPath ? matchPath(currentLocation.pathname, {
      path: escapedPath,
      exact: exact,
      sensitive: sensitive,
      strict: strict
    }) : null;
    var isActive = !!(isActiveProp ? isActiveProp(match, currentLocation) : match);
    var className = isActive ? joinClassnames(classNameProp, activeClassName) : classNameProp;
    var style = isActive ? _extends({}, styleProp, {}, activeStyle) : styleProp;

    var props = _extends({
      "aria-current": isActive && ariaCurrent || null,
      className: className,
      style: style,
      to: toLocation
    }, rest); // React 15 compat


    if (forwardRefShim$1 !== forwardRef$1) {
      props.ref = forwardedRef || innerRef;
    } else {
      props.innerRef = innerRef;
    }

    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Link, props);
  });
});

/*!
 * get-value <https://github.com/jonschlinkert/get-value>
 *
 * Copyright (c) 2014-2018, Jon Schlinkert.
 * Released under the MIT License.
 */

const isObject = _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.i;

var getValue = function(target, path, options) {
  if (!isObject(options)) {
    options = { default: options };
  }

  if (!isValidObject(target)) {
    return typeof options.default !== 'undefined' ? options.default : target;
  }

  if (typeof path === 'number') {
    path = String(path);
  }

  const isArray = Array.isArray(path);
  const isString = typeof path === 'string';
  const splitChar = options.separator || '.';
  const joinChar = options.joinChar || (typeof splitChar === 'string' ? splitChar : '.');

  if (!isString && !isArray) {
    return target;
  }

  if (isString && path in target) {
    return isValid$1(path, target, options) ? target[path] : options.default;
  }

  let segs = isArray ? path : split(path, splitChar, options);
  let len = segs.length;
  let idx = 0;

  do {
    let prop = segs[idx];
    if (typeof prop === 'number') {
      prop = String(prop);
    }

    while (prop && prop.slice(-1) === '\\') {
      prop = join([prop.slice(0, -1), segs[++idx] || ''], joinChar, options);
    }

    if (prop in target) {
      if (!isValid$1(prop, target, options)) {
        return options.default;
      }

      target = target[prop];
    } else {
      let hasProp = false;
      let n = idx + 1;

      while (n < len) {
        prop = join([prop, segs[n++]], joinChar, options);

        if ((hasProp = prop in target)) {
          if (!isValid$1(prop, target, options)) {
            return options.default;
          }

          target = target[prop];
          idx = n - 1;
          break;
        }
      }

      if (!hasProp) {
        return options.default;
      }
    }
  } while (++idx < len && isValidObject(target));

  if (idx === len) {
    return target;
  }

  return options.default;
};

function join(segs, joinChar, options) {
  if (typeof options.join === 'function') {
    return options.join(segs);
  }
  return segs[0] + joinChar + segs[1];
}

function split(path, splitChar, options) {
  if (typeof options.split === 'function') {
    return options.split(path);
  }
  return path.split(splitChar);
}

function isValid$1(key, target, options) {
  if (typeof options.isValid === 'function') {
    return options.isValid(key, target);
  }
  return true;
}

function isValidObject(val) {
  return isObject(val) || Array.isArray(val) || typeof val === 'function';
}

var getValue$1 = getValue;

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }

  var number = Number(dirtyNumber);

  if (isNaN(number)) {
    return number;
  }

  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */

function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument); // Clone the date

  if (argument instanceof Date || typeof argument === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://git.io/fjule"); // eslint-disable-next-line no-console

      console.warn(new Error().stack);
    }

    return new Date(NaN);
  }
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */

function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  date.setDate(date.getDate() + amount);
  return date;
}

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */

function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);

  if (isNaN(amount)) {
    return new Date(NaN);
  }

  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }

  var dayOfMonth = date.getDate(); // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 1, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.

  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();

  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */

function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

var MILLISECONDS_IN_MINUTE$2 = 60000;

function getDateMillisecondsPart(date) {
  return date.getTime() % MILLISECONDS_IN_MINUTE$2;
}
/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */


function getTimezoneOffsetInMilliseconds(dirtyDate) {
  var date = new Date(dirtyDate.getTime());
  var baseTimezoneOffset = Math.ceil(date.getTimezoneOffset());
  date.setSeconds(0, 0);
  var hasNegativeUTCOffset = baseTimezoneOffset > 0;
  var millisecondsPartOfTimezoneOffset = hasNegativeUTCOffset ? (MILLISECONDS_IN_MINUTE$2 + getDateMillisecondsPart(date)) % MILLISECONDS_IN_MINUTE$2 : getDateMillisecondsPart(date);
  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE$2 + millisecondsPartOfTimezoneOffset;
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */

function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

var MILLISECONDS_IN_DAY$1 = 86400000;
/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * var result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */

function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight); // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)

  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY$1);
}

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */

function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - Now `isValid` doesn't throw an exception
 *   if the first argument is not an instance of Date.
 *   Instead, argument is converted beforehand using `toDate`.
 *
 *   Examples:
 *
 *   | `isValid` argument        | Before v2.0.0 | v2.0.0 onward |
 *   |---------------------------|---------------|---------------|
 *   | `new Date()`              | `true`        | `true`        |
 *   | `new Date('2016-01-01')`  | `true`        | `true`        |
 *   | `new Date('')`            | `false`       | `false`       |
 *   | `new Date(1488370835081)` | `true`        | `true`        |
 *   | `new Date(NaN)`           | `false`       | `false`       |
 *   | `'2016-01-01'`            | `TypeError`   | `false`       |
 *   | `''`                      | `TypeError`   | `false`       |
 *   | `1488370835081`           | `TypeError`   | `true`        |
 *   | `NaN`                     | `TypeError`   | `false`       |
 *
 *   We introduce this change to make *date-fns* consistent with ECMAScript behavior
 *   that try to coerce arguments to the expected type
 *   (which is also the case with other *date-fns* functions).
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * var result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */

function isValid(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  return !isNaN(date);
}

// for accurate equality comparisons of UTC timestamps that end up
// having the same representation in local time, e.g. one hour before
// DST ends vs. the instant that DST ends.

function compareLocalAsc(dateLeft, dateRight) {
  var diff = dateLeft.getFullYear() - dateRight.getFullYear() || dateLeft.getMonth() - dateRight.getMonth() || dateLeft.getDate() - dateRight.getDate() || dateLeft.getHours() - dateRight.getHours() || dateLeft.getMinutes() - dateRight.getMinutes() || dateLeft.getSeconds() - dateRight.getSeconds() || dateLeft.getMilliseconds() - dateRight.getMilliseconds();

  if (diff < 0) {
    return -1;
  } else if (diff > 0) {
    return 1; // Return 0 if diff is 0; return NaN if diff is NaN
  } else {
    return diff;
  }
}
/**
 * @name differenceInDays
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full day periods between two dates. Fractional days are
 * truncated towards zero.
 *
 * One "full day" is the distance between a local time in one day to the same
 * local time on the next or previous day. A full day can sometimes be less than
 * or more than 24 hours if a daylight savings change happens between two dates.
 *
 * To ignore DST and only measure exact 24-hour periods, use this instead:
 * `Math.floor(differenceInHours(dateLeft, dateRight)/24)|0`.
 *
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of full days according to the local timezone
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 * // How many full days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * var result = differenceInDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 0
 * // How many full days are between
 * // 1 March 2020 0:00 and 1 June 2020 0:00 ?
 * // Note: because local time is used, the
 * // result will always be 92 days, even in
 * // time zones where DST starts and the
 * // period has only 92*24-1 hours.
 * var result = differenceInDays(
 *   new Date(2020, 5, 1),
 *   new Date(2020, 2, 1)
 * )
//=> 92
 */


function differenceInDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var sign = compareLocalAsc(dateLeft, dateRight);
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight));
  dateLeft.setDate(dateLeft.getDate() - sign * difference); // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value

  var isLastDayNotFull = compareLocalAsc(dateLeft, dateRight) === -sign;
  var result = sign * (difference - isLastDayNotFull); // Prevent negative zero

  return result === 0 ? 0 : result;
}

/**
 * @name differenceInMilliseconds
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * var result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */

function differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getTime() - dateRight.getTime();
}

var MILLISECONDS_IN_MINUTE$1 = 60000;
/**
 * @name differenceInMinutes
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the signed number of full (rounded towards 0) minutes between the given dates.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of minutes
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * var result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 *
 * @example
 * // How many minutes are from 10:01:59 to 10:00:00
 * var result = differenceInMinutes(
 *   new Date(2000, 0, 1, 10, 0, 0),
 *   new Date(2000, 0, 1, 10, 1, 59)
 * )
 * //=> -1
 */

function differenceInMinutes(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE$1;
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff);
}

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }

  return result;
}

function buildFormatLongFn(args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;

var formatRelativeLocale = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter'] // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.

};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};

function ordinalNumber(dirtyNumber, _dirtyOptions) {
  var number = Number(dirtyNumber); // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`:
  //
  //   var options = dirtyOptions || {}
  //   var unit = String(options.unit)
  //
  // where `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'

  var rem100 = number % 100;

  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';

      case 2:
        return number + 'nd';

      case 3:
        return number + 'rd';
    }
  }

  return number + 'th';
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

function buildMatchPatternFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var matchResult = string.match(args.matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);

    if (!parseResult) {
      return null;
    }

    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function buildMatchFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var value;

    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
      value = findIndex(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      });
    } else {
      value = findKey(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      });
    }

    value = args.valueCallback ? args.valueCallback(value) : value;
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
}

var matchOrdinalNumberPattern = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */

var locale = {
  code: 'en-US',
  formatDistance: formatDistance,
  formatLong: formatLong$1,
  formatRelative: formatRelative,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0
    /* Sunday */
    ,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale;

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */

function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();

  while (output.length < targetLength) {
    output = '0' + output;
  }

  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */

var formatters$2 = {
  // Year
  y: function (date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
    var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function (date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function (date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function (date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();

      case 'aaa':
        return dayPeriodEnumValue;

      case 'aaaaa':
        return dayPeriodEnumValue[0];

      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function (date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function (date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function (date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function (date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function (date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var formatters$3 = formatters$2;

var MILLISECONDS_IN_DAY = 86400000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeek(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeWeekStartsOn = locale && locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate, dirtyOptions);
  var year = date.getUTCFullYear();
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, dirtyOptions);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, dirtyOptions);

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

// See issue: https://github.com/date-fns/date-fns/issues/376

function startOfUTCWeekYear(dirtyDate, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var locale = options.locale;
  var localeFirstWeekContainsDate = locale && locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate);
  var year = getUTCWeekYear(dirtyDate, dirtyOptions);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, dirtyOptions);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000; // This function will be a part of public API when UTC function will be implemented.
// See issue: https://github.com/date-fns/date-fns/issues/376

function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime(); // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)

  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
  /*
   * |     | Unit                           |     | Unit                           |
   * |-----|--------------------------------|-----|--------------------------------|
   * |  a  | AM, PM                         |  A* | Milliseconds in day            |
   * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
   * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
   * |  d  | Day of month                   |  D  | Day of year                    |
   * |  e  | Local day of week              |  E  | Day of week                    |
   * |  f  |                                |  F* | Day of week in month           |
   * |  g* | Modified Julian day            |  G  | Era                            |
   * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
   * |  i! | ISO day of week                |  I! | ISO week of year               |
   * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
   * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
   * |  l* | (deprecated)                   |  L  | Stand-alone month              |
   * |  m  | Minute                         |  M  | Month                          |
   * |  n  |                                |  N  |                                |
   * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
   * |  p! | Long localized time            |  P! | Long localized date            |
   * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
   * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
   * |  s  | Second                         |  S  | Fraction of second             |
   * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
   * |  u  | Extended year                  |  U* | Cyclic year                    |
   * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
   * |  w  | Local week of year             |  W* | Week of month                  |
   * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
   * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
   * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
   *
   * Letters marked by * are not implemented but reserved by Unicode standard.
   *
   * Letters marked by ! are non-standard, but implemented by date-fns:
   * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
   * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
   *   i.e. 7 for Sunday, 1 for Monday, etc.
   * - `I` is ISO week of year, as opposed to `w` which is local week of year.
   * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
   *   `R` is supposed to be used in conjunction with `I` and `i`
   *   for universal ISO week-numbering date, whereas
   *   `Y` is supposed to be used in conjunction with `w` and `e`
   *   for week-numbering date specific to the locale.
   * - `P` is long localized date format
   * - `p` is long localized time format
   */

};
var formatters = {
  // Era
  G: function (date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;

    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B

      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ

      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function (date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear(); // Returns 1 for 1 BC (which is year 0 in JavaScript)

      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }

    return formatters$3.y(date, token);
  },
  // Local week-numbering year
  Y: function (date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options); // Returns 1 for 1 BC (which is year 0 in JavaScript)

    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear; // Two digit year

    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    } // Ordinal number


    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    } // Padding


    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function (date, token) {
    var isoWeekYear = getUTCISOWeekYear(date); // Padding

    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function (date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...

      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function (date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);

    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04

      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th

      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4

      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)

      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...

      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      case 'M':
      case 'MM':
        return formatters$3.M(date, token);
      // 1st, 2nd, ..., 12th

      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D

      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December

      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function (date, token, localize) {
    var month = date.getUTCMonth();

    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12

      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th

      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec

      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D

      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December

      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function (date, token, localize, options) {
    var week = getUTCWeek(date, options);

    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }

    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function (date, token, localize) {
    var isoWeek = getUTCISOWeek(date);

    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }

    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function (date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }

    return formatters$3.d(date, token);
  },
  // Day of year
  D: function (date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);

    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }

    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();

    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th

      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function (date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;

    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value

      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th

      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });

      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T

      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu

      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday

      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function (date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;

    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02

      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd

      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue

      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T

      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu

      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday

      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';

    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }

    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();

      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function (date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;

    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }

    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });

      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });

      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function (date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return formatters$3.h(date, token);
  },
  // Hour [0-23]
  H: function (date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }

    return formatters$3.H(date, token);
  },
  // Hour [0-11]
  K: function (date, token, localize) {
    var hours = date.getUTCHours() % 12;

    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function (date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;

    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }

    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function (date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }

    return formatters$3.m(date, token);
  },
  // Second
  s: function (date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }

    return formatters$3.s(date, token);
  },
  // Fraction of second
  S: function (date, token) {
    return formatters$3.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    if (timezoneOffset === 0) {
      return 'Z';
    }

    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`

      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`

      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`

      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`

      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter

      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();

    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long

      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function (date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};

function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;

  if (minutes === 0) {
    return sign + String(hours);
  }

  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}

function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }

  return formatTimezone(offset, dirtyDelimiter);
}

function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}

var formatters$1 = formatters;

function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });

    case 'PP':
      return formatLong.date({
        width: 'medium'
      });

    case 'PPP':
      return formatLong.date({
        width: 'long'
      });

    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
}

function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });

    case 'pp':
      return formatLong.time({
        width: 'medium'
      });

    case 'ppp':
      return formatLong.time({
        width: 'long'
      });

    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
}

function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/);
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];

  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }

  var dateTimeFormat;

  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;

    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;

    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;

    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }

  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
}

var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$1 = longFormatters;

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://git.io/fxCyr"));
  }
}

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps

var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g; // This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`

var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;
/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://git.io/fxCyr
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Su, Sa        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Su, Sa        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 0001, ..., 999               |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://git.io/fxCyr
 *
 * 9. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://git.io/fxCyr
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The second argument is now required for the sake of explicitness.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   format(new Date(2016, 0, 1))
 *
 *   // v2.0.0 onward
 *   format(new Date(2016, 0, 1), "yyyy-MM-dd'T'HH:mm:ss.SSSxxx")
 *   ```
 *
 * - New format string API for `format` function
 *   which is based on [Unicode Technical Standard #35](https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table).
 *   See [this post](https://blog.date-fns.org/post/unicode-tokens-in-date-fns-v2-sreatyki91jg) for more details.
 *
 * - Characters are now escaped using single quote symbols (`'`) instead of square brackets.
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://git.io/fxCyr
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://git.io/fxCyr
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://git.io/fxCyr
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * var result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * var result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, dirtyOptions) {
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var options = dirtyOptions || {};
  var locale = options.locale || defaultLocale;
  var localeFirstWeekContainsDate = locale.options && locale.options.firstWeekContainsDate;
  var defaultFirstWeekContainsDate = localeFirstWeekContainsDate == null ? 1 : toInteger(localeFirstWeekContainsDate);
  var firstWeekContainsDate = options.firstWeekContainsDate == null ? defaultFirstWeekContainsDate : toInteger(options.firstWeekContainsDate); // Test if weekStartsOn is between 1 and 7 _and_ is not NaN

  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }

  var localeWeekStartsOn = locale.options && locale.options.weekStartsOn;
  var defaultWeekStartsOn = localeWeekStartsOn == null ? 0 : toInteger(localeWeekStartsOn);
  var weekStartsOn = options.weekStartsOn == null ? defaultWeekStartsOn : toInteger(options.weekStartsOn); // Test if weekStartsOn is between 0 and 6 _and_ is not NaN

  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }

  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }

  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }

  var originalDate = toDate(dirtyDate);

  if (!isValid(originalDate)) {
    throw new RangeError('Invalid time value');
  } // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376


  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];

    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong, formatterOptions);
    }

    return substring;
  }).join('').match(formattingTokensRegExp).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }

    var firstCharacter = substring[0];

    if (firstCharacter === "'") {
      return cleanEscapedString(substring);
    }

    var formatter = formatters$1[firstCharacter];

    if (formatter) {
      if (!options.useAdditionalWeekYearTokens && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      if (!options.useAdditionalDayOfYearTokens && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, dirtyDate);
      }

      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }

    if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }

    return substring;
  }).join('');
  return result;
}

function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */

function subDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addDays(dirtyDate, -amount);
}

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */

function subMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}

var MILLISECONDS_IN_HOUR = 3600000;
var MILLISECONDS_IN_MINUTE = 60000;
var DEFAULT_ADDITIONAL_DIGITS = 2;
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * - The previous `parse` implementation was renamed to `parseISO`.
 *
 *   ```javascript
 *   // Before v2.0.0
 *   parse('2016-01-01')
 *
 *   // v2.0.0 onward
 *   parseISO('2016-01-01')
 *   ```
 *
 * - `parseISO` now validates separate date and time values in ISO-8601 strings
 *   and returns `Invalid Date` if the date is invalid.
 *
 *   ```javascript
 *   parseISO('2018-13-32')
 *   //=> Invalid Date
 *   ```
 *
 * - `parseISO` now doesn't fall back to `new Date` constructor
 *   if it fails to parse a string argument. Instead, it returns `Invalid Date`.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * var result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */

function parseISO(argument, dirtyOptions) {
  requiredArgs(1, arguments);
  var options = dirtyOptions || {};
  var additionalDigits = options.additionalDigits == null ? DEFAULT_ADDITIONAL_DIGITS : toInteger(options.additionalDigits);

  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }

  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }

  var dateStrings = splitDateString(argument);
  var date;

  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }

  if (isNaN(date) || !date) {
    return new Date(NaN);
  }

  var timestamp = date.getTime();
  var time = 0;
  var offset;

  if (dateStrings.time) {
    time = parseTime(dateStrings.time);

    if (isNaN(time) || time === null) {
      return new Date(NaN);
    }
  }

  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);

    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time); // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.

    var result = new Date(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate(), dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    result.setFullYear(dirtyDate.getUTCFullYear());
    return result;
  }

  return new Date(timestamp + time + offset);
}

function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString; // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].

  if (array.length > 2) {
    return dateStrings;
  }

  if (/:/.test(array[0])) {
    dateStrings.date = null;
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];

    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }

  if (timeString) {
    var token = patterns.timezone.exec(timeString);

    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }

  return dateStrings;
}

function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex); // Invalid ISO-formatted year

  if (!captures) return {
    year: null
  };
  var year = captures[1] && parseInt(captures[1]);
  var century = captures[2] && parseInt(captures[2]);
  return {
    year: century == null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}

function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return null;
  var captures = dateString.match(dateRegex); // Invalid ISO-formatted string

  if (!captures) return null;
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;

  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }

    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);

    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }

    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}

function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}

function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return null; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);

  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }

  return hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE + seconds * 1000;
}

function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}

function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;

  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }

  return sign * (hours * MILLISECONDS_IN_HOUR + minutes * MILLISECONDS_IN_MINUTE);
}

function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
} // Validation functions
// February is null to handle the leap year (using ||)


var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100;
}

function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}

function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}

function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}

function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }

  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}

function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * ### v2.0.0 breaking changes:
 *
 * - [Changes that are common for the whole library](https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#Common-Changes).
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */

function subYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addYears(dirtyDate, -amount);
}

var Download = {};

var _interopRequireDefault = _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bL.exports;

Object.defineProperty(Download, "__esModule", {
  value: true
});
var default_1 = Download.default = void 0;

var _createSvgIcon = _interopRequireDefault(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bK);

var _jsxRuntime = _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aQ.exports;

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M5 20h14v-2H5v2zM19 9h-4V3H9v6H5l7 7 7-7z"
}), 'Download');

default_1 = Download.default = _default;

const AppDialogContext = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createContext({ closeAdminBox: () => { } });
const AppDialog = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(props => {
    var _a, _b, _c;
    const theme = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.F)();
    const [open, setOpen] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(true);
    const { injector, themeOptions, builderMode } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const mediaQueryMdDown = useMuiMediaQuery(theme.breakpoints.down('md'));
    const fullScreen = (_c = (_b = (_a = themeOptions === null || themeOptions === void 0 ? void 0 : themeOptions.adminPortal) === null || _a === void 0 ? void 0 : _a.layout) === null || _b === void 0 ? void 0 : _b.fullScreenMode) !== null && _c !== void 0 ? _c : mediaQueryMdDown;
    const rootElementStyle = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
        style: { height: fullScreen ? undefined : 'calc(100vh - 100px)', overflow: 'hidden' },
    }), [fullScreen]);
    const closeAdminBox = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        if (!builderMode) {
            setOpen(false);
            setTimeout(() => injector === null || injector === void 0 ? void 0 : injector.close(), 300);
        }
    }, [injector, builderMode]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AppDialogContext.Provider, { value: { closeAdminBox } },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bM, Object.assign({ open: open }, props, { container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, fullWidth: true, maxWidth: 'xl', fullScreen: fullScreen, onBackdropClick: closeAdminBox, PaperProps: rootElementStyle })));
}) `
  & .MuiDialog-paper {
    transition: all 300ms;
  }
`;

const SkeletonListItem = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bN)({
    width: '100%',
});
SkeletonListItem.defaultProps = {
    variant: 'rectangular',
    height: 36,
    sx: { mb: 8 },
};
const SkeletonTenantName = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)((props) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bN, Object.assign({ variant: 'rectangular', height: 16 }, props))) `
  width: 60%;
  margin-top: 24px;
  margin-bottom: 24px;
`;
const NavSkeleton = () => {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("nav", null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, spacing: 3, justifyContent: 'center', alignItems: 'center', mt: 2, mb: 8 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bN, { variant: 'circular', height: 32, width: 32 })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bN, { variant: 'text', height: 18, width: '60%' }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bN, { variant: 'text', height: 16, width: '90%' }))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SkeletonListItem, { sx: { mb: 8, mt: 6 } }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SkeletonListItem, null),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SkeletonListItem, null),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SkeletonTenantName, null),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SkeletonListItem, null),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SkeletonListItem, null),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SkeletonListItem, null),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SkeletonListItem, null),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SkeletonListItem, null),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SkeletonListItem, null),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SkeletonListItem, null));
};

const PageTitleSkeleton = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B) `
  height: 5.5rem;
  border-bottom: 1px solid ${({ theme }) => theme.palette.divider};

  ${({ theme }) => theme.breakpoints.down('sm')} {
    height: 3.5rem;
  }
`;
const PageSkeleton = () => {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("div", null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageTitleSkeleton, null));
};

const NavigationGridItem = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G)(({ theme, withPoweredBy }) => ({
    transition: 'width 300ms ease-in-out, padding 300ms ease-in-out',
    width: '14.25rem',
    position: 'relative',
    height: '100%',
    backgroundColor: theme.navigation.background,
    'nav': {
        boxSizing: 'border-box',
        padding: theme.spacing(4),
        overflow: 'auto',
        maxHeight: '100%',
        paddingBottom: withPoweredBy ? '5rem' : undefined,
    },
    [theme.breakpoints.up('xl')]: {
        width: '18rem',
        'nav': {
            padding: theme.spacing(4, 6),
            paddingBottom: withPoweredBy ? '5rem' : undefined,
        },
    },
    [theme.breakpoints.up('sm')]: {
        width: '18rem',
        'nav': {
            padding: theme.spacing(4, 6),
            paddingBottom: withPoweredBy ? '5rem' : undefined,
        },
    },
}));
NavigationGridItem.defaultProps = {
    item: true,
};
const PageGridItem = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G)(({ theme }) => ({
    backgroundColor: theme.palette.background.default,
    overflow: 'auto',
}));
const StyledGrid = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G)(({ theme }) => ({
    fontFamily: theme.typographyStyleOptions,
}));
const AppSkeleton = ({ absolute }) => {
    const overrideStyle = absolute ? { position: 'absolute', left: 0, top: 0, zIndex: 1000 } : {};
    const theme = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.F)();
    const displayAsDrawer = useMuiMediaQuery(theme.breakpoints.down('sm'));
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StyledGrid, { "data-test-id": 'admin-portal-loader', height: '100%', container: true, alignItems: "stretch", style: overrideStyle },
        !displayAsDrawer && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(NavigationGridItem, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(NavSkeleton, null)),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageGridItem, { item: true, xs: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageSkeleton, null)));
};

const UserAvatar = () => {
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.X)();
    return user ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cu, { name: user.name, picture: user.profilePictureUrl }) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ce, null);
};

const wrapPage = (Component, pageKey) => {
    return () => {
        const t = useT(pageKey);
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cv, { title: t('pageTitle') }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Component, null));
    };
};

const callbackToPromise = (resolve, reject, closeable) => (data, error) => {
    if (error) {
        if (typeof error === typeof Error) {
            reject(error);
        }
        else {
            reject(new Error(error));
        }
        return;
    }
    resolve(data);
    closeable === null || closeable === void 0 ? void 0 : closeable(data);
};
const notNull = (p) => !!p;
const getUserMetadataTitle = (user) => {
    let metadata = {};
    try {
        metadata = JSON.parse(user.metadata);
    }
    catch (e) {
        // ignore metadata data parse error
    }
    return (metadata !== null && metadata !== void 0 ? metadata : {}).title;
};
const getUserMetadata = (user, key) => {
    let metadata = {};
    try {
        metadata = JSON.parse(user.metadata);
    }
    catch (e) {
        // ignore metadata data parse error
    }
    return key ? getValue$1(metadata, key) : metadata;
};
const addUserMetadata = (user, newMetadata) => {
    let metadata = {};
    try {
        metadata = JSON.parse(user.metadata);
    }
    catch (e) {
        // ignore metadata data parse error
    }
    return JSON.stringify(Object.assign(Object.assign({}, metadata), newMetadata));
};
const formatAddress = (addressMetadata) => {
    const { address1, address2, city, state, postCode, country, } = addressMetadata !== null && addressMetadata !== void 0 ? addressMetadata : {};
    return [
        address1,
        address2,
        city,
        state,
        postCode,
        country,
    ].filter(notNull).join(', ');
};
const getUserAddress = (user) => {
    var _a;
    return (_a = formatAddress(getUserMetadata(user, 'address'))) !== null && _a !== void 0 ? _a : '';
};
const getUserFullName = (user) => {
    return [getUserMetadataTitle(user), user.name].filter(notNull).join('. ');
};

const defaultPasswordConfig = {
    allowPassphrases: true,
    maxLength: 128,
    minLength: 6,
    minOptionalTestsToPass: 1,
    minPhraseLength: 6,
};
var MfaTypeEnum;
(function (MfaTypeEnum) {
    MfaTypeEnum["DontForce"] = "DontForce";
    MfaTypeEnum["Force"] = "Force";
    MfaTypeEnum["ForceExceptSAML"] = "ForceExceptSAML";
})(MfaTypeEnum || (MfaTypeEnum = {}));
const useOptionalEnforceMfaTypes = () => {
    const vendorMfaPolicy = useVendorMfaPolicySettings(true);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        var _a, _b, _c;
        if (vendorMfaPolicy.loading) {
            return [MfaTypeEnum.Force];
        }
        if (((_a = vendorMfaPolicy.policy) === null || _a === void 0 ? void 0 : _a.enforceMFAType) === MfaTypeEnum.DontForce || !((_b = vendorMfaPolicy.policy) === null || _b === void 0 ? void 0 : _b.enforceMFAType)) {
            return [MfaTypeEnum.DontForce, MfaTypeEnum.Force, MfaTypeEnum.ForceExceptSAML];
        }
        if (((_c = vendorMfaPolicy.policy) === null || _c === void 0 ? void 0 : _c.enforceMFAType) === 'ForceExceptSAML') {
            return [MfaTypeEnum.Force, MfaTypeEnum.ForceExceptSAML];
        }
        return [MfaTypeEnum.Force];
    }, [vendorMfaPolicy]);
};
const usePasswordConfig = (userId, loadOnMount = true) => {
    const { loadPasswordConfig } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a0)();
    const { passwordConfig, loading } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.$)();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (loading) {
            return;
        }
        if (!passwordConfig) {
            loadPasswordConfig({ userId });
        }
    }, [loading, passwordConfig, loadPasswordConfig]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        loadOnMount && loadPasswordConfig({ userId });
    }, [loadOnMount, loadPasswordConfig]);
    const passwordServerConfig = Object.assign(Object.assign({}, defaultPasswordConfig), passwordConfig);
    const strength = passwordServerConfig.minLength <= 6 ? 'easy' : passwordServerConfig.minLength <= 8 ? 'medium' : 'hard';
    return {
        loading,
        passwordConfig: loading && !passwordConfig ? null : passwordServerConfig,
        defaultPasswordConfig,
        strength,
    };
};
const useMfaPolicySettings = (loadOnMount = false) => {
    const { loading, policy, saving, error } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__._)(state => state.mfaPolicy);
    const { loadSecurityPolicyMfa, saveSecurityPolicyMfa } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a6)();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        (loadOnMount || !policy) && loadSecurityPolicyMfa();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadOnMount, loadSecurityPolicyMfa]);
    return { loading, saving, error, policy, saveSecurityPolicyMfa };
};
const useVendorMfaPolicySettings = (loadOnMount = false) => {
    const { loading, policy, saving, error } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__._)(state => state.vendorMfaPolicy);
    const { loadSecurityPolicyVendorMfa } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a6)();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        (loadOnMount || !policy) && loadSecurityPolicyVendorMfa();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadOnMount, loadSecurityPolicyVendorMfa]);
    return { loading, saving, error, policy };
};
const useLockoutPolicySettings = (loadOnMount = false) => {
    const { loading, policy, saving, error } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__._)(state => state.lockoutPolicy);
    const { loadSecurityPolicyLockout, saveSecurityPolicyLockout } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a6)();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        (loadOnMount || !policy) && loadSecurityPolicyLockout();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadOnMount, loadSecurityPolicyLockout]);
    return { loading, saving, error, policy, saveSecurityPolicyLockout };
};
const usePasswordHistoryPolicySettings = (loadOnMount = false) => {
    const { loading, policy, saving, error } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__._)(state => state.passwordHistoryPolicy);
    const { loadSecurityPolicyPasswordHistory, saveSecurityPolicyPasswordHistory } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a6)();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        (loadOnMount || !policy) && loadSecurityPolicyPasswordHistory();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadOnMount, loadSecurityPolicyPasswordHistory]);
    return { loading, saving, error, policy, saveSecurityPolicyPasswordHistory };
};
const usePublicPolicySettings = (loadOnMount = false) => {
    const { loading, policy, saving, error } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__._)(state => state.publicPolicy);
    const { loadPublicSecurityPolicy } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a6)();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        (loadOnMount || !policy) && loadPublicSecurityPolicy();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadOnMount, loadPublicSecurityPolicy]);
    return { loading, saving, error, policy };
};
const useDialogState = (defaultOpen = false) => {
    const [open, setOpen] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(defaultOpen);
    const [data, setData] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(null);
    const handleCloseEditName = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setOpen(false);
        setData(null);
    }, [setOpen]);
    const handleOpenEditName = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((data) => {
        setData(data);
        setOpen(true);
    }, [setOpen]);
    return [open, handleCloseEditName, handleOpenEditName, data, setOpen];
};
const useBooleanToggle = (delay) => {
    const [bool, setBoolean] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (bool) {
            setTimeout(() => {
                setBoolean(false);
            }, delay !== null && delay !== void 0 ? delay : 3000);
        }
    }, [bool]);
    return [bool, setBoolean];
};
const useEffectAfterMount = (fn, deps) => {
    const [mounted, setMounted] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => setMounted(true), [setMounted]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (!mounted) {
            return;
        }
        fn();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
const useDebounce = (value, delay = 300) => {
    const [debouncedValue, setDebouncedValue] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(value);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedValue(value);
        }, delay);
        return () => {
            clearTimeout(handler);
        };
    }, [value, delay]);
    return debouncedValue;
};
const useAsyncEffect = (effectFn, deps) => {
    const didMountRef = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef(true);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (didMountRef.current) {
            didMountRef.current = false;
            return;
        }
        // noinspection JSIgnoredPromiseFromCall
        effectFn();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [...deps]);
};
const useMemoProps = (props, key) => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => props[key], []);
};
const useRolesMap = (roles) => {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (roles !== null && roles !== void 0 ? roles : []).reduce((p, n) => (Object.assign(Object.assign({}, p), { [n.id]: n.name })), {}), [roles]);
};

const FormDialogBody = (props) => {
    const { initialValues, validationSchema, onSubmit, children, enableReinitialize, validateOnMount } = props;
    const [formError, setFormError] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(null);
    const formikProps = {
        onSubmit: (values, formikHelpers) => (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.g)(void 0, void 0, void 0, function* () {
            setFormError(null);
            try {
                yield onSubmit(values, formikHelpers);
            }
            catch (e) {
                setFormError(e.message);
            }
        }),
        enableReinitialize,
        initialValues,
        validationSchema,
        validateOnMount
    };
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.al, Object.assign({}, formikProps), props => {
        const canSubmit = !props.isSubmitting && props.isValid && props.dirty;
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.am, { autoComplete: 'on' }, children === null || children === void 0 ? void 0 : children(Object.assign(Object.assign({}, props), { canSubmit, formError })));
    });
};
const FormErrorDialogMessage = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ message, fieldName }) => {
    var _a, _b;
    let msg = ((_a = message === null || message === void 0 ? void 0 : message.startsWith) === null || _a === void 0 ? void 0 : _a.call(message, 'Error: ')) ? (_b = message === null || message === void 0 ? void 0 : message.substring) === null || _b === void 0 ? void 0 : _b.call(message, 'Error: '.length) : message;
    return msg ?
        // TODO: changed test-id from message to `${fieldName}-error`
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { component: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.A, mt: 4, "data-test-id": `${fieldName}-error` || msg, severity: 'error' }, msg)
        : null;
}, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bO)('message'));

const RemovePhotoForm = (props) => {
    const t = useT('profile');
    const { onClose } = props;
    const { saving, error, profile } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cD)();
    const { saveProfile, setProfileState } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cY)();
    const handleRemoveImage = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setProfileState({ profile: Object.assign(Object.assign({}, profile), { profilePictureUrl: 'null' }) });
    }, [profile, setProfileState]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if ((profile === null || profile === void 0 ? void 0 : profile.profilePictureUrl) === 'null') {
            saveProfile({
                callback: (_, error) => {
                    if (!error) {
                        onClose();
                    }
                },
            });
        }
    }, [profile, saveProfile, onClose]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'subtitle2Light' }, t('removeImageMessage')),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: error })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { color: 'inherit', variant: 'text', "data-test-id": 'remove-photo-btn', onClick: props.onClose }, t('removeImageCancelButton')),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { loading: saving, color: 'danger', onClick: handleRemoveImage }, t('removeImageButton'))));
};
const RemovePhotoDialog = (props) => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('profile');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { title: t('removeImageTitle') }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RemovePhotoForm, Object.assign({}, props)));
};

const HeaderContainer = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.C)(({ theme }) => ({
    backgroundColor: theme.rightPanel.profileHeader,
}));
const AvatarContainer = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)((props) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, Object.assign({ item: true }, props))) `
  & {
    margin: ${({ theme }) => `${theme.spacing(2)}`};
    position: relative;

    .MuiAvatar-root {
      width: 6.5rem;
      height: 6.5rem;
    }

    .show-on-hover {
      opacity: 0;
      transition: opacity 200ms ease-in-out;
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
    }

    &:hover {
      .show-on-hover {
        opacity: 1;
      }
    }
  }
`;
const UserEmptyAvatar = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bP) `
  &.MuiAvatar-root {
    background: ${_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.by.palette('grey.150')};
    color: ${_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.by.palette('grey.500')};
  }
`;
const EditAvatarButton = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bQ) `
  &.MuiIconButton-root {
    background: rgba(60, 74, 90, .7) !important;
    color: white;
  }
`;
const DetailsContainer = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)((props) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, Object.assign({ item: true, xs: true }, props))) `
  & {
    padding: ${({ theme }) => `${theme.spacing(2)}`};
    padding-left: ${({ theme }) => `${theme.spacing(8)}`};


    .MuiTypography-root {
      margin-bottom: .5rem;
      text-overflow: ellipsis;
      overflow: hidden;
      font-weight: 800;

      &:last-child {
        margin-bottom: 0;
        font-weight: 400;
        color: ${({ theme }) => theme.palette.grey[700]};
      }
    }
  }
`;
const JobTitleSpan = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('span') `
  font-size: 0.8em;
  font-weight: 400;
  color: ${({ theme }) => theme.palette.grey[600]}
`;
const toBase64 = (file) => new Promise((resolve, reject) => {
    if (file == null) {
        resolve('');
        return;
    }
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => { var _a, _b; return resolve((_b = (_a = reader.result) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : ''); };
    reader.onerror = (error) => reject(error);
});
const ProfileHeader = () => {
    const t = useT('profile');
    const [avatarAnchorEl, setAvatarAnchorEl] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(null);
    const [openDownloadBrowse, setOpenDownloadBrowse] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b$)();
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const jobTitle = getUserMetadata(user, 'jobTitle');
    const [uploadPhotoDialog, handleCloseUploadPhoto, handleOpenUploadPhoto] = useDialogState();
    const [removePhotoDialog, handleCloseRemovePhoto, handleOpenRemovePhoto] = useDialogState();
    const { saveProfile } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cY)();
    const menuItems = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => [{
            icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cZ, { "data-test-id": 'upload-avatar-icon' }),
            onClick: () => {
                setOpenDownloadBrowse(true);
                handleOpenUploadPhoto();
                setTimeout(() => {
                    setOpenDownloadBrowse(false);
                });
            },
            text: t('uploadImage'),
        },
        ...(user.profilePictureUrl && user.profilePictureUrl !== 'null' ? [{
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bZ, { "data-test-id": 'delete-avatar-icon' }),
                onClick: handleOpenRemovePhoto,
                text: t('removeImage'),
                negative: true,
            }] : []),
    ], [t, user, handleOpenUploadPhoto, handleOpenRemovePhoto]);
    const onEditAvatarClick = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e) => {
        if (user.profilePictureUrl && user.profilePictureUrl !== 'null') {
            setAvatarAnchorEl(e.currentTarget);
        }
        else {
            setOpenDownloadBrowse(true);
            handleOpenUploadPhoto();
            setTimeout(() => {
                setOpenDownloadBrowse(false);
            });
        }
    }, [handleOpenUploadPhoto, user.profilePictureUrl]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { sx: { mb: 8 } },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(HeaderContainer, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, justifyContent: 'center', alignItems: 'center' },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AvatarContainer, null,
                    user.profilePictureUrl && user.profilePictureUrl !== 'null' ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(UserAvatar, null) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(UserEmptyAvatar, { "data-test-id": 'empty-avatar' },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ce, null)),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditAvatarButton, { "data-test-id": "edit-avatar-btn", onClick: onEditAvatarClick, className: 'show-on-hover' },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c_, { "data-test-id": 'edit-avatar-icon' })),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c$, { anchorOrigin: {
                            vertical: 'bottom',
                            horizontal: 'center',
                        }, transformOrigin: {
                            vertical: 'top',
                            horizontal: 'center',
                        }, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, items: menuItems, onClose: () => setAvatarAnchorEl(null), anchorEl: avatarAnchorEl, open: !!avatarAnchorEl })),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DetailsContainer, null,
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'h4', "data-test-id": 'profile-header-name' },
                        getUserFullName(user),
                        " ",
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(JobTitleSpan, { "data-test-id": jobTitle }, jobTitle && `(${jobTitle})`)),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { "data-test-id": 'profile-header-email' }, user.email)))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d0, { open: uploadPhotoDialog, "data-test-id": "uploadPhotoDialog", openDownloadBrowse: openDownloadBrowse, onClose: handleCloseUploadPhoto, type: 'circle', uploadProgress: 0, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, onSubmit: (file) => new Promise((resolve, reject) => {
                toBase64(file).then(content => {
                    const callback = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aH)(() => {
                        handleCloseUploadPhoto();
                        resolve();
                    }, reject);
                    saveProfile({ profilePictureUrl: content, callback });
                });
            }) }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RemovePhotoDialog, { open: removePhotoDialog, onClose: handleCloseRemovePhoto }));
};

const DisplayNameField = () => {
    const t = useT('profile_EditName');
    const { values } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.u)();
    const displayName = [values.title, [values.firstName, values.lastName].filter(notNull).join(' ').trim()].filter(notNull).join('. ');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, { "data-test-id": "displayNameBox", label: t('displayNameInputLabel'), disabled: true, value: displayName });
};
const TitleField = () => {
    const t = useT('profile_EditName');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const [fieldProps, { error, touched }, { setValue }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('title');
    const options = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => [{
            label: t('nameTitle_mr'),
            value: 'Mr',
        }, {
            label: t('nameTitle_mrs'),
            value: 'Mrs',
        }, {
            label: t('nameTitle_miss'),
            value: 'Miss',
        }, {
            label: t('nameTitle_ms'),
            value: 'Ms',
        }, {
            label: t('nameTitle_dr'),
            value: 'Dr',
        }, {
            label: t('nameTitle_phd'),
            value: 'PhD',
        }], [t]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bS, { label: t('nameTitle'), clearable: true, name: fieldProps.name, value: fieldProps.value, onChange: (value) => setValue(value, true), errorMessage: touched ? error : undefined, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, options: options });
};
const FirstNameField$2 = () => {
    const t = useT('profile_EditName');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('firstName');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ label: t('firstNameInputLabel') }, fieldProps, { error: !!error && touched, errorMessage: error, "data-test-id": "firstNameBox", autoComplete: 'given-name' }));
};
const LastNameField$1 = () => {
    const t = useT('profile_EditName');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('lastName');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ label: t('lastNameInputLabel') }, fieldProps, { error: !!error && touched, errorMessage: error, "data-test-id": "lastNameBox", autoComplete: 'family-name' }));
};
const EditNameForm$1 = (props) => {
    const t = useT('profile_EditName');
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b$)();
    const { saveProfile } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cY)();
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
        firstName: user.name.split(' ')[0],
        lastName: user.name.split(' ').slice(1).join(' '),
        title: getUserMetadataTitle(user),
    }), [user]);
    const validationSchema = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({
        firstName: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('firstNameIsRequired')),
    }), [t]);
    const formikProps = {
        onSubmit: (values) => new Promise((resolve, reject) => {
            const name = [values.firstName, values.lastName].filter(notNull).join(' ').trim();
            const metadata = addUserMetadata(user, { title: values.title, name });
            const callback = callbackToPromise(() => {
                props.onClose();
                resolve();
            }, reject);
            saveProfile({ name, metadata, callback });
        }),
        initialValues,
        validationSchema,
    };
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit }) => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DisplayNameField, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TitleField, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FirstNameField$2, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(LastNameField$1, null)),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancelBtn", color: 'inherit', variant: 'text', type: 'reset', onClick: props.onClose }, t('cancel')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "saveBtn", disabled: !canSubmit, loading: isSubmitting, color: 'primary', type: 'submit' }, t('save'))));
    });
};
const EditNameDialog = (props) => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('profile_EditName');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { title: t('title') }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditNameForm$1, Object.assign({}, props)));
};

const Field$1 = (props) => {
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)(props.name);
    //TODO add to data-test-id: -box
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ label: props.label }, fieldProps, { error: !!error && touched, errorMessage: error, autoFocus: true, "data-test-id": `${props.name}-box`, autoComplete: props.autoComplete }));
};
const SingleInputFormDialog = (props) => {
    const { validationSchema, initialValues, onSubmit } = props;
    const formikProps = { onSubmit, initialValues, validationSchema: validationSchema !== null && validationSchema !== void 0 ? validationSchema : (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({}) };
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit, formError }) => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Field$1, { label: props.inputLabel, name: props.inputName, autoComplete: props.inputAutoComplete }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { fieldName: props.inputName, message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancelBtn", color: 'inherit', variant: 'text', type: 'reset', onClick: props.onClose }, props.cancelButton),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "saveBtn", disabled: !canSubmit, loading: isSubmitting, color: 'primary', type: 'submit' }, props.submitButton)));
    });
};
const EditSingleInputDialog = (props) => {
    const dialogProps = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(props, ["onSubmit", "inputLabel", "inputName", "inputAutoComplete", "initialValues", "validationSchema", "description"]);
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, dialogProps),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SingleInputFormDialog, Object.assign({}, props)));
};

const EditPhoneDialog = (props) => {
    const t = useT('profile_EditPhone');
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b$)();
    const { saveProfile } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cY)();
    const phoneNumber = getUserMetadata(user, 'phoneNumber');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditSingleInputDialog, { title: t('title'), onClose: props.onClose, open: props.open, inputName: 'phone', inputLabel: t('phoneInputLabel'), cancelButton: t('cancel'), submitButton: t('save'), inputAutoComplete: 'tel', initialValues: {
            phone: phoneNumber !== null && phoneNumber !== void 0 ? phoneNumber : '',
        }, validationSchema: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({
            phone: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d1)(t('phoneIsInvalid')),
        }), onSubmit: (values) => new Promise((resolve, reject) => {
            const metadata = addUserMetadata(user, { phoneNumber: values.phone });
            const callback = callbackToPromise(() => {
                props.onClose();
                resolve();
            }, reject);
            saveProfile({ metadata, callback });
        }) });
};

const EditJobTitleDialog = (props) => {
    var _a;
    const t = useT('profile_EditJobTitle');
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b$)();
    const { saveProfile } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cY)();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditSingleInputDialog, { title: t('title'), onClose: props.onClose, open: props.open, inputName: 'jobTitle', inputAutoComplete: 'organization-title', inputLabel: t('jobTitleInputLabel'), cancelButton: t('cancel'), submitButton: t('save'), initialValues: {
            jobTitle: (_a = getUserMetadata(user, 'jobTitle')) !== null && _a !== void 0 ? _a : '',
        }, onSubmit: (values) => new Promise((resolve, reject) => {
            const metadata = addUserMetadata(user, { jobTitle: values.jobTitle });
            const callback = callbackToPromise(() => {
                props.onClose();
                resolve();
            }, reject);
            saveProfile({ metadata, callback });
        }) });
};

const getRoleLevel = (roleId, roles) => {
    var _a;
    if (!roles)
        return Infinity;
    const roleSettings = roles.find((role) => role.id === roleId);
    return (_a = roleSettings === null || roleSettings === void 0 ? void 0 : roleSettings.permissionLevel) !== null && _a !== void 0 ? _a : Infinity;
};
const getMaxRoleLevel = (roleIds, roles) => {
    if (!roleIds)
        return Infinity;
    const levelsArr = roleIds.map((roleId) => getRoleLevel(roleId, roles));
    return levelsArr.length ? Math.min(...levelsArr) : Infinity;
};
const getUserMaxRoleLevel = (roles, loggedIn) => {
    const context = _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__.ContextHolder.getContext();
    const user = loggedIn !== null && loggedIn !== void 0 ? loggedIn : _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__.ContextHolder.getUser();
    let currentUserRoleLevel = Infinity;
    const currentUserRolesIds = user === null || user === void 0 ? void 0 : user.roles.map((r) => r.id);
    if (context.currentUserRoles && context.currentUserRoles.length > 0) {
        currentUserRoleLevel = getMaxRoleLevel(context.currentUserRoles, roles);
    }
    else if (currentUserRolesIds && currentUserRolesIds.length > 0) {
        currentUserRoleLevel = getMaxRoleLevel(currentUserRolesIds, roles);
    }
    return currentUserRoleLevel;
};
const checkRoleAccess = (roles, loggedIn) => {
    const currentUserRoleLevel = getUserMaxRoleLevel(roles, loggedIn);
    if (roles) {
        return roles.filter((role) => { var _a; return ((_a = role.permissionLevel) !== null && _a !== void 0 ? _a : Infinity) >= currentUserRoleLevel; });
    }
    return [];
};
const hasPermission = (...permissions) => {
    var _a, _b;
    const userPermissions = (_b = (_a = _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__.ContextHolder.getUser()) === null || _a === void 0 ? void 0 : _a.permissions) !== null && _b !== void 0 ? _b : [];
    return permissions.reduce((p, permission) => {
        return !!userPermissions.find(userPermission => new RegExp(userPermission.key
            .replace(/\./g, '\\.')
            .replace(/\*/g, '.*')).test(permission));
    }, true);
};
const usePermission = (...permissions) => {
    const { policy, loading: loadingPolicy } = usePublicPolicySettings();
    return hasPermission(...permissions) || (!loadingPolicy && !(policy === null || policy === void 0 ? void 0 : policy.forcePermissions));
};

const countries = [
    { name: 'Afghanistan', code: 'AF' },
    { name: 'Åland Islands', code: 'AX' },
    { name: 'Albania', code: 'AL' },
    { name: 'Algeria', code: 'DZ' },
    { name: 'American Samoa', code: 'AS' },
    { name: 'AndorrA', code: 'AD' },
    { name: 'Angola', code: 'AO' },
    { name: 'Anguilla', code: 'AI' },
    { name: 'Antarctica', code: 'AQ' },
    { name: 'Antigua and Barbuda', code: 'AG' },
    { name: 'Argentina', code: 'AR' },
    { name: 'Armenia', code: 'AM' },
    { name: 'Aruba', code: 'AW' },
    { name: 'Australia', code: 'AU' },
    { name: 'Austria', code: 'AT' },
    { name: 'Azerbaijan', code: 'AZ' },
    { name: 'Bahamas', code: 'BS' },
    { name: 'Bahrain', code: 'BH' },
    { name: 'Bangladesh', code: 'BD' },
    { name: 'Barbados', code: 'BB' },
    { name: 'Belarus', code: 'BY' },
    { name: 'Belgium', code: 'BE' },
    { name: 'Belize', code: 'BZ' },
    { name: 'Benin', code: 'BJ' },
    { name: 'Bermuda', code: 'BM' },
    { name: 'Bhutan', code: 'BT' },
    { name: 'Bolivia', code: 'BO' },
    { name: 'Bosnia and Herzegovina', code: 'BA' },
    { name: 'Botswana', code: 'BW' },
    { name: 'Bouvet Island', code: 'BV' },
    { name: 'Brazil', code: 'BR' },
    { name: 'British Indian Ocean Territory', code: 'IO' },
    { name: 'Brunei Darussalam', code: 'BN' },
    { name: 'Bulgaria', code: 'BG' },
    { name: 'Burkina Faso', code: 'BF' },
    { name: 'Burundi', code: 'BI' },
    { name: 'Cambodia', code: 'KH' },
    { name: 'Cameroon', code: 'CM' },
    { name: 'Canada', code: 'CA' },
    { name: 'Cape Verde', code: 'CV' },
    { name: 'Cayman Islands', code: 'KY' },
    { name: 'Central African Republic', code: 'CF' },
    { name: 'Chad', code: 'TD' },
    { name: 'Chile', code: 'CL' },
    { name: 'China', code: 'CN' },
    { name: 'Christmas Island', code: 'CX' },
    { name: 'Cocos (Keeling) Islands', code: 'CC' },
    { name: 'Colombia', code: 'CO' },
    { name: 'Comoros', code: 'KM' },
    { name: 'Congo', code: 'CG' },
    { name: 'Congo, The Democratic Republic of the', code: 'CD' },
    { name: 'Cook Islands', code: 'CK' },
    { name: 'Costa Rica', code: 'CR' },
    { name: 'Cote D\'Ivoire', code: 'CI' },
    { name: 'Croatia', code: 'HR' },
    { name: 'Cuba', code: 'CU' },
    { name: 'Cyprus', code: 'CY' },
    { name: 'Czech Republic', code: 'CZ' },
    { name: 'Denmark', code: 'DK' },
    { name: 'Djibouti', code: 'DJ' },
    { name: 'Dominica', code: 'DM' },
    { name: 'Dominican Republic', code: 'DO' },
    { name: 'Ecuador', code: 'EC' },
    { name: 'Egypt', code: 'EG' },
    { name: 'El Salvador', code: 'SV' },
    { name: 'Equatorial Guinea', code: 'GQ' },
    { name: 'Eritrea', code: 'ER' },
    { name: 'Estonia', code: 'EE' },
    { name: 'Ethiopia', code: 'ET' },
    { name: 'Falkland Islands (Malvinas)', code: 'FK' },
    { name: 'Faroe Islands', code: 'FO' },
    { name: 'Fiji', code: 'FJ' },
    { name: 'Finland', code: 'FI' },
    { name: 'France', code: 'FR' },
    { name: 'French Guiana', code: 'GF' },
    { name: 'French Polynesia', code: 'PF' },
    { name: 'French Southern Territories', code: 'TF' },
    { name: 'Gabon', code: 'GA' },
    { name: 'Gambia', code: 'GM' },
    { name: 'Georgia', code: 'GE' },
    { name: 'Germany', code: 'DE' },
    { name: 'Ghana', code: 'GH' },
    { name: 'Gibraltar', code: 'GI' },
    { name: 'Greece', code: 'GR' },
    { name: 'Greenland', code: 'GL' },
    { name: 'Grenada', code: 'GD' },
    { name: 'Guadeloupe', code: 'GP' },
    { name: 'Guam', code: 'GU' },
    { name: 'Guatemala', code: 'GT' },
    { name: 'Guernsey', code: 'GG' },
    { name: 'Guinea', code: 'GN' },
    { name: 'Guinea-Bissau', code: 'GW' },
    { name: 'Guyana', code: 'GY' },
    { name: 'Haiti', code: 'HT' },
    { name: 'Heard Island and Mcdonald Islands', code: 'HM' },
    { name: 'Holy See (Vatican City State)', code: 'VA' },
    { name: 'Honduras', code: 'HN' },
    { name: 'Hong Kong', code: 'HK' },
    { name: 'Hungary', code: 'HU' },
    { name: 'Iceland', code: 'IS' },
    { name: 'India', code: 'IN' },
    { name: 'Indonesia', code: 'ID' },
    { name: 'Iran, Islamic Republic Of', code: 'IR' },
    { name: 'Iraq', code: 'IQ' },
    { name: 'Ireland', code: 'IE' },
    { name: 'Isle of Man', code: 'IM' },
    { name: 'Israel', code: 'IL' },
    { name: 'Italy', code: 'IT' },
    { name: 'Jamaica', code: 'JM' },
    { name: 'Japan', code: 'JP' },
    { name: 'Jersey', code: 'JE' },
    { name: 'Jordan', code: 'JO' },
    { name: 'Kazakhstan', code: 'KZ' },
    { name: 'Kenya', code: 'KE' },
    { name: 'Kiribati', code: 'KI' },
    { name: 'Korea, Democratic People\'S Republic of', code: 'KP' },
    { name: 'Korea, Republic of', code: 'KR' },
    { name: 'Kuwait', code: 'KW' },
    { name: 'Kyrgyzstan', code: 'KG' },
    { name: 'Lao People\'S Democratic Republic', code: 'LA' },
    { name: 'Latvia', code: 'LV' },
    { name: 'Lebanon', code: 'LB' },
    { name: 'Lesotho', code: 'LS' },
    { name: 'Liberia', code: 'LR' },
    { name: 'Libyan Arab Jamahiriya', code: 'LY' },
    { name: 'Liechtenstein', code: 'LI' },
    { name: 'Lithuania', code: 'LT' },
    { name: 'Luxembourg', code: 'LU' },
    { name: 'Macao', code: 'MO' },
    { name: 'Macedonia, The Former Yugoslav Republic of', code: 'MK' },
    { name: 'Madagascar', code: 'MG' },
    { name: 'Malawi', code: 'MW' },
    { name: 'Malaysia', code: 'MY' },
    { name: 'Maldives', code: 'MV' },
    { name: 'Mali', code: 'ML' },
    { name: 'Malta', code: 'MT' },
    { name: 'Marshall Islands', code: 'MH' },
    { name: 'Martinique', code: 'MQ' },
    { name: 'Mauritania', code: 'MR' },
    { name: 'Mauritius', code: 'MU' },
    { name: 'Mayotte', code: 'YT' },
    { name: 'Mexico', code: 'MX' },
    { name: 'Micronesia, Federated States of', code: 'FM' },
    { name: 'Moldova, Republic of', code: 'MD' },
    { name: 'Monaco', code: 'MC' },
    { name: 'Mongolia', code: 'MN' },
    { name: 'Montserrat', code: 'MS' },
    { name: 'Morocco', code: 'MA' },
    { name: 'Mozambique', code: 'MZ' },
    { name: 'Myanmar', code: 'MM' },
    { name: 'Namibia', code: 'NA' },
    { name: 'Nauru', code: 'NR' },
    { name: 'Nepal', code: 'NP' },
    { name: 'Netherlands', code: 'NL' },
    { name: 'Netherlands Antilles', code: 'AN' },
    { name: 'New Caledonia', code: 'NC' },
    { name: 'New Zealand', code: 'NZ' },
    { name: 'Nicaragua', code: 'NI' },
    { name: 'Niger', code: 'NE' },
    { name: 'Nigeria', code: 'NG' },
    { name: 'Niue', code: 'NU' },
    { name: 'Norfolk Island', code: 'NF' },
    { name: 'Northern Mariana Islands', code: 'MP' },
    { name: 'Norway', code: 'NO' },
    { name: 'Oman', code: 'OM' },
    { name: 'Pakistan', code: 'PK' },
    { name: 'Palau', code: 'PW' },
    { name: 'Palestinian Territory, Occupied', code: 'PS' },
    { name: 'Panama', code: 'PA' },
    { name: 'Papua New Guinea', code: 'PG' },
    { name: 'Paraguay', code: 'PY' },
    { name: 'Peru', code: 'PE' },
    { name: 'Philippines', code: 'PH' },
    { name: 'Pitcairn', code: 'PN' },
    { name: 'Poland', code: 'PL' },
    { name: 'Portugal', code: 'PT' },
    { name: 'Puerto Rico', code: 'PR' },
    { name: 'Qatar', code: 'QA' },
    { name: 'Reunion', code: 'RE' },
    { name: 'Romania', code: 'RO' },
    { name: 'Russian Federation', code: 'RU' },
    { name: 'RWANDA', code: 'RW' },
    { name: 'Saint Helena', code: 'SH' },
    { name: 'Saint Kitts and Nevis', code: 'KN' },
    { name: 'Saint Lucia', code: 'LC' },
    { name: 'Saint Pierre and Miquelon', code: 'PM' },
    { name: 'Saint Vincent and the Grenadines', code: 'VC' },
    { name: 'Samoa', code: 'WS' },
    { name: 'San Marino', code: 'SM' },
    { name: 'Sao Tome and Principe', code: 'ST' },
    { name: 'Saudi Arabia', code: 'SA' },
    { name: 'Senegal', code: 'SN' },
    { name: 'Serbia and Montenegro', code: 'CS' },
    { name: 'Seychelles', code: 'SC' },
    { name: 'Sierra Leone', code: 'SL' },
    { name: 'Singapore', code: 'SG' },
    { name: 'Slovakia', code: 'SK' },
    { name: 'Slovenia', code: 'SI' },
    { name: 'Solomon Islands', code: 'SB' },
    { name: 'Somalia', code: 'SO' },
    { name: 'South Africa', code: 'ZA' },
    { name: 'South Georgia and the South Sandwich Islands', code: 'GS' },
    { name: 'Spain', code: 'ES' },
    { name: 'Sri Lanka', code: 'LK' },
    { name: 'Sudan', code: 'SD' },
    { name: 'Suriname', code: 'SR' },
    { name: 'Svalbard and Jan Mayen', code: 'SJ' },
    { name: 'Swaziland', code: 'SZ' },
    { name: 'Sweden', code: 'SE' },
    { name: 'Switzerland', code: 'CH' },
    { name: 'Syrian Arab Republic', code: 'SY' },
    { name: 'Taiwan, Province of China', code: 'TW' },
    { name: 'Tajikistan', code: 'TJ' },
    { name: 'Tanzania, United Republic of', code: 'TZ' },
    { name: 'Thailand', code: 'TH' },
    { name: 'Timor-Leste', code: 'TL' },
    { name: 'Togo', code: 'TG' },
    { name: 'Tokelau', code: 'TK' },
    { name: 'Tonga', code: 'TO' },
    { name: 'Trinidad and Tobago', code: 'TT' },
    { name: 'Tunisia', code: 'TN' },
    { name: 'Turkey', code: 'TR' },
    { name: 'Turkmenistan', code: 'TM' },
    { name: 'Turks and Caicos Islands', code: 'TC' },
    { name: 'Tuvalu', code: 'TV' },
    { name: 'Uganda', code: 'UG' },
    { name: 'Ukraine', code: 'UA' },
    { name: 'United Arab Emirates', code: 'AE' },
    { name: 'United Kingdom', code: 'GB' },
    { name: 'United States', code: 'US' },
    { name: 'United States Minor Outlying Islands', code: 'UM' },
    { name: 'Uruguay', code: 'UY' },
    { name: 'Uzbekistan', code: 'UZ' },
    { name: 'Vanuatu', code: 'VU' },
    { name: 'Venezuela', code: 'VE' },
    { name: 'Viet Nam', code: 'VN' },
    { name: 'Virgin Islands, British', code: 'VG' },
    { name: 'Virgin Islands, U.S.', code: 'VI' },
    { name: 'Wallis and Futuna', code: 'WF' },
    { name: 'Western Sahara', code: 'EH' },
    { name: 'Yemen', code: 'YE' },
    { name: 'Zambia', code: 'ZM' },
    { name: 'Zimbabwe', code: 'ZW' },
];

const InputCopyField = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ label, value, testId }) => {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aL, { label: label, value: value, testId: testId, sx: { marginBottom: 2 } });
});
const RolesField$4 = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ label, placeholder }) => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.X)();
    const allRoles = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bR)(state => state.roles);
    const roles = checkRoleAccess(allRoles, user);
    const [fieldProps, { error, touched }, { setValue, setTouched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('roleIds');
    const options = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (roles !== null && roles !== void 0 ? roles : []).map(role => ({ label: role.name, value: role.id, withCheckbox: true })), [roles]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bS, { label: label, name: 'roleIds', multi: true, placeholder: placeholder, value: fieldProps.value, "data-test-id": "selectRoles", onChange: (value) => {
            setValue(value, true);
            setTouched(true);
        }, error: !!error && touched, errorMessage: error, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, options: options });
}, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bO)('label'));
const Field = (props) => {
    var _a;
    const { autoComplete, autoFocus } = props;
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)(props.name);
    //TODO add to data test id: props.name-box
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ label: props.label, placeholder: props.placeholder }, fieldProps, { value: (_a = fieldProps.value) !== null && _a !== void 0 ? _a : '', error: !!error && touched, errorMessage: error, autoFocus: autoFocus, "data-test-id": `${props.name}-box`, autoComplete: autoComplete }));
};
const CountryField = ({ name, countryCode, label, placeholder }) => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const [fieldProps, { error, touched }, { setValue }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)(name !== null && name !== void 0 ? name : 'country');
    const [search, setSearch] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState('');
    const handleSearchChanged = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((str) => (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.g)(void 0, void 0, void 0, function* () { return setSearch((str !== null && str !== void 0 ? str : '').toLowerCase().trim()); }), [setSearch]);
    const options = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        let data = countries.map(({ name, code }) => ({ label: name, value: countryCode ? code : name }));
        if (search) {
            return data.filter(({ label }) => label.toLowerCase().indexOf(search) !== -1);
        }
        return data;
    }, [search, countryCode]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bS, { size: 'small', "data-test-id": "country-dropdown", name: fieldProps.name, value: fieldProps.value, onChange: (value) => setValue(value, true), options: options, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, label: label, errorMessage: touched ? error : undefined, onSearch: handleSearchChanged, placeholder: placeholder });
};

const CustomCountryField$2 = () => {
    const t = useT('profile_EditAddress');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CountryField, { label: t('countryInputLabel'), placeholder: t('countryInputPlaceholder') });
};
const Address1Field$2 = () => {
    const t = useT('profile_EditAddress');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Field, { autoComplete: 'street-address', name: 'address1', label: t('address1InputLabel') });
};
const Address2Field$2 = () => {
    const t = useT('profile_EditAddress');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Field, { autoComplete: 'address-level3', name: 'address2', label: t('address2InputLabel') });
};
const CityField$2 = () => {
    const t = useT('profile_EditAddress');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Field, { autoComplete: 'address-level2', name: 'city', label: t('cityInputLabel') });
};
const StateField$2 = () => {
    const t = useT('profile_EditAddress');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Field, { autoComplete: 'address-level1', name: 'state', label: t('stateInputLabel') });
};
const PostcodeField$2 = () => {
    const t = useT('profile_EditAddress');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Field, { autoComplete: 'postal-code', name: 'postCode', label: t('postCodeInputLabel') });
};
const EditNameForm = (props) => {
    const t = useT('profile_EditAddress');
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b$)();
    const { saveProfile } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cY)();
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
        address1: getUserMetadata(user, 'address.address1'),
        address2: getUserMetadata(user, 'address.address2'),
        city: getUserMetadata(user, 'address.city'),
        state: getUserMetadata(user, 'address.state'),
        postCode: getUserMetadata(user, 'address.postCode'),
        country: getUserMetadata(user, 'address.country'),
    }), [user]);
    const validationSchema = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({
        address1: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('address1IsRequired')),
        city: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('cityIsRequired')),
        postCode: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d2)(t('postCodeIsInvalid')),
        country: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('countryIsRequired')),
    }), [t]);
    const formikProps = {
        onSubmit: (values) => new Promise((resolve, reject) => {
            const metadata = addUserMetadata(user, { address: values });
            const callback = callbackToPromise(() => {
                props.onClose();
                resolve();
            }, reject);
            saveProfile({ metadata, callback });
        }),
        initialValues,
        validationSchema,
    };
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit }) => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CustomCountryField$2, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Address1Field$2, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Address2Field$2, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CityField$2, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StateField$2, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PostcodeField$2, null)),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancelBtn", color: 'inherit', variant: 'text', type: 'reset', onClick: props.onClose }, t('cancel')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "saveBtn", disabled: !canSubmit, loading: isSubmitting, color: 'primary', type: 'submit' }, t('save'))));
    });
};
const EditAddressDialog$1 = (props) => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('profile_EditAddress');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { title: t('title') }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditNameForm, Object.assign({}, props)));
};

const PageWrapper = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B)(({ theme }) => {
    var _a;
    return (Object.assign({ flex: 1, overflow: 'auto', transform: 'translate3d(0,0,0)' }, (_a = theme === null || theme === void 0 ? void 0 : theme.pages) === null || _a === void 0 ? void 0 : _a.content));
});
PageWrapper.defaultProps = {
    pt: 4,
    pb: 4,
    pl: 6,
    pr: 6,
};

const ProfilePage$1 = () => {
    const t = useT('profile');
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b$)();
    (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cE)();
    const [editNameDialog, handleCloseEditName, handleOpenEditName] = useDialogState();
    const [editPhoneNumberDialog, handleCloseEditPhoneNumber, handleOpenEditPhoneNumber] = useDialogState();
    const [editJobTitleDialog, handleCloseEditJobTitle, handleOpenEditJobTitle] = useDialogState();
    const [editAddressDialog, handleCloseEditAddress, handleOpenEditAddress] = useDialogState();
    const items = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => [
        {
            id: 'email',
            title: t('email'),
            value: user.email,
            onEditClick: null,
            testId: 'email-field'
        }, {
            id: 'name',
            title: t('name'),
            value: getUserFullName(user),
            onEditClick: handleOpenEditName,
            testId: 'name-field'
        }, {
            id: 'phone',
            title: t('phone'),
            value: getUserMetadata(user, 'phoneNumber'),
            onEditClick: handleOpenEditPhoneNumber,
            testId: 'phone-field'
        }, {
            id: 'metadata.address',
            title: t('address'),
            value: getUserAddress(user),
            onEditClick: handleOpenEditAddress,
            testId: 'address-field'
        }, {
            id: 'metadata.jobTitle',
            title: t('jobTitle'),
            value: getUserMetadata(user, 'jobTitle'),
            onEditClick: handleOpenEditJobTitle,
            testId: 'jobTitle-field'
        }
    ], [user, t, handleOpenEditName, handleOpenEditPhoneNumber, handleOpenEditJobTitle, handleOpenEditAddress]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageWrapper, { "data-test-id": 'profile-page-wrapper' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ProfileHeader, null),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cy, { title: t('informationTitle'), items: items }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditNameDialog, { open: editNameDialog, onClose: handleCloseEditName }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditPhoneDialog, { open: editPhoneNumberDialog, onClose: handleCloseEditPhoneNumber }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditJobTitleDialog, { open: editJobTitleDialog, onClose: handleCloseEditJobTitle }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditAddressDialog$1, { open: editAddressDialog, onClose: handleCloseEditAddress }));
};
var ProfilePage$2 = ProfilePage$1;

var ProfilePage = wrapPage(ProfilePage$2, 'profile');

const CurrentPasswordField = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(() => {
    const t = useT('privacy_ChangePassword');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('password');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.au, Object.assign({}, fieldProps, { autoFocus: true, label: t('currentPasswordInputLabel'), error: !!error, errorMessage: error && touched ? error : undefined, "data-test-id": "currentPasswordBox", autoComplete: 'current-password' }));
});
const NewPasswordField = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(() => {
    const t = useT('privacy_ChangePassword');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('newPassword');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.au, Object.assign({}, fieldProps, { label: t('newPasswordInputLabel'), error: !!error && touched, "aria-autocomplete": 'none', "data-test-id": "newPasswordBox", autoComplete: 'new-password' }));
});
const ConfirmPasswordField = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(() => {
    const t = useT('privacy_ChangePassword');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('confirmPassword');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.au, Object.assign({}, fieldProps, { label: t('confirmPasswordInputLabel'), error: !!error && touched, errorMessage: error, "aria-autocomplete": 'none', "data-test-id": "confirmPasswordBox", autoComplete: 'new-password' }));
});
const PasswordStrength = (props) => {
    const [{ value }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('newPassword');
    const globalT = useGlobalT();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.av, Object.assign({ t: globalT, value: value, isTouched: value !== '' }, props));
};
const ChangePasswordForm = (props) => {
    const t = useT('privacy_ChangePassword');
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b$)();
    const { changePassword } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cY)();
    const { loading, passwordConfig: passwordServerConfig, defaultPasswordConfig } = usePasswordConfig(user.id, false);
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
        password: '',
        newPassword: '',
        confirmPassword: '',
    }), []);
    const passwordConfig = loading || !passwordServerConfig ? defaultPasswordConfig : passwordServerConfig;
    const validationSchema = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({
            password: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('currentPasswordIsRequired')),
            newPassword: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ac)(t('newPasswordIsRequired')),
            confirmPassword: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ad)(t('confirmPasswordIsRequired'), t('confirmPasswordMustMatch'), 'newPassword'),
        });
    }, [t, passwordConfig]);
    const formikProps = {
        onSubmit: ({ password, newPassword }) => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, reject, props.onClose);
            changePassword({ password, newPassword, callback });
        }),
        initialValues,
        validationSchema,
    };
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit, formError }) => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CurrentPasswordField, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(NewPasswordField, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PasswordStrength, { passwordConfig: passwordConfig, loading: loading || !passwordConfig }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ConfirmPasswordField, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { fieldName: 'changePassword', message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancelBtn", color: 'inherit', variant: 'text', type: 'reset', onClick: props.onClose }, t('cancel')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "changePasswordBtn", disabled: !canSubmit, loading: isSubmitting, color: 'primary', type: 'submit' }, t('changePassword'))));
    });
};
const ChangePasswordDialog = (props) => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('privacy_ChangePassword');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ "data-test-id": "changePasswordDialog", container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, dialogTitleDataTestId: 'changePasswordHeader', title: t('title') }, props, { size: 'sm' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ChangePasswordForm, Object.assign({}, props)));
};

const PulseSvgIcon = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((props, ref) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ak, Object.assign({ ref: ref }, props)))) `
  & {
    animation: svg-pulse 1.5s ease-in-out 0.5s infinite;
    color: #E7E7E7;
  }

  @keyframes svg-pulse {
    0% {
      opacity: 1
    }
    50% {
      opacity: 0.4
    }
    100% {
      opacity: 1
    }
  }
`;
const QrCodeSkeleton = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((_, ref) => {
    const dots = [[90, 0], [120, 0], [110, 10], [120, 10], [120, 20], [90, 30], [90, 40], [120, 40], [80, 50], [100, 50], [110, 50], [120, 50], [80, 60], [100, 60], [120, 60], [110, 70], [120, 70], [0, 80], [30, 80], [50, 80], [60, 80], [80, 80], [90, 80], [130, 80], [150, 80], [40, 90], [100, 90], [140, 90], [150, 90], [180, 90], [190, 90], [200, 90], [0, 100], [10, 100], [20, 100], [60, 100], [70, 100], [90, 100], [100, 100], [120, 100], [130, 100], [170, 100], [200, 100], [10, 110], [20, 110], [70, 110], [90, 110], [110, 110], [160, 110], [170, 110], [190, 110], [200, 110], [0, 120], [10, 120], [20, 120], [30, 120], [40, 120], [50, 120], [60, 120], [70, 120], [90, 120], [100, 120], [120, 120], [140, 120], [150, 120], [160, 120], [190, 120], [80, 130], [90, 130], [100, 130], [110, 130], [150, 130], [170, 130], [200, 130], [130, 140], [150, 140], [160, 140], [180, 140], [190, 140], [80, 150], [100, 150], [110, 150], [120, 150], [130, 150], [150, 150], [160, 150], [200, 150], [90, 160], [100, 160], [110, 160], [140, 160], [150, 160], [160, 160], [200, 160], [80, 170], [110, 170], [150, 170], [160, 170], [170, 170], [190, 170], [200, 170], [100, 180], [120, 180], [150, 180], [160, 180], [180, 180], [200, 180], [130, 190], [140, 190], [160, 190], [80, 200], [90, 200], [100, 200], [110, 200], [120, 200], [170, 200], [190, 200]];
    const largeDots = [[20, 20], [160, 20], [20, 160]];
    const corners = [[0, 0], [140, 0], [0, 140]];
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PulseSvgIcon, { viewBox: '0 0 250 250', ref: ref },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { transform: "translate(20,20)" },
            dots.map((dot, index) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { key: index, transform: `translate(${dot[0]},${dot[1]}) scale(0.1,0.1)` },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "100", height: "100" }))),
            largeDots.map((dot, index) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { key: index, transform: `translate(${dot[0]},${dot[1]}) scale(0.3,0.3)` },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { width: "100", height: "100" }))),
            corners.map((corner, index) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { key: index, transform: `translate(${corner[0]},${corner[1]}) scale(0.7, 0.7)` },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("rect", { x: '15', y: '15', fill: 'none', width: '70', height: '70' }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M85,0H15H0v15v70v15h15h70h15V85V15V0H85z M85,85H15V15h70V85z" })))));
});

const GoogleAuthenticatorLink = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(() => {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.L, { href: 'https://www.google.com/search?q=google+authenticator', target: '_blank' }, ` Google Authenticator `);
});
const QrCodeContainer = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G)(({ theme }) => ({
    height: '12rem',
    width: '12rem',
    border: `1px solid ${theme.palette.grey[300]}`,
    borderRadius: '0.5rem',
    position: 'relative',
    padding: theme.spacing(10),
    justifyContent: 'center',
    alignItems: 'center',
    margin: '2rem auto',
    'img, svg': {
        top: '0.5rem',
        left: '0.5rem',
        position: 'absolute',
        width: 'calc(100% - 1rem)',
        height: 'calc(100% - 1rem)',
    },
}));
const QrCodeComponent = () => {
    const { loading, qrCode } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aq)();
    const displaySkeleton = !qrCode && loading;
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(QrCodeContainer, { container: true },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c9, { in: displaySkeleton },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(QrCodeSkeleton, null)),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c9, { in: !displaySkeleton },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("img", { "data-test-id": "qrCode", alt: 'qr-code', src: qrCode !== null && qrCode !== void 0 ? qrCode : '' }))));
};
const TokenInput$1 = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(() => {
    const t = useT('privacy_EnableMfa');
    const { submitCount, dirty } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.u)();
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('token');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({}, fieldProps, { autoFocus: true, "data-test-id": "6DigitsCode", inputMode: 'numeric', label: t('codeInputLabel'), placeholder: t('codeInputPlaceholder'), error: !!error && ((touched && !!submitCount) || dirty), errorMessage: error, autoComplete: 'one-time-code' }));
});
const VerifyMfaForm = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((props, ref) => {
    const t = useT('privacy_EnableMfa');
    const { verifyMfa } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ar)();
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({ token: '' }), []);
    const validationSchema = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({
        token: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ax)(6, t('codeIsRequired'), t('codeLengthAtLeast6')),
    }), [t]);
    const formikProps = {
        onSubmit: (values) => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, reject);
            verifyMfa({ token: values.token, callback });
        }),
        initialValues,
        validationSchema,
    };
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit, formError }) => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, { ref: ref },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { mb: 8 },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'subtitle2' }, t('subtitle'))),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'body1' },
                    t('scanDescription1'),
                    " ",
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(GoogleAuthenticatorLink, null),
                    " ",
                    t('scanDescription2')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(QrCodeComponent, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TokenInput$1, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancelBtn", color: 'inherit', variant: 'text', type: 'reset', onClick: props.onClose }, t('cancel')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "verifyBtn", disabled: !canSubmit, loading: isSubmitting, color: 'primary', type: 'submit' }, t('verify'))));
    });
});
const RecoveryMfaForm = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((props, ref) => {
    const t = useT('privacy_EnableMfa');
    const { recoveryCode = '' } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aq)();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, { ref: ref },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'subtitle1' }, t('recoveryCodeTitle')),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { mt: 8 },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aL, { label: t('recoveryCodeLabel'), value: recoveryCode })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { mt: 8 },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.A, { severity: 'info' }, t('recoveryCodeInstructions')))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancelBtn", color: 'inherit', variant: 'text', type: 'reset', onClick: props.onClose }, t('cancel')),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "closeBtn", color: "inherit", onClick: props.onClose }, t('close'))));
});
const EnableMfaStepper = props => {
    const { step } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aq)();
    const { enrollMfa, resetMfaState } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ar)();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        enrollMfa();
        return resetMfaState;
    }, [enrollMfa, resetMfaState]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (step !== _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .MFAStep.verify */ .bj.verify && step !== _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .MFAStep.recoveryCode */ .bj.recoveryCode) {
            props.onClose();
        }
    }, [step, props]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Slide$1, { in: step === _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .MFAStep.verify */ .bj.verify, appear: false, exit: false, unmountOnExit: true, direction: step === _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .MFAStep.verify */ .bj.verify ? 'left' : 'right' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(VerifyMfaForm, Object.assign({}, props))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Slide$1, { in: step === _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .MFAStep.recoveryCode */ .bj.recoveryCode, mountOnEnter: true, unmountOnExit: true, direction: step === _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .MFAStep.recoveryCode */ .bj.recoveryCode ? 'left' : 'right' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RecoveryMfaForm, Object.assign({}, props))));
};
const EnableMfaDialog = props => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('privacy_EnableMfa');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ "data-test-id": "enableMfa", container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { title: t('title'), size: 'sm' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EnableMfaStepper, Object.assign({}, props)));
};

const TokenInput = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(() => {
    const t = useT('privacy_DisableMfa');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('token');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({}, fieldProps, { autoFocus: true, inputMode: 'numeric', "data-test-id": "6DigitsCode", label: t('tokenInputLabel'), placeholder: t('tokenInputLabelPlaceholder'), error: !!error && touched, errorMessage: error, autoComplete: 'one-time-code' }));
});
const DisableMfaForm = (props) => {
    const t = useT('privacy_DisableMfa');
    const { disableMfa, resetMfaState } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ar)();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => resetMfaState, [resetMfaState]);
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({ token: '' }), []);
    const validationSchema = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({ token: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ax)(6, t('codeIsRequired'), t('codeLengthAtLeast6')) }), [t]);
    const formikProps = {
        onSubmit: ({ token }, { setErrors }) => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, (e) => {
                setErrors({ token: e.message });
                reject();
            }, props.onClose);
            disableMfa({ token, callback });
        }),
        initialValues,
        validationSchema,
    };
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit }) => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { "data-test-id": "disableMfabtn", mb: 4, component: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, variant: 'subtitle2' }, t('description')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TokenInput, null)),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancel", color: 'inherit', variant: 'text', type: 'reset', onClick: props.onClose }, t('cancel')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "submit", disabled: !canSubmit, loading: isSubmitting, color: 'danger', type: 'submit' }, t('disable'))));
    });
};
const DisableMfaDialog = props => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('privacy_DisableMfa');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { title: t('title'), size: 'sm' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DisableMfaForm, Object.assign({}, props)));
};

const PrivacyPage$1 = () => {
    const t = useT('privacy');
    const [changePasswordDialog, handleCloseChangePassword, handleOpenChangePassword] = useDialogState();
    const [enableMfaDialog, handleCloseEnableMfaDialog, handleOpenEnableMfaDialog] = useDialogState();
    const [disableMfaDialog, handleCloseDisableMfaDialog, handleOpenDisableMfaDialog] = useDialogState();
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b$)();
    const { policy, loading: loadingPolicy } = usePublicPolicySettings();
    const mfaPolicy = useMfaPolicySettings();
    usePasswordConfig(user.id);
    const isMfaForced = mfaPolicy.policy && mfaPolicy.policy.enforceMFAType !== 'DontForce';
    const items = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => [
        ...(!loadingPolicy && (policy === null || policy === void 0 ? void 0 : policy.authStrategy) === 'EmailAndPassword' ? [{
                id: 'password',
                title: t('passwordTitle'),
                value: '',
                onEditClick: handleOpenChangePassword,
            }] : []),
        {
            id: 'multiFactorAuthentication',
            title: t('mfaTitle'),
            value: mfaPolicy.loading ?
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bN, { width: 80, height: 18 })
                : isMfaForced ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'label' },
                    t('mfaRequired'),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cw, { message: t('mfaHelpMessage') }))) :
                    user.mfaEnrolled ? t('mfaEnabled') : t('mfaDisabled'),
            actions: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cx, { "data-test-id": "Switch", disabled: isMfaForced, checked: !mfaPolicy.loading && (isMfaForced || user.mfaEnrolled), onChange: e => {
                    if (e.target.checked) {
                        handleOpenEnableMfaDialog();
                    }
                    else {
                        handleOpenDisableMfaDialog();
                    }
                } }),
        }
    ], [user, t, handleOpenChangePassword, handleOpenEnableMfaDialog, handleOpenDisableMfaDialog, mfaPolicy.loading, isMfaForced, policy, loadingPolicy]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageWrapper, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cy, { title: t('basicSettings'), items: items }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ChangePasswordDialog, { open: changePasswordDialog, onClose: handleCloseChangePassword }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EnableMfaDialog, { open: enableMfaDialog, onClose: handleCloseEnableMfaDialog }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DisableMfaDialog, { open: disableMfaDialog, onClose: handleCloseDisableMfaDialog }));
};
var PrivacyPage$2 = PrivacyPage$1;

var PrivacyPage = wrapPage(PrivacyPage$2, 'privacy');

const TimezoneField = () => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('accountSettings_EditTimezone');
    const [search, setSearch] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState('');
    const [fieldProps, { error, touched }, { setValue }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('timezone');
    const handleSearchChanged = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((str) => (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.g)(void 0, void 0, void 0, function* () { return setSearch((str !== null && str !== void 0 ? str : '').toLowerCase().trim()); }), [setSearch]);
    const options = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        let data = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cz)();
        if (search) {
            return data.filter(({ label }) => label.toLowerCase().indexOf(search) !== -1);
        }
        return data;
    }, [search]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bS, { value: fieldProps.value, "data-test-id": "timezone-dropdown", onChange: (value) => setValue(value, true), errorMessage: touched ? error : undefined, options: options, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, label: t('timezoneInputLabel'), onSearch: handleSearchChanged });
};
const EditTimezoneForm = (props) => {
    const t = useT('accountSettings_EditTimezone');
    const { saveAccountSettings } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.V)();
    const { accountSettingsState: settings } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.J)();
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        var _a;
        return ({
            timezone: (_a = settings.timezone) !== null && _a !== void 0 ? _a : '',
        });
    }, [settings.timezone]);
    const validationSchema = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({}), []);
    const formikProps = {
        onSubmit: (values) => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, reject, props.onClose);
            saveAccountSettings(Object.assign(Object.assign(Object.assign({}, settings), values), { callback }));
        }),
        initialValues,
        validationSchema,
    };
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit, formError }) => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TimezoneField, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { fieldName: "timezone", message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancelBtn", color: 'inherit', variant: 'text', type: 'reset', onClick: props.onClose }, t('cancel')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "saveBtn", disabled: !canSubmit, loading: isSubmitting, color: 'primary', type: 'submit' }, t('save'))));
    });
};
const EditTimezoneDialog = (props) => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('accountSettings_EditTimezone');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { title: t('title'), size: 'sm' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditTimezoneForm, Object.assign({}, props)));
};

const EditCompanyNameDialog = (props) => {
    const t = useT('accountSettings_EditCompanyName');
    const { saveAccountSettings } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.V)();
    const { accountSettingsState: settings } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.J)();
    const { loadTenants } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cB)();
    const validationSchema = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({
        companyName: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('companyNameIsRequired')),
    }), [t]);
    const submitHandler = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((values) => new Promise((resolve, reject) => {
        const callback = callbackToPromise(resolve, reject, () => {
            loadTenants();
            props.onClose();
        });
        saveAccountSettings(Object.assign(Object.assign({}, settings), { name: values.companyName, callback }));
    }), [props, saveAccountSettings, settings, loadTenants]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditSingleInputDialog, { title: t('title'), onClose: props.onClose, open: props.open, validationSchema: validationSchema, inputName: 'companyName', inputLabel: t('companyNameLabel'), submitButton: t('save'), cancelButton: ('cancel'), initialValues: {
            companyName: settings.name,
        }, 
        // TODO: changed test-id from editName to companyName-box
        onSubmit: submitHandler });
};

const getAccountAddress = (address, key) => {
    let parsedAddress = {};
    try {
        parsedAddress = JSON.parse(address);
    }
    catch (e) {
        // ignore address data parse error
    }
    return key ? getValue$1(parsedAddress, key) : parsedAddress;
};
const addAddress = (address, newAddress) => {
    let parsedAddress = {};
    try {
        parsedAddress = JSON.parse(address);
    }
    catch (e) {
        // ignore address data parse error
    }
    return JSON.stringify(Object.assign(Object.assign({}, parsedAddress), newAddress));
};

const CustomCountryField$1 = () => {
    const t = useT('accountSettings_EditAddress');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CountryField, { label: t('countryInputLabel'), placeholder: t('countryInputPlaceholder') });
};
const Address1Field$1 = () => {
    const t = useT('accountSettings_EditAddress');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Field, { autoComplete: 'street-address', name: 'address1', label: t('address1InputLabel') });
};
const Address2Field$1 = () => {
    const t = useT('accountSettings_EditAddress');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Field, { autoComplete: 'address-level3', name: 'address2', label: t('address2InputLabel') });
};
const CityField$1 = () => {
    const t = useT('accountSettings_EditAddress');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Field, { autoComplete: 'address-level2', name: 'city', label: t('cityInputLabel') });
};
const StateField$1 = () => {
    const t = useT('accountSettings_EditAddress');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Field, { autoComplete: 'address-level1', name: 'state', label: t('stateInputLabel') });
};
//TODO change postCode to postcode
const PostcodeField$1 = () => {
    const t = useT('accountSettings_EditAddress');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Field, { autoComplete: 'postal-code', name: 'postCode', label: t('postCodeInputLabel') });
};
const EditAddressForm = (props) => {
    const t = useT('accountSettings_EditAddress');
    const { saveAccountSettings } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.V)();
    const { accountSettingsState: settings } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.J)();
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        var _a, _b, _c, _d, _e;
        return ({
            address1: (_a = getAccountAddress(settings.address, 'address1')) !== null && _a !== void 0 ? _a : '',
            address2: (_b = getAccountAddress(settings.address, 'address2')) !== null && _b !== void 0 ? _b : '',
            city: (_c = getAccountAddress(settings.address, 'city')) !== null && _c !== void 0 ? _c : '',
            state: (_d = getAccountAddress(settings.address, 'state')) !== null && _d !== void 0 ? _d : '',
            postCode: (_e = getAccountAddress(settings.address, 'postCode')) !== null && _e !== void 0 ? _e : '',
            country: getAccountAddress(settings.address, 'country'),
        });
    }, [settings.address]);
    const validationSchema = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({
        address1: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('address1IsRequired')),
        city: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('cityIsRequired')),
        postCode: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d2)(t('postCodeIsInvalid')),
        country: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('countryIsRequired')),
    }), [t]);
    const formikProps = {
        onSubmit: (values) => new Promise((resolve, reject) => {
            const newAddress = addAddress(settings.address, values);
            const callback = callbackToPromise(resolve, reject, props.onClose);
            saveAccountSettings(Object.assign(Object.assign({}, settings), { address: newAddress, callback }));
        }),
        initialValues,
        validationSchema,
    };
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit, formError }) => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CustomCountryField$1, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Address1Field$1, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Address2Field$1, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CityField$1, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StateField$1, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PostcodeField$1, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { fieldName: "address", message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancelBtn", color: 'inherit', variant: 'text', type: 'reset', onClick: props.onClose }, t('cancel')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "saveBtn", disabled: !canSubmit, loading: isSubmitting, color: 'primary', type: 'submit' }, t('save'))));
    });
};
const EditAddressDialog = (props) => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('accountSettings_EditAddress');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { title: t('title') }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditAddressForm, Object.assign({}, props)));
};

const EditWebsiteDialog = (props) => {
    var _a;
    const t = useT('accountSettings_EditWebsite');
    const { saveAccountSettings } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.V)();
    const { accountSettingsState: settings } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.J)();
    const submitHandler = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((values) => new Promise((resolve, reject) => {
        const callback = callbackToPromise(resolve, reject, props.onClose);
        saveAccountSettings(Object.assign(Object.assign(Object.assign({}, settings), values), { callback }));
    }), [props.onClose, saveAccountSettings, settings]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditSingleInputDialog, { title: t('title'), onClose: props.onClose, open: props.open, inputName: 'website', inputLabel: t('websiteInputLabel'), submitButton: t('save'), cancelButton: ('cancel'), inputAutoComplete: 'organization-title', initialValues: {
            website: (_a = settings.website) !== null && _a !== void 0 ? _a : ' ',
        }, onSubmit: submitHandler, "data-test-id": "website-box" });
};

const currencies = [
    { label: 'USD', value: 'USD' },
    { label: 'EUR', value: 'EUR' },
];
const CurrencyField = () => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('accountSettings_EditCurrency');
    const [fieldProps, { error, touched }, { setValue }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('currency');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bS, { value: fieldProps.value, "data-test-id": "currency-dropdown", onChange: (value) => setValue(value, true), errorMessage: touched ? error : undefined, options: currencies, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, label: t('currencyLabel') });
};
const EditCurrencyForm = (props) => {
    const t = useT('accountSettings_EditCurrency');
    const { saveAccountSettings } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.V)();
    const { accountSettingsState: settings } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.J)();
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
        currency: settings.currency,
    }), [settings.currency]);
    const formikProps = {
        onSubmit: (values) => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, reject, props.onClose);
            saveAccountSettings(Object.assign(Object.assign(Object.assign({}, settings), values), { callback }));
        }),
        initialValues,
    };
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit, formError }) => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CurrencyField, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { fieldName: "currency", message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancelBtn", color: 'inherit', variant: 'text', type: 'reset', onClick: props.onClose }, t('cancel')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "saveBtn", disabled: !canSubmit, loading: isSubmitting, color: 'primary', type: 'submit' }, t('save'))));
    });
};
const EditCurrencyDialog = (props) => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('accountSettings_EditCurrency');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { title: t('title'), size: 'sm' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditCurrencyForm, Object.assign({}, props)));
};

const SettingsRowValue = ({ value, noValueText, dataTestId, onClick }) => {
    const t = useT('accountSettings');
    if (value) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'body1', "data-test-id": `${dataTestId}-value`, component: 'span' }, value);
    }
    if (noValueText) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'body1Bold' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.L, { "data-test-id": `add-${dataTestId}`, onClick: onClick }, t(noValueText)));
    }
    return null;
};
const AccountDetailsPage$1 = () => {
    const t = useT('accountSettings');
    const { loadAccountSettings } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.V)();
    const { accountSettingsState: settings } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.J)();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => loadAccountSettings(), [loadAccountSettings]);
    const [editCompanyName, handleCloseCompanyName, handleOpenCompanyName] = useDialogState();
    const [editAddress, handleCloseAddress, handleOpenAddress] = useDialogState();
    const [editWebsite, handleCloseWebsite, handleOpenWebsite] = useDialogState();
    const [editTimezone, handleCloseTimezone, handleOpenTimezone] = useDialogState();
    const [editCurrency, handleCloseCurrency, handleOpenCurrency] = useDialogState();
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.X)();
    const tenantsState = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cd)();
    const tenants = tenantsState.tenants;
    const tenantName = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        var _a, _b;
        return (_b = (_a = tenants.find(({ tenantId }) => tenantId === (user === null || user === void 0 ? void 0 : user.tenantId))) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
    }, [tenants, user === null || user === void 0 ? void 0 : user.tenantId]);
    const items = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        var _a, _b;
        const companyAddress = formatAddress(getAccountAddress(settings.address));
        const companyTimezone = (_b = (_a = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cz)().find(s => s.value === settings.timezone)) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : '';
        return [{
                id: 'companyName',
                title: t('companyName'),
                value: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SettingsRowValue, { value: settings.name || tenantName, onClick: handleOpenCompanyName, dataTestId: 'companyName', noValueText: 'addCompanyButton' }),
                onEditClick: settings.name ? handleOpenCompanyName : undefined,
                testId: 'account-details-companyName-list-item'
            }, {
                id: 'address',
                title: t('address'),
                value: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SettingsRowValue, { value: companyAddress, onClick: handleOpenAddress, dataTestId: "address", noValueText: 'addAddressButton' }),
                onEditClick: companyAddress ? handleOpenAddress : undefined,
                testId: 'account-details-address-list-item'
            }, {
                id: 'website',
                title: t('website'),
                value: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SettingsRowValue, { value: settings.website, onClick: handleOpenWebsite, dataTestId: "website", noValueText: 'addWebsiteButton' }),
                onEditClick: settings.website ? handleOpenWebsite : undefined,
                testId: 'account-details-website-list-item'
            }, {
                id: 'timezone',
                title: t('timezone'),
                value: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SettingsRowValue, { value: companyTimezone, onClick: handleOpenTimezone, dataTestId: "timezone", noValueText: 'setTimezoneButton' }),
                onEditClick: companyTimezone ? handleOpenTimezone : undefined,
                testId: 'account-details-timezone-list-item'
            }, {
                id: 'currency',
                title: t('currency'),
                value: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SettingsRowValue, { value: settings.currency, onClick: handleOpenCurrency, dataTestId: 'currency', noValueText: 'setCurrencyButton' }),
                onEditClick: settings.currency ? handleOpenCurrency : undefined,
                testId: 'account-details-currency-list-item'
            }];
    }, [t, handleOpenAddress, handleOpenCompanyName, handleOpenCurrency,
        handleOpenTimezone, handleOpenWebsite, settings.address,
        settings.currency, settings.name, settings.timezone, settings.website, tenantName,
    ]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageWrapper, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cy, { title: t('subtitle'), items: items }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditCurrencyDialog, { "data-test-id": "editCurrency", open: editCurrency, onClose: handleCloseCurrency }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditTimezoneDialog, { "data-test-id": "editTimezone", open: editTimezone, onClose: handleCloseTimezone }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditCompanyNameDialog, { "data-test-id": "editCompanyName", open: editCompanyName, onClose: handleCloseCompanyName }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditAddressDialog, { "data-test-id": "editAddress", open: editAddress, onClose: handleCloseAddress }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditWebsiteDialog, { "data-test-id": "editWebsite", open: editWebsite, onClose: handleCloseWebsite }));
};
var AccountDetailsPage$2 = AccountDetailsPage$1;

var AccountDetailsPage = wrapPage(AccountDetailsPage$2, 'accountSettings');

const UsersHeader = ({ handleOpenInviteUser, isInviteWithEmailEnabled, isInviteLinkEnabled }) => {
    const t = useT('users');
    const { onSearch } = useTableSearch();
    const [search, setSearch] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState('');
    const debounceSearch = useDebounce(search);
    const canInviteUser = usePermission('fe.secure.write.users') && (isInviteWithEmailEnabled || isInviteLinkEnabled);
    useAsyncEffect(() => onSearch(debounceSearch), [debounceSearch]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, spacing: 4 },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 12, sm: 6, md: 4 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, { "data-test-id": "searchBox", endAdornment: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cF, null), onChange: (e) => setSearch(e.target.value), placeholder: t('searchInputPlaceholder') }))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: true }),
        canInviteUser && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "invite-user-btn", onClick: handleOpenInviteUser }, t('inviteUserButton'))));
};

const usersTableColumns = ({ t, user, rolesMap, container }) => [
    {
        Header: () => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { width: '2rem' }),
        accessor: ({ name, profileImageUrl, profilePictureUrl }) => ({ name, picture: profilePictureUrl !== null && profilePictureUrl !== void 0 ? profilePictureUrl : profileImageUrl }),
        width: '2rem',
        id: 'id',
        Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cG,
    },
    Object.assign(Object.assign({ Header: t('userHeader'), accessor: ({ id, name, email }) => ({ title: `${name} ${id === user.id ? `(${t('meTooltip')})` : ''}`, description: email }) }, (rolesMap && Object.keys(rolesMap).length > 0 ? { width: 260, maxWidth: 260 } : { minWidth: 260 })), { Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cH }),
    rolesMap && Object.keys(rolesMap).length > 0 && {
        Header: t('rolesHeader'),
        accessor: ({ roleIds }) => ({ items: roleIds.map(v => ({ text: rolesMap[v] })), max: 2, container }),
        minWidth: 300,
        Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cI,
    },
    {
        Header: t('joinedHeader'),
        accessor: ({ createdAt, verified, activatedForTenant }) => ({ date: createdAt, verified, activatedForTenant }),
        width: 160,
        maxWidth: 160,
        Cell: (props) => {
            return !props.value.activatedForTenant
                ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c5, { color: "secondary", label: t('pendingApprovalStatus') })
                : !props.value.verified
                    ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c5, { color: "secondary", label: t('pendingActivationStatus') })
                    : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c8, Object.assign({}, props));
        },
    },
    {
        Header: t('lastSeenHeader'),
        accessor: ({ lastLogin }) => ({ date: lastLogin }),
        width: 160,
        maxWidth: 160,
        Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c8,
    },
].filter(notNull);
const LEAVE_TEAM_OPTION = false;
const useUsersTableRowActions$1 = ({ container, resendActivationLink, resendInvitationLink, handleOpenDeleteUser, handleOpenEditUserRoles, currentTenantId, subTenants }) => {
    const t = useT('users');
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.X)();
    const canEditRoles = usePermission('fe.secure.write.users');
    const canDeleteUser = usePermission('fe.secure.delete.users');
    //TODO: add virified type to ITeamUser
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (row) => {
        var _a;
        const items = [];
        const handleEditRole = () => {
            handleOpenEditUserRoles(row);
        };
        const handleSendActivationLink = () => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, reject);
            resendActivationLink({ userId: row.id, callback });
        });
        const handleSendInvitationLink = () => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, reject);
            const invitationData = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(row, ["id"]);
            resendInvitationLink(Object.assign(Object.assign({}, invitationData), { callback }));
        });
        const handleDeleteUser = () => {
            handleOpenDeleteUser(row);
        };
        const isMe = row.id === (user === null || user === void 0 ? void 0 : user.id);
        const canEditSubTenantUser = !(subTenants === null || subTenants === void 0 ? void 0 : subTenants.length) || ((_a = row.tenants) === null || _a === void 0 ? void 0 : _a.find((tenant) => tenant.tenantId === currentTenantId));
        if (!isMe && canEditRoles && canEditSubTenantUser) {
            items.push({
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bI, { "data-test-id": "editBtn" }),
                onClick: handleEditRole,
                text: t('editRolesAction'),
            });
        }
        if (canEditSubTenantUser) {
            if (!row.activatedForTenant) {
                // add to tenant by addUser
                items.push({
                    icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cJ, { "data-test-id": "resendInvitationBtn" }),
                    onClick: handleSendInvitationLink,
                    text: t('resendInvitationAction'),
                });
            }
            else if (!row.verified) {
                items.push({
                    icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cJ, { "data-test-id": "resendBtn" }),
                    onClick: handleSendActivationLink,
                    text: t('resendActivationAction'),
                });
            }
        }
        if ((!isMe || LEAVE_TEAM_OPTION) && canDeleteUser && canEditSubTenantUser) {
            items.push({
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bZ, { "data-test-id": "deleteBtn" }),
                onClick: handleDeleteUser,
                text: isMe ? t('leaveTeamAction') : t('deleteUserAction'),
                negative: true,
            });
        }
        return { items, container };
    }, [t, user, container, canEditRoles, canDeleteUser, resendActivationLink, resendInvitationLink, handleOpenDeleteUser, handleOpenEditUserRoles, subTenants, currentTenantId]);
};

const usersTableColumnsOrganization = ({ t, user, subTenants, forcePermissions, container, currentTenantName, currentTenantId }) => [
    {
        Header: () => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { width: '2rem' }),
        accessor: ({ name, profileImageUrl, profilePictureUrl }) => ({ name, picture: profilePictureUrl !== null && profilePictureUrl !== void 0 ? profilePictureUrl : profileImageUrl }),
        width: '2rem',
        id: 'id',
        Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cG,
    },
    Object.assign(Object.assign({ Header: t('userHeader'), accessor: ({ id, name, email }) => ({ title: `${name} ${id === user.id ? `(${t('meTooltip')})` : ''}`, description: email }) }, (forcePermissions ? { width: 260, maxWidth: 260 } : { minWidth: 260 })), { Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cH }),
    subTenants && {
        Header: t('organizationHeader'),
        accessor: ({ tenants }) => {
            var _a;
            const items = (_a = tenants === null || tenants === void 0 ? void 0 : tenants.map((tenant) => {
                var _a;
                let text = (_a = subTenants.find((subTenant) => subTenant.tenantId === tenant.tenantId)) === null || _a === void 0 ? void 0 : _a.tenantName;
                if (!text && tenant.tenantId === currentTenantId) {
                    text = currentTenantName;
                }
                const subItems = forcePermissions ? tenant.roles.map((role) => role.name) : [];
                return { text, subItems };
            })) !== null && _a !== void 0 ? _a : [];
            return { items: items.filter((item) => item.text), max: 1, container };
        },
        minWidth: 300,
        Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cI,
    },
    {
        Header: t('joinedHeader'),
        accessor: ({ createdAt, verified, activatedForTenant }) => ({ date: createdAt, verified, activatedForTenant }),
        width: 160,
        maxWidth: 160,
        Cell: (props) => {
            return !props.value.activatedForTenant
                ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c5, { color: "secondary", label: t('pendingApprovalStatus') })
                : !props.value.verified
                    ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c5, { color: "secondary", label: t('pendingActivationStatus') })
                    : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c8, Object.assign({}, props));
        },
    },
    {
        Header: t('lastSeenHeader'),
        accessor: ({ lastLogin }) => ({ date: lastLogin }),
        width: 160,
        maxWidth: 160,
        Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c8,
    },
].filter(notNull);

const RolesField$3 = () => {
    const t = useT('users_EditUserRoles');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const [fieldProps, { error, touched }, { setValue }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('roleIds');
    const roles = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bR)(state => state.roles);
    const currentUserRoleLevel = getUserMaxRoleLevel(roles);
    const options = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (roles !== null && roles !== void 0 ? roles : []).filter(role => {
        var _a;
        if (currentUserRoleLevel > ((_a = role.permissionLevel) !== null && _a !== void 0 ? _a : Infinity)) {
            return fieldProps.value.indexOf(role.id) !== -1;
        }
        return true;
    }).map(role => {
        var _a;
        return ({
            label: role.name,
            value: role.id,
            withCheckbox: true,
            disabled: currentUserRoleLevel > ((_a = role.permissionLevel) !== null && _a !== void 0 ? _a : Infinity),
        });
    }), [roles, currentUserRoleLevel, fieldProps.value]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bS, { label: t('selectRolesLabel'), "data-test-id": "editRoleDropdown", name: 'roleIds', multi: true, placeholder: t('selectRolesPlaceholder'), value: fieldProps.value, onChange: (value) => setValue(value, true), errorMessage: touched ? error : undefined, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, options: options });
};
const EditUserRolesForm = (props) => {
    const t = useT('users_EditUserRoles');
    const { updateUser } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cA)();
    const user = useMemoProps(props, 'user');
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
        fullName: user.name,
        email: user.email,
        roleIds: user.roleIds,
    }), [user]);
    const formikProps = {
        onSubmit: ({ email, roleIds }) => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, reject, props.onClose);
            updateUser({ id: user.id, email, roleIds, callback });
        }),
        initialValues,
    };
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit, formError }) => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RolesField$3, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancelBtn", color: 'inherit', variant: 'text', type: 'reset', onClick: props.onClose }, t('cancel')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "updateBtn", disabled: !canSubmit, loading: isSubmitting, color: 'primary', type: 'submit' }, t('update'))));
    });
};
const EditUserRolesDialog = (props) => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('users_EditUserRoles');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { title: t('title') }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditUserRolesForm, Object.assign({}, props)));
};

const DeleteDialogBody = ({ error, description, loading, onDelete, onClose, deleteButtonText, cancelButtonText }) => {
    //TODO change data test id cancelBtn to cancel-btn
    //TODO change data test id deleteBtn to delete-btn
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: "subtitle2Light" }, description),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: error })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancel-btn", color: "inherit", variant: "text", onClick: onClose }, cancelButtonText),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "delete-btn", loading: loading, color: "danger", onClick: onDelete }, deleteButtonText))));
};
const DeleteDialog = (_a) => {
    var { onClose, title, open, dataTestId } = _a, props = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["onClose", "title", "open", "dataTestId"]);
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, { "data-test-id": dataTestId, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, open: open, onClose: onClose, title: title },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeleteDialogBody, Object.assign({}, props, { onClose: onClose }))));
};

const DeleteUserDialog$1 = ({ onClose, open, user }) => {
    const t = useT('users_DeleteUser');
    const [loading, setLoading] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const [error, setError] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(null);
    const { deleteUser } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cA)();
    const callback = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((success, error) => {
        if (error) {
            setError(error);
        }
        else {
            onClose();
        }
        setLoading(false);
    }, [setLoading, setError, onClose]);
    const handleDeleteUser = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setLoading(true);
        setError(null);
        deleteUser({ userId: user === null || user === void 0 ? void 0 : user.id, callback });
    }, [user === null || user === void 0 ? void 0 : user.id, callback, setLoading, setError, deleteUser]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeleteDialog, { dataTestId: 'deleteUserBtn', title: t('title'), cancelButtonText: t('cancel'), deleteButtonText: t('delete'), description: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            t('areYouSureDeleteUser1'),
            " ",
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("strong", null, user === null || user === void 0 ? void 0 : user.name),
            "? ",
            t('areYouSureDeleteUser2')), open: open, error: error, onClose: onClose, loading: !!loading, onDelete: handleDeleteUser }));
};

const UsersTable = () => {
    const t = useT('users');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const container = injector === null || injector === void 0 ? void 0 : injector.adminPortalEl;
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b$)();
    const { loaders, users, roles, permissions, totalPages, pageOffset, filter } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bR)();
    const { resendActivationLink, loadUsers, resendInvitationLink } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cA)();
    const [deleteUserDialog, handleCloseDeleteUser, handleOpenDeleteUser, deleteUserData] = useDialogState();
    const [editUserRolesDialog, handleCloseEditUserRoles, handleOpenEditUserRoles, editUserRolesData] = useDialogState();
    const { policy, loading: loadingPolicy } = usePublicPolicySettings();
    const rolesUse = useRolesMap(roles);
    const rolesMap = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => !loadingPolicy && (policy === null || policy === void 0 ? void 0 : policy.forcePermissions) ? rolesUse : undefined, [policy, rolesUse, loadingPolicy]);
    const { tenants, subTenants } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cd)();
    const tenantName = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        var _a, _b;
        return (_b = (_a = tenants.find(({ tenantId }) => tenantId === user.tenantId)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
    }, [tenants, user.tenantId]);
    const isPermissionsAndRolesEnabled = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => !loadingPolicy && (policy === null || policy === void 0 ? void 0 : policy.forcePermissions), [loadingPolicy, policy]);
    const columns = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        if (subTenants.length > 0) {
            return usersTableColumnsOrganization({ t, user, subTenants, forcePermissions: isPermissionsAndRolesEnabled, container, currentTenantName: tenantName, currentTenantId: user.tenantId });
        }
        else {
            return usersTableColumns({ t, user, rolesMap, container });
        }
    }, [t, user, subTenants, isPermissionsAndRolesEnabled, container, rolesMap, tenantName, user.tenantId]);
    const { searching } = useTableSearch();
    const getRowActions = useUsersTableRowActions$1({
        roles,
        subTenants,
        permissions,
        container,
        resendActivationLink,
        resendInvitationLink,
        handleOpenDeleteUser,
        handleOpenEditUserRoles,
        currentTenantId: user.tenantId
    });
    const onPageChange = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((event, page) => {
        loadUsers({ pageOffset: page - 1 });
    }, [loadUsers]);
    const loading = !!loaders.USERS;
    const tablePlaceholderProps = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        if (loading || searching) {
            return null;
        }
        else if (filter.length === 0 && users.length === 0) {
            return {
                show: true,
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cK, null),
                title: t('noUsersYet'),
                description: t('noUsersYetDescription'),
            };
        }
        else if (filter.length > 0 && users.length === 0) {
            return {
                show: true,
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cL, null),
                title: t('noResultFound'),
                description: t('noResultFoundDescription'),
            };
        }
        return null;
    }, [t, loading, searching, filter.length, users.length]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c7, { forwardedKey: 'users-table', columns: columns, data: users, getRowActions: getRowActions, loading: loading, searching: searching, loadingText: searching ? t('searchingPlaceholder') : undefined, totalPages: totalPages, pageOffset: pageOffset, onPageChange: onPageChange }, tablePlaceholderProps && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cM, Object.assign({}, tablePlaceholderProps))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeleteUserDialog$1, { open: deleteUserDialog, onClose: handleCloseDeleteUser, user: deleteUserData }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditUserRolesDialog, { open: editUserRolesDialog, onClose: handleCloseEditUserRoles, user: editUserRolesData, roles: roles }));
};

const countDifferenceInDays = (expirationDate) => {
    const exp = parseISO(expirationDate);
    const differenceMinutes = differenceInMinutes(exp, new Date());
    const differenceDays = differenceInDays(exp, new Date());
    if (differenceMinutes < 0) {
        return -1;
    }
    return differenceDays + 1;
};
const daysInMinutes = {
    one: 1430,
    seven: 10070,
    thirty: 43190
};
const expirationPeriodsOptions = [{ label: '1 day', value: daysInMinutes.one }, { label: '7 days', value: daysInMinutes.seven }, { label: '30 days', value: daysInMinutes.thirty }];

var EditInviteUserActiveDialog;
(function (EditInviteUserActiveDialog) {
    EditInviteUserActiveDialog["EDIT_LINK"] = "EDIT_LINK";
    EditInviteUserActiveDialog["INVITATION_FORM"] = "INVITATION_FORM";
})(EditInviteUserActiveDialog || (EditInviteUserActiveDialog = {}));

const CopiedLinkIcon = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bT) `
  &.MuiSvgIcon-root {
    width: 13px;
  }
`;
const CopyLinkIcon = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bU) `
  &.MuiSvgIcon-root {
    width: 16px;
    margin-bottom: -1px;
  }
`;
const EditInviteLinkSettingsButton = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B) `
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
`;
const CopyInviteLink = ({ setActiveDialog, isEmailInviteShown }) => {
    const t = useT('users_EditInvitationLink');
    const [isLinkCopied, setIslinkCopied] = useBooleanToggle();
    const routes = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.K)();
    const { inviteTokenState } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bR)();
    const { createInvitationLink, getInvitationLink, deleteInvitationLink } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cA)();
    const { token, expires, tenantInvitationsAllowed } = inviteTokenState !== null && inviteTokenState !== void 0 ? inviteTokenState : {};
    const { hostedLoginBox } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const canCopyInviteLink = usePermission('fe.secure.write.tenantInvites');
    const { baseUrl } = _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__.ContextHolder.getContext();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (!token) {
            getInvitationLink();
        }
        if (expires && countDifferenceInDays(expires) < 0) {
            deleteInvitationLink();
        }
    }, [getInvitationLink, deleteInvitationLink, expires]);
    const createSignupUrl = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((token) => {
        if (hostedLoginBox) {
            return `${baseUrl}/oauth/prelogin?redirectUrl=${window.location.origin}&invitationToken=${token}`;
        }
        else {
            return `${window.location.origin}${routes.signUpUrl}?invitationToken=${token}`;
        }
    }, [hostedLoginBox, baseUrl]);
    const handleCreateInvitationLink = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        if (!token) {
            createInvitationLink({
                callback: (token) => {
                    (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.df)(token ? createSignupUrl(token) : '');
                    setIslinkCopied(true);
                },
            });
        }
        else {
            (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.df)(createSignupUrl(token));
            setIslinkCopied(true);
        }
    }, [createInvitationLink, token, createSignupUrl]);
    const handleSetActiveDialog = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setActiveDialog(EditInviteUserActiveDialog.EDIT_LINK);
    }, [setActiveDialog]);
    const linkExpiredAt = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => countDifferenceInDays(expires), [expires]);
    const showInviteLink = tenantInvitationsAllowed && canCopyInviteLink;
    return !showInviteLink ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null)) : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        isEmailInviteShown && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { mb: 6, mt: 8 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.D, null)),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, justifyContent: 'space-between' },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { mb: 2, variant: 'dialogTitle' }, t('inviteWithLinkTitle')),
                    expires && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { mb: 3, variant: 'body1' },
                        t('linkExpiration', { days: linkExpiredAt }),
                        " ",
                        t(linkExpiredAt > 1 ? 'days' : 'day'))),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": 'copy-invite-btn', type: 'button', color: 'secondary', onClick: handleCreateInvitationLink, startIcon: isLinkCopied ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CopiedLinkIcon, null) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CopyLinkIcon, null) }, t('copyInviteLink'))),
                token && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditInviteLinkSettingsButton, { onClick: handleSetActiveDialog },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { "data-test-id": 'editBtn', variant: 'body1' }, t('edit')))))))));
};

const DeactivateInviteLinkDialog = ({ onClose, open }) => {
    const t = useT('users_DeactivateInvitationLink');
    const [loading, setLoading] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const [error, setError] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(null);
    const { deleteInvitationLink } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cA)();
    const callback = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((success, error) => {
        if (error) {
            setLoading(false);
            setError(error);
        }
        else {
            onClose(true);
        }
    }, [setLoading, setError, onClose]);
    const handleDeleteLink = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setLoading(true);
        setError(null);
        deleteInvitationLink({ callback });
    }, [callback, setLoading, setError, deleteInvitationLink]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeleteDialog, { dataTestId: 'deactivateBtn', title: t('title'), cancelButtonText: t('cancel'), deleteButtonText: t('deactivate'), description: t('areYouSureDeleteInviteLink'), open: open, error: error, onClose: onClose, loading: !!loading, onDelete: handleDeleteLink }));
};

const DeactivateLinkButton = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B) `
  cursor: pointer;
`;
const SendEmailField = () => {
    const t = useT('users_EditInvitationLink');
    const [{ value }, , { setValue, setTouched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('sendNotification');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, ml: -2, alignItems: 'center' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.o, { size: 'small', name: 'sendNotification', checked: value, onChange: () => {
                setValue(!value, true);
                setTouched(true);
            } }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'body1' }, t('sendMeNotification'))));
};
const ExpirationField = () => {
    const t = useT('users_EditInvitationLink');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const [{ value }, { error, touched }, { setValue, setTouched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('expiration');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bS, { "data-test-id": "expirationDropdown", label: t('expirationInputLabel'), name: 'expiration', value: value, placeholder: t('expirationInputPlaceholder'), container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, options: expirationPeriodsOptions, onChange: (value) => {
            setValue(value, true);
            setTouched(true);
        }, error: !!error && touched, errorMessage: error }));
};
const EditInviteLinkDialog = ({ setActiveDialog }) => {
    const t = useT('users_EditInvitationLink');
    const { updateInvitationLink } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cA)();
    const { inviteTokenState } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bR)();
    const { expires, emailsEnabled, shouldSendEmail } = inviteTokenState !== null && inviteTokenState !== void 0 ? inviteTokenState : {};
    const [deactivateLinkDialog, handleCloseDeactivateLink, handleOpenDeactivateLink] = useDialogState();
    const canDeleteInviteLink = usePermission('fe.secure.delete.tenantInvites');
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({ sendNotification: shouldSendEmail !== null && shouldSendEmail !== void 0 ? shouldSendEmail : true }), [shouldSendEmail]);
    const handleSetActiveDialogToInvitationForm = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setActiveDialog(EditInviteUserActiveDialog.INVITATION_FORM);
    }, []);
    const formikProps = {
        onSubmit: ({ sendNotification, expiration }) => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, reject, handleSetActiveDialogToInvitationForm);
            updateInvitationLink({ shouldSendEmail: sendNotification, expiresInMinutes: expiration, callback });
        }),
        initialValues,
    };
    const handleCloseDeactivateInvitationLinkDialog = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((success) => {
        if (success) {
            handleSetActiveDialogToInvitationForm();
        }
        handleCloseDeactivateLink();
    }, [handleCloseDeactivateLink, handleSetActiveDialogToInvitationForm]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit, formError }) => {
        return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ExpirationField, null),
                emailsEnabled && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { mb: 6, mt: 8 },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.D, null)),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { "data-test-id": "notificationBtn", variant: 'dialogTitle', mb: 3 }, t('notification')),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SendEmailField, null))),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                canDeleteInviteLink && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeactivateLinkButton, { onClick: handleOpenDeactivateLink },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { "data-test-id": "deactivateLinkBtn", variant: 'body1', color: 'error' }, t('deactivateLink')))),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": 'backBtn', color: 'inherit', variant: 'text', type: 'reset', onClick: handleSetActiveDialogToInvitationForm }, t('back')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": 'inviteBtn', disabled: !canSubmit, loading: isSubmitting, color: 'primary', type: 'submit' }, t('save'))),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeactivateInviteLinkDialog, { open: deactivateLinkDialog, onClose: handleCloseDeactivateInvitationLinkDialog })));
    }));
};

const FirstNameField$1 = () => {
    const t = useT('users_InviteUser');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('firstName');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ label: t('firstNameInputLabel') }, fieldProps, { autoFocus: true, error: !!error && touched, errorMessage: error, "data-test-id": "nameBox", autoComplete: 'given-name' }));
};
const LastNameField = () => {
    const t = useT('users_InviteUser');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('lastName');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ label: t('lastNameInputLabel') }, fieldProps, { error: !!error && touched, errorMessage: error, "data-test-id": "lastNameBox", autoComplete: 'family-name' }));
};
const PhoneField = () => {
    const t = useT('users_InviteUser');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('phone');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ label: t('phoneInputLabel') }, fieldProps, { error: !!error && touched, errorMessage: error, "data-test-id": "phoneBox", autoComplete: 'tel' }));
};
const EmailField$2 = () => {
    const t = useT('users_InviteUser');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('email');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ label: t('emailInputLabel') }, fieldProps, { error: !!error && touched, errorMessage: error, "data-test-id": "emailBox", autoComplete: 'email' }));
};
const RolesField$2 = ({ roles }) => {
    const t = useT('users_InviteUser');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const [fieldProps, { error, touched }, { setValue, setTouched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('roleIds');
    const options = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (roles !== null && roles !== void 0 ? roles : []).map((role) => ({ label: role.name, value: role.id, withCheckbox: true })), [roles]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bS, { label: t('rolesInputLabel'), name: 'roleIds', multi: true, placeholder: t('rolesInputPlaceholder'), value: fieldProps.value, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, options: options, onChange: (value) => {
            setValue(value, true);
            setTouched(true);
        }, error: !!error && touched, errorMessage: error });
};
const InviteUserForm$1 = (_a) => {
    var _b, _c;
    var { setActiveDialog, hideInviteWithEmail } = _a, props = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["setActiveDialog", "hideInviteWithEmail"]);
    const t = useT('users_InviteUser');
    const { addUser } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cA)();
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.X)();
    const allRoles = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bR)(state => state.roles);
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const metadata = (_c = (_b = _frontegg_types__WEBPACK_IMPORTED_MODULE_4__.Metadata.getInstance(injector.name).navigation.users) === null || _b === void 0 ? void 0 : _b.inviteDialog) !== null && _c !== void 0 ? _c : {};
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        roleIds: [],
    }), []);
    const { policy } = usePublicPolicySettings();
    const validationSchema = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({
        firstName: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('firstNameIsRequired')),
        lastName: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('lastNameIsRequired')),
        email: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ae)(t('emailMustBeValid'), t('emailIsRequired')),
        phone: metadata.phoneNumberField === 'mandatory' ? (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ai)(t('phoneIsRequired'), t('phoneIsInvalid')) :
            (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d1)(t('phoneIsInvalid')),
        roleIds: create().min((policy === null || policy === void 0 ? void 0 : policy.forcePermissions) ? 1 : 0, t('rolesIsRequired')),
    }), [t, metadata.phoneNumberField, policy === null || policy === void 0 ? void 0 : policy.forcePermissions]);
    const formikProps = {
        onSubmit: ({ firstName, lastName, email, phone, roleIds }) => new Promise((resolve, reject) => {
            const name = [firstName, lastName].filter(notNull).join(' ');
            const callback = callbackToPromise(resolve, reject, props.onClose);
            addUser({ name, email, roleIds, phone: phone ? '+' + phone.replace('+', '') : undefined, callback });
        }),
        initialValues,
        validationSchema,
    };
    const roles = checkRoleAccess(allRoles, user);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit, formError }) => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                !hideInviteWithEmail && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, spacing: 4 },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 12, sm: 6 },
                            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FirstNameField$1, null)),
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 12, sm: 6 },
                            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(LastNameField, null))),
                    !!metadata.phoneNumberField && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PhoneField, null),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EmailField$2, null),
                    (policy === null || policy === void 0 ? void 0 : policy.forcePermissions) && roles.length > 0 && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RolesField$2, { roles: roles })),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CopyInviteLink, { setActiveDialog: setActiveDialog, isEmailInviteShown: !hideInviteWithEmail }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancelBtn", color: 'inherit', variant: 'text', type: 'reset', onClick: props.onClose }, t('cancel')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "inviteBtn", disabled: !canSubmit, loading: isSubmitting, color: 'primary', type: 'submit' }, t('invite'))));
    });
};
const InviteUserDialog$1 = (_a) => {
    var { onClose, hideInviteWithEmail } = _a, props = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["onClose", "hideInviteWithEmail"]);
    const t = useT('users_InviteUser');
    const [activeDialog, setActiveDialog] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(EditInviteUserActiveDialog.INVITATION_FORM);
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const handleClose = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        onClose();
        setActiveDialog(EditInviteUserActiveDialog.INVITATION_FORM);
    }, [setActiveDialog, onClose]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { onClose: handleClose, title: t(activeDialog === EditInviteUserActiveDialog.INVITATION_FORM ? 'title' : 'inviteWithLinkSettings') }), activeDialog === EditInviteUserActiveDialog.INVITATION_FORM ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InviteUserForm$1, Object.assign({}, props, { onClose: handleClose, setActiveDialog: setActiveDialog, hideInviteWithEmail: hideInviteWithEmail }))) : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditInviteLinkDialog, { setActiveDialog: setActiveDialog }))));
};

const UsersPage$1 = () => {
    var _a, _b, _c;
    const [searching, setSearching] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const [searchQuery, onSearch] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState('');
    const themeOptions = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.F)();
    const hideInviteWithEmail = (_c = (_b = (_a = themeOptions === null || themeOptions === void 0 ? void 0 : themeOptions.adminPortal) === null || _a === void 0 ? void 0 : _a.pages) === null || _b === void 0 ? void 0 : _b.users) === null || _c === void 0 ? void 0 : _c.hideInviteWithEmail;
    const { users, roles, inviteTokenState } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bR)();
    const { loadUsers, getInvitationLink } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cA)();
    const { loadSubTenants } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cB)();
    const [inviteUserDialog, handleCloseInviteUser, handleOpenInviteUser] = useDialogState();
    const { tenantInvitationsAllowed } = inviteTokenState !== null && inviteTokenState !== void 0 ? inviteTokenState : {};
    const canCopyInviteLink = usePermission('fe.secure.write.tenantInvites');
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        getInvitationLink();
        loadSubTenants();
        const queryObject = { pageOffset: 0, pageSize: 10, filter: [], silentLoading: users.length > 0 };
        loadUsers(queryObject);
        return () => loadUsers(queryObject);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadUsers, getInvitationLink]);
    useEffectAfterMount(() => {
        loadUsers({
            filter: searchQuery ? [{ id: 'searchFilter', value: searchQuery }] : [],
            pageOffset: 0,
            callback: () => setSearching(false),
        });
    }, [searchQuery, loadUsers]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageWrapper, { flex: 1, display: 'flex', flexDirection: 'column' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableSearchContext.Provider, { value: { searching, searchQuery, onSearch, setSearching } },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(UsersHeader, { handleOpenInviteUser: handleOpenInviteUser, isInviteWithEmailEnabled: !hideInviteWithEmail, isInviteLinkEnabled: canCopyInviteLink && tenantInvitationsAllowed }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { mt: 6, flex: 1, display: 'flex', flexDirection: 'column' },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(UsersTable, null)),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InviteUserDialog$1, { open: inviteUserDialog, onClose: handleCloseInviteUser, roles: roles, hideInviteWithEmail: hideInviteWithEmail })));
};
var UsersPage$2 = UsersPage$1;

var UsersPage = wrapPage(UsersPage$2, 'users');

const RolesHeader = ({ handleOpenAddRole }) => {
    const t = useT('roles');
    const { onSearch } = useTableSearch();
    const [search, setSearch] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState('');
    const debounceSearch = useDebounce(search);
    const canAddRole = usePermission('fe.secure.write.roles');
    useAsyncEffect(() => onSearch(debounceSearch), [debounceSearch]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, spacing: 4 },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 12, sm: 6, md: 4 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, { "data-test-id": "searchBox", endAdornment: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cF, null), onChange: (e) => setSearch(e.target.value), placeholder: t('searchInputPlaceholder') }))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: true }),
        canAddRole && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "addRoleBtn", onClick: handleOpenAddRole }, t('addNewRoleButton'))));
};

const RoleName = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(() => {
    const t = useT('roles_AddRole');
    const { values, setFieldValue } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.u)();
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('name');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ label: t('nameInputLabel') }, fieldProps, { onChange: (e) => {
            fieldProps.onChange(e);
            if (values.shouldChangeKey) {
                setFieldValue('key', e.target.value.toLowerCase().replace(/ /g, '-'), true);
            }
        }, autoFocus: true, error: !!error && touched, errorMessage: error, "data-test-id": "roleNameBox" }));
});
const RoleKey = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(() => {
    const t = useT('roles_AddRole');
    const { setFieldValue } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.u)();
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('key');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ label: t('keyInputLabel') }, fieldProps, { onChange: (e) => {
            fieldProps.onChange(e);
            setFieldValue('shouldChangeKey', e.target.value.length === 0, false);
        }, error: !!error && touched, "data-test-id": "roleKeyBox", errorMessage: error }));
});
const RoleDescription = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(() => {
    const t = useT('roles_AddRole');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('description');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ label: t('descriptionInputLabel') }, fieldProps, { error: !!error && touched, errorMessage: error, "data-test-id": "roleDescriptionBox" }));
});
const RoleInherit = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(() => {
    const t = useT('roles_AddRole');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const { roles } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bV)();
    const [fieldProps, { error, touched }, { setValue }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('inherit');
    const options = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (roles !== null && roles !== void 0 ? roles : []).map((role) => ({ label: role.name, value: role.id })), [roles]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bS, { label: t('inheritPermissionInputLabel'), name: 'inherit', placeholder: t('inheritPermissionInputPlaceholder'), value: fieldProps.value, onChange: (value) => setValue(value, true), errorMessage: touched ? error : undefined, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, options: options });
});
const AddRoleForm = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((props, ref) => {
    const t = useT('roles_AddRole');
    const { addRole } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bW)();
    const { roles } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bV)();
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        var _a;
        return ({
            key: '',
            name: '',
            description: '',
            inherit: (_a = roles[0]) === null || _a === void 0 ? void 0 : _a.id,
            shouldChangeKey: true,
        });
    }, [roles]);
    const validationSchema = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({
        name: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('nameIsRequired')),
        key: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('keyIsRequired')),
    }), [t]);
    const formikProps = {
        onSubmit: ({ key, name, description, inherit }) => new Promise((resolve, reject) => {
            var _a;
            const inheritedRole = roles.find(({ id }) => id === inherit);
            const callback = callbackToPromise(resolve, reject);
            addRole({
                key,
                name,
                description,
                permissions: (_a = inheritedRole === null || inheritedRole === void 0 ? void 0 : inheritedRole.permissions) !== null && _a !== void 0 ? _a : [],
                isDefault: false,
                level: 0,
                callback,
            });
        }),
        initialValues,
        validationSchema,
    };
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit, formError }) => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, { ref: ref },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, spacing: 4, mb: 4 },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 6 },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RoleName, null)),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 6 },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RoleKey, null))),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RoleDescription, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RoleInherit, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancelBtn", color: 'inherit', variant: 'text', type: 'reset', onClick: props.onClose }, t('cancel')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "createBtn", disabled: !canSubmit, loading: isSubmitting, color: 'primary', type: 'submit' }, t('create'))));
    });
});
const AddRoleDialog = props => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('roles_AddRole');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { title: t('title'), size: 'sm' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AddRoleForm, Object.assign({}, props)));
};

const rolesTableColumns = (params) => {
    const { t, roles } = params;
    return [
        {
            id: 'actions',
            Header: t('actionsHeader'),
            accessor: ({ name, description }) => ({ title: name, description, multiLineDescription: true }),
            minWidth: 400,
            width: 400,
            maxWidth: 400,
            pivot: true,
            sortable: true,
            Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cH,
        },
        ...roles.map((role, index) => {
            return ({
                id: role.id,
                Header: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'tableSmallHeader' }, role.name),
                accessor: ({ id }) => ({
                    checked: role.permissions.includes(id),
                    containerStyle: { marginLeft: index === roles.length - 1 ? '.75rem' : undefined },
                }),
                width: 160,
                maxWidth: 160,
                Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cN,
            });
        }),
    ].filter(notNull);
};

const RolesTable = () => {
    const t = useT('roles');
    const { searching, searchQuery } = useTableSearch();
    const { loading, roles, permissions, permissionCategories } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bV)();
    const columns = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => rolesTableColumns({ t, roles, permissions }), [t, roles, permissions]);
    const rows = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        if (!!searchQuery) {
            return permissions.filter((permission) => {
                var _a;
                return permission.name.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1
                    || ((_a = permission.description) !== null && _a !== void 0 ? _a : '').toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1
                    || permission.key.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1;
            });
        }
        return permissions;
    }, [permissions, searchQuery]);
    const categoriesRows = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        const mapped = rows.reduce((p, n) => (Object.assign(Object.assign({}, p), { [n.id]: n })), {});
        return permissionCategories.concat().sort((a, b) => a.name.localeCompare(b.name))
            .map(category => {
            const fPermissions = category.permissionIds.map(permissionId => mapped[permissionId]).filter(notNull);
            if (fPermissions.length === 0) {
                return [];
            }
            return [{
                    __type: 'categoryRow',
                    id: category.id,
                    title: category.name,
                },
                ...fPermissions.sort((a, b) => a.name.localeCompare(b.name)),
            ];
        }).reduce((p, n) => [...p, ...n], []);
    }, [rows, permissionCategories]);
    const tablePlaceholderProps = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        if (loading) {
            return null;
        }
        else if (searchQuery && rows.length === 0) {
            return {
                show: true,
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cL, null),
                title: t('noResultFound'),
                description: t('noResultFoundDescription'),
            };
        }
        return null;
    }, [t, loading, searchQuery, rows.length]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c7, { forwardedKey: 'roles-table', columns: columns, data: categoriesRows, loading: loading, searching: searching, loadingText: searching ? t('searchingPlaceholder') : undefined }, tablePlaceholderProps && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cM, Object.assign({}, tablePlaceholderProps))));
};

const RolesPage$1 = () => {
    const [searching, setSearching] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const [searchQuery, onSearch] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState('');
    const { roles } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bV)();
    const { loadRolesAndPermissions } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bW)();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        loadRolesAndPermissions({ silentLoading: roles.length > 0 });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadRolesAndPermissions]);
    const [addRoleDialog, handleCloseAddRole, handleOpenAddRole] = useDialogState();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageWrapper, { flex: 1, display: 'flex', flexDirection: 'column' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableSearchContext.Provider, { value: { searching, searchQuery, onSearch, setSearching } },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RolesHeader, { handleOpenAddRole: handleOpenAddRole }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { mt: 6, flex: 1, display: 'flex', flexDirection: 'column' },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RolesTable, null)),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AddRoleDialog, { open: addRoleDialog, onClose: handleCloseAddRole })));
};
var RolesPage$2 = RolesPage$1;

var RolesPage = wrapPage(RolesPage$2, 'roles');

const AttemptsInput = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(() => {
    const t = useT('security_EditLockoutPolicy');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('maxAttempts');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({}, fieldProps, { autoFocus: true, inputMode: 'decimal', label: t('attemptsInputLabel'), placeholder: t('attemptsInputPlaceholder'), error: !!error && touched, "data-test-id": "userLockoutBox", errorMessage: error }));
});
const EditMfaPolicyForm$1 = (props) => {
    const t = useT('security_EditLockoutPolicy');
    const { policy, saveSecurityPolicyLockout } = useLockoutPolicySettings();
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        var _a, _b;
        return ({
            id: policy === null || policy === void 0 ? void 0 : policy.id,
            enabled: (_a = policy === null || policy === void 0 ? void 0 : policy.enabled) !== null && _a !== void 0 ? _a : true,
            maxAttempts: (_b = policy === null || policy === void 0 ? void 0 : policy.maxAttempts) !== null && _b !== void 0 ? _b : 0,
        });
    }, [policy]);
    const formikProps = {
        onSubmit: ({ id, maxAttempts, enabled }) => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, reject, props.onClose);
            saveSecurityPolicyLockout({ callback, id, maxAttempts: Number(maxAttempts), enabled });
        }),
        initialValues,
        validationSchema: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({
            maxAttempts: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d3)(t('attemptsInputErrorMessage')),
        }),
    };
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit, formError }) => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AttemptsInput, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancelBtn", color: 'inherit', variant: 'text', type: 'reset', onClick: props.onClose }, t('cancel')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "saveBtn", disabled: !canSubmit, loading: isSubmitting, color: 'primary', type: 'submit' }, t('save'))));
    });
};
const EditLockoutPolicyDialog = props => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('security_EditLockoutPolicy');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ "data-test-id": "edit-user-lockout-dialog", container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { dialogTitleDataTestId: "user-lockout-header", title: t('title'), size: 'sm' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditMfaPolicyForm$1, Object.assign({}, props)));
};

const MfaPolicySelect = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(() => {
    const t = useT('security_EditMfaPolicy');
    const [fieldProps, , { setValue }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('enforceMFAType');
    const activeMfaTypes = useOptionalEnforceMfaTypes();
    const options = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        return [{
                'data-test-id': 'DontForce',
                label: t('dontForceTitle'),
                value: MfaTypeEnum.DontForce,
                description: t('dontForceDescription'),
            }, {
                'data-test-id': 'Force',
                label: t('forceTitle'),
                value: MfaTypeEnum.Force,
                description: t('forceDescription'),
            }, {
                'data-test-id': 'ForceExceptSAML',
                label: t('forceExceptSAMLTitle'),
                value: MfaTypeEnum.ForceExceptSAML,
                description: t('forceExceptSAMLDescription')
            }].filter(({ value }) => activeMfaTypes.includes(value));
    }, [t, activeMfaTypes]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bY, { items: options, name: fieldProps.name, value: fieldProps.value, onChange: (_e, value) => setValue(value, true) });
});
const EditMfaPolicyForm = (props) => {
    const t = useT('security_EditMfaPolicy');
    const { policy, saveSecurityPolicyMfa } = useMfaPolicySettings();
    const vendorMfaPolicy = useVendorMfaPolicySettings();
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        var _a, _b, _c;
        return ({
            id: policy === null || policy === void 0 ? void 0 : policy.id,
            enforceMFAType: (_c = (_a = policy === null || policy === void 0 ? void 0 : policy.enforceMFAType) !== null && _a !== void 0 ? _a : (_b = vendorMfaPolicy.policy) === null || _b === void 0 ? void 0 : _b.enforceMFAType) !== null && _c !== void 0 ? _c : MfaTypeEnum.DontForce,
        });
    }, [policy]);
    const formikProps = {
        onSubmit: ({ id, enforceMFAType }) => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, reject, props.onClose);
            saveSecurityPolicyMfa({ callback, id, enforceMFAType });
        }),
        initialValues,
    };
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit, formError }) => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, { noPadding: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MfaPolicySelect, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancelBtn", color: 'inherit', variant: 'text', type: 'reset', onClick: props.onClose }, t('cancel')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "saveBtn", disabled: !canSubmit, loading: isSubmitting, color: 'primary', type: 'submit' }, t('save'))));
    });
};
const EditMfaPolicyDialog = props => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('security_EditMfaPolicy');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ "data-test-id": "edit-MFA-dialog", container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { dialogTitleDataTestId: "mfa-policy-header", title: t('title'), size: 'sm' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditMfaPolicyForm, Object.assign({}, props)));
};

const HistorySizeInput = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(() => {
    const t = useT('security_EditPasswordHistoryPolicy');
    const [fieldProps, { error }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('historySize');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({}, fieldProps, { autoFocus: true, inputMode: 'decimal', label: t('sizeInputLabel'), placeholder: t('sizeInputPlaceholder'), error: !!error, "data-test-id": "userPasswordHistoryBox", errorMessage: error }));
});
const EditPasswordHistoryPolicyForm = (props) => {
    const t = useT('security_EditPasswordHistoryPolicy');
    const { policy, saveSecurityPolicyPasswordHistory } = usePasswordHistoryPolicySettings();
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        var _a, _b;
        return ({
            id: policy === null || policy === void 0 ? void 0 : policy.id,
            enabled: (_a = policy === null || policy === void 0 ? void 0 : policy.enabled) !== null && _a !== void 0 ? _a : true,
            historySize: (_b = policy === null || policy === void 0 ? void 0 : policy.historySize) !== null && _b !== void 0 ? _b : 0,
        });
    }, [policy]);
    const formikProps = {
        onSubmit: ({ id, historySize, enabled }) => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, reject, props.onClose);
            saveSecurityPolicyPasswordHistory({ callback, id, historySize: Number(historySize), enabled });
        }),
        initialValues,
        validationSchema: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({
            historySize: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d4)(t('sizeIsRequired'), t('sizeMustBeNumber'), t('sizeMustBeGt0'), t('sizeMustBelt10')),
        }),
    };
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit, formError }) => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(HistorySizeInput, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancelBtn", color: 'inherit', variant: 'text', type: 'reset', onClick: props.onClose }, t('cancel')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "saveBtn", disabled: !canSubmit, loading: isSubmitting, color: 'primary', type: 'submit' }, t('save'))));
    });
};
const EditPasswordHistoryPolicyDialog = props => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('security_EditPasswordHistoryPolicy');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ "data-test-id": 'password-history-dialog', dialogTitleDataTestId: 'password-history-header', container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { title: t('title'), size: 'sm' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditPasswordHistoryPolicyForm, Object.assign({}, props)));
};

const MfaSecurityPolicyValue = () => {
    const t = useT('security');
    const { loading, policy } = useMfaPolicySettings();
    const { vendorMfaPolicy } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__._)();
    const activeMFATypes = useOptionalEnforceMfaTypes();
    const activeMFAPolicy = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => { var _a; return (policy === null || policy === void 0 ? void 0 : policy.enforceMFAType) && activeMFATypes.includes(policy.enforceMFAType) ? policy.enforceMFAType : (_a = vendorMfaPolicy.policy) === null || _a === void 0 ? void 0 : _a.enforceMFAType; }, [vendorMfaPolicy, policy, activeMFATypes]);
    let description;
    switch (activeMFAPolicy) {
        case 'Force':
            description = t('mfaPolicyForceDescription');
            break;
        case 'ForceExceptSAML':
            description = t('mfaPolicyForceExceptSAMLDescription');
            break;
        default:
            description = t('mfaPolicyDontForceDescription');
    }
    return (loading && !policy) ?
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bN, { width: 80, height: 18 })
        :
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { "data-test-id": "mfa-description", variant: 'body1' }, description);
};
const LockoutSecurityPolicyValue = () => {
    const t = useT('security');
    const { loading, policy } = useLockoutPolicySettings();
    if (loading && !policy) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bN, { width: 80, height: 18 });
    }
    if (!policy) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'body1' }, t('lockoutNotConfigured'));
    }
    if (policy.enabled) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'body1' },
            t('lockoutEnabledMaxAttempts1'),
            " ",
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("b", null, policy.maxAttempts),
            " ",
            t('lockoutEnabledMaxAttempts2'));
    }
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'body1' }, t('lockoutDisabled'));
};
const PasswordHistorySecurityPolicyValue = () => {
    const t = useT('security');
    const { loading, policy } = usePasswordHistoryPolicySettings();
    if (loading && !policy) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bN, { width: 80, height: 18 });
    }
    if (!policy) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'body1' }, t('passwordHistoryNotConfigured'));
    }
    if (policy.enabled) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'body1' },
            t('passwordHistoryEnabledHistorySize1'),
            " ",
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("b", null, policy.historySize),
            " ",
            t('passwordHistoryEnabledHistorySize2'));
    }
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'body1' }, t('passwordHistoryDisabled'));
};
const getLockoutSecurityPolicyActions = (policy, save) => {
    if (policy) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cO, { checked: policy.enabled, onChange: (_, value) => save(Object.assign(Object.assign({}, policy), { enabled: value })) });
    }
    return undefined;
};
const getPasswordHistorySecurityPolicyActions = (policy, save) => {
    if (policy) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cO, { "data-test-id": "switch", checked: policy.enabled, onChange: (_, value) => save(Object.assign(Object.assign({}, policy), { enabled: value })) });
    }
    return undefined;
};
const SecurityPage$1 = () => {
    const t = useT('security');
    const { loading: mfaLoading, policy: mfaPolicy } = useMfaPolicySettings(true);
    const { loading: lockoutLoading, policy: lockoutPolicy, saveSecurityPolicyLockout } = useLockoutPolicySettings(true);
    const { loading: passwordHistoryLoading, policy: passwordHistoryPolicy, saveSecurityPolicyPasswordHistory, } = usePasswordHistoryPolicySettings(true);
    const [editMfaPolicyDialog, handleCloseMfaPolicyDialog, handleOpenMfaPolicyDialog] = useDialogState();
    const [editLockoutPolicyDialog, handleCloseLockoutPolicyDialog, handleOpenLockoutPolicyDialog] = useDialogState();
    const [editPasswordHistoryPolicyDialog, handleClosePasswordHistoryPolicyDialog, handleOpenPasswordHistoryPolicyDialog] = useDialogState();
    const { loading: vendorMfaPolicyLoading } = useVendorMfaPolicySettings();
    const activeMfaTypes = useOptionalEnforceMfaTypes();
    const isMfaDisabled = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        if (vendorMfaPolicyLoading) {
            return true;
        }
        if (mfaLoading && !mfaPolicy) {
            return true;
        }
        if (activeMfaTypes.length <= 1) {
            return true;
        }
        return false;
    }, [activeMfaTypes, mfaLoading, mfaPolicy]);
    const canEditSecurityPolicy = usePermission('fe.secure.write.securityPolicy');
    const items = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => [{
            id: 'mfa',
            title: t('mfaTitle'),
            value: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MfaSecurityPolicyValue, null),
            disabled: isMfaDisabled,
            onEditClick: handleOpenMfaPolicyDialog,
            disabledRow: !canEditSecurityPolicy,
        }, {
            id: 'lockout',
            title: t('lockoutTitle'),
            value: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(LockoutSecurityPolicyValue, null),
            actions: getLockoutSecurityPolicyActions(lockoutPolicy, saveSecurityPolicyLockout),
            disabled: lockoutLoading && !lockoutPolicy,
            onEditClick: handleOpenLockoutPolicyDialog,
            disabledRow: !canEditSecurityPolicy,
        },
        {
            id: 'passwordHistory',
            title: t('passwordHistoryTitle'),
            value: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PasswordHistorySecurityPolicyValue, null),
            actions: getPasswordHistorySecurityPolicyActions(passwordHistoryPolicy, saveSecurityPolicyPasswordHistory),
            disabled: passwordHistoryLoading && !passwordHistoryPolicy,
            onEditClick: handleOpenPasswordHistoryPolicyDialog,
            disabledRow: !canEditSecurityPolicy,
        }], [
        t,
        lockoutPolicy,
        passwordHistoryPolicy,
        lockoutLoading,
        passwordHistoryLoading,
        saveSecurityPolicyLockout,
        saveSecurityPolicyPasswordHistory,
        handleOpenMfaPolicyDialog,
        handleOpenLockoutPolicyDialog,
        handleOpenPasswordHistoryPolicyDialog,
        canEditSecurityPolicy,
        isMfaDisabled,
    ]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageWrapper, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cy, { title: t('subtitle'), items: items }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditMfaPolicyDialog, { open: editMfaPolicyDialog, onClose: handleCloseMfaPolicyDialog }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditLockoutPolicyDialog, { open: editLockoutPolicyDialog, onClose: handleCloseLockoutPolicyDialog }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditPasswordHistoryPolicyDialog, { open: editPasswordHistoryPolicyDialog, onClose: handleClosePasswordHistoryPolicyDialog }));
};
var SecurityPage$2 = SecurityPage$1;

var SecurityPage = wrapPage(SecurityPage$2, 'security');

const SsoHeader = ({ handleOpenNewConfiguration }) => {
    const t = useT('sso_Header');
    const canCreateNewConfiguration = usePermission('fe.secure.write.samlConfiguration');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, spacing: 4, alignItems: 'center' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 12, sm: 6, md: 4 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, null, t('title'))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: true }),
        canCreateNewConfiguration && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "CreateNewSsoConfigBtn", onClick: handleOpenNewConfiguration }, t('addNew'))));
};

var SamlVendors;
(function (SamlVendors) {
    SamlVendors["Saml"] = "saml";
    SamlVendors["Oidc"] = "oidc";
})(SamlVendors || (SamlVendors = {}));
var ConfigSaml;
(function (ConfigSaml) {
    ConfigSaml["manual"] = "manual";
    ConfigSaml["auto"] = "auto";
})(ConfigSaml || (ConfigSaml = {}));
const IDPS = [
    { value: SamlVendors.Saml, label: 'SAML' },
    { value: SamlVendors.Oidc, label: 'Open ID Connect' },
];
const defaultSamlVendor = SamlVendors.Saml;

const SsoTableColumns = ({ onChangeStatus, rolesMap, container, t, hasWritePermission, forcePermissions, showConfigureSSOMessage }) => {
    return [
        {
            Header: t('domainsColumnName'),
            Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cH,
            accessor: ({ domains }) => ({ description: domains === null || domains === void 0 ? void 0 : domains.map(({ domain }) => domain).join(', ') }),
            minWidth: forcePermissions ? 280 : 180
        },
        {
            Header: t('idpColumnName'),
            Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cH,
            accessor: ({ type }) => { var _a; return ({ description: (_a = IDPS.find((idp) => idp.value === type)) === null || _a === void 0 ? void 0 : _a.label }); },
        },
        forcePermissions && {
            Header: t('rolesColumnName'),
            Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cI,
            accessor: ({ roleIds }) => { var _a; return ({ items: (_a = roleIds === null || roleIds === void 0 ? void 0 : roleIds.map((v) => ({ text: rolesMap[v] }))) !== null && _a !== void 0 ? _a : [], max: 2, container }); },
            minWidth: 280
        },
        {
            id: 'status',
            Header: t('statusColumnName'),
            Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cP,
            accessor: (ssoConfig) => {
                const isStep1Checked = !!ssoConfig.publicCertificate || !!ssoConfig.oidcClientId;
                const isStep2Checked = ssoConfig.domains.some(({ validated }) => validated);
                const isStep3Checked = !!ssoConfig.roleIds.length;
                const canEnableDisableSSO = hasWritePermission && isStep1Checked && isStep2Checked && (isStep3Checked || !forcePermissions);
                return {
                    checked: canEnableDisableSSO && ssoConfig.enabled,
                    onChange: () => {
                        if (canEnableDisableSSO) {
                            onChangeStatus(ssoConfig);
                        }
                        else {
                            showConfigureSSOMessage();
                        }
                    }
                };
            },
            maxWidth: 100,
            minWidth: 100,
        },
    ].filter(notNull);
};
const useSSOTableRowActions = ({ container, handleOpenDeleteConfig, handleOpenEditConfig, hasWritePermission, hasDeletePermission, }) => {
    const t = useT('sso_Table');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (row) => {
        const items = [];
        const handleEditConfig = () => {
            handleOpenEditConfig(row);
        };
        const handleDeleteConfig = () => {
            handleOpenDeleteConfig(row);
        };
        if (hasWritePermission) {
            items.push({
                text: t('editSSOConfig'),
                onClick: handleEditConfig,
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bI, { "data-test-id": 'editBtn' }),
            });
        }
        if (hasDeletePermission) {
            items.push({
                negative: true,
                text: t('deleteSSOConfig'),
                onClick: handleDeleteConfig,
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bZ, { "data-test-id": 'deleteBtn' }),
            });
        }
        return { items, container };
    }, [container, handleOpenDeleteConfig, handleOpenEditConfig, hasDeletePermission, hasWritePermission, t]);
};

const DeleteSSOConfigurationForm = ({ onClose, ssoConfig }) => {
    const t = useT('sso_Table');
    const { deleteSSOConfiguration } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a2)();
    const { loaders: { DELETE_SSO_CONFIGURATION: loading }, errors: { DELETE_SSO_CONFIGURATION: error } } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a1)();
    const handleDeleteSSOConfig = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        const callback = (success) => {
            if (success) {
                onClose();
            }
        };
        deleteSSOConfiguration({ ssoConfigId: ssoConfig.id, callback });
    }, [deleteSSOConfiguration, onClose]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'subtitle2Light' }, t('areYouSureDeleteSSOConfig')),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: error })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancelBtn", color: "inherit", variant: "text", onClick: onClose }, t('cancel')),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "deleteBtn", loading: loading, color: "danger", onClick: handleDeleteSSOConfig }, t('deleteSSOConfig')))));
};
const DeleteSSOConfigurationDialog = (_a) => {
    var { ssoConfig } = _a, props = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["ssoConfig"]);
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('sso_Table');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { title: t('deleteSSOConfigTitle') }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeleteSSOConfigurationForm, Object.assign({ ssoConfig: ssoConfig }, props))));
};

const SSODialogContext = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.createContext({
    stepNumber: 0,
    handleClose: () => { },
    handleOpen: () => { },
    handleNextStep: () => { },
    handlePrevStep: () => { },
    currentSSOConfiguration: {},
    setCurrentSSOConfigurationId: (id) => { },
    isFirstStep: true,
    isLastStep: false,
    steps: []
});
const useSSODialog = () => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(SSODialogContext);
const SSODialogProvider = ({ children, steps, handleClose, handleOpen, initialSSOConfigurationId }) => {
    const [stepNumber, setStepNumber] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(0);
    const [currentSSOConfigurationId, setCurrentSSOConfigurationId] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(initialSSOConfigurationId);
    const { ssoConfigurations } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a1)();
    const { isLastStep, isFirstStep } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({ isLastStep: stepNumber === steps.length - 1, isFirstStep: stepNumber === 0 }), [stepNumber, steps]);
    const handleNextStep = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        if (!isLastStep) {
            setStepNumber((step) => step + 1);
        }
        else {
            handleClose();
        }
    }, [setStepNumber, isLastStep]);
    const handlePrevStep = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        if (!isFirstStep) {
            setStepNumber((step) => step - 1);
        }
        else {
            handleClose();
        }
    }, [setStepNumber, isFirstStep]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SSODialogContext.Provider, { value: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
            stepNumber,
            handleClose,
            handleOpen,
            handlePrevStep,
            handleNextStep,
            currentSSOConfiguration: ssoConfigurations.find((config) => config.id === currentSSOConfigurationId),
            setCurrentSSOConfigurationId,
            isFirstStep,
            isLastStep,
            steps,
        }), [
            setCurrentSSOConfigurationId,
            stepNumber,
            handleClose,
            handleOpen,
            handlePrevStep,
            handleNextStep,
            setStepNumber,
            currentSSOConfigurationId,
            ssoConfigurations,
            isFirstStep,
            isLastStep,
            steps,
        ]) }, children));
};

const ssoConfigureIdpFormValidation = ({ t }) => {
    return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d5)().shape({
        configFile: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d6)().when('samlVendor', {
            is: SamlVendors.Saml,
            then: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d6)().when('configSaml', { is: 'auto', then: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d7)(t('metadataFileIsRequired')) }),
        }),
        ssoEndpoint: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d6)().when('configSaml', {
            is: 'manual',
            then: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d6)().when('samlVendor', {
                is: SamlVendors.Saml,
                then: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d8)(t('endpointIsRequired'), t('endpointUrlIsInvalid')),
                otherwise: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d8)(t('issuerUrlIsRequired'), t('issuerUrlIsInvalid')),
            }),
        }),
        publicCertificate: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d6)().when('configSaml', {
            is: 'manual',
            then: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d6)().when('samlVendor', {
                is: SamlVendors.Saml,
                then: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('publicCertificateIsRequired')),
            }),
        }),
        oidcClientId: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d6)().when('configSaml', {
            is: 'manual',
            then: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d6)().when('samlVendor', {
                is: SamlVendors.Oidc,
                then: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('clientIdIsRequired')),
            }),
        }),
        oidcSecret: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d6)().when('configSaml', {
            is: 'manual',
            then: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d6)().when('samlVendor', {
                is: SamlVendors.Oidc,
                then: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('secretIsRequired')),
            }),
        }),
    });
};
const ssoManageAuthorizationValidation = (t) => {
    return (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d5)().shape({
        roleIds: create().min(1, t('rolesIsRequired')),
        rolesGroups: create().of((0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d5)().shape({ group: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.da)().required(), roleIds: create().of((0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.da)()).min(1) })),
        addedGroups: create().of((0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d5)().shape({ group: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.da)().required(), roleIds: create().of((0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.da)()).min(1) })),
    });
};

const SsoFooter = (props) => {
    const t = useT('sso_Table');
    const { isValid, isSubmitting, onCancel, onNext, showSkipButton, onSkip, approveButtonText } = props;
    const { handlePrevStep, isFirstStep, isLastStep } = useSSODialog();
    const handleCancelButton = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        if (onCancel) {
            onCancel();
        }
        else {
            handlePrevStep();
        }
    }, [onCancel, handlePrevStep]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancelBtn", color: "inherit", variant: "text", type: "reset", onClick: handleCancelButton }, isFirstStep ? t('cancel') : t('back')),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { display: 'flex' },
            showSkipButton && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": 'skipBtn', onClick: onSkip, color: 'inherit', variant: "text" }, t('skip')),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": 'approveBtn', disabled: !isValid, loading: isSubmitting, color: "primary", type: "submit", onClick: onNext }, approveButtonText !== null && approveButtonText !== void 0 ? approveButtonText : (isLastStep ? t('done') : t('proceed')))));
};

const useValidateWellKnownDebounced = ({ value, setError }) => {
    const t = useT('sso_ConfigureIdp');
    const debouncedValue = useDebounce(value, 500);
    const wellKnownError = t('ssoWellKnownError');
    useAsyncEffect(() => {
        if (!value) {
            setError(t('issuerUrlIsRequired'));
        }
        else {
            setError(wellKnownError);
        }
    }, [value, setError, wellKnownError, t]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        const controller = new AbortController();
        const abortSignal = controller.signal;
        if (debouncedValue) {
            (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cc)(debouncedValue, abortSignal).then((verified) => setError(verified ? '' : wellKnownError));
        }
        return () => controller.abort();
        // eslint-disable-next-line
    }, [debouncedValue]);
};
const IssuerUrlInput = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I) `
  .MuiInputBase-adornedEnd {
    .MuiSvgIcon-root {
      ${({ theme, error }) => error && `color: ${theme.palette.error.main}`};
      ${({ theme, success }) => success && `color: ${theme.palette.success.main}`};
    }
  }
`;
const AcsUrlField = () => {
    const t = useT('sso_ConfigureIdp');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('acsUrl');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ label: t('acsUrlInputLabel') }, fieldProps, { errorMessage: error, error: !!error && touched, disabled: true }));
};
const EntityIdField = () => {
    const t = useT('sso_ConfigureIdp');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('spEntityId');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ label: t('entityIdInputLabel') }, fieldProps, { errorMessage: error, error: !!error && touched, disabled: true }));
};
const SsoEndpointField = () => {
    const t = useT('sso_ConfigureIdp');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('ssoEndpoint');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ "data-tets-id": "ssoEndPointBox", label: t('endpointInputLabel') }, fieldProps, { errorMessage: error, error: !!error && touched, placeholder: t('endpointInputPlaceholder') })));
};
const IssuerUrlField = ({ setError, error }) => {
    const [fieldProps, { touched, error: formikError }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)({ name: 'ssoEndpoint' });
    const t = useT('sso_ConfigureIdp');
    useValidateWellKnownDebounced({ setError, value: fieldProps.value });
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(IssuerUrlInput, Object.assign({ "data-test-id": "issuerUrlBox", endAdornment: touched && (!!error) ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.k, null) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ca, null), label: t('issuerUrlInputLabel'), errorMessage: (touched && formikError) || error, error: !!((touched && formikError) || error), success: !(formikError || error), tip: t('issuerUrlInputHelpMessage') }, fieldProps));
};
const RedirectUriField = () => {
    var _a;
    const t = useT('sso_ConfigureIdp');
    const { oidcRedirectUrl } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.K)();
    const { origin } = window.location;
    const defaultRedirectUri = `${origin}${oidcRedirectUrl}`;
    const { oidcConfiguration } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a1)();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, { label: t('redirectUriInputLabel'), value: (_a = oidcConfiguration === null || oidcConfiguration === void 0 ? void 0 : oidcConfiguration.redirectUri) !== null && _a !== void 0 ? _a : defaultRedirectUri, disabled: true });
};
const OidcClientIdField = () => {
    const t = useT('sso_ConfigureIdp');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('oidcClientId');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ "data-test-id": "clientIDBox", label: t('clientIdInputLabel') }, fieldProps, { errorMessage: error, error: !!error && touched, placeholder: t('clientIdInputPlaceholder') })));
};
const PublicSertificateField = () => {
    const t = useT('sso_ConfigureIdp');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('publicCertificate');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ "data-tets-id": "publicCertificateBox", multiline: true, rows: 4, label: t('publicCertificateInputLabel') }, fieldProps, { errorMessage: error, error: !!error && touched, placeholder: t('publicCertificateInputPlaceholder') })));
};
const OidcSecretField = () => {
    const t = useT('sso_ConfigureIdp');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('oidcSecret');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.au, Object.assign({ "data-test-id": "secretBox", label: t('secretInputLabel') }, fieldProps, { errorMessage: error, error: !!error && touched, placeholder: t('secretInputPlaceholder') })));
};
const IdpField = () => {
    const t = useT('sso_ConfigureIdp');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const [fieldProps, { error, touched }, { setValue }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('samlVendor');
    const [, , { setValue: setConfigSaml }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('configSaml');
    const handleOnChange = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((value) => {
        setValue(value, true);
        setConfigSaml(ConfigSaml.manual);
    }, [setValue, setConfigSaml]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bS, { "data-test-id": "ssoSelectIdpDrop", label: t('idpSelectLabel'), name: fieldProps.name, value: fieldProps.value, onChange: handleOnChange, errorMessage: touched ? error : undefined, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, options: IDPS }));
};
const ConfigSamlField = () => {
    const t = useT('sso_ConfigureIdp');
    const [fieldProps, , { setValue }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('configSaml');
    const handleSetValue = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        const value = fieldProps.value === ConfigSaml.manual ? ConfigSaml.auto : ConfigSaml.manual;
        setValue(value);
    }, [fieldProps, setValue]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { mb: 4 },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.dg, { row: true, defaultValue: "manual", onChange: handleSetValue },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aG, { "data-test-id": "autoBtn", value: "auto", control: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.dh, null), label: t('radioAutomaticLabel') }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aG, { "data-test-id": "menualBtn", value: "manual", control: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.dh, null), label: t('radioManualLabel') })));
};
const DropZoneField = () => {
    const t = useT('sso_ConfigureIdp');
    const [fieldProps, { error, touched }, { setValue, setError, setTouched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('configFile');
    const handleSetValue = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((files) => {
        setTouched(true);
        if (!files.length) {
            setError(t('metadataFileTypeErrorMessage'));
        }
        else {
            setError(null);
            setValue(files);
        }
    }, [setValue]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { "data-test-id": "metadataFileBox", marginBottom: "8px" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { color: touched && !!error ? 'error' : undefined, variant: "label" }, t('metadataFileLabel'))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.di, { "data-test-id": "metadataFileBox", fileType: ".xml", value: fieldProps.value, onDrop: handleSetValue, description: t('metadataFileDescription') }),
        touched && !!error && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: error })));
};

const SsoConfigureIdpBottomInputs = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.memo(({ samlVendor, setIssuerUrlError, issuerUrlError }) => {
    return (samlVendor === SamlVendors.Oidc ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(IssuerUrlField, { error: issuerUrlError, setError: setIssuerUrlError }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(OidcClientIdField, null),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(OidcSecretField, null),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RedirectUriField, null))) : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SsoEndpointField, null),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PublicSertificateField, null))));
});
const SsoConfigureIdpForm = () => {
    const t = useT('sso_ConfigureIdp');
    const { saveSSOConfigurationV2, updateSSOConfiguration, saveSSOConfigurationByMetadata, updateSSOConfigurationByMetadata } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a2)();
    const { currentSSOConfiguration, setCurrentSSOConfigurationId, handleNextStep } = useSSODialog();
    const { samlMetadata } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a1)();
    const [issuerUrlError, setIssuerUrlError] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState('');
    const initialSamlVendor = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => Object.values(SamlVendors).includes(currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.type)
        ? currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.type
        : defaultSamlVendor, [currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.type]);
    const validationSchema = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ssoConfigureIdpFormValidation({ t }), [t]);
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        var _a, _b, _c, _d;
        return (Object.assign(Object.assign({ samlVendor: initialSamlVendor, configFile: undefined, configSaml: ConfigSaml.manual }, currentSSOConfiguration), { acsUrl: (_a = currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.acsUrl) !== null && _a !== void 0 ? _a : (_b = samlMetadata === null || samlMetadata === void 0 ? void 0 : samlMetadata.configuration) === null || _b === void 0 ? void 0 : _b.acsUrl, spEntityId: (_c = currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.spEntityId) !== null && _c !== void 0 ? _c : (_d = samlMetadata === null || samlMetadata === void 0 ? void 0 : samlMetadata.configuration) === null || _d === void 0 ? void 0 : _d.spEntityId }));
    }, [currentSSOConfiguration, samlMetadata, initialSamlVendor]);
    const formikProps = {
        onSubmit: (values) => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, reject, (data) => {
                setCurrentSSOConfigurationId(data.id);
                handleNextStep();
            });
            const isEditMode = !!currentSSOConfiguration;
            const { samlVendor, configSaml } = values;
            const isOidcConfiguration = samlVendor === SamlVendors.Oidc;
            if (configSaml === 'auto' && !isOidcConfiguration) {
                const payload = { configFile: values.configFile[0], callback };
                if (isEditMode) {
                    updateSSOConfigurationByMetadata(Object.assign({ ssoConfigId: currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.id }, payload));
                }
                else {
                    saveSSOConfigurationByMetadata(payload);
                }
            }
            else {
                const { ssoEndpoint, publicCertificate, oidcClientId, oidcSecret } = values;
                const payload = {
                    ssoEndpoint,
                    type: samlVendor,
                    publicCertificate: isOidcConfiguration ? undefined : publicCertificate,
                    oidcClientId: isOidcConfiguration ? oidcClientId : undefined,
                    oidcSecret: isOidcConfiguration ? oidcSecret : undefined,
                    callback
                };
                if (isEditMode) {
                    updateSSOConfiguration(Object.assign(Object.assign({}, payload), { ssoConfigId: currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.id }));
                }
                else {
                    saveSSOConfigurationV2(Object.assign(Object.assign({}, payload), { enabled: false }));
                }
            }
        }),
        initialValues,
        validationSchema,
        validateOnMount: true
    };
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ values, isValid, formError, isSubmitting }) => {
        return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, null,
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(IdpField, null),
                    values.samlVendor !== SamlVendors.Oidc &&
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
                            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AcsUrlField, null),
                            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EntityIdField, null),
                            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ConfigSamlField, null)),
                    values.configSaml === ConfigSaml.auto && values.samlVendor === SamlVendors.Saml
                        ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DropZoneField, null)
                        : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SsoConfigureIdpBottomInputs, { samlVendor: values.samlVendor, issuerUrlError: issuerUrlError, setIssuerUrlError: setIssuerUrlError })),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SsoFooter, { isValid: isValid && (values.samlVendor !== SamlVendors.Oidc || !issuerUrlError), isSubmitting: isSubmitting }))));
    }));
};

const DomainFields = ({ ssoDomain }) => {
    const t = useT('sso_ClaimDomain');
    const [fieldProps, { error, touched, value }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('domain');
    const { currentSSOConfiguration } = useSSODialog();
    const recordValue = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.generatedVerification, [currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.generatedVerification]);
    const recordName = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => `_saml-domain-challenge.${value}`, [value]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ label: t('domainInputLabel') }, fieldProps, { "data-test-id": "domainNameBox", errorMessage: error, error: !!error && touched, placeholder: t('domainInputPlaceholder') })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aD, { in: (ssoDomain === null || ssoDomain === void 0 ? void 0 : ssoDomain.domain) === value, mountOnEnter: true, unmountOnExit: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: "subtitle2" }, t('claimDomainText')),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("br", null),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aL, { "data-test-id": "ssoRecordNameLabel", label: t('recordNameLabel'), readOnly: true, value: recordName !== null && recordName !== void 0 ? recordName : '' }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aL, { "data-test-id": "ssoRecordValueLabel", label: t('recordValueLabel'), readOnly: true, value: recordValue !== null && recordValue !== void 0 ? recordValue : '' })));
};

const AddDomainButton = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l) `
  align-self: flex-start;
`;
const DomainInput = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I) `
  margin-bottom: 0;
  margin-right: 0.5rem;
  flex: 1;
  .MuiInputBase-adornedEnd {
    .MuiSvgIcon-root {
      ${({ theme, error }) => error && `color: ${theme.palette.error.main}`};
      ${({ theme, success }) => success && `color: ${theme.palette.success.main}`};
    }
  }
`;
const DeleteIconStyle = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bZ)(({ theme }) => ({
    color: theme.palette.grey[500],
    width: '1rem',
    height: '1rem',
}));
const EditIconStyle = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bI)(({ theme }) => ({
    color: theme.palette.grey[500],
    width: '1rem',
    height: '1rem',
}));
const IconButtonStyle = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bQ) `
  width: 2rem;
  height: 2rem;
`;
const DomainListContainer = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B)(({ theme }) => ({
    paddingBottom: theme.spacing(2),
    marginBottom: theme.spacing(4),
    borderBottom: `1px solid ${theme.palette.grey[300]}`
}));
const SSOClaimDomainList = ({ onAddDomain, onEditDomain, hideDomainList }) => {
    var _a;
    const { currentSSOConfiguration, handlePrevStep } = useSSODialog();
    const { deleteSSODomain } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a2)();
    const hasWritePermission = usePermission('fe.secure.write.samlConfiguration');
    const hasDeletePermission = usePermission('fe.secure.delete.samlConfiguration');
    const handleDeleteDomain = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((domainId) => {
        const callback = () => {
            if ((currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.domains.length) === 1) {
                handlePrevStep();
            }
        };
        deleteSSODomain({ ssoConfigId: currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.id, domainId, callback });
    }, [deleteSSODomain, currentSSOConfiguration]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DomainListContainer, null, (_a = currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.domains) === null || _a === void 0 ? void 0 : _a.map((ssoDomain) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { key: ssoDomain.id, mb: 2, display: 'flex', alignItems: 'center' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DomainInput, { "data-test-id": ssoDomain.domain, endAdornment: ssoDomain.validated ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.k, null) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ca, null), error: !ssoDomain.validated, success: ssoDomain.validated, value: ssoDomain.domain, disabled: true }),
            hasWritePermission && hasDeletePermission && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(IconButtonStyle, { onClick: () => onEditDomain(ssoDomain) },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditIconStyle, null)),
            hasDeletePermission && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(IconButtonStyle, { onClick: () => handleDeleteDomain(ssoDomain.id) },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeleteIconStyle, null))))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AddDomainButton, { "data-test-id": "addGroupBtn", onClick: onAddDomain, type: 'button', size: 'small', color: 'secondary' }, "Add another domain")));
};

const SsoClaimDomainForm = (props) => {
    const t = useT('sso_ClaimDomain');
    const [ssoDomain, setSSODomain] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(props.domain);
    const { saveSSODomain, validateSSODomainV2, deleteSSODomain } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a2)();
    const { currentSSOConfiguration, handleNextStep } = useSSODialog();
    const [isDomainListShown, setIsDomainListShown] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState((currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.domains.length) > 0);
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
        domain: (ssoDomain === null || ssoDomain === void 0 ? void 0 : ssoDomain.domain) || '',
    }), [ssoDomain]);
    const validationSchema = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({
        domain: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d9)(t('domainIsRequired'), t('domainMustBeValid')),
    }), [t]);
    const formikProps = {
        onSubmit: ({ domain }) => new Promise((resolve, reject) => (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.g)(void 0, void 0, void 0, function* () {
            const callback = callbackToPromise(resolve, reject, showDomainList);
            const saveDomain = () => {
                saveSSODomain({
                    ssoConfigId: currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.id,
                    domain,
                    callback: (data, error) => {
                        if (error) {
                            reject(error);
                            return;
                        }
                        else if (data) {
                            setSSODomain(data);
                            resolve();
                        }
                    }
                });
            };
            if (ssoDomain && ssoDomain.domain === domain) {
                validateSSODomainV2({ callback, domainId: ssoDomain.id, ssoConfigId: currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.id });
            }
            else if (ssoDomain) {
                deleteSSODomain({ ssoConfigId: currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.id, domainId: ssoDomain.id, callback: saveDomain });
            }
            else {
                saveDomain();
            }
        })),
        enableReinitialize: true,
        initialValues,
        validationSchema: isDomainListShown ? undefined : validationSchema,
    };
    const showDomainList = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setIsDomainListShown(true);
    }, []);
    const hideDomainList = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setIsDomainListShown(false);
    }, []);
    const handleEditDomain = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((ssoDomain) => {
        hideDomainList();
        setSSODomain(ssoDomain);
    }, [hideDomainList, setSSODomain]);
    const handleAddDomain = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        hideDomainList();
        setSSODomain(undefined);
    }, [hideDomainList, setSSODomain]);
    if (isDomainListShown) {
        return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SSOClaimDomainList, { hideDomainList: hideDomainList, onAddDomain: handleAddDomain, onEditDomain: handleEditDomain })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SsoFooter, { isValid: true, isSubmitting: false, onNext: handleNextStep }))));
    }
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ formError, isSubmitting, values }) => {
        return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DomainFields, { ssoDomain: ssoDomain }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SsoFooter, { onCancel: (currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.domains.length) > 1 ? showDomainList : undefined, isValid: true, isSubmitting: isSubmitting, showSkipButton: (ssoDomain === null || ssoDomain === void 0 ? void 0 : ssoDomain.domain) === values.domain, onSkip: showDomainList, approveButtonText: (ssoDomain === null || ssoDomain === void 0 ? void 0 : ssoDomain.domain) === values.domain ? t('validate') : t('proceed') }))));
    }));
};

const ArrowsIconStyled = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b_)(({ theme }) => ({
    width: '0.5rem',
    height: '0.5rem',
    color: theme.palette.grey[500],
}));
const GroupNameField = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ error, errorMessage, group, handleGroupChange }) => {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, { error: error, errorMessage: errorMessage, value: group, onChange: handleGroupChange });
}, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bO)('error', 'errorMessage', 'group', 'handleGroupChange'));
const RolesField$1 = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ roles, handleRolesChange, groupId, error }) => {
    const t = useT('sso_ManageAuthorization');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b$)();
    const allRoles = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bR)(state => state.roles);
    const accessRoles = checkRoleAccess(allRoles, user);
    const options = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (accessRoles !== null && accessRoles !== void 0 ? accessRoles : []).map(role => ({ label: role.name, value: role.id, withCheckbox: true })), [accessRoles]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bS, { error: error, errorMessage: t('rolesGroupsMappingError'), name: `${groupId}_roleIds`, multi: true, oneLineMulti: true, placeholder: t('rolesInputPlaceholder'), value: roles, onChange: handleRolesChange, options: options, optionType: "tree", container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl });
}, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bO)('roles', 'handleRolesChange', 'groupId', 'error'));
const DeleteGroupButton = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ onDelete }) => {
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bQ, { onClick: () => onDelete() },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { component: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bZ, width: "1rem", height: "1rem", color: "#ADBCD2" }));
}, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bO)('onDelete'));
const RolesGroup = ({ groupId }) => {
    var _a, _b;
    const t = useT('sso_ManageAuthorization');
    const { values, setFieldValue, setFieldError } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.u)();
    const fieldValue = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => values.rolesGroups.find((group) => group.id === groupId), [values.rolesGroups, groupId]);
    const isGroupNameUnique = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => values.rolesGroups.filter(({ group }) => group === (fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.group)).length < 2, [values.rolesGroups, fieldValue]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (!isGroupNameUnique) {
            setFieldError('rolesGroups', t('rolesGroupsNameDuplicateError'));
        }
    }, [isGroupNameUnique, setFieldError, t]);
    const handleGroupNameChange = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e) => {
        const groupIdx = values.rolesGroups.findIndex((group) => group.id === groupId);
        const newRolesGroupsArray = values.rolesGroups.map((oldValue, currIdx) => currIdx === groupIdx ? Object.assign(Object.assign({}, oldValue), { group: e.target.value }) : oldValue);
        setFieldValue('rolesGroups', newRolesGroupsArray);
    }, [setFieldValue, values.rolesGroups, groupId]);
    const handleRolesChange = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((newValue) => {
        const changedGroups = [];
        const groupIdx = values.rolesGroups.findIndex((group) => group.id === groupId);
        const newrolesGroups = values.rolesGroups.map((oldValue, currIdx) => {
            let rolesGroup = oldValue;
            if (currIdx === groupIdx) {
                rolesGroup = Object.assign(Object.assign({}, oldValue), { roleIds: newValue });
                changedGroups.push(rolesGroup);
            }
            return rolesGroup;
        });
        setFieldValue('rolesGroups', newrolesGroups);
        setFieldValue('changedGroups', changedGroups);
    }, [setFieldValue, values.rolesGroups, values.changedGroups, groupId]);
    const deleteGroup = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        const newDeletedGroupsArr = [...values.deletedGroups, groupId];
        const newGroupsArr = values.rolesGroups.filter((group) => !newDeletedGroupsArr.includes(group.id));
        setFieldValue('deletedGroups', newDeletedGroupsArr);
        setFieldValue('rolesGroups', newGroupsArr);
    }, [setFieldValue, groupId, values.rolesGroups, values.deletedGroups]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, alignItems: 'baseline', justifyContent: "space-between", spacing: 2 },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 5 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(GroupNameField, { group: (_a = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.group) !== null && _a !== void 0 ? _a : '', handleGroupChange: handleGroupNameChange, error: !isGroupNameUnique || (!!fieldValue && fieldValue.group.length < 1), errorMessage: isGroupNameUnique ? t('rolesGroupsNameEmptyError') : t('rolesGroupsNameDuplicateError') })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 1, display: "flex", justifyContent: "center" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ArrowsIconStyled, null)),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 5 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RolesField$1, { roles: (_b = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.roleIds) !== null && _b !== void 0 ? _b : [], error: fieldValue && fieldValue.roleIds.length < 1, handleRolesChange: handleRolesChange, groupId: groupId })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 1, display: "flex", justifyContent: "center" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeleteGroupButton, { onDelete: deleteGroup })));
};
const NewRolesGroup = ({ idx }) => {
    var _a, _b;
    const t = useT('sso_ManageAuthorization');
    const { values, setFieldValue, setFieldError } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.u)();
    const fieldValue = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => values.addedGroups[idx], [idx, values.addedGroups]);
    const isGroupNameUnique = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => [...values.rolesGroups, ...values.addedGroups].filter(({ group }) => group === (fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.group)).length < 2, [values, fieldValue]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (!isGroupNameUnique) {
            setFieldError('addedGroups', 'Group name must be unique');
        }
    }, [isGroupNameUnique, setFieldError]);
    const handleGroupNameChange = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e) => {
        const newRolesGroupsArray = values.addedGroups.map((oldValue, currIdx) => currIdx === idx ? Object.assign(Object.assign({}, oldValue), { group: e.target.value }) : oldValue);
        setFieldValue('addedGroups', newRolesGroupsArray);
    }, [setFieldValue, values.addedGroups, idx]);
    const handleRolesChange = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((newValue) => {
        const newrolesGroups = values.addedGroups.map((oldValue, currIdx) => currIdx === idx ? Object.assign(Object.assign({}, oldValue), { roleIds: newValue }) : oldValue);
        setFieldValue('addedGroups', newrolesGroups);
    }, [setFieldValue, values.addedGroups, idx]);
    const deleteGroup = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        const newGroupsArr = values.addedGroups.filter((group, index) => idx !== index);
        setFieldValue('addedGroups', newGroupsArr);
    }, [setFieldValue, idx, values.addedGroups]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, alignItems: 'baseline', justifyContent: "space-between", spacing: 2 },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 5 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(GroupNameField, { group: (_a = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.group) !== null && _a !== void 0 ? _a : '', handleGroupChange: handleGroupNameChange, error: !isGroupNameUnique || (!!fieldValue && fieldValue.group.length < 1), errorMessage: isGroupNameUnique ? t('rolesGroupsNameEmptyError') : t('rolesGroupsNameDuplicateError') })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 1, display: "flex", justifyContent: "center" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ArrowsIconStyled, null)),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 5 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RolesField$1, { roles: (_b = fieldValue === null || fieldValue === void 0 ? void 0 : fieldValue.roleIds) !== null && _b !== void 0 ? _b : [], error: fieldValue && fieldValue.roleIds.length < 1, handleRolesChange: handleRolesChange, groupId: `${idx}` })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 1, display: "flex", justifyContent: "center" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeleteGroupButton, { onDelete: deleteGroup })));
};

const AddMappingButton = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l) `
  &.MuiButton-root {
    justify-content: space-between;
    height: 2rem;
    margin-top: 1rem;
    display: flex;
    padding: 1rem;
    align-self: flex-start;
    .MuiSvgIcon-root {
      padding-right: .5rem;
    }
  }
`;
const TableHeadRowGrid = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G) `
  background-color: #F5F6F8;
  padding: 0.75rem 2rem;
  border-bottom: 1px solid #E5EAF3;
`;
const TableBodyGrid = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G) `
  padding: 1rem 1rem 1rem 2rem;
`;
const AddIconStyle = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c0) `
  width: 0.75rem;
  height: 0.75rem,
`;
const AddIconButton = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l) `
  margin-bottom: 1rem;
  margin-left: 2rem;
  minWidth: 0;
  width: fit-content;
  padding: 0.75rem;
  color: #ADBCD2;
`;
const GroupsTable = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ addGroup }) => {
    var _a;
    const { values } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.u)();
    const t = useT('sso_ManageAuthorization');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { mt: 3, flex: 1, border: '1px solid #E5EAF3', borderRadius: '0.25rem', display: 'flex', flexDirection: 'column' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableHeadRowGrid, { container: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 6 },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'label' },
                    " ",
                    t('group'))),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 6 },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { marginLeft: '0.75rem', variant: 'label' },
                    " ",
                    t('roles')))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableBodyGrid, { container: true },
            values.rolesGroups.map((g) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RolesGroup, { "data-test-id": "groupBox", groupId: g.id })), (_a = values.addedGroups) === null || _a === void 0 ? void 0 :
            _a.map((g, idx) => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(NewRolesGroup, { idx: idx }))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AddIconButton, { "data-test-id": "addGroupBtn", onClick: addGroup, type: 'button', size: 'small', color: 'secondary' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AddIconStyle, null)));
}, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bO)('addGroup'));
const findNewGroups = (existingGroups, newGroups) => {
    const existingGroupsIds = existingGroups.map(({ id }) => id);
    const groupsToAdd = newGroups.filter((g) => !existingGroupsIds.includes(g.id));
    return groupsToAdd;
};
const RolesGroupsTable = () => {
    const t = useT('sso_ManageAuthorization');
    const { rolesGroups } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a1)();
    const { values, setFieldValue } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.u)();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        const existingGroupsIds = [...values.rolesGroups.map(({ id }) => id), ...values.deletedGroups];
        const isNewGroupAdded = rolesGroups === null || rolesGroups === void 0 ? void 0 : rolesGroups.some(({ id }) => !existingGroupsIds.includes(id));
        if (isNewGroupAdded) {
            const newGroup = findNewGroups(values.rolesGroups, rolesGroups !== null && rolesGroups !== void 0 ? rolesGroups : []);
            let newFieldValue = [...values.rolesGroups];
            if (newGroup) {
                newFieldValue = newFieldValue.concat(newGroup);
            }
            setFieldValue('rolesGroups', newFieldValue.filter((group) => !values.deletedGroups.includes(group.id)));
        }
    }, [values, rolesGroups, setFieldValue]);
    const shouldShowTable = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => [...values.addedGroups, ...values.rolesGroups].length > 0, [values]);
    const addGroup = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        const newAddedGroupsValue = [...values.addedGroups];
        newAddedGroupsValue.push({ group: '', roleIds: [] });
        setFieldValue('addedGroups', newAddedGroupsValue);
    }, [values.addedGroups, setFieldValue]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { marginTop: '2rem', fontSize: '1rem', variant: 'label' }, t('rolesGroupsMappingTitle')),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { fontWeight: '600', color: 'GrayText', variant: 'subtitle2Light' }, t('rolesGroupsMappingDescription')),
        shouldShowTable ?
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(GroupsTable, { addGroup: addGroup })
            :
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AddMappingButton, { "data-test-id": "addMappingBtn", color: 'secondary', onClick: addGroup, type: 'button', size: 'small' }, t('ssoAddMapping')));
};

const isAllGroupNamesUnique = (values) => {
    const uniquedValues = values.rolesGroups.reduce((acc, { group }) => (acc.includes(group) ? acc : [...acc, group]), []);
    return uniquedValues.length === values.rolesGroups.length;
};
const InputTipIcon = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c1) `
  &.MuiSvgIcon-root {
    width: 0.75rem !important;
    height: 0.75rem !important;
    fill: #ADBCD2;
  }
`;
const SsoManageAuthorizationForm = () => {
    const t = useT('sso_ManageAuthorization');
    const { setSSODefaultRoles, setSSOGroups, updateSSOGroups } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a2)();
    const { currentSSOConfiguration, handleNextStep } = useSSODialog();
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        var _a, _b;
        return ({
            roleIds: (_a = currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.roleIds) !== null && _a !== void 0 ? _a : [],
            rolesGroups: (_b = currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.groups) !== null && _b !== void 0 ? _b : [],
            deletedGroups: [],
            addedGroups: [],
            changedGroups: [],
        });
    }, []);
    const formikProps = {
        onSubmit: (values) => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, reject, handleNextStep);
            setSSOGroups({
                ssoConfigId: currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.id,
                groupsToAdd: values.addedGroups,
                groupsToDelete: values.deletedGroups,
                callback: (data, error) => {
                    if (error) {
                        reject(error);
                        return;
                    }
                    else if (data) {
                        updateSSOGroups({ ssoConfigId: currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.id, changedGroups: values.changedGroups });
                        setSSODefaultRoles({ ssoConfigId: currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.id, roleIds: values === null || values === void 0 ? void 0 : values.roleIds, callback });
                    }
                },
            });
        }),
        initialValues,
        validationSchema: ssoManageAuthorizationValidation(t),
        validateOnMount: true,
    };
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ formError, isSubmitting, isValid, values }) => {
        return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, { style: { maxHeight: '55vh' } },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { display: "flex", alignItems: "center", width: "fit-content" },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: "label", paddingBottom: "0.25rem" }, t('selectRolesLabel')),
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.db, { action: "hover", mountNode: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, placement: "right", arrow: true, trigger: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { display: "flex", marginLeft: "0.5rem", marginBottom: "0.25rem" },
                                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InputTipIcon, null)) },
                            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { color: "#3C4A5A", variant: "subtitle2Light" }, t('selectRolesHelpMessage')))),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RolesField$4, { label: "", placeholder: t('rolesInputPlaceholder') }),
                    (currentSSOConfiguration === null || currentSSOConfiguration === void 0 ? void 0 : currentSSOConfiguration.type) === SamlVendors.Saml && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RolesGroupsTable, null),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: formError }))),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SsoFooter, { isValid: isValid || !isAllGroupNamesUnique(values), isSubmitting: isSubmitting }))));
    }));
};

const StepperStyle = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(Stepper$1) `
  padding: ${({ theme }) => theme.spacing(4)};
`;
const MultiStepForm = () => {
    const { stepNumber, steps } = useSSODialog();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StepperStyle, { activeStep: stepNumber }, steps.map(({ label }) => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Step$1, { key: label },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StepLabel$1, null, label))))),
        steps[stepNumber].component);
};
const SsoConfigurationDialogForm = ({ open, handleOpen, handleClose, initialSSOConfigurationId }) => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const { policy } = usePublicPolicySettings();
    const t = useT('sso');
    const steps = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        return [
            {
                component: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SsoConfigureIdpForm, null),
                label: t('stepOneTitle'),
            },
            {
                component: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SsoClaimDomainForm, null),
                label: t('stepTwoTitle'),
            },
            ...((policy === null || policy === void 0 ? void 0 : policy.forcePermissions) ?
                [{
                        component: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SsoManageAuthorizationForm, null),
                        label: t('stepThreeTitle'),
                    }]
                : []),
        ];
    }, [policy === null || policy === void 0 ? void 0 : policy.forcePermissions]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, { topGravity: false, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, title: 'Configure SSO', open: open, onClose: handleClose },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SSODialogProvider, { steps: steps, handleOpen: handleOpen, handleClose: handleClose, initialSSOConfigurationId: initialSSOConfigurationId },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(MultiStepForm, null))));
};

const SsoTable = ({ showConfigureSSOMessage }) => {
    var _a;
    const t = useT('sso_Table');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const { roles } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bR)();
    const rolesMap = useRolesMap(roles);
    const { ssoConfigurations: ssoConfigurationsData, loaders: { LOAD_SSO_CONFIGURATIONS: loading } } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a1)();
    const { updateSSOConfiguration } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.a2)();
    const { policy, loading: loadingPolicy } = usePublicPolicySettings();
    const [deleteConfigDialog, handleCloseDeleteSSOConfig, handleOpenDeleteSSOConfig, ssoConfigToDelete] = useDialogState();
    const [editSSOConfigDialogOpen, handleCloseEditSSOConfig, handleOpenEditSSOConfig, ssoConfigToEdit] = useDialogState();
    const hasWritePermission = usePermission('fe.secure.write.samlConfiguration');
    const hasDeletePermission = usePermission('fe.secure.delete.samlConfiguration');
    const handleChangeStatus = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((ssoConfig) => {
        updateSSOConfiguration({ ssoConfigId: ssoConfig.id, enabled: !ssoConfig.enabled });
    }, [updateSSOConfiguration]);
    const columns = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => SsoTableColumns({
        container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl,
        forcePermissions: !loadingPolicy && (policy === null || policy === void 0 ? void 0 : policy.forcePermissions),
        onChangeStatus: handleChangeStatus,
        rolesMap,
        hasWritePermission,
        showConfigureSSOMessage,
        t,
    }), [t, handleChangeStatus, showConfigureSSOMessage, rolesMap, injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, policy, loadingPolicy, hasWritePermission]);
    const getRowActions = useSSOTableRowActions({
        container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl,
        handleOpenEditConfig: handleOpenEditSSOConfig,
        handleOpenDeleteConfig: handleOpenDeleteSSOConfig,
        hasWritePermission,
        hasDeletePermission,
    });
    const tablePlaceholderProps = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        if (loading) {
            return null;
        }
        if (!ssoConfigurationsData.length) {
            return {
                show: true,
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cm, null),
                title: t('noSSOConfigsYet'),
                description: t('noSSOConfigsYetDescription'),
            };
        }
        return null;
    }, [loading, ssoConfigurationsData, t]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c7, { loading: !!loading, container: (_a = injector === null || injector === void 0 ? void 0 : injector.adminPortalEl) !== null && _a !== void 0 ? _a : document.body, columns: columns, data: ssoConfigurationsData, getRowActions: getRowActions }, tablePlaceholderProps && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cM, Object.assign({}, tablePlaceholderProps))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeleteSSOConfigurationDialog, { open: deleteConfigDialog, onClose: handleCloseDeleteSSOConfig, ssoConfig: ssoConfigToDelete }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SsoConfigurationDialogForm, { open: editSSOConfigDialogOpen, handleClose: handleCloseEditSSOConfig, handleOpen: handleOpenEditSSOConfig, initialSSOConfigurationId: ssoConfigToEdit === null || ssoConfigToEdit === void 0 ? void 0 : ssoConfigToEdit.id })));
};

const SsoPage = () => {
    const { loadRoles } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cA)();
    const [isConfigureSSOMessage, setIsConfigureSSOMessage] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const [addSSOConfigDialogOpen, handleCloseAddSSOConfig, handleOpenAddSSOConfig] = useDialogState();
    const t = useT('sso');
    const showConfigureSSOMessage = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setIsConfigureSSOMessage(true);
    }, [setIsConfigureSSOMessage]);
    const hideConfigureSSOMessage = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setIsConfigureSSOMessage(false);
    }, [setIsConfigureSSOMessage]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        loadRoles();
    }, [loadRoles]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageWrapper, { flex: 1, display: 'flex', flexDirection: 'column' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aD, { in: isConfigureSSOMessage },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { mb: 8 },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cC, { onClose: hideConfigureSSOMessage, severity: 'warning' }, t('enableAlert')))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SsoHeader, { handleOpenNewConfiguration: handleOpenAddSSOConfig }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { mt: 9, flex: 1, display: 'flex', flexDirection: 'column' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SsoTable, { showConfigureSSOMessage: showConfigureSSOMessage })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SsoConfigurationDialogForm, { open: addSSOConfigDialogOpen, handleOpen: handleOpenAddSSOConfig, handleClose: handleCloseAddSSOConfig }));
};
var SsoPage$1 = SsoPage;

var MultipleSsoPage = wrapPage(SsoPage$1, 'sso');

class UserMapCache {
    constructor() {
        this.mapIds = {};
        this.mapEmails = {};
    }
    static getInstance() {
        if (!UserMapCache.instance) {
            UserMapCache.instance = new UserMapCache();
        }
        return UserMapCache.instance;
    }
    static getUserById(userId, users) {
        const map = this.getInstance().mapIds;
        if (!map[userId]) {
            map[userId] = {
                data: null,
                loading: true,
            };
            map[userId].promise = new Promise((resolve) => {
                const userFromTeams = users === null || users === void 0 ? void 0 : users.find(u => u.id === userId);
                if (userFromTeams) {
                    map[userId].data = Object.assign(Object.assign({}, userFromTeams), { profilePictureUrl: userFromTeams.profileImageUrl });
                    map[userId].loading = false;
                    map[userId].promise = undefined;
                    this.getInstance().mapEmails[userFromTeams.email] = map[userId];
                    resolve(userFromTeams);
                    return;
                }
                _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__.api.auth.getUserById({ userId })
                    .then((user) => {
                    map[userId].data = user;
                    map[userId].loading = false;
                    map[userId].promise = undefined;
                    this.getInstance().mapEmails[user.email] = map[userId];
                    resolve(user);
                })
                    .catch((e) => {
                    map[userId].data = null;
                    map[userId].loading = false;
                    map[userId].promise = undefined;
                    resolve(null);
                });
            });
        }
        const { loading, promise, data } = map[userId];
        if (loading && promise != null) {
            return promise;
        }
        return new Promise((resolve) => resolve(data));
    }
    static getUserByEmail(email, users) {
        const map = this.getInstance().mapEmails;
        if (!map[email]) {
            map[email] = {
                data: null,
                loading: true,
            };
            map[email].promise = new Promise((resolve) => {
                const userFromTeams = users === null || users === void 0 ? void 0 : users.find(u => u.email === email);
                if (userFromTeams) {
                    map[email].data = Object.assign(Object.assign({}, userFromTeams), { profilePictureUrl: userFromTeams.profileImageUrl });
                    map[email].loading = false;
                    map[email].promise = undefined;
                    this.getInstance().mapIds[userFromTeams.id] = map[email];
                    resolve(userFromTeams);
                    return;
                }
                _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__.api.teams.loadUsers({ filter: [{ id: 'searchFilter', value: email }], pageSize: 1, pageOffset: 0 })
                    .then((users) => {
                    if (users.items.length > 0) {
                        const user = users.items[0];
                        map[email].data = Object.assign(Object.assign({}, user), { profilePictureUrl: user.profileImageUrl });
                        map[email].loading = false;
                        map[email].promise = undefined;
                        this.getInstance().mapIds[user.id] = map[email];
                        resolve(user);
                    }
                    else {
                        map[email].data = null;
                        map[email].loading = false;
                        map[email].promise = undefined;
                        resolve(null);
                    }
                })
                    .catch((e) => {
                    map[email].data = null;
                    map[email].loading = false;
                    map[email].promise = undefined;
                    resolve(null);
                });
            });
        }
        const { loading, promise, data } = map[email];
        if (loading && promise != null) {
            return promise;
        }
        return new Promise((resolve) => resolve(data));
    }
}

const TableUserCell = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(({ value: { userId, email, name } }) => {
    const [currentUser, setCurrentUser] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(null);
    const users = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bR)(state => state.users);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (userId) {
            UserMapCache.getUserById(userId, users).then(setCurrentUser);
        }
        else if (email) {
            UserMapCache.getUserByEmail(email, users).then(setCurrentUser);
        }
    }, [userId, email, users, setCurrentUser]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c2, { value: currentUser !== null && currentUser !== void 0 ? currentUser : { name: name !== null && name !== void 0 ? name : 'Unknown', email: email !== null && email !== void 0 ? email : '' } });
}, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bO)('value.userId', 'value.email'));

const ApiTokensTableColumns = ({ t, container, rolesMap, isPermissionsAndRolesDisabled }) => [
    {
        Header: t('clientIdHeader'),
        accessor: ({ clientId, description }) => ({ title: description, description: clientId, copyValue: clientId }),
        minWidth: 370,
        maxWidth: 370,
        Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cQ,
    },
    ...isPermissionsAndRolesDisabled ? [] : [{
            Header: t('rolesHeader'),
            accessor: ({ roleIds }) => { var _a; return ({ items: (_a = roleIds === null || roleIds === void 0 ? void 0 : roleIds.map(v => ({ text: rolesMap[v] }))) !== null && _a !== void 0 ? _a : [], max: 1, container }); },
            minWidth: 200,
            Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cI,
        }],
    {
        Header: t('createdOnHeader'),
        accessor: ({ createdAt }) => ({ date: createdAt }),
        width: 140,
        maxWidth: 140,
        Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c8,
    },
    {
        Header: t('createdByHeader'),
        accessor: ({ createdByUserId }) => ({ userId: createdByUserId }),
        minWidth: 260,
        Cell: TableUserCell,
    },
];
const ApiTokenTableRowActions = ({ t, container, handleOpenDeleteToken, }) => (row) => {
    const items = [
        {
            icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bZ, { "data-test-id": "deleteApiBtn" }),
            onClick: () => handleOpenDeleteToken(row.clientId),
            text: t('deleteApiTokenAction'),
            negative: true,
        },
    ];
    return { items, container };
};

const DeleteApiTokenDialog$1 = ({ onClose, open, token = '' }) => {
    const t = useT('apiTokens_DeleteToken');
    const [submitted, setSubmitted] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const { loaders: { DELETE_API_TOKEN: loading }, errors: { DELETE_API_TOKEN: error }, } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c3)();
    const { deleteTenantApiToken, setApiTokensError, setApiTokensLoader } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c4)();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        setApiTokensError({ key: _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .ApiStateKeys.DELETE_API_TOKEN */ .GL.DELETE_API_TOKEN, value: false });
        setApiTokensLoader({ key: _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .ApiStateKeys.DELETE_API_TOKEN */ .GL.DELETE_API_TOKEN, value: false });
    }, [setApiTokensError, setApiTokensLoader]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (submitted && !error && !loading) {
            onClose();
        }
    }, [submitted, error, loading, onClose]);
    const handleDeleteApiToken = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        deleteTenantApiToken(token);
        setSubmitted(true);
    }, [token, setSubmitted, deleteTenantApiToken]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeleteDialog, { dataTestId: 'deleteApiBtn', title: t('title'), cancelButtonText: t('cancel'), deleteButtonText: t('delete'), description: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            t('areYouSureDeleteApiToken1'),
            " ",
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("strong", null,
                "(Token: ",
                token,
                ")"),
            "? ",
            t('areYouSureDeleteApiToken2')), open: open, error: error, onClose: onClose, loading: !!loading, onDelete: handleDeleteApiToken }));
};

const ApiTokensTable = () => {
    const t = useT('apiTokens');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const container = injector === null || injector === void 0 ? void 0 : injector.adminPortalEl;
    const { roles } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bR)();
    const { apiTokensDataTenant: tokensData, searchValue, loaders: { LOAD_API_TOKENS: loading } } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c3)();
    const rolesMap = useRolesMap(roles);
    const { policy, loading: loadingPolicy } = usePublicPolicySettings();
    const isPermissionsAndRolesDisabled = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => !loadingPolicy && !(policy === null || policy === void 0 ? void 0 : policy.forcePermissions), [loadingPolicy, policy]);
    const [deleteTokenDialog, handleCloseDeleteToken, handleOpenDeleteToken, deleteApiTokenData] = useDialogState();
    const rows = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        if (!!searchValue) {
            return tokensData.filter((token) => token.description.indexOf(searchValue) !== -1 || token.clientId.indexOf(searchValue) !== -1);
        }
        return tokensData;
    }, [tokensData, searchValue]);
    const columns = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ApiTokensTableColumns({
        t,
        rolesMap,
        container,
        isPermissionsAndRolesDisabled,
    }), [container, rolesMap, t, isPermissionsAndRolesDisabled]);
    const getRowActions = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ApiTokenTableRowActions({
        t,
        container,
        handleOpenDeleteToken,
    }), [t, container, handleOpenDeleteToken]);
    const tablePlaceholderProps = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        if (loading) {
            return null;
        }
        else if (!searchValue && rows.length === 0) {
            return {
                show: true,
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cp, null),
                title: t('noApiTokensYet'),
                description: t('noApiTokensYetDescription'),
            };
        }
        else if (searchValue && rows.length === 0) {
            return {
                show: true,
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cL, null),
                title: t('noResultFound'),
                description: t('noResultFoundDescription'),
            };
        }
        return null;
    }, [t, loading, searchValue, rows.length]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c7, { "data-test-id": "table", columns: columns, data: rows, getRowActions: getRowActions, loading: !!loading }, tablePlaceholderProps && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cM, Object.assign({}, tablePlaceholderProps))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeleteApiTokenDialog$1, { "data-test-id": "deleteTokenBox", open: deleteTokenDialog, onClose: handleCloseDeleteToken, token: deleteApiTokenData }));
};

const ApiTokensHeader = ({ handleOpenAddToken }) => {
    const t = useT('apiTokens');
    const { setApiTokensState } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c4)();
    const handleSearchChanged = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e) => setApiTokensState({ searchValue: e.target.value }), [setApiTokensState]);
    const canAddTenantToken = usePermission('fe.secure.write.tenantApiTokens');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, spacing: 4 },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 12, sm: 6, md: 4 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, { "data-test-id": "serachBox", endAdornment: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cF, null), onChange: handleSearchChanged, placeholder: t('searchInputPlaceholder') }))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: true }),
        canAddTenantToken && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "generateTokenBtn", onClick: handleOpenAddToken }, t('generateTokenButton'))));
};

const AddTokenSuccessForm$1 = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((props, ref) => {
    const t = useT('apiTokens_AddToken');
    const { successDialog: { clientId, secret } } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c3)();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, { ref: ref },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.A, { sx: { marginBottom: 4 }, color: "info" }, t('copyAndSaveId')),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InputCopyField, { label: t('clientId'), value: clientId !== null && clientId !== void 0 ? clientId : '' }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InputCopyField, { label: t('secretKey'), value: secret !== null && secret !== void 0 ? secret : '' })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "doneBtn", color: 'secondary', onClick: props.onClose, type: 'reset' }, t('done'))));
});
const DescriptionField$1 = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(() => {
    const t = useT('apiTokens_AddToken');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('description');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ label: t('descriptionInputLabel'), "data-test-id": "descriptionBox" }, fieldProps, { autoFocus: true, error: !!error && touched, errorMessage: error, autoComplete: 'description' }));
});
const AddTokenForm$1 = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((props, ref) => {
    const t = useT('apiTokens_AddToken');
    const { addTenantApiToken } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c4)();
    const { policy } = usePublicPolicySettings();
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
        description: '',
        roleIds: [],
    }), []);
    const validationSchema = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({
        description: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('descriptionIsRequired')),
        roleIds: create().min((policy === null || policy === void 0 ? void 0 : policy.forcePermissions) ? 1 : 0, t('rolesIsRequired')),
    }), [t, policy === null || policy === void 0 ? void 0 : policy.forcePermissions]);
    const formikProps = {
        onSubmit: ({ description, roleIds }) => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, reject);
            addTenantApiToken({ description, roleIds, callback });
        }),
        initialValues,
        validationSchema,
    };
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit, formError }) => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, { ref: ref },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DescriptionField$1, null),
                (policy === null || policy === void 0 ? void 0 : policy.forcePermissions) && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RolesField$4, { label: t('rolesInputLabel'), placeholder: t('rolesInputPlaceholder') }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancelBtn", color: 'inherit', variant: 'text', type: 'reset', onClick: props.onClose }, t('cancel')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "createBtn", disabled: !canSubmit, loading: isSubmitting, color: 'primary', type: 'submit' }, t('create'))));
    });
});
const AddTokenSteper$1 = props => {
    const { successDialog: { open } } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c3)();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Slide$1, { in: !open, appear: false, exit: false, unmountOnExit: true, direction: !open ? 'left' : 'right' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AddTokenForm$1, Object.assign({}, props))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Slide$1, { in: open, mountOnEnter: true, unmountOnExit: true, direction: open ? 'left' : 'right' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AddTokenSuccessForm$1, Object.assign({}, props))));
};
const AddTokenDialog$1 = props => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('apiTokens_AddToken');
    const { successDialog: { open } } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c3)();
    const title = open ? t('successTitle') : t('title');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { title: title, size: 'sm' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AddTokenSteper$1, Object.assign({}, props)));
};

const ApiTokensPage$1 = () => {
    const { loadRoles } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cA)();
    const { loadApiTokens, setApiTokensState } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c4)();
    const { apiTokensDataTenant } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c3)();
    const [addTokenDialog, handleCloseAddToken, handleOpenAddToken] = useDialogState();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        const queryObject = { pageOffset: 0, filter: [], silentLoading: apiTokensDataTenant.length > 0 };
        loadRoles();
        loadApiTokens(queryObject);
        return () => loadApiTokens(queryObject);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadApiTokens, loadRoles]);
    const onDialogCloseHandler = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        handleCloseAddToken();
        setTimeout(() => setApiTokensState({ successDialog: { clientId: '', secret: '', open: false } }), 400);
    }, [handleCloseAddToken, setApiTokensState]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageWrapper, { flex: 1, display: 'flex', flexDirection: 'column' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ApiTokensHeader, { handleOpenAddToken: handleOpenAddToken }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { mt: 6, flex: 1, display: 'flex', flexDirection: 'column' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ApiTokensTable, null)),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AddTokenDialog$1, { open: addTokenDialog, onClose: onDialogCloseHandler })));
};
var ApiTokensPage$2 = ApiTokensPage$1;

var ApiTokensPage = wrapPage(ApiTokensPage$2, 'apiTokens');

const AuditLogsHeader = () => {
    const t = useT('auditLogs');
    const prevSearch = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useRef({ search: null });
    const [search, setSearch] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState('');
    const { loadAuditLogs, exportAuditsCsv } = useAuditsActions();
    const { filter: filters, sort } = useAuditLogsState();
    const searchValue = useDebounce(search, 500);
    const filterOnly = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => { var _a; return (_a = filters === null || filters === void 0 ? void 0 : filters.filter((f) => f.id !== 'filter')) !== null && _a !== void 0 ? _a : []; }, [filters]);
    const handlerOnSetFilter = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((values) => {
        loadAuditLogs({
            pageOffset: 0,
            sort,
            filter: values,
        });
    }, [loadAuditLogs, sort]);
    const AuditsDownloadIcon = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(default_1)(({ theme }) => ({
        color: theme.palette.grey[500],
    }));
    const handlerSearch = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e) => {
        setSearch(e.target.value);
    }, [setSearch]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        prevSearch.current.search !== null &&
            prevSearch.current.search !== searchValue &&
            handlerOnSetFilter([...filterOnly, { id: 'filter', value: searchValue.toLowerCase() }]);
        prevSearch.current.search = searchValue;
    }, [searchValue, handlerOnSetFilter, filterOnly, prevSearch]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, spacing: 4, justifyContent: "space-between" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 8, sm: 6, md: 4 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, { "data-test-id": "Search", endAdornment: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cF, null), onChange: handlerSearch, placeholder: t('searchInputPlaceholder') }))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "Download", size: "small", color: "inherit", onClick: () => exportAuditsCsv() },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { component: AuditsDownloadIcon, sx: { height: '0.75rem', width: '0.75rem', marginRight: '0.75rem', marginTop: '0.125rem' } }),
                t('downloadCsvPrimaryButton'))));
};

const getIpMetadata = (ip) => (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.g)(void 0, void 0, void 0, function* () {
    try {
        return yield _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__.fetch.Get(`/metadata/ip/${ip}`);
    }
    catch (e) {
        throw new Error(`ip metadata not found`);
    }
});
const getFilterType = (type) => {
    switch (type) {
        case 'Timestamp':
            return 'select';
        case 'Severity':
            return 'select';
        default:
            return 'input';
    }
};
const capitalize = (s) => {
    // noinspection SuspiciousTypeOfGuard
    if (typeof s !== 'string')
        return `${s}`;
    return s.charAt(0).toUpperCase() + s.slice(1);
};
const getFilterName = (name) => {
    switch (name) {
        case 'createdAt':
            return 'Time';
        default:
            return capitalize(name);
    }
};
//TODO: wrong items order in selector
const timeOptions = [
    { label: 'Last Day', value: 'last_day' },
    { label: 'Last Week', value: 'last_week' },
    { label: 'Last Month', value: 'last_month' },
    { label: 'Last Year', value: 'last_year' },
];
const severityOptions = [
    { label: 'Info', value: 'Info' },
    { label: 'Medium', value: 'Medium' },
    { label: 'High', value: 'High' },
    { label: 'Critical', value: 'Critical' },
];
const getTimeDiff = (time) => {
    const diff = differenceInDays(new Date(), parseISO(time));
    return diff <= 1 ? 'last_day' : diff <= 7 ? 'last_week' : diff <= 30 ? 'last_month' : 'last_year';
};
const getFilterTime = (time) => {
    let value;
    const date = new Date();
    switch (time) {
        case 'last_day':
            value = subDays(date, 1).toISOString();
            break;
        case 'last_week':
            value = subDays(date, 7).toISOString();
            break;
        case 'last_month':
            value = subMonths(date, 1).toISOString();
            break;
        case 'last_year':
            value = subYears(date, 1).toISOString();
            break;
        default:
            value = date.toISOString();
    }
    return { $gt: value };
};
const getSeverityByName = (severity) => {
    switch (severity === null || severity === void 0 ? void 0 : severity.toLowerCase()) {
        case 'info':
            return 'info';
        case 'error':
            return 'error';
        case 'attention':
            return 'warning';
        case 'high':
            return 'warning';
        default:
            return 'info';
    }
};
const str2bool = (str) => {
    var _a;
    const value = (_a = str === null || str === void 0 ? void 0 : str.toLowerCase) === null || _a === void 0 ? void 0 : _a.call(str);
    if (!value) {
        return false;
    }
    switch (value) {
        case 'yes':
        case 'always':
            return true;
        default:
            return false;
    }
};

const FilterBody = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B)(({ theme }) => ({
    margin: '8px -16px 16px -16px',
    padding: '15px 16px',
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    borderTop: `1px solid ${theme.palette.grey[300]}`,
}));
const Selector = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bS)({
    '& .MuiOutlinedInput-root': {
        minWidth: '100%',
    },
});
const AlphaNumericFilter = ({ value, onChange }) => {
    const [inputState, setInputState] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(`${value !== null && value !== void 0 ? value : ''}`);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, { autoFocus: true, fullWidth: true, onChange: (e) => {
            setInputState(e.target.value);
            onChange(e.target.value);
        }, value: inputState }));
};
const SeverityFilter = ({ value, onChange }) => {
    const [selectState, setSelectState] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(severityOptions[0].value);
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        onChange(selectState);
        if (value) {
            setSelectState(severityOptions.filter((o) => o.value === value)[0].value);
        }
        // eslint-disable-next-line
    }, []);
    const handleSelect = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((value) => {
        setSelectState(value);
        onChange(value);
    }, [setSelectState, onChange]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Selector, { container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, fullWidth: true, size: "small", placeholder: "select", value: selectState, onChange: (value) => handleSelect(value), options: severityOptions }));
};
const TimeStampFilter = ({ value, onChange }) => {
    const [selectState, setSelectState] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(value ? timeOptions.filter((f) => f.value === getTimeDiff(value))[0].value : timeOptions[0].value);
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const handleSelect = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((value) => {
        setSelectState(value);
        onChange(value);
    }, [onChange, setSelectState]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Selector, { container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, fullWidth: true, size: "small", placeholder: "select", value: selectState, onChange: handleSelect, options: timeOptions }));
};
const Filter = ({ closePopup, value, setFilterValue, type, name }) => {
    const t = useT('auditLogs');
    const [state, setState] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState('');
    const filter = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        switch (type) {
            case 'Timestamp':
                return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TimeStampFilter, { value: value === null || value === void 0 ? void 0 : value.$gt, onChange: (value) => setState(value) });
            case 'Severity':
                return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SeverityFilter, { value: value, onChange: (value) => setState(value) });
            default:
                return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AlphaNumericFilter, { value: value, onChange: (value) => setState(value) });
        }
    }, [type, value, setState]);
    const handleFilter = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e) => {
        e.preventDefault();
        getFilterType(type) === 'input'
            ? !!state.trim() && setFilterValue(state)
            : setFilterValue(type === 'Timestamp' ? getFilterTime(state) : state);
    }, [type, state, setFilterValue]);
    const FilterFooter = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, spacing: 2, paddingBottom: 1 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 6 },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancelBtn", type: "button", color: "inherit", size: "small", fullWidth: true, onClick: () => {
                        !!value && setFilterValue(null);
                        closePopup === null || closePopup === void 0 ? void 0 : closePopup();
                    } }, value ? t('clear') : t('cancel'))),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 6 },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "submit-btn", size: "small", type: "submit", fullWidth: true, color: "primary" }, t('filter')))));
    }, [setFilterValue, closePopup, t, value]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("form", { onSubmit: (e) => {
                handleFilter(e);
                closePopup === null || closePopup === void 0 ? void 0 : closePopup();
            } },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: "tableFilterTitle" },
                t('filterBy'),
                " ",
                getFilterName(name)),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FilterBody, null, filter),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FilterFooter, null))));
};

const AuditLogsTableColumns = ({ columnsMetadata, container }) => {
    return columnsMetadata.filter(c => c.showInTable).map(c => {
        switch (c.type) {
            case 'Timestamp':
                return {
                    id: c.name,
                    Header: c.displayName,
                    accessor: (row) => ({ date: row[c.name] }),
                    Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c8,
                    Filter: c.filterable
                        ? ({ value, setFilterValue, closePopup }) => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Filter, { name: c.name, value: value, setFilterValue: setFilterValue, closePopup: closePopup, type: c.type }))
                        : undefined,
                    width: 160,
                    maxWidth: 160,
                    sortable: c.sortable,
                };
            case 'Email':
                return {
                    id: c.name,
                    Header: c.displayName,
                    accessor: (row) => ({ email: row[c.name], name: row['user'] }),
                    Cell: TableUserCell,
                    Filter: c.filterable
                        ? ({ value, setFilterValue, closePopup }) => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Filter, { name: c.name, value: value, setFilterValue: setFilterValue, closePopup: closePopup, type: c.type }))
                        : undefined,
                    width: 280,
                    maxWidth: 280,
                    sortable: c.sortable,
                };
            case 'IpAddress':
                return {
                    id: c.name,
                    Header: c.displayName,
                    accessor: (row) => ({ ip: row[c.name], container, getIpMetadata }),
                    Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cT,
                    Filter: c.filterable
                        ? ({ value, setFilterValue, closePopup }) => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Filter, { name: c.name, value: value, setFilterValue: setFilterValue, closePopup: closePopup, type: c.type }))
                        : undefined,
                    width: 280,
                    maxWidth: 280,
                    sortable: c.sortable,
                };
            case 'Json':
                return {
                    id: c.name,
                    Header: c.displayName,
                    accessor: (row) => ({ json: Array.isArray(row[c.name]) ? row[c.name] : [row[c.name]], container }),
                    Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cS,
                    width: 150,
                    maxWidth: 150,
                    sortable: c.sortable,
                };
            case 'Severity':
                return {
                    id: c.name,
                    Header: c.displayName,
                    accessor: (row) => ({ label: row[c.name], severity: getSeverityByName(row[c.name]) }),
                    Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cR,
                    Filter: c.filterable
                        ? ({ value, setFilterValue, closePopup }) => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Filter, { name: c.name, value: value, setFilterValue: setFilterValue, closePopup: closePopup, type: c.type }))
                        : undefined,
                    width: 150,
                    maxWidth: 150,
                    sortable: c.sortable,
                };
            default:
                return {
                    id: c.name,
                    Header: c.displayName,
                    accessor: (row) => ({ description: row[c.name], container }),
                    Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cH,
                    Filter: c.filterable
                        ? ({ value, setFilterValue, closePopup }) => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Filter, { name: c.name, value: value, setFilterValue: setFilterValue, closePopup: closePopup, type: c.type }))
                        : undefined,
                    minWidth: 220,
                    sortable: c.sortable,
                };
        }
    }).filter(c => !!c);
};

const AuditLogsTable = () => {
    var _a, _b;
    const t = useT('auditLogs');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const { searching } = useTableSearch();
    const { loadAuditLogs } = useAuditsActions();
    const { columns: columnsMetadata } = useAuditsMetadataState();
    const _c = useAuditLogsState(), { loading, totalPages, pageOffset, pageSize, sort, filter: filters } = _c, auditLogsState = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_c, ["loading", "totalPages", "pageOffset", "pageSize", "sort", "filter"]);
    const logs = (_a = auditLogsState === null || auditLogsState === void 0 ? void 0 : auditLogsState.logs) !== null && _a !== void 0 ? _a : [];
    const columns = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        var _a;
        return AuditLogsTableColumns({
            columnsMetadata: columnsMetadata !== null && columnsMetadata !== void 0 ? columnsMetadata : [],
            container: (_a = injector === null || injector === void 0 ? void 0 : injector.adminPortalEl) !== null && _a !== void 0 ? _a : document.body,
        });
    }, [t, columnsMetadata, injector === null || injector === void 0 ? void 0 : injector.adminPortalEl]);
    const onPageChange = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((_, page) => {
        loadAuditLogs({ pageOffset: pageSize * (page - 1) });
    }, [loadAuditLogs, pageSize]);
    const handlerSortChange = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((sortBy) => {
        loadAuditLogs({
            pageOffset: 0,
            sort: sortBy,
            filter: filters,
        });
    }, [loadAuditLogs, filters]);
    const handlerFilterChange = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((_filters) => {
        loadAuditLogs({
            pageOffset: 0,
            sort,
            filter: _filters,
        });
    }, [loadAuditLogs, sort]);
    const tablePlaceholderProps = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        if (loading) {
            return null;
        }
        else if (logs.length === 0) {
            return {
                show: true,
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cL, null),
                title: t('noResultFound'),
                description: t('noResultFoundDescription'),
            };
        }
        return null;
    }, [t, loading, logs.length]);
    const moreInfoColumns = columnsMetadata === null || columnsMetadata === void 0 ? void 0 : columnsMetadata.filter(c => str2bool(c.showInMoreInfo));
    const TableExpandRow = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((row) => {
        const rowToDisplay = {};
        moreInfoColumns === null || moreInfoColumns === void 0 ? void 0 : moreInfoColumns.filter(c => !!row.original[c.name]).forEach(c => {
            if (c.type === 'Timestamp') {
                const date = new Date(row.original[c.name]);
                if (!(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cU)(date)) {
                    return rowToDisplay[c.displayName] = '-';
                }
                return rowToDisplay[c.displayName] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cV)(date, 'dd/MM/yyyy hh:mm:ss bb');
            }
            return rowToDisplay[c.displayName] = row.original[c.name];
        });
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cW, { row: rowToDisplay });
    }, [moreInfoColumns]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c7, { container: (_b = injector === null || injector === void 0 ? void 0 : injector.adminPortalEl) !== null && _b !== void 0 ? _b : document.body, columns: columns, data: logs, loading: loading, searching: searching, loadingText: searching ? t('searchingPlaceholder') : undefined, totalPages: totalPages, pageOffset: Math.floor(pageOffset / pageSize), sortBy: sort, filters: filters, onSortChange: handlerSortChange, onFilterChange: handlerFilterChange, renderExpandedComponent: !(moreInfoColumns === null || moreInfoColumns === void 0 ? void 0 : moreInfoColumns.length) ? undefined : TableExpandRow, onPageChange: onPageChange }, tablePlaceholderProps && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cM, Object.assign({}, tablePlaceholderProps))));
};

const SubHeaderChip = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c5)({
    marginRight: '0.75rem',
});
const ChipsContainer = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B)({
    marginTop: '1rem',
});
const AuditLogsSubHeader = () => {
    const { sort, filter } = useAuditLogsState();
    const { loadAuditLogs } = useAuditsActions();
    const handleFilterDelete = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((id) => {
        loadAuditLogs({
            pageOffset: 0,
            sort,
            filter: filter.filter(f => f.id !== id),
        });
    }, [loadAuditLogs, sort, filter]);
    const chipLabel = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((id, value) => {
        if (typeof value === 'object') {
            return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { display: 'flex', alignItems: 'center' },
                getFilterName(id),
                ": ",
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'tableFilterChipInfo', marginLeft: '5px' }, (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cV)(new Date(Date.parse(value.$gt)), 'yyyy/MM/dd h:mm a')));
        }
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { display: 'flex', alignItems: 'center' },
            getFilterName(id),
            ": ",
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'tableFilterChipInfo', marginLeft: '5px' }, value));
    }, []);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ChipsContainer, null, filter.filter(f => f.id !== 'filter').map(f => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubHeaderChip, { label: chipLabel(f.id, f.value), key: f.value, onDelete: () => handleFilterDelete(f.id), deleteIcon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cX, null) }))));
};

const AuditLogsPage$1 = () => {
    var _a;
    const [searching, setSearching] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const [searchQuery, onSearch] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState('');
    const auditLogsState = useAuditLogsState();
    const logs = (_a = auditLogsState === null || auditLogsState === void 0 ? void 0 : auditLogsState.logs) !== null && _a !== void 0 ? _a : [];
    const { loadAuditLogs } = useAuditLogsActions();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        const queryObject = { pageOffset: 0, sort: [{ id: 'createdAt', desc: true }], silentLoading: logs.length > 0 };
        loadAuditLogs(queryObject);
        return () => loadAuditLogs(queryObject);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadAuditLogs]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageWrapper, { flex: 1, display: 'flex', flexDirection: 'column' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableSearchContext.Provider, { value: { searching, searchQuery, onSearch, setSearching } },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AuditLogsHeader, null),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AuditLogsSubHeader, null),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { mt: 1, flex: 1, display: 'flex', flexDirection: 'column' },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AuditLogsTable, null))));
};
var AuditLogsPage$2 = AuditLogsPage$1;

var AuditLogsPage = wrapPage(AuditLogsPage$2, 'auditLogs');

//TODO change data test id from doneBtn to done-btn
//TODO change data test id from clientId to copy-client-id-box moved it to the component
//TODO change data test id from secretKey to copy-secret-key-box moved it to the component
const AddTokenSuccessForm = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((props, ref) => {
    const t = useT('personalTokens_AddToken');
    const { successDialog: { clientId, secret } } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c3)();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, { ref: ref },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.A, { sx: { marginBottom: 4 }, color: "info" }, t('copyAndSaveId')),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InputCopyField, { testId: "copy-client-id", label: t('clientId'), value: clientId !== null && clientId !== void 0 ? clientId : '' }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InputCopyField, { testId: "copy-secret-key", label: t('secretKey'), value: secret !== null && secret !== void 0 ? secret : '' })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "done-btn", color: 'secondary', onClick: props.onClose, type: 'reset' }, t('done'))));
});
//TODO change data test id from descriptionBox to description-box
const DescriptionField = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.memo(() => {
    const t = useT('personalTokens_AddToken');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('description');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ label: t('descriptionInputLabel'), "data-test-id": "description-box" }, fieldProps, { autoFocus: true, error: !!error && touched, errorMessage: error, autoComplete: 'description' }));
});
const AddTokenForm = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef((props, ref) => {
    const t = useT('personalTokens_AddToken');
    const { addUserApiToken } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c4)();
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
        description: '',
    }), []);
    const validationSchema = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({
        description: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('descriptionIsRequired')),
    }), [t]);
    const formikProps = {
        onSubmit: ({ description }) => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, reject);
            addUserApiToken({ description, callback });
        }),
        initialValues,
        validationSchema,
    };
    //TODO change data test id from cancelBtn to cancel-btn
    //TODO change data test id from createBtn to create-btn
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit, formError }) => {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, { ref: ref },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DescriptionField, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancel-btn", color: 'inherit', variant: 'text', type: 'reset', onClick: props.onClose }, t('cancel')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "create-btn", disabled: !canSubmit, loading: isSubmitting, color: 'primary', type: 'submit' }, t('create'))));
    });
});
const AddTokenSteper = props => {
    const { successDialog: { open } } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c3)();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Slide$1, { in: !open, appear: false, exit: false, unmountOnExit: true, direction: !open ? 'left' : 'right' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AddTokenForm, Object.assign({}, props))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Slide$1, { in: open, mountOnEnter: true, unmountOnExit: true, direction: open ? 'left' : 'right' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AddTokenSuccessForm, Object.assign({}, props))));
};
const AddTokenDialog = props => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('personalTokens_AddToken');
    const { successDialog: { open } } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c3)();
    const title = open ? t('successTitle') : t('title');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { title: title, size: 'sm' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AddTokenSteper, Object.assign({}, props)));
};

const PersonalTokensHeader = ({ handleOpenAddToken }) => {
    const t = useT('personalTokens');
    const { setApiTokensState } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c4)();
    const handleSearchChanged = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((e) => setApiTokensState({ searchValue: e.target.value }), [setApiTokensState]);
    //TODO change data test id from searchBox to search-box
    //TODO change data test id from generateToken to generate-token
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, spacing: 4 },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 12, sm: 6, md: 4 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, { "data-test-id": "search-box", endAdornment: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cF, null), onChange: handleSearchChanged, placeholder: t('searchInputPlaceholder') }))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: true }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "generate-token", onClick: handleOpenAddToken }, t('generateTokenButton'))));
};

const PersonalTokensTableColumns = ({ t }) => [
    {
        Header: t('clientIdHeader'),
        accessor: ({ clientId, description }) => ({ title: description, description: clientId, copyValue: clientId, testId: 'client-id' }),
        minWidth: 400,
        Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cQ,
    },
    {
        Header: t('createdOnHeader'),
        accessor: ({ createdAt }) => ({ date: createdAt }),
        width: 250,
        maxWidth: 250,
        Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c8,
    },
];
const PersonalTokenTableRowActions = ({ t, container, handleOpenDeleteToken, }) => (row) => {
    const items = [
        {
            icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bZ, { "data-test-id": "delete-token" }),
            onClick: () => handleOpenDeleteToken(row.clientId),
            text: t('deleteApiTokenAction'),
            negative: true,
        },
    ];
    return { items, container };
};

const DeleteApiTokenDialog = ({ onClose, open, token = '' }) => {
    const t = useT('personalTokens_DeleteToken');
    const [submitted, setSubmitted] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const { loaders: { DELETE_API_TOKEN: loading }, errors: { DELETE_API_TOKEN: error }, } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c3)();
    const { deleteUserApiToken, setApiTokensError, setApiTokensLoader } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c4)();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        setApiTokensError({ key: _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .ApiStateKeys.DELETE_API_TOKEN */ .GL.DELETE_API_TOKEN, value: false });
        setApiTokensLoader({ key: _frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .ApiStateKeys.DELETE_API_TOKEN */ .GL.DELETE_API_TOKEN, value: false });
    }, [setApiTokensError, setApiTokensLoader]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (submitted && !error && !loading) {
            onClose();
        }
    }, [submitted, error, loading, onClose]);
    const handleDeleteApiToken = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        deleteUserApiToken(token);
        setSubmitted(true);
    }, [token, setSubmitted, deleteUserApiToken]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeleteDialog, { dataTestId: 'deleteApiBtn', title: t('title'), cancelButtonText: t('cancel'), deleteButtonText: t('delete'), description: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            t('areYouSureDeleteApiToken1'),
            " ",
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("strong", null,
                "(Token: ",
                token,
                ")"),
            "? ",
            t('areYouSureDeleteApiToken2')), open: open, error: error, onClose: onClose, loading: !!loading, onDelete: handleDeleteApiToken }));
};

const PersonalTokensTable = () => {
    const t = useT('personalTokens');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const container = injector === null || injector === void 0 ? void 0 : injector.adminPortalEl;
    const { apiTokensDataUser: tokensData, searchValue, loaders: { LOAD_API_TOKENS: loading } } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c3)();
    const [deleteTokenDialog, handleCloseDeleteToken, handleOpenDeleteToken, deleteApiTokenData] = useDialogState();
    const rows = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        if (!!searchValue) {
            return tokensData.filter((token) => token.description.indexOf(searchValue) !== -1 || token.clientId.indexOf(searchValue) !== -1);
        }
        return tokensData;
    }, [tokensData, searchValue]);
    const columns = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => PersonalTokensTableColumns({ t }), [t]);
    const getRowActions = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => PersonalTokenTableRowActions({
        t,
        container,
        handleOpenDeleteToken,
    }), [t, container, handleOpenDeleteToken]);
    const tablePlaceholderProps = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        if (loading) {
            return null;
        }
        else if (!searchValue && rows.length === 0) {
            return {
                show: true,
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cp, null),
                title: t('noApiTokensYet'),
                description: t('noApiTokensYetDescription'),
                testId: 'empty-table-personal-tokens'
            };
        }
        else if (searchValue && rows.length === 0) {
            return {
                show: true,
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cL, null),
                title: t('noResultFound'),
                description: t('noResultFoundDescription'),
                testId: 'empty-search-personal-tokens'
            };
        }
        return null;
    }, [t, loading, searchValue, rows.length]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c7, { columns: columns, data: rows, getRowActions: getRowActions, loading: !!loading }, tablePlaceholderProps && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cM, Object.assign({}, tablePlaceholderProps))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeleteApiTokenDialog, { open: deleteTokenDialog, onClose: handleCloseDeleteToken, token: deleteApiTokenData }));
};

const PersonalTokensPage$1 = () => {
    const { loadRoles } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cA)();
    const { loadApiTokens, setApiTokensState } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c4)();
    const { apiTokensDataUser } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c3)();
    const [addTokenDialog, handleCloseAddToken, handleOpenAddToken] = useDialogState();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        const queryObject = { pageOffset: 0, filter: [], silentLoading: apiTokensDataUser.length > 0 };
        loadRoles();
        loadApiTokens(queryObject);
        return () => loadApiTokens(queryObject);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadApiTokens, loadRoles]);
    const onDialogCloseHandler = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        handleCloseAddToken();
        setTimeout(() => setApiTokensState({ successDialog: { clientId: '', secret: '', open: false } }), 400);
    }, [handleCloseAddToken, setApiTokensState]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageWrapper, { flex: 1, display: 'flex', flexDirection: 'column' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PersonalTokensHeader, { handleOpenAddToken: handleOpenAddToken }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { mt: 6, flex: 1, display: 'flex', flexDirection: 'column' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PersonalTokensTable, null)),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AddTokenDialog, { open: addTokenDialog, onClose: onDialogCloseHandler })));
};
var PersonalTokensPage$2 = PersonalTokensPage$1;

var PersonalTokensPage = wrapPage(PersonalTokensPage$2, 'personalTokens');

(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bN) `
  &.MuiSkeleton-root {
    height: ${({ theme }) => theme.spacing(12)};
    width: 100%;
    transform: scale(1, 1);
    margin-bottom: ${({ theme }) => theme.spacing(2)};
  }
`;
const BoxSkeleton = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bN) `
  &.MuiSkeleton-root {
    width: 100%;
    transform: scale(1, 1);
    margin-bottom: ${({ theme }) => theme.spacing(4)};
  }
`;

const CurrentPlanComponentSkeleton = () => {
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: true, p: 0 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bN, { height: 52, width: '80%' }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bN, { height: 24, width: '60%' }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bN, { height: 32, width: '100%' })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, container: true, xs: true, p: 0, direction: 'column' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, mb: 12, justifyContent: 'flex-end' },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, mr: 6 },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(BoxSkeleton, { height: 40, width: 132 })),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(BoxSkeleton, { height: 40, width: 132 }))))));
};

const INVOICE_DATE_FORMAT = 'MMM dd, yyyy';
const BILLING_INFORMATION_PLAN_DATE_FORMAT = 'MMM dd, yyyy';
const DATE_FILENAME_FORMAT = 'ddMMyyyy';

const useSubscriptionPermissions = (permission) => {
    return usePermission(permission || 'fe.subscriptions.write.*');
};
const useBillingMetadata = () => {
    var _a, _b, _c, _d;
    const { summary, plan } = useBillingInformation();
    const { subscription } = useSubscription();
    const { plans } = usePlans();
    const now = Date.now();
    const { cancellation, status, trialEnd } = subscription || {};
    const willBeCanceled = (cancellation === null || cancellation === void 0 ? void 0 : cancellation.policy) === _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__.ISubscriptionCancellationPolicy.AT_PERIOD_END;
    const isCanceled = status === _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__.ISubscriptionStatus.CANCELED;
    const isDefaultPlan = (summary === null || summary === void 0 ? void 0 : summary.defaultPlanId) === (summary === null || summary === void 0 ? void 0 : summary.currentPlanId);
    const isTrialing = status === _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__.ISubscriptionStatus.TRIALING;
    const isInTrialPeriod = trialEnd && new Date(trialEnd).getTime() > now;
    const isExternallyManaged = (summary === null || summary === void 0 ? void 0 : summary.externallyManaged) || false;
    const hasPaymentMethod = !!(summary === null || summary === void 0 ? void 0 : summary.paymentMethodId);
    const isFreePlan = ((_b = (_a = plan === null || plan === void 0 ? void 0 : plan.name) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes('free')) || ((_d = (_c = plan === null || plan === void 0 ? void 0 : plan.description) === null || _c === void 0 ? void 0 : _c.toLowerCase()) === null || _d === void 0 ? void 0 : _d.includes('free'));
    const isSingularPlan = (plans === null || plans === void 0 ? void 0 : plans.length) === 1;
    const defaultPlanId = summary === null || summary === void 0 ? void 0 : summary.defaultPlanId;
    const hasTrialEnded = status === _frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__.ISubscriptionStatus.TRIAL_ENDED;
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
        isCanceled,
        willBeCanceled,
        isDefaultPlan,
        isTrialing,
        isInTrialPeriod,
        isExternallyManaged,
        hasPaymentMethod,
        isFreePlan,
        isSingularPlan,
        defaultPlanId,
        hasTrialEnded,
    }), [
        isCanceled,
        willBeCanceled,
        isDefaultPlan,
        isTrialing,
        isInTrialPeriod,
        isExternallyManaged,
        hasPaymentMethod,
        isFreePlan,
        isSingularPlan,
        defaultPlanId,
        hasTrialEnded,
    ]);
};

const CanceledChip = () => {
    const t = useT('subscriptions_CurrentPlan');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cb, { status: 'error', withIcons: false, label: t('canceled') });
};

const TrialingChip = () => {
    const t = useT('subscriptions_CurrentPlan');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cb, { status: 'default', withIcons: false, label: t('trialing') });
};

const TrialEndedChip = () => {
    const t = useT('subscriptions_CurrentPlan');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cb, { status: 'error', withIcons: false, label: t('trialEnded') });
};

const subscriptionStatusChipMap = {
    [_frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__.ISubscriptionStatus.INCOMPLETE]: null,
    [_frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__.ISubscriptionStatus.ACTIVE]: null,
    [_frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__.ISubscriptionStatus.TRIALING]: TrialingChip,
    [_frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__.ISubscriptionStatus.CANCELED]: CanceledChip,
    [_frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__.ISubscriptionStatus.TRIAL_ENDED]: TrialEndedChip,
    [_frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__.ISubscriptionStatus.EXPIRED]: null,
};

const PlanDetailsStatusChip = () => {
    const { subscription } = useSubscription();
    const { willBeCanceled } = useBillingMetadata();
    let Component = (subscription === null || subscription === void 0 ? void 0 : subscription.status) && subscriptionStatusChipMap[subscription.status];
    if (willBeCanceled) {
        Component = subscriptionStatusChipMap[_frontegg_rest_api__WEBPACK_IMPORTED_MODULE_3__.ISubscriptionStatus.CANCELED];
    }
    if (!Component) {
        return null;
    }
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Component, null);
};

const PlanDetails = () => {
    const t = useT('subscriptions_CurrentPlan');
    const { plan } = useBillingInformation();
    const { subscription } = useSubscription();
    const { isTrialing, isExternallyManaged, isFreePlan, willBeCanceled, hasTrialEnded } = useBillingMetadata();
    const { name = t('unknownPlan'), price = 0, currency = 'usd', description: priceDescription } = plan || {};
    const priceString = `${toCurrencySymbol(currency)}${toPriceDisplay(price)}`;
    let description = '';
    if (!isExternallyManaged) {
        if (isTrialing && (subscription === null || subscription === void 0 ? void 0 : subscription.trialEnd)) {
            description = t('yourPlanIsTrialing', {
                periodEnd: format(new Date(subscription === null || subscription === void 0 ? void 0 : subscription.trialEnd), BILLING_INFORMATION_PLAN_DATE_FORMAT),
            });
        }
        else if ((subscription === null || subscription === void 0 ? void 0 : subscription.currentPeriodEnd) && !isFreePlan && !hasTrialEnded) {
            description = t(willBeCanceled ? 'yourPlanWillBeCanceled' : 'yourPlanWillBeRenewed', {
                periodEnd: format(new Date(subscription === null || subscription === void 0 ? void 0 : subscription.currentPeriodEnd), BILLING_INFORMATION_PLAN_DATE_FORMAT),
            });
        }
    }
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, direction: 'column' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, container: true, alignItems: 'center', mb: 4 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, pr: 2 },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'h3' }, name)),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, pt: 3 },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PlanDetailsStatusChip, null))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, mb: !description ? 0 : 10 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'subtitle1' }, priceDescription ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TextBreakLine, { text: priceDescription }) : t('priceSubtitle', { price: priceString }))),
        description && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'body2' }, description)))));
};

const RowActionButtons = ({ main, secondary }) => {
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, container: true, xs: true, p: 0, direction: 'column' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, mb: 12, justifyContent: 'flex-end' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, mr: 6 }, main),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true }, secondary))));
};

const BuyNowButton = ({ onClick }) => {
    const t = useT('subscriptions_CurrentPlan');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": 'buyNowButton', variant: "contained", color: "primary", onClick: onClick }, t('buyNowButton'))));
};

const SelectPlanButton = ({ onClick }) => {
    const t = useT('subscriptions_CurrentPlan');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": 'updateButton', variant: "contained", color: "primary", onClick: onClick }, t('updateButton')));
};

const RenewDialogBody = () => {
    const t = useT('subscriptions_Renewal');
    const { subscription } = useSubscription();
    const endDate = (subscription === null || subscription === void 0 ? void 0 : subscription.currentPeriodEnd) ? format(new Date(subscription === null || subscription === void 0 ? void 0 : subscription.currentPeriodEnd), BILLING_INFORMATION_PLAN_DATE_FORMAT)
        : t('unknownDate');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'body1' }, t('description', { renewalDate: endDate })));
};

const RenewDialogFooter = ({ onClose }) => {
    const { loading, error } = useSubscriptionRenewal();
    const { renewSubscription } = useBillingInformationActions();
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionDialogFooter, { cancel: { onClick: onClose, disabled: loading }, confirm: { loading, disabled: !!error, onClick: renewSubscription, text: 'confirm' } }));
};

const RenewDialog = ({ open, onClose }) => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('subscriptions');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, { open: open, onClose: onClose, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, title: t('dialogRenewalTitle'), size: "sm" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RenewDialogBody, null)),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RenewDialogFooter, { onClose: onClose }))));
};

const RenewButton = () => {
    const t = useT('subscriptions_CurrentPlan');
    const [isOpen, closeDialog, openDialog] = useDialogState();
    const { loading } = useSubscriptionRenewal();
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { loading: loading, "data-test-id": 'renewButton', variant: "contained", color: "primary", onClick: openDialog }, t('renewButton')),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RenewDialog, { open: isOpen, onClose: closeDialog })));
};

const BillingActionMainButton = ({ openPlanSelect, openCheckout, }) => {
    const { isCanceled, willBeCanceled, isTrialing, hasPaymentMethod, isFreePlan, isSingularPlan, hasTrialEnded, } = useBillingMetadata();
    if (isSingularPlan) {
        if (!hasPaymentMethod) {
            return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(BuyNowButton, { onClick: openCheckout });
        }
    }
    else if (isFreePlan) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SelectPlanButton, { onClick: openPlanSelect });
    }
    else {
        if ((isTrialing || hasTrialEnded) && !hasPaymentMethod) {
            if (hasPaymentMethod) {
                return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SelectPlanButton, { onClick: openPlanSelect });
            }
            else {
                return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(BuyNowButton, { onClick: openCheckout });
            }
        }
        else if (isCanceled || willBeCanceled) {
            return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RenewButton, null);
        }
        else {
            return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SelectPlanButton, { onClick: openPlanSelect });
        }
    }
    return null;
};

const CancelDialogFooter = ({ onClose }) => {
    const { loading, error } = useSubscriptionCancellation();
    const { cancelSubscription } = useBillingInformationActions();
    const cancel = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
        onClick: onClose,
        disabled: loading,
    }), [onClose, loading]);
    const confirm = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
        onClick: cancelSubscription,
        disabled: !!error,
        color: 'danger',
        text: 'confirm',
        loading,
    }), [cancelSubscription, error, loading]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionDialogFooter, { cancel: cancel, confirm: confirm }));
};

const CancelDialogBody = () => {
    const t = useT('subscriptions_Cancellation');
    const { subscription } = useSubscription();
    const { error } = useSubscriptionCancellation();
    const endDate = (subscription === null || subscription === void 0 ? void 0 : subscription.currentPeriodEnd) ? format(new Date(subscription === null || subscription === void 0 ? void 0 : subscription.currentPeriodEnd), BILLING_INFORMATION_PLAN_DATE_FORMAT)
        : t('unknownDate');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        error && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.A, { "data-test-id": error, severity: "error" }, error)),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'body1' }, t('description', { expirationDate: endDate }))));
};

const CancelDialog = ({ open, onClose }) => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('subscriptions');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, { open: open, onClose: onClose, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, title: t('dialogCancellationTitle'), size: "sm" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CancelDialogBody, null)),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CancelDialogFooter, { onClose: onClose }))));
};

const PlanContainer = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G)(({ theme }) => ({
    padding: theme.spacing(6, 0),
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    '&:last-child': {
        borderBottom: 'none',
    },
    justifyContent: 'space-between',
    alignContent: 'center',
    alignItems: 'center',
}));
const PlanTitle = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G)(({ theme }) => ({
    color: theme.palette.grey[800],
    fontWeight: 'bold',
    fontSize: theme.typography.pxToRem(16),
    lineHeight: theme.typography.pxToRem(24),
    marginBottom: theme.spacing(2),
}));
const PlanPrice = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G)(({ theme }) => ({
    color: theme.palette.grey[700],
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(16),
    marginBottom: theme.spacing(2),
}));
const PlanDescription = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G)(({ theme }) => ({
    color: theme.palette.grey[700],
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(16),
    marginBottom: theme.spacing(2),
}));
const PlanSelectedCheckedIcon = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c6)(({ theme }) => ({
    color: theme.palette.success.main,
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(16),
    marginRight: theme.spacing(2),
}));
const PlanSelectedText = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('span')(({ theme }) => ({
    color: theme.palette.grey[800],
    fontSize: theme.typography.pxToRem(12),
    lineHeight: theme.typography.pxToRem(16),
}));
const SelectPlanItem = (props) => {
    const { isSelected, title, description, price, onClick } = props;
    const handleClick = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => onClick(), [onClick]);
    const t = useT('subscriptions_DialogSelection');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PlanContainer, { container: true },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, alignContent: 'center' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PlanTitle, null, title),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PlanPrice, { "data-test-id": price },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TextBreakLine, { text: price })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PlanDescription, null, description)),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true }, isSelected ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, justifyContent: 'space-between', alignContent: 'center', alignItems: 'center', padding: 4 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PlanSelectedCheckedIcon, null),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PlanSelectedText, null, t('currentPlan')))) : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": 'continueBtn-' + title, type: 'button', color: 'secondary', onClick: handleClick }, t('continue'))))));
};

const SelectPlan = ({ onSelectPlan }) => {
    const t = useT('subscriptions_DialogSelection');
    const { plans } = usePlans();
    const { summary } = useBillingInformation();
    const { currentPlanId: selectedPlanId } = summary || {};
    const displayPlans = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => plans.slice(0, 5), [plans]);
    const planSelectionItems = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => displayPlans.map(({ id, name, description, currency, price, recurringInterval }) => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SelectPlanItem, { key: id, isSelected: !!selectedPlanId && id === selectedPlanId, title: name, description: !!description ? '' : description, price: description || t('selectPlanPricePerRecurringInterval', {
            price: toPriceDisplay(price),
            currency: toCurrencySymbol(currency),
            interval: recurringInterval,
        }), onClick: () => onSelectPlan(id) }))), [displayPlans, selectedPlanId, onSelectPlan, t]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, direction: 'column' }, planSelectionItems));
};

const SelectDialogFooter = ({ onClose }) => {
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionDialogFooter, { cancel: { onClick: onClose } }));
};

const SelectDialogBody = ({ onSelectPlan, onClose }) => {
    const { error, plans, fetching: planFetching } = usePlans();
    const loading = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => plans.length === 0 && planFetching, [plans, planFetching]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
            error && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { p: 4 },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.A, { severity: "error" }, error))),
            loading ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(BoxLoader, { height: 220 })) : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SelectPlan, { onSelectPlan: onSelectPlan }))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SelectDialogFooter, { onClose: onClose }))));
};

const CheckoutDialogContent = ({ planId, onClose, onSuccess, onError }) => {
    const { plans } = usePlans();
    const { isTrialing } = useBillingMetadata();
    const hasPlanSelection = plans.length > 1 && !isTrialing;
    const initPlanId = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => { var _a; return planId && ((_a = plans.find((plan) => plan.id === planId)) === null || _a === void 0 ? void 0 : _a.id); }, [planId, plans]);
    const [checkoutPlanId, setCheckoutPlanId] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.useState(initPlanId || null);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        setCheckoutPlanId(initPlanId || null);
    }, [initPlanId]);
    const handlePlanSelection = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((planId) => {
        setCheckoutPlanId(planId);
    }, []);
    const goBack = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        if (hasPlanSelection) {
            setCheckoutPlanId(null);
        }
        else {
            onClose();
        }
    }, [hasPlanSelection, onClose]);
    const handleSuccess = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
    }, [onSuccess]);
    const handleError = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((msg) => {
        onError === null || onError === void 0 ? void 0 : onError(msg);
    }, [onError]);
    if (!checkoutPlanId) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SelectDialogBody, { onSelectPlan: handlePlanSelection, onClose: onClose });
    }
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CheckoutDialogBody, { planId: checkoutPlanId, onClose: goBack, onSuccess: handleSuccess, onError: handleError }));
};

const CheckoutDialog = (_a) => {
    var { planId, open, onClose, onSuccess, onError } = _a, props = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["planId", "open", "onClose", "onSuccess", "onError"]);
    const t = useT('subscriptions');
    const handleSuccess = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess();
    }, [onSuccess]);
    const handleError = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((msg) => {
        onError === null || onError === void 0 ? void 0 : onError(msg);
    }, [onError]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({}, props, { open: open, onClose: onClose, title: t('dialogCheckoutTitle'), size: 'sm' }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CheckoutDialogContent, { planId: planId, onSuccess: handleSuccess, onError: handleError, onClose: onClose })));
};

const EmailField$1 = () => {
    const t = useT('subscriptions');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Field, { "data-test-id": "email", autoComplete: "street-address", name: 'email', placeholder: t('emailInputPlaceholder'), label: t('emailInputLabel') });
};
const CustomCountryField = () => {
    const t = useT('subscriptions');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CountryField, { label: t('countryInputLabel'), countryCode: true, placeholder: t('countryInputPlaceholder') });
};
const Address1Field = () => {
    const t = useT('subscriptions');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Field, { "data-test-id": "address1", autoComplete: "street-address", name: 'addressLine1', placeholder: t('address1InputPlaceholder'), label: t('address1InputLabel') });
};
const Address2Field = () => {
    const t = useT('subscriptions');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Field, { "data-test-id": "address2", autoComplete: "address-level3", name: 'addressLine2', placeholder: t('address2InputPlaceholder'), label: t('address2InputLabel') });
};
const CityField = () => {
    const t = useT('subscriptions');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Field, { "data-test-id": "city", autoComplete: "address-level2", name: 'city', placeholder: t('cityInputPlaceholder'), label: t('cityInputLabel') });
};
const StateField = () => {
    const t = useT('subscriptions');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Field, { "data-test-id": "state", autoComplete: "address-level1", name: 'state', placeholder: t('stateInputPlaceholder'), label: t('stateInputLabel') });
};
const PostcodeField = () => {
    const t = useT('subscriptions');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Field, { "data-test-id": "postalCode", autoComplete: "postal-code", name: 'postalCode', placeholder: t('postCodeInputPlaceholder'), label: t('postCodeInputLabel') });
};
const SubscriptionUpdateBillingDetailsDialogBody = ({ onClose }) => {
    const t = useT('subscriptions');
    const { profile } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cD)();
    const { paymentMethod, loading, error } = usePaymentMethod();
    const { updatePaymentMethodBillingDetails, setError } = usePaymentMethodActions();
    const { billingDetails, id = '' } = paymentMethod !== null && paymentMethod !== void 0 ? paymentMethod : {};
    const { email = (profile === null || profile === void 0 ? void 0 : profile.email) || '', address } = billingDetails !== null && billingDetails !== void 0 ? billingDetails : {};
    const { addressLine1 = '', addressLine2 = '', city = '', state = '', postalCode = '', country = '' } = address !== null && address !== void 0 ? address : {};
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
        email,
        addressLine1,
        addressLine2,
        city,
        state,
        postalCode,
        country,
    }), [email, addressLine1, addressLine2, city, state, postalCode, country]);
    const validationSchema = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({
        email: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ae)(t('emailMustBeValid'), t('emailIsRequired')),
        postalCode: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d2)(t('postCodeIsInvalid')),
    }), [t]);
    const formikProps = {
        onSubmit: (_a, { setSubmitting }) => {
            var { email } = _a, address = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["email"]);
            const callback = (success) => (success ? onClose() : setSubmitting(false));
            updatePaymentMethodBillingDetails({
                id,
                email,
                address,
                callback,
            });
        },
        initialValues,
        validationSchema,
    };
    const handleClose = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        onClose();
        setError(null);
    }, [onClose, setError]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit }) => {
        return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                error && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { mb: 5 },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.A, { severity: "error" }, error))),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EmailField$1, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Address1Field, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Address2Field, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, spacing: 4, mb: 4 },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 6 },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CityField, null)),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 6 },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(StateField, null))),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, spacing: 4 },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 6 },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PostcodeField, null)),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 6 },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CustomCountryField, null)))),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionDialogFooter, { cancel: { onClick: handleClose, disabled: isSubmitting || loading }, confirm: { loading: isSubmitting || loading, disabled: !canSubmit, type: 'submit', text: 'update' } }))));
    }));
};

const SubscriptionUpdateBillingDetailsDialog = ({ open, onClose }) => {
    const t = useT('subscriptions');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, { open: open, onClose: onClose, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, title: t('dialogUpdateBillingDetailsTitle'), size: "sm" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionUpdateBillingDetailsDialogBody, { onClose: onClose })));
};

const SubscriptionUpdatePaymentMethodDialogFooter = ({ loading, onCancel }) => {
    const { valid, onSubmit } = useSubscriptionFormContext();
    const handleConfirm = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        if (onSubmit) {
            onSubmit();
        }
    }, [onSubmit]);
    const handleCancel = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => onCancel(), [onCancel]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionDialogFooter, { cancel: { onClick: handleCancel, disabled: loading }, confirm: { onClick: handleConfirm, loading, disabled: !valid, text: 'update' } }));
};

const SubscriptionUpdatePaymentMethodDialogBody = ({ onClose }) => {
    const t = useT('subscriptions');
    const { loading, error } = usePaymentMethod();
    const { submitPaymentMethod, submitPaymentMethodError, submitPaymentMethodSuccess } = usePaymentMethodActions();
    const handleSubmit = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        submitPaymentMethod();
    }, [submitPaymentMethod]);
    const handleError = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((error) => {
        submitPaymentMethodError(error);
    }, [submitPaymentMethodError]);
    const handleSuccess = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        submitPaymentMethodSuccess();
        onClose();
    }, [onClose, submitPaymentMethodSuccess]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionFormContextProvider, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, { noPadding: true },
            error && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { p: 4 },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.A, { severity: "error" }, error))),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DialogSectionBox, { title: t('paymentMethodTitle') },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, p: 4 },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PaymentMethodForm, { mode: "update", onError: handleError, onSubmit: handleSubmit, onSuccess: handleSuccess })))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionUpdatePaymentMethodDialogFooter, { loading: loading, onCancel: onClose }))));
};

const SubscriptionUpdatePaymentMethodDialog = ({ open, onClose }) => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('subscriptions');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, { open: open, onClose: onClose, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, title: t('updatePaymentMethod'), size: "sm" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionUpdatePaymentMethodDialogBody, { onClose: onClose })));
};

const CancelButton = () => {
    const t = useT('subscriptions_CurrentPlan');
    const [isOpen, closeDialog, openDialog] = useDialogState();
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": 'cancelButton', variant: "contained", color: "secondary", onClick: openDialog }, t('cancelButton')),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CancelDialog, { open: isOpen, onClose: closeDialog })));
};

const BillingActionSecondaryButton = () => {
    const { isCanceled, willBeCanceled, isTrialing, hasPaymentMethod, isFreePlan, isSingularPlan, hasTrialEnded, } = useBillingMetadata();
    if (isSingularPlan || isFreePlan || (isTrialing && !hasPaymentMethod) || isCanceled || willBeCanceled || hasTrialEnded) {
        return null;
    }
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CancelButton, null);
};

const BillingActions = () => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const { defaultPlanId } = useBillingMetadata();
    const { confirmed } = useCheckout();
    const [{ isOpen, selectedPlanId }, setState] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState({
        isOpen: false,
    });
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (confirmed) {
            setState({ isOpen: false, selectedPlanId: defaultPlanId });
        }
    }, [confirmed, defaultPlanId]);
    const handleOpenSelection = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setState({
            isOpen: true,
        });
    }, []);
    const handleOpenCheckout = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setState({
            isOpen: true,
            selectedPlanId: defaultPlanId,
        });
    }, [defaultPlanId]);
    const handleCloseCheckout = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setState(prevState => (Object.assign(Object.assign({}, prevState), { isOpen: false })));
    }, []);
    const main = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(BillingActionMainButton, { openCheckout: handleOpenCheckout, openPlanSelect: handleOpenSelection }), [handleOpenCheckout, handleOpenSelection]);
    const secondary = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(BillingActionSecondaryButton, null), []);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RowActionButtons, { main: main, secondary: secondary }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CheckoutDialog, { open: isOpen, onClose: handleCloseCheckout, planId: selectedPlanId, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }));
};

const CurrentPlan = () => {
    const { fetching } = useBillingInformation();
    const { fetching: fetchingPlans } = usePlans();
    const hasWritePermission = useSubscriptionPermissions('fe.subscriptions.write.*');
    const { isExternallyManaged } = useBillingMetadata();
    if (fetching || fetchingPlans) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CurrentPlanComponentSkeleton, null);
    }
    else {
        return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, p: 0 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PlanDetails, null)),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true }, hasWritePermission && !isExternallyManaged && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(BillingActions, null))));
    }
};

const CardNarrow = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.C)(({ theme }) => ({
    padding: 0,
    margin: 0,
}));
const DetailSectionBox = ({ title, children }) => {
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { mb: 6 },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'subtitle1', mb: 4 }, title),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CardNarrow, null, children)));
};

const CurrentPlanBox = ({ children }) => {
    const t = useT('subscriptions_CurrentPlan');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DetailSectionBox, { title: t('title') },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, p: 8 }, children)));
};

const CurrentPlanComponent = () => {
    const { fetching, loading } = useBillingInformation();
    const isLoading = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => fetching || loading, [fetching, loading]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CurrentPlanBox, null, isLoading ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CurrentPlanComponentSkeleton, null) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CurrentPlan, null));
};

const RowSkeleton = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bN) `
  &.MuiSkeleton-root {
    height: ${({ theme }) => theme.spacing(12)};
    width: 100%;
    transform: scale(1, 1);
    margin-bottom: ${({ theme }) => theme.spacing(2)};
  }
`;
const TableSkeleton = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.forwardRef(({ title = true, rows = 3, cols = 1 }, ref) => {
    const table = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        const range = Array.from({ length: rows }, (v, i) => i);
        const colsRange = Array.from({ length: cols }, (v, i) => i);
        return range.map(row => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, key: row, spacing: 4 }, row === 0 ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RowSkeleton, null)) :
            colsRange.map(col => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { key: col, item: true, xs: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RowSkeleton, null)))));
    }, [rows, cols]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { ref: ref },
        title && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { marginBottom: 1 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bN, { width: 200, height: 40 })),
        table);
});
TableSkeleton.defaultProps = {
    title: true,
};

const InvoicesListComponentSkeleton = () => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { p: 4 },
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableSkeleton, { rows: 5, title: false, cols: 4 })));

const InvoicesListBox = ({ children }) => {
    const t = useT('subscriptions');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DetailSectionBox, { title: t('invoices') }, children);
};

const InvoicesTable = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c7)(({ theme }) => ({}));
const AmountChipCell = ({ value }) => {
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { maxWidth: '100%' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, alignItems: 'center', justifyItems: 'center' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: 'tableTitleCell' }, value.amount)),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, ml: 4, pt: 2 }, value.status === 'paid' && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cb, { label: 'Paid', status: 'success', withIcons: false })))));
};
const invoicesTableColumns = [
    {
        Header: 'Billing Date',
        id: 'billingDate',
        accessor: ({ billingDate }) => ({ date: billingDate, format: INVOICE_DATE_FORMAT, withAgo: false }),
        Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c8,
    },
    {
        Header: 'Amount',
        id: 'amount',
        accessor: ({ amount, status }) => ({
            amount,
            status,
        }),
        Cell: AmountChipCell,
    },
];
const InvoiceList = () => {
    const t = useT('subscriptions');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const container = injector === null || injector === void 0 ? void 0 : injector.adminPortalEl;
    const { loading, invoices } = useInvoices();
    const { downloadInvoice } = useInvoicesActions();
    const handleInvoiceDownload = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((invoice) => {
        downloadInvoice({
            invoiceId: invoice.id,
            filename: `invoice_${(0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cV)(invoice.billingDate || new Date(), DATE_FILENAME_FORMAT)}`,
        });
    }, [downloadInvoice]);
    const tableData = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => invoices.map((invoice, index) => ({
        id: invoice.id,
        billingDate: invoice.paymentDate,
        status: invoice.paid ? 'paid' : '',
        isDefault: index === 0,
        amount: `$${invoice.totalAmount}`,
    })), [invoices]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InvoicesTable, { inline: true, autoHeight: false, loading: loading, columns: invoicesTableColumns, data: tableData, contentMaxHeight: {
                maxHeight: '24rem',
            }, getRowActions: (row) => ({
                items: [
                    {
                        icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.dk, { "data-test-id": 'DownloadPdf' }),
                        onClick: () => handleInvoiceDownload(row),
                        text: t('downloadPdf'),
                        negative: false,
                    },
                ],
                container,
            }) })));
};

const InvoicesListComponent = () => {
    const { fetching, error } = useInvoices();
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InvoicesListBox, null, fetching ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InvoicesListComponentSkeleton, null)) : error ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.A, { severity: 'error' }, error)) : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InvoiceList, null))));
};

const BillingDetailsComponentSkeleton = () => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, p: 0, m: 0 },
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bN, { height: '32px', width: '100%' })));

const UpdateBillingMethod = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    cursor: 'pointer',
    svg: {
        marginLeft: theme.spacing(4),
        width: '0.75rem',
        height: '0.75rem',
        color: theme.palette.grey[500],
    },
}));
const BillingDetails = () => {
    var _a, _b;
    const t = useT('subscriptions_Billing');
    const [isOpen, closeDialog, openDialog] = useDialogState();
    const { paymentMethod } = usePaymentMethod();
    const { email, name } = (_a = paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.billingDetails) !== null && _a !== void 0 ? _a : {};
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, p: 0, alignItems: "center" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: "label" }, (_b = email !== null && email !== void 0 ? email : name) !== null && _b !== void 0 ? _b : '')),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(UpdateBillingMethod, { item: true, onClick: openDialog },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { variant: "body1" }, t('title')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bI, null))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionUpdateBillingDetailsDialog, { open: isOpen, onClose: closeDialog })));
};

const BillingDetailsBox = ({ children }) => {
    const t = useT('subscriptions_Billing');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DetailSectionBox, { title: t('title') },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, p: 6 }, children)));
};

const BillingDetailsComponent = () => {
    const { fetching, paymentMethod } = usePaymentMethod();
    if (!fetching && !(paymentMethod === null || paymentMethod === void 0 ? void 0 : paymentMethod.id)) {
        return null;
    }
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(BillingDetailsBox, null, fetching ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(BillingDetailsComponentSkeleton, null) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(BillingDetails, null));
};

const PaymentMethodComponentSkeleton = () => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, p: 0, m: 0 },
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bN, { height: '32px', width: '100%' })));

const PaymentMethodBox = ({ children }) => {
    const t = useT('subscriptions');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DetailSectionBox, { title: t('paymentMethodTitle') },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, p: 6 }, children)));
};

const PaymentMethodDisplay = () => {
    const [isOpen, closeDialog, openDialog] = useDialogState();
    const { paymentMethod } = usePaymentMethod();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PaymentMethodSelect, Object.assign({}, (paymentMethod || {}), { onUpdate: openDialog })),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionUpdatePaymentMethodDialog, { open: isOpen, onClose: closeDialog }));
};

const PaymentMethodComponent = () => {
    const { fetching } = usePaymentMethod();
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PaymentMethodBox, null, fetching ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PaymentMethodComponentSkeleton, null) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PaymentMethodDisplay, null)));
};

const BillingComponent = () => {
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PaymentMethodComponent, null),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(BillingDetailsComponent, null)));
};

const SubscriptionSections = () => {
    const { isExternallyManaged, hasPaymentMethod } = useBillingMetadata();
    const permitted = useSubscriptionPermissions('fe.subscriptions.write.*');
    const hasBilling = !isExternallyManaged && hasPaymentMethod && permitted;
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CurrentPlanComponent, null),
        hasBilling && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(BillingComponent, null),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InvoicesListComponent, null))))), [hasBilling]);
};

const SubscriptionPageSkeleton = () => {
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageWrapper, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CurrentPlanBox, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(CurrentPlanComponentSkeleton, null))));
};

const ExternallyManagedAlert = () => {
    const t = useT('subscriptions');
    const { summary } = useBillingInformation();
    if (summary === null || summary === void 0 ? void 0 : summary.externallyManaged) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { mb: 6 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.A, { severity: 'warning' }, t('externallyManaged')));
    }
    return null;
};

const SubscriptionPageContainer = () => {
    const { loadPaymentMethod } = usePaymentMethodActions();
    const { loadInvoices } = useInvoicesActions();
    const { loadPlans } = usePlansActions();
    const { error: paymentProviderError } = usePaymentProvider();
    const { error: billingInformationError } = useBillingInformation();
    const error = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => paymentProviderError || billingInformationError, [paymentProviderError, billingInformationError]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        loadInvoices();
        loadPaymentMethod();
        loadPlans();
    }, [loadInvoices, loadPaymentMethod, loadPlans]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageWrapper, { flex: 1, display: 'flex', flexDirection: 'column' }, error ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.A, { "data-test-id": 'subscription-page-error', severity: 'error' }, error)) : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ExternallyManagedAlert, null),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionSections, null)))));
};

const SubscriptionPageBillingWrapper = () => {
    const { loadBillingInformation } = useBillingInformationActions();
    const { fetching, loading } = useBillingInformation();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        loadBillingInformation();
    }, [loadBillingInformation]);
    if (fetching || loading) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionPageSkeleton, null);
    }
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionPageContainer, null);
};

const SubscriptionPage$1 = () => {
    const { loadPaymentConfiguration } = usePaymentProviderActions();
    const { profile } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cD)();
    const { fetching, loading } = usePaymentProvider();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (profile === null || profile === void 0 ? void 0 : profile.tenantId) {
            loadPaymentConfiguration();
        }
    }, [profile, loadPaymentConfiguration]);
    if (fetching || loading) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionPageSkeleton, null);
    }
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SubscriptionPageBillingWrapper, null);
};
var SubscriptionPage$2 = SubscriptionPage$1;

var SubscriptionPage = wrapPage(SubscriptionPage$2, 'subscriptions');

const WebhooksHeader = ({ handleOpenInviteUser }) => {
    const t = useT('webhooks');
    const { onSearch } = useTableSearch();
    const [search, setSearch] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState('');
    const debounceSearch = useDebounce(search);
    useAsyncEffect(() => onSearch(debounceSearch), [debounceSearch]);
    const hasWritePermission = usePermission('fe.connectivity.write.webhook');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, spacing: 4 },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 12, sm: 6, md: 4 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, { "data-test-id": "search-box", endAdornment: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cF, null), placeholder: t('searchInputPlaceholder'), onChange: (e) => setSearch(e.target.value) }))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: true }),
        hasWritePermission && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "add-webhook-btn", onClick: handleOpenInviteUser }, t('addWebhook')))));
};

const filterCategories = (categories, channelMap) => 
// eslint-disable-next-line react-hooks/rules-of-hooks
_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
    if (categories && channelMap) {
        return categories
            .map((cat) => {
            var _a;
            return (Object.assign(Object.assign({}, cat), { events: (_a = cat.events) === null || _a === void 0 ? void 0 : _a.filter(({ key }) => channelMap.some(({ key: eventKey }) => eventKey === key)) }));
        })
            .filter(({ events }) => !!(events === null || events === void 0 ? void 0 : events.length))
            .map((cat, index) => (Object.assign(Object.assign({}, cat), { index })));
    }
    return undefined;
}, [categories, channelMap]);
const selectedEvents = (0,_frontegg_redux_store__WEBPACK_IMPORTED_MODULE_2__/* .createSelector */ .P1)((events) => events, (events) => events === null || events === void 0 ? void 0 : events.reduce((acc, curr) => {
    if (/\.\*$/.test(curr)) {
        const val = curr.replace(/\.\*$/, '');
        !acc.names.includes(val) && acc.names.push(val);
    }
    else if (!acc.eventKeys.includes(curr)) {
        acc.eventKeys.push(curr);
    }
    return acc;
}, { names: [], eventKeys: [] }));
const getCategoriesEventsArray = (categories, eventKeys) => {
    return categories.map((category) => {
        if (category.events && eventKeys.includes(category.id)) {
            return category.events.map((e) => e.id);
        }
        return undefined;
    }).flat(1).filter(Boolean);
};

const NameField = () => {
    const t = useT('webhooks_AddEditWebhook');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('name');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ "data-test-id": "webhookNameBox", label: t('nameInputLabel') }, fieldProps, { autoFocus: true, error: !!error && touched, errorMessage: error, autoComplete: "given-name", placeholder: t('nameInputPlaceholder') })));
};
const UrlField = () => {
    const t = useT('webhooks_AddEditWebhook');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('url');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ "data-test-id": "webhookUrlBox", label: t('urlInputLabel') }, fieldProps, { error: !!error && touched, errorMessage: error, placeholder: t('urlInputPlaceholder') }));
};
const SecretKeyField = () => {
    const t = useT('webhooks_AddEditWebhook');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('secretKey');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ "data-test-id": "secretKeyBox", label: t('secretKeyInputLabel') }, fieldProps, { error: !!error && touched, errorMessage: error, placeholder: t('secretKeyInputPlaceholder') }));
};
const EventsField = () => {
    var _a;
    const t = useT('webhooks_AddEditWebhook');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const [fieldProps, { error, touched }, { setValue, setTouched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('events');
    const { categories } = useConnectivityState();
    const options = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (categories !== null && categories !== void 0 ? categories : []).map(({ name, id, events }, categoryIdx) => {
        const categoryId = id !== null && id !== void 0 ? id : `${name.replace(/\s/g, '_')}_${categoryIdx}`;
        return {
            label: name,
            value: categoryId,
            category: true,
            withCheckbox: true,
            categoryItems: events.map(({ displayName, key, id }, eventIdx) => {
                return { label: displayName, value: id !== null && id !== void 0 ? id : `${categoryId}_${key}_${eventIdx}`, withCheckbox: true };
            }),
        };
    }), [categories]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.dj, { "data-test-id": 'webhookEvents', label: t('eventsInputLabel'), name: "events", clearable: true, placeholder: t('eventsInputPlaceholder'), value: (_a = fieldProps === null || fieldProps === void 0 ? void 0 : fieldProps.value) !== null && _a !== void 0 ? _a : [], container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, options: options, onChange: (value) => {
            setValue(value, true);
            setTouched(true);
        }, error: !!error && touched, errorMessage: error }));
};
const AddWebhookForm = ({ onClose }) => {
    const t = useT('webhooks_AddEditWebhook');
    const { cleanError, postDataAction } = useConnectivityActions();
    const { categories } = useConnectivityState();
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
        name: '',
        url: '',
        secretKey: '',
        events: [],
    }), []);
    const validationSchema = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({
        name: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('nameIsRequired')),
        url: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d8)(t('urlIsRequired'), t('urlIsInvalid')),
        secretKey: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.dc)(8, t('secretKeyLengthAtLeast8')),
        events: create().min(1, t('eventsIsRequired')),
    }), [t]);
    const formikProps = {
        onSubmit: ({ name, url, secretKey, events }) => new Promise((resolve, reject) => {
            cleanError();
            const callback = callbackToPromise(resolve, reject, onClose);
            const eventsToRemove = getCategoriesEventsArray(categories, events);
            const eventsToSend = events.filter(e => !eventsToRemove.includes(e));
            postDataAction({
                platform: 'webhook',
                data: { displayName: name, url, secret: !!secretKey ? secretKey : null, eventKeys: eventsToSend, description: '', isActive: false },
                callback,
            });
        }),
        initialValues,
        validationSchema,
    };
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit, formError }) => {
        return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, spacing: 4, mb: 4 },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 12, sm: 12 },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(NameField, null)),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 12, sm: 12 },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(UrlField, null))),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SecretKeyField, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EventsField, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancel-btn", color: "inherit", variant: "text", type: "reset", onClick: onClose }, t('cancel')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "form-add-webhook-btn", disabled: !canSubmit, loading: isSubmitting, color: "primary", type: "submit" }, t('create')))));
    }));
};
const AddWebhookDialog = (props) => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('webhooks_AddEditWebhook');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { title: t('addTitle') }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AddWebhookForm, { onClose: props.onClose })));
};

const EditWebhookForm = ({ onClose, webhook }) => {
    const t = useT('webhooks_AddEditWebhook');
    const { cleanError, postDataAction } = useConnectivityActions();
    const { categories } = useConnectivityState();
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        var _a, _b, _c, _d;
        const eventKeys = (_a = webhook === null || webhook === void 0 ? void 0 : webhook.eventKeys) !== null && _a !== void 0 ? _a : [];
        const eventsToAdd = getCategoriesEventsArray(categories, eventKeys);
        const initEventsValue = [...eventKeys, ...eventsToAdd];
        return {
            name: (_b = webhook === null || webhook === void 0 ? void 0 : webhook.displayName) !== null && _b !== void 0 ? _b : '',
            url: (_c = webhook === null || webhook === void 0 ? void 0 : webhook.url) !== null && _c !== void 0 ? _c : '',
            secretKey: (_d = webhook === null || webhook === void 0 ? void 0 : webhook.secret) !== null && _d !== void 0 ? _d : '',
            events: initEventsValue !== null && initEventsValue !== void 0 ? initEventsValue : [],
        };
    }, [categories, webhook]);
    const validationSchema = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)({
        name: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('nameIsRequired')),
        url: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.d8)(t('urlIsRequired'), t('urlIsInvalid')),
        secretKey: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.dc)(8, t('secretKeyLengthAtLeast8')),
        events: create().min(1, t('eventsIsRequired')),
    }), [t]);
    const formikProps = {
        onSubmit: ({ name, url, secretKey = null, events }) => new Promise((resolve, reject) => {
            cleanError();
            const callback = callbackToPromise(resolve, reject, onClose);
            const eventsToRemove = getCategoriesEventsArray(categories, events);
            const eventsToSend = events.filter(e => !eventsToRemove.includes(e));
            postDataAction({
                platform: 'webhook',
                data: {
                    _id: webhook._id,
                    displayName: name,
                    url,
                    secret: !!secretKey ? secretKey : null,
                    eventKeys: eventsToSend,
                    description: webhook.description,
                    isActive: webhook.isActive,
                },
                callback,
            });
        }),
        initialValues,
        validationSchema,
    };
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit, formError }) => {
        return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, spacing: 4, mb: 4 },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 12, sm: 12 },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(NameField, null)),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 12, sm: 12 },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(UrlField, null))),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(SecretKeyField, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EventsField, null),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": "cancel-btn", color: "inherit", variant: "text", type: "reset", onClick: onClose }, t('cancel')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": 'edit-btn', disabled: !canSubmit, loading: isSubmitting, color: "primary", type: "submit" }, t('edit')))));
    }));
};
const EditWebhookDialog = (props) => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const t = useT('webhooks_AddEditWebhook');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { title: t('editTitle') }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditWebhookForm, Object.assign({}, props))));
};

const DeleteWebhookDialog = ({ open, webhook, onClose }) => {
    const t = useT('webhooks_DeleteWebhook');
    const [loading, setLoading] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const [error, setError] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(null);
    const { deleteWebhookConfigAction } = useConnectivityActions();
    const callback = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((success, error) => {
        if (error) {
            setLoading(false);
            setError(error);
        }
        else {
            setLoading(false);
            onClose();
        }
    }, [setLoading, setError, onClose]);
    const handleDeleteWebhook = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setLoading(true);
        setError(null);
        deleteWebhookConfigAction({ webhookId: webhook === null || webhook === void 0 ? void 0 : webhook._id, callback });
    }, [callback, deleteWebhookConfigAction, webhook === null || webhook === void 0 ? void 0 : webhook._id]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeleteDialog, { title: t('title'), cancelButtonText: t('cancel'), deleteButtonText: t('delete'), description: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            t('areYouSureDeleteWebhook1'),
            " ",
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("strong", null, webhook === null || webhook === void 0 ? void 0 : webhook.displayName),
            " ",
            t('areYouSureDeleteWebhook2')), open: open, error: error, onClose: onClose, loading: !!loading, onDelete: handleDeleteWebhook }));
};

const useWebhooksTableRowActions = ({ container, handleOpenDeleteWebhook, handleOpenEditWebhook, hasWritePermission, hasDeletePermission, }) => {
    const t = useT('webhooks');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (row) => {
        const items = [];
        const handleEditWebhook = () => {
            handleOpenEditWebhook(row);
        };
        const handleDeleteWebhook = () => {
            handleOpenDeleteWebhook(row);
        };
        //TODO change data test id from editBtn to action-edit-btn
        if (hasWritePermission) {
            items.push({
                text: t('editWebhook'),
                onClick: handleEditWebhook,
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bI, { "data-test-id": 'action-edit-btn' }),
            });
        }
        //TODO change data test id from deleteBtn to delete-btn
        if (hasDeletePermission) {
            items.push({
                negative: true,
                text: t('deleteWebhook'),
                onClick: handleDeleteWebhook,
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bZ, { "data-test-id": 'action-delete-btn' }),
            });
        }
        return { items, container };
    }, [container, handleOpenDeleteWebhook, handleOpenEditWebhook, hasDeletePermission, hasWritePermission, t]);
};
const webhooksColumns = ({ onChangeStatus, t }) => [
    {
        accessor: ({ url, displayName }) => ({ title: displayName, description: url }),
        Header: t('nameHeader'),
        Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cH,
    },
    {
        accessor: (webhook) => {
            var _a;
            return ({
                checked: (_a = webhook === null || webhook === void 0 ? void 0 : webhook.isActive) !== null && _a !== void 0 ? _a : false,
                onChange: () => webhook && onChangeStatus(webhook),
            });
        },
        Header: t('statusHeader'),
        Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cP,
        maxWidth: 100,
        minWidth: 100,
    },
].filter(notNull);

const WebhooksTable = () => {
    var _a;
    const t = useT('webhooks');
    const { searchQuery } = useTableSearch();
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const container = injector === null || injector === void 0 ? void 0 : injector.adminPortalEl;
    const [editWebhookDialog, handleCloseEditWebhook, handleOpenEditWebhook, editWebhookData] = useDialogState();
    const [deleteWebhookDialog, handleCloseDeleteWebhook, handleOpenDeleteWebhook, deleteWebhookData] = useDialogState();
    const { postDataAction } = useConnectivityActions();
    const { webhook: webhookState, categories, channelMap, isLoading, totalPages } = useConnectivityState();
    const cleanCategories = filterCategories(categories, channelMap && channelMap.webhook);
    const hasWritePermission = usePermission('fe.connectivity.write.webhook');
    const hasDeletePermission = usePermission('fe.connectivity.delete.webhook');
    const getRowActions = useWebhooksTableRowActions({
        container,
        handleOpenEditWebhook,
        handleOpenDeleteWebhook,
        hasWritePermission,
        hasDeletePermission,
    });
    const preparedWebhookState = (_a = webhookState === null || webhookState === void 0 ? void 0 : webhookState.data) !== null && _a !== void 0 ? _a : webhookState;
    const webhooks = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => preparedWebhookState === null || preparedWebhookState === void 0 ? void 0 : preparedWebhookState.map((elm) => {
        var _a;
        const eventObject = selectedEvents(elm.eventKeys);
        const data = cleanCategories === null || cleanCategories === void 0 ? void 0 : cleanCategories.reduce((acc, cur) => {
            var _a, _b, _c;
            if (eventObject === null || eventObject === void 0 ? void 0 : eventObject.names.includes(cur.name)) {
                return [...acc, { name: cur.name, count: (_b = (_a = cur.events) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0 }];
            }
            else {
                const evs = (_c = cur.events) === null || _c === void 0 ? void 0 : _c.filter(({ key }) => eventObject === null || eventObject === void 0 ? void 0 : eventObject.eventKeys.includes(key));
                if (evs === null || evs === void 0 ? void 0 : evs.length) {
                    return [...acc, { name: cur.name, count: evs.length }];
                }
            }
            return acc;
        }, []);
        return Object.assign(Object.assign({}, elm), { groupEvents: data !== null && data !== void 0 ? data : [], totalEvents: (_a = data === null || data === void 0 ? void 0 : data.reduce((acc, cur) => acc + (cur.count || 0), 0)) !== null && _a !== void 0 ? _a : 0 });
    }), [preparedWebhookState, cleanCategories]);
    const filteredWebhooks = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        const query = searchQuery.toLocaleLowerCase();
        return webhooks
            ? webhooks.filter((w) => {
                const webhookUrl = w.url.toLocaleLowerCase();
                const webhookName = w.displayName.toLocaleLowerCase();
                return webhookName.includes(query) || webhookUrl.includes(query);
            })
            : [];
    }, [searchQuery, webhooks]);
    const tablePlaceholderProps = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        const webhooksLength = webhooks ? webhooks.length : 0;
        if (isLoading) {
            return null;
        }
        if (!webhooksLength) {
            return {
                show: true,
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.co, null),
                title: t('noWebhooksYet'),
                description: t('noWebhooksYetDescription'),
                testId: 'webhooks-table-empty-placeholder'
            };
        }
        if (filteredWebhooks.length === 0) {
            return {
                show: true,
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cL, null),
                title: t('noResultFound'),
                description: t('noResultFoundDescription'),
                testId: 'webhooks-table-no-results-placeholder'
            };
        }
        return null;
    }, [isLoading, webhooks, filteredWebhooks.length, t]);
    const onChangeStatus = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((data) => {
        postDataAction({ platform: 'webhook', data: Object.assign(Object.assign({}, data), { isActive: !data.isActive }) });
    }, [postDataAction]);
    const columns = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => webhooksColumns({ onChangeStatus, t }), [onChangeStatus, t]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c7, { forwardedKey: "webhooks-table", columns: columns, loading: isLoading, totalPages: totalPages, data: filteredWebhooks !== null && filteredWebhooks !== void 0 ? filteredWebhooks : [], getRowActions: getRowActions }, tablePlaceholderProps && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cM, Object.assign({}, tablePlaceholderProps))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EditWebhookDialog, { open: editWebhookDialog, onClose: handleCloseEditWebhook, webhook: editWebhookData }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeleteWebhookDialog, { open: deleteWebhookDialog, onClose: handleCloseDeleteWebhook, webhook: deleteWebhookData })));
};

const WebhooksPage$1 = () => {
    const [searchQuery, onSearch] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState("");
    const [searching, setSearching] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const { loadDataAction } = useConnectivityActions();
    const [addWebhookDialog, handleCloseAddWebhook, handleOpenAddWebhook] = useDialogState();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        loadDataAction();
    }, [loadDataAction]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageWrapper, { flex: 1, display: "flex", flexDirection: "column" },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableSearchContext.Provider, { value: { searching, searchQuery, onSearch, setSearching } },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(WebhooksHeader, { handleOpenInviteUser: handleOpenAddWebhook }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { mt: 6, flex: 1, display: "flex", flexDirection: "column" },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(WebhooksTable, null)),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AddWebhookDialog, { open: addWebhookDialog, onClose: handleCloseAddWebhook }))));
};
var WebhooksPage$2 = WebhooksPage$1;

var WebhooksPage = wrapPage(WebhooksPage$2, 'webhooks');

const LoginPage = () => {
    const { closeAdminBox } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(AppDialogContext);
    const { basename = '' } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const { loginUrl } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.K)();
    const onRedirectTo = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.Q)();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        closeAdminBox();
        const calculatedBasename = basename.endsWith('/') ? basename.substring(0, basename.length - 1) : '';
        window.location.href = calculatedBasename + loginUrl;
    }, [onRedirectTo, closeAdminBox]);
    return null;
};
var LoginPage$1 = LoginPage;

const AllUsersHeader = ({ handleOpenInviteUser }) => {
    const t = useT('allUsers');
    const { onSearch } = useTableSearch();
    const [search, setSearch] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState('');
    const debounceSearch = useDebounce(search);
    const canInviteUser = usePermission('fe.secure.write.users');
    useAsyncEffect(() => onSearch(debounceSearch), [debounceSearch]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, spacing: 4 },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 12, sm: 6, md: 4 },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, { "data-test-id": 'searchBox', endAdornment: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cF, null), onChange: (e) => setSearch(e.target.value), placeholder: t('searchInputPlaceholder') }))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: true }),
        canInviteUser && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": 'invite-user-btn', onClick: handleOpenInviteUser }, t('inviteUserButton'))))));
};

const useUsersTableRowActions = ({ container, resendActivationLink, resendInvitationLink, handleOpenDeleteUser, handleOpenLockUser, handleOpenInviteUser, currentTenantId, subTenants, }) => {
    const t = useT('allUsers');
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.X)();
    const canEditRoles = usePermission('fe.secure.write.users');
    const canDeleteUser = usePermission('fe.secure.delete.users');
    //TODO: add virified type to ITeamUser
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (row) => {
        const items = [];
        const handleManageUser = () => {
            handleOpenInviteUser(row);
        };
        const handleSendActivationLink = () => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, reject);
            resendActivationLink({ userId: row.id, callback });
        });
        const handleSendInvitationLink = () => new Promise((resolve, reject) => {
            const callback = callbackToPromise(resolve, reject);
            const invitationData = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(row, ["id"]);
            resendInvitationLink(Object.assign(Object.assign({}, invitationData), { callback }));
        });
        const handleDeleteUser = () => {
            handleOpenDeleteUser(row);
        };
        const isMe = row.id === (user === null || user === void 0 ? void 0 : user.id);
        if (!row.verified) {
            items.push({
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cJ, { "data-test-id": 'resendBtn' }),
                onClick: handleSendActivationLink,
                text: t('resendActivationAction'),
            });
        }
        else {
            items.push({
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cJ, { "data-test-id": 'resendInvitationBtn' }),
                onClick: handleSendInvitationLink,
                text: t('resendInvitationAction'),
            });
        }
        if (!isMe) {
            if (canEditRoles) {
                items.push({
                    icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TuneRounded, { "data-test-id": 'manageBtn' }),
                    onClick: handleManageUser,
                    text: t('manageAction'),
                });
            }
            if (canDeleteUser) {
                // TODO: Define lock user action
                // items.push({
                //   icon: <DoDisturb data-test-id='lockBtn' />,
                //   onClick: handleLockUser,
                //   text: t('lockUserAction'),
                // });
                items.push({
                    icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bZ, { "data-test-id": 'deleteBtn' }),
                    onClick: handleDeleteUser,
                    text: t('deleteUserAction'),
                });
            }
        }
        return { items, container };
    }, [
        t,
        user,
        container,
        canEditRoles,
        canDeleteUser,
        resendActivationLink,
        resendInvitationLink,
        handleOpenDeleteUser,
        handleOpenLockUser,
        handleOpenInviteUser,
        subTenants,
        currentTenantId,
    ]);
};
const allUsersTableColumnsOrganization = ({ t, user, subTenants, forcePermissions, container, currentTenantName, currentTenantId, }) => [
    {
        Header: () => _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { width: '2rem' }),
        accessor: ({ name, profileImageUrl, profilePictureUrl }) => ({
            name,
            picture: profilePictureUrl !== null && profilePictureUrl !== void 0 ? profilePictureUrl : profileImageUrl,
        }),
        width: '2rem',
        id: 'id',
        Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cG,
    },
    Object.assign(Object.assign({ Header: t('userHeader'), accessor: ({ id, name, email }) => ({
            title: `${name} ${id === user.id ? `(${t('meTooltip')})` : ''}`,
            description: email,
        }) }, (forcePermissions ? { width: 260, maxWidth: 260 } : { minWidth: 260 })), { Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cH }),
    {
        Header: t('accountsHeader'),
        accessor: ({ tenants }) => {
            var _a;
            const items = (_a = tenants === null || tenants === void 0 ? void 0 : tenants.map((tenant) => {
                var _a;
                let text = (_a = subTenants.find((subTenant) => subTenant.tenantId === tenant.tenantId)) === null || _a === void 0 ? void 0 : _a.tenantName;
                if (!text && tenant.tenantId === currentTenantId) {
                    text = currentTenantName;
                }
                return { text };
            })) !== null && _a !== void 0 ? _a : [];
            return { items: items.filter((item) => item.text), max: 2, container };
        },
        minWidth: 300,
        Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cI,
    },
    {
        Header: t('joinedHeader'),
        accessor: ({ createdAt, tenants }) => ({
            date: createdAt,
            tenants,
        }),
        width: 160,
        maxWidth: 160,
        Cell: (props) => {
            const hasOneActivatedTenant = !!(props.value.tenants || []).find((tenant) => tenant.activated);
            return !hasOneActivatedTenant ? (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c5, { color: 'secondary', label: t('pendingActivationStatus') })) : (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c8, Object.assign({}, props)));
        },
    },
    {
        Header: t('lastSeenHeader'),
        accessor: ({ tenants, tenantId }) => {
            var _a;
            return ({
                date: (_a = tenants === null || tenants === void 0 ? void 0 : tenants.find((tenant) => tenant.tenantId === tenantId)) === null || _a === void 0 ? void 0 : _a.lastLogin,
            });
        },
        width: 160,
        maxWidth: 160,
        Cell: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c8,
    },
].filter(notNull);

const DeleteUserDialog = ({ onClose, open, user }) => {
    const t = useT('allUsers_DeleteUser');
    const [loading, setLoading] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const [error, setError] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(null);
    const { deleteUserFromSubTenants } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cA)();
    const callback = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((success, error) => {
        if (error) {
            setError(error);
        }
        else {
            onClose();
        }
        setLoading(false);
    }, [setLoading, setError, onClose]);
    const handleDeleteUser = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setLoading(true);
        setError(null);
        deleteUserFromSubTenants({
            callback,
            userId: user.id,
            subTenants: user.tenants.map((tenant) => ({ tenantId: tenant.tenantId })),
        });
    }, [user === null || user === void 0 ? void 0 : user.id, user === null || user === void 0 ? void 0 : user.tenants, setLoading, setError, deleteUserFromSubTenants, callback]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeleteDialog, { dataTestId: 'deleteUserBtn', title: t('title', { name: user === null || user === void 0 ? void 0 : user.name }), cancelButtonText: t('cancel'), deleteButtonText: t('delete'), description: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            t('areYouSureDeleteUser1', { name: user === null || user === void 0 ? void 0 : user.name }),
            " ",
            t('areYouSureDeleteUser2')), open: open, error: error, onClose: onClose, loading: !!loading, onDelete: handleDeleteUser }));
};

const LockUserDialog = ({ onClose, open, user }) => {
    const t = useT('allUsers_LockUser');
    const [loading, setLoading] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const [error, setError] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(null);
    const { lockUser } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cA)();
    const callback = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((success, error) => {
        if (error) {
            setError(error);
        }
        else {
            onClose();
        }
        setLoading(false);
    }, [setLoading, setError, onClose]);
    const handleLockUser = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        setLoading(true);
        setError(null);
        lockUser({ userId: user === null || user === void 0 ? void 0 : user.id, callback });
    }, [user === null || user === void 0 ? void 0 : user.id, callback, setLoading, setError, lockUser]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeleteDialog, { dataTestId: 'lockUserBtn', title: t('title', { name: user === null || user === void 0 ? void 0 : user.name }), cancelButtonText: t('cancel'), deleteButtonText: t('lock'), description: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null, t('areYouSureLockUser1', { name: user === null || user === void 0 ? void 0 : user.name })), open: open, error: error, onClose: onClose, loading: !!loading, onDelete: handleLockUser }));
};

const AllUsersTable = ({ handleOpenInviteUser }) => {
    const t = useT('allUsers');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const container = injector === null || injector === void 0 ? void 0 : injector.adminPortalEl;
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.b$)();
    const { loaders, allUsers, roles, permissions, totalPages, pageOffset, filter } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bR)();
    const { resendActivationLink, loadAllSubTenantsUsers, resendInvitationLinkToAllSubTenants } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cA)();
    const [deleteUserDialog, handleCloseDeleteUser, handleOpenDeleteUser, deleteUserData] = useDialogState();
    const [lockUserDialog, handleCloseLockUser, handleOpenLockUser, lockUserData] = useDialogState();
    const { policy, loading: loadingPolicy } = usePublicPolicySettings();
    const rolesUse = useRolesMap(roles);
    const rolesMap = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (!loadingPolicy && (policy === null || policy === void 0 ? void 0 : policy.forcePermissions) ? rolesUse : undefined), [
        policy,
        rolesUse,
        loadingPolicy,
    ]);
    const { tenants, subTenants } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cd)();
    const tenantName = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        var _a, _b;
        return (_b = (_a = tenants.find(({ tenantId }) => tenantId === user.tenantId)) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : '';
    }, [tenants, user.tenantId]);
    const isPermissionsAndRolesEnabled = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => !loadingPolicy && (policy === null || policy === void 0 ? void 0 : policy.forcePermissions), [
        loadingPolicy,
        policy,
    ]);
    const columns = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        return allUsersTableColumnsOrganization({
            t,
            user,
            subTenants,
            forcePermissions: isPermissionsAndRolesEnabled,
            container,
            currentTenantName: tenantName,
            currentTenantId: user.tenantId,
        });
    }, [t, user, subTenants, isPermissionsAndRolesEnabled, container, rolesMap, tenantName, user.tenantId]);
    const { searching } = useTableSearch();
    const getRowActions = useUsersTableRowActions({
        roles,
        subTenants,
        permissions,
        container,
        resendActivationLink,
        resendInvitationLink: resendInvitationLinkToAllSubTenants,
        handleOpenDeleteUser,
        handleOpenLockUser,
        handleOpenInviteUser,
        currentTenantId: user.tenantId,
    });
    const onPageChange = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((event, page) => {
        loadAllSubTenantsUsers({ _offset: page - 1 });
    }, [loadAllSubTenantsUsers]);
    const onSortChange = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((sortBy = []) => {
        var _a, _b;
        loadAllSubTenantsUsers({
            _offset: 0,
            _sortBy: ((_a = sortBy[0]) === null || _a === void 0 ? void 0 : _a.id) || 'name',
            _order: ((_b = sortBy[0]) === null || _b === void 0 ? void 0 : _b.desc) ? 'DESC' : 'ASC',
        });
    }, [loadAllSubTenantsUsers]);
    const loading = !!loaders.USERS;
    const tablePlaceholderProps = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        if (loading || searching) {
            return null;
        }
        else if (filter.length === 0 && allUsers.length === 0) {
            return {
                show: true,
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cK, null),
                title: t('noUsersYet'),
                description: t('noUsersYetDescription'),
            };
        }
        else if (filter.length > 0 && allUsers.length === 0) {
            return {
                show: true,
                icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cL, null),
                title: t('noResultFound'),
                description: t('noResultFoundDescription'),
            };
        }
        return null;
    }, [t, loading, searching, filter.length, allUsers.length]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c7, { forwardedKey: 'all-users-table', columns: columns, data: allUsers, getRowActions: getRowActions, loading: loading, searching: searching, onSortChange: onSortChange, loadingText: searching ? t('searchingPlaceholder') : undefined, totalPages: totalPages, pageOffset: pageOffset, onPageChange: onPageChange }, tablePlaceholderProps && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cM, Object.assign({}, tablePlaceholderProps))),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DeleteUserDialog, { open: deleteUserDialog, onClose: handleCloseDeleteUser, user: deleteUserData }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(LockUserDialog, { open: lockUserDialog, onClose: handleCloseLockUser, user: lockUserData })));
};

const TreeHeader = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G) `
  height: 56px;
  background: #f5f6f8;
  border: 1px solid #e5eaf3;
  border-radius: 3px 3px 0 0;
  flex-direction: row;
  align-items: center;
  display: flex;
  border-bottom-width: 0;
`;
const FirstNameField = () => {
    const t = useT('allUsers_InviteUser');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('fullName');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ label: t('fullNameInputLabel') }, fieldProps, { error: !!error && touched, errorMessage: error, "data-test-id": 'nameBox', autoComplete: 'given-name' })));
};
const EmailField = ({ disabled }) => {
    const t = useT('allUsers_InviteUser');
    const [fieldProps, { error, touched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('email');
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.I, Object.assign({ label: t('emailInputLabel') }, fieldProps, { error: !!error && touched, errorMessage: error, "data-test-id": 'emailBox', autoComplete: 'email', disabled: disabled })));
};
const RolesField = ({ roles, id }) => {
    const t = useT('allUsers_InviteUser');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const [fieldProps, { error, touched }, { setValue, setTouched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)(`roleIds-${id}`);
    const options = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (roles !== null && roles !== void 0 ? roles : []).map((role) => ({ label: role.name, value: role.id, withCheckbox: true })), [roles]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bS, { name: `roleIds-${id}`, placeholder: t('rolesInputPlaceholder'), value: fieldProps.value, multi: true, oneLineMulti: true, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, options: options, onChange: (value) => {
            setValue(value, true);
            setTouched(true);
        }, error: !!error && touched, errorMessage: error, onClick: (e) => e.stopPropagation(), sx: { margin: '0 0 0 auto', width: 210 } }));
};
const AssignRolesToAll = ({ roles, selectedTenantIds }) => {
    const t = useT('allUsers_InviteUser');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const [fieldProps, { error, touched }, { setValue, setTouched }] = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.at)('rolesForAllTenants');
    const options = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (roles !== null && roles !== void 0 ? roles : []).map((role) => ({ label: role.name, value: role.id, withCheckbox: true })), [roles]);
    const formikContext = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.u)();
    const onChange = (value) => {
        setValue(value, true);
        setTouched(true);
        selectedTenantIds.forEach((id) => {
            formikContext.setFieldValue(`roleIds-${id}`, value);
        });
    };
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bS, { name: 'rolesForAllTenants', placeholder: t('rolesInputPlaceholder'), value: fieldProps.value, multi: true, oneLineMulti: true, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, options: options, onChange: onChange, error: !!error && touched, errorMessage: error, onClick: (e) => e.stopPropagation(), sx: { marginBottom: 0 }, customContent: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": 'assignRolesToAllBtn', size: 'small', color: 'inherit', onClick: (e) => e.stopPropagation(), type: 'button' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ManageAccounts, null),
            " ",
            t('assignRole')), minPopperWidth: 240 }));
};
const InviteUserForm = (_a) => {
    var props = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, []);
    const t = useT('allUsers_InviteUser');
    const { addUserToSubTenants, setUserRolesForSubTenants, deleteUserFromSubTenants } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cA)();
    const { tenantTree } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cd)();
    const userData = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => props.teamUser, [props.teamUser]);
    const treeData = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        const mapTree = (node, level = 1) => ({
            id: node.tenantId,
            name: node.tenantName || '',
            level,
            children: node.children.map((child) => mapTree(child, level + 1)),
        });
        return tenantTree && mapTree(tenantTree);
    }, [tenantTree]);
    const allTenantIds = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        const getTenantsIds = (node) => [
            node.tenantId,
            ...node.children.map((child) => getTenantsIds(child)).flat(),
        ];
        return tenantTree ? getTenantsIds(tenantTree) : [];
    }, [tenantTree]);
    const initialValues = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        const mapTreeInitialValues = (node, acc = {}) => {
            var _a;
            if (!node) {
                return {};
            }
            if (userData && userData.tenants) {
                acc[`roleIds-${node.id}`] =
                    ((_a = userData.tenants.find((tenant) => tenant.tenantId === node.id)) === null || _a === void 0 ? void 0 : _a.roles.map((role) => role.id)) || [];
            }
            else {
                acc[`roleIds-${node.id}`] = [];
            }
            (node.children || []).forEach((child) => mapTreeInitialValues(child, acc));
            return acc;
        };
        const tenantsRoles = mapTreeInitialValues(treeData);
        return Object.assign(Object.assign({}, tenantsRoles), { fullName: (userData === null || userData === void 0 ? void 0 : userData.name) || '', email: (userData === null || userData === void 0 ? void 0 : userData.email) || '', rolesForAllTenants: [] });
    }, [treeData, userData]);
    const [selectedTenants, setSelectedTenants] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(((userData === null || userData === void 0 ? void 0 : userData.tenants) || []).map((tenant) => tenant.tenantId) || []);
    const accountsCount = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => t('accountsCount_one', { count: selectedTenants.length }), [
        selectedTenants.length,
        t,
    ]);
    const validationSchema = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ab)(Object.assign({ fullName: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bX)(t('fullNameIsRequired')), email: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ae)(t('emailMustBeValid'), t('emailIsRequired')) }, selectedTenants.reduce((previousValue, currentValue) => {
        return Object.assign(Object.assign({}, previousValue), { [`roleIds-${currentValue}`]: create().min(1, t('rolesIsRequired')) });
    }, {}))), [t, selectedTenants]);
    const handleSelectedChange = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((ids) => setSelectedTenants(ids), [setSelectedTenants]);
    const cachedRoles = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => props.roles, [props.roles]);
    const itemProps = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({ roles: cachedRoles }), [cachedRoles]);
    const checked = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => selectedTenants.length === (allTenantIds === null || allTenantIds === void 0 ? void 0 : allTenantIds.length), [selectedTenants, allTenantIds]);
    const indeterminate = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => !checked && selectedTenants.length > 0, [selectedTenants, checked]);
    const handleSelectAll = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => setSelectedTenants(!checked ? allTenantIds : []), [allTenantIds, checked]);
    const formikProps = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
        onSubmit: (_a) => {
            var { fullName, email } = _a, rest = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["fullName", "email"]);
            return new Promise((resolve, reject) => {
                const callback = callbackToPromise(resolve, reject, props.onClose);
                if (userData && userData.tenantIds) {
                    const addedTenants = selectedTenants.filter((x) => !userData.tenantIds.includes(x));
                    const removedTenants = userData.tenantIds.filter((x) => !selectedTenants.includes(x));
                    if (addedTenants.length) {
                        addUserToSubTenants({
                            user: { name: userData.name, email: userData.email },
                            subTenants: addedTenants.map((id) => ({
                                tenantId: id,
                                roleIds: [...new Set(rest[`roleIds-${id}`])],
                            })),
                        });
                    }
                    if (removedTenants.length) {
                        deleteUserFromSubTenants({
                            userId: userData.id,
                            subTenants: removedTenants.map((id) => ({ tenantId: id })),
                        });
                    }
                    setUserRolesForSubTenants({
                        callback,
                        userId: userData.id,
                        subTenantsRoles: selectedTenants
                            .filter((id) => !removedTenants.includes(id))
                            .map((id) => ({
                            tenantId: id,
                            roleIds: [...new Set(rest[`roleIds-${id}`])],
                        })),
                    });
                }
                else {
                    addUserToSubTenants({
                        callback,
                        user: { name: fullName, email },
                        subTenants: selectedTenants.map((id) => ({
                            tenantId: id,
                            roleIds: [...new Set(rest[`roleIds-${id}`])],
                        })),
                    });
                }
            });
        },
        initialValues,
        validationSchema,
    }), [
        addUserToSubTenants,
        deleteUserFromSubTenants,
        initialValues,
        props.onClose,
        selectedTenants,
        setUserRolesForSubTenants,
        userData,
        validationSchema,
    ]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormDialogBody, Object.assign({}, formikProps), ({ isSubmitting, canSubmit, formError }) => {
        return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Body, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, spacing: 4 },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 12, sm: 6 },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FirstNameField, null)),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 12, sm: 6 },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(EmailField, { disabled: !!(userData === null || userData === void 0 ? void 0 : userData.email) }))),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { container: true, spacing: 4, style: { marginBottom: '8px' }, alignItems: 'center' },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 6 },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { component: 'div', display: 'inline-flex', marginRight: '1em' }, t('selected')),
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.dd, { label: accountsCount })),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 6, sx: { display: 'flex', justifyContent: 'end' } },
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AssignRolesToAll, { roles: cachedRoles, selectedTenantIds: selectedTenants }))),
                treeData && (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TreeHeader, null,
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 6 },
                            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { component: 'div', display: 'flex', marginLeft: '3.5em', fontWeight: 'bold', alignItems: 'center' },
                                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.o, { edge: 'start', checked: checked, onChange: handleSelectAll, tabIndex: -1, indeterminate: indeterminate, disableRipple: true, onClick: (e) => e.stopPropagation(), size: 'small', sx: { padding: '3px 8px 3px 1em' } }),
                                t('accounts'))),
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { item: true, xs: 6 },
                            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.T, { component: 'div', display: 'inline-flex', marginLeft: '3.5em', fontWeight: 'bold' }, t('role')))),
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.de, { data: treeData, selected: selectedTenants, handleSelectedChange: handleSelectedChange, ItemContent: RolesField, itemProps: itemProps }))),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(FormErrorDialogMessage, { message: formError })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG.Footer, null,
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { flex: 1 }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": 'cancelBtn', color: 'inherit', variant: 'text', type: 'reset', onClick: props.onClose }, t('cancel')),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.l, { "data-test-id": 'inviteBtn', disabled: !canSubmit, loading: isSubmitting, color: 'primary', type: 'submit' }, !userData ? t('invite') : t('save')))));
    }));
};
const InviteUserDialog = (_a) => {
    var { onClose } = _a, props = (0,_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.f)(_a, ["onClose"]);
    const t = useT('allUsers_InviteUser');
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const handleClose = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback(() => {
        onClose();
    }, [onClose]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bG, Object.assign({ container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl }, props, { onClose: handleClose, title: t('title') }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InviteUserForm, Object.assign({}, props, { onClose: handleClose }))));
};

const AllUsersPage$1 = () => {
    const [searching, setSearching] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const [searchQuery, onSearch] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState('');
    const { allUsers, roles } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bR)();
    const { loadAllSubTenantsUsers } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cA)();
    const { loadSubTenants, loadSubTenantsTree } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cB)();
    const [inviteUserDialog, handleCloseInviteUser, handleOpenInviteUser, inviteUserData] = useDialogState();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        loadSubTenants();
        loadSubTenantsTree();
        const queryObject = {
            _filter: '',
            _offset: 0,
            _limit: 20,
            _order: 'DESC',
            _sortBy: 'name',
            silentLoading: allUsers.length > 0,
        };
        loadAllSubTenantsUsers(queryObject);
        return () => loadAllSubTenantsUsers(queryObject);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadAllSubTenantsUsers]);
    useEffectAfterMount(() => {
        loadAllSubTenantsUsers({
            _filter: searchQuery,
            _offset: 0,
            _limit: 20,
            _order: 'DESC',
            _sortBy: 'name',
            callback: () => setSearching(false),
        });
    }, [searchQuery, loadAllSubTenantsUsers]);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageWrapper, { flex: 1, display: 'flex', flexDirection: 'column' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(TableSearchContext.Provider, { value: { searching, searchQuery, onSearch, setSearching } },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AllUsersHeader, { handleOpenInviteUser: handleOpenInviteUser }),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { mt: 6, flex: 1, display: 'flex', flexDirection: 'column' },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AllUsersTable, { handleOpenInviteUser: handleOpenInviteUser })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(InviteUserDialog, { open: inviteUserDialog, onClose: handleCloseInviteUser, roles: roles, teamUser: inviteUserData }))));
};
var AllUsersPage$2 = AllUsersPage$1;

var AllUsersPage = wrapPage(AllUsersPage$2, 'allUsers');

const usePreloadRoutes = () => {
    const { loadProfile, loadAccountSettings, loadSSOConfigurationsV2, loadSecurityPolicy, loadVendorPasswordConfig, } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.V)();
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const isAuthenticated = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.W)();
    const { policy, loading: loadingPolicy } = usePublicPolicySettings();
    const shouldLoad = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((page) => {
        var _a;
        const metadata = _frontegg_types__WEBPACK_IMPORTED_MODULE_4__.Metadata.getInstance(injector.name).navigation[page];
        if (!metadata) {
            return false;
        }
        if (metadata.visibility === 'hidden') {
            return false;
        }
        if (metadata.featureFlag) {
            return false;
        }
        if ((policy === null || policy === void 0 ? void 0 : policy.forcePermissions) && metadata.visibility === 'byPermissions') {
            return hasPermission(...((_a = metadata.permissions) !== null && _a !== void 0 ? _a : []));
        }
        return true;
    }, [policy === null || policy === void 0 ? void 0 : policy.forcePermissions]);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (isAuthenticated && !loadingPolicy) {
            if (shouldLoad('profile')) {
                loadProfile();
            }
            if (shouldLoad('privacy')) {
                loadVendorPasswordConfig();
            }
            if (shouldLoad('account')) {
                loadAccountSettings();
            }
            if (shouldLoad('security')) {
                loadSecurityPolicy();
            }
            if (shouldLoad('sso')) {
                loadSSOConfigurationsV2();
            }
        }
    }, [isAuthenticated, shouldLoad, loadingPolicy]);
};
const getRoutes = (appName, user, vendorConfig) => {
    return [
        { type: 'nav-header', id: 'profile', path: '/', icon: { xl: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ce, null), default: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(UserAvatar, null) }, component: ProfilePage },
        { type: 'nav-header', id: 'privacy', path: '/privacy', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cf, null), component: PrivacyPage },
        { type: 'nav-header', id: 'personalApiTokens', path: '/personal-tokens', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cg, null), component: PersonalTokensPage },
        { type: 'nav-body', id: 'usage', path: '/usage', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ch, null), component: ProfilePage },
        { type: 'nav-body', id: 'account', path: '/account', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ci, null), component: AccountDetailsPage },
        { type: 'nav-body', id: 'users', path: '/users', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cj, null), component: UsersPage },
        { type: 'nav-body', id: 'allUsers', path: '/all-users', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cj, null), component: AllUsersPage },
        { type: 'nav-body', id: 'roles', path: '/roles', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ck, null), component: RolesPage },
        { type: 'nav-body', id: 'security', path: '/security', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cl, null), component: SecurityPage },
        { type: 'nav-body', id: 'sso', path: '/sso', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cm, null), component: MultipleSsoPage },
        { type: 'nav-body', id: 'audits', path: '/audits', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cn, null), component: AuditLogsPage },
        { type: 'nav-body', id: 'webhooks', path: '/webhooks', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.co, null), component: WebhooksPage },
        { type: 'nav-body', id: 'apiTokens', path: '/api-tokens', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cp, null), component: ApiTokensPage },
        { type: 'nav-body', id: 'subscriptions', path: '/subscriptions', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cq, null), component: SubscriptionPage },
        { type: 'app-route', id: 'login', path: '/account/login', component: LoginPage$1, publicRoute: true },
    ].filter((route) => {
        var _a;
        if (route.type === 'app-route') {
            return true;
        }
        const allMetadata = _frontegg_types__WEBPACK_IMPORTED_MODULE_4__.Metadata.getInstance(appName).navigation;
        const metadata = allMetadata[route.id];
        if (!metadata) {
            return false;
        }
        if (metadata.visibility === 'hidden') {
            return false;
        }
        if (metadata.featureFlag) {
            return false;
        }
        if ((vendorConfig === null || vendorConfig === void 0 ? void 0 : vendorConfig.forcePermissions) && metadata.visibility === 'byPermissions') {
            return hasPermission(...((_a = metadata.permissions) !== null && _a !== void 0 ? _a : []));
        }
        return true;
    });
};
const getPreviewModeRoutes = (appName) => {
    return [
        { type: 'nav-header', id: 'profile', path: '/', icon: { xl: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ce, null), default: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(UserAvatar, null) }, component: ProfilePage },
        { type: 'nav-header', id: 'privacy', path: '/privacy', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cf, null), component: PrivacyPage },
        { type: 'nav-header', id: 'personalApiTokens', path: '/personal-tokens', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cg, null), component: PersonalTokensPage },
        { type: 'nav-body', id: 'usage', path: '/usage', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ch, null), component: ProfilePage },
        { type: 'nav-body', id: 'account', path: '/account', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ci, null), component: AccountDetailsPage },
        { type: 'nav-body', id: 'users', path: '/users', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cj, null), component: UsersPage },
        { type: 'nav-body', id: 'allUsers', path: '/all-users', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cj, null), component: AllUsersPage },
        { type: 'nav-body', id: 'roles', path: '/roles', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ck, null), component: RolesPage },
        { type: 'nav-body', id: 'security', path: '/security', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cl, null), component: SecurityPage },
        { type: 'nav-body', id: 'sso', path: '/sso', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cm, null), component: MultipleSsoPage },
        { type: 'nav-body', id: 'audits', path: '/audits', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cn, null), component: AuditLogsPage },
        { type: 'nav-body', id: 'webhooks', path: '/webhooks', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.co, null), component: WebhooksPage },
        { type: 'nav-body', id: 'apiTokens', path: '/api-tokens', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cp, null), component: ApiTokensPage },
        { type: 'nav-body', id: 'subscriptions', path: '/subscriptions', icon: _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cq, null), component: SubscriptionPage },
        { type: 'app-route', id: 'login', path: '/account/login', component: LoginPage$1, publicRoute: true },
    ]
        .filter((route) => {
        const allMetadata = _frontegg_types__WEBPACK_IMPORTED_MODULE_4__.Metadata.getInstance(appName).navigation;
        const metadata = allMetadata[route.id];
        if (!metadata) {
            return false;
        }
        if (metadata.featureFlag) {
            return false;
        }
        return true;
    })
        .map((route) => {
        const allMetadata = _frontegg_types__WEBPACK_IMPORTED_MODULE_4__.Metadata.getInstance(appName).navigation;
        const metadata = allMetadata[route.id];
        if (metadata.visibility === 'hidden') {
            return Object.assign(Object.assign({}, route), { visibility: 'hidden' });
        }
        return route;
    });
};

const AppNavigation = () => {
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.X)();
    const t = useT('navigation');
    const history = useHistory();
    const { close } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(DrawerContext);
    const location = useLocation();
    const activeRoute = useRouteMatch(location.pathname);
    const { policy } = usePublicPolicySettings();
    const { tenants } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cd)();
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const isTenantReseller = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        var _a, _b;
        return (_b = (_a = tenants.find(({ tenantId }) => tenantId === (user === null || user === void 0 ? void 0 : user.tenantId))) === null || _a === void 0 ? void 0 : _a.isReseller) !== null && _b !== void 0 ? _b : false;
    }, [tenants, user]);
    const routes = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        return getRoutes(injector.name, user, policy);
    }, [injector.name, policy, user]);
    const isRouteActive = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((route) => {
        return route.path === (activeRoute === null || activeRoute === void 0 ? void 0 : activeRoute.path);
    }, [activeRoute]);
    const onNavigationClicked = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((path) => {
        history.push(path);
        close();
    }, [history, close]);
    const userInfo = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => user
        ? {
            name: getUserFullName(user),
            email: user.email,
            profilePictureUrl: user.profilePictureUrl,
        }
        : null, [user]);
    const tenantRoutes = routes.filter((route) => route.type === 'nav-body');
    const workspaceRoutes = tenantRoutes.filter((route) => route.id !== 'allUsers');
    const allAccountsRoutes = tenantRoutes.filter((route) => route.id === 'allUsers');
    const items = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        return [
            {
                items: routes
                    .filter((route) => route.type === 'nav-header')
                    .map((route) => (Object.assign(Object.assign({}, route), { title: t(route.id), selected: isRouteActive(route), id: route.id }))),
            },
            ...(tenantRoutes.length > 0
                ? [
                    {
                        title: t('workspace'),
                        items: workspaceRoutes.map((route) => (Object.assign(Object.assign({}, route), { title: t(route.id), selected: isRouteActive(route), id: route.id }))),
                    },
                    ...(isTenantReseller
                        ? [
                            {
                                title: t('allAccounts'),
                                items: allAccountsRoutes.map((route) => (Object.assign(Object.assign({}, route), { title: t(route.id), selected: isRouteActive(route), id: route.id }))),
                            },
                        ]
                        : []),
                ]
                : []),
        ];
    }, [routes, tenantRoutes, workspaceRoutes, allAccountsRoutes, t, isRouteActive, isTenantReseller]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cr, { user: userInfo, items: items, onRedirectTo: onNavigationClicked });
};
var AppNavigation$1 = AppNavigation;

const AppNavigationPreviewMode = () => {
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.X)();
    const t = useT('navigation');
    const history = useHistory();
    const { close } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(DrawerContext);
    const location = useLocation();
    const activeRoute = useRouteMatch(location.pathname);
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const previewRoutes = getPreviewModeRoutes(injector.name);
    const isRouteActive = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((route) => {
        return route.path === (activeRoute === null || activeRoute === void 0 ? void 0 : activeRoute.path);
    }, [activeRoute]);
    const onNavigationClicked = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useCallback((path) => {
        history.push(path);
        close();
    }, [history, close]);
    const userInfo = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => user
        ? {
            name: getUserFullName(user),
            email: user.email,
            profilePictureUrl: user.profilePictureUrl,
        }
        : null, [user]);
    const tenantPreviewRoutes = previewRoutes.filter((route) => route.type === 'nav-body');
    const workspaceRoutes = tenantPreviewRoutes.filter((route) => route.id !== 'allUsers');
    const allAccountsRoutes = tenantPreviewRoutes.filter((route) => route.id === 'allUsers');
    const isAllWorkspaceRouteHidden = tenantPreviewRoutes.every((item) => (item === null || item === void 0 ? void 0 : item.visibility) === 'hidden');
    const items = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => {
        return [
            {
                items: previewRoutes
                    .filter((route) => route.type === 'nav-header')
                    .map((route) => (Object.assign(Object.assign({}, route), { title: t(route.id), selected: isRouteActive(route), id: route.id }))),
            },
            ...(tenantPreviewRoutes.length > 0 && !isAllWorkspaceRouteHidden
                ? [
                    {
                        title: t('workspace'),
                        items: workspaceRoutes.map((route) => (Object.assign(Object.assign({}, route), { title: t(route.id), selected: isRouteActive(route), id: route.id }))),
                    },
                    {
                        title: t('allAccounts'),
                        items: allAccountsRoutes.map((route) => (Object.assign(Object.assign({}, route), { title: t(route.id), selected: isRouteActive(route), id: route.id }))),
                    },
                ]
                : []),
        ];
    }, [previewRoutes, tenantPreviewRoutes, workspaceRoutes, allAccountsRoutes, t, isRouteActive]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cr, { user: userInfo, items: items, onRedirectTo: onNavigationClicked });
};
var AppNavigationPreviewMode$1 = AppNavigationPreviewMode;

const ProtectedRoute = (props) => {
    const isAuthenticated = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.W)();
    if (isAuthenticated) {
        return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Route, Object.assign({}, props));
    }
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Redirect, { to: '/account/login' });
};
const RoutesLayout = () => {
    const user = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.X)();
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const { policy } = usePublicPolicySettings();
    const routes = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => getRoutes(injector.name, user, policy), [user, policy, injector.name]);
    usePreloadRoutes();
    const routesComponents = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => routes.map(({ path, exact, component, id, publicRoute }) => {
        const routeProps = { path, exact: exact !== null && exact !== void 0 ? exact : true, component };
        return publicRoute ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Route, Object.assign({ key: id }, routeProps)) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ProtectedRoute, Object.assign({ key: id }, routeProps));
    }), [routes]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Switch, null,
        routesComponents,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Redirect, { path: '*', to: routes[0].path }));
};
const RoutesLayoutPreviewMode = () => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const routes = getPreviewModeRoutes(injector.name);
    usePreloadRoutes();
    const routesComponents = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => routes.map(({ path, exact, component, id, publicRoute }) => {
        const routeProps = { path, exact: exact !== null && exact !== void 0 ? exact : true, component };
        return publicRoute ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Route, Object.assign({ key: id }, routeProps)) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(ProtectedRoute, Object.assign({ key: id }, routeProps));
    }), [routes]);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Switch, null,
        routesComponents,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Redirect, { path: '*', to: routes[0].path }));
};

const PageLayout = () => {
    const theme = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.F)();
    const { isLoading } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.J)(({ isLoading }) => ({ isLoading }));
    const { previewMode } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const displayAsDrawer = useMuiMediaQuery(theme.breakpoints.down('sm'));
    const { open } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(DrawerContext);
    const { closeAdminBox } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(AppDialogContext);
    const routesLayout = previewMode ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RoutesLayoutPreviewMode, null) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(RoutesLayout, null);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.B, { height: '100%', overflow: 'auto', display: 'flex', flexDirection: 'column' },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.cs, null,
            !isLoading && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ct, { onClose: closeAdminBox, openDrawer: displayAsDrawer ? open : undefined }),
            !isLoading && routesLayout));
};
var PageLayout$1 = PageLayout;

const LogoContainer = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.f)('div')(({ theme }) => ({
    position: 'absolute',
    padding: '1.5rem 0',
    boxSizing: 'border-box',
    bottom: 0,
    left: 0,
    right: 0,
    color: theme.palette.grey[700],
    fontSize: '0.75rem',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    background: theme.navigation.background,
    '& svg': {
        width: '4.625rem',
        marginLeft: '.5rem',
    },
}));
const PoweredByLogo = () => {
    const t = useT('navigation');
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(LogoContainer, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("span", null, t('poweredBy')),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.ak, { viewBox: '0 0 74 14' },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("mask", { id: "mask0", mask: "alpha", maskUnits: "userSpaceOnUse", x: "0", y: "0", width: "74", height: "14" },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M74 0H0V14H74V0Z", fill: "white" })),
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("g", { mask: "url(#mask0)" },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M16.516 11.0457V6.73371H15.6987V5.50009H16.516V4.72148C16.4789 4.05463 16.6813 3.39642 17.0869 2.86486C17.4628 2.41167 18.0293 2.15935 18.6188 2.18263C19.1567 2.18869 19.6864 2.3155 20.1684 2.55363L19.8444 3.76356C19.7087 3.69388 19.5655 3.6397 19.4176 3.60202C19.271 3.5608 19.1195 3.53872 18.9672 3.53633C18.4065 3.53633 18.1261 3.91163 18.1261 4.66225V5.50063H19.6612V6.73425H18.1261V11.0462L16.516 11.0457Z", fill: "#8B9DB8" }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M25.6353 6.15842C25.1836 6.15833 24.737 6.25434 24.3255 6.44003C23.9604 6.60051 23.666 6.88746 23.4969 7.24772V11.045H21.8867V4.76919H23.3646V6.11049C23.5618 5.7023 23.8518 5.34556 24.2115 5.06857C24.5232 4.81796 24.9103 4.6788 25.3107 4.67334C25.3993 4.67334 25.4652 4.67334 25.5089 4.67926C25.5513 4.68307 25.5935 4.689 25.6353 4.69703V6.15842Z", fill: "#8B9DB8" }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M30.4891 11.1653C30.0155 11.1727 29.5454 11.0829 29.108 10.9015C28.716 10.7377 28.3621 10.4952 28.0682 10.1891C27.7842 9.89014 27.5618 9.53853 27.4136 9.15419C27.1102 8.35625 27.1102 7.47522 27.4136 6.67727C27.5617 6.2924 27.7841 5.94023 28.0682 5.64073C28.3624 5.33496 28.7162 5.09251 29.108 4.92835C29.5454 4.74718 30.0155 4.65755 30.4891 4.66504C30.9612 4.65706 31.4299 4.74672 31.8654 4.92835C32.6437 5.25767 33.2533 5.88936 33.5534 6.67727C33.8575 7.47508 33.8575 8.35638 33.5534 9.15419C33.4061 9.53785 33.1861 9.8896 32.9052 10.1902C32.6135 10.4971 32.2604 10.7394 31.8687 10.9015C31.4311 11.0829 30.9608 11.1727 30.487 11.1653H30.4891ZM28.8439 7.9195C28.8404 8.17841 28.8832 8.43586 28.9703 8.67981C29.0485 8.89711 29.1666 9.09797 29.3187 9.27212C29.4636 9.4367 29.6415 9.56915 29.841 9.66089C30.2535 9.84417 30.7248 9.84417 31.1373 9.66089C31.3368 9.56915 31.5147 9.4367 31.6596 9.27212C31.8128 9.09617 31.9311 8.89279 32.008 8.67281C32.0948 8.42673 32.1375 8.16739 32.1344 7.90658C32.1367 7.64987 32.0939 7.39475 32.008 7.15273C31.9312 6.93287 31.8129 6.72965 31.6596 6.55396C31.5149 6.3891 31.3369 6.25646 31.1373 6.16466C30.9339 6.07232 30.7127 6.02528 30.4891 6.02681C30.265 6.02515 30.0433 6.07432 29.841 6.17058C29.6419 6.26581 29.4642 6.40026 29.3187 6.56581C29.1655 6.74181 29.0473 6.94518 28.9703 7.16512C28.8843 7.4071 28.8415 7.66225 28.8439 7.91896", fill: "#8B9DB8" }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M41.8919 11.0458H40.2818V7.52423C40.3123 7.13836 40.2197 6.75274 40.0171 6.42254C39.8456 6.19311 39.5714 6.06309 39.2846 6.07523C39.1159 6.07673 38.9489 6.10922 38.792 6.17108C38.6209 6.23617 38.4608 6.32696 38.3172 6.44031C38.1654 6.55965 38.0301 6.69853 37.9148 6.85331C37.7953 7.01157 37.7056 7.1902 37.6502 7.38047V11.0458H36.0405V4.76947H37.4946V5.93147C37.7311 5.52762 38.0821 5.20256 38.5036 4.99723C38.9662 4.76857 39.477 4.65355 39.9933 4.66177C40.3272 4.64801 40.6589 4.72231 40.9548 4.87716C41.1927 5.01105 41.3914 5.20466 41.5311 5.43877C41.6721 5.68322 41.7678 5.95098 41.8136 6.22923C41.8657 6.52579 41.8919 6.82631 41.8919 7.12739V11.0458Z", fill: "#8B9DB8" }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M48.2354 10.7221C47.9751 10.8336 47.7084 10.9295 47.4365 11.0091C47.1152 11.106 46.7811 11.1547 46.4454 11.1534C46.2322 11.1546 46.0199 11.1263 45.8145 11.0694C45.6252 11.0171 45.4491 10.9254 45.2981 10.8001C45.1443 10.6699 45.0228 10.5058 44.9432 10.3209C44.849 10.0953 44.8039 9.85228 44.8109 9.60799V6.00029H43.9937V4.76937H44.8109V2.73291H46.4211V4.76937H47.7547V6.00299H46.4211V9.06899C46.402 9.24641 46.4691 9.42223 46.6015 9.54229C46.7259 9.63527 46.8782 9.68365 47.0336 9.6796C47.2015 9.67986 47.3683 9.65164 47.5267 9.59614C47.6861 9.54229 47.8152 9.49222 47.9108 9.45237L48.2354 10.7221Z", fill: "#8B9DB8" }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M53.1735 11.1651C52.704 11.1717 52.238 11.0842 51.8032 10.9077C51.4111 10.7468 51.0556 10.5087 50.758 10.2077C50.4692 9.91194 50.2426 9.56175 50.0914 9.17759C49.9347 8.78517 49.8551 8.36636 49.857 7.94398C49.8542 7.51244 49.9317 7.08413 50.0855 6.68075C50.2329 6.29252 50.4574 5.93795 50.7455 5.63829C51.0442 5.3324 51.402 5.09006 51.7972 4.9259C52.237 4.74503 52.7092 4.65544 53.1848 4.66259C53.6568 4.65466 54.1252 4.74431 54.5606 4.9259C54.9488 5.09036 55.3002 5.33056 55.5939 5.63236C55.8782 5.92827 56.0987 6.27899 56.2421 6.66298C56.3904 7.05311 56.4658 7.46701 56.4646 7.88421C56.4646 7.98813 56.4646 8.08775 56.4587 8.18359C56.4565 8.26426 56.4464 8.34452 56.4284 8.42321H51.5628C51.5817 8.65193 51.6429 8.87519 51.7432 9.08175C51.9257 9.45269 52.2439 9.73981 52.6323 9.88406C52.8243 9.956 53.0278 9.99249 53.2329 9.99175C53.5505 9.99243 53.8629 9.91197 54.1404 9.75806C54.4013 9.62723 54.6077 9.40894 54.7232 9.14152L56.1043 9.52436C55.8588 10.0184 55.4723 10.4291 54.9933 10.7047C54.4411 11.0231 53.8112 11.1827 53.1735 11.1656V11.1651ZM54.8069 7.38075C54.7859 6.9506 54.5985 6.5453 54.284 6.24998C53.9796 5.96781 53.5767 5.8152 53.1611 5.82459C52.9533 5.8232 52.7471 5.86177 52.554 5.93821C52.3692 6.01193 52.2001 6.11971 52.0554 6.2559C51.9081 6.39653 51.7879 6.563 51.7011 6.74698C51.6067 6.94629 51.5517 7.16181 51.539 7.38182L54.8069 7.38075Z", fill: "#ADBCD2" }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M61.1155 11.0814C60.7188 11.086 60.3264 11 59.9682 10.8299C59.6243 10.6663 59.3192 10.4315 59.0732 10.1412C58.82 9.84216 58.6246 9.49893 58.4969 9.1289C58.3586 8.73642 58.2891 8.32312 58.2916 7.90713C58.288 7.47451 58.3611 7.04465 58.5077 6.63744C58.6441 6.26089 58.8478 5.91208 59.1089 5.6079C59.6336 4.99625 60.4044 4.64946 61.2117 4.66182C61.6658 4.65112 62.1143 4.76492 62.508 4.99082C62.8756 5.20775 63.186 5.50902 63.4133 5.86959V4.76952H64.8177V10.7464C64.8249 11.1754 64.7369 11.6007 64.56 11.9919C64.3903 12.353 64.1413 12.6713 63.8314 12.9234C63.5032 13.187 63.1278 13.3862 62.7252 13.5104C62.2742 13.6496 61.8042 13.718 61.3321 13.7134C60.7311 13.7329 60.1335 13.6164 59.5842 13.3725C59.1148 13.1444 58.7022 12.815 58.3764 12.4081L59.2536 11.5579C59.4978 11.8562 59.8081 12.094 60.16 12.2525C60.5276 12.4208 60.9277 12.5066 61.3321 12.504C61.5738 12.505 61.8144 12.4707 62.0462 12.4022C62.2663 12.339 62.4709 12.2308 62.6468 12.0845C62.824 11.9351 62.9639 11.7467 63.0557 11.5342C63.1615 11.2841 63.2131 11.0146 63.207 10.7432V9.95544C63.0014 10.3116 62.6967 10.6007 62.3298 10.7879C61.955 10.9828 61.5382 11.0835 61.1155 11.0814ZM61.6686 9.79983C61.8404 9.8005 62.0109 9.77209 62.1731 9.71582C62.3295 9.66179 62.4771 9.58523 62.6112 9.48859C62.7434 9.39258 62.8625 9.27981 62.9655 9.15313C63.0666 9.03049 63.1481 8.89299 63.207 8.74552V7.24859C63.0722 6.89493 62.8385 6.5873 62.5334 6.36229C62.2584 6.14889 61.9209 6.03108 61.5725 6.02682C61.3361 6.0239 61.1026 6.0794 60.893 6.18836C60.6912 6.2947 60.5136 6.44134 60.3712 6.61913C60.2245 6.80318 60.1124 7.01227 60.0406 7.23621C59.9639 7.46795 59.9251 7.71048 59.9256 7.95452C59.9235 8.20039 59.9686 8.44439 60.0585 8.67336C60.1423 8.89028 60.2666 9.08942 60.4247 9.26028C60.5804 9.42765 60.7683 9.56206 60.9772 9.65552C61.1946 9.75247 61.4305 9.80151 61.6686 9.79929", fill: "#ADBCD2" }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M69.9231 11.0814C69.5265 11.086 69.134 11 68.7759 10.8299C68.4317 10.6663 68.1264 10.4315 67.8803 10.1412C67.6275 9.84191 67.4321 9.49875 67.304 9.12891C67.1658 8.73639 67.0966 8.32309 67.0993 7.90714C67.0956 7.47452 67.1687 7.04466 67.3153 6.63745C67.4515 6.2608 67.6552 5.91195 67.9165 5.60791C68.4411 4.99634 69.2117 4.64955 70.0187 4.66183C70.4729 4.65107 70.9213 4.76488 71.3151 4.99083C71.6819 5.20803 71.9915 5.50928 72.2182 5.8696V4.76952H73.6226V10.7464C73.6296 11.1755 73.5415 11.6008 73.3644 11.9919C73.1956 12.3528 72.9475 12.6712 72.6384 12.9234C72.3105 13.1872 71.9353 13.3863 71.5328 13.5104C71.0816 13.6496 70.6115 13.7181 70.1392 13.7134C69.5382 13.7328 68.9406 13.6163 68.3913 13.3725C67.922 13.1443 67.5094 12.8149 67.1835 12.4081L68.0591 11.5606C68.3035 11.8589 68.6139 12.0967 68.966 12.2552C69.3334 12.4234 69.7333 12.5093 70.1376 12.5067C70.3795 12.5076 70.6202 12.4733 70.8522 12.4049C71.0723 12.3417 71.2769 12.2335 71.4528 12.0872C71.63 11.9378 71.7699 11.7494 71.8617 11.5369C71.9673 11.2868 72.0187 11.0172 72.0124 10.7459V9.95545C71.8068 10.3116 71.5022 10.6007 71.1352 10.7879C70.7607 10.9829 70.344 11.0836 69.9215 11.0814H69.9231ZM70.4741 9.79984C70.646 9.80054 70.8168 9.77214 70.9791 9.71583C71.1354 9.66168 71.283 9.58514 71.4172 9.4886C71.5493 9.39244 71.6684 9.27969 71.7715 9.15314C71.8726 9.03061 71.9539 8.89308 72.0124 8.74552V7.2486C71.8781 6.89488 71.6444 6.58718 71.3394 6.36229C71.0642 6.14886 70.7266 6.03104 70.3779 6.02683C70.1417 6.02391 69.9084 6.07941 69.699 6.18837C69.4971 6.2947 69.3193 6.44133 69.1767 6.61914C69.0301 6.80332 68.9181 7.01237 68.8461 7.23621C68.7698 7.46805 68.7311 7.71054 68.7316 7.95452C68.7295 8.20039 68.7746 8.4444 68.8644 8.67337C68.9481 8.89026 69.0722 9.08941 69.2301 9.26029C69.3861 9.42767 69.5742 9.56207 69.7832 9.65552C70.0004 9.75248 70.2361 9.80153 70.4741 9.79929", fill: "#ADBCD2" }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M7.44386 1.49391C6.1648 0.107906 4.78202 -0.194171 3.39925 0.790137C2.41553 1.54874 1.64 2.54281 1.14468 3.68006C0.845721 4.30682 0.618683 4.96522 0.467877 5.64275C0.301835 6.38025 0.246138 7.13817 0.302592 7.89191C0.374127 9.24676 0.988291 10.5163 2.00729 11.4156C2.14052 11.5254 2.28051 11.6269 2.42645 11.7193C3.57731 12.3987 4.95184 12.5943 6.24744 12.2631C7.41559 11.9902 8.42156 11.2542 9.03297 10.2251C9.34465 9.67961 9.55507 9.08259 9.65414 8.46268C10.1403 5.5916 8.72293 2.88368 7.44386 1.49606V1.49391ZM4.35153 1.66406C3.03303 2.48844 2.47452 4.12752 2.31626 4.69021C2.28566 4.79969 2.17501 4.86663 2.06347 4.84314C2.00468 4.83116 1.95354 4.79535 1.92229 4.74428C1.89104 4.69322 1.88251 4.6315 1.89872 4.57391C2.01392 4.16654 2.16503 3.77012 2.35029 3.38929C2.73396 2.5402 3.34867 1.8153 4.12467 1.29683C4.19047 1.25643 4.2729 1.2541 4.34089 1.29071C4.40889 1.32732 4.45213 1.39731 4.45432 1.47432C4.45652 1.55133 4.41733 1.62366 4.35153 1.66406Z", fill: "#8B9DB8" }),
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement("path", { d: "M6.06104 13.2896C7.697 14.037 9.61721 13.7896 11.0088 12.6521C13.3508 10.7017 13.9996 6.71767 13.9996 6.71767C13.9996 6.71767 14.4133 4.65375 13.6517 3.46267C12.8901 2.27159 11.0088 2.28183 9.28733 2.87036C10.0566 4.43482 10.4802 6.1456 10.5297 7.88721C10.5079 10.5137 8.64445 12.7664 6.06212 13.288", fill: "#ADBCD2" }))));
};

const AppContent = () => {
    const { isLoading, isAuthenticated } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.J)(({ isLoading, isAuthenticated, tenantsState: { loading, tenants } }) => ({
        isLoading: isLoading || (loading && tenants.length === 0),
        isAuthenticated,
    }));
    const { showPoweredByLogo } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.aj)(({ whiteLabelMode }) => ({ showPoweredByLogo: !whiteLabelMode }));
    const { injector, basename = '', urlStrategy, setStaticRouteSetter, staticRoute, previewMode } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    const theme = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.F)();
    const displayAsDrawer = useMuiMediaQuery(theme.breakpoints.down('sm'));
    const history = useHistory();
    const [route, setRoute] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(staticRoute);
    setStaticRouteSetter === null || setStaticRouteSetter === void 0 ? void 0 : setStaticRouteSetter(setRoute);
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (route) {
            history.push(route);
        }
    }, [route, history]);
    const { closeAdminBox } = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useContext(AppDialogContext);
    const { loading: loadingPolicy } = usePublicPolicySettings();
    const [drawerOpened, setDrawerOpened] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState(false);
    const drawerContextValue = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useMemo(() => ({
        opened: drawerOpened,
        close: () => setDrawerOpened(false),
        open: () => setDrawerOpened(true),
    }), [drawerOpened, setDrawerOpened]);
    const routes = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.K)();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        if (!isLoading && !isAuthenticated) {
            const calculatedBasename = basename.endsWith('/') ? basename.substring(0, basename.length - 1) : '';
            if (injector) {
                closeAdminBox();
            }
            const path = calculatedBasename + routes.loginUrl;
            if (urlStrategy === 'path' && injector) {
                window.location.href = path;
            }
            else {
                window.location.hash = `#${path}`;
            }
        }
    }, [isLoading, isAuthenticated, routes, injector, urlStrategy, basename, closeAdminBox]);
    const appNavigation = previewMode ? _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AppNavigationPreviewMode$1, null) : _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AppNavigation$1, null);
    let navigationComponent = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.c9, { in: !isLoading },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(NavigationGridItem, { withPoweredBy: showPoweredByLogo },
            appNavigation,
            showPoweredByLogo && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PoweredByLogo, null)));
    if (displayAsDrawer) {
        navigationComponent = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(Drawer$1, { sx: { zIndex: '1300' }, open: drawerOpened, container: injector === null || injector === void 0 ? void 0 : injector.adminPortalEl, onBackdropClick: drawerContextValue.close },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { height: "100%", container: true, alignItems: "stretch", wrap: "nowrap", position: "relative" },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(NavigationGridItem, null,
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DrawerContext.Provider, { value: drawerContextValue }, appNavigation),
                    showPoweredByLogo && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PoweredByLogo, null))));
    }
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.Fragment, null,
        (isLoading || loadingPolicy) && _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AppSkeleton, { absolute: true }),
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.G, { height: "100%", container: true, alignItems: "stretch", wrap: "nowrap" },
            navigationComponent,
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageGridItem, { item: true, xs: true },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(DrawerContext.Provider, { value: drawerContextValue },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(PageLayout$1, null)))));
};
const AppLayout = () => {
    const { injector } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.P, { context: _formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.N, store: injector.store },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(HashRouter, { basename: "admin-box" },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AppContent, null)));
};
var AppLayout$1 = AppLayout;

const App = () => {
    const { isShadowDom } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.v)();
    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useEffect(() => {
        document.addEventListener('focus', shadowFocusHandler, true);
        const oldDocumentBodyOverflow = document.body.style.overflow;
        document.body.style.overflow = 'hidden';
        return () => {
            document.removeEventListener('focus', shadowFocusHandler, true);
            document.body.style.overflow = oldDocumentBodyOverflow;
            window.history.pushState('', document.title, window.location.pathname);
        };
    }, []);
    const { calculatedTheme, theme, overrides } = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.w)(true);
    return _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.x, null,
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.y, { theme: calculatedTheme, isShadowDom: isShadowDom },
            _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.z.Provider, { value: { theme, overrides } },
                _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.E, { themeOptionKey: 'adminPortal' },
                    _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AppDialog, null,
                        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(AppLayout$1, null))))));
};
var App$1 = App;

const defaultTheme = 'modern';
const AdminPortal = ({ injector, options }) => {
    var _a, _b;
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.S.Provider, { value: Object.assign(Object.assign({ iframeRendering: false }, options), { themeOptions: (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bE)((_a = options.metadata) !== null && _a !== void 0 ? _a : {}, (_b = options.themeOptions) !== null && _b !== void 0 ? _b : {}), injector, slotsContainer: injector.adminPortalContainer, rootEl: injector.adminPortalEl }) },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(App$1, null)));
};
const AdminPortalPage = ({ injector, options, setThemeSetter, staticRoute, setStaticRouteSetter, }) => {
    var _a, _b;
    const [themeOptions, setThemeOptions] = _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.r.exports.useState((0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bE)((_a = options === null || options === void 0 ? void 0 : options.metadata) !== null && _a !== void 0 ? _a : {}, (_b = options.themeOptions) !== null && _b !== void 0 ? _b : {}));
    const setTheme = (theme) => {
        var _a;
        const enhancedTheme = (0,_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.bE)((_a = options === null || options === void 0 ? void 0 : options.metadata) !== null && _a !== void 0 ? _a : {}, theme !== null && theme !== void 0 ? theme : {});
        setThemeOptions(enhancedTheme);
    };
    setThemeSetter === null || setThemeSetter === void 0 ? void 0 : setThemeSetter(setTheme);
    return (_FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(_formik_esm_baae0afb_js__WEBPACK_IMPORTED_MODULE_1__.S.Provider, { value: Object.assign(Object.assign({ iframeRendering: false }, options), { injector,
            themeOptions, slotsContainer: injector.adminPortalContainer, rootEl: injector.adminPortalEl, staticRoute,
            setStaticRouteSetter }) },
        _FronteggApp_35f1a2b2_js__WEBPACK_IMPORTED_MODULE_0__.R.createElement(App$1, null)));
};




/***/ }),

/***/ 51261:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "LoginBox": function() { return /* binding */ LoginBox; },
  "LoginBoxPage": function() { return /* binding */ LoginBoxPage; },
  "default": function() { return /* binding */ LoginBox; },
  "defaultTheme": function() { return /* binding */ defaultTheme; }
});

// EXTERNAL MODULE: ./node_modules/@frontegg/admin-portal/FronteggApp-35f1a2b2.js
var FronteggApp_35f1a2b2 = __webpack_require__(11277);
// EXTERNAL MODULE: ./node_modules/@frontegg/admin-portal/formik.esm-baae0afb.js
var formik_esm_baae0afb = __webpack_require__(25618);
// EXTERNAL MODULE: ./node_modules/@frontegg/rest-api/dist/umd/index.js
var umd = __webpack_require__(32205);
;// CONCATENATED MODULE: ./node_modules/@frontegg/admin-portal/node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/@frontegg/admin-portal/node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ./node_modules/@frontegg/admin-portal/node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
;// CONCATENATED MODULE: ./node_modules/@frontegg/admin-portal/node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify);
;// CONCATENATED MODULE: ./node_modules/@frontegg/admin-portal/node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);
// EXTERNAL MODULE: ./node_modules/@frontegg/redux-store/index.js + 28 modules
var redux_store = __webpack_require__(5850);
// EXTERNAL MODULE: ./node_modules/@frontegg/types/index.js
var types = __webpack_require__(36539);
// EXTERNAL MODULE: ./node_modules/@frontegg/admin-portal/AppHolder.js
var AppHolder = __webpack_require__(15501);
;// CONCATENATED MODULE: ./node_modules/@frontegg/admin-portal/index-861a4b16.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(83454);









var styleFunctionSx = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': formik_esm_baae0afb.s,
    extendSxProp: formik_esm_baae0afb.e
});

var createTheme = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': formik_esm_baae0afb.c
});

var dist=function(e){var t={};function n(r){if(t[r])return t[r].exports;var o=t[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,n),o.l=!0,o.exports}return n.m=e,n.c=t,n.d=function(e,t,r){n.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:r});},n.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});},n.t=function(e,t){if(1&t&&(e=n(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)n.d(r,o,function(t){return e[t]}.bind(null,o));return r},n.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return n.d(t,"a",t),t},n.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},n.p="",n(n.s=2)}([function(e,t){e.exports=FronteggApp_35f1a2b2.r.exports;},function(e,t){e.exports=formik_esm_baae0afb.p.exports;},function(e,t,n){n.r(t),n.d(t,"ReCaptcha",(function(){return v})),n.d(t,"loadReCaptcha",(function(){return h}));var r=n(0),o=n.n(r);n(1);function a(e){return (a="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function c(e,t){for(var n=0;n<t.length;n++){var r=t[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r);}}function u(e,t){return (u=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function i(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(e){return !1}}();return function(){var n,r=p(e);if(t){var o=p(this).constructor;n=Reflect.construct(r,arguments,o);}else n=r.apply(this,arguments);return f(this,n)}}function f(e,t){return !t||"object"!==a(t)&&"function"!=typeof t?l(e):t}function l(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function p(e){return (p=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function s(e,t,n){return t in e?Object.defineProperty(e,t,{value:n,enumerable:!0,configurable:!0,writable:!0}):e[t]=n,e}var d,y=function(){return "undefined"!=typeof window&&void 0!==window.grecaptcha&&void 0!==window.grecaptcha.execute},b=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&u(e,t);}(f,e);var t,n,a=i(f);function f(e){var t;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,f),s(l(t=a.call(this,e)),"execute",(function(){var e=t.props,n=e.sitekey,r=e.verifyCallback,o=e.action;t.state.ready&&window.grecaptcha.execute(n,{action:o}).then((function(e){void 0!==r&&r(e);}));})),s(l(t),"_updateReadyState",(function(){y()&&(t.setState((function(){return {ready:!0}})),clearInterval(d));})),t.state={ready:y()},t}return t=f,(n=[{key:"componentDidMount",value:function(){this.state.ready?this.execute():d=setInterval(this._updateReadyState,1e3);}},{key:"componentDidUpdate",value:function(e,t){this.state.ready&&!t.ready&&this.execute();}},{key:"componentWillUnmount",value:function(){clearInterval(d);}},{key:"render",value:function(){return this.state.ready?o.a.createElement("div",{id:this.props.elementID,"data-verifycallbackname":this.props.verifyCallbackName}):o.a.createElement("div",{id:this.props.elementID,className:"g-recaptcha"})}}])&&c(t.prototype,n),f}(r.Component);b.defaultProps={elementID:"g-recaptcha",verifyCallbackName:"verifyCallback"};var v=b,h=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:function(){},n=document.createElement("script");!window.onLoadCaptchaV3Callback&&t&&(window.onLoadCaptchaV3Callback=t),n.src="https://www.recaptcha.net/recaptcha/api.js?onload=onLoadCaptchaV3Callback&render=".concat(e),document.body.appendChild(n);};}]);

/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));

/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function forget(promise) {
    void promise.then(null, function (e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}

/**
 * This module mostly exists for optimizations in the build process
 * through rollup and terser.  We define some global constants which
 * are normally undefined.  However terser overrides these with global
 * definitions which can be evaluated by the static analyzer when
 * creating a bundle.
 *
 * In turn the `isDebugBuild` and `isBrowserBundle` functions are pure
 * and can help us remove unused code from the bundles.
 */
/**
 * Figures out if we're building with debug functionality.
 *
 * @returns true if this is a debug build
 */
function isDebugBuild() {
    return typeof __SENTRY_NO_DEBUG__ !== 'undefined' && !__SENTRY_BROWSER_BUNDLE__;
}
/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */
/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return (!isBrowserBundle() &&
        Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]');
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    }
    catch (e) {
        // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    }
    catch (e) {
        // no-empty
    }
    return mod;
}

/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */
var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
    return (isNodeEnv()
        ? __webpack_require__.g
        : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
            ? window // eslint-disable-line no-restricted-globals
            : typeof self !== 'undefined'
                ? self
                : fallbackGlobalObject);
}

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable-next-line @typescript-eslint/unbound-method
var objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (objectToString.call(wat)) {
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
function isBuiltin(wat, ty) {
    return objectToString.call(wat) === "[object " + ty + "]";
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return isBuiltin(wat, 'String');
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    }
    catch (_e) {
        return false;
    }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
                break;
            }
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length
        ? keyAttrs.filter(function (keyAttr) { return elem.getAttribute(keyAttr); }).map(function (keyAttr) { return [keyAttr, elem.getAttribute(keyAttr)]; })
        : null;
    if (keyAttrPairs && keyAttrPairs.length) {
        keyAttrPairs.forEach(function (keyAttrPair) {
            out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
        });
    }
    else {
        if (elem.id) {
            out.push("#" + elem.id);
        }
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && isString(className)) {
            classes = className.split(/\s+/);
            for (i = 0; i < classes.length; i++) {
                out.push("." + classes[i]);
            }
        }
    }
    var allowedAttrs = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < allowedAttrs.length; i++) {
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */
function getLocationHref() {
    var global = getGlobalObject();
    try {
        return global.document.location.href;
    }
    catch (oO) {
        return '';
    }
}

var setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function mixinProperties(obj, proto) {
    for (var prop in proto) {
        if (!Object.prototype.hasOwnProperty.call(obj, prop)) {
            // @ts-ignore typescript complains about indexing so we remove
            obj[prop] = proto[prop];
        }
    }
    return obj;
}

/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /** @class */ (function (_super) {
    (0,FronteggApp_35f1a2b2._)(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error));

/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsnToString(dsn, withPassword) {
    if (withPassword === void 0) { withPassword = false; }
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return (protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') +
        ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
}
function dsnFromString(str) {
    var match = DSN_REGEX.exec(str);
    if (!match) {
        throw new SentryError("Invalid Sentry Dsn: " + str);
    }
    var _a = (0,FronteggApp_35f1a2b2.b)(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) {
            projectId = projectMatch[0];
        }
    }
    return dsnFromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, publicKey: publicKey });
}
function dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) {
        components.publicKey = components.user;
    }
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId,
    };
}
function validateDsn(dsn) {
    if (!isDebugBuild()) {
        return;
    }
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
    requiredComponents.forEach(function (component) {
        if (!dsn[component]) {
            throw new SentryError("Invalid Sentry Dsn: " + component + " missing");
        }
    });
    if (!projectId.match(/^\d+$/)) {
        throw new SentryError("Invalid Sentry Dsn: Invalid projectId " + projectId);
    }
    if (!isValidProtocol(protocol)) {
        throw new SentryError("Invalid Sentry Dsn: Invalid protocol " + protocol);
    }
    if (port && isNaN(parseInt(port, 10))) {
        throw new SentryError("Invalid Sentry Dsn: Invalid port " + port);
    }
    return true;
}
/** The Sentry Dsn, identifying a Sentry instance and project. */
function makeDsn(from) {
    var components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
    validateDsn(components);
    return components;
}

var SeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical'];

// TODO: Implement different loggers for different environments
var global$a = getGlobalObject();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
/**
 * Temporarily unwrap `console.log` and friends in order to perform the given callback using the original methods.
 * Restores wrapping after the callback completes.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
    var global = getGlobalObject();
    var levels = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
    if (!('console' in global)) {
        return callback();
    }
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    levels.forEach(function (level) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        if (level in global.console && originalConsole[level].__sentry_original__) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalConsole[level].__sentry_original__;
        }
    });
    // Perform callback manipulations
    var result = callback();
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(function (level) {
        originalConsole[level] = wrappedLevels[level];
    });
    return result;
}
/** JSDoc */
var Logger = /** @class */ (function () {
    /** JSDoc */
    function Logger() {
        this._enabled = false;
    }
    /** JSDoc */
    Logger.prototype.disable = function () {
        this._enabled = false;
    };
    /** JSDoc */
    Logger.prototype.enable = function () {
        this._enabled = true;
    };
    /** JSDoc */
    Logger.prototype.log = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        consoleSandbox(function () {
            global$a.console.log(PREFIX + "[Log]: " + args.join(' '));
        });
    };
    /** JSDoc */
    Logger.prototype.warn = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        consoleSandbox(function () {
            global$a.console.warn(PREFIX + "[Warn]: " + args.join(' '));
        });
    };
    /** JSDoc */
    Logger.prototype.error = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (!this._enabled) {
            return;
        }
        consoleSandbox(function () {
            global$a.console.error(PREFIX + "[Error]: " + args.join(' '));
        });
    };
    return Logger;
}());
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
global$a.__SENTRY__ = global$a.__SENTRY__ || {};
var logger = global$a.__SENTRY__.logger || (global$a.__SENTRY__.logger = new Logger());

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Helper to decycle json objects
 */
function memoBuilder() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) {
                return true;
            }
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (var i = 0; i < inner.length; i++) {
            var value = inner[i];
            if (value === obj) {
                return true;
            }
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) {
            inner.delete(obj);
        }
        else {
            for (var i = 0; i < inner.length; i++) {
                if (inner[i] === obj) {
                    inner.splice(i, 1);
                    break;
                }
            }
        }
    }
    return [memoize, unmemoize];
}

var STACKTRACE_LIMIT = 50;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 * */
function createStackParser() {
    var parsers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parsers[_i] = arguments[_i];
    }
    return function (stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) { skipFirst = 0; }
        var frames = [];
        try {
            for (var _c = (0,FronteggApp_35f1a2b2.c)(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var line = _d.value;
                try {
                    for (var parsers_1 = (e_2 = void 0, (0,FronteggApp_35f1a2b2.c)(parsers)), parsers_1_1 = parsers_1.next(); !parsers_1_1.done; parsers_1_1 = parsers_1.next()) {
                        var parser = parsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (parsers_1_1 && !parsers_1_1.done && (_b = parsers_1.return)) _b.call(parsers_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return stripSentryFramesAndReverse(frames);
    };
}
/**
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
    if (!stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack
        .slice(0, STACKTRACE_LIMIT)
        .map(function (frame) { return ((0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, frame), { filename: frame.filename || localStack[0].filename, function: frame.function || '?' })); })
        .reverse();
}
var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') {
            return defaultFunctionName;
        }
        return fn.name || defaultFunctionName;
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    if (typeof str !== 'string' || max === 0) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
    if (!isString(value)) {
        return false;
    }
    if (isRegExp(pattern)) {
        return pattern.test(value);
    }
    if (typeof pattern === 'string') {
        return value.indexOf(pattern) !== -1;
    }
    return false;
}

/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') {
        try {
            markFunctionWrapped(wrapped, original);
        }
        catch (_Oo) {
            // This can throw if multiple fill happens on a global object like XMLHttpRequest
            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true,
    });
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
/**
 * Transforms any object into an object literal with all its attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 */
function getWalkSource(value) {
    if (isError(value)) {
        var error = value;
        var err = {
            message: error.message,
            name: error.name,
            stack: error.stack,
        };
        for (var i in error) {
            if (Object.prototype.hasOwnProperty.call(error, i)) {
                err[i] = error[i];
            }
        }
        return err;
    }
    if (isEvent(value)) {
        var event_1 = value;
        var source = {};
        // Accessing event attributes can throw (see https://github.com/getsentry/sentry-javascript/issues/768 and
        // https://github.com/getsentry/sentry-javascript/issues/838), but accessing `type` hasn't been wrapped in a
        // try-catch in at least two years and no one's complained, so that's likely not an issue anymore
        source.type = event_1.type;
        try {
            source.target = isElement(event_1.target)
                ? htmlTreeAsString(event_1.target)
                : Object.prototype.toString.call(event_1.target);
        }
        catch (_oO) {
            source.target = '<unknown>';
        }
        try {
            source.currentTarget = isElement(event_1.currentTarget)
                ? htmlTreeAsString(event_1.currentTarget)
                : Object.prototype.toString.call(event_1.currentTarget);
        }
        catch (_oO) {
            source.currentTarget = '<unknown>';
        }
        if (typeof CustomEvent !== 'undefined' && isInstanceOf(value, CustomEvent)) {
            source.detail = event_1.detail;
        }
        for (var attr in event_1) {
            if (Object.prototype.hasOwnProperty.call(event_1, attr)) {
                source[attr] = event_1[attr];
            }
        }
        return source;
    }
    return value;
}
/** Calculates bytes size of input string */
function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}
/** JSDoc */
function normalizeToSize(object, 
// Default Node.js REPL depth
depth, 
// 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) { depth = 3; }
    if (maxSize === void 0) { maxSize = 100 * 1024; }
    var serialized = normalize(object, depth);
    if (jsonSize(serialized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return serialized;
}
/**
 * Transform any non-primitive, BigInt, or Symbol-type value into a string. Acts as a no-op on strings, numbers,
 * booleans, null, and undefined.
 *
 * @param value The value to stringify
 * @returns For non-primitive, BigInt, and Symbol-type values, a string denoting the value's type, type and value, or
 *  type and `description` property, respectively. For non-BigInt, non-Symbol primitives, returns the original value,
 *  unchanged.
 */
function serializeValue(value) {
    // Node.js REPL notation
    if (typeof value === 'string') {
        return value;
    }
    var type = Object.prototype.toString.call(value);
    if (type === '[object Object]') {
        return '[Object]';
    }
    if (type === '[object Array]') {
        return '[Array]';
    }
    var normalized = normalizeValue(value);
    return isPrimitive(normalized) ? normalized : type;
}
/**
 * normalizeValue()
 *
 * Takes unserializable input and make it serializable friendly
 *
 * - translates undefined/NaN values to "[undefined]"/"[NaN]" respectively,
 * - serializes Error objects
 * - filter global objects
 */
function normalizeValue(value, key) {
    if (key === 'domain' && value && typeof value === 'object' && value._events) {
        return '[Domain]';
    }
    if (key === 'domainEmitter') {
        return '[DomainEmitter]';
    }
    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
        return '[Global]';
    }
    // It's safe to use `window` and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.
    // eslint-disable-next-line no-restricted-globals
    if (typeof window !== 'undefined' && value === window) {
        return '[Window]';
    }
    // eslint-disable-next-line no-restricted-globals
    if (typeof document !== 'undefined' && value === document) {
        return '[Document]';
    }
    // React's SyntheticEvent thingy
    if (isSyntheticEvent(value)) {
        return '[SyntheticEvent]';
    }
    if (typeof value === 'number' && value !== value) {
        return '[NaN]';
    }
    if (value === void 0) {
        return '[undefined]';
    }
    if (typeof value === 'function') {
        return "[Function: " + getFunctionName(value) + "]";
    }
    // symbols and bigints are considered primitives by TS, but aren't natively JSON-serilaizable
    if (typeof value === 'symbol') {
        return "[" + String(value) + "]";
    }
    if (typeof value === 'bigint') {
        return "[BigInt: " + String(value) + "]";
    }
    return value;
}
/**
 * Walks an object to perform a normalization on it
 *
 * @param key of object that's walked in current iteration
 * @param value object to be walked
 * @param depth Optional number indicating how deep should walking be performed
 * @param memo Optional Memo class handling decycling
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function walk(key, value, depth, memo) {
    if (depth === void 0) { depth = +Infinity; }
    if (memo === void 0) { memo = memoBuilder(); }
    // If we reach the maximum depth, serialize whatever is left
    if (depth === 0) {
        return serializeValue(value);
    }
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // If value implements `toJSON` method, call it and return early
    if (value !== null && value !== undefined && typeof value.toJSON === 'function') {
        return value.toJSON();
    }
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    // If normalized value is a primitive, there are no branches left to walk, so bail out
    var normalized = normalizeValue(value, key);
    if (isPrimitive(normalized)) {
        return normalized;
    }
    // Create source that we will use for the next iteration. It will either be an objectified error object (`Error` type
    // with extracted key:value pairs) or the input itself.
    var source = getWalkSource(value);
    // Create an accumulator that will act as a parent for all future itterations of that branch
    var acc = Array.isArray(value) ? [] : {};
    // If we already walked that branch, bail out, as it's circular reference
    if (memo[0](value)) {
        return '[Circular ~]';
    }
    // Walk all keys of the source
    for (var innerKey in source) {
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(source, innerKey)) {
            continue;
        }
        // Recursively walk through all the child nodes
        acc[innerKey] = walk(innerKey, source[innerKey], depth - 1, memo);
    }
    // Once walked through all the branches, remove the parent from memo storage
    memo[1](value);
    // Return accumulated values
    return acc;
}
/**
 * normalize()
 *
 * - Creates a copy to prevent original input mutation
 * - Skip non-enumerablers
 * - Calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializeable values (undefined/NaN/Functions) to serializable format
 * - Translates known global objects/Classes to a string representations
 * - Takes care of Error objects serialization
 * - Optionally limit depth of final output
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function normalize(input, depth) {
    try {
        return JSON.parse(JSON.stringify(input, function (key, value) { return walk(key, value, depth); }));
    }
    catch (_oO) {
        return '**non-serializable**';
    }
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) { maxLength = 40; }
    var keys = Object.keys(getWalkSource(exception));
    keys.sort();
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return truncate(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return truncate(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return the new object with removed keys that value was `undefined`.
 * Works recursively on objects and arrays.
 */
function dropUndefinedKeys(val) {
    var e_1, _a;
    if (isPlainObject(val)) {
        var obj = val;
        var rv = {};
        try {
            for (var _b = (0,FronteggApp_35f1a2b2.c)(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (typeof obj[key] !== 'undefined') {
                    rv[key] = dropUndefinedKeys(obj[key]);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return rv;
    }
    if (Array.isArray(val)) {
        return val.map(dropUndefinedKeys);
    }
    return val;
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in getGlobalObject())) {
        return false;
    }
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var global = getGlobalObject();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(global.fetch)) {
        return true;
    }
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === "function") {
        try {
            var sandbox = doc.createElement('iframe');
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // eslint-disable-next-line @typescript-eslint/unbound-method
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        }
        catch (err) {
            if (isDebugBuild()) {
                logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
            }
        }
    }
    return result;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        new Request('_', {
            referrerPolicy: 'origin',
        });
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = getGlobalObject();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

var global$9 = getGlobalObject();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */
var handlers = {};
var instrumented = {};
/** Instruments given API */
function instrument(type) {
    if (instrumented[type]) {
        return;
    }
    instrumented[type] = true;
    switch (type) {
        case 'console':
            instrumentConsole();
            break;
        case 'dom':
            instrumentDOM();
            break;
        case 'xhr':
            instrumentXHR();
            break;
        case 'fetch':
            instrumentFetch();
            break;
        case 'history':
            instrumentHistory();
            break;
        case 'error':
            instrumentError();
            break;
        case 'unhandledrejection':
            instrumentUnhandledRejection();
            break;
        default:
            logger.warn('unknown instrumentation type:', type);
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(callback);
    instrument(type);
}
/** JSDoc */
function triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !handlers[type]) {
        return;
    }
    try {
        for (var _b = (0,FronteggApp_35f1a2b2.c)(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
            var handler = _c.value;
            try {
                handler(data);
            }
            catch (e) {
                if (isDebugBuild()) {
                    logger.error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + getFunctionName(handler) + "\nError: " + e);
                }
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/** JSDoc */
function instrumentConsole() {
    if (!('console' in global$9)) {
        return;
    }
    ['debug', 'info', 'warn', 'error', 'log', 'assert'].forEach(function (level) {
        if (!(level in global$9.console)) {
            return;
        }
        fill(global$9.console, level, function (originalConsoleMethod) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                triggerHandlers('console', { args: args, level: level });
                // this fails for some browsers. :(
                if (originalConsoleMethod) {
                    originalConsoleMethod.apply(global$9.console, args);
                }
            };
        });
    });
}
/** JSDoc */
function instrumentFetch() {
    if (!supportsNativeFetch()) {
        return;
    }
    fill(global$9, 'fetch', function (originalFetch) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var handlerData = {
                args: args,
                fetchData: {
                    method: getFetchMethod(args),
                    url: getFetchUrl(args),
                },
                startTimestamp: Date.now(),
            };
            triggerHandlers('fetch', (0,FronteggApp_35f1a2b2.d)({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply(global$9, args).then(function (response) {
                triggerHandlers('fetch', (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, handlerData), { endTimestamp: Date.now(), response: response }));
                return response;
            }, function (error) {
                triggerHandlers('fetch', (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, handlerData), { endTimestamp: Date.now(), error: error }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if ('Request' in global$9 && isInstanceOf(fetchArgs[0], Request) && fetchArgs[0].method) {
        return String(fetchArgs[0].method).toUpperCase();
    }
    if (fetchArgs[1] && fetchArgs[1].method) {
        return String(fetchArgs[1].method).toUpperCase();
    }
    return 'GET';
}
/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if (typeof fetchArgs[0] === 'string') {
        return fetchArgs[0];
    }
    if ('Request' in global$9 && isInstanceOf(fetchArgs[0], Request)) {
        return fetchArgs[0].url;
    }
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */
/** JSDoc */
function instrumentXHR() {
    if (!('XMLHttpRequest' in global$9)) {
        return;
    }
    var xhrproto = XMLHttpRequest.prototype;
    fill(xhrproto, 'open', function (originalOpen) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = (xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: isString(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
            });
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (isString(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
                xhr.__sentry_own_request__ = true;
            }
            var onreadystatechangeHandler = function () {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    }
                    catch (e) {
                        /* do nothing */
                    }
                    triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr,
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                fill(xhr, 'onreadystatechange', function (original) {
                    return function () {
                        var readyStateArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            readyStateArgs[_i] = arguments[_i];
                        }
                        onreadystatechangeHandler();
                        return original.apply(xhr, readyStateArgs);
                    };
                });
            }
            else {
                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            }
            return originalOpen.apply(xhr, args);
        };
    });
    fill(xhrproto, 'send', function (originalSend) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.__sentry_xhr__ && args[0] !== undefined) {
                this.__sentry_xhr__.body = args[0];
            }
            triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this,
            });
            return originalSend.apply(this, args);
        };
    });
}
var lastHref;
/** JSDoc */
function instrumentHistory() {
    if (!supportsHistory()) {
        return;
    }
    var oldOnPopState = global$9.onpopstate;
    global$9.onpopstate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var to = global$9.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        triggerHandlers('history', {
            from: from,
            to: to,
        });
        if (oldOnPopState) {
            // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
            // https://github.com/getsentry/sentry-javascript/issues/3344
            // https://github.com/bugsnag/bugsnag-js/issues/469
            try {
                return oldOnPopState.apply(this, args);
            }
            catch (_oO) {
                // no-empty
            }
        }
    };
    /** @hidden */
    function historyReplacementFunction(originalHistoryFunction) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                triggerHandlers('history', {
                    from: from,
                    to: to,
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    fill(global$9.history, 'pushState', historyReplacementFunction);
    fill(global$9.history, 'replaceState', historyReplacementFunction);
}
var debounceDuration = 1000;
var debounceTimerID;
var lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) {
        return true;
    }
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) {
        return true;
    }
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) {
            return true;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') {
        return false;
    }
    try {
        var target = event.target;
        if (!target || !target.tagName) {
            return true;
        }
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
            return false;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) { globalListener = false; }
    return function (event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || lastCapturedEvent === event) {
            return;
        }
        // We always want to skip _some_ events.
        if (shouldSkipDOMEvent(event)) {
            return;
        }
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if (debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout(debounceTimerID);
        debounceTimerID = global$9.setTimeout(function () {
            debounceTimerID = undefined;
        }, debounceDuration);
    };
}
/** JSDoc */
function instrumentDOM() {
    if (!('document' in global$9)) {
        return;
    }
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
    global$9.document.addEventListener('click', globalDOMEventHandler, false);
    global$9.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    ['EventTarget', 'Node'].forEach(function (target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = global$9[target] && global$9[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        fill(proto, 'addEventListener', function (originalAddEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_1 = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
                        var handlerForType = (handlers_1[type] = handlers_1[type] || { refCount: 0 });
                        if (!handlerForType.handler) {
                            var handler = makeDOMEventHandler(triggerDOMHandler);
                            handlerForType.handler = handler;
                            originalAddEventListener.call(this, type, handler, options);
                        }
                        handlerForType.refCount += 1;
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers_2[type];
                        if (handlerForType) {
                            handlerForType.refCount -= 1;
                            // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                            if (handlerForType.refCount <= 0) {
                                originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                                handlerForType.handler = undefined;
                                delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                            }
                            // If there are no longer any custom handlers of any type on this element, cleanup everything.
                            if (Object.keys(handlers_2).length === 0) {
                                delete el.__sentry_instrumentation_handlers__;
                            }
                        }
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
    _oldOnErrorHandler = global$9.onerror;
    global$9.onerror = function (msg, url, line, column, error) {
        triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url,
        });
        if (_oldOnErrorHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnErrorHandler.apply(this, arguments);
        }
        return false;
    };
}
var _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = global$9.onunhandledrejection;
    global$9.onunhandledrejection = function (e) {
        triggerHandlers('unhandledrejection', e);
        if (_oldOnUnhandledRejectionHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        }
        return true;
    };
}

/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = getGlobalObject();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-bitwise
        var r = (Math.random() * 16) | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
function getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    var message = event.message, eventId = event.event_id;
    if (message) {
        return message;
    }
    var firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) {
            return firstException.type + ": " + firstException.value;
        }
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
    var exception = (event.exception = event.exception || {});
    var values = (exception.values = exception.values || []);
    var firstException = (values[0] = values[0] || {});
    if (!firstException.value) {
        firstException.value = value || '';
    }
    if (!firstException.type) {
        firstException.type = type || 'Error';
    }
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
    var firstException = getFirstException(event);
    if (!firstException) {
        return;
    }
    var defaultMechanism = { type: 'generic', handled: true };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, (currentMechanism && currentMechanism.data)), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
var defaultRetryAfter = 60 * 1000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param now current unix timestamp
 * @param header string representation of 'Retry-After' header
 */
function parseRetryAfterHeader(now, header) {
    if (!header) {
        return defaultRetryAfter;
    }
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) {
        return headerDelay * 1000;
    }
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) {
        return headerDate - now;
    }
    return defaultRetryAfter;
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) {
        return true;
    }
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        addNonEnumerableProperty(exception, '__sentry_captured__', true);
    }
    catch (err) {
        // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
    return new SyncPromise(function (resolve) {
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
    return new SyncPromise(function (_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
var SyncPromise = /** @class */ (function () {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */;
        this._handlers = [];
        /** JSDoc */
        this._resolve = function (value) {
            _this._setResult(1 /* RESOLVED */, value);
        };
        /** JSDoc */
        this._reject = function (reason) {
            _this._setResult(2 /* REJECTED */, reason);
        };
        /** JSDoc */
        this._setResult = function (state, value) {
            if (_this._state !== 0 /* PENDING */) {
                return;
            }
            if (isThenable(value)) {
                void value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */
        this._executeHandlers = function () {
            if (_this._state === 0 /* PENDING */) {
                return;
            }
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function (handler) {
                if (handler[0]) {
                    return;
                }
                if (_this._state === 1 /* RESOLVED */) {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    handler[1](_this._value);
                }
                if (_this._state === 2 /* REJECTED */) {
                    handler[2](_this._value);
                }
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        }
        catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */
    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            _this._handlers.push([
                false,
                function (result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                    }
                    else {
                        try {
                            resolve(onfulfilled(result));
                        }
                        catch (e) {
                            reject(e);
                        }
                    }
                },
                function (reason) {
                    if (!onrejected) {
                        reject(reason);
                    }
                    else {
                        try {
                            resolve(onrejected(reason));
                        }
                        catch (e) {
                            reject(e);
                        }
                    }
                },
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */
    SyncPromise.prototype.catch = function (onrejected) {
        return this.then(function (val) { return val; }, onrejected);
    };
    /** JSDoc */
    SyncPromise.prototype.finally = function (onfinally) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function (value) {
                isRejected = false;
                val = value;
                if (onfinally) {
                    onfinally();
                }
            }, function (reason) {
                isRejected = true;
                val = reason;
                if (onfinally) {
                    onfinally();
                }
            }).then(function () {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}());

/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */
    function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */
    function add(taskProducer) {
        if (!isReady()) {
            return rejectedSyncPromise(new SentryError('Not adding Promise due to buffer limit reached.'));
        }
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) {
            buffer.push(task);
        }
        void task
            .then(function () { return remove(task); })
            // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
            // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
            // have promises, so TS has to polyfill when down-compiling.)
            .then(null, function () {
            return remove(task).then(null, function () {
                // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */
    function drain(timeout) {
        return new SyncPromise(function (resolve, reject) {
            var counter = buffer.length;
            if (!counter) {
                return resolve(true);
            }
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function () {
                if (timeout && timeout > 0) {
                    resolve(false);
                }
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function (item) {
                void resolvedSyncPromise(item).then(function () {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain,
    };
}

function isSupportedSeverity(level) {
    return SeverityLevels.indexOf(level) !== -1;
}
/**
 * Converts a string-based level into a {@link Severity}.
 *
 * @param level string representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
    if (level === 'warn')
        return Severity.Warning;
    if (isSupportedSeverity(level)) {
        return level;
    }
    return Severity.Log;
}

/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */
function eventStatusFromHttpCode(code) {
    if (code >= 200 && code < 300) {
        return 'success';
    }
    if (code === 429) {
        return 'rate_limit';
    }
    if (code >= 400 && code < 500) {
        return 'invalid';
    }
    if (code >= 500) {
        return 'failed';
    }
    return 'unknown';
}

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
var dateTimestampSource = {
    nowSeconds: function () { return Date.now() / 1000; },
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
    var performance = getGlobalObject().performance;
    if (!performance || !performance.now) {
        return undefined;
    }
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function () { return performance.now(); },
        timeOrigin: timeOrigin,
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
    try {
        var perfHooks = dynamicRequire(module, 'perf_hooks');
        return perfHooks.performance;
    }
    catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */
var platformPerformance = isNodeEnv() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
    };
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
// Re-exported with an old name for backwards-compatibility.
var timestampWithMs = timestampInSeconds;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
var browserPerformanceTimeOrigin = (function () {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = getGlobalObject().performance;
    if (!performance || !performance.now) {
        return undefined;
    }
    var threshold = 3600 * 1000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin
        ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
        : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            return performance.timeOrigin;
        }
        else {
            return navigationStart;
        }
    }
    return dateNow;
})();

/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var Scope = /** @class */ (function () {
    function Scope() {
        /** Flag if notifying is happening. */
        this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this._eventProcessors = [];
        /** Array of breadcrumbs. */
        this._breadcrumbs = [];
        /** User */
        this._user = {};
        /** Tags */
        this._tags = {};
        /** Extra */
        this._extra = {};
        /** Contexts */
        this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */
        this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = (0,FronteggApp_35f1a2b2.e)(scope._breadcrumbs);
            newScope._tags = (0,FronteggApp_35f1a2b2.d)({}, scope._tags);
            newScope._extra = (0,FronteggApp_35f1a2b2.d)({}, scope._extra);
            newScope._contexts = (0,FronteggApp_35f1a2b2.d)({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = (0,FronteggApp_35f1a2b2.e)(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    Scope.prototype.addScopeListener = function (callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addEventProcessor = function (callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setUser = function (user) {
        this._user = user || {};
        if (this._session) {
            this._session.update({ user: user });
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getUser = function () {
        return this._user;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getRequestSession = function () {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setRequestSession = function (requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTags = function (tags) {
        this._tags = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this._tags = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtras = function (extras) {
        this._extra = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this._extra = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setLevel = function (level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTransactionName = function (name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */
    Scope.prototype.setTransaction = function (name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setContext = function (key, context) {
        var _a;
        if (context === null) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._contexts[key];
        }
        else {
            this._contexts = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this._contexts), (_a = {}, _a[key] = context, _a));
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSpan = function (span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSpan = function () {
        return this._span;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getTransaction = function () {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSession = function (session) {
        if (!session) {
            delete this._session;
        }
        else {
            this._session = session;
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSession = function () {
        return this._session;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.update = function (captureContext) {
        if (!captureContext) {
            return this;
        }
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this._tags), captureContext._tags);
            this._extra = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this._extra), captureContext._extra);
            this._contexts = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) {
                this._user = captureContext._user;
            }
            if (captureContext._level) {
                this._level = captureContext._level;
            }
            if (captureContext._fingerprint) {
                this._fingerprint = captureContext._fingerprint;
            }
            if (captureContext._requestSession) {
                this._requestSession = captureContext._requestSession;
            }
        }
        else if (isPlainObject(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext = captureContext;
            this._tags = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this._tags), captureContext.tags);
            this._extra = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this._extra), captureContext.extra);
            this._contexts = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this._contexts), captureContext.contexts);
            if (captureContext.user) {
                this._user = captureContext.user;
            }
            if (captureContext.level) {
                this._level = captureContext.level;
            }
            if (captureContext.fingerprint) {
                this._fingerprint = captureContext.fingerprint;
            }
            if (captureContext.requestSession) {
                this._requestSession = captureContext.requestSession;
            }
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clear = function () {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, MAX_BREADCRUMBS) : MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) {
            return this;
        }
        var mergedBreadcrumb = (0,FronteggApp_35f1a2b2.d)({ timestamp: dateTimestampInSeconds() }, breadcrumb);
        this._breadcrumbs = (0,FronteggApp_35f1a2b2.e)(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clearBreadcrumbs = function () {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */
    Scope.prototype.applyToEvent = function (event, hint) {
        if (this._extra && Object.keys(this._extra).length) {
            event.extra = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this._extra), event.extra);
        }
        if (this._tags && Object.keys(this._tags).length) {
            event.tags = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this._tags), event.tags);
        }
        if (this._user && Object.keys(this._user).length) {
            event.user = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this._user), event.user);
        }
        if (this._contexts && Object.keys(this._contexts).length) {
            event.contexts = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this._contexts), event.contexts);
        }
        if (this._level) {
            event.level = this._level;
        }
        if (this._transactionName) {
            event.transaction = this._transactionName;
        }
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = (0,FronteggApp_35f1a2b2.d)({ trace: this._span.getTraceContext() }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) {
                event.tags = (0,FronteggApp_35f1a2b2.d)({ transaction: transactionName }, event.tags);
            }
        }
        this._applyFingerprint(event);
        event.breadcrumbs = (0,FronteggApp_35f1a2b2.e)((event.breadcrumbs || []), this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors((0,FronteggApp_35f1a2b2.e)(getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */
    Scope.prototype.setSDKProcessingMetadata = function (newData) {
        this._sdkProcessingMetadata = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
        var _this = this;
        if (index === void 0) { index = 0; }
        return new SyncPromise(function (resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') {
                resolve(event);
            }
            else {
                var result = processor((0,FronteggApp_35f1a2b2.d)({}, event), hint);
                if (isThenable(result)) {
                    void result
                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
                        .then(null, reject);
                }
                else {
                    void _this._notifyEventProcessors(processors, result, hint, index + 1)
                        .then(resolve)
                        .then(null, reject);
                }
            }
        });
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype._notifyScopeListeners = function () {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function (callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype._applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint
            ? Array.isArray(event.fingerprint)
                ? event.fingerprint
                : [event.fingerprint]
            : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) {
            event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    return Scope;
}());
/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
    /* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access  */
    var global = getGlobalObject();
    global.__SENTRY__ = global.__SENTRY__ || {};
    global.__SENTRY__.globalEventProcessors = global.__SENTRY__.globalEventProcessors || [];
    return global.__SENTRY__.globalEventProcessors;
    /* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}

/**
 * @inheritdoc
 */
var Session = /** @class */ (function () {
    function Session(context) {
        this.errors = 0;
        this.sid = uuid4();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = timestampInSeconds();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) {
            this.update(context);
        }
    }
    /** JSDoc */
    // eslint-disable-next-line complexity
    Session.prototype.update = function (context) {
        if (context === void 0) { context = {}; }
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) {
                this.ipAddress = context.user.ip_address;
            }
            if (!this.did && !context.did) {
                this.did = context.user.id || context.user.email || context.user.username;
            }
        }
        this.timestamp = context.timestamp || timestampInSeconds();
        if (context.ignoreDuration) {
            this.ignoreDuration = context.ignoreDuration;
        }
        if (context.sid) {
            // Good enough uuid validation. — Kamil
            this.sid = context.sid.length === 32 ? context.sid : uuid4();
        }
        if (context.init !== undefined) {
            this.init = context.init;
        }
        if (!this.did && context.did) {
            this.did = "" + context.did;
        }
        if (typeof context.started === 'number') {
            this.started = context.started;
        }
        if (this.ignoreDuration) {
            this.duration = undefined;
        }
        else if (typeof context.duration === 'number') {
            this.duration = context.duration;
        }
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) {
            this.release = context.release;
        }
        if (context.environment) {
            this.environment = context.environment;
        }
        if (!this.ipAddress && context.ipAddress) {
            this.ipAddress = context.ipAddress;
        }
        if (!this.userAgent && context.userAgent) {
            this.userAgent = context.userAgent;
        }
        if (typeof context.errors === 'number') {
            this.errors = context.errors;
        }
        if (context.status) {
            this.status = context.status;
        }
    };
    /** JSDoc */
    Session.prototype.close = function (status) {
        if (status) {
            this.update({ status: status });
        }
        else if (this.status === 'ok') {
            this.update({ status: 'exited' });
        }
        else {
            this.update();
        }
    };
    /** JSDoc */
    Session.prototype.toJSON = function () {
        return dropUndefinedKeys({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent,
            },
        });
    };
    return Session;
}());

/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */
var Hub = /** @class */ (function () {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */
    function Hub(client, scope, _version) {
        if (scope === void 0) { scope = new Scope(); }
        if (_version === void 0) { _version = API_VERSION; }
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */
        this._stack = [{}];
        this.getStackTop().scope = scope;
        if (client) {
            this.bindClient(client);
        }
    }
    /**
     * @inheritDoc
     */
    Hub.prototype.isOlderThan = function (version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.bindClient = function (client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) {
            client.setupIntegrations();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.pushScope = function () {
        // We want to clone the content of prev scope
        var scope = Scope.clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope,
        });
        return scope;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.popScope = function () {
        if (this.getStack().length <= 1)
            return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.withScope = function (callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        }
        finally {
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getClient = function () {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */
    Hub.prototype.getScope = function () {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */
    Hub.prototype.getStack = function () {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */
    Hub.prototype.getStackTop = function () {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function (exception, hint) {
        var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : uuid4());
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureException', exception, (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureMessage = function (message, level, hint) {
        var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : uuid4());
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureMessage', message, level, (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureEvent = function (event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : uuid4();
        if (event.type !== 'transaction') {
            this._lastEventId = eventId;
        }
        this._invokeClient('captureEvent', event, (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, hint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.lastEventId = function () {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client)
            return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0)
            return;
        var timestamp = dateTimestampInSeconds();
        var mergedBreadcrumb = (0,FronteggApp_35f1a2b2.d)({ timestamp: timestamp }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb
            ? consoleSandbox(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
            : mergedBreadcrumb;
        if (finalBreadcrumb === null)
            return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setUser = function (user) {
        var scope = this.getScope();
        if (scope)
            scope.setUser(user);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTags = function (tags) {
        var scope = this.getScope();
        if (scope)
            scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtras = function (extras) {
        var scope = this.getScope();
        if (scope)
            scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTag = function (key, value) {
        var scope = this.getScope();
        if (scope)
            scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtra = function (key, extra) {
        var scope = this.getScope();
        if (scope)
            scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function (name, context) {
        var scope = this.getScope();
        if (scope)
            scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.configureScope = function (callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) {
            callback(scope);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.run = function (callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        }
        finally {
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getIntegration = function (integration) {
        var client = this.getClient();
        if (!client)
            return null;
        try {
            return client.getIntegration(integration);
        }
        catch (_oO) {
            logger.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSpan = function (context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startTransaction = function (context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.traceHeaders = function () {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureSession = function (endSession) {
        if (endSession === void 0) { endSession = false; }
        // both send the update and pull the session from the scope
        if (endSession) {
            return this.endSession();
        }
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.endSession = function () {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) {
            session.close();
        }
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) {
            scope.setSession();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSession = function (context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = getGlobalObject();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new Session((0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({ release: release,
            environment: environment }, (scope && { user: scope.getUser() })), (userAgent && { userAgent: userAgent })), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') {
                currentSession.update({ status: 'exited' });
            }
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */
    Hub.prototype._sendSessionUpdate = function () {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope)
            return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) {
                client.captureSession(session);
            }
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function (method) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            (_a = client)[method].apply(_a, (0,FronteggApp_35f1a2b2.e)(args, [scope]));
        }
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */
    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function (method) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
            return sentry.extensions[method].apply(this, args);
        }
        logger.warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}());
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
    var carrier = getGlobalObject();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined,
    };
    return carrier;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    // Prefer domains over global if they are there (applicable only to Node environment)
    if (isNodeEnv()) {
        return getHubFromActiveDomain(registry);
    }
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
    try {
        var sentry = getMainCarrier().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) {
            return getHubFromCarrier(registry);
        }
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, Scope.clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    }
    catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
    if (carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub)
        return carrier.__SENTRY__.hub;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = new Hub();
    return carrier.__SENTRY__.hub;
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
    if (!carrier)
        return false;
    carrier.__SENTRY__ = carrier.__SENTRY__ || {};
    carrier.__SENTRY__.hub = hub;
    return true;
}

/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = getCurrentHub();
    if (hub && hub[method]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return hub[method].apply(hub, (0,FronteggApp_35f1a2b2.e)(args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
    var syntheticException;
    try {
        throw new Error('Sentry syntheticException');
    }
    catch (exception) {
        syntheticException = exception;
    }
    return callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException,
    });
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}

var SENTRY_API_VERSION = '7';
/** Initializes API Details */
function initAPIDetails(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: makeDsn(dsn),
        tunnel: tunnel,
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn, target) {
    return "" + getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn) {
    return urlEncode({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: SENTRY_API_VERSION,
    });
}
/** Returns the store endpoint URL. */
function getStoreEndpoint(dsn) {
    return _getIngestEndpoint(dsn, 'store');
}
/**
 * Returns the store endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getStoreEndpointWithUrlEncodedAuth(dsn) {
    return getStoreEndpoint(dsn) + "?" + _encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */
function _getEnvelopeEndpoint(dsn) {
    return _getIngestEndpoint(dsn, 'envelope');
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel) {
    return tunnel ? tunnel : _getEnvelopeEndpoint(dsn) + "?" + _encodedAuth(dsn);
}
/** Returns the url to the report dialog endpoint. */
function getReportDialogEndpoint(dsnLike, dialogOptions) {
    var dsn = makeDsn(dsnLike);
    var endpoint = getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + dsnToString(dsn);
    for (var key in dialogOptions) {
        if (key === 'dsn') {
            continue;
        }
        if (key === 'user') {
            if (!dialogOptions.user) {
                continue;
            }
            if (dialogOptions.user.name) {
                encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            }
            if (dialogOptions.user.email) {
                encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
            }
        }
        else {
            encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
        }
    }
    return endpoint + "?" + encodedOptions;
}

var installedIntegrations = [];
/**
 * @private
 */
function filterDuplicates(integrations) {
    return integrations.reduce(function (acc, integrations) {
        if (acc.every(function (accIntegration) { return integrations.name !== accIntegration.name; })) {
            acc.push(integrations);
        }
        return acc;
    }, []);
}
/** Gets integration to install */
function getIntegrationsToSetup(options) {
    var defaultIntegrations = (options.defaultIntegrations && (0,FronteggApp_35f1a2b2.e)(options.defaultIntegrations)) || [];
    var userIntegrations = options.integrations;
    var integrations = (0,FronteggApp_35f1a2b2.e)(filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) {
        // Filter out integrations that are also included in user options
        integrations = (0,FronteggApp_35f1a2b2.e)(integrations.filter(function (integrations) {
            return userIntegrations.every(function (userIntegration) { return userIntegration.name !== integrations.name; });
        }), filterDuplicates(userIntegrations));
    }
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [integrations];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function (i) { return i.name; });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
        integrations.push.apply(integrations, (0,FronteggApp_35f1a2b2.e)(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    }
    return integrations;
}
/** Setup given integration */
function setupIntegration(integration) {
    if (installedIntegrations.indexOf(integration.name) !== -1) {
        return;
    }
    integration.setupOnce(addGlobalEventProcessor, getCurrentHub);
    installedIntegrations.push(integration.name);
    logger.log("Integration installed: " + integration.name);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(options) {
    var integrations = {};
    getIntegrationsToSetup(options).forEach(function (integration) {
        integrations[integration.name] = integration;
        setupIntegration(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    addNonEnumerableProperty(integrations, 'initialized', true);
    return integrations;
}

var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */
var BaseClient = /** @class */ (function () {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */
    function BaseClient(backendClass, options) {
        /** Array of used integrations. */
        this._integrations = {};
        /** Number of calls being processed */
        this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) {
            this._dsn = makeDsn(options.dsn);
        }
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function (exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if (checkOrSetAlreadyCaught(exception)) {
            logger.log(ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend()
            .eventFromException(exception, hint)
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = isPrimitive(message)
            ? this._getBackend().eventFromMessage(String(message), level, hint)
            : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureEvent = function (event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && checkOrSetAlreadyCaught(hint.originalException)) {
            logger.log(ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureSession = function (session) {
        if (!this._isEnabled()) {
            if (isDebugBuild()) {
                logger.warn('SDK not enabled, will not capture session.');
            }
            return;
        }
        if (!(typeof session.release === 'string')) {
            if (isDebugBuild()) {
                logger.warn('Discarded session because of missing or non-string release');
            }
        }
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({ init: false });
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getDsn = function () {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getOptions = function () {
        return this._options;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getTransport = function () {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.flush = function (timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function (clientFinished) {
            return _this.getTransport()
                .close(timeout)
                .then(function (transportFlushed) { return clientFinished && transportFlushed; });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.close = function (timeout) {
        var _this = this;
        return this.flush(timeout).then(function (result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */
    BaseClient.prototype.setupIntegrations = function () {
        if (this._isEnabled() && !this._integrations.initialized) {
            this._integrations = setupIntegrations(this._options);
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegration = function (integration) {
        try {
            return this._integrations[integration.id] || null;
        }
        catch (_oO) {
            logger.warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */
    BaseClient.prototype._updateSessionFromEvent = function (session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for (var exceptions_1 = (0,FronteggApp_35f1a2b2.c)(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()) {
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);
        if (shouldUpdateAndSend) {
            session.update((0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, (crashed && { status: 'crashed' })), { errors: session.errors || Number(errored || crashed) }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */
    BaseClient.prototype._sendSession = function (session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */
    BaseClient.prototype._isClientDoneProcessing = function (timeout) {
        var _this = this;
        return new SyncPromise(function (resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function () {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                }
                else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */
    BaseClient.prototype._getBackend = function () {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */
    BaseClient.prototype._isEnabled = function () {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */
    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
        var _this = this;
        var _a = this.getOptions().normalizeDepth, normalizeDepth = _a === void 0 ? 3 : _a;
        var prepared = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, event), { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : uuid4()), timestamp: event.timestamp || dateTimestampInSeconds() });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) {
            finalScope = Scope.clone(finalScope).update(hint.captureContext);
        }
        // We prepare the result here with a resolved Event.
        var result = resolvedSyncPromise(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) {
            // In case we have a hub we reassign it.
            result = finalScope.applyToEvent(prepared, hint);
        }
        return result.then(function (evt) {
            if (evt) {
                // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
                // it is only attached as extra data to the event if the event somehow skips being normalized
                evt.sdkProcessingMetadata = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, evt.sdkProcessingMetadata), { normalizeDepth: normalize(normalizeDepth) });
            }
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
                return _this._normalizeEvent(evt, normalizeDepth);
            }
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */
    BaseClient.prototype._normalizeEvent = function (event, depth) {
        if (!event) {
            return null;
        }
        var normalized = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, event), (event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function (b) { return ((0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, b), (b.data && {
                data: normalize(b.data, depth),
            }))); }),
        })), (event.user && {
            user: normalize(event.user, depth),
        })), (event.contexts && {
            contexts: normalize(event.contexts, depth),
        })), (event.extra && {
            extra: normalize(event.extra, depth),
        }));
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            normalized.contexts.trace = event.contexts.trace;
        }
        event.sdkProcessingMetadata = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, event.sdkProcessingMetadata), { baseClientNormalized: true });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */
    BaseClient.prototype._applyClientOptions = function (event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) {
            event.environment = 'environment' in options ? environment : 'production';
        }
        if (event.release === undefined && release !== undefined) {
            event.release = release;
        }
        if (event.dist === undefined && dist !== undefined) {
            event.dist = dist;
        }
        if (event.message) {
            event.message = truncate(event.message, maxValueLength);
        }
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) {
            exception.value = truncate(exception.value, maxValueLength);
        }
        var request = event.request;
        if (request && request.url) {
            request.url = truncate(request.url, maxValueLength);
        }
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */
    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = (0,FronteggApp_35f1a2b2.e)((event.sdk.integrations || []), integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */
    BaseClient.prototype._sendEvent = function (event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */
    BaseClient.prototype._captureEvent = function (event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function (finalEvent) {
            return finalEvent.event_id;
        }, function (reason) {
            logger.error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */
    BaseClient.prototype._processEvent = function (event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) {
                transport.recordLostEvent(outcome, category);
            }
        }
        if (!this._isEnabled()) {
            return rejectedSyncPromise(new SentryError('SDK not enabled, will not capture event.'));
        }
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return rejectedSyncPromise(new SentryError("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint)
            .then(function (prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new SentryError('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) {
                return prepared;
            }
            var beforeSendResult = beforeSend(prepared, hint);
            return _ensureBeforeSendRv(beforeSendResult);
        })
            .then(function (processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new SentryError('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) {
                _this._updateSessionFromEvent(session, processedEvent);
            }
            _this._sendEvent(processedEvent);
            return processedEvent;
        })
            .then(null, function (reason) {
            if (reason instanceof SentryError) {
                throw reason;
            }
            _this.captureException(reason, {
                data: {
                    __sentry__: true,
                },
                originalException: reason,
            });
            throw new SentryError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */
    BaseClient.prototype._process = function (promise) {
        var _this = this;
        this._numProcessing += 1;
        void promise.then(function (value) {
            _this._numProcessing -= 1;
            return value;
        }, function (reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}());
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */
function _ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if (isThenable(rv)) {
        return rv.then(function (event) {
            if (!(isPlainObject(event) || event === null)) {
                throw new SentryError(nullErr);
            }
            return event;
        }, function (e) {
            throw new SentryError("beforeSend rejected with " + e);
        });
    }
    else if (!(isPlainObject(rv) || rv === null)) {
        throw new SentryError(nullErr);
    }
    return rv;
}

/** Noop transport */
var NoopTransport = /** @class */ (function () {
    function NoopTransport() {
    }
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.sendEvent = function (_) {
        return resolvedSyncPromise({
            reason: "NoopTransport: Event has been skipped because no Dsn is configured.",
            status: 'skipped',
        });
    };
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.close = function (_) {
        return resolvedSyncPromise(true);
    };
    return NoopTransport;
}());

/**
 * This is the base implemention of a Backend.
 * @hidden
 */
var BaseBackend = /** @class */ (function () {
    /** Creates a new backend instance. */
    function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) {
            logger.warn('No DSN provided, backend will not do anything.');
        }
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
        throw new SentryError('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
        throw new SentryError('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendEvent = function (event) {
        void this._transport.sendEvent(event).then(null, function (reason) {
            if (isDebugBuild()) {
                logger.error("Error while sending event: " + reason);
            }
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendSession = function (session) {
        if (!this._transport.sendSession) {
            if (isDebugBuild()) {
                logger.warn("Dropping session because custom transport doesn't implement sendSession");
            }
            return;
        }
        void this._transport.sendSession(session).then(null, function (reason) {
            if (isDebugBuild()) {
                logger.error("Error while sending session: " + reason);
            }
        });
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.getTransport = function () {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */
    BaseBackend.prototype._setupTransport = function () {
        return new NoopTransport();
    };
    return BaseBackend;
}());

/** Extract sdk info from from the API metadata */
function getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) {
        return;
    }
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return { name: name, version: version };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) {
        return event;
    }
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = (0,FronteggApp_35f1a2b2.e)((event.sdk.integrations || []), (sdkInfo.integrations || []));
    event.sdk.packages = (0,FronteggApp_35f1a2b2.e)((event.sdk.packages || []), (sdkInfo.packages || []));
    return event;
}
/** Creates a SentryRequest from a Session. */
function sessionToSentryRequest(session, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = JSON.stringify((0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({ sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: dsnToString(api.dsn) })));
    // I know this is hacky but we don't want to add `session` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    var itemHeaders = JSON.stringify({
        type: type,
    });
    return {
        body: envelopeHeaders + "\n" + itemHeaders + "\n" + JSON.stringify(session),
        type: type,
        url: getEnvelopeEndpointWithUrlEncodedAuth(api.dsn, api.tunnel),
    };
}
/** Creates a SentryRequest from an event. */
function eventToSentryRequest(event, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    }
    catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify(normalize(event));
        }
        catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: { message: innerErr.message, stack: innerErr.stack },
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope
            ? getEnvelopeEndpointWithUrlEncodedAuth(api.dsn, api.tunnel)
            : getStoreEndpointWithUrlEncodedAuth(api.dsn),
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = JSON.stringify((0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({ event_id: event.event_id, sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: dsnToString(api.dsn) })));
        var itemHeaders = JSON.stringify({
            type: eventType,
            // TODO: Right now, sampleRate may or may not be defined (it won't be in the cases of inheritance and
            // explicitly-set sampling decisions). Are we good with that?
            sample_rates: [{ id: samplingMethod, rate: sampleRate }],
        });
        // The trailing newline is optional. We intentionally don't send it to avoid
        // sending unnecessary bytes.
        //
        // const envelope = `${envelopeHeaders}\n${itemHeaders}\n${req.body}\n`;
        var envelope = envelopeHeaders + "\n" + itemHeaders + "\n" + req.body;
        req.body = envelope;
    }
    return req;
}

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(clientClass, options) {
    if (options.debug === true) {
        logger.enable();
    }
    var hub = getCurrentHub();
    var scope = hub.getScope();
    if (scope) {
        scope.update(options.initialScope);
    }
    var client = new clientClass(options);
    hub.bindClient(client);
}

var SDK_VERSION = '6.18.0';

var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */ (function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = getOriginalFunction(this) || this;
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}());

// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */ (function () {
    function InboundFilters(_options) {
        if (_options === void 0) { _options = {}; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function () {
        addGlobalEventProcessor(function (event) {
            var hub = getCurrentHub();
            if (!hub) {
                return event;
            }
            var self = hub.getIntegration(InboundFilters);
            if (self) {
                var client = hub.getClient();
                var clientOptions = client ? client.getOptions() : {};
                // This checks prevents most of the occurrences of the bug linked below:
                // https://github.com/getsentry/sentry-javascript/issues/2622
                // The bug is caused by multiple SDK instances, where one is minified and one is using non-mangled code.
                // Unfortunatelly we cannot fix it reliably (thus reserved property in rollup's terser config),
                // as we cannot force people using multiple instances in their apps to sync SDK versions.
                var options = typeof self._mergeOptions === 'function' ? self._mergeOptions(clientOptions) : {};
                if (typeof self._shouldDropEvent !== 'function') {
                    return event;
                }
                return self._shouldDropEvent(event, options) ? null : event;
            }
            return event;
        });
    };
    /** JSDoc */
    InboundFilters.prototype._shouldDropEvent = function (event, options) {
        if (this._isSentryError(event, options)) {
            if (isDebugBuild()) {
                logger.warn("Event dropped due to being internal Sentry Error.\nEvent: " + getEventDescription(event));
            }
            return true;
        }
        if (this._isIgnoredError(event, options)) {
            if (isDebugBuild()) {
                logger.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + getEventDescription(event));
            }
            return true;
        }
        if (this._isDeniedUrl(event, options)) {
            if (isDebugBuild()) {
                logger.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            }
            return true;
        }
        if (!this._isAllowedUrl(event, options)) {
            if (isDebugBuild()) {
                logger.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + getEventDescription(event) + ".\nUrl: " + this._getEventFilterUrl(event));
            }
            return true;
        }
        return false;
    };
    /** JSDoc */
    InboundFilters.prototype._isSentryError = function (event, options) {
        if (!options.ignoreInternal) {
            return false;
        }
        try {
            // @ts-ignore can't be a sentry error if undefined
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return event.exception.values[0].type === 'SentryError';
        }
        catch (e) {
            // ignore
        }
        return false;
    };
    /** JSDoc */
    InboundFilters.prototype._isIgnoredError = function (event, options) {
        if (!options.ignoreErrors || !options.ignoreErrors.length) {
            return false;
        }
        return this._getPossibleEventMessages(event).some(function (message) {
            // Not sure why TypeScript complains here...
            return options.ignoreErrors.some(function (pattern) { return isMatchingPattern(message, pattern); });
        });
    };
    /** JSDoc */
    InboundFilters.prototype._isDeniedUrl = function (event, options) {
        // TODO: Use Glob instead?
        if (!options.denyUrls || !options.denyUrls.length) {
            return false;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? false : options.denyUrls.some(function (pattern) { return isMatchingPattern(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._isAllowedUrl = function (event, options) {
        // TODO: Use Glob instead?
        if (!options.allowUrls || !options.allowUrls.length) {
            return true;
        }
        var url = this._getEventFilterUrl(event);
        return !url ? true : options.allowUrls.some(function (pattern) { return isMatchingPattern(url, pattern); });
    };
    /** JSDoc */
    InboundFilters.prototype._mergeOptions = function (clientOptions) {
        if (clientOptions === void 0) { clientOptions = {}; }
        return {
            allowUrls: (0,FronteggApp_35f1a2b2.e)((this._options.whitelistUrls || []), (this._options.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
            denyUrls: (0,FronteggApp_35f1a2b2.e)((this._options.blacklistUrls || []), (this._options.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
            ignoreErrors: (0,FronteggApp_35f1a2b2.e)((this._options.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
            ignoreInternal: typeof this._options.ignoreInternal !== 'undefined' ? this._options.ignoreInternal : true,
        };
    };
    /** JSDoc */
    InboundFilters.prototype._getPossibleEventMessages = function (event) {
        if (event.message) {
            return [event.message];
        }
        if (event.exception) {
            try {
                var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
                return ["" + value, type + ": " + value];
            }
            catch (oO) {
                if (isDebugBuild()) {
                    logger.error("Cannot extract message for event " + getEventDescription(event));
                }
                return [];
            }
        }
        return [];
    };
    /** JSDoc */
    InboundFilters.prototype._getLastValidUrl = function (frames) {
        if (frames === void 0) { frames = []; }
        for (var i = frames.length - 1; i >= 0; i--) {
            var frame = frames[i];
            if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
                return frame.filename || null;
            }
        }
        return null;
    };
    /** JSDoc */
    InboundFilters.prototype._getEventFilterUrl = function (event) {
        try {
            if (event.stacktrace) {
                return this._getLastValidUrl(event.stacktrace.frames);
            }
            var frames_1;
            try {
                // @ts-ignore we only care about frames if the whole thing here is defined
                frames_1 = event.exception.values[0].stacktrace.frames;
            }
            catch (e) {
                // ignore
            }
            return frames_1 ? this._getLastValidUrl(frames_1) : null;
        }
        catch (oO) {
            if (isDebugBuild()) {
                logger.error("Cannot extract url for event " + getEventDescription(event));
            }
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}());

// global reference to slice
var UNKNOWN_FUNCTION = '?';
function createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true,
    };
    if (lineno !== undefined) {
        frame.lineno = lineno;
    }
    if (colno !== undefined) {
        frame.colno = colno;
    }
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var chrome = function (line) {
    var parts = chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = (0,FronteggApp_35f1a2b2.b)(extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var gecko = function (line) {
    var _a;
    var parts = geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || "eval";
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || UNKNOWN_FUNCTION;
        _a = (0,FronteggApp_35f1a2b2.b)(extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var winjs = function (line) {
    var parts = winjsRegex.exec(line);
    return parts
        ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
        : undefined;
};
var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var opera10 = function (line) {
    var parts = opera10Regex.exec(line);
    return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var opera11 = function (line) {
    var parts = opera11Regex.exec(line);
    return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
var extractSafariExtensionDetails = function (func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension
        ? [
            func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
            isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename,
        ]
        : [func, filename];
};

/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */
function exceptionFromError(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = parseStackFrames(ex);
    var exception = {
        type: ex && ex.name,
        value: extractMessage(ex),
    };
    if (frames && frames.length) {
        exception.stacktrace = { frames: frames };
    }
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
/**
 * @hidden
 */
function eventFromPlainObject(exception, syntheticException, rejection) {
    var event = {
        exception: {
            values: [
                {
                    type: isEvent(exception) ? exception.constructor.name : rejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (rejection ? 'promise rejection' : 'exception') + " captured with keys: " + extractExceptionKeysForMessage(exception),
                },
            ],
        },
        extra: {
            __serialized__: normalizeToSize(exception),
        },
    };
    if (syntheticException) {
        var frames_1 = parseStackFrames(syntheticException);
        if (frames_1.length) {
            event.stacktrace = { frames: frames_1 };
        }
    }
    return event;
}
/**
 * @hidden
 */
function eventFromError(ex) {
    return {
        exception: {
            values: [exceptionFromError(ex)],
        },
    };
}
/** Parses stack frames from an error */
function parseStackFrames(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = getPopSize(ex);
    try {
        // The order of the parsers in important
        return createStackParser(opera10, opera11, chrome, winjs, gecko)(stacktrace, popSize);
    }
    catch (e) {
        // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;
function getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') {
            return ex.framesToPop;
        }
        if (reactMinifiedRegexp.test(ex.message)) {
            return 1;
        }
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return 'No error message';
    }
    if (message.error && typeof message.error.message === 'string') {
        return message.error.message;
    }
    return message;
}

/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(options, exception, hint) {
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromUnknownInput(exception, syntheticException, {
        attachStacktrace: options.attachStacktrace,
    });
    addExceptionMechanism(event); // defaults to { type: 'generic', handled: true }
    event.level = Severity.Error;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return resolvedSyncPromise(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(options, message, level, hint) {
    if (level === void 0) { level = Severity.Info; }
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromString(message, syntheticException, {
        attachStacktrace: options.attachStacktrace,
    });
    event.level = level;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return resolvedSyncPromise(event);
}
/**
 * @hidden
 */
function eventFromUnknownInput(exception, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event;
    if (isErrorEvent(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return eventFromError(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if (isDOMError(exception) || isDOMException(exception)) {
        var domException = exception;
        if ('stack' in exception) {
            event = eventFromError(exception);
        }
        else {
            var name_1 = domException.name || (isDOMError(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = eventFromString(message, syntheticException, options);
            addExceptionTypeValue(event, message);
        }
        if ('code' in domException) {
            event.tags = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, event.tags), { 'DOMException.code': "" + domException.code });
        }
        return event;
    }
    if (isError(exception)) {
        // we have a real Error object, do nothing
        return eventFromError(exception);
    }
    if (isPlainObject(exception) || isEvent(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = eventFromPlainObject(objectException, syntheticException, options.isRejection);
        addExceptionMechanism(event, {
            synthetic: true,
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(exception, syntheticException, options);
    addExceptionTypeValue(event, "" + exception, undefined);
    addExceptionMechanism(event, {
        synthetic: true,
    });
    return event;
}
/**
 * @hidden
 */
function eventFromString(input, syntheticException, options) {
    if (options === void 0) { options = {}; }
    var event = {
        message: input,
    };
    if (options.attachStacktrace && syntheticException) {
        var frames_1 = parseStackFrames(syntheticException);
        if (frames_1.length) {
            event.stacktrace = { frames: frames_1 };
        }
    }
    return event;
}

var global$8 = getGlobalObject();
var cachedFetchImpl;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
    if (cachedFetchImpl) {
        return cachedFetchImpl;
    }
    /* eslint-disable @typescript-eslint/unbound-method */
    // Fast path to avoid DOM I/O
    if (isNativeFetch(global$8.fetch)) {
        return (cachedFetchImpl = global$8.fetch.bind(global$8));
    }
    var document = global$8.document;
    var fetchImpl = global$8.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === "function") {
        try {
            var sandbox = document.createElement('iframe');
            sandbox.hidden = true;
            document.head.appendChild(sandbox);
            var contentWindow = sandbox.contentWindow;
            if (contentWindow && contentWindow.fetch) {
                fetchImpl = contentWindow.fetch;
            }
            document.head.removeChild(sandbox);
        }
        catch (e) {
            if (isDebugBuild()) {
                logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
            }
        }
    }
    return (cachedFetchImpl = fetchImpl.bind(global$8));
    /* eslint-enable @typescript-eslint/unbound-method */
}
/**
 * Sends sdk client report using sendBeacon or fetch as a fallback if available
 *
 * @param url report endpoint
 * @param body report payload
 */
function sendReport(url, body) {
    var isRealNavigator = Object.prototype.toString.call(global$8 && global$8.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof global$8.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = global$8.navigator.sendBeacon.bind(global$8.navigator);
        return sendBeacon(url, body);
    }
    if (supportsFetch()) {
        var fetch_1 = getNativeFetchImplementation();
        return forget(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true,
        }));
    }
}

function requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var global$7 = getGlobalObject();
/** Base Transport class implementation */
var BaseTransport = /** @class */ (function () {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */
        this._buffer = makePromiseBuffer(30);
        /** Locks transport after receiving rate limits in a response */
        this._rateLimits = {};
        this._outcomes = {};
        this._api = initAPIDetails(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = getStoreEndpointWithUrlEncodedAuth(this._api.dsn);
        if (this.options.sendClientReports && global$7.document) {
            global$7.document.addEventListener('visibilitychange', function () {
                if (global$7.document.visibilityState === 'hidden') {
                    _this._flushOutcomes();
                }
            });
        }
    }
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendEvent = function (event) {
        return this._sendRequest(eventToSentryRequest(event, this._api), event);
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendSession = function (session) {
        return this._sendRequest(sessionToSentryRequest(session, this._api), session);
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.close = function (timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.recordLostEvent = function (reason, category) {
        var _a;
        if (!this.options.sendClientReports) {
            return;
        }
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = requestTypeToCategory(category) + ":" + reason;
        logger.log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], (_a !== null && _a !== void 0 ? _a : 0)) + 1;
    };
    /**
     * Send outcomes as an envelope
     */
    BaseTransport.prototype._flushOutcomes = function () {
        if (!this.options.sendClientReports) {
            return;
        }
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            logger.log('No outcomes to flush');
            return;
        }
        logger.log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = getEnvelopeEndpointWithUrlEncodedAuth(this._api.dsn, this._api.tunnel);
        // Envelope header is required to be at least an empty object
        var envelopeHeader = JSON.stringify((0,FronteggApp_35f1a2b2.d)({}, (this._api.tunnel && { dsn: dsnToString(this._api.dsn) })));
        var itemHeaders = JSON.stringify({
            type: 'client_report',
        });
        var item = JSON.stringify({
            timestamp: dateTimestampInSeconds(),
            discarded_events: Object.keys(outcomes).map(function (key) {
                var _a = (0,FronteggApp_35f1a2b2.b)(key.split(':'), 2), category = _a[0], reason = _a[1];
                return {
                    reason: reason,
                    category: category,
                    quantity: outcomes[key],
                };
            }),
        });
        var envelope = envelopeHeader + "\n" + itemHeaders + "\n" + item;
        try {
            sendReport(url, envelope);
        }
        catch (e) {
            logger.error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */
    BaseTransport.prototype._handleResponse = function (_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = eventStatusFromHttpCode(response.status);
        /**
         * "The name is case-insensitive."
         * https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
         */
        var limited = this._handleRateLimit(headers);
        if (limited && isDebugBuild()) {
            logger.warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        }
        if (status === 'success') {
            resolve({ status: status });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     */
    BaseTransport.prototype._disabledUntil = function (requestType) {
        var category = requestTypeToCategory(requestType);
        return this._rateLimits[category] || this._rateLimits.all;
    };
    /**
     * Checks if a category is rate limited
     */
    BaseTransport.prototype._isRateLimited = function (requestType) {
        return this._disabledUntil(requestType) > new Date(Date.now());
    };
    /**
     * Sets internal _rateLimits from incoming headers. Returns true if headers contains a non-empty rate limiting header.
     */
    BaseTransport.prototype._handleRateLimit = function (headers) {
        var e_1, _a, e_2, _b;
        var now = Date.now();
        var rlHeader = headers['x-sentry-rate-limits'];
        var raHeader = headers['retry-after'];
        if (rlHeader) {
            try {
                // rate limit headers are of the form
                //     <header>,<header>,..
                // where each <header> is of the form
                //     <retry_after>: <categories>: <scope>: <reason_code>
                // where
                //     <retry_after> is a delay in ms
                //     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
                //         <category>;<category>;...
                //     <scope> is what's being limited (org, project, or key) - ignored by SDK
                //     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
                for (var _c = (0,FronteggApp_35f1a2b2.c)(rlHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var limit = _d.value;
                    var parameters = limit.split(':', 2);
                    var headerDelay = parseInt(parameters[0], 10);
                    var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
                    try {
                        for (var _e = (e_2 = void 0, (0,FronteggApp_35f1a2b2.c)(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var category = _f.value;
                            this._rateLimits[category || 'all'] = new Date(now + delay);
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
            return true;
        }
        else if (raHeader) {
            this._rateLimits.all = new Date(now + parseRetryAfterHeader(now, raHeader));
            return true;
        }
        return false;
    };
    return BaseTransport;
}());

/** `fetch` based transport */
var FetchTransport = /** @class */ (function (_super) {
    (0,FronteggApp_35f1a2b2._)(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) { fetchImpl = getNativeFetchImplementation(); }
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    FetchTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (supportsReferrerPolicy() ? 'origin' : ''),
        };
        if (this.options.fetchParameters !== undefined) {
            Object.assign(options, this.options.fetchParameters);
        }
        if (this.options.headers !== undefined) {
            options.headers = this.options.headers;
        }
        return this._buffer
            .add(function () {
            return new SyncPromise(function (resolve, reject) {
                void _this._fetch(sentryRequest.url, options)
                    .then(function (response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After'),
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject,
                    });
                })
                    .catch(reject);
            });
        })
            .then(undefined, function (reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof SentryError) {
                _this.recordLostEvent('queue_overflow', sentryRequest.type);
            }
            else {
                _this.recordLostEvent('network_error', sentryRequest.type);
            }
            throw reason;
        });
    };
    return FetchTransport;
}(BaseTransport));

/** `XHR` based transport */
var XHRTransport = /** @class */ (function (_super) {
    (0,FronteggApp_35f1a2b2._)(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    XHRTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        return this._buffer
            .add(function () {
            return new SyncPromise(function (resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function () {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After'),
                        };
                        _this._handleResponse({ requestType: sentryRequest.type, response: request, headers: headers, resolve: resolve, reject: reject });
                    }
                };
                request.open('POST', sentryRequest.url);
                for (var header in _this.options.headers) {
                    if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) {
                        request.setRequestHeader(header, _this.options.headers[header]);
                    }
                }
                request.send(sentryRequest.body);
            });
        })
            .then(undefined, function (reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof SentryError) {
                _this.recordLostEvent('queue_overflow', sentryRequest.type);
            }
            else {
                _this.recordLostEvent('network_error', sentryRequest.type);
            }
            throw reason;
        });
    };
    return XHRTransport;
}(BaseTransport));

/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */
var BrowserBackend = /** @class */ (function (_super) {
    (0,FronteggApp_35f1a2b2._)(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromException = function (exception, hint) {
        return eventFromException(this._options, exception, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
        if (level === void 0) { level = Severity.Info; }
        return eventFromMessage(this._options, message, level, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype._setupTransport = function () {
        if (!this._options.dsn) {
            // We return the noop transport here in case there is no Dsn.
            return _super.prototype._setupTransport.call(this);
        }
        var transportOptions = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this._options.transportOptions), { dsn: this._options.dsn, tunnel: this._options.tunnel, sendClientReports: this._options.sendClientReports, _metadata: this._options._metadata });
        if (this._options.transport) {
            return new this._options.transport(transportOptions);
        }
        if (supportsFetch()) {
            return new FetchTransport(transportOptions);
        }
        return new XHRTransport(transportOptions);
    };
    return BrowserBackend;
}(BaseBackend));

var global$6 = getGlobalObject();
var ignoreOnError = 0;
/**
 * @hidden
 */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) { options = {}; }
    if (typeof fn !== 'function') {
        return fn;
    }
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            return wrapper;
        }
        // We don't wanna wrap it twice
        if (getOriginalFunction(fn)) {
            return fn;
        }
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function () {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') {
                before.apply(this, arguments);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        }
        catch (ex) {
            ignoreNextOnError();
            withScope(function (scope) {
                scope.addEventProcessor(function (event) {
                    if (options.mechanism) {
                        addExceptionTypeValue(event, undefined, undefined);
                        addExceptionMechanism(event, options.mechanism);
                    }
                    event.extra = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, event.extra), { arguments: args });
                    return event;
                });
                captureException(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    }
    catch (_oO) { } // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    markFunctionWrapped(sentryWrapped, fn);
    addNonEnumerableProperty(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, 'name', {
                get: function () {
                    return fn.name;
                },
            });
        }
        // eslint-disable-next-line no-empty
    }
    catch (_oO) { }
    return sentryWrapped;
}
/**
 * Injects the Report Dialog script
 * @hidden
 */
function injectReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!global$6.document) {
        return;
    }
    if (!options.eventId) {
        if (isDebugBuild()) {
            logger.error("Missing eventId option in showReportDialog call");
        }
        return;
    }
    if (!options.dsn) {
        if (isDebugBuild()) {
            logger.error("Missing dsn option in showReportDialog call");
        }
        return;
    }
    var script = global$6.document.createElement('script');
    script.async = true;
    script.src = getReportDialogEndpoint(options.dsn, options);
    if (options.onLoad) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        script.onload = options.onLoad;
    }
    var injectionPoint = global$6.document.head || global$6.document.body;
    if (injectionPoint) {
        injectionPoint.appendChild(script);
    }
}

/** Global handlers */
var GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */
        this._installFunc = {
            onerror: _installGlobalOnErrorHandler,
            onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
        };
        this._options = (0,FronteggApp_35f1a2b2.d)({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for (var key in options) {
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());
/** JSDoc */
function _installGlobalOnErrorHandler() {
    addInstrumentationHandler('error', 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (data) {
        var _a = (0,FronteggApp_35f1a2b2.b)(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration(GlobalHandlers)) {
            return;
        }
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
            return;
        }
        var event = error === undefined && isString(msg)
            ? _eventFromIncompleteOnError(msg, url, line, column)
            : _enhanceEventWithInitialFrame(eventFromUnknownInput(error || msg, undefined, {
                attachStacktrace: attachStacktrace,
                isRejection: false,
            }), url, line, column);
        event.level = Severity.Error;
        addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
    addInstrumentationHandler('unhandledrejection', 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (e) {
        var _a = (0,FronteggApp_35f1a2b2.b)(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration(GlobalHandlers)) {
            return;
        }
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) {
                error = e.reason;
            }
            // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
            // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
            // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
            // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
            // https://github.com/getsentry/sentry-javascript/issues/2380
            else if ('detail' in e && 'reason' in e.detail) {
                error = e.detail.reason;
            }
        }
        catch (_oO) {
            // no-empty
        }
        if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
            return true;
        }
        var event = isPrimitive(error)
            ? _eventFromRejectionWithPrimitive(error)
            : eventFromUnknownInput(error, undefined, {
                attachStacktrace: attachStacktrace,
                isRejection: true,
            });
        event.level = Severity.Error;
        addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason),
                },
            ],
        },
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = isErrorEvent(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message,
                },
            ],
        },
    };
    return _enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = (event.exception = event.exception || {});
    // event.exception.values
    var ev = (e.values = e.values || []);
    // event.exception.values[0]
    var ev0 = (ev[0] = ev[0] || {});
    // event.exception.values[0].stacktrace
    var ev0s = (ev0.stacktrace = ev0.stacktrace || {});
    // event.exception.values[0].stacktrace.frames
    var ev0sf = (ev0s.frames = ev0s.frames || []);
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = isString(url) && url.length > 0 ? url : getLocationHref();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) {
        ev0sf.push({
            colno: colno,
            filename: filename,
            function: '?',
            in_app: true,
            lineno: lineno,
        });
    }
    return event;
}
function globalHandlerLog(type) {
    if (isDebugBuild()) {
        logger.log("Global Handler attached: " + type);
    }
}
function addMechanismAndCapture(hub, error, event, type) {
    addExceptionMechanism(event, {
        handled: false,
        type: type,
    });
    hub.captureEvent(event, {
        originalException: error,
    });
}
function getHubAndAttachStacktrace() {
    var hub = getCurrentHub();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [hub, attachStacktrace];
}

var DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload',
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */
var TryCatch = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function TryCatch(options) {
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
        this._options = (0,FronteggApp_35f1a2b2.d)({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        var global = getGlobalObject();
        if (this._options.setTimeout) {
            fill(global, 'setTimeout', _wrapTimeFunction);
        }
        if (this._options.setInterval) {
            fill(global, 'setInterval', _wrapTimeFunction);
        }
        if (this._options.requestAnimationFrame) {
            fill(global, 'requestAnimationFrame', _wrapRAF);
        }
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
            fill(XMLHttpRequest.prototype, 'send', _wrapXHR);
        }
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
            eventTarget.forEach(_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}());
/** JSDoc */
function _wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var originalCallback = args[0];
        args[0] = wrap(originalCallback, {
            mechanism: {
                data: { function: getFunctionName(original) },
                handled: true,
                type: 'instrument',
            },
        });
        return original.apply(this, args);
    };
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.call(this, wrap(callback, {
            mechanism: {
                data: {
                    function: 'requestAnimationFrame',
                    handler: getFunctionName(original),
                },
                handled: true,
                type: 'instrument',
            },
        }));
    };
}
/** JSDoc */
function _wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
        xmlHttpRequestProps.forEach(function (prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                fill(xhr, prop, function (original) {
                    var wrapOptions = {
                        mechanism: {
                            data: {
                                function: prop,
                                handler: getFunctionName(original),
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    };
                    // If Instrument integration has been called before TryCatch, get the name of original function
                    var originalFunction = getOriginalFunction(original);
                    if (originalFunction) {
                        wrapOptions.mechanism.data.handler = getFunctionName(originalFunction);
                    }
                    // Otherwise wrap directly
                    return wrap(original, wrapOptions);
                });
            }
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */
function _wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = getGlobalObject();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
        return;
    }
    fill(proto, 'addEventListener', function (original) {
        return function (eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') {
                    fn.handleEvent = wrap(fn.handleEvent.bind(fn), {
                        mechanism: {
                            data: {
                                function: 'handleEvent',
                                handler: getFunctionName(fn),
                                target: target,
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    });
                }
            }
            catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.call(this, eventName, 
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            wrap(fn, {
                mechanism: {
                    data: {
                        function: 'addEventListener',
                        handler: getFunctionName(fn),
                        target: target,
                    },
                    handled: true,
                    type: 'instrument',
                },
            }), options);
        };
    });
    fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
        return function (eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */
            var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) {
                    originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            }
            catch (e) {
                // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
var Breadcrumbs = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this._options = (0,FronteggApp_35f1a2b2.d)({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */
    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
        if (!this._options.sentry) {
            return;
        }
        getCurrentHub().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: getEventDescription(event),
        }, {
            event: event,
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        if (this._options.console) {
            addInstrumentationHandler('console', _consoleBreadcrumb);
        }
        if (this._options.dom) {
            addInstrumentationHandler('dom', _domBreadcrumb(this._options.dom));
        }
        if (this._options.xhr) {
            addInstrumentationHandler('xhr', _xhrBreadcrumb);
        }
        if (this._options.fetch) {
            addInstrumentationHandler('fetch', _fetchBreadcrumb);
        }
        if (this._options.history) {
            addInstrumentationHandler('history', _historyBreadcrumb);
        }
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}());
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') {
            keyAttrs = [keyAttrs];
        }
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target
                ? htmlTreeAsString(handlerData.event.target, keyAttrs)
                : htmlTreeAsString(handlerData.event, keyAttrs);
        }
        catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) {
            return;
        }
        getCurrentHub().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target,
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global,
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console',
        },
        level: severityFromString(handlerData.level),
        message: safeJoin(handlerData.args, ' '),
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + (safeJoin(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        }
        else {
            // Don't capture a breadcrumb for passed assertions
            return;
        }
    }
    getCurrentHub().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level,
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) {
            return;
        }
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        getCurrentHub().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code,
            },
            type: 'http',
        }, {
            xhr: handlerData.xhr,
            input: body,
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) {
        return;
    }
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
        // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
    }
    if (handlerData.error) {
        getCurrentHub().addBreadcrumb({
            category: 'fetch',
            data: handlerData.fetchData,
            level: Severity.Error,
            type: 'http',
        }, {
            data: handlerData.error,
            input: handlerData.args,
        });
    }
    else {
        getCurrentHub().addBreadcrumb({
            category: 'fetch',
            data: (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, handlerData.fetchData), { status_code: handlerData.response.status }),
            type: 'http',
        }, {
            input: handlerData.args,
            response: handlerData.response,
        });
    }
}
/**
 * Creates breadcrumbs from history API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _historyBreadcrumb(handlerData) {
    var global = getGlobalObject();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = parseUrl(global.location.href);
    var parsedFrom = parseUrl(from);
    var parsedTo = parseUrl(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) {
        parsedFrom = parsedLoc;
    }
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
        to = parsedTo.relative;
    }
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
        from = parsedFrom.relative;
    }
    getCurrentHub().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to,
        },
    });
}

var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var LinkedErrors = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        addGlobalEventProcessor(function (event, hint) {
            var self = getCurrentHub().getIntegration(LinkedErrors);
            return self ? _handler(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}());
/**
 * @inheritDoc
 */
function _handler(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !isInstanceOf(hint.originalException, Error)) {
        return event;
    }
    var linkedErrors = _walkErrorTree(limit, hint.originalException, key);
    event.exception.values = (0,FronteggApp_35f1a2b2.e)(linkedErrors, event.exception.values);
    return event;
}
/**
 * JSDOC
 */
function _walkErrorTree(limit, error, key, stack) {
    if (stack === void 0) { stack = []; }
    if (!isInstanceOf(error[key], Error) || stack.length + 1 >= limit) {
        return stack;
    }
    var exception = exceptionFromError(error[key]);
    return _walkErrorTree(limit, error[key], key, (0,FronteggApp_35f1a2b2.e)([exception], stack));
}

var global$5 = getGlobalObject();
/** UserAgent */
var UserAgent = /** @class */ (function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        addGlobalEventProcessor(function (event) {
            if (getCurrentHub().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!global$5.navigator && !global$5.location && !global$5.document) {
                    return event;
                }
                // grab as much info as exists and add it to the event
                var url = (event.request && event.request.url) || (global$5.location && global$5.location.href);
                var referrer = (global$5.document || {}).referrer;
                var userAgent = (global$5.navigator || {}).userAgent;
                var headers = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, (event.request && event.request.headers)), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
                var request = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, (url && { url: url })), { headers: headers });
                return (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, event), { request: request });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}());

/** Deduplication filter */
var Dedupe = /** @class */ (function () {
    function Dedupe() {
        /**
         * @inheritDoc
         */
        this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */
    Dedupe.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if (_shouldDropEvent(currentEvent, self._previousEvent)) {
                        logger.warn("Event dropped due to being a duplicate of previously captured event.");
                        return null;
                    }
                }
                catch (_oO) {
                    return (self._previousEvent = currentEvent);
                }
                return (self._previousEvent = currentEvent);
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */
    Dedupe.id = 'Dedupe';
    return Dedupe;
}());
/** JSDoc */
function _shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) {
        return false;
    }
    if (_isSameMessageEvent(currentEvent, previousEvent)) {
        return true;
    }
    if (_isSameExceptionEvent(currentEvent, previousEvent)) {
        return true;
    }
    return false;
}
/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) {
        return false;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
        return false;
    }
    if (currentMessage !== previousMessage) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = _getExceptionFromEvent(previousEvent);
    var currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) {
        return false;
    }
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = _getFramesFromEvent(currentEvent);
    var previousFrames = _getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) {
        return true;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
        return false;
    }
    currentFrames = currentFrames;
    previousFrames = previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) {
        return false;
    }
    // Otherwise, compare the two
    for (var i = 0; i < previousFrames.length; i++) {
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename ||
            frameA.lineno !== frameB.lineno ||
            frameA.colno !== frameB.colno ||
            frameA.function !== frameB.function) {
            return false;
        }
    }
    return true;
}
/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) {
        return true;
    }
    // If only one event has a fingerprint, but not the other one, they are not the same
    if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
        return false;
    }
    currentFingerprint = currentFingerprint;
    previousFingerprint = previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    }
    catch (_oO) {
        return false;
    }
}
/** JSDoc */
function _getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */
function _getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) {
        try {
            // @ts-ignore Object could be undefined
            return exception.values[0].stacktrace.frames;
        }
        catch (_oO) {
            return undefined;
        }
    }
    else if (event.stacktrace) {
        return event.stacktrace.frames;
    }
    return undefined;
}

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var BrowserClient = /** @class */ (function (_super) {
    (0,FronteggApp_35f1a2b2._)(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */
    function BrowserClient(options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: SDK_VERSION,
                },
            ],
            version: SDK_VERSION,
        };
        _this = _super.call(this, BrowserBackend, options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */
    BrowserClient.prototype.showReportDialog = function (options) {
        if (options === void 0) { options = {}; }
        // doesn't work without a document (React Native)
        var document = getGlobalObject().document;
        if (!document) {
            return;
        }
        if (!this._isEnabled()) {
            logger.error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        injectReportDialog((0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, options), { dsn: options.dsn || this.getDsn() }));
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._sendEvent = function (event) {
        var integration = this.getIntegration(Breadcrumbs);
        if (integration) {
            integration.addSentryBreadcrumb(event);
        }
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}(BaseClient));

var defaultIntegrations = [
    new InboundFilters(),
    new FunctionToString(),
    new TryCatch(),
    new Breadcrumbs(),
    new GlobalHandlers(),
    new LinkedErrors(),
    new Dedupe(),
    new UserAgent(),
];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init$1(options) {
    if (options === void 0) { options = {}; }
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = defaultIntegrations;
    }
    if (options.release === undefined) {
        var window_1 = getGlobalObject();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
            options.release = window_1.SENTRY_RELEASE.id;
        }
    }
    if (options.autoSessionTracking === undefined) {
        options.autoSessionTracking = true;
    }
    if (options.sendClientReports === undefined) {
        options.sendClientReports = true;
    }
    initAndBind(BrowserClient, options);
    if (options.autoSessionTracking) {
        startSessionTracking();
    }
}
function startSessionOnHub(hub) {
    hub.startSession({ ignoreDuration: true });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
    var window = getGlobalObject();
    var document = window.document;
    if (typeof document === 'undefined') {
        if (isDebugBuild()) {
            logger.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        }
        return;
    }
    var hub = getCurrentHub();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) {
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    addInstrumentationHandler('history', function (_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) {
            startSessionOnHub(getCurrentHub());
        }
    });
}

/**
 * Inits the React SDK
 */
function init(options) {
    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
        name: 'sentry.javascript.react',
        packages: [
            {
                name: 'npm:@sentry/react',
                version: SDK_VERSION,
            },
        ],
        version: SDK_VERSION,
    };
    init$1(options);
}

var TRACEPARENT_REGEXP = new RegExp('^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$');
/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(maybeOptions) {
    var client = getCurrentHub().getClient();
    var options = maybeOptions || (client && client.getOptions());
    return !!options && ('tracesSampleRate' in options || 'tracesSampler' in options);
}
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
    var matches = traceparent.match(TRACEPARENT_REGEXP);
    if (matches) {
        var parentSampled = void 0;
        if (matches[3] === '1') {
            parentSampled = true;
        }
        else if (matches[3] === '0') {
            parentSampled = false;
        }
        return {
            traceId: matches[1],
            parentSampled: parentSampled,
            parentSpanId: matches[2],
        };
    }
    return undefined;
}
/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
    var hub = maybeHub || getCurrentHub();
    var scope = hub.getScope();
    return scope && scope.getTransaction();
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
    return time / 1000;
}
/**
 * Converts from seconds to milliseconds
 * @param time time in seconds
 */
function secToMs(time) {
    return time * 1000;
}

/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
    addInstrumentationHandler('error', errorCallback);
    addInstrumentationHandler('unhandledrejection', errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
    var activeTransaction = getActiveTransaction();
    if (activeTransaction) {
        var status_1 = 'internal_error';
        logger.log("[Tracing] Transaction: " + status_1 + " -> Global error occured");
        activeTransaction.setStatus(status_1);
    }
}

// Store finish reasons in tuple to save on bundle size
// Readonly type should enforce that this is not mutated.
var FINISH_REASON_TAG = 'finishReason';
var IDLE_TRANSACTION_FINISH_REASONS = ['heartbeatFailed', 'idleTimeout', 'documentHidden'];

/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
var SpanRecorder = /** @class */ (function () {
    function SpanRecorder(maxlen) {
        if (maxlen === void 0) { maxlen = 1000; }
        this.spans = [];
        this._maxlen = maxlen;
    }
    /**
     * This is just so that we don't run out of memory while recording a lot
     * of spans. At some point we just stop and flush out the start of the
     * trace tree (i.e.the first n spans with the smallest
     * start_timestamp).
     */
    SpanRecorder.prototype.add = function (span) {
        if (this.spans.length > this._maxlen) {
            span.spanRecorder = undefined;
        }
        else {
            this.spans.push(span);
        }
    };
    return SpanRecorder;
}());
/**
 * Span contains all data about a span
 */
var Span = /** @class */ (function () {
    /**
     * You should never call the constructor manually, always use `Sentry.startTransaction()`
     * or call `startChild()` on an existing span.
     * @internal
     * @hideconstructor
     * @hidden
     */
    function Span(spanContext) {
        /**
         * @inheritDoc
         */
        this.traceId = uuid4();
        /**
         * @inheritDoc
         */
        this.spanId = uuid4().substring(16);
        /**
         * Timestamp in seconds when the span was created.
         */
        this.startTimestamp = timestampWithMs();
        /**
         * @inheritDoc
         */
        this.tags = {};
        /**
         * @inheritDoc
         */
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.data = {};
        if (!spanContext) {
            return this;
        }
        if (spanContext.traceId) {
            this.traceId = spanContext.traceId;
        }
        if (spanContext.spanId) {
            this.spanId = spanContext.spanId;
        }
        if (spanContext.parentSpanId) {
            this.parentSpanId = spanContext.parentSpanId;
        }
        // We want to include booleans as well here
        if ('sampled' in spanContext) {
            this.sampled = spanContext.sampled;
        }
        if (spanContext.op) {
            this.op = spanContext.op;
        }
        if (spanContext.description) {
            this.description = spanContext.description;
        }
        if (spanContext.data) {
            this.data = spanContext.data;
        }
        if (spanContext.tags) {
            this.tags = spanContext.tags;
        }
        if (spanContext.status) {
            this.status = spanContext.status;
        }
        if (spanContext.startTimestamp) {
            this.startTimestamp = spanContext.startTimestamp;
        }
        if (spanContext.endTimestamp) {
            this.endTimestamp = spanContext.endTimestamp;
        }
    }
    /**
     * @inheritDoc
     * @deprecated
     */
    Span.prototype.child = function (spanContext) {
        return this.startChild(spanContext);
    };
    /**
     * @inheritDoc
     */
    Span.prototype.startChild = function (spanContext) {
        var childSpan = new Span((0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, spanContext), { parentSpanId: this.spanId, sampled: this.sampled, traceId: this.traceId }));
        childSpan.spanRecorder = this.spanRecorder;
        if (childSpan.spanRecorder) {
            childSpan.spanRecorder.add(childSpan);
        }
        childSpan.transaction = this.transaction;
        return childSpan;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setTag = function (key, value) {
        var _a;
        this.tags = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this.tags), (_a = {}, _a[key] = value, _a));
        return this;
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Span.prototype.setData = function (key, value) {
        var _a;
        this.data = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this.data), (_a = {}, _a[key] = value, _a));
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setStatus = function (value) {
        this.status = value;
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setHttpStatus = function (httpStatus) {
        this.setTag('http.status_code', String(httpStatus));
        var spanStatus = spanStatusfromHttpCode(httpStatus);
        if (spanStatus !== 'unknown_error') {
            this.setStatus(spanStatus);
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.isSuccess = function () {
        return this.status === 'ok';
    };
    /**
     * @inheritDoc
     */
    Span.prototype.finish = function (endTimestamp) {
        this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : timestampWithMs();
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toTraceparent = function () {
        var sampledString = '';
        if (this.sampled !== undefined) {
            sampledString = this.sampled ? '-1' : '-0';
        }
        return this.traceId + "-" + this.spanId + sampledString;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toContext = function () {
        return dropUndefinedKeys({
            data: this.data,
            description: this.description,
            endTimestamp: this.endTimestamp,
            op: this.op,
            parentSpanId: this.parentSpanId,
            sampled: this.sampled,
            spanId: this.spanId,
            startTimestamp: this.startTimestamp,
            status: this.status,
            tags: this.tags,
            traceId: this.traceId,
        });
    };
    /**
     * @inheritDoc
     */
    Span.prototype.updateWithContext = function (spanContext) {
        var _a, _b, _c, _d, _e;
        this.data = (_a = spanContext.data, (_a !== null && _a !== void 0 ? _a : {}));
        this.description = spanContext.description;
        this.endTimestamp = spanContext.endTimestamp;
        this.op = spanContext.op;
        this.parentSpanId = spanContext.parentSpanId;
        this.sampled = spanContext.sampled;
        this.spanId = (_b = spanContext.spanId, (_b !== null && _b !== void 0 ? _b : this.spanId));
        this.startTimestamp = (_c = spanContext.startTimestamp, (_c !== null && _c !== void 0 ? _c : this.startTimestamp));
        this.status = spanContext.status;
        this.tags = (_d = spanContext.tags, (_d !== null && _d !== void 0 ? _d : {}));
        this.traceId = (_e = spanContext.traceId, (_e !== null && _e !== void 0 ? _e : this.traceId));
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.getTraceContext = function () {
        return dropUndefinedKeys({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            trace_id: this.traceId,
        });
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toJSON = function () {
        return dropUndefinedKeys({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            start_timestamp: this.startTimestamp,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this.endTimestamp,
            trace_id: this.traceId,
        });
    };
    return Span;
}());
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) {
        return 'ok';
    }
    if (httpStatus >= 400 && httpStatus < 500) {
        switch (httpStatus) {
            case 401:
                return 'unauthenticated';
            case 403:
                return 'permission_denied';
            case 404:
                return 'not_found';
            case 409:
                return 'already_exists';
            case 413:
                return 'failed_precondition';
            case 429:
                return 'resource_exhausted';
            default:
                return 'invalid_argument';
        }
    }
    if (httpStatus >= 500 && httpStatus < 600) {
        switch (httpStatus) {
            case 501:
                return 'unimplemented';
            case 503:
                return 'unavailable';
            case 504:
                return 'deadline_exceeded';
            default:
                return 'internal_error';
        }
    }
    return 'unknown_error';
}

/** JSDoc */
var Transaction = /** @class */ (function (_super) {
    (0,FronteggApp_35f1a2b2._)(Transaction, _super);
    /**
     * This constructor should never be called manually. Those instrumenting tracing should use
     * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
     * @internal
     * @hideconstructor
     * @hidden
     */
    function Transaction(transactionContext, hub) {
        var _this = _super.call(this, transactionContext) || this;
        _this._measurements = {};
        /**
         * The reference to the current hub.
         */
        _this._hub = getCurrentHub();
        if (isInstanceOf(hub, Hub)) {
            _this._hub = hub;
        }
        _this.name = transactionContext.name || '';
        _this.metadata = transactionContext.metadata || {};
        _this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        _this.transaction = _this;
        return _this;
    }
    /**
     * JSDoc
     */
    Transaction.prototype.setName = function (name) {
        this.name = name;
    };
    /**
     * Attaches SpanRecorder to the span itself
     * @param maxlen maximum number of spans that can be recorded
     */
    Transaction.prototype.initSpanRecorder = function (maxlen) {
        if (maxlen === void 0) { maxlen = 1000; }
        if (!this.spanRecorder) {
            this.spanRecorder = new SpanRecorder(maxlen);
        }
        this.spanRecorder.add(this);
    };
    /**
     * Set observed measurements for this transaction.
     * @hidden
     */
    Transaction.prototype.setMeasurements = function (measurements) {
        this._measurements = (0,FronteggApp_35f1a2b2.d)({}, measurements);
    };
    /**
     * Set metadata for this transaction.
     * @hidden
     */
    Transaction.prototype.setMetadata = function (newMetadata) {
        this.metadata = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, this.metadata), newMetadata);
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.finish = function (endTimestamp) {
        var _this = this;
        // This transaction is already finished, so we should not flush it again.
        if (this.endTimestamp !== undefined) {
            return undefined;
        }
        if (!this.name) {
            logger.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this.name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        _super.prototype.finish.call(this, endTimestamp);
        if (this.sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            logger.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            var client = this._hub.getClient();
            var transport = client && client.getTransport && client.getTransport();
            if (transport && transport.recordLostEvent) {
                transport.recordLostEvent('sample_rate', 'transaction');
            }
            return undefined;
        }
        var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function (s) { return s !== _this && s.endTimestamp; }) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            this.endTimestamp = finishedSpans.reduce(function (prev, current) {
                if (prev.endTimestamp && current.endTimestamp) {
                    return prev.endTimestamp > current.endTimestamp ? prev : current;
                }
                return prev;
            }).endTimestamp;
        }
        var transaction = {
            contexts: {
                trace: this.getTraceContext(),
            },
            spans: finishedSpans,
            start_timestamp: this.startTimestamp,
            tags: this.tags,
            timestamp: this.endTimestamp,
            transaction: this.name,
            type: 'transaction',
            sdkProcessingMetadata: this.metadata,
        };
        var hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            logger.log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        logger.log("[Tracing] Finishing " + this.op + " transaction: " + this.name + ".");
        return this._hub.captureEvent(transaction);
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.toContext = function () {
        var spanContext = _super.prototype.toContext.call(this);
        return dropUndefinedKeys((0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, spanContext), { name: this.name, trimEnd: this._trimEnd }));
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.updateWithContext = function (transactionContext) {
        var _a;
        _super.prototype.updateWithContext.call(this, transactionContext);
        this.name = (_a = transactionContext.name, (_a !== null && _a !== void 0 ? _a : ''));
        this._trimEnd = transactionContext.trimEnd;
        return this;
    };
    return Transaction;
}(Span));

var DEFAULT_IDLE_TIMEOUT = 1000;
var HEARTBEAT_INTERVAL = 5000;
/**
 * @inheritDoc
 */
var IdleTransactionSpanRecorder = /** @class */ (function (_super) {
    (0,FronteggApp_35f1a2b2._)(IdleTransactionSpanRecorder, _super);
    function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
        if (transactionSpanId === void 0) { transactionSpanId = ''; }
        var _this = _super.call(this, maxlen) || this;
        _this._pushActivity = _pushActivity;
        _this._popActivity = _popActivity;
        _this.transactionSpanId = transactionSpanId;
        return _this;
    }
    /**
     * @inheritDoc
     */
    IdleTransactionSpanRecorder.prototype.add = function (span) {
        var _this = this;
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanId !== this.transactionSpanId) {
            // We patch span.finish() to pop an activity after setting an endTimestamp.
            span.finish = function (endTimestamp) {
                span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : timestampWithMs();
                _this._popActivity(span.spanId);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if (span.endTimestamp === undefined) {
                this._pushActivity(span.spanId);
            }
        }
        _super.prototype.add.call(this, span);
    };
    return IdleTransactionSpanRecorder;
}(SpanRecorder));
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
var IdleTransaction = /** @class */ (function (_super) {
    (0,FronteggApp_35f1a2b2._)(IdleTransaction, _super);
    function IdleTransaction(transactionContext, _idleHub, 
    /**
     * The time to wait in ms until the idle transaction will be finished.
     * @default 1000
     */
    _idleTimeout, 
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope) {
        if (_idleTimeout === void 0) { _idleTimeout = DEFAULT_IDLE_TIMEOUT; }
        if (_onScope === void 0) { _onScope = false; }
        var _this = _super.call(this, transactionContext, _idleHub) || this;
        _this._idleHub = _idleHub;
        _this._idleTimeout = _idleTimeout;
        _this._onScope = _onScope;
        // Activities store a list of active spans
        _this.activities = {};
        // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
        _this._heartbeatCounter = 0;
        // We should not use heartbeat if we finished a transaction
        _this._finished = false;
        _this._beforeFinishCallbacks = [];
        if (_idleHub && _onScope) {
            // There should only be one active transaction on the scope
            clearActiveTransaction(_idleHub);
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            logger.log("Setting idle transaction on scope. Span ID: " + _this.spanId);
            _idleHub.configureScope(function (scope) { return scope.setSpan(_this); });
        }
        _this._initTimeout = setTimeout(function () {
            if (!_this._finished) {
                _this.finish();
            }
        }, _this._idleTimeout);
        return _this;
    }
    /** {@inheritDoc} */
    IdleTransaction.prototype.finish = function (endTimestamp) {
        var e_1, _a;
        var _this = this;
        if (endTimestamp === void 0) { endTimestamp = timestampWithMs(); }
        this._finished = true;
        this.activities = {};
        if (this.spanRecorder) {
            logger.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);
            try {
                for (var _b = (0,FronteggApp_35f1a2b2.c)(this._beforeFinishCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var callback = _c.value;
                    callback(this, endTimestamp);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            this.spanRecorder.spans = this.spanRecorder.spans.filter(function (span) {
                // If we are dealing with the transaction itself, we just return it
                if (span.spanId === _this.spanId) {
                    return true;
                }
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!span.endTimestamp) {
                    span.endTimestamp = endTimestamp;
                    span.setStatus('cancelled');
                    logger.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                var keepSpan = span.startTimestamp < endTimestamp;
                if (!keepSpan) {
                    logger.log('[Tracing] discarding Span since it happened after Transaction was finished', JSON.stringify(span, undefined, 2));
                }
                return keepSpan;
            });
            logger.log('[Tracing] flushing IdleTransaction');
        }
        else {
            logger.log('[Tracing] No active IdleTransaction');
        }
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            clearActiveTransaction(this._idleHub);
        }
        return _super.prototype.finish.call(this, endTimestamp);
    };
    /**
     * Register a callback function that gets excecuted before the transaction finishes.
     * Useful for cleanup or if you want to add any additional spans based on current context.
     *
     * This is exposed because users have no other way of running something before an idle transaction
     * finishes.
     */
    IdleTransaction.prototype.registerBeforeFinishCallback = function (callback) {
        this._beforeFinishCallbacks.push(callback);
    };
    /**
     * @inheritDoc
     */
    IdleTransaction.prototype.initSpanRecorder = function (maxlen) {
        var _this = this;
        if (!this.spanRecorder) {
            var pushActivity = function (id) {
                if (_this._finished) {
                    return;
                }
                _this._pushActivity(id);
            };
            var popActivity = function (id) {
                if (_this._finished) {
                    return;
                }
                _this._popActivity(id);
            };
            this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            logger.log('Starting heartbeat');
            this._pingHeartbeat();
        }
        this.spanRecorder.add(this);
    };
    /**
     * Start tracking a specific activity.
     * @param spanId The span id that represents the activity
     */
    IdleTransaction.prototype._pushActivity = function (spanId) {
        if (this._initTimeout) {
            clearTimeout(this._initTimeout);
            this._initTimeout = undefined;
        }
        logger.log("[Tracing] pushActivity: " + spanId);
        this.activities[spanId] = true;
        logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
    };
    /**
     * Remove an activity from usage
     * @param spanId The span id that represents the activity
     */
    IdleTransaction.prototype._popActivity = function (spanId) {
        var _this = this;
        if (this.activities[spanId]) {
            logger.log("[Tracing] popActivity " + spanId);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            var timeout = this._idleTimeout;
            // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampWithMs is in seconds, timeout is in ms
            var end_1 = timestampWithMs() + timeout / 1000;
            setTimeout(function () {
                if (!_this._finished) {
                    _this.setTag(FINISH_REASON_TAG, IDLE_TRANSACTION_FINISH_REASONS[1]);
                    _this.finish(end_1);
                }
            }, timeout);
        }
    };
    /**
     * Checks when entries of this.activities are not changing for 3 beats.
     * If this occurs we finish the transaction.
     */
    IdleTransaction.prototype._beat = function () {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) {
            return;
        }
        var heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) {
            this._heartbeatCounter += 1;
        }
        else {
            this._heartbeatCounter = 1;
        }
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            logger.log("[Tracing] Transaction finished because of no change for 3 heart beats");
            this.setStatus('deadline_exceeded');
            this.setTag(FINISH_REASON_TAG, IDLE_TRANSACTION_FINISH_REASONS[0]);
            this.finish();
        }
        else {
            this._pingHeartbeat();
        }
    };
    /**
     * Pings the heartbeat
     */
    IdleTransaction.prototype._pingHeartbeat = function () {
        var _this = this;
        logger.log("pinging Heartbeat -> current counter: " + this._heartbeatCounter);
        setTimeout(function () {
            _this._beat();
        }, HEARTBEAT_INTERVAL);
    };
    return IdleTransaction;
}(Transaction));
/**
 * Reset transaction on scope to `undefined`
 */
function clearActiveTransaction(hub) {
    if (hub) {
        var scope = hub.getScope();
        if (scope) {
            var transaction = scope.getTransaction();
            if (transaction) {
                scope.setSpan(undefined);
            }
        }
    }
}

/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
    var scope = this.getScope();
    if (scope) {
        var span = scope.getSpan();
        if (span) {
            return {
                'sentry-trace': span.toTraceparent(),
            };
        }
    }
    return {};
}
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */
function sample(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!hasTracingEnabled(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    if (transaction.sampled !== undefined) {
        transaction.setMetadata({
            transactionSampling: { method: 'explicitly_set' },
        });
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    var sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setMetadata({
            transactionSampling: {
                method: 'client_sampler',
                // cast to number in case it's a boolean
                rate: Number(sampleRate),
            },
        });
    }
    else if (samplingContext.parentSampled !== undefined) {
        sampleRate = samplingContext.parentSampled;
        transaction.setMetadata({
            transactionSampling: { method: 'inheritance' },
        });
    }
    else {
        sampleRate = options.tracesSampleRate;
        transaction.setMetadata({
            transactionSampling: {
                method: 'client_rate',
                // cast to number in case it's a boolean
                rate: Number(sampleRate),
            },
        });
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!isValidSampleRate(sampleRate)) {
        logger.warn("[Tracing] Discarding transaction because of invalid sample rate.");
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        logger.log("[Tracing] Discarding transaction because " + (typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'));
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        logger.log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = " + Number(sampleRate) + ")");
        return transaction;
    }
    logger.log("[Tracing] starting " + transaction.op + " transaction - " + transaction.name);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (isNaN(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        logger.warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got " + JSON.stringify(rate) + " of type " + JSON.stringify(typeof rate) + ".");
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        logger.warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got " + rate + ".");
        return false;
    }
    return true;
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(transactionContext, customSamplingContext) {
    var client = this.getClient();
    var options = (client && client.getOptions()) || {};
    var transaction = new Transaction(transactionContext, this);
    transaction = sample(transaction, options, (0,FronteggApp_35f1a2b2.d)({ parentSampled: transactionContext.parentSampled, transactionContext: transactionContext }, customSamplingContext));
    if (transaction.sampled) {
        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    }
    return transaction;
}
/**
 * Create new idle transaction.
 */
function startIdleTransaction(hub, transactionContext, idleTimeout, onScope, customSamplingContext) {
    var client = hub.getClient();
    var options = (client && client.getOptions()) || {};
    var transaction = new IdleTransaction(transactionContext, hub, idleTimeout, onScope);
    transaction = sample(transaction, options, (0,FronteggApp_35f1a2b2.d)({ parentSampled: transactionContext.parentSampled, transactionContext: transactionContext }, customSamplingContext));
    if (transaction.sampled) {
        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    }
    return transaction;
}
/**
 * @private
 */
function _addTracingExtensions() {
    var carrier = getMainCarrier();
    if (!carrier.__SENTRY__) {
        return;
    }
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) {
        carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
    }
    if (!carrier.__SENTRY__.extensions.traceHeaders) {
        carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
    }
}
/**
 * @private
 */
function _autoloadDatabaseIntegrations() {
    var carrier = getMainCarrier();
    if (!carrier.__SENTRY__) {
        return;
    }
    var packageToIntegrationMapping = {
        mongodb: function () {
            var integration = dynamicRequire(module, './integrations/node/mongo');
            return new integration.Mongo();
        },
        mongoose: function () {
            var integration = dynamicRequire(module, './integrations/node/mongo');
            return new integration.Mongo({ mongoose: true });
        },
        mysql: function () {
            var integration = dynamicRequire(module, './integrations/node/mysql');
            return new integration.Mysql();
        },
        pg: function () {
            var integration = dynamicRequire(module, './integrations/node/postgres');
            return new integration.Postgres();
        },
    };
    var mappedPackages = Object.keys(packageToIntegrationMapping)
        .filter(function (moduleName) { return !!loadModule(moduleName); })
        .map(function (pkg) {
        try {
            return packageToIntegrationMapping[pkg]();
        }
        catch (e) {
            return undefined;
        }
    })
        .filter(function (p) { return p; });
    if (mappedPackages.length > 0) {
        carrier.__SENTRY__.integrations = (0,FronteggApp_35f1a2b2.e)((carrier.__SENTRY__.integrations || []), mappedPackages);
    }
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */
function addExtensionMethods() {
    _addTracingExtensions();
    // Detect and automatically load specified integrations.
    if (isNodeEnv()) {
        _autoloadDatabaseIntegrations();
    }
    // If an error happens globally, we should make sure transaction status is set to error.
    registerErrorInstrumentation();
}

var global$4 = getGlobalObject();
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
    if (global$4 && global$4.document) {
        global$4.document.addEventListener('visibilitychange', function () {
            var activeTransaction = getActiveTransaction();
            if (global$4.document.hidden && activeTransaction) {
                var statusType = 'cancelled';
                logger.log("[Tracing] Transaction: " + statusType + " -> since tab moved to the background, op: " + activeTransaction.op);
                // We should not set status if it is already set, this prevent important statuses like
                // error or data loss from being overwritten on transaction.
                if (!activeTransaction.status) {
                    activeTransaction.setStatus(statusType);
                }
                activeTransaction.setTag('visibilitychange', 'document.hidden');
                activeTransaction.setTag(FINISH_REASON_TAG, IDLE_TRANSACTION_FINISH_REASONS[2]);
                activeTransaction.finish();
            }
        });
    }
    else {
        logger.warn('[Tracing] Could not set up background tab detection due to lack of global document');
    }
}

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var bindReporter = function (callback, metric, reportAllChanges) {
    var prevValue;
    return function (forceReport) {
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                metric.delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (metric.delta || prevValue === undefined) {
                    prevValue = metric.value;
                    callback(metric);
                }
            }
        }
    };
};

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
var generateUniqueID = function () {
    return "v2-" + Date.now() + "-" + (Math.floor(Math.random() * (9e12 - 1)) + 1e12);
};

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var initMetric = function (name, value) {
    return {
        name: name,
        value: (value !== null && value !== void 0 ? value : -1),
        delta: 0,
        entries: [],
        id: generateUniqueID(),
    };
};

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
var observe = function (type, callback) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            // More extensive feature detect needed for Firefox due to:
            // https://github.com/GoogleChrome/web-vitals/issues/142
            if (type === 'first-input' && !('PerformanceEventTiming' in self)) {
                return;
            }
            var po = new PerformanceObserver(function (l) { return l.getEntries().map(callback); });
            po.observe({ type: type, buffered: true });
            return po;
        }
    }
    catch (e) {
        // Do nothing.
    }
    return;
};

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var onHidden = function (cb, once) {
    var onHiddenOrPageHide = function (event) {
        if (event.type === 'pagehide' || getGlobalObject().document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener('visibilitychange', onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener('pagehide', onHiddenOrPageHide, true);
};

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var getCLS = function (onReport, reportAllChanges) {
    var metric = initMetric('CLS', 0);
    var report;
    var sessionValue = 0;
    var sessionEntries = [];
    var entryHandler = function (entry) {
        // Only count layout shifts without recent user input.
        // TODO: Figure out why entry can be undefined
        if (entry && !entry.hadRecentInput) {
            var firstSessionEntry = sessionEntries[0];
            var lastSessionEntry = sessionEntries[sessionEntries.length - 1];
            // If the entry occurred less than 1 second after the previous entry and
            // less than 5 seconds after the first entry in the session, include the
            // entry in the current session. Otherwise, start a new session.
            if (sessionValue &&
                sessionEntries.length !== 0 &&
                entry.startTime - lastSessionEntry.startTime < 1000 &&
                entry.startTime - firstSessionEntry.startTime < 5000) {
                sessionValue += entry.value;
                sessionEntries.push(entry);
            }
            else {
                sessionValue = entry.value;
                sessionEntries = [entry];
            }
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                if (report) {
                    report();
                }
            }
        }
    };
    var po = observe('layout-shift', entryHandler);
    if (po) {
        report = bindReporter(onReport, metric, reportAllChanges);
        onHidden(function () {
            po.takeRecords().map(entryHandler);
            report(true);
        });
    }
};

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var firstHiddenTime = -1;
var initHiddenTime = function () {
    return getGlobalObject().document.visibilityState === 'hidden' ? 0 : Infinity;
};
var trackChanges = function () {
    // Update the time if/when the document becomes hidden.
    onHidden(function (_a) {
        var timeStamp = _a.timeStamp;
        firstHiddenTime = timeStamp;
    }, true);
};
var getVisibilityWatcher = function () {
    if (firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        firstHiddenTime = initHiddenTime();
        trackChanges();
    }
    return {
        get firstHiddenTime() {
            return firstHiddenTime;
        },
    };
};

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var getFID = function (onReport, reportAllChanges) {
    var visibilityWatcher = getVisibilityWatcher();
    var metric = initMetric('FID');
    var report;
    var entryHandler = function (entry) {
        // Only report if the page wasn't hidden prior to the first input.
        if (report && entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    var po = observe('first-input', entryHandler);
    if (po) {
        report = bindReporter(onReport, metric, reportAllChanges);
        onHidden(function () {
            po.takeRecords().map(entryHandler);
            po.disconnect();
        }, true);
    }
};

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var reportedMetricIDs = {};
var getLCP = function (onReport, reportAllChanges) {
    var visibilityWatcher = getVisibilityWatcher();
    var metric = initMetric('LCP');
    var report;
    var entryHandler = function (entry) {
        // The startTime attribute returns the value of the renderTime if it is not 0,
        // and the value of the loadTime otherwise.
        var value = entry.startTime;
        // If the page was hidden prior to paint time of the entry,
        // ignore it and mark the metric as final, otherwise add the entry.
        if (value < visibilityWatcher.firstHiddenTime) {
            metric.value = value;
            metric.entries.push(entry);
        }
        if (report) {
            report();
        }
    };
    var po = observe('largest-contentful-paint', entryHandler);
    if (po) {
        report = bindReporter(onReport, metric, reportAllChanges);
        var stopListening_1 = function () {
            if (!reportedMetricIDs[metric.id]) {
                po.takeRecords().map(entryHandler);
                po.disconnect();
                reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        ['keydown', 'click'].forEach(function (type) {
            addEventListener(type, stopListening_1, { once: true, capture: true });
        });
        onHidden(stopListening_1, true);
    }
};

var global$3 = getGlobalObject();
/** Class tracking metrics  */
var MetricsInstrumentation = /** @class */ (function () {
    function MetricsInstrumentation(_reportAllChanges) {
        if (_reportAllChanges === void 0) { _reportAllChanges = false; }
        this._reportAllChanges = _reportAllChanges;
        this._measurements = {};
        this._performanceCursor = 0;
        if (!isNodeEnv() && global$3 && global$3.performance && global$3.document) {
            if (global$3.performance.mark) {
                global$3.performance.mark('sentry-tracing-init');
            }
            this._trackCLS();
            this._trackLCP();
            this._trackFID();
        }
    }
    /** Add performance related spans to a transaction */
    MetricsInstrumentation.prototype.addPerformanceEntries = function (transaction) {
        var _this = this;
        if (!global$3 || !global$3.performance || !global$3.performance.getEntries || !browserPerformanceTimeOrigin) {
            // Gatekeeper if performance API not available
            return;
        }
        logger.log('[Tracing] Adding & adjusting spans using Performance API');
        var timeOrigin = msToSec(browserPerformanceTimeOrigin);
        var responseStartTimestamp;
        var requestStartTimestamp;
        global$3.performance
            .getEntries()
            .slice(this._performanceCursor)
            .forEach(function (entry) {
            var startTime = msToSec(entry.startTime);
            var duration = msToSec(entry.duration);
            if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
                return;
            }
            switch (entry.entryType) {
                case 'navigation': {
                    addNavigationSpans(transaction, entry, timeOrigin);
                    responseStartTimestamp = timeOrigin + msToSec(entry.responseStart);
                    requestStartTimestamp = timeOrigin + msToSec(entry.requestStart);
                    break;
                }
                case 'mark':
                case 'paint':
                case 'measure': {
                    var startTimestamp = addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    var firstHidden = getVisibilityWatcher();
                    // Only report if the page wasn't hidden prior to the web vital.
                    var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        logger.log('[Measurements] Adding FP');
                        _this._measurements['fp'] = { value: entry.startTime };
                        _this._measurements['mark.fp'] = { value: startTimestamp };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        logger.log('[Measurements] Adding FCP');
                        _this._measurements['fcp'] = { value: entry.startTime };
                        _this._measurements['mark.fcp'] = { value: startTimestamp };
                    }
                    break;
                }
                case 'resource': {
                    var resourceName = entry.name.replace(global$3.location.origin, '');
                    addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
                    break;
                }
                // Ignore other entry types.
            }
        });
        this._performanceCursor = Math.max(performance.getEntries().length - 1, 0);
        this._trackNavigator(transaction);
        // Measurements are only available for pageload transactions
        if (transaction.op === 'pageload') {
            // normalize applicable web vital values to be relative to transaction.startTimestamp
            var timeOrigin_1 = msToSec(browserPerformanceTimeOrigin);
            // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
            // start of the response in milliseconds
            if (typeof responseStartTimestamp === 'number') {
                logger.log('[Measurements] Adding TTFB');
                this._measurements['ttfb'] = { value: (responseStartTimestamp - transaction.startTimestamp) * 1000 };
                if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
                    // Capture the time spent making the request and receiving the first byte of the response.
                    // This is the time between the start of the request and the start of the response in milliseconds.
                    this._measurements['ttfb.requestTime'] = { value: (responseStartTimestamp - requestStartTimestamp) * 1000 };
                }
            }
            ['fcp', 'fp', 'lcp'].forEach(function (name) {
                if (!_this._measurements[name] || timeOrigin_1 >= transaction.startTimestamp) {
                    return;
                }
                // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
                // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
                // to be adjusted to be relative to transaction.startTimestamp.
                var oldValue = _this._measurements[name].value;
                var measurementTimestamp = timeOrigin_1 + msToSec(oldValue);
                // normalizedValue should be in milliseconds
                var normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
                var delta = normalizedValue - oldValue;
                logger.log("[Measurements] Normalized " + name + " from " + oldValue + " to " + normalizedValue + " (" + delta + ")");
                _this._measurements[name].value = normalizedValue;
            });
            if (this._measurements['mark.fid'] && this._measurements['fid']) {
                // create span for FID
                _startChild(transaction, {
                    description: 'first input delay',
                    endTimestamp: this._measurements['mark.fid'].value + msToSec(this._measurements['fid'].value),
                    op: 'web.vitals',
                    startTimestamp: this._measurements['mark.fid'].value,
                });
            }
            // If FCP is not recorded we should not record the cls value
            // according to the new definition of CLS.
            if (!('fcp' in this._measurements)) {
                delete this._measurements.cls;
            }
            transaction.setMeasurements(this._measurements);
            tagMetricInfo(transaction, this._lcpEntry, this._clsEntry);
            transaction.setTag('sentry_reportAllChanges', this._reportAllChanges);
        }
    };
    /**
     * Capture the information of the user agent.
     */
    MetricsInstrumentation.prototype._trackNavigator = function (transaction) {
        var navigator = global$3.navigator;
        if (!navigator) {
            return;
        }
        // track network connectivity
        var connection = navigator.connection;
        if (connection) {
            if (connection.effectiveType) {
                transaction.setTag('effectiveConnectionType', connection.effectiveType);
            }
            if (connection.type) {
                transaction.setTag('connectionType', connection.type);
            }
            if (isMeasurementValue(connection.rtt)) {
                this._measurements['connection.rtt'] = { value: connection.rtt };
            }
            if (isMeasurementValue(connection.downlink)) {
                this._measurements['connection.downlink'] = { value: connection.downlink };
            }
        }
        if (isMeasurementValue(navigator.deviceMemory)) {
            transaction.setTag('deviceMemory', String(navigator.deviceMemory));
        }
        if (isMeasurementValue(navigator.hardwareConcurrency)) {
            transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
        }
    };
    /** Starts tracking the Cumulative Layout Shift on the current page. */
    MetricsInstrumentation.prototype._trackCLS = function () {
        var _this = this;
        // See:
        // https://web.dev/evolving-cls/
        // https://web.dev/cls-web-tooling/
        getCLS(function (metric) {
            var entry = metric.entries.pop();
            if (!entry) {
                return;
            }
            logger.log('[Measurements] Adding CLS');
            _this._measurements['cls'] = { value: metric.value };
            _this._clsEntry = entry;
        });
    };
    /** Starts tracking the Largest Contentful Paint on the current page. */
    MetricsInstrumentation.prototype._trackLCP = function () {
        var _this = this;
        getLCP(function (metric) {
            var entry = metric.entries.pop();
            if (!entry) {
                return;
            }
            var timeOrigin = msToSec(browserPerformanceTimeOrigin);
            var startTime = msToSec(entry.startTime);
            logger.log('[Measurements] Adding LCP');
            _this._measurements['lcp'] = { value: metric.value };
            _this._measurements['mark.lcp'] = { value: timeOrigin + startTime };
            _this._lcpEntry = entry;
        }, this._reportAllChanges);
    };
    /** Starts tracking the First Input Delay on the current page. */
    MetricsInstrumentation.prototype._trackFID = function () {
        var _this = this;
        getFID(function (metric) {
            var entry = metric.entries.pop();
            if (!entry) {
                return;
            }
            var timeOrigin = msToSec(browserPerformanceTimeOrigin);
            var startTime = msToSec(entry.startTime);
            logger.log('[Measurements] Adding FID');
            _this._measurements['fid'] = { value: metric.value };
            _this._measurements['mark.fid'] = { value: timeOrigin + startTime };
        });
    };
    return MetricsInstrumentation;
}());
/** Instrument navigation entries */
function addNavigationSpans(transaction, entry, timeOrigin) {
    ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(function (event) {
        addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    addRequest(transaction, entry, timeOrigin);
}
/** Create measure related spans */
function addMeasureSpans(transaction, entry, startTime, duration, timeOrigin) {
    var measureStartTimestamp = timeOrigin + startTime;
    var measureEndTimestamp = measureStartTimestamp + duration;
    _startChild(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        startTimestamp: measureStartTimestamp,
    });
    return measureStartTimestamp;
}
/** Create resource-related spans */
function addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
        return;
    }
    var data = {};
    if ('transferSize' in entry) {
        data['Transfer Size'] = entry.transferSize;
    }
    if ('encodedBodySize' in entry) {
        data['Encoded Body Size'] = entry.encodedBodySize;
    }
    if ('decodedBodySize' in entry) {
        data['Decoded Body Size'] = entry.decodedBodySize;
    }
    var startTimestamp = timeOrigin + startTime;
    var endTimestamp = startTimestamp + duration;
    _startChild(transaction, {
        description: resourceName,
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? "resource." + entry.initiatorType : 'resource',
        startTimestamp: startTimestamp,
        data: data,
    });
}
/** Create performance navigation related spans */
function addPerformanceNavigationTiming(transaction, entry, event, timeOrigin, description, eventEnd) {
    var end = eventEnd ? entry[eventEnd] : entry[event + "End"];
    var start = entry[event + "Start"];
    if (!start || !end) {
        return;
    }
    _startChild(transaction, {
        op: 'browser',
        description: (description !== null && description !== void 0 ? description : event),
        startTimestamp: timeOrigin + msToSec(start),
        endTimestamp: timeOrigin + msToSec(end),
    });
}
/** Create request and response related spans */
function addRequest(transaction, entry, timeOrigin) {
    _startChild(transaction, {
        op: 'browser',
        description: 'request',
        startTimestamp: timeOrigin + msToSec(entry.requestStart),
        endTimestamp: timeOrigin + msToSec(entry.responseEnd),
    });
    _startChild(transaction, {
        op: 'browser',
        description: 'response',
        startTimestamp: timeOrigin + msToSec(entry.responseStart),
        endTimestamp: timeOrigin + msToSec(entry.responseEnd),
    });
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, _a) {
    var startTimestamp = _a.startTimestamp, ctx = (0,FronteggApp_35f1a2b2.f)(_a, ["startTimestamp"]);
    if (startTimestamp && transaction.startTimestamp > startTimestamp) {
        transaction.startTimestamp = startTimestamp;
    }
    return transaction.startChild((0,FronteggApp_35f1a2b2.d)({ startTimestamp: startTimestamp }, ctx));
}
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
    return typeof value === 'number' && isFinite(value);
}
/** Add LCP / CLS data to transaction to allow debugging */
function tagMetricInfo(transaction, lcpEntry, clsEntry) {
    if (lcpEntry) {
        logger.log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if (lcpEntry.element) {
            transaction.setTag('lcp.element', htmlTreeAsString(lcpEntry.element));
        }
        if (lcpEntry.id) {
            transaction.setTag('lcp.id', lcpEntry.id);
        }
        if (lcpEntry.url) {
            // Trim URL to the first 200 characters.
            transaction.setTag('lcp.url', lcpEntry.url.trim().slice(0, 200));
        }
        transaction.setTag('lcp.size', lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if (clsEntry && clsEntry.sources) {
        logger.log('[Measurements] Adding CLS Data');
        clsEntry.sources.forEach(function (source, index) {
            return transaction.setTag("cls.source." + (index + 1), htmlTreeAsString(source.node));
        });
    }
}

var DEFAULT_TRACING_ORIGINS = ['localhost', /^\//];
var defaultRequestInstrumentationOptions = {
    traceFetch: true,
    traceXHR: true,
    tracingOrigins: DEFAULT_TRACING_ORIGINS,
};
/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    var _a = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, defaultRequestInstrumentationOptions), _options), traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
    // We should cache url -> decision so that we don't have to compute
    // regexp everytime we create a request.
    var urlMap = {};
    var defaultShouldCreateSpan = function (url) {
        if (urlMap[url]) {
            return urlMap[url];
        }
        var origins = tracingOrigins;
        urlMap[url] =
            origins.some(function (origin) { return isMatchingPattern(url, origin); }) &&
                !isMatchingPattern(url, 'sentry_key');
        return urlMap[url];
    };
    // We want that our users don't have to re-implement shouldCreateSpanForRequest themselves
    // That's why we filter out already unwanted Spans from tracingOrigins
    var shouldCreateSpan = defaultShouldCreateSpan;
    if (typeof shouldCreateSpanForRequest === 'function') {
        shouldCreateSpan = function (url) {
            return defaultShouldCreateSpan(url) && shouldCreateSpanForRequest(url);
        };
    }
    var spans = {};
    if (traceFetch) {
        addInstrumentationHandler('fetch', function (handlerData) {
            fetchCallback(handlerData, shouldCreateSpan, spans);
        });
    }
    if (traceXHR) {
        addInstrumentationHandler('xhr', function (handlerData) {
            xhrCallback(handlerData, shouldCreateSpan, spans);
        });
    }
}
/**
 * Create and track fetch request spans
 */
function fetchCallback(handlerData, shouldCreateSpan, spans) {
    if (!hasTracingEnabled() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
        return;
    }
    if (handlerData.endTimestamp) {
        var spanId = handlerData.fetchData.__span;
        if (!spanId)
            return;
        var span = spans[spanId];
        if (span) {
            if (handlerData.response) {
                // TODO (kmclb) remove this once types PR goes through
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                span.setHttpStatus(handlerData.response.status);
            }
            else if (handlerData.error) {
                span.setStatus('internal_error');
            }
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    var activeTransaction = getActiveTransaction();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, handlerData.fetchData), { type: 'fetch' }),
            description: handlerData.fetchData.method + " " + handlerData.fetchData.url,
            op: 'http.client',
        });
        handlerData.fetchData.__span = span.spanId;
        spans[span.spanId] = span;
        var request = (handlerData.args[0] = handlerData.args[0]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var options = (handlerData.args[1] = handlerData.args[1] || {});
        var headers = options.headers;
        if (isInstanceOf(request, Request)) {
            headers = request.headers;
        }
        if (headers) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (typeof headers.append === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                headers.append('sentry-trace', span.toTraceparent());
            }
            else if (Array.isArray(headers)) {
                headers = (0,FronteggApp_35f1a2b2.e)(headers, [['sentry-trace', span.toTraceparent()]]);
            }
            else {
                headers = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, headers), { 'sentry-trace': span.toTraceparent() });
            }
        }
        else {
            headers = { 'sentry-trace': span.toTraceparent() };
        }
        options.headers = headers;
    }
}
/**
 * Create and track xhr request spans
 */
function xhrCallback(handlerData, shouldCreateSpan, spans) {
    if (!hasTracingEnabled() ||
        (handlerData.xhr && handlerData.xhr.__sentry_own_request__) ||
        !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))) {
        return;
    }
    var xhr = handlerData.xhr.__sentry_xhr__;
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp) {
        var spanId = handlerData.xhr.__sentry_xhr_span_id__;
        if (!spanId)
            return;
        var span = spans[spanId];
        if (span) {
            span.setHttpStatus(xhr.status_code);
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    // if not, create a new span to track it
    var activeTransaction = getActiveTransaction();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, xhr.data), { type: 'xhr', method: xhr.method, url: xhr.url }),
            description: xhr.method + " " + xhr.url,
            op: 'http.client',
        });
        handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
        spans[handlerData.xhr.__sentry_xhr_span_id__] = span;
        if (handlerData.xhr.setRequestHeader) {
            try {
                handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());
            }
            catch (_) {
                // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
            }
        }
    }
}

var global$2 = getGlobalObject();
/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(customStartTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
    if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
    if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
    if (!global$2 || !global$2.location) {
        logger.warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    var startingUrl = global$2.location.href;
    var activeTransaction;
    if (startTransactionOnPageLoad) {
        activeTransaction = customStartTransaction({ name: global$2.location.pathname, op: 'pageload' });
    }
    if (startTransactionOnLocationChange) {
        addInstrumentationHandler('history', function (_a) {
            var to = _a.to, from = _a.from;
            /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */
            if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                startingUrl = undefined;
                return;
            }
            if (from !== to) {
                startingUrl = undefined;
                if (activeTransaction) {
                    logger.log("[Tracing] Finishing current transaction with op: " + activeTransaction.op);
                    // If there's an open transaction on the scope, we need to finish it before creating an new one.
                    activeTransaction.finish();
                }
                activeTransaction = customStartTransaction({ name: global$2.location.pathname, op: 'navigation' });
            }
        });
    }
}

var DEFAULT_MAX_TRANSACTION_DURATION_SECONDS = 600;
var DEFAULT_BROWSER_TRACING_OPTIONS = (0,FronteggApp_35f1a2b2.d)({ idleTimeout: DEFAULT_IDLE_TIMEOUT, markBackgroundTransactions: true, maxTransactionDuration: DEFAULT_MAX_TRANSACTION_DURATION_SECONDS, routingInstrumentation: instrumentRoutingWithDefaults, startTransactionOnLocationChange: true, startTransactionOnPageLoad: true }, defaultRequestInstrumentationOptions);
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
var BrowserTracing = /** @class */ (function () {
    function BrowserTracing(_options) {
        /**
         * @inheritDoc
         */
        this.name = BrowserTracing.id;
        this._emitOptionsWarning = false;
        /** Store configured idle timeout so that it can be added as a tag to transactions */
        this._configuredIdleTimeout = undefined;
        var tracingOrigins = defaultRequestInstrumentationOptions.tracingOrigins;
        // NOTE: Logger doesn't work in constructors, as it's initialized after integrations instances
        if (_options) {
            this._configuredIdleTimeout = _options.idleTimeout;
            if (_options.tracingOrigins && Array.isArray(_options.tracingOrigins) && _options.tracingOrigins.length !== 0) {
                tracingOrigins = _options.tracingOrigins;
            }
            else {
                this._emitOptionsWarning = true;
            }
        }
        this.options = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, DEFAULT_BROWSER_TRACING_OPTIONS), _options), { tracingOrigins: tracingOrigins });
        var _metricOptions = this.options._metricOptions;
        this._metrics = new MetricsInstrumentation(_metricOptions && _metricOptions._reportAllChanges);
    }
    /**
     * @inheritDoc
     */
    BrowserTracing.prototype.setupOnce = function (_, getCurrentHub) {
        var _this = this;
        this._getCurrentHub = getCurrentHub;
        if (this._emitOptionsWarning) {
            logger.warn('[Tracing] You need to define `tracingOrigins` in the options. Set an array of urls or patterns to trace.');
            logger.warn("[Tracing] We added a reasonable default for you: " + defaultRequestInstrumentationOptions.tracingOrigins);
        }
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.options, instrumentRouting = _a.routingInstrumentation, startTransactionOnLocationChange = _a.startTransactionOnLocationChange, startTransactionOnPageLoad = _a.startTransactionOnPageLoad, markBackgroundTransactions = _a.markBackgroundTransactions, traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
        instrumentRouting(function (context) { return _this._createRouteTransaction(context); }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) {
            registerBackgroundTabDetection();
        }
        instrumentOutgoingRequests({ traceFetch: traceFetch, traceXHR: traceXHR, tracingOrigins: tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest });
    };
    /** Create routing idle transaction. */
    BrowserTracing.prototype._createRouteTransaction = function (context) {
        var _this = this;
        if (!this._getCurrentHub) {
            logger.warn("[Tracing] Did not create " + context.op + " transaction because _getCurrentHub is invalid.");
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.options, beforeNavigate = _a.beforeNavigate, idleTimeout = _a.idleTimeout, maxTransactionDuration = _a.maxTransactionDuration;
        var parentContextFromHeader = context.op === 'pageload' ? getHeaderContext() : undefined;
        var expandedContext = (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, context), parentContextFromHeader), { trimEnd: true });
        var modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        var finalContext = modifiedContext === undefined ? (0,FronteggApp_35f1a2b2.d)((0,FronteggApp_35f1a2b2.d)({}, expandedContext), { sampled: false }) : modifiedContext;
        if (finalContext.sampled === false) {
            logger.log("[Tracing] Will not send " + finalContext.op + " transaction because of beforeNavigate.");
        }
        logger.log("[Tracing] Starting " + finalContext.op + " transaction on scope");
        var hub = this._getCurrentHub();
        var location = getGlobalObject().location;
        var idleTransaction = startIdleTransaction(hub, finalContext, idleTimeout, true, { location: location });
        idleTransaction.registerBeforeFinishCallback(function (transaction, endTimestamp) {
            _this._metrics.addPerformanceEntries(transaction);
            adjustTransactionDuration(secToMs(maxTransactionDuration), transaction, endTimestamp);
        });
        idleTransaction.setTag('idleTimeout', this._configuredIdleTimeout);
        return idleTransaction;
    };
    /**
     * @inheritDoc
     */
    BrowserTracing.id = 'BrowserTracing';
    return BrowserTracing;
}());
/**
 * Gets transaction context from a sentry-trace meta.
 *
 * @returns Transaction context data from the header or undefined if there's no header or the header is malformed
 */
function getHeaderContext() {
    var header = getMetaContent('sentry-trace');
    if (header) {
        return extractTraceparentData(header);
    }
    return undefined;
}
/** Returns the value of a meta tag */
function getMetaContent(metaName) {
    var el = getGlobalObject().document.querySelector("meta[name=" + metaName + "]");
    return el ? el.getAttribute('content') : null;
}
/** Adjusts transaction value based on max transaction duration */
function adjustTransactionDuration(maxDuration, transaction, endTimestamp) {
    var diff = endTimestamp - transaction.startTimestamp;
    var isOutdatedTransaction = endTimestamp && (diff > maxDuration || diff < 0);
    if (isOutdatedTransaction) {
        transaction.setStatus('deadline_exceeded');
        transaction.setTag('maxTransactionDurationExceeded', 'true');
    }
}

// We are patching the global object with our hub extension methods
addExtensionMethods();

var global$1 = getGlobalObject();
/** Send Console API calls as Sentry Events */
var CaptureConsole = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function CaptureConsole(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = CaptureConsole.id;
        /**
         * @inheritDoc
         */
        this._levels = ['log', 'info', 'warn', 'error', 'debug', 'assert'];
        if (options.levels) {
            this._levels = options.levels;
        }
    }
    /**
     * @inheritDoc
     */
    CaptureConsole.prototype.setupOnce = function (_, getCurrentHub) {
        if (!('console' in global$1)) {
            return;
        }
        this._levels.forEach(function (level) {
            if (!(level in global$1.console)) {
                return;
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            fill(global$1.console, level, function (originalConsoleMethod) { return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                var hub = getCurrentHub();
                if (hub.getIntegration(CaptureConsole)) {
                    hub.withScope(function (scope) {
                        scope.setLevel(severityFromString(level));
                        scope.setExtra('arguments', args);
                        scope.addEventProcessor(function (event) {
                            event.logger = 'console';
                            return event;
                        });
                        var message = safeJoin(args, ' ');
                        if (level === 'assert') {
                            if (args[0] === false) {
                                message = "Assertion failed: " + (safeJoin(args.slice(1), ' ') || 'console.assert');
                                scope.setExtra('arguments', args.slice(1));
                                hub.captureMessage(message);
                            }
                        }
                        else if (level === 'error' && args[0] instanceof Error) {
                            hub.captureException(args[0]);
                        }
                        else {
                            hub.captureMessage(message);
                        }
                    });
                }
                // this fails for some browsers. :(
                if (originalConsoleMethod) {
                    originalConsoleMethod.apply(global$1.console, args);
                }
            }; });
        });
    };
    /**
     * @inheritDoc
     */
    CaptureConsole.id = 'CaptureConsole';
    return CaptureConsole;
}());

var createStyled$1 = {};

var interopRequireDefault = {exports: {}};

(function (module) {
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

module.exports = _interopRequireDefault;
module.exports["default"] = module.exports, module.exports.__esModule = true;
}(interopRequireDefault));

var _extends$3 = {exports: {}};

(function (module) {
function _extends() {
  module.exports = _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  module.exports["default"] = module.exports, module.exports.__esModule = true;
  return _extends.apply(this, arguments);
}

module.exports = _extends;
module.exports["default"] = module.exports, module.exports.__esModule = true;
}(_extends$3));

var objectWithoutPropertiesLoose = {exports: {}};

(function (module) {
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

module.exports = _objectWithoutPropertiesLoose;
module.exports["default"] = module.exports, module.exports.__esModule = true;
}(objectWithoutPropertiesLoose));

var require$$3 = /*@__PURE__*/(0,formik_esm_baae0afb.g)(formik_esm_baae0afb.a);

var require$$5 = /*@__PURE__*/(0,formik_esm_baae0afb.g)(createTheme);

var require$$6 = /*@__PURE__*/(0,formik_esm_baae0afb.g)(styleFunctionSx);

var propsToClassKey$1 = {};

var _interopRequireDefault$1 = interopRequireDefault.exports;

Object.defineProperty(propsToClassKey$1, "__esModule", {
  value: true
});
propsToClassKey$1.default = propsToClassKey;

var _objectWithoutPropertiesLoose2$1 = _interopRequireDefault$1(objectWithoutPropertiesLoose.exports);

var _utils = formik_esm_baae0afb.r;

const _excluded$1 = ["variant"];

function isEmpty$1(string) {
  return string.length === 0;
}
/**
 * Generates string classKey based on the properties provided. It starts with the
 * variant if defined, and then it appends all other properties in alphabetical order.
 * @param {object} props - the properties for which the classKey should be created.
 */


function propsToClassKey(props) {
  const {
    variant
  } = props,
        other = (0, _objectWithoutPropertiesLoose2$1.default)(props, _excluded$1);
  let classKey = variant || '';
  Object.keys(other).sort().forEach(key => {
    if (key === 'color') {
      classKey += isEmpty$1(classKey) ? props[key] : (0, _utils.unstable_capitalize)(props[key]);
    } else {
      classKey += `${isEmpty$1(classKey) ? key : (0, _utils.unstable_capitalize)(key)}${(0, _utils.unstable_capitalize)(props[key].toString())}`;
    }
  });
  return classKey;
}

var _interopRequireDefault = interopRequireDefault.exports;

Object.defineProperty(createStyled$1, "__esModule", {
  value: true
});
createStyled$1.shouldForwardProp = shouldForwardProp;
var _default = createStyled$1.default = createStyled;
createStyled$1.systemDefaultTheme = void 0;

var _extends2 = _interopRequireDefault(_extends$3.exports);

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(objectWithoutPropertiesLoose.exports);

var _styledEngine = _interopRequireDefault(require$$3);

var _createTheme = _interopRequireDefault(require$$5);

var _styleFunctionSx = _interopRequireDefault(require$$6);

var _propsToClassKey = _interopRequireDefault(propsToClassKey$1);

const _excluded = ["name", "slot", "skipVariantsResolver", "skipSx", "overridesResolver"],
      _excluded2 = ["theme"],
      _excluded3 = ["theme"];

function isEmpty(obj) {
  return Object.keys(obj).length === 0;
}

const getStyleOverrides = (name, theme) => {
  if (theme.components && theme.components[name] && theme.components[name].styleOverrides) {
    return theme.components[name].styleOverrides;
  }

  return null;
};

const getVariantStyles = (name, theme) => {
  let variants = [];

  if (theme && theme.components && theme.components[name] && theme.components[name].variants) {
    variants = theme.components[name].variants;
  }

  const variantsStyles = {};
  variants.forEach(definition => {
    const key = (0, _propsToClassKey.default)(definition.props);
    variantsStyles[key] = definition.style;
  });
  return variantsStyles;
};

const variantsResolver = (props, styles, theme, name) => {
  var _theme$components, _theme$components$nam;

  const {
    ownerState = {}
  } = props;
  const variantsStyles = [];
  const themeVariants = theme == null ? void 0 : (_theme$components = theme.components) == null ? void 0 : (_theme$components$nam = _theme$components[name]) == null ? void 0 : _theme$components$nam.variants;

  if (themeVariants) {
    themeVariants.forEach(themeVariant => {
      let isMatch = true;
      Object.keys(themeVariant.props).forEach(key => {
        if (ownerState[key] !== themeVariant.props[key] && props[key] !== themeVariant.props[key]) {
          isMatch = false;
        }
      });

      if (isMatch) {
        variantsStyles.push(styles[(0, _propsToClassKey.default)(themeVariant.props)]);
      }
    });
  }

  return variantsStyles;
};

function shouldForwardProp(prop) {
  return prop !== 'ownerState' && prop !== 'theme' && prop !== 'sx' && prop !== 'as';
}

const systemDefaultTheme = (0, _createTheme.default)();
createStyled$1.systemDefaultTheme = systemDefaultTheme;

function createStyled(input = {}) {
  const {
    defaultTheme = systemDefaultTheme,
    rootShouldForwardProp = shouldForwardProp,
    slotShouldForwardProp = shouldForwardProp
  } = input;
  return (tag, inputOptions = {}) => {
    const {
      name: componentName,
      slot: componentSlot,
      skipVariantsResolver: inputSkipVariantsResolver,
      skipSx: inputSkipSx,
      overridesResolver
    } = inputOptions,
          options = (0, _objectWithoutPropertiesLoose2.default)(inputOptions, _excluded); // if skipVariantsResolver option is defined, take the value, otherwise, true for root and false for other slots.

    const skipVariantsResolver = inputSkipVariantsResolver !== undefined ? inputSkipVariantsResolver : componentSlot && componentSlot !== 'Root' || false;
    const skipSx = inputSkipSx || false;
    let label;

    let shouldForwardPropOption = shouldForwardProp;

    if (componentSlot === 'Root') {
      shouldForwardPropOption = rootShouldForwardProp;
    } else if (componentSlot) {
      // any other slot specified
      shouldForwardPropOption = slotShouldForwardProp;
    }

    const defaultStyledResolver = (0, _styledEngine.default)(tag, (0, _extends2.default)({
      shouldForwardProp: shouldForwardPropOption,
      label
    }, options));

    const muiStyledResolver = (styleArg, ...expressions) => {
      const expressionsWithDefaultTheme = expressions ? expressions.map(stylesArg => {
        return typeof stylesArg === 'function' ? _ref => {
          let {
            theme: themeInput
          } = _ref,
              other = (0, _objectWithoutPropertiesLoose2.default)(_ref, _excluded2);
          return stylesArg((0, _extends2.default)({
            theme: isEmpty(themeInput) ? defaultTheme : themeInput
          }, other));
        } : stylesArg;
      }) : [];
      let transformedStyleArg = styleArg;

      if (componentName && overridesResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = isEmpty(props.theme) ? defaultTheme : props.theme;
          const styleOverrides = getStyleOverrides(componentName, theme);

          if (styleOverrides) {
            return overridesResolver(props, styleOverrides);
          }

          return null;
        });
      }

      if (componentName && !skipVariantsResolver) {
        expressionsWithDefaultTheme.push(props => {
          const theme = isEmpty(props.theme) ? defaultTheme : props.theme;
          return variantsResolver(props, getVariantStyles(componentName, theme), theme, componentName);
        });
      }

      if (!skipSx) {
        expressionsWithDefaultTheme.push(props => {
          const theme = isEmpty(props.theme) ? defaultTheme : props.theme;
          return (0, _styleFunctionSx.default)((0, _extends2.default)({}, props, {
            theme
          }));
        });
      }

      const numOfCustomFnsApplied = expressionsWithDefaultTheme.length - expressions.length;

      if (Array.isArray(styleArg) && numOfCustomFnsApplied > 0) {
        const placeholders = new Array(numOfCustomFnsApplied).fill(''); // If the type is array, than we need to add placeholders in the template for the overrides, variants and the sx styles.

        transformedStyleArg = [...styleArg, ...placeholders];
        transformedStyleArg.raw = [...styleArg.raw, ...placeholders];
      } else if (typeof styleArg === 'function') {
        // If the type is function, we need to define the default theme.
        transformedStyleArg = _ref2 => {
          let {
            theme: themeInput
          } = _ref2,
              other = (0, _objectWithoutPropertiesLoose2.default)(_ref2, _excluded3);
          return styleArg((0, _extends2.default)({
            theme: isEmpty(themeInput) ? defaultTheme : themeInput
          }, other));
        };
      }

      const Component = defaultStyledResolver(transformedStyleArg, ...expressionsWithDefaultTheme);

      return Component;
    };

    return muiStyledResolver;
  };
}

/*!
 * get-value <https://github.com/jonschlinkert/get-value>
 *
 * Copyright (c) 2014-2018, Jon Schlinkert.
 * Released under the MIT License.
 */

const isObject = formik_esm_baae0afb.i;

var getValue = function(target, path, options) {
  if (!isObject(options)) {
    options = { default: options };
  }

  if (!isValidObject(target)) {
    return typeof options.default !== 'undefined' ? options.default : target;
  }

  if (typeof path === 'number') {
    path = String(path);
  }

  const isArray = Array.isArray(path);
  const isString = typeof path === 'string';
  const splitChar = options.separator || '.';
  const joinChar = options.joinChar || (typeof splitChar === 'string' ? splitChar : '.');

  if (!isString && !isArray) {
    return target;
  }

  if (isString && path in target) {
    return isValid(path, target, options) ? target[path] : options.default;
  }

  let segs = isArray ? path : split(path, splitChar, options);
  let len = segs.length;
  let idx = 0;

  do {
    let prop = segs[idx];
    if (typeof prop === 'number') {
      prop = String(prop);
    }

    while (prop && prop.slice(-1) === '\\') {
      prop = join([prop.slice(0, -1), segs[++idx] || ''], joinChar, options);
    }

    if (prop in target) {
      if (!isValid(prop, target, options)) {
        return options.default;
      }

      target = target[prop];
    } else {
      let hasProp = false;
      let n = idx + 1;

      while (n < len) {
        prop = join([prop, segs[n++]], joinChar, options);

        if ((hasProp = prop in target)) {
          if (!isValid(prop, target, options)) {
            return options.default;
          }

          target = target[prop];
          idx = n - 1;
          break;
        }
      }

      if (!hasProp) {
        return options.default;
      }
    }
  } while (++idx < len && isValidObject(target));

  if (idx === len) {
    return target;
  }

  return options.default;
};

function join(segs, joinChar, options) {
  if (typeof options.join === 'function') {
    return options.join(segs);
  }
  return segs[0] + joinChar + segs[1];
}

function split(path, splitChar, options) {
  if (typeof options.split === 'function') {
    return options.split(path);
  }
  return path.split(splitChar);
}

function isValid(key, target, options) {
  if (typeof options.isValid === 'function') {
    return options.isValid(key, target);
  }
  return true;
}

function isValidObject(val) {
  return isObject(val) || Array.isArray(val) || typeof val === 'function';
}

var getValue$1 = getValue;

const index_861a4b16_toString = Object.prototype.toString;
const errorToString = Error.prototype.toString;
const regExpToString = RegExp.prototype.toString;
const symbolToString = typeof Symbol !== 'undefined' ? Symbol.prototype.toString : () => '';
const SYMBOL_REGEXP = /^Symbol\((.*)\)(.*)$/;

function printNumber(val) {
  if (val != +val) return 'NaN';
  const isNegativeZero = val === 0 && 1 / val < 0;
  return isNegativeZero ? '-0' : '' + val;
}

function printSimpleValue(val, quoteStrings = false) {
  if (val == null || val === true || val === false) return '' + val;
  const typeOf = typeof val;
  if (typeOf === 'number') return printNumber(val);
  if (typeOf === 'string') return quoteStrings ? `"${val}"` : val;
  if (typeOf === 'function') return '[Function ' + (val.name || 'anonymous') + ']';
  if (typeOf === 'symbol') return symbolToString.call(val).replace(SYMBOL_REGEXP, 'Symbol($1)');
  const tag = index_861a4b16_toString.call(val).slice(8, -1);
  if (tag === 'Date') return isNaN(val.getTime()) ? '' + val : val.toISOString(val);
  if (tag === 'Error' || val instanceof Error) return '[' + errorToString.call(val) + ']';
  if (tag === 'RegExp') return regExpToString.call(val);
  return null;
}

function printValue(value, quoteStrings) {
  let result = printSimpleValue(value, quoteStrings);
  if (result !== null) return result;
  return JSON.stringify(value, function (key, value) {
    let result = printSimpleValue(this[key], quoteStrings);
    if (result !== null) return result;
    return value;
  }, 2);
}

let mixed = {
  default: '${path} is invalid',
  required: '${path} is a required field',
  oneOf: '${path} must be one of the following values: ${values}',
  notOneOf: '${path} must not be one of the following values: ${values}',
  notType: ({
    path,
    type,
    value,
    originalValue
  }) => {
    let isCast = originalValue != null && originalValue !== value;
    let msg = `${path} must be a \`${type}\` type, ` + `but the final value was: \`${printValue(value, true)}\`` + (isCast ? ` (cast from the value \`${printValue(originalValue, true)}\`).` : '.');

    if (value === null) {
      msg += `\n If "null" is intended as an empty value be sure to mark the schema as \`.nullable()\``;
    }

    return msg;
  },
  defined: '${path} must be defined'
};
let string = {
  length: '${path} must be exactly ${length} characters',
  min: '${path} must be at least ${min} characters',
  max: '${path} must be at most ${max} characters',
  matches: '${path} must match the following: "${regex}"',
  email: '${path} must be a valid email',
  url: '${path} must be a valid URL',
  uuid: '${path} must be a valid UUID',
  trim: '${path} must be a trimmed string',
  lowercase: '${path} must be a lowercase string',
  uppercase: '${path} must be a upper case string'
};
let number = {
  min: '${path} must be greater than or equal to ${min}',
  max: '${path} must be less than or equal to ${max}',
  lessThan: '${path} must be less than ${less}',
  moreThan: '${path} must be greater than ${more}',
  positive: '${path} must be a positive number',
  negative: '${path} must be a negative number',
  integer: '${path} must be an integer'
};
let date = {
  min: '${path} field must be later than ${min}',
  max: '${path} field must be at earlier than ${max}'
};
let index_861a4b16_boolean = {
  isValue: '${path} field must be ${value}'
};
let object = {
  noUnknown: '${path} field has unspecified keys: ${unknown}'
};
let array = {
  min: '${path} field must have at least ${min} items',
  max: '${path} field must have less than or equal to ${max} items',
  length: '${path} must be have ${length} items'
};
Object.assign(Object.create(null), {
  mixed,
  string,
  number,
  date,
  object,
  array,
  boolean: index_861a4b16_boolean
});

var isSchema = (obj => obj && obj.__isYupSchema__);

class Condition {
  constructor(refs, options) {
    this.refs = refs;
    this.refs = refs;

    if (typeof options === 'function') {
      this.fn = options;
      return;
    }

    if (!(0,formik_esm_baae0afb.h)(options, 'is')) throw new TypeError('`is:` is required for `when()` conditions');
    if (!options.then && !options.otherwise) throw new TypeError('either `then:` or `otherwise:` is required for `when()` conditions');
    let {
      is,
      then,
      otherwise
    } = options;
    let check = typeof is === 'function' ? is : (...values) => values.every(value => value === is);

    this.fn = function (...args) {
      let options = args.pop();
      let schema = args.pop();
      let branch = check(...args) ? then : otherwise;
      if (!branch) return undefined;
      if (typeof branch === 'function') return branch(schema);
      return schema.concat(branch.resolve(options));
    };
  }

  resolve(base, options) {
    let values = this.refs.map(ref => ref.getValue(options == null ? void 0 : options.value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context));
    let schema = this.fn.apply(base, values.concat(base, options));
    if (schema === undefined || schema === base) return base;
    if (!isSchema(schema)) throw new TypeError('conditions must return a schema object');
    return schema.resolve(options);
  }

}

var Condition$1 = Condition;

function toArray(value) {
  return value == null ? [] : [].concat(value);
}

function _extends$2() { _extends$2 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
let strReg = /\$\{\s*(\w+)\s*\}/g;
class ValidationError extends Error {
  static formatError(message, params) {
    const path = params.label || params.path || 'this';
    if (path !== params.path) params = _extends$2({}, params, {
      path
    });
    if (typeof message === 'string') return message.replace(strReg, (_, key) => printValue(params[key]));
    if (typeof message === 'function') return message(params);
    return message;
  }

  static isError(err) {
    return err && err.name === 'ValidationError';
  }

  constructor(errorOrErrors, value, field, type) {
    super();
    this.name = 'ValidationError';
    this.value = value;
    this.path = field;
    this.type = type;
    this.errors = [];
    this.inner = [];
    toArray(errorOrErrors).forEach(err => {
      if (ValidationError.isError(err)) {
        this.errors.push(...err.errors);
        this.inner = this.inner.concat(err.inner.length ? err.inner : err);
      } else {
        this.errors.push(err);
      }
    });
    this.message = this.errors.length > 1 ? `${this.errors.length} errors occurred` : this.errors[0];
    if (Error.captureStackTrace) Error.captureStackTrace(this, ValidationError);
  }

}

const once = cb => {
  let fired = false;
  return (...args) => {
    if (fired) return;
    fired = true;
    cb(...args);
  };
};

function runTests(options, cb) {
  let {
    endEarly,
    tests,
    args,
    value,
    errors,
    sort,
    path
  } = options;
  let callback = once(cb);
  let count = tests.length;
  const nestedErrors = [];
  errors = errors ? errors : [];
  if (!count) return errors.length ? callback(new ValidationError(errors, value, path)) : callback(null, value);

  for (let i = 0; i < tests.length; i++) {
    const test = tests[i];
    test(args, function finishTestRun(err) {
      if (err) {
        // always return early for non validation errors
        if (!ValidationError.isError(err)) {
          return callback(err, value);
        }

        if (endEarly) {
          err.value = value;
          return callback(err, value);
        }

        nestedErrors.push(err);
      }

      if (--count <= 0) {
        if (nestedErrors.length) {
          if (sort) nestedErrors.sort(sort); //show parent errors after the nested ones: name.first, name

          if (errors.length) nestedErrors.push(...errors);
          errors = nestedErrors;
        }

        if (errors.length) {
          callback(new ValidationError(errors, value, path), value);
          return;
        }

        callback(null, value);
      }
    });
  }
}

const prefixes = {
  context: '$',
  value: '.'
};
class Reference {
  constructor(key, options = {}) {
    if (typeof key !== 'string') throw new TypeError('ref must be a string, got: ' + key);
    this.key = key.trim();
    if (key === '') throw new TypeError('ref must be a non-empty string');
    this.isContext = this.key[0] === prefixes.context;
    this.isValue = this.key[0] === prefixes.value;
    this.isSibling = !this.isContext && !this.isValue;
    let prefix = this.isContext ? prefixes.context : this.isValue ? prefixes.value : '';
    this.path = this.key.slice(prefix.length);
    this.getter = this.path && formik_esm_baae0afb.b.getter(this.path, true);
    this.map = options.map;
  }

  getValue(value, parent, context) {
    let result = this.isContext ? context : this.isValue ? value : parent;
    if (this.getter) result = this.getter(result || {});
    if (this.map) result = this.map(result);
    return result;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {Object=} options.context
   * @param {Object=} options.parent
   */


  cast(value, options) {
    return this.getValue(value, options == null ? void 0 : options.parent, options == null ? void 0 : options.context);
  }

  resolve() {
    return this;
  }

  describe() {
    return {
      type: 'ref',
      key: this.key
    };
  }

  toString() {
    return `Ref(${this.key})`;
  }

  static isRef(value) {
    return value && value.__isYupRef;
  }

} // @ts-ignore

Reference.prototype.__isYupRef = true;

function _extends$1() { _extends$1 = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function createValidation(config) {
  function validate(_ref, cb) {
    let {
      value,
      path = '',
      label,
      options,
      originalValue,
      sync
    } = _ref,
        rest = _objectWithoutPropertiesLoose(_ref, ["value", "path", "label", "options", "originalValue", "sync"]);

    const {
      name,
      test,
      params,
      message
    } = config;
    let {
      parent,
      context
    } = options;

    function resolve(item) {
      return Reference.isRef(item) ? item.getValue(value, parent, context) : item;
    }

    function createError(overrides = {}) {
      const nextParams = (0,formik_esm_baae0afb.m)(_extends$1({
        value,
        originalValue,
        label,
        path: overrides.path || path
      }, params, overrides.params), resolve);
      const error = new ValidationError(ValidationError.formatError(overrides.message || message, nextParams), value, nextParams.path, overrides.type || name);
      error.params = nextParams;
      return error;
    }

    let ctx = _extends$1({
      path,
      parent,
      type: name,
      createError,
      resolve,
      options,
      originalValue
    }, rest);

    if (!sync) {
      try {
        Promise.resolve(test.call(ctx, value, ctx)).then(validOrError => {
          if (ValidationError.isError(validOrError)) cb(validOrError);else if (!validOrError) cb(createError());else cb(null, validOrError);
        });
      } catch (err) {
        cb(err);
      }

      return;
    }

    let result;

    try {
      var _ref2;

      result = test.call(ctx, value, ctx);

      if (typeof ((_ref2 = result) == null ? void 0 : _ref2.then) === 'function') {
        throw new Error(`Validation test of type: "${ctx.type}" returned a Promise during a synchronous validate. ` + `This test will finish after the validate call has returned`);
      }
    } catch (err) {
      cb(err);
      return;
    }

    if (ValidationError.isError(result)) cb(result);else if (!result) cb(createError());else cb(null, result);
  }

  validate.OPTIONS = config;
  return validate;
}

let trim = part => part.substr(0, part.length - 1).substr(1);

function getIn(schema, path, value, context = value) {
  let parent, lastPart, lastPartDebug; // root path: ''

  if (!path) return {
    parent,
    parentPath: path,
    schema
  };
  formik_esm_baae0afb.b.forEach(path, (_part, isBracket, isArray) => {
    let part = isBracket ? trim(_part) : _part;
    schema = schema.resolve({
      context,
      parent,
      value
    });

    if (schema.innerType) {
      let idx = isArray ? parseInt(part, 10) : 0;

      if (value && idx >= value.length) {
        throw new Error(`Yup.reach cannot resolve an array item at index: ${_part}, in the path: ${path}. ` + `because there is no value at that index. `);
      }

      parent = value;
      value = value && value[idx];
      schema = schema.innerType;
    } // sometimes the array index part of a path doesn't exist: "nested.arr.child"
    // in these cases the current part is the next schema and should be processed
    // in this iteration. For cases where the index signature is included this
    // check will fail and we'll handle the `child` part on the next iteration like normal


    if (!isArray) {
      if (!schema.fields || !schema.fields[part]) throw new Error(`The schema does not contain the path: ${path}. ` + `(failed at: ${lastPartDebug} which is a type: "${schema._type}")`);
      parent = value;
      value = value && value[part];
      schema = schema.fields[part];
    }

    lastPart = part;
    lastPartDebug = isBracket ? '[' + _part + ']' : '.' + _part;
  });
  return {
    schema,
    parent,
    parentPath: lastPart
  };
}

class ReferenceSet {
  constructor() {
    this.list = new Set();
    this.refs = new Map();
  }

  get size() {
    return this.list.size + this.refs.size;
  }

  describe() {
    const description = [];

    for (const item of this.list) description.push(item);

    for (const [, ref] of this.refs) description.push(ref.describe());

    return description;
  }

  toArray() {
    return Array.from(this.list).concat(Array.from(this.refs.values()));
  }

  add(value) {
    Reference.isRef(value) ? this.refs.set(value.key, value) : this.list.add(value);
  }

  delete(value) {
    Reference.isRef(value) ? this.refs.delete(value.key) : this.list.delete(value);
  }

  has(value, resolve) {
    if (this.list.has(value)) return true;
    let item,
        values = this.refs.values();

    while (item = values.next(), !item.done) if (resolve(item.value) === value) return true;

    return false;
  }

  clone() {
    const next = new ReferenceSet();
    next.list = new Set(this.list);
    next.refs = new Map(this.refs);
    return next;
  }

  merge(newItems, removeItems) {
    const next = this.clone();
    newItems.list.forEach(value => next.add(value));
    newItems.refs.forEach(value => next.add(value));
    removeItems.list.forEach(value => next.delete(value));
    removeItems.refs.forEach(value => next.delete(value));
    return next;
  }

}

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
class BaseSchema {
  constructor(options) {
    this.deps = [];
    this.conditions = [];
    this._whitelist = new ReferenceSet();
    this._blacklist = new ReferenceSet();
    this.exclusiveTests = Object.create(null);
    this.tests = [];
    this.transforms = [];
    this.withMutation(() => {
      this.typeError(mixed.notType);
    });
    this.type = (options == null ? void 0 : options.type) || 'mixed';
    this.spec = _extends({
      strip: false,
      strict: false,
      abortEarly: true,
      recursive: true,
      label: undefined,
      meta: undefined,
      nullable: false,
      presence: 'optional'
    }, options == null ? void 0 : options.spec);
  } // TODO: remove


  get _type() {
    return this.type;
  }

  _typeCheck(_value) {
    return true;
  }

  clone(spec) {
    if (this._mutate) {
      if (spec) Object.assign(this.spec, spec);
      return this;
    } // if the nested value is a schema we can skip cloning, since
    // they are already immutable


    const next = Object.create(Object.getPrototypeOf(this)); // @ts-expect-error this is readonly

    next.type = this.type;
    next._typeError = this._typeError;
    next._whitelistError = this._whitelistError;
    next._blacklistError = this._blacklistError;
    next._whitelist = this._whitelist.clone();
    next._blacklist = this._blacklist.clone();
    next.exclusiveTests = _extends({}, this.exclusiveTests); // @ts-expect-error this is readonly

    next.deps = [...this.deps];
    next.conditions = [...this.conditions];
    next.tests = [...this.tests];
    next.transforms = [...this.transforms];
    next.spec = (0,formik_esm_baae0afb.d)(_extends({}, this.spec, spec));
    return next;
  }

  label(label) {
    var next = this.clone();
    next.spec.label = label;
    return next;
  }

  meta(...args) {
    if (args.length === 0) return this.spec.meta;
    let next = this.clone();
    next.spec.meta = Object.assign(next.spec.meta || {}, args[0]);
    return next;
  } // withContext<TContext extends AnyObject>(): BaseSchema<
  //   TCast,
  //   TContext,
  //   TOutput
  // > {
  //   return this as any;
  // }


  withMutation(fn) {
    let before = this._mutate;
    this._mutate = true;
    let result = fn(this);
    this._mutate = before;
    return result;
  }

  concat(schema) {
    if (!schema || schema === this) return this;
    if (schema.type !== this.type && this.type !== 'mixed') throw new TypeError(`You cannot \`concat()\` schema's of different types: ${this.type} and ${schema.type}`);
    let base = this;
    let combined = schema.clone();

    const mergedSpec = _extends({}, base.spec, combined.spec); // if (combined.spec.nullable === UNSET)
    //   mergedSpec.nullable = base.spec.nullable;
    // if (combined.spec.presence === UNSET)
    //   mergedSpec.presence = base.spec.presence;


    combined.spec = mergedSpec;
    combined._typeError || (combined._typeError = base._typeError);
    combined._whitelistError || (combined._whitelistError = base._whitelistError);
    combined._blacklistError || (combined._blacklistError = base._blacklistError); // manually merge the blacklist/whitelist (the other `schema` takes
    // precedence in case of conflicts)

    combined._whitelist = base._whitelist.merge(schema._whitelist, schema._blacklist);
    combined._blacklist = base._blacklist.merge(schema._blacklist, schema._whitelist); // start with the current tests

    combined.tests = base.tests;
    combined.exclusiveTests = base.exclusiveTests; // manually add the new tests to ensure
    // the deduping logic is consistent

    combined.withMutation(next => {
      schema.tests.forEach(fn => {
        next.test(fn.OPTIONS);
      });
    });
    return combined;
  }

  isType(v) {
    if (this.spec.nullable && v === null) return true;
    return this._typeCheck(v);
  }

  resolve(options) {
    let schema = this;

    if (schema.conditions.length) {
      let conditions = schema.conditions;
      schema = schema.clone();
      schema.conditions = [];
      schema = conditions.reduce((schema, condition) => condition.resolve(schema, options), schema);
      schema = schema.resolve(options);
    }

    return schema;
  }
  /**
   *
   * @param {*} value
   * @param {Object} options
   * @param {*=} options.parent
   * @param {*=} options.context
   */


  cast(value, options = {}) {
    let resolvedSchema = this.resolve(_extends({
      value
    }, options));

    let result = resolvedSchema._cast(value, options);

    if (value !== undefined && options.assert !== false && resolvedSchema.isType(result) !== true) {
      let formattedValue = printValue(value);
      let formattedResult = printValue(result);
      throw new TypeError(`The value of ${options.path || 'field'} could not be cast to a value ` + `that satisfies the schema type: "${resolvedSchema._type}". \n\n` + `attempted value: ${formattedValue} \n` + (formattedResult !== formattedValue ? `result of cast: ${formattedResult}` : ''));
    }

    return result;
  }

  _cast(rawValue, _options) {
    let value = rawValue === undefined ? rawValue : this.transforms.reduce((value, fn) => fn.call(this, value, rawValue, this), rawValue);

    if (value === undefined) {
      value = this.getDefault();
    }

    return value;
  }

  _validate(_value, options = {}, cb) {
    let {
      sync,
      path,
      from = [],
      originalValue = _value,
      strict = this.spec.strict,
      abortEarly = this.spec.abortEarly
    } = options;
    let value = _value;

    if (!strict) {
      // this._validating = true;
      value = this._cast(value, _extends({
        assert: false
      }, options)); // this._validating = false;
    } // value is cast, we can check if it meets type requirements


    let args = {
      value,
      path,
      options,
      originalValue,
      schema: this,
      label: this.spec.label,
      sync,
      from
    };
    let initialTests = [];
    if (this._typeError) initialTests.push(this._typeError);
    if (this._whitelistError) initialTests.push(this._whitelistError);
    if (this._blacklistError) initialTests.push(this._blacklistError);
    runTests({
      args,
      value,
      path,
      sync,
      tests: initialTests,
      endEarly: abortEarly
    }, err => {
      if (err) return void cb(err, value);
      runTests({
        tests: this.tests,
        args,
        path,
        sync,
        value,
        endEarly: abortEarly
      }, cb);
    });
  }

  validate(value, options, maybeCb) {
    let schema = this.resolve(_extends({}, options, {
      value
    })); // callback case is for nested validations

    return typeof maybeCb === 'function' ? schema._validate(value, options, maybeCb) : new Promise((resolve, reject) => schema._validate(value, options, (err, value) => {
      if (err) reject(err);else resolve(value);
    }));
  }

  validateSync(value, options) {
    let schema = this.resolve(_extends({}, options, {
      value
    }));
    let result;

    schema._validate(value, _extends({}, options, {
      sync: true
    }), (err, value) => {
      if (err) throw err;
      result = value;
    });

    return result;
  }

  isValid(value, options) {
    return this.validate(value, options).then(() => true, err => {
      if (ValidationError.isError(err)) return false;
      throw err;
    });
  }

  isValidSync(value, options) {
    try {
      this.validateSync(value, options);
      return true;
    } catch (err) {
      if (ValidationError.isError(err)) return false;
      throw err;
    }
  }

  _getDefault() {
    let defaultValue = this.spec.default;

    if (defaultValue == null) {
      return defaultValue;
    }

    return typeof defaultValue === 'function' ? defaultValue.call(this) : (0,formik_esm_baae0afb.d)(defaultValue);
  }

  getDefault(options) {
    let schema = this.resolve(options || {});
    return schema._getDefault();
  }

  default(def) {
    if (arguments.length === 0) {
      return this._getDefault();
    }

    let next = this.clone({
      default: def
    });
    return next;
  }

  strict(isStrict = true) {
    var next = this.clone();
    next.spec.strict = isStrict;
    return next;
  }

  _isPresent(value) {
    return value != null;
  }

  defined(message = mixed.defined) {
    return this.test({
      message,
      name: 'defined',
      exclusive: true,

      test(value) {
        return value !== undefined;
      }

    });
  }

  required(message = mixed.required) {
    return this.clone({
      presence: 'required'
    }).withMutation(s => s.test({
      message,
      name: 'required',
      exclusive: true,

      test(value) {
        return this.schema._isPresent(value);
      }

    }));
  }

  notRequired() {
    var next = this.clone({
      presence: 'optional'
    });
    next.tests = next.tests.filter(test => test.OPTIONS.name !== 'required');
    return next;
  }

  nullable(isNullable = true) {
    var next = this.clone({
      nullable: isNullable !== false
    });
    return next;
  }

  transform(fn) {
    var next = this.clone();
    next.transforms.push(fn);
    return next;
  }
  /**
   * Adds a test function to the schema's queue of tests.
   * tests can be exclusive or non-exclusive.
   *
   * - exclusive tests, will replace any existing tests of the same name.
   * - non-exclusive: can be stacked
   *
   * If a non-exclusive test is added to a schema with an exclusive test of the same name
   * the exclusive test is removed and further tests of the same name will be stacked.
   *
   * If an exclusive test is added to a schema with non-exclusive tests of the same name
   * the previous tests are removed and further tests of the same name will replace each other.
   */


  test(...args) {
    let opts;

    if (args.length === 1) {
      if (typeof args[0] === 'function') {
        opts = {
          test: args[0]
        };
      } else {
        opts = args[0];
      }
    } else if (args.length === 2) {
      opts = {
        name: args[0],
        test: args[1]
      };
    } else {
      opts = {
        name: args[0],
        message: args[1],
        test: args[2]
      };
    }

    if (opts.message === undefined) opts.message = mixed.default;
    if (typeof opts.test !== 'function') throw new TypeError('`test` is a required parameters');
    let next = this.clone();
    let validate = createValidation(opts);
    let isExclusive = opts.exclusive || opts.name && next.exclusiveTests[opts.name] === true;

    if (opts.exclusive) {
      if (!opts.name) throw new TypeError('Exclusive tests must provide a unique `name` identifying the test');
    }

    if (opts.name) next.exclusiveTests[opts.name] = !!opts.exclusive;
    next.tests = next.tests.filter(fn => {
      if (fn.OPTIONS.name === opts.name) {
        if (isExclusive) return false;
        if (fn.OPTIONS.test === validate.OPTIONS.test) return false;
      }

      return true;
    });
    next.tests.push(validate);
    return next;
  }

  when(keys, options) {
    if (!Array.isArray(keys) && typeof keys !== 'string') {
      options = keys;
      keys = '.';
    }

    let next = this.clone();
    let deps = toArray(keys).map(key => new Reference(key));
    deps.forEach(dep => {
      // @ts-ignore
      if (dep.isSibling) next.deps.push(dep.key);
    });
    next.conditions.push(new Condition$1(deps, options));
    return next;
  }

  typeError(message) {
    var next = this.clone();
    next._typeError = createValidation({
      message,
      name: 'typeError',

      test(value) {
        if (value !== undefined && !this.schema.isType(value)) return this.createError({
          params: {
            type: this.schema._type
          }
        });
        return true;
      }

    });
    return next;
  }

  oneOf(enums, message = mixed.oneOf) {
    var next = this.clone();
    enums.forEach(val => {
      next._whitelist.add(val);

      next._blacklist.delete(val);
    });
    next._whitelistError = createValidation({
      message,
      name: 'oneOf',

      test(value) {
        if (value === undefined) return true;
        let valids = this.schema._whitelist;
        return valids.has(value, this.resolve) ? true : this.createError({
          params: {
            values: valids.toArray().join(', ')
          }
        });
      }

    });
    return next;
  }

  notOneOf(enums, message = mixed.notOneOf) {
    var next = this.clone();
    enums.forEach(val => {
      next._blacklist.add(val);

      next._whitelist.delete(val);
    });
    next._blacklistError = createValidation({
      message,
      name: 'notOneOf',

      test(value) {
        let invalids = this.schema._blacklist;
        if (invalids.has(value, this.resolve)) return this.createError({
          params: {
            values: invalids.toArray().join(', ')
          }
        });
        return true;
      }

    });
    return next;
  }

  strip(strip = true) {
    let next = this.clone();
    next.spec.strip = strip;
    return next;
  }

  describe() {
    const next = this.clone();
    const {
      label,
      meta
    } = next.spec;
    const description = {
      meta,
      label,
      type: next.type,
      oneOf: next._whitelist.describe(),
      notOneOf: next._blacklist.describe(),
      tests: next.tests.map(fn => ({
        name: fn.OPTIONS.name,
        params: fn.OPTIONS.params
      })).filter((n, idx, list) => list.findIndex(c => c.name === n.name) === idx)
    };
    return description;
  }

}
// @ts-expect-error
BaseSchema.prototype.__isYupSchema__ = true;

for (const method of ['validate', 'validateSync']) BaseSchema.prototype[`${method}At`] = function (path, value, options = {}) {
  const {
    parent,
    parentPath,
    schema
  } = getIn(this, path, value, options.context);
  return schema[method](parent && parent[parentPath], _extends({}, options, {
    parent,
    path
  }));
};

for (const alias of ['equals', 'is']) BaseSchema.prototype[alias] = BaseSchema.prototype.oneOf;

for (const alias of ['not', 'nope']) BaseSchema.prototype[alias] = BaseSchema.prototype.notOneOf;

BaseSchema.prototype.optional = BaseSchema.prototype.notRequired;

var isAbsent = (value => value == null);

let rEmail = /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i; // eslint-disable-next-line

let rUrl = /^((https?|ftp):)?\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i; // eslint-disable-next-line

let rUUID = /^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i;

let isTrimmed = value => isAbsent(value) || value === value.trim();

let objStringTag = {}.toString();
function create() {
  return new StringSchema();
}
class StringSchema extends BaseSchema {
  constructor() {
    super({
      type: 'string'
    });
    this.withMutation(() => {
      this.transform(function (value) {
        if (this.isType(value)) return value;
        if (Array.isArray(value)) return value;
        const strValue = value != null && value.toString ? value.toString() : value;
        if (strValue === objStringTag) return value;
        return strValue;
      });
    });
  }

  _typeCheck(value) {
    if (value instanceof String) value = value.valueOf();
    return typeof value === 'string';
  }

  _isPresent(value) {
    return super._isPresent(value) && !!value.length;
  }

  length(length, message = string.length) {
    return this.test({
      message,
      name: 'length',
      exclusive: true,
      params: {
        length
      },

      test(value) {
        return isAbsent(value) || value.length === this.resolve(length);
      }

    });
  }

  min(min, message = string.min) {
    return this.test({
      message,
      name: 'min',
      exclusive: true,
      params: {
        min
      },

      test(value) {
        return isAbsent(value) || value.length >= this.resolve(min);
      }

    });
  }

  max(max, message = string.max) {
    return this.test({
      name: 'max',
      exclusive: true,
      message,
      params: {
        max
      },

      test(value) {
        return isAbsent(value) || value.length <= this.resolve(max);
      }

    });
  }

  matches(regex, options) {
    let excludeEmptyString = false;
    let message;
    let name;

    if (options) {
      if (typeof options === 'object') {
        ({
          excludeEmptyString = false,
          message,
          name
        } = options);
      } else {
        message = options;
      }
    }

    return this.test({
      name: name || 'matches',
      message: message || string.matches,
      params: {
        regex
      },
      test: value => isAbsent(value) || value === '' && excludeEmptyString || value.search(regex) !== -1
    });
  }

  email(message = string.email) {
    return this.matches(rEmail, {
      name: 'email',
      message,
      excludeEmptyString: true
    });
  }

  url(message = string.url) {
    return this.matches(rUrl, {
      name: 'url',
      message,
      excludeEmptyString: true
    });
  }

  uuid(message = string.uuid) {
    return this.matches(rUUID, {
      name: 'uuid',
      message,
      excludeEmptyString: false
    });
  } //-- transforms --


  ensure() {
    return this.default('').transform(val => val === null ? '' : val);
  }

  trim(message = string.trim) {
    return this.transform(val => val != null ? val.trim() : val).test({
      message,
      name: 'trim',
      test: isTrimmed
    });
  }

  lowercase(message = string.lowercase) {
    return this.transform(value => !isAbsent(value) ? value.toLowerCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => isAbsent(value) || value === value.toLowerCase()
    });
  }

  uppercase(message = string.uppercase) {
    return this.transform(value => !isAbsent(value) ? value.toUpperCase() : value).test({
      message,
      name: 'string_case',
      exclusive: true,
      test: value => isAbsent(value) || value === value.toUpperCase()
    });
  }

}
create.prototype = StringSchema.prototype; //
// String Interfaces
//

const useT = (root) => {
    const { t } = (0,formik_esm_baae0afb.M)();
    return FronteggApp_35f1a2b2.r.exports.useCallback((key, options, defaultValue) => {
        return t(`loginBox.${root}.${key}`, options, defaultValue);
    }, [t]);
};
const useGlobalT = () => {
    const { t } = (0,formik_esm_baae0afb.M)();
    return FronteggApp_35f1a2b2.r.exports.useCallback((key, options, defaultValue) => {
        return t(key, options, defaultValue);
    }, [t]);
};
const useContextT = (context) => {
    const { t } = (0,formik_esm_baae0afb.M)();
    return FronteggApp_35f1a2b2.r.exports.useCallback((key, options, defaultValue) => {
        return t(`${context}.${key}`, options, defaultValue);
    }, [t]);
};
const defaultPasswordConfig = {
    allowPassphrases: true,
    maxLength: 128,
    minLength: 6,
    minOptionalTestsToPass: 1,
    minPhraseLength: 6,
};
const IDENTITY_CONFIGURATION_SERVICE_URL_V1 = '/identity/resources/configurations/v1';
const usePasswordConfig = (userId) => {
    const { setForgotPasswordState, loadPasswordConfig } = (0,formik_esm_baae0afb.a0)();
    const { passwordConfig, loading } = (0,formik_esm_baae0afb.$)();
    const { builderMode } = (0,formik_esm_baae0afb.v)();
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        if (loading) {
            return;
        }
        if (!passwordConfig) {
            if (userId || builderMode) {
                loadPasswordConfig({ userId: userId !== null && userId !== void 0 ? userId : 'demo-user' });
            }
            else {
                // TODO: to be replaced with loadPublicPasswordConfig
                umd.fetch.Get(`${IDENTITY_CONFIGURATION_SERVICE_URL_V1}/password`).then((data) => (0,FronteggApp_35f1a2b2.g)(void 0, void 0, void 0, function* () {
                    setForgotPasswordState({ loading: false, passwordConfig: data });
                })).catch(e => {
                    setForgotPasswordState({ loading: false, passwordConfig: defaultPasswordConfig });
                });
            }
        }
    }, [loading, passwordConfig, setForgotPasswordState, loadPasswordConfig]);
    const passwordServerConfig = Object.assign(Object.assign({}, defaultPasswordConfig), passwordConfig);
    const strength = passwordServerConfig.minLength <= 6 ? 'easy' : passwordServerConfig.minLength <= 8 ? 'medium' : 'hard';
    return {
        loading,
        passwordConfig: loading && !passwordConfig ? defaultPasswordConfig : passwordServerConfig,
        defaultPasswordConfig,
        strength,
    };
};
const useRecaptcha = ({ action, recaptchaRef, onTokenLoad }) => {
    var _a, _b, _c, _d;
    const { loadSecurityPolicyCaptcha } = (0,formik_esm_baae0afb.a6)();
    const { captchaPolicy } = (0,formik_esm_baae0afb._)();
    const [token, setToken] = FronteggApp_35f1a2b2.r.exports.useState('');
    const timer = FronteggApp_35f1a2b2.r.exports.useRef(null);
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        !captchaPolicy.policy && loadSecurityPolicyCaptcha();
    }, [captchaPolicy.policy, loadSecurityPolicyCaptcha]);
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        var _a;
        if ((_a = captchaPolicy.policy) === null || _a === void 0 ? void 0 : _a.enabled)
            dist.loadReCaptcha(captchaPolicy.policy.siteKey || '');
    }, [(_a = captchaPolicy.policy) === null || _a === void 0 ? void 0 : _a.enabled, (_b = captchaPolicy.policy) === null || _b === void 0 ? void 0 : _b.siteKey]);
    const handleCallback = FronteggApp_35f1a2b2.r.exports.useCallback((token) => {
        setToken(token);
        onTokenLoad === null || onTokenLoad === void 0 ? void 0 : onTokenLoad(token);
        timer.current && clearTimeout(timer.current);
        timer.current = setTimeout(() => {
            var _a;
            if ((_a = captchaPolicy.policy) === null || _a === void 0 ? void 0 : _a.enabled) {
                dist.loadReCaptcha(captchaPolicy.policy.siteKey || '');
            }
        }, 60 * 1000);
    }, [setToken, dist.loadReCaptcha, captchaPolicy, onTokenLoad]);
    // clear timeout on unmount
    FronteggApp_35f1a2b2.r.exports.useCallback(() => () => timer.current && clearTimeout(timer.current), []);
    if (!((_c = captchaPolicy.policy) === null || _c === void 0 ? void 0 : _c.enabled))
        return null;
    return {
        token,
        component: FronteggApp_35f1a2b2.R.createElement(dist.ReCaptcha, { sitekey: (_d = captchaPolicy.policy) === null || _d === void 0 ? void 0 : _d.siteKey, ref: recaptchaRef, verifyCallback: handleCallback, action: action }),
    };
};
const useVerifyInviteToken = () => {
    var _a;
    const url = new URL(window.location.href);
    const invitationToken = (_a = url.searchParams.get('invitationToken')) !== null && _a !== void 0 ? _a : '';
    const { verifyInviteToken } = (0,formik_esm_baae0afb.U)();
    const { inviteTokenTenantName, inviteTokenError } = (0,formik_esm_baae0afb.a4)(({ inviteTokenTenantName, inviteTokenError }) => ({
        inviteTokenTenantName,
        inviteTokenError,
    }));
    const loadingVerifyInviteToken = FronteggApp_35f1a2b2.r.exports.useMemo(() => !!invitationToken && (!inviteTokenTenantName && !inviteTokenError), [inviteTokenTenantName, inviteTokenError]);
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        invitationToken && verifyInviteToken({ token: invitationToken });
    }, [invitationToken, verifyInviteToken]);
    return { invitationToken, loading: loadingVerifyInviteToken };
};
const useQueryParams = (...keys) => {
    const params = new URLSearchParams(window.location.search);
    const result = {};
    keys.forEach((key) => {
        result[key] = params.get(key);
    });
    return result;
};
const setTtlInterval = (cb, delay) => {
    const maxTtlForInterval = Math.pow(2, 31) - 1;
    const timesArray = [];
    for (let i = delay; i > 0; i -= maxTtlForInterval) {
        if (i > maxTtlForInterval) {
            timesArray.push(maxTtlForInterval);
        }
        else {
            timesArray.push(i);
        }
    }
    let counter = 0;
    return setInterval((...args) => {
        counter++;
        if (timesArray.length <= counter) {
            counter = 0;
            cb(...args);
        }
    }, ...timesArray);
};
const useHideRecaptcha = () => {
    const hideRecaptcha = (element) => {
        if (!!element) {
            element.style.visibility = 'hidden';
        }
    };
    return [hideRecaptcha];
};

const redirectIfFronteggPath = (_routes, basename, urlStrategy, path, opts) => {
    const routes = (0,FronteggApp_35f1a2b2.f)(_routes, ["authenticatedUrl", "signUpSuccessUrl"]);
    if (path === '/') {
        return false;
    }
    const fronteggPath = Object.values(routes).find((p) => p.startsWith(path));
    if (!fronteggPath) {
        return false;
    }
    const calculatedBasename = basename ? (basename.endsWith('/') ? basename.substring(0, basename.length - 1) : '') : '';
    let newPath = calculatedBasename + path;
    if (opts === null || opts === void 0 ? void 0 : opts.preserveQueryParams) {
        newPath += window.location.search;
    }
    if (urlStrategy === 'path') {
        window.history.pushState(null, '', newPath);
    }
    else {
        window.history.pushState(null, '', `#${newPath}`);
    }
    return true;
};
const StoreListener = () => {
    var _a;
    const timer = FronteggApp_35f1a2b2.r.exports.useRef(0);
    const { previewMode, builderMode, contextOptions, basename, urlStrategy, onRedirectTo: onRedirectToProp, hostedLoginBox, framework, } = (0,formik_esm_baae0afb.v)();
    const routes = (0,formik_esm_baae0afb.K)();
    const { setState: setAuthState, logout } = (0,formik_esm_baae0afb.V)();
    const isAuthenticated = (0,formik_esm_baae0afb.W)();
    const { keepSessionAlive } = (0,formik_esm_baae0afb.J)(({ keepSessionAlive }) => ({ keepSessionAlive }));
    const user = (0,formik_esm_baae0afb.X)();
    const { requestAuthorize } = (0,formik_esm_baae0afb.U)();
    const updateSessionTimer = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        timer.current && clearInterval(timer.current);
        if (isAuthenticated && !hostedLoginBox) {
            if (keepSessionAlive === true) {
                const ttl = ((user === null || user === void 0 ? void 0 : user.expiresIn) || 20) * 1000 * 0.8;
                timer.current = setTtlInterval(() => requestAuthorize(), ttl);
            }
            else {
                const ttl = ((user === null || user === void 0 ? void 0 : user.expiresIn) || 20) * 1000;
                timer.current = setTtlInterval(() => logout(), ttl);
            }
        }
    }, [keepSessionAlive, isAuthenticated, logout, requestAuthorize, user === null || user === void 0 ? void 0 : user.expiresIn]);
    if (!builderMode && !previewMode) {
        umd.ContextHolder.setAccessToken((_a = user === null || user === void 0 ? void 0 : user.accessToken) !== null && _a !== void 0 ? _a : '');
        umd.ContextHolder.setUser(user);
        umd.ContextHolder.setContext(contextOptions);
    }
    const onRedirectTo = FronteggApp_35f1a2b2.r.exports.useCallback((path, opts) => {
        document.dispatchEvent(new CustomEvent('frontegg_onRedirectTo_fired'));
        if (redirectIfFronteggPath(routes, basename, urlStrategy, path, opts)) {
            return;
        }
        else if (onRedirectToProp && !path.startsWith('http')) {
            onRedirectToProp(path, opts);
        }
        else {
            if (opts === null || opts === void 0 ? void 0 : opts.preserveQueryParams) {
                path = `${path}${window.location.search}`;
            }
            if (urlStrategy === 'path' || path.startsWith('http')) {
                window.location.href = path;
            }
            else {
                window.location.href = `${window.location.pathname}#${path}`;
            }
        }
    }, [basename, urlStrategy, routes, onRedirectToProp]);
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        setAuthState({ onRedirectTo });
        umd.ContextHolder.setOnRedirectTo(onRedirectTo);
    }, [onRedirectTo, setAuthState]);
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        if (hostedLoginBox && framework !== 'nextjs') {
            setAuthState({ isLoading: false });
        }
    }, [framework, setAuthState, hostedLoginBox]);
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        updateSessionTimer();
    }, [updateSessionTimer, isAuthenticated]);
    return null;
};

const dsn = "https://0b39f7899e9e402cac3d7a15c51528bb@o362363.ingest.sentry.io/6234067";
const AppLayout = ({ children }) => {
    const { injector, customStyles } = (0,formik_esm_baae0afb.v)();
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.P, { context: formik_esm_baae0afb.N, store: injector.store },
        FronteggApp_35f1a2b2.R.createElement(StoreListener, null),
        customStyles && FronteggApp_35f1a2b2.R.createElement("style", { type: 'text/css', dangerouslySetInnerHTML: { __html: customStyles } }),
        children);
};
const App = ({ children }) => {
    var _a;
    const { isShadowDom, injector } = (0,formik_esm_baae0afb.v)();
    if ((_a = injector.options) === null || _a === void 0 ? void 0 : _a.tracing) {
        init({
            dsn,
            integrations: [
                new BrowserTracing(),
                new CaptureConsole({
                    levels: ['error'],
                })
            ],
            tracesSampleRate: 1.0,
        });
    }
    const { calculatedTheme, theme, overrides } = (0,formik_esm_baae0afb.w)();
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.x, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.y, { theme: calculatedTheme, isShadowDom: isShadowDom },
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.z.Provider, { value: { theme, overrides } },
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.E, { themeOptionKey: 'loginBox' },
                    FronteggApp_35f1a2b2.R.createElement(AppLayout, null, children)))));
};

const ThemeOptionKeyContext = FronteggApp_35f1a2b2.r.exports.createContext('');
const useThemeOptionKey = () => FronteggApp_35f1a2b2.r.exports.useContext(ThemeOptionKeyContext);
var ThemeOptionKeyContext$1 = ThemeOptionKeyContext;

const styled$7 = _default();
const buildLayout = (theme) => {
    var _a, _b;
    const layoutType = (_b = (_a = theme.layout) === null || _a === void 0 ? void 0 : _a.type) !== null && _b !== void 0 ? _b : 'center';
    if (layoutType !== 'center') {
        return {
            flexDirection: layoutType === 'float-left' ? 'row' : 'row-reverse',
            '@media (max-width:1000px)': {
                '& .fe-page-side-element': {
                    display: 'none',
                },
            },
        };
    }
    return {};
};
const RootElementContainer = styled$7(formik_esm_baae0afb.B)(({ theme }) => {
    var _a, _b, _c, _d, _e;
    const sideElementFlex = ((_b = (_a = theme.layout) === null || _a === void 0 ? void 0 : _a.splitSize) !== null && _b !== void 0 ? _b : 50) / 100;
    const splitContainerStyle = (_e = (_d = (_c = theme.layout) === null || _c === void 0 ? void 0 : _c.splitModeStyles) === null || _d === void 0 ? void 0 : _d.splitContainerStyle) !== null && _e !== void 0 ? _e : {};
    return Object.assign(Object.assign(Object.assign({ position: 'fixed', display: 'flex', flexDirection: 'row', width: '100vw', height: '100vh', top: 0, left: 0 }, theme.rootStyle), { '& .fe-page-side-element': Object.assign({ flex: sideElementFlex * 2, height: '100vh', overflow: 'auto' }, splitContainerStyle) }), buildLayout(theme));
});
const RootElement = ({ children, themeOptionKey: themeOptionKeyProps }) => {
    const themeOptionKey = themeOptionKeyProps !== null && themeOptionKeyProps !== void 0 ? themeOptionKeyProps : useThemeOptionKey();
    return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.E, { themeOptionKey: themeOptionKey, withFallback: true },
        FronteggApp_35f1a2b2.R.createElement(RootElementContainer, { "data-test-id": 'root-element' }, children)));
};
const TransparentRootElement = ({ children, themeOptionKey: themeOptionKeyProps }) => {
    const themeOptionKey = themeOptionKeyProps !== null && themeOptionKeyProps !== void 0 ? themeOptionKeyProps : useThemeOptionKey();
    return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.E, { themeOptionKey: themeOptionKey, withFallback: true }, children));
};
var RootElement$1 = RootElement;

const SlotRenderer = ({ themeKey, mount, unmount }) => {
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        mount();
        return unmount;
    }, [mount, unmount]);
    return FronteggApp_35f1a2b2.R.createElement("slot", { name: themeKey });
};
const UnstyledCustomComponent = (_a) => {
    var { componentKey, componentKeys, children, className } = _a, props = (0,FronteggApp_35f1a2b2.f)(_a, ["componentKey", "componentKeys", "children", "className"]);
    const theme = (0,formik_esm_baae0afb.F)();
    const t = useGlobalT();
    const component = FronteggApp_35f1a2b2.r.exports.useMemo(() => {
        // We receive both "componentKeys" and "componentKey" in order not to break the app.
        // If componentKeys are available, they get priority. Inside, we include all component keys that we intend to read, in priority order.
        // For example, for account signup page, we send ['titleAccount', 'title']
        // Now if the user will pass override for both titleAccount and title, we will grab the first one in priority and ignore the rest of them.
        if (componentKeys === null || componentKeys === void 0 ? void 0 : componentKeys.length) {
            return componentKeys.reduce((acc, key) => {
                acc = acc !== null && acc !== void 0 ? acc : getValue$1(theme, key);
                return acc;
            }, undefined);
        }
        // if componentKeys array is not available/empty, we proceed with the single key, as before
        return getValue$1(theme, componentKey);
    }, [componentKeys, componentKey]);
    if (component === undefined) {
        if (!children) {
            return null;
        }
        return FronteggApp_35f1a2b2.R.createElement("div", { className: className }, children);
    }
    if (component === null) {
        return null;
    }
    if (component.type === 'slot') {
        const { themeKey, mount, unmount } = component;
        return FronteggApp_35f1a2b2.R.createElement("div", { className: className },
            FronteggApp_35f1a2b2.R.createElement(SlotRenderer, Object.assign({}, { themeKey, mount, unmount })));
    }
    if (typeof component === 'function') {
        const html = component(Object.assign(Object.assign({}, props), { t, className }));
        if (FronteggApp_35f1a2b2.r.exports.isValidElement(html)) {
            return FronteggApp_35f1a2b2.R.cloneElement(html);
        }
        if (typeof html === 'string') {
            return FronteggApp_35f1a2b2.R.createElement("div", { dangerouslySetInnerHTML: { __html: html } });
        }
        else {
            console.error('Unsupported custom element format, html must be a string');
            return null;
        }
    }
    if (typeof component === 'string') {
        return FronteggApp_35f1a2b2.R.createElement("div", { className: className, dangerouslySetInnerHTML: { __html: component } });
    }
    else {
        console.error('Unsupported custom element format, html must be a string');
        return null;
    }
};
const CustomComponent = (0,formik_esm_baae0afb.f)(UnstyledCustomComponent)(({ theme, componentKey, componentKeys = [] }) => (Object.assign({}, ([componentKey, ...componentKeys.slice().reverse()].reduce((styles, key) => (Object.assign(Object.assign({}, styles), theme[`${key}Style`])), {})))));

const Container$2 = (0,formik_esm_baae0afb.f)(formik_esm_baae0afb.B)(({ theme }) => {
    var _a;
    return (Object.assign({ textAlign: 'center', color: (_a = theme.poweredByColor) !== null && _a !== void 0 ? _a : '#a9a9ab', marginTop: '3rem', cursor: 'pointer', '> a': {
            color: 'currentColor',
            textDecoration: 'none',
            cursor: 'pointer',
            '&:hover .frontegg-logo': {
                color: '#8f8f8f',
            }
        } }, (theme.poweredByPlacement === 'leftBottomCorner' ? {
        margin: 0,
        [theme.breakpoints.up('sm')]: {
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            background: 'none',
            position: 'absolute',
            bottom: '1rem',
            left: '1.5rem',
        }
    } : {})));
});
const PowerByFrontegg = (props) => {
    const { whiteLabelMode } = (0,formik_esm_baae0afb.aj)(({ whiteLabelMode }) => ({ whiteLabelMode }));
    if (whiteLabelMode !== null && whiteLabelMode !== void 0 ? whiteLabelMode : false) {
        return null;
    }
    return FronteggApp_35f1a2b2.R.createElement(Container$2, Object.assign({}, props),
        FronteggApp_35f1a2b2.R.createElement("a", { href: 'https://frontegg.com', target: '_blank', "data-test-id": "powered-by-logo" },
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.ak, { sx: { width: '165px' }, viewBox: "0 0 165 15", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
                FronteggApp_35f1a2b2.R.createElement("path", { d: "M0.99778 10.6198H2.56428V7.35027H4.86528C4.95195 7.35027 5.06678 7.34593 5.20978 7.33727C5.35711 7.3286 5.49145 7.3156 5.61278 7.29827C6.41878 7.1726 7.01678 6.83677 7.40678 6.29077C7.80111 5.74043 7.99828 5.0796 7.99828 4.30827C7.99828 3.5326 7.80328 2.87177 7.41328 2.32577C7.02761 1.77543 6.42745 1.43743 5.61278 1.31177C5.49145 1.2901 5.35928 1.2771 5.21628 1.27277C5.07328 1.2641 4.95628 1.25977 4.86528 1.25977H0.99778V10.6198ZM2.56428 5.88777V2.72877H4.80028C4.88695 2.72877 4.98445 2.7331 5.09278 2.74177C5.20111 2.75043 5.30078 2.7656 5.39178 2.78727C5.65178 2.85227 5.85545 2.96927 6.00278 3.13827C6.15445 3.30293 6.26061 3.48927 6.32128 3.69727C6.38628 3.90527 6.41878 4.10893 6.41878 4.30827C6.41878 4.5076 6.38628 4.71127 6.32128 4.91927C6.26061 5.12727 6.15445 5.3136 6.00278 5.47827C5.85545 5.64293 5.65178 5.75777 5.39178 5.82277C5.30078 5.84877 5.20111 5.8661 5.09278 5.87477C4.98445 5.88343 4.88695 5.88777 4.80028 5.88777H2.56428Z", fill: "currentColor" }),
                FronteggApp_35f1a2b2.R.createElement("path", { d: "M12.5468 10.8148C13.2488 10.8148 13.8619 10.6588 14.3863 10.3468C14.9106 10.0304 15.3179 9.59493 15.6083 9.04027C15.9029 8.48127 16.0503 7.83777 16.0503 7.10977C16.0503 6.3861 15.9051 5.74693 15.6148 5.19227C15.3244 4.63327 14.9171 4.1956 14.3928 3.87927C13.8684 3.56293 13.2531 3.40477 12.5468 3.40477C11.8578 3.40477 11.2511 3.56077 10.7268 3.87277C10.2024 4.18477 9.79292 4.6181 9.49826 5.17277C9.20359 5.72743 9.05626 6.3731 9.05626 7.10977C9.05626 7.83343 9.19926 8.47477 9.48526 9.03377C9.77559 9.58843 10.1829 10.0239 10.7073 10.3403C11.2316 10.6566 11.8448 10.8148 12.5468 10.8148ZM12.5468 9.34577C11.9444 9.34577 11.4873 9.14427 11.1753 8.74127C10.8676 8.33393 10.7138 7.7901 10.7138 7.10977C10.7138 6.44677 10.8611 5.90943 11.1558 5.49777C11.4548 5.08177 11.9184 4.87377 12.5468 4.87377C13.1621 4.87377 13.6236 5.07743 13.9313 5.48477C14.2389 5.88777 14.3928 6.42943 14.3928 7.10977C14.3928 7.76843 14.2389 8.30577 13.9313 8.72177C13.6279 9.13777 13.1664 9.34577 12.5468 9.34577Z", fill: "currentColor" }),
                FronteggApp_35f1a2b2.R.createElement("path", { d: "M18.9835 10.6198H20.2055L21.7915 5.79027L23.384 10.6198H24.606L26.751 3.59977H25.217L23.839 8.10427L22.4545 3.59977H21.135L19.744 8.10427L18.3725 3.59977L16.8385 3.58677L18.9835 10.6198Z", fill: "currentColor" }),
                FronteggApp_35f1a2b2.R.createElement("path", { d: "M31.1216 10.8148C31.7976 10.8148 32.4151 10.6414 32.9741 10.2948C33.5375 9.94377 33.9535 9.44977 34.2221 8.81277L32.6751 8.34477C32.3631 9.0121 31.815 9.34577 31.0306 9.34577C30.4976 9.34577 30.0773 9.19193 29.7696 8.88427C29.462 8.57227 29.2778 8.12593 29.2171 7.54527H34.3001C34.3608 6.70027 34.2676 5.96793 34.0206 5.34827C33.7736 4.7286 33.3945 4.24977 32.8831 3.91177C32.3761 3.57377 31.7586 3.40477 31.0306 3.40477C30.3416 3.40477 29.735 3.56077 29.2106 3.87277C28.6863 4.18043 28.2768 4.6181 27.9821 5.18577C27.6875 5.75343 27.5401 6.42077 27.5401 7.18777C27.5401 7.89843 27.6896 8.52677 27.9886 9.07277C28.292 9.61877 28.7123 10.0456 29.2496 10.3533C29.787 10.6609 30.411 10.8148 31.1216 10.8148ZM31.0956 4.77627C31.581 4.77627 31.9536 4.9041 32.2136 5.15977C32.478 5.4111 32.6448 5.81193 32.7141 6.36227H29.2561C29.4425 5.30493 30.0556 4.77627 31.0956 4.77627Z", fill: "currentColor" }),
                FronteggApp_35f1a2b2.R.createElement("path", { d: "M36.0104 10.6198H37.5834V7.05127C37.5834 6.64393 37.6571 6.2821 37.8044 5.96577C37.9561 5.64943 38.1923 5.4046 38.5129 5.23127C38.7296 5.1056 38.9723 5.03193 39.2409 5.01027C39.5096 4.98427 39.7501 5.0016 39.9624 5.06227V3.59977C39.6461 3.5521 39.3211 3.5586 38.9874 3.61927C38.6538 3.6756 38.3569 3.7926 38.0969 3.97027C37.9496 4.06127 37.8174 4.17177 37.7004 4.30177C37.5834 4.42743 37.4816 4.56827 37.3949 4.72427V3.59977H36.0104V10.6198Z", fill: "currentColor" }),
                FronteggApp_35f1a2b2.R.createElement("path", { d: "M44.5274 10.8148C45.2034 10.8148 45.8209 10.6414 46.3799 10.2948C46.9432 9.94377 47.3592 9.44977 47.6279 8.81277L46.0809 8.34477C45.7689 9.0121 45.2207 9.34577 44.4364 9.34577C43.9034 9.34577 43.483 9.19193 43.1754 8.88427C42.8677 8.57227 42.6835 8.12593 42.6229 7.54527H47.7059C47.7665 6.70027 47.6734 5.96793 47.4264 5.34827C47.1794 4.7286 46.8002 4.24977 46.2889 3.91177C45.7819 3.57377 45.1644 3.40477 44.4364 3.40477C43.7474 3.40477 43.1407 3.56077 42.6164 3.87277C42.092 4.18043 41.6825 4.6181 41.3879 5.18577C41.0932 5.75343 40.9459 6.42077 40.9459 7.18777C40.9459 7.89843 41.0954 8.52677 41.3944 9.07277C41.6977 9.61877 42.118 10.0456 42.6554 10.3533C43.1927 10.6609 43.8167 10.8148 44.5274 10.8148ZM44.5014 4.77627C44.9867 4.77627 45.3594 4.9041 45.6194 5.15977C45.8837 5.4111 46.0505 5.81193 46.1199 6.36227H42.6619C42.8482 5.30493 43.4614 4.77627 44.5014 4.77627Z", fill: "currentColor" }),
                FronteggApp_35f1a2b2.R.createElement("path", { d: "M52.2307 10.8148C52.6467 10.8148 53.0215 10.7519 53.3552 10.6263C53.6888 10.5006 53.9813 10.3251 54.2327 10.0998V10.6198H55.6172V1.25977H54.0377V3.94427C53.8037 3.77093 53.5415 3.63877 53.2512 3.54777C52.9608 3.45243 52.6402 3.40477 52.2892 3.40477C51.6262 3.40477 51.0498 3.5651 50.5602 3.88577C50.0748 4.20643 49.6978 4.64627 49.4292 5.20527C49.1605 5.76427 49.0262 6.3991 49.0262 7.10977C49.0262 7.81177 49.1583 8.44227 49.4227 9.00127C49.687 9.56027 50.0597 10.0023 50.5407 10.3273C51.0217 10.6523 51.585 10.8148 52.2307 10.8148ZM52.4712 9.41077C52.0638 9.41077 51.728 9.30893 51.4637 9.10527C51.1993 8.89727 51.0022 8.61993 50.8722 8.27327C50.7465 7.9266 50.6837 7.53877 50.6837 7.10977C50.6837 6.6851 50.7487 6.29943 50.8787 5.95277C51.013 5.60177 51.2145 5.32443 51.4832 5.12077C51.7562 4.91277 52.1028 4.80877 52.5232 4.80877C53.1212 4.80877 53.5545 5.0211 53.8232 5.44577C54.0962 5.87043 54.2327 6.4251 54.2327 7.10977C54.2327 7.7901 54.0962 8.34477 53.8232 8.77377C53.5545 9.19843 53.1038 9.41077 52.4712 9.41077Z", fill: "currentColor" }),
                FronteggApp_35f1a2b2.R.createElement("path", { d: "M60.5492 10.6198H61.9337V10.0998C62.185 10.3251 62.4775 10.5006 62.8112 10.6263C63.1448 10.7519 63.5197 10.8148 63.9357 10.8148C64.5857 10.8148 65.149 10.6523 65.6257 10.3273C66.1067 10.0023 66.4793 9.56027 66.7437 9.00127C67.008 8.44227 67.1402 7.81177 67.1402 7.10977C67.1402 6.3991 67.0058 5.76427 66.7372 5.20527C66.4728 4.64627 66.0958 4.20643 65.6062 3.88577C65.1165 3.5651 64.5402 3.40477 63.8772 3.40477C63.5262 3.40477 63.2055 3.45243 62.9152 3.54777C62.6248 3.63877 62.3627 3.77093 62.1287 3.94427V1.25977H60.5492V10.6198ZM63.6952 9.41077C63.0668 9.41077 62.6162 9.19843 62.3432 8.77377C62.0702 8.34477 61.9337 7.7901 61.9337 7.10977C61.9337 6.4251 62.068 5.87043 62.3367 5.44577C62.6097 5.0211 63.0452 4.80877 63.6432 4.80877C64.0635 4.80877 64.408 4.91277 64.6767 5.12077C64.9497 5.32443 65.1512 5.60177 65.2812 5.95277C65.4155 6.29943 65.4827 6.6851 65.4827 7.10977C65.4827 7.53877 65.4176 7.9266 65.2877 8.27327C65.162 8.61993 64.967 8.89727 64.7027 9.10527C64.4383 9.30893 64.1025 9.41077 63.6952 9.41077Z", fill: "currentColor" }),
                FronteggApp_35f1a2b2.R.createElement("path", { d: "M69.2862 13.7398H70.7552L74.6682 3.59977H73.1017L71.1972 8.62427L69.2342 3.59977H67.6027L70.4432 10.5678L69.2862 13.7398Z", fill: "currentColor" }),
                FronteggApp_35f1a2b2.R.createElement("path", { className: 'frontegg-logo', d: "M100.703 12.0328V7.24279H99.795V5.87242H100.703V5.00749C100.662 4.26672 100.887 3.53554 101.337 2.94505C101.755 2.44161 102.384 2.16132 103.039 2.18719C103.636 2.19392 104.225 2.33479 104.76 2.59932L104.4 3.94337C104.249 3.86598 104.09 3.80578 103.926 3.76393C103.763 3.71814 103.595 3.69361 103.426 3.69095C102.803 3.69095 102.492 4.10787 102.492 4.94169V5.87302H104.197V7.24339H102.492V12.0334L100.703 12.0328Z", fill: "currentColor" }),
                FronteggApp_35f1a2b2.R.createElement("path", { className: 'frontegg-logo', d: "M110.833 6.60479C110.331 6.60469 109.835 6.71134 109.378 6.91762C108.972 7.09589 108.645 7.41465 108.458 7.81485V12.033H106.669V5.06155H108.311V6.55155C108.53 6.09811 108.852 5.70182 109.251 5.39412C109.598 5.11573 110.028 4.96114 110.473 4.95508C110.571 4.95508 110.644 4.95508 110.693 4.96166C110.74 4.96589 110.787 4.97248 110.833 4.9814V6.60479Z", fill: "currentColor" }),
                FronteggApp_35f1a2b2.R.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", className: 'frontegg-logo', d: "M116.223 12.1668C115.697 12.1748 115.176 12.075 114.69 11.8737C114.255 11.6918 113.862 11.4224 113.535 11.0823C113.22 10.7502 112.973 10.3596 112.808 9.93267C112.471 9.04626 112.471 8.06757 112.808 7.18116C112.972 6.75362 113.22 6.36241 113.535 6.02971C113.862 5.69004 114.255 5.42072 114.69 5.23835C115.176 5.0371 115.698 4.93754 116.224 4.94586C116.749 4.93699 117.269 5.03659 117.753 5.23835C118.618 5.60418 119.295 6.3059 119.628 7.18116C119.966 8.06741 119.966 9.04641 119.628 9.93267C119.465 10.3589 119.22 10.7496 118.908 11.0835C118.584 11.4244 118.192 11.6936 117.757 11.8737C117.271 12.0751 116.749 12.1748 116.223 12.1668ZM114.538 9.40588C114.441 9.13488 114.394 8.84889 114.397 8.56128V8.56069C114.395 8.27551 114.442 7.99208 114.538 7.72327C114.623 7.47895 114.755 7.25304 114.925 7.05753C115.087 6.87362 115.284 6.72427 115.505 6.61848C115.73 6.51154 115.976 6.45693 116.225 6.45877C116.473 6.45708 116.719 6.50933 116.945 6.6119C117.167 6.71388 117.365 6.86123 117.525 7.04437C117.696 7.23953 117.827 7.46528 117.912 7.70951C118.008 7.97835 118.055 8.26176 118.053 8.54693C118.056 8.83665 118.009 9.12474 117.912 9.3981C117.827 9.64247 117.696 9.86839 117.525 10.0638C117.364 10.2467 117.167 10.3938 116.945 10.4957C116.487 10.6993 115.963 10.6993 115.505 10.4957C115.283 10.3938 115.086 10.2467 114.925 10.0638C114.756 9.8704 114.625 9.64726 114.538 9.40588Z", fill: "currentColor" }),
                FronteggApp_35f1a2b2.R.createElement("path", { className: 'frontegg-logo', d: "M128.892 12.033H127.104V8.12104C127.138 7.69239 127.035 7.26402 126.81 6.89721C126.619 6.64235 126.314 6.49791 125.996 6.5114C125.809 6.51306 125.623 6.54916 125.449 6.61788C125.259 6.69018 125.081 6.79104 124.921 6.91695C124.753 7.04952 124.602 7.2038 124.474 7.37574C124.341 7.55154 124.242 7.74997 124.18 7.96133V12.033H122.392V5.06088H124.007V6.3517C124.27 5.90308 124.66 5.54198 125.128 5.3139C125.642 5.05988 126.21 4.93211 126.783 4.94125C127.154 4.92596 127.523 5.00849 127.851 5.18051C128.116 5.32924 128.336 5.54432 128.491 5.80439C128.648 6.07594 128.754 6.37338 128.805 6.68248C128.863 7.01191 128.892 7.34574 128.892 7.6802V12.033Z", fill: "currentColor" }),
                FronteggApp_35f1a2b2.R.createElement("path", { className: 'frontegg-logo', d: "M135.939 11.6736C135.65 11.7976 135.353 11.9041 135.051 11.9925C134.694 12.1002 134.323 12.1542 133.95 12.1528C133.714 12.1541 133.478 12.1227 133.25 12.0595C133.039 12.0014 132.844 11.8995 132.676 11.7604C132.505 11.6156 132.37 11.4334 132.282 11.228C132.177 10.9774 132.127 10.7074 132.135 10.4361V6.42843H131.227V5.06105H132.135V2.79883H133.923V5.06105H135.405V6.43142H133.923V9.83731C133.902 10.0344 133.977 10.2297 134.124 10.3631C134.262 10.4664 134.431 10.5201 134.604 10.5156C134.79 10.5159 134.976 10.4846 135.152 10.4229C135.329 10.3631 135.472 10.3075 135.578 10.2632L135.939 11.6736Z", fill: "currentColor" }),
                FronteggApp_35f1a2b2.R.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", className: 'frontegg-logo', d: "M139.902 11.8793C140.385 12.0754 140.903 12.1726 141.424 12.1653V12.1659C142.133 12.1848 142.832 12.0076 143.446 11.6538C143.978 11.3477 144.407 10.8915 144.68 10.3427L143.146 9.91739C143.017 10.2145 142.788 10.4569 142.498 10.6023C142.19 10.7733 141.843 10.8626 141.49 10.8619C141.262 10.8627 141.036 10.8222 140.823 10.7422C140.392 10.582 140.038 10.2631 139.835 9.851C139.724 9.62154 139.656 9.37353 139.635 9.11945H145.04C145.06 9.03204 145.071 8.94289 145.074 8.85328C145.08 8.7468 145.08 8.63615 145.08 8.5207C145.082 8.05725 144.998 7.59747 144.833 7.16409C144.674 6.73753 144.429 6.34793 144.113 6.01922C143.787 5.68396 143.396 5.41713 142.965 5.23444C142.482 5.03272 141.961 4.93313 141.437 4.94194C140.908 4.934 140.384 5.03352 139.895 5.23444C139.456 5.4168 139.059 5.68601 138.727 6.0258C138.407 6.35869 138.158 6.75256 137.994 7.18383C137.823 7.63193 137.737 8.10772 137.74 8.5871C137.738 9.0563 137.826 9.52154 138.001 9.95747C138.169 10.3842 138.42 10.7732 138.741 11.1017C139.072 11.4362 139.466 11.7007 139.902 11.8793ZM142.658 6.70579C143.007 7.03386 143.215 7.48408 143.239 7.96192L139.609 7.96311C139.623 7.71871 139.684 7.47929 139.789 7.25789C139.885 7.05351 140.019 6.86859 140.182 6.71237C140.343 6.56109 140.531 6.44136 140.736 6.35946C140.951 6.27456 141.18 6.2317 141.411 6.23325C141.872 6.22281 142.32 6.39235 142.658 6.70579Z", fill: "currentColor" }),
                FronteggApp_35f1a2b2.R.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", className: 'frontegg-logo', d: "M148.972 11.794C149.37 11.983 149.806 12.0786 150.246 12.0734C150.716 12.0758 151.179 11.9639 151.595 11.7474C152.003 11.5395 152.341 11.2183 152.57 10.8226V11.6977C152.577 11.9992 152.519 12.2986 152.402 12.5764C152.3 12.8125 152.144 13.0217 151.948 13.1877C151.752 13.3502 151.525 13.4704 151.28 13.5406C151.023 13.6167 150.756 13.6548 150.487 13.6537C150.038 13.6566 149.593 13.5613 149.185 13.3744C148.794 13.1982 148.449 12.9341 148.178 12.6027L147.204 13.5472C147.566 13.9992 148.024 14.3651 148.545 14.6185C149.156 14.8894 149.819 15.0188 150.487 14.9971C151.012 15.0023 151.534 14.9263 152.035 14.7716C152.482 14.6337 152.899 14.4125 153.263 14.1197C153.608 13.8396 153.884 13.4859 154.073 13.0848C154.269 12.6503 154.367 12.1779 154.359 11.7013V5.0618H152.799V6.28383C152.546 5.88329 152.202 5.54862 151.793 5.30765C151.356 5.0567 150.858 4.93029 150.353 4.94217C149.457 4.92843 148.6 5.31368 148.017 5.99313C147.727 6.33103 147.501 6.71851 147.35 7.1368C147.187 7.58916 147.105 8.06667 147.11 8.54725C147.107 9.00935 147.184 9.46847 147.338 9.90446C147.479 10.3155 147.697 10.6968 147.978 11.029C148.251 11.3515 148.59 11.6123 148.972 11.794ZM151.422 10.5568C151.242 10.6193 151.052 10.6509 150.862 10.6501V10.6495C150.597 10.652 150.335 10.5975 150.094 10.4898C149.862 10.386 149.653 10.2367 149.48 10.0508C149.304 9.86096 149.166 9.63974 149.073 9.39878C148.973 9.14442 148.923 8.87337 148.925 8.60024C148.925 8.32915 148.968 8.05974 149.053 7.8023C149.133 7.55354 149.257 7.32127 149.42 7.11682C149.579 6.91932 149.776 6.75643 150 6.6383C150.233 6.51725 150.492 6.4556 150.755 6.45885C151.142 6.46357 151.517 6.59445 151.822 6.8315C152.161 7.08146 152.421 7.4232 152.571 7.81606V9.47893C152.505 9.64276 152.415 9.7955 152.302 9.93173C152.188 10.0725 152.056 10.1977 151.909 10.3044C151.76 10.4117 151.596 10.4968 151.422 10.5568Z", fill: "currentColor" }),
                FronteggApp_35f1a2b2.R.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", className: 'frontegg-logo', d: "M158.615 11.794C159.013 11.983 159.449 12.0786 159.889 12.0734C160.359 12.0758 160.822 11.9639 161.238 11.7474C161.646 11.5395 161.984 11.2183 162.212 10.8226V11.6977C162.219 11.9992 162.162 12.2986 162.044 12.5764C161.943 12.8125 161.787 13.0217 161.59 13.1877C161.395 13.3502 161.168 13.4704 160.923 13.5406C160.666 13.6167 160.398 13.6548 160.13 13.6537C159.681 13.6566 159.236 13.5613 158.828 13.3744C158.437 13.1982 158.092 12.9341 157.821 12.6027L156.846 13.5472C157.208 13.9992 157.667 14.3651 158.188 14.6185C158.798 14.8894 159.462 15.0188 160.13 14.9971C160.654 15.0023 161.176 14.9263 161.677 14.7716C162.125 14.6337 162.542 14.4125 162.906 14.1197C163.25 13.8396 163.527 13.4859 163.716 13.0848C163.912 12.6503 164.01 12.1779 164.002 11.7013V5.0618H162.442V6.28383C162.189 5.88329 161.844 5.54862 161.436 5.30765C160.999 5.0567 160.501 4.93029 159.996 4.94217C159.099 4.92843 158.243 5.31368 157.66 5.99313C157.37 6.33103 157.144 6.71851 156.992 7.1368C156.829 7.58916 156.748 8.06667 156.752 8.54725C156.749 9.00935 156.827 9.46847 156.98 9.90446C157.122 10.3155 157.339 10.6968 157.62 11.029C157.894 11.3515 158.233 11.6123 158.615 11.794ZM161.065 10.5568C160.885 10.6193 160.695 10.6509 160.504 10.6501V10.6495C160.24 10.652 159.978 10.5975 159.736 10.4898C159.504 10.386 159.295 10.2367 159.122 10.0508C158.947 9.86096 158.809 9.63974 158.716 9.39878C158.616 9.14442 158.566 8.87337 158.568 8.60024C158.567 8.32915 158.611 8.05974 158.696 7.8023C158.776 7.55354 158.9 7.32127 159.063 7.11682C159.221 6.91932 159.418 6.75643 159.643 6.6383C159.875 6.51725 160.135 6.4556 160.397 6.45885C160.785 6.46357 161.159 6.59445 161.465 6.8315C161.804 7.08146 162.063 7.4232 162.213 7.81606V9.47893C162.148 9.64276 162.057 9.7955 161.945 9.93173C161.83 10.0725 161.698 10.1977 161.551 10.3044C161.402 10.4117 161.238 10.4968 161.065 10.5568Z", fill: "currentColor" }),
                FronteggApp_35f1a2b2.R.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", className: 'frontegg-logo', d: "M86.1318 0.640696C87.6679 -0.45273 89.204 -0.117165 90.6248 1.42248V1.42488C92.0457 2.96632 93.6202 5.97444 93.0801 9.1638C92.9701 9.85244 92.7363 10.5156 92.3901 11.1216C91.7109 12.2647 90.5934 13.0824 89.2958 13.3856C87.8565 13.7535 86.3296 13.5362 85.0512 12.7814C84.8891 12.6788 84.7336 12.5661 84.5856 12.4441C83.4536 11.445 82.7714 10.0348 82.6919 8.52975C82.6292 7.69245 82.691 6.85051 82.8755 6.03126C83.043 5.27862 83.2952 4.54723 83.6273 3.85099C84.1776 2.58766 85.0391 1.4834 86.1318 0.640696ZM84.9288 4.97281C85.1046 4.34774 85.725 2.52696 87.1897 1.61119C87.2628 1.56631 87.3063 1.48596 87.3039 1.40042C87.3014 1.31487 87.2534 1.23712 87.1779 1.19645C87.1023 1.15578 87.0108 1.15837 86.9377 1.20324C86.0757 1.77919 85.3928 2.58446 84.9666 3.52767C84.7608 3.95072 84.5929 4.39108 84.465 4.84361C84.447 4.90759 84.4564 4.97615 84.4912 5.03287C84.5259 5.0896 84.5827 5.12938 84.648 5.14269C84.7719 5.16878 84.8948 5.09442 84.9288 4.97281Z", fill: "currentColor" }),
                FronteggApp_35f1a2b2.R.createElement("path", { className: 'frontegg-logo', d: "M89.0883 14.5244C90.9056 15.3547 93.0387 15.0798 94.5845 13.8162C97.1862 11.6497 97.9068 7.22397 97.9068 7.22397C97.9068 7.22397 98.3665 4.93124 97.5204 3.60812C96.6744 2.28501 94.5845 2.29637 92.6722 2.95015C93.5268 4.68805 93.9974 6.58848 94.0523 8.52316C94.0281 11.4408 91.9581 13.9432 89.0895 14.5226", fill: "currentColor" }))));
};

const CompanyPlaceholder = () => {
    return FronteggApp_35f1a2b2.R.createElement("svg", { width: "161", height: "32", viewBox: "0 0 161 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        FronteggApp_35f1a2b2.R.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M113.765 8.66072C112.013 8.66072 111.262 10.1626 111.262 11.5643L111.287 17.6719H107.857V0H111.212V7.78464H111.287C111.862 6.58316 112.964 5.70706 114.866 5.70706C117.795 5.70706 119.297 7.73458 119.297 10.4129V17.6719H115.842V11.0136C115.842 9.61188 115.166 8.66072 113.765 8.66072ZM55.9935 4.86374e-05H59.4227V17.6719H55.9935V4.86374e-05ZM9.66134 17.6713H6.1069V11.739L0.5 1.15086H4.32974L7.10814 6.70771C7.44154 7.36408 7.70987 8.05153 7.90918 8.76023H7.98422C8.17326 8.05172 8.43325 7.36408 8.76021 6.70771L11.5136 1.15086H15.2432L9.66134 11.6638V17.6713ZM158.385 27.4094L158.475 27.3043C159.035 27.2597 159.598 27.2597 160.157 27.3043H158.966C158.966 27.4368 157.474 28.7016 156.423 29.5922L156.423 29.5926L156.422 29.5928C155.886 30.0472 155.465 30.404 155.416 30.4632C154.661 30.5241 153.749 30.5251 152.803 30.526C151.65 30.5272 150.446 30.5284 149.409 30.6384C149.612 30.6529 149.438 30.658 149.209 30.6647C148.885 30.674 148.452 30.6866 148.818 30.7335H147.627C148.003 30.733 148.378 30.6978 148.748 30.6284C147.021 30.6116 145.201 30.6173 143.418 30.6229H143.417H143.416H143.416H143.415H143.415H143.414H143.414H143.413H143.413H143.412H143.412H143.411C142.535 30.6257 141.667 30.6284 140.823 30.6284C140.022 30.6177 139.221 30.678 138.43 30.8086L138.501 30.7335H136.954C137.057 30.7631 137.084 30.7989 137.111 30.8338C137.155 30.8932 137.198 30.9499 137.614 30.9688C137.264 31.0065 136.91 31.0165 136.558 30.9988C136.743 30.9838 137.139 30.9087 136.808 30.9087C136.198 30.9062 136.106 30.9217 135.977 30.9436C135.852 30.9647 135.693 30.9917 134.996 31.0139C134.999 31.0111 135.033 31.0052 135.08 30.9971C135.289 30.9607 135.75 30.8805 134.801 30.8437C132.992 30.8091 125.911 30.8733 120.126 30.9259H120.125H120.125L120.125 30.9259H120.125H120.124L120.124 30.9259L120.124 30.9259L120.123 30.9259L120.122 30.9259L120.122 30.9259H120.122C116.751 30.9565 113.821 30.9831 112.631 30.9838C112.722 30.9714 112.873 30.9028 113.022 30.8348C113.172 30.7668 113.32 30.6995 113.405 30.6897L111.973 30.7786L112.754 30.8737C111.828 30.9668 108.533 31.057 105.437 31.1416L105.437 31.1416H105.437C102.875 31.2117 100.45 31.2781 99.6175 31.3393H100.118C98.6766 31.4444 97.6354 31.4444 95.9039 31.4444L96.9742 31.3994C96.2042 31.2813 95.4235 31.2493 94.6464 31.3042L95.2921 31.3493C94.485 31.4381 93.7713 31.4286 92.8013 31.4156L92.8009 31.4156H92.8008H92.8007C92.4052 31.4103 91.9669 31.4044 91.4624 31.4044L92.1283 31.4394H90.7365C91.2939 31.3996 90.9371 31.3785 90.5095 31.3532C90.2381 31.3372 89.9382 31.3195 89.8254 31.2942C90.4061 31.4344 88.6639 31.4344 88.1633 31.4344C88.0343 31.3979 87.6497 31.4193 87.2777 31.4401C86.8844 31.4621 86.5051 31.4833 86.4562 31.4344C85.9872 31.4604 86.2717 31.5129 86.4697 31.5263C85.879 31.5056 85.3251 31.5365 84.6382 31.5749L84.638 31.5749C84.0144 31.6097 83.2811 31.6507 82.3111 31.6646C80.8646 31.6626 80.5019 31.6494 80.325 31.6429L80.2784 31.6413C80.2618 31.6407 80.2464 31.6403 80.231 31.6399C80.128 31.6378 80.0247 31.6415 79.551 31.6585L79.5504 31.6585L79.5501 31.6585L79.55 31.6585L79.5498 31.6585C79.2037 31.6709 78.6602 31.6904 77.7755 31.7198L77.315 31.6547L77.0496 31.7648C76.7018 31.6704 76.1135 31.6611 75.5651 31.6523C75.0084 31.6435 74.4928 31.6353 74.3113 31.5395C74.1217 31.5676 73.9257 31.5661 73.676 31.5643C73.3915 31.5622 73.0374 31.5596 72.5441 31.5996C72.7823 31.6838 73.2467 31.6922 73.6824 31.7001C73.9974 31.7057 74.2974 31.7112 74.4865 31.7448C71.633 31.8019 60.7341 31.7892 55.0464 31.7825H55.0461H55.0459H55.0454H55.0448L55.0403 31.7825C53.7557 31.781 52.7376 31.7798 52.1388 31.7798C52.6695 31.7648 52.5644 31.6997 52.0637 31.6697L50.8172 31.7148C50.8717 31.7257 50.9514 31.7326 51.0213 31.7387C51.144 31.7494 51.2369 31.7575 51.1126 31.7798C50.6362 31.7528 50.1583 31.7729 49.6858 31.8399C49.7359 31.7598 48.8898 31.7598 48.8898 31.7598C48.6426 31.8042 48.1018 31.7932 47.5077 31.7812H47.5077H47.5077C46.6946 31.7648 45.7818 31.7463 45.3855 31.8649C44.5072 31.8849 44.4044 31.8562 44.2836 31.8224C44.1628 31.7886 44.0241 31.7498 43.0727 31.7498L42.9525 31.89C42.7923 31.8749 32.7999 31.935 33.0903 32.0001C32.8401 31.9339 32.583 31.897 32.3243 31.89C31.428 31.9129 30.5421 31.9229 29.6327 31.9331H29.6325C28.7592 31.9429 27.8643 31.953 26.9177 31.975C26.9555 31.972 26.993 31.9695 27.0274 31.9673H27.0274C27.1612 31.9586 27.2484 31.9529 27.1329 31.925C22.8657 31.9783 18.7162 31.9606 14.5484 31.9428H14.5484H14.5484H14.5483H14.5483H14.5483H14.5483H14.5483H14.5483H14.5482H14.5482H14.5482H14.5482L14.5473 31.9428C12.4567 31.9339 10.3616 31.925 8.24459 31.925C7.62166 31.9224 7.58008 31.8875 7.54076 31.8545C7.50423 31.8238 7.46965 31.7948 6.97306 31.7948C6.4717 31.7719 5.91181 31.8103 5.43433 31.8432C5.28724 31.8533 5.14797 31.8628 5.02063 31.8699C5.07251 31.8766 5.14564 31.8811 5.21273 31.8852C5.34634 31.8933 5.45598 31.9 5.326 31.92C4.99084 31.885 4.58073 31.885 4.16054 31.885H4.15958C4.21024 31.879 4.26625 31.8729 4.32306 31.8666H4.32308C4.60306 31.8357 4.90256 31.8027 4.67651 31.7878C4.53787 31.788 4.38391 31.7858 4.21464 31.7798H3.3836L3.44868 31.7047C-0.776536 31.1591 2.53752 28.4657 2.53752 28.4657H2.83794L4.9055 28.676C7.12199 28.5822 9.57473 28.6186 11.6681 28.6496C12.5913 28.6633 13.4446 28.676 14.1769 28.676C14.4532 28.672 14.8487 28.6705 15.3079 28.6687H15.3079H15.3079H15.3079H15.308H15.308H15.308C16.5791 28.6638 18.3382 28.6571 19.4084 28.5909L19.3383 28.6659C20.4283 28.6472 21.773 28.5872 22.8857 28.5376L22.8858 28.5376C23.5516 28.5079 24.1343 28.4819 24.5297 28.4707L24.5047 28.5008C25.2005 28.4908 27.0378 28.3956 26.8175 28.2555C27.993 28.3524 29.1731 28.3808 30.3519 28.3406H30.0215C31.2901 28.3042 35.1261 28.3029 38.817 28.3016C42.2339 28.3005 45.5263 28.2994 46.5419 28.2705L46.3467 28.3055C47.2384 28.2632 48.2294 28.2565 49.2313 28.2498H49.2314C50.4793 28.2415 51.744 28.2331 52.8547 28.1553C56.5943 28.2104 72.7193 28.2104 76.9295 28.1103C78.7417 28.0805 78.829 28.0508 78.895 28.0283C78.9622 28.0054 79.0072 27.9901 80.8343 27.9901C81.3499 27.9901 81.5752 27.9301 80.9144 27.895C81.2882 27.9013 81.7003 27.9027 82.1249 27.9041C83.0481 27.9071 84.0308 27.9103 84.8092 27.9651C89.843 27.8555 98.2731 27.7858 105.376 27.727C108.658 27.6999 111.656 27.675 113.905 27.6497H113.72C115.267 27.6365 118.319 27.6018 121.878 27.5613L121.887 27.5612L121.892 27.5611L121.898 27.5611L121.9 27.561L121.903 27.561C129.082 27.4794 138.313 27.3744 141.419 27.3744L142.355 27.2792C142.856 27.3075 143.34 27.3081 143.873 27.3087C144.379 27.3093 144.929 27.31 145.579 27.3343C146.21 27.3208 146.038 27.2546 145.756 27.2415C146.291 27.2526 146.843 27.243 147.343 27.2344L147.343 27.2344C147.905 27.2246 148.401 27.216 148.733 27.2392L148.538 27.2693C149.437 27.3088 150.148 27.2727 150.877 27.2357C151.626 27.1976 152.395 27.1586 153.409 27.1992C154.232 27.2159 155.056 27.1908 155.877 27.1241C156.404 27.1424 156.401 27.1718 156.398 27.2006C156.395 27.2268 156.392 27.2526 156.788 27.2693C157.497 27.1987 158.21 27.187 158.921 27.2342C157.935 27.2492 156.818 27.2742 156.883 27.3643C157.47 27.357 157.546 27.3781 157.613 27.3965C157.684 27.416 157.744 27.4325 158.385 27.4094ZM145.659 27.2392L145.756 27.2415C145.725 27.24 145.692 27.2392 145.659 27.2392ZM86.4697 31.5263L86.523 31.5283L86.5514 31.5295C86.5391 31.5295 86.5254 31.5292 86.5107 31.5286L86.4927 31.5277L86.4697 31.5263ZM112.584 30.9838C112.597 30.9865 112.613 30.9863 112.631 30.9838L112.584 30.9838ZM5.10314 31.7798H5.61133C5.64248 31.7531 5.56783 31.7571 5.38739 31.7667C5.3114 31.7707 5.21665 31.7757 5.10314 31.7798ZM20.0243 17.8233C23.7539 17.8233 26.232 15.3202 26.232 11.7658C26.232 8.21139 23.7289 5.70831 20.0243 5.70831C16.3197 5.70831 13.7916 8.21139 13.7916 11.7658C13.7916 15.3202 16.2697 17.8233 20.0243 17.8233ZM20.0243 8.51176C21.7014 8.51176 22.7526 9.86343 22.7526 11.7658C22.7526 13.6681 21.7014 15.0198 20.0243 15.0198C18.3472 15.0198 17.2709 13.6932 17.2709 11.7658C17.2709 9.8384 18.3222 8.51176 20.0243 8.51176ZM34.8647 17.2262C34.2064 17.6591 33.4261 17.8683 32.6396 17.8227C29.711 17.8227 28.2091 15.7952 28.2091 13.1169V5.85795H31.6634V12.5161C31.6634 13.9179 32.3643 14.8691 33.741 14.8691C35.2929 14.8691 36.0689 13.3422 36.0689 11.9655V5.85795H39.4981V17.6725L36.7196 17.7726C36.527 17.0006 36.4014 16.2134 36.3442 15.4198H36.2941C36.0242 16.1599 35.5229 16.7934 34.8647 17.2262ZM45.6057 11.9649C45.6057 9.98746 46.7321 8.9612 48.0337 8.9612C48.518 8.95606 48.9914 9.10508 49.3854 9.38671L50.2865 6.08264C49.7335 5.84415 49.1365 5.72477 48.5343 5.73223C46.7571 5.73223 45.831 6.88362 45.3805 8.38547H45.2803C45.2397 7.50419 45.0969 6.63062 44.8548 5.78228L42.1765 5.88238V17.697H45.6057V11.9649ZM67.733 17.8233C71.4626 17.8233 73.9406 15.3202 73.9406 11.7658C73.9406 8.21139 71.4376 5.70831 67.733 5.70831C64.0284 5.70831 61.5003 8.21139 61.5003 11.7658C61.5003 15.3202 63.9784 17.8233 67.733 17.8233ZM67.733 8.51176C69.4101 8.51176 70.4613 9.86343 70.4613 11.7658C70.4613 13.6681 69.4101 15.0198 67.733 15.0198C66.0559 15.0198 64.9796 13.6932 64.9796 11.7658C64.9796 9.8384 66.0209 8.51176 67.733 8.51176ZM87.6078 19.0999C87.6078 20.9772 86.2311 22.9296 81.1498 22.9296C76.8195 22.9296 74.8671 21.6781 74.8671 19.8759C74.8671 18.6994 75.618 17.8984 76.8445 17.4979C76.4399 17.2822 76.1009 16.9615 75.8631 16.5695C75.6252 16.1775 75.4974 15.7286 75.4929 15.2702C75.4998 14.7682 75.6694 14.2821 75.9764 13.8848C76.2833 13.4876 76.711 13.2008 77.1949 13.0675C76.7783 12.6883 76.4486 12.2236 76.2283 11.7052C76.0079 11.1868 75.9022 10.6268 75.9184 10.0638C75.9184 7.48558 77.9959 5.70835 81.1498 5.70835C82.2261 5.68567 83.2916 5.92628 84.2537 6.40923C85.0547 5.95867 85.3801 4.83227 85.3801 3.58072L87.9582 4.25655C87.9647 4.98466 87.7265 5.69386 87.2816 6.27033C86.8368 6.84679 86.2112 7.25716 85.5053 7.43552C86.14 8.16176 86.4793 9.09954 86.4564 10.0638C86.4564 12.642 84.3538 14.3941 81.1749 14.3941C80.4359 14.4077 79.6999 14.2977 78.9972 14.0687C78.4465 14.1939 78.1712 14.4191 78.1712 14.7946C78.1712 15.3953 78.6718 15.5956 80.0735 15.5956H82.7268C85.6054 15.5956 87.6078 16.6969 87.6078 19.0999ZM83.3025 10.0888C83.3276 8.9874 82.4765 8.18645 81.2249 8.18645C79.9734 8.18645 79.1974 8.88727 79.1474 10.0137C79.0973 11.1401 79.8482 11.916 81.1498 11.916C82.4514 11.916 83.2775 11.1901 83.3025 10.0888ZM82.4014 18.1988H80.1737V18.1738C78.4715 18.1738 77.8958 18.6243 77.8958 19.3252C77.8958 20.1512 78.6968 20.5768 81.1498 20.5768C83.6029 20.5768 84.4539 20.1011 84.4539 19.2751C84.4539 18.4491 83.8031 18.1988 82.4014 18.1988ZM94.5561 17.8233C98.2857 17.8233 100.764 15.3202 100.764 11.7658C100.764 8.21139 98.2857 5.70831 94.5561 5.70831C90.8265 5.70831 88.3234 8.21139 88.3234 11.7658C88.3234 15.3202 90.7865 17.8233 94.5561 17.8233ZM94.5561 8.51176C96.2332 8.51176 97.2845 9.86343 97.2845 11.7658C97.2845 13.6681 96.2332 15.0198 94.5561 15.0198C92.879 15.0198 91.8027 13.6932 91.8027 11.7658C91.8027 9.8384 92.839 8.51176 94.5561 8.51176ZM127.632 17.8233C130.185 17.8233 131.912 16.8221 132.713 15.7457L131.086 13.8684C130.711 14.3086 130.242 14.6586 129.713 14.8926C129.185 15.1266 128.61 15.2385 128.032 15.2201C126.08 15.2201 124.979 14.1187 124.678 12.5418H132.638C132.709 12.1284 132.742 11.7095 132.738 11.2902C132.738 8.06122 130.736 5.70831 127.306 5.70831C123.652 5.70831 121.269 8.23642 121.269 11.7658C121.269 15.2951 123.652 17.8233 127.632 17.8233ZM127.306 8.31156C128.733 8.31156 129.584 9.36281 129.609 10.7645H124.678C124.929 9.18759 125.955 8.31156 127.306 8.31156ZM140.748 8.96116C139.442 8.96116 138.315 9.98743 138.315 11.9649V17.697H134.886V5.88234L137.564 5.78224C137.807 6.63058 137.949 7.50415 137.99 8.38544H138.09C138.541 6.88358 139.467 5.73219 141.249 5.73219C141.851 5.72518 142.448 5.84454 143.001 6.0826L142.1 9.38667C141.706 9.10598 141.233 8.95706 140.748 8.96116ZM149.734 17.8233C152.287 17.8233 154.014 16.8221 154.815 15.7457L153.188 13.8684C152.814 14.3086 152.344 14.6586 151.816 14.8926C151.287 15.1266 150.713 15.2385 150.135 15.2201C148.177 15.2201 147.076 14.1187 146.781 12.5418H154.74C154.811 12.1284 154.845 11.7095 154.841 11.2902C154.841 8.06122 152.838 5.70831 149.409 5.70831C145.754 5.70831 143.371 8.23642 143.371 11.7658C143.371 15.2951 145.754 17.8233 149.734 17.8233ZM149.409 8.31156C150.836 8.31156 151.687 9.36281 151.712 10.7645H146.781C147.031 9.18759 148.052 8.31156 149.409 8.31156ZM159.6 17.4925C159.279 17.7071 158.901 17.8216 158.515 17.8216C157.998 17.8203 157.502 17.6141 157.136 17.2483C156.77 16.8824 156.564 16.3866 156.563 15.8692C156.563 15.483 156.677 15.1055 156.892 14.7845C157.106 14.4634 157.411 14.2131 157.768 14.0654C158.125 13.9176 158.517 13.8789 158.896 13.9543C159.275 14.0296 159.622 14.2156 159.896 14.4886C160.169 14.7617 160.355 15.1095 160.43 15.4883C160.505 15.867 160.467 16.2596 160.319 16.6163C160.171 16.9731 159.921 17.278 159.6 17.4925Z", fill: "#b7b7bb" }));
};
var CompanyPlaceholder$1 = CompanyPlaceholder;

const loginBoxStyler = (0,formik_esm_baae0afb.j)();
const Container$1 = loginBoxStyler(formik_esm_baae0afb.B)(({ theme }) => {
    var _a, _b, _c;
    return (Object.assign({ color: '#a9a9ab', marginTop: '.5rem', marginBottom: '2rem', width: '100%', textAlign: (_b = (_a = theme.logo) === null || _a === void 0 ? void 0 : _a.alignment) !== null && _b !== void 0 ? _b : 'center', height: '50px', '& .MuiCompanyLogo-img': {
            maxWidth: '100%',
            maxHeight: '100%',
        } }, (_c = theme.logo) === null || _c === void 0 ? void 0 : _c.style));
});
const CompanyLogo = (props) => {
    var _a, _b;
    const { logo } = (0,formik_esm_baae0afb.F)();
    let component;
    if ((_b = (_a = logo === null || logo === void 0 ? void 0 : logo.image) === null || _a === void 0 ? void 0 : _a.startsWith) === null || _b === void 0 ? void 0 : _b.call(_a, 'http')) {
        component = FronteggApp_35f1a2b2.R.createElement("img", { className: "MuiCompanyLogo-img", src: logo === null || logo === void 0 ? void 0 : logo.image, alt: "company-logo", "data-test-id": 'company-logo' });
    }
    else {
        component = FronteggApp_35f1a2b2.R.createElement(UnstyledCustomComponent, { componentKey: "logo.image" },
            FronteggApp_35f1a2b2.R.createElement(CompanyPlaceholder$1, null));
    }
    return FronteggApp_35f1a2b2.R.createElement(Container$1, Object.assign({}, props), component);
};

const styled$6 = (0,formik_esm_baae0afb.j)();
const BoxCustomComponents$1 = CustomComponent;
const BoxElementContainer = styled$6(formik_esm_baae0afb.C)(({ theme: { spacing, palette, boxStyle } }) => {
    return (Object.assign({ overflow: 'auto', maxWidth: '100%', boxSizing: 'border-box', width: '480px', padding: spacing(8), border: 'none', borderRadius: '9px', backgroundCard: palette.common.white }, boxStyle));
});
const BoxElement = ({ children, themeOptionKey: themeOptionKeyProps }) => {
    const themeOptionKey = themeOptionKeyProps !== null && themeOptionKeyProps !== void 0 ? themeOptionKeyProps : useThemeOptionKey();
    const { poweredByPlacement, logo } = (0,formik_esm_baae0afb.F)();
    return FronteggApp_35f1a2b2.R.createElement(BoxElementContainer, null,
        (logo === undefined || (logo === null || logo === void 0 ? void 0 : logo.placement) === undefined || logo.placement == 'box') && FronteggApp_35f1a2b2.R.createElement(CompanyLogo, null),
        FronteggApp_35f1a2b2.R.createElement(BoxCustomComponents$1, { componentKey: 'boxHeader', className: `fe-${themeOptionKey}-box-header` }),
        children,
        FronteggApp_35f1a2b2.R.createElement(BoxCustomComponents$1, { componentKey: 'boxFooter', className: `fe-${themeOptionKey}-box-title` }),
        (!poweredByPlacement || poweredByPlacement === 'box') && FronteggApp_35f1a2b2.R.createElement(PowerByFrontegg, null));
};
var BoxElement$1 = BoxElement;

const styled$5 = _default();
const Logo = styled$5('img')(({ theme }) => {
    var _a, _b, _c;
    return (Object.assign({ width: 'auto', maxWidth: '100%', maxHeight: '100%' }, (_c = (_b = (_a = theme.layout) === null || _a === void 0 ? void 0 : _a.splitModeStyles) === null || _b === void 0 ? void 0 : _b.logos) === null || _c === void 0 ? void 0 : _c.logoStyle));
});
const LogosContainer = styled$5(formik_esm_baae0afb.G)(({ theme }) => {
    var _a, _b, _c;
    return (Object.assign({ alignItems: 'center', justifyContent: 'space-between', rowGap: '60px' }, (_c = (_b = (_a = theme.layout) === null || _a === void 0 ? void 0 : _a.splitModeStyles) === null || _b === void 0 ? void 0 : _b.logos) === null || _c === void 0 ? void 0 : _c.logosContainerStyle));
});
const LogosComponent = ({ logos, layout = 'vertical' }) => {
    if (!logos) {
        return null;
    }
    const logosArray = FronteggApp_35f1a2b2.r.exports.useMemo(() => Object.values(logos).map((logo) => ({ id: esm_browser_v4(), logo })), [logos]);
    const vertical = layout === 'vertical';
    return (FronteggApp_35f1a2b2.R.createElement(LogosContainer, { container: true, columnGap: !vertical ? '35px' : 0 }, logosArray.map(({ id, logo }) => (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.G, { key: id, xs: vertical ? 6 : 3, item: true },
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { width: '100%', maxHeight: '3rem', display: 'flex', justifyContent: 'center' },
            FronteggApp_35f1a2b2.R.createElement(Logo, { src: logo, alt: logo })))))));
};

const styled$4 = (0,formik_esm_baae0afb.j)();
const Icon = styled$4(formik_esm_baae0afb.k)(({ theme }) => {
    var _a, _b, _c;
    return (Object.assign({ marginRight: theme.spacing(5), color: theme.palette.primary.main }, (_c = (_b = (_a = theme.layout) === null || _a === void 0 ? void 0 : _a.splitModeStyles) === null || _b === void 0 ? void 0 : _b.values) === null || _c === void 0 ? void 0 : _c.valuesIconStyle));
});
const Value = styled$4(formik_esm_baae0afb.B)(({ theme }) => {
    var _a, _b, _c;
    return (Object.assign({}, (_c = (_b = (_a = theme.layout) === null || _a === void 0 ? void 0 : _a.splitModeStyles) === null || _b === void 0 ? void 0 : _b.values) === null || _c === void 0 ? void 0 : _c.valuesTextStyle));
});
const ValuesContainer = styled$4(formik_esm_baae0afb.B)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
});
const ValuesComponent = ({ t }) => {
    const values = t('valuesComponent', { returnObjects: true });
    const isValuesEmpty = typeof values === 'string';
    const preparedValues = FronteggApp_35f1a2b2.r.exports.useMemo(() => (isValuesEmpty ? [] : Object.values(values)), [values, isValuesEmpty]);
    if (!preparedValues.length) {
        return null;
    }
    return (FronteggApp_35f1a2b2.R.createElement(ValuesContainer, null, preparedValues.map((value, index) => {
        const isLastItem = index === preparedValues.length - 1;
        return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { key: value, width: '100%', display: 'flex', mb: isLastItem ? 0 : 4, alignItems: 'center' },
            FronteggApp_35f1a2b2.R.createElement(Icon, null),
            FronteggApp_35f1a2b2.R.createElement(Value, null, value)));
    })));
};

const styled$3 = (0,formik_esm_baae0afb.j)();
const TestimonialsContainer = styled$3(formik_esm_baae0afb.B)(({ theme }) => {
    var _a, _b, _c;
    return (Object.assign({ marginBottom: theme.spacing(10) }, (_c = (_b = (_a = theme.layout) === null || _a === void 0 ? void 0 : _a.splitModeStyles) === null || _b === void 0 ? void 0 : _b.testimonials) === null || _c === void 0 ? void 0 : _c.testimonialsContainerStyle));
});
const Label = styled$3((props) => FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.T, Object.assign({}, props, { variant: 'testimonialTitle' })))(({ theme }) => {
    var _a, _b, _c;
    return (Object.assign({}, ((_c = (_b = (_a = theme.layout) === null || _a === void 0 ? void 0 : _a.splitModeStyles) === null || _b === void 0 ? void 0 : _b.testimonials) === null || _c === void 0 ? void 0 : _c.testimonialsTitleStyle)));
});
const SubTitle = styled$3((props) => FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.T, Object.assign({}, props, { variant: 'testimonialSubtitle' })))(({ theme }) => {
    var _a, _b, _c;
    return (Object.assign({}, ((_c = (_b = (_a = theme.layout) === null || _a === void 0 ? void 0 : _a.splitModeStyles) === null || _b === void 0 ? void 0 : _b.testimonials) === null || _c === void 0 ? void 0 : _c.testtomonialsSubtitleStyle)));
});
const Description$1 = styled$3((props) => FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.T, Object.assign({}, props, { variant: 'testimonialDescription' })))(({ theme }) => {
    var _a, _b, _c;
    return (Object.assign({}, ((_c = (_b = (_a = theme.layout) === null || _a === void 0 ? void 0 : _a.splitModeStyles) === null || _b === void 0 ? void 0 : _b.testimonials) === null || _c === void 0 ? void 0 : _c.testimonialsTextStyle)));
});
const TestimonialsComponent = ({ testimonials, t }) => {
    var _a, _b, _c, _d, _e, _f;
    const { layout } = (0,formik_esm_baae0afb.F)();
    const testimonialsObject = t('testimonialComponent', {
        returnObjects: true,
    });
    if (typeof testimonialsObject === 'string') {
        return null;
    }
    const testimonialsImagesArray = FronteggApp_35f1a2b2.r.exports.useMemo(() => (testimonials ? Object.values(testimonials).map((t) => t) : []), [
        testimonials,
    ]);
    const preparedTestimonials = FronteggApp_35f1a2b2.r.exports.useMemo(() => Object.keys(testimonialsObject).map((key, index) => {
        return Object.assign(Object.assign({}, testimonialsObject[key]), { image: testimonialsImagesArray[index] });
    }).filter((item) => item.label && item.text), [testimonialsObject, testimonialsImagesArray]);
    const indicatorPropsStyles = (_b = (_a = layout === null || layout === void 0 ? void 0 : layout.splitModeStyles) === null || _a === void 0 ? void 0 : _a.testimonials) === null || _b === void 0 ? void 0 : _b.testimonialsIndicatorStyle;
    const indicatorActivePropsStyles = (_d = (_c = layout === null || layout === void 0 ? void 0 : layout.splitModeStyles) === null || _c === void 0 ? void 0 : _c.testimonials) === null || _d === void 0 ? void 0 : _d.testimonialsActiveIndicatorStyle;
    const indicatorContainerPropsStyles = (_f = (_e = layout === null || layout === void 0 ? void 0 : layout.splitModeStyles) === null || _e === void 0 ? void 0 : _e.testimonials) === null || _f === void 0 ? void 0 : _f.testimonialsIndicatorContainerStyle;
    return (FronteggApp_35f1a2b2.R.createElement(TestimonialsContainer, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.az, { duration: 750, navButtonsAlwaysInvisible: true, indicatorIconButtonProps: { style: indicatorPropsStyles }, indicatorContainerProps: { style: indicatorContainerPropsStyles }, activeIndicatorIconButtonProps: { style: indicatorActivePropsStyles } }, preparedTestimonials.map(({ label, subtitle, text, image }) => {
            return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { key: label, textAlign: 'center' },
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { mb: 8 },
                    FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, null,
                        image && (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { display: 'flex', justifyContent: 'center' },
                            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { mb: 3, borderRadius: '50%', height: '80px', width: '80px', border: '2px solid #fff', sx: {
                                    background: `url(${image})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'contain',
                                    backgroundPosition: 'center',
                                } }))),
                        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, null,
                            FronteggApp_35f1a2b2.R.createElement(Label, null, label),
                            FronteggApp_35f1a2b2.R.createElement(SubTitle, null, subtitle)))),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, null,
                    FronteggApp_35f1a2b2.R.createElement(Description$1, null, text))));
        }))));
};

const styled$2 = _default();
const TitleDescriptionContainer = styled$2(formik_esm_baae0afb.B)(({ theme }) => {
    var _a, _b, _c;
    return (Object.assign({ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', marginBottom: '2.5rem' }, (_c = (_b = (_a = theme.layout) === null || _a === void 0 ? void 0 : _a.splitModeStyles) === null || _b === void 0 ? void 0 : _b.titleDescription) === null || _c === void 0 ? void 0 : _c.titleDescriptionContainerStyle));
});
const Title = styled$2((props) => FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.T, Object.assign({}, props, { variant: 'h1' })))(({ theme }) => {
    var _a, _b, _c;
    return (Object.assign({}, ((_c = (_b = (_a = theme.layout) === null || _a === void 0 ? void 0 : _a.splitModeStyles) === null || _b === void 0 ? void 0 : _b.titleDescription) === null || _c === void 0 ? void 0 : _c.titleDescriptionTitleStyle)));
});
const CompanyName = styled$2('span')(({ theme }) => {
    var _a, _b, _c;
    return (Object.assign({}, ((_c = (_b = (_a = theme.layout) === null || _a === void 0 ? void 0 : _a.splitModeStyles) === null || _b === void 0 ? void 0 : _b.titleDescription) === null || _c === void 0 ? void 0 : _c.titleDescriptionCompanyNameStyle)));
});
const Description = styled$2((props) => FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.T, Object.assign({}, props, { variant: 'description' })))(({ theme }) => {
    var _a, _b, _c;
    return (Object.assign({ width: '100%' }, (_c = (_b = (_a = theme.layout) === null || _a === void 0 ? void 0 : _a.splitModeStyles) === null || _b === void 0 ? void 0 : _b.titleDescription) === null || _c === void 0 ? void 0 : _c.titleDescriptionDescriptionStyle));
});
const TitleDescriptionComponent = ({ t }) => {
    const titleDescriptionComponent = t('titleDescriptionComponent', {
        returnObjects: true,
    });
    if (typeof titleDescriptionComponent === 'string') {
        return null;
    }
    const { titleBeforeCompanyName, titleAfterCompanyName, description, companyName } = titleDescriptionComponent;
    const titleBeforeCompanyNamePresent = !titleBeforeCompanyName.includes('titleBeforeCompanyName');
    const titleAfterCompanyNamePresent = !titleAfterCompanyName.includes('titleAfterCompanyName');
    const companyNamePresent = !companyName.includes('companyName') && !!companyName;
    const descriptionPresent = !description.includes('description') && !!description;
    return (FronteggApp_35f1a2b2.R.createElement(TitleDescriptionContainer, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { mb: descriptionPresent ? 4 : 0, display: 'flex', flexWrap: 'wrap' },
            FronteggApp_35f1a2b2.R.createElement(Title, null,
                titleBeforeCompanyNamePresent && titleBeforeCompanyName,
                companyNamePresent && FronteggApp_35f1a2b2.R.createElement(CompanyName, null,
                    "\u00A0",
                    companyName),
                "\u00A0",
                titleAfterCompanyNamePresent && titleAfterCompanyName)),
        descriptionPresent && FronteggApp_35f1a2b2.R.createElement(Description, null, description)));
};

const styled$1 = _default();
const SideElementsDivider = styled$1(formik_esm_baae0afb.D)(({ theme, showdivider }) => {
    var _a, _b;
    return (Object.assign({ width: showdivider ? '100%' : 0, margin: showdivider ? '7.5vh 0' : '3vh 0' }, (_b = (_a = theme.layout) === null || _a === void 0 ? void 0 : _a.splitModeStyles) === null || _b === void 0 ? void 0 : _b.dividerStyle));
});
const SideElementsComponent = ({ themeOptionKey: themeOptionKeyProps }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x;
    const { layout } = (0,formik_esm_baae0afb.F)();
    const localizationKey = themeOptionKeyProps === 'signup' ? 'splitSignUp' : 'splitLogin';
    const t = useT(`${themeOptionKeyProps}.${[localizationKey]}`);
    const twoSideElementsActive = !!((_b = (_a = layout === null || layout === void 0 ? void 0 : layout.splitModeElements) === null || _a === void 0 ? void 0 : _a.activeElements) === null || _b === void 0 ? void 0 : _b.element1) && !!((_d = (_c = layout === null || layout === void 0 ? void 0 : layout.splitModeElements) === null || _c === void 0 ? void 0 : _c.activeElements) === null || _d === void 0 ? void 0 : _d.element2);
    const showTitle = !!((_f = (_e = layout === null || layout === void 0 ? void 0 : layout.splitModeElements) === null || _e === void 0 ? void 0 : _e.activeElements) === null || _f === void 0 ? void 0 : _f.titleDescription);
    const splitModeElements = FronteggApp_35f1a2b2.r.exports.useMemo(() => {
        var _a, _b, _c, _d, _e;
        return ({
            logos: (FronteggApp_35f1a2b2.R.createElement(LogosComponent, { layout: twoSideElementsActive || showTitle ? 'horizontal' : (_b = (_a = layout === null || layout === void 0 ? void 0 : layout.splitModeElements) === null || _a === void 0 ? void 0 : _a.logos) === null || _b === void 0 ? void 0 : _b.layout, logos: (_d = (_c = layout === null || layout === void 0 ? void 0 : layout.splitModeElements) === null || _c === void 0 ? void 0 : _c.logos) === null || _d === void 0 ? void 0 : _d.logos })),
            values: FronteggApp_35f1a2b2.R.createElement(ValuesComponent, { t: t }),
            testimonials: FronteggApp_35f1a2b2.R.createElement(TestimonialsComponent, { t: t, testimonials: (_e = layout === null || layout === void 0 ? void 0 : layout.splitModeElements) === null || _e === void 0 ? void 0 : _e.testimonials }),
            titleDescription: FronteggApp_35f1a2b2.R.createElement(TitleDescriptionComponent, { t: t }),
        });
    }, [
        twoSideElementsActive,
        showTitle,
        (_h = (_g = layout === null || layout === void 0 ? void 0 : layout.splitModeElements) === null || _g === void 0 ? void 0 : _g.logos) === null || _h === void 0 ? void 0 : _h.layout,
        (_k = (_j = layout === null || layout === void 0 ? void 0 : layout.splitModeElements) === null || _j === void 0 ? void 0 : _j.logos) === null || _k === void 0 ? void 0 : _k.logos,
        (_l = layout === null || layout === void 0 ? void 0 : layout.splitModeElements) === null || _l === void 0 ? void 0 : _l.testimonials,
        t,
    ]);
    const showDivider = (_o = (_m = layout === null || layout === void 0 ? void 0 : layout.splitModeElements) === null || _m === void 0 ? void 0 : _m.showDivider) !== null && _o !== void 0 ? _o : true;
    const showTitleDivider = !!((_p = layout === null || layout === void 0 ? void 0 : layout.splitModeElements) === null || _p === void 0 ? void 0 : _p.showTitleDivider);
    if (((layout === null || layout === void 0 ? void 0 : layout.type) !== 'float-left' && (layout === null || layout === void 0 ? void 0 : layout.type) !== 'float-right') || !!(layout === null || layout === void 0 ? void 0 : layout.sideElement)) {
        return FronteggApp_35f1a2b2.R.createElement(CustomComponent, { componentKey: 'layout.sideElement', className: 'fe-page-side-element' });
    }
    return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { className: 'fe-page-side-element', display: 'grid', justifyItems: 'center', alignItems: 'center' },
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { minWidth: '70%', maxWidth: '70%', py: 10 },
            showTitle && splitModeElements['titleDescription'],
            showTitle && showTitleDivider && FronteggApp_35f1a2b2.R.createElement(SideElementsDivider, { showdivider: showTitleDivider ? 'true' : undefined }),
            ((_r = (_q = layout === null || layout === void 0 ? void 0 : layout.splitModeElements) === null || _q === void 0 ? void 0 : _q.activeElements) === null || _r === void 0 ? void 0 : _r.element1) &&
                splitModeElements[(_t = (_s = layout === null || layout === void 0 ? void 0 : layout.splitModeElements) === null || _s === void 0 ? void 0 : _s.activeElements) === null || _t === void 0 ? void 0 : _t.element1],
            twoSideElementsActive && FronteggApp_35f1a2b2.R.createElement(SideElementsDivider, { showdivider: showDivider ? 'true' : undefined }),
            ((_v = (_u = layout.splitModeElements) === null || _u === void 0 ? void 0 : _u.activeElements) === null || _v === void 0 ? void 0 : _v.element2) &&
                splitModeElements[(_x = (_w = layout.splitModeElements) === null || _w === void 0 ? void 0 : _w.activeElements) === null || _x === void 0 ? void 0 : _x.element2])));
};

const styled = (0,formik_esm_baae0afb.j)();
const BoxCustomComponents = CustomComponent;
const PageElementContainer = styled(formik_esm_baae0afb.B)(({ theme }) => ({
    flex: 1,
    height: '100vh',
    overflow: 'auto',
    position: 'relative',
}));
const Container = styled(formik_esm_baae0afb.B)(({ theme: { pageStyle } }) => (Object.assign({ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', padding: '2rem 0', boxSizing: 'border-box' }, pageStyle)));
const PageElement = ({ children, themeOptionKey: themeOptionKeyProps }) => {
    const themeOptionKey = themeOptionKeyProps !== null && themeOptionKeyProps !== void 0 ? themeOptionKeyProps : useThemeOptionKey();
    const { poweredByPlacement, logo } = (0,formik_esm_baae0afb.F)();
    return FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        FronteggApp_35f1a2b2.R.createElement(PageElementContainer, { className: 'fe-page-container-element' },
            FronteggApp_35f1a2b2.R.createElement(Container, null,
                (logo === null || logo === void 0 ? void 0 : logo.placement) === 'page' && FronteggApp_35f1a2b2.R.createElement(CompanyLogo, null),
                FronteggApp_35f1a2b2.R.createElement(BoxCustomComponents, { componentKey: 'pageHeader', className: `fe-${themeOptionKey}-page-header` }),
                children,
                FronteggApp_35f1a2b2.R.createElement(BoxCustomComponents, { componentKey: 'pageFooter', className: `fe-${themeOptionKey}-page-footer` }),
                (poweredByPlacement === 'page' || poweredByPlacement === 'leftBottomCorner') && FronteggApp_35f1a2b2.R.createElement(PowerByFrontegg, null))),
        FronteggApp_35f1a2b2.R.createElement(SideElementsComponent, { themeOptionKey: themeOptionKey }));
};
var PageElement$1 = PageElement;

const wrapPage = (Component, themeOptionKey) => () => {
    return FronteggApp_35f1a2b2.R.createElement(RootElement$1, { themeOptionKey: themeOptionKey },
        FronteggApp_35f1a2b2.R.createElement(PageElement$1, { themeOptionKey: themeOptionKey },
            FronteggApp_35f1a2b2.R.createElement(BoxElement$1, { themeOptionKey: themeOptionKey },
                FronteggApp_35f1a2b2.R.createElement(Component, null))));
};
const wrapPageWithoutBox = (Component, themeOptionKey) => () => {
    return FronteggApp_35f1a2b2.R.createElement(RootElement$1, { themeOptionKey: themeOptionKey },
        FronteggApp_35f1a2b2.R.createElement(PageElement$1, { themeOptionKey: themeOptionKey },
            FronteggApp_35f1a2b2.R.createElement(Component, null)));
};
const wrapPageContext = (Component, themeOptionKey) => () => {
    return FronteggApp_35f1a2b2.R.createElement(ThemeOptionKeyContext$1.Provider, { value: themeOptionKey },
        FronteggApp_35f1a2b2.R.createElement(TransparentRootElement, null,
            FronteggApp_35f1a2b2.R.createElement(Component, null)));
};

const TenantInvitationFailed = ({ t, variant }) => {
    const { resetLoginState } = (0,formik_esm_baae0afb.V)();
    const routes = (0,formik_esm_baae0afb.K)();
    const { inviteTokenError } = (0,formik_esm_baae0afb.a4)(({ inviteTokenError }) => ({ inviteTokenError }));
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const backPath = FronteggApp_35f1a2b2.r.exports.useMemo(() => variant === 'signup' ? routes.signUpUrl : routes.loginUrl, [variant]);
    return FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.a3, { title: t('failedJoinTenantTitle'), description: inviteTokenError || '', testId: "tenant-invitation-failed" },
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { sx: { mt: 8 }, className: 'fe-back-to-login-btn', "data-test-id": 'back-to-login-btn', onClick: () => {
                    resetLoginState();
                    onRedirectTo(backPath, { preserveQueryParams: false });
                } }, t('failedJoinTenantBackButton'))));
};

const TitleComponent = (0,formik_esm_baae0afb.f)(UnstyledCustomComponent)(({ isThumbnailMode, theme, componentKey, componentKeys = [] }) => (Object.assign(Object.assign({ transition: 'all 0.3s ease-in-out', fontStyle: 'normal', fontWeight: 'bold', marginBottom: '2rem', fontSize: isThumbnailMode ? '1.25rem' : '1.5rem', opacity: isThumbnailMode ? 0.5 : 1, lineHeight: '2.5rem', textAlign: 'center' }, (theme[`boxTitleStyle`])), ([componentKey, ...componentKeys.slice().reverse()].reduce((styles, key) => (Object.assign(Object.assign({}, styles), theme[`${key}Style`])), {})))));
const BoxTitle = ({ isThumbnailMode, componentKey, title, componentKeys }) => {
    return FronteggApp_35f1a2b2.R.createElement(TitleComponent, { isThumbnailMode: isThumbnailMode, componentKey: componentKey, componentKeys: componentKeys, className: `fe-${componentKey}`, title: title }, title);
};
const MessageComponent = (0,formik_esm_baae0afb.f)(UnstyledCustomComponent)(({ theme, componentKey, componentKeys = [], textAlignCenter }) => (Object.assign(Object.assign({ fontStyle: 'normal', fontWeight: 400, fontSize: '1rem', marginTop: '0.5rem', marginBottom: '1.5rem', lineHeight: '1.5rem', textAlign: `${textAlignCenter ? 'center' : 'inherit'}`, color: '#7A7D93' }, (theme[`boxMessageStyle`])), ([componentKey, ...componentKeys.slice().reverse()].reduce((styles, key) => (Object.assign(Object.assign({}, styles), theme[`${key}Style`])), {})))));
const BoxMessage = ({ componentKey, message, componentKeys, textAlignCenter }) => {
    return FronteggApp_35f1a2b2.R.createElement(MessageComponent, { componentKey: componentKey, componentKeys: componentKeys, className: `fe-${componentKey}`, message: message, textAlignCenter: textAlignCenter }, message);
};

const loginStyler = (0,formik_esm_baae0afb.j)();
const LoginPageTitle = BoxTitle;
const LoginPageMessage = BoxMessage;
const SignupMessageComponent = CustomComponent;
const ResendOTCComponent = UnstyledCustomComponent;
const LoginIconComponent = CustomComponent;

const loaderStyler = (0,formik_esm_baae0afb.j)();
const CenterContent = loaderStyler(formik_esm_baae0afb.B)(({ theme }) => {
    return ({
        background: '#FFFFFF',
        position: 'fixed',
        top: '0',
        left: '0',
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 100000,
    });
});
const getUri$1 = (urlStrategy) => {
    if (urlStrategy === 'path') {
        return (window !== null && window !== void 0 ? window : document).location.pathname;
    }
    else {
        return ((window !== null && window !== void 0 ? window : document).location.hash || '#').substring(1);
    }
};
const PageLoader = () => {
    var _a, _b;
    const { customLoader } = (0,formik_esm_baae0afb.v)();
    const theme = (0,formik_esm_baae0afb.F)();
    const { loginUrl, logoutUrl, activateUrl, acceptInvitationUrl, forgetPasswordUrl, resetPasswordUrl, } = (0,formik_esm_baae0afb.K)();
    const { urlStrategy } = (0,formik_esm_baae0afb.v)();
    const pathname = getUri$1(urlStrategy);
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        document.body.classList.add('frontegg-loading');
        (typeof customLoader === 'function') && (customLoader === null || customLoader === void 0 ? void 0 : customLoader(true));
        return () => {
            document.body.classList.remove('frontegg-loading');
            (typeof customLoader === 'function') && (customLoader === null || customLoader === void 0 ? void 0 : customLoader(false));
        };
    }, [customLoader]);
    const isAuthRoute = FronteggApp_35f1a2b2.r.exports.useMemo(() => {
        const routeValue = [loginUrl, logoutUrl, activateUrl, acceptInvitationUrl, forgetPasswordUrl, resetPasswordUrl];
        return routeValue.includes(pathname);
    }, [
        pathname,
        loginUrl,
        logoutUrl,
        activateUrl,
        acceptInvitationUrl,
        forgetPasswordUrl,
        resetPasswordUrl
    ]);
    if (customLoader) {
        return null;
    }
    return FronteggApp_35f1a2b2.R.createElement(CenterContent, { sx: (isAuthRoute ? Object.assign(Object.assign({}, theme.rootStyle), (_a = theme.loader) === null || _a === void 0 ? void 0 : _a.containerStyle) : Object.assign({}, (_b = theme.loader) === null || _b === void 0 ? void 0 : _b.containerStyle)) },
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.O, { "data-test-id": "page-loader" }));
};

var LoginStrategyID;
(function (LoginStrategyID) {
    LoginStrategyID["Internal"] = "internal";
    LoginStrategyID["UsbKey"] = "usb-key";
    LoginStrategyID["Main"] = "main";
    LoginStrategyID["Android"] = "android";
    LoginStrategyID["Sms"] = "sms";
})(LoginStrategyID || (LoginStrategyID = {}));
const LoginCarouselContext = FronteggApp_35f1a2b2.r.exports.createContext({});
const useLoginCarouselContext = () => FronteggApp_35f1a2b2.r.exports.useContext(LoginCarouselContext);
const useShowThumbnail = (loginStrategyId) => {
    const { items, activeIndex } = useLoginCarouselContext();
    const isActiveInCarousel = activeIndex === (items === null || items === void 0 ? void 0 : items.findIndex(({ id }) => loginStrategyId === id));
    return !isActiveInCarousel;
};

const LoginIconContainer = (0,formik_esm_baae0afb.f)((_a) => {
    var props = (0,FronteggApp_35f1a2b2.f)(_a, ["isThumbnailMode", "iconSize"]);
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, Object.assign({}, props));
})(({ isThumbnailMode, iconSize, theme }) => ({
    transition: 'all 0.3s ease-in-out',
    display: 'flex',
    justifyContent: 'center',
    marginBottom: isThumbnailMode ? 0 : '1.5rem',
    marginTop: isThumbnailMode ? '1rem' : 0,
    svg: {
        color: 'transparent',
        transition: 'all 0.3s ease-in-out',
        width: isThumbnailMode ? '64px' : `${iconSize !== null && iconSize !== void 0 ? iconSize : 150}px`,
        height: isThumbnailMode ? '64px' : `${iconSize !== null && iconSize !== void 0 ? iconSize : 150}px`,
        opacity: isThumbnailMode ? 0.5 : 1,
        '.custom-fill': {
            fill: theme.palette.primary.main
        },
        '.custom-stroke': {
            stroke: theme.palette.primary.main
        },
    }
}));

const RecaptchaContext = FronteggApp_35f1a2b2.r.exports.createContext({});
const RecaptchaProvider = ({ children, action }) => {
    var _a;
    const recaptchaRef = FronteggApp_35f1a2b2.r.exports.useRef(null);
    const [onTokenLoad, setOnTokenLoad] = FronteggApp_35f1a2b2.r.exports.useState(() => (token) => { });
    const recaptcha = useRecaptcha({ action, recaptchaRef, onTokenLoad });
    const loadNewToken = FronteggApp_35f1a2b2.r.exports.useCallback((callback) => {
        var _a;
        if (callback) {
            setOnTokenLoad(() => (token) => {
                callback(token);
                setOnTokenLoad(() => (token) => { });
            });
        }
        (_a = recaptchaRef === null || recaptchaRef === void 0 ? void 0 : recaptchaRef.current) === null || _a === void 0 ? void 0 : _a.execute();
    }, [setOnTokenLoad, recaptchaRef]);
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        return () => {
            const recaptchaElement = document.getElementsByClassName('grecaptcha-badge')[0];
            if (recaptchaElement) {
                recaptchaElement.style.visibility = 'hidden';
            }
        };
    }, []);
    return (FronteggApp_35f1a2b2.R.createElement(RecaptchaContext.Provider, { value: { loadNewToken, recaptchaRef, token: (_a = recaptcha === null || recaptcha === void 0 ? void 0 : recaptcha.token) !== null && _a !== void 0 ? _a : '' } },
        children,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { position: 'absolute' }, recaptcha === null || recaptcha === void 0 ? void 0 : recaptcha.component)));
};
const useRecaptchaContext = () => FronteggApp_35f1a2b2.r.exports.useContext(RecaptchaContext);

const LoginErrorMessage = (0,formik_esm_baae0afb.f)(formik_esm_baae0afb.A)(({ theme }) => ({
    padding: '0.5rem 1rem',
    marginBottom: theme.spacing(2),
}));
LoginErrorMessage.defaultProps = {
    className: 'fe-alert-error',
    severity: 'error',
};

const LoginWithWebAuthnForm = ({ onMainAuthenticationRequired, loginStrategyId, buttonText, transports, authenticatorAttachment }) => {
    const { webAuthnPrelogin, webAuthnPostLogin, webAuthnCreateNewDeviceSession, webAuthnVerifyNewDeviceSession, afterAuthNavigation, resetLoginState } = (0,formik_esm_baae0afb.U)();
    const { loading, error } = (0,formik_esm_baae0afb.a4)();
    const { recaptchaRef, token, loadNewToken } = useRecaptchaContext();
    const user = (0,formik_esm_baae0afb.X)();
    const handleRegisterNewLogin = FronteggApp_35f1a2b2.r.exports.useCallback((user) => {
        const createNewDeviceCallback = (response) => (0,FronteggApp_35f1a2b2.g)(void 0, void 0, void 0, function* () {
            if (!response)
                return;
            const publicKey = Object.assign(Object.assign({}, response), { authenticatorSelection: Object.assign(Object.assign({}, response.authenticatorSelection), { authenticatorAttachment }) });
            const result = yield navigator.credentials.create({ publicKey });
            if (!result)
                return;
            const verifyNewDeviceSessionCallback = (success) => {
                if (!success)
                    return;
                localStorage.setItem(`${user.email}-${loginStrategyId}`, 'true');
                localStorage.setItem(`${user.email}-preferred-login-method`, loginStrategyId);
                resetLoginState();
                afterAuthNavigation();
            };
            webAuthnVerifyNewDeviceSession({ publicKey: result, callback: verifyNewDeviceSessionCallback });
        });
        webAuthnCreateNewDeviceSession({ callback: createNewDeviceCallback });
    }, [webAuthnCreateNewDeviceSession, webAuthnVerifyNewDeviceSession, resetLoginState]);
    const handleLoginUser = FronteggApp_35f1a2b2.r.exports.useCallback((email) => (0,FronteggApp_35f1a2b2.g)(void 0, void 0, void 0, function* () {
        const preloginCallback = (response) => (0,FronteggApp_35f1a2b2.g)(void 0, void 0, void 0, function* () {
            var _a;
            if (!response)
                return;
            response.allowCredentials = (_a = response.allowCredentials) === null || _a === void 0 ? void 0 : _a.map((credential) => (Object.assign(Object.assign({}, credential), { transports })));
            const publicKey = response;
            let result;
            try {
                result = yield navigator.credentials.get({ publicKey });
                if (!result) {
                    loadNewToken();
                    return;
                }
            }
            catch (e) {
                loadNewToken();
                console.log(e);
                return;
            }
            const postloginCallback = (success) => {
                if (!success) {
                    loadNewToken();
                    return;
                }
                localStorage.setItem(`${email}-${loginStrategyId}`, 'true');
                localStorage.setItem(`${email}-preferred-login-method`, loginStrategyId);
                resetLoginState();
            };
            if (recaptchaRef === null || recaptchaRef === void 0 ? void 0 : recaptchaRef.current) {
                loadNewToken((recaptchaToken) => webAuthnPostLogin({ publicKey: result, recaptchaToken, callback: postloginCallback }));
            }
            else {
                webAuthnPostLogin({ publicKey: result, callback: postloginCallback });
            }
        });
        webAuthnPrelogin({ email, recaptchaToken: token, callback: preloginCallback });
    }), [webAuthnPrelogin, webAuthnPostLogin, token]);
    const handleSubmit = FronteggApp_35f1a2b2.r.exports.useCallback(() => new Promise((resolve) => {
        const email = localStorage.getItem('email');
        const usedStrategy = localStorage.getItem(`${email}-${loginStrategyId}`);
        if (email && usedStrategy) {
            handleLoginUser(email);
        }
        else if (user) {
            handleRegisterNewLogin(user);
        }
        else {
            onMainAuthenticationRequired === null || onMainAuthenticationRequired === void 0 ? void 0 : onMainAuthenticationRequired();
        }
    }), [handleLoginUser, handleRegisterNewLogin, onMainAuthenticationRequired, user]);
    return FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        error && FronteggApp_35f1a2b2.R.createElement(LoginErrorMessage, null, error),
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.l, { sx: { mt: 4 }, fullWidth: true, loading: loading, color: "primary", type: "submit", onClick: handleSubmit }, buttonText));
};

const LoginWithWebAuthn = (props) => {
    const { titleComponentKey, messageComponentKey, loginStrategyId, title, message, iconComponentKey, defaultIcon } = props;
    const isThumbnailMode = useShowThumbnail(loginStrategyId);
    return FronteggApp_35f1a2b2.R.createElement(BoxElement$1, null,
        FronteggApp_35f1a2b2.R.createElement(LoginPageTitle, { isThumbnailMode: isThumbnailMode, componentKey: titleComponentKey, title: title }),
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aD, { in: !isThumbnailMode, appear: false, timeout: 300 },
            FronteggApp_35f1a2b2.R.createElement(LoginPageMessage, { componentKey: messageComponentKey, message: message, textAlignCenter: true })),
        FronteggApp_35f1a2b2.R.createElement(LoginIconContainer, { isThumbnailMode: isThumbnailMode },
            FronteggApp_35f1a2b2.R.createElement(LoginIconComponent, { componentKey: iconComponentKey }, defaultIcon)),
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aD, { in: !isThumbnailMode, appear: false, timeout: 300 },
            FronteggApp_35f1a2b2.R.createElement(LoginWithWebAuthnForm, Object.assign({}, props))));
};

const LoginWithTouchID = ({ onMainAuthenticationRequired }) => {
    const t = useT('login');
    return FronteggApp_35f1a2b2.R.createElement(LoginWithWebAuthn, { onMainAuthenticationRequired: onMainAuthenticationRequired, loginStrategyId: LoginStrategyID.Internal, title: t('oneTouchLoginTitle'), message: t('oneTouchLoginMessage'), buttonText: t('oneTouchLoginButton'), transports: ['internal'], defaultIcon: FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aA, null), authenticatorAttachment: 'platform', iconComponentKey: 'touchIdCardIcon', titleComponentKey: 'touchIdTitle', messageComponentKey: 'touchIdMessage' });
};

const LoginWithUsbKey = ({ onMainAuthenticationRequired }) => {
    const t = useT('login');
    return FronteggApp_35f1a2b2.R.createElement(LoginWithWebAuthn, { onMainAuthenticationRequired: onMainAuthenticationRequired, title: t('usbLoginTitle'), message: t('usbLoginMessage'), buttonText: t('usbLoginButton'), transports: ['usb'], defaultIcon: FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aB, null), loginStrategyId: LoginStrategyID.UsbKey, authenticatorAttachment: 'cross-platform', iconComponentKey: 'usbKeyCardIcon', titleComponentKey: 'usbKeyTitle', messageComponentKey: 'usbKeyMessage' });
};

const LoginWithAndroid = ({ onMainAuthenticationRequired }) => {
    const t = useT('login');
    return FronteggApp_35f1a2b2.R.createElement(LoginWithWebAuthn, { onMainAuthenticationRequired: onMainAuthenticationRequired, title: t('androidLoginTitle'), message: t('androidLoginMessage'), buttonText: t('androidLoginButton'), transports: ['ble', 'nfc', 'cable'], defaultIcon: FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aC, null), loginStrategyId: LoginStrategyID.Android, authenticatorAttachment: 'cross-platform', iconComponentKey: 'androidCardIcon', titleComponentKey: 'androidTitle', messageComponentKey: 'androidMessage' });
};

const FromWrapper = (props) => {
    const { initialValues, validationSchema, onSubmit, children, enableReinitialize, validateOnBlur } = props;
    const [formError, setFormError] = FronteggApp_35f1a2b2.r.exports.useState(null);
    const formikProps = {
        onSubmit: (values, formikHelpers) => (0,FronteggApp_35f1a2b2.g)(void 0, void 0, void 0, function* () {
            setFormError(null);
            try {
                yield onSubmit(values, formikHelpers);
            }
            catch (e) {
                setFormError(e.message);
            }
        }),
        enableReinitialize,
        initialValues,
        validationSchema,
        validateOnBlur,
    };
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.al, Object.assign({}, formikProps), props => {
        const canSubmit = !props.isSubmitting && props.isValid && props.dirty;
        return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.am, { autoComplete: 'on' }, children === null || children === void 0 ? void 0 : children(Object.assign(Object.assign({}, props), { canSubmit, formError })));
    });
};

var SocialLoginsActions;
(function (SocialLoginsActions) {
    SocialLoginsActions["Login"] = "login";
    SocialLoginsActions["SignUp"] = "signUp";
    SocialLoginsActions["Activation"] = "activation";
})(SocialLoginsActions || (SocialLoginsActions = {}));
var SocialLoginDisplayMode;
(function (SocialLoginDisplayMode) {
    SocialLoginDisplayMode["STACK"] = "stack";
    SocialLoginDisplayMode["EVENTUALLY"] = "eventually";
})(SocialLoginDisplayMode || (SocialLoginDisplayMode = {}));
var SocialLoginLocation;
(function (SocialLoginLocation) {
    SocialLoginLocation["BOTTOM"] = "bottom";
    SocialLoginLocation["TOP"] = "top";
})(SocialLoginLocation || (SocialLoginLocation = {}));

const SocialLoginsContext = FronteggApp_35f1a2b2.r.exports.createContext({ action: SocialLoginsActions.Login });

const FRONTEGG_CODE_VERIFIER = 'FRONTEGG_CODE_VERIFIER';
const FRONTEGG_INVITATION_TOKEN = 'fe-invitation-token';
const FRONTEGG_ORIGIN_URL = 'FRONTEGG_ORIGIN_URL';

const SocialLogins = (props) => {
    const { firstLoad, socialLoginsConfigV2, error } = (0,formik_esm_baae0afb.H)(({ firstLoad, socialLoginsConfigV2, error }) => ({
        firstLoad,
        socialLoginsConfigV2,
        error,
    }));
    const { loadSocialLoginsConfigurationV2 } = (0,formik_esm_baae0afb.a7)();
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        if (firstLoad) {
            loadSocialLoginsConfigurationV2();
        }
    }, [loadSocialLoginsConfigurationV2, firstLoad]);
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        const url = new URL(window.location.href);
        const invitationToken = url.searchParams.get('invitationToken');
        localStorage.setItem(FRONTEGG_ORIGIN_URL, window.location.href);
        if (invitationToken) {
            localStorage.setItem(FRONTEGG_INVITATION_TOKEN, invitationToken);
        }
        return () => {
            localStorage.removeItem(FRONTEGG_ORIGIN_URL);
            localStorage.removeItem(FRONTEGG_INVITATION_TOKEN);
        };
    }, [window.location.search]);
    if (!(socialLoginsConfigV2 === null || socialLoginsConfigV2 === void 0 ? void 0 : socialLoginsConfigV2.some(({ active }) => active))) {
        return null;
    }
    let component = FronteggApp_35f1a2b2.R.createElement(SocialLoginsContext.Provider, { value: { action: props.action } }, props.children);
    if (error) {
        component = FronteggApp_35f1a2b2.R.createElement("div", { className: "fe-error-message" }, error);
    }
    if (firstLoad) {
        component = FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.O, null);
    }
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { textAlign: "center", mt: 4 }, component);
};

const socialLoginStyler = (0,formik_esm_baae0afb.j)();
const SocialLoginCustomComponent = CustomComponent;

const DividerWrapper = socialLoginStyler(formik_esm_baae0afb.B)(({ theme }) => (Object.assign({ width: '100%', display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', color: '#CDD3DF', '& > div:first-of-type': {
        height: '1px',
        backgroundColor: 'currentColor',
        flex: 1,
        marginRight: '1rem',
    }, '& > div:last-of-type': {
        height: '1px',
        backgroundColor: 'currentColor',
        flex: 1,
        marginLeft: '1rem',
    } }, theme.dividerStyle)));
const DividerText = socialLoginStyler(formik_esm_baae0afb.B)(({ theme }) => (Object.assign({ marginBottom: '0.5rem', marginTop: '0.5rem', fontStyle: 'normal', fontWeight: 800, lineHeight: '1rem', display: 'flex', alignItems: 'center', textAlign: 'center', color: '#99A0AF' }, theme.dividerTextStyle)));
const SocialLoginDivider = ({ children, testId }) => {
    return (FronteggApp_35f1a2b2.R.createElement(SocialLoginCustomComponent, { componentKey: 'divider', className: 'fe-social-login-divider', text: children },
        FronteggApp_35f1a2b2.R.createElement(DividerWrapper, { "data-test-id": testId },
            FronteggApp_35f1a2b2.R.createElement("div", null),
            FronteggApp_35f1a2b2.R.createElement(DividerText, null, children),
            FronteggApp_35f1a2b2.R.createElement("div", null))));
};

const createSocialLoginState = (state) => JSON.stringify(state);
const useRedirectUri = () => {
    const routes = (0,formik_esm_baae0afb.K)();
    const { basename = '/', urlStrategy } = (0,formik_esm_baae0afb.v)();
    const calculatedBasename = basename.endsWith('/') ? basename.substring(0, basename.length - 1) : '';
    return FronteggApp_35f1a2b2.r.exports.useMemo(() => `${window.location.origin}${urlStrategy === 'path' ? '' : '#'}${calculatedBasename}${routes.socialLoginCallbackUrl}`, [routes.socialLoginCallbackUrl, calculatedBasename, urlStrategy]);
};
const useRedirectUrl = (urlCreator, socialLoginType) => {
    const { action } = useSocialLoginContext();
    const { socialLoginsConfigV2 } = (0,formik_esm_baae0afb.H)(({ socialLoginsConfigV2 }) => ({ socialLoginsConfigV2 }));
    const config = FronteggApp_35f1a2b2.r.exports.useMemo(() => socialLoginsConfigV2 === null || socialLoginsConfigV2 === void 0 ? void 0 : socialLoginsConfigV2.find(({ type }) => type.toLowerCase() === socialLoginType.toLowerCase()), [socialLoginsConfigV2, socialLoginType]);
    const redirectUri = useRedirectUri();
    const redirectUrl = FronteggApp_35f1a2b2.r.exports.useMemo(() => {
        var _a;
        if (config) {
            if (config.customised) {
                return urlCreator(Object.assign(Object.assign({}, config), { redirectUrl: redirectUri, state: createSocialLoginState({ provider: socialLoginType, action }) }));
            }
            else {
                return (_a = `${config.authorizationUrl}${window.location.search}`) !== null && _a !== void 0 ? _a : undefined;
            }
        }
    }, [config, redirectUri, socialLoginType, action, urlCreator]);
    if (!(config === null || config === void 0 ? void 0 : config.active) || !redirectUrl) {
        return null;
    }
    return redirectUrl;
};
const useSocialLoginContext = () => {
    const context = FronteggApp_35f1a2b2.r.exports.useContext(SocialLoginsContext);
    if (!context) {
        throw new Error('Social Login compound component cannot be rendered outside SocialLogins component');
    }
    return context;
};
const useSocialLoginMainButton = (activeProviders) => {
    var _a, _b;
    const { socialLogins } = (0,formik_esm_baae0afb.F)();
    let mainSocialLoginProvider = ((_a = socialLogins === null || socialLogins === void 0 ? void 0 : socialLogins.socialLoginsLayout) === null || _a === void 0 ? void 0 : _a.mode) === SocialLoginDisplayMode.STACK && ((_b = socialLogins === null || socialLogins === void 0 ? void 0 : socialLogins.socialLoginsLayout) === null || _b === void 0 ? void 0 : _b.mainButton);
    const shouldUseDefaultMainButton = !mainSocialLoginProvider || !activeProviders.some(({ type }) => type === mainSocialLoginProvider);
    if (shouldUseDefaultMainButton) {
        mainSocialLoginProvider = activeProviders[0].type;
    }
    return mainSocialLoginProvider;
};
const useSocialLoginsIconsOnly = (provider, isMainButton) => {
    var _a;
    let { iconsOnly, socialLoginsLayout } = (0,formik_esm_baae0afb.F)();
    const { socialLoginsConfigV2 } = (0,formik_esm_baae0afb.H)(({ socialLoginsConfigV2 }) => ({ socialLoginsConfigV2 }));
    const isStackLayout = (socialLoginsLayout === null || socialLoginsLayout === void 0 ? void 0 : socialLoginsLayout.mode) === SocialLoginDisplayMode.STACK;
    const INACTIVE_PROVIDERS = ['gitlab', 'linkedin'];
    const count = (_a = (socialLoginsConfigV2 !== null && socialLoginsConfigV2 !== void 0 ? socialLoginsConfigV2 : [])) === null || _a === void 0 ? void 0 : _a.filter(({ active, type }) => active && !INACTIVE_PROVIDERS.includes(type)).length;
    if (iconsOnly && !isStackLayout)
        return true;
    if (isStackLayout && !isMainButton && count > 1)
        return true;
    // default is by count, if iconsOnly = false will force to render with icons also if count > 3
    return !isStackLayout && count > 3;
};
const useIsMoreThenOneProvider = () => {
    const { socialLoginsConfigV2 } = (0,formik_esm_baae0afb.H)(({ socialLoginsConfigV2 }) => ({ socialLoginsConfigV2 }));
    const activeProvidersLength = socialLoginsConfigV2 === null || socialLoginsConfigV2 === void 0 ? void 0 : socialLoginsConfigV2.filter(({ active }) => active).length;
    return !!activeProvidersLength && activeProvidersLength > 1;
};

const enhancedSocialButtonStyle = (style) => {
    if (!style || typeof style !== 'object') {
        return {};
    }
    const { base, hover, active, focus, icon } = style;
    return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, base), (icon ? { '& svg path': icon } : {})), (hover ? { '&:hover:not(.Mui-disabled)': hover } : {})), (focus ? { '&:focus:not(.Mui-disabled)': focus } : {})), (active ? { '&:active:not(.Mui-disabled)': active } : {}));
};
const SocialLoginButton = socialLoginStyler(formik_esm_baae0afb.l)(({ theme }) => ({
    '&.MuiButton-root': {
        margin: '0.5rem',
        flex: 'inherit',
        '&.MuiButton-containedSecondary': Object.assign({}, enhancedSocialButtonStyle(theme.buttonStyle)),
    },
}));
const StackedSocialLoginButton = socialLoginStyler(SocialLoginButton)(({ theme }) => {
    var _a;
    const isMoreThenOneProvider = useIsMoreThenOneProvider();
    return ({
        '&.MuiButton-root.MuiButton-containedSecondary': Object.assign({}, (((_a = theme === null || theme === void 0 ? void 0 : theme.socialLoginsLayout) === null || _a === void 0 ? void 0 : _a.mode) === SocialLoginDisplayMode.STACK && isMoreThenOneProvider ? {
            'svg': {
                width: '1.5rem',
                height: '1.5rem',
            },
            minWidth: 0,
            background: 'none',
            border: 'none',
            margin: 0,
            padding: '0.5rem',
            boxShadow: 'none',
            display: 'flex',
            alignItems: 'baseline',
            fontSize: 'inherit',
        } : {}))
    });
});
const MainSocialLoginButton = socialLoginStyler(SocialLoginButton)(({ theme }) => {
    var _a, _b;
    return ({
        '&.MuiButton-root': {
            margin: 0,
            flex: 'initial',
        },
        '&.MuiButton-root.MuiButton-containedSecondary': Object.assign({ width: '15rem' }, (((_a = theme === null || theme === void 0 ? void 0 : theme.socialLoginsLayout) === null || _a === void 0 ? void 0 : _a.mode) === SocialLoginDisplayMode.STACK ? enhancedSocialButtonStyle(((_b = theme === null || theme === void 0 ? void 0 : theme.socialLoginsLayout) === null || _b === void 0 ? void 0 : _b.mainButtonStyle) || {}) : {})),
    });
});

const FacebookIcon = (props) => {
    return (FronteggApp_35f1a2b2.R.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 1365 1365", fill: "white" }, props),
        FronteggApp_35f1a2b2.R.createElement("g", { xmlns: "http://www.w3.org/2000/svg", transform: "matrix(1.3333333,0,0,-1.3333333,0,1365.3333)", id: "g10" },
            FronteggApp_35f1a2b2.R.createElement("g", { transform: "scale(0.1)", id: "g12" },
                FronteggApp_35f1a2b2.R.createElement("path", { fill: "#4267B2", d: "m 10240,5120 c 0,2827.7 -2292.3,5120 -5120,5120 C 2292.3,10240 0,7947.7 0,5120 0,2564.46 1872.31,446.301 4320,62.1992 V 3640 H 3020 v 1480 h 1300 v 1128 c 0,1283.2 764.38,1992 1933.9,1992 560.17,0 1146.1,-100 1146.1,-100 V 6880 H 6754.38 C 6118.35,6880 5920,6485.33 5920,6080.43 V 5120 H 7340 L 7113,3640 H 5920 V 62.1992 C 8367.69,446.301 10240,2564.46 10240,5120" })))));
};
const GoogleIcon = (props) => {
    return (FronteggApp_35f1a2b2.R.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 48 48", fill: "none" }, props),
        FronteggApp_35f1a2b2.R.createElement("path", { fill: "#FFC107", d: "M43.611,20.083H42V20H24v8h11.303c-1.649,4.657-6.08,8-11.303,8c-6.627,0-12-5.373-12-12c0-6.627,5.373-12,12-12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C12.955,4,4,12.955,4,24c0,11.045,8.955,20,20,20c11.045,0,20-8.955,20-20C44,22.659,43.862,21.35,43.611,20.083z" }),
        FronteggApp_35f1a2b2.R.createElement("path", { fill: "#FF3D00", d: "M6.306,14.691l6.571,4.819C14.655,15.108,18.961,12,24,12c3.059,0,5.842,1.154,7.961,3.039l5.657-5.657C34.046,6.053,29.268,4,24,4C16.318,4,9.656,8.337,6.306,14.691z" }),
        FronteggApp_35f1a2b2.R.createElement("path", { fill: "#4CAF50", d: "M24,44c5.166,0,9.86-1.977,13.409-5.192l-6.19-5.238C29.211,35.091,26.715,36,24,36c-5.202,0-9.619-3.317-11.283-7.946l-6.522,5.025C9.505,39.556,16.227,44,24,44z" }),
        FronteggApp_35f1a2b2.R.createElement("path", { fill: "#1976D2", d: "M43.611,20.083H42V20H24v8h11.303c-0.792,2.237-2.231,4.166-4.087,5.571c0.001-0.001,0.002-0.001,0.003-0.002l6.19,5.238C36.971,39.205,44,34,44,24C44,22.659,43.862,21.35,43.611,20.083z" })));
};
const GithubIcon = (props) => {
    return (FronteggApp_35f1a2b2.R.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 17 16", fill: "none" }, props),
        FronteggApp_35f1a2b2.R.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.50001 -0.0010302C6.55044 -0.00301169 4.66389 0.689346 3.17843 1.95197C1.69296 3.2146 0.705689 4.96496 0.39354 6.88938C0.0813902 8.81379 0.464767 10.7865 1.47496 12.4539C2.48515 14.1213 4.05613 15.3745 5.90637 15.9889C6.3143 16.0644 6.46539 15.8076 6.46539 15.591C6.46539 15.3745 6.46539 14.8809 6.46539 14.196C4.18399 14.6996 3.70051 13.0981 3.70051 13.0981C3.54849 12.6018 3.22554 12.1753 2.78896 11.8945C2.04864 11.3908 2.84939 11.3908 2.84939 11.3908C3.10891 11.4275 3.35668 11.5227 3.57394 11.6693C3.7912 11.8159 3.97227 12.01 4.10341 12.2369C4.21484 12.439 4.36507 12.617 4.54548 12.7609C4.7259 12.9047 4.93294 13.0115 5.15474 13.0752C5.37653 13.1388 5.6087 13.158 5.83794 13.1317C6.06717 13.1054 6.28896 13.0341 6.49056 12.9219C6.52217 12.5076 6.70078 12.1182 6.99418 11.824C5.17108 11.6175 3.25732 10.9124 3.25732 7.76982C3.24481 6.95546 3.54594 6.16747 4.09837 5.569C3.85183 4.861 3.8806 4.08618 4.17895 3.3984C4.17895 3.3984 4.86891 3.17681 6.43516 4.23945C7.78012 3.87017 9.19974 3.87017 10.5447 4.23945C12.111 3.17681 12.7959 3.3984 12.7959 3.3984C13.0974 4.0852 13.1279 4.8606 12.8815 5.569C13.4339 6.16747 13.7351 6.95546 13.7225 7.76982C13.7225 10.9225 11.8038 11.6124 9.97561 11.7988C10.1716 11.9958 10.323 12.2327 10.4195 12.4934C10.5159 12.7541 10.5552 13.0324 10.5346 13.3096C10.5346 14.4075 10.5346 15.2939 10.5346 15.5608C10.5346 15.8277 10.6807 16.0342 11.0987 15.9587C12.9431 15.3385 14.5072 14.0833 15.5121 12.417C16.517 10.7507 16.8973 8.78157 16.5852 6.86089C16.273 4.94021 15.2887 3.19286 13.8079 1.93051C12.327 0.668166 10.4459 -0.027091 8.50001 -0.03125V-0.0010302Z", fill: "#231E1B" })));
};
const MicrosoftIcon = (props) => {
    return (FronteggApp_35f1a2b2.R.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", fill: "none" }, props),
        FronteggApp_35f1a2b2.R.createElement("path", { d: "M7.60384 7.60256H0.00128174V0H7.60384V7.60256Z", fill: "#F1511B" }),
        FronteggApp_35f1a2b2.R.createElement("path", { d: "M15.9987 7.60256H8.39552V0H15.9981V7.60256H15.9987Z", fill: "#80CC28" }),
        FronteggApp_35f1a2b2.R.createElement("path", { d: "M7.60384 16.001H0.00128174V8.39844H7.60384V16.001Z", fill: "#00ADEF" }),
        FronteggApp_35f1a2b2.R.createElement("path", { d: "M15.9987 16.001H8.39552V8.39844H15.9981V16.001H15.9987Z", fill: "#FBBC09" })));
};

const createGoogleUrl = ({ clientId, redirectUrl, state }) => {
    const searchParams = new URLSearchParams({
        redirect_uri: redirectUrl,
        response_type: 'code',
        include_granted_scopes: 'true',
        scope: 'https://www.googleapis.com/auth/userinfo.profile https://www.googleapis.com/auth/userinfo.email',
        state,
    });
    if (clientId) {
        searchParams.set('client_id', clientId);
    }
    const url = new URL('https://accounts.google.com/o/oauth2/v2/auth');
    url.search = searchParams.toString();
    return url.toString();
};
const SocialButton$3 = socialLoginStyler(StackedSocialLoginButton)(({ theme }) => {
    var _a, _b;
    const isMoreThenOneProvider = useIsMoreThenOneProvider();
    return ({
        '&.MuiButton-root.MuiButton-containedSecondary': Object.assign({}, enhancedSocialButtonStyle(((_a = theme === null || theme === void 0 ? void 0 : theme.socialLoginsLayout) === null || _a === void 0 ? void 0 : _a.mode) === SocialLoginDisplayMode.STACK && isMoreThenOneProvider ? (_b = theme === null || theme === void 0 ? void 0 : theme.socialLoginsLayout) === null || _b === void 0 ? void 0 : _b.stackedButtonsStyle : theme.googleButtonStyle)),
    });
});
const GoogleLoginButton = ({ isMainButton = false }) => {
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const redirectUrl = useRedirectUrl(createGoogleUrl, umd.SocialLoginProviders.Google);
    const iconsOnly = useSocialLoginsIconsOnly(umd.SocialLoginProviders.Google, isMainButton);
    const handleClick = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        onRedirectTo(redirectUrl, { refresh: true });
    }, [redirectUrl, onRedirectTo]);
    const icon = FronteggApp_35f1a2b2.R.createElement(SocialLoginCustomComponent, { componentKey: "googleIcon", className: "fe-social-login-google-icon" },
        FronteggApp_35f1a2b2.R.createElement(GoogleIcon, null));
    if (redirectUrl) {
        return isMainButton ?
            FronteggApp_35f1a2b2.R.createElement(MainSocialLoginButton, { onClick: handleClick, color: "secondary", startIcon: icon, children: iconsOnly ? undefined : 'Continue with Google', "data-test-id": "google-main-btn" }) :
            FronteggApp_35f1a2b2.R.createElement(SocialButton$3, { onClick: handleClick, color: "secondary", startIcon: icon, children: iconsOnly ? undefined : 'Google', "data-test-id": "google-btn" });
    }
    return null;
};
var GoogleLoginButton$1 = GoogleLoginButton;

const createGithubUrl = ({ clientId, redirectUrl, state }) => {
    const searchParams = new URLSearchParams({
        redirect_uri: redirectUrl,
        scope: 'read:user user:email',
        state,
    });
    if (clientId) {
        searchParams.set('client_id', clientId);
    }
    const url = new URL('https://github.com/login/oauth/authorize');
    url.search = searchParams.toString();
    return url.toString();
};
const SocialButton$2 = socialLoginStyler(StackedSocialLoginButton)(({ theme }) => {
    var _a, _b;
    const isMoreThenOneProvider = useIsMoreThenOneProvider();
    return ({
        '&.MuiButton-root.MuiButton-containedSecondary': Object.assign({}, enhancedSocialButtonStyle(((_a = theme === null || theme === void 0 ? void 0 : theme.socialLoginsLayout) === null || _a === void 0 ? void 0 : _a.mode) === SocialLoginDisplayMode.STACK && isMoreThenOneProvider ? (_b = theme === null || theme === void 0 ? void 0 : theme.socialLoginsLayout) === null || _b === void 0 ? void 0 : _b.stackedButtonsStyle : theme.githubButtonStyle)),
    });
});
const GithubLoginButton = ({ isMainButton = false }) => {
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const redirectUrl = useRedirectUrl(createGithubUrl, umd.SocialLoginProviders.Github);
    const iconsOnly = useSocialLoginsIconsOnly(umd.SocialLoginProviders.Github, isMainButton);
    const handleClick = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        onRedirectTo(redirectUrl, { refresh: true });
    }, [redirectUrl, onRedirectTo]);
    const icon = FronteggApp_35f1a2b2.R.createElement(SocialLoginCustomComponent, { componentKey: "githubIcon", className: "fe-social-login-github-icon" },
        FronteggApp_35f1a2b2.R.createElement(GithubIcon, null));
    if (redirectUrl) {
        return isMainButton ?
            FronteggApp_35f1a2b2.R.createElement(MainSocialLoginButton, { onClick: handleClick, color: "secondary", startIcon: icon, children: iconsOnly ? undefined : 'Continue with Github', "data-test-id": "github-main-btn" }) :
            FronteggApp_35f1a2b2.R.createElement(SocialButton$2, { onClick: handleClick, color: "secondary", startIcon: icon, children: iconsOnly ? undefined : 'Github', "data-test-id": "github-btn" });
    }
    return null;
};
var GithubLoginButton$1 = GithubLoginButton;

const codeVerifier = `${esm_browser_v4()}${esm_browser_v4()}`;
const createMicrosoftUrl = ({ clientId, redirectUrl, state }) => {
    localStorage.setItem(FRONTEGG_CODE_VERIFIER, codeVerifier);
    const searchParams = new URLSearchParams({
        response_type: 'code',
        redirect_uri: redirectUrl,
        response_mode: 'query',
        scope: 'openid profile email',
        code_challenge: codeVerifier,
        state,
        code_challenge_type: 'S256',
    });
    if (clientId) {
        searchParams.set('client_id', clientId);
    }
    const url = new URL('https://login.microsoftonline.com/common/oauth2/v2.0/authorize');
    url.search = searchParams.toString();
    return url.toString();
};
const SocialButton$1 = socialLoginStyler(StackedSocialLoginButton)(({ theme }) => {
    var _a, _b;
    const isMoreThenOneProvider = useIsMoreThenOneProvider();
    return ({
        '&.MuiButton-root.MuiButton-containedSecondary': Object.assign({}, enhancedSocialButtonStyle(((_a = theme === null || theme === void 0 ? void 0 : theme.socialLoginsLayout) === null || _a === void 0 ? void 0 : _a.mode) === SocialLoginDisplayMode.STACK && isMoreThenOneProvider ? (_b = theme === null || theme === void 0 ? void 0 : theme.socialLoginsLayout) === null || _b === void 0 ? void 0 : _b.stackedButtonsStyle : theme.microsoftButtonStyle)),
    });
});
const MicrosoftLoginButton = ({ isMainButton = false }) => {
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const redirectUrl = useRedirectUrl(createMicrosoftUrl, umd.SocialLoginProviders.Microsoft);
    const iconsOnly = useSocialLoginsIconsOnly(umd.SocialLoginProviders.Microsoft, isMainButton);
    const handleClick = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        onRedirectTo(redirectUrl, { refresh: true });
    }, [redirectUrl, onRedirectTo]);
    const icon = FronteggApp_35f1a2b2.R.createElement(SocialLoginCustomComponent, { componentKey: "microsoftIcon", className: "fe-social-login-microsoft-icon" },
        FronteggApp_35f1a2b2.R.createElement(MicrosoftIcon, null));
    if (redirectUrl) {
        return isMainButton ?
            FronteggApp_35f1a2b2.R.createElement(MainSocialLoginButton, { onClick: handleClick, color: "secondary", startIcon: icon, children: iconsOnly ? undefined : 'Continue with Microsoft', "data-test-id": "microsoft-main-btn" }) :
            FronteggApp_35f1a2b2.R.createElement(SocialButton$1, { onClick: handleClick, color: "secondary", startIcon: icon, children: iconsOnly ? undefined : 'Microsoft', "data-test-id": "microsoft-btn" });
    }
    return null;
};
var MicrosoftLoginButton$1 = MicrosoftLoginButton;

const createFacebookUrl = ({ clientId, redirectUrl, state }) => {
    const searchParams = new URLSearchParams({
        scope: 'email',
        redirect_uri: redirectUrl,
        response_type: 'code',
        state,
    });
    if (clientId) {
        searchParams.set('client_id', clientId);
    }
    const url = new URL('https://www.facebook.com/v10.0/dialog/oauth');
    url.search = searchParams.toString();
    return url.toString();
};
const SocialButton = socialLoginStyler(StackedSocialLoginButton)(({ theme }) => {
    var _a, _b;
    const isMoreThenOneProvider = useIsMoreThenOneProvider();
    return ({
        '&.MuiButton-root.MuiButton-containedSecondary': Object.assign({}, enhancedSocialButtonStyle(((_a = theme === null || theme === void 0 ? void 0 : theme.socialLoginsLayout) === null || _a === void 0 ? void 0 : _a.mode) === SocialLoginDisplayMode.STACK && isMoreThenOneProvider ? (_b = theme === null || theme === void 0 ? void 0 : theme.socialLoginsLayout) === null || _b === void 0 ? void 0 : _b.stackedButtonsStyle : theme.facebookButtonStyle)),
    });
});
const FacebookLoginButton = ({ isMainButton = false }) => {
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const redirectUrl = useRedirectUrl(createFacebookUrl, umd.SocialLoginProviders.Facebook);
    const iconsOnly = useSocialLoginsIconsOnly(umd.SocialLoginProviders.Facebook, isMainButton);
    const handleClick = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        onRedirectTo(redirectUrl, { refresh: true });
    }, [redirectUrl, onRedirectTo]);
    const icon = FronteggApp_35f1a2b2.R.createElement(SocialLoginCustomComponent, { componentKey: "facebookIcon", className: "fe-social-login-facebook-icon" },
        FronteggApp_35f1a2b2.R.createElement(FacebookIcon, null));
    if (redirectUrl) {
        return isMainButton ?
            FronteggApp_35f1a2b2.R.createElement(MainSocialLoginButton, { onClick: handleClick, color: "secondary", startIcon: icon, children: iconsOnly ? undefined : 'Continue with Facebook', "data-test-id": "facebook-main-btn" }) :
            FronteggApp_35f1a2b2.R.createElement(SocialButton, { onClick: handleClick, color: "secondary", startIcon: icon, children: iconsOnly ? undefined : 'Facebook', "data-test-id": "facebook-btn" });
    }
    return null;
};
var FacebookLoginButton$1 = FacebookLoginButton;

const mapActionToStyle = {
    [SocialLoginsActions.Login]: 'login',
    [SocialLoginsActions.SignUp]: 'signup',
    [SocialLoginsActions.Activation]: 'activateAccount',
};
const SocialLoginsContainer = socialLoginStyler((_a) => {
    var props = (0,FronteggApp_35f1a2b2.f)(_a, ["action", "theme"]);
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, Object.assign({}, props));
})(({ theme, action }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    return (Object.assign({ display: 'flex', flexGrow: 1, flexDirection: 'row', marginLeft: '-0.5rem', marginRight: '-0.5rem', justifyContent: 'center', marginTop: '0.5rem' }, ((0,formik_esm_baae0afb.n)((_c = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.loginBox) === null || _a === void 0 ? void 0 : _a.socialLogins) === null || _b === void 0 ? void 0 : _b.conatinerStyle) !== null && _c !== void 0 ? _c : {}, (_g = (_f = (_e = (_d = theme === null || theme === void 0 ? void 0 : theme.loginBox) === null || _d === void 0 ? void 0 : _d[mapActionToStyle[action]]) === null || _e === void 0 ? void 0 : _e.socialLogins) === null || _f === void 0 ? void 0 : _f.containerStyle) !== null && _g !== void 0 ? _g : {}))));
});
const SocialLoginsContainerForStackedMode = socialLoginStyler((_a) => {
    var props = (0,FronteggApp_35f1a2b2.f)(_a, ["action", "theme"]);
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, Object.assign({}, props));
})(({ theme, action }) => {
    var _a, _b, _c, _d, _e, _f, _g;
    return (Object.assign({ display: 'flex', flexGrow: 1, flexDirection: 'row', justifyContent: 'space-between', marginTop: '1.5rem', marginBottom: '1rem' }, ((0,formik_esm_baae0afb.n)((_c = (_b = (_a = theme === null || theme === void 0 ? void 0 : theme.loginBox) === null || _a === void 0 ? void 0 : _a.socialLogins) === null || _b === void 0 ? void 0 : _b.conatinerStyle) !== null && _c !== void 0 ? _c : {}, (_g = (_f = (_e = (_d = theme === null || theme === void 0 ? void 0 : theme.loginBox) === null || _d === void 0 ? void 0 : _d[mapActionToStyle[action]]) === null || _e === void 0 ? void 0 : _e.socialLogins) === null || _f === void 0 ? void 0 : _f.containerStyle) !== null && _g !== void 0 ? _g : {}))));
});
const SocialLoginsStackedContainer = socialLoginStyler(formik_esm_baae0afb.B)(({ theme }) => {
    var _a, _b;
    return (Object.assign({ display: 'flex', alignItems: 'center', margin: 0 }, (((_a = theme === null || theme === void 0 ? void 0 : theme.socialLoginsLayout) === null || _a === void 0 ? void 0 : _a.mode) === SocialLoginDisplayMode.STACK ? (_b = theme === null || theme === void 0 ? void 0 : theme.socialLoginsLayout) === null || _b === void 0 ? void 0 : _b.stackedContainerStyle : {})));
});
const mapSocialProviderToComponent = [
    { socialProvider: umd.SocialLoginProviders.Google, button: (isMainButton, index) => FronteggApp_35f1a2b2.R.createElement(GoogleLoginButton$1, { isMainButton: isMainButton, key: index }) },
    { socialProvider: umd.SocialLoginProviders.Microsoft, button: (isMainButton, index) => FronteggApp_35f1a2b2.R.createElement(MicrosoftLoginButton$1, { isMainButton: isMainButton, key: index }) },
    { socialProvider: umd.SocialLoginProviders.Facebook, button: (isMainButton, index) => FronteggApp_35f1a2b2.R.createElement(FacebookLoginButton$1, { isMainButton: isMainButton, key: index }) },
    { socialProvider: umd.SocialLoginProviders.Github, button: (isMainButton, index) => FronteggApp_35f1a2b2.R.createElement(GithubLoginButton$1, { isMainButton: isMainButton, key: index }) },
];
const SocialLoginsStackModeButtons = ({ testId, dividerText, withSocialDivider = true, action }) => {
    const { socialLoginsConfigV2 } = (0,formik_esm_baae0afb.H)(({ socialLoginsConfigV2 }) => ({ socialLoginsConfigV2 }));
    const activeProviders = socialLoginsConfigV2 === null || socialLoginsConfigV2 === void 0 ? void 0 : socialLoginsConfigV2.filter(({ active }) => active);
    if (!(activeProviders === null || activeProviders === void 0 ? void 0 : activeProviders.length)) {
        return null;
    }
    const mainSocialLoginProvider = useSocialLoginMainButton(activeProviders);
    const mainSocialLoginButton = mapSocialProviderToComponent.find((item) => item.socialProvider === mainSocialLoginProvider);
    const stackedSocialLoginsButtons = mapSocialProviderToComponent.filter(item => item.socialProvider !== mainSocialLoginProvider);
    return (FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        FronteggApp_35f1a2b2.R.createElement(SocialLoginTopDivider, { withSocialDivider: withSocialDivider, dividerText: dividerText, socialLoginLocation: SocialLoginLocation.BOTTOM }),
        FronteggApp_35f1a2b2.R.createElement(SocialLoginsContainerForStackedMode, { "data-test-id": testId, action: action }, mainSocialLoginButton === null || mainSocialLoginButton === void 0 ? void 0 :
            mainSocialLoginButton.button(true),
            FronteggApp_35f1a2b2.R.createElement(SocialLoginsStackedContainer, null, stackedSocialLoginsButtons.map((item, index) => item.button(false, index)))),
        FronteggApp_35f1a2b2.R.createElement(SocialLoginBottomDivider, { withSocialDivider: withSocialDivider, dividerText: dividerText, socialLoginLocation: SocialLoginLocation.TOP })));
};
const SocialLoginsButtonsContainer = ({ testId, dividerText, withSocialDivider = true, action }) => {
    var _a;
    const { socialLogins } = (0,formik_esm_baae0afb.F)();
    const isStackDisplayMode = ((_a = socialLogins === null || socialLogins === void 0 ? void 0 : socialLogins.socialLoginsLayout) === null || _a === void 0 ? void 0 : _a.mode) === SocialLoginDisplayMode.STACK;
    const { socialLoginsConfigV2 } = (0,formik_esm_baae0afb.H)(({ socialLoginsConfigV2 }) => ({ socialLoginsConfigV2 }));
    const activeProviders = socialLoginsConfigV2 === null || socialLoginsConfigV2 === void 0 ? void 0 : socialLoginsConfigV2.filter(({ active }) => active);
    if (!(activeProviders === null || activeProviders === void 0 ? void 0 : activeProviders.length)) {
        return null;
    }
    if (isStackDisplayMode && activeProviders.length > 1) {
        return (FronteggApp_35f1a2b2.R.createElement(SocialLoginsStackModeButtons, { dividerText: dividerText, withSocialDivider: withSocialDivider, action: action, testId: testId }));
    }
    return (FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        FronteggApp_35f1a2b2.R.createElement(SocialLoginTopDivider, { withSocialDivider: withSocialDivider, dividerText: dividerText, socialLoginLocation: SocialLoginLocation.BOTTOM }),
        FronteggApp_35f1a2b2.R.createElement(SocialLoginsContainer, { "data-test-id": testId, action: action },
            FronteggApp_35f1a2b2.R.createElement(GoogleLoginButton$1, null),
            FronteggApp_35f1a2b2.R.createElement(GithubLoginButton$1, null),
            FronteggApp_35f1a2b2.R.createElement(MicrosoftLoginButton$1, null),
            FronteggApp_35f1a2b2.R.createElement(FacebookLoginButton$1, null)),
        FronteggApp_35f1a2b2.R.createElement(SocialLoginBottomDivider, { withSocialDivider: withSocialDivider, dividerText: dividerText, socialLoginLocation: SocialLoginLocation.TOP })));
};
const SocialLoginsWithWrapper = ({ testId, action, dividerText, withSocialDivider = true }) => {
    return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.E, { themeOptionKey: "socialLogins" },
        FronteggApp_35f1a2b2.R.createElement(SocialLogins, { action: action },
            FronteggApp_35f1a2b2.R.createElement(SocialLoginsButtonsContainer, { dividerText: dividerText, withSocialDivider: withSocialDivider, action: action, testId: testId }))));
};
const SocialLoginTopDivider = ({ withSocialDivider, dividerText, socialLoginLocation }) => {
    var _a, _b;
    const { socialLogins } = (0,formik_esm_baae0afb.F)();
    const socialLoginsLayout = (_b = (_a = socialLogins === null || socialLogins === void 0 ? void 0 : socialLogins.socialLoginsLayout) === null || _a === void 0 ? void 0 : _a.placement) !== null && _b !== void 0 ? _b : SocialLoginLocation.BOTTOM;
    return withSocialDivider && socialLoginsLayout === socialLoginLocation ? FronteggApp_35f1a2b2.R.createElement(SocialLoginDivider, { children: dividerText, testId: 'top-social-divider' }) : null;
};
const SocialLoginBottomDivider = ({ withSocialDivider, dividerText }) => {
    var _a, _b;
    const { socialLogins } = (0,formik_esm_baae0afb.F)();
    const socialLoginsLayout = (_b = (_a = socialLogins === null || socialLogins === void 0 ? void 0 : socialLogins.socialLoginsLayout) === null || _a === void 0 ? void 0 : _a.placement) !== null && _b !== void 0 ? _b : SocialLoginLocation.BOTTOM;
    return withSocialDivider && socialLoginsLayout === SocialLoginLocation.TOP ? FronteggApp_35f1a2b2.R.createElement(SocialLoginDivider, { children: dividerText, testId: 'bottom-social-divider' }) : null;
};
const SocialLoginsLogin = ({ dividerText, withSocialDivider = true }) => {
    return FronteggApp_35f1a2b2.R.createElement(SocialLoginsWithWrapper, { action: SocialLoginsActions.Login, withSocialDivider: withSocialDivider, dividerText: dividerText });
};
const SocialLoginsActivation = ({ dividerText, withSocialDivider = true }) => {
    return FronteggApp_35f1a2b2.R.createElement(SocialLoginsWithWrapper, { action: SocialLoginsActions.Activation, withSocialDivider: withSocialDivider, dividerText: dividerText });
};
const SocialLoginsSignUp = ({ testId, dividerText, withSocialDivider = true }) => {
    return FronteggApp_35f1a2b2.R.createElement(SocialLoginsWithWrapper, { action: SocialLoginsActions.SignUp, withSocialDivider: withSocialDivider, dividerText: dividerText, testId: testId });
};

const PageWrapper = ({ children }) => FronteggApp_35f1a2b2.R.createElement(RootElement$1, null,
    FronteggApp_35f1a2b2.R.createElement(PageElement$1, null,
        FronteggApp_35f1a2b2.R.createElement(BoxElement$1, null, children)));
var PageWrapper$1 = PageWrapper;

const SocialLoginsSuccess$1 = () => {
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const socialLoginsState = (0,formik_esm_baae0afb.H)();
    const { resetSocialLoginsState, setSocialLoginError, loginViaSocialLogin } = (0,formik_esm_baae0afb.a7)();
    const routes = (0,formik_esm_baae0afb.K)();
    const t = useT('socialLogins');
    const redirectUri = useRedirectUri();
    const { events } = (0,formik_esm_baae0afb.v)();
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const devCreds = params.get('customised') === 'false';
        const error = t('failedInvalidCallbackUrl');
        const state = params.get('state');
        const code = params.get('code');
        if (!state || !code) {
            setSocialLoginError({ error });
            return;
        }
        let provider;
        if (devCreds) {
            provider = params.get('provider');
        }
        else {
            let parsedState;
            try {
                parsedState = JSON.parse(state);
            }
            catch (e) {
                setSocialLoginError({ error });
                return;
            }
            provider = parsedState.provider;
        }
        if (!provider) {
            setSocialLoginError({ error });
            return;
        }
        const payload = {
            code, provider, state,
        };
        if (!devCreds) {
            payload.redirectUri = redirectUri;
        }
        const codeVerifier = localStorage.getItem(FRONTEGG_CODE_VERIFIER);
        const invitationToken = localStorage.getItem(FRONTEGG_INVITATION_TOKEN);
        localStorage.removeItem(FRONTEGG_CODE_VERIFIER);
        localStorage.removeItem(FRONTEGG_INVITATION_TOKEN);
        if (invitationToken) {
            payload.invitationToken = invitationToken;
        }
        if (codeVerifier) {
            payload.codeVerifier = codeVerifier;
        }
        const fronteggOriginUrl = localStorage.getItem(FRONTEGG_ORIGIN_URL);
        const loginViaSocialLoginPayload = Object.assign(Object.assign({}, payload), { events });
        if (fronteggOriginUrl) {
            loginViaSocialLoginPayload['url'] = new URL(fronteggOriginUrl);
        }
        loginViaSocialLogin(loginViaSocialLoginPayload);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (!socialLoginsState.error || socialLoginsState.firstLoad || socialLoginsState.loading) {
        return FronteggApp_35f1a2b2.R.createElement(PageLoader, null);
    }
    return (FronteggApp_35f1a2b2.R.createElement(PageWrapper$1, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.a3, { title: t('invalidTitle'), description: socialLoginsState.error, testId: 'social-login-failure' },
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { sx: { mt: 8 }, onClick: () => {
                    resetSocialLoginsState();
                    onRedirectTo(routes.loginUrl);
                } }, t('failedBackToLogin')))));
};

const SocialLoginsSuccess = wrapPageContext(SocialLoginsSuccess$1, 'login');

const validateEmail = (invalidMessage, requiredMessage) => create().email(invalidMessage).required(requiredMessage);
const validatePassword = (minLength, invalidMinLengthMessage, requiredMessage) => create().min(minLength, invalidMinLengthMessage).required(requiredMessage);

const StyledContainer$3 = loginStyler(formik_esm_baae0afb.B)(({ theme }) => {
    var _a;
    return (Object.assign({}, (_a = theme.disclaimer) === null || _a === void 0 ? void 0 : _a.disclaimerContainerStyle));
});
const StyledDisclaimerText$1 = loginStyler(formik_esm_baae0afb.T)(({ theme }) => {
    var _a;
    return (Object.assign({ marginTop: '2rem', textAlign: 'center' }, (_a = theme.disclaimer) === null || _a === void 0 ? void 0 : _a.textStyle));
});
const StyledDisclaimerTermsLink$1 = loginStyler(formik_esm_baae0afb.L)(({ theme }) => {
    var _a, _b;
    return (Object.assign({}, (_b = (_a = theme.disclaimer) === null || _a === void 0 ? void 0 : _a.terms) === null || _b === void 0 ? void 0 : _b.linkStyle));
});
const StyledDisclaimerPrivacyLink$1 = loginStyler(formik_esm_baae0afb.L)(({ theme }) => {
    var _a, _b;
    return (Object.assign({}, (_b = (_a = theme.disclaimer) === null || _a === void 0 ? void 0 : _a.privacy) === null || _b === void 0 ? void 0 : _b.linkStyle));
});
const DisclaimerInfo = () => {
    const { disclaimer } = (0,formik_esm_baae0afb.F)();
    const t = useContextT('loginBox.login');
    const showTerms = FronteggApp_35f1a2b2.r.exports.useMemo(() => { var _a; return (_a = disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.terms) === null || _a === void 0 ? void 0 : _a.enabled; }, [disclaimer]);
    const showPrivacy = FronteggApp_35f1a2b2.r.exports.useMemo(() => { var _a; return (_a = disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.privacy) === null || _a === void 0 ? void 0 : _a.enabled; }, [disclaimer]);
    if (!showTerms && !showPrivacy) {
        return null;
    }
    return (FronteggApp_35f1a2b2.R.createElement(StyledContainer$3, null,
        FronteggApp_35f1a2b2.R.createElement(StyledDisclaimerText$1, { variant: 'body2', "data-test-id": 'login-disclaimer-text' },
            t('disclaimerText'),
            ' ',
            showTerms && (FronteggApp_35f1a2b2.R.createElement(StyledDisclaimerTermsLink$1, { href: t('termsLink'), target: '_blank', "data-test-id": 'login-terms-link' }, t('termsLinkText'))),
            showTerms && showPrivacy && ` ${t('termsAndPrivacyConjunctionText')} `,
            showPrivacy && (FronteggApp_35f1a2b2.R.createElement(StyledDisclaimerPrivacyLink$1, { href: t('privacyLink'), target: '_blank', "data-test-id": 'login-privacy-link' }, t('privacyLinkText'))))));
};

const inputStyleKeys = [
    'padding',
    'padding-left',
    'padding-right',
    'padding-top',
    'padding-bottom',
    'margin',
    'margin-left',
    'margin-right',
    'margin-top',
    'margin-bottom',
    'height',
    'background',
    'box-sizing',
    'color',
    'outline',
    'cursor',
    'display',
    'font',
    'letter-spacing',
    'line-height',
    'text-align',
    'text-transform',
    'word-break',
    'word-spacing',
    'writing-mode',
];
const RenderSlottedInput = FronteggApp_35f1a2b2.r.exports.forwardRef((props, ref) => {
    const hiddenInputRef = FronteggApp_35f1a2b2.r.exports.useRef();
    const slottedInputRef = FronteggApp_35f1a2b2.r.exports.useRef();
    const { submitForm } = (0,formik_esm_baae0afb.u)();
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        const interval = setInterval(() => {
            if (hiddenInputRef.current && slottedInputRef.current) {
                const input = slottedInputRef.current;
                const styleLoader = window.getComputedStyle(hiddenInputRef.current);
                for (let i = 0; i < inputStyleKeys.length; i++) {
                    const key = inputStyleKeys[i];
                    const value = styleLoader[key];
                    input.style.setProperty(key, value);
                }
                input.style.setProperty('width', '100%');
                if (input.getAttribute('name') === 'password') {
                    input.style.setProperty('min-width', 'calc(100% + 0.5rem)');
                }
                else {
                    input.style.setProperty('min-width', '100%');
                }
                input.style.setProperty('border', 'none');
                input.style.setProperty('outline', 'none');
                input.style.setProperty('flex', '1');
                input.style.setProperty('opacity', '1');
            }
        }, 50);
        return () => {
            clearInterval(interval);
        };
    }, []);
    const handleSubmit = FronteggApp_35f1a2b2.r.exports.useCallback((e) => {
        e.preventDefault();
        if (e.keyCode === 13 || e.code === 'Enter') {
            e.target.blur();
            submitForm();
        }
    }, [submitForm]);
    return (FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.I, { inputRef: hiddenInputRef, tabIndex: -1, style: { position: 'fixed', top: -10000, left: -10000, zIndex: -1 } }),
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.R, { name: `slotted-input-${props.name}`, containerStyle: { width: 'calc(100% - 32px)', display: 'flex', flexDirection: 'row' } },
            FronteggApp_35f1a2b2.R.createElement("input", Object.assign({ style: { opacity: 0 }, "data-test-id": `input-${props.name}`, ref: (r) => {
                    slottedInputRef.current = r;
                    ref === null || ref === void 0 ? void 0 : ref(r);
                } }, props, { onKeyUp: handleSubmit })))));
});
const EmailField$3 = ({ shouldBackToLoginIfEmailChanged }) => {
    const t = useT('login');
    const { iframeRendering } = (0,formik_esm_baae0afb.v)();
    const { submitCount } = (0,formik_esm_baae0afb.u)();
    const [fieldProps, { error }] = (0,formik_esm_baae0afb.at)('email');
    const { resetForm } = (0,formik_esm_baae0afb.u)();
    const { setLoginState } = (0,formik_esm_baae0afb.U)();
    const backToPreLogin = FronteggApp_35f1a2b2.r.exports.useCallback(() => setLoginState({ step: redux_store/* LoginStep.preLogin */.Fh.preLogin }), [setLoginState]);
    const onFocus = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        if (shouldBackToLoginIfEmailChanged) {
            backToPreLogin();
            resetForm({
                values: {
                    email: fieldProps.value,
                    password: '',
                },
            });
        }
    }, [backToPreLogin, fieldProps, resetForm, shouldBackToLoginIfEmailChanged]);
    return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.I, Object.assign({ label: t('emailInputLabel') }, fieldProps, { inputComponent: iframeRendering ? undefined : RenderSlottedInput, 
        // onMouseDown={shouldBackToLoginIfEmailChanged ? onFocus : undefined}
        // disabled={shouldBackToLoginIfEmailChanged || submitCount > 0}
        autoFocus: true, onFocus: onFocus, onChange: fieldProps.onChange, error: !!error && (fieldProps.value !== '' || submitCount > 0), placeholder: t('emailInputPlaceholder'), errorMessage: error, autoComplete: 'email', "data-test-id": 'email-box' })));
};
const InputButton = loginStyler(formik_esm_baae0afb.L)(({ theme }) => ({
    '&.MuiLink-root': {
        color: theme.typography.label.color,
    },
}));
const PasswordField$3 = ({ shouldDisplayPassword, inputRef }) => {
    const t = useT('login');
    const { values: { email }, } = (0,formik_esm_baae0afb.u)();
    const [fieldProps, { error, touched }] = (0,formik_esm_baae0afb.at)('password');
    const { setForgotPasswordState } = (0,formik_esm_baae0afb.a0)();
    const { resetLoginState } = (0,formik_esm_baae0afb.U)();
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const routes = (0,formik_esm_baae0afb.K)();
    const { iframeRendering } = (0,formik_esm_baae0afb.v)();
    const onForgetPasswordClick = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        setForgotPasswordState({ email });
        resetLoginState();
        onRedirectTo(routes.forgetPasswordUrl);
    }, [setForgotPasswordState, resetLoginState, onRedirectTo, routes, email]);
    // TODO: changed testId from forgotPassBtn to forgot-password-btn
    const labelButton = (FronteggApp_35f1a2b2.R.createElement(InputButton, { onClick: onForgetPasswordClick, "data-test-id": 'forgot-password-btn' }, t('forgotPassword')));
    return (FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.au, Object.assign({ label: t('passwordInputLabel') }, fieldProps, { inputRef: inputRef, inputComponent: iframeRendering ? undefined : RenderSlottedInput, disabled: false, error: !!error && touched, errorMessage: error, button: labelButton, type: 'password', name: 'password', tabIndex: shouldDisplayPassword ? undefined : -1, autoComplete: 'current-password', placeholder: t('passwordInputPlaceholder'), "data-test-id": 'password-box' }))));
};
const LoginSignupSwitch = loginStyler(formik_esm_baae0afb.T)(({ theme }) => (Object.assign(Object.assign({ marginBottom: '0.75rem', textAlign: 'center', color: 'inherit', fontWeight: 'normal' }, theme.signupMessageStyle), { position: 'unset !important' })));
const SignUpMessage = () => {
    const t = useT('login');
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const routes = (0,formik_esm_baae0afb.K)();
    const { policy, loading } = (0,formik_esm_baae0afb._)(({ publicPolicy }) => publicPolicy);
    const redirectToSignUp = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        onRedirectTo(routes.signUpUrl + window.location.search);
    }, [onRedirectTo, routes.signUpUrl]);
    if (loading || !(policy === null || policy === void 0 ? void 0 : policy.allowSignups)) {
        return null;
    }
    const props = {
        goToSignupMessage: t('signUpMessage'),
        goToSignupButtonText: t('signUpLink'),
        goToSignup: redirectToSignUp,
    };
    return (FronteggApp_35f1a2b2.R.createElement(SignupMessageComponent, Object.assign({ componentKey: 'signupMessage' }, props),
        FronteggApp_35f1a2b2.R.createElement(LoginSignupSwitch, { variant: 'subtitle1', position: 'unset' },
            props.goToSignupMessage,
            ' ',
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { onClick: props.goToSignup, "data-test-id": 'redirect-to-signup' }, props.goToSignupButtonText))));
};
const LoginWithPasswordForm = () => {
    var _a, _b;
    const t = useT('login');
    const { isSSOAuth } = (0,formik_esm_baae0afb.J)(({ isSSOAuth }) => ({ isSSOAuth }));
    const { loading, step, error } = (0,formik_esm_baae0afb.a4)();
    const { login, preLogin, passwordlessPreLogin, setLoginState } = (0,formik_esm_baae0afb.U)();
    const [submitedEmailValue, setSubmitedEmailValue] = FronteggApp_35f1a2b2.r.exports.useState('');
    const { publicPolicy: { policy, error: policyError } } = (0,formik_esm_baae0afb._)();
    const { invitationToken } = useVerifyInviteToken();
    const [policyLocalError, setPolicyLocalError] = FronteggApp_35f1a2b2.r.exports.useState(false);
    const passwordRef = FronteggApp_35f1a2b2.r.exports.useRef(null);
    const { token: recaptchaToken, loadNewToken } = useRecaptchaContext();
    const shouldDisplayPassword = FronteggApp_35f1a2b2.r.exports.useMemo(() => (!isSSOAuth || step === redux_store/* LoginStep.loginWithPassword */.Fh.loginWithPassword) &&
        (policy === null || policy === void 0 ? void 0 : policy.authStrategy) === redux_store/* AuthStrategyEnum.EmailAndPassword */.lw.EmailAndPassword, [policy === null || policy === void 0 ? void 0 : policy.authStrategy, isSSOAuth, step]);
    const shouldDisplayOnlySocialLogins = FronteggApp_35f1a2b2.r.exports.useMemo(() => !isSSOAuth && (policy === null || policy === void 0 ? void 0 : policy.authStrategy) === redux_store/* AuthStrategyEnum.NoLocalAuthentication */.lw.NoLocalAuthentication, [policy === null || policy === void 0 ? void 0 : policy.authStrategy, isSSOAuth, step]);
    const shouldBackToLoginIfEmailChanged = isSSOAuth && shouldDisplayPassword;
    const validationSchema = {
        email: validateEmail(t('emailMustBeValid'), t('emailIsRequired')),
        password: shouldDisplayPassword ? validatePassword(6, t('passwordMustBeCharacters', { length: 6 }), t('passwordIsRequired')) : undefined,
    };
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        var _a, _b;
        if (isSSOAuth && shouldDisplayPassword) {
            (_b = (_a = passwordRef.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 ? void 0 : _b.call(_a);
        }
    }, [shouldDisplayPassword, isSSOAuth]);
    const initialValues = FronteggApp_35f1a2b2.r.exports.useMemo(() => ({ email: '', password: '' }), []);
    const formikProps = {
        onSubmit: (values) => new Promise((resolve) => {
            const { email, password } = values;
            setSubmitedEmailValue(email);
            if (!policy || !policy.authStrategy) {
                setPolicyLocalError(true);
            }
            else {
                localStorage.setItem(`${email}-preferred-login-method`, LoginStrategyID.Main);
                if (shouldDisplayPassword) {
                    login({ email, password, recaptchaToken, invitationToken });
                }
                else if (isSSOAuth) {
                    preLogin({ email, recaptchaToken, invitationToken });
                }
                else {
                    passwordlessPreLogin({ email, recaptchaToken, type: policy === null || policy === void 0 ? void 0 : policy.authStrategy, invitationToken });
                }
                loadNewToken();
                resolve();
            }
        }),
        initialValues,
        validationSchema: (0,formik_esm_baae0afb.ab)(validationSchema),
        enableReinitialize: true,
        validateOnBlur: false,
    };
    const isError = FronteggApp_35f1a2b2.r.exports.useMemo(() => error || policyError || policyLocalError, [policyError, error, policyLocalError]);
    const { socialLogins, disclaimer } = (0,formik_esm_baae0afb.a8)();
    const socialLoginsLayout = (_b = (_a = socialLogins === null || socialLogins === void 0 ? void 0 : socialLogins.socialLoginsLayout) === null || _a === void 0 ? void 0 : _a.placement) !== null && _b !== void 0 ? _b : SocialLoginLocation.BOTTOM;
    return FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        socialLoginsLayout === SocialLoginLocation.TOP && FronteggApp_35f1a2b2.R.createElement(SocialLoginsLogin, { dividerText: t('signInWithSocialLogin'), withSocialDivider: !shouldDisplayOnlySocialLogins }),
        !shouldDisplayOnlySocialLogins && (FronteggApp_35f1a2b2.R.createElement(FromWrapper, Object.assign({}, formikProps), ({ isValid, values, touched }) => {
            if (error && submitedEmailValue !== (values === null || values === void 0 ? void 0 : values.email)) {
                setLoginState({ error: null });
            }
            return FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
                FronteggApp_35f1a2b2.R.createElement(EmailField$3, { shouldBackToLoginIfEmailChanged: shouldBackToLoginIfEmailChanged }),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aD, { in: shouldDisplayPassword, appear: false },
                    FronteggApp_35f1a2b2.R.createElement(PasswordField$3, { shouldDisplayPassword: shouldDisplayPassword, inputRef: passwordRef })),
                isError && FronteggApp_35f1a2b2.R.createElement(LoginErrorMessage, null, policyError ? t('missingPolicyErrorMessage') : error),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.l, { sx: { mt: 4 }, disabled: loading || !isValid || !touched, loading: loading, fullWidth: true, color: "primary", "data-test-id": "submit-btn", type: "submit" }, shouldDisplayPassword ? t('login') : t('continue')));
        })),
        socialLoginsLayout === SocialLoginLocation.BOTTOM && FronteggApp_35f1a2b2.R.createElement(SocialLoginsLogin, { dividerText: t('signInWithSocialLogin'), withSocialDivider: !shouldDisplayOnlySocialLogins }),
        disclaimer && (!disclaimer.placement || disclaimer.placement === 'box') && FronteggApp_35f1a2b2.R.createElement(DisclaimerInfo, null));
};

const LoginWithPassword = () => {
    const t = useT('login');
    const isThumbnailMode = useShowThumbnail(LoginStrategyID.Main);
    const { signupMessagePlacement } = (0,formik_esm_baae0afb.a8)();
    return FronteggApp_35f1a2b2.R.createElement(BoxElement$1, null,
        FronteggApp_35f1a2b2.R.createElement(LoginPageTitle, { isThumbnailMode: isThumbnailMode, componentKey: "title", title: t('title') }),
        (!signupMessagePlacement || signupMessagePlacement === 'box') && FronteggApp_35f1a2b2.R.createElement(SignUpMessage, null),
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aD, { in: !isThumbnailMode, appear: false },
            FronteggApp_35f1a2b2.R.createElement(LoginWithPasswordForm, null)),
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aD, { in: isThumbnailMode, appear: false },
            FronteggApp_35f1a2b2.R.createElement(LoginIconContainer, { isThumbnailMode: isThumbnailMode, iconSize: 64 },
                FronteggApp_35f1a2b2.R.createElement(LoginIconComponent, { componentKey: 'loginCardIcon' },
                    FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aE, null)))));
};

const LoginWithQuickSmsForm = ({ onMainAuthenticationRequired }) => {
    const t = useT('login');
    const { error, loading } = (0,formik_esm_baae0afb.a4)();
    const { quickSmsPasswordlessPreLogin } = (0,formik_esm_baae0afb.U)();
    const { token: recaptchaToken, loadNewToken } = useRecaptchaContext();
    const email = localStorage.getItem('email');
    const usedStrategy = localStorage.getItem(`${email}-${LoginStrategyID.Sms}`);
    const handleSubmit = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        if (email && usedStrategy) {
            quickSmsPasswordlessPreLogin({ email, recaptchaToken });
            loadNewToken();
        }
        else {
            onMainAuthenticationRequired === null || onMainAuthenticationRequired === void 0 ? void 0 : onMainAuthenticationRequired();
        }
    }, [quickSmsPasswordlessPreLogin, loadNewToken, onMainAuthenticationRequired, recaptchaToken]);
    return FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        error && FronteggApp_35f1a2b2.R.createElement(LoginErrorMessage, null, error),
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.l, { sx: { mt: 4 }, fullWidth: true, loading: loading, color: "primary", type: "submit", onClick: handleSubmit }, t('smsLoginButton')));
};

const LoginWithQuickSms = ({ onMainAuthenticationRequired }) => {
    const t = useT('login');
    const isThumbnailMode = useShowThumbnail(LoginStrategyID.Sms);
    return FronteggApp_35f1a2b2.R.createElement(BoxElement$1, null,
        FronteggApp_35f1a2b2.R.createElement(LoginPageTitle, { isThumbnailMode: isThumbnailMode, componentKey: 'smsPreviewTitle', title: t('smsLoginTitle') }),
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aD, { in: !isThumbnailMode },
            FronteggApp_35f1a2b2.R.createElement(LoginPageMessage, { componentKey: 'smsPreviewMessage', message: t('smsLoginMessage'), textAlignCenter: true })),
        FronteggApp_35f1a2b2.R.createElement(LoginIconContainer, { isThumbnailMode: isThumbnailMode },
            FronteggApp_35f1a2b2.R.createElement(LoginIconComponent, { componentKey: 'smsCardIcon' },
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aJ, null))),
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aD, { in: !isThumbnailMode, appear: false, timeout: 300 },
            FronteggApp_35f1a2b2.R.createElement(LoginWithQuickSmsForm, { onMainAuthenticationRequired: onMainAuthenticationRequired })));
};

const useLoginStrategiesConfig = () => {
    const [isLoading, setIsLoading] = FronteggApp_35f1a2b2.r.exports.useState(true);
    const [isPlatformAuthenticationAvailable, setIsPlatformAuthenticationAvailable] = FronteggApp_35f1a2b2.r.exports.useState(true);
    const { policy, loading } = (0,formik_esm_baae0afb.aK)();
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        (() => (0,FronteggApp_35f1a2b2.g)(void 0, void 0, void 0, function* () {
            if (window.PublicKeyCredential) {
                const available = yield PublicKeyCredential.isUserVerifyingPlatformAuthenticatorAvailable();
                setIsPlatformAuthenticationAvailable(available);
            }
            setIsLoading(false);
        }))();
    }, [setIsLoading, setIsPlatformAuthenticationAvailable]);
    const isPlatformAuthenticationAllowed = !!(policy === null || policy === void 0 ? void 0 : policy.secondaryAuthStrategies.some(({ isActive, strategy }) => isActive && strategy === umd.SecondaryAuthStrategy.WebAuthnPlatform));
    const isCrossPlatformAuthenticationAllowed = !!(policy === null || policy === void 0 ? void 0 : policy.secondaryAuthStrategies.some(({ isActive, strategy }) => isActive && strategy === umd.SecondaryAuthStrategy.WebAuthnCrossPlatform));
    const isSmsAuthenticationAllowed = !!(policy === null || policy === void 0 ? void 0 : policy.secondaryAuthStrategies.some(({ isActive, strategy }) => isActive && strategy === umd.SecondaryAuthStrategy.SmsCode));
    return {
        isSmsAuthenticationAllowed,
        isLoading: isLoading || loading,
        isCrossPlatformAuthenticationAllowed: !!window.PublicKeyCredential && isCrossPlatformAuthenticationAllowed,
        isPlatformAuthenticationAvailable: !!window.PublicKeyCredential && isPlatformAuthenticationAvailable && isPlatformAuthenticationAllowed,
    };
};
const openCarouselAnimationDuration = 1; // seconds
const closeCarouselAnimationDuration = 0.5; // seconds
const useLoginCarousel = () => {
    var _a, _b, _c, _d;
    const [isCarouselOpen, setIsCarouselOpen] = FronteggApp_35f1a2b2.r.exports.useState(true);
    const { setLoginState } = (0,formik_esm_baae0afb.U)();
    const { isPlatformAuthenticationAvailable, isSmsAuthenticationAllowed, isCrossPlatformAuthenticationAllowed, isLoading } = useLoginStrategiesConfig();
    const handleMainAuthenticationRequired = FronteggApp_35f1a2b2.r.exports.useCallback((loginStrategyId) => {
        setIsCarouselOpen(false);
        setLoginState({ quickLoginToRegister: loginStrategyId });
        localStorage.setItem('register-quick-login', loginStrategyId);
    }, [setIsCarouselOpen, setLoginState]);
    const handleAnimationClose = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        setLoginState({ flow: redux_store/* LoginFlow.RegisterQuickLogin */.iP.RegisterQuickLogin });
    }, [setLoginState]);
    const email = localStorage.getItem('email');
    const { layout, breakpoints } = (0,formik_esm_baae0afb.F)();
    const twoSideElementsActive = !!((_b = (_a = layout === null || layout === void 0 ? void 0 : layout.splitModeElements) === null || _a === void 0 ? void 0 : _a.activeElements) === null || _b === void 0 ? void 0 : _b.element1) && !!((_d = (_c = layout === null || layout === void 0 ? void 0 : layout.splitModeElements) === null || _c === void 0 ? void 0 : _c.activeElements) === null || _d === void 0 ? void 0 : _d.element2);
    const shouldDisplayQuickLogins = (0,formik_esm_baae0afb.ao)(breakpoints.up('sm')) && !twoSideElementsActive;
    const items = FronteggApp_35f1a2b2.r.exports.useMemo(() => ([
        {
            id: LoginStrategyID.Internal,
            component: FronteggApp_35f1a2b2.R.createElement(LoginWithTouchID, { onMainAuthenticationRequired: () => handleMainAuthenticationRequired(LoginStrategyID.Internal) }),
            show: isPlatformAuthenticationAvailable && shouldDisplayQuickLogins,
        },
        {
            id: LoginStrategyID.UsbKey,
            component: FronteggApp_35f1a2b2.R.createElement(LoginWithUsbKey, { onMainAuthenticationRequired: () => handleMainAuthenticationRequired(LoginStrategyID.UsbKey) }),
            show: isCrossPlatformAuthenticationAllowed && shouldDisplayQuickLogins,
        },
        {
            id: LoginStrategyID.Main,
            component: FronteggApp_35f1a2b2.R.createElement(LoginWithPassword, null),
            show: true,
        },
        {
            id: LoginStrategyID.Sms,
            component: FronteggApp_35f1a2b2.R.createElement(LoginWithQuickSms, { onMainAuthenticationRequired: () => handleMainAuthenticationRequired(LoginStrategyID.Sms) }),
            show: isSmsAuthenticationAllowed && shouldDisplayQuickLogins,
        },
        {
            id: LoginStrategyID.Android,
            component: FronteggApp_35f1a2b2.R.createElement(LoginWithAndroid, { onMainAuthenticationRequired: () => handleMainAuthenticationRequired(LoginStrategyID.Android) }),
            show: isCrossPlatformAuthenticationAllowed && shouldDisplayQuickLogins,
        },
    ].filter(({ show }) => show)), [isPlatformAuthenticationAvailable, isCrossPlatformAuthenticationAllowed, isSmsAuthenticationAllowed, shouldDisplayQuickLogins]);
    const initialIndex = FronteggApp_35f1a2b2.r.exports.useMemo(() => {
        var _a;
        const lastLoginStrategy = (_a = localStorage.getItem(`${email}-preferred-login-method`)) !== null && _a !== void 0 ? _a : LoginStrategyID.Main;
        let initialIndex = items.findIndex(({ id }) => id === lastLoginStrategy);
        if (initialIndex === -1) {
            initialIndex = items.findIndex(({ id }) => id === LoginStrategyID.Main);
        }
        return initialIndex;
    }, [items, handleMainAuthenticationRequired]);
    const [activeIndex, setActiveIndex] = FronteggApp_35f1a2b2.r.exports.useState();
    return {
        items,
        isLoading,
        activeIndex: activeIndex !== null && activeIndex !== void 0 ? activeIndex : initialIndex,
        component: isLoading ? null : FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.an, { items: items.map((item) => item.component), onActiveItemChange: (index) => {
                setActiveIndex(index);
                setLoginState({ error: null });
            }, openCarouselAnimationDuration: openCarouselAnimationDuration, closeCarouselAnimationDuration: closeCarouselAnimationDuration, onCloseCarouselAnimationFinish: handleAnimationClose, open: isCarouselOpen, activeIndex: activeIndex !== null && activeIndex !== void 0 ? activeIndex : initialIndex })
    };
};

const PageTitle = loginStyler(formik_esm_baae0afb.T)(({ theme }) => (Object.assign({ fontWeight: 'bold', fontSize: '1.8rem', textAlign: 'center' }, theme.pageTitleStyle)));
const PageSubtitle = loginStyler(formik_esm_baae0afb.T)(({ theme }) => (Object.assign({ fontSize: '1rem', textAlign: 'center' }, theme.pageSubtitleStyle)));
const LoginCarousel = () => {
    const { component: carousel, activeIndex, items, isLoading } = useLoginCarousel();
    const t = useT('login');
    const theme = (0,formik_esm_baae0afb.F)();
    const name = localStorage.getItem('name');
    const showTitles = (0,formik_esm_baae0afb.ao)(theme.breakpoints.up('sm')) && items.length > 1;
    const { pageTitle, pageSubtitle } = FronteggApp_35f1a2b2.r.exports.useMemo(() => {
        let pageTitle = t('loginWelcomeTitle');
        let pageSubtitle = t('loginWelcomeSubtitleSubtitle');
        if (name) {
            pageTitle += `, ${name}`;
            pageSubtitle = t('loginWelcomeKnownUserSubtitle');
        }
        return { pageTitle, pageSubtitle };
    }, [t]);
    if (isLoading) {
        return null;
    }
    return (FronteggApp_35f1a2b2.R.createElement(LoginCarouselContext.Provider, { value: { items, activeIndex } },
        showTitles && FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { display: 'flex', flexDirection: 'column', rowGap: 2 },
            FronteggApp_35f1a2b2.R.createElement(PageTitle, null, pageTitle),
            FronteggApp_35f1a2b2.R.createElement(PageSubtitle, null, pageSubtitle)),
        carousel));
};

const ResendContainer = loginStyler(ResendOTCComponent)(({ theme }) => (Object.assign({ marginTop: '1rem', textAlign: 'center' }, theme.resendOTCStyle)));
const ResendOTCMessage = loginStyler(formik_esm_baae0afb.T)(({ theme }) => (Object.assign({ color: 'inherit' }, theme.resendOTCMessageStyle)));
const OTCField$1 = () => {
    const [, , { setValue }] = (0,formik_esm_baae0afb.at)('token');
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { sx: { mb: 4 } },
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aF, { autoFocus: true, length: 6, onChangeOTP: setValue, "data-test-id": 'otc-box' }));
};
const ResendCode = ({ onResendCode }) => {
    const t = useT('login');
    const { resetLoginState } = (0,formik_esm_baae0afb.U)();
    const { email } = (0,formik_esm_baae0afb.a4)();
    const { values: { recaptchaToken } } = (0,formik_esm_baae0afb.u)();
    const resendOTC = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        if (email) {
            onResendCode({ recaptchaToken, email });
        }
        else {
            resetLoginState();
        }
    }, [onResendCode, email, recaptchaToken]);
    const props = {
        haventReceiveOTCMessage: t('otcHaventReceivedCode'),
        resendOTCMessage: t('otcResend'),
        resendOTC,
    };
    return FronteggApp_35f1a2b2.R.createElement(ResendContainer, Object.assign({ componentKey: 'resendOTC' }, props),
        FronteggApp_35f1a2b2.R.createElement(ResendOTCMessage, { variant: 'subtitle1' },
            props.haventReceiveOTCMessage,
            " ",
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { onClick: props.resendOTC, "data-test-id": 'resend-otc-btn' }, props.resendOTCMessage)));
};
const LoginWithOTC = ({ header, onResendCode, onSubmit, loading, error }) => {
    const t = useT('login');
    const { setLoginState } = (0,formik_esm_baae0afb.U)();
    const recaptchaRef = FronteggApp_35f1a2b2.R.createRef();
    const { token: recaptchaToken, loadNewToken } = useRecaptchaContext();
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        setLoginState({ error: null });
    }, [setLoginState]);
    const handleResendCode = FronteggApp_35f1a2b2.r.exports.useCallback(({ recaptchaToken, email }) => {
        onResendCode({ recaptchaToken, email });
        loadNewToken();
    }, [onResendCode, recaptchaRef]);
    return FronteggApp_35f1a2b2.R.createElement(BoxElement$1, null,
        header,
        FronteggApp_35f1a2b2.R.createElement(FromWrapper, { initialValues: { token: '', recaptchaToken }, onSubmit: (values) => {
                onSubmit(Object.assign({}, values));
                loadNewToken();
            }, validationSchema: (0,formik_esm_baae0afb.ab)({
                token: (0,formik_esm_baae0afb.ap)(6, t('otcCodeIsRequired'), t('otcInvalidLengthCode'))
            }), enableReinitialize: true }, ({ dirty, isValid }) => FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
            FronteggApp_35f1a2b2.R.createElement(OTCField$1, null),
            error && FronteggApp_35f1a2b2.R.createElement(LoginErrorMessage, null, error),
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.l, { disabled: loading || !isValid || !dirty, 
                // TODO the data-test-id was changed from `passwordless-prelogin-success-resend-btn` value to the `passwordless-continue-btn`
                className: 'fe-primary-btn', fullWidth: true, color: 'primary', loading: loading, "data-test-id": 'passwordless-continue-btn' }, t('otcContinue')),
            FronteggApp_35f1a2b2.R.createElement(ResendCode, { onResendCode: handleResendCode }))));
};

const LoginWithSmsOTC = () => {
    const t = useT('login');
    const { phoneNumber } = (0,formik_esm_baae0afb.a4)();
    const { passwordlessPreLogin, passwordlessPostLogin } = (0,formik_esm_baae0afb.U)();
    const { invitationToken } = useVerifyInviteToken();
    const { loading, error } = (0,formik_esm_baae0afb.a4)();
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const routes = (0,formik_esm_baae0afb.K)();
    const handleSubmit = FronteggApp_35f1a2b2.r.exports.useCallback((values) => {
        passwordlessPostLogin(Object.assign(Object.assign({}, values), { invitationToken, type: redux_store/* AuthStrategyEnum.SmsCode */.lw.SmsCode }));
    }, [passwordlessPostLogin]);
    const handleResend = FronteggApp_35f1a2b2.r.exports.useCallback((values) => {
        passwordlessPreLogin(Object.assign(Object.assign({}, values), { type: redux_store/* AuthStrategyEnum.SmsCode */.lw.SmsCode }));
    }, [passwordlessPreLogin]);
    const goToChangePhoneNumber = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        onRedirectTo(routes.resetPhoneNumberUrl);
    }, [onRedirectTo, routes.resetPhoneNumberUrl]);
    return FronteggApp_35f1a2b2.R.createElement(LoginWithOTC, { loading: loading, error: error, onSubmit: handleSubmit, onResendCode: handleResend, header: FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
            FronteggApp_35f1a2b2.R.createElement(LoginPageTitle, { componentKey: 'otcTitle', title: t('smsOtcTitle') }),
            FronteggApp_35f1a2b2.R.createElement(LoginPageMessage, { componentKey: 'otcMessage', message: FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
                    t('smsOtcMessage', { phoneNumber }),
                    " ",
                    FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { onClick: goToChangePhoneNumber }, t('smsOtcChangePhoneMessage'))) })) });
};

const ReCaptcha = ({ action, fieldName = 'recaptchaToken', recaptchaRef }) => {
    const { setFieldValue } = (0,formik_esm_baae0afb.u)();
    const recaptcha = useRecaptcha({ action, recaptchaRef });
    const token = recaptcha === null || recaptcha === void 0 ? void 0 : recaptcha.token;
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        token && setFieldValue(fieldName, token, true);
    }, [fieldName, token, setFieldValue]);
    return FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null, recaptcha === null || recaptcha === void 0 ? void 0 : recaptcha.component);
};

const ONE_DAY_IN_SECONDS$1 = 60 * 60 * 24;
const CodeField$1 = () => {
    const [, , { setValue }] = (0,formik_esm_baae0afb.at)('code');
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { mt: 4 },
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aF, { autoFocus: true, length: 6, onChangeOTP: setValue, "data-test-id": 'mfa-code-input' }));
};
const RememberDeviceField = ({ mfaDeviceExpiration }) => {
    const t = useT('login');
    const [rememberDeviceFieldProps] = (0,formik_esm_baae0afb.at)('rememberDevice');
    return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aG, { sx: { pl: 0, pb: 0, pt: 4 }, control: FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.o, Object.assign({}, rememberDeviceFieldProps, { size: "small" })), label: (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.T, { variant: "body1" }, t('mfaRememberThisDevice', { count: Math.floor(mfaDeviceExpiration / ONE_DAY_IN_SECONDS$1) }))) }));
};
const LoginWithTwoFactor = () => {
    const t = useT('login');
    const { loading, error, mfaToken } = (0,formik_esm_baae0afb.a4)();
    const { loginWithMfa, setLoginState } = (0,formik_esm_baae0afb.U)();
    const { allowRememberMfaDevice, mfaDeviceExpiration } = (0,formik_esm_baae0afb.a4)();
    const initialValues = FronteggApp_35f1a2b2.r.exports.useMemo(() => ({ code: '', rememberDevice: false }), []);
    const validationSchema = FronteggApp_35f1a2b2.r.exports.useMemo(() => (0,formik_esm_baae0afb.ab)({
        code: (0,formik_esm_baae0afb.ax)(6, t('mfaCodeIsRequired'), t('mfaCodeLengthAtLeast6')),
    }), [t]);
    const formikProps = {
        onSubmit: ({ code, rememberDevice }) => new Promise((resolve, reject) => {
            const callback = (0,formik_esm_baae0afb.aH)(resolve, reject);
            loginWithMfa({ mfaToken: mfaToken || '', value: code, rememberDevice, callback });
        }),
        initialValues,
        validationSchema,
    };
    return FronteggApp_35f1a2b2.R.createElement(BoxElement$1, null,
        FronteggApp_35f1a2b2.R.createElement(LoginPageTitle, { componentKey: 'title', title: t('mfaTitle') }),
        FronteggApp_35f1a2b2.R.createElement(FromWrapper, Object.assign({}, formikProps), ({ isValid, dirty }) => {
            return FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
                FronteggApp_35f1a2b2.R.createElement(CodeField$1, null),
                error && FronteggApp_35f1a2b2.R.createElement(LoginErrorMessage, null, error),
                allowRememberMfaDevice && mfaDeviceExpiration && FronteggApp_35f1a2b2.R.createElement(RememberDeviceField, { mfaDeviceExpiration: mfaDeviceExpiration }),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { height: '1px', mb: 4 }),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.l, { className: 'fe-primary-btn', disabled: loading || !isValid || !dirty, fullWidth: true, color: 'primary', loading: loading, "data-test-id": 'submit-btn' }, t('login')),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.T, { variant: 'body1Bold', mt: 4 }, t('disableMultiFactorTitle')),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.T, { variant: 'body1', mt: 1 },
                    FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { "data-test-id": "disableMfaClickHereButton", onClick: () => {
                            setLoginState({ step: redux_store/* LoginStep.recoverTwoFactor */.Fh.recoverTwoFactor });
                        } }, t('disabledMultiFactorClickHereButton')),
                    " ",
                    t('disableMultiFactorMessage')),
                FronteggApp_35f1a2b2.R.createElement(ReCaptcha, { action: 'login' }));
        }));
};

const PasswordlessPreLoginSuccessContainer = (0,formik_esm_baae0afb.f)(formik_esm_baae0afb.B)({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '.MuiTypography-root': {
        marginBottom: '1.5rem',
    },
});
const ResendLinkButton = (0,formik_esm_baae0afb.f)(formik_esm_baae0afb.l)({
    width: '22rem',
    marginBottom: '2rem',
    marginTop: '2rem'
});
const MagicLinkPreLoginSuccess = () => {
    const t = useT('login');
    const { email, loading } = (0,formik_esm_baae0afb.a4)();
    const { passwordlessPreLogin, resetLoginState } = (0,formik_esm_baae0afb.U)();
    const { invitationToken } = useVerifyInviteToken();
    const { token: recaptchaToken, loadNewToken } = useRecaptchaContext();
    return FronteggApp_35f1a2b2.R.createElement(BoxElement$1, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.a3, { title: t('magicLinkTitle'), description: t(`magicLinkText`, { email }), testId: 'magic-link-success', iconKey: 'magicLinkSent' },
            FronteggApp_35f1a2b2.R.createElement(FromWrapper, { initialValues: { email, recaptchaToken }, onSubmit: (values) => {
                    passwordlessPreLogin(Object.assign(Object.assign({}, values), { invitationToken, type: redux_store/* AuthStrategyEnum.MagicLink */.lw.MagicLink }));
                    loadNewToken();
                }, enableReinitialize: true }, () => FronteggApp_35f1a2b2.R.createElement(PasswordlessPreLoginSuccessContainer, null,
                FronteggApp_35f1a2b2.R.createElement(ResendLinkButton, { fullWidth: true, color: 'primary', loading: loading, "data-test-id": 'passwordless-prelogin-success-resend-btn' }, t(`magicLinkResend`)),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { onClick: resetLoginState }, t(`backToLogin`))))));
};

const CodeField = () => {
    const t = useT('login');
    const [fieldProps, { error, touched }] = (0,formik_esm_baae0afb.at)('code');
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.I, Object.assign({ label: t('enterRecoveryCode') }, fieldProps, { error: !!error && touched, errorMessage: error, autoComplete: 'one-time-code', "data-test-id": 'mfa-code-input' }));
};
const RecoverTwoFactor = () => {
    const t = useT('login');
    const { recoverMfa } = (0,formik_esm_baae0afb.U)();
    const { loading, error, email } = (0,formik_esm_baae0afb.a4)();
    const initialValues = FronteggApp_35f1a2b2.r.exports.useMemo(() => ({ code: '' }), []);
    const validationSchema = FronteggApp_35f1a2b2.r.exports.useMemo(() => (0,formik_esm_baae0afb.ab)({
        code: (0,formik_esm_baae0afb.ax)(8, t('twoFactorCodeIsRequired'), t('twoFactorCodeLengthAtLeast8')),
    }), [t]);
    const formikProps = {
        onSubmit: ({ code }) => new Promise((resolve) => {
            recoverMfa({ email: email !== null && email !== void 0 ? email : '', recoveryCode: code });
            resolve();
        }),
        initialValues,
        validationSchema,
    };
    return FronteggApp_35f1a2b2.R.createElement(BoxElement$1, null,
        FronteggApp_35f1a2b2.R.createElement(LoginPageTitle, { componentKey: 'recoverMfaTitle', title: t('recoverMfaTitle') }),
        FronteggApp_35f1a2b2.R.createElement(FromWrapper, Object.assign({}, formikProps), ({ isValid, dirty }) => {
            return FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
                FronteggApp_35f1a2b2.R.createElement(CodeField, null),
                error && FronteggApp_35f1a2b2.R.createElement(LoginErrorMessage, null, error),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.l, { sx: { mt: 4 }, "data-test-id": 'diableMfaBtn', className: 'fe-primary-btn', disabled: loading || !isValid || !dirty, fullWidth: true, color: 'primary', loading: loading }, t('disabledMultiFactorButton')),
                FronteggApp_35f1a2b2.R.createElement(ReCaptcha, { action: 'login' }));
        }));
};

const LargeLoader = ({ height }) => {
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.G, { container: true, justifyContent: 'center', alignItems: 'center', height: height !== null && height !== void 0 ? height : 100 },
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.G, { item: true },
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.O, { "data-test-id": "page-loader" })));
};

const RedirectToSSO = () => {
    const t = useT('login');
    return (FronteggApp_35f1a2b2.R.createElement(BoxElement$1, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.T, { sx: { marginBottom: 4, width: '100%', textAlign: 'center' }, variant: 'body1Bold' }, t('ssoRedirectToMessage')),
        FronteggApp_35f1a2b2.R.createElement(LargeLoader, { height: 40 })));
};

const LoginWithEmailOTC = () => {
    const t = useT('login');
    const { email } = (0,formik_esm_baae0afb.a4)();
    const { passwordlessPreLogin, passwordlessPostLogin } = (0,formik_esm_baae0afb.U)();
    const { invitationToken } = useVerifyInviteToken();
    const { loading, error } = (0,formik_esm_baae0afb.a4)();
    const { events } = (0,formik_esm_baae0afb.v)();
    const handleSubmit = FronteggApp_35f1a2b2.r.exports.useCallback((values) => {
        passwordlessPostLogin(Object.assign(Object.assign({}, values), { invitationToken, type: redux_store/* AuthStrategyEnum.Code */.lw.Code, events }));
    }, [passwordlessPostLogin]);
    const handleResend = FronteggApp_35f1a2b2.r.exports.useCallback((values) => {
        passwordlessPreLogin(Object.assign(Object.assign({}, values), { type: redux_store/* AuthStrategyEnum.Code */.lw.Code }));
    }, [passwordlessPreLogin]);
    return FronteggApp_35f1a2b2.R.createElement(LoginWithOTC, { loading: loading, error: error, onSubmit: handleSubmit, onResendCode: handleResend, header: FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
            FronteggApp_35f1a2b2.R.createElement(LoginPageTitle, { componentKey: 'otcTitle', title: t('otcTitle') }),
            FronteggApp_35f1a2b2.R.createElement(LoginPageMessage, { textAlignCenter: true, componentKey: 'otcMessage', message: t(`otcMessage`, { email }) })) });
};

const OTCField = () => {
    const [, , { setValue }] = (0,formik_esm_baae0afb.at)('token');
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aF, { autoFocus: true, length: 6, onChangeOTP: setValue, "data-test-id": 'otc-box' });
};
const LoginWithQuickSmsVerifyOTC = () => {
    var _a;
    const t = useT('login');
    const { loading, error, changePhoneId, phoneNumber } = (0,formik_esm_baae0afb.a4)();
    const { changePhoneNumberWithVerification, quickSmsPasswordlessPreLogin, passwordlessPostLogin, verifyChangePhoneNumber, afterAuthNavigation } = (0,formik_esm_baae0afb.U)();
    const { token: recaptchaToken, loadNewToken } = useRecaptchaContext();
    const user = (0,formik_esm_baae0afb.X)();
    const email = localStorage.getItem('email');
    const usedStrategy = localStorage.getItem(`${email}-${LoginStrategyID.Sms}`);
    const handleSubmit = FronteggApp_35f1a2b2.r.exports.useCallback((values) => {
        const callback = (success) => {
            if (success) {
                const email = localStorage.getItem('email');
                localStorage.setItem(`${email}-${LoginStrategyID.Sms}`, 'true');
                localStorage.setItem(`${email}-preferred-login-method`, LoginStrategyID.Sms);
                afterAuthNavigation();
            }
        };
        if (email && usedStrategy) {
            passwordlessPostLogin({ token: values.token, type: redux_store/* AuthStrategyEnum.SmsCode */.lw.SmsCode, recaptchaToken, callback });
        }
        else if (user) {
            verifyChangePhoneNumber({ code: values.token, changePhoneId: values.changePhoneId, callback });
        }
        loadNewToken();
    }, [email, usedStrategy, afterAuthNavigation, passwordlessPostLogin, recaptchaToken]);
    const handleResendCode = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        if (email && usedStrategy) {
            quickSmsPasswordlessPreLogin({ recaptchaToken, email });
            loadNewToken();
        }
        else if (user) {
            changePhoneNumberWithVerification({ phoneNumber: phoneNumber });
        }
    }, [email, loadNewToken, usedStrategy, user, changePhoneNumberWithVerification, phoneNumber]);
    return FronteggApp_35f1a2b2.R.createElement(BoxElement$1, null,
        FronteggApp_35f1a2b2.R.createElement(LoginPageTitle, { componentKey: "smsVerifyCodeTitle", title: t('smsLoginPinTitle') }),
        FronteggApp_35f1a2b2.R.createElement(LoginPageMessage, { componentKey: 'smsVerifyCodeMessage', message: t('smsLoginPinMessage', { phoneNumber: (_a = user === null || user === void 0 ? void 0 : user.phoneNumber) !== null && _a !== void 0 ? _a : localStorage.getItem(`${email}-phone`) }), textAlignCenter: true }),
        FronteggApp_35f1a2b2.R.createElement(FromWrapper, { onSubmit: handleSubmit, initialValues: { token: '', changePhoneId }, validationSchema: (0,formik_esm_baae0afb.ab)({
                token: (0,formik_esm_baae0afb.ap)(6, t('otcCodeIsRequired'), t('otcInvalidLengthCode'))
            }), enableReinitialize: true }, ({ isValid }) => FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
            FronteggApp_35f1a2b2.R.createElement(OTCField, null),
            error && FronteggApp_35f1a2b2.R.createElement(LoginErrorMessage, null, error),
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.l, { disabled: loading || !isValid, sx: { mt: 4 }, fullWidth: true, loading: loading, color: "primary", type: "submit" }, t('smsLoginPinButton')),
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.T, { variant: 'subtitle1', textAlign: 'center', mt: 3 },
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { onClick: handleResendCode, "data-test-id": 'resend-otc-btn' }, t('otcResend'))))));
};

const getLoginComponentByStep = (step) => {
    if ([redux_store/* LoginStep.preLogin */.Fh.preLogin, redux_store/* LoginStep.loginWithPassword */.Fh.loginWithPassword].includes(step)) {
        return FronteggApp_35f1a2b2.R.createElement(LoginWithPassword, null);
    }
    else if (step === redux_store/* LoginStep.redirectToSSO */.Fh.redirectToSSO) {
        return FronteggApp_35f1a2b2.R.createElement(RedirectToSSO, null);
    }
    else if (step === redux_store/* LoginStep.loginWithTwoFactor */.Fh.loginWithTwoFactor) {
        return FronteggApp_35f1a2b2.R.createElement(LoginWithTwoFactor, null);
    }
    else if (step === redux_store/* LoginStep.recoverTwoFactor */.Fh.recoverTwoFactor) {
        return FronteggApp_35f1a2b2.R.createElement(RecoverTwoFactor, null);
    }
    else if (step === redux_store/* LoginStep.magicLinkPreLoginSuccess */.Fh.magicLinkPreLoginSuccess) {
        return FronteggApp_35f1a2b2.R.createElement(MagicLinkPreLoginSuccess, null);
    }
    else if (step === redux_store/* LoginStep.loginWithSmsOtc */.Fh.loginWithSmsOtc) {
        return FronteggApp_35f1a2b2.R.createElement(LoginWithSmsOTC, null);
    }
    else if (step === redux_store/* LoginStep.loginWithOtc */.Fh.loginWithOtc) {
        return FronteggApp_35f1a2b2.R.createElement(LoginWithEmailOTC, null);
    }
    else if (step === redux_store/* LoginStep.loginWithQuickSmsOtc */.Fh.loginWithQuickSmsOtc) {
        return FronteggApp_35f1a2b2.R.createElement(LoginWithQuickSmsVerifyOTC, null);
    }
};

const PhoneField$2 = () => {
    const [fieldProps, { error, touched }] = (0,formik_esm_baae0afb.at)('phoneNumber');
    const signupT = useT('signup');
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.I, Object.assign({}, fieldProps, { error: !!error && touched, errorMessage: error, label: signupT('phoneInputLabel'), placeholder: signupT('phoneInputPlaceholder'), "data-test-id": 'phone-number-box', name: 'phoneNumber' }));
};
const LoginWithQuickSmsChangePhone = () => {
    const t = useT('login');
    const { changePhoneNumberWithVerification } = (0,formik_esm_baae0afb.U)();
    const { loading, error } = (0,formik_esm_baae0afb.a4)();
    const user = (0,formik_esm_baae0afb.X)();
    const validationSchema = FronteggApp_35f1a2b2.r.exports.useMemo(() => (0,formik_esm_baae0afb.ab)({
        phoneNumber: (0,formik_esm_baae0afb.ai)(t('phoneIsRequired'), t('phoneIsInvalid')),
    }), [t]);
    const handleSubmit = FronteggApp_35f1a2b2.r.exports.useCallback(({ phoneNumber }) => {
        changePhoneNumberWithVerification({ phoneNumber });
        localStorage.setItem(`${user === null || user === void 0 ? void 0 : user.email}-phone`, phoneNumber);
    }, [user, changePhoneNumberWithVerification]);
    return FronteggApp_35f1a2b2.R.createElement(BoxElement$1, null,
        FronteggApp_35f1a2b2.R.createElement(LoginPageTitle, { componentKey: 'smsChangePhoneTitle', title: t('smsLoginChangePhoneTitle') }),
        FronteggApp_35f1a2b2.R.createElement(LoginPageMessage, { componentKey: 'smsChangePhoneMessage', message: t('smsLoginChangePhoneMessage'), textAlignCenter: true }),
        FronteggApp_35f1a2b2.R.createElement(FromWrapper, { onSubmit: handleSubmit, initialValues: { phoneNumber: '' }, validationSchema: validationSchema }, ({ isValid }) => FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
            FronteggApp_35f1a2b2.R.createElement(PhoneField$2, null),
            error && FronteggApp_35f1a2b2.R.createElement(LoginErrorMessage, null, error),
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.l, { disabled: loading || !isValid, sx: { mt: 4 }, fullWidth: true, loading: loading, color: "primary", type: "submit" }, t('smsLoginChangePhoneButton')))));
};

const PopupMainCard = (0,formik_esm_baae0afb.f)(formik_esm_baae0afb.B)(({ showCard, shouldRunAnimations }) => (showCard ? {
    position: 'absolute',
    opacity: 1,
    transform: 'translateX(-50%)',
    bottom: '2rem',
    zIndex: 3,
    animation: shouldRunAnimations ? 'pop-up 0.5s ease-in-out 1' : '',
    width: '465px',
    left: '50%',
    'div:first-of-type': {
        maxWidth: '100%',
    },
    "@keyframes pop-up": {
        "0%": {
            transform: 'translateX(-50%)',
            bottom: '-4rem',
            width: '465px',
            opacity: 0,
            zIndex: 3,
        },
        "100%": {
            transform: 'translateX(-50%)',
            bottom: '2rem',
            width: '465px',
            opacity: 1,
            zIndex: 3
        }
    },
    '> div:first-of-type': {
        minHeight: '380px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
    },
} : {
    position: 'absolute',
    transform: 'translateX(-50%)',
    bottom: '-4rem',
    width: '465px',
    opacity: 0,
    zIndex: 1,
    left: '50%',
    animation: shouldRunAnimations ? 'hide-pop-up 0.4s ease-in-out 1' : '',
    'div:first-of-type': {
        maxWidth: '100%',
    },
    "@keyframes hide-pop-up": {
        "0%": {
            transform: 'translateX(-50%)',
            bottom: '2rem',
            width: '465px',
            opacity: 1,
            zIndex: 3
        },
        "100%": {
            transform: 'translateX(-50%)',
            bottom: '-4rem',
            width: '465px',
            opacity: 0,
            zIndex: 1,
        }
    }
}));
const RegiterQuickLoginCard = (0,formik_esm_baae0afb.f)(formik_esm_baae0afb.B)(({ showCard, shouldRunAnimations }) => (showCard ? {
    width: '465px',
    opacity: 1,
    animation: shouldRunAnimations ? 'show 0.4s ease-in-out 1' : '',
    zIndex: 3,
    'div:first-of-type': {
        maxWidth: '100%',
    },
    "@keyframes show": {
        "0%": {
            width: '400px',
            opacity: 0.5,
        },
        "100%": {
            width: '465px',
            opacity: 1,
        }
    }
} : {
    width: '400px',
    opacity: 0.5,
    animation: shouldRunAnimations ? 'go-back 0.5s ease-in-out 1' : '',
    'div:first-of-type': {
        maxWidth: '100%',
    },
    "@keyframes go-back": {
        "0%": {
            width: '465px',
            opacity: 1,
        },
        "100%": {
            width: '400px',
            opacity: 0.5,
        }
    }
}));
const RegisterQuickLoginContainer = (0,formik_esm_baae0afb.f)(formik_esm_baae0afb.B)({
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '35rem',
    width: '100%',
    flexDirection: 'column',
    rowGap: '2.5rem'
});
const RegisterQuickLogin = ({ loginStrategyId }) => {
    const t = useT('login');
    const { step } = (0,formik_esm_baae0afb.a4)();
    const user = (0,formik_esm_baae0afb.X)();
    const [shouldRunAnimations] = FronteggApp_35f1a2b2.r.exports.useState(!user);
    const mainCard = getLoginComponentByStep(step);
    let component;
    let type = '';
    if (loginStrategyId === LoginStrategyID.Internal) {
        component = FronteggApp_35f1a2b2.R.createElement(LoginWithTouchID, null);
        type = t('touchId');
    }
    else if (loginStrategyId === LoginStrategyID.Android) {
        component = FronteggApp_35f1a2b2.R.createElement(LoginWithAndroid, null);
        type = t('android');
    }
    else if (loginStrategyId === LoginStrategyID.UsbKey) {
        component = FronteggApp_35f1a2b2.R.createElement(LoginWithUsbKey, null);
        type = t('usb');
    }
    else if (loginStrategyId === LoginStrategyID.Sms) {
        type = t('sms');
        component = FronteggApp_35f1a2b2.R.createElement(LoginWithQuickSmsChangePhone, null);
        if (step === redux_store/* LoginStep.loginWithQuickSmsOtc */.Fh.loginWithQuickSmsOtc) {
            component = FronteggApp_35f1a2b2.R.createElement(LoginWithQuickSmsVerifyOTC, null);
        }
    }
    return FronteggApp_35f1a2b2.R.createElement(RegisterQuickLoginContainer, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { display: 'flex', flexDirection: 'column', rowGap: 2 },
            FronteggApp_35f1a2b2.R.createElement(PageTitle, null, t('registerNewQuickLoginTitle')),
            FronteggApp_35f1a2b2.R.createElement(PageSubtitle, null, t('registerNewQuickLoginSubtitle', { type }))),
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { minHeight: '32.5rem', display: 'flex', alignItems: 'center', position: 'relative' },
            FronteggApp_35f1a2b2.R.createElement(RegiterQuickLoginCard, { showCard: !!user, shouldRunAnimations: shouldRunAnimations }, component),
            FronteggApp_35f1a2b2.R.createElement(PopupMainCard, { showCard: !user, shouldRunAnimations: shouldRunAnimations }, mainCard)),
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { height: '2.5rem' }));
};

const MFARecoveryCodeStepForm = () => {
    const t = useT('recoveryMfa');
    const { recoveryCode } = (0,formik_esm_baae0afb.aq)(({ recoveryCode }) => ({ recoveryCode }));
    return (FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { mb: 4 },
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aL, { label: t('recoveryCodeLabel'), value: recoveryCode })),
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { mb: 4 },
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.A, { color: "warning" },
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.T, { variant: "subtitle2" }, t('copyAndSaveCode'))))));
};
const MFARecoveryCodeStep = () => {
    const t = useT('recoveryMfa');
    const { step } = (0,formik_esm_baae0afb.aq)(({ step }) => ({ step }));
    const { setState } = (0,formik_esm_baae0afb.V)();
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const routes = (0,formik_esm_baae0afb.K)();
    const loginState = (0,formik_esm_baae0afb.a4)();
    const handleContinue = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        setState({ isAuthenticated: true, loginState: Object.assign(Object.assign({}, loginState), { step: redux_store/* LoginStep.success */.Fh.success }) });
        if (loginState.flow === redux_store/* LoginFlow.Login */.iP.Login) {
            const { loginUrl, logoutUrl, socialLoginCallbackUrl, activateUrl } = routes;
            let authenticatedUrl = routes.authenticatedUrl;
            const afterAuthRedirect = window.localStorage.getItem('FRONTEGG_AFTER_AUTH_REDIRECT_URL');
            if (afterAuthRedirect && ![loginUrl, logoutUrl, socialLoginCallbackUrl, activateUrl].includes(afterAuthRedirect)) {
                authenticatedUrl = afterAuthRedirect;
            }
            window.localStorage.removeItem('FRONTEGG_AFTER_AUTH_REDIRECT_URL');
            const url = new URL(window === null || window === void 0 ? void 0 : window.location.href);
            const redirectUrl = url.searchParams.get('redirectUrl') || authenticatedUrl;
            onRedirectTo(redirectUrl, { refresh: redirectUrl.startsWith('http') });
        }
    }, [setState, onRedirectTo, routes, loginState]);
    if (step !== redux_store/* MFAStep.recoveryCode */.bj.recoveryCode) {
        return null;
    }
    return (FronteggApp_35f1a2b2.R.createElement(BoxElement$1, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.T, { variant: "subtitle1", mb: 2 }, t('title')),
        FronteggApp_35f1a2b2.R.createElement(MFARecoveryCodeStepForm, null),
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { textAlign: 'right' },
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.l, { "data-test-id": "continueBtn", className: 'fe-primary-btn', color: "primary", onClick: handleContinue }, t('continueButton')))));
};

const ONE_DAY_IN_SECONDS = 60 * 60 * 24;
var MFAStep;
(function (MFAStep) {
    MFAStep["verify"] = "verify";
    MFAStep["recoveryCode"] = "recoveryCode";
})(MFAStep || (MFAStep = {}));
const GoogleAuthenticatorLink = FronteggApp_35f1a2b2.r.exports.memo(() => {
    return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { href: "https://www.google.com/search?q=google+authenticator", target: "_blank" }, "Google Authenticator"));
});
const MFAVerifyStepForm = () => {
    const t = useT('login');
    const { loading, qrCode, error: stateError } = (0,formik_esm_baae0afb.aq)();
    const { enrollMfa } = (0,formik_esm_baae0afb.ar)();
    const [tokenFieldProps, { error: tokenError }] = (0,formik_esm_baae0afb.at)('token');
    const [rememberDeviceFieldProps] = (0,formik_esm_baae0afb.at)('rememberDevice');
    const { allowRememberMfaDevice, mfaDeviceExpiration } = (0,formik_esm_baae0afb.a4)();
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        if (!qrCode) {
            enrollMfa();
        }
    }, [qrCode, enrollMfa]);
    return (FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.T, { variant: "body1" },
            t('forceMfaScanQueryDescription1'),
            " ",
            FronteggApp_35f1a2b2.R.createElement(GoogleAuthenticatorLink, null),
            " ",
            t('forceMfaScanQueryDescription2')),
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { margin: "2rem auto", textAlign: 'center' }, loading && !qrCode ? FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.O, { center: true }) : FronteggApp_35f1a2b2.R.createElement("img", { alt: "Multi-factor QR", src: qrCode !== null && qrCode !== void 0 ? qrCode : '' })),
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.I, Object.assign({ "data-test-id": "6DigitsBox" }, tokenFieldProps, { autoFocus: true, inputMode: "numeric", label: t('mfaInputLabel'), error: !!tokenError || !!stateError, errorMessage: tokenError || stateError, autoComplete: "one-time-code", placeholder: t('forceMfaInputPlaceholder') })),
        allowRememberMfaDevice && mfaDeviceExpiration && (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aG, { "data-test-id": "forceMfaRememberThisDevice", sx: { pl: 0, pb: 4, pt: 4 }, control: FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.o, Object.assign({}, rememberDeviceFieldProps, { size: "small" })), label: (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.T, { variant: "body1" }, t('forceMfaRememberThisDevice', { count: Math.floor(mfaDeviceExpiration / ONE_DAY_IN_SECONDS) }))) }))));
};
const ForceEnrollMfa = () => {
    const t = useT('login');
    const { step, loading, recoveryCode, mfaToken } = (0,formik_esm_baae0afb.aq)();
    const { setMfaState, verifyMfaAfterForce } = (0,formik_esm_baae0afb.ar)();
    const recoveryCodeRef = FronteggApp_35f1a2b2.r.exports.useRef('');
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        recoveryCodeRef.current = recoveryCode !== null && recoveryCode !== void 0 ? recoveryCode : '';
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    if (step === MFAStep.recoveryCode) {
        return FronteggApp_35f1a2b2.R.createElement(MFARecoveryCodeStep, null);
    }
    return (FronteggApp_35f1a2b2.R.createElement(BoxElement$1, null,
        FronteggApp_35f1a2b2.R.createElement(FromWrapper, { validationSchema: (0,formik_esm_baae0afb.ab)({
                token: (0,formik_esm_baae0afb.as)(t('mfaCodeLengthAtLeast6'), t('mfaCodeIsRequired')),
            }), initialValues: { token: '', rememberDevice: false }, onSubmit: ({ token, rememberDevice }, { setSubmitting }) => (0,FronteggApp_35f1a2b2.g)(void 0, void 0, void 0, function* () {
                verifyMfaAfterForce({
                    mfaToken: mfaToken || '',
                    value: token,
                    rememberDevice,
                    callback: (success) => {
                        if (success) {
                            setMfaState({ recoveryCode });
                        }
                        setSubmitting(false);
                    },
                });
            }) }, ({ isValid, dirty }) => {
            return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, null,
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.T, { variant: "subtitle1", mb: 4 }, t('forceMfaMessage')),
                FronteggApp_35f1a2b2.R.createElement(MFAVerifyStepForm, null),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { className: "fe-dialog__footer" },
                    FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.G, { container: true },
                        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.G, { xs: true, item: true, className: "fe-text-align-end" },
                            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.l, { className: 'fe-primary-btn', disabled: !isValid || !dirty, type: "submit", size: "large", fullWidth: true, color: "primary", loading: loading, "data-test-id": "sumbit-btn" }, t('forceMfaVerifyButton')))))));
        })));
};

const LoginContainer = loginStyler(formik_esm_baae0afb.B)(({ theme }) => (Object.assign({}, theme.containerStyle)));
const loginCarouselSteps = [
    redux_store/* LoginStep.preLogin */.Fh.preLogin,
    redux_store/* LoginStep.loginWithPassword */.Fh.loginWithPassword,
];
const LoginPage$1 = () => {
    const t = useT('login');
    const { isLoading, isAuthenticated, user } = (0,formik_esm_baae0afb.J)(({ isLoading, isAuthenticated, user }) => ({ isLoading, isAuthenticated, user }));
    const { flow, step, inviteTokenError, quickLoginToRegister } = (0,formik_esm_baae0afb.a4)();
    const { resetLoginState } = (0,formik_esm_baae0afb.U)();
    const { authOptions: { includeQueryParam } = {} } = (0,formik_esm_baae0afb.v)();
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const routes = (0,formik_esm_baae0afb.K)();
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        // only after first mount and redirected by saga
        const timeout = setTimeout(() => {
            var _a;
            if (!isLoading && isAuthenticated && window.location.pathname.endsWith(routes.loginUrl) && flow === redux_store/* LoginFlow.Login */.iP.Login) {
                const url = new URL(window.location.href);
                let redirectUrl = routes.authenticatedUrl;
                if (url.searchParams.get('redirectUrl')) {
                    redirectUrl = (_a = url.searchParams.get('redirectUrl')) !== null && _a !== void 0 ? _a : routes.authenticatedUrl;
                }
                else if (includeQueryParam) {
                    redirectUrl += window.location.search;
                }
                onRedirectTo(redirectUrl, { refresh: redirectUrl.startsWith('http') });
            }
        }, 1000);
        return () => clearTimeout(timeout);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { components } = FronteggApp_35f1a2b2.r.exports.useMemo(() => {
        let components;
        if (inviteTokenError) {
            components = FronteggApp_35f1a2b2.R.createElement(TenantInvitationFailed, { variant: 'login', t: t });
        }
        else if (step === redux_store/* LoginStep.forceTwoFactor */.Fh.forceTwoFactor) {
            components = FronteggApp_35f1a2b2.R.createElement(ForceEnrollMfa, null);
        }
        else if (flow === redux_store/* LoginFlow.Login */.iP.Login) {
            if (loginCarouselSteps.includes(step)) {
                components = FronteggApp_35f1a2b2.R.createElement(LoginCarousel, null);
            }
            else {
                components = getLoginComponentByStep(step);
            }
        }
        else if (flow === redux_store/* LoginFlow.RegisterQuickLogin */.iP.RegisterQuickLogin && quickLoginToRegister) {
            components = FronteggApp_35f1a2b2.R.createElement(RegisterQuickLogin, { loginStrategyId: quickLoginToRegister });
        }
        return { components };
    }, [flow, step, quickLoginToRegister, inviteTokenError, resetLoginState, user]);
    const { signupMessagePlacement, disclaimer } = (0,formik_esm_baae0afb.a8)();
    if ((isLoading || isAuthenticated) && flow === redux_store/* LoginFlow.Login */.iP.Login) {
        return FronteggApp_35f1a2b2.R.createElement(PageLoader, null);
    }
    return (FronteggApp_35f1a2b2.R.createElement(RecaptchaProvider, { action: 'login' },
        signupMessagePlacement === 'page' && FronteggApp_35f1a2b2.R.createElement(SignUpMessage, null),
        FronteggApp_35f1a2b2.R.createElement(LoginContainer, null, components),
        (disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.placement) === 'page' && FronteggApp_35f1a2b2.R.createElement(DisclaimerInfo, null)));
};

const LoginPage = wrapPageWithoutBox(LoginPage$1, 'login');

const acceptInvitationStyler = (0,formik_esm_baae0afb.j)();

const AcceptInvitationSuccessContainer = acceptInvitationStyler(formik_esm_baae0afb.B)(({ theme }) => (Object.assign({}, theme.successContainerStyle)));
const AcceptInvitationSuccess = () => {
    const t = useT('acceptInvitation');
    const { loginUrl } = (0,formik_esm_baae0afb.K)();
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        setTimeout(() => {
            onRedirectTo(loginUrl);
        }, 3000);
    }, [loginUrl, onRedirectTo]);
    return (FronteggApp_35f1a2b2.R.createElement(AcceptInvitationSuccessContainer, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.a3, { title: t('successTitle'), description: t(`successMessage`), iconKey: 'joinTeam', testId: 'accept-invitation-success' })));
};

const AcceptInvitationFailedContainer = acceptInvitationStyler(formik_esm_baae0afb.B)(({ theme }) => (Object.assign({}, theme.failedContainerStyle)));
const AcceptInvitationFailed = () => {
    const t = useT('acceptInvitation');
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const { loginUrl } = (0,formik_esm_baae0afb.K)();
    const backToLogin = FronteggApp_35f1a2b2.r.exports.useCallback(() => onRedirectTo(loginUrl), [loginUrl]);
    return (FronteggApp_35f1a2b2.R.createElement(AcceptInvitationFailedContainer, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.a3, { title: t('invalidTitle'), description: t('invalidMessage'), testId: 'accept-invitation-failed' },
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { sx: { mt: 8 }, className: 'fe-back-to-login-btn', "data-test-id": 'loginBack-btn', onClick: backToLogin }, t('invalidBackToLoginButton')))));
};

const AcceptInvitationContainer = acceptInvitationStyler(formik_esm_baae0afb.B)(({ theme }) => (Object.assign({}, theme.containerStyle)));
const AcceptInvitationPage$1 = () => {
    const { acceptInvitation } = (0,formik_esm_baae0afb.a9)();
    const { step } = (0,formik_esm_baae0afb.aa)();
    const url = new URL(window === null || window === void 0 ? void 0 : window.location.href);
    const userId = url.searchParams.get('userId') || '';
    const token = url.searchParams.get('token') || '';
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        acceptInvitation({ token, userId });
    }, [acceptInvitation, token, userId]);
    let components;
    switch (step) {
        case redux_store/* AcceptInvitationStep.invalid */.Mr.invalid:
            components = FronteggApp_35f1a2b2.R.createElement(AcceptInvitationFailed, null);
            break;
        case redux_store/* AcceptInvitationStep.pending */.Mr.pending:
            components = FronteggApp_35f1a2b2.R.createElement(LargeLoader, null);
            break;
        case redux_store/* AcceptInvitationStep.success */.Mr.success:
            components = FronteggApp_35f1a2b2.R.createElement(AcceptInvitationSuccess, null);
            break;
        case redux_store/* AcceptInvitationStep.failed */.Mr.failed:
            components = FronteggApp_35f1a2b2.R.createElement(AcceptInvitationFailed, null);
            break;
        default:
            return null;
    }
    return FronteggApp_35f1a2b2.R.createElement(AcceptInvitationContainer, null, components);
};

const AcceptInvitationPage = wrapPage(AcceptInvitationPage$1, 'acceptInvitation');

const activateAccountStyler = (0,formik_esm_baae0afb.j)();
const ActivateAccountPageTitle = BoxTitle;

const ActivateAccountFormContainer = activateAccountStyler(formik_esm_baae0afb.B)(({ theme }) => (Object.assign({}, theme.formContainerStyle)));
const PasswordField$2 = () => {
    const t = useT('activateAccount');
    const [fieldProps, { error, touched }] = (0,formik_esm_baae0afb.at)('password');
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.au, Object.assign({}, fieldProps, { error: !!error && touched, autoFocus: true, type: "password", name: "password", label: t('newPasswordInputLabel'), placeholder: t('newPasswordInputPlaceholder'), "data-test-id": "password-box" }));
};
const ConfirmPasswordField$1 = () => {
    const t = useT('activateAccount');
    const [fieldProps, { error, touched }] = (0,formik_esm_baae0afb.at)('confirmPassword');
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.au, Object.assign({}, fieldProps, { error: !!error && touched, errorMessage: error, type: "password", name: "confirmPassword", label: t('confirmPasswordInputLabel'), placeholder: t('confirmPasswordInputPlaceholder'), "data-test-id": "confirmPassword-box" }));
};
const PasswordStrength$1 = (props) => {
    const [{ value }] = (0,formik_esm_baae0afb.at)('password');
    const t = useGlobalT();
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.av, Object.assign({ t: t, value: value, isTouched: value !== '' }, props));
};
const ActivateAccountForm = (props) => {
    var _a, _b;
    const { userId, token } = props;
    const t = useT('activateAccount');
    const { activateAccount } = (0,formik_esm_baae0afb.V)();
    const { loading: activateStateLoading, error } = (0,formik_esm_baae0afb.Y)();
    const { loading: passwordConfigLoading, passwordConfig } = usePasswordConfig(props.userId);
    const recaptcha = useRecaptcha({ action: 'activate_account' });
    const { socialLogins } = (0,formik_esm_baae0afb.F)();
    const socialLoginsLayout = (_b = (_a = socialLogins === null || socialLogins === void 0 ? void 0 : socialLogins.socialLoginsLayout) === null || _a === void 0 ? void 0 : _a.placement) !== null && _b !== void 0 ? _b : SocialLoginLocation.BOTTOM;
    const [hideRecaptcha] = useHideRecaptcha();
    const { events } = (0,formik_esm_baae0afb.v)();
    const initialValues = FronteggApp_35f1a2b2.r.exports.useMemo(() => ({ password: '', confirmPassword: '', token, userId, recaptchaToken: '' }), [token, userId]);
    const validationSchema = FronteggApp_35f1a2b2.r.exports.useMemo(() => (0,formik_esm_baae0afb.ab)({
        password: (0,formik_esm_baae0afb.ac)(t('newPasswordIsRequired')),
        confirmPassword: (0,formik_esm_baae0afb.ad)(t('confirmPasswordIsRequired'), t('confirmPasswordMustMatch')),
    }), [passwordConfig, t]);
    const formikProps = {
        onSubmit: ({ password }) => new Promise((resolve, reject) => {
            const recaptchaElement = document.getElementsByClassName('grecaptcha-badge')[0];
            const callback = () => hideRecaptcha(recaptchaElement);
            activateAccount({ password, token, userId, recaptchaToken: recaptcha === null || recaptcha === void 0 ? void 0 : recaptcha.token, callback, events });
            resolve();
        }),
        initialValues,
        validationSchema,
    };
    return FronteggApp_35f1a2b2.R.createElement(ActivateAccountFormContainer, null,
        FronteggApp_35f1a2b2.R.createElement(ActivateAccountPageTitle, { componentKey: "title", title: t('title') }),
        socialLoginsLayout === SocialLoginLocation.TOP && FronteggApp_35f1a2b2.R.createElement(SocialLoginsActivation, { dividerText: 'Or activate with' }),
        FronteggApp_35f1a2b2.R.createElement(FromWrapper, Object.assign({}, formikProps), ({ isValid }) => {
            return FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
                FronteggApp_35f1a2b2.R.createElement(PasswordField$2, null),
                FronteggApp_35f1a2b2.R.createElement(PasswordStrength$1, { passwordConfig: passwordConfig, loading: passwordConfigLoading || !passwordConfig }),
                FronteggApp_35f1a2b2.R.createElement(ConfirmPasswordField$1, null),
                error && FronteggApp_35f1a2b2.R.createElement(LoginErrorMessage, null, error),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.l, { sx: { mt: 4 }, className: 'fe-primary-btn', disabled: passwordConfigLoading || !isValid, fullWidth: true, color: "primary", loading: activateStateLoading, "data-test-id": "activate-btn" }, t('activateButton')), recaptcha === null || recaptcha === void 0 ? void 0 :
                recaptcha.component);
        }),
        socialLoginsLayout === SocialLoginLocation.BOTTOM && FronteggApp_35f1a2b2.R.createElement(SocialLoginsActivation, { dividerText: 'Or activate with' }));
};

const ActivateAccountSuccessContainer = activateAccountStyler(formik_esm_baae0afb.B)(({ theme }) => (Object.assign({}, theme.successContainerStyle)));
const ActivateAccountSuccess = () => {
    const t = useT('activateAccount');
    return (FronteggApp_35f1a2b2.R.createElement(ActivateAccountSuccessContainer, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.a3, { title: t('successTitle'), description: t(`successMessage`), iconKey: 'check', testId: 'activate-success' })));
};

const ActivateAccountFailedContainer = activateAccountStyler(formik_esm_baae0afb.B)(({ theme }) => (Object.assign({}, theme.failedContainerStyle)));
const ActivateAccountFailed = ({ title, description, testId }) => {
    const t = useT('activateAccount');
    const { resetActivateState, resetLoginState, resetMfaState } = (0,formik_esm_baae0afb.V)();
    const routes = (0,formik_esm_baae0afb.K)();
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    return (FronteggApp_35f1a2b2.R.createElement(ActivateAccountFailedContainer, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.a3, { title: t(title), description: t(description), testId: testId },
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { sx: { mt: 8 }, className: 'fe-back-to-login-btn', onClick: () => {
                    resetActivateState();
                    resetLoginState();
                    resetMfaState();
                    onRedirectTo(routes.loginUrl);
                } }, t('failedBackToLoginButton')))));
};

var activationLinkErrorType;
(function (activationLinkErrorType) {
    activationLinkErrorType["INVALID"] = "invalid";
    activationLinkErrorType["EXPIRED"] = "expired";
})(activationLinkErrorType || (activationLinkErrorType = {}));
const linkErrorTypeToText = {
    [activationLinkErrorType.INVALID]: { title: 'linkFailedTitle', description: 'linkFailedMessage', testId: 'activate-failed' },
    [activationLinkErrorType.EXPIRED]: { title: 'linkExpiredTitle', description: 'linkExpiredMessage', testId: 'activate-expired' },
};

const ActivateAccountContainer = activateAccountStyler(formik_esm_baae0afb.B)(({ theme }) => (Object.assign({}, theme.containerStyle)));
const ActivateAccountPage$1 = () => {
    const { isLoading } = (0,formik_esm_baae0afb.J)(({ isLoading }) => ({ isLoading }));
    const { step, error } = (0,formik_esm_baae0afb.Y)();
    const { activateAccount } = (0,formik_esm_baae0afb.Z)();
    const { preActivateAccount } = (0,formik_esm_baae0afb.Z)();
    const { builderMode } = (0,formik_esm_baae0afb.v)();
    const { captchaPolicy } = (0,formik_esm_baae0afb._)();
    const { activationStrategy: { strategy } } = (0,formik_esm_baae0afb.Y)();
    const recaptcha = useRecaptcha({ action: 'activate_account' });
    const url = new URL(window === null || window === void 0 ? void 0 : window.location.href);
    const userId = url.searchParams.get('userId') || (builderMode ? 'demo-user-id' : '');
    const token = url.searchParams.get('token') || (builderMode ? 'demo-token-id' : '');
    const { events } = (0,formik_esm_baae0afb.v)();
    const isCaptchaLoading = FronteggApp_35f1a2b2.r.exports.useMemo(() => {
        if (captchaPolicy.loading) {
            return true;
        }
        if (captchaPolicy.policy && !captchaPolicy.policy.enabled) {
            return false;
        }
        return !(recaptcha === null || recaptcha === void 0 ? void 0 : recaptcha.token.length);
    }, [captchaPolicy, recaptcha]);
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        if (!!error || invalidUrlParams) {
            return;
        }
        if (strategy && !strategy.shouldSetPassword && !isCaptchaLoading) {
            activateAccount({ userId, token, recaptchaToken: recaptcha === null || recaptcha === void 0 ? void 0 : recaptcha.token, events });
        }
    }, [activateAccount, captchaPolicy, recaptcha, strategy]);
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        preActivateAccount({ userId, token });
    }, [preActivateAccount]);
    const invalidUrlParams = FronteggApp_35f1a2b2.r.exports.useMemo(() => !userId || !token, [userId, token]);
    let components;
    if (invalidUrlParams || !!error) {
        components =
            FronteggApp_35f1a2b2.R.createElement(ActivateAccountFailed, Object.assign({}, linkErrorTypeToText[invalidUrlParams ? activationLinkErrorType.INVALID : activationLinkErrorType.EXPIRED]));
    }
    else if (step === redux_store/* ActivateAccountStep.activating */.M1.activating || isLoading) {
        components = FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null, recaptcha === null || recaptcha === void 0 ? void 0 :
            recaptcha.component,
            FronteggApp_35f1a2b2.R.createElement(PageLoader, null));
    }
    else if (step === redux_store/* ActivateAccountStep.success */.M1.success) {
        components = FronteggApp_35f1a2b2.R.createElement(ActivateAccountSuccess, null);
    }
    else if (step === redux_store/* ActivateAccountStep.activatingForm */.M1.activatingForm) {
        components = FronteggApp_35f1a2b2.R.createElement(ActivateAccountForm, { userId: userId, token: token });
    }
    else {
        components = FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null, recaptcha === null || recaptcha === void 0 ? void 0 :
            recaptcha.component,
            FronteggApp_35f1a2b2.R.createElement(PageLoader, null));
    }
    return FronteggApp_35f1a2b2.R.createElement(ActivateAccountContainer, null, components);
};

const ActivateAccountPage = wrapPage(ActivateAccountPage$1, 'activateAccount');

const forgotPasswordStyler = (0,formik_esm_baae0afb.j)();
const ForgotPasswordPageTitle = BoxTitle;
const ForgotPasswordPageMessage = BoxMessage;

const ForgotPasswordFormContainer = forgotPasswordStyler(formik_esm_baae0afb.B)(({ theme }) => (Object.assign({}, theme.formContainerStyle)));
const EmailField$2 = () => {
    const t = useT('forgetPassword');
    const [fieldProps, { error, touched }] = (0,formik_esm_baae0afb.at)('email');
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.I, Object.assign({}, fieldProps, { error: !!error && touched, errorMessage: error, name: "email", placeholder: t('emailInputPlaceholder'), label: t('emailInputLabel'), "data-test-id": "email-box" }));
};
const ForgotPasswordForm = () => {
    const t = useT('forgetPassword');
    const { loading, email = '', error } = (0,formik_esm_baae0afb.$)();
    const { forgotPassword, setForgotPasswordState } = (0,formik_esm_baae0afb.a0)();
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const { loginUrl } = (0,formik_esm_baae0afb.K)();
    const handleBackToLogin = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        onRedirectTo(loginUrl);
    }, [loginUrl, onRedirectTo]);
    const initialValues = FronteggApp_35f1a2b2.r.exports.useMemo(() => ({ email }), [email]);
    const validationSchema = FronteggApp_35f1a2b2.r.exports.useMemo(() => (0,formik_esm_baae0afb.ab)({
        email: (0,formik_esm_baae0afb.ae)(t('emailMustBeValid'), t('emailIsRequired')),
    }), [t]);
    const formikProps = {
        onSubmit: ({ email }) => new Promise((resolve) => {
            setForgotPasswordState({ email });
            forgotPassword({ email });
            resolve();
        }),
        initialValues,
        validationSchema,
    };
    return FronteggApp_35f1a2b2.R.createElement(ForgotPasswordFormContainer, { "data-test-id": "forgot-password-form" },
        FronteggApp_35f1a2b2.R.createElement(ForgotPasswordPageTitle, { componentKey: "title", title: t('title') }),
        FronteggApp_35f1a2b2.R.createElement(ForgotPasswordPageMessage, { componentKey: "message", message: t('description') }),
        FronteggApp_35f1a2b2.R.createElement(FromWrapper, Object.assign({}, formikProps), ({ isValid }) => {
            return FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
                FronteggApp_35f1a2b2.R.createElement(EmailField$2, null),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { height: "1px", mb: 4 }),
                error && FronteggApp_35f1a2b2.R.createElement(LoginErrorMessage, { "data-test-id": "forgot-password-form-error" }, error),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.l, { className: 'fe-primary-btn', disabled: loading || !isValid, fullWidth: true, color: "primary", loading: loading, "data-test-id": "submit-btn" }, t('submitButtonText')),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { height: "1px", mb: 4 }),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { textAlign: "center" },
                    FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { sx: { mt: 8 }, "data-test-id": "back-to-login-btn", onClick: handleBackToLogin }, t('backToLogin'))));
        }));
};

const ForgotPasswordSuccessContainer = forgotPasswordStyler(formik_esm_baae0afb.B)(({ theme }) => (Object.assign({}, theme.successContainerStyle)));
const ForgotPasswordSuccess = () => {
    const t = useT('forgetPassword');
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const { loginUrl } = (0,formik_esm_baae0afb.K)();
    const { email } = (0,formik_esm_baae0afb.$)();
    const { resetForgotPasswordState } = (0,formik_esm_baae0afb.a0)();
    return (FronteggApp_35f1a2b2.R.createElement(ForgotPasswordSuccessContainer, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.a3, { title: t('resetEmailSentTitle'), description: t(`resetEmailSentMessage`, { email }), iconKey: 'check', testId: 'forgot-password-success' },
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { sx: { mt: 8 }, "data-test-id": 'back-to-login-btn', className: 'fe-back-to-login-btn', onClick: () => {
                    resetForgotPasswordState();
                    onRedirectTo(loginUrl);
                } }, t('backToLogin')))));
};

const ForgotPasswordContainer = forgotPasswordStyler(formik_esm_baae0afb.B)(({ theme }) => (Object.assign({}, theme.containerStyle)));
const ForgotPasswordPage$1 = () => {
    const { step } = (0,formik_esm_baae0afb.$)();
    let components;
    if (step === redux_store/* ForgotPasswordStep.success */.M_.success) {
        components = FronteggApp_35f1a2b2.R.createElement(ForgotPasswordSuccess, null);
    }
    else {
        components = FronteggApp_35f1a2b2.R.createElement(ForgotPasswordForm, null);
    }
    return FronteggApp_35f1a2b2.R.createElement(ForgotPasswordContainer, null, components);
};

const ForgotPasswordPage = wrapPage(ForgotPasswordPage$1, 'forgotPassword');

const ResetPasswordFailed = () => {
    const t = useT('resetPassword');
    const { loginUrl } = (0,formik_esm_baae0afb.K)();
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const { resetForgotPasswordState } = (0,formik_esm_baae0afb.V)();
    return (FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.a3, { title: t('failedTitle'), description: t('failedMessage'), testId: "reset-password-failed" },
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { sx: { mt: 8 }, className: 'fe-back-to-login-btn', "data-test-id": 'redirect-to-login', onClick: () => {
                    resetForgotPasswordState();
                    onRedirectTo(loginUrl);
                } }, t('failedBackToLoginButton')))));
};

const ResetPasswordSuccess = (props) => {
    const t = useT('resetPassword');
    const { resetForgotPasswordState } = (0,formik_esm_baae0afb.J)();
    const routes = (0,formik_esm_baae0afb.K)();
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        setTimeout(() => {
            onRedirectTo(routes.loginUrl);
        }, 1000);
        return resetForgotPasswordState;
    }, [onRedirectTo, resetForgotPasswordState, routes.loginUrl]);
    return (FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.a3, { title: t('successTitle'), description: t('successMessage'), iconKey: 'check', testId: 'reset-password-success' })));
};

const resetPasswordStyler = (0,formik_esm_baae0afb.j)();
const ResetPasswordPageTitle = BoxTitle;

const PasswordField$1 = () => {
    const t = useT('resetPassword');
    const [fieldProps, { error, touched }] = (0,formik_esm_baae0afb.at)('password');
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.au, Object.assign({}, fieldProps, { error: !!error && touched, errorMessage: error, autoFocus: true, type: "password", name: "password", label: t('newPasswordInputLabel'), placeholder: t('newPasswordInputPlaceholder'), "data-test-id": "password-box" }));
};
const ConfirmPasswordField = () => {
    const t = useT('resetPassword');
    const [fieldProps, { error, touched }] = (0,formik_esm_baae0afb.at)('confirmPassword');
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.au, Object.assign({}, fieldProps, { error: !!error && touched, errorMessage: error, type: "password", name: "confirmPassword", label: t('confirmPasswordInputLabel'), placeholder: t('confirmPasswordInputPlaceholder'), "data-test-id": "repeat-password-box" }));
};
const PasswordStrength = (props) => {
    const [{ value }] = (0,formik_esm_baae0afb.at)('password');
    const t = useGlobalT();
    return FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.av, Object.assign({ t: t, value: value, isTouched: value !== '' }, props));
};
const ResetPasswordForm = ({ token, userId }) => {
    const t = useT('resetPassword');
    const globalT = useGlobalT();
    const { error } = (0,formik_esm_baae0afb.$)();
    const { loading, passwordConfig } = usePasswordConfig();
    const { resetPassword } = (0,formik_esm_baae0afb.a0)();
    const { loadVendorPasswordConfig } = (0,formik_esm_baae0afb.a6)();
    const { passwordPolicy } = (0,formik_esm_baae0afb._)();
    formik_esm_baae0afb.af.setConfig(passwordPolicy.policy, globalT);
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        !passwordPolicy && loadVendorPasswordConfig();
    }, [passwordPolicy, loadVendorPasswordConfig]);
    const initialValues = FronteggApp_35f1a2b2.r.exports.useMemo(() => ({ password: '', confirmPassword: '', token, userId }), [token, userId]);
    const validationSchema = FronteggApp_35f1a2b2.r.exports.useMemo(() => (0,formik_esm_baae0afb.ab)({
        password: (0,formik_esm_baae0afb.ac)(t('newPasswordIsRequired')),
        confirmPassword: (0,formik_esm_baae0afb.ad)(t('confirmPasswordIsRequired'), t('confirmPasswordMustMatch')),
    }), [t, passwordConfig]);
    const formikProps = {
        onSubmit: ({ password }) => new Promise((resolve, reject) => {
            const callback = (0,formik_esm_baae0afb.aH)(resolve, reject);
            resetPassword({ password, token, userId, callback });
        }),
        initialValues,
        validationSchema,
    };
    return FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        FronteggApp_35f1a2b2.R.createElement(ResetPasswordPageTitle, { componentKey: "title", title: t('title') }),
        FronteggApp_35f1a2b2.R.createElement(FromWrapper, Object.assign({}, formikProps), ({ isValid }) => {
            return FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
                FronteggApp_35f1a2b2.R.createElement(PasswordField$1, null),
                FronteggApp_35f1a2b2.R.createElement(PasswordStrength, { passwordConfig: passwordConfig, loading: loading || !passwordConfig }),
                FronteggApp_35f1a2b2.R.createElement(ConfirmPasswordField, null),
                error && FronteggApp_35f1a2b2.R.createElement(LoginErrorMessage, { "data-test-id": "reset-password-form_error" }, error),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.l, { sx: { mt: 4 }, className: 'fe-primary-btn', disabled: loading || !isValid, fullWidth: true, color: "primary", loading: loading, "data-test-id": "submit-btn" }, t('resetPasswordButton')));
        }));
};

const ResetPasswordContainer = resetPasswordStyler(formik_esm_baae0afb.B)(({ theme }) => (Object.assign({}, theme.containerStyle)));
const ResetPasswordPage$1 = () => {
    const { step } = (0,formik_esm_baae0afb.$)();
    const { builderMode } = (0,formik_esm_baae0afb.v)();
    const { loadPasswordConfig, resetForgotPasswordState } = (0,formik_esm_baae0afb.a0)();
    const url = new URL(window === null || window === void 0 ? void 0 : window.location.href);
    const userId = url.searchParams.get('userId') || (builderMode ? 'demo-user-id' : '');
    const token = url.searchParams.get('token') || (builderMode ? 'demo-token-id' : '');
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        loadPasswordConfig({ userId });
        return resetForgotPasswordState;
    }, [loadPasswordConfig, resetForgotPasswordState]);
    let components;
    if (!userId || !token) {
        components = FronteggApp_35f1a2b2.R.createElement(ResetPasswordFailed, null);
    }
    else if (step === redux_store/* ForgotPasswordStep.success */.M_.success) {
        components = FronteggApp_35f1a2b2.R.createElement(ResetPasswordSuccess, null);
    }
    else {
        components = FronteggApp_35f1a2b2.R.createElement(ResetPasswordForm, { userId: userId, token: token });
    }
    return FronteggApp_35f1a2b2.R.createElement(ResetPasswordContainer, null, components);
};

const ResetPasswordPage = wrapPage(ResetPasswordPage$1, 'resetPassword');

const OidcLoginSuccess$1 = () => {
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const ssoState = (0,formik_esm_baae0afb.a1)();
    const routes = (0,formik_esm_baae0afb.K)();
    const { isLoading, isAuthenticated } = (0,formik_esm_baae0afb.J)(({ isLoading, isAuthenticated }) => ({ isLoading, isAuthenticated }));
    const t = useT('login');
    const { setSSOState, oidcPostlogin } = (0,formik_esm_baae0afb.a2)();
    const loadingMode = FronteggApp_35f1a2b2.r.exports.useMemo(() => !ssoState.error && ssoState.loading, [ssoState.error, ssoState.loading]);
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const state = params.get('state');
        const code = params.get('code');
        const error = t('failedOicdLoginTitle');
        if (!state || !code) {
            setSSOState({ error });
            return;
        }
        try {
            const encodedState = atob(state);
            const encodeStateTenantIdMatch = encodedState.match(/tenantId=([a-zA-Z0-9-]{0,};)/);
            if (!encodeStateTenantIdMatch) {
                setSSOState({ error });
            }
        }
        catch (e) {
            setSSOState({ error });
            return;
        }
        const { origin, pathname } = window.location;
        const redirectUri = `${origin}${pathname}`;
        oidcPostlogin({ code, state, redirectUri });
        // eslint-disable-next-line
    }, []);
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        if (!isLoading && isAuthenticated) {
            let authenticatedUrl = routes.authenticatedUrl;
            const afterAuthRedirect = window.localStorage.getItem('FRONTEGG_AFTER_AUTH_REDIRECT_URL');
            if (afterAuthRedirect) {
                authenticatedUrl = afterAuthRedirect;
            }
            window.localStorage.removeItem('FRONTEGG_AFTER_AUTH_REDIRECT_URL');
            onRedirectTo(authenticatedUrl);
        }
    }, [onRedirectTo, isLoading, isAuthenticated, routes]);
    return loadingMode ? FronteggApp_35f1a2b2.R.createElement(PageLoader, null) : (FronteggApp_35f1a2b2.R.createElement(BoxElement$1, { themeOptionKey: 'login' },
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.a3, { title: t('invalidTitle'), description: ssoState.error },
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { sx: { mt: 8 }, onClick: () => {
                    onRedirectTo(routes.loginUrl);
                } }, t('failedOicdBackToLogin')))));
};

const OidcLoginSuccess = wrapPageWithoutBox(OidcLoginSuccess$1, 'login');

const LogoutPage$1 = () => {
    const { loginUrl } = (0,formik_esm_baae0afb.K)();
    const { silentLogout } = (0,formik_esm_baae0afb.U)();
    const { basename = '', urlStrategy } = (0,formik_esm_baae0afb.v)();
    const calculatedBasename = basename.endsWith('/') ? basename.substring(0, basename.length - 1) : '';
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        localStorage.removeItem('register-quick-login');
        silentLogout(() => {
            const path = calculatedBasename + loginUrl;
            if (urlStrategy === 'path') {
                window.location.href = path;
            }
            else {
                window.location.href = `${window.location.pathname}#${path}`;
            }
        });
    }, [silentLogout]);
    return FronteggApp_35f1a2b2.R.createElement(PageLoader, null);
};

const LogoutPage = wrapPageContext(LogoutPage$1, 'login');

const MagicLinkCallbackPage$1 = () => {
    const t = useT('login');
    const { invitationToken } = useVerifyInviteToken();
    const { passwordlessPostLogin, resetLoginState, setLoginState } = (0,formik_esm_baae0afb.U)();
    const { captchaPolicy } = (0,formik_esm_baae0afb._)();
    const { error } = (0,formik_esm_baae0afb.a4)();
    const recaptcha = useRecaptcha({ action: 'magic_link_postlogin' });
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const routes = (0,formik_esm_baae0afb.K)();
    const { events } = (0,formik_esm_baae0afb.v)();
    const token = FronteggApp_35f1a2b2.r.exports.useMemo(() => new URLSearchParams(window.location.search).get('token'), []);
    const backToLogin = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        onRedirectTo(routes.loginUrl);
        resetLoginState();
    }, [onRedirectTo, routes.loginUrl, resetLoginState]);
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        const quickLoginToRegister = localStorage.getItem('register-quick-login');
        if (quickLoginToRegister) {
            setLoginState({ quickLoginToRegister, flow: redux_store/* LoginFlow.RegisterQuickLogin */.iP.RegisterQuickLogin });
            localStorage.removeItem('register-quick-login');
        }
    }, [setLoginState]);
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        var _a;
        if (!captchaPolicy.loading && token && (!((_a = captchaPolicy.policy) === null || _a === void 0 ? void 0 : _a.enabled) || (recaptcha === null || recaptcha === void 0 ? void 0 : recaptcha.token))) {
            passwordlessPostLogin({
                token,
                invitationToken,
                recaptchaToken: recaptcha === null || recaptcha === void 0 ? void 0 : recaptcha.token,
                type: redux_store/* AuthStrategyEnum.MagicLink */.lw.MagicLink,
                events
            });
        }
    }, [token, recaptcha === null || recaptcha === void 0 ? void 0 : recaptcha.token, captchaPolicy, passwordlessPostLogin]);
    if (!token || error) {
        return (FronteggApp_35f1a2b2.R.createElement(PageWrapper$1, null,
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.a3, { title: t(`invalidMagicLinkTitle`), description: !token ? t('invalidMagicLinkText') : error, testId: 'magic-link-error', iconKey: error === "Magic link has expired" ? 'magicLinkExpired' : 'none' },
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { sx: { mt: 8 }, "data-test-id": 'back-to-login-btn', className: 'fe-primary-btn', onClick: backToLogin }, t(`backToLogin`)))));
    }
    return (FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        FronteggApp_35f1a2b2.R.createElement(PageLoader, null), recaptcha === null || recaptcha === void 0 ? void 0 :
        recaptcha.component));
};

const MagicLinkCallbackPage = wrapPageContext(MagicLinkCallbackPage$1, 'login');

const HostedLoginPage = () => {
    const { handleHostedLoginCallback } = (0,formik_esm_baae0afb.U)();
    const params = useQueryParams('code', 'state', 'nonce');
    FronteggApp_35f1a2b2.r.exports.useEffect(() => handleHostedLoginCallback(params), [handleHostedLoginCallback, params]);
    return FronteggApp_35f1a2b2.R.createElement(PageLoader, null);
};

const SamlLoginSuccess$1 = () => {
    var _a;
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const ssoState = (0,formik_esm_baae0afb.a1)();
    const routes = (0,formik_esm_baae0afb.K)();
    const { isLoading, isAuthenticated } = (0,formik_esm_baae0afb.J)(({ isLoading, isAuthenticated }) => ({ isLoading, isAuthenticated }));
    const t = useT('login');
    const { setSSOState } = (0,formik_esm_baae0afb.a2)();
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        const error = params.get('samlerrors');
        const parsedError = (error === null || error === void 0 ? void 0 : error.includes('|')) ? error.split('|')[0] : error;
        if (parsedError) {
            setSSOState({ error: parsedError });
            return;
        }
    }, [setSSOState]);
    return isLoading || isAuthenticated ? FronteggApp_35f1a2b2.R.createElement(PageLoader, null) : (FronteggApp_35f1a2b2.R.createElement(BoxElement$1, { themeOptionKey: 'login' },
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.a3, { title: t('invalidTitle'), description: (_a = ssoState.error) !== null && _a !== void 0 ? _a : t('failedSamlDefaultError'), testId: 'saml-error' },
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { sx: { mt: 8 }, "data-test-id": 'redirect-to-login', onClick: () => {
                    onRedirectTo(routes.loginUrl);
                } }, t('failedSamlBackToLogin')))));
};

const SamlLoginSuccess = wrapPageWithoutBox(SamlLoginSuccess$1, 'login');

const signupStyler = (0,formik_esm_baae0afb.j)();
const SignupPageTitle = BoxTitle;
const LoginMessageComponent = CustomComponent;

const GoToLoginMessage = ({ t }) => {
    const routes = (0,formik_esm_baae0afb.K)();
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const { resetLoginState } = (0,formik_esm_baae0afb.U)();
    const redirectToLogin = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        resetLoginState();
        onRedirectTo(routes.loginUrl + window.location.search);
    }, [routes.loginUrl, onRedirectTo, resetLoginState]);
    const props = {
        goToLoginMessage: t('loginMessage'),
        goToLoginButtonText: t('loginLink'),
        goToLogin: redirectToLogin,
    };
    return FronteggApp_35f1a2b2.R.createElement(LoginMessageComponent, Object.assign({ componentKey: 'loginMessage' }, props),
        FronteggApp_35f1a2b2.R.createElement(LoginSignupSwitch, { variant: 'subtitle1' },
            props.goToLoginMessage,
            " ",
            FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { onClick: props.goToLogin, "data-test-id": 'redirect-to-login' }, props.goToLoginButtonText)));
};

const StyledDisclaimerText = signupStyler(formik_esm_baae0afb.T)(({ theme }) => {
    var _a, _b;
    return (Object.assign(Object.assign({}, (((_a = theme.disclaimer) === null || _a === void 0 ? void 0 : _a.hasCheckbox) ? {}
        : {
            marginTop: '2rem',
            textAlign: 'center',
        })), (_b = theme.disclaimer) === null || _b === void 0 ? void 0 : _b.textStyle));
});
const StyledDisclaimerTermsLink = signupStyler(formik_esm_baae0afb.L)(({ theme }) => {
    var _a, _b;
    return (Object.assign({}, (_b = (_a = theme.disclaimer) === null || _a === void 0 ? void 0 : _a.terms) === null || _b === void 0 ? void 0 : _b.linkStyle));
});
const StyledDisclaimerPrivacyLink = signupStyler(formik_esm_baae0afb.L)(({ theme }) => {
    var _a, _b;
    return (Object.assign({}, (_b = (_a = theme.disclaimer) === null || _a === void 0 ? void 0 : _a.privacy) === null || _b === void 0 ? void 0 : _b.linkStyle));
});
const DisclaimerText = ({ isCheckboxLabel = false }) => {
    const { disclaimer } = (0,formik_esm_baae0afb.F)();
    const t = useContextT('loginBox.signup');
    const showTerms = FronteggApp_35f1a2b2.r.exports.useMemo(() => { var _a; return (_a = disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.terms) === null || _a === void 0 ? void 0 : _a.enabled; }, [disclaimer]);
    const showPrivacy = FronteggApp_35f1a2b2.r.exports.useMemo(() => { var _a; return (_a = disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.privacy) === null || _a === void 0 ? void 0 : _a.enabled; }, [disclaimer]);
    if ((!isCheckboxLabel && (disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.hasCheckbox)) || (!showTerms && !showPrivacy)) {
        return null;
    }
    return (FronteggApp_35f1a2b2.R.createElement(StyledDisclaimerText, { variant: 'body2', "data-test-id": 'signup-disclaimer-text' },
        isCheckboxLabel ? t('disclaimerCheckboxLabel') : t('disclaimerText'),
        ' ',
        showTerms && (FronteggApp_35f1a2b2.R.createElement(StyledDisclaimerTermsLink, { href: t('termsLink'), target: '_blank', "data-test-id": 'signup-terms-link' }, t('termsLinkText'))),
        showTerms && showPrivacy && ` ${t('termsAndPrivacyConjunctionText')} `,
        showPrivacy && (FronteggApp_35f1a2b2.R.createElement(StyledDisclaimerPrivacyLink, { href: t('privacyLink'), target: '_blank', "data-test-id": 'signup-privacy-link' }, t('privacyLinkText')))));
};
const StyledDisclaimerCheckbox = signupStyler(formik_esm_baae0afb.o)(({ theme }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    return ({
        '&:not(.MuiCheckbox-indeterminate) .MuiSvgIcon-root': Object.assign({}, (_c = (_b = (_a = theme.disclaimer) === null || _a === void 0 ? void 0 : _a.checkBoxStyle) === null || _b === void 0 ? void 0 : _b.unchecked) === null || _c === void 0 ? void 0 : _c.base),
        '&:not(.Mui-checked):not(.MuiCheckbox-indeterminate):hover .MuiSvgIcon-root': Object.assign({}, (_f = (_e = (_d = theme.disclaimer) === null || _d === void 0 ? void 0 : _d.checkBoxStyle) === null || _e === void 0 ? void 0 : _e.unchecked) === null || _f === void 0 ? void 0 : _f.hover),
        '&:not(.MuiCheckbox-indeterminate).Mui-checked .MuiSvgIcon-root': Object.assign({ color: theme.palette.primary.main }, (_j = (_h = (_g = theme.disclaimer) === null || _g === void 0 ? void 0 : _g.checkBoxStyle) === null || _h === void 0 ? void 0 : _h.checked) === null || _j === void 0 ? void 0 : _j.base),
        '&:not(.MuiCheckbox-indeterminate).Mui-checked:hover .MuiSvgIcon-root': Object.assign({}, (_m = (_l = (_k = theme.disclaimer) === null || _k === void 0 ? void 0 : _k.checkBoxStyle) === null || _l === void 0 ? void 0 : _l.checked) === null || _m === void 0 ? void 0 : _m.hover),
    });
});
const DisclaimerField = () => {
    const [fieldProps, { error, touched }] = (0,formik_esm_baae0afb.at)('disclaimer');
    const t = useContextT('loginBox.signup');
    return (FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aG, { name: 'disclaimer', control: FronteggApp_35f1a2b2.R.createElement(StyledDisclaimerCheckbox, Object.assign({}, fieldProps, { size: 'small', "data-test-id": 'signup-disclaimer-checkbox' })), label: FronteggApp_35f1a2b2.R.createElement(DisclaimerText, { isCheckboxLabel: true }) }),
        !!error && touched && (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.aI, { error: true, "data-test-id": 'signup-disclaimer-checkbox-error' }, t(error)))));
};

const StyledContainer$2 = signupStyler(formik_esm_baae0afb.B)(({ theme }) => {
    var _a;
    return (Object.assign({}, (_a = theme.disclaimer) === null || _a === void 0 ? void 0 : _a.disclaimerContainerStyle));
});
const SignUpForm = ({ t, config }) => {
    var _a, _b;
    const globalT = useGlobalT();
    const { fields } = config, formikConfig = (0,FronteggApp_35f1a2b2.f)(config, ["fields"]);
    const { loading, error } = (0,formik_esm_baae0afb.ag)();
    const { loadVendorPasswordConfig } = (0,formik_esm_baae0afb.a6)();
    const { isSSOAuth } = (0,formik_esm_baae0afb.J)(({ isSSOAuth }) => ({ isSSOAuth }));
    const { passwordPolicy: { policy: passwordPolicy, loading: passwordPolicyLoading }, publicPolicy: { policy: publicPolicy }, } = (0,formik_esm_baae0afb._)();
    const recaptchaRef = FronteggApp_35f1a2b2.R.createRef();
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        if (recaptchaRef.current && !loading) {
            recaptchaRef.current.execute();
        }
    }, [loading, recaptchaRef]);
    formik_esm_baae0afb.af.setConfig(passwordPolicy, globalT);
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        !passwordPolicy && loadVendorPasswordConfig();
    }, [passwordPolicy, loadVendorPasswordConfig]);
    const shouldDisplayOnlySocialLogins = FronteggApp_35f1a2b2.r.exports.useMemo(() => !isSSOAuth && (publicPolicy === null || publicPolicy === void 0 ? void 0 : publicPolicy.authStrategy) === redux_store/* AuthStrategyEnum.NoLocalAuthentication */.lw.NoLocalAuthentication, [publicPolicy === null || publicPolicy === void 0 ? void 0 : publicPolicy.authStrategy, isSSOAuth]);
    if (passwordPolicyLoading) {
        return FronteggApp_35f1a2b2.R.createElement(PageLoader, null);
    }
    const { socialLogins, loginMessagePlacement, disclaimer } = (0,formik_esm_baae0afb.F)();
    const socialLoginsLayout = (_b = (_a = socialLogins === null || socialLogins === void 0 ? void 0 : socialLogins.socialLoginsLayout) === null || _a === void 0 ? void 0 : _a.placement) !== null && _b !== void 0 ? _b : SocialLoginLocation.BOTTOM;
    return (FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        (!loginMessagePlacement || loginMessagePlacement === 'box') && FronteggApp_35f1a2b2.R.createElement(GoToLoginMessage, { t: t }),
        socialLoginsLayout === SocialLoginLocation.TOP && FronteggApp_35f1a2b2.R.createElement(SocialLoginsSignUp, { testId: 'social-logins-top-layout', dividerText: t('signUpWithSocialLogin'), withSocialDivider: !shouldDisplayOnlySocialLogins }),
        FronteggApp_35f1a2b2.R.createElement(FromWrapper, Object.assign({}, formikConfig), ({ isValid, dirty }) => {
            return (FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
                Object.entries(fields).map(([key, { Component, hide }]) => hide || !Component ? null : FronteggApp_35f1a2b2.R.createElement(Component, { key: key, t: t })),
                error && FronteggApp_35f1a2b2.R.createElement(LoginErrorMessage, { "data-test-id": 'signup-error' }, error),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { height: '1px', mb: 4 }),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.l, { className: 'fe-primary-btn', disabled: !isValid || !dirty, type: 'submit', fullWidth: true, color: 'primary', loading: loading, "data-test-id": 'signupSubmit-btn' }, t('signupButtonText')),
                FronteggApp_35f1a2b2.R.createElement(ReCaptcha, { recaptchaRef: recaptchaRef, action: 'sign_up' })));
        }),
        socialLoginsLayout === SocialLoginLocation.BOTTOM && FronteggApp_35f1a2b2.R.createElement(SocialLoginsSignUp, { testId: 'social-logins-bottom-layout', dividerText: t('signUpWithSocialLogin'), withSocialDivider: !shouldDisplayOnlySocialLogins }),
        disclaimer && (!disclaimer.placement || disclaimer.placement === 'box') && FronteggApp_35f1a2b2.R.createElement(StyledContainer$2, null,
            FronteggApp_35f1a2b2.R.createElement(DisclaimerText, null))));
};

const SignUpSuccess = ({ t, successRedirectUrl }) => {
    const { shouldActivate, onRedirectTo, routes } = (0,formik_esm_baae0afb.J)(({ signUpState, routes, onRedirectTo }) => (Object.assign({ routes, onRedirectTo }, signUpState)));
    const { resetSignUpStateSoft } = (0,formik_esm_baae0afb.V)();
    const BackToLoginClicked = () => {
        onRedirectTo(routes.loginUrl);
    };
    const message = FronteggApp_35f1a2b2.r.exports.useMemo(() => {
        if (shouldActivate) {
            return t('successActivateMessage');
        }
        return t('successGoToLoginButton');
    }, [t, shouldActivate]);
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        if (!shouldActivate) {
            onRedirectTo(successRedirectUrl || routes.signUpSuccessUrl || routes.authenticatedUrl);
        }
        return resetSignUpStateSoft;
    }, [shouldActivate, routes, resetSignUpStateSoft, onRedirectTo]);
    if (!shouldActivate) {
        return null;
    }
    return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.a3, { title: t('successTitle'), description: message, iconKey: 'check', testId: 'signup-success' },
        FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { mt: 10, onClick: BackToLoginClicked }, t('backToLoginLink'))));
};

const EmailField$1 = ({ t }) => {
    const [fieldProps, { error, touched }] = (0,formik_esm_baae0afb.at)('email');
    const { submitCount } = (0,formik_esm_baae0afb.u)();
    return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.I, Object.assign({ autoFocus: true }, fieldProps, { onChange: fieldProps.onChange, error: !!error && touched && (fieldProps.value !== '' || submitCount > 0), errorMessage: error, name: 'email', placeholder: t('emailInputPlaceholder'), label: t('emailInputLabel'), "data-test-id": 'email-box' })));
};

const NameField = ({ t }) => {
    const [fieldProps, { error, touched }] = (0,formik_esm_baae0afb.at)('name');
    return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.I, Object.assign({}, fieldProps, { error: !!error && touched, errorMessage: error, name: 'name', label: t('nameInputLabel'), placeholder: t('nameInputPlaceholder'), "data-test-id": 'name-box' })));
};

const PasswordField = ({ t }) => {
    const [fieldProps, { error, touched }] = (0,formik_esm_baae0afb.at)('password');
    return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.au, Object.assign({}, fieldProps, { error: !!error && touched, errorMessage: error, type: 'password', name: 'password', label: t('passwordInputLabel'), placeholder: t('passwordInputPlaceholder'), "data-test-id": 'password-box' })));
};

const PhoneField$1 = ({ t }) => {
    const [fieldProps, { error, touched }] = (0,formik_esm_baae0afb.at)('phoneNumber');
    return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.I, Object.assign({}, fieldProps, { error: !!error && touched, errorMessage: error, autoComplete: 'tel', name: 'phoneNumber', label: t('phoneInputLabel'), placeholder: t('phoneInputPlaceholder'), "data-test-id": 'phone-number-box' })));
};

const CompanyNameField = ({ t }) => {
    const [fieldProps, { error, touched }] = (0,formik_esm_baae0afb.at)('companyName');
    return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.I, Object.assign({}, fieldProps, { error: !!error && touched, errorMessage: error, name: 'companyName', label: t('companyNameInputLabel'), placeholder: t('companyNameInputPlaceholder'), "data-test-id": 'companyName-box' })));
};

const useSignupForm = ({ t, invitationToken }) => {
    const { signUpUser } = (0,formik_esm_baae0afb.aw)();
    const fields = useSignupFields({ t, invitationToken });
    const { withCompanyName = true, events } = (0,formik_esm_baae0afb.v)();
    const formConfig = FronteggApp_35f1a2b2.r.exports.useMemo(() => {
        const { initialValues, validationSchema } = Object.entries(fields).reduce((acc, [type, config]) => {
            if (config.hide) {
                return acc;
            }
            acc.initialValues[type] = config.initialValue;
            acc.validationSchema[type] = config.validationSchema;
            return acc;
        }, { initialValues: {}, validationSchema: {} });
        return {
            initialValues,
            onSubmit: (values) => {
                var _a;
                const url = new URL((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.href);
                if (invitationToken) {
                    values.invitationToken = invitationToken;
                }
                if (values.disclaimer) {
                    values.metadata = JSON.stringify({
                        lastTermsCheck: new Date().toISOString(),
                    });
                }
                if (withCompanyName) {
                    signUpUser(Object.assign(Object.assign({}, values), { events, url }));
                }
                else {
                    signUpUser(Object.assign(Object.assign({}, values), { companyName: values.name, events, url }));
                }
            },
            validationSchema: (0,formik_esm_baae0afb.ab)(validationSchema),
        };
    }, [fields, formik_esm_baae0afb.ab, signUpUser]);
    return {
        fields,
        formConfig,
    };
};
const useSignupFields = ({ t, invitationToken }) => {
    const { allowNotVerifiedUsersLogin } = (0,formik_esm_baae0afb.ag)();
    const { publicPolicy: { policy: publicPolicy }, } = (0,formik_esm_baae0afb._)();
    const { withCompanyName = true } = (0,formik_esm_baae0afb.v)();
    const shouldDisplayPassword = FronteggApp_35f1a2b2.r.exports.useMemo(() => (publicPolicy === null || publicPolicy === void 0 ? void 0 : publicPolicy.authStrategy) === redux_store/* AuthStrategyEnum.EmailAndPassword */.lw.EmailAndPassword && allowNotVerifiedUsersLogin, [publicPolicy === null || publicPolicy === void 0 ? void 0 : publicPolicy.authStrategy, allowNotVerifiedUsersLogin]);
    const shouldDisplayPhoneNumber = FronteggApp_35f1a2b2.r.exports.useMemo(() => (publicPolicy === null || publicPolicy === void 0 ? void 0 : publicPolicy.authStrategy) === redux_store/* AuthStrategyEnum.SmsCode */.lw.SmsCode, [
        publicPolicy === null || publicPolicy === void 0 ? void 0 : publicPolicy.authStrategy,
    ]);
    const { disclaimer } = (0,formik_esm_baae0afb.F)();
    const fields = FronteggApp_35f1a2b2.r.exports.useMemo(() => {
        var _a, _b;
        return ({
            email: {
                type: 'email',
                initialValue: '',
                Component: EmailField$1,
                validationSchema: (0,formik_esm_baae0afb.ae)(t('emailMustBeValid'), t('emailIsRequired')),
            },
            name: {
                type: 'name',
                initialValue: '',
                Component: NameField,
                validationSchema: (0,formik_esm_baae0afb.ax)(3, t('nameIsRequired'), t('nameMinLengthIs3')),
            },
            password: {
                type: 'password',
                hide: !shouldDisplayPassword,
                initialValue: '',
                Component: PasswordField,
                validationSchema: (0,formik_esm_baae0afb.ac)(t('passwordIsRequired')),
            },
            phoneNumber: {
                type: 'phoneNumber',
                hide: !shouldDisplayPhoneNumber,
                initialValue: '',
                Component: PhoneField$1,
                validationSchema: (0,formik_esm_baae0afb.ai)(t('phoneIsRequired'), t('phoneIsInvalid')),
            },
            companyName: {
                type: 'companyName',
                hide: !!invitationToken || !withCompanyName,
                initialValue: '',
                Component: CompanyNameField,
                validationSchema: (0,formik_esm_baae0afb.ax)(3, t('companyNameIsRequired'), t('companyNameMinLengthIs3')),
            },
            disclaimer: {
                type: 'disclaimer',
                hide: !(!!((_a = disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.privacy) === null || _a === void 0 ? void 0 : _a.enabled) || !!((_b = disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.terms) === null || _b === void 0 ? void 0 : _b.enabled)) || !(disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.hasCheckbox),
                initialValue: false,
                Component: DisclaimerField,
                validationSchema: (0,formik_esm_baae0afb.ay)('disclaimerTextRequired'),
            },
            recaptchaToken: {
                type: 'recaptchaToken',
                initialValue: '',
            },
        });
    }, [shouldDisplayPassword, t, formik_esm_baae0afb.ae, formik_esm_baae0afb.ax, formik_esm_baae0afb.ac, disclaimer]);
    return fields;
};

const SignupContainer$1 = signupStyler(formik_esm_baae0afb.B)(({ theme }) => (Object.assign({}, theme.containerStyle)));
const StyledContainer$1 = signupStyler(formik_esm_baae0afb.B)(({ theme }) => {
    var _a;
    return (Object.assign({}, (_a = theme.disclaimer) === null || _a === void 0 ? void 0 : _a.disclaimerContainerStyle));
});
const UserSignUp = () => {
    var _a;
    const oldT = useT('signup');
    const t = useContextT('loginBox.signup.user');
    const { stage, firstLoad, allowSignUps } = (0,formik_esm_baae0afb.ag)();
    const { userSignUpSuccessUrl, loginUrl } = (0,formik_esm_baae0afb.K)();
    const url = new URL(window.location.href);
    const invitationToken = (_a = url.searchParams.get('invitationToken')) !== null && _a !== void 0 ? _a : '';
    const { inviteTokenError } = (0,formik_esm_baae0afb.a4)(({ inviteTokenError }) => ({ inviteTokenError }));
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const { fields, formConfig } = useSignupForm({ t, invitationToken });
    const redirectToLogin = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        onRedirectTo(loginUrl);
    }, [onRedirectTo, loginUrl]);
    if (!firstLoad && !allowSignUps) {
        redirectToLogin();
        return null;
    }
    const components = FronteggApp_35f1a2b2.r.exports.useMemo(() => {
        if (inviteTokenError) {
            return FronteggApp_35f1a2b2.R.createElement(TenantInvitationFailed, { variant: "signup", t: t });
        }
        switch (stage) {
            case redux_store/* SignUpStage.SignUpSuccess */.vb.SignUpSuccess:
                return FronteggApp_35f1a2b2.R.createElement(SignUpSuccess, { t: t, successRedirectUrl: userSignUpSuccessUrl });
            default:
                return (FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
                    FronteggApp_35f1a2b2.R.createElement(SignupPageTitle, { componentKey: 'title', componentKeys: ['userTitle', 'title'], title: oldT('title', { defaultValue: null }) || t('title') }),
                    FronteggApp_35f1a2b2.R.createElement(SignUpForm, { t: t, config: Object.assign(Object.assign({}, formConfig), { fields }) })));
        }
    }, [stage, inviteTokenError, fields, formConfig, t, oldT]);
    const { loginMessagePlacement, disclaimer } = (0,formik_esm_baae0afb.F)();
    return (FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        loginMessagePlacement === 'page' && FronteggApp_35f1a2b2.R.createElement(GoToLoginMessage, { t: t }),
        FronteggApp_35f1a2b2.R.createElement(BoxElement$1, null,
            FronteggApp_35f1a2b2.R.createElement(SignupContainer$1, { "data-test-id": "signup-page" }, components)),
        (disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.placement) === 'page' && stage === redux_store/* SignUpStage.SignUp */.vb.SignUp && FronteggApp_35f1a2b2.R.createElement(StyledContainer$1, null,
            FronteggApp_35f1a2b2.R.createElement(DisclaimerText, null))));
};

const SignupContainer = signupStyler(formik_esm_baae0afb.B)(({ theme }) => (Object.assign({}, theme.containerStyle)));
const StyledContainer = signupStyler(formik_esm_baae0afb.B)(({ theme }) => {
    var _a;
    return (Object.assign({}, (_a = theme.disclaimer) === null || _a === void 0 ? void 0 : _a.disclaimerContainerStyle));
});
const AccountSignUp = () => {
    const oldT = useT('signup');
    const t = useContextT('loginBox.signup.account');
    const { stage, firstLoad, allowSignUps } = (0,formik_esm_baae0afb.ag)();
    const { accountSignUpSuccessUrl, loginUrl } = (0,formik_esm_baae0afb.K)();
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const { fields, formConfig } = useSignupForm({ t });
    const redirectToLogin = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        onRedirectTo(loginUrl);
    }, [onRedirectTo, loginUrl]);
    if (!firstLoad && !allowSignUps) {
        redirectToLogin();
        return null;
    }
    const components = FronteggApp_35f1a2b2.r.exports.useMemo(() => {
        switch (stage) {
            case redux_store/* SignUpStage.SignUpSuccess */.vb.SignUpSuccess:
                return FronteggApp_35f1a2b2.R.createElement(SignUpSuccess, { t: t, successRedirectUrl: accountSignUpSuccessUrl });
            default:
                return (FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
                    FronteggApp_35f1a2b2.R.createElement(SignupPageTitle, { componentKey: 'title', componentKeys: ['accountTitle', 'title'], title: oldT('title', { defaultValue: null }) || t('title') }),
                    FronteggApp_35f1a2b2.R.createElement(SignUpForm, { t: t, config: Object.assign(Object.assign({}, formConfig), { fields }) })));
        }
    }, [stage, fields, formConfig, t, oldT]);
    const { loginMessagePlacement, disclaimer } = (0,formik_esm_baae0afb.F)();
    return (FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        loginMessagePlacement === 'page' && FronteggApp_35f1a2b2.R.createElement(GoToLoginMessage, { t: t }),
        FronteggApp_35f1a2b2.R.createElement(BoxElement$1, null,
            FronteggApp_35f1a2b2.R.createElement(SignupContainer, { "data-test-id": "signup-page" }, components)),
        (disclaimer === null || disclaimer === void 0 ? void 0 : disclaimer.placement) === 'page' && stage === redux_store/* SignUpStage.SignUp */.vb.SignUp && FronteggApp_35f1a2b2.R.createElement(StyledContainer, null,
            FronteggApp_35f1a2b2.R.createElement(DisclaimerText, null))));
};

const _SignUpPage = () => {
    const { invitationToken, loading } = useVerifyInviteToken();
    const Component = FronteggApp_35f1a2b2.r.exports.useMemo(() => {
        if (loading) {
            return PageLoader;
        }
        return invitationToken ? UserSignUp : AccountSignUp;
    }, [invitationToken, loading]);
    return FronteggApp_35f1a2b2.R.createElement(Component, null);
};
const SignUpPage = wrapPageWithoutBox(_SignUpPage, 'signup');

const resetPhoneNumberStyler = (0,formik_esm_baae0afb.j)();
const ResetPhoneNumberPageTitle = BoxTitle;
const VerifyPhoneNumberPageTitle = BoxTitle;
const VerifyPhoneNumberPageMessage = BoxMessage;
const ChangePhoneNumberPageTitle = BoxTitle;
const ChangePhoneNumberPageMessage = BoxMessage;

const EmailField = () => {
    const t = useT('resetPhoneNumber');
    const [fieldProps, { error, touched }] = (0,formik_esm_baae0afb.at)('email');
    return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.I, Object.assign({ autoFocus: true }, fieldProps, { onChange: fieldProps.onChange, error: !!error && touched, errorMessage: error, name: 'email', placeholder: t('emailInputPlaceholder'), label: t('emailInputLabel'), "data-test-id": 'email-box' })));
};
const ResetPhoneNumberForm = () => {
    const t = useT('resetPhoneNumber');
    const { email } = (0,formik_esm_baae0afb.a4)();
    const { error, loading } = (0,formik_esm_baae0afb.a5)();
    const { resetPhoneNumber } = (0,formik_esm_baae0afb.ah)();
    const initialValues = FronteggApp_35f1a2b2.r.exports.useMemo(() => ({ email: email !== null && email !== void 0 ? email : '' }), [email]);
    const onRedirectTo = (0,formik_esm_baae0afb.Q)();
    const { loginUrl } = (0,formik_esm_baae0afb.K)();
    const { resetLoginState } = (0,formik_esm_baae0afb.V)();
    const validationSchema = FronteggApp_35f1a2b2.r.exports.useMemo(() => (0,formik_esm_baae0afb.ab)({
        email: (0,formik_esm_baae0afb.ae)(t('emailMustBeValid'), t('emailIsRequired')),
    }), [t, email]);
    const formikProps = {
        onSubmit: ({ email }) => new Promise((resolve, reject) => {
            const callback = (0,formik_esm_baae0afb.aH)(resolve, reject);
            resetPhoneNumber({ email, callback });
        }),
        initialValues,
        validationSchema,
    };
    const handleBackToLogin = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        resetLoginState();
        onRedirectTo(loginUrl);
    }, [loginUrl, onRedirectTo]);
    return FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        FronteggApp_35f1a2b2.R.createElement(ResetPhoneNumberPageTitle, { componentKey: 'resetPhoneNumberTitle', title: t('resetPhoneNumberTitle') }),
        FronteggApp_35f1a2b2.R.createElement(FromWrapper, Object.assign({}, formikProps), ({ isValid }) => {
            return FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
                FronteggApp_35f1a2b2.R.createElement(EmailField, null),
                error && FronteggApp_35f1a2b2.R.createElement(LoginErrorMessage, { "data-test-id": "reset-phone-number-form_error" }, error),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.l, { sx: { mt: 4 }, className: 'fe-primary-btn', disabled: loading || !isValid, fullWidth: true, color: "primary", loading: loading, "data-test-id": "submit-btn" }, t('continue')),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.B, { textAlign: "center", mt: 4 },
                    FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.L, { "data-test-id": "back-to-login-btn", onClick: handleBackToLogin }, t('backToLogin'))));
        }));
};

const VerifyResetPhoneNumberForm = () => {
    const t = useT('resetPhoneNumber');
    const { resetPhoneNumber, verifyResetPhoneNumber } = (0,formik_esm_baae0afb.ah)();
    const { loading, error, resetPhoneNumberToken } = (0,formik_esm_baae0afb.a5)();
    const handleSubmit = FronteggApp_35f1a2b2.r.exports.useCallback(({ token: code }) => {
        verifyResetPhoneNumber({ code, resetPhoneNumberToken: resetPhoneNumberToken !== null && resetPhoneNumberToken !== void 0 ? resetPhoneNumberToken : '' });
    }, [verifyResetPhoneNumber, resetPhoneNumberToken]);
    const handleResend = FronteggApp_35f1a2b2.r.exports.useCallback((values) => {
        resetPhoneNumber(values);
    }, [resetPhoneNumber]);
    return FronteggApp_35f1a2b2.R.createElement(LoginWithOTC, { loading: loading, error: error, onSubmit: handleSubmit, onResendCode: handleResend, header: FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
            FronteggApp_35f1a2b2.R.createElement(VerifyPhoneNumberPageTitle, { componentKey: 'verifyResetPhoneNumberTitle', title: t('resetPhoneOtcTitle') }),
            FronteggApp_35f1a2b2.R.createElement(VerifyPhoneNumberPageMessage, { componentKey: 'verifyResetPhoneNumberTitleStyle', message: t('resetPhoneOtcMessage') })) });
};

const PhoneField = () => {
    const t = useT('signup');
    const [fieldProps, { error, touched }] = (0,formik_esm_baae0afb.at)('phoneNumber');
    return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.I, Object.assign({}, fieldProps, { error: !!error && touched, errorMessage: error, autoComplete: 'tel', name: 'phoneNumber', label: t('phoneInputLabel'), placeholder: t('phoneInputPlaceholder'), "data-test-id": 'phone-number-box' })));
};
const ChangePhoneNumberForm = () => {
    const t = useT('resetPhoneNumber');
    const { email } = (0,formik_esm_baae0afb.a4)();
    const { changePhoneNumber } = (0,formik_esm_baae0afb.ah)();
    const { changePhoneNumberToken, error, loading } = (0,formik_esm_baae0afb.a5)();
    const initialValues = FronteggApp_35f1a2b2.r.exports.useMemo(() => ({ phoneNumber: '', recaptchaToken: '' }), []);
    const recaptchaRef = FronteggApp_35f1a2b2.R.createRef();
    const [hideRecaptcha] = useHideRecaptcha();
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        if (recaptchaRef.current && !loading) {
            recaptchaRef.current.execute();
        }
    }, [loading, recaptchaRef]);
    const validationSchema = FronteggApp_35f1a2b2.r.exports.useMemo(() => (0,formik_esm_baae0afb.ab)({
        phoneNumber: (0,formik_esm_baae0afb.ai)(t('phoneIsRequired'), t('phoneIsInvalid')),
    }), [t]);
    const formikProps = {
        onSubmit: ({ phoneNumber, recaptchaToken }) => {
            const recaptchaElement = document.getElementsByClassName('grecaptcha-badge')[0];
            const callback = () => hideRecaptcha(recaptchaElement);
            changePhoneNumber({ email: email !== null && email !== void 0 ? email : '', recaptchaToken, phoneNumber, changePhoneNumberToken: changePhoneNumberToken !== null && changePhoneNumberToken !== void 0 ? changePhoneNumberToken : '', callback });
        },
        initialValues,
        validationSchema,
    };
    return FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
        FronteggApp_35f1a2b2.R.createElement(ChangePhoneNumberPageTitle, { componentKey: "changePhoneNumberTitle", title: t('changePhoneNumberTitle') }),
        FronteggApp_35f1a2b2.R.createElement(ChangePhoneNumberPageMessage, { componentKey: "changePhoneNumberMessageStyle", message: t('changePhoneNumberMessage') }),
        FronteggApp_35f1a2b2.R.createElement(FromWrapper, Object.assign({}, formikProps), ({ isValid }) => {
            return FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Fragment, null,
                FronteggApp_35f1a2b2.R.createElement(PhoneField, null),
                error && FronteggApp_35f1a2b2.R.createElement(LoginErrorMessage, { "data-test-id": "reset-phone-number-form_error" }, error),
                FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.l, { sx: { mt: 4 }, className: 'fe-primary-btn', disabled: loading || !isValid, fullWidth: true, color: "primary", loading: loading, "data-test-id": "submit-btn" }, t('continue')));
        }));
};

const ResetPhoneNumberContainer = resetPhoneNumberStyler(formik_esm_baae0afb.B)(({ theme }) => (Object.assign({}, theme.containerStyle)));
const ResetPhoneNumberPage$1 = () => {
    const { step } = (0,formik_esm_baae0afb.a5)();
    let components;
    if (step === redux_store/* ResetPhoneNumberStep.ResetPhoneNumber */.Z$.ResetPhoneNumber) {
        components = FronteggApp_35f1a2b2.R.createElement(ResetPhoneNumberForm, null);
    }
    else if (step === redux_store/* ResetPhoneNumberStep.VerifyResetPhoneNumber */.Z$.VerifyResetPhoneNumber) {
        components = FronteggApp_35f1a2b2.R.createElement(VerifyResetPhoneNumberForm, null);
    }
    else {
        components = FronteggApp_35f1a2b2.R.createElement(ChangePhoneNumberForm, null);
    }
    return FronteggApp_35f1a2b2.R.createElement(ResetPhoneNumberContainer, { "data-test-id": "reset-phone-number-form" }, components);
};

const ResetPhoneNumberPage = wrapPage(ResetPhoneNumberPage$1, 'resetPassword');

const getUri = (urlStrategy) => {
    if (urlStrategy === 'path') {
        return (window !== null && window !== void 0 ? window : document).location.pathname;
    }
    else {
        return ((window !== null && window !== void 0 ? window : document).location.hash || '#').substring(1);
    }
};
const Routes = ({ staticRoute }) => {
    const { isLoading } = (0,formik_esm_baae0afb.J)(({ isLoading }) => ({ isLoading }));
    const { basename = '', urlStrategy, hostedLoginBox } = (0,formik_esm_baae0afb.v)();
    const routes = (0,formik_esm_baae0afb.K)();
    const uriRef = FronteggApp_35f1a2b2.r.exports.useRef(getUri(urlStrategy));
    const [uri, setUri] = FronteggApp_35f1a2b2.r.exports.useState(getUri(urlStrategy));
    const onUriChanged = FronteggApp_35f1a2b2.r.exports.useCallback(() => {
        const uri = getUri(urlStrategy);
        if (uriRef.current !== uri) {
            uriRef.current = uri;
            setUri(uri);
        }
    }, [setUri, urlStrategy]);
    FronteggApp_35f1a2b2.r.exports.useEffect(() => {
        document.addEventListener('frontegg_onRedirectTo_fired', onUriChanged);
        window.addEventListener('popstate', onUriChanged);
        window.addEventListener('hashchange', onUriChanged, false);
        setInterval(onUriChanged, 50);
        return () => {
            window.removeEventListener('popstate', onUriChanged);
            window.removeEventListener('hashchange', onUriChanged);
        };
    }, [onUriChanged]);
    if (isLoading) {
        return FronteggApp_35f1a2b2.R.createElement(PageLoader, null);
    }
    const calculatedBasename = basename ? (basename.endsWith('/') ? basename.substring(0, basename.length - 1) : basename) : '';
    if (hostedLoginBox) {
        switch (staticRoute !== null && staticRoute !== void 0 ? staticRoute : uri) {
            case calculatedBasename + routes.hostedLoginRedirectUrl:
                return FronteggApp_35f1a2b2.R.createElement(HostedLoginPage, null);
            default:
                return null;
        }
    }
    switch (staticRoute !== null && staticRoute !== void 0 ? staticRoute : uri) {
        case calculatedBasename + routes.loginUrl:
            return FronteggApp_35f1a2b2.R.createElement(LoginPage, null);
        case calculatedBasename + routes.logoutUrl:
            return FronteggApp_35f1a2b2.R.createElement(LogoutPage, null);
        case calculatedBasename + routes.activateUrl:
            return FronteggApp_35f1a2b2.R.createElement(ActivateAccountPage, null);
        case calculatedBasename + routes.acceptInvitationUrl:
            return FronteggApp_35f1a2b2.R.createElement(AcceptInvitationPage, null);
        case calculatedBasename + routes.forgetPasswordUrl:
            return FronteggApp_35f1a2b2.R.createElement(ForgotPasswordPage, null);
        case calculatedBasename + routes.resetPhoneNumberUrl:
            return FronteggApp_35f1a2b2.R.createElement(ResetPhoneNumberPage, null);
        case calculatedBasename + routes.resetPasswordUrl:
            return FronteggApp_35f1a2b2.R.createElement(ResetPasswordPage, null);
        case calculatedBasename + routes.socialLoginCallbackUrl:
            return FronteggApp_35f1a2b2.R.createElement(SocialLoginsSuccess, null);
        case calculatedBasename + routes.signUpUrl:
            return FronteggApp_35f1a2b2.R.createElement(SignUpPage, null);
        case calculatedBasename + routes.oidcRedirectUrl:
            return FronteggApp_35f1a2b2.R.createElement(OidcLoginSuccess, null);
        case calculatedBasename + routes.samlCallbackUrl:
            return FronteggApp_35f1a2b2.R.createElement(SamlLoginSuccess, null);
        case calculatedBasename + routes.magicLinkCallbackUrl:
            return FronteggApp_35f1a2b2.R.createElement(MagicLinkCallbackPage, null);
    }
    return null;
};

const defaultTheme = 'modern';
const LoginBox = ({ injector, options }) => {
    var _a, _b;
    umd.ContextHolder.setOnRedirectTo(options.onRedirectTo);
    return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.S.Provider, { value: Object.assign(Object.assign({ iframeRendering: false, injector }, options), { themeOptions: (0,formik_esm_baae0afb.q)(defaultTheme, (_a = options.metadata) !== null && _a !== void 0 ? _a : {}, (_b = options.themeOptions) !== null && _b !== void 0 ? _b : {}, options), slotsContainer: injector.loginBoxContainer, rootEl: injector.loginBoxEl, renderByRoute: true }) },
        FronteggApp_35f1a2b2.R.createElement(App, null,
            FronteggApp_35f1a2b2.R.createElement(Routes, null))));
};
const LoginBoxPage = ({ injector, options, staticRoute, setThemeSetter, setStaticRouteSetter, }) => {
    var _a;
    const [themeOptions, setThemeOptions] = FronteggApp_35f1a2b2.r.exports.useState((0,formik_esm_baae0afb.q)(defaultTheme, {}, (_a = options.themeOptions) !== null && _a !== void 0 ? _a : {}));
    const [route, setRoute] = FronteggApp_35f1a2b2.r.exports.useState(staticRoute);
    // @ts-ignore
    setThemeSetter === null || setThemeSetter === void 0 ? void 0 : setThemeSetter((theme) => setThemeOptions((0,formik_esm_baae0afb.q)(defaultTheme, {}, theme !== null && theme !== void 0 ? theme : {})));
    setStaticRouteSetter === null || setStaticRouteSetter === void 0 ? void 0 : setStaticRouteSetter(setRoute);
    return (FronteggApp_35f1a2b2.R.createElement(formik_esm_baae0afb.S.Provider, { value: Object.assign(Object.assign({ injector, iframeRendering: false }, options), { themeOptions, slotsContainer: injector.loginBoxContainer, rootEl: injector.loginBoxEl, renderByRoute: true }) },
        FronteggApp_35f1a2b2.R.createElement(App, null,
            FronteggApp_35f1a2b2.R.createElement(Routes, { staticRoute: route }))));
};




/***/ }),

/***/ 81894:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AcceptInvitationStep": function() { return /* reexport */ redux_store/* AcceptInvitationStep */.Mr; },
  "ActivateAccountStep": function() { return /* reexport */ redux_store/* ActivateAccountStep */.M1; },
  "AdminPortal": function() { return /* reexport */ AdminPortal; },
  "AdminPortalRenderer": function() { return /* binding */ AdminPortalRenderer; },
  "ApiStateKeys": function() { return /* reexport */ redux_store/* ApiStateKeys */.GL; },
  "AppHolder": function() { return /* reexport */ AppHolder/* AppHolder */.V; },
  "AuthStrategyEnum": function() { return /* reexport */ redux_store/* AuthStrategyEnum */.lw; },
  "AuthenticationTypes": function() { return /* reexport */ redux_store/* AuthenticationTypes */.Xh; },
  "CheckoutDialog": function() { return /* reexport */ CheckoutDialog; },
  "ForgotPasswordStep": function() { return /* reexport */ redux_store/* ForgotPasswordStep */.M_; },
  "HostedLogin": function() { return /* reexport */ HostedLogin; },
  "LoginBoxRenderer": function() { return /* reexport */ LoginBoxRenderer; },
  "LoginFlow": function() { return /* reexport */ redux_store/* LoginFlow */.iP; },
  "LoginStep": function() { return /* reexport */ redux_store/* LoginStep */.Fh; },
  "MFAStep": function() { return /* reexport */ redux_store/* MFAStep */.bj; },
  "PaymentMethodType": function() { return /* reexport */ redux_store/* PaymentMethodType */.Lt; },
  "PaymentProvider": function() { return /* reexport */ redux_store/* PaymentProvider */.OH; },
  "QuickLoginStrategy": function() { return /* reexport */ redux_store/* QuickLoginStrategy */.mK; },
  "ResetPhoneNumberStep": function() { return /* reexport */ redux_store/* ResetPhoneNumberStep */.Z$; },
  "SSOStateKeys": function() { return /* reexport */ redux_store/* SSOStateKeys */.p1; },
  "SamlVendors": function() { return /* reexport */ redux_store/* SamlVendors */.pA; },
  "SignUpStage": function() { return /* reexport */ redux_store/* SignUpStage */.vb; },
  "SubscriptionCancellationPolicy": function() { return /* reexport */ redux_store/* SubscriptionCancellationPolicy */.oY; },
  "SubscriptionStatus": function() { return /* reexport */ redux_store/* SubscriptionStatus */.yh; },
  "TeamStateKeys": function() { return /* reexport */ redux_store/* TeamStateKeys */.DY; },
  "UserVeirifedOriginTypes": function() { return /* reexport */ redux_store/* UserVeirifedOriginTypes */.EJ; },
  "acceptInvitationActions": function() { return /* reexport */ redux_store/* acceptInvitationActions */.kX; },
  "acceptInvitationReducers": function() { return /* reexport */ redux_store/* acceptInvitationReducers */.YQ; },
  "acceptInvitationState": function() { return /* reexport */ redux_store/* acceptInvitationState */.CD; },
  "accountSettingsActions": function() { return /* reexport */ redux_store/* accountSettingsActions */.vc; },
  "accountSettingsReducers": function() { return /* reexport */ redux_store/* accountSettingsReducers */.wn; },
  "accountSettingsState": function() { return /* reexport */ redux_store/* accountSettingsState */.e3; },
  "actions": function() { return /* reexport */ redux_store/* actions */.Nw; },
  "activateAccountActions": function() { return /* reexport */ redux_store/* activateAccountActions */.pf; },
  "activateAccountReducers": function() { return /* reexport */ redux_store/* activateAccountReducers */.iJ; },
  "activateState": function() { return /* reexport */ redux_store/* activateState */.fA; },
  "all": function() { return /* reexport */ redux_store/* all */.$6; },
  "apiTokensActions": function() { return /* reexport */ redux_store/* apiTokensActions */.UY; },
  "apiTokensReducers": function() { return /* reexport */ redux_store/* apiTokensReducers */.Ol; },
  "apiTokensState": function() { return /* reexport */ redux_store/* apiTokensState */.HU; },
  "auditLogsActions": function() { return /* reexport */ redux_store/* auditLogsActions */.u1; },
  "auditLogsReducers": function() { return /* reexport */ redux_store/* auditLogsReducers */.cG; },
  "auditLogsState": function() { return /* reexport */ redux_store/* auditLogsState */.md; },
  "audits": function() { return /* reexport */ redux_store/* audits */.y5; },
  "auditsActions": function() { return /* reexport */ redux_store/* auditsActions */.iN; },
  "auditsInitialState": function() { return /* reexport */ redux_store/* auditsInitialState */.rH; },
  "auditsMetadataActions": function() { return /* reexport */ redux_store/* auditsMetadataActions */.oX; },
  "auditsMetadataReducers": function() { return /* reexport */ redux_store/* auditsMetadataReducers */.od; },
  "auditsMetadataState": function() { return /* reexport */ redux_store/* auditsMetadataState */.LE; },
  "auditsMockSagas": function() { return /* reexport */ redux_store/* auditsMockSagas */.It; },
  "auditsReducers": function() { return /* reexport */ redux_store/* auditsReducers */.nc; },
  "auditsSagas": function() { return /* reexport */ redux_store/* auditsSagas */.iW; },
  "auditsStoreName": function() { return /* reexport */ redux_store/* auditsStoreName */.e_; },
  "auth": function() { return /* reexport */ redux_store/* auth */.I8; },
  "authActions": function() { return /* reexport */ redux_store/* authActions */.YV; },
  "authInitialState": function() { return /* reexport */ redux_store/* authInitialState */.y7; },
  "authMockSagas": function() { return /* reexport */ redux_store/* authMockSagas */.Gw; },
  "authReducers": function() { return /* reexport */ redux_store/* authReducers */.Cp; },
  "authSagas": function() { return /* reexport */ redux_store/* authSagas */.MX; },
  "authStoreName": function() { return /* reexport */ redux_store/* authStoreName */.Y2; },
  "bindActionCreators": function() { return /* reexport */ redux_store/* bindActionCreators */.DE; },
  "call": function() { return /* reexport */ redux_store/* call */.RE; },
  "combineReducers": function() { return /* reexport */ redux_store/* combineReducers */.I0; },
  "configureStore": function() { return /* reexport */ redux_store/* configureStore */.xC; },
  "connectivity": function() { return /* reexport */ redux_store/* connectivity */.wF; },
  "connectivityActions": function() { return /* reexport */ redux_store/* connectivityActions */.W3; },
  "connectivityInitialState": function() { return /* reexport */ redux_store/* connectivityInitialState */.Bz; },
  "connectivityReducers": function() { return /* reexport */ redux_store/* connectivityReducers */.m5; },
  "connectivitySagas": function() { return /* reexport */ redux_store/* connectivitySagas */.CJ; },
  "connectivityStoreName": function() { return /* reexport */ redux_store/* connectivityStoreName */.S4; },
  "createFronteggStore": function() { return /* reexport */ redux_store/* createFronteggStore */.iv; },
  "createSagaMiddleware": function() { return /* reexport */ redux_store/* createSagaMiddleware */.l9; },
  "createSelector": function() { return /* reexport */ redux_store/* createSelector */.P1; },
  "createSlice": function() { return /* reexport */ redux_store/* createSlice */.oM; },
  "defaultItemsPerPage": function() { return /* reexport */ redux_store/* defaultItemsPerPage */.NS; },
  "defaultTheme": function() { return /* reexport */ defaultTheme; },
  "delay": function() { return /* reexport */ redux_store/* delay */.gw; },
  "forgotPasswordActions": function() { return /* reexport */ redux_store/* forgotPasswordActions */.ZK; },
  "forgotPasswordReducers": function() { return /* reexport */ redux_store/* forgotPasswordReducers */.Mc; },
  "forgotPasswordState": function() { return /* reexport */ redux_store/* forgotPasswordState */.j4; },
  "getDefaultMiddleware": function() { return /* reexport */ redux_store/* getDefaultMiddleware */.Bx; },
  "getThemeByName": function() { return /* reexport */ getThemeByName; },
  "initialState": function() { return /* reexport */ redux_store/* initialState */.E3; },
  "initialize": function() { return /* binding */ initialize; },
  "loginActions": function() { return /* reexport */ redux_store/* loginActions */.BK; },
  "loginReducers": function() { return /* reexport */ redux_store/* loginReducers */.fv; },
  "loginState": function() { return /* reexport */ redux_store/* loginState */.PH; },
  "mfaActions": function() { return /* reexport */ redux_store/* mfaActions */.rg; },
  "mfaReducers": function() { return /* reexport */ redux_store/* mfaReducers */.a4; },
  "mfaState": function() { return /* reexport */ redux_store/* mfaState */.Yb; },
  "profileActions": function() { return /* reexport */ redux_store/* profileActions */.ef; },
  "profileReducers": function() { return /* reexport */ redux_store/* profileReducers */.i1; },
  "profileState": function() { return /* reexport */ redux_store/* profileState */.rc; },
  "put": function() { return /* reexport */ redux_store/* put */.gz; },
  "reducer": function() { return /* reexport */ redux_store/* reducer */.I6; },
  "resetPhoneNumberActions": function() { return /* reexport */ redux_store/* resetPhoneNumberActions */.ng; },
  "resetPhoneNumberReducers": function() { return /* reexport */ redux_store/* resetPhoneNumberReducers */.TK; },
  "resetPhoneNumberState": function() { return /* reexport */ redux_store/* resetPhoneNumberState */.kd; },
  "rolesActions": function() { return /* reexport */ redux_store/* rolesActions */.$3; },
  "rolesReducers": function() { return /* reexport */ redux_store/* rolesReducers */.Az; },
  "rolesState": function() { return /* reexport */ redux_store/* rolesState */.ZX; },
  "sagas": function() { return /* reexport */ redux_store/* sagas */.vQ; },
  "securityPolicyActions": function() { return /* reexport */ redux_store/* securityPolicyActions */.yr; },
  "securityPolicyReducers": function() { return /* reexport */ redux_store/* securityPolicyReducers */._; },
  "securityPolicyState": function() { return /* reexport */ redux_store/* securityPolicyState */.SC; },
  "select": function() { return /* reexport */ redux_store/* select */.Ys; },
  "signUpActions": function() { return /* reexport */ redux_store/* signUpActions */.j0; },
  "signUpReducers": function() { return /* reexport */ redux_store/* signUpReducers */._A; },
  "signUpState": function() { return /* reexport */ redux_store/* signUpState */.GD; },
  "socialLoginState": function() { return /* reexport */ redux_store/* socialLoginState */.PG; },
  "socialLoginsActions": function() { return /* reexport */ redux_store/* socialLoginsActions */.ak; },
  "socialLoginsReducer": function() { return /* reexport */ redux_store/* socialLoginsReducer */.BP; },
  "ssoActions": function() { return /* reexport */ redux_store/* ssoActions */.E1; },
  "ssoReducers": function() { return /* reexport */ redux_store/* ssoReducers */.rw; },
  "ssoState": function() { return /* reexport */ redux_store/* ssoState */.Ku; },
  "storeName": function() { return /* reexport */ redux_store/* storeName */.tC; },
  "subscriptionActions": function() { return /* reexport */ redux_store/* subscriptionActions */.bP; },
  "subscriptionInitialState": function() { return /* reexport */ redux_store/* subscriptionInitialState */.pg; },
  "subscriptionReducers": function() { return /* reexport */ redux_store/* subscriptionReducers */.rj; },
  "subscriptionSagas": function() { return /* reexport */ redux_store/* subscriptionSagas */.Pu; },
  "subscriptionSagasMock": function() { return /* reexport */ redux_store/* subscriptionSagasMock */.dQ; },
  "subscriptions": function() { return /* reexport */ redux_store/* subscriptions */.Vt; },
  "subscriptionsStoreName": function() { return /* reexport */ redux_store/* subscriptionsStoreName */.PP; },
  "takeEvery": function() { return /* reexport */ redux_store/* takeEvery */.ib; },
  "takeLatest": function() { return /* reexport */ redux_store/* takeLatest */.Fm; },
  "teamActions": function() { return /* reexport */ redux_store/* teamActions */.L2; },
  "teamReducers": function() { return /* reexport */ redux_store/* teamReducers */.vy; },
  "teamState": function() { return /* reexport */ redux_store/* teamState */.ju; },
  "tenantsActions": function() { return /* reexport */ redux_store/* tenantsActions */.Q_; },
  "tenantsReducers": function() { return /* reexport */ redux_store/* tenantsReducers */.Y; },
  "tenantsState": function() { return /* reexport */ redux_store/* tenantsState */.Qg; },
  "vendor": function() { return /* reexport */ redux_store/* vendor */.UZ; },
  "vendorActions": function() { return /* reexport */ redux_store/* vendorActions */.Ne; },
  "vendorInitialState": function() { return /* reexport */ redux_store/* vendorInitialState */.JO; },
  "vendorReducers": function() { return /* reexport */ redux_store/* vendorReducers */.Kt; },
  "vendorSagas": function() { return /* reexport */ redux_store/* vendorSagas */.rv; },
  "vendorStoreName": function() { return /* reexport */ redux_store/* vendorStoreName */.wv; }
});

// EXTERNAL MODULE: ./node_modules/@frontegg/admin-portal/FronteggApp-35f1a2b2.js
var FronteggApp_35f1a2b2 = __webpack_require__(11277);
// EXTERNAL MODULE: ./node_modules/@frontegg/admin-portal/utils.js
var utils = __webpack_require__(95555);
// EXTERNAL MODULE: ./node_modules/@frontegg/admin-portal/AppHolder.js
var AppHolder = __webpack_require__(15501);
;// CONCATENATED MODULE: ./node_modules/@frontegg/admin-portal/AdminPortal.js


class AdminPortal {
    static show(name = 'default') {
        AppHolder/* AppHolder.getInstance */.V.getInstance(name).showAdminPortal();
    }
    static hide(name = 'default') {
        AppHolder/* AppHolder.getInstance */.V.getInstance(name).hideAdminPortal();
    }
}



;// CONCATENATED MODULE: ./node_modules/@frontegg/admin-portal/CheckoutDialog.js


class CheckoutDialog {
    static show(opts, name = 'default') {
        AppHolder/* AppHolder.getInstance */.V.getInstance(name).showCheckoutDialog(opts);
    }
    static hide(name = 'default') {
        AppHolder/* AppHolder.getInstance */.V.getInstance(name).hideCheckoutDialog();
    }
}



// EXTERNAL MODULE: ./node_modules/@frontegg/redux-store/index.js + 28 modules
var redux_store = __webpack_require__(5850);
// EXTERNAL MODULE: ./node_modules/@frontegg/rest-api/dist/umd/index.js
var umd = __webpack_require__(32205);
;// CONCATENATED MODULE: ./node_modules/@frontegg/admin-portal/HostedLogin.js




class HostedLogin {
    static setAuthentication(isAuthenticated, accessToken, user, appName = 'default') {
        const app = AppHolder/* AppHolder.getInstance */.V.getInstance(appName);
        if (isAuthenticated && accessToken) {
            umd.ContextHolder.setAccessToken(accessToken);
            umd.ContextHolder.setUser(Object.assign(Object.assign({}, user), { accessToken }));
            app.store.dispatch(redux_store/* authActions.setState */.YV.setState({
                isLoading: false,
                isAuthenticated,
                user,
            }));
            app.store.dispatch(redux_store/* authActions.loadTenants */.YV.loadTenants());
        }
        else {
            umd.ContextHolder.setAccessToken(null);
            umd.ContextHolder.setUser(null);
            app.store.dispatch(redux_store/* authActions.setState */.YV.setState({
                isLoading: false,
                isAuthenticated: false,
                user: null,
            }));
        }
    }
}



// EXTERNAL MODULE: ./node_modules/@frontegg/types/index.js
var types = __webpack_require__(36539);
// EXTERNAL MODULE: ./node_modules/@frontegg/admin-portal/index-861a4b16.js + 5 modules
var index_861a4b16 = __webpack_require__(51261);
// EXTERNAL MODULE: ./node_modules/@frontegg/admin-portal/formik.esm-baae0afb.js
var formik_esm_baae0afb = __webpack_require__(25618);
;// CONCATENATED MODULE: ./node_modules/@frontegg/admin-portal/LoginBoxRenderer.js










const defaultTheme = 'modern';
const getThemeByName = (name) => { var _a; return (_a = formik_esm_baae0afb.t[name]) !== null && _a !== void 0 ? _a : formik_esm_baae0afb.t[defaultTheme]; };
class LoginBoxRenderer {
    constructor(name, themeOptions, store, appOptions) {
        this.setRoute = () => { };
        this.themeOptions = {};
        const contextOptions = { baseUrl: 'preview' };
        this.store = store !== null && store !== void 0 ? store : (0,redux_store/* createFronteggStore */.iv)({ context: contextOptions }, this, true, undefined, undefined, true);
        this.options = Object.assign({ themeOptions, iframeRendering: true, metadata: {}, previewMode: true, builderMode: true, store: this.store, contextOptions, onRedirectTo: () => {
                console.debug('path');
            } }, appOptions);
        this.app = new FronteggApp_35f1a2b2.F(this.options, name, true);
        types.Metadata.set({}, name);
    }
    render(loginBoxContainer) {
        let loginBoxEl = loginBoxContainer.querySelector('#root');
        if (!loginBoxEl) {
            loginBoxEl = loginBoxContainer.ownerDocument.createElement('div');
            loginBoxEl.setAttribute('id', 'root');
            loginBoxContainer.appendChild(loginBoxEl);
        }
        this.app.loginBoxContainer = loginBoxContainer;
        this.app.loginBoxEl = loginBoxEl;
        const setThemeSetter = (themeSetter) => {
            this.themeSetter = themeSetter;
        };
        const setStaticRouteSetter = (setStaticRoute) => {
            this.setRoute = setStaticRoute;
        };
        const loginBox = FronteggApp_35f1a2b2.R.createElement(index_861a4b16.LoginBoxPage, {
            options: this.options,
            injector: this.app,
            setThemeSetter,
            setStaticRouteSetter,
            staticRoute: '/account/login',
        });
        const wrapper = FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Suspense, { fallback: '' }, loginBox);
        FronteggApp_35f1a2b2.a.render(wrapper, loginBoxEl);
        this.app.loading = false;
    }
    unmount() {
        try {
            if (this.app.loginBoxEl) {
                FronteggApp_35f1a2b2.a.unmountComponentAtNode(this.app.loginBoxEl);
            }
        }
        catch (e) {
            console.error('Failed to unmount login box renderer', e);
        }
    }
    setTheme(themeOptions) {
        var _a;
        this.themeOptions = themeOptions;
        (_a = this.themeSetter) === null || _a === void 0 ? void 0 : _a.call(this, this.themeOptions);
    }
    setStaticRoute(staticRoute) {
        var _a;
        (_a = this.setRoute) === null || _a === void 0 ? void 0 : _a.call(this, staticRoute);
    }
    setStore(state) {
        this.store.dispatch({
            type: 'auth/setState',
            payload: state,
        });
    }
}



// EXTERNAL MODULE: ./node_modules/@frontegg/admin-portal/index-4c5b763f.js
var index_4c5b763f = __webpack_require__(88768);
;// CONCATENATED MODULE: ./node_modules/@frontegg/admin-portal/index.js

















class AdminPortalRenderer {
    constructor(name, themeOptions, store, appOptions) {
        this.setRoute = () => { };
        this.themeOptions = {};
        const contextOptions = { baseUrl: 'preview' };
        this.store = store !== null && store !== void 0 ? store : (0,redux_store/* createFronteggStore */.iv)({ context: contextOptions }, this, true, undefined, undefined, true);
        this.options = Object.assign({ themeOptions, iframeRendering: true, metadata: {}, previewMode: true, builderMode: true, store: this.store, contextOptions }, appOptions);
        this.app = new FronteggApp_35f1a2b2.F(this.options, name, true);
        types.Metadata.set({}, name);
    }
    render(adminPortalContainer) {
        let adminPortalEl = adminPortalContainer.querySelector('#root');
        if (!adminPortalEl) {
            adminPortalEl = adminPortalContainer.ownerDocument.createElement('div');
            adminPortalEl.setAttribute('id', 'root');
            adminPortalContainer.appendChild(adminPortalEl);
        }
        this.app.adminPortalContainer = adminPortalContainer;
        this.app.adminPortalEl = adminPortalEl;
        const setThemeSetter = (themeSetter) => {
            this.themeSetter = themeSetter;
        };
        const setStaticRouteSetter = (setStaticRoute) => {
            this.setRoute = setStaticRoute;
        };
        const adminPortal = FronteggApp_35f1a2b2.R.createElement(index_4c5b763f.AdminPortalPage, {
            options: this.options,
            injector: this.app,
            setThemeSetter,
            setStaticRouteSetter,
        });
        const wrapper = FronteggApp_35f1a2b2.R.createElement(FronteggApp_35f1a2b2.R.Suspense, { fallback: '' }, adminPortal);
        FronteggApp_35f1a2b2.a.render(wrapper, adminPortalEl);
        this.app.loading = false;
    }
    setStaticRoute(staticRoute) {
        var _a;
        (_a = this.setRoute) === null || _a === void 0 ? void 0 : _a.call(this, staticRoute);
    }
    unmount() {
        try {
            if (this.app.adminPortalEl) {
                FronteggApp_35f1a2b2.a.unmountComponentAtNode(this.app.adminPortalEl);
            }
        }
        catch (e) {
            console.error('Failed to unmount admin Portal renderer', e);
        }
    }
    setTheme(themeOptions) {
        var _a;
        this.themeOptions = themeOptions;
        (_a = this.themeSetter) === null || _a === void 0 ? void 0 : _a.call(this, this.themeOptions);
    }
}

const initialize = (options, name = 'default') => {
    var _a;
    const createdApp = new FronteggApp_35f1a2b2.F(options, name);
    if (typeof document !== 'undefined') {
        if (!customElements.get('frontegg-app')) {
            class FronteggAppContainer extends HTMLElement {
                constructor() {
                    super(...arguments);
                    this.app = null;
                }
                static get observedAttributes() {
                    return ['app-name'];
                }
                connectedCallback() {
                    this.updateContent();
                }
                attributeChangedCallback(name, oldValue, newValue) {
                    if (name === 'app-name') {
                        if (oldValue === null) {
                            return;
                        }
                        if (oldValue === newValue) {
                            return;
                        }
                        const app = AppHolder/* AppHolder.getInstance */.V.getInstance(oldValue);
                        try {
                            FronteggApp_35f1a2b2.a.unmountComponentAtNode(app.adminPortalEl);
                            FronteggApp_35f1a2b2.a.unmountComponentAtNode(app.loginBoxEl);
                        }
                        catch (e) {
                            console.error('Failed to unmount frontegg app', e);
                        }
                        this.innerHTML = '';
                        if (newValue === null) {
                            this.remove();
                        }
                        else {
                            this.updateContent();
                        }
                    }
                    console.debug('attributeChangedCallback', name, oldValue, newValue);
                }
                updateContent() {
                    var _a;
                    const appName = (_a = this.getAttribute('app-name')) !== null && _a !== void 0 ? _a : 'default';
                    const app = AppHolder/* AppHolder.getInstance */.V.getInstance(appName);
                    if (app === null) {
                        throw Error(`FronteggApp not found for appName: '${appName}'`);
                    }
                    this.setAttribute('id', `frontegg-app-${app.name}`);
                    const adminPortalContainer = (0,utils/* createElement */.a)(this, 'div', { id: `frontegg-admin-portal-container-${app.name}` });
                    const loginBoxContainer = (0,utils/* createElement */.a)(this, 'div', { id: `frontegg-login-box-container-${app.name}` });
                    const checkoutDialogContainer = (0,utils/* createElement */.a)(this, 'div', { id: `frontegg-checkout-dialog-container-${app.name}` });
                    const adminBoxShadowEl = adminPortalContainer.attachShadow({ mode: 'open' });
                    const loginBoxShadowEl = loginBoxContainer.attachShadow({ mode: 'open' });
                    const checkoutDialogShadowEl = checkoutDialogContainer.attachShadow({ mode: 'open' });
                    const adminPortalEl = (0,utils/* createElement */.a)(adminBoxShadowEl, 'div', {
                        id: `frontegg-admin-portal-${app.name}`,
                        class: 'frontegg-root-content',
                    });
                    const loginBoxEl = (0,utils/* createElement */.a)(loginBoxShadowEl, 'div', {
                        id: `frontegg-login-box-${app.name}`,
                        class: 'frontegg-root-content',
                    });
                    const checkoutDialogEl = (0,utils/* createElement */.a)(checkoutDialogShadowEl, 'div', {
                        id: `frontegg-checkout-dialog-${app.name}`,
                        class: 'frontegg-root-content',
                    });
                    app.initContainers({ adminPortalEl, loginBoxEl, adminPortalContainer, loginBoxContainer, checkoutDialogContainer, checkoutDialogEl });
                }
            }
            customElements.define('frontegg-app', FronteggAppContainer);
        }
        (_a = document.querySelector(`frontegg-app[app-name="${createdApp.name}"]`)) === null || _a === void 0 ? void 0 : _a.remove();
        const element = document.createElement('frontegg-app');
        element.setAttribute('app-name', createdApp.name);
        document.body.appendChild(element);
    }
    return createdApp;
};




/***/ }),

/***/ 95555:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "K": function() { return /* binding */ formatName; },
/* harmony export */   "a": function() { return /* binding */ createElement; }
/* harmony export */ });
const formatName = (name) => name.replace(/\W+/g, ' ').split(/ |\B(?=[A-Z])/).map(word => word.toLowerCase()).join('');
const createElement = (container, type, attrs = {}) => {
    const el = document.createElement(type);
    Object.keys(attrs).forEach(key => el.setAttribute(key, attrs[key]));
    container.appendChild(el);
    return el;
};




/***/ }),

/***/ 38623:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", ({ value: true }));

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib = __webpack_require__(70655);
var React = __webpack_require__(67294);
var React__default = _interopDefault(React);
var adminPortal = __webpack_require__(81894);
var reactHooks = __webpack_require__(59122);
var restApi = __webpack_require__(32205);
var router = __webpack_require__(11163);
var types = __webpack_require__(36539);

var Connector = function (_a) {
    var _b;
    var router = _a.router, appName = _a.appName, props = tslib.__rest(_a, ["router", "appName"]);
    var isSSR = typeof window === 'undefined';
    // v6 or v5
    var baseName = (_b = props.basename) !== null && _b !== void 0 ? _b : router.basePath;
    var onRedirectTo = React.useCallback(function (_path, opts) {
        var path = _path;
        if (path.startsWith(baseName)) {
            path = path.substring(baseName.length);
        }
        if (opts === null || opts === void 0 ? void 0 : opts.preserveQueryParams) {
            path = "" + path + window.location.search;
        }
        if ((opts === null || opts === void 0 ? void 0 : opts.refresh) && !isSSR) {
            // @ts-ignore
            window.Cypress ? router.push(path) : (window.location.href = path);
        }
        else {
            (opts === null || opts === void 0 ? void 0 : opts.replace) ? router.replace(path) : router.push(path);
        }
    }, []);
    var app = React.useMemo(function () {
        var _a;
        try {
            return adminPortal.AppHolder.getInstance(appName !== null && appName !== void 0 ? appName : 'default');
        }
        catch (e) {
            return adminPortal.initialize(tslib.__assign(tslib.__assign({}, props), { basename: (_a = props.basename) !== null && _a !== void 0 ? _a : baseName, contextOptions: tslib.__assign({ requestCredentials: 'include' }, props.contextOptions), onRedirectTo: onRedirectTo }), appName !== null && appName !== void 0 ? appName : 'default');
        }
    }, [onRedirectTo]);
    restApi.ContextHolder.setOnRedirectTo(onRedirectTo);
    return React__default.createElement(reactHooks.FronteggStoreProvider, tslib.__assign({}, tslib.__assign(tslib.__assign({}, props), { app: app })), props.children);
};
var FronteggProvider = function (props) {
    var router$1 = router.useRouter();
    return (React__default.createElement(Connector, tslib.__assign({}, props, { router: router$1 }), props.children));
};

var AuthorizedContent = function (props) {
    var _a, _b;
    var isAuthorized = true; // Initially
    var user = reactHooks.useAuthUserOrNull();
    if (!(user === null || user === void 0 ? void 0 : user.superUser)) {
        if (props.requiredPermissions) {
            if (!(user === null || user === void 0 ? void 0 : user.permissions) || (user === null || user === void 0 ? void 0 : user.permissions.length) === 0) {
                isAuthorized = false;
            }
            var _loop_1 = function (permission) {
                if (!((_a = user === null || user === void 0 ? void 0 : user.permissions) === null || _a === void 0 ? void 0 : _a.find(function (_a) {
                    var key = _a.key;
                    return key === permission;
                }))) {
                    isAuthorized = false;
                }
            };
            for (var _i = 0, _c = props.requiredPermissions; _i < _c.length; _i++) {
                var permission = _c[_i];
                _loop_1(permission);
            }
        }
        if (props.requiredRoles) {
            if (!(user === null || user === void 0 ? void 0 : user.roles) || (user === null || user === void 0 ? void 0 : user.roles.length) === 0) {
                isAuthorized = false;
            }
            var _loop_2 = function (role) {
                if (!((_b = user === null || user === void 0 ? void 0 : user.roles) === null || _b === void 0 ? void 0 : _b.find(function (_a) {
                    var key = _a.key;
                    return key === role;
                }))) {
                    isAuthorized = false;
                }
            };
            for (var _d = 0, _e = props.requiredRoles; _d < _e.length; _d++) {
                var role = _e[_d];
                _loop_2(role);
            }
        }
    }
    if (typeof props.render === 'function') {
        return React__default.createElement(React__default.Fragment, null, props.render(isAuthorized));
    }
    return isAuthorized ? React__default.createElement(React__default.Fragment, null, props.children) : null;
};

Object.keys(reactHooks).forEach(function (k) {
  if (k !== 'default') Object.defineProperty(exports, k, {
    enumerable: true,
    get: function () {
      return reactHooks[k];
    }
  });
});
Object.keys(types).forEach(function (k) {
  if (k !== 'default') Object.defineProperty(exports, k, {
    enumerable: true,
    get: function () {
      return types[k];
    }
  });
});
Object.defineProperty(exports, "AdminPortal", ({
  enumerable: true,
  get: function () {
    return adminPortal.AdminPortal;
  }
}));
exports.AuthorizedContent = AuthorizedContent;
exports.Connector = Connector;
exports.FronteggProvider = FronteggProvider;
//# sourceMappingURL=index.js.map


/***/ }),

/***/ 59122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "FronteggStoreContext": function() { return /* reexport */ FronteggStoreContext; },
  "FronteggStoreProvider": function() { return /* binding */ FronteggStoreProvider; },
  "Provider": function() { return /* reexport */ components_Provider; },
  "ShadowDomContext": function() { return /* reexport */ ShadowDomContext; },
  "connectAdvanced": function() { return /* reexport */ connectAdvanced_connectAdvanced; },
  "reloadProfileIfNeeded": function() { return /* reexport */ reloadProfileIfNeeded; },
  "shallowEqual": function() { return /* reexport */ shallowEqual_shallowEqual; },
  "useAcceptInvitationActions": function() { return /* reexport */ useAcceptInvitationActions; },
  "useAcceptInvitationState": function() { return /* reexport */ useAcceptInvitationState; },
  "useActivateAccountActions": function() { return /* reexport */ useActivateAccountActions; },
  "useActivateAccountState": function() { return /* reexport */ useActivateAccountState; },
  "useApiTokensActions": function() { return /* reexport */ useApiTokensActions; },
  "useApiTokensState": function() { return /* reexport */ useApiTokensState; },
  "useAuditLogsActions": function() { return /* reexport */ useAuditLogsActions; },
  "useAuditLogsState": function() { return /* reexport */ useAuditLogsState; },
  "useAuditsActions": function() { return /* reexport */ useAuditsActions; },
  "useAuditsMetadataActions": function() { return /* reexport */ useAuditsMetadataActions; },
  "useAuditsMetadataState": function() { return /* reexport */ useAuditsMetadataState; },
  "useAuditsState": function() { return /* reexport */ useAuditsState; },
  "useAuth": function() { return /* reexport */ useAuth; },
  "useAuthActions": function() { return /* reexport */ useAuthActions; },
  "useAuthRoutes": function() { return /* reexport */ useAuthRoutes; },
  "useAuthTeamActions": function() { return /* reexport */ useAuthTeamActions; },
  "useAuthTeamState": function() { return /* reexport */ useAuthTeamState; },
  "useAuthUser": function() { return /* reexport */ useAuthUser; },
  "useAuthUserOrNull": function() { return /* reexport */ useAuthUserOrNull; },
  "useBillingInformation": function() { return /* reexport */ useBillingInformation; },
  "useBillingInformationActions": function() { return /* reexport */ useBillingInformationActions; },
  "useCheckout": function() { return /* reexport */ useCheckout; },
  "useCheckoutActions": function() { return /* reexport */ useCheckoutActions; },
  "useConnectivityActions": function() { return /* reexport */ useConnectivityActions; },
  "useConnectivityState": function() { return /* reexport */ useConnectivityState; },
  "useDispatch": function() { return /* reexport */ FronteggStoreContext_d6c3b684_useDispatch; },
  "useForgotPasswordActions": function() { return /* reexport */ useForgotPasswordActions; },
  "useForgotPasswordState": function() { return /* reexport */ useForgotPasswordState; },
  "useInvoices": function() { return /* reexport */ useInvoices; },
  "useInvoicesActions": function() { return /* reexport */ useInvoicesActions; },
  "useIsAuthenticated": function() { return /* reexport */ useIsAuthenticated; },
  "useLoginActions": function() { return /* reexport */ useLoginActions; },
  "useLoginState": function() { return /* reexport */ useLoginState; },
  "useLoginWithRedirect": function() { return /* reexport */ useLoginWithRedirect; },
  "useMfaActions": function() { return /* reexport */ useMfaActions; },
  "useMfaState": function() { return /* reexport */ useMfaState; },
  "useOnRedirectTo": function() { return /* reexport */ useOnRedirectTo; },
  "usePaymentMethod": function() { return /* reexport */ usePaymentMethod; },
  "usePaymentMethodActions": function() { return /* reexport */ usePaymentMethodActions; },
  "usePaymentProvider": function() { return /* reexport */ usePaymentProvider; },
  "usePaymentProviderActions": function() { return /* reexport */ usePaymentProviderActions; },
  "usePlans": function() { return /* reexport */ usePlans; },
  "usePlansActions": function() { return /* reexport */ usePlansActions; },
  "useProfileActions": function() { return /* reexport */ useProfileActions; },
  "useProfileState": function() { return /* reexport */ useProfileState; },
  "usePublicAuthStrategiesPolicySettings": function() { return /* reexport */ usePublicAuthStrategiesPolicySettings; },
  "usePublicPolicySettings": function() { return /* reexport */ usePublicPolicySettings; },
  "useResetPhoneNumberActions": function() { return /* reexport */ useResetPhoneNumberActions; },
  "useResetPhoneNumberState": function() { return /* reexport */ useResetPhoneNumberState; },
  "useRolesActions": function() { return /* reexport */ useRolesActions; },
  "useRolesState": function() { return /* reexport */ useRolesState; },
  "useSSOActions": function() { return /* reexport */ useSSOActions; },
  "useSSOState": function() { return /* reexport */ useSSOState; },
  "useSecurityPolicyActions": function() { return /* reexport */ useSecurityPolicyActions; },
  "useSecurityPolicyState": function() { return /* reexport */ useSecurityPolicyState; },
  "useSelector": function() { return /* reexport */ FronteggStoreContext_d6c3b684_useSelector; },
  "useShadowDom": function() { return /* reexport */ useShadowDom; },
  "useSignUpActions": function() { return /* reexport */ useSignUpActions; },
  "useSignUpState": function() { return /* reexport */ useSignUpState; },
  "useSocialLoginActions": function() { return /* reexport */ useSocialLoginActions; },
  "useSocialLoginState": function() { return /* reexport */ useSocialLoginState; },
  "useStore": function() { return /* reexport */ useStore; },
  "useStripeActions": function() { return /* reexport */ useStripeActions; },
  "useStripeState": function() { return /* reexport */ useStripeState; },
  "useSubscription": function() { return /* reexport */ useSubscription; },
  "useSubscriptionActions": function() { return /* reexport */ useSubscriptionActions; },
  "useSubscriptionCancellation": function() { return /* reexport */ useSubscriptionCancellation; },
  "useSubscriptionRenewal": function() { return /* reexport */ useSubscriptionRenewal; },
  "useTenantsActions": function() { return /* reexport */ useTenantsActions; },
  "useTenantsState": function() { return /* reexport */ useTenantsState; },
  "useVendorActions": function() { return /* reexport */ useVendorActions; },
  "useVendorState": function() { return /* reexport */ useVendorState; }
});

// EXTERNAL MODULE: ./node_modules/@frontegg/redux-store/index.js + 28 modules
var redux_store = __webpack_require__(5850);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Context.js

var ReactReduxContext = /*#__PURE__*/react.createContext(null);

if (false) {}

/* harmony default export */ var Context = ((/* unused pure expression or super */ null && (ReactReduxContext)));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/batch.js
// Default to a dummy "batch" implementation that just runs the callback
function defaultNoopBatch(callback) {
  callback();
}

var batch = defaultNoopBatch; // Allow injecting another batching function later

var setBatch = function setBatch(newBatch) {
  return batch = newBatch;
}; // Supply a getter just to skip dealing with ESM bindings

var getBatch = function getBatch() {
  return batch;
};
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
 // encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants

function createListenerCollection() {
  var batch = getBatch();
  var first = null;
  var last = null;
  return {
    clear: function clear() {
      first = null;
      last = null;
    },
    notify: function notify() {
      batch(function () {
        var listener = first;

        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get: function get() {
      var listeners = [];
      var listener = first;

      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }

      return listeners;
    },
    subscribe: function subscribe(callback) {
      var isSubscribed = true;
      var listener = last = {
        callback: callback,
        next: null,
        prev: last
      };

      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first = listener;
      }

      return function unsubscribe() {
        if (!isSubscribed || first === null) return;
        isSubscribed = false;

        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last = listener.prev;
        }

        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first = listener.next;
        }
      };
    }
  };
}

var nullListeners = {
  notify: function notify() {},
  get: function get() {
    return [];
  }
};
function createSubscription(store, parentSub) {
  var unsubscribe;
  var listeners = nullListeners;

  function addNestedSub(listener) {
    trySubscribe();
    return listeners.subscribe(listener);
  }

  function notifyNestedSubs() {
    listeners.notify();
  }

  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }

  function isSubscribed() {
    return Boolean(unsubscribe);
  }

  function trySubscribe() {
    if (!unsubscribe) {
      unsubscribe = parentSub ? parentSub.addNestedSub(handleChangeWrapper) : store.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }

  function tryUnsubscribe() {
    if (unsubscribe) {
      unsubscribe();
      unsubscribe = undefined;
      listeners.clear();
      listeners = nullListeners;
    }
  }

  var subscription = {
    addNestedSub: addNestedSub,
    notifyNestedSubs: notifyNestedSubs,
    handleChangeWrapper: handleChangeWrapper,
    isSubscribed: isSubscribed,
    trySubscribe: trySubscribe,
    tryUnsubscribe: tryUnsubscribe,
    getListeners: function getListeners() {
      return listeners;
    }
  };
  return subscription;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/useIsomorphicLayoutEffect.js
 // React currently throws a warning when using useLayoutEffect on the server.
// To get around it, we can conditionally useEffect on the server (no-op) and
// useLayoutEffect in the browser. We need useLayoutEffect to ensure the store
// subscription callback always has the selector from the latest render commit
// available, otherwise a store update may happen between render and the effect,
// which may cause missed updates; we also must ensure the store subscription
// is created synchronously, otherwise a store update may occur before the
// subscription is created and an inconsistent state may be observed

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? react.useLayoutEffect : react.useEffect;
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js






function Provider(_ref) {
  var store = _ref.store,
      context = _ref.context,
      children = _ref.children;
  var contextValue = (0,react.useMemo)(function () {
    var subscription = createSubscription(store);
    return {
      store: store,
      subscription: subscription
    };
  }, [store]);
  var previousState = (0,react.useMemo)(function () {
    return store.getState();
  }, [store]);
  useIsomorphicLayoutEffect(function () {
    var subscription = contextValue.subscription;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();

    if (previousState !== store.getState()) {
      subscription.notifyNestedSubs();
    }

    return function () {
      subscription.tryUnsubscribe();
      subscription.onStateChange = null;
    };
  }, [contextValue, previousState]);
  var Context = context || ReactReduxContext;
  return /*#__PURE__*/react.createElement(Context.Provider, {
    value: contextValue
  }, children);
}

if (false) {}

/* harmony default export */ var components_Provider = (Provider);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/react-redux/node_modules/react-is/index.js
var react_is = __webpack_require__(72973);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/components/connectAdvanced.js


var _excluded = ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef", "forwardRef", "context"],
    _excluded2 = ["reactReduxForwardedRef"];





 // Define some constant arrays just to avoid re-creating these

var EMPTY_ARRAY = [];
var NO_SUBSCRIPTION_ARRAY = [null, null];

var stringifyComponent = function stringifyComponent(Comp) {
  try {
    return JSON.stringify(Comp);
  } catch (err) {
    return String(Comp);
  }
};

function storeStateUpdatesReducer(state, action) {
  var updateCount = state[1];
  return [action.payload, updateCount + 1];
}

function useIsomorphicLayoutEffectWithArgs(effectFunc, effectArgs, dependencies) {
  useIsomorphicLayoutEffect(function () {
    return effectFunc.apply(void 0, effectArgs);
  }, dependencies);
}

function captureWrapperProps(lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs) {
  // We want to capture the wrapper props and child props we used for later comparisons
  lastWrapperProps.current = wrapperProps;
  lastChildProps.current = actualChildProps;
  renderIsScheduled.current = false; // If the render was from a store update, clear out that reference and cascade the subscriber update

  if (childPropsFromStoreUpdate.current) {
    childPropsFromStoreUpdate.current = null;
    notifyNestedSubs();
  }
}

function subscribeUpdates(shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch) {
  // If we're not subscribed to the store, nothing to do here
  if (!shouldHandleStateChanges) return; // Capture values for checking if and when this component unmounts

  var didUnsubscribe = false;
  var lastThrownError = null; // We'll run this callback every time a store subscription update propagates to this component

  var checkForUpdates = function checkForUpdates() {
    if (didUnsubscribe) {
      // Don't run stale listeners.
      // Redux doesn't guarantee unsubscriptions happen until next dispatch.
      return;
    }

    var latestStoreState = store.getState();
    var newChildProps, error;

    try {
      // Actually run the selector with the most recent store state and wrapper props
      // to determine what the child props should be
      newChildProps = childPropsSelector(latestStoreState, lastWrapperProps.current);
    } catch (e) {
      error = e;
      lastThrownError = e;
    }

    if (!error) {
      lastThrownError = null;
    } // If the child props haven't changed, nothing to do here - cascade the subscription update


    if (newChildProps === lastChildProps.current) {
      if (!renderIsScheduled.current) {
        notifyNestedSubs();
      }
    } else {
      // Save references to the new child props.  Note that we track the "child props from store update"
      // as a ref instead of a useState/useReducer because we need a way to determine if that value has
      // been processed.  If this went into useState/useReducer, we couldn't clear out the value without
      // forcing another re-render, which we don't want.
      lastChildProps.current = newChildProps;
      childPropsFromStoreUpdate.current = newChildProps;
      renderIsScheduled.current = true; // If the child props _did_ change (or we caught an error), this wrapper component needs to re-render

      forceComponentUpdateDispatch({
        type: 'STORE_UPDATED',
        payload: {
          error: error
        }
      });
    }
  }; // Actually subscribe to the nearest connected ancestor (or store)


  subscription.onStateChange = checkForUpdates;
  subscription.trySubscribe(); // Pull data from the store after first render in case the store has
  // changed since we began.

  checkForUpdates();

  var unsubscribeWrapper = function unsubscribeWrapper() {
    didUnsubscribe = true;
    subscription.tryUnsubscribe();
    subscription.onStateChange = null;

    if (lastThrownError) {
      // It's possible that we caught an error due to a bad mapState function, but the
      // parent re-rendered without this component and we're about to unmount.
      // This shouldn't happen as long as we do top-down subscriptions correctly, but
      // if we ever do those wrong, this throw will surface the error in our tests.
      // In that case, throw the error from here so it doesn't get lost.
      throw lastThrownError;
    }
  };

  return unsubscribeWrapper;
}

var initStateUpdates = function initStateUpdates() {
  return [null, 0];
};

function connectAdvanced_connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
      export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
    Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
    Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      _ref2$forwardRef = _ref2.forwardRef,
      forwardRef = _ref2$forwardRef === void 0 ? false : _ref2$forwardRef,
      _ref2$context = _ref2.context,
      context = _ref2$context === void 0 ? ReactReduxContext : _ref2$context,
      connectOptions = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref2, _excluded);

  if (false) { var customStoreWarningMessage; }

  var Context = context;
  return function wrapWithConnect(WrappedComponent) {
    if (false) {}

    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = (0,esm_extends/* default */.Z)({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent
    });

    var pure = connectOptions.pure;

    function createChildSelector(store) {
      return selectorFactory(store.dispatch, selectorFactoryOptions);
    } // If we aren't running in "pure" mode, we don't want to memoize values.
    // To avoid conditionally calling hooks, we fall back to a tiny wrapper
    // that just executes the given callback immediately.


    var usePureOnlyMemo = pure ? react.useMemo : function (callback) {
      return callback();
    };

    function ConnectFunction(props) {
      var _useMemo = (0,react.useMemo)(function () {
        // Distinguish between actual "data" props that were passed to the wrapper component,
        // and values needed to control behavior (forwarded refs, alternate context instances).
        // To maintain the wrapperProps object reference, memoize this destructuring.
        var reactReduxForwardedRef = props.reactReduxForwardedRef,
            wrapperProps = (0,objectWithoutPropertiesLoose/* default */.Z)(props, _excluded2);

        return [props.context, reactReduxForwardedRef, wrapperProps];
      }, [props]),
          propsContext = _useMemo[0],
          reactReduxForwardedRef = _useMemo[1],
          wrapperProps = _useMemo[2];

      var ContextToUse = (0,react.useMemo)(function () {
        // Users may optionally pass in a custom context instance to use instead of our ReactReduxContext.
        // Memoize the check that determines which context instance we should use.
        return propsContext && propsContext.Consumer && (0,react_is.isContextConsumer)( /*#__PURE__*/react.createElement(propsContext.Consumer, null)) ? propsContext : Context;
      }, [propsContext, Context]); // Retrieve the store and ancestor subscription via context, if available

      var contextValue = (0,react.useContext)(ContextToUse); // The store _must_ exist as either a prop or in context.
      // We'll check to see if it _looks_ like a Redux store first.
      // This allows us to pass through a `store` prop that is just a plain value.

      var didStoreComeFromProps = Boolean(props.store) && Boolean(props.store.getState) && Boolean(props.store.dispatch);
      var didStoreComeFromContext = Boolean(contextValue) && Boolean(contextValue.store);

      if (false) {} // Based on the previous check, one of these must be true


      var store = didStoreComeFromProps ? props.store : contextValue.store;
      var childPropsSelector = (0,react.useMemo)(function () {
        // The child props selector needs the store reference as an input.
        // Re-create this selector whenever the store changes.
        return createChildSelector(store);
      }, [store]);

      var _useMemo2 = (0,react.useMemo)(function () {
        if (!shouldHandleStateChanges) return NO_SUBSCRIPTION_ARRAY; // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        // This Subscription's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.
        var subscription = createSubscription(store, didStoreComeFromProps ? null : contextValue.subscription); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.

        // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `subscription` will then be null. This can
        // probably be avoided if Subscription's listeners logic is changed to not call listeners
        // that have been unsubscribed in the  middle of the notification loop.
        var notifyNestedSubs = subscription.notifyNestedSubs.bind(subscription);
        return [subscription, notifyNestedSubs];
      }, [store, didStoreComeFromProps, contextValue]),
          subscription = _useMemo2[0],
          notifyNestedSubs = _useMemo2[1]; // Determine what {store, subscription} value should be put into nested context, if necessary,
      // and memoize that value to avoid unnecessary context updates.


      var overriddenContextValue = (0,react.useMemo)(function () {
        if (didStoreComeFromProps) {
          // This component is directly subscribed to a store from props.
          // We don't want descendants reading from this store - pass down whatever
          // the existing context value is from the nearest connected ancestor.
          return contextValue;
        } // Otherwise, put this component's subscription instance into context, so that
        // connected descendants won't update until after this component is done


        return (0,esm_extends/* default */.Z)({}, contextValue, {
          subscription: subscription
        });
      }, [didStoreComeFromProps, contextValue, subscription]); // We need to force this wrapper component to re-render whenever a Redux store update
      // causes a change to the calculated child component props (or we caught an error in mapState)

      var _useReducer = (0,react.useReducer)(storeStateUpdatesReducer, EMPTY_ARRAY, initStateUpdates),
          _useReducer$ = _useReducer[0],
          previousStateUpdateResult = _useReducer$[0],
          forceComponentUpdateDispatch = _useReducer[1]; // Propagate any mapState/mapDispatch errors upwards


      if (previousStateUpdateResult && previousStateUpdateResult.error) {
        throw previousStateUpdateResult.error;
      } // Set up refs to coordinate values between the subscription effect and the render logic


      var lastChildProps = (0,react.useRef)();
      var lastWrapperProps = (0,react.useRef)(wrapperProps);
      var childPropsFromStoreUpdate = (0,react.useRef)();
      var renderIsScheduled = (0,react.useRef)(false);
      var actualChildProps = usePureOnlyMemo(function () {
        // Tricky logic here:
        // - This render may have been triggered by a Redux store update that produced new child props
        // - However, we may have gotten new wrapper props after that
        // If we have new child props, and the same wrapper props, we know we should use the new child props as-is.
        // But, if we have new wrapper props, those might change the child props, so we have to recalculate things.
        // So, we'll use the child props from store update only if the wrapper props are the same as last time.
        if (childPropsFromStoreUpdate.current && wrapperProps === lastWrapperProps.current) {
          return childPropsFromStoreUpdate.current;
        } // TODO We're reading the store directly in render() here. Bad idea?
        // This will likely cause Bad Things (TM) to happen in Concurrent Mode.
        // Note that we do this because on renders _not_ caused by store updates, we need the latest store state
        // to determine what the child props should be.


        return childPropsSelector(store.getState(), wrapperProps);
      }, [store, previousStateUpdateResult, wrapperProps]); // We need this to execute synchronously every time we re-render. However, React warns
      // about useLayoutEffect in SSR, so we try to detect environment and fall back to
      // just useEffect instead to avoid the warning, since neither will run anyway.

      useIsomorphicLayoutEffectWithArgs(captureWrapperProps, [lastWrapperProps, lastChildProps, renderIsScheduled, wrapperProps, actualChildProps, childPropsFromStoreUpdate, notifyNestedSubs]); // Our re-subscribe logic only runs when the store/subscription setup changes

      useIsomorphicLayoutEffectWithArgs(subscribeUpdates, [shouldHandleStateChanges, store, subscription, childPropsSelector, lastWrapperProps, lastChildProps, renderIsScheduled, childPropsFromStoreUpdate, notifyNestedSubs, forceComponentUpdateDispatch], [store, subscription, childPropsSelector]); // Now that all that's done, we can finally try to actually render the child component.
      // We memoize the elements for the rendered child component as an optimization.

      var renderedWrappedComponent = (0,react.useMemo)(function () {
        return /*#__PURE__*/react.createElement(WrappedComponent, (0,esm_extends/* default */.Z)({}, actualChildProps, {
          ref: reactReduxForwardedRef
        }));
      }, [reactReduxForwardedRef, WrappedComponent, actualChildProps]); // If React sees the exact same element reference as last time, it bails out of re-rendering
      // that child, same as if it was wrapped in React.memo() or returned false from shouldComponentUpdate.

      var renderedChild = (0,react.useMemo)(function () {
        if (shouldHandleStateChanges) {
          // If this component is subscribed to store updates, we need to pass its own
          // subscription instance down to our descendants. That means rendering the same
          // Context instance, and putting a different value into the context.
          return /*#__PURE__*/react.createElement(ContextToUse.Provider, {
            value: overriddenContextValue
          }, renderedWrappedComponent);
        }

        return renderedWrappedComponent;
      }, [ContextToUse, renderedWrappedComponent, overriddenContextValue]);
      return renderedChild;
    } // If we're in "pure" mode, ensure our wrapper component only re-renders when incoming props have changed.


    var Connect = pure ? react.memo(ConnectFunction) : ConnectFunction;
    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = ConnectFunction.displayName = displayName;

    if (forwardRef) {
      var forwarded = react.forwardRef(function forwardConnectRef(props, ref) {
        return /*#__PURE__*/react.createElement(Connect, (0,esm_extends/* default */.Z)({}, props, {
          reactReduxForwardedRef: ref
        }));
      });
      forwarded.displayName = displayName;
      forwarded.WrappedComponent = WrappedComponent;
      return hoist_non_react_statics_cjs_default()(forwarded, WrappedComponent);
    }

    return hoist_non_react_statics_cjs_default()(Connect, WrappedComponent);
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/bindActionCreators.js
function bindActionCreators(actionCreators, dispatch) {
  var boundActionCreators = {};

  var _loop = function _loop(key) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = function () {
        return dispatch(actionCreator.apply(void 0, arguments));
      };
    }
  };

  for (var key in actionCreators) {
    _loop(key);
  }

  return boundActionCreators;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/wrapMapToProps.js

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
//
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
//
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) {}
      return props;
    };

    return proxy;
  };
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapDispatchToProps.js


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return bindActionCreators(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ var mapDispatchToProps = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapStateToProps.js

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ var mapStateToProps = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mergeProps.js


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return (0,esm_extends/* default */.Z)({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) {}
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ var mergeProps = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/connect.js


var connect_excluded = (/* unused pure expression or super */ null && (["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]));






/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? defaultMapStateToPropsFactories : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? defaultMapDispatchToPropsFactories : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? defaultMergePropsFactories : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? defaultSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = _objectWithoutPropertiesLoose(_ref3, connect_excluded);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ var connect = (/*#__PURE__*/(/* unused pure expression or super */ null && (createConnect())));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useReduxContext.js


/**
 * A hook to access the value of the `ReactReduxContext`. This is a low-level
 * hook that you should usually not need to call directly.
 *
 * @returns {any} the value of the `ReactReduxContext`
 *
 * @example
 *
 * import React from 'react'
 * import { useReduxContext } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const { store } = useReduxContext()
 *   return <div>{store.getState()}</div>
 * }
 */

function useReduxContext_useReduxContext() {
  var contextValue = (0,react.useContext)(ReactReduxContext);

  if (false) {}

  return contextValue;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useStore.js



/**
 * Hook factory, which creates a `useStore` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useStore` hook bound to the specified context.
 */

function createStoreHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext = context === ReactReduxContext ? useReduxContext_useReduxContext : function () {
    return (0,react.useContext)(context);
  };
  return function useStore() {
    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store;

    return store;
  };
}
/**
 * A hook to access the redux store.
 *
 * @returns {any} the redux store
 *
 * @example
 *
 * import React from 'react'
 * import { useStore } from 'react-redux'
 *
 * export const ExampleComponent = () => {
 *   const store = useStore()
 *   return <div>{store.getState()}</div>
 * }
 */

var useStore_useStore = /*#__PURE__*/createStoreHook();
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useDispatch.js


/**
 * Hook factory, which creates a `useDispatch` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useDispatch` hook bound to the specified context.
 */

function createDispatchHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useStore = context === ReactReduxContext ? useStore_useStore : createStoreHook(context);
  return function useDispatch() {
    var store = useStore();
    return store.dispatch;
  };
}
/**
 * A hook to access the redux `dispatch` function.
 *
 * @returns {any|function} redux store's `dispatch` function
 *
 * @example
 *
 * import React, { useCallback } from 'react'
 * import { useDispatch } from 'react-redux'
 *
 * export const CounterComponent = ({ value }) => {
 *   const dispatch = useDispatch()
 *   const increaseCounter = useCallback(() => dispatch({ type: 'increase-counter' }), [])
 *   return (
 *     <div>
 *       <span>{value}</span>
 *       <button onClick={increaseCounter}>Increase counter</button>
 *     </div>
 *   )
 * }
 */

var useDispatch = /*#__PURE__*/(/* unused pure expression or super */ null && (createDispatchHook()));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/hooks/useSelector.js






var refEquality = function refEquality(a, b) {
  return a === b;
};

function useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub) {
  var _useReducer = (0,react.useReducer)(function (s) {
    return s + 1;
  }, 0),
      forceRender = _useReducer[1];

  var subscription = (0,react.useMemo)(function () {
    return createSubscription(store, contextSub);
  }, [store, contextSub]);
  var latestSubscriptionCallbackError = (0,react.useRef)();
  var latestSelector = (0,react.useRef)();
  var latestStoreState = (0,react.useRef)();
  var latestSelectedState = (0,react.useRef)();
  var storeState = store.getState();
  var selectedState;

  try {
    if (selector !== latestSelector.current || storeState !== latestStoreState.current || latestSubscriptionCallbackError.current) {
      var newSelectedState = selector(storeState); // ensure latest selected state is reused so that a custom equality function can result in identical references

      if (latestSelectedState.current === undefined || !equalityFn(newSelectedState, latestSelectedState.current)) {
        selectedState = newSelectedState;
      } else {
        selectedState = latestSelectedState.current;
      }
    } else {
      selectedState = latestSelectedState.current;
    }
  } catch (err) {
    if (latestSubscriptionCallbackError.current) {
      err.message += "\nThe error may be correlated with this previous error:\n" + latestSubscriptionCallbackError.current.stack + "\n\n";
    }

    throw err;
  }

  useIsomorphicLayoutEffect(function () {
    latestSelector.current = selector;
    latestStoreState.current = storeState;
    latestSelectedState.current = selectedState;
    latestSubscriptionCallbackError.current = undefined;
  });
  useIsomorphicLayoutEffect(function () {
    function checkForUpdates() {
      try {
        var newStoreState = store.getState(); // Avoid calling selector multiple times if the store's state has not changed

        if (newStoreState === latestStoreState.current) {
          return;
        }

        var _newSelectedState = latestSelector.current(newStoreState);

        if (equalityFn(_newSelectedState, latestSelectedState.current)) {
          return;
        }

        latestSelectedState.current = _newSelectedState;
        latestStoreState.current = newStoreState;
      } catch (err) {
        // we ignore all errors here, since when the component
        // is re-rendered, the selectors are called again, and
        // will throw again, if neither props nor store state
        // changed
        latestSubscriptionCallbackError.current = err;
      }

      forceRender();
    }

    subscription.onStateChange = checkForUpdates;
    subscription.trySubscribe();
    checkForUpdates();
    return function () {
      return subscription.tryUnsubscribe();
    };
  }, [store, subscription]);
  return selectedState;
}
/**
 * Hook factory, which creates a `useSelector` hook bound to a given context.
 *
 * @param {React.Context} [context=ReactReduxContext] Context passed to your `<Provider>`.
 * @returns {Function} A `useSelector` hook bound to the specified context.
 */


function createSelectorHook(context) {
  if (context === void 0) {
    context = ReactReduxContext;
  }

  var useReduxContext = context === ReactReduxContext ? useReduxContext_useReduxContext : function () {
    return (0,react.useContext)(context);
  };
  return function useSelector(selector, equalityFn) {
    if (equalityFn === void 0) {
      equalityFn = refEquality;
    }

    if (false) {}

    var _useReduxContext = useReduxContext(),
        store = _useReduxContext.store,
        contextSub = _useReduxContext.subscription;

    var selectedState = useSelectorWithStoreAndSubscription(selector, equalityFn, store, contextSub);
    (0,react.useDebugValue)(selectedState);
    return selectedState;
  };
}
/**
 * A hook to access the redux store's state. This hook takes a selector function
 * as an argument. The selector is called with the store state.
 *
 * This hook takes an optional equality comparison function as the second parameter
 * that allows you to customize the way the selected state is compared to determine
 * whether the component needs to be re-rendered.
 *
 * @param {Function} selector the selector function
 * @param {Function=} equalityFn the function that will be used to determine equality
 *
 * @returns {any} the selected state
 *
 * @example
 *
 * import React from 'react'
 * import { useSelector } from 'react-redux'
 *
 * export const CounterComponent = () => {
 *   const counter = useSelector(state => state.counter)
 *   return <div>{counter}</div>
 * }
 */

var useSelector = /*#__PURE__*/(/* unused pure expression or super */ null && (createSelectorHook()));
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/shallowEqual.js
function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual_shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!Object.prototype.hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
;// CONCATENATED MODULE: ./node_modules/react-redux/es/exports.js









// EXTERNAL MODULE: ./node_modules/react-dom/index.js
var react_dom = __webpack_require__(73935);
;// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/reactBatchedUpdates.js
/* eslint-disable import/no-unresolved */

;// CONCATENATED MODULE: ./node_modules/react-redux/es/index.js


 // Enable batched updates in our subscriptions for use
// with standard React renderers (ReactDOM, React Native)

setBatch(react_dom.unstable_batchedUpdates);

;// CONCATENATED MODULE: ./node_modules/@frontegg/react-hooks/FronteggStoreContext-d6c3b684.js



const FronteggStoreContext = react.createContext(null);
const FronteggStoreContext_d6c3b684_useSelector = createSelectorHook(FronteggStoreContext);
const FronteggStoreContext_d6c3b684_useDispatch = createDispatchHook(FronteggStoreContext);
const useStore = createStoreHook(FronteggStoreContext);



// EXTERNAL MODULE: ./node_modules/@frontegg/rest-api/dist/umd/index.js
var umd = __webpack_require__(32205);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
;// CONCATENATED MODULE: ./node_modules/@frontegg/react-hooks/roles-18da4c43.js







const ShadowDomContext = (0,react.createContext)({});
const useShadowDom = () => {
    const context = (0,react.useContext)(ShadowDomContext);
    const { urlStrategy = 'path', onRedirectTo = urlStrategy === 'path'
        ? (path) => window.history.pushState(null, '', path)
        : (path) => window.history.pushState(null, '', `#${path}`), renderByRoute = false, customLoader = false, customStyles, contextOptions } = context, rest = (0,tslib_es6.__rest)(context, ["urlStrategy", "onRedirectTo", "renderByRoute", "customLoader", "customStyles", "contextOptions"]);
    return Object.assign({ isShadowDom: true, onRedirectTo,
        renderByRoute,
        customLoader,
        customStyles,
        urlStrategy, contextOptions: Object.assign({ requestCredentials: 'include' }, contextOptions) }, rest);
};

const defaultMapper = {
    state: (state) => state,
    actions: (actions) => actions,
};
const useAuth = (stateMapper = defaultMapper.state) => {
    return FronteggStoreContext_d6c3b684_useSelector((state) => stateMapper(state[redux_store/* authStoreName */.Y2]), shallowEqual_shallowEqual);
};
/**
 * ```jsx
 * export const MyFunctionComponent = () => {
 *   const { isAuthenticated, user } = useAuth();
 *   const loginWithRedirect = useLoginWithRedirect();
 *
 *   if (!isAuthenticated) {
 *     loginWithRedirect();
 *     return <></>;
 *   }
 *
 *   return (<div>Hello User {user.name}</div>);
 * }
 * ```
 *
 * use this frontegg hook function to get if user is "Authenticated"
 */
const useLoginWithRedirect = () => {
    const dispatch = FronteggStoreContext_d6c3b684_useDispatch();
    return (0,react.useMemo)(() => (0,redux_store/* bindActionCreators */.DE)(redux_store/* authActions.requestHostedLoginAuthorize */.YV.requestHostedLoginAuthorize, dispatch), [redux_store/* authActions.requestHostedLoginAuthorize */.YV.requestHostedLoginAuthorize]);
};
const useAuthActions = () => {
    const dispatch = FronteggStoreContext_d6c3b684_useDispatch();
    return (0,react.useMemo)(() => (0,redux_store/* bindActionCreators */.DE)(redux_store/* authActions */.YV, dispatch), [redux_store/* authActions */.YV]);
};
const useOnRedirectTo = () => {
    var _a;
    const context = (0,react.useContext)(ShadowDomContext);
    return (_a = context === null || context === void 0 ? void 0 : context.onRedirectTo) !== null && _a !== void 0 ? _a : umd.ContextHolder.onRedirectTo;
};
const useAuthRoutes = () => useAuth((state) => (Object.assign({}, state.routes)));
/**
 * ```jsx
 * export const MyFunctionComponent = () => {
 *   const isAuthenticated  = useIsAuthenticated();
 *   return isAuthenticated ? <div>Hello User</div> : <Redirect to={'/login'}/>
 * }
 * ```
 *
 * use this frontegg hook function to get if user is "Authenticated"
 */
const useIsAuthenticated = () => FronteggStoreContext_d6c3b684_useSelector(({ [redux_store/* authStoreName */.Y2]: { isAuthenticated } }) => isAuthenticated, shallowEqual_shallowEqual);
/**
 * ```jsx
 * export const MyFunctionComponent = () => {
 *   const user = useAuthUser();
 *   return user ? <div>Hello {user.name}!</div> : <div>Hello Guest!</div>
 * }
 * ```
 *
 * use this frontegg hook function to get the authenticated user
 * the return user is null if not authenticated
 */
const useAuthUser = () => {
    const routes = useAuthRoutes();
    const onRedirectTo = useOnRedirectTo();
    const user = useAuthUserOrNull();
    if (user == null) {
        onRedirectTo(routes.loginUrl, { refresh: true });
        return {};
    }
    return user;
};
const useAuthUserOrNull = () => {
    const { user } = FronteggStoreContext_d6c3b684_useSelector(({ [redux_store/* authStoreName */.Y2]: { user } }) => ({ user }), shallowEqual_shallowEqual);
    return user || null;
};
/**
 * hooks helpers
 */
const sliceReducerActionsBy = (reducer) => {
    const reducerKeys = Object.keys(reducer);
    const reducerActions = reducerKeys.map((key) => ({ [key]: redux_store/* authActions */.YV[key] }));
    return reducerActions.reduce((p, n) => (Object.assign(Object.assign({}, p), n)), {});
};
const stateHookGenerator = (stateMapper, subState) => {
    return FronteggStoreContext_d6c3b684_useSelector((state) => { var _a; return (_a = stateMapper === null || stateMapper === void 0 ? void 0 : stateMapper(state[redux_store/* authStoreName */.Y2][subState])) !== null && _a !== void 0 ? _a : state[redux_store/* authStoreName */.Y2][subState]; }, shallowEqual_shallowEqual);
};
const reducerActionsGenerator = (actions, reducers) => {
    const dispatch = FronteggStoreContext_d6c3b684_useDispatch();
    return (0,react.useMemo)(() => (0,redux_store/* bindActionCreators */.DE)(Object.assign(Object.assign({}, actions), sliceReducerActionsBy(reducers)), dispatch), [dispatch]);
};

const useAcceptInvitationState = (stateMapper) => stateHookGenerator(stateMapper, 'acceptInvitationState');
const useAcceptInvitationActions = () => reducerActionsGenerator(redux_store/* acceptInvitationActions */.kX, redux_store/* acceptInvitationReducers */.YQ);

const useActivateAccountState = (stateMapper) => stateHookGenerator(stateMapper, 'activateState');
const useActivateAccountActions = () => reducerActionsGenerator(redux_store/* activateAccountActions */.pf, redux_store/* activateAccountReducers */.iJ);

const useApiTokensState = (stateMapper) => stateHookGenerator(stateMapper, 'apiTokensState');
const useApiTokensActions = () => reducerActionsGenerator(redux_store/* apiTokensActions */.UY, redux_store/* apiTokensReducers */.Ol);

const useForgotPasswordState = (stateMapper) => stateHookGenerator(stateMapper, 'forgotPasswordState');
const useForgotPasswordActions = () => reducerActionsGenerator(redux_store/* forgotPasswordActions */.ZK, redux_store/* forgotPasswordReducers */.Mc);

const useResetPhoneNumberState = (stateMapper) => stateHookGenerator(stateMapper, 'resetPhoneNumberState');
const useResetPhoneNumberActions = () => reducerActionsGenerator(redux_store/* resetPhoneNumberActions */.ng, redux_store/* resetPhoneNumberReducers */.TK);

const useLoginState = (stateMapper) => stateHookGenerator(stateMapper, 'loginState');
const useLoginActions = () => reducerActionsGenerator(redux_store/* loginActions */.BK, redux_store/* loginReducers */.fv);

const useMfaState = (stateMapper) => stateHookGenerator(stateMapper, 'mfaState');
const useMfaActions = () => reducerActionsGenerator(redux_store/* mfaActions */.rg, redux_store/* mfaReducers */.a4);

const reloadProfileIfNeeded = () => {
    const { loading } = useProfileState();
    const { loadProfile } = useProfileActions();
    (0,react.useEffect)(() => {
        !loading && loadProfile();
    }, []);
};
const useProfileState = (stateMapper) => stateHookGenerator(stateMapper, 'profileState');
const useProfileActions = () => reducerActionsGenerator(redux_store/* profileActions */.ef, redux_store/* profileReducers */.i1);

const useSignUpState = (stateMapper) => stateHookGenerator(stateMapper, 'signUpState');
const useSignUpActions = () => reducerActionsGenerator(redux_store/* signUpActions */.j0, redux_store/* signUpReducers */._A);

const useSocialLoginState = (stateMapper) => stateHookGenerator(stateMapper, 'socialLoginState');
const useSocialLoginActions = () => reducerActionsGenerator(redux_store/* socialLoginsActions */.ak, redux_store/* socialLoginsReducer */.BP);

const useAuthTeamState = (stateMapper) => stateHookGenerator(stateMapper, 'teamState');
const useAuthTeamActions = () => reducerActionsGenerator(redux_store/* teamActions */.L2, redux_store/* teamReducers */.vy);

const useSSOState = (stateMapper) => stateHookGenerator(stateMapper, 'ssoState');
const useSSOActions = () => reducerActionsGenerator(redux_store/* ssoActions */.E1, redux_store/* ssoReducers */.rw);

const useSecurityPolicyState = (stateMapper) => stateHookGenerator(stateMapper, 'securityPolicyState');
const useSecurityPolicyActions = () => reducerActionsGenerator(redux_store/* securityPolicyActions */.yr, redux_store/* securityPolicyReducers */._);
const usePublicPolicySettings = (loadOnMount = false) => {
    const { loading, policy, saving, error } = useSecurityPolicyState(state => state.publicPolicy);
    const { loadPublicSecurityPolicy } = useSecurityPolicyActions();
    (0,react.useEffect)(() => {
        (loadOnMount || !policy) && loadPublicSecurityPolicy();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadOnMount, loadPublicSecurityPolicy]);
    return { loading, saving, error, policy };
};
const usePublicAuthStrategiesPolicySettings = (loadOnMount = false) => {
    const { loading, policy, saving, error } = useSecurityPolicyState(state => state.publicAuthStrategyPolicy);
    const { loadPublicAuthStrategiesPolicy } = useSecurityPolicyActions();
    (0,react.useEffect)(() => {
        (loadOnMount || !policy) && loadPublicAuthStrategiesPolicy();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loadOnMount, loadPublicAuthStrategiesPolicy]);
    return { loading, saving, error, policy };
};

const useTenantsState = (stateMapper) => stateHookGenerator(stateMapper, 'tenantsState');
const useTenantsActions = () => reducerActionsGenerator(redux_store/* tenantsActions */.Q_, redux_store/* tenantsReducers */.Y);

const useRolesState = (stateMapper) => stateHookGenerator(stateMapper, 'rolesState');
const useRolesActions = () => reducerActionsGenerator(redux_store/* rolesActions */.$3, redux_store/* rolesReducers */.Az);



;// CONCATENATED MODULE: ./node_modules/@frontegg/react-hooks/auditsMetadata-9ab88593.js





const useAuditsState = (stateMapper) => {
    return FronteggStoreContext_d6c3b684_useSelector((state) => { var _a; return (_a = stateMapper === null || stateMapper === void 0 ? void 0 : stateMapper(state[redux_store/* auditsStoreName */.e_])) !== null && _a !== void 0 ? _a : state[redux_store/* auditsStoreName */.e_]; }, shallowEqual_shallowEqual);
};
const useAuditsActions = () => {
    const dispatch = FronteggStoreContext_d6c3b684_useDispatch();
    return (0,react.useMemo)(() => (0,redux_store/* bindActionCreators */.DE)(redux_store/* auditsActions */.iN, dispatch), [redux_store/* auditsActions */.iN]);
};
/**
 * hooks helpers
 */
const auditsMetadata_9ab88593_sliceReducerActionsBy = (reducer) => {
    const reducerKeys = Object.keys(reducer);
    const reducerActions = reducerKeys.map((key) => ({ [key]: redux_store/* auditsActions */.iN[key] }));
    return reducerActions.reduce((p, n) => (Object.assign(Object.assign({}, p), n)), {});
};
const auditsMetadata_9ab88593_stateHookGenerator = (stateMapper, subState) => {
    return FronteggStoreContext_d6c3b684_useSelector((state) => { var _a; return (_a = stateMapper === null || stateMapper === void 0 ? void 0 : stateMapper(state[redux_store/* auditsStoreName */.e_][subState])) !== null && _a !== void 0 ? _a : state[redux_store/* auditsStoreName */.e_][subState]; }, shallowEqual_shallowEqual);
};
const auditsMetadata_9ab88593_reducerActionsGenerator = (actions, reducers) => {
    const dispatch = FronteggStoreContext_d6c3b684_useDispatch();
    return (0,react.useMemo)(() => (0,redux_store/* bindActionCreators */.DE)(Object.assign(Object.assign({}, actions), auditsMetadata_9ab88593_sliceReducerActionsBy(reducers)), dispatch), [dispatch]);
};

const useAuditLogsState = (stateMapper) => auditsMetadata_9ab88593_stateHookGenerator(stateMapper, 'auditLogsState');
const useAuditLogsActions = () => auditsMetadata_9ab88593_reducerActionsGenerator(redux_store/* auditLogsActions */.u1, redux_store/* auditLogsReducers */.cG);

const useAuditsMetadataState = (stateMapper) => auditsMetadata_9ab88593_stateHookGenerator(stateMapper, 'auditsMetadataState');
const useAuditsMetadataActions = () => auditsMetadata_9ab88593_reducerActionsGenerator(redux_store/* auditsMetadataActions */.oX, redux_store/* auditsMetadataReducers */.od);



;// CONCATENATED MODULE: ./node_modules/@frontegg/react-hooks/hooks-6400e233.js





const useConnectivityState = (stateMapper) => {
    return FronteggStoreContext_d6c3b684_useSelector((state) => { var _a; return (_a = stateMapper === null || stateMapper === void 0 ? void 0 : stateMapper(state[redux_store/* connectivityStoreName */.S4])) !== null && _a !== void 0 ? _a : state[redux_store/* connectivityStoreName */.S4]; }, shallowEqual_shallowEqual);
};
const useConnectivityActions = () => {
    const dispatch = FronteggStoreContext_d6c3b684_useDispatch();
    return (0,react.useMemo)(() => (0,redux_store/* bindActionCreators */.DE)(redux_store/* connectivityActions */.W3, dispatch), [redux_store/* connectivityActions */.W3]);
};



;// CONCATENATED MODULE: ./node_modules/@frontegg/react-hooks/hooks-7fc5d634.js





function getSubscriptionState(state) {
    return state[redux_store/* subscriptionsStoreName */.PP];
}
const usePaymentProvider = () => {
    return FronteggStoreContext_d6c3b684_useSelector((state) => getSubscriptionState(state).config, shallowEqual_shallowEqual);
};
const usePaymentProviderActions = () => {
    const dispatch = FronteggStoreContext_d6c3b684_useDispatch();
    return (0,react.useMemo)(() => (0,redux_store/* bindActionCreators */.DE)(redux_store/* subscriptionActions.config */.bP.config, dispatch), [dispatch]);
};
const usePlans = () => {
    return FronteggStoreContext_d6c3b684_useSelector((state) => getSubscriptionState(state).plans, shallowEqual_shallowEqual);
};
const usePlansActions = () => {
    const dispatch = FronteggStoreContext_d6c3b684_useDispatch();
    return (0,react.useMemo)(() => (0,redux_store/* bindActionCreators */.DE)(redux_store/* subscriptionActions.plans */.bP.plans, dispatch), [dispatch]);
};
const useCheckout = () => {
    return FronteggStoreContext_d6c3b684_useSelector((state) => getSubscriptionState(state).checkout, shallowEqual_shallowEqual);
};
const useCheckoutActions = () => {
    const dispatch = FronteggStoreContext_d6c3b684_useDispatch();
    return (0,react.useMemo)(() => (0,redux_store/* bindActionCreators */.DE)(redux_store/* subscriptionActions.checkout */.bP.checkout, dispatch), [dispatch]);
};
const useBillingActions = (billingKey) => {
    const dispatch = FronteggStoreContext_d6c3b684_useDispatch();
    return (0,react.useMemo)(() => (0,redux_store/* bindActionCreators */.DE)(redux_store/* subscriptionActions.billing */.bP.billing[billingKey], dispatch), [billingKey, dispatch]);
};
const useBillingInformation = () => FronteggStoreContext_d6c3b684_useSelector((state) => getSubscriptionState(state).billing.information, shallowEqual_shallowEqual);
const useBillingInformationActions = () => useBillingActions('information');
const usePaymentMethod = () => FronteggStoreContext_d6c3b684_useSelector((state) => getSubscriptionState(state).billing.paymentMethod, shallowEqual_shallowEqual);
const usePaymentMethodActions = () => useBillingActions('paymentMethod');
const useInvoices = () => FronteggStoreContext_d6c3b684_useSelector((state) => getSubscriptionState(state).billing.invoices, shallowEqual_shallowEqual);
const useInvoicesActions = () => useBillingActions('invoices');
const useStripeState = () => {
    return FronteggStoreContext_d6c3b684_useSelector((state) => getSubscriptionState(state).stripe, shallowEqual_shallowEqual);
};
const useStripeActions = () => {
    const dispatch = FronteggStoreContext_d6c3b684_useDispatch();
    return (0,react.useMemo)(() => (0,redux_store/* bindActionCreators */.DE)(redux_store/* subscriptionActions.stripe */.bP.stripe, dispatch), [dispatch]);
};
const useSubscriptionCancellation = () => {
    return FronteggStoreContext_d6c3b684_useSelector((state) => getSubscriptionState(state).billing.subscription.cancellation, shallowEqual_shallowEqual);
};
const useSubscriptionRenewal = () => {
    return FronteggStoreContext_d6c3b684_useSelector((state) => getSubscriptionState(state).billing.subscription.renewal, shallowEqual_shallowEqual);
};
const useSubscription = () => {
    return FronteggStoreContext_d6c3b684_useSelector((state) => {
        const { billing: { subscription }, } = getSubscriptionState(state);
        return subscription;
    }, shallowEqual_shallowEqual);
};
const useSubscriptionActions = () => {
    const dispatch = FronteggStoreContext_d6c3b684_useDispatch();
    return (0,react.useMemo)(() => (0,redux_store/* bindActionCreators */.DE)(redux_store/* subscriptionActions.billing.subscription */.bP.billing.subscription, dispatch), [dispatch]);
};



;// CONCATENATED MODULE: ./node_modules/@frontegg/react-hooks/hooks-eaf879c9.js





const useVendorState = (stateMapper) => {
    return FronteggStoreContext_d6c3b684_useSelector((state) => { var _a; return (_a = stateMapper === null || stateMapper === void 0 ? void 0 : stateMapper(state[redux_store/* vendorStoreName */.wv])) !== null && _a !== void 0 ? _a : state[redux_store/* vendorStoreName */.wv]; }, shallowEqual_shallowEqual);
};
const useVendorActions = () => {
    const dispatch = FronteggStoreContext_d6c3b684_useDispatch();
    return (0,react.useMemo)(() => (0,redux_store/* bindActionCreators */.DE)(redux_store/* vendorActions */.Ne, dispatch), [redux_store/* vendorActions */.Ne]);
};



;// CONCATENATED MODULE: ./node_modules/@frontegg/react-hooks/index.js















const setLoading = (loading) => {
    const isSSR = typeof document === 'undefined' || typeof window === 'undefined';
    if (!isSSR) {
        if (loading) {
            document.body.classList.add('frontegg-loading');
        }
        else {
            document.body.classList.remove('frontegg-loading');
        }
    }
};
const HideChildrenIfFronteggRoutes = ({ children, basename }) => {
    const routes = useAuthRoutes();
    const uriRef = (0,react.useRef)(window.location.pathname);
    const animationFrameRef = (0,react.useRef)(0);
    const [uri, setUri] = (0,react.useState)(window.location.pathname);
    const checker = () => {
        if (uriRef.current !== window.location.pathname) {
            uriRef.current = window.location.pathname;
            setUri(document.location.pathname);
        }
        animationFrameRef.current = window.requestAnimationFrame(checker);
    };
    (0,react.useEffect)(() => {
        document.addEventListener('frontegg_onRedirectTo_fired', () => {
            if (uriRef.current !== window.location.pathname) {
                uriRef.current = window.location.pathname;
                setUri(document.location.pathname);
            }
        });
        window.addEventListener('popstate', () => {
            if (uriRef.current !== window.location.pathname) {
                uriRef.current = window.location.pathname;
                setUri(document.location.pathname);
            }
        });
        animationFrameRef.current = window.requestAnimationFrame(checker);
        return () => {
            window.cancelAnimationFrame(animationFrameRef.current);
        };
    }, [setUri]);
    const calculatedBasename = basename ? (basename.endsWith('/') ? basename.substring(0, basename.length - 1) : '') : '';
    const checkRoutes = (0,tslib_es6.__rest)(routes, ["authenticatedUrl", "signUpSuccessUrl"]);
    if (Object.values(checkRoutes).map(url => `${calculatedBasename}${url}`).indexOf(uri) !== -1) {
        return null;
    }
    return react.createElement(react.Fragment, null, children);
};
const FronteggContent = ({ children, app, setLoading }) => {
    var _a, _b, _c;
    const { isLoading } = useAuth(({ isLoading }) => ({ isLoading }));
    const customLoginBox = !app || ((_a = app === null || app === void 0 ? void 0 : app.options) === null || _a === void 0 ? void 0 : _a.customLoginBox) === true;
    const alwaysShowChildren = customLoginBox || (((_b = app === null || app === void 0 ? void 0 : app.options) === null || _b === void 0 ? void 0 : _b.hostedLoginBox) === true && ((_c = app === null || app === void 0 ? void 0 : app.options) === null || _c === void 0 ? void 0 : _c.framework) === 'nextjs');
    const loadingRef = (0,react.useRef)(undefined);
    if (isLoading !== loadingRef.current) {
        loadingRef.current = isLoading;
        setLoading(isLoading);
    }
    if (isLoading) {
        return null;
    }
    if (alwaysShowChildren) {
        return react.createElement(react.Fragment, null, children);
    }
    return react.createElement(HideChildrenIfFronteggRoutes, { basename: app === null || app === void 0 ? void 0 : app.options.basename }, children);
};
const FronteggStoreProvider = ({ children, app, contextOptions, setLoading: setLoadingProps, }) => {
    var _a, _b, _c, _d, _e, _f;
    const context = (_b = (_a = app === null || app === void 0 ? void 0 : app.options) === null || _a === void 0 ? void 0 : _a.contextOptions) !== null && _b !== void 0 ? _b : contextOptions;
    const previewMode = (_d = (_c = app === null || app === void 0 ? void 0 : app.options) === null || _c === void 0 ? void 0 : _c.previewMode) !== null && _d !== void 0 ? _d : false;
    const authOptions = (_f = (_e = app === null || app === void 0 ? void 0 : app.options) === null || _e === void 0 ? void 0 : _e.authOptions) !== null && _f !== void 0 ? _f : {};
    umd.ContextHolder.setContext(context);
    const store = (0,react.useMemo)(() => (0,redux_store/* createFronteggStore */.iv)({ context: context }, app, previewMode, authOptions), [app, previewMode]);
    return (react.createElement(components_Provider, { context: FronteggStoreContext, store: store },
        react.createElement(FronteggContent, { setLoading: setLoadingProps !== null && setLoadingProps !== void 0 ? setLoadingProps : setLoading, app: app }, children)));
};




/***/ }),

/***/ 5850:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Mr": function() { return /* reexport */ AcceptInvitationStep; },
  "M1": function() { return /* reexport */ ActivateAccountStep; },
  "GL": function() { return /* reexport */ ApiStateKeys; },
  "lw": function() { return /* reexport */ umd.AuthStrategyEnum; },
  "Xh": function() { return /* reexport */ AuthenticationTypes; },
  "M_": function() { return /* reexport */ ForgotPasswordStep; },
  "iP": function() { return /* reexport */ LoginFlow; },
  "Fh": function() { return /* reexport */ LoginStep; },
  "bj": function() { return /* reexport */ MFAStep; },
  "Lt": function() { return /* reexport */ PaymentMethodType; },
  "OH": function() { return /* reexport */ PaymentProvider; },
  "mK": function() { return /* reexport */ QuickLoginStrategy; },
  "Z$": function() { return /* reexport */ ResetPhoneNumberStep; },
  "p1": function() { return /* reexport */ SSOStateKeys; },
  "pA": function() { return /* reexport */ SamlVendors; },
  "vb": function() { return /* reexport */ SignUpStage; },
  "oY": function() { return /* reexport */ SubscriptionCancellationPolicy; },
  "yh": function() { return /* reexport */ SubscriptionStatus; },
  "DY": function() { return /* reexport */ TeamStateKeys; },
  "EJ": function() { return /* reexport */ UserVeirifedOriginTypes; },
  "kX": function() { return /* reexport */ actions$e; },
  "YQ": function() { return /* reexport */ reducers$d; },
  "CD": function() { return /* reexport */ acceptInvitationState; },
  "vc": function() { return /* reexport */ actions$3; },
  "wn": function() { return /* reexport */ reducers$2; },
  "e3": function() { return /* reexport */ accountSettingsState; },
  "Nw": function() { return /* reexport */ saga_7a267fe0_actions; },
  "pf": function() { return /* reexport */ actions$f; },
  "iJ": function() { return /* reexport */ reducers$e; },
  "fA": function() { return /* reexport */ activateState; },
  "$6": function() { return /* reexport */ io_c3792963_all; },
  "UY": function() { return /* reexport */ actions$5; },
  "Ol": function() { return /* reexport */ reducers$4; },
  "HU": function() { return /* reexport */ apiTokensState; },
  "u1": function() { return /* reexport */ audits_actions$2; },
  "cG": function() { return /* reexport */ audits_reducers$1; },
  "md": function() { return /* reexport */ auditLogsState; },
  "y5": function() { return /* reexport */ auditsStore; },
  "iN": function() { return /* reexport */ audits_actions; },
  "rH": function() { return /* reexport */ audits_initialState; },
  "oX": function() { return /* reexport */ audits_actions$1; },
  "od": function() { return /* reexport */ audits_reducers; },
  "LE": function() { return /* reexport */ auditsMetadataState; },
  "It": function() { return /* reexport */ audits_mockSagas; },
  "nc": function() { return /* reexport */ audits_reducer; },
  "iW": function() { return /* reexport */ audits_sagas; },
  "e_": function() { return /* reexport */ auditsStoreName; },
  "I8": function() { return /* reexport */ authStore; },
  "YV": function() { return /* reexport */ auth_actions; },
  "y7": function() { return /* reexport */ auth_initialState; },
  "Gw": function() { return /* reexport */ mockSagas; },
  "Cp": function() { return /* reexport */ auth_reducer; },
  "MX": function() { return /* reexport */ auth_sagas; },
  "Y2": function() { return /* reexport */ authStoreName; },
  "DE": function() { return /* reexport */ bindActionCreators; },
  "RE": function() { return /* reexport */ call; },
  "I0": function() { return /* reexport */ combineReducers; },
  "xC": function() { return /* reexport */ configureStore; },
  "wF": function() { return /* reexport */ connectivityStore; },
  "W3": function() { return /* reexport */ connectivity_actions; },
  "Bz": function() { return /* reexport */ connectivity_initialState; },
  "m5": function() { return /* reexport */ connectivity_reducer; },
  "CJ": function() { return /* reexport */ connectivity_sagas; },
  "S4": function() { return /* reexport */ connectivityStoreName; },
  "iv": function() { return /* reexport */ createFronteggStore; },
  "l9": function() { return /* reexport */ redux_saga_core_npm_proxy_esm; },
  "P1": function() { return /* reexport */ reselect_es/* createSelector */.P1; },
  "oM": function() { return /* reexport */ createSlice; },
  "NS": function() { return /* reexport */ defaultItemsPerPage; },
  "gw": function() { return /* reexport */ io_c3792963_delay; },
  "ZK": function() { return /* reexport */ actions$d; },
  "Mc": function() { return /* reexport */ reducers$c; },
  "j4": function() { return /* reexport */ forgotPasswordState; },
  "Bx": function() { return /* reexport */ getDefaultMiddleware; },
  "E3": function() { return /* reexport */ saga_7a267fe0_initialState; },
  "BK": function() { return /* reexport */ actions$g; },
  "fv": function() { return /* reexport */ reducers$f; },
  "PH": function() { return /* reexport */ loginState; },
  "rg": function() { return /* reexport */ actions$9; },
  "a4": function() { return /* reexport */ reducers$8; },
  "Yb": function() { return /* reexport */ mfaState; },
  "ef": function() { return /* reexport */ actions$a; },
  "i1": function() { return /* reexport */ reducers$9; },
  "rc": function() { return /* reexport */ profileState; },
  "gz": function() { return /* reexport */ put; },
  "I6": function() { return /* reexport */ saga_7a267fe0_reducer; },
  "ng": function() { return /* reexport */ actions$c; },
  "TK": function() { return /* reexport */ reducers$b; },
  "kd": function() { return /* reexport */ resetPhoneNumberState; },
  "$3": function() { return /* reexport */ auth_actions$1; },
  "Az": function() { return /* reexport */ auth_reducers; },
  "ZX": function() { return /* reexport */ rolesState; },
  "vQ": function() { return /* reexport */ saga_7a267fe0_sagas; },
  "yr": function() { return /* reexport */ actions$4; },
  "_": function() { return /* reexport */ reducers$3; },
  "SC": function() { return /* reexport */ securityPolicyState; },
  "Ys": function() { return /* reexport */ io_c3792963_select; },
  "j0": function() { return /* reexport */ actions$6; },
  "_A": function() { return /* reexport */ reducers$5; },
  "GD": function() { return /* reexport */ signUpState; },
  "PG": function() { return /* reexport */ socialLoginState; },
  "ak": function() { return /* reexport */ actions$7; },
  "BP": function() { return /* reexport */ reducers$6; },
  "E1": function() { return /* reexport */ actions$b; },
  "rw": function() { return /* reexport */ reducers$a; },
  "Ku": function() { return /* reexport */ ssoState; },
  "tC": function() { return /* reexport */ storeName; },
  "bP": function() { return /* reexport */ subscriptions_actions; },
  "pg": function() { return /* reexport */ subscriptions_initialState; },
  "rj": function() { return /* reexport */ subscriptions_reducer; },
  "Pu": function() { return /* reexport */ subscriptions_sagas; },
  "dQ": function() { return /* reexport */ subscriptions_mockSagas; },
  "Vt": function() { return /* reexport */ subscriptionsStore; },
  "PP": function() { return /* reexport */ subscriptionsStoreName; },
  "ib": function() { return /* reexport */ takeEvery$1; },
  "Fm": function() { return /* reexport */ takeLatest$1; },
  "L2": function() { return /* reexport */ actions$8; },
  "vy": function() { return /* reexport */ reducers$7; },
  "ju": function() { return /* reexport */ teamState; },
  "Q_": function() { return /* reexport */ actions$2; },
  "Y": function() { return /* reexport */ reducers$1; },
  "Qg": function() { return /* reexport */ tenantsState; },
  "UZ": function() { return /* reexport */ vendorStore; },
  "Ne": function() { return /* reexport */ actions; },
  "JO": function() { return /* reexport */ initialState; },
  "Kt": function() { return /* reexport */ reducer; },
  "rv": function() { return /* reexport */ sagas; },
  "wv": function() { return /* reexport */ vendorStoreName; }
});

// EXTERNAL MODULE: ./node_modules/immer/dist/immer.esm.mjs
var immer_esm = __webpack_require__(12902);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js + 2 modules
var toPropertyKey = __webpack_require__(19376);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  key = (0,toPropertyKey/* default */.Z)(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
;// CONCATENATED MODULE: ./node_modules/redux/es/redux.js


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {}

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 0);
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : 0);
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : 0);
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 0);
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 0);
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 0);
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : 0);
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 0);
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 0);
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : 0);
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : 0);
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = (/* unused pure expression or super */ null && (createStore));

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : 0);
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : 0);
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {}

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {}

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) { var warningMessage; }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : 0);
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : 0);
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 0);
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return _objectSpread2(_objectSpread2({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}

/*
 * This is a dummy function to check if the function name has been altered by minification.
 * If the function has been minified and NODE_ENV !== 'production', warn the user.
 */

function isCrushed() {}

if (false) {}



;// CONCATENATED MODULE: ./node_modules/redux-thunk/es/index.js
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ var es = (thunk);
;// CONCATENATED MODULE: ./node_modules/@reduxjs/toolkit/dist/redux-toolkit.esm.js
/* provided dependency */ var process = __webpack_require__(83454);
var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __generator = (undefined && undefined.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function (obj, key, value) { return key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value: value }) : obj[key] = value; };
var __spreadValues = function (a, b) {
    for (var prop in b || (b = {}))
        if (__hasOwnProp.call(b, prop))
            __defNormalProp(a, prop, b[prop]);
    if (__getOwnPropSymbols)
        for (var _i = 0, _c = __getOwnPropSymbols(b); _i < _c.length; _i++) {
            var prop = _c[_i];
            if (__propIsEnum.call(b, prop))
                __defNormalProp(a, prop, b[prop]);
        }
    return a;
};
var __spreadProps = function (a, b) { return __defProps(a, __getOwnPropDescs(b)); };
var __async = function (__this, __arguments, generator) {
    return new Promise(function (resolve, reject) {
        var fulfilled = function (value) {
            try {
                step(generator.next(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var rejected = function (value) {
            try {
                step(generator.throw(value));
            }
            catch (e) {
                reject(e);
            }
        };
        var step = function (x) { return x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected); };
        step((generator = generator.apply(__this, __arguments)).next());
    });
};
// src/index.ts




// src/createDraftSafeSelector.ts


var createDraftSafeSelector = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var selector = createSelector.apply(void 0, args);
    var wrappedSelector = function (value) {
        var rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            rest[_i - 1] = arguments[_i];
        }
        return selector.apply(void 0, __spreadArray([isDraft(value) ? current(value) : value], rest));
    };
    return wrappedSelector;
};
// src/configureStore.ts

// src/devtoolsExtension.ts

var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function () {
    if (arguments.length === 0)
        return void 0;
    if (typeof arguments[0] === "object")
        return compose;
    return compose.apply(null, arguments);
};
var devToolsEnhancer = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__ : function () {
    return function (noop2) {
        return noop2;
    };
};
// src/isPlainObject.ts
function redux_toolkit_esm_isPlainObject(value) {
    if (typeof value !== "object" || value === null)
        return false;
    var proto = Object.getPrototypeOf(value);
    if (proto === null)
        return true;
    var baseProto = proto;
    while (Object.getPrototypeOf(baseProto) !== null) {
        baseProto = Object.getPrototypeOf(baseProto);
    }
    return proto === baseProto;
}
// src/getDefaultMiddleware.ts

// src/utils.ts

function getTimeMeasureUtils(maxDelay, fnName) {
    var elapsed = 0;
    return {
        measureTime: function (fn) {
            var started = Date.now();
            try {
                return fn();
            }
            finally {
                var finished = Date.now();
                elapsed += finished - started;
            }
        },
        warnIfExceeded: function () {
            if (elapsed > maxDelay) {
                console.warn(fnName + " took " + elapsed + "ms, which is more than the warning threshold of " + maxDelay + "ms. \nIf your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.\nIt is disabled in production builds, so you don't need to worry about that.");
            }
        }
    };
}
var MiddlewareArray = /** @class */ (function (_super) {
    __extends(MiddlewareArray, _super);
    function MiddlewareArray() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var _this = _super.apply(this, args) || this;
        Object.setPrototypeOf(_this, MiddlewareArray.prototype);
        return _this;
    }
    Object.defineProperty(MiddlewareArray, Symbol.species, {
        get: function () {
            return MiddlewareArray;
        },
        enumerable: false,
        configurable: true
    });
    MiddlewareArray.prototype.concat = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        return _super.prototype.concat.apply(this, arr);
    };
    MiddlewareArray.prototype.prepend = function () {
        var arr = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            arr[_i] = arguments[_i];
        }
        if (arr.length === 1 && Array.isArray(arr[0])) {
            return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr[0].concat(this))))();
        }
        return new (MiddlewareArray.bind.apply(MiddlewareArray, __spreadArray([void 0], arr.concat(this))))();
    };
    return MiddlewareArray;
}(Array));
function freezeDraftable(val) {
    return (0,immer_esm/* isDraftable */.o$)(val) ? (0,immer_esm/* default */.ZP)(val, function () {
    }) : val;
}
// src/immutableStateInvariantMiddleware.ts
var isProduction = (/* unused pure expression or super */ null && ("production" === "production"));
var prefix = "Invariant failed";
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    throw new Error(prefix + ": " + (message || ""));
}
function stringify(obj, serializer, indent, decycler) {
    return JSON.stringify(obj, getSerialize(serializer, decycler), indent);
}
function getSerialize(serializer, decycler) {
    var stack = [], keys = [];
    if (!decycler)
        decycler = function (_, value) {
            if (stack[0] === value)
                return "[Circular ~]";
            return "[Circular ~." + keys.slice(0, stack.indexOf(value)).join(".") + "]";
        };
    return function (key, value) {
        if (stack.length > 0) {
            var thisPos = stack.indexOf(this);
            ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
            ~thisPos ? keys.splice(thisPos, Infinity, key) : keys.push(key);
            if (~stack.indexOf(value))
                value = decycler.call(this, key, value);
        }
        else
            stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
    };
}
function isImmutableDefault(value) {
    return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignorePaths, obj) {
    var trackedProperties = trackProperties(isImmutable, ignorePaths, obj);
    return {
        detectMutations: function () {
            return detectMutations(isImmutable, ignorePaths, trackedProperties, obj);
        }
    };
}
function trackProperties(isImmutable, ignorePaths, obj, path) {
    if (ignorePaths === void 0) { ignorePaths = []; }
    if (path === void 0) { path = ""; }
    var tracked = { value: obj };
    if (!isImmutable(obj)) {
        tracked.children = {};
        for (var key in obj) {
            var childPath = path ? path + "." + key : key;
            if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
                continue;
            }
            tracked.children[key] = trackProperties(isImmutable, ignorePaths, obj[key], childPath);
        }
    }
    return tracked;
}
function detectMutations(isImmutable, ignorePaths, trackedProperty, obj, sameParentRef, path) {
    if (ignorePaths === void 0) { ignorePaths = []; }
    if (sameParentRef === void 0) { sameParentRef = false; }
    if (path === void 0) { path = ""; }
    var prevObj = trackedProperty ? trackedProperty.value : void 0;
    var sameRef = prevObj === obj;
    if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
        return { wasMutated: true, path: path };
    }
    if (isImmutable(prevObj) || isImmutable(obj)) {
        return { wasMutated: false };
    }
    var keysToDetect = {};
    for (var key in trackedProperty.children) {
        keysToDetect[key] = true;
    }
    for (var key in obj) {
        keysToDetect[key] = true;
    }
    for (var key in keysToDetect) {
        var childPath = path ? path + "." + key : key;
        if (ignorePaths.length && ignorePaths.indexOf(childPath) !== -1) {
            continue;
        }
        var result = detectMutations(isImmutable, ignorePaths, trackedProperty.children[key], obj[key], sameRef, childPath);
        if (result.wasMutated) {
            return result;
        }
    }
    return { wasMutated: false };
}
function createImmutableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isImmutable, isImmutable = _c === void 0 ? isImmutableDefault : _c, ignoredPaths = options.ignoredPaths, _d = options.warnAfter, warnAfter = _d === void 0 ? 32 : _d, ignore = options.ignore;
    ignoredPaths = ignoredPaths || ignore;
    var track = trackForMutations.bind(null, isImmutable, ignoredPaths);
    return function (_c) {
        var getState = _c.getState;
        var state = getState();
        var tracker = track(state);
        var result;
        return function (next) { return function (action) {
            var measureUtils = getTimeMeasureUtils(warnAfter, "ImmutableStateInvariantMiddleware");
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                invariant(!result.wasMutated, "A state mutation was detected between dispatches, in the path '" + (result.path || "") + "'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            var dispatchedAction = next(action);
            measureUtils.measureTime(function () {
                state = getState();
                result = tracker.detectMutations();
                tracker = track(state);
                result.wasMutated && invariant(!result.wasMutated, "A state mutation was detected inside a dispatch, in the path: " + (result.path || "") + ". Take a look at the reducer(s) handling the action " + stringify(action) + ". (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)");
            });
            measureUtils.warnIfExceeded();
            return dispatchedAction;
        }; };
    };
}
// src/serializableStateInvariantMiddleware.ts
function isPlain(val) {
    var type = typeof val;
    return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || redux_toolkit_esm_isPlainObject(val);
}
function findNonSerializableValue(value, path, isSerializable, getEntries, ignoredPaths) {
    if (path === void 0) { path = ""; }
    if (isSerializable === void 0) { isSerializable = isPlain; }
    if (ignoredPaths === void 0) { ignoredPaths = []; }
    var foundNestedSerializable;
    if (!isSerializable(value)) {
        return {
            keyPath: path || "<root>",
            value: value
        };
    }
    if (typeof value !== "object" || value === null) {
        return false;
    }
    var entries = getEntries != null ? getEntries(value) : Object.entries(value);
    var hasIgnoredPaths = ignoredPaths.length > 0;
    for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
        var _c = entries_1[_i], key = _c[0], nestedValue = _c[1];
        var nestedPath = path ? path + "." + key : key;
        if (hasIgnoredPaths && ignoredPaths.indexOf(nestedPath) >= 0) {
            continue;
        }
        if (!isSerializable(nestedValue)) {
            return {
                keyPath: nestedPath,
                value: nestedValue
            };
        }
        if (typeof nestedValue === "object") {
            foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths);
            if (foundNestedSerializable) {
                return foundNestedSerializable;
            }
        }
    }
    return false;
}
function createSerializableStateInvariantMiddleware(options) {
    if (options === void 0) { options = {}; }
    if (true) {
        return function () { return function (next) { return function (action) { return next(action); }; }; };
    }
    var _c = options.isSerializable, isSerializable = _c === void 0 ? isPlain : _c, getEntries = options.getEntries, _d = options.ignoredActions, ignoredActions = _d === void 0 ? [] : _d, _e = options.ignoredActionPaths, ignoredActionPaths = _e === void 0 ? ["meta.arg", "meta.baseQueryMeta"] : _e, _f = options.ignoredPaths, ignoredPaths = _f === void 0 ? [] : _f, _g = options.warnAfter, warnAfter = _g === void 0 ? 32 : _g, _h = options.ignoreState, ignoreState = _h === void 0 ? false : _h, _j = options.ignoreActions, ignoreActions = _j === void 0 ? false : _j;
    return function (storeAPI) { return function (next) { return function (action) {
        var result = next(action);
        var measureUtils = getTimeMeasureUtils(warnAfter, "SerializableStateInvariantMiddleware");
        if (!ignoreActions && !(ignoredActions.length && ignoredActions.indexOf(action.type) !== -1)) {
            measureUtils.measureTime(function () {
                var foundActionNonSerializableValue = findNonSerializableValue(action, "", isSerializable, getEntries, ignoredActionPaths);
                if (foundActionNonSerializableValue) {
                    var keyPath = foundActionNonSerializableValue.keyPath, value = foundActionNonSerializableValue.value;
                    console.error("A non-serializable value was detected in an action, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the logic that dispatched this action: ", action, "\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)", "\n(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)");
                }
            });
        }
        if (!ignoreState) {
            measureUtils.measureTime(function () {
                var state = storeAPI.getState();
                var foundStateNonSerializableValue = findNonSerializableValue(state, "", isSerializable, getEntries, ignoredPaths);
                if (foundStateNonSerializableValue) {
                    var keyPath = foundStateNonSerializableValue.keyPath, value = foundStateNonSerializableValue.value;
                    console.error("A non-serializable value was detected in the state, in the path: `" + keyPath + "`. Value:", value, "\nTake a look at the reducer(s) handling this action type: " + action.type + ".\n(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)");
                }
            });
            measureUtils.warnIfExceeded();
        }
        return result;
    }; }; };
}
// src/getDefaultMiddleware.ts
function isBoolean(x) {
    return typeof x === "boolean";
}
function curryGetDefaultMiddleware() {
    return function curriedGetDefaultMiddleware(options) {
        return getDefaultMiddleware(options);
    };
}
function getDefaultMiddleware(options) {
    if (options === void 0) { options = {}; }
    var _c = options.thunk, thunk = _c === void 0 ? true : _c, _d = options.immutableCheck, immutableCheck = _d === void 0 ? true : _d, _e = options.serializableCheck, serializableCheck = _e === void 0 ? true : _e;
    var middlewareArray = new MiddlewareArray();
    if (thunk) {
        if (isBoolean(thunk)) {
            middlewareArray.push(es);
        }
        else {
            middlewareArray.push(es.withExtraArgument(thunk.extraArgument));
        }
    }
    if (false) { var serializableOptions, immutableOptions; }
    return middlewareArray;
}
// src/configureStore.ts
var IS_PRODUCTION = "production" === "production";
function configureStore(options) {
    var curriedGetDefaultMiddleware = curryGetDefaultMiddleware();
    var _c = options || {}, _d = _c.reducer, reducer = _d === void 0 ? void 0 : _d, _e = _c.middleware, middleware = _e === void 0 ? curriedGetDefaultMiddleware() : _e, _f = _c.devTools, devTools = _f === void 0 ? true : _f, _g = _c.preloadedState, preloadedState = _g === void 0 ? void 0 : _g, _h = _c.enhancers, enhancers = _h === void 0 ? void 0 : _h;
    var rootReducer;
    if (typeof reducer === "function") {
        rootReducer = reducer;
    }
    else if (redux_toolkit_esm_isPlainObject(reducer)) {
        rootReducer = combineReducers(reducer);
    }
    else {
        throw new Error('"reducer" is a required argument, and must be a function or an object of functions that can be passed to combineReducers');
    }
    var finalMiddleware = middleware;
    if (typeof finalMiddleware === "function") {
        finalMiddleware = finalMiddleware(curriedGetDefaultMiddleware);
        if (!IS_PRODUCTION && !Array.isArray(finalMiddleware)) {
            throw new Error("when using a middleware builder function, an array of middleware must be returned");
        }
    }
    if (!IS_PRODUCTION && finalMiddleware.some(function (item) { return typeof item !== "function"; })) {
        throw new Error("each middleware provided to configureStore must be a function");
    }
    var middlewareEnhancer = applyMiddleware.apply(void 0, finalMiddleware);
    var finalCompose = compose;
    if (devTools) {
        finalCompose = composeWithDevTools(__spreadValues({
            trace: !IS_PRODUCTION
        }, typeof devTools === "object" && devTools));
    }
    var storeEnhancers = [middlewareEnhancer];
    if (Array.isArray(enhancers)) {
        storeEnhancers = __spreadArray([middlewareEnhancer], enhancers);
    }
    else if (typeof enhancers === "function") {
        storeEnhancers = enhancers(storeEnhancers);
    }
    var composedEnhancer = finalCompose.apply(void 0, storeEnhancers);
    return createStore(rootReducer, preloadedState, composedEnhancer);
}
// src/createAction.ts
function createAction(type, prepareAction) {
    function actionCreator() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (prepareAction) {
            var prepared = prepareAction.apply(void 0, args);
            if (!prepared) {
                throw new Error("prepareAction did not return an object");
            }
            return __spreadValues(__spreadValues({
                type: type,
                payload: prepared.payload
            }, "meta" in prepared && { meta: prepared.meta }), "error" in prepared && { error: prepared.error });
        }
        return { type: type, payload: args[0] };
    }
    actionCreator.toString = function () { return "" + type; };
    actionCreator.type = type;
    actionCreator.match = function (action) { return action.type === type; };
    return actionCreator;
}
function isFSA(action) {
    return redux_toolkit_esm_isPlainObject(action) && typeof action.type === "string" && Object.keys(action).every(isValidKey);
}
function isValidKey(key) {
    return ["type", "payload", "error", "meta"].indexOf(key) > -1;
}
function getType(actionCreator) {
    return "" + actionCreator;
}
// src/createReducer.ts

// src/mapBuilders.ts
function executeReducerBuilderCallback(builderCallback) {
    var actionsMap = {};
    var actionMatchers = [];
    var defaultCaseReducer;
    var builder = {
        addCase: function (typeOrActionCreator, reducer) {
            if (false) {}
            var type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
            if (type in actionsMap) {
                throw new Error("addCase cannot be called with two reducers for the same action type");
            }
            actionsMap[type] = reducer;
            return builder;
        },
        addMatcher: function (matcher, reducer) {
            if (false) {}
            actionMatchers.push({ matcher: matcher, reducer: reducer });
            return builder;
        },
        addDefaultCase: function (reducer) {
            if (false) {}
            defaultCaseReducer = reducer;
            return builder;
        }
    };
    builderCallback(builder);
    return [actionsMap, actionMatchers, defaultCaseReducer];
}
// src/createReducer.ts
function isStateFunction(x) {
    return typeof x === "function";
}
var hasWarnedAboutObjectNotation = false;
function createReducer(initialState, mapOrBuilderCallback, actionMatchers, defaultCaseReducer) {
    if (actionMatchers === void 0) { actionMatchers = []; }
    if (false) {}
    var _c = typeof mapOrBuilderCallback === "function" ? executeReducerBuilderCallback(mapOrBuilderCallback) : [mapOrBuilderCallback, actionMatchers, defaultCaseReducer], actionsMap = _c[0], finalActionMatchers = _c[1], finalDefaultCaseReducer = _c[2];
    var getInitialState;
    if (isStateFunction(initialState)) {
        getInitialState = function () { return freezeDraftable(initialState()); };
    }
    else {
        var frozenInitialState_1 = freezeDraftable(initialState);
        getInitialState = function () { return frozenInitialState_1; };
    }
    function reducer(state, action) {
        if (state === void 0) { state = getInitialState(); }
        var caseReducers = __spreadArray([
            actionsMap[action.type]
        ], finalActionMatchers.filter(function (_c) {
            var matcher = _c.matcher;
            return matcher(action);
        }).map(function (_c) {
            var reducer2 = _c.reducer;
            return reducer2;
        }));
        if (caseReducers.filter(function (cr) { return !!cr; }).length === 0) {
            caseReducers = [finalDefaultCaseReducer];
        }
        return caseReducers.reduce(function (previousState, caseReducer) {
            if (caseReducer) {
                if ((0,immer_esm/* isDraft */.mv)(previousState)) {
                    var draft = previousState;
                    var result = caseReducer(draft, action);
                    if (result === void 0) {
                        return previousState;
                    }
                    return result;
                }
                else if (!(0,immer_esm/* isDraftable */.o$)(previousState)) {
                    var result = caseReducer(previousState, action);
                    if (result === void 0) {
                        if (previousState === null) {
                            return previousState;
                        }
                        throw Error("A case reducer on a non-draftable value must not return undefined");
                    }
                    return result;
                }
                else {
                    return (0,immer_esm/* default */.ZP)(previousState, function (draft) {
                        return caseReducer(draft, action);
                    });
                }
            }
            return previousState;
        }, state);
    }
    reducer.getInitialState = getInitialState;
    return reducer;
}
// src/createSlice.ts
var hasWarnedAboutObjectNotation2 = false;
function getType2(slice, actionKey) {
    return slice + "/" + actionKey;
}
function createSlice(options) {
    var name = options.name;
    if (!name) {
        throw new Error("`name` is a required option for createSlice");
    }
    if (typeof process !== "undefined" && "production" === "development") {}
    var initialState = typeof options.initialState == "function" ? options.initialState : freezeDraftable(options.initialState);
    var reducers = options.reducers || {};
    var reducerNames = Object.keys(reducers);
    var sliceCaseReducersByName = {};
    var sliceCaseReducersByType = {};
    var actionCreators = {};
    reducerNames.forEach(function (reducerName) {
        var maybeReducerWithPrepare = reducers[reducerName];
        var type = getType2(name, reducerName);
        var caseReducer;
        var prepareCallback;
        if ("reducer" in maybeReducerWithPrepare) {
            caseReducer = maybeReducerWithPrepare.reducer;
            prepareCallback = maybeReducerWithPrepare.prepare;
        }
        else {
            caseReducer = maybeReducerWithPrepare;
        }
        sliceCaseReducersByName[reducerName] = caseReducer;
        sliceCaseReducersByType[type] = caseReducer;
        actionCreators[reducerName] = prepareCallback ? createAction(type, prepareCallback) : createAction(type);
    });
    function buildReducer() {
        if (false) {}
        var _c = typeof options.extraReducers === "function" ? executeReducerBuilderCallback(options.extraReducers) : [options.extraReducers], _d = _c[0], extraReducers = _d === void 0 ? {} : _d, _e = _c[1], actionMatchers = _e === void 0 ? [] : _e, _f = _c[2], defaultCaseReducer = _f === void 0 ? void 0 : _f;
        var finalCaseReducers = __spreadValues(__spreadValues({}, extraReducers), sliceCaseReducersByType);
        return createReducer(initialState, function (builder) {
            for (var key in finalCaseReducers) {
                builder.addCase(key, finalCaseReducers[key]);
            }
            for (var _i = 0, actionMatchers_1 = actionMatchers; _i < actionMatchers_1.length; _i++) {
                var m = actionMatchers_1[_i];
                builder.addMatcher(m.matcher, m.reducer);
            }
            if (defaultCaseReducer) {
                builder.addDefaultCase(defaultCaseReducer);
            }
        });
    }
    var _reducer;
    return {
        name: name,
        reducer: function (state, action) {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer(state, action);
        },
        actions: actionCreators,
        caseReducers: sliceCaseReducersByName,
        getInitialState: function () {
            if (!_reducer)
                _reducer = buildReducer();
            return _reducer.getInitialState();
        }
    };
}
// src/entities/entity_state.ts
function getInitialEntityState() {
    return {
        ids: [],
        entities: {}
    };
}
function createInitialStateFactory() {
    function getInitialState(additionalState) {
        if (additionalState === void 0) { additionalState = {}; }
        return Object.assign(getInitialEntityState(), additionalState);
    }
    return { getInitialState: getInitialState };
}
// src/entities/state_selectors.ts
function createSelectorsFactory() {
    function getSelectors(selectState) {
        var selectIds = function (state) { return state.ids; };
        var selectEntities = function (state) { return state.entities; };
        var selectAll = createDraftSafeSelector(selectIds, selectEntities, function (ids, entities) { return ids.map(function (id) { return entities[id]; }); });
        var selectId = function (_, id) { return id; };
        var selectById = function (entities, id) { return entities[id]; };
        var selectTotal = createDraftSafeSelector(selectIds, function (ids) { return ids.length; });
        if (!selectState) {
            return {
                selectIds: selectIds,
                selectEntities: selectEntities,
                selectAll: selectAll,
                selectTotal: selectTotal,
                selectById: createDraftSafeSelector(selectEntities, selectId, selectById)
            };
        }
        var selectGlobalizedEntities = createDraftSafeSelector(selectState, selectEntities);
        return {
            selectIds: createDraftSafeSelector(selectState, selectIds),
            selectEntities: selectGlobalizedEntities,
            selectAll: createDraftSafeSelector(selectState, selectAll),
            selectTotal: createDraftSafeSelector(selectState, selectTotal),
            selectById: createDraftSafeSelector(selectGlobalizedEntities, selectId, selectById)
        };
    }
    return { getSelectors: getSelectors };
}
// src/entities/state_adapter.ts

function createSingleArgumentStateOperator(mutator) {
    var operator = createStateOperator(function (_, state) { return mutator(state); });
    return function operation(state) {
        return operator(state, void 0);
    };
}
function createStateOperator(mutator) {
    return function operation(state, arg) {
        function isPayloadActionArgument(arg2) {
            return isFSA(arg2);
        }
        var runMutator = function (draft) {
            if (isPayloadActionArgument(arg)) {
                mutator(arg.payload, draft);
            }
            else {
                mutator(arg, draft);
            }
        };
        if (isDraft3(state)) {
            runMutator(state);
            return state;
        }
        else {
            return createNextState3(state, runMutator);
        }
    };
}
// src/entities/utils.ts
function selectIdValue(entity, selectId) {
    var key = selectId(entity);
    if (false) {}
    return key;
}
function ensureEntitiesArray(entities) {
    if (!Array.isArray(entities)) {
        entities = Object.values(entities);
    }
    return entities;
}
function splitAddedUpdatedEntities(newEntities, selectId, state) {
    newEntities = ensureEntitiesArray(newEntities);
    var added = [];
    var updated = [];
    for (var _i = 0, newEntities_1 = newEntities; _i < newEntities_1.length; _i++) {
        var entity = newEntities_1[_i];
        var id = selectIdValue(entity, selectId);
        if (id in state.entities) {
            updated.push({ id: id, changes: entity });
        }
        else {
            added.push(entity);
        }
    }
    return [added, updated];
}
// src/entities/unsorted_state_adapter.ts
function createUnsortedStateAdapter(selectId) {
    function addOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (key in state.entities) {
            return;
        }
        state.ids.push(key);
        state.entities[key] = entity;
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (var _i = 0, newEntities_2 = newEntities; _i < newEntities_2.length; _i++) {
            var entity = newEntities_2[_i];
            addOneMutably(entity, state);
        }
    }
    function setOneMutably(entity, state) {
        var key = selectIdValue(entity, selectId);
        if (!(key in state.entities)) {
            state.ids.push(key);
        }
        state.entities[key] = entity;
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        for (var _i = 0, newEntities_3 = newEntities; _i < newEntities_3.length; _i++) {
            var entity = newEntities_3[_i];
            setOneMutably(entity, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.ids = [];
        state.entities = {};
        addManyMutably(newEntities, state);
    }
    function removeOneMutably(key, state) {
        return removeManyMutably([key], state);
    }
    function removeManyMutably(keys, state) {
        var didMutate = false;
        keys.forEach(function (key) {
            if (key in state.entities) {
                delete state.entities[key];
                didMutate = true;
            }
        });
        if (didMutate) {
            state.ids = state.ids.filter(function (id) { return id in state.entities; });
        }
    }
    function removeAllMutably(state) {
        Object.assign(state, {
            ids: [],
            entities: {}
        });
    }
    function takeNewKey(keys, update, state) {
        var original2 = state.entities[update.id];
        var updated = Object.assign({}, original2, update.changes);
        var newKey = selectIdValue(updated, selectId);
        var hasNewKey = newKey !== update.id;
        if (hasNewKey) {
            keys[update.id] = newKey;
            delete state.entities[update.id];
        }
        state.entities[newKey] = updated;
        return hasNewKey;
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([update], state);
    }
    function updateManyMutably(updates, state) {
        var newKeys = {};
        var updatesPerEntity = {};
        updates.forEach(function (update) {
            if (update.id in state.entities) {
                updatesPerEntity[update.id] = {
                    id: update.id,
                    changes: __spreadValues(__spreadValues({}, updatesPerEntity[update.id] ? updatesPerEntity[update.id].changes : null), update.changes)
                };
            }
        });
        updates = Object.values(updatesPerEntity);
        var didMutateEntities = updates.length > 0;
        if (didMutateEntities) {
            var didMutateIds = updates.filter(function (update) { return takeNewKey(newKeys, update, state); }).length > 0;
            if (didMutateIds) {
                state.ids = Object.keys(state.entities);
            }
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([entity], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    return {
        removeAll: createSingleArgumentStateOperator(removeAllMutably),
        addOne: createStateOperator(addOneMutably),
        addMany: createStateOperator(addManyMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        updateOne: createStateOperator(updateOneMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        upsertMany: createStateOperator(upsertManyMutably),
        removeOne: createStateOperator(removeOneMutably),
        removeMany: createStateOperator(removeManyMutably)
    };
}
// src/entities/sorted_state_adapter.ts
function createSortedStateAdapter(selectId, sort) {
    var _c = createUnsortedStateAdapter(selectId), removeOne = _c.removeOne, removeMany = _c.removeMany, removeAll = _c.removeAll;
    function addOneMutably(entity, state) {
        return addManyMutably([entity], state);
    }
    function addManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        var models = newEntities.filter(function (model) { return !(selectIdValue(model, selectId) in state.entities); });
        if (models.length !== 0) {
            merge(models, state);
        }
    }
    function setOneMutably(entity, state) {
        return setManyMutably([entity], state);
    }
    function setManyMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        if (newEntities.length !== 0) {
            merge(newEntities, state);
        }
    }
    function setAllMutably(newEntities, state) {
        newEntities = ensureEntitiesArray(newEntities);
        state.entities = {};
        state.ids = [];
        addManyMutably(newEntities, state);
    }
    function updateOneMutably(update, state) {
        return updateManyMutably([update], state);
    }
    function updateManyMutably(updates, state) {
        var appliedUpdates = false;
        for (var _i = 0, updates_1 = updates; _i < updates_1.length; _i++) {
            var update = updates_1[_i];
            var entity = state.entities[update.id];
            if (!entity) {
                continue;
            }
            appliedUpdates = true;
            Object.assign(entity, update.changes);
            var newId = selectId(entity);
            if (update.id !== newId) {
                delete state.entities[update.id];
                state.entities[newId] = entity;
            }
        }
        if (appliedUpdates) {
            resortEntities(state);
        }
    }
    function upsertOneMutably(entity, state) {
        return upsertManyMutably([entity], state);
    }
    function upsertManyMutably(newEntities, state) {
        var _c = splitAddedUpdatedEntities(newEntities, selectId, state), added = _c[0], updated = _c[1];
        updateManyMutably(updated, state);
        addManyMutably(added, state);
    }
    function areArraysEqual(a, b) {
        if (a.length !== b.length) {
            return false;
        }
        for (var i = 0; i < a.length && i < b.length; i++) {
            if (a[i] === b[i]) {
                continue;
            }
            return false;
        }
        return true;
    }
    function merge(models, state) {
        models.forEach(function (model) {
            state.entities[selectId(model)] = model;
        });
        resortEntities(state);
    }
    function resortEntities(state) {
        var allEntities = Object.values(state.entities);
        allEntities.sort(sort);
        var newSortedIds = allEntities.map(selectId);
        var ids = state.ids;
        if (!areArraysEqual(ids, newSortedIds)) {
            state.ids = newSortedIds;
        }
    }
    return {
        removeOne: removeOne,
        removeMany: removeMany,
        removeAll: removeAll,
        addOne: createStateOperator(addOneMutably),
        updateOne: createStateOperator(updateOneMutably),
        upsertOne: createStateOperator(upsertOneMutably),
        setOne: createStateOperator(setOneMutably),
        setMany: createStateOperator(setManyMutably),
        setAll: createStateOperator(setAllMutably),
        addMany: createStateOperator(addManyMutably),
        updateMany: createStateOperator(updateManyMutably),
        upsertMany: createStateOperator(upsertManyMutably)
    };
}
// src/entities/create_adapter.ts
function createEntityAdapter(options) {
    if (options === void 0) { options = {}; }
    var _c = __spreadValues({
        sortComparer: false,
        selectId: function (instance) { return instance.id; }
    }, options), selectId = _c.selectId, sortComparer = _c.sortComparer;
    var stateFactory = createInitialStateFactory();
    var selectorsFactory = createSelectorsFactory();
    var stateAdapter = sortComparer ? createSortedStateAdapter(selectId, sortComparer) : createUnsortedStateAdapter(selectId);
    return __spreadValues(__spreadValues(__spreadValues({
        selectId: selectId,
        sortComparer: sortComparer
    }, stateFactory), selectorsFactory), stateAdapter);
}
// src/nanoid.ts
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = function (size) {
    if (size === void 0) { size = 21; }
    var id = "";
    var i = size;
    while (i--) {
        id += urlAlphabet[Math.random() * 64 | 0];
    }
    return id;
};
// src/createAsyncThunk.ts
var commonProperties = [
    "name",
    "message",
    "stack",
    "code"
];
var RejectWithValue = /** @class */ (function () {
    function RejectWithValue(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return RejectWithValue;
}());
var FulfillWithMeta = /** @class */ (function () {
    function FulfillWithMeta(payload, meta) {
        this.payload = payload;
        this.meta = meta;
    }
    return FulfillWithMeta;
}());
var miniSerializeError = function (value) {
    if (typeof value === "object" && value !== null) {
        var simpleError = {};
        for (var _i = 0, commonProperties_1 = commonProperties; _i < commonProperties_1.length; _i++) {
            var property = commonProperties_1[_i];
            if (typeof value[property] === "string") {
                simpleError[property] = value[property];
            }
        }
        return simpleError;
    }
    return { message: String(value) };
};
var createAsyncThunk = (function () {
    function createAsyncThunk2(typePrefix, payloadCreator, options) {
        var fulfilled = createAction(typePrefix + "/fulfilled", function (payload, requestId, arg, meta) { return ({
            payload: payload,
            meta: __spreadProps(__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                requestStatus: "fulfilled"
            })
        }); });
        var pending = createAction(typePrefix + "/pending", function (requestId, arg, meta) { return ({
            payload: void 0,
            meta: __spreadProps(__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                requestStatus: "pending"
            })
        }); });
        var rejected = createAction(typePrefix + "/rejected", function (error, requestId, arg, payload, meta) { return ({
            payload: payload,
            error: (options && options.serializeError || miniSerializeError)(error || "Rejected"),
            meta: __spreadProps(__spreadValues({}, meta || {}), {
                arg: arg,
                requestId: requestId,
                rejectedWithValue: !!payload,
                requestStatus: "rejected",
                aborted: (error == null ? void 0 : error.name) === "AbortError",
                condition: (error == null ? void 0 : error.name) === "ConditionError"
            })
        }); });
        var displayedWarning = false;
        var AC = typeof AbortController !== "undefined" ? AbortController : /** @class */ (function () {
            function class_1() {
                this.signal = {
                    aborted: false,
                    addEventListener: function () {
                    },
                    dispatchEvent: function () {
                        return false;
                    },
                    onabort: function () {
                    },
                    removeEventListener: function () {
                    },
                    reason: void 0,
                    throwIfAborted: function () {
                    }
                };
            }
            class_1.prototype.abort = function () {
                if (false) {}
            };
            return class_1;
        }());
        function actionCreator(arg) {
            return function (dispatch, getState, extra) {
                var requestId = (options == null ? void 0 : options.idGenerator) ? options.idGenerator(arg) : nanoid();
                var abortController = new AC();
                var abortReason;
                var started = false;
                function abort(reason) {
                    abortReason = reason;
                    abortController.abort();
                }
                var promise2 = function () {
                    return __async(this, null, function () {
                        var _a, _b, finalAction, conditionResult, abortedPromise, err_1, skipDispatch;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    _c.trys.push([0, 4, , 5]);
                                    conditionResult = (_a = options == null ? void 0 : options.condition) == null ? void 0 : _a.call(options, arg, { getState: getState, extra: extra });
                                    if (!isThenable(conditionResult)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, conditionResult];
                                case 1:
                                    conditionResult = _c.sent();
                                    _c.label = 2;
                                case 2:
                                    if (conditionResult === false || abortController.signal.aborted) {
                                        throw {
                                            name: "ConditionError",
                                            message: "Aborted due to condition callback returning false."
                                        };
                                    }
                                    started = true;
                                    abortedPromise = new Promise(function (_, reject) { return abortController.signal.addEventListener("abort", function () { return reject({
                                        name: "AbortError",
                                        message: abortReason || "Aborted"
                                    }); }); });
                                    dispatch(pending(requestId, arg, (_b = options == null ? void 0 : options.getPendingMeta) == null ? void 0 : _b.call(options, { requestId: requestId, arg: arg }, { getState: getState, extra: extra })));
                                    return [4 /*yield*/, Promise.race([
                                            abortedPromise,
                                            Promise.resolve(payloadCreator(arg, {
                                                dispatch: dispatch,
                                                getState: getState,
                                                extra: extra,
                                                requestId: requestId,
                                                signal: abortController.signal,
                                                abort: abort,
                                                rejectWithValue: function (value, meta) {
                                                    return new RejectWithValue(value, meta);
                                                },
                                                fulfillWithValue: function (value, meta) {
                                                    return new FulfillWithMeta(value, meta);
                                                }
                                            })).then(function (result) {
                                                if (result instanceof RejectWithValue) {
                                                    throw result;
                                                }
                                                if (result instanceof FulfillWithMeta) {
                                                    return fulfilled(result.payload, requestId, arg, result.meta);
                                                }
                                                return fulfilled(result, requestId, arg);
                                            })
                                        ])];
                                case 3:
                                    finalAction = _c.sent();
                                    return [3 /*break*/, 5];
                                case 4:
                                    err_1 = _c.sent();
                                    finalAction = err_1 instanceof RejectWithValue ? rejected(null, requestId, arg, err_1.payload, err_1.meta) : rejected(err_1, requestId, arg);
                                    return [3 /*break*/, 5];
                                case 5:
                                    skipDispatch = options && !options.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
                                    if (!skipDispatch) {
                                        dispatch(finalAction);
                                    }
                                    return [2 /*return*/, finalAction];
                            }
                        });
                    });
                }();
                return Object.assign(promise2, {
                    abort: abort,
                    requestId: requestId,
                    arg: arg,
                    unwrap: function () {
                        return promise2.then(unwrapResult);
                    }
                });
            };
        }
        return Object.assign(actionCreator, {
            pending: pending,
            rejected: rejected,
            fulfilled: fulfilled,
            typePrefix: typePrefix
        });
    }
    createAsyncThunk2.withTypes = function () { return createAsyncThunk2; };
    return createAsyncThunk2;
})();
function unwrapResult(action) {
    if (action.meta && action.meta.rejectedWithValue) {
        throw action.payload;
    }
    if (action.error) {
        throw action.error;
    }
    return action.payload;
}
function isThenable(value) {
    return value !== null && typeof value === "object" && typeof value.then === "function";
}
// src/tsHelpers.ts
var hasMatchFunction = function (v) {
    return v && typeof v.match === "function";
};
// src/matchers.ts
var matches = function (matcher, action) {
    if (hasMatchFunction(matcher)) {
        return matcher.match(action);
    }
    else {
        return matcher(action);
    }
};
function isAnyOf() {
    var matchers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        matchers[_i] = arguments[_i];
    }
    return function (action) {
        return matchers.some(function (matcher) { return matches(matcher, action); });
    };
}
function isAllOf() {
    var matchers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        matchers[_i] = arguments[_i];
    }
    return function (action) {
        return matchers.every(function (matcher) { return matches(matcher, action); });
    };
}
function hasExpectedRequestMetadata(action, validStatus) {
    if (!action || !action.meta)
        return false;
    var hasValidRequestId = typeof action.meta.requestId === "string";
    var hasValidRequestStatus = validStatus.indexOf(action.meta.requestStatus) > -1;
    return hasValidRequestId && hasValidRequestStatus;
}
function isAsyncThunkArray(a) {
    return typeof a[0] === "function" && "pending" in a[0] && "fulfilled" in a[0] && "rejected" in a[0];
}
function isPending() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["pending"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isPending()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.pending; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejected() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["rejected"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isRejected()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.rejected; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isRejectedWithValue() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    var hasFlag = function (action) {
        return action && action.meta && action.meta.rejectedWithValue;
    };
    if (asyncThunks.length === 0) {
        return function (action) {
            var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
            return combinedMatcher(action);
        };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isRejectedWithValue()(asyncThunks[0]);
    }
    return function (action) {
        var combinedMatcher = isAllOf(isRejected.apply(void 0, asyncThunks), hasFlag);
        return combinedMatcher(action);
    };
}
function isFulfilled() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["fulfilled"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isFulfilled()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = asyncThunks.map(function (asyncThunk) { return asyncThunk.fulfilled; });
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
function isAsyncThunkAction() {
    var asyncThunks = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        asyncThunks[_i] = arguments[_i];
    }
    if (asyncThunks.length === 0) {
        return function (action) { return hasExpectedRequestMetadata(action, ["pending", "fulfilled", "rejected"]); };
    }
    if (!isAsyncThunkArray(asyncThunks)) {
        return isAsyncThunkAction()(asyncThunks[0]);
    }
    return function (action) {
        var matchers = [];
        for (var _i = 0, asyncThunks_1 = asyncThunks; _i < asyncThunks_1.length; _i++) {
            var asyncThunk = asyncThunks_1[_i];
            matchers.push(asyncThunk.pending, asyncThunk.rejected, asyncThunk.fulfilled);
        }
        var combinedMatcher = isAnyOf.apply(void 0, matchers);
        return combinedMatcher(action);
    };
}
// src/listenerMiddleware/utils.ts
var assertFunction = function (func, expected) {
    if (typeof func !== "function") {
        throw new TypeError(expected + " is not a function");
    }
};
var noop = function () {
};
var catchRejection = function (promise2, onError) {
    if (onError === void 0) { onError = noop; }
    promise2.catch(onError);
    return promise2;
};
var addAbortSignalListener = function (abortSignal, callback) {
    abortSignal.addEventListener("abort", callback, { once: true });
};
var abortControllerWithReason = function (abortController, reason) {
    var signal = abortController.signal;
    if (signal.aborted) {
        return;
    }
    if (!("reason" in signal)) {
        Object.defineProperty(signal, "reason", {
            enumerable: true,
            value: reason,
            configurable: true,
            writable: true
        });
    }
    ;
    abortController.abort(reason);
};
// src/listenerMiddleware/exceptions.ts
var task = "task";
var listener = "listener";
var completed = "completed";
var cancelled = "cancelled";
var taskCancelled = "task-" + cancelled;
var taskCompleted = "task-" + completed;
var listenerCancelled = listener + "-" + cancelled;
var listenerCompleted = listener + "-" + completed;
var TaskAbortError = /** @class */ (function () {
    function TaskAbortError(code) {
        this.code = code;
        this.name = "TaskAbortError";
        this.message = task + " " + cancelled + " (reason: " + code + ")";
    }
    return TaskAbortError;
}());
// src/listenerMiddleware/task.ts
var validateActive = function (signal) {
    if (signal.aborted) {
        throw new TaskAbortError(signal.reason);
    }
};
var promisifyAbortSignal = function (signal) {
    return catchRejection(new Promise(function (_, reject) {
        var notifyRejection = function () { return reject(new TaskAbortError(signal.reason)); };
        if (signal.aborted) {
            notifyRejection();
        }
        else {
            addAbortSignalListener(signal, notifyRejection);
        }
    }));
};
var runTask = function (task2, cleanUp) { return __async(void 0, null, function () {
    var value, error_1;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                _c.trys.push([0, 3, 4, 5]);
                return [4 /*yield*/, Promise.resolve()];
            case 1:
                _c.sent();
                return [4 /*yield*/, task2()];
            case 2:
                value = _c.sent();
                return [2 /*return*/, {
                        status: "ok",
                        value: value
                    }];
            case 3:
                error_1 = _c.sent();
                return [2 /*return*/, {
                        status: error_1 instanceof TaskAbortError ? "cancelled" : "rejected",
                        error: error_1
                    }];
            case 4:
                cleanUp == null ? void 0 : cleanUp();
                return [7 /*endfinally*/];
            case 5: return [2 /*return*/];
        }
    });
}); };
var createPause = function (signal) {
    return function (promise2) {
        return catchRejection(Promise.race([promisifyAbortSignal(signal), promise2]).then(function (output) {
            validateActive(signal);
            return output;
        }));
    };
};
var createDelay = function (signal) {
    var pause = createPause(signal);
    return function (timeoutMs) {
        return pause(new Promise(function (resolve) { return setTimeout(resolve, timeoutMs); }));
    };
};
// src/listenerMiddleware/index.ts
var redux_toolkit_esm_assign = Object.assign;
var INTERNAL_NIL_TOKEN = {};
var alm = "listenerMiddleware";
var createFork = function (parentAbortSignal) {
    var linkControllers = function (controller) { return addAbortSignalListener(parentAbortSignal, function () { return abortControllerWithReason(controller, parentAbortSignal.reason); }); };
    return function (taskExecutor) {
        assertFunction(taskExecutor, "taskExecutor");
        var childAbortController = new AbortController();
        linkControllers(childAbortController);
        var result = runTask(function () { return __async(void 0, null, function () {
            var result2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        validateActive(parentAbortSignal);
                        validateActive(childAbortController.signal);
                        return [4 /*yield*/, taskExecutor({
                                pause: createPause(childAbortController.signal),
                                delay: createDelay(childAbortController.signal),
                                signal: childAbortController.signal
                            })];
                    case 1:
                        result2 = _c.sent();
                        validateActive(childAbortController.signal);
                        return [2 /*return*/, result2];
                }
            });
        }); }, function () { return abortControllerWithReason(childAbortController, taskCompleted); });
        return {
            result: createPause(parentAbortSignal)(result),
            cancel: function () {
                abortControllerWithReason(childAbortController, taskCancelled);
            }
        };
    };
};
var createTakePattern = function (startListening, signal) {
    var take = function (predicate, timeout) { return __async(void 0, null, function () {
        var unsubscribe, tuplePromise, promises, output;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    validateActive(signal);
                    unsubscribe = function () {
                    };
                    tuplePromise = new Promise(function (resolve) {
                        unsubscribe = startListening({
                            predicate: predicate,
                            effect: function (action, listenerApi) {
                                listenerApi.unsubscribe();
                                resolve([
                                    action,
                                    listenerApi.getState(),
                                    listenerApi.getOriginalState()
                                ]);
                            }
                        });
                    });
                    promises = [
                        promisifyAbortSignal(signal),
                        tuplePromise
                    ];
                    if (timeout != null) {
                        promises.push(new Promise(function (resolve) { return setTimeout(resolve, timeout, null); }));
                    }
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, , 3, 4]);
                    return [4 /*yield*/, Promise.race(promises)];
                case 2:
                    output = _c.sent();
                    validateActive(signal);
                    return [2 /*return*/, output];
                case 3:
                    unsubscribe();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return function (predicate, timeout) { return catchRejection(take(predicate, timeout)); };
};
var getListenerEntryPropsFrom = function (options) {
    var type = options.type, actionCreator = options.actionCreator, matcher = options.matcher, predicate = options.predicate, effect = options.effect;
    if (type) {
        predicate = createAction(type).match;
    }
    else if (actionCreator) {
        type = actionCreator.type;
        predicate = actionCreator.match;
    }
    else if (matcher) {
        predicate = matcher;
    }
    else if (predicate) {
    }
    else {
        throw new Error("Creating or removing a listener requires one of the known fields for matching an action");
    }
    assertFunction(effect, "options.listener");
    return { predicate: predicate, type: type, effect: effect };
};
var createListenerEntry = function (options) {
    var _c = getListenerEntryPropsFrom(options), type = _c.type, predicate = _c.predicate, effect = _c.effect;
    var id = nanoid();
    var entry = {
        id: id,
        effect: effect,
        type: type,
        predicate: predicate,
        pending: new Set(),
        unsubscribe: function () {
            throw new Error("Unsubscribe not initialized");
        }
    };
    return entry;
};
var createClearListenerMiddleware = function (listenerMap) {
    return function () {
        listenerMap.forEach(cancelActiveListeners);
        listenerMap.clear();
    };
};
var safelyNotifyError = function (errorHandler, errorToNotify, errorInfo) {
    try {
        errorHandler(errorToNotify, errorInfo);
    }
    catch (errorHandlerError) {
        setTimeout(function () {
            throw errorHandlerError;
        }, 0);
    }
};
var addListener = createAction(alm + "/add");
var clearAllListeners = createAction(alm + "/removeAll");
var removeListener = createAction(alm + "/remove");
var defaultErrorHandler = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    console.error.apply(console, __spreadArray([alm + "/error"], args));
};
var cancelActiveListeners = function (entry) {
    entry.pending.forEach(function (controller) {
        abortControllerWithReason(controller, listenerCancelled);
    });
};
function createListenerMiddleware(middlewareOptions) {
    var _this = this;
    if (middlewareOptions === void 0) { middlewareOptions = {}; }
    var listenerMap = new Map();
    var extra = middlewareOptions.extra, _c = middlewareOptions.onError, onError = _c === void 0 ? defaultErrorHandler : _c;
    assertFunction(onError, "onError");
    var insertEntry = function (entry) {
        entry.unsubscribe = function () { return listenerMap.delete(entry.id); };
        listenerMap.set(entry.id, entry);
        return function (cancelOptions) {
            entry.unsubscribe();
            if (cancelOptions == null ? void 0 : cancelOptions.cancelActive) {
                cancelActiveListeners(entry);
            }
        };
    };
    var findListenerEntry = function (comparator) {
        for (var _i = 0, _c = Array.from(listenerMap.values()); _i < _c.length; _i++) {
            var entry = _c[_i];
            if (comparator(entry)) {
                return entry;
            }
        }
        return void 0;
    };
    var startListening = function (options) {
        var entry = findListenerEntry(function (existingEntry) { return existingEntry.effect === options.effect; });
        if (!entry) {
            entry = createListenerEntry(options);
        }
        return insertEntry(entry);
    };
    var stopListening = function (options) {
        var _c = getListenerEntryPropsFrom(options), type = _c.type, effect = _c.effect, predicate = _c.predicate;
        var entry = findListenerEntry(function (entry2) {
            var matchPredicateOrType = typeof type === "string" ? entry2.type === type : entry2.predicate === predicate;
            return matchPredicateOrType && entry2.effect === effect;
        });
        if (entry) {
            entry.unsubscribe();
            if (options.cancelActive) {
                cancelActiveListeners(entry);
            }
        }
        return !!entry;
    };
    var notifyListener = function (entry, action, api, getOriginalState) { return __async(_this, null, function () {
        var internalTaskController, take, listenerError_1;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    internalTaskController = new AbortController();
                    take = createTakePattern(startListening, internalTaskController.signal);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 3, 4, 5]);
                    entry.pending.add(internalTaskController);
                    return [4 /*yield*/, Promise.resolve(entry.effect(action, redux_toolkit_esm_assign({}, api, {
                            getOriginalState: getOriginalState,
                            condition: function (predicate, timeout) { return take(predicate, timeout).then(Boolean); },
                            take: take,
                            delay: createDelay(internalTaskController.signal),
                            pause: createPause(internalTaskController.signal),
                            extra: extra,
                            signal: internalTaskController.signal,
                            fork: createFork(internalTaskController.signal),
                            unsubscribe: entry.unsubscribe,
                            subscribe: function () {
                                listenerMap.set(entry.id, entry);
                            },
                            cancelActiveListeners: function () {
                                entry.pending.forEach(function (controller, _, set) {
                                    if (controller !== internalTaskController) {
                                        abortControllerWithReason(controller, listenerCancelled);
                                        set.delete(controller);
                                    }
                                });
                            }
                        })))];
                case 2:
                    _c.sent();
                    return [3 /*break*/, 5];
                case 3:
                    listenerError_1 = _c.sent();
                    if (!(listenerError_1 instanceof TaskAbortError)) {
                        safelyNotifyError(onError, listenerError_1, {
                            raisedBy: "effect"
                        });
                    }
                    return [3 /*break*/, 5];
                case 4:
                    abortControllerWithReason(internalTaskController, listenerCompleted);
                    entry.pending.delete(internalTaskController);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var clearListenerMiddleware = createClearListenerMiddleware(listenerMap);
    var middleware = function (api) { return function (next) { return function (action) {
        if (addListener.match(action)) {
            return startListening(action.payload);
        }
        if (clearAllListeners.match(action)) {
            clearListenerMiddleware();
            return;
        }
        if (removeListener.match(action)) {
            return stopListening(action.payload);
        }
        var originalState = api.getState();
        var getOriginalState = function () {
            if (originalState === INTERNAL_NIL_TOKEN) {
                throw new Error(alm + ": getOriginalState can only be called synchronously");
            }
            return originalState;
        };
        var result;
        try {
            result = next(action);
            if (listenerMap.size > 0) {
                var currentState = api.getState();
                var listenerEntries = Array.from(listenerMap.values());
                for (var _i = 0, listenerEntries_1 = listenerEntries; _i < listenerEntries_1.length; _i++) {
                    var entry = listenerEntries_1[_i];
                    var runListener = false;
                    try {
                        runListener = entry.predicate(action, currentState, originalState);
                    }
                    catch (predicateError) {
                        runListener = false;
                        safelyNotifyError(onError, predicateError, {
                            raisedBy: "predicate"
                        });
                    }
                    if (!runListener) {
                        continue;
                    }
                    notifyListener(entry, action, api, getOriginalState);
                }
            }
        }
        finally {
            originalState = INTERNAL_NIL_TOKEN;
        }
        return result;
    }; }; };
    return {
        middleware: middleware,
        startListening: startListening,
        stopListening: stopListening,
        clearListeners: clearListenerMiddleware
    };
}
// src/autoBatchEnhancer.ts
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var prepareAutoBatched = function () { return function (payload) {
    var _c;
    return ({
        payload: payload,
        meta: (_c = {}, _c[SHOULD_AUTOBATCH] = true, _c)
    });
}; };
var promise;
var queueMicrotaskShim = typeof queueMicrotask === "function" ? queueMicrotask.bind(typeof window !== "undefined" ? window : typeof __webpack_require__.g !== "undefined" ? __webpack_require__.g : globalThis) : function (cb) { return (promise || (promise = Promise.resolve())).then(cb).catch(function (err) { return setTimeout(function () {
    throw err;
}, 0); }); };
var createQueueWithTimer = function (timeout) {
    return function (notify) {
        setTimeout(notify, timeout);
    };
};
var rAF = typeof window !== "undefined" && window.requestAnimationFrame ? window.requestAnimationFrame : createQueueWithTimer(10);
var autoBatchEnhancer = function (options) {
    if (options === void 0) { options = { type: "raf" }; }
    return function (next) { return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var store = next.apply(void 0, args);
        var notifying = true;
        var shouldNotifyAtEndOfTick = false;
        var notificationQueued = false;
        var listeners = new Set();
        var queueCallback = options.type === "tick" ? queueMicrotaskShim : options.type === "raf" ? rAF : options.type === "callback" ? options.queueNotification : createQueueWithTimer(options.timeout);
        var notifyListeners = function () {
            notificationQueued = false;
            if (shouldNotifyAtEndOfTick) {
                shouldNotifyAtEndOfTick = false;
                listeners.forEach(function (l) { return l(); });
            }
        };
        return Object.assign({}, store, {
            subscribe: function (listener2) {
                var wrappedListener = function () { return notifying && listener2(); };
                var unsubscribe = store.subscribe(wrappedListener);
                listeners.add(listener2);
                return function () {
                    unsubscribe();
                    listeners.delete(listener2);
                };
            },
            dispatch: function (action) {
                var _a;
                try {
                    notifying = !((_a = action == null ? void 0 : action.meta) == null ? void 0 : _a[SHOULD_AUTOBATCH]);
                    shouldNotifyAtEndOfTick = !notifying;
                    if (shouldNotifyAtEndOfTick) {
                        if (!notificationQueued) {
                            notificationQueued = true;
                            queueCallback(notifyListeners);
                        }
                    }
                    return store.dispatch(action);
                }
                finally {
                    notifying = true;
                }
            }
        });
    }; };
};
// src/index.ts
(0,immer_esm/* enableES5 */.pV)();

//# sourceMappingURL=redux-toolkit.esm.js.map
;// CONCATENATED MODULE: ./node_modules/@frontegg/redux-store/constants-4d9682b2.js
const FRONTEGG_AFTER_AUTH_REDIRECT_URL = 'FRONTEGG_AFTER_AUTH_REDIRECT_URL';
const HOSTED_LOGIN_VERIFIER_KEY = 'HOSTED_LOGIN_VERIFIER_KEY';
const authStoreName = 'auth';
const connectivityStoreName = 'connectivity';
const auditsStoreName = 'auditLogs';
const subscriptionsStoreName = 'subscriptions';
const vendorStoreName = 'vendor';



// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
;// CONCATENATED MODULE: ./node_modules/@redux-saga/symbols/dist/redux-saga-symbols.esm.js
var createSymbol = function createSymbol(name) {
  return "@@redux-saga/" + name;
};

var CANCEL =
/*#__PURE__*/
createSymbol('CANCEL_PROMISE');
var CHANNEL_END_TYPE =
/*#__PURE__*/
createSymbol('CHANNEL_END');
var redux_saga_symbols_esm_IO =
/*#__PURE__*/
createSymbol('IO');
var MATCH =
/*#__PURE__*/
createSymbol('MATCH');
var MULTICAST =
/*#__PURE__*/
createSymbol('MULTICAST');
var redux_saga_symbols_esm_SAGA_ACTION =
/*#__PURE__*/
createSymbol('SAGA_ACTION');
var SELF_CANCELLATION =
/*#__PURE__*/
createSymbol('SELF_CANCELLATION');
var redux_saga_symbols_esm_TASK =
/*#__PURE__*/
createSymbol('TASK');
var TASK_CANCEL =
/*#__PURE__*/
createSymbol('TASK_CANCEL');
var TERMINATE =
/*#__PURE__*/
createSymbol('TERMINATE');
var SAGA_LOCATION =
/*#__PURE__*/
createSymbol('LOCATION');



;// CONCATENATED MODULE: ./node_modules/@redux-saga/is/dist/redux-saga-is.esm.js


var undef = function undef(v) {
  return v === null || v === undefined;
};
var redux_saga_is_esm_notUndef = function notUndef(v) {
  return v !== null && v !== undefined;
};
var redux_saga_is_esm_func = function func(f) {
  return typeof f === 'function';
};
var number = function number(n) {
  return typeof n === 'number';
};
var redux_saga_is_esm_string = function string(s) {
  return typeof s === 'string';
};
var redux_saga_is_esm_array = Array.isArray;
var redux_saga_is_esm_object = function object(obj) {
  return obj && !redux_saga_is_esm_array(obj) && typeof obj === 'object';
};
var redux_saga_is_esm_promise = function promise(p) {
  return p && redux_saga_is_esm_func(p.then);
};
var iterator = function iterator(it) {
  return it && redux_saga_is_esm_func(it.next) && redux_saga_is_esm_func(it.throw);
};
var iterable = function iterable(it) {
  return it && redux_saga_is_esm_func(Symbol) ? redux_saga_is_esm_func(it[Symbol.iterator]) : redux_saga_is_esm_array(it);
};
var redux_saga_is_esm_task = function task(t) {
  return t && t[TASK];
};
var sagaAction = function sagaAction(a) {
  return Boolean(a && a[SAGA_ACTION]);
};
var observable = function observable(ob) {
  return ob && redux_saga_is_esm_func(ob.subscribe);
};
var buffer = function buffer(buf) {
  return buf && redux_saga_is_esm_func(buf.isEmpty) && redux_saga_is_esm_func(buf.take) && redux_saga_is_esm_func(buf.put);
};
var pattern = function pattern(pat) {
  return pat && (redux_saga_is_esm_string(pat) || symbol(pat) || redux_saga_is_esm_func(pat) || redux_saga_is_esm_array(pat) && pat.every(pattern));
};
var redux_saga_is_esm_channel = function channel(ch) {
  return ch && redux_saga_is_esm_func(ch.take) && redux_saga_is_esm_func(ch.close);
};
var stringableFunc = function stringableFunc(f) {
  return redux_saga_is_esm_func(f) && f.hasOwnProperty('toString');
};
var symbol = function symbol(sym) {
  return Boolean(sym) && typeof Symbol === 'function' && sym.constructor === Symbol && sym !== Symbol.prototype;
};
var multicast = function multicast(ch) {
  return redux_saga_is_esm_channel(ch) && ch[MULTICAST];
};
var redux_saga_is_esm_effect = function effect(eff) {
  return eff && eff[IO];
};



// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
;// CONCATENATED MODULE: ./node_modules/@redux-saga/delay-p/dist/redux-saga-delay-p.esm.js


var MAX_SIGNED_INT = 2147483647;
function delayP(ms, val) {
  if (val === void 0) {
    val = true;
  }

  // https://developer.mozilla.org/en-US/docs/Web/API/setTimeout#maximum_delay_value
  if (false) {}

  var timeoutId;
  var promise = new Promise(function (resolve) {
    timeoutId = setTimeout(resolve, Math.min(MAX_SIGNED_INT, ms), val);
  });

  promise[CANCEL] = function () {
    clearTimeout(timeoutId);
  };

  return promise;
}

/* harmony default export */ var redux_saga_delay_p_esm = (delayP);

;// CONCATENATED MODULE: ./node_modules/@redux-saga/core/dist/io-c3792963.js





var konst = function konst(v) {
  return function () {
    return v;
  };
};
var kTrue =
/*#__PURE__*/
konst(true);

var io_c3792963_noop = function noop() {};

if (false) {}
var identity = function identity(v) {
  return v;
};
var hasSymbol = typeof Symbol === 'function';
var asyncIteratorSymbol = hasSymbol && Symbol.asyncIterator ? Symbol.asyncIterator : '@@asyncIterator';
function io_c3792963_check(value, predicate, error) {
  if (!predicate(value)) {
    throw new Error(error);
  }
}
var assignWithSymbols = function assignWithSymbols(target, source) {
  (0,esm_extends/* default */.Z)(target, source);

  if (Object.getOwnPropertySymbols) {
    Object.getOwnPropertySymbols(source).forEach(function (s) {
      target[s] = source[s];
    });
  }
};
var flatMap = function flatMap(mapper, arr) {
  var _ref;

  return (_ref = []).concat.apply(_ref, arr.map(mapper));
};
function remove(array, item) {
  var index = array.indexOf(item);

  if (index >= 0) {
    array.splice(index, 1);
  }
}
function io_c3792963_once(fn) {
  var called = false;
  return function () {
    if (called) {
      return;
    }

    called = true;
    fn();
  };
}

var kThrow = function kThrow(err) {
  throw err;
};

var kReturn = function kReturn(value) {
  return {
    value: value,
    done: true
  };
};

function makeIterator(next, thro, name) {
  if (thro === void 0) {
    thro = kThrow;
  }

  if (name === void 0) {
    name = 'iterator';
  }

  var iterator = {
    meta: {
      name: name
    },
    next: next,
    throw: thro,
    return: kReturn,
    isSagaIterator: true
  };

  if (typeof Symbol !== 'undefined') {
    iterator[Symbol.iterator] = function () {
      return iterator;
    };
  }

  return iterator;
}
function logError(error, _ref2) {
  var sagaStack = _ref2.sagaStack;

  /*eslint-disable no-console*/
  console.error(error);
  console.error(sagaStack);
}
var internalErr = function internalErr(err) {
  return new Error("\n  redux-saga: Error checking hooks detected an inconsistent state. This is likely a bug\n  in redux-saga code and not yours. Thanks for reporting this in the project's github repo.\n  Error: " + err + "\n");
};
var createSetContextWarning = function createSetContextWarning(ctx, props) {
  return (ctx ? ctx + '.' : '') + "setContext(props): argument " + props + " is not a plain object";
};
var FROZEN_ACTION_ERROR = "You can't put (a.k.a. dispatch from saga) frozen actions.\nWe have to define a special non-enumerable property on those actions for scheduling purposes.\nOtherwise you wouldn't be able to communicate properly between sagas & other subscribers (action ordering would become far less predictable).\nIf you are using redux and you care about this behaviour (frozen actions),\nthen you might want to switch to freezing actions in a middleware rather than in action creator.\nExample implementation:\n\nconst freezeActions = store => next => action => next(Object.freeze(action))\n"; // creates empty, but not-holey array

var createEmptyArray = function createEmptyArray(n) {
  return Array.apply(null, new Array(n));
};
var wrapSagaDispatch = function wrapSagaDispatch(dispatch) {
  return function (action) {
    if (false) {}

    return dispatch(Object.defineProperty(action, redux_saga_symbols_esm_SAGA_ACTION, {
      value: true
    }));
  };
};
var shouldTerminate = function shouldTerminate(res) {
  return res === TERMINATE;
};
var shouldCancel = function shouldCancel(res) {
  return res === TASK_CANCEL;
};
var shouldComplete = function shouldComplete(res) {
  return shouldTerminate(res) || shouldCancel(res);
};
function createAllStyleChildCallbacks(shape, parentCallback) {
  var keys = Object.keys(shape);
  var totalCount = keys.length;

  if (false) {}

  var completedCount = 0;
  var completed;
  var results = redux_saga_is_esm_array(shape) ? createEmptyArray(totalCount) : {};
  var childCallbacks = {};

  function checkEnd() {
    if (completedCount === totalCount) {
      completed = true;
      parentCallback(results);
    }
  }

  keys.forEach(function (key) {
    var chCbAtKey = function chCbAtKey(res, isErr) {
      if (completed) {
        return;
      }

      if (isErr || shouldComplete(res)) {
        parentCallback.cancel();
        parentCallback(res, isErr);
      } else {
        results[key] = res;
        completedCount++;
        checkEnd();
      }
    };

    chCbAtKey.cancel = io_c3792963_noop;
    childCallbacks[key] = chCbAtKey;
  });

  parentCallback.cancel = function () {
    if (!completed) {
      completed = true;
      keys.forEach(function (key) {
        return childCallbacks[key].cancel();
      });
    }
  };

  return childCallbacks;
}
function getMetaInfo(fn) {
  return {
    name: fn.name || 'anonymous',
    location: getLocation(fn)
  };
}
function getLocation(instrumented) {
  return instrumented[SAGA_LOCATION];
}

var BUFFER_OVERFLOW = "Channel's Buffer overflow!";
var ON_OVERFLOW_THROW = 1;
var ON_OVERFLOW_DROP = 2;
var ON_OVERFLOW_SLIDE = 3;
var ON_OVERFLOW_EXPAND = 4;
var zeroBuffer = {
  isEmpty: kTrue,
  put: io_c3792963_noop,
  take: io_c3792963_noop
};

function ringBuffer(limit, overflowAction) {
  if (limit === void 0) {
    limit = 10;
  }

  var arr = new Array(limit);
  var length = 0;
  var pushIndex = 0;
  var popIndex = 0;

  var push = function push(it) {
    arr[pushIndex] = it;
    pushIndex = (pushIndex + 1) % limit;
    length++;
  };

  var take = function take() {
    if (length != 0) {
      var it = arr[popIndex];
      arr[popIndex] = null;
      length--;
      popIndex = (popIndex + 1) % limit;
      return it;
    }
  };

  var flush = function flush() {
    var items = [];

    while (length) {
      items.push(take());
    }

    return items;
  };

  return {
    isEmpty: function isEmpty() {
      return length == 0;
    },
    put: function put(it) {
      if (length < limit) {
        push(it);
      } else {
        var doubledLimit;

        switch (overflowAction) {
          case ON_OVERFLOW_THROW:
            throw new Error(BUFFER_OVERFLOW);

          case ON_OVERFLOW_SLIDE:
            arr[pushIndex] = it;
            pushIndex = (pushIndex + 1) % limit;
            popIndex = pushIndex;
            break;

          case ON_OVERFLOW_EXPAND:
            doubledLimit = 2 * limit;
            arr = flush();
            length = arr.length;
            pushIndex = arr.length;
            popIndex = 0;
            arr.length = doubledLimit;
            limit = doubledLimit;
            push(it);
            break;

          default: // DROP

        }
      }
    },
    take: take,
    flush: flush
  };
}

var io_c3792963_none = function none() {
  return zeroBuffer;
};
var fixed = function fixed(limit) {
  return ringBuffer(limit, ON_OVERFLOW_THROW);
};
var dropping = function dropping(limit) {
  return ringBuffer(limit, ON_OVERFLOW_DROP);
};
var io_c3792963_sliding = function sliding(limit) {
  return ringBuffer(limit, ON_OVERFLOW_SLIDE);
};
var expanding = function expanding(initialSize) {
  return ringBuffer(initialSize, ON_OVERFLOW_EXPAND);
};

var buffers = /*#__PURE__*/Object.freeze({
  __proto__: null,
  none: io_c3792963_none,
  fixed: fixed,
  dropping: dropping,
  sliding: io_c3792963_sliding,
  expanding: expanding
});

var TAKE = 'TAKE';
var PUT = 'PUT';
var ALL = 'ALL';
var RACE = 'RACE';
var CALL = 'CALL';
var CPS = 'CPS';
var FORK = 'FORK';
var JOIN = 'JOIN';
var io_c3792963_CANCEL = 'CANCEL';
var SELECT = 'SELECT';
var ACTION_CHANNEL = 'ACTION_CHANNEL';
var CANCELLED = 'CANCELLED';
var FLUSH = 'FLUSH';
var GET_CONTEXT = 'GET_CONTEXT';
var SET_CONTEXT = 'SET_CONTEXT';

var effectTypes = /*#__PURE__*/Object.freeze({
  __proto__: null,
  TAKE: TAKE,
  PUT: PUT,
  ALL: ALL,
  RACE: RACE,
  CALL: CALL,
  CPS: CPS,
  FORK: FORK,
  JOIN: JOIN,
  CANCEL: io_c3792963_CANCEL,
  SELECT: SELECT,
  ACTION_CHANNEL: ACTION_CHANNEL,
  CANCELLED: CANCELLED,
  FLUSH: FLUSH,
  GET_CONTEXT: GET_CONTEXT,
  SET_CONTEXT: SET_CONTEXT
});

var TEST_HINT = '\n(HINT: if you are getting these errors in tests, consider using createMockTask from @redux-saga/testing-utils)';

var makeEffect = function makeEffect(type, payload) {
  var _ref;

  return _ref = {}, _ref[redux_saga_symbols_esm_IO] = true, _ref.combinator = false, _ref.type = type, _ref.payload = payload, _ref;
};

var isForkEffect = function isForkEffect(eff) {
  return effect(eff) && eff.type === FORK;
};

var detach = function detach(eff) {
  if (false) {}

  return makeEffect(FORK, _extends({}, eff.payload, {
    detached: true
  }));
};
function io_c3792963_take(patternOrChannel, multicastPattern) {
  if (patternOrChannel === void 0) {
    patternOrChannel = '*';
  }

  if (false) {}

  if (pattern(patternOrChannel)) {
    if (redux_saga_is_esm_notUndef(multicastPattern)) {
      /* eslint-disable no-console */
      console.warn("take(pattern) takes one argument but two were provided. Consider passing an array for listening to several action types");
    }

    return makeEffect(TAKE, {
      pattern: patternOrChannel
    });
  }

  if (multicast(patternOrChannel) && redux_saga_is_esm_notUndef(multicastPattern) && pattern(multicastPattern)) {
    return makeEffect(TAKE, {
      channel: patternOrChannel,
      pattern: multicastPattern
    });
  }

  if (redux_saga_is_esm_channel(patternOrChannel)) {
    if (redux_saga_is_esm_notUndef(multicastPattern)) {
      /* eslint-disable no-console */
      console.warn("take(channel) takes one argument but two were provided. Second argument is ignored.");
    }

    return makeEffect(TAKE, {
      channel: patternOrChannel
    });
  }

  if (false) {}
}
var takeMaybe = function takeMaybe() {
  var eff = io_c3792963_take.apply(void 0, arguments);
  eff.payload.maybe = true;
  return eff;
};
function put(channel$1, action) {
  if (false) {}

  if (undef(action)) {
    action = channel$1; // `undefined` instead of `null` to make default parameter work

    channel$1 = undefined;
  }

  return makeEffect(PUT, {
    channel: channel$1,
    action: action
  });
}
var putResolve = function putResolve() {
  var eff = put.apply(void 0, arguments);
  eff.payload.resolve = true;
  return eff;
};
function io_c3792963_all(effects) {
  var eff = makeEffect(ALL, effects);
  eff.combinator = true;
  return eff;
}
function io_c3792963_race(effects) {
  var eff = makeEffect(RACE, effects);
  eff.combinator = true;
  return eff;
} // this match getFnCallDescriptor logic

var validateFnDescriptor = function validateFnDescriptor(effectName, fnDescriptor) {
  io_c3792963_check(fnDescriptor, notUndef, effectName + ": argument fn is undefined or null");

  if (func(fnDescriptor)) {
    return;
  }

  var context = null;
  var fn;

  if (array(fnDescriptor)) {
    context = fnDescriptor[0];
    fn = fnDescriptor[1];
    io_c3792963_check(fn, notUndef, effectName + ": argument of type [context, fn] has undefined or null `fn`");
  } else if (object(fnDescriptor)) {
    context = fnDescriptor.context;
    fn = fnDescriptor.fn;
    io_c3792963_check(fn, notUndef, effectName + ": argument of type {context, fn} has undefined or null `fn`");
  } else {
    io_c3792963_check(fnDescriptor, func, effectName + ": argument fn is not function");
    return;
  }

  if (context && string(fn)) {
    io_c3792963_check(context[fn], func, effectName + ": context arguments has no such method - \"" + fn + "\"");
    return;
  }

  io_c3792963_check(fn, func, effectName + ": unpacked fn argument (from [context, fn] or {context, fn}) is not a function");
};

function getFnCallDescriptor(fnDescriptor, args) {
  var context = null;
  var fn;

  if (redux_saga_is_esm_func(fnDescriptor)) {
    fn = fnDescriptor;
  } else {
    if (redux_saga_is_esm_array(fnDescriptor)) {
      context = fnDescriptor[0];
      fn = fnDescriptor[1];
    } else {
      context = fnDescriptor.context;
      fn = fnDescriptor.fn;
    }

    if (context && redux_saga_is_esm_string(fn) && redux_saga_is_esm_func(context[fn])) {
      fn = context[fn];
    }
  }

  return {
    context: context,
    fn: fn,
    args: args
  };
}

var isNotDelayEffect = function isNotDelayEffect(fn) {
  return fn !== io_c3792963_delay;
};

function call(fnDescriptor) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  if (false) { var arg0; }

  return makeEffect(CALL, getFnCallDescriptor(fnDescriptor, args));
}
function apply(context, fn, args) {
  if (args === void 0) {
    args = [];
  }

  var fnDescriptor = [context, fn];

  if (false) {}

  return makeEffect(CALL, getFnCallDescriptor([context, fn], args));
}
function cps(fnDescriptor) {
  if (false) {}

  for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    args[_key2 - 1] = arguments[_key2];
  }

  return makeEffect(CPS, getFnCallDescriptor(fnDescriptor, args));
}
function io_c3792963_fork(fnDescriptor) {
  if (false) {}

  for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  return makeEffect(FORK, getFnCallDescriptor(fnDescriptor, args));
}
function spawn(fnDescriptor) {
  if (false) {}

  for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
    args[_key4 - 1] = arguments[_key4];
  }

  return detach(io_c3792963_fork.apply(void 0, [fnDescriptor].concat(args)));
}
function join(taskOrTasks) {
  if (false) {}

  return makeEffect(JOIN, taskOrTasks);
}
function cancel(taskOrTasks) {
  if (taskOrTasks === void 0) {
    taskOrTasks = SELF_CANCELLATION;
  }

  if (false) {}

  return makeEffect(io_c3792963_CANCEL, taskOrTasks);
}
function io_c3792963_select(selector) {
  if (selector === void 0) {
    selector = identity;
  }

  for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
    args[_key5 - 1] = arguments[_key5];
  }

  if (false) {}

  return makeEffect(SELECT, {
    selector: selector,
    args: args
  });
}
/**
  channel(pattern, [buffer])    => creates a proxy channel for store actions
**/

function io_c3792963_actionChannel(pattern$1, buffer$1) {
  if (false) {}

  return makeEffect(ACTION_CHANNEL, {
    pattern: pattern$1,
    buffer: buffer$1
  });
}
function io_c3792963_cancelled() {
  return makeEffect(CANCELLED, {});
}
function flush(channel$1) {
  if (false) {}

  return makeEffect(FLUSH, channel$1);
}
function getContext(prop) {
  if (false) {}

  return makeEffect(GET_CONTEXT, prop);
}
function setContext(props) {
  if (false) {}

  return makeEffect(SET_CONTEXT, props);
}
var io_c3792963_delay =
/*#__PURE__*/
call.bind(null, redux_saga_delay_p_esm);



;// CONCATENATED MODULE: ./node_modules/@redux-saga/core/dist/redux-saga-effects.esm.js







var done = function done(value) {
  return {
    done: true,
    value: value
  };
};

var qEnd = {};
function safeName(patternOrChannel) {
  if (redux_saga_is_esm_channel(patternOrChannel)) {
    return 'channel';
  }

  if (stringableFunc(patternOrChannel)) {
    return String(patternOrChannel);
  }

  if (redux_saga_is_esm_func(patternOrChannel)) {
    return patternOrChannel.name;
  }

  return String(patternOrChannel);
}
function fsmIterator(fsm, startState, name) {
  var stateUpdater,
      errorState,
      effect,
      nextState = startState;

  function next(arg, error) {
    if (nextState === qEnd) {
      return done(arg);
    }

    if (error && !errorState) {
      nextState = qEnd;
      throw error;
    } else {
      stateUpdater && stateUpdater(arg);
      var currentState = error ? fsm[errorState](error) : fsm[nextState]();
      nextState = currentState.nextState;
      effect = currentState.effect;
      stateUpdater = currentState.stateUpdater;
      errorState = currentState.errorState;
      return nextState === qEnd ? done(arg) : effect;
    }
  }

  return makeIterator(next, function (error) {
    return next(null, error);
  }, name);
}

function takeEvery(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: io_c3792963_take(patternOrChannel)
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: io_c3792963_fork.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var action,
      setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return {
        nextState: 'q1',
        effect: yFork(action)
      };
    }
  }, 'q1', "takeEvery(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function takeLatest(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: io_c3792963_take(patternOrChannel)
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: io_c3792963_fork.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yCancel = function yCancel(task) {
    return {
      done: false,
      value: cancel(task)
    };
  };

  var task, action;

  var setTask = function setTask(t) {
    return task = t;
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return task ? {
        nextState: 'q3',
        effect: yCancel(task)
      } : {
        nextState: 'q1',
        effect: yFork(action),
        stateUpdater: setTask
      };
    },
    q3: function q3() {
      return {
        nextState: 'q1',
        effect: yFork(action),
        stateUpdater: setTask
      };
    }
  }, 'q1', "takeLatest(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function takeLeading(patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var yTake = {
    done: false,
    value: io_c3792963_take(patternOrChannel)
  };

  var yCall = function yCall(ac) {
    return {
      done: false,
      value: call.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var action;

  var setAction = function setAction(ac) {
    return action = ac;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return {
        nextState: 'q1',
        effect: yCall(action)
      };
    }
  }, 'q1', "takeLeading(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function throttle(delayLength, patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action, channel$1;

  var yTake = function yTake() {
    return {
      done: false,
      value: take(channel$1)
    };
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: fork.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yDelay = {
    done: false,
    value: delay(delayLength)
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  var setChannel = function setChannel(ch) {
    return channel$1 = ch;
  };

  var needsChannel = !channel(patternOrChannel);

  if (!needsChannel) {
    setChannel(patternOrChannel);
  }

  return fsmIterator({
    q1: function q1() {
      var yActionChannel = {
        done: false,
        value: actionChannel(patternOrChannel, sliding(1))
      };
      return {
        nextState: 'q2',
        effect: yActionChannel,
        stateUpdater: setChannel
      };
    },
    q2: function q2() {
      return {
        nextState: 'q3',
        effect: yTake(),
        stateUpdater: setAction
      };
    },
    q3: function q3() {
      return {
        nextState: 'q4',
        effect: yFork(action)
      };
    },
    q4: function q4() {
      return {
        nextState: 'q2',
        effect: yDelay
      };
    }
  }, needsChannel ? 'q1' : 'q2', "throttle(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

function retry(maxTries, delayLength, fn) {
  var counter = maxTries;

  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var yCall = {
    done: false,
    value: call.apply(void 0, [fn].concat(args))
  };
  var yDelay = {
    done: false,
    value: io_c3792963_delay(delayLength)
  };
  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yCall,
        errorState: 'q10'
      };
    },
    q2: function q2() {
      return {
        nextState: qEnd
      };
    },
    q10: function q10(error) {
      counter -= 1;

      if (counter <= 0) {
        throw error;
      }

      return {
        nextState: 'q1',
        effect: yDelay
      };
    }
  }, 'q1', "retry(" + fn.name + ")");
}

function debounceHelper(delayLength, patternOrChannel, worker) {
  for (var _len = arguments.length, args = new Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
    args[_key - 3] = arguments[_key];
  }

  var action, raceOutput;
  var yTake = {
    done: false,
    value: take(patternOrChannel)
  };
  var yRace = {
    done: false,
    value: race({
      action: take(patternOrChannel),
      debounce: delay(delayLength)
    })
  };

  var yFork = function yFork(ac) {
    return {
      done: false,
      value: fork.apply(void 0, [worker].concat(args, [ac]))
    };
  };

  var yNoop = function yNoop(value) {
    return {
      done: false,
      value: value
    };
  };

  var setAction = function setAction(ac) {
    return action = ac;
  };

  var setRaceOutput = function setRaceOutput(ro) {
    return raceOutput = ro;
  };

  return fsmIterator({
    q1: function q1() {
      return {
        nextState: 'q2',
        effect: yTake,
        stateUpdater: setAction
      };
    },
    q2: function q2() {
      return {
        nextState: 'q3',
        effect: yRace,
        stateUpdater: setRaceOutput
      };
    },
    q3: function q3() {
      return raceOutput.debounce ? {
        nextState: 'q1',
        effect: yFork(action)
      } : {
        nextState: 'q2',
        effect: yNoop(raceOutput.action),
        stateUpdater: setAction
      };
    }
  }, 'q1', "debounce(" + safeName(patternOrChannel) + ", " + worker.name + ")");
}

var validateTakeEffect = function validateTakeEffect(fn, patternOrChannel, worker) {
  check(patternOrChannel, notUndef, fn.name + " requires a pattern or channel");
  check(worker, notUndef, fn.name + " requires a saga parameter");
};

function takeEvery$1(patternOrChannel, worker) {
  if (false) {}

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  return io_c3792963_fork.apply(void 0, [takeEvery, patternOrChannel, worker].concat(args));
}
function takeLatest$1(patternOrChannel, worker) {
  if (false) {}

  for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    args[_key2 - 2] = arguments[_key2];
  }

  return io_c3792963_fork.apply(void 0, [takeLatest, patternOrChannel, worker].concat(args));
}
function takeLeading$1(patternOrChannel, worker) {
  if (false) {}

  for (var _len3 = arguments.length, args = new Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
    args[_key3 - 2] = arguments[_key3];
  }

  return io_c3792963_fork.apply(void 0, [takeLeading, patternOrChannel, worker].concat(args));
}
function throttle$1(ms, patternOrChannel, worker) {
  if (false) {}

  for (var _len4 = arguments.length, args = new Array(_len4 > 3 ? _len4 - 3 : 0), _key4 = 3; _key4 < _len4; _key4++) {
    args[_key4 - 3] = arguments[_key4];
  }

  return fork.apply(void 0, [throttle, ms, patternOrChannel, worker].concat(args));
}
function retry$1(maxTries, delayLength, worker) {
  for (var _len5 = arguments.length, args = new Array(_len5 > 3 ? _len5 - 3 : 0), _key5 = 3; _key5 < _len5; _key5++) {
    args[_key5 - 3] = arguments[_key5];
  }

  return call.apply(void 0, [retry, maxTries, delayLength, worker].concat(args));
}
function debounce(delayLength, pattern, worker) {
  for (var _len6 = arguments.length, args = new Array(_len6 > 3 ? _len6 - 3 : 0), _key6 = 3; _key6 < _len6; _key6++) {
    args[_key6 - 3] = arguments[_key6];
  }

  return fork.apply(void 0, [debounceHelper, delayLength, pattern, worker].concat(args));
}



;// CONCATENATED MODULE: ./node_modules/redux-saga/dist/redux-saga-effects-npm-proxy.esm.js


// EXTERNAL MODULE: ./node_modules/@frontegg/rest-api/dist/umd/index.js
var umd = __webpack_require__(32205);
;// CONCATENATED MODULE: ./node_modules/@frontegg/redux-store/saga-b6529ffb.js





const reducers = {
    setVendorState: (state, { payload }) => (Object.assign(Object.assign({}, state), payload)),
};
const actions$1 = {
    loadVendorPublicInfo: createAction(`${vendorStoreName}/loadVendorPublicInfo`),
};

const initialState = {
    whiteLabelMode: false,
};
const { reducer, actions: sliceActions } = createSlice({
    name: vendorStoreName,
    initialState,
    reducers: Object.assign({}, reducers)
});
const actions = Object.assign(Object.assign({}, sliceActions), actions$1);

function* loadVendorPublicInfo() {
    try {
        const { whiteLabelMode = false } = yield umd.api.vendor.getVendorPublicInfo();
        yield put(actions.setVendorState({ whiteLabelMode }));
    }
    catch (e) {
        console.error('failed to getVendorPublicInfo - ', e);
    }
}
function* sagas() {
    yield takeEvery$1(actions.loadVendorPublicInfo, loadVendorPublicInfo);
}



;// CONCATENATED MODULE: ./node_modules/@frontegg/redux-store/node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/@frontegg/redux-store/node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ./node_modules/@frontegg/redux-store/node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
;// CONCATENATED MODULE: ./node_modules/@frontegg/redux-store/node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify_stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify_stringify);
;// CONCATENATED MODULE: ./node_modules/@frontegg/redux-store/node_modules/uuid/dist/esm-browser/v4.js



function v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4);
;// CONCATENATED MODULE: ./node_modules/@frontegg/redux-store/auth/index.js










const resetStateByKey = (key, initialState) => (state) => (Object.assign(Object.assign({}, state), { [key]: initialState[key] }));
const typeReducer = (key) => (state, { payload }) => (Object.assign(Object.assign({}, state), { [key]: payload }));
const typeReducerForKey = (key) => ({
    prepare: (payload) => ({ payload }),
    reducer: (state, { payload }) => {
        return Object.assign(Object.assign({}, state), { [key]: Object.assign(Object.assign({}, state[key]), payload) });
    },
});
const typeReducerNestedKey = (key, nestedKey) => ({
    prepare: (payload) => ({ payload }),
    reducer: (state, { payload }) => {
        var _a;
        return Object.assign(Object.assign({}, state), { [key]: Object.assign(Object.assign({}, state[key]), { [nestedKey]: Object.assign(Object.assign({}, (_a = state === null || state === void 0 ? void 0 : state[key]) === null || _a === void 0 ? void 0 : _a[nestedKey]), payload) }) });
    },
});
const loadersReducerForKey = (key) => ({
    prepare: (payload) => ({ payload }),
    reducer: (state, { payload }) => {
        var _a;
        return (Object.assign(Object.assign({}, state), { [key]: Object.assign(Object.assign({}, state[key]), { loaders: Object.assign(Object.assign({}, state[key].loaders), { [payload.key]: (_a = payload.value) !== null && _a !== void 0 ? _a : true }) }) }));
    },
});
const errorsReducerForKey = (key) => ({
    prepare: (payload) => ({ payload }),
    reducer: (state, { payload }) => {
        var _a;
        return (Object.assign(Object.assign({}, state), { [key]: Object.assign(Object.assign({}, state[key]), { errors: Object.assign(Object.assign({}, state[key].errors), { [payload.key]: (_a = payload.value) !== null && _a !== void 0 ? _a : true }) }) }));
    },
});
const auth_delay = (delayTime = 500) => new Promise((resolve) => setTimeout(resolve, delayTime));
const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_';
const lookup = new Uint8Array(256);
for (let i = 0; i < chars.length; i++) {
    lookup[chars.charCodeAt(i)] = i;
}
const base64urlEncode = (arraybuffer) => {
    const bytes = new Uint8Array(arraybuffer);
    const len = bytes.length;
    let i;
    let base64url = '';
    for (i = 0; i < len; i += 3) {
        base64url += chars[bytes[i] >> 2];
        base64url += chars[((bytes[i] & 3) << 4) | (bytes[i + 1] >> 4)];
        base64url += chars[((bytes[i + 1] & 15) << 2) | (bytes[i + 2] >> 6)];
        base64url += chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) {
        base64url = base64url.substring(0, base64url.length - 1);
    }
    else if (len % 3 === 1) {
        base64url = base64url.substring(0, base64url.length - 2);
    }
    return base64url;
};
const base64urlDecode = (base64string) => {
    const bufferLength = base64string.length * 0.75;
    let len = base64string.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
    const bytes = new Uint8Array(bufferLength);
    for (i = 0; i < len; i += 4) {
        encoded1 = lookup[base64string.charCodeAt(i)];
        encoded2 = lookup[base64string.charCodeAt(i + 1)];
        encoded3 = lookup[base64string.charCodeAt(i + 2)];
        encoded4 = lookup[base64string.charCodeAt(i + 3)];
        bytes[p++] = (encoded1 << 2) | (encoded2 >> 4);
        bytes[p++] = ((encoded2 & 15) << 4) | (encoded3 >> 2);
        bytes[p++] = ((encoded3 & 3) << 6) | (encoded4 & 63);
    }
    return bytes.buffer;
};
const publicKeyCredentialToJSON = (pubKeyCred) => {
    if (pubKeyCred instanceof Array) {
        const arr = [];
        for (const i of pubKeyCred) {
            arr.push(publicKeyCredentialToJSON(i));
        }
        return arr;
    }
    else if (pubKeyCred instanceof ArrayBuffer) {
        return base64urlEncode(pubKeyCred);
    }
    else if (pubKeyCred instanceof Object) {
        const obj = {};
        for (const key in pubKeyCred) {
            obj[key] = publicKeyCredentialToJSON(pubKeyCred[key]);
        }
        return obj;
    }
    return pubKeyCred;
};

var LoginStep;
(function (LoginStep) {
    LoginStep["preLogin"] = "preLogin";
    LoginStep["magicLinkPreLoginSuccess"] = "magicLinkPreLoginSuccess";
    LoginStep["loginWithSmsOtc"] = "loginWithSmsOtc";
    LoginStep["loginWithQuickSmsOtc"] = "loginWithQuickSmsOtc";
    LoginStep["loginWithOtc"] = "loginWithOtc";
    LoginStep["loginWithPassword"] = "loginWithPassword";
    LoginStep["loginWithTwoFactor"] = "loginWithTwoFactor";
    LoginStep["redirectToSSO"] = "redirectToSSO";
    LoginStep["loginWithSSOFailed"] = "loginWithSSOFailed";
    LoginStep["success"] = "success";
    LoginStep["forceTwoFactor"] = "forceTwoFactor";
    LoginStep["recoverTwoFactor"] = "recoverTwoFactor";
})(LoginStep || (LoginStep = {}));
var LoginFlow;
(function (LoginFlow) {
    LoginFlow["Login"] = "login";
    LoginFlow["RegisterQuickLogin"] = "registerQuickLogin";
})(LoginFlow || (LoginFlow = {}));
var QuickLoginStrategy;
(function (QuickLoginStrategy) {
    QuickLoginStrategy["Internal"] = "internal";
    QuickLoginStrategy["UsbKey"] = "usb-key";
    QuickLoginStrategy["Android"] = "android";
    QuickLoginStrategy["Sms"] = "sms";
})(QuickLoginStrategy || (QuickLoginStrategy = {}));

const loginState = {
    flow: LoginFlow.Login,
    step: LoginStep.preLogin,
    loading: false,
    email: '',
    tenants: [],
};
const reducers$f = {
    setLoginState: typeReducerForKey('loginState'),
    resetLoginState: resetStateByKey('loginState', { loginState }),
};
const actions$g = {
    requestAuthorize: createAction(`${authStoreName}/requestAuthorize`, (payload = false) => ({ payload })),
    requestAuthorizeSSR: createAction(`${authStoreName}/requestAuthorizeSSR`, (payload) => ({ payload })),
    requestHostedLoginAuthorize: createAction(`${authStoreName}/requestHostedLoginAuthorize`),
    handleHostedLoginCallback: createAction(`${authStoreName}/handleHostedLoginCallback`, (payload) => ({ payload })),
    afterAuthNavigation: createAction(`${authStoreName}/afterAuthNavigation`),
    preLogin: createAction(`${authStoreName}/preLogin`, (payload) => ({ payload })),
    postLogin: createAction(`${authStoreName}/postLogin`, (payload) => ({ payload })),
    login: createAction(`${authStoreName}/login`, (payload) => ({ payload })),
    loginWithMfa: createAction(`${authStoreName}/loginWithMfa`, (payload) => ({ payload })),
    recoverMfa: createAction(`${authStoreName}/recoverMfa`, (payload) => ({ payload })),
    logout: createAction(`${authStoreName}/logout`, (payload) => ({ payload })),
    silentLogout: createAction(`${authStoreName}/silentLogout`, (payload) => ({ payload })),
    checkIfAllowToRememberMfaDevice: createAction(`${authStoreName}/checkIfAllowToRememberMfaDevice`, (payload) => ({ payload })),
    changePhoneNumberWithVerification: createAction(`${authStoreName}/changePhoneNumberWithVerification`, (payload) => ({ payload })),
    verifyChangePhoneNumber: createAction(`${authStoreName}/verifyChangePhoneNumber`, (payload) => ({ payload })),
    quickSmsPasswordlessPreLogin: createAction(`${authStoreName}/quickSmsPasswordlessPreLogin`, (payload) => ({ payload })),
    passwordlessPreLogin: createAction(`${authStoreName}/passwordlessPreLogin`, (payload) => ({ payload })),
    passwordlessPostLogin: createAction(`${authStoreName}/passwordlessPostLogin`, (payload) => ({ payload })),
    verifyInviteToken: createAction(`${authStoreName}/verifyInviteToken`, (payload) => ({ payload })),
    webAuthnPrelogin: createAction(`${authStoreName}/webAuthnPrelogin`, (payload) => ({ payload })),
    webAuthnPostLogin: createAction(`${authStoreName}/webAuthnPostLogin`, (payload) => ({ payload })),
    webAuthnCreateNewDeviceSession: createAction(`${authStoreName}/webAuthnCreateNewDeviceSession`, (payload) => ({ payload })),
    webAuthnVerifyNewDeviceSession: createAction(`${authStoreName}/webAuthnVerifyNewDeviceSession`, (payload) => ({ payload })),
};

var ActivateAccountStep;
(function (ActivateAccountStep) {
    ActivateAccountStep["activating"] = "activating";
    ActivateAccountStep["success"] = "success";
    ActivateAccountStep["resend"] = "resend";
    ActivateAccountStep["activatingForm"] = "activatingForm";
})(ActivateAccountStep || (ActivateAccountStep = {}));

const activateState = {
    step: ActivateAccountStep.activating,
    loading: false,
    resentEmail: false,
    activationStrategy: {
        loading: false,
    },
};
const reducers$e = {
    setActivateState: typeReducerForKey('activateState'),
    resetActivateState: resetStateByKey('activateState', { activateState }),
    setActivateStrategyState: typeReducerNestedKey('activateState', 'activationStrategy'),
};
const actions$f = {
    activateAccount: createAction(`${authStoreName}/activateAccount`, (payload) => ({ payload })),
    preActivateAccount: createAction(`${authStoreName}/preActivateAccount`, (payload) => ({ payload })),
    getActivateAccountStrategy: createAction(`${authStoreName}/getActivateAccountStrategy`, (payload) => ({ payload })),
    resendActivationEmail: createAction(`${authStoreName}/resendActivationEmail`, (payload) => ({
        payload,
    })),
};

var AcceptInvitationStep;
(function (AcceptInvitationStep) {
    AcceptInvitationStep["validate"] = "validate";
    AcceptInvitationStep["invalid"] = "invalid";
    AcceptInvitationStep["pending"] = "pending";
    AcceptInvitationStep["success"] = "success";
    AcceptInvitationStep["failed"] = "failed";
})(AcceptInvitationStep || (AcceptInvitationStep = {}));

const acceptInvitationState = {
    step: AcceptInvitationStep.validate,
};
const reducers$d = {
    setAcceptInvitationState: typeReducerForKey('acceptInvitationState'),
    resetAcceptInvitationState: resetStateByKey('acceptInvitationState', {
        acceptInvitationState,
    }),
};
const actions$e = {
    acceptInvitation: createAction(`${authStoreName}/acceptInvitation`, (payload) => ({ payload })),
};

var ForgotPasswordStep;
(function (ForgotPasswordStep) {
    ForgotPasswordStep["forgotPassword"] = "forgotPassword";
    ForgotPasswordStep["success"] = "success";
})(ForgotPasswordStep || (ForgotPasswordStep = {}));

const forgotPasswordState = {
    step: ForgotPasswordStep.forgotPassword,
    loading: false,
    email: '',
    passwordConfig: null,
};
const reducers$c = {
    setForgotPasswordState: typeReducerForKey('forgotPasswordState'),
    resetForgotPasswordState: resetStateByKey('forgotPasswordState', { forgotPasswordState }),
};
const actions$d = {
    forgotPassword: createAction(`${authStoreName}/forgotPassword`, (payload) => ({ payload })),
    resetPassword: createAction(`${authStoreName}/resetPassword`, (payload) => ({ payload })),
    loadPasswordConfig: createAction(`${authStoreName}/loadPasswordConfig`, (payload) => ({
        payload,
    })),
};

var ResetPhoneNumberStep;
(function (ResetPhoneNumberStep) {
    ResetPhoneNumberStep["ResetPhoneNumber"] = "ResetPhoneNumber";
    ResetPhoneNumberStep["VerifyResetPhoneNumber"] = "VerifyResetPhoneNumber";
    ResetPhoneNumberStep["ChangePhoneNumber"] = "ChangePhoneNumber";
})(ResetPhoneNumberStep || (ResetPhoneNumberStep = {}));

const resetPhoneNumberState = {
    step: ResetPhoneNumberStep.ResetPhoneNumber,
    loading: false,
};
const reducers$b = {
    setResetPhoneNumberState: typeReducerForKey('resetPhoneNumberState'),
    resetResetPhoneNumberState: resetStateByKey('resetPhoneNumberState', { resetPhoneNumberState }),
};
const actions$c = {
    resetPhoneNumber: createAction(`${authStoreName}/resetPhoneNumber`, (payload) => ({ payload })),
    verifyResetPhoneNumber: createAction(`${authStoreName}/verifyResetPhoneNumber`, (payload) => ({ payload })),
    changePhoneNumber: createAction(`${authStoreName}/changePhoneNumber`, (payload) => ({ payload })),
};

const ssoState = {
    firstLoad: true,
    loading: true,
    saving: false,
    errors: {},
    loaders: {},
    ssoConfigurations: []
};
const reducers$a = {
    setSSOLoader: loadersReducerForKey('ssoState'),
    setSSOError: errorsReducerForKey('ssoState'),
    setSSOState: typeReducerForKey('ssoState'),
    resetSSOState: resetStateByKey('ssoState', { ssoState }),
};
const actions$b = {
    loadSSOConfigurationsV2: createAction(`${authStoreName}/loadSSOConfigurationsV2`),
    saveSSOConfigurationV2: createAction(`${authStoreName}/saveSSOConfigurationV2`, (payload) => ({ payload })),
    updateSSOConfiguration: createAction(`${authStoreName}/updateSSOConfiguration`, (payload) => ({ payload })),
    deleteSSOConfiguration: createAction(`${authStoreName}/deleteSSOConfiguration`, (payload) => ({ payload })),
    saveSSODomain: createAction(`${authStoreName}/saveSSODomain`, (payload) => ({ payload })),
    deleteSSODomain: createAction(`${authStoreName}/deleteSSODomain`, (payload) => ({ payload })),
    validateSSODomainV2: createAction(`${authStoreName}/validateSSODomainV2`, (payload) => ({ payload })),
    setSSODefaultRoles: createAction(`${authStoreName}/setSSODefaultRoles`, (payload) => ({ payload })),
    setSSOGroups: createAction(`${authStoreName}/setSSOGroups`, (payload) => ({ payload })),
    updateSSOGroups: createAction(`${authStoreName}/updateSSOGroups`, (payload) => ({ payload })),
    saveSSOConfigurationByMetadata: createAction(`${authStoreName}/saveSSOConfigurationByMetadata`, (payload) => ({ payload })),
    updateSSOConfigurationByMetadata: createAction(`${authStoreName}/updateSSOConfigurationByMetadata`, (payload) => ({ payload })),
    loadSSOConfigurations: createAction(`${authStoreName}/loadSSOConfigurations`),
    loadSSOAuthorizationRoles: createAction(`${authStoreName}/loadSSOAuthorizationRoles`),
    saveSSOConfigurations: createAction(`${authStoreName}/saveSSOConfigurations`, (payload) => ({ payload })),
    // NOTE: use withCallback in case of promise response
    saveSSOConfigurationsFile: createAction(`${authStoreName}/saveSSOConfigurationsFile`, (payload) => ({
        payload,
    })),
    saveSSOConfigurationsFileWithCallback: createAction(`${authStoreName}/saveSSOConfigurationsFileWithCallback`, (payload) => ({ payload })),
    validateSSODomain: createAction(`${authStoreName}/validateSSODomain`, (payload) => ({ payload })),
    updateSSOAuthorizationRoles: createAction(`${authStoreName}/updateSSOAuthorizationRoles`, (payload) => ({ payload })),
    deleteSamlGroup: createAction(`${authStoreName}/deleteSamlGroup`, (payload) => ({ payload })),
    createSamlGroup: createAction(`${authStoreName}/createSamlGroup`, (payload) => ({ payload })),
    oidcPostlogin: createAction(`${authStoreName}/oidcPostlogin`, (payload) => ({
        payload,
    })),
};

const profileState = {
    loading: false,
    error: null,
};
const reducers$9 = {
    setProfileState: typeReducerForKey('profileState'),
    resetProfileState: resetStateByKey('profileState', { profileState }),
};
const actions$a = {
    loadProfile: createAction(`${authStoreName}/loadProfile`),
    saveProfile: createAction(`${authStoreName}/saveProfile`, (payload) => ({ payload })),
    changePassword: createAction(`${authStoreName}/changePassword`, (payload) => ({
        payload,
    })),
};

var MFAStep;
(function (MFAStep) {
    MFAStep["verify"] = "verify";
    MFAStep["recoveryCode"] = "recoveryCode";
})(MFAStep || (MFAStep = {}));

const mfaState = {
    step: MFAStep.verify,
    loading: false,
};
const reducers$8 = {
    setMfaState: typeReducerForKey('mfaState'),
    resetMfaState: resetStateByKey('mfaState', { mfaState }),
};
const actions$9 = {
    enrollMfa: createAction(`${authStoreName}/enrollMfa`),
    verifyMfa: createAction(`${authStoreName}/verifyMfa`, (payload) => ({
        payload,
    })),
    verifyMfaAfterForce: createAction(`${authStoreName}/verifyMfaAfterForce`, (payload) => ({
        payload,
    })),
    disableMfa: createAction(`${authStoreName}/disableMfa`, (payload) => ({ payload })),
};

const teamState = {
    loaders: {},
    pageOffset: 0,
    pageSize: 20,
    errors: {},
    users: [],
    allUsers: [],
    roles: [],
    permissions: [],
    totalPages: 0,
    filter: [],
    sort: [],
    allUsersQueryParams: {
        _filter: null,
        _offset: 0,
        _limit: 20,
        _order: 'DESC',
        _sortBy: 'name',
    },
    addUserDialogState: {
        loading: false,
        open: false,
    },
    deleteUserDialogState: {
        loading: false,
        open: false,
    },
    lockUserDialogState: {
        loading: false,
        open: false,
    },
};
const reducers$7 = {
    setTeamLoader: loadersReducerForKey('teamState'),
    setTeamError: errorsReducerForKey('teamState'),
    setTeamState: typeReducerForKey('teamState'),
    resetTeamState: resetStateByKey('teamState', { teamState }),
};
const actions$8 = {
    loadUsers: createAction(`${authStoreName}/loadUsers`, (payload) => ({ payload })),
    loadAllSubTenantsUsers: createAction(`${authStoreName}/loadAllSubTenantsUsers`, (payload) => ({ payload })),
    loadRoles: createAction(`${authStoreName}/loadRoles`, (payload) => ({ payload })),
    addUser: createAction(`${authStoreName}/addUser`, (payload) => ({ payload })),
    addUserToSubTenants: createAction(`${authStoreName}/addUserToSubTenants`, (payload) => ({ payload })),
    updateUser: createAction(`${authStoreName}/updateUser`, (payload) => ({
        payload,
    })),
    deleteUser: createAction(`${authStoreName}/deleteUser`, (payload) => ({ payload })),
    setUserRolesForSubTenants: createAction(`${authStoreName}/setUserRolesForSubTenants`, (payload) => ({ payload })),
    deleteUserFromSubTenants: createAction(`${authStoreName}/deleteUserFromSubTenants`, (payload) => ({ payload })),
    lockUser: createAction(`${authStoreName}/lockUser`, (payload) => ({ payload })),
    resendActivationLink: createAction(`${authStoreName}/resendActivationLink`, (payload) => ({ payload })),
    resendInvitationLink: createAction(`${authStoreName}/resendInvitationLink`, (payload) => ({ payload })),
    resendInvitationLinkToAllSubTenants: createAction(`${authStoreName}/resendInvitationLinkToAllSubTenants`, (payload) => ({ payload })),
    getInvitationLink: createAction(`${authStoreName}/getInvitationLink`),
    createInvitationLink: createAction(`${authStoreName}/createInvitationLink`, (payload) => ({ payload })),
    updateInvitationLink: createAction(`${authStoreName}/updateInvitationLink`, (payload) => ({ payload })),
    deleteInvitationLink: createAction(`${authStoreName}/deleteInvitationLink`, (payload) => ({ payload })),
    openAddUserDialog: createAction(`${authStoreName}/openAddUserDialog`, (payload) => ({ payload })),
    closeAddUserDialog: createAction(`${authStoreName}/closeAddUserDialog`, (payload) => ({ payload })),
    openDeleteUserDialog: createAction(`${authStoreName}/openDeleteUserDialog`, (payload) => ({
        payload,
    })),
    closeDeleteUserDialog: createAction(`${authStoreName}/closeDeleteUserDialog`, (payload) => ({ payload })),
    openLockUserDialog: createAction(`${authStoreName}/openLockUserDialog`, (payload) => ({
        payload,
    })),
    closeLockUserDialog: createAction(`${authStoreName}/closeLockUserDialog`, (payload) => ({ payload })),
};

const socialLoginState = {
    firstLoad: true,
    loading: false,
    error: '',
};
const reducers$6 = {
    setSocialLoginsState: typeReducerForKey('socialLoginState'),
    resetSocialLoginsState: resetStateByKey('socialLoginState', { socialLoginState }),
};
const actions$7 = {
    loadSocialLoginsConfiguration: createAction(`${authStoreName}/loadSocialLoginsConfiguration`),
    loadSocialLoginsConfigurationV2: createAction(`${authStoreName}/loadSocialLoginsConfigurationV2`),
    loginViaSocialLogin: createAction(`${authStoreName}/loginViaSocialLogin`, (payload) => ({
        payload,
    })),
    setSocialLoginError: createAction(`${authStoreName}/setSocialLoginError`, (payload) => ({
        payload,
    })),
};

var SignUpStage;
(function (SignUpStage) {
    SignUpStage["SignUp"] = "SignUp";
    SignUpStage["SignUpSuccess"] = "SignUpSuccess";
})(SignUpStage || (SignUpStage = {}));

const signUpState = {
    loading: false,
    allowSignUps: false,
    allowNotVerifiedUsersLogin: false,
    firstLoad: true,
    stage: SignUpStage.SignUp,
};
const reducers$5 = {
    setSignUpState: typeReducerForKey('signUpState'),
    resetSignUpState: resetStateByKey('signUpState', { signUpState }),
};
const actions$6 = {
    signUpUser: createAction(`${authStoreName}/signUpUser`, (payload) => ({ payload })),
    resetSignUpStateSoft: createAction(`${authStoreName}/resetSignUpStateSoft`),
};

const apiTokensState = {
    apiTokenType: null,
    searchValue: '',
    showAddTokenDialog: false,
    createdByUserIdColumn: 'show',
    deleteTokenDialog: {
        open: false,
        clientId: '',
    },
    successDialog: {
        open: false,
        secret: '',
        clientId: '',
    },
    loaders: {},
    apiTokensDataTenant: [],
    apiTokensDataUser: [],
    roles: [],
    permissions: [],
    errors: {},
};
const reducers$4 = {
    setApiTokensLoader: loadersReducerForKey('apiTokensState'),
    setApiTokensError: errorsReducerForKey('apiTokensState'),
    setApiTokensState: typeReducerForKey('apiTokensState'),
    resetApiTokensState: resetStateByKey('apiTokensState', { apiTokensState }),
};
const actions$5 = {
    loadApiTokens: createAction(`${authStoreName}/loadApiTokens`, (payload) => ({
        payload,
    })),
    initApiTokensData: createAction(`${authStoreName}/initApiTokensData`, (payload) => ({ payload })),
    addTenantApiToken: createAction(`${authStoreName}/addTenantApiToken`, (payload) => ({
        payload,
    })),
    addUserApiToken: createAction(`${authStoreName}/addUserApiToken`, (payload) => ({ payload })),
    deleteUserApiToken: createAction(`${authStoreName}/deleteUserApiToken`, (payload) => ({ payload })),
    deleteTenantApiToken: createAction(`${authStoreName}/deleteTenantApiToken`, (payload) => ({ payload })),
};

const securityPolicyState = {
    globalPolicy: {
        loading: true,
    },
    publicPolicy: {
        loading: false,
    },
    vendorMfaPolicy: {
        loading: true,
    },
    mfaPolicy: {
        loading: true,
    },
    lockoutPolicy: {
        loading: true,
    },
    captchaPolicy: {
        loading: true,
    },
    passwordHistoryPolicy: {
        loading: true,
    },
    passwordPolicy: {
        loading: true,
    },
    publicAuthStrategyPolicy: {
        loading: true,
    },
};
const reducers$3 = {
    setSecurityPolicyState: typeReducerForKey('securityPolicyState'),
    setSecurityPolicyGlobalState: typeReducerNestedKey('securityPolicyState', 'globalPolicy'),
    setSecurityPolicyPublicState: typeReducerNestedKey('securityPolicyState', 'publicPolicy'),
    setSecurityPolicyAuthStrategyPublicState: typeReducerNestedKey('securityPolicyState', 'publicAuthStrategyPolicy'),
    setSecurityPolicyMfaState: typeReducerNestedKey('securityPolicyState', 'mfaPolicy'),
    setSecurityPolicyVendorMfaState: typeReducerNestedKey('securityPolicyState', 'vendorMfaPolicy'),
    setSecurityPolicyLockoutState: typeReducerNestedKey('securityPolicyState', 'lockoutPolicy'),
    setSecurityPolicyCaptchaState: typeReducerNestedKey('securityPolicyState', 'captchaPolicy'),
    setSecurityPolicyPasswordHistoryState: typeReducerNestedKey('securityPolicyState', 'passwordHistoryPolicy'),
    setSecurityPolicyPasswordState: typeReducerNestedKey('securityPolicyState', 'passwordPolicy'),
    resetSecurityPolicyState: resetStateByKey('securityPolicyState', { securityPolicyState }),
};
const actions$4 = {
    loadSecurityPolicy: createAction(`${authStoreName}/loadSecurityPolicy`),
    loadPublicSecurityPolicy: createAction(`${authStoreName}/loadPublicSecurityPolicy`),
    loadSecurityPolicyMfa: createAction(`${authStoreName}/loadSecurityPolicyMfa`),
    loadSecurityPolicyVendorMfa: createAction(`${authStoreName}/loadSecurityPolicyVendorMfa`),
    saveSecurityPolicyMfa: createAction(`${authStoreName}/saveSecurityPolicyMfa`, (payload) => ({ payload })),
    loadSecurityPolicyLockout: createAction(`${authStoreName}/loadSecurityPolicyLockout`),
    saveSecurityPolicyLockout: createAction(`${authStoreName}/saveSecurityPolicyLockout`, (payload) => ({ payload })),
    loadSecurityPolicyCaptcha: createAction(`${authStoreName}/loadSecurityPolicyCaptcha`),
    loadSecurityPolicyPasswordHistory: createAction(`${authStoreName}/loadSecurityPolicyPasswordHistory`),
    saveSecurityPolicyPasswordHistory: createAction(`${authStoreName}/saveSecurityPolicyPasswordHistory`, (payload) => ({ payload })),
    loadVendorPasswordConfig: createAction(`${authStoreName}/loadVendorPasswordConfig`),
    loadPublicAuthStrategiesPolicy: createAction(`${authStoreName}/loadPublicAuthStrategiesPolicy`),
};

const accountSettingsState = {
    loading: false,
};
const reducers$2 = {
    setAccountSettingsState: typeReducerForKey('accountSettingsState'),
    resetAccountSettingsState: resetStateByKey('accountSettingsState', { accountSettingsState }),
};
const actions$3 = {
    loadAccountSettings: createAction(`${authStoreName}/loadAccountSettings`, (payload) => ({ payload })),
    saveAccountSettings: createAction(`${authStoreName}/saveAccountSettings`, (payload) => ({ payload })),
};

const tenantsState = {
    tenants: [],
    subTenants: [],
    loading: true,
    tenantTree: null,
};
const reducers$1 = {
    setTenantsState: typeReducerForKey('tenantsState'),
    resetTenantsState: resetStateByKey('tenantsState', { tenantsState }),
};
const actions$2 = {
    switchTenant: createAction(`${authStoreName}/switchTenant`, (payload) => ({ payload })),
    loadTenants: createAction(`${authStoreName}/loadTenants`, (payload) => ({
        payload,
    })),
    loadSubTenants: createAction(`${authStoreName}/loadSubTenants`, (payload) => ({
        payload,
    })),
    loadSubTenantsTree: createAction(`${authStoreName}/loadSubTenantsTree`, (payload) => ({
        payload,
    })),
};

const rolesState = {
    loading: false,
    roles: [],
    permissions: [],
    permissionCategories: [],
};
const auth_reducers = {
    setRolesState: typeReducerForKey('rolesState'),
    resetRolesState: resetStateByKey('rolesState', { rolesState }),
};
const auth_actions$1 = {
    loadRolesAndPermissions: createAction(`${authStoreName}/loadRoles`, (payload) => ({ payload })),
    addRole: createAction(`${authStoreName}/addRole`, (payload) => ({ payload })),
    updateRole: createAction(`${authStoreName}/updateRole`, (payload) => ({ payload })),
    deleteRole: createAction(`${authStoreName}/deleteRole`, (payload) => ({ payload })),
    attachPermissionsToRole: createAction(`${authStoreName}/attachPermissionsToRole`, (payload) => ({ payload })),
    attachPermissionToRoles: createAction(`${authStoreName}/attachPermissionToRoles`, (payload) => ({ payload })),
};

const reinitializeState = {
    isAuthenticated: false,
    isLoading: true,
    isSSOAuth: false,
    user: null,
    signUpState,
    loginState,
    activateState,
    acceptInvitationState,
    forgotPasswordState,
    ssoState,
    profileState,
    mfaState,
    teamState,
    socialLoginState,
    apiTokensState,
    securityPolicyState,
    accountSettingsState,
    tenantsState,
    rolesState,
    resetPhoneNumberState
};
const auth_initialState = Object.assign({ routes: {
        authenticatedUrl: '/',
        loginUrl: '/account/login',
        logoutUrl: '/account/logout',
        activateUrl: '/account/activate',
        acceptInvitationUrl: '/account/invitation/accept',
        forgetPasswordUrl: '/account/forget-password',
        resetPhoneNumberUrl: '/account/reset-phone-number',
        resetPasswordUrl: '/account/reset-password',
        socialLoginCallbackUrl: '/account/social/success',
        signUpUrl: '/account/sign-up',
        oidcRedirectUrl: '/account/oidc/callback',
        samlCallbackUrl: '/account/saml/callback',
        magicLinkCallbackUrl: '/account/login/magic-link',
        hostedLoginRedirectUrl: '/oauth/callback'
    }, onRedirectTo: () => { } }, reinitializeState);

const { reducer: auth_reducer, actions: auth_sliceActions } = createSlice({
    name: authStoreName,
    initialState: auth_initialState,
    reducers: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({ resetState: (state) => (Object.assign(Object.assign({}, state), reinitializeState)), setState: (state, { payload }) => (Object.assign(Object.assign({}, state), payload)), setUser: typeReducer('user') }, reducers$f), reducers$6), reducers$e), reducers$d), reducers$c), reducers$b), reducers$5), reducers$9), reducers$a), reducers$8), reducers$7), reducers$4), reducers$3), reducers$2), reducers$1), auth_reducers),
});
const auth_actions = Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, auth_sliceActions), actions$g), actions$7), actions$f), actions$e), actions$d), actions$c), actions$6), actions$a), actions$b), actions$9), actions$8), actions$5), actions$4), actions$3), actions$2), auth_actions$1);

var SSOStateKeys;
(function (SSOStateKeys) {
    SSOStateKeys["LOAD_SSO_CONFIGURATIONS"] = "LOAD_SSO_CONFIGURATIONS";
    SSOStateKeys["SAVE_SSO_CONFIGURATION"] = "SAVE_SSO_CONFIGURATION";
    SSOStateKeys["UPDATE_SSO_CONFIGURATION"] = "UPDATE_SSO_CONFIGURATION";
    SSOStateKeys["SAVE_SSO_CONFIGURATION_BY_METADATA"] = "SAVE_SSO_CONFIGURATION_BY_METADATA";
    SSOStateKeys["UPDATE_SSO_CONFIGURATION_BY_METADATA"] = "UPDATE_SSO_CONFIGURATION";
    SSOStateKeys["DELETE_SSO_CONFIGURATION"] = "DELETE_SSO_CONFIGURATION";
    SSOStateKeys["SAVE_SSO_DOMAIN"] = "SAVE_SSO_DOMAIN";
    SSOStateKeys["DELETE_SSO_DOMAIN"] = "DELETE_SSO_DOMAIN";
    SSOStateKeys["VALIDATE_SSO_DOMAIN"] = "VALIDATE_SSO_DOMAIN";
    SSOStateKeys["UPDATE_SSO_DEFAULT_ROLES"] = "UPDATE_SSO_DEFAULT_ROLES";
    SSOStateKeys["DELETE_SSO_GROUPS"] = "DELETE_SSO_GROUPS";
    SSOStateKeys["SAVE_SSO_GROUPS"] = "SAVE_SSO_GROUPS";
    SSOStateKeys["GET_SSO_AUTHORIZATION_ROLES"] = "GET_SSO_AUTHORIZATION_ROLES";
})(SSOStateKeys || (SSOStateKeys = {}));
var SamlVendors;
(function (SamlVendors) {
    SamlVendors["Saml"] = "saml";
    SamlVendors["Okta"] = "okta";
    SamlVendors["Azure"] = "azure";
    SamlVendors["Google"] = "google";
    SamlVendors["Oidc"] = "oidc";
})(SamlVendors || (SamlVendors = {}));

function omitProps(props, keys) {
    const newProps = Object.assign({}, props);
    keys.forEach((key) => {
        delete newProps[key];
    });
    return newProps;
}
function generateCodeChallenge(codeVerifier) {
    return (0,tslib_es6.__awaiter)(this, void 0, void 0, function* () {
        const digest = yield crypto.subtle.digest('SHA-256', new TextEncoder().encode(codeVerifier));
        // @ts-ignore
        return btoa(String.fromCharCode(...new Uint8Array(digest)))
            .replace(/=/g, '')
            .replace(/\+/g, '-')
            .replace(/\//g, '_');
    });
}
function createRandomString(length = 16) {
    let text = '';
    const possible = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < length; i++) {
        text += possible.charAt(Math.floor(Math.random() * possible.length));
    }
    return text;
}
const readFileAsText = (file) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsText(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
});

const apiTokensDataDemo = {
    clientId: 'CLIENT_ID_16806d3d-8fc3-4450-be97-abdaf66b723e',
    secret: 'SECRET_16806d3d-8fc3-4450-be97-abdaf66b723e',
    createdAt: 'createdAt',
    description: 'Demo API Token (preview only)',
};
const apiTokensDataTenantDemo = Object.assign(Object.assign({}, apiTokensDataDemo), { roleIds: [], tenantId: 'my-tenant-id', createdByUserId: 'createdByUserId' });
const roleDemo = [
    {
        id: 'roleId',
        key: 'admin',
        isDefault: false,
        name: 'Admin',
        description: null,
        permissions: ['adminPermissionId'],
        tenantId: 'tenantId',
        vendorId: 'vendorId',
        createdAt: new Date(),
        updatedAt: new Date(),
    },
];
const rolePermissionDemo = [
    {
        id: 'adminPermissionId',
        key: 'fe.*',
        name: 'General Admin',
        description: undefined,
        categoryId: 'category',
        fePermission: true,
        createdAt: new Date(),
        updatedAt: new Date(),
    },
];
const userProfileDemo = {
    id: 'testId',
    name: 'Demo User Name',
    email: 'demo-user@frontegg.com',
    mfaEnrolled: true,
    profileImage: undefined,
    profilePictureUrl: 'https://www.gravatar.com/avatar/42b2ad2bad6fc9b9db5086dfcf8072ac?d=https://ui-avatars.com/api/fe/128/random?t=1617261890875?t=1617261917434',
    roles: roleDemo,
    permissions: rolePermissionDemo,
    tenantId: 'my-tenant-id',
    tenantIds: ['my-tenant-id'],
    activatedForTenant: true,
    metadata: JSON.stringify({
        phoneNumber: '+972-54123456',
        jobTitle: 'Developer',
        address: {
            city: 'Tel Aviv',
            country: 'Israel',
        },
    }),
    roleIds: undefined,
    verified: undefined,
};
const userDemo = Object.assign(Object.assign({}, userProfileDemo), { accessToken: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiI1MTY5YmY0Zi02YmI5LTQ5NGMtOGNkZS05MDc4NDQ0NWY4MDciLCJuYW1lIjoiRHVtbXkgVXNlciIsImVtYWlsIjoiZHVtbXlAZnJvbnRlZ2cuY29tIiwiZW1haWxfdmVyaWZpZWQiOnRydWUsIm1ldGFkYXRhIjp7fSwicm9sZXMiOlsiYWRtaW4iXSwicGVybWlzc2lvbnMiOlsiZmUuKiJdLCJ0ZW5hbnRJZCI6Im15LXRlbmFudC1pZCIsInRlbmFudElkcyI6WyJteS10ZW5hbnQtaWQiXSwicHJvZmlsZVBpY3R1cmVVcmwiOiJodHRwczovL3d3dy5ncmF2YXRhci5jb20vYXZhdGFyLzQyYjJhZDJiYWQ2ZmM5YjlkYjUwODZkZmNmODA3MmFjP2Q9aHR0cHM6Ly91aS1hdmF0YXJzLmNvbS9hcGkvZmUvMTI4L3JhbmRvbT90PTE2MTcyNjE4OTA4NzU_dD0xNjE3MjYxOTE3NDM0IiwidHlwZSI6InVzZXJUb2tlbiIsImlhdCI6MTYxNzkwNjMyNCwiZXhwIjoxNjE3OTkyNzI0LCJpc3MiOiJmcm9udGVnZyJ9.paaXLkpWEWbQmUtoK2P8IwXCxK4WJp7XhXonvzF8g1I', expiresIn: 86400, mfaRequired: false, refreshToken: 'refresh-token-dummy-de39dc9c-9d22-4852-b7f5-c3c0aa613b58', type: 'userToken', iat: 1617906324, exp: 1617992724, iss: 'frontegg', email_verified: true });
const profileStateDemo = {
    loading: false,
    error: undefined,
    saving: true,
    profile: userProfileDemo,
};
const policyDemo = {
    id: 'id',
    enforceMFAType: 'DontForce',
    createdAt: new Date(),
    updatedAt: new Date(),
    allowOverrideEnforcePasswordHistory: true,
    allowOverridePasswordComplexity: false,
    allowOverridePasswordExpiration: false,
    allowSignups: true,
    apiTokensEnabled: true,
    cookieSameSite: 'cookieSameSite',
    defaultRefreshTokenExpiration: 0,
    defaultTokenExpiration: 1,
    publicKey: 'publicKey',
};
const publicSecurityPolicy = {
    allowSignups: true,
    allowNotVerifiedUsersLogin: false,
    apiTokensEnabled: true,
    forcePermissions: false,
    authStrategy: umd.AuthStrategyEnum.EmailAndPassword,
};
const policyMfaDemo = {
    id: 'id',
    enforceMFAType: 'DontForce',
    createdAt: new Date(),
    updatedAt: new Date(),
};
const policyLockoutDemo = {
    id: 'id',
    enabled: true,
    maxAttempts: 1,
    createdAt: new Date(),
    updatedAt: new Date(),
};
const policyPasswordHistoryDemo = {
    id: 'id',
    enabled: true,
    historySize: 1,
    createdAt: new Date(),
    updatedAt: new Date(),
};
const samlConfigurationDemo = {
    enabled: true,
    domain: 'domain',
    validated: true,
    generatedVerification: 'generatedVerification',
    ssoEndpoint: 'ssoEndpoint',
    publicCertificate: 'publicCertificate',
    signRequest: true,
    createdAt: new Date(),
    updatedAt: new Date(),
    acsUrl: undefined,
    spEntityId: undefined,
    oidcClientId: undefined,
    oidcSecret: undefined,
    type: undefined,
};
const samlMetadataDemo = {
    id: 'id',
    createdAt: 'createdAt',
    updatedAt: 'updatedAt',
    properties: [],
    vendorId: 'vendorId',
    entityName: 'saml',
    isActive: true,
    configuration: {
        acsUrl: 'acsUrl',
        spEntityId: 'spEntityId',
    },
};
const rolesDemo = [
    {
        id: 'id',
        description: 'description',
        key: 'key',
        name: 'name',
        permissions: [],
        permissionLevel: 1,
    },
];
const ssoStateDemo = {
    firstLoad: false,
    loading: false,
    error: undefined,
    saving: false,
    samlConfiguration: samlConfigurationDemo,
    roles: rolesDemo,
    authorizationRoles: [],
    errors: {},
    loaders: {},
    ssoConfigurations: [],
};
const permissionsDemo = [
    {
        description: 'string',
        fePermission: true,
        id: 'id',
        key: 'key',
        name: 'name',
        roleIds: [],
        createdAt: new Date(),
        updatedAt: new Date(),
        categoryId: 'categoryId',
    },
];
const userTeamDemo2 = {
    id: 'id2',
    email: 'demo-user2@frontegg.com',
    name: 'Demo User Name2',
    phone: undefined,
    profileImage: undefined,
    profileImageUrl: undefined,
    tenantId: 'tenantId',
    vendorId: 'vendorId',
    roleIds: [],
    activatedForTenant: true,
    verified: false,
    createdAt: new Date().toISOString(),
    customData: undefined,
    lastLogin: undefined,
    mfaEnabled: undefined,
    roles: [],
}; // TODO add verified to ITeamUser
const userTeamDemo = {
    id: 'id',
    email: 'demo-user@frontegg.com',
    name: 'Demo User Name',
    phone: undefined,
    profileImage: undefined,
    profileImageUrl: undefined,
    tenantId: 'tenantId',
    vendorId: 'vendorId',
    roleIds: [],
    activatedForTenant: true,
    createdAt: new Date(2022, 4, 1).toISOString(),
    verified: true,
    customData: undefined,
    lastLogin: new Date(2022, 5, 25).toISOString(),
    mfaEnabled: undefined,
    roles: [],
};
const userSubTenantDemo = {
    metadata: '',
    mfaEnrolled: false,
    provider: '',
    sub: '',
    tenantIds: [],
    tenants: [],
    verified: false,
    id: 'id',
    email: 'email',
    name: 'name',
    tenantId: 'tenantId',
    createdAt: new Date(),
};
const usersDemo = [userTeamDemo, userTeamDemo2];
const allUsersDemo = [userSubTenantDemo];
const tenantsDemo = [
    {
        id: 'my-tenant-id',
        isReseller: false,
        name: 'Frontegg demo',
        deletedAt: null,
        metadata: undefined,
        tenantId: 'my-tenant-id',
        vendorId: 'vendorId',
        createdAt: new Date(),
        updatedAt: new Date(),
        address: undefined,
        timezone: undefined,
        dateFormat: undefined,
        timeFormat: undefined,
        currency: undefined,
        logo: undefined,
    },
];

var UserVeirifedOriginTypes;
(function (UserVeirifedOriginTypes) {
    UserVeirifedOriginTypes["SOCIAL_LOGIN"] = "SOCIAL_LOGIN";
    UserVeirifedOriginTypes["PASSWORDLESS"] = "PASSWORDLESS";
    UserVeirifedOriginTypes["ACTIVATION_LINK"] = "ACTIVATION_LINK";
})(UserVeirifedOriginTypes || (UserVeirifedOriginTypes = {}));
var AuthenticationTypes;
(function (AuthenticationTypes) {
    AuthenticationTypes["SOCIAL_LOGIN"] = "SOCIAL_LOGIN";
    AuthenticationTypes["PASSWORD"] = "PASSWORD";
})(AuthenticationTypes || (AuthenticationTypes = {}));

function* loadAllowSignUps() {
    yield put(auth_actions.setSignUpState({ loading: true }));
    try {
        const policy = yield call(umd.api.auth.getVendorConfig);
        const { allowSignups: allowSignUps, allowNotVerifiedUsersLogin } = policy;
        yield put(auth_actions.setSignUpState({ loading: false, allowSignUps, allowNotVerifiedUsersLogin, firstLoad: false }));
        yield put(auth_actions.setSecurityPolicyPublicState({ policy, loading: false }));
    }
    catch (e) {
        yield put(auth_actions.setSignUpState({ loading: false, error: e.message, firstLoad: false }));
    }
}
function* signUpUser(_a) {
    var _b;
    var _c = _a.payload, { events, url } = _c, payload = (0,tslib_es6.__rest)(_c, ["events", "url"]);
    yield put(auth_actions.setSignUpState({ loading: true }));
    try {
        const { routes, onRedirectTo } = yield io_c3792963_select((state) => state.auth);
        const { shouldActivate, user, tenantId, userId } = yield call(umd.api.auth.signUpUser, payload);
        if (!payload.invitationToken) {
            const { email, name, companyName } = payload;
            (_b = events === null || events === void 0 ? void 0 : events.signUpComplete) === null || _b === void 0 ? void 0 : _b.call(events, {
                email,
                name,
                companyName,
                url,
                authenticationType: AuthenticationTypes.PASSWORD,
                id: userId,
                tenantId,
                createdAt: new Date(),
            });
        }
        umd.ContextHolder.setAccessToken(user === null || user === void 0 ? void 0 : user.accessToken);
        umd.ContextHolder.setUser(user);
        if (!shouldActivate && (user === null || user === void 0 ? void 0 : user.mfaRequired) && (user === null || user === void 0 ? void 0 : user.mfaToken)) {
            let step = LoginStep.loginWithTwoFactor;
            if (user.hasOwnProperty('mfaEnrolled') && !user.mfaEnrolled) {
                yield put(auth_actions.setMfaState({
                    step: MFAStep.verify,
                    qrCode: user.qrCode,
                    recoveryCode: user.recoveryCode,
                    mfaToken: user.mfaToken,
                    loading: false,
                }));
                step = LoginStep.forceTwoFactor;
            }
            yield put(auth_actions.setLoginState({ step }));
            onRedirectTo(routes.loginUrl);
        }
        else {
            yield put(auth_actions.setSignUpState({ loading: false, shouldActivate, stage: SignUpStage.SignUpSuccess }));
            yield put(auth_actions.setState({
                user,
                isAuthenticated: !!(user === null || user === void 0 ? void 0 : user.accessToken),
            }));
            if (!shouldActivate) {
                yield put(auth_actions.loadTenants());
            }
        }
    }
    catch (e) {
        umd.ContextHolder.setAccessToken(null);
        umd.ContextHolder.setUser(null);
        yield put(auth_actions.setSignUpState({ loading: false, error: e.message }));
    }
    yield put(auth_actions.setSignUpState({ loading: false }));
}
function* resetSignUpStateSoft() {
    const { allowSignUps, allowNotVerifiedUsersLogin } = yield io_c3792963_select((state) => state.auth.signUpState);
    yield put(auth_actions.resetSignUpState());
    yield put(auth_actions.setSignUpState({ allowSignUps, allowNotVerifiedUsersLogin }));
}
function* signUpSaga() {
    yield takeLeading$1(auth_actions.signUpUser, signUpUser);
    yield takeLeading$1(auth_actions.resetSignUpStateSoft, resetSignUpStateSoft);
}

function* loadSecurityPolicy() {
    yield put(auth_actions.setSecurityPolicyGlobalState({ loading: true, error: null }));
    try {
        const policy = yield call(umd.api.auth.getGlobalSecurityPolicy);
        yield put(auth_actions.setSecurityPolicyGlobalState({ policy, loading: false }));
    }
    catch (e) {
        yield put(auth_actions.setSecurityPolicyGlobalState({ error: e.message, loading: false }));
    }
    yield put(auth_actions.loadSecurityPolicyMfa());
    yield put(auth_actions.loadSecurityPolicyVendorMfa());
    yield put(auth_actions.loadSecurityPolicyLockout());
    yield put(auth_actions.loadSecurityPolicyCaptcha());
    yield put(auth_actions.loadPublicAuthStrategiesPolicy());
}
function* loadPublicSecurityPolicy() {
    yield put(auth_actions.setSecurityPolicyPublicState({ loading: true, error: null }));
    try {
        const policy = yield call(umd.api.auth.getVendorConfig);
        yield put(auth_actions.setSecurityPolicyPublicState({ policy, loading: false }));
    }
    catch (e) {
        yield put(auth_actions.setSecurityPolicyPublicState({ error: e.message, loading: false }));
    }
}
function* loadPublicAuthStrategiesPolicy() {
    yield put(auth_actions.setSecurityPolicyAuthStrategyPublicState({ loading: true, error: null }));
    try {
        const policy = yield call(umd.api.auth.getVendorPublicAuthStrategiesConfig);
        yield put(auth_actions.setSecurityPolicyAuthStrategyPublicState({ policy, loading: false }));
    }
    catch (e) {
        yield put(auth_actions.setSecurityPolicyAuthStrategyPublicState({ error: e.message, loading: false }));
    }
}
function* loadSecurityPolicyMfa() {
    yield put(auth_actions.setSecurityPolicyMfaState({ loading: true, error: null }));
    try {
        const policy = yield call(umd.api.auth.getMfaPolicy);
        yield put(auth_actions.setSecurityPolicyMfaState({ policy, loading: false }));
    }
    catch (e) {
        yield put(auth_actions.setSecurityPolicyMfaState({ error: e.message, loading: false }));
    }
}
function* loadSecurityPolicyVendorMfa() {
    yield put(auth_actions.setSecurityPolicyMfaState({ loading: true, error: null }));
    try {
        const policy = yield call(umd.api.auth.getVendorMfaPolicy);
        yield put(auth_actions.setSecurityPolicyVendorMfaState({ policy, loading: false }));
    }
    catch (e) {
        yield put(auth_actions.setSecurityPolicyVendorMfaState({ error: e.message, loading: false }));
    }
}
function* saveSecurityPolicyMfa(_a) {
    var _b = _a.payload, { callback } = _b, newSecurityPolicy = (0,tslib_es6.__rest)(_b, ["callback"]);
    yield put(auth_actions.setSecurityPolicyMfaState({ saving: true, error: null }));
    try {
        const policy = yield call(umd.api.auth.saveMfaPolicy, newSecurityPolicy);
        yield put(auth_actions.setSecurityPolicyMfaState({ policy, saving: false }));
        callback === null || callback === void 0 ? void 0 : callback(policy);
    }
    catch (e) {
        yield put(auth_actions.setSecurityPolicyMfaState({ saving: false, error: e.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
}
function* loadSecurityPolicyLockout() {
    yield put(auth_actions.setSecurityPolicyLockoutState({ loading: true, error: null }));
    try {
        const policy = yield call(umd.api.auth.getLockoutPolicy);
        yield put(auth_actions.setSecurityPolicyLockoutState({ policy, loading: false }));
    }
    catch (e) {
        yield put(auth_actions.setSecurityPolicyLockoutState({ error: e.message, loading: false }));
    }
}
function* saveSecurityPolicyLockout(_a) {
    var _b = _a.payload, { callback } = _b, newSecurityPolicy = (0,tslib_es6.__rest)(_b, ["callback"]);
    yield put(auth_actions.setSecurityPolicyLockoutState({ saving: true, error: null }));
    try {
        const policy = yield call(umd.api.auth.saveLockoutPolicy, newSecurityPolicy);
        yield put(auth_actions.setSecurityPolicyLockoutState({ policy, saving: false }));
        callback === null || callback === void 0 ? void 0 : callback(policy);
    }
    catch (e) {
        yield put(auth_actions.setSecurityPolicyLockoutState({ saving: false, error: e.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
}
function* loadSecurityPolicyCaptcha() {
    yield put(auth_actions.setSecurityPolicyLockoutState({ loading: true, error: null }));
    try {
        const policy = yield call(umd.api.auth.getCaptchaPolicy);
        yield put(auth_actions.setSecurityPolicyCaptchaState({ policy, loading: false }));
    }
    catch (e) {
        yield put(auth_actions.setSecurityPolicyCaptchaState({ error: e.message, loading: false }));
    }
}
function* loadSecurityPolicyPasswordHistory() {
    yield put(auth_actions.setSecurityPolicyPasswordHistoryState({ loading: true, error: null }));
    try {
        const policy = yield call(umd.api.auth.getPasswordHistoryPolicy);
        yield put(auth_actions.setSecurityPolicyPasswordHistoryState({ policy, loading: false }));
    }
    catch (e) {
        yield put(auth_actions.setSecurityPolicyPasswordHistoryState({ error: e.message, loading: false }));
    }
}
function* saveSecurityPolicyPasswordHistory(_a) {
    var _b = _a.payload, { callback } = _b, newSecurityPolicy = (0,tslib_es6.__rest)(_b, ["callback"]);
    yield put(auth_actions.setSecurityPolicyPasswordHistoryState({ saving: true, error: null }));
    try {
        const policy = yield call(umd.api.auth.savePasswordHistoryPolicy, newSecurityPolicy);
        yield put(auth_actions.setSecurityPolicyPasswordHistoryState({ policy, saving: false }));
        callback === null || callback === void 0 ? void 0 : callback(policy);
    }
    catch (e) {
        yield put(auth_actions.setSecurityPolicyPasswordHistoryState({ saving: false, error: e.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
}
function* loadVendorPasswordConfig() {
    yield put(auth_actions.setSecurityPolicyPasswordState({ loading: true, error: null }));
    try {
        const policy = yield call(umd.api.auth.getPasswordConfigPolicy);
        yield put(auth_actions.setSecurityPolicyPasswordState({ policy, loading: false }));
    }
    catch (e) {
        yield put(auth_actions.setSecurityPolicyPasswordState({ error: e.message, loading: false }));
    }
}
function* securityPolicySagas() {
    yield takeLeading$1(auth_actions.loadSecurityPolicy, loadSecurityPolicy);
    yield takeEvery$1(auth_actions.saveSecurityPolicyMfa, saveSecurityPolicyMfa);
    yield takeEvery$1(auth_actions.loadSecurityPolicyMfa, loadSecurityPolicyMfa);
    yield takeEvery$1(auth_actions.loadSecurityPolicyVendorMfa, loadSecurityPolicyVendorMfa);
    yield takeEvery$1(auth_actions.saveSecurityPolicyLockout, saveSecurityPolicyLockout);
    yield takeEvery$1(auth_actions.loadSecurityPolicyLockout, loadSecurityPolicyLockout);
    yield takeEvery$1(auth_actions.loadSecurityPolicyCaptcha, loadSecurityPolicyCaptcha);
    yield takeEvery$1(auth_actions.saveSecurityPolicyPasswordHistory, saveSecurityPolicyPasswordHistory);
    yield takeEvery$1(auth_actions.loadSecurityPolicyPasswordHistory, loadSecurityPolicyPasswordHistory);
    yield takeEvery$1(auth_actions.loadVendorPasswordConfig, loadVendorPasswordConfig);
    yield takeEvery$1(auth_actions.loadPublicSecurityPolicy, loadPublicSecurityPolicy);
    yield takeEvery$1(auth_actions.loadPublicAuthStrategiesPolicy, loadPublicAuthStrategiesPolicy);
}
/*********************************
 *  Preview Sagas
 *********************************/
function* loadPublicSecurityPolicyMock() {
    yield put(auth_actions.setSecurityPolicyPublicState({ loading: true, error: null }));
    try {
        yield put(auth_actions.setSecurityPolicyPublicState({ policy: publicSecurityPolicy, loading: false }));
    }
    catch (e) {
        yield put(auth_actions.setSecurityPolicyPublicState({ error: e.message, loading: false }));
    }
}
function* loadSecurityPolicyMock() {
    yield put(auth_actions.setSecurityPolicyGlobalState({ loading: true, error: null }));
    yield auth_delay();
    yield put(auth_actions.setSecurityPolicyGlobalState({ policy: policyDemo, loading: false }));
    yield put(auth_actions.loadSecurityPolicyMfa());
    yield put(auth_actions.loadSecurityPolicyVendorMfa());
    yield put(auth_actions.loadSecurityPolicyLockout());
    yield put(auth_actions.loadSecurityPolicyCaptcha());
}
function* loadSecurityPolicyMfaMock() {
    yield put(auth_actions.setSecurityPolicyMfaState({ loading: true, error: null }));
    yield auth_delay();
    yield put(auth_actions.setSecurityPolicyMfaState({ policy: policyMfaDemo, loading: false }));
}
function* loadSecurityPolicyVendorMfaMock() {
    yield put(auth_actions.setSecurityPolicyVendorMfaState({ loading: true, error: null }));
    yield auth_delay();
    yield put(auth_actions.setSecurityPolicyVendorMfaState({ policy: policyMfaDemo, loading: false }));
}
function* saveSecurityPolicyMfaMock(_a) {
    var _b;
    var _c = _a.payload, { callback } = _c, newSecurityPolicy = (0,tslib_es6.__rest)(_c, ["callback"]);
    yield put(auth_actions.setSecurityPolicyMfaState({ saving: true, error: null }));
    const policy = Object.assign(Object.assign({}, policyLockoutDemo), { id: (_b = newSecurityPolicy.id) !== null && _b !== void 0 ? _b : policyLockoutDemo.id, enforceMFAType: newSecurityPolicy.enforceMFAType });
    yield auth_delay();
    yield put(auth_actions.setSecurityPolicyMfaState({ policy, saving: false }));
    callback === null || callback === void 0 ? void 0 : callback(policy);
}
function* loadSecurityPolicyLockoutMock() {
    yield put(auth_actions.setSecurityPolicyLockoutState({ loading: true, error: null }));
    yield auth_delay();
    yield put(auth_actions.setSecurityPolicyLockoutState({ policy: policyLockoutDemo, loading: false }));
}
function* saveSecurityPolicyLockoutMock(_a) {
    var _b = _a.payload, { callback } = _b, newSecurityPolicy = (0,tslib_es6.__rest)(_b, ["callback"]);
    yield put(auth_actions.setSecurityPolicyLockoutState({ saving: true, error: null }));
    yield auth_delay();
    const policy = Object.assign(Object.assign(Object.assign({}, newSecurityPolicy), policyLockoutDemo), { id: newSecurityPolicy.id ? newSecurityPolicy.id : policyLockoutDemo.id });
    callback === null || callback === void 0 ? void 0 : callback(policy);
    yield put(auth_actions.setSecurityPolicyLockoutState({ policy, saving: false }));
}
function* loadSecurityPolicyCaptchaMock() {
    yield put(auth_actions.setSecurityPolicyLockoutState({ loading: true, error: null }));
    yield auth_delay();
    yield put(auth_actions.setSecurityPolicyLockoutState({ policy: policyLockoutDemo, loading: false }));
}
function* loadSecurityPolicyPasswordHistoryMock() {
    yield put(auth_actions.setSecurityPolicyPasswordHistoryState({ loading: true, error: null }));
    yield auth_delay();
    yield put(auth_actions.setSecurityPolicyPasswordHistoryState({ policy: policyPasswordHistoryDemo, loading: false }));
}
function* saveSecurityPolicyPasswordHistoryMock(_a) {
    var _b = _a.payload, { callback } = _b, newSecurityPolicy = (0,tslib_es6.__rest)(_b, ["callback"]);
    yield put(auth_actions.setSecurityPolicyPasswordHistoryState({ saving: true, error: null }));
    yield auth_delay();
    const policy = Object.assign(Object.assign(Object.assign({}, newSecurityPolicy), policyPasswordHistoryDemo), { id: newSecurityPolicy.id ? newSecurityPolicy.id : policyPasswordHistoryDemo.id });
    callback === null || callback === void 0 ? void 0 : callback(policy);
    yield put(auth_actions.setSecurityPolicyPasswordHistoryState({ policy, saving: false }));
}
function* securityPolicySagasMock() {
    yield takeLeading$1(auth_actions.loadSecurityPolicy, loadSecurityPolicyMock);
    yield takeEvery$1(auth_actions.loadPublicSecurityPolicy, loadPublicSecurityPolicyMock);
    yield takeEvery$1(auth_actions.saveSecurityPolicyMfa, saveSecurityPolicyMfaMock);
    yield takeEvery$1(auth_actions.loadSecurityPolicyMfa, loadSecurityPolicyMfaMock);
    yield takeEvery$1(auth_actions.loadSecurityPolicyVendorMfa, loadSecurityPolicyVendorMfaMock);
    yield takeEvery$1(auth_actions.saveSecurityPolicyLockout, saveSecurityPolicyLockoutMock);
    yield takeEvery$1(auth_actions.loadSecurityPolicyLockout, loadSecurityPolicyLockoutMock);
    yield takeEvery$1(auth_actions.loadSecurityPolicyCaptcha, loadSecurityPolicyCaptchaMock);
    yield takeEvery$1(auth_actions.saveSecurityPolicyPasswordHistory, saveSecurityPolicyPasswordHistoryMock);
    yield takeEvery$1(auth_actions.loadSecurityPolicyPasswordHistory, loadSecurityPolicyPasswordHistoryMock);
}

const authStrategyLoginStepMap = {
    [umd.AuthStrategyEnum.Code]: LoginStep.loginWithOtc,
    [umd.AuthStrategyEnum.EmailAndPassword]: LoginStep.loginWithPassword,
    [umd.AuthStrategyEnum.MagicLink]: LoginStep.magicLinkPreLoginSuccess,
    [umd.AuthStrategyEnum.SmsCode]: LoginStep.loginWithSmsOtc,
};
function* afterAuthNavigation() {
    var _a;
    const onRedirectTo = umd.ContextHolder.onRedirectTo;
    const { routes, includeQueryParam } = yield io_c3792963_select((state) => state.auth);
    const { loginUrl, logoutUrl, socialLoginCallbackUrl, activateUrl } = routes;
    let { authenticatedUrl } = routes;
    const afterAuthRedirect = window.localStorage.getItem(FRONTEGG_AFTER_AUTH_REDIRECT_URL);
    if (afterAuthRedirect && ![loginUrl, logoutUrl, socialLoginCallbackUrl, activateUrl].includes(afterAuthRedirect)) {
        authenticatedUrl = afterAuthRedirect;
    }
    window.localStorage.removeItem(FRONTEGG_AFTER_AUTH_REDIRECT_URL);
    yield io_c3792963_delay(200);
    put(auth_actions.resetLoginState());
    const url = new URL(window === null || window === void 0 ? void 0 : window.location.href);
    let redirectUrl = authenticatedUrl;
    if (url.searchParams.get('redirectUrl')) {
        redirectUrl = (_a = url.searchParams.get('redirectUrl')) !== null && _a !== void 0 ? _a : authenticatedUrl;
    }
    else if (includeQueryParam) {
        redirectUrl += window.location.search;
    }
    onRedirectTo(redirectUrl, { refresh: redirectUrl.startsWith('http') });
}
function* refreshMetadata() {
    var _a;
    let ssoACS;
    try {
        const metadata = yield call(umd.api.metadata.getSamlMetadata);
        ssoACS = (_a = metadata === null || metadata === void 0 ? void 0 : metadata.configuration) === null || _a === void 0 ? void 0 : _a.acsUrl;
    }
    catch (e) {
        console.error(e);
    }
    yield put(auth_actions.setState({ ssoACS }));
}
function* loadSSOPublicConfigurationFunction() {
    try {
        const { isActive } = yield call(umd.api.auth.getSSOPublicConfiguration);
        yield put(auth_actions.setState({ isSSOAuth: isActive }));
    }
    catch (e) {
        console.error(e);
    }
}
const isMfaRequired = (user) => {
    if (user.mfaRequired && user.mfaToken) {
        umd.ContextHolder.setAccessToken(null);
        umd.ContextHolder.setUser(null);
        return true;
    }
    else {
        umd.ContextHolder.setAccessToken(user.accessToken);
        umd.ContextHolder.setUser(user);
        return false;
    }
};
function* getMfaRequiredState(user) {
    let setMfaState = {};
    let step = LoginStep.loginWithTwoFactor;
    const { loginState } = yield io_c3792963_select((state) => state.auth);
    const { isAllowedToRemember, mfaDeviceExpiration } = yield call(umd.api.auth.checkIfAllowToRememberMfaDevice, user.mfaToken);
    if (user.hasOwnProperty('mfaEnrolled') && !user.mfaEnrolled) {
        setMfaState = {
            mfaState: {
                step: MFAStep.verify,
                qrCode: user.qrCode,
                recoveryCode: user.recoveryCode,
                loading: false,
                mfaToken: user.mfaToken,
            },
        };
        step = LoginStep.forceTwoFactor;
    }
    return Object.assign(Object.assign({ user: undefined, isAuthenticated: false }, setMfaState), { loginState: Object.assign(Object.assign({}, loginState), { mfaToken: user.mfaToken, mfaRequired: user.mfaRequired, loading: false, error: undefined, step, tenantsLoading: true, email: user.userEmail, tenants: [], allowRememberMfaDevice: isAllowedToRemember, mfaDeviceExpiration }) });
}
function* refreshToken() {
    var _a;
    try {
        const onRedirectTo = umd.ContextHolder.onRedirectTo;
        const { routes, loginState } = yield io_c3792963_select((state) => state.auth);
        const { user, tenants } = yield call(umd.api.auth.refreshTokenV2);
        if (isMfaRequired(user)) {
            const mfaRequiredState = yield getMfaRequiredState(user);
            yield put(auth_actions.setState(mfaRequiredState));
            onRedirectTo(routes.loginUrl, { preserveQueryParams: true });
        }
        else {
            if (user.email) {
                localStorage.setItem('email', user.email);
                localStorage.setItem('name', user.name);
            }
            const quickLoginToRegister = (_a = localStorage.getItem('register-quick-login')) !== null && _a !== void 0 ? _a : loginState.quickLoginToRegister;
            const shouldNavigateToRegisterQuicKLogin = quickLoginToRegister && localStorage.getItem(`${user.email}-${quickLoginToRegister}`) !== 'true';
            yield put(auth_actions.setTenantsState({ tenants, loading: false }));
            yield put(auth_actions.setState({
                user,
                isAuthenticated: true,
                loginState: Object.assign(Object.assign({}, loginState), { quickLoginToRegister, flow: shouldNavigateToRegisterQuicKLogin ? LoginFlow.RegisterQuickLogin : LoginFlow.Login })
            }));
            if (shouldNavigateToRegisterQuicKLogin) {
                onRedirectTo(routes.loginUrl);
            }
            else if ([routes.loginUrl, routes.socialLoginCallbackUrl, routes.signUpUrl, routes.oidcRedirectUrl, routes.samlCallbackUrl]
                .some(url => url && window.location.pathname.endsWith(url))) {
                if (loginState.isNewUser && routes.signUpSuccessUrl && routes.socialLoginCallbackUrl === window.location.pathname) {
                    onRedirectTo(routes.signUpSuccessUrl, { refresh: routes.signUpSuccessUrl.startsWith('http') });
                }
                else {
                    yield afterAuthNavigation();
                }
            }
        }
    }
    catch (e) {
        umd.ContextHolder.setAccessToken(null);
        umd.ContextHolder.setUser(null);
        yield put(auth_actions.setState({ user: undefined, isAuthenticated: false }));
    }
}
function* requestAuthorize({ payload: firstTime }) {
    const calls = [];
    if (firstTime) {
        yield put(auth_actions.setState({ isLoading: true }));
        yield put(auth_actions.loadSocialLoginsConfigurationV2());
        calls.push(call(loadAllowSignUps));
        calls.push(call(loadPublicAuthStrategiesPolicy));
        calls.push(call(loadSSOPublicConfigurationFunction));
        calls.push(call(loadVendorPublicInfo));
        calls.push(call(refreshMetadata));
    }
    calls.push(call(refreshToken));
    yield io_c3792963_all(calls);
    yield put(auth_actions.setState({ isLoading: false }));
}
function* refreshTokenSSR(accessToken) {
    if (!accessToken) {
        umd.ContextHolder.setAccessToken(null);
        umd.ContextHolder.setUser(null);
        yield put(auth_actions.setState({ user: undefined, isAuthenticated: false }));
        return;
    }
    try {
        const onRedirectTo = umd.ContextHolder.onRedirectTo;
        const { routes } = yield io_c3792963_select((state) => state.auth);
        const { user, tenants } = yield call(umd.api.auth.generateLoginResponseV2, { accessToken });
        if (isMfaRequired(user)) {
            const mfaRequiredState = yield getMfaRequiredState(user);
            yield put(auth_actions.setState(mfaRequiredState));
            onRedirectTo(routes.loginUrl, { preserveQueryParams: true });
        }
        else {
            yield put(auth_actions.setTenantsState({ tenants, loading: false }));
            yield put(auth_actions.setState({ user, isAuthenticated: true }));
        }
    }
    catch (e) {
        umd.ContextHolder.setAccessToken(null);
        umd.ContextHolder.setUser(null);
        yield put(auth_actions.setState({ user: undefined, isAuthenticated: false }));
    }
}
function* requestAuthorizeSSR({ payload: accessToken }) {
    const calls = [];
    yield put(auth_actions.setState({ isLoading: true }));
    yield put(auth_actions.loadSocialLoginsConfigurationV2());
    calls.push(call(loadAllowSignUps));
    calls.push(call(loadSSOPublicConfigurationFunction));
    calls.push(call(loadVendorPublicInfo));
    calls.push(call(refreshMetadata));
    calls.push(call(refreshTokenSSR, accessToken));
    yield io_c3792963_all(calls);
    yield put(auth_actions.setState({ isLoading: false }));
}
function* requestHostedLoginAuthorize() {
    const { routes, context, onRedirectTo } = yield io_c3792963_select((state) => ({
        routes: state.auth.routes,
        onRedirectTo: state.auth.onRedirectTo,
        context: state.root.context,
    }));
    // Generate the relevant params for the redirect
    const nonce = createRandomString();
    const code_verifier = createRandomString();
    const code_challenge = yield call(generateCodeChallenge, code_verifier);
    // We are saving the verifier in session storage to be able to validate the response
    localStorage.setItem(HOSTED_LOGIN_VERIFIER_KEY, code_verifier);
    const redirectUrl = `${window.location.origin}${routes.hostedLoginRedirectUrl}`;
    const baseUrl = umd.fetch.getBaseUrl(context, '/oauth/authorize');
    // Hard coded for now
    const oauthUrl = `${baseUrl}/oauth/authorize`;
    const params = {
        response_type: 'code',
        client_id: context.clientId || 'INVALID-CLIENT-ID',
        scope: 'openid email profile',
        redirect_uri: redirectUrl,
        code_challenge: code_challenge,
        code_challenge_method: 'S256',
        nonce,
    };
    const searchParams = new URLSearchParams(params);
    const url = `${oauthUrl}?${searchParams.toString()}`;
    onRedirectTo(url, { refresh: true });
}
function* handleHostedLoginCallback({ payload }) {
    // Hard coded for now
    const code_verifier = localStorage.getItem(HOSTED_LOGIN_VERIFIER_KEY) || 'INVALID-CODE-VERIFIER';
    const routes = yield io_c3792963_select((state) => state.auth.routes);
    const redirectUrl = `${window.location.origin}${routes.hostedLoginRedirectUrl}`;
    const body = {
        code: payload.code,
        redirect_uri: redirectUrl,
        code_verifier,
        grant_type: 'authorization_code',
    };
    const user = yield call(umd.api.auth.exchangeOAuthTokens, body);
    // TODO: Validate nonce and aud
    yield put(auth_actions.setState({ user, isAuthenticated: true }));
    yield put(auth_actions.loadTenants());
    yield afterAuthNavigation();
}
function* changePhoneNumberWithVerification(_a) {
    var _b = _a.payload, { callback } = _b, payload = (0,tslib_es6.__rest)(_b, ["callback"]);
    try {
        yield put(auth_actions.setLoginState({ loading: true }));
        const changePhoneRes = yield call(umd.api.auth.changePhoneNumberWithVerification, payload);
        yield put(auth_actions.setLoginState({ phoneNumber: payload.phoneNumber, loading: false, changePhoneId: changePhoneRes.changePhoneId, step: LoginStep.loginWithQuickSmsOtc, error: undefined }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setLoginState({ error: e.message, loading: false }));
    }
}
function* verifyChangePhoneNumber(_a) {
    var _b = _a.payload, { callback } = _b, payload = (0,tslib_es6.__rest)(_b, ["callback"]);
    try {
        yield put(auth_actions.setLoginState({ loading: true }));
        yield call(umd.api.auth.verifyChangePhoneNumber, payload);
        yield put(auth_actions.setLoginState({ loading: false }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setLoginState({ error: e.message, loading: false }));
    }
}
function* quickSmsPasswordlessPreLogin(_a) {
    var _b = _a.payload, { callback } = _b, payload = (0,tslib_es6.__rest)(_b, ["callback"]);
    try {
        yield put(auth_actions.setLoginState({ loading: true }));
        const preloginRes = yield call(umd.api.auth.passwordlessPreLogin, Object.assign(Object.assign({}, payload), { type: umd.AuthStrategyEnum.SmsCode }));
        yield put(auth_actions.setLoginState({
            step: LoginStep.loginWithQuickSmsOtc,
            loading: false,
            email: payload.email,
            phoneNumber: preloginRes === null || preloginRes === void 0 ? void 0 : preloginRes.phoneNumber,
        }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setLoginState({ error: e.message, loading: false }));
        callback === null || callback === void 0 ? void 0 : callback(e);
    }
}
function* passwordlessPreLogin(_a) {
    var _b = _a.payload, { callback } = _b, payload = (0,tslib_es6.__rest)(_b, ["callback"]);
    try {
        const { onRedirectTo, routes } = yield io_c3792963_select(({ auth: { onRedirectTo, routes } }) => ({ onRedirectTo, routes }));
        yield put(auth_actions.setLoginState({ loading: true }));
        const preloginRes = yield call(umd.api.auth.passwordlessPreLogin, payload);
        const step = authStrategyLoginStepMap[payload.type];
        if (step === LoginStep.loginWithSmsOtc && preloginRes.resetPhoneNumberToken) {
            yield put(auth_actions.setResetPhoneNumberState({
                resetPhoneNumberToken: preloginRes.resetPhoneNumberToken,
                step: ResetPhoneNumberStep.VerifyResetPhoneNumber,
            }));
            onRedirectTo(routes.resetPhoneNumberUrl);
            return;
        }
        yield put(auth_actions.setLoginState({
            step,
            loading: false,
            email: payload.email,
            phoneNumber: preloginRes === null || preloginRes === void 0 ? void 0 : preloginRes.phoneNumber,
        }));
        callback === null || callback === void 0 ? void 0 : callback();
    }
    catch (e) {
        yield put(auth_actions.setLoginState({ error: e.message, loading: false }));
        callback === null || callback === void 0 ? void 0 : callback();
    }
}
function* passwordlessPostLogin(_a) {
    var _b, _c;
    var _d = _a.payload, { callback, events } = _d, payload = (0,tslib_es6.__rest)(_d, ["callback", "events"]);
    try {
        yield put(auth_actions.setLoginState({ loading: true }));
        const data = yield call(umd.api.auth.passwordlessPostLogin, payload);
        const onRedirectTo = umd.ContextHolder.onRedirectTo;
        const { routes } = yield io_c3792963_select((state) => state.auth);
        if (isMfaRequired(data)) {
            const mfaRequiredState = yield getMfaRequiredState(data);
            yield put(auth_actions.setState(mfaRequiredState));
            onRedirectTo(routes.loginUrl, { preserveQueryParams: true });
        }
        else {
            const { loginState } = yield io_c3792963_select((state) => state.auth);
            const user = yield call(umd.api.auth.generateLoginResponse, data);
            if (data.emailVerified) {
                (_b = events === null || events === void 0 ? void 0 : events.userVerified) === null || _b === void 0 ? void 0 : _b.call(events, {
                    email: user.email,
                    origin: UserVeirifedOriginTypes.PASSWORDLESS,
                    id: user.id,
                    tenantId: user.tenantId,
                    createdAt: new Date(),
                    name: user.name,
                });
            }
            if (user.email) {
                localStorage.setItem('email', user.email);
                localStorage.setItem('name', user.name);
            }
            yield put(auth_actions.setState({ user, isAuthenticated: true }));
            yield put(auth_actions.loadTenants());
            if (loginState.flow === LoginFlow.Login) {
                yield afterAuthNavigation();
            }
            else {
                onRedirectTo(routes.loginUrl, { preserveQueryParams: true });
            }
        }
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setLoginState({ error: (_c = e.message) !== null && _c !== void 0 ? _c : 'Failed to authenticate' }));
    }
    finally {
        yield put(auth_actions.setLoginState({ loading: false }));
    }
}
function* verifyInviteToken({ payload }) {
    var _a;
    try {
        yield put(auth_actions.setLoginState({ loading: true }));
        const { name: inviteTokenTenantName } = yield call(umd.api.auth.verifyInviteToken, payload);
        yield put(auth_actions.setLoginState({ inviteTokenTenantName }));
    }
    catch (e) {
        console.error(e);
        yield put(auth_actions.setLoginState({ inviteTokenError: (_a = e.message) !== null && _a !== void 0 ? _a : `We couldn't verify your invitation` }));
    }
    finally {
        yield put(auth_actions.setLoginState({ loading: false }));
    }
}
function* preLogin({ payload: { email, recaptchaToken, invitationToken, callback, }, }) {
    yield put(auth_actions.setLoginState({ loading: true }));
    try {
        const onRedirectTo = yield io_c3792963_select(({ auth: { onRedirectTo } }) => onRedirectTo);
        let { address, idpType } = yield call(umd.api.auth.preLoginV2, { email });
        if (address) {
            if (idpType === SamlVendors.Oidc && !address.includes('redirect_uri')) {
                const { routes: { oidcRedirectUrl } } = yield io_c3792963_select(({ auth: { routes } }) => ({ routes }));
                address += `&redirect_uri=${window.location.origin}${oidcRedirectUrl}`;
            }
            yield put(auth_actions.setLoginState({ step: LoginStep.redirectToSSO, loading: false, ssoRedirectUrl: address }));
            setTimeout(() => {
                onRedirectTo(address, { refresh: true });
            }, 2000);
        }
        else {
            yield ssoPreloginFailed({ email, recaptchaToken, callback, invitationToken });
        }
    }
    catch (e) {
        yield ssoPreloginFailed({ email, recaptchaToken, callback, invitationToken });
    }
}
function* ssoPreloginFailed(_a) {
    var { callback } = _a, body = (0,tslib_es6.__rest)(_a, ["callback"]);
    const publicPolicy = yield io_c3792963_select(({ auth: { securityPolicyState: { publicPolicy: { policy: publicPolicy } } } }) => publicPolicy);
    if (!(publicPolicy === null || publicPolicy === void 0 ? void 0 : publicPolicy.authStrategy)) {
        yield put(auth_actions.setLoginState({ step: LoginStep.loginWithPassword, loading: false }));
        callback === null || callback === void 0 ? void 0 : callback();
        return;
    }
    if ((publicPolicy === null || publicPolicy === void 0 ? void 0 : publicPolicy.authStrategy) === umd.AuthStrategyEnum.EmailAndPassword) {
        yield put(auth_actions.setLoginState({ step: LoginStep.loginWithPassword, loading: false }));
        callback === null || callback === void 0 ? void 0 : callback();
    }
    else if ([umd.AuthStrategyEnum.MagicLink, umd.AuthStrategyEnum.Code, umd.AuthStrategyEnum.SmsCode].includes(publicPolicy === null || publicPolicy === void 0 ? void 0 : publicPolicy.authStrategy)) {
        yield put(auth_actions.passwordlessPreLogin(Object.assign(Object.assign({}, body), { type: publicPolicy === null || publicPolicy === void 0 ? void 0 : publicPolicy.authStrategy, callback })));
    }
    else {
        yield put(auth_actions.setLoginState({ step: LoginStep.loginWithPassword, loading: false }));
        callback === null || callback === void 0 ? void 0 : callback();
    }
}
function* webAuthnCreateNewDeviceSession({ payload: { callback } }) {
    try {
        yield put(auth_actions.setLoginState({ loading: true }));
        const { options } = yield call(umd.api.auth.webAuthnCreateNewDeviceSession);
        options.user.id = base64urlDecode(options.user.id);
        options.challenge = base64urlDecode(options.challenge);
        options.excludeCredentials = [];
        callback === null || callback === void 0 ? void 0 : callback(options);
    }
    catch (e) {
        yield put(auth_actions.setLoginState({ error: e.message }));
        callback === null || callback === void 0 ? void 0 : callback(null);
    }
    finally {
        yield put(auth_actions.setLoginState({ loading: false }));
    }
}
function* webAuthnVerifyNewDeviceSession(_a) {
    var _b = _a.payload, { callback } = _b, body = (0,tslib_es6.__rest)(_b, ["callback"]);
    try {
        yield put(auth_actions.setLoginState({ loading: true }));
        const publicKey = publicKeyCredentialToJSON(body.publicKey);
        yield call(umd.api.auth.verifyNewDeviceSession, {
            id: publicKey.id,
            response: publicKey.response
        });
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setLoginState({ error: e.message }));
        callback === null || callback === void 0 ? void 0 : callback(null);
    }
    finally {
        yield put(auth_actions.setLoginState({ loading: false }));
    }
}
function* webAuthnPrelogin(_a) {
    var _b;
    var _c = _a.payload, { callback } = _c, body = (0,tslib_es6.__rest)(_c, ["callback"]);
    try {
        yield put(auth_actions.setLoginState({ loading: true }));
        const { options } = yield call(umd.api.auth.webAuthnPreLogin, body);
        options.challenge = base64urlDecode(options.challenge);
        options.allowCredentials = (_b = options.allowCredentials) === null || _b === void 0 ? void 0 : _b.map((credentials) => (Object.assign(Object.assign({}, credentials), { id: base64urlDecode(credentials.id) })));
        callback === null || callback === void 0 ? void 0 : callback(options);
    }
    catch (e) {
        yield put(auth_actions.setLoginState({ error: e.message }));
        callback === null || callback === void 0 ? void 0 : callback(null);
    }
    finally {
        yield put(auth_actions.setLoginState({ loading: false }));
    }
}
function* webAuthnPostLogin(_a) {
    var _b;
    var _c = _a.payload, { callback } = _c, body = (0,tslib_es6.__rest)(_c, ["callback"]);
    try {
        yield put(auth_actions.setLoginState({ loading: true }));
        const publicKey = publicKeyCredentialToJSON(body.publicKey);
        const data = yield call(umd.api.auth.webAuthnPostLogin, Object.assign(Object.assign({}, publicKey), { response: Object.assign(Object.assign({}, publicKey.response), { userHandle: (_b = publicKey.response.userHandle) !== null && _b !== void 0 ? _b : undefined }), recaptchaToken: body.recaptchaToken, invitationToken: body.invitationToken }));
        if (isMfaRequired(data)) {
            const onRedirectTo = umd.ContextHolder.onRedirectTo;
            const { routes } = yield io_c3792963_select((state) => state.auth);
            const mfaRequiredState = yield getMfaRequiredState(data);
            yield put(auth_actions.setState(mfaRequiredState));
            onRedirectTo(routes.loginUrl, { preserveQueryParams: true });
        }
        else {
            const user = yield call(umd.api.auth.generateLoginResponse, data);
            if (user.email) {
                localStorage.setItem('email', user.email);
                localStorage.setItem('name', user.name);
            }
            yield put(auth_actions.loadTenants());
            yield put(auth_actions.setState({ user, isAuthenticated: true }));
            yield afterAuthNavigation();
        }
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setLoginState({ error: e.message }));
        callback === null || callback === void 0 ? void 0 : callback(null);
    }
    finally {
        yield put(auth_actions.setLoginState({ loading: false }));
    }
}
function* postLogin({ payload }) {
    const { onRedirectTo, routes } = yield io_c3792963_select(({ auth: { onRedirectTo, routes } }) => ({ onRedirectTo, routes }));
    yield put(auth_actions.setLoginState({ loading: true }));
    try {
        const user = yield call(umd.api.auth.postLogin, payload);
        umd.ContextHolder.setAccessToken(user.accessToken);
        umd.ContextHolder.setUser(user);
        yield put(auth_actions.setState({
            user: !!user.accessToken ? user : undefined,
            isAuthenticated: !!user.accessToken,
        }));
        yield afterAuthNavigation();
    }
    catch (e) {
        setTimeout(() => {
            onRedirectTo(routes.authenticatedUrl);
        }, 1000);
        yield put(auth_actions.setLoginState({ step: LoginStep.loginWithSSOFailed, loading: false }));
    }
}
function* login({ payload: { email, password, recaptchaToken, invitationToken, callback, }, }) {
    yield put(auth_actions.setLoginState({ loading: true }));
    try {
        const user = yield call(umd.api.auth.login, {
            email,
            password,
            recaptchaToken,
            invitationToken,
        });
        umd.ContextHolder.setAccessToken(user.accessToken);
        umd.ContextHolder.setUser(user);
        let setMfaState = {};
        let step = LoginStep.success;
        if (user.mfaRequired && user.mfaToken) {
            step = LoginStep.loginWithTwoFactor;
            if (user.hasOwnProperty('mfaEnrolled') && !user.mfaEnrolled) {
                setMfaState = {
                    mfaState: {
                        step: MFAStep.verify,
                        qrCode: user.qrCode,
                        recoveryCode: user.recoveryCode,
                        mfaToken: user.mfaToken,
                        loading: false,
                    },
                };
                step = LoginStep.forceTwoFactor;
            }
        }
        const { loginState } = yield io_c3792963_select((state) => state.auth);
        const isLoginSucceeded = step === LoginStep.success;
        const isAuthenticated = isLoginSucceeded && !!user.accessToken;
        const loggedInUser = isLoginSucceeded ? user : undefined;
        let allowRememberDevice = { isAllowedToRemember: false, mfaDeviceExpiration: 0 };
        if (user.mfaRequired && user.mfaToken) {
            allowRememberDevice = yield call(umd.api.auth.checkIfAllowToRememberMfaDevice, user.mfaToken);
        }
        const { isAllowedToRemember, mfaDeviceExpiration } = allowRememberDevice;
        if (user.email) {
            localStorage.setItem('email', user.email);
            localStorage.setItem('name', user.name);
        }
        yield put(auth_actions.setState(Object.assign(Object.assign({ user: loggedInUser, isAuthenticated }, setMfaState), { loginState: {
                flow: loginState.flow,
                quickLoginToRegister: loginState.quickLoginToRegister,
                email,
                loading: false,
                error: undefined,
                mfaToken: user.mfaToken,
                step: (!isLoginSucceeded || loginState.flow === LoginFlow.Login) ? step : loginState.step,
                tenants: [],
                tenantsLoading: true,
                allowRememberMfaDevice: isAllowedToRemember,
                mfaDeviceExpiration,
            } })));
        if (isLoginSucceeded) {
            yield put(auth_actions.loadTenants());
        }
        if (isAuthenticated && loginState.flow === LoginFlow.Login) {
            yield afterAuthNavigation();
        }
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        umd.ContextHolder.setAccessToken(null);
        umd.ContextHolder.setUser(null);
        yield put(auth_actions.setLoginState({
            email,
            error: e.message,
            loading: false,
        }));
    }
}
function* loginWithMfa({ payload: { mfaToken, value, rememberDevice, callback }, }) {
    yield put(auth_actions.setLoginState({ loading: true }));
    try {
        const user = yield call(umd.api.auth.loginWithMfa, { mfaToken, value, rememberDevice });
        const { loginState } = yield io_c3792963_select((state) => state.auth);
        const step = loginState.flow === LoginFlow.Login ? LoginStep.success : loginState.step;
        yield put(auth_actions.setState({
            loginState: { flow: loginState.flow, quickLoginToRegister: loginState.quickLoginToRegister, loading: false, step, error: undefined, tenantsLoading: true, tenants: [] },
            user,
            isAuthenticated: true,
        }));
        if (user.email) {
            localStorage.setItem('email', user.email);
            localStorage.setItem('name', user.name);
        }
        yield put(auth_actions.loadTenants());
        if (loginState.flow === LoginFlow.Login) {
            yield afterAuthNavigation();
        }
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setLoginState({ error: e.message, loading: false }));
        callback === null || callback === void 0 ? void 0 : callback(false, e);
    }
}
function* recoverMfa({ payload }) {
    yield put(auth_actions.setLoginState({ loading: true }));
    try {
        yield call(umd.api.auth.recoverMfaToken, payload);
        yield put(auth_actions.setLoginState({ loading: false, error: undefined, step: LoginStep.preLogin }));
        yield put(auth_actions.setState({ user: undefined, isAuthenticated: false }));
    }
    catch (e) {
        yield put(auth_actions.setLoginState({ error: e.message, loading: false }));
    }
}
function* logout({ payload }) {
    yield put(auth_actions.setState({ isLoading: true }));
    try {
        yield call(umd.api.auth.logout);
    }
    catch (_a) {
    }
    yield put(auth_actions.resetState());
    yield put(auth_actions.requestAuthorize(true));
    payload === null || payload === void 0 ? void 0 : payload();
}
function* silentLogout({ payload }) {
    try {
        yield call(umd.api.auth.logout);
    }
    catch (_a) {
    }
    setTimeout(() => payload === null || payload === void 0 ? void 0 : payload(), 500);
}
function* loginSagas() {
    yield takeLeading$1(auth_actions.requestAuthorize, requestAuthorize);
    yield takeLeading$1(auth_actions.requestAuthorizeSSR, requestAuthorizeSSR);
    yield takeLeading$1(auth_actions.requestHostedLoginAuthorize, requestHostedLoginAuthorize);
    yield takeLeading$1(auth_actions.handleHostedLoginCallback, handleHostedLoginCallback);
    yield takeLeading$1(auth_actions.preLogin, preLogin);
    yield takeLeading$1(auth_actions.postLogin, postLogin);
    yield takeLeading$1(auth_actions.login, login);
    yield takeLeading$1(auth_actions.logout, logout);
    yield takeLeading$1(auth_actions.silentLogout, silentLogout);
    yield takeLeading$1(auth_actions.loginWithMfa, loginWithMfa);
    yield takeLeading$1(auth_actions.recoverMfa, recoverMfa);
    yield takeLeading$1(auth_actions.quickSmsPasswordlessPreLogin, quickSmsPasswordlessPreLogin);
    yield takeLeading$1(auth_actions.changePhoneNumberWithVerification, changePhoneNumberWithVerification);
    yield takeLeading$1(auth_actions.verifyChangePhoneNumber, verifyChangePhoneNumber);
    yield takeLeading$1(auth_actions.passwordlessPreLogin, passwordlessPreLogin);
    yield takeLeading$1(auth_actions.passwordlessPostLogin, passwordlessPostLogin);
    yield takeLeading$1(auth_actions.verifyInviteToken, verifyInviteToken);
    yield takeLeading$1(auth_actions.webAuthnPrelogin, webAuthnPrelogin);
    yield takeLeading$1(auth_actions.webAuthnPostLogin, webAuthnPostLogin);
    yield takeLeading$1(auth_actions.webAuthnCreateNewDeviceSession, webAuthnCreateNewDeviceSession);
    yield takeLeading$1(auth_actions.webAuthnVerifyNewDeviceSession, webAuthnVerifyNewDeviceSession);
    yield takeLeading$1(auth_actions.afterAuthNavigation, afterAuthNavigation);
}
/*********************************
 *  Preview Sagas
 *********************************/
function* requestAuthorizeMock({ payload: firstTime }) {
    if (firstTime) {
        yield put(auth_actions.setState({ isLoading: true }));
    }
    const user = userDemo;
    yield put(auth_actions.loadTenants());
    yield put(auth_actions.setState({ user, isAuthenticated: true, isLoading: false }));
}
function* loginSagasMock() {
    yield takeLeading$1(auth_actions.requestAuthorize, requestAuthorizeMock);
    yield takeLeading$1(auth_actions.afterAuthNavigation, afterAuthNavigation);
}

function* loadSSOConfigurations() {
    var _a, _b;
    try {
        yield put(auth_actions.setSSOState({ loading: true }));
        const samlConfiguration = yield call(umd.api.auth.getSamlConfiguration);
        const oidcConfiguration = yield call(umd.api.auth.getOidcConfiguration);
        const samlMetadata = yield call(umd.api.metadata.getSamlMetadata);
        samlConfiguration.acsUrl = (_a = samlMetadata === null || samlMetadata === void 0 ? void 0 : samlMetadata.configuration) === null || _a === void 0 ? void 0 : _a.acsUrl;
        samlConfiguration.spEntityId = (_b = samlMetadata === null || samlMetadata === void 0 ? void 0 : samlMetadata.configuration) === null || _b === void 0 ? void 0 : _b.spEntityId;
        samlConfiguration.isSamlActive = samlMetadata === null || samlMetadata === void 0 ? void 0 : samlMetadata.isActive;
        yield put(auth_actions.setSSOState({ samlConfiguration, oidcConfiguration, loading: false, firstLoad: false }));
    }
    catch (e) {
        yield put(auth_actions.setSSOState({ error: e.message, loading: false }));
    }
}
function* saveSSOConfigurationsFile({ payload: configFile }) {
    const oldSamlConfiguration = yield io_c3792963_select((state) => state.auth.ssoState.samlConfiguration);
    const loaderKey = 'saving';
    yield put(auth_actions.setSSOState({ error: undefined, [loaderKey]: true }));
    try {
        const metadata = yield readFileAsText(configFile[0]);
        const newSamlConfiguration = yield call(umd.api.auth.updateSamlVendorMetadata, { metadata });
        newSamlConfiguration.isSamlActive = oldSamlConfiguration === null || oldSamlConfiguration === void 0 ? void 0 : oldSamlConfiguration.isSamlActive;
        yield put(auth_actions.setSSOState({ samlConfiguration: newSamlConfiguration, error: undefined, [loaderKey]: false }));
    }
    catch (e) {
        yield put(auth_actions.setSSOState({ samlConfiguration: oldSamlConfiguration, error: e.message, [loaderKey]: false }));
    }
}
function* saveSSOConfigurationsFileWithCallback({ payload }) {
    const { configFile, callback } = payload;
    const oldSamlConfiguration = yield io_c3792963_select((state) => state.auth.ssoState.samlConfiguration);
    const loaderKey = 'saving';
    yield put(auth_actions.setSSOState({ error: undefined, [loaderKey]: true }));
    try {
        const metadata = yield readFileAsText(configFile);
        const newSamlConfiguration = yield call(umd.api.auth.updateSamlVendorMetadata, { metadata });
        newSamlConfiguration.isSamlActive = oldSamlConfiguration === null || oldSamlConfiguration === void 0 ? void 0 : oldSamlConfiguration.isSamlActive;
        yield put(auth_actions.setSSOState({ samlConfiguration: newSamlConfiguration, error: undefined, [loaderKey]: false }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setSSOState({ samlConfiguration: oldSamlConfiguration, error: e.message, [loaderKey]: false }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
}
function* saveSSOConfigurations({ payload }) {
    var _a, _b;
    const { callback, samlVendor } = payload, newSamlConfiguration = (0,tslib_es6.__rest)(payload, ["callback", "samlVendor"]);
    const oldSamlConfiguration = yield io_c3792963_select((state) => state.auth.ssoState.samlConfiguration);
    const samlConfiguration = Object.assign(Object.assign({}, oldSamlConfiguration), newSamlConfiguration);
    let loaderKey = 'saving';
    if ((samlConfiguration === null || samlConfiguration === void 0 ? void 0 : samlConfiguration.enabled) !== oldSamlConfiguration.enabled) {
        loaderKey = 'loading';
    }
    try {
        const firstTimeConfigure = !(samlConfiguration === null || samlConfiguration === void 0 ? void 0 : samlConfiguration.domain);
        if (firstTimeConfigure) {
            yield put(auth_actions.setSSOState({ samlConfiguration: Object.assign(Object.assign({}, oldSamlConfiguration), samlConfiguration) }));
            return;
        }
        else {
            yield put(auth_actions.setSSOState({ error: undefined, [loaderKey]: true }));
        }
        if (payload.type === SamlVendors.Saml) {
            const samlMetadata = yield call(umd.api.metadata.getSamlMetadata);
            samlConfiguration.acsUrl = (_a = samlMetadata === null || samlMetadata === void 0 ? void 0 : samlMetadata.configuration) === null || _a === void 0 ? void 0 : _a.acsUrl;
            samlConfiguration.spEntityId = (_b = samlMetadata === null || samlMetadata === void 0 ? void 0 : samlMetadata.configuration) === null || _b === void 0 ? void 0 : _b.spEntityId;
        }
        const updateSamlConfiguration = omitProps(samlConfiguration, [
            'validated',
            'generatedVerification',
            'createdAt',
            'updatedAt',
        ]);
        if ((oldSamlConfiguration === null || oldSamlConfiguration === void 0 ? void 0 : oldSamlConfiguration.domain) !== (updateSamlConfiguration === null || updateSamlConfiguration === void 0 ? void 0 : updateSamlConfiguration.domain)) {
            updateSamlConfiguration.ssoEndpoint = '';
            updateSamlConfiguration.publicCertificate = '';
            updateSamlConfiguration.signRequest = false;
        }
        updateSamlConfiguration.type = samlVendor === null || samlVendor === void 0 ? void 0 : samlVendor.toLowerCase();
        const newSamlConfiguration = yield call(umd.api.auth.updateSamlConfiguration, updateSamlConfiguration);
        newSamlConfiguration.isSamlActive = oldSamlConfiguration === null || oldSamlConfiguration === void 0 ? void 0 : oldSamlConfiguration.isSamlActive;
        yield put(auth_actions.setSSOState({ samlConfiguration: newSamlConfiguration, error: undefined, [loaderKey]: false }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setSSOState({ samlConfiguration: oldSamlConfiguration, error: e.message, [loaderKey]: false }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
}
function* validateSSODomain({ payload: { callback } = {} }) {
    const samlConfiguration = yield io_c3792963_select((state) => state.auth.ssoState.samlConfiguration);
    try {
        yield put(auth_actions.setSSOState({ error: undefined, saving: true }));
        yield call(umd.api.auth.validateSamlDomain);
        yield put(auth_actions.setSSOState({
            samlConfiguration: Object.assign(Object.assign({}, samlConfiguration), { validated: true }),
            error: undefined,
            saving: false,
        }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setSSOState({
            samlConfiguration: Object.assign(Object.assign({}, samlConfiguration), { validated: false }),
            error: e.message,
            saving: false,
        }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
}
function* getAuthorizationRoles() {
    try {
        const data = yield call(umd.api.auth.getSamlRoles);
        const groupsData = yield call(umd.api.auth.getSamlRolesGroups);
        yield put(auth_actions.setSSOState({
            authorizationRoles: data.roleIds,
            rolesGroups: groupsData,
            error: undefined,
        }));
    }
    catch (e) {
        yield put(auth_actions.setSSOState({
            error: e.message,
        }));
    }
}
function* updateRolesGroups(groups) {
    try {
        yield io_c3792963_all(groups.map((group) => call(umd.api.auth.updateSamlGroup, { id: group.id, roleIds: group.roleIds, group: group.group })));
    }
    catch (e) {
        yield put(auth_actions.setSSOState({
            error: e.message,
        }));
    }
}
function* updateAuthorizationRoles({ payload: { callback, authorizationRoles, groups }, }) {
    try {
        yield put(auth_actions.setSSOState({ error: undefined, saving: true }));
        yield call(umd.api.auth.updateSamlRoles, { roleIds: authorizationRoles });
        if (groups) {
            yield updateRolesGroups(groups);
        }
        yield getAuthorizationRoles();
        yield put(auth_actions.setSSOState({ error: undefined, saving: false }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setSSOState({
            error: e.message,
            saving: false,
        }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
}
function* deleteSamlGroupFunction({ payload: { callback, id } }) {
    try {
        yield put(auth_actions.setSSOState({ error: undefined, saving: true }));
        yield call(umd.api.auth.deleteSamlGroup, { id });
        yield getAuthorizationRoles();
        yield put(auth_actions.setSSOState({ error: undefined, saving: false }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setSSOState({
            error: e.message,
            saving: false,
        }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
}
function* createSamlGroupFunction({ payload: { group, roleIds, callback } }) {
    try {
        yield put(auth_actions.setSSOState({ error: undefined, saving: true }));
        yield call(umd.api.auth.createSamlGroup, { group, roleIds });
        yield getAuthorizationRoles();
        yield put(auth_actions.setSSOState({ error: undefined, saving: false }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setSSOState({
            error: e.message,
            saving: false,
        }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
}
function* oidcPostloginFunction({ payload }) {
    var _a;
    const data = { code: payload.code, redirectUri: payload.redirectUri, RelayState: payload.state };
    try {
        yield put(auth_actions.setSSOState({ loading: true }));
        yield call(umd.api.auth.oidcPostLoginV2, data);
        yield refreshToken();
        yield put(auth_actions.setSSOState({ loading: false }));
    }
    catch (e) {
        yield put(auth_actions.setSSOState({ loading: false, error: (_a = e.message) !== null && _a !== void 0 ? _a : 'Failed to authenticate', firstLoad: false }));
    }
}
function* ssoSagas$1() {
    yield takeEvery$1(auth_actions.loadSSOConfigurations, loadSSOConfigurations);
    yield takeEvery$1(auth_actions.saveSSOConfigurations, saveSSOConfigurations);
    yield takeEvery$1(auth_actions.saveSSOConfigurationsFile, saveSSOConfigurationsFile);
    yield takeEvery$1(auth_actions.saveSSOConfigurationsFileWithCallback, saveSSOConfigurationsFileWithCallback);
    yield takeEvery$1(auth_actions.validateSSODomain, validateSSODomain);
    yield takeEvery$1(auth_actions.loadSSOAuthorizationRoles, getAuthorizationRoles);
    yield takeEvery$1(auth_actions.updateSSOAuthorizationRoles, updateAuthorizationRoles);
    yield takeEvery$1(auth_actions.deleteSamlGroup, deleteSamlGroupFunction);
    yield takeEvery$1(auth_actions.createSamlGroup, createSamlGroupFunction);
    yield takeEvery$1(auth_actions.oidcPostlogin, oidcPostloginFunction);
}
/*********************************
 *  Preview Sagas
 *********************************/
function* loadSSOConfigurationsMock() {
    yield put(auth_actions.setSSOState({ loading: true }));
    yield auth_delay();
    yield put(auth_actions.setSSOState({ samlConfiguration: samlConfigurationDemo, loading: false, firstLoad: false }));
}
function* saveSSOConfigurationsFileMock({ payload: configFile }) {
    const loaderKey = 'saving';
    yield put(auth_actions.setSSOState({ error: undefined, [loaderKey]: true }));
    const oldSamlConfiguration = yield io_c3792963_select((state) => state.auth.ssoState.samlConfiguration);
    const newSamlConfiguration = Object.assign(Object.assign(Object.assign({}, oldSamlConfiguration), { enabled: true }), configFile[0]);
    yield put(auth_actions.setSSOState({ samlConfiguration: newSamlConfiguration, error: undefined, [loaderKey]: false }));
}
function* saveSSOConfigurationsMock({ payload }) {
    var _a, _b;
    const { callback, samlVendor } = payload, newSamlConfiguration = (0,tslib_es6.__rest)(payload, ["callback", "samlVendor"]);
    const oldSamlConfiguration = ssoStateDemo.samlConfiguration;
    const samlConfiguration = Object.assign(Object.assign({}, oldSamlConfiguration), newSamlConfiguration);
    let loaderKey = 'saving';
    if ((samlConfiguration === null || samlConfiguration === void 0 ? void 0 : samlConfiguration.enabled) !== oldSamlConfiguration.enabled) {
        loaderKey = 'loading';
    }
    const firstTimeConfigure = !(samlConfiguration === null || samlConfiguration === void 0 ? void 0 : samlConfiguration.domain);
    if (firstTimeConfigure) {
        yield put(auth_actions.setSSOState({ samlConfiguration: Object.assign(Object.assign({}, oldSamlConfiguration), samlConfiguration) }));
        return;
    }
    else {
        yield put(auth_actions.setSSOState({ error: undefined, [loaderKey]: true }));
    }
    yield auth_delay();
    samlConfiguration.acsUrl = (_a = samlMetadataDemo === null || samlMetadataDemo === void 0 ? void 0 : samlMetadataDemo.configuration) === null || _a === void 0 ? void 0 : _a.acsUrl;
    samlConfiguration.spEntityId = (_b = samlMetadataDemo === null || samlMetadataDemo === void 0 ? void 0 : samlMetadataDemo.configuration) === null || _b === void 0 ? void 0 : _b.spEntityId;
    const updateSamlConfiguration = omitProps(samlConfiguration, [
        'validated',
        'generatedVerification',
        'createdAt',
        'updatedAt',
    ]);
    if ((oldSamlConfiguration === null || oldSamlConfiguration === void 0 ? void 0 : oldSamlConfiguration.domain) !== (updateSamlConfiguration === null || updateSamlConfiguration === void 0 ? void 0 : updateSamlConfiguration.domain)) {
        updateSamlConfiguration.ssoEndpoint = '';
        updateSamlConfiguration.publicCertificate = '';
        updateSamlConfiguration.signRequest = false;
    }
    updateSamlConfiguration.type = samlVendor === null || samlVendor === void 0 ? void 0 : samlVendor.toLowerCase();
    yield auth_delay();
    yield put(auth_actions.setSSOState({ samlConfiguration: updateSamlConfiguration, error: undefined, [loaderKey]: false }));
    callback === null || callback === void 0 ? void 0 : callback(true);
}
function* validateSSODomainMock({ payload: { callback } = {} }) {
    const samlConfiguration = ssoStateDemo.samlConfiguration;
    yield put(auth_actions.setSSOState({ error: undefined, saving: true }));
    yield auth_delay();
    yield put(auth_actions.setSSOState({
        samlConfiguration: Object.assign(Object.assign({}, samlConfiguration), { validated: true }),
        error: undefined,
        saving: false,
    }));
    callback === null || callback === void 0 ? void 0 : callback(true);
}
function* getAuthorizationRolesMock() {
    yield auth_delay();
    const data = { roleIds: ['1', '2', '3'] };
    yield put(auth_actions.setSSOState({
        authorizationRoles: data.roleIds,
        error: undefined,
    }));
}
function* updateAuthorizationRolesMock({ payload: { callback, authorizationRoles }, }) {
    yield put(auth_actions.setSSOState({ error: undefined, saving: true }));
    yield auth_delay();
    yield put(auth_actions.setSSOState({ authorizationRoles, error: undefined, saving: false }));
    callback === null || callback === void 0 ? void 0 : callback(true);
}
function* ssoSagasMock() {
    yield takeEvery$1(auth_actions.loadSSOConfigurations, loadSSOConfigurationsMock);
    yield takeEvery$1(auth_actions.saveSSOConfigurations, saveSSOConfigurationsMock);
    yield takeEvery$1(auth_actions.saveSSOConfigurationsFile, saveSSOConfigurationsFileMock);
    yield takeEvery$1(auth_actions.validateSSODomain, validateSSODomainMock);
    yield takeEvery$1(auth_actions.loadSSOAuthorizationRoles, getAuthorizationRolesMock);
    yield takeEvery$1(auth_actions.updateSSOAuthorizationRoles, updateAuthorizationRolesMock);
}

function* loadOidc() {
    try {
        const oidcConfiguration = yield call(umd.api.auth.getOidcConfiguration);
        return oidcConfiguration;
    }
    catch (e) {
        return null;
    }
}
function* loadSaml() {
    try {
        const samlMetadata = yield call(umd.api.metadata.getSamlMetadata);
        return samlMetadata;
    }
    catch (e) {
        return null;
    }
}
function* loadSSOConfigurationsV2() {
    try {
        yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.LOAD_SSO_CONFIGURATIONS, value: true }));
        const [oidcConfiguration, samlMetadata] = yield io_c3792963_all([call(loadOidc), call(loadSaml)]);
        const ssoConfigurations = yield call(umd.api.auth.getSSOConfigurations);
        yield put(auth_actions.setSSOState({
            ssoConfigurations,
            oidcConfiguration,
            samlMetadata
        }));
    }
    catch (error) {
        yield put(auth_actions.setSSOError({ key: SSOStateKeys.LOAD_SSO_CONFIGURATIONS, value: error.message }));
    }
    finally {
        yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.LOAD_SSO_CONFIGURATIONS, value: false }));
    }
}
function* saveSSOConfigurationV2({ payload }) {
    var _a;
    yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.SAVE_SSO_CONFIGURATION, value: true }));
    const { callback } = payload, ssoConfiguration = (0,tslib_es6.__rest)(payload, ["callback"]);
    const ssoConfigurations = yield io_c3792963_select((state) => state.auth.ssoState.ssoConfigurations);
    try {
        const newSsoConfiguration = yield call(umd.api.auth.createSSOConfiguration, Object.assign(Object.assign({}, ssoConfiguration), { enabled: (_a = ssoConfiguration.enabled) !== null && _a !== void 0 ? _a : false }));
        yield put(auth_actions.setSSOState({ ssoConfigurations: [...ssoConfigurations, newSsoConfiguration] }));
        callback === null || callback === void 0 ? void 0 : callback(newSsoConfiguration);
    }
    catch (error) {
        yield put(auth_actions.setSSOError({ key: SSOStateKeys.SAVE_SSO_CONFIGURATION, value: error.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, error);
    }
    finally {
        yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.SAVE_SSO_CONFIGURATION, value: false }));
    }
}
function* saveSSOConfigurationByMetadata({ payload }) {
    yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.SAVE_SSO_CONFIGURATION_BY_METADATA, value: true }));
    const { configFile, callback } = payload;
    const ssoConfigurations = yield io_c3792963_select((state) => state.auth.ssoState.ssoConfigurations);
    try {
        const metadata = yield readFileAsText(configFile);
        const newSsoConfiguration = yield call(umd.api.auth.createSSOConfigurationByMetadata, { metadata });
        yield put(auth_actions.setSSOState({ ssoConfigurations: [...ssoConfigurations, newSsoConfiguration] }));
        callback === null || callback === void 0 ? void 0 : callback(newSsoConfiguration);
    }
    catch (error) {
        yield put(auth_actions.setSSOError({ key: SSOStateKeys.SAVE_SSO_CONFIGURATION_BY_METADATA, value: error.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, error);
    }
    finally {
        yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.SAVE_SSO_CONFIGURATION_BY_METADATA, value: false }));
    }
}
function* updateSSOConfiguration({ payload }) {
    yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.UPDATE_SSO_CONFIGURATION, value: true }));
    const { callback, ssoConfigId } = payload, ssoConfiguration = (0,tslib_es6.__rest)(payload, ["callback", "ssoConfigId"]);
    const ssoConfigurations = yield io_c3792963_select((state) => state.auth.ssoState.ssoConfigurations);
    try {
        const newSsoConfiguration = yield call(umd.api.auth.updateSSOConfiguration, ssoConfigId, ssoConfiguration);
        const newSsoConfigurations = ssoConfigurations.map((ssoConfig) => ssoConfig.id === ssoConfigId ? newSsoConfiguration : ssoConfig);
        yield put(auth_actions.setSSOState({ ssoConfigurations: newSsoConfigurations }));
        callback === null || callback === void 0 ? void 0 : callback(newSsoConfiguration);
    }
    catch (error) {
        yield put(auth_actions.setSSOError({ key: SSOStateKeys.UPDATE_SSO_CONFIGURATION, value: error.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, error);
    }
    finally {
        yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.UPDATE_SSO_CONFIGURATION, value: false }));
    }
}
function* updateSSOConfigurationByMetadata({ payload }) {
    yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.UPDATE_SSO_CONFIGURATION_BY_METADATA, value: true }));
    const { callback, ssoConfigId, configFile } = payload;
    const ssoConfigurations = yield io_c3792963_select((state) => state.auth.ssoState.ssoConfigurations);
    try {
        const metadata = yield readFileAsText(configFile);
        const newSsoConfiguration = yield call(umd.api.auth.updateSSOConfigurationByMetadata, ssoConfigId, { metadata });
        const newSsoConfigurations = ssoConfigurations.map((ssoConfig) => ssoConfig.id === ssoConfigId ? newSsoConfiguration : ssoConfig);
        yield put(auth_actions.setSSOState({ ssoConfigurations: newSsoConfigurations }));
        callback === null || callback === void 0 ? void 0 : callback(newSsoConfiguration);
    }
    catch (error) {
        yield put(auth_actions.setSSOError({ key: SSOStateKeys.UPDATE_SSO_CONFIGURATION, value: error.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, error);
    }
    finally {
        yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.UPDATE_SSO_CONFIGURATION, value: false }));
    }
}
function* deleteSSOConfiguration({ payload }) {
    yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.DELETE_SSO_CONFIGURATION, value: true }));
    const { ssoConfigId, callback } = payload;
    const ssoConfigurations = yield io_c3792963_select((state) => state.auth.ssoState.ssoConfigurations);
    try {
        yield call(umd.api.auth.deleteSSOConfiguration, ssoConfigId);
        yield put(auth_actions.setSSOState({ ssoConfigurations: ssoConfigurations.filter(({ id }) => id !== ssoConfigId) }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (error) {
        yield put(auth_actions.setSSOError({ key: SSOStateKeys.DELETE_SSO_CONFIGURATION, value: error.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, error);
    }
    finally {
        yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.DELETE_SSO_CONFIGURATION, value: false }));
    }
}
function* saveSSODomain({ payload }) {
    const { callback, ssoConfigId } = payload, body = (0,tslib_es6.__rest)(payload, ["callback", "ssoConfigId"]);
    yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.SAVE_SSO_DOMAIN, value: true }));
    const ssoConfigurations = yield io_c3792963_select((state) => state.auth.ssoState.ssoConfigurations);
    try {
        const domain = yield call(umd.api.auth.createSSODomain, ssoConfigId, body);
        const newSsoConfigurations = ssoConfigurations.map((ssoConfig) => {
            if (ssoConfig.id === ssoConfigId) {
                return Object.assign(Object.assign({}, ssoConfig), { domains: [...ssoConfig.domains, domain] });
            }
            return ssoConfig;
        });
        yield put(auth_actions.setSSOState({ ssoConfigurations: newSsoConfigurations }));
        callback === null || callback === void 0 ? void 0 : callback(domain);
    }
    catch (error) {
        yield put(auth_actions.setSSOError({ key: SSOStateKeys.SAVE_SSO_DOMAIN, value: error.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, error);
    }
    finally {
        yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.SAVE_SSO_DOMAIN, value: false }));
    }
}
function* deleteSSODomain({ payload }) {
    const { ssoConfigId, domainId, callback } = payload;
    yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.DELETE_SSO_DOMAIN, value: true }));
    const ssoConfigurations = yield io_c3792963_select((state) => state.auth.ssoState.ssoConfigurations);
    try {
        yield call(umd.api.auth.deleteSSODomain, ssoConfigId, domainId);
        const newSsoConfigurations = ssoConfigurations.map((ssoConfig) => {
            if (ssoConfig.id === ssoConfigId) {
                return Object.assign(Object.assign({}, ssoConfig), { domains: ssoConfig.domains.filter(({ id }) => id !== domainId) });
            }
            return ssoConfig;
        });
        yield put(auth_actions.setSSOState({ ssoConfigurations: newSsoConfigurations }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (error) {
        yield put(auth_actions.setSSOError({ key: SSOStateKeys.DELETE_SSO_DOMAIN, value: error.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, error);
    }
    finally {
        yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.DELETE_SSO_DOMAIN, value: false }));
    }
}
function* validateSSODomainV2({ payload }) {
    const { callback, domainId, ssoConfigId } = payload;
    yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.VALIDATE_SSO_DOMAIN, value: true }));
    const ssoConfigurations = yield io_c3792963_select((state) => state.auth.ssoState.ssoConfigurations);
    try {
        yield call(umd.api.auth.validateSSODomain, ssoConfigId, domainId);
        const newSsoConfigurations = ssoConfigurations.map((ssoConfig) => {
            if (ssoConfig.id === ssoConfigId) {
                return Object.assign(Object.assign({}, ssoConfig), { domains: ssoConfig.domains.map((ssoDomain) => ssoDomain.id === domainId ? Object.assign(Object.assign({}, ssoDomain), { validated: true }) : ssoDomain) });
            }
            return ssoConfig;
        });
        yield put(auth_actions.setSSOState({ ssoConfigurations: newSsoConfigurations }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (error) {
        yield put(auth_actions.setSSOError({ key: SSOStateKeys.VALIDATE_SSO_DOMAIN, value: error.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, error);
    }
    finally {
        yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.VALIDATE_SSO_DOMAIN, value: false }));
    }
}
function* setSSODefaultRoles({ payload: { callback, ssoConfigId, roleIds }, }) {
    yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.UPDATE_SSO_DEFAULT_ROLES, value: true }));
    const ssoConfigurations = yield io_c3792963_select((state) => state.auth.ssoState.ssoConfigurations);
    try {
        yield call(umd.api.auth.setSSODefaultRoles, ssoConfigId, { roleIds });
        const newSsoConfigurations = ssoConfigurations.map((ssoConfig) => {
            if (ssoConfig.id === ssoConfigId) {
                return Object.assign(Object.assign({}, ssoConfig), { roleIds });
            }
            return ssoConfig;
        });
        yield put(auth_actions.setSSOState({ ssoConfigurations: newSsoConfigurations }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (error) {
        yield put(auth_actions.setSSOError({ key: SSOStateKeys.UPDATE_SSO_DEFAULT_ROLES, value: error.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, error);
    }
    finally {
        yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.UPDATE_SSO_DEFAULT_ROLES, value: false }));
    }
}
function* setSSOGroups({ payload: { groupsToAdd, groupsToDelete, ssoConfigId, callback } }) {
    yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.SAVE_SSO_GROUPS, value: true }));
    const ssoConfigurations = yield io_c3792963_select((state) => state.auth.ssoState.ssoConfigurations);
    try {
        yield io_c3792963_all(groupsToDelete.map((groupId) => call(umd.api.auth.deleteSSOGroup, ssoConfigId, groupId)));
        yield io_c3792963_all(groupsToAdd.map((group) => call(umd.api.auth.createSSOGroup, ssoConfigId, group)));
        const groups = yield call(umd.api.auth.getSSOGroups, ssoConfigId);
        const newSsoConfigurations = ssoConfigurations.map((ssoConfig) => {
            if (ssoConfig.id === ssoConfigId) {
                return Object.assign(Object.assign({}, ssoConfig), { groups });
            }
            return ssoConfig;
        });
        yield put(auth_actions.setSSOState({ ssoConfigurations: newSsoConfigurations }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (error) {
        yield put(auth_actions.setSSOError({ key: SSOStateKeys.SAVE_SSO_GROUPS, value: error.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, error);
    }
    finally {
        yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.SAVE_SSO_GROUPS, value: false }));
    }
}
function* updateSSOGroups({ payload: { ssoConfigId, changedGroups, callback } }) {
    try {
        yield io_c3792963_all(changedGroups.map((group) => call(umd.api.auth.updateSSOGroup, ssoConfigId, group)));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (error) {
        yield put(auth_actions.setSSOError({ key: SSOStateKeys.SAVE_SSO_GROUPS, value: error.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, error);
    }
    finally {
        yield put(auth_actions.setSSOLoader({ key: SSOStateKeys.SAVE_SSO_GROUPS, value: false }));
    }
}
function* ssoSagas() {
    yield takeEvery$1(auth_actions.loadSSOConfigurationsV2, loadSSOConfigurationsV2);
    yield takeEvery$1(auth_actions.saveSSOConfigurationV2, saveSSOConfigurationV2);
    yield takeEvery$1(auth_actions.saveSSODomain, saveSSODomain);
    yield takeEvery$1(auth_actions.deleteSSODomain, deleteSSODomain);
    yield takeEvery$1(auth_actions.validateSSODomainV2, validateSSODomainV2);
    yield takeEvery$1(auth_actions.updateSSOConfiguration, updateSSOConfiguration);
    yield takeEvery$1(auth_actions.deleteSSOConfiguration, deleteSSOConfiguration);
    yield takeEvery$1(auth_actions.setSSOGroups, setSSOGroups);
    yield takeEvery$1(auth_actions.updateSSOGroups, updateSSOGroups);
    yield takeEvery$1(auth_actions.setSSODefaultRoles, setSSODefaultRoles);
    yield takeEvery$1(auth_actions.saveSSOConfigurationByMetadata, saveSSOConfigurationByMetadata);
    yield takeEvery$1(auth_actions.updateSSOConfigurationByMetadata, updateSSOConfigurationByMetadata);
}

function* loadProfile() {
    yield put(auth_actions.setProfileState({ loading: true }));
    try {
        const profile = yield retry$1(3, 2000, umd.api.teams.getProfile);
        const currentUser = yield io_c3792963_select((state) => state.auth.user);
        auth_actions.setUser(Object.assign(Object.assign({}, currentUser), profile));
        yield put(auth_actions.setProfileState({ profile, loading: false }));
    }
    catch (e) {
        yield put(auth_actions.setProfileState({ loading: false, error: e.message }));
    }
}
function b64toBlob(base64, contentType) {
    const sliceSize = 512;
    const byteCharacters = atob(base64);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        const slice = byteCharacters.slice(offset, offset + sliceSize);
        const byteNumbers = new Array(slice.length);
        for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
        }
        byteArrays.push(new Uint8Array(byteNumbers));
    }
    return new Blob(byteArrays, { type: contentType });
}
function base64ToFormData(base64, key = 'file') {
    const matchResult = base64.match(/^data:image\/([A-Za-z-+\/]+);base64,(.+)$/);
    if (matchResult == null) {
        return null;
    }
    // Get the content type of the image
    const contentType = `image/${matchResult[1]}`;
    // get the real base64 content of the file
    const data = matchResult[2];
    // Convert it to a blob to upload
    const blob = b64toBlob(data, contentType);
    // Create a FormData and append the file with "image" as parameter name
    const formDataToUpload = new FormData();
    formDataToUpload.append(key, new File([blob], key, { type: contentType }));
    return formDataToUpload;
}
function* saveProfile(_a) {
    var _b = _a.payload, { callback, profilePictureUrl } = _b, payload = (0,tslib_es6.__rest)(_b, ["callback", "profilePictureUrl"]);
    yield put(auth_actions.setProfileState({ saving: true, error: null }));
    try {
        const oldProfileData = yield io_c3792963_select((state) => state.auth.profileState.profile);
        let newProfilePictureUrl = oldProfileData.profilePictureUrl;
        if (profilePictureUrl !== oldProfileData.profilePictureUrl && profilePictureUrl) {
            const matchResult = (profilePictureUrl || '').match(/^data:image\/([A-Za-z-+\/]+);base64,(.+)$/);
            if (matchResult) {
                const profileImage = base64ToFormData(profilePictureUrl, 'image');
                if (profileImage) {
                    newProfilePictureUrl = yield call(umd.api.teams.updateProfileImage, profileImage);
                    const imageTimeStamp = Date.now().toString();
                    const urlTemplate = new URL(newProfilePictureUrl);
                    urlTemplate.searchParams.set('t', imageTimeStamp);
                    newProfilePictureUrl = urlTemplate.href;
                }
            }
        }
        const newProfileData = Object.assign(Object.assign(Object.assign({}, oldProfileData), payload), { profilePictureUrl: newProfilePictureUrl });
        const profile = yield call(umd.api.teams.updateProfile, newProfileData);
        const currentUser = yield io_c3792963_select((state) => state.auth.user);
        yield put(auth_actions.setUser(Object.assign(Object.assign({}, currentUser), profile)));
        yield put(auth_actions.setProfileState({ profile, saving: false }));
        callback === null || callback === void 0 ? void 0 : callback(newProfileData);
    }
    catch (e) {
        yield put(auth_actions.setProfileState({ saving: false, error: e.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
}
function* changePassword({ payload }) {
    var _a, _b;
    yield put(auth_actions.setProfileState({ loading: true }));
    try {
        yield call(umd.api.teams.changePassword, payload);
        yield put(auth_actions.setProfileState({ loading: false, error: undefined }));
        (_a = payload.callback) === null || _a === void 0 ? void 0 : _a.call(payload, true);
    }
    catch (e) {
        yield put(auth_actions.setProfileState({ loading: false, error: e.message }));
        (_b = payload.callback) === null || _b === void 0 ? void 0 : _b.call(payload, null, e);
    }
}
function* profileSagas() {
    yield takeLeading$1(auth_actions.loadProfile, loadProfile);
    yield takeEvery$1(auth_actions.saveProfile, saveProfile);
    yield takeEvery$1(auth_actions.changePassword, changePassword);
}
/*********************************
 *  Preview Sagas
 *********************************/
function* loadProfileMock() {
    yield put(auth_actions.setProfileState({ loading: true }));
    yield auth_delay();
    yield put(auth_actions.setUser(Object.assign(Object.assign({}, (userDemo)), userProfileDemo)));
    yield put(auth_actions.setProfileState({ loading: false, profile: userProfileDemo }));
}
function* saveProfileMock(_a) {
    var _b = _a.payload, { callback, profilePictureUrl } = _b, payload = (0,tslib_es6.__rest)(_b, ["callback", "profilePictureUrl"]);
    yield put(auth_actions.setProfileState({ saving: true, error: null }));
    const oldProfileData = profileStateDemo;
    let newProfilePictureUrl = oldProfileData.profile.profilePictureUrl;
    if (profilePictureUrl !== oldProfileData.profile.profilePictureUrl && profilePictureUrl) {
        const matchResult = (profilePictureUrl || '').match(/^data:image\/([A-Za-z-+\/]+);base64,(.+)$/);
        if (matchResult) {
            newProfilePictureUrl = profilePictureUrl;
        }
    }
    const newProfileData = Object.assign(Object.assign(Object.assign({}, oldProfileData.profile), payload), { profilePictureUrl: newProfilePictureUrl });
    const currentUser = userDemo;
    yield auth_delay();
    yield put(auth_actions.setUser(Object.assign(Object.assign({}, currentUser), newProfileData)));
    yield put(auth_actions.setProfileState({ loading: false, error: null, saving: false, profile: newProfileData }));
    callback === null || callback === void 0 ? void 0 : callback(newProfileData);
}
function* changePasswordMock({ payload }) {
    var _a;
    yield put(auth_actions.setProfileState({ loading: true }));
    yield auth_delay();
    yield put(auth_actions.setProfileState({ loading: false, error: undefined }));
    (_a = payload.callback) === null || _a === void 0 ? void 0 : _a.call(payload, true);
}
function* profileSagasMock() {
    yield takeLeading$1(auth_actions.loadProfile, loadProfileMock);
    yield takeEvery$1(auth_actions.saveProfile, saveProfileMock);
    yield takeEvery$1(auth_actions.changePassword, changePasswordMock);
}

function* enrollMfa() {
    yield put(auth_actions.setMfaState({ loading: true }));
    try {
        const { qrCode } = yield call(umd.api.auth.enrollMfa);
        yield put(auth_actions.setMfaState({ loading: false, error: undefined, qrCode }));
    }
    catch (e) {
        yield put(auth_actions.setMfaState({ loading: false, error: e.message }));
    }
}
function* verifyMfa(_a) {
    var _b = _a.payload, { callback } = _b, payload = (0,tslib_es6.__rest)(_b, ["callback"]);
    yield put(auth_actions.setMfaState({ loading: true }));
    try {
        const user = yield io_c3792963_select((state) => state.auth.user);
        const data = yield call(umd.api.auth.verifyMfa, payload);
        const mfaState = {
            step: MFAStep.recoveryCode,
            loading: false,
            error: undefined,
        };
        if (data === null || data === void 0 ? void 0 : data.recoveryCode) {
            mfaState.recoveryCode = data.recoveryCode;
        }
        yield put(auth_actions.setMfaState(mfaState));
        yield put(auth_actions.setUser(Object.assign(Object.assign({}, user), { mfaEnrolled: true })));
        callback === null || callback === void 0 ? void 0 : callback(mfaState.recoveryCode);
    }
    catch (e) {
        yield put(auth_actions.setMfaState({ loading: false, error: e.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
}
function* verifyMfaAfterForce(_a) {
    var _b = _a.payload, { callback } = _b, payload = (0,tslib_es6.__rest)(_b, ["callback"]);
    yield put(auth_actions.setMfaState({ loading: true }));
    try {
        const user = yield call(umd.api.auth.loginWithMfa, payload);
        const mfaState = {
            step: MFAStep.recoveryCode,
            loading: false,
            error: undefined,
        };
        if (user === null || user === void 0 ? void 0 : user.recoveryCode) {
            mfaState.recoveryCode = user.recoveryCode;
        }
        yield put(auth_actions.setMfaState(mfaState));
        yield put(auth_actions.setState({ user }));
        yield put(auth_actions.loadTenants());
        callback === null || callback === void 0 ? void 0 : callback(mfaState.recoveryCode);
    }
    catch (e) {
        yield put(auth_actions.setMfaState({ loading: false, error: e.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
}
function* disableMfa({ payload }) {
    var _a, _b;
    yield put(auth_actions.setMfaState({ loading: true }));
    try {
        const user = yield io_c3792963_select((state) => state.auth.user);
        yield umd.api.auth.disableMfa(payload);
        yield put(auth_actions.setMfaState({ loading: false, error: undefined }));
        yield put(auth_actions.setUser(Object.assign(Object.assign({}, user), { mfaEnrolled: false })));
        (_a = payload.callback) === null || _a === void 0 ? void 0 : _a.call(payload, true);
    }
    catch (e) {
        yield put(auth_actions.setMfaState({ loading: false, error: e.message }));
        (_b = payload.callback) === null || _b === void 0 ? void 0 : _b.call(payload, false, e);
    }
}
function* mfaSagas() {
    yield takeEvery$1(auth_actions.enrollMfa, enrollMfa);
    yield takeEvery$1(auth_actions.verifyMfa, verifyMfa);
    yield takeEvery$1(auth_actions.disableMfa, disableMfa);
    yield takeEvery$1(auth_actions.verifyMfaAfterForce, verifyMfaAfterForce);
}
/*********************************
 *  Preview Sagas
 *********************************/
function* enrollMfaMock() {
    yield put(auth_actions.setMfaState({ loading: true }));
    const qrCode = 'test';
    yield put(auth_actions.setMfaState({ loading: false, error: undefined, qrCode }));
}
function* verifyMfaMock({ payload: { callback }, }) {
    yield put(auth_actions.setMfaState({ loading: true }));
    yield auth_delay();
    const data = { token: 'token', recoveryCode: 'recoveryCode' };
    const mfaState = {
        step: MFAStep.recoveryCode,
        loading: false,
        error: undefined,
    };
    if (data === null || data === void 0 ? void 0 : data.recoveryCode) {
        mfaState.recoveryCode = data.recoveryCode;
    }
    yield put(auth_actions.setMfaState(mfaState));
    yield put(auth_actions.setUser(Object.assign(Object.assign({}, userDemo), { mfaEnrolled: true })));
    callback === null || callback === void 0 ? void 0 : callback(mfaState.recoveryCode);
}
function* verifyMfaAfterForceMock(_a) {
    var _b = _a.payload, { callback } = _b, payload = (0,tslib_es6.__rest)(_b, ["callback"]);
    yield put(auth_actions.setMfaState({ loading: true }));
    yield auth_delay();
    const data = Object.assign(Object.assign({}, payload), { recoveryCode: 'recoveryCode' });
    const mfaState = {
        step: MFAStep.recoveryCode,
        loading: false,
        error: undefined,
    };
    if (data === null || data === void 0 ? void 0 : data.recoveryCode) {
        mfaState.recoveryCode = data.recoveryCode;
    }
    yield put(auth_actions.setMfaState(mfaState));
    yield auth_delay();
    yield put(auth_actions.setUser(Object.assign(Object.assign({}, userDemo), { mfaEnrolled: true })));
    callback === null || callback === void 0 ? void 0 : callback(mfaState.recoveryCode);
}
function* disableMfaMock({ payload }) {
    var _a;
    yield put(auth_actions.setMfaState({ loading: true }));
    yield auth_delay();
    yield put(auth_actions.setMfaState({ loading: false, error: undefined }));
    yield put(auth_actions.setUser(Object.assign(Object.assign({}, userDemo), { mfaEnrolled: false })));
    (_a = payload.callback) === null || _a === void 0 ? void 0 : _a.call(payload, true);
}
function* mfaSagasMock() {
    yield takeEvery$1(auth_actions.enrollMfa, enrollMfaMock);
    yield takeEvery$1(auth_actions.verifyMfa, verifyMfaMock);
    yield takeEvery$1(auth_actions.disableMfa, disableMfaMock);
    yield takeEvery$1(auth_actions.verifyMfaAfterForce, verifyMfaAfterForceMock);
}

function* forgotPassword({ payload }) {
    yield put(auth_actions.setForgotPasswordState({ loading: true }));
    try {
        yield call(umd.api.auth.forgotPassword, payload);
        yield put(auth_actions.setForgotPasswordState({ loading: false, error: undefined, step: ForgotPasswordStep.success }));
    }
    catch (e) {
        yield put(auth_actions.setForgotPasswordState({ loading: false, error: e.message || 'Unknown error occurred' }));
    }
}
function* resetPassword(_a) {
    var _b = _a.payload, { callback } = _b, body = (0,tslib_es6.__rest)(_b, ["callback"]);
    yield put(auth_actions.setForgotPasswordState({ loading: true }));
    try {
        yield call(umd.api.auth.resetPassword, body);
        yield put(auth_actions.setForgotPasswordState({ loading: false, error: undefined, step: ForgotPasswordStep.success }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setForgotPasswordState({ loading: false, error: e.message }));
        callback === null || callback === void 0 ? void 0 : callback(false);
    }
}
function* loadPasswordConfig({ payload }) {
    yield put(auth_actions.setForgotPasswordState({ loading: true }));
    try {
        const passwordConfig = yield call(umd.api.auth.loadPasswordConfig, payload);
        yield put(auth_actions.setForgotPasswordState({ loading: false, passwordConfig }));
    }
    catch (e) {
        yield put(auth_actions.setForgotPasswordState({ loading: false, error: e.message }));
    }
}
function* forgotPasswordSagas() {
    yield takeLeading$1(auth_actions.forgotPassword, forgotPassword);
    yield takeLeading$1(auth_actions.resetPassword, resetPassword);
    yield takeLeading$1(auth_actions.loadPasswordConfig, loadPasswordConfig);
}

function* preActivateAccount({ payload: { userId, token } }) {
    yield put(auth_actions.setActivateState({ loading: true, step: ActivateAccountStep.activating }));
    try {
        const { isAuthenticated } = yield io_c3792963_select((state) => state.auth);
        if (isAuthenticated) {
            yield put(auth_actions.silentLogout());
        }
        const strategy = yield call(umd.api.auth.getActivateAccountStrategy, { userId, token });
        yield put(auth_actions.setActivateStrategyState({ strategy, loading: false, error: undefined }));
        if (strategy.shouldSetPassword) {
            yield put(auth_actions.setActivateState({ loading: false, step: ActivateAccountStep.activatingForm }));
        }
    }
    catch (e) {
        yield put(auth_actions.setActivateState({ loading: false, error: e.message }));
    }
}
function* activateAccount(_a) {
    var _b;
    var _c = _a.payload, { callback, events } = _c, payload = (0,tslib_es6.__rest)(_c, ["callback", "events"]);
    yield put(auth_actions.setActivateState({ loading: true }));
    try {
        const onRedirectTo = umd.ContextHolder.onRedirectTo;
        const { routes } = yield io_c3792963_select((state) => state.auth);
        const data = yield call(umd.api.auth.activateAccount, payload);
        if (data.redirectLocation) {
            window.location.href = data.redirectLocation;
            return;
        }
        if (isMfaRequired(data)) {
            yield put(auth_actions.setActivateState({ step: ActivateAccountStep.success }));
            const mfaRequiredState = yield getMfaRequiredState(data);
            yield put(auth_actions.setState(mfaRequiredState));
            yield io_c3792963_delay(1000);
            onRedirectTo(routes.loginUrl, { preserveQueryParams: true });
        }
        else {
            yield put(auth_actions.setActivateState({ step: ActivateAccountStep.success }));
            const { user, tenants } = yield call(umd.api.auth.generateLoginResponseV2, data);
            (_b = events === null || events === void 0 ? void 0 : events.userVerified) === null || _b === void 0 ? void 0 : _b.call(events, { email: user.email, origin: UserVeirifedOriginTypes.ACTIVATION_LINK, id: user.id, tenantId: user.tenantId, name: user.name, createdAt: new Date() });
            yield put(auth_actions.setTenantsState({ tenants, loading: false }));
            yield put(auth_actions.setState({ user, isAuthenticated: true }));
            yield io_c3792963_delay(1000);
            yield afterAuthNavigation();
            yield put(auth_actions.resetActivateState());
        }
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setActivateState({ loading: false, error: e.message }));
    }
}
function* getActivateAccountStrategy({ payload, }) {
    const { callback } = payload, params = (0,tslib_es6.__rest)(payload, ["callback"]);
    yield put(auth_actions.setActivateStrategyState({ loading: true }));
    try {
        const strategy = yield call(umd.api.auth.getActivateAccountStrategy, params);
        yield put(auth_actions.setActivateStrategyState({ strategy, loading: false, error: undefined }));
        callback === null || callback === void 0 ? void 0 : callback(strategy);
    }
    catch (e) {
        yield put(auth_actions.setActivateStrategyState({ loading: false, error: e.message }));
    }
}
function* resendActivationEmailFunction({ payload }) {
    yield put(auth_actions.setActivateState({ loading: true }));
    try {
        yield call(umd.api.auth.resendActivationEmail, { email: payload.email });
        yield put(auth_actions.setActivateState({ loading: false, error: undefined, resentEmail: true }));
    }
    catch (e) {
        yield put(auth_actions.setActivateState({ loading: false, error: e.message }));
    }
}
function* activateSagas() {
    yield takeLeading$1(auth_actions.activateAccount, activateAccount);
    yield takeLeading$1(auth_actions.preActivateAccount, preActivateAccount);
    yield takeLeading$1(auth_actions.getActivateAccountStrategy, getActivateAccountStrategy);
    yield takeLeading$1(auth_actions.resendActivationEmail, resendActivationEmailFunction);
}

function* acceptInvitation({ payload }) {
    if (!payload.token || !payload.userId) {
        yield put(auth_actions.setAcceptInvitationState({ error: undefined, step: AcceptInvitationStep.invalid }));
        return;
    }
    try {
        yield put(auth_actions.setAcceptInvitationState({ error: undefined, step: AcceptInvitationStep.pending }));
        yield call(umd.api.auth.acceptInvitation, payload);
        yield put(auth_actions.setState({
            isAuthenticated: false,
            user: null,
            acceptInvitationState: { error: undefined, step: AcceptInvitationStep.success },
        }));
    }
    catch (e) {
        yield put(auth_actions.setAcceptInvitationState({ step: AcceptInvitationStep.failed, error: e.message }));
    }
}
function* acceptInvitationSagas() {
    yield takeLeading$1(auth_actions.acceptInvitation, acceptInvitation);
}

var TeamStateKeys;
(function (TeamStateKeys) {
    TeamStateKeys["USERS"] = "USERS";
    TeamStateKeys["STATS"] = "STATS";
    TeamStateKeys["UPDATE_USER"] = "UPDATE_USER";
    TeamStateKeys["DELETE_USER"] = "DELETE_USER";
    TeamStateKeys["RESEND_ACTIVATE_LINK"] = "RESEND_ACTIVATE_LINK";
    TeamStateKeys["RESEND_INVITATION_LINK"] = "RESEND_INVITATION_LINK";
    TeamStateKeys["ROLES_AND_PERMISSIONS"] = "ROLES_AND_PERMISSIONS";
    TeamStateKeys["CREATE_TOKEN_LINK"] = "CREATE_TOKEN_LINK";
    TeamStateKeys["GET_TOKEN_LINK"] = "GET_TOKEN_LINK";
    TeamStateKeys["UPDATE_TOKEN_LINK"] = "UPDATE_TOKEN_LINK";
    TeamStateKeys["DELETE_TOKEN_LINK"] = "DELETE_TOKEN_LINK";
    TeamStateKeys["CONFIG_TOKEN_LINK"] = "CONFIG_TOKEN_LINK";
})(TeamStateKeys || (TeamStateKeys = {}));

const selectTeamState = () => io_c3792963_select((_) => _[authStoreName].teamState);
function* loadUsers({ payload }) {
    var _a, _b, _c, _d;
    const { silentLoading, callback } = payload;
    const teamState = yield selectTeamState();
    const pageSize = (_a = payload.pageSize) !== null && _a !== void 0 ? _a : teamState.pageSize;
    const pageOffset = (_b = payload.pageOffset) !== null && _b !== void 0 ? _b : teamState.pageOffset;
    const filter = (_c = payload.filter) !== null && _c !== void 0 ? _c : teamState.filter;
    const sort = (_d = payload.sort) !== null && _d !== void 0 ? _d : teamState.sort;
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.USERS, value: !silentLoading }));
    yield put(auth_actions.setTeamState({
        pageSize,
        pageOffset,
        filter,
        sort,
    }));
    try {
        const [{ items: users, totalPages, totalItems }, { items: roles }, { items: permissions }] = yield io_c3792963_all([
            call(umd.api.teams.loadUsers, {
                pageSize,
                pageOffset,
                filter,
                sort,
            }),
            call(umd.api.teams.loadAvailableRoles),
            call(umd.api.teams.loadAvailablePermissions),
        ]);
        yield put(auth_actions.setTeamState({ users, totalPages, totalItems, roles, permissions }));
        callback === null || callback === void 0 ? void 0 : callback(users);
    }
    catch (e) {
        yield put(auth_actions.setTeamError({ key: TeamStateKeys.USERS, value: e.message }));
        yield put(auth_actions.setTeamState({ totalPages: 0, users: [] }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.USERS, value: false }));
}
function* loadAllSubTenantsUsers({ payload, }) {
    var _a, _b, _c, _d, _e;
    const { silentLoading, callback } = payload;
    const teamState = yield selectTeamState();
    const _limit = (_a = payload._limit) !== null && _a !== void 0 ? _a : teamState.allUsersQueryParams._limit;
    const _offset = (_b = payload._offset) !== null && _b !== void 0 ? _b : teamState.allUsersQueryParams._offset;
    const _filter = (_c = payload._filter) !== null && _c !== void 0 ? _c : teamState.allUsersQueryParams._filter;
    const _sortBy = (_d = payload._sortBy) !== null && _d !== void 0 ? _d : teamState.allUsersQueryParams._sortBy;
    const _order = (_e = payload._order) !== null && _e !== void 0 ? _e : teamState.allUsersQueryParams._order;
    const allUsersQueryParams = {
        _limit: _limit || 20,
        _offset: _offset || 0,
        _filter: _filter || '',
        _sortBy: _sortBy || 'name',
        _order: _order || 'DESC',
    };
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.USERS, value: !silentLoading }));
    yield put(auth_actions.setTeamState({
        allUsersQueryParams,
    }));
    try {
        const [{ items: users, _metadata: { totalPages, totalItems }, }, { items: roles }, { items: permissions },] = yield io_c3792963_all([
            call(umd.api.subTenants.loadAllUsers, Object.assign({}, allUsersQueryParams)),
            call(umd.api.teams.loadAvailableRoles),
            call(umd.api.teams.loadAvailablePermissions),
        ]);
        yield put(auth_actions.setTeamState({
            allUsers: users,
            totalPages,
            totalItems,
            roles,
            permissions,
        }));
        callback === null || callback === void 0 ? void 0 : callback(users);
    }
    catch (e) {
        yield put(auth_actions.setTeamError({ key: TeamStateKeys.USERS, value: e.message }));
        yield put(auth_actions.setTeamState({ totalPages: 0, users: [] }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.USERS, value: false }));
}
function* loadRoles({ payload }) {
    var _a, _b;
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.ROLES_AND_PERMISSIONS, value: true }));
    try {
        const [{ items: roles }, { items: permissions }] = yield io_c3792963_all([
            call(umd.api.teams.loadAvailableRoles),
            call(umd.api.teams.loadAvailablePermissions),
        ]);
        yield put(auth_actions.setTeamState({ roles, permissions }));
        (_a = payload === null || payload === void 0 ? void 0 : payload.callback) === null || _a === void 0 ? void 0 : _a.call(payload, { roles, permissions });
    }
    catch (e) {
        (_b = payload === null || payload === void 0 ? void 0 : payload.callback) === null || _b === void 0 ? void 0 : _b.call(payload, null, e);
        yield put(auth_actions.setTeamError({ key: TeamStateKeys.ROLES_AND_PERMISSIONS, value: e.message }));
    }
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.ROLES_AND_PERMISSIONS, value: true }));
}
function* addUser({ payload }) {
    const { callback } = payload, body = (0,tslib_es6.__rest)(payload, ["callback"]);
    const teamState = yield selectTeamState();
    yield put(auth_actions.setTeamState({ addUserDialogState: Object.assign(Object.assign({}, teamState.addUserDialogState), { loading: true }) }));
    try {
        const res = yield call(umd.api.teams.addUser, body);
        const { roles } = res, userWithoutRoleIds = (0,tslib_es6.__rest)(res, ["roles"]);
        const roleIds = roles.map((role) => role.id);
        const newUser = Object.assign(Object.assign({}, userWithoutRoleIds), { roleIds });
        callback === null || callback === void 0 ? void 0 : callback(newUser);
        yield put(auth_actions.setTeamState({
            users: [newUser, ...teamState.users],
            addUserDialogState: { open: false, loading: false },
        }));
    }
    catch (e) {
        yield put(auth_actions.setTeamState({
            addUserDialogState: Object.assign(Object.assign({}, teamState.addUserDialogState), { loading: false, error: e.message }),
        }));
        callback === null || callback === void 0 ? void 0 : callback(null, e.message);
    }
}
function* addUserToSubTenants({ payload }) {
    const { callback } = payload, body = (0,tslib_es6.__rest)(payload, ["callback"]);
    const teamState = yield selectTeamState();
    yield put(auth_actions.setTeamState({ addUserDialogState: Object.assign(Object.assign({}, teamState.addUserDialogState), { loading: true }) }));
    try {
        yield call(umd.api.subTenants.addUserToTenantAndSubTenants, body);
        const { items: users, _metadata: { totalPages, totalItems }, } = yield call(umd.api.subTenants.loadAllUsers, {
            _limit: 20,
            _offset: 0,
            _filter: '',
            _sortBy: 'name',
            _order: 'DESC',
        });
        yield put(auth_actions.setTeamState({
            allUsers: users,
            totalPages,
            totalItems,
            addUserDialogState: { open: false, loading: false },
        }));
        callback === null || callback === void 0 ? void 0 : callback(null);
    }
    catch (e) {
        yield put(auth_actions.setTeamState({
            addUserDialogState: Object.assign(Object.assign({}, teamState.addUserDialogState), { loading: false, error: e.message }),
        }));
        callback === null || callback === void 0 ? void 0 : callback(null, e.message);
    }
}
function* updateUser({ payload }) {
    var _a;
    const { callback, profileImage } = payload, body = (0,tslib_es6.__rest)(payload, ["callback", "profileImage"]);
    const { id: userId } = body;
    const teamState = yield selectTeamState();
    const oldUserData = teamState.users.find((user) => user.id === body.id);
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.UPDATE_USER, value: userId || '' }));
    yield put(auth_actions.setTeamState({ addUserDialogState: Object.assign(Object.assign({}, teamState.addUserDialogState), { loading: true }) }));
    yield put(auth_actions.setTeamState({
        addUserDialogState: Object.assign(Object.assign({}, teamState.addUserDialogState), { loading: true }),
        users: teamState.users.map((user) => {
            if (user.id === body.id) {
                return Object.assign(Object.assign({}, user), body);
            }
            return user;
        }),
    }));
    try {
        if (oldUserData.roleIds.length > 0 && ((_a = body.roleIds) === null || _a === void 0 ? void 0 : _a.length) === 0) {
            body.roleIds = [''];
        }
        const { item: newUser } = yield call(umd.api.teams.updateUser, body);
        callback === null || callback === void 0 ? void 0 : callback(newUser);
        yield put(auth_actions.setTeamState({
            users: teamState.users.map((user) => user.id === newUser.id
                ? Object.assign(Object.assign(Object.assign({}, user), newUser), { createdAt: user.createdAt, customData: user.customData, lastLogin: user.lastLogin }) : user),
        }));
        yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.UPDATE_USER, value: false }));
    }
    catch (e) {
        yield put(auth_actions.setTeamState({
            addUserDialogState: Object.assign(Object.assign({}, teamState.addUserDialogState), { loading: false, error: e.message }),
            users: teamState.users.map((user) => (user.id === body.id ? Object.assign(Object.assign({}, user), oldUserData) : user)),
        }));
        yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.UPDATE_USER, value: false }));
        callback === null || callback === void 0 ? void 0 : callback(null, e.message);
    }
}
function* deleteUser({ payload }) {
    const { callback } = payload, body = (0,tslib_es6.__rest)(payload, ["callback"]);
    const teamState = yield selectTeamState();
    yield put(auth_actions.setTeamState({ deleteUserDialogState: Object.assign(Object.assign({}, teamState.deleteUserDialogState), { loading: true }) }));
    try {
        yield call(umd.api.teams.deleteUser, body);
        callback === null || callback === void 0 ? void 0 : callback(true);
        yield put(auth_actions.setTeamState({
            users: teamState.users.filter((user) => user.id !== body.userId),
            deleteUserDialogState: { open: false, loading: false },
        }));
    }
    catch (e) {
        yield put(auth_actions.setTeamState({
            deleteUserDialogState: Object.assign(Object.assign({}, teamState.deleteUserDialogState), { loading: false, error: e.message }),
        }));
        callback === null || callback === void 0 ? void 0 : callback(null, e.message);
    }
}
function* setUserRolesForSubTenants({ payload, }) {
    const { callback, userId } = payload, body = (0,tslib_es6.__rest)(payload, ["callback", "userId"]);
    const teamState = yield selectTeamState();
    yield put(auth_actions.setTeamState({ addUserDialogState: Object.assign(Object.assign({}, teamState.addUserDialogState), { loading: true }) }));
    try {
        yield call(umd.api.subTenants.setUserRolesForSubTenants, userId, body);
        const updatedUser = teamState.allUsers.find((user) => user.id === userId);
        let newTenants = [];
        if (updatedUser) {
            newTenants = updatedUser.tenants.map((tenant) => {
                var _a;
                return (Object.assign(Object.assign({}, tenant), { roles: ((_a = body.subTenantsRoles
                        .find((roleUpdate) => roleUpdate.tenantId === tenant.tenantId)) === null || _a === void 0 ? void 0 : _a.roleIds.map((roleId) => {
                        const role = teamState.roles.find(({ id }) => roleId === id);
                        return role;
                    }).filter((role) => role)) || tenant.roles }));
            });
        }
        yield put(auth_actions.setTeamState({
            allUsers: [
                ...teamState.allUsers.filter((user) => user.id !== userId),
                ...(updatedUser ? [Object.assign(Object.assign({}, updatedUser), { tenants: newTenants })] : []),
            ],
            addUserDialogState: { open: false, loading: false },
        }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setTeamState({
            addUserDialogState: Object.assign(Object.assign({}, teamState.addUserDialogState), { loading: false, error: e.message }),
        }));
        callback === null || callback === void 0 ? void 0 : callback(null, e.message);
    }
}
function* deleteUserFromSubTenants({ payload }) {
    const { callback } = payload, body = (0,tslib_es6.__rest)(payload, ["callback"]);
    const teamState = yield selectTeamState();
    yield put(auth_actions.setTeamState({ deleteUserDialogState: Object.assign(Object.assign({}, teamState.deleteUserDialogState), { loading: true }) }));
    try {
        yield call(umd.api.subTenants.removeUserFromTenantAndSubTenants, body);
        callback === null || callback === void 0 ? void 0 : callback(true);
        yield put(auth_actions.setTeamState({
            allUsers: teamState.allUsers.filter((user) => user.id !== body.userId && user.tenants.length === body.subTenants.length),
            deleteUserDialogState: { open: false, loading: false },
        }));
    }
    catch (e) {
        yield put(auth_actions.setTeamState({
            deleteUserDialogState: Object.assign(Object.assign({}, teamState.deleteUserDialogState), { loading: false, error: e.message }),
        }));
        callback === null || callback === void 0 ? void 0 : callback(null, e.message);
    }
}
function* resendActivationLink({ payload }) {
    const { callback } = payload, body = (0,tslib_es6.__rest)(payload, ["callback"]);
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.RESEND_ACTIVATE_LINK, value: body.userId }));
    try {
        yield call(umd.api.teams.resendActivationLink, body);
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setTeamError({ key: TeamStateKeys.RESEND_ACTIVATE_LINK, value: e.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, e.message);
    }
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.RESEND_ACTIVATE_LINK, value: false }));
}
function* resendInvitationLink({ payload }) {
    const { callback } = payload, body = (0,tslib_es6.__rest)(payload, ["callback"]);
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.RESEND_INVITATION_LINK, value: body.email }));
    try {
        yield call(umd.api.teams.resendInvitationLink, body);
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setTeamError({ key: TeamStateKeys.RESEND_INVITATION_LINK, value: e.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, e.message);
    }
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.RESEND_INVITATION_LINK, value: false }));
}
function* resendInvitationLinkToAllSubTenants({ payload, }) {
    const { callback } = payload, body = (0,tslib_es6.__rest)(payload, ["callback"]);
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.RESEND_INVITATION_LINK, value: body.email }));
    try {
        yield call(umd.api.teams.resendInvitationLinkToAllTenants, body);
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setTeamError({ key: TeamStateKeys.RESEND_INVITATION_LINK, value: e.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, e.message);
    }
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.RESEND_INVITATION_LINK, value: false }));
}
function* getInvitationLinkConfig() {
    yield put(auth_actions.setTeamError({ key: TeamStateKeys.CONFIG_TOKEN_LINK, value: false }));
    try {
        const invitationLinkConfig = yield call(umd.api.teams.getInviteLinkConfiguration);
        yield put(auth_actions.setTeamState({ inviteTokenState: Object.assign({}, invitationLinkConfig) }));
    }
    catch (e) {
        yield put(auth_actions.setTeamError({ key: TeamStateKeys.CONFIG_TOKEN_LINK, value: e.message }));
    }
}
function* getInvitationLink() {
    yield put(auth_actions.setTeamError({ key: TeamStateKeys.GET_TOKEN_LINK, value: false }));
    try {
        yield call(getInvitationLinkConfig);
        const data = yield call(umd.api.teams.getInviteUserLink);
        const { inviteTokenState } = yield selectTeamState();
        yield put(auth_actions.setTeamState({ inviteTokenState: Object.assign(Object.assign({}, inviteTokenState), data) }));
    }
    catch (e) {
        yield put(auth_actions.setTeamError({ key: TeamStateKeys.GET_TOKEN_LINK, value: e.message }));
    }
}
function* createInvitationLink({ payload: { callback }, }) {
    yield put(auth_actions.setTeamError({ key: TeamStateKeys.CREATE_TOKEN_LINK, value: false }));
    const { inviteTokenState } = yield selectTeamState();
    try {
        const data = yield call(umd.api.teams.createInviteUserLink, { expiresInMinutes: 43200 });
        yield put(auth_actions.setTeamState({ inviteTokenState: Object.assign(Object.assign({}, inviteTokenState), data) }));
        callback === null || callback === void 0 ? void 0 : callback(data.token);
    }
    catch (e) {
        callback === null || callback === void 0 ? void 0 : callback(null, e.message);
        yield put(auth_actions.setTeamError({ key: TeamStateKeys.CREATE_TOKEN_LINK, value: e.message }));
    }
}
function* updateInvitationLink({ payload: { callback, expiresInMinutes, shouldSendEmail }, }) {
    const { inviteTokenState } = yield selectTeamState();
    yield put(auth_actions.setTeamError({ key: TeamStateKeys.UPDATE_TOKEN_LINK, value: false }));
    try {
        const data = yield call(umd.api.teams.updateInviteUserLink, { expiresInMinutes, shouldSendEmail });
        yield put(auth_actions.setTeamState({ inviteTokenState: Object.assign(Object.assign({}, inviteTokenState), data) }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        callback === null || callback === void 0 ? void 0 : callback(null, e.message);
        yield put(auth_actions.setTeamError({ key: TeamStateKeys.UPDATE_TOKEN_LINK, value: e.message }));
    }
}
function* deleteInvitationLink({ payload }) {
    const { callback } = payload !== null && payload !== void 0 ? payload : {};
    yield put(auth_actions.setTeamError({ key: TeamStateKeys.DELETE_TOKEN_LINK, value: false }));
    try {
        yield call(umd.api.teams.deleteInviteUserLink);
        yield put(auth_actions.setTeamState({ inviteTokenState: undefined }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setTeamError({ key: TeamStateKeys.DELETE_TOKEN_LINK, value: e.message }));
        callback === null || callback === void 0 ? void 0 : callback(false, e.message);
    }
}
function* openAddUserDialog({ payload }) {
    yield put(auth_actions.setTeamState({
        addUserDialogState: Object.assign({ open: true, loading: false, error: false }, payload),
    }));
}
function* closeAddUserDialog({ payload }) {
    const teamState = yield selectTeamState();
    const { addUserDialogState: { onClose }, } = teamState;
    onClose === null || onClose === void 0 ? void 0 : onClose(payload);
    yield put(auth_actions.setTeamState({
        addUserDialogState: {
            loading: false,
            error: false,
            open: false,
        },
    }));
}
function* openDeleteUserDialog({ payload }) {
    yield put(auth_actions.setTeamState({
        deleteUserDialogState: Object.assign({ open: true, loading: false, error: false }, payload),
    }));
}
function* closeDeleteUserDialog({ payload }) {
    const teamState = yield selectTeamState();
    const { deleteUserDialogState: { onClose }, } = teamState;
    onClose === null || onClose === void 0 ? void 0 : onClose(payload);
    yield put(auth_actions.setTeamState({
        deleteUserDialogState: {
            loading: false,
            error: false,
            open: false,
        },
    }));
}
function* teamSagas() {
    yield takeLatest$1(auth_actions.loadUsers, loadUsers);
    yield takeLatest$1(auth_actions.loadAllSubTenantsUsers, loadAllSubTenantsUsers);
    yield takeLatest$1(auth_actions.loadRoles, loadRoles);
    yield takeEvery$1(auth_actions.addUser, addUser);
    yield takeEvery$1(auth_actions.addUserToSubTenants, addUserToSubTenants);
    yield takeEvery$1(auth_actions.updateUser, updateUser);
    yield takeEvery$1(auth_actions.setUserRolesForSubTenants, setUserRolesForSubTenants);
    yield takeEvery$1(auth_actions.deleteUser, deleteUser);
    yield takeEvery$1(auth_actions.deleteUserFromSubTenants, deleteUserFromSubTenants);
    yield takeEvery$1(auth_actions.resendActivationLink, resendActivationLink);
    yield takeEvery$1(auth_actions.resendInvitationLink, resendInvitationLink);
    yield takeEvery$1(auth_actions.resendInvitationLinkToAllSubTenants, resendInvitationLinkToAllSubTenants);
    yield takeEvery$1(auth_actions.getInvitationLink, getInvitationLink);
    yield takeEvery$1(auth_actions.createInvitationLink, createInvitationLink);
    yield takeEvery$1(auth_actions.updateInvitationLink, updateInvitationLink);
    yield takeEvery$1(auth_actions.deleteInvitationLink, deleteInvitationLink);
    yield takeEvery$1(auth_actions.openAddUserDialog, openAddUserDialog);
    yield takeEvery$1(auth_actions.closeAddUserDialog, closeAddUserDialog);
    yield takeEvery$1(auth_actions.openDeleteUserDialog, openDeleteUserDialog);
    yield takeEvery$1(auth_actions.closeDeleteUserDialog, closeDeleteUserDialog);
}
/*********************************
 *  Preview Sagas
 *********************************/
function* loadUsersMock({ payload }) {
    var _a, _b, _c, _d;
    const { silentLoading, callback } = payload;
    const teamState = yield selectTeamState();
    const pageSize = (_a = payload.pageSize) !== null && _a !== void 0 ? _a : teamState.pageSize;
    const pageOffset = (_b = payload.pageOffset) !== null && _b !== void 0 ? _b : teamState.pageOffset;
    const filter = (_c = payload.filter) !== null && _c !== void 0 ? _c : teamState.filter;
    const sort = (_d = payload.sort) !== null && _d !== void 0 ? _d : teamState.sort;
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.USERS, value: !silentLoading }));
    yield put(auth_actions.setTeamState({
        pageSize,
        pageOffset,
        filter,
        sort,
    }));
    const totalPages = 2;
    const totalItems = 10;
    yield auth_delay();
    yield put(auth_actions.setTeamState({ users: usersDemo, totalPages, totalItems, roles: rolesDemo, permissions: permissionsDemo }));
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.USERS, value: false }));
    callback === null || callback === void 0 ? void 0 : callback(usersDemo);
}
function* loadAllSubTenantsUsersMock({ payload, }) {
    var _a, _b, _c, _d, _e;
    const { silentLoading, callback } = payload;
    const teamState = yield selectTeamState();
    const _limit = (_a = payload._limit) !== null && _a !== void 0 ? _a : teamState.allUsersQueryParams._limit;
    const _offset = (_b = payload._offset) !== null && _b !== void 0 ? _b : teamState.allUsersQueryParams._offset;
    const _filter = (_c = payload._filter) !== null && _c !== void 0 ? _c : teamState.allUsersQueryParams._filter;
    const _sortBy = (_d = payload._sortBy) !== null && _d !== void 0 ? _d : teamState.allUsersQueryParams._sortBy;
    const _order = (_e = payload._order) !== null && _e !== void 0 ? _e : teamState.allUsersQueryParams._order;
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.USERS, value: !silentLoading }));
    yield put(auth_actions.setTeamState({
        allUsersQueryParams: {
            _limit,
            _offset,
            _filter,
            _sortBy,
            _order,
        },
    }));
    const totalPages = 2;
    const totalItems = 10;
    yield auth_delay();
    yield put(auth_actions.setTeamState({
        allUsers: allUsersDemo,
        totalPages,
        totalItems,
        roles: rolesDemo,
        permissions: permissionsDemo,
    }));
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.USERS, value: false }));
    callback === null || callback === void 0 ? void 0 : callback(allUsersDemo);
}
function* loadRolesMock({ payload }) {
    var _a;
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.ROLES_AND_PERMISSIONS, value: true }));
    yield auth_delay();
    yield put(auth_actions.setTeamState({ roles: rolesDemo, permissions: permissionsDemo }));
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.ROLES_AND_PERMISSIONS, value: true }));
    (_a = payload === null || payload === void 0 ? void 0 : payload.callback) === null || _a === void 0 ? void 0 : _a.call(payload, { roles: rolesDemo, permissions: permissionsDemo });
}
function* addUserMock({ payload }) {
    const { callback } = payload, body = (0,tslib_es6.__rest)(payload, ["callback"]);
    const teamState = yield selectTeamState();
    yield put(auth_actions.setTeamState({ addUserDialogState: Object.assign(Object.assign({}, teamState.addUserDialogState), { loading: true }) }));
    yield auth_delay();
    const newUser = Object.assign(Object.assign(Object.assign({}, userTeamDemo), body), { id: `${esm_browser_v4()}` });
    callback === null || callback === void 0 ? void 0 : callback(newUser);
    yield put(auth_actions.setTeamState({
        users: [newUser, ...teamState.users],
        addUserDialogState: { open: false, loading: false },
    }));
}
function* addUserToSubTenantsMock({ payload }) {
    const { callback } = payload, body = (0,tslib_es6.__rest)(payload, ["callback"]);
    const teamState = yield selectTeamState();
    yield put(auth_actions.setTeamState({ addUserDialogState: Object.assign(Object.assign({}, teamState.addUserDialogState), { loading: true }) }));
    yield auth_delay();
    const newUser = Object.assign(Object.assign(Object.assign({}, userTeamDemo), body), { id: `${esm_browser_v4()}` });
    yield put(auth_actions.setTeamState({
        users: [newUser, ...teamState.users],
        addUserDialogState: { open: false, loading: false },
    }));
    callback === null || callback === void 0 ? void 0 : callback(null);
}
function* updateUserMock({ payload }) {
    var _a;
    const { callback, profileImage } = payload, body = (0,tslib_es6.__rest)(payload, ["callback", "profileImage"]);
    const { id: userId } = body;
    const teamState = yield selectTeamState();
    const oldUserData = teamState.users.find((user) => user.id === body.id);
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.UPDATE_USER, value: userId || '' }));
    yield put(auth_actions.setTeamState({ addUserDialogState: Object.assign(Object.assign({}, teamState.addUserDialogState), { loading: true }) }));
    yield put(auth_actions.setTeamState({
        addUserDialogState: Object.assign(Object.assign({}, teamState.addUserDialogState), { loading: true }),
        users: teamState.users.map((user) => {
            if (user.id === body.id) {
                return Object.assign(Object.assign({}, user), body);
            }
            return user;
        }),
    }));
    if (oldUserData.roleIds.length > 0 && ((_a = body.roleIds) === null || _a === void 0 ? void 0 : _a.length) === 0) {
        body.roleIds = [''];
    }
    yield auth_delay();
    const newUser = Object.assign(Object.assign({}, oldUserData), body);
    callback === null || callback === void 0 ? void 0 : callback(newUser);
    yield put(auth_actions.setTeamState({
        users: teamState.users.map((user) => user.id === newUser.id
            ? Object.assign(Object.assign(Object.assign({}, user), newUser), { createdAt: user.createdAt, customData: user.customData, lastLogin: user.lastLogin }) : user),
    }));
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.UPDATE_USER, value: false }));
}
function* deleteUserMock({ payload }) {
    const { callback } = payload, body = (0,tslib_es6.__rest)(payload, ["callback"]);
    const teamState = yield selectTeamState();
    yield put(auth_actions.setTeamState({ deleteUserDialogState: Object.assign(Object.assign({}, teamState.deleteUserDialogState), { loading: true }) }));
    yield auth_delay();
    callback === null || callback === void 0 ? void 0 : callback(true);
    yield put(auth_actions.setTeamState({
        users: teamState.users.filter((user) => user.id !== body.userId),
        deleteUserDialogState: { open: false, loading: false },
    }));
}
function* deleteUserFromSubTenantsMock({ payload }) {
    const { callback } = payload, body = (0,tslib_es6.__rest)(payload, ["callback"]);
    const teamState = yield selectTeamState();
    yield put(auth_actions.setTeamState({ deleteUserDialogState: Object.assign(Object.assign({}, teamState.deleteUserDialogState), { loading: true }) }));
    yield auth_delay();
    callback === null || callback === void 0 ? void 0 : callback(true);
    yield put(auth_actions.setTeamState({
        allUsers: teamState.allUsers.filter((user) => user.id !== body.userId),
        deleteUserDialogState: { open: false, loading: false },
    }));
}
function* resendActivationLinkMock({ payload }) {
    const { callback } = payload, body = (0,tslib_es6.__rest)(payload, ["callback"]);
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.RESEND_ACTIVATE_LINK, value: body.userId }));
    yield auth_delay();
    callback === null || callback === void 0 ? void 0 : callback(true);
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.RESEND_ACTIVATE_LINK, value: false }));
}
function* resendInvitationLinkMock({ payload }) {
    const { callback } = payload, body = (0,tslib_es6.__rest)(payload, ["callback"]);
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.RESEND_INVITATION_LINK, value: body.email }));
    yield auth_delay();
    callback === null || callback === void 0 ? void 0 : callback(true);
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.RESEND_INVITATION_LINK, value: false }));
}
function* resendInvitationLinkToAllSubTenantsMock({ payload, }) {
    const { callback } = payload, body = (0,tslib_es6.__rest)(payload, ["callback"]);
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.RESEND_INVITATION_LINK, value: body.email }));
    yield auth_delay();
    callback === null || callback === void 0 ? void 0 : callback(true);
    yield put(auth_actions.setTeamLoader({ key: TeamStateKeys.RESEND_INVITATION_LINK, value: false }));
}
function* teamSagasMock() {
    yield takeLatest$1(auth_actions.loadUsers, loadUsersMock);
    yield takeLatest$1(auth_actions.loadAllSubTenantsUsers, loadAllSubTenantsUsersMock);
    yield takeLatest$1(auth_actions.loadRoles, loadRolesMock);
    yield takeEvery$1(auth_actions.addUser, addUserMock);
    yield takeEvery$1(auth_actions.addUserToSubTenants, addUserToSubTenantsMock);
    yield takeEvery$1(auth_actions.updateUser, updateUserMock);
    yield takeEvery$1(auth_actions.deleteUser, deleteUserMock);
    yield takeEvery$1(auth_actions.deleteUserFromSubTenants, deleteUserFromSubTenantsMock);
    yield takeEvery$1(auth_actions.resendActivationLink, resendActivationLinkMock);
    yield takeEvery$1(auth_actions.resendInvitationLink, resendInvitationLinkMock);
    yield takeEvery$1(auth_actions.resendInvitationLinkToAllSubTenants, resendInvitationLinkToAllSubTenantsMock);
    yield takeEvery$1(auth_actions.openAddUserDialog, openAddUserDialog);
    yield takeEvery$1(auth_actions.closeAddUserDialog, closeAddUserDialog);
    yield takeEvery$1(auth_actions.openDeleteUserDialog, openDeleteUserDialog);
    yield takeEvery$1(auth_actions.closeDeleteUserDialog, closeDeleteUserDialog);
}

function* loadSocialLoginsConfigurations() {
    try {
        yield put(auth_actions.setSocialLoginsState({ loading: true }));
        const socialLoginsConfig = yield call(umd.api.auth.getSocialLoginProviders);
        yield put(auth_actions.setSocialLoginsState({ socialLoginsConfig, loading: false, firstLoad: false }));
    }
    catch (e) {
        yield put(auth_actions.setSocialLoginsState({ error: e.message, loading: false, firstLoad: false }));
    }
}
function* loadSocialLoginsConfigurationsV2() {
    try {
        const context = yield io_c3792963_select((state) => state.root.context);
        yield put(auth_actions.setSocialLoginsState({ loading: true }));
        const socialLoginsConfigV2 = yield call(umd.api.auth.getSocialLoginProvidersV2);
        const socialLoginsConfigWithFullUrl = socialLoginsConfigV2.map((_a) => {
            var { authorizationUrl } = _a, config = (0,tslib_es6.__rest)(_a, ["authorizationUrl"]);
            const baseUrl = umd.fetch.getBaseUrl(context, authorizationUrl !== null && authorizationUrl !== void 0 ? authorizationUrl : '');
            return (Object.assign(Object.assign({}, config), { authorizationUrl: authorizationUrl ? `${baseUrl}${authorizationUrl}` : null }));
        });
        yield put(auth_actions.setSocialLoginsState({ socialLoginsConfigV2: socialLoginsConfigWithFullUrl, loading: false, firstLoad: false }));
    }
    catch (e) {
        yield put(auth_actions.setSocialLoginsState({ error: e.message, loading: false, firstLoad: false }));
    }
}
function* loginViaSocialLogin(_a) {
    var _b, _c, _d;
    var _e = _a.payload, { events, url } = _e, payload = (0,tslib_es6.__rest)(_e, ["events", "url"]);
    try {
        yield put(auth_actions.setSocialLoginsState({ loading: true }));
        const { email, isNewUser, userId, tenantId, name, } = yield call(umd.api.auth.loginViaSocialLogin, payload);
        if (isNewUser) {
            (_b = events === null || events === void 0 ? void 0 : events.signUpComplete) === null || _b === void 0 ? void 0 : _b.call(events, {
                email,
                url,
                authenticationType: AuthenticationTypes.SOCIAL_LOGIN,
                createdAt: new Date(),
                id: userId,
                socialProvider: payload.provider,
                tenantId,
            });
            (_c = events === null || events === void 0 ? void 0 : events.userVerified) === null || _c === void 0 ? void 0 : _c.call(events, {
                email,
                origin: UserVeirifedOriginTypes.SOCIAL_LOGIN,
                createdAt: new Date(),
                id: userId,
                url,
                tenantId,
                name,
            });
        }
        if (email) {
            localStorage.setItem('email', email);
            localStorage.setItem('name', name);
        }
        yield put(auth_actions.setLoginState({ email, isNewUser }));
        yield refreshToken();
        yield put(auth_actions.setSocialLoginsState({ loading: false }));
    }
    catch (e) {
        yield put(auth_actions.setSocialLoginsState({ loading: false, error: (_d = e.message) !== null && _d !== void 0 ? _d : 'Failed to authenticate', firstLoad: false }));
    }
}
function* setSocialLoginError({ payload }) {
    yield put(auth_actions.setSocialLoginsState({ error: payload.error, loading: false, firstLoad: false }));
}
function* socialLoginsSaga() {
    yield takeLeading$1(auth_actions.loadSocialLoginsConfiguration, loadSocialLoginsConfigurations);
    yield takeLeading$1(auth_actions.loadSocialLoginsConfigurationV2, loadSocialLoginsConfigurationsV2);
    yield takeLeading$1(auth_actions.loginViaSocialLogin, loginViaSocialLogin);
    yield takeLatest$1(auth_actions.setSocialLoginError, setSocialLoginError);
}

var ApiStateKeys;
(function (ApiStateKeys) {
    ApiStateKeys["LOAD_API_TOKENS"] = "LOAD_API_TOKENS";
    ApiStateKeys["ADD_API_TOKEN"] = "ADD_API_TOKEN";
    ApiStateKeys["DELETE_API_TOKEN"] = "DELETE_API_TOKEN";
})(ApiStateKeys || (ApiStateKeys = {}));

function* loadApiTokensData({ payload: apiTokenType }) {
    yield put(auth_actions.setApiTokensState({ apiTokenType }));
    try {
        yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.LOAD_API_TOKENS, value: true }));
        if (apiTokenType === 'user') {
            const apiTokensData = yield call(umd.api.auth.getUserApiTokensData);
            yield put(auth_actions.setApiTokensState({ apiTokensDataUser: apiTokensData !== null && apiTokensData !== void 0 ? apiTokensData : [] }));
        }
        else {
            const apiTenantTokensData = yield call(umd.api.auth.getTenantApiTokensData);
            const { items: roles } = yield call(umd.api.teams.loadAvailableRoles);
            const { items: permissions } = yield call(umd.api.teams.loadAvailablePermissions);
            yield put(auth_actions.setApiTokensState({
                apiTokensDataTenant: apiTenantTokensData !== null && apiTenantTokensData !== void 0 ? apiTenantTokensData : [],
                roles: roles !== null && roles !== void 0 ? roles : [],
                permissions: permissions !== null && permissions !== void 0 ? permissions : [],
            }));
        }
        yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.LOAD_API_TOKENS, value: false }));
    }
    catch (e) {
        yield put(auth_actions.setApiTokensError({ key: ApiStateKeys.LOAD_API_TOKENS, value: e.message }));
        yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.LOAD_API_TOKENS, value: false }));
    }
}
function* addUserApiToken({ payload }) {
    const { description, callback } = payload;
    const { apiTokensDataUser } = yield io_c3792963_select((state) => state.auth.apiTokensState);
    try {
        yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.ADD_API_TOKEN, value: true }));
        const data = yield call(umd.api.auth.updateUserApiTokensData, { description });
        yield put(auth_actions.setApiTokensState({ showAddTokenDialog: false }));
        yield io_c3792963_delay(200);
        yield put(auth_actions.setApiTokensState({
            apiTokensDataUser: [data, ...apiTokensDataUser],
            successDialog: { open: true, secret: data.secret, clientId: data.clientId },
        }));
        yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.ADD_API_TOKEN, value: false }));
        callback === null || callback === void 0 ? void 0 : callback(null);
    }
    catch (e) {
        yield put(auth_actions.setApiTokensError({ key: ApiStateKeys.ADD_API_TOKEN, value: e.message }));
        yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.ADD_API_TOKEN, value: false }));
        callback === null || callback === void 0 ? void 0 : callback(null, e.message);
    }
}
function* addTenantApiToken({ payload }) {
    const { description, roleIds, callback } = payload;
    const { apiTokensDataTenant } = yield io_c3792963_select((state) => state.auth.apiTokensState);
    try {
        yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.ADD_API_TOKEN, value: true }));
        const data = yield call(umd.api.auth.updateTenantApiTokensData, { description, roleIds });
        yield put(auth_actions.setApiTokensState({ showAddTokenDialog: false }));
        yield io_c3792963_delay(200);
        yield put(auth_actions.setApiTokensState({
            apiTokensDataTenant: [data, ...apiTokensDataTenant],
            successDialog: { open: true, secret: data.secret, clientId: data.clientId },
        }));
        yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.ADD_API_TOKEN, value: false }));
        callback === null || callback === void 0 ? void 0 : callback(null);
    }
    catch (e) {
        yield put(auth_actions.setApiTokensError({ key: ApiStateKeys.ADD_API_TOKEN, value: e.message }));
        yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.ADD_API_TOKEN, value: false }));
        callback === null || callback === void 0 ? void 0 : callback(null, e.message);
    }
}
function* deleteUserApiToken({ payload }) {
    const { apiTokensDataUser } = yield io_c3792963_select((state) => state.auth.apiTokensState);
    try {
        yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.DELETE_API_TOKEN, value: true }));
        yield call(umd.api.auth.deleteUserApiToken, { tokenId: payload });
        yield put(auth_actions.setApiTokensState({
            apiTokensDataUser: apiTokensDataUser.filter((i) => i.clientId !== payload),
            deleteTokenDialog: { open: false, clientId: payload },
        }));
        yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.DELETE_API_TOKEN, value: false }));
    }
    catch (e) {
        yield put(auth_actions.setApiTokensError({ key: ApiStateKeys.DELETE_API_TOKEN, value: e.message }));
        yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.DELETE_API_TOKEN, value: false }));
    }
}
function* deleteTenantApiToken({ payload }) {
    const { apiTokensDataTenant } = yield io_c3792963_select((state) => state.auth.apiTokensState);
    try {
        yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.DELETE_API_TOKEN, value: true }));
        yield call(umd.api.auth.deleteTenantApiToken, { tokenId: payload });
        yield put(auth_actions.setApiTokensState({
            apiTokensDataTenant: apiTokensDataTenant.filter((i) => i.clientId !== payload),
            deleteTokenDialog: { open: false, clientId: payload },
        }));
        yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.DELETE_API_TOKEN, value: false }));
    }
    catch (e) {
        yield put(auth_actions.setApiTokensError({ key: ApiStateKeys.DELETE_API_TOKEN, value: e.message }));
        yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.DELETE_API_TOKEN, value: false }));
    }
}
function* loadApiTokens({ payload }) {
    var _a, _b;
    if (!(payload === null || payload === void 0 ? void 0 : payload.silentLoading)) {
        yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.LOAD_API_TOKENS, value: true }));
    }
    try {
        const [apiTokensDataUser = [], apiTokensDataTenant = []] = yield io_c3792963_all([
            call(umd.api.auth.getUserApiTokensData),
            call(umd.api.auth.getTenantApiTokensData),
        ]);
        yield put(auth_actions.setApiTokensState({
            apiTokensDataUser,
            apiTokensDataTenant,
        }));
        yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.LOAD_API_TOKENS, value: false }));
        (_a = payload === null || payload === void 0 ? void 0 : payload.callback) === null || _a === void 0 ? void 0 : _a.call(payload, true);
    }
    catch (e) {
        yield put(auth_actions.setApiTokensError({ key: ApiStateKeys.LOAD_API_TOKENS, value: e.message }));
        yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.LOAD_API_TOKENS, value: false }));
        (_b = payload === null || payload === void 0 ? void 0 : payload.callback) === null || _b === void 0 ? void 0 : _b.call(payload, null, e);
    }
}
function* apiTokensSaga() {
    yield takeLeading$1(auth_actions.loadApiTokens, loadApiTokens);
    yield takeLeading$1(auth_actions.initApiTokensData, loadApiTokensData);
    yield takeEvery$1(auth_actions.addUserApiToken, addUserApiToken);
    yield takeEvery$1(auth_actions.addTenantApiToken, addTenantApiToken);
    yield takeLatest$1(auth_actions.deleteTenantApiToken, deleteTenantApiToken);
    yield takeLatest$1(auth_actions.deleteUserApiToken, deleteUserApiToken);
}
/*********************************
 *  Preview Sagas
 *********************************/
function* loadApiTokensDataMock({ payload: apiTokenType }) {
    var _a;
    yield put(auth_actions.setApiTokensState({ apiTokenType }));
    yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.LOAD_API_TOKENS, value: true }));
    if (apiTokenType === 'user') {
        yield io_c3792963_delay(200);
        const apiTokensData = [apiTokensDataDemo];
        yield put(auth_actions.setApiTokensState({ apiTokensDataUser: apiTokensData !== null && apiTokensData !== void 0 ? apiTokensData : [] }));
    }
    else {
        yield io_c3792963_delay(200);
        yield put(auth_actions.setApiTokensState({
            apiTokensDataTenant: (_a = [apiTokensDataTenantDemo]) !== null && _a !== void 0 ? _a : [],
            roles: rolesDemo !== null && rolesDemo !== void 0 ? rolesDemo : [],
            permissions: permissionsDemo !== null && permissionsDemo !== void 0 ? permissionsDemo : [],
        }));
    }
    yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.LOAD_API_TOKENS, value: false }));
}
function* addTenantApiTokenMock({ payload }) {
    const { description, roleIds, callback } = payload;
    yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.ADD_API_TOKEN, value: true }));
    const { apiTokensDataTenant } = yield io_c3792963_select((state) => state.auth.apiTokensState);
    const newToken = Object.assign(Object.assign({}, apiTokensDataTenantDemo), { description,
        roleIds, clientId: `CLIENT_ID_${esm_browser_v4()}` });
    yield put(auth_actions.setApiTokensState({ showAddTokenDialog: false }));
    yield io_c3792963_delay(200);
    yield put(auth_actions.setApiTokensState({
        apiTokensDataTenant: [...apiTokensDataTenant, newToken],
        successDialog: { open: true, secret: newToken.secret, clientId: newToken.clientId },
    }));
    yield io_c3792963_delay(200);
    yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.ADD_API_TOKEN, value: false }));
    callback === null || callback === void 0 ? void 0 : callback(null);
}
function* deleteTenantApiTokenMock({ payload }) {
    yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.DELETE_API_TOKEN, value: true }));
    yield io_c3792963_delay(200);
    const apiTokensDataTenant = [apiTokensDataTenantDemo];
    yield put(auth_actions.setApiTokensState({
        apiTokensDataTenant: apiTokensDataTenant.filter((i) => i.clientId !== payload),
        deleteTokenDialog: { open: false, clientId: payload },
    }));
    yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.DELETE_API_TOKEN, value: false }));
}
function* loadApiTokensMock({ payload }) {
    var _a;
    if (!(payload === null || payload === void 0 ? void 0 : payload.silentLoading)) {
        yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.LOAD_API_TOKENS, value: true }));
    }
    const apiTokensDataUser = [apiTokensDataDemo];
    const apiTokensDataTenant = [apiTokensDataTenantDemo];
    yield put(auth_actions.setApiTokensState({
        apiTokensDataUser,
        apiTokensDataTenant,
    }));
    yield io_c3792963_delay(200);
    yield put(auth_actions.setApiTokensLoader({ key: ApiStateKeys.LOAD_API_TOKENS, value: false }));
    (_a = payload === null || payload === void 0 ? void 0 : payload.callback) === null || _a === void 0 ? void 0 : _a.call(payload, true);
}
function* apiTokensSagaMock() {
    yield takeLeading$1(auth_actions.loadApiTokens, loadApiTokensMock);
    yield takeLeading$1(auth_actions.initApiTokensData, loadApiTokensDataMock);
    yield takeEvery$1(auth_actions.addTenantApiToken, addTenantApiTokenMock);
    yield takeLatest$1(auth_actions.deleteTenantApiToken, deleteTenantApiTokenMock);
}

function* saveAccountSettings({ payload }) {
    var _a, _b;
    try {
        yield put(auth_actions.setAccountSettingsState({ loading: true }));
        const { accountSettingsState } = yield io_c3792963_select((state) => state.auth);
        const { address, timezone, dateFormat, timeFormat, currency, logo } = accountSettingsState;
        const body = yield call(umd.api.accountSettings.updateSettings, Object.assign({ address,
            timezone,
            dateFormat,
            timeFormat,
            currency,
            logo }, payload));
        yield put(auth_actions.setAccountSettingsState(Object.assign(Object.assign({}, body), { loading: false })));
        (_a = payload.callback) === null || _a === void 0 ? void 0 : _a.call(payload, body);
    }
    catch (e) {
        yield put(auth_actions.setAccountSettingsState({ loading: false, error: e.message }));
        (_b = payload.callback) === null || _b === void 0 ? void 0 : _b.call(payload, null, e);
    }
}
function* loadAccountSettings({ payload }) {
    yield put(auth_actions.setAccountSettingsState({ loading: !(payload === null || payload === void 0 ? void 0 : payload.silentLoading), error: null }));
    try {
        const body = yield call(umd.api.accountSettings.getSettings);
        yield put(auth_actions.setAccountSettingsState(Object.assign(Object.assign({}, body), { loading: false })));
    }
    catch (e) {
        yield put(auth_actions.setAccountSettingsState({ loading: false, error: e.message }));
    }
}
function* accountSettingsSaga() {
    yield takeLeading$1(auth_actions.saveAccountSettings, saveAccountSettings);
    yield takeLeading$1(auth_actions.loadAccountSettings, loadAccountSettings);
}
/*********************************
 *  Preview Sagas
 *********************************/
function* saveAccountSettingsMock({ payload }) {
    var _a;
    yield put(auth_actions.setAccountSettingsState({ loading: true }));
    yield auth_delay();
    const { accountSettingsState } = yield io_c3792963_select((state) => state.auth);
    const { address, timezone, dateFormat, timeFormat, currency, logo } = accountSettingsState;
    const body = Object.assign({ address,
        timezone,
        dateFormat,
        timeFormat,
        currency,
        logo }, payload);
    yield put(auth_actions.setAccountSettingsState(Object.assign(Object.assign({}, body), { loading: false })));
    (_a = payload.callback) === null || _a === void 0 ? void 0 : _a.call(payload, body);
}
function* loadAccountSettingsMock({ payload }) {
    yield put(auth_actions.setAccountSettingsState({ loading: !(payload === null || payload === void 0 ? void 0 : payload.silentLoading), error: null }));
    yield auth_delay();
    yield put(auth_actions.setAccountSettingsState({
        address: 'Tel-aviv',
        timezone: 'Asia/Jerusalem',
        dateFormat: 'DD/MM/YYYY',
        timeFormat: 'HH:mm',
        currency: 'USD',
        loading: false,
    }));
}
function* accountSettingsSagaMock() {
    yield takeLeading$1(auth_actions.saveAccountSettings, saveAccountSettingsMock);
    yield takeLeading$1(auth_actions.loadAccountSettings, loadAccountSettingsMock);
}

function* switchTenant({ payload: { tenantId, callback } }) {
    yield put(auth_actions.setState({ isLoading: true }));
    try {
        yield call(umd.api.tenants.switchTenant, { tenantId });
        yield call(refreshToken);
        const callbackConsumed = callback === null || callback === void 0 ? void 0 : callback(true);
        if (!callbackConsumed) {
            yield put(auth_actions.setState({ isLoading: false }));
        }
    }
    catch (e) {
        yield put(auth_actions.setState({ isLoading: false }));
        callback === null || callback === void 0 ? void 0 : callback(false, e);
    }
}
function* loadTenants({ payload }) {
    var _a, _b;
    yield put(auth_actions.setTenantsState({ loading: true }));
    try {
        const tenants = yield call(umd.api.tenants.getTenants);
        yield put(auth_actions.setTenantsState({ tenants, loading: false }));
        (_a = payload === null || payload === void 0 ? void 0 : payload.callback) === null || _a === void 0 ? void 0 : _a.call(payload, []);
    }
    catch (e) {
        (_b = payload === null || payload === void 0 ? void 0 : payload.callback) === null || _b === void 0 ? void 0 : _b.call(payload, [], e);
        yield put(auth_actions.setTenantsState({ loading: false }));
    }
}
function* loadSubTenants({ payload }) {
    var _a, _b;
    yield put(auth_actions.setTenantsState({ loading: true }));
    try {
        const subTenants = yield call(umd.api.tenants.getSubTenants);
        yield put(auth_actions.setTenantsState({ subTenants, loading: false }));
        (_a = payload === null || payload === void 0 ? void 0 : payload.callback) === null || _a === void 0 ? void 0 : _a.call(payload, true);
    }
    catch (e) {
        yield put(auth_actions.setTenantsState({ loading: false }));
        (_b = payload === null || payload === void 0 ? void 0 : payload.callback) === null || _b === void 0 ? void 0 : _b.call(payload, null, e);
    }
}
function* loadSubTenantsTree({ payload }) {
    var _a, _b;
    yield put(auth_actions.setTenantsState({ loading: true }));
    try {
        const tenantTree = yield call(umd.api.tenants.getSubTenantsAsTree);
        yield put(auth_actions.setTenantsState({ tenantTree, loading: false }));
        (_a = payload === null || payload === void 0 ? void 0 : payload.callback) === null || _a === void 0 ? void 0 : _a.call(payload, true);
    }
    catch (e) {
        yield put(auth_actions.setTenantsState({ loading: false }));
        (_b = payload === null || payload === void 0 ? void 0 : payload.callback) === null || _b === void 0 ? void 0 : _b.call(payload, null, e);
    }
}
function* tenantsSagas() {
    yield takeEvery$1(auth_actions.loadTenants, loadTenants);
    yield takeEvery$1(auth_actions.loadSubTenants, loadSubTenants);
    yield takeEvery$1(auth_actions.switchTenant, switchTenant);
    yield takeEvery$1(auth_actions.loadSubTenantsTree, loadSubTenantsTree);
}
/*********************************
 *  Preview Sagas
 *********************************/
function* loadTenantsMock({}) {
    yield put(auth_actions.setTenantsState({ loading: true }));
    yield auth_delay();
    yield put(auth_actions.setTenantsState({ tenants: tenantsDemo, loading: false }));
}
function* tenantsSagasMock() {
    yield takeEvery$1(auth_actions.loadTenants, loadTenantsMock);
}

function* loadRolesAndPermissions({ payload }) {
    var _a;
    yield put(auth_actions.setRolesState({ loading: !((_a = payload === null || payload === void 0 ? void 0 : payload.silentLoading) !== null && _a !== void 0 ? _a : false), error: null }));
    try {
        const result = yield io_c3792963_all([
            call(umd.api.roles.getRoles),
            call(umd.api.roles.getPermissions),
            call(umd.api.roles.getPermissionCategories),
        ]);
        const [roles, permissions, permissionCategories] = result;
        yield put(auth_actions.setRolesState({ roles, permissions, permissionCategories, loading: false }));
    }
    catch (e) {
        yield put(auth_actions.setRolesState({ error: e.message, loading: false }));
    }
}
function* addRole(_a) {
    var _b = _a.payload, { callback } = _b, body = (0,tslib_es6.__rest)(_b, ["callback"]);
    yield put(auth_actions.setRolesState({ saving: true }));
    try {
        const role = yield call(umd.api.roles.addRole, body);
        const roles = yield call(umd.api.roles.getRoles);
        yield put(auth_actions.loadRolesAndPermissions({ silentLoading: true }));
        yield put(auth_actions.setRolesState({ roles, saving: false }));
        callback === null || callback === void 0 ? void 0 : callback(role);
    }
    catch (e) {
        yield put(auth_actions.setRolesState({ error: e.message, saving: false }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
}
function* deleteRole(_a) {
    var _b = _a.payload, { callback } = _b, body = (0,tslib_es6.__rest)(_b, ["callback"]);
    yield put(auth_actions.setRolesState({ saving: true }));
    try {
        yield call(umd.api.roles.deleteRole, body);
        yield put(auth_actions.loadRolesAndPermissions({ silentLoading: true }));
        yield put(auth_actions.setRolesState({ saving: false }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setRolesState({ error: e.message, saving: false }));
        callback === null || callback === void 0 ? void 0 : callback(false, e);
    }
}
function* updateRole(_a) {
    var _b = _a.payload, { callback } = _b, body = (0,tslib_es6.__rest)(_b, ["callback"]);
    yield put(auth_actions.setRolesState({ saving: true }));
    try {
        const role = yield call(umd.api.roles.updateRole, body);
        yield put(auth_actions.loadRolesAndPermissions({ silentLoading: true }));
        yield put(auth_actions.setRolesState({ saving: false }));
        callback === null || callback === void 0 ? void 0 : callback(role);
    }
    catch (e) {
        yield put(auth_actions.setRolesState({ error: e.message, saving: false }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
}
function* attachPermissionsToRole(_a) {
    var _b = _a.payload, { callback } = _b, body = (0,tslib_es6.__rest)(_b, ["callback"]);
    yield put(auth_actions.setRolesState({ saving: true }));
    try {
        const role = yield call(umd.api.roles.attachPermissionsToRole, body);
        yield put(auth_actions.loadRolesAndPermissions({ silentLoading: true }));
        yield put(auth_actions.setRolesState({ saving: false }));
        callback === null || callback === void 0 ? void 0 : callback(role);
    }
    catch (e) {
        yield put(auth_actions.setRolesState({ error: e.message, saving: false }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
}
function* attachPermissionToRoles(_a) {
    var _b = _a.payload, { callback } = _b, body = (0,tslib_es6.__rest)(_b, ["callback"]);
    yield put(auth_actions.setRolesState({ saving: true }));
    try {
        const permission = yield call(umd.api.roles.attachPermissionToRoles, body);
        yield put(auth_actions.loadRolesAndPermissions({ silentLoading: true }));
        yield put(auth_actions.setRolesState({ saving: false }));
        callback === null || callback === void 0 ? void 0 : callback(permission);
    }
    catch (e) {
        yield put(auth_actions.setRolesState({ error: e.message, saving: false }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
}
function* rolesSagas() {
    yield takeLeading$1(auth_actions.loadRolesAndPermissions, loadRolesAndPermissions);
    yield takeEvery$1(auth_actions.addRole, addRole);
    yield takeEvery$1(auth_actions.deleteRole, deleteRole);
    yield takeEvery$1(auth_actions.updateRole, updateRole);
    yield takeEvery$1(auth_actions.attachPermissionsToRole, attachPermissionsToRole);
    yield takeEvery$1(auth_actions.attachPermissionToRoles, attachPermissionToRoles);
}

function* resetPhoneNumber(_a) {
    var _b = _a.payload, { callback } = _b, body = (0,tslib_es6.__rest)(_b, ["callback"]);
    yield put(auth_actions.setResetPhoneNumberState({ loading: true }));
    try {
        const res = yield call(umd.api.auth.resetPhoneNumber, body);
        yield put(auth_actions.setResetPhoneNumberState({ loading: false, error: undefined, resetPhoneNumberToken: res.resetPhoneNumberToken, step: ResetPhoneNumberStep.VerifyResetPhoneNumber }));
        yield put(auth_actions.setLoginState({ email: body.email }));
    }
    catch (e) {
        yield put(auth_actions.setResetPhoneNumberState({ loading: false, error: e.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
}
function* verifyResetPhoneNumber(_a) {
    var _b = _a.payload, { callback } = _b, body = (0,tslib_es6.__rest)(_b, ["callback"]);
    yield put(auth_actions.setResetPhoneNumberState({ loading: true }));
    try {
        const res = yield call(umd.api.auth.verifyResetPhoneNumber, body);
        yield put(auth_actions.setResetPhoneNumberState({ loading: false, error: undefined, changePhoneNumberToken: res.changePhoneNumberToken, step: ResetPhoneNumberStep.ChangePhoneNumber }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setResetPhoneNumberState({ loading: false, error: e.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
}
function* changePhoneNumber(_a) {
    var _b = _a.payload, { callback } = _b, body = (0,tslib_es6.__rest)(_b, ["callback"]);
    yield put(auth_actions.setResetPhoneNumberState({ loading: true }));
    try {
        const { onRedirectTo, routes } = yield io_c3792963_select(({ auth: { onRedirectTo, routes } }) => ({ onRedirectTo, routes }));
        yield call(umd.api.auth.changePhoneNumber, { phoneNumber: body.phoneNumber, changePhoneNumberToken: body.changePhoneNumberToken });
        yield put(auth_actions.setLoginState({ step: LoginStep.loginWithSmsOtc }));
        yield put(auth_actions.passwordlessPreLogin({
            type: umd.AuthStrategyEnum.SmsCode,
            email: body.email,
            recaptchaToken: body.recaptchaToken,
        }));
        onRedirectTo(routes.loginUrl);
        yield put(auth_actions.setResetPhoneNumberState({ loading: false }));
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(auth_actions.setResetPhoneNumberState({ loading: false, error: e.message }));
        callback === null || callback === void 0 ? void 0 : callback(null, e);
    }
}
function* resetPhoneNumberSagas() {
    yield takeLeading$1(auth_actions.resetPhoneNumber, resetPhoneNumber);
    yield takeLeading$1(auth_actions.verifyResetPhoneNumber, verifyResetPhoneNumber);
    yield takeLeading$1(auth_actions.changePhoneNumber, changePhoneNumber);
}

function* auth_sagas() {
    yield io_c3792963_all([
        call(loginSagas),
        call(activateSagas),
        call(acceptInvitationSagas),
        call(forgotPasswordSagas),
        call(resetPhoneNumberSagas),
        call(ssoSagas$1),
        call(ssoSagas),
        call(profileSagas),
        call(mfaSagas),
        call(teamSagas),
        call(socialLoginsSaga),
        call(signUpSaga),
        call(apiTokensSaga),
        call(securityPolicySagas),
        call(accountSettingsSaga),
        call(tenantsSagas),
        call(rolesSagas),
    ]);
}
function* mockSagas() {
    yield io_c3792963_all([
        call(loginSagasMock),
        // call(activateSagas),
        // call(acceptInvitationSagas),
        // call(forgotPasswordSagas),
        // call(socialLoginsSaga),
        // call(signUpSaga),
        call(ssoSagasMock),
        call(profileSagasMock),
        call(mfaSagasMock),
        call(teamSagasMock),
        call(apiTokensSagaMock),
        call(securityPolicySagasMock),
        call(accountSettingsSagaMock),
        call(tenantsSagasMock),
    ]);
}

// export store
var authStore = {
    sagas: auth_sagas,
    mockSagas,
    storeName: authStoreName,
    initialState: auth_initialState,
    reducer: auth_reducer,
    actions: auth_actions,
};



;// CONCATENATED MODULE: ./node_modules/@frontegg/redux-store/audits/index.js






const audits_typeReducerForKey = (key) => ({
    prepare: (payload) => ({ payload }),
    reducer: (state, { payload }) => {
        return Object.assign(Object.assign({}, state), { [key]: Object.assign(Object.assign({}, state[key]), payload) });
    },
});

const auditLogsState = {
    loading: true,
    pageOffset: 0,
    pageSize: 20,
    logs: [],
    sort: [],
    filter: [],
    totalPages: 0,
    isDownloadingCsv: false,
};
const audits_reducers$1 = {
    setAuditLogsState: audits_typeReducerForKey('auditLogsState'),
    resetAuditLogsState: (state) => (Object.assign(Object.assign({}, state), { auditLogsState })),
};
const audits_actions$2 = {
    exportAuditsCsv: createAction(`${auditsStoreName}/exportAuditsCsv`),
    loadAuditLogs: createAction(`${auditsStoreName}/loadAuditLogs`, (payload) => ({ payload })),
};

const auditsMetadataState = {
    loading: true,
};
const audits_reducers = {
    setAuditsMetadataState: audits_typeReducerForKey('auditsMetadataState'),
    resetAuditsMetadataState: (state) => (Object.assign(Object.assign({}, state), { auditsMetadataState })),
};
const audits_actions$1 = {
    loadAuditsMetadata: createAction(`${auditsStoreName}/loadAuditsMetadata`),
};

const audits_initialState = {
    auditLogsState,
    auditsMetadataState,
};

const { reducer: audits_reducer, actions: audits_sliceActions } = createSlice({
    name: auditsStoreName,
    initialState: audits_initialState,
    reducers: Object.assign(Object.assign({ resetState: (state) => (Object.assign(Object.assign({}, state), audits_initialState)), setState: (state, { payload }) => (Object.assign(Object.assign({}, state), payload)) }, audits_reducers$1), audits_reducers),
});
const audits_actions = Object.assign(Object.assign(Object.assign({}, audits_sliceActions), audits_actions$2), audits_actions$1);

const sortMethodBasedOnOrder = (sortBy, desc) => (a, b) => {
    if (a[sortBy] > b[sortBy]) {
        return desc ? -1 : 1;
    }
    if (b[sortBy] > a[sortBy]) {
        return desc ? 1 : -1;
    }
    return 0;
};
const filterAuditsByQuery = (filterOptions) => (log) => filterOptions
    .filter(filterOutTimeFilterForDummyMode)
    .every((filterItem) => log[filterItem.id].includes(filterItem.value));
const filterOutTimeFilterForDummyMode = (filterItem) => filterItem.id !== 'createdAt';
const auditsLogsFilterAndSort = (filterOptions, sortOptions) => {
    const { data } = auditLogsDataDemo;
    let dataByQuery = data.filter(filterAuditsByQuery(filterOptions));
    if (sortOptions.length) {
        const { id, desc = false } = sortOptions[0];
        dataByQuery = dataByQuery.sort(sortMethodBasedOnOrder(id, desc));
    }
    return { data: dataByQuery, total: dataByQuery.length };
};
const randomAction = () => {
    const random = Math.floor(Math.random() * 6);
    switch (random) {
        case 0:
            return {
                action: 'Updated profile',
                description: 'User updated profile details',
                severity: 'Info',
            };
        case 1:
            return {
                action: 'User logged in',
                severity: 'Info',
                description: 'User logged in to the product',
            };
        case 2:
            return {
                action: 'User failed to login',
                severity: 'High',
                description: 'User failed to login with password',
            };
        case 3:
            return {
                action: 'Added user',
                severity: 'Info',
                description: 'Added user david+535@frontegg.com to tenant',
            };
        case 4:
            return {
                action: 'Assigned roles',
                severity: 'Info',
                description: 'Assigned 0 roles for user',
            };
        case 5:
            return {
                action: 'Removed user david+108@frontegg.com from account',
                severity: 'Info',
                description: 'Removed access from the account for user david+108@frontegg.com',
            };
    }
};
const auditLogsDataDemo = {
    total: 20,
    data: Array.from(Array(5).keys()).map((i) => (Object.assign(Object.assign({ ip: '198.143.51.1', user: 'Demo User Name', email: 'demo-user@frontegg.com' }, randomAction()), { json: { key1: 'value1', key2: 'value2', key3: 'value3', key4: 'value4' }, tenantId: 'my-tenant-id', vendorId: 'my-vendor-id', userAgent: 'Mozilla/5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/89.0.4389.114 Safari/537.36', createdAt: `2022-04-07 10:${50 - i}:40.201` }))),
};
const auditLogsMetadataDemo = {
    properties: [
        {
            showInTable: true,
            name: 'createdAt',
            displayName: 'Time',
            type: 'Timestamp',
            sortable: true,
            filterable: true,
            showInMoreInfo: 'Always',
            chosen: false,
            selected: false,
            isPredefined: false,
        },
        {
            showInTable: true,
            name: 'email',
            displayName: 'User',
            type: 'Email',
            filterable: true,
            sortable: true,
            isPredefined: true,
            chosen: false,
            selected: false,
        },
        {
            showInTable: true,
            name: 'action',
            displayName: 'Action',
            type: 'AlphaNumeric',
            sortable: true,
            filterable: true,
            showInMoreInfo: 'Always',
            chosen: false,
            selected: false,
            isPredefined: true,
        },
        {
            showInTable: true,
            name: 'description',
            type: 'AlphaNumeric',
            sortable: false,
            filterable: false,
            displayName: 'Description',
            isPredefined: true,
            chosen: false,
            selected: false,
        },
        {
            showInTable: true,
            name: 'ip',
            displayName: 'IP Address',
            type: 'IpAddress',
            sortable: true,
            filterable: true,
            showInMoreInfo: 'Always',
            chosen: false,
            selected: false,
            isPredefined: true,
        },
        {
            showInTable: false,
            name: 'severity',
            displayName: 'Severity',
            type: 'Severity',
            sortable: true,
            filterable: true,
            showInMoreInfo: 'Always',
            chosen: false,
            selected: false,
            isPredefined: true,
        },
        {
            showInTable: false,
            name: 'userAgent',
            displayName: 'User Agent',
            type: 'AlphaNumeric',
            filterable: true,
            sortable: true,
            isPredefined: true,
            chosen: false,
            selected: false,
        },
        {
            showInTable: false,
            name: 'json',
            type: 'Json',
            sortable: true,
            filterable: true,
            displayName: 'Json Data',
            showInMoreInfo: 'Always',
            isPredefined: false,
        },
    ],
};

const audits_select = () => io_c3792963_select((_) => _[auditsStoreName].auditLogsState);
const selectMetadata = () => io_c3792963_select((_) => _[auditsStoreName].auditsMetadataState);
function* exportAuditsCsv() {
    const state = yield audits_select();
    const { columns } = yield selectMetadata();
    try {
        const filter = state.filter;
        const sort = state.sort;
        const sortParams = sort.reduce((p, n) => (Object.assign(Object.assign({}, p), { sortBy: n.id, sortDirection: n.desc ? 'desc' : 'asc' })), {});
        const filterParams = filter.reduce((p, n) => (Object.assign(Object.assign({}, p), { [n.id]: encodeURIComponent(n.value) })), {});
        yield put(audits_actions.setAuditLogsState({ isDownloadingCsv: true }));
        const outputFileName = `audits.csv`;
        yield umd.api.audits.exportAudits(Object.assign(Object.assign({ endpoint: 'csv/v2', headerProps: columns, offset: 0, outputFileName }, sortParams), filterParams));
    }
    catch (e) {
        console.error('failed to export audits - ', e);
    }
    yield put(audits_actions.setAuditLogsState({ isDownloadingCsv: false }));
}
function* loadAuditLogs({ payload }) {
    var _a, _b, _c, _d, _e, _f;
    yield put(audits_actions.setAuditLogsState({ loading: !(payload === null || payload === void 0 ? void 0 : payload.silentLoading), error: null }));
    const state = yield audits_select();
    const { columns } = yield selectMetadata();
    try {
        const pageSize = (_a = payload.pageSize) !== null && _a !== void 0 ? _a : state.pageSize;
        const pageOffset = (_b = payload.pageOffset) !== null && _b !== void 0 ? _b : state.pageOffset;
        const filter = (_c = payload.filter) !== null && _c !== void 0 ? _c : state.filter;
        const sort = (_d = payload.sort) !== null && _d !== void 0 ? _d : state.sort;
        yield put(audits_actions.setAuditLogsState({
            pageSize,
            pageOffset,
            filter,
            sort,
        }));
        const sortParams = sort.reduce((p, n) => (Object.assign(Object.assign({}, p), { sortBy: n.id, sortDirection: n.desc ? 'desc' : 'asc' })), {});
        const filterParams = filter.reduce((p, n) => (Object.assign(Object.assign({}, p), { [n.id]: n.value })), {});
        if (!columns) {
            yield put(audits_actions.loadAuditsMetadata());
        }
        const { data, total } = yield call(umd.api.audits.getAudits, Object.assign(Object.assign({ offset: pageOffset, count: pageSize }, sortParams), filterParams));
        yield put(audits_actions.setAuditLogsState({
            loading: false,
            logs: data !== null && data !== void 0 ? data : [],
            totalPages: +Math.ceil(total / pageSize),
        }));
        (_e = payload === null || payload === void 0 ? void 0 : payload.callback) === null || _e === void 0 ? void 0 : _e.call(payload, true);
    }
    catch (e) {
        yield put(audits_actions.setAuditLogsState({ loading: false, error: e.message }));
        (_f = payload === null || payload === void 0 ? void 0 : payload.callback) === null || _f === void 0 ? void 0 : _f.call(payload, null, e);
    }
}
function* auditLogsSagas() {
    yield takeEvery$1(audits_actions.exportAuditsCsv, exportAuditsCsv);
    yield takeEvery$1(audits_actions.loadAuditLogs, loadAuditLogs);
}
/*********************************
 *  Preview Sagas
 *********************************/
function* loadAuditLogsMock({ payload }) {
    var _a, _b, _c, _d, _e, _f;
    yield put(audits_actions.setAuditLogsState({ loading: !(payload === null || payload === void 0 ? void 0 : payload.silentLoading), error: null }));
    const state = yield audits_select();
    const { columns } = yield selectMetadata();
    try {
        const pageSize = (_a = payload.pageSize) !== null && _a !== void 0 ? _a : state.pageSize;
        const pageOffset = (_b = payload.pageOffset) !== null && _b !== void 0 ? _b : state.pageOffset;
        const filter = (_c = payload.filter) !== null && _c !== void 0 ? _c : state.filter;
        const sort = (_d = payload.sort) !== null && _d !== void 0 ? _d : state.sort;
        yield put(audits_actions.setAuditLogsState({
            pageSize,
            pageOffset,
            filter,
            sort,
        }));
        if (!columns) {
            yield put(audits_actions.loadAuditsMetadata());
        }
        const { data, total } = auditsLogsFilterAndSort(filter, sort);
        yield put(audits_actions.setAuditLogsState({
            loading: false,
            logs: data !== null && data !== void 0 ? data : [],
            totalPages: +Math.ceil(total / pageSize),
        }));
        (_e = payload === null || payload === void 0 ? void 0 : payload.callback) === null || _e === void 0 ? void 0 : _e.call(payload, true);
    }
    catch (e) {
        yield put(audits_actions.setAuditLogsState({ loading: false, error: e.message }));
        (_f = payload === null || payload === void 0 ? void 0 : payload.callback) === null || _f === void 0 ? void 0 : _f.call(payload, null, e);
    }
}
function* auditLogsSagasMock() {
    yield takeEvery$1(audits_actions.loadAuditLogs, loadAuditLogsMock);
}

function* loadAuditsMetadata() {
    yield put(audits_actions.setAuditsMetadataState({ loading: true, error: null }));
    try {
        const { properties } = yield call(umd.api.metadata.getAuditsMetadata);
        yield put(audits_actions.setAuditsMetadataState({ columns: properties, loading: false }));
    }
    catch (e) {
        yield put(audits_actions.setAuditsMetadataState({ error: e, loading: false }));
    }
}
function* auditsMetadataSagas() {
    yield takeEvery$1(audits_actions.loadAuditsMetadata, loadAuditsMetadata);
}
/*********************************
 *  Preview Sagas
 *********************************/
function* loadAuditsMetadataMock() {
    yield put(audits_actions.setAuditsMetadataState({ loading: true, error: null }));
    try {
        const { properties } = auditLogsMetadataDemo;
        yield put(audits_actions.setAuditsMetadataState({ columns: properties, loading: false }));
    }
    catch (e) {
        yield put(audits_actions.setAuditsMetadataState({ error: e, loading: false }));
    }
}
function* auditsMetadataSagasMock() {
    yield takeEvery$1(audits_actions.loadAuditsMetadata, loadAuditsMetadataMock);
}

function* audits_sagas() {
    yield io_c3792963_all([call(auditLogsSagas), call(auditsMetadataSagas)]);
}
function* audits_mockSagas() {
    yield io_c3792963_all([call(auditLogsSagasMock), call(auditsMetadataSagasMock)]);
}

// export store
var auditsStore = {
    sagas: audits_sagas,
    mockSagas: audits_mockSagas,
    storeName: auditsStoreName,
    initialState: audits_initialState,
    reducer: audits_reducer,
    actions: audits_actions,
};



;// CONCATENATED MODULE: ./node_modules/@frontegg/redux-store/connectivity/index.js







const initialState$1 = {
    isLoading: false,
    isSaving: false,
    list: [],
    processIds: [],
    slackChannels: {
        isLoading: false,
    },
};
const connectivity_reducers = {
    initData: () => (Object.assign({}, initialState$1)),
    // Deprecated: use initData instead;
    // cleanData: () => ({ ...initialState }),
    setConnectivityState: (state, { payload }) => (Object.assign(Object.assign({}, state), payload)),
    cleanWebhookTestData: (state) => (Object.assign(Object.assign({}, state), { testResult: undefined })),
    cleanWebhookLogsData: (state) => (Object.assign(Object.assign({}, state), { webhookLogs: undefined })),
    cleanWebhookTestMessage: (state) => {
        var _a;
        return (Object.assign(Object.assign({}, state), { testResult: { status: (_a = state.testResult) === null || _a === void 0 ? void 0 : _a.status, message: undefined } }));
    },
    cleanError: (state) => (Object.assign(Object.assign({}, state), { error: undefined })),
    cleanSlackData: (state) => (Object.assign(Object.assign({}, state), { slackChannels: { isLoading: false } })),
    postWebhookRetryAction: {
        prepare: (logId) => ({ payload: logId }),
        reducer: (state, { payload }) => (Object.assign(Object.assign({}, state), { retryResult: Object.assign(Object.assign({}, state.retryResult), { [payload]: { isProcess: true, success: false } }) })),
    },
    postWebhookRetryResult: {
        prepare: (payload) => ({ payload }),
        reducer: (state, { payload }) => (Object.assign(Object.assign({}, state), { retryResult: Object.assign(Object.assign({}, state.retryResult), payload) })),
    },
};
const connectivity_actions$1 = {
    loadSlackActions: createAction(`${connectivityStoreName}/loadSlackActions`),
    loadDataAction: createAction(`${connectivityStoreName}/loadDataAction`, (payload) => ({
        payload,
    })),
    postDataAction: createAction(`${connectivityStoreName}/postDataAction`, (payload) => ({
        payload,
    })),
    postCodeAction: createAction(`${connectivityStoreName}/postCodeAction`, (payload) => ({ payload })),
    loadScope: createAction(`${connectivityStoreName}/loadScope`),
    deleteWebhookConfigAction: createAction(`${connectivityStoreName}/deleteWebhookConfigAction`, (payload) => ({
        payload,
    })),
    postWebhookTestAction: createAction(`${connectivityStoreName}/postWebhookTestAction`, (payload) => ({
        payload,
    })),
    loadWebhookLogsAction: createAction(`${connectivityStoreName}/loadWebhookLogsAction`, (id, offset = 0, limit = 10) => ({ payload: { id, offset, limit } })),
};

const connectivity_initialState = {
    isLoading: false,
    isSaving: false,
    list: [],
    processIds: [],
    slackChannels: {
        isLoading: false,
    },
};
const { reducer: connectivity_reducer, actions: connectivity_sliceActions } = createSlice({
    name: connectivityStoreName,
    initialState: connectivity_initialState,
    reducers: Object.assign({}, connectivity_reducers),
});
const connectivity_actions = Object.assign(Object.assign({}, connectivity_sliceActions), connectivity_actions$1);

const type2ApiGet = {
    slack: umd.api.connectivity.getSlackConfiguration,
    email: umd.api.connectivity.getEmailConfiguration,
    sms: umd.api.connectivity.getSMSConfiguration,
    webhook: umd.api.connectivity.getWebhooksConfigurations,
    categories: umd.api.connectivity.getCategories,
    channelMap: umd.api.connectivity.getChannelMaps,
};
const type2ApiPost = {
    slack: umd.api.connectivity.postSlackConfiguration,
    email: umd.api.connectivity.postEmailConfiguration,
    sms: umd.api.connectivity.postSMSConfiguration,
    webhook: umd.api.connectivity.postWebhooksConfiguration,
};
const channels = ['email', 'slack', 'sms', 'webhook'];
const channels2Platform = {
    sms: {
        title: 'connectivity.sms',
        events: (data) => { var _a; return ((_a = data) === null || _a === void 0 ? void 0 : _a.length) || 0; },
        isActive: (data) => { var _a, _b; return (_b = (_a = data) === null || _a === void 0 ? void 0 : _a.some(({ enabled }) => enabled)) !== null && _b !== void 0 ? _b : false; },
        image: 'sms',
    },
    email: {
        title: 'common.email',
        events: (data) => { var _a; return ((_a = data) === null || _a === void 0 ? void 0 : _a.length) || 0; },
        isActive: (data) => { var _a, _b; return (_b = (_a = data) === null || _a === void 0 ? void 0 : _a.some(({ enabled }) => enabled)) !== null && _b !== void 0 ? _b : false; },
        image: 'email',
    },
    slack: {
        title: 'connectivity.slack',
        events: (data) => { var _a, _b; return ((_b = (_a = data) === null || _a === void 0 ? void 0 : _a.slackSubscriptions) === null || _b === void 0 ? void 0 : _b.length) || 0; },
        isActive: (data) => { var _a, _b; return (_b = !!((_a = data) === null || _a === void 0 ? void 0 : _a.slackSubscriptions.some(({ isActive }) => isActive))) !== null && _b !== void 0 ? _b : false; },
        image: 'slack',
    },
    webhook: {
        title: 'connectivity.webhook',
        events: (data) => { var _a; return ((_a = data) === null || _a === void 0 ? void 0 : _a.length) || 0; },
        isActive: (data) => { var _a, _b; return (_b = (_a = data) === null || _a === void 0 ? void 0 : _a.some(({ isActive }) => isActive)) !== null && _b !== void 0 ? _b : false; },
        image: 'webhook',
    },
};

const addApi = ['categories', 'channelMap'];
function* loadPlatromData(ch) {
    return yield loadFunction({ payload: { api: ch }, type: '' });
}
function* loadDataFunction({ payload = channels }) {
    yield put(connectivity_actions.setConnectivityState({ isLoading: true }));
    try {
        const values = yield io_c3792963_all([
            ...payload.map(loadPlatromData),
            yield loadFunction({ payload: { api: 'categories' }, type: '' }),
            yield (function* () {
                const res = yield io_c3792963_all(payload.map(function* (ch) {
                    return yield loadFunction({ payload: { api: 'channelMap', params: ch }, type: '' });
                }));
                return res.reduce((acc, curr, idx) => (Object.assign(Object.assign({}, acc), { [`${payload[idx]}`]: curr })), {});
            })(),
        ]);
        const webhooks = yield loadFunction({ payload: { api: 'webhook' }, type: '' });
        const data = values.reduce((acc, curr, idx) => payload[idx]
            ? values[values.length - 1][payload[idx]].length
                ? Object.assign(Object.assign({}, acc), { [`${payload[idx]}`]: curr, list: [
                        ...acc.list,
                        {
                            id: idx,
                            key: payload[idx],
                            events: channels2Platform[payload[idx]].events(curr),
                            active: channels2Platform[payload[idx]].isActive(curr),
                            platform: channels2Platform[payload[idx]].title,
                            image: channels2Platform[payload[idx]].image,
                        },
                    ] }) : acc
            : Object.assign(Object.assign({}, acc), { [`${addApi[idx - payload.length]}`]: curr }), { list: [], webhook: webhooks });
        yield put(connectivity_actions.setConnectivityState(Object.assign(Object.assign({}, data), { error: undefined, isSaving: false, isLoading: false })));
    }
    catch (e) {
        yield put(connectivity_actions.setConnectivityState({ isLoading: false }));
    }
}
function* loadFunction({ payload: { api, params }, }) {
    try {
        return yield call(type2ApiGet[api], params);
    }
    catch (e) {
        return undefined;
    }
}
function* loadSlackFunction() {
    try {
        yield put(connectivity_actions.setConnectivityState({ slackChannels: { isLoading: true } }));
        const data = yield call(umd.api.connectivity.getSlackChannels);
        yield put(connectivity_actions.setConnectivityState({ error: undefined, slackChannels: { isLoading: false, data } }));
    }
    catch (e) {
        yield put(connectivity_actions.setConnectivityState({ error: undefined, slackChannels: { isLoading: false } }));
    }
}
function* checkNewStatus(platform, data) {
    const { connectivity: { list }, } = yield io_c3792963_select();
    const currPlatform = list.find(({ key }) => key === platform);
    if (!currPlatform)
        return;
    const newActive = channels2Platform[platform].isActive(data);
    if (newActive === currPlatform.active)
        return;
    //TODO: double check
    yield put(connectivity_actions.setConnectivityState({
        list: list.map((elm) => (elm.key === platform ? Object.assign(Object.assign({}, elm), { active: newActive }) : elm)),
    }));
}
function* postDataFunction({ payload: { platform, data, callback }, }) {
    var _a;
    const { processIds } = yield io_c3792963_select((state) => state.connectivity);
    try {
        yield put(connectivity_actions.setConnectivityState({
            isSaving: true,
            //@ts-ignore
            processIds: platform === 'webhook' ? [data._id, ...processIds] : processIds,
        }));
        if (platform === 'slack') {
            yield postSlackData({ payload: data, type: '' });
        }
        else if (['sms', 'email'].includes(platform)) {
            yield postEmailSMSData({ payload: data, type: platform });
        }
        else {
            yield call(type2ApiPost[platform], data);
        }
        if (!['sms', 'email'].includes(platform)) {
            const newData = yield loadFunction({ payload: { api: platform }, type: '' });
            if (platform === 'webhook') {
                newData.id = data._id;
            }
            yield put(connectivity_actions.setConnectivityState({
                error: undefined,
                isSaving: false,
                [`${platform}`]: newData,
                processIds: newData.id ? processIds.filter((el) => el !== newData.id) : processIds,
            }));
            yield checkNewStatus(platform, newData);
            callback === null || callback === void 0 ? void 0 : callback(true);
        }
    }
    catch (e) {
        yield put(connectivity_actions.setConnectivityState({ error: (_a = e.message) !== null && _a !== void 0 ? _a : e.toString(), isSaving: false, isLoading: false }));
    }
}
function* postSlackData({ payload }) {
    const { connectivity: { slack }, } = yield io_c3792963_select();
    if (!slack) {
        return;
    }
    const { slackSubscriptions: stateSlackSubscriptions } = slack;
    const { slackSubscriptions } = payload;
    yield io_c3792963_all([
        ...slackSubscriptions
            .reduce((acc, curr) => {
            var _a, _b;
            if (!curr.id && curr.slackEvents && ((_a = curr.slackEvents[0].channelIds) === null || _a === void 0 ? void 0 : _a.length)) {
                return [...acc, curr];
            }
            const el = stateSlackSubscriptions === null || stateSlackSubscriptions === void 0 ? void 0 : stateSlackSubscriptions.find((_a) => {
                var { id } = _a, props = (0,tslib_es6.__rest)(_a, ["id"]);
                return id === curr.id && JSON.stringify(Object.assign({ id }, props)) !== JSON.stringify(curr);
            });
            if (el && curr.slackEvents && ((_b = curr.slackEvents[0].channelIds) === null || _b === void 0 ? void 0 : _b.length)) {
                return [...acc, curr];
            }
            return acc;
        }, [])
            .map(function* (el) {
            return yield call(type2ApiPost.slack, el);
        }),
        ...slackSubscriptions
            .reduce((acc, curr) => {
            if (curr.id && !curr.slackEvents[0].channelIds.length) {
                return [...acc, curr];
            }
            return acc;
        }, [])
            .map(function* (el) {
            return yield call(umd.api.connectivity.deleteSlackConfiguration, el);
        }),
    ]);
}
function* postEmailSMSData({ payload, type }) {
    const { connectivity } = yield io_c3792963_select();
    const { processIds } = yield io_c3792963_select((state) => state.connectivity);
    const stateData = connectivity[type];
    if (!stateData)
        return;
    let actionsResult = [];
    try {
        actionsResult = yield io_c3792963_all([
            // create new
            ...payload
                .reduce((acc, curr) => {
                const state = stateData.find(({ eventKey }) => eventKey === curr.eventKey);
                if (!state && curr.subscriptions[0].recipients.filter((el) => el).length) {
                    return [...acc, curr];
                }
                return acc;
            }, [])
                .map(function* (data) {
                return yield call(type === 'email' ? umd.api.connectivity.postEmailConfiguration : umd.api.connectivity.postSMSConfiguration, data);
            }),
            // update exists
            ...payload
                .reduce((acc, curr) => {
                const state = stateData.find(({ eventKey }) => eventKey === curr.eventKey);
                if (state && JSON.stringify(state) !== JSON.stringify(curr)) {
                    return [...acc, curr];
                }
                return acc;
            }, [])
                .map(function* (data) {
                const { subscriptions, eventKey } = data;
                const _a = subscriptions[0], { id = '', enabled } = _a, body = (0,tslib_es6.__rest)(_a, ["id", "enabled"]);
                return yield io_c3792963_all([
                    yield call(type === 'email' ? umd.api.connectivity.patchEmailConfiguration : umd.api.connectivity.patchSMSConfiguration, { eventKey, enabled }),
                    yield call(type === 'email' ? umd.api.connectivity.putEmailSubscriptions : umd.api.connectivity.putSMSSubscriptions, id, eventKey, Object.assign(Object.assign({}, body), { enabled })),
                ]);
            }),
            // delete record with empty recipients
            ...payload
                .reduce((acc, curr) => {
                const state = stateData.find(({ eventKey }) => eventKey === curr.eventKey);
                if (state &&
                    state.subscriptions[0].recipients.length &&
                    !curr.subscriptions[0].recipients.filter((el) => !!el).length) {
                    return [...acc, curr];
                }
                return acc;
            }, [])
                .map(function* ({ eventKey, subscriptions }) {
                return call(type === 'email' ? umd.api.connectivity.deleteEmailSubscriptions : umd.api.connectivity.deleteSMSSubscriptions, eventKey, subscriptions[0].id || '');
            }),
        ]);
    }
    catch (_a) {
    }
    if (actionsResult.length) {
        const newData = yield loadFunction({ payload: { api: type }, type: '' });
        // yield put(connectivityActions.postDataSuccess({ platform: type, data: newData }));
        yield put(connectivity_actions.setConnectivityState({
            error: undefined,
            isSaving: false,
            [`${type}`]: newData,
            processIds: newData.id ? processIds.filter((el) => el !== newData.id) : processIds,
        }));
        yield checkNewStatus(type, newData);
    }
    else {
        // yield put(connectivityActions.postDataSuccess({ platform: type, data: stateData }));
        yield put(connectivity_actions.setConnectivityState({
            error: undefined,
            isSaving: false,
            [`${type}`]: stateData,
            processIds: processIds,
        }));
    }
}
function* postCodeFunction({ payload }) {
    try {
        yield umd.api.connectivity.postSlackCode(payload);
    }
    catch (_a) {
    }
    // yield put(connectivityActions.postCodeSuccess());
    yield put(connectivity_actions.setConnectivityState({ error: undefined, isSaving: false }));
}
function* loadSlackPermissions() {
    const { slackChannels } = yield io_c3792963_select((state) => state.connectivity);
    try {
        yield put(connectivity_actions.setConnectivityState({ slackChannels: Object.assign(Object.assign({}, slackChannels), { isLoadingScope: true }) }));
        const { clientId } = yield call(umd.api.connectivity.getSlackScope);
        // yield put(connectivityActions.loadScopeSuccess(clientId));
        yield put(connectivity_actions.setConnectivityState({
            slackChannels: { error: undefined, clientId, isLoadingScope: false, isLoading: false },
        }));
    }
    catch (_a) {
        // yield put(connectivityActions.loadScopeSuccess(null));
        yield put(connectivity_actions.setConnectivityState({
            slackChannels: { error: undefined, isLoadingScope: false, isLoading: false },
        }));
    }
}
function* deleteWebhookConfigFunction({ payload }) {
    const { callback, webhookId } = payload;
    const { processIds } = yield io_c3792963_select((state) => state.connectivity);
    try {
        yield put(connectivity_actions.setConnectivityState({ isSaving: true }));
        yield call(umd.api.connectivity.deleteWebhooksConfiguration, webhookId);
    }
    catch (e) {
        callback === null || callback === void 0 ? void 0 : callback(null, e.message);
    }
    const newData = yield loadFunction({ payload: { api: 'webhook' }, type: '' });
    if (newData) {
        yield put(connectivity_actions.setConnectivityState({
            error: undefined,
            isSaving: false,
            webhook: newData,
            processIds: newData.id ? processIds.filter((el) => el !== newData.id) : processIds,
        }));
    }
    callback === null || callback === void 0 ? void 0 : callback(true);
}
function* postWebhookTestFunction({ payload }) {
    try {
        yield put(connectivity_actions.setConnectivityState({ isTesting: true }));
        const { statusCode, body } = yield call(umd.api.connectivity.postWebhookTest, payload);
        if ([201, 200].includes(statusCode)) {
            // yield put(connectivityActions.postWebhookTestSuccess('success', JSON.stringify(body, null, 2)));
            const message = JSON.stringify(body, null, 2);
            yield put(connectivity_actions.setConnectivityState({ isTesting: false, testResult: { status: 'success', message } }));
        }
        else {
            // yield put(connectivityActions.postWebhookTestSuccess('failed', body.toString()));
            yield put(connectivity_actions.setConnectivityState({ isTesting: false, testResult: { status: 'failed' } }));
        }
    }
    catch (e) {
        // yield put(connectivityActions.postWebhookTestSuccess('failed', e.toString()));
        yield put(connectivity_actions.setConnectivityState({
            isTesting: false,
            testResult: { status: 'failed', message: e.toString() },
        }));
    }
}
function* postWebhookRetryFunction({ payload }) {
    try {
        const { statusCode } = yield call(umd.api.connectivity.postWebhookRetry, payload);
        yield put(connectivity_actions.postWebhookRetryResult({
            [payload]: { isProcess: false, success: statusCode === 202 },
        }));
    }
    catch (e) {
        yield put(connectivity_actions.postWebhookRetryResult({
            [payload]: { isProcess: false, success: false },
        }));
    }
}
function* loadWebhookLogsFunction({ payload: { id, limit, offset }, }) {
    const { webhookLogs } = yield io_c3792963_select((state) => state.connectivity);
    try {
        yield put(connectivity_actions.setConnectivityState({ webhookLogs: Object.assign(Object.assign({}, webhookLogs), { isLoading: true }) }));
        //TODO: Fix types
        //@ts-ignore
        const data = yield call(umd.api.connectivity.getWebhookLog, id, offset, limit);
        // yield put(connectivityActions.loadWebhookLogsSuccess(data));
        yield put(connectivity_actions.setConnectivityState({ error: undefined, webhookLogs: Object.assign({ isLoading: false }, data) }));
    }
    catch (e) {
        yield put(connectivity_actions.setConnectivityState({ error: undefined, webhookLogs: { isLoading: false } }));
    }
}
function* connectivity_sagas() {
    yield takeEvery$1(connectivity_actions.loadDataAction, loadDataFunction);
    yield takeLatest$1(connectivity_actions.loadSlackActions, loadSlackFunction);
    yield takeEvery$1(connectivity_actions.postDataAction, postDataFunction);
    yield takeEvery$1(connectivity_actions.postCodeAction, postCodeFunction);
    yield takeEvery$1(connectivity_actions.loadScope, loadSlackPermissions);
    yield takeEvery$1(connectivity_actions.deleteWebhookConfigAction, deleteWebhookConfigFunction);
    yield takeEvery$1(connectivity_actions.postWebhookTestAction, postWebhookTestFunction);
    yield takeEvery$1(connectivity_actions.postWebhookRetryAction, postWebhookRetryFunction);
    yield takeLatest$1(connectivity_actions.loadWebhookLogsAction, loadWebhookLogsFunction);
}

// export store
var connectivityStore = {
    sagas: connectivity_sagas,
    storeName: connectivityStoreName,
    initialState: connectivity_initialState,
    reducer: connectivity_reducer,
    actions: connectivity_actions,
};



;// CONCATENATED MODULE: ./node_modules/@frontegg/redux-store/subscriptions/index.js






function createModuleCaseReducers() {
    return {
        setLoading: {
            prepare: (payload) => ({ payload }),
            reducer: (state, action) => (Object.assign(Object.assign(Object.assign({}, state), { loading: action.payload }), (action.payload ? { error: null } : {}))),
        },
        setError: {
            prepare: (payload) => ({ payload }),
            reducer: (state, action) => (Object.assign(Object.assign({}, state), { error: action.payload, loading: false, fetching: false })),
        },
        setState: {
            prepare: (payload) => ({ payload }),
            reducer: (state, action) => (Object.assign(Object.assign({}, state), action.payload)),
        },
    };
}
function createKeyCaseReducer(key, setState) {
    return {
        prepare: (payload) => ({ payload }),
        reducer: (state, action) => (Object.assign(Object.assign({}, state), { [key]: setState(state[key], action) })),
    };
}
function createKeyCaseLoadingReducer(key) {
    return createKeyCaseReducer(key, (state, action) => (Object.assign(Object.assign({}, state), { loading: action.payload })));
}
function createKeyCaseErrorReducer(key) {
    return createKeyCaseReducer(key, (state, action) => (Object.assign(Object.assign({}, state), { error: action.payload, loading: false })));
}

const plansInitialState = {
    loading: false,
    error: null,
    fetching: true,
    plans: [],
};
const { actions: sliceActions$1, reducer: reducer$8, name: name$7 } = createSlice({
    name: `${subscriptionsStoreName}/plans`,
    initialState: plansInitialState,
    reducers: Object.assign({}, createModuleCaseReducers()),
});
const subscriptions_actions$8 = Object.assign({ loadPlans: createAction(`${name$7}/loadPlans`) }, sliceActions$1);

const configInitialState = {
    loading: false,
    error: null,
    fetching: true,
    config: null,
};
const subscriptions_reducers$6 = Object.assign({}, createModuleCaseReducers());
const { actions: configActions, reducer: reducer$7, name: name$6, } = createSlice({
    name: `${subscriptionsStoreName}/config`,
    initialState: configInitialState,
    reducers: subscriptions_reducers$6,
});
const subscriptions_actions$7 = Object.assign({ loadPaymentConfiguration: createAction(`${name$6}/loadPaymentConfiguration`) }, configActions);

const initialSubscriptionState = {
    loading: false,
    error: null,
    fetching: true,
    cancellation: {
        loading: false,
        error: null,
    },
    renewal: {
        loading: false,
        error: null,
    },
};
const subscriptions_reducers$5 = Object.assign(Object.assign({}, createModuleCaseReducers()), { setCancellationLoading: createKeyCaseLoadingReducer('cancellation'), setCancellationError: createKeyCaseErrorReducer('cancellation'), setRenewalLoading: createKeyCaseLoadingReducer('renewal'), setRenewalError: createKeyCaseErrorReducer('renewal') });
const { reducer: reducer$6, actions: overviewActions$1, name: name$5, } = createSlice({
    name: `${subscriptionsStoreName}/billing/subscription`,
    initialState: initialSubscriptionState,
    reducers: subscriptions_reducers$5,
});
const subscriptions_actions$6 = Object.assign({ load: createAction(`${name$5}/loadSubscription`), cancelSubscription: createAction(`${name$5}/cancelSubscription`), renewSubscription: createAction(`${name$5}/renewSubscription`) }, overviewActions$1);

const initialBillingInformationState = {
    loading: false,
    error: null,
    fetching: true,
};
const subscriptions_reducers$4 = Object.assign({}, createModuleCaseReducers());
const { reducer: reducer$5, actions: overviewActions, name: name$4, } = createSlice({
    name: `${subscriptionsStoreName}/billing/information`,
    initialState: initialBillingInformationState,
    reducers: subscriptions_reducers$4,
});
const subscriptions_actions$5 = Object.assign({ loadBillingInformation: createAction(`${name$4}/loadBillingInformation`), cancelSubscription: subscriptions_actions$6.cancelSubscription, renewSubscription: subscriptions_actions$6.renewSubscription }, overviewActions);

const initialPaymentMethodState = {
    loading: false,
    error: null,
    fetching: true,
};
const subscriptions_reducers$3 = Object.assign(Object.assign({}, createModuleCaseReducers()), { setState: {
        prepare: (payload) => ({ payload }),
        reducer: (state, action) => (Object.assign(Object.assign({}, state), action.payload)),
    } });
const { reducer: reducer$4, actions: paymentActions, name: name$3, } = createSlice({
    name: `${subscriptionsStoreName}/billing/payment`,
    initialState: initialPaymentMethodState,
    reducers: subscriptions_reducers$3,
});
const subscriptions_actions$4 = Object.assign({ loadPaymentMethod: createAction(`${name$3}/loadPaymentMethod`), submitPaymentMethod: createAction(`${name$3}/submitPaymentMethod`), submitPaymentMethodError: createAction(`${name$3}/submitPaymentMethodError`), submitPaymentMethodSuccess: createAction(`${name$3}/submitPaymentMethodSuccess`), updatePaymentMethodBillingDetails: createAction(`${name$3}/updateBillingDetails`, (payload) => ({ payload })) }, paymentActions);

const initialInvoicesState = {
    loading: false,
    error: null,
    fetching: true,
    invoices: [],
    invoiceDownload: {
        loading: false,
        error: null
    }
};
const subscriptions_reducers$2 = Object.assign(Object.assign({}, createModuleCaseReducers()), { setInvoiceDownloadState: {
        prepare: (payload) => ({ payload }),
        reducer: (state, action) => (Object.assign(Object.assign({}, state), { invoiceDownload: Object.assign(Object.assign({}, state.invoiceDownload), action.payload) })),
    } });
const { reducer: reducer$3, actions: subscriptions_sliceActions, name: name$2, } = createSlice({
    name: `${subscriptionsStoreName}/billing/invoices`,
    initialState: initialInvoicesState,
    reducers: subscriptions_reducers$2,
});
const subscriptions_actions$3 = Object.assign({ loadInvoices: createAction(`${name$2}/loadInvoices`), downloadInvoice: createAction(`${name$2}/downloadInvoice`, (payload) => ({ payload })) }, subscriptions_sliceActions);

const billingInitialState = {
    information: initialBillingInformationState,
    invoices: initialInvoicesState,
    paymentMethod: initialPaymentMethodState,
    subscription: initialSubscriptionState,
};
const billingActions = {
    invoices: subscriptions_actions$3,
    information: subscriptions_actions$5,
    paymentMethod: subscriptions_actions$4,
    subscription: subscriptions_actions$6,
};
const billingReducer = combineReducers({
    invoices: reducer$3,
    information: reducer$5,
    paymentMethod: reducer$4,
    subscription: reducer$6,
});

const checkoutInitialState = {
    fetching: true,
    loading: false,
    error: null,
    confirmed: false,
};
const subscriptions_reducers$1 = Object.assign({}, createModuleCaseReducers());
const { actions: checkoutActions, reducer: reducer$2, name: name$1 } = createSlice({
    name: `${subscriptionsStoreName}/checkout`,
    initialState: checkoutInitialState,
    reducers: subscriptions_reducers$1,
});
const subscriptions_actions$2 = Object.assign({ loadCheckout: createAction(`${name$1}/loadCheckout`), resetCheckout: createAction(`${name$1}/resetCheckout`), submitCheckout: createAction(`${name$1}/submitCheckout`), confirmCheckout: createAction(`${name$1}/confirmCheckout`, (payload) => ({ payload })), errorCheckout: createAction(`${name$1}/errorCheckout`, (payload) => ({ payload })) }, checkoutActions);

const initialSubscriptionStripeState = {
    loading: false,
    error: null,
    cardSetupIntentSecret: null,
};
const subscriptions_reducers = Object.assign({}, createModuleCaseReducers());
const { reducer: reducer$1, actions: reducerActions, name: subscriptions_name, } = createSlice({
    name: `${subscriptionsStoreName}/stripe`,
    initialState: initialSubscriptionStripeState,
    reducers: subscriptions_reducers,
});
const subscriptions_actions$1 = Object.assign({ loadCustomer: createAction(`${subscriptions_name}/loadCustomer`), createCardSetupIntentSecret: createAction(`${subscriptions_name}/createCardSetupIntentSecret`) }, reducerActions);

const subscriptions_initialState = {
    config: configInitialState,
    plans: plansInitialState,
    checkout: checkoutInitialState,
    billing: billingInitialState,
    stripe: initialSubscriptionStripeState,
};
const subscriptions_actions = {
    config: subscriptions_actions$7,
    billing: billingActions,
    plans: subscriptions_actions$8,
    checkout: subscriptions_actions$2,
    stripe: subscriptions_actions$1,
};
const subscriptions_reducer = combineReducers({
    config: reducer$7,
    billing: billingReducer,
    plans: reducer$8,
    checkout: reducer$2,
    stripe: reducer$1,
});

var PaymentProvider;
(function (PaymentProvider) {
    PaymentProvider["STRIPE"] = "Stripe";
})(PaymentProvider || (PaymentProvider = {}));
var SubscriptionStatus;
(function (SubscriptionStatus) {
    SubscriptionStatus["ACTIVE"] = "ACTIVE";
    SubscriptionStatus["CANCELED"] = "CANCELED";
    SubscriptionStatus["INCOMPLETE"] = "INCOMPLETE";
    SubscriptionStatus["EXPIRED"] = "EXPIRED";
    SubscriptionStatus["TRIALING"] = "TRIALING";
})(SubscriptionStatus || (SubscriptionStatus = {}));
var SubscriptionCancellationPolicy;
(function (SubscriptionCancellationPolicy) {
    SubscriptionCancellationPolicy["AT_PERIOD_END"] = "atPeriodEnd";
})(SubscriptionCancellationPolicy || (SubscriptionCancellationPolicy = {}));

function toSubscriptionCancellation({ policy }) {
    return {
        policy: toSubscriptionCancellationPolicy(),
    };
}
function toSubscriptionCancellationPolicy(policy) {
    return SubscriptionCancellationPolicy.AT_PERIOD_END;
}
function toSubscriptionStatus(status) {
    switch (status) {
        case umd.ISubscriptionStatus.ACTIVE:
            return SubscriptionStatus.ACTIVE;
        case umd.ISubscriptionStatus.INCOMPLETE:
            return SubscriptionStatus.INCOMPLETE;
        case umd.ISubscriptionStatus.CANCELED:
            return SubscriptionStatus.CANCELED;
        case umd.ISubscriptionStatus.EXPIRED:
            return SubscriptionStatus.EXPIRED;
        case umd.ISubscriptionStatus.TRIALING:
            return SubscriptionStatus.TRIALING;
        default:
            return SubscriptionStatus.EXPIRED;
    }
}

const subscriptionResponseMock = {
    id: 'sub_1JbhYVEwsu4qiqnnfMhYAdY6',
    externalId: 'sub_1JbhYVEwsu4qiqnnfMhYAdY6',
    startDate: '2021-09-20T08:08:51.000Z',
    status: umd.ISubscriptionStatus.ACTIVE,
    externallyManaged: false,
    cancellation: null,
    currentPeriodStart: '2021-09-20T08:08:51.000Z',
    currentPeriodEnd: '2021-10-20T08:08:51.000Z',
    plan: {
        // TODO: fix dummy data
        slug: 'test'
    }
    // items: [
    //   {
    //     id: 'si_KGE0p5himocPXH',
    //     externalId: 'prod_J60fUEvI7qV1eL',
    //     planId: 'prod_J60fUEvI7qV1eL',
    //     price: {
    //       id: 'price_1IToe8Ewsu4qiqnndAV76J69',
    //       externalId: 'price_1IToe8Ewsu4qiqnndAV76J69',
    //       currency: 'usd',
    //       amount: 10000,
    //     },
    //   },
    // ],
};
const planResponseMock = [
    {
        id: 'prod_J60fUEvI7qV1eL',
        externalId: 'prod_J60fUEvI7qV1eL',
        name: 'Premium',
        description: '',
        price: {
            id: 'price_1IToe8Ewsu4qiqnndAV76J69',
            externalId: 'price_1IToe8Ewsu4qiqnndAV76J69',
            currency: 'usd',
            amount: 10000,
        },
        slug: 'premium',
    },
    {
        id: 'prod_J60duauCpXfcur',
        externalId: 'prod_J60duauCpXfcur',
        name: 'Free',
        description: 'Totally free plan. Nothing to pay.',
        price: {
            id: 'price_1ITocfEwsu4qiqnnnBHDx9fQ',
            externalId: 'price_1ITocfEwsu4qiqnnnBHDx9fQ',
            currency: 'usd',
            amount: 0,
        },
        slug: 'free',
    },
];
const invoicesMock = [
    {
        id: 'in_1JbhYWEwsu4qiqnnrUh6hsHa',
        externalId: 'in_1JbhYWEwsu4qiqnnrUh6hsHa',
        subscriptionId: 'sub_1JbhYVEwsu4qiqnnfMhYAdY6',
        paymentDate: '2021-09-20T08:08:51.000Z',
        totalAmount: 10000,
        currency: 'usd',
        paid: true,
        receiptNumber: '',
    },
    {
        id: 'in_1JbhYWEwsu4qiqnnrUh6hsHa',
        externalId: 'in_1JbhYWEwsu4qiqnnrUh6hsHa',
        subscriptionId: 'sub_1JbhYVEwsu4qiqnnfMhYAdY6',
        paymentDate: '2021-08-20T08:08:51.000Z',
        totalAmount: 10000,
        currency: 'usd',
        paid: true,
        receiptNumber: '',
    },
];
const paymentMethodsMock = [
    {
        id: 'id',
        externalId: 'externalId',
        type: umd.PaymentMethodType.CARD,
        isDefault: true,
        last4: '4242',
        expMonth: 11,
        expYear: 25,
        brand: 'visa',
        billingDetails: {
            name: 'Dummy',
            email: 'dummy@email.com',
        },
    },
];

function* subscriptionSagas() {
    yield takeEvery$1(subscriptions_actions$6.load, loadSubscriptionTenant);
    yield takeEvery$1(subscriptions_actions$6.cancelSubscription, cancelSubscription);
    yield takeEvery$1(subscriptions_actions$6.renewSubscription, renewSubscription);
}
function* loadSubscriptionTenant() {
    const tenantId = yield io_c3792963_select((state) => { var _a, _b; return (_b = (_a = state.auth) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.tenantId; });
    yield loadSummaries(tenantId);
}
function* loadSubscription() {
    yield put(subscriptions_actions$6.setLoading(true));
    try {
        const [subscription] = yield call(umd.api.subscriptions.getManagedSubscriptions);
        yield put(subscriptions_actions$6.setState({
            subscription,
            fetching: false,
            loading: false,
            error: null,
        }));
    }
    catch (e) {
        yield put(subscriptions_actions$6.setError(e));
    }
}
function* cancelSubscription() {
    const { subscription } = yield io_c3792963_select((state) => state.subscriptions.billing.subscription);
    if (!subscription) {
        yield put(subscriptions_actions$6.setCancellationError('Subscription not found.'));
        return;
    }
    if (subscription === null || subscription === void 0 ? void 0 : subscription.externallyManaged) {
        yield put(subscriptions_actions$6.setCancellationError('Billing is externally managed.'));
        return;
    }
    const { id: subscriptionId, cancellation, status } = subscription || {};
    const isCancellable = !cancellation && status === umd.ISubscriptionStatus.ACTIVE;
    if (isCancellable) {
        try {
            yield put(subscriptions_actions$6.setCancellationLoading(true));
            yield call(umd.api.subscriptions.cancelManagedSubscription, subscriptionId);
            yield loadSubscription();
            yield put(subscriptions_actions$6.setCancellationLoading(false));
        }
        catch (e) {
            yield put(subscriptions_actions$6.setCancellationError(e.message));
        }
    }
}
function* renewSubscription() {
    const { subscription } = yield io_c3792963_select((state) => state.subscriptions.billing.subscription);
    if (!subscription) {
        yield put(subscriptions_actions$6.setCancellationError('Subscription not found.'));
        return;
    }
    if (subscription === null || subscription === void 0 ? void 0 : subscription.externallyManaged) {
        yield put(subscriptions_actions$6.setCancellationError('Billing is externally managed'));
        return;
    }
    const { id: subscriptionId, cancellation } = subscription || {};
    const renewable = (cancellation === null || cancellation === void 0 ? void 0 : cancellation.policy) === umd.ISubscriptionCancellationPolicy.AT_PERIOD_END;
    if (renewable) {
        try {
            yield put(subscriptions_actions$6.setRenewalLoading(true));
            yield call(umd.api.subscriptions.renewManagedSubscription, subscriptionId);
            yield loadSubscription();
            yield put(subscriptions_actions$6.setRenewalLoading(false));
        }
        catch (e) {
            yield put(subscriptions_actions$6.setCancellationError(e.message));
        }
    }
}
/*********************************
 *  Preview Sagas
 *********************************/
function* loadMock() {
    yield put(subscriptions_actions$6.setLoading(true));
    yield io_c3792963_delay(500);
    yield put(subscriptions_actions$6.setState({
        subscription: subscriptionResponseMock,
        fetching: false,
        loading: false,
        error: null,
    }));
}
function* subscriptionSagasMock() {
    yield takeEvery$1(subscriptions_actions$6.load, loadMock);
}

function* subscriptionBillingInformationSagas() {
    yield takeEvery$1(subscriptions_actions$5.loadBillingInformation, loadBillingInformation);
}
function* loadBillingInformation() {
    yield loadBillingInformationAction(false);
}
function* loadBillingInformationAction(forceActive) {
    const paymentProvider = yield io_c3792963_select((state) => { var _a; return (_a = state.subscriptions.config.config) === null || _a === void 0 ? void 0 : _a.paymentProvider; });
    const tenantId = yield io_c3792963_select((state) => { var _a, _b; return (_b = (_a = state.auth) === null || _a === void 0 ? void 0 : _a.user) === null || _b === void 0 ? void 0 : _b.tenantId; });
    if (!paymentProvider || !tenantId) {
        yield put(subscriptions_actions$5.setError(!paymentProvider ? 'Internal feature failure' : 'Not authorized'));
        return;
    }
    yield loadSummaries(tenantId, forceActive);
}
function* loadSummaries(tenantId, forceActive) {
    var _a, _b;
    yield put(subscriptions_actions$5.setLoading(true));
    try {
        const summary = yield call(umd.api.subscriptions.getSubscriptionSummaries, tenantId);
        const { currentPlanId, externallyManaged } = summary;
        let subscriptionResponse = null;
        let planResponse;
        if (!externallyManaged) {
            [, planResponse] = yield io_c3792963_all([
                yield loadSubscription(),
                call(umd.api.subscriptions.getSubscriptionPlan, currentPlanId),
            ]);
            subscriptionResponse = yield io_c3792963_select((state) => state.subscriptions.billing.subscription.subscription || null);
        }
        else {
            planResponse = yield call(umd.api.subscriptions.getSubscriptionPlan, currentPlanId);
        }
        yield put(subscriptions_actions$5.setState(Object.assign(Object.assign({ loading: false, fetching: false, summary }, (subscriptionResponse
            ? {
                subscription: {
                    id: subscriptionResponse.id,
                    externalId: subscriptionResponse.externalId,
                    startDate: subscriptionResponse.startDate,
                    currentPeriodStart: subscriptionResponse.currentPeriodStart,
                    currentPeriodEnd: subscriptionResponse.currentPeriodEnd,
                    status: forceActive ? SubscriptionStatus.ACTIVE : toSubscriptionStatus(subscriptionResponse.status),
                    cancellation: subscriptionResponse.cancellation && toSubscriptionCancellation(subscriptionResponse.cancellation),
                    trialEnd: subscriptionResponse.trialEnd ? subscriptionResponse.trialEnd : null,
                },
            }
            : {})), (planResponse
            ? {
                plan: {
                    id: planResponse.id,
                    name: planResponse.name,
                    description: planResponse.description,
                    price: ((_a = planResponse.price) === null || _a === void 0 ? void 0 : _a.amount) || 0,
                    currency: ((_b = planResponse.price) === null || _b === void 0 ? void 0 : _b.currency) || 'usd',
                    recurringInterval: 'month',
                    slug: planResponse.slug,
                },
            }
            : {}))));
    }
    catch (e) {
        yield put(subscriptions_actions$5.setError(e.message));
    }
}
/*********************************
 *  Preview Sagas
 *********************************/
function* loadBillingInformationMock() {
    yield loadSummariesMock();
}
function* loadSummariesMock() {
    var _a, _b;
    yield put(subscriptions_actions$5.setLoading(true));
    yield io_c3792963_delay(500);
    yield put(subscriptions_actions$5.setState({
        loading: false,
        fetching: false,
        summary: {
            subscriptionId: subscriptionResponseMock.id,
            paymentMethodId: 'mockPaymentMethodId',
            tenantConfigurationId: 'mockTenantConfigurationId',
            providerType: umd.ProviderType.Stripe,
            externallyManaged: false,
            currentPlanId: planResponseMock[0].id,
            defaultPlanId: planResponseMock[0].id,
        },
        plan: Object.assign(Object.assign({}, planResponseMock[0]), { price: (_a = planResponseMock[0].price) === null || _a === void 0 ? void 0 : _a.amount, currency: (_b = planResponseMock[0].price) === null || _b === void 0 ? void 0 : _b.currency, recurringInterval: 'month' }),
    }));
}
function* subscriptionBillingInformationSagasMock() {
    yield takeEvery$1(subscriptions_actions$5.loadBillingInformation, loadBillingInformationMock);
}

function* subscriptionsPaymentMethodSagas() {
    yield takeEvery$1(subscriptions_actions$4.loadPaymentMethod, loadPaymentMethod);
    yield takeEvery$1(subscriptions_actions$4.submitPaymentMethod, submitPaymentMethod);
    yield takeEvery$1(subscriptions_actions$4.submitPaymentMethodError, submitPaymentMethodError);
    yield takeEvery$1(subscriptions_actions$4.submitPaymentMethodSuccess, submitPaymentMethodSuccess);
    yield takeEvery$1(subscriptions_actions$4.updatePaymentMethodBillingDetails, updateBillingDetails);
}
function* loadPaymentMethod() {
    yield put(subscriptions_actions$4.setLoading(true));
    try {
        const paymentMethods = yield call(umd.api.subscriptions.getPaymentMethods);
        const paymentMethod = paymentMethods[0];
        yield put(subscriptions_actions$4.setState({
            paymentMethod,
            loading: false,
            fetching: false,
        }));
    }
    catch (e) {
        yield put(subscriptions_actions$4.setError(e.message));
    }
}
function* updateBillingDetails({ payload, }) {
    yield put(subscriptions_actions$4.setLoading(true));
    const { id, email, address, callback } = payload;
    try {
        yield call(umd.api.subscriptions.updatePaymentMethodBillingDetails, id, Object.assign({ email }, address));
        yield call(loadPaymentMethod);
        callback === null || callback === void 0 ? void 0 : callback(true);
    }
    catch (e) {
        yield put(subscriptions_actions$4.setError(e.message));
        callback === null || callback === void 0 ? void 0 : callback(false);
    }
    yield put(subscriptions_actions$4.setLoading(false));
}
function* submitPaymentMethod() {
    yield put(subscriptions_actions$4.setLoading(true));
}
function* submitPaymentMethodError({ payload: error }) {
    yield put(subscriptions_actions$4.setError(error));
}
function* submitPaymentMethodSuccess() {
    yield put(subscriptions_actions$4.loadPaymentMethod());
}
/*********************************
 *  Preview Sagas
 *********************************/
function* loadPaymentMethodMock() {
    yield put(subscriptions_actions$4.setLoading(true));
    yield io_c3792963_delay(500);
    const paymentMethod = paymentMethodsMock[0];
    yield put(subscriptions_actions$4.setState({
        paymentMethod,
        loading: false,
        fetching: false,
    }));
}
function* subscriptionsPaymentMethodSagasMock() {
    yield takeEvery$1(subscriptions_actions$4.loadPaymentMethod, loadPaymentMethodMock);
}

function* subscriptionInvoicesSagas() {
    yield takeEvery$1(subscriptions_actions$3.loadInvoices, loadInvoices);
    yield takeEvery$1(subscriptions_actions$3.downloadInvoice, downloadInvoice);
}
function* loadInvoices() {
    yield put(subscriptions_actions$3.setLoading(true));
    try {
        const responseInvoices = yield call(umd.api.subscriptions.getSubscriptionInvoices);
        const invoices = responseInvoices.map((invoice) => ({
            id: invoice.id,
            externalId: invoice.externalId,
            subscriptionId: invoice.subscriptionId,
            paymentDate: new Date(Date.parse(invoice.paymentDate)),
            totalAmount: +((invoice.totalAmount || 0) / 100).toFixed(2),
            currency: invoice.currency || 'usd',
            paid: invoice.paid || false,
            receiptNumber: invoice.receiptNumber,
        }));
        yield put(subscriptions_actions$3.setState({
            loading: false,
            fetching: false,
            invoices,
        }));
    }
    catch (e) {
        yield put(subscriptions_actions$3.setError(e.message));
    }
}
function* downloadInvoice({ payload }) {
    yield put(subscriptions_actions$3.setInvoiceDownloadState({ loading: true, error: null }));
    try {
        yield call(umd.api.subscriptions.getSubscriptionInvoicePdf, payload.invoiceId, payload.filename);
        yield put(subscriptions_actions$3.setInvoiceDownloadState({ loading: false, error: null }));
    }
    catch (e) {
        yield put(subscriptions_actions$3.setInvoiceDownloadState({ loading: false, error: e.message || null }));
    }
}
/*********************************
 *  Preview Sagas
 *********************************/
function* loadInvoicesMock() {
    yield put(subscriptions_actions$3.setLoading(true));
    yield io_c3792963_delay(500);
    const selectPlanTitle = 'Premium';
    yield put(subscriptions_actions$3.setState({
        loading: false,
        fetching: false,
        invoices: invoicesMock.map((invoice) => (Object.assign(Object.assign({}, invoice), { selectedPlan: selectPlanTitle, paymentDate: new Date(Date.parse(invoice.paymentDate)), totalAmount: +((invoice.totalAmount || 0) / 100).toFixed(2) }))),
    }));
    yield put(subscriptions_actions$3.setLoading(false));
}
function* subscriptionInvoicesSagasMock() {
    yield takeEvery$1(subscriptions_actions$3.loadInvoices, loadInvoicesMock);
}

function* billingSagas() {
    yield io_c3792963_all([
        call(subscriptionBillingInformationSagas),
        call(subscriptionsPaymentMethodSagas),
        call(subscriptionInvoicesSagas),
        call(subscriptionSagas),
    ]);
}
function* billingSagasMock() {
    yield io_c3792963_all([
        call(subscriptionBillingInformationSagasMock),
        call(subscriptionsPaymentMethodSagasMock),
        call(subscriptionInvoicesSagasMock),
        call(subscriptionSagasMock),
    ]);
}

function* checkoutSagas() {
    yield takeEvery$1(subscriptions_actions$2.loadCheckout, loadCheckout);
    yield takeEvery$1(subscriptions_actions$2.resetCheckout, resetCheckout);
    yield takeEvery$1(subscriptions_actions$2.submitCheckout, submitCheckout);
    yield takeEvery$1(subscriptions_actions$2.confirmCheckout, confirmPlan);
    yield takeEvery$1(subscriptions_actions$2.errorCheckout, errorCheckout);
}
function* loadCheckout() {
    yield put(subscriptions_actions$2.setState({
        fetching: false,
        loading: false,
        error: null,
        confirmed: false,
    }));
}
function* resetCheckout() {
    yield put(subscriptions_actions$2.setState({
        loading: false,
        error: null,
        confirmed: false,
    }));
}
/**
 * Based on payment provider type
 */
function* submitCheckout() {
    yield put(subscriptions_actions$2.setState({
        loading: true,
        error: null,
    }));
}
function* confirmPlan({ payload: { paymentMethodId, planId } }) {
    const subscription = yield io_c3792963_select((state) => state.subscriptions.billing.subscription.subscription);
    const summary = yield io_c3792963_select((state) => state.subscriptions.billing.information.summary);
    const isTrialing = (subscription === null || subscription === void 0 ? void 0 : subscription.status) === SubscriptionStatus.TRIALING;
    const hasPaymentMethod = !!(summary === null || summary === void 0 ? void 0 : summary.paymentMethodId);
    if (!subscription) {
        yield put(subscriptions_actions$2.setState({
            loading: false,
            error: 'Subscription not found',
        }));
        return;
    }
    yield put(subscriptions_actions$2.setState({
        loading: true,
        error: null,
    }));
    if (isTrialing && hasPaymentMethod) {
        yield confirmCheckout();
        yield put(subscriptions_actions$6.setState({
            subscription: Object.assign(Object.assign({}, subscription), { status: umd.ISubscriptionStatus.ACTIVE }),
        }));
        return;
    }
    try {
        yield call(umd.api.subscriptions.updateManagedSubscription, subscription.id, {
            paymentMethodId,
            planId,
        });
        yield io_c3792963_all([
            loadBillingInformation(),
            loadPaymentMethod(),
            loadInvoices(),
        ]);
        yield confirmCheckout();
    }
    catch (e) {
        yield put(subscriptions_actions$2.setState({
            loading: false,
            error: e.message,
        }));
    }
}
function* confirmCheckout() {
    yield put(subscriptions_actions$2.setState({
        loading: false,
        error: null,
        confirmed: true,
    }));
}
function* errorCheckout({ payload }) {
    yield put(subscriptions_actions$2.setState({
        loading: false,
        error: payload,
    }));
}
/*********************************
 *  Preview Sagas
 *********************************/
function* checkoutSagasMock() {
    yield takeEvery$1(subscriptions_actions$2.resetCheckout, resetCheckout);
}

function* plansSagas() {
    yield takeEvery$1(subscriptions_actions$8.loadPlans, loadPlans);
}
function* loadPlans() {
    yield put(subscriptions_actions$8.setLoading(true));
    try {
        const products = yield call(umd.api.subscriptions.getSubscriptionPlans);
        const plans = products.map((item) => {
            var _a, _b;
            return ({
                id: item.id,
                name: item.name,
                description: item.description,
                price: ((_a = item.price) === null || _a === void 0 ? void 0 : _a.amount) || 0,
                currency: ((_b = item.price) === null || _b === void 0 ? void 0 : _b.currency) || 'usd',
                recurringInterval: 'month',
                slug: item.slug,
            });
        });
        yield put(subscriptions_actions$8.setState({
            fetching: false,
            loading: false,
            plans,
        }));
    }
    catch (e) {
        yield put(subscriptions_actions$8.setError(e.message));
    }
}
/*********************************
 *  Preview Sagas
 *********************************/
function* loadPlansMock() {
    yield put(subscriptions_actions$8.setLoading(true));
    yield io_c3792963_delay(500);
    yield put(subscriptions_actions$8.setState({
        fetching: false,
        loading: false,
        plans: planResponseMock.map((item) => {
            var _a, _b;
            return (Object.assign(Object.assign({}, item), { price: ((_a = item.price) === null || _a === void 0 ? void 0 : _a.amount) || 0, currency: ((_b = item.price) === null || _b === void 0 ? void 0 : _b.currency) || 'usd', recurringInterval: 'month' }));
        }),
    }));
}
function* plansSagasMock() {
    yield takeEvery$1(subscriptions_actions$8.loadPlans, loadPlansMock);
}

var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["UNKNWON"] = "unknown";
    PaymentMethodType["CARD"] = "card";
})(PaymentMethodType || (PaymentMethodType = {}));

function* configSagas() {
    yield takeEvery$1(subscriptions_actions$7.loadPaymentConfiguration, loadPaymentConfiguration);
}
function* loadPaymentConfiguration() {
    yield put(subscriptions_actions$7.setLoading(true));
    try {
        const response = yield call(umd.api.subscriptions.getPaymentProviders) || [];
        const stripePaymentProvider = response.find((paymentProvider) => paymentProvider.status === '1' && paymentProvider.providerType === umd.ProviderType.Stripe);
        if (stripePaymentProvider) {
            yield loadStripePaymentConfiguration();
        }
        else {
            yield put(subscriptions_actions$7.setError('Payment provider not configured'));
        }
    }
    catch (e) {
        yield put(subscriptions_actions$7.setError(e.message));
    }
}
function* loadStripePaymentConfiguration() {
    yield put(subscriptions_actions$7.setLoading(true));
    try {
        const response = yield call(umd.api.subscriptions.getStripePaymentProviderConfiguration);
        yield put(subscriptions_actions$7.setState({
            loading: false,
            fetching: false,
            config: {
                paymentProvider: PaymentProvider.STRIPE,
                apiKey: response.publishableKey
            }
        }));
    }
    catch (e) {
        yield put(subscriptions_actions$7.setError(e.message));
    }
}
/*********************************
 *  Preview Sagas
 *********************************/
function* loadPaymentConfigurationMock() {
    yield put(subscriptions_actions$7.setLoading(true));
    yield io_c3792963_delay(500);
    yield put(subscriptions_actions$7.setState({
        loading: false,
        fetching: false,
        config: {
            paymentProvider: PaymentProvider.STRIPE,
            apiKey: ''
        },
    }));
}
function* configSagasMock() {
    yield takeEvery$1(subscriptions_actions$7.loadPaymentConfiguration, loadPaymentConfigurationMock);
}

function* subscriptionStripeSagas() {
    yield takeEvery$1(subscriptions_actions$1.createCardSetupIntentSecret, createCardSetupIntentSecret);
}
function* createCardSetupIntentSecret({ payload }) {
    yield put(subscriptions_actions$1.setState({
        loading: true,
        error: null,
        cardSetupIntentSecret: null,
    }));
    try {
        const request = {};
        if (payload) {
            request.paymentMethodId = payload;
        }
        const { setupIntentSecret } = yield call(umd.api.subscriptions.createStripePaymentMethodSetupIntentSecret, request);
        yield put(subscriptions_actions$1.setState({
            cardSetupIntentSecret: setupIntentSecret,
            loading: false,
        }));
    }
    catch (e) {
        yield put(subscriptions_actions$1.setError(e.message));
    }
}

function* subscriptions_sagas() {
    yield io_c3792963_all([
        call(billingSagas),
        call(checkoutSagas),
        call(plansSagas),
        call(configSagas),
        call(subscriptionStripeSagas),
    ]);
}
function* subscriptions_mockSagas() {
    yield io_c3792963_all([call(billingSagasMock), call(checkoutSagasMock), call(plansSagasMock), call(configSagasMock)]);
}

// export store
// export store
var subscriptionsStore = {
    sagas: subscriptions_sagas,
    mockSagas: subscriptions_mockSagas,
    reducer: subscriptions_reducer,
    actions: subscriptions_actions,
    initialState: subscriptions_initialState,
    storeName: subscriptionsStoreName,
};



;// CONCATENATED MODULE: ./node_modules/@frontegg/redux-store/vendor/index.js








// export store
var vendorStore = {
    sagas: sagas,
    storeName: vendorStoreName,
    initialState: initialState,
    reducer: reducer,
    actions: actions,
};



// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
var objectWithoutPropertiesLoose = __webpack_require__(63366);
;// CONCATENATED MODULE: ./node_modules/@redux-saga/deferred/dist/redux-saga-deferred.esm.js
function deferred() {
  var def = {};
  def.promise = new Promise(function (resolve, reject) {
    def.resolve = resolve;
    def.reject = reject;
  });
  return def;
}
function arrayOfDeferred(length) {
  var arr = [];

  for (var i = 0; i < length; i++) {
    arr.push(deferred());
  }

  return arr;
}

/* harmony default export */ var redux_saga_deferred_esm = (deferred);


;// CONCATENATED MODULE: ./node_modules/@redux-saga/core/dist/redux-saga-core.esm.js











var queue = [];
/**
  Variable to hold a counting semaphore
  - Incrementing adds a lock and puts the scheduler in a `suspended` state (if it's not
    already suspended)
  - Decrementing releases a lock. Zero locks puts the scheduler in a `released` state. This
    triggers flushing the queued tasks.
**/

var semaphore = 0;
/**
  Executes a task 'atomically'. Tasks scheduled during this execution will be queued
  and flushed after this task has finished (assuming the scheduler endup in a released
  state).
**/

function exec(task) {
  try {
    suspend();
    task();
  } finally {
    release();
  }
}
/**
  Executes or queues a task depending on the state of the scheduler (`suspended` or `released`)
**/


function asap(task) {
  queue.push(task);

  if (!semaphore) {
    suspend();
    redux_saga_core_esm_flush();
  }
}
/**
 * Puts the scheduler in a `suspended` state and executes a task immediately.
 */

function immediately(task) {
  try {
    suspend();
    return task();
  } finally {
    redux_saga_core_esm_flush();
  }
}
/**
  Puts the scheduler in a `suspended` state. Scheduled tasks will be queued until the
  scheduler is released.
**/

function suspend() {
  semaphore++;
}
/**
  Puts the scheduler in a `released` state.
**/


function release() {
  semaphore--;
}
/**
  Releases the current lock. Executes all queued tasks if the scheduler is in the released state.
**/


function redux_saga_core_esm_flush() {
  release();
  var task;

  while (!semaphore && (task = queue.shift()) !== undefined) {
    exec(task);
  }
}

var redux_saga_core_esm_array = function array(patterns) {
  return function (input) {
    return patterns.some(function (p) {
      return matcher(p)(input);
    });
  };
};
var predicate = function predicate(_predicate) {
  return function (input) {
    return _predicate(input);
  };
};
var redux_saga_core_esm_string = function string(pattern) {
  return function (input) {
    return input.type === String(pattern);
  };
};
var redux_saga_core_esm_symbol = function symbol(pattern) {
  return function (input) {
    return input.type === pattern;
  };
};
var wildcard = function wildcard() {
  return kTrue;
};
function matcher(pattern) {
  // prettier-ignore
  var matcherCreator = pattern === '*' ? wildcard : redux_saga_is_esm_string(pattern) ? redux_saga_core_esm_string : redux_saga_is_esm_array(pattern) ? redux_saga_core_esm_array : stringableFunc(pattern) ? redux_saga_core_esm_string : redux_saga_is_esm_func(pattern) ? predicate : symbol(pattern) ? redux_saga_core_esm_symbol : null;

  if (matcherCreator === null) {
    throw new Error("invalid pattern: " + pattern);
  }

  return matcherCreator(pattern);
}

var END = {
  type: CHANNEL_END_TYPE
};
var isEnd = function isEnd(a) {
  return a && a.type === CHANNEL_END_TYPE;
};
var CLOSED_CHANNEL_WITH_TAKERS = 'Cannot have a closed channel with pending takers';
var INVALID_BUFFER = 'invalid buffer passed to channel factory function';
var UNDEFINED_INPUT_ERROR = "Saga or channel was provided with an undefined action\nHints:\n  - check that your Action Creator returns a non-undefined value\n  - if the Saga was started using runSaga, check that your subscribe source provides the action to its listeners";
function redux_saga_core_esm_channel(buffer$1) {
  if (buffer$1 === void 0) {
    buffer$1 = expanding();
  }

  var closed = false;
  var takers = [];

  if (false) {}

  function checkForbiddenStates() {
    if (closed && takers.length) {
      throw internalErr(CLOSED_CHANNEL_WITH_TAKERS);
    }

    if (takers.length && !buffer$1.isEmpty()) {
      throw internalErr('Cannot have pending takers with non empty buffer');
    }
  }

  function put(input) {
    if (false) {}

    if (closed) {
      return;
    }

    if (takers.length === 0) {
      return buffer$1.put(input);
    }

    var cb = takers.shift();
    cb(input);
  }

  function take(cb) {
    if (false) {}

    if (closed && buffer$1.isEmpty()) {
      cb(END);
    } else if (!buffer$1.isEmpty()) {
      cb(buffer$1.take());
    } else {
      takers.push(cb);

      cb.cancel = function () {
        remove(takers, cb);
      };
    }
  }

  function flush(cb) {
    if (false) {}

    if (closed && buffer$1.isEmpty()) {
      cb(END);
      return;
    }

    cb(buffer$1.flush());
  }

  function close() {
    if (false) {}

    if (closed) {
      return;
    }

    closed = true;
    var arr = takers;
    takers = [];

    for (var i = 0, len = arr.length; i < len; i++) {
      var taker = arr[i];
      taker(END);
    }
  }

  return {
    take: take,
    put: put,
    flush: flush,
    close: close
  };
}
function eventChannel(subscribe, buffer) {
  if (buffer === void 0) {
    buffer = none();
  }

  var closed = false;
  var unsubscribe;
  var chan = redux_saga_core_esm_channel(buffer);

  var close = function close() {
    if (closed) {
      return;
    }

    closed = true;

    if (func(unsubscribe)) {
      unsubscribe();
    }

    chan.close();
  };

  unsubscribe = subscribe(function (input) {
    if (isEnd(input)) {
      close();
      return;
    }

    chan.put(input);
  });

  if (false) {}

  unsubscribe = once(unsubscribe);

  if (closed) {
    unsubscribe();
  }

  return {
    take: chan.take,
    flush: chan.flush,
    close: close
  };
}
function multicastChannel() {
  var _ref;

  var closed = false;
  var currentTakers = [];
  var nextTakers = currentTakers;

  function checkForbiddenStates() {
    if (closed && nextTakers.length) {
      throw internalErr(CLOSED_CHANNEL_WITH_TAKERS);
    }
  }

  var ensureCanMutateNextTakers = function ensureCanMutateNextTakers() {
    if (nextTakers !== currentTakers) {
      return;
    }

    nextTakers = currentTakers.slice();
  };

  var close = function close() {
    if (false) {}

    closed = true;
    var takers = currentTakers = nextTakers;
    nextTakers = [];
    takers.forEach(function (taker) {
      taker(END);
    });
  };

  return _ref = {}, _ref[MULTICAST] = true, _ref.put = function put(input) {
    if (false) {}

    if (closed) {
      return;
    }

    if (isEnd(input)) {
      close();
      return;
    }

    var takers = currentTakers = nextTakers;

    for (var i = 0, len = takers.length; i < len; i++) {
      var taker = takers[i];

      if (taker[MATCH](input)) {
        taker.cancel();
        taker(input);
      }
    }
  }, _ref.take = function take(cb, matcher) {
    if (matcher === void 0) {
      matcher = wildcard;
    }

    if (false) {}

    if (closed) {
      cb(END);
      return;
    }

    cb[MATCH] = matcher;
    ensureCanMutateNextTakers();
    nextTakers.push(cb);
    cb.cancel = io_c3792963_once(function () {
      ensureCanMutateNextTakers();
      remove(nextTakers, cb);
    });
  }, _ref.close = close, _ref;
}
function stdChannel() {
  var chan = multicastChannel();
  var put = chan.put;

  chan.put = function (input) {
    if (input[redux_saga_symbols_esm_SAGA_ACTION]) {
      put(input);
      return;
    }

    asap(function () {
      put(input);
    });
  };

  return chan;
}

var RUNNING = 0;
var redux_saga_core_esm_CANCELLED = 1;
var ABORTED = 2;
var DONE = 3;

function resolvePromise(promise, cb) {
  var cancelPromise = promise[CANCEL];

  if (redux_saga_is_esm_func(cancelPromise)) {
    cb.cancel = cancelPromise;
  }

  promise.then(cb, function (error) {
    cb(error, true);
  });
}

var redux_saga_core_esm_current = 0;
var nextSagaId = (function () {
  return ++redux_saga_core_esm_current;
});

var _effectRunnerMap;

function getIteratorMetaInfo(iterator, fn) {
  if (iterator.isSagaIterator) {
    return {
      name: iterator.meta.name
    };
  }

  return getMetaInfo(fn);
}

function createTaskIterator(_ref) {
  var context = _ref.context,
      fn = _ref.fn,
      args = _ref.args;

  // catch synchronous failures; see #152 and #441
  try {
    var result = fn.apply(context, args); // i.e. a generator function returns an iterator

    if (iterator(result)) {
      return result;
    }

    var resolved = false;

    var next = function next(arg) {
      if (!resolved) {
        resolved = true; // Only promises returned from fork will be interpreted. See #1573

        return {
          value: result,
          done: !redux_saga_is_esm_promise(result)
        };
      } else {
        return {
          value: arg,
          done: true
        };
      }
    };

    return makeIterator(next);
  } catch (err) {
    // do not bubble up synchronous failures for detached forks
    // instead create a failed task. See #152 and #441
    return makeIterator(function () {
      throw err;
    });
  }
}

function runPutEffect(env, _ref2, cb) {
  var channel = _ref2.channel,
      action = _ref2.action,
      resolve = _ref2.resolve;

  /**
   Schedule the put in case another saga is holding a lock.
   The put will be executed atomically. ie nested puts will execute after
   this put has terminated.
   **/
  asap(function () {
    var result;

    try {
      result = (channel ? channel.put : env.dispatch)(action);
    } catch (error) {
      cb(error, true);
      return;
    }

    if (resolve && redux_saga_is_esm_promise(result)) {
      resolvePromise(result, cb);
    } else {
      cb(result);
    }
  }); // Put effects are non cancellables
}

function runTakeEffect(env, _ref3, cb) {
  var _ref3$channel = _ref3.channel,
      channel = _ref3$channel === void 0 ? env.channel : _ref3$channel,
      pattern = _ref3.pattern,
      maybe = _ref3.maybe;

  var takeCb = function takeCb(input) {
    if (input instanceof Error) {
      cb(input, true);
      return;
    }

    if (isEnd(input) && !maybe) {
      cb(TERMINATE);
      return;
    }

    cb(input);
  };

  try {
    channel.take(takeCb, redux_saga_is_esm_notUndef(pattern) ? matcher(pattern) : null);
  } catch (err) {
    cb(err, true);
    return;
  }

  cb.cancel = takeCb.cancel;
}

function runCallEffect(env, _ref4, cb, _ref5) {
  var context = _ref4.context,
      fn = _ref4.fn,
      args = _ref4.args;
  var task = _ref5.task;

  // catch synchronous failures; see #152
  try {
    var result = fn.apply(context, args);

    if (redux_saga_is_esm_promise(result)) {
      resolvePromise(result, cb);
      return;
    }

    if (iterator(result)) {
      // resolve iterator
      proc(env, result, task.context, redux_saga_core_esm_current, getMetaInfo(fn),
      /* isRoot */
      false, cb);
      return;
    }

    cb(result);
  } catch (error) {
    cb(error, true);
  }
}

function runCPSEffect(env, _ref6, cb) {
  var context = _ref6.context,
      fn = _ref6.fn,
      args = _ref6.args;

  // CPS (ie node style functions) can define their own cancellation logic
  // by setting cancel field on the cb
  // catch synchronous failures; see #152
  try {
    var cpsCb = function cpsCb(err, res) {
      if (undef(err)) {
        cb(res);
      } else {
        cb(err, true);
      }
    };

    fn.apply(context, args.concat(cpsCb));

    if (cpsCb.cancel) {
      cb.cancel = cpsCb.cancel;
    }
  } catch (error) {
    cb(error, true);
  }
}

function runForkEffect(env, _ref7, cb, _ref8) {
  var context = _ref7.context,
      fn = _ref7.fn,
      args = _ref7.args,
      detached = _ref7.detached;
  var parent = _ref8.task;
  var taskIterator = createTaskIterator({
    context: context,
    fn: fn,
    args: args
  });
  var meta = getIteratorMetaInfo(taskIterator, fn);
  immediately(function () {
    var child = proc(env, taskIterator, parent.context, redux_saga_core_esm_current, meta, detached, undefined);

    if (detached) {
      cb(child);
    } else {
      if (child.isRunning()) {
        parent.queue.addTask(child);
        cb(child);
      } else if (child.isAborted()) {
        parent.queue.abort(child.error());
      } else {
        cb(child);
      }
    }
  }); // Fork effects are non cancellables
}

function runJoinEffect(env, taskOrTasks, cb, _ref9) {
  var task = _ref9.task;

  var joinSingleTask = function joinSingleTask(taskToJoin, cb) {
    if (taskToJoin.isRunning()) {
      var joiner = {
        task: task,
        cb: cb
      };

      cb.cancel = function () {
        if (taskToJoin.isRunning()) remove(taskToJoin.joiners, joiner);
      };

      taskToJoin.joiners.push(joiner);
    } else {
      if (taskToJoin.isAborted()) {
        cb(taskToJoin.error(), true);
      } else {
        cb(taskToJoin.result());
      }
    }
  };

  if (redux_saga_is_esm_array(taskOrTasks)) {
    if (taskOrTasks.length === 0) {
      cb([]);
      return;
    }

    var childCallbacks = createAllStyleChildCallbacks(taskOrTasks, cb);
    taskOrTasks.forEach(function (t, i) {
      joinSingleTask(t, childCallbacks[i]);
    });
  } else {
    joinSingleTask(taskOrTasks, cb);
  }
}

function cancelSingleTask(taskToCancel) {
  if (taskToCancel.isRunning()) {
    taskToCancel.cancel();
  }
}

function runCancelEffect(env, taskOrTasks, cb, _ref10) {
  var task = _ref10.task;

  if (taskOrTasks === SELF_CANCELLATION) {
    cancelSingleTask(task);
  } else if (redux_saga_is_esm_array(taskOrTasks)) {
    taskOrTasks.forEach(cancelSingleTask);
  } else {
    cancelSingleTask(taskOrTasks);
  }

  cb(); // cancel effects are non cancellables
}

function runAllEffect(env, effects, cb, _ref11) {
  var digestEffect = _ref11.digestEffect;
  var effectId = redux_saga_core_esm_current;
  var keys = Object.keys(effects);

  if (keys.length === 0) {
    cb(redux_saga_is_esm_array(effects) ? [] : {});
    return;
  }

  var childCallbacks = createAllStyleChildCallbacks(effects, cb);
  keys.forEach(function (key) {
    digestEffect(effects[key], effectId, childCallbacks[key], key);
  });
}

function runRaceEffect(env, effects, cb, _ref12) {
  var digestEffect = _ref12.digestEffect;
  var effectId = redux_saga_core_esm_current;
  var keys = Object.keys(effects);
  var response = redux_saga_is_esm_array(effects) ? createEmptyArray(keys.length) : {};
  var childCbs = {};
  var completed = false;
  keys.forEach(function (key) {
    var chCbAtKey = function chCbAtKey(res, isErr) {
      if (completed) {
        return;
      }

      if (isErr || shouldComplete(res)) {
        // Race Auto cancellation
        cb.cancel();
        cb(res, isErr);
      } else {
        cb.cancel();
        completed = true;
        response[key] = res;
        cb(response);
      }
    };

    chCbAtKey.cancel = io_c3792963_noop;
    childCbs[key] = chCbAtKey;
  });

  cb.cancel = function () {
    // prevents unnecessary cancellation
    if (!completed) {
      completed = true;
      keys.forEach(function (key) {
        return childCbs[key].cancel();
      });
    }
  };

  keys.forEach(function (key) {
    if (completed) {
      return;
    }

    digestEffect(effects[key], effectId, childCbs[key], key);
  });
}

function runSelectEffect(env, _ref13, cb) {
  var selector = _ref13.selector,
      args = _ref13.args;

  try {
    var state = selector.apply(void 0, [env.getState()].concat(args));
    cb(state);
  } catch (error) {
    cb(error, true);
  }
}

function runChannelEffect(env, _ref14, cb) {
  var pattern = _ref14.pattern,
      buffer = _ref14.buffer;
  var chan = redux_saga_core_esm_channel(buffer);
  var match = matcher(pattern);

  var taker = function taker(action) {
    if (!isEnd(action)) {
      env.channel.take(taker, match);
    }

    chan.put(action);
  };

  var close = chan.close;

  chan.close = function () {
    taker.cancel();
    close();
  };

  env.channel.take(taker, match);
  cb(chan);
}

function runCancelledEffect(env, data, cb, _ref15) {
  var task = _ref15.task;
  cb(task.isCancelled());
}

function runFlushEffect(env, channel, cb) {
  channel.flush(cb);
}

function runGetContextEffect(env, prop, cb, _ref16) {
  var task = _ref16.task;
  cb(task.context[prop]);
}

function runSetContextEffect(env, props, cb, _ref17) {
  var task = _ref17.task;
  assignWithSymbols(task.context, props);
  cb();
}

var effectRunnerMap = (_effectRunnerMap = {}, _effectRunnerMap[TAKE] = runTakeEffect, _effectRunnerMap[PUT] = runPutEffect, _effectRunnerMap[ALL] = runAllEffect, _effectRunnerMap[RACE] = runRaceEffect, _effectRunnerMap[CALL] = runCallEffect, _effectRunnerMap[CPS] = runCPSEffect, _effectRunnerMap[FORK] = runForkEffect, _effectRunnerMap[JOIN] = runJoinEffect, _effectRunnerMap[io_c3792963_CANCEL] = runCancelEffect, _effectRunnerMap[SELECT] = runSelectEffect, _effectRunnerMap[ACTION_CHANNEL] = runChannelEffect, _effectRunnerMap[CANCELLED] = runCancelledEffect, _effectRunnerMap[FLUSH] = runFlushEffect, _effectRunnerMap[GET_CONTEXT] = runGetContextEffect, _effectRunnerMap[SET_CONTEXT] = runSetContextEffect, _effectRunnerMap);

/**
 Used to track a parent task and its forks
 In the fork model, forked tasks are attached by default to their parent
 We model this using the concept of Parent task && main Task
 main task is the main flow of the current Generator, the parent tasks is the
 aggregation of the main tasks + all its forked tasks.
 Thus the whole model represents an execution tree with multiple branches (vs the
 linear execution tree in sequential (non parallel) programming)

 A parent tasks has the following semantics
 - It completes if all its forks either complete or all cancelled
 - If it's cancelled, all forks are cancelled as well
 - It aborts if any uncaught error bubbles up from forks
 - If it completes, the return value is the one returned by the main task
 **/

function forkQueue(mainTask, onAbort, cont) {
  var tasks = [];
  var result;
  var completed = false;
  addTask(mainTask);

  var getTasks = function getTasks() {
    return tasks;
  };

  function abort(err) {
    onAbort();
    cancelAll();
    cont(err, true);
  }

  function addTask(task) {
    tasks.push(task);

    task.cont = function (res, isErr) {
      if (completed) {
        return;
      }

      remove(tasks, task);
      task.cont = io_c3792963_noop;

      if (isErr) {
        abort(res);
      } else {
        if (task === mainTask) {
          result = res;
        }

        if (!tasks.length) {
          completed = true;
          cont(result);
        }
      }
    };
  }

  function cancelAll() {
    if (completed) {
      return;
    }

    completed = true;
    tasks.forEach(function (t) {
      t.cont = io_c3792963_noop;
      t.cancel();
    });
    tasks = [];
  }

  return {
    addTask: addTask,
    cancelAll: cancelAll,
    abort: abort,
    getTasks: getTasks
  };
}

// there can be only a single saga error created at any given moment

function formatLocation(fileName, lineNumber) {
  return fileName + "?" + lineNumber;
}

function effectLocationAsString(effect) {
  var location = getLocation(effect);

  if (location) {
    var code = location.code,
        fileName = location.fileName,
        lineNumber = location.lineNumber;
    var source = code + "  " + formatLocation(fileName, lineNumber);
    return source;
  }

  return '';
}

function sagaLocationAsString(sagaMeta) {
  var name = sagaMeta.name,
      location = sagaMeta.location;

  if (location) {
    return name + "  " + formatLocation(location.fileName, location.lineNumber);
  }

  return name;
}

function cancelledTasksAsString(sagaStack) {
  var cancelledTasks = flatMap(function (i) {
    return i.cancelledTasks;
  }, sagaStack);

  if (!cancelledTasks.length) {
    return '';
  }

  return ['Tasks cancelled due to error:'].concat(cancelledTasks).join('\n');
}

var crashedEffect = null;
var sagaStack = [];
var addSagaFrame = function addSagaFrame(frame) {
  frame.crashedEffect = crashedEffect;
  sagaStack.push(frame);
};
var clear = function clear() {
  crashedEffect = null;
  sagaStack.length = 0;
}; // this sets crashed effect for the soon-to-be-reported saga frame
// this slightly streatches the singleton nature of this module into wrong direction
// as it's even less obvious what's the data flow here, but it is what it is for now

var setCrashedEffect = function setCrashedEffect(effect) {
  crashedEffect = effect;
};
/**
  @returns {string}

  @example
  The above error occurred in task errorInPutSaga {pathToFile}
  when executing effect put({type: 'REDUCER_ACTION_ERROR_IN_PUT'}) {pathToFile}
      created by fetchSaga {pathToFile}
      created by rootSaga {pathToFile}
*/

var redux_saga_core_esm_toString = function toString() {
  var firstSaga = sagaStack[0],
      otherSagas = sagaStack.slice(1);
  var crashedEffectLocation = firstSaga.crashedEffect ? effectLocationAsString(firstSaga.crashedEffect) : null;
  var errorMessage = "The above error occurred in task " + sagaLocationAsString(firstSaga.meta) + (crashedEffectLocation ? " \n when executing effect " + crashedEffectLocation : '');
  return [errorMessage].concat(otherSagas.map(function (s) {
    return "    created by " + sagaLocationAsString(s.meta);
  }), [cancelledTasksAsString(sagaStack)]).join('\n');
};

function newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont) {
  var _task;

  if (cont === void 0) {
    cont = io_c3792963_noop;
  }

  var status = RUNNING;
  var taskResult;
  var taskError;
  var deferredEnd = null;
  var cancelledDueToErrorTasks = [];
  var context = Object.create(parentContext);
  var queue = forkQueue(mainTask, function onAbort() {
    cancelledDueToErrorTasks.push.apply(cancelledDueToErrorTasks, queue.getTasks().map(function (t) {
      return t.meta.name;
    }));
  }, end);
  /**
   This may be called by a parent generator to trigger/propagate cancellation
   cancel all pending tasks (including the main task), then end the current task.
    Cancellation propagates down to the whole execution tree held by this Parent task
   It's also propagated to all joiners of this task and their execution tree/joiners
    Cancellation is noop for terminated/Cancelled tasks tasks
   **/

  function cancel() {
    if (status === RUNNING) {
      // Setting status to CANCELLED does not necessarily mean that the task/iterators are stopped
      // effects in the iterator's finally block will still be executed
      status = redux_saga_core_esm_CANCELLED;
      queue.cancelAll(); // Ending with a TASK_CANCEL will propagate the Cancellation to all joiners

      end(TASK_CANCEL, false);
    }
  }

  function end(result, isErr) {
    if (!isErr) {
      // The status here may be RUNNING or CANCELLED
      // If the status is CANCELLED, then we do not need to change it here
      if (result === TASK_CANCEL) {
        status = redux_saga_core_esm_CANCELLED;
      } else if (status !== redux_saga_core_esm_CANCELLED) {
        status = DONE;
      }

      taskResult = result;
      deferredEnd && deferredEnd.resolve(result);
    } else {
      status = ABORTED;
      addSagaFrame({
        meta: meta,
        cancelledTasks: cancelledDueToErrorTasks
      });

      if (task.isRoot) {
        var sagaStack = redux_saga_core_esm_toString(); // we've dumped the saga stack to string and are passing it to user's code
        // we know that it won't be needed anymore and we need to clear it

        clear();
        env.onError(result, {
          sagaStack: sagaStack
        });
      }

      taskError = result;
      deferredEnd && deferredEnd.reject(result);
    }

    task.cont(result, isErr);
    task.joiners.forEach(function (joiner) {
      joiner.cb(result, isErr);
    });
    task.joiners = null;
  }

  function setContext(props) {
    if (false) {}

    assignWithSymbols(context, props);
  }

  function toPromise() {
    if (deferredEnd) {
      return deferredEnd.promise;
    }

    deferredEnd = redux_saga_deferred_esm();

    if (status === ABORTED) {
      deferredEnd.reject(taskError);
    } else if (status !== RUNNING) {
      deferredEnd.resolve(taskResult);
    }

    return deferredEnd.promise;
  }

  var task = (_task = {}, _task[redux_saga_symbols_esm_TASK] = true, _task.id = parentEffectId, _task.meta = meta, _task.isRoot = isRoot, _task.context = context, _task.joiners = [], _task.queue = queue, _task.cancel = cancel, _task.cont = cont, _task.end = end, _task.setContext = setContext, _task.toPromise = toPromise, _task.isRunning = function isRunning() {
    return status === RUNNING;
  }, _task.isCancelled = function isCancelled() {
    return status === redux_saga_core_esm_CANCELLED || status === RUNNING && mainTask.status === redux_saga_core_esm_CANCELLED;
  }, _task.isAborted = function isAborted() {
    return status === ABORTED;
  }, _task.result = function result() {
    return taskResult;
  }, _task.error = function error() {
    return taskError;
  }, _task);
  return task;
}

function proc(env, iterator$1, parentContext, parentEffectId, meta, isRoot, cont) {
  if (false) {}

  var finalRunEffect = env.finalizeRunEffect(runEffect);
  /**
    Tracks the current effect cancellation
    Each time the generator progresses. calling runEffect will set a new value
    on it. It allows propagating cancellation to child effects
  **/

  next.cancel = io_c3792963_noop;
  /** Creates a main task to track the main flow */

  var mainTask = {
    meta: meta,
    cancel: cancelMain,
    status: RUNNING
  };
  /**
   Creates a new task descriptor for this generator.
   A task is the aggregation of it's mainTask and all it's forked tasks.
   **/

  var task = newTask(env, mainTask, parentContext, parentEffectId, meta, isRoot, cont);
  var executingContext = {
    task: task,
    digestEffect: digestEffect
  };
  /**
    cancellation of the main task. We'll simply resume the Generator with a TASK_CANCEL
  **/

  function cancelMain() {
    if (mainTask.status === RUNNING) {
      mainTask.status = redux_saga_core_esm_CANCELLED;
      next(TASK_CANCEL);
    }
  }
  /**
    attaches cancellation logic to this task's continuation
    this will permit cancellation to propagate down the call chain
  **/


  if (cont) {
    cont.cancel = task.cancel;
  } // kicks up the generator


  next(); // then return the task descriptor to the caller

  return task;
  /**
   * This is the generator driver
   * It's a recursive async/continuation function which calls itself
   * until the generator terminates or throws
   * @param {internal commands(TASK_CANCEL | TERMINATE) | any} arg - value, generator will be resumed with.
   * @param {boolean} isErr - the flag shows if effect finished with an error
   *
   * receives either (command | effect result, false) or (any thrown thing, true)
   */

  function next(arg, isErr) {
    try {
      var result;

      if (isErr) {
        result = iterator$1.throw(arg); // user handled the error, we can clear bookkept values

        clear();
      } else if (shouldCancel(arg)) {
        /**
          getting TASK_CANCEL automatically cancels the main task
          We can get this value here
           - By cancelling the parent task manually
          - By joining a Cancelled task
        **/
        mainTask.status = redux_saga_core_esm_CANCELLED;
        /**
          Cancels the current effect; this will propagate the cancellation down to any called tasks
        **/

        next.cancel();
        /**
          If this Generator has a `return` method then invokes it
          This will jump to the finally block
        **/

        result = redux_saga_is_esm_func(iterator$1.return) ? iterator$1.return(TASK_CANCEL) : {
          done: true,
          value: TASK_CANCEL
        };
      } else if (shouldTerminate(arg)) {
        // We get TERMINATE flag, i.e. by taking from a channel that ended using `take` (and not `takem` used to trap End of channels)
        result = redux_saga_is_esm_func(iterator$1.return) ? iterator$1.return() : {
          done: true
        };
      } else {
        result = iterator$1.next(arg);
      }

      if (!result.done) {
        digestEffect(result.value, parentEffectId, next);
      } else {
        /**
          This Generator has ended, terminate the main task and notify the fork queue
        **/
        if (mainTask.status !== redux_saga_core_esm_CANCELLED) {
          mainTask.status = DONE;
        }

        mainTask.cont(result.value);
      }
    } catch (error) {
      if (mainTask.status === redux_saga_core_esm_CANCELLED) {
        throw error;
      }

      mainTask.status = ABORTED;
      mainTask.cont(error, true);
    }
  }

  function runEffect(effect, effectId, currCb) {
    /**
      each effect runner must attach its own logic of cancellation to the provided callback
      it allows this generator to propagate cancellation downward.
       ATTENTION! effect runners must setup the cancel logic by setting cb.cancel = [cancelMethod]
      And the setup must occur before calling the callback
       This is a sort of inversion of control: called async functions are responsible
      of completing the flow by calling the provided continuation; while caller functions
      are responsible for aborting the current flow by calling the attached cancel function
       Library users can attach their own cancellation logic to promises by defining a
      promise[CANCEL] method in their returned promises
      ATTENTION! calling cancel must have no effect on an already completed or cancelled effect
    **/
    if (redux_saga_is_esm_promise(effect)) {
      resolvePromise(effect, currCb);
    } else if (iterator(effect)) {
      // resolve iterator
      proc(env, effect, task.context, effectId, meta,
      /* isRoot */
      false, currCb);
    } else if (effect && effect[redux_saga_symbols_esm_IO]) {
      var effectRunner = effectRunnerMap[effect.type];
      effectRunner(env, effect.payload, currCb, executingContext);
    } else {
      // anything else returned as is
      currCb(effect);
    }
  }

  function digestEffect(effect, parentEffectId, cb, label) {
    if (label === void 0) {
      label = '';
    }

    var effectId = nextSagaId();
    env.sagaMonitor && env.sagaMonitor.effectTriggered({
      effectId: effectId,
      parentEffectId: parentEffectId,
      label: label,
      effect: effect
    });
    /**
      completion callback and cancel callback are mutually exclusive
      We can't cancel an already completed effect
      And We can't complete an already cancelled effectId
    **/

    var effectSettled; // Completion callback passed to the appropriate effect runner

    function currCb(res, isErr) {
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      cb.cancel = io_c3792963_noop; // defensive measure

      if (env.sagaMonitor) {
        if (isErr) {
          env.sagaMonitor.effectRejected(effectId, res);
        } else {
          env.sagaMonitor.effectResolved(effectId, res);
        }
      }

      if (isErr) {
        setCrashedEffect(effect);
      }

      cb(res, isErr);
    } // tracks down the current cancel


    currCb.cancel = io_c3792963_noop; // setup cancellation logic on the parent cb

    cb.cancel = function () {
      // prevents cancelling an already completed effect
      if (effectSettled) {
        return;
      }

      effectSettled = true;
      currCb.cancel(); // propagates cancel downward

      currCb.cancel = io_c3792963_noop; // defensive measure

      env.sagaMonitor && env.sagaMonitor.effectCancelled(effectId);
    };

    finalRunEffect(effect, effectId, currCb);
  }
}

var RUN_SAGA_SIGNATURE = 'runSaga(options, saga, ...args)';
var NON_GENERATOR_ERR = RUN_SAGA_SIGNATURE + ": saga argument must be a Generator function!";
function runSaga(_ref, saga) {
  var _ref$channel = _ref.channel,
      channel = _ref$channel === void 0 ? stdChannel() : _ref$channel,
      dispatch = _ref.dispatch,
      getState = _ref.getState,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? {} : _ref$context,
      sagaMonitor = _ref.sagaMonitor,
      effectMiddlewares = _ref.effectMiddlewares,
      _ref$onError = _ref.onError,
      onError = _ref$onError === void 0 ? logError : _ref$onError;

  if (false) {}

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  var iterator$1 = saga.apply(void 0, args);

  if (false) {}

  var effectId = nextSagaId();

  if (sagaMonitor) {
    // monitors are expected to have a certain interface, let's fill-in any missing ones
    sagaMonitor.rootSagaStarted = sagaMonitor.rootSagaStarted || io_c3792963_noop;
    sagaMonitor.effectTriggered = sagaMonitor.effectTriggered || io_c3792963_noop;
    sagaMonitor.effectResolved = sagaMonitor.effectResolved || io_c3792963_noop;
    sagaMonitor.effectRejected = sagaMonitor.effectRejected || io_c3792963_noop;
    sagaMonitor.effectCancelled = sagaMonitor.effectCancelled || io_c3792963_noop;
    sagaMonitor.actionDispatched = sagaMonitor.actionDispatched || io_c3792963_noop;
    sagaMonitor.rootSagaStarted({
      effectId: effectId,
      saga: saga,
      args: args
    });
  }

  if (false) { var MIDDLEWARE_TYPE_ERROR; }

  var finalizeRunEffect;

  if (effectMiddlewares) {
    var middleware = compose.apply(void 0, effectMiddlewares);

    finalizeRunEffect = function finalizeRunEffect(runEffect) {
      return function (effect, effectId, currCb) {
        var plainRunEffect = function plainRunEffect(eff) {
          return runEffect(eff, effectId, currCb);
        };

        return middleware(plainRunEffect)(effect);
      };
    };
  } else {
    finalizeRunEffect = identity;
  }

  var env = {
    channel: channel,
    dispatch: wrapSagaDispatch(dispatch),
    getState: getState,
    sagaMonitor: sagaMonitor,
    onError: onError,
    finalizeRunEffect: finalizeRunEffect
  };
  return immediately(function () {
    var task = proc(env, iterator$1, context, effectId, getMetaInfo(saga),
    /* isRoot */
    true, undefined);

    if (sagaMonitor) {
      sagaMonitor.effectResolved(effectId, task);
    }

    return task;
  });
}

function sagaMiddlewareFactory(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$context = _ref.context,
      context = _ref$context === void 0 ? {} : _ref$context,
      _ref$channel = _ref.channel,
      channel = _ref$channel === void 0 ? stdChannel() : _ref$channel,
      sagaMonitor = _ref.sagaMonitor,
      options = (0,objectWithoutPropertiesLoose/* default */.Z)(_ref, ["context", "channel", "sagaMonitor"]);

  var boundRunSaga;

  if (false) {}

  function sagaMiddleware(_ref2) {
    var getState = _ref2.getState,
        dispatch = _ref2.dispatch;
    boundRunSaga = runSaga.bind(null, (0,esm_extends/* default */.Z)({}, options, {
      context: context,
      channel: channel,
      dispatch: dispatch,
      getState: getState,
      sagaMonitor: sagaMonitor
    }));
    return function (next) {
      return function (action) {
        if (sagaMonitor && sagaMonitor.actionDispatched) {
          sagaMonitor.actionDispatched(action);
        }

        var result = next(action); // hit reducers

        channel.put(action);
        return result;
      };
    };
  }

  sagaMiddleware.run = function () {
    if (false) {}

    return boundRunSaga.apply(void 0, arguments);
  };

  sagaMiddleware.setContext = function (props) {
    if (false) {}

    assignWithSymbols(context, props);
  };

  return sagaMiddleware;
}

/* harmony default export */ var redux_saga_core_esm = (sagaMiddlewareFactory);


;// CONCATENATED MODULE: ./node_modules/redux-saga/dist/redux-saga-core-npm-proxy.esm.js





/* harmony default export */ var redux_saga_core_npm_proxy_esm = (redux_saga_core_esm);

;// CONCATENATED MODULE: ./node_modules/@frontegg/redux-store/saga-7a267fe0.js




const saga_7a267fe0_initialState = {
    total: 0,
    offset: 0,
    filter: '',
    sortBy: 'createdAt',
    context: null,
    filters: [],
    rowsData: [],
    lastUpdated: new Date(),
    isLoading: true,
    isFetchMore: false,
    totalToday: 0,
    currentPage: 0,
    headerProps: [],
    sortDirection: 'desc',
    severeThisWeek: 0,
    predefinedFilters: [],
    isDownloadingCsv: false,
    virtualScroll: false,
};

const defaultItemsPerPage = 20;
const { name: storeName, actions: lifeCycleActions, reducer: saga_7a267fe0_reducer } = createSlice({
    name: 'audits',
    initialState: saga_7a267fe0_initialState,
    reducers: {
        setContext: (state, { payload }) => {
            state.context = payload;
        },
        startLoading: (state) => {
            state.isLoading = true;
        },
        setVirtualScroll: (state, { payload }) => {
            state.virtualScroll = payload;
        },
        startRefresh: (state) => {
            state.isLoading = true;
        },
        startFetching: (state) => {
            state.isFetchMore = true;
        },
        finishLoading: (state) => {
            state.isLoading = false;
        },
        startDownloadingCsv: (state) => {
            state.isDownloadingCsv = true;
        },
        stopDownloadingCsv: (state) => {
            state.isDownloadingCsv = false;
        },
        loadStatsSuccess: (state, { payload }) => {
            state.error = undefined;
            state.totalToday = payload.totalToday;
            state.severeThisWeek = payload.severeThisWeek;
        },
        loadItemFailedAction: (state, { payload }) => {
            state.error = Object.assign(Object.assign({}, state.error), { [payload.name]: payload.error });
        },
        loadMetadataSuccess: (state, { payload }) => {
            state.error = {};
            state.headerProps = payload.properties;
            state.themeAudits = payload.theme ? payload.theme.styles : {};
        },
        loadAuditsSuccess: (state, { payload }) => {
            state.error = {};
            state.rowsData = payload.rowsData;
            state.lastUpdated = new Date();
            state.total = payload.total;
        },
        fetchMoreSuccess: (state, { payload }) => {
            state.error = {};
            state.offset = payload.offset;
            state.currentPage = payload.currentPage;
            state.isFetchMore = false;
        },
        setFilterData: (state, { payload }) => {
            state.filters = payload;
            state.currentPage = 0;
            state.offset = 0;
            state.isLoading = true;
        },
        textSearch: (state, { payload }) => {
            state.filter = payload;
            state.currentPage = 0;
            state.offset = 0;
            state.isLoading = true;
        },
        onPageChange: (state, { payload }) => {
            state.currentPage = payload - 1;
            state.offset = state.currentPage * defaultItemsPerPage;
            state.isLoading = true;
        },
        setDataSorting: (state, { payload }) => {
            state.sortBy = payload.sortBy;
            state.currentPage = 0;
            state.sortDirection = payload.sortDirection === 'asc' ? 'desc' : 'asc';
            state.offset = 0;
            state.isLoading = true;
        },
        setPredefinedFilters: (state, { payload }) => {
            state.predefinedFilters = payload;
            state.filters = Object.keys(payload).map((key) => ({ key, value: payload[key] }));
        },
    },
});
const saga_7a267fe0_actions = Object.assign(Object.assign({}, lifeCycleActions), { initData: createAction(`${storeName}/initData`), loadAudits: createAction(`${storeName}/loadAudits`), removeFilter: createAction(`${storeName}/removeFilter`), filterData: createAction(`${storeName}/filterData`), exportCSV: createAction(`${storeName}/exportCSV`), deleteAudits: createAction(`${storeName}/deleteAudits`) });

const saga_7a267fe0_select = () => io_c3792963_select((_) => _[storeName]);
function* loadStats() {
    const { sortBy, sortDirection } = yield saga_7a267fe0_select();
    try {
        const stats = yield call(umd.api.audits.getAuditsStats, {
            sortBy,
            sortDirection,
            count: defaultItemsPerPage,
        });
        yield put(saga_7a267fe0_actions.loadStatsSuccess(stats));
    }
    catch (e) {
        const errorMessage = {
            name: 'stats',
            error: e,
        };
        console.error('failed to load stats - ', e);
        yield put(saga_7a267fe0_actions.loadItemFailedAction(errorMessage));
    }
}
function* loadMetadata() {
    try {
        const result = yield call(umd.api.metadata.getAuditsMetadata);
        yield put(saga_7a267fe0_actions.loadMetadataSuccess(result));
    }
    catch (e) {
        const errorMessage = {
            name: 'metadata',
            error: e,
        };
        console.error('failed to load metadata - ', e);
        yield put(saga_7a267fe0_actions.loadItemFailedAction(errorMessage));
    }
}
const filterToObject = (arr) => arr.reduce((res, curr) => {
    res[curr.key] = curr.value;
    return res;
}, {});
function* loadAuditsFunction({ payload }) {
    const { filters, sortBy, sortDirection, filter, offset, virtualScroll } = yield saga_7a267fe0_select();
    const { appendMode = virtualScroll, onlyOneLoad = true, offset: incomeOffset } = payload || {};
    const { rowsData } = appendMode ? yield saga_7a267fe0_select() : { rowsData: [] };
    try {
        const f2o = filterToObject(filters);
        const { data, total } = yield call(umd.api.audits.getAudits, Object.assign(Object.assign(Object.assign(Object.assign({}, (virtualScroll && { paginationMode: 'virtual' })), { sortDirection,
            sortBy,
            filter }), f2o), { 
            // TODO: refactor once api become V2 with query field for virtual scroll
            offset: virtualScroll ? rowsData.length + incomeOffset || rowsData.length + offset : incomeOffset || offset, count: defaultItemsPerPage }));
        yield put(saga_7a267fe0_actions.loadAuditsSuccess({ rowsData: [...rowsData, ...data], total }));
        onlyOneLoad && (yield put(saga_7a267fe0_actions.finishLoading()));
    }
    catch (e) {
        const errorMessage = {
            name: 'audits',
            error: e,
        };
        console.error('failed to load audits - ', e);
        yield put(saga_7a267fe0_actions.loadItemFailedAction(errorMessage));
    }
}
function* initDataFunction() {
    yield put(saga_7a267fe0_actions.startLoading());
    yield io_c3792963_all([loadStats(), loadMetadata(), loadAuditsFunction({ payload: { onlyOneLoad: false }, type: '' })]);
    yield put(saga_7a267fe0_actions.finishLoading());
}
function* removeFilterFunction({ payload }) {
    const { filters: allFilters } = yield saga_7a267fe0_select();
    const removedFilterIndex = allFilters.findIndex((item) => item.key === payload.key);
    if (removedFilterIndex < 0) {
        return;
    }
    const newFilters = [...allFilters.slice(0, removedFilterIndex), ...allFilters.slice(removedFilterIndex + 1)];
    yield put(saga_7a267fe0_actions.setFilterData(newFilters));
}
function* filterDataFunction({ payload }) {
    const { filters: allFilters } = yield saga_7a267fe0_select();
    let filterIndex = allFilters.findIndex((item) => item.key === payload.key);
    if (filterIndex < 0) {
        filterIndex = allFilters.length;
    }
    const newFilters = [...allFilters.slice(0, filterIndex), payload, ...allFilters.slice(filterIndex + 1)];
    yield put(saga_7a267fe0_actions.setFilterData(newFilters));
}
function* exportCsvFunction() {
    const { filters, sortBy, sortDirection, filter, headerProps } = yield saga_7a267fe0_select();
    const f2o = filterToObject(filters);
    yield put(saga_7a267fe0_actions.startDownloadingCsv());
    const outputFileName = `audits.csv`;
    try {
        yield umd.api.audits.exportAudits(Object.assign(Object.assign({ endpoint: 'csv/v2', headerProps,
            sortDirection,
            sortBy,
            filter }, f2o), { offset: 0, outputFileName }));
    }
    catch (e) {
        console.error('failed to export audits - ', e);
    }
    finally {
        yield put(saga_7a267fe0_actions.stopDownloadingCsv());
    }
}
function* saga_7a267fe0_sagas() {
    yield takeLatest$1(saga_7a267fe0_actions.initData, initDataFunction);
    yield takeLatest$1(saga_7a267fe0_actions.removeFilter, removeFilterFunction);
    yield takeLatest$1(saga_7a267fe0_actions.filterData, filterDataFunction);
    yield takeLatest$1([saga_7a267fe0_actions.loadAudits, saga_7a267fe0_actions.textSearch, saga_7a267fe0_actions.onPageChange], loadAuditsFunction);
    yield takeLatest$1([saga_7a267fe0_actions.setFilterData, saga_7a267fe0_actions.setDataSorting, saga_7a267fe0_actions.startRefresh], () => loadAuditsFunction({ payload: { appendMode: false }, type: '' }));
    yield takeLatest$1(saga_7a267fe0_actions.exportCSV, exportCsvFunction);
}



;// CONCATENATED MODULE: ./node_modules/@frontegg/redux-store/toolkit/index.js


















const toolkit_initialState = {
    context: undefined,
};
const { reducer: rootReducer } = createSlice({
    name: 'root',
    initialState: toolkit_initialState,
    reducers: {
        setContext: {
            prepare: (context) => ({ payload: context }),
            reducer: (state, { payload }) => {
                umd.ContextHolder.setContext(payload);
                return Object.assign(Object.assign({}, state), { context: payload });
            },
        },
    },
});
const createFronteggStore = (rootInitialState, storeHolder, previewMode = false, authInitialState, overrideInitialState, builderMode = false) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
    const isSSR = typeof window === 'undefined';
    let holder = storeHolder;
    if (isSSR && storeHolder == null) {
        throw Error('createFronteggStore(initState, storeHolder) failed, storeHolder must not be null in Server-Side rendering');
    }
    if (!holder) {
        holder = window;
    }
    if (!holder.store) {
        if (!previewMode && !builderMode) {
            umd.ContextHolder.setContext(rootInitialState.context);
        }
        const sagaMiddleware = redux_saga_core_npm_proxy_esm();
        const middleware = [
            ...getDefaultMiddleware({ thunk: false, immutableCheck: false, serializableCheck: false }),
            sagaMiddleware,
        ];
        holder.store = configureStore({
            middleware,
            preloadedState: {
                root: Object.assign(Object.assign({}, rootInitialState), { previewMode }),
                [authStore.storeName]: Object.assign(Object.assign(Object.assign(Object.assign({}, authStore.initialState), authInitialState), ((_a = overrideInitialState === null || overrideInitialState === void 0 ? void 0 : overrideInitialState.auth) !== null && _a !== void 0 ? _a : {})), { routes: Object.assign(Object.assign(Object.assign({}, authStore.initialState.routes), ((_b = authInitialState === null || authInitialState === void 0 ? void 0 : authInitialState.routes) !== null && _b !== void 0 ? _b : {})), ((_d = (_c = overrideInitialState === null || overrideInitialState === void 0 ? void 0 : overrideInitialState.auth) === null || _c === void 0 ? void 0 : _c.routes) !== null && _d !== void 0 ? _d : {})) }),
                [auditsStore.storeName]: Object.assign(Object.assign(Object.assign({}, auditsStore.initialState), ((_e = overrideInitialState === null || overrideInitialState === void 0 ? void 0 : overrideInitialState.auditLogs) !== null && _e !== void 0 ? _e : {})), { auditLogsState: Object.assign(Object.assign({}, auditsStore.initialState.auditLogsState), ((_g = (_f = overrideInitialState === null || overrideInitialState === void 0 ? void 0 : overrideInitialState.auditLogs) === null || _f === void 0 ? void 0 : _f.auditLogsState) !== null && _g !== void 0 ? _g : {})), auditsMetadataState: Object.assign(Object.assign({}, auditsStore.initialState.auditsMetadataState), ((_j = (_h = overrideInitialState === null || overrideInitialState === void 0 ? void 0 : overrideInitialState.auditLogs) === null || _h === void 0 ? void 0 : _h.auditsMetadataState) !== null && _j !== void 0 ? _j : {})) }),
                [storeName]: Object.assign(Object.assign({}, saga_7a267fe0_initialState), ((_k = overrideInitialState === null || overrideInitialState === void 0 ? void 0 : overrideInitialState.audits) !== null && _k !== void 0 ? _k : {})),
                [connectivityStore.storeName]: connectivityStore.initialState,
                [subscriptionsStore.storeName]: subscriptionsStore.initialState,
                [vendorStore.storeName]: vendorStore.initialState,
            },
            reducer: combineReducers({
                root: rootReducer,
                [authStore.storeName]: authStore.reducer,
                [auditsStore.storeName]: auditsStore.reducer,
                [storeName]: saga_7a267fe0_reducer,
                [connectivityStore.storeName]: connectivityStore.reducer,
                [subscriptionsStore.storeName]: subscriptionsStore.reducer,
                [vendorStore.storeName]: vendorStore.reducer,
            }),
        });
        const rootSaga = function* () {
            yield io_c3792963_all([
                call(authStore.sagas),
                call(auditsStore.sagas),
                call(saga_7a267fe0_sagas),
                call(connectivityStore.sagas),
                call(subscriptionsStore.sagas),
                call(vendorStore.sagas),
            ]);
        };
        const rootMockSaga = function* () {
            yield io_c3792963_all([call(authStore.mockSagas), call(auditsStore.mockSagas), call(subscriptionsStore.mockSagas)]);
        };
        if (previewMode) {
            holder.store.destroy = sagaMiddleware.run(rootMockSaga).cancel;
            holder.store.dispatch(auth_actions.requestAuthorize(true));
        }
        else {
            holder.store.destroy = sagaMiddleware.run(rootSaga).cancel;
        }
    }
    return holder.store;
};



// EXTERNAL MODULE: ./node_modules/reselect/es/index.js
var reselect_es = __webpack_require__(22222);
;// CONCATENATED MODULE: ./node_modules/@frontegg/redux-store/index.js

















/***/ }),

/***/ 32205:
/***/ (function(__unused_webpack_module, exports) {

(function (global, factory) {
     true ? factory(exports) :
    0;
}(this, (function (exports) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    class ContextHolder {
        constructor() {
            this.context = null;
            this.accessToken = null;
            this.user = null;
            this.onRedirectTo = (path) => (window.location.href = path);
            this.logout = () => (window.location.href = '/account/logout');
        }
        static getInstance() {
            if (!ContextHolder.instance) {
                ContextHolder.instance = new ContextHolder();
            }
            return ContextHolder.instance;
        }
        static setContext(context) {
            ContextHolder.getInstance().context = context;
        }
        static setAccessToken(accessToken) {
            ContextHolder.getInstance().accessToken = accessToken;
        }
        static setUser(user) {
            ContextHolder.getInstance().user = user;
        }
        static setOnRedirectTo(onRedirectTo) {
            ContextHolder.getInstance().onRedirectTo = onRedirectTo;
        }
        static setLogout(logout, logoutUrl) {
            ContextHolder.getInstance().logout = (callback) => {
                if (!callback) {
                    ContextHolder.onRedirectTo(logoutUrl);
                }
                else {
                    logout(callback);
                }
            };
        }
        static getContext() {
            var _a;
            return ((_a = ContextHolder.getInstance().context) !== null && _a !== void 0 ? _a : {
                baseUrl: window.location.href,
                tokenResolver: () => 'my-authentication-token',
                logLevel: 'error',
            });
        }
        static getAccessToken() {
            return ContextHolder.getInstance().accessToken;
        }
        static getUser() {
            return ContextHolder.getInstance().user;
        }
        static onRedirectTo(path, opts) {
            return ContextHolder.getInstance().onRedirectTo(path, opts);
        }
        static logout(callback) {
            return ContextHolder.getInstance().logout(callback);
        }
    }
    const FronteggContext = {
        getContext: () => ContextHolder.getContext(),
        getAccessToken: () => ContextHolder.getAccessToken(),
        getUser: () => ContextHolder.getUser(),
        onRedirectTo: (path, opts) => ContextHolder.onRedirectTo(path, opts),
        logout: (callback) => ContextHolder.logout(callback),
    };

    class FronteggApiError extends Error {
        constructor(message, statusCode) {
            super(message);
            this._statusCode = statusCode;
        }
        get statusCode() {
            return this._statusCode;
        }
    }

    function getBaseUrl(context, url) {
        let baseUrl;
        if (typeof context.baseUrl === 'function') {
            baseUrl = context.baseUrl(url);
        }
        else {
            baseUrl = context.baseUrl;
        }
        const prefix = context.urlPrefix || 'frontegg';
        if (!baseUrl.endsWith('/')) {
            baseUrl += '/';
        }
        if (!baseUrl.endsWith(prefix)) {
            baseUrl += prefix;
        }
        return baseUrl;
    }
    function prepareUrl(context, url, params) {
        return __awaiter(this, void 0, void 0, function* () {
            const baseUrl = getBaseUrl(context, url);
            const paramsToSend = yield buildQueryParams(context, params);
            let finalUrl = url.startsWith('http') ? url : `${baseUrl}${url}`;
            const hasKeys = Object.keys(paramsToSend).length > 0;
            if (paramsToSend && hasKeys) {
                const urlParams = new URLSearchParams(paramsToSend);
                finalUrl += `?${urlParams}`;
            }
            return finalUrl;
        });
    }
    function buildRequestHeaders(context, contentType) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const authToken = yield ((_a = context === null || context === void 0 ? void 0 : context.tokenResolver) !== null && _a !== void 0 ? _a : ContextHolder.getAccessToken)();
            const headers = {};
            if (authToken) {
                headers.Authorization = `Bearer ${authToken}`;
            }
            if (contentType) {
                headers['Content-Type'] = contentType;
            }
            for (const additionalHeader of yield getAdditionalHeaders(context)) {
                headers[`${additionalHeader.key}`] = `${additionalHeader.value}`;
            }
            headers['x-frontegg-source'] = 'frontegg-react';
            return headers;
        });
    }
    function buildQueryParams(context, params) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!params) {
                params = {};
            }
            const additionalQueryParams = yield getAdditionalQueryParams(context);
            for (const queryParam of additionalQueryParams) {
                params[queryParam.key] = queryParam.value;
            }
            const keys = Object.keys(params);
            for (const key of keys) {
                const value = params[key];
                params[key] = typeof value === 'object' ? JSON.stringify(value) : value;
            }
            return params;
        });
    }
    function getAdditionalQueryParams(context) {
        return __awaiter(this, void 0, void 0, function* () {
            let output = [];
            if (context.additionalQueryParamsResolver) {
                output = yield context.additionalQueryParamsResolver();
            }
            return output;
        });
    }
    function getAdditionalHeaders(context) {
        return __awaiter(this, void 0, void 0, function* () {
            let output = [];
            if (context.additionalHeadersResolver) {
                output = yield context.additionalHeadersResolver();
            }
            return output;
        });
    }
    const sendRequest = (opts) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b, _c, _d, _e;
        const context = ContextHolder.getContext();
        const headers = yield buildRequestHeaders(context, opts.contentType);
        const url = yield prepareUrl(context, opts.url, opts.params);
        const response = yield fetch(url, {
            body: opts.body ? (opts.contentType === 'application/json' ? JSON.stringify(opts.body) : opts.body) : null,
            method: (_a = opts.method) !== null && _a !== void 0 ? _a : 'GET',
            headers: Object.assign(Object.assign({}, headers), opts.headers),
            credentials: (_c = (_b = opts.credentials) !== null && _b !== void 0 ? _b : context.requestCredentials) !== null && _c !== void 0 ? _c : 'same-origin',
        });
        if (response.status === 302) {
            window.location.href = yield response.text();
            return new Promise(() => {
            });
        }
        if (!response.ok) {
            if (response.status === 413) {
                throw new FronteggApiError('Error request is too large', response.status);
            }
            let errorMessage;
            try {
                errorMessage = yield response.text();
                errorMessage = JSON.parse(errorMessage);
            }
            catch (e) {
            }
            if (errorMessage.errors) {
                errorMessage = errorMessage.errors.join(', ');
            }
            else if (typeof errorMessage !== 'string') {
                errorMessage = `Error ${response.status} - ${response.statusText}`;
            }
            if (response.status >= 400 && response.status < 500 && ['warn'].includes((_d = context.logLevel) !== null && _d !== void 0 ? _d : ''))
                console.warn(errorMessage);
            else if (response.status === 500 && ['warn', 'error'].includes((_e = context.logLevel) !== null && _e !== void 0 ? _e : ''))
                console.error(errorMessage);
            throw new FronteggApiError(errorMessage, response.status);
        }
        if (!opts.responseType || opts.responseType === 'json') {
            try {
                return yield response.json();
            }
            catch (e) {
                return {};
            }
        }
        else if (opts.responseType === 'blob') {
            const { outputFileName } = opts.params;
            return yield response
                .blob()
                .then((blob) => URL.createObjectURL(blob))
                .then((url) => {
                const tempLink = document.createElement('a');
                tempLink.href = url;
                tempLink.setAttribute('download', outputFileName || 'output');
                tempLink.click();
            });
        }
        else {
            return yield response.text();
        }
    });
    const Get = (url, params, opts) => __awaiter(void 0, void 0, void 0, function* () {
        return sendRequest(Object.assign({ url, method: 'GET', contentType: 'application/json', params }, opts));
    });
    const Post = (url, body, opts) => __awaiter(void 0, void 0, void 0, function* () {
        return sendRequest(Object.assign({ url, method: 'POST', contentType: 'application/json', body }, opts));
    });
    const Patch = (url, body, opts) => __awaiter(void 0, void 0, void 0, function* () {
        return sendRequest(Object.assign({ url, method: 'PATCH', contentType: 'application/json', body }, opts));
    });
    const Put = (url, body, opts) => __awaiter(void 0, void 0, void 0, function* () {
        return sendRequest(Object.assign({ url, method: 'PUT', contentType: 'application/json', body }, opts));
    });
    const Delete = (url, body, opts) => __awaiter(void 0, void 0, void 0, function* () {
        return sendRequest(Object.assign({ url, method: 'DELETE', contentType: 'application/json', body }, opts));
    });
    const PostDownload = (url, body, params, opts) => __awaiter(void 0, void 0, void 0, function* () {
        return sendRequest(Object.assign({ url, method: 'POST', contentType: 'application/json', responseType: 'blob', body,
            params }, opts));
    });

    var fetch$1 = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getBaseUrl: getBaseUrl,
        Get: Get,
        Post: Post,
        Patch: Patch,
        Put: Put,
        Delete: Delete,
        PostDownload: PostDownload
    });

    const urls = {
        vendor: '/vendors',
        identity: {
            webAuthnDevices: {
                v1: '/identity/resources/users/webauthn/v1/devices',
            },
            auth: {
                v1: '/identity/resources/auth/v1',
                v2: '/identity/resources/auth/v2'
            },
            users: {
                v1: '/identity/resources/users/v1',
                v2: '/identity/resources/users/v2',
                apiTokens: {
                    v1: '/identity/resources/users/api-tokens/v1',
                },
                sessions: {
                    currentUser: {
                        v1: '/identity/resources/users/sessions/v1/me',
                    },
                    configurations: {
                        v1: '/identity/resources/configurations/sessions/v1'
                    }
                },
                invitation: {
                    resendAll: {
                        v1: '/identity/resources/users/v1/invitation/reset/all',
                    }
                }
            },
            configurations: {
                v1: '/identity/resources/configurations/v1'
            },
            sso: {
                v1: '/identity/resources/sso/v1',
                v2: '/identity/resources/sso/v2'
            },
            permissions: {
                v1: '/identity/resources/permissions/v1'
            },
            tenants: {
                apiTokens: {
                    v1: '/identity/resources/tenants/api-tokens/v1',
                    v2: '/identity/resources/tenants/api-tokens/v2'
                },
                invites: {
                    user: {
                        v1: '/identity/resources/tenants/invites/v1/user'
                    },
                    verify: {
                        v1: '/identity/resources/tenants/invites/v1/verify'
                    },
                    configuration: {
                        v1: '/identity/resources/tenants/invites/v1/configuration'
                    }
                }
            },
            roles: {
                v1: '/identity/resources/roles/v1'
            },
            subTenants: {
                v1: '/identity/resources/sub-tenants/users/v1'
            }
        },
        team: {
            sso: {
                v1: '/team/resources/sso/v1',
                v2: '/team/resources/sso/v2',
            },
            members: {
                v1: '/team/resources/members/v1'
            },
            roles: {
                v1: '/team/resources/roles/v1'
            },
            stats: {
                v1: '/team/resources/stats/v1'
            },
            profile: {
                v1: '/team/resources/profile' // no versioning in backend
            }
        },
        tenants: {
            accountSettings: {
                v1: '/tenants/resources/account-settings/v1'
            },
            hierarchy: {
                v1: '/tenants/resources/hierarchy/v1',
                tree: {
                    v1: '/tenants/resources/hierarchy/v1/tree'
                }
            }
        },
        integrations: {
            configurations: {
                v1: '/integrations/resources/configurations/v1',
                v2: '/integrations/resources/configurations/v2',
            }
        },
        subscriptions: {
            billing: {
                subscriptions: {
                    v1: '/subscriptions/resources/billing/subscriptions/v1'
                },
                plans: {
                    v1: '/subscriptions/resources/billing/plans/v1'
                },
                invoices: {
                    v1: '/subscriptions/resources/billing/invoices/v1'
                },
                paymentMethods: {
                    v1: '/subscriptions/resources/billing/payment-methods/v1'
                },
                summaries: {
                    v1: '/subscriptions/resources/billing/summaries/v1'
                },
                tenantConfiguration: {
                    v1: '/subscriptions/resources/billing/tenant-configurations/v1'
                },
                paymentProviders: {
                    stripe: {
                        customers: {
                            v1: '/subscriptions/resources/billing/payment-providers/stripe/customers/v1'
                        },
                        publicConfigurations: {
                            v1: '/subscriptions/resources/billing/payment-providers/stripe/public-configurations/v1'
                        },
                        subscriptions: {
                            v1: '/subscriptions/resources/billing/payment-providers/stripe/subscriptions/v1'
                        },
                        setupIntents: {
                            v1: '/subscriptions/resources/billing/payment-providers/stripe/setup-intents/v1'
                        }
                    }
                }
            },
            paymentProviders: {
                v1: '/subscriptions/resources/payment-providers/v1'
            },
            managedSubscriptions: {
                v1: '/subscriptions/resources/subscriptions/v1'
            }
        },
        reports: {
            service: {
                v1: '/reports/resources/reports/v1',
                v2: '/reports/resources/reports/v2'
            },
            trigger: {
                v1: '/reports/engine/resources/triggers/v1'
            }
        },
        notifications: {
            v1: '/notification'
        },
        audits: {
            v1: '/audits',
        },
        events: {
            configurations: {
                v1: '/event/resources/configurations/v1'
            }
        },
        webhooks: {
            v1: '/webhook'
        },
        oauth: {
            v1: '/oauth'
        },
    };

    /**
     * switch logged in user to specific tenant by providing tenantId.
     *
     * @throws exception if invalid tenantId.
     * ``authorized user``
     */
    function switchTenant(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('switchTenant()', body);
            return Put(`${urls.identity.users.v1}/tenant`, body);
        });
    }
    /**
     * retrieve logged in user's available tenants.
     *
     * ``authorized user``
     */
    function getTenants() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getTenants()');
            return Get(`${urls.identity.users.v2}/me/tenants`);
        });
    }
    /**
     * retrieve logged in user's available sub tenants.
     *
     * ``authorized user``
     */
    function getSubTenants() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getSubTenants()');
            return Get(urls.tenants.hierarchy.v1);
        });
    }
    /**
     * retrieve logged in user's available sub tenants as a tree.
     *
     * ``authorized user``
     */
    function getSubTenantsAsTree() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getSubTenantsAsTree()');
            return Get(urls.tenants.hierarchy.tree.v1);
        });
    }

    var tenants = /*#__PURE__*/Object.freeze({
        __proto__: null,
        switchTenant: switchTenant,
        getTenants: getTenants,
        getSubTenants: getSubTenants,
        getSubTenantsAsTree: getSubTenantsAsTree
    });

    /**
     * Get global secure access configuration
     */
    function getGlobalSecurityPolicy() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getGlobalSecurityPolicy()');
            return Get(urls.identity.configurations.v1);
        });
    }
    /**
     * Get Mfa configuration from security policy
     */
    function getMfaPolicy() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getMfaPolicy()');
            return Get(`${urls.identity.configurations.v1}/mfa-policy`);
        });
    }
    /**
     * Get Mfa configuration from security policy
     */
    function getVendorMfaPolicy() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getVendorMfaPolicy()');
            return Get(`${urls.identity.configurations.v1}/mfa-policy/vendor`);
        });
    }
    /**
     * Create/Update Mfa configuration from security policy
     */
    function saveMfaPolicy(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('saveMfaPolicy()');
            if (body.id) {
                return Patch(`${urls.identity.configurations.v1}/mfa-policy`, body);
            }
            else {
                return Post(`${urls.identity.configurations.v1}/mfa-policy`, body);
            }
        });
    }
    /**
     * Get Lockout configuration from security policy
     */
    function getLockoutPolicy() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getLockoutPolicy()');
            return Get(`${urls.identity.configurations.v1}/lockout-policy`);
        });
    }
    /**
     * Create/Update Lockout configuration from security policy
     */
    function saveLockoutPolicy(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('saveLockoutPolicy()');
            if (body.id) {
                return Patch(`${urls.identity.configurations.v1}/lockout-policy`, body);
            }
            else {
                return Post(`${urls.identity.configurations.v1}/lockout-policy`, body);
            }
        });
    }
    /**
     * Get Captcha configuration from security policy
     */
    function getCaptchaPolicy() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                return yield Get(`${urls.identity.configurations.v1}/captcha-policy/public`);
            }
            catch (_a) {
                return null;
            }
        });
    }
    /**
     * Get Password History configuration from security policy
     */
    function getPasswordHistoryPolicy() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getPasswordHistoryPolicy()');
            return Get(`${urls.identity.configurations.v1}/password-history-policy`);
        });
    }
    /**
     * Create/Update Password History configuration from security policy
     */
    function savePasswordHistoryPolicy(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('savePasswordHistoryPolicy()');
            if (body.id) {
                return Patch(`${urls.identity.configurations.v1}/password-history-policy`, body);
            }
            else {
                return Post(`${urls.identity.configurations.v1}/password-history-policy`, body);
            }
        });
    }
    /**
     * load vendor password configuration.
     */
    function getPasswordConfigPolicy() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getPasswordConfigPolicy()');
            return Get(`${urls.identity.configurations.v1}/password`);
        });
    }

    exports.SocialLoginProviders = void 0;
    (function (SocialLoginProviders) {
        SocialLoginProviders["Microsoft"] = "microsoft";
        SocialLoginProviders["Facebook"] = "facebook";
        SocialLoginProviders["Google"] = "google";
        SocialLoginProviders["Github"] = "github";
    })(exports.SocialLoginProviders || (exports.SocialLoginProviders = {}));
    exports.AuthStrategyEnum = void 0;
    (function (AuthStrategyEnum) {
        AuthStrategyEnum["EmailAndPassword"] = "EmailAndPassword";
        AuthStrategyEnum["MagicLink"] = "MagicLink";
        AuthStrategyEnum["Code"] = "Code";
        AuthStrategyEnum["NoLocalAuthentication"] = "NoLocalAuthentication";
        AuthStrategyEnum["SmsCode"] = "SmsCode";
    })(exports.AuthStrategyEnum || (exports.AuthStrategyEnum = {}));

    /**
     * The code was extracted from:
     * https://github.com/davidchambers/Base64.js
     */
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
    class InvalidCharacterError extends Error {
        constructor(message) {
            super(message);
        }
    }
    function polyfill(input) {
        const str = String(input).replace(/=+$/, '');
        if (str.length % 4 === 1) {
            throw new InvalidCharacterError("'atob' failed: The string to be decoded is not correctly encoded.");
        }
        let output = '';
        // noinspection JSAssignmentUsedAsCondition,JSUnusedAssignment,CommaExpressionJS
        for (
        // initialize result and counters
        let bc = 0, bs, buffer, idx = 0; 
        // get next character
        // tslint:disable-next-line:no-conditional-assignment
        (buffer = str.charAt(idx++)); 
        // character found in table? initialize bit storage and add its ascii value;
        // tslint:disable-next-line:no-conditional-assignment
        ~buffer &&
            ((bs = bc % 4 ? bs * 64 + buffer : buffer),
                // and if not first of each 4 characters,
                // convert the first 8 bits to one ascii character
                bc++ % 4)
            ? (output += String.fromCharCode(255 & (bs >> ((-2 * bc) & 6))))
            : 0) {
            // try to find character in table (0-63, not found => -1)
            buffer = chars.indexOf(buffer);
        }
        return output;
    }
    const atob = (typeof window !== 'undefined' && window.atob && window.atob.bind(window)) || polyfill;
    function b64DecodeUnicode(str) {
        return decodeURIComponent(atob(str).replace(/(.)/g, (m, p) => {
            let code = p.charCodeAt(0).toString(16).toUpperCase();
            if (code.length < 2) {
                code = '0' + code;
            }
            return '%' + code;
        }));
    }
    const base64UrlDecode = (str) => {
        let output = str.replace(/-/g, '+').replace(/_/g, '/');
        switch (output.length % 4) {
            case 0:
                break;
            case 2:
                output += '==';
                break;
            case 3:
                output += '=';
                break;
            default:
                throw new Error('Illegal base64url string!');
        }
        try {
            return b64DecodeUnicode(output);
        }
        catch (err) {
            return atob(output);
        }
    };
    class InvalidTokenError extends Error {
        constructor(message) {
            super(message);
        }
    }
    const jwtDecode = (token, options = {}) => {
        const pos = !!options.header ? 0 : 1;
        try {
            return JSON.parse(base64UrlDecode(token.split('.')[pos]));
        }
        catch (e) {
            throw new InvalidTokenError('Invalid token specified: ' + e.message);
        }
    };

    /*****************************************
     * Authentication
     *****************************************/
    function generateLoginResponse(loginResponse) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!loginResponse.accessToken) {
                return loginResponse;
            }
            ContextHolder.setAccessToken(loginResponse.accessToken);
            const me = yield Get(`${urls.identity.users.v2}/me`);
            const decodedContent = loginResponse.accessToken ? jwtDecode(loginResponse.accessToken) : {};
            const user = Object.assign(Object.assign(Object.assign({}, loginResponse), decodedContent), me);
            ContextHolder.setUser(user);
            return user;
        });
    }
    function generateLoginResponseV2(loginResponse) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!loginResponse.accessToken) {
                return { user: loginResponse };
            }
            ContextHolder.setAccessToken(loginResponse.accessToken);
            const [me, tenants] = yield Promise.all([Get(`${urls.identity.users.v2}/me`), getTenants()]);
            const decodedContent = loginResponse.accessToken ? jwtDecode(loginResponse.accessToken) : {};
            const user = Object.assign(Object.assign(Object.assign({}, loginResponse), decodedContent), me);
            ContextHolder.setUser(user);
            return { user, tenants };
        });
    }
    function generateLoginResponseFromOAuthResponse(oauthResponse) {
        return __awaiter(this, void 0, void 0, function* () {
            ContextHolder.setAccessToken(oauthResponse.id_token);
            const me = yield Get(`${urls.identity.users.v2}/me`);
            const decodedContent = oauthResponse.id_token ? jwtDecode(oauthResponse.id_token) : {};
            const user = Object.assign(Object.assign({ mfaRequired: false, accessToken: oauthResponse.id_token, refreshToken: oauthResponse.refresh_token }, decodedContent), me);
            ContextHolder.setUser(user);
            return user;
        });
    }
    /**
     * Check if requested email address has sso configuration
     * If true, this function will return the sso address to navigate to
     * else, return null
     */
    function preLogin(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('preLogin()', body);
            try {
                const { address } = yield Post(`${urls.identity.auth.v1}/user/saml/prelogin`, body);
                return address;
            }
            catch (_a) {
                return null;
            }
        });
    }
    /**
     * Check if requested email address has sso configuration
     * If true, this function will return the sso address and IdpType to navigate to
     */
    function preLoginWithIdpType(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('preLoginWithIdpType()', body);
            return Post(`${urls.identity.auth.v1}/user/saml/prelogin`, body);
        });
    }
    /**
     * After calling preLogin and navigated to SSO url, the IDP will redirect you to the ACS Url
     * Which configured in the SSO configuraation
     * else, return null
     */
    function postLogin(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('postLogin()');
            const data = yield Post(`${urls.identity.auth.v1}/user/saml/postlogin`, body);
            return generateLoginResponse(data);
        });
    }
    /**
     * After calling preLogin and navigated to SSO url, the IDP will redirect you to the redirect url
     * with code and state
     */
    function oidcPostLogin(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('oidcPostLogin()');
            const data = yield Post(`${urls.identity.auth.v1}/user/oidc/postlogin`, body);
            return generateLoginResponse(data);
        });
    }
    /**
     * login with username and password.
     * if the user has two factor authentication
     *    the server will return mfaToken with mfaRequired: true,
     *    and then ``loginWithMfa`` should be called with the mfaToken and and generated code
     * else, the server will accessToken and refreshToken.
     * the refresh should be used to renew your access token by calling ``refreshToken``
     *
     * @throw exception if login failed
     */
    function login(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('login()');
            const data = yield Post(`${urls.identity.auth.v1}/user`, body);
            return generateLoginResponse(data);
        });
    }
    /**
     * after login succeeded with mfaRequired token response, this function should be called
     * with the mfaToken and the generated code from your authenticator app.
     *
     * @throw exception if generated code or mfaToken are incorrect
     */
    function loginWithMfa(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('loginWithMfa()');
            const data = yield Post(`${urls.identity.auth.v1}/user/mfa/verify`, body);
            return generateLoginResponse(data);
        });
    }
    /**
     * activating account should be called after registering new user of deactivate account
     * ``activateAccount`` should contains userId and the token that has been sent to the user after activation requested.
     *
     * @throws exception if activation failed
     */
    function activateAccount(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('activateAccount()');
            return Post(`${urls.identity.users.v1}/activate`, body);
        });
    }
    /**
     * get account activation configuration.
     */
    function getActivateAccountStrategy(params) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getActivateAccountStrategy()');
            return Get(`${urls.identity.users.v1}/activate/strategy`, params);
        });
    }
    /**
     * resend activation email should be called after a failed user activation.
     * ``resend activation email`` should contain  the user email.
     *
     * @throws exception if resend failed
     */
    function resendActivationEmail(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('resendActivationEmail()');
            return Post(`${urls.identity.users.v1}/activate/reset`, body);
        });
    }
    /**
     * activating account should be called after registering new user of deactivate account
     * ``activateAccount`` should contains userId and the token that has been sent to the user after activation requested.
     *
     * @throws exception if activation failed
     */
    function acceptInvitation(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('acceptInvitation()');
            return Post(`${urls.identity.users.v1}/invitation/accept`, body);
        });
    }
    /**
     * refresh token called as authenticated use, access and refresh tokens resolved by the cookies.
     * the server will return ILoginResponse with new access Token and refresh token and store it in the browser cookies.
     */
    function refreshToken() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('refreshToken()');
            const data = yield Post(`${urls.identity.auth.v1}/user/token/refresh`);
            return generateLoginResponse(data);
        });
    }
    /**
     * refresh token called as authenticated use, access and refresh tokens resolved by the cookies.
     * the server will return ILoginResponseV2 with new access Token and refresh token and store it in the browser cookies, as well as the tenants.
     */
    function refreshTokenV2() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('refreshTokenV2()');
            const data = yield Post(`${urls.identity.auth.v1}/user/token/refresh`);
            return generateLoginResponseV2(data);
        });
    }
    /**
     * logout from server, invalidate access and refresh token, remove it from cookies.
     */
    function logout() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('logout()');
            return Post(`${urls.identity.auth.v1}/logout`);
        });
    }
    /**
     * calling forgot password request will send email with link to reset user's password.
     *
     * @throws exception if the user not found
     */
    function forgotPassword(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('forgotPassword()', body);
            return Post(`${urls.identity.users.v1}/passwords/reset`, body);
        });
    }
    /**
     * reset password should be called after forget password request.
     * userId, new password and the token has been sent to the user email.
     *
     * @throws exception if the user not found, password validation failed or invalid token.
     */
    function resetPassword(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('resetPassword()');
            return Post(`${urls.identity.users.v1}/passwords/reset/verify`, body);
        });
    }
    /**
     * load password configuration for user.
     */
    function loadPasswordConfig(params) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('loadPasswordConfig()');
            return Get(`${urls.identity.users.v1}/passwords/config`, params);
        });
    }
    /**
     * recover Multi-Factor authentication by providing the recoveryCode
     * that has been received when activated it
     *
     * @throws exception if recovery code is not valid
     */
    function recoverMfaToken(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('recoverMfaToken()', body);
            return Post(`${urls.identity.auth.v1}/user/mfa/recover`, body);
        });
    }
    /**
     * Multi-Factor Settings
     */
    /**
     * enroll Multi-Factor Auth Code to use in 3rd party apps like Google Authenticator.
     * the server returns qrCode as png image in base64 format
     *
     * @throws exception if the user already have mfa-enabled
     * ``authorized user``
     */
    function enrollMfa() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('enrollMfa()');
            return Post(`${urls.identity.users.v1}/mfa/enroll`);
        });
    }
    /**
     * after enrolling MFA QR code, verify function should be called
     * with the generated code in the Authenticator App
     *
     * @return recoveryCode to use to disable mfa if your device is lost, this code won't show it again.
     * @throws exception if the generated token is invalid
     * ``authorized user``
     */
    function verifyMfa(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('verifyMfa()', body);
            return Post(`${urls.identity.users.v1}/mfa/enroll/verify`, body);
        });
    }
    /**
     * disable MFA by either passing the recoveryCode or the generated code from the Authenticator App.
     *
     * @throws exception if the generated token or the recoveryCode are incorrect.
     * * ``authorized user``
     */
    function disableMfa(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('disableMfa()', body);
            return Post(`${urls.identity.users.v1}/mfa/disable`, body);
        });
    }
    /**
     * SSO Configurations
     */
    /**
     *  Retrieve SAML configurations from server by logged in user (tenantId, vendorId)
     *
     *  @return {enabled: false} if no saml configuration found. else ISamlConfiguration
     * * ``authorized user``
     */
    function getSamlConfiguration() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getSamlConfiguration()');
            return Get(`${urls.team.sso.v1}/saml/configurations`);
        });
    }
    /**
     *  Update SAML configuration by logged in user (tenantId, vendorId)
     * * ``authorized user``
     */
    function updateSamlConfiguration(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('updateSamlConfiguration()', body);
            return Post(`${urls.team.sso.v1}/saml/configurations`, body);
        });
    }
    /**
     *  Retrieve 'Vendor' Saml config from server by logged in user (tenantId, vendorId)
     *
     *  @throws exception 'ACS url information not found' if no saml vendor configuration found.
     * * ``authorized user``
     */
    function getSamlVendorConfiguration() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getSamlVendorConfiguration()');
            return Get(`${urls.team.sso.v1}/saml/configurations/vendor-config`);
        });
    }
    /**
     *  Update Vendor Saml metadata by logged in user (tenantId, vendorId)
     *
     *  @return {enabled: false} if no saml configuration found. else ISamlConfiguration
     * * ``authorized user``
     */
    function updateSamlVendorMetadata(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('updateSamlVendorMetadata()', body);
            return Put(`${urls.team.sso.v1}/saml/configurations/metadata`, body);
        });
    }
    /**
     *  Validate Saml configuration's domain by logged in user (tenantId, vendorId)
     *
     *  @return {enabled: false} if no saml configuration found. else ISamlConfiguration
     * * ``authorized user``
     */
    function validateSamlDomain() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('validateSamlDomain()');
            return Put(`${urls.team.sso.v1}/saml/validations/domain`);
        });
    }
    /**
     *  Get Saml roles for authorization
     * @return array of role IDs
     */
    function getSamlRoles() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getSamlRoles()');
            return Get(`${urls.team.sso.v1}/saml/configurations/roles/default`);
        });
    }
    /**
     *  Get Saml roles groups
     * @return array of groups and assigend role IDs
     */
    function getSamlRolesGroups() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getSamlRoles()');
            return Get(`${urls.team.sso.v2}/saml/configurations/groups`);
        });
    }
    /**
     *  Update Saml roles for authorization
     */
    function updateSamlRoles({ roleIds }) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('updateSamlRoles()');
            return Post(`${urls.team.sso.v1}/saml/configurations/roles/default`, { roleIds });
        });
    }
    /**
     *  Create Saml group roles for authorization
     */
    function createSamlGroup({ roleIds, group }) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('createSamlGroup()');
            return Post(`${urls.team.sso.v2}/saml/configurations/groups`, { group, roleIds });
        });
    }
    /**
     *  Update Saml group roles for authorization
     */
    function updateSamlGroup({ roleIds, group, id }) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('updateSamlGroup()');
            return Patch(`${urls.team.sso.v2}/saml/configurations/groups/${id}`, { group, roleIds });
        });
    }
    /**
     *  Delete Saml group
     */
    function deleteSamlGroup({ id }) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('deleteSamlGroup()');
            return Delete(`${urls.team.sso.v2}/saml/configurations/groups/${id}`);
        });
    }
    /**
     *  Retrieve OIDC configurations from server by logged in user (vendorId)
     *
     *  @return {active: true} if no oidc configuration found. else IOidcConfiguration
     * * ``authorized user``
     */
    function getOidcConfiguration() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getOidcConfiguration()');
            return Get(`${urls.team.sso.v1}/oidc/configurations`);
        });
    }
    /**
     *  Check if one or more saml/oidc configuration are active
     *
     **  @return {isActive: true/false}
     */
    function getSSOPublicConfiguration() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getSSOPublicConfiguration()');
            return Get(`${urls.team.sso.v2}/configurations/public`);
        });
    }
    /**
     *  Get social logins providers configurations for vendor
     * @return array of providers configurations
     */
    function getSocialLoginProviders() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getSocialLoginProviders()');
            return Get(urls.identity.sso.v1);
        });
    }
    /**
     *  Get social logins providers configurations V2 supports dev credentials as well
     * @return array of providers configurations
     */
    function getSocialLoginProvidersV2() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getSocialLoginProvidersV2()');
            return Get(urls.identity.sso.v2);
        });
    }
    /**
     * Login using social login
     * @return cookie with refresh token
     */
    function loginViaSocialLogin({ provider, code, redirectUri, codeVerifier, metadata, invitationToken, state, }) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('loginViaSocialLogin()');
            const params = { code };
            if (redirectUri) {
                params.redirectUri = redirectUri;
            }
            if (codeVerifier) {
                params.code_verifier = codeVerifier;
            }
            if (state) {
                params.state = state;
            }
            return Post(`${urls.identity.auth.v1}/user/sso/${provider}/postlogin`, { metadata, invitationToken }, { params });
        });
    }
    /**
     * Get vendor secure access configuration
     */
    function getVendorConfig() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getVendorConfig()');
            return Get(`${urls.identity.configurations.v1}/public`);
        });
    }
    /**
     * Sign up new user
     * create new user with a new tenant
     */
    function signUpUser(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('signUpUser()', body);
            const { shouldActivate, authResponse, userId, tenantId } = yield Post(`${urls.identity.users.v1}/signUp`, body);
            const loginResponse = !shouldActivate && authResponse ? yield generateLoginResponse(authResponse) : undefined;
            return { shouldActivate, user: loginResponse, userId, tenantId };
        });
    }
    /**
     * Get all current user active sessions
     */
    function getCurrentUserSessions() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getCurrentUserSessions');
            const sessions = yield Get(urls.identity.users.sessions.currentUser.v1);
            return sessions;
        });
    }
    /**
     * Get session configurations
     */
    function getSessionConfigurations() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getSessionConfigurations');
            const sessionsConfigurations = yield Get(urls.identity.users.sessions.configurations.v1);
            return sessionsConfigurations;
        });
    }
    /**
     * Create or update session configurations
     */
    function createOrUpdateSessionConfigrations(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('createOrUpdateSessionConfigrations');
            yield Post(urls.identity.users.sessions.configurations.v1, body);
        });
    }
    /**
     * Delete user session
     */
    function deleteSessionForUser(id) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('deleteSessionForUser', id);
            yield Delete(`${urls.identity.users.sessions.currentUser.v1}/${id}`);
        });
    }
    /**
     * Delete all user sessions
     */
    function deleteAllSessionsForUser() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('deleteAllSessionsForUser');
            yield Delete(`${urls.identity.users.sessions.currentUser.v1}/all`);
        });
    }
    /**
     * Api tokens Configurations
     */
    /**
     * Get user api tokens data
     */
    function getUserApiTokensData() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getUserApiTokensData()');
            return Get(urls.identity.users.apiTokens.v1);
        });
    }
    /**
     * Get tenant api tokens data
     */
    function getTenantApiTokensData() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('geTenantApiTokensData()');
            return Get(urls.identity.tenants.apiTokens.v1);
        });
    }
    /**
     *  Update User Api Tokens
     */
    function updateUserApiTokensData(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('updateUserApiTokensData()', body);
            return Post(urls.identity.users.apiTokens.v1, body);
        });
    }
    /**
     * Update Tenant Api Tokens
     */
    function updateTenantApiTokensData(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('updateTenantApiTokensData()', body);
            return Post(urls.identity.tenants.apiTokens.v2, body);
        });
    }
    /**
     * Delete Tenant Api Token
     */
    function deleteTenantApiToken({ tokenId }) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('deleteTenantApiToken()', tokenId);
            return Delete(`${urls.identity.tenants.apiTokens.v1}/${tokenId}`);
        });
    }
    /**
     * Delete Tenant Api Token
     */
    function deleteUserApiToken({ tokenId }) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('deleteUserApiToken()', tokenId);
            return Delete(`${urls.identity.users.apiTokens.v1}/${tokenId}`);
        });
    }
    /**
     * Get Tenant Api Token Creator User
     */
    function getUserById({ userId }) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getUserById()');
            return Get(`${urls.identity.users.v1}/${userId}`);
        });
    }
    /**
     * Checks if remember MFA device is enabled for user.
     */
    function checkIfAllowToRememberMfaDevice(mfaToken) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('checkIfAllowToRememberMfaDevice()');
            return Get(`${urls.identity.configurations.v1}/mfa-policy/allow-remember-device`, { mfaToken });
        });
    }
    /**
     * Passwordless prelogin authentication
     */
    function passwordlessPreLogin(_a) {
        var { type } = _a, body = __rest(_a, ["type"]);
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('passwordlessPrelogin()');
            return Post(`${urls.identity.auth.v1}/passwordless/${type.toLocaleLowerCase()}/prelogin`, body);
        });
    }
    function passwordlessPostLogin(_a) {
        var { type } = _a, body = __rest(_a, ["type"]);
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('passwordlessPostLogin()');
            return Post(`${urls.identity.auth.v1}/passwordless/${type.toLocaleLowerCase()}/postlogin`, body);
        });
    }
    /**
     * Check if tenant invitation token is valid
     * @param token - invitation token
     * @returns tenant name
     */
    function verifyInviteToken({ token }) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('verifyInviteToken()');
            return Post(urls.identity.tenants.invites.verify.v1, { token });
        });
    }
    /**
     * SSO Configurations V1
     */
    /**
     *  Retrieve SSO configurations from server by logged in user (tenantId, vendorId)
     *
     *  @return ISSOConfiguration[]
     * * ``authorized user``
     */
    function getSSOConfigurations() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getSSOConfigurations()');
            return Get(`${urls.team.sso.v1}/configurations`);
        });
    }
    /**
     *  Create SSO configuration by logged in user (tenantId, vendorId)
     *
     *  @returns ISSOConfiguration
     * * ``authorized user``
     */
    function createSSOConfiguration(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('createSSOConfiguration()', body);
            return Post(`${urls.team.sso.v1}/configurations`, body);
        });
    }
    /**
     *  Update SSO configuration by logged in user (tenantId, vendorId)
     *
     *  @returns ISSOConfiguration
     * * ``authorized user``
     */
    function updateSSOConfiguration(ssoConfigId, body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('updateSSOConfiguration()', { body, ssoConfigId });
            return Patch(`${urls.team.sso.v1}/configurations/${ssoConfigId}`, body);
        });
    }
    /**
     *  Delete SSO configuration by logged in user (tenantId, vendorId)
     * * ``authorized user``
     */
    function deleteSSOConfiguration(ssoConfigId) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('deleteSSOConfiguration()', { ssoConfigId });
            return Delete(`${urls.team.sso.v1}/configurations/${ssoConfigId}`);
        });
    }
    /**
     *  Create SSO configuration by metadata by logged in user (tenantId, vendorId)
     *
     *  @returns ISSOConfiguration
     * * ``authorized user``
     */
    function createSSOConfigurationByMetadata(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('createSSOConfigurationByMetadata()', body);
            return Post(`${urls.team.sso.v1}/configurations/metadata`, body);
        });
    }
    /**
     *  Update SSO configuration by metadata by logged in user (tenantId, vendorId)
     *
     *  @returns ISSOConfiguration
     * * ``authorized user``
     */
    function updateSSOConfigurationByMetadata(ssoConfigId, body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('updateSSOConfigurationByMetadata()', { body, ssoConfigId });
            return Put(`${urls.team.sso.v1}/configurations/${ssoConfigId}/metadata`, body);
        });
    }
    /**
     *  Create SSO configuration domain by logged in user (tenantId, vendorId)
     *
     *  @returns ISSODomain
     * * ``authorized user``
     */
    function createSSODomain(ssoConfigId, body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('createSSODomain()', { body, ssoConfigId });
            return Post(`${urls.team.sso.v1}/configurations/${ssoConfigId}/domains`, body);
        });
    }
    /**
     *  Create SSO configuration domain by logged in user (tenantId, vendorId)
     * * ``authorized user``
     */
    function deleteSSODomain(ssoConfigId, domainId) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('deleteSSODomain()', { domainId, ssoConfigId });
            return Delete(`${urls.team.sso.v1}/configurations/${ssoConfigId}/domains/${domainId}`);
        });
    }
    /**
     *  Validate SSO configuration domain by logged in user (tenantId, vendorId)
     * * ``authorized user``
     */
    function validateSSODomain(ssoConfigId, domainId) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('validateSSODomain()', { domainId, ssoConfigId });
            return Put(`${urls.team.sso.v1}/configurations/${ssoConfigId}/domains/${domainId}/validate`);
        });
    }
    /**
     *  Get SSO configuration default roles by logged in user (tenantId, vendorId)
     * * ``authorized user``
     */
    function getSSODefaultRoles(ssoConfigId) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getSSODefaultRoles()', { ssoConfigId });
            return Get(`${urls.team.sso.v1}/configurations/${ssoConfigId}/roles`);
        });
    }
    /**
     *  Create SSO configuration default roles by logged in user (tenantId, vendorId)
     * * ``authorized user``
     */
    function setSSODefaultRoles(ssoConfigId, body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('setSSODefaultRoles()', { body, ssoConfigId });
            return Put(`${urls.team.sso.v1}/configurations/${ssoConfigId}/roles`, body);
        });
    }
    /**
     *  Create SSO configuration group roles for authorization
     */
    function createSSOGroup(ssoConfigId, body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('createSSOGroup()', { body, ssoConfigId });
            return Post(`${urls.team.sso.v1}/configurations/${ssoConfigId}/groups`, body);
        });
    }
    /**
     *  Update SSO configuration group roles for authorization
     */
    function updateSSOGroup(ssoConfigId, { roleIds, group, id }) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('updateSSOGroup()', { ssoConfigId, roleIds, group });
            return Patch(`${urls.team.sso.v1}/configurations/${ssoConfigId}/groups/${id}`, { group, roleIds });
        });
    }
    /**
     *  Delete SSO configuration group
     */
    function deleteSSOGroup(ssoConfigId, groupId) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('deleteSSOGroup()', { ssoConfigId, groupId });
            return Delete(`${urls.team.sso.v1}/configurations/${ssoConfigId}/groups/${groupId}`);
        });
    }
    /**
     *  Get SSO configuration groups
     */
    function getSSOGroups(ssoConfigId) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getSSOGroups()', { ssoConfigId });
            return Get(`${urls.team.sso.v1}/configurations/${ssoConfigId}/groups`);
        });
    }
    /**
     * Check if requested email address has sso configuration
     * If true, this function will return the sso address to navigate to
     * else, return null
     */
    function preLoginV2(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('preLoginV2()', body);
            return Post(`${urls.identity.auth.v2}/user/sso/prelogin`, body);
        });
    }
    /**
     * After calling preLogin and navigated to SSO url, the IDP will redirect you to the redirect url
     * with code and state
     */
    function oidcPostLoginV2(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('oidcPostLoginV2()');
            const data = yield Post(`${urls.identity.auth.v2}/user/oidc/postlogin`, body);
            return generateLoginResponse(data);
        });
    }
    function exchangeOAuthTokens(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('exchangeOauthTokens()');
            const data = yield Post(`${urls.oauth.v1}/token`, body);
            return generateLoginResponseFromOAuthResponse(data);
        });
    }
    /**
     * reset phone should be called in case user want to reset his phone number
     * when using sms authentication strategy. a 6-digits code will be send to the user email.
     */
    function resetPhoneNumber(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('resetPhoneNumber()', body);
            return Post(`${urls.identity.users.v1}/phone/reset`, body);
        });
    }
    /**
     * verify reset phone should be called after reset phone number request
     * with the token received from the reset phone number request and a code that was sent to the user email
     */
    function verifyResetPhoneNumber(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('verifyResetPhoneNumber()', body);
            return Post(`${urls.identity.users.v1}/phone/reset/verify`, body);
        });
    }
    /**
     * change phone number with verification.
     */
    function changePhoneNumberWithVerification(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('changePhoneNumberWithVerification()', body);
            return Post(`${urls.identity.users.v1}/phone`, body);
        });
    }
    /**
     * verify new phone number.
     */
    function verifyChangePhoneNumber(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('verifyChangePhoneNumber()', body);
            return Post(`${urls.identity.users.v1}/phone/verify`, body);
        });
    }
    /**
     * change phone number should be called after verify reset phone number with the new phone number
     */
    function changePhoneNumber(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('changePhoneNumber()', body);
            return Put(`${urls.identity.users.v1}/phone/change`, body);
        });
    }
    /**
     * webauthn prelogin should be called when the user wants to be authenticated using his device/android/usb key
     */
    function webAuthnPreLogin(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('webAuthnPreLogin()', body);
            return Post(`${urls.identity.auth.v1}/webauthn/prelogin`, body);
        });
    }
    /**
     * webauthn postlogin should be called after the user used his authenticator (device/android/usb key) in order to login
     */
    function webAuthnPostLogin(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('webAuthnPostLogin()', body);
            return Post(`${urls.identity.auth.v1}/webauthn/postlogin`, body);
        });
    }
    /**
     * webauthn create new device should be called once the user wants to add new device as authenticator
     */
    function webAuthnCreateNewDeviceSession() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('webAuthnCreateNewDeviceSession()');
            return Post(urls.identity.webAuthnDevices.v1);
        });
    }
    /**
     * webauthn verify new device should be called after the user used his authenticator in order to register the new device
     */
    function verifyNewDeviceSession(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('verifyNewDeviceSession()', body);
            return Post(`${urls.identity.webAuthnDevices.v1}/verify`, body);
        });
    }
    /**
     * Get public vendor auth strategies public configuration
     */
    function getVendorPublicAuthStrategiesConfig() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getVendorPublicAuthStrategiesConfig()');
            return Get(`${urls.identity.configurations.v1}/auth/strategies/public`);
        });
    }

    var auth = /*#__PURE__*/Object.freeze({
        __proto__: null,
        generateLoginResponse: generateLoginResponse,
        generateLoginResponseV2: generateLoginResponseV2,
        generateLoginResponseFromOAuthResponse: generateLoginResponseFromOAuthResponse,
        preLogin: preLogin,
        preLoginWithIdpType: preLoginWithIdpType,
        postLogin: postLogin,
        oidcPostLogin: oidcPostLogin,
        login: login,
        loginWithMfa: loginWithMfa,
        activateAccount: activateAccount,
        getActivateAccountStrategy: getActivateAccountStrategy,
        resendActivationEmail: resendActivationEmail,
        acceptInvitation: acceptInvitation,
        refreshToken: refreshToken,
        refreshTokenV2: refreshTokenV2,
        logout: logout,
        forgotPassword: forgotPassword,
        resetPassword: resetPassword,
        loadPasswordConfig: loadPasswordConfig,
        recoverMfaToken: recoverMfaToken,
        enrollMfa: enrollMfa,
        verifyMfa: verifyMfa,
        disableMfa: disableMfa,
        getSamlConfiguration: getSamlConfiguration,
        updateSamlConfiguration: updateSamlConfiguration,
        getSamlVendorConfiguration: getSamlVendorConfiguration,
        updateSamlVendorMetadata: updateSamlVendorMetadata,
        validateSamlDomain: validateSamlDomain,
        getSamlRoles: getSamlRoles,
        getSamlRolesGroups: getSamlRolesGroups,
        updateSamlRoles: updateSamlRoles,
        createSamlGroup: createSamlGroup,
        updateSamlGroup: updateSamlGroup,
        deleteSamlGroup: deleteSamlGroup,
        getOidcConfiguration: getOidcConfiguration,
        getSSOPublicConfiguration: getSSOPublicConfiguration,
        getSocialLoginProviders: getSocialLoginProviders,
        getSocialLoginProvidersV2: getSocialLoginProvidersV2,
        loginViaSocialLogin: loginViaSocialLogin,
        getVendorConfig: getVendorConfig,
        signUpUser: signUpUser,
        getCurrentUserSessions: getCurrentUserSessions,
        getSessionConfigurations: getSessionConfigurations,
        createOrUpdateSessionConfigrations: createOrUpdateSessionConfigrations,
        deleteSessionForUser: deleteSessionForUser,
        deleteAllSessionsForUser: deleteAllSessionsForUser,
        getUserApiTokensData: getUserApiTokensData,
        getTenantApiTokensData: getTenantApiTokensData,
        updateUserApiTokensData: updateUserApiTokensData,
        updateTenantApiTokensData: updateTenantApiTokensData,
        deleteTenantApiToken: deleteTenantApiToken,
        deleteUserApiToken: deleteUserApiToken,
        getUserById: getUserById,
        checkIfAllowToRememberMfaDevice: checkIfAllowToRememberMfaDevice,
        passwordlessPreLogin: passwordlessPreLogin,
        passwordlessPostLogin: passwordlessPostLogin,
        verifyInviteToken: verifyInviteToken,
        getSSOConfigurations: getSSOConfigurations,
        createSSOConfiguration: createSSOConfiguration,
        updateSSOConfiguration: updateSSOConfiguration,
        deleteSSOConfiguration: deleteSSOConfiguration,
        createSSOConfigurationByMetadata: createSSOConfigurationByMetadata,
        updateSSOConfigurationByMetadata: updateSSOConfigurationByMetadata,
        createSSODomain: createSSODomain,
        deleteSSODomain: deleteSSODomain,
        validateSSODomain: validateSSODomain,
        getSSODefaultRoles: getSSODefaultRoles,
        setSSODefaultRoles: setSSODefaultRoles,
        createSSOGroup: createSSOGroup,
        updateSSOGroup: updateSSOGroup,
        deleteSSOGroup: deleteSSOGroup,
        getSSOGroups: getSSOGroups,
        preLoginV2: preLoginV2,
        oidcPostLoginV2: oidcPostLoginV2,
        exchangeOAuthTokens: exchangeOAuthTokens,
        resetPhoneNumber: resetPhoneNumber,
        verifyResetPhoneNumber: verifyResetPhoneNumber,
        changePhoneNumberWithVerification: changePhoneNumberWithVerification,
        verifyChangePhoneNumber: verifyChangePhoneNumber,
        changePhoneNumber: changePhoneNumber,
        webAuthnPreLogin: webAuthnPreLogin,
        webAuthnPostLogin: webAuthnPostLogin,
        webAuthnCreateNewDeviceSession: webAuthnCreateNewDeviceSession,
        verifyNewDeviceSession: verifyNewDeviceSession,
        getVendorPublicAuthStrategiesConfig: getVendorPublicAuthStrategiesConfig,
        getGlobalSecurityPolicy: getGlobalSecurityPolicy,
        getMfaPolicy: getMfaPolicy,
        getVendorMfaPolicy: getVendorMfaPolicy,
        saveMfaPolicy: saveMfaPolicy,
        getLockoutPolicy: getLockoutPolicy,
        saveLockoutPolicy: saveLockoutPolicy,
        getCaptchaPolicy: getCaptchaPolicy,
        getPasswordHistoryPolicy: getPasswordHistoryPolicy,
        savePasswordHistoryPolicy: savePasswordHistoryPolicy,
        getPasswordConfigPolicy: getPasswordConfigPolicy,
        get SocialLoginProviders () { return exports.SocialLoginProviders; },
        get AuthStrategyEnum () { return exports.AuthStrategyEnum; }
    });

    /*****************************************
     * Profile Api
     *****************************************/
    /**
     * change user password by providing current password and the new password.
     *
     * @throws exception if the current password incorrect or new password validation failed.
     * ``authorized user``
     */
    function getProfile(params) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getProfile()');
            return Get(`${urls.identity.users.v2}/me`, params !== null && params !== void 0 ? params : { addRoles: true });
        });
    }
    /**
     * update user profile by providing updated fields.
     * ``authorized user``
     */
    function updateProfile(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('updateProfile()', body);
            return Put(`${urls.identity.users.v2}/me`, body);
        });
    }
    /**
     * update user profile image
     * ``authorized user``
     */
    function updateProfileImage(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('updateProfileImage()', body);
            return Put(`${urls.team.profile.v1}/me/image/v1`, body, { responseType: 'plain', contentType: undefined });
        });
    }
    /**
     * change user password by providing current password and the new password.
     *
     * @throws exception if the current password incorrect or new password validation failed.
     * ``authorized user``
     */
    function changePassword(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('changePassword()');
            return Post(`${urls.identity.users.v1}/passwords/change`, body);
        });
    }
    /*****************************************
     * Team Api
     *****************************************/
    /**
     * load users from team-management-service
     *
     * ``authorized user``
     */
    function loadUsers(params) {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            const filters = (params.filter || []).reduce((p, n) => (Object.assign(Object.assign({}, p), { [n.id]: n.value })), {});
            const sorts = ((_a = params.sort) === null || _a === void 0 ? void 0 : _a.length)
                ? {
                    sortBy: (_d = (_c = (_b = params.sort) === null || _b === void 0 ? void 0 : _b[0]) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : 'name',
                    sortDirection: ((_f = (_e = params.sort) === null || _e === void 0 ? void 0 : _e[0]) === null || _f === void 0 ? void 0 : _f.desc) ? 'desc' : 'asc',
                }
                : null;
            return Get(urls.team.members.v1, Object.assign(Object.assign({ pageOffset: params.pageOffset, pageSize: params.pageSize }, filters), sorts));
        });
    }
    /**
     * add user to team, invitation link will be sent to the added user.
     *
     * ``authorized user``
     */
    function addUser(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('addUser()', body);
            return Post(urls.identity.users.v2, Object.assign(Object.assign({}, body), { provider: 'local' }));
        });
    }
    /**
     * delete user from team, user will be deleted.
     *
     * ``authorized user``
     */
    function deleteUser(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('deleteUser()', body);
            return Delete(`${urls.team.members.v1}/${body.userId}`);
        });
    }
    /**
     * edit user roles in team
     *
     * ``authorized user``
     */
    function updateUser(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('editUser()', body);
            return Put(urls.team.members.v1, body);
        });
    }
    /**
     * create link to invite user
     *
     * ``authorized user``
     */
    function createInviteUserLink(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('createInviteUserLink()');
            return Post(urls.identity.tenants.invites.user.v1, Object.assign({}, body));
        });
    }
    /**
     * update link to invite user
     *
     * ``authorized user``
     */
    function updateInviteUserLink(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('updateInviteUserLink()', body);
            return Patch(urls.identity.tenants.invites.user.v1, Object.assign({}, body));
        });
    }
    /**
     * delete link to invite user
     *
     * ``authorized user``
     */
    function deleteInviteUserLink() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('deleteInviteUserLink()');
            return Delete(urls.identity.tenants.invites.user.v1);
        });
    }
    /**
     * get link to invite user
     *
     * ``authorized user``
     */
    function getInviteUserLink() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getInviteUserLink()');
            return Get(urls.identity.tenants.invites.user.v1);
        });
    }
    /**
     * get invite link configuration
     *
     */
    function getInviteLinkConfiguration() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getInviteLinkConfiguration()');
            return Get(urls.identity.tenants.invites.configuration.v1);
        });
    }
    /**
     * load available roles that can be assigned to team users from team-management-service
     *
     * ``authorized user``
     */
    function loadAvailableRoles() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('loadAvailableRoles()');
            return Get(urls.team.roles.v1);
        });
    }
    function loadAvailablePermissions() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('loadAvailablePermissions()');
            return Get(urls.identity.permissions.v1);
        });
    }
    /**
     * load users stats from team-management-service
     *
     * ``authorized user``
     */
    function loadStats() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('loadStats()');
            return Get(`${urls.team.stats.v1}/members`);
        });
    }
    /**
     * resend activation link to specific user
     *
     * ``authorized user``
     */
    function resendActivationLink(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('resendActivationLink()', body);
            return Post(`${urls.team.members.v1}/${body.userId}/resendActivationEmail`, {});
        });
    }
    /**
     * resend accept join tenant invitation link to specific user
     *
     * ``authorized user``
     */
    function resendInvitationLink(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('resendInvitationLink()', body);
            return Post(urls.identity.users.v2, Object.assign(Object.assign({}, body), { provider: 'local' }));
        });
    }
    /**
     * resend accept join all pending tenant for current hierarchy invitation link to specific user
     *
     * ``authorized user``
     */
    function resendInvitationLinkToAllTenants(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('resendInvitationLinkToAllTenants()', body);
            return Post(urls.identity.users.invitation.resendAll.v1, Object.assign({}, body));
        });
    }

    var teams = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getProfile: getProfile,
        updateProfile: updateProfile,
        updateProfileImage: updateProfileImage,
        changePassword: changePassword,
        loadUsers: loadUsers,
        addUser: addUser,
        deleteUser: deleteUser,
        updateUser: updateUser,
        createInviteUserLink: createInviteUserLink,
        updateInviteUserLink: updateInviteUserLink,
        deleteInviteUserLink: deleteInviteUserLink,
        getInviteUserLink: getInviteUserLink,
        getInviteLinkConfiguration: getInviteLinkConfiguration,
        loadAvailableRoles: loadAvailableRoles,
        loadAvailablePermissions: loadAvailablePermissions,
        loadStats: loadStats,
        resendActivationLink: resendActivationLink,
        resendInvitationLink: resendInvitationLink,
        resendInvitationLinkToAllTenants: resendInvitationLinkToAllTenants
    });

    function getMetadata(body) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield Get('/metadata', body);
            if ((_a = data === null || data === void 0 ? void 0 : data.rows) === null || _a === void 0 ? void 0 : _a[0])
                return (_b = data === null || data === void 0 ? void 0 : data.rows) === null || _b === void 0 ? void 0 : _b[0];
            throw new Error(`metadata not found: ${body.entityName}`);
        });
    }
    function getIpMetadata(ip) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = yield Get(`/metadata/ip/${ip}`);
            if (data)
                return data;
            throw new Error(`ip metadata not found`);
        });
    }
    const getNotificationsMetadata = () => __awaiter(void 0, void 0, void 0, function* () { return getMetadata({ entityName: 'notifications' }); });
    const getSamlMetadata = () => __awaiter(void 0, void 0, void 0, function* () { return getMetadata({ entityName: 'saml' }); });
    const getAuditsMetadata = () => __awaiter(void 0, void 0, void 0, function* () { return getMetadata({ entityName: 'audits' }); });
    const getIpAdressMetadata = (ip) => __awaiter(void 0, void 0, void 0, function* () { return getIpMetadata(ip); });

    var metadata = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getNotificationsMetadata: getNotificationsMetadata,
        getSamlMetadata: getSamlMetadata,
        getAuditsMetadata: getAuditsMetadata,
        getIpAdressMetadata: getIpAdressMetadata
    });

    /**
     * Get all active tenant reports from reports service by active vendor.
     * Optional: pass filters and sort options to reports.
     *
     * @returns list of reports objects
     */
    function getReports(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getReports()', body);
            return Get(`${urls.reports.service.v2}/tenant-reports`, body);
        });
    }
    /**
     * Get report record by id.
     *
     * @returns list of report object
     * @throws exception if report not found.
     */
    function getReport(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getReport()', body);
            return Get(`${urls.reports.service.v2}/${body.id}/tenant-reports`);
        });
    }
    /**
     * Render report by id.
     * Optional: pass data filters if exists to render report by specific data.
     *
     * @returns html content of the rendered reports
     * @throws exception if report not found or the data api unreached.
     */
    function renderReport(_a) {
        var { dataFilters } = _a, body = __rest(_a, ["dataFilters"]);
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('renderReport()', body);
            const html = yield Get(`${urls.reports.trigger.v1}/preview-report`, Object.assign(Object.assign({}, body), { dataFilters: btoa(JSON.stringify(dataFilters || {})), responseType: 'html' }), { responseType: 'plain' });
            return { html };
        });
    }
    /**
     * schedule report by providing cron expression and data filters.
     *
     * @returns the updated report object
     * @throws exception if report not found or the data api unreached.
     */
    function scheduleReport(_a) {
        var { templateId, dataFilters } = _a, body = __rest(_a, ["templateId", "dataFilters"]);
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('scheduleReport()', body);
            return Post(`${urls.reports.service.v2}/${templateId}/tenant-reports`, Object.assign(Object.assign({}, body), { dataFilters: btoa(JSON.stringify(dataFilters || {})) }));
        });
    }
    /**
     * download report as file in specific format.
     * this function will add a href element with url to trigger file download.
     * Optional: pass data filters if exists to generate report by specific data.
     *
     * @throws exception if report not found or the data api unreached.
     */
    function downloadReport(_a) {
        var { dataFilters } = _a, body = __rest(_a, ["dataFilters"]);
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('downloadReport()', body);
            const blob = yield Get(`${urls.reports.trigger.v1}/preview-report`, Object.assign(Object.assign({}, body), { dataFilters: btoa(JSON.stringify(dataFilters || {})) }), { responseType: 'blob' });
            let contentType = 'text/html';
            let contentExt = 'html';
            if (body.responseType === 'pdf') {
                contentType = 'application/pdf';
                contentExt = 'pdf';
            }
            else if (body.responseType === 'image') {
                contentType = 'image/jpeg';
                contentExt = 'jpg';
            }
            const newBlob = new Blob([blob], { type: contentType });
            const fileURL = URL.createObjectURL(newBlob);
            const tempLink = document.createElement('a');
            tempLink.href = fileURL;
            tempLink.setAttribute('download', `report_${body.name || ''}.${contentExt}`);
            tempLink.click();
            setTimeout(tempLink.remove.bind(tempLink));
        });
    }
    /**
     * send report to specific email address.
     * Optional: pass data filters if exists to send report by specific data.
     *
     * @throws exception if report not found or the data api unreached.
     */
    function sendReport(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('sendReport()', body);
            return Post(`${urls.reports.trigger.v1}/tenant-reports`, body);
        });
    }

    var reports = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getReports: getReports,
        getReport: getReport,
        renderReport: renderReport,
        scheduleReport: scheduleReport,
        downloadReport: downloadReport,
        sendReport: sendReport
    });

    /**
     * get Notifications
     */
    function getNotifications(params) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getNotifications()');
            return Get(urls.notifications.v1, { params });
        });
    }
    /**
     * update Notification status
     */
    function updateNotificationStatus(params) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getNotifications()');
            return Put(`${urls.notifications.v1}/status`, { params });
        });
    }
    /**
     * update Notification pin status
     */
    function updateNotificationIsPinned(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { notificationId, pinStatus } = params;
            console.debug('getNotifications()');
            return Put(`${urls.notifications.v1}/${pinStatus}`, { notificationId });
        });
    }
    /**
     * mark all notifications as read
     */
    function markAllAsRead() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getNotifications()');
            return Post(`${urls.notifications.v1}/status/mark-all-read`);
        });
    }

    var notifications = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getNotifications: getNotifications,
        updateNotificationStatus: updateNotificationStatus,
        updateNotificationIsPinned: updateNotificationIsPinned,
        markAllAsRead: markAllAsRead
    });

    /*****************************************
     * Audits Api
     *****************************************/
    /**
     * get Audits
     */
    function getAudits(params) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getAudits()');
            return Get(urls.audits.v1, params);
        });
    }
    /**
     * get Audits Stats
     */
    function getAuditsStats(params) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getAuditsStats()');
            return Get(`${urls.audits.v1}/stats`, params);
        });
    }
    /**
     * export Audits
     */
    function exportAudits(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const { endpoint, headerProps } = params, restParams = __rest(params, ["endpoint", "headerProps"]);
            return PostDownload(`${urls.audits.v1}/export/${endpoint}`, { properties: headerProps }, restParams);
        });
    }

    var audits = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getAudits: getAudits,
        getAuditsStats: getAuditsStats,
        exportAudits: exportAudits
    });

    const getSlackConfiguration = () => {
        console.debug('getSlackConfiguration()');
        return Get(`${urls.integrations.configurations.v1}/slack`);
    };
    const getSlackScope = () => {
        console.debug('getSlackScope()');
        return Get(`${urls.integrations.configurations.v1}/slack/applications`);
    };
    const getSlackChannels = () => {
        console.debug('getSlackChannels()');
        return Get(`${urls.integrations.configurations.v1}/slack/channels`);
    };
    const postSlackConfiguration = (data) => {
        console.debug('postSlackConfiguration()', data);
        if (data.id) {
            return Patch(`${urls.integrations.configurations.v1}/slack/subscription/${data.id}`, data);
        }
        return Post(`${urls.integrations.configurations.v1}/slack/subscriptions`, data);
    };
    const deleteSlackConfiguration = (data) => {
        console.debug('deleteSlackConfiguration()', data);
        return Delete(`${urls.integrations.configurations.v1}/slack/subscriptions/${data.id}`);
    };
    const postSlackCode = (code) => {
        console.debug('postSlackCode()', { code });
        return Post(`${urls.integrations.configurations.v1}/slack/applications/registrations`, { code });
    };
    const getEmailConfiguration = () => {
        console.debug('getEmailConfiguration()');
        return Get(`${urls.integrations.configurations.v1}/emails`);
    };
    const postEmailConfiguration = (_a) => {
        var { eventKey } = _a, data = __rest(_a, ["eventKey"]);
        console.debug('postEmailConfiguration()', Object.assign(Object.assign({}, data), { eventKey }));
        return Post(`${urls.integrations.configurations.v1}/emails/${eventKey}`, data);
    };
    const patchEmailConfiguration = ({ eventKey, enabled, }) => {
        console.debug('patchEmailConfiguration()', { eventKey, enabled });
        return Patch(`${urls.integrations.configurations.v1}/emails/${eventKey}`, { enabled });
    };
    const deleteEmailSubscriptions = (eventKey, subscriptionId) => {
        console.debug('deleteEmailSubscriptions()', { eventKey, subscriptionId });
        return Delete(`${urls.integrations.configurations.v1}/emails/${eventKey}/subscriptions/${subscriptionId}`);
    };
    const putEmailSubscriptions = (subscriptionId, eventKey, data) => {
        console.debug('putEmailSubscriptions()', Object.assign(Object.assign({}, data), { subscriptionId, eventKey }));
        return Put(`${urls.integrations.configurations.v1}/emails/${eventKey}/subscriptions/${subscriptionId}`, data);
    };
    const deleteEmailConfiguration = (eventKey) => {
        console.debug('deleteEmailConfiguration()', { eventKey });
        return Delete(`${urls.integrations.configurations.v1}/emails/${eventKey}`);
    };
    const getSMSConfiguration = () => {
        console.debug('getSMSConfiguration()');
        return Get(`${urls.integrations.configurations.v2}/sms`);
    };
    const postSMSConfiguration = (_a) => {
        var { eventKey } = _a, data = __rest(_a, ["eventKey"]);
        console.debug('postSMSConfiguration()', Object.assign(Object.assign({}, data), { eventKey }));
        return Post(`${urls.integrations.configurations.v2}/sms/${eventKey}`, data);
    };
    const patchSMSConfiguration = ({ eventKey, enabled, }) => {
        console.debug('patchSMSConfiguration()', { eventKey, enabled });
        return Patch(`${urls.integrations.configurations.v2}/sms/${eventKey}`, { enabled });
    };
    const deleteSMSSubscriptions = (eventKey, subscriptionId) => {
        console.debug('deleteSMSSubscriptions()', { eventKey, subscriptionId });
        return Delete(`${urls.integrations.configurations.v2}/sms/${eventKey}/subscriptions/${subscriptionId}`);
    };
    const putSMSSubscriptions = (subscriptionId, eventKey, data) => {
        console.debug('putSMSSubscriptions()', Object.assign(Object.assign({}, data), { subscriptionId, eventKey }));
        return Put(`${urls.integrations.configurations.v2}/sms/${eventKey}/subscriptions/${subscriptionId}`, data);
    };
    const deleteSMSConfiguration = (eventKey) => {
        console.debug('deleteSMSConfiguration()', { eventKey });
        return Delete(`${urls.integrations.configurations.v2}/sms/${eventKey}`);
    };
    const getWebhooksConfigurations = () => {
        console.debug('getWebhooksConfigurations()');
        return Get(urls.webhooks.v1);
    };
    const postWebhooksConfiguration = (data) => {
        console.debug('postWebhooksConfiguration()', data);
        if (data._id) {
            return Patch(`${urls.webhooks.v1}/${data._id}`, data);
        }
        else {
            return Post(`${urls.webhooks.v1}/custom`, data);
        }
    };
    const deleteWebhooksConfiguration = (id) => {
        console.debug('deleteWebhooksConfiguration()', id);
        return Delete(`${urls.webhooks.v1}/${id}`);
    };
    const getWebhookLog = (id, offset = 0, limit = 10) => {
        console.debug('getWebhookLog()', id);
        const query = new URLSearchParams({ id, offset: `${offset}`, limit: `${limit}` });
        return Get(`${urls.webhooks.v1}/logs/?${query.toString()}`);
    };
    const postWebhookTest = (data) => {
        console.debug('postWebhookTest', data);
        return Post(`${urls.webhooks.v1}/test`, data);
    };
    const postWebhookRetry = (id) => {
        console.debug('postWebhookRetry', id);
        return Post(`${urls.webhooks.v1}/logs/${id}/retries`);
    };
    const getCategories = () => {
        console.debug('getCategories()');
        return Get(`${urls.events.configurations.v1}/categories`);
    };
    const getChannelMaps = (channels) => {
        console.debug('getChannelMaps()', channels);
        return Get(urls.events.configurations.v1, { channels });
    };

    var connectivity = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getSlackConfiguration: getSlackConfiguration,
        getSlackScope: getSlackScope,
        getSlackChannels: getSlackChannels,
        postSlackConfiguration: postSlackConfiguration,
        deleteSlackConfiguration: deleteSlackConfiguration,
        postSlackCode: postSlackCode,
        getEmailConfiguration: getEmailConfiguration,
        postEmailConfiguration: postEmailConfiguration,
        patchEmailConfiguration: patchEmailConfiguration,
        deleteEmailSubscriptions: deleteEmailSubscriptions,
        putEmailSubscriptions: putEmailSubscriptions,
        deleteEmailConfiguration: deleteEmailConfiguration,
        getSMSConfiguration: getSMSConfiguration,
        postSMSConfiguration: postSMSConfiguration,
        patchSMSConfiguration: patchSMSConfiguration,
        deleteSMSSubscriptions: deleteSMSSubscriptions,
        putSMSSubscriptions: putSMSSubscriptions,
        deleteSMSConfiguration: deleteSMSConfiguration,
        getWebhooksConfigurations: getWebhooksConfigurations,
        postWebhooksConfiguration: postWebhooksConfiguration,
        deleteWebhooksConfiguration: deleteWebhooksConfiguration,
        getWebhookLog: getWebhookLog,
        postWebhookTest: postWebhookTest,
        postWebhookRetry: postWebhookRetry,
        getCategories: getCategories,
        getChannelMaps: getChannelMaps
    });

    /*** update account settings for tenant.
     * tenantId is caclulated in the backend from context
     * ``authorized user``
     */
    function updateSettings(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('updateSettings()', body);
            return Put(urls.tenants.accountSettings.v1, body);
        });
    }
    function getSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getSettings()');
            return Get(urls.tenants.accountSettings.v1);
        });
    }

    var accountSettings = /*#__PURE__*/Object.freeze({
        __proto__: null,
        updateSettings: updateSettings,
        getSettings: getSettings
    });

    /**
     * Gets tenant related roles
     */
    function getRoles() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getRoles()');
            return Get(urls.identity.roles.v1);
        });
    }
    /**
     * Adds tenant related roles
     * @param body: IAddRole
     */
    function addRole(body) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('addRole()', body);
            return Post(urls.identity.roles.v1, body);
        });
    }
    /**
     * Deletes role given role ID
     */
    function deleteRole({ roleId }) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('deleteRole()', roleId);
            return Delete(`${urls.identity.roles.v1}/${roleId}`);
        });
    }
    /**
     * Updates role using a given role ID and IUpdateRole object
     */
    function updateRole(_a) {
        var { roleId } = _a, body = __rest(_a, ["roleId"]);
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('updateRole()', roleId, body);
            return Patch(`${urls.identity.roles.v1}/${roleId}`, body);
        });
    }
    /**
     * Attaches permissions to role given a role ID
     */
    function attachPermissionsToRole(_a) {
        var { roleId } = _a, body = __rest(_a, ["roleId"]);
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('attachPermissionsToRole()', roleId, body);
            return Put(`${urls.identity.roles.v1}/${roleId}/permissions`, body);
        });
    }
    /**
     * Gets all vendor permissions
     */
    function getPermissions() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getPermissions()');
            return Get(urls.identity.permissions.v1);
        });
    }
    /**
     * Associate permission to roles
     */
    function attachPermissionToRoles(_a) {
        var { permissionId } = _a, body = __rest(_a, ["permissionId"]);
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('attachPermissionToRoles()');
            return Put(`${urls.identity.permissions.v1}/${permissionId}/roles`, body);
        });
    }
    /**
     * Gets all vendor categories including the permissions
     */
    function getPermissionCategories() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getPermissionCategories()');
            return Get(`${urls.identity.permissions.v1}/categories`);
        });
    }

    var roles = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getRoles: getRoles,
        addRole: addRole,
        deleteRole: deleteRole,
        updateRole: updateRole,
        attachPermissionsToRole: attachPermissionsToRole,
        getPermissions: getPermissions,
        attachPermissionToRoles: attachPermissionToRoles,
        getPermissionCategories: getPermissionCategories
    });

    /**
     * Get tenant subscriptions
     */
    function getSubscriptions() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug("getSubscriptions()");
            return Get(urls.subscriptions.billing.subscriptions.v1);
        });
    }
    /**
     * Get tenant subscription
     */
    function getSubscription(subscriptionId) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug("getSubscription()", { subscriptionId });
            return Get(`${urls.subscriptions.billing.subscriptions.v1}/${subscriptionId}`);
        });
    }
    /**
     * Cancel tenant subscription
     */
    function cancelSubscription(subscriptionId) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug("cancelSubscription()", { subscriptionId });
            return Put(`${urls.subscriptions.billing.subscriptions.v1}/${subscriptionId}/cancellations/`, {});
        });
    }
    /**
     * Renew tenant subscription
     */
    function renewSubscription(subscriptionId) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug("renewSubscription()", { subscriptionId });
            return Put(`${urls.subscriptions.billing.subscriptions.v1}/${subscriptionId}/renewals/`, {});
        });
    }
    /**
     * Upgrade/Downgrade tenant subscription plan
     */
    function updateSubscription(subscriptionId, { paymentMethodId, planId }) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug("updateSubscription()", { subscriptionId });
            return Put(`${urls.subscriptions.billing.subscriptions.v1}/${subscriptionId}`, { paymentMethodId, planId });
        });
    }

    function getManagedSubscription(subscriptionId) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getManagedSubscription()', { subscriptionId });
            return Get(`${urls.subscriptions.managedSubscriptions.v1}/${subscriptionId}`);
        });
    }
    function getManagedSubscriptions() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getManagedSubscriptions()');
            return Get(`${urls.subscriptions.managedSubscriptions.v1}`);
        });
    }
    /**
     * Cancel tenant subscription
     */
    function cancelManagedSubscription(subscriptionId) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug("cancelManagedSubscription()", { subscriptionId });
            return Put(`${urls.subscriptions.managedSubscriptions.v1}/${subscriptionId}/cancellations/`, {});
        });
    }
    /**
     * Renew tenant subscription
     */
    function renewManagedSubscription(subscriptionId) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug("renewManagedSubscription()", { subscriptionId });
            return Put(`${urls.subscriptions.managedSubscriptions.v1}/${subscriptionId}/renewals/`, {});
        });
    }
    /**
     * Upgrade/Downgrade tenant subscription plan
     */
    function updateManagedSubscription(subscriptionId, { paymentMethodId, planId }) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug("updateManagedSubscription()", { subscriptionId });
            return Put(`${urls.subscriptions.managedSubscriptions.v1}/${subscriptionId}`, { paymentMethodId, planId });
        });
    }

    /**
     * Gets subscription plans
     */
    function getSubscriptionPlans() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getSubscriptionPlans()');
            return Get(urls.subscriptions.billing.plans.v1);
        });
    }
    /**
     * Gets subscription plan singular
     */
    function getSubscriptionPlan(planId) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getSubscriptionPlan()');
            return Get(`${urls.subscriptions.billing.plans.v1}/${planId}`);
        });
    }

    /**
     * Get subscription invoices
     */
    function getSubscriptionInvoices() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug("getSubscriptionInvoices()");
            return Get(urls.subscriptions.billing.invoices.v1);
        });
    }
    /**
     * Get subscription invoice
     */
    function getSubscriptionInvoice(invoiceId) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug("getSubscriptionInvoice()", { invoiceId });
            return Get(`${urls.subscriptions.billing.invoices.v1}/${invoiceId}`);
        });
    }
    /**
     * Get subscription invoice pdf file
     */
    function getSubscriptionInvoicePdf(invoiceId, outputFileName) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug("getSubscriptionInvoicePdf()", { invoiceId });
            return Get(`${urls.subscriptions.billing.invoices.v1}/${invoiceId}/pdf`, {
                outputFileName,
            }, {
                responseType: "blob",
            });
        });
    }

    /**
     * Get payment methods
     */
    function getPaymentMethods() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug("getPaymentMethods()");
            return Get(urls.subscriptions.billing.paymentMethods.v1);
        });
    }
    /**
     * Get payment method
     */
    function getPaymentMethod(paymentMethodId) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug("getPaymentMethod()", { paymentMethodId });
            return Get(`${urls.subscriptions.billing.paymentMethods.v1}/${paymentMethodId}`);
        });
    }
    /**
     * Update payment method billing details
     */
    function updatePaymentMethodBillingDetails(paymentMethodId, _a) {
        var { email } = _a, address = __rest(_a, ["email"]);
        return __awaiter(this, void 0, void 0, function* () {
            console.debug("updatePaymentMethodBillingDetails()", {
                paymentMethodId,
                email,
                address,
            });
            return Patch(`${urls.subscriptions.billing.paymentMethods.v1}/${paymentMethodId}/billing-details`, { email, address });
        });
    }

    /**
     * Creates new stripe subscription
     * @param request
     */
    function createSubscription(request) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('createSubscription()');
            return Post(urls.subscriptions.billing.paymentProviders.stripe.subscriptions.v1, request);
        });
    }
    /**
     * Fetch tenant mapping external stripe customer object
     */
    function getStripeCustomer(tenantId) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getStripeCustomer()');
            return Get(`${urls.subscriptions.billing.paymentProviders.stripe.customers.v1}/${tenantId}`);
        });
    }
    /**
     * Create tenant mapping external stripe customer object
     * @param request
     */
    function createStripeCustomer(request) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('createStripeCustomer()');
            return Post(`${urls.subscriptions.billing.paymentProviders.stripe.customers.v1}`, request);
        });
    }
    function getStripePaymentProviderConfiguration() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getStripePaymentProviderConfiguration()');
            return Get(`${urls.subscriptions.billing.paymentProviders.stripe.publicConfigurations.v1}`);
        });
    }
    /**
     * Create payment method intent secret
     * @param request
     */
    function createStripePaymentMethodSetupIntentSecret(request) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('createStripePaymentMethodSetupIntentSecret()');
            return Post(`${urls.subscriptions.billing.paymentProviders.stripe.setupIntents.v1}`, request);
        });
    }

    /**
     * Gets subscription summaries
     */
    function getSubscriptionSummaries(tenantId) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getSubscriptionSummaries()');
            return Get(`${urls.subscriptions.billing.summaries.v1}/${tenantId}`);
        });
    }

    function getTenantConfiguration(tenantId) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug("getTenantConfiguration()");
            return Get(`${urls.subscriptions.billing.tenantConfiguration.v1}/${tenantId}`);
        });
    }
    function createTenantConfiguration(request) {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug("createTenantConfiguration()");
            return Post(`${urls.subscriptions.billing.tenantConfiguration.v1}`, request);
        });
    }

    /**
     * Gets payment providers for vendor
     */
    function getPaymentProviders() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug("getPaymentProviders()");
            return Get(urls.subscriptions.paymentProviders.v1);
        });
    }

    exports.ISubscriptionStatus = void 0;
    (function (ISubscriptionStatus) {
        ISubscriptionStatus["ACTIVE"] = "active";
        ISubscriptionStatus["CANCELED"] = "canceled";
        ISubscriptionStatus["INCOMPLETE"] = "incomplete";
        ISubscriptionStatus["EXPIRED"] = "expired";
        ISubscriptionStatus["TRIALING"] = "trialing";
        ISubscriptionStatus["TRIAL_ENDED"] = "trialEnded";
    })(exports.ISubscriptionStatus || (exports.ISubscriptionStatus = {}));
    exports.PaymentMethodType = void 0;
    (function (PaymentMethodType) {
        PaymentMethodType["UNKNWON"] = "unknown";
        PaymentMethodType["CARD"] = "card";
    })(exports.PaymentMethodType || (exports.PaymentMethodType = {}));
    exports.ISubscriptionCancellationPolicy = void 0;
    (function (ISubscriptionCancellationPolicy) {
        ISubscriptionCancellationPolicy["AT_PERIOD_END"] = "atPeriodEnd";
    })(exports.ISubscriptionCancellationPolicy || (exports.ISubscriptionCancellationPolicy = {}));
    exports.ProviderType = void 0;
    (function (ProviderType) {
        ProviderType["Stripe"] = "Stripe";
    })(exports.ProviderType || (exports.ProviderType = {}));

    var subscriptions = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getSubscriptions: getSubscriptions,
        getSubscription: getSubscription,
        cancelSubscription: cancelSubscription,
        renewSubscription: renewSubscription,
        updateSubscription: updateSubscription,
        getManagedSubscription: getManagedSubscription,
        getManagedSubscriptions: getManagedSubscriptions,
        cancelManagedSubscription: cancelManagedSubscription,
        renewManagedSubscription: renewManagedSubscription,
        updateManagedSubscription: updateManagedSubscription,
        getSubscriptionPlans: getSubscriptionPlans,
        getSubscriptionPlan: getSubscriptionPlan,
        getSubscriptionInvoices: getSubscriptionInvoices,
        getSubscriptionInvoice: getSubscriptionInvoice,
        getSubscriptionInvoicePdf: getSubscriptionInvoicePdf,
        getPaymentMethods: getPaymentMethods,
        getPaymentMethod: getPaymentMethod,
        updatePaymentMethodBillingDetails: updatePaymentMethodBillingDetails,
        createSubscription: createSubscription,
        getStripeCustomer: getStripeCustomer,
        createStripeCustomer: createStripeCustomer,
        getStripePaymentProviderConfiguration: getStripePaymentProviderConfiguration,
        createStripePaymentMethodSetupIntentSecret: createStripePaymentMethodSetupIntentSecret,
        getSubscriptionSummaries: getSubscriptionSummaries,
        getTenantConfiguration: getTenantConfiguration,
        createTenantConfiguration: createTenantConfiguration,
        getPaymentProviders: getPaymentProviders,
        get ISubscriptionStatus () { return exports.ISubscriptionStatus; },
        get PaymentMethodType () { return exports.PaymentMethodType; },
        get ISubscriptionCancellationPolicy () { return exports.ISubscriptionCancellationPolicy; },
        get ProviderType () { return exports.ProviderType; }
    });

    /**
     * provide vendor public info by providing the vendor context.
     * @return IVendorPublicInfoResponse
     */
    function getVendorPublicInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            console.debug('getVendorPublicInfo()');
            return Get(`${urls.vendor}/public`);
        });
    }

    var vendor = /*#__PURE__*/Object.freeze({
        __proto__: null,
        getVendorPublicInfo: getVendorPublicInfo
    });

    function loadAllUsers(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return Get(urls.identity.subTenants.v1, params);
        });
    }
    function addUserToTenantAndSubTenants(body) {
        return __awaiter(this, void 0, void 0, function* () {
            return Post(urls.identity.subTenants.v1, body);
        });
    }
    function removeUserFromTenantAndSubTenants(body) {
        return __awaiter(this, void 0, void 0, function* () {
            return Delete(urls.identity.subTenants.v1, body);
        });
    }
    function addUserRolesForSubTenants(userId, body) {
        return __awaiter(this, void 0, void 0, function* () {
            return Post(`${urls.identity.subTenants.v1}/${userId}/roles`, body);
        });
    }
    function removeUserRolesFromSubTenants(userId, body) {
        return __awaiter(this, void 0, void 0, function* () {
            return Delete(`${urls.identity.subTenants.v1}/${userId}/roles`, body);
        });
    }
    function setUserRolesForSubTenants(userId, body) {
        return __awaiter(this, void 0, void 0, function* () {
            return Patch(`${urls.identity.subTenants.v1}/${userId}/roles`, body);
        });
    }

    var subTenants = /*#__PURE__*/Object.freeze({
        __proto__: null,
        loadAllUsers: loadAllUsers,
        addUserToTenantAndSubTenants: addUserToTenantAndSubTenants,
        removeUserFromTenantAndSubTenants: removeUserFromTenantAndSubTenants,
        addUserRolesForSubTenants: addUserRolesForSubTenants,
        removeUserRolesFromSubTenants: removeUserRolesFromSubTenants,
        setUserRolesForSubTenants: setUserRolesForSubTenants
    });

    exports.SecondaryAuthStrategy = void 0;
    (function (SecondaryAuthStrategy) {
        SecondaryAuthStrategy["WebAuthnPlatform"] = "WebAuthnPlatform";
        SecondaryAuthStrategy["WebAuthnCrossPlatform"] = "WebAuthnCrossPlatform";
        SecondaryAuthStrategy["SmsCode"] = "SmsCode";
    })(exports.SecondaryAuthStrategy || (exports.SecondaryAuthStrategy = {}));

    const fronteggAuthApiRoutes = [
        `${urls.identity.auth.v1}/logout`,
        `${urls.identity.auth.v1}/user/saml/postlogin`,
        `${urls.identity.auth.v2}/user/oidc/postlogin`,
        `${urls.identity.auth.v1}/user`,
        `${urls.identity.auth.v1}/user/mfa/verify`,
        `${urls.identity.auth.v1}/user/token/refresh`,
        `${urls.identity.users.v1}`,
        `${urls.identity.auth.v1}/passwordless/magiclink/postlogin`,
        `${urls.identity.auth.v1}/passwordless/code/postlogin`,
        `${urls.identity.auth.v1}/passwordless/smscode/postlogin`,
        `${urls.identity.users.v1}/activate`,
        `${urls.identity.users.v1}/invitation/accept`
    ];
    const fronteggRefreshTokenUrl = `${urls.identity.auth.v1}/user/token/refresh`;

    const api = {
        auth,
        teams,
        metadata,
        reports,
        connectivity,
        notifications,
        audits,
        tenants,
        accountSettings,
        roles,
        subscriptions,
        vendor,
        subTenants
    };
    var index = {
        fetch: fetch$1,
        ContextHolder,
        FronteggContext,
        api,
        FronteggApiError,
        AuthStrategyEnum: exports.AuthStrategyEnum,
        SocialLoginProviders: exports.SocialLoginProviders,
        ISubscriptionCancellationPolicy: exports.ISubscriptionCancellationPolicy,
        ISubscriptionStatus: exports.ISubscriptionStatus,
        PaymentMethodType: exports.PaymentMethodType,
        ProviderType: exports.ProviderType,
    };

    exports.ContextHolder = ContextHolder;
    exports.FronteggApiError = FronteggApiError;
    exports.FronteggContext = FronteggContext;
    exports.api = api;
    exports.default = index;
    exports.fetch = fetch$1;
    exports.fronteggAuthApiRoutes = fronteggAuthApiRoutes;
    exports.fronteggRefreshTokenUrl = fronteggRefreshTokenUrl;

    Object.defineProperty(exports, '__esModule', { value: true });

})));


/***/ }),

/***/ 36539:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Metadata": function() { return /* binding */ Metadata; }
/* harmony export */ });
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

var cjs = deepmerge_1;

var deepMerge = cjs;

/**
 * Returns a number whose value is limited to the given range.
 * @param {number} value The value to be clamped
 * @param {number} min The lower boundary of the output range
 * @param {number} max The upper boundary of the output range
 * @returns {number} A number in the range [min, max]
 */
function clamp(value, min = 0, max = 1) {
    return Math.min(Math.max(min, value), max);
}
/**
 * Converts a color from CSS hex format to CSS rgb format.
 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
 * @returns {string} A CSS rgb color string
 */
function hexToRgb(color) {
    color = color.substr(1);
    const re = new RegExp(`.{1,${color.length >= 6 ? 2 : 1}}`, 'g');
    let colors = color.match(re);
    if (colors && colors[0].length === 1) {
        colors = colors.map((n) => n + n);
    }
    return colors
        ? `rgb${colors.length === 4 ? 'a' : ''}(${colors
            .map((n, index) => {
            return index < 3 ? parseInt(n, 16) : Math.round((parseInt(n, 16) / 255) * 1000) / 1000;
        })
            .join(', ')})`
        : '';
}
function intToHex(int) {
    const hex = int.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}
/**
 * Returns an object with the type and values of a color.
 *
 * Note: Does not support rgb % values.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
 * @returns {object} - A MUI color object: {type: string, values: number[]}
 */
function decomposeColor(color) {
    // Idempotent
    if (color.type) {
        return color;
    }
    if (color.charAt(0) === '#') {
        return decomposeColor(hexToRgb(color));
    }
    const marker = color.indexOf('(');
    const type = color.substring(0, marker);
    if (['rgb', 'rgba', 'hsl', 'hsla', 'color'].indexOf(type) === -1) {
        throw new Error('MUI: Unsupported `%s` color.\n' +
            'The following formats are supported: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color(). ' + color);
    }
    let values = color.substring(marker + 1, color.length - 1);
    let colorSpace;
    if (type === 'color') {
        values = values.split(' ');
        colorSpace = values.shift();
        if (values.length === 4 && values[3].charAt(0) === '/') {
            values[3] = values[3].substr(1);
        }
        if (['srgb', 'display-p3', 'a98-rgb', 'prophoto-rgb', 'rec-2020'].indexOf(colorSpace) === -1) {
            throw new Error('MUI: unsupported `%s` color space.\n' +
                'The following color spaces are supported: srgb, display-p3, a98-rgb, prophoto-rgb, rec-2020.' + colorSpace);
        }
    }
    else {
        values = values.split(',');
    }
    values = values.map((value) => parseFloat(value));
    return { type, values, colorSpace };
}
/**
 * Converts a color object with type and values to a string.
 * @param {object} color - Decomposed color
 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
 * @param {array} color.values - [n,n,n] or [n,n,n,n]
 * @returns {string} A CSS color string
 */
function recomposeColor(color) {
    const { type, colorSpace } = color;
    let { values } = color;
    if (type.indexOf('rgb') !== -1) {
        // Only convert the first 3 values to int (i.e. not alpha)
        values = values.map((n, i) => (i < 3 ? parseInt(n, 10) : n));
    }
    else if (type.indexOf('hsl') !== -1) {
        values[1] = `${values[1]}%`;
        values[2] = `${values[2]}%`;
    }
    if (type.indexOf('color') !== -1) {
        values = `${colorSpace} ${values.join(' ')}`;
    }
    else {
        values = `${values.join(', ')}`;
    }
    return `${type}(${values})`;
}
/**
 * Converts a color from CSS rgb format to CSS hex format.
 * @param {string} color - RGB color, i.e. rgb(n, n, n)
 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
 */
function rgbToHex(color) {
    // Idempotent
    if (color.indexOf('#') === 0) {
        return color;
    }
    const { values } = decomposeColor(color);
    return `#${values.map((n, i) => intToHex(i === 3 ? Math.round(255 * n) : n)).join('')}`;
}
/**
 * Darkens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function darken(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) {
        color.values[2] *= 1 - coefficient;
    }
    else if (color.type.indexOf('rgb') !== -1 || color.type.indexOf('color') !== -1) {
        for (let i = 0; i < 3; i += 1) {
            color.values[i] *= 1 - coefficient;
        }
    }
    return recomposeColor(color);
}
/**
 * Lightens a color.
 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla(), color()
 * @param {number} coefficient - multiplier in the range 0 - 1
 * @returns {string} A CSS color string. Hex input values are returned as rgb
 */
function lighten(color, coefficient) {
    color = decomposeColor(color);
    coefficient = clamp(coefficient);
    if (color.type.indexOf('hsl') !== -1) {
        color.values[2] += (100 - color.values[2]) * coefficient;
    }
    else if (color.type.indexOf('rgb') !== -1) {
        for (let i = 0; i < 3; i += 1) {
            color.values[i] += (255 - color.values[i]) * coefficient;
        }
    }
    else if (color.type.indexOf('color') !== -1) {
        for (let i = 0; i < 3; i += 1) {
            color.values[i] += (1 - color.values[i]) * coefficient;
        }
    }
    return recomposeColor(color);
}

const generateMainColorObject = (color) => {
    if (!!color) {
        return {
            main: color,
            light: rgbToHex(lighten(color, 0.4)),
            dark: rgbToHex(darken(color, 0.15)),
            hover: rgbToHex(darken(color, 0.15)),
            active: rgbToHex(darken(color, 0.20)),
        };
    }
};
const generateSubColorObject = (color) => {
    if (!!color) {
        return {
            main: color,
            light: lighten(color, 0.7),
            dark: darken(color, 0.2),
        };
    }
};
const getPalette = (theme, defaultTheme) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    if (!(theme === null || theme === void 0 ? void 0 : theme.palette) || typeof ((_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.primary) !== 'string') {
        return {};
    }
    return Object.assign(Object.assign({}, defaultTheme), { palette: {
            primary: Object.assign(Object.assign({}, generateMainColorObject((_b = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _b === void 0 ? void 0 : _b.primary)), { contrastText: (_d = (_c = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _c === void 0 ? void 0 : _c.primaryText) !== null && _d !== void 0 ? _d : '#000000' }),
            secondary: Object.assign(Object.assign({}, generateMainColorObject((_e = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _e === void 0 ? void 0 : _e.secondary)), { contrastText: (_g = (_f = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _f === void 0 ? void 0 : _f.secondaryText) !== null && _g !== void 0 ? _g : '#000000' }),
            danger: Object.assign(Object.assign({}, generateMainColorObject((_h = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _h === void 0 ? void 0 : _h.error)), { contrastText: '#FFF' }),
            success: Object.assign(Object.assign({}, generateSubColorObject((_j = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _j === void 0 ? void 0 : _j.success)), { contrastText: '#FFF' }),
            error: Object.assign(Object.assign({}, generateSubColorObject((_k = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _k === void 0 ? void 0 : _k.error)), { contrastText: '#FFF' }),
            warning: Object.assign(Object.assign({}, generateSubColorObject((_l = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _l === void 0 ? void 0 : _l.warning)), { contrastText: '#FFF' }),
            info: Object.assign(Object.assign({}, generateSubColorObject((_m = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _m === void 0 ? void 0 : _m.info)), { contrastText: '#FFF' }),
        } });
};

const defaultMetadata = {
    theme: {},
    themeV2: {},
    localizations: {},
    navigation: {
        usage: {
            visibility: 'hidden',
            permissions: ['fe.usage.read'],
            featureFlag: 'fe-usage-page',
        },
        webhooks: {
            visibility: 'hidden',
            permissions: ['fe.connectivity.read.webhooks'],
        },
        roles: {
            visibility: 'hidden',
            featureFlag: 'fe-roles-page',
            permissions: ['fe.secure.read.roles'],
        },
        users: {
            visibility: 'always',
            permissions: ['fe.secure.read.users'],
            inviteDialog: {
                phoneNumberField: 'optional',
            },
        },
        personalApiTokens: {
            visibility: 'hidden',
        },
        apiTokens: {
            visibility: 'hidden',
            permissions: ['fe.secure.read.tenantApiTokens'],
        },
        profile: {
            visibility: 'always',
        },
        privacy: {
            visibility: 'always',
        },
        account: {
            visibility: 'always',
        },
        security: {
            visibility: 'always',
            permissions: ['fe.secure.read.securityPolicy'],
        },
        sso: {
            visibility: 'hidden',
        },
        multipleSSO: {
            visibility: 'hidden',
            permissions: ['fe.secure.read.samlConfiguration'],
        },
        audits: {
            visibility: 'always',
            permissions: ['fe.secure.read.audits'],
        },
        subscriptions: {
            visibility: 'hidden',
            permissions: ['fe.subscriptions.*'],
        },
    },
};
class Metadata {
    constructor() {
        this._theme = defaultMetadata.theme;
        this._themeV2 = defaultMetadata.themeV2;
        this._navigation = defaultMetadata.navigation;
        this._localizations = defaultMetadata.localizations;
    }
    static getInstance(name = 'default') {
        return this._instances[name];
    }
    static set(metadata, name = 'default') {
        const metadataInstance = new Metadata();
        metadataInstance.set(metadata);
        Metadata._instances[name] = metadataInstance;
        return metadataInstance;
    }
    get theme() {
        var _a;
        return (_a = this._theme) !== null && _a !== void 0 ? _a : {};
    }
    get themeV2() {
        var _a;
        return (_a = this._themeV2) !== null && _a !== void 0 ? _a : {};
    }
    get navigation() {
        var _a;
        return (_a = this._navigation) !== null && _a !== void 0 ? _a : {};
    }
    get localizations() {
        var _a;
        return (_a = this._localizations) !== null && _a !== void 0 ? _a : {};
    }
    set(metadata) {
        var _a, _b, _c, _d, _e, _f, _g;
        try {
            this._navigation = deepMerge.all([(_a = defaultMetadata.navigation) !== null && _a !== void 0 ? _a : {}, (_b = metadata === null || metadata === void 0 ? void 0 : metadata.navigation) !== null && _b !== void 0 ? _b : {}]);
            this._theme = deepMerge.all([
                (_c = defaultMetadata.theme) !== null && _c !== void 0 ? _c : {},
                getPalette(metadata === null || metadata === void 0 ? void 0 : metadata.theme, defaultMetadata.theme),
            ]);
            this._themeV2 = deepMerge.all([(_d = defaultMetadata.themeV2) !== null && _d !== void 0 ? _d : {}, (_e = metadata === null || metadata === void 0 ? void 0 : metadata.themeV2) !== null && _e !== void 0 ? _e : {}]);
            this._localizations = deepMerge.all([(_f = defaultMetadata.localizations) !== null && _f !== void 0 ? _f : {}, (_g = metadata === null || metadata === void 0 ? void 0 : metadata.localizations) !== null && _g !== void 0 ? _g : {}]);
        }
        catch (e) {
            this._navigation = defaultMetadata.navigation;
            this._theme = defaultMetadata.theme;
            this._themeV2 = defaultMetadata.themeV2;
            this._localizations = defaultMetadata.localizations;
        }
    }
}
Metadata._instances = {};




/***/ }),

/***/ 16617:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { define } = __webpack_require__(27397)
const base = __webpack_require__(19331)
const constants = __webpack_require__(24776)
const decoders = __webpack_require__(15515)
const encoders = __webpack_require__(55457)

module.exports = {
  base,
  constants,
  decoders,
  define,
  encoders
}


/***/ }),

/***/ 27397:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { inherits } = __webpack_require__(79720)
const encoders = __webpack_require__(55457)
const decoders = __webpack_require__(15515)

module.exports.define = function define (name, body) {
  return new Entity(name, body)
}

function Entity (name, body) {
  this.name = name
  this.body = body

  this.decoders = {}
  this.encoders = {}
}

Entity.prototype._createNamed = function createNamed (Base) {
  const name = this.name

  function Generated (entity) {
    this._initNamed(entity, name)
  }
  inherits(Generated, Base)
  Generated.prototype._initNamed = function _initNamed (entity, name) {
    Base.call(this, entity, name)
  }

  return new Generated(this)
}

Entity.prototype._getDecoder = function _getDecoder (enc) {
  enc = enc || 'der'
  // Lazily create decoder
  if (!Object.prototype.hasOwnProperty.call(this.decoders, enc)) { this.decoders[enc] = this._createNamed(decoders[enc]) }
  return this.decoders[enc]
}

Entity.prototype.decode = function decode (data, enc, options) {
  return this._getDecoder(enc).decode(data, options)
}

Entity.prototype._getEncoder = function _getEncoder (enc) {
  enc = enc || 'der'
  // Lazily create encoder
  if (!Object.prototype.hasOwnProperty.call(this.encoders, enc)) { this.encoders[enc] = this._createNamed(encoders[enc]) }
  return this.encoders[enc]
}

Entity.prototype.encode = function encode (data, enc, /* internal */ reporter) {
  return this._getEncoder(enc).encode(data, reporter)
}


/***/ }),

/***/ 62331:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const { inherits } = __webpack_require__(79720)

const { Reporter } = __webpack_require__(20461)

function DecoderBuffer (base, options) {
  Reporter.call(this, options)
  if (!Buffer.isBuffer(base)) {
    this.error('Input not Buffer')
    return
  }

  this.base = base
  this.offset = 0
  this.length = base.length
}
inherits(DecoderBuffer, Reporter)

DecoderBuffer.isDecoderBuffer = function isDecoderBuffer (data) {
  if (data instanceof DecoderBuffer) {
    return true
  }

  // Or accept compatible API
  const isCompatible = typeof data === 'object' &&
    Buffer.isBuffer(data.base) &&
    data.constructor.name === 'DecoderBuffer' &&
    typeof data.offset === 'number' &&
    typeof data.length === 'number' &&
    typeof data.save === 'function' &&
    typeof data.restore === 'function' &&
    typeof data.isEmpty === 'function' &&
    typeof data.readUInt8 === 'function' &&
    typeof data.skip === 'function' &&
    typeof data.raw === 'function'

  return isCompatible
}

DecoderBuffer.prototype.save = function save () {
  return { offset: this.offset, reporter: Reporter.prototype.save.call(this) }
}

DecoderBuffer.prototype.restore = function restore (save) {
  // Return skipped data
  const res = new DecoderBuffer(this.base)
  res.offset = save.offset
  res.length = this.offset

  this.offset = save.offset
  Reporter.prototype.restore.call(this, save.reporter)

  return res
}

DecoderBuffer.prototype.isEmpty = function isEmpty () {
  return this.offset === this.length
}

DecoderBuffer.prototype.readUInt8 = function readUInt8 (fail) {
  if (this.offset + 1 <= this.length) { return this.base.readUInt8(this.offset++, true) } else { return this.error(fail || 'DecoderBuffer overrun') }
}

DecoderBuffer.prototype.skip = function skip (bytes, fail) {
  if (!(this.offset + bytes <= this.length)) { return this.error(fail || 'DecoderBuffer overrun') }

  const res = new DecoderBuffer(this.base)

  // Share reporter state
  res._reporterState = this._reporterState

  res.offset = this.offset
  res.length = this.offset + bytes
  this.offset += bytes
  return res
}

DecoderBuffer.prototype.raw = function raw (save) {
  return this.base.slice(save ? save.offset : this.offset, this.length)
}

function EncoderBuffer (value, reporter) {
  if (Array.isArray(value)) {
    this.length = 0
    this.value = value.map(function (item) {
      if (!EncoderBuffer.isEncoderBuffer(item)) { item = new EncoderBuffer(item, reporter) }
      this.length += item.length
      return item
    }, this)
  } else if (typeof value === 'number') {
    if (!(value >= 0 && value <= 0xff)) { return reporter.error('non-byte EncoderBuffer value') }
    this.value = value
    this.length = 1
  } else if (typeof value === 'string') {
    this.value = value
    this.length = Buffer.byteLength(value)
  } else if (Buffer.isBuffer(value)) {
    this.value = value
    this.length = value.length
  } else {
    return reporter.error(`Unsupported type: ${typeof value}`)
  }
}

EncoderBuffer.isEncoderBuffer = function isEncoderBuffer (data) {
  if (data instanceof EncoderBuffer) {
    return true
  }

  // Or accept compatible API
  const isCompatible = typeof data === 'object' &&
    data.constructor.name === 'EncoderBuffer' &&
    typeof data.length === 'number' &&
    typeof data.join === 'function'

  return isCompatible
}

EncoderBuffer.prototype.join = function join (out, offset) {
  if (!out) { out = Buffer.alloc(this.length) }
  if (!offset) { offset = 0 }

  if (this.length === 0) { return out }

  if (Array.isArray(this.value)) {
    this.value.forEach(function (item) {
      item.join(out, offset)
      offset += item.length
    })
  } else {
    if (typeof this.value === 'number') { out[offset] = this.value } else if (typeof this.value === 'string') { out.write(this.value, offset) } else if (Buffer.isBuffer(this.value)) { this.value.copy(out, offset) }
    offset += this.length
  }

  return out
}

module.exports = {
  DecoderBuffer,
  EncoderBuffer
}


/***/ }),

/***/ 19331:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { Reporter } = __webpack_require__(20461)
const { DecoderBuffer, EncoderBuffer } = __webpack_require__(62331)
const Node = __webpack_require__(3741)

module.exports = {
  DecoderBuffer,
  EncoderBuffer,
  Node,
  Reporter
}


/***/ }),

/***/ 3741:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { strict: assert } = __webpack_require__(27596)

const { Reporter } = __webpack_require__(20461)
const { DecoderBuffer, EncoderBuffer } = __webpack_require__(62331)

// Supported tags
const tags = [
  'seq', 'seqof', 'set', 'setof', 'objid', 'bool',
  'gentime', 'utctime', 'null_', 'enum', 'int', 'objDesc',
  'bitstr', 'bmpstr', 'charstr', 'genstr', 'graphstr', 'ia5str', 'iso646str',
  'numstr', 'octstr', 'printstr', 't61str', 'unistr', 'utf8str', 'videostr'
]

// Public methods list
const methods = [
  'key', 'obj', 'use', 'optional', 'explicit', 'implicit', 'def', 'choice',
  'any', 'contains'
].concat(tags)

// Overrided methods list
const overrided = [
  '_peekTag', '_decodeTag', '_use',
  '_decodeStr', '_decodeObjid', '_decodeTime',
  '_decodeNull', '_decodeInt', '_decodeBool', '_decodeList',

  '_encodeComposite', '_encodeStr', '_encodeObjid', '_encodeTime',
  '_encodeNull', '_encodeInt', '_encodeBool'
]

function Node (enc, parent, name) {
  const state = {}
  this._baseState = state

  state.name = name
  state.enc = enc

  state.parent = parent || null
  state.children = null

  // State
  state.tag = null
  state.args = null
  state.reverseArgs = null
  state.choice = null
  state.optional = false
  state.any = false
  state.obj = false
  state.use = null
  state.useDecoder = null
  state.key = null
  state.default = null
  state.explicit = null
  state.implicit = null
  state.contains = null

  // Should create new instance on each method
  if (!state.parent) {
    state.children = []
    this._wrap()
  }
}

const stateProps = [
  'enc', 'parent', 'children', 'tag', 'args', 'reverseArgs', 'choice',
  'optional', 'any', 'obj', 'use', 'alteredUse', 'key', 'default', 'explicit',
  'implicit', 'contains'
]

Node.prototype.clone = function clone () {
  const state = this._baseState
  const cstate = {}
  stateProps.forEach(function (prop) {
    cstate[prop] = state[prop]
  })
  const res = new this.constructor(cstate.parent)
  res._baseState = cstate
  return res
}

Node.prototype._wrap = function wrap () {
  const state = this._baseState
  methods.forEach(function (method) {
    this[method] = function _wrappedMethod () {
      const clone = new this.constructor(this)
      state.children.push(clone)
      return clone[method].apply(clone, arguments)
    }
  }, this)
}

Node.prototype._init = function init (body) {
  const state = this._baseState

  assert(state.parent === null)
  body.call(this)

  // Filter children
  state.children = state.children.filter(function (child) {
    return child._baseState.parent === this
  }, this)
  assert.equal(state.children.length, 1, 'Root node can have only one child')
}

Node.prototype._useArgs = function useArgs (args) {
  const state = this._baseState

  // Filter children and args
  const children = args.filter(function (arg) {
    return arg instanceof this.constructor
  }, this)
  args = args.filter(function (arg) {
    return !(arg instanceof this.constructor)
  }, this)

  if (children.length !== 0) {
    assert(state.children === null)
    state.children = children

    // Replace parent to maintain backward link
    children.forEach(function (child) {
      child._baseState.parent = this
    }, this)
  }
  if (args.length !== 0) {
    assert(state.args === null)
    state.args = args
    state.reverseArgs = args.map(function (arg) {
      if (typeof arg !== 'object' || arg.constructor !== Object) { return arg }

      const res = {}
      Object.keys(arg).forEach(function (key) {
        if (key == (key | 0)) { key |= 0 } // eslint-disable-line eqeqeq
        const value = arg[key]
        res[value] = key
      })
      return res
    })
  }
}

//
// Overrided methods
//

overrided.forEach(function (method) {
  Node.prototype[method] = function _overrided () {
    const state = this._baseState
    throw new Error(`${method} not implemented for encoding: ${state.enc}`)
  }
})

//
// Public methods
//

tags.forEach(function (tag) {
  Node.prototype[tag] = function _tagMethod () {
    const state = this._baseState
    const args = Array.prototype.slice.call(arguments)

    assert(state.tag === null)
    state.tag = tag

    this._useArgs(args)

    return this
  }
})

Node.prototype.use = function use (item) {
  assert(item)
  const state = this._baseState

  assert(state.use === null)
  state.use = item

  return this
}

Node.prototype.optional = function optional () {
  const state = this._baseState

  state.optional = true

  return this
}

Node.prototype.def = function def (val) {
  const state = this._baseState

  assert(state.default === null)
  state.default = val
  state.optional = true

  return this
}

Node.prototype.explicit = function explicit (num) {
  const state = this._baseState

  assert(state.explicit === null && state.implicit === null)
  state.explicit = num

  return this
}

Node.prototype.implicit = function implicit (num) {
  const state = this._baseState

  assert(state.explicit === null && state.implicit === null)
  state.implicit = num

  return this
}

Node.prototype.obj = function obj () {
  const state = this._baseState
  const args = Array.prototype.slice.call(arguments)

  state.obj = true

  if (args.length !== 0) { this._useArgs(args) }

  return this
}

Node.prototype.key = function key (newKey) {
  const state = this._baseState

  assert(state.key === null)
  state.key = newKey

  return this
}

Node.prototype.any = function any () {
  const state = this._baseState

  state.any = true

  return this
}

Node.prototype.choice = function choice (obj) {
  const state = this._baseState

  assert(state.choice === null)
  state.choice = obj
  this._useArgs(Object.keys(obj).map(function (key) {
    return obj[key]
  }))

  return this
}

Node.prototype.contains = function contains (item) {
  const state = this._baseState

  assert(state.use === null)
  state.contains = item

  return this
}

//
// Decoding
//

Node.prototype._decode = function decode (input, options) {
  const state = this._baseState

  // Decode root node
  if (state.parent === null) { return input.wrapResult(state.children[0]._decode(input, options)) }

  let result = state.default
  let present = true

  let prevKey = null
  if (state.key !== null) { prevKey = input.enterKey(state.key) }

  // Check if tag is there
  if (state.optional) {
    let tag = null
    if (state.explicit !== null) { tag = state.explicit } else if (state.implicit !== null) { tag = state.implicit } else if (state.tag !== null) { tag = state.tag }

    if (tag === null && !state.any) {
      // Trial and Error
      const save = input.save()
      try {
        if (state.choice === null) { this._decodeGeneric(state.tag, input, options) } else { this._decodeChoice(input, options) }
        present = true
      } catch (e) {
        present = false
      }
      input.restore(save)
    } else {
      present = this._peekTag(input, tag, state.any)

      if (input.isError(present)) { return present }
    }
  }

  // Push object on stack
  let prevObj
  if (state.obj && present) { prevObj = input.enterObject() }

  if (present) {
    // Unwrap explicit values
    if (state.explicit !== null) {
      const explicit = this._decodeTag(input, state.explicit)
      if (input.isError(explicit)) { return explicit }
      input = explicit
    }

    const start = input.offset

    // Unwrap implicit and normal values
    if (state.use === null && state.choice === null) {
      let save
      if (state.any) { save = input.save() }
      const body = this._decodeTag(
        input,
        state.implicit !== null ? state.implicit : state.tag,
        state.any
      )
      if (input.isError(body)) { return body }

      if (state.any) { result = input.raw(save) } else { input = body }
    }

    if (options && options.track && state.tag !== null) { options.track(input.path(), start, input.length, 'tagged') }

    if (options && options.track && state.tag !== null) { options.track(input.path(), input.offset, input.length, 'content') }

    // Select proper method for tag
    if (state.any) {
      // no-op
    } else if (state.choice === null) {
      result = this._decodeGeneric(state.tag, input, options)
    } else {
      result = this._decodeChoice(input, options)
    }

    if (input.isError(result)) { return result }

    // Decode children
    if (!state.any && state.choice === null && state.children !== null) {
      state.children.forEach(function decodeChildren (child) {
        // NOTE: We are ignoring errors here, to let parser continue with other
        // parts of encoded data
        child._decode(input, options)
      })
    }

    // Decode contained/encoded by schema, only in bit or octet strings
    if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
      const data = new DecoderBuffer(result)
      result = this._getUse(state.contains, input._reporterState.obj)
        ._decode(data, options)
    }
  }

  // Pop object
  if (state.obj && present) { result = input.leaveObject(prevObj) }

  // Set key
  if (state.key !== null && (result !== null || present === true)) { input.leaveKey(prevKey, state.key, result) } else if (prevKey !== null) { input.exitKey(prevKey) }

  return result
}

Node.prototype._decodeGeneric = function decodeGeneric (tag, input, options) {
  const state = this._baseState

  if (tag === 'seq' || tag === 'set') { return null }
  if (tag === 'seqof' || tag === 'setof') { return this._decodeList(input, tag, state.args[0], options) } else if (/str$/.test(tag)) { return this._decodeStr(input, tag, options) } else if (tag === 'objid' && state.args) { return this._decodeObjid(input, state.args[0], state.args[1], options) } else if (tag === 'objid') { return this._decodeObjid(input, null, null, options) } else if (tag === 'gentime' || tag === 'utctime') { return this._decodeTime(input, tag, options) } else if (tag === 'null_') { return this._decodeNull(input, options) } else if (tag === 'bool') { return this._decodeBool(input, options) } else if (tag === 'objDesc') { return this._decodeStr(input, tag, options) } else if (tag === 'int' || tag === 'enum') { return this._decodeInt(input, state.args && state.args[0], options) }

  if (state.use !== null) {
    return this._getUse(state.use, input._reporterState.obj)
      ._decode(input, options)
  } else {
    return input.error(`unknown tag: ${tag}`)
  }
}

Node.prototype._getUse = function _getUse (entity, obj) {
  const state = this._baseState
  // Create altered use decoder if implicit is set
  state.useDecoder = this._use(entity, obj)
  assert(state.useDecoder._baseState.parent === null)
  state.useDecoder = state.useDecoder._baseState.children[0]
  if (state.implicit !== state.useDecoder._baseState.implicit) {
    state.useDecoder = state.useDecoder.clone()
    state.useDecoder._baseState.implicit = state.implicit
  }
  return state.useDecoder
}

Node.prototype._decodeChoice = function decodeChoice (input, options) {
  const state = this._baseState
  let result = null
  let match = false

  Object.keys(state.choice).some(function (key) {
    const save = input.save()
    const node = state.choice[key]
    try {
      const value = node._decode(input, options)
      if (input.isError(value)) { return false }

      result = { type: key, value: value }
      match = true
    } catch (e) {
      input.restore(save)
      return false
    }
    return true
  }, this)

  if (!match) { return input.error('Choice not matched') }

  return result
}

//
// Encoding
//

Node.prototype._createEncoderBuffer = function createEncoderBuffer (data) {
  return new EncoderBuffer(data, this.reporter)
}

Node.prototype._encode = function encode (data, reporter, parent) {
  const state = this._baseState
  if (state.default !== null && state.default === data) { return }

  const result = this._encodeValue(data, reporter, parent)
  if (result === undefined) { return }

  if (this._skipDefault(result, reporter, parent)) { return }

  return result
}

Node.prototype._encodeValue = function encode (data, reporter, parent) {
  const state = this._baseState

  // Decode root node
  if (state.parent === null) { return state.children[0]._encode(data, reporter || new Reporter()) }

  let result = null

  // Set reporter to share it with a child class
  this.reporter = reporter

  // Check if data is there
  if (state.optional && data === undefined) {
    if (state.default !== null) { data = state.default } else { return }
  }

  // Encode children first
  let content = null
  let primitive = false
  if (state.any) {
    // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data)
  } else if (state.choice) {
    result = this._encodeChoice(data, reporter)
  } else if (state.contains) {
    content = this._getUse(state.contains, parent)._encode(data, reporter)
    primitive = true
  } else if (state.children) {
    content = state.children.map(function (child) {
      if (child._baseState.tag === 'null_') { return child._encode(null, reporter, data) }

      if (child._baseState.key === null) { return reporter.error('Child should have a key') }
      const prevKey = reporter.enterKey(child._baseState.key)

      if (typeof data !== 'object') { return reporter.error('Child expected, but input is not object') }

      const res = child._encode(data[child._baseState.key], reporter, data)
      reporter.leaveKey(prevKey)

      return res
    }, this).filter(function (child) {
      return child
    })
    content = this._createEncoderBuffer(content)
  } else {
    if (state.tag === 'seqof' || state.tag === 'setof') {
      if (!(state.args && state.args.length === 1)) { return reporter.error(`Too many args for: ${state.tag}`) }

      if (!Array.isArray(data)) { return reporter.error('seqof/setof, but data is not Array') }

      const child = this.clone()
      child._baseState.implicit = null
      content = this._createEncoderBuffer(data.map(function (item) {
        const state = this._baseState

        return this._getUse(state.args[0], data)._encode(item, reporter)
      }, child))
    } else if (state.use !== null) {
      result = this._getUse(state.use, parent)._encode(data, reporter)
    } else {
      content = this._encodePrimitive(state.tag, data)
      primitive = true
    }
  }

  // Encode data itself
  if (!state.any && state.choice === null) {
    const tag = state.implicit !== null ? state.implicit : state.tag
    const cls = state.implicit === null ? 'universal' : 'context'

    if (tag === null) {
      if (state.use === null) { reporter.error('Tag could be omitted only for .use()') }
    } else {
      if (state.use === null) { result = this._encodeComposite(tag, primitive, cls, content) }
    }
  }

  // Wrap in explicit
  if (state.explicit !== null) { result = this._encodeComposite(state.explicit, false, 'context', result) }

  return result
}

Node.prototype._encodeChoice = function encodeChoice (data, reporter) {
  const state = this._baseState

  const node = state.choice[data.type]
  if (!node) {
    assert(
      false,
      `${data.type} not found in ${JSON.stringify(Object.keys(state.choice))}`
    )
  }
  return node._encode(data.value, reporter)
}

Node.prototype._encodePrimitive = function encodePrimitive (tag, data) {
  const state = this._baseState

  if (/str$/.test(tag)) { return this._encodeStr(data, tag) } else if (tag === 'objid' && state.args) { return this._encodeObjid(data, state.reverseArgs[0], state.args[1]) } else if (tag === 'objid') { return this._encodeObjid(data, null, null) } else if (tag === 'gentime' || tag === 'utctime') { return this._encodeTime(data, tag) } else if (tag === 'null_') { return this._encodeNull() } else if (tag === 'int' || tag === 'enum') { return this._encodeInt(data, state.args && state.reverseArgs[0]) } else if (tag === 'bool') { return this._encodeBool(data) } else if (tag === 'objDesc') { return this._encodeStr(data, tag) } else { throw new Error(`Unsupported tag: ${tag}`) }
}

Node.prototype._isNumstr = function isNumstr (str) {
  return /^[0-9 ]*$/.test(str)
}

Node.prototype._isPrintstr = function isPrintstr (str) {
  return /^[A-Za-z0-9 '()+,-./:=?]*$/.test(str)
}

module.exports = Node


/***/ }),

/***/ 20461:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

const { inherits } = __webpack_require__(79720)

function Reporter (options) {
  this._reporterState = {
    obj: null,
    path: [],
    options: options || {},
    errors: []
  }
}

Reporter.prototype.isError = function isError (obj) {
  return obj instanceof ReporterError
}

Reporter.prototype.save = function save () {
  const state = this._reporterState

  return { obj: state.obj, pathLen: state.path.length }
}

Reporter.prototype.restore = function restore (data) {
  const state = this._reporterState

  state.obj = data.obj
  state.path = state.path.slice(0, data.pathLen)
}

Reporter.prototype.enterKey = function enterKey (key) {
  return this._reporterState.path.push(key)
}

Reporter.prototype.exitKey = function exitKey (index) {
  const state = this._reporterState

  state.path = state.path.slice(0, index - 1)
}

Reporter.prototype.leaveKey = function leaveKey (index, key, value) {
  const state = this._reporterState

  this.exitKey(index)
  if (state.obj !== null) { state.obj[key] = value }
}

Reporter.prototype.path = function path () {
  return this._reporterState.path.join('/')
}

Reporter.prototype.enterObject = function enterObject () {
  const state = this._reporterState

  const prev = state.obj
  state.obj = {}
  return prev
}

Reporter.prototype.leaveObject = function leaveObject (prev) {
  const state = this._reporterState

  const now = state.obj
  state.obj = prev
  return now
}

Reporter.prototype.error = function error (msg) {
  let err
  const state = this._reporterState

  const inherited = msg instanceof ReporterError
  if (inherited) {
    err = msg
  } else {
    err = new ReporterError(state.path.map(function (elem) {
      return `[${JSON.stringify(elem)}]`
    }).join(''), msg.message || msg, msg.stack)
  }

  if (!state.options.partial) { throw err }

  if (!inherited) { state.errors.push(err) }

  return err
}

Reporter.prototype.wrapResult = function wrapResult (result) {
  const state = this._reporterState
  if (!state.options.partial) { return result }

  return {
    result: this.isError(result) ? null : result,
    errors: state.errors
  }
}

function ReporterError (path, msg) {
  this.path = path
  this.rethrow(msg)
}
inherits(ReporterError, Error)

ReporterError.prototype.rethrow = function rethrow (msg) {
  this.message = `${msg} at: ${this.path || '(shallow)'}`
  if (Error.captureStackTrace) { Error.captureStackTrace(this, ReporterError) }

  if (!this.stack) {
    try {
      // IE only adds stack when thrown
      throw new Error(this.message)
    } catch (e) {
      this.stack = e.stack
    }
  }
  return this
}

exports.Reporter = Reporter


/***/ }),

/***/ 77680:
/***/ (function(__unused_webpack_module, exports) {

// Helper
function reverse (map) {
  const res = {}

  Object.keys(map).forEach(function (key) {
    // Convert key to integer if it is stringified
    if ((key | 0) == key) { key = key | 0 } // eslint-disable-line eqeqeq

    const value = map[key]
    res[value] = key
  })

  return res
}

exports.tagClass = {
  0: 'universal',
  1: 'application',
  2: 'context',
  3: 'private'
}
exports.tagClassByName = reverse(exports.tagClass)

exports.tag = {
  0x00: 'end',
  0x01: 'bool',
  0x02: 'int',
  0x03: 'bitstr',
  0x04: 'octstr',
  0x05: 'null_',
  0x06: 'objid',
  0x07: 'objDesc',
  0x08: 'external',
  0x09: 'real',
  0x0a: 'enum',
  0x0b: 'embed',
  0x0c: 'utf8str',
  0x0d: 'relativeOid',
  0x10: 'seq',
  0x11: 'set',
  0x12: 'numstr',
  0x13: 'printstr',
  0x14: 't61str',
  0x15: 'videostr',
  0x16: 'ia5str',
  0x17: 'utctime',
  0x18: 'gentime',
  0x19: 'graphstr',
  0x1a: 'iso646str',
  0x1b: 'genstr',
  0x1c: 'unistr',
  0x1d: 'charstr',
  0x1e: 'bmpstr'
}
exports.tagByName = reverse(exports.tag)


/***/ }),

/***/ 24776:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
  der: __webpack_require__(77680)
}


/***/ }),

/***/ 73909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* global BigInt */
const { inherits } = __webpack_require__(79720)

const { DecoderBuffer } = __webpack_require__(62331)
const Node = __webpack_require__(3741)

// Import DER constants
const der = __webpack_require__(77680)

function DERDecoder (entity) {
  this.enc = 'der'
  this.name = entity.name
  this.entity = entity

  // Construct base tree
  this.tree = new DERNode()
  this.tree._init(entity.body)
}

DERDecoder.prototype.decode = function decode (data, options) {
  if (!DecoderBuffer.isDecoderBuffer(data)) {
    data = new DecoderBuffer(data, options)
  }

  return this.tree._decode(data, options)
}

// Tree methods

function DERNode (parent) {
  Node.call(this, 'der', parent)
}
inherits(DERNode, Node)

DERNode.prototype._peekTag = function peekTag (buffer, tag, any) {
  if (buffer.isEmpty()) { return false }

  const state = buffer.save()
  const decodedTag = derDecodeTag(buffer, `Failed to peek tag: "${tag}"`)
  if (buffer.isError(decodedTag)) { return decodedTag }

  buffer.restore(state)

  return decodedTag.tag === tag || decodedTag.tagStr === tag || (decodedTag.tagStr + 'of') === tag || any
}

DERNode.prototype._decodeTag = function decodeTag (buffer, tag, any) {
  const decodedTag = derDecodeTag(buffer,
    `Failed to decode tag of "${tag}"`)
  if (buffer.isError(decodedTag)) { return decodedTag }

  let len = derDecodeLen(buffer,
    decodedTag.primitive,
    `Failed to get length of "${tag}"`)

  // Failure
  if (buffer.isError(len)) { return len }

  if (!any &&
      decodedTag.tag !== tag &&
      decodedTag.tagStr !== tag &&
      decodedTag.tagStr + 'of' !== tag) {
    return buffer.error(`Failed to match tag: "${tag}"`)
  }

  if (decodedTag.primitive || len !== null) { return buffer.skip(len, `Failed to match body of: "${tag}"`) }

  // Indefinite length... find END tag
  const state = buffer.save()
  const res = this._skipUntilEnd(
    buffer,
    `Failed to skip indefinite length body: "${this.tag}"`)
  if (buffer.isError(res)) { return res }

  len = buffer.offset - state.offset
  buffer.restore(state)
  return buffer.skip(len, `Failed to match body of: "${tag}"`)
}

DERNode.prototype._skipUntilEnd = function skipUntilEnd (buffer, fail) {
  for (;;) {
    const tag = derDecodeTag(buffer, fail)
    if (buffer.isError(tag)) { return tag }
    const len = derDecodeLen(buffer, tag.primitive, fail)
    if (buffer.isError(len)) { return len }

    let res
    if (tag.primitive || len !== null) { res = buffer.skip(len) } else { res = this._skipUntilEnd(buffer, fail) }

    // Failure
    if (buffer.isError(res)) { return res }

    if (tag.tagStr === 'end') { break }
  }
}

DERNode.prototype._decodeList = function decodeList (buffer, tag, decoder,
  options) {
  const result = []
  while (!buffer.isEmpty()) {
    const possibleEnd = this._peekTag(buffer, 'end')
    if (buffer.isError(possibleEnd)) { return possibleEnd }

    const res = decoder.decode(buffer, 'der', options)
    if (buffer.isError(res) && possibleEnd) { break }
    result.push(res)
  }
  return result
}

DERNode.prototype._decodeStr = function decodeStr (buffer, tag) {
  if (tag === 'bitstr') {
    const unused = buffer.readUInt8()
    if (buffer.isError(unused)) { return unused }
    return { unused: unused, data: buffer.raw() }
  } else if (tag === 'bmpstr') {
    const raw = buffer.raw()
    if (raw.length % 2 === 1) { return buffer.error('Decoding of string type: bmpstr length mismatch') }

    let str = ''
    for (let i = 0; i < raw.length / 2; i++) {
      str += String.fromCharCode(raw.readUInt16BE(i * 2))
    }
    return str
  } else if (tag === 'numstr') {
    const numstr = buffer.raw().toString('ascii')
    if (!this._isNumstr(numstr)) {
      return buffer.error('Decoding of string type: numstr unsupported characters')
    }
    return numstr
  } else if (tag === 'octstr') {
    return buffer.raw()
  } else if (tag === 'objDesc') {
    return buffer.raw()
  } else if (tag === 'printstr') {
    const printstr = buffer.raw().toString('ascii')
    if (!this._isPrintstr(printstr)) {
      return buffer.error('Decoding of string type: printstr unsupported characters')
    }
    return printstr
  } else if (/str$/.test(tag)) {
    return buffer.raw().toString()
  } else {
    return buffer.error(`Decoding of string type: ${tag} unsupported`)
  }
}

DERNode.prototype._decodeObjid = function decodeObjid (buffer, values, relative) {
  let result
  const identifiers = []
  let ident = 0
  let subident = 0
  while (!buffer.isEmpty()) {
    subident = buffer.readUInt8()
    ident <<= 7
    ident |= subident & 0x7f
    if ((subident & 0x80) === 0) {
      identifiers.push(ident)
      ident = 0
    }
  }
  if (subident & 0x80) { identifiers.push(ident) }

  const first = (identifiers[0] / 40) | 0
  const second = identifiers[0] % 40

  if (relative) { result = identifiers } else { result = [first, second].concat(identifiers.slice(1)) }

  if (values) {
    let tmp = values[result.join(' ')]
    if (tmp === undefined) { tmp = values[result.join('.')] }
    if (tmp !== undefined) { result = tmp }
  }

  return result
}

DERNode.prototype._decodeTime = function decodeTime (buffer, tag) {
  const str = buffer.raw().toString()

  let year
  let mon
  let day
  let hour
  let min
  let sec
  if (tag === 'gentime') {
    year = str.slice(0, 4) | 0
    mon = str.slice(4, 6) | 0
    day = str.slice(6, 8) | 0
    hour = str.slice(8, 10) | 0
    min = str.slice(10, 12) | 0
    sec = str.slice(12, 14) | 0
  } else if (tag === 'utctime') {
    year = str.slice(0, 2) | 0
    mon = str.slice(2, 4) | 0
    day = str.slice(4, 6) | 0
    hour = str.slice(6, 8) | 0
    min = str.slice(8, 10) | 0
    sec = str.slice(10, 12) | 0
    if (year < 70) { year = 2000 + year } else { year = 1900 + year }
  } else {
    return buffer.error(`Decoding ${tag} time is not supported yet`)
  }

  return Date.UTC(year, mon - 1, day, hour, min, sec, 0)
}

DERNode.prototype._decodeNull = function decodeNull () {
  return null
}

DERNode.prototype._decodeBool = function decodeBool (buffer) {
  const res = buffer.readUInt8()
  if (buffer.isError(res)) { return res } else { return res !== 0 }
}

DERNode.prototype._decodeInt = function decodeInt (buffer, values) {
  // Bigint, return as it is (assume big endian)
  const raw = buffer.raw()
  let res = BigInt(`0x${raw.toString('hex')}`)

  if (values) {
    res = values[res.toString(10)] || res
  }

  return res
}

DERNode.prototype._use = function use (entity, obj) {
  if (typeof entity === 'function') { entity = entity(obj) }
  return entity._getDecoder('der').tree
}

// Utility methods

function derDecodeTag (buf, fail) {
  let tag = buf.readUInt8(fail)
  if (buf.isError(tag)) { return tag }

  const cls = der.tagClass[tag >> 6]
  const primitive = (tag & 0x20) === 0

  // Multi-octet tag - load
  if ((tag & 0x1f) === 0x1f) {
    let oct = tag
    tag = 0
    while ((oct & 0x80) === 0x80) {
      oct = buf.readUInt8(fail)
      if (buf.isError(oct)) { return oct }

      tag <<= 7
      tag |= oct & 0x7f
    }
  } else {
    tag &= 0x1f
  }
  const tagStr = der.tag[tag]

  return {
    cls: cls,
    primitive: primitive,
    tag: tag,
    tagStr: tagStr
  }
}

function derDecodeLen (buf, primitive, fail) {
  let len = buf.readUInt8(fail)
  if (buf.isError(len)) { return len }

  // Indefinite form
  if (!primitive && len === 0x80) { return null }

  // Definite form
  if ((len & 0x80) === 0) {
    // Short form
    return len
  }

  // Long form
  const num = len & 0x7f
  if (num > 4) { return buf.error('length octect is too long') }

  len = 0
  for (let i = 0; i < num; i++) {
    len <<= 8
    const j = buf.readUInt8(fail)
    if (buf.isError(j)) { return j }
    len |= j
  }

  return len
}

module.exports = DERDecoder


/***/ }),

/***/ 15515:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
  der: __webpack_require__(73909),
  pem: __webpack_require__(71350)
}


/***/ }),

/***/ 71350:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const { inherits } = __webpack_require__(79720)

const DERDecoder = __webpack_require__(73909)

function PEMDecoder (entity) {
  DERDecoder.call(this, entity)
  this.enc = 'pem'
}
inherits(PEMDecoder, DERDecoder)

PEMDecoder.prototype.decode = function decode (data, options) {
  const lines = data.toString().split(/[\r\n]+/g)

  const label = options.label.toUpperCase()

  const re = /^-----(BEGIN|END) ([^-]+)-----$/
  let start = -1
  let end = -1
  for (let i = 0; i < lines.length; i++) {
    const match = lines[i].match(re)
    if (match === null) { continue }

    if (match[2] !== label) { continue }

    if (start === -1) {
      if (match[1] !== 'BEGIN') { break }
      start = i
    } else {
      if (match[1] !== 'END') { break }
      end = i
      break
    }
  }
  if (start === -1 || end === -1) { throw new Error(`PEM section not found for: ${label}`) }

  const base64 = lines.slice(start + 1, end).join('')
  // Remove excessive symbols
  base64.replace(/[^a-z0-9+/=]+/gi, '')

  const input = Buffer.from(base64, 'base64')
  return DERDecoder.prototype.decode.call(this, input, options)
}

module.exports = PEMDecoder


/***/ }),

/***/ 7081:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/* global BigInt */
const { inherits } = __webpack_require__(79720)

const Node = __webpack_require__(3741)
const der = __webpack_require__(77680)

function DEREncoder (entity) {
  this.enc = 'der'
  this.name = entity.name
  this.entity = entity

  // Construct base tree
  this.tree = new DERNode()
  this.tree._init(entity.body)
}

DEREncoder.prototype.encode = function encode (data, reporter) {
  return this.tree._encode(data, reporter).join()
}

// Tree methods

function DERNode (parent) {
  Node.call(this, 'der', parent)
}
inherits(DERNode, Node)

DERNode.prototype._encodeComposite = function encodeComposite (tag,
  primitive,
  cls,
  content) {
  const encodedTag = encodeTag(tag, primitive, cls, this.reporter)

  // Short form
  if (content.length < 0x80) {
    const header = Buffer.alloc(2)
    header[0] = encodedTag
    header[1] = content.length
    return this._createEncoderBuffer([header, content])
  }

  // Long form
  // Count octets required to store length
  let lenOctets = 1
  for (let i = content.length; i >= 0x100; i >>= 8) { lenOctets++ }

  const header = Buffer.alloc(1 + 1 + lenOctets)
  header[0] = encodedTag
  header[1] = 0x80 | lenOctets

  for (let i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8) { header[i] = j & 0xff }

  return this._createEncoderBuffer([header, content])
}

DERNode.prototype._encodeStr = function encodeStr (str, tag) {
  if (tag === 'bitstr') {
    return this._createEncoderBuffer([str.unused | 0, str.data])
  } else if (tag === 'bmpstr') {
    const buf = Buffer.alloc(str.length * 2)
    for (let i = 0; i < str.length; i++) {
      buf.writeUInt16BE(str.charCodeAt(i), i * 2)
    }
    return this._createEncoderBuffer(buf)
  } else if (tag === 'numstr') {
    if (!this._isNumstr(str)) {
      return this.reporter.error('Encoding of string type: numstr supports only digits and space')
    }
    return this._createEncoderBuffer(str)
  } else if (tag === 'printstr') {
    if (!this._isPrintstr(str)) {
      return this.reporter.error('Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark')
    }
    return this._createEncoderBuffer(str)
  } else if (/str$/.test(tag)) {
    return this._createEncoderBuffer(str)
  } else if (tag === 'objDesc') {
    return this._createEncoderBuffer(str)
  } else {
    return this.reporter.error(`Encoding of string type: ${tag} unsupported`)
  }
}

DERNode.prototype._encodeObjid = function encodeObjid (id, values, relative) {
  if (typeof id === 'string') {
    if (!values) { return this.reporter.error('string objid given, but no values map found') }
    if (!Object.prototype.hasOwnProperty.call(values, id)) { return this.reporter.error('objid not found in values map') }
    id = values[id].split(/[\s.]+/g)
    for (let i = 0; i < id.length; i++) { id[i] |= 0 }
  } else if (Array.isArray(id)) {
    id = id.slice()
    for (let i = 0; i < id.length; i++) { id[i] |= 0 }
  }

  if (!Array.isArray(id)) {
    return this.reporter.error(`objid() should be either array or string, got: ${JSON.stringify(id)}`)
  }

  if (!relative) {
    if (id[1] >= 40) { return this.reporter.error('Second objid identifier OOB') }
    id.splice(0, 2, id[0] * 40 + id[1])
  }

  // Count number of octets
  let size = 0
  for (let i = 0; i < id.length; i++) {
    let ident = id[i]
    for (size++; ident >= 0x80; ident >>= 7) { size++ }
  }

  const objid = Buffer.alloc(size)
  let offset = objid.length - 1
  for (let i = id.length - 1; i >= 0; i--) {
    let ident = id[i]
    objid[offset--] = ident & 0x7f
    while ((ident >>= 7) > 0) { objid[offset--] = 0x80 | (ident & 0x7f) }
  }

  return this._createEncoderBuffer(objid)
}

function two (num) {
  if (num < 10) { return `0${num}` } else { return num }
}

DERNode.prototype._encodeTime = function encodeTime (time, tag) {
  let str
  const date = new Date(time)

  if (tag === 'gentime') {
    str = [
      two(date.getUTCFullYear()),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('')
  } else if (tag === 'utctime') {
    str = [
      two(date.getUTCFullYear() % 100),
      two(date.getUTCMonth() + 1),
      two(date.getUTCDate()),
      two(date.getUTCHours()),
      two(date.getUTCMinutes()),
      two(date.getUTCSeconds()),
      'Z'
    ].join('')
  } else {
    this.reporter.error(`Encoding ${tag} time is not supported yet`)
  }

  return this._encodeStr(str, 'octstr')
}

DERNode.prototype._encodeNull = function encodeNull () {
  return this._createEncoderBuffer('')
}

function bnToBuf (bn) {
  var hex = BigInt(bn).toString(16)
  if (hex.length % 2) { hex = '0' + hex }

  var len = hex.length / 2
  var u8 = new Uint8Array(len)

  var i = 0
  var j = 0
  while (i < len) {
    u8[i] = parseInt(hex.slice(j, j + 2), 16)
    i += 1
    j += 2
  }

  return u8
}

DERNode.prototype._encodeInt = function encodeInt (num, values) {
  if (typeof num === 'string') {
    if (!values) { return this.reporter.error('String int or enum given, but no values map') }
    if (!Object.prototype.hasOwnProperty.call(values, num)) {
      return this.reporter.error(`Values map doesn't contain: ${JSON.stringify(num)}`)
    }
    num = values[num]
  }

  if (typeof num === 'bigint') {
    const numArray = [...bnToBuf(num)]
    if (numArray[0] & 0x80) {
      numArray.unshift(0)
    }
    num = Buffer.from(numArray)
  }

  if (Buffer.isBuffer(num)) {
    let size = num.length
    if (num.length === 0) { size++ }

    const out = Buffer.alloc(size)
    num.copy(out)
    if (num.length === 0) { out[0] = 0 }
    return this._createEncoderBuffer(out)
  }

  if (num < 0x80) { return this._createEncoderBuffer(num) }

  if (num < 0x100) { return this._createEncoderBuffer([0, num]) }

  let size = 1
  for (let i = num; i >= 0x100; i >>= 8) { size++ }

  const out = new Array(size)
  for (let i = out.length - 1; i >= 0; i--) {
    out[i] = num & 0xff
    num >>= 8
  }
  if (out[0] & 0x80) {
    out.unshift(0)
  }

  return this._createEncoderBuffer(Buffer.from(out))
}

DERNode.prototype._encodeBool = function encodeBool (value) {
  return this._createEncoderBuffer(value ? 0xff : 0)
}

DERNode.prototype._use = function use (entity, obj) {
  if (typeof entity === 'function') { entity = entity(obj) }
  return entity._getEncoder('der').tree
}

DERNode.prototype._skipDefault = function skipDefault (dataBuffer, reporter, parent) {
  const state = this._baseState
  let i
  if (state.default === null) { return false }

  const data = dataBuffer.join()
  if (state.defaultBuffer === undefined) { state.defaultBuffer = this._encodeValue(state.default, reporter, parent).join() }

  if (data.length !== state.defaultBuffer.length) { return false }

  for (i = 0; i < data.length; i++) {
    if (data[i] !== state.defaultBuffer[i]) { return false }
  }

  return true
}

// Utility methods

function encodeTag (tag, primitive, cls, reporter) {
  let res

  if (tag === 'seqof') { tag = 'seq' } else if (tag === 'setof') { tag = 'set' }

  if (Object.prototype.hasOwnProperty.call(der.tagByName, tag)) { res = der.tagByName[tag] } else if (typeof tag === 'number' && (tag | 0) === tag) { res = tag } else { return reporter.error(`Unknown tag: ${tag}`) }

  if (res >= 0x1f) { return reporter.error('Multi-octet tag encoding unsupported') }

  if (!primitive) { res |= 0x20 }

  res |= (der.tagClassByName[cls || 'universal'] << 6)

  return res
}

module.exports = DEREncoder


/***/ }),

/***/ 55457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
  der: __webpack_require__(7081),
  pem: __webpack_require__(74858)
}


/***/ }),

/***/ 74858:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { inherits } = __webpack_require__(79720)

const DEREncoder = __webpack_require__(7081)

function PEMEncoder (entity) {
  DEREncoder.call(this, entity)
  this.enc = 'pem'
}
inherits(PEMEncoder, DEREncoder)

PEMEncoder.prototype.encode = function encode (data, options) {
  const buf = DEREncoder.prototype.encode.call(this, data)

  const p = buf.toString('base64')
  const out = [`-----BEGIN ${options.label}-----`]
  for (let i = 0; i < p.length; i += 64) { out.push(p.slice(i, i + 64)) }
  out.push(`-----END ${options.label}-----`)
  return out.join('\n')
}

module.exports = PEMEncoder


/***/ }),

/***/ 90966:
/***/ (function() {

test

/***/ }),

/***/ 93373:
/***/ (function() {

test

/***/ }),

/***/ 59533:
/***/ (function() {

test

/***/ }),

/***/ 99859:
/***/ (function() {

test

/***/ }),

/***/ 47857:
/***/ (function() {

test

/***/ }),

/***/ 53851:
/***/ (function() {

test

/***/ }),

/***/ 14315:
/***/ (function() {

test

/***/ }),

/***/ 9831:
/***/ (function() {

test

/***/ }),

/***/ 5607:
/***/ (function() {

test

/***/ }),

/***/ 28272:
/***/ (function() {

test

/***/ }),

/***/ 5293:
/***/ (function() {

test

/***/ }),

/***/ 27791:
/***/ (function() {

test

/***/ }),

/***/ 7141:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./aws-secrets-manager/aws_secrets_manager": 55024,
	"./aws-secrets-manager/aws_secrets_manager.js": 55024,
	"./aws-secrets-manager/package": 95194,
	"./aws-secrets-manager/package.json": 95194,
	"./aws-secrets-manager/readme.md": 90966,
	"./cloudflare/cache": 97476,
	"./cloudflare/cache.js": 97476,
	"./cloudflare/cloudflare": 57042,
	"./cloudflare/cloudflare.js": 57042,
	"./cloudflare/package": 99751,
	"./cloudflare/package.json": 99751,
	"./cloudflare/readme.md": 93373,
	"./cloudflare/records": 88729,
	"./cloudflare/records.js": 88729,
	"./cloudflare/zones": 23599,
	"./cloudflare/zones.js": 23599,
	"./copper/companies": 77606,
	"./copper/companies.js": 77606,
	"./copper/copper": 15446,
	"./copper/copper.js": 15446,
	"./copper/custom_fields": 26451,
	"./copper/custom_fields.js": 26451,
	"./copper/opportunities": 61564,
	"./copper/opportunities.js": 61564,
	"./copper/package": 74091,
	"./copper/package.json": 74091,
	"./copper/readme.md": 59533,
	"./copper/users": 3500,
	"./copper/users.js": 3500,
	"./copper/webhooks/company_webhook": 88233,
	"./copper/webhooks/company_webhook.js": 88233,
	"./copper/webhooks/opportunity_webhook": 15665,
	"./copper/webhooks/opportunity_webhook.js": 15665,
	"./copper/webhooks/webhooks": 65149,
	"./copper/webhooks/webhooks.js": 65149,
	"./doppler/doppler": 55984,
	"./doppler/doppler.js": 55984,
	"./doppler/package": 29214,
	"./doppler/package.json": 29214,
	"./doppler/readme.md": 99859,
	"./frontegg/frontegg": 22597,
	"./frontegg/frontegg.js": 22597,
	"./frontegg/package": 80037,
	"./frontegg/package.json": 80037,
	"./frontegg/readme.md": 47857,
	"./google-drive/drives": 25940,
	"./google-drive/drives.js": 25940,
	"./google-drive/files": 91751,
	"./google-drive/files.js": 91751,
	"./google-drive/folders": 34637,
	"./google-drive/folders.js": 34637,
	"./google-drive/google_drive": 39915,
	"./google-drive/google_drive.js": 39915,
	"./google-drive/package": 17959,
	"./google-drive/package.json": 17959,
	"./google-drive/permissions": 31028,
	"./google-drive/permissions.js": 31028,
	"./google-drive/readme.md": 53851,
	"./hasura/applications/applications": 89103,
	"./hasura/applications/applications.js": 89103,
	"./hasura/attributes/attributes": 49079,
	"./hasura/attributes/attributes.js": 49079,
	"./hasura/attributes/entity-attributes": 74883,
	"./hasura/attributes/entity-attributes.js": 74883,
	"./hasura/files/files": 89361,
	"./hasura/files/files.js": 89361,
	"./hasura/hasura": 98172,
	"./hasura/hasura.js": 98172,
	"./hasura/orders/orders": 56129,
	"./hasura/orders/orders.js": 56129,
	"./hasura/organizations/clients": 67697,
	"./hasura/organizations/clients.js": 67697,
	"./hasura/organizations/organizations": 2975,
	"./hasura/organizations/organizations.js": 2975,
	"./hasura/package": 37817,
	"./hasura/package.json": 37817,
	"./hasura/products/products": 87916,
	"./hasura/products/products.js": 87916,
	"./hasura/projects/projects": 11597,
	"./hasura/projects/projects.js": 11597,
	"./hasura/readme.md": 14315,
	"./hasura/source/event-queue": 53606,
	"./hasura/source/event-queue.js": 53606,
	"./hasura/tenants/tenants": 2943,
	"./hasura/tenants/tenants.js": 2943,
	"./hasura/tickets/tickets": 10162,
	"./hasura/tickets/tickets.js": 10162,
	"./hasura/users/users": 91107,
	"./hasura/users/users.js": 91107,
	"./hasura/webhooks/authentication_webhook": 35681,
	"./hasura/webhooks/authentication_webhook.js": 35681,
	"./hasura/webhooks/webhooks": 78485,
	"./hasura/webhooks/webhooks.js": 78485,
	"./netlify/netlify": 33383,
	"./netlify/netlify.js": 33383,
	"./netlify/package": 31405,
	"./netlify/package.json": 31405,
	"./netlify/readme.md": 9831,
	"./utilities/cache": 74806,
	"./utilities/cache.js": 74806,
	"./utilities/integration": 59709,
	"./utilities/integration.js": 59709,
	"./utilities/integrations": 79523,
	"./utilities/integrations.js": 79523,
	"./utilities/package": 57867,
	"./utilities/package.json": 57867,
	"./utilities/readme.md": 5607,
	"./utilities/utilities": 93909,
	"./utilities/utilities.js": 93909,
	"./woocommerce/attributes": 17019,
	"./woocommerce/attributes.js": 17019,
	"./woocommerce/categories": 49723,
	"./woocommerce/categories.js": 49723,
	"./woocommerce/coupons": 71217,
	"./woocommerce/coupons.js": 71217,
	"./woocommerce/customers": 88074,
	"./woocommerce/customers.js": 88074,
	"./woocommerce/notes": 64996,
	"./woocommerce/notes.js": 64996,
	"./woocommerce/orders": 89322,
	"./woocommerce/orders.js": 89322,
	"./woocommerce/package": 36036,
	"./woocommerce/package.json": 36036,
	"./woocommerce/products": 42631,
	"./woocommerce/products.js": 42631,
	"./woocommerce/readme.md": 28272,
	"./woocommerce/refunds": 94439,
	"./woocommerce/refunds.js": 94439,
	"./woocommerce/tags": 22379,
	"./woocommerce/tags.js": 22379,
	"./woocommerce/variations": 7974,
	"./woocommerce/variations.js": 7974,
	"./woocommerce/woocommerce": 32699,
	"./woocommerce/woocommerce.js": 32699,
	"./wordpress/package": 37637,
	"./wordpress/package.json": 37637,
	"./wordpress/readme.md": 5293,
	"./wordpress/sites": 17162,
	"./wordpress/sites.js": 17162,
	"./wordpress/wordpress": 124,
	"./wordpress/wordpress.js": 124,
	"./wpengine/accounts": 93304,
	"./wpengine/accounts.js": 93304,
	"./wpengine/cache": 70936,
	"./wpengine/cache.js": 70936,
	"./wpengine/domains": 68124,
	"./wpengine/domains.js": 68124,
	"./wpengine/installs": 97474,
	"./wpengine/installs.js": 97474,
	"./wpengine/package": 31678,
	"./wpengine/package.json": 31678,
	"./wpengine/readme.md": 27791,
	"./wpengine/sites": 85335,
	"./wpengine/sites.js": 85335,
	"./wpengine/wpengine": 64961,
	"./wpengine/wpengine.js": 64961
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7141;

/***/ }),

/***/ 64487:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$e": function() { return /* binding */ withScope; },
/* harmony export */   "Tb": function() { return /* binding */ captureException; },
/* harmony export */   "e": function() { return /* binding */ configureScope; }
/* harmony export */ });
/* unused harmony exports addBreadcrumb, captureEvent, captureMessage, setContext, setExtra, setExtras, setTag, setTags, setUser, startTransaction */
/* harmony import */ var _hub_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95659);


// Note: All functions in this file are typed with a return value of `ReturnType<Hub[HUB_FUNCTION]>`,
// where HUB_FUNCTION is some method on the Hub class.
//
// This is done to make sure the top level SDK methods stay in sync with the hub methods.
// Although every method here has an explicit return type, some of them (that map to void returns) do not
// contain `return` keywords. This is done to save on bundle size, as `return` is not minifiable.

/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @param captureContext Additional scope data to apply to exception event.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
  return (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().captureException(exception, { captureContext });
}

/**
 * Captures a message event and sends it to Sentry.
 *
 * @param message The message to send to Sentry.
 * @param Severity Define the level of the message.
 * @returns The generated eventId.
 */
function captureMessage(
  message,
  // eslint-disable-next-line deprecation/deprecation
  captureContext,
) {
  // This is necessary to provide explicit scopes upgrade, without changing the original
  // arity of the `captureMessage(message, level)` method.
  const level = typeof captureContext === 'string' ? captureContext : undefined;
  const context = typeof captureContext !== 'string' ? { captureContext } : undefined;
  return getCurrentHub().captureMessage(message, level, context);
}

/**
 * Captures a manually created event and sends it to Sentry.
 *
 * @param event The event to send to Sentry.
 * @returns The generated eventId.
 */
function captureEvent(event, hint) {
  return getCurrentHub().captureEvent(event, hint);
}

/**
 * Callback to set context information onto the scope.
 * @param callback Callback function that receives Scope.
 */
function configureScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().configureScope(callback);
}

/**
 * Records a new breadcrumb which will be attached to future events.
 *
 * Breadcrumbs will be added to subsequent events to provide more context on
 * user's actions prior to an error or crash.
 *
 * @param breadcrumb The breadcrumb to record.
 */
function addBreadcrumb(breadcrumb) {
  getCurrentHub().addBreadcrumb(breadcrumb);
}

/**
 * Sets context data with the given name.
 * @param name of the context
 * @param context Any kind of data. This data will be normalized.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setContext(name, context) {
  getCurrentHub().setContext(name, context);
}

/**
 * Set an object that will be merged sent as extra data with the event.
 * @param extras Extras object to merge into current context.
 */
function setExtras(extras) {
  getCurrentHub().setExtras(extras);
}

/**
 * Set key:value that will be sent as extra data with the event.
 * @param key String of extra
 * @param extra Any kind of data. This data will be normalized.
 */
function setExtra(key, extra) {
  getCurrentHub().setExtra(key, extra);
}

/**
 * Set an object that will be merged sent as tags data with the event.
 * @param tags Tags context object to merge into current context.
 */
function setTags(tags) {
  getCurrentHub().setTags(tags);
}

/**
 * Set key:value that will be sent as tags data with the event.
 *
 * Can also be used to unset a tag, by passing `undefined`.
 *
 * @param key String key of tag
 * @param value Value of tag
 */
function setTag(key, value) {
  getCurrentHub().setTag(key, value);
}

/**
 * Updates user context information for future events.
 *
 * @param user User context object to be set in the current context. Pass `null` to unset the user.
 */
function setUser(user) {
  getCurrentHub().setUser(user);
}

/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
  (0,_hub_js__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().withScope(callback);
}

/**
 * Starts a new `Transaction` and returns it. This is the entry point to manual tracing instrumentation.
 *
 * A tree structure can be built by adding child spans to the transaction, and child spans to other spans. To start a
 * new child span within the transaction or any span, call the respective `.startChild()` method.
 *
 * Every child span must be finished before the transaction is finished, otherwise the unfinished spans are discarded.
 *
 * The transaction must be finished with a call to its `.finish()` method, at which point the transaction with all its
 * finished child spans will be sent to Sentry.
 *
 * NOTE: This function should only be used for *manual* instrumentation. Auto-instrumentation should call
 * `startTransaction` directly on the hub.
 *
 * @param context Properties of the new `Transaction`.
 * @param customSamplingContext Information given to the transaction sampling function (along with context-dependent
 * default values). See {@link Options.tracesSampler}.
 *
 * @returns The transaction which was just started
 */
function startTransaction(
  context,
  customSamplingContext,
) {
  return getCurrentHub().startTransaction({ ...context }, customSamplingContext);
}


//# sourceMappingURL=exports.js.map


/***/ }),

/***/ 95659:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Gd": function() { return /* binding */ getCurrentHub; },
/* harmony export */   "cu": function() { return /* binding */ getMainCarrier; }
/* harmony export */ });
/* unused harmony exports API_VERSION, Hub, getHubFromCarrier, makeMain, setHubOnCarrier */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71235);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92448);
/* harmony import */ var _scope_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(10350);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9015);




/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
const API_VERSION = 4;

/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
const DEFAULT_BREADCRUMBS = 100;

/**
 * A layer in the process stack.
 * @hidden
 */

/**
 * @inheritDoc
 */
class Hub  {
  /** Is a {@link Layer}[] containing the client and scope */
    __init() {this._stack = [{}];}

  /** Contains the last event id of a captured event.  */

  /**
   * Creates a new instance of the hub, will push one {@link Layer} into the
   * internal stack on creation.
   *
   * @param client bound to the hub.
   * @param scope bound to the hub.
   * @param version number, higher number means higher priority.
   */
   constructor(client, scope = new _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope */ .s(),   _version = API_VERSION) {;this._version = _version;Hub.prototype.__init.call(this);
    this.getStackTop().scope = scope;
    if (client) {
      this.bindClient(client);
    }
  }

  /**
   * @inheritDoc
   */
   isOlderThan(version) {
    return this._version < version;
  }

  /**
   * @inheritDoc
   */
   bindClient(client) {
    const top = this.getStackTop();
    top.client = client;
    if (client && client.setupIntegrations) {
      client.setupIntegrations();
    }
  }

  /**
   * @inheritDoc
   */
   pushScope() {
    // We want to clone the content of prev scope
    const scope = _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(this.getScope());
    this.getStack().push({
      client: this.getClient(),
      scope,
    });
    return scope;
  }

  /**
   * @inheritDoc
   */
   popScope() {
    if (this.getStack().length <= 1) return false;
    return !!this.getStack().pop();
  }

  /**
   * @inheritDoc
   */
   withScope(callback) {
    const scope = this.pushScope();
    try {
      callback(scope);
    } finally {
      this.popScope();
    }
  }

  /**
   * @inheritDoc
   */
   getClient() {
    return this.getStackTop().client ;
  }

  /** Returns the scope of the top stack. */
   getScope() {
    return this.getStackTop().scope;
  }

  /** Returns the scope stack for domains or the process. */
   getStack() {
    return this._stack;
  }

  /** Returns the topmost scope layer in the order domain > local > process. */
   getStackTop() {
    return this._stack[this._stack.length - 1];
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    const syntheticException = new Error('Sentry syntheticException');
    this._withClient((client, scope) => {
      client.captureException(
        exception,
        {
          originalException: exception,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
  ) {
    const eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)());
    const syntheticException = new Error(message);
    this._withClient((client, scope) => {
      client.captureMessage(
        message,
        level,
        {
          originalException: message,
          syntheticException,
          ...hint,
          event_id: eventId,
        },
        scope,
      );
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint) {
    const eventId = hint && hint.event_id ? hint.event_id : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
    if (event.type !== 'transaction') {
      this._lastEventId = eventId;
    }

    this._withClient((client, scope) => {
      client.captureEvent(event, { ...hint, event_id: eventId }, scope);
    });
    return eventId;
  }

  /**
   * @inheritDoc
   */
   lastEventId() {
    return this._lastEventId;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, hint) {
    const { scope, client } = this.getStackTop();

    if (!scope || !client) return;

    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { beforeBreadcrumb = null, maxBreadcrumbs = DEFAULT_BREADCRUMBS } =
      (client.getOptions && client.getOptions()) || {};

    if (maxBreadcrumbs <= 0) return;

    const timestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)();
    const mergedBreadcrumb = { timestamp, ...breadcrumb };
    const finalBreadcrumb = beforeBreadcrumb
      ? ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .consoleSandbox */ .Cf)(() => beforeBreadcrumb(mergedBreadcrumb, hint)) )
      : mergedBreadcrumb;

    if (finalBreadcrumb === null) return;

    scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    const scope = this.getScope();
    if (scope) scope.setUser(user);
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    const scope = this.getScope();
    if (scope) scope.setTags(tags);
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    const scope = this.getScope();
    if (scope) scope.setExtras(extras);
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    const scope = this.getScope();
    if (scope) scope.setTag(key, value);
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    const scope = this.getScope();
    if (scope) scope.setExtra(key, extra);
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   setContext(name, context) {
    const scope = this.getScope();
    if (scope) scope.setContext(name, context);
  }

  /**
   * @inheritDoc
   */
   configureScope(callback) {
    const { scope, client } = this.getStackTop();
    if (scope && client) {
      callback(scope);
    }
  }

  /**
   * @inheritDoc
   */
   run(callback) {
    const oldHub = makeMain(this);
    try {
      callback(this);
    } finally {
      makeMain(oldHub);
    }
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    const client = this.getClient();
    if (!client) return null;
    try {
      return client.getIntegration(integration);
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Cannot retrieve integration ${integration.id} from the current Hub`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   startTransaction(context, customSamplingContext) {
    return this._callExtensionMethod('startTransaction', context, customSamplingContext);
  }

  /**
   * @inheritDoc
   */
   traceHeaders() {
    return this._callExtensionMethod('traceHeaders');
  }

  /**
   * @inheritDoc
   */
   captureSession(endSession = false) {
    // both send the update and pull the session from the scope
    if (endSession) {
      return this.endSession();
    }

    // only send the update
    this._sendSessionUpdate();
  }

  /**
   * @inheritDoc
   */
   endSession() {
    const layer = this.getStackTop();
    const scope = layer && layer.scope;
    const session = scope && scope.getSession();
    if (session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .closeSession */ .RJ)(session);
    }
    this._sendSessionUpdate();

    // the session is over; take it off of the scope
    if (scope) {
      scope.setSession();
    }
  }

  /**
   * @inheritDoc
   */
   startSession(context) {
    const { scope, client } = this.getStackTop();
    const { release, environment } = (client && client.getOptions()) || {};

    // Will fetch userAgent if called from browser sdk
    const { userAgent } = _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .GLOBAL_OBJ.navigator */ .n2.navigator || {};

    const session = (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .makeSession */ .Hv)({
      release,
      environment,
      ...(scope && { user: scope.getUser() }),
      ...(userAgent && { userAgent }),
      ...context,
    });

    if (scope) {
      // End existing session if there's one
      const currentSession = scope.getSession && scope.getSession();
      if (currentSession && currentSession.status === 'ok') {
        (0,_session_js__WEBPACK_IMPORTED_MODULE_4__/* .updateSession */ .CT)(currentSession, { status: 'exited' });
      }
      this.endSession();

      // Afterwards we set the new session on the scope
      scope.setSession(session);
    }

    return session;
  }

  /**
   * Returns if default PII should be sent to Sentry and propagated in ourgoing requests
   * when Tracing is used.
   */
   shouldSendDefaultPii() {
    const client = this.getClient();
    const options = client && client.getOptions();
    return Boolean(options && options.sendDefaultPii);
  }

  /**
   * Sends the current Session on the scope
   */
   _sendSessionUpdate() {
    const { scope, client } = this.getStackTop();
    if (!scope) return;

    const session = scope.getSession();
    if (session) {
      if (client && client.captureSession) {
        client.captureSession(session);
      }
    }
  }

  /**
   * Internal helper function to call a method on the top client if it exists.
   *
   * @param method The method to call on the client.
   * @param args Arguments to pass to the client function.
   */
   _withClient(callback) {
    const { scope, client } = this.getStackTop();
    if (client) {
      callback(client, scope);
    }
  }

  /**
   * Calls global extension method and binding current instance to the function call
   */
  // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   _callExtensionMethod(method, ...args) {
    const carrier = getMainCarrier();
    const sentry = carrier.__SENTRY__;
    if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
      return sentry.extensions[method].apply(this, args);
    }
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn(`Extension method ${method} couldn't be found, doing nothing.`);
  }
}

/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
  _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ = _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .GLOBAL_OBJ.__SENTRY__ */ .n2.__SENTRY__ || {
    extensions: {},
    hub: undefined,
  };
  return _sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .GLOBAL_OBJ */ .n2;
}

/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
  const registry = getMainCarrier();
  const oldHub = getHubFromCarrier(registry);
  setHubOnCarrier(registry, hub);
  return oldHub;
}

/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
  // Get main carrier (global for every environment)
  const registry = getMainCarrier();

  // If there's no hub, or its an old API, assign a new one
  if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
    setHubOnCarrier(registry, new Hub());
  }

  // Prefer domains over global if they are there (applicable only to Node environment)
  if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .isNodeEnv */ .KV)()) {
    return getHubFromActiveDomain(registry);
  }
  // Return hub that lives on a global object
  return getHubFromCarrier(registry);
}

/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
  try {
    const sentry = getMainCarrier().__SENTRY__;
    const activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;

    // If there's no active domain, just return global hub
    if (!activeDomain) {
      return getHubFromCarrier(registry);
    }

    // If there's no hub on current domain, or it's an old API, assign a new one
    if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
      const registryHubTopStack = getHubFromCarrier(registry).getStackTop();
      setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, _scope_js__WEBPACK_IMPORTED_MODULE_0__/* .Scope.clone */ .s.clone(registryHubTopStack.scope)));
    }

    // Return hub that lives on a domain
    return getHubFromCarrier(activeDomain);
  } catch (_Oo) {
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
  }
}

/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
  return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}

/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .getGlobalSingleton */ .YO)('hub', () => new Hub(), carrier);
}

/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
  if (!carrier) return false;
  const __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
  __SENTRY__.hub = hub;
  return true;
}


//# sourceMappingURL=hub.js.map


/***/ }),

/***/ 10350:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "c": function() { return /* binding */ addGlobalEventProcessor; },
/* harmony export */   "s": function() { return /* binding */ Scope; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96893);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(71235);
/* harmony import */ var _session_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9015);



/**
 * Default value for maximum number of breadcrumbs added to an event.
 */
const DEFAULT_MAX_BREADCRUMBS = 100;

/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
class Scope  {
  /** Flag if notifying is happening. */

  /** Callback for client to receive scope changes. */

  /** Callback list that will be called after {@link applyToEvent}. */

  /** Array of breadcrumbs. */

  /** User */

  /** Tags */

  /** Extra */

  /** Contexts */

  /** Attachments */

  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */

  /** Fingerprint */

  /** Severity */
  // eslint-disable-next-line deprecation/deprecation

  /** Transaction Name */

  /** Span */

  /** Session */

  /** Request Mode Session Status */

  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.

   constructor() {
    this._notifyingListeners = false;
    this._scopeListeners = [];
    this._eventProcessors = [];
    this._breadcrumbs = [];
    this._attachments = [];
    this._user = {};
    this._tags = {};
    this._extra = {};
    this._contexts = {};
    this._sdkProcessingMetadata = {};
  }

  /**
   * Inherit values from the parent scope.
   * @param scope to clone.
   */
   static clone(scope) {
    const newScope = new Scope();
    if (scope) {
      newScope._breadcrumbs = [...scope._breadcrumbs];
      newScope._tags = { ...scope._tags };
      newScope._extra = { ...scope._extra };
      newScope._contexts = { ...scope._contexts };
      newScope._user = scope._user;
      newScope._level = scope._level;
      newScope._span = scope._span;
      newScope._session = scope._session;
      newScope._transactionName = scope._transactionName;
      newScope._fingerprint = scope._fingerprint;
      newScope._eventProcessors = [...scope._eventProcessors];
      newScope._requestSession = scope._requestSession;
      newScope._attachments = [...scope._attachments];
      newScope._sdkProcessingMetadata = { ...scope._sdkProcessingMetadata };
    }
    return newScope;
  }

  /**
   * Add internal on change listener. Used for sub SDKs that need to store the scope.
   * @hidden
   */
   addScopeListener(callback) {
    this._scopeListeners.push(callback);
  }

  /**
   * @inheritDoc
   */
   addEventProcessor(callback) {
    this._eventProcessors.push(callback);
    return this;
  }

  /**
   * @inheritDoc
   */
   setUser(user) {
    this._user = user || {};
    if (this._session) {
      (0,_session_js__WEBPACK_IMPORTED_MODULE_0__/* .updateSession */ .CT)(this._session, { user });
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getUser() {
    return this._user;
  }

  /**
   * @inheritDoc
   */
   getRequestSession() {
    return this._requestSession;
  }

  /**
   * @inheritDoc
   */
   setRequestSession(requestSession) {
    this._requestSession = requestSession;
    return this;
  }

  /**
   * @inheritDoc
   */
   setTags(tags) {
    this._tags = {
      ...this._tags,
      ...tags,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this._tags = { ...this._tags, [key]: value };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtras(extras) {
    this._extra = {
      ...this._extra,
      ...extras,
    };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setExtra(key, extra) {
    this._extra = { ...this._extra, [key]: extra };
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setFingerprint(fingerprint) {
    this._fingerprint = fingerprint;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setLevel(
    // eslint-disable-next-line deprecation/deprecation
    level,
  ) {
    this._level = level;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setTransactionName(name) {
    this._transactionName = name;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }

    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   setSpan(span) {
    this._span = span;
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSpan() {
    return this._span;
  }

  /**
   * @inheritDoc
   */
   getTransaction() {
    // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
    // have a pointer to the currently-active transaction.
    const span = this.getSpan();
    return span && span.transaction;
  }

  /**
   * @inheritDoc
   */
   setSession(session) {
    if (!session) {
      delete this._session;
    } else {
      this._session = session;
    }
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   getSession() {
    return this._session;
  }

  /**
   * @inheritDoc
   */
   update(captureContext) {
    if (!captureContext) {
      return this;
    }

    if (typeof captureContext === 'function') {
      const updatedScope = (captureContext )(this);
      return updatedScope instanceof Scope ? updatedScope : this;
    }

    if (captureContext instanceof Scope) {
      this._tags = { ...this._tags, ...captureContext._tags };
      this._extra = { ...this._extra, ...captureContext._extra };
      this._contexts = { ...this._contexts, ...captureContext._contexts };
      if (captureContext._user && Object.keys(captureContext._user).length) {
        this._user = captureContext._user;
      }
      if (captureContext._level) {
        this._level = captureContext._level;
      }
      if (captureContext._fingerprint) {
        this._fingerprint = captureContext._fingerprint;
      }
      if (captureContext._requestSession) {
        this._requestSession = captureContext._requestSession;
      }
    } else if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isPlainObject */ .PO)(captureContext)) {
      // eslint-disable-next-line no-param-reassign
      captureContext = captureContext ;
      this._tags = { ...this._tags, ...captureContext.tags };
      this._extra = { ...this._extra, ...captureContext.extra };
      this._contexts = { ...this._contexts, ...captureContext.contexts };
      if (captureContext.user) {
        this._user = captureContext.user;
      }
      if (captureContext.level) {
        this._level = captureContext.level;
      }
      if (captureContext.fingerprint) {
        this._fingerprint = captureContext.fingerprint;
      }
      if (captureContext.requestSession) {
        this._requestSession = captureContext.requestSession;
      }
    }

    return this;
  }

  /**
   * @inheritDoc
   */
   clear() {
    this._breadcrumbs = [];
    this._tags = {};
    this._extra = {};
    this._user = {};
    this._contexts = {};
    this._level = undefined;
    this._transactionName = undefined;
    this._fingerprint = undefined;
    this._requestSession = undefined;
    this._span = undefined;
    this._session = undefined;
    this._notifyScopeListeners();
    this._attachments = [];
    return this;
  }

  /**
   * @inheritDoc
   */
   addBreadcrumb(breadcrumb, maxBreadcrumbs) {
    const maxCrumbs = typeof maxBreadcrumbs === 'number' ? maxBreadcrumbs : DEFAULT_MAX_BREADCRUMBS;

    // No data has been changed, so don't notify scope listeners
    if (maxCrumbs <= 0) {
      return this;
    }

    const mergedBreadcrumb = {
      timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dateTimestampInSeconds */ .yW)(),
      ...breadcrumb,
    };
    this._breadcrumbs = [...this._breadcrumbs, mergedBreadcrumb].slice(-maxCrumbs);
    this._notifyScopeListeners();

    return this;
  }

  /**
   * @inheritDoc
   */
   getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }

  /**
   * @inheritDoc
   */
   clearBreadcrumbs() {
    this._breadcrumbs = [];
    this._notifyScopeListeners();
    return this;
  }

  /**
   * @inheritDoc
   */
   addAttachment(attachment) {
    this._attachments.push(attachment);
    return this;
  }

  /**
   * @inheritDoc
   */
   getAttachments() {
    return this._attachments;
  }

  /**
   * @inheritDoc
   */
   clearAttachments() {
    this._attachments = [];
    return this;
  }

  /**
   * Applies data from the scope to the event and runs all event processors on it.
   *
   * @param event Event
   * @param hint Object containing additional information about the original exception, for use by the event processors.
   * @hidden
   */
   applyToEvent(event, hint = {}) {
    if (this._extra && Object.keys(this._extra).length) {
      event.extra = { ...this._extra, ...event.extra };
    }
    if (this._tags && Object.keys(this._tags).length) {
      event.tags = { ...this._tags, ...event.tags };
    }
    if (this._user && Object.keys(this._user).length) {
      event.user = { ...this._user, ...event.user };
    }
    if (this._contexts && Object.keys(this._contexts).length) {
      event.contexts = { ...this._contexts, ...event.contexts };
    }
    if (this._level) {
      event.level = this._level;
    }
    if (this._transactionName) {
      event.transaction = this._transactionName;
    }

    // We want to set the trace context for normal events only if there isn't already
    // a trace context on the event. There is a product feature in place where we link
    // errors with transaction and it relies on that.
    if (this._span) {
      event.contexts = { trace: this._span.getTraceContext(), ...event.contexts };
      const transactionName = this._span.transaction && this._span.transaction.name;
      if (transactionName) {
        event.tags = { transaction: transactionName, ...event.tags };
      }
    }

    this._applyFingerprint(event);

    event.breadcrumbs = [...(event.breadcrumbs || []), ...this._breadcrumbs];
    event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;

    event.sdkProcessingMetadata = { ...event.sdkProcessingMetadata, ...this._sdkProcessingMetadata };

    return this._notifyEventProcessors([...getGlobalEventProcessors(), ...this._eventProcessors], event, hint);
  }

  /**
   * Add data which will be accessible during event processing but won't get sent to Sentry
   */
   setSDKProcessingMetadata(newData) {
    this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...newData };

    return this;
  }

  /**
   * This will be called after {@link applyToEvent} is finished.
   */
   _notifyEventProcessors(
    processors,
    event,
    hint,
    index = 0,
  ) {
    return new _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .SyncPromise */ .cW((resolve, reject) => {
      const processor = processors[index];
      if (event === null || typeof processor !== 'function') {
        resolve(event);
      } else {
        const result = processor({ ...event }, hint) ;

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          processor.id &&
          result === null &&
          _sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .logger.log */ .kg.log(`Event processor "${processor.id}" dropped event`);

        if ((0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .isThenable */ .J8)(result)) {
          void result
            .then(final => this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve))
            .then(null, reject);
        } else {
          void this._notifyEventProcessors(processors, result, hint, index + 1)
            .then(resolve)
            .then(null, reject);
        }
      }
    });
  }

  /**
   * This will be called on every set call.
   */
   _notifyScopeListeners() {
    // We need this check for this._notifyingListeners to be able to work on scope during updates
    // If this check is not here we'll produce endless recursion when something is done with the scope
    // during the callback.
    if (!this._notifyingListeners) {
      this._notifyingListeners = true;
      this._scopeListeners.forEach(callback => {
        callback(this);
      });
      this._notifyingListeners = false;
    }
  }

  /**
   * Applies fingerprint from the scope to the event if there's one,
   * uses message if there's one instead or get rid of empty fingerprint
   */
   _applyFingerprint(event) {
    // Make sure it's an array first and we actually have something in place
    event.fingerprint = event.fingerprint ? (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_5__/* .arrayify */ .lE)(event.fingerprint) : [];

    // If we have something on the scope, then merge it with event
    if (this._fingerprint) {
      event.fingerprint = event.fingerprint.concat(this._fingerprint);
    }

    // If we have no data at all, remove empty array default
    if (event.fingerprint && !event.fingerprint.length) {
      delete event.fingerprint;
    }
  }
}

/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .getGlobalSingleton */ .YO)('globalEventProcessors', () => []);
}

/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
  getGlobalEventProcessors().push(callback);
}


//# sourceMappingURL=scope.js.map


/***/ }),

/***/ 9015:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CT": function() { return /* binding */ updateSession; },
/* harmony export */   "Hv": function() { return /* binding */ makeSession; },
/* harmony export */   "RJ": function() { return /* binding */ closeSession; }
/* harmony export */ });
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(20535);


/**
 * Creates a new `Session` object by setting certain default parameters. If optional @param context
 * is passed, the passed properties are applied to the session object.
 *
 * @param context (optional) additional properties to be applied to the returned session object
 *
 * @returns a new `Session` object
 */
function makeSession(context) {
  // Both timestamp and started are in seconds since the UNIX epoch.
  const startingTime = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  const session = {
    sid: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)(),
    init: true,
    timestamp: startingTime,
    started: startingTime,
    duration: 0,
    status: 'ok',
    errors: 0,
    ignoreDuration: false,
    toJSON: () => sessionToJSON(session),
  };

  if (context) {
    updateSession(session, context);
  }

  return session;
}

/**
 * Updates a session object with the properties passed in the context.
 *
 * Note that this function mutates the passed object and returns void.
 * (Had to do this instead of returning a new and updated session because closing and sending a session
 * makes an update to the session after it was passed to the sending logic.
 * @see BaseClient.captureSession )
 *
 * @param session the `Session` to update
 * @param context the `SessionContext` holding the properties that should be updated in @param session
 */
// eslint-disable-next-line complexity
function updateSession(session, context = {}) {
  if (context.user) {
    if (!session.ipAddress && context.user.ip_address) {
      session.ipAddress = context.user.ip_address;
    }

    if (!session.did && !context.did) {
      session.did = context.user.id || context.user.email || context.user.username;
    }
  }

  session.timestamp = context.timestamp || (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .timestampInSeconds */ .ph)();

  if (context.ignoreDuration) {
    session.ignoreDuration = context.ignoreDuration;
  }
  if (context.sid) {
    // Good enough uuid validation. — Kamil
    session.sid = context.sid.length === 32 ? context.sid : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .uuid4 */ .DM)();
  }
  if (context.init !== undefined) {
    session.init = context.init;
  }
  if (!session.did && context.did) {
    session.did = `${context.did}`;
  }
  if (typeof context.started === 'number') {
    session.started = context.started;
  }
  if (session.ignoreDuration) {
    session.duration = undefined;
  } else if (typeof context.duration === 'number') {
    session.duration = context.duration;
  } else {
    const duration = session.timestamp - session.started;
    session.duration = duration >= 0 ? duration : 0;
  }
  if (context.release) {
    session.release = context.release;
  }
  if (context.environment) {
    session.environment = context.environment;
  }
  if (!session.ipAddress && context.ipAddress) {
    session.ipAddress = context.ipAddress;
  }
  if (!session.userAgent && context.userAgent) {
    session.userAgent = context.userAgent;
  }
  if (typeof context.errors === 'number') {
    session.errors = context.errors;
  }
  if (context.status) {
    session.status = context.status;
  }
}

/**
 * Closes a session by setting its status and updating the session object with it.
 * Internally calls `updateSession` to update the passed session object.
 *
 * Note that this function mutates the passed session (@see updateSession for explanation).
 *
 * @param session the `Session` object to be closed
 * @param status the `SessionStatus` with which the session was closed. If you don't pass a status,
 *               this function will keep the previously set status, unless it was `'ok'` in which case
 *               it is changed to `'exited'`.
 */
function closeSession(session, status) {
  let context = {};
  if (status) {
    context = { status };
  } else if (session.status === 'ok') {
    context = { status: 'exited' };
  }

  updateSession(session, context);
}

/**
 * Serializes a passed session object to a JSON object with a slightly different structure.
 * This is necessary because the Sentry backend requires a slightly different schema of a session
 * than the one the JS SDKs use internally.
 *
 * @param session the session to be converted
 *
 * @returns a JSON object of the passed session
 */
function sessionToJSON(session) {
  return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .dropUndefinedKeys */ .Jr)({
    sid: `${session.sid}`,
    init: session.init,
    // Make sure that sec is converted to ms for date constructor
    started: new Date(session.started * 1000).toISOString(),
    timestamp: new Date(session.timestamp * 1000).toISOString(),
    status: session.status,
    errors: session.errors,
    did: typeof session.did === 'number' || typeof session.did === 'string' ? `${session.did}` : undefined,
    duration: session.duration,
    attrs: {
      release: session.release,
      environment: session.environment,
      ip_address: session.ipAddress,
      user_agent: session.userAgent,
    },
  });
}


//# sourceMappingURL=session.js.map


/***/ }),

/***/ 62758:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ro": function() { return /* binding */ addExtensionMethods; },
  "lb": function() { return /* binding */ startIdleTransaction; }
});

// UNUSED EXPORTS: _addTracingExtensions

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js
var hub = __webpack_require__(95659);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/node.js + 1 modules
var node = __webpack_require__(92448);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(9732);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(63233);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/errors.js



/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
  (0,instrument/* addInstrumentationHandler */.o)('error', errorCallback);
  (0,instrument/* addInstrumentationHandler */.o)('unhandledrejection', errorCallback);
}

/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
  const activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    const status = 'internal_error';
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] Transaction: ${status} -> Global error occured`);
    activeTransaction.setStatus(status);
  }
}


//# sourceMappingURL=errors.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(16458);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/transaction.js
var esm_transaction = __webpack_require__(33391);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/hubextensions.js
/* module decorator */ module = __webpack_require__.hmd(module);







/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
  const scope = this.getScope();
  if (scope) {
    const span = scope.getSpan();
    if (span) {
      return {
        'sentry-trace': span.toTraceparent(),
      };
    }
  }
  return {};
}

/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */
function sample(
  transaction,
  options,
  samplingContext,
) {
  // nothing to do if tracing is not enabled
  if (!(0,utils/* hasTracingEnabled */.zu)(options)) {
    transaction.sampled = false;
    return transaction;
  }

  // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
  if (transaction.sampled !== undefined) {
    transaction.setMetadata({
      sampleRate: Number(transaction.sampled),
    });
    return transaction;
  }

  // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
  // work; prefer the hook if so
  let sampleRate;
  if (typeof options.tracesSampler === 'function') {
    sampleRate = options.tracesSampler(samplingContext);
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  } else if (samplingContext.parentSampled !== undefined) {
    sampleRate = samplingContext.parentSampled;
  } else {
    sampleRate = options.tracesSampleRate;
    transaction.setMetadata({
      sampleRate: Number(sampleRate),
    });
  }

  // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
  // only valid values are booleans or numbers between 0 and 1.)
  if (!isValidSampleRate(sampleRate)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.warn */.kg.warn('[Tracing] Discarding transaction because of invalid sample rate.');
    transaction.sampled = false;
    return transaction;
  }

  // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
  if (!sampleRate) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because ${
          typeof options.tracesSampler === 'function'
            ? 'tracesSampler returned 0 or false'
            : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'
        }`,
      );
    transaction.sampled = false;
    return transaction;
  }

  // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
  // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
  transaction.sampled = Math.random() < (sampleRate );

  // if we're not going to keep it, we're done
  if (!transaction.sampled) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.log */.kg.log(
        `[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = ${Number(
          sampleRate,
        )})`,
      );
    return transaction;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger/* logger.log */.kg.log(`[Tracing] starting ${transaction.op} transaction - ${transaction.name}`);
  return transaction;
}

/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
  // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((0,is/* isNaN */.i2)(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(
        `[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got ${JSON.stringify(
          rate,
        )} of type ${JSON.stringify(typeof rate)}.`,
      );
    return false;
  }

  // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
  if (rate < 0 || rate > 1) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.warn */.kg.warn(`[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got ${rate}.`);
    return false;
  }
  return true;
}

/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(

  transactionContext,
  customSamplingContext,
) {
  const client = this.getClient();
  const options = (client && client.getOptions()) || {};

  const configInstrumenter = options.instrumenter || 'sentry';
  const transactionInstrumenter = transactionContext.instrumenter || 'sentry';

  if (configInstrumenter !== transactionInstrumenter) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      logger/* logger.error */.kg.error(
        `A transaction was started with instrumenter=\`${transactionInstrumenter}\`, but the SDK is configured with the \`${configInstrumenter}\` instrumenter.
The transaction will not be sampled. Please use the ${configInstrumenter} instrumentation to start transactions.`,
      );

    transactionContext.sampled = false;
  }

  let transaction = new esm_transaction/* Transaction */.Y(transactionContext, this);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  return transaction;
}

/**
 * Create new idle transaction.
 */
function startIdleTransaction(
  hub,
  transactionContext,
  idleTimeout,
  finalTimeout,
  onScope,
  customSamplingContext,
  heartbeatInterval,
) {
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {};

  let transaction = new idletransaction/* IdleTransaction */.io(transactionContext, hub, idleTimeout, finalTimeout, heartbeatInterval, onScope);
  transaction = sample(transaction, options, {
    parentSampled: transactionContext.parentSampled,
    transactionContext,
    ...customSamplingContext,
  });
  if (transaction.sampled) {
    transaction.initSpanRecorder(options._experiments && (options._experiments.maxSpans ));
  }
  return transaction;
}

/**
 * @private
 */
function _addTracingExtensions() {
  const carrier = (0,hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }
  carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
  if (!carrier.__SENTRY__.extensions.startTransaction) {
    carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
  }
  if (!carrier.__SENTRY__.extensions.traceHeaders) {
    carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
  }
}

/**
 * @private
 */
function _autoloadDatabaseIntegrations() {
  const carrier = (0,hub/* getMainCarrier */.cu)();
  if (!carrier.__SENTRY__) {
    return;
  }

  const packageToIntegrationMapping = {
    mongodb() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo')

;
      return new integration.Mongo();
    },
    mongoose() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mongo')

;
      return new integration.Mongo({ mongoose: true });
    },
    mysql() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/mysql')

;
      return new integration.Mysql();
    },
    pg() {
      const integration = (0,node/* dynamicRequire */.l$)(module, './integrations/node/postgres')

;
      return new integration.Postgres();
    },
  };

  const mappedPackages = Object.keys(packageToIntegrationMapping)
    .filter(moduleName => !!(0,node/* loadModule */.$y)(moduleName))
    .map(pkg => {
      try {
        return packageToIntegrationMapping[pkg]();
      } catch (e) {
        return undefined;
      }
    })
    .filter(p => p) ;

  if (mappedPackages.length > 0) {
    carrier.__SENTRY__.integrations = [...(carrier.__SENTRY__.integrations || []), ...mappedPackages];
  }
}

/**
 * This patches the global object and injects the Tracing extensions methods
 */
function addExtensionMethods() {
  _addTracingExtensions();

  // Detect and automatically load specified integrations.
  if ((0,node/* isNodeEnv */.KV)()) {
    _autoloadDatabaseIntegrations();
  }

  // If an error happens globally, we should make sure transaction status is set to error.
  registerErrorInstrumentation();
}


//# sourceMappingURL=hubextensions.js.map


/***/ }),

/***/ 16458:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "hd": function() { return /* binding */ DEFAULT_HEARTBEAT_INTERVAL; },
/* harmony export */   "io": function() { return /* binding */ IdleTransaction; },
/* harmony export */   "mg": function() { return /* binding */ DEFAULT_FINAL_TIMEOUT; },
/* harmony export */   "nT": function() { return /* binding */ DEFAULT_IDLE_TIMEOUT; }
/* harmony export */ });
/* unused harmony export IdleTransactionSpanRecorder */
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12343);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55334);
/* harmony import */ var _transaction_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(33391);




const DEFAULT_IDLE_TIMEOUT = 1000;
const DEFAULT_FINAL_TIMEOUT = 30000;
const DEFAULT_HEARTBEAT_INTERVAL = 5000;

/**
 * @inheritDoc
 */
class IdleTransactionSpanRecorder extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB {
   constructor(
      _pushActivity,
      _popActivity,
     transactionSpanId,
    maxlen,
  ) {
    super(maxlen);this._pushActivity = _pushActivity;this._popActivity = _popActivity;this.transactionSpanId = transactionSpanId;;
  }

  /**
   * @inheritDoc
   */
   add(span) {
    // We should make sure we do not push and pop activities for
    // the transaction that this span recorder belongs to.
    if (span.spanId !== this.transactionSpanId) {
      // We patch span.finish() to pop an activity after setting an endTimestamp.
      span.finish = (endTimestamp) => {
        span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
        this._popActivity(span.spanId);
      };

      // We should only push new activities if the span does not have an end timestamp.
      if (span.endTimestamp === undefined) {
        this._pushActivity(span.spanId);
      }
    }

    super.add(span);
  }
}

/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
class IdleTransaction extends _transaction_js__WEBPACK_IMPORTED_MODULE_2__/* .Transaction */ .Y {
  // Activities store a list of active spans
   __init() {this.activities = {};}

  // Track state of activities in previous heartbeat

  // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
   __init2() {this._heartbeatCounter = 0;}

  // We should not use heartbeat if we finished a transaction
   __init3() {this._finished = false;}

    __init4() {this._beforeFinishCallbacks = [];}

  /**
   * Timer that tracks Transaction idleTimeout
   */

   constructor(
    transactionContext,
      _idleHub,
    /**
     * The time to wait in ms until the idle transaction will be finished. This timer is started each time
     * there are no active spans on this transaction.
     */
      _idleTimeout = DEFAULT_IDLE_TIMEOUT,
    /**
     * The final value in ms that a transaction cannot exceed
     */
      _finalTimeout = DEFAULT_FINAL_TIMEOUT,
      _heartbeatInterval = DEFAULT_HEARTBEAT_INTERVAL,
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
      _onScope = false,
  ) {
    super(transactionContext, _idleHub);this._idleHub = _idleHub;this._idleTimeout = _idleTimeout;this._finalTimeout = _finalTimeout;this._heartbeatInterval = _heartbeatInterval;this._onScope = _onScope;IdleTransaction.prototype.__init.call(this);IdleTransaction.prototype.__init2.call(this);IdleTransaction.prototype.__init3.call(this);IdleTransaction.prototype.__init4.call(this);;

    if (_onScope) {
      // There should only be one active transaction on the scope
      clearActiveTransaction(_idleHub);

      // We set the transaction here on the scope so error events pick up the trace
      // context and attach it to the error.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`Setting idle transaction on scope. Span ID: ${this.spanId}`);
      _idleHub.configureScope(scope => scope.setSpan(this));
    }

    this._startIdleTimeout();
    setTimeout(() => {
      if (!this._finished) {
        this.setStatus('deadline_exceeded');
        this.finish();
      }
    }, this._finalTimeout);
  }

  /** {@inheritDoc} */
   finish(endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)()) {
    this._finished = true;
    this.activities = {};

    if (this.spanRecorder) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);

      for (const callback of this._beforeFinishCallbacks) {
        callback(this, endTimestamp);
      }

      this.spanRecorder.spans = this.spanRecorder.spans.filter((span) => {
        // If we are dealing with the transaction itself, we just return it
        if (span.spanId === this.spanId) {
          return true;
        }

        // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
        if (!span.endTimestamp) {
          span.endTimestamp = endTimestamp;
          span.setStatus('cancelled');
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
        }

        const keepSpan = span.startTimestamp < endTimestamp;
        if (!keepSpan) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
            _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(
              '[Tracing] discarding Span since it happened after Transaction was finished',
              JSON.stringify(span, undefined, 2),
            );
        }
        return keepSpan;
      });

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] flushing IdleTransaction');
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] No active IdleTransaction');
    }

    // if `this._onScope` is `true`, the transaction put itself on the scope when it started
    if (this._onScope) {
      clearActiveTransaction(this._idleHub);
    }

    return super.finish(endTimestamp);
  }

  /**
   * Register a callback function that gets excecuted before the transaction finishes.
   * Useful for cleanup or if you want to add any additional spans based on current context.
   *
   * This is exposed because users have no other way of running something before an idle transaction
   * finishes.
   */
   registerBeforeFinishCallback(callback) {
    this._beforeFinishCallbacks.push(callback);
  }

  /**
   * @inheritDoc
   */
   initSpanRecorder(maxlen) {
    if (!this.spanRecorder) {
      const pushActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._pushActivity(id);
      };
      const popActivity = (id) => {
        if (this._finished) {
          return;
        }
        this._popActivity(id);
      };

      this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);

      // Start heartbeat so that transactions do not run forever.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('Starting heartbeat');
      this._pingHeartbeat();
    }
    this.spanRecorder.add(this);
  }

  /**
   * Cancels the existing idletimeout, if there is one
   */
   _cancelIdleTimeout() {
    if (this._idleTimeoutID) {
      clearTimeout(this._idleTimeoutID);
      this._idleTimeoutID = undefined;
    }
  }

  /**
   * Creates an idletimeout
   */
   _startIdleTimeout(endTimestamp) {
    this._cancelIdleTimeout();
    this._idleTimeoutID = setTimeout(() => {
      if (!this._finished && Object.keys(this.activities).length === 0) {
        this.finish(endTimestamp);
      }
    }, this._idleTimeout);
  }

  /**
   * Start tracking a specific activity.
   * @param spanId The span id that represents the activity
   */
   _pushActivity(spanId) {
    this._cancelIdleTimeout();
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] pushActivity: ${spanId}`);
    this.activities[spanId] = true;
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
  }

  /**
   * Remove an activity from usage
   * @param spanId The span id that represents the activity
   */
   _popActivity(spanId) {
    if (this.activities[spanId]) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] popActivity ${spanId}`);
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this.activities[spanId];
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] new activities count', Object.keys(this.activities).length);
    }

    if (Object.keys(this.activities).length === 0) {
      // We need to add the timeout here to have the real endtimestamp of the transaction
      // Remember timestampWithMs is in seconds, timeout is in ms
      const endTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)() + this._idleTimeout / 1000;
      this._startIdleTimeout(endTimestamp);
    }
  }

  /**
   * Checks when entries of this.activities are not changing for 3 beats.
   * If this occurs we finish the transaction.
   */
   _beat() {
    // We should not be running heartbeat if the idle transaction is finished.
    if (this._finished) {
      return;
    }

    const heartbeatString = Object.keys(this.activities).join('');

    if (heartbeatString === this._prevHeartbeatString) {
      this._heartbeatCounter++;
    } else {
      this._heartbeatCounter = 1;
    }

    this._prevHeartbeatString = heartbeatString;

    if (this._heartbeatCounter >= 3) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] Transaction finished because of no change for 3 heart beats');
      this.setStatus('deadline_exceeded');
      this.finish();
    } else {
      this._pingHeartbeat();
    }
  }

  /**
   * Pings the heartbeat
   */
   _pingHeartbeat() {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`pinging Heartbeat -> current counter: ${this._heartbeatCounter}`);
    setTimeout(() => {
      this._beat();
    }, this._heartbeatInterval);
  }
}

/**
 * Reset transaction on scope to `undefined`
 */
function clearActiveTransaction(hub) {
  const scope = hub.getScope();
  if (scope) {
    const transaction = scope.getTransaction();
    if (transaction) {
      scope.setSpan(undefined);
    }
  }
}


//# sourceMappingURL=idletransaction.js.map


/***/ }),

/***/ 55334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Dr": function() { return /* binding */ Span; },
/* harmony export */   "gB": function() { return /* binding */ SpanRecorder; }
/* harmony export */ });
/* unused harmony export spanStatusfromHttpCode */
/* harmony import */ var _sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(45375);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62844);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20535);



/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
class SpanRecorder {
   __init() {this.spans = [];}

   constructor(maxlen = 1000) {;SpanRecorder.prototype.__init.call(this);
    this._maxlen = maxlen;
  }

  /**
   * This is just so that we don't run out of memory while recording a lot
   * of spans. At some point we just stop and flush out the start of the
   * trace tree (i.e.the first n spans with the smallest
   * start_timestamp).
   */
   add(span) {
    if (this.spans.length > this._maxlen) {
      span.spanRecorder = undefined;
    } else {
      this.spans.push(span);
    }
  }
}

/**
 * Span contains all data about a span
 */
class Span  {
  /**
   * @inheritDoc
   */
   __init2() {this.traceId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)();}

  /**
   * @inheritDoc
   */
   __init3() {this.spanId = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_0__/* .uuid4 */ .DM)().substring(16);}

  /**
   * @inheritDoc
   */

  /**
   * Internal keeper of the status
   */

  /**
   * @inheritDoc
   */

  /**
   * Timestamp in seconds when the span was created.
   */
   __init4() {this.startTimestamp = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();}

  /**
   * Timestamp in seconds when the span ended.
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   __init5() {this.tags = {};}

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
   __init6() {this.data = {};}

  /**
   * List of spans that were finalized
   */

  /**
   * @inheritDoc
   */

  /**
   * The instrumenter that created this span.
   */
   __init7() {this.instrumenter = 'sentry';}

  /**
   * You should never call the constructor manually, always use `Sentry.startTransaction()`
   * or call `startChild()` on an existing span.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(spanContext) {;Span.prototype.__init2.call(this);Span.prototype.__init3.call(this);Span.prototype.__init4.call(this);Span.prototype.__init5.call(this);Span.prototype.__init6.call(this);Span.prototype.__init7.call(this);
    if (!spanContext) {
      return this;
    }
    if (spanContext.traceId) {
      this.traceId = spanContext.traceId;
    }
    if (spanContext.spanId) {
      this.spanId = spanContext.spanId;
    }
    if (spanContext.parentSpanId) {
      this.parentSpanId = spanContext.parentSpanId;
    }
    // We want to include booleans as well here
    if ('sampled' in spanContext) {
      this.sampled = spanContext.sampled;
    }
    if (spanContext.op) {
      this.op = spanContext.op;
    }
    if (spanContext.description) {
      this.description = spanContext.description;
    }
    if (spanContext.data) {
      this.data = spanContext.data;
    }
    if (spanContext.tags) {
      this.tags = spanContext.tags;
    }
    if (spanContext.status) {
      this.status = spanContext.status;
    }
    if (spanContext.startTimestamp) {
      this.startTimestamp = spanContext.startTimestamp;
    }
    if (spanContext.endTimestamp) {
      this.endTimestamp = spanContext.endTimestamp;
    }
    if (spanContext.instrumenter) {
      this.instrumenter = spanContext.instrumenter;
    }
  }

  /**
   * @inheritDoc
   */
   startChild(
    spanContext,
  ) {
    const childSpan = new Span({
      ...spanContext,
      parentSpanId: this.spanId,
      sampled: this.sampled,
      traceId: this.traceId,
    });

    childSpan.spanRecorder = this.spanRecorder;
    if (childSpan.spanRecorder) {
      childSpan.spanRecorder.add(childSpan);
    }

    childSpan.transaction = this.transaction;

    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && childSpan.transaction) {
      const opStr = (spanContext && spanContext.op) || '< unknown op >';
      const nameStr = childSpan.transaction.name || '< unknown name >';
      const idStr = childSpan.transaction.spanId;

      const logMessage = `[Tracing] Starting '${opStr}' span on transaction '${nameStr}' (${idStr}).`;
      childSpan.transaction.metadata.spanMetadata[childSpan.spanId] = { logMessage };
      _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log(logMessage);
    }

    return childSpan;
  }

  /**
   * @inheritDoc
   */
   setTag(key, value) {
    this.tags = { ...this.tags, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   setData(key, value) {
    this.data = { ...this.data, [key]: value };
    return this;
  }

  /**
   * @inheritDoc
   */
   setStatus(value) {
    this.status = value;
    return this;
  }

  /**
   * @inheritDoc
   */
   setHttpStatus(httpStatus) {
    this.setTag('http.status_code', String(httpStatus));
    const spanStatus = spanStatusfromHttpCode(httpStatus);
    if (spanStatus !== 'unknown_error') {
      this.setStatus(spanStatus);
    }
    return this;
  }

  /**
   * @inheritDoc
   */
   isSuccess() {
    return this.status === 'ok';
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    if (
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      // Don't call this for transactions
      this.transaction &&
      this.transaction.spanId !== this.spanId
    ) {
      const { logMessage } = this.transaction.metadata.spanMetadata[this.spanId];
      if (logMessage) {
        _sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .logger.log */ .kg.log((logMessage ).replace('Starting', 'Finishing'));
      }
    }

    this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .timestampWithMs */ ._I)();
  }

  /**
   * @inheritDoc
   */
   toTraceparent() {
    let sampledString = '';
    if (this.sampled !== undefined) {
      sampledString = this.sampled ? '-1' : '-0';
    }
    return `${this.traceId}-${this.spanId}${sampledString}`;
  }

  /**
   * @inheritDoc
   */
   toContext() {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: this.data,
      description: this.description,
      endTimestamp: this.endTimestamp,
      op: this.op,
      parentSpanId: this.parentSpanId,
      sampled: this.sampled,
      spanId: this.spanId,
      startTimestamp: this.startTimestamp,
      status: this.status,
      tags: this.tags,
      traceId: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(spanContext) {
    this.data = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.data, () => ( {}));
    this.description = spanContext.description;
    this.endTimestamp = spanContext.endTimestamp;
    this.op = spanContext.op;
    this.parentSpanId = spanContext.parentSpanId;
    this.sampled = spanContext.sampled;
    this.spanId = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.spanId, () => ( this.spanId));
    this.startTimestamp = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.startTimestamp, () => ( this.startTimestamp));
    this.status = spanContext.status;
    this.tags = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.tags, () => ( {}));
    this.traceId = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_4__/* ._nullishCoalesce */ .h)(spanContext.traceId, () => ( this.traceId));

    return this;
  }

  /**
   * @inheritDoc
   */
   getTraceContext()

 {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      trace_id: this.traceId,
    });
  }

  /**
   * @inheritDoc
   */
   toJSON()

 {
    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .dropUndefinedKeys */ .Jr)({
      data: Object.keys(this.data).length > 0 ? this.data : undefined,
      description: this.description,
      op: this.op,
      parent_span_id: this.parentSpanId,
      span_id: this.spanId,
      start_timestamp: this.startTimestamp,
      status: this.status,
      tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
      timestamp: this.endTimestamp,
      trace_id: this.traceId,
    });
  }
}

/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
  if (httpStatus < 400 && httpStatus >= 100) {
    return 'ok';
  }

  if (httpStatus >= 400 && httpStatus < 500) {
    switch (httpStatus) {
      case 401:
        return 'unauthenticated';
      case 403:
        return 'permission_denied';
      case 404:
        return 'not_found';
      case 409:
        return 'already_exists';
      case 413:
        return 'failed_precondition';
      case 429:
        return 'resource_exhausted';
      default:
        return 'invalid_argument';
    }
  }

  if (httpStatus >= 500 && httpStatus < 600) {
    switch (httpStatus) {
      case 501:
        return 'unimplemented';
      case 503:
        return 'unavailable';
      case 504:
        return 'deadline_exceeded';
      default:
        return 'internal_error';
    }
  }

  return 'unknown_error';
}


//# sourceMappingURL=span.js.map


/***/ }),

/***/ 33391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Y": function() { return /* binding */ Transaction; }
/* harmony export */ });
/* harmony import */ var _sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45375);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95659);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(21170);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12343);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(20535);
/* harmony import */ var _span_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(55334);





/** JSDoc */
class Transaction extends _span_js__WEBPACK_IMPORTED_MODULE_0__/* .Span */ .Dr  {

  /**
   * The reference to the current hub.
   */

   __init() {this._measurements = {};}

   __init2() {this._contexts = {};}

   __init3() {this._frozenDynamicSamplingContext = undefined;}

  /**
   * This constructor should never be called manually. Those instrumenting tracing should use
   * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
   * @internal
   * @hideconstructor
   * @hidden
   */
   constructor(transactionContext, hub) {
    super(transactionContext);Transaction.prototype.__init.call(this);Transaction.prototype.__init2.call(this);Transaction.prototype.__init3.call(this);;

    this._hub = hub || (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();

    this._name = transactionContext.name || '';

    this.metadata = {
      source: 'custom',
      ...transactionContext.metadata,
      spanMetadata: {},
      changes: [],
      propagations: 0,
    };

    this._trimEnd = transactionContext.trimEnd;

    // this is because transactions are also spans, and spans have a transaction pointer
    this.transaction = this;

    // If Dynamic Sampling Context is provided during the creation of the transaction, we freeze it as it usually means
    // there is incoming Dynamic Sampling Context. (Either through an incoming request, a baggage meta-tag, or other means)
    const incomingDynamicSamplingContext = this.metadata.dynamicSamplingContext;
    if (incomingDynamicSamplingContext) {
      // We shallow copy this in case anything writes to the original reference of the passed in `dynamicSamplingContext`
      this._frozenDynamicSamplingContext = { ...incomingDynamicSamplingContext };
    }
  }

  /** Getter for `name` property */
   get name() {
    return this._name;
  }

  /** Setter for `name` property, which also sets `source` as custom */
   set name(newName) {
    this.setName(newName);
  }

  /**
   * JSDoc
   */
   setName(name, source = 'custom') {
    // `source` could change without the name changing if we discover that an unparameterized route is actually
    // parameterized by virtue of having no parameters in its path
    if (name !== this.name || source !== this.metadata.source) {
      this.metadata.changes.push({
        // log previous source
        source: this.metadata.source,
        timestamp: (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_2__/* .timestampInSeconds */ .ph)(),
        propagations: this.metadata.propagations,
      });
    }

    this._name = name;
    this.metadata.source = source;
  }

  /**
   * Attaches SpanRecorder to the span itself
   * @param maxlen maximum number of spans that can be recorded
   */
   initSpanRecorder(maxlen = 1000) {
    if (!this.spanRecorder) {
      this.spanRecorder = new _span_js__WEBPACK_IMPORTED_MODULE_0__/* .SpanRecorder */ .gB(maxlen);
    }
    this.spanRecorder.add(this);
  }

  /**
   * @inheritDoc
   */
   setContext(key, context) {
    if (context === null) {
      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete this._contexts[key];
    } else {
      this._contexts[key] = context;
    }
  }

  /**
   * @inheritDoc
   */
   setMeasurement(name, value, unit = '') {
    this._measurements[name] = { value, unit };
  }

  /**
   * @inheritDoc
   */
   setMetadata(newMetadata) {
    this.metadata = { ...this.metadata, ...newMetadata };
  }

  /**
   * @inheritDoc
   */
   finish(endTimestamp) {
    // This transaction is already finished, so we should not flush it again.
    if (this.endTimestamp !== undefined) {
      return undefined;
    }

    if (!this.name) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.warn */ .kg.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
      this.name = '<unlabeled transaction>';
    }

    // just sets the end timestamp
    super.finish(endTimestamp);

    if (this.sampled !== true) {
      // At this point if `sampled !== true` we want to discard the transaction.
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');

      const client = this._hub.getClient();
      if (client) {
        client.recordDroppedEvent('sample_rate', 'transaction');
      }

      return undefined;
    }

    const finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(s => s !== this && s.endTimestamp) : [];

    if (this._trimEnd && finishedSpans.length > 0) {
      this.endTimestamp = finishedSpans.reduce((prev, current) => {
        if (prev.endTimestamp && current.endTimestamp) {
          return prev.endTimestamp > current.endTimestamp ? prev : current;
        }
        return prev;
      }).endTimestamp;
    }

    const metadata = this.metadata;

    const transaction = {
      contexts: {
        ...this._contexts,
        // We don't want to override trace context
        trace: this.getTraceContext(),
      },
      spans: finishedSpans,
      start_timestamp: this.startTimestamp,
      tags: this.tags,
      timestamp: this.endTimestamp,
      transaction: this.name,
      type: 'transaction',
      sdkProcessingMetadata: {
        ...metadata,
        dynamicSamplingContext: this.getDynamicSamplingContext(),
      },
      ...(metadata.source && {
        transaction_info: {
          source: metadata.source,
          changes: metadata.changes,
          propagations: metadata.propagations,
        },
      }),
    };

    const hasMeasurements = Object.keys(this._measurements).length > 0;

    if (hasMeasurements) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(
          '[Measurements] Adding measurements to transaction',
          JSON.stringify(this._measurements, undefined, 2),
        );
      transaction.measurements = this._measurements;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _sentry_utils__WEBPACK_IMPORTED_MODULE_3__/* .logger.log */ .kg.log(`[Tracing] Finishing ${this.op} transaction: ${this.name}.`);

    return this._hub.captureEvent(transaction);
  }

  /**
   * @inheritDoc
   */
   toContext() {
    const spanContext = super.toContext();

    return (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .dropUndefinedKeys */ .Jr)({
      ...spanContext,
      name: this.name,
      trimEnd: this._trimEnd,
    });
  }

  /**
   * @inheritDoc
   */
   updateWithContext(transactionContext) {
    super.updateWithContext(transactionContext);

    this.name = (0,_sentry_utils_esm_buildPolyfills__WEBPACK_IMPORTED_MODULE_5__/* ._nullishCoalesce */ .h)(transactionContext.name, () => ( ''));

    this._trimEnd = transactionContext.trimEnd;

    return this;
  }

  /**
   * @inheritdoc
   *
   * @experimental
   */
   getDynamicSamplingContext() {
    if (this._frozenDynamicSamplingContext) {
      return this._frozenDynamicSamplingContext;
    }

    const hub = this._hub || (0,_sentry_core__WEBPACK_IMPORTED_MODULE_1__/* .getCurrentHub */ .Gd)();
    const client = hub && hub.getClient();

    if (!client) return {};

    const { environment, release } = client.getOptions() || {};
    const { publicKey: public_key } = client.getDsn() || {};

    const maybeSampleRate = this.metadata.sampleRate;
    const sample_rate = maybeSampleRate !== undefined ? maybeSampleRate.toString() : undefined;

    const scope = hub.getScope();
    const { segment: user_segment } = (scope && scope.getUser()) || {};

    const source = this.metadata.source;

    // We don't want to have a transaction name in the DSC if the source is "url" because URLs might contain PII
    const transaction = source && source !== 'url' ? this.name : undefined;

    const dsc = (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_4__/* .dropUndefinedKeys */ .Jr)({
      environment,
      release,
      transaction,
      user_segment,
      public_key,
      trace_id: this.traceId,
      sample_rate,
    });

    // Uncomment if we want to make DSC immutable
    // this._frozenDynamicSamplingContext = dsc;

    return dsc;
  }
}


//# sourceMappingURL=transaction.js.map


/***/ }),

/***/ 63233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XL": function() { return /* binding */ msToSec; },
/* harmony export */   "x1": function() { return /* binding */ getActiveTransaction; },
/* harmony export */   "zu": function() { return /* binding */ hasTracingEnabled; }
/* harmony export */ });
/* unused harmony export secToMs */
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(95659);



/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(
  maybeOptions,
) {
  const client = (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)().getClient();
  const options = maybeOptions || (client && client.getOptions());
  return !!options && ('tracesSampleRate' in options || 'tracesSampler' in options);
}

/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
  const hub = maybeHub || (0,_sentry_core__WEBPACK_IMPORTED_MODULE_0__/* .getCurrentHub */ .Gd)();
  const scope = hub.getScope();
  return scope && (scope.getTransaction() );
}

/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
  return time / 1000;
}

/**
 * Converts from seconds to milliseconds
 * @param time time in seconds
 */
function secToMs(time) {
  return time * 1000;
}


//# sourceMappingURL=utils.js.map


/***/ }),

/***/ 58464:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rt": function() { return /* binding */ htmlTreeAsString; },
/* harmony export */   "l4": function() { return /* binding */ getLocationHref; },
/* harmony export */   "qT": function() { return /* binding */ getDomElement; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67597);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

const DEFAULT_MAX_STRING_LENGTH = 80;

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(
  elem,
  options = {},
) {

  // try/catch both:
  // - accessing event.target (see getsentry/raven-js#838, #768)
  // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
  // - can throw an exception in some circumstances.
  try {
    let currentElem = elem ;
    const MAX_TRAVERSE_HEIGHT = 5;
    const out = [];
    let height = 0;
    let len = 0;
    const separator = ' > ';
    const sepLength = separator.length;
    let nextStr;
    const keyAttrs = Array.isArray(options) ? options : options.keyAttrs;
    const maxStringLength = (!Array.isArray(options) && options.maxStringLength) || DEFAULT_MAX_STRING_LENGTH;

    while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
      nextStr = _htmlElementAsString(currentElem, keyAttrs);
      // bail out if
      // - nextStr is the 'html' element
      // - the length of the string that would be created exceeds maxStringLength
      //   (ignore this limit if we are on the first iteration)
      if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= maxStringLength)) {
        break;
      }

      out.push(nextStr);

      len += nextStr.length;
      currentElem = currentElem.parentNode;
    }

    return out.reverse().join(separator);
  } catch (_oO) {
    return '<unknown>';
  }
}

/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
  const elem = el

;

  const out = [];
  let className;
  let classes;
  let key;
  let attr;
  let i;

  if (!elem || !elem.tagName) {
    return '';
  }

  out.push(elem.tagName.toLowerCase());

  // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
  const keyAttrPairs =
    keyAttrs && keyAttrs.length
      ? keyAttrs.filter(keyAttr => elem.getAttribute(keyAttr)).map(keyAttr => [keyAttr, elem.getAttribute(keyAttr)])
      : null;

  if (keyAttrPairs && keyAttrPairs.length) {
    keyAttrPairs.forEach(keyAttrPair => {
      out.push(`[${keyAttrPair[0]}="${keyAttrPair[1]}"]`);
    });
  } else {
    if (elem.id) {
      out.push(`#${elem.id}`);
    }

    // eslint-disable-next-line prefer-const
    className = elem.className;
    if (className && (0,_is_js__WEBPACK_IMPORTED_MODULE_1__/* .isString */ .HD)(className)) {
      classes = className.split(/\s+/);
      for (i = 0; i < classes.length; i++) {
        out.push(`.${classes[i]}`);
      }
    }
  }
  const allowedAttrs = ['type', 'name', 'title', 'alt'];
  for (i = 0; i < allowedAttrs.length; i++) {
    key = allowedAttrs[i];
    attr = elem.getAttribute(key);
    if (attr) {
      out.push(`[${key}="${attr}"]`);
    }
  }
  return out.join('');
}

/**
 * A safe form of location.href
 */
function getLocationHref() {
  try {
    return WINDOW.document.location.href;
  } catch (oO) {
    return '';
  }
}

/**
 * Gets a DOM element by using document.querySelector.
 *
 * This wrapper will first check for the existance of the function before
 * actually calling it so that we don't have to take care of this check,
 * every time we want to access the DOM.
 *
 * Reason: DOM/querySelector is not available in all environments.
 *
 * We have to cast to any because utils can be consumed by a variety of environments,
 * and we don't want to break TS users. If you know what element will be selected by
 * `document.querySelector`, specify it as part of the generic call. For example,
 * `const element = getDomElement<Element>('selector');`
 *
 * @param selector the selector string passed on to document.querySelector
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function getDomElement(selector) {
  if (WINDOW.document && WINDOW.document.querySelector) {
    return WINDOW.document.querySelector(selector) ;
  }
  return null;
}


//# sourceMappingURL=browser.js.map


/***/ }),

/***/ 45375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ _nullishCoalesce; }
/* harmony export */ });
/**
 * Polyfill for the nullish coalescing operator (`??`).
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */
function _nullishCoalesce(lhs, rhsFn) {
  // by checking for loose equality to `null`, we catch both `null` and `undefined`
  return lhs != null ? lhs : rhsFn();
}

// Sucrase version:
// function _nullishCoalesce(lhs, rhsFn) {
//   if (lhs != null) {
//     return lhs;
//   } else {
//     return rhsFn();
//   }
// }


//# sourceMappingURL=_nullishCoalesce.js.map


/***/ }),

/***/ 9732:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ addInstrumentationHandler; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67597);
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12343);
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(20535);
/* harmony import */ var _stacktrace_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30360);
/* harmony import */ var _supports_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(8823);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);







// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */

const handlers = {};
const instrumented = {};

/** Instruments given API */
function instrument(type) {
  if (instrumented[type]) {
    return;
  }

  instrumented[type] = true;

  switch (type) {
    case 'console':
      instrumentConsole();
      break;
    case 'dom':
      instrumentDOM();
      break;
    case 'xhr':
      instrumentXHR();
      break;
    case 'fetch':
      instrumentFetch();
      break;
    case 'history':
      instrumentHistory();
      break;
    case 'error':
      instrumentError();
      break;
    case 'unhandledrejection':
      instrumentUnhandledRejection();
      break;
    default:
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('unknown instrumentation type:', type);
      return;
  }
}

/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
  handlers[type] = handlers[type] || [];
  (handlers[type] ).push(callback);
  instrument(type);
}

/** JSDoc */
function triggerHandlers(type, data) {
  if (!type || !handlers[type]) {
    return;
  }

  for (const handler of handlers[type] || []) {
    try {
      handler(data);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.error */ .kg.error(
          `Error while triggering instrumentation handler.\nType: ${type}\nName: ${(0,_stacktrace_js__WEBPACK_IMPORTED_MODULE_2__/* .getFunctionName */ .$P)(handler)}\nError:`,
          e,
        );
    }
  }
}

/** JSDoc */
function instrumentConsole() {
  if (!('console' in WINDOW)) {
    return;
  }

  _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .CONSOLE_LEVELS.forEach */ .RU.forEach(function (level) {
    if (!(level in WINDOW.console)) {
      return;
    }

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW.console, level, function (originalConsoleMethod) {
      return function (...args) {
        triggerHandlers('console', { args, level });

        // this fails for some browsers. :(
        if (originalConsoleMethod) {
          originalConsoleMethod.apply(WINDOW.console, args);
        }
      };
    });
  });
}

/** JSDoc */
function instrumentFetch() {
  if (!(0,_supports_js__WEBPACK_IMPORTED_MODULE_4__/* .supportsNativeFetch */ .t$)()) {
    return;
  }

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW, 'fetch', function (originalFetch) {
    return function (...args) {
      const handlerData = {
        args,
        fetchData: {
          method: getFetchMethod(args),
          url: getFetchUrl(args),
        },
        startTimestamp: Date.now(),
      };

      triggerHandlers('fetch', {
        ...handlerData,
      });

      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      return originalFetch.apply(WINDOW, args).then(
        (response) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            response,
          });
          return response;
        },
        (error) => {
          triggerHandlers('fetch', {
            ...handlerData,
            endTimestamp: Date.now(),
            error,
          });
          // NOTE: If you are a Sentry user, and you are seeing this stack frame,
          //       it means the sentry.javascript SDK caught an error invoking your application code.
          //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
          throw error;
        },
      );
    };
  });
}

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs = []) {
  if ('Request' in WINDOW && (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isInstanceOf */ .V9)(fetchArgs[0], Request) && fetchArgs[0].method) {
    return String(fetchArgs[0].method).toUpperCase();
  }
  if (fetchArgs[1] && fetchArgs[1].method) {
    return String(fetchArgs[1].method).toUpperCase();
  }
  return 'GET';
}

/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs = []) {
  if (typeof fetchArgs[0] === 'string') {
    return fetchArgs[0];
  }
  if ('Request' in WINDOW && (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isInstanceOf */ .V9)(fetchArgs[0], Request)) {
    return fetchArgs[0].url;
  }
  return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */

/** JSDoc */
function instrumentXHR() {
  if (!('XMLHttpRequest' in WINDOW)) {
    return;
  }

  const xhrproto = XMLHttpRequest.prototype;

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhrproto, 'open', function (originalOpen) {
    return function ( ...args) {
      // eslint-disable-next-line @typescript-eslint/no-this-alias
      const xhr = this;
      const url = args[1];
      const xhrInfo = (xhr.__sentry_xhr__ = {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        method: (0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .HD)(args[0]) ? args[0].toUpperCase() : args[0],
        url: args[1],
      });

      // if Sentry key appears in URL, don't capture it as a request
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      if ((0,_is_js__WEBPACK_IMPORTED_MODULE_5__/* .isString */ .HD)(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
        xhr.__sentry_own_request__ = true;
      }

      const onreadystatechangeHandler = function () {
        if (xhr.readyState === 4) {
          try {
            // touching statusCode in some platforms throws
            // an exception
            xhrInfo.status_code = xhr.status;
          } catch (e) {
            /* do nothing */
          }

          triggerHandlers('xhr', {
            args,
            endTimestamp: Date.now(),
            startTimestamp: Date.now(),
            xhr,
          });
        }
      };

      if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
        (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhr, 'onreadystatechange', function (original) {
          return function (...readyStateArgs) {
            onreadystatechangeHandler();
            return original.apply(xhr, readyStateArgs);
          };
        });
      } else {
        xhr.addEventListener('readystatechange', onreadystatechangeHandler);
      }

      return originalOpen.apply(xhr, args);
    };
  });

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(xhrproto, 'send', function (originalSend) {
    return function ( ...args) {
      if (this.__sentry_xhr__ && args[0] !== undefined) {
        this.__sentry_xhr__.body = args[0];
      }

      triggerHandlers('xhr', {
        args,
        startTimestamp: Date.now(),
        xhr: this,
      });

      return originalSend.apply(this, args);
    };
  });
}

let lastHref;

/** JSDoc */
function instrumentHistory() {
  if (!(0,_supports_js__WEBPACK_IMPORTED_MODULE_4__/* .supportsHistory */ .Bf)()) {
    return;
  }

  const oldOnPopState = WINDOW.onpopstate;
  WINDOW.onpopstate = function ( ...args) {
    const to = WINDOW.location.href;
    // keep track of the current URL state, as we always receive only the updated state
    const from = lastHref;
    lastHref = to;
    triggerHandlers('history', {
      from,
      to,
    });
    if (oldOnPopState) {
      // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
      // https://github.com/getsentry/sentry-javascript/issues/3344
      // https://github.com/bugsnag/bugsnag-js/issues/469
      try {
        return oldOnPopState.apply(this, args);
      } catch (_oO) {
        // no-empty
      }
    }
  };

  /** @hidden */
  function historyReplacementFunction(originalHistoryFunction) {
    return function ( ...args) {
      const url = args.length > 2 ? args[2] : undefined;
      if (url) {
        // coerce to string (this is what pushState does)
        const from = lastHref;
        const to = String(url);
        // keep track of the current URL state, as we always receive only the updated state
        lastHref = to;
        triggerHandlers('history', {
          from,
          to,
        });
      }
      return originalHistoryFunction.apply(this, args);
    };
  }

  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW.history, 'pushState', historyReplacementFunction);
  (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(WINDOW.history, 'replaceState', historyReplacementFunction);
}

const debounceDuration = 1000;
let debounceTimerID;
let lastCapturedEvent;

/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
  // If there was no previous event, it should always be swapped for the new one.
  if (!previous) {
    return true;
  }

  // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
  if (previous.type !== current.type) {
    return true;
  }

  try {
    // If both events have the same type, it's still possible that actions were performed on different targets.
    // e.g. 2 clicks on different buttons.
    if (previous.target !== current.target) {
      return true;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
  // to which an event listener was attached), we treat them as the same action, as we want to capture
  // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
  return false;
}

/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
  // We are only interested in filtering `keypress` events for now.
  if (event.type !== 'keypress') {
    return false;
  }

  try {
    const target = event.target ;

    if (!target || !target.tagName) {
      return true;
    }

    // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
    // e.g.tabbing through elements, hotkeys, etc.
    if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
      return false;
    }
  } catch (e) {
    // just accessing `target` property can throw an exception in some rare circumstances
    // see: https://github.com/getsentry/sentry-javascript/issues/838
  }

  return true;
}

/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener = false) {
  return (event) => {
    // It's possible this handler might trigger multiple times for the same
    // event (e.g. event propagation through node ancestors).
    // Ignore if we've already captured that event.
    if (!event || lastCapturedEvent === event) {
      return;
    }

    // We always want to skip _some_ events.
    if (shouldSkipDOMEvent(event)) {
      return;
    }

    const name = event.type === 'keypress' ? 'input' : event.type;

    // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
    if (debounceTimerID === undefined) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }
    // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
    // If that's the case, emit the previous event and store locally the newly-captured DOM event.
    else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
      handler({
        event: event,
        name,
        global: globalListener,
      });
      lastCapturedEvent = event;
    }

    // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
    clearTimeout(debounceTimerID);
    debounceTimerID = WINDOW.setTimeout(() => {
      debounceTimerID = undefined;
    }, debounceDuration);
  };
}

/** JSDoc */
function instrumentDOM() {
  if (!('document' in WINDOW)) {
    return;
  }

  // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
  // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
  // we instrument `addEventListener` so that we don't end up attaching this handler twice.
  const triggerDOMHandler = triggerHandlers.bind(null, 'dom');
  const globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
  WINDOW.document.addEventListener('click', globalDOMEventHandler, false);
  WINDOW.document.addEventListener('keypress', globalDOMEventHandler, false);

  // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
  // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
  // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
  // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
  // guaranteed to fire at least once.)
  ['EventTarget', 'Node'].forEach((target) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    const proto = (WINDOW )[target] && (WINDOW )[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
      return;
    }

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(proto, 'addEventListener', function (originalAddEventListener) {
      return function (

        type,
        listener,
        options,
      ) {
        if (type === 'click' || type == 'keypress') {
          try {
            const el = this ;
            const handlers = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
            const handlerForType = (handlers[type] = handlers[type] || { refCount: 0 });

            if (!handlerForType.handler) {
              const handler = makeDOMEventHandler(triggerDOMHandler);
              handlerForType.handler = handler;
              originalAddEventListener.call(this, type, handler, options);
            }

            handlerForType.refCount++;
          } catch (e) {
            // Accessing dom properties is always fragile.
            // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
          }
        }

        return originalAddEventListener.call(this, type, listener, options);
      };
    });

    (0,_object_js__WEBPACK_IMPORTED_MODULE_3__/* .fill */ .hl)(
      proto,
      'removeEventListener',
      function (originalRemoveEventListener) {
        return function (

          type,
          listener,
          options,
        ) {
          if (type === 'click' || type == 'keypress') {
            try {
              const el = this ;
              const handlers = el.__sentry_instrumentation_handlers__ || {};
              const handlerForType = handlers[type];

              if (handlerForType) {
                handlerForType.refCount--;
                // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                if (handlerForType.refCount <= 0) {
                  originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                  handlerForType.handler = undefined;
                  delete handlers[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                }

                // If there are no longer any custom handlers of any type on this element, cleanup everything.
                if (Object.keys(handlers).length === 0) {
                  delete el.__sentry_instrumentation_handlers__;
                }
              }
            } catch (e) {
              // Accessing dom properties is always fragile.
              // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
            }
          }

          return originalRemoveEventListener.call(this, type, listener, options);
        };
      },
    );
  });
}

let _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
  _oldOnErrorHandler = WINDOW.onerror;

  WINDOW.onerror = function (msg, url, line, column, error) {
    triggerHandlers('error', {
      column,
      error,
      line,
      msg,
      url,
    });

    if (_oldOnErrorHandler) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnErrorHandler.apply(this, arguments);
    }

    return false;
  };
}

let _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
  _oldOnUnhandledRejectionHandler = WINDOW.onunhandledrejection;

  WINDOW.onunhandledrejection = function (e) {
    triggerHandlers('unhandledrejection', e);

    if (_oldOnUnhandledRejectionHandler) {
      // eslint-disable-next-line prefer-rest-params
      return _oldOnUnhandledRejectionHandler.apply(this, arguments);
    }

    return true;
  };
}


//# sourceMappingURL=instrument.js.map


/***/ }),

/***/ 67597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cy": function() { return /* binding */ isSyntheticEvent; },
/* harmony export */   "HD": function() { return /* binding */ isString; },
/* harmony export */   "J8": function() { return /* binding */ isThenable; },
/* harmony export */   "Kj": function() { return /* binding */ isRegExp; },
/* harmony export */   "PO": function() { return /* binding */ isPlainObject; },
/* harmony export */   "TX": function() { return /* binding */ isDOMError; },
/* harmony export */   "V9": function() { return /* binding */ isInstanceOf; },
/* harmony export */   "VW": function() { return /* binding */ isErrorEvent; },
/* harmony export */   "VZ": function() { return /* binding */ isError; },
/* harmony export */   "cO": function() { return /* binding */ isEvent; },
/* harmony export */   "fm": function() { return /* binding */ isDOMException; },
/* harmony export */   "i2": function() { return /* binding */ isNaN; },
/* harmony export */   "kK": function() { return /* binding */ isElement; },
/* harmony export */   "pt": function() { return /* binding */ isPrimitive; }
/* harmony export */ });
// eslint-disable-next-line @typescript-eslint/unbound-method
const objectToString = Object.prototype.toString;

/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
  switch (objectToString.call(wat)) {
    case '[object Error]':
    case '[object Exception]':
    case '[object DOMException]':
      return true;
    default:
      return isInstanceOf(wat, Error);
  }
}
/**
 * Checks whether given value is an instance of the given built-in class.
 *
 * @param wat The value to be checked
 * @param className
 * @returns A boolean representing the result.
 */
function isBuiltin(wat, className) {
  return objectToString.call(wat) === `[object ${className}]`;
}

/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
  return isBuiltin(wat, 'ErrorEvent');
}

/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
  return isBuiltin(wat, 'DOMError');
}

/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
  return isBuiltin(wat, 'DOMException');
}

/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
  return isBuiltin(wat, 'String');
}

/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
  return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}

/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
  return isBuiltin(wat, 'Object');
}

/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
  return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}

/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement(wat) {
  return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}

/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
  return isBuiltin(wat, 'RegExp');
}

/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return Boolean(wat && wat.then && typeof wat.then === 'function');
}

/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
  return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}

/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN(wat) {
  return typeof wat === 'number' && wat !== wat;
}

/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
  try {
    return wat instanceof base;
  } catch (_e) {
    return false;
  }
}


//# sourceMappingURL=is.js.map


/***/ }),

/***/ 12343:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cf": function() { return /* binding */ consoleSandbox; },
/* harmony export */   "RU": function() { return /* binding */ CONSOLE_LEVELS; },
/* harmony export */   "kg": function() { return /* binding */ logger; }
/* harmony export */ });
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);


/** Prefix for logging strings */
const PREFIX = 'Sentry Logger ';

const CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert', 'trace'] ;

/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
  if (!("console" in _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2)) {
    return callback();
  }

  const originalConsole = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console ;
  const wrappedLevels = {};

  // Restore all wrapped console methods
  CONSOLE_LEVELS.forEach(level => {
    // TODO(v7): Remove this check as it's only needed for Node 6
    const originalWrappedFunc =
      originalConsole[level] && (originalConsole[level] ).__sentry_original__;
    if (level in originalConsole && originalWrappedFunc) {
      wrappedLevels[level] = originalConsole[level] ;
      originalConsole[level] = originalWrappedFunc ;
    }
  });

  try {
    return callback();
  } finally {
    // Revert restoration to wrapped state
    Object.keys(wrappedLevels).forEach(level => {
      originalConsole[level] = wrappedLevels[level ];
    });
  }
}

function makeLogger() {
  let enabled = false;
  const logger = {
    enable: () => {
      enabled = true;
    },
    disable: () => {
      enabled = false;
    },
  };

  if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    CONSOLE_LEVELS.forEach(name => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      logger[name] = (...args) => {
        if (enabled) {
          consoleSandbox(() => {
            _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ.console */ .n2.console[name](`${PREFIX}[${name}]:`, ...args);
          });
        }
      };
    });
  } else {
    CONSOLE_LEVELS.forEach(name => {
      logger[name] = () => undefined;
    });
  }

  return logger ;
}

// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
let logger;
if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
  logger = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalSingleton */ .YO)('logger', makeLogger);
} else {
  logger = makeLogger();
}


//# sourceMappingURL=logger.js.map


/***/ }),

/***/ 62844:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DM": function() { return /* binding */ uuid4; },
/* harmony export */   "Db": function() { return /* binding */ addExceptionTypeValue; },
/* harmony export */   "EG": function() { return /* binding */ addExceptionMechanism; },
/* harmony export */   "YO": function() { return /* binding */ checkOrSetAlreadyCaught; },
/* harmony export */   "jH": function() { return /* binding */ getEventDescription; },
/* harmony export */   "lE": function() { return /* binding */ arrayify; }
/* harmony export */ });
/* unused harmony exports addContextToFrame, parseSemver */
/* harmony import */ var _object_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(20535);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);




/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
  const gbl = _worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .GLOBAL_OBJ */ .n2 ;
  const crypto = gbl.crypto || gbl.msCrypto;

  if (crypto && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, '');
  }

  const getRandomByte =
    crypto && crypto.getRandomValues ? () => crypto.getRandomValues(new Uint8Array(1))[0] : () => Math.random() * 16;

  // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
  // Concatenating the following numbers as strings results in '10000000100040008000100000000000'
  return (([1e7] ) + 1e3 + 4e3 + 8e3 + 1e11).replace(/[018]/g, c =>
    // eslint-disable-next-line no-bitwise
    ((c ) ^ ((getRandomByte() & 15) >> ((c ) / 4))).toString(16),
  );
}

function getFirstException(event) {
  return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}

/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
  const { message, event_id: eventId } = event;
  if (message) {
    return message;
  }

  const firstException = getFirstException(event);
  if (firstException) {
    if (firstException.type && firstException.value) {
      return `${firstException.type}: ${firstException.value}`;
    }
    return firstException.type || firstException.value || eventId || '<unknown>';
  }
  return eventId || '<unknown>';
}

/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
  const exception = (event.exception = event.exception || {});
  const values = (exception.values = exception.values || []);
  const firstException = (values[0] = values[0] || {});
  if (!firstException.value) {
    firstException.value = value || '';
  }
  if (!firstException.type) {
    firstException.type = type || 'Error';
  }
}

/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
  const firstException = getFirstException(event);
  if (!firstException) {
    return;
  }

  const defaultMechanism = { type: 'generic', handled: true };
  const currentMechanism = firstException.mechanism;
  firstException.mechanism = { ...defaultMechanism, ...currentMechanism, ...newMechanism };

  if (newMechanism && 'data' in newMechanism) {
    const mergedData = { ...(currentMechanism && currentMechanism.data), ...newMechanism.data };
    firstException.mechanism.data = mergedData;
  }
}

// https://semver.org/#is-there-a-suggested-regular-expression-regex-to-check-a-semver-string
const SEMVER_REGEXP =
  /^(0|[1-9]\d*)\.(0|[1-9]\d*)\.(0|[1-9]\d*)(?:-((?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*)(?:\.(?:0|[1-9]\d*|\d*[a-zA-Z-][0-9a-zA-Z-]*))*))?(?:\+([0-9a-zA-Z-]+(?:\.[0-9a-zA-Z-]+)*))?$/;

/**
 * Represents Semantic Versioning object
 */

/**
 * Parses input into a SemVer interface
 * @param input string representation of a semver version
 */
function parseSemver(input) {
  const match = input.match(SEMVER_REGEXP) || [];
  const major = parseInt(match[1], 10);
  const minor = parseInt(match[2], 10);
  const patch = parseInt(match[3], 10);
  return {
    buildmetadata: match[5],
    major: isNaN(major) ? undefined : major,
    minor: isNaN(minor) ? undefined : minor,
    patch: isNaN(patch) ? undefined : patch,
    prerelease: match[4],
  };
}

/**
 * This function adds context (pre/post/line) lines to the provided frame
 *
 * @param lines string[] containing all lines
 * @param frame StackFrame that will be mutated
 * @param linesOfContext number of context lines we want to add pre/post
 */
function addContextToFrame(lines, frame, linesOfContext = 5) {
  // When there is no line number in the frame, attaching context is nonsensical and will even break grouping
  if (frame.lineno === undefined) {
    return;
  }

  const maxLines = lines.length;
  const sourceLine = Math.max(Math.min(maxLines, frame.lineno - 1), 0);

  frame.pre_context = lines
    .slice(Math.max(0, sourceLine - linesOfContext), sourceLine)
    .map((line) => snipLine(line, 0));

  frame.context_line = snipLine(lines[Math.min(maxLines - 1, sourceLine)], frame.colno || 0);

  frame.post_context = lines
    .slice(Math.min(sourceLine + 1, maxLines), sourceLine + 1 + linesOfContext)
    .map((line) => snipLine(line, 0));
}

/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  if (exception && (exception ).__sentry_captured__) {
    return true;
  }

  try {
    // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
    // `ExtraErrorData` integration
    (0,_object_js__WEBPACK_IMPORTED_MODULE_1__/* .addNonEnumerableProperty */ .xp)(exception , '__sentry_captured__', true);
  } catch (err) {
    // `exception` is a primitive, so we can't mark it seen
  }

  return false;
}

/**
 * Checks whether the given input is already an array, and if it isn't, wraps it in one.
 *
 * @param maybeArray Input to turn into an array, if necessary
 * @returns The input, if already an array, or an array with the input as the only element, if not
 */
function arrayify(maybeArray) {
  return Array.isArray(maybeArray) ? maybeArray : [maybeArray];
}


//# sourceMappingURL=misc.js.map


/***/ }),

/***/ 92448:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "l$": function() { return /* binding */ dynamicRequire; },
  "KV": function() { return /* binding */ isNodeEnv; },
  "$y": function() { return /* binding */ loadModule; }
});

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/env.js
/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */

/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
  return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}


//# sourceMappingURL=env.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/node.js
/* module decorator */ module = __webpack_require__.hmd(module);
/* provided dependency */ var process = __webpack_require__(83454);


/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */

/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
  // explicitly check for browser bundles as those can be optimized statically
  // by terser/rollup.
  return (
    !isBrowserBundle() &&
    Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]'
  );
}

/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return mod.require(request);
}

/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
  let mod;

  try {
    mod = dynamicRequire(module, moduleName);
  } catch (e) {
    // no-empty
  }

  try {
    const { cwd } = dynamicRequire(module, 'process');
    mod = dynamicRequire(module, `${cwd()}/node_modules/${moduleName}`) ;
  } catch (e) {
    // no-empty
  }

  return mod;
}


//# sourceMappingURL=node.js.map


/***/ }),

/***/ 20535:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$Q": function() { return /* binding */ markFunctionWrapped; },
/* harmony export */   "HK": function() { return /* binding */ getOriginalFunction; },
/* harmony export */   "Jr": function() { return /* binding */ dropUndefinedKeys; },
/* harmony export */   "Sh": function() { return /* binding */ convertToPlainObject; },
/* harmony export */   "_j": function() { return /* binding */ urlEncode; },
/* harmony export */   "hl": function() { return /* binding */ fill; },
/* harmony export */   "xp": function() { return /* binding */ addNonEnumerableProperty; },
/* harmony export */   "zf": function() { return /* binding */ extractExceptionKeysForMessage; }
/* harmony export */ });
/* unused harmony export objectify */
/* harmony import */ var _browser_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(58464);
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);
/* harmony import */ var _string_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57321);




/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
  if (!(name in source)) {
    return;
  }

  const original = source[name] ;
  const wrapped = replacementFactory(original) ;

  // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
  // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
  if (typeof wrapped === 'function') {
    try {
      markFunctionWrapped(wrapped, original);
    } catch (_Oo) {
      // This can throw if multiple fill happens on a global object like XMLHttpRequest
      // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
    }
  }

  source[name] = wrapped;
}

/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
  Object.defineProperty(obj, name, {
    // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
    value: value,
    writable: true,
    configurable: true,
  });
}

/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
  const proto = original.prototype || {};
  wrapped.prototype = original.prototype = proto;
  addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}

/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
  return func.__sentry_original__;
}

/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
  return Object.keys(object)
    .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(object[key])}`)
    .join('&');
}

/**
 * Transforms any `Error` or `Event` into a plain object with all of their enumerable properties, and some of their
 * non-enumerable properties attached.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 * @returns An Event or Error turned into an object - or the value argurment itself, when value is neither an Event nor
 *  an Error.
 */
function convertToPlainObject(
  value,
)

 {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isError */ .VZ)(value)) {
    return {
      message: value.message,
      name: value.name,
      stack: value.stack,
      ...getOwnProperties(value),
    };
  } else if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isEvent */ .cO)(value)) {
    const newObj

 = {
      type: value.type,
      target: serializeEventTarget(value.target),
      currentTarget: serializeEventTarget(value.currentTarget),
      ...getOwnProperties(value),
    };

    if (typeof CustomEvent !== 'undefined' && (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isInstanceOf */ .V9)(value, CustomEvent)) {
      newObj.detail = value.detail;
    }

    return newObj;
  } else {
    return value;
  }
}

/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
  try {
    return (0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isElement */ .kK)(target) ? (0,_browser_js__WEBPACK_IMPORTED_MODULE_1__/* .htmlTreeAsString */ .Rt)(target) : Object.prototype.toString.call(target);
  } catch (_oO) {
    return '<unknown>';
  }
}

/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
  if (typeof obj === 'object' && obj !== null) {
    const extractedProps = {};
    for (const property in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, property)) {
        extractedProps[property] = (obj )[property];
      }
    }
    return extractedProps;
  } else {
    return {};
  }
}

/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
function extractExceptionKeysForMessage(exception, maxLength = 40) {
  const keys = Object.keys(convertToPlainObject(exception));
  keys.sort();

  if (!keys.length) {
    return '[object has no keys]';
  }

  if (keys[0].length >= maxLength) {
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(keys[0], maxLength);
  }

  for (let includedKeys = keys.length; includedKeys > 0; includedKeys--) {
    const serialized = keys.slice(0, includedKeys).join(', ');
    if (serialized.length > maxLength) {
      continue;
    }
    if (includedKeys === keys.length) {
      return serialized;
    }
    return (0,_string_js__WEBPACK_IMPORTED_MODULE_2__/* .truncate */ .$G)(serialized, maxLength);
  }

  return '';
}

/**
 * Given any object, return a new object having removed all fields whose value was `undefined`.
 * Works recursively on objects and arrays.
 *
 * Attention: This function keeps circular references in the returned object.
 */
function dropUndefinedKeys(inputValue) {
  // This map keeps track of what already visited nodes map to.
  // Our Set - based memoBuilder doesn't work here because we want to the output object to have the same circular
  // references as the input object.
  const memoizationMap = new Map();

  // This function just proxies `_dropUndefinedKeys` to keep the `memoBuilder` out of this function's API
  return _dropUndefinedKeys(inputValue, memoizationMap);
}

function _dropUndefinedKeys(inputValue, memoizationMap) {
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isPlainObject */ .PO)(inputValue)) {
    // If this node has already been visited due to a circular reference, return the object it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = {};
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    for (const key of Object.keys(inputValue)) {
      if (typeof inputValue[key] !== 'undefined') {
        returnValue[key] = _dropUndefinedKeys(inputValue[key], memoizationMap);
      }
    }

    return returnValue ;
  }

  if (Array.isArray(inputValue)) {
    // If this node has already been visited due to a circular reference, return the array it was mapped to in the new object
    const memoVal = memoizationMap.get(inputValue);
    if (memoVal !== undefined) {
      return memoVal ;
    }

    const returnValue = [];
    // Store the mapping of this value in case we visit it again, in case of circular data
    memoizationMap.set(inputValue, returnValue);

    inputValue.forEach((item) => {
      returnValue.push(_dropUndefinedKeys(item, memoizationMap));
    });

    return returnValue ;
  }

  return inputValue;
}

/**
 * Ensure that something is an object.
 *
 * Turns `undefined` and `null` into `String`s and all other primitives into instances of their respective wrapper
 * classes (String, Boolean, Number, etc.). Acts as the identity function on non-primitives.
 *
 * @param wat The subject of the objectification
 * @returns A version of `wat` which can safely be used with `Object` class methods
 */
function objectify(wat) {
  let objectified;
  switch (true) {
    case wat === undefined || wat === null:
      objectified = new String(wat);
      break;

    // Though symbols and bigints do have wrapper classes (`Symbol` and `BigInt`, respectively), for whatever reason
    // those classes don't have constructors which can be used with the `new` keyword. We therefore need to cast each as
    // an object in order to wrap it.
    case typeof wat === 'symbol' || typeof wat === 'bigint':
      objectified = Object(wat);
      break;

    // this will catch the remaining primitives: `String`, `Number`, and `Boolean`
    case isPrimitive(wat):
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      objectified = new (wat ).constructor(wat);
      break;

    // by process of elimination, at this point we know that `wat` must already be an object
    default:
      objectified = wat;
      break;
  }
  return objectified;
}


//# sourceMappingURL=object.js.map


/***/ }),

/***/ 30360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$P": function() { return /* binding */ getFunctionName; },
/* harmony export */   "Sq": function() { return /* binding */ stackParserFromStackParserOptions; },
/* harmony export */   "pE": function() { return /* binding */ createStackParser; }
/* harmony export */ });
/* unused harmony exports nodeStackLineParser, stripSentryFramesAndReverse */


const STACKTRACE_LIMIT = 50;

/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser(...parsers) {
  const sortedParsers = parsers.sort((a, b) => a[0] - b[0]).map(p => p[1]);

  return (stack, skipFirst = 0) => {
    const frames = [];

    for (const line of stack.split('\n').slice(skipFirst)) {
      // https://github.com/getsentry/sentry-javascript/issues/5459
      // Remove webpack (error: *) wrappers
      const cleanedLine = line.replace(/\(error: (.*)\)/, '$1');

      for (const parser of sortedParsers) {
        const frame = parser(cleanedLine);

        if (frame) {
          frames.push(frame);
          break;
        }
      }
    }

    return stripSentryFramesAndReverse(frames);
  };
}

/**
 * Gets a stack parser implementation from Options.stackParser
 * @see Options
 *
 * If options contains an array of line parsers, it is converted into a parser
 */
function stackParserFromStackParserOptions(stackParser) {
  if (Array.isArray(stackParser)) {
    return createStackParser(...stackParser);
  }
  return stackParser;
}

/**
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
  if (!stack.length) {
    return [];
  }

  let localStack = stack;

  const firstFrameFunction = localStack[0].function || '';
  const lastFrameFunction = localStack[localStack.length - 1].function || '';

  // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
  if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
    localStack = localStack.slice(1);
  }

  // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
  if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
    localStack = localStack.slice(0, -1);
  }

  // The frame where the crash happened, should be the last entry in the array
  return localStack
    .slice(0, STACKTRACE_LIMIT)
    .map(frame => ({
      ...frame,
      filename: frame.filename || localStack[0].filename,
      function: frame.function || '?',
    }))
    .reverse();
}

const defaultFunctionName = '<anonymous>';

/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
  try {
    if (!fn || typeof fn !== 'function') {
      return defaultFunctionName;
    }
    return fn.name || defaultFunctionName;
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    return defaultFunctionName;
  }
}

// eslint-disable-next-line complexity
function node(getModule) {
  const FILENAME_MATCH = /^\s*[-]{4,}$/;
  const FULL_MATCH = /at (?:async )?(?:(.+?)\s+\()?(?:(.+):(\d+):(\d+)?|([^)]+))\)?/;

  // eslint-disable-next-line complexity
  return (line) => {
    if (line.match(FILENAME_MATCH)) {
      return {
        filename: line,
      };
    }

    const lineMatch = line.match(FULL_MATCH);
    if (!lineMatch) {
      return undefined;
    }

    let object;
    let method;
    let functionName;
    let typeName;
    let methodName;

    if (lineMatch[1]) {
      functionName = lineMatch[1];

      let methodStart = functionName.lastIndexOf('.');
      if (functionName[methodStart - 1] === '.') {
        methodStart--;
      }

      if (methodStart > 0) {
        object = functionName.substr(0, methodStart);
        method = functionName.substr(methodStart + 1);
        const objectEnd = object.indexOf('.Module');
        if (objectEnd > 0) {
          functionName = functionName.substr(objectEnd + 1);
          object = object.substr(0, objectEnd);
        }
      }
      typeName = undefined;
    }

    if (method) {
      typeName = object;
      methodName = method;
    }

    if (method === '<anonymous>') {
      methodName = undefined;
      functionName = undefined;
    }

    if (functionName === undefined) {
      methodName = methodName || '<anonymous>';
      functionName = typeName ? `${typeName}.${methodName}` : methodName;
    }

    const filename = _optionalChain([lineMatch, 'access', _ => _[2], 'optionalAccess', _2 => _2.startsWith, 'call', _3 => _3('file://')]) ? lineMatch[2].substr(7) : lineMatch[2];
    const isNative = lineMatch[5] === 'native';
    const isInternal =
      isNative || (filename && !filename.startsWith('/') && !filename.startsWith('.') && filename.indexOf(':\\') !== 1);

    // in_app is all that's not an internal Node function or a module within node_modules
    // note that isNative appears to return true even for node core libraries
    // see https://github.com/getsentry/raven-node/issues/176
    const in_app = !isInternal && filename !== undefined && !filename.includes('node_modules/');

    return {
      filename,
      module: _optionalChain([getModule, 'optionalCall', _4 => _4(filename)]),
      function: functionName,
      lineno: parseInt(lineMatch[3], 10) || undefined,
      colno: parseInt(lineMatch[4], 10) || undefined,
      in_app,
    };
  };
}

/**
 * Node.js stack line parser
 *
 * This is in @sentry/utils so it can be used from the Electron SDK in the browser for when `nodeIntegration == true`.
 * This allows it to be used without referencing or importing any node specific code which causes bundlers to complain
 */
function nodeStackLineParser(getModule) {
  return [90, node(getModule)];
}


//# sourceMappingURL=stacktrace.js.map


/***/ }),

/***/ 57321:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$G": function() { return /* binding */ truncate; },
/* harmony export */   "U0": function() { return /* binding */ stringMatchesSomePattern; },
/* harmony export */   "nK": function() { return /* binding */ safeJoin; }
/* harmony export */ });
/* unused harmony exports escapeStringForRegex, isMatchingPattern, snipLine */
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);


/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max = 0) {
  if (typeof str !== 'string' || max === 0) {
    return str;
  }
  return str.length <= max ? str : `${str.substr(0, max)}...`;
}

/**
 * This is basically just `trim_line` from
 * https://github.com/getsentry/sentry/blob/master/src/sentry/lang/javascript/processor.py#L67
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string
 * @returns string Encoded
 */
function snipLine(line, colno) {
  let newLine = line;
  const lineLength = newLine.length;
  if (lineLength <= 150) {
    return newLine;
  }
  if (colno > lineLength) {
    // eslint-disable-next-line no-param-reassign
    colno = lineLength;
  }

  let start = Math.max(colno - 60, 0);
  if (start < 5) {
    start = 0;
  }

  let end = Math.min(start + 140, lineLength);
  if (end > lineLength - 5) {
    end = lineLength;
  }
  if (end === lineLength) {
    start = Math.max(end - 140, 0);
  }

  newLine = newLine.slice(start, end);
  if (start > 0) {
    newLine = `'{snip} ${newLine}`;
  }
  if (end < lineLength) {
    newLine += ' {snip}';
  }

  return newLine;
}

/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
  if (!Array.isArray(input)) {
    return '';
  }

  const output = [];
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < input.length; i++) {
    const value = input[i];
    try {
      output.push(String(value));
    } catch (e) {
      output.push('[value cannot be serialized]');
    }
  }

  return output.join(delimiter);
}

/**
 * Checks if the given value matches a regex or string
 *
 * @param value The string to test
 * @param pattern Either a regex or a string against which `value` will be matched
 * @param requireExactStringMatch If true, `value` must match `pattern` exactly. If false, `value` will match
 * `pattern` if it contains `pattern`. Only applies to string-type patterns.
 */
function isMatchingPattern(
  value,
  pattern,
  requireExactStringMatch = false,
) {
  if (!(0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(value)) {
    return false;
  }

  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isRegExp */ .Kj)(pattern)) {
    return pattern.test(value);
  }
  if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isString */ .HD)(pattern)) {
    return requireExactStringMatch ? value === pattern : value.includes(pattern);
  }

  return false;
}

/**
 * Test the given string against an array of strings and regexes. By default, string matching is done on a
 * substring-inclusion basis rather than a strict equality basis
 *
 * @param testString The string to test
 * @param patterns The patterns against which to test the string
 * @param requireExactStringMatch If true, `testString` must match one of the given string patterns exactly in order to
 * count. If false, `testString` will match a string pattern if it contains that pattern.
 * @returns
 */
function stringMatchesSomePattern(
  testString,
  patterns = [],
  requireExactStringMatch = false,
) {
  return patterns.some(pattern => isMatchingPattern(testString, pattern, requireExactStringMatch));
}

/**
 * Given a string, escape characters which have meaning in the regex grammar, such that the result is safe to feed to
 * `new RegExp()`.
 *
 * Based on https://github.com/sindresorhus/escape-string-regexp. Vendored to a) reduce the size by skipping the runtime
 * type-checking, and b) ensure it gets down-compiled for old versions of Node (the published package only supports Node
 * 12+).
 *
 * @param regexString The string to escape
 * @returns An version of the string with all special regex characters escaped
 */
function escapeStringForRegex(regexString) {
  // escape the hyphen separately so we can also replace it with a unicode literal hyphen, to avoid the problems
  // discussed in https://github.com/sindresorhus/escape-string-regexp/issues/20.
  return regexString.replace(/[|\\{}()[\]^$+*?.]/g, '\\$&').replace(/-/g, '\\x2d');
}


//# sourceMappingURL=string.js.map


/***/ }),

/***/ 8823:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Ak": function() { return /* binding */ supportsFetch; },
/* harmony export */   "Bf": function() { return /* binding */ supportsHistory; },
/* harmony export */   "Du": function() { return /* binding */ isNativeFetch; },
/* harmony export */   "t$": function() { return /* binding */ supportsNativeFetch; }
/* harmony export */ });
/* unused harmony exports supportsDOMError, supportsDOMException, supportsErrorEvent, supportsReferrerPolicy, supportsReportingObserver */
/* harmony import */ var _logger_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12343);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * Tells whether current environment supports ErrorEvent objects
 * {@link supportsErrorEvent}.
 *
 * @returns Answer to the given question.
 */
function supportsErrorEvent() {
  try {
    new ErrorEvent('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMError objects
 * {@link supportsDOMError}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMError() {
  try {
    // Chrome: VM89:1 Uncaught TypeError: Failed to construct 'DOMError':
    // 1 argument required, but only 0 present.
    // @ts-ignore It really needs 1 argument, not 0.
    new DOMError('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports DOMException objects
 * {@link supportsDOMException}.
 *
 * @returns Answer to the given question.
 */
function supportsDOMException() {
  try {
    new DOMException('');
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
  if (!('fetch' in WINDOW)) {
    return false;
  }

  try {
    new Headers();
    new Request('http://www.example.com');
    new Response();
    return true;
  } catch (e) {
    return false;
  }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
  return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}

/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
  if (!supportsFetch()) {
    return false;
  }

  // Fast path to avoid DOM I/O
  // eslint-disable-next-line @typescript-eslint/unbound-method
  if (isNativeFetch(WINDOW.fetch)) {
    return true;
  }

  // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
  // so create a "pure" iframe to see if that has native fetch
  let result = false;
  const doc = WINDOW.document;
  // eslint-disable-next-line deprecation/deprecation
  if (doc && typeof (doc.createElement ) === 'function') {
    try {
      const sandbox = doc.createElement('iframe');
      sandbox.hidden = true;
      doc.head.appendChild(sandbox);
      if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        result = isNativeFetch(sandbox.contentWindow.fetch);
      }
      doc.head.removeChild(sandbox);
    } catch (err) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        _logger_js__WEBPACK_IMPORTED_MODULE_1__/* .logger.warn */ .kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
    }
  }

  return result;
}

/**
 * Tells whether current environment supports ReportingObserver API
 * {@link supportsReportingObserver}.
 *
 * @returns Answer to the given question.
 */
function supportsReportingObserver() {
  return 'ReportingObserver' in WINDOW;
}

/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
  // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
  // (see https://caniuse.com/#feat=referrer-policy),
  // it doesn't. And it throws an exception instead of ignoring this parameter...
  // REF: https://github.com/getsentry/raven-js/issues/1233

  if (!supportsFetch()) {
    return false;
  }

  try {
    new Request('_', {
      referrerPolicy: 'origin' ,
    });
    return true;
  } catch (e) {
    return false;
  }
}

/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
  // NOTE: in Chrome App environment, touching history.pushState, *even inside
  //       a try/catch block*, will cause Chrome to output an error to console.error
  // borrowed from: https://github.com/angular/angular.js/pull/13945/files
  /* eslint-disable @typescript-eslint/no-unsafe-member-access */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const chrome = (WINDOW ).chrome;
  const isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
  /* eslint-enable @typescript-eslint/no-unsafe-member-access */
  const hasHistoryApi = 'history' in WINDOW && !!WINDOW.history.pushState && !!WINDOW.history.replaceState;

  return !isChromePackagedApp && hasHistoryApi;
}


//# sourceMappingURL=supports.js.map


/***/ }),

/***/ 96893:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$2": function() { return /* binding */ rejectedSyncPromise; },
/* harmony export */   "WD": function() { return /* binding */ resolvedSyncPromise; },
/* harmony export */   "cW": function() { return /* binding */ SyncPromise; }
/* harmony export */ });
/* harmony import */ var _is_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67597);


/* eslint-disable @typescript-eslint/explicit-function-return-type */

/** SyncPromise internal states */
var States; (function (States) {
  /** Pending */
  const PENDING = 0; States[States["PENDING"] = PENDING] = "PENDING";
  /** Resolved / OK */
  const RESOLVED = 1; States[States["RESOLVED"] = RESOLVED] = "RESOLVED";
  /** Rejected / Error */
  const REJECTED = 2; States[States["REJECTED"] = REJECTED] = "REJECTED";
})(States || (States = {}));

// Overloads so we can call resolvedSyncPromise without arguments and generic argument

/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
  return new SyncPromise(resolve => {
    resolve(value);
  });
}

/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
  return new SyncPromise((_, reject) => {
    reject(reason);
  });
}

/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
class SyncPromise {
   __init() {this._state = States.PENDING;}
   __init2() {this._handlers = [];}

   constructor(
    executor,
  ) {;SyncPromise.prototype.__init.call(this);SyncPromise.prototype.__init2.call(this);SyncPromise.prototype.__init3.call(this);SyncPromise.prototype.__init4.call(this);SyncPromise.prototype.__init5.call(this);SyncPromise.prototype.__init6.call(this);
    try {
      executor(this._resolve, this._reject);
    } catch (e) {
      this._reject(e);
    }
  }

  /** JSDoc */
   then(
    onfulfilled,
    onrejected,
  ) {
    return new SyncPromise((resolve, reject) => {
      this._handlers.push([
        false,
        result => {
          if (!onfulfilled) {
            // TODO: ¯\_(ツ)_/¯
            // TODO: FIXME
            resolve(result );
          } else {
            try {
              resolve(onfulfilled(result));
            } catch (e) {
              reject(e);
            }
          }
        },
        reason => {
          if (!onrejected) {
            reject(reason);
          } else {
            try {
              resolve(onrejected(reason));
            } catch (e) {
              reject(e);
            }
          }
        },
      ]);
      this._executeHandlers();
    });
  }

  /** JSDoc */
   catch(
    onrejected,
  ) {
    return this.then(val => val, onrejected);
  }

  /** JSDoc */
   finally(onfinally) {
    return new SyncPromise((resolve, reject) => {
      let val;
      let isRejected;

      return this.then(
        value => {
          isRejected = false;
          val = value;
          if (onfinally) {
            onfinally();
          }
        },
        reason => {
          isRejected = true;
          val = reason;
          if (onfinally) {
            onfinally();
          }
        },
      ).then(() => {
        if (isRejected) {
          reject(val);
          return;
        }

        resolve(val );
      });
    });
  }

  /** JSDoc */
    __init3() {this._resolve = (value) => {
    this._setResult(States.RESOLVED, value);
  };}

  /** JSDoc */
    __init4() {this._reject = (reason) => {
    this._setResult(States.REJECTED, reason);
  };}

  /** JSDoc */
    __init5() {this._setResult = (state, value) => {
    if (this._state !== States.PENDING) {
      return;
    }

    if ((0,_is_js__WEBPACK_IMPORTED_MODULE_0__/* .isThenable */ .J8)(value)) {
      void (value ).then(this._resolve, this._reject);
      return;
    }

    this._state = state;
    this._value = value;

    this._executeHandlers();
  };}

  /** JSDoc */
    __init6() {this._executeHandlers = () => {
    if (this._state === States.PENDING) {
      return;
    }

    const cachedHandlers = this._handlers.slice();
    this._handlers = [];

    cachedHandlers.forEach(handler => {
      if (handler[0]) {
        return;
      }

      if (this._state === States.RESOLVED) {
        // eslint-disable-next-line @typescript-eslint/no-floating-promises
        handler[1](this._value );
      }

      if (this._state === States.REJECTED) {
        handler[2](this._value);
      }

      handler[0] = true;
    });
  };}
}


//# sourceMappingURL=syncpromise.js.map


/***/ }),

/***/ 21170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z1": function() { return /* binding */ browserPerformanceTimeOrigin; },
/* harmony export */   "_I": function() { return /* binding */ timestampWithMs; },
/* harmony export */   "ph": function() { return /* binding */ timestampInSeconds; },
/* harmony export */   "yW": function() { return /* binding */ dateTimestampInSeconds; }
/* harmony export */ });
/* unused harmony exports _browserPerformanceTimeOriginMode, usingPerformanceAPI */
/* harmony import */ var _node_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(92448);
/* harmony import */ var _worldwide_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(71235);
/* module decorator */ module = __webpack_require__.hmd(module);



// eslint-disable-next-line deprecation/deprecation
const WINDOW = (0,_worldwide_js__WEBPACK_IMPORTED_MODULE_0__/* .getGlobalObject */ .Rf)();

/**
 * An object that can return the current timestamp in seconds since the UNIX epoch.
 */

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
const dateTimestampSource = {
  nowSeconds: () => Date.now() / 1000,
};

/**
 * A partial definition of the [Performance Web API]{@link https://developer.mozilla.org/en-US/docs/Web/API/Performance}
 * for accessing a high-resolution monotonic clock.
 */

/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    return undefined;
  }

  // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
  //
  // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
  // performance.now() gives a date arbitrarily in the past.
  //
  // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
  // undefined.
  //
  // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
  // interact with data coming out of performance entries.
  //
  // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
  // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
  // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
  // observed skews that can be as long as days, weeks or months.
  //
  // See https://github.com/getsentry/sentry-javascript/issues/2590.
  //
  // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
  // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
  // transactions of long-lived web pages.
  const timeOrigin = Date.now() - performance.now();

  return {
    now: () => performance.now(),
    timeOrigin,
  };
}

/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
  try {
    const perfHooks = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .dynamicRequire */ .l$)(module, 'perf_hooks') ;
    return perfHooks.performance;
  } catch (_) {
    return undefined;
  }
}

/**
 * The Performance API implementation for the current platform, if available.
 */
const platformPerformance = (0,_node_js__WEBPACK_IMPORTED_MODULE_1__/* .isNodeEnv */ .KV)() ? getNodePerformance() : getBrowserPerformance();

const timestampSource =
  platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: () => (platformPerformance.timeOrigin + platformPerformance.now()) / 1000,
      };

/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
const dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);

/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
const timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);

// Re-exported with an old name for backwards-compatibility.
const timestampWithMs = timestampInSeconds;

/**
 * A boolean that is true when timestampInSeconds uses the Performance API to produce monotonic timestamps.
 */
const usingPerformanceAPI = platformPerformance !== undefined;

/**
 * Internal helper to store what is the source of browserPerformanceTimeOrigin below. For debugging only.
 */
let _browserPerformanceTimeOriginMode;

/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
const browserPerformanceTimeOrigin = (() => {
  // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
  // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
  // data as reliable if they are within a reasonable threshold of the current time.

  const { performance } = WINDOW;
  if (!performance || !performance.now) {
    _browserPerformanceTimeOriginMode = 'none';
    return undefined;
  }

  const threshold = 3600 * 1000;
  const performanceNow = performance.now();
  const dateNow = Date.now();

  // if timeOrigin isn't available set delta to threshold so it isn't used
  const timeOriginDelta = performance.timeOrigin
    ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
    : threshold;
  const timeOriginIsReliable = timeOriginDelta < threshold;

  // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
  // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
  // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
  // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
  // Date API.
  // eslint-disable-next-line deprecation/deprecation
  const navigationStart = performance.timing && performance.timing.navigationStart;
  const hasNavigationStart = typeof navigationStart === 'number';
  // if navigationStart isn't available set delta to threshold so it isn't used
  const navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
  const navigationStartIsReliable = navigationStartDelta < threshold;

  if (timeOriginIsReliable || navigationStartIsReliable) {
    // Use the more reliable time origin
    if (timeOriginDelta <= navigationStartDelta) {
      _browserPerformanceTimeOriginMode = 'timeOrigin';
      return performance.timeOrigin;
    } else {
      _browserPerformanceTimeOriginMode = 'navigationStart';
      return navigationStart;
    }
  }

  // Either both timeOrigin and navigationStart are skewed or neither is available, fallback to Date.
  _browserPerformanceTimeOriginMode = 'dateNow';
  return dateNow;
})();


//# sourceMappingURL=time.js.map


/***/ }),

/***/ 71235:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Rf": function() { return /* binding */ getGlobalObject; },
/* harmony export */   "YO": function() { return /* binding */ getGlobalSingleton; },
/* harmony export */   "n2": function() { return /* binding */ GLOBAL_OBJ; }
/* harmony export */ });
/** Internal global with common properties and Sentry extensions  */

// The code below for 'isGlobalObj' and 'GLOBAL_OBJ' was copied from core-js before modification
// https://github.com/zloirock/core-js/blob/1b944df55282cdc99c90db5f49eb0b6eda2cc0a3/packages/core-js/internals/global.js
// core-js has the following licence:
//
// Copyright (c) 2014-2022 Denis Pushkarev
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
// THE SOFTWARE.

/** Returns 'obj' if it's the global object, otherwise returns undefined */
function isGlobalObj(obj) {
  return obj && obj.Math == Math ? obj : undefined;
}

/** Get's the global object for the current JavaScript runtime */
const GLOBAL_OBJ =
  (typeof globalThis == 'object' && isGlobalObj(globalThis)) ||
  // eslint-disable-next-line no-restricted-globals
  (typeof window == 'object' && isGlobalObj(window)) ||
  (typeof self == 'object' && isGlobalObj(self)) ||
  (typeof __webpack_require__.g == 'object' && isGlobalObj(__webpack_require__.g)) ||
  (function () {
    return this;
  })() ||
  {};

/**
 * @deprecated Use GLOBAL_OBJ instead or WINDOW from @sentry/browser. This will be removed in v8
 */
function getGlobalObject() {
  return GLOBAL_OBJ ;
}

/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `GLOBAL_OBJ`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
  const gbl = (obj || GLOBAL_OBJ) ;
  const __SENTRY__ = (gbl.__SENTRY__ = gbl.__SENTRY__ || {});
  const singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
  return singleton;
}


//# sourceMappingURL=worldwide.js.map


/***/ }),

/***/ 85813:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

var _global = (typeof window !== 'undefined' ? window : typeof __webpack_require__.g !== 'undefined' ? __webpack_require__.g : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"6becb65528745897787e8211f258c50ea3582b37"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["pim-nextjs@imprint-engine"]={id:"6becb65528745897787e8211f258c50ea3582b37"};
      

/***/ }),

/***/ 9669:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(51609);

/***/ }),

/***/ 55448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var settle = __webpack_require__(36026);
var cookies = __webpack_require__(4372);
var buildURL = __webpack_require__(15327);
var buildFullPath = __webpack_require__(94097);
var parseHeaders = __webpack_require__(84109);
var isURLSameOrigin = __webpack_require__(67985);
var transitionalDefaults = __webpack_require__(77874);
var AxiosError = __webpack_require__(82648);
var CanceledError = __webpack_require__(60644);
var parseProtocol = __webpack_require__(90205);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;
    var responseType = config.responseType;
    var onCanceled;
    function done() {
      if (config.cancelToken) {
        config.cancelToken.unsubscribe(onCanceled);
      }

      if (config.signal) {
        config.signal.removeEventListener('abort', onCanceled);
      }
    }

    if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);

    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    function onloadend() {
      if (!request) {
        return;
      }
      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !responseType || responseType === 'text' ||  responseType === 'json' ?
        request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(function _resolve(value) {
        resolve(value);
        done();
      }, function _reject(err) {
        reject(err);
        done();
      }, response);

      // Clean up request
      request = null;
    }

    if ('onloadend' in request) {
      // Use onloadend if available
      request.onloadend = onloadend;
    } else {
      // Listen for ready state to emulate onloadend
      request.onreadystatechange = function handleLoad() {
        if (!request || request.readyState !== 4) {
          return;
        }

        // The request errored out and we didn't get a response, this will be
        // handled by onerror instead
        // With one exception: request that using file: protocol, most browsers
        // will return status as 0 even though it's a successful request
        if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
          return;
        }
        // readystate handler is calling before onerror or ontimeout handlers,
        // so we should call onloadend on the next 'tick'
        setTimeout(onloadend);
      };
    }

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(new AxiosError('Request aborted', AxiosError.ECONNABORTED, config, request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(new AxiosError('Network Error', AxiosError.ERR_NETWORK, config, request, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = config.timeout ? 'timeout of ' + config.timeout + 'ms exceeded' : 'timeout exceeded';
      var transitional = config.transitional || transitionalDefaults;
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(new AxiosError(
        timeoutErrorMessage,
        transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
        config,
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (responseType && responseType !== 'json') {
      request.responseType = config.responseType;
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken || config.signal) {
      // Handle cancellation
      // eslint-disable-next-line func-names
      onCanceled = function(cancel) {
        if (!request) {
          return;
        }
        reject(!cancel || (cancel && cancel.type) ? new CanceledError() : cancel);
        request.abort();
        request = null;
      };

      config.cancelToken && config.cancelToken.subscribe(onCanceled);
      if (config.signal) {
        config.signal.aborted ? onCanceled() : config.signal.addEventListener('abort', onCanceled);
      }
    }

    if (!requestData) {
      requestData = null;
    }

    var protocol = parseProtocol(fullPath);

    if (protocol && [ 'http', 'https', 'file' ].indexOf(protocol) === -1) {
      reject(new AxiosError('Unsupported protocol ' + protocol + ':', AxiosError.ERR_BAD_REQUEST, config));
      return;
    }


    // Send the request
    request.send(requestData);
  });
};


/***/ }),

/***/ 51609:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var bind = __webpack_require__(91849);
var Axios = __webpack_require__(30321);
var mergeConfig = __webpack_require__(47185);
var defaults = __webpack_require__(45546);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  // Factory for creating new instances
  instance.create = function create(instanceConfig) {
    return createInstance(mergeConfig(defaultConfig, instanceConfig));
  };

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Expose Cancel & CancelToken
axios.CanceledError = __webpack_require__(60644);
axios.CancelToken = __webpack_require__(14972);
axios.isCancel = __webpack_require__(26502);
axios.VERSION = (__webpack_require__(97288).version);
axios.toFormData = __webpack_require__(47675);

// Expose AxiosError class
axios.AxiosError = __webpack_require__(82648);

// alias for CanceledError for backward compatibility
axios.Cancel = axios.CanceledError;

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(8713);

// Expose isAxiosError
axios.isAxiosError = __webpack_require__(16268);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports["default"] = axios;


/***/ }),

/***/ 14972:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var CanceledError = __webpack_require__(60644);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;

  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;

  // eslint-disable-next-line func-names
  this.promise.then(function(cancel) {
    if (!token._listeners) return;

    var i;
    var l = token._listeners.length;

    for (i = 0; i < l; i++) {
      token._listeners[i](cancel);
    }
    token._listeners = null;
  });

  // eslint-disable-next-line func-names
  this.promise.then = function(onfulfilled) {
    var _resolve;
    // eslint-disable-next-line func-names
    var promise = new Promise(function(resolve) {
      token.subscribe(resolve);
      _resolve = resolve;
    }).then(onfulfilled);

    promise.cancel = function reject() {
      token.unsubscribe(_resolve);
    };

    return promise;
  };

  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new CanceledError(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Subscribe to the cancel signal
 */

CancelToken.prototype.subscribe = function subscribe(listener) {
  if (this.reason) {
    listener(this.reason);
    return;
  }

  if (this._listeners) {
    this._listeners.push(listener);
  } else {
    this._listeners = [listener];
  }
};

/**
 * Unsubscribe from the cancel signal
 */

CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
  if (!this._listeners) {
    return;
  }
  var index = this._listeners.indexOf(listener);
  if (index !== -1) {
    this._listeners.splice(index, 1);
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),

/***/ 60644:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(82648);
var utils = __webpack_require__(64867);

/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function CanceledError(message) {
  // eslint-disable-next-line no-eq-null,eqeqeq
  AxiosError.call(this, message == null ? 'canceled' : message, AxiosError.ERR_CANCELED);
  this.name = 'CanceledError';
}

utils.inherits(CanceledError, AxiosError, {
  __CANCEL__: true
});

module.exports = CanceledError;


/***/ }),

/***/ 26502:
/***/ (function(module) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),

/***/ 30321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var buildURL = __webpack_require__(15327);
var InterceptorManager = __webpack_require__(80782);
var dispatchRequest = __webpack_require__(13572);
var mergeConfig = __webpack_require__(47185);
var buildFullPath = __webpack_require__(94097);
var validator = __webpack_require__(54875);

var validators = validator.validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(configOrUrl, config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof configOrUrl === 'string') {
    config = config || {};
    config.url = configOrUrl;
  } else {
    config = configOrUrl || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  var transitional = config.transitional;

  if (transitional !== undefined) {
    validator.assertOptions(transitional, {
      silentJSONParsing: validators.transitional(validators.boolean),
      forcedJSONParsing: validators.transitional(validators.boolean),
      clarifyTimeoutError: validators.transitional(validators.boolean)
    }, false);
  }

  // filter out skipped interceptors
  var requestInterceptorChain = [];
  var synchronousRequestInterceptors = true;
  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    if (typeof interceptor.runWhen === 'function' && interceptor.runWhen(config) === false) {
      return;
    }

    synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;

    requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  var responseInterceptorChain = [];
  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
  });

  var promise;

  if (!synchronousRequestInterceptors) {
    var chain = [dispatchRequest, undefined];

    Array.prototype.unshift.apply(chain, requestInterceptorChain);
    chain = chain.concat(responseInterceptorChain);

    promise = Promise.resolve(config);
    while (chain.length) {
      promise = promise.then(chain.shift(), chain.shift());
    }

    return promise;
  }


  var newConfig = config;
  while (requestInterceptorChain.length) {
    var onFulfilled = requestInterceptorChain.shift();
    var onRejected = requestInterceptorChain.shift();
    try {
      newConfig = onFulfilled(newConfig);
    } catch (error) {
      onRejected(error);
      break;
    }
  }

  try {
    promise = dispatchRequest(newConfig);
  } catch (error) {
    return Promise.reject(error);
  }

  while (responseInterceptorChain.length) {
    promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  var fullPath = buildFullPath(config.baseURL, config.url);
  return buildURL(fullPath, config.params, config.paramsSerializer);
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(mergeConfig(config || {}, {
      method: method,
      url: url,
      data: (config || {}).data
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/

  function generateHTTPMethod(isForm) {
    return function httpMethod(url, data, config) {
      return this.request(mergeConfig(config || {}, {
        method: method,
        headers: isForm ? {
          'Content-Type': 'multipart/form-data'
        } : {},
        url: url,
        data: data
      }));
    };
  }

  Axios.prototype[method] = generateHTTPMethod();

  Axios.prototype[method + 'Form'] = generateHTTPMethod(true);
});

module.exports = Axios;


/***/ }),

/***/ 82648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
function AxiosError(message, code, config, request, response) {
  Error.call(this);
  this.message = message;
  this.name = 'AxiosError';
  code && (this.code = code);
  config && (this.config = config);
  request && (this.request = request);
  response && (this.response = response);
}

utils.inherits(AxiosError, Error, {
  toJSON: function toJSON() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});

var prototype = AxiosError.prototype;
var descriptors = {};

[
  'ERR_BAD_OPTION_VALUE',
  'ERR_BAD_OPTION',
  'ECONNABORTED',
  'ETIMEDOUT',
  'ERR_NETWORK',
  'ERR_FR_TOO_MANY_REDIRECTS',
  'ERR_DEPRECATED',
  'ERR_BAD_RESPONSE',
  'ERR_BAD_REQUEST',
  'ERR_CANCELED'
// eslint-disable-next-line func-names
].forEach(function(code) {
  descriptors[code] = {value: code};
});

Object.defineProperties(AxiosError, descriptors);
Object.defineProperty(prototype, 'isAxiosError', {value: true});

// eslint-disable-next-line func-names
AxiosError.from = function(error, code, config, request, response, customProps) {
  var axiosError = Object.create(prototype);

  utils.toFlatObject(error, axiosError, function filter(obj) {
    return obj !== Error.prototype;
  });

  AxiosError.call(axiosError, error.message, code, config, request, response);

  axiosError.name = error.name;

  customProps && Object.assign(axiosError, customProps);

  return axiosError;
};

module.exports = AxiosError;


/***/ }),

/***/ 80782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected,
    synchronous: options ? options.synchronous : false,
    runWhen: options ? options.runWhen : null
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),

/***/ 94097:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(91793);
var combineURLs = __webpack_require__(7303);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),

/***/ 13572:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var transformData = __webpack_require__(18527);
var isCancel = __webpack_require__(26502);
var defaults = __webpack_require__(45546);
var CanceledError = __webpack_require__(60644);

/**
 * Throws a `CanceledError` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }

  if (config.signal && config.signal.aborted) {
    throw new CanceledError();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData.call(
    config,
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData.call(
      config,
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData.call(
          config,
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),

/***/ 47185:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  function getMergedValue(target, source) {
    if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
      return utils.merge(target, source);
    } else if (utils.isPlainObject(source)) {
      return utils.merge({}, source);
    } else if (utils.isArray(source)) {
      return source.slice();
    }
    return source;
  }

  // eslint-disable-next-line consistent-return
  function mergeDeepProperties(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function valueFromConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function defaultToConfig2(prop) {
    if (!utils.isUndefined(config2[prop])) {
      return getMergedValue(undefined, config2[prop]);
    } else if (!utils.isUndefined(config1[prop])) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  // eslint-disable-next-line consistent-return
  function mergeDirectKeys(prop) {
    if (prop in config2) {
      return getMergedValue(config1[prop], config2[prop]);
    } else if (prop in config1) {
      return getMergedValue(undefined, config1[prop]);
    }
  }

  var mergeMap = {
    'url': valueFromConfig2,
    'method': valueFromConfig2,
    'data': valueFromConfig2,
    'baseURL': defaultToConfig2,
    'transformRequest': defaultToConfig2,
    'transformResponse': defaultToConfig2,
    'paramsSerializer': defaultToConfig2,
    'timeout': defaultToConfig2,
    'timeoutMessage': defaultToConfig2,
    'withCredentials': defaultToConfig2,
    'adapter': defaultToConfig2,
    'responseType': defaultToConfig2,
    'xsrfCookieName': defaultToConfig2,
    'xsrfHeaderName': defaultToConfig2,
    'onUploadProgress': defaultToConfig2,
    'onDownloadProgress': defaultToConfig2,
    'decompress': defaultToConfig2,
    'maxContentLength': defaultToConfig2,
    'maxBodyLength': defaultToConfig2,
    'beforeRedirect': defaultToConfig2,
    'transport': defaultToConfig2,
    'httpAgent': defaultToConfig2,
    'httpsAgent': defaultToConfig2,
    'cancelToken': defaultToConfig2,
    'socketPath': defaultToConfig2,
    'responseEncoding': defaultToConfig2,
    'validateStatus': mergeDirectKeys
  };

  utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
    var merge = mergeMap[prop] || mergeDeepProperties;
    var configValue = merge(prop);
    (utils.isUndefined(configValue) && merge !== mergeDirectKeys) || (config[prop] = configValue);
  });

  return config;
};


/***/ }),

/***/ 36026:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var AxiosError = __webpack_require__(82648);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(new AxiosError(
      'Request failed with status code ' + response.status,
      [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
      response.config,
      response.request,
      response
    ));
  }
};


/***/ }),

/***/ 18527:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);
var defaults = __webpack_require__(45546);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  var context = this || defaults;
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn.call(context, data, headers);
  });

  return data;
};


/***/ }),

/***/ 45546:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var process = __webpack_require__(83454);


var utils = __webpack_require__(64867);
var normalizeHeaderName = __webpack_require__(16016);
var AxiosError = __webpack_require__(82648);
var transitionalDefaults = __webpack_require__(77874);
var toFormData = __webpack_require__(47675);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(55448);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(55448);
  }
  return adapter;
}

function stringifySafely(rawValue, parser, encoder) {
  if (utils.isString(rawValue)) {
    try {
      (parser || JSON.parse)(rawValue);
      return utils.trim(rawValue);
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
  }

  return (encoder || JSON.stringify)(rawValue);
}

var defaults = {

  transitional: transitionalDefaults,

  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');

    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }

    var isObjectPayload = utils.isObject(data);
    var contentType = headers && headers['Content-Type'];

    var isFileList;

    if ((isFileList = utils.isFileList(data)) || (isObjectPayload && contentType === 'multipart/form-data')) {
      var _FormData = this.env && this.env.FormData;
      return toFormData(isFileList ? {'files[]': data} : data, _FormData && new _FormData());
    } else if (isObjectPayload || contentType === 'application/json') {
      setContentTypeIfUnset(headers, 'application/json');
      return stringifySafely(data);
    }

    return data;
  }],

  transformResponse: [function transformResponse(data) {
    var transitional = this.transitional || defaults.transitional;
    var silentJSONParsing = transitional && transitional.silentJSONParsing;
    var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
    var strictJSONParsing = !silentJSONParsing && this.responseType === 'json';

    if (strictJSONParsing || (forcedJSONParsing && utils.isString(data) && data.length)) {
      try {
        return JSON.parse(data);
      } catch (e) {
        if (strictJSONParsing) {
          if (e.name === 'SyntaxError') {
            throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
          }
          throw e;
        }
      }
    }

    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,
  maxBodyLength: -1,

  env: {
    FormData: __webpack_require__(91623)
  },

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  },

  headers: {
    common: {
      'Accept': 'application/json, text/plain, */*'
    }
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;


/***/ }),

/***/ 77874:
/***/ (function(module) {

"use strict";


module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};


/***/ }),

/***/ 97288:
/***/ (function(module) {

module.exports = {
  "version": "0.27.2"
};

/***/ }),

/***/ 91849:
/***/ (function(module) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),

/***/ 15327:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),

/***/ 7303:
/***/ (function(module) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),

/***/ 4372:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),

/***/ 91793:
/***/ (function(module) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
};


/***/ }),

/***/ 16268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

/**
 * Determines whether the payload is an error thrown by Axios
 *
 * @param {*} payload The value to test
 * @returns {boolean} True if the payload is an error thrown by Axios, otherwise false
 */
module.exports = function isAxiosError(payload) {
  return utils.isObject(payload) && (payload.isAxiosError === true);
};


/***/ }),

/***/ 67985:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),

/***/ 16016:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),

/***/ 91623:
/***/ (function(module) {

// eslint-disable-next-line strict
module.exports = null;


/***/ }),

/***/ 84109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(64867);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),

/***/ 90205:
/***/ (function(module) {

"use strict";


module.exports = function parseProtocol(url) {
  var match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
  return match && match[1] || '';
};


/***/ }),

/***/ 8713:
/***/ (function(module) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),

/***/ 47675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];


var utils = __webpack_require__(64867);

/**
 * Convert a data object to FormData
 * @param {Object} obj
 * @param {?Object} [formData]
 * @returns {Object}
 **/

function toFormData(obj, formData) {
  // eslint-disable-next-line no-param-reassign
  formData = formData || new FormData();

  var stack = [];

  function convertValue(value) {
    if (value === null) return '';

    if (utils.isDate(value)) {
      return value.toISOString();
    }

    if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
      return typeof Blob === 'function' ? new Blob([value]) : Buffer.from(value);
    }

    return value;
  }

  function build(data, parentKey) {
    if (utils.isPlainObject(data) || utils.isArray(data)) {
      if (stack.indexOf(data) !== -1) {
        throw Error('Circular reference detected in ' + parentKey);
      }

      stack.push(data);

      utils.forEach(data, function each(value, key) {
        if (utils.isUndefined(value)) return;
        var fullKey = parentKey ? parentKey + '.' + key : key;
        var arr;

        if (value && !parentKey && typeof value === 'object') {
          if (utils.endsWith(key, '{}')) {
            // eslint-disable-next-line no-param-reassign
            value = JSON.stringify(value);
          } else if (utils.endsWith(key, '[]') && (arr = utils.toArray(value))) {
            // eslint-disable-next-line func-names
            arr.forEach(function(el) {
              !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
            });
            return;
          }
        }

        build(value, fullKey);
      });

      stack.pop();
    } else {
      formData.append(parentKey, convertValue(data));
    }
  }

  build(obj);

  return formData;
}

module.exports = toFormData;


/***/ }),

/***/ 54875:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var VERSION = (__webpack_require__(97288).version);
var AxiosError = __webpack_require__(82648);

var validators = {};

// eslint-disable-next-line func-names
['object', 'boolean', 'number', 'function', 'string', 'symbol'].forEach(function(type, i) {
  validators[type] = function validator(thing) {
    return typeof thing === type || 'a' + (i < 1 ? 'n ' : ' ') + type;
  };
});

var deprecatedWarnings = {};

/**
 * Transitional option validator
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 * @returns {function}
 */
validators.transitional = function transitional(validator, version, message) {
  function formatMessage(opt, desc) {
    return '[Axios v' + VERSION + '] Transitional option \'' + opt + '\'' + desc + (message ? '. ' + message : '');
  }

  // eslint-disable-next-line func-names
  return function(value, opt, opts) {
    if (validator === false) {
      throw new AxiosError(
        formatMessage(opt, ' has been removed' + (version ? ' in ' + version : '')),
        AxiosError.ERR_DEPRECATED
      );
    }

    if (version && !deprecatedWarnings[opt]) {
      deprecatedWarnings[opt] = true;
      // eslint-disable-next-line no-console
      console.warn(
        formatMessage(
          opt,
          ' has been deprecated since v' + version + ' and will be removed in the near future'
        )
      );
    }

    return validator ? validator(value, opt, opts) : true;
  };
};

/**
 * Assert object's properties type
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 */

function assertOptions(options, schema, allowUnknown) {
  if (typeof options !== 'object') {
    throw new AxiosError('options must be an object', AxiosError.ERR_BAD_OPTION_VALUE);
  }
  var keys = Object.keys(options);
  var i = keys.length;
  while (i-- > 0) {
    var opt = keys[i];
    var validator = schema[opt];
    if (validator) {
      var value = options[opt];
      var result = value === undefined || validator(value, opt, options);
      if (result !== true) {
        throw new AxiosError('option ' + opt + ' must be ' + result, AxiosError.ERR_BAD_OPTION_VALUE);
      }
      continue;
    }
    if (allowUnknown !== true) {
      throw new AxiosError('Unknown option ' + opt, AxiosError.ERR_BAD_OPTION);
    }
  }
}

module.exports = {
  assertOptions: assertOptions,
  validators: validators
};


/***/ }),

/***/ 64867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(91849);

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

// eslint-disable-next-line func-names
var kindOf = (function(cache) {
  // eslint-disable-next-line func-names
  return function(thing) {
    var str = toString.call(thing);
    return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
  };
})(Object.create(null));

function kindOfTest(type) {
  type = type.toLowerCase();
  return function isKindOf(thing) {
    return kindOf(thing) === type;
  };
}

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return Array.isArray(val);
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
var isArrayBuffer = kindOfTest('ArrayBuffer');


/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (isArrayBuffer(val.buffer));
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a plain Object
 *
 * @param {Object} val The value to test
 * @return {boolean} True if value is a plain Object, otherwise false
 */
function isPlainObject(val) {
  if (kindOf(val) !== 'object') {
    return false;
  }

  var prototype = Object.getPrototypeOf(val);
  return prototype === null || prototype === Object.prototype;
}

/**
 * Determine if a value is a Date
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
var isDate = kindOfTest('Date');

/**
 * Determine if a value is a File
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFile = kindOfTest('File');

/**
 * Determine if a value is a Blob
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
var isBlob = kindOfTest('Blob');

/**
 * Determine if a value is a FileList
 *
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
var isFileList = kindOfTest('FileList');

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} thing The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(thing) {
  var pattern = '[object FormData]';
  return thing && (
    (typeof FormData === 'function' && thing instanceof FormData) ||
    toString.call(thing) === pattern ||
    (isFunction(thing.toString) && thing.toString() === pattern)
  );
}

/**
 * Determine if a value is a URLSearchParams object
 * @function
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
var isURLSearchParams = kindOfTest('URLSearchParams');

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (isPlainObject(result[key]) && isPlainObject(val)) {
      result[key] = merge(result[key], val);
    } else if (isPlainObject(val)) {
      result[key] = merge({}, val);
    } else if (isArray(val)) {
      result[key] = val.slice();
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 * @return {string} content value without BOM
 */
function stripBOM(content) {
  if (content.charCodeAt(0) === 0xFEFF) {
    content = content.slice(1);
  }
  return content;
}

/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 */

function inherits(constructor, superConstructor, props, descriptors) {
  constructor.prototype = Object.create(superConstructor.prototype, descriptors);
  constructor.prototype.constructor = constructor;
  props && Object.assign(constructor.prototype, props);
}

/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function} [filter]
 * @returns {Object}
 */

function toFlatObject(sourceObj, destObj, filter) {
  var props;
  var i;
  var prop;
  var merged = {};

  destObj = destObj || {};

  do {
    props = Object.getOwnPropertyNames(sourceObj);
    i = props.length;
    while (i-- > 0) {
      prop = props[i];
      if (!merged[prop]) {
        destObj[prop] = sourceObj[prop];
        merged[prop] = true;
      }
    }
    sourceObj = Object.getPrototypeOf(sourceObj);
  } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);

  return destObj;
}

/*
 * determines whether a string ends with the characters of a specified string
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 * @returns {boolean}
 */
function endsWith(str, searchString, position) {
  str = String(str);
  if (position === undefined || position > str.length) {
    position = str.length;
  }
  position -= searchString.length;
  var lastIndex = str.indexOf(searchString, position);
  return lastIndex !== -1 && lastIndex === position;
}


/**
 * Returns new array from array like object
 * @param {*} [thing]
 * @returns {Array}
 */
function toArray(thing) {
  if (!thing) return null;
  var i = thing.length;
  if (isUndefined(i)) return null;
  var arr = new Array(i);
  while (i-- > 0) {
    arr[i] = thing[i];
  }
  return arr;
}

// eslint-disable-next-line func-names
var isTypedArray = (function(TypedArray) {
  // eslint-disable-next-line func-names
  return function(thing) {
    return TypedArray && thing instanceof TypedArray;
  };
})(typeof Uint8Array !== 'undefined' && Object.getPrototypeOf(Uint8Array));

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isPlainObject: isPlainObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim,
  stripBOM: stripBOM,
  inherits: inherits,
  toFlatObject: toFlatObject,
  kindOf: kindOf,
  kindOfTest: kindOfTest,
  endsWith: endsWith,
  toArray: toArray,
  isTypedArray: isTypedArray,
  isFileList: isFileList
};


/***/ }),

/***/ 79742:
/***/ (function(__unused_webpack_module, exports) {

"use strict";


exports.byteLength = byteLength
exports.toByteArray = toByteArray
exports.fromByteArray = fromByteArray

var lookup = []
var revLookup = []
var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array

var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
for (var i = 0, len = code.length; i < len; ++i) {
  lookup[i] = code[i]
  revLookup[code.charCodeAt(i)] = i
}

// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
revLookup['-'.charCodeAt(0)] = 62
revLookup['_'.charCodeAt(0)] = 63

function getLens (b64) {
  var len = b64.length

  if (len % 4 > 0) {
    throw new Error('Invalid string. Length must be a multiple of 4')
  }

  // Trim off extra bytes after placeholder bytes are found
  // See: https://github.com/beatgammit/base64-js/issues/42
  var validLen = b64.indexOf('=')
  if (validLen === -1) validLen = len

  var placeHoldersLen = validLen === len
    ? 0
    : 4 - (validLen % 4)

  return [validLen, placeHoldersLen]
}

// base64 is 4/3 + up to two characters of the original data
function byteLength (b64) {
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function _byteLength (b64, validLen, placeHoldersLen) {
  return ((validLen + placeHoldersLen) * 3 / 4) - placeHoldersLen
}

function toByteArray (b64) {
  var tmp
  var lens = getLens(b64)
  var validLen = lens[0]
  var placeHoldersLen = lens[1]

  var arr = new Arr(_byteLength(b64, validLen, placeHoldersLen))

  var curByte = 0

  // if there are placeholders, only get up to the last complete 4 chars
  var len = placeHoldersLen > 0
    ? validLen - 4
    : validLen

  var i
  for (i = 0; i < len; i += 4) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 18) |
      (revLookup[b64.charCodeAt(i + 1)] << 12) |
      (revLookup[b64.charCodeAt(i + 2)] << 6) |
      revLookup[b64.charCodeAt(i + 3)]
    arr[curByte++] = (tmp >> 16) & 0xFF
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 2) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 2) |
      (revLookup[b64.charCodeAt(i + 1)] >> 4)
    arr[curByte++] = tmp & 0xFF
  }

  if (placeHoldersLen === 1) {
    tmp =
      (revLookup[b64.charCodeAt(i)] << 10) |
      (revLookup[b64.charCodeAt(i + 1)] << 4) |
      (revLookup[b64.charCodeAt(i + 2)] >> 2)
    arr[curByte++] = (tmp >> 8) & 0xFF
    arr[curByte++] = tmp & 0xFF
  }

  return arr
}

function tripletToBase64 (num) {
  return lookup[num >> 18 & 0x3F] +
    lookup[num >> 12 & 0x3F] +
    lookup[num >> 6 & 0x3F] +
    lookup[num & 0x3F]
}

function encodeChunk (uint8, start, end) {
  var tmp
  var output = []
  for (var i = start; i < end; i += 3) {
    tmp =
      ((uint8[i] << 16) & 0xFF0000) +
      ((uint8[i + 1] << 8) & 0xFF00) +
      (uint8[i + 2] & 0xFF)
    output.push(tripletToBase64(tmp))
  }
  return output.join('')
}

function fromByteArray (uint8) {
  var tmp
  var len = uint8.length
  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
  var parts = []
  var maxChunkLength = 16383 // must be multiple of 3

  // go through the array every three bytes, we'll deal with trailing stuff later
  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
  }

  // pad the end with zeros, but make sure to not forget the extra bytes
  if (extraBytes === 1) {
    tmp = uint8[len - 1]
    parts.push(
      lookup[tmp >> 2] +
      lookup[(tmp << 4) & 0x3F] +
      '=='
    )
  } else if (extraBytes === 2) {
    tmp = (uint8[len - 2] << 8) + uint8[len - 1]
    parts.push(
      lookup[tmp >> 10] +
      lookup[(tmp >> 4) & 0x3F] +
      lookup[(tmp << 2) & 0x3F] +
      '='
    )
  }

  return parts.join('')
}


/***/ }),

/***/ 51206:
/***/ (function(module) {

!function(e,t){ true?module.exports=t():0}(this,(function(){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var i=t[n]={i:n,l:!1,exports:{}};return e[n].call(i.exports,i,i.exports,r),i.l=!0,i.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var i in e)r.d(n,i,function(t){return e[t]}.bind(null,i));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=90)}({17:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=r(18),i=function(){function e(){}return e.getFirstMatch=function(e,t){var r=t.match(e);return r&&r.length>0&&r[1]||""},e.getSecondMatch=function(e,t){var r=t.match(e);return r&&r.length>1&&r[2]||""},e.matchAndReturnConst=function(e,t,r){if(e.test(t))return r},e.getWindowsVersionName=function(e){switch(e){case"NT":return"NT";case"XP":return"XP";case"NT 5.0":return"2000";case"NT 5.1":return"XP";case"NT 5.2":return"2003";case"NT 6.0":return"Vista";case"NT 6.1":return"7";case"NT 6.2":return"8";case"NT 6.3":return"8.1";case"NT 10.0":return"10";default:return}},e.getMacOSVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),10===t[0])switch(t[1]){case 5:return"Leopard";case 6:return"Snow Leopard";case 7:return"Lion";case 8:return"Mountain Lion";case 9:return"Mavericks";case 10:return"Yosemite";case 11:return"El Capitan";case 12:return"Sierra";case 13:return"High Sierra";case 14:return"Mojave";case 15:return"Catalina";default:return}},e.getAndroidVersionName=function(e){var t=e.split(".").splice(0,2).map((function(e){return parseInt(e,10)||0}));if(t.push(0),!(1===t[0]&&t[1]<5))return 1===t[0]&&t[1]<6?"Cupcake":1===t[0]&&t[1]>=6?"Donut":2===t[0]&&t[1]<2?"Eclair":2===t[0]&&2===t[1]?"Froyo":2===t[0]&&t[1]>2?"Gingerbread":3===t[0]?"Honeycomb":4===t[0]&&t[1]<1?"Ice Cream Sandwich":4===t[0]&&t[1]<4?"Jelly Bean":4===t[0]&&t[1]>=4?"KitKat":5===t[0]?"Lollipop":6===t[0]?"Marshmallow":7===t[0]?"Nougat":8===t[0]?"Oreo":9===t[0]?"Pie":void 0},e.getVersionPrecision=function(e){return e.split(".").length},e.compareVersions=function(t,r,n){void 0===n&&(n=!1);var i=e.getVersionPrecision(t),s=e.getVersionPrecision(r),a=Math.max(i,s),o=0,u=e.map([t,r],(function(t){var r=a-e.getVersionPrecision(t),n=t+new Array(r+1).join(".0");return e.map(n.split("."),(function(e){return new Array(20-e.length).join("0")+e})).reverse()}));for(n&&(o=a-Math.min(i,s)),a-=1;a>=o;){if(u[0][a]>u[1][a])return 1;if(u[0][a]===u[1][a]){if(a===o)return 0;a-=1}else if(u[0][a]<u[1][a])return-1}},e.map=function(e,t){var r,n=[];if(Array.prototype.map)return Array.prototype.map.call(e,t);for(r=0;r<e.length;r+=1)n.push(t(e[r]));return n},e.find=function(e,t){var r,n;if(Array.prototype.find)return Array.prototype.find.call(e,t);for(r=0,n=e.length;r<n;r+=1){var i=e[r];if(t(i,r))return i}},e.assign=function(e){for(var t,r,n=e,i=arguments.length,s=new Array(i>1?i-1:0),a=1;a<i;a++)s[a-1]=arguments[a];if(Object.assign)return Object.assign.apply(Object,[e].concat(s));var o=function(){var e=s[t];"object"==typeof e&&null!==e&&Object.keys(e).forEach((function(t){n[t]=e[t]}))};for(t=0,r=s.length;t<r;t+=1)o();return e},e.getBrowserAlias=function(e){return n.BROWSER_ALIASES_MAP[e]},e.getBrowserTypeByAlias=function(e){return n.BROWSER_MAP[e]||""},e}();t.default=i,e.exports=t.default},18:function(e,t,r){"use strict";t.__esModule=!0,t.ENGINE_MAP=t.OS_MAP=t.PLATFORMS_MAP=t.BROWSER_MAP=t.BROWSER_ALIASES_MAP=void 0;t.BROWSER_ALIASES_MAP={"Amazon Silk":"amazon_silk","Android Browser":"android",Bada:"bada",BlackBerry:"blackberry",Chrome:"chrome",Chromium:"chromium",Electron:"electron",Epiphany:"epiphany",Firefox:"firefox",Focus:"focus",Generic:"generic","Google Search":"google_search",Googlebot:"googlebot","Internet Explorer":"ie","K-Meleon":"k_meleon",Maxthon:"maxthon","Microsoft Edge":"edge","MZ Browser":"mz","NAVER Whale Browser":"naver",Opera:"opera","Opera Coast":"opera_coast",PhantomJS:"phantomjs",Puffin:"puffin",QupZilla:"qupzilla",QQ:"qq",QQLite:"qqlite",Safari:"safari",Sailfish:"sailfish","Samsung Internet for Android":"samsung_internet",SeaMonkey:"seamonkey",Sleipnir:"sleipnir",Swing:"swing",Tizen:"tizen","UC Browser":"uc",Vivaldi:"vivaldi","WebOS Browser":"webos",WeChat:"wechat","Yandex Browser":"yandex",Roku:"roku"};t.BROWSER_MAP={amazon_silk:"Amazon Silk",android:"Android Browser",bada:"Bada",blackberry:"BlackBerry",chrome:"Chrome",chromium:"Chromium",electron:"Electron",epiphany:"Epiphany",firefox:"Firefox",focus:"Focus",generic:"Generic",googlebot:"Googlebot",google_search:"Google Search",ie:"Internet Explorer",k_meleon:"K-Meleon",maxthon:"Maxthon",edge:"Microsoft Edge",mz:"MZ Browser",naver:"NAVER Whale Browser",opera:"Opera",opera_coast:"Opera Coast",phantomjs:"PhantomJS",puffin:"Puffin",qupzilla:"QupZilla",qq:"QQ Browser",qqlite:"QQ Browser Lite",safari:"Safari",sailfish:"Sailfish",samsung_internet:"Samsung Internet for Android",seamonkey:"SeaMonkey",sleipnir:"Sleipnir",swing:"Swing",tizen:"Tizen",uc:"UC Browser",vivaldi:"Vivaldi",webos:"WebOS Browser",wechat:"WeChat",yandex:"Yandex Browser"};t.PLATFORMS_MAP={tablet:"tablet",mobile:"mobile",desktop:"desktop",tv:"tv"};t.OS_MAP={WindowsPhone:"Windows Phone",Windows:"Windows",MacOS:"macOS",iOS:"iOS",Android:"Android",WebOS:"WebOS",BlackBerry:"BlackBerry",Bada:"Bada",Tizen:"Tizen",Linux:"Linux",ChromeOS:"Chrome OS",PlayStation4:"PlayStation 4",Roku:"Roku"};t.ENGINE_MAP={EdgeHTML:"EdgeHTML",Blink:"Blink",Trident:"Trident",Presto:"Presto",Gecko:"Gecko",WebKit:"WebKit"}},90:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(91))&&n.__esModule?n:{default:n},s=r(18);function a(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var o=function(){function e(){}var t,r,n;return e.getParser=function(e,t){if(void 0===t&&(t=!1),"string"!=typeof e)throw new Error("UserAgent should be a string");return new i.default(e,t)},e.parse=function(e){return new i.default(e).getResult()},t=e,n=[{key:"BROWSER_MAP",get:function(){return s.BROWSER_MAP}},{key:"ENGINE_MAP",get:function(){return s.ENGINE_MAP}},{key:"OS_MAP",get:function(){return s.OS_MAP}},{key:"PLATFORMS_MAP",get:function(){return s.PLATFORMS_MAP}}],(r=null)&&a(t.prototype,r),n&&a(t,n),e}();t.default=o,e.exports=t.default},91:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n=u(r(92)),i=u(r(93)),s=u(r(94)),a=u(r(95)),o=u(r(17));function u(e){return e&&e.__esModule?e:{default:e}}var d=function(){function e(e,t){if(void 0===t&&(t=!1),null==e||""===e)throw new Error("UserAgent parameter can't be empty");this._ua=e,this.parsedResult={},!0!==t&&this.parse()}var t=e.prototype;return t.getUA=function(){return this._ua},t.test=function(e){return e.test(this._ua)},t.parseBrowser=function(){var e=this;this.parsedResult.browser={};var t=o.default.find(n.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.browser=t.describe(this.getUA())),this.parsedResult.browser},t.getBrowser=function(){return this.parsedResult.browser?this.parsedResult.browser:this.parseBrowser()},t.getBrowserName=function(e){return e?String(this.getBrowser().name).toLowerCase()||"":this.getBrowser().name||""},t.getBrowserVersion=function(){return this.getBrowser().version},t.getOS=function(){return this.parsedResult.os?this.parsedResult.os:this.parseOS()},t.parseOS=function(){var e=this;this.parsedResult.os={};var t=o.default.find(i.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.os=t.describe(this.getUA())),this.parsedResult.os},t.getOSName=function(e){var t=this.getOS().name;return e?String(t).toLowerCase()||"":t||""},t.getOSVersion=function(){return this.getOS().version},t.getPlatform=function(){return this.parsedResult.platform?this.parsedResult.platform:this.parsePlatform()},t.getPlatformType=function(e){void 0===e&&(e=!1);var t=this.getPlatform().type;return e?String(t).toLowerCase()||"":t||""},t.parsePlatform=function(){var e=this;this.parsedResult.platform={};var t=o.default.find(s.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.platform=t.describe(this.getUA())),this.parsedResult.platform},t.getEngine=function(){return this.parsedResult.engine?this.parsedResult.engine:this.parseEngine()},t.getEngineName=function(e){return e?String(this.getEngine().name).toLowerCase()||"":this.getEngine().name||""},t.parseEngine=function(){var e=this;this.parsedResult.engine={};var t=o.default.find(a.default,(function(t){if("function"==typeof t.test)return t.test(e);if(t.test instanceof Array)return t.test.some((function(t){return e.test(t)}));throw new Error("Browser's test function is not valid")}));return t&&(this.parsedResult.engine=t.describe(this.getUA())),this.parsedResult.engine},t.parse=function(){return this.parseBrowser(),this.parseOS(),this.parsePlatform(),this.parseEngine(),this},t.getResult=function(){return o.default.assign({},this.parsedResult)},t.satisfies=function(e){var t=this,r={},n=0,i={},s=0;if(Object.keys(e).forEach((function(t){var a=e[t];"string"==typeof a?(i[t]=a,s+=1):"object"==typeof a&&(r[t]=a,n+=1)})),n>0){var a=Object.keys(r),u=o.default.find(a,(function(e){return t.isOS(e)}));if(u){var d=this.satisfies(r[u]);if(void 0!==d)return d}var c=o.default.find(a,(function(e){return t.isPlatform(e)}));if(c){var f=this.satisfies(r[c]);if(void 0!==f)return f}}if(s>0){var l=Object.keys(i),h=o.default.find(l,(function(e){return t.isBrowser(e,!0)}));if(void 0!==h)return this.compareVersion(i[h])}},t.isBrowser=function(e,t){void 0===t&&(t=!1);var r=this.getBrowserName().toLowerCase(),n=e.toLowerCase(),i=o.default.getBrowserTypeByAlias(n);return t&&i&&(n=i.toLowerCase()),n===r},t.compareVersion=function(e){var t=[0],r=e,n=!1,i=this.getBrowserVersion();if("string"==typeof i)return">"===e[0]||"<"===e[0]?(r=e.substr(1),"="===e[1]?(n=!0,r=e.substr(2)):t=[],">"===e[0]?t.push(1):t.push(-1)):"="===e[0]?r=e.substr(1):"~"===e[0]&&(n=!0,r=e.substr(1)),t.indexOf(o.default.compareVersions(i,r,n))>-1},t.isOS=function(e){return this.getOSName(!0)===String(e).toLowerCase()},t.isPlatform=function(e){return this.getPlatformType(!0)===String(e).toLowerCase()},t.isEngine=function(e){return this.getEngineName(!0)===String(e).toLowerCase()},t.is=function(e,t){return void 0===t&&(t=!1),this.isBrowser(e,t)||this.isOS(e)||this.isPlatform(e)},t.some=function(e){var t=this;return void 0===e&&(e=[]),e.some((function(e){return t.is(e)}))},e}();t.default=d,e.exports=t.default},92:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n};var s=/version\/(\d+(\.?_?\d+)+)/i,a=[{test:[/googlebot/i],describe:function(e){var t={name:"Googlebot"},r=i.default.getFirstMatch(/googlebot\/(\d+(\.\d+))/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/opera/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:opera)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opr\/|opios/i],describe:function(e){var t={name:"Opera"},r=i.default.getFirstMatch(/(?:opr|opios)[\s/](\S+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/SamsungBrowser/i],describe:function(e){var t={name:"Samsung Internet for Android"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:SamsungBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Whale/i],describe:function(e){var t={name:"NAVER Whale Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:whale)[\s/](\d+(?:\.\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MZBrowser/i],describe:function(e){var t={name:"MZ Browser"},r=i.default.getFirstMatch(/(?:MZBrowser)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/focus/i],describe:function(e){var t={name:"Focus"},r=i.default.getFirstMatch(/(?:focus)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/swing/i],describe:function(e){var t={name:"Swing"},r=i.default.getFirstMatch(/(?:swing)[\s/](\d+(?:\.\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/coast/i],describe:function(e){var t={name:"Opera Coast"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:coast)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/opt\/\d+(?:.?_?\d+)+/i],describe:function(e){var t={name:"Opera Touch"},r=i.default.getFirstMatch(/(?:opt)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/yabrowser/i],describe:function(e){var t={name:"Yandex Browser"},r=i.default.getFirstMatch(/(?:yabrowser)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/ucbrowser/i],describe:function(e){var t={name:"UC Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:ucbrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/Maxthon|mxios/i],describe:function(e){var t={name:"Maxthon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:Maxthon|mxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/epiphany/i],describe:function(e){var t={name:"Epiphany"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:epiphany)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/puffin/i],describe:function(e){var t={name:"Puffin"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:puffin)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sleipnir/i],describe:function(e){var t={name:"Sleipnir"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:sleipnir)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/k-meleon/i],describe:function(e){var t={name:"K-Meleon"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/(?:k-meleon)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/micromessenger/i],describe:function(e){var t={name:"WeChat"},r=i.default.getFirstMatch(/(?:micromessenger)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qqbrowser/i],describe:function(e){var t={name:/qqbrowserlite/i.test(e)?"QQ Browser Lite":"QQ Browser"},r=i.default.getFirstMatch(/(?:qqbrowserlite|qqbrowser)[/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/msie|trident/i],describe:function(e){var t={name:"Internet Explorer"},r=i.default.getFirstMatch(/(?:msie |rv:)(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/\sedg\//i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getFirstMatch(/\sedg\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/edg([ea]|ios)/i],describe:function(e){var t={name:"Microsoft Edge"},r=i.default.getSecondMatch(/edg([ea]|ios)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/vivaldi/i],describe:function(e){var t={name:"Vivaldi"},r=i.default.getFirstMatch(/vivaldi\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/seamonkey/i],describe:function(e){var t={name:"SeaMonkey"},r=i.default.getFirstMatch(/seamonkey\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/sailfish/i],describe:function(e){var t={name:"Sailfish"},r=i.default.getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i,e);return r&&(t.version=r),t}},{test:[/silk/i],describe:function(e){var t={name:"Amazon Silk"},r=i.default.getFirstMatch(/silk\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/phantom/i],describe:function(e){var t={name:"PhantomJS"},r=i.default.getFirstMatch(/phantomjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/slimerjs/i],describe:function(e){var t={name:"SlimerJS"},r=i.default.getFirstMatch(/slimerjs\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t={name:"BlackBerry"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/blackberry[\d]+\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t={name:"WebOS Browser"},r=i.default.getFirstMatch(s,e)||i.default.getFirstMatch(/w(?:eb)?[o0]sbrowser\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/bada/i],describe:function(e){var t={name:"Bada"},r=i.default.getFirstMatch(/dolfin\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/tizen/i],describe:function(e){var t={name:"Tizen"},r=i.default.getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/qupzilla/i],describe:function(e){var t={name:"QupZilla"},r=i.default.getFirstMatch(/(?:qupzilla)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/firefox|iceweasel|fxios/i],describe:function(e){var t={name:"Firefox"},r=i.default.getFirstMatch(/(?:firefox|iceweasel|fxios)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/electron/i],describe:function(e){var t={name:"Electron"},r=i.default.getFirstMatch(/(?:electron)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/MiuiBrowser/i],describe:function(e){var t={name:"Miui"},r=i.default.getFirstMatch(/(?:MiuiBrowser)[\s/](\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/chromium/i],describe:function(e){var t={name:"Chromium"},r=i.default.getFirstMatch(/(?:chromium)[\s/](\d+(\.?_?\d+)+)/i,e)||i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/chrome|crios|crmo/i],describe:function(e){var t={name:"Chrome"},r=i.default.getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/GSA/i],describe:function(e){var t={name:"Google Search"},r=i.default.getFirstMatch(/(?:GSA)\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t={name:"Android Browser"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/playstation 4/i],describe:function(e){var t={name:"PlayStation 4"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/safari|applewebkit/i],describe:function(e){var t={name:"Safari"},r=i.default.getFirstMatch(s,e);return r&&(t.version=r),t}},{test:[/.*/i],describe:function(e){var t=-1!==e.search("\\(")?/^(.*)\/(.*)[ \t]\((.*)/:/^(.*)\/(.*) /;return{name:i.default.getFirstMatch(t,e),version:i.default.getSecondMatch(t,e)}}}];t.default=a,e.exports=t.default},93:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/Roku\/DVP/],describe:function(e){var t=i.default.getFirstMatch(/Roku\/DVP-(\d+\.\d+)/i,e);return{name:s.OS_MAP.Roku,version:t}}},{test:[/windows phone/i],describe:function(e){var t=i.default.getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.WindowsPhone,version:t}}},{test:[/windows /i],describe:function(e){var t=i.default.getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i,e),r=i.default.getWindowsVersionName(t);return{name:s.OS_MAP.Windows,version:t,versionName:r}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(e){var t={name:s.OS_MAP.iOS},r=i.default.getSecondMatch(/(Version\/)(\d[\d.]+)/,e);return r&&(t.version=r),t}},{test:[/macintosh/i],describe:function(e){var t=i.default.getFirstMatch(/mac os x (\d+(\.?_?\d+)+)/i,e).replace(/[_\s]/g,"."),r=i.default.getMacOSVersionName(t),n={name:s.OS_MAP.MacOS,version:t};return r&&(n.versionName=r),n}},{test:[/(ipod|iphone|ipad)/i],describe:function(e){var t=i.default.getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i,e).replace(/[_\s]/g,".");return{name:s.OS_MAP.iOS,version:t}}},{test:function(e){var t=!e.test(/like android/i),r=e.test(/android/i);return t&&r},describe:function(e){var t=i.default.getFirstMatch(/android[\s/-](\d+(\.\d+)*)/i,e),r=i.default.getAndroidVersionName(t),n={name:s.OS_MAP.Android,version:t};return r&&(n.versionName=r),n}},{test:[/(web|hpw)[o0]s/i],describe:function(e){var t=i.default.getFirstMatch(/(?:web|hpw)[o0]s\/(\d+(\.\d+)*)/i,e),r={name:s.OS_MAP.WebOS};return t&&t.length&&(r.version=t),r}},{test:[/blackberry|\bbb\d+/i,/rim\stablet/i],describe:function(e){var t=i.default.getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i,e)||i.default.getFirstMatch(/blackberry\d+\/(\d+([_\s]\d+)*)/i,e)||i.default.getFirstMatch(/\bbb(\d+)/i,e);return{name:s.OS_MAP.BlackBerry,version:t}}},{test:[/bada/i],describe:function(e){var t=i.default.getFirstMatch(/bada\/(\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Bada,version:t}}},{test:[/tizen/i],describe:function(e){var t=i.default.getFirstMatch(/tizen[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.Tizen,version:t}}},{test:[/linux/i],describe:function(){return{name:s.OS_MAP.Linux}}},{test:[/CrOS/],describe:function(){return{name:s.OS_MAP.ChromeOS}}},{test:[/PlayStation 4/],describe:function(e){var t=i.default.getFirstMatch(/PlayStation 4[/\s](\d+(\.\d+)*)/i,e);return{name:s.OS_MAP.PlayStation4,version:t}}}];t.default=a,e.exports=t.default},94:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:[/googlebot/i],describe:function(){return{type:"bot",vendor:"Google"}}},{test:[/huawei/i],describe:function(e){var t=i.default.getFirstMatch(/(can-l01)/i,e)&&"Nova",r={type:s.PLATFORMS_MAP.mobile,vendor:"Huawei"};return t&&(r.model=t),r}},{test:[/nexus\s*(?:7|8|9|10).*/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Nexus"}}},{test:[/ipad/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/Macintosh(.*?) FxiOS(.*?)\//],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Apple",model:"iPad"}}},{test:[/kftt build/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon",model:"Kindle Fire HD 7"}}},{test:[/silk/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet,vendor:"Amazon"}}},{test:[/tablet(?! pc)/i],describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){var t=e.test(/ipod|iphone/i),r=e.test(/like (ipod|iphone)/i);return t&&!r},describe:function(e){var t=i.default.getFirstMatch(/(ipod|iphone)/i,e);return{type:s.PLATFORMS_MAP.mobile,vendor:"Apple",model:t}}},{test:[/nexus\s*[0-6].*/i,/galaxy nexus/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Nexus"}}},{test:[/[^-]mobi/i],describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"blackberry"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"BlackBerry"}}},{test:function(e){return"bada"===e.getBrowserName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"windows phone"===e.getBrowserName()},describe:function(){return{type:s.PLATFORMS_MAP.mobile,vendor:"Microsoft"}}},{test:function(e){var t=Number(String(e.getOSVersion()).split(".")[0]);return"android"===e.getOSName(!0)&&t>=3},describe:function(){return{type:s.PLATFORMS_MAP.tablet}}},{test:function(e){return"android"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.mobile}}},{test:function(e){return"macos"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop,vendor:"Apple"}}},{test:function(e){return"windows"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"linux"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.desktop}}},{test:function(e){return"playstation 4"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}},{test:function(e){return"roku"===e.getOSName(!0)},describe:function(){return{type:s.PLATFORMS_MAP.tv}}}];t.default=a,e.exports=t.default},95:function(e,t,r){"use strict";t.__esModule=!0,t.default=void 0;var n,i=(n=r(17))&&n.__esModule?n:{default:n},s=r(18);var a=[{test:function(e){return"microsoft edge"===e.getBrowserName(!0)},describe:function(e){if(/\sedg\//i.test(e))return{name:s.ENGINE_MAP.Blink};var t=i.default.getFirstMatch(/edge\/(\d+(\.?_?\d+)+)/i,e);return{name:s.ENGINE_MAP.EdgeHTML,version:t}}},{test:[/trident/i],describe:function(e){var t={name:s.ENGINE_MAP.Trident},r=i.default.getFirstMatch(/trident\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){return e.test(/presto/i)},describe:function(e){var t={name:s.ENGINE_MAP.Presto},r=i.default.getFirstMatch(/presto\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:function(e){var t=e.test(/gecko/i),r=e.test(/like gecko/i);return t&&!r},describe:function(e){var t={name:s.ENGINE_MAP.Gecko},r=i.default.getFirstMatch(/gecko\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}},{test:[/(apple)?webkit\/537\.36/i],describe:function(){return{name:s.ENGINE_MAP.Blink}}},{test:[/(apple)?webkit/i],describe:function(e){var t={name:s.ENGINE_MAP.WebKit},r=i.default.getFirstMatch(/webkit\/(\d+(\.?_?\d+)+)/i,e);return r&&(t.version=r),t}}];t.default=a,e.exports=t.default}})}));

/***/ }),

/***/ 88500:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";
/*jshint node:true */

var Buffer = (__webpack_require__(48764).Buffer); // browserify
var SlowBuffer = (__webpack_require__(48764).SlowBuffer);

module.exports = bufferEq;

function bufferEq(a, b) {

  // shortcutting on type is necessary for correctness
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    return false;
  }

  // buffer sizes should be well-known information, so despite this
  // shortcutting, it doesn't leak any information about the *contents* of the
  // buffers.
  if (a.length !== b.length) {
    return false;
  }

  var c = 0;
  for (var i = 0; i < a.length; i++) {
    /*jshint bitwise:false */
    c |= a[i] ^ b[i]; // XOR
  }
  return c === 0;
}

bufferEq.install = function() {
  Buffer.prototype.equal = SlowBuffer.prototype.equal = function equal(that) {
    return bufferEq(this, that);
  };
};

var origBufEqual = Buffer.prototype.equal;
var origSlowBufEqual = SlowBuffer.prototype.equal;
bufferEq.restore = function() {
  Buffer.prototype.equal = origBufEqual;
  SlowBuffer.prototype.equal = origSlowBufEqual;
};


/***/ }),

/***/ 48764:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
/* eslint-disable no-proto */



var base64 = __webpack_require__(79742)
var ieee754 = __webpack_require__(80645)
var customInspectSymbol =
  (typeof Symbol === 'function' && typeof Symbol['for'] === 'function') // eslint-disable-line dot-notation
    ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
    : null

exports.Buffer = Buffer
exports.SlowBuffer = SlowBuffer
exports.INSPECT_MAX_BYTES = 50

var K_MAX_LENGTH = 0x7fffffff
exports.kMaxLength = K_MAX_LENGTH

/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */
Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport()

if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' &&
    typeof console.error === 'function') {
  console.error(
    'This browser lacks typed array (Uint8Array) support which is required by ' +
    '`buffer` v5.x. Use `buffer` v4.x if you require old browser support.'
  )
}

function typedArraySupport () {
  // Can typed array instances can be augmented?
  try {
    var arr = new Uint8Array(1)
    var proto = { foo: function () { return 42 } }
    Object.setPrototypeOf(proto, Uint8Array.prototype)
    Object.setPrototypeOf(arr, proto)
    return arr.foo() === 42
  } catch (e) {
    return false
  }
}

Object.defineProperty(Buffer.prototype, 'parent', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.buffer
  }
})

Object.defineProperty(Buffer.prototype, 'offset', {
  enumerable: true,
  get: function () {
    if (!Buffer.isBuffer(this)) return undefined
    return this.byteOffset
  }
})

function createBuffer (length) {
  if (length > K_MAX_LENGTH) {
    throw new RangeError('The value "' + length + '" is invalid for option "size"')
  }
  // Return an augmented `Uint8Array` instance
  var buf = new Uint8Array(length)
  Object.setPrototypeOf(buf, Buffer.prototype)
  return buf
}

/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */

function Buffer (arg, encodingOrOffset, length) {
  // Common case.
  if (typeof arg === 'number') {
    if (typeof encodingOrOffset === 'string') {
      throw new TypeError(
        'The "string" argument must be of type string. Received type number'
      )
    }
    return allocUnsafe(arg)
  }
  return from(arg, encodingOrOffset, length)
}

Buffer.poolSize = 8192 // not used by this implementation

function from (value, encodingOrOffset, length) {
  if (typeof value === 'string') {
    return fromString(value, encodingOrOffset)
  }

  if (ArrayBuffer.isView(value)) {
    return fromArrayView(value)
  }

  if (value == null) {
    throw new TypeError(
      'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
      'or Array-like Object. Received type ' + (typeof value)
    )
  }

  if (isInstance(value, ArrayBuffer) ||
      (value && isInstance(value.buffer, ArrayBuffer))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof SharedArrayBuffer !== 'undefined' &&
      (isInstance(value, SharedArrayBuffer) ||
      (value && isInstance(value.buffer, SharedArrayBuffer)))) {
    return fromArrayBuffer(value, encodingOrOffset, length)
  }

  if (typeof value === 'number') {
    throw new TypeError(
      'The "value" argument must not be of type number. Received type number'
    )
  }

  var valueOf = value.valueOf && value.valueOf()
  if (valueOf != null && valueOf !== value) {
    return Buffer.from(valueOf, encodingOrOffset, length)
  }

  var b = fromObject(value)
  if (b) return b

  if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null &&
      typeof value[Symbol.toPrimitive] === 'function') {
    return Buffer.from(
      value[Symbol.toPrimitive]('string'), encodingOrOffset, length
    )
  }

  throw new TypeError(
    'The first argument must be one of type string, Buffer, ArrayBuffer, Array, ' +
    'or Array-like Object. Received type ' + (typeof value)
  )
}

/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/
Buffer.from = function (value, encodingOrOffset, length) {
  return from(value, encodingOrOffset, length)
}

// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype)
Object.setPrototypeOf(Buffer, Uint8Array)

function assertSize (size) {
  if (typeof size !== 'number') {
    throw new TypeError('"size" argument must be of type number')
  } else if (size < 0) {
    throw new RangeError('The value "' + size + '" is invalid for option "size"')
  }
}

function alloc (size, fill, encoding) {
  assertSize(size)
  if (size <= 0) {
    return createBuffer(size)
  }
  if (fill !== undefined) {
    // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string'
      ? createBuffer(size).fill(fill, encoding)
      : createBuffer(size).fill(fill)
  }
  return createBuffer(size)
}

/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/
Buffer.alloc = function (size, fill, encoding) {
  return alloc(size, fill, encoding)
}

function allocUnsafe (size) {
  assertSize(size)
  return createBuffer(size < 0 ? 0 : checked(size) | 0)
}

/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */
Buffer.allocUnsafe = function (size) {
  return allocUnsafe(size)
}
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */
Buffer.allocUnsafeSlow = function (size) {
  return allocUnsafe(size)
}

function fromString (string, encoding) {
  if (typeof encoding !== 'string' || encoding === '') {
    encoding = 'utf8'
  }

  if (!Buffer.isEncoding(encoding)) {
    throw new TypeError('Unknown encoding: ' + encoding)
  }

  var length = byteLength(string, encoding) | 0
  var buf = createBuffer(length)

  var actual = buf.write(string, encoding)

  if (actual !== length) {
    // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual)
  }

  return buf
}

function fromArrayLike (array) {
  var length = array.length < 0 ? 0 : checked(array.length) | 0
  var buf = createBuffer(length)
  for (var i = 0; i < length; i += 1) {
    buf[i] = array[i] & 255
  }
  return buf
}

function fromArrayView (arrayView) {
  if (isInstance(arrayView, Uint8Array)) {
    var copy = new Uint8Array(arrayView)
    return fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength)
  }
  return fromArrayLike(arrayView)
}

function fromArrayBuffer (array, byteOffset, length) {
  if (byteOffset < 0 || array.byteLength < byteOffset) {
    throw new RangeError('"offset" is outside of buffer bounds')
  }

  if (array.byteLength < byteOffset + (length || 0)) {
    throw new RangeError('"length" is outside of buffer bounds')
  }

  var buf
  if (byteOffset === undefined && length === undefined) {
    buf = new Uint8Array(array)
  } else if (length === undefined) {
    buf = new Uint8Array(array, byteOffset)
  } else {
    buf = new Uint8Array(array, byteOffset, length)
  }

  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(buf, Buffer.prototype)

  return buf
}

function fromObject (obj) {
  if (Buffer.isBuffer(obj)) {
    var len = checked(obj.length) | 0
    var buf = createBuffer(len)

    if (buf.length === 0) {
      return buf
    }

    obj.copy(buf, 0, 0, len)
    return buf
  }

  if (obj.length !== undefined) {
    if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) {
      return createBuffer(0)
    }
    return fromArrayLike(obj)
  }

  if (obj.type === 'Buffer' && Array.isArray(obj.data)) {
    return fromArrayLike(obj.data)
  }
}

function checked (length) {
  // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
  // length is NaN (which is otherwise coerced to zero.)
  if (length >= K_MAX_LENGTH) {
    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
                         'size: 0x' + K_MAX_LENGTH.toString(16) + ' bytes')
  }
  return length | 0
}

function SlowBuffer (length) {
  if (+length != length) { // eslint-disable-line eqeqeq
    length = 0
  }
  return Buffer.alloc(+length)
}

Buffer.isBuffer = function isBuffer (b) {
  return b != null && b._isBuffer === true &&
    b !== Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
}

Buffer.compare = function compare (a, b) {
  if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength)
  if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength)
  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
    throw new TypeError(
      'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
    )
  }

  if (a === b) return 0

  var x = a.length
  var y = b.length

  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
    if (a[i] !== b[i]) {
      x = a[i]
      y = b[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

Buffer.isEncoding = function isEncoding (encoding) {
  switch (String(encoding).toLowerCase()) {
    case 'hex':
    case 'utf8':
    case 'utf-8':
    case 'ascii':
    case 'latin1':
    case 'binary':
    case 'base64':
    case 'ucs2':
    case 'ucs-2':
    case 'utf16le':
    case 'utf-16le':
      return true
    default:
      return false
  }
}

Buffer.concat = function concat (list, length) {
  if (!Array.isArray(list)) {
    throw new TypeError('"list" argument must be an Array of Buffers')
  }

  if (list.length === 0) {
    return Buffer.alloc(0)
  }

  var i
  if (length === undefined) {
    length = 0
    for (i = 0; i < list.length; ++i) {
      length += list[i].length
    }
  }

  var buffer = Buffer.allocUnsafe(length)
  var pos = 0
  for (i = 0; i < list.length; ++i) {
    var buf = list[i]
    if (isInstance(buf, Uint8Array)) {
      if (pos + buf.length > buffer.length) {
        Buffer.from(buf).copy(buffer, pos)
      } else {
        Uint8Array.prototype.set.call(
          buffer,
          buf,
          pos
        )
      }
    } else if (!Buffer.isBuffer(buf)) {
      throw new TypeError('"list" argument must be an Array of Buffers')
    } else {
      buf.copy(buffer, pos)
    }
    pos += buf.length
  }
  return buffer
}

function byteLength (string, encoding) {
  if (Buffer.isBuffer(string)) {
    return string.length
  }
  if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) {
    return string.byteLength
  }
  if (typeof string !== 'string') {
    throw new TypeError(
      'The "string" argument must be one of type string, Buffer, or ArrayBuffer. ' +
      'Received type ' + typeof string
    )
  }

  var len = string.length
  var mustMatch = (arguments.length > 2 && arguments[2] === true)
  if (!mustMatch && len === 0) return 0

  // Use a for loop to avoid recursion
  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'ascii':
      case 'latin1':
      case 'binary':
        return len
      case 'utf8':
      case 'utf-8':
        return utf8ToBytes(string).length
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return len * 2
      case 'hex':
        return len >>> 1
      case 'base64':
        return base64ToBytes(string).length
      default:
        if (loweredCase) {
          return mustMatch ? -1 : utf8ToBytes(string).length // assume utf8
        }
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}
Buffer.byteLength = byteLength

function slowToString (encoding, start, end) {
  var loweredCase = false

  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
  // property of a typed array.

  // This behaves neither like String nor Uint8Array in that we set start/end
  // to their upper/lower bounds if the value passed is out of range.
  // undefined is handled specially as per ECMA-262 6th Edition,
  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
  if (start === undefined || start < 0) {
    start = 0
  }
  // Return early if start > this.length. Done here to prevent potential uint32
  // coercion fail below.
  if (start > this.length) {
    return ''
  }

  if (end === undefined || end > this.length) {
    end = this.length
  }

  if (end <= 0) {
    return ''
  }

  // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
  end >>>= 0
  start >>>= 0

  if (end <= start) {
    return ''
  }

  if (!encoding) encoding = 'utf8'

  while (true) {
    switch (encoding) {
      case 'hex':
        return hexSlice(this, start, end)

      case 'utf8':
      case 'utf-8':
        return utf8Slice(this, start, end)

      case 'ascii':
        return asciiSlice(this, start, end)

      case 'latin1':
      case 'binary':
        return latin1Slice(this, start, end)

      case 'base64':
        return base64Slice(this, start, end)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return utf16leSlice(this, start, end)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = (encoding + '').toLowerCase()
        loweredCase = true
    }
  }
}

// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
Buffer.prototype._isBuffer = true

function swap (b, n, m) {
  var i = b[n]
  b[n] = b[m]
  b[m] = i
}

Buffer.prototype.swap16 = function swap16 () {
  var len = this.length
  if (len % 2 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 16-bits')
  }
  for (var i = 0; i < len; i += 2) {
    swap(this, i, i + 1)
  }
  return this
}

Buffer.prototype.swap32 = function swap32 () {
  var len = this.length
  if (len % 4 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 32-bits')
  }
  for (var i = 0; i < len; i += 4) {
    swap(this, i, i + 3)
    swap(this, i + 1, i + 2)
  }
  return this
}

Buffer.prototype.swap64 = function swap64 () {
  var len = this.length
  if (len % 8 !== 0) {
    throw new RangeError('Buffer size must be a multiple of 64-bits')
  }
  for (var i = 0; i < len; i += 8) {
    swap(this, i, i + 7)
    swap(this, i + 1, i + 6)
    swap(this, i + 2, i + 5)
    swap(this, i + 3, i + 4)
  }
  return this
}

Buffer.prototype.toString = function toString () {
  var length = this.length
  if (length === 0) return ''
  if (arguments.length === 0) return utf8Slice(this, 0, length)
  return slowToString.apply(this, arguments)
}

Buffer.prototype.toLocaleString = Buffer.prototype.toString

Buffer.prototype.equals = function equals (b) {
  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
  if (this === b) return true
  return Buffer.compare(this, b) === 0
}

Buffer.prototype.inspect = function inspect () {
  var str = ''
  var max = exports.INSPECT_MAX_BYTES
  str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim()
  if (this.length > max) str += ' ... '
  return '<Buffer ' + str + '>'
}
if (customInspectSymbol) {
  Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect
}

Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
  if (isInstance(target, Uint8Array)) {
    target = Buffer.from(target, target.offset, target.byteLength)
  }
  if (!Buffer.isBuffer(target)) {
    throw new TypeError(
      'The "target" argument must be one of type Buffer or Uint8Array. ' +
      'Received type ' + (typeof target)
    )
  }

  if (start === undefined) {
    start = 0
  }
  if (end === undefined) {
    end = target ? target.length : 0
  }
  if (thisStart === undefined) {
    thisStart = 0
  }
  if (thisEnd === undefined) {
    thisEnd = this.length
  }

  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
    throw new RangeError('out of range index')
  }

  if (thisStart >= thisEnd && start >= end) {
    return 0
  }
  if (thisStart >= thisEnd) {
    return -1
  }
  if (start >= end) {
    return 1
  }

  start >>>= 0
  end >>>= 0
  thisStart >>>= 0
  thisEnd >>>= 0

  if (this === target) return 0

  var x = thisEnd - thisStart
  var y = end - start
  var len = Math.min(x, y)

  var thisCopy = this.slice(thisStart, thisEnd)
  var targetCopy = target.slice(start, end)

  for (var i = 0; i < len; ++i) {
    if (thisCopy[i] !== targetCopy[i]) {
      x = thisCopy[i]
      y = targetCopy[i]
      break
    }
  }

  if (x < y) return -1
  if (y < x) return 1
  return 0
}

// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
  // Empty buffer means no match
  if (buffer.length === 0) return -1

  // Normalize byteOffset
  if (typeof byteOffset === 'string') {
    encoding = byteOffset
    byteOffset = 0
  } else if (byteOffset > 0x7fffffff) {
    byteOffset = 0x7fffffff
  } else if (byteOffset < -0x80000000) {
    byteOffset = -0x80000000
  }
  byteOffset = +byteOffset // Coerce to Number.
  if (numberIsNaN(byteOffset)) {
    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : (buffer.length - 1)
  }

  // Normalize byteOffset: negative offsets start from the end of the buffer
  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
  if (byteOffset >= buffer.length) {
    if (dir) return -1
    else byteOffset = buffer.length - 1
  } else if (byteOffset < 0) {
    if (dir) byteOffset = 0
    else return -1
  }

  // Normalize val
  if (typeof val === 'string') {
    val = Buffer.from(val, encoding)
  }

  // Finally, search either indexOf (if dir is true) or lastIndexOf
  if (Buffer.isBuffer(val)) {
    // Special case: looking for empty string/buffer always fails
    if (val.length === 0) {
      return -1
    }
    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
  } else if (typeof val === 'number') {
    val = val & 0xFF // Search for a byte value [0-255]
    if (typeof Uint8Array.prototype.indexOf === 'function') {
      if (dir) {
        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
      } else {
        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
      }
    }
    return arrayIndexOf(buffer, [val], byteOffset, encoding, dir)
  }

  throw new TypeError('val must be string, number or Buffer')
}

function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
  var indexSize = 1
  var arrLength = arr.length
  var valLength = val.length

  if (encoding !== undefined) {
    encoding = String(encoding).toLowerCase()
    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
        encoding === 'utf16le' || encoding === 'utf-16le') {
      if (arr.length < 2 || val.length < 2) {
        return -1
      }
      indexSize = 2
      arrLength /= 2
      valLength /= 2
      byteOffset /= 2
    }
  }

  function read (buf, i) {
    if (indexSize === 1) {
      return buf[i]
    } else {
      return buf.readUInt16BE(i * indexSize)
    }
  }

  var i
  if (dir) {
    var foundIndex = -1
    for (i = byteOffset; i < arrLength; i++) {
      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
        if (foundIndex === -1) foundIndex = i
        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
      } else {
        if (foundIndex !== -1) i -= i - foundIndex
        foundIndex = -1
      }
    }
  } else {
    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
    for (i = byteOffset; i >= 0; i--) {
      var found = true
      for (var j = 0; j < valLength; j++) {
        if (read(arr, i + j) !== read(val, j)) {
          found = false
          break
        }
      }
      if (found) return i
    }
  }

  return -1
}

Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
  return this.indexOf(val, byteOffset, encoding) !== -1
}

Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
}

Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
}

function hexWrite (buf, string, offset, length) {
  offset = Number(offset) || 0
  var remaining = buf.length - offset
  if (!length) {
    length = remaining
  } else {
    length = Number(length)
    if (length > remaining) {
      length = remaining
    }
  }

  var strLen = string.length

  if (length > strLen / 2) {
    length = strLen / 2
  }
  for (var i = 0; i < length; ++i) {
    var parsed = parseInt(string.substr(i * 2, 2), 16)
    if (numberIsNaN(parsed)) return i
    buf[offset + i] = parsed
  }
  return i
}

function utf8Write (buf, string, offset, length) {
  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
}

function asciiWrite (buf, string, offset, length) {
  return blitBuffer(asciiToBytes(string), buf, offset, length)
}

function base64Write (buf, string, offset, length) {
  return blitBuffer(base64ToBytes(string), buf, offset, length)
}

function ucs2Write (buf, string, offset, length) {
  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
}

Buffer.prototype.write = function write (string, offset, length, encoding) {
  // Buffer#write(string)
  if (offset === undefined) {
    encoding = 'utf8'
    length = this.length
    offset = 0
  // Buffer#write(string, encoding)
  } else if (length === undefined && typeof offset === 'string') {
    encoding = offset
    length = this.length
    offset = 0
  // Buffer#write(string, offset[, length][, encoding])
  } else if (isFinite(offset)) {
    offset = offset >>> 0
    if (isFinite(length)) {
      length = length >>> 0
      if (encoding === undefined) encoding = 'utf8'
    } else {
      encoding = length
      length = undefined
    }
  } else {
    throw new Error(
      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
    )
  }

  var remaining = this.length - offset
  if (length === undefined || length > remaining) length = remaining

  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
    throw new RangeError('Attempt to write outside buffer bounds')
  }

  if (!encoding) encoding = 'utf8'

  var loweredCase = false
  for (;;) {
    switch (encoding) {
      case 'hex':
        return hexWrite(this, string, offset, length)

      case 'utf8':
      case 'utf-8':
        return utf8Write(this, string, offset, length)

      case 'ascii':
      case 'latin1':
      case 'binary':
        return asciiWrite(this, string, offset, length)

      case 'base64':
        // Warning: maxLength not taken into account in base64Write
        return base64Write(this, string, offset, length)

      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return ucs2Write(this, string, offset, length)

      default:
        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
        encoding = ('' + encoding).toLowerCase()
        loweredCase = true
    }
  }
}

Buffer.prototype.toJSON = function toJSON () {
  return {
    type: 'Buffer',
    data: Array.prototype.slice.call(this._arr || this, 0)
  }
}

function base64Slice (buf, start, end) {
  if (start === 0 && end === buf.length) {
    return base64.fromByteArray(buf)
  } else {
    return base64.fromByteArray(buf.slice(start, end))
  }
}

function utf8Slice (buf, start, end) {
  end = Math.min(buf.length, end)
  var res = []

  var i = start
  while (i < end) {
    var firstByte = buf[i]
    var codePoint = null
    var bytesPerSequence = (firstByte > 0xEF)
      ? 4
      : (firstByte > 0xDF)
          ? 3
          : (firstByte > 0xBF)
              ? 2
              : 1

    if (i + bytesPerSequence <= end) {
      var secondByte, thirdByte, fourthByte, tempCodePoint

      switch (bytesPerSequence) {
        case 1:
          if (firstByte < 0x80) {
            codePoint = firstByte
          }
          break
        case 2:
          secondByte = buf[i + 1]
          if ((secondByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
            if (tempCodePoint > 0x7F) {
              codePoint = tempCodePoint
            }
          }
          break
        case 3:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
              codePoint = tempCodePoint
            }
          }
          break
        case 4:
          secondByte = buf[i + 1]
          thirdByte = buf[i + 2]
          fourthByte = buf[i + 3]
          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
              codePoint = tempCodePoint
            }
          }
      }
    }

    if (codePoint === null) {
      // we did not generate a valid codePoint so insert a
      // replacement char (U+FFFD) and advance only 1 byte
      codePoint = 0xFFFD
      bytesPerSequence = 1
    } else if (codePoint > 0xFFFF) {
      // encode to utf16 (surrogate pair dance)
      codePoint -= 0x10000
      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
      codePoint = 0xDC00 | codePoint & 0x3FF
    }

    res.push(codePoint)
    i += bytesPerSequence
  }

  return decodeCodePointsArray(res)
}

// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
var MAX_ARGUMENTS_LENGTH = 0x1000

function decodeCodePointsArray (codePoints) {
  var len = codePoints.length
  if (len <= MAX_ARGUMENTS_LENGTH) {
    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
  }

  // Decode in chunks to avoid "call stack size exceeded".
  var res = ''
  var i = 0
  while (i < len) {
    res += String.fromCharCode.apply(
      String,
      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
    )
  }
  return res
}

function asciiSlice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i] & 0x7F)
  }
  return ret
}

function latin1Slice (buf, start, end) {
  var ret = ''
  end = Math.min(buf.length, end)

  for (var i = start; i < end; ++i) {
    ret += String.fromCharCode(buf[i])
  }
  return ret
}

function hexSlice (buf, start, end) {
  var len = buf.length

  if (!start || start < 0) start = 0
  if (!end || end < 0 || end > len) end = len

  var out = ''
  for (var i = start; i < end; ++i) {
    out += hexSliceLookupTable[buf[i]]
  }
  return out
}

function utf16leSlice (buf, start, end) {
  var bytes = buf.slice(start, end)
  var res = ''
  // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
  for (var i = 0; i < bytes.length - 1; i += 2) {
    res += String.fromCharCode(bytes[i] + (bytes[i + 1] * 256))
  }
  return res
}

Buffer.prototype.slice = function slice (start, end) {
  var len = this.length
  start = ~~start
  end = end === undefined ? len : ~~end

  if (start < 0) {
    start += len
    if (start < 0) start = 0
  } else if (start > len) {
    start = len
  }

  if (end < 0) {
    end += len
    if (end < 0) end = 0
  } else if (end > len) {
    end = len
  }

  if (end < start) end = start

  var newBuf = this.subarray(start, end)
  // Return an augmented `Uint8Array` instance
  Object.setPrototypeOf(newBuf, Buffer.prototype)

  return newBuf
}

/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */
function checkOffset (offset, ext, length) {
  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
}

Buffer.prototype.readUintLE =
Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }

  return val
}

Buffer.prototype.readUintBE =
Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    checkOffset(offset, byteLength, this.length)
  }

  var val = this[offset + --byteLength]
  var mul = 1
  while (byteLength > 0 && (mul *= 0x100)) {
    val += this[offset + --byteLength] * mul
  }

  return val
}

Buffer.prototype.readUint8 =
Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  return this[offset]
}

Buffer.prototype.readUint16LE =
Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return this[offset] | (this[offset + 1] << 8)
}

Buffer.prototype.readUint16BE =
Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  return (this[offset] << 8) | this[offset + 1]
}

Buffer.prototype.readUint32LE =
Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return ((this[offset]) |
      (this[offset + 1] << 8) |
      (this[offset + 2] << 16)) +
      (this[offset + 3] * 0x1000000)
}

Buffer.prototype.readUint32BE =
Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] * 0x1000000) +
    ((this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    this[offset + 3])
}

Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var val = this[offset]
  var mul = 1
  var i = 0
  while (++i < byteLength && (mul *= 0x100)) {
    val += this[offset + i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) checkOffset(offset, byteLength, this.length)

  var i = byteLength
  var mul = 1
  var val = this[offset + --i]
  while (i > 0 && (mul *= 0x100)) {
    val += this[offset + --i] * mul
  }
  mul *= 0x80

  if (val >= mul) val -= Math.pow(2, 8 * byteLength)

  return val
}

Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 1, this.length)
  if (!(this[offset] & 0x80)) return (this[offset])
  return ((0xff - this[offset] + 1) * -1)
}

Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset] | (this[offset + 1] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 2, this.length)
  var val = this[offset + 1] | (this[offset] << 8)
  return (val & 0x8000) ? val | 0xFFFF0000 : val
}

Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset]) |
    (this[offset + 1] << 8) |
    (this[offset + 2] << 16) |
    (this[offset + 3] << 24)
}

Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)

  return (this[offset] << 24) |
    (this[offset + 1] << 16) |
    (this[offset + 2] << 8) |
    (this[offset + 3])
}

Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, true, 23, 4)
}

Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 4, this.length)
  return ieee754.read(this, offset, false, 23, 4)
}

Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, true, 52, 8)
}

Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
  offset = offset >>> 0
  if (!noAssert) checkOffset(offset, 8, this.length)
  return ieee754.read(this, offset, false, 52, 8)
}

function checkInt (buf, value, offset, ext, max, min) {
  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
}

Buffer.prototype.writeUintLE =
Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var mul = 1
  var i = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUintBE =
Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  byteLength = byteLength >>> 0
  if (!noAssert) {
    var maxBytes = Math.pow(2, 8 * byteLength) - 1
    checkInt(this, value, offset, byteLength, maxBytes, 0)
  }

  var i = byteLength - 1
  var mul = 1
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    this[offset + i] = (value / mul) & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeUint8 =
Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeUint16LE =
Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeUint16BE =
Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeUint32LE =
Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset + 3] = (value >>> 24)
  this[offset + 2] = (value >>> 16)
  this[offset + 1] = (value >>> 8)
  this[offset] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeUint32BE =
Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = 0
  var mul = 1
  var sub = 0
  this[offset] = value & 0xFF
  while (++i < byteLength && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    var limit = Math.pow(2, (8 * byteLength) - 1)

    checkInt(this, value, offset, byteLength, limit - 1, -limit)
  }

  var i = byteLength - 1
  var mul = 1
  var sub = 0
  this[offset + i] = value & 0xFF
  while (--i >= 0 && (mul *= 0x100)) {
    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
      sub = 1
    }
    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
  }

  return offset + byteLength
}

Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
  if (value < 0) value = 0xff + value + 1
  this[offset] = (value & 0xff)
  return offset + 1
}

Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  return offset + 2
}

Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
  this[offset] = (value >>> 8)
  this[offset + 1] = (value & 0xff)
  return offset + 2
}

Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  this[offset] = (value & 0xff)
  this[offset + 1] = (value >>> 8)
  this[offset + 2] = (value >>> 16)
  this[offset + 3] = (value >>> 24)
  return offset + 4
}

Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
  if (value < 0) value = 0xffffffff + value + 1
  this[offset] = (value >>> 24)
  this[offset + 1] = (value >>> 16)
  this[offset + 2] = (value >>> 8)
  this[offset + 3] = (value & 0xff)
  return offset + 4
}

function checkIEEE754 (buf, value, offset, ext, max, min) {
  if (offset + ext > buf.length) throw new RangeError('Index out of range')
  if (offset < 0) throw new RangeError('Index out of range')
}

function writeFloat (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
  }
  ieee754.write(buf, value, offset, littleEndian, 23, 4)
  return offset + 4
}

Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
  return writeFloat(this, value, offset, true, noAssert)
}

Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
  return writeFloat(this, value, offset, false, noAssert)
}

function writeDouble (buf, value, offset, littleEndian, noAssert) {
  value = +value
  offset = offset >>> 0
  if (!noAssert) {
    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
  }
  ieee754.write(buf, value, offset, littleEndian, 52, 8)
  return offset + 8
}

Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
  return writeDouble(this, value, offset, true, noAssert)
}

Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
  return writeDouble(this, value, offset, false, noAssert)
}

// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
Buffer.prototype.copy = function copy (target, targetStart, start, end) {
  if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer')
  if (!start) start = 0
  if (!end && end !== 0) end = this.length
  if (targetStart >= target.length) targetStart = target.length
  if (!targetStart) targetStart = 0
  if (end > 0 && end < start) end = start

  // Copy 0 bytes; we're done
  if (end === start) return 0
  if (target.length === 0 || this.length === 0) return 0

  // Fatal error conditions
  if (targetStart < 0) {
    throw new RangeError('targetStart out of bounds')
  }
  if (start < 0 || start >= this.length) throw new RangeError('Index out of range')
  if (end < 0) throw new RangeError('sourceEnd out of bounds')

  // Are we oob?
  if (end > this.length) end = this.length
  if (target.length - targetStart < end - start) {
    end = target.length - targetStart + start
  }

  var len = end - start

  if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') {
    // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end)
  } else {
    Uint8Array.prototype.set.call(
      target,
      this.subarray(start, end),
      targetStart
    )
  }

  return len
}

// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
Buffer.prototype.fill = function fill (val, start, end, encoding) {
  // Handle string cases:
  if (typeof val === 'string') {
    if (typeof start === 'string') {
      encoding = start
      start = 0
      end = this.length
    } else if (typeof end === 'string') {
      encoding = end
      end = this.length
    }
    if (encoding !== undefined && typeof encoding !== 'string') {
      throw new TypeError('encoding must be a string')
    }
    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
      throw new TypeError('Unknown encoding: ' + encoding)
    }
    if (val.length === 1) {
      var code = val.charCodeAt(0)
      if ((encoding === 'utf8' && code < 128) ||
          encoding === 'latin1') {
        // Fast path: If `val` fits into a single byte, use that numeric value.
        val = code
      }
    }
  } else if (typeof val === 'number') {
    val = val & 255
  } else if (typeof val === 'boolean') {
    val = Number(val)
  }

  // Invalid ranges are not set to a default, so can range check early.
  if (start < 0 || this.length < start || this.length < end) {
    throw new RangeError('Out of range index')
  }

  if (end <= start) {
    return this
  }

  start = start >>> 0
  end = end === undefined ? this.length : end >>> 0

  if (!val) val = 0

  var i
  if (typeof val === 'number') {
    for (i = start; i < end; ++i) {
      this[i] = val
    }
  } else {
    var bytes = Buffer.isBuffer(val)
      ? val
      : Buffer.from(val, encoding)
    var len = bytes.length
    if (len === 0) {
      throw new TypeError('The value "' + val +
        '" is invalid for argument "value"')
    }
    for (i = 0; i < end - start; ++i) {
      this[i + start] = bytes[i % len]
    }
  }

  return this
}

// HELPER FUNCTIONS
// ================

var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g

function base64clean (str) {
  // Node takes equal signs as end of the Base64 encoding
  str = str.split('=')[0]
  // Node strips out invalid characters like \n and \t from the string, base64-js does not
  str = str.trim().replace(INVALID_BASE64_RE, '')
  // Node converts strings with length < 2 to ''
  if (str.length < 2) return ''
  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
  while (str.length % 4 !== 0) {
    str = str + '='
  }
  return str
}

function utf8ToBytes (string, units) {
  units = units || Infinity
  var codePoint
  var length = string.length
  var leadSurrogate = null
  var bytes = []

  for (var i = 0; i < length; ++i) {
    codePoint = string.charCodeAt(i)

    // is surrogate component
    if (codePoint > 0xD7FF && codePoint < 0xE000) {
      // last char was a lead
      if (!leadSurrogate) {
        // no lead yet
        if (codePoint > 0xDBFF) {
          // unexpected trail
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        } else if (i + 1 === length) {
          // unpaired lead
          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
          continue
        }

        // valid lead
        leadSurrogate = codePoint

        continue
      }

      // 2 leads in a row
      if (codePoint < 0xDC00) {
        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
        leadSurrogate = codePoint
        continue
      }

      // valid surrogate pair
      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
    } else if (leadSurrogate) {
      // valid bmp char, but last char was a lead
      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
    }

    leadSurrogate = null

    // encode utf8
    if (codePoint < 0x80) {
      if ((units -= 1) < 0) break
      bytes.push(codePoint)
    } else if (codePoint < 0x800) {
      if ((units -= 2) < 0) break
      bytes.push(
        codePoint >> 0x6 | 0xC0,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x10000) {
      if ((units -= 3) < 0) break
      bytes.push(
        codePoint >> 0xC | 0xE0,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else if (codePoint < 0x110000) {
      if ((units -= 4) < 0) break
      bytes.push(
        codePoint >> 0x12 | 0xF0,
        codePoint >> 0xC & 0x3F | 0x80,
        codePoint >> 0x6 & 0x3F | 0x80,
        codePoint & 0x3F | 0x80
      )
    } else {
      throw new Error('Invalid code point')
    }
  }

  return bytes
}

function asciiToBytes (str) {
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    // Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF)
  }
  return byteArray
}

function utf16leToBytes (str, units) {
  var c, hi, lo
  var byteArray = []
  for (var i = 0; i < str.length; ++i) {
    if ((units -= 2) < 0) break

    c = str.charCodeAt(i)
    hi = c >> 8
    lo = c % 256
    byteArray.push(lo)
    byteArray.push(hi)
  }

  return byteArray
}

function base64ToBytes (str) {
  return base64.toByteArray(base64clean(str))
}

function blitBuffer (src, dst, offset, length) {
  for (var i = 0; i < length; ++i) {
    if ((i + offset >= dst.length) || (i >= src.length)) break
    dst[i + offset] = src[i]
  }
  return i
}

// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function isInstance (obj, type) {
  return obj instanceof type ||
    (obj != null && obj.constructor != null && obj.constructor.name != null &&
      obj.constructor.name === type.name)
}
function numberIsNaN (obj) {
  // For IE11 support
  return obj !== obj // eslint-disable-line no-self-compare
}

// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
var hexSliceLookupTable = (function () {
  var alphabet = '0123456789abcdef'
  var table = new Array(256)
  for (var i = 0; i < 16; ++i) {
    var i16 = i * 16
    for (var j = 0; j < 16; ++j) {
      table[i16 + j] = alphabet[i] + alphabet[j]
    }
  }
  return table
})()


/***/ }),

/***/ 11227:
/***/ (function(module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
/* eslint-env browser */

/**
 * This is the web browser implementation of `debug()`.
 */

exports.formatArgs = formatArgs;
exports.save = save;
exports.load = load;
exports.useColors = useColors;
exports.storage = localstorage();
exports.destroy = (() => {
	let warned = false;

	return () => {
		if (!warned) {
			warned = true;
			console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
		}
	};
})();

/**
 * Colors.
 */

exports.colors = [
	'#0000CC',
	'#0000FF',
	'#0033CC',
	'#0033FF',
	'#0066CC',
	'#0066FF',
	'#0099CC',
	'#0099FF',
	'#00CC00',
	'#00CC33',
	'#00CC66',
	'#00CC99',
	'#00CCCC',
	'#00CCFF',
	'#3300CC',
	'#3300FF',
	'#3333CC',
	'#3333FF',
	'#3366CC',
	'#3366FF',
	'#3399CC',
	'#3399FF',
	'#33CC00',
	'#33CC33',
	'#33CC66',
	'#33CC99',
	'#33CCCC',
	'#33CCFF',
	'#6600CC',
	'#6600FF',
	'#6633CC',
	'#6633FF',
	'#66CC00',
	'#66CC33',
	'#9900CC',
	'#9900FF',
	'#9933CC',
	'#9933FF',
	'#99CC00',
	'#99CC33',
	'#CC0000',
	'#CC0033',
	'#CC0066',
	'#CC0099',
	'#CC00CC',
	'#CC00FF',
	'#CC3300',
	'#CC3333',
	'#CC3366',
	'#CC3399',
	'#CC33CC',
	'#CC33FF',
	'#CC6600',
	'#CC6633',
	'#CC9900',
	'#CC9933',
	'#CCCC00',
	'#CCCC33',
	'#FF0000',
	'#FF0033',
	'#FF0066',
	'#FF0099',
	'#FF00CC',
	'#FF00FF',
	'#FF3300',
	'#FF3333',
	'#FF3366',
	'#FF3399',
	'#FF33CC',
	'#FF33FF',
	'#FF6600',
	'#FF6633',
	'#FF9900',
	'#FF9933',
	'#FFCC00',
	'#FFCC33'
];

/**
 * Currently only WebKit-based Web Inspectors, Firefox >= v31,
 * and the Firebug extension (any Firefox version) are known
 * to support "%c" CSS customizations.
 *
 * TODO: add a `localStorage` variable to explicitly enable/disable colors
 */

// eslint-disable-next-line complexity
function useColors() {
	// NB: In an Electron preload script, document will be defined but not fully
	// initialized. Since we know we're in Chrome, we'll just detect this case
	// explicitly
	if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
		return true;
	}

	// Internet Explorer and Edge do not support colors.
	if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
		return false;
	}

	// Is webkit? http://stackoverflow.com/a/16459606/376773
	// document is undefined in react-native: https://github.com/facebook/react-native/pull/1632
	return (typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance) ||
		// Is firebug? http://stackoverflow.com/a/398120/376773
		(typeof window !== 'undefined' && window.console && (window.console.firebug || (window.console.exception && window.console.table))) ||
		// Is firefox >= v31?
		// https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31) ||
		// Double check webkit in userAgent just in case we are in a worker
		(typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/));
}

/**
 * Colorize log arguments if enabled.
 *
 * @api public
 */

function formatArgs(args) {
	args[0] = (this.useColors ? '%c' : '') +
		this.namespace +
		(this.useColors ? ' %c' : ' ') +
		args[0] +
		(this.useColors ? '%c ' : ' ') +
		'+' + module.exports.humanize(this.diff);

	if (!this.useColors) {
		return;
	}

	const c = 'color: ' + this.color;
	args.splice(1, 0, c, 'color: inherit');

	// The final "%c" is somewhat tricky, because there could be other
	// arguments passed either before or after the %c, so we need to
	// figure out the correct index to insert the CSS into
	let index = 0;
	let lastC = 0;
	args[0].replace(/%[a-zA-Z%]/g, match => {
		if (match === '%%') {
			return;
		}
		index++;
		if (match === '%c') {
			// We only are interested in the *last* %c
			// (the user may have provided their own)
			lastC = index;
		}
	});

	args.splice(lastC, 0, c);
}

/**
 * Invokes `console.debug()` when available.
 * No-op when `console.debug` is not a "function".
 * If `console.debug` is not available, falls back
 * to `console.log`.
 *
 * @api public
 */
exports.log = console.debug || console.log || (() => {});

/**
 * Save `namespaces`.
 *
 * @param {String} namespaces
 * @api private
 */
function save(namespaces) {
	try {
		if (namespaces) {
			exports.storage.setItem('debug', namespaces);
		} else {
			exports.storage.removeItem('debug');
		}
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

/**
 * Load `namespaces`.
 *
 * @return {String} returns the previously persisted debug modes
 * @api private
 */
function load() {
	let r;
	try {
		r = exports.storage.getItem('debug');
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}

	// If debug isn't set in LS, and we're in Electron, try to load $DEBUG
	if (!r && typeof process !== 'undefined' && 'env' in process) {
		r = process.env.DEBUG;
	}

	return r;
}

/**
 * Localstorage attempts to return the localstorage.
 *
 * This is necessary because safari throws
 * when a user disables cookies/localstorage
 * and you attempt to access it.
 *
 * @return {LocalStorage}
 * @api private
 */

function localstorage() {
	try {
		// TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
		// The Browser also has localStorage in the global context.
		return localStorage;
	} catch (error) {
		// Swallow
		// XXX (@Qix-) should we be logging these?
	}
}

module.exports = __webpack_require__(82447)(exports);

const {formatters} = module.exports;

/**
 * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
 */

formatters.j = function (v) {
	try {
		return JSON.stringify(v);
	} catch (error) {
		return '[UnexpectedJSONParseError]: ' + error.message;
	}
};


/***/ }),

/***/ 82447:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {


/**
 * This is the common logic for both the Node.js and web browser
 * implementations of `debug()`.
 */

function setup(env) {
	createDebug.debug = createDebug;
	createDebug.default = createDebug;
	createDebug.coerce = coerce;
	createDebug.disable = disable;
	createDebug.enable = enable;
	createDebug.enabled = enabled;
	createDebug.humanize = __webpack_require__(57824);
	createDebug.destroy = destroy;

	Object.keys(env).forEach(key => {
		createDebug[key] = env[key];
	});

	/**
	* The currently active debug mode names, and names to skip.
	*/

	createDebug.names = [];
	createDebug.skips = [];

	/**
	* Map of special "%n" handling functions, for the debug "format" argument.
	*
	* Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
	*/
	createDebug.formatters = {};

	/**
	* Selects a color for a debug namespace
	* @param {String} namespace The namespace string for the debug instance to be colored
	* @return {Number|String} An ANSI color code for the given namespace
	* @api private
	*/
	function selectColor(namespace) {
		let hash = 0;

		for (let i = 0; i < namespace.length; i++) {
			hash = ((hash << 5) - hash) + namespace.charCodeAt(i);
			hash |= 0; // Convert to 32bit integer
		}

		return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
	}
	createDebug.selectColor = selectColor;

	/**
	* Create a debugger with the given `namespace`.
	*
	* @param {String} namespace
	* @return {Function}
	* @api public
	*/
	function createDebug(namespace) {
		let prevTime;
		let enableOverride = null;
		let namespacesCache;
		let enabledCache;

		function debug(...args) {
			// Disabled?
			if (!debug.enabled) {
				return;
			}

			const self = debug;

			// Set `diff` timestamp
			const curr = Number(new Date());
			const ms = curr - (prevTime || curr);
			self.diff = ms;
			self.prev = prevTime;
			self.curr = curr;
			prevTime = curr;

			args[0] = createDebug.coerce(args[0]);

			if (typeof args[0] !== 'string') {
				// Anything else let's inspect with %O
				args.unshift('%O');
			}

			// Apply any `formatters` transformations
			let index = 0;
			args[0] = args[0].replace(/%([a-zA-Z%])/g, (match, format) => {
				// If we encounter an escaped % then don't increase the array index
				if (match === '%%') {
					return '%';
				}
				index++;
				const formatter = createDebug.formatters[format];
				if (typeof formatter === 'function') {
					const val = args[index];
					match = formatter.call(self, val);

					// Now we need to remove `args[index]` since it's inlined in the `format`
					args.splice(index, 1);
					index--;
				}
				return match;
			});

			// Apply env-specific formatting (colors, etc.)
			createDebug.formatArgs.call(self, args);

			const logFn = self.log || createDebug.log;
			logFn.apply(self, args);
		}

		debug.namespace = namespace;
		debug.useColors = createDebug.useColors();
		debug.color = createDebug.selectColor(namespace);
		debug.extend = extend;
		debug.destroy = createDebug.destroy; // XXX Temporary. Will be removed in the next major release.

		Object.defineProperty(debug, 'enabled', {
			enumerable: true,
			configurable: false,
			get: () => {
				if (enableOverride !== null) {
					return enableOverride;
				}
				if (namespacesCache !== createDebug.namespaces) {
					namespacesCache = createDebug.namespaces;
					enabledCache = createDebug.enabled(namespace);
				}

				return enabledCache;
			},
			set: v => {
				enableOverride = v;
			}
		});

		// Env-specific initialization logic for debug instances
		if (typeof createDebug.init === 'function') {
			createDebug.init(debug);
		}

		return debug;
	}

	function extend(namespace, delimiter) {
		const newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
		newDebug.log = this.log;
		return newDebug;
	}

	/**
	* Enables a debug mode by namespaces. This can include modes
	* separated by a colon and wildcards.
	*
	* @param {String} namespaces
	* @api public
	*/
	function enable(namespaces) {
		createDebug.save(namespaces);
		createDebug.namespaces = namespaces;

		createDebug.names = [];
		createDebug.skips = [];

		let i;
		const split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
		const len = split.length;

		for (i = 0; i < len; i++) {
			if (!split[i]) {
				// ignore empty strings
				continue;
			}

			namespaces = split[i].replace(/\*/g, '.*?');

			if (namespaces[0] === '-') {
				createDebug.skips.push(new RegExp('^' + namespaces.slice(1) + '$'));
			} else {
				createDebug.names.push(new RegExp('^' + namespaces + '$'));
			}
		}
	}

	/**
	* Disable debug output.
	*
	* @return {String} namespaces
	* @api public
	*/
	function disable() {
		const namespaces = [
			...createDebug.names.map(toNamespace),
			...createDebug.skips.map(toNamespace).map(namespace => '-' + namespace)
		].join(',');
		createDebug.enable('');
		return namespaces;
	}

	/**
	* Returns true if the given mode name is enabled, false otherwise.
	*
	* @param {String} name
	* @return {Boolean}
	* @api public
	*/
	function enabled(name) {
		if (name[name.length - 1] === '*') {
			return true;
		}

		let i;
		let len;

		for (i = 0, len = createDebug.skips.length; i < len; i++) {
			if (createDebug.skips[i].test(name)) {
				return false;
			}
		}

		for (i = 0, len = createDebug.names.length; i < len; i++) {
			if (createDebug.names[i].test(name)) {
				return true;
			}
		}

		return false;
	}

	/**
	* Convert regexp to namespace
	*
	* @param {RegExp} regxep
	* @return {String} namespace
	* @api private
	*/
	function toNamespace(regexp) {
		return regexp.toString()
			.substring(2, regexp.toString().length - 2)
			.replace(/\.\*\?$/, '*');
	}

	/**
	* Coerce `val`.
	*
	* @param {Mixed} val
	* @return {Mixed}
	* @api private
	*/
	function coerce(val) {
		if (val instanceof Error) {
			return val.stack || val.message;
		}
		return val;
	}

	/**
	* XXX DO NOT USE. This is a temporary stub function.
	* XXX It WILL be removed in the next major release.
	*/
	function destroy() {
		console.warn('Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.');
	}

	createDebug.enable(createDebug.load());

	return createDebug;
}

module.exports = setup;


/***/ }),

/***/ 9996:
/***/ (function(module) {

"use strict";


var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function getMergeFunction(key, options) {
	if (!options.customMerge) {
		return deepmerge
	}
	var customMerge = options.customMerge(key);
	return typeof customMerge === 'function' ? customMerge : deepmerge
}

function getEnumerableOwnPropertySymbols(target) {
	return Object.getOwnPropertySymbols
		? Object.getOwnPropertySymbols(target).filter(function(symbol) {
			return target.propertyIsEnumerable(symbol)
		})
		: []
}

function getKeys(target) {
	return Object.keys(target).concat(getEnumerableOwnPropertySymbols(target))
}

function propertyIsOnObject(object, property) {
	try {
		return property in object
	} catch(_) {
		return false
	}
}

// Protects from prototype poisoning and unexpected merging up the prototype chain.
function propertyIsUnsafe(target, key) {
	return propertyIsOnObject(target, key) // Properties are safe to merge if they don't exist in the target yet,
		&& !(Object.hasOwnProperty.call(target, key) // unsafe if they exist up the prototype chain,
			&& Object.propertyIsEnumerable.call(target, key)) // and also unsafe if they're nonenumerable.
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		getKeys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	getKeys(source).forEach(function(key) {
		if (propertyIsUnsafe(target, key)) {
			return
		}

		if (propertyIsOnObject(target, key) && options.isMergeableObject(source[key])) {
			destination[key] = getMergeFunction(key, options)(target[key], source[key], options);
		} else {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;
	// cloneUnlessOtherwiseSpecified is added to `options` so that custom arrayMerge()
	// implementations can use it. The caller may not replace it.
	options.cloneUnlessOtherwiseSpecified = cloneUnlessOtherwiseSpecified;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

module.exports = deepmerge_1;


/***/ }),

/***/ 35015:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var Buffer = (__webpack_require__(89509).Buffer);

var getParamBytesForAlg = __webpack_require__(6972);

var MAX_OCTET = 0x80,
	CLASS_UNIVERSAL = 0,
	PRIMITIVE_BIT = 0x20,
	TAG_SEQ = 0x10,
	TAG_INT = 0x02,
	ENCODED_TAG_SEQ = (TAG_SEQ | PRIMITIVE_BIT) | (CLASS_UNIVERSAL << 6),
	ENCODED_TAG_INT = TAG_INT | (CLASS_UNIVERSAL << 6);

function base64Url(base64) {
	return base64
		.replace(/=/g, '')
		.replace(/\+/g, '-')
		.replace(/\//g, '_');
}

function signatureAsBuffer(signature) {
	if (Buffer.isBuffer(signature)) {
		return signature;
	} else if ('string' === typeof signature) {
		return Buffer.from(signature, 'base64');
	}

	throw new TypeError('ECDSA signature must be a Base64 string or a Buffer');
}

function derToJose(signature, alg) {
	signature = signatureAsBuffer(signature);
	var paramBytes = getParamBytesForAlg(alg);

	// the DER encoded param should at most be the param size, plus a padding
	// zero, since due to being a signed integer
	var maxEncodedParamLength = paramBytes + 1;

	var inputLength = signature.length;

	var offset = 0;
	if (signature[offset++] !== ENCODED_TAG_SEQ) {
		throw new Error('Could not find expected "seq"');
	}

	var seqLength = signature[offset++];
	if (seqLength === (MAX_OCTET | 1)) {
		seqLength = signature[offset++];
	}

	if (inputLength - offset < seqLength) {
		throw new Error('"seq" specified length of "' + seqLength + '", only "' + (inputLength - offset) + '" remaining');
	}

	if (signature[offset++] !== ENCODED_TAG_INT) {
		throw new Error('Could not find expected "int" for "r"');
	}

	var rLength = signature[offset++];

	if (inputLength - offset - 2 < rLength) {
		throw new Error('"r" specified length of "' + rLength + '", only "' + (inputLength - offset - 2) + '" available');
	}

	if (maxEncodedParamLength < rLength) {
		throw new Error('"r" specified length of "' + rLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
	}

	var rOffset = offset;
	offset += rLength;

	if (signature[offset++] !== ENCODED_TAG_INT) {
		throw new Error('Could not find expected "int" for "s"');
	}

	var sLength = signature[offset++];

	if (inputLength - offset !== sLength) {
		throw new Error('"s" specified length of "' + sLength + '", expected "' + (inputLength - offset) + '"');
	}

	if (maxEncodedParamLength < sLength) {
		throw new Error('"s" specified length of "' + sLength + '", max of "' + maxEncodedParamLength + '" is acceptable');
	}

	var sOffset = offset;
	offset += sLength;

	if (offset !== inputLength) {
		throw new Error('Expected to consume entire buffer, but "' + (inputLength - offset) + '" bytes remain');
	}

	var rPadding = paramBytes - rLength,
		sPadding = paramBytes - sLength;

	var dst = Buffer.allocUnsafe(rPadding + rLength + sPadding + sLength);

	for (offset = 0; offset < rPadding; ++offset) {
		dst[offset] = 0;
	}
	signature.copy(dst, offset, rOffset + Math.max(-rPadding, 0), rOffset + rLength);

	offset = paramBytes;

	for (var o = offset; offset < o + sPadding; ++offset) {
		dst[offset] = 0;
	}
	signature.copy(dst, offset, sOffset + Math.max(-sPadding, 0), sOffset + sLength);

	dst = dst.toString('base64');
	dst = base64Url(dst);

	return dst;
}

function countPadding(buf, start, stop) {
	var padding = 0;
	while (start + padding < stop && buf[start + padding] === 0) {
		++padding;
	}

	var needsSign = buf[start + padding] >= MAX_OCTET;
	if (needsSign) {
		--padding;
	}

	return padding;
}

function joseToDer(signature, alg) {
	signature = signatureAsBuffer(signature);
	var paramBytes = getParamBytesForAlg(alg);

	var signatureBytes = signature.length;
	if (signatureBytes !== paramBytes * 2) {
		throw new TypeError('"' + alg + '" signatures must be "' + paramBytes * 2 + '" bytes, saw "' + signatureBytes + '"');
	}

	var rPadding = countPadding(signature, 0, paramBytes);
	var sPadding = countPadding(signature, paramBytes, signature.length);
	var rLength = paramBytes - rPadding;
	var sLength = paramBytes - sPadding;

	var rsBytes = 1 + 1 + rLength + 1 + 1 + sLength;

	var shortLength = rsBytes < MAX_OCTET;

	var dst = Buffer.allocUnsafe((shortLength ? 2 : 3) + rsBytes);

	var offset = 0;
	dst[offset++] = ENCODED_TAG_SEQ;
	if (shortLength) {
		// Bit 8 has value "0"
		// bits 7-1 give the length.
		dst[offset++] = rsBytes;
	} else {
		// Bit 8 of first octet has value "1"
		// bits 7-1 give the number of additional length octets.
		dst[offset++] = MAX_OCTET	| 1;
		// length, base 256
		dst[offset++] = rsBytes & 0xff;
	}
	dst[offset++] = ENCODED_TAG_INT;
	dst[offset++] = rLength;
	if (rPadding < 0) {
		dst[offset++] = 0;
		offset += signature.copy(dst, offset, 0, paramBytes);
	} else {
		offset += signature.copy(dst, offset, rPadding, paramBytes);
	}
	dst[offset++] = ENCODED_TAG_INT;
	dst[offset++] = sLength;
	if (sPadding < 0) {
		dst[offset++] = 0;
		signature.copy(dst, offset, paramBytes);
	} else {
		signature.copy(dst, offset, paramBytes + sPadding);
	}

	return dst;
}

module.exports = {
	derToJose: derToJose,
	joseToDer: joseToDer
};


/***/ }),

/***/ 6972:
/***/ (function(module) {

"use strict";


function getParamSize(keySize) {
	var result = ((keySize / 8) | 0) + (keySize % 8 === 0 ? 0 : 1);
	return result;
}

var paramBytesForAlg = {
	ES256: getParamSize(256),
	ES384: getParamSize(384),
	ES512: getParamSize(521)
};

function getParamBytesForAlg(alg) {
	var paramBytes = paramBytesForAlg[alg];
	if (paramBytes) {
		return paramBytes;
	}

	throw new Error('Unknown algorithm "' + alg + '"');
}

module.exports = getParamBytesForAlg;


/***/ }),

/***/ 17187:
/***/ (function(module) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



var R = typeof Reflect === 'object' ? Reflect : null
var ReflectApply = R && typeof R.apply === 'function'
  ? R.apply
  : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
  }

var ReflectOwnKeys
if (R && typeof R.ownKeys === 'function') {
  ReflectOwnKeys = R.ownKeys
} else if (Object.getOwnPropertySymbols) {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target)
      .concat(Object.getOwnPropertySymbols(target));
  };
} else {
  ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
  };
}

function ProcessEmitWarning(warning) {
  if (console && console.warn) console.warn(warning);
}

var NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
  return value !== value;
}

function EventEmitter() {
  EventEmitter.init.call(this);
}
module.exports = EventEmitter;
module.exports.once = once;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._eventsCount = 0;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var defaultMaxListeners = 10;

function checkListener(listener) {
  if (typeof listener !== 'function') {
    throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
  }
}

Object.defineProperty(EventEmitter, 'defaultMaxListeners', {
  enumerable: true,
  get: function() {
    return defaultMaxListeners;
  },
  set: function(arg) {
    if (typeof arg !== 'number' || arg < 0 || NumberIsNaN(arg)) {
      throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
    }
    defaultMaxListeners = arg;
  }
});

EventEmitter.init = function() {

  if (this._events === undefined ||
      this._events === Object.getPrototypeOf(this)._events) {
    this._events = Object.create(null);
    this._eventsCount = 0;
  }

  this._maxListeners = this._maxListeners || undefined;
};

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
  if (typeof n !== 'number' || n < 0 || NumberIsNaN(n)) {
    throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
  }
  this._maxListeners = n;
  return this;
};

function _getMaxListeners(that) {
  if (that._maxListeners === undefined)
    return EventEmitter.defaultMaxListeners;
  return that._maxListeners;
}

EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
  return _getMaxListeners(this);
};

EventEmitter.prototype.emit = function emit(type) {
  var args = [];
  for (var i = 1; i < arguments.length; i++) args.push(arguments[i]);
  var doError = (type === 'error');

  var events = this._events;
  if (events !== undefined)
    doError = (doError && events.error === undefined);
  else if (!doError)
    return false;

  // If there is no 'error' event listener then throw.
  if (doError) {
    var er;
    if (args.length > 0)
      er = args[0];
    if (er instanceof Error) {
      // Note: The comments on the `throw` lines are intentional, they show
      // up in Node's output if this results in an unhandled exception.
      throw er; // Unhandled 'error' event
    }
    // At least give some kind of context to the user
    var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
    err.context = er;
    throw err; // Unhandled 'error' event
  }

  var handler = events[type];

  if (handler === undefined)
    return false;

  if (typeof handler === 'function') {
    ReflectApply(handler, this, args);
  } else {
    var len = handler.length;
    var listeners = arrayClone(handler, len);
    for (var i = 0; i < len; ++i)
      ReflectApply(listeners[i], this, args);
  }

  return true;
};

function _addListener(target, type, listener, prepend) {
  var m;
  var events;
  var existing;

  checkListener(listener);

  events = target._events;
  if (events === undefined) {
    events = target._events = Object.create(null);
    target._eventsCount = 0;
  } else {
    // To avoid recursion in the case that type === "newListener"! Before
    // adding it to the listeners, first emit "newListener".
    if (events.newListener !== undefined) {
      target.emit('newListener', type,
                  listener.listener ? listener.listener : listener);

      // Re-assign `events` because a newListener handler could have caused the
      // this._events to be assigned to a new object
      events = target._events;
    }
    existing = events[type];
  }

  if (existing === undefined) {
    // Optimize the case of one listener. Don't need the extra array object.
    existing = events[type] = listener;
    ++target._eventsCount;
  } else {
    if (typeof existing === 'function') {
      // Adding the second element, need to change to array.
      existing = events[type] =
        prepend ? [listener, existing] : [existing, listener];
      // If we've already got an array, just append.
    } else if (prepend) {
      existing.unshift(listener);
    } else {
      existing.push(listener);
    }

    // Check for listener leak
    m = _getMaxListeners(target);
    if (m > 0 && existing.length > m && !existing.warned) {
      existing.warned = true;
      // No error code for this since it is a Warning
      // eslint-disable-next-line no-restricted-syntax
      var w = new Error('Possible EventEmitter memory leak detected. ' +
                          existing.length + ' ' + String(type) + ' listeners ' +
                          'added. Use emitter.setMaxListeners() to ' +
                          'increase limit');
      w.name = 'MaxListenersExceededWarning';
      w.emitter = target;
      w.type = type;
      w.count = existing.length;
      ProcessEmitWarning(w);
    }
  }

  return target;
}

EventEmitter.prototype.addListener = function addListener(type, listener) {
  return _addListener(this, type, listener, false);
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.prependListener =
    function prependListener(type, listener) {
      return _addListener(this, type, listener, true);
    };

function onceWrapper() {
  if (!this.fired) {
    this.target.removeListener(this.type, this.wrapFn);
    this.fired = true;
    if (arguments.length === 0)
      return this.listener.call(this.target);
    return this.listener.apply(this.target, arguments);
  }
}

function _onceWrap(target, type, listener) {
  var state = { fired: false, wrapFn: undefined, target: target, type: type, listener: listener };
  var wrapped = onceWrapper.bind(state);
  wrapped.listener = listener;
  state.wrapFn = wrapped;
  return wrapped;
}

EventEmitter.prototype.once = function once(type, listener) {
  checkListener(listener);
  this.on(type, _onceWrap(this, type, listener));
  return this;
};

EventEmitter.prototype.prependOnceListener =
    function prependOnceListener(type, listener) {
      checkListener(listener);
      this.prependListener(type, _onceWrap(this, type, listener));
      return this;
    };

// Emits a 'removeListener' event if and only if the listener was removed.
EventEmitter.prototype.removeListener =
    function removeListener(type, listener) {
      var list, events, position, i, originalListener;

      checkListener(listener);

      events = this._events;
      if (events === undefined)
        return this;

      list = events[type];
      if (list === undefined)
        return this;

      if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0)
          this._events = Object.create(null);
        else {
          delete events[type];
          if (events.removeListener)
            this.emit('removeListener', type, list.listener || listener);
        }
      } else if (typeof list !== 'function') {
        position = -1;

        for (i = list.length - 1; i >= 0; i--) {
          if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
          }
        }

        if (position < 0)
          return this;

        if (position === 0)
          list.shift();
        else {
          spliceOne(list, position);
        }

        if (list.length === 1)
          events[type] = list[0];

        if (events.removeListener !== undefined)
          this.emit('removeListener', type, originalListener || listener);
      }

      return this;
    };

EventEmitter.prototype.off = EventEmitter.prototype.removeListener;

EventEmitter.prototype.removeAllListeners =
    function removeAllListeners(type) {
      var listeners, events, i;

      events = this._events;
      if (events === undefined)
        return this;

      // not listening for removeListener, no need to emit
      if (events.removeListener === undefined) {
        if (arguments.length === 0) {
          this._events = Object.create(null);
          this._eventsCount = 0;
        } else if (events[type] !== undefined) {
          if (--this._eventsCount === 0)
            this._events = Object.create(null);
          else
            delete events[type];
        }
        return this;
      }

      // emit removeListener for all listeners on all events
      if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for (i = 0; i < keys.length; ++i) {
          key = keys[i];
          if (key === 'removeListener') continue;
          this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
      }

      listeners = events[type];

      if (typeof listeners === 'function') {
        this.removeListener(type, listeners);
      } else if (listeners !== undefined) {
        // LIFO order
        for (i = listeners.length - 1; i >= 0; i--) {
          this.removeListener(type, listeners[i]);
        }
      }

      return this;
    };

function _listeners(target, type, unwrap) {
  var events = target._events;

  if (events === undefined)
    return [];

  var evlistener = events[type];
  if (evlistener === undefined)
    return [];

  if (typeof evlistener === 'function')
    return unwrap ? [evlistener.listener || evlistener] : [evlistener];

  return unwrap ?
    unwrapListeners(evlistener) : arrayClone(evlistener, evlistener.length);
}

EventEmitter.prototype.listeners = function listeners(type) {
  return _listeners(this, type, true);
};

EventEmitter.prototype.rawListeners = function rawListeners(type) {
  return _listeners(this, type, false);
};

EventEmitter.listenerCount = function(emitter, type) {
  if (typeof emitter.listenerCount === 'function') {
    return emitter.listenerCount(type);
  } else {
    return listenerCount.call(emitter, type);
  }
};

EventEmitter.prototype.listenerCount = listenerCount;
function listenerCount(type) {
  var events = this._events;

  if (events !== undefined) {
    var evlistener = events[type];

    if (typeof evlistener === 'function') {
      return 1;
    } else if (evlistener !== undefined) {
      return evlistener.length;
    }
  }

  return 0;
}

EventEmitter.prototype.eventNames = function eventNames() {
  return this._eventsCount > 0 ? ReflectOwnKeys(this._events) : [];
};

function arrayClone(arr, n) {
  var copy = new Array(n);
  for (var i = 0; i < n; ++i)
    copy[i] = arr[i];
  return copy;
}

function spliceOne(list, index) {
  for (; index + 1 < list.length; index++)
    list[index] = list[index + 1];
  list.pop();
}

function unwrapListeners(arr) {
  var ret = new Array(arr.length);
  for (var i = 0; i < ret.length; ++i) {
    ret[i] = arr[i].listener || arr[i];
  }
  return ret;
}

function once(emitter, name) {
  return new Promise(function (resolve, reject) {
    function errorListener(err) {
      emitter.removeListener(name, resolver);
      reject(err);
    }

    function resolver() {
      if (typeof emitter.removeListener === 'function') {
        emitter.removeListener('error', errorListener);
      }
      resolve([].slice.call(arguments));
    };

    eventTargetAgnosticAddListener(emitter, name, resolver, { once: true });
    if (name !== 'error') {
      addErrorHandlerIfEventEmitter(emitter, errorListener, { once: true });
    }
  });
}

function addErrorHandlerIfEventEmitter(emitter, handler, flags) {
  if (typeof emitter.on === 'function') {
    eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
  }
}

function eventTargetAgnosticAddListener(emitter, name, listener, flags) {
  if (typeof emitter.on === 'function') {
    if (flags.once) {
      emitter.once(name, listener);
    } else {
      emitter.on(name, listener);
    }
  } else if (typeof emitter.addEventListener === 'function') {
    // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
      // IE does not have builtin `{ once: true }` support so we
      // have to do it manually.
      if (flags.once) {
        emitter.removeEventListener(name, wrapListener);
      }
      listener(arg);
    });
  } else {
    throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
  }
}


/***/ }),

/***/ 17283:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ lib; },
  "Ps": function() { return /* binding */ gql; }
});

// UNUSED EXPORTS: disableExperimentalFragmentVariables, disableFragmentWarnings, enableExperimentalFragmentVariables, resetCaches

// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(70655);
;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/isObjectLike.mjs
/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return typeof value == 'object' && value !== null;
}

;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/invariant.mjs
function invariant(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(
      message != null ? message : 'Unexpected invariant triggered.',
    );
  }
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/location.mjs

const LineRegExp = /\r\n|[\n\r]/g;
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  let lastLineStart = 0;
  let line = 1;

  for (const match of source.body.matchAll(LineRegExp)) {
    typeof match.index === 'number' || invariant(false);

    if (match.index >= position) {
      break;
    }

    lastLineStart = match.index + match[0].length;
    line += 1;
  }

  return {
    line,
    column: position + 1 - lastLineStart,
  };
}

;// CONCATENATED MODULE: ./node_modules/graphql/language/printLocation.mjs


/**
 * Render a helpful description of the location in the GraphQL Source document.
 */
function printLocation(location) {
  return printSourceLocation(
    location.source,
    getLocation(location.source, location.start),
  );
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  const firstLineColumnOffset = source.locationOffset.column - 1;
  const body = ''.padStart(firstLineColumnOffset) + source.body;
  const lineIndex = sourceLocation.line - 1;
  const lineOffset = source.locationOffset.line - 1;
  const lineNum = sourceLocation.line + lineOffset;
  const columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  const columnNum = sourceLocation.column + columnOffset;
  const locationStr = `${source.name}:${lineNum}:${columnNum}\n`;
  const lines = body.split(/\r\n|[\n\r]/g);
  const locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    const subLineIndex = Math.floor(columnNum / 80);
    const subLineColumnNum = columnNum % 80;
    const subLines = [];

    for (let i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return (
      locationStr +
      printPrefixedLines([
        [`${lineNum} |`, subLines[0]],
        ...subLines.slice(1, subLineIndex + 1).map((subLine) => ['|', subLine]),
        ['|', '^'.padStart(subLineColumnNum)],
        ['|', subLines[subLineIndex + 1]],
      ])
    );
  }

  return (
    locationStr +
    printPrefixedLines([
      // Lines specified like this: ["prefix", "string"],
      [`${lineNum - 1} |`, lines[lineIndex - 1]],
      [`${lineNum} |`, locationLine],
      ['|', '^'.padStart(columnNum)],
      [`${lineNum + 1} |`, lines[lineIndex + 1]],
    ])
  );
}

function printPrefixedLines(lines) {
  const existingLines = lines.filter(([_, line]) => line !== undefined);
  const padLen = Math.max(...existingLines.map(([prefix]) => prefix.length));
  return existingLines
    .map(([prefix, line]) => prefix.padStart(padLen) + (line ? ' ' + line : ''))
    .join('\n');
}

;// CONCATENATED MODULE: ./node_modules/graphql/error/GraphQLError.mjs




function toNormalizedOptions(args) {
  const firstArg = args[0];

  if (firstArg == null || 'kind' in firstArg || 'length' in firstArg) {
    return {
      nodes: firstArg,
      source: args[1],
      positions: args[2],
      path: args[3],
      originalError: args[4],
      extensions: args[5],
    };
  }

  return firstArg;
}
/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

class GraphQLError extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */

  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(message, ...rawArgs) {
    var _this$nodes, _nodeLocations$, _ref;

    const { nodes, source, positions, path, originalError, extensions } =
      toNormalizedOptions(rawArgs);
    super(message);
    this.name = 'GraphQLError';
    this.path = path !== null && path !== void 0 ? path : undefined;
    this.originalError =
      originalError !== null && originalError !== void 0
        ? originalError
        : undefined; // Compute list of blame nodes.

    this.nodes = undefinedIfEmpty(
      Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined,
    );
    const nodeLocations = undefinedIfEmpty(
      (_this$nodes = this.nodes) === null || _this$nodes === void 0
        ? void 0
        : _this$nodes.map((node) => node.loc).filter((loc) => loc != null),
    ); // Compute locations in the source for the given nodes/positions.

    this.source =
      source !== null && source !== void 0
        ? source
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : (_nodeLocations$ = nodeLocations[0]) === null ||
          _nodeLocations$ === void 0
        ? void 0
        : _nodeLocations$.source;
    this.positions =
      positions !== null && positions !== void 0
        ? positions
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => loc.start);
    this.locations =
      positions && source
        ? positions.map((pos) => getLocation(source, pos))
        : nodeLocations === null || nodeLocations === void 0
        ? void 0
        : nodeLocations.map((loc) => getLocation(loc.source, loc.start));
    const originalExtensions = isObjectLike(
      originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions,
    )
      ? originalError === null || originalError === void 0
        ? void 0
        : originalError.extensions
      : undefined;
    this.extensions =
      (_ref =
        extensions !== null && extensions !== void 0
          ? extensions
          : originalExtensions) !== null && _ref !== void 0
        ? _ref
        : Object.create(null); // Only properties prescribed by the spec should be enumerable.
    // Keep the rest as non-enumerable.

    Object.defineProperties(this, {
      message: {
        writable: true,
        enumerable: true,
      },
      name: {
        enumerable: false,
      },
      nodes: {
        enumerable: false,
      },
      source: {
        enumerable: false,
      },
      positions: {
        enumerable: false,
      },
      originalError: {
        enumerable: false,
      },
    }); // Include (non-enumerable) stack trace.

    /* c8 ignore start */
    // FIXME: https://github.com/graphql/graphql-js/issues/2317

    if (
      originalError !== null &&
      originalError !== void 0 &&
      originalError.stack
    ) {
      Object.defineProperty(this, 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true,
      });
    } else if (Error.captureStackTrace) {
      Error.captureStackTrace(this, GraphQLError);
    } else {
      Object.defineProperty(this, 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true,
      });
    }
    /* c8 ignore stop */
  }

  get [Symbol.toStringTag]() {
    return 'GraphQLError';
  }

  toString() {
    let output = this.message;

    if (this.nodes) {
      for (const node of this.nodes) {
        if (node.loc) {
          output += '\n\n' + printLocation(node.loc);
        }
      }
    } else if (this.source && this.locations) {
      for (const location of this.locations) {
        output += '\n\n' + printSourceLocation(this.source, location);
      }
    }

    return output;
  }

  toJSON() {
    const formattedError = {
      message: this.message,
    };

    if (this.locations != null) {
      formattedError.locations = this.locations;
    }

    if (this.path != null) {
      formattedError.path = this.path;
    }

    if (this.extensions != null && Object.keys(this.extensions).length > 0) {
      formattedError.extensions = this.extensions;
    }

    return formattedError;
  }
}

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * See: https://spec.graphql.org/draft/#sec-Errors
 */

/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 *
 * @deprecated Please use `error.toString` instead. Will be removed in v17
 */
function printError(error) {
  return error.toString();
}
/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 *
 * @deprecated Please use `error.toJSON` instead. Will be removed in v17
 */

function formatError(error) {
  return error.toJSON();
}

;// CONCATENATED MODULE: ./node_modules/graphql/error/syntaxError.mjs

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new GraphQLError(`Syntax Error: ${description}`, {
    source,
    positions: [position],
  });
}

// EXTERNAL MODULE: ./node_modules/graphql/language/ast.mjs
var ast = __webpack_require__(72380);
;// CONCATENATED MODULE: ./node_modules/graphql/language/directiveLocation.mjs
/**
 * The set of allowed directive location values.
 */
var DirectiveLocation;

(function (DirectiveLocation) {
  DirectiveLocation['QUERY'] = 'QUERY';
  DirectiveLocation['MUTATION'] = 'MUTATION';
  DirectiveLocation['SUBSCRIPTION'] = 'SUBSCRIPTION';
  DirectiveLocation['FIELD'] = 'FIELD';
  DirectiveLocation['FRAGMENT_DEFINITION'] = 'FRAGMENT_DEFINITION';
  DirectiveLocation['FRAGMENT_SPREAD'] = 'FRAGMENT_SPREAD';
  DirectiveLocation['INLINE_FRAGMENT'] = 'INLINE_FRAGMENT';
  DirectiveLocation['VARIABLE_DEFINITION'] = 'VARIABLE_DEFINITION';
  DirectiveLocation['SCHEMA'] = 'SCHEMA';
  DirectiveLocation['SCALAR'] = 'SCALAR';
  DirectiveLocation['OBJECT'] = 'OBJECT';
  DirectiveLocation['FIELD_DEFINITION'] = 'FIELD_DEFINITION';
  DirectiveLocation['ARGUMENT_DEFINITION'] = 'ARGUMENT_DEFINITION';
  DirectiveLocation['INTERFACE'] = 'INTERFACE';
  DirectiveLocation['UNION'] = 'UNION';
  DirectiveLocation['ENUM'] = 'ENUM';
  DirectiveLocation['ENUM_VALUE'] = 'ENUM_VALUE';
  DirectiveLocation['INPUT_OBJECT'] = 'INPUT_OBJECT';
  DirectiveLocation['INPUT_FIELD_DEFINITION'] = 'INPUT_FIELD_DEFINITION';
})(DirectiveLocation || (DirectiveLocation = {}));


/**
 * The enum type representing the directive location values.
 *
 * @deprecated Please use `DirectiveLocation`. Will be remove in v17.
 */

// EXTERNAL MODULE: ./node_modules/graphql/language/kinds.mjs
var kinds = __webpack_require__(97359);
// EXTERNAL MODULE: ./node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(87392);
// EXTERNAL MODULE: ./node_modules/graphql/language/characterClasses.mjs
var characterClasses = __webpack_require__(68297);
;// CONCATENATED MODULE: ./node_modules/graphql/language/tokenKind.mjs
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var tokenKind_TokenKind;

(function (TokenKind) {
  TokenKind['SOF'] = '<SOF>';
  TokenKind['EOF'] = '<EOF>';
  TokenKind['BANG'] = '!';
  TokenKind['DOLLAR'] = '$';
  TokenKind['AMP'] = '&';
  TokenKind['PAREN_L'] = '(';
  TokenKind['PAREN_R'] = ')';
  TokenKind['SPREAD'] = '...';
  TokenKind['COLON'] = ':';
  TokenKind['EQUALS'] = '=';
  TokenKind['AT'] = '@';
  TokenKind['BRACKET_L'] = '[';
  TokenKind['BRACKET_R'] = ']';
  TokenKind['BRACE_L'] = '{';
  TokenKind['PIPE'] = '|';
  TokenKind['BRACE_R'] = '}';
  TokenKind['NAME'] = 'Name';
  TokenKind['INT'] = 'Int';
  TokenKind['FLOAT'] = 'Float';
  TokenKind['STRING'] = 'String';
  TokenKind['BLOCK_STRING'] = 'BlockString';
  TokenKind['COMMENT'] = 'Comment';
})(tokenKind_TokenKind || (tokenKind_TokenKind = {}));


/**
 * The enum type representing the token kinds values.
 *
 * @deprecated Please use `TokenKind`. Will be remove in v17.
 */

;// CONCATENATED MODULE: ./node_modules/graphql/language/lexer.mjs





/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

class Lexer {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  constructor(source) {
    const startOfFileToken = new ast/* Token */.WU(tokenKind_TokenKind.SOF, 0, 0, 0, 0);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }

  get [Symbol.toStringTag]() {
    return 'Lexer';
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */

  advance() {
    this.lastToken = this.token;
    const token = (this.token = this.lookahead());
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */

  lookahead() {
    let token = this.token;

    if (token.kind !== tokenKind_TokenKind.EOF) {
      do {
        if (token.next) {
          token = token.next;
        } else {
          // Read the next token and form a link in the token linked-list.
          const nextToken = readNextToken(this, token.end); // @ts-expect-error next is only mutable during parsing.

          token.next = nextToken; // @ts-expect-error prev is only mutable during parsing.

          nextToken.prev = token;
          token = nextToken;
        }
      } while (token.kind === tokenKind_TokenKind.COMMENT);
    }

    return token;
  }
}
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return (
    kind === tokenKind_TokenKind.BANG ||
    kind === tokenKind_TokenKind.DOLLAR ||
    kind === tokenKind_TokenKind.AMP ||
    kind === tokenKind_TokenKind.PAREN_L ||
    kind === tokenKind_TokenKind.PAREN_R ||
    kind === tokenKind_TokenKind.SPREAD ||
    kind === tokenKind_TokenKind.COLON ||
    kind === tokenKind_TokenKind.EQUALS ||
    kind === tokenKind_TokenKind.AT ||
    kind === tokenKind_TokenKind.BRACKET_L ||
    kind === tokenKind_TokenKind.BRACKET_R ||
    kind === tokenKind_TokenKind.BRACE_L ||
    kind === tokenKind_TokenKind.PIPE ||
    kind === tokenKind_TokenKind.BRACE_R
  );
}
/**
 * A Unicode scalar value is any Unicode code point except surrogate code
 * points. In other words, the inclusive ranges of values 0x0000 to 0xD7FF and
 * 0xE000 to 0x10FFFF.
 *
 * SourceCharacter ::
 *   - "Any Unicode scalar value"
 */

function isUnicodeScalarValue(code) {
  return (
    (code >= 0x0000 && code <= 0xd7ff) || (code >= 0xe000 && code <= 0x10ffff)
  );
}
/**
 * The GraphQL specification defines source text as a sequence of unicode scalar
 * values (which Unicode defines to exclude surrogate code points). However
 * JavaScript defines strings as a sequence of UTF-16 code units which may
 * include surrogates. A surrogate pair is a valid source character as it
 * encodes a supplementary code point (above U+FFFF), but unpaired surrogate
 * code points are not valid source characters.
 */

function isSupplementaryCodePoint(body, location) {
  return (
    isLeadingSurrogate(body.charCodeAt(location)) &&
    isTrailingSurrogate(body.charCodeAt(location + 1))
  );
}

function isLeadingSurrogate(code) {
  return code >= 0xd800 && code <= 0xdbff;
}

function isTrailingSurrogate(code) {
  return code >= 0xdc00 && code <= 0xdfff;
}
/**
 * Prints the code point (or end of file reference) at a given location in a
 * source for use in error messages.
 *
 * Printable ASCII is printed quoted, while other points are printed in Unicode
 * code point form (ie. U+1234).
 */

function printCodePointAt(lexer, location) {
  const code = lexer.source.body.codePointAt(location);

  if (code === undefined) {
    return tokenKind_TokenKind.EOF;
  } else if (code >= 0x0020 && code <= 0x007e) {
    // Printable ASCII
    const char = String.fromCodePoint(code);
    return char === '"' ? "'\"'" : `"${char}"`;
  } // Unicode code point

  return 'U+' + code.toString(16).toUpperCase().padStart(4, '0');
}
/**
 * Create a token with line and column location information.
 */

function createToken(lexer, kind, start, end, value) {
  const line = lexer.line;
  const col = 1 + start - lexer.lineStart;
  return new ast/* Token */.WU(kind, start, end, line, col, value);
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */

function readNextToken(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // SourceCharacter

    switch (code) {
      // Ignored ::
      //   - UnicodeBOM
      //   - WhiteSpace
      //   - LineTerminator
      //   - Comment
      //   - Comma
      //
      // UnicodeBOM :: "Byte Order Mark (U+FEFF)"
      //
      // WhiteSpace ::
      //   - "Horizontal Tab (U+0009)"
      //   - "Space (U+0020)"
      //
      // Comma :: ,
      case 0xfeff: // <BOM>

      case 0x0009: // \t

      case 0x0020: // <space>

      case 0x002c:
        // ,
        ++position;
        continue;
      // LineTerminator ::
      //   - "New Line (U+000A)"
      //   - "Carriage Return (U+000D)" [lookahead != "New Line (U+000A)"]
      //   - "Carriage Return (U+000D)" "New Line (U+000A)"

      case 0x000a:
        // \n
        ++position;
        ++lexer.line;
        lexer.lineStart = position;
        continue;

      case 0x000d:
        // \r
        if (body.charCodeAt(position + 1) === 0x000a) {
          position += 2;
        } else {
          ++position;
        }

        ++lexer.line;
        lexer.lineStart = position;
        continue;
      // Comment

      case 0x0023:
        // #
        return readComment(lexer, position);
      // Token ::
      //   - Punctuator
      //   - Name
      //   - IntValue
      //   - FloatValue
      //   - StringValue
      //
      // Punctuator :: one of ! $ & ( ) ... : = @ [ ] { | }

      case 0x0021:
        // !
        return createToken(lexer, tokenKind_TokenKind.BANG, position, position + 1);

      case 0x0024:
        // $
        return createToken(lexer, tokenKind_TokenKind.DOLLAR, position, position + 1);

      case 0x0026:
        // &
        return createToken(lexer, tokenKind_TokenKind.AMP, position, position + 1);

      case 0x0028:
        // (
        return createToken(lexer, tokenKind_TokenKind.PAREN_L, position, position + 1);

      case 0x0029:
        // )
        return createToken(lexer, tokenKind_TokenKind.PAREN_R, position, position + 1);

      case 0x002e:
        // .
        if (
          body.charCodeAt(position + 1) === 0x002e &&
          body.charCodeAt(position + 2) === 0x002e
        ) {
          return createToken(lexer, tokenKind_TokenKind.SPREAD, position, position + 3);
        }

        break;

      case 0x003a:
        // :
        return createToken(lexer, tokenKind_TokenKind.COLON, position, position + 1);

      case 0x003d:
        // =
        return createToken(lexer, tokenKind_TokenKind.EQUALS, position, position + 1);

      case 0x0040:
        // @
        return createToken(lexer, tokenKind_TokenKind.AT, position, position + 1);

      case 0x005b:
        // [
        return createToken(lexer, tokenKind_TokenKind.BRACKET_L, position, position + 1);

      case 0x005d:
        // ]
        return createToken(lexer, tokenKind_TokenKind.BRACKET_R, position, position + 1);

      case 0x007b:
        // {
        return createToken(lexer, tokenKind_TokenKind.BRACE_L, position, position + 1);

      case 0x007c:
        // |
        return createToken(lexer, tokenKind_TokenKind.PIPE, position, position + 1);

      case 0x007d:
        // }
        return createToken(lexer, tokenKind_TokenKind.BRACE_R, position, position + 1);
      // StringValue

      case 0x0022:
        // "
        if (
          body.charCodeAt(position + 1) === 0x0022 &&
          body.charCodeAt(position + 2) === 0x0022
        ) {
          return readBlockString(lexer, position);
        }

        return readString(lexer, position);
    } // IntValue | FloatValue (Digit | -)

    if ((0,characterClasses/* isDigit */.X1)(code) || code === 0x002d) {
      return readNumber(lexer, position, code);
    } // Name

    if ((0,characterClasses/* isNameStart */.LQ)(code)) {
      return readName(lexer, position);
    }

    throw syntaxError(
      lexer.source,
      position,
      code === 0x0027
        ? 'Unexpected single quote character (\'), did you mean to use a double quote (")?'
        : isUnicodeScalarValue(code) || isSupplementaryCodePoint(body, position)
        ? `Unexpected character: ${printCodePointAt(lexer, position)}.`
        : `Invalid character: ${printCodePointAt(lexer, position)}.`,
    );
  }

  return createToken(lexer, tokenKind_TokenKind.EOF, bodyLength, bodyLength);
}
/**
 * Reads a comment token from the source file.
 *
 * ```
 * Comment :: # CommentChar* [lookahead != CommentChar]
 *
 * CommentChar :: SourceCharacter but not LineTerminator
 * ```
 */

function readComment(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.COMMENT,
    start,
    position,
    body.slice(start + 1, position),
  );
}
/**
 * Reads a number token from the source file, either a FloatValue or an IntValue
 * depending on whether a FractionalPart or ExponentPart is encountered.
 *
 * ```
 * IntValue :: IntegerPart [lookahead != {Digit, `.`, NameStart}]
 *
 * IntegerPart ::
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit Digit*
 *
 * NegativeSign :: -
 *
 * NonZeroDigit :: Digit but not `0`
 *
 * FloatValue ::
 *   - IntegerPart FractionalPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart FractionalPart [lookahead != {Digit, `.`, NameStart}]
 *   - IntegerPart ExponentPart [lookahead != {Digit, `.`, NameStart}]
 *
 * FractionalPart :: . Digit+
 *
 * ExponentPart :: ExponentIndicator Sign? Digit+
 *
 * ExponentIndicator :: one of `e` `E`
 *
 * Sign :: one of + -
 * ```
 */

function readNumber(lexer, start, firstCode) {
  const body = lexer.source.body;
  let position = start;
  let code = firstCode;
  let isFloat = false; // NegativeSign (-)

  if (code === 0x002d) {
    code = body.charCodeAt(++position);
  } // Zero (0)

  if (code === 0x0030) {
    code = body.charCodeAt(++position);

    if ((0,characterClasses/* isDigit */.X1)(code)) {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid number, unexpected digit after 0: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  } else {
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Full stop (.)

  if (code === 0x002e) {
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // E e

  if (code === 0x0045 || code === 0x0065) {
    isFloat = true;
    code = body.charCodeAt(++position); // + -

    if (code === 0x002b || code === 0x002d) {
      code = body.charCodeAt(++position);
    }

    position = readDigits(lexer, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart

  if (code === 0x002e || (0,characterClasses/* isNameStart */.LQ)(code)) {
    throw syntaxError(
      lexer.source,
      position,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        position,
      )}.`,
    );
  }

  return createToken(
    lexer,
    isFloat ? tokenKind_TokenKind.FLOAT : tokenKind_TokenKind.INT,
    start,
    position,
    body.slice(start, position),
  );
}
/**
 * Returns the new position in the source after reading one or more digits.
 */

function readDigits(lexer, start, firstCode) {
  if (!(0,characterClasses/* isDigit */.X1)(firstCode)) {
    throw syntaxError(
      lexer.source,
      start,
      `Invalid number, expected digit but got: ${printCodePointAt(
        lexer,
        start,
      )}.`,
    );
  }

  const body = lexer.source.body;
  let position = start + 1; // +1 to skip first firstCode

  while ((0,characterClasses/* isDigit */.X1)(body.charCodeAt(position))) {
    ++position;
  }

  return position;
}
/**
 * Reads a single-quote string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `""` [lookahead != `"`]
 *   - `"` StringCharacter+ `"`
 *
 * StringCharacter ::
 *   - SourceCharacter but not `"` or `\` or LineTerminator
 *   - `\u` EscapedUnicode
 *   - `\` EscapedCharacter
 *
 * EscapedUnicode ::
 *   - `{` HexDigit+ `}`
 *   - HexDigit HexDigit HexDigit HexDigit
 *
 * EscapedCharacter :: one of `"` `\` `/` `b` `f` `n` `r` `t`
 * ```
 */

function readString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;
  let chunkStart = position;
  let value = '';

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Quote (")

    if (code === 0x0022) {
      value += body.slice(chunkStart, position);
      return createToken(lexer, tokenKind_TokenKind.STRING, start, position + 1, value);
    } // Escape Sequence (\)

    if (code === 0x005c) {
      value += body.slice(chunkStart, position);
      const escape =
        body.charCodeAt(position + 1) === 0x0075 // u
          ? body.charCodeAt(position + 2) === 0x007b // {
            ? readEscapedUnicodeVariableWidth(lexer, position)
            : readEscapedUnicodeFixedWidth(lexer, position)
          : readEscapedCharacter(lexer, position);
      value += escape.value;
      position += escape.size;
      chunkStart = position;
      continue;
    } // LineTerminator (\n | \r)

    if (code === 0x000a || code === 0x000d) {
      break;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
} // The string value and lexed size of an escape sequence.

function readEscapedUnicodeVariableWidth(lexer, position) {
  const body = lexer.source.body;
  let point = 0;
  let size = 3; // Cannot be larger than 12 chars (\u{00000000}).

  while (size < 12) {
    const code = body.charCodeAt(position + size++); // Closing Brace (})

    if (code === 0x007d) {
      // Must be at least 5 chars (\u{0}) and encode a Unicode scalar value.
      if (size < 5 || !isUnicodeScalarValue(point)) {
        break;
      }

      return {
        value: String.fromCodePoint(point),
        size,
      };
    } // Append this hex digit to the code point.

    point = (point << 4) | readHexDigit(code);

    if (point < 0) {
      break;
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(
      position,
      position + size,
    )}".`,
  );
}

function readEscapedUnicodeFixedWidth(lexer, position) {
  const body = lexer.source.body;
  const code = read16BitHexCode(body, position + 2);

  if (isUnicodeScalarValue(code)) {
    return {
      value: String.fromCodePoint(code),
      size: 6,
    };
  } // GraphQL allows JSON-style surrogate pair escape sequences, but only when
  // a valid pair is formed.

  if (isLeadingSurrogate(code)) {
    // \u
    if (
      body.charCodeAt(position + 6) === 0x005c &&
      body.charCodeAt(position + 7) === 0x0075
    ) {
      const trailingCode = read16BitHexCode(body, position + 8);

      if (isTrailingSurrogate(trailingCode)) {
        // JavaScript defines strings as a sequence of UTF-16 code units and
        // encodes Unicode code points above U+FFFF using a surrogate pair of
        // code units. Since this is a surrogate pair escape sequence, just
        // include both codes into the JavaScript string value. Had JavaScript
        // not been internally based on UTF-16, then this surrogate pair would
        // be decoded to retrieve the supplementary code point.
        return {
          value: String.fromCodePoint(code, trailingCode),
          size: 12,
        };
      }
    }
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid Unicode escape sequence: "${body.slice(position, position + 6)}".`,
  );
}
/**
 * Reads four hexadecimal characters and returns the positive integer that 16bit
 * hexadecimal string represents. For example, "000f" will return 15, and "dead"
 * will return 57005.
 *
 * Returns a negative number if any char was not a valid hexadecimal digit.
 */

function read16BitHexCode(body, position) {
  // readHexDigit() returns -1 on error. ORing a negative value with any other
  // value always produces a negative value.
  return (
    (readHexDigit(body.charCodeAt(position)) << 12) |
    (readHexDigit(body.charCodeAt(position + 1)) << 8) |
    (readHexDigit(body.charCodeAt(position + 2)) << 4) |
    readHexDigit(body.charCodeAt(position + 3))
  );
}
/**
 * Reads a hexadecimal character and returns its positive integer value (0-15).
 *
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 if the provided character code was not a valid hexadecimal digit.
 *
 * HexDigit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 *   - `A` `B` `C` `D` `E` `F`
 *   - `a` `b` `c` `d` `e` `f`
 */

function readHexDigit(code) {
  return code >= 0x0030 && code <= 0x0039 // 0-9
    ? code - 0x0030
    : code >= 0x0041 && code <= 0x0046 // A-F
    ? code - 0x0037
    : code >= 0x0061 && code <= 0x0066 // a-f
    ? code - 0x0057
    : -1;
}
/**
 * | Escaped Character | Code Point | Character Name               |
 * | ----------------- | ---------- | ---------------------------- |
 * | `"`               | U+0022     | double quote                 |
 * | `\`               | U+005C     | reverse solidus (back slash) |
 * | `/`               | U+002F     | solidus (forward slash)      |
 * | `b`               | U+0008     | backspace                    |
 * | `f`               | U+000C     | form feed                    |
 * | `n`               | U+000A     | line feed (new line)         |
 * | `r`               | U+000D     | carriage return              |
 * | `t`               | U+0009     | horizontal tab               |
 */

function readEscapedCharacter(lexer, position) {
  const body = lexer.source.body;
  const code = body.charCodeAt(position + 1);

  switch (code) {
    case 0x0022:
      // "
      return {
        value: '\u0022',
        size: 2,
      };

    case 0x005c:
      // \
      return {
        value: '\u005c',
        size: 2,
      };

    case 0x002f:
      // /
      return {
        value: '\u002f',
        size: 2,
      };

    case 0x0062:
      // b
      return {
        value: '\u0008',
        size: 2,
      };

    case 0x0066:
      // f
      return {
        value: '\u000c',
        size: 2,
      };

    case 0x006e:
      // n
      return {
        value: '\u000a',
        size: 2,
      };

    case 0x0072:
      // r
      return {
        value: '\u000d',
        size: 2,
      };

    case 0x0074:
      // t
      return {
        value: '\u0009',
        size: 2,
      };
  }

  throw syntaxError(
    lexer.source,
    position,
    `Invalid character escape sequence: "${body.slice(
      position,
      position + 2,
    )}".`,
  );
}
/**
 * Reads a block string token from the source file.
 *
 * ```
 * StringValue ::
 *   - `"""` BlockStringCharacter* `"""`
 *
 * BlockStringCharacter ::
 *   - SourceCharacter but not `"""` or `\"""`
 *   - `\"""`
 * ```
 */

function readBlockString(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let lineStart = lexer.lineStart;
  let position = start + 3;
  let chunkStart = position;
  let currentLine = '';
  const blockLines = [];

  while (position < bodyLength) {
    const code = body.charCodeAt(position); // Closing Triple-Quote (""")

    if (
      code === 0x0022 &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);
      const token = createToken(
        lexer,
        tokenKind_TokenKind.BLOCK_STRING,
        start,
        position + 3, // Return a string of the lines joined with U+000A.
        (0,blockString/* dedentBlockStringLines */.wv)(blockLines).join('\n'),
      );
      lexer.line += blockLines.length - 1;
      lexer.lineStart = lineStart;
      return token;
    } // Escaped Triple-Quote (\""")

    if (
      code === 0x005c &&
      body.charCodeAt(position + 1) === 0x0022 &&
      body.charCodeAt(position + 2) === 0x0022 &&
      body.charCodeAt(position + 3) === 0x0022
    ) {
      currentLine += body.slice(chunkStart, position);
      chunkStart = position + 1; // skip only slash

      position += 4;
      continue;
    } // LineTerminator

    if (code === 0x000a || code === 0x000d) {
      currentLine += body.slice(chunkStart, position);
      blockLines.push(currentLine);

      if (code === 0x000d && body.charCodeAt(position + 1) === 0x000a) {
        position += 2;
      } else {
        ++position;
      }

      currentLine = '';
      chunkStart = position;
      lineStart = position;
      continue;
    } // SourceCharacter

    if (isUnicodeScalarValue(code)) {
      ++position;
    } else if (isSupplementaryCodePoint(body, position)) {
      position += 2;
    } else {
      throw syntaxError(
        lexer.source,
        position,
        `Invalid character within String: ${printCodePointAt(
          lexer,
          position,
        )}.`,
      );
    }
  }

  throw syntaxError(lexer.source, position, 'Unterminated string.');
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * ```
 * Name ::
 *   - NameStart NameContinue* [lookahead != NameContinue]
 * ```
 */

function readName(lexer, start) {
  const body = lexer.source.body;
  const bodyLength = body.length;
  let position = start + 1;

  while (position < bodyLength) {
    const code = body.charCodeAt(position);

    if ((0,characterClasses/* isNameContinue */.HQ)(code)) {
      ++position;
    } else {
      break;
    }
  }

  return createToken(
    lexer,
    tokenKind_TokenKind.NAME,
    start,
    position,
    body.slice(start, position),
  );
}

// EXTERNAL MODULE: ./node_modules/graphql/language/source.mjs + 1 modules
var language_source = __webpack_require__(51270);
;// CONCATENATED MODULE: ./node_modules/graphql/language/parser.mjs







/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  const parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseValueLiteral(false);
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Similar to parseValue(), but raises a parse error if it encounters a
 * variable. The return type will be a constant value.
 */

function parseConstValue(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const value = parser.parseConstValueLiteral();
  parser.expectToken(TokenKind.EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  const parser = new Parser(source, options);
  parser.expectToken(TokenKind.SOF);
  const type = parser.parseTypeReference();
  parser.expectToken(TokenKind.EOF);
  return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

class Parser {
  constructor(source, options = {}) {
    const sourceObj = (0,language_source/* isSource */.T)(source) ? source : new language_source/* Source */.H(source);
    this._lexer = new Lexer(sourceObj);
    this._options = options;
    this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */

  parseName() {
    const token = this.expectToken(tokenKind_TokenKind.NAME);
    return this.node(token, {
      kind: kinds/* Kind.NAME */.h.NAME,
      value: token.value,
    });
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */

  parseDocument() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.DOCUMENT */.h.DOCUMENT,
      definitions: this.many(
        tokenKind_TokenKind.SOF,
        this.parseDefinition,
        tokenKind_TokenKind.EOF,
      ),
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */

  parseDefinition() {
    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.parseOperationDefinition();
    } // Many definitions begin with a description and require a lookahead.

    const hasDescription = this.peekDescription();
    const keywordToken = hasDescription
      ? this._lexer.lookahead()
      : this._lexer.token;

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }

      if (hasDescription) {
        throw syntaxError(
          this._lexer.source,
          this._lexer.token.start,
          'Unexpected description, descriptions are supported only on type definitions.',
        );
      }

      switch (keywordToken.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    }

    throw this.unexpected(keywordToken);
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */

  parseOperationDefinition() {
    const start = this._lexer.token;

    if (this.peek(tokenKind_TokenKind.BRACE_L)) {
      return this.node(start, {
        kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
        operation: ast/* OperationTypeNode.QUERY */.ku.QUERY,
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
      });
    }

    const operation = this.parseOperationType();
    let name;

    if (this.peek(tokenKind_TokenKind.NAME)) {
      name = this.parseName();
    }

    return this.node(start, {
      kind: kinds/* Kind.OPERATION_DEFINITION */.h.OPERATION_DEFINITION,
      operation,
      name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */

  parseOperationType() {
    const operationToken = this.expectToken(tokenKind_TokenKind.NAME);

    switch (operationToken.value) {
      case 'query':
        return ast/* OperationTypeNode.QUERY */.ku.QUERY;

      case 'mutation':
        return ast/* OperationTypeNode.MUTATION */.ku.MUTATION;

      case 'subscription':
        return ast/* OperationTypeNode.SUBSCRIPTION */.ku.SUBSCRIPTION;
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */

  parseVariableDefinitions() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseVariableDefinition,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */

  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.VARIABLE_DEFINITION */.h.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(tokenKind_TokenKind.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
        ? this.parseConstValueLiteral()
        : undefined,
      directives: this.parseConstDirectives(),
    });
  }
  /**
   * Variable : $ Name
   */

  parseVariable() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.DOLLAR);
    return this.node(start, {
      kind: kinds/* Kind.VARIABLE */.h.VARIABLE,
      name: this.parseName(),
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */

  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.SELECTION_SET */.h.SELECTION_SET,
      selections: this.many(
        tokenKind_TokenKind.BRACE_L,
        this.parseSelection,
        tokenKind_TokenKind.BRACE_R,
      ),
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */

  parseSelection() {
    return this.peek(tokenKind_TokenKind.SPREAD)
      ? this.parseFragment()
      : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */

  parseField() {
    const start = this._lexer.token;
    const nameOrAlias = this.parseName();
    let alias;
    let name;

    if (this.expectOptionalToken(tokenKind_TokenKind.COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return this.node(start, {
      kind: kinds/* Kind.FIELD */.h.FIELD,
      alias,
      name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(tokenKind_TokenKind.BRACE_L)
        ? this.parseSelectionSet()
        : undefined,
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */

  parseArguments(isConst) {
    const item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(tokenKind_TokenKind.PAREN_L, item, tokenKind_TokenKind.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */

  parseArgument(isConst = false) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds/* Kind.ARGUMENT */.h.ARGUMENT,
      name,
      value: this.parseValueLiteral(isConst),
    });
  }

  parseConstArgument() {
    return this.parseArgument(true);
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */

  parseFragment() {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.SPREAD);
    const hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(tokenKind_TokenKind.NAME)) {
      return this.node(start, {
        kind: kinds/* Kind.FRAGMENT_SPREAD */.h.FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
      });
    }

    return this.node(start, {
      kind: kinds/* Kind.INLINE_FRAGMENT */.h.INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */

  parseFragmentDefinition() {
    const start = this._lexer.token;
    this.expectKeyword('fragment'); // Legacy support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (this._options.allowLegacyFragmentVariables === true) {
      return this.node(start, {
        kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
      });
    }

    return this.node(start, {
      kind: kinds/* Kind.FRAGMENT_DEFINITION */.h.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
    });
  }
  /**
   * FragmentName : Name but not `on`
   */

  parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseValueLiteral(isConst) {
    const token = this._lexer.token;

    switch (token.kind) {
      case tokenKind_TokenKind.BRACKET_L:
        return this.parseList(isConst);

      case tokenKind_TokenKind.BRACE_L:
        return this.parseObject(isConst);

      case tokenKind_TokenKind.INT:
        this.advanceLexer();
        return this.node(token, {
          kind: kinds/* Kind.INT */.h.INT,
          value: token.value,
        });

      case tokenKind_TokenKind.FLOAT:
        this.advanceLexer();
        return this.node(token, {
          kind: kinds/* Kind.FLOAT */.h.FLOAT,
          value: token.value,
        });

      case tokenKind_TokenKind.STRING:
      case tokenKind_TokenKind.BLOCK_STRING:
        return this.parseStringLiteral();

      case tokenKind_TokenKind.NAME:
        this.advanceLexer();

        switch (token.value) {
          case 'true':
            return this.node(token, {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: true,
            });

          case 'false':
            return this.node(token, {
              kind: kinds/* Kind.BOOLEAN */.h.BOOLEAN,
              value: false,
            });

          case 'null':
            return this.node(token, {
              kind: kinds/* Kind.NULL */.h.NULL,
            });

          default:
            return this.node(token, {
              kind: kinds/* Kind.ENUM */.h.ENUM,
              value: token.value,
            });
        }

      case tokenKind_TokenKind.DOLLAR:
        if (isConst) {
          this.expectToken(tokenKind_TokenKind.DOLLAR);

          if (this._lexer.token.kind === tokenKind_TokenKind.NAME) {
            const varName = this._lexer.token.value;
            throw syntaxError(
              this._lexer.source,
              token.start,
              `Unexpected variable "$${varName}" in constant value.`,
            );
          } else {
            throw this.unexpected(token);
          }
        }

        return this.parseVariable();

      default:
        throw this.unexpected();
    }
  }

  parseConstValueLiteral() {
    return this.parseValueLiteral(true);
  }

  parseStringLiteral() {
    const token = this._lexer.token;
    this.advanceLexer();
    return this.node(token, {
      kind: kinds/* Kind.STRING */.h.STRING,
      value: token.value,
      block: token.kind === tokenKind_TokenKind.BLOCK_STRING,
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */

  parseList(isConst) {
    const item = () => this.parseValueLiteral(isConst);

    return this.node(this._lexer.token, {
      kind: kinds/* Kind.LIST */.h.LIST,
      values: this.any(tokenKind_TokenKind.BRACKET_L, item, tokenKind_TokenKind.BRACKET_R),
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */

  parseObject(isConst) {
    const item = () => this.parseObjectField(isConst);

    return this.node(this._lexer.token, {
      kind: kinds/* Kind.OBJECT */.h.OBJECT,
      fields: this.any(tokenKind_TokenKind.BRACE_L, item, tokenKind_TokenKind.BRACE_R),
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */

  parseObjectField(isConst) {
    const start = this._lexer.token;
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    return this.node(start, {
      kind: kinds/* Kind.OBJECT_FIELD */.h.OBJECT_FIELD,
      name,
      value: this.parseValueLiteral(isConst),
    });
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */

  parseDirectives(isConst) {
    const directives = [];

    while (this.peek(tokenKind_TokenKind.AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }

  parseConstDirectives() {
    return this.parseDirectives(true);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */

  parseDirective(isConst) {
    const start = this._lexer.token;
    this.expectToken(tokenKind_TokenKind.AT);
    return this.node(start, {
      kind: kinds/* Kind.DIRECTIVE */.h.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
    });
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */

  parseTypeReference() {
    const start = this._lexer.token;
    let type;

    if (this.expectOptionalToken(tokenKind_TokenKind.BRACKET_L)) {
      const innerType = this.parseTypeReference();
      this.expectToken(tokenKind_TokenKind.BRACKET_R);
      type = this.node(start, {
        kind: kinds/* Kind.LIST_TYPE */.h.LIST_TYPE,
        type: innerType,
      });
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(tokenKind_TokenKind.BANG)) {
      return this.node(start, {
        kind: kinds/* Kind.NON_NULL_TYPE */.h.NON_NULL_TYPE,
        type,
      });
    }

    return type;
  }
  /**
   * NamedType : Name
   */

  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: kinds/* Kind.NAMED_TYPE */.h.NAMED_TYPE,
      name: this.parseName(),
    });
  } // Implements the parsing rules in the Type Definition section.

  peekDescription() {
    return this.peek(tokenKind_TokenKind.STRING) || this.peek(tokenKind_TokenKind.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */

  parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */

  parseSchemaDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.many(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
    return this.node(start, {
      kind: kinds/* Kind.SCHEMA_DEFINITION */.h.SCHEMA_DEFINITION,
      description,
      directives,
      operationTypes,
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */

  parseOperationTypeDefinition() {
    const start = this._lexer.token;
    const operation = this.parseOperationType();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseNamedType();
    return this.node(start, {
      kind: kinds/* Kind.OPERATION_TYPE_DEFINITION */.h.OPERATION_TYPE_DEFINITION,
      operation,
      type,
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */

  parseScalarTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.SCALAR_TYPE_DEFINITION */.h.SCALAR_TYPE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */

  parseObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.OBJECT_TYPE_DEFINITION */.h.OBJECT_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */

  parseImplementsInterfaces() {
    return this.expectOptionalKeyword('implements')
      ? this.delimitedMany(tokenKind_TokenKind.AMP, this.parseNamedType)
      : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */

  parseFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseFieldDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */

  parseFieldDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.FIELD_DEFINITION */.h.FIELD_DEFINITION,
      description,
      name,
      arguments: args,
      type,
      directives,
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */

  parseArgumentDefs() {
    return this.optionalMany(
      tokenKind_TokenKind.PAREN_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.PAREN_R,
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */

  parseInputValueDef() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseName();
    this.expectToken(tokenKind_TokenKind.COLON);
    const type = this.parseTypeReference();
    let defaultValue;

    if (this.expectOptionalToken(tokenKind_TokenKind.EQUALS)) {
      defaultValue = this.parseConstValueLiteral();
    }

    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.INPUT_VALUE_DEFINITION */.h.INPUT_VALUE_DEFINITION,
      description,
      name,
      type,
      defaultValue,
      directives,
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */

  parseInterfaceTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.INTERFACE_TYPE_DEFINITION */.h.INTERFACE_TYPE_DEFINITION,
      description,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */

  parseUnionTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();
    return this.node(start, {
      kind: kinds/* Kind.UNION_TYPE_DEFINITION */.h.UNION_TYPE_DEFINITION,
      description,
      name,
      directives,
      types,
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */

  parseUnionMemberTypes() {
    return this.expectOptionalToken(tokenKind_TokenKind.EQUALS)
      ? this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseNamedType)
      : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */

  parseEnumTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();
    return this.node(start, {
      kind: kinds/* Kind.ENUM_TYPE_DEFINITION */.h.ENUM_TYPE_DEFINITION,
      description,
      name,
      directives,
      values,
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */

  parseEnumValuesDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseEnumValueDefinition,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */

  parseEnumValueDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    const name = this.parseEnumValueName();
    const directives = this.parseConstDirectives();
    return this.node(start, {
      kind: kinds/* Kind.ENUM_VALUE_DEFINITION */.h.ENUM_VALUE_DEFINITION,
      description,
      name,
      directives,
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */

  parseEnumValueName() {
    if (
      this._lexer.token.value === 'true' ||
      this._lexer.token.value === 'false' ||
      this._lexer.token.value === 'null'
    ) {
      throw syntaxError(
        this._lexer.source,
        this._lexer.token.start,
        `${getTokenDesc(
          this._lexer.token,
        )} is reserved and cannot be used for an enum value.`,
      );
    }

    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */

  parseInputObjectTypeDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();
    return this.node(start, {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_DEFINITION */.h.INPUT_OBJECT_TYPE_DEFINITION,
      description,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */

  parseInputFieldsDefinition() {
    return this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseInputValueDef,
      tokenKind_TokenKind.BRACE_R,
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */

  parseTypeSystemExtension() {
    const keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === tokenKind_TokenKind.NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */

  parseSchemaExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    const directives = this.parseConstDirectives();
    const operationTypes = this.optionalMany(
      tokenKind_TokenKind.BRACE_L,
      this.parseOperationTypeDefinition,
      tokenKind_TokenKind.BRACE_R,
    );

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.SCHEMA_EXTENSION */.h.SCHEMA_EXTENSION,
      directives,
      operationTypes,
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */

  parseScalarTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    const name = this.parseName();
    const directives = this.parseConstDirectives();

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.SCALAR_TYPE_EXTENSION */.h.SCALAR_TYPE_EXTENSION,
      name,
      directives,
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */

  parseObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.OBJECT_TYPE_EXTENSION */.h.OBJECT_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */

  parseInterfaceTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    const name = this.parseName();
    const interfaces = this.parseImplementsInterfaces();
    const directives = this.parseConstDirectives();
    const fields = this.parseFieldsDefinition();

    if (
      interfaces.length === 0 &&
      directives.length === 0 &&
      fields.length === 0
    ) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.INTERFACE_TYPE_EXTENSION */.h.INTERFACE_TYPE_EXTENSION,
      name,
      interfaces,
      directives,
      fields,
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */

  parseUnionTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.UNION_TYPE_EXTENSION */.h.UNION_TYPE_EXTENSION,
      name,
      directives,
      types,
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */

  parseEnumTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.ENUM_TYPE_EXTENSION */.h.ENUM_TYPE_EXTENSION,
      name,
      directives,
      values,
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */

  parseInputObjectTypeExtension() {
    const start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    const name = this.parseName();
    const directives = this.parseConstDirectives();
    const fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return this.node(start, {
      kind: kinds/* Kind.INPUT_OBJECT_TYPE_EXTENSION */.h.INPUT_OBJECT_TYPE_EXTENSION,
      name,
      directives,
      fields,
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */

  parseDirectiveDefinition() {
    const start = this._lexer.token;
    const description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(tokenKind_TokenKind.AT);
    const name = this.parseName();
    const args = this.parseArgumentDefs();
    const repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    const locations = this.parseDirectiveLocations();
    return this.node(start, {
      kind: kinds/* Kind.DIRECTIVE_DEFINITION */.h.DIRECTIVE_DEFINITION,
      description,
      name,
      arguments: args,
      repeatable,
      locations,
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */

  parseDirectiveLocations() {
    return this.delimitedMany(tokenKind_TokenKind.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */

  parseDirectiveLocation() {
    const start = this._lexer.token;
    const name = this.parseName();

    if (Object.prototype.hasOwnProperty.call(DirectiveLocation, name.value)) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */

  node(startToken, node) {
    if (this._options.noLocation !== true) {
      node.loc = new ast/* Location */.Ye(
        startToken,
        this._lexer.lastToken,
        this._lexer.source,
      );
    }

    return node;
  }
  /**
   * Determines if the next token is of a given kind
   */

  peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return token;
    }

    throw syntaxError(
      this._lexer.source,
      token.start,
      `Expected ${getTokenKindDesc(kind)}, found ${getTokenDesc(token)}.`,
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalToken(kind) {
    const token = this._lexer.token;

    if (token.kind === kind) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */

  expectKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this.advanceLexer();
    } else {
      throw syntaxError(
        this._lexer.source,
        token.start,
        `Expected "${value}", found ${getTokenDesc(token)}.`,
      );
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */

  expectOptionalKeyword(value) {
    const token = this._lexer.token;

    if (token.kind === tokenKind_TokenKind.NAME && token.value === value) {
      this.advanceLexer();
      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */

  unexpected(atToken) {
    const token =
      atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return syntaxError(
      this._lexer.source,
      token.start,
      `Unexpected ${getTokenDesc(token)}.`,
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      const nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */

  many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */

  delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    const nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  }

  advanceLexer() {
    const { maxTokens } = this._options;

    const token = this._lexer.advance();

    if (maxTokens !== undefined && token.kind !== tokenKind_TokenKind.EOF) {
      ++this._tokenCounter;

      if (this._tokenCounter > maxTokens) {
        throw syntaxError(
          this._lexer.source,
          token.start,
          `Document contains more that ${maxTokens} tokens. Parsing aborted.`,
        );
      }
    }
  }
}
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  const value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? ` "${value}"` : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */

function getTokenKindDesc(kind) {
  return isPunctuatorTokenKind(kind) ? `"${kind}"` : kind;
}

;// CONCATENATED MODULE: ./node_modules/graphql-tag/lib/index.js


var docCache = new Map();
var fragmentSourceMap = new Map();
var printFragmentWarnings = true;
var experimentalFragmentVariables = false;
function normalize(string) {
    return string.replace(/[\s,]+/g, ' ').trim();
}
function cacheKeyFromLoc(loc) {
    return normalize(loc.source.body.substring(loc.start, loc.end));
}
function processFragments(ast) {
    var seenKeys = new Set();
    var definitions = [];
    ast.definitions.forEach(function (fragmentDefinition) {
        if (fragmentDefinition.kind === 'FragmentDefinition') {
            var fragmentName = fragmentDefinition.name.value;
            var sourceKey = cacheKeyFromLoc(fragmentDefinition.loc);
            var sourceKeySet = fragmentSourceMap.get(fragmentName);
            if (sourceKeySet && !sourceKeySet.has(sourceKey)) {
                if (printFragmentWarnings) {
                    console.warn("Warning: fragment with name " + fragmentName + " already exists.\n"
                        + "graphql-tag enforces all fragment names across your application to be unique; read more about\n"
                        + "this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names");
                }
            }
            else if (!sourceKeySet) {
                fragmentSourceMap.set(fragmentName, sourceKeySet = new Set);
            }
            sourceKeySet.add(sourceKey);
            if (!seenKeys.has(sourceKey)) {
                seenKeys.add(sourceKey);
                definitions.push(fragmentDefinition);
            }
        }
        else {
            definitions.push(fragmentDefinition);
        }
    });
    return (0,tslib_es6.__assign)((0,tslib_es6.__assign)({}, ast), { definitions: definitions });
}
function stripLoc(doc) {
    var workSet = new Set(doc.definitions);
    workSet.forEach(function (node) {
        if (node.loc)
            delete node.loc;
        Object.keys(node).forEach(function (key) {
            var value = node[key];
            if (value && typeof value === 'object') {
                workSet.add(value);
            }
        });
    });
    var loc = doc.loc;
    if (loc) {
        delete loc.startToken;
        delete loc.endToken;
    }
    return doc;
}
function parseDocument(source) {
    var cacheKey = normalize(source);
    if (!docCache.has(cacheKey)) {
        var parsed = parse(source, {
            experimentalFragmentVariables: experimentalFragmentVariables,
            allowLegacyFragmentVariables: experimentalFragmentVariables
        });
        if (!parsed || parsed.kind !== 'Document') {
            throw new Error('Not a valid GraphQL document.');
        }
        docCache.set(cacheKey, stripLoc(processFragments(parsed)));
    }
    return docCache.get(cacheKey);
}
function gql(literals) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (typeof literals === 'string') {
        literals = [literals];
    }
    var result = literals[0];
    args.forEach(function (arg, i) {
        if (arg && arg.kind === 'Document') {
            result += arg.loc.source.body;
        }
        else {
            result += arg;
        }
        result += literals[i + 1];
    });
    return parseDocument(result);
}
function resetCaches() {
    docCache.clear();
    fragmentSourceMap.clear();
}
function disableFragmentWarnings() {
    printFragmentWarnings = false;
}
function enableExperimentalFragmentVariables() {
    experimentalFragmentVariables = true;
}
function disableExperimentalFragmentVariables() {
    experimentalFragmentVariables = false;
}
var extras = {
    gql: gql,
    resetCaches: resetCaches,
    disableFragmentWarnings: disableFragmentWarnings,
    enableExperimentalFragmentVariables: enableExperimentalFragmentVariables,
    disableExperimentalFragmentVariables: disableExperimentalFragmentVariables
};
(function (gql_1) {
    gql_1.gql = extras.gql, gql_1.resetCaches = extras.resetCaches, gql_1.disableFragmentWarnings = extras.disableFragmentWarnings, gql_1.enableExperimentalFragmentVariables = extras.enableExperimentalFragmentVariables, gql_1.disableExperimentalFragmentVariables = extras.disableExperimentalFragmentVariables;
})(gql || (gql = {}));
gql["default"] = gql;
/* harmony default export */ var lib = (gql);
//# sourceMappingURL=index.js.map

/***/ }),

/***/ 8679:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(21296);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),

/***/ 96103:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),

/***/ 21296:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(96103);
} else {}


/***/ }),

/***/ 80645:
/***/ (function(__unused_webpack_module, exports) {

/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
exports.read = function (buffer, offset, isLE, mLen, nBytes) {
  var e, m
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var nBits = -7
  var i = isLE ? (nBytes - 1) : 0
  var d = isLE ? -1 : 1
  var s = buffer[offset + i]

  i += d

  e = s & ((1 << (-nBits)) - 1)
  s >>= (-nBits)
  nBits += eLen
  for (; nBits > 0; e = (e * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  m = e & ((1 << (-nBits)) - 1)
  e >>= (-nBits)
  nBits += mLen
  for (; nBits > 0; m = (m * 256) + buffer[offset + i], i += d, nBits -= 8) {}

  if (e === 0) {
    e = 1 - eBias
  } else if (e === eMax) {
    return m ? NaN : ((s ? -1 : 1) * Infinity)
  } else {
    m = m + Math.pow(2, mLen)
    e = e - eBias
  }
  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
}

exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
  var e, m, c
  var eLen = (nBytes * 8) - mLen - 1
  var eMax = (1 << eLen) - 1
  var eBias = eMax >> 1
  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
  var i = isLE ? 0 : (nBytes - 1)
  var d = isLE ? 1 : -1
  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0

  value = Math.abs(value)

  if (isNaN(value) || value === Infinity) {
    m = isNaN(value) ? 1 : 0
    e = eMax
  } else {
    e = Math.floor(Math.log(value) / Math.LN2)
    if (value * (c = Math.pow(2, -e)) < 1) {
      e--
      c *= 2
    }
    if (e + eBias >= 1) {
      value += rt / c
    } else {
      value += rt * Math.pow(2, 1 - eBias)
    }
    if (value * c >= 2) {
      e++
      c /= 2
    }

    if (e + eBias >= eMax) {
      m = 0
      e = eMax
    } else if (e + eBias >= 1) {
      m = ((value * c) - 1) * Math.pow(2, mLen)
      e = e + eBias
    } else {
      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
      e = 0
    }
  }

  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}

  e = (e << mLen) | m
  eLen += mLen
  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}

  buffer[offset + i - d] |= s * 128
}


/***/ }),

/***/ 8293:
/***/ (function(module) {

const CODES = {
  JOSEAlgNotWhitelisted: 'ERR_JOSE_ALG_NOT_WHITELISTED',
  JOSECritNotUnderstood: 'ERR_JOSE_CRIT_NOT_UNDERSTOOD',
  JOSEInvalidEncoding: 'ERR_JOSE_INVALID_ENCODING',
  JOSEMultiError: 'ERR_JOSE_MULTIPLE_ERRORS',
  JOSENotSupported: 'ERR_JOSE_NOT_SUPPORTED',
  JWEDecryptionFailed: 'ERR_JWE_DECRYPTION_FAILED',
  JWEInvalid: 'ERR_JWE_INVALID',
  JWKImportFailed: 'ERR_JWK_IMPORT_FAILED',
  JWKInvalid: 'ERR_JWK_INVALID',
  JWKKeySupport: 'ERR_JWK_KEY_SUPPORT',
  JWKSNoMatchingKey: 'ERR_JWKS_NO_MATCHING_KEY',
  JWSInvalid: 'ERR_JWS_INVALID',
  JWSVerificationFailed: 'ERR_JWS_VERIFICATION_FAILED',
  JWTClaimInvalid: 'ERR_JWT_CLAIM_INVALID',
  JWTExpired: 'ERR_JWT_EXPIRED',
  JWTMalformed: 'ERR_JWT_MALFORMED'
}

const DEFAULT_MESSAGES = {
  JWEDecryptionFailed: 'decryption operation failed',
  JWEInvalid: 'JWE invalid',
  JWKSNoMatchingKey: 'no matching key found in the KeyStore',
  JWSInvalid: 'JWS invalid',
  JWSVerificationFailed: 'signature verification failed'
}

class JOSEError extends Error {
  constructor (message) {
    super(message)
    if (message === undefined) {
      this.message = DEFAULT_MESSAGES[this.constructor.name]
    }
    this.name = this.constructor.name
    this.code = CODES[this.constructor.name]
    Error.captureStackTrace(this, this.constructor)
  }
}

const isMulti = e => e instanceof JOSEMultiError
class JOSEMultiError extends JOSEError {
  constructor (errors) {
    super()
    let i
    while ((i = errors.findIndex(isMulti)) && i !== -1) {
      errors.splice(i, 1, ...errors[i])
    }
    Object.defineProperty(this, 'errors', { value: errors })
  }

  * [Symbol.iterator] () {
    for (const error of this.errors) {
      yield error
    }
  }
}
module.exports.JOSEError = JOSEError

module.exports.JOSEAlgNotWhitelisted = class JOSEAlgNotWhitelisted extends JOSEError {}
module.exports.JOSECritNotUnderstood = class JOSECritNotUnderstood extends JOSEError {}
module.exports.JOSEInvalidEncoding = class JOSEInvalidEncoding extends JOSEError {}
module.exports.JOSEMultiError = JOSEMultiError
module.exports.JOSENotSupported = class JOSENotSupported extends JOSEError {}

module.exports.JWEDecryptionFailed = class JWEDecryptionFailed extends JOSEError {}
module.exports.JWEInvalid = class JWEInvalid extends JOSEError {}

module.exports.JWKImportFailed = class JWKImportFailed extends JOSEError {}
module.exports.JWKInvalid = class JWKInvalid extends JOSEError {}
module.exports.JWKKeySupport = class JWKKeySupport extends JOSEError {}

module.exports.JWKSNoMatchingKey = class JWKSNoMatchingKey extends JOSEError {}

module.exports.JWSInvalid = class JWSInvalid extends JOSEError {}
module.exports.JWSVerificationFailed = class JWSVerificationFailed extends JOSEError {}

class JWTClaimInvalid extends JOSEError {
  constructor (message, claim = 'unspecified', reason = 'unspecified') {
    super(message)
    this.claim = claim
    this.reason = reason
  }
}
module.exports.JWTClaimInvalid = JWTClaimInvalid
module.exports.JWTExpired = class JWTExpired extends JWTClaimInvalid {}
module.exports.JWTMalformed = class JWTMalformed extends JOSEError {}


/***/ }),

/***/ 16200:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const oids = __webpack_require__(23020)

module.exports = function () {
  this.seq().obj(
    this.key('algorithm').objid(oids),
    this.key('parameters').optional().choice({ namedCurve: this.objid(oids), null: this.null_() })
  )
}


/***/ }),

/***/ 11192:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const oids = __webpack_require__(23020)

module.exports = function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('privateKey').octstr(),
    this.key('parameters').explicit(0).optional().choice({ namedCurve: this.objid(oids) }),
    this.key('publicKey').explicit(1).optional().bitstr()
  )
}


/***/ }),

/***/ 42993:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const asn1 = __webpack_require__(16617)

const types = new Map()

const AlgorithmIdentifier = asn1.define('AlgorithmIdentifier', __webpack_require__(16200))
types.set('AlgorithmIdentifier', AlgorithmIdentifier)

const ECPrivateKey = asn1.define('ECPrivateKey', __webpack_require__(11192))
types.set('ECPrivateKey', ECPrivateKey)

const PrivateKeyInfo = asn1.define('PrivateKeyInfo', __webpack_require__(97895)(AlgorithmIdentifier))
types.set('PrivateKeyInfo', PrivateKeyInfo)

const PublicKeyInfo = asn1.define('PublicKeyInfo', __webpack_require__(35910)(AlgorithmIdentifier))
types.set('PublicKeyInfo', PublicKeyInfo)

const PrivateKey = asn1.define('PrivateKey', __webpack_require__(53960))
types.set('PrivateKey', PrivateKey)

const OneAsymmetricKey = asn1.define('OneAsymmetricKey', __webpack_require__(18676)(AlgorithmIdentifier, PrivateKey))
types.set('OneAsymmetricKey', OneAsymmetricKey)

const RSAPrivateKey = asn1.define('RSAPrivateKey', __webpack_require__(40893))
types.set('RSAPrivateKey', RSAPrivateKey)

const RSAPublicKey = asn1.define('RSAPublicKey', __webpack_require__(99778))
types.set('RSAPublicKey', RSAPublicKey)

module.exports = types


/***/ }),

/***/ 23020:
/***/ (function(module) {

const oids = {
  '1 2 840 10045 3 1 7': 'P-256',
  '1 3 132 0 10': 'secp256k1',
  '1 3 132 0 34': 'P-384',
  '1 3 132 0 35': 'P-521',
  '1 2 840 10045 2 1': 'ecPublicKey',
  '1 2 840 113549 1 1 1': 'rsaEncryption',
  '1 3 101 110': 'X25519',
  '1 3 101 111': 'X448',
  '1 3 101 112': 'Ed25519',
  '1 3 101 113': 'Ed448'
}

module.exports = oids


/***/ }),

/***/ 18676:
/***/ (function(module) {

module.exports = (AlgorithmIdentifier, PrivateKey) => function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('privateKey').use(PrivateKey)
  )
}


/***/ }),

/***/ 53960:
/***/ (function(module) {

module.exports = function () {
  this.octstr().contains().obj(
    this.key('privateKey').octstr()
  )
}


/***/ }),

/***/ 97895:
/***/ (function(module) {

module.exports = (AlgorithmIdentifier) => function () {
  this.seq().obj(
    this.key('version').int(),
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('privateKey').octstr()
  )
}


/***/ }),

/***/ 35910:
/***/ (function(module) {

module.exports = AlgorithmIdentifier => function () {
  this.seq().obj(
    this.key('algorithm').use(AlgorithmIdentifier),
    this.key('publicKey').bitstr()
  )
}


/***/ }),

/***/ 40893:
/***/ (function(module) {

module.exports = function () {
  this.seq().obj(
    this.key('version').int({ 0: 'two-prime', 1: 'multi' }),
    this.key('n').int(),
    this.key('e').int(),
    this.key('d').int(),
    this.key('p').int(),
    this.key('q').int(),
    this.key('dp').int(),
    this.key('dq').int(),
    this.key('qi').int()
  )
}


/***/ }),

/***/ 99778:
/***/ (function(module) {

module.exports = function () {
  this.seq().obj(
    this.key('n').int(),
    this.key('e').int()
  )
}


/***/ }),

/***/ 37448:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
let encode
let encodeBuffer
if (Buffer.isEncoding('base64url')) {
  encode = (input, encoding = 'utf8') => Buffer.from(input, encoding).toString('base64url')
  encodeBuffer = (buf) => buf.toString('base64url')
} else {
  const fromBase64 = (base64) => base64.replace(/=/g, '').replace(/\+/g, '-').replace(/\//g, '_')
  encode = (input, encoding = 'utf8') => fromBase64(Buffer.from(input, encoding).toString('base64'))
  encodeBuffer = (buf) => fromBase64(buf.toString('base64'))
}

const decodeToBuffer = (input) => {
  return Buffer.from(input, 'base64')
}

const decode = (input, encoding = 'utf8') => {
  return decodeToBuffer(input).toString(encoding)
}

const b64uJSON = {
  encode: (input) => {
    return encode(JSON.stringify(input))
  },
  decode: (input, encoding = 'utf8') => {
    return JSON.parse(decode(input, encoding))
  }
}

b64uJSON.decode.try = (input, encoding = 'utf8') => {
  try {
    return b64uJSON.decode(input, encoding)
  } catch (err) {
    return decode(input, encoding)
  }
}

const bnToBuf = (bn) => {
  let hex = BigInt(bn).toString(16)
  if (hex.length % 2) {
    hex = `0${hex}`
  }

  const len = hex.length / 2
  const u8 = new Uint8Array(len)

  let i = 0
  let j = 0
  while (i < len) {
    u8[i] = parseInt(hex.slice(j, j + 2), 16)
    i += 1
    j += 2
  }

  return u8
}

const encodeBigInt = (bn) => encodeBuffer(Buffer.from(bnToBuf(bn)))

module.exports.decode = decode
module.exports.decodeToBuffer = decodeToBuffer
module.exports.encode = encode
module.exports.encodeBuffer = encodeBuffer
module.exports.JSON = b64uJSON
module.exports.encodeBigInt = encodeBigInt


/***/ }),

/***/ 92931:
/***/ (function(module) {

module.exports.KEYOBJECT = Symbol('KEYOBJECT')
module.exports.PRIVATE_MEMBERS = Symbol('PRIVATE_MEMBERS')
module.exports.PUBLIC_MEMBERS = Symbol('PUBLIC_MEMBERS')
module.exports.THUMBPRINT_MATERIAL = Symbol('THUMBPRINT_MATERIAL')
module.exports.JWK_MEMBERS = Symbol('JWK_MEMBERS')
module.exports.KEY_MANAGEMENT_ENCRYPT = Symbol('KEY_MANAGEMENT_ENCRYPT')
module.exports.KEY_MANAGEMENT_DECRYPT = Symbol('KEY_MANAGEMENT_DECRYPT')

const USES_MAPPING = {
  sig: new Set(['sign', 'verify']),
  enc: new Set(['encrypt', 'decrypt', 'wrapKey', 'unwrapKey', 'deriveKey'])
}
const OPS = new Set([...USES_MAPPING.sig, ...USES_MAPPING.enc])
const USES = new Set(Object.keys(USES_MAPPING))

module.exports.USES_MAPPING = USES_MAPPING
module.exports.OPS = OPS
module.exports.USES = USES


/***/ }),

/***/ 49270:
/***/ (function(module) {

module.exports = obj => JSON.parse(JSON.stringify(obj))


/***/ }),

/***/ 62867:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const MAX_OCTET = 0x80
const CLASS_UNIVERSAL = 0
const PRIMITIVE_BIT = 0x20
const TAG_SEQ = 0x10
const TAG_INT = 0x02
const ENCODED_TAG_SEQ = (TAG_SEQ | PRIMITIVE_BIT) | (CLASS_UNIVERSAL << 6)
const ENCODED_TAG_INT = TAG_INT | (CLASS_UNIVERSAL << 6)

const getParamSize = keySize => ((keySize / 8) | 0) + (keySize % 8 === 0 ? 0 : 1)

const paramBytesForAlg = {
  ES256: getParamSize(256),
  ES256K: getParamSize(256),
  ES384: getParamSize(384),
  ES512: getParamSize(521)
}

const countPadding = (buf, start, stop) => {
  let padding = 0
  while (start + padding < stop && buf[start + padding] === 0) {
    ++padding
  }

  const needsSign = buf[start + padding] >= MAX_OCTET
  if (needsSign) {
    --padding
  }

  return padding
}

module.exports.derToJose = (signature, alg) => {
  if (!Buffer.isBuffer(signature)) {
    throw new TypeError('ECDSA signature must be a Buffer')
  }

  if (!paramBytesForAlg[alg]) {
    throw new Error(`Unknown algorithm "${alg}"`)
  }

  const paramBytes = paramBytesForAlg[alg]

  // the DER encoded param should at most be the param size, plus a padding
  // zero, since due to being a signed integer
  const maxEncodedParamLength = paramBytes + 1

  const inputLength = signature.length

  let offset = 0
  if (signature[offset++] !== ENCODED_TAG_SEQ) {
    throw new Error('Could not find expected "seq"')
  }

  let seqLength = signature[offset++]
  if (seqLength === (MAX_OCTET | 1)) {
    seqLength = signature[offset++]
  }

  if (inputLength - offset < seqLength) {
    throw new Error(`"seq" specified length of ${seqLength}", only ${inputLength - offset}" remaining`)
  }

  if (signature[offset++] !== ENCODED_TAG_INT) {
    throw new Error('Could not find expected "int" for "r"')
  }

  const rLength = signature[offset++]

  if (inputLength - offset - 2 < rLength) {
    throw new Error(`"r" specified length of "${rLength}", only "${inputLength - offset - 2}" available`)
  }

  if (maxEncodedParamLength < rLength) {
    throw new Error(`"r" specified length of "${rLength}", max of "${maxEncodedParamLength}" is acceptable`)
  }

  const rOffset = offset
  offset += rLength

  if (signature[offset++] !== ENCODED_TAG_INT) {
    throw new Error('Could not find expected "int" for "s"')
  }

  const sLength = signature[offset++]

  if (inputLength - offset !== sLength) {
    throw new Error(`"s" specified length of "${sLength}", expected "${inputLength - offset}"`)
  }

  if (maxEncodedParamLength < sLength) {
    throw new Error(`"s" specified length of "${sLength}", max of "${maxEncodedParamLength}" is acceptable`)
  }

  const sOffset = offset
  offset += sLength

  if (offset !== inputLength) {
    throw new Error(`Expected to consume entire buffer, but "${inputLength - offset}" bytes remain`)
  }

  const rPadding = paramBytes - rLength

  const sPadding = paramBytes - sLength

  const dst = Buffer.allocUnsafe(rPadding + rLength + sPadding + sLength)

  for (offset = 0; offset < rPadding; ++offset) {
    dst[offset] = 0
  }
  signature.copy(dst, offset, rOffset + Math.max(-rPadding, 0), rOffset + rLength)

  offset = paramBytes

  for (const o = offset; offset < o + sPadding; ++offset) {
    dst[offset] = 0
  }
  signature.copy(dst, offset, sOffset + Math.max(-sPadding, 0), sOffset + sLength)

  return dst
}

module.exports.joseToDer = (signature, alg) => {
  if (!Buffer.isBuffer(signature)) {
    throw new TypeError('ECDSA signature must be a Buffer')
  }

  if (!paramBytesForAlg[alg]) {
    throw new TypeError(`Unknown algorithm "${alg}"`)
  }

  const paramBytes = paramBytesForAlg[alg]

  const signatureBytes = signature.length
  if (signatureBytes !== paramBytes * 2) {
    throw new Error(`"${alg}" signatures must be "${paramBytes * 2}" bytes, saw "${signatureBytes}"`)
  }

  const rPadding = countPadding(signature, 0, paramBytes)
  const sPadding = countPadding(signature, paramBytes, signature.length)
  const rLength = paramBytes - rPadding
  const sLength = paramBytes - sPadding

  const rsBytes = 1 + 1 + rLength + 1 + 1 + sLength

  const shortLength = rsBytes < MAX_OCTET

  const dst = Buffer.allocUnsafe((shortLength ? 2 : 3) + rsBytes)

  let offset = 0
  dst[offset++] = ENCODED_TAG_SEQ
  if (shortLength) {
    // Bit 8 has value "0"
    // bits 7-1 give the length.
    dst[offset++] = rsBytes
  } else {
    // Bit 8 of first octet has value "1"
    // bits 7-1 give the number of additional length octets.
    dst[offset++] = MAX_OCTET	| 1 // eslint-disable-line no-tabs
    // length, base 256
    dst[offset++] = rsBytes & 0xff
  }
  dst[offset++] = ENCODED_TAG_INT
  dst[offset++] = rLength
  if (rPadding < 0) {
    dst[offset++] = 0
    offset += signature.copy(dst, offset, 0, paramBytes)
  } else {
    offset += signature.copy(dst, offset, rPadding, paramBytes)
  }
  dst[offset++] = ENCODED_TAG_INT
  dst[offset++] = sLength
  if (sPadding < 0) {
    dst[offset++] = 0
    signature.copy(dst, offset, paramBytes)
  } else {
    signature.copy(dst, offset, paramBytes + sPadding)
  }

  return dst
}


/***/ }),

/***/ 7374:
/***/ (function(module) {

module.exports = (date) => Math.floor(date.getTime() / 1000)


/***/ }),

/***/ 3501:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { randomBytes } = __webpack_require__(42474)

const { IVLENGTHS } = __webpack_require__(7422)

module.exports = alg => randomBytes(IVLENGTHS.get(alg) / 8)


/***/ }),

/***/ 75579:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const errors = __webpack_require__(8293)
const Key = __webpack_require__(52155)
const importKey = __webpack_require__(86698)
const { KeyStore } = __webpack_require__(47031)

module.exports = (input, keyStoreAllowed = false) => {
  if (input instanceof Key) {
    return input
  }

  if (input instanceof KeyStore) {
    if (!keyStoreAllowed) {
      throw new TypeError('key argument for this operation must not be a JWKS.KeyStore instance')
    }

    return input
  }

  try {
    return importKey(input)
  } catch (err) {
    if (err instanceof errors.JOSEError && !(err instanceof errors.JWKImportFailed)) {
      throw err
    }

    let msg
    if (keyStoreAllowed) {
      msg = 'key must be an instance of a key instantiated by JWK.asKey, a valid JWK.asKey input, or a JWKS.KeyStore instance'
    } else {
      msg = 'key must be an instance of a key instantiated by JWK.asKey, or a valid JWK.asKey input'
    }

    throw new TypeError(msg)
  }
}


/***/ }),

/***/ 970:
/***/ (function(module) {

module.exports = (a = {}, b = {}) => {
  const keysA = Object.keys(a)
  const keysB = new Set(Object.keys(b))
  return !keysA.some((ka) => keysB.has(ka))
}


/***/ }),

/***/ 94336:
/***/ (function(module) {

module.exports = a => !!a && a.constructor === Object


/***/ }),

/***/ 57658:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const { keyObjectSupported } = __webpack_require__(17945)

let createPublicKey
let createPrivateKey
let createSecretKey
let KeyObject
let asInput

if (keyObjectSupported) {
  ({ createPublicKey, createPrivateKey, createSecretKey, KeyObject } = __webpack_require__(42474))
  asInput = (input) => input
} else {
  const { EOL } = __webpack_require__(73461)

  const errors = __webpack_require__(8293)
  const isObject = __webpack_require__(94336)
  const asn1 = __webpack_require__(42993)
  const toInput = Symbol('toInput')

  const namedCurve = Symbol('namedCurve')

  asInput = (keyObject, needsPublic) => {
    if (keyObject instanceof KeyObject) {
      return keyObject[toInput](needsPublic)
    }

    return createSecretKey(keyObject)[toInput](needsPublic)
  }

  const pemToDer = pem => Buffer.from(pem.replace(/(?:-----(?:BEGIN|END)(?: (?:RSA|EC))? (?:PRIVATE|PUBLIC) KEY-----|\s)/g, ''), 'base64')
  const derToPem = (der, label) => `-----BEGIN ${label}-----${EOL}${(der.toString('base64').match(/.{1,64}/g) || []).join(EOL)}${EOL}-----END ${label}-----`
  const unsupported = (input) => {
    const label = typeof input === 'string' ? input : `OID ${input.join('.')}`
    throw new errors.JOSENotSupported(`${label} is not supported in your Node.js runtime version`)
  }

  KeyObject = class KeyObject {
    export ({ cipher, passphrase, type, format } = {}) {
      if (this._type === 'secret') {
        return this._buffer
      }

      if (this._type === 'public') {
        if (this.asymmetricKeyType === 'rsa') {
          switch (type) {
            case 'pkcs1':
              if (format === 'pem') {
                return this._pem
              }

              return pemToDer(this._pem)
            case 'spki': {
              const PublicKeyInfo = asn1.get('PublicKeyInfo')
              const pem = PublicKeyInfo.encode({
                algorithm: {
                  algorithm: 'rsaEncryption',
                  parameters: { type: 'null' }
                },
                publicKey: {
                  unused: 0,
                  data: pemToDer(this._pem)
                }
              }, 'pem', { label: 'PUBLIC KEY' })

              return format === 'pem' ? pem : pemToDer(pem)
            }
            default:
              throw new TypeError(`The value ${type} is invalid for option "type"`)
          }
        }

        if (this.asymmetricKeyType === 'ec') {
          if (type !== 'spki') {
            throw new TypeError(`The value ${type} is invalid for option "type"`)
          }

          if (format === 'pem') {
            return this._pem
          }

          return pemToDer(this._pem)
        }
      }

      if (this._type === 'private') {
        if (passphrase !== undefined || cipher !== undefined) {
          throw new errors.JOSENotSupported('encrypted private keys are not supported in your Node.js runtime version')
        }

        if (type === 'pkcs8') {
          if (this._pkcs8) {
            if (format === 'der' && typeof this._pkcs8 === 'string') {
              return pemToDer(this._pkcs8)
            }

            if (format === 'pem' && Buffer.isBuffer(this._pkcs8)) {
              return derToPem(this._pkcs8, 'PRIVATE KEY')
            }

            return this._pkcs8
          }

          if (this.asymmetricKeyType === 'rsa') {
            const parsed = this._asn1
            const RSAPrivateKey = asn1.get('RSAPrivateKey')
            const privateKey = RSAPrivateKey.encode(parsed)
            const PrivateKeyInfo = asn1.get('PrivateKeyInfo')
            const pkcs8 = PrivateKeyInfo.encode({
              version: 0,
              privateKey,
              algorithm: {
                algorithm: 'rsaEncryption',
                parameters: { type: 'null' }
              }
            })

            this._pkcs8 = pkcs8

            return this.export({ type, format })
          }

          if (this.asymmetricKeyType === 'ec') {
            const parsed = this._asn1
            const ECPrivateKey = asn1.get('ECPrivateKey')
            const privateKey = ECPrivateKey.encode({
              version: parsed.version,
              privateKey: parsed.privateKey,
              publicKey: parsed.publicKey
            })
            const PrivateKeyInfo = asn1.get('PrivateKeyInfo')
            const pkcs8 = PrivateKeyInfo.encode({
              version: 0,
              privateKey,
              algorithm: {
                algorithm: 'ecPublicKey',
                parameters: this._asn1.parameters
              }
            })

            this._pkcs8 = pkcs8

            return this.export({ type, format })
          }
        }

        if (this.asymmetricKeyType === 'rsa' && type === 'pkcs1') {
          if (format === 'pem') {
            return this._pem
          }

          return pemToDer(this._pem)
        } else if (this.asymmetricKeyType === 'ec' && type === 'sec1') {
          if (format === 'pem') {
            return this._pem
          }

          return pemToDer(this._pem)
        } else {
          throw new TypeError(`The value ${type} is invalid for option "type"`)
        }
      }
    }

    get type () {
      return this._type
    }

    get asymmetricKeyType () {
      return this._asymmetricKeyType
    }

    get symmetricKeySize () {
      return this._symmetricKeySize
    }

    [toInput] (needsPublic) {
      switch (this._type) {
        case 'secret':
          return this._buffer
        case 'public':
          return this._pem
        default:
          if (needsPublic) {
            if (!('_pub' in this)) {
              this._pub = createPublicKey(this)
            }

            return this._pub[toInput](false)
          }

          return this._pem
      }
    }
  }

  createSecretKey = (buffer) => {
    if (!Buffer.isBuffer(buffer) || !buffer.length) {
      throw new TypeError('input must be a non-empty Buffer instance')
    }

    const keyObject = new KeyObject()
    keyObject._buffer = Buffer.from(buffer)
    keyObject._symmetricKeySize = buffer.length
    keyObject._type = 'secret'

    return keyObject
  }

  createPublicKey = (input) => {
    if (input instanceof KeyObject) {
      if (input.type !== 'private') {
        throw new TypeError(`Invalid key object type ${input.type}, expected private.`)
      }

      switch (input.asymmetricKeyType) {
        case 'ec': {
          const PublicKeyInfo = asn1.get('PublicKeyInfo')
          const key = PublicKeyInfo.encode({
            algorithm: {
              algorithm: 'ecPublicKey',
              parameters: input._asn1.parameters
            },
            publicKey: input._asn1.publicKey
          })

          return createPublicKey({ key, format: 'der', type: 'spki' })
        }
        case 'rsa': {
          const RSAPublicKey = asn1.get('RSAPublicKey')
          const key = RSAPublicKey.encode(input._asn1)
          return createPublicKey({ key, format: 'der', type: 'pkcs1' })
        }
      }
    }

    if (typeof input === 'string' || Buffer.isBuffer(input)) {
      input = { key: input, format: 'pem' }
    }

    if (!isObject(input)) {
      throw new TypeError('input must be a string, Buffer or an object')
    }

    const { format, passphrase } = input
    let { key, type } = input

    if (typeof key !== 'string' && !Buffer.isBuffer(key)) {
      throw new TypeError('key must be a string or Buffer')
    }

    if (format !== 'pem' && format !== 'der') {
      throw new TypeError('format must be one of "pem" or "der"')
    }

    let label
    if (format === 'pem') {
      key = key.toString()
      switch (key.split(/\r?\n/g)[0].toString()) {
        case '-----BEGIN PUBLIC KEY-----':
          type = 'spki'
          label = 'PUBLIC KEY'
          break
        case '-----BEGIN RSA PUBLIC KEY-----':
          type = 'pkcs1'
          label = 'RSA PUBLIC KEY'
          break
        case '-----BEGIN CERTIFICATE-----':
          throw new errors.JOSENotSupported('X.509 certificates are not supported in your Node.js runtime version')
        case '-----BEGIN PRIVATE KEY-----':
        case '-----BEGIN EC PRIVATE KEY-----':
        case '-----BEGIN RSA PRIVATE KEY-----':
          return createPublicKey(createPrivateKey(key))
        default:
          throw new TypeError('unknown/unsupported PEM type')
      }
    }

    switch (type) {
      case 'spki': {
        const PublicKeyInfo = asn1.get('PublicKeyInfo')
        const parsed = PublicKeyInfo.decode(key, format, { label })

        let type, keyObject
        switch (parsed.algorithm.algorithm) {
          case 'ecPublicKey': {
            keyObject = new KeyObject()
            keyObject._asn1 = parsed
            keyObject._asymmetricKeyType = 'ec'
            keyObject._type = 'public'
            keyObject._pem = PublicKeyInfo.encode(parsed, 'pem', { label: 'PUBLIC KEY' })

            break
          }
          case 'rsaEncryption': {
            type = 'pkcs1'
            keyObject = createPublicKey({ type, key: parsed.publicKey.data, format: 'der' })
            break
          }
          default:
            unsupported(parsed.algorithm.algorithm)
        }

        return keyObject
      }
      case 'pkcs1': {
        const RSAPublicKey = asn1.get('RSAPublicKey')
        const parsed = RSAPublicKey.decode(key, format, { label })

        // special case when private pkcs1 PEM / DER is used with createPublicKey
        if (parsed.n === BigInt(0)) {
          return createPublicKey(createPrivateKey({ key, format, type, passphrase }))
        }

        const keyObject = new KeyObject()
        keyObject._asn1 = parsed
        keyObject._asymmetricKeyType = 'rsa'
        keyObject._type = 'public'
        keyObject._pem = RSAPublicKey.encode(parsed, 'pem', { label: 'RSA PUBLIC KEY' })

        return keyObject
      }
      case 'pkcs8':
      case 'sec1':
        return createPublicKey(createPrivateKey({ format, key, type, passphrase }))
      default:
        throw new TypeError(`The value ${type} is invalid for option "type"`)
    }
  }

  createPrivateKey = (input, hints) => {
    if (typeof input === 'string' || Buffer.isBuffer(input)) {
      input = { key: input, format: 'pem' }
    }

    if (!isObject(input)) {
      throw new TypeError('input must be a string, Buffer or an object')
    }

    const { format, passphrase } = input
    let { key, type } = input

    if (typeof key !== 'string' && !Buffer.isBuffer(key)) {
      throw new TypeError('key must be a string or Buffer')
    }

    if (passphrase !== undefined) {
      throw new errors.JOSENotSupported('encrypted private keys are not supported in your Node.js runtime version')
    }

    if (format !== 'pem' && format !== 'der') {
      throw new TypeError('format must be one of "pem" or "der"')
    }

    let label
    if (format === 'pem') {
      key = key.toString()
      switch (key.split(/\r?\n/g)[0].toString()) {
        case '-----BEGIN PRIVATE KEY-----':
          type = 'pkcs8'
          label = 'PRIVATE KEY'
          break
        case '-----BEGIN EC PRIVATE KEY-----':
          type = 'sec1'
          label = 'EC PRIVATE KEY'
          break
        case '-----BEGIN RSA PRIVATE KEY-----':
          type = 'pkcs1'
          label = 'RSA PRIVATE KEY'
          break
        default:
          throw new TypeError('unknown/unsupported PEM type')
      }
    }

    switch (type) {
      case 'pkcs8': {
        const PrivateKeyInfo = asn1.get('PrivateKeyInfo')
        const parsed = PrivateKeyInfo.decode(key, format, { label })

        let type, keyObject
        switch (parsed.algorithm.algorithm) {
          case 'ecPublicKey': {
            type = 'sec1'
            keyObject = createPrivateKey({ type, key: parsed.privateKey, format: 'der' }, { [namedCurve]: parsed.algorithm.parameters.value })
            break
          }
          case 'rsaEncryption': {
            type = 'pkcs1'
            keyObject = createPrivateKey({ type, key: parsed.privateKey, format: 'der' })
            break
          }
          default:
            unsupported(parsed.algorithm.algorithm)
        }

        keyObject._pkcs8 = key
        return keyObject
      }
      case 'pkcs1': {
        const RSAPrivateKey = asn1.get('RSAPrivateKey')
        const parsed = RSAPrivateKey.decode(key, format, { label })

        const keyObject = new KeyObject()
        keyObject._asn1 = parsed
        keyObject._asymmetricKeyType = 'rsa'
        keyObject._type = 'private'
        keyObject._pem = RSAPrivateKey.encode(parsed, 'pem', { label: 'RSA PRIVATE KEY' })

        return keyObject
      }
      case 'sec1': {
        const ECPrivateKey = asn1.get('ECPrivateKey')
        let parsed = ECPrivateKey.decode(key, format, { label })

        if (!('parameters' in parsed) && !hints[namedCurve]) {
          throw new Error('invalid sec1')
        } else if (!('parameters' in parsed)) {
          parsed = { ...parsed, parameters: { type: 'namedCurve', value: hints[namedCurve] } }
        }

        const keyObject = new KeyObject()
        keyObject._asn1 = parsed
        keyObject._asymmetricKeyType = 'ec'
        keyObject._type = 'private'
        keyObject._pem = ECPrivateKey.encode(parsed, 'pem', { label: 'EC PRIVATE KEY' })

        return keyObject
      }
      default:
        throw new TypeError(`The value ${type} is invalid for option "type"`)
    }
  }
}

module.exports = { createPublicKey, createPrivateKey, createSecretKey, KeyObject, asInput }


/***/ }),

/***/ 91166:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const { EOL } = __webpack_require__(73461)

const errors = __webpack_require__(8293)

const { keyObjectSupported } = __webpack_require__(17945)
const { createPublicKey } = __webpack_require__(57658)
const base64url = __webpack_require__(37448)
const asn1 = __webpack_require__(42993)
const computePrimes = __webpack_require__(14504)
const { OKP_CURVES, EC_CURVES } = __webpack_require__(7422)

const formatPem = (base64pem, descriptor) => `-----BEGIN ${descriptor} KEY-----${EOL}${(base64pem.match(/.{1,64}/g) || []).join(EOL)}${EOL}-----END ${descriptor} KEY-----`

const okpToJWK = {
  private (crv, keyObject) {
    const der = keyObject.export({ type: 'pkcs8', format: 'der' })
    const OneAsymmetricKey = asn1.get('OneAsymmetricKey')
    const { privateKey: { privateKey: d } } = OneAsymmetricKey.decode(der)

    return {
      ...okpToJWK.public(crv, createPublicKey(keyObject)),
      d: base64url.encodeBuffer(d)
    }
  },
  public (crv, keyObject) {
    const der = keyObject.export({ type: 'spki', format: 'der' })

    const PublicKeyInfo = asn1.get('PublicKeyInfo')

    const { publicKey: { data: x } } = PublicKeyInfo.decode(der)

    return {
      kty: 'OKP',
      crv,
      x: base64url.encodeBuffer(x)
    }
  }
}

const keyObjectToJWK = {
  rsa: {
    private (keyObject) {
      const der = keyObject.export({ type: 'pkcs8', format: 'der' })

      const PrivateKeyInfo = asn1.get('PrivateKeyInfo')
      const RSAPrivateKey = asn1.get('RSAPrivateKey')

      const { privateKey } = PrivateKeyInfo.decode(der)
      const { version, n, e, d, p, q, dp, dq, qi } = RSAPrivateKey.decode(privateKey)

      if (version !== 'two-prime') {
        throw new errors.JOSENotSupported('Private RSA keys with more than two primes are not supported')
      }

      return {
        kty: 'RSA',
        n: base64url.encodeBigInt(n),
        e: base64url.encodeBigInt(e),
        d: base64url.encodeBigInt(d),
        p: base64url.encodeBigInt(p),
        q: base64url.encodeBigInt(q),
        dp: base64url.encodeBigInt(dp),
        dq: base64url.encodeBigInt(dq),
        qi: base64url.encodeBigInt(qi)
      }
    },
    public (keyObject) {
      const der = keyObject.export({ type: 'spki', format: 'der' })

      const PublicKeyInfo = asn1.get('PublicKeyInfo')
      const RSAPublicKey = asn1.get('RSAPublicKey')

      const { publicKey: { data: publicKey } } = PublicKeyInfo.decode(der)
      const { n, e } = RSAPublicKey.decode(publicKey)

      return {
        kty: 'RSA',
        n: base64url.encodeBigInt(n),
        e: base64url.encodeBigInt(e)
      }
    }
  },
  ec: {
    private (keyObject) {
      const der = keyObject.export({ type: 'pkcs8', format: 'der' })

      const PrivateKeyInfo = asn1.get('PrivateKeyInfo')
      const ECPrivateKey = asn1.get('ECPrivateKey')

      const { privateKey, algorithm: { parameters: { value: crv } } } = PrivateKeyInfo.decode(der)
      const { privateKey: d, publicKey } = ECPrivateKey.decode(privateKey)

      if (typeof publicKey === 'undefined') {
        if (keyObjectSupported) {
          return {
            ...keyObjectToJWK.ec.public(createPublicKey(keyObject)),
            d: base64url.encodeBuffer(d)
          }
        }

        throw new errors.JOSENotSupported('Private EC keys without the public key embedded are not supported in your Node.js runtime version')
      }

      const x = publicKey.data.slice(1, ((publicKey.data.length - 1) / 2) + 1)
      const y = publicKey.data.slice(((publicKey.data.length - 1) / 2) + 1)

      return {
        kty: 'EC',
        crv,
        d: base64url.encodeBuffer(d),
        x: base64url.encodeBuffer(x),
        y: base64url.encodeBuffer(y)
      }
    },
    public (keyObject) {
      const der = keyObject.export({ type: 'spki', format: 'der' })

      const PublicKeyInfo = asn1.get('PublicKeyInfo')

      const { publicKey: { data: publicKey }, algorithm: { parameters: { value: crv } } } = PublicKeyInfo.decode(der)

      const x = publicKey.slice(1, ((publicKey.length - 1) / 2) + 1)
      const y = publicKey.slice(((publicKey.length - 1) / 2) + 1)

      return {
        kty: 'EC',
        crv,
        x: base64url.encodeBuffer(x),
        y: base64url.encodeBuffer(y)
      }
    }
  },
  ed25519: {
    private (keyObject) {
      return okpToJWK.private('Ed25519', keyObject)
    },
    public (keyObject) {
      return okpToJWK.public('Ed25519', keyObject)
    }
  },
  ed448: {
    private (keyObject) {
      return okpToJWK.private('Ed448', keyObject)
    },
    public (keyObject) {
      return okpToJWK.public('Ed448', keyObject)
    }
  },
  x25519: {
    private (keyObject) {
      return okpToJWK.private('X25519', keyObject)
    },
    public (keyObject) {
      return okpToJWK.public('X25519', keyObject)
    }
  },
  x448: {
    private (keyObject) {
      return okpToJWK.private('X448', keyObject)
    },
    public (keyObject) {
      return okpToJWK.public('X448', keyObject)
    }
  }
}

module.exports.keyObjectToJWK = (keyObject) => {
  if (keyObject.type === 'private') {
    return keyObjectToJWK[keyObject.asymmetricKeyType].private(keyObject)
  }

  return keyObjectToJWK[keyObject.asymmetricKeyType].public(keyObject)
}

const concatEcPublicKey = (x, y) => ({
  unused: 0,
  data: Buffer.concat([
    Buffer.alloc(1, 4),
    base64url.decodeToBuffer(x),
    base64url.decodeToBuffer(y)
  ])
})

const jwkToPem = {
  RSA: {
    private (jwk, { calculateMissingRSAPrimes }) {
      const RSAPrivateKey = asn1.get('RSAPrivateKey')

      if ('oth' in jwk) {
        throw new errors.JOSENotSupported('Private RSA keys with more than two primes are not supported')
      }

      if (jwk.p || jwk.q || jwk.dp || jwk.dq || jwk.qi) {
        if (!(jwk.p && jwk.q && jwk.dp && jwk.dq && jwk.qi)) {
          throw new errors.JWKInvalid('all other private key parameters must be present when any one of them is present')
        }
      } else if (calculateMissingRSAPrimes) {
        jwk = computePrimes(jwk)
      } else if (!calculateMissingRSAPrimes) {
        throw new errors.JOSENotSupported('importing private RSA keys without all other private key parameters is not enabled, see documentation and its advisory on how and when its ok to enable it')
      }

      return RSAPrivateKey.encode({
        version: 0,
        n: BigInt(`0x${base64url.decodeToBuffer(jwk.n).toString('hex')}`),
        e: BigInt(`0x${base64url.decodeToBuffer(jwk.e).toString('hex')}`),
        d: BigInt(`0x${base64url.decodeToBuffer(jwk.d).toString('hex')}`),
        p: BigInt(`0x${base64url.decodeToBuffer(jwk.p).toString('hex')}`),
        q: BigInt(`0x${base64url.decodeToBuffer(jwk.q).toString('hex')}`),
        dp: BigInt(`0x${base64url.decodeToBuffer(jwk.dp).toString('hex')}`),
        dq: BigInt(`0x${base64url.decodeToBuffer(jwk.dq).toString('hex')}`),
        qi: BigInt(`0x${base64url.decodeToBuffer(jwk.qi).toString('hex')}`)
      }, 'pem', { label: 'RSA PRIVATE KEY' })
    },
    public (jwk) {
      const RSAPublicKey = asn1.get('RSAPublicKey')

      return RSAPublicKey.encode({
        version: 0,
        n: BigInt(`0x${base64url.decodeToBuffer(jwk.n).toString('hex')}`),
        e: BigInt(`0x${base64url.decodeToBuffer(jwk.e).toString('hex')}`)
      }, 'pem', { label: 'RSA PUBLIC KEY' })
    }
  },
  EC: {
    private (jwk) {
      const ECPrivateKey = asn1.get('ECPrivateKey')

      return ECPrivateKey.encode({
        version: 1,
        privateKey: base64url.decodeToBuffer(jwk.d),
        parameters: { type: 'namedCurve', value: jwk.crv },
        publicKey: concatEcPublicKey(jwk.x, jwk.y)
      }, 'pem', { label: 'EC PRIVATE KEY' })
    },
    public (jwk) {
      const PublicKeyInfo = asn1.get('PublicKeyInfo')

      return PublicKeyInfo.encode({
        algorithm: {
          algorithm: 'ecPublicKey',
          parameters: { type: 'namedCurve', value: jwk.crv }
        },
        publicKey: concatEcPublicKey(jwk.x, jwk.y)
      }, 'pem', { label: 'PUBLIC KEY' })
    }
  },
  OKP: {
    private (jwk) {
      const OneAsymmetricKey = asn1.get('OneAsymmetricKey')

      const b64 = OneAsymmetricKey.encode({
        version: 0,
        privateKey: { privateKey: base64url.decodeToBuffer(jwk.d) },
        algorithm: { algorithm: jwk.crv }
      }, 'der')

      // TODO: WHYYY? https://github.com/indutny/asn1.js/issues/110
      b64.write('04', 12, 1, 'hex')

      return formatPem(b64.toString('base64'), 'PRIVATE')
    },
    public (jwk) {
      const PublicKeyInfo = asn1.get('PublicKeyInfo')

      return PublicKeyInfo.encode({
        algorithm: { algorithm: jwk.crv },
        publicKey: {
          unused: 0,
          data: base64url.decodeToBuffer(jwk.x)
        }
      }, 'pem', { label: 'PUBLIC KEY' })
    }
  }
}

module.exports.jwkToPem = (jwk, { calculateMissingRSAPrimes = false } = {}) => {
  switch (jwk.kty) {
    case 'EC':
      if (!EC_CURVES.has(jwk.crv)) {
        throw new errors.JOSENotSupported(`unsupported EC key curve: ${jwk.crv}`)
      }
      break
    case 'OKP':
      if (!OKP_CURVES.has(jwk.crv)) {
        throw new errors.JOSENotSupported(`unsupported OKP key curve: ${jwk.crv}`)
      }
      break
    case 'RSA':
      break
    default:
      throw new errors.JOSENotSupported(`unsupported key type: ${jwk.kty}`)
  }

  if (jwk.d) {
    return jwkToPem[jwk.kty].private(jwk, { calculateMissingRSAPrimes })
  }

  return jwkToPem[jwk.kty].public(jwk)
}


/***/ }),

/***/ 89231:
/***/ (function(module) {

module.exports = alg => `sha${alg.substr(2, 3)}`


/***/ }),

/***/ 14504:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const { randomBytes } = __webpack_require__(42474)

const base64url = __webpack_require__(37448)
const errors = __webpack_require__(8293)

const ZERO = BigInt(0)
const ONE = BigInt(1)
const TWO = BigInt(2)

const toJWKParameter = (n) => {
  const hex = n.toString(16)
  return base64url.encodeBuffer(Buffer.from(hex.length % 2 ? `0${hex}` : hex, 'hex'))
}
const fromBuffer = buf => BigInt(`0x${buf.toString('hex')}`)
const bitLength = n => n.toString(2).length

const eGcdX = (a, b) => {
  let x = ZERO
  let y = ONE
  let u = ONE
  let v = ZERO

  while (a !== ZERO) {
    const q = b / a
    const r = b % a
    const m = x - (u * q)
    const n = y - (v * q)
    b = a
    a = r
    x = u
    y = v
    u = m
    v = n
  }
  return x
}

const gcd = (a, b) => {
  let shift = ZERO
  while (!((a | b) & ONE)) {
    a >>= ONE
    b >>= ONE
    shift++
  }
  while (!(a & ONE)) {
    a >>= ONE
  }
  do {
    while (!(b & ONE)) {
      b >>= ONE
    }
    if (a > b) {
      const x = a
      a = b
      b = x
    }
    b -= a
  } while (b)

  return a << shift
}

const modPow = (a, b, n) => {
  a = toZn(a, n)
  let result = ONE
  let x = a
  while (b > 0) {
    const leastSignificantBit = b % TWO
    b = b / TWO
    if (leastSignificantBit === ONE) {
      result = result * x
      result = result % n
    }
    x = x * x
    x = x % n
  }
  return result
}

const randBetween = (min, max) => {
  const interval = max - min
  const bitLen = bitLength(interval)
  let rnd
  do {
    rnd = fromBuffer(randBits(bitLen))
  } while (rnd > interval)
  return rnd + min
}

const randBits = (bitLength) => {
  const byteLength = Math.ceil(bitLength / 8)
  const rndBytes = randomBytes(byteLength)
  // Fill with 0's the extra bits
  rndBytes[0] = rndBytes[0] & (2 ** (bitLength % 8) - 1)
  return rndBytes
}

const toZn = (a, n) => {
  a = a % n
  return (a < 0) ? a + n : a
}

const odd = (n) => {
  let r = n
  while (r % TWO === ZERO) {
    r = r / TWO
  }
  return r
}

// not sold on these values
const maxCountWhileNoY = 30
const maxCountWhileInot0 = 22

const getPrimeFactors = (e, d, n) => {
  const r = odd(e * d - ONE)

  let countWhileNoY = 0
  let y
  do {
    countWhileNoY++
    if (countWhileNoY === maxCountWhileNoY) {
      throw new errors.JWKImportFailed('failed to calculate missing primes')
    }

    let countWhileInot0 = 0
    let i = modPow(randBetween(TWO, n), r, n)
    let o = ZERO
    while (i !== ONE) {
      countWhileInot0++
      if (countWhileInot0 === maxCountWhileInot0) {
        throw new errors.JWKImportFailed('failed to calculate missing primes')
      }
      o = i
      i = (i * i) % n
    }
    if (o !== (n - ONE)) {
      y = o
    }
  } while (!y)

  const p = gcd(y - ONE, n)
  const q = n / p

  return p > q ? { p, q } : { p: q, q: p }
}

module.exports = (jwk) => {
  const e = fromBuffer(base64url.decodeToBuffer(jwk.e))
  const d = fromBuffer(base64url.decodeToBuffer(jwk.d))
  const n = fromBuffer(base64url.decodeToBuffer(jwk.n))

  if (d >= n) {
    throw new errors.JWKInvalid('invalid RSA private exponent')
  }

  const { p, q } = getPrimeFactors(e, d, n)
  const dp = d % (p - ONE)
  const dq = d % (q - ONE)
  const qi = toZn(eGcdX(toZn(q, p), p), p)

  return {
    ...jwk,
    p: toJWKParameter(p),
    q: toJWKParameter(q),
    dp: toJWKParameter(dp),
    dq: toJWKParameter(dq),
    qi: toJWKParameter(qi)
  }
}


/***/ }),

/***/ 17945:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
const { diffieHellman, KeyObject, sign, verify } = __webpack_require__(42474)

const [major, minor] = process.version.substr(1).split('.').map(x => parseInt(x, 10))

module.exports = {
  oaepHashSupported: major > 12 || (major === 12 && minor >= 9),
  keyObjectSupported: !!KeyObject && major >= 12,
  edDSASupported: !!sign && !!verify,
  dsaEncodingSupported: major > 13 || (major === 13 && minor >= 2) || (major === 12 && minor >= 16),
  improvedDH: !!diffieHellman
}


/***/ }),

/***/ 73232:
/***/ (function(module) {

const minute = 60
const hour = minute * 60
const day = hour * 24
const week = day * 7
const year = day * 365.25

const REGEX = /^(\d+|\d+\.\d+) ?(seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)$/i

module.exports = (str) => {
  const matched = REGEX.exec(str)

  if (!matched) {
    throw new TypeError(`invalid time period format ("${str}")`)
  }

  const value = parseFloat(matched[1])
  const unit = matched[2].toLowerCase()

  switch (unit) {
    case 'sec':
    case 'secs':
    case 'second':
    case 'seconds':
    case 's':
      return Math.round(value)
    case 'minute':
    case 'minutes':
    case 'min':
    case 'mins':
    case 'm':
      return Math.round(value * minute)
    case 'hour':
    case 'hours':
    case 'hr':
    case 'hrs':
    case 'h':
      return Math.round(value * hour)
    case 'day':
    case 'days':
    case 'd':
      return Math.round(value * day)
    case 'week':
    case 'weeks':
    case 'w':
      return Math.round(value * week)
    case 'year':
    case 'years':
    case 'yr':
    case 'yrs':
    case 'y':
      return Math.round(value * year)
  }
}


/***/ }),

/***/ 2683:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const { timingSafeEqual: TSE } = __webpack_require__(42474)

const paddedBuffer = (input, length) => {
  if (input.length === length) {
    return input
  }

  const buffer = Buffer.alloc(length)
  input.copy(buffer)
  return buffer
}

const timingSafeEqual = (a, b) => {
  const length = Math.max(a.length, b.length)
  return TSE(paddedBuffer(a, length), paddedBuffer(b, length))
}

module.exports = timingSafeEqual


/***/ }),

/***/ 29980:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const MAX_INT32 = Math.pow(2, 32)

module.exports = (value, buf = Buffer.allocUnsafe(8)) => {
  const high = Math.floor(value / MAX_INT32)
  const low = value % MAX_INT32

  buf.writeUInt32BE(high, 0)
  buf.writeUInt32BE(low, 4)
  return buf
}


/***/ }),

/***/ 16542:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { JOSECritNotUnderstood, JWSInvalid } = __webpack_require__(8293)

const DEFINED = new Set([
  'alg', 'jku', 'jwk', 'kid', 'x5u', 'x5c', 'x5t', 'x5t#S256', 'typ', 'cty',
  'crit', 'enc', 'zip', 'epk', 'apu', 'apv', 'iv', 'tag', 'p2s', 'p2c'
])

module.exports = function validateCrit (Err, protectedHeader, unprotectedHeader, understood) {
  if (protectedHeader && 'crit' in protectedHeader) {
    if (
      !Array.isArray(protectedHeader.crit) ||
      protectedHeader.crit.length === 0 ||
      protectedHeader.crit.some(s => typeof s !== 'string' || !s)
    ) {
      throw new Err('"crit" Header Parameter MUST be an array of non-empty strings when present')
    }
    const whitelisted = new Set(understood)
    const combined = { ...protectedHeader, ...unprotectedHeader }
    protectedHeader.crit.forEach((parameter) => {
      if (DEFINED.has(parameter)) {
        throw new Err(`The critical list contains a non-extension Header Parameter ${parameter}`)
      }
      if (!whitelisted.has(parameter)) {
        throw new JOSECritNotUnderstood(`critical "${parameter}" is not understood`)
      }
      if (parameter === 'b64') {
        if (!('b64' in protectedHeader)) {
          throw new JWSInvalid('"b64" critical parameter must be integrity protected')
        }
        if (typeof protectedHeader.b64 !== 'boolean') {
          throw new JWSInvalid('"b64" critical parameter must be a boolean')
        }
      } else if (!(parameter in combined)) {
        throw new Err(`critical parameter "${parameter}" is missing`)
      }
    })
  }
  if (unprotectedHeader && 'crit' in unprotectedHeader) {
    throw new Err('"crit" Header Parameter MUST be integrity protected when present')
  }
}


/***/ }),

/***/ 4948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
  JWE: __webpack_require__(48033),
  JWK: __webpack_require__(86887),
  JWKS: __webpack_require__(718),
  JWS: __webpack_require__(94207),
  JWT: __webpack_require__(26698),
  errors: __webpack_require__(8293)
}


/***/ }),

/***/ 67074:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const { createCipheriv, createDecipheriv, getCiphers } = __webpack_require__(42474)

const uint64be = __webpack_require__(29980)
const timingSafeEqual = __webpack_require__(2683)
const { KEYOBJECT } = __webpack_require__(92931)
const { JWEInvalid, JWEDecryptionFailed } = __webpack_require__(8293)

const checkInput = function (size, iv, tag) {
  if (iv.length !== 16) {
    throw new JWEInvalid('invalid iv')
  }
  if (arguments.length === 3) {
    if (tag.length !== size / 8) {
      throw new JWEInvalid('invalid tag')
    }
  }
}

const encrypt = (size, sign, { [KEYOBJECT]: keyObject }, cleartext, { iv, aad = Buffer.alloc(0) }) => {
  const key = keyObject.export()
  checkInput(size, iv)

  const keySize = size / 8
  const encKey = key.slice(keySize)
  const cipher = createCipheriv(`aes-${size}-cbc`, encKey, iv)
  const ciphertext = Buffer.concat([cipher.update(cleartext), cipher.final()])
  const macData = Buffer.concat([aad, iv, ciphertext, uint64be(aad.length * 8)])

  const macKey = key.slice(0, keySize)
  const tag = sign({ [KEYOBJECT]: macKey }, macData).slice(0, keySize)

  return { ciphertext, tag }
}

const decrypt = (size, sign, { [KEYOBJECT]: keyObject }, ciphertext, { iv, tag = Buffer.alloc(0), aad = Buffer.alloc(0) }) => {
  checkInput(size, iv, tag)

  const keySize = size / 8
  const key = keyObject.export()
  const encKey = key.slice(keySize)
  const macKey = key.slice(0, keySize)

  const macData = Buffer.concat([aad, iv, ciphertext, uint64be(aad.length * 8)])
  const expectedTag = sign({ [KEYOBJECT]: macKey }, macData, tag).slice(0, keySize)
  const macCheckPassed = timingSafeEqual(tag, expectedTag)

  if (!macCheckPassed) {
    throw new JWEDecryptionFailed()
  }

  let cleartext
  try {
    const cipher = createDecipheriv(`aes-${size}-cbc`, encKey, iv)
    cleartext = Buffer.concat([cipher.update(ciphertext), cipher.final()])
  } catch (err) {}

  if (!cleartext) {
    throw new JWEDecryptionFailed()
  }

  return cleartext
}

module.exports = (JWA, JWK) => {
  ['A128CBC-HS256', 'A192CBC-HS384', 'A256CBC-HS512'].forEach((jwaAlg) => {
    const size = parseInt(jwaAlg.substr(1, 3), 10)
    const sign = JWA.sign.get(`HS${size * 2}`)
    if (getCiphers().includes(`aes-${size}-cbc`)) {
      JWA.encrypt.set(jwaAlg, encrypt.bind(undefined, size, sign))
      JWA.decrypt.set(jwaAlg, decrypt.bind(undefined, size, sign))
      JWK.oct.encrypt[jwaAlg] = JWK.oct.decrypt[jwaAlg] = key => (key.use === 'enc' || key.use === undefined) && key.length / 2 === size
    }
  })
}


/***/ }),

/***/ 39303:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const { createCipheriv, createDecipheriv, getCiphers } = __webpack_require__(42474)

const { KEYOBJECT } = __webpack_require__(92931)
const { JWEInvalid, JWEDecryptionFailed } = __webpack_require__(8293)
const { asInput } = __webpack_require__(57658)

const checkInput = function (size, iv, tag) {
  if (iv.length !== 12) {
    throw new JWEInvalid('invalid iv')
  }
  if (arguments.length === 3) {
    if (tag.length !== 16) {
      throw new JWEInvalid('invalid tag')
    }
  }
}

const encrypt = (size, { [KEYOBJECT]: keyObject }, cleartext, { iv, aad = Buffer.alloc(0) }) => {
  const key = asInput(keyObject, false)
  checkInput(size, iv)

  const cipher = createCipheriv(`aes-${size}-gcm`, key, iv, { authTagLength: 16 })
  cipher.setAAD(aad)

  const ciphertext = Buffer.concat([cipher.update(cleartext), cipher.final()])
  const tag = cipher.getAuthTag()

  return { ciphertext, tag }
}

const decrypt = (size, { [KEYOBJECT]: keyObject }, ciphertext, { iv, tag = Buffer.alloc(0), aad = Buffer.alloc(0) }) => {
  const key = asInput(keyObject, false)
  checkInput(size, iv, tag)

  try {
    const cipher = createDecipheriv(`aes-${size}-gcm`, key, iv, { authTagLength: 16 })
    cipher.setAuthTag(tag)
    cipher.setAAD(aad)

    return Buffer.concat([cipher.update(ciphertext), cipher.final()])
  } catch (err) {
    throw new JWEDecryptionFailed()
  }
}

module.exports = (JWA, JWK) => {
  ['A128GCM', 'A192GCM', 'A256GCM'].forEach((jwaAlg) => {
    const size = parseInt(jwaAlg.substr(1, 3), 10)
    if (getCiphers().includes(`aes-${size}-gcm`)) {
      JWA.encrypt.set(jwaAlg, encrypt.bind(undefined, size))
      JWA.decrypt.set(jwaAlg, decrypt.bind(undefined, size))
      JWK.oct.encrypt[jwaAlg] = JWK.oct.decrypt[jwaAlg] = key => (key.use === 'enc' || key.use === undefined) && key.length === size
    }
  })
}


/***/ }),

/***/ 46269:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const generateIV = __webpack_require__(3501)
const base64url = __webpack_require__(37448)

module.exports = (JWA, JWK) => {
  ['A128GCMKW', 'A192GCMKW', 'A256GCMKW'].forEach((jwaAlg) => {
    const encAlg = jwaAlg.substr(0, 7)
    const size = parseInt(jwaAlg.substr(1, 3), 10)
    const encrypt = JWA.encrypt.get(encAlg)
    const decrypt = JWA.decrypt.get(encAlg)

    if (encrypt && decrypt) {
      JWA.keyManagementEncrypt.set(jwaAlg, (key, payload) => {
        const iv = generateIV(jwaAlg)
        const { ciphertext, tag } = encrypt(key, payload, { iv })
        return {
          wrapped: ciphertext,
          header: { tag: base64url.encodeBuffer(tag), iv: base64url.encodeBuffer(iv) }
        }
      })
      JWA.keyManagementDecrypt.set(jwaAlg, decrypt)
      JWK.oct.wrapKey[jwaAlg] = JWK.oct.unwrapKey[jwaAlg] = key => (key.use === 'enc' || key.use === undefined) && key.length === size
    }
  })
}


/***/ }),

/***/ 2409:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const { createCipheriv, createDecipheriv, getCiphers } = __webpack_require__(42474)

const { KEYOBJECT } = __webpack_require__(92931)
const { asInput } = __webpack_require__(57658)

const checkInput = (data) => {
  if (data !== undefined && data.length % 8 !== 0) {
    throw new Error('invalid data length')
  }
}

const wrapKey = (alg, { [KEYOBJECT]: keyObject }, payload) => {
  const key = asInput(keyObject, false)
  const cipher = createCipheriv(alg, key, Buffer.alloc(8, 'a6', 'hex'))

  return { wrapped: Buffer.concat([cipher.update(payload), cipher.final()]) }
}

const unwrapKey = (alg, { [KEYOBJECT]: keyObject }, payload) => {
  const key = asInput(keyObject, false)
  checkInput(payload)
  const cipher = createDecipheriv(alg, key, Buffer.alloc(8, 'a6', 'hex'))

  return Buffer.concat([cipher.update(payload), cipher.final()])
}

module.exports = (JWA, JWK) => {
  ['A128KW', 'A192KW', 'A256KW'].forEach((jwaAlg) => {
    const size = parseInt(jwaAlg.substr(1, 3), 10)
    const alg = `aes${size}-wrap`
    if (getCiphers().includes(alg)) {
      JWA.keyManagementEncrypt.set(jwaAlg, wrapKey.bind(undefined, alg))
      JWA.keyManagementDecrypt.set(jwaAlg, unwrapKey.bind(undefined, alg))
      JWK.oct.wrapKey[jwaAlg] = JWK.oct.unwrapKey[jwaAlg] = key => (key.use === 'enc' || key.use === undefined) && key.length === size
    }
  })
}


/***/ }),

/***/ 10391:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const { improvedDH } = __webpack_require__(17945)

if (improvedDH) {
  const { diffieHellman } = __webpack_require__(42474)

  const { KeyObject } = __webpack_require__(57658)
  const importKey = __webpack_require__(86698)

  module.exports = ({ keyObject: privateKey }, publicKey) => {
    if (!(publicKey instanceof KeyObject)) {
      ({ keyObject: publicKey } = importKey(publicKey))
    }

    return diffieHellman({ privateKey, publicKey })
  }
} else {
  const { createECDH, constants: { POINT_CONVERSION_UNCOMPRESSED } } = __webpack_require__(42474)

  const base64url = __webpack_require__(37448)

  const crvToCurve = (crv) => {
    switch (crv) {
      case 'P-256':
        return 'prime256v1'
      case 'P-384':
        return 'secp384r1'
      case 'P-521':
        return 'secp521r1'
    }
  }

  const UNCOMPRESSED = Buffer.alloc(1, POINT_CONVERSION_UNCOMPRESSED)
  const pubToBuffer = (x, y) => Buffer.concat([UNCOMPRESSED, base64url.decodeToBuffer(x), base64url.decodeToBuffer(y)])

  module.exports = ({ crv, d }, { x, y }) => {
    const curve = crvToCurve(crv)
    const exchange = createECDH(curve)

    exchange.setPrivateKey(base64url.decodeToBuffer(d))

    return exchange.computeSecret(pubToBuffer(x, y))
  }
}


/***/ }),

/***/ 37029:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const { createHash } = __webpack_require__(42474)
const ecdhComputeSecret = __webpack_require__(10391)

const concat = (key, length, value) => {
  const iterations = Math.ceil(length / 32)
  let res

  for (let iter = 1; iter <= iterations; iter++) {
    const buf = Buffer.allocUnsafe(4 + key.length + value.length)
    buf.writeUInt32BE(iter, 0)
    key.copy(buf, 4)
    value.copy(buf, 4 + key.length)
    if (!res) {
      res = createHash('sha256').update(buf).digest()
    } else {
      res = Buffer.concat([res, createHash('sha256').update(buf).digest()])
    }
  }

  return res.slice(0, length)
}

const uint32be = (value, buf = Buffer.allocUnsafe(4)) => {
  buf.writeUInt32BE(value)
  return buf
}

const lengthAndInput = input => Buffer.concat([uint32be(input.length), input])

module.exports = (alg, keyLen, privKey, pubKey, { apu = Buffer.alloc(0), apv = Buffer.alloc(0) } = {}, computeSecret = ecdhComputeSecret) => {
  const value = Buffer.concat([
    lengthAndInput(Buffer.from(alg)),
    lengthAndInput(apu),
    lengthAndInput(apv),
    uint32be(keyLen)
  ])

  const sharedSecret = computeSecret(privKey, pubKey)
  return concat(sharedSecret, keyLen / 8, value)
}


/***/ }),

/***/ 50428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { improvedDH } = __webpack_require__(17945)
const { KEYLENGTHS } = __webpack_require__(7422)
const { generateSync } = __webpack_require__(47943)

const derive = __webpack_require__(37029)

const wrapKey = (key, payload, { enc }) => {
  const epk = generateSync(key.kty, key.crv)

  const derivedKey = derive(enc, KEYLENGTHS.get(enc), epk, key)

  return {
    wrapped: derivedKey,
    header: { epk: { kty: key.kty, crv: key.crv, x: epk.x, y: epk.y } }
  }
}

const unwrapKey = (key, payload, header) => {
  const { enc, epk } = header
  return derive(enc, KEYLENGTHS.get(enc), key, epk, header)
}

module.exports = (JWA, JWK) => {
  JWA.keyManagementEncrypt.set('ECDH-ES', wrapKey)
  JWA.keyManagementDecrypt.set('ECDH-ES', unwrapKey)
  JWK.EC.deriveKey['ECDH-ES'] = key => (key.use === 'enc' || key.use === undefined) && key.crv !== 'secp256k1'

  if (improvedDH) {
    JWK.OKP.deriveKey['ECDH-ES'] = key => (key.use === 'enc' || key.use === undefined) && key.keyObject.asymmetricKeyType.startsWith('x')
  }
}


/***/ }),

/***/ 32953:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { improvedDH } = __webpack_require__(17945)
const { KEYOBJECT } = __webpack_require__(92931)
const { generateSync } = __webpack_require__(47943)
const { ECDH_DERIVE_LENGTHS } = __webpack_require__(7422)

const derive = __webpack_require__(37029)

const wrapKey = (wrap, derive, key, payload) => {
  const epk = generateSync(key.kty, key.crv)

  const derivedKey = derive(epk, key, payload)

  const result = wrap({ [KEYOBJECT]: derivedKey }, payload)
  result.header = result.header || {}
  Object.assign(result.header, { epk: { kty: key.kty, crv: key.crv, x: epk.x, y: epk.y } })

  return result
}

const unwrapKey = (unwrap, derive, key, payload, header) => {
  const { epk } = header
  const derivedKey = derive(key, epk, header)

  return unwrap({ [KEYOBJECT]: derivedKey }, payload, header)
}

module.exports = (JWA, JWK) => {
  ['ECDH-ES+A128KW', 'ECDH-ES+A192KW', 'ECDH-ES+A256KW'].forEach((jwaAlg) => {
    const kw = jwaAlg.substr(-6)
    const kwWrap = JWA.keyManagementEncrypt.get(kw)
    const kwUnwrap = JWA.keyManagementDecrypt.get(kw)
    const keylen = parseInt(jwaAlg.substr(9, 3), 10)
    ECDH_DERIVE_LENGTHS.set(jwaAlg, keylen)

    if (kwWrap && kwUnwrap) {
      JWA.keyManagementEncrypt.set(jwaAlg, wrapKey.bind(undefined, kwWrap, derive.bind(undefined, jwaAlg, keylen)))
      JWA.keyManagementDecrypt.set(jwaAlg, unwrapKey.bind(undefined, kwUnwrap, derive.bind(undefined, jwaAlg, keylen)))
      JWK.EC.deriveKey[jwaAlg] = key => (key.use === 'enc' || key.use === undefined) && key.crv !== 'secp256k1'

      if (improvedDH) {
        JWK.OKP.deriveKey[jwaAlg] = key => (key.use === 'enc' || key.use === undefined) && key.keyObject.asymmetricKeyType.startsWith('x')
      }
    }
  })
}
module.exports.wrapKey = wrapKey
module.exports.unwrapKey = unwrapKey


/***/ }),

/***/ 36275:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const { sign: signOneShot, verify: verifyOneShot, createSign, createVerify, getCurves } = __webpack_require__(42474)

const { derToJose, joseToDer } = __webpack_require__(62867)
const { KEYOBJECT } = __webpack_require__(92931)
const resolveNodeAlg = __webpack_require__(89231)
const { asInput } = __webpack_require__(57658)
const { dsaEncodingSupported } = __webpack_require__(17945)

let sign, verify

if (dsaEncodingSupported) {
  sign = (jwaAlg, nodeAlg, { [KEYOBJECT]: keyObject }, payload) => {
    if (typeof payload === 'string') {
      payload = Buffer.from(payload)
    }
    return signOneShot(nodeAlg, payload, { key: asInput(keyObject, false), dsaEncoding: 'ieee-p1363' })
  }
  verify = (jwaAlg, nodeAlg, { [KEYOBJECT]: keyObject }, payload, signature) => {
    try {
      return verifyOneShot(nodeAlg, payload, { key: asInput(keyObject, true), dsaEncoding: 'ieee-p1363' }, signature)
    } catch (err) {
      return false
    }
  }
} else {
  sign = (jwaAlg, nodeAlg, { [KEYOBJECT]: keyObject }, payload) => {
    return derToJose(createSign(nodeAlg).update(payload).sign(asInput(keyObject, false)), jwaAlg)
  }
  verify = (jwaAlg, nodeAlg, { [KEYOBJECT]: keyObject }, payload, signature) => {
    try {
      return createVerify(nodeAlg).update(payload).verify(asInput(keyObject, true), joseToDer(signature, jwaAlg))
    } catch (err) {
      return false
    }
  }
}

const crvToAlg = (crv) => {
  switch (crv) {
    case 'P-256':
      return 'ES256'
    case 'secp256k1':
      return 'ES256K'
    case 'P-384':
      return 'ES384'
    case 'P-521':
      return 'ES512'
  }
}

module.exports = (JWA, JWK) => {
  const algs = []

  if (getCurves().includes('prime256v1')) {
    algs.push('ES256')
  }

  if (getCurves().includes('secp256k1')) {
    algs.push('ES256K')
  }

  if (getCurves().includes('secp384r1')) {
    algs.push('ES384')
  }

  if (getCurves().includes('secp521r1')) {
    algs.push('ES512')
  }

  algs.forEach((jwaAlg) => {
    const nodeAlg = resolveNodeAlg(jwaAlg)
    JWA.sign.set(jwaAlg, sign.bind(undefined, jwaAlg, nodeAlg))
    JWA.verify.set(jwaAlg, verify.bind(undefined, jwaAlg, nodeAlg))
    JWK.EC.sign[jwaAlg] = key => key.private && JWK.EC.verify[jwaAlg](key)
    JWK.EC.verify[jwaAlg] = key => (key.use === 'sig' || key.use === undefined) && crvToAlg(key.crv) === jwaAlg
  })
}


/***/ }),

/***/ 12466:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const { sign: signOneShot, verify: verifyOneShot } = __webpack_require__(42474)

const { KEYOBJECT } = __webpack_require__(92931)
const { edDSASupported } = __webpack_require__(17945)

const sign = ({ [KEYOBJECT]: keyObject }, payload) => {
  if (typeof payload === 'string') {
    payload = Buffer.from(payload)
  }
  return signOneShot(undefined, payload, keyObject)
}

const verify = ({ [KEYOBJECT]: keyObject }, payload, signature) => {
  return verifyOneShot(undefined, payload, keyObject, signature)
}

module.exports = (JWA, JWK) => {
  if (edDSASupported) {
    JWA.sign.set('EdDSA', sign)
    JWA.verify.set('EdDSA', verify)
    JWK.OKP.sign.EdDSA = key => key.private && JWK.OKP.verify.EdDSA(key)
    JWK.OKP.verify.EdDSA = key => (key.use === 'sig' || key.use === undefined) && key.keyObject.asymmetricKeyType.startsWith('ed')
  }
}


/***/ }),

/***/ 44354:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { createHmac } = __webpack_require__(42474)

const { KEYOBJECT } = __webpack_require__(92931)
const timingSafeEqual = __webpack_require__(2683)
const resolveNodeAlg = __webpack_require__(89231)
const { asInput } = __webpack_require__(57658)

const sign = (jwaAlg, hmacAlg, { [KEYOBJECT]: keyObject }, payload) => {
  const hmac = createHmac(hmacAlg, asInput(keyObject, false))
  hmac.update(payload)
  return hmac.digest()
}

const verify = (jwaAlg, hmacAlg, key, payload, signature) => {
  const expected = sign(jwaAlg, hmacAlg, key, payload)
  const actual = signature

  return timingSafeEqual(actual, expected)
}

module.exports = (JWA, JWK) => {
  ['HS256', 'HS384', 'HS512'].forEach((jwaAlg) => {
    const hmacAlg = resolveNodeAlg(jwaAlg)
    JWA.sign.set(jwaAlg, sign.bind(undefined, jwaAlg, hmacAlg))
    JWA.verify.set(jwaAlg, verify.bind(undefined, jwaAlg, hmacAlg))
    JWK.oct.sign[jwaAlg] = JWK.oct.verify[jwaAlg] = key => key.use === 'sig' || key.use === undefined
  })
}


/***/ }),

/***/ 45889:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { JWKKeySupport, JOSENotSupported } = __webpack_require__(8293)
const { KEY_MANAGEMENT_ENCRYPT, KEY_MANAGEMENT_DECRYPT } = __webpack_require__(92931)

const { JWA, JWK } = __webpack_require__(7422)

// sign, verify
__webpack_require__(44354)(JWA, JWK)
__webpack_require__(36275)(JWA, JWK)
__webpack_require__(12466)(JWA, JWK)
__webpack_require__(53721)(JWA, JWK)
__webpack_require__(65415)(JWA, JWK)
__webpack_require__(3928)(JWA)

// encrypt, decrypt
__webpack_require__(67074)(JWA, JWK)
__webpack_require__(39303)(JWA, JWK)

// wrapKey, unwrapKey
__webpack_require__(58353)(JWA, JWK)
__webpack_require__(2409)(JWA, JWK)
__webpack_require__(46269)(JWA, JWK)

// deriveKey
__webpack_require__(84782)(JWA, JWK)
__webpack_require__(50428)(JWA, JWK)
__webpack_require__(32953)(JWA, JWK)

const check = (key, op, alg) => {
  const cache = `_${op}_${alg}`

  let label
  let keyOp
  if (op === 'keyManagementEncrypt') {
    label = 'key management (encryption)'
    keyOp = KEY_MANAGEMENT_ENCRYPT
  } else if (op === 'keyManagementDecrypt') {
    label = 'key management (decryption)'
    keyOp = KEY_MANAGEMENT_DECRYPT
  }

  if (cache in key) {
    if (key[cache]) {
      return
    }
    throw new JWKKeySupport(`the key does not support ${alg} ${label || op} algorithm`)
  }

  let value = true
  if (!JWA[op].has(alg)) {
    throw new JOSENotSupported(`unsupported ${label || op} alg: ${alg}`)
  } else if (!key.algorithms(keyOp).has(alg)) {
    value = false
  }

  Object.defineProperty(key, cache, { value, enumerable: false })

  if (!value) {
    return check(key, op, alg)
  }
}

module.exports = {
  check,
  sign: (alg, key, payload) => {
    check(key, 'sign', alg)
    return JWA.sign.get(alg)(key, payload)
  },
  verify: (alg, key, payload, signature) => {
    check(key, 'verify', alg)
    return JWA.verify.get(alg)(key, payload, signature)
  },
  keyManagementEncrypt: (alg, key, payload, opts) => {
    check(key, 'keyManagementEncrypt', alg)
    return JWA.keyManagementEncrypt.get(alg)(key, payload, opts)
  },
  keyManagementDecrypt: (alg, key, payload, opts) => {
    check(key, 'keyManagementDecrypt', alg)
    return JWA.keyManagementDecrypt.get(alg)(key, payload, opts)
  },
  encrypt: (alg, key, cleartext, opts) => {
    check(key, 'encrypt', alg)
    return JWA.encrypt.get(alg)(key, cleartext, opts)
  },
  decrypt: (alg, key, ciphertext, opts) => {
    check(key, 'decrypt', alg)
    return JWA.decrypt.get(alg)(key, ciphertext, opts)
  }
}


/***/ }),

/***/ 3928:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const sign = () => Buffer.from('')
const verify = (key, payload, signature) => !signature.length

module.exports = (JWA, JWK) => {
  JWA.sign.set('none', sign)
  JWA.verify.set('none', verify)
}


/***/ }),

/***/ 84782:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const { pbkdf2Sync: pbkdf2, randomBytes } = __webpack_require__(42474)

const { KEYOBJECT } = __webpack_require__(92931)
const base64url = __webpack_require__(37448)

const SALT_LENGTH = 16
const NULL_BUFFER = Buffer.alloc(1, 0)

const concatSalt = (alg, p2s) => {
  return Buffer.concat([
    Buffer.from(alg, 'utf8'),
    NULL_BUFFER,
    p2s
  ])
}

const wrapKey = (keylen, sha, concat, wrap, { [KEYOBJECT]: keyObject }, payload) => {
  // Note that if password-based encryption is used for multiple
  // recipients, it is expected that each recipient use different values
  // for the PBES2 parameters "p2s" and "p2c".
  // here we generate p2c between 2048 and 4096 and random p2s
  const p2c = Math.floor((Math.random() * 2049) + 2048)
  const p2s = randomBytes(SALT_LENGTH)
  const salt = concat(p2s)

  const derivedKey = pbkdf2(keyObject.export(), salt, p2c, keylen, sha)

  const result = wrap({ [KEYOBJECT]: derivedKey }, payload)
  result.header = result.header || {}
  Object.assign(result.header, { p2c, p2s: base64url.encodeBuffer(p2s) })

  return result
}

const unwrapKey = (keylen, sha, concat, unwrap, { [KEYOBJECT]: keyObject }, payload, header) => {
  const { p2s, p2c } = header
  const salt = concat(p2s)
  const derivedKey = pbkdf2(keyObject.export(), salt, p2c, keylen, sha)
  return unwrap({ [KEYOBJECT]: derivedKey }, payload, header)
}

module.exports = (JWA, JWK) => {
  ['PBES2-HS256+A128KW', 'PBES2-HS384+A192KW', 'PBES2-HS512+A256KW'].forEach((jwaAlg) => {
    const kw = jwaAlg.substr(-6)
    const kwWrap = JWA.keyManagementEncrypt.get(kw)
    const kwUnwrap = JWA.keyManagementDecrypt.get(kw)
    const keylen = parseInt(jwaAlg.substr(13, 3), 10) / 8
    const sha = `sha${jwaAlg.substr(8, 3)}`

    if (kwWrap && kwUnwrap) {
      JWA.keyManagementEncrypt.set(jwaAlg, wrapKey.bind(undefined, keylen, sha, concatSalt.bind(undefined, jwaAlg), kwWrap))
      JWA.keyManagementDecrypt.set(jwaAlg, unwrapKey.bind(undefined, keylen, sha, concatSalt.bind(undefined, jwaAlg), kwUnwrap))
      JWK.oct.deriveKey[jwaAlg] = key => key.use === 'enc' || key.use === undefined
    }
  })
}


/***/ }),

/***/ 58353:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { publicEncrypt, privateDecrypt, constants } = __webpack_require__(42474)

const { oaepHashSupported } = __webpack_require__(17945)
const { KEYOBJECT } = __webpack_require__(92931)
const { asInput } = __webpack_require__(57658)

const resolvePadding = (alg) => {
  switch (alg) {
    case 'RSA-OAEP':
    case 'RSA-OAEP-256':
    case 'RSA-OAEP-384':
    case 'RSA-OAEP-512':
      return constants.RSA_PKCS1_OAEP_PADDING
    case 'RSA1_5':
      return constants.RSA_PKCS1_PADDING
  }
}

const resolveOaepHash = (alg) => {
  switch (alg) {
    case 'RSA-OAEP':
      return 'sha1'
    case 'RSA-OAEP-256':
      return 'sha256'
    case 'RSA-OAEP-384':
      return 'sha384'
    case 'RSA-OAEP-512':
      return 'sha512'
    default:
      return undefined
  }
}

const wrapKey = (padding, oaepHash, { [KEYOBJECT]: keyObject }, payload) => {
  const key = asInput(keyObject, true)
  return { wrapped: publicEncrypt({ key, oaepHash, padding }, payload) }
}

const unwrapKey = (padding, oaepHash, { [KEYOBJECT]: keyObject }, payload) => {
  const key = asInput(keyObject, false)
  return privateDecrypt({ key, oaepHash, padding }, payload)
}

const LENGTHS = {
  RSA1_5: 0,
  'RSA-OAEP': 592,
  'RSA-OAEP-256': 784,
  'RSA-OAEP-384': 1040,
  'RSA-OAEP-512': 1296
}

module.exports = (JWA, JWK) => {
  const algs = ['RSA-OAEP', 'RSA1_5']

  if (oaepHashSupported) {
    algs.splice(1, 0, 'RSA-OAEP-256', 'RSA-OAEP-384', 'RSA-OAEP-512')
  }

  algs.forEach((jwaAlg) => {
    const padding = resolvePadding(jwaAlg)
    const oaepHash = resolveOaepHash(jwaAlg)
    JWA.keyManagementEncrypt.set(jwaAlg, wrapKey.bind(undefined, padding, oaepHash))
    JWA.keyManagementDecrypt.set(jwaAlg, unwrapKey.bind(undefined, padding, oaepHash))
    JWK.RSA.wrapKey[jwaAlg] = key => (key.use === 'enc' || key.use === undefined) && key.length >= LENGTHS[jwaAlg]
    JWK.RSA.unwrapKey[jwaAlg] = key => key.private && (key.use === 'enc' || key.use === undefined) && key.length >= LENGTHS[jwaAlg]
  })
}


/***/ }),

/***/ 65415:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { createSign, createVerify } = __webpack_require__(42474)

const { KEYOBJECT } = __webpack_require__(92931)
const resolveNodeAlg = __webpack_require__(89231)
const { asInput } = __webpack_require__(57658)

const sign = (nodeAlg, { [KEYOBJECT]: keyObject }, payload) => {
  return createSign(nodeAlg).update(payload).sign(asInput(keyObject, false))
}

const verify = (nodeAlg, { [KEYOBJECT]: keyObject }, payload, signature) => {
  return createVerify(nodeAlg).update(payload).verify(asInput(keyObject, true), signature)
}

const LENGTHS = {
  RS256: 0,
  RS384: 624,
  RS512: 752
}

module.exports = (JWA, JWK) => {
  ['RS256', 'RS384', 'RS512'].forEach((jwaAlg) => {
    const nodeAlg = resolveNodeAlg(jwaAlg)
    JWA.sign.set(jwaAlg, sign.bind(undefined, nodeAlg))
    JWA.verify.set(jwaAlg, verify.bind(undefined, nodeAlg))
    JWK.RSA.sign[jwaAlg] = key => key.private && JWK.RSA.verify[jwaAlg](key)
    JWK.RSA.verify[jwaAlg] = key => (key.use === 'sig' || key.use === undefined) && key.length >= LENGTHS[jwaAlg]
  })
}


/***/ }),

/***/ 53721:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const {
  createSign,
  createVerify,
  constants
} = __webpack_require__(42474)

const { KEYOBJECT } = __webpack_require__(92931)
const resolveNodeAlg = __webpack_require__(89231)
const { asInput } = __webpack_require__(57658)

const sign = (nodeAlg, { [KEYOBJECT]: keyObject }, payload) => {
  const key = asInput(keyObject, false)
  return createSign(nodeAlg).update(payload).sign({
    key,
    padding: constants.RSA_PKCS1_PSS_PADDING,
    saltLength: constants.RSA_PSS_SALTLEN_DIGEST
  })
}

const verify = (nodeAlg, { [KEYOBJECT]: keyObject }, payload, signature) => {
  const key = asInput(keyObject, true)
  return createVerify(nodeAlg).update(payload).verify({
    key,
    padding: constants.RSA_PKCS1_PSS_PADDING,
    saltLength: constants.RSA_PSS_SALTLEN_DIGEST
  }, signature)
}

const LENGTHS = {
  PS256: 528,
  PS384: 784,
  PS512: 1040
}

module.exports = (JWA, JWK) => {
  ['PS256', 'PS384', 'PS512'].forEach((jwaAlg) => {
    const nodeAlg = resolveNodeAlg(jwaAlg)
    JWA.sign.set(jwaAlg, sign.bind(undefined, nodeAlg))
    JWA.verify.set(jwaAlg, verify.bind(undefined, nodeAlg))
    JWK.RSA.sign[jwaAlg] = key => key.private && JWK.RSA.verify[jwaAlg](key)
    JWK.RSA.verify[jwaAlg] = key => (key.use === 'sig' || key.use === undefined) && key.length >= LENGTHS[jwaAlg]
  })
}


/***/ }),

/***/ 26319:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const { inflateRawSync } = __webpack_require__(47715)

const base64url = __webpack_require__(37448)
const getKey = __webpack_require__(75579)
const { KeyStore } = __webpack_require__(718)
const errors = __webpack_require__(8293)
const { check, decrypt, keyManagementDecrypt } = __webpack_require__(45889)
const JWK = __webpack_require__(86887)

const { createSecretKey } = __webpack_require__(57658)
const generateCEK = __webpack_require__(42967)
const validateHeaders = __webpack_require__(66557)
const { detect: resolveSerialization } = __webpack_require__(11757)

const SINGLE_RECIPIENT = new Set(['compact', 'flattened'])

const combineHeader = (prot = {}, unprotected = {}, header = {}) => {
  if (typeof prot === 'string') {
    prot = base64url.JSON.decode(prot)
  }

  const p2s = prot.p2s || unprotected.p2s || header.p2s
  const apu = prot.apu || unprotected.apu || header.apu
  const apv = prot.apv || unprotected.apv || header.apv
  const iv = prot.iv || unprotected.iv || header.iv
  const tag = prot.tag || unprotected.tag || header.tag

  return {
    ...prot,
    ...unprotected,
    ...header,
    ...(typeof p2s === 'string' ? { p2s: base64url.decodeToBuffer(p2s) } : undefined),
    ...(typeof apu === 'string' ? { apu: base64url.decodeToBuffer(apu) } : undefined),
    ...(typeof apv === 'string' ? { apv: base64url.decodeToBuffer(apv) } : undefined),
    ...(typeof iv === 'string' ? { iv: base64url.decodeToBuffer(iv) } : undefined),
    ...(typeof tag === 'string' ? { tag: base64url.decodeToBuffer(tag) } : undefined)
  }
}

const validateAlgorithms = (algorithms, option) => {
  if (algorithms !== undefined && (!Array.isArray(algorithms) || algorithms.some(s => typeof s !== 'string' || !s))) {
    throw new TypeError(`"${option}" option must be an array of non-empty strings`)
  }

  if (!algorithms) {
    return undefined
  }

  return new Set(algorithms)
}

/*
 * @public
 */
const jweDecrypt = (skipValidateHeaders, serialization, jwe, key, { crit = [], complete = false, keyManagementAlgorithms, contentEncryptionAlgorithms, maxPBES2Count = 10000 } = {}) => {
  key = getKey(key, true)

  keyManagementAlgorithms = validateAlgorithms(keyManagementAlgorithms, 'keyManagementAlgorithms')
  contentEncryptionAlgorithms = validateAlgorithms(contentEncryptionAlgorithms, 'contentEncryptionAlgorithms')

  if (!Array.isArray(crit) || crit.some(s => typeof s !== 'string' || !s)) {
    throw new TypeError('"crit" option must be an array of non-empty strings')
  }

  if (!serialization) {
    serialization = resolveSerialization(jwe)
  }

  let alg, ciphertext, enc, encryptedKey, iv, opts, prot, tag, unprotected, cek, aad, header

  // treat general format with one recipient as flattened
  // skips iteration and avoids multi errors in this case
  if (serialization === 'general' && jwe.recipients.length === 1) {
    serialization = 'flattened'
    const { recipients, ...root } = jwe
    jwe = { ...root, ...recipients[0] }
  }

  if (SINGLE_RECIPIENT.has(serialization)) {
    if (serialization === 'compact') { // compact serialization format
      ([prot, encryptedKey, iv, ciphertext, tag] = jwe.split('.'))
    } else { // flattened serialization format
      ({ protected: prot, encrypted_key: encryptedKey, iv, ciphertext, tag, unprotected, aad, header } = jwe)
    }

    if (!skipValidateHeaders) {
      validateHeaders(prot, unprotected, [{ header }], true, crit)
    }

    opts = combineHeader(prot, unprotected, header)

    ;({ alg, enc } = opts)

    if (keyManagementAlgorithms && !keyManagementAlgorithms.has(alg)) {
      throw new errors.JOSEAlgNotWhitelisted('key management algorithm not whitelisted')
    }

    if (contentEncryptionAlgorithms && !contentEncryptionAlgorithms.has(enc)) {
      throw new errors.JOSEAlgNotWhitelisted('content encryption algorithm not whitelisted')
    }

    if (key instanceof KeyStore) {
      const keystore = key
      let keys
      if (opts.alg === 'dir') {
        keys = keystore.all({ kid: opts.kid, alg: opts.enc, key_ops: ['decrypt'] })
      } else {
        keys = keystore.all({ kid: opts.kid, alg: opts.alg, key_ops: ['unwrapKey'] })
      }
      switch (keys.length) {
        case 0:
          throw new errors.JWKSNoMatchingKey()
        case 1:
          // treat the call as if a Key instance was passed in
          // skips iteration and avoids multi errors in this case
          key = keys[0]
          break
        default: {
          const errs = []
          for (const key of keys) {
            try {
              return jweDecrypt(true, serialization, jwe, key, {
                crit,
                complete,
                contentEncryptionAlgorithms: contentEncryptionAlgorithms ? [...contentEncryptionAlgorithms] : undefined,
                keyManagementAlgorithms: keyManagementAlgorithms ? [...keyManagementAlgorithms] : undefined
              })
            } catch (err) {
              errs.push(err)
              continue
            }
          }

          const multi = new errors.JOSEMultiError(errs)
          if ([...multi].some(e => e instanceof errors.JWEDecryptionFailed)) {
            throw new errors.JWEDecryptionFailed()
          }
          throw multi
        }
      }
    }

    check(key, ...(alg === 'dir' ? ['decrypt', enc] : ['keyManagementDecrypt', alg]))

    if (alg.startsWith('PBES2')) {
      if (opts && opts.p2c > maxPBES2Count) {
        throw new errors.JWEInvalid('JOSE Header "p2c" (PBES2 Count) out is of acceptable bounds')
      }
    }

    try {
      if (alg === 'dir') {
        cek = JWK.asKey(key, { alg: enc, use: 'enc' })
      } else if (alg === 'ECDH-ES') {
        const unwrapped = keyManagementDecrypt(alg, key, undefined, opts)
        cek = JWK.asKey(createSecretKey(unwrapped), { alg: enc, use: 'enc' })
      } else {
        const unwrapped = keyManagementDecrypt(alg, key, base64url.decodeToBuffer(encryptedKey), opts)
        cek = JWK.asKey(createSecretKey(unwrapped), { alg: enc, use: 'enc' })
      }
    } catch (err) {
      // To mitigate the attacks described in RFC 3218, the
      // recipient MUST NOT distinguish between format, padding, and length
      // errors of encrypted keys.  It is strongly recommended, in the event
      // of receiving an improperly formatted key, that the recipient
      // substitute a randomly generated CEK and proceed to the next step, to
      // mitigate timing attacks.
      cek = generateCEK(enc)
    }

    let adata
    if (aad) {
      adata = Buffer.concat([
        Buffer.from(prot || ''),
        Buffer.from('.'),
        Buffer.from(aad)
      ])
    } else {
      adata = Buffer.from(prot || '')
    }

    try {
      iv = base64url.decodeToBuffer(iv)
    } catch (err) {}
    try {
      tag = base64url.decodeToBuffer(tag)
    } catch (err) {}

    let cleartext = decrypt(enc, cek, base64url.decodeToBuffer(ciphertext), { iv, tag, aad: adata })

    if (opts.zip) {
      cleartext = inflateRawSync(cleartext)
    }

    if (complete) {
      const result = { cleartext, key, cek }
      if (aad) result.aad = aad
      if (header) result.header = header
      if (unprotected) result.unprotected = unprotected
      if (prot) result.protected = base64url.JSON.decode(prot)
      return result
    }

    return cleartext
  }

  validateHeaders(jwe.protected, jwe.unprotected, jwe.recipients.map(({ header }) => ({ header })), true, crit)

  // general serialization format
  const { recipients, ...root } = jwe
  const errs = []
  for (const recipient of recipients) {
    try {
      return jweDecrypt(true, 'flattened', { ...root, ...recipient }, key, {
        crit,
        complete,
        contentEncryptionAlgorithms: contentEncryptionAlgorithms ? [...contentEncryptionAlgorithms] : undefined,
        keyManagementAlgorithms: keyManagementAlgorithms ? [...keyManagementAlgorithms] : undefined
      })
    } catch (err) {
      errs.push(err)
      continue
    }
  }

  const multi = new errors.JOSEMultiError(errs)
  if ([...multi].some(e => e instanceof errors.JWEDecryptionFailed)) {
    throw new errors.JWEDecryptionFailed()
  } else if ([...multi].every(e => e instanceof errors.JWKSNoMatchingKey)) {
    throw new errors.JWKSNoMatchingKey()
  }
  throw multi
}

module.exports = jweDecrypt.bind(undefined, false, undefined)


/***/ }),

/***/ 93677:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const { deflateRawSync } = __webpack_require__(47715)

const { KEYOBJECT } = __webpack_require__(92931)
const generateIV = __webpack_require__(3501)
const base64url = __webpack_require__(37448)
const getKey = __webpack_require__(75579)
const isObject = __webpack_require__(94336)
const { createSecretKey } = __webpack_require__(57658)
const deepClone = __webpack_require__(49270)
const importKey = __webpack_require__(86698)
const { JWEInvalid } = __webpack_require__(8293)
const { check, keyManagementEncrypt, encrypt } = __webpack_require__(45889)

const serializers = __webpack_require__(11757)
const generateCEK = __webpack_require__(42967)
const validateHeaders = __webpack_require__(66557)

const PROCESS_RECIPIENT = Symbol('PROCESS_RECIPIENT')

class Encrypt {
  constructor (cleartext, protectedHeader, aad, unprotectedHeader) {
    if (!Buffer.isBuffer(cleartext) && typeof cleartext !== 'string') {
      throw new TypeError('cleartext argument must be a Buffer or a string')
    }
    cleartext = Buffer.from(cleartext)

    if (aad !== undefined && !Buffer.isBuffer(aad) && typeof aad !== 'string') {
      throw new TypeError('aad argument must be a Buffer or a string when provided')
    }
    aad = aad ? Buffer.from(aad) : undefined

    if (protectedHeader !== undefined && !isObject(protectedHeader)) {
      throw new TypeError('protectedHeader argument must be a plain object when provided')
    }

    if (unprotectedHeader !== undefined && !isObject(unprotectedHeader)) {
      throw new TypeError('unprotectedHeader argument must be a plain object when provided')
    }

    this._recipients = []
    this._cleartext = cleartext
    this._aad = aad
    this._unprotected = unprotectedHeader ? deepClone(unprotectedHeader) : undefined
    this._protected = protectedHeader ? deepClone(protectedHeader) : undefined
  }

  /*
   * @public
   */
  recipient (key, header) {
    key = getKey(key)

    if (header !== undefined && !isObject(header)) {
      throw new TypeError('header argument must be a plain object when provided')
    }

    this._recipients.push({
      key,
      header: header ? deepClone(header) : undefined
    })

    return this
  }

  /*
   * @private
   */
  [PROCESS_RECIPIENT] (recipient) {
    const unprotectedHeader = this._unprotected
    const protectedHeader = this._protected
    const { length: recipientCount } = this._recipients

    const jweHeader = {
      ...protectedHeader,
      ...unprotectedHeader,
      ...recipient.header
    }
    const { key } = recipient

    const enc = jweHeader.enc
    let alg = jweHeader.alg

    if (key.use === 'sig') {
      throw new TypeError('a key with "use":"sig" is not usable for encryption')
    }

    if (alg === 'dir') {
      check(key, 'encrypt', enc)
    } else if (alg) {
      check(key, 'keyManagementEncrypt', alg)
    } else {
      alg = key.alg || [...key.algorithms('wrapKey')][0] || [...key.algorithms('deriveKey')][0]

      if (alg === 'ECDH-ES' && recipientCount !== 1) {
        alg = [...key.algorithms('deriveKey')][1]
      }

      if (!alg) {
        throw new JWEInvalid('could not resolve a usable "alg" for a recipient')
      }

      if (recipientCount === 1) {
        if (protectedHeader) {
          protectedHeader.alg = alg
        } else {
          this._protected = { alg }
        }
      } else {
        if (recipient.header) {
          recipient.header.alg = alg
        } else {
          recipient.header = { alg }
        }
      }
    }

    let wrapped
    let generatedHeader

    if (key.kty === 'oct' && alg === 'dir') {
      this._cek = importKey(key[KEYOBJECT], { use: 'enc', alg: enc })
    } else {
      check(this._cek, 'encrypt', enc)
      ;({ wrapped, header: generatedHeader } = keyManagementEncrypt(alg, key, this._cek[KEYOBJECT].export(), { enc, alg }))
      if (alg === 'ECDH-ES') {
        this._cek = importKey(createSecretKey(wrapped), { use: 'enc', alg: enc })
      }
    }

    if (alg === 'dir' || alg === 'ECDH-ES') {
      recipient.encrypted_key = ''
    } else {
      recipient.encrypted_key = base64url.encodeBuffer(wrapped)
    }

    if (generatedHeader) {
      recipient.generatedHeader = generatedHeader
    }
  }

  /*
   * @public
   */
  encrypt (serialization) {
    const serializer = serializers[serialization]
    if (!serializer) {
      throw new TypeError('serialization must be one of "compact", "flattened", "general"')
    }

    if (!this._recipients.length) {
      throw new JWEInvalid('missing recipients')
    }

    serializer.validate(this._protected, this._unprotected, this._aad, this._recipients)

    let enc = validateHeaders(this._protected, this._unprotected, this._recipients, false, this._protected ? this._protected.crit : undefined)
    if (!enc) {
      enc = 'A128CBC-HS256'
      if (this._protected) {
        this._protected.enc = enc
      } else {
        this._protected = { enc }
      }
    }
    const final = {}
    this._cek = generateCEK(enc)

    for (const recipient of this._recipients) {
      this[PROCESS_RECIPIENT](recipient)
    }

    const iv = generateIV(enc)
    final.iv = base64url.encodeBuffer(iv)

    if (this._recipients.length === 1 && this._recipients[0].generatedHeader) {
      const [{ generatedHeader }] = this._recipients
      delete this._recipients[0].generatedHeader
      this._protected = {
        ...this._protected,
        ...generatedHeader
      }
    }

    if (this._protected) {
      final.protected = base64url.JSON.encode(this._protected)
    }
    final.unprotected = this._unprotected

    let aad
    if (this._aad) {
      final.aad = base64url.encode(this._aad)
      aad = Buffer.concat([
        Buffer.from(final.protected || ''),
        Buffer.from('.'),
        Buffer.from(final.aad)
      ])
    } else {
      aad = Buffer.from(final.protected || '')
    }

    let cleartext = this._cleartext
    if (this._protected && 'zip' in this._protected) {
      cleartext = deflateRawSync(cleartext)
    }

    const { ciphertext, tag } = encrypt(enc, this._cek, cleartext, { iv, aad })
    final.tag = base64url.encodeBuffer(tag)
    final.ciphertext = base64url.encodeBuffer(ciphertext)

    return serializer(final, this._recipients)
  }
}

module.exports = Encrypt


/***/ }),

/***/ 42967:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { randomBytes } = __webpack_require__(42474)

const { createSecretKey } = __webpack_require__(57658)
const { KEYLENGTHS } = __webpack_require__(7422)
const Key = __webpack_require__(91933)

module.exports = (alg) => {
  const keyLength = KEYLENGTHS.get(alg)

  if (!keyLength) {
    return new Key({ type: 'secret' })
  }

  return new Key(createSecretKey(randomBytes(keyLength / 8)), { use: 'enc', alg })
}


/***/ }),

/***/ 48033:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const Encrypt = __webpack_require__(93677)
const decrypt = __webpack_require__(26319)

const single = (serialization, cleartext, key, protectedHeader, aad, unprotectedHeader) => {
  return new Encrypt(cleartext, protectedHeader, aad, unprotectedHeader)
    .recipient(key)
    .encrypt(serialization)
}

module.exports.Encrypt = Encrypt
module.exports.encrypt = single.bind(undefined, 'compact')
module.exports.encrypt.flattened = single.bind(undefined, 'flattened')
module.exports.encrypt.general = single.bind(undefined, 'general')

module.exports.decrypt = decrypt


/***/ }),

/***/ 11757:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const isObject = __webpack_require__(94336)
let validateCrit = __webpack_require__(16542)

const { JWEInvalid } = __webpack_require__(8293)

validateCrit = validateCrit.bind(undefined, JWEInvalid)

const compactSerializer = (final, [recipient]) => {
  return `${final.protected}.${recipient.encrypted_key}.${final.iv}.${final.ciphertext}.${final.tag}`
}
compactSerializer.validate = (protectedHeader, unprotectedHeader, aad, { 0: { header }, length }) => {
  if (length !== 1 || aad || unprotectedHeader || header) {
    throw new JWEInvalid('JWE Compact Serialization doesn\'t support multiple recipients, JWE unprotected headers or AAD')
  }
  validateCrit(protectedHeader, unprotectedHeader, protectedHeader ? protectedHeader.crit : undefined)
}

const flattenedSerializer = (final, [recipient]) => {
  const { header, encrypted_key: encryptedKey } = recipient

  return {
    ...(final.protected ? { protected: final.protected } : undefined),
    ...(final.unprotected ? { unprotected: final.unprotected } : undefined),
    ...(header ? { header } : undefined),
    ...(encryptedKey ? { encrypted_key: encryptedKey } : undefined),
    ...(final.aad ? { aad: final.aad } : undefined),
    iv: final.iv,
    ciphertext: final.ciphertext,
    tag: final.tag
  }
}
flattenedSerializer.validate = (protectedHeader, unprotectedHeader, aad, { 0: { header }, length }) => {
  if (length !== 1) {
    throw new JWEInvalid('Flattened JWE JSON Serialization doesn\'t support multiple recipients')
  }
  validateCrit(protectedHeader, { ...unprotectedHeader, ...header }, protectedHeader ? protectedHeader.crit : undefined)
}

const generalSerializer = (final, recipients) => {
  const result = {
    ...(final.protected ? { protected: final.protected } : undefined),
    ...(final.unprotected ? { unprotected: final.unprotected } : undefined),
    recipients: recipients.map(({ header, encrypted_key: encryptedKey, generatedHeader }) => {
      if (!header && !encryptedKey && !generatedHeader) {
        return false
      }

      return {
        ...(header || generatedHeader ? { header: { ...header, ...generatedHeader } } : undefined),
        ...(encryptedKey ? { encrypted_key: encryptedKey } : undefined)
      }
    }).filter(Boolean),
    ...(final.aad ? { aad: final.aad } : undefined),
    iv: final.iv,
    ciphertext: final.ciphertext,
    tag: final.tag
  }

  if (!result.recipients.length) {
    delete result.recipients
  }

  return result
}
generalSerializer.validate = (protectedHeader, unprotectedHeader, aad, recipients) => {
  recipients.forEach(({ header }) => {
    validateCrit(protectedHeader, { ...header, ...unprotectedHeader }, protectedHeader ? protectedHeader.crit : undefined)
  })
}

const isJSON = (input) => {
  return isObject(input) &&
    typeof input.ciphertext === 'string' &&
    typeof input.iv === 'string' &&
    typeof input.tag === 'string' &&
    (input.unprotected === undefined || isObject(input.unprotected)) &&
    (input.protected === undefined || typeof input.protected === 'string') &&
    (input.aad === undefined || typeof input.aad === 'string')
}

const isSingleRecipient = (input) => {
  return (input.encrypted_key === undefined || typeof input.encrypted_key === 'string') &&
    (input.header === undefined || isObject(input.header))
}

const isValidRecipient = (recipient) => {
  return isObject(recipient) && typeof recipient.encrypted_key === 'string' && (recipient.header === undefined || isObject(recipient.header))
}

const isMultiRecipient = (input) => {
  if (Array.isArray(input.recipients) && input.recipients.every(isValidRecipient)) {
    return true
  }

  return false
}

const detect = (input) => {
  if (typeof input === 'string' && input.split('.').length === 5) {
    return 'compact'
  }

  if (isJSON(input)) {
    if (isMultiRecipient(input)) {
      return 'general'
    }

    if (isSingleRecipient(input)) {
      return 'flattened'
    }
  }

  throw new JWEInvalid('JWE malformed or invalid serialization')
}

module.exports = {
  compact: compactSerializer,
  flattened: flattenedSerializer,
  general: generalSerializer,
  detect
}


/***/ }),

/***/ 66557:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const isDisjoint = __webpack_require__(970)
const base64url = __webpack_require__(37448)
let validateCrit = __webpack_require__(16542)
const { JWEInvalid, JOSENotSupported } = __webpack_require__(8293)

validateCrit = validateCrit.bind(undefined, JWEInvalid)

module.exports = (prot, unprotected, recipients, checkAlgorithms, crit) => {
  if (typeof prot === 'string') {
    try {
      prot = base64url.JSON.decode(prot)
    } catch (err) {
      throw new JWEInvalid('could not parse JWE protected header')
    }
  }

  let alg = []
  const enc = new Set()
  if (!isDisjoint(prot, unprotected) || !recipients.every(({ header }) => {
    if (typeof header === 'object') {
      alg.push(header.alg)
      enc.add(header.enc)
    }
    const combined = { ...unprotected, ...header }
    validateCrit(prot, combined, crit)
    if ('zip' in combined) {
      throw new JWEInvalid('"zip" Header Parameter MUST be integrity protected')
    } else if (prot && 'zip' in prot && prot.zip !== 'DEF') {
      throw new JOSENotSupported('only "DEF" compression algorithm is supported')
    }
    return isDisjoint(header, prot) && isDisjoint(header, unprotected)
  })) {
    throw new JWEInvalid('JWE Shared Protected, JWE Shared Unprotected and JWE Per-Recipient Header Parameter names must be disjoint')
  }

  if (typeof prot === 'object') {
    alg.push(prot.alg)
    enc.add(prot.enc)
  }
  if (typeof unprotected === 'object') {
    alg.push(unprotected.alg)
    enc.add(unprotected.enc)
  }

  alg = alg.filter(Boolean)
  enc.delete(undefined)

  if (recipients.length !== 1) {
    if (alg.includes('dir') || alg.includes('ECDH-ES')) {
      throw new JWEInvalid('dir and ECDH-ES alg may only be used with a single recipient')
    }
  }

  if (checkAlgorithms) {
    if (alg.length !== recipients.length) {
      throw new JWEInvalid('missing Key Management algorithm')
    }
    if (enc.size === 0) {
      throw new JWEInvalid('missing Content Encryption algorithm')
    } else if (enc.size !== 1) {
      throw new JWEInvalid('there must only be one Content Encryption algorithm')
    }
  } else {
    if (enc.size > 1) {
      throw new JWEInvalid('there must only be one Content Encryption algorithm')
    }
  }

  return [...enc][0]
}


/***/ }),

/***/ 47943:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const errors = __webpack_require__(8293)

const importKey = __webpack_require__(86698)

const RSAKey = __webpack_require__(32285)
const ECKey = __webpack_require__(61661)
const OKPKey = __webpack_require__(76618)
const OctKey = __webpack_require__(91933)

const generate = async (kty, crvOrSize, params, generatePrivate = true) => {
  switch (kty) {
    case 'RSA':
      return importKey(
        await RSAKey.generate(crvOrSize, generatePrivate),
        params
      )
    case 'EC':
      return importKey(
        await ECKey.generate(crvOrSize, generatePrivate),
        params
      )
    case 'OKP':
      return importKey(
        await OKPKey.generate(crvOrSize, generatePrivate),
        params
      )
    case 'oct':
      return importKey(
        await OctKey.generate(crvOrSize, generatePrivate),
        params
      )
    default:
      throw new errors.JOSENotSupported(`unsupported key type: ${kty}`)
  }
}

const generateSync = (kty, crvOrSize, params, generatePrivate = true) => {
  switch (kty) {
    case 'RSA':
      return importKey(RSAKey.generateSync(crvOrSize, generatePrivate), params)
    case 'EC':
      return importKey(ECKey.generateSync(crvOrSize, generatePrivate), params)
    case 'OKP':
      return importKey(OKPKey.generateSync(crvOrSize, generatePrivate), params)
    case 'oct':
      return importKey(OctKey.generateSync(crvOrSize, generatePrivate), params)
    default:
      throw new errors.JOSENotSupported(`unsupported key type: ${kty}`)
  }
}

module.exports.generate = generate
module.exports.generateSync = generateSync


/***/ }),

/***/ 86698:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const { createPublicKey, createPrivateKey, createSecretKey, KeyObject } = __webpack_require__(57658)
const base64url = __webpack_require__(37448)
const isObject = __webpack_require__(94336)
const { jwkToPem } = __webpack_require__(91166)
const errors = __webpack_require__(8293)

const RSAKey = __webpack_require__(32285)
const ECKey = __webpack_require__(61661)
const OKPKey = __webpack_require__(76618)
const OctKey = __webpack_require__(91933)

const importable = new Set(['string', 'buffer', 'object'])

const mergedParameters = (target = {}, source = {}) => {
  return {
    alg: source.alg,
    key_ops: source.key_ops,
    kid: source.kid,
    use: source.use,
    x5c: source.x5c,
    x5t: source.x5t,
    'x5t#S256': source['x5t#S256'],
    ...target
  }
}

const openSSHpublicKey = /^[a-zA-Z0-9-]+ AAAA(?:[0-9A-Za-z+/])+(?:==|=)?(?: .*)?$/

const asKey = (key, parameters, { calculateMissingRSAPrimes = false } = {}) => {
  let privateKey, publicKey, secret

  if (!importable.has(typeof key)) {
    throw new TypeError('key argument must be a string, buffer or an object')
  }

  if (parameters !== undefined && !isObject(parameters)) {
    throw new TypeError('parameters argument must be a plain object when provided')
  }

  if (key instanceof KeyObject) {
    switch (key.type) {
      case 'private':
        privateKey = key
        break
      case 'public':
        publicKey = key
        break
      case 'secret':
        secret = key
        break
    }
  } else if (typeof key === 'object' && key && 'kty' in key && key.kty === 'oct') { // symmetric key <Object>
    try {
      secret = createSecretKey(base64url.decodeToBuffer(key.k))
    } catch (err) {
      if (!('k' in key)) {
        secret = { type: 'secret' }
      }
    }
    parameters = mergedParameters(parameters, key)
  } else if (typeof key === 'object' && key && 'kty' in key) { // assume JWK formatted asymmetric key <Object>
    ({ calculateMissingRSAPrimes = false } = parameters || { calculateMissingRSAPrimes })
    let pem

    try {
      pem = jwkToPem(key, { calculateMissingRSAPrimes })
    } catch (err) {
      if (err instanceof errors.JOSEError) {
        throw err
      }
    }

    if (pem && key.d) {
      privateKey = createPrivateKey(pem)
    } else if (pem) {
      publicKey = createPublicKey(pem)
    }

    parameters = mergedParameters({}, key)
  } else if (key && (typeof key === 'object' || typeof key === 'string')) { // <Object> | <string> | <Buffer> passed to crypto.createPrivateKey or crypto.createPublicKey or <Buffer> passed to crypto.createSecretKey
    try {
      privateKey = createPrivateKey(key)
    } catch (err) {
      if (err instanceof errors.JOSEError) {
        throw err
      }
    }

    try {
      publicKey = createPublicKey(key)
      if (key.startsWith('-----BEGIN CERTIFICATE-----') && (!parameters || !('x5c' in parameters))) {
        parameters = mergedParameters(parameters, {
          x5c: [key.replace(/(?:-----(?:BEGIN|END) CERTIFICATE-----|\s)/g, '')]
        })
      }
    } catch (err) {
      if (err instanceof errors.JOSEError) {
        throw err
      }
    }

    try {
      // this is to filter out invalid PEM keys and certs, i'll rather have them fail import then
      // have them imported as symmetric "oct" keys
      if (!key.includes('-----BEGIN') && !openSSHpublicKey.test(key.toString('ascii').replace(/[\r\n]/g, ''))) {
        secret = createSecretKey(Buffer.isBuffer(key) ? key : Buffer.from(key))
      }
    } catch (err) {}
  }

  const keyObject = privateKey || publicKey || secret

  if (privateKey || publicKey) {
    switch (keyObject.asymmetricKeyType) {
      case 'rsa':
        return new RSAKey(keyObject, parameters)
      case 'ec':
        return new ECKey(keyObject, parameters)
      case 'ed25519':
      case 'ed448':
      case 'x25519':
      case 'x448':
        return new OKPKey(keyObject, parameters)
      default:
        throw new errors.JOSENotSupported('only RSA, EC and OKP asymmetric keys are supported')
    }
  } else if (secret) {
    return new OctKey(keyObject, parameters)
  }

  throw new errors.JWKImportFailed('key import failed')
}

module.exports = asKey


/***/ }),

/***/ 86887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const Key = __webpack_require__(52155)
const None = __webpack_require__(97306)
const EmbeddedJWK = __webpack_require__(77762)
const EmbeddedX5C = __webpack_require__(48482)
const importKey = __webpack_require__(86698)
const generate = __webpack_require__(47943)

module.exports = {
  ...generate,
  asKey: importKey,
  isKey: input => input instanceof Key,
  None,
  EmbeddedJWK,
  EmbeddedX5C
}


/***/ }),

/***/ 52155:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
const { strict: assert } = __webpack_require__(27596)
const { inspect } = __webpack_require__(79720)
const { EOL } = __webpack_require__(73461)

const { keyObjectSupported } = __webpack_require__(17945)
const { createPublicKey } = __webpack_require__(57658)
const { keyObjectToJWK } = __webpack_require__(91166)
const {
  THUMBPRINT_MATERIAL, PUBLIC_MEMBERS, PRIVATE_MEMBERS, JWK_MEMBERS, KEYOBJECT,
  USES_MAPPING, OPS, USES
} = __webpack_require__(92931)
const isObject = __webpack_require__(94336)
const thumbprint = __webpack_require__(62000)
const errors = __webpack_require__(8293)

const privateApi = Symbol('privateApi')
const { JWK } = __webpack_require__(7422)

class Key {
  constructor (keyObject, { alg, use, kid, key_ops: ops, x5c, x5t, 'x5t#S256': x5t256 } = {}) {
    if (use !== undefined) {
      if (typeof use !== 'string' || !USES.has(use)) {
        throw new TypeError('`use` must be either "sig" or "enc" string when provided')
      }
    }

    if (alg !== undefined) {
      if (typeof alg !== 'string' || !alg) {
        throw new TypeError('`alg` must be a non-empty string when provided')
      }
    }

    if (kid !== undefined) {
      if (typeof kid !== 'string' || !kid) {
        throw new TypeError('`kid` must be a non-empty string when provided')
      }
    }

    if (ops !== undefined) {
      if (!Array.isArray(ops) || !ops.length || ops.some(o => typeof o !== 'string')) {
        throw new TypeError('`key_ops` must be a non-empty array of strings when provided')
      }
      ops = Array.from(new Set(ops)).filter(x => OPS.has(x))
    }

    if (ops && use) {
      if (
        (use === 'enc' && ops.some(x => USES_MAPPING.sig.has(x))) ||
        (use === 'sig' && ops.some(x => USES_MAPPING.enc.has(x)))
      ) {
        throw new errors.JWKInvalid('inconsistent JWK "use" and "key_ops"')
      }
    }

    if (keyObjectSupported && x5c !== undefined) {
      if (!Array.isArray(x5c) || !x5c.length || x5c.some(c => typeof c !== 'string')) {
        throw new TypeError('`x5c` must be an array of one or more PKIX certificates when provided')
      }

      x5c.forEach((cert, i) => {
        let publicKey
        try {
          publicKey = createPublicKey({
            key: `-----BEGIN CERTIFICATE-----${EOL}${(cert.match(/.{1,64}/g) || []).join(EOL)}${EOL}-----END CERTIFICATE-----`, format: 'pem'
          })
        } catch (err) {
          throw new errors.JWKInvalid(`\`x5c\` member at index ${i} is not a valid base64-encoded DER PKIX certificate`)
        }
        if (i === 0) {
          try {
            assert.deepEqual(
              publicKey.export({ type: 'spki', format: 'der' }),
              (keyObject.type === 'public' ? keyObject : createPublicKey(keyObject)).export({ type: 'spki', format: 'der' })
            )
          } catch (err) {
            throw new errors.JWKInvalid('The key in the first `x5c` certificate MUST match the public key represented by the JWK')
          }
        }
      })
    }

    Object.defineProperties(this, {
      [KEYOBJECT]: { value: isObject(keyObject) ? undefined : keyObject },
      keyObject: {
        get () {
          if (!keyObjectSupported) {
            throw new errors.JOSENotSupported('KeyObject class is not supported in your Node.js runtime version')
          }

          return this[KEYOBJECT]
        }
      },
      type: { value: keyObject.type },
      private: { value: keyObject.type === 'private' },
      public: { value: keyObject.type === 'public' },
      secret: { value: keyObject.type === 'secret' },
      alg: { value: alg, enumerable: alg !== undefined },
      use: { value: use, enumerable: use !== undefined },
      x5c: {
        enumerable: x5c !== undefined,
        ...(x5c ? { get () { return [...x5c] } } : { value: undefined })
      },
      key_ops: {
        enumerable: ops !== undefined,
        ...(ops ? { get () { return [...ops] } } : { value: undefined })
      },
      kid: {
        enumerable: true,
        ...(kid
          ? { value: kid }
          : {
              get () {
                Object.defineProperty(this, 'kid', { value: this.thumbprint, configurable: false })
                return this.kid
              },
              configurable: true
            })
      },
      ...(x5c
        ? {
            x5t: {
              enumerable: true,
              ...(x5t
                ? { value: x5t }
                : {
                    get () {
                      Object.defineProperty(this, 'x5t', { value: thumbprint.x5t(this.x5c[0]), configurable: false })
                      return this.x5t
                    },
                    configurable: true
                  })
            }
          }
        : undefined),
      ...(x5c
        ? {
            'x5t#S256': {
              enumerable: true,
              ...(x5t256
                ? { value: x5t256 }
                : {
                    get () {
                      Object.defineProperty(this, 'x5t#S256', { value: thumbprint['x5t#S256'](this.x5c[0]), configurable: false })
                      return this['x5t#S256']
                    },
                    configurable: true
                  })
            }
          }
        : undefined),
      thumbprint: {
        get () {
          Object.defineProperty(this, 'thumbprint', { value: thumbprint.kid(this[THUMBPRINT_MATERIAL]()), configurable: false })
          return this.thumbprint
        },
        configurable: true
      }
    })
  }

  toPEM (priv = false, encoding = {}) {
    if (this.secret) {
      throw new TypeError('symmetric keys cannot be exported as PEM')
    }

    if (priv && this.public === true) {
      throw new TypeError('public key cannot be exported as private')
    }

    const { type = priv ? 'pkcs8' : 'spki', cipher, passphrase } = encoding

    let keyObject = this[KEYOBJECT]

    if (!priv) {
      if (this.private) {
        keyObject = createPublicKey(keyObject)
      }
      if (cipher || passphrase) {
        throw new TypeError('cipher and passphrase can only be applied when exporting private keys')
      }
    }

    if (priv) {
      return keyObject.export({ format: 'pem', type, cipher, passphrase })
    }

    return keyObject.export({ format: 'pem', type })
  }

  toJWK (priv = false) {
    if (priv && this.public === true) {
      throw new TypeError('public key cannot be exported as private')
    }

    const components = [...this.constructor[priv ? PRIVATE_MEMBERS : PUBLIC_MEMBERS]]
      .map(k => [k, this[k]])

    const result = {}

    Object.keys(components).forEach((key) => {
      const [k, v] = components[key]

      result[k] = v
    })

    result.kty = this.kty
    result.kid = this.kid

    if (this.alg) {
      result.alg = this.alg
    }

    if (this.key_ops && this.key_ops.length) {
      result.key_ops = this.key_ops
    }

    if (this.use) {
      result.use = this.use
    }

    if (this.x5c) {
      result.x5c = this.x5c
    }

    if (this.x5t) {
      result.x5t = this.x5t
    }

    if (this['x5t#S256']) {
      result['x5t#S256'] = this['x5t#S256']
    }

    return result
  }

  [JWK_MEMBERS] () {
    const props = this[KEYOBJECT].type === 'private' ? this.constructor[PRIVATE_MEMBERS] : this.constructor[PUBLIC_MEMBERS]
    Object.defineProperties(this, [...props].reduce((acc, component) => {
      acc[component] = {
        get () {
          const jwk = keyObjectToJWK(this[KEYOBJECT])
          Object.defineProperties(
            this,
            Object.entries(jwk)
              .filter(([key]) => props.has(key))
              .reduce((acc, [key, value]) => {
                acc[key] = { value, enumerable: this.constructor[PUBLIC_MEMBERS].has(key), configurable: false }
                return acc
              }, {})
          )

          return this[component]
        },
        enumerable: this.constructor[PUBLIC_MEMBERS].has(component),
        configurable: true
      }
      return acc
    }, {}))
  }

  /* c8 ignore next 8 */
  [inspect.custom] () {
    return `${this.constructor.name} ${inspect(this.toJWK(false), {
      depth: Infinity,
      colors: process.stdout.isTTY,
      compact: false,
      sorted: true
    })}`
  }

  /* c8 ignore next 3 */
  [THUMBPRINT_MATERIAL] () {
    throw new Error(`"[THUMBPRINT_MATERIAL]()" is not implemented on ${this.constructor.name}`)
  }

  algorithms (operation, /* the rest is private API */ int, opts) {
    const { use = this.use, alg = this.alg, key_ops: ops = this.key_ops } = int === privateApi ? opts : {}
    if (alg) {
      return new Set(this.algorithms(operation, privateApi, { alg: null, use, key_ops: ops }).has(alg) ? [alg] : undefined)
    }

    if (typeof operation === 'symbol') {
      try {
        return this[operation]()
      } catch (err) {
        return new Set()
      }
    }

    if (operation && ops && !ops.includes(operation)) {
      return new Set()
    }

    switch (operation) {
      case 'decrypt':
      case 'deriveKey':
      case 'encrypt':
      case 'sign':
      case 'unwrapKey':
      case 'verify':
      case 'wrapKey':
        return new Set(Object.entries(JWK[this.kty][operation]).map(([alg, fn]) => fn(this) ? alg : undefined).filter(Boolean))
      case undefined:
        return new Set([
          ...this.algorithms('sign'),
          ...this.algorithms('verify'),
          ...this.algorithms('decrypt'),
          ...this.algorithms('encrypt'),
          ...this.algorithms('unwrapKey'),
          ...this.algorithms('wrapKey'),
          ...this.algorithms('deriveKey')
        ])
      default:
        throw new TypeError('invalid key operation')
    }
  }

  /* c8 ignore next 3 */
  static async generate () {
    throw new Error(`"static async generate()" is not implemented on ${this.name}`)
  }

  /* c8 ignore next 3 */
  static generateSync () {
    throw new Error(`"static generateSync()" is not implemented on ${this.name}`)
  }

  /* c8 ignore next 3 */
  static get [PUBLIC_MEMBERS] () {
    throw new Error(`"static get [PUBLIC_MEMBERS]()" is not implemented on ${this.name}`)
  }

  /* c8 ignore next 3 */
  static get [PRIVATE_MEMBERS] () {
    throw new Error(`"static get [PRIVATE_MEMBERS]()" is not implemented on ${this.name}`)
  }
}

module.exports = Key


/***/ }),

/***/ 61661:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { generateKeyPairSync, generateKeyPair: async } = __webpack_require__(42474)
const { promisify } = __webpack_require__(79720)

const {
  THUMBPRINT_MATERIAL, JWK_MEMBERS, PUBLIC_MEMBERS,
  PRIVATE_MEMBERS, KEY_MANAGEMENT_DECRYPT, KEY_MANAGEMENT_ENCRYPT
} = __webpack_require__(92931)
const { EC_CURVES } = __webpack_require__(7422)
const { keyObjectSupported } = __webpack_require__(17945)
const { createPublicKey, createPrivateKey } = __webpack_require__(57658)

const errors = __webpack_require__(8293)

const Key = __webpack_require__(52155)

const generateKeyPair = promisify(async)

const EC_PUBLIC = new Set(['crv', 'x', 'y'])
Object.freeze(EC_PUBLIC)
const EC_PRIVATE = new Set([...EC_PUBLIC, 'd'])
Object.freeze(EC_PRIVATE)

// Elliptic Curve Key Type
class ECKey extends Key {
  constructor (...args) {
    super(...args)
    this[JWK_MEMBERS]()
    Object.defineProperty(this, 'kty', { value: 'EC', enumerable: true })
    if (!EC_CURVES.has(this.crv)) {
      throw new errors.JOSENotSupported('unsupported EC key curve')
    }
  }

  static get [PUBLIC_MEMBERS] () {
    return EC_PUBLIC
  }

  static get [PRIVATE_MEMBERS] () {
    return EC_PRIVATE
  }

  // https://tc39.github.io/ecma262/#sec-ordinaryownpropertykeys no need for any special
  // JSON.stringify handling in V8
  [THUMBPRINT_MATERIAL] () {
    return { crv: this.crv, kty: 'EC', x: this.x, y: this.y }
  }

  [KEY_MANAGEMENT_ENCRYPT] () {
    return this.algorithms('deriveKey')
  }

  [KEY_MANAGEMENT_DECRYPT] () {
    if (this.public) {
      return new Set()
    }
    return this.algorithms('deriveKey')
  }

  static async generate (crv = 'P-256', privat = true) {
    if (!EC_CURVES.has(crv)) {
      throw new errors.JOSENotSupported(`unsupported EC key curve: ${crv}`)
    }

    let privateKey, publicKey

    if (keyObjectSupported) {
      ({ privateKey, publicKey } = await generateKeyPair('ec', { namedCurve: crv }))
      return privat ? privateKey : publicKey
    }

    ({ privateKey, publicKey } = await generateKeyPair('ec', {
      namedCurve: crv,
      publicKeyEncoding: { type: 'spki', format: 'pem' },
      privateKeyEncoding: { type: 'pkcs8', format: 'pem' }
    }))

    if (privat) {
      return createPrivateKey(privateKey)
    } else {
      return createPublicKey(publicKey)
    }
  }

  static generateSync (crv = 'P-256', privat = true) {
    if (!EC_CURVES.has(crv)) {
      throw new errors.JOSENotSupported(`unsupported EC key curve: ${crv}`)
    }

    let privateKey, publicKey

    if (keyObjectSupported) {
      ({ privateKey, publicKey } = generateKeyPairSync('ec', { namedCurve: crv }))
      return privat ? privateKey : publicKey
    }

    ({ privateKey, publicKey } = generateKeyPairSync('ec', {
      namedCurve: crv,
      publicKeyEncoding: { type: 'spki', format: 'pem' },
      privateKeyEncoding: { type: 'pkcs8', format: 'pem' }
    }))

    if (privat) {
      return createPrivateKey(privateKey)
    } else {
      return createPublicKey(publicKey)
    }
  }
}

module.exports = ECKey


/***/ }),

/***/ 77762:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { inspect } = __webpack_require__(79720)

const Key = __webpack_require__(52155)

class EmbeddedJWK extends Key {
  constructor () {
    super({ type: 'embedded' })
    Object.defineProperties(this, {
      kid: { value: undefined },
      kty: { value: undefined },
      thumbprint: { value: undefined },
      toJWK: { value: undefined },
      toPEM: { value: undefined }
    })
  }

  /* c8 ignore next 3 */
  [inspect.custom] () {
    return 'Embedded.JWK {}'
  }

  algorithms () {
    return new Set()
  }
}

module.exports = new EmbeddedJWK()


/***/ }),

/***/ 48482:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { inspect } = __webpack_require__(79720)

const Key = __webpack_require__(52155)

class EmbeddedX5C extends Key {
  constructor () {
    super({ type: 'embedded' })
    Object.defineProperties(this, {
      kid: { value: undefined },
      kty: { value: undefined },
      thumbprint: { value: undefined },
      toJWK: { value: undefined },
      toPEM: { value: undefined }
    })
  }

  /* c8 ignore next 3 */
  [inspect.custom] () {
    return 'Embedded.X5C {}'
  }

  algorithms () {
    return new Set()
  }
}

module.exports = new EmbeddedX5C()


/***/ }),

/***/ 97306:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { inspect } = __webpack_require__(79720)

const Key = __webpack_require__(52155)

class NoneKey extends Key {
  constructor () {
    super({ type: 'unsecured' }, { alg: 'none' })
    Object.defineProperties(this, {
      kid: { value: undefined },
      kty: { value: undefined },
      thumbprint: { value: undefined },
      toJWK: { value: undefined },
      toPEM: { value: undefined }
    })
  }

  /* c8 ignore next 3 */
  [inspect.custom] () {
    return 'None {}'
  }

  algorithms (operation) {
    switch (operation) {
      case 'sign':
      case 'verify':
      case undefined:
        return new Set(['none'])
      default:
        return new Set()
    }
  }
}

module.exports = new NoneKey()


/***/ }),

/***/ 91933:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { randomBytes } = __webpack_require__(42474)

const { createSecretKey } = __webpack_require__(57658)
const base64url = __webpack_require__(37448)
const {
  THUMBPRINT_MATERIAL, PUBLIC_MEMBERS, PRIVATE_MEMBERS,
  KEY_MANAGEMENT_DECRYPT, KEY_MANAGEMENT_ENCRYPT, KEYOBJECT
} = __webpack_require__(92931)

const Key = __webpack_require__(52155)

const OCT_PUBLIC = new Set()
Object.freeze(OCT_PUBLIC)
const OCT_PRIVATE = new Set(['k'])
Object.freeze(OCT_PRIVATE)

// Octet sequence Key Type
class OctKey extends Key {
  constructor (...args) {
    super(...args)
    Object.defineProperties(this, {
      kty: {
        value: 'oct',
        enumerable: true
      },
      length: {
        value: this[KEYOBJECT] ? this[KEYOBJECT].symmetricKeySize * 8 : undefined
      },
      k: {
        enumerable: false,
        get () {
          if (this[KEYOBJECT]) {
            Object.defineProperty(this, 'k', {
              value: base64url.encodeBuffer(this[KEYOBJECT].export()),
              configurable: false
            })
          } else {
            Object.defineProperty(this, 'k', {
              value: undefined,
              configurable: false
            })
          }

          return this.k
        },
        configurable: true
      }
    })
  }

  static get [PUBLIC_MEMBERS] () {
    return OCT_PUBLIC
  }

  static get [PRIVATE_MEMBERS] () {
    return OCT_PRIVATE
  }

  // https://tc39.github.io/ecma262/#sec-ordinaryownpropertykeys no need for any special
  // JSON.stringify handling in V8
  [THUMBPRINT_MATERIAL] () {
    if (!this[KEYOBJECT]) {
      throw new TypeError('reference "oct" keys without "k" cannot have their thumbprint calculated')
    }
    return { k: this.k, kty: 'oct' }
  }

  [KEY_MANAGEMENT_ENCRYPT] () {
    return new Set([
      ...this.algorithms('wrapKey'),
      ...this.algorithms('deriveKey')
    ])
  }

  [KEY_MANAGEMENT_DECRYPT] () {
    return this[KEY_MANAGEMENT_ENCRYPT]()
  }

  algorithms (...args) {
    if (!this[KEYOBJECT]) {
      return new Set()
    }

    return Key.prototype.algorithms.call(this, ...args)
  }

  static async generate (...args) {
    return this.generateSync(...args)
  }

  static generateSync (len = 256, privat = true) {
    if (!privat) {
      throw new TypeError('"oct" keys cannot be generated as public')
    }
    if (!Number.isSafeInteger(len) || !len || len % 8 !== 0) {
      throw new TypeError('invalid bit length')
    }

    return createSecretKey(randomBytes(len / 8))
  }
}

module.exports = OctKey


/***/ }),

/***/ 76618:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { generateKeyPairSync, generateKeyPair: async } = __webpack_require__(42474)
const { promisify } = __webpack_require__(79720)

const {
  THUMBPRINT_MATERIAL, JWK_MEMBERS, PUBLIC_MEMBERS,
  PRIVATE_MEMBERS, KEY_MANAGEMENT_DECRYPT, KEY_MANAGEMENT_ENCRYPT
} = __webpack_require__(92931)
const { OKP_CURVES } = __webpack_require__(7422)
const { edDSASupported } = __webpack_require__(17945)
const errors = __webpack_require__(8293)

const Key = __webpack_require__(52155)

const generateKeyPair = promisify(async)

const OKP_PUBLIC = new Set(['crv', 'x'])
Object.freeze(OKP_PUBLIC)
const OKP_PRIVATE = new Set([...OKP_PUBLIC, 'd'])
Object.freeze(OKP_PRIVATE)

// Octet string key pairs Key Type
class OKPKey extends Key {
  constructor (...args) {
    super(...args)
    this[JWK_MEMBERS]()
    Object.defineProperty(this, 'kty', { value: 'OKP', enumerable: true })
    if (!OKP_CURVES.has(this.crv)) {
      throw new errors.JOSENotSupported('unsupported OKP key curve')
    }
  }

  static get [PUBLIC_MEMBERS] () {
    return OKP_PUBLIC
  }

  static get [PRIVATE_MEMBERS] () {
    return OKP_PRIVATE
  }

  // https://tc39.github.io/ecma262/#sec-ordinaryownpropertykeys no need for any special
  // JSON.stringify handling in V8
  [THUMBPRINT_MATERIAL] () {
    return { crv: this.crv, kty: 'OKP', x: this.x }
  }

  [KEY_MANAGEMENT_ENCRYPT] () {
    return this.algorithms('deriveKey')
  }

  [KEY_MANAGEMENT_DECRYPT] () {
    if (this.public) {
      return new Set()
    }
    return this.algorithms('deriveKey')
  }

  static async generate (crv = 'Ed25519', privat = true) {
    if (!edDSASupported) {
      throw new errors.JOSENotSupported('OKP keys are not supported in your Node.js runtime version')
    }

    if (!OKP_CURVES.has(crv)) {
      throw new errors.JOSENotSupported(`unsupported OKP key curve: ${crv}`)
    }

    const { privateKey, publicKey } = await generateKeyPair(crv.toLowerCase())

    return privat ? privateKey : publicKey
  }

  static generateSync (crv = 'Ed25519', privat = true) {
    if (!edDSASupported) {
      throw new errors.JOSENotSupported('OKP keys are not supported in your Node.js runtime version')
    }

    if (!OKP_CURVES.has(crv)) {
      throw new errors.JOSENotSupported(`unsupported OKP key curve: ${crv}`)
    }

    const { privateKey, publicKey } = generateKeyPairSync(crv.toLowerCase())

    return privat ? privateKey : publicKey
  }
}

module.exports = OKPKey


/***/ }),

/***/ 32285:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/* provided dependency */ var process = __webpack_require__(83454);
const { generateKeyPairSync, generateKeyPair: async } = __webpack_require__(42474)
const { promisify } = __webpack_require__(79720)

const {
  THUMBPRINT_MATERIAL, JWK_MEMBERS, PUBLIC_MEMBERS,
  PRIVATE_MEMBERS, KEY_MANAGEMENT_DECRYPT, KEY_MANAGEMENT_ENCRYPT
} = __webpack_require__(92931)
const { keyObjectSupported } = __webpack_require__(17945)
const { createPublicKey, createPrivateKey } = __webpack_require__(57658)

const Key = __webpack_require__(52155)

const generateKeyPair = promisify(async)

const RSA_PUBLIC = new Set(['e', 'n'])
Object.freeze(RSA_PUBLIC)
const RSA_PRIVATE = new Set([...RSA_PUBLIC, 'd', 'p', 'q', 'dp', 'dq', 'qi'])
Object.freeze(RSA_PRIVATE)

// RSA Key Type
class RSAKey extends Key {
  constructor (...args) {
    super(...args)
    this[JWK_MEMBERS]()
    Object.defineProperties(this, {
      kty: {
        value: 'RSA',
        enumerable: true
      },
      length: {
        get () {
          Object.defineProperty(this, 'length', {
            value: Buffer.byteLength(this.n, 'base64') * 8,
            configurable: false
          })

          return this.length
        },
        configurable: true
      }
    })
  }

  static get [PUBLIC_MEMBERS] () {
    return RSA_PUBLIC
  }

  static get [PRIVATE_MEMBERS] () {
    return RSA_PRIVATE
  }

  // https://tc39.github.io/ecma262/#sec-ordinaryownpropertykeys no need for any special
  // JSON.stringify handling in V8
  [THUMBPRINT_MATERIAL] () {
    return { e: this.e, kty: 'RSA', n: this.n }
  }

  [KEY_MANAGEMENT_ENCRYPT] () {
    return this.algorithms('wrapKey')
  }

  [KEY_MANAGEMENT_DECRYPT] () {
    return this.algorithms('unwrapKey')
  }

  static async generate (len = 2048, privat = true) {
    if (!Number.isSafeInteger(len) || len < 512 || len % 8 !== 0 || (('electron' in process.versions) && len % 128 !== 0)) {
      throw new TypeError('invalid bit length')
    }

    let privateKey, publicKey

    if (keyObjectSupported) {
      ({ privateKey, publicKey } = await generateKeyPair('rsa', { modulusLength: len }))
      return privat ? privateKey : publicKey
    }

    ({ privateKey, publicKey } = await generateKeyPair('rsa', {
      modulusLength: len,
      publicKeyEncoding: { type: 'spki', format: 'pem' },
      privateKeyEncoding: { type: 'pkcs8', format: 'pem' }
    }))

    if (privat) {
      return createPrivateKey(privateKey)
    } else {
      return createPublicKey(publicKey)
    }
  }

  static generateSync (len = 2048, privat = true) {
    if (!Number.isSafeInteger(len) || len < 512 || len % 8 !== 0 || (('electron' in process.versions) && len % 128 !== 0)) {
      throw new TypeError('invalid bit length')
    }

    let privateKey, publicKey

    if (keyObjectSupported) {
      ({ privateKey, publicKey } = generateKeyPairSync('rsa', { modulusLength: len }))
      return privat ? privateKey : publicKey
    }

    ({ privateKey, publicKey } = generateKeyPairSync('rsa', {
      modulusLength: len,
      publicKeyEncoding: { type: 'spki', format: 'pem' },
      privateKeyEncoding: { type: 'pkcs8', format: 'pem' }
    }))

    if (privat) {
      return createPrivateKey(privateKey)
    } else {
      return createPublicKey(publicKey)
    }
  }
}

module.exports = RSAKey


/***/ }),

/***/ 62000:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const { createHash } = __webpack_require__(42474)

const base64url = __webpack_require__(37448)

const x5t = (hash, cert) => base64url.encodeBuffer(createHash(hash).update(Buffer.from(cert, 'base64')).digest())

module.exports.kid = components => base64url.encodeBuffer(createHash('sha256').update(JSON.stringify(components)).digest())
module.exports.x5t = x5t.bind(undefined, 'sha1')
module.exports["x5t#S256"] = x5t.bind(undefined, 'sha256')


/***/ }),

/***/ 718:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const KeyStore = __webpack_require__(47031)

module.exports = KeyStore


/***/ }),

/***/ 47031:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
const { inspect } = __webpack_require__(79720)

const isObject = __webpack_require__(94336)
const { generate, generateSync } = __webpack_require__(47943)
const { USES_MAPPING } = __webpack_require__(92931)
const { isKey, asKey: importKey } = __webpack_require__(86887)

const keyscore = (key, { alg, use, ops }) => {
  let score = 0

  if (alg && key.alg) {
    score++
  }

  if (use && key.use) {
    score++
  }

  if (ops && key.key_ops) {
    score++
  }

  return score
}

class KeyStore {
  constructor (...keys) {
    while (keys.some(Array.isArray)) {
      keys = keys.flat
        ? keys.flat()
        : keys.reduce((acc, val) => {
          if (Array.isArray(val)) {
            return [...acc, ...val]
          }

          acc.push(val)
          return acc
        }, [])
    }
    if (keys.some(k => !isKey(k) || !k.kty)) {
      throw new TypeError('all keys must be instances of a key instantiated by JWK.asKey')
    }

    this._keys = new Set(keys)
  }

  all ({ alg, kid, thumbprint, use, kty, key_ops: ops, x5t, 'x5t#S256': x5t256, crv } = {}) {
    if (ops !== undefined && (!Array.isArray(ops) || !ops.length || ops.some(x => typeof x !== 'string'))) {
      throw new TypeError('`key_ops` must be a non-empty array of strings')
    }

    const search = { alg, use, ops }
    return [...this._keys]
      .filter((key) => {
        let candidate = true

        if (candidate && kid !== undefined && key.kid !== kid) {
          candidate = false
        }

        if (candidate && thumbprint !== undefined && key.thumbprint !== thumbprint) {
          candidate = false
        }

        if (candidate && x5t !== undefined && key.x5t !== x5t) {
          candidate = false
        }

        if (candidate && x5t256 !== undefined && key['x5t#S256'] !== x5t256) {
          candidate = false
        }

        if (candidate && kty !== undefined && key.kty !== kty) {
          candidate = false
        }

        if (candidate && crv !== undefined && (key.crv !== crv)) {
          candidate = false
        }

        if (alg !== undefined && !key.algorithms().has(alg)) {
          candidate = false
        }

        if (candidate && use !== undefined && (key.use !== undefined && key.use !== use)) {
          candidate = false
        }

        // TODO:
        if (candidate && ops !== undefined && (key.key_ops !== undefined || key.use !== undefined)) {
          let keyOps
          if (key.key_ops) {
            keyOps = new Set(key.key_ops)
          } else {
            keyOps = USES_MAPPING[key.use]
          }
          if (ops.some(x => !keyOps.has(x))) {
            candidate = false
          }
        }

        return candidate
      })
      .sort((first, second) => keyscore(second, search) - keyscore(first, search))
  }

  get (...args) {
    return this.all(...args)[0]
  }

  add (key) {
    if (!isKey(key) || !key.kty) {
      throw new TypeError('key must be an instance of a key instantiated by JWK.asKey')
    }

    this._keys.add(key)
  }

  remove (key) {
    if (!isKey(key)) {
      throw new TypeError('key must be an instance of a key instantiated by JWK.asKey')
    }

    this._keys.delete(key)
  }

  toJWKS (priv = false) {
    return {
      keys: [...this._keys.values()].map(
        key => key.toJWK(priv && (key.private || (key.secret && key.k)))
      )
    }
  }

  async generate (...args) {
    this._keys.add(await generate(...args))
  }

  generateSync (...args) {
    this._keys.add(generateSync(...args))
  }

  get size () {
    return this._keys.size
  }

  /* c8 ignore next 8 */
  [inspect.custom] () {
    return `${this.constructor.name} ${inspect(this.toJWKS(false), {
      depth: Infinity,
      colors: process.stdout.isTTY,
      compact: false,
      sorted: true
    })}`
  }

  * [Symbol.iterator] () {
    for (const key of this._keys) {
      yield key
    }
  }
}

function asKeyStore (jwks, { ignoreErrors = false, calculateMissingRSAPrimes = false } = {}) {
  if (!isObject(jwks) || !Array.isArray(jwks.keys) || jwks.keys.some(k => !isObject(k) || !('kty' in k))) {
    throw new TypeError('jwks must be a JSON Web Key Set formatted object')
  }

  const keys = jwks.keys.map((jwk) => {
    try {
      return importKey(jwk, { calculateMissingRSAPrimes })
    } catch (err) {
      if (!ignoreErrors) {
        throw err
      }
      return undefined
    }
  }).filter(Boolean)

  return new KeyStore(...keys)
}

module.exports = { KeyStore, asKeyStore }


/***/ }),

/***/ 94207:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const Sign = __webpack_require__(919)
const { verify } = __webpack_require__(18508)

const single = (serialization, payload, key, protectedHeader, unprotectedHeader) => {
  return new Sign(payload)
    .recipient(key, protectedHeader, unprotectedHeader)
    .sign(serialization)
}

module.exports.Sign = Sign
module.exports.sign = single.bind(undefined, 'compact')
module.exports.sign.flattened = single.bind(undefined, 'flattened')
module.exports.sign.general = single.bind(undefined, 'general')

module.exports.verify = verify


/***/ }),

/***/ 59606:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const isObject = __webpack_require__(94336)
let validateCrit = __webpack_require__(16542)
const { JWSInvalid } = __webpack_require__(8293)

validateCrit = validateCrit.bind(undefined, JWSInvalid)

const compactSerializer = (payload, [recipient]) => {
  return `${recipient.protected}.${payload}.${recipient.signature}`
}
compactSerializer.validate = (jws, { 0: { unprotectedHeader, protectedHeader }, length }) => {
  if (length !== 1 || unprotectedHeader) {
    throw new JWSInvalid('JWS Compact Serialization doesn\'t support multiple recipients or JWS unprotected headers')
  }
  validateCrit(protectedHeader, unprotectedHeader, protectedHeader ? protectedHeader.crit : undefined)
}

const flattenedSerializer = (payload, [recipient]) => {
  const { header, signature, protected: prot } = recipient

  return {
    payload,
    ...prot ? { protected: prot } : undefined,
    ...header ? { header } : undefined,
    signature
  }
}
flattenedSerializer.validate = (jws, { 0: { unprotectedHeader, protectedHeader }, length }) => {
  if (length !== 1) {
    throw new JWSInvalid('Flattened JWS JSON Serialization doesn\'t support multiple recipients')
  }
  validateCrit(protectedHeader, unprotectedHeader, protectedHeader ? protectedHeader.crit : undefined)
}

const generalSerializer = (payload, recipients) => {
  return {
    payload,
    signatures: recipients.map(({ header, signature, protected: prot }) => {
      return {
        ...prot ? { protected: prot } : undefined,
        ...header ? { header } : undefined,
        signature
      }
    })
  }
}
generalSerializer.validate = (jws, recipients) => {
  let validateB64 = false
  recipients.forEach(({ protectedHeader, unprotectedHeader }) => {
    if (protectedHeader && !validateB64 && 'b64' in protectedHeader) {
      validateB64 = true
    }
    validateCrit(protectedHeader, unprotectedHeader, protectedHeader ? protectedHeader.crit : undefined)
  })

  if (validateB64) {
    const values = recipients.map(({ protectedHeader }) => protectedHeader && protectedHeader.b64)
    if (!values.every((actual, i, [expected]) => actual === expected)) {
      throw new JWSInvalid('the "b64" Header Parameter value MUST be the same for all recipients')
    }
  }
}

const isJSON = (input) => {
  return isObject(input) && (typeof input.payload === 'string' || Buffer.isBuffer(input.payload))
}

const isValidRecipient = (recipient) => {
  return isObject(recipient) && typeof recipient.signature === 'string' &&
    (recipient.header === undefined || isObject(recipient.header)) &&
    (recipient.protected === undefined || typeof recipient.protected === 'string')
}

const isMultiRecipient = (input) => {
  if (Array.isArray(input.signatures) && input.signatures.every(isValidRecipient)) {
    return true
  }

  return false
}

const detect = (input) => {
  if (typeof input === 'string' && input.split('.').length === 3) {
    return 'compact'
  }

  if (isJSON(input)) {
    if (isMultiRecipient(input)) {
      return 'general'
    }

    if (isValidRecipient(input)) {
      return 'flattened'
    }
  }

  throw new JWSInvalid('JWS malformed or invalid serialization')
}

module.exports = {
  compact: compactSerializer,
  flattened: flattenedSerializer,
  general: generalSerializer,
  detect
}


/***/ }),

/***/ 919:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const base64url = __webpack_require__(37448)
const isDisjoint = __webpack_require__(970)
const isObject = __webpack_require__(94336)
const deepClone = __webpack_require__(49270)
const { JWSInvalid } = __webpack_require__(8293)
const { sign } = __webpack_require__(45889)
const getKey = __webpack_require__(75579)

const serializers = __webpack_require__(59606)

const PROCESS_RECIPIENT = Symbol('PROCESS_RECIPIENT')

class Sign {
  constructor (payload) {
    if (typeof payload === 'string') {
      payload = base64url.encode(payload)
    } else if (Buffer.isBuffer(payload)) {
      payload = base64url.encodeBuffer(payload)
      this._binary = true
    } else if (isObject(payload)) {
      payload = base64url.JSON.encode(payload)
    } else {
      throw new TypeError('payload argument must be a Buffer, string or an object')
    }

    this._payload = payload
    this._recipients = []
  }

  /*
   * @public
   */
  recipient (key, protectedHeader, unprotectedHeader) {
    key = getKey(key)

    if (protectedHeader !== undefined && !isObject(protectedHeader)) {
      throw new TypeError('protectedHeader argument must be a plain object when provided')
    }

    if (unprotectedHeader !== undefined && !isObject(unprotectedHeader)) {
      throw new TypeError('unprotectedHeader argument must be a plain object when provided')
    }

    if (!isDisjoint(protectedHeader, unprotectedHeader)) {
      throw new JWSInvalid('JWS Protected and JWS Unprotected Header Parameter names must be disjoint')
    }

    this._recipients.push({
      key,
      protectedHeader: protectedHeader ? deepClone(protectedHeader) : undefined,
      unprotectedHeader: unprotectedHeader ? deepClone(unprotectedHeader) : undefined
    })

    return this
  }

  /*
   * @private
   */
  [PROCESS_RECIPIENT] (recipient, first) {
    const { key, protectedHeader, unprotectedHeader } = recipient

    if (key.use === 'enc') {
      throw new TypeError('a key with "use":"enc" is not usable for signing')
    }

    const joseHeader = {
      protected: protectedHeader || {},
      unprotected: unprotectedHeader || {}
    }

    let alg = joseHeader.protected.alg || joseHeader.unprotected.alg

    if (!alg) {
      alg = key.alg || [...key.algorithms('sign')][0]
      if (recipient.protectedHeader) {
        joseHeader.protected.alg = recipient.protectedHeader.alg = alg
      } else {
        joseHeader.protected = recipient.protectedHeader = { alg }
      }
    }

    if (!alg) {
      throw new JWSInvalid('could not resolve a usable "alg" for a recipient')
    }

    recipient.header = unprotectedHeader
    recipient.protected = Object.keys(joseHeader.protected).length ? base64url.JSON.encode(joseHeader.protected) : ''

    if (first && joseHeader.protected.crit && joseHeader.protected.crit.includes('b64') && joseHeader.protected.b64 === false) {
      if (this._binary) {
        this._payload = base64url.decodeToBuffer(this._payload)
      } else {
        this._payload = base64url.decode(this._payload)
      }
    }

    const data = Buffer.concat([
      Buffer.from(recipient.protected || ''),
      Buffer.from('.'),
      Buffer.from(this._payload)
    ])

    recipient.signature = base64url.encodeBuffer(sign(alg, key, data))
  }

  /*
   * @public
   */
  sign (serialization) {
    const serializer = serializers[serialization]
    if (!serializer) {
      throw new TypeError('serialization must be one of "compact", "flattened", "general"')
    }

    if (!this._recipients.length) {
      throw new JWSInvalid('missing recipients')
    }

    serializer.validate(this, this._recipients)

    this._recipients.forEach((recipient, i) => {
      this[PROCESS_RECIPIENT](recipient, i === 0)
    })

    return serializer(this._payload, this._recipients)
  }
}

module.exports = Sign


/***/ }),

/***/ 18508:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
const { EOL } = __webpack_require__(73461)

const base64url = __webpack_require__(37448)
const isDisjoint = __webpack_require__(970)
const isObject = __webpack_require__(94336)
let validateCrit = __webpack_require__(16542)
const getKey = __webpack_require__(75579)
const { KeyStore } = __webpack_require__(718)
const errors = __webpack_require__(8293)
const { check, verify } = __webpack_require__(45889)
const JWK = __webpack_require__(86887)

const { detect: resolveSerialization } = __webpack_require__(59606)

validateCrit = validateCrit.bind(undefined, errors.JWSInvalid)
const SINGLE_RECIPIENT = new Set(['compact', 'flattened', 'preparsed'])

/*
 * @public
 */
const jwsVerify = (skipDisjointCheck, serialization, jws, key, { crit = [], complete = false, algorithms } = {}) => {
  key = getKey(key, true)

  if (algorithms !== undefined && (!Array.isArray(algorithms) || algorithms.some(s => typeof s !== 'string' || !s))) {
    throw new TypeError('"algorithms" option must be an array of non-empty strings')
  } else if (algorithms) {
    algorithms = new Set(algorithms)
  }

  if (!Array.isArray(crit) || crit.some(s => typeof s !== 'string' || !s)) {
    throw new TypeError('"crit" option must be an array of non-empty strings')
  }

  if (!serialization) {
    serialization = resolveSerialization(jws)
  }

  let prot // protected header
  let header // unprotected header
  let payload
  let signature
  let alg

  // treat general format with one recipient as flattened
  // skips iteration and avoids multi errors in this case
  if (serialization === 'general' && jws.signatures.length === 1) {
    serialization = 'flattened'
    const { signatures, ...root } = jws
    jws = { ...root, ...signatures[0] }
  }

  let decoded

  if (SINGLE_RECIPIENT.has(serialization)) {
    let parsedProt = {}

    switch (serialization) {
      case 'compact': // compact serialization format
        ([prot, payload, signature] = jws.split('.'))
        break
      case 'flattened': // flattened serialization format
        ({ protected: prot, payload, signature, header } = jws)
        break
      case 'preparsed': { // from the JWT module
        ({ decoded } = jws);
        ([prot, payload, signature] = jws.token.split('.'))
        break
      }
    }

    if (!header) {
      skipDisjointCheck = true
    }

    if (decoded) {
      parsedProt = decoded.header
    } else if (prot) {
      try {
        parsedProt = base64url.JSON.decode(prot)
      } catch (err) {
        throw new errors.JWSInvalid('could not parse JWS protected header')
      }
    } else {
      skipDisjointCheck = skipDisjointCheck || true
    }

    if (!skipDisjointCheck && !isDisjoint(parsedProt, header)) {
      throw new errors.JWSInvalid('JWS Protected and JWS Unprotected Header Parameter names must be disjoint')
    }

    const combinedHeader = { ...parsedProt, ...header }
    validateCrit(parsedProt, header, crit)

    alg = parsedProt.alg || (header && header.alg)
    if (!alg) {
      throw new errors.JWSInvalid('missing JWS signature algorithm')
    } else if (algorithms && !algorithms.has(alg)) {
      throw new errors.JOSEAlgNotWhitelisted('alg not whitelisted')
    }

    if (key instanceof KeyStore) {
      const keystore = key
      const keys = keystore.all({ kid: combinedHeader.kid, alg: combinedHeader.alg, key_ops: ['verify'] })
      switch (keys.length) {
        case 0:
          throw new errors.JWKSNoMatchingKey()
        case 1:
          // treat the call as if a Key instance was passed in
          // skips iteration and avoids multi errors in this case
          key = keys[0]
          break
        default: {
          const errs = []
          for (const key of keys) {
            try {
              return jwsVerify(true, serialization, jws, key, { crit, complete, algorithms: algorithms ? [...algorithms] : undefined })
            } catch (err) {
              errs.push(err)
              continue
            }
          }

          const multi = new errors.JOSEMultiError(errs)
          if ([...multi].some(e => e instanceof errors.JWSVerificationFailed)) {
            throw new errors.JWSVerificationFailed()
          }
          throw multi
        }
      }
    }

    if (key === JWK.EmbeddedJWK) {
      if (!isObject(combinedHeader.jwk)) {
        throw new errors.JWSInvalid('JWS Header Parameter "jwk" must be a JSON object')
      }
      key = JWK.asKey(combinedHeader.jwk)
      if (key.type !== 'public') {
        throw new errors.JWSInvalid('JWS Header Parameter "jwk" must be a public key')
      }
    } else if (key === JWK.EmbeddedX5C) {
      if (!Array.isArray(combinedHeader.x5c) || !combinedHeader.x5c.length || combinedHeader.x5c.some(c => typeof c !== 'string' || !c)) {
        throw new errors.JWSInvalid('JWS Header Parameter "x5c" must be a JSON array of certificate value strings')
      }
      key = JWK.asKey(
        `-----BEGIN CERTIFICATE-----${EOL}${(combinedHeader.x5c[0].match(/.{1,64}/g) || []).join(EOL)}${EOL}-----END CERTIFICATE-----`,
        { x5c: combinedHeader.x5c }
      )
    }

    check(key, 'verify', alg)

    const toBeVerified = Buffer.concat([
      Buffer.from(prot || ''),
      Buffer.from('.'),
      Buffer.isBuffer(payload) ? payload : Buffer.from(payload)
    ])

    if (!verify(alg, key, toBeVerified, base64url.decodeToBuffer(signature))) {
      throw new errors.JWSVerificationFailed()
    }

    if (combinedHeader.b64 === false) {
      payload = Buffer.from(payload)
    } else {
      payload = base64url.decodeToBuffer(payload)
    }

    if (complete) {
      const result = { payload, key }
      if (prot) result.protected = parsedProt
      if (header) result.header = header
      return result
    }

    return payload
  }

  // general serialization format
  const { signatures, ...root } = jws
  const errs = []
  for (const recipient of signatures) {
    try {
      return jwsVerify(false, 'flattened', { ...root, ...recipient }, key, { crit, complete, algorithms: algorithms ? [...algorithms] : undefined })
    } catch (err) {
      errs.push(err)
      continue
    }
  }

  const multi = new errors.JOSEMultiError(errs)
  if ([...multi].some(e => e instanceof errors.JWSVerificationFailed)) {
    throw new errors.JWSVerificationFailed()
  } else if ([...multi].every(e => e instanceof errors.JWKSNoMatchingKey)) {
    throw new errors.JWKSNoMatchingKey()
  }
  throw multi
}

module.exports = {
  bare: jwsVerify,
  verify: jwsVerify.bind(undefined, false, undefined)
}


/***/ }),

/***/ 24889:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const base64url = __webpack_require__(37448)
const errors = __webpack_require__(8293)

module.exports = (token, { complete = false } = {}) => {
  if (typeof token !== 'string' || !token) {
    throw new TypeError('JWT must be a string')
  }

  const { 0: header, 1: payload, 2: signature, length } = token.split('.')

  if (length === 5) {
    throw new TypeError('encrypted JWTs cannot be decoded')
  }

  if (length !== 3) {
    throw new errors.JWTMalformed('JWTs must have three components')
  }

  try {
    const result = {
      header: base64url.JSON.decode(header),
      payload: base64url.JSON.decode(payload),
      signature
    }

    return complete ? result : result.payload
  } catch (err) {
    throw new errors.JWTMalformed('JWT is malformed')
  }
}


/***/ }),

/***/ 26698:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const decode = __webpack_require__(24889)
const sign = __webpack_require__(58838)
const verify = __webpack_require__(27459)
const profiles = __webpack_require__(94611)

module.exports = {
  sign,
  verify,
  ...profiles
}

Object.defineProperty(module.exports, "decode", ({
  enumerable: false,
  configurable: true,
  value: decode
}))


/***/ }),

/***/ 94611:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
const { JWTClaimInvalid } = __webpack_require__(8293)
const secs = __webpack_require__(73232)
const epoch = __webpack_require__(7374)
const isObject = __webpack_require__(94336)

const verify = __webpack_require__(27459)
const {
  isString,
  isRequired,
  isTimestamp,
  isStringOrArrayOfStrings
} = __webpack_require__(72563)

const isPayloadRequired = isRequired.bind(undefined, JWTClaimInvalid)
const isPayloadString = isString.bind(undefined, JWTClaimInvalid)
const isOptionString = isString.bind(undefined, TypeError)

const defineLazyExportWithWarning = (obj, property, name, definition) => {
  Object.defineProperty(obj, property, {
    enumerable: true,
    configurable: true,
    value (...args) {
      process.emitWarning(
        `The ${name} API implements an IETF draft. Breaking draft implementations are included as minor versions of the jose library, therefore, the ~ semver operator should be used and close attention be payed to library changelog as well as the drafts themselves.`,
        'DraftWarning'
      )
      Object.defineProperty(obj, property, {
        enumerable: true,
        configurable: true,
        value: definition
      })
      return obj[property](...args)
    }
  })
}

const validateCommonOptions = (options, profile) => {
  if (!isObject(options)) {
    throw new TypeError('options must be an object')
  }

  if (!options.issuer) {
    throw new TypeError(`"issuer" option is required to validate ${profile}`)
  }

  if (!options.audience) {
    throw new TypeError(`"audience" option is required to validate ${profile}`)
  }
}

module.exports = {
  IdToken: {
    verify: (token, key, options = {}) => {
      validateCommonOptions(options, 'an ID Token')

      if ('maxAuthAge' in options) {
        isOptionString(options.maxAuthAge, 'options.maxAuthAge')
      }
      if ('nonce' in options) {
        isOptionString(options.nonce, 'options.nonce')
      }

      const unix = epoch(options.now || new Date())
      const result = verify(token, key, { ...options })
      const payload = options.complete ? result.payload : result

      if (Array.isArray(payload.aud) && payload.aud.length > 1) {
        isPayloadRequired(payload.azp, '"azp" claim', 'azp')
      }
      isPayloadRequired(payload.iat, '"iat" claim', 'iat')
      isPayloadRequired(payload.sub, '"sub" claim', 'sub')
      isPayloadRequired(payload.exp, '"exp" claim', 'exp')
      isTimestamp(payload.auth_time, 'auth_time', !!options.maxAuthAge)
      isPayloadString(payload.nonce, '"nonce" claim', 'nonce', !!options.nonce)
      isPayloadString(payload.acr, '"acr" claim', 'acr')
      isStringOrArrayOfStrings(payload.amr, 'amr')

      if (options.nonce && payload.nonce !== options.nonce) {
        throw new JWTClaimInvalid('unexpected "nonce" claim value', 'nonce', 'check_failed')
      }

      const tolerance = options.clockTolerance ? secs(options.clockTolerance) : 0

      if (options.maxAuthAge) {
        const maxAuthAgeSeconds = secs(options.maxAuthAge)
        if (payload.auth_time + maxAuthAgeSeconds < unix - tolerance) {
          throw new JWTClaimInvalid('"auth_time" claim timestamp check failed (too much time has elapsed since the last End-User authentication)', 'auth_time', 'check_failed')
        }
      }

      if (Array.isArray(payload.aud) && payload.aud.length > 1 && payload.azp !== options.audience) {
        throw new JWTClaimInvalid('unexpected "azp" claim value', 'azp', 'check_failed')
      }

      return result
    }
  },
  LogoutToken: {},
  AccessToken: {}
}

defineLazyExportWithWarning(module.exports.LogoutToken, 'verify', 'jose.JWT.LogoutToken.verify', (token, key, options = {}) => {
  validateCommonOptions(options, 'a Logout Token')

  const result = verify(token, key, { ...options })
  const payload = options.complete ? result.payload : result

  isPayloadRequired(payload.iat, '"iat" claim', 'iat')
  isPayloadRequired(payload.jti, '"jti" claim', 'jti')
  isPayloadString(payload.sid, '"sid" claim', 'sid')

  if (!('sid' in payload) && !('sub' in payload)) {
    throw new JWTClaimInvalid('either "sid" or "sub" (or both) claims must be present')
  }

  if ('nonce' in payload) {
    throw new JWTClaimInvalid('"nonce" claim is prohibited', 'nonce', 'prohibited')
  }

  if (!('events' in payload)) {
    throw new JWTClaimInvalid('"events" claim is missing', 'events', 'missing')
  }

  if (!isObject(payload.events)) {
    throw new JWTClaimInvalid('"events" claim must be an object', 'events', 'invalid')
  }

  if (!('http://schemas.openid.net/event/backchannel-logout' in payload.events)) {
    throw new JWTClaimInvalid('"http://schemas.openid.net/event/backchannel-logout" member is missing in the "events" claim', 'events', 'invalid')
  }

  if (!isObject(payload.events['http://schemas.openid.net/event/backchannel-logout'])) {
    throw new JWTClaimInvalid('"http://schemas.openid.net/event/backchannel-logout" member in the "events" claim must be an object', 'events', 'invalid')
  }

  return result
})

defineLazyExportWithWarning(module.exports.AccessToken, 'verify', 'jose.JWT.AccessToken.verify', (token, key, options = {}) => {
  validateCommonOptions(options, 'a JWT Access Token')

  isOptionString(options.maxAuthAge, 'options.maxAuthAge')

  const unix = epoch(options.now || new Date())
  const typ = 'at+JWT'
  const result = verify(token, key, { ...options, typ })
  const payload = options.complete ? result.payload : result

  isPayloadRequired(payload.iat, '"iat" claim', 'iat')
  isPayloadRequired(payload.exp, '"exp" claim', 'exp')
  isPayloadRequired(payload.sub, '"sub" claim', 'sub')
  isPayloadRequired(payload.jti, '"jti" claim', 'jti')
  isPayloadString(payload.client_id, '"client_id" claim', 'client_id', true)
  isTimestamp(payload.auth_time, 'auth_time', !!options.maxAuthAge)
  isPayloadString(payload.acr, '"acr" claim', 'acr')
  isStringOrArrayOfStrings(payload.amr, 'amr')

  const tolerance = options.clockTolerance ? secs(options.clockTolerance) : 0

  if (options.maxAuthAge) {
    const maxAuthAgeSeconds = secs(options.maxAuthAge)
    if (payload.auth_time + maxAuthAgeSeconds < unix - tolerance) {
      throw new JWTClaimInvalid('"auth_time" claim timestamp check failed (too much time has elapsed since the last End-User authentication)', 'auth_time', 'check_failed')
    }
  }

  return result
})


/***/ }),

/***/ 72563:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { JWTClaimInvalid } = __webpack_require__(8293)

const isNotString = val => typeof val !== 'string' || val.length === 0
const isNotArrayOfStrings = val => !Array.isArray(val) || val.length === 0 || val.some(isNotString)
const isRequired = (Err, value, label, claim) => {
  if (value === undefined) {
    throw new Err(`${label} is missing`, claim, 'missing')
  }
}
const isString = (Err, value, label, claim, required = false) => {
  if (required) {
    isRequired(Err, value, label, claim)
  }

  if (value !== undefined && isNotString(value)) {
    throw new Err(`${label} must be a string`, claim, 'invalid')
  }
}
const isTimestamp = (value, label, required = false) => {
  if (required && value === undefined) {
    throw new JWTClaimInvalid(`"${label}" claim is missing`, label, 'missing')
  }

  if (value !== undefined && (typeof value !== 'number')) {
    throw new JWTClaimInvalid(`"${label}" claim must be a JSON numeric value`, label, 'invalid')
  }
}
const isStringOrArrayOfStrings = (value, label, required = false) => {
  if (required && value === undefined) {
    throw new JWTClaimInvalid(`"${label}" claim is missing`, label, 'missing')
  }

  if (value !== undefined && (isNotString(value) && isNotArrayOfStrings(value))) {
    throw new JWTClaimInvalid(`"${label}" claim must be a string or array of strings`, label, 'invalid')
  }
}

module.exports = {
  isNotArrayOfStrings,
  isRequired,
  isNotString,
  isString,
  isTimestamp,
  isStringOrArrayOfStrings
}


/***/ }),

/***/ 58838:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const isObject = __webpack_require__(94336)
const secs = __webpack_require__(73232)
const epoch = __webpack_require__(7374)
const getKey = __webpack_require__(75579)
const JWS = __webpack_require__(94207)

const isString = (__webpack_require__(72563).isString.bind)(undefined, TypeError)

const validateOptions = (options) => {
  if (typeof options.iat !== 'boolean') {
    throw new TypeError('options.iat must be a boolean')
  }

  if (typeof options.kid !== 'boolean') {
    throw new TypeError('options.kid must be a boolean')
  }

  isString(options.subject, 'options.subject')
  isString(options.issuer, 'options.issuer')

  if (
    options.audience !== undefined &&
    (
      (typeof options.audience !== 'string' || !options.audience) &&
      (!Array.isArray(options.audience) || options.audience.length === 0 || options.audience.some(a => !a || typeof a !== 'string'))
    )
  ) {
    throw new TypeError('options.audience must be a string or an array of strings')
  }

  if (!isObject(options.header)) {
    throw new TypeError('options.header must be an object')
  }

  isString(options.algorithm, 'options.algorithm')
  isString(options.expiresIn, 'options.expiresIn')
  isString(options.notBefore, 'options.notBefore')
  isString(options.jti, 'options.jti')

  if (options.now !== undefined && (!(options.now instanceof Date) || !options.now.getTime())) {
    throw new TypeError('options.now must be a valid Date object')
  }
}

module.exports = (payload, key, options = {}) => {
  if (!isObject(options)) {
    throw new TypeError('options must be an object')
  }

  const {
    algorithm, audience, expiresIn, header = {}, iat = true,
    issuer, jti, kid = true, notBefore, subject, now
  } = options

  validateOptions({
    algorithm, audience, expiresIn, header, iat, issuer, jti, kid, notBefore, now, subject
  })

  if (!isObject(payload)) {
    throw new TypeError('payload must be an object')
  }

  let unix
  if (expiresIn || notBefore || iat) {
    unix = epoch(now || new Date())
  }

  payload = {
    ...payload,
    sub: subject || payload.sub,
    aud: audience || payload.aud,
    iss: issuer || payload.iss,
    jti: jti || payload.jti,
    iat: iat ? unix : payload.iat,
    exp: expiresIn ? unix + secs(expiresIn) : payload.exp,
    nbf: notBefore ? unix + secs(notBefore) : payload.nbf
  }

  key = getKey(key)

  let includeKid

  if (typeof options.kid === 'boolean') {
    includeKid = kid
  } else {
    includeKid = !key.secret
  }

  return JWS.sign(JSON.stringify(payload), key, {
    ...header,
    alg: algorithm || header.alg,
    kid: includeKid ? key.kid : header.kid
  })
}


/***/ }),

/***/ 27459:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const isObject = __webpack_require__(94336)
const epoch = __webpack_require__(7374)
const secs = __webpack_require__(73232)
const getKey = __webpack_require__(75579)
const { bare: verify } = __webpack_require__(18508)
const { JWTClaimInvalid, JWTExpired } = __webpack_require__(8293)

const {
  isString,
  isNotString,
  isNotArrayOfStrings,
  isTimestamp,
  isStringOrArrayOfStrings
} = __webpack_require__(72563)
const decode = __webpack_require__(24889)

const isPayloadString = isString.bind(undefined, JWTClaimInvalid)
const isOptionString = isString.bind(undefined, TypeError)

const normalizeTyp = (value) => value.toLowerCase().replace(/^application\//, '')

const validateOptions = ({
  algorithms, audience, clockTolerance, complete = false, crit, ignoreExp = false,
  ignoreIat = false, ignoreNbf = false, issuer, jti, maxTokenAge, now = new Date(),
  subject, typ
}) => {
  if (typeof complete !== 'boolean') {
    throw new TypeError('options.complete must be a boolean')
  }

  if (typeof ignoreExp !== 'boolean') {
    throw new TypeError('options.ignoreExp must be a boolean')
  }

  if (typeof ignoreNbf !== 'boolean') {
    throw new TypeError('options.ignoreNbf must be a boolean')
  }

  if (typeof ignoreIat !== 'boolean') {
    throw new TypeError('options.ignoreIat must be a boolean')
  }

  isOptionString(maxTokenAge, 'options.maxTokenAge')
  isOptionString(subject, 'options.subject')
  isOptionString(jti, 'options.jti')
  isOptionString(clockTolerance, 'options.clockTolerance')
  isOptionString(typ, 'options.typ')

  if (issuer !== undefined && (isNotString(issuer) && isNotArrayOfStrings(issuer))) {
    throw new TypeError('options.issuer must be a string or an array of strings')
  }

  if (audience !== undefined && (isNotString(audience) && isNotArrayOfStrings(audience))) {
    throw new TypeError('options.audience must be a string or an array of strings')
  }

  if (algorithms !== undefined && isNotArrayOfStrings(algorithms)) {
    throw new TypeError('options.algorithms must be an array of strings')
  }

  if (!(now instanceof Date) || !now.getTime()) {
    throw new TypeError('options.now must be a valid Date object')
  }

  if (ignoreIat && maxTokenAge !== undefined) {
    throw new TypeError('options.ignoreIat and options.maxTokenAge cannot used together')
  }

  if (crit !== undefined && isNotArrayOfStrings(crit)) {
    throw new TypeError('options.crit must be an array of strings')
  }

  return {
    algorithms,
    audience,
    clockTolerance,
    complete,
    crit,
    ignoreExp,
    ignoreIat,
    ignoreNbf,
    issuer,
    jti,
    maxTokenAge,
    now,
    subject,
    typ
  }
}

const validateTypes = ({ header, payload }, options) => {
  isPayloadString(header.alg, '"alg" header parameter', 'alg', true)

  isTimestamp(payload.iat, 'iat', !!options.maxTokenAge)
  isTimestamp(payload.exp, 'exp')
  isTimestamp(payload.nbf, 'nbf')
  isPayloadString(payload.jti, '"jti" claim', 'jti', !!options.jti)
  isStringOrArrayOfStrings(payload.iss, 'iss', !!options.issuer)
  isPayloadString(payload.sub, '"sub" claim', 'sub', !!options.subject)
  isStringOrArrayOfStrings(payload.aud, 'aud', !!options.audience)
  isPayloadString(header.typ, '"typ" header parameter', 'typ', !!options.typ)
}

const checkAudiencePresence = (audPayload, audOption) => {
  if (typeof audPayload === 'string') {
    return audOption.includes(audPayload)
  }

  // Each principal intended to process the JWT MUST
  // identify itself with a value in the audience claim
  audPayload = new Set(audPayload)
  return audOption.some(Set.prototype.has.bind(audPayload))
}

module.exports = (token, key, options = {}) => {
  if (!isObject(options)) {
    throw new TypeError('options must be an object')
  }

  const {
    algorithms, audience, clockTolerance, complete, crit, ignoreExp, ignoreIat, ignoreNbf, issuer,
    jti, maxTokenAge, now, subject, typ
  } = options = validateOptions(options)

  const decoded = decode(token, { complete: true })
  key = getKey(key, true)

  if (complete) {
    ({ key } = verify(true, 'preparsed', { decoded, token }, key, { crit, algorithms, complete: true }))
    decoded.key = key
  } else {
    verify(true, 'preparsed', { decoded, token }, key, { crit, algorithms })
  }

  const unix = epoch(now)
  validateTypes(decoded, options)

  if (issuer && (typeof decoded.payload.iss !== 'string' || !(typeof issuer === 'string' ? [issuer] : issuer).includes(decoded.payload.iss))) {
    throw new JWTClaimInvalid('unexpected "iss" claim value', 'iss', 'check_failed')
  }

  if (subject && decoded.payload.sub !== subject) {
    throw new JWTClaimInvalid('unexpected "sub" claim value', 'sub', 'check_failed')
  }

  if (jti && decoded.payload.jti !== jti) {
    throw new JWTClaimInvalid('unexpected "jti" claim value', 'jti', 'check_failed')
  }

  if (audience && !checkAudiencePresence(decoded.payload.aud, typeof audience === 'string' ? [audience] : audience)) {
    throw new JWTClaimInvalid('unexpected "aud" claim value', 'aud', 'check_failed')
  }

  if (typ && normalizeTyp(decoded.header.typ) !== normalizeTyp(typ)) {
    throw new JWTClaimInvalid('unexpected "typ" JWT header value', 'typ', 'check_failed')
  }

  const tolerance = clockTolerance ? secs(clockTolerance) : 0

  if (!ignoreIat && !('exp' in decoded.payload) && 'iat' in decoded.payload && decoded.payload.iat > unix + tolerance) {
    throw new JWTClaimInvalid('"iat" claim timestamp check failed (it should be in the past)', 'iat', 'check_failed')
  }

  if (!ignoreNbf && 'nbf' in decoded.payload && decoded.payload.nbf > unix + tolerance) {
    throw new JWTClaimInvalid('"nbf" claim timestamp check failed', 'nbf', 'check_failed')
  }

  if (!ignoreExp && 'exp' in decoded.payload && decoded.payload.exp <= unix - tolerance) {
    throw new JWTExpired('"exp" claim timestamp check failed', 'exp', 'check_failed')
  }

  if (maxTokenAge) {
    const age = unix - decoded.payload.iat
    const max = secs(maxTokenAge)

    if (age - tolerance > max) {
      throw new JWTExpired('"iat" claim timestamp check failed (too far in the past)', 'iat', 'check_failed')
    }

    if (age < 0 - tolerance) {
      throw new JWTClaimInvalid('"iat" claim timestamp check failed (it should be in the past)', 'iat', 'check_failed')
    }
  }

  return complete ? decoded : decoded.payload
}


/***/ }),

/***/ 80796:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { getCurves } = __webpack_require__(42474)

const curves = new Set()

if (getCurves().includes('prime256v1')) {
  curves.add('P-256')
}

if (getCurves().includes('secp256k1')) {
  curves.add('secp256k1')
}

if (getCurves().includes('secp384r1')) {
  curves.add('P-384')
}

if (getCurves().includes('secp521r1')) {
  curves.add('P-521')
}

module.exports = curves


/***/ }),

/***/ 97106:
/***/ (function(module) {

module.exports = new Map()


/***/ }),

/***/ 7422:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const EC_CURVES = __webpack_require__(80796)
const IVLENGTHS = __webpack_require__(75319)
const JWA = __webpack_require__(6954)
const JWK = __webpack_require__(39484)
const KEYLENGTHS = __webpack_require__(55347)
const OKP_CURVES = __webpack_require__(74047)
const ECDH_DERIVE_LENGTHS = __webpack_require__(97106)

module.exports = {
  EC_CURVES,
  ECDH_DERIVE_LENGTHS,
  IVLENGTHS,
  JWA,
  JWK,
  KEYLENGTHS,
  OKP_CURVES
}


/***/ }),

/***/ 75319:
/***/ (function(module) {

module.exports = new Map([
  ['A128CBC-HS256', 128],
  ['A128GCM', 96],
  ['A128GCMKW', 96],
  ['A192CBC-HS384', 128],
  ['A192GCM', 96],
  ['A192GCMKW', 96],
  ['A256CBC-HS512', 128],
  ['A256GCM', 96],
  ['A256GCMKW', 96]
])


/***/ }),

/***/ 6954:
/***/ (function(module) {

module.exports = {
  sign: new Map(),
  verify: new Map(),
  keyManagementEncrypt: new Map(),
  keyManagementDecrypt: new Map(),
  encrypt: new Map(),
  decrypt: new Map()
}


/***/ }),

/***/ 39484:
/***/ (function(module) {

module.exports = {
  oct: {
    decrypt: {},
    deriveKey: {},
    encrypt: {},
    sign: {},
    unwrapKey: {},
    verify: {},
    wrapKey: {}
  },
  EC: {
    decrypt: {},
    deriveKey: {},
    encrypt: {},
    sign: {},
    unwrapKey: {},
    verify: {},
    wrapKey: {}
  },
  RSA: {
    decrypt: {},
    deriveKey: {},
    encrypt: {},
    sign: {},
    unwrapKey: {},
    verify: {},
    wrapKey: {}
  },
  OKP: {
    decrypt: {},
    deriveKey: {},
    encrypt: {},
    sign: {},
    unwrapKey: {},
    verify: {},
    wrapKey: {}
  }
}


/***/ }),

/***/ 55347:
/***/ (function(module) {

module.exports = new Map([
  ['A128CBC-HS256', 256],
  ['A128GCM', 128],
  ['A192CBC-HS384', 384],
  ['A192GCM', 192],
  ['A256CBC-HS512', 512],
  ['A256GCM', 256]
])


/***/ }),

/***/ 74047:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
const curves = new Set(['Ed25519'])

if (!('electron' in process.versions)) {
  curves.add('Ed448')
  curves.add('X25519')
  curves.add('X448')
}

module.exports = curves


/***/ }),

/***/ 97626:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var jws = __webpack_require__(40158);

module.exports = function (jwt, options) {
  options = options || {};
  var decoded = jws.decode(jwt, options);
  if (!decoded) { return null; }
  var payload = decoded.payload;

  //try parse the payload
  if(typeof payload === 'string') {
    try {
      var obj = JSON.parse(payload);
      if(obj !== null && typeof obj === 'object') {
        payload = obj;
      }
    } catch (e) { }
  }

  //return header if `complete` option is enabled.  header includes claims
  //such as `kid` and `alg` used to select the key within a JWKS needed to
  //verify the signature
  if (options.complete === true) {
    return {
      header: decoded.header,
      payload: payload,
      signature: decoded.signature
    };
  }
  return payload;
};


/***/ }),

/***/ 49704:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
  decode: __webpack_require__(97626),
  verify: __webpack_require__(17030),
  sign: __webpack_require__(22506),
  JsonWebTokenError: __webpack_require__(58619),
  NotBeforeError: __webpack_require__(71826),
  TokenExpiredError: __webpack_require__(2340),
};


/***/ }),

/***/ 58619:
/***/ (function(module) {

var JsonWebTokenError = function (message, error) {
  Error.call(this, message);
  if(Error.captureStackTrace) {
    Error.captureStackTrace(this, this.constructor);
  }
  this.name = 'JsonWebTokenError';
  this.message = message;
  if (error) this.inner = error;
};

JsonWebTokenError.prototype = Object.create(Error.prototype);
JsonWebTokenError.prototype.constructor = JsonWebTokenError;

module.exports = JsonWebTokenError;


/***/ }),

/***/ 71826:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var JsonWebTokenError = __webpack_require__(58619);

var NotBeforeError = function (message, date) {
  JsonWebTokenError.call(this, message);
  this.name = 'NotBeforeError';
  this.date = date;
};

NotBeforeError.prototype = Object.create(JsonWebTokenError.prototype);

NotBeforeError.prototype.constructor = NotBeforeError;

module.exports = NotBeforeError;

/***/ }),

/***/ 2340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var JsonWebTokenError = __webpack_require__(58619);

var TokenExpiredError = function (message, expiredAt) {
  JsonWebTokenError.call(this, message);
  this.name = 'TokenExpiredError';
  this.expiredAt = expiredAt;
};

TokenExpiredError.prototype = Object.create(JsonWebTokenError.prototype);

TokenExpiredError.prototype.constructor = TokenExpiredError;

module.exports = TokenExpiredError;

/***/ }),

/***/ 14964:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
var semver = __webpack_require__(72057);

module.exports = semver.satisfies(process.version, '^6.12.0 || >=8.0.0');


/***/ }),

/***/ 68034:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var ms = __webpack_require__(57824);

module.exports = function (time, iat) {
  var timestamp = iat || Math.floor(Date.now() / 1000);

  if (typeof time === 'string') {
    var milliseconds = ms(time);
    if (typeof milliseconds === 'undefined') {
      return;
    }
    return Math.floor(timestamp + milliseconds / 1000);
  } else if (typeof time === 'number') {
    return timestamp + time;
  } else {
    return;
  }

};

/***/ }),

/***/ 72057:
/***/ (function(module, exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
exports = module.exports = SemVer

var debug
/* istanbul ignore next */
if (typeof process === 'object' &&
    process.env &&
    process.env.NODE_DEBUG &&
    /\bsemver\b/i.test(process.env.NODE_DEBUG)) {
  debug = function () {
    var args = Array.prototype.slice.call(arguments, 0)
    args.unshift('SEMVER')
    console.log.apply(console, args)
  }
} else {
  debug = function () {}
}

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0'

var MAX_LENGTH = 256
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER ||
  /* istanbul ignore next */ 9007199254740991

// Max safe segment length for coercion.
var MAX_SAFE_COMPONENT_LENGTH = 16

// The actual regexps go on exports.re
var re = exports.re = []
var src = exports.src = []
var R = 0

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*'
var NUMERICIDENTIFIERLOOSE = R++
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+'

// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*'

// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')'

var MAINVERSIONLOOSE = R++
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')'

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')'

var PRERELEASEIDENTIFIERLOOSE = R++
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')'

// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))'

var PRERELEASELOOSE = R++
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))'

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+'

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))'

// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?'

src[FULL] = '^' + FULLPLAIN + '$'

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?'

var LOOSE = R++
src[LOOSE] = '^' + LOOSEPLAIN + '$'

var GTLT = R++
src[GTLT] = '((?:<|>)?=?)'

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*'
var XRANGEIDENTIFIER = R++
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*'

var XRANGEPLAIN = R++
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?'

var XRANGEPLAINLOOSE = R++
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?'

var XRANGE = R++
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$'
var XRANGELOOSE = R++
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$'

// Coercion.
// Extract anything that could conceivably be a part of a valid semver
var COERCE = R++
src[COERCE] = '(?:^|[^\\d])' +
              '(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '})' +
              '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' +
              '(?:\\.(\\d{1,' + MAX_SAFE_COMPONENT_LENGTH + '}))?' +
              '(?:$|[^\\d])'

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++
src[LONETILDE] = '(?:~>?)'

var TILDETRIM = R++
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+'
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g')
var tildeTrimReplace = '$1~'

var TILDE = R++
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$'
var TILDELOOSE = R++
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$'

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++
src[LONECARET] = '(?:\\^)'

var CARETTRIM = R++
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+'
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g')
var caretTrimReplace = '$1^'

var CARET = R++
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$'
var CARETLOOSE = R++
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$'

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$'
var COMPARATOR = R++
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$'

// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')'

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g')
var comparatorTrimReplace = '$1$2$3'

// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$'

var HYPHENRANGELOOSE = R++
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$'

// Star ranges basically just allow anything at all.
var STAR = R++
src[STAR] = '(<|>)?=?\\s*\\*'

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i])
  if (!re[i]) {
    re[i] = new RegExp(src[i])
  }
}

exports.parse = parse
function parse (version, options) {
  if (!options || typeof options !== 'object') {
    options = {
      loose: !!options,
      includePrerelease: false
    }
  }

  if (version instanceof SemVer) {
    return version
  }

  if (typeof version !== 'string') {
    return null
  }

  if (version.length > MAX_LENGTH) {
    return null
  }

  var r = options.loose ? re[LOOSE] : re[FULL]
  if (!r.test(version)) {
    return null
  }

  try {
    return new SemVer(version, options)
  } catch (er) {
    return null
  }
}

exports.valid = valid
function valid (version, options) {
  var v = parse(version, options)
  return v ? v.version : null
}

exports.clean = clean
function clean (version, options) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), options)
  return s ? s.version : null
}

exports.SemVer = SemVer

function SemVer (version, options) {
  if (!options || typeof options !== 'object') {
    options = {
      loose: !!options,
      includePrerelease: false
    }
  }
  if (version instanceof SemVer) {
    if (version.loose === options.loose) {
      return version
    } else {
      version = version.version
    }
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version)
  }

  if (version.length > MAX_LENGTH) {
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')
  }

  if (!(this instanceof SemVer)) {
    return new SemVer(version, options)
  }

  debug('SemVer', version, options)
  this.options = options
  this.loose = !!options.loose

  var m = version.trim().match(options.loose ? re[LOOSE] : re[FULL])

  if (!m) {
    throw new TypeError('Invalid Version: ' + version)
  }

  this.raw = version

  // these are actually numbers
  this.major = +m[1]
  this.minor = +m[2]
  this.patch = +m[3]

  if (this.major > MAX_SAFE_INTEGER || this.major < 0) {
    throw new TypeError('Invalid major version')
  }

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0) {
    throw new TypeError('Invalid minor version')
  }

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0) {
    throw new TypeError('Invalid patch version')
  }

  // numberify any prerelease numeric ids
  if (!m[4]) {
    this.prerelease = []
  } else {
    this.prerelease = m[4].split('.').map(function (id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id
        if (num >= 0 && num < MAX_SAFE_INTEGER) {
          return num
        }
      }
      return id
    })
  }

  this.build = m[5] ? m[5].split('.') : []
  this.format()
}

SemVer.prototype.format = function () {
  this.version = this.major + '.' + this.minor + '.' + this.patch
  if (this.prerelease.length) {
    this.version += '-' + this.prerelease.join('.')
  }
  return this.version
}

SemVer.prototype.toString = function () {
  return this.version
}

SemVer.prototype.compare = function (other) {
  debug('SemVer.compare', this.version, this.options, other)
  if (!(other instanceof SemVer)) {
    other = new SemVer(other, this.options)
  }

  return this.compareMain(other) || this.comparePre(other)
}

SemVer.prototype.compareMain = function (other) {
  if (!(other instanceof SemVer)) {
    other = new SemVer(other, this.options)
  }

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch)
}

SemVer.prototype.comparePre = function (other) {
  if (!(other instanceof SemVer)) {
    other = new SemVer(other, this.options)
  }

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length) {
    return -1
  } else if (!this.prerelease.length && other.prerelease.length) {
    return 1
  } else if (!this.prerelease.length && !other.prerelease.length) {
    return 0
  }

  var i = 0
  do {
    var a = this.prerelease[i]
    var b = other.prerelease[i]
    debug('prerelease compare', i, a, b)
    if (a === undefined && b === undefined) {
      return 0
    } else if (b === undefined) {
      return 1
    } else if (a === undefined) {
      return -1
    } else if (a === b) {
      continue
    } else {
      return compareIdentifiers(a, b)
    }
  } while (++i)
}

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function (release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0
      this.patch = 0
      this.minor = 0
      this.major++
      this.inc('pre', identifier)
      break
    case 'preminor':
      this.prerelease.length = 0
      this.patch = 0
      this.minor++
      this.inc('pre', identifier)
      break
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0
      this.inc('patch', identifier)
      this.inc('pre', identifier)
      break
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0) {
        this.inc('patch', identifier)
      }
      this.inc('pre', identifier)
      break

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 ||
          this.patch !== 0 ||
          this.prerelease.length === 0) {
        this.major++
      }
      this.minor = 0
      this.patch = 0
      this.prerelease = []
      break
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0) {
        this.minor++
      }
      this.patch = 0
      this.prerelease = []
      break
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0) {
        this.patch++
      }
      this.prerelease = []
      break
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0) {
        this.prerelease = [0]
      } else {
        var i = this.prerelease.length
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++
            i = -2
          }
        }
        if (i === -1) {
          // didn't increment anything
          this.prerelease.push(0)
        }
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1])) {
            this.prerelease = [identifier, 0]
          }
        } else {
          this.prerelease = [identifier, 0]
        }
      }
      break

    default:
      throw new Error('invalid increment argument: ' + release)
  }
  this.format()
  this.raw = this.version
  return this
}

exports.inc = inc
function inc (version, release, loose, identifier) {
  if (typeof (loose) === 'string') {
    identifier = loose
    loose = undefined
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version
  } catch (er) {
    return null
  }
}

exports.diff = diff
function diff (version1, version2) {
  if (eq(version1, version2)) {
    return null
  } else {
    var v1 = parse(version1)
    var v2 = parse(version2)
    var prefix = ''
    if (v1.prerelease.length || v2.prerelease.length) {
      prefix = 'pre'
      var defaultResult = 'prerelease'
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return prefix + key
        }
      }
    }
    return defaultResult // may be undefined
  }
}

exports.compareIdentifiers = compareIdentifiers

var numeric = /^[0-9]+$/
function compareIdentifiers (a, b) {
  var anum = numeric.test(a)
  var bnum = numeric.test(b)

  if (anum && bnum) {
    a = +a
    b = +b
  }

  return a === b ? 0
    : (anum && !bnum) ? -1
    : (bnum && !anum) ? 1
    : a < b ? -1
    : 1
}

exports.rcompareIdentifiers = rcompareIdentifiers
function rcompareIdentifiers (a, b) {
  return compareIdentifiers(b, a)
}

exports.major = major
function major (a, loose) {
  return new SemVer(a, loose).major
}

exports.minor = minor
function minor (a, loose) {
  return new SemVer(a, loose).minor
}

exports.patch = patch
function patch (a, loose) {
  return new SemVer(a, loose).patch
}

exports.compare = compare
function compare (a, b, loose) {
  return new SemVer(a, loose).compare(new SemVer(b, loose))
}

exports.compareLoose = compareLoose
function compareLoose (a, b) {
  return compare(a, b, true)
}

exports.rcompare = rcompare
function rcompare (a, b, loose) {
  return compare(b, a, loose)
}

exports.sort = sort
function sort (list, loose) {
  return list.sort(function (a, b) {
    return exports.compare(a, b, loose)
  })
}

exports.rsort = rsort
function rsort (list, loose) {
  return list.sort(function (a, b) {
    return exports.rcompare(a, b, loose)
  })
}

exports.gt = gt
function gt (a, b, loose) {
  return compare(a, b, loose) > 0
}

exports.lt = lt
function lt (a, b, loose) {
  return compare(a, b, loose) < 0
}

exports.eq = eq
function eq (a, b, loose) {
  return compare(a, b, loose) === 0
}

exports.neq = neq
function neq (a, b, loose) {
  return compare(a, b, loose) !== 0
}

exports.gte = gte
function gte (a, b, loose) {
  return compare(a, b, loose) >= 0
}

exports.lte = lte
function lte (a, b, loose) {
  return compare(a, b, loose) <= 0
}

exports.cmp = cmp
function cmp (a, op, b, loose) {
  switch (op) {
    case '===':
      if (typeof a === 'object')
        a = a.version
      if (typeof b === 'object')
        b = b.version
      return a === b

    case '!==':
      if (typeof a === 'object')
        a = a.version
      if (typeof b === 'object')
        b = b.version
      return a !== b

    case '':
    case '=':
    case '==':
      return eq(a, b, loose)

    case '!=':
      return neq(a, b, loose)

    case '>':
      return gt(a, b, loose)

    case '>=':
      return gte(a, b, loose)

    case '<':
      return lt(a, b, loose)

    case '<=':
      return lte(a, b, loose)

    default:
      throw new TypeError('Invalid operator: ' + op)
  }
}

exports.Comparator = Comparator
function Comparator (comp, options) {
  if (!options || typeof options !== 'object') {
    options = {
      loose: !!options,
      includePrerelease: false
    }
  }

  if (comp instanceof Comparator) {
    if (comp.loose === !!options.loose) {
      return comp
    } else {
      comp = comp.value
    }
  }

  if (!(this instanceof Comparator)) {
    return new Comparator(comp, options)
  }

  debug('comparator', comp, options)
  this.options = options
  this.loose = !!options.loose
  this.parse(comp)

  if (this.semver === ANY) {
    this.value = ''
  } else {
    this.value = this.operator + this.semver.version
  }

  debug('comp', this)
}

var ANY = {}
Comparator.prototype.parse = function (comp) {
  var r = this.options.loose ? re[COMPARATORLOOSE] : re[COMPARATOR]
  var m = comp.match(r)

  if (!m) {
    throw new TypeError('Invalid comparator: ' + comp)
  }

  this.operator = m[1]
  if (this.operator === '=') {
    this.operator = ''
  }

  // if it literally is just '>' or '' then allow anything.
  if (!m[2]) {
    this.semver = ANY
  } else {
    this.semver = new SemVer(m[2], this.options.loose)
  }
}

Comparator.prototype.toString = function () {
  return this.value
}

Comparator.prototype.test = function (version) {
  debug('Comparator.test', version, this.options.loose)

  if (this.semver === ANY) {
    return true
  }

  if (typeof version === 'string') {
    version = new SemVer(version, this.options)
  }

  return cmp(version, this.operator, this.semver, this.options)
}

Comparator.prototype.intersects = function (comp, options) {
  if (!(comp instanceof Comparator)) {
    throw new TypeError('a Comparator is required')
  }

  if (!options || typeof options !== 'object') {
    options = {
      loose: !!options,
      includePrerelease: false
    }
  }

  var rangeTmp

  if (this.operator === '') {
    rangeTmp = new Range(comp.value, options)
    return satisfies(this.value, rangeTmp, options)
  } else if (comp.operator === '') {
    rangeTmp = new Range(this.value, options)
    return satisfies(comp.semver, rangeTmp, options)
  }

  var sameDirectionIncreasing =
    (this.operator === '>=' || this.operator === '>') &&
    (comp.operator === '>=' || comp.operator === '>')
  var sameDirectionDecreasing =
    (this.operator === '<=' || this.operator === '<') &&
    (comp.operator === '<=' || comp.operator === '<')
  var sameSemVer = this.semver.version === comp.semver.version
  var differentDirectionsInclusive =
    (this.operator === '>=' || this.operator === '<=') &&
    (comp.operator === '>=' || comp.operator === '<=')
  var oppositeDirectionsLessThan =
    cmp(this.semver, '<', comp.semver, options) &&
    ((this.operator === '>=' || this.operator === '>') &&
    (comp.operator === '<=' || comp.operator === '<'))
  var oppositeDirectionsGreaterThan =
    cmp(this.semver, '>', comp.semver, options) &&
    ((this.operator === '<=' || this.operator === '<') &&
    (comp.operator === '>=' || comp.operator === '>'))

  return sameDirectionIncreasing || sameDirectionDecreasing ||
    (sameSemVer && differentDirectionsInclusive) ||
    oppositeDirectionsLessThan || oppositeDirectionsGreaterThan
}

exports.Range = Range
function Range (range, options) {
  if (!options || typeof options !== 'object') {
    options = {
      loose: !!options,
      includePrerelease: false
    }
  }

  if (range instanceof Range) {
    if (range.loose === !!options.loose &&
        range.includePrerelease === !!options.includePrerelease) {
      return range
    } else {
      return new Range(range.raw, options)
    }
  }

  if (range instanceof Comparator) {
    return new Range(range.value, options)
  }

  if (!(this instanceof Range)) {
    return new Range(range, options)
  }

  this.options = options
  this.loose = !!options.loose
  this.includePrerelease = !!options.includePrerelease

  // First, split based on boolean or ||
  this.raw = range
  this.set = range.split(/\s*\|\|\s*/).map(function (range) {
    return this.parseRange(range.trim())
  }, this).filter(function (c) {
    // throw out any that are not relevant for whatever reason
    return c.length
  })

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range)
  }

  this.format()
}

Range.prototype.format = function () {
  this.range = this.set.map(function (comps) {
    return comps.join(' ').trim()
  }).join('||').trim()
  return this.range
}

Range.prototype.toString = function () {
  return this.range
}

Range.prototype.parseRange = function (range) {
  var loose = this.options.loose
  range = range.trim()
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE]
  range = range.replace(hr, hyphenReplace)
  debug('hyphen replace', range)
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace)
  debug('comparator trim', range, re[COMPARATORTRIM])

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace)

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace)

  // normalize spaces
  range = range.split(/\s+/).join(' ')

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR]
  var set = range.split(' ').map(function (comp) {
    return parseComparator(comp, this.options)
  }, this).join(' ').split(/\s+/)
  if (this.options.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function (comp) {
      return !!comp.match(compRe)
    })
  }
  set = set.map(function (comp) {
    return new Comparator(comp, this.options)
  }, this)

  return set
}

Range.prototype.intersects = function (range, options) {
  if (!(range instanceof Range)) {
    throw new TypeError('a Range is required')
  }

  return this.set.some(function (thisComparators) {
    return thisComparators.every(function (thisComparator) {
      return range.set.some(function (rangeComparators) {
        return rangeComparators.every(function (rangeComparator) {
          return thisComparator.intersects(rangeComparator, options)
        })
      })
    })
  })
}

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators
function toComparators (range, options) {
  return new Range(range, options).set.map(function (comp) {
    return comp.map(function (c) {
      return c.value
    }).join(' ').trim().split(' ')
  })
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator (comp, options) {
  debug('comp', comp, options)
  comp = replaceCarets(comp, options)
  debug('caret', comp)
  comp = replaceTildes(comp, options)
  debug('tildes', comp)
  comp = replaceXRanges(comp, options)
  debug('xrange', comp)
  comp = replaceStars(comp, options)
  debug('stars', comp)
  return comp
}

function isX (id) {
  return !id || id.toLowerCase() === 'x' || id === '*'
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes (comp, options) {
  return comp.trim().split(/\s+/).map(function (comp) {
    return replaceTilde(comp, options)
  }).join(' ')
}

function replaceTilde (comp, options) {
  var r = options.loose ? re[TILDELOOSE] : re[TILDE]
  return comp.replace(r, function (_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr)
    var ret

    if (isX(M)) {
      ret = ''
    } else if (isX(m)) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0'
    } else if (isX(p)) {
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0'
    } else if (pr) {
      debug('replaceTilde pr', pr)
      ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
            ' <' + M + '.' + (+m + 1) + '.0'
    } else {
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0'
    }

    debug('tilde return', ret)
    return ret
  })
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets (comp, options) {
  return comp.trim().split(/\s+/).map(function (comp) {
    return replaceCaret(comp, options)
  }).join(' ')
}

function replaceCaret (comp, options) {
  debug('caret', comp, options)
  var r = options.loose ? re[CARETLOOSE] : re[CARET]
  return comp.replace(r, function (_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr)
    var ret

    if (isX(M)) {
      ret = ''
    } else if (isX(m)) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0'
    } else if (isX(p)) {
      if (M === '0') {
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0'
      } else {
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0'
      }
    } else if (pr) {
      debug('replaceCaret pr', pr)
      if (M === '0') {
        if (m === '0') {
          ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
                ' <' + M + '.' + m + '.' + (+p + 1)
        } else {
          ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
                ' <' + M + '.' + (+m + 1) + '.0'
        }
      } else {
        ret = '>=' + M + '.' + m + '.' + p + '-' + pr +
              ' <' + (+M + 1) + '.0.0'
      }
    } else {
      debug('no pr')
      if (M === '0') {
        if (m === '0') {
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1)
        } else {
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0'
        }
      } else {
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0'
      }
    }

    debug('caret return', ret)
    return ret
  })
}

function replaceXRanges (comp, options) {
  debug('replaceXRanges', comp, options)
  return comp.split(/\s+/).map(function (comp) {
    return replaceXRange(comp, options)
  }).join(' ')
}

function replaceXRange (comp, options) {
  comp = comp.trim()
  var r = options.loose ? re[XRANGELOOSE] : re[XRANGE]
  return comp.replace(r, function (ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr)
    var xM = isX(M)
    var xm = xM || isX(m)
    var xp = xm || isX(p)
    var anyX = xp

    if (gtlt === '=' && anyX) {
      gtlt = ''
    }

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0'
      } else {
        // nothing is forbidden
        ret = '*'
      }
    } else if (gtlt && anyX) {
      // we know patch is an x, because we have any x at all.
      // replace X with 0
      if (xm) {
        m = 0
      }
      p = 0

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>='
        if (xm) {
          M = +M + 1
          m = 0
          p = 0
        } else {
          m = +m + 1
          p = 0
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<'
        if (xm) {
          M = +M + 1
        } else {
          m = +m + 1
        }
      }

      ret = gtlt + M + '.' + m + '.' + p
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0'
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0'
    }

    debug('xRange return', ret)

    return ret
  })
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars (comp, options) {
  debug('replaceStars', comp, options)
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '')
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace ($0,
  from, fM, fm, fp, fpr, fb,
  to, tM, tm, tp, tpr, tb) {
  if (isX(fM)) {
    from = ''
  } else if (isX(fm)) {
    from = '>=' + fM + '.0.0'
  } else if (isX(fp)) {
    from = '>=' + fM + '.' + fm + '.0'
  } else {
    from = '>=' + from
  }

  if (isX(tM)) {
    to = ''
  } else if (isX(tm)) {
    to = '<' + (+tM + 1) + '.0.0'
  } else if (isX(tp)) {
    to = '<' + tM + '.' + (+tm + 1) + '.0'
  } else if (tpr) {
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr
  } else {
    to = '<=' + to
  }

  return (from + ' ' + to).trim()
}

// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function (version) {
  if (!version) {
    return false
  }

  if (typeof version === 'string') {
    version = new SemVer(version, this.options)
  }

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version, this.options)) {
      return true
    }
  }
  return false
}

function testSet (set, version, options) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version)) {
      return false
    }
  }

  if (version.prerelease.length && !options.includePrerelease) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (i = 0; i < set.length; i++) {
      debug(set[i].semver)
      if (set[i].semver === ANY) {
        continue
      }

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch) {
          return true
        }
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false
  }

  return true
}

exports.satisfies = satisfies
function satisfies (version, range, options) {
  try {
    range = new Range(range, options)
  } catch (er) {
    return false
  }
  return range.test(version)
}

exports.maxSatisfying = maxSatisfying
function maxSatisfying (versions, range, options) {
  var max = null
  var maxSV = null
  try {
    var rangeObj = new Range(range, options)
  } catch (er) {
    return null
  }
  versions.forEach(function (v) {
    if (rangeObj.test(v)) {
      // satisfies(v, range, options)
      if (!max || maxSV.compare(v) === -1) {
        // compare(max, v, true)
        max = v
        maxSV = new SemVer(max, options)
      }
    }
  })
  return max
}

exports.minSatisfying = minSatisfying
function minSatisfying (versions, range, options) {
  var min = null
  var minSV = null
  try {
    var rangeObj = new Range(range, options)
  } catch (er) {
    return null
  }
  versions.forEach(function (v) {
    if (rangeObj.test(v)) {
      // satisfies(v, range, options)
      if (!min || minSV.compare(v) === 1) {
        // compare(min, v, true)
        min = v
        minSV = new SemVer(min, options)
      }
    }
  })
  return min
}

exports.minVersion = minVersion
function minVersion (range, loose) {
  range = new Range(range, loose)

  var minver = new SemVer('0.0.0')
  if (range.test(minver)) {
    return minver
  }

  minver = new SemVer('0.0.0-0')
  if (range.test(minver)) {
    return minver
  }

  minver = null
  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i]

    comparators.forEach(function (comparator) {
      // Clone to avoid manipulating the comparator's semver object.
      var compver = new SemVer(comparator.semver.version)
      switch (comparator.operator) {
        case '>':
          if (compver.prerelease.length === 0) {
            compver.patch++
          } else {
            compver.prerelease.push(0)
          }
          compver.raw = compver.format()
          /* fallthrough */
        case '':
        case '>=':
          if (!minver || gt(minver, compver)) {
            minver = compver
          }
          break
        case '<':
        case '<=':
          /* Ignore maximum versions */
          break
        /* istanbul ignore next */
        default:
          throw new Error('Unexpected operation: ' + comparator.operator)
      }
    })
  }

  if (minver && range.test(minver)) {
    return minver
  }

  return null
}

exports.validRange = validRange
function validRange (range, options) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, options).range || '*'
  } catch (er) {
    return null
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr
function ltr (version, range, options) {
  return outside(version, range, '<', options)
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr
function gtr (version, range, options) {
  return outside(version, range, '>', options)
}

exports.outside = outside
function outside (version, range, hilo, options) {
  version = new SemVer(version, options)
  range = new Range(range, options)

  var gtfn, ltefn, ltfn, comp, ecomp
  switch (hilo) {
    case '>':
      gtfn = gt
      ltefn = lte
      ltfn = lt
      comp = '>'
      ecomp = '>='
      break
    case '<':
      gtfn = lt
      ltefn = gte
      ltfn = gt
      comp = '<'
      ecomp = '<='
      break
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"')
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, options)) {
    return false
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i]

    var high = null
    var low = null

    comparators.forEach(function (comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator
      low = low || comparator
      if (gtfn(comparator.semver, high.semver, options)) {
        high = comparator
      } else if (ltfn(comparator.semver, low.semver, options)) {
        low = comparator
      }
    })

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false
    }
  }
  return true
}

exports.prerelease = prerelease
function prerelease (version, options) {
  var parsed = parse(version, options)
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null
}

exports.intersects = intersects
function intersects (r1, r2, options) {
  r1 = new Range(r1, options)
  r2 = new Range(r2, options)
  return r1.intersects(r2)
}

exports.coerce = coerce
function coerce (version) {
  if (version instanceof SemVer) {
    return version
  }

  if (typeof version !== 'string') {
    return null
  }

  var match = version.match(re[COERCE])

  if (match == null) {
    return null
  }

  return parse(match[1] +
    '.' + (match[2] || '0') +
    '.' + (match[3] || '0'))
}


/***/ }),

/***/ 22506:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
var timespan = __webpack_require__(68034);
var PS_SUPPORTED = __webpack_require__(14964);
var jws = __webpack_require__(40158);
var includes = __webpack_require__(28922);
var isBoolean = __webpack_require__(48094);
var isInteger = __webpack_require__(55928);
var isNumber = __webpack_require__(23126);
var isPlainObject = __webpack_require__(8146);
var isString = __webpack_require__(25751);
var once = __webpack_require__(38917);

var SUPPORTED_ALGS = ['RS256', 'RS384', 'RS512', 'ES256', 'ES384', 'ES512', 'HS256', 'HS384', 'HS512', 'none']
if (PS_SUPPORTED) {
  SUPPORTED_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
}

var sign_options_schema = {
  expiresIn: { isValid: function(value) { return isInteger(value) || (isString(value) && value); }, message: '"expiresIn" should be a number of seconds or string representing a timespan' },
  notBefore: { isValid: function(value) { return isInteger(value) || (isString(value) && value); }, message: '"notBefore" should be a number of seconds or string representing a timespan' },
  audience: { isValid: function(value) { return isString(value) || Array.isArray(value); }, message: '"audience" must be a string or array' },
  algorithm: { isValid: includes.bind(null, SUPPORTED_ALGS), message: '"algorithm" must be a valid string enum value' },
  header: { isValid: isPlainObject, message: '"header" must be an object' },
  encoding: { isValid: isString, message: '"encoding" must be a string' },
  issuer: { isValid: isString, message: '"issuer" must be a string' },
  subject: { isValid: isString, message: '"subject" must be a string' },
  jwtid: { isValid: isString, message: '"jwtid" must be a string' },
  noTimestamp: { isValid: isBoolean, message: '"noTimestamp" must be a boolean' },
  keyid: { isValid: isString, message: '"keyid" must be a string' },
  mutatePayload: { isValid: isBoolean, message: '"mutatePayload" must be a boolean' }
};

var registered_claims_schema = {
  iat: { isValid: isNumber, message: '"iat" should be a number of seconds' },
  exp: { isValid: isNumber, message: '"exp" should be a number of seconds' },
  nbf: { isValid: isNumber, message: '"nbf" should be a number of seconds' }
};

function validate(schema, allowUnknown, object, parameterName) {
  if (!isPlainObject(object)) {
    throw new Error('Expected "' + parameterName + '" to be a plain object.');
  }
  Object.keys(object)
    .forEach(function(key) {
      var validator = schema[key];
      if (!validator) {
        if (!allowUnknown) {
          throw new Error('"' + key + '" is not allowed in "' + parameterName + '"');
        }
        return;
      }
      if (!validator.isValid(object[key])) {
        throw new Error(validator.message);
      }
    });
}

function validateOptions(options) {
  return validate(sign_options_schema, false, options, 'options');
}

function validatePayload(payload) {
  return validate(registered_claims_schema, true, payload, 'payload');
}

var options_to_payload = {
  'audience': 'aud',
  'issuer': 'iss',
  'subject': 'sub',
  'jwtid': 'jti'
};

var options_for_objects = [
  'expiresIn',
  'notBefore',
  'noTimestamp',
  'audience',
  'issuer',
  'subject',
  'jwtid',
];

module.exports = function (payload, secretOrPrivateKey, options, callback) {
  if (typeof options === 'function') {
    callback = options;
    options = {};
  } else {
    options = options || {};
  }

  var isObjectPayload = typeof payload === 'object' &&
                        !Buffer.isBuffer(payload);

  var header = Object.assign({
    alg: options.algorithm || 'HS256',
    typ: isObjectPayload ? 'JWT' : undefined,
    kid: options.keyid
  }, options.header);

  function failure(err) {
    if (callback) {
      return callback(err);
    }
    throw err;
  }

  if (!secretOrPrivateKey && options.algorithm !== 'none') {
    return failure(new Error('secretOrPrivateKey must have a value'));
  }

  if (typeof payload === 'undefined') {
    return failure(new Error('payload is required'));
  } else if (isObjectPayload) {
    try {
      validatePayload(payload);
    }
    catch (error) {
      return failure(error);
    }
    if (!options.mutatePayload) {
      payload = Object.assign({},payload);
    }
  } else {
    var invalid_options = options_for_objects.filter(function (opt) {
      return typeof options[opt] !== 'undefined';
    });

    if (invalid_options.length > 0) {
      return failure(new Error('invalid ' + invalid_options.join(',') + ' option for ' + (typeof payload ) + ' payload'));
    }
  }

  if (typeof payload.exp !== 'undefined' && typeof options.expiresIn !== 'undefined') {
    return failure(new Error('Bad "options.expiresIn" option the payload already has an "exp" property.'));
  }

  if (typeof payload.nbf !== 'undefined' && typeof options.notBefore !== 'undefined') {
    return failure(new Error('Bad "options.notBefore" option the payload already has an "nbf" property.'));
  }

  try {
    validateOptions(options);
  }
  catch (error) {
    return failure(error);
  }

  var timestamp = payload.iat || Math.floor(Date.now() / 1000);

  if (options.noTimestamp) {
    delete payload.iat;
  } else if (isObjectPayload) {
    payload.iat = timestamp;
  }

  if (typeof options.notBefore !== 'undefined') {
    try {
      payload.nbf = timespan(options.notBefore, timestamp);
    }
    catch (err) {
      return failure(err);
    }
    if (typeof payload.nbf === 'undefined') {
      return failure(new Error('"notBefore" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
  }

  if (typeof options.expiresIn !== 'undefined' && typeof payload === 'object') {
    try {
      payload.exp = timespan(options.expiresIn, timestamp);
    }
    catch (err) {
      return failure(err);
    }
    if (typeof payload.exp === 'undefined') {
      return failure(new Error('"expiresIn" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
    }
  }

  Object.keys(options_to_payload).forEach(function (key) {
    var claim = options_to_payload[key];
    if (typeof options[key] !== 'undefined') {
      if (typeof payload[claim] !== 'undefined') {
        return failure(new Error('Bad "options.' + key + '" option. The payload already has an "' + claim + '" property.'));
      }
      payload[claim] = options[key];
    }
  });

  var encoding = options.encoding || 'utf8';

  if (typeof callback === 'function') {
    callback = callback && once(callback);

    jws.createSign({
      header: header,
      privateKey: secretOrPrivateKey,
      payload: payload,
      encoding: encoding
    }).once('error', callback)
      .once('done', function (signature) {
        callback(null, signature);
      });
  } else {
    return jws.sign({header: header, payload: payload, secret: secretOrPrivateKey, encoding: encoding});
  }
};


/***/ }),

/***/ 17030:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var JsonWebTokenError = __webpack_require__(58619);
var NotBeforeError    = __webpack_require__(71826);
var TokenExpiredError = __webpack_require__(2340);
var decode            = __webpack_require__(97626);
var timespan          = __webpack_require__(68034);
var PS_SUPPORTED      = __webpack_require__(14964);
var jws               = __webpack_require__(40158);

var PUB_KEY_ALGS = ['RS256', 'RS384', 'RS512', 'ES256', 'ES384', 'ES512'];
var RSA_KEY_ALGS = ['RS256', 'RS384', 'RS512'];
var HS_ALGS = ['HS256', 'HS384', 'HS512'];

if (PS_SUPPORTED) {
  PUB_KEY_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
  RSA_KEY_ALGS.splice(3, 0, 'PS256', 'PS384', 'PS512');
}

module.exports = function (jwtString, secretOrPublicKey, options, callback) {
  if ((typeof options === 'function') && !callback) {
    callback = options;
    options = {};
  }

  if (!options) {
    options = {};
  }

  //clone this object since we are going to mutate it.
  options = Object.assign({}, options);

  var done;

  if (callback) {
    done = callback;
  } else {
    done = function(err, data) {
      if (err) throw err;
      return data;
    };
  }

  if (options.clockTimestamp && typeof options.clockTimestamp !== 'number') {
    return done(new JsonWebTokenError('clockTimestamp must be a number'));
  }

  if (options.nonce !== undefined && (typeof options.nonce !== 'string' || options.nonce.trim() === '')) {
    return done(new JsonWebTokenError('nonce must be a non-empty string'));
  }

  var clockTimestamp = options.clockTimestamp || Math.floor(Date.now() / 1000);

  if (!jwtString){
    return done(new JsonWebTokenError('jwt must be provided'));
  }

  if (typeof jwtString !== 'string') {
    return done(new JsonWebTokenError('jwt must be a string'));
  }

  var parts = jwtString.split('.');

  if (parts.length !== 3){
    return done(new JsonWebTokenError('jwt malformed'));
  }

  var decodedToken;

  try {
    decodedToken = decode(jwtString, { complete: true });
  } catch(err) {
    return done(err);
  }

  if (!decodedToken) {
    return done(new JsonWebTokenError('invalid token'));
  }

  var header = decodedToken.header;
  var getSecret;

  if(typeof secretOrPublicKey === 'function') {
    if(!callback) {
      return done(new JsonWebTokenError('verify must be called asynchronous if secret or public key is provided as a callback'));
    }

    getSecret = secretOrPublicKey;
  }
  else {
    getSecret = function(header, secretCallback) {
      return secretCallback(null, secretOrPublicKey);
    };
  }

  return getSecret(header, function(err, secretOrPublicKey) {
    if(err) {
      return done(new JsonWebTokenError('error in secret or public key callback: ' + err.message));
    }

    var hasSignature = parts[2].trim() !== '';

    if (!hasSignature && secretOrPublicKey){
      return done(new JsonWebTokenError('jwt signature is required'));
    }

    if (hasSignature && !secretOrPublicKey) {
      return done(new JsonWebTokenError('secret or public key must be provided'));
    }

    if (!hasSignature && !options.algorithms) {
      options.algorithms = ['none'];
    }

    if (!options.algorithms) {
      options.algorithms = ~secretOrPublicKey.toString().indexOf('BEGIN CERTIFICATE') ||
        ~secretOrPublicKey.toString().indexOf('BEGIN PUBLIC KEY') ? PUB_KEY_ALGS :
        ~secretOrPublicKey.toString().indexOf('BEGIN RSA PUBLIC KEY') ? RSA_KEY_ALGS : HS_ALGS;

    }

    if (!~options.algorithms.indexOf(decodedToken.header.alg)) {
      return done(new JsonWebTokenError('invalid algorithm'));
    }

    var valid;

    try {
      valid = jws.verify(jwtString, decodedToken.header.alg, secretOrPublicKey);
    } catch (e) {
      return done(e);
    }

    if (!valid) {
      return done(new JsonWebTokenError('invalid signature'));
    }

    var payload = decodedToken.payload;

    if (typeof payload.nbf !== 'undefined' && !options.ignoreNotBefore) {
      if (typeof payload.nbf !== 'number') {
        return done(new JsonWebTokenError('invalid nbf value'));
      }
      if (payload.nbf > clockTimestamp + (options.clockTolerance || 0)) {
        return done(new NotBeforeError('jwt not active', new Date(payload.nbf * 1000)));
      }
    }

    if (typeof payload.exp !== 'undefined' && !options.ignoreExpiration) {
      if (typeof payload.exp !== 'number') {
        return done(new JsonWebTokenError('invalid exp value'));
      }
      if (clockTimestamp >= payload.exp + (options.clockTolerance || 0)) {
        return done(new TokenExpiredError('jwt expired', new Date(payload.exp * 1000)));
      }
    }

    if (options.audience) {
      var audiences = Array.isArray(options.audience) ? options.audience : [options.audience];
      var target = Array.isArray(payload.aud) ? payload.aud : [payload.aud];

      var match = target.some(function (targetAudience) {
        return audiences.some(function (audience) {
          return audience instanceof RegExp ? audience.test(targetAudience) : audience === targetAudience;
        });
      });

      if (!match) {
        return done(new JsonWebTokenError('jwt audience invalid. expected: ' + audiences.join(' or ')));
      }
    }

    if (options.issuer) {
      var invalid_issuer =
              (typeof options.issuer === 'string' && payload.iss !== options.issuer) ||
              (Array.isArray(options.issuer) && options.issuer.indexOf(payload.iss) === -1);

      if (invalid_issuer) {
        return done(new JsonWebTokenError('jwt issuer invalid. expected: ' + options.issuer));
      }
    }

    if (options.subject) {
      if (payload.sub !== options.subject) {
        return done(new JsonWebTokenError('jwt subject invalid. expected: ' + options.subject));
      }
    }

    if (options.jwtid) {
      if (payload.jti !== options.jwtid) {
        return done(new JsonWebTokenError('jwt jwtid invalid. expected: ' + options.jwtid));
      }
    }

    if (options.nonce) {
      if (payload.nonce !== options.nonce) {
        return done(new JsonWebTokenError('jwt nonce invalid. expected: ' + options.nonce));
      }
    }

    if (options.maxAge) {
      if (typeof payload.iat !== 'number') {
        return done(new JsonWebTokenError('iat required when maxAge is specified'));
      }

      var maxAgeTimestamp = timespan(options.maxAge, payload.iat);
      if (typeof maxAgeTimestamp === 'undefined') {
        return done(new JsonWebTokenError('"maxAge" should be a number of seconds or string representing a timespan eg: "1d", "20h", 60'));
      }
      if (clockTimestamp >= maxAgeTimestamp + (options.clockTolerance || 0)) {
        return done(new TokenExpiredError('maxAge exceeded', new Date(maxAgeTimestamp * 1000)));
      }
    }

    if (options.complete === true) {
      var signature = decodedToken.signature;

      return done(null, {
        header: header,
        payload: payload,
        signature: signature
      });
    }

    return done(null, payload);
  });
};


/***/ }),

/***/ 54178:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var bufferEqual = __webpack_require__(88500);
var Buffer = (__webpack_require__(89509).Buffer);
var crypto = __webpack_require__(42474);
var formatEcdsa = __webpack_require__(35015);
var util = __webpack_require__(79720);

var MSG_INVALID_ALGORITHM = '"%s" is not a valid algorithm.\n  Supported algorithms are:\n  "HS256", "HS384", "HS512", "RS256", "RS384", "RS512", "PS256", "PS384", "PS512", "ES256", "ES384", "ES512" and "none".'
var MSG_INVALID_SECRET = 'secret must be a string or buffer';
var MSG_INVALID_VERIFIER_KEY = 'key must be a string or a buffer';
var MSG_INVALID_SIGNER_KEY = 'key must be a string, a buffer or an object';

var supportsKeyObjects = typeof crypto.createPublicKey === 'function';
if (supportsKeyObjects) {
  MSG_INVALID_VERIFIER_KEY += ' or a KeyObject';
  MSG_INVALID_SECRET += 'or a KeyObject';
}

function checkIsPublicKey(key) {
  if (Buffer.isBuffer(key)) {
    return;
  }

  if (typeof key === 'string') {
    return;
  }

  if (!supportsKeyObjects) {
    throw typeError(MSG_INVALID_VERIFIER_KEY);
  }

  if (typeof key !== 'object') {
    throw typeError(MSG_INVALID_VERIFIER_KEY);
  }

  if (typeof key.type !== 'string') {
    throw typeError(MSG_INVALID_VERIFIER_KEY);
  }

  if (typeof key.asymmetricKeyType !== 'string') {
    throw typeError(MSG_INVALID_VERIFIER_KEY);
  }

  if (typeof key.export !== 'function') {
    throw typeError(MSG_INVALID_VERIFIER_KEY);
  }
};

function checkIsPrivateKey(key) {
  if (Buffer.isBuffer(key)) {
    return;
  }

  if (typeof key === 'string') {
    return;
  }

  if (typeof key === 'object') {
    return;
  }

  throw typeError(MSG_INVALID_SIGNER_KEY);
};

function checkIsSecretKey(key) {
  if (Buffer.isBuffer(key)) {
    return;
  }

  if (typeof key === 'string') {
    return key;
  }

  if (!supportsKeyObjects) {
    throw typeError(MSG_INVALID_SECRET);
  }

  if (typeof key !== 'object') {
    throw typeError(MSG_INVALID_SECRET);
  }

  if (key.type !== 'secret') {
    throw typeError(MSG_INVALID_SECRET);
  }

  if (typeof key.export !== 'function') {
    throw typeError(MSG_INVALID_SECRET);
  }
}

function fromBase64(base64) {
  return base64
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
}

function toBase64(base64url) {
  base64url = base64url.toString();

  var padding = 4 - base64url.length % 4;
  if (padding !== 4) {
    for (var i = 0; i < padding; ++i) {
      base64url += '=';
    }
  }

  return base64url
    .replace(/\-/g, '+')
    .replace(/_/g, '/');
}

function typeError(template) {
  var args = [].slice.call(arguments, 1);
  var errMsg = util.format.bind(util, template).apply(null, args);
  return new TypeError(errMsg);
}

function bufferOrString(obj) {
  return Buffer.isBuffer(obj) || typeof obj === 'string';
}

function normalizeInput(thing) {
  if (!bufferOrString(thing))
    thing = JSON.stringify(thing);
  return thing;
}

function createHmacSigner(bits) {
  return function sign(thing, secret) {
    checkIsSecretKey(secret);
    thing = normalizeInput(thing);
    var hmac = crypto.createHmac('sha' + bits, secret);
    var sig = (hmac.update(thing), hmac.digest('base64'))
    return fromBase64(sig);
  }
}

function createHmacVerifier(bits) {
  return function verify(thing, signature, secret) {
    var computedSig = createHmacSigner(bits)(thing, secret);
    return bufferEqual(Buffer.from(signature), Buffer.from(computedSig));
  }
}

function createKeySigner(bits) {
 return function sign(thing, privateKey) {
    checkIsPrivateKey(privateKey);
    thing = normalizeInput(thing);
    // Even though we are specifying "RSA" here, this works with ECDSA
    // keys as well.
    var signer = crypto.createSign('RSA-SHA' + bits);
    var sig = (signer.update(thing), signer.sign(privateKey, 'base64'));
    return fromBase64(sig);
  }
}

function createKeyVerifier(bits) {
  return function verify(thing, signature, publicKey) {
    checkIsPublicKey(publicKey);
    thing = normalizeInput(thing);
    signature = toBase64(signature);
    var verifier = crypto.createVerify('RSA-SHA' + bits);
    verifier.update(thing);
    return verifier.verify(publicKey, signature, 'base64');
  }
}

function createPSSKeySigner(bits) {
  return function sign(thing, privateKey) {
    checkIsPrivateKey(privateKey);
    thing = normalizeInput(thing);
    var signer = crypto.createSign('RSA-SHA' + bits);
    var sig = (signer.update(thing), signer.sign({
      key: privateKey,
      padding: crypto.constants.RSA_PKCS1_PSS_PADDING,
      saltLength: crypto.constants.RSA_PSS_SALTLEN_DIGEST
    }, 'base64'));
    return fromBase64(sig);
  }
}

function createPSSKeyVerifier(bits) {
  return function verify(thing, signature, publicKey) {
    checkIsPublicKey(publicKey);
    thing = normalizeInput(thing);
    signature = toBase64(signature);
    var verifier = crypto.createVerify('RSA-SHA' + bits);
    verifier.update(thing);
    return verifier.verify({
      key: publicKey,
      padding: crypto.constants.RSA_PKCS1_PSS_PADDING,
      saltLength: crypto.constants.RSA_PSS_SALTLEN_DIGEST
    }, signature, 'base64');
  }
}

function createECDSASigner(bits) {
  var inner = createKeySigner(bits);
  return function sign() {
    var signature = inner.apply(null, arguments);
    signature = formatEcdsa.derToJose(signature, 'ES' + bits);
    return signature;
  };
}

function createECDSAVerifer(bits) {
  var inner = createKeyVerifier(bits);
  return function verify(thing, signature, publicKey) {
    signature = formatEcdsa.joseToDer(signature, 'ES' + bits).toString('base64');
    var result = inner(thing, signature, publicKey);
    return result;
  };
}

function createNoneSigner() {
  return function sign() {
    return '';
  }
}

function createNoneVerifier() {
  return function verify(thing, signature) {
    return signature === '';
  }
}

module.exports = function jwa(algorithm) {
  var signerFactories = {
    hs: createHmacSigner,
    rs: createKeySigner,
    ps: createPSSKeySigner,
    es: createECDSASigner,
    none: createNoneSigner,
  }
  var verifierFactories = {
    hs: createHmacVerifier,
    rs: createKeyVerifier,
    ps: createPSSKeyVerifier,
    es: createECDSAVerifer,
    none: createNoneVerifier,
  }
  var match = algorithm.match(/^(RS|PS|ES|HS)(256|384|512)$|^(none)$/i);
  if (!match)
    throw typeError(MSG_INVALID_ALGORITHM, algorithm);
  var algo = (match[1] || match[3]).toLowerCase();
  var bits = match[2];

  return {
    sign: signerFactories[algo](bits),
    verify: verifierFactories[algo](bits),
  }
};


/***/ }),

/***/ 66503:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const logger = __webpack_require__(11227)('jwks');
const { retrieveSigningKeys } = __webpack_require__(62270) ;
const { request, cacheSigningKey, rateLimitSigningKey, getKeysInterceptor, callbackSupport } = __webpack_require__(24821);
const JwksError = __webpack_require__(69110);
const SigningKeyNotFoundError = __webpack_require__(45224);

class JwksClient {
  constructor(options) {
    this.options = {
      rateLimit: false,
      cache: true,
      timeout: 30000,
      ...options
    };

    // Initialize wrappers.
    if (this.options.getKeysInterceptor) {
      this.getSigningKey = getKeysInterceptor(this, options);
    }

    if (this.options.rateLimit) {
      this.getSigningKey = rateLimitSigningKey(this, options);
    }
    if (this.options.cache) {
      this.getSigningKey = cacheSigningKey(this, options);
    }

    this.getSigningKey = callbackSupport(this, options);
  }

  async getKeys() {
    logger(`Fetching keys from '${this.options.jwksUri}'`);

    try {
      const res = await request({
        uri: this.options.jwksUri,
        headers: this.options.requestHeaders,
        agent: this.options.requestAgent,
        timeout: this.options.timeout,
        fetcher: this.options.fetcher
      });

      logger('Keys:', res.keys);
      return res.keys;
    } catch (err) {
      const { errorMsg } = err;
      logger('Failure:', errorMsg || err);
      throw (errorMsg ? new JwksError(errorMsg) : err);
    }
  }

  async getSigningKeys() {
    const keys = await this.getKeys();

    if (!keys || !keys.length) {
      throw new JwksError('The JWKS endpoint did not contain any keys');
    }

    const signingKeys = retrieveSigningKeys(keys);

    if (!signingKeys.length) {
      throw new JwksError('The JWKS endpoint did not contain any signing keys');
    }

    logger('Signing Keys:', signingKeys);
    return signingKeys;
  }

  async getSigningKey (kid) {
    logger(`Fetching signing key for '${kid}'`);
    const keys = await this.getSigningKeys();

    const kidDefined = kid !== undefined && kid !== null;
    if (!kidDefined && keys.length > 1) {
      logger('No KID specified and JWKS endpoint returned more than 1 key');
      throw new SigningKeyNotFoundError('No KID specified and JWKS endpoint returned more than 1 key');
    }

    const key = keys.find(k => !kidDefined || k.kid === kid);
    if (key) {
      return key;
    } else {
      logger(`Unable to find a signing key that matches '${kid}'`);
      throw new SigningKeyNotFoundError(`Unable to find a signing key that matches '${kid}'`);
    }
  }
}

module.exports = {
  JwksClient
};


/***/ }),

/***/ 75992:
/***/ (function(module) {

function ArgumentError(message) {
  Error.call(this, message);
  Error.captureStackTrace(this, this.constructor);
  this.name = 'ArgumentError';
  this.message = message;
}

ArgumentError.prototype = Object.create(Error.prototype);
ArgumentError.prototype.constructor = ArgumentError;
module.exports = ArgumentError;


/***/ }),

/***/ 69110:
/***/ (function(module) {

function JwksError(message) {
  Error.call(this, message);
  Error.captureStackTrace(this, this.constructor);
  this.name = 'JwksError';
  this.message = message;
}

JwksError.prototype = Object.create(Error.prototype);
JwksError.prototype.constructor = JwksError;
module.exports = JwksError;


/***/ }),

/***/ 16037:
/***/ (function(module) {

function JwksRateLimitError(message) {
  Error.call(this, message);
  Error.captureStackTrace(this, this.constructor);
  this.name = 'JwksRateLimitError';
  this.message = message;
}

JwksRateLimitError.prototype = Object.create(Error.prototype);
JwksRateLimitError.prototype.constructor = JwksRateLimitError;
module.exports = JwksRateLimitError;


/***/ }),

/***/ 45224:
/***/ (function(module) {

function SigningKeyNotFoundError(message) {
  Error.call(this, message);
  Error.captureStackTrace(this, this.constructor);
  this.name = 'SigningKeyNotFoundError';
  this.message = message;
}

SigningKeyNotFoundError.prototype = Object.create(Error.prototype);
SigningKeyNotFoundError.prototype.constructor = SigningKeyNotFoundError;
module.exports = SigningKeyNotFoundError;


/***/ }),

/***/ 68927:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
  ArgumentError: __webpack_require__(75992),
  JwksError: __webpack_require__(69110),
  JwksRateLimitError: __webpack_require__(16037),
  SigningKeyNotFoundError: __webpack_require__(45224)
};


/***/ }),

/***/ 6064:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { JwksClient } = __webpack_require__(66503);
const errors = __webpack_require__(68927);
const { hapiJwt2Key, hapiJwt2KeyAsync } = __webpack_require__(77454);
const { expressJwtSecret } = __webpack_require__(700);
const { koaJwtSecret } = __webpack_require__(61765);
const { passportJwtSecret } = __webpack_require__(10186);

module.exports = (options) => {
  return new JwksClient(options);
};
module.exports.JwksClient = JwksClient;

module.exports.ArgumentError = errors.ArgumentError;
module.exports.JwksError = errors.JwksError;
module.exports.JwksRateLimitError = errors.JwksRateLimitError;
module.exports.SigningKeyNotFoundError = errors.SigningKeyNotFoundError;

module.exports.expressJwtSecret = expressJwtSecret;
module.exports.hapiJwt2Key = hapiJwt2Key;
module.exports.hapiJwt2KeyAsync = hapiJwt2KeyAsync;
module.exports.koaJwtSecret = koaJwtSecret;
module.exports.passportJwtSecret = passportJwtSecret;


/***/ }),

/***/ 41614:
/***/ (function(module) {

const allowedSignatureAlg = [
  'RS256',
  'RS384',
  'RS512',
  'PS256',
  'PS384',
  'PS512',
  'ES256',
  'ES256K',
  'ES384',
  'ES512',
  'EdDSA'
];

module.exports = allowedSignatureAlg;


/***/ }),

/***/ 700:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { ArgumentError } = __webpack_require__(68927);
const { JwksClient } = __webpack_require__(66503);
const supportedAlg = __webpack_require__(41614);

const handleSigningKeyError = (err, cb) => {
  // If we didn't find a match, can't provide a key.
  if (err && err.name === 'SigningKeyNotFoundError') {
    return cb(null);
  }

  // If an error occured like rate limiting or HTTP issue, we'll bubble up the error.
  if (err) {
    return cb(err);
  }
};

module.exports.expressJwtSecret = function (options) {
  if (options === null || options === undefined) {
    throw new ArgumentError('An options object must be provided when initializing expressJwtSecret');
  }

  const client = new JwksClient(options);
  const onError = options.handleSigningKeyError || handleSigningKeyError;

  const expressJwt7Provider = async (req, token) => {
    if (!token) { return; }
    const header = token.header;
    if (!header || !supportedAlg.includes(header.alg)) {
      return;
    }
    try {
      const key = await client.getSigningKey(header.kid);
      return key.publicKey || key.rsaPublicKey;
    } catch (err) {
      return new Promise((resolve, reject) => {
        onError(err, (newError) => {
          if (!newError) { return resolve(); }
          reject(newError);
        });
      });
    }
  };

  return function secretProvider(req, header, payload, cb) {
    //This function has 4 parameters to make it work with express-jwt@6
    //but it also supports express-jwt@7 which only has 2.
    if (arguments.length === 4) {
      expressJwt7Provider(req, { header })
        .then(key => {
          setImmediate(cb, null, key);
        }).catch(err => {
          setImmediate(cb, err);
        });

      return;
    }

    return expressJwt7Provider(req, arguments[1]);
  };
};


/***/ }),

/***/ 77454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { ArgumentError } = __webpack_require__(68927);
const { JwksClient } = __webpack_require__(66503);
const supportedAlg = __webpack_require__(41614);

const handleSigningKeyError = (err, cb) => {
  // If we didn't find a match, can't provide a key.
  if (err && err.name === 'SigningKeyNotFoundError') {
    return cb(err, null, null);
  }

  // If an error occured like rate limiting or HTTP issue, we'll bubble up the error.
  if (err) {
    return cb(err, null, null);
  }
};

/**
 * Call hapiJwt2Key as a Promise
 * @param {object} options 
 * @returns {Promise}
 */
module.exports.hapiJwt2KeyAsync = (options) => {
  const secretProvider = module.exports.hapiJwt2Key(options);
  return function(decoded) {
    return new Promise((resolve, reject) => {
      const cb = (err, key) => {
        (!key || err) ? reject(err) : resolve({ key });
      };
      secretProvider(decoded, cb);
    });
  };
}; 

module.exports.hapiJwt2Key = function (options) {
  if (options === null || options === undefined) {
    throw new ArgumentError('An options object must be provided when initializing hapiJwt2Key');
  }

  const client = new JwksClient(options);
  const onError = options.handleSigningKeyError || handleSigningKeyError;

  return function secretProvider(decoded, cb) {
    // We cannot find a signing certificate if there is no header (no kid).
    if (!decoded || !decoded.header) {
      return cb(new Error('Cannot find a signing certificate if there is no header'), null, null);
    }

    if (!supportedAlg.includes(decoded.header.alg)) {
      return cb(new Error('Unsupported algorithm ' + decoded.header.alg + ' supplied.'), null, null);
    }

    client.getSigningKey(decoded.header.kid)
      .then(key => {
        return cb(null, key.publicKey || key.rsaPublicKey, key);
      }).catch(err => {
        return onError(err, (newError) => cb(newError, null, null));
      });
  };
};


/***/ }),

/***/ 61765:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { ArgumentError } = __webpack_require__(68927);
const { JwksClient } = __webpack_require__(66503);
const supportedAlg = __webpack_require__(41614);

module.exports.koaJwtSecret = function (options = {}) {
  if (!options.jwksUri) {
    throw new ArgumentError('No JWKS provided. Please provide a jwksUri');
  }

  const client = new JwksClient(options);

  return function secretProvider({ alg, kid } = {}) {
    return new Promise((resolve, reject) => {
      if (!supportedAlg.includes(alg)) {
        return reject(new Error('Missing / invalid token algorithm'));
      }

      client.getSigningKey(kid)
        .then(key => {
          resolve(key.publicKey || key.rsaPublicKey);
        }).catch(err => {
          if (options.handleSigningKeyError) {
            return options.handleSigningKeyError(err).then(reject);
          }

          return reject(err);
        });
    });
  };
};


/***/ }),

/***/ 10186:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const JWT = (__webpack_require__(4948).JWT);
const { ArgumentError } = __webpack_require__(68927);
const { JwksClient } = __webpack_require__(66503);
const supportedAlg = __webpack_require__(41614);

const handleSigningKeyError = (err, cb) => {
  // If we didn't find a match, can't provide a key.
  if (err && err.name === 'SigningKeyNotFoundError') {
    return cb(null);
  }

  // If an error occured like rate limiting or HTTP issue, we'll bubble up the error.
  if (err) {
    return cb(err);
  }
};

module.exports.passportJwtSecret = function (options) {
  if (options === null || options === undefined) {
    throw new ArgumentError('An options object must be provided when initializing passportJwtSecret');
  }

  if (!options.jwksUri) {
    throw new ArgumentError('No JWKS provided. Please provide a jwksUri');
  }

  const client = new JwksClient(options);
  const onError = options.handleSigningKeyError || handleSigningKeyError;

  return function secretProvider(req, rawJwtToken, cb) {
    let decoded;
    try {
      decoded = JWT.decode(rawJwtToken, { complete: true });
    } catch (err) {
      decoded = null;
    }

    if (!decoded || !supportedAlg.includes(decoded.header.alg)) {
      return cb(null, null);
    }

    client.getSigningKey(decoded.header.kid)
      .then(key => {
        cb(null, key.publicKey || key.rsaPublicKey);
      }).catch(err => {
        onError(err, (newError) => cb(newError, null));
      });
  };
};


/***/ }),

/***/ 62270:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const jose = __webpack_require__(4948);

function retrieveSigningKeys(keys) {
  const keystore = jose.JWKS.asKeyStore({ keys }, { ignoreErrors: true });

  return keystore.all({ use: 'sig' }).map((key) => {
    return {
      kid: key.kid,
      alg: key.alg,
      get publicKey() { return key.toPEM(false); },
      get rsaPublicKey() { return key.toPEM(false); },
      getPublicKey() { return key.toPEM(false); }
    };
  });
}

module.exports = {
  retrieveSigningKeys
};


/***/ }),

/***/ 38757:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const logger = __webpack_require__(11227)('jwks');
const memoizer = __webpack_require__(39723);
const { promisify, callbackify } = __webpack_require__(79720);

function cacheWrapper(client, { cacheMaxEntries = 5, cacheMaxAge = 600000 }) {
  logger(`Configured caching of signing keys. Max: ${cacheMaxEntries} / Age: ${cacheMaxAge}`);
  return promisify(memoizer({
    hash: (kid) => kid,
    load: callbackify(client.getSigningKey.bind(client)),
    maxAge: cacheMaxAge,
    max: cacheMaxEntries
  }));
}

module.exports.Z = cacheWrapper;


/***/ }),

/***/ 59176:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const { callbackify } = __webpack_require__(79720);

const callbackSupport = (client) => {
  const getSigningKey = client.getSigningKey.bind(client);

  return (kid, cb) => {
    if (cb) {
      const callbackFunc = callbackify(getSigningKey);
      return callbackFunc(kid, cb);
    }

    return getSigningKey(kid);
  };
};

module.exports.Z = callbackSupport;


/***/ }),

/***/ 24821:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = {
  request: (__webpack_require__(76007)/* ["default"] */ .Z),
  cacheSigningKey: (__webpack_require__(38757)/* ["default"] */ .Z),
  rateLimitSigningKey: (__webpack_require__(53147)/* ["default"] */ .Z),
  getKeysInterceptor: (__webpack_require__(80193)/* ["default"] */ .Z),
  callbackSupport: (__webpack_require__(59176)/* ["default"] */ .Z)
};


/***/ }),

/***/ 80193:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const retrieveSigningKeys = (__webpack_require__(62270).retrieveSigningKeys);

/**
 * Uses getKeysInterceptor to allow users to retrieve keys from a file,
 * external cache, or provided object before falling back to the jwksUri endpoint
 */
function getKeysInterceptor(client, { getKeysInterceptor }) {
  const getSigningKey = client.getSigningKey.bind(client);

  return async (kid) => {
    const keys = await getKeysInterceptor();

    let signingKeys;
    if (keys && keys.length) {
      signingKeys = retrieveSigningKeys(keys);
    }

    if (signingKeys && signingKeys.length) {
      const key = signingKeys.find(k => !kid || k.kid === kid);

      if (key) {
        return key;
      }
    }

    return getSigningKey(kid);
  };
}

module.exports.Z = getKeysInterceptor;


/***/ }),

/***/ 53147:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const logger = __webpack_require__(11227)('jwks');
const { RateLimiter } = __webpack_require__(75516);

const JwksRateLimitError = __webpack_require__(16037);

function rateLimitWrapper(client, { jwksRequestsPerMinute = 10 }) {
  const getSigningKey = client.getSigningKey.bind(client);

  const limiter = new RateLimiter(jwksRequestsPerMinute, 'minute', true);
  logger(`Configured rate limiting to JWKS endpoint at ${jwksRequestsPerMinute}/minute`);

  return async (kid) => await new Promise((resolve, reject) => {
    limiter.removeTokens(1, async (err, remaining) => {
      if (err) {
        reject(err);
      }

      logger('Requests to the JWKS endpoint available for the next minute:', remaining);
      if (remaining < 0) {
        logger('Too many requests to the JWKS endpoint');
        reject(new JwksRateLimitError('Too many requests to the JWKS endpoint'));
      } else {
        try {
          const key = await getSigningKey(kid);
          resolve(key);
        } catch (error) {
          reject(error);
        }
      }
    });
  });
}

module.exports.Z = rateLimitWrapper;


/***/ }),

/***/ 76007:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

const http = __webpack_require__(22321);
const https = __webpack_require__(78428);
const urlUtil = __webpack_require__(11987);

module.exports.Z =  (options) => {
  if (options.fetcher) {
    return options.fetcher(options.uri);
  }

  return new Promise((resolve, reject) => {
    const {
      hostname,
      path,
      port,
      protocol
    } = urlUtil.parse(options.uri);

    const requestOptions = {
      hostname,
      path,
      port,
      method: 'GET',
      ...(options.headers && { headers: { ...options.headers } }),
      ...(options.timeout && { timeout: options.timeout }),
      ...(options.agent && { agent: options.agent })
    };

    const httpRequestLib = protocol === 'https:' ? https : http;
    const httpRequest = httpRequestLib.request(requestOptions, (res) => {
      let rawData = '';
      res.setEncoding('utf8');
      res.on('data', (chunk) => { rawData += chunk; });
      res.on('end', () => {
        if (res.statusCode < 200 || res.statusCode >= 300) {
          const errorMsg = res.body && (res.body.message || res.body) || res.statusMessage || `Http Error ${res.statusCode}`;
          reject({ errorMsg });
        } else {
          try {
            resolve(rawData && JSON.parse(rawData));
          } catch (error) {
            reject(error);
          }
        }
      });
    });

    httpRequest
      .on('timeout', () => httpRequest.destroy())
      .on('error', (e) => reject(e))
      .end();
  });
};


/***/ }),

/***/ 40158:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

/*global exports*/
var SignStream = __webpack_require__(48952);
var VerifyStream = __webpack_require__(43079);

var ALGORITHMS = [
  'HS256', 'HS384', 'HS512',
  'RS256', 'RS384', 'RS512',
  'PS256', 'PS384', 'PS512',
  'ES256', 'ES384', 'ES512'
];

exports.ALGORITHMS = ALGORITHMS;
exports.sign = SignStream.sign;
exports.verify = VerifyStream.verify;
exports.decode = VerifyStream.decode;
exports.isValid = VerifyStream.isValid;
exports.createSign = function createSign(opts) {
  return new SignStream(opts);
};
exports.createVerify = function createVerify(opts) {
  return new VerifyStream(opts);
};


/***/ }),

/***/ 97006:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
/*global module, process*/
var Buffer = (__webpack_require__(89509).Buffer);
var Stream = __webpack_require__(79681);
var util = __webpack_require__(79720);

function DataStream(data) {
  this.buffer = null;
  this.writable = true;
  this.readable = true;

  // No input
  if (!data) {
    this.buffer = Buffer.alloc(0);
    return this;
  }

  // Stream
  if (typeof data.pipe === 'function') {
    this.buffer = Buffer.alloc(0);
    data.pipe(this);
    return this;
  }

  // Buffer or String
  // or Object (assumedly a passworded key)
  if (data.length || typeof data === 'object') {
    this.buffer = data;
    this.writable = false;
    process.nextTick(function () {
      this.emit('end', data);
      this.readable = false;
      this.emit('close');
    }.bind(this));
    return this;
  }

  throw new TypeError('Unexpected data type ('+ typeof data + ')');
}
util.inherits(DataStream, Stream);

DataStream.prototype.write = function write(data) {
  this.buffer = Buffer.concat([this.buffer, Buffer.from(data)]);
  this.emit('data', data);
};

DataStream.prototype.end = function end(data) {
  if (data)
    this.write(data);
  this.emit('end', data);
  this.emit('close');
  this.writable = false;
  this.readable = false;
};

module.exports = DataStream;


/***/ }),

/***/ 48952:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*global module*/
var Buffer = (__webpack_require__(89509).Buffer);
var DataStream = __webpack_require__(97006);
var jwa = __webpack_require__(54178);
var Stream = __webpack_require__(79681);
var toString = __webpack_require__(32010);
var util = __webpack_require__(79720);

function base64url(string, encoding) {
  return Buffer
    .from(string, encoding)
    .toString('base64')
    .replace(/=/g, '')
    .replace(/\+/g, '-')
    .replace(/\//g, '_');
}

function jwsSecuredInput(header, payload, encoding) {
  encoding = encoding || 'utf8';
  var encodedHeader = base64url(toString(header), 'binary');
  var encodedPayload = base64url(toString(payload), encoding);
  return util.format('%s.%s', encodedHeader, encodedPayload);
}

function jwsSign(opts) {
  var header = opts.header;
  var payload = opts.payload;
  var secretOrKey = opts.secret || opts.privateKey;
  var encoding = opts.encoding;
  var algo = jwa(header.alg);
  var securedInput = jwsSecuredInput(header, payload, encoding);
  var signature = algo.sign(securedInput, secretOrKey);
  return util.format('%s.%s', securedInput, signature);
}

function SignStream(opts) {
  var secret = opts.secret||opts.privateKey||opts.key;
  var secretStream = new DataStream(secret);
  this.readable = true;
  this.header = opts.header;
  this.encoding = opts.encoding;
  this.secret = this.privateKey = this.key = secretStream;
  this.payload = new DataStream(opts.payload);
  this.secret.once('close', function () {
    if (!this.payload.writable && this.readable)
      this.sign();
  }.bind(this));

  this.payload.once('close', function () {
    if (!this.secret.writable && this.readable)
      this.sign();
  }.bind(this));
}
util.inherits(SignStream, Stream);

SignStream.prototype.sign = function sign() {
  try {
    var signature = jwsSign({
      header: this.header,
      payload: this.payload.buffer,
      secret: this.secret.buffer,
      encoding: this.encoding
    });
    this.emit('done', signature);
    this.emit('data', signature);
    this.emit('end');
    this.readable = false;
    return signature;
  } catch (e) {
    this.readable = false;
    this.emit('error', e);
    this.emit('close');
  }
};

SignStream.sign = jwsSign;

module.exports = SignStream;


/***/ }),

/***/ 32010:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*global module*/
var Buffer = (__webpack_require__(48764).Buffer);

module.exports = function toString(obj) {
  if (typeof obj === 'string')
    return obj;
  if (typeof obj === 'number' || Buffer.isBuffer(obj))
    return obj.toString();
  return JSON.stringify(obj);
};


/***/ }),

/***/ 43079:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/*global module*/
var Buffer = (__webpack_require__(89509).Buffer);
var DataStream = __webpack_require__(97006);
var jwa = __webpack_require__(54178);
var Stream = __webpack_require__(79681);
var toString = __webpack_require__(32010);
var util = __webpack_require__(79720);
var JWS_REGEX = /^[a-zA-Z0-9\-_]+?\.[a-zA-Z0-9\-_]+?\.([a-zA-Z0-9\-_]+)?$/;

function isObject(thing) {
  return Object.prototype.toString.call(thing) === '[object Object]';
}

function safeJsonParse(thing) {
  if (isObject(thing))
    return thing;
  try { return JSON.parse(thing); }
  catch (e) { return undefined; }
}

function headerFromJWS(jwsSig) {
  var encodedHeader = jwsSig.split('.', 1)[0];
  return safeJsonParse(Buffer.from(encodedHeader, 'base64').toString('binary'));
}

function securedInputFromJWS(jwsSig) {
  return jwsSig.split('.', 2).join('.');
}

function signatureFromJWS(jwsSig) {
  return jwsSig.split('.')[2];
}

function payloadFromJWS(jwsSig, encoding) {
  encoding = encoding || 'utf8';
  var payload = jwsSig.split('.')[1];
  return Buffer.from(payload, 'base64').toString(encoding);
}

function isValidJws(string) {
  return JWS_REGEX.test(string) && !!headerFromJWS(string);
}

function jwsVerify(jwsSig, algorithm, secretOrKey) {
  if (!algorithm) {
    var err = new Error("Missing algorithm parameter for jws.verify");
    err.code = "MISSING_ALGORITHM";
    throw err;
  }
  jwsSig = toString(jwsSig);
  var signature = signatureFromJWS(jwsSig);
  var securedInput = securedInputFromJWS(jwsSig);
  var algo = jwa(algorithm);
  return algo.verify(securedInput, signature, secretOrKey);
}

function jwsDecode(jwsSig, opts) {
  opts = opts || {};
  jwsSig = toString(jwsSig);

  if (!isValidJws(jwsSig))
    return null;

  var header = headerFromJWS(jwsSig);

  if (!header)
    return null;

  var payload = payloadFromJWS(jwsSig);
  if (header.typ === 'JWT' || opts.json)
    payload = JSON.parse(payload, opts.encoding);

  return {
    header: header,
    payload: payload,
    signature: signatureFromJWS(jwsSig)
  };
}

function VerifyStream(opts) {
  opts = opts || {};
  var secretOrKey = opts.secret||opts.publicKey||opts.key;
  var secretStream = new DataStream(secretOrKey);
  this.readable = true;
  this.algorithm = opts.algorithm;
  this.encoding = opts.encoding;
  this.secret = this.publicKey = this.key = secretStream;
  this.signature = new DataStream(opts.signature);
  this.secret.once('close', function () {
    if (!this.signature.writable && this.readable)
      this.verify();
  }.bind(this));

  this.signature.once('close', function () {
    if (!this.secret.writable && this.readable)
      this.verify();
  }.bind(this));
}
util.inherits(VerifyStream, Stream);
VerifyStream.prototype.verify = function verify() {
  try {
    var valid = jwsVerify(this.signature.buffer, this.algorithm, this.key.buffer);
    var obj = jwsDecode(this.signature.buffer, this.encoding);
    this.emit('done', valid, obj);
    this.emit('data', valid);
    this.emit('end');
    this.readable = false;
    return valid;
  } catch (e) {
    this.readable = false;
    this.emit('error', e);
    this.emit('close');
  }
};

VerifyStream.decode = jwsDecode;
VerifyStream.isValid = isValidJws;
VerifyStream.verify = jwsVerify;

module.exports = VerifyStream;


/***/ }),

/***/ 75516:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {


exports.RateLimiter = __webpack_require__(31114);
exports.TokenBucket = __webpack_require__(14976);


/***/ }),

/***/ 46188:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
var getMilliseconds = function() {
  if (typeof process !== 'undefined' && process.hrtime) {
    var hrtime = process.hrtime();
    var seconds = hrtime[0];
    var nanoseconds = hrtime[1];

    return seconds * 1e3 +  Math.floor(nanoseconds / 1e6);
  }

  return new Date().getTime();
}

module.exports = getMilliseconds;


/***/ }),

/***/ 31114:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
var TokenBucket = __webpack_require__(14976);
var getMilliseconds = __webpack_require__(46188);

/**
 * A generic rate limiter. Underneath the hood, this uses a token bucket plus
 * an additional check to limit how many tokens we can remove each interval.
 * @author John Hurliman <jhurliman@jhurliman.org>
 *
 * @param {Number} tokensPerInterval Maximum number of tokens that can be
 *  removed at any given moment and over the course of one interval.
 * @param {String|Number} interval The interval length in milliseconds, or as
 *  one of the following strings: 'second', 'minute', 'hour', day'.
 * @param {Boolean} fireImmediately Optional. Whether or not the callback
 *  will fire immediately when rate limiting is in effect (default is false).
 */
var RateLimiter = function(tokensPerInterval, interval, fireImmediately) {
  this.tokenBucket = new TokenBucket(tokensPerInterval, tokensPerInterval,
    interval, null);

  // Fill the token bucket to start
  this.tokenBucket.content = tokensPerInterval;

  this.curIntervalStart = getMilliseconds();
  this.tokensThisInterval = 0;
  this.fireImmediately = fireImmediately;
};

RateLimiter.prototype = {
  tokenBucket: null,
  curIntervalStart: 0,
  tokensThisInterval: 0,
  fireImmediately: false,

  /**
   * Remove the requested number of tokens and fire the given callback. If the
   * rate limiter contains enough tokens and we haven't spent too many tokens
   * in this interval already, this will happen immediately. Otherwise, the
   * removal and callback will happen when enough tokens become available.
   * @param {Number} count The number of tokens to remove.
   * @param {Function} callback(err, remainingTokens)
   * @returns {Boolean} True if the callback was fired immediately, otherwise
   *  false.
   */
  removeTokens: function(count, callback) {
    // Make sure the request isn't for more than we can handle
    if (count > this.tokenBucket.bucketSize) {
      process.nextTick(callback.bind(null, 'Requested tokens ' + count +
        ' exceeds maximum tokens per interval ' + this.tokenBucket.bucketSize,
        null));
      return false;
    }

    var self = this;
    var now = getMilliseconds();

    // Advance the current interval and reset the current interval token count
    // if needed
    if (now < this.curIntervalStart
      || now - this.curIntervalStart >= this.tokenBucket.interval) {
      this.curIntervalStart = now;
      this.tokensThisInterval = 0;
    }

    // If we don't have enough tokens left in this interval, wait until the
    // next interval
    if (count > this.tokenBucket.tokensPerInterval - this.tokensThisInterval) {
      if (this.fireImmediately) {
        process.nextTick(callback.bind(null, null, -1));
      } else {
        var waitInterval = Math.ceil(
          this.curIntervalStart + this.tokenBucket.interval - now);

        setTimeout(function() {
          self.tokenBucket.removeTokens(count, afterTokensRemoved);
        }, waitInterval);
      }
      return false;
    }

    // Remove the requested number of tokens from the token bucket
    return this.tokenBucket.removeTokens(count, afterTokensRemoved);

    function afterTokensRemoved(err, tokensRemaining) {
      if (err) return callback(err, null);

      self.tokensThisInterval += count;
      callback(null, tokensRemaining);
    }
  },

  /**
   * Attempt to remove the requested number of tokens and return immediately.
   * If the bucket (and any parent buckets) contains enough tokens and we
   * haven't spent too many tokens in this interval already, this will return
   * true. Otherwise, false is returned.
   * @param {Number} count The number of tokens to remove.
   * @param {Boolean} True if the tokens were successfully removed, otherwise
   *  false.
   */
  tryRemoveTokens: function(count) {
    // Make sure the request isn't for more than we can handle
    if (count > this.tokenBucket.bucketSize)
      return false;

    var now = getMilliseconds();

    // Advance the current interval and reset the current interval token count
    // if needed
    if (now < this.curIntervalStart
      || now - this.curIntervalStart >= this.tokenBucket.interval) {
      this.curIntervalStart = now;
      this.tokensThisInterval = 0;
    }

    // If we don't have enough tokens left in this interval, return false
    if (count > this.tokenBucket.tokensPerInterval - this.tokensThisInterval)
      return false;

    // Try to remove the requested number of tokens from the token bucket
    var removed = this.tokenBucket.tryRemoveTokens(count);
    if (removed) {
      this.tokensThisInterval += count;
    }
    return removed;
  },

  /**
   * Returns the number of tokens remaining in the TokenBucket.
   * @returns {Number} The number of tokens remaining.
   */
  getTokensRemaining: function () {
    this.tokenBucket.drip();
    return this.tokenBucket.content;
  }
};

module.exports = RateLimiter;


/***/ }),

/***/ 14976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);

/**
 * A hierarchical token bucket for rate limiting. See
 * http://en.wikipedia.org/wiki/Token_bucket for more information.
 * @author John Hurliman <jhurliman@cull.tv>
 *
 * @param {Number} bucketSize Maximum number of tokens to hold in the bucket.
 *  Also known as the burst rate.
 * @param {Number} tokensPerInterval Number of tokens to drip into the bucket
 *  over the course of one interval.
 * @param {String|Number} interval The interval length in milliseconds, or as
 *  one of the following strings: 'second', 'minute', 'hour', day'.
 * @param {TokenBucket} parentBucket Optional. A token bucket that will act as
 *  the parent of this bucket.
 */
var TokenBucket = function(bucketSize, tokensPerInterval, interval, parentBucket) {
  this.bucketSize = bucketSize;
  this.tokensPerInterval = tokensPerInterval;

  if (typeof interval === 'string') {
    switch (interval) {
      case 'sec': case 'second':
        this.interval = 1000; break;
      case 'min': case 'minute':
        this.interval = 1000 * 60; break;
      case 'hr': case 'hour':
        this.interval = 1000 * 60 * 60; break;
      case 'day':
        this.interval = 1000 * 60 * 60 * 24; break;
      default:
        throw new Error('Invaid interval ' + interval);
    }
  } else {
    this.interval = interval;
  }

  this.parentBucket = parentBucket;
  this.content = 0;
  this.lastDrip = +new Date();
};

TokenBucket.prototype = {
  bucketSize: 1,
  tokensPerInterval: 1,
  interval: 1000,
  parentBucket: null,
  content: 0,
  lastDrip: 0,

  /**
   * Remove the requested number of tokens and fire the given callback. If the
   * bucket (and any parent buckets) contains enough tokens this will happen
   * immediately. Otherwise, the removal and callback will happen when enough
   * tokens become available.
   * @param {Number} count The number of tokens to remove.
   * @param {Function} callback(err, remainingTokens)
   * @returns {Boolean} True if the callback was fired immediately, otherwise
   *  false.
   */
  removeTokens: function(count, callback) {
    var self = this;

    // Is this an infinite size bucket?
    if (!this.bucketSize) {
      process.nextTick(callback.bind(null, null, count, Number.POSITIVE_INFINITY));
      return true;
    }

    // Make sure the bucket can hold the requested number of tokens
    if (count > this.bucketSize) {
      process.nextTick(callback.bind(null, 'Requested tokens ' + count + ' exceeds bucket size ' +
        this.bucketSize, null));
      return false;
    }

    // Drip new tokens into this bucket
    this.drip();

    // If we don't have enough tokens in this bucket, come back later
    if (count > this.content)
      return comeBackLater();

    if (this.parentBucket) {
      // Remove the requested from the parent bucket first
      return this.parentBucket.removeTokens(count, function(err, remainingTokens) {
        if (err) return callback(err, null);

        // Check that we still have enough tokens in this bucket
        if (count > self.content)
          return comeBackLater();

        // Tokens were removed from the parent bucket, now remove them from
        // this bucket and fire the callback. Note that we look at the current
        // bucket and parent bucket's remaining tokens and return the smaller
        // of the two values
        self.content -= count;
        callback(null, Math.min(remainingTokens, self.content));
      });
    } else {
      // Remove the requested tokens from this bucket and fire the callback
      this.content -= count;
      process.nextTick(callback.bind(null, null, this.content));
      return true;
    }

    function comeBackLater() {
      // How long do we need to wait to make up the difference in tokens?
      var waitInterval = Math.ceil(
        (count - self.content) * (self.interval / self.tokensPerInterval));
      setTimeout(function() { self.removeTokens(count, callback); }, waitInterval);
      return false;
    }
  },

  /**
   * Attempt to remove the requested number of tokens and return immediately.
   * If the bucket (and any parent buckets) contains enough tokens this will
   * return true, otherwise false is returned.
   * @param {Number} count The number of tokens to remove.
   * @param {Boolean} True if the tokens were successfully removed, otherwise
   *  false.
   */
  tryRemoveTokens: function(count) {
    // Is this an infinite size bucket?
    if (!this.bucketSize)
      return true;

    // Make sure the bucket can hold the requested number of tokens
    if (count > this.bucketSize)
      return false;

    // Drip new tokens into this bucket
    this.drip();

    // If we don't have enough tokens in this bucket, return false
    if (count > this.content)
      return false;

    // Try to remove the requested tokens from the parent bucket
    if (this.parentBucket && !this.parentBucket.tryRemoveTokens(count))
      return false;

    // Remove the requested tokens from this bucket and return
    this.content -= count;
    return true;
  },

  /**
   * Add any new tokens to the bucket since the last drip.
   * @returns {Boolean} True if new tokens were added, otherwise false.
   */
  drip: function() {
    if (!this.tokensPerInterval) {
      this.content = this.bucketSize;
      return;
    }

    var now = +new Date();
    var deltaMS = Math.max(now - this.lastDrip, 0);
    this.lastDrip = now;

    var dripAmount = deltaMS * (this.tokensPerInterval / this.interval);
    this.content = Math.min(this.content + dripAmount, this.bucketSize);
  }
};

module.exports = TokenBucket;


/***/ }),

/***/ 83465:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/**
 * Adds the key-value `pair` to `map`.
 *
 * @private
 * @param {Object} map The map to modify.
 * @param {Array} pair The key-value pair to add.
 * @returns {Object} Returns `map`.
 */
function addMapEntry(map, pair) {
  // Don't return `map.set` because it's not chainable in IE 11.
  map.set(pair[0], pair[1]);
  return map;
}

/**
 * Adds `value` to `set`.
 *
 * @private
 * @param {Object} set The set to modify.
 * @param {*} value The value to add.
 * @returns {Object} Returns `set`.
 */
function addSetEntry(set, value) {
  // Don't return `set.add` because it's not chainable in IE 11.
  set.add(value);
  return set;
}

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array ? array.length : 0;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

/** Used for built-in method references. */
var arrayProto = Array.prototype,
    funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    Symbol = root.Symbol,
    Uint8Array = root.Uint8Array,
    getPrototype = overArg(Object.getPrototypeOf, Object),
    objectCreate = Object.create,
    propertyIsEnumerable = objectProto.propertyIsEnumerable,
    splice = arrayProto.splice;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols,
    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
    nativeKeys = overArg(Object.keys, Object);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView'),
    Map = getNative(root, 'Map'),
    Promise = getNative(root, 'Promise'),
    Set = getNative(root, 'Set'),
    WeakMap = getNative(root, 'WeakMap'),
    nativeCreate = getNative(Object, 'create');

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
}

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  return this.has(key) && delete this.__data__[key];
}

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
}

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
}

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  return true;
}

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries ? entries.length : 0;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  return getMapData(this, key)['delete'](key);
}

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  getMapData(this, key).set(key, value);
  return this;
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  this.__data__ = new ListCache(entries);
}

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
}

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  return this.__data__['delete'](key);
}

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var cache = this.__data__;
  if (cache instanceof ListCache) {
    var pairs = cache.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      return this;
    }
    cache = this.__data__ = new MapCache(pairs);
  }
  cache.set(key, value);
  return this;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    object[key] = value;
  }
}

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @param {boolean} [isFull] Specify a clone including symbols.
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
  var result;
  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      if (isHostObject(value)) {
        return object ? value : {};
      }
      result = initCloneObject(isFunc ? {} : value);
      if (!isDeep) {
        return copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, baseClone, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (!isArr) {
    var props = isFull ? getAllKeys(value) : keys(value);
  }
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
  });
  return result;
}

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} prototype The object to inherit from.
 * @returns {Object} Returns the new object.
 */
function baseCreate(proto) {
  return isObject(proto) ? objectCreate(proto) : {};
}

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

/**
 * The base implementation of `getTag`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  return objectToString.call(value);
}

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var result = new buffer.constructor(buffer.length);
  buffer.copy(result);
  return result;
}

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

/**
 * Creates a clone of `map`.
 *
 * @private
 * @param {Object} map The map to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned map.
 */
function cloneMap(map, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
  return arrayReduce(array, addMapEntry, new map.constructor);
}

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

/**
 * Creates a clone of `set`.
 *
 * @private
 * @param {Object} set The set to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned set.
 */
function cloneSet(set, isDeep, cloneFunc) {
  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
  return arrayReduce(array, addSetEntry, new set.constructor);
}

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    assignValue(object, key, newValue === undefined ? source[key] : newValue);
  }
  return object;
}

/**
 * Copies own symbol properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

/**
 * Creates an array of the own enumerable symbol properties of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11,
// for data views in Edge < 14, and promises in Node.js.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = objectToString.call(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : undefined;

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {Function} cloneFunc The function to clone values.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, cloneFunc, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return cloneMap(object, isDeep, cloneFunc);

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return cloneSet(object, isDeep, cloneFunc);

    case symbolTag:
      return cloneSymbol(object);
  }
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to process.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, true, true);
}

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = cloneDeep;


/***/ }),

/***/ 28922:
/***/ (function(module) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array ? array.length : 0,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  if (value !== value) {
    return baseFindIndex(array, baseIsNaN, fromIndex);
  }
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object),
    nativeMax = Math.max;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  // Safari 9 makes `arguments.length` enumerable in strict mode.
  var result = (isArray(value) || isArguments(value))
    ? baseTimes(value.length, String)
    : [];

  var length = result.length,
      skipIndexes = !!length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
      result.push(key);
    }
  }
  return result;
}

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  length = length == null ? MAX_SAFE_INTEGER : length;
  return !!length &&
    (typeof value == 'number' || reIsUint.test(value)) &&
    (value > -1 && value % 1 == 0 && value < length);
}

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
function isArguments(value) {
  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
}

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8-9 which returns 'object' for typed array and other constructors.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
}

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object ? baseValues(object, keys(object)) : [];
}

module.exports = includes;


/***/ }),

/***/ 48094:
/***/ (function(module) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && objectToString.call(value) == boolTag);
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

module.exports = isBoolean;


/***/ }),

/***/ 55928:
/***/ (function(module) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is an integer.
 *
 * **Note:** This method is based on
 * [`Number.isInteger`](https://mdn.io/Number/isInteger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
 * @example
 *
 * _.isInteger(3);
 * // => true
 *
 * _.isInteger(Number.MIN_VALUE);
 * // => false
 *
 * _.isInteger(Infinity);
 * // => false
 *
 * _.isInteger('3');
 * // => false
 */
function isInteger(value) {
  return typeof value == 'number' && value == toInteger(value);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = isInteger;


/***/ }),

/***/ 23126:
/***/ (function(module) {

/**
 * lodash 3.0.3 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var numberTag = '[object Number]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are classified
 * as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */
function isNumber(value) {
  return typeof value == 'number' ||
    (isObjectLike(value) && objectToString.call(value) == numberTag);
}

module.exports = isNumber;


/***/ }),

/***/ 8146:
/***/ (function(module) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/**
 * Checks if `value` is a host object in IE < 9.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
 */
function isHostObject(value) {
  // Many host objects are `Object` objects that can coerce to strings
  // despite having improperly defined `toString` methods.
  var result = false;
  if (value != null && typeof value.toString != 'function') {
    try {
      result = !!(value + '');
    } catch (e) {}
  }
  return result;
}

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) ||
      objectToString.call(value) != objectTag || isHostObject(value)) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return (typeof Ctor == 'function' &&
    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
}

module.exports = isPlainObject;


/***/ }),

/***/ 25751:
/***/ (function(module) {

/**
 * lodash 4.0.1 (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright 2012-2016 The Dojo Foundation <http://dojofoundation.org/>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright 2009-2016 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 * Available under MIT license <https://lodash.com/license>
 */

/** `Object#toString` result references. */
var stringTag = '[object String]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the [`toStringTag`](http://ecma-international.org/ecma-262/6.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @type Function
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is correctly classified, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && objectToString.call(value) == stringTag);
}

module.exports = isString;


/***/ }),

/***/ 38917:
/***/ (function(module) {

/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/**
 * Creates a function that invokes `func`, with the `this` binding and arguments
 * of the created function, while it's called less than `n` times. Subsequent
 * calls to the created function return the result of the last `func` invocation.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {number} n The number of calls at which `func` is no longer invoked.
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * jQuery(element).on('click', _.before(5, addContactToList));
 * // => Allows adding up to 4 contacts to the list.
 */
function before(n, func) {
  var result;
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  n = toInteger(n);
  return function() {
    if (--n > 0) {
      result = func.apply(this, arguments);
    }
    if (n <= 1) {
      func = undefined;
    }
    return result;
  };
}

/**
 * Creates a function that is restricted to invoking `func` once. Repeat calls
 * to the function return the value of the first invocation. The `func` is
 * invoked with the `this` binding and arguments of the created function.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new restricted function.
 * @example
 *
 * var initialize = _.once(createApplication);
 * initialize();
 * initialize();
 * // => `createApplication` is invoked once
 */
function once(func) {
  return before(2, func);
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = once;


/***/ }),

/***/ 83099:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var lru_cache_1 = __importDefault(__webpack_require__(7659));
var events_1 = __webpack_require__(17187);
var lodash_clonedeep_1 = __importDefault(__webpack_require__(83465));
var freeze_1 = __webpack_require__(19265);
var sync_1 = __webpack_require__(90886);
function asyncMemoizer(options) {
    var cache = new lru_cache_1.default(options);
    var load = options.load;
    var hash = options.hash;
    var bypass = options.bypass;
    var itemMaxAge = options.itemMaxAge;
    var freeze = options.freeze;
    var clone = options.clone;
    var queueMaxAge = options.queueMaxAge || 1000;
    var loading = new Map();
    var emitter = new events_1.EventEmitter();
    var memoizerMethods = Object.assign({
        del: del,
        reset: function () { return cache.reset(); },
        keys: cache.keys.bind(cache),
        on: emitter.on.bind(emitter),
        once: emitter.once.bind(emitter)
    }, options);
    if (options.disable) {
        return Object.assign(load, memoizerMethods);
    }
    function del() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var key = hash.apply(void 0, __spread(args));
        cache.del(key);
    }
    function add(key, parameters, result) {
        if (freeze) {
            result.forEach(freeze_1.deepFreeze);
        }
        if (itemMaxAge) {
            cache.set(key, result, itemMaxAge.apply(void 0, __spread(parameters.concat(result))));
        }
        else {
            cache.set(key, result);
        }
    }
    function runCallbacks(callbacks, args) {
        var e_1, _a;
        try {
            for (var callbacks_1 = __values(callbacks), callbacks_1_1 = callbacks_1.next(); !callbacks_1_1.done; callbacks_1_1 = callbacks_1.next()) {
                var callback = callbacks_1_1.value;
                // Simulate async call when returning from cache
                // and yield between callback resolution
                if (clone) {
                    setImmediate.apply(void 0, __spread([callback], args.map(lodash_clonedeep_1.default)));
                }
                else {
                    setImmediate.apply(void 0, __spread([callback], args));
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (callbacks_1_1 && !callbacks_1_1.done && (_a = callbacks_1.return)) _a.call(callbacks_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    function emit(event) {
        var parameters = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            parameters[_i - 1] = arguments[_i];
        }
        emitter.emit.apply(emitter, __spread([event], parameters));
    }
    function memoizedFunction() {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var parameters = args.slice(0, -1);
        var callback = args.slice(-1).pop();
        var key;
        if (bypass && bypass.apply(void 0, __spread(parameters))) {
            emit.apply(void 0, __spread(['miss'], parameters));
            return load.apply(void 0, __spread(args));
        }
        if (parameters.length === 0 && !hash) {
            //the load function only receives callback.
            key = '_';
        }
        else {
            key = hash.apply(void 0, __spread(parameters));
        }
        var fromCache = cache.get(key);
        if (fromCache) {
            emit.apply(void 0, __spread(['hit'], parameters));
            // found, invoke callback
            return runCallbacks([callback], [null].concat(fromCache));
        }
        var pendingLoad = loading.get(key);
        if (pendingLoad && pendingLoad.expiresAt > Date.now()) {
            // request already in progress, queue and return
            pendingLoad.queue.push(callback);
            emit.apply(void 0, __spread(['queue'], parameters));
            return;
        }
        emit.apply(void 0, __spread(['miss'], parameters));
        var started = Date.now();
        // no pending request or not resolved before expiration
        // create a new queue and invoke load
        var queue = [callback];
        loading.set(key, {
            queue: queue,
            expiresAt: started + queueMaxAge
        });
        var loadHandler = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var err = args[0];
            if (!err) {
                add(key, parameters, args.slice(1));
            }
            // this can potentially delete a different queue than `queue` if
            // this callback was called after expiration.
            // that will only cause a new call to be performed and a new queue to be
            // created
            loading.delete(key);
            emit.apply(void 0, __spread(['loaded', Date.now() - started], parameters));
            runCallbacks(queue, args);
        };
        load.apply(void 0, __spread(parameters, [loadHandler]));
    }
    ;
    return Object.assign(memoizedFunction, memoizerMethods);
}
exports.asyncMemoizer = asyncMemoizer;
asyncMemoizer.sync = sync_1.syncMemoizer;
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 19265:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];

// From https://raw.githubusercontent.com/nikoskalogridis/deep-freeze/fb921b32064dce1645197be2bf975fe0385450b0/index.js
// which is sadly, no longer maintained
Object.defineProperty(exports, "__esModule", ({ value: true }));
function deepFreeze(o) {
    if (o) {
        Object.freeze(o);
        Object.getOwnPropertyNames(o).forEach(function (prop) {
            if (o.hasOwnProperty(prop)
                && o[prop] !== null
                && (typeof o[prop] === 'object' || typeof o[prop] === 'function')
                && (o[prop].constructor !== Buffer)
                && !Object.isFrozen(o[prop])) {
                deepFreeze(o[prop]);
            }
        });
    }
    return o;
}
exports.deepFreeze = deepFreeze;
;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZnJlZXplLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vc3JjL2ZyZWV6ZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUEsdUhBQXVIO0FBQ3ZILHVDQUF1Qzs7QUFFdkMsU0FBZ0IsVUFBVSxDQUFFLENBQU07SUFDaEMsSUFBSSxDQUFDLEVBQUU7UUFDTCxNQUFNLENBQUMsTUFBTSxDQUFDLENBQUMsQ0FBQyxDQUFDO1FBRWpCLE1BQU0sQ0FBQyxtQkFBbUIsQ0FBQyxDQUFDLENBQUMsQ0FBQyxPQUFPLENBQUMsVUFBVSxJQUFJO1lBQ2xELElBQUksQ0FBQyxDQUFDLGNBQWMsQ0FBQyxJQUFJLENBQUM7bUJBQ3JCLENBQUMsQ0FBQyxJQUFJLENBQUMsS0FBSyxJQUFJO21CQUNoQixDQUFDLE9BQU8sQ0FBQyxDQUFDLElBQUksQ0FBQyxLQUFLLFFBQVEsSUFBSSxPQUFPLENBQUMsQ0FBQyxJQUFJLENBQUMsS0FBSyxVQUFVLENBQUM7bUJBQzlELENBQUMsQ0FBQyxDQUFDLElBQUksQ0FBQyxDQUFDLFdBQVcsS0FBSyxNQUFNLENBQUM7bUJBQ2hDLENBQUMsTUFBTSxDQUFDLFFBQVEsQ0FBQyxDQUFDLENBQUMsSUFBSSxDQUFDLENBQUMsRUFBRTtnQkFDNUIsVUFBVSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDO2FBQ3JCO1FBQ0wsQ0FBQyxDQUFDLENBQUM7S0FDSjtJQUVELE9BQU8sQ0FBQyxDQUFDO0FBQ1gsQ0FBQztBQWhCRCxnQ0FnQkM7QUFBQSxDQUFDIn0=

/***/ }),

/***/ 39723:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var async_1 = __webpack_require__(83099);
module.exports = async_1.asyncMemoizer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvaW5kZXgudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUFBLGlDQUF3QztBQUV4QyxpQkFBUyxxQkFBYSxDQUFDIn0=

/***/ }),

/***/ 90886:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", ({ value: true }));
var lru_cache_1 = __importDefault(__webpack_require__(7659));
var events_1 = __webpack_require__(17187);
var lodash_clonedeep_1 = __importDefault(__webpack_require__(83465));
var freeze_1 = __webpack_require__(19265);
function syncMemoizer(options) {
    var cache = new lru_cache_1.default(options);
    var load = options.load;
    var hash = options.hash;
    var bypass = options.bypass;
    var itemMaxAge = options.itemMaxAge;
    var freeze = options.freeze;
    var clone = options.clone;
    var emitter = new events_1.EventEmitter();
    var defaultResult = Object.assign({
        del: del,
        reset: function () { return cache.reset(); },
        keys: cache.keys.bind(cache),
        on: emitter.on.bind(emitter),
        once: emitter.once.bind(emitter)
    }, options);
    if (options.disable) {
        return Object.assign(load, defaultResult);
    }
    function del() {
        var key = hash.apply(void 0, __spread(arguments));
        cache.del(key);
    }
    function emit(event) {
        var parameters = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            parameters[_i - 1] = arguments[_i];
        }
        emitter.emit.apply(emitter, __spread([event], parameters));
    }
    function isPromise(result) {
        // detect native, bluebird, A+ promises
        return result && result.then && typeof result.then === 'function';
    }
    function processResult(result) {
        var res = result;
        if (clone) {
            if (isPromise(res)) {
                res = res.then(lodash_clonedeep_1.default);
            }
            else {
                res = lodash_clonedeep_1.default(res);
            }
        }
        if (freeze) {
            if (isPromise(res)) {
                res = res.then(freeze_1.deepFreeze);
            }
            else {
                freeze_1.deepFreeze(res);
            }
        }
        return res;
    }
    var result = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        if (bypass && bypass.apply(void 0, __spread(args))) {
            emit.apply(void 0, __spread(['miss'], args));
            return load.apply(void 0, __spread(args));
        }
        var key = hash.apply(void 0, __spread(args));
        var fromCache = cache.get(key);
        if (fromCache) {
            emit.apply(void 0, __spread(['hit'], args));
            return processResult(fromCache);
        }
        emit.apply(void 0, __spread(['miss'], args));
        var result = load.apply(void 0, __spread(args));
        if (itemMaxAge) {
            // @ts-ignore
            cache.set(key, result, itemMaxAge.apply(void 0, __spread(args.concat([result]))));
        }
        else {
            cache.set(key, result);
        }
        return processResult(result);
    };
    return Object.assign(result, defaultResult);
}
exports.syncMemoizer = syncMemoizer;
//# sourceMappingURL=data:application/json;base64,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

/***/ }),

/***/ 7659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = LRUCache

// This will be a proper iterable 'Map' in engines that support it,
// or a fakey-fake PseudoMap in older versions.
var Map = __webpack_require__(69246)
var util = __webpack_require__(79720)

// A linked list to keep track of recently-used-ness
var Yallist = __webpack_require__(40214)

// use symbols if possible, otherwise just _props
var symbols = {}
var hasSymbol = typeof Symbol === 'function'
var makeSymbol
/* istanbul ignore if */
if (hasSymbol) {
  makeSymbol = function (key) {
    return Symbol.for(key)
  }
} else {
  makeSymbol = function (key) {
    return '_' + key
  }
}

function priv (obj, key, val) {
  var sym
  if (symbols[key]) {
    sym = symbols[key]
  } else {
    sym = makeSymbol(key)
    symbols[key] = sym
  }
  if (arguments.length === 2) {
    return obj[sym]
  } else {
    obj[sym] = val
    return val
  }
}

function naiveLength () { return 1 }

// lruList is a yallist where the head is the youngest
// item, and the tail is the oldest.  the list contains the Hit
// objects as the entries.
// Each Hit object has a reference to its Yallist.Node.  This
// never changes.
//
// cache is a Map (or PseudoMap) that matches the keys to
// the Yallist.Node object.
function LRUCache (options) {
  if (!(this instanceof LRUCache)) {
    return new LRUCache(options)
  }

  if (typeof options === 'number') {
    options = { max: options }
  }

  if (!options) {
    options = {}
  }

  var max = priv(this, 'max', options.max)
  // Kind of weird to have a default max of Infinity, but oh well.
  if (!max ||
      !(typeof max === 'number') ||
      max <= 0) {
    priv(this, 'max', Infinity)
  }

  var lc = options.length || naiveLength
  if (typeof lc !== 'function') {
    lc = naiveLength
  }
  priv(this, 'lengthCalculator', lc)

  priv(this, 'allowStale', options.stale || false)
  priv(this, 'maxAge', options.maxAge || 0)
  priv(this, 'dispose', options.dispose)
  this.reset()
}

// resize the cache when the max changes.
Object.defineProperty(LRUCache.prototype, 'max', {
  set: function (mL) {
    if (!mL || !(typeof mL === 'number') || mL <= 0) {
      mL = Infinity
    }
    priv(this, 'max', mL)
    trim(this)
  },
  get: function () {
    return priv(this, 'max')
  },
  enumerable: true
})

Object.defineProperty(LRUCache.prototype, 'allowStale', {
  set: function (allowStale) {
    priv(this, 'allowStale', !!allowStale)
  },
  get: function () {
    return priv(this, 'allowStale')
  },
  enumerable: true
})

Object.defineProperty(LRUCache.prototype, 'maxAge', {
  set: function (mA) {
    if (!mA || !(typeof mA === 'number') || mA < 0) {
      mA = 0
    }
    priv(this, 'maxAge', mA)
    trim(this)
  },
  get: function () {
    return priv(this, 'maxAge')
  },
  enumerable: true
})

// resize the cache when the lengthCalculator changes.
Object.defineProperty(LRUCache.prototype, 'lengthCalculator', {
  set: function (lC) {
    if (typeof lC !== 'function') {
      lC = naiveLength
    }
    if (lC !== priv(this, 'lengthCalculator')) {
      priv(this, 'lengthCalculator', lC)
      priv(this, 'length', 0)
      priv(this, 'lruList').forEach(function (hit) {
        hit.length = priv(this, 'lengthCalculator').call(this, hit.value, hit.key)
        priv(this, 'length', priv(this, 'length') + hit.length)
      }, this)
    }
    trim(this)
  },
  get: function () { return priv(this, 'lengthCalculator') },
  enumerable: true
})

Object.defineProperty(LRUCache.prototype, 'length', {
  get: function () { return priv(this, 'length') },
  enumerable: true
})

Object.defineProperty(LRUCache.prototype, 'itemCount', {
  get: function () { return priv(this, 'lruList').length },
  enumerable: true
})

LRUCache.prototype.rforEach = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = priv(this, 'lruList').tail; walker !== null;) {
    var prev = walker.prev
    forEachStep(this, fn, walker, thisp)
    walker = prev
  }
}

function forEachStep (self, fn, node, thisp) {
  var hit = node.value
  if (isStale(self, hit)) {
    del(self, node)
    if (!priv(self, 'allowStale')) {
      hit = undefined
    }
  }
  if (hit) {
    fn.call(thisp, hit.value, hit.key, self)
  }
}

LRUCache.prototype.forEach = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = priv(this, 'lruList').head; walker !== null;) {
    var next = walker.next
    forEachStep(this, fn, walker, thisp)
    walker = next
  }
}

LRUCache.prototype.keys = function () {
  return priv(this, 'lruList').toArray().map(function (k) {
    return k.key
  }, this)
}

LRUCache.prototype.values = function () {
  return priv(this, 'lruList').toArray().map(function (k) {
    return k.value
  }, this)
}

LRUCache.prototype.reset = function () {
  if (priv(this, 'dispose') &&
      priv(this, 'lruList') &&
      priv(this, 'lruList').length) {
    priv(this, 'lruList').forEach(function (hit) {
      priv(this, 'dispose').call(this, hit.key, hit.value)
    }, this)
  }

  priv(this, 'cache', new Map()) // hash of items by key
  priv(this, 'lruList', new Yallist()) // list of items in order of use recency
  priv(this, 'length', 0) // length of items in the list
}

LRUCache.prototype.dump = function () {
  return priv(this, 'lruList').map(function (hit) {
    if (!isStale(this, hit)) {
      return {
        k: hit.key,
        v: hit.value,
        e: hit.now + (hit.maxAge || 0)
      }
    }
  }, this).toArray().filter(function (h) {
    return h
  })
}

LRUCache.prototype.dumpLru = function () {
  return priv(this, 'lruList')
}

LRUCache.prototype.inspect = function (n, opts) {
  var str = 'LRUCache {'
  var extras = false

  var as = priv(this, 'allowStale')
  if (as) {
    str += '\n  allowStale: true'
    extras = true
  }

  var max = priv(this, 'max')
  if (max && max !== Infinity) {
    if (extras) {
      str += ','
    }
    str += '\n  max: ' + util.inspect(max, opts)
    extras = true
  }

  var maxAge = priv(this, 'maxAge')
  if (maxAge) {
    if (extras) {
      str += ','
    }
    str += '\n  maxAge: ' + util.inspect(maxAge, opts)
    extras = true
  }

  var lc = priv(this, 'lengthCalculator')
  if (lc && lc !== naiveLength) {
    if (extras) {
      str += ','
    }
    str += '\n  length: ' + util.inspect(priv(this, 'length'), opts)
    extras = true
  }

  var didFirst = false
  priv(this, 'lruList').forEach(function (item) {
    if (didFirst) {
      str += ',\n  '
    } else {
      if (extras) {
        str += ',\n'
      }
      didFirst = true
      str += '\n  '
    }
    var key = util.inspect(item.key).split('\n').join('\n  ')
    var val = { value: item.value }
    if (item.maxAge !== maxAge) {
      val.maxAge = item.maxAge
    }
    if (lc !== naiveLength) {
      val.length = item.length
    }
    if (isStale(this, item)) {
      val.stale = true
    }

    val = util.inspect(val, opts).split('\n').join('\n  ')
    str += key + ' => ' + val
  })

  if (didFirst || extras) {
    str += '\n'
  }
  str += '}'

  return str
}

LRUCache.prototype.set = function (key, value, maxAge) {
  maxAge = maxAge || priv(this, 'maxAge')

  var now = maxAge ? Date.now() : 0
  var len = priv(this, 'lengthCalculator').call(this, value, key)

  if (priv(this, 'cache').has(key)) {
    if (len > priv(this, 'max')) {
      del(this, priv(this, 'cache').get(key))
      return false
    }

    var node = priv(this, 'cache').get(key)
    var item = node.value

    // dispose of the old one before overwriting
    if (priv(this, 'dispose')) {
      priv(this, 'dispose').call(this, key, item.value)
    }

    item.now = now
    item.maxAge = maxAge
    item.value = value
    priv(this, 'length', priv(this, 'length') + (len - item.length))
    item.length = len
    this.get(key)
    trim(this)
    return true
  }

  var hit = new Entry(key, value, len, now, maxAge)

  // oversized objects fall out of cache automatically.
  if (hit.length > priv(this, 'max')) {
    if (priv(this, 'dispose')) {
      priv(this, 'dispose').call(this, key, value)
    }
    return false
  }

  priv(this, 'length', priv(this, 'length') + hit.length)
  priv(this, 'lruList').unshift(hit)
  priv(this, 'cache').set(key, priv(this, 'lruList').head)
  trim(this)
  return true
}

LRUCache.prototype.has = function (key) {
  if (!priv(this, 'cache').has(key)) return false
  var hit = priv(this, 'cache').get(key).value
  if (isStale(this, hit)) {
    return false
  }
  return true
}

LRUCache.prototype.get = function (key) {
  return get(this, key, true)
}

LRUCache.prototype.peek = function (key) {
  return get(this, key, false)
}

LRUCache.prototype.pop = function () {
  var node = priv(this, 'lruList').tail
  if (!node) return null
  del(this, node)
  return node.value
}

LRUCache.prototype.del = function (key) {
  del(this, priv(this, 'cache').get(key))
}

LRUCache.prototype.load = function (arr) {
  // reset the cache
  this.reset()

  var now = Date.now()
  // A previous serialized cache has the most recent items first
  for (var l = arr.length - 1; l >= 0; l--) {
    var hit = arr[l]
    var expiresAt = hit.e || 0
    if (expiresAt === 0) {
      // the item was created without expiration in a non aged cache
      this.set(hit.k, hit.v)
    } else {
      var maxAge = expiresAt - now
      // dont add already expired items
      if (maxAge > 0) {
        this.set(hit.k, hit.v, maxAge)
      }
    }
  }
}

LRUCache.prototype.prune = function () {
  var self = this
  priv(this, 'cache').forEach(function (value, key) {
    get(self, key, false)
  })
}

function get (self, key, doUse) {
  var node = priv(self, 'cache').get(key)
  if (node) {
    var hit = node.value
    if (isStale(self, hit)) {
      del(self, node)
      if (!priv(self, 'allowStale')) hit = undefined
    } else {
      if (doUse) {
        priv(self, 'lruList').unshiftNode(node)
      }
    }
    if (hit) hit = hit.value
  }
  return hit
}

function isStale (self, hit) {
  if (!hit || (!hit.maxAge && !priv(self, 'maxAge'))) {
    return false
  }
  var stale = false
  var diff = Date.now() - hit.now
  if (hit.maxAge) {
    stale = diff > hit.maxAge
  } else {
    stale = priv(self, 'maxAge') && (diff > priv(self, 'maxAge'))
  }
  return stale
}

function trim (self) {
  if (priv(self, 'length') > priv(self, 'max')) {
    for (var walker = priv(self, 'lruList').tail;
         priv(self, 'length') > priv(self, 'max') && walker !== null;) {
      // We know that we're about to delete this one, and also
      // what the next least recently used key will be, so just
      // go ahead and set it now.
      var prev = walker.prev
      del(self, walker)
      walker = prev
    }
  }
}

function del (self, node) {
  if (node) {
    var hit = node.value
    if (priv(self, 'dispose')) {
      priv(self, 'dispose').call(this, hit.key, hit.value)
    }
    priv(self, 'length', priv(self, 'length') - hit.length)
    priv(self, 'cache').delete(hit.key)
    priv(self, 'lruList').removeNode(node)
  }
}

// classy, since V8 prefers predictable objects.
function Entry (key, value, length, now, maxAge) {
  this.key = key
  this.value = value
  this.length = length
  this.now = now
  this.maxAge = maxAge || 0
}


/***/ }),

/***/ 40214:
/***/ (function(module) {

module.exports = Yallist

Yallist.Node = Node
Yallist.create = Yallist

function Yallist (list) {
  var self = this
  if (!(self instanceof Yallist)) {
    self = new Yallist()
  }

  self.tail = null
  self.head = null
  self.length = 0

  if (list && typeof list.forEach === 'function') {
    list.forEach(function (item) {
      self.push(item)
    })
  } else if (arguments.length > 0) {
    for (var i = 0, l = arguments.length; i < l; i++) {
      self.push(arguments[i])
    }
  }

  return self
}

Yallist.prototype.removeNode = function (node) {
  if (node.list !== this) {
    throw new Error('removing node which does not belong to this list')
  }

  var next = node.next
  var prev = node.prev

  if (next) {
    next.prev = prev
  }

  if (prev) {
    prev.next = next
  }

  if (node === this.head) {
    this.head = next
  }
  if (node === this.tail) {
    this.tail = prev
  }

  node.list.length--
  node.next = null
  node.prev = null
  node.list = null
}

Yallist.prototype.unshiftNode = function (node) {
  if (node === this.head) {
    return
  }

  if (node.list) {
    node.list.removeNode(node)
  }

  var head = this.head
  node.list = this
  node.next = head
  if (head) {
    head.prev = node
  }

  this.head = node
  if (!this.tail) {
    this.tail = node
  }
  this.length++
}

Yallist.prototype.pushNode = function (node) {
  if (node === this.tail) {
    return
  }

  if (node.list) {
    node.list.removeNode(node)
  }

  var tail = this.tail
  node.list = this
  node.prev = tail
  if (tail) {
    tail.next = node
  }

  this.tail = node
  if (!this.head) {
    this.head = node
  }
  this.length++
}

Yallist.prototype.push = function () {
  for (var i = 0, l = arguments.length; i < l; i++) {
    push(this, arguments[i])
  }
  return this.length
}

Yallist.prototype.unshift = function () {
  for (var i = 0, l = arguments.length; i < l; i++) {
    unshift(this, arguments[i])
  }
  return this.length
}

Yallist.prototype.pop = function () {
  if (!this.tail) {
    return undefined
  }

  var res = this.tail.value
  this.tail = this.tail.prev
  if (this.tail) {
    this.tail.next = null
  } else {
    this.head = null
  }
  this.length--
  return res
}

Yallist.prototype.shift = function () {
  if (!this.head) {
    return undefined
  }

  var res = this.head.value
  this.head = this.head.next
  if (this.head) {
    this.head.prev = null
  } else {
    this.tail = null
  }
  this.length--
  return res
}

Yallist.prototype.forEach = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = this.head, i = 0; walker !== null; i++) {
    fn.call(thisp, walker.value, i, this)
    walker = walker.next
  }
}

Yallist.prototype.forEachReverse = function (fn, thisp) {
  thisp = thisp || this
  for (var walker = this.tail, i = this.length - 1; walker !== null; i--) {
    fn.call(thisp, walker.value, i, this)
    walker = walker.prev
  }
}

Yallist.prototype.get = function (n) {
  for (var i = 0, walker = this.head; walker !== null && i < n; i++) {
    // abort out of the list early if we hit a cycle
    walker = walker.next
  }
  if (i === n && walker !== null) {
    return walker.value
  }
}

Yallist.prototype.getReverse = function (n) {
  for (var i = 0, walker = this.tail; walker !== null && i < n; i++) {
    // abort out of the list early if we hit a cycle
    walker = walker.prev
  }
  if (i === n && walker !== null) {
    return walker.value
  }
}

Yallist.prototype.map = function (fn, thisp) {
  thisp = thisp || this
  var res = new Yallist()
  for (var walker = this.head; walker !== null;) {
    res.push(fn.call(thisp, walker.value, this))
    walker = walker.next
  }
  return res
}

Yallist.prototype.mapReverse = function (fn, thisp) {
  thisp = thisp || this
  var res = new Yallist()
  for (var walker = this.tail; walker !== null;) {
    res.push(fn.call(thisp, walker.value, this))
    walker = walker.prev
  }
  return res
}

Yallist.prototype.reduce = function (fn, initial) {
  var acc
  var walker = this.head
  if (arguments.length > 1) {
    acc = initial
  } else if (this.head) {
    walker = this.head.next
    acc = this.head.value
  } else {
    throw new TypeError('Reduce of empty list with no initial value')
  }

  for (var i = 0; walker !== null; i++) {
    acc = fn(acc, walker.value, i)
    walker = walker.next
  }

  return acc
}

Yallist.prototype.reduceReverse = function (fn, initial) {
  var acc
  var walker = this.tail
  if (arguments.length > 1) {
    acc = initial
  } else if (this.tail) {
    walker = this.tail.prev
    acc = this.tail.value
  } else {
    throw new TypeError('Reduce of empty list with no initial value')
  }

  for (var i = this.length - 1; walker !== null; i--) {
    acc = fn(acc, walker.value, i)
    walker = walker.prev
  }

  return acc
}

Yallist.prototype.toArray = function () {
  var arr = new Array(this.length)
  for (var i = 0, walker = this.head; walker !== null; i++) {
    arr[i] = walker.value
    walker = walker.next
  }
  return arr
}

Yallist.prototype.toArrayReverse = function () {
  var arr = new Array(this.length)
  for (var i = 0, walker = this.tail; walker !== null; i++) {
    arr[i] = walker.value
    walker = walker.prev
  }
  return arr
}

Yallist.prototype.slice = function (from, to) {
  to = to || this.length
  if (to < 0) {
    to += this.length
  }
  from = from || 0
  if (from < 0) {
    from += this.length
  }
  var ret = new Yallist()
  if (to < from || to < 0) {
    return ret
  }
  if (from < 0) {
    from = 0
  }
  if (to > this.length) {
    to = this.length
  }
  for (var i = 0, walker = this.head; walker !== null && i < from; i++) {
    walker = walker.next
  }
  for (; walker !== null && i < to; i++, walker = walker.next) {
    ret.push(walker.value)
  }
  return ret
}

Yallist.prototype.sliceReverse = function (from, to) {
  to = to || this.length
  if (to < 0) {
    to += this.length
  }
  from = from || 0
  if (from < 0) {
    from += this.length
  }
  var ret = new Yallist()
  if (to < from || to < 0) {
    return ret
  }
  if (from < 0) {
    from = 0
  }
  if (to > this.length) {
    to = this.length
  }
  for (var i = this.length, walker = this.tail; walker !== null && i > to; i--) {
    walker = walker.prev
  }
  for (; walker !== null && i > from; i--, walker = walker.prev) {
    ret.push(walker.value)
  }
  return ret
}

Yallist.prototype.reverse = function () {
  var head = this.head
  var tail = this.tail
  for (var walker = head; walker !== null; walker = walker.prev) {
    var p = walker.prev
    walker.prev = walker.next
    walker.next = p
  }
  this.head = tail
  this.tail = head
  return this
}

function push (self, item) {
  self.tail = new Node(item, self.tail, null, self)
  if (!self.head) {
    self.head = self.tail
  }
  self.length++
}

function unshift (self, item) {
  self.head = new Node(item, null, self.head, self)
  if (!self.tail) {
    self.tail = self.head
  }
  self.length++
}

function Node (value, prev, next, list) {
  if (!(this instanceof Node)) {
    return new Node(value, prev, next, list)
  }

  this.list = list
  this.value = value

  if (prev) {
    prev.next = this
    this.prev = prev
  } else {
    this.prev = null
  }

  if (next) {
    next.prev = this
    this.next = next
  } else {
    this.next = null
  }
}


/***/ }),

/***/ 57824:
/***/ (function(module) {

/**
 * Helpers.
 */

var s = 1000;
var m = s * 60;
var h = m * 60;
var d = h * 24;
var w = d * 7;
var y = d * 365.25;

/**
 * Parse or format the given `val`.
 *
 * Options:
 *
 *  - `long` verbose formatting [false]
 *
 * @param {String|Number} val
 * @param {Object} [options]
 * @throws {Error} throw an error if val is not a non-empty string or a number
 * @return {String|Number}
 * @api public
 */

module.exports = function(val, options) {
  options = options || {};
  var type = typeof val;
  if (type === 'string' && val.length > 0) {
    return parse(val);
  } else if (type === 'number' && isFinite(val)) {
    return options.long ? fmtLong(val) : fmtShort(val);
  }
  throw new Error(
    'val is not a non-empty string or a valid number. val=' +
      JSON.stringify(val)
  );
};

/**
 * Parse the given `str` and return milliseconds.
 *
 * @param {String} str
 * @return {Number}
 * @api private
 */

function parse(str) {
  str = String(str);
  if (str.length > 100) {
    return;
  }
  var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
    str
  );
  if (!match) {
    return;
  }
  var n = parseFloat(match[1]);
  var type = (match[2] || 'ms').toLowerCase();
  switch (type) {
    case 'years':
    case 'year':
    case 'yrs':
    case 'yr':
    case 'y':
      return n * y;
    case 'weeks':
    case 'week':
    case 'w':
      return n * w;
    case 'days':
    case 'day':
    case 'd':
      return n * d;
    case 'hours':
    case 'hour':
    case 'hrs':
    case 'hr':
    case 'h':
      return n * h;
    case 'minutes':
    case 'minute':
    case 'mins':
    case 'min':
    case 'm':
      return n * m;
    case 'seconds':
    case 'second':
    case 'secs':
    case 'sec':
    case 's':
      return n * s;
    case 'milliseconds':
    case 'millisecond':
    case 'msecs':
    case 'msec':
    case 'ms':
      return n;
    default:
      return undefined;
  }
}

/**
 * Short format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtShort(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return Math.round(ms / d) + 'd';
  }
  if (msAbs >= h) {
    return Math.round(ms / h) + 'h';
  }
  if (msAbs >= m) {
    return Math.round(ms / m) + 'm';
  }
  if (msAbs >= s) {
    return Math.round(ms / s) + 's';
  }
  return ms + 'ms';
}

/**
 * Long format for `ms`.
 *
 * @param {Number} ms
 * @return {String}
 * @api private
 */

function fmtLong(ms) {
  var msAbs = Math.abs(ms);
  if (msAbs >= d) {
    return plural(ms, msAbs, d, 'day');
  }
  if (msAbs >= h) {
    return plural(ms, msAbs, h, 'hour');
  }
  if (msAbs >= m) {
    return plural(ms, msAbs, m, 'minute');
  }
  if (msAbs >= s) {
    return plural(ms, msAbs, s, 'second');
  }
  return ms + ' ms';
}

/**
 * Pluralization helper.
 */

function plural(ms, msAbs, n, name) {
  var isPlural = msAbs >= n * 1.5;
  return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
}


/***/ }),

/***/ 83454:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var ref, ref1;
module.exports = ((ref = __webpack_require__.g.process) === null || ref === void 0 ? void 0 : ref.env) && typeof ((ref1 = __webpack_require__.g.process) === null || ref1 === void 0 ? void 0 : ref1.env) === 'object' ? __webpack_require__.g.process : __webpack_require__(77663);

//# sourceMappingURL=process.js.map

/***/ }),

/***/ 91118:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/_app",
      function () {
        return __webpack_require__(38484);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 9777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ IdentityProvider; },
/* harmony export */   "j": function() { return /* binding */ useIdentity; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(16918);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(17283);
/* harmony import */ var _frontegg_nextjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(38623);
/* harmony import */ var _frontegg_nextjs__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_frontegg_nextjs__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _print_engine_utilities_integrations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79523);
/* harmony import */ var _print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93909);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67294);
/* harmony import */ var _global_loader__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(5121);
/* harmony import */ var _tenantApp_functions_hasuraIntegration__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(29148);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n                        ",
        "\n                    "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}











var IdentityContext = /*#__PURE__*/ react__WEBPACK_IMPORTED_MODULE_7__.createContext();
var useIdentity = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_7__.useContext)(IdentityContext);
};
/**
 * Request for page comes in.
 * https://app.imprintenginedev.io/?ie_redirect=https://something.com
 *
 * If queryParam "redirect" in url, set cookie, redirect to https://something.com
 *
 * Call useAuthUser() and isAuthenticated() from Frontegg/Nextjs, which automatically
 * redirects user to login page, if user not authenticated.
 *
 * useAuth() automatically redirects.
 * useAuthUser() and useIsAuthenticated() do not.
 */ function IdentityProvider() {
    var user_props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var currentEnvironment = "staging" || 0;
    console.log("-Environment name:", "staging", "\n-Hasura endpoint:", "https://graph-stage.hasura.app/v1/graphql");
    var ref3 = (0,_frontegg_nextjs__WEBPACK_IMPORTED_MODULE_3__.useAuth)(), FRONTEGG_user = ref3.user, isAuthenticated = ref3.isAuthenticated; // NO AUTO REDIRECT NOW; CAN HANDLE MANUALLY
    var allCookies;
    var cookieKeyRegex = /ie_redirect=((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
    if (FRONTEGG_user && FRONTEGG_user.email) {
        /* LOGGED IN */ /* User is authenticated.  Check for redirect cookie. */ allCookies = document === null || document === void 0 ? void 0 : document.cookie;
        if (cookieKeyRegex.test(allCookies)) {
            /* REDIRECT */ /* "redirect" cookie, with valid URL present.  Get value, delete cookie, redirect to value. */ var redirectUrl = allCookies.match(cookieKeyRegex)[1];
            /* Remove cookie before redirect, so that it's not present for another session. */ document.cookie = "ie_redirect=;";
            /* Don't allow redirects back to an account/login page */ var validatedRedirectUrl = redirectUrl.replace(/\/account\/login/i, "");
            /* Redirect */ window.location.href = validatedRedirectUrl;
        } else {}
    } else {
        /* NOT LOGGED IN */ if (cookieKeyRegex.test(window.location.search)) {
            /* SET COOKIE AND AUTHENTICATE */ var redirectUrl1 = window.location.search.match(cookieKeyRegex)[1];
            document.cookie = "ie_redirect=".concat(redirectUrl1, ";");
        }
    }
    /* Redirect to account/login AUTOMATICALLY (frontegg/nextjs package) */ FRONTEGG_user = (0,_frontegg_nextjs__WEBPACK_IMPORTED_MODULE_3__.useAuthUser)();
    isAuthenticated = (0,_frontegg_nextjs__WEBPACK_IMPORTED_MODULE_3__.useIsAuthenticated)();
    var request = function() {
        var _ref = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(qry, vrs) {
            var xPimHost, hasuraBaseUrl, config, response;
            return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        xPimHost = /deploy-preview/i.test(window === null || window === void 0 ? void 0 : window.location.hostname) ? "app.imprintengine.pim" : window === null || window === void 0 ? void 0 : window.location.hostname;
                        hasuraBaseUrl = "https://graph-stage.hasura.app/v1/graphql";
                        console.log(hasuraBaseUrl);
                        config = {
                            baseURL: hasuraBaseUrl,
                            headers: {
                                authorization: "Bearer ".concat(FRONTEGG_user.accessToken),
                                "x-pim-host": xPimHost
                            },
                            timeout: 30000,
                            method: "POST",
                            data: {
                                query: (0,graphql__WEBPACK_IMPORTED_MODULE_10__/* .print */ .S)((0,graphql_tag__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .ZP)(_templateObject(), qry)),
                                variables: vrs
                            }
                        };
                        console.log(currentEnvironment, "request.config: ", config);
                        _ctx.prev = 5;
                        _ctx.next = 8;
                        return axios__WEBPACK_IMPORTED_MODULE_2___default()(config);
                    case 8:
                        response = _ctx.sent;
                        return _ctx.abrupt("return", response.data.errors ? response.data : response.data.data);
                    case 12:
                        _ctx.prev = 12;
                        _ctx.t0 = _ctx["catch"](5);
                        // throw e;
                        console.log("e", qry);
                        console.log(_ctx.t0);
                        return _ctx.abrupt("return", _ctx.t0);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    5,
                    12
                ]
            ]);
        }));
        return function request(qry, vrs) {
            return _ref.apply(this, arguments);
        };
    }();
    var pimUserId;
    try {
        var pimUserMetadata = JSON.parse(FRONTEGG_user.metadata);
        pimUserId = pimUserMetadata === null || pimUserMetadata === void 0 ? void 0 : pimUserMetadata.entity_id;
    } catch (e) {
        console.log("COULDNT PARSE JSON FROM FRONTEGG USER METADATA", FRONTEGG_user);
    }
    var integrations1 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(function() {
        if (isAuthenticated && !(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_5__.is_empty)(FRONTEGG_user.accessToken)) {
            var integrations = {
                hasura: {}
            };
            var user_args = {
                environment: currentEnvironment,
                application: "tenant",
                context: "frontend",
                token: FRONTEGG_user.accessToken
            };
            return new _print_engine_utilities_integrations__WEBPACK_IMPORTED_MODULE_4__.Integrations(integrations, user_args);
        } else {
            return {};
        }
    }, [
        user_props,
        FRONTEGG_user,
        isAuthenticated
    ]);
    var default_props = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(function() {
        return {
            api: {
                integrations: {
                    hasura: integrations1.hasura
                }
            }
        };
    }, [
        integrations1
    ]);
    var props = (0,react__WEBPACK_IMPORTED_MODULE_7__.useMemo)(function() {
        return (0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_5__.merge)(default_props, user_props.props);
    }, [
        default_props,
        user_props
    ]);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(null), fetchedUser = ref1[0], setFetchedUser = ref1[1]; // 36
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_7__.useState)(IdentityContext.user), currentUser = ref2[0], setCurrentUser = ref2[1]; //37
    var currentApplication = "tenant";
    var currentHost = window === null || window === void 0 ? void 0 : window.location.host;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var fetchUser = (0,react__WEBPACK_IMPORTED_MODULE_7__.useCallback)(// USER PARAM = FRONTEGG USER DATA
    _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var userParam, ref, response, result, authorizedApplications, legacyUserObject, _args = arguments;
        return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    userParam = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    _ctx.prev = 1;
                    ;
                    _ctx.next = 5;
                    return request(queryGetUserWhereId, {
                        id: pimUserId
                    });
                case 5:
                    response = _ctx.sent;
                    result = response.user;
                    if (result === null || result === void 0 ? void 0 : result.email) {
                        _ctx.next = 10;
                        break;
                    }
                    setFetchedUser(false);
                    return _ctx.abrupt("return", {});
                case 10:
                    if (!(result.email !== userParam.email)) {
                        _ctx.next = 13;
                        break;
                    }
                    setFetchedUser(false);
                    return _ctx.abrupt("return", {});
                case 13:
                    authorizedApplications = {
                        tenant: [],
                        client: []
                    };
                    if (result.user_entities) {
                        result.user_entities.map(function(application) {
                            if (String(application.entity.entity_type.singular_name).toLowerCase() === "tenant") {
                                authorizedApplications.tenant.push(application.entity);
                            }
                            if (String(application.entity.entity_type.singular_name).toLowerCase() === "customer") {
                                authorizedApplications.client.push(application.entity);
                            }
                        });
                    }
                    result.tenant_user = !(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_5__.is_empty)(authorizedApplications.tenant);
                    result.authorizedApplications = authorizedApplications;
                    setFetchedUser(true);
                    legacyUserObject = (0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_5__.merge)(userParam, (0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_5__.merge)(currentUser, result));
                    return _ctx.abrupt("return", _objectSpread({}, legacyUserObject, {
                        pimUser: result,
                        pimTenantId: (ref = result.tenant) === null || ref === void 0 ? void 0 : ref.id
                    }));
                case 22:
                    _ctx.prev = 22;
                    _ctx.t0 = _ctx["catch"](1);
                    console.log(_ctx.t0);
                    setFetchedUser(false);
                case 26:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                1,
                22
            ]
        ]);
    })), [
        currentUser,
        props
    ]);
    /** * If the user is authenticated with FrontEgg, then fetch the user from our database.*/ (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var PIM_user_data, _currentUser, fronteggUserHasAdminRole;
            return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(isAuthenticated === true && fetchedUser === null)) {
                            _ctx.next = 5;
                            break;
                        }
                        _ctx.next = 3;
                        return fetchUser(FRONTEGG_user);
                    case 3:
                        PIM_user_data = _ctx.sent;
                        if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_5__.is_empty)(PIM_user_data)) {
                            _currentUser = (0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_5__.merge)((0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_5__.merge)(currentUser, PIM_user_data), FRONTEGG_user);
                            _currentUser.id = PIM_user_data.id;
                            _currentUser.frontegg_id = FRONTEGG_user.id;
                            fronteggUserHasAdminRole = function(fronteggUser) {
                                return Array.isArray(fronteggUser.roles) && fronteggUser.roles.some(function(role) {
                                    return role.name === "Admin";
                                });
                            };
                            _currentUser.is_super_admin = fronteggUserHasAdminRole(PIM_user_data);
                            setCurrentUser(_currentUser);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, [
        currentUser,
        fetchUser,
        fetchedUser,
        isAuthenticated,
        FRONTEGG_user
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_7__.useEffect)(function() {
        _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var ref, ref4;
            return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!currentEnvironment || !currentApplication)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return", false);
                    case 2:
                        if (!(isAuthenticated === true && fetchedUser === true)) {
                            _ctx.next = 10;
                            break;
                        }
                        ;
                        if (!(((ref = router.query) === null || ref === void 0 ? void 0 : (ref4 = ref.path) === null || ref4 === void 0 ? void 0 : ref4[0]) && router.query.path[0].startsWith("ey"))) {
                            _ctx.next = 7;
                            break;
                        }
                        _ctx.next = 7;
                        return router.push(router.asPath.replace("/".concat(router.query.path[0]), ""));
                    case 7:
                        if (!(router.asPath === "/")) {
                            _ctx.next = 10;
                            break;
                        }
                        _ctx.next = 10;
                        return router.push("/dashboard");
                    case 10:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, [
        isAuthenticated,
        router,
        // currentEntity,
        currentApplication,
        currentUser,
        currentEnvironment,
        fetchedUser, 
    ]);
    if (!currentHost || !currentEnvironment || !currentApplication || !currentUser) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_global_loader__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            classes: "absolute top-5 left-1/2"
        });
    }
    var hasura = (0,_tenantApp_functions_hasuraIntegration__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
        userAccessToken: currentUser === null || currentUser === void 0 ? void 0 : currentUser.accessToken,
        environment: currentEnvironment,
        appName: currentApplication
    }).hasura;
    var appConfig = user_props.props ? user_props.props.app : null;
    var apiConfig = user_props.props ? user_props.props.api : null;
    apiConfig = _objectSpread({}, apiConfig, {
        integrations: {
            hasura: hasura
        }
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(IdentityContext.Provider, {
        value: {
            currentHost: currentHost,
            currentEnvironment: currentEnvironment,
            currentApplication: currentApplication,
            // currentEntity,
            currentUser: currentUser,
            user: currentUser,
            request: request,
            appConfig: appConfig,
            apiConfig: apiConfig
        },
        children: user_props.children
    });
}
var queryGetUserWhereId = 'query GetUserByPk( $id: bigint! ) {\n        user: users_by_pk( id:$id ) {\n            id\n            first_name\n            last_name\n            email\n            cognito_user_id\n            source_ref\n            created_at\n            updated_at\n            active\n            tenant {\n                id\n                name\n                tenant_id\n            }\n            attributes {\n                attribute_id\n                attribute_name\n                attribute_code\n                attribute_value\n                field_type_id\n                field_type\n                entity_attribute_id\n            },\n            user_entities( where: {\n                entity: {\n                    entity_type: {\n                        code: { _in: [ "customer", "tenant", "NETLIFY" ] }\n                    }\n                }\n            } ) {\n                id\n                entity {\n                    id\n                    name\n                    created_at\n                    updated_at\n                    active\n                    entity_type_id\n                    entity_type {\n                        id\n                        name\n                        singular_name\n                        plural_name\n                    }\n                    apps {\n                        domain\n                        sub_domain\n                    }\n                }\n            }\n    }\n    }';


/***/ }),

/***/ 29148:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ hasuraIntegration; }
/* harmony export */ });
/* harmony import */ var _print_engine_utilities_integrations__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79523);

function hasuraIntegration(param) {
    var userAccessToken = param.userAccessToken, environment = param.environment, _appName = param.appName, appName = _appName === void 0 ? "tenant" : _appName;
    var hasura = {
        hasura: {
            load: [
                "orders/orders",
                "organizations/clients",
                "projects/projects",
                "users/users", 
            ]
        }
    };
    var theRest = {
        environment: environment,
        /* THE FOLLOWING COMMENT IS NO LONGER TRUE, SINCE THIS FILE IS USED _IDENTITY / CONTEXT NOW.  ENABLED APPNAME (TENANT|CLIENT|FOUNTANE,ETC...) */ /* WE CAN DO THIS SINCE THIS FILE IS IN THE TENANT APP TREE */ application: appName,
        context: "frontend" /* WE CAN DO THIS SINCE THIS FILE IS IN THE TENANT APP TREE */ ,
        token: userAccessToken
    };
    var hasuraIntegrationObject = new _print_engine_utilities_integrations__WEBPACK_IMPORTED_MODULE_0__.Integrations(hasura, theRest);
    return hasuraIntegrationObject;
};


/***/ }),

/***/ 77403:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoaderSvg; },
/* harmony export */   "h": function() { return /* binding */ defaultStyle; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

var defaultStyle = {
    width: "50px",
    height: "20px",
    display: "inline"
};
function LoaderSvg(param) {
    var _fill = param.fill, fill = _fill === void 0 ? "#000" : _fill, _style = param.style, style = _style === void 0 ? defaultStyle : _style;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        style: style,
        x: "0px",
        y: "0px",
        viewBox: "10 10 60 40",
        enableBackground: "new 0 0 0 0",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "20",
                y: "20",
                width: "4",
                height: "10",
                fill: fill,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                    attributeType: "xml",
                    attributeName: "transform",
                    type: "translate",
                    values: "0 0; 0 20; 0 0",
                    begin: "0",
                    dur: "0.6s",
                    repeatCount: "indefinite"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "30",
                y: "20",
                width: "4",
                height: "10",
                fill: fill,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                    attributeType: "xml",
                    attributeName: "transform",
                    type: "translate",
                    values: "0 0; 0 20; 0 0",
                    begin: "0.2s",
                    dur: "0.6s",
                    repeatCount: "indefinite"
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                x: "40",
                y: "20",
                width: "4",
                height: "10",
                fill: fill,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("animateTransform", {
                    attributeType: "xml",
                    attributeName: "transform",
                    type: "translate",
                    values: "0 0; 0 20; 0 0",
                    begin: "0.4s",
                    dur: "0.6s",
                    repeatCount: "indefinite"
                })
            })
        ]
    });
};


/***/ }),

/***/ 5121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Loader; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



function Loader(user_props) {
    var default_props = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return {
            styles: {},
            classes: "relative inline-block"
        };
    }, []);
    var props = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        return _objectSpread({}, default_props, user_props);
    }, [
        default_props,
        user_props
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "loader ".concat(props["classes"]),
        style: props["styles"],
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                quality: 100,
                className: "icon",
                src: "/logo/svg/Icon_2CPurpleBlack_RGB.svg",
                layout: "responsive",
                width: "2000",
                height: "2000",
                alt: ""
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "ball"
            })
        ]
    });
};


/***/ }),

/***/ 76815:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/buildPolyfills/_optionalChain.js
/**
 * Polyfill for the optional chain operator, `?.`, given previous conversion of the expression into an array of values,
 * descriptors, and functions.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 * See https://github.com/alangpierce/sucrase/blob/265887868966917f3b924ce38dfad01fbab1329f/src/transformers/OptionalChainingNullishTransformer.ts#L15
 *
 * @param ops Array result of expression conversion
 * @returns The value of the expression
 */
function _optionalChain(ops) {
  let lastAccessLHS = undefined;
  let value = ops[0];
  let i = 1;
  while (i < ops.length) {
    const op = ops[i] ;
    const fn = ops[i + 1] ;
    i += 2;
    // by checking for loose equality to `null`, we catch both `null` and `undefined`
    if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
      // really we're meaning to return `undefined` as an actual value here, but it saves bytes not to write it
      return;
    }
    if (op === 'access' || op === 'optionalAccess') {
      lastAccessLHS = value;
      value = fn(value);
    } else if (op === 'call' || op === 'optionalCall') {
      value = fn((...args) => (value ).call(lastAccessLHS, ...args));
      lastAccessLHS = undefined;
    }
  }
  return value;
}

// Sucrase version
// function _optionalChain(ops) {
//   let lastAccessLHS = undefined;
//   let value = ops[0];
//   let i = 1;
//   while (i < ops.length) {
//     const op = ops[i];
//     const fn = ops[i + 1];
//     i += 2;
//     if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) {
//       return undefined;
//     }
//     if (op === 'access' || op === 'optionalAccess') {
//       lastAccessLHS = value;
//       value = fn(value);
//     } else if (op === 'call' || op === 'optionalCall') {
//       value = fn((...args) => value.call(lastAccessLHS, ...args));
//       lastAccessLHS = undefined;
//     }
//   }
//   return value;
// }


//# sourceMappingURL=_optionalChain.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/path.js
// Slightly modified (no IE8 support, ES6) and transcribed to TypeScript
// https://raw.githubusercontent.com/calvinmetcalf/rollup-plugin-node-builtins/master/src/es6/path.js

/** JSDoc */
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  let up = 0;
  for (let i = parts.length - 1; i >= 0; i--) {
    const last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// Split a filename into [root, dir, basename, ext], unix version
// 'root' is just a slash, or nothing.
const splitPathRe = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^/]+?|)(\.[^./]*|))(?:[/]*)$/;
/** JSDoc */
function splitPath(filename) {
  const parts = splitPathRe.exec(filename);
  return parts ? parts.slice(1) : [];
}

// path.resolve([from ...], to)
// posix version
/** JSDoc */
function resolve(...args) {
  let resolvedPath = '';
  let resolvedAbsolute = false;

  for (let i = args.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    const path = i >= 0 ? args[i] : '/';

    // Skip empty entries
    if (!path) {
      continue;
    }

    resolvedPath = `${path}/${resolvedPath}`;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(
    resolvedPath.split('/').filter(p => !!p),
    !resolvedAbsolute,
  ).join('/');

  return (resolvedAbsolute ? '/' : '') + resolvedPath || '.';
}

/** JSDoc */
function trim(arr) {
  let start = 0;
  for (; start < arr.length; start++) {
    if (arr[start] !== '') {
      break;
    }
  }

  let end = arr.length - 1;
  for (; end >= 0; end--) {
    if (arr[end] !== '') {
      break;
    }
  }

  if (start > end) {
    return [];
  }
  return arr.slice(start, end - start + 1);
}

// path.relative(from, to)
// posix version
/** JSDoc */
function relative(from, to) {
  /* eslint-disable no-param-reassign */
  from = resolve(from).substr(1);
  to = resolve(to).substr(1);
  /* eslint-enable no-param-reassign */

  const fromParts = trim(from.split('/'));
  const toParts = trim(to.split('/'));

  const length = Math.min(fromParts.length, toParts.length);
  let samePartsLength = length;
  for (let i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  let outputParts = [];
  for (let i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
}

// path.normalize(path)
// posix version
/** JSDoc */
function normalizePath(path) {
  const isPathAbsolute = isAbsolute(path);
  const trailingSlash = path.substr(-1) === '/';

  // Normalize the path
  let normalizedPath = normalizeArray(
    path.split('/').filter(p => !!p),
    !isPathAbsolute,
  ).join('/');

  if (!normalizedPath && !isPathAbsolute) {
    normalizedPath = '.';
  }
  if (normalizedPath && trailingSlash) {
    normalizedPath += '/';
  }

  return (isPathAbsolute ? '/' : '') + normalizedPath;
}

// posix version
/** JSDoc */
function isAbsolute(path) {
  return path.charAt(0) === '/';
}

// posix version
/** JSDoc */
function join(...args) {
  return normalizePath(args.join('/'));
}

/** JSDoc */
function dirname(path) {
  const result = splitPath(path);
  const root = result[0];
  let dir = result[1];

  if (!root && !dir) {
    // No dirname whatsoever
    return '.';
  }

  if (dir) {
    // It has a dirname, strip trailing slash
    dir = dir.substr(0, dir.length - 1);
  }

  return root + dir;
}

/** JSDoc */
function basename(path, ext) {
  let f = splitPath(path)[2];
  if (ext && f.substr(ext.length * -1) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
}


//# sourceMappingURL=path.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/integrations/esm/rewriteframes.js


/** Rewrite event frames paths */
class RewriteFrames  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'RewriteFrames';}

  /**
   * @inheritDoc
   */
   __init() {this.name = RewriteFrames.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
    __init2() {this._prefix = 'app:///';}

  /**
   * @inheritDoc
   */
   constructor(options = {}) {;RewriteFrames.prototype.__init.call(this);RewriteFrames.prototype.__init2.call(this);RewriteFrames.prototype.__init3.call(this);
    if (options.root) {
      this._root = options.root;
    }
    if (options.prefix) {
      this._prefix = options.prefix;
    }
    if (options.iteratee) {
      this._iteratee = options.iteratee;
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    addGlobalEventProcessor(event => {
      const self = getCurrentHub().getIntegration(RewriteFrames);
      if (self) {
        return self.process(event);
      }
      return event;
    });
  }

  /** JSDoc */
   process(originalEvent) {
    let processedEvent = originalEvent;

    if (originalEvent.exception && Array.isArray(originalEvent.exception.values)) {
      processedEvent = this._processExceptionsEvent(processedEvent);
    }

    return processedEvent;
  }

  /**
   * @inheritDoc
   */
    __init3() {this._iteratee = (frame) => {
    if (!frame.filename) {
      return frame;
    }
    // Check if the frame filename begins with `/` or a Windows-style prefix such as `C:\`
    const isWindowsFrame = /^[A-Z]:\\/.test(frame.filename);
    const startsWithSlash = /^\//.test(frame.filename);
    if (isWindowsFrame || startsWithSlash) {
      const filename = isWindowsFrame
        ? frame.filename
            .replace(/^[A-Z]:/, '') // remove Windows-style prefix
            .replace(/\\/g, '/') // replace all `\\` instances with `/`
        : frame.filename;
      const base = this._root ? relative(this._root, filename) : basename(filename);
      frame.filename = `${this._prefix}${base}`;
    }
    return frame;
  };}

  /** JSDoc */
   _processExceptionsEvent(event) {
    try {
      return {
        ...event,
        exception: {
          ...event.exception,
          // The check for this is performed inside `process` call itself, safe to skip here
          // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
          values: event.exception.values.map(value => ({
            ...value,
            ...(value.stacktrace && { stacktrace: this._processStacktrace(value.stacktrace) }),
          })),
        },
      };
    } catch (_oO) {
      return event;
    }
  }

  /** JSDoc */
   _processStacktrace(stacktrace) {
    return {
      ...stacktrace,
      frames: stacktrace && stacktrace.frames && stacktrace.frames.map(f => this._iteratee(f)),
    };
  }
} RewriteFrames.__initStatic();


//# sourceMappingURL=rewriteframes.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/version.js
const SDK_VERSION = '7.28.1';


//# sourceMappingURL=version.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/misc.js
var misc = __webpack_require__(62844);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var esm_logger = __webpack_require__(12343);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js
var esm_hub = __webpack_require__(95659);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/scope.js
var esm_scope = __webpack_require__(10350);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integration.js




const installedIntegrations = [];

/** Map of integrations assigned to a client */

/**
 * Remove duplicates from the given array, preferring the last instance of any duplicate. Not guaranteed to
 * preseve the order of integrations in the array.
 *
 * @private
 */
function filterDuplicates(integrations) {
  const integrationsByName = {};

  integrations.forEach(currentInstance => {
    const { name } = currentInstance;

    const existingInstance = integrationsByName[name];

    // We want integrations later in the array to overwrite earlier ones of the same type, except that we never want a
    // default instance to overwrite an existing user instance
    if (existingInstance && !existingInstance.isDefaultInstance && currentInstance.isDefaultInstance) {
      return;
    }

    integrationsByName[name] = currentInstance;
  });

  return Object.values(integrationsByName);
}

/** Gets integrations to install */
function getIntegrationsToSetup(options) {
  const defaultIntegrations = options.defaultIntegrations || [];
  const userIntegrations = options.integrations;

  // We flag default instances, so that later we can tell them apart from any user-created instances of the same class
  defaultIntegrations.forEach(integration => {
    integration.isDefaultInstance = true;
  });

  let integrations;

  if (Array.isArray(userIntegrations)) {
    integrations = [...defaultIntegrations, ...userIntegrations];
  } else if (typeof userIntegrations === 'function') {
    integrations = (0,misc/* arrayify */.lE)(userIntegrations(defaultIntegrations));
  } else {
    integrations = defaultIntegrations;
  }

  const finalIntegrations = filterDuplicates(integrations);

  // The `Debug` integration prints copies of the `event` and `hint` which will be passed to `beforeSend` or
  // `beforeSendTransaction`. It therefore has to run after all other integrations, so that the changes of all event
  // processors will be reflected in the printed values. For lack of a more elegant way to guarantee that, we therefore
  // locate it and, assuming it exists, pop it out of its current spot and shove it onto the end of the array.
  const debugIndex = finalIntegrations.findIndex(integration => integration.name === 'Debug');
  if (debugIndex !== -1) {
    const [debugInstance] = finalIntegrations.splice(debugIndex, 1);
    finalIntegrations.push(debugInstance);
  }

  return finalIntegrations;
}

/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(integrations) {
  const integrationIndex = {};

  integrations.forEach(integration => {
    integrationIndex[integration.name] = integration;

    if (installedIntegrations.indexOf(integration.name) === -1) {
      integration.setupOnce(esm_scope/* addGlobalEventProcessor */.c, esm_hub/* getCurrentHub */.Gd);
      installedIntegrations.push(integration.name);
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Integration installed: ${integration.name}`);
    }
  });

  return integrationIndex;
}


//# sourceMappingURL=integration.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/sdk.js



/** A class object that can instantiate Client objects. */

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(
  clientClass,
  options,
) {
  if (options.debug === true) {
    if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
      esm_logger/* logger.enable */.kg.enable();
    } else {
      // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
      // eslint-disable-next-line no-console
      console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
    }
  }
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const scope = hub.getScope();
  if (scope) {
    scope.update(options.initialScope);
  }

  const client = new clientClass(options);
  hub.bindClient(client);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/string.js
var string = __webpack_require__(57321);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/inboundfilters.js


// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
const DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];

/** Options for the InboundFilters integration */

/** Inbound filters configurable by the user */
class InboundFilters  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'InboundFilters';}

  /**
   * @inheritDoc
   */
   __init() {this.name = InboundFilters.id;}

   constructor(  _options = {}) {;this._options = _options;InboundFilters.prototype.__init.call(this);}

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const eventProcess = (event) => {
      const hub = getCurrentHub();
      if (hub) {
        const self = hub.getIntegration(InboundFilters);
        if (self) {
          const client = hub.getClient();
          const clientOptions = client ? client.getOptions() : {};
          const options = _mergeOptions(self._options, clientOptions);
          return _shouldDropEvent(event, options) ? null : event;
        }
      }
      return event;
    };

    eventProcess.id = this.name;
    addGlobalEventProcessor(eventProcess);
  }
} InboundFilters.__initStatic();

/** JSDoc */
function _mergeOptions(
  internalOptions = {},
  clientOptions = {},
) {
  return {
    allowUrls: [...(internalOptions.allowUrls || []), ...(clientOptions.allowUrls || [])],
    denyUrls: [...(internalOptions.denyUrls || []), ...(clientOptions.denyUrls || [])],
    ignoreErrors: [
      ...(internalOptions.ignoreErrors || []),
      ...(clientOptions.ignoreErrors || []),
      ...DEFAULT_IGNORE_ERRORS,
    ],
    ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
  };
}

/** JSDoc */
function _shouldDropEvent(event, options) {
  if (options.ignoreInternal && _isSentryError(event)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(`Event dropped due to being internal Sentry Error.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`);
    return true;
  }
  if (_isIgnoredError(event, options.ignoreErrors)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`ignoreErrors\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(event)}`,
      );
    return true;
  }
  if (_isDeniedUrl(event, options.denyUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to being matched by \`denyUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  if (!_isAllowedUrl(event, options.allowUrls)) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn(
        `Event dropped due to not being matched by \`allowUrls\` option.\nEvent: ${(0,misc/* getEventDescription */.jH)(
          event,
        )}.\nUrl: ${_getEventFilterUrl(event)}`,
      );
    return true;
  }
  return false;
}

function _isIgnoredError(event, ignoreErrors) {
  if (!ignoreErrors || !ignoreErrors.length) {
    return false;
  }

  return _getPossibleEventMessages(event).some(message => (0,string/* stringMatchesSomePattern */.U0)(message, ignoreErrors));
}

function _isDeniedUrl(event, denyUrls) {
  // TODO: Use Glob instead?
  if (!denyUrls || !denyUrls.length) {
    return false;
  }
  const url = _getEventFilterUrl(event);
  return !url ? false : (0,string/* stringMatchesSomePattern */.U0)(url, denyUrls);
}

function _isAllowedUrl(event, allowUrls) {
  // TODO: Use Glob instead?
  if (!allowUrls || !allowUrls.length) {
    return true;
  }
  const url = _getEventFilterUrl(event);
  return !url ? true : (0,string/* stringMatchesSomePattern */.U0)(url, allowUrls);
}

function _getPossibleEventMessages(event) {
  if (event.message) {
    return [event.message];
  }
  if (event.exception) {
    try {
      const { type = '', value = '' } = (event.exception.values && event.exception.values[0]) || {};
      return [`${value}`, `${type}: ${value}`];
    } catch (oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Cannot extract message for event ${(0,misc/* getEventDescription */.jH)(event)}`);
      return [];
    }
  }
  return [];
}

function _isSentryError(event) {
  try {
    // @ts-ignore can't be a sentry error if undefined
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return event.exception.values[0].type === 'SentryError';
  } catch (e) {
    // ignore
  }
  return false;
}

function _getLastValidUrl(frames = []) {
  for (let i = frames.length - 1; i >= 0; i--) {
    const frame = frames[i];

    if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
      return frame.filename || null;
    }
  }

  return null;
}

function _getEventFilterUrl(event) {
  try {
    let frames;
    try {
      // @ts-ignore we only care about frames if the whole thing here is defined
      frames = event.exception.values[0].stacktrace.frames;
    } catch (e) {
      // ignore
    }
    return frames ? _getLastValidUrl(frames) : null;
  } catch (oO) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(`Cannot extract url for event ${(0,misc/* getEventDescription */.jH)(event)}`);
    return null;
  }
}


//# sourceMappingURL=inboundfilters.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(20535);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/integrations/functiontostring.js


let originalFunctionToString;

/** Patch toString calls to return proper name for wrapped functions */
class FunctionToString  {constructor() { FunctionToString.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'FunctionToString';}

  /**
   * @inheritDoc
   */
   __init() {this.name = FunctionToString.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    originalFunctionToString = Function.prototype.toString;

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Function.prototype.toString = function ( ...args) {
      const context = (0,object/* getOriginalFunction */.HK)(this) || this;
      return originalFunctionToString.apply(context, args);
    };
  }
} FunctionToString.__initStatic();


//# sourceMappingURL=functiontostring.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/stacktrace.js
var stacktrace = __webpack_require__(30360);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/supports.js
var supports = __webpack_require__(8823);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument.js
var instrument = __webpack_require__(9732);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/error.js
/** An error emitted by Sentry SDKs and related utilities. */
class SentryError extends Error {
  /** Display name of this error instance. */

   constructor( message, logLevel = 'warn') {
    super(message);this.message = message;;

    this.name = new.target.prototype.constructor.name;
    // This sets the prototype to be `Error`, not `SentryError`. It's unclear why we do this, but commenting this line
    // out causes various (seemingly totally unrelated) playwright tests consistently time out. FYI, this makes
    // instances of `SentryError` fail `obj instanceof SentryError` checks.
    Object.setPrototypeOf(this, new.target.prototype);
    this.logLevel = logLevel;
  }
}


//# sourceMappingURL=error.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/dsn.js


/** Regular expression used to parse a Dsn. */
const DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+)?)?@)([\w.-]+)(?::(\d+))?\/(.+)/;

function isValidProtocol(protocol) {
  return protocol === 'http' || protocol === 'https';
}

/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsn_dsnToString(dsn, withPassword = false) {
  const { host, path, pass, port, projectId, protocol, publicKey } = dsn;
  return (
    `${protocol}://${publicKey}${withPassword && pass ? `:${pass}` : ''}` +
    `@${host}${port ? `:${port}` : ''}/${path ? `${path}/` : path}${projectId}`
  );
}

/**
 * Parses a Dsn from a given string.
 *
 * @param str A Dsn as string
 * @returns Dsn as DsnComponents
 */
function dsnFromString(str) {
  const match = DSN_REGEX.exec(str);

  if (!match) {
    throw new SentryError(`Invalid Sentry Dsn: ${str}`);
  }

  const [protocol, publicKey, pass = '', host, port = '', lastPath] = match.slice(1);
  let path = '';
  let projectId = lastPath;

  const split = projectId.split('/');
  if (split.length > 1) {
    path = split.slice(0, -1).join('/');
    projectId = split.pop() ;
  }

  if (projectId) {
    const projectMatch = projectId.match(/^\d+/);
    if (projectMatch) {
      projectId = projectMatch[0];
    }
  }

  return dsnFromComponents({ host, pass, path, projectId, port, protocol: protocol , publicKey });
}

function dsnFromComponents(components) {
  return {
    protocol: components.protocol,
    publicKey: components.publicKey || '',
    pass: components.pass || '',
    host: components.host,
    port: components.port || '',
    path: components.path || '',
    projectId: components.projectId,
  };
}

function validateDsn(dsn) {
  if (!(typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
    return;
  }

  const { port, projectId, protocol } = dsn;

  const requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
  requiredComponents.forEach(component => {
    if (!dsn[component]) {
      throw new SentryError(`Invalid Sentry Dsn: ${component} missing`);
    }
  });

  if (!projectId.match(/^\d+$/)) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid projectId ${projectId}`);
  }

  if (!isValidProtocol(protocol)) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid protocol ${protocol}`);
  }

  if (port && isNaN(parseInt(port, 10))) {
    throw new SentryError(`Invalid Sentry Dsn: Invalid port ${port}`);
  }

  return true;
}

/** The Sentry Dsn, identifying a Sentry instance and project. */
function dsn_makeDsn(from) {
  const components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
  validateDsn(components);
  return components;
}


//# sourceMappingURL=dsn.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(67597);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/syncpromise.js
var syncpromise = __webpack_require__(96893);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/memo.js
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */

/**
 * Helper to decycle json objects
 */
function memoBuilder() {
  const hasWeakSet = typeof WeakSet === 'function';
  const inner = hasWeakSet ? new WeakSet() : [];
  function memoize(obj) {
    if (hasWeakSet) {
      if (inner.has(obj)) {
        return true;
      }
      inner.add(obj);
      return false;
    }
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < inner.length; i++) {
      const value = inner[i];
      if (value === obj) {
        return true;
      }
    }
    inner.push(obj);
    return false;
  }

  function unmemoize(obj) {
    if (hasWeakSet) {
      inner.delete(obj);
    } else {
      for (let i = 0; i < inner.length; i++) {
        if (inner[i] === obj) {
          inner.splice(i, 1);
          break;
        }
      }
    }
  }
  return [memoize, unmemoize];
}


//# sourceMappingURL=memo.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/normalize.js





/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output.
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalize(input, depth = +Infinity, maxProperties = +Infinity) {
  try {
    // since we're at the outermost level, we don't provide a key
    return visit('', input, depth, maxProperties);
  } catch (err) {
    return { ERROR: `**non-serializable** (${err})` };
  }
}

/** JSDoc */
function normalizeToSize(
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  object,
  // Default Node.js REPL depth
  depth = 3,
  // 100kB, as 200kB is max payload size, so half sounds reasonable
  maxSize = 100 * 1024,
) {
  const normalized = normalize(object, depth);

  if (jsonSize(normalized) > maxSize) {
    return normalizeToSize(object, depth - 1, maxSize);
  }

  return normalized ;
}

/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(
  key,
  value,
  depth = +Infinity,
  maxProperties = +Infinity,
  memo = memoBuilder(),
) {
  const [memoize, unmemoize] = memo;

  // Get the simple cases out of the way first
  if (value === null || (['number', 'boolean', 'string'].includes(typeof value) && !(0,is/* isNaN */.i2)(value))) {
    return value ;
  }

  const stringified = stringifyValue(key, value);

  // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
  // Everything else will have already been serialized, so if we don't see that pattern, we're done.
  if (!stringified.startsWith('[object ')) {
    return stringified;
  }

  // From here on, we can assert that `value` is either an object or an array.

  // Do not normalize objects that we know have already been normalized. As a general rule, the
  // "__sentry_skip_normalization__" property should only be used sparingly and only should only be set on objects that
  // have already been normalized.
  if ((value )['__sentry_skip_normalization__']) {
    return value ;
  }

  // We're also done if we've reached the max depth
  if (depth === 0) {
    // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
    return stringified.replace('object ', '');
  }

  // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
  if (memoize(value)) {
    return '[Circular ~]';
  }

  // If the value has a `toJSON` method, we call it to extract more information
  const valueWithToJSON = value ;
  if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
    try {
      const jsonValue = valueWithToJSON.toJSON();
      // We need to normalize the return value of `.toJSON()` in case it has circular references
      return visit('', jsonValue, depth - 1, maxProperties, memo);
    } catch (err) {
      // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
    }
  }

  // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
  // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
  // property/entry, and keep track of the number of items we add to it.
  const normalized = (Array.isArray(value) ? [] : {}) ;
  let numAdded = 0;

  // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
  // properties are non-enumerable and otherwise would get missed.
  const visitable = (0,object/* convertToPlainObject */.Sh)(value );

  for (const visitKey in visitable) {
    // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
    if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
      continue;
    }

    if (numAdded >= maxProperties) {
      normalized[visitKey] = '[MaxProperties ~]';
      break;
    }

    // Recursively visit all the child nodes
    const visitValue = visitable[visitKey];
    normalized[visitKey] = visit(visitKey, visitValue, depth - 1, maxProperties, memo);

    numAdded++;
  }

  // Once we've visited all the branches, remove the parent from memo storage
  unmemoize(value);

  // Return accumulated values
  return normalized;
}

/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(
  key,
  // this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
  // our internal use, it'll do
  value,
) {
  try {
    if (key === 'domain' && value && typeof value === 'object' && (value )._events) {
      return '[Domain]';
    }

    if (key === 'domainEmitter') {
      return '[DomainEmitter]';
    }

    // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
    // which won't throw if they are not present.

    if (typeof __webpack_require__.g !== 'undefined' && value === __webpack_require__.g) {
      return '[Global]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof window !== 'undefined' && value === window) {
      return '[Window]';
    }

    // eslint-disable-next-line no-restricted-globals
    if (typeof document !== 'undefined' && value === document) {
      return '[Document]';
    }

    // React's SyntheticEvent thingy
    if ((0,is/* isSyntheticEvent */.Cy)(value)) {
      return '[SyntheticEvent]';
    }

    if (typeof value === 'number' && value !== value) {
      return '[NaN]';
    }

    // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
    if (value === void 0) {
      return '[undefined]';
    }

    if (typeof value === 'function') {
      return `[Function: ${(0,stacktrace/* getFunctionName */.$P)(value)}]`;
    }

    if (typeof value === 'symbol') {
      return `[${String(value)}]`;
    }

    // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
    if (typeof value === 'bigint') {
      return `[BigInt: ${String(value)}]`;
    }

    // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
    // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
    // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
    // we can make sure that only plain objects come out that way.
    return `[object ${(Object.getPrototypeOf(value) ).constructor.name}]`;
  } catch (err) {
    return `**non-serializable** (${err})`;
  }
}

/** Calculates bytes size of input string */
function utf8Length(value) {
  // eslint-disable-next-line no-bitwise
  return ~-encodeURI(value).split(/%..|./).length;
}

/** Calculates bytes size of input object */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function jsonSize(value) {
  return utf8Length(JSON.stringify(value));
}


//# sourceMappingURL=normalize.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/envelope.js




/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items = []) {
  return [headers, items] ;
}

/**
 * Add an item to an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function addItemToEnvelope(envelope, newItem) {
  const [headers, items] = envelope;
  return [headers, [...items, newItem]] ;
}

/**
 * Convenience function to loop through the items and item types of an envelope.
 * (This function was mostly created because working with envelope types is painful at the moment)
 */
function forEachEnvelopeItem(
  envelope,
  callback,
) {
  const envelopeItems = envelope[1];
  envelopeItems.forEach((envelopeItem) => {
    const envelopeItemType = envelopeItem[0].type;
    callback(envelopeItem, envelopeItemType);
  });
}

function encodeUTF8(input, textEncoder) {
  const utf8 = textEncoder || new TextEncoder();
  return utf8.encode(input);
}

/**
 * Serializes an envelope.
 */
function serializeEnvelope(envelope, textEncoder) {
  const [envHeaders, items] = envelope;

  // Initially we construct our envelope as a string and only convert to binary chunks if we encounter binary data
  let parts = JSON.stringify(envHeaders);

  function append(next) {
    if (typeof parts === 'string') {
      parts = typeof next === 'string' ? parts + next : [encodeUTF8(parts, textEncoder), next];
    } else {
      parts.push(typeof next === 'string' ? encodeUTF8(next, textEncoder) : next);
    }
  }

  for (const item of items) {
    const [itemHeaders, payload] = item;

    append(`\n${JSON.stringify(itemHeaders)}\n`);

    if (typeof payload === 'string' || payload instanceof Uint8Array) {
      append(payload);
    } else {
      let stringifiedPayload;
      try {
        stringifiedPayload = JSON.stringify(payload);
      } catch (e) {
        // In case, despite all our efforts to keep `payload` circular-dependency-free, `JSON.strinify()` still
        // fails, we try again after normalizing it again with infinite normalization depth. This of course has a
        // performance impact but in this case a performance hit is better than throwing.
        stringifiedPayload = JSON.stringify(normalize(payload));
      }
      append(stringifiedPayload);
    }
  }

  return typeof parts === 'string' ? parts : concatBuffers(parts);
}

function concatBuffers(buffers) {
  const totalLength = buffers.reduce((acc, buf) => acc + buf.length, 0);

  const merged = new Uint8Array(totalLength);
  let offset = 0;
  for (const buffer of buffers) {
    merged.set(buffer, offset);
    offset += buffer.length;
  }

  return merged;
}

/**
 * Parses an envelope
 */
function parseEnvelope(
  env,
  textEncoder,
  textDecoder,
) {
  let buffer = typeof env === 'string' ? textEncoder.encode(env) : env;

  function readBinary(length) {
    const bin = buffer.subarray(0, length);
    // Replace the buffer with the remaining data excluding trailing newline
    buffer = buffer.subarray(length + 1);
    return bin;
  }

  function readJson() {
    let i = buffer.indexOf(0xa);
    // If we couldn't find a newline, we must have found the end of the buffer
    if (i < 0) {
      i = buffer.length;
    }

    return JSON.parse(textDecoder.decode(readBinary(i))) ;
  }

  const envelopeHeader = readJson();
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const items = [];

  while (buffer.length) {
    const itemHeader = readJson();
    const binaryLength = typeof itemHeader.length === 'number' ? itemHeader.length : undefined;

    items.push([itemHeader, binaryLength ? readBinary(binaryLength) : readJson()]);
  }

  return [envelopeHeader, items];
}

/**
 * Creates attachment envelope items
 */
function createAttachmentEnvelopeItem(
  attachment,
  textEncoder,
) {
  const buffer = typeof attachment.data === 'string' ? encodeUTF8(attachment.data, textEncoder) : attachment.data;

  return [
    (0,object/* dropUndefinedKeys */.Jr)({
      type: 'attachment',
      length: buffer.length,
      filename: attachment.filename,
      content_type: attachment.contentType,
      attachment_type: attachment.attachmentType,
    }),
    buffer,
  ];
}

const ITEM_TYPE_TO_DATA_CATEGORY_MAP = {
  session: 'session',
  sessions: 'session',
  attachment: 'attachment',
  transaction: 'transaction',
  event: 'error',
  client_report: 'internal',
  user_report: 'default',
  profile: 'profile',
};

/**
 * Maps the type of an envelope item to a data category.
 */
function envelopeItemTypeToDataCategory(type) {
  return ITEM_TYPE_TO_DATA_CATEGORY_MAP[type];
}

/** Extracts the minimal SDK info from from the metadata or an events */
function getSdkMetadataForEnvelopeHeader(metadataOrEvent) {
  if (!metadataOrEvent || !metadataOrEvent.sdk) {
    return;
  }
  const { name, version } = metadataOrEvent.sdk;
  return { name, version };
}

/**
 * Creates event envelope headers, based on event, sdk info and tunnel
 * Note: This function was extracted from the core package to make it available in Replay
 */
function createEventEnvelopeHeaders(
  event,
  sdkInfo,
  tunnel,
  dsn,
) {
  const dynamicSamplingContext = event.sdkProcessingMetadata && event.sdkProcessingMetadata.dynamicSamplingContext;

  return {
    event_id: event.event_id ,
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: dsn_dsnToString(dsn) }),
    ...(event.type === 'transaction' &&
      dynamicSamplingContext && {
        trace: (0,object/* dropUndefinedKeys */.Jr)({ ...dynamicSamplingContext }),
      }),
  };
}


//# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(21170);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/api.js


const SENTRY_API_VERSION = '7';

/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
  const protocol = dsn.protocol ? `${dsn.protocol}:` : '';
  const port = dsn.port ? `:${dsn.port}` : '';
  return `${protocol}//${dsn.host}${port}${dsn.path ? `/${dsn.path}` : ''}/api/`;
}

/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn) {
  return `${getBaseApiEndpoint(dsn)}${dsn.projectId}/envelope/`;
}

/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn, sdkInfo) {
  return (0,object/* urlEncode */._j)({
    // We send only the minimum set of required information. See
    // https://github.com/getsentry/sentry-javascript/issues/2572.
    sentry_key: dsn.publicKey,
    sentry_version: SENTRY_API_VERSION,
    ...(sdkInfo && { sentry_client: `${sdkInfo.name}/${sdkInfo.version}` }),
  });
}

/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(
  dsn,
  // TODO (v8): Remove `tunnelOrOptions` in favor of `options`, and use the substitute code below
  // options: ClientOptions = {} as ClientOptions,
  tunnelOrOptions = {} ,
) {
  // TODO (v8): Use this code instead
  // const { tunnel, _metadata = {} } = options;
  // return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, _metadata.sdk)}`;

  const tunnel = typeof tunnelOrOptions === 'string' ? tunnelOrOptions : tunnelOrOptions.tunnel;
  const sdkInfo =
    typeof tunnelOrOptions === 'string' || !tunnelOrOptions._metadata ? undefined : tunnelOrOptions._metadata.sdk;

  return tunnel ? tunnel : `${_getIngestEndpoint(dsn)}?${_encodedAuth(dsn, sdkInfo)}`;
}

/** Returns the url to the report dialog endpoint. */
function api_getReportDialogEndpoint(
  dsnLike,
  dialogOptions

,
) {
  const dsn = makeDsn(dsnLike);
  const endpoint = `${getBaseApiEndpoint(dsn)}embed/error-page/`;

  let encodedOptions = `dsn=${dsnToString(dsn)}`;
  for (const key in dialogOptions) {
    if (key === 'dsn') {
      continue;
    }

    if (key === 'user') {
      const user = dialogOptions.user;
      if (!user) {
        continue;
      }
      if (user.name) {
        encodedOptions += `&name=${encodeURIComponent(user.name)}`;
      }
      if (user.email) {
        encodedOptions += `&email=${encodeURIComponent(user.email)}`;
      }
    } else {
      encodedOptions += `&${encodeURIComponent(key)}=${encodeURIComponent(dialogOptions[key] )}`;
    }
  }

  return `${endpoint}?${encodedOptions}`;
}


//# sourceMappingURL=api.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/envelope.js


/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
  if (!sdkInfo) {
    return event;
  }
  event.sdk = event.sdk || {};
  event.sdk.name = event.sdk.name || sdkInfo.name;
  event.sdk.version = event.sdk.version || sdkInfo.version;
  event.sdk.integrations = [...(event.sdk.integrations || []), ...(sdkInfo.integrations || [])];
  event.sdk.packages = [...(event.sdk.packages || []), ...(sdkInfo.packages || [])];
  return event;
}

/** Creates an envelope from a Session */
function createSessionEnvelope(
  session,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  const envelopeHeaders = {
    sent_at: new Date().toISOString(),
    ...(sdkInfo && { sdk: sdkInfo }),
    ...(!!tunnel && { dsn: dsn_dsnToString(dsn) }),
  };

  const envelopeItem =
    'aggregates' in session ? [{ type: 'sessions' }, session] : [{ type: 'session' }, session];

  return createEnvelope(envelopeHeaders, [envelopeItem]);
}

/**
 * Create an Envelope from an event.
 */
function createEventEnvelope(
  event,
  dsn,
  metadata,
  tunnel,
) {
  const sdkInfo = getSdkMetadataForEnvelopeHeader(metadata);
  const eventType = event.type || 'event';

  enhanceEventWithSdkInfo(event, metadata && metadata.sdk);

  const envelopeHeaders = createEventEnvelopeHeaders(event, sdkInfo, tunnel, dsn);

  // Prevent this data (which, if it exists, was used in earlier steps in the processing pipeline) from being sent to
  // sentry. (Note: Our use of this property comes and goes with whatever we might be debugging, whatever hacks we may
  // have temporarily added, etc. Even if we don't happen to be using it at some point in the future, let's not get rid
  // of this `delete`, lest we miss putting it back in the next time the property is in use.)
  delete event.sdkProcessingMetadata;

  const eventItem = [{ type: eventType }, event];
  return createEnvelope(envelopeHeaders, [eventItem]);
}


//# sourceMappingURL=envelope.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/session.js
var esm_session = __webpack_require__(9015);
;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/baseclient.js







const ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";

/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(options);
 *   }
 *
 *   // ...
 * }
 */
class BaseClient {
  /** Options passed to the SDK. */

  /** The client Dsn, if specified in options. Without this Dsn, the SDK will be disabled. */

  /** Array of set up integrations. */
   __init() {this._integrations = {};}

  /** Indicates whether this client's integrations have been set up. */
   __init2() {this._integrationsInitialized = false;}

  /** Number of calls being processed */
   __init3() {this._numProcessing = 0;}

  /** Holds flushable  */
   __init4() {this._outcomes = {};}

  /**
   * Initializes this client instance.
   *
   * @param options Options for the client.
   */
   constructor(options) {;BaseClient.prototype.__init.call(this);BaseClient.prototype.__init2.call(this);BaseClient.prototype.__init3.call(this);BaseClient.prototype.__init4.call(this);
    this._options = options;
    if (options.dsn) {
      this._dsn = dsn_makeDsn(options.dsn);
      const url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, options);
      this._transport = options.transport({
        recordDroppedEvent: this.recordDroppedEvent.bind(this),
        ...options.transportOptions,
        url,
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('No DSN provided, client will not do anything.');
    }
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
   captureException(exception, hint, scope) {
    // ensure we haven't captured this very object before
    if ((0,misc/* checkOrSetAlreadyCaught */.YO)(exception)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this.eventFromException(exception, hint)
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level,
    hint,
    scope,
  ) {
    let eventId = hint && hint.event_id;

    const promisedEvent = (0,is/* isPrimitive */.pt)(message)
      ? this.eventFromMessage(String(message), level, hint)
      : this.eventFromException(message, hint);

    this._process(
      promisedEvent
        .then(event => this._captureEvent(event, hint, scope))
        .then(result => {
          eventId = result;
        }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureEvent(event, hint, scope) {
    // ensure we haven't captured this very object before
    if (hint && hint.originalException && (0,misc/* checkOrSetAlreadyCaught */.YO)(hint.originalException)) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(ALREADY_SEEN_ERROR);
      return;
    }

    let eventId = hint && hint.event_id;

    this._process(
      this._captureEvent(event, hint, scope).then(result => {
        eventId = result;
      }),
    );

    return eventId;
  }

  /**
   * @inheritDoc
   */
   captureSession(session) {
    if (!this._isEnabled()) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('SDK not enabled, will not capture session.');
      return;
    }

    if (!(typeof session.release === 'string')) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Discarded session because of missing or non-string release');
    } else {
      this.sendSession(session);
      // After sending, we set init false to indicate it's not the first occurrence
      (0,esm_session/* updateSession */.CT)(session, { init: false });
    }
  }

  /**
   * @inheritDoc
   */
   getDsn() {
    return this._dsn;
  }

  /**
   * @inheritDoc
   */
   getOptions() {
    return this._options;
  }

  /**
   * @inheritDoc
   */
   getTransport() {
    return this._transport;
  }

  /**
   * @inheritDoc
   */
   flush(timeout) {
    const transport = this._transport;
    if (transport) {
      return this._isClientDoneProcessing(timeout).then(clientFinished => {
        return transport.flush(timeout).then(transportFlushed => clientFinished && transportFlushed);
      });
    } else {
      return (0,syncpromise/* resolvedSyncPromise */.WD)(true);
    }
  }

  /**
   * @inheritDoc
   */
   close(timeout) {
    return this.flush(timeout).then(result => {
      this.getOptions().enabled = false;
      return result;
    });
  }

  /**
   * Sets up the integrations
   */
   setupIntegrations() {
    if (this._isEnabled() && !this._integrationsInitialized) {
      this._integrations = setupIntegrations(this._options.integrations);
      this._integrationsInitialized = true;
    }
  }

  /**
   * Gets an installed integration by its `id`.
   *
   * @returns The installed integration or `undefined` if no integration with that `id` was installed.
   */
   getIntegrationById(integrationId) {
    return this._integrations[integrationId];
  }

  /**
   * @inheritDoc
   */
   getIntegration(integration) {
    try {
      return (this._integrations[integration.id] ) || null;
    } catch (_oO) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Cannot retrieve integration ${integration.id} from the current Client`);
      return null;
    }
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint = {}) {
    if (this._dsn) {
      let env = createEventEnvelope(event, this._dsn, this._options._metadata, this._options.tunnel);

      for (const attachment of hint.attachments || []) {
        env = addItemToEnvelope(
          env,
          createAttachmentEnvelopeItem(
            attachment,
            this._options.transportOptions && this._options.transportOptions.textEncoder,
          ),
        );
      }

      this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   sendSession(session) {
    if (this._dsn) {
      const env = createSessionEnvelope(session, this._dsn, this._options._metadata, this._options.tunnel);
      this._sendEnvelope(env);
    }
  }

  /**
   * @inheritDoc
   */
   recordDroppedEvent(reason, category, _event) {
    // Note: we use `event` in replay, where we overwrite this hook.

    if (this._options.sendClientReports) {
      // We want to track each category (error, transaction, session) separately
      // but still keep the distinction between different type of outcomes.
      // We could use nested maps, but it's much easier to read and type this way.
      // A correct type for map-based implementation if we want to go that route
      // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
      // With typescript 4.1 we could even use template literal types
      const key = `${reason}:${category}`;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Adding outcome: "${key}"`);

      // The following works because undefined + 1 === NaN and NaN is falsy
      this._outcomes[key] = this._outcomes[key] + 1 || 1;
    }
  }

  /** Updates existing session based on the provided event */
   _updateSessionFromEvent(session, event) {
    let crashed = false;
    let errored = false;
    const exceptions = event.exception && event.exception.values;

    if (exceptions) {
      errored = true;

      for (const ex of exceptions) {
        const mechanism = ex.mechanism;
        if (mechanism && mechanism.handled === false) {
          crashed = true;
          break;
        }
      }
    }

    // A session is updated and that session update is sent in only one of the two following scenarios:
    // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
    // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
    const sessionNonTerminal = session.status === 'ok';
    const shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);

    if (shouldUpdateAndSend) {
      (0,esm_session/* updateSession */.CT)(session, {
        ...(crashed && { status: 'crashed' }),
        errors: session.errors || Number(errored || crashed),
      });
      this.captureSession(session);
    }
  }

  /**
   * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
   * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
   * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
   * `false` otherwise
   */
   _isClientDoneProcessing(timeout) {
    return new syncpromise/* SyncPromise */.cW(resolve => {
      let ticked = 0;
      const tick = 1;

      const interval = setInterval(() => {
        if (this._numProcessing == 0) {
          clearInterval(interval);
          resolve(true);
        } else {
          ticked += tick;
          if (timeout && ticked >= timeout) {
            clearInterval(interval);
            resolve(false);
          }
        }
      }, tick);
    });
  }

  /** Determines whether this SDK is enabled and a valid Dsn is present. */
   _isEnabled() {
    return this.getOptions().enabled !== false && this._dsn !== undefined;
  }

  /**
   * Adds common information to events.
   *
   * The information includes release and environment from `options`,
   * breadcrumbs and context (extra, tags and user) from the scope.
   *
   * Information that is already present in the event is never overwritten. For
   * nested objects, such as the context, keys are merged.
   *
   * @param event The original event.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A new event with more information.
   */
   _prepareEvent(event, hint, scope) {
    const { normalizeDepth = 3, normalizeMaxBreadth = 1000 } = this.getOptions();
    const prepared = {
      ...event,
      event_id: event.event_id || hint.event_id || (0,misc/* uuid4 */.DM)(),
      timestamp: event.timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
    };

    this._applyClientOptions(prepared);
    this._applyIntegrationsMetadata(prepared);

    // If we have scope given to us, use it as the base for further modifications.
    // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
    let finalScope = scope;
    if (hint.captureContext) {
      finalScope = esm_scope/* Scope.clone */.s.clone(finalScope).update(hint.captureContext);
    }

    // We prepare the result here with a resolved Event.
    let result = (0,syncpromise/* resolvedSyncPromise */.WD)(prepared);

    // This should be the last thing called, since we want that
    // {@link Hub.addEventProcessor} gets the finished prepared event.
    //
    // We need to check for the existence of `finalScope.getAttachments`
    // because `getAttachments` can be undefined if users are using an older version
    // of `@sentry/core` that does not have the `getAttachments` method.
    // See: https://github.com/getsentry/sentry-javascript/issues/5229
    if (finalScope && finalScope.getAttachments) {
      // Collect attachments from the hint and scope
      const attachments = [...(hint.attachments || []), ...finalScope.getAttachments()];

      if (attachments.length) {
        hint.attachments = attachments;
      }

      // In case we have a hub we reassign it.
      result = finalScope.applyToEvent(prepared, hint);
    }

    return result.then(evt => {
      if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
        return this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
      }
      return evt;
    });
  }

  /**
   * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
   * Normalized keys:
   * - `breadcrumbs.data`
   * - `user`
   * - `contexts`
   * - `extra`
   * @param event Event
   * @returns Normalized event
   */
   _normalizeEvent(event, depth, maxBreadth) {
    if (!event) {
      return null;
    }

    const normalized = {
      ...event,
      ...(event.breadcrumbs && {
        breadcrumbs: event.breadcrumbs.map(b => ({
          ...b,
          ...(b.data && {
            data: normalize(b.data, depth, maxBreadth),
          }),
        })),
      }),
      ...(event.user && {
        user: normalize(event.user, depth, maxBreadth),
      }),
      ...(event.contexts && {
        contexts: normalize(event.contexts, depth, maxBreadth),
      }),
      ...(event.extra && {
        extra: normalize(event.extra, depth, maxBreadth),
      }),
    };

    // event.contexts.trace stores information about a Transaction. Similarly,
    // event.spans[] stores information about child Spans. Given that a
    // Transaction is conceptually a Span, normalization should apply to both
    // Transactions and Spans consistently.
    // For now the decision is to skip normalization of Transactions and Spans,
    // so this block overwrites the normalized event to add back the original
    // Transaction information prior to normalization.
    if (event.contexts && event.contexts.trace && normalized.contexts) {
      normalized.contexts.trace = event.contexts.trace;

      // event.contexts.trace.data may contain circular/dangerous data so we need to normalize it
      if (event.contexts.trace.data) {
        normalized.contexts.trace.data = normalize(event.contexts.trace.data, depth, maxBreadth);
      }
    }

    // event.spans[].data may contain circular/dangerous data so we need to normalize it
    if (event.spans) {
      normalized.spans = event.spans.map(span => {
        // We cannot use the spread operator here because `toJSON` on `span` is non-enumerable
        if (span.data) {
          span.data = normalize(span.data, depth, maxBreadth);
        }
        return span;
      });
    }

    return normalized;
  }

  /**
   *  Enhances event using the client configuration.
   *  It takes care of all "static" values like environment, release and `dist`,
   *  as well as truncating overly long values.
   * @param event event instance to be enhanced
   */
   _applyClientOptions(event) {
    const options = this.getOptions();
    const { environment, release, dist, maxValueLength = 250 } = options;

    if (!('environment' in event)) {
      event.environment = 'environment' in options ? environment : 'production';
    }

    if (event.release === undefined && release !== undefined) {
      event.release = release;
    }

    if (event.dist === undefined && dist !== undefined) {
      event.dist = dist;
    }

    if (event.message) {
      event.message = (0,string/* truncate */.$G)(event.message, maxValueLength);
    }

    const exception = event.exception && event.exception.values && event.exception.values[0];
    if (exception && exception.value) {
      exception.value = (0,string/* truncate */.$G)(exception.value, maxValueLength);
    }

    const request = event.request;
    if (request && request.url) {
      request.url = (0,string/* truncate */.$G)(request.url, maxValueLength);
    }
  }

  /**
   * This function adds all used integrations to the SDK info in the event.
   * @param event The event that will be filled with all integrations.
   */
   _applyIntegrationsMetadata(event) {
    const integrationsArray = Object.keys(this._integrations);
    if (integrationsArray.length > 0) {
      event.sdk = event.sdk || {};
      event.sdk.integrations = [...(event.sdk.integrations || []), ...integrationsArray];
    }
  }

  /**
   * Processes the event and logs an error in case of rejection
   * @param event
   * @param hint
   * @param scope
   */
   _captureEvent(event, hint = {}, scope) {
    return this._processEvent(event, hint, scope).then(
      finalEvent => {
        return finalEvent.event_id;
      },
      reason => {
        if ((typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__)) {
          // If something's gone wrong, log the error as a warning. If it's just us having used a `SentryError` for
          // control flow, log just the message (no stack) as a log-level log.
          const sentryError = reason ;
          if (sentryError.logLevel === 'log') {
            esm_logger/* logger.log */.kg.log(sentryError.message);
          } else {
            esm_logger/* logger.warn */.kg.warn(sentryError);
          }
        }
        return undefined;
      },
    );
  }

  /**
   * Processes an event (either error or message) and sends it to Sentry.
   *
   * This also adds breadcrumbs and context information to the event. However,
   * platform specific meta data (such as the User's IP address) must be added
   * by the SDK implementor.
   *
   *
   * @param event The event to send to Sentry.
   * @param hint May contain additional information about the original exception.
   * @param scope A scope containing event metadata.
   * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
   */
   _processEvent(event, hint, scope) {
    const options = this.getOptions();
    const { sampleRate } = options;

    if (!this._isEnabled()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('SDK not enabled, will not capture event.', 'log'));
    }

    const isTransaction = isTransactionEvent(event);
    const isError = isErrorEvent(event);
    const eventType = event.type || 'error';
    const beforeSendLabel = `before send for type \`${eventType}\``;

    // 1.0 === 100% events are sent
    // 0.0 === 0% events are sent
    // Sampling for transaction happens somewhere else
    if (isError && typeof sampleRate === 'number' && Math.random() > sampleRate) {
      this.recordDroppedEvent('sample_rate', 'error', event);
      return (0,syncpromise/* rejectedSyncPromise */.$2)(
        new SentryError(
          `Discarding event because it's not included in the random sample (sampling rate = ${sampleRate})`,
          'log',
        ),
      );
    }

    return this._prepareEvent(event, hint, scope)
      .then(prepared => {
        if (prepared === null) {
          this.recordDroppedEvent('event_processor', eventType, event);
          throw new SentryError('An event processor returned `null`, will not send event.', 'log');
        }

        const isInternalException = hint.data && (hint.data ).__sentry__ === true;
        if (isInternalException) {
          return prepared;
        }

        const result = processBeforeSend(options, prepared, hint);
        return _validateBeforeSendResult(result, beforeSendLabel);
      })
      .then(processedEvent => {
        if (processedEvent === null) {
          this.recordDroppedEvent('before_send', event.type || 'error', event);
          throw new SentryError(`${beforeSendLabel} returned \`null\`, will not send event.`, 'log');
        }

        const session = scope && scope.getSession();
        if (!isTransaction && session) {
          this._updateSessionFromEvent(session, processedEvent);
        }

        // None of the Sentry built event processor will update transaction name,
        // so if the transaction name has been changed by an event processor, we know
        // it has to come from custom event processor added by a user
        const transactionInfo = processedEvent.transaction_info;
        if (isTransaction && transactionInfo && processedEvent.transaction !== event.transaction) {
          const source = 'custom';
          processedEvent.transaction_info = {
            ...transactionInfo,
            source,
            changes: [
              ...transactionInfo.changes,
              {
                source,
                // use the same timestamp as the processed event.
                timestamp: processedEvent.timestamp ,
                propagations: transactionInfo.propagations,
              },
            ],
          };
        }

        this.sendEvent(processedEvent, hint);
        return processedEvent;
      })
      .then(null, reason => {
        if (reason instanceof SentryError) {
          throw reason;
        }

        this.captureException(reason, {
          data: {
            __sentry__: true,
          },
          originalException: reason ,
        });
        throw new SentryError(
          `Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: ${reason}`,
        );
      });
  }

  /**
   * Occupies the client with processing and event
   */
   _process(promise) {
    this._numProcessing++;
    void promise.then(
      value => {
        this._numProcessing--;
        return value;
      },
      reason => {
        this._numProcessing--;
        return reason;
      },
    );
  }

  /**
   * @inheritdoc
   */
   _sendEnvelope(envelope) {
    if (this._transport && this._dsn) {
      this._transport.send(envelope).then(null, reason => {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Error while sending event:', reason);
      });
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Transport disabled');
    }
  }

  /**
   * Clears outcomes on this client and returns them.
   */
   _clearOutcomes() {
    const outcomes = this._outcomes;
    this._outcomes = {};
    return Object.keys(outcomes).map(key => {
      const [reason, category] = key.split(':') ;
      return {
        reason,
        category,
        quantity: outcomes[key],
      };
    });
  }

  /**
   * @inheritDoc
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types

}

/**
 * Verifies that return value of configured `beforeSend` or `beforeSendTransaction` is of expected type, and returns the value if so.
 */
function _validateBeforeSendResult(
  beforeSendResult,
  beforeSendLabel,
) {
  const invalidValueError = `${beforeSendLabel} must return \`null\` or a valid event.`;
  if ((0,is/* isThenable */.J8)(beforeSendResult)) {
    return beforeSendResult.then(
      event => {
        if (!(0,is/* isPlainObject */.PO)(event) && event !== null) {
          throw new SentryError(invalidValueError);
        }
        return event;
      },
      e => {
        throw new SentryError(`${beforeSendLabel} rejected with ${e}`);
      },
    );
  } else if (!(0,is/* isPlainObject */.PO)(beforeSendResult) && beforeSendResult !== null) {
    throw new SentryError(invalidValueError);
  }
  return beforeSendResult;
}

/**
 * Process the matching `beforeSendXXX` callback.
 */
function processBeforeSend(
  options,
  event,
  hint,
) {
  const { beforeSend, beforeSendTransaction } = options;

  if (isErrorEvent(event) && beforeSend) {
    return beforeSend(event, hint);
  }

  if (isTransactionEvent(event) && beforeSendTransaction) {
    return beforeSendTransaction(event, hint);
  }

  return event;
}

function isErrorEvent(event) {
  return event.type === undefined;
}

function isTransactionEvent(event) {
  return event.type === 'transaction';
}


//# sourceMappingURL=baseclient.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/clientreport.js



/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(
  discarded_events,
  dsn,
  timestamp,
) {
  const clientReportItem = [
    { type: 'client_report' },
    {
      timestamp: timestamp || (0,time/* dateTimestampInSeconds */.yW)(),
      discarded_events,
    },
  ];
  return createEnvelope(dsn ? { dsn } : {}, [clientReportItem]);
}


//# sourceMappingURL=clientreport.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/eventbuilder.js



/**
 * This function creates an exception from a JavaScript Error
 */
function exceptionFromError(stackParser, ex) {
  // Get the frames first since Opera can lose the stack if we touch anything else first
  const frames = parseStackFrames(stackParser, ex);

  const exception = {
    type: ex && ex.name,
    value: extractMessage(ex),
  };

  if (frames.length) {
    exception.stacktrace = { frames };
  }

  if (exception.type === undefined && exception.value === '') {
    exception.value = 'Unrecoverable error caught';
  }

  return exception;
}

/**
 * @hidden
 */
function eventFromPlainObject(
  stackParser,
  exception,
  syntheticException,
  isUnhandledRejection,
) {
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const client = hub.getClient();
  const normalizeDepth = client && client.getOptions().normalizeDepth;

  const event = {
    exception: {
      values: [
        {
          type: (0,is/* isEvent */.cO)(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
          value: `Non-Error ${
            isUnhandledRejection ? 'promise rejection' : 'exception'
          } captured with keys: ${(0,object/* extractExceptionKeysForMessage */.zf)(exception)}`,
        },
      ],
    },
    extra: {
      __serialized__: normalizeToSize(exception, normalizeDepth),
    },
  };

  if (syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      // event.exception.values[0] has been set above
      (event.exception ).values[0].stacktrace = { frames };
    }
  }

  return event;
}

/**
 * @hidden
 */
function eventFromError(stackParser, ex) {
  return {
    exception: {
      values: [exceptionFromError(stackParser, ex)],
    },
  };
}

/** Parses stack frames from an error */
function parseStackFrames(
  stackParser,
  ex,
) {
  // Access and store the stacktrace property before doing ANYTHING
  // else to it because Opera is not very good at providing it
  // reliably in other circumstances.
  const stacktrace = ex.stacktrace || ex.stack || '';

  const popSize = getPopSize(ex);

  try {
    return stackParser(stacktrace, popSize);
  } catch (e) {
    // no-empty
  }

  return [];
}

// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
const reactMinifiedRegexp = /Minified React error #\d+;/i;

function getPopSize(ex) {
  if (ex) {
    if (typeof ex.framesToPop === 'number') {
      return ex.framesToPop;
    }

    if (reactMinifiedRegexp.test(ex.message)) {
      return 1;
    }
  }

  return 0;
}

/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
  const message = ex && ex.message;
  if (!message) {
    return 'No error message';
  }
  if (message.error && typeof message.error.message === 'string') {
    return message.error.message;
  }
  return message;
}

/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(
  stackParser,
  exception,
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromUnknownInput(stackParser, exception, syntheticException, attachStacktrace);
  (0,misc/* addExceptionMechanism */.EG)(event); // defaults to { type: 'generic', handled: true }
  event.level = 'error';
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(
  stackParser,
  message,
  // eslint-disable-next-line deprecation/deprecation
  level = 'info',
  hint,
  attachStacktrace,
) {
  const syntheticException = (hint && hint.syntheticException) || undefined;
  const event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
  event.level = level;
  if (hint && hint.event_id) {
    event.event_id = hint.event_id;
  }
  return (0,syncpromise/* resolvedSyncPromise */.WD)(event);
}

/**
 * @hidden
 */
function eventFromUnknownInput(
  stackParser,
  exception,
  syntheticException,
  attachStacktrace,
  isUnhandledRejection,
) {
  let event;

  if ((0,is/* isErrorEvent */.VW)(exception ) && (exception ).error) {
    // If it is an ErrorEvent with `error` property, extract it to get actual Error
    const errorEvent = exception ;
    return eventFromError(stackParser, errorEvent.error );
  }

  // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
  // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
  // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
  //
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
  // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
  // https://webidl.spec.whatwg.org/#es-DOMException-specialness
  if ((0,is/* isDOMError */.TX)(exception ) || (0,is/* isDOMException */.fm)(exception )) {
    const domException = exception ;

    if ('stack' in (exception )) {
      event = eventFromError(stackParser, exception );
    } else {
      const name = domException.name || ((0,is/* isDOMError */.TX)(domException) ? 'DOMError' : 'DOMException');
      const message = domException.message ? `${name}: ${domException.message}` : name;
      event = eventFromString(stackParser, message, syntheticException, attachStacktrace);
      (0,misc/* addExceptionTypeValue */.Db)(event, message);
    }
    if ('code' in domException) {
      event.tags = { ...event.tags, 'DOMException.code': `${domException.code}` };
    }

    return event;
  }
  if ((0,is/* isError */.VZ)(exception)) {
    // we have a real Error object, do nothing
    return eventFromError(stackParser, exception);
  }
  if ((0,is/* isPlainObject */.PO)(exception) || (0,is/* isEvent */.cO)(exception)) {
    // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
    // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
    // group on any key/value change.
    const objectException = exception ;
    event = eventFromPlainObject(stackParser, objectException, syntheticException, isUnhandledRejection);
    (0,misc/* addExceptionMechanism */.EG)(event, {
      synthetic: true,
    });
    return event;
  }

  // If none of previous checks were valid, then it means that it's not:
  // - an instance of DOMError
  // - an instance of DOMException
  // - an instance of Event
  // - an instance of Error
  // - a valid ErrorEvent (one with an error property)
  // - a plain Object
  //
  // So bail out and capture it as a simple message:
  event = eventFromString(stackParser, exception , syntheticException, attachStacktrace);
  (0,misc/* addExceptionTypeValue */.Db)(event, `${exception}`, undefined);
  (0,misc/* addExceptionMechanism */.EG)(event, {
    synthetic: true,
  });

  return event;
}

/**
 * @hidden
 */
function eventFromString(
  stackParser,
  input,
  syntheticException,
  attachStacktrace,
) {
  const event = {
    message: input,
  };

  if (attachStacktrace && syntheticException) {
    const frames = parseStackFrames(stackParser, syntheticException);
    if (frames.length) {
      event.exception = {
        values: [{ value: input, stacktrace: { frames } }],
      };
    }
  }

  return event;
}


//# sourceMappingURL=eventbuilder.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(64487);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(71235);
;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/helpers.js



const helpers_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;

let ignoreOnError = 0;

/**
 * @hidden
 */
function shouldIgnoreOnError() {
  return ignoreOnError > 0;
}

/**
 * @hidden
 */
function ignoreNextOnError() {
  // onerror should trigger before setTimeout
  ignoreOnError++;
  setTimeout(() => {
    ignoreOnError--;
  });
}

/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap. It is generally safe to pass an unbound function, because the returned wrapper always
 * has a correct `this` context.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(
  fn,
  options

 = {},
  before,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
) {
  // for future readers what this does is wrap a function and then create
  // a bi-directional wrapping between them.
  //
  // example: wrapped = wrap(original);
  //  original.__sentry_wrapped__ -> wrapped
  //  wrapped.__sentry_original__ -> original

  if (typeof fn !== 'function') {
    return fn;
  }

  try {
    // if we're dealing with a function that was previously wrapped, return
    // the original wrapper.
    const wrapper = fn.__sentry_wrapped__;
    if (wrapper) {
      return wrapper;
    }

    // We don't wanna wrap it twice
    if ((0,object/* getOriginalFunction */.HK)(fn)) {
      return fn;
    }
  } catch (e) {
    // Just accessing custom props in some Selenium environments
    // can cause a "Permission denied" exception (see raven-js#495).
    // Bail on wrapping and return the function as-is (defers to window.onerror).
    return fn;
  }

  /* eslint-disable prefer-rest-params */
  // It is important that `sentryWrapped` is not an arrow function to preserve the context of `this`
  const sentryWrapped = function () {
    const args = Array.prototype.slice.call(arguments);

    try {
      if (before && typeof before === 'function') {
        before.apply(this, arguments);
      }

      // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
      const wrappedArguments = args.map((arg) => wrap(arg, options));

      // Attempt to invoke user-land function
      // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
      //       means the sentry.javascript SDK caught an error invoking your application code. This
      //       is expected behavior and NOT indicative of a bug with sentry.javascript.
      return fn.apply(this, wrappedArguments);
    } catch (ex) {
      ignoreNextOnError();

      (0,esm_exports/* withScope */.$e)((scope) => {
        scope.addEventProcessor((event) => {
          if (options.mechanism) {
            (0,misc/* addExceptionTypeValue */.Db)(event, undefined, undefined);
            (0,misc/* addExceptionMechanism */.EG)(event, options.mechanism);
          }

          event.extra = {
            ...event.extra,
            arguments: args,
          };

          return event;
        });

        (0,esm_exports/* captureException */.Tb)(ex);
      });

      throw ex;
    }
  };
  /* eslint-enable prefer-rest-params */

  // Accessing some objects may throw
  // ref: https://github.com/getsentry/sentry-javascript/issues/1168
  try {
    for (const property in fn) {
      if (Object.prototype.hasOwnProperty.call(fn, property)) {
        sentryWrapped[property] = fn[property];
      }
    }
  } catch (_oO) {} // eslint-disable-line no-empty

  // Signal that this function has been wrapped/filled already
  // for both debugging and to prevent it to being wrapped/filled twice
  (0,object/* markFunctionWrapped */.$Q)(sentryWrapped, fn);

  (0,object/* addNonEnumerableProperty */.xp)(fn, '__sentry_wrapped__', sentryWrapped);

  // Restore original function name (not all browsers allow that)
  try {
    const descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name') ;
    if (descriptor.configurable) {
      Object.defineProperty(sentryWrapped, 'name', {
        get() {
          return fn.name;
        },
      });
    }
    // eslint-disable-next-line no-empty
  } catch (_oO) {}

  return sentryWrapped;
}

/**
 * All properties the report dialog supports
 */


//# sourceMappingURL=helpers.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/browser.js
var browser = __webpack_require__(58464);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/severity.js
// Note: Ideally the `SeverityLevel` type would be derived from `validSeverityLevels`, but that would mean either
//
// a) moving `validSeverityLevels` to `@sentry/types`,
// b) moving the`SeverityLevel` type here, or
// c) importing `validSeverityLevels` from here into `@sentry/types`.
//
// Option A would make `@sentry/types` a runtime dependency of `@sentry/utils` (not good), and options B and C would
// create a circular dependency between `@sentry/types` and `@sentry/utils` (also not good). So a TODO accompanying the
// type, reminding anyone who changes it to change this list also, will have to do.

const validSeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug'];

/**
 * Converts a string-based level into a member of the deprecated {@link Severity} enum.
 *
 * @deprecated `severityFromString` is deprecated. Please use `severityLevelFromString` instead.
 *
 * @param level String representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
  return severityLevelFromString(level) ;
}

/**
 * Converts a string-based level into a `SeverityLevel`, normalizing it along the way.
 *
 * @param level String representation of desired `SeverityLevel`.
 * @returns The `SeverityLevel` corresponding to the given string, or 'log' if the string isn't a valid level.
 */
function severityLevelFromString(level) {
  return (level === 'warn' ? 'warning' : validSeverityLevels.includes(level) ? level : 'log') ;
}


//# sourceMappingURL=severity.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/url.js
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url)

 {
  if (!url) {
    return {};
  }

  const match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);

  if (!match) {
    return {};
  }

  // coerce to undefined values to empty string so we don't get 'undefined'
  const query = match[6] || '';
  const fragment = match[8] || '';
  return {
    host: match[4],
    path: match[5],
    protocol: match[2],
    relative: match[5] + query + fragment, // everything minus origin
  };
}

/**
 * Strip the query string and fragment off of a given URL or path (if present)
 *
 * @param urlPath Full URL or path, including possible query string and/or fragment
 * @returns URL or path without query string or fragment
 */
function stripUrlQueryAndFragment(urlPath) {
  // eslint-disable-next-line no-useless-escape
  return urlPath.split(/[\?#]/, 1)[0];
}

/**
 * Returns number of URL segments of a passed string URL.
 */
function getNumberOfUrlSegments(url) {
  // split at '/' or at '\/' to split regex urls correctly
  return url.split(/\\?\//).filter(s => s.length > 0 && s !== ',').length;
}


//# sourceMappingURL=url.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/breadcrumbs.js




/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** JSDoc */

/** maxStringLength gets capped to prevent 100 breadcrumbs exceeding 1MB event payload size */
const MAX_ALLOWED_STRING_LENGTH = 1024;

const BREADCRUMB_INTEGRATION_ID = 'Breadcrumbs';

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
class Breadcrumbs  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = BREADCRUMB_INTEGRATION_ID;}

  /**
   * @inheritDoc
   */
   __init() {this.name = Breadcrumbs.id;}

  /**
   * Options of the breadcrumbs integration.
   */
  // This field is public, because we use it in the browser client to check if the `sentry` option is enabled.

  /**
   * @inheritDoc
   */
   constructor(options) {;Breadcrumbs.prototype.__init.call(this);
    this.options = {
      console: true,
      dom: true,
      fetch: true,
      history: true,
      sentry: true,
      xhr: true,
      ...options,
    };
  }

  /**
   * Instrument browser built-ins w/ breadcrumb capturing
   *  - Console API
   *  - DOM API (click/typing)
   *  - XMLHttpRequest API
   *  - Fetch API
   *  - History API
   */
   setupOnce() {
    if (this.options.console) {
      (0,instrument/* addInstrumentationHandler */.o)('console', _consoleBreadcrumb);
    }
    if (this.options.dom) {
      (0,instrument/* addInstrumentationHandler */.o)('dom', _domBreadcrumb(this.options.dom));
    }
    if (this.options.xhr) {
      (0,instrument/* addInstrumentationHandler */.o)('xhr', _xhrBreadcrumb);
    }
    if (this.options.fetch) {
      (0,instrument/* addInstrumentationHandler */.o)('fetch', _fetchBreadcrumb);
    }
    if (this.options.history) {
      (0,instrument/* addInstrumentationHandler */.o)('history', _historyBreadcrumb);
    }
  }

  /**
   * Adds a breadcrumb for Sentry events or transactions if this option is enabled.
   */
   addSentryBreadcrumb(event) {
    if (this.options.sentry) {
      (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
        {
          category: `sentry.${event.type === 'transaction' ? 'transaction' : 'event'}`,
          event_id: event.event_id,
          level: event.level,
          message: (0,misc/* getEventDescription */.jH)(event),
        },
        {
          event,
        },
      );
    }
  }
} Breadcrumbs.__initStatic();

/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _domBreadcrumb(dom) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  function _innerDomBreadcrumb(handlerData) {
    let target;
    let keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;

    let maxStringLength =
      typeof dom === 'object' && typeof dom.maxStringLength === 'number' ? dom.maxStringLength : undefined;
    if (maxStringLength && maxStringLength > MAX_ALLOWED_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(
          `\`dom.maxStringLength\` cannot exceed ${MAX_ALLOWED_STRING_LENGTH}, but a value of ${maxStringLength} was configured. Sentry will use ${MAX_ALLOWED_STRING_LENGTH} instead.`,
        );
      maxStringLength = MAX_ALLOWED_STRING_LENGTH;
    }

    if (typeof keyAttrs === 'string') {
      keyAttrs = [keyAttrs];
    }

    // Accessing event.target can throw (see getsentry/raven-js#838, #768)
    try {
      target = handlerData.event.target
        ? (0,browser/* htmlTreeAsString */.Rt)(handlerData.event.target , { keyAttrs, maxStringLength })
        : (0,browser/* htmlTreeAsString */.Rt)(handlerData.event , { keyAttrs, maxStringLength });
    } catch (e) {
      target = '<unknown>';
    }

    if (target.length === 0) {
      return;
    }

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: `ui.${handlerData.name}`,
        message: target,
      },
      {
        event: handlerData.event,
        name: handlerData.name,
        global: handlerData.global,
      },
    );
  }

  return _innerDomBreadcrumb;
}

/**
 * Creates breadcrumbs from console API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _consoleBreadcrumb(handlerData) {
  // This is a hack to fix a Vue3-specific bug that causes an infinite loop of
  // console warnings. This happens when a Vue template is rendered with
  // an undeclared variable, which we try to stringify, ultimately causing
  // Vue to issue another warning which repeats indefinitely.
  // see: https://github.com/getsentry/sentry-javascript/pull/6010
  // see: https://github.com/getsentry/sentry-javascript/issues/5916
  for (let i = 0; i < handlerData.args.length; i++) {
    if (handlerData.args[i] === 'ref=Ref<') {
      handlerData.args[i + 1] = 'viewRef';
      break;
    }
  }
  const breadcrumb = {
    category: 'console',
    data: {
      arguments: handlerData.args,
      logger: 'console',
    },
    level: severityLevelFromString(handlerData.level),
    message: (0,string/* safeJoin */.nK)(handlerData.args, ' '),
  };

  if (handlerData.level === 'assert') {
    if (handlerData.args[0] === false) {
      breadcrumb.message = `Assertion failed: ${(0,string/* safeJoin */.nK)(handlerData.args.slice(1), ' ') || 'console.assert'}`;
      breadcrumb.data.arguments = handlerData.args.slice(1);
    } else {
      // Don't capture a breadcrumb for passed assertions
      return;
    }
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(breadcrumb, {
    input: handlerData.args,
    level: handlerData.level,
  });
}

/**
 * Creates breadcrumbs from XHR API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _xhrBreadcrumb(handlerData) {
  if (handlerData.endTimestamp) {
    // We only capture complete, non-sentry requests
    if (handlerData.xhr.__sentry_own_request__) {
      return;
    }

    const { method, url, status_code, body } = handlerData.xhr.__sentry_xhr__ || {};

    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'xhr',
        data: {
          method,
          url,
          status_code,
        },
        type: 'http',
      },
      {
        xhr: handlerData.xhr,
        input: body,
      },
    );

    return;
  }
}

/**
 * Creates breadcrumbs from fetch API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _fetchBreadcrumb(handlerData) {
  // We only capture complete fetch requests
  if (!handlerData.endTimestamp) {
    return;
  }

  if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
    // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
    return;
  }

  if (handlerData.error) {
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data: handlerData.fetchData,
        level: 'error',
        type: 'http',
      },
      {
        data: handlerData.error,
        input: handlerData.args,
      },
    );
  } else {
    (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb(
      {
        category: 'fetch',
        data: {
          ...handlerData.fetchData,
          status_code: handlerData.response.status,
        },
        type: 'http',
      },
      {
        input: handlerData.args,
        response: handlerData.response,
      },
    );
  }
}

/**
 * Creates breadcrumbs from history API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _historyBreadcrumb(handlerData) {
  let from = handlerData.from;
  let to = handlerData.to;
  const parsedLoc = parseUrl(helpers_WINDOW.location.href);
  let parsedFrom = parseUrl(from);
  const parsedTo = parseUrl(to);

  // Initial pushState doesn't provide `from` information
  if (!parsedFrom.path) {
    parsedFrom = parsedLoc;
  }

  // Use only the path component of the URL if the URL matches the current
  // document (almost all the time when using pushState)
  if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
    to = parsedTo.relative;
  }
  if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
    from = parsedFrom.relative;
  }

  (0,esm_hub/* getCurrentHub */.Gd)().addBreadcrumb({
    category: 'navigation',
    data: {
      from,
      to,
    },
  });
}


//# sourceMappingURL=breadcrumbs.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/client.js







/**
 * Configuration options for the Sentry Browser SDK.
 * @see @sentry/types Options for more information.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
class BrowserClient extends BaseClient {
  /**
   * Creates a new Browser SDK instance.
   *
   * @param options Configuration options for this SDK.
   */
   constructor(options) {
    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
      name: 'sentry.javascript.browser',
      packages: [
        {
          name: 'npm:@sentry/browser',
          version: SDK_VERSION,
        },
      ],
      version: SDK_VERSION,
    };

    super(options);

    if (options.sendClientReports && helpers_WINDOW.document) {
      helpers_WINDOW.document.addEventListener('visibilitychange', () => {
        if (helpers_WINDOW.document.visibilityState === 'hidden') {
          this._flushOutcomes();
        }
      });
    }
  }

  /**
   * @inheritDoc
   */
   eventFromException(exception, hint) {
    return eventFromException(this._options.stackParser, exception, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   eventFromMessage(
    message,
    // eslint-disable-next-line deprecation/deprecation
    level = 'info',
    hint,
  ) {
    return eventFromMessage(this._options.stackParser, message, level, hint, this._options.attachStacktrace);
  }

  /**
   * @inheritDoc
   */
   sendEvent(event, hint) {
    // We only want to add the sentry event breadcrumb when the user has the breadcrumb integration installed and
    // activated its `sentry` option.
    // We also do not want to use the `Breadcrumbs` class here directly, because we do not want it to be included in
    // bundles, if it is not used by the SDK.
    // This all sadly is a bit ugly, but we currently don't have a "pre-send" hook on the integrations so we do it this
    // way for now.
    const breadcrumbIntegration = this.getIntegrationById(BREADCRUMB_INTEGRATION_ID) ;
    // We check for definedness of `addSentryBreadcrumb` in case users provided their own integration with id
    // "Breadcrumbs" that does not have this function.
    _optionalChain([breadcrumbIntegration, 'optionalAccess', _ => _.addSentryBreadcrumb, 'optionalCall', _2 => _2(event)]);

    super.sendEvent(event, hint);
  }

  /**
   * @inheritDoc
   */
   _prepareEvent(event, hint, scope) {
    event.platform = event.platform || 'javascript';
    return super._prepareEvent(event, hint, scope);
  }

  /**
   * Sends client reports as an envelope.
   */
   _flushOutcomes() {
    const outcomes = this._clearOutcomes();

    if (outcomes.length === 0) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No outcomes to send');
      return;
    }

    if (!this._dsn) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('No dsn provided, will not send outcomes');
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('Sending outcomes:', outcomes);

    const url = getEnvelopeEndpointWithUrlEncodedAuth(this._dsn, this._options);
    const envelope = createClientReportEnvelope(outcomes, this._options.tunnel && dsn_dsnToString(this._dsn));

    try {
      const isRealNavigator = Object.prototype.toString.call(helpers_WINDOW && helpers_WINDOW.navigator) === '[object Navigator]';
      const hasSendBeacon = isRealNavigator && typeof helpers_WINDOW.navigator.sendBeacon === 'function';
      // Make sure beacon is not used if user configures custom transport options
      if (hasSendBeacon && !this._options.transportOptions) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        const sendBeacon = helpers_WINDOW.navigator.sendBeacon.bind(helpers_WINDOW.navigator);
        sendBeacon(url, serializeEnvelope(envelope));
      } else {
        // If beacon is not supported or if they are using the tunnel option
        // use our regular transport to send client reports to Sentry.
        this._sendEnvelope(envelope);
      }
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error(e);
    }
  }
}


//# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/stack-parsers.js


// global reference to slice
const UNKNOWN_FUNCTION = '?';

const OPERA10_PRIORITY = 10;
const OPERA11_PRIORITY = 20;
const CHROME_PRIORITY = 30;
const WINJS_PRIORITY = 40;
const GECKO_PRIORITY = 50;

function createFrame(filename, func, lineno, colno) {
  const frame = {
    filename,
    function: func,
    // All browser frames are considered in_app
    in_app: true,
  };

  if (lineno !== undefined) {
    frame.lineno = lineno;
  }

  if (colno !== undefined) {
    frame.colno = colno;
  }

  return frame;
}

// Chromium based browsers: Chrome, Brave, new Opera, new Edge
const chromeRegex =
  /^\s*at (?:(.*\).*?|.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/)?.*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
const chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;

const chrome = line => {
  const parts = chromeRegex.exec(line);

  if (parts) {
    const isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line

    if (isEval) {
      const subMatch = chromeEvalRegex.exec(parts[2]);

      if (subMatch) {
        // throw out eval line/column and use top-most line/column number
        parts[2] = subMatch[1]; // url
        parts[3] = subMatch[2]; // line
        parts[4] = subMatch[3]; // column
      }
    }

    // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
    // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
    const [func, filename] = extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]);

    return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
  }

  return;
};

const chromeStackLineParser = [CHROME_PRIORITY, chrome];

// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
const geckoREgex =
  /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|safari-extension|safari-web-extension|capacitor)?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
const geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;

const gecko = line => {
  const parts = geckoREgex.exec(line);

  if (parts) {
    const isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
    if (isEval) {
      const subMatch = geckoEvalRegex.exec(parts[3]);

      if (subMatch) {
        // throw out eval line/column and use top-most line number
        parts[1] = parts[1] || 'eval';
        parts[3] = subMatch[1];
        parts[4] = subMatch[2];
        parts[5] = ''; // no column when eval
      }
    }

    let filename = parts[3];
    let func = parts[1] || UNKNOWN_FUNCTION;
    [func, filename] = extractSafariExtensionDetails(func, filename);

    return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
  }

  return;
};

const geckoStackLineParser = [GECKO_PRIORITY, gecko];

const winjsRegex =
  /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;

const winjs = line => {
  const parts = winjsRegex.exec(line);

  return parts
    ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
    : undefined;
};

const winjsStackLineParser = [WINJS_PRIORITY, winjs];

const opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;

const opera10 = line => {
  const parts = opera10Regex.exec(line);
  return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};

const opera10StackLineParser = [OPERA10_PRIORITY, opera10];

const opera11Regex =
  / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;

const opera11 = line => {
  const parts = opera11Regex.exec(line);
  return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};

const opera11StackLineParser = [OPERA11_PRIORITY, opera11];

const defaultStackLineParsers = [chromeStackLineParser, geckoStackLineParser, winjsStackLineParser];

const defaultStackParser = (0,stacktrace/* createStackParser */.pE)(...defaultStackLineParsers);

/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
const extractSafariExtensionDetails = (func, filename) => {
  const isSafariExtension = func.indexOf('safari-extension') !== -1;
  const isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;

  return isSafariExtension || isSafariWebExtension
    ? [
        func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
        isSafariExtension ? `safari-extension:${filename}` : `safari-web-extension:${filename}`,
      ]
    : [func, filename];
};


//# sourceMappingURL=stack-parsers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/trycatch.js



const DEFAULT_EVENT_TARGET = [
  'EventTarget',
  'Window',
  'Node',
  'ApplicationCache',
  'AudioTrackList',
  'ChannelMergerNode',
  'CryptoOperation',
  'EventSource',
  'FileReader',
  'HTMLUnknownElement',
  'IDBDatabase',
  'IDBRequest',
  'IDBTransaction',
  'KeyOperation',
  'MediaController',
  'MessagePort',
  'ModalWindow',
  'Notification',
  'SVGElementInstance',
  'Screen',
  'TextTrack',
  'TextTrackCue',
  'TextTrackList',
  'WebSocket',
  'WebSocketWorker',
  'Worker',
  'XMLHttpRequest',
  'XMLHttpRequestEventTarget',
  'XMLHttpRequestUpload',
];

/** Wrap timer functions and event targets to catch errors and provide better meta data */
class TryCatch  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'TryCatch';}

  /**
   * @inheritDoc
   */
   __init() {this.name = TryCatch.id;}

  /** JSDoc */

  /**
   * @inheritDoc
   */
   constructor(options) {;TryCatch.prototype.__init.call(this);
    this._options = {
      XMLHttpRequest: true,
      eventTarget: true,
      requestAnimationFrame: true,
      setInterval: true,
      setTimeout: true,
      ...options,
    };
  }

  /**
   * Wrap timer functions and event targets to catch errors
   * and provide better metadata.
   */
   setupOnce() {
    if (this._options.setTimeout) {
      (0,object/* fill */.hl)(helpers_WINDOW, 'setTimeout', _wrapTimeFunction);
    }

    if (this._options.setInterval) {
      (0,object/* fill */.hl)(helpers_WINDOW, 'setInterval', _wrapTimeFunction);
    }

    if (this._options.requestAnimationFrame) {
      (0,object/* fill */.hl)(helpers_WINDOW, 'requestAnimationFrame', _wrapRAF);
    }

    if (this._options.XMLHttpRequest && "XMLHttpRequest" in helpers_WINDOW) {
      (0,object/* fill */.hl)(XMLHttpRequest.prototype, 'send', _wrapXHR);
    }

    const eventTargetOption = this._options.eventTarget;
    if (eventTargetOption) {
      const eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
      eventTarget.forEach(_wrapEventTarget);
    }
  }
} TryCatch.__initStatic();

/** JSDoc */
function _wrapTimeFunction(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    const originalCallback = args[0];
    args[0] = wrap(originalCallback, {
      mechanism: {
        data: { function: (0,stacktrace/* getFunctionName */.$P)(original) },
        handled: true,
        type: 'instrument',
      },
    });
    return original.apply(this, args);
  };
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( callback) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return original.apply(this, [
      wrap(callback, {
        mechanism: {
          data: {
            function: 'requestAnimationFrame',
            handler: (0,stacktrace/* getFunctionName */.$P)(original),
          },
          handled: true,
          type: 'instrument',
        },
      }),
    ]);
  };
}

/** JSDoc */
function _wrapXHR(originalSend) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return function ( ...args) {
    // eslint-disable-next-line @typescript-eslint/no-this-alias
    const xhr = this;
    const xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];

    xmlHttpRequestProps.forEach(prop => {
      if (prop in xhr && typeof xhr[prop] === 'function') {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        (0,object/* fill */.hl)(xhr, prop, function (original) {
          const wrapOptions = {
            mechanism: {
              data: {
                function: prop,
                handler: (0,stacktrace/* getFunctionName */.$P)(original),
              },
              handled: true,
              type: 'instrument',
            },
          };

          // If Instrument integration has been called before TryCatch, get the name of original function
          const originalFunction = (0,object/* getOriginalFunction */.HK)(original);
          if (originalFunction) {
            wrapOptions.mechanism.data.handler = (0,stacktrace/* getFunctionName */.$P)(originalFunction);
          }

          // Otherwise wrap directly
          return wrap(original, wrapOptions);
        });
      }
    });

    return originalSend.apply(this, args);
  };
}

/** JSDoc */
function _wrapEventTarget(target) {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const globalObject = helpers_WINDOW ;
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  const proto = globalObject[target] && globalObject[target].prototype;

  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
  if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
    return;
  }

  (0,object/* fill */.hl)(proto, 'addEventListener', function (original)

 {
    return function (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any

      eventName,
      fn,
      options,
    ) {
      try {
        if (typeof fn.handleEvent === 'function') {
          // ESlint disable explanation:
          //  First, it is generally safe to call `wrap` with an unbound function. Furthermore, using `.bind()` would
          //  introduce a bug here, because bind returns a new function that doesn't have our
          //  flags(like __sentry_original__) attached. `wrap` checks for those flags to avoid unnecessary wrapping.
          //  Without those flags, every call to addEventListener wraps the function again, causing a memory leak.
          // eslint-disable-next-line @typescript-eslint/unbound-method
          fn.handleEvent = wrap(fn.handleEvent, {
            mechanism: {
              data: {
                function: 'handleEvent',
                handler: (0,stacktrace/* getFunctionName */.$P)(fn),
                target,
              },
              handled: true,
              type: 'instrument',
            },
          });
        }
      } catch (err) {
        // can sometimes get 'Permission denied to access property "handle Event'
      }

      return original.apply(this, [
        eventName,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        wrap(fn , {
          mechanism: {
            data: {
              function: 'addEventListener',
              handler: (0,stacktrace/* getFunctionName */.$P)(fn),
              target,
            },
            handled: true,
            type: 'instrument',
          },
        }),
        options,
      ]);
    };
  });

  (0,object/* fill */.hl)(
    proto,
    'removeEventListener',
    function (
      originalRemoveEventListener,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) {
      return function (
        // eslint-disable-next-line @typescript-eslint/no-explicit-any

        eventName,
        fn,
        options,
      ) {
        /**
         * There are 2 possible scenarios here:
         *
         * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
         * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
         * as a pass-through, and call original `removeEventListener` with it.
         *
         * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
         * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
         * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
         * in order for us to make a distinction between wrapped/non-wrapped functions possible.
         * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
         *
         * When someone adds a handler prior to initialization, and then do it again, but after,
         * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
         * to get rid of the initial handler and it'd stick there forever.
         */
        const wrappedEventHandler = fn ;
        try {
          const originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
          if (originalEventHandler) {
            originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
          }
        } catch (e) {
          // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
        }
        return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
      };
    },
  );
}


//# sourceMappingURL=trycatch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/globalhandlers.js





/* eslint-disable @typescript-eslint/no-unsafe-member-access */

/** Global handlers */
class GlobalHandlers  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'GlobalHandlers';}

  /**
   * @inheritDoc
   */
   __init() {this.name = GlobalHandlers.id;}

  /** JSDoc */

  /**
   * Stores references functions to installing handlers. Will set to undefined
   * after they have been run so that they are not used twice.
   */
   __init2() {this._installFunc = {
    onerror: _installGlobalOnErrorHandler,
    onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
  };}

  /** JSDoc */
   constructor(options) {;GlobalHandlers.prototype.__init.call(this);GlobalHandlers.prototype.__init2.call(this);
    this._options = {
      onerror: true,
      onunhandledrejection: true,
      ...options,
    };
  }
  /**
   * @inheritDoc
   */
   setupOnce() {
    Error.stackTraceLimit = 50;
    const options = this._options;

    // We can disable guard-for-in as we construct the options object above + do checks against
    // `this._installFunc` for the property.
    // eslint-disable-next-line guard-for-in
    for (const key in options) {
      const installFunc = this._installFunc[key ];
      if (installFunc && options[key ]) {
        globalHandlerLog(key);
        installFunc();
        this._installFunc[key ] = undefined;
      }
    }
  }
} GlobalHandlers.__initStatic();

/** JSDoc */
function _installGlobalOnErrorHandler() {
  (0,instrument/* addInstrumentationHandler */.o)(
    'error',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (data) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      const { msg, url, line, column, error } = data;
      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return;
      }

      const event =
        error === undefined && (0,is/* isString */.HD)(msg)
          ? _eventFromIncompleteOnError(msg, url, line, column)
          : _enhanceEventWithInitialFrame(
              eventFromUnknownInput(stackParser, error || msg, undefined, attachStacktrace, false),
              url,
              line,
              column,
            );

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onerror');
    },
  );
}

/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
  (0,instrument/* addInstrumentationHandler */.o)(
    'unhandledrejection',
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (e) => {
      const [hub, stackParser, attachStacktrace] = getHubAndOptions();
      if (!hub.getIntegration(GlobalHandlers)) {
        return;
      }
      let error = e;

      // dig the object of the rejection out of known event types
      try {
        // PromiseRejectionEvents store the object of the rejection under 'reason'
        // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
        if ('reason' in e) {
          error = e.reason;
        }
        // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
        // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
        // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
        // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
        // https://github.com/getsentry/sentry-javascript/issues/2380
        else if ('detail' in e && 'reason' in e.detail) {
          error = e.detail.reason;
        }
      } catch (_oO) {
        // no-empty
      }

      if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
        return true;
      }

      const event = (0,is/* isPrimitive */.pt)(error)
        ? _eventFromRejectionWithPrimitive(error)
        : eventFromUnknownInput(stackParser, error, undefined, attachStacktrace, true);

      event.level = 'error';

      addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
      return;
    },
  );
}

/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
  return {
    exception: {
      values: [
        {
          type: 'UnhandledRejection',
          // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
          value: `Non-Error promise rejection captured with value: ${String(reason)}`,
        },
      ],
    },
  };
}

/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
  const ERROR_TYPES_RE =
    /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;

  // If 'message' is ErrorEvent, get real message from inside
  let message = (0,is/* isErrorEvent */.VW)(msg) ? msg.message : msg;
  let name = 'Error';

  const groups = message.match(ERROR_TYPES_RE);
  if (groups) {
    name = groups[1];
    message = groups[2];
  }

  const event = {
    exception: {
      values: [
        {
          type: name,
          value: message,
        },
      ],
    },
  };

  return _enhanceEventWithInitialFrame(event, url, line, column);
}

/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
  // event.exception
  const e = (event.exception = event.exception || {});
  // event.exception.values
  const ev = (e.values = e.values || []);
  // event.exception.values[0]
  const ev0 = (ev[0] = ev[0] || {});
  // event.exception.values[0].stacktrace
  const ev0s = (ev0.stacktrace = ev0.stacktrace || {});
  // event.exception.values[0].stacktrace.frames
  const ev0sf = (ev0s.frames = ev0s.frames || []);

  const colno = isNaN(parseInt(column, 10)) ? undefined : column;
  const lineno = isNaN(parseInt(line, 10)) ? undefined : line;
  const filename = (0,is/* isString */.HD)(url) && url.length > 0 ? url : (0,browser/* getLocationHref */.l4)();

  // event.exception.values[0].stacktrace.frames
  if (ev0sf.length === 0) {
    ev0sf.push({
      colno,
      filename,
      function: '?',
      in_app: true,
      lineno,
    });
  }

  return event;
}

function globalHandlerLog(type) {
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`Global Handler attached: ${type}`);
}

function addMechanismAndCapture(hub, error, event, type) {
  (0,misc/* addExceptionMechanism */.EG)(event, {
    handled: false,
    type,
  });
  hub.captureEvent(event, {
    originalException: error,
  });
}

function getHubAndOptions() {
  const hub = (0,esm_hub/* getCurrentHub */.Gd)();
  const client = hub.getClient();
  const options = (client && client.getOptions()) || {
    stackParser: () => [],
    attachStacktrace: false,
  };
  return [hub, options.stackParser, options.attachStacktrace];
}


//# sourceMappingURL=globalhandlers.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/linkederrors.js




const DEFAULT_KEY = 'cause';
const DEFAULT_LIMIT = 5;

/** Adds SDK info to an event. */
class LinkedErrors  {
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'LinkedErrors';}

  /**
   * @inheritDoc
   */
    __init() {this.name = LinkedErrors.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   constructor(options = {}) {;LinkedErrors.prototype.__init.call(this);
    this._key = options.key || DEFAULT_KEY;
    this._limit = options.limit || DEFAULT_LIMIT;
  }

  /**
   * @inheritDoc
   */
   setupOnce() {
    const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();
    if (!client) {
      return;
    }
    (0,esm_scope/* addGlobalEventProcessor */.c)((event, hint) => {
      const self = (0,esm_hub/* getCurrentHub */.Gd)().getIntegration(LinkedErrors);
      return self ? _handler(client.getOptions().stackParser, self._key, self._limit, event, hint) : event;
    });
  }
} LinkedErrors.__initStatic();

/**
 * @inheritDoc
 */
function _handler(
  parser,
  key,
  limit,
  event,
  hint,
) {
  if (!event.exception || !event.exception.values || !hint || !(0,is/* isInstanceOf */.V9)(hint.originalException, Error)) {
    return event;
  }
  const linkedErrors = _walkErrorTree(parser, limit, hint.originalException , key);
  event.exception.values = [...linkedErrors, ...event.exception.values];
  return event;
}

/**
 * JSDOC
 */
function _walkErrorTree(
  parser,
  limit,
  error,
  key,
  stack = [],
) {
  if (!(0,is/* isInstanceOf */.V9)(error[key], Error) || stack.length + 1 >= limit) {
    return stack;
  }
  const exception = exceptionFromError(parser, error[key]);
  return _walkErrorTree(parser, limit, error[key], key, [exception, ...stack]);
}


//# sourceMappingURL=linkederrors.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/dedupe.js


/** Deduplication filter */
class Dedupe  {constructor() { Dedupe.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'Dedupe';}

  /**
   * @inheritDoc
   */
   __init() {this.name = Dedupe.id;}

  /**
   * @inheritDoc
   */

  /**
   * @inheritDoc
   */
   setupOnce(addGlobalEventProcessor, getCurrentHub) {
    const eventProcessor = currentEvent => {
      const self = getCurrentHub().getIntegration(Dedupe);
      if (self) {
        // Juuust in case something goes wrong
        try {
          if (dedupe_shouldDropEvent(currentEvent, self._previousEvent)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Event dropped due to being a duplicate of previously captured event.');
            return null;
          }
        } catch (_oO) {
          return (self._previousEvent = currentEvent);
        }

        return (self._previousEvent = currentEvent);
      }
      return currentEvent;
    };

    eventProcessor.id = this.name;
    addGlobalEventProcessor(eventProcessor);
  }
} Dedupe.__initStatic();

/** JSDoc */
function dedupe_shouldDropEvent(currentEvent, previousEvent) {
  if (!previousEvent) {
    return false;
  }

  if (_isSameMessageEvent(currentEvent, previousEvent)) {
    return true;
  }

  if (_isSameExceptionEvent(currentEvent, previousEvent)) {
    return true;
  }

  return false;
}

/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
  const currentMessage = currentEvent.message;
  const previousMessage = previousEvent.message;

  // If neither event has a message property, they were both exceptions, so bail out
  if (!currentMessage && !previousMessage) {
    return false;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
    return false;
  }

  if (currentMessage !== previousMessage) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
  const previousException = _getExceptionFromEvent(previousEvent);
  const currentException = _getExceptionFromEvent(currentEvent);

  if (!previousException || !currentException) {
    return false;
  }

  if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
    return false;
  }

  if (!_isSameFingerprint(currentEvent, previousEvent)) {
    return false;
  }

  if (!_isSameStacktrace(currentEvent, previousEvent)) {
    return false;
  }

  return true;
}

/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
  let currentFrames = _getFramesFromEvent(currentEvent);
  let previousFrames = _getFramesFromEvent(previousEvent);

  // If neither event has a stacktrace, they are assumed to be the same
  if (!currentFrames && !previousFrames) {
    return true;
  }

  // If only one event has a stacktrace, but not the other one, they are not the same
  if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
    return false;
  }

  currentFrames = currentFrames ;
  previousFrames = previousFrames ;

  // If number of frames differ, they are not the same
  if (previousFrames.length !== currentFrames.length) {
    return false;
  }

  // Otherwise, compare the two
  for (let i = 0; i < previousFrames.length; i++) {
    const frameA = previousFrames[i];
    const frameB = currentFrames[i];

    if (
      frameA.filename !== frameB.filename ||
      frameA.lineno !== frameB.lineno ||
      frameA.colno !== frameB.colno ||
      frameA.function !== frameB.function
    ) {
      return false;
    }
  }

  return true;
}

/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
  let currentFingerprint = currentEvent.fingerprint;
  let previousFingerprint = previousEvent.fingerprint;

  // If neither event has a fingerprint, they are assumed to be the same
  if (!currentFingerprint && !previousFingerprint) {
    return true;
  }

  // If only one event has a fingerprint, but not the other one, they are not the same
  if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
    return false;
  }

  currentFingerprint = currentFingerprint ;
  previousFingerprint = previousFingerprint ;

  // Otherwise, compare the two
  try {
    return !!(currentFingerprint.join('') === previousFingerprint.join(''));
  } catch (_oO) {
    return false;
  }
}

/** JSDoc */
function _getExceptionFromEvent(event) {
  return event.exception && event.exception.values && event.exception.values[0];
}

/** JSDoc */
function _getFramesFromEvent(event) {
  const exception = event.exception;

  if (exception) {
    try {
      // @ts-ignore Object could be undefined
      return exception.values[0].stacktrace.frames;
    } catch (_oO) {
      return undefined;
    }
  }
  return undefined;
}


//# sourceMappingURL=dedupe.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/integrations/httpcontext.js



/** HttpContext integration collects information about HTTP request headers */
class HttpContext  {constructor() { HttpContext.prototype.__init.call(this); }
  /**
   * @inheritDoc
   */
   static __initStatic() {this.id = 'HttpContext';}

  /**
   * @inheritDoc
   */
   __init() {this.name = HttpContext.id;}

  /**
   * @inheritDoc
   */
   setupOnce() {
    (0,esm_scope/* addGlobalEventProcessor */.c)((event) => {
      if ((0,esm_hub/* getCurrentHub */.Gd)().getIntegration(HttpContext)) {
        // if none of the information we want exists, don't bother
        if (!helpers_WINDOW.navigator && !helpers_WINDOW.location && !helpers_WINDOW.document) {
          return event;
        }

        // grab as much info as exists and add it to the event
        const url = (event.request && event.request.url) || (helpers_WINDOW.location && helpers_WINDOW.location.href);
        const { referrer } = helpers_WINDOW.document || {};
        const { userAgent } = helpers_WINDOW.navigator || {};

        const headers = {
          ...(event.request && event.request.headers),
          ...(referrer && { Referer: referrer }),
          ...(userAgent && { 'User-Agent': userAgent }),
        };
        const request = { ...(url && { url }), headers };

        return { ...event, request };
      }
      return event;
    });
  }
} HttpContext.__initStatic();


//# sourceMappingURL=httpcontext.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/promisebuffer.js



/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
  const buffer = [];

  function isReady() {
    return limit === undefined || buffer.length < limit;
  }

  /**
   * Remove a promise from the queue.
   *
   * @param task Can be any PromiseLike<T>
   * @returns Removed promise.
   */
  function remove(task) {
    return buffer.splice(buffer.indexOf(task), 1)[0];
  }

  /**
   * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
   *
   * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
   *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
   *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
   *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
   *        limit check.
   * @returns The original promise.
   */
  function add(taskProducer) {
    if (!isReady()) {
      return (0,syncpromise/* rejectedSyncPromise */.$2)(new SentryError('Not adding Promise because buffer limit was reached.'));
    }

    // start the task and add its promise to the queue
    const task = taskProducer();
    if (buffer.indexOf(task) === -1) {
      buffer.push(task);
    }
    void task
      .then(() => remove(task))
      // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
      // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
      // have promises, so TS has to polyfill when down-compiling.)
      .then(null, () =>
        remove(task).then(null, () => {
          // We have to add another catch here because `remove()` starts a new promise chain.
        }),
      );
    return task;
  }

  /**
   * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
   *
   * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
   * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
   * `true`.
   * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
   * `false` otherwise
   */
  function drain(timeout) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      let counter = buffer.length;

      if (!counter) {
        return resolve(true);
      }

      // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
      const capturedSetTimeout = setTimeout(() => {
        if (timeout && timeout > 0) {
          resolve(false);
        }
      }, timeout);

      // if all promises resolve in time, cancel the timer and resolve to `true`
      buffer.forEach(item => {
        void (0,syncpromise/* resolvedSyncPromise */.WD)(item).then(() => {
          if (!--counter) {
            clearTimeout(capturedSetTimeout);
            resolve(true);
          }
        }, reject);
      });
    });
  }

  return {
    $: buffer,
    add,
    drain,
  };
}


//# sourceMappingURL=promisebuffer.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/ratelimit.js
// Intentionally keeping the key broad, as we don't know for sure what rate limit headers get returned from backend

const DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds

/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now = Date.now()) {
  const headerDelay = parseInt(`${header}`, 10);
  if (!isNaN(headerDelay)) {
    return headerDelay * 1000;
  }

  const headerDate = Date.parse(`${header}`);
  if (!isNaN(headerDate)) {
    return headerDate - now;
  }

  return DEFAULT_RETRY_AFTER;
}

/**
 * Gets the time that given category is disabled until for rate limiting
 */
function disabledUntil(limits, category) {
  return limits[category] || limits.all || 0;
}

/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, category, now = Date.now()) {
  return disabledUntil(limits, category) > now;
}

/**
 * Update ratelimits from incoming headers.
 * Returns true if headers contains a non-empty rate limiting header.
 */
function updateRateLimits(
  limits,
  { statusCode, headers },
  now = Date.now(),
) {
  const updatedRateLimits = {
    ...limits,
  };

  // "The name is case-insensitive."
  // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
  const rateLimitHeader = headers && headers['x-sentry-rate-limits'];
  const retryAfterHeader = headers && headers['retry-after'];

  if (rateLimitHeader) {
    /**
     * rate limit headers are of the form
     *     <header>,<header>,..
     * where each <header> is of the form
     *     <retry_after>: <categories>: <scope>: <reason_code>
     * where
     *     <retry_after> is a delay in seconds
     *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
     *         <category>;<category>;...
     *     <scope> is what's being limited (org, project, or key) - ignored by SDK
     *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
     */
    for (const limit of rateLimitHeader.trim().split(',')) {
      const [retryAfter, categories] = limit.split(':', 2);
      const headerDelay = parseInt(retryAfter, 10);
      const delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
      if (!categories) {
        updatedRateLimits.all = now + delay;
      } else {
        for (const category of categories.split(';')) {
          updatedRateLimits[category] = now + delay;
        }
      }
    }
  } else if (retryAfterHeader) {
    updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
  } else if (statusCode === 429) {
    updatedRateLimits.all = now + 60 * 1000;
  }

  return updatedRateLimits;
}


//# sourceMappingURL=ratelimit.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/core/esm/transports/base.js


const DEFAULT_TRANSPORT_BUFFER_SIZE = 30;

/**
 * Creates an instance of a Sentry `Transport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(
  options,
  makeRequest,
  buffer = makePromiseBuffer(options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE),
) {
  let rateLimits = {};

  const flush = (timeout) => buffer.drain(timeout);

  function send(envelope) {
    const filteredEnvelopeItems = [];

    // Drop rate limited items from envelope
    forEachEnvelopeItem(envelope, (item, type) => {
      const envelopeItemDataCategory = envelopeItemTypeToDataCategory(type);
      if (isRateLimited(rateLimits, envelopeItemDataCategory)) {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent('ratelimit_backoff', envelopeItemDataCategory, event);
      } else {
        filteredEnvelopeItems.push(item);
      }
    });

    // Skip sending if envelope is empty after filtering out rate limited events
    if (filteredEnvelopeItems.length === 0) {
      return (0,syncpromise/* resolvedSyncPromise */.WD)();
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const filteredEnvelope = createEnvelope(envelope[0], filteredEnvelopeItems );

    // Creates client report for each item in an envelope
    const recordEnvelopeLoss = (reason) => {
      forEachEnvelopeItem(filteredEnvelope, (item, type) => {
        const event = getEventForEnvelopeItem(item, type);
        options.recordDroppedEvent(reason, envelopeItemTypeToDataCategory(type), event);
      });
    };

    const requestTask = () =>
      makeRequest({ body: serializeEnvelope(filteredEnvelope, options.textEncoder) }).then(
        response => {
          // We don't want to throw on NOK responses, but we want to at least log them
          if (response.statusCode !== undefined && (response.statusCode < 200 || response.statusCode >= 300)) {
            (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`Sentry responded with status code ${response.statusCode} to sent event.`);
          }

          rateLimits = updateRateLimits(rateLimits, response);
        },
        error => {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Failed while sending event:', error);
          recordEnvelopeLoss('network_error');
        },
      );

    return buffer.add(requestTask).then(
      result => result,
      error => {
        if (error instanceof SentryError) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.error */.kg.error('Skipped sending event because buffer is full.');
          recordEnvelopeLoss('queue_overflow');
          return (0,syncpromise/* resolvedSyncPromise */.WD)();
        } else {
          throw error;
        }
      },
    );
  }

  return {
    send,
    flush,
  };
}

function getEventForEnvelopeItem(item, type) {
  if (type !== 'event' && type !== 'transaction') {
    return undefined;
  }

  return Array.isArray(item) ? (item )[1] : undefined;
}


//# sourceMappingURL=base.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/utils.js



let cachedFetchImpl = undefined;

/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
  if (cachedFetchImpl) {
    return cachedFetchImpl;
  }

  /* eslint-disable @typescript-eslint/unbound-method */

  // Fast path to avoid DOM I/O
  if ((0,supports/* isNativeFetch */.Du)(helpers_WINDOW.fetch)) {
    return (cachedFetchImpl = helpers_WINDOW.fetch.bind(helpers_WINDOW));
  }

  const document = helpers_WINDOW.document;
  let fetchImpl = helpers_WINDOW.fetch;
  // eslint-disable-next-line deprecation/deprecation
  if (document && typeof document.createElement === 'function') {
    try {
      const sandbox = document.createElement('iframe');
      sandbox.hidden = true;
      document.head.appendChild(sandbox);
      const contentWindow = sandbox.contentWindow;
      if (contentWindow && contentWindow.fetch) {
        fetchImpl = contentWindow.fetch;
      }
      document.head.removeChild(sandbox);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
    }
  }

  return (cachedFetchImpl = fetchImpl.bind(helpers_WINDOW));
  /* eslint-enable @typescript-eslint/unbound-method */
}

/** Clears cached fetch impl */
function clearCachedFetchImplementation() {
  cachedFetchImpl = undefined;
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/fetch.js




/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeFetchTransport(
  options,
  nativeFetch = getNativeFetchImplementation(),
) {
  function makeRequest(request) {
    const requestOptions = {
      body: request.body,
      method: 'POST',
      referrerPolicy: 'origin',
      headers: options.headers,
      // Outgoing requests are usually cancelled when navigating to a different page, causing a "TypeError: Failed to
      // fetch" error and sending a "network_error" client-outcome - in Chrome, the request status shows "(cancelled)".
      // The `keepalive` flag keeps outgoing requests alive, even when switching pages. We want this since we're
      // frequently sending events right before the user is switching pages (eg. whenfinishing navigation transactions).
      // Gotchas:
      // - `keepalive` isn't supported by Firefox
      // - As per spec (https://fetch.spec.whatwg.org/#http-network-or-cache-fetch), a request with `keepalive: true`
      //   and a content length of > 64 kibibytes returns a network error. We will therefore only activate the flag when
      //   we're below that limit.
      keepalive: request.body.length <= 65536,
      ...options.fetchOptions,
    };

    try {
      return nativeFetch(options.url, requestOptions).then(response => ({
        statusCode: response.status,
        headers: {
          'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
          'retry-after': response.headers.get('Retry-After'),
        },
      }));
    } catch (e) {
      clearCachedFetchImplementation();
      return (0,syncpromise/* rejectedSyncPromise */.$2)(e);
    }
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=fetch.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/transports/xhr.js



/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
const XHR_READYSTATE_DONE = 4;

/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeXHRTransport(options) {
  function makeRequest(request) {
    return new syncpromise/* SyncPromise */.cW((resolve, reject) => {
      const xhr = new XMLHttpRequest();

      xhr.onerror = reject;

      xhr.onreadystatechange = () => {
        if (xhr.readyState === XHR_READYSTATE_DONE) {
          resolve({
            statusCode: xhr.status,
            headers: {
              'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
              'retry-after': xhr.getResponseHeader('Retry-After'),
            },
          });
        }
      };

      xhr.open('POST', options.url);

      for (const header in options.headers) {
        if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
          xhr.setRequestHeader(header, options.headers[header]);
        }
      }

      xhr.send(request.body);
    });
  }

  return createTransport(options, makeRequest);
}


//# sourceMappingURL=xhr.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/browser/esm/sdk.js
















const defaultIntegrations = [
  new InboundFilters(),
  new FunctionToString(),
  new TryCatch(),
  new Breadcrumbs(),
  new GlobalHandlers(),
  new LinkedErrors(),
  new Dedupe(),
  new HttpContext(),
];

/**
 * A magic string that build tooling can leverage in order to inject a release value into the SDK.
 */

/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init(options = {}) {
  if (options.defaultIntegrations === undefined) {
    options.defaultIntegrations = defaultIntegrations;
  }
  if (options.release === undefined) {
    // This allows build tooling to find-and-replace __SENTRY_RELEASE__ to inject a release value
    if (typeof __SENTRY_RELEASE__ === 'string') {
      options.release = __SENTRY_RELEASE__;
    }

    // This supports the variable that sentry-webpack-plugin injects
    if (helpers_WINDOW.SENTRY_RELEASE && helpers_WINDOW.SENTRY_RELEASE.id) {
      options.release = helpers_WINDOW.SENTRY_RELEASE.id;
    }
  }
  if (options.autoSessionTracking === undefined) {
    options.autoSessionTracking = true;
  }
  if (options.sendClientReports === undefined) {
    options.sendClientReports = true;
  }

  const clientOptions = {
    ...options,
    stackParser: (0,stacktrace/* stackParserFromStackParserOptions */.Sq)(options.stackParser || defaultStackParser),
    integrations: getIntegrationsToSetup(options),
    transport: options.transport || ((0,supports/* supportsFetch */.Ak)() ? makeFetchTransport : makeXHRTransport),
  };

  initAndBind(BrowserClient, clientOptions);

  if (options.autoSessionTracking) {
    startSessionTracking();
  }
}

/**
 * Present the user with a report dialog.
 *
 * @param options Everything is optional, we try to fetch all info need from the global scope.
 */
function showReportDialog(options = {}, hub = getCurrentHub()) {
  // doesn't work without a document (React Native)
  if (!WINDOW.document) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Global document not defined in showReportDialog call');
    return;
  }

  const { client, scope } = hub.getStackTop();
  const dsn = options.dsn || (client && client.getDsn());
  if (!dsn) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('DSN not configured for showReportDialog call');
    return;
  }

  if (scope) {
    options.user = {
      ...scope.getUser(),
      ...options.user,
    };
  }

  if (!options.eventId) {
    options.eventId = hub.lastEventId();
  }

  const script = WINDOW.document.createElement('script');
  script.async = true;
  script.src = getReportDialogEndpoint(dsn, options);

  if (options.onLoad) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    script.onload = options.onLoad;
  }

  const injectionPoint = WINDOW.document.head || WINDOW.document.body;
  if (injectionPoint) {
    injectionPoint.appendChild(script);
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.error('Not injecting report dialog. No injection point found in HTML');
  }
}

/**
 * This is the getter for lastEventId.
 *
 * @returns The last event id of a captured event.
 */
function lastEventId() {
  return getCurrentHub().lastEventId();
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function forceLoad() {
  // Noop
}

/**
 * This function is here to be API compatible with the loader.
 * @hidden
 */
function onLoad(callback) {
  callback();
}

/**
 * Call `flush()` on the current client, if there is one. See {@link Client.flush}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue. Omitting this parameter will cause
 * the client to wait until all events are sent before resolving the promise.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function flush(timeout) {
  const client = getCurrentHub().getClient();
  if (client) {
    return client.flush(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events. No client defined.');
  return resolvedSyncPromise(false);
}

/**
 * Call `close()` on the current client, if there is one. See {@link Client.close}.
 *
 * @param timeout Maximum time in ms the client should wait to flush its event queue before shutting down. Omitting this
 * parameter will cause the client to wait until all events are sent before disabling itself.
 * @returns A promise which resolves to `true` if the queue successfully drains before the timeout, or `false` if it
 * doesn't (or if there's no client defined).
 */
function sdk_close(timeout) {
  const client = getCurrentHub().getClient();
  if (client) {
    return client.close(timeout);
  }
  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && logger.warn('Cannot flush events and disable SDK. No client defined.');
  return resolvedSyncPromise(false);
}

/**
 * Wrap code within a try/catch block so the SDK is able to capture errors.
 *
 * @param fn A function to wrap.
 *
 * @returns The result of wrapped function call.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function sdk_wrap(fn) {
  return wrap$1(fn)();
}

function startSessionOnHub(hub) {
  hub.startSession({ ignoreDuration: true });
  hub.captureSession();
}

/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
  if (typeof helpers_WINDOW.document === 'undefined') {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
    return;
  }

  const hub = (0,esm_hub/* getCurrentHub */.Gd)();

  // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
  // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
  // pinned at the same version in package.json, but there are edge cases where it's possible. See
  // https://github.com/getsentry/sentry-javascript/issues/3207 and
  // https://github.com/getsentry/sentry-javascript/issues/3234 and
  // https://github.com/getsentry/sentry-javascript/issues/3278.
  if (!hub.captureSession) {
    return;
  }

  // The session duration for browser sessions does not track a meaningful
  // concept that can be used as a metric.
  // Automatically captured sessions are akin to page views, and thus we
  // discard their duration.
  startSessionOnHub(hub);

  // We want to create a session for every navigation as well
  (0,instrument/* addInstrumentationHandler */.o)('history', ({ from, to }) => {
    // Don't create an additional session for the initial route or if the location did not change
    if (!(from === undefined || from === to)) {
      startSessionOnHub((0,esm_hub/* getCurrentHub */.Gd)());
    }
  });
}


//# sourceMappingURL=sdk.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/sdk.js


/**
 * Inits the React SDK
 */
function sdk_init(options) {
  options._metadata = options._metadata || {};
  options._metadata.sdk = options._metadata.sdk || {
    name: 'sentry.javascript.react',
    packages: [
      {
        name: 'npm:@sentry/react',
        version: SDK_VERSION,
      },
    ],
    version: SDK_VERSION,
  };
  init(options);
}


//# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(62758);
// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/utils.js
var utils = __webpack_require__(63233);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/buildPolyfills/_nullishCoalesce.js
var _nullishCoalesce = __webpack_require__(45375);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/tracing.js
const TRACEPARENT_REGEXP = new RegExp(
  '^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$', // whitespace
);

/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
  const matches = traceparent.match(TRACEPARENT_REGEXP);

  if (!traceparent || !matches) {
    // empty string or no matches is invalid traceparent data
    return undefined;
  }

  let parentSampled;
  if (matches[3] === '1') {
    parentSampled = true;
  } else if (matches[3] === '0') {
    parentSampled = false;
  }

  return {
    traceId: matches[1],
    parentSampled,
    parentSpanId: matches[2],
  };
}


//# sourceMappingURL=tracing.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/baggage.js



const BAGGAGE_HEADER_NAME = 'baggage';

const SENTRY_BAGGAGE_KEY_PREFIX = 'sentry-';

const SENTRY_BAGGAGE_KEY_PREFIX_REGEX = /^sentry-/;

/**
 * Max length of a serialized baggage string
 *
 * https://www.w3.org/TR/baggage/#limits
 */
const MAX_BAGGAGE_STRING_LENGTH = 8192;

/**
 * Takes a baggage header and turns it into Dynamic Sampling Context, by extracting all the "sentry-" prefixed values
 * from it.
 *
 * @param baggageHeader A very bread definition of a baggage header as it might appear in various frameworks.
 * @returns The Dynamic Sampling Context that was found on `baggageHeader`, if there was any, `undefined` otherwise.
 */
function baggageHeaderToDynamicSamplingContext(
  // Very liberal definition of what any incoming header might look like
  baggageHeader,
) {
  if (!(0,is/* isString */.HD)(baggageHeader) && !Array.isArray(baggageHeader)) {
    return undefined;
  }

  // Intermediary object to store baggage key value pairs of incoming baggage headers on.
  // It is later used to read Sentry-DSC-values from.
  let baggageObject = {};

  if (Array.isArray(baggageHeader)) {
    // Combine all baggage headers into one object containing the baggage values so we can later read the Sentry-DSC-values from it
    baggageObject = baggageHeader.reduce((acc, curr) => {
      const currBaggageObject = baggageHeaderToObject(curr);
      return {
        ...acc,
        ...currBaggageObject,
      };
    }, {});
  } else {
    // Return undefined if baggage header is an empty string (technically an empty baggage header is not spec conform but
    // this is how we choose to handle it)
    if (!baggageHeader) {
      return undefined;
    }

    baggageObject = baggageHeaderToObject(baggageHeader);
  }

  // Read all "sentry-" prefixed values out of the baggage object and put it onto a dynamic sampling context object.
  const dynamicSamplingContext = Object.entries(baggageObject).reduce((acc, [key, value]) => {
    if (key.match(SENTRY_BAGGAGE_KEY_PREFIX_REGEX)) {
      const nonPrefixedKey = key.slice(SENTRY_BAGGAGE_KEY_PREFIX.length);
      acc[nonPrefixedKey] = value;
    }
    return acc;
  }, {});

  // Only return a dynamic sampling context object if there are keys in it.
  // A keyless object means there were no sentry values on the header, which means that there is no DSC.
  if (Object.keys(dynamicSamplingContext).length > 0) {
    return dynamicSamplingContext ;
  } else {
    return undefined;
  }
}

/**
 * Turns a Dynamic Sampling Object into a baggage header by prefixing all the keys on the object with "sentry-".
 *
 * @param dynamicSamplingContext The Dynamic Sampling Context to turn into a header. For convenience and compatibility
 * with the `getDynamicSamplingContext` method on the Transaction class ,this argument can also be `undefined`. If it is
 * `undefined` the function will return `undefined`.
 * @returns a baggage header, created from `dynamicSamplingContext`, or `undefined` either if `dynamicSamplingContext`
 * was `undefined`, or if `dynamicSamplingContext` didn't contain any values.
 */
function dynamicSamplingContextToSentryBaggageHeader(
  // this also takes undefined for convenience and bundle size in other places
  dynamicSamplingContext,
) {
  // Prefix all DSC keys with "sentry-" and put them into a new object
  const sentryPrefixedDSC = Object.entries(dynamicSamplingContext).reduce(
    (acc, [dscKey, dscValue]) => {
      if (dscValue) {
        acc[`${SENTRY_BAGGAGE_KEY_PREFIX}${dscKey}`] = dscValue;
      }
      return acc;
    },
    {},
  );

  return objectToBaggageHeader(sentryPrefixedDSC);
}

/**
 * Will parse a baggage header, which is a simple key-value map, into a flat object.
 *
 * @param baggageHeader The baggage header to parse.
 * @returns a flat object containing all the key-value pairs from `baggageHeader`.
 */
function baggageHeaderToObject(baggageHeader) {
  return baggageHeader
    .split(',')
    .map(baggageEntry => baggageEntry.split('=').map(keyOrValue => decodeURIComponent(keyOrValue.trim())))
    .reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
}

/**
 * Turns a flat object (key-value pairs) into a baggage header, which is also just key-value pairs.
 *
 * @param object The object to turn into a baggage header.
 * @returns a baggage header string, or `undefined` if the object didn't have any values, since an empty baggage header
 * is not spec compliant.
 */
function objectToBaggageHeader(object) {
  if (Object.keys(object).length === 0) {
    // An empty baggage header is not spec compliant: We return undefined.
    return undefined;
  }

  return Object.entries(object).reduce((baggageHeader, [objectKey, objectValue], currentIndex) => {
    const baggageEntry = `${encodeURIComponent(objectKey)}=${encodeURIComponent(objectValue)}`;
    const newBaggageHeader = currentIndex === 0 ? baggageEntry : `${baggageHeader},${baggageEntry}`;
    if (newBaggageHeader.length > MAX_BAGGAGE_STRING_LENGTH) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(
          `Not adding key: ${objectKey} with val: ${objectValue} to baggage header due to exceeding baggage size limits.`,
        );
      return baggageHeader;
    } else {
      return newBaggageHeader;
    }
  }, '');
}


//# sourceMappingURL=baggage.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/tracing/esm/idletransaction.js
var idletransaction = __webpack_require__(16458);
;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/types.js


const types_WINDOW = worldwide/* GLOBAL_OBJ */.n2 ;


//# sourceMappingURL=types.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/backgroundtab.js




/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
  if (types_WINDOW && types_WINDOW.document) {
    types_WINDOW.document.addEventListener('visibilitychange', () => {
      const activeTransaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (types_WINDOW.document.hidden && activeTransaction) {
        const statusType = 'cancelled';

        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          esm_logger/* logger.log */.kg.log(
            `[Tracing] Transaction: ${statusType} -> since tab moved to the background, op: ${activeTransaction.op}`,
          );
        // We should not set status if it is already set, this prevent important statuses like
        // error or data loss from being overwritten on transaction.
        if (!activeTransaction.status) {
          activeTransaction.setStatus(statusType);
        }
        activeTransaction.setTag('visibilitychange', 'document.hidden');
        activeTransaction.finish();
      }
    });
  } else {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
      esm_logger/* logger.warn */.kg.warn('[Tracing] Could not set up background tab detection due to lack of global document');
  }
}


//# sourceMappingURL=backgroundtab.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/bindReporter.js
const bindReporter = (
  callback,
  metric,
  reportAllChanges,
) => {
  let prevValue;
  let delta;
  return (forceReport) => {
    if (metric.value >= 0) {
      if (forceReport || reportAllChanges) {
        delta = metric.value - (prevValue || 0);

        // Report the metric if there's a non-zero delta or if no previous
        // value exists (which can happen in the case of the document becoming
        // hidden when the metric value is 0).
        // See: https://github.com/GoogleChrome/web-vitals/issues/14
        if (delta || prevValue === undefined) {
          prevValue = metric.value;
          metric.delta = delta;
          callback(metric);
        }
      }
    }
  };
};


//# sourceMappingURL=bindReporter.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/generateUniqueID.js
/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
const generateUniqueID = () => {
  return `v3-${Date.now()}-${Math.floor(Math.random() * (9e12 - 1)) + 1e12}`;
};


//# sourceMappingURL=generateUniqueID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getNavigationEntry.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getNavigationEntryFromPerformanceTiming = () => {
  // eslint-disable-next-line deprecation/deprecation
  const timing = types_WINDOW.performance.timing;
  // eslint-disable-next-line deprecation/deprecation
  const type = types_WINDOW.performance.navigation.type;

  const navigationEntry = {
    entryType: 'navigation',
    startTime: 0,
    type: type == 2 ? 'back_forward' : type === 1 ? 'reload' : 'navigate',
  };

  for (const key in timing) {
    if (key !== 'navigationStart' && key !== 'toJSON') {
      navigationEntry[key] = Math.max((timing[key ] ) - timing.navigationStart, 0);
    }
  }
  return navigationEntry ;
};

const getNavigationEntry = () => {
  if (types_WINDOW.__WEB_VITALS_POLYFILL__) {
    return (
      types_WINDOW.performance &&
      ((performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) ||
        getNavigationEntryFromPerformanceTiming())
    );
  } else {
    return types_WINDOW.performance && performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
  }
};


//# sourceMappingURL=getNavigationEntry.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getActivationStart.js


/*
 * Copyright 2022 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const getActivationStart = () => {
  const navEntry = getNavigationEntry();
  return (navEntry && navEntry.activationStart) || 0;
};


//# sourceMappingURL=getActivationStart.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/initMetric.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const initMetric = (name, value) => {
  const navEntry = getNavigationEntry();
  let navigationType = 'navigate';

  if (navEntry) {
    if (types_WINDOW.document.prerendering || getActivationStart() > 0) {
      navigationType = 'prerender';
    } else {
      navigationType = navEntry.type.replace(/_/g, '-') ;
    }
  }

  return {
    name,
    value: typeof value === 'undefined' ? -1 : value,
    rating: 'good', // Will be updated if the value changes.
    delta: 0,
    entries: [],
    id: generateUniqueID(),
    navigationType,
  };
};


//# sourceMappingURL=initMetric.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/observe.js
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
const observe = (
  type,
  callback,
  opts,
) => {
  try {
    if (PerformanceObserver.supportedEntryTypes.includes(type)) {
      const po = new PerformanceObserver(list => {
        callback(list.getEntries() );
      });
      po.observe(
        Object.assign(
          {
            type,
            buffered: true,
          },
          opts || {},
        ) ,
      );
      return po;
    }
  } catch (e) {
    // Do nothing.
  }
  return;
};


//# sourceMappingURL=observe.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/onHidden.js


/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const onHidden = (cb, once) => {
  const onHiddenOrPageHide = (event) => {
    if (event.type === 'pagehide' || types_WINDOW.document.visibilityState === 'hidden') {
      cb(event);
      if (once) {
        removeEventListener('visibilitychange', onHiddenOrPageHide, true);
        removeEventListener('pagehide', onHiddenOrPageHide, true);
      }
    }
  };
  addEventListener('visibilitychange', onHiddenOrPageHide, true);
  // Some browsers have buggy implementations of visibilitychange,
  // so we use pagehide in addition, just to be safe.
  addEventListener('pagehide', onHiddenOrPageHide, true);
};


//# sourceMappingURL=onHidden.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getCLS.js





/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [CLS](https://web.dev/cls/) value for the current page and
 * calls the `callback` function once the value is ready to be reported, along
 * with all `layout-shift` performance entries that were used in the metric
 * value calculation. The reported value is a `double` (corresponding to a
 * [layout shift score](https://web.dev/cls/#layout-shift-score)).
 *
 * If the `reportAllChanges` configuration option is set to `true`, the
 * `callback` function will be called as soon as the value is initially
 * determined as well as any time the value changes throughout the page
 * lifespan.
 *
 * _**Important:** CLS should be continually monitored for changes throughout
 * the entire lifespan of a page—including if the user returns to the page after
 * it's been hidden/backgrounded. However, since browsers often [will not fire
 * additional callbacks once the user has backgrounded a
 * page](https://developer.chrome.com/blog/page-lifecycle-api/#advice-hidden),
 * `callback` is always called when the page's visibility state changes to
 * hidden. As a result, the `callback` function might be called multiple times
 * during the same page load._
 */
const onCLS = (onReport) => {
  const metric = initMetric('CLS', 0);
  let report;

  let sessionValue = 0;
  let sessionEntries = [];

  // const handleEntries = (entries: Metric['entries']) => {
  const handleEntries = (entries) => {
    entries.forEach(entry => {
      // Only count layout shifts without recent user input.
      if (!entry.hadRecentInput) {
        const firstSessionEntry = sessionEntries[0];
        const lastSessionEntry = sessionEntries[sessionEntries.length - 1];

        // If the entry occurred less than 1 second after the previous entry and
        // less than 5 seconds after the first entry in the session, include the
        // entry in the current session. Otherwise, start a new session.
        if (
          sessionValue &&
          sessionEntries.length !== 0 &&
          entry.startTime - lastSessionEntry.startTime < 1000 &&
          entry.startTime - firstSessionEntry.startTime < 5000
        ) {
          sessionValue += entry.value;
          sessionEntries.push(entry);
        } else {
          sessionValue = entry.value;
          sessionEntries = [entry];
        }

        // If the current session value is larger than the current CLS value,
        // update CLS and the entries contributing to it.
        if (sessionValue > metric.value) {
          metric.value = sessionValue;
          metric.entries = sessionEntries;
          if (report) {
            report();
          }
        }
      }
    });
  };

  const po = observe('layout-shift', handleEntries);
  if (po) {
    report = bindReporter(onReport, metric);

    onHidden(() => {
      handleEntries(po.takeRecords() );
      report(true);
    });
  }
};


//# sourceMappingURL=getCLS.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/lib/getVisibilityWatcher.js



/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

let firstHiddenTime = -1;

const initHiddenTime = () => {
  // If the document is hidden and not prerendering, assume it was always
  // hidden and the page was loaded in the background.
  return types_WINDOW.document.visibilityState === 'hidden' && !types_WINDOW.document.prerendering ? 0 : Infinity;
};

const trackChanges = () => {
  // Update the time if/when the document becomes hidden.
  onHidden(({ timeStamp }) => {
    firstHiddenTime = timeStamp;
  }, true);
};

const getVisibilityWatcher = (

) => {
  if (firstHiddenTime < 0) {
    // If the document is hidden when this code runs, assume it was hidden
    // since navigation start. This isn't a perfect heuristic, but it's the
    // best we can do until an API is available to support querying past
    // visibilityState.
    firstHiddenTime = initHiddenTime();
    trackChanges();
  }
  return {
    get firstHiddenTime() {
      return firstHiddenTime;
    },
  };
};


//# sourceMappingURL=getVisibilityWatcher.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getFID.js






/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Calculates the [FID](https://web.dev/fid/) value for the current page and
 * calls the `callback` function once the value is ready, along with the
 * relevant `first-input` performance entry used to determine the value. The
 * reported value is a `DOMHighResTimeStamp`.
 *
 * _**Important:** since FID is only reported after the user interacts with the
 * page, it's possible that it will not be reported for some page loads._
 */
const onFID = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('FID');
  // eslint-disable-next-line prefer-const
  let report;

  const handleEntry = (entry) => {
    // Only report if the page wasn't hidden prior to the first input.
    if (entry.startTime < visibilityWatcher.firstHiddenTime) {
      metric.value = entry.processingStart - entry.startTime;
      metric.entries.push(entry);
      report(true);
    }
  };

  const handleEntries = (entries) => {
    (entries ).forEach(handleEntry);
  };

  const po = observe('first-input', handleEntries);
  report = bindReporter(onReport, metric);

  if (po) {
    onHidden(() => {
      handleEntries(po.takeRecords() );
      po.disconnect();
    }, true);
  }
};


//# sourceMappingURL=getFID.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/web-vitals/getLCP.js







/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

const reportedMetricIDs = {};

/**
 * Calculates the [LCP](https://web.dev/lcp/) value for the current page and
 * calls the `callback` function once the value is ready (along with the
 * relevant `largest-contentful-paint` performance entry used to determine the
 * value). The reported value is a `DOMHighResTimeStamp`.
 */
const onLCP = (onReport) => {
  const visibilityWatcher = getVisibilityWatcher();
  const metric = initMetric('LCP');
  let report;

  const handleEntries = (entries) => {
    const lastEntry = entries[entries.length - 1] ;
    if (lastEntry) {
      // The startTime attribute returns the value of the renderTime if it is
      // not 0, and the value of the loadTime otherwise. The activationStart
      // reference is used because LCP should be relative to page activation
      // rather than navigation start if the page was prerendered.
      const value = Math.max(lastEntry.startTime - getActivationStart(), 0);

      // Only report if the page wasn't hidden prior to LCP.
      if (value < visibilityWatcher.firstHiddenTime) {
        metric.value = value;
        metric.entries = [lastEntry];
        report();
      }
    }
  };

  const po = observe('largest-contentful-paint', handleEntries);

  if (po) {
    report = bindReporter(onReport, metric);

    const stopListening = () => {
      if (!reportedMetricIDs[metric.id]) {
        handleEntries(po.takeRecords() );
        po.disconnect();
        reportedMetricIDs[metric.id] = true;
        report(true);
      }
    };

    // Stop listening after input. Note: while scrolling is an input that
    // stop LCP observation, it's unreliable since it can be programmatically
    // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
    ['keydown', 'click'].forEach(type => {
      addEventListener(type, stopListening, { once: true, capture: true });
    });

    onHidden(stopListening, true);
  }
};


//# sourceMappingURL=getLCP.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/metrics/utils.js
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
  return typeof value === 'number' && isFinite(value);
}

/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, { startTimestamp, ...ctx }) {
  if (startTimestamp && transaction.startTimestamp > startTimestamp) {
    transaction.startTimestamp = startTimestamp;
  }

  return transaction.startChild({
    startTimestamp,
    ...ctx,
  });
}


//# sourceMappingURL=utils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/metrics/index.js











function getBrowserPerformanceAPI() {
  return types_WINDOW && types_WINDOW.addEventListener && types_WINDOW.performance;
}

let _performanceCursor = 0;

let _measurements = {};
let _lcpEntry;
let _clsEntry;

/**
 * Start tracking web vitals
 */
function startTrackingWebVitals() {
  const performance = getBrowserPerformanceAPI();
  if (performance && time/* browserPerformanceTimeOrigin */.Z1) {
    if (performance.mark) {
      types_WINDOW.performance.mark('sentry-tracing-init');
    }
    _trackCLS();
    _trackLCP();
    _trackFID();
  }
}

/**
 * Start tracking long tasks.
 */
function startTrackingLongTasks() {
  const entryHandler = (entries) => {
    for (const entry of entries) {
      const transaction = (0,utils/* getActiveTransaction */.x1)() ;
      if (!transaction) {
        return;
      }
      const startTime = (0,utils/* msToSec */.XL)((time/* browserPerformanceTimeOrigin */.Z1 ) + entry.startTime);
      const duration = (0,utils/* msToSec */.XL)(entry.duration);

      transaction.startChild({
        description: 'Main UI thread blocked',
        op: 'ui.long-task',
        startTimestamp: startTime,
        endTimestamp: startTime + duration,
      });
    }
  };

  observe('longtask', entryHandler);
}

/** Starts tracking the Cumulative Layout Shift on the current page. */
function _trackCLS() {
  // See:
  // https://web.dev/evolving-cls/
  // https://web.dev/cls-web-tooling/
  onCLS(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS');
    _measurements['cls'] = { value: metric.value, unit: '' };
    _clsEntry = entry ;
  });
}

/** Starts tracking the Largest Contentful Paint on the current page. */
function _trackLCP() {
  onLCP(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP');
    _measurements['lcp'] = { value: metric.value, unit: 'millisecond' };
    _lcpEntry = entry ;
  });
}

/** Starts tracking the First Input Delay on the current page. */
function _trackFID() {
  onFID(metric => {
    const entry = metric.entries.pop();
    if (!entry) {
      return;
    }

    const timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1 );
    const startTime = (0,utils/* msToSec */.XL)(entry.startTime);
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FID');
    _measurements['fid'] = { value: metric.value, unit: 'millisecond' };
    _measurements['mark.fid'] = { value: timeOrigin + startTime, unit: 'second' };
  });
}

/** Add performance related spans to a transaction */
function addPerformanceEntries(transaction) {
  const performance = getBrowserPerformanceAPI();
  if (!performance || !types_WINDOW.performance.getEntries || !time/* browserPerformanceTimeOrigin */.Z1) {
    // Gatekeeper if performance API not available
    return;
  }

  (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Tracing] Adding & adjusting spans using Performance API');
  const timeOrigin = (0,utils/* msToSec */.XL)(time/* browserPerformanceTimeOrigin */.Z1);

  const performanceEntries = performance.getEntries();

  let responseStartTimestamp;
  let requestStartTimestamp;

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  performanceEntries.slice(_performanceCursor).forEach((entry) => {
    const startTime = (0,utils/* msToSec */.XL)(entry.startTime);
    const duration = (0,utils/* msToSec */.XL)(entry.duration);

    if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
      return;
    }

    switch (entry.entryType) {
      case 'navigation': {
        _addNavigationSpans(transaction, entry, timeOrigin);
        responseStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart);
        requestStartTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart);
        break;
      }
      case 'mark':
      case 'paint':
      case 'measure': {
        _addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);

        // capture web vitals
        const firstHidden = getVisibilityWatcher();
        // Only report if the page wasn't hidden prior to the web vital.
        const shouldRecord = entry.startTime < firstHidden.firstHiddenTime;

        if (entry.name === 'first-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FP');
          _measurements['fp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        if (entry.name === 'first-contentful-paint' && shouldRecord) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding FCP');
          _measurements['fcp'] = { value: entry.startTime, unit: 'millisecond' };
        }
        break;
      }
      case 'resource': {
        const resourceName = (entry.name ).replace(types_WINDOW.location.origin, '');
        _addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
        break;
      }
      default:
      // Ignore other entry types.
    }
  });

  _performanceCursor = Math.max(performanceEntries.length - 1, 0);

  _trackNavigator(transaction);

  // Measurements are only available for pageload transactions
  if (transaction.op === 'pageload') {
    // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
    // start of the response in milliseconds
    if (typeof responseStartTimestamp === 'number') {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding TTFB');
      _measurements['ttfb'] = {
        value: (responseStartTimestamp - transaction.startTimestamp) * 1000,
        unit: 'millisecond',
      };

      if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
        // Capture the time spent making the request and receiving the first byte of the response.
        // This is the time between the start of the request and the start of the response in milliseconds.
        _measurements['ttfb.requestTime'] = {
          value: (responseStartTimestamp - requestStartTimestamp) * 1000,
          unit: 'millisecond',
        };
      }
    }

    ['fcp', 'fp', 'lcp'].forEach(name => {
      if (!_measurements[name] || timeOrigin >= transaction.startTimestamp) {
        return;
      }
      // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
      // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
      // to be adjusted to be relative to transaction.startTimestamp.
      const oldValue = _measurements[name].value;
      const measurementTimestamp = timeOrigin + (0,utils/* msToSec */.XL)(oldValue);

      // normalizedValue should be in milliseconds
      const normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
      const delta = normalizedValue - oldValue;

      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.log */.kg.log(`[Measurements] Normalized ${name} from ${oldValue} to ${normalizedValue} (${delta})`);
      _measurements[name].value = normalizedValue;
    });

    const fidMark = _measurements['mark.fid'];
    if (fidMark && _measurements['fid']) {
      // create span for FID
      _startChild(transaction, {
        description: 'first input delay',
        endTimestamp: fidMark.value + (0,utils/* msToSec */.XL)(_measurements['fid'].value),
        op: 'ui.action',
        startTimestamp: fidMark.value,
      });

      // Delete mark.fid as we don't want it to be part of final payload
      delete _measurements['mark.fid'];
    }

    // If FCP is not recorded we should not record the cls value
    // according to the new definition of CLS.
    if (!('fcp' in _measurements)) {
      delete _measurements.cls;
    }

    Object.keys(_measurements).forEach(measurementName => {
      transaction.setMeasurement(
        measurementName,
        _measurements[measurementName].value,
        _measurements[measurementName].unit,
      );
    });

    _tagMetricInfo(transaction);
  }

  _lcpEntry = undefined;
  _clsEntry = undefined;
  _measurements = {};
}

/** Create measure related spans */
function _addMeasureSpans(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  startTime,
  duration,
  timeOrigin,
) {
  const measureStartTimestamp = timeOrigin + startTime;
  const measureEndTimestamp = measureStartTimestamp + duration;

  _startChild(transaction, {
    description: entry.name ,
    endTimestamp: measureEndTimestamp,
    op: entry.entryType ,
    startTimestamp: measureStartTimestamp,
  });

  return measureStartTimestamp;
}

/** Instrument navigation entries */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addNavigationSpans(transaction, entry, timeOrigin) {
  ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(event => {
    _addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
  });
  _addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
  _addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
  _addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
  _addRequest(transaction, entry, timeOrigin);
}

/** Create performance navigation related spans */
function _addPerformanceNavigationTiming(
  transaction,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  entry,
  event,
  timeOrigin,
  description,
  eventEnd,
) {
  const end = eventEnd ? (entry[eventEnd] ) : (entry[`${event}End`] );
  const start = entry[`${event}Start`] ;
  if (!start || !end) {
    return;
  }
  _startChild(transaction, {
    op: 'browser',
    description: (0,_nullishCoalesce/* _nullishCoalesce */.h)(description, () => ( event)),
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(start),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(end),
  });
}

/** Create request and response related spans */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _addRequest(transaction, entry, timeOrigin) {
  _startChild(transaction, {
    op: 'browser',
    description: 'request',
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.requestStart ),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd ),
  });

  _startChild(transaction, {
    op: 'browser',
    description: 'response',
    startTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseStart ),
    endTimestamp: timeOrigin + (0,utils/* msToSec */.XL)(entry.responseEnd ),
  });
}

/** Create resource-related spans */
function _addResourceSpans(
  transaction,
  entry,
  resourceName,
  startTime,
  duration,
  timeOrigin,
) {
  // we already instrument based on fetch and xhr, so we don't need to
  // duplicate spans here.
  if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
    return;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const data = {};
  if ('transferSize' in entry) {
    data['Transfer Size'] = entry.transferSize;
  }
  if ('encodedBodySize' in entry) {
    data['Encoded Body Size'] = entry.encodedBodySize;
  }
  if ('decodedBodySize' in entry) {
    data['Decoded Body Size'] = entry.decodedBodySize;
  }

  const startTimestamp = timeOrigin + startTime;
  const endTimestamp = startTimestamp + duration;

  _startChild(transaction, {
    description: resourceName,
    endTimestamp,
    op: entry.initiatorType ? `resource.${entry.initiatorType}` : 'resource.other',
    startTimestamp,
    data,
  });
}

/**
 * Capture the information of the user agent.
 */
function _trackNavigator(transaction) {
  const navigator = types_WINDOW.navigator ;
  if (!navigator) {
    return;
  }

  // track network connectivity
  const connection = navigator.connection;
  if (connection) {
    if (connection.effectiveType) {
      transaction.setTag('effectiveConnectionType', connection.effectiveType);
    }

    if (connection.type) {
      transaction.setTag('connectionType', connection.type);
    }

    if (isMeasurementValue(connection.rtt)) {
      _measurements['connection.rtt'] = { value: connection.rtt, unit: 'millisecond' };
    }
  }

  if (isMeasurementValue(navigator.deviceMemory)) {
    transaction.setTag('deviceMemory', `${navigator.deviceMemory} GB`);
  }

  if (isMeasurementValue(navigator.hardwareConcurrency)) {
    transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
  }
}

/** Add LCP / CLS data to transaction to allow debugging */
function _tagMetricInfo(transaction) {
  if (_lcpEntry) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding LCP Data');

    // Capture Properties of the LCP element that contributes to the LCP.

    if (_lcpEntry.element) {
      transaction.setTag('lcp.element', (0,browser/* htmlTreeAsString */.Rt)(_lcpEntry.element));
    }

    if (_lcpEntry.id) {
      transaction.setTag('lcp.id', _lcpEntry.id);
    }

    if (_lcpEntry.url) {
      // Trim URL to the first 200 characters.
      transaction.setTag('lcp.url', _lcpEntry.url.trim().slice(0, 200));
    }

    transaction.setTag('lcp.size', _lcpEntry.size);
  }

  // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
  if (_clsEntry && _clsEntry.sources) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('[Measurements] Adding CLS Data');
    _clsEntry.sources.forEach((source, index) =>
      transaction.setTag(`cls.source.${index + 1}`, (0,browser/* htmlTreeAsString */.Rt)(source.node)),
    );
  }
}


//# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/request.js



const DEFAULT_TRACE_PROPAGATION_TARGETS = ['localhost', /^\//];

/** Options for Request Instrumentation */

const defaultRequestInstrumentationOptions = {
  traceFetch: true,
  traceXHR: true,
  // TODO (v8): Remove this property
  tracingOrigins: DEFAULT_TRACE_PROPAGATION_TARGETS,
  tracePropagationTargets: DEFAULT_TRACE_PROPAGATION_TARGETS,
};

/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
  // eslint-disable-next-line deprecation/deprecation
  const { traceFetch, traceXHR, tracePropagationTargets, tracingOrigins, shouldCreateSpanForRequest } = {
    traceFetch: defaultRequestInstrumentationOptions.traceFetch,
    traceXHR: defaultRequestInstrumentationOptions.traceXHR,
    ..._options,
  };

  const shouldCreateSpan =
    typeof shouldCreateSpanForRequest === 'function' ? shouldCreateSpanForRequest : (_) => true;

  // TODO(v8) Remove tracingOrigins here
  // The only reason we're passing it in here is because this instrumentOutgoingRequests function is publicly exported
  // and we don't want to break the API. We can remove it in v8.
  const shouldAttachHeadersWithTargets = (url) =>
    shouldAttachHeaders(url, tracePropagationTargets || tracingOrigins);

  const spans = {};

  if (traceFetch) {
    (0,instrument/* addInstrumentationHandler */.o)('fetch', (handlerData) => {
      fetchCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
  }

  if (traceXHR) {
    (0,instrument/* addInstrumentationHandler */.o)('xhr', (handlerData) => {
      xhrCallback(handlerData, shouldCreateSpan, shouldAttachHeadersWithTargets, spans);
    });
  }
}

/**
 * A function that determines whether to attach tracing headers to a request.
 * This was extracted from `instrumentOutgoingRequests` to make it easier to test shouldAttachHeaders.
 * We only export this fuction for testing purposes.
 */
function shouldAttachHeaders(url, tracePropagationTargets) {
  return (0,string/* stringMatchesSomePattern */.U0)(url, tracePropagationTargets || DEFAULT_TRACE_PROPAGATION_TARGETS);
}

/**
 * Create and track fetch request spans
 */
function fetchCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  if (!(0,utils/* hasTracingEnabled */.zu)() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
    return;
  }

  if (handlerData.endTimestamp) {
    const spanId = handlerData.fetchData.__span;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      if (handlerData.response) {
        // TODO (kmclb) remove this once types PR goes through
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        span.setHttpStatus(handlerData.response.status);
      } else if (handlerData.error) {
        span.setStatus('internal_error');
      }
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return;
  }

  const activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    const span = activeTransaction.startChild({
      data: {
        ...handlerData.fetchData,
        type: 'fetch',
      },
      description: `${handlerData.fetchData.method} ${handlerData.fetchData.url}`,
      op: 'http.client',
    });

    handlerData.fetchData.__span = span.spanId;
    spans[span.spanId] = span;

    const request = handlerData.args[0];

    // In case the user hasn't set the second argument of a fetch call we default it to `{}`.
    handlerData.args[1] = handlerData.args[1] || {};

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const options = handlerData.args[1];

    if (shouldAttachHeaders(handlerData.fetchData.url)) {
      options.headers = addTracingHeadersToFetchRequest(
        request,
        activeTransaction.getDynamicSamplingContext(),
        span,
        options,
      );

      activeTransaction.metadata.propagations++;
    }
  }
}

function addTracingHeadersToFetchRequest(
  request,
  dynamicSamplingContext,
  span,
  options

,
) {
  const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);
  const sentryTraceHeader = span.toTraceparent();

  const headers =
    typeof Request !== 'undefined' && (0,is/* isInstanceOf */.V9)(request, Request) ? (request ).headers : options.headers;

  if (!headers) {
    return { 'sentry-trace': sentryTraceHeader, baggage: sentryBaggageHeader };
  } else if (typeof Headers !== 'undefined' && (0,is/* isInstanceOf */.V9)(headers, Headers)) {
    const newHeaders = new Headers(headers );

    newHeaders.append('sentry-trace', sentryTraceHeader);

    if (sentryBaggageHeader) {
      // If the same header is appended miultiple times the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.append(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
    }

    return newHeaders ;
  } else if (Array.isArray(headers)) {
    const newHeaders = [...headers, ['sentry-trace', sentryTraceHeader]];

    if (sentryBaggageHeader) {
      // If there are multiple entries with the same key, the browser will merge the values into a single request header.
      // Its therefore safe to simply push a "baggage" entry, even though there might already be another baggage header.
      newHeaders.push([BAGGAGE_HEADER_NAME, sentryBaggageHeader]);
    }

    return newHeaders;
  } else {
    const existingBaggageHeader = 'baggage' in headers ? headers.baggage : undefined;
    const newBaggageHeaders = [];

    if (Array.isArray(existingBaggageHeader)) {
      newBaggageHeaders.push(...existingBaggageHeader);
    } else if (existingBaggageHeader) {
      newBaggageHeaders.push(existingBaggageHeader);
    }

    if (sentryBaggageHeader) {
      newBaggageHeaders.push(sentryBaggageHeader);
    }

    return {
      ...(headers ),
      'sentry-trace': sentryTraceHeader,
      baggage: newBaggageHeaders.length > 0 ? newBaggageHeaders.join(',') : undefined,
    };
  }
}

/**
 * Create and track xhr request spans
 */
function xhrCallback(
  handlerData,
  shouldCreateSpan,
  shouldAttachHeaders,
  spans,
) {
  if (
    !(0,utils/* hasTracingEnabled */.zu)() ||
    (handlerData.xhr && handlerData.xhr.__sentry_own_request__) ||
    !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))
  ) {
    return;
  }

  const xhr = handlerData.xhr.__sentry_xhr__;

  // check first if the request has finished and is tracked by an existing span which should now end
  if (handlerData.endTimestamp) {
    const spanId = handlerData.xhr.__sentry_xhr_span_id__;
    if (!spanId) return;

    const span = spans[spanId];
    if (span) {
      span.setHttpStatus(xhr.status_code);
      span.finish();

      // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
      delete spans[spanId];
    }
    return;
  }

  // if not, create a new span to track it
  const activeTransaction = (0,utils/* getActiveTransaction */.x1)();
  if (activeTransaction) {
    const span = activeTransaction.startChild({
      data: {
        ...xhr.data,
        type: 'xhr',
        method: xhr.method,
        url: xhr.url,
      },
      description: `${xhr.method} ${xhr.url}`,
      op: 'http.client',
    });

    handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
    spans[handlerData.xhr.__sentry_xhr_span_id__] = span;

    if (handlerData.xhr.setRequestHeader && shouldAttachHeaders(handlerData.xhr.__sentry_xhr__.url)) {
      try {
        handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());

        const dynamicSamplingContext = activeTransaction.getDynamicSamplingContext();
        const sentryBaggageHeader = dynamicSamplingContextToSentryBaggageHeader(dynamicSamplingContext);

        if (sentryBaggageHeader) {
          // From MDN: "If this method is called several times with the same header, the values are merged into one single request header."
          // We can therefore simply set a baggage header without checking what was there before
          // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/setRequestHeader
          handlerData.xhr.setRequestHeader(BAGGAGE_HEADER_NAME, sentryBaggageHeader);
        }

        activeTransaction.metadata.propagations++;
      } catch (_) {
        // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
      }
    }
  }
}


//# sourceMappingURL=request.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/router.js



/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(
  customStartTransaction,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  if (!types_WINDOW || !types_WINDOW.location) {
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Could not initialize routing instrumentation due to invalid location');
    return;
  }

  let startingUrl = types_WINDOW.location.href;

  let activeTransaction;
  if (startTransactionOnPageLoad) {
    activeTransaction = customStartTransaction({
      name: types_WINDOW.location.pathname,
      op: 'pageload',
      metadata: { source: 'url' },
    });
  }

  if (startTransactionOnLocationChange) {
    (0,instrument/* addInstrumentationHandler */.o)('history', ({ to, from }) => {
      /**
       * This early return is there to account for some cases where a navigation transaction starts right after
       * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
       * create an uneccessary navigation transaction.
       *
       * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
       * only be caused in certain development environments where the usage of a hot module reloader is causing
       * errors.
       */
      if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
        startingUrl = undefined;
        return;
      }

      if (from !== to) {
        startingUrl = undefined;
        if (activeTransaction) {
          (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Tracing] Finishing current transaction with op: ${activeTransaction.op}`);
          // If there's an open transaction on the scope, we need to finish it before creating an new one.
          activeTransaction.finish();
        }
        activeTransaction = customStartTransaction({
          name: types_WINDOW.location.pathname,
          op: 'navigation',
          metadata: { source: 'url' },
        });
      }
    });
  }
}


//# sourceMappingURL=router.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/browser/browsertracing.js











const BROWSER_TRACING_INTEGRATION_ID = 'BrowserTracing';

/** Options for Browser Tracing integration */

const DEFAULT_BROWSER_TRACING_OPTIONS = {
  idleTimeout: idletransaction/* DEFAULT_IDLE_TIMEOUT */.nT,
  finalTimeout: idletransaction/* DEFAULT_FINAL_TIMEOUT */.mg,
  heartbeatInterval: idletransaction/* DEFAULT_HEARTBEAT_INTERVAL */.hd,
  markBackgroundTransactions: true,
  routingInstrumentation: instrumentRoutingWithDefaults,
  startTransactionOnLocationChange: true,
  startTransactionOnPageLoad: true,
  _experiments: { enableLongTask: true, enableInteractions: false },
  ...defaultRequestInstrumentationOptions,
};

/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
class BrowserTracing  {
  // This class currently doesn't have a static `id` field like the other integration classes, because it prevented
  // @sentry/tracing from being treeshaken. Tree shakers do not like static fields, because they behave like side effects.
  // TODO: Come up with a better plan, than using static fields on integration classes, and use that plan on all
  // integrations.

  /** Browser Tracing integration options */

  /**
   * @inheritDoc
   */
   __init() {this.name = BROWSER_TRACING_INTEGRATION_ID;}

   constructor(_options) {;BrowserTracing.prototype.__init.call(this);
    this.options = {
      ...DEFAULT_BROWSER_TRACING_OPTIONS,
      ..._options,
    };

    // TODO (v8): remove this block after tracingOrigins is removed
    // Set tracePropagationTargets to tracingOrigins if specified by the user
    // In case both are specified, tracePropagationTargets takes precedence
    // eslint-disable-next-line deprecation/deprecation
    if (_options && !_options.tracePropagationTargets && _options.tracingOrigins) {
      // eslint-disable-next-line deprecation/deprecation
      this.options.tracePropagationTargets = _options.tracingOrigins;
    }

    startTrackingWebVitals();
    if (_optionalChain([this, 'access', _2 => _2.options, 'access', _3 => _3._experiments, 'optionalAccess', _4 => _4.enableLongTask])) {
      startTrackingLongTasks();
    }
  }

  /**
   * @inheritDoc
   */
   setupOnce(_, getCurrentHub) {
    this._getCurrentHub = getCurrentHub;

    // eslint-disable-next-line @typescript-eslint/unbound-method
    const {
      routingInstrumentation: instrumentRouting,
      startTransactionOnLocationChange,
      startTransactionOnPageLoad,
      markBackgroundTransactions,
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
      _experiments,
    } = this.options;

    instrumentRouting(
      (context) => this._createRouteTransaction(context),
      startTransactionOnPageLoad,
      startTransactionOnLocationChange,
    );

    if (markBackgroundTransactions) {
      registerBackgroundTabDetection();
    }

    if (_optionalChain([_experiments, 'optionalAccess', _5 => _5.enableInteractions])) {
      this._registerInteractionListener();
    }

    instrumentOutgoingRequests({
      traceFetch,
      traceXHR,
      tracePropagationTargets,
      shouldCreateSpanForRequest,
    });
  }

  /** Create routing idle transaction. */
   _createRouteTransaction(context) {
    if (!this._getCurrentHub) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${context.op} transaction because _getCurrentHub is invalid.`);
      return undefined;
    }

    // eslint-disable-next-line @typescript-eslint/unbound-method
    const { beforeNavigate, idleTimeout, finalTimeout, heartbeatInterval } = this.options;

    const isPageloadTransaction = context.op === 'pageload';

    const sentryTraceMetaTagValue = isPageloadTransaction ? getMetaContent('sentry-trace') : null;
    const baggageMetaTagValue = isPageloadTransaction ? getMetaContent('baggage') : null;

    const traceParentData = sentryTraceMetaTagValue ? extractTraceparentData(sentryTraceMetaTagValue) : undefined;
    const dynamicSamplingContext = baggageMetaTagValue
      ? baggageHeaderToDynamicSamplingContext(baggageMetaTagValue)
      : undefined;

    const expandedContext = {
      ...context,
      ...traceParentData,
      metadata: {
        ...context.metadata,
        dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
      trimEnd: true,
    };

    const modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;

    // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
    // from being sent to Sentry).
    const finalContext = modifiedContext === undefined ? { ...expandedContext, sampled: false } : modifiedContext;

    // If `beforeNavigate` set a custom name, record that fact
    finalContext.metadata =
      finalContext.name !== expandedContext.name
        ? { ...finalContext.metadata, source: 'custom' }
        : finalContext.metadata;

    this._latestRouteName = finalContext.name;
    this._latestRouteSource = _optionalChain([finalContext, 'access', _6 => _6.metadata, 'optionalAccess', _7 => _7.source]);

    if (finalContext.sampled === false) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
        esm_logger/* logger.log */.kg.log(`[Tracing] Will not send ${finalContext.op} transaction because of beforeNavigate.`);
    }

    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log(`[Tracing] Starting ${finalContext.op} transaction on scope`);

    const hub = this._getCurrentHub();
    const { location } = types_WINDOW;

    const idleTransaction = (0,hubextensions/* startIdleTransaction */.lb)(
      hub,
      finalContext,
      idleTimeout,
      finalTimeout,
      true,
      { location }, // for use in the tracesSampler
      heartbeatInterval,
    );
    idleTransaction.registerBeforeFinishCallback(transaction => {
      addPerformanceEntries(transaction);
    });

    return idleTransaction ;
  }

  /** Start listener for interaction transactions */
   _registerInteractionListener() {
    let inflightInteractionTransaction;
    const registerInteractionTransaction = () => {
      const { idleTimeout, finalTimeout, heartbeatInterval } = this.options;

      const op = 'ui.action.click';
      if (inflightInteractionTransaction) {
        inflightInteractionTransaction.finish();
        inflightInteractionTransaction = undefined;
      }

      if (!this._getCurrentHub) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _getCurrentHub is invalid.`);
        return undefined;
      }

      if (!this._latestRouteName) {
        (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) &&
          esm_logger/* logger.warn */.kg.warn(`[Tracing] Did not create ${op} transaction because _latestRouteName is missing.`);
        return undefined;
      }

      const hub = this._getCurrentHub();
      const { location } = types_WINDOW;

      const context = {
        name: this._latestRouteName,
        op,
        trimEnd: true,
        metadata: {
          source: (0,_nullishCoalesce/* _nullishCoalesce */.h)(this._latestRouteSource, () => ( 'url')),
        },
      };

      inflightInteractionTransaction = (0,hubextensions/* startIdleTransaction */.lb)(
        hub,
        context,
        idleTimeout,
        finalTimeout,
        true,
        { location }, // for use in the tracesSampler
        heartbeatInterval,
      );
    };

    ['click'].forEach(type => {
      addEventListener(type, registerInteractionTransaction, { once: false, capture: true });
    });
  }
}

/** Returns the value of a meta tag */
function getMetaContent(metaName) {
  // Can't specify generic to `getDomElement` because tracing can be used
  // in a variety of environments, have to disable `no-unsafe-member-access`
  // as a result.
  const metaTag = (0,browser/* getDomElement */.qT)(`meta[name=${metaName}]`);
  // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
  return metaTag ? metaTag.getAttribute('content') : null;
}


//# sourceMappingURL=browsertracing.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/tracing/esm/index.js














;
;

// Treeshakable guard to remove all code related to tracing

// Guard for tree
if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
  // We are patching the global object with our hub extension methods
  (0,hubextensions/* addExtensionMethods */.ro)();
}
//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/performance/client.js





const globalObject = helpers_WINDOW

;

/**
 * Every Next.js page (static and dynamic ones) comes with a script tag with the id "__NEXT_DATA__". This script tag
 * contains a JSON object with data that was either generated at build time for static pages (`getStaticProps`), or at
 * runtime with data fetchers like `getServerSideProps.`.
 *
 * We can use this information to:
 * - Always get the parameterized route we're in when loading a page.
 * - Send trace information (trace-id, baggage) from the server to the client.
 *
 * This function extracts this information.
 */
function extractNextDataTagInformation() {
  let nextData;
  // Let's be on the safe side and actually check first if there is really a __NEXT_DATA__ script tag on the page.
  // Theoretically this should always be the case though.
  const nextDataTag = globalObject.document.getElementById('__NEXT_DATA__');
  if (nextDataTag && nextDataTag.innerHTML) {
    try {
      nextData = JSON.parse(nextDataTag.innerHTML);
    } catch (e) {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Could not extract __NEXT_DATA__');
    }
  }

  if (!nextData) {
    return {};
  }

  const nextDataTagInfo = {};

  const { page, query, props } = nextData;

  // `nextData.page` always contains the parameterized route - except for when an error occurs in a data fetching
  // function, then it is "/_error", but that isn't a problem since users know which route threw by looking at the
  // parent transaction
  // TODO: Actually this is a problem (even though it is not that big), because the DSC and the transaction payload will contain
  // a different transaction name. Maybe we can fix this. Idea: Also send transaction name via pageProps when available.
  nextDataTagInfo.route = page;
  nextDataTagInfo.params = query;

  if (props && props.pageProps) {
    if (props.pageProps._sentryBaggage) {
      nextDataTagInfo.baggage = props.pageProps._sentryBaggage;
    }

    if (props.pageProps._sentryTraceData) {
      nextDataTagInfo.traceParentData = extractTraceparentData(props.pageProps._sentryTraceData);
    }
  }

  return nextDataTagInfo;
}

const DEFAULT_TAGS = {
  'routing.instrumentation': 'next-router',
} ;

// We keep track of the active transaction so we can finish it when we start a navigation transaction.
let activeTransaction = undefined;

// We keep track of the previous location name so we can set the `from` field on navigation transactions.
// This is either a route or a pathname.
let prevLocationName = undefined;

const client = (0,esm_hub/* getCurrentHub */.Gd)().getClient();

/**
 * Creates routing instrumention for Next Router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */
function nextRouterInstrumentation(
  startTransactionCb,
  startTransactionOnPageLoad = true,
  startTransactionOnLocationChange = true,
) {
  const { route, traceParentData, baggage, params } = extractNextDataTagInformation();
  prevLocationName = route || globalObject.location.pathname;

  if (startTransactionOnPageLoad) {
    const source = route ? 'route' : 'url';
    const dynamicSamplingContext = baggageHeaderToDynamicSamplingContext(baggage);

    activeTransaction = startTransactionCb({
      name: prevLocationName,
      op: 'pageload',
      tags: DEFAULT_TAGS,
      ...(params && client && client.getOptions().sendDefaultPii && { data: params }),
      ...traceParentData,
      metadata: {
        source,
        dynamicSamplingContext: traceParentData && !dynamicSamplingContext ? {} : dynamicSamplingContext,
      },
    });
  }

  if (startTransactionOnLocationChange) {
    router_default().events.on('routeChangeStart', (navigationTarget) => {
      const matchedRoute = getNextRouteFromPathname(stripUrlQueryAndFragment(navigationTarget));

      let transactionName;
      let transactionSource;

      if (matchedRoute) {
        transactionName = matchedRoute;
        transactionSource = 'route';
      } else {
        transactionName = navigationTarget;
        transactionSource = 'url';
      }

      const tags = {
        ...DEFAULT_TAGS,
        from: prevLocationName,
      };

      prevLocationName = transactionName;

      if (activeTransaction) {
        activeTransaction.finish();
      }

      const navigationTransaction = startTransactionCb({
        name: transactionName,
        op: 'navigation',
        tags,
        metadata: { source: transactionSource },
      });

      if (navigationTransaction) {
        // In addition to the navigation transaction we're also starting a span to mark Next.js's `routeChangeStart`
        // and `routeChangeComplete` events.
        // We don't want to finish the navigation transaction on `routeChangeComplete`, since users might want to attach
        // spans to that transaction even after `routeChangeComplete` is fired (eg. HTTP requests in some useEffect
        // hooks). Instead, we'll simply let the navigation transaction finish itself (it's an `IdleTransaction`).
        const nextRouteChangeSpan = navigationTransaction.startChild({
          op: 'ui.nextjs.route-change',
          description: 'Next.js Route Change',
        });

        const finishRouteChangeSpan = () => {
          nextRouteChangeSpan.finish();
          router_default().events.off('routeChangeComplete', finishRouteChangeSpan);
        };

        router_default().events.on('routeChangeComplete', finishRouteChangeSpan);
      }
    });
  }
}

function getNextRouteFromPathname(pathname) {
  const pageRoutes = (globalObject.__BUILD_MANIFEST || {}).sortedPages;

  // Page route should in 99.999% of the cases be defined by now but just to be sure we make a check here
  if (!pageRoutes) {
    return;
  }

  return pageRoutes.find(route => {
    const routeRegExp = convertNextRouteToRegExp(route);
    return pathname.match(routeRegExp);
  });
}

/**
 * Converts a Next.js style route to a regular expression that matches on pathnames (no query params or URL fragments).
 *
 * In general this involves replacing any instances of square brackets in a route with a wildcard:
 * e.g. "/users/[id]/info" becomes /\/users\/([^/]+?)\/info/
 *
 * Some additional edgecases need to be considered:
 * - All routes have an optional slash at the end, meaning users can navigate to "/users/[id]/info" or
 *   "/users/[id]/info/" - both will be resolved to "/users/[id]/info".
 * - Non-optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[...params]").
 * - Optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[[...params]]").
 *
 * @param route A Next.js style route as it is found in `global.__BUILD_MANIFEST.sortedPages`
 */
function convertNextRouteToRegExp(route) {
  // We can assume a route is at least "/".
  const routeParts = route.split('/');

  let optionalCatchallWildcardRegex = '';
  if (routeParts[routeParts.length - 1].match(/^\[\[\.\.\..+\]\]$/)) {
    // If last route part has pattern "[[...xyz]]" we pop the latest route part to get rid of the required trailing
    // slash that would come before it if we didn't pop it.
    routeParts.pop();
    optionalCatchallWildcardRegex = '(?:/(.+?))?';
  }

  const rejoinedRouteParts = routeParts
    .map(
      routePart =>
        routePart
          .replace(/^\[\.\.\..+\]$/, '(.+?)') // Replace catch all wildcard with regex wildcard
          .replace(/^\[.*\]$/, '([^/]+?)'), // Replace route wildcards with lazy regex wildcards
    )
    .join('/');

  return new RegExp(
    `^${rejoinedRouteParts}${optionalCatchallWildcardRegex}(?:/)?$`, // optional slash at the end
  );
}


//# sourceMappingURL=client.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/utils/metadata.js


const PACKAGE_NAME_PREFIX = 'npm:@sentry/';

/**
 * A builder for the SDK metadata in the options for the SDK initialization.
 * @param options sdk options object that gets mutated
 * @param names list of package names
 */
function buildMetadata(options, names) {
  options._metadata = options._metadata || {};
  options._metadata.sdk =
    options._metadata.sdk ||
    ({
      name: 'sentry.javascript.nextjs',
      packages: names.map(name => ({
        name: `${PACKAGE_NAME_PREFIX}${name}`,
        version: SDK_VERSION,
      })),
      version: SDK_VERSION,
    } );
}


//# sourceMappingURL=metadata.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/utils/tunnelRoute.js


const globalWithInjectedValues = __webpack_require__.g

;

/**
 * Applies the `tunnel` option to the Next.js SDK options based on `withSentryConfig`'s `tunnelRoute` option.
 */
function applyTunnelRouteOption(options) {
  const tunnelRouteOption = globalWithInjectedValues.__sentryRewritesTunnelPath__;
  if (tunnelRouteOption && options.dsn) {
    const dsnComponents = dsnFromString(options.dsn);
    const sentrySaasDsnMatch = dsnComponents.host.match(/^o(\d+)\.ingest\.sentry\.io$/);
    if (sentrySaasDsnMatch) {
      const orgId = sentrySaasDsnMatch[1];
      const tunnelPath = `${tunnelRouteOption}?o=${orgId}&p=${dsnComponents.projectId}`;
      options.tunnel = tunnelPath;
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.info */.kg.info(`Tunneling events to "${tunnelPath}"`);
    } else {
      (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.warn */.kg.warn('Provided DSN is not a Sentry SaaS DSN. Will not tunnel events.');
    }
  }
}


//# sourceMappingURL=tunnelRoute.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/utils/userIntegrations.js
/**
 * Recursively traverses an object to update an existing nested key.
 * Note: The provided key path must include existing properties,
 * the function will not create objects while traversing.
 *
 * @param obj An object to update
 * @param value The value to update the nested key with
 * @param keyPath The path to the key to update ex. fizz.buzz.foo
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function setNestedKey(obj, keyPath, value) {
  // Ex. foo.bar.zoop will extract foo and bar.zoop
  const match = keyPath.match(/([a-z_]+)\.(.*)/i);
  // The match will be null when there's no more recursing to do, i.e., when we've reached the right level of the object
  if (match === null) {
    obj[keyPath] = value;
  } else {
    // `match[1]` is the initial segment of the path, and `match[2]` is the remainder of the path
    const innerObj = obj[match[1]];
    setNestedKey(innerObj, match[2], value);
  }
}

/**
 * Enforces inclusion of a given integration with specified options in an integration array originally determined by the
 * user, by either including the given default instance or by patching an existing user instance with the given options.
 *
 * Ideally this would happen when integrations are set up, but there isn't currently a mechanism there for merging
 * options from a default integration instance with those from a user-provided instance of the same integration, only
 * for allowing the user to override a default instance entirely. (TODO: Fix that.)
 *
 * @param defaultIntegrationInstance An instance of the integration with the correct options already set
 * @param userIntegrations Integrations defined by the user.
 * @param forcedOptions Options with which to patch an existing user-derived instance on the integration.
 * @returns A final integrations array.
 */
function addOrUpdateIntegration(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions = {},
) {
  return (
    Array.isArray(userIntegrations)
      ? addOrUpdateIntegrationInArray(defaultIntegrationInstance, userIntegrations, forcedOptions)
      : addOrUpdateIntegrationInFunction(
          defaultIntegrationInstance,
          // Somehow TS can't figure out that not being an array makes this necessarily a function
          userIntegrations ,
          forcedOptions,
        )
  ) ;
}

function addOrUpdateIntegrationInArray(
  defaultIntegrationInstance,
  userIntegrations,
  forcedOptions,
) {
  const userInstance = userIntegrations.find(integration => integration.name === defaultIntegrationInstance.name);

  if (userInstance) {
    for (const [keyPath, value] of Object.entries(forcedOptions)) {
      setNestedKey(userInstance, keyPath, value);
    }

    return userIntegrations;
  }

  return [...userIntegrations, defaultIntegrationInstance];
}

function addOrUpdateIntegrationInFunction(
  defaultIntegrationInstance,
  userIntegrationsFunc,
  forcedOptions,
) {
  const wrapper = defaultIntegrations => {
    const userFinalIntegrations = userIntegrationsFunc(defaultIntegrations);

    // There are instances where we want the user to be able to prevent an integration from appearing at all, which they
    // would do by providing a function which filters out the integration in question. If that's happened in one of
    // those cases, don't add our default back in.
    if (defaultIntegrationInstance.allowExclusionByUser) {
      const userFinalInstance = userFinalIntegrations.find(
        integration => integration.name === defaultIntegrationInstance.name,
      );
      if (!userFinalInstance) {
        return userFinalIntegrations;
      }
    }

    return addOrUpdateIntegrationInArray(defaultIntegrationInstance, userFinalIntegrations, forcedOptions);
  };

  return wrapper;
}


//# sourceMappingURL=userIntegrations.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/index.client.js















// Treeshakable guard to remove all code related to tracing

const index_client_globalWithInjectedValues = __webpack_require__.g

;

/** Inits the Sentry NextJS SDK on the browser with the React SDK. */
function index_client_init(options) {
  if (typeof EdgeRuntime === 'string') {
    // If the SDK is imported when using the Vercel Edge Runtime, it will import the browser SDK, even though it is
    // running the server part of a Next.js application. We can use the `EdgeRuntime` to check for that case and make
    // the init call a no-op. This will prevent the SDK from crashing on the Edge Runtime.
    (typeof __SENTRY_DEBUG__ === 'undefined' || __SENTRY_DEBUG__) && esm_logger/* logger.log */.kg.log('Vercel Edge Runtime detected. Will not initialize SDK.');
    return;
  }

  applyTunnelRouteOption(options);
  buildMetadata(options, ['nextjs', 'react']);
  options.environment = options.environment || "production";
  addClientIntegrations(options);

  sdk_init(options);

  (0,esm_exports/* configureScope */.e)(scope => {
    scope.setTag('runtime', 'browser');
    const filterTransactions = event =>
      event.type === 'transaction' && event.transaction === '/404' ? null : event;
    filterTransactions.id = 'NextClient404Filter';
    scope.addEventProcessor(filterTransactions);
  });
}

function addClientIntegrations(options) {
  let integrations = options.integrations || [];

  // This value is injected at build time, based on the output directory specified in the build config. Though a default
  // is set there, we set it here as well, just in case something has gone wrong with the injection.
  const assetPrefixPath = index_client_globalWithInjectedValues.__rewriteFramesAssetPrefixPath__ || '';

  const defaultRewriteFramesIntegration = new RewriteFrames({
    // Turn `<origin>/<path>/_next/static/...` into `app:///_next/static/...`
    iteratee: frame => {
      try {
        const { origin } = new URL(frame.filename );
        frame.filename = _optionalChain([frame, 'access', _ => _.filename, 'optionalAccess', _2 => _2.replace, 'call', _3 => _3(origin, 'app://'), 'access', _4 => _4.replace, 'call', _5 => _5(assetPrefixPath, '')]);
      } catch (err) {
        // Filename wasn't a properly formed URL, so there's nothing we can do
      }

      return frame;
    },
  });
  integrations = addOrUpdateIntegration(defaultRewriteFramesIntegration, integrations);

  // This evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false", in which case everything inside
  // will get treeshaken away
  if (typeof __SENTRY_TRACING__ === 'undefined' || __SENTRY_TRACING__) {
    if ((0,utils/* hasTracingEnabled */.zu)(options)) {
      const defaultBrowserTracingIntegration = new BrowserTracing({
        // eslint-disable-next-line deprecation/deprecation
        tracingOrigins: [...defaultRequestInstrumentationOptions.tracingOrigins, /^(api\/)/],
        routingInstrumentation: nextRouterInstrumentation,
      });

      integrations = addOrUpdateIntegration(defaultBrowserTracingIntegration, integrations, {
        'options.routingInstrumentation': nextRouterInstrumentation,
      });
    }
  }

  options.integrations = integrations;
}


//# sourceMappingURL=index.client.js.map

;// CONCATENATED MODULE: ./sentry.client.config.js
/* provided dependency */ var process = __webpack_require__(83454);
// This file configures the initialization of Sentry on the browser.
// The config you add here will be used whenever a page is visited.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

var _sentryCollisionFreeGlobalObject =  false ? 0 : window;
_sentryCollisionFreeGlobalObject["__sentryRewritesTunnelPath__"] = undefined;
_sentryCollisionFreeGlobalObject["__rewriteFramesAssetPrefixPath__"] = "";
var SENTRY_DSN = process.env.SENTRY_DSN || process.env.NEXT_PUBLIC_SENTRY_DSN;
/*
https://docs.sentry.io/product/sentry-basics/dsn-explainer/
DSN Utilization
DSNs are safe to keep public because they only allow submission of new events and related event data; they do not allow read access to any information.
*/ index_client_init({
    dsn: SENTRY_DSN || "https://ab4ad27dd0894985acb42eac39b95db9@o567600.ingest.sentry.io/6629552",
    // Adjust this value in production, or use tracesSampler for greater control
    tracesSampleRate: 0.1,
    sampleRate: 0.1
});


/***/ }),

/***/ 19749:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = Image;
var _react = _interopRequireWildcard(__webpack_require__(67294));
var _head = _interopRequireDefault(__webpack_require__(83121));
var _imageConfig = __webpack_require__(10139);
var _useIntersection = __webpack_require__(81489);
var _imageConfigContext = __webpack_require__(28730);
var _utils = __webpack_require__(670);
var _normalizeTrailingSlash = __webpack_require__(52700);
function Image(_param) {
    var src = _param.src, sizes = _param.sizes, _unoptimized = _param.unoptimized, unoptimized = _unoptimized === void 0 ? false : _unoptimized, _priority = _param.priority, priority = _priority === void 0 ? false : _priority, loading = _param.loading, _lazyRoot = _param.lazyRoot, lazyRoot = _lazyRoot === void 0 ? null : _lazyRoot, _lazyBoundary = _param.lazyBoundary, lazyBoundary = _lazyBoundary === void 0 ? "200px" : _lazyBoundary, className = _param.className, quality = _param.quality, width = _param.width, height = _param.height, style = _param.style, objectFit = _param.objectFit, objectPosition = _param.objectPosition, onLoadingComplete = _param.onLoadingComplete, _placeholder = _param.placeholder, placeholder = _placeholder === void 0 ? "empty" : _placeholder, blurDataURL = _param.blurDataURL, all = _objectWithoutProperties(_param, [
        "src",
        "sizes",
        "unoptimized",
        "priority",
        "loading",
        "lazyRoot",
        "lazyBoundary",
        "className",
        "quality",
        "width",
        "height",
        "style",
        "objectFit",
        "objectPosition",
        "onLoadingComplete",
        "placeholder",
        "blurDataURL"
    ]);
    var configContext = (0, _react).useContext(_imageConfigContext.ImageConfigContext);
    var config = (0, _react).useMemo(function() {
        var c = configEnv || configContext || _imageConfig.imageConfigDefault;
        var allSizes = _toConsumableArray(c.deviceSizes).concat(_toConsumableArray(c.imageSizes)).sort(function(a, b) {
            return a - b;
        });
        var deviceSizes = c.deviceSizes.sort(function(a, b) {
            return a - b;
        });
        return _objectSpread({}, c, {
            allSizes: allSizes,
            deviceSizes: deviceSizes
        });
    }, [
        configContext
    ]);
    var rest = all;
    var layout = sizes ? "responsive" : "intrinsic";
    if ("layout" in rest) {
        // Override default layout if the user specified one:
        if (rest.layout) layout = rest.layout;
        // Remove property so it's not spread on <img>:
        delete rest.layout;
    }
    var loader = defaultImageLoader;
    if ("loader" in rest) {
        if (rest.loader) {
            var customImageLoader = rest.loader;
            var _tmp;
            _tmp = function(obj) {
                var _ = obj.config, opts = _objectWithoutProperties(obj, [
                    "config"
                ]);
                // The config object is internal only so we must
                // not pass it to the user-defined loader()
                return customImageLoader(opts);
            }, loader = _tmp, _tmp;
        }
        // Remove property so it's not spread on <img>
        delete rest.loader;
    }
    var staticSrc = "";
    if (isStaticImport(src)) {
        var staticImageData = isStaticRequire(src) ? src.default : src;
        if (!staticImageData.src) {
            throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include src. Received ".concat(JSON.stringify(staticImageData)));
        }
        blurDataURL = blurDataURL || staticImageData.blurDataURL;
        staticSrc = staticImageData.src;
        if (!layout || layout !== "fill") {
            height = height || staticImageData.height;
            width = width || staticImageData.width;
            if (!staticImageData.height || !staticImageData.width) {
                throw new Error("An object should only be passed to the image component src parameter if it comes from a static image import. It must include height and width. Received ".concat(JSON.stringify(staticImageData)));
            }
        }
    }
    src = typeof src === "string" ? src : staticSrc;
    var widthInt = getInt(width);
    var heightInt = getInt(height);
    var qualityInt = getInt(quality);
    var isLazy = !priority && (loading === "lazy" || typeof loading === "undefined");
    if (src.startsWith("data:") || src.startsWith("blob:")) {
        // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/Data_URIs
        unoptimized = true;
        isLazy = false;
    }
    if ( true && loadedImageURLs.has(src)) {
        isLazy = false;
    }
    var ref2 = _slicedToArray((0, _react).useState(false), 2), blurComplete = ref2[0], setBlurComplete = ref2[1];
    var ref1 = _slicedToArray((0, _useIntersection).useIntersection({
        rootRef: lazyRoot,
        rootMargin: lazyBoundary,
        disabled: !isLazy
    }), 3), setIntersection = ref1[0], isIntersected = ref1[1], resetIntersected = ref1[2];
    var isVisible = !isLazy || isIntersected;
    var wrapperStyle = {
        boxSizing: "border-box",
        display: "block",
        overflow: "hidden",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var sizerStyle = {
        boxSizing: "border-box",
        display: "block",
        width: "initial",
        height: "initial",
        background: "none",
        opacity: 1,
        border: 0,
        margin: 0,
        padding: 0
    };
    var hasSizer = false;
    var sizerSvgUrl;
    var layoutStyle = {
        position: "absolute",
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        boxSizing: "border-box",
        padding: 0,
        border: "none",
        margin: "auto",
        display: "block",
        width: 0,
        height: 0,
        minWidth: "100%",
        maxWidth: "100%",
        minHeight: "100%",
        maxHeight: "100%",
        objectFit: objectFit,
        objectPosition: objectPosition
    };
    if (false) {}
    if (false) { var overwrittenStyles, url, urlStr, VALID_BLUR_EXT; }
    var imgStyle = Object.assign({}, style, layout === "raw" ? {} : layoutStyle);
    var blurStyle = placeholder === "blur" && !blurComplete ? {
        filter: "blur(20px)",
        backgroundSize: objectFit || "cover",
        backgroundImage: 'url("'.concat(blurDataURL, '")'),
        backgroundPosition: objectPosition || "0% 0%"
    } : {};
    if (layout === "fill") {
        // <Image src="i.png" layout="fill" />
        wrapperStyle.display = "block";
        wrapperStyle.position = "absolute";
        wrapperStyle.top = 0;
        wrapperStyle.left = 0;
        wrapperStyle.bottom = 0;
        wrapperStyle.right = 0;
    } else if (typeof widthInt !== "undefined" && typeof heightInt !== "undefined") {
        // <Image src="i.png" width="100" height="100" />
        var quotient = heightInt / widthInt;
        var paddingTop = isNaN(quotient) ? "100%" : "".concat(quotient * 100, "%");
        if (layout === "responsive") {
            // <Image src="i.png" width="100" height="100" layout="responsive" />
            wrapperStyle.display = "block";
            wrapperStyle.position = "relative";
            hasSizer = true;
            sizerStyle.paddingTop = paddingTop;
        } else if (layout === "intrinsic") {
            // <Image src="i.png" width="100" height="100" layout="intrinsic" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.maxWidth = "100%";
            hasSizer = true;
            sizerStyle.maxWidth = "100%";
            sizerSvgUrl = "data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%27".concat(widthInt, "%27%20height=%27").concat(heightInt, "%27/%3e");
        } else if (layout === "fixed") {
            // <Image src="i.png" width="100" height="100" layout="fixed" />
            wrapperStyle.display = "inline-block";
            wrapperStyle.position = "relative";
            wrapperStyle.width = widthInt;
            wrapperStyle.height = heightInt;
        }
    } else {
        // <Image src="i.png" />
        if (false) {}
    }
    var imgAttributes = {
        src: emptyDataURL,
        srcSet: undefined,
        sizes: undefined
    };
    if (isVisible) {
        imgAttributes = generateImgAttrs({
            config: config,
            src: src,
            unoptimized: unoptimized,
            layout: layout,
            width: widthInt,
            quality: qualityInt,
            sizes: sizes,
            loader: loader
        });
    }
    var srcString = src;
    if (false) { var fullUrl; }
    var imageSrcSetPropName = "imagesrcset";
    var imageSizesPropName = "imagesizes";
    if (true) {
        imageSrcSetPropName = "imageSrcSet";
        imageSizesPropName = "imageSizes";
    }
    var _obj;
    var linkProps = (_obj = {}, // Note: imagesrcset and imagesizes are not in the link element type with react 17.
    _defineProperty(_obj, imageSrcSetPropName, imgAttributes.srcSet), _defineProperty(_obj, imageSizesPropName, imgAttributes.sizes), _obj);
    var useLayoutEffect =  false ? 0 : _react.default.useLayoutEffect;
    var onLoadingCompleteRef = (0, _react).useRef(onLoadingComplete);
    var previousImageSrc = (0, _react).useRef(src);
    (0, _react).useEffect(function() {
        onLoadingCompleteRef.current = onLoadingComplete;
    }, [
        onLoadingComplete
    ]);
    useLayoutEffect(function() {
        if (previousImageSrc.current !== src) {
            resetIntersected();
            previousImageSrc.current = src;
        }
    }, [
        resetIntersected,
        src
    ]);
    var imgElementArgs = _objectSpread({
        isLazy: isLazy,
        imgAttributes: imgAttributes,
        heightInt: heightInt,
        widthInt: widthInt,
        qualityInt: qualityInt,
        layout: layout,
        className: className,
        imgStyle: imgStyle,
        blurStyle: blurStyle,
        loading: loading,
        config: config,
        unoptimized: unoptimized,
        placeholder: placeholder,
        loader: loader,
        srcString: srcString,
        onLoadingCompleteRef: onLoadingCompleteRef,
        setBlurComplete: setBlurComplete,
        setIntersection: setIntersection,
        isVisible: isVisible
    }, rest);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, layout === "raw" ? /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs)) : /*#__PURE__*/ _react.default.createElement("span", {
        style: wrapperStyle
    }, hasSizer ? /*#__PURE__*/ _react.default.createElement("span", {
        style: sizerStyle
    }, sizerSvgUrl ? /*#__PURE__*/ _react.default.createElement("img", {
        style: {
            display: "block",
            maxWidth: "100%",
            width: "initial",
            height: "initial",
            background: "none",
            opacity: 1,
            border: 0,
            margin: 0,
            padding: 0
        },
        alt: "",
        "aria-hidden": true,
        src: sizerSvgUrl
    }) : null) : null, /*#__PURE__*/ _react.default.createElement(ImageElement, Object.assign({}, imgElementArgs))), priority ? // for browsers that do not support `imagesrcset`, and in those cases
    // it would likely cause the incorrect image to be preloaded.
    //
    // https://html.spec.whatwg.org/multipage/semantics.html#attr-link-imagesrcset
    /*#__PURE__*/ _react.default.createElement(_head.default, null, /*#__PURE__*/ _react.default.createElement("link", Object.assign({
        key: "__nimg-" + imgAttributes.src + imgAttributes.srcSet + imgAttributes.sizes,
        rel: "preload",
        as: "image",
        href: imgAttributes.srcSet ? undefined : imgAttributes.src
    }, linkProps))) : null);
}
function _defineProperty1(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _interopRequireWildcard(obj) {
    if (obj && obj.__esModule) {
        return obj;
    } else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj){
                if (Object.prototype.hasOwnProperty.call(obj, key)) {
                    var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                    if (desc.get || desc.set) {
                        Object.defineProperty(newObj, key, desc);
                    } else {
                        newObj[key] = obj[key];
                    }
                }
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function _objectSpread(target) {
    var _arguments = arguments, _loop = function(i) {
        var source = _arguments[i] != null ? _arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty1(target, key, source[key]);
        });
    };
    for(var i = 1; i < arguments.length; i++)_loop(i);
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var ref;
var experimentalLayoutRaw = (ref = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","experimentalLayoutRaw":false}) === null || ref === void 0 ? void 0 : ref.experimentalLayoutRaw;
var configEnv = {"deviceSizes":[640,750,828,1080,1200,1920,2048,3840],"imageSizes":[16,32,48,64,96,128,256,384],"path":"/_next/image","loader":"default","experimentalLayoutRaw":false};
var loadedImageURLs = new Set();
var allImgs = new Map();
var perfObserver;
var emptyDataURL = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
if (false) {}
var VALID_LOADING_VALUES = (/* unused pure expression or super */ null && ([
    "lazy",
    "eager",
    undefined
]));
var loaders = new Map([
    [
        "default",
        defaultLoader
    ],
    [
        "imgix",
        imgixLoader
    ],
    [
        "cloudinary",
        cloudinaryLoader
    ],
    [
        "akamai",
        akamaiLoader
    ],
    [
        "custom",
        customLoader
    ], 
]);
var VALID_LAYOUT_VALUES = (/* unused pure expression or super */ null && ([
    "fill",
    "fixed",
    "intrinsic",
    "responsive",
    "raw",
    undefined, 
]));
function isStaticRequire(src) {
    return src.default !== undefined;
}
function isStaticImageData(src) {
    return src.src !== undefined;
}
function isStaticImport(src) {
    return typeof src === "object" && (isStaticRequire(src) || isStaticImageData(src));
}
function getWidths(param, width, layout, sizes) {
    var deviceSizes = param.deviceSizes, allSizes = param.allSizes;
    if (sizes && (layout === "fill" || layout === "responsive" || layout === "raw")) {
        // Find all the "vw" percent sizes used in the sizes prop
        var viewportWidthRe = /(^|\s)(1?\d?\d)vw/g;
        var percentSizes = [];
        for(var match; match = viewportWidthRe.exec(sizes); match){
            percentSizes.push(parseInt(match[2]));
        }
        if (percentSizes.length) {
            var _Math;
            var smallestRatio = (_Math = Math).min.apply(_Math, _toConsumableArray(percentSizes)) * 0.01;
            return {
                widths: allSizes.filter(function(s) {
                    return s >= deviceSizes[0] * smallestRatio;
                }),
                kind: "w"
            };
        }
        return {
            widths: allSizes,
            kind: "w"
        };
    }
    if (typeof width !== "number" || layout === "fill" || layout === "responsive") {
        return {
            widths: deviceSizes,
            kind: "w"
        };
    }
    var widths = _toConsumableArray(new Set(// > are actually 3x in the green color, but only 1.5x in the red and
    // > blue colors. Showing a 3x resolution image in the app vs a 2x
    // > resolution image will be visually the same, though the 3x image
    // > takes significantly more data. Even true 3x resolution screens are
    // > wasteful as the human eye cannot see that level of detail without
    // > something like a magnifying glass.
    // https://blog.twitter.com/engineering/en_us/topics/infrastructure/2019/capping-image-fidelity-on-ultra-high-resolution-devices.html
    [
        width,
        width * 2 /*, width * 3*/ 
    ].map(function(w) {
        return allSizes.find(function(p) {
            return p >= w;
        }) || allSizes[allSizes.length - 1];
    })));
    return {
        widths: widths,
        kind: "x"
    };
}
function generateImgAttrs(param) {
    var config = param.config, src = param.src, unoptimized = param.unoptimized, layout = param.layout, width = param.width, quality = param.quality, sizes = param.sizes, loader = param.loader;
    if (unoptimized) {
        return {
            src: src,
            srcSet: undefined,
            sizes: undefined
        };
    }
    var ref3 = getWidths(config, width, layout, sizes), widths = ref3.widths, kind = ref3.kind;
    var last = widths.length - 1;
    return {
        sizes: !sizes && kind === "w" ? "100vw" : sizes,
        srcSet: widths.map(function(w, i) {
            return "".concat(loader({
                config: config,
                src: src,
                quality: quality,
                width: w
            }), " ").concat(kind === "w" ? w : i + 1).concat(kind);
        }).join(", "),
        // It's intended to keep `src` the last attribute because React updates
        // attributes in order. If we keep `src` the first one, Safari will
        // immediately start to fetch `src`, before `sizes` and `srcSet` are even
        // updated by React. That causes multiple unnecessary requests if `srcSet`
        // and `sizes` are defined.
        // This bug cannot be reproduced in Chrome or Firefox.
        src: loader({
            config: config,
            src: src,
            quality: quality,
            width: widths[last]
        })
    };
}
function getInt(x) {
    if (typeof x === "number") {
        return x;
    }
    if (typeof x === "string") {
        return parseInt(x, 10);
    }
    return undefined;
}
function defaultImageLoader(loaderProps) {
    var ref2;
    var loaderKey = ((ref2 = loaderProps.config) === null || ref2 === void 0 ? void 0 : ref2.loader) || "default";
    var load = loaders.get(loaderKey);
    if (load) {
        return load(loaderProps);
    }
    throw new Error('Unknown "loader" found in "next.config.js". Expected: '.concat(_imageConfig.VALID_LOADERS.join(", "), ". Received: ").concat(loaderKey));
}
// See https://stackoverflow.com/q/39777833/266535 for why we use this ref
// handler instead of the img's onLoad attribute.
function handleLoading(img, src, layout, placeholder, onLoadingCompleteRef, setBlurComplete) {
    if (!img || img.src === emptyDataURL || img["data-loaded-src"] === src) {
        return;
    }
    img["data-loaded-src"] = src;
    var p = "decode" in img ? img.decode() : Promise.resolve();
    p.catch(function() {}).then(function() {
        if (!img.parentNode) {
            // Exit early in case of race condition:
            // - onload() is called
            // - decode() is called but incomplete
            // - unmount is called
            // - decode() completes
            return;
        }
        loadedImageURLs.add(src);
        if (placeholder === "blur") {
            setBlurComplete(true);
        }
        if (onLoadingCompleteRef === null || onLoadingCompleteRef === void 0 ? void 0 : onLoadingCompleteRef.current) {
            var naturalWidth = img.naturalWidth, naturalHeight = img.naturalHeight;
            // Pass back read-only primitive values but not the
            // underlying DOM element because it could be misused.
            onLoadingCompleteRef.current({
                naturalWidth: naturalWidth,
                naturalHeight: naturalHeight
            });
        }
        if (false) { var parent, widthModified, heightModified, ref3; }
    });
}
var ImageElement = function(_param) {
    var imgAttributes = _param.imgAttributes, heightInt = _param.heightInt, widthInt = _param.widthInt, qualityInt = _param.qualityInt, layout = _param.layout, className = _param.className, imgStyle = _param.imgStyle, blurStyle = _param.blurStyle, isLazy = _param.isLazy, placeholder = _param.placeholder, loading = _param.loading, srcString = _param.srcString, config = _param.config, unoptimized = _param.unoptimized, loader = _param.loader, onLoadingCompleteRef = _param.onLoadingCompleteRef, setBlurComplete = _param.setBlurComplete, setIntersection = _param.setIntersection, onLoad = _param.onLoad, onError = _param.onError, isVisible = _param.isVisible, rest = _objectWithoutProperties(_param, [
        "imgAttributes",
        "heightInt",
        "widthInt",
        "qualityInt",
        "layout",
        "className",
        "imgStyle",
        "blurStyle",
        "isLazy",
        "placeholder",
        "loading",
        "srcString",
        "config",
        "unoptimized",
        "loader",
        "onLoadingCompleteRef",
        "setBlurComplete",
        "setIntersection",
        "onLoad",
        "onError",
        "isVisible"
    ]);
    return /*#__PURE__*/ _react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, imgAttributes, layout === "raw" ? {
        height: heightInt,
        width: widthInt
    } : {}, {
        decoding: "async",
        "data-nimg": layout,
        className: className,
        style: _objectSpread({}, imgStyle, blurStyle),
        ref: (0, _react).useCallback(function(img) {
            setIntersection(img);
            if (img === null || img === void 0 ? void 0 : img.complete) {
                handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            }
        }, [
            setIntersection,
            srcString,
            layout,
            placeholder,
            onLoadingCompleteRef,
            setBlurComplete, 
        ]),
        onLoad: function(event) {
            var img = event.currentTarget;
            handleLoading(img, srcString, layout, placeholder, onLoadingCompleteRef, setBlurComplete);
            if (onLoad) {
                onLoad(event);
            }
        },
        onError: function(event) {
            if (placeholder === "blur") {
                // If the real image fails to load, this will still remove the placeholder.
                setBlurComplete(true);
            }
            if (onError) {
                onError(event);
            }
        }
    })), (isLazy || placeholder === "blur") && /*#__PURE__*/ _react.default.createElement("noscript", null, /*#__PURE__*/ _react.default.createElement("img", Object.assign({}, rest, generateImgAttrs({
        config: config,
        src: srcString,
        unoptimized: unoptimized,
        layout: layout,
        width: widthInt,
        quality: qualityInt,
        sizes: imgAttributes.sizes,
        loader: loader
    }), layout === "raw" ? {
        height: heightInt,
        width: widthInt
    } : {}, {
        decoding: "async",
        "data-nimg": layout,
        style: imgStyle,
        className: className,
        // @ts-ignore - TODO: upgrade to `@types/react@17`
        loading: loading || "lazy"
    }))));
};
function normalizeSrc(src) {
    return src[0] === "/" ? src.slice(1) : src;
}
function imgixLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://static.imgix.net/daisy.png?auto=format&fit=max&w=300
    var url = new URL("".concat(config.path).concat(normalizeSrc(src)));
    var params = url.searchParams;
    params.set("auto", params.get("auto") || "format");
    params.set("fit", params.get("fit") || "max");
    params.set("w", params.get("w") || width.toString());
    if (quality) {
        params.set("q", quality.toString());
    }
    return url.href;
}
function akamaiLoader(param) {
    var config = param.config, src = param.src, width = param.width;
    return "".concat(config.path).concat(normalizeSrc(src), "?imwidth=").concat(width);
}
function cloudinaryLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    // Demo: https://res.cloudinary.com/demo/image/upload/w_300,c_limit,q_auto/turtles.jpg
    var params = [
        "f_auto",
        "c_limit",
        "w_" + width,
        "q_" + (quality || "auto")
    ];
    var paramsString = params.join(",") + "/";
    return "".concat(config.path).concat(paramsString).concat(normalizeSrc(src));
}
function customLoader(param) {
    var src = param.src;
    throw new Error('Image with src "'.concat(src, '" is missing "loader" prop.') + "\nRead more: https://nextjs.org/docs/messages/next-image-missing-loader");
}
function defaultLoader(param) {
    var config = param.config, src = param.src, width = param.width, quality = param.quality;
    if (false) { var parsedSrc, missingValues; }
    if (src.endsWith(".svg") && !config.dangerouslyAllowSVG) {
        // Special case to make svg serve as-is to avoid proxying
        // through the built-in Image Optimization API.
        return src;
    }
    return "".concat((0, _normalizeTrailingSlash).normalizePathTrailingSlash(config.path), "?url=").concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality || 75);
}
if (typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) {
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=image.js.map


/***/ }),

/***/ 81489:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.useIntersection = useIntersection;
var _react = __webpack_require__(67294);
var _requestIdleCallback = __webpack_require__(44686);
var hasIntersectionObserver = typeof IntersectionObserver !== "undefined";
function useIntersection(param) {
    var rootRef = param.rootRef, rootMargin = param.rootMargin, disabled = param.disabled;
    var isDisabled = disabled || !hasIntersectionObserver;
    var unobserve = (0, _react).useRef();
    var ref = _slicedToArray((0, _react).useState(false), 2), visible = ref[0], setVisible = ref[1];
    var ref1 = _slicedToArray((0, _react).useState(rootRef ? rootRef.current : null), 2), root = ref1[0], setRoot = ref1[1];
    var setRef = (0, _react).useCallback(function(el) {
        if (unobserve.current) {
            unobserve.current();
            unobserve.current = undefined;
        }
        if (isDisabled || visible) return;
        if (el && el.tagName) {
            unobserve.current = observe(el, function(isVisible) {
                return isVisible && setVisible(isVisible);
            }, {
                root: root,
                rootMargin: rootMargin
            });
        }
    }, [
        isDisabled,
        root,
        rootMargin,
        visible
    ]);
    var resetVisible = (0, _react).useCallback(function() {
        setVisible(false);
    }, []);
    (0, _react).useEffect(function() {
        if (!hasIntersectionObserver) {
            if (!visible) {
                var idleCallback = (0, _requestIdleCallback).requestIdleCallback(function() {
                    return setVisible(true);
                });
                return function() {
                    return (0, _requestIdleCallback).cancelIdleCallback(idleCallback);
                };
            }
        }
    }, [
        visible
    ]);
    (0, _react).useEffect(function() {
        if (rootRef) setRoot(rootRef.current);
    }, [
        rootRef
    ]);
    return [
        setRef,
        visible,
        resetVisible
    ];
}
function observe(element, callback, options) {
    var ref = createObserver(options), id = ref.id, observer = ref.observer, elements = ref.elements;
    elements.set(element, callback);
    observer.observe(element);
    return function unobserve() {
        elements.delete(element);
        observer.unobserve(element);
        // Destroy observer when there's nothing left to watch:
        if (elements.size === 0) {
            observer.disconnect();
            observers.delete(id);
            var index = idList.findIndex(function(obj) {
                return obj.root === id.root && obj.margin === id.margin;
            });
            if (index > -1) {
                idList.splice(index, 1);
            }
        }
    };
}
var observers = new Map();
var idList = [];
function createObserver(options) {
    var id = {
        root: options.root || null,
        margin: options.rootMargin || ""
    };
    var existing = idList.find(function(obj) {
        return obj.root === id.root && obj.margin === id.margin;
    });
    var instance;
    if (existing) {
        instance = observers.get(existing);
    } else {
        instance = observers.get(id);
        idList.push(id);
    }
    if (instance) {
        return instance;
    }
    var elements = new Map();
    var observer = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
            var callback = elements.get(entry.target);
            var isVisible = entry.isIntersecting || entry.intersectionRatio > 0;
            if (callback && isVisible) {
                callback(isVisible);
            }
        });
    }, options);
    observers.set(id, instance = {
        id: id,
        observer: observer,
        elements: elements
    });
    return instance;
}
if (typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) {
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=use-intersection.js.map


/***/ }),

/***/ 37645:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _loadable = _interopRequireDefault(__webpack_require__(14588));
function dynamic(dynamicOptions, options) {
    var loadableFn = _loadable.default;
    var loadableOptions = {
        // A loading component is not required, so we default it
        loading: function(param) {
            var error = param.error, isLoading = param.isLoading, pastDelay = param.pastDelay;
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (_instanceof(dynamicOptions, Promise)) {
        loadableOptions.loader = function() {
            return dynamicOptions;
        };
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _objectSpread({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _objectSpread({}, loadableOptions, options);
    var suspenseOptions = loadableOptions;
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (suspenseOptions.suspense) {
        return loadableFn(suspenseOptions);
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _objectSpread({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false})
    if (typeof loadableOptions.ssr === "boolean") {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    var Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return function() {
        return /*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
    };
}
if (typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) {
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 33644:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14588:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _react = _interopRequireDefault(__webpack_require__(67294));
var _useSubscription = __webpack_require__(82021);
var _loadableContext = __webpack_require__(33644);
function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var ALL_INITIALIZERS = [];
var READY_INITIALIZERS = [];
var initialized = false;
function load(loader) {
    var promise = loader();
    var state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then(function(loaded) {
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch(function(err) {
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    var init = function init() {
        if (!subscription) {
            var sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    };
    var LoadableImpl = function LoadableImpl(props, ref) {
        init();
        var context = _react.default.useContext(_loadableContext.LoadableContext);
        var state = (0, _useSubscription).useSubscription(subscription);
        _react.default.useImperativeHandle(ref, function() {
            return {
                retry: subscription.retry
            };
        }, []);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach(function(moduleName) {
                context(moduleName);
            });
        }
        return _react.default.useMemo(function() {
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    };
    var LazyImpl = function LazyImpl(props, ref) {
        return _react.default.createElement(opts.lazy, _objectSpread({}, props, {
            ref: ref
        }));
    };
    var opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    var subscription = null;
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined" && !opts.suspense) {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        var moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push(function(ids) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = moduleIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var moduleId = _step.value;
                        if (ids.indexOf(moduleId) !== -1) {
                            return init();
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
        }
    }
    var LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = function() {
        return !opts.suspense && init();
    };
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
var LoadableSubscription = /*#__PURE__*/ function() {
    function LoadableSubscription(loadFn, opts) {
        _classCallCheck(this, LoadableSubscription);
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
    _createClass(LoadableSubscription, [
        {
            key: "promise",
            value: function promise() {
                return this._res.promise;
            }
        },
        {
            key: "retry",
            value: function retry() {
                var _this = this;
                this._clearTimeouts();
                this._res = this._loadFn(this._opts.loader);
                this._state = {
                    pastDelay: false,
                    timedOut: false
                };
                var ref = this, res = ref._res, opts = ref._opts;
                if (res.loading) {
                    if (typeof opts.delay === "number") {
                        if (opts.delay === 0) {
                            this._state.pastDelay = true;
                        } else {
                            var _this1 = this;
                            this._delay = setTimeout(function() {
                                _this1._update({
                                    pastDelay: true
                                });
                            }, opts.delay);
                        }
                    }
                    if (typeof opts.timeout === "number") {
                        var _this2 = this;
                        this._timeout = setTimeout(function() {
                            _this2._update({
                                timedOut: true
                            });
                        }, opts.timeout);
                    }
                }
                this._res.promise.then(function() {
                    _this._update({});
                    _this._clearTimeouts();
                }).catch(function(_err) {
                    _this._update({});
                    _this._clearTimeouts();
                });
                this._update({});
            }
        },
        {
            key: "_update",
            value: function _update(partial) {
                this._state = _objectSpread({}, this._state, {
                    error: this._res.error,
                    loaded: this._res.loaded,
                    loading: this._res.loading
                }, partial);
                this._callbacks.forEach(function(callback) {
                    return callback();
                });
            }
        },
        {
            key: "_clearTimeouts",
            value: function _clearTimeouts() {
                clearTimeout(this._delay);
                clearTimeout(this._timeout);
            }
        },
        {
            key: "getCurrentValue",
            value: function getCurrentValue() {
                return this._state;
            }
        },
        {
            key: "subscribe",
            value: function subscribe(callback) {
                var _this = this;
                this._callbacks.add(callback);
                return function() {
                    _this._callbacks.delete(callback);
                };
            }
        }
    ]);
    return LoadableSubscription;
}();
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    var promises = [];
    while(initializers.length){
        var init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(function() {
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = function() {
    return new Promise(function(resolveInitializers, reject) {
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = function() {
    var ids = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    return new Promise(function(resolvePreload) {
        var res = function() {
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 38484:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var tailwindcss_tailwind_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52490);
/* harmony import */ var tailwindcss_tailwind_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(tailwindcss_tailwind_css__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _styles_globals_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(97039);
/* harmony import */ var _styles_globals_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_styles_globals_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _styles_input_focus_none_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46848);
/* harmony import */ var _styles_input_focus_none_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_input_focus_none_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _components_global_LoaderSvg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(77403);
/* harmony import */ var _frontegg_nextjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(38623);
/* harmony import */ var _frontegg_nextjs__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_frontegg_nextjs__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_identityApp_context__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(9777);
/* harmony import */ var _app_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(53067);
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}









var contextOptions = {
    // hostedLoginBox: false,
    hostedLoginBox: true,
    baseUrl: "https://staging.auth.imprintengine.io" || 0,
    clientId: "da45aacb-da8d-4f30-a89c-0f834680f276"
};
function App(param) {
    var Component = param.Component, pageProps = param.pageProps, err = param.err;
    var ref2;
    console.log("contextOptions: ", contextOptions);
    var ref1 = _slicedToArray(react__WEBPACK_IMPORTED_MODULE_4__.useState(null), 2), proppies = ref1[0], setProppies = ref1[1];
    react__WEBPACK_IMPORTED_MODULE_4__.useEffect(function() {
        if (/localhost:8888/i.test(window === null || window === void 0 ? void 0 : window.location.href)) {
            console.log('YOU ARE AT "localhost:8888/". REDIRECTING YOU TO "http://app.imprintengine.pim:8888/"');
            window.location.href = "http://app.imprintengine.pim:8888/";
        }
        var pathname = window === null || window === void 0 ? void 0 : window.location.pathname;
        var hosty = window === null || window === void 0 ? void 0 : window.location.host;
        /* TO BYPASS THE DEFAULT "LAYOUT", LEFT-SIDE COLLAPSABLE NAVBAR,
            ADD ROUTE NAME TO FOLLOWING REGEX */ var removeNavigation = /\/editor\/([0-9]{16})/.test(pathname);
        var ref = getUrls(hosty), apiUrl = ref.apiUrl, appUrl = ref.appUrl;
        var tempProppies = {
            navigation: !removeNavigation,
            host: hosty,
            environment: "staging" || 0,
            component: Component,
            app: {
                url: appUrl,
                component: Component,
                name: "tenant",
                entity_id: 0,
                entity: {},
                router: null
            },
            api: {
                url: apiUrl
            }
        };
        setProppies(tempProppies);
    }, [
        Component
    ]);
    if (!proppies) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_global_LoaderSvg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {});
    }
    if (!proppies.app) {
        return null;
    }
    if ((proppies === null || proppies === void 0 ? void 0 : (ref2 = proppies.app) === null || ref2 === void 0 ? void 0 : ref2.name) !== "tenant") {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_frontegg_nextjs__WEBPACK_IMPORTED_MODULE_6__.FronteggProvider, {
        contextOptions: contextOptions,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_identityApp_context__WEBPACK_IMPORTED_MODULE_7__/* .IdentityProvider */ .E, _objectSpread({}, proppies, pageProps, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_js__WEBPACK_IMPORTED_MODULE_8__["default"], _objectSpread({}, proppies, pageProps))
        }))
    });
}
/* harmony default export */ __webpack_exports__["default"] = (App);
var getUrls = function(host) {
    return {
        /* URL prefix needed for API calls (as is today.  probably can change to relative URLs) */ apiUrl: "http".concat(/pim/i.test(host) ? "" : "s", "://").concat(host, "/api/rest"),
        appUrl: "http".concat(/pim/i.test(host) ? "" : "s", "://").concat(host)
    };
};


/***/ }),

/***/ 53067:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ TenantApp; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_global_LoaderSvg__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(77403);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _print_engine_utilities_integrations__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79523);
/* harmony import */ var _print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93909);
/* harmony import */ var _components_identityApp_context__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9777);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}







var TenantBackend = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5046), __webpack_require__.e(2962), __webpack_require__.e(1897), __webpack_require__.e(1570), __webpack_require__.e(2701)]).then(__webpack_require__.bind(__webpack_require__, 92701));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92701)
            ];
        }
    }
});
function TenantApp() {
    var user_props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    console.log("___\nRENDER: TenantApp (pages/app.js)");
    var identity = (0,_components_identityApp_context__WEBPACK_IMPORTED_MODULE_6__/* .useIdentity */ .j)();
    var currentUser = identity.currentUser, currentEnvironment = identity.currentEnvironment;
    var integrations = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        var integ = new _print_engine_utilities_integrations__WEBPACK_IMPORTED_MODULE_4__.Integrations({
            hasura: {
                load: [
                    "orders/orders",
                    "organizations/clients",
                    "projects/projects",
                    "tenants/tenants",
                    "users/users", 
                ]
            }
        }, {
            environment: currentEnvironment,
            application: user_props["app"]["name"],
            context: "frontend",
            token: currentUser["accessToken"]
        });
        return integ;
    }, [
        currentUser,
        user_props
    ]);
    var default_props = {
        api: {
            integrations: {
                hasura: integrations["hasura"]
            }
        }
    };
    var props = (0,react__WEBPACK_IMPORTED_MODULE_2__.useMemo)(function() {
        return (0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_5__.merge)((0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_5__.merge)(default_props, user_props), identity);
    }, [
        default_props,
        user_props
    ]);
    /**
     *  ex- "/editor/[designId]"
     * WHITE-LABELED
     */ if (!props.navigation) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(props.component, _objectSpread({}, props));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(TenantBackend, _objectSpread({}, props));
};


/***/ }),

/***/ 55024:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "AWS_Secrets_Manager": function() { return /* binding */ AWS_Secrets_Manager; },
  "Configuration": function() { return /* binding */ Configuration; }
});

// NAMESPACE OBJECT: ./node_modules/@aws-sdk/util-endpoints/dist-es/lib/aws/index.js
var aws_namespaceObject = {};
__webpack_require__.r(aws_namespaceObject);
__webpack_require__.d(aws_namespaceObject, {
  "isVirtualHostableS3Bucket": function() { return isVirtualHostableS3Bucket; },
  "parseArn": function() { return parseArn; },
  "partition": function() { return partition; }
});

// NAMESPACE OBJECT: ./node_modules/@aws-sdk/util-endpoints/dist-es/lib/index.js
var lib_namespaceObject = {};
__webpack_require__.r(lib_namespaceObject);
__webpack_require__.d(lib_namespaceObject, {
  "aws": function() { return aws_namespaceObject; },
  "booleanEquals": function() { return booleanEquals; },
  "getAttr": function() { return getAttr; },
  "isSet": function() { return isSet; },
  "isValidHostLabel": function() { return isValidHostLabel; },
  "not": function() { return not; },
  "parseURL": function() { return parseURL; },
  "stringEquals": function() { return stringEquals; },
  "substring": function() { return substring; },
  "uriEncode": function() { return uriEncode; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-serde/dist-es/deserializerMiddleware.js
const deserializerMiddleware = (options, deserializer) => (next, context) => async (args) => {
    const { response } = await next(args);
    try {
        const parsed = await deserializer(response, options);
        return {
            response,
            output: parsed,
        };
    }
    catch (error) {
        Object.defineProperty(error, "$response", {
            value: response,
        });
        throw error;
    }
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-serde/dist-es/serializerMiddleware.js
const serializerMiddleware = (options, serializer) => (next, context) => async (args) => {
    const endpoint = context.endpointV2?.url && options.urlParser
        ? async () => options.urlParser(context.endpointV2.url)
        : options.endpoint;
    if (!endpoint) {
        throw new Error("No valid endpoint provider available.");
    }
    const request = await serializer(args.input, { ...options, endpoint });
    return next({
        ...args,
        request,
    });
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-serde/dist-es/serdePlugin.js


const deserializerMiddlewareOption = {
    name: "deserializerMiddleware",
    step: "deserialize",
    tags: ["DESERIALIZER"],
    override: true,
};
const serializerMiddlewareOption = {
    name: "serializerMiddleware",
    step: "serialize",
    tags: ["SERIALIZER"],
    override: true,
};
function getSerdePlugin(config, serializer, deserializer) {
    return {
        applyToStack: (commandStack) => {
            commandStack.add(deserializerMiddleware(config, deserializer), deserializerMiddlewareOption);
            commandStack.add(serializerMiddleware(config, serializer), serializerMiddlewareOption);
        },
    };
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-serde/dist-es/index.js




;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-endpoint/dist-es/service-customizations/s3.js
const resolveParamsForS3 = async (endpointParams) => {
    const bucket = endpointParams?.Bucket || "";
    if (typeof endpointParams.Bucket === "string") {
        endpointParams.Bucket = bucket.replace(/#/g, encodeURIComponent("#")).replace(/\?/g, encodeURIComponent("?"));
    }
    if (isArnBucketName(bucket)) {
        if (endpointParams.ForcePathStyle === true) {
            throw new Error("Path-style addressing cannot be used with ARN buckets");
        }
    }
    else if (!isDnsCompatibleBucketName(bucket) ||
        (bucket.indexOf(".") !== -1 && !String(endpointParams.Endpoint).startsWith("http:")) ||
        bucket.toLowerCase() !== bucket ||
        bucket.length < 3) {
        endpointParams.ForcePathStyle = true;
    }
    if (endpointParams.DisableMultiRegionAccessPoints) {
        endpointParams.disableMultiRegionAccessPoints = true;
        endpointParams.DisableMRAP = true;
    }
    return endpointParams;
};
const DOMAIN_PATTERN = /^[a-z0-9][a-z0-9\.\-]{1,61}[a-z0-9]$/;
const IP_ADDRESS_PATTERN = /(\d+\.){3}\d+/;
const DOTS_PATTERN = /\.\./;
const DOT_PATTERN = /\./;
const S3_HOSTNAME_PATTERN = /^(.+\.)?s3(-fips)?(\.dualstack)?[.-]([a-z0-9-]+)\./;
const isDnsCompatibleBucketName = (bucketName) => DOMAIN_PATTERN.test(bucketName) && !IP_ADDRESS_PATTERN.test(bucketName) && !DOTS_PATTERN.test(bucketName);
const isArnBucketName = (bucketName) => {
    const [arn, partition, service, region, account, typeOrId] = bucketName.split(":");
    const isArn = arn === "arn" && bucketName.split(":").length >= 6;
    const isValidArn = [arn, partition, service, account, typeOrId].filter(Boolean).length === 5;
    if (isArn && !isValidArn) {
        throw new Error(`Invalid ARN: ${bucketName} was an invalid ARN.`);
    }
    return arn === "arn" && !!partition && !!service && !!account && !!typeOrId;
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-endpoint/dist-es/adaptors/createConfigValueProvider.js
const createConfigValueProvider = (configKey, canonicalEndpointParamKey, config) => {
    const configProvider = async () => {
        const configValue = config[configKey] ?? config[canonicalEndpointParamKey];
        if (typeof configValue === "function") {
            return configValue();
        }
        return configValue;
    };
    if (configKey === "endpoint" || canonicalEndpointParamKey === "endpoint") {
        return async () => {
            const endpoint = await configProvider();
            if (endpoint && typeof endpoint === "object") {
                if ("url" in endpoint) {
                    return endpoint.url.href;
                }
                if ("hostname" in endpoint) {
                    const { protocol, hostname, port, path } = endpoint;
                    return `${protocol}//${hostname}${port ? ":" + port : ""}${path}`;
                }
            }
            return endpoint;
        };
    }
    return configProvider;
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-endpoint/dist-es/adaptors/getEndpointFromInstructions.js


const getEndpointFromInstructions = async (commandInput, instructionsSupplier, clientConfig, context) => {
    const endpointParams = await resolveParams(commandInput, instructionsSupplier, clientConfig);
    if (typeof clientConfig.endpointProvider !== "function") {
        throw new Error("config.endpointProvider is not set.");
    }
    const endpoint = clientConfig.endpointProvider(endpointParams, context);
    return endpoint;
};
const resolveParams = async (commandInput, instructionsSupplier, clientConfig) => {
    const endpointParams = {};
    const instructions = instructionsSupplier?.getEndpointParameterInstructions?.() || {};
    for (const [name, instruction] of Object.entries(instructions)) {
        switch (instruction.type) {
            case "staticContextParams":
                endpointParams[name] = instruction.value;
                break;
            case "contextParams":
                endpointParams[name] = commandInput[instruction.name];
                break;
            case "clientContextParams":
            case "builtInParams":
                endpointParams[name] = await createConfigValueProvider(instruction.name, name, clientConfig)();
                break;
            default:
                throw new Error("Unrecognized endpoint parameter instruction: " + JSON.stringify(instruction));
        }
    }
    if (Object.keys(instructions).length === 0) {
        Object.assign(endpointParams, clientConfig);
    }
    if (String(clientConfig.serviceId).toLowerCase() === "s3") {
        await resolveParamsForS3(endpointParams);
    }
    return endpointParams;
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-endpoint/dist-es/endpointMiddleware.js

const endpointMiddleware = ({ config, instructions, }) => {
    return (next, context) => async (args) => {
        const endpoint = await getEndpointFromInstructions(args.input, {
            getEndpointParameterInstructions() {
                return instructions;
            },
        }, { ...config }, context);
        context.endpointV2 = endpoint;
        context.authSchemes = endpoint.properties?.authSchemes;
        const authScheme = context.authSchemes?.[0];
        if (authScheme) {
            context["signing_region"] = authScheme.signingRegion;
            context["signing_service"] = authScheme.signingName;
        }
        return next({
            ...args,
        });
    };
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-endpoint/dist-es/getEndpointPlugin.js


const endpointMiddlewareOptions = {
    step: "serialize",
    tags: ["ENDPOINT_PARAMETERS", "ENDPOINT_V2", "ENDPOINT"],
    name: "endpointV2Middleware",
    override: true,
    relation: "before",
    toMiddleware: serializerMiddlewareOption.name,
};
const getEndpointPlugin = (config, instructions) => ({
    applyToStack: (clientStack) => {
        clientStack.addRelativeTo(endpointMiddleware({
            config,
            instructions,
        }), endpointMiddlewareOptions);
    },
});

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-middleware/dist-es/normalizeProvider.js
const normalizeProvider_normalizeProvider = (input) => {
    if (typeof input === "function")
        return input;
    const promisified = Promise.resolve(input);
    return () => promisified;
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/querystring-parser/dist-es/index.js
function parseQueryString(querystring) {
    const query = {};
    querystring = querystring.replace(/^\?/, "");
    if (querystring) {
        for (const pair of querystring.split("&")) {
            let [key, value = null] = pair.split("=");
            key = decodeURIComponent(key);
            if (value) {
                value = decodeURIComponent(value);
            }
            if (!(key in query)) {
                query[key] = value;
            }
            else if (Array.isArray(query[key])) {
                query[key].push(value);
            }
            else {
                query[key] = [query[key], value];
            }
        }
    }
    return query;
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/url-parser/dist-es/index.js

const parseUrl = (url) => {
    if (typeof url === "string") {
        return parseUrl(new URL(url));
    }
    const { hostname, pathname, port, protocol, search } = url;
    let query;
    if (search) {
        query = parseQueryString(search);
    }
    return {
        hostname,
        port: port ? parseInt(port) : undefined,
        protocol,
        path: pathname,
        query,
    };
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-endpoint/dist-es/adaptors/toEndpointV1.js

const toEndpointV1 = (endpoint) => {
    if (typeof endpoint === "object") {
        if ("url" in endpoint) {
            return parseUrl(endpoint.url);
        }
        return endpoint;
    }
    return parseUrl(endpoint);
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-endpoint/dist-es/resolveEndpointConfig.js


const resolveEndpointConfig = (input) => {
    const tls = input.tls ?? true;
    const { endpoint } = input;
    const customEndpointProvider = endpoint != null ? async () => toEndpointV1(await normalizeProvider_normalizeProvider(endpoint)()) : undefined;
    const isCustomEndpoint = !!endpoint;
    return {
        ...input,
        endpoint: customEndpointProvider,
        tls,
        isCustomEndpoint,
        useDualstackEndpoint: normalizeProvider_normalizeProvider(input.useDualstackEndpoint ?? false),
        useFipsEndpoint: normalizeProvider_normalizeProvider(input.useFipsEndpoint ?? false),
    };
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-endpoint/dist-es/index.js






;// CONCATENATED MODULE: ./node_modules/@aws-sdk/smithy-client/dist-es/NoOpLogger.js
class NoOpLogger {
    trace() { }
    debug() { }
    info() { }
    warn() { }
    error() { }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-stack/dist-es/MiddlewareStack.js
const constructStack = () => {
    let absoluteEntries = [];
    let relativeEntries = [];
    const entriesNameSet = new Set();
    const sort = (entries) => entries.sort((a, b) => stepWeights[b.step] - stepWeights[a.step] ||
        priorityWeights[b.priority || "normal"] - priorityWeights[a.priority || "normal"]);
    const removeByName = (toRemove) => {
        let isRemoved = false;
        const filterCb = (entry) => {
            if (entry.name && entry.name === toRemove) {
                isRemoved = true;
                entriesNameSet.delete(toRemove);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    const removeByReference = (toRemove) => {
        let isRemoved = false;
        const filterCb = (entry) => {
            if (entry.middleware === toRemove) {
                isRemoved = true;
                if (entry.name)
                    entriesNameSet.delete(entry.name);
                return false;
            }
            return true;
        };
        absoluteEntries = absoluteEntries.filter(filterCb);
        relativeEntries = relativeEntries.filter(filterCb);
        return isRemoved;
    };
    const cloneTo = (toStack) => {
        absoluteEntries.forEach((entry) => {
            toStack.add(entry.middleware, { ...entry });
        });
        relativeEntries.forEach((entry) => {
            toStack.addRelativeTo(entry.middleware, { ...entry });
        });
        return toStack;
    };
    const expandRelativeMiddlewareList = (from) => {
        const expandedMiddlewareList = [];
        from.before.forEach((entry) => {
            if (entry.before.length === 0 && entry.after.length === 0) {
                expandedMiddlewareList.push(entry);
            }
            else {
                expandedMiddlewareList.push(...expandRelativeMiddlewareList(entry));
            }
        });
        expandedMiddlewareList.push(from);
        from.after.reverse().forEach((entry) => {
            if (entry.before.length === 0 && entry.after.length === 0) {
                expandedMiddlewareList.push(entry);
            }
            else {
                expandedMiddlewareList.push(...expandRelativeMiddlewareList(entry));
            }
        });
        return expandedMiddlewareList;
    };
    const getMiddlewareList = (debug = false) => {
        const normalizedAbsoluteEntries = [];
        const normalizedRelativeEntries = [];
        const normalizedEntriesNameMap = {};
        absoluteEntries.forEach((entry) => {
            const normalizedEntry = {
                ...entry,
                before: [],
                after: [],
            };
            if (normalizedEntry.name)
                normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedAbsoluteEntries.push(normalizedEntry);
        });
        relativeEntries.forEach((entry) => {
            const normalizedEntry = {
                ...entry,
                before: [],
                after: [],
            };
            if (normalizedEntry.name)
                normalizedEntriesNameMap[normalizedEntry.name] = normalizedEntry;
            normalizedRelativeEntries.push(normalizedEntry);
        });
        normalizedRelativeEntries.forEach((entry) => {
            if (entry.toMiddleware) {
                const toMiddleware = normalizedEntriesNameMap[entry.toMiddleware];
                if (toMiddleware === undefined) {
                    if (debug) {
                        return;
                    }
                    throw new Error(`${entry.toMiddleware} is not found when adding ${entry.name || "anonymous"} middleware ${entry.relation} ${entry.toMiddleware}`);
                }
                if (entry.relation === "after") {
                    toMiddleware.after.push(entry);
                }
                if (entry.relation === "before") {
                    toMiddleware.before.push(entry);
                }
            }
        });
        const mainChain = sort(normalizedAbsoluteEntries)
            .map(expandRelativeMiddlewareList)
            .reduce((wholeList, expendedMiddlewareList) => {
            wholeList.push(...expendedMiddlewareList);
            return wholeList;
        }, []);
        return mainChain;
    };
    const stack = {
        add: (middleware, options = {}) => {
            const { name, override } = options;
            const entry = {
                step: "initialize",
                priority: "normal",
                middleware,
                ...options,
            };
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override)
                        throw new Error(`Duplicate middleware name '${name}'`);
                    const toOverrideIndex = absoluteEntries.findIndex((entry) => entry.name === name);
                    const toOverride = absoluteEntries[toOverrideIndex];
                    if (toOverride.step !== entry.step || toOverride.priority !== entry.priority) {
                        throw new Error(`"${name}" middleware with ${toOverride.priority} priority in ${toOverride.step} step cannot be ` +
                            `overridden by same-name middleware with ${entry.priority} priority in ${entry.step} step.`);
                    }
                    absoluteEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            absoluteEntries.push(entry);
        },
        addRelativeTo: (middleware, options) => {
            const { name, override } = options;
            const entry = {
                middleware,
                ...options,
            };
            if (name) {
                if (entriesNameSet.has(name)) {
                    if (!override)
                        throw new Error(`Duplicate middleware name '${name}'`);
                    const toOverrideIndex = relativeEntries.findIndex((entry) => entry.name === name);
                    const toOverride = relativeEntries[toOverrideIndex];
                    if (toOverride.toMiddleware !== entry.toMiddleware || toOverride.relation !== entry.relation) {
                        throw new Error(`"${name}" middleware ${toOverride.relation} "${toOverride.toMiddleware}" middleware cannot be overridden ` +
                            `by same-name middleware ${entry.relation} "${entry.toMiddleware}" middleware.`);
                    }
                    relativeEntries.splice(toOverrideIndex, 1);
                }
                entriesNameSet.add(name);
            }
            relativeEntries.push(entry);
        },
        clone: () => cloneTo(constructStack()),
        use: (plugin) => {
            plugin.applyToStack(stack);
        },
        remove: (toRemove) => {
            if (typeof toRemove === "string")
                return removeByName(toRemove);
            else
                return removeByReference(toRemove);
        },
        removeByTag: (toRemove) => {
            let isRemoved = false;
            const filterCb = (entry) => {
                const { tags, name } = entry;
                if (tags && tags.includes(toRemove)) {
                    if (name)
                        entriesNameSet.delete(name);
                    isRemoved = true;
                    return false;
                }
                return true;
            };
            absoluteEntries = absoluteEntries.filter(filterCb);
            relativeEntries = relativeEntries.filter(filterCb);
            return isRemoved;
        },
        concat: (from) => {
            const cloned = cloneTo(constructStack());
            cloned.use(from);
            return cloned;
        },
        applyToStack: cloneTo,
        identify: () => {
            return getMiddlewareList(true).map((mw) => {
                return mw.name + ": " + (mw.tags || []).join(",");
            });
        },
        resolve: (handler, context) => {
            for (const middleware of getMiddlewareList()
                .map((entry) => entry.middleware)
                .reverse()) {
                handler = middleware(handler, context);
            }
            return handler;
        },
    };
    return stack;
};
const stepWeights = {
    initialize: 5,
    serialize: 4,
    build: 3,
    finalizeRequest: 2,
    deserialize: 1,
};
const priorityWeights = {
    high: 3,
    normal: 2,
    low: 1,
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-stack/dist-es/index.js


;// CONCATENATED MODULE: ./node_modules/@aws-sdk/smithy-client/dist-es/client.js

class Client {
    constructor(config) {
        this.middlewareStack = constructStack();
        this.config = config;
    }
    send(command, optionsOrCb, cb) {
        const options = typeof optionsOrCb !== "function" ? optionsOrCb : undefined;
        const callback = typeof optionsOrCb === "function" ? optionsOrCb : cb;
        const handler = command.resolveMiddleware(this.middlewareStack, this.config, options);
        if (callback) {
            handler(command)
                .then((result) => callback(null, result.output), (err) => callback(err))
                .catch(() => { });
        }
        else {
            return handler(command).then((result) => result.output);
        }
    }
    destroy() {
        if (this.config.requestHandler.destroy)
            this.config.requestHandler.destroy();
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/smithy-client/dist-es/command.js

class Command {
    constructor() {
        this.middlewareStack = constructStack();
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/smithy-client/dist-es/constants.js
const SENSITIVE_STRING = "***SensitiveInformation***";

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/smithy-client/dist-es/parse-utils.js
const parseBoolean = (value) => {
    switch (value) {
        case "true":
            return true;
        case "false":
            return false;
        default:
            throw new Error(`Unable to parse boolean value "${value}"`);
    }
};
const expectBoolean = (value) => {
    if (value === null || value === undefined) {
        return undefined;
    }
    if (typeof value === "number") {
        if (value === 0 || value === 1) {
            logger.warn(stackTraceWarning(`Expected boolean, got ${typeof value}: ${value}`));
        }
        if (value === 0) {
            return false;
        }
        if (value === 1) {
            return true;
        }
    }
    if (typeof value === "string") {
        const lower = value.toLowerCase();
        if (lower === "false" || lower === "true") {
            logger.warn(stackTraceWarning(`Expected boolean, got ${typeof value}: ${value}`));
        }
        if (lower === "false") {
            return false;
        }
        if (lower === "true") {
            return true;
        }
    }
    if (typeof value === "boolean") {
        return value;
    }
    throw new TypeError(`Expected boolean, got ${typeof value}: ${value}`);
};
const expectNumber = (value) => {
    if (value === null || value === undefined) {
        return undefined;
    }
    if (typeof value === "string") {
        const parsed = parseFloat(value);
        if (!Number.isNaN(parsed)) {
            if (String(parsed) !== String(value)) {
                logger.warn(stackTraceWarning(`Expected number but observed string: ${value}`));
            }
            return parsed;
        }
    }
    if (typeof value === "number") {
        return value;
    }
    throw new TypeError(`Expected number, got ${typeof value}: ${value}`);
};
const MAX_FLOAT = Math.ceil(2 ** 127 * (2 - 2 ** -23));
const expectFloat32 = (value) => {
    const expected = expectNumber(value);
    if (expected !== undefined && !Number.isNaN(expected) && expected !== Infinity && expected !== -Infinity) {
        if (Math.abs(expected) > MAX_FLOAT) {
            throw new TypeError(`Expected 32-bit float, got ${value}`);
        }
    }
    return expected;
};
const expectLong = (value) => {
    if (value === null || value === undefined) {
        return undefined;
    }
    if (Number.isInteger(value) && !Number.isNaN(value)) {
        return value;
    }
    throw new TypeError(`Expected integer, got ${typeof value}: ${value}`);
};
const expectInt = (/* unused pure expression or super */ null && (expectLong));
const expectInt32 = (value) => expectSizedInt(value, 32);
const expectShort = (value) => expectSizedInt(value, 16);
const expectByte = (value) => expectSizedInt(value, 8);
const expectSizedInt = (value, size) => {
    const expected = expectLong(value);
    if (expected !== undefined && castInt(expected, size) !== expected) {
        throw new TypeError(`Expected ${size}-bit integer, got ${value}`);
    }
    return expected;
};
const castInt = (value, size) => {
    switch (size) {
        case 32:
            return Int32Array.of(value)[0];
        case 16:
            return Int16Array.of(value)[0];
        case 8:
            return Int8Array.of(value)[0];
    }
};
const expectNonNull = (value, location) => {
    if (value === null || value === undefined) {
        if (location) {
            throw new TypeError(`Expected a non-null value for ${location}`);
        }
        throw new TypeError("Expected a non-null value");
    }
    return value;
};
const expectObject = (value) => {
    if (value === null || value === undefined) {
        return undefined;
    }
    if (typeof value === "object" && !Array.isArray(value)) {
        return value;
    }
    const receivedType = Array.isArray(value) ? "array" : typeof value;
    throw new TypeError(`Expected object, got ${receivedType}: ${value}`);
};
const expectString = (value) => {
    if (value === null || value === undefined) {
        return undefined;
    }
    if (typeof value === "string") {
        return value;
    }
    if (["boolean", "number", "bigint"].includes(typeof value)) {
        logger.warn(stackTraceWarning(`Expected string, got ${typeof value}: ${value}`));
        return String(value);
    }
    throw new TypeError(`Expected string, got ${typeof value}: ${value}`);
};
const expectUnion = (value) => {
    if (value === null || value === undefined) {
        return undefined;
    }
    const asObject = expectObject(value);
    const setKeys = Object.entries(asObject)
        .filter(([, v]) => v != null)
        .map(([k]) => k);
    if (setKeys.length === 0) {
        throw new TypeError(`Unions must have exactly one non-null member. None were found.`);
    }
    if (setKeys.length > 1) {
        throw new TypeError(`Unions must have exactly one non-null member. Keys ${setKeys} were not null.`);
    }
    return asObject;
};
const strictParseDouble = (value) => {
    if (typeof value == "string") {
        return expectNumber(parseNumber(value));
    }
    return expectNumber(value);
};
const strictParseFloat = (/* unused pure expression or super */ null && (strictParseDouble));
const parse_utils_strictParseFloat32 = (value) => {
    if (typeof value == "string") {
        return expectFloat32(parseNumber(value));
    }
    return expectFloat32(value);
};
const NUMBER_REGEX = /(-?(?:0|[1-9]\d*)(?:\.\d+)?(?:[eE][+-]?\d+)?)|(-?Infinity)|(NaN)/g;
const parseNumber = (value) => {
    const matches = value.match(NUMBER_REGEX);
    if (matches === null || matches[0].length !== value.length) {
        throw new TypeError(`Expected real number, got implicit NaN`);
    }
    return parseFloat(value);
};
const limitedParseDouble = (value) => {
    if (typeof value == "string") {
        return parseFloatString(value);
    }
    return expectNumber(value);
};
const handleFloat = (/* unused pure expression or super */ null && (limitedParseDouble));
const limitedParseFloat = (/* unused pure expression or super */ null && (limitedParseDouble));
const limitedParseFloat32 = (value) => {
    if (typeof value == "string") {
        return parseFloatString(value);
    }
    return expectFloat32(value);
};
const parseFloatString = (value) => {
    switch (value) {
        case "NaN":
            return NaN;
        case "Infinity":
            return Infinity;
        case "-Infinity":
            return -Infinity;
        default:
            throw new Error(`Unable to parse float value: ${value}`);
    }
};
const strictParseLong = (value) => {
    if (typeof value === "string") {
        return expectLong(parseNumber(value));
    }
    return expectLong(value);
};
const strictParseInt = (/* unused pure expression or super */ null && (strictParseLong));
const strictParseInt32 = (value) => {
    if (typeof value === "string") {
        return expectInt32(parseNumber(value));
    }
    return expectInt32(value);
};
const parse_utils_strictParseShort = (value) => {
    if (typeof value === "string") {
        return expectShort(parseNumber(value));
    }
    return expectShort(value);
};
const parse_utils_strictParseByte = (value) => {
    if (typeof value === "string") {
        return expectByte(parseNumber(value));
    }
    return expectByte(value);
};
const stackTraceWarning = (message) => {
    return String(new TypeError(message).stack || message)
        .split("\n")
        .slice(0, 5)
        .filter((s) => !s.includes("stackTraceWarning"))
        .join("\n");
};
const logger = {
    warn: console.warn,
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/smithy-client/dist-es/date-utils.js

const DAYS = (/* unused pure expression or super */ null && (["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"]));
const MONTHS = (/* unused pure expression or super */ null && (["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]));
function dateToUtcString(date) {
    const year = date.getUTCFullYear();
    const month = date.getUTCMonth();
    const dayOfWeek = date.getUTCDay();
    const dayOfMonthInt = date.getUTCDate();
    const hoursInt = date.getUTCHours();
    const minutesInt = date.getUTCMinutes();
    const secondsInt = date.getUTCSeconds();
    const dayOfMonthString = dayOfMonthInt < 10 ? `0${dayOfMonthInt}` : `${dayOfMonthInt}`;
    const hoursString = hoursInt < 10 ? `0${hoursInt}` : `${hoursInt}`;
    const minutesString = minutesInt < 10 ? `0${minutesInt}` : `${minutesInt}`;
    const secondsString = secondsInt < 10 ? `0${secondsInt}` : `${secondsInt}`;
    return `${DAYS[dayOfWeek]}, ${dayOfMonthString} ${MONTHS[month]} ${year} ${hoursString}:${minutesString}:${secondsString} GMT`;
}
const RFC3339 = (/* unused pure expression or super */ null && (new RegExp(/^(\d{4})-(\d{2})-(\d{2})[tT](\d{2}):(\d{2}):(\d{2})(?:\.(\d+))?[zZ]$/)));
const parseRfc3339DateTime = (value) => {
    if (value === null || value === undefined) {
        return undefined;
    }
    if (typeof value !== "string") {
        throw new TypeError("RFC-3339 date-times must be expressed as strings");
    }
    const match = RFC3339.exec(value);
    if (!match) {
        throw new TypeError("Invalid RFC-3339 date-time value");
    }
    const [_, yearStr, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds] = match;
    const year = strictParseShort(stripLeadingZeroes(yearStr));
    const month = parseDateValue(monthStr, "month", 1, 12);
    const day = parseDateValue(dayStr, "day", 1, 31);
    return buildDate(year, month, day, { hours, minutes, seconds, fractionalMilliseconds });
};
const IMF_FIXDATE = (/* unused pure expression or super */ null && (new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d{2}) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/)));
const RFC_850_DATE = (/* unused pure expression or super */ null && (new RegExp(/^(?:Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d{2})-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? GMT$/)));
const ASC_TIME = (/* unused pure expression or super */ null && (new RegExp(/^(?:Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( [1-9]|\d{2}) (\d{1,2}):(\d{2}):(\d{2})(?:\.(\d+))? (\d{4})$/)));
const parseRfc7231DateTime = (value) => {
    if (value === null || value === undefined) {
        return undefined;
    }
    if (typeof value !== "string") {
        throw new TypeError("RFC-7231 date-times must be expressed as strings");
    }
    let match = IMF_FIXDATE.exec(value);
    if (match) {
        const [_, dayStr, monthStr, yearStr, hours, minutes, seconds, fractionalMilliseconds] = match;
        return buildDate(strictParseShort(stripLeadingZeroes(yearStr)), parseMonthByShortName(monthStr), parseDateValue(dayStr, "day", 1, 31), { hours, minutes, seconds, fractionalMilliseconds });
    }
    match = RFC_850_DATE.exec(value);
    if (match) {
        const [_, dayStr, monthStr, yearStr, hours, minutes, seconds, fractionalMilliseconds] = match;
        return adjustRfc850Year(buildDate(parseTwoDigitYear(yearStr), parseMonthByShortName(monthStr), parseDateValue(dayStr, "day", 1, 31), {
            hours,
            minutes,
            seconds,
            fractionalMilliseconds,
        }));
    }
    match = ASC_TIME.exec(value);
    if (match) {
        const [_, monthStr, dayStr, hours, minutes, seconds, fractionalMilliseconds, yearStr] = match;
        return buildDate(strictParseShort(stripLeadingZeroes(yearStr)), parseMonthByShortName(monthStr), parseDateValue(dayStr.trimLeft(), "day", 1, 31), { hours, minutes, seconds, fractionalMilliseconds });
    }
    throw new TypeError("Invalid RFC-7231 date-time value");
};
const parseEpochTimestamp = (value) => {
    if (value === null || value === undefined) {
        return undefined;
    }
    let valueAsDouble;
    if (typeof value === "number") {
        valueAsDouble = value;
    }
    else if (typeof value === "string") {
        valueAsDouble = strictParseDouble(value);
    }
    else {
        throw new TypeError("Epoch timestamps must be expressed as floating point numbers or their string representation");
    }
    if (Number.isNaN(valueAsDouble) || valueAsDouble === Infinity || valueAsDouble === -Infinity) {
        throw new TypeError("Epoch timestamps must be valid, non-Infinite, non-NaN numerics");
    }
    return new Date(Math.round(valueAsDouble * 1000));
};
const buildDate = (year, month, day, time) => {
    const adjustedMonth = month - 1;
    validateDayOfMonth(year, adjustedMonth, day);
    return new Date(Date.UTC(year, adjustedMonth, day, parseDateValue(time.hours, "hour", 0, 23), parseDateValue(time.minutes, "minute", 0, 59), parseDateValue(time.seconds, "seconds", 0, 60), parseMilliseconds(time.fractionalMilliseconds)));
};
const parseTwoDigitYear = (value) => {
    const thisYear = new Date().getUTCFullYear();
    const valueInThisCentury = Math.floor(thisYear / 100) * 100 + strictParseShort(stripLeadingZeroes(value));
    if (valueInThisCentury < thisYear) {
        return valueInThisCentury + 100;
    }
    return valueInThisCentury;
};
const FIFTY_YEARS_IN_MILLIS = (/* unused pure expression or super */ null && (50 * 365 * 24 * 60 * 60 * 1000));
const adjustRfc850Year = (input) => {
    if (input.getTime() - new Date().getTime() > FIFTY_YEARS_IN_MILLIS) {
        return new Date(Date.UTC(input.getUTCFullYear() - 100, input.getUTCMonth(), input.getUTCDate(), input.getUTCHours(), input.getUTCMinutes(), input.getUTCSeconds(), input.getUTCMilliseconds()));
    }
    return input;
};
const parseMonthByShortName = (value) => {
    const monthIdx = MONTHS.indexOf(value);
    if (monthIdx < 0) {
        throw new TypeError(`Invalid month: ${value}`);
    }
    return monthIdx + 1;
};
const DAYS_IN_MONTH = (/* unused pure expression or super */ null && ([31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]));
const validateDayOfMonth = (year, month, day) => {
    let maxDays = DAYS_IN_MONTH[month];
    if (month === 1 && isLeapYear(year)) {
        maxDays = 29;
    }
    if (day > maxDays) {
        throw new TypeError(`Invalid day for ${MONTHS[month]} in ${year}: ${day}`);
    }
};
const isLeapYear = (year) => {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
};
const parseDateValue = (value, type, lower, upper) => {
    const dateVal = strictParseByte(stripLeadingZeroes(value));
    if (dateVal < lower || dateVal > upper) {
        throw new TypeError(`${type} must be between ${lower} and ${upper}, inclusive`);
    }
    return dateVal;
};
const parseMilliseconds = (value) => {
    if (value === null || value === undefined) {
        return 0;
    }
    return strictParseFloat32("0." + value) * 1000;
};
const stripLeadingZeroes = (value) => {
    let idx = 0;
    while (idx < value.length - 1 && value.charAt(idx) === "0") {
        idx++;
    }
    if (idx === 0) {
        return value;
    }
    return value.slice(idx);
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/smithy-client/dist-es/exceptions.js
class ServiceException extends Error {
    constructor(options) {
        super(options.message);
        Object.setPrototypeOf(this, ServiceException.prototype);
        this.name = options.name;
        this.$fault = options.$fault;
        this.$metadata = options.$metadata;
    }
}
const decorateServiceException = (exception, additions = {}) => {
    Object.entries(additions)
        .filter(([, v]) => v !== undefined)
        .forEach(([k, v]) => {
        if (exception[k] == undefined || exception[k] === "") {
            exception[k] = v;
        }
    });
    const message = exception.message || exception.Message || "UnknownError";
    exception.message = message;
    delete exception.Message;
    return exception;
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/smithy-client/dist-es/default-error-handler.js

const throwDefaultError = ({ output, parsedBody, exceptionCtor, errorCode }) => {
    const $metadata = deserializeMetadata(output);
    const statusCode = $metadata.httpStatusCode ? $metadata.httpStatusCode + "" : undefined;
    const response = new exceptionCtor({
        name: parsedBody.code || parsedBody.Code || errorCode || statusCode || "UnknownError",
        $fault: "client",
        $metadata,
    });
    throw decorateServiceException(response, parsedBody);
};
const deserializeMetadata = (output) => ({
    httpStatusCode: output.statusCode,
    requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"],
});

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/smithy-client/dist-es/defaults-mode.js
const loadConfigsForDefaultMode = (mode) => {
    switch (mode) {
        case "standard":
            return {
                retryMode: "standard",
                connectionTimeout: 3100,
            };
        case "in-region":
            return {
                retryMode: "standard",
                connectionTimeout: 1100,
            };
        case "cross-region":
            return {
                retryMode: "standard",
                connectionTimeout: 3100,
            };
        case "mobile":
            return {
                retryMode: "standard",
                connectionTimeout: 30000,
            };
        default:
            return {};
    }
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/smithy-client/dist-es/lazy-json.js
const StringWrapper = function () {
    const Class = Object.getPrototypeOf(this).constructor;
    const Constructor = Function.bind.apply(String, [null, ...arguments]);
    const instance = new Constructor();
    Object.setPrototypeOf(instance, Class.prototype);
    return instance;
};
StringWrapper.prototype = Object.create(String.prototype, {
    constructor: {
        value: StringWrapper,
        enumerable: false,
        writable: true,
        configurable: true,
    },
});
Object.setPrototypeOf(StringWrapper, String);
class LazyJsonString extends (/* unused pure expression or super */ null && (StringWrapper)) {
    deserializeJSON() {
        return JSON.parse(super.toString());
    }
    toJSON() {
        return super.toString();
    }
    static fromObject(object) {
        if (object instanceof LazyJsonString) {
            return object;
        }
        else if (object instanceof String || typeof object === "string") {
            return new LazyJsonString(object);
        }
        return new LazyJsonString(JSON.stringify(object));
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/smithy-client/dist-es/index.js



















;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/models/SecretsManagerServiceException.js

class SecretsManagerServiceException extends ServiceException {
    constructor(options) {
        super(options);
        Object.setPrototypeOf(this, SecretsManagerServiceException.prototype);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/models/models_0.js


class InternalServiceError extends SecretsManagerServiceException {
    constructor(opts) {
        super({
            name: "InternalServiceError",
            $fault: "server",
            ...opts,
        });
        this.name = "InternalServiceError";
        this.$fault = "server";
        Object.setPrototypeOf(this, InternalServiceError.prototype);
        this.Message = opts.Message;
    }
}
class InvalidParameterException extends SecretsManagerServiceException {
    constructor(opts) {
        super({
            name: "InvalidParameterException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidParameterException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidParameterException.prototype);
        this.Message = opts.Message;
    }
}
class InvalidRequestException extends SecretsManagerServiceException {
    constructor(opts) {
        super({
            name: "InvalidRequestException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidRequestException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidRequestException.prototype);
        this.Message = opts.Message;
    }
}
class ResourceNotFoundException extends SecretsManagerServiceException {
    constructor(opts) {
        super({
            name: "ResourceNotFoundException",
            $fault: "client",
            ...opts,
        });
        this.name = "ResourceNotFoundException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ResourceNotFoundException.prototype);
        this.Message = opts.Message;
    }
}
var StatusType;
(function (StatusType) {
    StatusType["Failed"] = "Failed";
    StatusType["InProgress"] = "InProgress";
    StatusType["InSync"] = "InSync";
})(StatusType || (StatusType = {}));
class DecryptionFailure extends SecretsManagerServiceException {
    constructor(opts) {
        super({
            name: "DecryptionFailure",
            $fault: "client",
            ...opts,
        });
        this.name = "DecryptionFailure";
        this.$fault = "client";
        Object.setPrototypeOf(this, DecryptionFailure.prototype);
        this.Message = opts.Message;
    }
}
class EncryptionFailure extends SecretsManagerServiceException {
    constructor(opts) {
        super({
            name: "EncryptionFailure",
            $fault: "client",
            ...opts,
        });
        this.name = "EncryptionFailure";
        this.$fault = "client";
        Object.setPrototypeOf(this, EncryptionFailure.prototype);
        this.Message = opts.Message;
    }
}
class LimitExceededException extends SecretsManagerServiceException {
    constructor(opts) {
        super({
            name: "LimitExceededException",
            $fault: "client",
            ...opts,
        });
        this.name = "LimitExceededException";
        this.$fault = "client";
        Object.setPrototypeOf(this, LimitExceededException.prototype);
        this.Message = opts.Message;
    }
}
class MalformedPolicyDocumentException extends SecretsManagerServiceException {
    constructor(opts) {
        super({
            name: "MalformedPolicyDocumentException",
            $fault: "client",
            ...opts,
        });
        this.name = "MalformedPolicyDocumentException";
        this.$fault = "client";
        Object.setPrototypeOf(this, MalformedPolicyDocumentException.prototype);
        this.Message = opts.Message;
    }
}
class PreconditionNotMetException extends SecretsManagerServiceException {
    constructor(opts) {
        super({
            name: "PreconditionNotMetException",
            $fault: "client",
            ...opts,
        });
        this.name = "PreconditionNotMetException";
        this.$fault = "client";
        Object.setPrototypeOf(this, PreconditionNotMetException.prototype);
        this.Message = opts.Message;
    }
}
class ResourceExistsException extends SecretsManagerServiceException {
    constructor(opts) {
        super({
            name: "ResourceExistsException",
            $fault: "client",
            ...opts,
        });
        this.name = "ResourceExistsException";
        this.$fault = "client";
        Object.setPrototypeOf(this, ResourceExistsException.prototype);
        this.Message = opts.Message;
    }
}
var FilterNameStringType;
(function (FilterNameStringType) {
    FilterNameStringType["all"] = "all";
    FilterNameStringType["description"] = "description";
    FilterNameStringType["name"] = "name";
    FilterNameStringType["owning_service"] = "owning-service";
    FilterNameStringType["primary_region"] = "primary-region";
    FilterNameStringType["tag_key"] = "tag-key";
    FilterNameStringType["tag_value"] = "tag-value";
})(FilterNameStringType || (FilterNameStringType = {}));
class InvalidNextTokenException extends SecretsManagerServiceException {
    constructor(opts) {
        super({
            name: "InvalidNextTokenException",
            $fault: "client",
            ...opts,
        });
        this.name = "InvalidNextTokenException";
        this.$fault = "client";
        Object.setPrototypeOf(this, InvalidNextTokenException.prototype);
        this.Message = opts.Message;
    }
}
var SortOrderType;
(function (SortOrderType) {
    SortOrderType["asc"] = "asc";
    SortOrderType["desc"] = "desc";
})(SortOrderType || (SortOrderType = {}));
class PublicPolicyException extends SecretsManagerServiceException {
    constructor(opts) {
        super({
            name: "PublicPolicyException",
            $fault: "client",
            ...opts,
        });
        this.name = "PublicPolicyException";
        this.$fault = "client";
        Object.setPrototypeOf(this, PublicPolicyException.prototype);
        this.Message = opts.Message;
    }
}
const ReplicaRegionTypeFilterSensitiveLog = (obj) => ({
    ...obj,
});
const CancelRotateSecretRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
const CancelRotateSecretResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
const TagFilterSensitiveLog = (obj) => ({
    ...obj,
});
const CreateSecretRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.SecretBinary && { SecretBinary: SENSITIVE_STRING }),
    ...(obj.SecretString && { SecretString: SENSITIVE_STRING }),
});
const ReplicationStatusTypeFilterSensitiveLog = (obj) => ({
    ...obj,
});
const CreateSecretResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
const DeleteResourcePolicyRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
const DeleteResourcePolicyResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
const DeleteSecretRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
const DeleteSecretResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
const DescribeSecretRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
const RotationRulesTypeFilterSensitiveLog = (obj) => ({
    ...obj,
});
const DescribeSecretResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
const FilterFilterSensitiveLog = (obj) => ({
    ...obj,
});
const GetRandomPasswordRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
const GetRandomPasswordResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.RandomPassword && { RandomPassword: SENSITIVE_STRING }),
});
const GetResourcePolicyRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
const GetResourcePolicyResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
const GetSecretValueRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
const GetSecretValueResponseFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.SecretBinary && { SecretBinary: SENSITIVE_STRING }),
    ...(obj.SecretString && { SecretString: SENSITIVE_STRING }),
});
const ListSecretsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
const SecretListEntryFilterSensitiveLog = (obj) => ({
    ...obj,
});
const ListSecretsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
const ListSecretVersionIdsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
const SecretVersionsListEntryFilterSensitiveLog = (obj) => ({
    ...obj,
});
const ListSecretVersionIdsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
const PutResourcePolicyRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
const PutResourcePolicyResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
const PutSecretValueRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.SecretBinary && { SecretBinary: SENSITIVE_STRING }),
    ...(obj.SecretString && { SecretString: SENSITIVE_STRING }),
});
const PutSecretValueResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
const RemoveRegionsFromReplicationRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
const RemoveRegionsFromReplicationResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
const ReplicateSecretToRegionsRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
const ReplicateSecretToRegionsResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
const RestoreSecretRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
const RestoreSecretResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
const RotateSecretRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
const RotateSecretResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
const StopReplicationToReplicaRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
const StopReplicationToReplicaResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
const TagResourceRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
const UntagResourceRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
const UpdateSecretRequestFilterSensitiveLog = (obj) => ({
    ...obj,
    ...(obj.SecretBinary && { SecretBinary: SENSITIVE_STRING }),
    ...(obj.SecretString && { SecretString: SENSITIVE_STRING }),
});
const UpdateSecretResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
const UpdateSecretVersionStageRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
const UpdateSecretVersionStageResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});
const ValidateResourcePolicyRequestFilterSensitiveLog = (obj) => ({
    ...obj,
});
const ValidationErrorsEntryFilterSensitiveLog = (obj) => ({
    ...obj,
});
const ValidateResourcePolicyResponseFilterSensitiveLog = (obj) => ({
    ...obj,
});

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/protocol-http/dist-es/httpRequest.js
class httpRequest_HttpRequest {
    constructor(options) {
        this.method = options.method || "GET";
        this.hostname = options.hostname || "localhost";
        this.port = options.port;
        this.query = options.query || {};
        this.headers = options.headers || {};
        this.body = options.body;
        this.protocol = options.protocol
            ? options.protocol.slice(-1) !== ":"
                ? `${options.protocol}:`
                : options.protocol
            : "https:";
        this.path = options.path ? (options.path.charAt(0) !== "/" ? `/${options.path}` : options.path) : "/";
    }
    static isInstance(request) {
        if (!request)
            return false;
        const req = request;
        return ("method" in req &&
            "protocol" in req &&
            "hostname" in req &&
            "path" in req &&
            typeof req["query"] === "object" &&
            typeof req["headers"] === "object");
    }
    clone() {
        const cloned = new httpRequest_HttpRequest({
            ...this,
            headers: { ...this.headers },
        });
        if (cloned.query)
            cloned.query = cloneQuery(cloned.query);
        return cloned;
    }
}
function cloneQuery(query) {
    return Object.keys(query).reduce((carry, paramName) => {
        const param = query[paramName];
        return {
            ...carry,
            [paramName]: Array.isArray(param) ? [...param] : param,
        };
    }, {});
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var getRandomValues;
var rnds8 = new Uint8Array(16);
function rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return getRandomValues(rnds8);
}
;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/node_modules/uuid/dist/esm-browser/validate.js


function validate(uuid) {
  return typeof uuid === 'string' && regex.test(uuid);
}

/* harmony default export */ var esm_browser_validate = (validate);
;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var byteToHex = [];

for (var i = 0; i < 256; ++i) {
  byteToHex.push((i + 0x100).toString(16).substr(1));
}

function stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (byteToHex[arr[offset + 0]] + byteToHex[arr[offset + 1]] + byteToHex[arr[offset + 2]] + byteToHex[arr[offset + 3]] + '-' + byteToHex[arr[offset + 4]] + byteToHex[arr[offset + 5]] + '-' + byteToHex[arr[offset + 6]] + byteToHex[arr[offset + 7]] + '-' + byteToHex[arr[offset + 8]] + byteToHex[arr[offset + 9]] + '-' + byteToHex[arr[offset + 10]] + byteToHex[arr[offset + 11]] + byteToHex[arr[offset + 12]] + byteToHex[arr[offset + 13]] + byteToHex[arr[offset + 14]] + byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var esm_browser_stringify = (stringify);
;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/node_modules/uuid/dist/esm-browser/v4.js



function v4_v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return esm_browser_stringify(rnds);
}

/* harmony default export */ var esm_browser_v4 = (v4_v4);
;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/protocols/Aws_json1_1.js





const serializeAws_json1_1CancelRotateSecretCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.CancelRotateSecret",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1CancelRotateSecretRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1CreateSecretCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.CreateSecret",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1CreateSecretRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1DeleteResourcePolicyCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.DeleteResourcePolicy",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1DeleteResourcePolicyRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1DeleteSecretCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.DeleteSecret",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1DeleteSecretRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1DescribeSecretCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.DescribeSecret",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1DescribeSecretRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1GetRandomPasswordCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.GetRandomPassword",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1GetRandomPasswordRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1GetResourcePolicyCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.GetResourcePolicy",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1GetResourcePolicyRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1GetSecretValueCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.GetSecretValue",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1GetSecretValueRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1ListSecretsCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.ListSecrets",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1ListSecretsRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1ListSecretVersionIdsCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.ListSecretVersionIds",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1ListSecretVersionIdsRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1PutResourcePolicyCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.PutResourcePolicy",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1PutResourcePolicyRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1PutSecretValueCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.PutSecretValue",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1PutSecretValueRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1RemoveRegionsFromReplicationCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.RemoveRegionsFromReplication",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1RemoveRegionsFromReplicationRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1ReplicateSecretToRegionsCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.ReplicateSecretToRegions",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1ReplicateSecretToRegionsRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1RestoreSecretCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.RestoreSecret",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1RestoreSecretRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1RotateSecretCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.RotateSecret",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1RotateSecretRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1StopReplicationToReplicaCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.StopReplicationToReplica",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1StopReplicationToReplicaRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1TagResourceCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.TagResource",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1TagResourceRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1UntagResourceCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.UntagResource",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1UntagResourceRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1UpdateSecretCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.UpdateSecret",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1UpdateSecretRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1UpdateSecretVersionStageCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.UpdateSecretVersionStage",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1UpdateSecretVersionStageRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const serializeAws_json1_1ValidateResourcePolicyCommand = async (input, context) => {
    const headers = {
        "content-type": "application/x-amz-json-1.1",
        "x-amz-target": "secretsmanager.ValidateResourcePolicy",
    };
    let body;
    body = JSON.stringify(serializeAws_json1_1ValidateResourcePolicyRequest(input, context));
    return buildHttpRpcRequest(context, headers, "/", undefined, body);
};
const deserializeAws_json1_1CancelRotateSecretCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1CancelRotateSecretCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1CancelRotateSecretResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1CancelRotateSecretCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "InvalidRequestException":
        case "com.amazonaws.secretsmanager#InvalidRequestException":
            throw await deserializeAws_json1_1InvalidRequestExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1CreateSecretCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1CreateSecretCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1CreateSecretResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1CreateSecretCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "DecryptionFailure":
        case "com.amazonaws.secretsmanager#DecryptionFailure":
            throw await deserializeAws_json1_1DecryptionFailureResponse(parsedOutput, context);
        case "EncryptionFailure":
        case "com.amazonaws.secretsmanager#EncryptionFailure":
            throw await deserializeAws_json1_1EncryptionFailureResponse(parsedOutput, context);
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "InvalidRequestException":
        case "com.amazonaws.secretsmanager#InvalidRequestException":
            throw await deserializeAws_json1_1InvalidRequestExceptionResponse(parsedOutput, context);
        case "LimitExceededException":
        case "com.amazonaws.secretsmanager#LimitExceededException":
            throw await deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context);
        case "MalformedPolicyDocumentException":
        case "com.amazonaws.secretsmanager#MalformedPolicyDocumentException":
            throw await deserializeAws_json1_1MalformedPolicyDocumentExceptionResponse(parsedOutput, context);
        case "PreconditionNotMetException":
        case "com.amazonaws.secretsmanager#PreconditionNotMetException":
            throw await deserializeAws_json1_1PreconditionNotMetExceptionResponse(parsedOutput, context);
        case "ResourceExistsException":
        case "com.amazonaws.secretsmanager#ResourceExistsException":
            throw await deserializeAws_json1_1ResourceExistsExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1DeleteResourcePolicyCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1DeleteResourcePolicyCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1DeleteResourcePolicyResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1DeleteResourcePolicyCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "InvalidRequestException":
        case "com.amazonaws.secretsmanager#InvalidRequestException":
            throw await deserializeAws_json1_1InvalidRequestExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1DeleteSecretCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1DeleteSecretCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1DeleteSecretResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1DeleteSecretCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "InvalidRequestException":
        case "com.amazonaws.secretsmanager#InvalidRequestException":
            throw await deserializeAws_json1_1InvalidRequestExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1DescribeSecretCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1DescribeSecretCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1DescribeSecretResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1DescribeSecretCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1GetRandomPasswordCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1GetRandomPasswordCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1GetRandomPasswordResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1GetRandomPasswordCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "InvalidRequestException":
        case "com.amazonaws.secretsmanager#InvalidRequestException":
            throw await deserializeAws_json1_1InvalidRequestExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1GetResourcePolicyCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1GetResourcePolicyCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1GetResourcePolicyResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1GetResourcePolicyCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "InvalidRequestException":
        case "com.amazonaws.secretsmanager#InvalidRequestException":
            throw await deserializeAws_json1_1InvalidRequestExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1GetSecretValueCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1GetSecretValueCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1GetSecretValueResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1GetSecretValueCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "DecryptionFailure":
        case "com.amazonaws.secretsmanager#DecryptionFailure":
            throw await deserializeAws_json1_1DecryptionFailureResponse(parsedOutput, context);
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "InvalidRequestException":
        case "com.amazonaws.secretsmanager#InvalidRequestException":
            throw await deserializeAws_json1_1InvalidRequestExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1ListSecretsCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1ListSecretsCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1ListSecretsResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1ListSecretsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidNextTokenException":
        case "com.amazonaws.secretsmanager#InvalidNextTokenException":
            throw await deserializeAws_json1_1InvalidNextTokenExceptionResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1ListSecretVersionIdsCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1ListSecretVersionIdsCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1ListSecretVersionIdsResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1ListSecretVersionIdsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidNextTokenException":
        case "com.amazonaws.secretsmanager#InvalidNextTokenException":
            throw await deserializeAws_json1_1InvalidNextTokenExceptionResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1PutResourcePolicyCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1PutResourcePolicyCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1PutResourcePolicyResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1PutResourcePolicyCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "InvalidRequestException":
        case "com.amazonaws.secretsmanager#InvalidRequestException":
            throw await deserializeAws_json1_1InvalidRequestExceptionResponse(parsedOutput, context);
        case "MalformedPolicyDocumentException":
        case "com.amazonaws.secretsmanager#MalformedPolicyDocumentException":
            throw await deserializeAws_json1_1MalformedPolicyDocumentExceptionResponse(parsedOutput, context);
        case "PublicPolicyException":
        case "com.amazonaws.secretsmanager#PublicPolicyException":
            throw await deserializeAws_json1_1PublicPolicyExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1PutSecretValueCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1PutSecretValueCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1PutSecretValueResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1PutSecretValueCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "DecryptionFailure":
        case "com.amazonaws.secretsmanager#DecryptionFailure":
            throw await deserializeAws_json1_1DecryptionFailureResponse(parsedOutput, context);
        case "EncryptionFailure":
        case "com.amazonaws.secretsmanager#EncryptionFailure":
            throw await deserializeAws_json1_1EncryptionFailureResponse(parsedOutput, context);
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "InvalidRequestException":
        case "com.amazonaws.secretsmanager#InvalidRequestException":
            throw await deserializeAws_json1_1InvalidRequestExceptionResponse(parsedOutput, context);
        case "LimitExceededException":
        case "com.amazonaws.secretsmanager#LimitExceededException":
            throw await deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context);
        case "ResourceExistsException":
        case "com.amazonaws.secretsmanager#ResourceExistsException":
            throw await deserializeAws_json1_1ResourceExistsExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1RemoveRegionsFromReplicationCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1RemoveRegionsFromReplicationCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1RemoveRegionsFromReplicationResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1RemoveRegionsFromReplicationCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "InvalidRequestException":
        case "com.amazonaws.secretsmanager#InvalidRequestException":
            throw await deserializeAws_json1_1InvalidRequestExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1ReplicateSecretToRegionsCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1ReplicateSecretToRegionsCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1ReplicateSecretToRegionsResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1ReplicateSecretToRegionsCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "InvalidRequestException":
        case "com.amazonaws.secretsmanager#InvalidRequestException":
            throw await deserializeAws_json1_1InvalidRequestExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1RestoreSecretCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1RestoreSecretCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1RestoreSecretResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1RestoreSecretCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "InvalidRequestException":
        case "com.amazonaws.secretsmanager#InvalidRequestException":
            throw await deserializeAws_json1_1InvalidRequestExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1RotateSecretCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1RotateSecretCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1RotateSecretResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1RotateSecretCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "InvalidRequestException":
        case "com.amazonaws.secretsmanager#InvalidRequestException":
            throw await deserializeAws_json1_1InvalidRequestExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1StopReplicationToReplicaCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1StopReplicationToReplicaCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1StopReplicationToReplicaResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1StopReplicationToReplicaCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "InvalidRequestException":
        case "com.amazonaws.secretsmanager#InvalidRequestException":
            throw await deserializeAws_json1_1InvalidRequestExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1TagResourceCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1TagResourceCommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1TagResourceCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "InvalidRequestException":
        case "com.amazonaws.secretsmanager#InvalidRequestException":
            throw await deserializeAws_json1_1InvalidRequestExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1UntagResourceCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1UntagResourceCommandError(output, context);
    }
    await collectBody(output.body, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1UntagResourceCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "InvalidRequestException":
        case "com.amazonaws.secretsmanager#InvalidRequestException":
            throw await deserializeAws_json1_1InvalidRequestExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1UpdateSecretCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1UpdateSecretCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1UpdateSecretResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1UpdateSecretCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "DecryptionFailure":
        case "com.amazonaws.secretsmanager#DecryptionFailure":
            throw await deserializeAws_json1_1DecryptionFailureResponse(parsedOutput, context);
        case "EncryptionFailure":
        case "com.amazonaws.secretsmanager#EncryptionFailure":
            throw await deserializeAws_json1_1EncryptionFailureResponse(parsedOutput, context);
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "InvalidRequestException":
        case "com.amazonaws.secretsmanager#InvalidRequestException":
            throw await deserializeAws_json1_1InvalidRequestExceptionResponse(parsedOutput, context);
        case "LimitExceededException":
        case "com.amazonaws.secretsmanager#LimitExceededException":
            throw await deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context);
        case "MalformedPolicyDocumentException":
        case "com.amazonaws.secretsmanager#MalformedPolicyDocumentException":
            throw await deserializeAws_json1_1MalformedPolicyDocumentExceptionResponse(parsedOutput, context);
        case "PreconditionNotMetException":
        case "com.amazonaws.secretsmanager#PreconditionNotMetException":
            throw await deserializeAws_json1_1PreconditionNotMetExceptionResponse(parsedOutput, context);
        case "ResourceExistsException":
        case "com.amazonaws.secretsmanager#ResourceExistsException":
            throw await deserializeAws_json1_1ResourceExistsExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1UpdateSecretVersionStageCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1UpdateSecretVersionStageCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1UpdateSecretVersionStageResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1UpdateSecretVersionStageCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "InvalidRequestException":
        case "com.amazonaws.secretsmanager#InvalidRequestException":
            throw await deserializeAws_json1_1InvalidRequestExceptionResponse(parsedOutput, context);
        case "LimitExceededException":
        case "com.amazonaws.secretsmanager#LimitExceededException":
            throw await deserializeAws_json1_1LimitExceededExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1ValidateResourcePolicyCommand = async (output, context) => {
    if (output.statusCode >= 300) {
        return deserializeAws_json1_1ValidateResourcePolicyCommandError(output, context);
    }
    const data = await parseBody(output.body, context);
    let contents = {};
    contents = deserializeAws_json1_1ValidateResourcePolicyResponse(data, context);
    const response = {
        $metadata: Aws_json1_1_deserializeMetadata(output),
        ...contents,
    };
    return Promise.resolve(response);
};
const deserializeAws_json1_1ValidateResourcePolicyCommandError = async (output, context) => {
    const parsedOutput = {
        ...output,
        body: await parseErrorBody(output.body, context),
    };
    const errorCode = loadRestJsonErrorCode(output, parsedOutput.body);
    switch (errorCode) {
        case "InternalServiceError":
        case "com.amazonaws.secretsmanager#InternalServiceError":
            throw await deserializeAws_json1_1InternalServiceErrorResponse(parsedOutput, context);
        case "InvalidParameterException":
        case "com.amazonaws.secretsmanager#InvalidParameterException":
            throw await deserializeAws_json1_1InvalidParameterExceptionResponse(parsedOutput, context);
        case "InvalidRequestException":
        case "com.amazonaws.secretsmanager#InvalidRequestException":
            throw await deserializeAws_json1_1InvalidRequestExceptionResponse(parsedOutput, context);
        case "MalformedPolicyDocumentException":
        case "com.amazonaws.secretsmanager#MalformedPolicyDocumentException":
            throw await deserializeAws_json1_1MalformedPolicyDocumentExceptionResponse(parsedOutput, context);
        case "ResourceNotFoundException":
        case "com.amazonaws.secretsmanager#ResourceNotFoundException":
            throw await deserializeAws_json1_1ResourceNotFoundExceptionResponse(parsedOutput, context);
        default:
            const parsedBody = parsedOutput.body;
            throwDefaultError({
                output,
                parsedBody,
                exceptionCtor: SecretsManagerServiceException,
                errorCode,
            });
    }
};
const deserializeAws_json1_1DecryptionFailureResponse = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = deserializeAws_json1_1DecryptionFailure(body, context);
    const exception = new DecryptionFailure({
        $metadata: Aws_json1_1_deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return decorateServiceException(exception, body);
};
const deserializeAws_json1_1EncryptionFailureResponse = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = deserializeAws_json1_1EncryptionFailure(body, context);
    const exception = new EncryptionFailure({
        $metadata: Aws_json1_1_deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return decorateServiceException(exception, body);
};
const deserializeAws_json1_1InternalServiceErrorResponse = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = deserializeAws_json1_1InternalServiceError(body, context);
    const exception = new InternalServiceError({
        $metadata: Aws_json1_1_deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return decorateServiceException(exception, body);
};
const deserializeAws_json1_1InvalidNextTokenExceptionResponse = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = deserializeAws_json1_1InvalidNextTokenException(body, context);
    const exception = new InvalidNextTokenException({
        $metadata: Aws_json1_1_deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return decorateServiceException(exception, body);
};
const deserializeAws_json1_1InvalidParameterExceptionResponse = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = deserializeAws_json1_1InvalidParameterException(body, context);
    const exception = new InvalidParameterException({
        $metadata: Aws_json1_1_deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return decorateServiceException(exception, body);
};
const deserializeAws_json1_1InvalidRequestExceptionResponse = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = deserializeAws_json1_1InvalidRequestException(body, context);
    const exception = new InvalidRequestException({
        $metadata: Aws_json1_1_deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return decorateServiceException(exception, body);
};
const deserializeAws_json1_1LimitExceededExceptionResponse = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = deserializeAws_json1_1LimitExceededException(body, context);
    const exception = new LimitExceededException({
        $metadata: Aws_json1_1_deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return decorateServiceException(exception, body);
};
const deserializeAws_json1_1MalformedPolicyDocumentExceptionResponse = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = deserializeAws_json1_1MalformedPolicyDocumentException(body, context);
    const exception = new MalformedPolicyDocumentException({
        $metadata: Aws_json1_1_deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return decorateServiceException(exception, body);
};
const deserializeAws_json1_1PreconditionNotMetExceptionResponse = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = deserializeAws_json1_1PreconditionNotMetException(body, context);
    const exception = new PreconditionNotMetException({
        $metadata: Aws_json1_1_deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return decorateServiceException(exception, body);
};
const deserializeAws_json1_1PublicPolicyExceptionResponse = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = deserializeAws_json1_1PublicPolicyException(body, context);
    const exception = new PublicPolicyException({
        $metadata: Aws_json1_1_deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return decorateServiceException(exception, body);
};
const deserializeAws_json1_1ResourceExistsExceptionResponse = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = deserializeAws_json1_1ResourceExistsException(body, context);
    const exception = new ResourceExistsException({
        $metadata: Aws_json1_1_deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return decorateServiceException(exception, body);
};
const deserializeAws_json1_1ResourceNotFoundExceptionResponse = async (parsedOutput, context) => {
    const body = parsedOutput.body;
    const deserialized = deserializeAws_json1_1ResourceNotFoundException(body, context);
    const exception = new ResourceNotFoundException({
        $metadata: Aws_json1_1_deserializeMetadata(parsedOutput),
        ...deserialized,
    });
    return decorateServiceException(exception, body);
};
const serializeAws_json1_1AddReplicaRegionListType = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return serializeAws_json1_1ReplicaRegionType(entry, context);
    });
};
const serializeAws_json1_1CancelRotateSecretRequest = (input, context) => {
    return {
        ...(input.SecretId != null && { SecretId: input.SecretId }),
    };
};
const serializeAws_json1_1CreateSecretRequest = (input, context) => {
    return {
        ...(input.AddReplicaRegions != null && {
            AddReplicaRegions: serializeAws_json1_1AddReplicaRegionListType(input.AddReplicaRegions, context),
        }),
        ClientRequestToken: input.ClientRequestToken ?? esm_browser_v4(),
        ...(input.Description != null && { Description: input.Description }),
        ...(input.ForceOverwriteReplicaSecret != null && {
            ForceOverwriteReplicaSecret: input.ForceOverwriteReplicaSecret,
        }),
        ...(input.KmsKeyId != null && { KmsKeyId: input.KmsKeyId }),
        ...(input.Name != null && { Name: input.Name }),
        ...(input.SecretBinary != null && { SecretBinary: context.base64Encoder(input.SecretBinary) }),
        ...(input.SecretString != null && { SecretString: input.SecretString }),
        ...(input.Tags != null && { Tags: serializeAws_json1_1TagListType(input.Tags, context) }),
    };
};
const serializeAws_json1_1DeleteResourcePolicyRequest = (input, context) => {
    return {
        ...(input.SecretId != null && { SecretId: input.SecretId }),
    };
};
const serializeAws_json1_1DeleteSecretRequest = (input, context) => {
    return {
        ...(input.ForceDeleteWithoutRecovery != null && { ForceDeleteWithoutRecovery: input.ForceDeleteWithoutRecovery }),
        ...(input.RecoveryWindowInDays != null && { RecoveryWindowInDays: input.RecoveryWindowInDays }),
        ...(input.SecretId != null && { SecretId: input.SecretId }),
    };
};
const serializeAws_json1_1DescribeSecretRequest = (input, context) => {
    return {
        ...(input.SecretId != null && { SecretId: input.SecretId }),
    };
};
const serializeAws_json1_1Filter = (input, context) => {
    return {
        ...(input.Key != null && { Key: input.Key }),
        ...(input.Values != null && { Values: serializeAws_json1_1FilterValuesStringList(input.Values, context) }),
    };
};
const serializeAws_json1_1FiltersListType = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return serializeAws_json1_1Filter(entry, context);
    });
};
const serializeAws_json1_1FilterValuesStringList = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return entry;
    });
};
const serializeAws_json1_1GetRandomPasswordRequest = (input, context) => {
    return {
        ...(input.ExcludeCharacters != null && { ExcludeCharacters: input.ExcludeCharacters }),
        ...(input.ExcludeLowercase != null && { ExcludeLowercase: input.ExcludeLowercase }),
        ...(input.ExcludeNumbers != null && { ExcludeNumbers: input.ExcludeNumbers }),
        ...(input.ExcludePunctuation != null && { ExcludePunctuation: input.ExcludePunctuation }),
        ...(input.ExcludeUppercase != null && { ExcludeUppercase: input.ExcludeUppercase }),
        ...(input.IncludeSpace != null && { IncludeSpace: input.IncludeSpace }),
        ...(input.PasswordLength != null && { PasswordLength: input.PasswordLength }),
        ...(input.RequireEachIncludedType != null && { RequireEachIncludedType: input.RequireEachIncludedType }),
    };
};
const serializeAws_json1_1GetResourcePolicyRequest = (input, context) => {
    return {
        ...(input.SecretId != null && { SecretId: input.SecretId }),
    };
};
const serializeAws_json1_1GetSecretValueRequest = (input, context) => {
    return {
        ...(input.SecretId != null && { SecretId: input.SecretId }),
        ...(input.VersionId != null && { VersionId: input.VersionId }),
        ...(input.VersionStage != null && { VersionStage: input.VersionStage }),
    };
};
const serializeAws_json1_1ListSecretsRequest = (input, context) => {
    return {
        ...(input.Filters != null && { Filters: serializeAws_json1_1FiltersListType(input.Filters, context) }),
        ...(input.IncludePlannedDeletion != null && { IncludePlannedDeletion: input.IncludePlannedDeletion }),
        ...(input.MaxResults != null && { MaxResults: input.MaxResults }),
        ...(input.NextToken != null && { NextToken: input.NextToken }),
        ...(input.SortOrder != null && { SortOrder: input.SortOrder }),
    };
};
const serializeAws_json1_1ListSecretVersionIdsRequest = (input, context) => {
    return {
        ...(input.IncludeDeprecated != null && { IncludeDeprecated: input.IncludeDeprecated }),
        ...(input.MaxResults != null && { MaxResults: input.MaxResults }),
        ...(input.NextToken != null && { NextToken: input.NextToken }),
        ...(input.SecretId != null && { SecretId: input.SecretId }),
    };
};
const serializeAws_json1_1PutResourcePolicyRequest = (input, context) => {
    return {
        ...(input.BlockPublicPolicy != null && { BlockPublicPolicy: input.BlockPublicPolicy }),
        ...(input.ResourcePolicy != null && { ResourcePolicy: input.ResourcePolicy }),
        ...(input.SecretId != null && { SecretId: input.SecretId }),
    };
};
const serializeAws_json1_1PutSecretValueRequest = (input, context) => {
    return {
        ClientRequestToken: input.ClientRequestToken ?? esm_browser_v4(),
        ...(input.SecretBinary != null && { SecretBinary: context.base64Encoder(input.SecretBinary) }),
        ...(input.SecretId != null && { SecretId: input.SecretId }),
        ...(input.SecretString != null && { SecretString: input.SecretString }),
        ...(input.VersionStages != null && {
            VersionStages: serializeAws_json1_1SecretVersionStagesType(input.VersionStages, context),
        }),
    };
};
const serializeAws_json1_1RemoveRegionsFromReplicationRequest = (input, context) => {
    return {
        ...(input.RemoveReplicaRegions != null && {
            RemoveReplicaRegions: serializeAws_json1_1RemoveReplicaRegionListType(input.RemoveReplicaRegions, context),
        }),
        ...(input.SecretId != null && { SecretId: input.SecretId }),
    };
};
const serializeAws_json1_1RemoveReplicaRegionListType = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return entry;
    });
};
const serializeAws_json1_1ReplicaRegionType = (input, context) => {
    return {
        ...(input.KmsKeyId != null && { KmsKeyId: input.KmsKeyId }),
        ...(input.Region != null && { Region: input.Region }),
    };
};
const serializeAws_json1_1ReplicateSecretToRegionsRequest = (input, context) => {
    return {
        ...(input.AddReplicaRegions != null && {
            AddReplicaRegions: serializeAws_json1_1AddReplicaRegionListType(input.AddReplicaRegions, context),
        }),
        ...(input.ForceOverwriteReplicaSecret != null && {
            ForceOverwriteReplicaSecret: input.ForceOverwriteReplicaSecret,
        }),
        ...(input.SecretId != null && { SecretId: input.SecretId }),
    };
};
const serializeAws_json1_1RestoreSecretRequest = (input, context) => {
    return {
        ...(input.SecretId != null && { SecretId: input.SecretId }),
    };
};
const serializeAws_json1_1RotateSecretRequest = (input, context) => {
    return {
        ClientRequestToken: input.ClientRequestToken ?? esm_browser_v4(),
        ...(input.RotateImmediately != null && { RotateImmediately: input.RotateImmediately }),
        ...(input.RotationLambdaARN != null && { RotationLambdaARN: input.RotationLambdaARN }),
        ...(input.RotationRules != null && {
            RotationRules: serializeAws_json1_1RotationRulesType(input.RotationRules, context),
        }),
        ...(input.SecretId != null && { SecretId: input.SecretId }),
    };
};
const serializeAws_json1_1RotationRulesType = (input, context) => {
    return {
        ...(input.AutomaticallyAfterDays != null && { AutomaticallyAfterDays: input.AutomaticallyAfterDays }),
        ...(input.Duration != null && { Duration: input.Duration }),
        ...(input.ScheduleExpression != null && { ScheduleExpression: input.ScheduleExpression }),
    };
};
const serializeAws_json1_1SecretVersionStagesType = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return entry;
    });
};
const serializeAws_json1_1StopReplicationToReplicaRequest = (input, context) => {
    return {
        ...(input.SecretId != null && { SecretId: input.SecretId }),
    };
};
const serializeAws_json1_1Tag = (input, context) => {
    return {
        ...(input.Key != null && { Key: input.Key }),
        ...(input.Value != null && { Value: input.Value }),
    };
};
const serializeAws_json1_1TagKeyListType = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return entry;
    });
};
const serializeAws_json1_1TagListType = (input, context) => {
    return input
        .filter((e) => e != null)
        .map((entry) => {
        return serializeAws_json1_1Tag(entry, context);
    });
};
const serializeAws_json1_1TagResourceRequest = (input, context) => {
    return {
        ...(input.SecretId != null && { SecretId: input.SecretId }),
        ...(input.Tags != null && { Tags: serializeAws_json1_1TagListType(input.Tags, context) }),
    };
};
const serializeAws_json1_1UntagResourceRequest = (input, context) => {
    return {
        ...(input.SecretId != null && { SecretId: input.SecretId }),
        ...(input.TagKeys != null && { TagKeys: serializeAws_json1_1TagKeyListType(input.TagKeys, context) }),
    };
};
const serializeAws_json1_1UpdateSecretRequest = (input, context) => {
    return {
        ClientRequestToken: input.ClientRequestToken ?? esm_browser_v4(),
        ...(input.Description != null && { Description: input.Description }),
        ...(input.KmsKeyId != null && { KmsKeyId: input.KmsKeyId }),
        ...(input.SecretBinary != null && { SecretBinary: context.base64Encoder(input.SecretBinary) }),
        ...(input.SecretId != null && { SecretId: input.SecretId }),
        ...(input.SecretString != null && { SecretString: input.SecretString }),
    };
};
const serializeAws_json1_1UpdateSecretVersionStageRequest = (input, context) => {
    return {
        ...(input.MoveToVersionId != null && { MoveToVersionId: input.MoveToVersionId }),
        ...(input.RemoveFromVersionId != null && { RemoveFromVersionId: input.RemoveFromVersionId }),
        ...(input.SecretId != null && { SecretId: input.SecretId }),
        ...(input.VersionStage != null && { VersionStage: input.VersionStage }),
    };
};
const serializeAws_json1_1ValidateResourcePolicyRequest = (input, context) => {
    return {
        ...(input.ResourcePolicy != null && { ResourcePolicy: input.ResourcePolicy }),
        ...(input.SecretId != null && { SecretId: input.SecretId }),
    };
};
const deserializeAws_json1_1CancelRotateSecretResponse = (output, context) => {
    return {
        ARN: expectString(output.ARN),
        Name: expectString(output.Name),
        VersionId: expectString(output.VersionId),
    };
};
const deserializeAws_json1_1CreateSecretResponse = (output, context) => {
    return {
        ARN: expectString(output.ARN),
        Name: expectString(output.Name),
        ReplicationStatus: output.ReplicationStatus != null
            ? deserializeAws_json1_1ReplicationStatusListType(output.ReplicationStatus, context)
            : undefined,
        VersionId: expectString(output.VersionId),
    };
};
const deserializeAws_json1_1DecryptionFailure = (output, context) => {
    return {
        Message: expectString(output.Message),
    };
};
const deserializeAws_json1_1DeleteResourcePolicyResponse = (output, context) => {
    return {
        ARN: expectString(output.ARN),
        Name: expectString(output.Name),
    };
};
const deserializeAws_json1_1DeleteSecretResponse = (output, context) => {
    return {
        ARN: expectString(output.ARN),
        DeletionDate: output.DeletionDate != null
            ? expectNonNull(parseEpochTimestamp(expectNumber(output.DeletionDate)))
            : undefined,
        Name: expectString(output.Name),
    };
};
const deserializeAws_json1_1DescribeSecretResponse = (output, context) => {
    return {
        ARN: expectString(output.ARN),
        CreatedDate: output.CreatedDate != null
            ? expectNonNull(parseEpochTimestamp(expectNumber(output.CreatedDate)))
            : undefined,
        DeletedDate: output.DeletedDate != null
            ? expectNonNull(parseEpochTimestamp(expectNumber(output.DeletedDate)))
            : undefined,
        Description: expectString(output.Description),
        KmsKeyId: expectString(output.KmsKeyId),
        LastAccessedDate: output.LastAccessedDate != null
            ? expectNonNull(parseEpochTimestamp(expectNumber(output.LastAccessedDate)))
            : undefined,
        LastChangedDate: output.LastChangedDate != null
            ? expectNonNull(parseEpochTimestamp(expectNumber(output.LastChangedDate)))
            : undefined,
        LastRotatedDate: output.LastRotatedDate != null
            ? expectNonNull(parseEpochTimestamp(expectNumber(output.LastRotatedDate)))
            : undefined,
        Name: expectString(output.Name),
        NextRotationDate: output.NextRotationDate != null
            ? expectNonNull(parseEpochTimestamp(expectNumber(output.NextRotationDate)))
            : undefined,
        OwningService: expectString(output.OwningService),
        PrimaryRegion: expectString(output.PrimaryRegion),
        ReplicationStatus: output.ReplicationStatus != null
            ? deserializeAws_json1_1ReplicationStatusListType(output.ReplicationStatus, context)
            : undefined,
        RotationEnabled: expectBoolean(output.RotationEnabled),
        RotationLambdaARN: expectString(output.RotationLambdaARN),
        RotationRules: output.RotationRules != null ? deserializeAws_json1_1RotationRulesType(output.RotationRules, context) : undefined,
        Tags: output.Tags != null ? deserializeAws_json1_1TagListType(output.Tags, context) : undefined,
        VersionIdsToStages: output.VersionIdsToStages != null
            ? deserializeAws_json1_1SecretVersionsToStagesMapType(output.VersionIdsToStages, context)
            : undefined,
    };
};
const deserializeAws_json1_1EncryptionFailure = (output, context) => {
    return {
        Message: expectString(output.Message),
    };
};
const deserializeAws_json1_1GetRandomPasswordResponse = (output, context) => {
    return {
        RandomPassword: expectString(output.RandomPassword),
    };
};
const deserializeAws_json1_1GetResourcePolicyResponse = (output, context) => {
    return {
        ARN: expectString(output.ARN),
        Name: expectString(output.Name),
        ResourcePolicy: expectString(output.ResourcePolicy),
    };
};
const deserializeAws_json1_1GetSecretValueResponse = (output, context) => {
    return {
        ARN: expectString(output.ARN),
        CreatedDate: output.CreatedDate != null
            ? expectNonNull(parseEpochTimestamp(expectNumber(output.CreatedDate)))
            : undefined,
        Name: expectString(output.Name),
        SecretBinary: output.SecretBinary != null ? context.base64Decoder(output.SecretBinary) : undefined,
        SecretString: expectString(output.SecretString),
        VersionId: expectString(output.VersionId),
        VersionStages: output.VersionStages != null
            ? deserializeAws_json1_1SecretVersionStagesType(output.VersionStages, context)
            : undefined,
    };
};
const deserializeAws_json1_1InternalServiceError = (output, context) => {
    return {
        Message: expectString(output.Message),
    };
};
const deserializeAws_json1_1InvalidNextTokenException = (output, context) => {
    return {
        Message: expectString(output.Message),
    };
};
const deserializeAws_json1_1InvalidParameterException = (output, context) => {
    return {
        Message: expectString(output.Message),
    };
};
const deserializeAws_json1_1InvalidRequestException = (output, context) => {
    return {
        Message: expectString(output.Message),
    };
};
const deserializeAws_json1_1KmsKeyIdListType = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return expectString(entry);
    });
    return retVal;
};
const deserializeAws_json1_1LimitExceededException = (output, context) => {
    return {
        Message: expectString(output.Message),
    };
};
const deserializeAws_json1_1ListSecretsResponse = (output, context) => {
    return {
        NextToken: expectString(output.NextToken),
        SecretList: output.SecretList != null ? deserializeAws_json1_1SecretListType(output.SecretList, context) : undefined,
    };
};
const deserializeAws_json1_1ListSecretVersionIdsResponse = (output, context) => {
    return {
        ARN: expectString(output.ARN),
        Name: expectString(output.Name),
        NextToken: expectString(output.NextToken),
        Versions: output.Versions != null ? deserializeAws_json1_1SecretVersionsListType(output.Versions, context) : undefined,
    };
};
const deserializeAws_json1_1MalformedPolicyDocumentException = (output, context) => {
    return {
        Message: expectString(output.Message),
    };
};
const deserializeAws_json1_1PreconditionNotMetException = (output, context) => {
    return {
        Message: expectString(output.Message),
    };
};
const deserializeAws_json1_1PublicPolicyException = (output, context) => {
    return {
        Message: expectString(output.Message),
    };
};
const deserializeAws_json1_1PutResourcePolicyResponse = (output, context) => {
    return {
        ARN: expectString(output.ARN),
        Name: expectString(output.Name),
    };
};
const deserializeAws_json1_1PutSecretValueResponse = (output, context) => {
    return {
        ARN: expectString(output.ARN),
        Name: expectString(output.Name),
        VersionId: expectString(output.VersionId),
        VersionStages: output.VersionStages != null
            ? deserializeAws_json1_1SecretVersionStagesType(output.VersionStages, context)
            : undefined,
    };
};
const deserializeAws_json1_1RemoveRegionsFromReplicationResponse = (output, context) => {
    return {
        ARN: expectString(output.ARN),
        ReplicationStatus: output.ReplicationStatus != null
            ? deserializeAws_json1_1ReplicationStatusListType(output.ReplicationStatus, context)
            : undefined,
    };
};
const deserializeAws_json1_1ReplicateSecretToRegionsResponse = (output, context) => {
    return {
        ARN: expectString(output.ARN),
        ReplicationStatus: output.ReplicationStatus != null
            ? deserializeAws_json1_1ReplicationStatusListType(output.ReplicationStatus, context)
            : undefined,
    };
};
const deserializeAws_json1_1ReplicationStatusListType = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1ReplicationStatusType(entry, context);
    });
    return retVal;
};
const deserializeAws_json1_1ReplicationStatusType = (output, context) => {
    return {
        KmsKeyId: expectString(output.KmsKeyId),
        LastAccessedDate: output.LastAccessedDate != null
            ? expectNonNull(parseEpochTimestamp(expectNumber(output.LastAccessedDate)))
            : undefined,
        Region: expectString(output.Region),
        Status: expectString(output.Status),
        StatusMessage: expectString(output.StatusMessage),
    };
};
const deserializeAws_json1_1ResourceExistsException = (output, context) => {
    return {
        Message: expectString(output.Message),
    };
};
const deserializeAws_json1_1ResourceNotFoundException = (output, context) => {
    return {
        Message: expectString(output.Message),
    };
};
const deserializeAws_json1_1RestoreSecretResponse = (output, context) => {
    return {
        ARN: expectString(output.ARN),
        Name: expectString(output.Name),
    };
};
const deserializeAws_json1_1RotateSecretResponse = (output, context) => {
    return {
        ARN: expectString(output.ARN),
        Name: expectString(output.Name),
        VersionId: expectString(output.VersionId),
    };
};
const deserializeAws_json1_1RotationRulesType = (output, context) => {
    return {
        AutomaticallyAfterDays: expectLong(output.AutomaticallyAfterDays),
        Duration: expectString(output.Duration),
        ScheduleExpression: expectString(output.ScheduleExpression),
    };
};
const deserializeAws_json1_1SecretListEntry = (output, context) => {
    return {
        ARN: expectString(output.ARN),
        CreatedDate: output.CreatedDate != null
            ? expectNonNull(parseEpochTimestamp(expectNumber(output.CreatedDate)))
            : undefined,
        DeletedDate: output.DeletedDate != null
            ? expectNonNull(parseEpochTimestamp(expectNumber(output.DeletedDate)))
            : undefined,
        Description: expectString(output.Description),
        KmsKeyId: expectString(output.KmsKeyId),
        LastAccessedDate: output.LastAccessedDate != null
            ? expectNonNull(parseEpochTimestamp(expectNumber(output.LastAccessedDate)))
            : undefined,
        LastChangedDate: output.LastChangedDate != null
            ? expectNonNull(parseEpochTimestamp(expectNumber(output.LastChangedDate)))
            : undefined,
        LastRotatedDate: output.LastRotatedDate != null
            ? expectNonNull(parseEpochTimestamp(expectNumber(output.LastRotatedDate)))
            : undefined,
        Name: expectString(output.Name),
        NextRotationDate: output.NextRotationDate != null
            ? expectNonNull(parseEpochTimestamp(expectNumber(output.NextRotationDate)))
            : undefined,
        OwningService: expectString(output.OwningService),
        PrimaryRegion: expectString(output.PrimaryRegion),
        RotationEnabled: expectBoolean(output.RotationEnabled),
        RotationLambdaARN: expectString(output.RotationLambdaARN),
        RotationRules: output.RotationRules != null ? deserializeAws_json1_1RotationRulesType(output.RotationRules, context) : undefined,
        SecretVersionsToStages: output.SecretVersionsToStages != null
            ? deserializeAws_json1_1SecretVersionsToStagesMapType(output.SecretVersionsToStages, context)
            : undefined,
        Tags: output.Tags != null ? deserializeAws_json1_1TagListType(output.Tags, context) : undefined,
    };
};
const deserializeAws_json1_1SecretListType = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1SecretListEntry(entry, context);
    });
    return retVal;
};
const deserializeAws_json1_1SecretVersionsListEntry = (output, context) => {
    return {
        CreatedDate: output.CreatedDate != null
            ? expectNonNull(parseEpochTimestamp(expectNumber(output.CreatedDate)))
            : undefined,
        KmsKeyIds: output.KmsKeyIds != null ? deserializeAws_json1_1KmsKeyIdListType(output.KmsKeyIds, context) : undefined,
        LastAccessedDate: output.LastAccessedDate != null
            ? expectNonNull(parseEpochTimestamp(expectNumber(output.LastAccessedDate)))
            : undefined,
        VersionId: expectString(output.VersionId),
        VersionStages: output.VersionStages != null
            ? deserializeAws_json1_1SecretVersionStagesType(output.VersionStages, context)
            : undefined,
    };
};
const deserializeAws_json1_1SecretVersionsListType = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1SecretVersionsListEntry(entry, context);
    });
    return retVal;
};
const deserializeAws_json1_1SecretVersionStagesType = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return expectString(entry);
    });
    return retVal;
};
const deserializeAws_json1_1SecretVersionsToStagesMapType = (output, context) => {
    return Object.entries(output).reduce((acc, [key, value]) => {
        if (value === null) {
            return acc;
        }
        acc[key] = deserializeAws_json1_1SecretVersionStagesType(value, context);
        return acc;
    }, {});
};
const deserializeAws_json1_1StopReplicationToReplicaResponse = (output, context) => {
    return {
        ARN: expectString(output.ARN),
    };
};
const deserializeAws_json1_1Tag = (output, context) => {
    return {
        Key: expectString(output.Key),
        Value: expectString(output.Value),
    };
};
const deserializeAws_json1_1TagListType = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1Tag(entry, context);
    });
    return retVal;
};
const deserializeAws_json1_1UpdateSecretResponse = (output, context) => {
    return {
        ARN: expectString(output.ARN),
        Name: expectString(output.Name),
        VersionId: expectString(output.VersionId),
    };
};
const deserializeAws_json1_1UpdateSecretVersionStageResponse = (output, context) => {
    return {
        ARN: expectString(output.ARN),
        Name: expectString(output.Name),
    };
};
const deserializeAws_json1_1ValidateResourcePolicyResponse = (output, context) => {
    return {
        PolicyValidationPassed: expectBoolean(output.PolicyValidationPassed),
        ValidationErrors: output.ValidationErrors != null
            ? deserializeAws_json1_1ValidationErrorsType(output.ValidationErrors, context)
            : undefined,
    };
};
const deserializeAws_json1_1ValidationErrorsEntry = (output, context) => {
    return {
        CheckName: expectString(output.CheckName),
        ErrorMessage: expectString(output.ErrorMessage),
    };
};
const deserializeAws_json1_1ValidationErrorsType = (output, context) => {
    const retVal = (output || [])
        .filter((e) => e != null)
        .map((entry) => {
        if (entry === null) {
            return null;
        }
        return deserializeAws_json1_1ValidationErrorsEntry(entry, context);
    });
    return retVal;
};
const Aws_json1_1_deserializeMetadata = (output) => ({
    httpStatusCode: output.statusCode,
    requestId: output.headers["x-amzn-requestid"] ?? output.headers["x-amzn-request-id"] ?? output.headers["x-amz-request-id"],
    extendedRequestId: output.headers["x-amz-id-2"],
    cfId: output.headers["x-amz-cf-id"],
});
const collectBody = (streamBody = new Uint8Array(), context) => {
    if (streamBody instanceof Uint8Array) {
        return Promise.resolve(streamBody);
    }
    return context.streamCollector(streamBody) || Promise.resolve(new Uint8Array());
};
const collectBodyString = (streamBody, context) => collectBody(streamBody, context).then((body) => context.utf8Encoder(body));
const buildHttpRpcRequest = async (context, headers, path, resolvedHostname, body) => {
    const { hostname, protocol = "https", port, path: basePath } = await context.endpoint();
    const contents = {
        protocol,
        hostname,
        port,
        method: "POST",
        path: basePath.endsWith("/") ? basePath.slice(0, -1) + path : basePath + path,
        headers,
    };
    if (resolvedHostname !== undefined) {
        contents.hostname = resolvedHostname;
    }
    if (body !== undefined) {
        contents.body = body;
    }
    return new httpRequest_HttpRequest(contents);
};
const parseBody = (streamBody, context) => collectBodyString(streamBody, context).then((encoded) => {
    if (encoded.length) {
        return JSON.parse(encoded);
    }
    return {};
});
const parseErrorBody = async (errorBody, context) => {
    const value = await parseBody(errorBody, context);
    value.message = value.message ?? value.Message;
    return value;
};
const loadRestJsonErrorCode = (output, data) => {
    const findKey = (object, key) => Object.keys(object).find((k) => k.toLowerCase() === key.toLowerCase());
    const sanitizeErrorCode = (rawValue) => {
        let cleanValue = rawValue;
        if (typeof cleanValue === "number") {
            cleanValue = cleanValue.toString();
        }
        if (cleanValue.indexOf(",") >= 0) {
            cleanValue = cleanValue.split(",")[0];
        }
        if (cleanValue.indexOf(":") >= 0) {
            cleanValue = cleanValue.split(":")[0];
        }
        if (cleanValue.indexOf("#") >= 0) {
            cleanValue = cleanValue.split("#")[1];
        }
        return cleanValue;
    };
    const headerKey = findKey(output.headers, "x-amzn-errortype");
    if (headerKey !== undefined) {
        return sanitizeErrorCode(output.headers[headerKey]);
    }
    if (data.code !== undefined) {
        return sanitizeErrorCode(data.code);
    }
    if (data["__type"] !== undefined) {
        return sanitizeErrorCode(data["__type"]);
    }
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/CancelRotateSecretCommand.js





class CancelRotateSecretCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, CancelRotateSecretCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "CancelRotateSecretCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: CancelRotateSecretRequestFilterSensitiveLog,
            outputFilterSensitiveLog: CancelRotateSecretResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1CancelRotateSecretCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1CancelRotateSecretCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/CreateSecretCommand.js





class CreateSecretCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, CreateSecretCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "CreateSecretCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: CreateSecretRequestFilterSensitiveLog,
            outputFilterSensitiveLog: CreateSecretResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1CreateSecretCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1CreateSecretCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/DeleteResourcePolicyCommand.js





class DeleteResourcePolicyCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, DeleteResourcePolicyCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "DeleteResourcePolicyCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: DeleteResourcePolicyRequestFilterSensitiveLog,
            outputFilterSensitiveLog: DeleteResourcePolicyResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1DeleteResourcePolicyCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1DeleteResourcePolicyCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/DeleteSecretCommand.js





class DeleteSecretCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, DeleteSecretCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "DeleteSecretCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: DeleteSecretRequestFilterSensitiveLog,
            outputFilterSensitiveLog: DeleteSecretResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1DeleteSecretCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1DeleteSecretCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/DescribeSecretCommand.js





class DescribeSecretCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, DescribeSecretCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "DescribeSecretCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: DescribeSecretRequestFilterSensitiveLog,
            outputFilterSensitiveLog: DescribeSecretResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1DescribeSecretCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1DescribeSecretCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/GetRandomPasswordCommand.js





class GetRandomPasswordCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, GetRandomPasswordCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "GetRandomPasswordCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: GetRandomPasswordRequestFilterSensitiveLog,
            outputFilterSensitiveLog: GetRandomPasswordResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1GetRandomPasswordCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1GetRandomPasswordCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/GetResourcePolicyCommand.js





class GetResourcePolicyCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, GetResourcePolicyCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "GetResourcePolicyCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: GetResourcePolicyRequestFilterSensitiveLog,
            outputFilterSensitiveLog: GetResourcePolicyResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1GetResourcePolicyCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1GetResourcePolicyCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/GetSecretValueCommand.js





class GetSecretValueCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, GetSecretValueCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "GetSecretValueCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: GetSecretValueRequestFilterSensitiveLog,
            outputFilterSensitiveLog: GetSecretValueResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1GetSecretValueCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1GetSecretValueCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/ListSecretsCommand.js





class ListSecretsCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, ListSecretsCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "ListSecretsCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: ListSecretsRequestFilterSensitiveLog,
            outputFilterSensitiveLog: ListSecretsResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1ListSecretsCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1ListSecretsCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/ListSecretVersionIdsCommand.js





class ListSecretVersionIdsCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, ListSecretVersionIdsCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "ListSecretVersionIdsCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: ListSecretVersionIdsRequestFilterSensitiveLog,
            outputFilterSensitiveLog: ListSecretVersionIdsResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1ListSecretVersionIdsCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1ListSecretVersionIdsCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/PutResourcePolicyCommand.js





class PutResourcePolicyCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, PutResourcePolicyCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "PutResourcePolicyCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: PutResourcePolicyRequestFilterSensitiveLog,
            outputFilterSensitiveLog: PutResourcePolicyResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1PutResourcePolicyCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1PutResourcePolicyCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/PutSecretValueCommand.js





class PutSecretValueCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, PutSecretValueCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "PutSecretValueCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: PutSecretValueRequestFilterSensitiveLog,
            outputFilterSensitiveLog: PutSecretValueResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1PutSecretValueCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1PutSecretValueCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/RemoveRegionsFromReplicationCommand.js





class RemoveRegionsFromReplicationCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, RemoveRegionsFromReplicationCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "RemoveRegionsFromReplicationCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: RemoveRegionsFromReplicationRequestFilterSensitiveLog,
            outputFilterSensitiveLog: RemoveRegionsFromReplicationResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1RemoveRegionsFromReplicationCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1RemoveRegionsFromReplicationCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/ReplicateSecretToRegionsCommand.js





class ReplicateSecretToRegionsCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, ReplicateSecretToRegionsCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "ReplicateSecretToRegionsCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: ReplicateSecretToRegionsRequestFilterSensitiveLog,
            outputFilterSensitiveLog: ReplicateSecretToRegionsResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1ReplicateSecretToRegionsCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1ReplicateSecretToRegionsCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/RestoreSecretCommand.js





class RestoreSecretCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, RestoreSecretCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "RestoreSecretCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: RestoreSecretRequestFilterSensitiveLog,
            outputFilterSensitiveLog: RestoreSecretResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1RestoreSecretCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1RestoreSecretCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/RotateSecretCommand.js





class RotateSecretCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, RotateSecretCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "RotateSecretCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: RotateSecretRequestFilterSensitiveLog,
            outputFilterSensitiveLog: RotateSecretResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1RotateSecretCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1RotateSecretCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/StopReplicationToReplicaCommand.js





class StopReplicationToReplicaCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, StopReplicationToReplicaCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "StopReplicationToReplicaCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: StopReplicationToReplicaRequestFilterSensitiveLog,
            outputFilterSensitiveLog: StopReplicationToReplicaResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1StopReplicationToReplicaCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1StopReplicationToReplicaCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/TagResourceCommand.js





class TagResourceCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, TagResourceCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "TagResourceCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: TagResourceRequestFilterSensitiveLog,
            outputFilterSensitiveLog: (output) => output,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1TagResourceCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1TagResourceCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/UntagResourceCommand.js





class UntagResourceCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, UntagResourceCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "UntagResourceCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: UntagResourceRequestFilterSensitiveLog,
            outputFilterSensitiveLog: (output) => output,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1UntagResourceCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1UntagResourceCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/UpdateSecretCommand.js





class UpdateSecretCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, UpdateSecretCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "UpdateSecretCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: UpdateSecretRequestFilterSensitiveLog,
            outputFilterSensitiveLog: UpdateSecretResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1UpdateSecretCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1UpdateSecretCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/UpdateSecretVersionStageCommand.js





class UpdateSecretVersionStageCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, UpdateSecretVersionStageCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "UpdateSecretVersionStageCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: UpdateSecretVersionStageRequestFilterSensitiveLog,
            outputFilterSensitiveLog: UpdateSecretVersionStageResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1UpdateSecretVersionStageCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1UpdateSecretVersionStageCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/commands/ValidateResourcePolicyCommand.js





class ValidateResourcePolicyCommand extends Command {
    constructor(input) {
        super();
        this.input = input;
    }
    static getEndpointParameterInstructions() {
        return {
            UseFIPS: { type: "builtInParams", name: "useFipsEndpoint" },
            Endpoint: { type: "builtInParams", name: "endpoint" },
            Region: { type: "builtInParams", name: "region" },
            UseDualStack: { type: "builtInParams", name: "useDualstackEndpoint" },
        };
    }
    resolveMiddleware(clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getEndpointPlugin(configuration, ValidateResourcePolicyCommand.getEndpointParameterInstructions()));
        const stack = clientStack.concat(this.middlewareStack);
        const { logger } = configuration;
        const clientName = "SecretsManagerClient";
        const commandName = "ValidateResourcePolicyCommand";
        const handlerExecutionContext = {
            logger,
            clientName,
            commandName,
            inputFilterSensitiveLog: ValidateResourcePolicyRequestFilterSensitiveLog,
            outputFilterSensitiveLog: ValidateResourcePolicyResponseFilterSensitiveLog,
        };
        const { requestHandler } = configuration;
        return stack.resolve((request) => requestHandler.handle(request.request, options || {}), handlerExecutionContext);
    }
    serialize(input, context) {
        return serializeAws_json1_1ValidateResourcePolicyCommand(input, context);
    }
    deserialize(output, context) {
        return deserializeAws_json1_1ValidateResourcePolicyCommand(output, context);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-config-provider/dist-es/booleanSelector.js
var SelectorType;
(function (SelectorType) {
    SelectorType["ENV"] = "env";
    SelectorType["CONFIG"] = "shared config entry";
})(SelectorType || (SelectorType = {}));
const booleanSelector = (obj, key, type) => {
    if (!(key in obj))
        return undefined;
    if (obj[key] === "true")
        return true;
    if (obj[key] === "false")
        return false;
    throw new Error(`Cannot load ${type} "${key}". Expected "true" or "false", got ${obj[key]}.`);
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-config-provider/dist-es/index.js


;// CONCATENATED MODULE: ./node_modules/@aws-sdk/config-resolver/dist-es/endpointsConfig/NodeUseDualstackEndpointConfigOptions.js

const ENV_USE_DUALSTACK_ENDPOINT = "AWS_USE_DUALSTACK_ENDPOINT";
const CONFIG_USE_DUALSTACK_ENDPOINT = "use_dualstack_endpoint";
const DEFAULT_USE_DUALSTACK_ENDPOINT = false;
const NODE_USE_DUALSTACK_ENDPOINT_CONFIG_OPTIONS = {
    environmentVariableSelector: (env) => booleanSelector(env, ENV_USE_DUALSTACK_ENDPOINT, SelectorType.ENV),
    configFileSelector: (profile) => booleanSelector(profile, CONFIG_USE_DUALSTACK_ENDPOINT, SelectorType.CONFIG),
    default: false,
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/config-resolver/dist-es/endpointsConfig/NodeUseFipsEndpointConfigOptions.js

const ENV_USE_FIPS_ENDPOINT = "AWS_USE_FIPS_ENDPOINT";
const CONFIG_USE_FIPS_ENDPOINT = "use_fips_endpoint";
const DEFAULT_USE_FIPS_ENDPOINT = false;
const NODE_USE_FIPS_ENDPOINT_CONFIG_OPTIONS = {
    environmentVariableSelector: (env) => booleanSelector(env, ENV_USE_FIPS_ENDPOINT, SelectorType.ENV),
    configFileSelector: (profile) => booleanSelector(profile, CONFIG_USE_FIPS_ENDPOINT, SelectorType.CONFIG),
    default: false,
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/config-resolver/dist-es/endpointsConfig/index.js





;// CONCATENATED MODULE: ./node_modules/@aws-sdk/config-resolver/dist-es/regionConfig/config.js
const REGION_ENV_NAME = "AWS_REGION";
const REGION_INI_NAME = "region";
const NODE_REGION_CONFIG_OPTIONS = {
    environmentVariableSelector: (env) => env[REGION_ENV_NAME],
    configFileSelector: (profile) => profile[REGION_INI_NAME],
    default: () => {
        throw new Error("Region is missing");
    },
};
const NODE_REGION_CONFIG_FILE_OPTIONS = {
    preferredFile: "credentials",
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/config-resolver/dist-es/regionConfig/isFipsRegion.js
const isFipsRegion = (region) => typeof region === "string" && (region.startsWith("fips-") || region.endsWith("-fips"));

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/config-resolver/dist-es/regionConfig/getRealRegion.js

const getRealRegion = (region) => isFipsRegion(region)
    ? ["fips-aws-global", "aws-fips"].includes(region)
        ? "us-east-1"
        : region.replace(/fips-(dkr-|prod-)?|-fips/, "")
    : region;

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/config-resolver/dist-es/regionConfig/resolveRegionConfig.js


const resolveRegionConfig = (input) => {
    const { region, useFipsEndpoint } = input;
    if (!region) {
        throw new Error("Region is missing");
    }
    return {
        ...input,
        region: async () => {
            if (typeof region === "string") {
                return getRealRegion(region);
            }
            const providedRegion = await region();
            return getRealRegion(providedRegion);
        },
        useFipsEndpoint: async () => {
            const providedRegion = typeof region === "string" ? region : await region();
            if (isFipsRegion(providedRegion)) {
                return true;
            }
            return typeof useFipsEndpoint !== "function" ? Promise.resolve(!!useFipsEndpoint) : useFipsEndpoint();
        },
    };
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/config-resolver/dist-es/regionConfig/index.js



;// CONCATENATED MODULE: ./node_modules/@aws-sdk/config-resolver/dist-es/index.js




;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-content-length/dist-es/index.js

const CONTENT_LENGTH_HEADER = "content-length";
function contentLengthMiddleware(bodyLengthChecker) {
    return (next) => async (args) => {
        const request = args.request;
        if (httpRequest_HttpRequest.isInstance(request)) {
            const { body, headers } = request;
            if (body &&
                Object.keys(headers)
                    .map((str) => str.toLowerCase())
                    .indexOf(CONTENT_LENGTH_HEADER) === -1) {
                try {
                    const length = bodyLengthChecker(body);
                    request.headers = {
                        ...request.headers,
                        [CONTENT_LENGTH_HEADER]: String(length),
                    };
                }
                catch (error) {
                }
            }
        }
        return next({
            ...args,
            request,
        });
    };
}
const contentLengthMiddlewareOptions = {
    step: "build",
    tags: ["SET_CONTENT_LENGTH", "CONTENT_LENGTH"],
    name: "contentLengthMiddleware",
    override: true,
};
const getContentLengthPlugin = (options) => ({
    applyToStack: (clientStack) => {
        clientStack.add(contentLengthMiddleware(options.bodyLengthChecker), contentLengthMiddlewareOptions);
    },
});

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-host-header/dist-es/index.js

function resolveHostHeaderConfig(input) {
    return input;
}
const hostHeaderMiddleware = (options) => (next) => async (args) => {
    if (!httpRequest_HttpRequest.isInstance(args.request))
        return next(args);
    const { request } = args;
    const { handlerProtocol = "" } = options.requestHandler.metadata || {};
    if (handlerProtocol.indexOf("h2") >= 0 && !request.headers[":authority"]) {
        delete request.headers["host"];
        request.headers[":authority"] = "";
    }
    else if (!request.headers["host"]) {
        request.headers["host"] = request.hostname;
    }
    return next(args);
};
const hostHeaderMiddlewareOptions = {
    name: "hostHeaderMiddleware",
    step: "build",
    priority: "low",
    tags: ["HOST"],
    override: true,
};
const getHostHeaderPlugin = (options) => ({
    applyToStack: (clientStack) => {
        clientStack.add(hostHeaderMiddleware(options), hostHeaderMiddlewareOptions);
    },
});

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-logger/dist-es/loggerMiddleware.js
const loggerMiddleware = () => (next, context) => async (args) => {
    const response = await next(args);
    const { clientName, commandName, logger, inputFilterSensitiveLog, outputFilterSensitiveLog, dynamoDbDocumentClientOptions = {}, } = context;
    const { overrideInputFilterSensitiveLog, overrideOutputFilterSensitiveLog } = dynamoDbDocumentClientOptions;
    if (!logger) {
        return response;
    }
    if (typeof logger.info === "function") {
        const { $metadata, ...outputWithoutMetadata } = response.output;
        logger.info({
            clientName,
            commandName,
            input: (overrideInputFilterSensitiveLog ?? inputFilterSensitiveLog)(args.input),
            output: (overrideOutputFilterSensitiveLog ?? outputFilterSensitiveLog)(outputWithoutMetadata),
            metadata: $metadata,
        });
    }
    return response;
};
const loggerMiddlewareOptions = {
    name: "loggerMiddleware",
    tags: ["LOGGER"],
    step: "initialize",
    override: true,
};
const getLoggerPlugin = (options) => ({
    applyToStack: (clientStack) => {
        clientStack.add(loggerMiddleware(), loggerMiddlewareOptions);
    },
});

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-logger/dist-es/index.js


;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-recursion-detection/dist-es/index.js
/* provided dependency */ var process = __webpack_require__(83454);

const TRACE_ID_HEADER_NAME = "X-Amzn-Trace-Id";
const ENV_LAMBDA_FUNCTION_NAME = "AWS_LAMBDA_FUNCTION_NAME";
const ENV_TRACE_ID = "_X_AMZN_TRACE_ID";
const recursionDetectionMiddleware = (options) => (next) => async (args) => {
    const { request } = args;
    if (!httpRequest_HttpRequest.isInstance(request) ||
        options.runtime !== "node" ||
        request.headers.hasOwnProperty(TRACE_ID_HEADER_NAME)) {
        return next(args);
    }
    const functionName = process.env[ENV_LAMBDA_FUNCTION_NAME];
    const traceId = process.env[ENV_TRACE_ID];
    const nonEmptyString = (str) => typeof str === "string" && str.length > 0;
    if (nonEmptyString(functionName) && nonEmptyString(traceId)) {
        request.headers[TRACE_ID_HEADER_NAME] = traceId;
    }
    return next({
        ...args,
        request,
    });
};
const addRecursionDetectionMiddlewareOptions = {
    step: "build",
    tags: ["RECURSION_DETECTION"],
    name: "recursionDetectionMiddleware",
    override: true,
    priority: "low",
};
const getRecursionDetectionPlugin = (options) => ({
    applyToStack: (clientStack) => {
        clientStack.add(recursionDetectionMiddleware(options), addRecursionDetectionMiddlewareOptions);
    },
});

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-retry/dist-es/config.js
var config_RETRY_MODES;
(function (RETRY_MODES) {
    RETRY_MODES["STANDARD"] = "standard";
    RETRY_MODES["ADAPTIVE"] = "adaptive";
})(config_RETRY_MODES || (config_RETRY_MODES = {}));
const config_DEFAULT_MAX_ATTEMPTS = 3;
const DEFAULT_RETRY_MODE = "STANDARD";

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/service-error-classification/dist-es/constants.js
const constants_CLOCK_SKEW_ERROR_CODES = (/* unused pure expression or super */ null && ([
    "AuthFailure",
    "InvalidSignatureException",
    "RequestExpired",
    "RequestInTheFuture",
    "RequestTimeTooSkewed",
    "SignatureDoesNotMatch",
]));
const THROTTLING_ERROR_CODES = [
    "BandwidthLimitExceeded",
    "EC2ThrottledException",
    "LimitExceededException",
    "PriorRequestNotComplete",
    "ProvisionedThroughputExceededException",
    "RequestLimitExceeded",
    "RequestThrottled",
    "RequestThrottledException",
    "SlowDown",
    "ThrottledException",
    "Throttling",
    "ThrottlingException",
    "TooManyRequestsException",
    "TransactionInProgressException",
];
const TRANSIENT_ERROR_CODES = ["AbortError", "TimeoutError", "RequestTimeout", "RequestTimeoutException"];
const TRANSIENT_ERROR_STATUS_CODES = [500, 502, 503, 504];
const NODEJS_TIMEOUT_ERROR_CODES = ["ECONNRESET", "EPIPE", "ETIMEDOUT"];

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/service-error-classification/dist-es/index.js

const isRetryableByTrait = (error) => error.$retryable !== undefined;
const isClockSkewError = (error) => CLOCK_SKEW_ERROR_CODES.includes(error.name);
const dist_es_isThrottlingError = (error) => error.$metadata?.httpStatusCode === 429 ||
    THROTTLING_ERROR_CODES.includes(error.name) ||
    error.$retryable?.throttling == true;
const isTransientError = (error) => TRANSIENT_ERROR_CODES.includes(error.name) ||
    NODEJS_TIMEOUT_ERROR_CODES.includes(error?.code || "") ||
    TRANSIENT_ERROR_STATUS_CODES.includes(error.$metadata?.httpStatusCode || 0);
const isServerError = (error) => {
    if (error.$metadata?.httpStatusCode !== undefined) {
        const statusCode = error.$metadata.httpStatusCode;
        if (500 <= statusCode && statusCode <= 599 && !isTransientError(error)) {
            return true;
        }
        return false;
    }
    return false;
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-retry/dist-es/DefaultRateLimiter.js

class DefaultRateLimiter_DefaultRateLimiter {
    constructor(options) {
        this.currentCapacity = 0;
        this.enabled = false;
        this.lastMaxRate = 0;
        this.measuredTxRate = 0;
        this.requestCount = 0;
        this.lastTimestamp = 0;
        this.timeWindow = 0;
        this.beta = options?.beta ?? 0.7;
        this.minCapacity = options?.minCapacity ?? 1;
        this.minFillRate = options?.minFillRate ?? 0.5;
        this.scaleConstant = options?.scaleConstant ?? 0.4;
        this.smooth = options?.smooth ?? 0.8;
        const currentTimeInSeconds = this.getCurrentTimeInSeconds();
        this.lastThrottleTime = currentTimeInSeconds;
        this.lastTxRateBucket = Math.floor(this.getCurrentTimeInSeconds());
        this.fillRate = this.minFillRate;
        this.maxCapacity = this.minCapacity;
    }
    getCurrentTimeInSeconds() {
        return Date.now() / 1000;
    }
    async getSendToken() {
        return this.acquireTokenBucket(1);
    }
    async acquireTokenBucket(amount) {
        if (!this.enabled) {
            return;
        }
        this.refillTokenBucket();
        if (amount > this.currentCapacity) {
            const delay = ((amount - this.currentCapacity) / this.fillRate) * 1000;
            await new Promise((resolve) => setTimeout(resolve, delay));
        }
        this.currentCapacity = this.currentCapacity - amount;
    }
    refillTokenBucket() {
        const timestamp = this.getCurrentTimeInSeconds();
        if (!this.lastTimestamp) {
            this.lastTimestamp = timestamp;
            return;
        }
        const fillAmount = (timestamp - this.lastTimestamp) * this.fillRate;
        this.currentCapacity = Math.min(this.maxCapacity, this.currentCapacity + fillAmount);
        this.lastTimestamp = timestamp;
    }
    updateClientSendingRate(response) {
        let calculatedRate;
        this.updateMeasuredRate();
        if (dist_es_isThrottlingError(response)) {
            const rateToUse = !this.enabled ? this.measuredTxRate : Math.min(this.measuredTxRate, this.fillRate);
            this.lastMaxRate = rateToUse;
            this.calculateTimeWindow();
            this.lastThrottleTime = this.getCurrentTimeInSeconds();
            calculatedRate = this.cubicThrottle(rateToUse);
            this.enableTokenBucket();
        }
        else {
            this.calculateTimeWindow();
            calculatedRate = this.cubicSuccess(this.getCurrentTimeInSeconds());
        }
        const newRate = Math.min(calculatedRate, 2 * this.measuredTxRate);
        this.updateTokenBucketRate(newRate);
    }
    calculateTimeWindow() {
        this.timeWindow = this.getPrecise(Math.pow((this.lastMaxRate * (1 - this.beta)) / this.scaleConstant, 1 / 3));
    }
    cubicThrottle(rateToUse) {
        return this.getPrecise(rateToUse * this.beta);
    }
    cubicSuccess(timestamp) {
        return this.getPrecise(this.scaleConstant * Math.pow(timestamp - this.lastThrottleTime - this.timeWindow, 3) + this.lastMaxRate);
    }
    enableTokenBucket() {
        this.enabled = true;
    }
    updateTokenBucketRate(newRate) {
        this.refillTokenBucket();
        this.fillRate = Math.max(newRate, this.minFillRate);
        this.maxCapacity = Math.max(newRate, this.minCapacity);
        this.currentCapacity = Math.min(this.currentCapacity, this.maxCapacity);
    }
    updateMeasuredRate() {
        const t = this.getCurrentTimeInSeconds();
        const timeBucket = Math.floor(t * 2) / 2;
        this.requestCount++;
        if (timeBucket > this.lastTxRateBucket) {
            const currentRate = this.requestCount / (timeBucket - this.lastTxRateBucket);
            this.measuredTxRate = this.getPrecise(currentRate * this.smooth + this.measuredTxRate * (1 - this.smooth));
            this.requestCount = 0;
            this.lastTxRateBucket = timeBucket;
        }
    }
    getPrecise(num) {
        return parseFloat(num.toFixed(8));
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-retry/dist-es/constants.js
const constants_DEFAULT_RETRY_DELAY_BASE = 100;
const constants_MAXIMUM_RETRY_DELAY = 20 * 1000;
const constants_THROTTLING_RETRY_DELAY_BASE = 500;
const constants_INITIAL_RETRY_TOKENS = 500;
const constants_RETRY_COST = 5;
const constants_TIMEOUT_RETRY_COST = 10;
const constants_NO_RETRY_INCREMENT = 1;
const constants_INVOCATION_ID_HEADER = "amz-sdk-invocation-id";
const constants_REQUEST_HEADER = "amz-sdk-request";

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-retry/dist-es/defaultRetryBackoffStrategy.js

const getDefaultRetryBackoffStrategy = () => {
    let delayBase = constants_DEFAULT_RETRY_DELAY_BASE;
    const computeNextBackoffDelay = (attempts) => {
        return Math.floor(Math.min(constants_MAXIMUM_RETRY_DELAY, Math.random() * 2 ** attempts * delayBase));
    };
    const setDelayBase = (delay) => {
        delayBase = delay;
    };
    return {
        computeNextBackoffDelay,
        setDelayBase,
    };
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-retry/dist-es/defaultRetryToken.js


const getDefaultRetryToken = (initialRetryTokens, initialRetryDelay, initialRetryCount, options) => {
    const MAX_CAPACITY = initialRetryTokens;
    const retryCost = options?.retryCost ?? constants_RETRY_COST;
    const timeoutRetryCost = options?.timeoutRetryCost ?? constants_TIMEOUT_RETRY_COST;
    const retryBackoffStrategy = options?.retryBackoffStrategy ?? getDefaultRetryBackoffStrategy();
    let availableCapacity = initialRetryTokens;
    let retryDelay = Math.min(constants_MAXIMUM_RETRY_DELAY, initialRetryDelay);
    let lastRetryCost = undefined;
    let retryCount = initialRetryCount ?? 0;
    const getCapacityAmount = (errorType) => (errorType === "TRANSIENT" ? timeoutRetryCost : retryCost);
    const getRetryCount = () => retryCount;
    const getRetryDelay = () => retryDelay;
    const getLastRetryCost = () => lastRetryCost;
    const hasRetryTokens = (errorType) => getCapacityAmount(errorType) <= availableCapacity;
    const getRetryTokenCount = (errorInfo) => {
        const errorType = errorInfo.errorType;
        if (!hasRetryTokens(errorType)) {
            throw new Error("No retry token available");
        }
        const capacityAmount = getCapacityAmount(errorType);
        const delayBase = errorType === "THROTTLING" ? constants_THROTTLING_RETRY_DELAY_BASE : constants_DEFAULT_RETRY_DELAY_BASE;
        retryBackoffStrategy.setDelayBase(delayBase);
        const delayFromErrorType = retryBackoffStrategy.computeNextBackoffDelay(retryCount);
        if (errorInfo.retryAfterHint) {
            const delayFromRetryAfterHint = errorInfo.retryAfterHint.getTime() - Date.now();
            retryDelay = Math.max(delayFromRetryAfterHint || 0, delayFromErrorType);
        }
        else {
            retryDelay = delayFromErrorType;
        }
        retryCount++;
        lastRetryCost = capacityAmount;
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    const releaseRetryTokens = (releaseAmount) => {
        availableCapacity += releaseAmount ?? constants_NO_RETRY_INCREMENT;
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return {
        getRetryCount,
        getRetryDelay,
        getLastRetryCost,
        hasRetryTokens,
        getRetryTokenCount,
        releaseRetryTokens,
    };
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-retry/dist-es/StandardRetryStrategy.js



class StandardRetryStrategy_StandardRetryStrategy {
    constructor(maxAttemptsProvider) {
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = config_RETRY_MODES.STANDARD;
        this.retryToken = getDefaultRetryToken(constants_INITIAL_RETRY_TOKENS, constants_DEFAULT_RETRY_DELAY_BASE);
        this.maxAttemptsProvider = maxAttemptsProvider;
    }
    async acquireInitialRetryToken(retryTokenScope) {
        return this.retryToken;
    }
    async refreshRetryTokenForRetry(tokenToRenew, errorInfo) {
        const maxAttempts = await this.getMaxAttempts();
        if (this.shouldRetry(tokenToRenew, errorInfo, maxAttempts)) {
            tokenToRenew.getRetryTokenCount(errorInfo);
            return tokenToRenew;
        }
        throw new Error("No retry token available");
    }
    recordSuccess(token) {
        this.retryToken.releaseRetryTokens(token.getLastRetryCost());
    }
    async getMaxAttempts() {
        let maxAttempts;
        try {
            return await this.maxAttemptsProvider();
        }
        catch (error) {
            console.warn(`Max attempts provider could not resolve. Using default of ${config_DEFAULT_MAX_ATTEMPTS}`);
            return config_DEFAULT_MAX_ATTEMPTS;
        }
    }
    shouldRetry(tokenToRenew, errorInfo, maxAttempts) {
        const attempts = tokenToRenew.getRetryCount();
        return (attempts < maxAttempts &&
            tokenToRenew.hasRetryTokens(errorInfo.errorType) &&
            this.isRetryableError(errorInfo.errorType));
    }
    isRetryableError(errorType) {
        return errorType === "THROTTLING" || errorType === "TRANSIENT";
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-retry/dist-es/AdaptiveRetryStrategy.js



class AdaptiveRetryStrategy {
    constructor(maxAttemptsProvider, options) {
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = config_RETRY_MODES.ADAPTIVE;
        const { rateLimiter } = options ?? {};
        this.rateLimiter = rateLimiter ?? new DefaultRateLimiter_DefaultRateLimiter();
        this.standardRetryStrategy = new StandardRetryStrategy_StandardRetryStrategy(maxAttemptsProvider);
    }
    async acquireInitialRetryToken(retryTokenScope) {
        await this.rateLimiter.getSendToken();
        return this.standardRetryStrategy.acquireInitialRetryToken(retryTokenScope);
    }
    async refreshRetryTokenForRetry(tokenToRenew, errorInfo) {
        this.rateLimiter.updateClientSendingRate(errorInfo);
        return this.standardRetryStrategy.refreshRetryTokenForRetry(tokenToRenew, errorInfo);
    }
    recordSuccess(token) {
        this.rateLimiter.updateClientSendingRate({});
        this.standardRetryStrategy.recordSuccess(token);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-retry/dist-es/index.js







;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-retry/dist-es/defaultRetryQuota.js

const defaultRetryQuota_getDefaultRetryQuota = (initialRetryTokens, options) => {
    const MAX_CAPACITY = initialRetryTokens;
    const noRetryIncrement = options?.noRetryIncrement ?? NO_RETRY_INCREMENT;
    const retryCost = options?.retryCost ?? RETRY_COST;
    const timeoutRetryCost = options?.timeoutRetryCost ?? TIMEOUT_RETRY_COST;
    let availableCapacity = initialRetryTokens;
    const getCapacityAmount = (error) => (error.name === "TimeoutError" ? timeoutRetryCost : retryCost);
    const hasRetryTokens = (error) => getCapacityAmount(error) <= availableCapacity;
    const retrieveRetryTokens = (error) => {
        if (!hasRetryTokens(error)) {
            throw new Error("No retry token available");
        }
        const capacityAmount = getCapacityAmount(error);
        availableCapacity -= capacityAmount;
        return capacityAmount;
    };
    const releaseRetryTokens = (capacityReleaseAmount) => {
        availableCapacity += capacityReleaseAmount ?? noRetryIncrement;
        availableCapacity = Math.min(availableCapacity, MAX_CAPACITY);
    };
    return Object.freeze({
        hasRetryTokens,
        retrieveRetryTokens,
        releaseRetryTokens,
    });
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-retry/dist-es/delayDecider.js

const delayDecider_defaultDelayDecider = (delayBase, attempts) => Math.floor(Math.min(MAXIMUM_RETRY_DELAY, Math.random() * 2 ** attempts * delayBase));

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-retry/dist-es/StandardRetryStrategy.js








class dist_es_StandardRetryStrategy_StandardRetryStrategy {
    constructor(maxAttemptsProvider, options) {
        this.maxAttemptsProvider = maxAttemptsProvider;
        this.mode = RETRY_MODES.STANDARD;
        this.retryDecider = options?.retryDecider ?? defaultRetryDecider;
        this.delayDecider = options?.delayDecider ?? defaultDelayDecider;
        this.retryQuota = options?.retryQuota ?? getDefaultRetryQuota(INITIAL_RETRY_TOKENS);
    }
    shouldRetry(error, attempts, maxAttempts) {
        return attempts < maxAttempts && this.retryDecider(error) && this.retryQuota.hasRetryTokens(error);
    }
    async getMaxAttempts() {
        let maxAttempts;
        try {
            maxAttempts = await this.maxAttemptsProvider();
        }
        catch (error) {
            maxAttempts = DEFAULT_MAX_ATTEMPTS;
        }
        return maxAttempts;
    }
    async retry(next, args, options) {
        let retryTokenAmount;
        let attempts = 0;
        let totalDelay = 0;
        const maxAttempts = await this.getMaxAttempts();
        const { request } = args;
        if (HttpRequest.isInstance(request)) {
            request.headers[INVOCATION_ID_HEADER] = v4();
        }
        while (true) {
            try {
                if (HttpRequest.isInstance(request)) {
                    request.headers[REQUEST_HEADER] = `attempt=${attempts + 1}; max=${maxAttempts}`;
                }
                if (options?.beforeRequest) {
                    await options.beforeRequest();
                }
                const { response, output } = await next(args);
                if (options?.afterRequest) {
                    options.afterRequest(response);
                }
                this.retryQuota.releaseRetryTokens(retryTokenAmount);
                output.$metadata.attempts = attempts + 1;
                output.$metadata.totalRetryDelay = totalDelay;
                return { response, output };
            }
            catch (e) {
                const err = asSdkError(e);
                attempts++;
                if (this.shouldRetry(err, attempts, maxAttempts)) {
                    retryTokenAmount = this.retryQuota.retrieveRetryTokens(err);
                    const delayFromDecider = this.delayDecider(isThrottlingError(err) ? THROTTLING_RETRY_DELAY_BASE : DEFAULT_RETRY_DELAY_BASE, attempts);
                    const delayFromResponse = getDelayFromRetryAfterHeader(err.$response);
                    const delay = Math.max(delayFromResponse || 0, delayFromDecider);
                    totalDelay += delay;
                    await new Promise((resolve) => setTimeout(resolve, delay));
                    continue;
                }
                if (!err.$metadata) {
                    err.$metadata = {};
                }
                err.$metadata.attempts = attempts;
                err.$metadata.totalRetryDelay = totalDelay;
                throw err;
            }
        }
    }
}
const getDelayFromRetryAfterHeader = (response) => {
    if (!HttpResponse.isInstance(response))
        return;
    const retryAfterHeaderName = Object.keys(response.headers).find((key) => key.toLowerCase() === "retry-after");
    if (!retryAfterHeaderName)
        return;
    const retryAfter = response.headers[retryAfterHeaderName];
    const retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds))
        return retryAfterSeconds * 1000;
    const retryAfterDate = new Date(retryAfter);
    return retryAfterDate.getTime() - Date.now();
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-retry/dist-es/AdaptiveRetryStrategy.js


class AdaptiveRetryStrategy_AdaptiveRetryStrategy extends (/* unused pure expression or super */ null && (StandardRetryStrategy)) {
    constructor(maxAttemptsProvider, options) {
        const { rateLimiter, ...superOptions } = options ?? {};
        super(maxAttemptsProvider, superOptions);
        this.rateLimiter = rateLimiter ?? new DefaultRateLimiter();
        this.mode = RETRY_MODES.ADAPTIVE;
    }
    async retry(next, args) {
        return super.retry(next, args, {
            beforeRequest: async () => {
                return this.rateLimiter.getSendToken();
            },
            afterRequest: (response) => {
                this.rateLimiter.updateClientSendingRate(response);
            },
        });
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-retry/dist-es/configurations.js


const ENV_MAX_ATTEMPTS = "AWS_MAX_ATTEMPTS";
const CONFIG_MAX_ATTEMPTS = "max_attempts";
const NODE_MAX_ATTEMPT_CONFIG_OPTIONS = {
    environmentVariableSelector: (env) => {
        const value = env[ENV_MAX_ATTEMPTS];
        if (!value)
            return undefined;
        const maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) {
            throw new Error(`Environment variable ${ENV_MAX_ATTEMPTS} mast be a number, got "${value}"`);
        }
        return maxAttempt;
    },
    configFileSelector: (profile) => {
        const value = profile[CONFIG_MAX_ATTEMPTS];
        if (!value)
            return undefined;
        const maxAttempt = parseInt(value);
        if (Number.isNaN(maxAttempt)) {
            throw new Error(`Shared config file entry ${CONFIG_MAX_ATTEMPTS} mast be a number, got "${value}"`);
        }
        return maxAttempt;
    },
    default: config_DEFAULT_MAX_ATTEMPTS,
};
const resolveRetryConfig = (input) => {
    const { retryStrategy } = input;
    const maxAttempts = normalizeProvider_normalizeProvider(input.maxAttempts ?? config_DEFAULT_MAX_ATTEMPTS);
    return {
        ...input,
        maxAttempts,
        retryStrategy: async () => {
            if (retryStrategy) {
                return retryStrategy;
            }
            const retryMode = await normalizeProvider_normalizeProvider(input.retryMode)();
            if (retryMode === config_RETRY_MODES.ADAPTIVE) {
                return new AdaptiveRetryStrategy(maxAttempts);
            }
            return new StandardRetryStrategy_StandardRetryStrategy(maxAttempts);
        },
    };
};
const ENV_RETRY_MODE = "AWS_RETRY_MODE";
const CONFIG_RETRY_MODE = "retry_mode";
const NODE_RETRY_MODE_CONFIG_OPTIONS = {
    environmentVariableSelector: (env) => env[ENV_RETRY_MODE],
    configFileSelector: (profile) => profile[CONFIG_RETRY_MODE],
    default: DEFAULT_RETRY_MODE,
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-retry/dist-es/omitRetryHeadersMiddleware.js


const omitRetryHeadersMiddleware = () => (next) => async (args) => {
    const { request } = args;
    if (HttpRequest.isInstance(request)) {
        delete request.headers[INVOCATION_ID_HEADER];
        delete request.headers[REQUEST_HEADER];
    }
    return next(args);
};
const omitRetryHeadersMiddlewareOptions = {
    name: "omitRetryHeadersMiddleware",
    tags: ["RETRY", "HEADERS", "OMIT_RETRY_HEADERS"],
    relation: "before",
    toMiddleware: "awsAuthMiddleware",
    override: true,
};
const getOmitRetryHeadersPlugin = (options) => ({
    applyToStack: (clientStack) => {
        clientStack.addRelativeTo(omitRetryHeadersMiddleware(), omitRetryHeadersMiddlewareOptions);
    },
});

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/protocol-http/dist-es/httpResponse.js
class httpResponse_HttpResponse {
    constructor(options) {
        this.statusCode = options.statusCode;
        this.headers = options.headers || {};
        this.body = options.body;
    }
    static isInstance(response) {
        if (!response)
            return false;
        const resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-retry/node_modules/uuid/dist/esm-browser/rng.js
// Unique ID creation requires a high quality random # generator. In the browser we therefore
// require the crypto API and do not support built-in fallback to lower quality random number
// generators (like Math.random()).
var rng_getRandomValues;
var rng_rnds8 = new Uint8Array(16);
function rng_rng() {
  // lazy load so that environments that need to polyfill have a chance to do so
  if (!rng_getRandomValues) {
    // getRandomValues needs to be invoked in a context where "this" is a Crypto implementation. Also,
    // find the complete implementation of crypto (msCrypto) on IE11.
    rng_getRandomValues = typeof crypto !== 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto !== 'undefined' && typeof msCrypto.getRandomValues === 'function' && msCrypto.getRandomValues.bind(msCrypto);

    if (!rng_getRandomValues) {
      throw new Error('crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported');
    }
  }

  return rng_getRandomValues(rng_rnds8);
}
;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-retry/node_modules/uuid/dist/esm-browser/regex.js
/* harmony default export */ var esm_browser_regex = (/^(?:[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}|00000000-0000-0000-0000-000000000000)$/i);
;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-retry/node_modules/uuid/dist/esm-browser/validate.js


function validate_validate(uuid) {
  return typeof uuid === 'string' && esm_browser_regex.test(uuid);
}

/* harmony default export */ var dist_esm_browser_validate = (validate_validate);
;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-retry/node_modules/uuid/dist/esm-browser/stringify.js

/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */

var stringify_byteToHex = [];

for (var stringify_i = 0; stringify_i < 256; ++stringify_i) {
  stringify_byteToHex.push((stringify_i + 0x100).toString(16).substr(1));
}

function stringify_stringify(arr) {
  var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  // Note: Be careful editing this code!  It's been tuned for performance
  // and works in ways you may not expect. See https://github.com/uuidjs/uuid/pull/434
  var uuid = (stringify_byteToHex[arr[offset + 0]] + stringify_byteToHex[arr[offset + 1]] + stringify_byteToHex[arr[offset + 2]] + stringify_byteToHex[arr[offset + 3]] + '-' + stringify_byteToHex[arr[offset + 4]] + stringify_byteToHex[arr[offset + 5]] + '-' + stringify_byteToHex[arr[offset + 6]] + stringify_byteToHex[arr[offset + 7]] + '-' + stringify_byteToHex[arr[offset + 8]] + stringify_byteToHex[arr[offset + 9]] + '-' + stringify_byteToHex[arr[offset + 10]] + stringify_byteToHex[arr[offset + 11]] + stringify_byteToHex[arr[offset + 12]] + stringify_byteToHex[arr[offset + 13]] + stringify_byteToHex[arr[offset + 14]] + stringify_byteToHex[arr[offset + 15]]).toLowerCase(); // Consistency check for valid UUID.  If this throws, it's likely due to one
  // of the following:
  // - One or more input array values don't map to a hex octet (leading to
  // "undefined" in the uuid)
  // - Invalid input values for the RFC `version` or `variant` fields

  if (!dist_esm_browser_validate(uuid)) {
    throw TypeError('Stringified UUID is invalid');
  }

  return uuid;
}

/* harmony default export */ var dist_esm_browser_stringify = (stringify_stringify);
;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-retry/node_modules/uuid/dist/esm-browser/v4.js



function esm_browser_v4_v4(options, buf, offset) {
  options = options || {};
  var rnds = options.random || (options.rng || rng_rng)(); // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`

  rnds[6] = rnds[6] & 0x0f | 0x40;
  rnds[8] = rnds[8] & 0x3f | 0x80; // Copy bytes to buffer, if provided

  if (buf) {
    offset = offset || 0;

    for (var i = 0; i < 16; ++i) {
      buf[offset + i] = rnds[i];
    }

    return buf;
  }

  return dist_esm_browser_stringify(rnds);
}

/* harmony default export */ var dist_esm_browser_v4 = (esm_browser_v4_v4);
;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-retry/dist-es/util.js
const util_asSdkError = (error) => {
    if (error instanceof Error)
        return error;
    if (error instanceof Object)
        return Object.assign(new Error(), error);
    if (typeof error === "string")
        return new Error(error);
    return new Error(`AWS SDK error wrapper for ${error}`);
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-retry/dist-es/retryMiddleware.js





const retryMiddleware = (options) => (next, context) => async (args) => {
    let retryStrategy = await options.retryStrategy();
    const maxAttempts = await options.maxAttempts();
    if (isRetryStrategyV2(retryStrategy)) {
        retryStrategy = retryStrategy;
        let retryToken = await retryStrategy.acquireInitialRetryToken(context["partition_id"]);
        let lastError = new Error();
        let attempts = 0;
        let totalRetryDelay = 0;
        const { request } = args;
        if (httpRequest_HttpRequest.isInstance(request)) {
            request.headers[constants_INVOCATION_ID_HEADER] = dist_esm_browser_v4();
        }
        while (true) {
            try {
                if (httpRequest_HttpRequest.isInstance(request)) {
                    request.headers[constants_REQUEST_HEADER] = `attempt=${attempts + 1}; max=${maxAttempts}`;
                }
                const { response, output } = await next(args);
                retryStrategy.recordSuccess(retryToken);
                output.$metadata.attempts = attempts + 1;
                output.$metadata.totalRetryDelay = totalRetryDelay;
                return { response, output };
            }
            catch (e) {
                const retryErrorInfo = getRetyErrorInto(e);
                lastError = util_asSdkError(e);
                try {
                    retryToken = await retryStrategy.refreshRetryTokenForRetry(retryToken, retryErrorInfo);
                }
                catch (refreshError) {
                    if (!lastError.$metadata) {
                        lastError.$metadata = {};
                    }
                    lastError.$metadata.attempts = attempts + 1;
                    lastError.$metadata.totalRetryDelay = totalRetryDelay;
                    throw lastError;
                }
                attempts = retryToken.getRetryCount();
                const delay = retryToken.getRetryDelay();
                totalRetryDelay += delay;
                await new Promise((resolve) => setTimeout(resolve, delay));
            }
        }
    }
    else {
        retryStrategy = retryStrategy;
        if (retryStrategy?.mode)
            context.userAgent = [...(context.userAgent || []), ["cfg/retry-mode", retryStrategy.mode]];
        return retryStrategy.retry(next, args);
    }
};
const isRetryStrategyV2 = (retryStrategy) => typeof retryStrategy.acquireInitialRetryToken !== "undefined" &&
    typeof retryStrategy.refreshRetryTokenForRetry !== "undefined" &&
    typeof retryStrategy.recordSuccess !== "undefined";
const getRetyErrorInto = (error) => {
    const errorInfo = {
        errorType: getRetryErrorType(error),
    };
    const retryAfterHint = getRetryAfterHint(error.$response);
    if (retryAfterHint) {
        errorInfo.retryAfterHint = retryAfterHint;
    }
    return errorInfo;
};
const getRetryErrorType = (error) => {
    if (dist_es_isThrottlingError(error))
        return "THROTTLING";
    if (isTransientError(error))
        return "TRANSIENT";
    if (isServerError(error))
        return "SERVER_ERROR";
    return "CLIENT_ERROR";
};
const retryMiddlewareOptions = {
    name: "retryMiddleware",
    tags: ["RETRY"],
    step: "finalizeRequest",
    priority: "high",
    override: true,
};
const getRetryPlugin = (options) => ({
    applyToStack: (clientStack) => {
        clientStack.add(retryMiddleware(options), retryMiddlewareOptions);
    },
});
const getRetryAfterHint = (response) => {
    if (!httpResponse_HttpResponse.isInstance(response))
        return;
    const retryAfterHeaderName = Object.keys(response.headers).find((key) => key.toLowerCase() === "retry-after");
    if (!retryAfterHeaderName)
        return;
    const retryAfter = response.headers[retryAfterHeaderName];
    const retryAfterSeconds = Number(retryAfter);
    if (!Number.isNaN(retryAfterSeconds))
        return new Date(retryAfterSeconds * 1000);
    const retryAfterDate = new Date(retryAfter);
    return retryAfterDate;
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-retry/dist-es/index.js








;// CONCATENATED MODULE: ./node_modules/@aws-sdk/property-provider/dist-es/ProviderError.js
class ProviderError_ProviderError extends Error {
    constructor(message, tryNextLink = true) {
        super(message);
        this.tryNextLink = tryNextLink;
        this.name = "ProviderError";
        Object.setPrototypeOf(this, ProviderError_ProviderError.prototype);
    }
    static from(error, tryNextLink = true) {
        return Object.assign(new this(error.message, tryNextLink), error);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/property-provider/dist-es/CredentialsProviderError.js

class CredentialsProviderError extends (/* unused pure expression or super */ null && (ProviderError)) {
    constructor(message, tryNextLink = true) {
        super(message, tryNextLink);
        this.tryNextLink = tryNextLink;
        this.name = "CredentialsProviderError";
        Object.setPrototypeOf(this, CredentialsProviderError.prototype);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/property-provider/dist-es/TokenProviderError.js

class TokenProviderError extends (/* unused pure expression or super */ null && (ProviderError)) {
    constructor(message, tryNextLink = true) {
        super(message, tryNextLink);
        this.tryNextLink = tryNextLink;
        this.name = "TokenProviderError";
        Object.setPrototypeOf(this, TokenProviderError.prototype);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/property-provider/dist-es/chain.js

function chain(...providers) {
    return () => {
        let promise = Promise.reject(new ProviderError("No providers in chain"));
        for (const provider of providers) {
            promise = promise.catch((err) => {
                if (err?.tryNextLink) {
                    return provider();
                }
                throw err;
            });
        }
        return promise;
    };
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/property-provider/dist-es/memoize.js
const memoize = (provider, isExpired, requiresRefresh) => {
    let resolved;
    let pending;
    let hasResult;
    let isConstant = false;
    const coalesceProvider = async () => {
        if (!pending) {
            pending = provider();
        }
        try {
            resolved = await pending;
            hasResult = true;
            isConstant = false;
        }
        finally {
            pending = undefined;
        }
        return resolved;
    };
    if (isExpired === undefined) {
        return async (options) => {
            if (!hasResult || options?.forceRefresh) {
                resolved = await coalesceProvider();
            }
            return resolved;
        };
    }
    return async (options) => {
        if (!hasResult || options?.forceRefresh) {
            resolved = await coalesceProvider();
        }
        if (isConstant) {
            return resolved;
        }
        if (requiresRefresh && !requiresRefresh(resolved)) {
            isConstant = true;
            return resolved;
        }
        if (isExpired(resolved)) {
            await coalesceProvider();
            return resolved;
        }
        return resolved;
    };
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/property-provider/dist-es/index.js







;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-hex-encoding/dist-es/index.js
const SHORT_TO_HEX = {};
const HEX_TO_SHORT = {};
for (let i = 0; i < 256; i++) {
    let encodedByte = i.toString(16).toLowerCase();
    if (encodedByte.length === 1) {
        encodedByte = `0${encodedByte}`;
    }
    SHORT_TO_HEX[i] = encodedByte;
    HEX_TO_SHORT[encodedByte] = i;
}
function fromHex(encoded) {
    if (encoded.length % 2 !== 0) {
        throw new Error("Hex encoded strings must have an even number length");
    }
    const out = new Uint8Array(encoded.length / 2);
    for (let i = 0; i < encoded.length; i += 2) {
        const encodedByte = encoded.slice(i, i + 2).toLowerCase();
        if (encodedByte in HEX_TO_SHORT) {
            out[i / 2] = HEX_TO_SHORT[encodedByte];
        }
        else {
            throw new Error(`Cannot decode unrecognized sequence ${encodedByte} as hexadecimal`);
        }
    }
    return out;
}
function toHex(bytes) {
    let out = "";
    for (let i = 0; i < bytes.byteLength; i++) {
        out += SHORT_TO_HEX[bytes[i]];
    }
    return out;
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/signature-v4/dist-es/constants.js
const ALGORITHM_QUERY_PARAM = "X-Amz-Algorithm";
const CREDENTIAL_QUERY_PARAM = "X-Amz-Credential";
const AMZ_DATE_QUERY_PARAM = "X-Amz-Date";
const SIGNED_HEADERS_QUERY_PARAM = "X-Amz-SignedHeaders";
const EXPIRES_QUERY_PARAM = "X-Amz-Expires";
const SIGNATURE_QUERY_PARAM = "X-Amz-Signature";
const TOKEN_QUERY_PARAM = "X-Amz-Security-Token";
const REGION_SET_PARAM = "X-Amz-Region-Set";
const AUTH_HEADER = "authorization";
const AMZ_DATE_HEADER = AMZ_DATE_QUERY_PARAM.toLowerCase();
const DATE_HEADER = "date";
const GENERATED_HEADERS = [AUTH_HEADER, AMZ_DATE_HEADER, DATE_HEADER];
const SIGNATURE_HEADER = SIGNATURE_QUERY_PARAM.toLowerCase();
const SHA256_HEADER = "x-amz-content-sha256";
const TOKEN_HEADER = TOKEN_QUERY_PARAM.toLowerCase();
const HOST_HEADER = "host";
const ALWAYS_UNSIGNABLE_HEADERS = {
    authorization: true,
    "cache-control": true,
    connection: true,
    expect: true,
    from: true,
    "keep-alive": true,
    "max-forwards": true,
    pragma: true,
    referer: true,
    te: true,
    trailer: true,
    "transfer-encoding": true,
    upgrade: true,
    "user-agent": true,
    "x-amzn-trace-id": true,
};
const PROXY_HEADER_PATTERN = /^proxy-/;
const SEC_HEADER_PATTERN = /^sec-/;
const UNSIGNABLE_PATTERNS = (/* unused pure expression or super */ null && ([/^proxy-/i, /^sec-/i]));
const ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256";
const ALGORITHM_IDENTIFIER_V4A = "AWS4-ECDSA-P256-SHA256";
const EVENT_ALGORITHM_IDENTIFIER = "AWS4-HMAC-SHA256-PAYLOAD";
const UNSIGNED_PAYLOAD = "UNSIGNED-PAYLOAD";
const MAX_CACHE_SIZE = 50;
const KEY_TYPE_IDENTIFIER = "aws4_request";
const MAX_PRESIGNED_TTL = 60 * 60 * 24 * 7;

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/signature-v4/dist-es/credentialDerivation.js


const signingKeyCache = {};
const cacheQueue = [];
const createScope = (shortDate, region, service) => `${shortDate}/${region}/${service}/${KEY_TYPE_IDENTIFIER}`;
const getSigningKey = async (sha256Constructor, credentials, shortDate, region, service) => {
    const credsHash = await hmac(sha256Constructor, credentials.secretAccessKey, credentials.accessKeyId);
    const cacheKey = `${shortDate}:${region}:${service}:${toHex(credsHash)}:${credentials.sessionToken}`;
    if (cacheKey in signingKeyCache) {
        return signingKeyCache[cacheKey];
    }
    cacheQueue.push(cacheKey);
    while (cacheQueue.length > MAX_CACHE_SIZE) {
        delete signingKeyCache[cacheQueue.shift()];
    }
    let key = `AWS4${credentials.secretAccessKey}`;
    for (const signable of [shortDate, region, service, KEY_TYPE_IDENTIFIER]) {
        key = await hmac(sha256Constructor, key, signable);
    }
    return (signingKeyCache[cacheKey] = key);
};
const clearCredentialCache = () => {
    cacheQueue.length = 0;
    Object.keys(signingKeyCache).forEach((cacheKey) => {
        delete signingKeyCache[cacheKey];
    });
};
const hmac = (ctor, secret, data) => {
    const hash = new ctor(secret);
    hash.update(data);
    return hash.digest();
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/signature-v4/dist-es/getCanonicalHeaders.js

const getCanonicalHeaders = ({ headers }, unsignableHeaders, signableHeaders) => {
    const canonical = {};
    for (const headerName of Object.keys(headers).sort()) {
        if (headers[headerName] == undefined) {
            continue;
        }
        const canonicalHeaderName = headerName.toLowerCase();
        if (canonicalHeaderName in ALWAYS_UNSIGNABLE_HEADERS ||
            unsignableHeaders?.has(canonicalHeaderName) ||
            PROXY_HEADER_PATTERN.test(canonicalHeaderName) ||
            SEC_HEADER_PATTERN.test(canonicalHeaderName)) {
            if (!signableHeaders || (signableHeaders && !signableHeaders.has(canonicalHeaderName))) {
                continue;
            }
        }
        canonical[canonicalHeaderName] = headers[headerName].trim().replace(/\s+/g, " ");
    }
    return canonical;
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-uri-escape/dist-es/escape-uri.js
const escapeUri = (uri) => encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
const hexEncode = (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`;

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/signature-v4/dist-es/getCanonicalQuery.js


const getCanonicalQuery = ({ query = {} }) => {
    const keys = [];
    const serialized = {};
    for (const key of Object.keys(query).sort()) {
        if (key.toLowerCase() === SIGNATURE_HEADER) {
            continue;
        }
        keys.push(key);
        const value = query[key];
        if (typeof value === "string") {
            serialized[key] = `${escapeUri(key)}=${escapeUri(value)}`;
        }
        else if (Array.isArray(value)) {
            serialized[key] = value
                .slice(0)
                .sort()
                .reduce((encoded, value) => encoded.concat([`${escapeUri(key)}=${escapeUri(value)}`]), [])
                .join("&");
        }
    }
    return keys
        .map((key) => serialized[key])
        .filter((serialized) => serialized)
        .join("&");
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/is-array-buffer/dist-es/index.js
const isArrayBuffer = (arg) => (typeof ArrayBuffer === "function" && arg instanceof ArrayBuffer) ||
    Object.prototype.toString.call(arg) === "[object ArrayBuffer]";

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/signature-v4/dist-es/getPayloadHash.js



const getPayloadHash = async ({ headers, body }, hashConstructor) => {
    for (const headerName of Object.keys(headers)) {
        if (headerName.toLowerCase() === SHA256_HEADER) {
            return headers[headerName];
        }
    }
    if (body == undefined) {
        return "e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855";
    }
    else if (typeof body === "string" || ArrayBuffer.isView(body) || isArrayBuffer(body)) {
        const hashCtor = new hashConstructor();
        hashCtor.update(body);
        return toHex(await hashCtor.digest());
    }
    return UNSIGNED_PAYLOAD;
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/signature-v4/dist-es/headerUtil.js
const hasHeader = (soughtHeader, headers) => {
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)) {
        if (soughtHeader === headerName.toLowerCase()) {
            return true;
        }
    }
    return false;
};
const getHeaderValue = (soughtHeader, headers) => {
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)) {
        if (soughtHeader === headerName.toLowerCase()) {
            return headers[headerName];
        }
    }
    return undefined;
};
const deleteHeader = (soughtHeader, headers) => {
    soughtHeader = soughtHeader.toLowerCase();
    for (const headerName of Object.keys(headers)) {
        if (soughtHeader === headerName.toLowerCase()) {
            delete headers[headerName];
        }
    }
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/signature-v4/dist-es/cloneRequest.js
const cloneRequest = ({ headers, query, ...rest }) => ({
    ...rest,
    headers: { ...headers },
    query: query ? cloneRequest_cloneQuery(query) : undefined,
});
const cloneRequest_cloneQuery = (query) => Object.keys(query).reduce((carry, paramName) => {
    const param = query[paramName];
    return {
        ...carry,
        [paramName]: Array.isArray(param) ? [...param] : param,
    };
}, {});

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/signature-v4/dist-es/moveHeadersToQuery.js

const moveHeadersToQuery = (request, options = {}) => {
    const { headers, query = {} } = typeof request.clone === "function" ? request.clone() : cloneRequest(request);
    for (const name of Object.keys(headers)) {
        const lname = name.toLowerCase();
        if (lname.slice(0, 6) === "x-amz-" && !options.unhoistableHeaders?.has(lname)) {
            query[name] = headers[name];
            delete headers[name];
        }
    }
    return {
        ...request,
        headers,
        query,
    };
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/signature-v4/dist-es/prepareRequest.js


const prepareRequest = (request) => {
    request = typeof request.clone === "function" ? request.clone() : cloneRequest(request);
    for (const headerName of Object.keys(request.headers)) {
        if (GENERATED_HEADERS.indexOf(headerName.toLowerCase()) > -1) {
            delete request.headers[headerName];
        }
    }
    return request;
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/signature-v4/dist-es/utilDate.js
const iso8601 = (time) => toDate(time)
    .toISOString()
    .replace(/\.\d{3}Z$/, "Z");
const toDate = (time) => {
    if (typeof time === "number") {
        return new Date(time * 1000);
    }
    if (typeof time === "string") {
        if (Number(time)) {
            return new Date(Number(time) * 1000);
        }
        return new Date(time);
    }
    return time;
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/signature-v4/dist-es/SignatureV4.js











class SignatureV4_SignatureV4 {
    constructor({ applyChecksum, credentials, region, service, sha256, uriEscapePath = true, }) {
        this.service = service;
        this.sha256 = sha256;
        this.uriEscapePath = uriEscapePath;
        this.applyChecksum = typeof applyChecksum === "boolean" ? applyChecksum : true;
        this.regionProvider = normalizeProvider_normalizeProvider(region);
        this.credentialProvider = normalizeProvider_normalizeProvider(credentials);
    }
    async presign(originalRequest, options = {}) {
        const { signingDate = new Date(), expiresIn = 3600, unsignableHeaders, unhoistableHeaders, signableHeaders, signingRegion, signingService, } = options;
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? (await this.regionProvider());
        const { longDate, shortDate } = formatDate(signingDate);
        if (expiresIn > MAX_PRESIGNED_TTL) {
            return Promise.reject("Signature version 4 presigned URLs" + " must have an expiration date less than one week in" + " the future");
        }
        const scope = createScope(shortDate, region, signingService ?? this.service);
        const request = moveHeadersToQuery(prepareRequest(originalRequest), { unhoistableHeaders });
        if (credentials.sessionToken) {
            request.query[TOKEN_QUERY_PARAM] = credentials.sessionToken;
        }
        request.query[ALGORITHM_QUERY_PARAM] = ALGORITHM_IDENTIFIER;
        request.query[CREDENTIAL_QUERY_PARAM] = `${credentials.accessKeyId}/${scope}`;
        request.query[AMZ_DATE_QUERY_PARAM] = longDate;
        request.query[EXPIRES_QUERY_PARAM] = expiresIn.toString(10);
        const canonicalHeaders = getCanonicalHeaders(request, unsignableHeaders, signableHeaders);
        request.query[SIGNED_HEADERS_QUERY_PARAM] = getCanonicalHeaderList(canonicalHeaders);
        request.query[SIGNATURE_QUERY_PARAM] = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, await getPayloadHash(originalRequest, this.sha256)));
        return request;
    }
    async sign(toSign, options) {
        if (typeof toSign === "string") {
            return this.signString(toSign, options);
        }
        else if (toSign.headers && toSign.payload) {
            return this.signEvent(toSign, options);
        }
        else {
            return this.signRequest(toSign, options);
        }
    }
    async signEvent({ headers, payload }, { signingDate = new Date(), priorSignature, signingRegion, signingService }) {
        const region = signingRegion ?? (await this.regionProvider());
        const { shortDate, longDate } = formatDate(signingDate);
        const scope = createScope(shortDate, region, signingService ?? this.service);
        const hashedPayload = await getPayloadHash({ headers: {}, body: payload }, this.sha256);
        const hash = new this.sha256();
        hash.update(headers);
        const hashedHeaders = toHex(await hash.digest());
        const stringToSign = [
            EVENT_ALGORITHM_IDENTIFIER,
            longDate,
            scope,
            priorSignature,
            hashedHeaders,
            hashedPayload,
        ].join("\n");
        return this.signString(stringToSign, { signingDate, signingRegion: region, signingService });
    }
    async signString(stringToSign, { signingDate = new Date(), signingRegion, signingService } = {}) {
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? (await this.regionProvider());
        const { shortDate } = formatDate(signingDate);
        const hash = new this.sha256(await this.getSigningKey(credentials, region, shortDate, signingService));
        hash.update(stringToSign);
        return toHex(await hash.digest());
    }
    async signRequest(requestToSign, { signingDate = new Date(), signableHeaders, unsignableHeaders, signingRegion, signingService, } = {}) {
        const credentials = await this.credentialProvider();
        this.validateResolvedCredentials(credentials);
        const region = signingRegion ?? (await this.regionProvider());
        const request = prepareRequest(requestToSign);
        const { longDate, shortDate } = formatDate(signingDate);
        const scope = createScope(shortDate, region, signingService ?? this.service);
        request.headers[AMZ_DATE_HEADER] = longDate;
        if (credentials.sessionToken) {
            request.headers[TOKEN_HEADER] = credentials.sessionToken;
        }
        const payloadHash = await getPayloadHash(request, this.sha256);
        if (!hasHeader(SHA256_HEADER, request.headers) && this.applyChecksum) {
            request.headers[SHA256_HEADER] = payloadHash;
        }
        const canonicalHeaders = getCanonicalHeaders(request, unsignableHeaders, signableHeaders);
        const signature = await this.getSignature(longDate, scope, this.getSigningKey(credentials, region, shortDate, signingService), this.createCanonicalRequest(request, canonicalHeaders, payloadHash));
        request.headers[AUTH_HEADER] =
            `${ALGORITHM_IDENTIFIER} ` +
                `Credential=${credentials.accessKeyId}/${scope}, ` +
                `SignedHeaders=${getCanonicalHeaderList(canonicalHeaders)}, ` +
                `Signature=${signature}`;
        return request;
    }
    createCanonicalRequest(request, canonicalHeaders, payloadHash) {
        const sortedHeaders = Object.keys(canonicalHeaders).sort();
        return `${request.method}
${this.getCanonicalPath(request)}
${getCanonicalQuery(request)}
${sortedHeaders.map((name) => `${name}:${canonicalHeaders[name]}`).join("\n")}

${sortedHeaders.join(";")}
${payloadHash}`;
    }
    async createStringToSign(longDate, credentialScope, canonicalRequest) {
        const hash = new this.sha256();
        hash.update(canonicalRequest);
        const hashedRequest = await hash.digest();
        return `${ALGORITHM_IDENTIFIER}
${longDate}
${credentialScope}
${toHex(hashedRequest)}`;
    }
    getCanonicalPath({ path }) {
        if (this.uriEscapePath) {
            const normalizedPathSegments = [];
            for (const pathSegment of path.split("/")) {
                if (pathSegment?.length === 0)
                    continue;
                if (pathSegment === ".")
                    continue;
                if (pathSegment === "..") {
                    normalizedPathSegments.pop();
                }
                else {
                    normalizedPathSegments.push(pathSegment);
                }
            }
            const normalizedPath = `${path?.startsWith("/") ? "/" : ""}${normalizedPathSegments.join("/")}${normalizedPathSegments.length > 0 && path?.endsWith("/") ? "/" : ""}`;
            const doubleEncoded = encodeURIComponent(normalizedPath);
            return doubleEncoded.replace(/%2F/g, "/");
        }
        return path;
    }
    async getSignature(longDate, credentialScope, keyPromise, canonicalRequest) {
        const stringToSign = await this.createStringToSign(longDate, credentialScope, canonicalRequest);
        const hash = new this.sha256(await keyPromise);
        hash.update(stringToSign);
        return toHex(await hash.digest());
    }
    getSigningKey(credentials, region, shortDate, service) {
        return getSigningKey(this.sha256, credentials, shortDate, region, service || this.service);
    }
    validateResolvedCredentials(credentials) {
        if (typeof credentials !== "object" ||
            typeof credentials.accessKeyId !== "string" ||
            typeof credentials.secretAccessKey !== "string") {
            throw new Error("Resolved credential object is not valid");
        }
    }
}
const formatDate = (now) => {
    const longDate = iso8601(now).replace(/[\-:]/g, "");
    return {
        longDate,
        shortDate: longDate.slice(0, 8),
    };
};
const getCanonicalHeaderList = (headers) => Object.keys(headers).sort().join(";");

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/signature-v4/dist-es/index.js








;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-signing/dist-es/configurations.js



const CREDENTIAL_EXPIRE_WINDOW = 300000;
const resolveAwsAuthConfig = (input) => {
    const normalizedCreds = input.credentials
        ? normalizeCredentialProvider(input.credentials)
        : input.credentialDefaultProvider(input);
    const { signingEscapePath = true, systemClockOffset = input.systemClockOffset || 0, sha256 } = input;
    let signer;
    if (input.signer) {
        signer = normalizeProvider_normalizeProvider(input.signer);
    }
    else if (input.regionInfoProvider) {
        signer = () => normalizeProvider_normalizeProvider(input.region)()
            .then(async (region) => [
            (await input.regionInfoProvider(region, {
                useFipsEndpoint: await input.useFipsEndpoint(),
                useDualstackEndpoint: await input.useDualstackEndpoint(),
            })) || {},
            region,
        ])
            .then(([regionInfo, region]) => {
            const { signingRegion, signingService } = regionInfo;
            input.signingRegion = input.signingRegion || signingRegion || region;
            input.signingName = input.signingName || signingService || input.serviceId;
            const params = {
                ...input,
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256,
                uriEscapePath: signingEscapePath,
            };
            const SignerCtor = input.signerConstructor || SignatureV4_SignatureV4;
            return new SignerCtor(params);
        });
    }
    else {
        signer = async (authScheme) => {
            authScheme = Object.assign({}, {
                name: "sigv4",
                signingName: input.signingName || input.defaultSigningName,
                signingRegion: await normalizeProvider_normalizeProvider(input.region)(),
                properties: {},
            }, authScheme);
            const signingRegion = authScheme.signingRegion;
            const signingService = authScheme.signingName;
            input.signingRegion = input.signingRegion || signingRegion;
            input.signingName = input.signingName || signingService || input.serviceId;
            const params = {
                ...input,
                credentials: normalizedCreds,
                region: input.signingRegion,
                service: input.signingName,
                sha256,
                uriEscapePath: signingEscapePath,
            };
            const SignerCtor = input.signerConstructor || SignatureV4_SignatureV4;
            return new SignerCtor(params);
        };
    }
    return {
        ...input,
        systemClockOffset,
        signingEscapePath,
        credentials: normalizedCreds,
        signer,
    };
};
const resolveSigV4AuthConfig = (input) => {
    const normalizedCreds = input.credentials
        ? normalizeCredentialProvider(input.credentials)
        : input.credentialDefaultProvider(input);
    const { signingEscapePath = true, systemClockOffset = input.systemClockOffset || 0, sha256 } = input;
    let signer;
    if (input.signer) {
        signer = normalizeProvider(input.signer);
    }
    else {
        signer = normalizeProvider(new SignatureV4({
            credentials: normalizedCreds,
            region: input.region,
            service: input.signingName,
            sha256,
            uriEscapePath: signingEscapePath,
        }));
    }
    return {
        ...input,
        systemClockOffset,
        signingEscapePath,
        credentials: normalizedCreds,
        signer,
    };
};
const normalizeCredentialProvider = (credentials) => {
    if (typeof credentials === "function") {
        return memoize(credentials, (credentials) => credentials.expiration !== undefined &&
            credentials.expiration.getTime() - Date.now() < CREDENTIAL_EXPIRE_WINDOW, (credentials) => credentials.expiration !== undefined);
    }
    return normalizeProvider_normalizeProvider(credentials);
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-signing/dist-es/utils/getSkewCorrectedDate.js
const getSkewCorrectedDate = (systemClockOffset) => new Date(Date.now() + systemClockOffset);

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-signing/dist-es/utils/isClockSkewed.js

const isClockSkewed = (clockTime, systemClockOffset) => Math.abs(getSkewCorrectedDate(systemClockOffset).getTime() - clockTime) >= 300000;

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-signing/dist-es/utils/getUpdatedSystemClockOffset.js

const getUpdatedSystemClockOffset = (clockTime, currentSystemClockOffset) => {
    const clockTimeInMs = Date.parse(clockTime);
    if (isClockSkewed(clockTimeInMs, currentSystemClockOffset)) {
        return clockTimeInMs - Date.now();
    }
    return currentSystemClockOffset;
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-signing/dist-es/middleware.js



const awsAuthMiddleware = (options) => (next, context) => async function (args) {
    if (!httpRequest_HttpRequest.isInstance(args.request))
        return next(args);
    const authScheme = context.endpointV2?.properties?.authSchemes?.[0];
    const multiRegionOverride = authScheme?.name === "sigv4a" ? authScheme?.signingRegionSet?.join(",") : undefined;
    const signer = await options.signer(authScheme);
    const output = await next({
        ...args,
        request: await signer.sign(args.request, {
            signingDate: getSkewCorrectedDate(options.systemClockOffset),
            signingRegion: multiRegionOverride || context["signing_region"],
            signingService: context["signing_service"],
        }),
    }).catch((error) => {
        const serverTime = error.ServerTime ?? getDateHeader(error.$response);
        if (serverTime) {
            options.systemClockOffset = getUpdatedSystemClockOffset(serverTime, options.systemClockOffset);
        }
        throw error;
    });
    const dateHeader = getDateHeader(output.response);
    if (dateHeader) {
        options.systemClockOffset = getUpdatedSystemClockOffset(dateHeader, options.systemClockOffset);
    }
    return output;
};
const getDateHeader = (response) => httpResponse_HttpResponse.isInstance(response) ? response.headers?.date ?? response.headers?.Date : undefined;
const awsAuthMiddlewareOptions = {
    name: "awsAuthMiddleware",
    tags: ["SIGNATURE", "AWSAUTH"],
    relation: "after",
    toMiddleware: "retryMiddleware",
    override: true,
};
const getAwsAuthPlugin = (options) => ({
    applyToStack: (clientStack) => {
        clientStack.addRelativeTo(awsAuthMiddleware(options), awsAuthMiddlewareOptions);
    },
});
const getSigV4AuthPlugin = (/* unused pure expression or super */ null && (getAwsAuthPlugin));

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-signing/dist-es/index.js



;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-user-agent/dist-es/configurations.js
function resolveUserAgentConfig(input) {
    return {
        ...input,
        customUserAgent: typeof input.customUserAgent === "string" ? [[input.customUserAgent]] : input.customUserAgent,
    };
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-user-agent/dist-es/constants.js
const USER_AGENT = "user-agent";
const X_AMZ_USER_AGENT = "x-amz-user-agent";
const SPACE = " ";
const UA_ESCAPE_REGEX = /[^\!\#\$\%\&\'\*\+\-\.\^\_\`\|\~\d\w]/g;

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-user-agent/dist-es/user-agent-middleware.js


const userAgentMiddleware = (options) => (next, context) => async (args) => {
    const { request } = args;
    if (!httpRequest_HttpRequest.isInstance(request))
        return next(args);
    const { headers } = request;
    const userAgent = context?.userAgent?.map(escapeUserAgent) || [];
    const defaultUserAgent = (await options.defaultUserAgentProvider()).map(escapeUserAgent);
    const customUserAgent = options?.customUserAgent?.map(escapeUserAgent) || [];
    const sdkUserAgentValue = [...defaultUserAgent, ...userAgent, ...customUserAgent].join(SPACE);
    const normalUAValue = [
        ...defaultUserAgent.filter((section) => section.startsWith("aws-sdk-")),
        ...customUserAgent,
    ].join(SPACE);
    if (options.runtime !== "browser") {
        if (normalUAValue) {
            headers[X_AMZ_USER_AGENT] = headers[X_AMZ_USER_AGENT]
                ? `${headers[USER_AGENT]} ${normalUAValue}`
                : normalUAValue;
        }
        headers[USER_AGENT] = sdkUserAgentValue;
    }
    else {
        headers[X_AMZ_USER_AGENT] = sdkUserAgentValue;
    }
    return next({
        ...args,
        request,
    });
};
const escapeUserAgent = ([name, version]) => {
    const prefixSeparatorIndex = name.indexOf("/");
    const prefix = name.substring(0, prefixSeparatorIndex);
    let uaName = name.substring(prefixSeparatorIndex + 1);
    if (prefix === "api") {
        uaName = uaName.toLowerCase();
    }
    return [prefix, uaName, version]
        .filter((item) => item && item.length > 0)
        .map((item) => item?.replace(UA_ESCAPE_REGEX, "_"))
        .join("/");
};
const getUserAgentMiddlewareOptions = {
    name: "getUserAgentMiddleware",
    step: "build",
    priority: "low",
    tags: ["SET_USER_AGENT", "USER_AGENT"],
    override: true,
};
const getUserAgentPlugin = (config) => ({
    applyToStack: (clientStack) => {
        clientStack.add(userAgentMiddleware(config), getUserAgentMiddlewareOptions);
    },
});

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/middleware-user-agent/dist-es/index.js



;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/endpoint/EndpointParameters.js
const resolveClientEndpointParameters = (options) => {
    return {
        ...options,
        useDualstackEndpoint: options.useDualstackEndpoint ?? false,
        useFipsEndpoint: options.useFipsEndpoint ?? false,
        defaultSigningName: "secretsmanager",
    };
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/package.json
var package_namespaceObject = {"i8":"3.241.0"};
// EXTERNAL MODULE: ./node_modules/@aws-crypto/sha256-browser/build/index.js
var build = __webpack_require__(77643);
;// CONCATENATED MODULE: ./node_modules/@aws-sdk/querystring-builder/dist-es/index.js

function buildQueryString(query) {
    const parts = [];
    for (let key of Object.keys(query).sort()) {
        const value = query[key];
        key = escapeUri(key);
        if (Array.isArray(value)) {
            for (let i = 0, iLen = value.length; i < iLen; i++) {
                parts.push(`${key}=${escapeUri(value[i])}`);
            }
        }
        else {
            let qsEntry = key;
            if (value || typeof value === "string") {
                qsEntry += `=${escapeUri(value)}`;
            }
            parts.push(qsEntry);
        }
    }
    return parts.join("&");
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/fetch-http-handler/dist-es/request-timeout.js
function requestTimeout(timeoutInMs = 0) {
    return new Promise((resolve, reject) => {
        if (timeoutInMs) {
            setTimeout(() => {
                const timeoutError = new Error(`Request did not complete within ${timeoutInMs} ms`);
                timeoutError.name = "TimeoutError";
                reject(timeoutError);
            }, timeoutInMs);
        }
    });
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/fetch-http-handler/dist-es/fetch-http-handler.js



class FetchHttpHandler {
    constructor(options) {
        if (typeof options === "function") {
            this.configProvider = options().then((opts) => opts || {});
        }
        else {
            this.config = options ?? {};
            this.configProvider = Promise.resolve(this.config);
        }
    }
    destroy() {
    }
    async handle(request, { abortSignal } = {}) {
        if (!this.config) {
            this.config = await this.configProvider;
        }
        const requestTimeoutInMs = this.config.requestTimeout;
        if (abortSignal?.aborted) {
            const abortError = new Error("Request aborted");
            abortError.name = "AbortError";
            return Promise.reject(abortError);
        }
        let path = request.path;
        if (request.query) {
            const queryString = buildQueryString(request.query);
            if (queryString) {
                path += `?${queryString}`;
            }
        }
        const { port, method } = request;
        const url = `${request.protocol}//${request.hostname}${port ? `:${port}` : ""}${path}`;
        const body = method === "GET" || method === "HEAD" ? undefined : request.body;
        const requestOptions = {
            body,
            headers: new Headers(request.headers),
            method: method,
        };
        if (typeof AbortController !== "undefined") {
            requestOptions["signal"] = abortSignal;
        }
        const fetchRequest = new Request(url, requestOptions);
        const raceOfPromises = [
            fetch(fetchRequest).then((response) => {
                const fetchHeaders = response.headers;
                const transformedHeaders = {};
                for (const pair of fetchHeaders.entries()) {
                    transformedHeaders[pair[0]] = pair[1];
                }
                const hasReadableStream = response.body !== undefined;
                if (!hasReadableStream) {
                    return response.blob().then((body) => ({
                        response: new httpResponse_HttpResponse({
                            headers: transformedHeaders,
                            statusCode: response.status,
                            body,
                        }),
                    }));
                }
                return {
                    response: new httpResponse_HttpResponse({
                        headers: transformedHeaders,
                        statusCode: response.status,
                        body: response.body,
                    }),
                };
            }),
            requestTimeout(requestTimeoutInMs),
        ];
        if (abortSignal) {
            raceOfPromises.push(new Promise((resolve, reject) => {
                abortSignal.onabort = () => {
                    const abortError = new Error("Request aborted");
                    abortError.name = "AbortError";
                    reject(abortError);
                };
            }));
        }
        return Promise.race(raceOfPromises);
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-base64/dist-es/constants.browser.js
const alphabetByEncoding = {};
const alphabetByValue = new Array(64);
for (let i = 0, start = "A".charCodeAt(0), limit = "Z".charCodeAt(0); i + start <= limit; i++) {
    const char = String.fromCharCode(i + start);
    alphabetByEncoding[char] = i;
    alphabetByValue[i] = char;
}
for (let i = 0, start = "a".charCodeAt(0), limit = "z".charCodeAt(0); i + start <= limit; i++) {
    const char = String.fromCharCode(i + start);
    const index = i + 26;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
for (let i = 0; i < 10; i++) {
    alphabetByEncoding[i.toString(10)] = i + 52;
    const char = i.toString(10);
    const index = i + 52;
    alphabetByEncoding[char] = index;
    alphabetByValue[index] = char;
}
alphabetByEncoding["+"] = 62;
alphabetByValue[62] = "+";
alphabetByEncoding["/"] = 63;
alphabetByValue[63] = "/";
const bitsPerLetter = 6;
const bitsPerByte = 8;
const maxLetterValue = 0b111111;


;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-base64/dist-es/fromBase64.browser.js

const fromBase64 = (input) => {
    let totalByteLength = (input.length / 4) * 3;
    if (input.slice(-2) === "==") {
        totalByteLength -= 2;
    }
    else if (input.slice(-1) === "=") {
        totalByteLength--;
    }
    const out = new ArrayBuffer(totalByteLength);
    const dataView = new DataView(out);
    for (let i = 0; i < input.length; i += 4) {
        let bits = 0;
        let bitLength = 0;
        for (let j = i, limit = i + 3; j <= limit; j++) {
            if (input[j] !== "=") {
                if (!(input[j] in alphabetByEncoding)) {
                    throw new TypeError(`Invalid character ${input[j]} in base64 string.`);
                }
                bits |= alphabetByEncoding[input[j]] << ((limit - j) * bitsPerLetter);
                bitLength += bitsPerLetter;
            }
            else {
                bits >>= bitsPerLetter;
            }
        }
        const chunkOffset = (i / 4) * 3;
        bits >>= bitLength % bitsPerByte;
        const byteLength = Math.floor(bitLength / bitsPerByte);
        for (let k = 0; k < byteLength; k++) {
            const offset = (byteLength - k - 1) * bitsPerByte;
            dataView.setUint8(chunkOffset + k, (bits & (255 << offset)) >> offset);
        }
    }
    return new Uint8Array(out);
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-base64/dist-es/toBase64.browser.js

function toBase64(input) {
    let str = "";
    for (let i = 0; i < input.length; i += 3) {
        let bits = 0;
        let bitLength = 0;
        for (let j = i, limit = Math.min(i + 3, input.length); j < limit; j++) {
            bits |= input[j] << ((limit - j - 1) * bitsPerByte);
            bitLength += bitsPerByte;
        }
        const bitClusterCount = Math.ceil(bitLength / bitsPerLetter);
        bits <<= bitClusterCount * bitsPerLetter - bitLength;
        for (let k = 1; k <= bitClusterCount; k++) {
            const offset = (bitClusterCount - k) * bitsPerLetter;
            str += alphabetByValue[(bits & (maxLetterValue << offset)) >> offset];
        }
        str += "==".slice(0, 4 - bitClusterCount);
    }
    return str;
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-base64/dist-es/index.js



;// CONCATENATED MODULE: ./node_modules/@aws-sdk/fetch-http-handler/dist-es/stream-collector.js

const streamCollector = (stream) => {
    if (typeof Blob === "function" && stream instanceof Blob) {
        return collectBlob(stream);
    }
    return collectStream(stream);
};
async function collectBlob(blob) {
    const base64 = await readToBase64(blob);
    const arrayBuffer = fromBase64(base64);
    return new Uint8Array(arrayBuffer);
}
async function collectStream(stream) {
    let res = new Uint8Array(0);
    const reader = stream.getReader();
    let isDone = false;
    while (!isDone) {
        const { done, value } = await reader.read();
        if (value) {
            const prior = res;
            res = new Uint8Array(prior.length + value.length);
            res.set(prior);
            res.set(value, prior.length);
        }
        isDone = done;
    }
    return res;
}
function readToBase64(blob) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
            if (reader.readyState !== 2) {
                return reject(new Error("Reader aborted too early"));
            }
            const result = (reader.result ?? "");
            const commaIndex = result.indexOf(",");
            const dataOffset = commaIndex > -1 ? commaIndex + 1 : result.length;
            resolve(result.substring(dataOffset));
        };
        reader.onabort = () => reject(new Error("Read aborted"));
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(blob);
    });
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/fetch-http-handler/dist-es/index.js



;// CONCATENATED MODULE: ./node_modules/@aws-sdk/invalid-dependency/dist-es/invalidProvider.js
const invalidProvider = (message) => () => Promise.reject(message);

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-body-length-browser/dist-es/calculateBodyLength.js
const calculateBodyLength = (body) => {
    if (typeof body === "string") {
        let len = body.length;
        for (let i = len - 1; i >= 0; i--) {
            const code = body.charCodeAt(i);
            if (code > 0x7f && code <= 0x7ff)
                len++;
            else if (code > 0x7ff && code <= 0xffff)
                len += 2;
            if (code >= 0xdc00 && code <= 0xdfff)
                i--;
        }
        return len;
    }
    else if (typeof body.byteLength === "number") {
        return body.byteLength;
    }
    else if (typeof body.size === "number") {
        return body.size;
    }
    throw new Error(`Body Length computation failed for ${body}`);
};

// EXTERNAL MODULE: ./node_modules/bowser/es5.js
var es5 = __webpack_require__(51206);
var es5_default = /*#__PURE__*/__webpack_require__.n(es5);
;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-user-agent-browser/dist-es/index.js

const defaultUserAgent = ({ serviceId, clientVersion }) => async () => {
    const parsedUA = typeof window !== "undefined" && window?.navigator?.userAgent
        ? es5_default().parse(window.navigator.userAgent)
        : undefined;
    const sections = [
        ["aws-sdk-js", clientVersion],
        [`os/${parsedUA?.os?.name || "other"}`, parsedUA?.os?.version],
        ["lang/js"],
        ["md/browser", `${parsedUA?.browser?.name ?? "unknown"}_${parsedUA?.browser?.version ?? "unknown"}`],
    ];
    if (serviceId) {
        sections.push([`api/${serviceId}`, clientVersion]);
    }
    return sections;
};

// EXTERNAL MODULE: ./node_modules/@aws-sdk/util-utf8-browser/dist-es/index.js + 2 modules
var dist_es = __webpack_require__(19193);
;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/lib/aws/partitions.json
var partitions_namespaceObject = JSON.parse('{"partitions":[{"id":"aws","outputs":{"dnsSuffix":"amazonaws.com","dualStackDnsSuffix":"api.aws","name":"aws","supportsDualStack":true,"supportsFIPS":true},"regionRegex":"^(us|eu|ap|sa|ca|me|af)\\\\-\\\\w+\\\\-\\\\d+$","regions":{"af-south-1":{"description":"Africa (Cape Town)"},"ap-east-1":{"description":"Asia Pacific (Hong Kong)"},"ap-northeast-1":{"description":"Asia Pacific (Tokyo)"},"ap-northeast-2":{"description":"Asia Pacific (Seoul)"},"ap-northeast-3":{"description":"Asia Pacific (Osaka)"},"ap-south-1":{"description":"Asia Pacific (Mumbai)"},"ap-south-2":{"description":"Asia Pacific (Hyderabad)"},"ap-southeast-1":{"description":"Asia Pacific (Singapore)"},"ap-southeast-2":{"description":"Asia Pacific (Sydney)"},"ap-southeast-3":{"description":"Asia Pacific (Jakarta)"},"aws-global":{"description":"AWS Standard global region"},"ca-central-1":{"description":"Canada (Central)"},"eu-central-1":{"description":"Europe (Frankfurt)"},"eu-central-2":{"description":"Europe (Zurich)"},"eu-north-1":{"description":"Europe (Stockholm)"},"eu-south-1":{"description":"Europe (Milan)"},"eu-south-2":{"description":"Europe (Spain)"},"eu-west-1":{"description":"Europe (Ireland)"},"eu-west-2":{"description":"Europe (London)"},"eu-west-3":{"description":"Europe (Paris)"},"me-central-1":{"description":"Middle East (UAE)"},"me-south-1":{"description":"Middle East (Bahrain)"},"sa-east-1":{"description":"South America (São Paulo)"},"us-east-1":{"description":"US East (N. Virginia)"},"us-east-2":{"description":"US East (Ohio)"},"us-west-1":{"description":"US West (N. California)"},"us-west-2":{"description":"US West (Oregon)"}}},{"id":"aws-cn","outputs":{"dnsSuffix":"amazonaws.com.cn","dualStackDnsSuffix":"api.amazonwebservices.com.cn","name":"aws-cn","supportsDualStack":true,"supportsFIPS":true},"regionRegex":"^cn\\\\-\\\\w+\\\\-\\\\d+$","regions":{"aws-cn-global":{"description":"AWS China global region"},"cn-north-1":{"description":"China (Beijing)"},"cn-northwest-1":{"description":"China (Ningxia)"}}},{"id":"aws-us-gov","outputs":{"dnsSuffix":"amazonaws.com","dualStackDnsSuffix":"api.aws","name":"aws-us-gov","supportsDualStack":true,"supportsFIPS":true},"regionRegex":"^us\\\\-gov\\\\-\\\\w+\\\\-\\\\d+$","regions":{"aws-us-gov-global":{"description":"AWS GovCloud (US) global region"},"us-gov-east-1":{"description":"AWS GovCloud (US-East)"},"us-gov-west-1":{"description":"AWS GovCloud (US-West)"}}},{"id":"aws-iso","outputs":{"dnsSuffix":"c2s.ic.gov","dualStackDnsSuffix":"c2s.ic.gov","name":"aws-iso","supportsDualStack":false,"supportsFIPS":true},"regionRegex":"^us\\\\-iso\\\\-\\\\w+\\\\-\\\\d+$","regions":{"aws-iso-global":{"description":"AWS ISO (US) global region"},"us-iso-east-1":{"description":"US ISO East"},"us-iso-west-1":{"description":"US ISO WEST"}}},{"id":"aws-iso-b","outputs":{"dnsSuffix":"sc2s.sgov.gov","dualStackDnsSuffix":"sc2s.sgov.gov","name":"aws-iso-b","supportsDualStack":false,"supportsFIPS":true},"regionRegex":"^us\\\\-isob\\\\-\\\\w+\\\\-\\\\d+$","regions":{"aws-iso-b-global":{"description":"AWS ISOB (US) global region"},"us-isob-east-1":{"description":"US ISOB East (Ohio)"}}}],"version":"1.1"}');
;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/lib/aws/partition.js

const { partitions } = partitions_namespaceObject;
const DEFAULT_PARTITION = partitions.find((partition) => partition.id === "aws");
const partition = (value) => {
    for (const partition of partitions) {
        const { regions, outputs } = partition;
        for (const [region, regionData] of Object.entries(regions)) {
            if (region === value) {
                return {
                    ...outputs,
                    ...regionData,
                };
            }
        }
    }
    for (const partition of partitions) {
        const { regionRegex, outputs } = partition;
        if (new RegExp(regionRegex).test(value)) {
            return {
                ...outputs,
            };
        }
    }
    if (!DEFAULT_PARTITION) {
        throw new Error("Provided region was not found in the partition array or regex," +
            " and default partition with id 'aws' doesn't exist.");
    }
    return {
        ...DEFAULT_PARTITION.outputs,
    };
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/debug/debugId.js
const debugId = "endpoints";

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/debug/toDebugString.js
function toDebugString(input) {
    if (typeof input !== "object" || input == null) {
        return input;
    }
    if ("ref" in input) {
        return `$${toDebugString(input.ref)}`;
    }
    if ("fn" in input) {
        return `${input.fn}(${(input.argv || []).map(toDebugString).join(", ")})`;
    }
    return JSON.stringify(input, null, 2);
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/types/EndpointError.js
class EndpointError extends Error {
    constructor(message) {
        super(message);
        this.name = "EndpointError";
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/types/index.js







;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/lib/isIpAddress.js
const IP_V4_REGEX = new RegExp(`^(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}$`);
const isIpAddress = (value) => IP_V4_REGEX.test(value) || (value.startsWith("[") && value.endsWith("]"));

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/lib/isValidHostLabel.js
const VALID_HOST_LABEL_REGEX = new RegExp(`^(?!.*-$)(?!-)[a-zA-Z0-9-]{1,63}$`);
const isValidHostLabel = (value, allowSubDomains = false) => {
    if (!allowSubDomains) {
        return VALID_HOST_LABEL_REGEX.test(value);
    }
    const labels = value.split(".");
    for (const label of labels) {
        if (!isValidHostLabel(label)) {
            return false;
        }
    }
    return true;
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/lib/aws/isVirtualHostableS3Bucket.js


const isVirtualHostableS3Bucket = (value, allowSubDomains = false) => {
    if (allowSubDomains) {
        for (const label of value.split(".")) {
            if (!isVirtualHostableS3Bucket(label)) {
                return false;
            }
        }
        return true;
    }
    if (!isValidHostLabel(value)) {
        return false;
    }
    if (value.length < 3 || value.length > 63) {
        return false;
    }
    if (value !== value.toLowerCase()) {
        return false;
    }
    if (isIpAddress(value)) {
        return false;
    }
    return true;
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/lib/aws/parseArn.js
const parseArn = (value) => {
    const segments = value.split(":");
    if (segments.length < 6)
        return null;
    const [arn, partition, service, region, accountId, ...resourceId] = segments;
    if (arn !== "arn" || partition === "" || service === "" || resourceId[0] === "")
        return null;
    return {
        partition,
        service,
        region,
        accountId,
        resourceId: resourceId[0].includes("/") ? resourceId[0].split("/") : resourceId,
    };
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/lib/aws/index.js




;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/lib/booleanEquals.js
const booleanEquals = (value1, value2) => value1 === value2;

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/lib/getAttrPathList.js

const getAttrPathList = (path) => {
    const parts = path.split(".");
    const pathList = [];
    for (const part of parts) {
        const squareBracketIndex = part.indexOf("[");
        if (squareBracketIndex !== -1) {
            if (part.indexOf("]") !== part.length - 1) {
                throw new EndpointError(`Path: '${path}' does not end with ']'`);
            }
            const arrayIndex = part.slice(squareBracketIndex + 1, -1);
            if (Number.isNaN(parseInt(arrayIndex))) {
                throw new EndpointError(`Invalid array index: '${arrayIndex}' in path: '${path}'`);
            }
            if (squareBracketIndex !== 0) {
                pathList.push(part.slice(0, squareBracketIndex));
            }
            pathList.push(arrayIndex);
        }
        else {
            pathList.push(part);
        }
    }
    return pathList;
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/lib/getAttr.js


const getAttr = (value, path) => getAttrPathList(path).reduce((acc, index) => {
    if (typeof acc !== "object") {
        throw new EndpointError(`Index '${index}' in '${path}' not found in '${JSON.stringify(value)}'`);
    }
    else if (Array.isArray(acc)) {
        return acc[parseInt(index)];
    }
    return acc[index];
}, value);

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/lib/isSet.js
const isSet = (value) => value != null;

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/lib/not.js
const not = (value) => !value;

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/types/dist-es/endpoint.js
var EndpointURLScheme;
(function (EndpointURLScheme) {
    EndpointURLScheme["HTTP"] = "http";
    EndpointURLScheme["HTTPS"] = "https";
})(EndpointURLScheme || (EndpointURLScheme = {}));

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/types/dist-es/index.js


























;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/lib/parseURL.js


const DEFAULT_PORTS = {
    [EndpointURLScheme.HTTP]: 80,
    [EndpointURLScheme.HTTPS]: 443,
};
const parseURL = (value) => {
    const whatwgURL = (() => {
        try {
            if (value instanceof URL) {
                return value;
            }
            if (typeof value === "object" && "hostname" in value) {
                const { hostname, port, protocol = "", path = "", query = {} } = value;
                const url = new URL(`${protocol}//${hostname}${port ? `:${port}` : ""}${path}`);
                url.search = Object.entries(query)
                    .map(([k, v]) => `${k}=${v}`)
                    .join("&");
                return url;
            }
            return new URL(value);
        }
        catch (error) {
            return null;
        }
    })();
    if (!whatwgURL) {
        console.error(`Unable to parse ${JSON.stringify(value)} as a whatwg URL.`);
        return null;
    }
    const urlString = whatwgURL.href;
    const { host, hostname, pathname, protocol, search } = whatwgURL;
    if (search) {
        return null;
    }
    const scheme = protocol.slice(0, -1);
    if (!Object.values(EndpointURLScheme).includes(scheme)) {
        return null;
    }
    const isIp = isIpAddress(hostname);
    const inputContainsDefaultPort = urlString.includes(`${host}:${DEFAULT_PORTS[scheme]}`) ||
        (typeof value === "string" && value.includes(`${host}:${DEFAULT_PORTS[scheme]}`));
    const authority = `${host}${inputContainsDefaultPort ? `:${DEFAULT_PORTS[scheme]}` : ``}`;
    return {
        scheme,
        authority,
        path: pathname,
        normalizedPath: pathname.endsWith("/") ? pathname : `${pathname}/`,
        isIp,
    };
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/lib/stringEquals.js
const stringEquals = (value1, value2) => value1 === value2;

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/lib/substring.js
const substring = (input, start, stop, reverse) => {
    if (start >= stop || input.length < stop) {
        return null;
    }
    if (!reverse) {
        return input.substring(start, stop);
    }
    return input.substring(input.length - stop, input.length - start);
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/lib/uriEncode.js
const uriEncode = (value) => encodeURIComponent(value).replace(/[!*'()]/g, (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`);

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/lib/index.js











;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/utils/evaluateTemplate.js

const evaluateTemplate = (template, options) => {
    const evaluatedTemplateArr = [];
    const templateContext = {
        ...options.endpointParams,
        ...options.referenceRecord,
    };
    let currentIndex = 0;
    while (currentIndex < template.length) {
        const openingBraceIndex = template.indexOf("{", currentIndex);
        if (openingBraceIndex === -1) {
            evaluatedTemplateArr.push(template.slice(currentIndex));
            break;
        }
        evaluatedTemplateArr.push(template.slice(currentIndex, openingBraceIndex));
        const closingBraceIndex = template.indexOf("}", openingBraceIndex);
        if (closingBraceIndex === -1) {
            evaluatedTemplateArr.push(template.slice(openingBraceIndex));
            break;
        }
        if (template[openingBraceIndex + 1] === "{" && template[closingBraceIndex + 1] === "}") {
            evaluatedTemplateArr.push(template.slice(openingBraceIndex + 1, closingBraceIndex));
            currentIndex = closingBraceIndex + 2;
        }
        const parameterName = template.substring(openingBraceIndex + 1, closingBraceIndex);
        if (parameterName.includes("#")) {
            const [refName, attrName] = parameterName.split("#");
            evaluatedTemplateArr.push(getAttr(templateContext[refName], attrName));
        }
        else {
            evaluatedTemplateArr.push(templateContext[parameterName]);
        }
        currentIndex = closingBraceIndex + 1;
    }
    return evaluatedTemplateArr.join("");
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/utils/getReferenceValue.js
const getReferenceValue = ({ ref }, options) => {
    const referenceRecord = {
        ...options.endpointParams,
        ...options.referenceRecord,
    };
    return referenceRecord[ref];
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/utils/evaluateExpression.js




const evaluateExpression = (obj, keyName, options) => {
    if (typeof obj === "string") {
        return evaluateTemplate(obj, options);
    }
    else if (obj["fn"]) {
        return callFunction(obj, options);
    }
    else if (obj["ref"]) {
        return getReferenceValue(obj, options);
    }
    throw new EndpointError(`'${keyName}': ${String(obj)} is not a string, function or reference.`);
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/utils/callFunction.js


const callFunction = ({ fn, argv }, options) => {
    const evaluatedArgs = argv.map((arg) => ["boolean", "number"].includes(typeof arg) ? arg : evaluateExpression(arg, "arg", options));
    return fn.split(".").reduce((acc, key) => acc[key], lib_namespaceObject)(...evaluatedArgs);
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/utils/evaluateCondition.js



const evaluateCondition = ({ assign, ...fnArgs }, options) => {
    if (assign && assign in options.referenceRecord) {
        throw new EndpointError(`'${assign}' is already defined in Reference Record.`);
    }
    const value = callFunction(fnArgs, options);
    options.logger?.debug?.(debugId, `evaluateCondition: ${toDebugString(fnArgs)} = ${toDebugString(value)}`);
    return {
        result: value === "" ? true : !!value,
        ...(assign != null && { toAssign: { name: assign, value } }),
    };
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/utils/evaluateConditions.js


const evaluateConditions = (conditions = [], options) => {
    const conditionsReferenceRecord = {};
    for (const condition of conditions) {
        const { result, toAssign } = evaluateCondition(condition, {
            ...options,
            referenceRecord: {
                ...options.referenceRecord,
                ...conditionsReferenceRecord,
            },
        });
        if (!result) {
            return { result };
        }
        if (toAssign) {
            conditionsReferenceRecord[toAssign.name] = toAssign.value;
            options.logger?.debug?.(debugId, `assign: ${toAssign.name} := ${toDebugString(toAssign.value)}`);
        }
    }
    return { result: true, referenceRecord: conditionsReferenceRecord };
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/utils/getEndpointHeaders.js


const getEndpointHeaders = (headers, options) => Object.entries(headers).reduce((acc, [headerKey, headerVal]) => ({
    ...acc,
    [headerKey]: headerVal.map((headerValEntry) => {
        const processedExpr = evaluateExpression(headerValEntry, "Header value entry", options);
        if (typeof processedExpr !== "string") {
            throw new EndpointError(`Header '${headerKey}' value '${processedExpr}' is not a string`);
        }
        return processedExpr;
    }),
}), {});

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/utils/getEndpointProperty.js



const getEndpointProperty = (property, options) => {
    if (Array.isArray(property)) {
        return property.map((propertyEntry) => getEndpointProperty(propertyEntry, options));
    }
    switch (typeof property) {
        case "string":
            return evaluateTemplate(property, options);
        case "object":
            if (property === null) {
                throw new EndpointError(`Unexpected endpoint property: ${property}`);
            }
            return getEndpointProperties(property, options);
        case "boolean":
            return property;
        default:
            throw new EndpointError(`Unexpected endpoint property type: ${typeof property}`);
    }
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/utils/getEndpointProperties.js

const getEndpointProperties = (properties, options) => Object.entries(properties).reduce((acc, [propertyKey, propertyVal]) => ({
    ...acc,
    [propertyKey]: getEndpointProperty(propertyVal, options),
}), {});

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/utils/getEndpointUrl.js


const getEndpointUrl = (endpointUrl, options) => {
    const expression = evaluateExpression(endpointUrl, "Endpoint URL", options);
    if (typeof expression === "string") {
        try {
            return new URL(expression);
        }
        catch (error) {
            console.error(`Failed to construct URL with ${expression}`, error);
            throw error;
        }
    }
    throw new EndpointError(`Endpoint URL must be a string, got ${typeof expression}`);
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/utils/evaluateEndpointRule.js





const evaluateEndpointRule = (endpointRule, options) => {
    const { conditions, endpoint } = endpointRule;
    const { result, referenceRecord } = evaluateConditions(conditions, options);
    if (!result) {
        return;
    }
    const endpointRuleOptions = {
        ...options,
        referenceRecord: { ...options.referenceRecord, ...referenceRecord },
    };
    const { url, properties, headers } = endpoint;
    options.logger?.debug?.(debugId, `Resolving endpoint from template: ${toDebugString(endpoint)}`);
    return {
        ...(headers != undefined && {
            headers: getEndpointHeaders(headers, endpointRuleOptions),
        }),
        ...(properties != undefined && {
            properties: getEndpointProperties(properties, endpointRuleOptions),
        }),
        url: getEndpointUrl(url, endpointRuleOptions),
    };
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/utils/evaluateErrorRule.js



const evaluateErrorRule = (errorRule, options) => {
    const { conditions, error } = errorRule;
    const { result, referenceRecord } = evaluateConditions(conditions, options);
    if (!result) {
        return;
    }
    throw new EndpointError(evaluateExpression(error, "Error", {
        ...options,
        referenceRecord: { ...options.referenceRecord, ...referenceRecord },
    }));
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/utils/evaluateTreeRule.js


const evaluateTreeRule = (treeRule, options) => {
    const { conditions, rules } = treeRule;
    const { result, referenceRecord } = evaluateConditions(conditions, options);
    if (!result) {
        return;
    }
    return evaluateRules(rules, {
        ...options,
        referenceRecord: { ...options.referenceRecord, ...referenceRecord },
    });
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/utils/evaluateRules.js




const evaluateRules = (rules, options) => {
    for (const rule of rules) {
        if (rule.type === "endpoint") {
            const endpointOrUndefined = evaluateEndpointRule(rule, options);
            if (endpointOrUndefined) {
                return endpointOrUndefined;
            }
        }
        else if (rule.type === "error") {
            evaluateErrorRule(rule, options);
        }
        else if (rule.type === "tree") {
            const endpointOrUndefined = evaluateTreeRule(rule, options);
            if (endpointOrUndefined) {
                return endpointOrUndefined;
            }
        }
        else {
            throw new EndpointError(`Unknown endpoint rule: ${rule}`);
        }
    }
    throw new EndpointError(`Rules evaluation failed`);
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/utils/index.js


;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/resolveEndpoint.js



const resolveEndpoint = (ruleSetObject, options) => {
    const { endpointParams, logger } = options;
    const { parameters, rules } = ruleSetObject;
    options.logger?.debug?.(debugId, `Initial EndpointParams: ${toDebugString(endpointParams)}`);
    const paramsWithDefault = Object.entries(parameters)
        .filter(([, v]) => v.default != null)
        .map(([k, v]) => [k, v.default]);
    if (paramsWithDefault.length > 0) {
        for (const [paramKey, paramDefaultValue] of paramsWithDefault) {
            endpointParams[paramKey] = endpointParams[paramKey] ?? paramDefaultValue;
        }
    }
    const requiredParams = Object.entries(parameters)
        .filter(([, v]) => v.required)
        .map(([k]) => k);
    for (const requiredParam of requiredParams) {
        if (endpointParams[requiredParam] == null) {
            throw new EndpointError(`Missing required parameter: '${requiredParam}'`);
        }
    }
    const endpoint = evaluateRules(rules, { endpointParams, logger, referenceRecord: {} });
    if (options.endpointParams?.Endpoint) {
        try {
            const givenEndpoint = new URL(options.endpointParams.Endpoint);
            const { protocol, port } = givenEndpoint;
            endpoint.url.protocol = protocol;
            endpoint.url.port = port;
        }
        catch (e) {
        }
    }
    options.logger?.debug?.(debugId, `Resolved endpoint: ${toDebugString(endpoint)}`);
    return endpoint;
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-endpoints/dist-es/index.js




;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/endpoint/ruleset.js
const q = "fn", r = "argv", s = "ref";
const a = true, b = false, c = "String", d = "PartitionResult", e = "tree", f = "error", g = "endpoint", h = { "required": true, "default": false, "type": "Boolean" }, ruleset_i = { [s]: "Endpoint" }, j = { [q]: "booleanEquals", [r]: [{ [s]: "UseFIPS" }, true] }, k = { [q]: "booleanEquals", [r]: [{ [s]: "UseDualStack" }, true] }, l = {}, m = { [q]: "booleanEquals", [r]: [true, { [q]: "getAttr", [r]: [{ [s]: d }, "supportsFIPS"] }] }, n = { [q]: "booleanEquals", [r]: [true, { [q]: "getAttr", [r]: [{ [s]: d }, "supportsDualStack"] }] }, o = [j], p = [k];
const _data = { version: "1.0", parameters: { Region: { required: a, type: c }, UseDualStack: h, UseFIPS: h, Endpoint: { required: b, type: c } }, rules: [{ conditions: [{ [q]: "aws.partition", [r]: [{ [s]: "Region" }], assign: d }], type: e, rules: [{ conditions: [{ [q]: "isSet", [r]: [ruleset_i] }], type: e, rules: [{ conditions: o, error: "Invalid Configuration: FIPS and custom endpoint are not supported", type: f }, { type: e, rules: [{ conditions: p, error: "Invalid Configuration: Dualstack and custom endpoint are not supported", type: f }, { endpoint: { url: ruleset_i, properties: l, headers: l }, type: g }] }] }, { conditions: [j, k], type: e, rules: [{ conditions: [m, n], type: e, rules: [{ endpoint: { url: "https://secretsmanager-fips.{Region}.{PartitionResult#dualStackDnsSuffix}", properties: l, headers: l }, type: g }] }, { error: "FIPS and DualStack are enabled, but this partition does not support one or both", type: f }] }, { conditions: o, type: e, rules: [{ conditions: [m], type: e, rules: [{ type: e, rules: [{ endpoint: { url: "https://secretsmanager-fips.{Region}.{PartitionResult#dnsSuffix}", properties: l, headers: l }, type: g }] }] }, { error: "FIPS is enabled but this partition does not support FIPS", type: f }] }, { conditions: p, type: e, rules: [{ conditions: [n], type: e, rules: [{ endpoint: { url: "https://secretsmanager.{Region}.{PartitionResult#dualStackDnsSuffix}", properties: l, headers: l }, type: g }] }, { error: "DualStack is enabled but this partition does not support DualStack", type: f }] }, { endpoint: { url: "https://secretsmanager.{Region}.{PartitionResult#dnsSuffix}", properties: l, headers: l }, type: g }] }] };
const ruleSet = _data;

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/endpoint/endpointResolver.js


const defaultEndpointResolver = (endpointParams, context = {}) => {
    return resolveEndpoint(ruleSet, {
        endpointParams: endpointParams,
        logger: context.logger,
    });
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/runtimeConfig.shared.js




const getRuntimeConfig = (config) => ({
    apiVersion: "2017-10-17",
    base64Decoder: config?.base64Decoder ?? fromBase64,
    base64Encoder: config?.base64Encoder ?? toBase64,
    disableHostPrefix: config?.disableHostPrefix ?? false,
    endpointProvider: config?.endpointProvider ?? defaultEndpointResolver,
    logger: config?.logger ?? new NoOpLogger(),
    serviceId: config?.serviceId ?? "Secrets Manager",
    urlParser: config?.urlParser ?? parseUrl,
});

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-defaults-mode-browser/dist-es/constants.js
const DEFAULTS_MODE_OPTIONS = ["in-region", "cross-region", "mobile", "standard", "legacy"];

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-defaults-mode-browser/dist-es/resolveDefaultsModeConfig.js



const resolveDefaultsModeConfig = ({ defaultsMode, } = {}) => memoize(async () => {
    const mode = typeof defaultsMode === "function" ? await defaultsMode() : defaultsMode;
    switch (mode?.toLowerCase()) {
        case "auto":
            return Promise.resolve(isMobileBrowser() ? "mobile" : "standard");
        case "mobile":
        case "in-region":
        case "cross-region":
        case "standard":
        case "legacy":
            return Promise.resolve(mode?.toLocaleLowerCase());
        case undefined:
            return Promise.resolve("legacy");
        default:
            throw new Error(`Invalid parameter for "defaultsMode", expect ${DEFAULTS_MODE_OPTIONS.join(", ")}, got ${mode}`);
    }
});
const isMobileBrowser = () => {
    const parsedUA = typeof window !== "undefined" && window?.navigator?.userAgent
        ? es5_default().parse(window.navigator.userAgent)
        : undefined;
    const platform = parsedUA?.platform?.type;
    return platform === "tablet" || platform === "mobile";
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/util-defaults-mode-browser/dist-es/index.js


;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/runtimeConfig.browser.js












const runtimeConfig_browser_getRuntimeConfig = (config) => {
    const defaultsMode = resolveDefaultsModeConfig(config);
    const defaultConfigProvider = () => defaultsMode().then(loadConfigsForDefaultMode);
    const clientSharedValues = getRuntimeConfig(config);
    return {
        ...clientSharedValues,
        ...config,
        runtime: "browser",
        defaultsMode,
        bodyLengthChecker: config?.bodyLengthChecker ?? calculateBodyLength,
        credentialDefaultProvider: config?.credentialDefaultProvider ?? ((_) => () => Promise.reject(new Error("Credential is missing"))),
        defaultUserAgentProvider: config?.defaultUserAgentProvider ??
            defaultUserAgent({ serviceId: clientSharedValues.serviceId, clientVersion: package_namespaceObject.i8 }),
        maxAttempts: config?.maxAttempts ?? config_DEFAULT_MAX_ATTEMPTS,
        region: config?.region ?? invalidProvider("Region is missing"),
        requestHandler: config?.requestHandler ?? new FetchHttpHandler(defaultConfigProvider),
        retryMode: config?.retryMode ?? (async () => (await defaultConfigProvider()).retryMode || DEFAULT_RETRY_MODE),
        sha256: config?.sha256 ?? build.Sha256,
        streamCollector: config?.streamCollector ?? streamCollector,
        useDualstackEndpoint: config?.useDualstackEndpoint ?? (() => Promise.resolve(DEFAULT_USE_DUALSTACK_ENDPOINT)),
        useFipsEndpoint: config?.useFipsEndpoint ?? (() => Promise.resolve(DEFAULT_USE_FIPS_ENDPOINT)),
        utf8Decoder: config?.utf8Decoder ?? dist_es.fromUtf8,
        utf8Encoder: config?.utf8Encoder ?? dist_es.toUtf8,
    };
};

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/SecretsManagerClient.js












class SecretsManagerClient extends Client {
    constructor(configuration) {
        const _config_0 = runtimeConfig_browser_getRuntimeConfig(configuration);
        const _config_1 = resolveClientEndpointParameters(_config_0);
        const _config_2 = resolveRegionConfig(_config_1);
        const _config_3 = resolveEndpointConfig(_config_2);
        const _config_4 = resolveRetryConfig(_config_3);
        const _config_5 = resolveHostHeaderConfig(_config_4);
        const _config_6 = resolveAwsAuthConfig(_config_5);
        const _config_7 = resolveUserAgentConfig(_config_6);
        super(_config_7);
        this.config = _config_7;
        this.middlewareStack.use(getRetryPlugin(this.config));
        this.middlewareStack.use(getContentLengthPlugin(this.config));
        this.middlewareStack.use(getHostHeaderPlugin(this.config));
        this.middlewareStack.use(getLoggerPlugin(this.config));
        this.middlewareStack.use(getRecursionDetectionPlugin(this.config));
        this.middlewareStack.use(getAwsAuthPlugin(this.config));
        this.middlewareStack.use(getUserAgentPlugin(this.config));
    }
    destroy() {
        super.destroy();
    }
}

;// CONCATENATED MODULE: ./node_modules/@aws-sdk/client-secrets-manager/dist-es/SecretsManager.js























class SecretsManager extends SecretsManagerClient {
    cancelRotateSecret(args, optionsOrCb, cb) {
        const command = new CancelRotateSecretCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    createSecret(args, optionsOrCb, cb) {
        const command = new CreateSecretCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    deleteResourcePolicy(args, optionsOrCb, cb) {
        const command = new DeleteResourcePolicyCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    deleteSecret(args, optionsOrCb, cb) {
        const command = new DeleteSecretCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    describeSecret(args, optionsOrCb, cb) {
        const command = new DescribeSecretCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getRandomPassword(args, optionsOrCb, cb) {
        const command = new GetRandomPasswordCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getResourcePolicy(args, optionsOrCb, cb) {
        const command = new GetResourcePolicyCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    getSecretValue(args, optionsOrCb, cb) {
        const command = new GetSecretValueCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    listSecrets(args, optionsOrCb, cb) {
        const command = new ListSecretsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    listSecretVersionIds(args, optionsOrCb, cb) {
        const command = new ListSecretVersionIdsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    putResourcePolicy(args, optionsOrCb, cb) {
        const command = new PutResourcePolicyCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    putSecretValue(args, optionsOrCb, cb) {
        const command = new PutSecretValueCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    removeRegionsFromReplication(args, optionsOrCb, cb) {
        const command = new RemoveRegionsFromReplicationCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    replicateSecretToRegions(args, optionsOrCb, cb) {
        const command = new ReplicateSecretToRegionsCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    restoreSecret(args, optionsOrCb, cb) {
        const command = new RestoreSecretCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    rotateSecret(args, optionsOrCb, cb) {
        const command = new RotateSecretCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    stopReplicationToReplica(args, optionsOrCb, cb) {
        const command = new StopReplicationToReplicaCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    tagResource(args, optionsOrCb, cb) {
        const command = new TagResourceCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    untagResource(args, optionsOrCb, cb) {
        const command = new UntagResourceCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateSecret(args, optionsOrCb, cb) {
        const command = new UpdateSecretCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    updateSecretVersionStage(args, optionsOrCb, cb) {
        const command = new UpdateSecretVersionStageCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
    validateResourcePolicy(args, optionsOrCb, cb) {
        const command = new ValidateResourcePolicyCommand(args);
        if (typeof optionsOrCb === "function") {
            this.send(command, optionsOrCb);
        }
        else if (typeof cb === "function") {
            if (typeof optionsOrCb !== "object")
                throw new Error(`Expect http options but get ${typeof optionsOrCb}`);
            this.send(command, optionsOrCb || {}, cb);
        }
        else {
            return this.send(command, optionsOrCb);
        }
    }
}

// EXTERNAL MODULE: ./node_modules/@print-engine/utilities/utilities.js
var utilities = __webpack_require__(93909);
// EXTERNAL MODULE: ./node_modules/@print-engine/utilities/integration.js
var integration = __webpack_require__(59709);
// EXTERNAL MODULE: ./node_modules/@print-engine/utilities/cache.js
var utilities_cache = __webpack_require__(74806);
;// CONCATENATED MODULE: ./node_modules/@print-engine/aws-secrets-manager/aws_secrets_manager.js
/* provided dependency */ var aws_secrets_manager_process = __webpack_require__(83454);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}





/**
 * AWS Secrets Manager Configuration
 *
 * @type {{development: {tenant: {access_key_id: (string|*|string), secret_access_key: (string|*|string), region: string}}, production:
 *     {tenant: {access_key_id: (string|*|string), secret_access_key: (string|*|string), region: string}}, staging: {tenant:
 *     {access_key_id: (string|*|string), secret_access_key: (string|*|string), region: string}}, local: {tenant: {access_key_id:
 *     (string|*|string), secret_access_key: (string|*|string), region: string}}}}
 */ var Configuration = {
    "production": {
        "tenant": {
            "access_key_id": !(0,utilities.is_empty)(aws_secrets_manager_process.env["P_IE_AWS_ACCESS_KEY_ID"]) ? "".concat(aws_secrets_manager_process.env["P_IE_AWS_ACCESS_KEY_ID"]) : !(0,utilities.is_empty)(aws_secrets_manager_process.env["IE_AWS_ACCESS_KEY_ID"]) ? aws_secrets_manager_process.env["IE_AWS_ACCESS_KEY_ID"] : "",
            "secret_access_key": !(0,utilities.is_empty)(aws_secrets_manager_process.env["P_IE_AWS_SECRET_ACCESS_KEY"]) ? "".concat(aws_secrets_manager_process.env["P_IE_AWS_SECRET_ACCESS_KEY"]) : !(0,utilities.is_empty)(aws_secrets_manager_process.env["IE_AWS_SECRET_ACCESS_KEY"]) ? aws_secrets_manager_process.env["IE_AWS_SECRET_ACCESS_KEY"] : "",
            "region": "us-east-2"
        }
    },
    "staging": {
        "tenant": {
            "access_key_id": !(0,utilities.is_empty)(aws_secrets_manager_process.env["S_IE_AWS_ACCESS_KEY_ID"]) ? "".concat(aws_secrets_manager_process.env["S_IE_AWS_ACCESS_KEY_ID"]) : !(0,utilities.is_empty)(aws_secrets_manager_process.env["IE_AWS_ACCESS_KEY_ID"]) ? aws_secrets_manager_process.env["IE_AWS_ACCESS_KEY_ID"] : "",
            "secret_access_key": !(0,utilities.is_empty)(aws_secrets_manager_process.env["S_IE_AWS_SECRET_ACCESS_KEY"]) ? "".concat(aws_secrets_manager_process.env["S_IE_AWS_SECRET_ACCESS_KEY"]) : !(0,utilities.is_empty)(aws_secrets_manager_process.env["IE_AWS_SECRET_ACCESS_KEY"]) ? aws_secrets_manager_process.env["IE_AWS_SECRET_ACCESS_KEY"] : "",
            "region": "us-east-2"
        }
    },
    "development": {
        "tenant": {
            "access_key_id": !(0,utilities.is_empty)(aws_secrets_manager_process.env["D_IE_AWS_ACCESS_KEY_ID"]) ? "".concat(aws_secrets_manager_process.env["D_IE_AWS_ACCESS_KEY_ID"]) : !(0,utilities.is_empty)(aws_secrets_manager_process.env["IE_AWS_ACCESS_KEY_ID"]) ? aws_secrets_manager_process.env["IE_AWS_ACCESS_KEY_ID"] : "",
            "secret_access_key": !(0,utilities.is_empty)(aws_secrets_manager_process.env["D_IE_AWS_SECRET_ACCESS_KEY"]) ? "".concat(aws_secrets_manager_process.env["D_IE_AWS_SECRET_ACCESS_KEY"]) : !(0,utilities.is_empty)(aws_secrets_manager_process.env["IE_AWS_SECRET_ACCESS_KEY"]) ? aws_secrets_manager_process.env["IE_AWS_SECRET_ACCESS_KEY"] : "",
            "region": "us-east-2"
        }
    },
    "local": {
        "tenant": {
            "access_key_id": !(0,utilities.is_empty)(aws_secrets_manager_process.env["L_IE_AWS_ACCESS_KEY_ID"]) ? "".concat(aws_secrets_manager_process.env["L_IE_AWS_ACCESS_KEY_ID"]) : !(0,utilities.is_empty)(aws_secrets_manager_process.env["IE_AWS_ACCESS_KEY_ID"]) ? aws_secrets_manager_process.env["IE_AWS_ACCESS_KEY_ID"] : "",
            "secret_access_key": !(0,utilities.is_empty)(aws_secrets_manager_process.env["L_IE_AWS_SECRET_ACCESS_KEY"]) ? "".concat(aws_secrets_manager_process.env["L_IE_AWS_SECRET_ACCESS_KEY"]) : !(0,utilities.is_empty)(aws_secrets_manager_process.env["IE_AWS_SECRET_ACCESS_KEY"]) ? aws_secrets_manager_process.env["IE_AWS_SECRET_ACCESS_KEY"] : "",
            "region": "us-east-2"
        }
    }
};
/**
 * AWS Secrets Manager Integration
 * @class AWS_Secrets_Manager
 * @extends Integration
 */ var AWS_Secrets_Manager = /*#__PURE__*/ function(Integration1) {
    "use strict";
    _inherits(AWS_Secrets_Manager, Integration1);
    var _super = _createSuper(AWS_Secrets_Manager);
    function AWS_Secrets_Manager() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, AWS_Secrets_Manager);
        var _this;
        var default_args = {
            "environment": null,
            "application": "tenant",
            "context": null,
            "scope": null
        };
        var args = _objectSpread({}, default_args, user_args);
        _this = _super.call(this, args);
        _this.args = _objectSpread({}, args, {
            "name": "Amazon Web Services - Secrets Manager",
            "class_name": _this.constructor["name"],
            "reference_name": "aws_secrets_manager",
            "description": "Easily rotate, manage, and retrieve database credentials, API keys, and other secrets through their lifecycle.",
            "documentation_url": "https://aws.amazon.com/secrets-manager/"
        });
        try {
            _this.set_bindings();
            _this.set_configuration(Configuration);
            _this.secrets_manager = new SecretsManager({
                "region": _this.configuration["region"],
                "credentials": {
                    "accessKeyId": _this.configuration["access_key_id"],
                    "secretAccessKey": _this.configuration["secret_access_key"]
                }
            });
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/aws_secrets_manager -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _this;
    }
    _createClass(AWS_Secrets_Manager, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.get = this.get.bind(this);
                this.create = this.create.bind(this);
                this.set_args = this.set_args.bind(this);
            }
        },
        {
            key: "set_args",
            value: function set_args() {
                var args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                this.args = _objectSpread({}, this.args, args);
            }
        },
        {
            key: "get",
            value: /**
	 * Retrieves a secret.
	 *
	 * @documentation https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/SecretsManager.html#getSecretValue-property
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(runtime_default().mark(function _callee() {
                    var default_args, args, response, cache, remote_response;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "secret_name": ""
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                cache = utilities_cache._Cache.get(_this.args["reference_name"], args["secret_name"]);
                                if (!cache) {
                                    _ctx.next = 9;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 13;
                                break;
                            case 9:
                                _ctx.next = 11;
                                return _this.secrets_manager.getSecretValue({
                                    "SecretId": args["secret_name"]
                                });
                            case 11:
                                remote_response = _ctx.sent;
                                if (!(0,utilities.is_empty)(remote_response["SecretString"])) {
                                    response = JSON.parse(remote_response["SecretString"]);
                                    utilities_cache._Cache.set(_this.args["reference_name"], args["secret_name"], response);
                                }
                            case 13:
                                return _ctx.abrupt("return", response);
                            case 16:
                                _ctx.prev = 16;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/aws_secrets_manager -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration
                                    });
                                }
                                throw _ctx.t0;
                            case 20:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            16
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "create",
            value: /**
	 * Creates a new secret.
	 *
	 * @documentation https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/SecretsManager.html#createSecret-property
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(runtime_default().mark(function _callee() {
                    var default_args, args, response, remote_response;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "secret_name": "",
                                    "secret_value": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                _ctx.next = 6;
                                return _this.secrets_manager.createSecret({
                                    "Name": "".concat(args["secret_name"]),
                                    "SecretString": JSON.stringify(args["secret_value"])
                                });
                            case 6:
                                remote_response = _ctx.sent;
                                if (!(0,utilities.is_empty)(remote_response)) {
                                    _this.cache.remove(_this.args["reference_name"]);
                                    response = remote_response;
                                }
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/aws_secrets_manager -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * Deletes a secret.
	 *
	 * @documentation https://docs.aws.amazon.com/AWSJavaScriptSDK/latest/AWS/SecretsManager.html#deleteSecret-property
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(runtime_default().mark(function _callee() {
                    var default_args, args, response, remote_response;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "secret_name": ""
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                _ctx.next = 6;
                                return _this.secrets_manager.deleteSecret({
                                    "SecretId": args.secret_name
                                });
                            case 6:
                                remote_response = _ctx.sent;
                                if (!(0,utilities.is_empty)(remote_response)) {
                                    _this.cache.remove(_this.args["reference_name"]);
                                    response = remote_response;
                                }
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/aws_secrets_manager -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            11
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return AWS_Secrets_Manager;
}(integration.Integration);


/***/ }),

/***/ 97476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cache": function() { return /* binding */ Cache; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _cloudflare_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57042);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * Cloudflare Integration
 * @class   Cache
 * @extends Cloudflare
 */ var Cache = /*#__PURE__*/ function(Cloudflare1) {
    "use strict";
    _inherits(Cache, Cloudflare1);
    var _super = _createSuper(Cache);
    function Cache() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Cache);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/cloudflare/cache -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Cache, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.purge = this.purge.bind(this);
            }
        },
        {
            key: "purge",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function purge() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("post", "/cache/purge");
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/cloudflare/cache -> purge():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Cache;
}(_cloudflare_js__WEBPACK_IMPORTED_MODULE_2__.Cloudflare);


/***/ }),

/***/ 57042:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cloudflare": function() { return /* binding */ Cloudflare; },
/* harmony export */   "Configuration": function() { return /* binding */ Configuration; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93909);
/* harmony import */ var _print_engine_utilities_integration_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59709);
/* provided dependency */ var process = __webpack_require__(83454);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




/**
 * Cloudflare Configuration
 *
 * @type {{development: {tenant: {url: string, token: (string|*|string)}}, production: {tenant: {url: string, token: (string|*|string)}},
 *     staging: {tenant: {url: string, token: (string|*|string)}}, local: {tenant: {url: string, token: (string|*|string)}}}}
 */ var Configuration = {
    "production": {
        "tenant": {
            "url": "https://api.cloudflare.com/client/v4",
            "token": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["P_CLOUDFLARE_TOKEN"]) ? "".concat(process.env["P_CLOUDFLARE_TOKEN"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["CLOUDFLARE_TOKEN"]) ? process.env["CLOUDFLARE_TOKEN"] : ""
        }
    },
    "staging": {
        "tenant": {
            "url": "https://api.cloudflare.com/client/v4",
            "token": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["S_CLOUDFLARE_TOKEN"]) ? "".concat(process.env["S_CLOUDFLARE_TOKEN"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["CLOUDFLARE_TOKEN"]) ? process.env["CLOUDFLARE_TOKEN"] : ""
        }
    },
    "development": {
        "tenant": {
            "url": "https://api.cloudflare.com/client/v4",
            "token": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["D_CLOUDFLARE_TOKEN"]) ? "".concat(process.env["D_CLOUDFLARE_TOKEN"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["CLOUDFLARE_TOKEN"]) ? process.env["CLOUDFLARE_TOKEN"] : ""
        }
    },
    "local": {
        "tenant": {
            "url": "https://api.cloudflare.com/client/v4",
            "token": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["L_CLOUDFLARE_TOKEN"]) ? "".concat(process.env["L_CLOUDFLARE_TOKEN"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["CLOUDFLARE_TOKEN"]) ? process.env["CLOUDFLARE_TOKEN"] : ""
        }
    }
};
/**
 * Cloudflare Integration
 * @class   Cloudflare
 * @extends Integration
 */ var Cloudflare = /*#__PURE__*/ function(Integration1) {
    "use strict";
    _inherits(Cloudflare, Integration1);
    var _super = _createSuper(Cloudflare);
    function Cloudflare() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Cloudflare);
        var _this;
        var default_args = {
            "environment": null,
            "application": "tenant",
            "context": null,
            "scope": null
        };
        var args = _objectSpread({}, default_args, user_args);
        _this = _super.call(this, args);
        _this.args = _objectSpread({}, args, {
            "name": "Cloudflare",
            "class_name": _this.constructor["name"],
            "reference_name": "cloudflare",
            "description": "Cloudflare is a global network designed to make everything you connect to the Internet secure, private, fast, and reliable.",
            "documentation_url": "https://api.cloudflare.com/"
        });
        try {
            _this.set_bindings();
            _this.set_configuration(Configuration);
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/cloudflare -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _this;
    }
    _createClass(Cloudflare, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.request = this.request.bind(this);
            }
        },
        {
            key: "request",
            value: /**
	 * Performs a network request to WP Engine.
	 *
	 * @param method
	 * @param endpoint
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function request1() {
                var method = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", endpoint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", user_args = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response, token, request, remote_response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "parameters": {},
                                    "data": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                if (!((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["context"]) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.configuration) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(method) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(endpoint))) {
                                    _ctx.next = 6;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 6:
                                method = String(method).toUpperCase();
                                token = !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["token"]) ? "".concat(_this.args["token"]) : "".concat(_this.configuration["token"]);
                                request = {
                                    "baseURL": _this.configuration["url"],
                                    "headers": {
                                        "Authorization": "Bearer ".concat(token),
                                        "Content-Type": "application/json"
                                    },
                                    "timeout": 30000,
                                    "url": "".concat(endpoint),
                                    "method": "".concat(method)
                                };
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args)) {
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["parameters"])) {
                                        request["params"] = args["parameters"];
                                    }
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["data"])) {
                                        if ([
                                            "PUT",
                                            "POST",
                                            "DELETE",
                                            "PATCH"
                                        ].includes(method)) {
                                            request["data"] = args["data"];
                                        }
                                    }
                                }
                                console.log("@imprint-engine/packages/cloudflare -> request():", {
                                    "args": {
                                        "class": _this.args,
                                        "method": {
                                            "method": method,
                                            "endpoint": endpoint,
                                            "user_args": user_args
                                        }
                                    },
                                    "configuration": _this.configuration
                                });
                                _ctx.next = 13;
                                return axios__WEBPACK_IMPORTED_MODULE_1___default()(request);
                            case 13:
                                remote_response = _ctx.sent;
                                //console.log( '@imprint-engine/packages/cloudflare -> request(): (REMOTE_RESPONSE)', util.inspect( remote_response,
                                // false, null, true ) );
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(remote_response["data"])) {
                                    response = remote_response["data"];
                                }
                                return _ctx.abrupt("return", response);
                            case 18:
                                _ctx.prev = 18;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/cloudflare -> request():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": {
                                                "method": method,
                                                "endpoint": endpoint,
                                                "user_args": user_args
                                            }
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 22:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            18
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Cloudflare;
}(_print_engine_utilities_integration_js__WEBPACK_IMPORTED_MODULE_3__.Integration);


/***/ }),

/***/ 88729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Records": function() { return /* binding */ Records; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _cloudflare_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57042);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * Cloudflare Integration
 * @class   Records
 * @extends Cloudflare
 */ var Records = /*#__PURE__*/ function(Cloudflare1) {
    "use strict";
    _inherits(Records, Cloudflare1);
    var _super = _createSuper(Records);
    function Records() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Records);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/cloudflare/records -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Records, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("post", "/records", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/cloudflare/records -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 16;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/records/".concat(args["id"]));
                            case 14:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                }
                            case 16:
                                return _ctx.abrupt("return", response);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/cloudflare/records -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 23:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("get", "/records", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/cloudflare/records -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0,
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/records/".concat(args["id"]), {
                                    "data": args["payload"]
                                });
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/cloudflare/records -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/records/".concat(args["id"]));
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/cloudflare/records -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Records;
}(_cloudflare_js__WEBPACK_IMPORTED_MODULE_2__.Cloudflare);


/***/ }),

/***/ 23599:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Zones": function() { return /* binding */ Zones; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _cloudflare_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57042);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * Cloudflare Integration
 * @class   Zones
 * @extends Cloudflare
 */ var Zones = /*#__PURE__*/ function(Cloudflare1) {
    "use strict";
    _inherits(Zones, Cloudflare1);
    var _super = _createSuper(Zones);
    function Zones() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Zones);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/cloudflare/zones -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Zones, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("post", "/zones", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/cloudflare/zones -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 16;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/zones/".concat(args["id"]));
                            case 14:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                }
                            case 16:
                                return _ctx.abrupt("return", response);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/cloudflare/zones -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 23:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("get", "/zones", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/cloudflare/zones -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0,
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/zones/".concat(args["id"]), {
                                    "data": args["payload"]
                                });
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/cloudflare/zones -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/zones/".concat(args["id"]));
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/cloudflare/zones -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Zones;
}(_cloudflare_js__WEBPACK_IMPORTED_MODULE_2__.Cloudflare);


/***/ }),

/***/ 77606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Companies": function() { return /* binding */ Companies; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _copper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15446);
/* harmony import */ var _custom_fields_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26451);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93909);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




/**
 * Copper Integration
 * @class   Companies
 * @extends Copper
 */ var Companies = /*#__PURE__*/ function(Copper1) {
    "use strict";
    _inherits(Companies, Copper1);
    var _super = _createSuper(Companies);
    function Companies() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Companies);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/copper/companies -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(error["message"])) {
                throw error["message"];
            } else {
                throw error;
            }
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Companies, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
                this.get_custom_fields = this.get_custom_fields.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * Create a New Company
	 *
	 * @documentation https://developer.copper.com/companies/create-a-new-company.html
	 * @endpoint https://app.copper.com/developer_api/v1/companies
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "name": "",
                                    "custom_fields": []
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                _ctx.next = 6;
                                return _this.request("post", "/companies", {
                                    "data": args
                                });
                            case 6:
                                response = _ctx.sent;
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/companies -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 18;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 18:
                                throw _ctx.t0;
                            case 19:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * Fetch a Company by ID
	 *
	 * @documentation https://developer.copper.com/companies/fetch-a-company-by-id.html
	 * @endpoint https://app.copper.com/developer_api/v1/companies/{{example_company_id}}
	 * @method GET
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<boolean>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(args["id"])) {
                                    _ctx.next = 6;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 6:
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 20;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/companies/".concat(args["id"]));
                            case 14:
                                response = _ctx.sent;
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(response)) {
                                    _ctx.next = 20;
                                    break;
                                }
                                _ctx.next = 18;
                                return _this.get_custom_fields(response);
                            case 18:
                                response["custom_fields"] = _ctx.sent;
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                            case 20:
                                return _ctx.abrupt("return", response);
                            case 23:
                                _ctx.prev = 23;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/companies -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 30;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 30:
                                throw _ctx.t0;
                            case 31:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            23
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * List Companies (Search)
	 *
	 * @documentation https://developer.copper.com/companies/list-companies-search.html
	 * @endpoint https://app.copper.com/developer_api/v1/companies/search
	 * @method POST
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "page_number": 1,
                                    "page_size": 20,
                                    "sort_by": "name",
                                    "sort_direction": "asc",
                                    "field_ids": []
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 10;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 14;
                                break;
                            case 10:
                                _ctx.next = 12;
                                return _this.request("post", "/companies/search", {
                                    "data": args
                                });
                            case 12:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                    if (Array.isArray(response) && response["length"] > 0) {
                                        response.map(function(result) {
                                            _this.cache.set(_this.constructor["name"], JSON.stringify({
                                                "id": result["id"]
                                            }), result);
                                        });
                                    }
                                }
                            case 14:
                                return _ctx.abrupt("return", response);
                            case 17:
                                _ctx.prev = 17;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/companies -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 24;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 24:
                                throw _ctx.t0;
                            case 25:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            17
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * Update a Company
	 *
	 * @documentation https://developer.copper.com/companies/update-a-company.html
	 * @endpoint https://app.copper.com/developer_api/v1/companies/{{example_company_id}}
	 * @method PUT
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(args["id"])) {
                                    _ctx.next = 6;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 6:
                                _ctx.next = 8;
                                return _this.request("put", "/companies/".concat(args["id"]), {
                                    "data": args
                                });
                            case 8:
                                response = _ctx.sent;
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/companies -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 20;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 20:
                                throw _ctx.t0;
                            case 21:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * Delete a Company
	 *
	 * @documentation https://developer.copper.com/companies/delete-a-company.html
	 * @endpoint https://app.copper.com/developer_api/v1/companies/{{delete_company_id}}
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(args["id"])) {
                                    _ctx.next = 6;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 6:
                                _ctx.next = 8;
                                return _this.request("delete", "/companies/".concat(args["id"]));
                            case 8:
                                response = _ctx.sent;
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/companies -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 20;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 20:
                                throw _ctx.t0;
                            case 21:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get_custom_fields",
            value: /**
	 *
	 * @param entity_object
	 * @returns {Promise<boolean>}
	 */ function get_custom_fields() {
                var entity_object = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var Custom_Fields;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.prev = 0;
                                Custom_Fields = new _custom_fields_js__WEBPACK_IMPORTED_MODULE_2__.Custom_Fields(_this.args);
                                _ctx.next = 4;
                                return Custom_Fields.list({
                                    "entity_object": entity_object,
                                    "entity_type": "company",
                                    "field_ids": Object.values(_this.configuration["ids"]["company"]["custom_fields"])
                                });
                            case 4:
                                return _ctx.abrupt("return", _ctx.sent);
                            case 7:
                                _ctx.prev = 7;
                                _ctx.t0 = _ctx["catch"](0);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/companies -> get_custom_fields():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": entity_object
                                        },
                                        "configuration": _this.configuration
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 14;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 14:
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            7
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Companies;
}(_copper_js__WEBPACK_IMPORTED_MODULE_1__.Copper);


/***/ }),

/***/ 15446:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Configuration": function() { return /* binding */ Configuration; },
/* harmony export */   "Copper": function() { return /* binding */ Copper; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93909);
/* harmony import */ var _print_engine_utilities_integration_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59709);
/* provided dependency */ var process = __webpack_require__(83454);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




/**
 * Copper Configuration
 *
 * @type {{development: {tenant: {account_id: number, ids: {opportunity: {pipeline_stages: {presale_engagement: number,
 *     sales_order_created: number, project_started: number, invoiced: number, ready_to_invoice: number}, custom_fields:
 *     {production_status: number, project_number: number, print_engine_url: number, project_manager_order_rep: number,
 *     commonsku_project_link: number, google_drive_url: number}}, company: {custom_fields: {company_type: number, print_engine_url:
 *     number, commonsku_company_link: number, estimated_annual_spend: number, company_code: number, google_drive_url: number}}}, secret:
 *     (string|*|string), url: string, email: (string|*|string), token: (string|*|string)}}, production: {tenant: {account_id: number, ids:
 *     {opportunity: {pipeline_stages: {presale_engagement: number, sales_order_created: number, project_started: number, invoiced: number,
 *     ready_to_invoice: number}, custom_fields: {production_status: number, project_number: number, print_engine_url: number,
 *     project_manager_order_rep: number, commonsku_project_link: number, google_drive_url: number}}, company: {custom_fields:
 *     {company_type: number, print_engine_url: number, commonsku_company_link: number, estimated_annual_spend: number, company_code:
 *     number, google_drive_url: number}}}, secret: (string|*|string), url: string, email: (string|*|string), token: (string|*|string)}},
 *     staging: {tenant: {account_id: number, ids: {opportunity: {pipeline_stages: {presale_engagement: number, sales_order_created:
 *     number, project_started: number, invoiced: number, ready_to_invoice: number}, custom_fields: {production_status: number,
 *     project_number: number, print_engine_url: number, project_manager_order_rep: number, commonsku_project_link: number,
 *     google_drive_url: number}}, company: {custom_fields: {company_type: number, print_engine_url: number, commonsku_company_link:
 *     number, estimated_annual_spend: number, company_code: number, google_drive_url: number}}}, secret: (string|*|string), url: string,
 *     email: (string|*|string), token: (string|*|string)}}, local: {tenant: {account_id: number, ids: {opportunity: {pipeline_stages:
 *     {presale_engagement: number, sales_order_created: number, project_started: number, invoiced: number, ready_to_invoice: number},
 *     custom_fields: {production_status: number, project_number: number, print_engine_url: number, project_manager_order_rep: number,
 *     commonsku_project_link: number, google_drive_url: number}}, company: {custom_fields: {company_type: number, print_engine_url:
 *     number, commonsku_company_link: number, estimated_annual_spend: number, company_code: number, google_drive_url: number}}}, secret:
 *     (string|*|string), url: string, email: (string|*|string), token: (string|*|string)}}}}
 */ var Configuration = {
    "production": {
        "tenant": {
            "account_id": 74171,
            "url": "https://api.copper.com/developer_api/v1",
            "email": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["P_COPPER_EMAIL"]) ? "".concat(process.env["P_COPPER_EMAIL"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["COPPER_EMAIL"]) ? process.env["COPPER_EMAIL"] : "",
            "token": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["P_COPPER_TOKEN"]) ? "".concat(process.env["P_COPPER_TOKEN"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["COPPER_TOKEN"]) ? process.env["COPPER_TOKEN"] : "",
            "secret": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["P_COPPER_SECRET"]) ? "".concat(process.env["P_COPPER_SECRET"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["COPPER_SECRET"]) ? process.env["COPPER_SECRET"] : "",
            "ids": {
                "company": {
                    "custom_fields": {
                        "company_type": 93510,
                        "estimated_annual_spend": 486868,
                        "company_code": 497325,
                        "print_engine_url": 472853,
                        "google_drive_url": 527676,
                        "commonsku_company_link": 481765
                    }
                },
                "opportunity": {
                    "custom_fields": {
                        "production_status": 485513,
                        "project_manager_order_rep": 483694,
                        "project_number": 497335,
                        "print_engine_url": 472750,
                        "google_drive_url": 484418,
                        "commonsku_project_link": 449970
                    },
                    "pipeline_stages": {
                        "presale_engagement": 3807939,
                        "project_started": 724338,
                        "sales_order_created": 3689981,
                        "ready_to_invoice": 3670607,
                        "invoiced": 3826964
                    }
                }
            }
        }
    },
    "staging": {
        "tenant": {
            "account_id": 399031,
            "url": "https://api.copper.com/developer_api/v1",
            "email": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["S_COPPER_EMAIL"]) ? "".concat(process.env["S_COPPER_EMAIL"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["COPPER_EMAIL"]) ? process.env["COPPER_EMAIL"] : "",
            "token": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["S_COPPER_TOKEN"]) ? "".concat(process.env["S_COPPER_TOKEN"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["COPPER_TOKEN"]) ? process.env["COPPER_TOKEN"] : "",
            "secret": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["S_COPPER_SECRET"]) ? "".concat(process.env["S_COPPER_SECRET"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["COPPER_SECRET"]) ? process.env["COPPER_SECRET"] : "",
            "ids": {
                "company": {
                    "custom_fields": {
                        "company_type": 497096,
                        "estimated_annual_spend": 495558,
                        "company_code": 519156,
                        "print_engine_url": 503680,
                        "google_drive_url": 503682,
                        "commonsku_company_link": 503683
                    }
                },
                "opportunity": {
                    "custom_fields": {
                        "production_status": 497098,
                        "project_manager_order_rep": 495559,
                        "project_number": 519157,
                        "print_engine_url": 503680,
                        "google_drive_url": 503682,
                        "commonsku_project_link": 503683
                    },
                    "pipeline_stages": {
                        "presale_engagement": 4026429,
                        "project_started": 4026430,
                        "sales_order_created": 4026431,
                        "ready_to_invoice": 4044870,
                        "invoiced": 4044871
                    }
                }
            }
        }
    },
    "development": {
        "tenant": {
            "account_id": 399031,
            "url": "https://api.copper.com/developer_api/v1",
            "email": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["D_COPPER_EMAIL"]) ? "".concat(process.env["D_COPPER_EMAIL"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["COPPER_EMAIL"]) ? process.env["COPPER_EMAIL"] : "",
            "token": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["D_COPPER_TOKEN"]) ? "".concat(process.env["D_COPPER_TOKEN"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["COPPER_TOKEN"]) ? process.env["COPPER_TOKEN"] : "",
            "secret": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["D_COPPER_SECRET"]) ? "".concat(process.env["D_COPPER_SECRET"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["COPPER_SECRET"]) ? process.env["COPPER_SECRET"] : "",
            "ids": {
                "company": {
                    "custom_fields": {
                        "company_type": 497096,
                        "estimated_annual_spend": 495558,
                        "company_code": 519156,
                        "print_engine_url": 503680,
                        "google_drive_url": 503682,
                        "commonsku_company_link": 503683
                    }
                },
                "opportunity": {
                    "custom_fields": {
                        "production_status": 497098,
                        "project_manager_order_rep": 495559,
                        "project_number": 519157,
                        "print_engine_url": 503680,
                        "google_drive_url": 503682,
                        "commonsku_project_link": 503683
                    },
                    "pipeline_stages": {
                        "presale_engagement": 4026429,
                        "project_started": 4026430,
                        "sales_order_created": 4026431,
                        "ready_to_invoice": 4044870,
                        "invoiced": 4044871
                    }
                }
            }
        }
    },
    "local": {
        "tenant": {
            "account_id": 399031,
            "url": "https://api.copper.com/developer_api/v1",
            "email": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["L_COPPER_EMAIL"]) ? "".concat(process.env["L_COPPER_EMAIL"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["COPPER_EMAIL"]) ? process.env["COPPER_EMAIL"] : "",
            "token": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["L_COPPER_TOKEN"]) ? "".concat(process.env["L_COPPER_TOKEN"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["COPPER_TOKEN"]) ? process.env["COPPER_TOKEN"] : "",
            "secret": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["L_COPPER_SECRET"]) ? "".concat(process.env["L_COPPER_SECRET"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["COPPER_SECRET"]) ? process.env["COPPER_SECRET"] : "",
            "ids": {
                "company": {
                    "custom_fields": {
                        "company_type": 497096,
                        "estimated_annual_spend": 495558,
                        "company_code": 519156,
                        "print_engine_url": 503680,
                        "google_drive_url": 503682,
                        "commonsku_company_link": 503683
                    }
                },
                "opportunity": {
                    "custom_fields": {
                        "production_status": 497098,
                        "project_manager_order_rep": 495559,
                        "project_number": 519157,
                        "print_engine_url": 503680,
                        "google_drive_url": 503682,
                        "commonsku_project_link": 503683
                    },
                    "pipeline_stages": {
                        "presale_engagement": 4026429,
                        "project_started": 4026430,
                        "sales_order_created": 4026431,
                        "ready_to_invoice": 4044870,
                        "invoiced": 4044871
                    }
                }
            }
        }
    }
};
/**
 * Copper Integration
 * @class   Copper
 * @extends Integration
 */ var Copper = /*#__PURE__*/ function(Integration1) {
    "use strict";
    _inherits(Copper, Integration1);
    var _super = _createSuper(Copper);
    function Copper() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Copper);
        var _this;
        var default_args = {
            "environment": null,
            "application": "tenant",
            "context": null,
            "scope": null,
            "email": null,
            "token": null,
            "tenant_id": null,
            "source_id": "3428514535649076"
        };
        var args = _objectSpread({}, default_args, user_args);
        _this = _super.call(this, args);
        _this.args = _objectSpread({}, args, {
            "name": "Copper",
            "class_name": _this.constructor["name"],
            "reference_name": "copper",
            "description": "Copper (formerly ProsperWorks CRM) is a productivity CRM software designed for companies that love G Suite and use solutions such as GMail, Google Calendar, and Google Sheets. The Copper Web API allows you to access and build your own applications that interact with Copper in more complex ways than the integrations we provide out of the box.",
            "documentation_url": "https://developer.copper.com/"
        });
        try {
            if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["tenant_id"])) {
                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)((_this.args["secret"] || {})["tenant_id"])) {
                    _this.args["tenant_id"] = _this.args["secret"]["tenant_id"];
                }
            }
            _this.set_bindings();
            _this.set_configuration(Configuration);
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/copper -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(error["message"])) {
                throw error["message"];
            } else {
                throw error;
            }
        }
        return _this;
    }
    _createClass(Copper, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.request = this.request.bind(this);
                this.get_account = this.get_account.bind(this);
            }
        },
        {
            key: "request",
            value: /**
	 * Performs a network request to Copper.
	 *
	 * @param method
	 * @param endpoint
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function request1() {
                var method = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", endpoint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", user_args = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response, request, remote_response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "parameters": {},
                                    "data": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                if (!((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["context"]) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.configuration) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(method) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(endpoint))) {
                                    _ctx.next = 6;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 6:
                                method = String(method).toUpperCase();
                                request = {
                                    "baseURL": _this.configuration["url"],
                                    "headers": {
                                        "X-PW-UserEmail": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["email"]) ? "".concat(_this.args["email"]) : "".concat(_this.configuration["email"]),
                                        "X-PW-AccessToken": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["token"]) ? "".concat(_this.args["token"]) : "".concat(_this.configuration["token"]),
                                        "X-PW-Application": "developer_api",
                                        "Content-Type": "application/json"
                                    },
                                    "timeout": 30000,
                                    "url": "".concat(endpoint),
                                    "method": "".concat(method)
                                };
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args)) {
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["parameters"])) {
                                        request["params"] = args["parameters"];
                                    }
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["data"])) {
                                        if ([
                                            "PUT",
                                            "POST",
                                            "DELETE",
                                            "PATCH"
                                        ].includes(method)) {
                                            request["data"] = args["data"];
                                        }
                                    }
                                }
                                _ctx.next = 11;
                                return axios__WEBPACK_IMPORTED_MODULE_1___default()(request);
                            case 11:
                                remote_response = _ctx.sent;
                                //console.log( 'remote_response:' );
                                //console.log( remote_response );
                                //console.log( util.inspect( remote_response, false, null, true ) );
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(remote_response["data"])) {
                                    response = remote_response["data"];
                                }
                                return _ctx.abrupt("return", response);
                            case 16:
                                _ctx.prev = 16;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/copper -> request():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": {
                                                "method": method,
                                                "endpoint": endpoint,
                                                "user_args": user_args
                                            }
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 23;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 23:
                                throw _ctx.t0;
                            case 24:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            16
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get_account",
            value: /**
	 * Fetch Account Details
	 *
	 * @documentation https://developer.copper.com/account-and-users/fetch-account-details.html
	 * @endpoint https://app.copper.com/developer_api/v1/account
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function get_account() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {};
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                _ctx.next = 6;
                                return _this.request("get", "/account");
                            case 6:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 10:
                                _ctx.prev = 10;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/copper -> get_account():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 17;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 17:
                                throw _ctx.t0;
                            case 18:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            10
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Copper;
}(_print_engine_utilities_integration_js__WEBPACK_IMPORTED_MODULE_3__.Integration);


/***/ }),

/***/ 26451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Custom_Fields": function() { return /* binding */ Custom_Fields; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _copper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15446);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93909);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * Copper Integration
 * @class   Custom_Fields
 * @extends Copper
 */ var Custom_Fields = /*#__PURE__*/ function(Copper1) {
    "use strict";
    _inherits(Custom_Fields, Copper1);
    var _super = _createSuper(Custom_Fields);
    function Custom_Fields() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Custom_Fields);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/copper/custom_fields -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(error["message"])) {
                throw error["message"];
            } else {
                throw error;
            }
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Custom_Fields, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * Create a new custom field definition
	 *
	 * @documentation https://developer.copper.com/custom-fields/general/create-a-new-custom-field-definition.html
	 * @endpoint https://app.copper.com/developer_api/v1/custom_field_definitions
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "name": "",
                                    "data_type": "",
                                    "available_on": [],
                                    "options": []
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                _ctx.next = 6;
                                return _this.request("post", "/custom_field_definitions", {
                                    "data": args
                                });
                            case 6:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 10:
                                _ctx.prev = 10;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/custom_fields -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 17;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 17:
                                throw _ctx.t0;
                            case 18:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            10
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * Fetch a Custom Field Definition
	 *
	 * @documentation https://developer.copper.com/custom-fields/general/fetch-a-custom-field-definition.html
	 * @endpoint https://app.copper.com/developer_api/v1/custom_field_definitions/{{custom_field_definition_id}}
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                _ctx.next = 6;
                                return _this.request("get", "/custom_field_definitions/".concat(args["id"]));
                            case 6:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 10:
                                _ctx.prev = 10;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/custom_fields -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 17;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 17:
                                throw _ctx.t0;
                            case 18:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            10
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * List Custom Field Definition
	 *
	 * @documentation https://developer.copper.com/custom-fields/general/list-custom-field-definitions.html
	 * @endpoint https://app.copper.com/developer_api/v1/custom_field_definitions
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<*[]|boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee1() {
                    var default_args, args, response, custom_fields, requests, batches;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx1) {
                        while(1)switch(_ctx1.prev = _ctx1.next){
                            case 0:
                                default_args = {
                                    "entity_object": {},
                                    "entity_type": "",
                                    "field_ids": [],
                                    "name": "",
                                    "data_type": "",
                                    "options": []
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx1.prev = 3;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["entity_object"])) {
                                    _ctx1.next = 10;
                                    break;
                                }
                                _ctx1.next = 7;
                                return _this.request("get", "/custom_field_definitions", {
                                    "parameters": args
                                });
                            case 7:
                                response = _ctx1.sent;
                                _ctx1.next = 20;
                                break;
                            case 10:
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["entity_object"]["custom_fields"])) {
                                    _ctx1.next = 12;
                                    break;
                                }
                                return _ctx1.abrupt("return", response);
                            case 12:
                                custom_fields = [];
                                requests = {};
                                args["entity_object"]["custom_fields"].map(function(item) {
                                    var request = {
                                        "callback": _this.get,
                                        "args": {
                                            "id": item["custom_field_definition_id"]
                                        }
                                    };
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["field_ids"])) {
                                        if (args["field_ids"].includes(item["custom_field_definition_id"])) {
                                            requests[item["custom_field_definition_id"]] = request;
                                        }
                                    } else {
                                        requests[item["custom_field_definition_id"]] = request;
                                    }
                                });
                                _ctx1.next = 17;
                                return (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.process_in_batches)(requests, 5);
                            case 17:
                                batches = _ctx1.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(batches)) {
                                    Object.keys(batches).map(function() {
                                        var _ref1 = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(batch_number) {
                                            var promises;
                                            return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx2) {
                                                while(1)switch(_ctx2.prev = _ctx2.next){
                                                    case 0:
                                                        promises = args["entity_object"]["custom_fields"].map(function() {
                                                            var _ref = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(custom_field) {
                                                                var value, connected_field;
                                                                return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                                                    while(1)switch(_ctx.prev = _ctx.next){
                                                                        case 0:
                                                                            if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(batches[batch_number][custom_field["custom_field_definition_id"]])) {
                                                                                _ctx.next = 9;
                                                                                break;
                                                                            }
                                                                            value = custom_field["value"];
                                                                            if (batches[batch_number][custom_field["custom_field_definition_id"]]["data_type"] === "Dropdown") {
                                                                                batches[batch_number][custom_field["custom_field_definition_id"]]["options"].map(function(option) {
                                                                                    if (option["id"] === custom_field["value"]) {
                                                                                        value = option["name"];
                                                                                    }
                                                                                });
                                                                            }
                                                                            if (!(batches[batch_number][custom_field["custom_field_definition_id"]]["data_type"] === "Connect")) {
                                                                                _ctx.next = 8;
                                                                                break;
                                                                            }
                                                                            _ctx.next = 6;
                                                                            return _this.request("get", "/related_links", {
                                                                                parameters: {
                                                                                    "custom_field_definition_id": custom_field["custom_field_definition_id"],
                                                                                    "source_type": args["entity_type"],
                                                                                    "source_id": args["entity_object"]["id"]
                                                                                }
                                                                            });
                                                                        case 6:
                                                                            connected_field = _ctx.sent;
                                                                            value = !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(((connected_field[0] || {})["target"] || {})["id"]) ? connected_field[0]["target"]["id"] : "";
                                                                        case 8:
                                                                            custom_fields.push({
                                                                                "id": custom_field["custom_field_definition_id"],
                                                                                "code": (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.sanitize_string)(batches[batch_number][custom_field["custom_field_definition_id"]]["name"], "upper", "_"),
                                                                                "name": batches[batch_number][custom_field["custom_field_definition_id"]]["name"],
                                                                                "value": value
                                                                            });
                                                                        case 9:
                                                                        case "end":
                                                                            return _ctx.stop();
                                                                    }
                                                                }, _callee);
                                                            }));
                                                            return function(custom_field) {
                                                                return _ref.apply(this, arguments);
                                                            };
                                                        }());
                                                        _ctx2.next = 3;
                                                        return Promise.all(promises);
                                                    case 3:
                                                    case "end":
                                                        return _ctx2.stop();
                                                }
                                            }, _callee2);
                                        }));
                                        return function(batch_number) {
                                            return _ref1.apply(this, arguments);
                                        };
                                    }());
                                }
                                response = custom_fields;
                            case 20:
                                return _ctx1.abrupt("return", response);
                            case 23:
                                _ctx1.prev = 23;
                                _ctx1.t0 = _ctx1["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/custom_fields -> list():", {
                                        "error": _ctx1.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_ctx1.t0["message"])) {
                                    _ctx1.next = 30;
                                    break;
                                }
                                throw _ctx1.t0["message"];
                            case 30:
                                throw _ctx1.t0;
                            case 31:
                            case "end":
                                return _ctx1.stop();
                        }
                    }, _callee1, null, [
                        [
                            3,
                            23
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * Update an existing custom field definition
	 *
	 * @documentation https://developer.copper.com/custom-fields/general/update-an-existing-custom-field-definition.html
	 * @endpoint https://app.copper.com/developer_api/v1/custom_field_definitions/{{custom_field_definition_id}}
	 * @method PUT
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "id": 0,
                                    "name": "",
                                    "data_type": "",
                                    "available_on": [],
                                    "options": []
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                _ctx.next = 6;
                                return _this.request("put", "/custom_field_definitions/".concat(args["id"]), {
                                    "data": args
                                });
                            case 6:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 10:
                                _ctx.prev = 10;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/custom_fields -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 17;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 17:
                                throw _ctx.t0;
                            case 18:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            10
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * Delete a Custom Field Definition
	 *
	 * @documentation https://developer.copper.com/custom-fields/general/delete-a-custom-field-definition.html
	 * @endpoint https://app.copper.com/developer_api/v1/custom_field_definitions/{{custom_field_definition_id}}
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                _ctx.next = 6;
                                return _this.request("delete", "/custom_field_definitions/".concat(args["id"]));
                            case 6:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 10:
                                _ctx.prev = 10;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/custom_fields -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 17;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 17:
                                throw _ctx.t0;
                            case 18:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            10
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Custom_Fields;
}(_copper_js__WEBPACK_IMPORTED_MODULE_1__.Copper);


/***/ }),

/***/ 61564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Opportunities": function() { return /* binding */ Opportunities; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _copper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15446);
/* harmony import */ var _custom_fields_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26451);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93909);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




/**
 * Copper Integration
 * @class   Opportunities
 * @extends Copper
 */ var Opportunities = /*#__PURE__*/ function(Copper1) {
    "use strict";
    _inherits(Opportunities, Copper1);
    var _super = _createSuper(Opportunities);
    function Opportunities() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Opportunities);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/copper/opportunities -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(error["message"])) {
                throw error["message"];
            } else {
                throw error;
            }
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Opportunities, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * Create a New Opportunity
	 *
	 * @documentation https://developer.copper.com/opportunities/create-a-new-opportunity.html
	 * @endpoint https://app.copper.com/developer_api/v1/opportunities
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "name": "",
                                    "custom_fields": []
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                _ctx.next = 6;
                                return _this.request("post", "/opportunities", {
                                    "data": args
                                });
                            case 6:
                                response = _ctx.sent;
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/opportunities -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 18;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 18:
                                throw _ctx.t0;
                            case 19:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * Fetch an Opportunity by ID
	 *
	 * @documentation https://developer.copper.com/opportunities/fetch-an-opportunity-by-id.html
	 * @endpoint https://app.copper.com/developer_api/v1/opportunities/{{example_opportunity_id}}
	 * @method GET
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<boolean>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(args["id"])) {
                                    _ctx.next = 6;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 6:
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 20;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/opportunities/".concat(args["id"]));
                            case 14:
                                response = _ctx.sent;
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(response)) {
                                    _ctx.next = 20;
                                    break;
                                }
                                _ctx.next = 18;
                                return _this.get_custom_fields(response);
                            case 18:
                                response["custom_fields"] = _ctx.sent;
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                            case 20:
                                return _ctx.abrupt("return", response);
                            case 23:
                                _ctx.prev = 23;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/opportunities -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 30;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 30:
                                throw _ctx.t0;
                            case 31:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            23
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * List Opportunities (Search)
	 *
	 * @documentation https://developer.copper.com/opportunities/list-opportunities-search.html
	 * @endpoint https://app.copper.com/developer_api/v1/opportunities/search
	 * @method POST
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "page_number": 1,
                                    "page_size": 20,
                                    "sort_by": "name",
                                    "sort_direction": "asc"
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 10;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 14;
                                break;
                            case 10:
                                _ctx.next = 12;
                                return _this.request("post", "/opportunities/search", {
                                    "data": args
                                });
                            case 12:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                    if (Array.isArray(response) && response["length"] > 0) {
                                        response.map(function(result) {
                                            _this.cache.set(_this.constructor["name"], JSON.stringify({
                                                "id": result["id"]
                                            }), result);
                                        });
                                    }
                                }
                            case 14:
                                return _ctx.abrupt("return", response);
                            case 17:
                                _ctx.prev = 17;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/opportunities -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 24;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 24:
                                throw _ctx.t0;
                            case 25:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            17
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * Update an Opportunity
	 *
	 * @documentation https://developer.copper.com/opportunities/update-an-opportunity.html
	 * @endpoint https://app.copper.com/developer_api/v1/opportunities/{{example_opportunity_id}}
	 * @method PUT
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(args["id"])) {
                                    _ctx.next = 6;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 6:
                                _ctx.next = 8;
                                return _this.request("put", "/opportunities/".concat(args["id"]), {
                                    "data": args
                                });
                            case 8:
                                response = _ctx.sent;
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/opportunities -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 20;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 20:
                                throw _ctx.t0;
                            case 21:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * Delete an Opportunity
	 *
	 * @documentation https://developer.copper.com/opportunities/delete-an-opportunity.html
	 * @endpoint https://app.copper.com/developer_api/v1/opportunities/{{delete_opportunity_id}}
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(args["id"])) {
                                    _ctx.next = 6;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 6:
                                _ctx.next = 8;
                                return _this.request("delete", "/opportunities/".concat(args["id"]));
                            case 8:
                                response = _ctx.sent;
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/opportunities -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 20;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 20:
                                throw _ctx.t0;
                            case 21:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get_custom_fields",
            value: /**
	 *
	 * @param entity_object
	 * @returns {Promise<*[]|boolean>}
	 */ function get_custom_fields() {
                var entity_object = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var Custom_Fields;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.prev = 0;
                                Custom_Fields = new _custom_fields_js__WEBPACK_IMPORTED_MODULE_2__.Custom_Fields(_this.args);
                                _ctx.next = 4;
                                return Custom_Fields.list({
                                    "entity_object": entity_object,
                                    "entity_type": "opportunity",
                                    "field_ids": Object.values(_this.configuration["ids"]["opportunity"]["custom_fields"])
                                });
                            case 4:
                                return _ctx.abrupt("return", _ctx.sent);
                            case 7:
                                _ctx.prev = 7;
                                _ctx.t0 = _ctx["catch"](0);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/opportunities -> get_custom_fields():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": entity_object
                                        },
                                        "configuration": _this.configuration
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 14;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 14:
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            7
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Opportunities;
}(_copper_js__WEBPACK_IMPORTED_MODULE_1__.Copper);


/***/ }),

/***/ 3500:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Users": function() { return /* binding */ Users; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _copper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15446);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93909);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * Copper Integration
 * @class   Users
 * @extends Copper
 */ var Users = /*#__PURE__*/ function(Copper1) {
    "use strict";
    _inherits(Users, Copper1);
    var _super = _createSuper(Users);
    function Users() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Users);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/copper/users -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(error["message"])) {
                throw error["message"];
            } else {
                throw error;
            }
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Users, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
            }
        },
        {
            key: "get",
            value: /**
	 * Fetch User by ID
	 *
	 * @documentation https://developer.copper.com/account-and-users/fetch-user-by-id.html
	 * @endpoint https://app.copper.com/developer_api/v1/users/{{example_user_id}}
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "id": 0,
                                    "name": "",
                                    "email": ""
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["id"])) {
                                    _ctx.next = 6;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 6:
                                cache = _this.cache.get(_this.constructor["name"], args["id"]);
                                if (!cache) {
                                    _ctx.next = 11;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 15;
                                break;
                            case 11:
                                _ctx.next = 13;
                                return _this.request("get", "/users/".concat(args["id"]));
                            case 13:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], args["id"], response);
                                }
                            case 15:
                                return _ctx.abrupt("return", response);
                            case 18:
                                _ctx.prev = 18;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/users -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 25;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 25:
                                throw _ctx.t0;
                            case 26:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            18
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * List Users
	 *
	 * @documentation https://developer.copper.com/account-and-users/list-users.html
	 * @endpoint https://app.copper.com/developer_api/v1/users/search
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "page_number": 1,
                                    "page_size": 20,
                                    "sort_by": "name",
                                    "sort_direction": "asc"
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                _ctx.next = 6;
                                return _this.request("post", "/users/search", {
                                    "data": args
                                });
                            case 6:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 10:
                                _ctx.prev = 10;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/users -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 17;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 17:
                                throw _ctx.t0;
                            case 18:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            10
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Users;
}(_copper_js__WEBPACK_IMPORTED_MODULE_1__.Copper);


/***/ }),

/***/ 88233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Company_Webhook": function() { return /* binding */ Company_Webhook; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _webhooks_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(65149);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93909);
/* harmony import */ var _print_engine_netlify_netlify_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(33383);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




/**
 * Copper Integration
 * @class   Company_Webhook
 * @extends Webhooks
 */ var Company_Webhook = /*#__PURE__*/ function(Webhooks1) {
    "use strict";
    _inherits(Company_Webhook, Webhooks1);
    var _super = _createSuper(Company_Webhook);
    function Company_Webhook() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Company_Webhook);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/copper/webhooks/company_webhook -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(error["message"])) {
                throw error["message"];
            } else {
                throw error;
            }
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Company_Webhook, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.process = this.process.bind(this);
                this.process_client = this.process_client.bind(this);
                this.create_client = this.create_client.bind(this);
                this.update_client = this.update_client.bind(this);
            }
        },
        {
            key: "process",
            value: /**
	 * Processes the webhook.
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function process() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response, copper_object, company_type;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "event": "",
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                console.log("@imprint-engine/copper/webhooks/company_webhook -> process():");
                                if (!((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["event"]) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["id"]))) {
                                    _ctx.next = 8;
                                    break;
                                }
                                console.log("[Copper]: Missing event or id.");
                                return _ctx.abrupt("return", response);
                            case 8:
                                _ctx.next = 10;
                                return _this.integrations["copper"]["companies"].get(args, true);
                            case 10:
                                copper_object = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(copper_object)) {
                                    _ctx.next = 14;
                                    break;
                                }
                                console.log("[Copper]: Company not found.", args["id"]);
                                return _ctx.abrupt("return", response);
                            case 14:
                                console.log('[Copper]: Entity -> "company".', copper_object["id"]);
                                company_type = String((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.list_pluck)(copper_object["custom_fields"], "value", {
                                    "id": _this.configuration["ids"]["company"]["custom_fields"]["company_type"]
                                })).toLowerCase();
                                if (![
                                    "client",
                                    "vendor"
                                ].includes(company_type)) {
                                    company_type = "client";
                                }
                                if (!(company_type === "client")) {
                                    _ctx.next = 23;
                                    break;
                                }
                                _ctx.next = 20;
                                return _this["process_client"](args, copper_object);
                            case 20:
                                response = _ctx.sent;
                                _ctx.next = 25;
                                break;
                            case 23:
                                console.log("[Copper]: Invalid company type.");
                                return _ctx.abrupt("return", response);
                            case 25:
                                return _ctx.abrupt("return", response);
                            case 28:
                                _ctx.prev = 28;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/webhooks/company_webhook -> process():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 35;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 35:
                                throw _ctx.t0;
                            case 36:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            28
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "process_client",
            value: /**
	 * Processes the webhook for a client.
	 * @param user_args
	 * @param copper_company
	 * @returns {Promise<boolean>}
	 */ function process_client() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, copper_company = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response, pim_client, _pim_client, pim_client_account_manager, hasura_payload, copper_payload, attributes;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "event": "",
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                console.log("@imprint-engine/copper/webhooks/company_webhook -> process_client():");
                                if (!((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["event"]) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["id"]))) {
                                    _ctx.next = 8;
                                    break;
                                }
                                console.log("[Copper]: Missing event or id.");
                                return _ctx.abrupt("return", response);
                            case 8:
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(copper_company)) {
                                    _ctx.next = 11;
                                    break;
                                }
                                console.log("[Copper]: Company not found.", args["id"]);
                                return _ctx.abrupt("return", response);
                            case 11:
                                console.log("[Hasura]: Logging Copper company object to the source event queue.");
                                _ctx.next = 14;
                                return _this.integrations["hasura"]["source_event_queue"].create({
                                    "source_id": 3428514535649076,
                                    "collection_id": 3449689559112548,
                                    "payload": {
                                        "args": _this.args,
                                        "data": copper_company
                                    }
                                });
                            case 14:
                                console.log('[Copper]: Event Type -> "Client".', copper_company["id"]);
                                pim_client = {};
                                _ctx.next = 18;
                                return _this.integrations["hasura"]["clients"].get({
                                    "source_id": _this.args["source_id"],
                                    "source_ref": copper_company["id"]
                                }, true);
                            case 18:
                                _pim_client = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_pim_client["results"])) {
                                    pim_client = _pim_client["results"];
                                }
                                _ctx.next = 22;
                                return _this.integrations["hasura"]["users"].get({
                                    "source_id": _this.args["source_id"],
                                    "source_ref": copper_company["assignee_id"]
                                }, true);
                            case 22:
                                pim_client_account_manager = _ctx.sent;
                                hasura_payload = {
                                    "name": copper_company["name"],
                                    "tenant_id": Number(_this.args["tenant_id"]),
                                    "source_id": Number(_this.args["source_id"]),
                                    "source_ref": String(copper_company["id"]),
                                    "attributes": []
                                };
                                copper_payload = {
                                    "id": copper_company["id"],
                                    "custom_fields": []
                                };
                                attributes = {
                                    3428512981659433: "",
                                    3437051064188788: "",
                                    3428512979562279: "",
                                    3437050795753328: "",
                                    3437050250493804: "",
                                    3437576037957551: "",
                                    3437576004403117: "" // Google Drive Projects Folder ID
                                };
                                if (!(args["event"] === "new" && (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(pim_client) || args["event"] === "update" && (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(pim_client))) {
                                    _ctx.next = 31;
                                    break;
                                }
                                console.log('[Copper]: Event -> "create".');
                                _ctx.next = 30;
                                return _this.create_client(copper_company, copper_payload, pim_client, pim_client_account_manager, attributes, hasura_payload);
                            case 30:
                                response = _ctx.sent;
                            case 31:
                                if (!(args["event"] === "update" && !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(pim_client))) {
                                    _ctx.next = 36;
                                    break;
                                }
                                console.log('[Copper]: Event -> "update".');
                                _ctx.next = 35;
                                return _this.update_client(copper_company, copper_payload, pim_client, pim_client_account_manager, attributes, hasura_payload);
                            case 35:
                                response = _ctx.sent;
                            case 36:
                                return _ctx.abrupt("return", response);
                            case 39:
                                _ctx.prev = 39;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/webhooks/company_webhook -> process_client():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": {
                                                "user_args": user_args,
                                                "copper_object": copper_company
                                            }
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 46;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 46:
                                throw _ctx.t0;
                            case 47:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            39
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "create_client",
            value: /**
	 *
	 * @param copper_company
	 * @param copper_payload
	 * @param pim_client
	 * @param pim_client_account_manager
	 * @param attributes
	 * @param hasura_payload
	 * @returns {Promise<{copper: {}, hasura: {}}>}
	 */ function create_client() {
                var copper_company = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, copper_payload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, pim_client = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, pim_client_account_manager = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, attributes = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, hasura_payload = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                response = {
                                    "hasura": {},
                                    "copper": {}
                                };
                                _ctx.prev = 1;
                                console.log("@imprint-engine/copper/webhooks/company_webhook -> create_client():");
                                // Create database entity
                                console.log('[Hasura]: Create Entity -> "Client/Organization".');
                                _ctx.next = 6;
                                return _this.integrations["hasura"]["clients"].create({
                                    "payload": [
                                        _objectSpread({}, hasura_payload, {
                                            "attributes": [
                                                {
                                                    "attribute_id": 3428512981659433,
                                                    "attribute_value": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)((pim_client_account_manager["results"] || {})["id"]) ? pim_client_account_manager["results"]["id"] : ""
                                                },
                                                {
                                                    "attribute_id": 3437050795753328,
                                                    "attribute_value": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.list_pluck)(copper_company["custom_fields"], "value", {
                                                        "id": _this.configuration["ids"]["company"]["custom_fields"]["commonsku_company_link"]
                                                    })) ? (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.list_pluck)(copper_company["custom_fields"], "value", {
                                                        "id": _this.configuration["ids"]["company"]["custom_fields"]["commonsku_company_link"]
                                                    }) : ""
                                                },
                                                {
                                                    "attribute_id": 3437051064188788,
                                                    "attribute_value": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.list_pluck)(copper_company["custom_fields"], "value", {
                                                        "id": _this.configuration["ids"]["company"]["custom_fields"]["estimated_annual_spend"]
                                                    })) ? (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.list_pluck)(copper_company["custom_fields"], "value", {
                                                        "id": _this.configuration["ids"]["company"]["custom_fields"]["estimated_annual_spend"]
                                                    }) : ""
                                                },
                                                {
                                                    "attribute_id": 3437050250493804,
                                                    "attribute_value": ""
                                                },
                                                {
                                                    "attribute_id": 3437576037957551,
                                                    "attribute_value": ""
                                                },
                                                {
                                                    "attribute_id": 3437576004403117,
                                                    "attribute_value": ""
                                                }
                                            ]
                                        })
                                    ]
                                });
                            case 6:
                                response["hasura"]["create"] = _ctx.sent;
                                pim_client = response["hasura"]["create"]["results"]["entity"][0];
                                pim_client["attributes"].map(function(attribute) {
                                    attributes[[
                                        attribute["attribute_id"]
                                    ]] = attribute["attribute_value"];
                                });
                                // Update Copper entity
                                console.log('[Copper]: Update Entity -> "company".');
                                console.log('[Copper]: Update Custom field -> "Print Engine URL".');
                                console.log('[Copper]: Update Custom field -> "Company Code".');
                                _ctx.next = 14;
                                return _this.integrations["copper"]["companies"].update(_objectSpread({}, copper_payload, {
                                    "name": copper_company["name"],
                                    "custom_fields": [
                                        {
                                            "custom_field_definition_id": _this.configuration["ids"]["company"]["custom_fields"]["print_engine_url"],
                                            "value": "".concat(_print_engine_netlify_netlify_js__WEBPACK_IMPORTED_MODULE_3__.Configuration[_this.args["environment"]][_this.args["application"]]["app"]["url"], "/clients/").concat(pim_client["id"])
                                        },
                                        {
                                            "custom_field_definition_id": _this.configuration["ids"]["company"]["custom_fields"]["company_code"],
                                            "value": "".concat(attributes[3428512979562279])
                                        }
                                    ]
                                }));
                            case 14:
                                response["copper"] = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 18:
                                _ctx.prev = 18;
                                _ctx.t0 = _ctx["catch"](1);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/webhooks/company_webhook -> create_client():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": {
                                                "copper_company": copper_company,
                                                "copper_payload": copper_payload,
                                                "pim_client": pim_client,
                                                "pim_client_account_manager": pim_client_account_manager,
                                                "attributes": attributes,
                                                "hasura_payload": hasura_payload
                                            }
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 25;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 25:
                                throw _ctx.t0;
                            case 26:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            18
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update_client",
            value: /**
	 *
	 * @param copper_company
	 * @param copper_payload
	 * @param pim_client
	 * @param pim_client_account_manager
	 * @param attributes
	 * @param hasura_payload
	 * @returns {Promise<{copper: {}, hasura: {}, google_drive: {}}>}
	 */ function update_client() {
                var copper_company = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, copper_payload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, pim_client = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, pim_client_account_manager = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, attributes = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, hasura_payload = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var response, needs_update, existing_attributes, missing_attributes, client_name, client_code, client_commonsku_url, client_url, company_name, concatenated_company_name, custom_field_print_engine_url, custom_field_commonsku_url, custom_field_company_code, custom_field_estimated_annual_spend;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                response = {
                                    "hasura": {},
                                    "copper": {},
                                    "google_drive": {}
                                };
                                needs_update = {
                                    "hasura": false,
                                    "copper": false,
                                    "google_drive": false
                                };
                                _ctx.prev = 2;
                                console.log("@imprint-engine/copper/webhooks/company_webhook -> update_client():");
                                existing_attributes = {};
                                pim_client["attributes"].map(function(attribute) {
                                    attributes[[
                                        attribute["attribute_id"]
                                    ]] = attribute["attribute_value"];
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(attribute["entity_attribute_id"])) {
                                        existing_attributes[[
                                            attribute["attribute_id"]
                                        ]] = attribute["attribute_value"];
                                    }
                                });
                                missing_attributes = [];
                                Object.keys(attributes).map(function(attribute_id) {
                                    if (!Object.keys(existing_attributes).includes(attribute_id) && (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(attributes[attribute_id])) {
                                        missing_attributes.push({
                                            "attribute_id": attribute_id,
                                            "attribute_value": ""
                                        });
                                    }
                                });
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(missing_attributes)) {
                                    _ctx.next = 12;
                                    break;
                                }
                                console.log("[Hasura]: Create missing attributes.");
                                _ctx.next = 12;
                                return _this.integrations["hasura"]["entity_attributes"].create({
                                    "entity_id": pim_client["id"],
                                    "payload": missing_attributes
                                });
                            case 12:
                                client_name = pim_client["name"];
                                client_code = attributes[3428512979562279];
                                client_commonsku_url = attributes[3437050795753328];
                                client_url = "".concat(_print_engine_netlify_netlify_js__WEBPACK_IMPORTED_MODULE_3__.Configuration[_this.args["environment"]][_this.args["application"]]["app"]["url"], "/clients/").concat(pim_client["id"]);
                                company_name = copper_company["name"];
                                concatenated_company_name = "".concat(company_name, " - ").concat(client_code);
                                custom_field_print_engine_url = (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.list_pluck)(copper_company["custom_fields"], "value", {
                                    "id": _this.configuration["ids"]["company"]["custom_fields"]["print_engine_url"]
                                });
                                custom_field_commonsku_url = (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.list_pluck)(copper_company["custom_fields"], "value", {
                                    "id": _this.configuration["ids"]["company"]["custom_fields"]["commonsku_company_link"]
                                });
                                custom_field_company_code = (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.list_pluck)(copper_company["custom_fields"], "value", {
                                    "id": _this.configuration["ids"]["company"]["custom_fields"]["company_code"]
                                });
                                custom_field_estimated_annual_spend = (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.list_pluck)(copper_company["custom_fields"], "value", {
                                    "id": _this.configuration["ids"]["company"]["custom_fields"]["estimated_annual_spend"]
                                });
                                if (company_name !== client_name) {
                                    console.log("[Hasura]: Update Client/Organization database entity name.");
                                    needs_update["hasura"] = true;
                                    hasura_payload["name"] = company_name;
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(attributes[3437050250493804])) {
                                        console.log("[Google Drive]: Update company/client folder name.");
                                        needs_update["google_drive"] = true;
                                    }
                                }
                                if (String(custom_field_estimated_annual_spend) !== String(attributes[3437051064188788])) {
                                    console.log('[Hasura]: Update Entity Attribute -> "ESTIMATED_ANNUAL_SPEND".');
                                    needs_update["hasura"] = true;
                                    hasura_payload["attributes"].push({
                                        "attribute_id": 3437051064188788,
                                        "attribute_value": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(custom_field_estimated_annual_spend) ? custom_field_estimated_annual_spend : ""
                                    });
                                }
                                if (!(!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)((pim_client_account_manager["results"] || {})["source_ref"]) && !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(copper_company["assignee_id"]) && String(copper_company["assignee_id"]) !== pim_client_account_manager["results"]["source_ref"])) {
                                    _ctx.next = 31;
                                    break;
                                }
                                console.log('[Hasura]: Update Entity Attribute -> "ACCOUNT_MANAGER".');
                                _ctx.next = 28;
                                return _this.integrations["hasura"]["users"].get({
                                    "source_id": _this.args["source_id"],
                                    "source_ref": copper_company["assignee_id"]
                                }, true);
                            case 28:
                                pim_client_account_manager = _ctx.sent;
                                needs_update["hasura"] = true;
                                hasura_payload["attributes"].push({
                                    "attribute_id": 3428512981659433,
                                    "attribute_value": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)((pim_client_account_manager["results"] || {})["id"]) ? pim_client_account_manager["results"]["id"] : ""
                                });
                            case 31:
                                if (String(custom_field_commonsku_url) !== String(client_commonsku_url)) {
                                    console.log('[Hasura]: Update Entity Attribute -> "COMMONSKU_COMPANY_LINK".');
                                    needs_update["hasura"] = true;
                                    hasura_payload["attributes"].push({
                                        "attribute_id": 3437050795753328,
                                        "attribute_value": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(custom_field_commonsku_url) ? custom_field_commonsku_url : ""
                                    });
                                }
                                if (String(custom_field_print_engine_url) !== String(client_url)) {
                                    console.log('[Copper]: Update Custom field -> "Print Engine URL".');
                                    needs_update["copper"] = true;
                                    copper_payload["custom_fields"].push({
                                        "custom_field_definition_id": _this.configuration["ids"]["company"]["custom_fields"]["print_engine_url"],
                                        "value": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(client_url) ? client_url : ""
                                    });
                                }
                                if (custom_field_company_code !== client_code) {
                                    console.log('[Copper]: Update Custom field -> "Company Code".');
                                    needs_update["copper"] = true;
                                    copper_payload["custom_fields"].push({
                                        "custom_field_definition_id": _this.configuration["ids"]["company"]["custom_fields"]["company_code"],
                                        "value": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(client_code) ? client_code : ""
                                    });
                                }
                                if (!needs_update["hasura"]) {
                                    _ctx.next = 41;
                                    break;
                                }
                                // Update Hasura
                                console.log('[Hasura]: Update Entity -> "Client/Organization".', pim_client["id"]);
                                console.log("[Hasura]: Update Entity Attributes:");
                                console.log(hasura_payload["attributes"]);
                                _ctx.next = 40;
                                return _this.integrations["hasura"]["clients"].update({
                                    "payload": [
                                        _objectSpread({}, hasura_payload, {
                                            "id": pim_client["id"]
                                        })
                                    ]
                                });
                            case 40:
                                response["hasura"] = _ctx.sent;
                            case 41:
                                if (!needs_update["google_drive"]) {
                                    _ctx.next = 46;
                                    break;
                                }
                                // Update Google Drive
                                console.log('[Google Drive]: Update Folder -> "'.concat(concatenated_company_name, '".'));
                                _ctx.next = 45;
                                return _this.integrations["google_drive"]["folders"].update({
                                    "fileId": attributes[3437050250493804],
                                    "name": concatenated_company_name
                                });
                            case 45:
                                response["google_drive"]["client"] = _ctx.sent;
                            case 46:
                                if (!needs_update["copper"]) {
                                    _ctx.next = 53;
                                    break;
                                }
                                // Update Copper
                                console.log('[Copper]: Update Entity -> "company".');
                                console.log("[Copper]: Update Custom Fields:");
                                console.log(copper_payload["custom_fields"]);
                                _ctx.next = 52;
                                return _this.integrations["copper"]["companies"].update(copper_payload);
                            case 52:
                                response["copper"] = _ctx.sent;
                            case 53:
                                return _ctx.abrupt("return", response);
                            case 56:
                                _ctx.prev = 56;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/webhooks/company_webhook -> update_client():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": {
                                                "copper_company": copper_company,
                                                "copper_payload": copper_payload,
                                                "pim_client": pim_client,
                                                "pim_client_account_manager": pim_client_account_manager,
                                                "attributes": attributes,
                                                "hasura_payload": hasura_payload
                                            }
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 63;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 63:
                                throw _ctx.t0;
                            case 64:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            56
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Company_Webhook;
}(_webhooks_js__WEBPACK_IMPORTED_MODULE_1__.Webhooks);


/***/ }),

/***/ 15665:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Opportunity_Webhook": function() { return /* binding */ Opportunity_Webhook; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _webhooks_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(65149);
/* harmony import */ var _company_webhook_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88233);
/* harmony import */ var _print_engine_netlify_netlify_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33383);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}





/**
 * Copper Integration
 * @class   Opportunity_Webhook
 * @extends Webhooks
 */ var Opportunity_Webhook = /*#__PURE__*/ function(Webhooks1) {
    "use strict";
    _inherits(Opportunity_Webhook, Webhooks1);
    var _super = _createSuper(Opportunity_Webhook);
    function Opportunity_Webhook() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Opportunity_Webhook);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/copper/webhooks/opportunity_webhook -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(error["message"])) {
                throw error["message"];
            } else {
                throw error;
            }
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Opportunity_Webhook, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.process = this.process.bind(this);
                this.create = this.create.bind(this);
                this.update = this.update.bind(this);
            }
        },
        {
            key: "process",
            value: /**
	 * Processes the webhook.
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function process() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response, copper_opportunity, pim_client, _pim_client, Company_Webhook, client_response, pim_project, _pim_project, pim_project_assignee, pim_project_owner, hasura_payload, copper_payload, attributes;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "event": "",
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                console.log("@imprint-engine/copper/webhooks/opportunity_webhook -> process():");
                                if (!((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["event"]) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"]))) {
                                    _ctx.next = 8;
                                    break;
                                }
                                console.log("[Copper]: Missing event or id.");
                                return _ctx.abrupt("return", response);
                            case 8:
                                _ctx.next = 10;
                                return _this.integrations["copper"]["opportunities"].get(args, true);
                            case 10:
                                copper_opportunity = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(copper_opportunity)) {
                                    _ctx.next = 14;
                                    break;
                                }
                                console.log("[Copper]: Opportunity not found.", args["id"]);
                                return _ctx.abrupt("return", response);
                            case 14:
                                if (Object.values(_this.configuration["ids"]["opportunity"]["pipeline_stages"]).includes(copper_opportunity["pipeline_stage_id"])) {
                                    _ctx.next = 17;
                                    break;
                                }
                                console.log("[Copper]: Opportunity contains invalid pipeline stages.");
                                return _ctx.abrupt("return", response);
                            case 17:
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(copper_opportunity["company_id"])) {
                                    _ctx.next = 20;
                                    break;
                                }
                                console.log("[Copper]: Opportunity not affiliated with a company.");
                                return _ctx.abrupt("return", response);
                            case 20:
                                pim_client = {};
                                _ctx.next = 23;
                                return _this.integrations["hasura"]["clients"].get({
                                    "source_id": _this.args["source_id"],
                                    "source_ref": copper_opportunity["company_id"]
                                }, true);
                            case 23:
                                _pim_client = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_pim_client["results"])) {
                                    _ctx.next = 34;
                                    break;
                                }
                                console.log("[Hasura]: No client/organization found in database.", copper_opportunity["company_id"]);
                                console.log("[Copper]: Simulating new company webhook...");
                                Company_Webhook = new _company_webhook_js__WEBPACK_IMPORTED_MODULE_3__.Company_Webhook(_this.args);
                                _ctx.next = 30;
                                return Company_Webhook.process({
                                    "event": "new",
                                    "id": copper_opportunity["company_id"]
                                });
                            case 30:
                                client_response = _ctx.sent;
                                pim_client = client_response["hasura"]["update"]["results"]["entity"][0];
                                _ctx.next = 35;
                                break;
                            case 34:
                                {
                                    pim_client = _pim_client["results"];
                                }
                            case 35:
                                console.log("[Hasura]: Logging Copper opportunity object to the source event queue.");
                                _ctx.next = 38;
                                return _this.integrations["hasura"]["source_event_queue"].create({
                                    "source_id": 3428514535649076,
                                    "collection_id": 3449689559112548,
                                    "payload": {
                                        "args": _this.args,
                                        "data": copper_opportunity
                                    }
                                });
                            case 38:
                                console.log('[Copper]: Entity -> "opportunity".', copper_opportunity["id"]);
                                pim_project = {};
                                _ctx.next = 42;
                                return _this.integrations["hasura"]["projects"].get({
                                    "source_id": _this.args["source_id"],
                                    "source_ref": copper_opportunity["id"]
                                }, true);
                            case 42:
                                _pim_project = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_pim_project["results"])) {
                                    pim_project = _pim_project["results"];
                                }
                                _ctx.next = 46;
                                return _this.integrations["hasura"]["users"].get({
                                    "source_id": _this.args["source_id"],
                                    "source_ref": copper_opportunity["assignee_id"]
                                }, true);
                            case 46:
                                pim_project_assignee = _ctx.sent;
                                _ctx.next = 49;
                                return _this.integrations["hasura"]["users"].get({
                                    "source_id": _this.args["source_id"],
                                    "source_ref": (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.list_pluck)(copper_opportunity["custom_fields"], "value", {
                                        "id": _this.configuration["ids"]["opportunity"]["custom_fields"]["project_manager_order_rep"]
                                    })
                                }, true);
                            case 49:
                                pim_project_owner = _ctx.sent;
                                hasura_payload = {
                                    "name": copper_opportunity["name"],
                                    "tenant_id": _this.args["tenant_id"],
                                    "source_id": _this.args["source_id"],
                                    "source_ref": copper_opportunity["id"],
                                    "entity_id": pim_client["id"],
                                    "attributes": []
                                };
                                copper_payload = {
                                    "id": copper_opportunity["id"],
                                    "custom_fields": []
                                };
                                attributes = {
                                    3428512977465125: "",
                                    3437901222346691: "",
                                    3437050592329582: "",
                                    3437577203974067: "",
                                    3437579299028923: "",
                                    3437579250794425: "",
                                    3437579607310269: "",
                                    3437579133353909: "",
                                    3437579192074167: "",
                                    3437577143156657: "",
                                    3437579676516287: "",
                                    3437580301467585: "" // Google Drive Internal Project Sheet File ID
                                };
                                if (!(args["event"] === "new" && (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(pim_project) || args["event"] === "update" && (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(pim_project))) {
                                    _ctx.next = 58;
                                    break;
                                }
                                console.log('[Copper]: Event -> "create".');
                                _ctx.next = 57;
                                return _this.create(copper_opportunity, copper_payload, pim_project, pim_project_owner, pim_project_assignee, pim_client, attributes, hasura_payload);
                            case 57:
                                response = _ctx.sent;
                            case 58:
                                if (!(args["event"] === "update" && !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(pim_project))) {
                                    _ctx.next = 63;
                                    break;
                                }
                                console.log('[Copper]: Event -> "update".');
                                _ctx.next = 62;
                                return _this.update(copper_opportunity, copper_payload, pim_project, pim_project_owner, pim_project_assignee, pim_client, attributes, hasura_payload);
                            case 62:
                                response = _ctx.sent;
                            case 63:
                                return _ctx.abrupt("return", response);
                            case 66:
                                _ctx.prev = 66;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/webhooks/opportunity_webhook -> process():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 73;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 73:
                                throw _ctx.t0;
                            case 74:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            66
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "create",
            value: /**
	 *
	 * @param copper_opportunity
	 * @param copper_payload
	 * @param pim_project
	 * @param pim_project_owner
	 * @param pim_project_assignee
	 * @param pim_client
	 * @param attributes
	 * @param hasura_payload
	 * @returns {Promise<{copper: {}, hasura: {}}>}
	 */ function create() {
                var copper_opportunity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, copper_payload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, pim_project = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, pim_project_owner = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, pim_project_assignee = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, pim_client = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, attributes = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : {}, hasura_payload = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var response, project_number, opportunity_name, trimmed_opportunity_name, concatenated_opportunity_name;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                response = {
                                    "hasura": {},
                                    "copper": {}
                                };
                                _ctx.prev = 1;
                                console.log("@imprint-engine/copper/webhooks/opportunity_webhook -> create():");
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)((pim_project_assignee["results"] || {})["id"]) && pim_project_assignee["results"]["id"] > 0) {
                                    hasura_payload["assignee_id"] = pim_project_assignee["results"]["id"];
                                }
                                // Create database entity
                                console.log('[Hasura]: Create Entity -> "Project".');
                                _ctx.next = 7;
                                return _this.integrations["hasura"]["projects"].create({
                                    "payload": [
                                        _objectSpread({}, hasura_payload, {
                                            "attributes": [
                                                {
                                                    "attribute_id": 3437901222346691,
                                                    "attribute_value": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(pim_project_owner["results"]["id"]) ? pim_project_owner["results"]["id"] : ""
                                                },
                                                {
                                                    "attribute_id": 3428512977465125,
                                                    "attribute_value": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.list_pluck)(copper_opportunity["custom_fields"], "value", {
                                                        "id": _this.configuration["ids"]["opportunity"]["custom_fields"]["commonsku_project_link"]
                                                    })) ? (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.list_pluck)(copper_opportunity["custom_fields"], "value", {
                                                        "id": _this.configuration["ids"]["opportunity"]["custom_fields"]["commonsku_project_link"]
                                                    }) : ""
                                                },
                                                {
                                                    "attribute_id": 3437050592329582,
                                                    "attribute_value": ""
                                                },
                                                {
                                                    "attribute_id": 3437577203974067,
                                                    "attribute_value": ""
                                                },
                                                {
                                                    "attribute_id": 3437579299028923,
                                                    "attribute_value": ""
                                                },
                                                {
                                                    "attribute_id": 3437579250794425,
                                                    "attribute_value": ""
                                                },
                                                {
                                                    "attribute_id": 3437579607310269,
                                                    "attribute_value": ""
                                                },
                                                {
                                                    "attribute_id": 3437579133353909,
                                                    "attribute_value": ""
                                                },
                                                {
                                                    "attribute_id": 3437579192074167,
                                                    "attribute_value": ""
                                                },
                                                {
                                                    "attribute_id": 3437577143156657,
                                                    "attribute_value": ""
                                                },
                                                {
                                                    "attribute_id": 3437579676516287,
                                                    "attribute_value": ""
                                                },
                                                {
                                                    "attribute_id": 3437580301467585,
                                                    "attribute_value": ""
                                                }
                                            ]
                                        })
                                    ]
                                });
                            case 7:
                                response["hasura"]["create"] = _ctx.sent;
                                pim_project = response["hasura"]["create"]["results"]["entity"][0];
                                pim_project["attributes"].map(function(attribute) {
                                    attributes[[
                                        attribute["attribute_id"]
                                    ]] = attribute["attribute_value"];
                                });
                                project_number = String(pim_project["project_number"]);
                                opportunity_name = copper_opportunity["name"];
                                trimmed_opportunity_name = opportunity_name.replace(new RegExp("".concat(project_number, " - "), "g"), "");
                                concatenated_opportunity_name = "".concat(project_number, " - ").concat(trimmed_opportunity_name);
                                // Update database entity
                                console.log('[Hasura]: Update Entity -> "Project".');
                                console.log("[Hasura]: Update Entity Attributes:");
                                console.log(hasura_payload["attributes"]);
                                _ctx.next = 19;
                                return _this.integrations["hasura"]["projects"].update({
                                    "payload": [
                                        _objectSpread({}, hasura_payload, {
                                            "id": pim_project["id"],
                                            "name": trimmed_opportunity_name
                                        })
                                    ]
                                });
                            case 19:
                                response["hasura"]["update"] = _ctx.sent;
                                pim_project = response["hasura"]["update"]["results"]["entity"][0];
                                // Update Copper entity
                                console.log('[Copper]: Update Entity -> "Opportunity".');
                                console.log('[Copper]: Custom field -> "Print Engine URL".');
                                console.log('[Copper]: Custom field: -> "Project Number".');
                                _ctx.next = 26;
                                return _this.integrations["copper"]["opportunities"].update(_objectSpread({}, copper_payload, {
                                    "name": concatenated_opportunity_name,
                                    "custom_fields": [
                                        {
                                            "custom_field_definition_id": _this.configuration["ids"]["opportunity"]["custom_fields"]["print_engine_url"],
                                            "value": "".concat(_print_engine_netlify_netlify_js__WEBPACK_IMPORTED_MODULE_4__.Configuration[_this.args["environment"]][_this.args["application"]]["app"]["url"], "/projects/").concat(pim_project["id"])
                                        },
                                        {
                                            "custom_field_definition_id": _this.configuration["ids"]["opportunity"]["custom_fields"]["project_number"],
                                            "value": "".concat(pim_project["project_number"])
                                        }
                                    ]
                                }));
                            case 26:
                                response["copper"] = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 30:
                                _ctx.prev = 30;
                                _ctx.t0 = _ctx["catch"](1);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/webhooks/opportunity_webhook -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": {
                                                "copper_opportunity": copper_opportunity,
                                                "copper_payload": copper_payload,
                                                "pim_project": pim_project,
                                                "pim_project_owner": pim_project_owner,
                                                "pim_project_assignee": pim_project_assignee,
                                                "pim_client": pim_client,
                                                "attributes": attributes,
                                                "hasura_payload": hasura_payload
                                            }
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 37;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 37:
                                throw _ctx.t0;
                            case 38:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            30
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 *
	 * @param copper_opportunity
	 * @param copper_payload
	 * @param pim_project
	 * @param pim_project_owner
	 * @param pim_project_assignee
	 * @param pim_client
	 * @param attributes
	 * @param hasura_payload
	 * @returns {Promise<{copper: {}, hasura: {}, google_drive: {}}>}
	 */ function update() {
                var copper_opportunity = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, copper_payload = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, pim_project = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, pim_project_owner = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, pim_project_assignee = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : {}, pim_client = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : {}, attributes = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : {}, hasura_payload = arguments.length > 7 && arguments[7] !== void 0 ? arguments[7] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var response, needs_update, existing_attributes, missing_attributes, project_name, project_number, project_commonsku_url, project_google_drive_url, project_url, opportunity_name, trimmed_opportunity_name, concatenated_opportunity_name, custom_field_print_engine_url, custom_field_google_drive_url, custom_field_commonsku_url, custom_field_project_number, custom_field_project_manager_order_rep;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                response = {
                                    "hasura": {},
                                    "google_drive": {},
                                    "copper": {}
                                };
                                needs_update = {
                                    "hasura": false,
                                    "google_drive": false,
                                    "copper": false
                                };
                                _ctx.prev = 2;
                                console.log("@imprint-engine/copper/webhooks/opportunity_webhook -> update():");
                                existing_attributes = {};
                                pim_project["attributes"].map(function(attribute) {
                                    attributes[[
                                        attribute["attribute_id"]
                                    ]] = attribute["attribute_value"];
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(attribute["entity_attribute_id"])) {
                                        existing_attributes[[
                                            attribute["attribute_id"]
                                        ]] = attribute["attribute_value"];
                                    }
                                });
                                missing_attributes = [];
                                Object.keys(attributes).map(function(attribute_id) {
                                    if (!Object.keys(existing_attributes).includes(attribute_id) && (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(attributes[attribute_id])) {
                                        missing_attributes.push({
                                            "attribute_id": attribute_id,
                                            "attribute_value": ""
                                        });
                                    }
                                });
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(missing_attributes)) {
                                    _ctx.next = 12;
                                    break;
                                }
                                console.log("[Hasura]: Create missing attributes.");
                                _ctx.next = 12;
                                return _this.integrations["hasura"]["entity_attributes"].create({
                                    "entity_id": pim_project["id"],
                                    "payload": missing_attributes
                                });
                            case 12:
                                project_name = pim_project["name"];
                                project_number = String(pim_project["project_number"]);
                                project_commonsku_url = attributes[3428512977465125];
                                project_google_drive_url = "https://drive.google.com/drive/folders/".concat(response["google_drive"][3437050592329582]);
                                project_url = "".concat(_print_engine_netlify_netlify_js__WEBPACK_IMPORTED_MODULE_4__.Configuration[_this.args["environment"]][_this.args["application"]]["app"]["url"], "/projects/").concat(pim_project["id"]);
                                opportunity_name = copper_opportunity["name"];
                                trimmed_opportunity_name = opportunity_name.replace(new RegExp("".concat(project_number, " - "), "g"), "");
                                concatenated_opportunity_name = "".concat(project_number, " - ").concat(trimmed_opportunity_name);
                                custom_field_print_engine_url = (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.list_pluck)(copper_opportunity["custom_fields"], "value", {
                                    "id": _this.configuration["ids"]["opportunity"]["custom_fields"]["print_engine_url"]
                                });
                                custom_field_google_drive_url = (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.list_pluck)(copper_opportunity["custom_fields"], "value", {
                                    "id": _this.configuration["ids"]["opportunity"]["custom_fields"]["google_drive_url"]
                                });
                                custom_field_commonsku_url = (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.list_pluck)(copper_opportunity["custom_fields"], "value", {
                                    "id": _this.configuration["ids"]["opportunity"]["custom_fields"]["commonsku_project_link"]
                                });
                                custom_field_project_number = Number((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.list_pluck)(copper_opportunity["custom_fields"], "value", {
                                    "id": _this.configuration["ids"]["opportunity"]["custom_fields"]["project_number"]
                                })).toFixed();
                                custom_field_project_manager_order_rep = (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.list_pluck)(copper_opportunity["custom_fields"], "value", {
                                    "id": _this.configuration["ids"]["opportunity"]["custom_fields"]["project_manager_order_rep"]
                                });
                                if (trimmed_opportunity_name !== project_name) {
                                    console.log("[Hasura]: Update Project database entity name.");
                                    needs_update["hasura"] = true;
                                    hasura_payload["name"] = trimmed_opportunity_name;
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(attributes[3437050592329582]) && !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(attributes[3437579676516287]) && !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(attributes[3437580301467585])) {
                                        console.log("[Google Drive]: Update opportunity/project folder name.");
                                        needs_update["google_drive"] = true;
                                    }
                                    console.log("[Copper]: Update opportunity entity name.");
                                    needs_update["copper"] = true;
                                    copper_payload["name"] = concatenated_opportunity_name;
                                }
                                if (!(!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)((pim_project_owner["results"] || {})["source_ref"]) && !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(custom_field_project_manager_order_rep) && String(custom_field_project_manager_order_rep) !== pim_project_owner["results"]["source_ref"])) {
                                    _ctx.next = 33;
                                    break;
                                }
                                console.log('[Hasura]: Update Entity Attribute -> "PROJECT_MANAGER_USER_ID".');
                                _ctx.next = 30;
                                return _this.integrations["hasura"]["users"].get({
                                    "source_id": _this.args["source_id"],
                                    "source_ref": custom_field_project_manager_order_rep
                                }, true);
                            case 30:
                                pim_project_owner = _ctx.sent;
                                needs_update["hasura"] = true;
                                hasura_payload["attributes"].push({
                                    "attribute_id": 3437901222346691,
                                    "attribute_value": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(pim_project_owner["results"]["id"]) ? pim_project_owner["results"]["id"] : ""
                                });
                            case 33:
                                if (!(!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)((pim_project_assignee["results"] || {})["source_ref"]) && !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(copper_opportunity["assignee_id"]) && String(copper_opportunity["assignee_id"]) !== pim_project_assignee["results"]["source_ref"])) {
                                    _ctx.next = 40;
                                    break;
                                }
                                console.log('[Hasura]: Update Entity -> "assignee_id".');
                                _ctx.next = 37;
                                return _this.integrations["hasura"]["users"].get({
                                    "source_id": _this.args["source_id"],
                                    "source_ref": copper_opportunity["assignee_id"]
                                }, true);
                            case 37:
                                pim_project_assignee = _ctx.sent;
                                needs_update["hasura"] = true;
                                hasura_payload["assignee_id"] = pim_project_assignee["results"]["id"];
                            case 40:
                                if (String(custom_field_commonsku_url) !== String(project_commonsku_url)) {
                                    console.log('[Hasura]: Update Entity Attribute -> "COMMONSKU_PROJECT_LINK".');
                                    needs_update["hasura"] = true;
                                    hasura_payload["attributes"].push({
                                        "attribute_id": 3428512977465125,
                                        "attribute_value": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(custom_field_commonsku_url) ? custom_field_commonsku_url : ""
                                    });
                                }
                                if (String(custom_field_print_engine_url) !== String(project_url)) {
                                    console.log('[Copper]: Update Custom field -> "Print Engine URL".');
                                    needs_update["copper"] = true;
                                    copper_payload["custom_fields"].push({
                                        "custom_field_definition_id": _this.configuration["ids"]["opportunity"]["custom_fields"]["print_engine_url"],
                                        "value": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(project_url) ? project_url : ""
                                    });
                                }
                                if (custom_field_project_number !== project_number) {
                                    console.log('[Copper]: Update Custom field -> "Project Number".');
                                    needs_update["google_drive"] = true;
                                    needs_update["copper"] = true;
                                    copper_payload["custom_fields"].push({
                                        "custom_field_definition_id": _this.configuration["ids"]["opportunity"]["custom_fields"]["project_number"],
                                        "value": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(project_number) ? project_number : ""
                                    });
                                }
                                if (!needs_update["hasura"]) {
                                    _ctx.next = 50;
                                    break;
                                }
                                // Update Hasura
                                console.log('[Hasura]: Update Entity -> "Project".', pim_project["id"]);
                                console.log("[Hasura]: Update Entity Attributes:");
                                console.log(hasura_payload["attributes"]);
                                _ctx.next = 49;
                                return _this.integrations["hasura"]["projects"].update({
                                    "payload": [
                                        _objectSpread({}, hasura_payload, {
                                            "id": pim_project["id"],
                                            "name": trimmed_opportunity_name
                                        })
                                    ]
                                });
                            case 49:
                                response["hasura"]["update"] = _ctx.sent;
                            case 50:
                                if (!needs_update["google_drive"]) {
                                    _ctx.next = 63;
                                    break;
                                }
                                // Update Google Drive
                                console.log('[Google Drive]: Update Folder -> "'.concat(concatenated_opportunity_name, '".'));
                                _ctx.next = 54;
                                return _this.integrations["google_drive"]["folders"].update({
                                    "fileId": attributes[3437050592329582],
                                    "name": concatenated_opportunity_name
                                });
                            case 54:
                                response["google_drive"]["project"] = _ctx.sent;
                                console.log('[Google Drive]: Update File "Project Presentation Sheet" -> "'.concat(pim_client["name"], "/Projects/").concat(concatenated_opportunity_name, '/Production Files".'));
                                _ctx.next = 58;
                                return _this.integrations["google_drive"]["files"].update({
                                    "fileId": attributes[3437579676516287],
                                    "name": "Project ".concat(project_number, " - Presentation Sheet")
                                });
                            case 58:
                                response["google_drive"]["project_presentation_sheet"] = _ctx.sent;
                                console.log('[Google Drive]: Update File "Internal Project Sheet" -> "'.concat(pim_client["name"], "/Projects/").concat(concatenated_opportunity_name, '/Production Files".'));
                                _ctx.next = 62;
                                return _this.integrations["google_drive"]["files"].update({
                                    "fileId": attributes[3437580301467585],
                                    "name": "Project ".concat(project_number, " - Project Sheet - ").concat(trimmed_opportunity_name, " - INTERNAL ONLY")
                                });
                            case 62:
                                response["google_drive"]["internal_project_sheet"] = _ctx.sent;
                            case 63:
                                if (!needs_update["copper"]) {
                                    _ctx.next = 70;
                                    break;
                                }
                                // Update Copper
                                console.log('[Copper]: Update Entity -> "Opportunity".');
                                console.log("[Copper]: Update Custom Fields:");
                                console.log(copper_payload["custom_fields"]);
                                _ctx.next = 69;
                                return _this.integrations["copper"]["opportunities"].update(copper_payload);
                            case 69:
                                response["copper"] = _ctx.sent;
                            case 70:
                                return _ctx.abrupt("return", response);
                            case 73:
                                _ctx.prev = 73;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/webhooks/opportunity_webhook -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": {
                                                "copper_opportunity": copper_opportunity,
                                                "copper_payload": copper_payload,
                                                "pim_project": pim_project,
                                                "pim_project_owner": pim_project_owner,
                                                "pim_project_assignee": pim_project_assignee,
                                                "pim_client": pim_client,
                                                "attributes": attributes,
                                                "hasura_payload": hasura_payload
                                            }
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 80;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 80:
                                throw _ctx.t0;
                            case 81:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            73
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Opportunity_Webhook;
}(_webhooks_js__WEBPACK_IMPORTED_MODULE_2__.Webhooks);


/***/ }),

/***/ 65149:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Webhooks": function() { return /* binding */ Webhooks; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _copper_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(15446);
/* harmony import */ var _opportunities_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(61564);
/* harmony import */ var _companies_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77606);
/* harmony import */ var _print_engine_google_drive_files_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91751);
/* harmony import */ var _print_engine_google_drive_folders_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34637);
/* harmony import */ var _print_engine_google_drive_permissions_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31028);
/* harmony import */ var _print_engine_hasura_organizations_clients_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(67697);
/* harmony import */ var _print_engine_hasura_projects_projects_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(11597);
/* harmony import */ var _print_engine_hasura_users_users_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(91107);
/* harmony import */ var _print_engine_hasura_source_event_queue_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(53606);
/* harmony import */ var _print_engine_hasura_attributes_entity_attributes_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(74883);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(93909);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}













/**
 * Copper Integration
 * @class   Webhooks
 * @extends Copper
 */ var Webhooks = /*#__PURE__*/ function(Copper1) {
    "use strict";
    _inherits(Webhooks, Copper1);
    var _super = _createSuper(Webhooks);
    function Webhooks() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Webhooks);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.integrations = {
                "copper": {
                    "companies": new _companies_js__WEBPACK_IMPORTED_MODULE_3__.Companies(_this.args),
                    "opportunities": new _opportunities_js__WEBPACK_IMPORTED_MODULE_2__.Opportunities(_this.args)
                },
                "google_drive": {
                    "files": new _print_engine_google_drive_files_js__WEBPACK_IMPORTED_MODULE_4__.Files(_objectSpread({}, _this.args, {
                        "token": null
                    })),
                    "folders": new _print_engine_google_drive_folders_js__WEBPACK_IMPORTED_MODULE_5__.Folders(_objectSpread({}, _this.args, {
                        "token": null
                    })),
                    "permissions": new _print_engine_google_drive_permissions_js__WEBPACK_IMPORTED_MODULE_6__.Permissions(_objectSpread({}, _this.args, {
                        "token": null
                    }))
                },
                "hasura": {
                    "clients": new _print_engine_hasura_organizations_clients_js__WEBPACK_IMPORTED_MODULE_7__.Clients(_objectSpread({}, _this.args, {
                        "token": null
                    })),
                    "projects": new _print_engine_hasura_projects_projects_js__WEBPACK_IMPORTED_MODULE_8__.Projects(_objectSpread({}, _this.args, {
                        "token": null
                    })),
                    "users": new _print_engine_hasura_users_users_js__WEBPACK_IMPORTED_MODULE_9__.Users(_objectSpread({}, _this.args, {
                        "token": null
                    })),
                    "source_event_queue": new _print_engine_hasura_source_event_queue_js__WEBPACK_IMPORTED_MODULE_10__.Source_Event_Queue(_objectSpread({}, _this.args, {
                        "token": null
                    })),
                    "entity_attributes": new _print_engine_hasura_attributes_entity_attributes_js__WEBPACK_IMPORTED_MODULE_11__.Entity_Attributes(_objectSpread({}, _this.args, {
                        "token": null
                    }))
                }
            };
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/copper/webhooks -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_12__.is_empty)(error["message"])) {
                throw error["message"];
            } else {
                throw error;
            }
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Webhooks, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.list_subscriptions = this.list_subscriptions.bind(this);
            }
        },
        {
            key: "list_subscriptions",
            value: /**
	 * List all webhook subscriptions
	 *
	 * @documentation https://developer.copper.com/webhooks/list-all-subscriptions.html
	 * @endpoint https://app.copper.com/developer_api/v1/webhooks
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function list_subscriptions() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {};
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                _ctx.next = 6;
                                return _this.request("get", "/webhooks");
                            case 6:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 10:
                                _ctx.prev = 10;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/copper/webhooks/webhooks -> list_subscriptions():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_12__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 17;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 17:
                                throw _ctx.t0;
                            case 18:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            10
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Webhooks;
}(_copper_js__WEBPACK_IMPORTED_MODULE_1__.Copper);


/***/ }),

/***/ 55984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Configuration": function() { return /* binding */ Configuration; },
/* harmony export */   "Doppler": function() { return /* binding */ Doppler; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93909);
/* harmony import */ var _print_engine_utilities_integration_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59709);
/* provided dependency */ var process = __webpack_require__(83454);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




/**
 * Doppler Configuration
 *
 * @type {{development: {tenant: {url: string, token: (string|*|string)}}, production: {tenant: {url: string, token: (string|*|string)}},
 *     staging: {tenant: {url: string, token: (string|*|string)}}, local: {tenant: {url: string, token: (string|*|string)}}}}
 */ var Configuration = {
    "production": {
        "tenant": {
            "url": "https://api.doppler.com/v3",
            "token": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["P_DOPPLER_KEY"]) ? "".concat(process.env["P_DOPPLER_KEY"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["DOPPLER_KEY"]) ? process.env["DOPPLER_KEY"] : ""
        }
    },
    "staging": {
        "tenant": {
            "url": "https://api.doppler.com/v3",
            "token": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["S_DOPPLER_KEY"]) ? "".concat(process.env["S_DOPPLER_KEY"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["DOPPLER_KEY"]) ? process.env["DOPPLER_KEY"] : ""
        }
    },
    "development": {
        "tenant": {
            "url": "https://api.doppler.com/v3",
            "token": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["D_DOPPLER_KEY"]) ? "".concat(process.env["D_DOPPLER_KEY"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["DOPPLER_KEY"]) ? process.env["DOPPLER_KEY"] : ""
        }
    },
    "local": {
        "tenant": {
            "url": "https://api.doppler.com/v3",
            "token": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["L_DOPPLER_KEY"]) ? "".concat(process.env["L_DOPPLER_KEY"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["DOPPLER_KEY"]) ? process.env["DOPPLER_KEY"] : ""
        }
    }
};
/**
 * Doppler Integration
 * @class   Doppler
 * @extends Integration
 */ var Doppler = /*#__PURE__*/ function(Integration1) {
    "use strict";
    _inherits(Doppler, Integration1);
    var _super = _createSuper(Doppler);
    function Doppler() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Doppler);
        var _this;
        var default_args = {
            "environment": null,
            "application": "tenant",
            "context": null,
            "scope": null
        };
        var args = _objectSpread({}, default_args, user_args);
        _this = _super.call(this, args);
        _this.args = _objectSpread({}, args, {
            "name": "Doppler",
            "class_name": _this.constructor["name"],
            "reference_name": "doppler",
            "description": "Doppler is the easiest way to securely manage all your environment variables in one encrypted place. No more sharing secrets over Slack or copying .env files.",
            "documentation_url": "https://docs.doppler.com/reference/api"
        });
        try {
            _this.set_bindings();
            _this.set_configuration(Configuration);
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/doppler -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _this;
    }
    _createClass(Doppler, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.request = this.request.bind(this);
                this.get = this.get.bind(this);
            }
        },
        {
            key: "request",
            value: /**
	 * Performs a network request to Doppler.
	 *
	 * @param method
	 * @param endpoint
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function request1() {
                var method = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", endpoint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", user_args = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response, request, remote_response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "parameters": {},
                                    "data": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                if (!((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["context"]) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.configuration) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(method) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(endpoint))) {
                                    _ctx.next = 6;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 6:
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["access_token"])) {
                                    _ctx.next = 8;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 8:
                                method = String(method).toUpperCase();
                                request = {
                                    "baseURL": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["url"]) ? "".concat(_this.args["url"]) : "".concat(_this.configuration["url"]),
                                    "headers": {
                                        "Accept": "application/json",
                                        "Content-Type": "application/json",
                                        "Authorization": "Bearer ".concat(_this.args["access_token"])
                                    },
                                    "timeout": 30000,
                                    "url": "".concat(endpoint),
                                    "method": "".concat(method)
                                };
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args)) {
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["parameters"])) {
                                        request["params"] = args["parameters"];
                                    }
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["data"])) {
                                        if ([
                                            "PUT",
                                            "POST",
                                            "DELETE",
                                            "PATCH"
                                        ].includes(method)) {
                                            request["data"] = args["data"];
                                        }
                                    }
                                }
                                _ctx.next = 13;
                                return axios__WEBPACK_IMPORTED_MODULE_1___default()(_objectSpread({}, _this.configuration, request));
                            case 13:
                                remote_response = _ctx.sent;
                                //console.log( 'remote_response:' );
                                //console.log( remote_response );
                                //console.log( util.inspect( remote_response, false, null, true ) );
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(remote_response["data"])) {
                                    response = remote_response["data"];
                                }
                                return _ctx.abrupt("return", response);
                            case 18:
                                _ctx.prev = 18;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/doppler -> request():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": {
                                                "method": method,
                                                "endpoint": endpoint,
                                                "user_args": user_args
                                            }
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 22:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            18
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * Gets a value of a secret.
	 *
	 * @documentation https://docs.doppler.com/reference/enclave-config-secret-retrieve
	 * @endpoint https://api.doppler.com/v3/configs/config/secret
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "project_name": "pim-environment-variables",
                                    "configuration_name": _this.args["environment"],
                                    "secret_name": ""
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                args = _objectSpread({}, default_args, user_args);
                                return _ctx.abrupt("return", response);
                            case 8:
                                _ctx.prev = 8;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/doppler -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": {
                                                "user_args": user_args
                                            }
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 12:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            8
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Doppler;
}(_print_engine_utilities_integration_js__WEBPACK_IMPORTED_MODULE_3__.Integration);


/***/ }),

/***/ 22597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Configuration": function() { return /* binding */ Configuration; },
/* harmony export */   "Frontegg": function() { return /* binding */ Frontegg; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93909);
/* harmony import */ var _print_engine_utilities_integration_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59709);
/* provided dependency */ var process = __webpack_require__(83454);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




/**
 * Frontegg Configuration
 *
 * @type {{development: {client: {secret_key: (string|*|string), url: string, client_id: (string|*|string)}, tenant: {api_key: (string|*|string),
 *     url: string, client_id: (string|*|string)}}, production: {client: {secret_key: (string|*|string), url: string, client_id: (string|*|string)},
 *     tenant: {api_key: (string|*|string), url: string, client_id: (string|*|string)}}, staging: {client: {secret_key: (string|*|string), url:
 *     string, client_id: (string|*|string)}, tenant: {api_key: (string|*|string), url: string, client_id: (string|*|string)}}, local: {client:
 *     {secret_key: (string|*|string), url: string, client_id: (string|*|string)}, tenant: {api_key: (string|*|string), url: string, client_id:
 *     (string|*|string)}}}}
 */ var Configuration = {
    "production": {
        "tenant": {
            "url": "https://auth.imprintengine.io",
            "client_id": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["P_FRONTEGG_CLIENT_ID"]) ? "".concat(process.env["P_FRONTEGG_CLIENT_ID"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["FRONTEGG_CLIENT_ID"]) ? process.env["FRONTEGG_CLIENT_ID"] : "",
            "api_key": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["P_FRONTEGG_API_KEY"]) ? "".concat(process.env["P_FRONTEGG_API_KEY"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["FRONTEGG_API_KEY"]) ? process.env["FRONTEGG_API_KEY"] : ""
        }
    },
    "staging": {
        "tenant": {
            "url": "https://auth.imprintenginestage.io",
            "client_id": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["S_FRONTEGG_CLIENT_ID"]) ? "".concat(process.env["S_FRONTEGG_CLIENT_ID"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["FRONTEGG_CLIENT_ID"]) ? process.env["FRONTEGG_CLIENT_ID"] : "",
            "api_key": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["S_FRONTEGG_API_KEY"]) ? "".concat(process.env["S_FRONTEGG_API_KEY"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["FRONTEGG_API_KEY"]) ? process.env["FRONTEGG_API_KEY"] : ""
        }
    },
    "development": {
        "tenant": {
            "url": "https://auth.imprintenginedev.io",
            "client_id": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["D_FRONTEGG_CLIENT_ID"]) ? "".concat(process.env["D_FRONTEGG_CLIENT_ID"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["FRONTEGG_CLIENT_ID"]) ? process.env["FRONTEGG_CLIENT_ID"] : "",
            "api_key": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["D_FRONTEGG_API_KEY"]) ? "".concat(process.env["D_FRONTEGG_API_KEY"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["FRONTEGG_API_KEY"]) ? process.env["FRONTEGG_API_KEY"] : ""
        }
    },
    "local": {
        "tenant": {
            "url": "https://auth.imprintenginedev.io",
            "client_id": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["L_FRONTEGG_CLIENT_ID"]) ? "".concat(process.env["L_FRONTEGG_CLIENT_ID"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["FRONTEGG_CLIENT_ID"]) ? process.env["FRONTEGG_CLIENT_ID"] : "",
            "api_key": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["L_FRONTEGG_API_KEY"]) ? "".concat(process.env["L_FRONTEGG_API_KEY"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["FRONTEGG_API_KEY"]) ? process.env["FRONTEGG_API_KEY"] : ""
        }
    }
};
/**
 * Frontegg Integration
 * @class   Frontegg
 * @extends Integration
 */ var Frontegg = /*#__PURE__*/ function(Integration1) {
    "use strict";
    _inherits(Frontegg, Integration1);
    var _super = _createSuper(Frontegg);
    function Frontegg() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Frontegg);
        var _this;
        var default_args = {
            "environment": null,
            "application": "tenant",
            "context": null,
            "scope": null,
            "access_token": null,
            "id_token": null
        };
        var args = _objectSpread({}, default_args, user_args);
        _this = _super.call(this, args);
        _this.args = _objectSpread({}, _this.args, {
            "name": "Frontegg",
            "class_name": _this.constructor["name"],
            "reference_name": "frontegg",
            "description": "Frontegg is a first-of-its-kind full-stack user management platform, empowering software teams with user infrastructure features for the product-led era. From the most fundamental authentication flows to the most complex use cases, Frontegg has you covered.",
            "documentation_url": "https://docs.frontegg.com/reference/"
        });
        try {
            _this.set_bindings();
            _this.set_configuration(Configuration);
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/frontegg -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _this;
    }
    _createClass(Frontegg, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.verify_token = this.verify_token.bind(this);
                this.verify_api_credentials = this.verify_api_credentials.bind(this);
                this.request = this.request.bind(this);
            }
        },
        {
            key: "verify_api_credentials",
            value: /**
	 * Intended to be used for 3rd party integrations to authenticate.
	 *
	 * @param client_id
	 * @param client_secret
	 * @returns {Promise<boolean>}
	 */ function verify_api_credentials() {
                var client_id = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", client_secret = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var response, vendor_request, vendor_response, request, remote_response, _error;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                response = false;
                                _ctx.prev = 1;
                                vendor_request = {
                                    "baseURL": "https://api.frontegg.com",
                                    "headers": {
                                        "Accept": "application/json",
                                        "Content-Type": "application/json"
                                    },
                                    "timeout": 30000,
                                    "url": "/auth/vendor/",
                                    "method": "POST",
                                    "data": {
                                        "clientId": "".concat(_this.configuration["client_id"]),
                                        "secret": "".concat(_this.configuration["api_key"])
                                    }
                                };
                                _ctx.next = 5;
                                return axios__WEBPACK_IMPORTED_MODULE_1___default()(vendor_request);
                            case 5:
                                vendor_response = _ctx.sent;
                                request = {
                                    "baseURL": "https://api.frontegg.com",
                                    "headers": {
                                        "Accept": "application/json",
                                        "Content-Type": "application/json",
                                        "Authorization": "Bearer ".concat(vendor_response["data"]["token"])
                                    },
                                    "timeout": 30000,
                                    "url": "/identity/resources/auth/v1/api-token",
                                    "method": "POST",
                                    "data": {
                                        "clientId": "".concat(client_id),
                                        "secret": "".concat(client_secret)
                                    }
                                };
                                _ctx.next = 9;
                                return axios__WEBPACK_IMPORTED_MODULE_1___default()(request);
                            case 9:
                                remote_response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)((remote_response["data"] || {})["accessToken"])) {
                                    response = remote_response["data"]["accessToken"];
                                }
                                return _ctx.abrupt("return", response);
                            case 14:
                                _ctx.prev = 14;
                                _ctx.t0 = _ctx["catch"](1);
                                _error = new Error(_ctx.t0["message"]);
                                _error["name"] = "Frontegg.verify_api_credentials";
                                throw _error;
                            case 19:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            14
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "verify_token",
            value: /**
	 * Intended to be used for application authentication requests.
	 *
	 * @param json_web_token
	 * @returns {Promise<unknown>}
	 */ function verify_token(json_web_token) {
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee1() {
                    var response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx1) {
                        while(1)switch(_ctx1.prev = _ctx1.next){
                            case 0:
                                response = false;
                                _ctx1.prev = 1;
                                return _ctx1.abrupt("return", new Promise(function() {
                                    var _ref = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(resolve, reject) {
                                        var jwt, jwksClient, client;
                                        return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    jwt = __webpack_require__(49704);
                                                    jwksClient = __webpack_require__(6064);
                                                    client = jwksClient({
                                                        "jwksUri": "".concat(_this.configuration["url"], "/.well-known/jwks.json"),
                                                        "requestHeaders": {
                                                            "Accept": "application/json",
                                                            "Content-Type": "application/json"
                                                        }
                                                    });
                                                    jwt.verify(json_web_token, function(header, callback) {
                                                        client.getSigningKey(header["kid"], function(error, key) {
                                                            var signingKey = key["publicKey"] || key["rsaPublicKey"];
                                                            callback(null, signingKey);
                                                        });
                                                    }, {
                                                        algorithms: [
                                                            "RS256"
                                                        ]
                                                    }, function(error, decoded_token) {
                                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(error)) {
                                                            return reject(error);
                                                        } else {
                                                            return resolve(decoded_token);
                                                        }
                                                    });
                                                case 4:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    }));
                                    return function(resolve, reject) {
                                        return _ref.apply(this, arguments);
                                    };
                                }()));
                            case 5:
                                _ctx1.prev = 5;
                                _ctx1.t0 = _ctx1["catch"](1);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/frontegg -> verify_token():", {
                                        "error": _ctx1.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": {
                                                "user_args": json_web_token
                                            }
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx1.t0;
                            case 9:
                            case "end":
                                return _ctx1.stop();
                        }
                    }, _callee1, null, [
                        [
                            1,
                            5
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "request",
            value: /**
	 * Performs a network request to Frontegg.
	 *
	 * @param method
	 * @param endpoint
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function request1() {
                var method = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", endpoint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", user_args = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response, request, remote_response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "parameters": {},
                                    "data": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                if (!((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["context"]) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.configuration) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(method) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(endpoint))) {
                                    _ctx.next = 6;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 6:
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["access_token"])) {
                                    _ctx.next = 8;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 8:
                                method = String(method).toUpperCase();
                                request = {
                                    "baseURL": "".concat(_this.configuration["url"]),
                                    "headers": {
                                        "Accept": "application/json",
                                        "Content-Type": "application/json",
                                        "Authorization": "Bearer ".concat(_this.args["access_token"])
                                    },
                                    "timeout": 30000,
                                    "url": "".concat(endpoint),
                                    "method": "".concat(method)
                                };
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args)) {
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["parameters"])) {
                                        request["params"] = args["parameters"];
                                    }
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["data"])) {
                                        if ([
                                            "PUT",
                                            "POST",
                                            "DELETE",
                                            "PATCH"
                                        ].includes(method)) {
                                            request["data"] = args["data"];
                                        }
                                    }
                                }
                                _ctx.next = 13;
                                return axios__WEBPACK_IMPORTED_MODULE_1___default()(_objectSpread({}, _this.configuration, request));
                            case 13:
                                remote_response = _ctx.sent;
                                //console.log( 'remote_response:' );
                                //console.log( remote_response );
                                //console.log( util.inspect( remote_response, false, null, true ) );
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(remote_response["data"])) {
                                    response = remote_response["data"];
                                }
                                return _ctx.abrupt("return", response);
                            case 18:
                                _ctx.prev = 18;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/frontegg -> request():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": {
                                                "method": method,
                                                "endpoint": endpoint,
                                                "user_args": user_args
                                            }
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 22:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            18
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Frontegg;
}(_print_engine_utilities_integration_js__WEBPACK_IMPORTED_MODULE_3__.Integration);


/***/ }),

/***/ 25940:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Drives": function() { return /* binding */ Drives; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _google_drive_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39915);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * Google Drive Integration
 * @class   Drives
 * @extends Google_Drive
 */ var Drives = /*#__PURE__*/ function(Google_Drive1) {
    "use strict";
    _inherits(Drives, Google_Drive1);
    var _super = _createSuper(Drives);
    function Drives() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Drives);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/google_drive/drives -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(error["message"])) {
                throw error["message"];
            } else {
                throw error;
            }
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Drives, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * Creates a new shared drive.
	 *
	 * @documentation https://developers.google.com/drive/api/v3/reference/drives/create
	 * @endpoint https://www.googleapis.com/drive/v3/drives
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "requestId": "",
                                    "themeId": ""
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("post", "/drives", {
                                    "data": args
                                });
                            case 7:
                                response = _ctx.sent;
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", response);
                            case 12:
                                _ctx.prev = 12;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/drives -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 19;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 19:
                                throw _ctx.t0;
                            case 20:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            12
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * Gets a shared drive's metadata by ID.
	 *
	 * @documentation https://developers.google.com/drive/api/v3/reference/drives/get
	 * @endpoint https://www.googleapis.com/drive/v3/drives/{{driveId}}
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "driveId": ""
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["driveId"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = _this.cache.get(_this.constructor["name"], args["driveId"]);
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 16;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/drives/".concat(args["driveId"]));
                            case 14:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], args["driveId"], response);
                                }
                            case 16:
                                return _ctx.abrupt("return", response);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/drives -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 26;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 26:
                                throw _ctx.t0;
                            case 27:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * Lists the user's shared drives.
	 *
	 * @documentation https://developers.google.com/drive/api/v3/reference/drives/list
	 * @endpoint https://www.googleapis.com/drive/v3/drives
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {};
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("get", "/drives");
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/drives -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 18;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 18:
                                throw _ctx.t0;
                            case 19:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * Updates a permission with patch semantics.
	 *
	 * @documentation https://developers.google.com/drive/api/v3/reference/drives/update
	 * @endpoint https://www.googleapis.com/drive/v3/drives/{{driveId}}
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "driveId": "",
                                    "backgroundImageFile": {},
                                    "colorRgb": "",
                                    "name": "",
                                    "restrictions": {},
                                    "themeId": ""
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["driveId"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/drives/".concat(args["driveId"]), {
                                    "data": args
                                });
                            case 9:
                                response = _ctx.sent;
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", response);
                            case 14:
                                _ctx.prev = 14;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/drives -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 21;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 21:
                                throw _ctx.t0;
                            case 22:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            14
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * Permanently deletes a shared drive for which the user is an organizer. The shared drive cannot contain any untrashed items.
	 *
	 * @documentation https://developers.google.com/drive/api/v3/reference/permissions/delete
	 * @endpoint https://www.googleapis.com/drive/v3/drives/{{driveId}}
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "driveId": ""
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["driveId"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/drives/".concat(args["driveId"]));
                            case 9:
                                response = _ctx.sent;
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", response);
                            case 14:
                                _ctx.prev = 14;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/drives -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 21;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 21:
                                throw _ctx.t0;
                            case 22:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            14
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Drives;
}(_google_drive_js__WEBPACK_IMPORTED_MODULE_2__.Google_Drive);


/***/ }),

/***/ 91751:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Files": function() { return /* binding */ Files; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _google_drive_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39915);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * Google Drive Integration
 * @class   Files
 * @extends Google_Drive
 */ var Files = /*#__PURE__*/ function(Google_Drive1) {
    "use strict";
    _inherits(Files, Google_Drive1);
    var _super = _createSuper(Files);
    function Files() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Files);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/google_drive/files -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(error["message"])) {
                throw error["message"];
            } else {
                throw error;
            }
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Files, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
                this.copy = this.copy.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * Creates a new file.
	 *
	 * @documentation https://developers.google.com/drive/api/v3/reference/files/create
	 * @endpoint https://www.googleapis.com/drive/v3/files
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "parents": [],
                                    "name": "",
                                    "mimeType": "application/vnd.google-apps.file",
                                    "supportsAllDrives": true
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("post", "/files", {
                                    "data": {
                                        "name": args["name"],
                                        "parents": args["parents"],
                                        "mimeType": args["mimeType"]
                                    },
                                    "parameters": {
                                        "supportsAllDrives": args["supportsAllDrives"]
                                    }
                                });
                            case 7:
                                response = _ctx.sent;
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", response);
                            case 12:
                                _ctx.prev = 12;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/files -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 19;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 19:
                                throw _ctx.t0;
                            case 20:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            12
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "copy",
            value: /**
	 * Copies a file.
	 *
	 * @documentation https://developers.google.com/drive/api/v3/reference/files/copy
	 * @endpoint https://www.googleapis.com/upload/drive/v3/files/{{fileId}}/copy
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function copy() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "fileId": "",
                                    "addParents": [],
                                    "removeParents": [],
                                    "name": "",
                                    "supportsAllDrives": true
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["fileId"]) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["addParents"]) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["name"]))) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("post", "/files/".concat(args["fileId"], "/copy"), {
                                    "data": {
                                        "name": args["name"],
                                        "parents": args["addParents"]
                                    },
                                    "parameters": {
                                        "supportsAllDrives": args["supportsAllDrives"]
                                    }
                                });
                            case 9:
                                // Duplicate the file
                                response = _ctx.sent;
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["removeParents"])) {
                                    _ctx.next = 13;
                                    break;
                                }
                                _ctx.next = 13;
                                return _this.update({
                                    "fileId": response["id"],
                                    "name": args["name"],
                                    "addParents": args["addParents"],
                                    "removeParents": args["removeParents"]
                                });
                            case 13:
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", response);
                            case 17:
                                _ctx.prev = 17;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/files -> copy():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 24;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 24:
                                throw _ctx.t0;
                            case 25:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            17
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * Gets a file's metadata or content by ID.
	 *
	 * @documentation https://developers.google.com/drive/api/v3/reference/files/get
	 * @endpoint https://www.googleapis.com/drive/v3/files/{{fileId}}
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "fileId": "",
                                    "parentId": ""
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["fileId"]) && (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["parentId"]))) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = _this.cache.get(_this.constructor["name"], args["parentId"]);
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 16;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/files/".concat(args["fileId"]));
                            case 14:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], args["fileId"], response);
                                }
                            case 16:
                                return _ctx.abrupt("return", response);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/files -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 26;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 26:
                                throw _ctx.t0;
                            case 27:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * Lists or searches files.
	 *
	 * @documentation https://developers.google.com/drive/api/v3/reference/files/list
	 * @endpoint https://www.googleapis.com/drive/v3/files
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<*[]>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, remote_response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = [];
                                _ctx.prev = 2;
                                default_args = {};
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("get", "/files", {
                                    "parameters": args
                                });
                            case 7:
                                remote_response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(remote_response["files"])) {
                                    response = remote_response["files"];
                                }
                                return _ctx.abrupt("return", response);
                            case 12:
                                _ctx.prev = 12;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    /*
				 console.log( '@imprint-engine/packages/google_drive/files -> list():', util.inspect( {
				 'error': error,
				 'args': {
				 'class': this.args,
				 'method': args
				 },
				 'configuration': this.configuration,
				 'response': response
				 }, false, null, true ) );
				 */ console.log("@imprint-engine/packages/google_drive/files -> list():", _ctx.t0["response"]["status"]);
                                }
                                if (!(!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)((_ctx.t0["response"] || {})["status"]) && _ctx.t0["response"]["status"] === 404)) {
                                    _ctx.next = 19;
                                    break;
                                }
                                return _ctx.abrupt("return", []);
                            case 19:
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 23;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 23:
                                throw _ctx.t0;
                            case 24:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            12
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * Updates a file's metadata and/or content. This method supports patch semantics.
	 *
	 * @documentation https://developers.google.com/drive/api/v3/reference/files/update
	 * @endpoint https://www.googleapis.com/drive/v3/files/{{fileId}}
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "fileId": "",
                                    "name": "",
                                    "addParents": [],
                                    "removeParents": [],
                                    "supportsAllDrives": true
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["fileId"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/files/".concat(args["fileId"]), {
                                    "data": {
                                        "name": args["name"]
                                    },
                                    "parameters": {
                                        "addParents": args["addParents"].join(","),
                                        "removeParents": args["removeParents"].join(","),
                                        "supportsAllDrives": args["supportsAllDrives"]
                                    }
                                });
                            case 9:
                                response = _ctx.sent;
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", response);
                            case 14:
                                _ctx.prev = 14;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/files -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 21;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 21:
                                throw _ctx.t0;
                            case 22:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            14
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * Permanently deletes a file owned by the user without moving it to the trash. If the file belongs to a shared drive the user must be
	 * an organizer on the parent. If the target is a folder, all descendants owned by the user are also deleted.
	 *
	 * @documentation https://developers.google.com/drive/api/v3/reference/files/delete
	 * @endpoint https://www.googleapis.com/drive/v3/files/{{fileId}}
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "fileId": ""
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["fileId"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/files/".concat(args["fileId"]));
                            case 9:
                                response = _ctx.sent;
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", response);
                            case 14:
                                _ctx.prev = 14;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/files -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 21;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 21:
                                throw _ctx.t0;
                            case 22:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            14
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Files;
}(_google_drive_js__WEBPACK_IMPORTED_MODULE_2__.Google_Drive);


/***/ }),

/***/ 34637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Folders": function() { return /* binding */ Folders; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _files_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91751);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get(target1, property1, receiver1) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver);
            }
            return desc.value;
        };
    }
    return _get(target1, property1, receiver1 || target1);
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
function _superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * Google Drive Integration
 * @class   Folders
 * @extends Files
 */ var Folders = /*#__PURE__*/ function(Files1) {
    "use strict";
    _inherits(Folders, Files1);
    var _super = _createSuper(Folders);
    function Folders() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Folders);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/google_drive/folders -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(error["message"])) {
                throw error["message"];
            } else {
                throw error;
            }
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Folders, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * Create a new folder.
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                var _this1 = this, _superprop_get_create = function() {
                    return _get(_getPrototypeOf(Folders.prototype), "create", _this);
                };
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "parents": [],
                                    "name": "",
                                    "mimeType": "application/vnd.google-apps.folder"
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _superprop_get_create().call(_this1, args);
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this1.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/folders -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this1.args,
                                            "method": args
                                        },
                                        "configuration": _this1.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 18;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 18:
                                throw _ctx.t0;
                            case 19:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * Get a folder.
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                var _this2 = this, _superprop_get_get = function() {
                    return _get(_getPrototypeOf(Folders.prototype), "get", _this);
                };
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "parentId": ""
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["parentId"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = _this2.cache.get(_this2.constructor["name"], args["parentId"]);
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 16;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _superprop_get_get().call(_this2, args);
                            case 14:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this2.cache.set(_this2.constructor["name"], args["parentId"], response);
                                }
                            case 16:
                                return _ctx.abrupt("return", response);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this2.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/folders -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this2.args,
                                            "method": args
                                        },
                                        "configuration": _this2.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 26;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 26:
                                throw _ctx.t0;
                            case 27:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * List all folders.
	 * @param user_args
	 * @returns {Promise<*[]>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                var _this3 = this, _superprop_get_list = function() {
                    return _get(_getPrototypeOf(Folders.prototype), "list", _this);
                };
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = [];
                                _ctx.prev = 2;
                                default_args = {};
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _superprop_get_list().call(_this3, args);
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this3.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/folders -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this3.args,
                                            "method": args
                                        },
                                        "configuration": _this3.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 18;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 18:
                                throw _ctx.t0;
                            case 19:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * Updates a folder.
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                var _this4 = this, _superprop_get_update = function() {
                    return _get(_getPrototypeOf(Folders.prototype), "update", _this);
                };
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "fileId": null,
                                    "parents": [],
                                    "name": "",
                                    "mimeType": "application/vnd.google-apps.folder"
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["fileId"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _superprop_get_update().call(_this4, args);
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this4.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/folders -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this4.args,
                                            "method": args
                                        },
                                        "configuration": _this4.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 20;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 20:
                                throw _ctx.t0;
                            case 21:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * Deletes a folder.
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                var _this5 = this, _superprop_get_delete = function() {
                    return _get(_getPrototypeOf(Folders.prototype), "delete", _this);
                };
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": ""
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _superprop_get_delete().call(_this5, args);
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this5.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/folders -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this5.args,
                                            "method": args
                                        },
                                        "configuration": _this5.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 20;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 20:
                                throw _ctx.t0;
                            case 21:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Folders;
}(_files_js__WEBPACK_IMPORTED_MODULE_2__.Files);


/***/ }),

/***/ 39915:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Configuration": function() { return /* binding */ Configuration; },
/* harmony export */   "Google_Drive": function() { return /* binding */ Google_Drive; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(49704);
/* harmony import */ var jsonwebtoken__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(jsonwebtoken__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93909);
/* harmony import */ var _print_engine_utilities_integration_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59709);
/* harmony import */ var _print_engine_aws_secrets_manager_aws_secrets_manager__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55024);
/* provided dependency */ var process = __webpack_require__(83454);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}






/**
 * Google Drive Configuration
 *
 * @type {{development: {tenant: {auth: {private_key_id: (string|string|string), client_x509_cert_url: string, project_id: string,
 *     auth_provider_x509_cert_url: string, client_email: string, private_key: (string|string|string), auth_url: string, type: string, token_url:
 *     string, client_id: (string|string|string), admin_email: (string|string|string)}, scope: string, ids: {folders: {clients: string, root: string,
 *     templates: string}, drives: {pim: string}, files: {project_presentation_sheet_template: string, internal_project_sheet_template: string}},
 *     url: string}}, production: {tenant: {auth: {private_key_id: (string|string|string), client_x509_cert_url: string, project_id: string,
 *     auth_provider_x509_cert_url: string, client_email: string, private_key: (string|string|string), auth_url: string, type: string, token_url:
 *     string, client_id: (string|string|string), admin_email: (string|string|string)}, scope: string, ids: {folders: {clients: string, root: string,
 *     templates: string}, drives: {pim: string, production: string}, files: {project_presentation_sheet_template: string,
 *     internal_project_sheet_template: string}}, url: string}}, staging: {tenant: {auth: {private_key_id: (string|string|string),
 *     client_x509_cert_url: string, project_id: string, auth_provider_x509_cert_url: string, client_email: string, private_key:
 *     (string|string|string), auth_url: string, type: string, token_url: string, client_id: (string|string|string), admin_email:
 *     (string|string|string)}, scope: string, ids: {folders: {clients: string, root: string, templates: string}, drives: {pim: string}, files:
 *     {project_presentation_sheet_template: string, internal_project_sheet_template: string}}, url: string}}, local: {tenant: {auth:
 *     {private_key_id: (string|string|string), client_x509_cert_url: string, project_id: string, auth_provider_x509_cert_url: string, client_email:
 *     string, private_key: (string|string|string), auth_url: string, type: string, token_url: string, client_id: (string|string|string),
 *     admin_email: (string|string|string)}, scope: string, ids: {folders: {clients: string, root: string, templates: string}, drives: {pim: string},
 *     files: {project_presentation_sheet_template: string, internal_project_sheet_template: string}}, url: string}}}}
 */ var Configuration = {
    "production": {
        "tenant": {
            "url": "https://www.googleapis.com/drive/v3",
            "scope": "https://www.googleapis.com/auth/drive",
            "auth": {
                "type": "service_account",
                "project_id": "pimapi-303221",
                "client_id": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["P_GOOGLE_SA_CLIENT_ID"]) ? "".concat(process.env["P_GOOGLE_SA_CLIENT_ID"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["GOOGLE_SA_CLIENT_ID"]) ? process.env["GOOGLE_SA_CLIENT_ID"] : "",
                "private_key_id": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["P_GOOGLE_SA_PRIVATE_KEY_ID"]) ? "".concat(process.env["P_GOOGLE_SA_PRIVATE_KEY_ID"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["GOOGLE_SA_PRIVATE_KEY_ID"]) ? process.env["GOOGLE_SA_PRIVATE_KEY_ID"] : "",
                "private_key": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["P_GOOGLE_SA_PRIVATE_KEY"]) ? "".concat(process.env["P_GOOGLE_SA_PRIVATE_KEY"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["GOOGLE_SA_PRIVATE_KEY"]) ? process.env["GOOGLE_SA_PRIVATE_KEY"] : "",
                "admin_email": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["P_GOOGLE_SA_ADMIN_EMAIL"]) ? "".concat(process.env["P_GOOGLE_SA_ADMIN_EMAIL"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["GOOGLE_SA_ADMIN_EMAIL"]) ? process.env["GOOGLE_SA_ADMIN_EMAIL"] : "",
                "client_email": "pimapi@pimapi-303221.iam.gserviceaccount.com",
                "auth_url": "https://accounts.google.com/o/oauth2/auth",
                "token_url": "https://oauth2.googleapis.com/token",
                "auth_provider_x509_cert_url": "https://www.googleapis.com/oauth2/v1/certs",
                "client_x509_cert_url": "https://www.googleapis.com/robot/v1/metadata/x509/pimapi%40pimapi-303221.iam.gserviceaccount.com"
            },
            "ids": {
                "drives": {
                    "pim": "0AM1NawXqTCOeUk9PVA",
                    "production": "0AF_Mqfs9p2suUk9PVA"
                },
                "folders": {
                    "root": "1BT1ZyL4GlvLrDEMvvAfzPoIhLp2D_ol1",
                    "clients": "1fkcZXPko-ySOY6S0fbRqGS1DjWi7GBwO",
                    "templates": "1PpPs1pwdMcWHTZa2NxNc-nAXdF95Ez3M"
                },
                "files": {
                    "project_presentation_sheet_template": "1Q1_lYfSUaJmCgO4-kV4nWqJjECMqbJUs_m397YJaBgg",
                    "internal_project_sheet_template": "1TjylTX_6A2LfcwJzi_XUeHYoTqL-kKFIJpHAQIA6jmQ"
                }
            }
        }
    },
    "staging": {
        "tenant": {
            "url": "https://www.googleapis.com/drive/v3",
            "scope": "https://www.googleapis.com/auth/drive",
            "auth": {
                "type": "service_account",
                "project_id": "pimapi-303221",
                "client_id": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["S_GOOGLE_SA_CLIENT_ID"]) ? "".concat(process.env["S_GOOGLE_SA_CLIENT_ID"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["GOOGLE_SA_CLIENT_ID"]) ? process.env["GOOGLE_SA_CLIENT_ID"] : "",
                "private_key_id": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["S_GOOGLE_SA_PRIVATE_KEY_ID"]) ? "".concat(process.env["S_GOOGLE_SA_PRIVATE_KEY_ID"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["GOOGLE_SA_PRIVATE_KEY_ID"]) ? process.env["GOOGLE_SA_PRIVATE_KEY_ID"] : "",
                "private_key": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["S_GOOGLE_SA_PRIVATE_KEY"]) ? "".concat(process.env["S_GOOGLE_SA_PRIVATE_KEY"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["GOOGLE_SA_PRIVATE_KEY"]) ? process.env["GOOGLE_SA_PRIVATE_KEY"] : "",
                "admin_email": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["S_GOOGLE_SA_ADMIN_EMAIL"]) ? "".concat(process.env["S_GOOGLE_SA_ADMIN_EMAIL"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["GOOGLE_SA_ADMIN_EMAIL"]) ? process.env["GOOGLE_SA_ADMIN_EMAIL"] : "",
                "client_email": "pimapi@pimapi-303221.iam.gserviceaccount.com",
                "auth_url": "https://accounts.google.com/o/oauth2/auth",
                "token_url": "https://oauth2.googleapis.com/token",
                "auth_provider_x509_cert_url": "https://www.googleapis.com/oauth2/v1/certs",
                "client_x509_cert_url": "https://www.googleapis.com/robot/v1/metadata/x509/pimapi%40pimapi-303221.iam.gserviceaccount.com"
            },
            "ids": {
                "drives": {
                    "pim": "0AM1NawXqTCOeUk9PVA"
                },
                "folders": {
                    "root": "1hvc_WbuwsBeQxLQ9b125Qbc4RvUvk0ql",
                    "clients": "1DO5kG2CF56rdQhJG2appyyFLqBflZeRv",
                    "templates": "1gXVi3Wu-NBOaZgGS48mHgRWkmJ0wYJae"
                },
                "files": {
                    "project_presentation_sheet_template": "11SBF90uyDbg87Txi2LrSpOS97ccW9t65W5zx1kY3E28",
                    "internal_project_sheet_template": "1gV9yn0-aQA1_z2QEMC1_c2GK9gmaENpSjLazHmomrVw"
                }
            }
        }
    },
    "development": {
        "tenant": {
            "url": "https://www.googleapis.com/drive/v3",
            "scope": "https://www.googleapis.com/auth/drive",
            "auth": {
                "type": "service_account",
                "project_id": "pimapi-303221",
                "client_id": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["D_GOOGLE_SA_CLIENT_ID"]) ? "".concat(process.env["D_GOOGLE_SA_CLIENT_ID"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["GOOGLE_SA_CLIENT_ID"]) ? process.env["GOOGLE_SA_CLIENT_ID"] : "",
                "private_key_id": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["D_GOOGLE_SA_PRIVATE_KEY_ID"]) ? "".concat(process.env["D_GOOGLE_SA_PRIVATE_KEY_ID"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["GOOGLE_SA_PRIVATE_KEY_ID"]) ? process.env["GOOGLE_SA_PRIVATE_KEY_ID"] : "",
                "private_key": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["D_GOOGLE_SA_PRIVATE_KEY"]) ? "".concat(process.env["D_GOOGLE_SA_PRIVATE_KEY"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["GOOGLE_SA_PRIVATE_KEY"]) ? process.env["GOOGLE_SA_PRIVATE_KEY"] : "",
                "admin_email": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["D_GOOGLE_SA_ADMIN_EMAIL"]) ? "".concat(process.env["D_GOOGLE_SA_ADMIN_EMAIL"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["GOOGLE_SA_ADMIN_EMAIL"]) ? process.env["GOOGLE_SA_ADMIN_EMAIL"] : "",
                "client_email": "pimapi@pimapi-303221.iam.gserviceaccount.com",
                "auth_url": "https://accounts.google.com/o/oauth2/auth",
                "token_url": "https://oauth2.googleapis.com/token",
                "auth_provider_x509_cert_url": "https://www.googleapis.com/oauth2/v1/certs",
                "client_x509_cert_url": "https://www.googleapis.com/robot/v1/metadata/x509/pimapi%40pimapi-303221.iam.gserviceaccount.com"
            },
            "ids": {
                "drives": {
                    "pim": "0AM1NawXqTCOeUk9PVA"
                },
                "folders": {
                    "root": "1o0zNYTo0_bGCbgpV9OAkN36MSdoJIaz1",
                    "clients": "1BAXaN-QuiPDi5XiAAqJEp6raiYqSgMfG",
                    "templates": "1c7oJNn2LmgmQRrURowLGdZ6TbCtQRINX"
                },
                "files": {
                    "project_presentation_sheet_template": "1VZtDLBF4C8Btm7ZOc-9htqTvbFVLGBMFJbV3PAbKArw",
                    "internal_project_sheet_template": "1aSFc7d0pOgonkGAkgSDeyESh40lQNbau_MKId3peGns"
                }
            }
        }
    },
    "local": {
        "tenant": {
            "url": "https://www.googleapis.com/drive/v3",
            "scope": "https://www.googleapis.com/auth/drive",
            "auth": {
                "type": "service_account",
                "project_id": "pimapi-303221",
                "client_id": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["L_GOOGLE_SA_CLIENT_ID"]) ? "".concat(process.env["L_GOOGLE_SA_CLIENT_ID"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["GOOGLE_SA_CLIENT_ID"]) ? process.env["GOOGLE_SA_CLIENT_ID"] : "",
                "private_key_id": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["L_GOOGLE_SA_PRIVATE_KEY_ID"]) ? "".concat(process.env["L_GOOGLE_SA_PRIVATE_KEY_ID"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["GOOGLE_SA_PRIVATE_KEY_ID"]) ? process.env["GOOGLE_SA_PRIVATE_KEY_ID"] : "",
                "private_key": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["L_GOOGLE_SA_PRIVATE_KEY"]) ? "".concat(process.env["L_GOOGLE_SA_PRIVATE_KEY"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["GOOGLE_SA_PRIVATE_KEY"]) ? process.env["GOOGLE_SA_PRIVATE_KEY"] : "",
                "admin_email": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["L_GOOGLE_SA_ADMIN_EMAIL"]) ? "".concat(process.env["L_GOOGLE_SA_ADMIN_EMAIL"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(process.env["GOOGLE_SA_ADMIN_EMAIL"]) ? process.env["GOOGLE_SA_ADMIN_EMAIL"] : "",
                "client_email": "pimapi@pimapi-303221.iam.gserviceaccount.com",
                "auth_url": "https://accounts.google.com/o/oauth2/auth",
                "token_url": "https://oauth2.googleapis.com/token",
                "auth_provider_x509_cert_url": "https://www.googleapis.com/oauth2/v1/certs",
                "client_x509_cert_url": "https://www.googleapis.com/robot/v1/metadata/x509/pimapi%40pimapi-303221.iam.gserviceaccount.com"
            },
            "ids": {
                "drives": {
                    "pim": "0AM1NawXqTCOeUk9PVA"
                },
                "folders": {
                    "root": "1o0zNYTo0_bGCbgpV9OAkN36MSdoJIaz1",
                    "clients": "1BAXaN-QuiPDi5XiAAqJEp6raiYqSgMfG",
                    "templates": "1c7oJNn2LmgmQRrURowLGdZ6TbCtQRINX"
                },
                "files": {
                    "project_presentation_sheet_template": "1VZtDLBF4C8Btm7ZOc-9htqTvbFVLGBMFJbV3PAbKArw",
                    "internal_project_sheet_template": "1aSFc7d0pOgonkGAkgSDeyESh40lQNbau_MKId3peGns"
                }
            }
        }
    }
};
/**
 * Google Drive Integration
 * @class   Google_Drive
 * @extends Integration
 */ var Google_Drive = /*#__PURE__*/ function(Integration1) {
    "use strict";
    _inherits(Google_Drive, Integration1);
    var _super = _createSuper(Google_Drive);
    function Google_Drive() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Google_Drive);
        var _this;
        var default_args = {
            "environment": null,
            "application": "tenant",
            "context": null,
            "scope": null,
            "tenant_id": null,
            "json_web_token": null,
            "access_token": null
        };
        var args = _objectSpread({}, default_args, user_args);
        _this = _super.call(this, args);
        _this.args = _objectSpread({}, args, {
            "name": "Google Drive",
            "class_name": _this.constructor["name"],
            "reference_name": "google_drive",
            "description": "Google Drive is a file storage and synchronization service.",
            "documentation_url": "https://developers.google.com/drive/api/v3/reference"
        });
        try {
            _this.set_bindings();
            _this.set_configuration(Configuration);
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/google_drive -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(error["message"])) {
                throw error["message"];
            } else {
                throw error;
            }
        }
        return _this;
    }
    _createClass(Google_Drive, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.request = this.request.bind(this);
                this.authenticate = this.authenticate.bind(this);
            }
        },
        {
            key: "authenticate",
            value: /**
	 *
	 * @documentation https://developers.google.com/identity/protocols/oauth2/service-account#httprest
	 *
	 * @returns {Promise<boolean>}
	 */ function authenticate() {
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var AWS_Secrets_Manager, secrets, JWT, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.prev = 0;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)((_this.configuration["auth"] || {})["private_key"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                AWS_Secrets_Manager = new _print_engine_aws_secrets_manager_aws_secrets_manager__WEBPACK_IMPORTED_MODULE_5__.AWS_Secrets_Manager(_this.args);
                                _ctx.next = 5;
                                return AWS_Secrets_Manager.get({
                                    "secret_name": "pim/integration/gcp/global/tenant"
                                });
                            case 5:
                                secrets = _ctx.sent;
                                _this.configuration["auth"]["private_key"] = String(secrets["PRIVATE_KEY"]).replace(/\\n/g, "\n");
                            case 7:
                                JWT = {
                                    "payload": {
                                        iss: !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_this.configuration["auth"]["client_email"]) ? _this.configuration["auth"]["client_email"] : "",
                                        sub: !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_this.configuration["auth"]["client_email"]) ? _this.configuration["auth"]["client_email"] : "",
                                        scope: !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_this.configuration["scope"]) ? _this.configuration["scope"] : "",
                                        aud: !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_this.configuration["auth"]["token_url"]) ? _this.configuration["auth"]["token_url"] : "",
                                        exp: Math.floor(Date.now() / 1000) + 3600,
                                        iat: Math.floor(Date.now() / 1000)
                                    },
                                    "private_key": _this.configuration["auth"]["private_key"],
                                    "options": {
                                        algorithm: "RS256"
                                    }
                                };
                                _this.args["json_web_token"] = jsonwebtoken__WEBPACK_IMPORTED_MODULE_2___default().sign(JWT["payload"], JWT["private_key"], JWT["options"], null);
                                _ctx.next = 11;
                                return axios__WEBPACK_IMPORTED_MODULE_1___default()({
                                    "url": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_this.configuration["auth"]["token_url"]) ? "".concat(_this.configuration["auth"]["token_url"]) : "",
                                    "method": "post",
                                    "data": {
                                        "grant_type": "urn:ietf:params:oauth:grant-type:jwt-bearer",
                                        "assertion": _this.args["json_web_token"]
                                    }
                                });
                            case 11:
                                response = _ctx.sent;
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(response["data"])) {
                                    _ctx.next = 16;
                                    break;
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(response["data"]["access_token"])) {
                                    _ctx.next = 16;
                                    break;
                                }
                                _this.args["access_token"] = response["data"]["access_token"];
                                return _ctx.abrupt("return", true);
                            case 16:
                                return _ctx.abrupt("return", false);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](0);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive -> authenticate():", {
                                        "error": _ctx.t0,
                                        args: _this.args,
                                        "configuration": _this.configuration
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 26;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 26:
                                throw _ctx.t0;
                            case 27:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "request",
            value: /**
	 * Performs a network request to Google Drive.
	 *
	 * @param method
	 * @param endpoint
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function request1() {
                var method = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", endpoint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", user_args = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response, request, remote_response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "parameters": {},
                                    "data": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                if (!((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_this.args["context"]) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_this.configuration) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(method) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(endpoint))) {
                                    _ctx.next = 6;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 6:
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_this.args["access_token"])) {
                                    _ctx.next = 9;
                                    break;
                                }
                                _ctx.next = 9;
                                return _this.authenticate();
                            case 9:
                                console.log("@imprint-engine/packages/google_drive -> request():");
                                method = String(method).toUpperCase();
                                request = {
                                    "baseURL": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(_this.configuration["url"]) ? _this.configuration["url"] : "",
                                    "headers": {
                                        "Accept": "application/json",
                                        "Content-Type": "application/json",
                                        "Authorization": "Bearer ".concat(_this.args["access_token"])
                                    },
                                    "timeout": 30000,
                                    "url": "".concat(endpoint),
                                    "method": "".concat(method)
                                };
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(args)) {
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(args["parameters"])) {
                                        request["params"] = args["parameters"];
                                    }
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(args["data"])) {
                                        if ([
                                            "PUT",
                                            "POST",
                                            "DELETE",
                                            "PATCH"
                                        ].includes(method)) {
                                            request["data"] = args["data"];
                                        }
                                    }
                                }
                                _ctx.next = 15;
                                return axios__WEBPACK_IMPORTED_MODULE_1___default()(request);
                            case 15:
                                remote_response = _ctx.sent;
                                //console.log( 'remote_response:' );
                                //console.log( remote_response );
                                //console.log( util.inspect( remote_response, false, null, true ) );
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_3__.is_empty)(remote_response["data"])) {
                                    response = remote_response["data"];
                                }
                                return _ctx.abrupt("return", response);
                            case 20:
                                _ctx.prev = 20;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive -> request():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": {
                                                "method": method,
                                                "endpoint": endpoint,
                                                "user_args": user_args
                                            }
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 24:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            20
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Google_Drive;
}(_print_engine_utilities_integration_js__WEBPACK_IMPORTED_MODULE_4__.Integration);


/***/ }),

/***/ 31028:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Permissions": function() { return /* binding */ Permissions; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _google_drive_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39915);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * Google Drive Integration
 * @class   Permissions
 * @extends Google_Drive
 */ var Permissions = /*#__PURE__*/ function(Google_Drive1) {
    "use strict";
    _inherits(Permissions, Google_Drive1);
    var _super = _createSuper(Permissions);
    function Permissions() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Permissions);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/google_drive/permissions -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(error["message"])) {
                throw error["message"];
            } else {
                throw error;
            }
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Permissions, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * Creates a permission for a file or shared drive.
	 *
	 * @documentation https://developers.google.com/drive/api/v3/reference/permissions/create
	 * @endpoint https://www.googleapis.com/drive/v3/files/{{fileId}}/permissions
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, request_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "fileId": "",
                                    "role": "reader",
                                    "type": "domain",
                                    "domain": "imprintengine.com",
                                    "supportsAllDrives": true
                                };
                                args = _objectSpread({}, default_args, user_args);
                                request_args = {
                                    "role": args["role"],
                                    "type": args["type"]
                                };
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["type"]) && !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["domain"])) {
                                    if (args["type"] === "domain") {
                                        request_args["domain"] = args["domain"];
                                    }
                                }
                                _ctx.next = 9;
                                return _this.request("post", "/files/".concat(args["fileId"], "/permissions"), {
                                    "data": request_args,
                                    "parameters": {
                                        "supportsAllDrives": args["supportsAllDrives"]
                                    }
                                });
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/permissions -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 20;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 20:
                                throw _ctx.t0;
                            case 21:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * Gets a permission by ID.
	 *
	 * @documentation https://developers.google.com/drive/api/v3/reference/permissions/get
	 * @endpoint https://www.googleapis.com/drive/v3/files/{{fileId}}/permissions/{{permissionId}}
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "fileId": "",
                                    "permissionId": ""
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["fileId"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = _this.cache.get(_this.constructor["name"], args["fileId"]);
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 16;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/files/".concat(args["fileId"], "/permissions/").concat(args["permissionId"]));
                            case 14:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], args["fileId"], response);
                                }
                            case 16:
                                return _ctx.abrupt("return", response);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/permissions -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 26;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 26:
                                throw _ctx.t0;
                            case 27:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * Lists a file's or shared drive's permissions.
	 *
	 * @documentation https://developers.google.com/drive/api/v3/reference/permissions/list
	 * @endpoint https://www.googleapis.com/drive/v3/files/{{fileId}}/permissions
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "fileId": ""
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("get", "/files/".concat(args["fileId"], "/permissions"));
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/permissions -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 18;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 18:
                                throw _ctx.t0;
                            case 19:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * Updates a permission with patch semantics.
	 *
	 * @documentation https://developers.google.com/drive/api/v3/reference/permissions/update
	 * @endpoint https://www.googleapis.com/drive/v3/files/{{fileId}}/permissions/{{permissionId}}
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "fileId": "",
                                    "permissionId": "",
                                    "expirationTime": "",
                                    "role": "",
                                    "view": ""
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["fileId"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/files/".concat(args["fileId"], "/permissions/").concat(args["permissionId"]), {
                                    "data": args
                                });
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/permissions -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 20;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 20:
                                throw _ctx.t0;
                            case 21:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * Deletes a permission.
	 *
	 * @documentation https://developers.google.com/drive/api/v3/reference/permissions/delete
	 * @endpoint https://www.googleapis.com/drive/v3/files/{{fileId}}/permissions/{{permissionId}}
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "fileId": "",
                                    "permissionId": ""
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["fileId"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/files/".concat(args["fileId"], "/permissions/").concat(args["permissionId"]));
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/google_drive/permissions -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 20;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 20:
                                throw _ctx.t0;
                            case 21:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Permissions;
}(_google_drive_js__WEBPACK_IMPORTED_MODULE_2__.Google_Drive);


/***/ }),

/***/ 89103:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Applications": function() { return /* binding */ Applications; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _hasura_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98172);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * Hasura Integration
 * @class   Applications
 * @extends Hasura
 */ var Applications = /*#__PURE__*/ function(Hasura1) {
    "use strict";
    _inherits(Applications, Hasura1);
    var _super = _createSuper(Applications);
    function Applications() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Applications);
        var _this;
        try {
            var default_args = {
                "environment": null,
                "context": null,
                "entity_type_id": 3428497181716238
            };
            var args = _objectSpread({}, default_args, user_args);
            _this = _super.call(this, args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/hasura/applications/applications -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Applications, [
        {
            /**
	 *
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.get = this.get.bind(this);
            }
        },
        {
            key: "get",
            value: /**
	 * Retrieves a specific application from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "id": ""
                                };
                                args = _objectSpread({}, default_args, user_args);
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 18;
                                break;
                            case 12:
                                graphql = "\n				query get_app( $app_id: bigint! )  {\n					app: apps_by_pk( id: $app_id ) {\n						id\n						name\n						entity {\n							id\n							entity_type_id\n						}\n						entity_type {\n							name\n						}\n						products {\n							product {\n								id\n								name\n								description\n								sku\n								identifiers {\n									key\n									value\n								}\n								bundle_items {\n									product_id\n									product {\n										id\n										name\n										sku\n										identifiers {\n											key\n											value\n										}\n									}\n									min_quantity\n									max_quantity\n								}\n							}\n						}\n						integrations {\n							connection {\n								id\n								name\n								key\n								integration {\n									name\n								}\n							}\n						}\n					}\n				}\n				";
                                _ctx.next = 15;
                                return _this.query(graphql, {
                                    "app_id": args["id"]
                                });
                            case 15:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"] = response;
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["app"])) {
                                        data["results"] = response["app"];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                            case 18:
                                return _ctx.abrupt("return", data);
                            case 21:
                                _ctx.prev = 21;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/applications/applications -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "graphql": graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 25:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            21
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Applications;
}(_hasura_js__WEBPACK_IMPORTED_MODULE_2__.Hasura);


/***/ }),

/***/ 49079:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Attributes": function() { return /* binding */ Attributes; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _hasura_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98172);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * Hasura Integration
 * @class   Attributes
 * @extends Hasura
 */ var Attributes = /*#__PURE__*/ function(Hasura1) {
    "use strict";
    _inherits(Attributes, Hasura1);
    var _super = _createSuper(Attributes);
    function Attributes() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Attributes);
        var _this;
        try {
            var default_args = {
                "environment": null,
                "context": null
            };
            var args = _objectSpread({}, default_args, user_args);
            _this = _super.call(this, args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/hasura/attributes/attributes -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Attributes, [
        {
            /**
	 *
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
            }
        },
        {
            key: "get",
            value: /**
	 * Retrieves a specific attribute from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "id": "",
                                    "entity_type_id": "",
                                    "returning": [
                                        "id",
                                        "name",
                                        "code"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 20;
                                break;
                            case 12:
                                where = 'id: { _eq: "'.concat(args["id"], '" }');
                                where += "archived_at: {_is_null: true}";
                                graphql = "\n				query getAttribute {\n					attributes (\n						where: { ".concat(where, " }\n					) {\n						").concat(args["returning"].join("\n"), "\n					}\n				}\n				");
                                _ctx.next = 17;
                                return _this.query(graphql);
                            case 17:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"] = response;
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["attributes"])) {
                                        data["results"] = response["attributes"][0];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                            case 20:
                                return _ctx.abrupt("return", data);
                            case 23:
                                _ctx.prev = 23;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/attributes/attributes -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 27:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            23
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * Retrieves multiple attributes from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{total: number, response: *[], results: *[]}>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: [],
                                    total: 0,
                                    response: []
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "column": "name",
                                    "order": "asc",
                                    "page": 1,
                                    "per_page": 20,
                                    "includes": "",
                                    "excludes": "",
                                    "entity_type_id": "",
                                    "entity_id": "",
                                    "returning": [
                                        "id",
                                        "name",
                                        "code"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                args["offset"] = (args["page"] - 1) * args["per_page"];
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["entity_type_id"])) {
                                    _ctx.next = 9;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 9:
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 15;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 28;
                                break;
                            case 15:
                                where = 'entity_type_id: { _eq: "'.concat(_this.args["entity_type_id"], '" }');
                                where += "archived_at: {_is_null: true}";
                                where += "_and: [";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["includes"])) {
                                    where += '{ name: { _ilike: "%'.concat(args["includes"], '%" } }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["excludes"])) {
                                    where += '{ name: { _nilike: "%'.concat(args["excludes"], '%" } }');
                                }
                                where += "]";
                                graphql = "\n				query listAttributes {\n					attributes (\n						where: { ".concat(where, " }\n						order_by: { ").concat(args["column"], ": ").concat(args["order"], " }\n						offset: ").concat(args["offset"], "\n						limit: ").concat(args["per_page"], "\n					) {\n						").concat(args["returning"].join("\n"), "\n					}\n					attributes_aggregate (\n						where: { ").concat(where, " }\n					) {\n						aggregate  {\n							total: count\n						}\n					}\n				}\n				");
                                _ctx.next = 24;
                                return _this.query(graphql);
                            case 24:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"].push(response);
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["attributes"])) {
                                        data["results"] = response["attributes"];
                                    }
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["attributes_aggregate"]["aggregate"]["total"])) {
                                        data["total"] = response["attributes_aggregate"]["aggregate"]["total"];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                                if (data["total"] > 0) {
                                    data["results"].map(function(result) {
                                        _this.cache.set(_this.constructor["name"], JSON.stringify({
                                            "id": result["id"]
                                        }), {
                                            response: "cached",
                                            results: result
                                        });
                                    });
                                }
                            case 28:
                                return _ctx.abrupt("return", data);
                            case 31:
                                _ctx.prev = 31;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/attributes/attributes -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 35:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            31
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Attributes;
}(_hasura_js__WEBPACK_IMPORTED_MODULE_2__.Hasura);


/***/ }),

/***/ 74883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Entity_Attributes": function() { return /* binding */ Entity_Attributes; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _hasura_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98172);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * Hasura Integration
 * @class   Entity_Attributes
 * @extends Hasura
 */ var Entity_Attributes = /*#__PURE__*/ function(Hasura1) {
    "use strict";
    _inherits(Entity_Attributes, Hasura1);
    var _super = _createSuper(Entity_Attributes);
    function Entity_Attributes() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Entity_Attributes);
        var _this;
        try {
            var default_args = {
                "environment": null,
                "context": null
            };
            var args = _objectSpread({}, default_args, user_args);
            _this = _super.call(this, args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/hasura/attributes/entity_attributes -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Entity_Attributes, [
        {
            /**
	 *
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.set_args = this.set_args.bind(this);
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
            }
        },
        {
            /**
	 *
	 * @param user_args
	 * @returns {boolean}
	 */ key: "set_args",
            value: function set_args() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var default_args = {
                    "environment": null,
                    "context": null
                };
                this.args = _objectSpread({}, default_args, user_args);
                return true;
            }
        },
        {
            key: "create",
            value: /**
	 * Creates an attribute for an entity in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "return": false,
                                    "payload": [],
                                    "entity_id": "",
                                    "returning": [
                                        "id",
                                        "entity_id",
                                        "attribute_id",
                                        "attribute_value",
                                        "created_at",
                                        "updated_at"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["payload"])) {
                                    _ctx.next = 8;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 8:
                                if (Array.isArray(args["payload"])) {
                                    _ctx.next = 10;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 10:
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["entity_id"])) {
                                    args["payload"].map(function(item, index) {
                                        args["payload"][index] = _objectSpread({}, item, {
                                            "entity_id": Number(args["entity_id"])
                                        });
                                    });
                                }
                                args["payload"].map(function(item, index) {
                                    args["payload"][index] = _objectSpread({}, item, {
                                        "attribute_id": Number(item["attribute_id"]),
                                        "attribute_value": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["attribute_value"]) ? String(item["attribute_value"]) : ""
                                    });
                                });
                                graphql = "\n			mutation createEntityAttributes($objects: [entity_attributes_insert_input!]!) {\n				insert_entity_attributes(\n					objects: $objects,\n					on_conflict: {\n						constraint: entity_attributes_entity_id_attribute_id_attribute_value_key,\n						update_columns: []\n					}\n				) {\n					returning {\n						".concat(args["returning"].join("\n"), "\n					}\n				}\n			}\n			");
                                if (!(args["return"] === true)) {
                                    _ctx.next = 15;
                                    break;
                                }
                                return _ctx.abrupt("return", {
                                    "graphql": graphql,
                                    "variables": {
                                        "objects": args["payload"]
                                    }
                                });
                            case 15:
                                _ctx.next = 17;
                                return _this.mutation(graphql, {
                                    "objects": args["payload"]
                                });
                            case 17:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"] = response;
                                    data["results"] = response["insert_entity_attributes"]["returning"];
                                    _this.cache.remove(_this.constructor["name"]);
                                }
                                return _ctx.abrupt("return", data);
                            case 22:
                                _ctx.prev = 22;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/attributes/entity_attributes -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 26:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            22
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * Retrieves a specific attribute from and entity in the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, source_id, source_ref, source, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "attribute_id": "",
                                    "entity_id": "",
                                    "returning": [
                                        "id",
                                        "entity_id",
                                        "attribute_id",
                                        "attribute_value"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 25;
                                break;
                            case 12:
                                where = 'entity_id: { _eq: "'.concat(args["entity_id"], '" } attribute_id: { _eq: "').concat(args["attribute_id"], '" }');
                                source_id = "";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["source_id"])) {
                                    source_id = 'source_id: { _eq: "'.concat(args["source_id"], '" }');
                                }
                                source_ref = "";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["source_ref"])) {
                                    source_ref = 'source_ref: { _eq: "'.concat(args["source_ref"], '" }');
                                }
                                source = "".concat(source_id).concat(source_ref);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(source)) {
                                    where = source;
                                }
                                graphql = "\n				query getEntityAttribute {\n					entity_attributes (\n						where: { ".concat(where, " }\n					) {\n						").concat(args["returning"].join("\n"), "\n					}\n				}\n				");
                                _ctx.next = 22;
                                return _this.query(graphql);
                            case 22:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"] = response;
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["entity_attributes"])) {
                                        data["results"] = response["entity_attributes"][0];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                            case 25:
                                return _ctx.abrupt("return", data);
                            case 28:
                                _ctx.prev = 28;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/attributes/entity_attributes -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 32:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            28
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * Retrieves multiple attributes from an entity in the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{total: number, response: *[], results: *[]}>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: [],
                                    total: 0,
                                    response: []
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "column": "attribute_value",
                                    "order": "asc",
                                    "page": 1,
                                    "per_page": 20,
                                    "includes": "",
                                    "excludes": "",
                                    "entity_id": "",
                                    "returning": [
                                        "attribute_id",
                                        "attribute_value"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                args["offset"] = (args["page"] - 1) * args["per_page"];
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["entity_id"])) {
                                    _ctx.next = 9;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 9:
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 15;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 27;
                                break;
                            case 15:
                                where = 'entity_id: { _eq: "'.concat(_this.args["entity_id"], '" }');
                                where += "_and: [";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["includes"])) {
                                    where += '{ name: { _ilike: "%'.concat(args["includes"], '%" } }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["excludes"])) {
                                    where += '{ name: { _nilike: "%'.concat(args["excludes"], '%" } }');
                                }
                                where += "]";
                                graphql = "\n				query listEntityAttributes {\n					entity_attributes (\n						where: { ".concat(where, " }\n						order_by: { ").concat(args["column"], ": ").concat(args["order"], " }\n						offset: ").concat(args["offset"], "\n						limit: ").concat(args["per_page"], "\n					) {\n						").concat(args["returning"].join("\n"), "\n					}\n					entity_attributes_aggregate (\n						where: { ").concat(where, " }\n					) {\n						aggregate  {\n							total: count\n						}\n					}\n				}\n				");
                                _ctx.next = 23;
                                return _this.query(graphql);
                            case 23:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"].push(response);
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["entity_attributes"])) {
                                        data["results"] = response["entity_attributes"];
                                    }
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["entity_attributes_aggregate"]["aggregate"]["total"])) {
                                        data["total"] = response["entity_attributes_aggregate"]["aggregate"]["total"];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                                if (data["total"] > 0) {
                                    data["results"].map(function(result) {
                                        _this.cache.set(_this.constructor["name"], JSON.stringify({
                                            "attribute_id": result["attribute_id"],
                                            "entity_id": args["entity_id"]
                                        }), {
                                            response: "cached",
                                            results: result
                                        });
                                    });
                                }
                            case 27:
                                return _ctx.abrupt("return", data);
                            case 30:
                                _ctx.prev = 30;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/attributes/entity_attributes -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 34:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            30
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * Updates an attribute for an entity in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{mutations: {}, queries: {}}|boolean|{response: *[], results: *[]}>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee1() {
                    var args, data, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx1) {
                        while(1)switch(_ctx1.prev = _ctx1.next){
                            case 0:
                                args = {};
                                data = {
                                    results: [],
                                    response: []
                                };
                                _ctx1.prev = 2;
                                default_args = {
                                    "payload": [],
                                    "returning": [
                                        "id",
                                        "entity_id",
                                        "attribute_id",
                                        "attribute_value",
                                        "created_at",
                                        "updated_at"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["payload"])) {
                                    _ctx1.next = 7;
                                    break;
                                }
                                return _ctx1.abrupt("return", data);
                            case 7:
                                if (Array.isArray(args["payload"])) {
                                    _ctx1.next = 9;
                                    break;
                                }
                                return _ctx1.abrupt("return", data);
                            case 9:
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["entity_id"])) {
                                    args["payload"].map(function(item, index) {
                                        args["payload"][index] = _objectSpread({}, item, {
                                            "entity_id": Number(args["entity_id"])
                                        });
                                    });
                                }
                                args["payload"].map(function(item, index) {
                                    args["payload"][index] = _objectSpread({}, item, {
                                        "attribute_id": Number(item["attribute_id"]),
                                        "attribute_value": String(item["attribute_value"])
                                    });
                                });
                                args["payload"].map(function() {
                                    var _ref = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(attribute) {
                                        return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                            while(1)switch(_ctx.prev = _ctx.next){
                                                case 0:
                                                    _ctx.next = 2;
                                                    return _this.mutation("\n					update_entity_attributes(\n						where: {\n							entity_id: { _eq: $entity_id },\n							attribute_id: { _eq: $attribute_id }\n						},\n						_set: $fields\n					) {\n						affected_rows\n						returning {\n							".concat(args["returning"].join("\n"), "\n						}\n					}"), {
                                                        "data": {
                                                            "entity_id": attribute["entity_id"],
                                                            "attribute_id": attribute["attribute_id"],
                                                            "fields": {
                                                                "attribute_value": attribute["attribute_value"]
                                                            }
                                                        },
                                                        "types": {
                                                            "entity_id": "bigint",
                                                            "attribute_id": "bigint",
                                                            "fields": "entity_attributes_set_input"
                                                        }
                                                    }, {
                                                        "return": true
                                                    });
                                                case 2:
                                                case "end":
                                                    return _ctx.stop();
                                            }
                                        }, _callee);
                                    }));
                                    return function(attribute) {
                                        return _ref.apply(this, arguments);
                                    };
                                }());
                                _this.cache.remove(_this.constructor["name"]);
                                _ctx1.next = 15;
                                return _this.process_queue();
                            case 15:
                                data = _ctx1.sent;
                                return _ctx1.abrupt("return", data);
                            case 19:
                                _ctx1.prev = 19;
                                _ctx1.t0 = _ctx1["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/attributes/entity_attributes -> update():", {
                                        "error": _ctx1.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx1.t0;
                            case 23:
                            case "end":
                                return _ctx1.stop();
                        }
                    }, _callee1, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Entity_Attributes;
}(_hasura_js__WEBPACK_IMPORTED_MODULE_2__.Hasura);


/***/ }),

/***/ 89361:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Files": function() { return /* binding */ Files; },
/* harmony export */   "entity_type_id": function() { return /* binding */ entity_type_id; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _attributes_entity_attributes__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74883);
/* harmony import */ var _hasura__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98172);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




var entity_type_id = "3458360330524727";
/**
 * Hasura Integration
 * @class   Files
 * @extends Hasura
 */ var Files = /*#__PURE__*/ function(Hasura1) {
    "use strict";
    _inherits(Files, Hasura1);
    var _super = _createSuper(Files);
    function Files() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Files);
        var _this;
        try {
            _this = _super.call(this, user_args);
            var default_args = {
                environment: null,
                token: null,
                context: null,
                tenant_id: null,
                entity_type_id: entity_type_id
            };
            _this.args = _objectSpread({}, default_args, _this.args, user_args);
            _this.Entity_Attributes = new _attributes_entity_attributes__WEBPACK_IMPORTED_MODULE_2__.Entity_Attributes(_this.args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/hasura/files/files -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Files, [
        {
            /**
	 *
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * Creates a file in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, payload, file_response, attributes, attributes_response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "payload": [],
                                    "entity_type_id": _this.args["entity_type_id"],
                                    "returning": [
                                        "id",
                                        "name"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["payload"])) {
                                    _ctx.next = 8;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 8:
                                if (Array.isArray(args["payload"])) {
                                    _ctx.next = 10;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 10:
                                payload = [];
                                args["payload"].map(function(item) {
                                    payload.push(_objectSpread({}, item, {
                                        "entity_type_id": args["entity_type_id"]
                                    }));
                                });
                                payload.map(function(item) {
                                    delete item["attributes"];
                                });
                                graphql = "\n			mutation createFile($objects: [files_insert_input!]!) {\n				insert_files(objects: $objects) {\n					returning {\n						".concat(args["returning"].join("\n"), "\n					}\n				}\n			}\n			");
                                _ctx.next = 16;
                                return _this.mutation(graphql, payload);
                            case 16:
                                file_response = _ctx.sent;
                                if ((0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(file_response)) {
                                    _ctx.next = 29;
                                    break;
                                }
                                _this.cache.remove(_this.constructor["name"]);
                                data["response"]["entity"] = file_response;
                                attributes = [];
                                if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(file_response["insert_files"]["returning"])) {
                                    data["results"]["entity"] = file_response["insert_files"]["returning"];
                                    file_response["insert_files"]["returning"].map(function(file) {
                                        if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(file["id"]) && !(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(file["name"])) {
                                            args["payload"].map(function(item) {
                                                if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["name"])) {
                                                    if (file["name"] === item["name"]) {
                                                        if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["attributes"])) {
                                                            item["attributes"].map(function(attribute) {
                                                                attributes.push(_objectSpread({}, attribute, {
                                                                    "entity_id": file["id"]
                                                                }));
                                                            });
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(attributes)) {
                                    _ctx.next = 29;
                                    break;
                                }
                                delete args["returning"];
                                _ctx.next = 26;
                                return _this.Entity_Attributes.create(_objectSpread({}, args, {
                                    payload: attributes
                                }));
                            case 26:
                                attributes_response = _ctx.sent;
                                data["response"]["attributes"] = attributes_response["response"];
                                data["results"]["attributes"] = attributes_response["results"];
                            case 29:
                                return _ctx.abrupt("return", data);
                            case 32:
                                _ctx.prev = 32;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/files/files -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 36:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            32
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * Retrieves a specific file from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, source_id, source_ref, source, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "id": "",
                                    "entity_type_id": "",
                                    "returning": [
                                        "id",
                                        "entity_id",
                                        "name",
                                        "active",
                                        "created_at",
                                        "updated_at"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 26;
                                break;
                            case 12:
                                where = 'id: { _eq: "'.concat(args["id"], '" }');
                                where += "archived_at: {_is_null: true}";
                                source_id = "";
                                if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["source_id"])) {
                                    source_id = 'source_id: { _eq: "'.concat(args["source_id"], '" }');
                                }
                                source_ref = "";
                                if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["source_ref"])) {
                                    source_ref = 'source_ref: { _eq: "'.concat(args["source_ref"], '" }');
                                }
                                source = "".concat(source_id).concat(source_ref);
                                if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(source)) {
                                    where = source;
                                }
                                graphql = "\n				query getFile {\n					files (\n						where: { ".concat(where, " }\n					) {\n						").concat(args["returning"].join("\n"), "\n						tenant {\n							id\n							tenant_id\n							name\n						}\n					}\n				}\n				");
                                _ctx.next = 23;
                                return _this.query(graphql);
                            case 23:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"] = response;
                                    if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["files"])) {
                                        data["results"] = response["files"][0];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                            case 26:
                                return _ctx.abrupt("return", data);
                            case 29:
                                _ctx.prev = 29;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/files/files -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 33:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            29
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * Retrieves multiple files from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{total: number, response: *[], results: *[]}>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: [],
                                    total: 0,
                                    response: []
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "column": "name",
                                    "order": "asc",
                                    "page": 1,
                                    "per_page": 20,
                                    "includes": "",
                                    "excludes": "",
                                    "entity_id": "",
                                    "entity_type_id": "",
                                    "returning": [
                                        "id",
                                        "name"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                args["offset"] = (args["page"] - 1) * args["per_page"];
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 13;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 27;
                                break;
                            case 13:
                                where = 'entity_type_id: { _eq: "'.concat(_this.args["entity_type_id"], '" }');
                                where += "archived_at: {_is_null: true}";
                                where += "_and: [";
                                if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["entity_id"])) {
                                    where += '{ entity_id: { _eq: "'.concat(args["entity_id"], '" } }');
                                }
                                if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["includes"])) {
                                    where += '{ name: { _ilike: "%'.concat(args["includes"], '%" } }');
                                }
                                if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["excludes"])) {
                                    where += '{ name: { _nilike: "%'.concat(args["excludes"], '%" } }');
                                }
                                where += "]";
                                graphql = "\n				query listFiles {\n					files (\n						where: { ".concat(where, " }\n						order_by: { ").concat(args["column"], ": ").concat(args["order"], " }\n						offset: ").concat(args["offset"], "\n						limit: ").concat(args["per_page"], "\n					) {\n						").concat(args["returning"].join("\n"), "\n						tenant {\n							id\n							tenant_id\n							name\n						}\n					}\n					files_aggregate (\n						where: { ").concat(where, " }\n					) {\n						aggregate  {\n							total: count\n						}\n					}\n				}\n		        ");
                                _ctx.next = 23;
                                return _this.query(graphql);
                            case 23:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"].push(response);
                                    if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["files"])) {
                                        data["results"] = response["files"];
                                    }
                                    if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["files_aggregate"]["aggregate"]["total"])) {
                                        data["total"] = response["files_aggregate"]["aggregate"]["total"];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                                if (data["total"] > 0) {
                                    data["results"].map(function(result) {
                                        _this.cache.set(_this.constructor["name"], JSON.stringify({
                                            "id": result["id"],
                                            "entity_type_id": args["entity_type_id"]
                                        }), {
                                            response: "cached",
                                            results: result
                                        });
                                    });
                                }
                            case 27:
                                return _ctx.abrupt("return", data);
                            case 30:
                                _ctx.prev = 30;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/files/files -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 34:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            30
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * Updates a file in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, data, default_args, payload, attributes, requests, variables, entity_responses, id, response, organization_attributes;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": [],
                                    "returning": [
                                        "id",
                                        "name",
                                        "created_at",
                                        "updated_at"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["payload"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 7:
                                if (Array.isArray(args["payload"])) {
                                    _ctx.next = 9;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 9:
                                payload = [];
                                attributes = [];
                                args["payload"].map(function(item) {
                                    payload.push(_objectSpread({}, item, {
                                        "entity_type_id": _this["args"]["entity_type_id"]
                                    }));
                                    if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["attributes"])) {
                                        item["attributes"].map(function(attribute) {
                                            attributes.push(_objectSpread({}, attribute, {
                                                entity_id: item["id"]
                                            }));
                                        });
                                    }
                                });
                                payload.map(function(item) {
                                    delete item["attributes"];
                                });
                                requests = {};
                                variables = {};
                                payload.map(function(item) {
                                    if ((0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["id"])) {
                                        return false;
                                    }
                                    var fields = [];
                                    Object.keys(item).map(function(key) {
                                        if (key !== "id" && key !== "metadata") {
                                            fields.push("".concat(key, ': "').concat(item[key], '"'));
                                        }
                                        if (key === "metadata") {
                                            fields.push("".concat(key, ": $metadata"));
                                        }
                                    });
                                    var graphql = '\n				mutation updateFiles($objects: files_set_input){\n					update_files(\n						where: { \n							id: { _eq: "'.concat(item["id"], '" } \n						}, \n						_set: $objects\n					) {\n						affected_rows\n						returning {\n							').concat(args["returning"].join("\n"), "\n						}\n					}\n				}\n				");
                                    requests[item["id"]] = {
                                        "callback": _this.mutation.bind(_this),
                                        "args": graphql
                                    };
                                    variables[item["id"]] = item;
                                });
                                if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(requests)) {
                                    _ctx.next = 18;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 18:
                                data["response"]["entity"] = [];
                                data["results"]["entity"] = [];
                                entity_responses = [];
                                _ctx.t0 = regeneratorRuntime.keys(requests);
                            case 22:
                                if ((_ctx.t1 = _ctx.t0()).done) {
                                    _ctx.next = 30;
                                    break;
                                }
                                id = _ctx.t1.value;
                                _ctx.next = 26;
                                return _this.mutation(requests[id]["args"], variables[id]);
                            case 26:
                                response = _ctx.sent;
                                entity_responses.push(response);
                                _ctx.next = 22;
                                break;
                            case 30:
                                if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)(entity_responses)) {
                                    _this.cache.remove(_this.constructor["name"]);
                                    entity_responses.map(function(entity_response) {
                                        var entity = entity_response[Object.keys(entity_response)[0]];
                                        data["response"]["entity"].push(entity);
                                        if (!(0,_print_engine_utilities_utilities__WEBPACK_IMPORTED_MODULE_1__.is_empty)((entity["update_files"] || {})["returning"])) {
                                            data["results"]["entity"] = data["results"]["entity"].concat(entity["update_files"]["returning"]);
                                        }
                                    });
                                }
                                delete args["returning"];
                                _ctx.next = 34;
                                return _this.Entity_Attributes.update(_objectSpread({}, args, {
                                    payload: attributes
                                }));
                            case 34:
                                organization_attributes = _ctx.sent;
                                data["response"]["attributes"] = organization_attributes["response"];
                                data["results"]["attributes"] = organization_attributes["results"];
                                return _ctx.abrupt("return", data);
                            case 40:
                                _ctx.prev = 40;
                                _ctx.t2 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/files/files -> update():", {
                                        "error": _ctx.t2,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t2;
                            case 44:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            40
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Files;
}(_hasura__WEBPACK_IMPORTED_MODULE_3__.Hasura);


/***/ }),

/***/ 98172:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Configuration": function() { return /* binding */ Configuration; },
/* harmony export */   "Hasura": function() { return /* binding */ Hasura; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var graphql__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(16918);
/* harmony import */ var graphql_tag__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(17283);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93909);
/* harmony import */ var _print_engine_utilities_integration_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59709);
/* provided dependency */ var process = __webpack_require__(83454);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "",
        ""
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}





/**
 * Hasura Configuration
 *
 * @type {{development: {tenant: {url: string, token: (string|*|string)}}, production: {tenant: {url: string, token: (string|*|string)}},
 *     staging: {tenant: {url: string, token: (*|string)}}, local: {tenant: {url: string, token: (string|*|string)}}}}
 */ var Configuration = {
    "production": {
        "tenant": {
            "url": "https://graph-prod.imprintengine.io/v1/graphql",
            "token": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["P_HASURA_ADMIN_SECRET"]) ? "".concat(process.env["P_HASURA_ADMIN_SECRET"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["HASURA_ADMIN_SECRET"]) ? process.env["HASURA_ADMIN_SECRET"] : ""
        }
    },
    "staging": {
        "tenant": {
            "url": "https://graph-stage.imprintengine.io/v1/graphql",
            "token": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["S_HASURA_ADMIN_SECRET"]) ? process.env["S_HASURA_ADMIN_SECRET"] : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["HASURA_ADMIN_SECRET"]) ? process.env["HASURA_ADMIN_SECRET"] : ""
        }
    },
    "development": {
        "tenant": {
            "url": "https://graph-dev2.imprintengine.io/v1/graphql",
            "token": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["D_HASURA_ADMIN_SECRET"]) ? "".concat(process.env["D_HASURA_ADMIN_SECRET"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["HASURA_ADMIN_SECRET"]) ? process.env["HASURA_ADMIN_SECRET"] : ""
        }
    },
    "local": {
        "tenant": {
            "url": "https://graph-dev2.imprintengine.io/v1/graphql",
            "token": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["L_HASURA_ADMIN_SECRET"]) ? "".concat(process.env["L_HASURA_ADMIN_SECRET"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["HASURA_ADMIN_SECRET"]) ? process.env["HASURA_ADMIN_SECRET"] : ""
        }
    }
};
/**
 * Hasura Integration
 * @class   Hasura
 * @extends Integration
 */ var Hasura = /*#__PURE__*/ function(Integration1) {
    "use strict";
    _inherits(Hasura, Integration1);
    var _super = _createSuper(Hasura);
    function Hasura() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Hasura);
        var _this;
        try {
            var default_args = {
                "host": null,
                "environment": null,
                "application": "tenant",
                "context": null,
                "scope": null,
                "tenant_id": null,
                "token": null
            };
            var args = _objectSpread({}, default_args, user_args);
            _this = _super.call(this, args);
            _this.args = _objectSpread({}, _this.args, {
                "name": "Hasura",
                "class_name": _this.constructor["name"],
                "reference_name": "hasura",
                "description": "Hasura gives you instant GraphQL & REST APIs on new & existing data sources. Connect Hasura to your data & get APIs in under a minute.",
                "documentation_url": "https://hasura.io/docs/latest/graphql/core/api-reference/index.html"
            });
            _this.set_bindings();
            _this.set_configuration(Configuration);
            if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["token"])) {
                _this.configuration["token"] = _this.args["token"];
            }
            _this.queue = {
                "query": [],
                "mutation": []
            };
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/hasura -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Hasura, [
        {
            /**
	 *
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.request = this.request.bind(this);
                this.query = this.query.bind(this);
                this.mutation = this.mutation.bind(this);
                this.set_queue = this.set_queue.bind(this);
                this.get_queue = this.get_queue.bind(this);
                this.process_queue = this.process_queue.bind(this);
            }
        },
        {
            /**
	 *
	 * @TODO - INCOMPLETE STILL, NEEDS WORK
	 *
	 * @param graphql
	 * @param variables
	 * @param type
	 * @returns {boolean}
	 */ key: "set_queue",
            value: function set_queue() {
                var graphql = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", variables = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "";
                try {
                    if (this.queue[type].includes({
                        "graphql": graphql,
                        "variables": variables
                    })) {
                        return false;
                    }
                    this.queue[type].push({
                        "graphql": graphql,
                        "variables": variables
                    });
                    return true;
                } catch (error) {
                    if (this.args["environment"] !== "production") {
                        console.log("@imprint-engine/packages/hasura -> set_queue():", {
                            "error": error,
                            "queue": this.queue
                        });
                    }
                    return false;
                }
            }
        },
        {
            /**
	 *
	 * @TODO - INCOMPLETE STILL, NEEDS WORK
	 *
	 * @param type
	 * @returns {[]|*}
	 */ key: "get_queue",
            value: function get_queue() {
                var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
                try {
                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(type) && !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(this.queue[type])) {
                        return this.queue[type];
                    }
                    return this.queue;
                } catch (error) {
                    if (this.args["environment"] !== "production") {
                        console.log("@imprint-engine/packages/hasura -> get_queue():", {
                            "error": error,
                            "type": type,
                            "queue": this.queue
                        });
                    }
                    return false;
                }
            }
        },
        {
            key: "process_queue",
            value: /**
	 *
	 * @TODO - INCOMPLETE STILL, NEEDS WORK
	 *
	 * @returns {Promise<{mutations: {}, queries: {}}|boolean>}
	 */ function process_queue() {
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var queue, query_request, mutation_request, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.prev = 0;
                                queue = _this.get_queue();
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(queue)) {
                                    _ctx.next = 4;
                                    break;
                                }
                                return _ctx.abrupt("return", false);
                            case 4:
                                query_request = {
                                    "queries": [],
                                    "variable_data": {},
                                    "variable_types": []
                                };
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(queue["query"])) {
                                    queue["query"].map(function(query, index) {
                                        var graphql = query.graphql, variables = query.variables;
                                        Object.keys(variables["types"]).map(function(variable) {
                                            graphql = graphql.replace(new RegExp("\\$".concat(variable), "g"), "$".concat(variable, "_").concat(index));
                                            query_request["variable_data"]["".concat(variable, "_").concat(index)] = variables["data"][variable];
                                            query_request["variable_types"].push("$".concat(variable, "_").concat(index, ": ").concat(variables["types"][variable]));
                                        });
                                        query_request["queries"].push("update_".concat(index, ":").concat(graphql).replace(new RegExp("(	)", "gm"), "").replace("\n", ""));
                                        delete _this.queue["query"][index];
                                    });
                                }
                                mutation_request = {
                                    "mutations": [],
                                    "variable_data": {},
                                    "variable_types": []
                                };
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(queue["mutation"])) {
                                    queue["mutation"].map(function(mutation, index) {
                                        var graphql = mutation.graphql, variables = mutation.variables;
                                        Object.keys(variables["types"]).map(function(variable) {
                                            graphql = graphql.replace(new RegExp("\\$".concat(variable), "g"), "$".concat(variable, "_").concat(index));
                                            mutation_request["variable_data"]["".concat(variable, "_").concat(index)] = variables["data"][variable];
                                            mutation_request["variable_types"].push("$".concat(variable, "_").concat(index, ": ").concat(variables["types"][variable]));
                                        });
                                        mutation_request["mutations"].push("update_".concat(index, ":").concat(graphql).replace(new RegExp("(	)", "gm"), "").replace("\n", ""));
                                        delete _this.queue["mutation"][index];
                                    });
                                }
                                response = {
                                    "queries": {},
                                    "mutations": {}
                                };
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(query_request["queries"])) {
                                    _ctx.next = 13;
                                    break;
                                }
                                _ctx.next = 12;
                                return _this.request("query ( ".concat(query_request["variable_types"].join(", "), " ) { ").concat(query_request["queries"].join("\n"), " }"), query_request["variable_data"]);
                            case 12:
                                response["queries"] = _ctx.sent;
                            case 13:
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(mutation_request["mutations"])) {
                                    _ctx.next = 17;
                                    break;
                                }
                                _ctx.next = 16;
                                return _this.request("mutation ( ".concat(mutation_request["variable_types"].join(", "), " ) { ").concat(mutation_request["mutations"].join("\n"), " }"), mutation_request["variable_data"]);
                            case 16:
                                response["mutations"] = _ctx.sent;
                            case 17:
                                return _ctx.abrupt("return", response);
                            case 20:
                                _ctx.prev = 20;
                                _ctx.t0 = _ctx["catch"](0);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura -> process_queue():", {
                                        "error": _ctx.t0,
                                        "queue": _this.queue
                                    });
                                }
                                return _ctx.abrupt("return", false);
                            case 24:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            20
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "request",
            value: /**
	 *
	 * @param graphql
	 * @param variables
	 * @returns {Promise<boolean|*>}
	 */ function request1() {
                var graphql = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", variables = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var response, headers, request, remote_response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                response = false;
                                _ctx.prev = 1;
                                if (!((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["context"]) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.configuration) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(graphql))) {
                                    _ctx.next = 4;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 4:
                                headers = {};
                                if (_this.args["context"] === "frontend") {
                                    headers = {
                                        "authorization": "Bearer ".concat(_this.configuration["token"]),
                                        "x-pim-host": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["host"]) ? _this.args["host"] : ""
                                    };
                                }
                                if (_this.args["context"] === "backend") {
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["token"])) {
                                        headers = {
                                            "authorization": "Bearer ".concat(_this.args["token"]),
                                            "x-pim-host": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["host"]) ? _this.args["host"] : ""
                                        };
                                    } else {
                                        headers = {
                                            "x-hasura-admin-secret": _this.configuration["token"],
                                            "x-hasura-tenant-id": _this.args["tenant_id"]
                                        };
                                    }
                                }
                                request = {
                                    "baseURL": _this.configuration["url"],
                                    "headers": headers,
                                    "timeout": 30000,
                                    "method": "POST",
                                    "data": {
                                        "query": (0,graphql__WEBPACK_IMPORTED_MODULE_4__/* .print */ .S)((0,graphql_tag__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .ZP)(_templateObject(), graphql))
                                    }
                                };
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(variables)) {
                                    request["data"]["variables"] = variables;
                                }
                                _ctx.next = 11;
                                return axios__WEBPACK_IMPORTED_MODULE_1___default()(request);
                            case 11:
                                remote_response = _ctx.sent;
                                //console.log( 'remote_response:' );
                                //console.log( remote_response );
                                //console.log( util.inspect( remote_response, false, null, true ) );
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)((remote_response["data"] || {})["data"])) {
                                    response = remote_response["data"]["data"];
                                } else {
                                    response = remote_response["data"];
                                }
                                return _ctx.abrupt("return", response);
                            case 16:
                                _ctx.prev = 16;
                                _ctx.t0 = _ctx["catch"](1);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura -> request():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": {
                                                "args": _this.args
                                            },
                                            "method": {
                                                "graphql": graphql,
                                                "variables": variables
                                            }
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 20:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            16
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "query",
            value: /**
	 *
	 * @param graphql
	 * @param variables
	 * @param args
	 * @returns {Promise<boolean|*>}
	 */ function query() {
                var graphql = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", variables = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, args = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
                    "return": false
                };
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                if (!(args["return"] === true)) {
                                    _ctx.next = 2;
                                    break;
                                }
                                return _ctx.abrupt("return", _this.set_queue(graphql, variables, "query"));
                            case 2:
                                return _ctx.abrupt("return", _this.request(graphql, variables));
                            case 3:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        },
        {
            key: "mutation",
            value: /**
	 *
	 * @param graphql
	 * @param variables
	 * @param args
	 * @returns {Promise<boolean|*>}
	 */ function mutation() {
                var graphql = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", variables = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, args = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
                    "return": false
                };
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                if (!(args["return"] === true)) {
                                    _ctx.next = 2;
                                    break;
                                }
                                return _ctx.abrupt("return", _this.set_queue(graphql, variables, "mutation"));
                            case 2:
                                return _ctx.abrupt("return", _this.request(graphql, variables));
                            case 3:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }))();
            }
        }
    ]);
    return Hasura;
}(_print_engine_utilities_integration_js__WEBPACK_IMPORTED_MODULE_3__.Integration);


/***/ }),

/***/ 56129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Orders": function() { return /* binding */ Orders; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _hasura_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98172);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * Hasura Integration
 * @class   Orders
 * @extends Hasura
 */ var Orders = /*#__PURE__*/ function(Hasura1) {
    "use strict";
    _inherits(Orders, Hasura1);
    var _super = _createSuper(Orders);
    function Orders() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Orders);
        var _this;
        try {
            var default_args = {
                "environment": null,
                "context": null,
                "entity_type_id": 3429973138428903
            };
            var args = _objectSpread({}, default_args, user_args);
            _this = _super.call(this, args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/hasura/orders/orders -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Orders, [
        {
            /**
	 *
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * Creates an order in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, order_response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "payload": {},
                                    "returning": [
                                        "id"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["payload"])) {
                                    _ctx.next = 8;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 8:
                                graphql = "\n			mutation createOrder($input: orders_insert_input!) {\n				insert_orders(objects: [$input]) {\n					returning {\n						".concat(args["returning"].join("\n"), "\n					}\n				}\n			}\n			");
                                _ctx.next = 11;
                                return _this.mutation(graphql, {
                                    "input": args["payload"]
                                });
                            case 11:
                                order_response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(order_response)) {
                                    _this.cache.remove(_this.constructor["name"]);
                                    data["response"] = order_response;
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)((order_response["insert_orders"] || {})["returning"])) {
                                        data["results"] = order_response["insert_orders"]["returning"];
                                    }
                                }
                                return _ctx.abrupt("return", data);
                            case 16:
                                _ctx.prev = 16;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/orders/orders -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "graphql": graphql,
                                        "payload": args["payload"],
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 20:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            16
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * Retrieves a specific order from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "id": "",
                                    "entity_type_id": "",
                                    "returning": [
                                        "id",
                                        "entity_id",
                                        "name",
                                        "created_at",
                                        "updated_at"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 20;
                                break;
                            case 12:
                                where = 'id: { _eq: "'.concat(args["id"], '" }');
                                where += "archived_at: {_is_null: true}";
                                graphql = "\n				query getOrder {\n					orders (\n						where: { ".concat(where, " }\n					) {\n						").concat(args["returning"].join("\n"), "\n						tenant {\n							id\n							tenant_id\n							name\n						}\n					}\n				}\n				");
                                _ctx.next = 17;
                                return _this.query(graphql);
                            case 17:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"] = response;
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["orders"])) {
                                        data["results"] = response["orders"][0];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                            case 20:
                                return _ctx.abrupt("return", data);
                            case 23:
                                _ctx.prev = 23;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/orders/orders -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 27:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            23
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * Retrieves multiple orders from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{total: number, response: *[], results: *[]}>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: [],
                                    total: 0,
                                    response: []
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "column": "name",
                                    "order": "asc",
                                    "page": 1,
                                    "per_page": 20,
                                    "includes": "",
                                    "excludes": "",
                                    "entity_id": "",
                                    "entity_type_id": "",
                                    "returning": [
                                        "id",
                                        "entity_id",
                                        "name",
                                        "created_at",
                                        "updated_at"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                args["offset"] = (args["page"] - 1) * args["per_page"];
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 13;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 27;
                                break;
                            case 13:
                                where = 'entity_type_id: { _eq: "'.concat(_this.args["entity_type_id"], '" }');
                                where += "archived_at: {_is_null: true}";
                                where += "_and: [";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["entity_id"])) {
                                    where += '{ entity_id: { _eq: "'.concat(args["entity_id"], '" } }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["includes"])) {
                                    where += '{ name: { _ilike: "%'.concat(args["includes"], '%" } }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["excludes"])) {
                                    where += '{ name: { _nilike: "%'.concat(args["excludes"], '%" } }');
                                }
                                where += "]";
                                graphql = "\n				query listOrders {\n					orders (\n						where: { ".concat(where, " }\n						order_by: { ").concat(args["column"], ": ").concat(args["order"], " }\n						offset: ").concat(args["offset"], "\n						limit: ").concat(args["per_page"], "\n					) {\n						").concat(args["returning"].join("\n"), "\n						tenant {\n							id\n							tenant_id\n							name\n						}\n					}\n					orders_aggregate (\n						where: { ").concat(where, " }\n					) {\n						aggregate  {\n							total: count\n						}\n					}\n				}\n		        ");
                                _ctx.next = 23;
                                return _this.query(graphql);
                            case 23:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"].push(response);
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["orders"])) {
                                        data["results"] = response["orders"];
                                    }
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["orders_aggregate"]["aggregate"]["total"])) {
                                        data["total"] = response["orders_aggregate"]["aggregate"]["total"];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                                if (data["total"] > 0) {
                                    data["results"].map(function(result) {
                                        _this.cache.set(_this.constructor["name"], JSON.stringify({
                                            "id": result["id"],
                                            "entity_type_id": args["entity_type_id"]
                                        }), {
                                            response: "cached",
                                            results: result
                                        });
                                    });
                                }
                            case 27:
                                return _ctx.abrupt("return", data);
                            case 30:
                                _ctx.prev = 30;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/orders/orders -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 34:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            30
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * Updates an order in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, data, default_args, payload, attributes, requests, batches, entity_responses, organization_attributes;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": [],
                                    "returning": [
                                        "id",
                                        "name",
                                        "created_at",
                                        "updated_at"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["payload"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 7:
                                if (Array.isArray(args["payload"])) {
                                    _ctx.next = 9;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 9:
                                payload = [];
                                attributes = [];
                                args["payload"].map(function(item) {
                                    payload.push(_objectSpread({}, item, {
                                        "entity_type_id": args["entity_type_id"]
                                    }));
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["attributes"])) {
                                        item["attributes"].map(function(attribute) {
                                            attributes.push(_objectSpread({}, attribute, {
                                                entity_id: item["id"]
                                            }));
                                        });
                                    }
                                });
                                payload.map(function(item) {
                                    delete item["attributes"];
                                });
                                requests = {};
                                payload.map(function(item) {
                                    if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["id"])) {
                                        return false;
                                    }
                                    var fields = [];
                                    Object.keys(item).map(function(key) {
                                        if (key !== "id") {
                                            fields.push("".concat(key, ': "').concat(item[key], '"'));
                                        }
                                    });
                                    var graphql = '\n				mutation updateOrders {\n					update_orders(\n						where: { \n							id: { _eq: "'.concat(item["id"], '" } \n						}, \n						_set: { ').concat(fields.join(), " }\n					) {\n						affected_rows\n						returning {\n							").concat(args["returning"].join("\n"), "\n						}\n					}\n				}\n				");
                                    requests[item["id"]] = {
                                        "callback": _this.mutation.bind(_this),
                                        "args": graphql
                                    };
                                });
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(requests)) {
                                    _ctx.next = 17;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 17:
                                data["response"]["entity"] = [];
                                data["results"]["entity"] = [];
                                _ctx.next = 21;
                                return (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.process_in_batches)(requests, 5);
                            case 21:
                                batches = _ctx.sent;
                                entity_responses = Object.values(batches);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(entity_responses)) {
                                    _this.cache.remove(_this.constructor["name"]);
                                    entity_responses.map(function(entity_response) {
                                        var entity = entity_response[Object.keys(entity_response)[0]];
                                        data["response"]["entity"].push(entity);
                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)((entity["update_orders"] || {})["returning"])) {
                                            data["results"]["entity"] = data["results"]["entity"].concat(entity["update_orders"]["returning"]);
                                        }
                                    });
                                }
                                delete args["returning"];
                                _ctx.next = 27;
                                return _this.Entity_Attributes.update(_objectSpread({}, args, {
                                    payload: attributes
                                }));
                            case 27:
                                organization_attributes = _ctx.sent;
                                data["response"]["attributes"] = organization_attributes["response"];
                                data["results"]["attributes"] = organization_attributes["results"];
                                return _ctx.abrupt("return", data);
                            case 33:
                                _ctx.prev = 33;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/orders/orders -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 37:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            33
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Orders;
}(_hasura_js__WEBPACK_IMPORTED_MODULE_2__.Hasura);


/***/ }),

/***/ 67697:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Clients": function() { return /* binding */ Clients; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _organizations_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2975);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _get(target1, property1, receiver1) {
    if (typeof Reflect !== "undefined" && Reflect.get) {
        _get = Reflect.get;
    } else {
        _get = function _get(target, property, receiver) {
            var base = _superPropBase(target, property);
            if (!base) return;
            var desc = Object.getOwnPropertyDescriptor(base, property);
            if (desc.get) {
                return desc.get.call(receiver);
            }
            return desc.value;
        };
    }
    return _get(target1, property1, receiver1 || target1);
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
function _superPropBase(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = _getPrototypeOf(object);
        if (object === null) break;
    }
    return object;
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}


/**
 * Hasura Integration
 * @class   Clients
 * @extends Organizations
 */ var Clients = /*#__PURE__*/ function(Organizations1) {
    "use strict";
    _inherits(Clients, Organizations1);
    var _super = _createSuper(Clients);
    function Clients() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Clients);
        var _this;
        try {
            var default_args = {
                "environment": null,
                "context": null,
                "entity_type_id": 3428497185910548
            };
            var args = _objectSpread({}, default_args, user_args);
            _this = _super.call(this, args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/hasura/organizations/clients -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Clients, [
        {
            /**
	 *
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * Creates a client in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}|boolean|*>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                var _this1 = this, _superprop_get_create = function() {
                    return _get(_getPrototypeOf(Clients.prototype), "create", _this);
                };
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                _ctx.prev = 1;
                                default_args = {
                                    "payload": [],
                                    "entity_type_id": _this1.args["entity_type_id"]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 6;
                                return _superprop_get_create().call(_this1, args);
                            case 6:
                                return _ctx.abrupt("return", _ctx.sent);
                            case 9:
                                _ctx.prev = 9;
                                _ctx.t0 = _ctx["catch"](1);
                                if (_this1.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/organizations/clients -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this1.args,
                                            "method": args
                                        },
                                        "configuration": _this1.configuration
                                    });
                                }
                                throw _ctx.t0;
                            case 13:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            9
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * Retrieves a specific client from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                var _this2 = this, _superprop_get_get = function() {
                    return _get(_getPrototypeOf(Clients.prototype), "get", _this);
                };
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                _ctx.prev = 1;
                                default_args = {
                                    "id": "",
                                    "entity_type_id": _this2.args["entity_type_id"]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 6;
                                return _superprop_get_get().call(_this2, args, disable_cache);
                            case 6:
                                return _ctx.abrupt("return", _ctx.sent);
                            case 9:
                                _ctx.prev = 9;
                                _ctx.t0 = _ctx["catch"](1);
                                if (_this2.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/organizations/clients -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this2.args,
                                            "method": args
                                        },
                                        "configuration": _this2.configuration
                                    });
                                }
                                throw _ctx.t0;
                            case 13:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            9
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * Retrieves multiple clients from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{total: number, response: *[], results: *[]}>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                var _this3 = this, _superprop_get_list = function() {
                    return _get(_getPrototypeOf(Clients.prototype), "list", _this);
                };
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                _ctx.prev = 1;
                                default_args = {
                                    "column": "created_at",
                                    "order": "desc",
                                    "page": 1,
                                    "per_page": 20,
                                    "includes": "",
                                    "excludes": "",
                                    "entity_type_id": _this3.args["entity_type_id"]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                args["offset"] = (args["page"] - 1) * args["per_page"];
                                _ctx.next = 7;
                                return _superprop_get_list().call(_this3, args, disable_cache);
                            case 7:
                                return _ctx.abrupt("return", _ctx.sent);
                            case 10:
                                _ctx.prev = 10;
                                _ctx.t0 = _ctx["catch"](1);
                                if (_this3.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/organizations/clients -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this3.args,
                                            "method": args
                                        },
                                        "configuration": _this3.configuration
                                    });
                                }
                                throw _ctx.t0;
                            case 14:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            10
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * Updates a client in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                var _this4 = this, _superprop_get_update = function() {
                    return _get(_getPrototypeOf(Clients.prototype), "update", _this);
                };
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                _ctx.prev = 1;
                                default_args = {
                                    "id": 0,
                                    "payload": [],
                                    "entity_type_id": _this4.args["entity_type_id"]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 6;
                                return _superprop_get_update().call(_this4, args);
                            case 6:
                                return _ctx.abrupt("return", _ctx.sent);
                            case 9:
                                _ctx.prev = 9;
                                _ctx.t0 = _ctx["catch"](1);
                                if (_this4.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/organizations/clients -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this4.args,
                                            "method": args
                                        },
                                        "configuration": _this4.configuration
                                    });
                                }
                                throw _ctx.t0;
                            case 13:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            1,
                            9
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Clients;
}(_organizations_js__WEBPACK_IMPORTED_MODULE_1__.Organizations);


/***/ }),

/***/ 2975:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Organizations": function() { return /* binding */ Organizations; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _hasura_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98172);
/* harmony import */ var _attributes_entity_attributes_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(74883);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




var _Entity_Attributes = new _attributes_entity_attributes_js__WEBPACK_IMPORTED_MODULE_3__.Entity_Attributes();
/**
 * Hasura Integration
 * @class   Organizations
 * @extends Hasura
 */ var Organizations = /*#__PURE__*/ function(Hasura1) {
    "use strict";
    _inherits(Organizations, Hasura1);
    var _super = _createSuper(Organizations);
    function Organizations() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Organizations);
        var _this;
        try {
            var default_args = {
                "environment": null,
                "context": null,
                "entity_type_id": 3428497016041225
            };
            var args = _objectSpread({}, default_args, user_args);
            _this = _super.call(this, args);
            _this.Entity_Attributes = _Entity_Attributes;
            _this.Entity_Attributes.set_args(_this.args);
            _this.Entity_Attributes["configuration"] = _this.configuration;
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/hasura/organizations/organizations -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Organizations, [
        {
            /**
	 *
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * Creates an organization in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, payload, organization_response, attributes, attributes_response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "payload": [],
                                    "entity_type_id": _this.args["entity_type_id"],
                                    "returning": [
                                        "id",
                                        "name",
                                        "created_at",
                                        "updated_at",
                                        "source_id",
                                        "source_ref",
                                        "active"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["payload"])) {
                                    _ctx.next = 8;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 8:
                                if (Array.isArray(args["payload"])) {
                                    _ctx.next = 10;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 10:
                                payload = [];
                                args["payload"].map(function(item) {
                                    payload.push(_objectSpread({}, item, {
                                        "entity_type_id": Number(args["entity_type_id"]),
                                        "source_ref": String(item["source_ref"])
                                    }));
                                });
                                payload.map(function(item) {
                                    delete item["attributes"];
                                });
                                graphql = "\n			mutation createOrganization($objects: [organizations_insert_input!]!) {\n				insert_organizations(objects: $objects) {\n					returning {\n						".concat(args["returning"].join("\n"), "\n						entity_type {\n							id\n							name\n							type\n							level\n							root_id\n							root_name\n							path\n						}\n						attributes {\n							attribute_id\n							attribute_name\n							attribute_code\n							attribute_value\n							field_type_id\n							field_type\n							entity_attribute_id\n						}\n						tenant {\n							id\n							tenant_id\n							name\n						}\n					}\n				}\n			}\n			");
                                _ctx.next = 16;
                                return _this.mutation(graphql, {
                                    "objects": payload
                                });
                            case 16:
                                organization_response = _ctx.sent;
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(organization_response)) {
                                    _ctx.next = 29;
                                    break;
                                }
                                _this.cache.remove(_this.constructor["name"]);
                                data["response"]["entity"] = organization_response;
                                attributes = [];
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(organization_response["insert_organizations"]["returning"])) {
                                    data["results"]["entity"] = organization_response["insert_organizations"]["returning"];
                                    organization_response["insert_organizations"]["returning"].map(function(organization) {
                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(organization["id"]) && !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(organization["name"])) {
                                            args["payload"].map(function(item) {
                                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["name"])) {
                                                    if (organization["name"] === item["name"]) {
                                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["attributes"])) {
                                                            item["attributes"].map(function(attribute) {
                                                                attributes.push(_objectSpread({}, attribute, {
                                                                    "entity_id": organization["id"]
                                                                }));
                                                            });
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(attributes)) {
                                    _ctx.next = 29;
                                    break;
                                }
                                delete args["returning"];
                                _ctx.next = 26;
                                return _this.Entity_Attributes.create(_objectSpread({}, args, {
                                    payload: attributes
                                }));
                            case 26:
                                attributes_response = _ctx.sent;
                                data["response"]["attributes"] = attributes_response["response"];
                                data["results"]["attributes"] = attributes_response["results"];
                            case 29:
                                return _ctx.abrupt("return", data);
                            case 32:
                                _ctx.prev = 32;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/organizations/organizations -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 36:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            32
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * Retrieves a specific organization from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, source_id, source_ref, source, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "id": "",
                                    "entity_type_id": _this.args["entity_type_id"],
                                    "source_id": "",
                                    "source_ref": "",
                                    "returning": [
                                        "id",
                                        "entity_type_id",
                                        "name",
                                        "active",
                                        "created_at",
                                        "updated_at",
                                        "source_id",
                                        "source_ref"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 26;
                                break;
                            case 12:
                                where = 'id: { _eq: "'.concat(args["id"], '" }');
                                where += "archived_at: {_is_null: true}";
                                source_id = "";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["source_id"])) {
                                    source_id = 'source_id: { _eq: "'.concat(args["source_id"], '" }');
                                }
                                source_ref = "";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["source_ref"])) {
                                    source_ref = 'source_ref: { _eq: "'.concat(args["source_ref"], '" }');
                                }
                                source = "".concat(source_id).concat(source_ref);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(source)) {
                                    where = source;
                                }
                                graphql = "\n				query getOrganization {\n					organizations(\n						where: { ".concat(where, " }\n					) {\n						").concat(args["returning"].join("\n"), "\n						entity_type {\n							id\n							name\n							plural_name\n							singular_name\n						}\n						attributes {\n							attribute_id\n							attribute_name\n							attribute_code\n							attribute_value\n							field_type_id\n							field_type\n							field_type_code\n							entity_attribute_id\n							properties\n							type\n						}\n						tenant {\n							id\n							tenant_id\n							name\n						}\n					}\n				}\n				");
                                _ctx.next = 23;
                                return _this.query(graphql);
                            case 23:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"] = response;
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["organizations"])) {
                                        data["results"] = response["organizations"][0];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                            case 26:
                                return _ctx.abrupt("return", data);
                            case 29:
                                _ctx.prev = 29;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/organizations/organizations -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 33:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            29
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * Retrieves multiple organizations from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{total: number, response: *[], results: *[]}>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, limit, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: [],
                                    total: 0,
                                    response: []
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "column": "created_at",
                                    "order": "desc",
                                    "page": 1,
                                    "per_page": 20,
                                    "includes": "",
                                    "excludes": "",
                                    "entity_type_id": _this.args["entity_type_id"],
                                    "returning": [
                                        "id",
                                        "entity_type_id",
                                        "name",
                                        "active",
                                        "created_at",
                                        "updated_at",
                                        "source_id",
                                        "source_ref"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                args["offset"] = (args["page"] - 1) * args["per_page"];
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["entity_type_id"])) {
                                    _ctx.next = 9;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 9:
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 15;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 32;
                                break;
                            case 15:
                                where = "";
                                where += "archived_at: {_is_null: true}";
                                where += "_and: [";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["entity_type_id"])) {
                                    where += "{ entity_type_id: { _eq: ".concat(args["entity_type_id"], " } }");
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["includes"])) {
                                    where += '{ name: { _ilike: "%'.concat(args["includes"], '%" } }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["excludes"])) {
                                    where += '{ name: { _nilike: "%'.concat(args["excludes"], '%" } }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["account_manager_id"])) {
                                    where += 'attributes: {attribute_id: {_eq: "3428512981659433"}, attribute_value: {_eq: "'.concat(args["account_manager_id"], '"}}');
                                }
                                where += "]";
                                limit = "";
                                if (args["per_page"] > 0) {
                                    limit = "limit: ".concat(args["per_page"]);
                                }
                                graphql = "\n				query listOrganizations {\n					organizations(\n						where: { ".concat(where, " }\n						order_by: { ").concat(args["column"], ": ").concat(args["order"], " }\n						offset: ").concat(args["offset"], "\n						").concat(limit, "\n					) {\n						").concat(args["returning"].join("\n"), "\n						entity_type {\n							id\n							name\n							plural_name\n							singular_name\n						}\n						attributes {\n							attribute_id\n							attribute_name\n							attribute_code\n							attribute_value\n							field_type_id\n							field_type\n							field_type_code\n							entity_attribute_id\n							properties\n							type\n						}\n						tenant {\n							id\n							tenant_id\n							name\n						}\n					}\n					organizations_aggregate(\n						where: { ").concat(where, " }\n					) {\n						aggregate {\n							total: count\n						}\n					}\n				}\n				");
                                _ctx.next = 28;
                                return _this.query(graphql);
                            case 28:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"].push(response);
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["organizations"])) {
                                        data["results"] = response["organizations"];
                                    }
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["organizations_aggregate"]["aggregate"]["total"])) {
                                        data["total"] = response["organizations_aggregate"]["aggregate"]["total"];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                                if (data["total"] > 0) {
                                    data["results"].map(function(result) {
                                        _this.cache.set(_this.constructor["name"], JSON.stringify({
                                            "id": result["id"],
                                            "entity_type_id": args["entity_type_id"]
                                        }), {
                                            response: "cached",
                                            results: result
                                        });
                                    });
                                }
                            case 32:
                                return _ctx.abrupt("return", data);
                            case 35:
                                _ctx.prev = 35;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/organizations/organizations -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 39:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            35
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * Updates an organization in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, data, default_args, payload, attributes, returning, organization_attributes, requests, batches, entity_responses;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": [],
                                    "returning": [
                                        "id",
                                        "name",
                                        "created_at",
                                        "updated_at",
                                        "source_id",
                                        "source_ref",
                                        "active"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["payload"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 7:
                                if (Array.isArray(args["payload"])) {
                                    _ctx.next = 9;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 9:
                                payload = [];
                                attributes = [];
                                args["payload"].map(function(item) {
                                    payload.push(_objectSpread({}, item, {
                                        "entity_type_id": Number(args["entity_type_id"]),
                                        "source_ref": String(item["source_ref"])
                                    }));
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["attributes"])) {
                                        item["attributes"].map(function(attribute) {
                                            attributes.push(_objectSpread({}, attribute, {
                                                entity_id: item["id"]
                                            }));
                                        });
                                    }
                                });
                                payload.map(function(item) {
                                    delete item["attributes"];
                                });
                                returning = args["returning"];
                                delete args["returning"];
                                _ctx.next = 17;
                                return _this.Entity_Attributes.update(_objectSpread({}, args, {
                                    payload: attributes
                                }));
                            case 17:
                                organization_attributes = _ctx.sent;
                                data["response"]["attributes"] = organization_attributes["response"];
                                data["results"]["attributes"] = organization_attributes["results"];
                                args["returning"] = returning;
                                requests = {};
                                payload.map(function(item) {
                                    if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["id"])) {
                                        return false;
                                    }
                                    var fields = [];
                                    Object.keys(item).map(function(key) {
                                        if (key !== "id") {
                                            fields.push("".concat(key, ': "').concat(item[key], '"'));
                                        }
                                    });
                                    var graphql = '\n				mutation updateOrganizations {\n					update_organizations(\n						where: { \n							id: { _eq: "'.concat(item["id"], '" } \n						}, \n						_set: { ').concat(fields.join(), " }\n					) {\n						affected_rows\n						returning {\n							").concat(args["returning"].join("\n"), "\n							entity_type {\n								id\n								name\n								type\n								level\n								root_id\n								root_name\n								path\n							}\n							attributes {\n								attribute_id\n								attribute_name\n								attribute_code\n								attribute_value\n								field_type_id\n								field_type\n							}\n							tenant {\n								id\n								tenant_id\n								name\n							}\n						}\n					}\n				}\n				");
                                    requests[item["id"]] = {
                                        "callback": _this.mutation.bind(_this),
                                        "args": graphql
                                    };
                                });
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(requests)) {
                                    _ctx.next = 25;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 25:
                                data["response"]["entity"] = [];
                                data["results"]["entity"] = [];
                                _ctx.next = 29;
                                return (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.process_in_batches)(requests, 5);
                            case 29:
                                batches = _ctx.sent;
                                entity_responses = Object.values(batches);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(entity_responses)) {
                                    entity_responses.map(function(entity_response) {
                                        var entity = entity_response[Object.keys(entity_response)[0]];
                                        data["response"]["entity"].push(entity);
                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)((entity["update_organizations"] || {})["returning"])) {
                                            data["results"]["entity"] = data["results"]["entity"].concat(entity["update_organizations"]["returning"]);
                                        }
                                    });
                                }
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", data);
                            case 36:
                                _ctx.prev = 36;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/organizations/organizations -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 40:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            36
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Organizations;
}(_hasura_js__WEBPACK_IMPORTED_MODULE_2__.Hasura);


/***/ }),

/***/ 87916:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Products": function() { return /* binding */ Products; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _attributes_entity_attributes_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74883);
/* harmony import */ var _hasura_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98172);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




var _Entity_Attributes = new _attributes_entity_attributes_js__WEBPACK_IMPORTED_MODULE_2__.Entity_Attributes();
/**
 * Hasura Integration
 * @class   Products
 * @extends Hasura
 */ var Products = /*#__PURE__*/ function(Hasura1) {
    "use strict";
    _inherits(Products, Hasura1);
    var _super = _createSuper(Products);
    function Products() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Products);
        var _this;
        try {
            var default_args = {
                "environment": null,
                "context": null,
                "entity_type_id": 3428497181716238
            };
            var args = _objectSpread({}, default_args, user_args);
            _this = _super.call(this, args);
            _this.Entity_Attributes = _Entity_Attributes;
            _this.Entity_Attributes.set_args(_this.args);
            _this.Entity_Attributes["configuration"] = _this.configuration;
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/hasura/products/products -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Products, [
        {
            /**
	 *
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * Creates a product in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, payload, product_response, attributes, attributes_response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "payload": [],
                                    "entity_type_id": _this.args["entity_type_id"],
                                    "returning": [
                                        "id",
                                        "entity_id",
                                        "name",
                                        "product_number",
                                        "active",
                                        "created_at",
                                        "updated_at",
                                        "source_id",
                                        "source_ref"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["payload"])) {
                                    _ctx.next = 8;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 8:
                                if (Array.isArray(args["payload"])) {
                                    _ctx.next = 10;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 10:
                                payload = [];
                                args["payload"].map(function(item) {
                                    payload.push(_objectSpread({}, item, {
                                        "entity_type_id": Number(args["entity_type_id"]),
                                        "source_ref": String(item["source_ref"])
                                    }));
                                });
                                payload.map(function(item) {
                                    delete item["attributes"];
                                });
                                graphql = "\n			mutation createProduct($objects: [products_insert_input!]!) {\n				insert_products(objects: $objects) {\n					returning {\n						".concat(args["returning"].join("\n"), "\n						attributes {\n							attribute_id\n							attribute_name\n							attribute_code\n							attribute_value\n							field_type_id\n							field_type\n							entity_attribute_id\n						}\n						assigned_to {\n							id\n							first_name\n							last_name\n							email\n						}\n						organization {\n							id\n							name\n							entity_type {\n								name\n								code\n							}\n						}\n						tenant {\n							id\n							tenant_id\n							name\n						}\n					}\n				}\n			}\n			");
                                _ctx.next = 16;
                                return _this.mutation(graphql, payload);
                            case 16:
                                product_response = _ctx.sent;
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(product_response)) {
                                    _ctx.next = 29;
                                    break;
                                }
                                _this.cache.remove(_this.constructor["name"]);
                                data["response"]["entity"] = product_response;
                                attributes = [];
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(product_response["insert_products"]["returning"])) {
                                    data["results"]["entity"] = product_response["insert_products"]["returning"];
                                    product_response["insert_products"]["returning"].map(function(product) {
                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(product["id"]) && !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(product["name"])) {
                                            args["payload"].map(function(item) {
                                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["name"])) {
                                                    if (product["name"] === item["name"]) {
                                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["attributes"])) {
                                                            item["attributes"].map(function(attribute) {
                                                                attributes.push(_objectSpread({}, attribute, {
                                                                    "entity_id": product["id"]
                                                                }));
                                                            });
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(attributes)) {
                                    _ctx.next = 29;
                                    break;
                                }
                                delete args["returning"];
                                _ctx.next = 26;
                                return _this.Entity_Attributes.create(_objectSpread({}, args, {
                                    payload: attributes
                                }));
                            case 26:
                                attributes_response = _ctx.sent;
                                data["response"]["attributes"] = attributes_response["response"];
                                data["results"]["attributes"] = attributes_response["results"];
                            case 29:
                                return _ctx.abrupt("return", data);
                            case 32:
                                _ctx.prev = 32;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/products/products -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 36:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            32
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * Retrieves a specific product from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "id": "",
                                    "returning": [
                                        "id",
                                        "sku",
                                        "name"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 23;
                                break;
                            case 12:
                                where = [];
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    where.push("id: {_eq: ".concat(args["id"], "}"));
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["source_id"])) {
                                    where.push("source_id: {_eq: ".concat(args["source_id"], "}"));
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["source_ref"])) {
                                    where.push('source_ref: {_eq: "'.concat(args["source_ref"], '"}'));
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["sku"])) {
                                    where.push('sku: {_eq: "'.concat(args["sku"], '"}'));
                                }
                                graphql = "\n				query getProduct {\n					products (\n						where: { ".concat(where.join(", "), " }\n					) {\n						").concat(args["returning"].join("\n"), "\n						identifiers {\n							key\n							value\n						}\n						bundle_items {\n							product {\n								id\n								name\n								sku\n								identifiers {\n									key\n									value\n								}\n							}\n							min_quantity\n							max_quantity\n						}\n					}\n				}\n				");
                                _ctx.next = 20;
                                return _this.query(graphql);
                            case 20:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"] = response;
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["products"])) {
                                        data["results"] = response["products"][0];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                            case 23:
                                return _ctx.abrupt("return", data);
                            case 26:
                                _ctx.prev = 26;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/products/products -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 30:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            26
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * Retrieves multiple products from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{total: number, response: *[], results: *[]}>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: [],
                                    total: 0,
                                    response: []
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "column": "created_at",
                                    "order": "desc",
                                    "page": 1,
                                    "per_page": 20,
                                    "includes": "",
                                    "excludes": "",
                                    "entity_id": "",
                                    "returning": [
                                        "id",
                                        "entity_id",
                                        "name",
                                        "product_number",
                                        "active",
                                        "created_at",
                                        "updated_at",
                                        "source_id",
                                        "source_ref"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                args["offset"] = (args["page"] - 1) * args["per_page"];
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 13;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 28;
                                break;
                            case 13:
                                where = "";
                                where += "archived_at: {_is_null: true}";
                                where += "_and: [";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["entity_id"])) {
                                    where += '{ entity_id: { _eq: "'.concat(args["entity_id"], '" } }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["includes"])) {
                                    where += '{ name: { _ilike: "%'.concat(args["includes"], '%" } }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["excludes"])) {
                                    where += '{ name: { _nilike: "%'.concat(args["excludes"], '%" } }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["owner_id"]) || !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["assignee_id"])) {
                                    where += "{_or: [";
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["owner_id"])) {
                                        where += '{attributes: {attribute_id: {_eq: "3437901222346691"}, attribute_value: {_eq: "'.concat(args["owner_id"], '"}}}');
                                    }
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["assignee_id"])) {
                                        where += '{ assignee_id: { _eq: "'.concat(args["assignee_id"], '" } }');
                                    }
                                    where += "]}";
                                }
                                where += "]";
                                graphql = "\n				query listProducts {\n					products (\n						where: { ".concat(where, " }\n						order_by: { ").concat(args["column"], ": ").concat(args["order"], " }\n						offset: ").concat(args["offset"], "\n						limit: ").concat(args["per_page"], "\n					) {\n						").concat(args["returning"].join("\n"), "\n						attributes {\n							attribute_id\n							attribute_name\n							attribute_code\n							attribute_value\n							field_type_id\n							field_type\n							entity_attribute_id\n						}\n						assigned_to {\n							id\n							first_name\n							last_name\n							email\n						}\n						organization {\n							id\n							name\n							entity_type {\n								name\n								code\n							}\n						}\n						tenant {\n							id\n							tenant_id\n							name\n						}\n					}\n					products_aggregate (\n						where: { ").concat(where, " }\n					) {\n						aggregate  {\n							total: count\n						}\n					}\n				}\n		        ");
                                _ctx.next = 24;
                                return _this.query(graphql);
                            case 24:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"].push(response);
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["products"])) {
                                        data["results"] = response["products"];
                                    }
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["products_aggregate"]["aggregate"]["total"])) {
                                        data["total"] = response["products_aggregate"]["aggregate"]["total"];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                                if (data["total"] > 0) {
                                    data["results"].map(function(result) {
                                        _this.cache.set(_this.constructor["name"], JSON.stringify({
                                            "id": result["id"],
                                            "entity_type_id": args["entity_type_id"]
                                        }), {
                                            response: "cached",
                                            results: result
                                        });
                                    });
                                }
                            case 28:
                                return _ctx.abrupt("return", data);
                            case 31:
                                _ctx.prev = 31;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/products/products -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 35:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            31
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * Updates a product in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, data, default_args, payload, attributes, returning, organization_attributes, requests, batches, entity_responses;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": [],
                                    "entity_type_id": _this.args["entity_type_id"],
                                    "returning": [
                                        "id",
                                        "entity_id",
                                        "name",
                                        "product_number",
                                        "active",
                                        "created_at",
                                        "updated_at",
                                        "source_id",
                                        "source_ref"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["payload"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 7:
                                if (Array.isArray(args["payload"])) {
                                    _ctx.next = 9;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 9:
                                payload = [];
                                attributes = [];
                                args["payload"].map(function(item) {
                                    payload.push(_objectSpread({}, item, {
                                        "entity_type_id": Number(args["entity_type_id"]),
                                        "source_ref": String(item["source_ref"])
                                    }));
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["attributes"])) {
                                        item["attributes"].map(function(attribute) {
                                            attributes.push(_objectSpread({}, attribute, {
                                                entity_id: item["id"]
                                            }));
                                        });
                                    }
                                });
                                payload.map(function(item) {
                                    delete item["attributes"];
                                });
                                returning = args["returning"];
                                delete args["returning"];
                                _ctx.next = 17;
                                return _this.Entity_Attributes.update(_objectSpread({}, args, {
                                    payload: attributes
                                }));
                            case 17:
                                organization_attributes = _ctx.sent;
                                data["response"]["attributes"] = organization_attributes["response"];
                                data["results"]["attributes"] = organization_attributes["results"];
                                args["returning"] = returning;
                                requests = {};
                                payload.map(function(item) {
                                    if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["id"])) {
                                        return false;
                                    }
                                    var fields = [];
                                    Object.keys(item).map(function(key) {
                                        if (key !== "id") {
                                            fields.push("".concat(key, ': "').concat(item[key], '"'));
                                        }
                                    });
                                    var graphql = '\n				mutation updateProducts {\n					update_products(\n						where: { \n							id: { _eq: "'.concat(item["id"], '" } \n						}, \n						_set: { ').concat(fields.join(), " }\n					) {\n						affected_rows\n						returning {\n							").concat(args["returning"].join("\n"), "\n							attributes {\n								attribute_id\n								attribute_name\n								attribute_code\n								attribute_value\n								field_type_id\n								field_type,\n								entity_attribute_id\n							}\n							assigned_to {\n								id\n								first_name\n								last_name\n								email\n							}\n							organization {\n								id\n								name\n								entity_type {\n									name\n									code\n								}\n							}\n							tenant {\n								id\n								tenant_id\n								name\n							}\n						}\n					}\n				}\n				");
                                    requests[item["id"]] = {
                                        "callback": _this.mutation.bind(_this),
                                        "args": graphql
                                    };
                                });
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(requests)) {
                                    _ctx.next = 25;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 25:
                                data["response"]["entity"] = [];
                                data["results"]["entity"] = [];
                                _ctx.next = 29;
                                return (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.process_in_batches)(requests, 5);
                            case 29:
                                batches = _ctx.sent;
                                entity_responses = Object.values(batches);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(entity_responses)) {
                                    _this.cache.remove(_this.constructor["name"]);
                                    entity_responses.map(function(entity_response) {
                                        var entity = entity_response[Object.keys(entity_response)[0]];
                                        data["response"]["entity"].push(entity);
                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)((entity["update_products"] || {})["returning"])) {
                                            data["results"]["entity"] = data["results"]["entity"].concat(entity["update_products"]["returning"]);
                                        }
                                    });
                                }
                                return _ctx.abrupt("return", data);
                            case 35:
                                _ctx.prev = 35;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/products/products -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 39:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            35
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Products;
}(_hasura_js__WEBPACK_IMPORTED_MODULE_3__.Hasura);


/***/ }),

/***/ 11597:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Projects": function() { return /* binding */ Projects; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _attributes_entity_attributes_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74883);
/* harmony import */ var _hasura_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98172);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




var _Entity_Attributes = new _attributes_entity_attributes_js__WEBPACK_IMPORTED_MODULE_2__.Entity_Attributes();
/**
 * Hasura Integration
 * @class   Projects
 * @extends Hasura
 */ var Projects = /*#__PURE__*/ function(Hasura1) {
    "use strict";
    _inherits(Projects, Hasura1);
    var _super = _createSuper(Projects);
    function Projects() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Projects);
        var _this;
        try {
            var default_args = {
                "environment": null,
                "context": null,
                "entity_type_id": 3428497181716238
            };
            var args = _objectSpread({}, default_args, user_args);
            _this = _super.call(this, args);
            _this.Entity_Attributes = _Entity_Attributes;
            _this.Entity_Attributes.set_args(_this.args);
            _this.Entity_Attributes["configuration"] = _this.configuration;
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/hasura/projects/projects -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Projects, [
        {
            /**
	 *
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * Creates a project in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, payload, project_response, attributes, attributes_response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "payload": [],
                                    "entity_type_id": _this.args["entity_type_id"],
                                    "returning": [
                                        "id",
                                        "entity_id",
                                        "name",
                                        "project_number",
                                        "active",
                                        "created_at",
                                        "updated_at",
                                        "source_id",
                                        "source_ref"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["payload"])) {
                                    _ctx.next = 8;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 8:
                                if (Array.isArray(args["payload"])) {
                                    _ctx.next = 10;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 10:
                                payload = [];
                                args["payload"].map(function(item) {
                                    payload.push(_objectSpread({}, item, {
                                        "entity_type_id": Number(args["entity_type_id"]),
                                        "source_ref": String(item["source_ref"])
                                    }));
                                });
                                payload.map(function(item) {
                                    delete item["attributes"];
                                });
                                graphql = "\n			mutation createProject($objects: [projects_insert_input!]!) {\n				insert_projects(objects: $objects) {\n					returning {\n						".concat(args["returning"].join("\n"), "\n						attributes {\n							attribute_id\n							attribute_name\n							attribute_code\n							attribute_value\n							field_type_id\n							field_type\n							entity_attribute_id\n						}\n						assigned_to {\n							id\n							first_name\n							last_name\n							email\n						}\n						organization {\n							id\n							name\n							entity_type {\n								name\n								code\n							}\n						}\n						tenant {\n							id\n							tenant_id\n							name\n						}\n					}\n				}\n			}\n			");
                                _ctx.next = 16;
                                return _this.mutation(graphql, {
                                    "objects": payload
                                });
                            case 16:
                                project_response = _ctx.sent;
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(project_response)) {
                                    _ctx.next = 29;
                                    break;
                                }
                                _this.cache.remove(_this.constructor["name"]);
                                data["response"]["entity"] = project_response;
                                attributes = [];
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(project_response["insert_projects"]["returning"])) {
                                    data["results"]["entity"] = project_response["insert_projects"]["returning"];
                                    project_response["insert_projects"]["returning"].map(function(project) {
                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(project["id"]) && !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(project["name"])) {
                                            args["payload"].map(function(item) {
                                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["name"])) {
                                                    if (project["name"] === item["name"]) {
                                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["attributes"])) {
                                                            item["attributes"].map(function(attribute) {
                                                                attributes.push(_objectSpread({}, attribute, {
                                                                    "entity_id": project["id"]
                                                                }));
                                                            });
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(attributes)) {
                                    _ctx.next = 29;
                                    break;
                                }
                                delete args["returning"];
                                _ctx.next = 26;
                                return _this.Entity_Attributes.create(_objectSpread({}, args, {
                                    payload: attributes
                                }));
                            case 26:
                                attributes_response = _ctx.sent;
                                data["response"]["attributes"] = attributes_response["response"];
                                data["results"]["attributes"] = attributes_response["results"];
                            case 29:
                                return _ctx.abrupt("return", data);
                            case 32:
                                _ctx.prev = 32;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/projects/projects -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 36:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            32
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * Retrieves a specific project from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, source_id, source_ref, source, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "id": "",
                                    "returning": [
                                        "id",
                                        "entity_id",
                                        "entity_type_id",
                                        "name",
                                        "project_number",
                                        "active",
                                        "created_at",
                                        "updated_at",
                                        "source_id",
                                        "source_ref"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 26;
                                break;
                            case 12:
                                where = 'id: { _eq: "'.concat(args["id"], '" }');
                                where += "archived_at: {_is_null: true}";
                                source_id = "";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["source_id"])) {
                                    source_id = 'source_id: { _eq: "'.concat(args["source_id"], '" }');
                                }
                                source_ref = "";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["source_ref"])) {
                                    source_ref = 'source_ref: { _eq: "'.concat(args["source_ref"], '" }');
                                }
                                source = "".concat(source_id).concat(source_ref);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(source)) {
                                    where = source;
                                }
                                graphql = "\n				query getProject {\n					projects (\n						where: { ".concat(where, " }\n					) {\n						").concat(args["returning"].join("\n"), "\n						entity_type {\n							id\n							name\n							plural_name\n							singular_name\n						}\n						attributes {\n							attribute_id\n							attribute_name\n							attribute_code\n							attribute_value\n							field_type_id\n							field_type\n							field_type_code\n							entity_attribute_id\n							properties\n							type\n						}\n						assigned_to {\n							id\n							first_name\n							last_name\n							email\n						}\n						organization {\n							id\n							name\n							entity_type {\n								name\n								code\n							}\n						}\n						tenant {\n							id\n							tenant_id\n							name\n						}\n					}\n				}\n				");
                                _ctx.next = 23;
                                return _this.query(graphql);
                            case 23:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"] = response;
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["projects"])) {
                                        data["results"] = response["projects"][0];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                            case 26:
                                return _ctx.abrupt("return", data);
                            case 29:
                                _ctx.prev = 29;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/projects/projects -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 33:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            29
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * Retrieves multiple projects from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{total: number, response: *[], results: *[]}>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, limit, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: [],
                                    total: 0,
                                    response: []
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "column": "created_at",
                                    "order": "desc",
                                    "page": 1,
                                    "per_page": 20,
                                    "includes": "",
                                    "excludes": "",
                                    "entity_id": "",
                                    "entity_type_id": _this.args["entity_type_id"],
                                    "returning": [
                                        "id",
                                        "entity_id",
                                        "entity_type_id",
                                        "name",
                                        "project_number",
                                        "active",
                                        "created_at",
                                        "updated_at",
                                        "source_id",
                                        "source_ref"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                args["offset"] = (args["page"] - 1) * args["per_page"];
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 13;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 31;
                                break;
                            case 13:
                                where = "";
                                where += "archived_at: {_is_null: true}";
                                where += "_and: [";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["entity_type_id"])) {
                                    where += "{ entity_type_id: { _eq: ".concat(args["entity_type_id"], " } }");
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["entity_id"])) {
                                    where += '{ entity_id: { _eq: "'.concat(args["entity_id"], '" } }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["includes"])) {
                                    where += '{ name: { _ilike: "%'.concat(args["includes"], '%" } }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["excludes"])) {
                                    where += '{ name: { _nilike: "%'.concat(args["excludes"], '%" } }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["owner_id"]) || !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["assignee_id"])) {
                                    where += "{_or: [";
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["owner_id"])) {
                                        where += '{attributes: {attribute_id: {_eq: "3437901222346691"}, attribute_value: {_eq: "'.concat(args["owner_id"], '"}}}');
                                    }
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["assignee_id"])) {
                                        where += '{ assignee_id: { _eq: "'.concat(args["assignee_id"], '" } }');
                                    }
                                    where += "]}";
                                }
                                where += "]";
                                limit = "";
                                if (args["per_page"] > 0) {
                                    limit = "limit: ".concat(args["per_page"]);
                                }
                                graphql = "\n				query listProjects {\n					projects (\n						where: { ".concat(where, " }\n						order_by: { ").concat(args["column"], ": ").concat(args["order"], " }\n						offset: ").concat(args["offset"], "\n						").concat(limit, "\n					) {\n						").concat(args["returning"].join("\n"), "\n						entity_type {\n							id\n							name\n							plural_name\n							singular_name\n						}\n						attributes {\n							attribute_id\n							attribute_name\n							attribute_code\n							attribute_value\n							field_type_id\n							field_type\n							field_type_code\n							entity_attribute_id\n							properties\n							type\n						}\n						assigned_to {\n							id\n							first_name\n							last_name\n							email\n						}\n						organization {\n							id\n							name\n							entity_type {\n								name\n								code\n							}\n						}\n						tenant {\n							id\n							tenant_id\n							name\n						}\n					}\n					projects_aggregate (\n						where: { ").concat(where, " }\n					) {\n						aggregate  {\n							total: count\n						}\n					}\n				}\n		        ");
                                _ctx.next = 27;
                                return _this.query(graphql);
                            case 27:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"].push(response);
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["projects"])) {
                                        data["results"] = response["projects"];
                                    }
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["projects_aggregate"]["aggregate"]["total"])) {
                                        data["total"] = response["projects_aggregate"]["aggregate"]["total"];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                                if (data["total"] > 0) {
                                    data["results"].map(function(result) {
                                        _this.cache.set(_this.constructor["name"], JSON.stringify({
                                            "id": result["id"],
                                            "entity_type_id": args["entity_type_id"]
                                        }), {
                                            response: "cached",
                                            results: result
                                        });
                                    });
                                }
                            case 31:
                                return _ctx.abrupt("return", data);
                            case 34:
                                _ctx.prev = 34;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/projects/projects -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 38:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            34
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * Updates a project in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, data, default_args, payload, attributes, returning, organization_attributes, requests, batches, entity_responses;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": [],
                                    "entity_type_id": _this.args["entity_type_id"],
                                    "returning": [
                                        "id",
                                        "entity_id",
                                        "name",
                                        "project_number",
                                        "active",
                                        "created_at",
                                        "updated_at",
                                        "source_id",
                                        "source_ref"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["payload"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 7:
                                if (Array.isArray(args["payload"])) {
                                    _ctx.next = 9;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 9:
                                payload = [];
                                attributes = [];
                                args["payload"].map(function(item) {
                                    payload.push(_objectSpread({}, item, {
                                        "entity_type_id": Number(args["entity_type_id"]),
                                        "source_ref": String(item["source_ref"])
                                    }));
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["attributes"])) {
                                        item["attributes"].map(function(attribute) {
                                            attributes.push(_objectSpread({}, attribute, {
                                                entity_id: item["id"]
                                            }));
                                        });
                                    }
                                });
                                payload.map(function(item) {
                                    delete item["attributes"];
                                });
                                returning = args["returning"];
                                delete args["returning"];
                                _ctx.next = 17;
                                return _this.Entity_Attributes.update(_objectSpread({}, args, {
                                    payload: attributes
                                }));
                            case 17:
                                organization_attributes = _ctx.sent;
                                data["response"]["attributes"] = organization_attributes["response"];
                                data["results"]["attributes"] = organization_attributes["results"];
                                args["returning"] = returning;
                                requests = {};
                                payload.map(function(item) {
                                    if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["id"])) {
                                        return false;
                                    }
                                    var fields = [];
                                    Object.keys(item).map(function(key) {
                                        if (key !== "id") {
                                            fields.push("".concat(key, ': "').concat(item[key], '"'));
                                        }
                                    });
                                    var graphql = '\n				mutation updateProjects {\n					update_projects(\n						where: { \n							id: { _eq: "'.concat(item["id"], '" } \n						}, \n						_set: { ').concat(fields.join(), " }\n					) {\n						affected_rows\n						returning {\n							").concat(args["returning"].join("\n"), "\n							attributes {\n								attribute_id\n								attribute_name\n								attribute_code\n								attribute_value\n								field_type_id\n								field_type,\n								entity_attribute_id\n							}\n							assigned_to {\n								id\n								first_name\n								last_name\n								email\n							}\n							organization {\n								id\n								name\n								entity_type {\n									name\n									code\n								}\n							}\n							tenant {\n								id\n								tenant_id\n								name\n							}\n						}\n					}\n				}\n				");
                                    requests[item["id"]] = {
                                        "callback": _this.mutation.bind(_this),
                                        "args": graphql
                                    };
                                });
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(requests)) {
                                    _ctx.next = 25;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 25:
                                data["response"]["entity"] = [];
                                data["results"]["entity"] = [];
                                _ctx.next = 29;
                                return (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.process_in_batches)(requests, 5);
                            case 29:
                                batches = _ctx.sent;
                                entity_responses = Object.values(batches);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(entity_responses)) {
                                    _this.cache.remove(_this.constructor["name"]);
                                    entity_responses.map(function(entity_response) {
                                        var entity = entity_response[Object.keys(entity_response)[0]];
                                        data["response"]["entity"].push(entity);
                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)((entity["update_projects"] || {})["returning"])) {
                                            data["results"]["entity"] = data["results"]["entity"].concat(entity["update_projects"]["returning"]);
                                        }
                                    });
                                }
                                return _ctx.abrupt("return", data);
                            case 35:
                                _ctx.prev = 35;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/projects/projects -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 39:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            35
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Projects;
}(_hasura_js__WEBPACK_IMPORTED_MODULE_3__.Hasura);


/***/ }),

/***/ 53606:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Source_Event_Queue": function() { return /* binding */ Source_Event_Queue; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _hasura_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(98172);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * Hasura Integration
 * @class   Source_Event_Queue
 * @extends Hasura
 */ var Source_Event_Queue = /*#__PURE__*/ function(Hasura1) {
    "use strict";
    _inherits(Source_Event_Queue, Hasura1);
    var _super = _createSuper(Source_Event_Queue);
    function Source_Event_Queue() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Source_Event_Queue);
        var _this;
        try {
            var default_args = {
                "environment": null,
                "context": null
            };
            var args = _objectSpread({}, default_args, user_args);
            _this = _super.call(this, args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/hasura/attributes/attributes -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Source_Event_Queue, [
        {
            /**
	 *
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * Inserts data to the source event queue to be processed later.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, payload, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "source_id": 0,
                                    "collection_id": 0,
                                    "payload": {},
                                    "returning": [
                                        "id"
                                    ],
                                    "objects": []
                                };
                                args = _objectSpread({}, default_args, user_args);
                                graphql = "\n			mutation insertSourceEvent($objects: [source_event_queue_insert_input!]!) {\n				insert_source_event_queue(objects: $objects) {\n					returning {\n						".concat(args["returning"].join("\n"), "\n					}\n				}\n			}\n			");
                                payload = {
                                    "objects": [
                                        {
                                            "source_id": args["source_id"],
                                            "collection_id": args["collection_id"],
                                            "payload": args["payload"]
                                        }
                                    ]
                                };
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["objects"]) && Array.isArray(args["objects"])) {
                                    payload = {
                                        "objects": args["objects"]
                                    };
                                }
                                _ctx.next = 11;
                                return _this.mutation(graphql, payload);
                            case 11:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.remove(_this.constructor["name"]);
                                    data["response"] = response;
                                    data["results"] = response["insert_source_event_queue"]["returning"];
                                }
                                return _ctx.abrupt("return", data);
                            case 16:
                                _ctx.prev = 16;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/source/event_queue -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 20:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            16
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Source_Event_Queue;
}(_hasura_js__WEBPACK_IMPORTED_MODULE_2__.Hasura);


/***/ }),

/***/ 2943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tenants": function() { return /* binding */ Tenants; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _attributes_entity_attributes_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74883);
/* harmony import */ var _hasura_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98172);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




var _Entity_Attributes = new _attributes_entity_attributes_js__WEBPACK_IMPORTED_MODULE_2__.Entity_Attributes();
/**
 * Hasura Integration
 * @class   Tenants
 * @extends Hasura
 */ var Tenants = /*#__PURE__*/ function(Hasura1) {
    "use strict";
    _inherits(Tenants, Hasura1);
    var _super = _createSuper(Tenants);
    function Tenants() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Tenants);
        var _this;
        try {
            var default_args = {
                "environment": null,
                "context": null,
                "entity_type_id": 3428497183813392
            };
            var args = _objectSpread({}, default_args, user_args);
            _this = _super.call(this, args);
            _this.Entity_Attributes = _Entity_Attributes;
            _this.Entity_Attributes.set_args(_this.args);
            _this.Entity_Attributes["configuration"] = _this.configuration;
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/hasura/tenants/tenants -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Tenants, [
        {
            /**
	 *
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * Creates a tenant in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, payload, tenant_response, attributes, attributes_response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "payload": [],
                                    "entity_type_id": _this.args["entity_type_id"],
                                    "returning": [
                                        "id",
                                        "name"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["payload"])) {
                                    _ctx.next = 8;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 8:
                                if (Array.isArray(args["payload"])) {
                                    _ctx.next = 10;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 10:
                                payload = [];
                                args["payload"].map(function(item) {
                                    payload.push(_objectSpread({}, item, {
                                        "entity_type_id": args["entity_type_id"]
                                    }));
                                });
                                payload.map(function(item) {
                                    delete item["attributes"];
                                });
                                graphql = "\n			mutation createTenant($objects: [tenants_insert_input!]!) {\n				insert_tenants(objects: $objects) {\n					returning {\n						".concat(args["returning"].join("\n"), "\n					}\n				}\n			}\n			");
                                _ctx.next = 16;
                                return _this.mutation(graphql, payload);
                            case 16:
                                tenant_response = _ctx.sent;
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(tenant_response)) {
                                    _ctx.next = 29;
                                    break;
                                }
                                _this.cache.remove(_this.constructor["name"]);
                                data["response"]["entity"] = tenant_response;
                                attributes = [];
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(tenant_response["insert_tenants"]["returning"])) {
                                    data["results"]["entity"] = tenant_response["insert_tenants"]["returning"];
                                    tenant_response["insert_tenants"]["returning"].map(function(tenant) {
                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(tenant["id"]) && !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(tenant["name"])) {
                                            args["payload"].map(function(item) {
                                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["name"])) {
                                                    if (tenant["name"] === item["name"]) {
                                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["attributes"])) {
                                                            item["attributes"].map(function(attribute) {
                                                                attributes.push(_objectSpread({}, attribute, {
                                                                    "entity_id": tenant["id"]
                                                                }));
                                                            });
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(attributes)) {
                                    _ctx.next = 29;
                                    break;
                                }
                                delete args["returning"];
                                _ctx.next = 26;
                                return _this.Entity_Attributes.create(_objectSpread({}, args, {
                                    payload: attributes
                                }));
                            case 26:
                                attributes_response = _ctx.sent;
                                data["response"]["attributes"] = attributes_response["response"];
                                data["results"]["attributes"] = attributes_response["results"];
                            case 29:
                                return _ctx.abrupt("return", data);
                            case 32:
                                _ctx.prev = 32;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/tenants/tenants -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 36:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            32
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * Retrieves a specific tenant from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, email_address, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "id": "",
                                    "entity_type_id": "",
                                    "returning": [
                                        "id",
                                        "tenant_id",
                                        "name",
                                        "region",
                                        "identity_pool_id",
                                        "app_client_id",
                                        "tenant_prefix"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 22;
                                break;
                            case 12:
                                where = 'id: { _eq: "'.concat(args["id"], '" }');
                                email_address = "";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["email_address"])) {
                                    email_address = 'email: { _eq: "'.concat(args["email_address"], '" }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(email_address)) {
                                    where = "";
                                }
                                graphql = "\n				query getTenant {\n					tenants (\n						where: { ".concat(where, " }\n					) {\n						").concat(args["returning"].join("\n"), "\n					}\n				}\n				");
                                _ctx.next = 19;
                                return _this.query(graphql);
                            case 19:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"] = response;
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["tenants"])) {
                                        data["results"] = response["tenants"][0];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                            case 22:
                                return _ctx.abrupt("return", data);
                            case 25:
                                _ctx.prev = 25;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/tenants/tenants -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 29:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            25
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * Retrieves multiple tenants from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{total: number, response: *[], results: *[]}>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: [],
                                    total: 0,
                                    response: []
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "column": "name",
                                    "order": "asc",
                                    "page": 1,
                                    "per_page": 20,
                                    "includes": "",
                                    "excludes": "",
                                    "entity_id": "",
                                    "entity_type_id": "",
                                    "returning": [
                                        "id",
                                        "role_id",
                                        "cognito_pool_id",
                                        "cognito_tenant_id",
                                        "source_id",
                                        "source_ref",
                                        "email_address",
                                        "first_name",
                                        "last_name",
                                        "created_at",
                                        "updated_at"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                args["offset"] = (args["page"] - 1) * args["per_page"];
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["entity_type_id"])) {
                                    _ctx.next = 9;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 9:
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 15;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 29;
                                break;
                            case 15:
                                where = 'entity_type_id: { _eq: "'.concat(_this.args["entity_type_id"], '" }');
                                where += "archived_at: {_is_null: true}";
                                where += "_and: [";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["entity_id"])) {
                                    where += '{ entity_id: { _eq: "'.concat(args["entity_id"], '" } }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["includes"])) {
                                    where += '{ name: { _ilike: "%'.concat(args["includes"], '%" } }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["excludes"])) {
                                    where += '{ name: { _nilike: "%'.concat(args["excludes"], '%" } }');
                                }
                                where += "]";
                                graphql = "\n				query listTenants {\n					tenants (\n						where: { ".concat(where, " }\n						order_by: { ").concat(args["column"], ": ").concat(args["order"], " }\n						offset: ").concat(args["offset"], "\n						limit: ").concat(args["per_page"], "\n					) {\n						").concat(args["returning"].join("\n"), "\n						attributes {\n							attribute_id\n							attribute_name\n							attribute_code\n							attribute_value\n							field_type_id\n							field_type\n							entity_attribute_id\n						}\n						tenant {\n							id\n							tenant_id\n							name\n						}\n					}\n					tenants_aggregate (\n						where: { ").concat(where, " }\n					) {\n						aggregate  {\n							total: count\n						}\n					}\n				}\n		        ");
                                _ctx.next = 25;
                                return _this.query(graphql);
                            case 25:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"].push(response);
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["tenants"])) {
                                        data["results"] = response["tenants"];
                                    }
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["tenants_aggregate"]["aggregate"]["total"])) {
                                        data["total"] = response["tenants_aggregate"]["aggregate"]["total"];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                                if (data["total"] > 0) {
                                    data["results"].map(function(result) {
                                        _this.cache.set(_this.constructor["name"], JSON.stringify({
                                            "id": result["id"],
                                            "entity_type_id": args["entity_type_id"]
                                        }), {
                                            response: "cached",
                                            results: result
                                        });
                                    });
                                }
                            case 29:
                                return _ctx.abrupt("return", data);
                            case 32:
                                _ctx.prev = 32;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/tenants/tenants -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 36:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            32
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * Updates a tenant in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, data, default_args, payload, attributes, requests, batches, entity_responses, organization_attributes;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": [],
                                    "returning": [
                                        "id",
                                        "name",
                                        "created_at",
                                        "updated_at"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["payload"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 7:
                                if (Array.isArray(args["payload"])) {
                                    _ctx.next = 9;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 9:
                                payload = [];
                                attributes = [];
                                args["payload"].map(function(item) {
                                    payload.push(_objectSpread({}, item, {
                                        "entity_type_id": args["entity_type_id"]
                                    }));
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["attributes"])) {
                                        item["attributes"].map(function(attribute) {
                                            attributes.push(_objectSpread({}, attribute, {
                                                entity_id: item["id"]
                                            }));
                                        });
                                    }
                                });
                                payload.map(function(item) {
                                    delete item["attributes"];
                                });
                                requests = {};
                                payload.map(function(item) {
                                    if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["id"])) {
                                        return false;
                                    }
                                    var fields = [];
                                    Object.keys(item).map(function(key) {
                                        if (key !== "id") {
                                            fields.push("".concat(key, ': "').concat(item[key], '"'));
                                        }
                                    });
                                    var graphql = '\n				mutation updateTenants {\n					update_tenants(\n						where: { \n							id: { _eq: "'.concat(item["id"], '" } \n						}, \n						_set: { ').concat(fields.join(), " }\n					) {\n						affected_rows\n						returning {\n							").concat(args["returning"].join("\n"), "\n						}\n					}\n				}\n				");
                                    requests[item["id"]] = {
                                        "callback": _this.mutation.bind(_this),
                                        "args": graphql
                                    };
                                });
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(requests)) {
                                    _ctx.next = 17;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 17:
                                data["response"]["entity"] = [];
                                data["results"]["entity"] = [];
                                _ctx.next = 21;
                                return (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.process_in_batches)(requests, 5);
                            case 21:
                                batches = _ctx.sent;
                                entity_responses = Object.values(batches);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(entity_responses)) {
                                    _this.cache.remove(_this.constructor["name"]);
                                    entity_responses.map(function(entity_response) {
                                        var entity = entity_response[Object.keys(entity_response)[0]];
                                        data["response"]["entity"].push(entity);
                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)((entity["update_tenants"] || {})["returning"])) {
                                            data["results"]["entity"] = data["results"]["entity"].concat(entity["update_tenants"]["returning"]);
                                        }
                                    });
                                }
                                delete args["returning"];
                                _ctx.next = 27;
                                return _this.Entity_Attributes.update(_objectSpread({}, args, {
                                    payload: attributes
                                }));
                            case 27:
                                organization_attributes = _ctx.sent;
                                data["response"]["attributes"] = organization_attributes["response"];
                                data["results"]["attributes"] = organization_attributes["results"];
                                return _ctx.abrupt("return", data);
                            case 33:
                                _ctx.prev = 33;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/tenants/tenants -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 37:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            33
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Tenants;
}(_hasura_js__WEBPACK_IMPORTED_MODULE_3__.Hasura);


/***/ }),

/***/ 10162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tickets": function() { return /* binding */ Tickets; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _attributes_entity_attributes_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74883);
/* harmony import */ var _hasura_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98172);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




var _Entity_Attributes = new _attributes_entity_attributes_js__WEBPACK_IMPORTED_MODULE_2__.Entity_Attributes();
/**
 * Hasura Integration
 * @class   Tickets
 * @extends Hasura
 */ var Tickets = /*#__PURE__*/ function(Hasura1) {
    "use strict";
    _inherits(Tickets, Hasura1);
    var _super = _createSuper(Tickets);
    function Tickets() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Tickets);
        var _this;
        try {
            var default_args = {
                "environment": null,
                "context": null,
                "entity_type_id": 3428497181716237
            };
            var args = _objectSpread({}, default_args, user_args);
            _this = _super.call(this, args);
            _this.Entity_Attributes = _Entity_Attributes;
            _this.Entity_Attributes.set_args(_this.args);
            _this.Entity_Attributes["configuration"] = _this.configuration;
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/hasura/tickets/tickets -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Tickets, [
        {
            /**
	 *
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * Creates a ticket in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, payload, ticket_response, attributes, attributes_response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "payload": [],
                                    "entity_type_id": _this.args["entity_type_id"],
                                    "returning": [
                                        "id",
                                        "name"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["payload"])) {
                                    _ctx.next = 8;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 8:
                                if (Array.isArray(args["payload"])) {
                                    _ctx.next = 10;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 10:
                                payload = [];
                                args["payload"].map(function(item) {
                                    payload.push(_objectSpread({}, item, {
                                        "entity_type_id": args["entity_type_id"]
                                    }));
                                });
                                payload.map(function(item) {
                                    delete item["attributes"];
                                });
                                graphql = "\n			mutation createTicket($objects: [tickets_insert_input!]!) {\n				insert_tickets(objects: $objects) {\n					returning {\n						".concat(args["returning"].join("\n"), "\n					}\n				}\n			}\n			");
                                _ctx.next = 16;
                                return _this.mutation(graphql, payload);
                            case 16:
                                ticket_response = _ctx.sent;
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(ticket_response)) {
                                    _ctx.next = 29;
                                    break;
                                }
                                _this.cache.remove(_this.constructor["name"]);
                                data["response"]["entity"] = ticket_response;
                                attributes = [];
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(ticket_response["insert_tickets"]["returning"])) {
                                    data["results"]["entity"] = ticket_response["insert_tickets"]["returning"];
                                    ticket_response["insert_tickets"]["returning"].map(function(ticket) {
                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(ticket["id"]) && !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(ticket["name"])) {
                                            args["payload"].map(function(item) {
                                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["name"])) {
                                                    if (ticket["name"] === item["name"]) {
                                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["attributes"])) {
                                                            item["attributes"].map(function(attribute) {
                                                                attributes.push(_objectSpread({}, attribute, {
                                                                    "entity_id": ticket["id"]
                                                                }));
                                                            });
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(attributes)) {
                                    _ctx.next = 29;
                                    break;
                                }
                                delete args["returning"];
                                _ctx.next = 26;
                                return _this.Entity_Attributes.create(_objectSpread({}, args, {
                                    payload: attributes
                                }));
                            case 26:
                                attributes_response = _ctx.sent;
                                data["response"]["attributes"] = attributes_response["response"];
                                data["results"]["attributes"] = attributes_response["results"];
                            case 29:
                                return _ctx.abrupt("return", data);
                            case 32:
                                _ctx.prev = 32;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/tickets/tickets -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 36:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            32
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * Retrieves a specific ticket from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, source_id, source_ref, source, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "id": "",
                                    "entity_type_id": "",
                                    "returning": [
                                        "id",
                                        "entity_id",
                                        "subject",
                                        "details",
                                        "active",
                                        "status",
                                        "priority",
                                        "due_date",
                                        "completed_at",
                                        "created_at",
                                        "updated_at",
                                        "source_id",
                                        "source_ref"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 26;
                                break;
                            case 12:
                                where = 'id: { _eq: "'.concat(args["id"], '" }');
                                where += "archived_at: {_is_null: true}";
                                source_id = "";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["source_id"])) {
                                    source_id = 'source_id: { _eq: "'.concat(args["source_id"], '" }');
                                }
                                source_ref = "";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["source_ref"])) {
                                    source_ref = 'source_ref: { _eq: "'.concat(args["source_ref"], '" }');
                                }
                                source = "".concat(source_id).concat(source_ref);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(source)) {
                                    where = source;
                                }
                                graphql = "\n				query getTicket {\n					tickets (\n						where: { ".concat(where, " }\n					) {\n						").concat(args["returning"].join("\n"), "\n						attributes {\n							attribute_id\n							attribute_name\n							attribute_code\n							attribute_value\n							field_type_id\n							field_type\n							entity_attribute_id\n						}\n						tenant {\n							id\n							tenant_id\n							name\n						}\n					}\n				}\n				");
                                _ctx.next = 23;
                                return _this.query(graphql);
                            case 23:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"] = response;
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["tickets"])) {
                                        data["results"] = response["tickets"][0];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                            case 26:
                                return _ctx.abrupt("return", data);
                            case 29:
                                _ctx.prev = 29;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/tickets/tickets -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 33:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            29
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * Retrieves multiple tickets from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{total: number, response: *[], results: *[]}>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: [],
                                    total: 0,
                                    response: []
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "column": "name",
                                    "order": "asc",
                                    "page": 1,
                                    "per_page": 20,
                                    "includes": "",
                                    "excludes": "",
                                    "entity_id": "",
                                    "entity_type_id": "",
                                    "returning": [
                                        "id",
                                        "entity_id",
                                        "subject",
                                        "details",
                                        "active",
                                        "status",
                                        "priority",
                                        "due_date",
                                        "completed_at",
                                        "created_at",
                                        "updated_at",
                                        "source_id",
                                        "source_ref"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                args["offset"] = (args["page"] - 1) * args["per_page"];
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 13;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 27;
                                break;
                            case 13:
                                where = 'entity_type_id: { _eq: "'.concat(_this.args["entity_type_id"], '" }');
                                where += "archived_at: {_is_null: true}";
                                where += "_and: [";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["entity_id"])) {
                                    where += '{ entity_id: { _eq: "'.concat(args["entity_id"], '" } }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["includes"])) {
                                    where += '{ name: { _ilike: "%'.concat(args["includes"], '%" } }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["excludes"])) {
                                    where += '{ name: { _nilike: "%'.concat(args["excludes"], '%" } }');
                                }
                                where += "]";
                                graphql = "\n				query listTickets {\n					tickets (\n						where: { ".concat(where, " }\n						order_by: { ").concat(args["column"], ": ").concat(args["order"], " }\n						offset: ").concat(args["offset"], "\n						limit: ").concat(args["per_page"], "\n					) {\n						").concat(args["returning"].join("\n"), "\n						attributes {\n							attribute_id\n							attribute_name\n							attribute_code\n							attribute_value\n							field_type_id\n							field_type\n							entity_attribute_id\n						}\n						tenant {\n							id\n							tenant_id\n							name\n						}\n					}\n					tickets_aggregate (\n						where: { ").concat(where, " }\n					) {\n						aggregate  {\n							total: count\n						}\n					}\n				}\n		        ");
                                _ctx.next = 23;
                                return _this.query(graphql);
                            case 23:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"].push(response);
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["tickets"])) {
                                        data["results"] = response["tickets"];
                                    }
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["tickets_aggregate"]["aggregate"]["total"])) {
                                        data["total"] = response["tickets_aggregate"]["aggregate"]["total"];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                                if (data["total"] > 0) {
                                    data["results"].map(function(result) {
                                        _this.cache.set(_this.constructor["name"], JSON.stringify({
                                            "id": result["id"],
                                            "entity_type_id": args["entity_type_id"]
                                        }), {
                                            response: "cached",
                                            results: result
                                        });
                                    });
                                }
                            case 27:
                                return _ctx.abrupt("return", data);
                            case 30:
                                _ctx.prev = 30;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/tickets/tickets -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 34:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            30
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * Updates a ticket in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, data, default_args, payload, attributes, requests, batches, entity_responses, organization_attributes;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": [],
                                    "returning": [
                                        "id",
                                        "name",
                                        "created_at",
                                        "updated_at"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["payload"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 7:
                                if (Array.isArray(args["payload"])) {
                                    _ctx.next = 9;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 9:
                                payload = [];
                                attributes = [];
                                args["payload"].map(function(item) {
                                    payload.push(_objectSpread({}, item, {
                                        "entity_type_id": args["entity_type_id"]
                                    }));
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["attributes"])) {
                                        item["attributes"].map(function(attribute) {
                                            attributes.push(_objectSpread({}, attribute, {
                                                entity_id: item["id"]
                                            }));
                                        });
                                    }
                                });
                                payload.map(function(item) {
                                    delete item["attributes"];
                                });
                                requests = {};
                                payload.map(function(item) {
                                    if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["id"])) {
                                        return false;
                                    }
                                    var fields = [];
                                    Object.keys(item).map(function(key) {
                                        if (key !== "id") {
                                            fields.push("".concat(key, ': "').concat(item[key], '"'));
                                        }
                                    });
                                    var graphql = '\n				mutation updateTickets {\n					update_tickets(\n						where: { \n							id: { _eq: "'.concat(item["id"], '" } \n						}, \n						_set: { ').concat(fields.join(), " }\n					) {\n						affected_rows\n						returning {\n							").concat(args["returning"].join("\n"), "\n						}\n					}\n				}\n				");
                                    requests[item["id"]] = {
                                        "callback": _this.mutation.bind(_this),
                                        "args": graphql
                                    };
                                });
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(requests)) {
                                    _ctx.next = 17;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 17:
                                data["response"]["entity"] = [];
                                data["results"]["entity"] = [];
                                _ctx.next = 21;
                                return (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.process_in_batches)(requests, 5);
                            case 21:
                                batches = _ctx.sent;
                                entity_responses = Object.values(batches);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(entity_responses)) {
                                    _this.cache.remove(_this.constructor["name"]);
                                    entity_responses.map(function(entity_response) {
                                        var entity = entity_response[Object.keys(entity_response)[0]];
                                        data["response"]["entity"].push(entity);
                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)((entity["update_tickets"] || {})["returning"])) {
                                            data["results"]["entity"] = data["results"]["entity"].concat(entity["update_tickets"]["returning"]);
                                        }
                                    });
                                }
                                delete args["returning"];
                                _ctx.next = 27;
                                return _this.Entity_Attributes.update(_objectSpread({}, args, {
                                    payload: attributes
                                }));
                            case 27:
                                organization_attributes = _ctx.sent;
                                data["response"]["attributes"] = organization_attributes["response"];
                                data["results"]["attributes"] = organization_attributes["results"];
                                return _ctx.abrupt("return", data);
                            case 33:
                                _ctx.prev = 33;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/tickets/tickets -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 37:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            33
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Tickets;
}(_hasura_js__WEBPACK_IMPORTED_MODULE_3__.Hasura);


/***/ }),

/***/ 91107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Users": function() { return /* binding */ Users; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _attributes_entity_attributes_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74883);
/* harmony import */ var _hasura_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(98172);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




var _Entity_Attributes = new _attributes_entity_attributes_js__WEBPACK_IMPORTED_MODULE_2__.Entity_Attributes();
/**
 * Hasura Integration
 * @class   Users
 * @extends Hasura
 */ var Users = /*#__PURE__*/ function(Hasura1) {
    "use strict";
    _inherits(Users, Hasura1);
    var _super = _createSuper(Users);
    function Users() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Users);
        var _this;
        try {
            var default_args = {
                "environment": null,
                "context": null,
                "entity_type_id": 3428497183813391
            };
            var args = _objectSpread({}, default_args, user_args);
            _this = _super.call(this, args);
            _this.Entity_Attributes = _Entity_Attributes;
            _this.Entity_Attributes.set_args(_this.args);
            _this.Entity_Attributes["configuration"] = _this.configuration;
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/hasura/users/users -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Users, [
        {
            /**
	 *
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * Creates a user in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, payload, user_response, attributes, attributes_response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "payload": [],
                                    "entity_type_id": _this.args["entity_type_id"],
                                    "returning": [
                                        "id",
                                        "name"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["payload"])) {
                                    _ctx.next = 8;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 8:
                                if (Array.isArray(args["payload"])) {
                                    _ctx.next = 10;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 10:
                                payload = [];
                                args["payload"].map(function(item) {
                                    payload.push(_objectSpread({}, item, {
                                        "entity_type_id": args["entity_type_id"]
                                    }));
                                });
                                payload.map(function(item) {
                                    delete item["attributes"];
                                });
                                graphql = "\n			mutation createUser($objects: [users_insert_input!]!) {\n				insert_users(objects: $objects) {\n					returning {\n						".concat(args["returning"].join("\n"), "\n					}\n				}\n			}\n			");
                                _ctx.next = 16;
                                return _this.mutation(graphql, payload);
                            case 16:
                                user_response = _ctx.sent;
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(user_response)) {
                                    _ctx.next = 29;
                                    break;
                                }
                                _this.cache.remove(_this.constructor["name"]);
                                data["response"]["entity"] = user_response;
                                attributes = [];
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(user_response["insert_users"]["returning"])) {
                                    data["results"]["entity"] = user_response["insert_users"]["returning"];
                                    user_response["insert_users"]["returning"].map(function(user) {
                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(user["id"]) && !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(user["name"])) {
                                            args["payload"].map(function(item) {
                                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["name"])) {
                                                    if (user["name"] === item["name"]) {
                                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["attributes"])) {
                                                            item["attributes"].map(function(attribute) {
                                                                attributes.push(_objectSpread({}, attribute, {
                                                                    "entity_id": user["id"]
                                                                }));
                                                            });
                                                        }
                                                    }
                                                }
                                            });
                                        }
                                    });
                                }
                                if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(attributes)) {
                                    _ctx.next = 29;
                                    break;
                                }
                                delete args["returning"];
                                _ctx.next = 26;
                                return _this.Entity_Attributes.create(_objectSpread({}, args, {
                                    payload: attributes
                                }));
                            case 26:
                                attributes_response = _ctx.sent;
                                data["response"]["attributes"] = attributes_response["response"];
                                data["results"]["attributes"] = attributes_response["results"];
                            case 29:
                                return _ctx.abrupt("return", data);
                            case 32:
                                _ctx.prev = 32;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/users/users -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 36:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            32
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * Retrieves a specific user from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "id": "",
                                    "entity_type_id": _this.args["entity_type_id"],
                                    "returning": [
                                        "id",
                                        "first_name",
                                        "last_name",
                                        "email",
                                        "cognito_user_id",
                                        "source_ref",
                                        "created_at",
                                        "updated_at",
                                        "active"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 25;
                                break;
                            case 12:
                                where = "";
                                where += "archived_at: {_is_null: true}";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    where += 'id: { _eq: "'.concat(args["id"], '" }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["cognito_user_id"])) {
                                    where += 'cognito_user_id: { _eq: "'.concat(args["cognito_user_id"], '" }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["source_id"])) {
                                    where += 'source_id: { _eq: "'.concat(args["source_id"], '" }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["source_ref"])) {
                                    where += 'source_ref: { _eq: "'.concat(args["source_ref"], '" }');
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["email"])) {
                                    where += 'email: { _eq: "'.concat(args["email"], '" }');
                                }
                                graphql = "\n				query getUser {\n					users (\n						where: { ".concat(where, " }\n					) {\n						").concat(args["returning"].join("\n"), '\n						tenant {\n							id\n							name\n							tenant_id\n						}\n						attributes {\n							attribute_id\n							attribute_name\n							attribute_code\n							attribute_value\n							field_type_id\n							field_type\n							entity_attribute_id\n						},\n						user_entities(where: {entity: {entity_type: {code: {_eq: "').concat(String(_this.args["application"]).toUpperCase(), 'S"}}}}) {\n							id\n							entity {\n								id\n								name\n							}\n						}\n					}\n				}\n				');
                                _ctx.next = 22;
                                return _this.query(graphql);
                            case 22:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"] = response;
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["users"])) {
                                        data["results"] = response["users"][0];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                            case 25:
                                return _ctx.abrupt("return", data);
                            case 28:
                                _ctx.prev = 28;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/users/users -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 32:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            28
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * Retrieves multiple users from the database.
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<{total: number, response: *[], results: *[]}>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, graphql, data, default_args, cache, where, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                graphql = "";
                                data = {
                                    results: [],
                                    total: 0,
                                    response: []
                                };
                                _ctx.prev = 3;
                                default_args = {
                                    "column": "email",
                                    "order": "asc",
                                    "page": 1,
                                    "per_page": 20,
                                    "includes": "",
                                    "excludes": "",
                                    "entity_id": "",
                                    "returning": [
                                        "id",
                                        "first_name",
                                        "last_name",
                                        "email",
                                        "cognito_user_id",
                                        "source_ref",
                                        "created_at",
                                        "updated_at",
                                        "active"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                args["offset"] = (args["page"] - 1) * args["per_page"];
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 13;
                                    break;
                                }
                                {
                                    data = cache;
                                }
                                _ctx.next = 27;
                                break;
                            case 13:
                                where = "";
                                where += "archived_at: {_is_null: true}";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["entity_id"])) {
                                    where += 'user_entities: {entity_id: {_eq: "'.concat(args["entity_id"], '"}}');
                                }
                                where += "_and: [";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["includes"])) {
                                    where += "{_or: [";
                                    where += '{ first_name: { _ilike: "%'.concat(args["includes"], '%" } }');
                                    where += '{ last_name: { _ilike: "%'.concat(args["includes"], '%" } }');
                                    where += '{ email: { _ilike: "%'.concat(args["includes"], '%" } }');
                                    where += "]}";
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["excludes"])) {
                                    where += "{_and: [";
                                    where += '{ first_name: { _nilike: "%'.concat(args["excludes"], '%" } }');
                                    where += '{ last_name: { _nilike: "%'.concat(args["excludes"], '%" } }');
                                    where += '{ email: { _nilike: "%'.concat(args["excludes"], '%" } }');
                                    where += "]}";
                                }
                                where += "]";
                                graphql = "\n				query listUsers {\n					users (\n						where: { ".concat(where, " }\n						order_by: { ").concat(args["column"], ": ").concat(args["order"], " }\n						offset: ").concat(args["offset"], "\n						limit: ").concat(args["per_page"], "\n					) {\n						").concat(args["returning"].join("\n"), "\n						tenant {\n							id\n							name\n							tenant_id\n						}\n						attributes {\n							attribute_id\n							attribute_name\n							attribute_code\n							attribute_value\n							field_type_id\n							field_type\n							entity_attribute_id\n						}\n					}\n					users_aggregate (\n						where: { ").concat(where, " }\n					) {\n						aggregate  {\n							total: count\n						}\n					}\n				}\n		        ");
                                _ctx.next = 23;
                                return _this.query(graphql);
                            case 23:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    data["response"].push(response);
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["users"])) {
                                        data["results"] = response["users"];
                                    }
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response["users_aggregate"]["aggregate"]["total"])) {
                                        data["total"] = response["users_aggregate"]["aggregate"]["total"];
                                    }
                                }
                                _this.cache.set(_this.constructor["name"], JSON.stringify(args), data);
                                if (data["total"] > 0) {
                                    data["results"].map(function(result) {
                                        _this.cache.set(_this.constructor["name"], JSON.stringify({
                                            "id": result["id"],
                                            "entity_type_id": args["entity_type_id"]
                                        }), {
                                            response: "cached",
                                            results: result
                                        });
                                    });
                                }
                            case 27:
                                return _ctx.abrupt("return", data);
                            case 30:
                                _ctx.prev = 30;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/users/users -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        graphql: graphql,
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 34:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            30
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * Updates a user in the database.
	 *
	 * @param user_args
	 * @returns {Promise<{response: {}, results: {}}>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, data, default_args, payload, attributes, requests, batches, entity_responses, organization_attributes;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                data = {
                                    results: {},
                                    response: {}
                                };
                                _ctx.prev = 2;
                                default_args = {
                                    "id": "",
                                    "entity_type_id": _this.args["entity_type_id"],
                                    "payload": [],
                                    "returning": [
                                        "id",
                                        "first_name",
                                        "last_name",
                                        "email",
                                        "created_at",
                                        "updated_at"
                                    ]
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["payload"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 7:
                                if (Array.isArray(args["payload"])) {
                                    _ctx.next = 9;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 9:
                                payload = [];
                                attributes = [];
                                args["payload"].map(function(item) {
                                    payload.push(_objectSpread({}, item, {
                                        "entity_type_id": args["entity_type_id"]
                                    }));
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["attributes"])) {
                                        item["attributes"].map(function(attribute) {
                                            attributes.push(_objectSpread({}, attribute, {
                                                entity_id: item["id"]
                                            }));
                                        });
                                    }
                                });
                                payload.map(function(item) {
                                    delete item["attributes"];
                                });
                                requests = {};
                                payload.map(function(item) {
                                    if ((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(item["id"])) {
                                        return false;
                                    }
                                    var fields = [];
                                    Object.keys(item).map(function(key) {
                                        if (key !== "id") {
                                            fields.push("".concat(key, ': "').concat(item[key], '"'));
                                        }
                                    });
                                    var graphql = '\n				mutation updateUsers {\n					update_users(\n						where: { \n							id: { _eq: "'.concat(item["id"], '" } \n						}, \n						_set: { ').concat(fields.join(), " }\n					) {\n						affected_rows\n						returning {\n							").concat(args["returning"].join("\n"), "\n						}\n					}\n				}\n				");
                                    requests[item["id"]] = {
                                        "callback": _this.mutation.bind(_this),
                                        "args": graphql
                                    };
                                });
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(requests)) {
                                    _ctx.next = 17;
                                    break;
                                }
                                return _ctx.abrupt("return", data);
                            case 17:
                                data["response"]["entity"] = [];
                                data["results"]["entity"] = [];
                                _ctx.next = 21;
                                return (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.process_in_batches)(requests, 5);
                            case 21:
                                batches = _ctx.sent;
                                entity_responses = Object.values(batches);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(entity_responses)) {
                                    _this.cache.remove(_this.constructor["name"]);
                                    entity_responses.map(function(entity_response) {
                                        var entity = entity_response[Object.keys(entity_response)[0]];
                                        data["response"]["entity"].push(entity);
                                        if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)((entity["update_users"] || {})["returning"])) {
                                            data["results"]["entity"] = data["results"]["entity"].concat(entity["update_users"]["returning"]);
                                        }
                                    });
                                }
                                delete args["returning"];
                                _ctx.next = 27;
                                return _this.Entity_Attributes.update(_objectSpread({}, args, {
                                    payload: attributes
                                }));
                            case 27:
                                organization_attributes = _ctx.sent;
                                data["response"]["attributes"] = organization_attributes["response"];
                                data["results"]["attributes"] = organization_attributes["results"];
                                return _ctx.abrupt("return", data);
                            case 33:
                                _ctx.prev = 33;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/users/users -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "data": data
                                    });
                                }
                                throw _ctx.t0;
                            case 37:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            33
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Users;
}(_hasura_js__WEBPACK_IMPORTED_MODULE_3__.Hasura);


/***/ }),

/***/ 35681:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Authentication_Webhook": function() { return /* binding */ Authentication_Webhook; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _webhooks_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78485);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93909);
/* harmony import */ var _print_engine_frontegg_frontegg_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22597);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




/**
 * Hasura Integration
 * @class   Authentication_Webhook
 * @extends Webhooks
 */ var Authentication_Webhook = /*#__PURE__*/ function(Webhooks1) {
    "use strict";
    _inherits(Authentication_Webhook, Webhooks1);
    var _super = _createSuper(Authentication_Webhook);
    function Authentication_Webhook() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Authentication_Webhook);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/hasura/webhooks/authentication_webhook -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Authentication_Webhook, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.process = this.process.bind(this);
            }
        },
        {
            key: "process",
            value: /**
	 * Processes the webhook.
	 *
	 * @param user_args
	 * @returns {Promise<{'x-hasura-role': string, 'x-hasura-pim-host': (string|string), 'x-hasura-tenant-id': (string|string), 'x-hasura-user-id':
	 *     (string|string)}>}
	 */ function process() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response, token, frontegg, user_payload;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {};
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                console.log("@imprint-engine/packages/hasura/webhooks/authentication_webhook -> process():");
                                token = args["headers"]["authorization"].split(" ").pop();
                                frontegg = new _print_engine_frontegg_frontegg_js__WEBPACK_IMPORTED_MODULE_3__.Frontegg(args);
                                _ctx.next = 9;
                                return frontegg.verify_token(token);
                            case 9:
                                user_payload = _ctx.sent;
                                response = {
                                    "x-hasura-user-id": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)((user_payload["metadata"] || {})["entity_id"]) ? String(user_payload["metadata"]["entity_id"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)((user_payload["userMetadata"] || {})["entity_id"]) ? String(user_payload["userMetadata"]["entity_id"]) : "",
                                    "x-hasura-role": "internal-api",
                                    "x-hasura-tenant-id": "3428513608707886",
                                    "x-hasura-pim-host": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)((args["headers"] || {})["x-pim-host"]) ? String(args["headers"]["x-pim-host"]) : ""
                                };
                                return _ctx.abrupt("return", response);
                            case 14:
                                _ctx.prev = 14;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura/webhooks/authentication_webhook -> process():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 18:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            14
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Authentication_Webhook;
}(_webhooks_js__WEBPACK_IMPORTED_MODULE_1__.Webhooks);


/***/ }),

/***/ 78485:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Webhooks": function() { return /* binding */ Webhooks; }
/* harmony export */ });
/* harmony import */ var _hasura_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98172);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/**
 * Hasura Integration
 * @class   Webhooks
 * @extends Hasura
 */ var Webhooks = /*#__PURE__*/ function(Hasura1) {
    "use strict";
    _inherits(Webhooks, Hasura1);
    var _super = _createSuper(Webhooks);
    function Webhooks() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Webhooks);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/hasura/webhooks -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Webhooks, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {}
        }
    ]);
    return Webhooks;
}(_hasura_js__WEBPACK_IMPORTED_MODULE_0__.Hasura);


/***/ }),

/***/ 33383:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Configuration": function() { return /* binding */ Configuration; },
/* harmony export */   "Netlify": function() { return /* binding */ Netlify; }
/* harmony export */ });
/* harmony import */ var _print_engine_utilities_integration_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59709);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}

/**
 * Netlify Configuration
 *
 * @type {{development: {client: {app: {url: string}, tenant: {url: string}}, swag: {app: {url: string}, tenant: {url: string}}, tenant:
 *     {app: {url: string}, api: {url: string}}}, production: {client: {app: {url: string}, tenant: {url: string}}, swag: {app: {url:
 *     string}, tenant: {url: string}}, tenant: {app: {url: string}, api: {url: string}}}, staging: {client: {app: {url: string}, tenant:
 *     {url: string}}, swag: {app: {url: string}, tenant: {url: string}}, tenant: {app: {url: string}, api: {url: string}}}, local:
 *     {client: {app: {url: string}, tenant: {url: string}}, swag: {app: {url: string}, tenant: {url: string}}, tenant: {app: {url:
 *     string}, api: {url: string}}}}}
 */ var Configuration = {
    "production": {
        "identity": {
            "api": {
                "url": "https://identity.imprintengine.io/api/rest"
            },
            "app": {
                "url": "https://identity.imprintengine.io"
            }
        },
        "tenant": {
            "api": {
                "url": "https://app.imprintengine.io/api/rest"
            },
            "app": {
                "url": "https://app.imprintengine.io"
            }
        },
        "client": {
            "api": {
                "url": "https://client.imprintengine.io/api/rest"
            },
            "app": {
                "url": "https://client.imprintengine.io"
            }
        },
        "swag": {
            "api": {
                "url": "https://swag.imprintengine.io/api/rest"
            },
            "app": {
                "url": "https://swag.imprintengine.io"
            }
        }
    },
    "staging": {
        "identity": {
            "api": {
                "url": "https://identity.imprintenginestage.io/api/rest"
            },
            "app": {
                "url": "https://identity.imprintenginestage.io"
            }
        },
        "tenant": {
            "api": {
                "url": "https://app.imprintenginestage.io/api/rest"
            },
            "app": {
                "url": "https://app.imprintenginestage.io"
            }
        },
        "client": {
            "api": {
                "url": "https://client.imprintenginestage.io/api/rest"
            },
            "app": {
                "url": "https://client.imprintenginestage.io"
            }
        },
        "swag": {
            "api": {
                "url": "https://swag.imprintenginestage.io/api/rest"
            },
            "app": {
                "url": "https://swag.imprintenginestage.io"
            }
        }
    },
    "development": {
        "identity": {
            "api": {
                "url": "https://identity.imprintenginedev.io/api/rest"
            },
            "app": {
                "url": "https://identity.imprintenginedev.io"
            }
        },
        "tenant": {
            "api": {
                "url": "https://app.imprintenginedev.io/api/rest"
            },
            "app": {
                "url": "https://app.imprintenginedev.io"
            }
        },
        "client": {
            "api": {
                "url": "https://client.imprintenginedev.io/api/rest"
            },
            "app": {
                "url": "https://client.imprintenginedev.io"
            }
        },
        "swag": {
            "api": {
                "url": "https://swag.imprintenginedev.io/api/rest"
            },
            "app": {
                "url": "https://swag.imprintenginedev.io"
            }
        }
    },
    "local": {
        "identity": {
            "api": {
                "url": "http://identity.imprintengine.pim:8888/api/rest"
            },
            "app": {
                "url": "http://identity.imprintengine.pim:8888"
            }
        },
        "tenant": {
            "api": {
                "url": "http://app.imprintengine.pim:8888/api/rest"
            },
            "app": {
                "url": "http://app.imprintengine.pim:8888"
            }
        },
        "client": {
            "api": {
                "url": "http://client.imprintengine.pim:8888/api/rest"
            },
            "app": {
                "url": "http://client.imprintengine.pim:8888"
            }
        },
        "swag": {
            "api": {
                "url": "http://swag.imprintengine.pim:8888/api/rest"
            },
            "app": {
                "url": "http://swag.imprintengine.pim:8888"
            }
        }
    }
};
/**
 * Netlify Integration
 * @class   Netlify
 * @extends Integration
 */ var Netlify = /*#__PURE__*/ function(Integration1) {
    "use strict";
    _inherits(Netlify, Integration1);
    var _super = _createSuper(Netlify);
    function Netlify() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Netlify);
        var _this;
        var default_args = {
            "environment": null,
            "application": "tenant",
            "context": null,
            "scope": null
        };
        var args = _objectSpread({}, default_args, user_args);
        _this = _super.call(this, args);
        _this.args = _objectSpread({}, args, {
            "name": "Netlify",
            "class_name": _this.constructor["name"],
            "reference_name": "netlify",
            "description": "Netlify is a hosting service for the programmable web. It understands your documents and provides an API to handle atomic deploys of websites, manage form submissions, inject JavaScript snippets, and much more. This is a REST-style API that uses JSON for serialization and OAuth 2 for authentication.",
            "documentation_url": "https://docs.netlify.com/api/get-started/"
        });
        try {
            _this.set_bindings();
            _this.set_configuration(Configuration);
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/netlify -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _this;
    }
    _createClass(Netlify, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {}
        }
    ]);
    return Netlify;
}(_print_engine_utilities_integration_js__WEBPACK_IMPORTED_MODULE_0__.Integration);


/***/ }),

/***/ 74806:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cache": function() { return /* binding */ Cache; },
/* harmony export */   "_Cache": function() { return /* binding */ _Cache; }
/* harmony export */ });
/* harmony import */ var _utilities_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93909);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}

/**
 *
 */ var Cache = /*#__PURE__*/ function() {
    "use strict";
    function Cache() {
        _classCallCheck(this, Cache);
        this.set_bindings();
        this.cache = {};
    }
    _createClass(Cache, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.get = this.get.bind(this);
                this.set = this.set.bind(this);
                this.get_index = this.get_index.bind(this);
            }
        },
        {
            /**
	 * Retrieves cached objects.
	 *
	 * @param type
	 * @param key
	 * @returns {boolean|*}
	 */ key: "get",
            value: function get() {
                var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
                if ((0,_utilities_js__WEBPACK_IMPORTED_MODULE_0__.is_json)(key)) {
                    key = JSON.stringify((0,_utilities_js__WEBPACK_IMPORTED_MODULE_0__.object_filter)(JSON.parse(key)));
                }
                if ((0,_utilities_js__WEBPACK_IMPORTED_MODULE_0__.is_empty)(type) || (0,_utilities_js__WEBPACK_IMPORTED_MODULE_0__.is_empty)(key)) {
                    return false;
                }
                if ((0,_utilities_js__WEBPACK_IMPORTED_MODULE_0__.is_empty)((this.cache[type] || {})[key])) {
                    return false;
                }
                return this.cache[type][key];
            }
        },
        {
            /**
	 * Stores objects in the cache.
	 *
	 * @param type
	 * @param key
	 * @param value
	 * @returns {boolean}
	 */ key: "set",
            value: function set() {
                var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", value = arguments.length > 2 ? arguments[2] : void 0;
                if ((0,_utilities_js__WEBPACK_IMPORTED_MODULE_0__.is_json)(key)) {
                    key = JSON.stringify((0,_utilities_js__WEBPACK_IMPORTED_MODULE_0__.object_filter)(JSON.parse(key)));
                }
                if ((0,_utilities_js__WEBPACK_IMPORTED_MODULE_0__.is_empty)(type) || (0,_utilities_js__WEBPACK_IMPORTED_MODULE_0__.is_empty)(key) || (0,_utilities_js__WEBPACK_IMPORTED_MODULE_0__.is_empty)(value)) {
                    return false;
                }
                if ((0,_utilities_js__WEBPACK_IMPORTED_MODULE_0__.is_empty)(this.cache[type])) {
                    this.cache[type] = {};
                }
                if ((0,_utilities_js__WEBPACK_IMPORTED_MODULE_0__.is_empty)(this.cache[type][key])) {
                    this.cache[type][key] = {};
                }
                this.cache[type][key] = value;
                return true;
            }
        },
        {
            /**
	 * Removes objects or types of objects from the cache.
	 *
	 * @param type
	 * @param key
	 * @returns {boolean}
	 */ key: "remove",
            value: function remove() {
                var type = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", key = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
                if ((0,_utilities_js__WEBPACK_IMPORTED_MODULE_0__.is_empty)(type)) {
                    return false;
                }
                if (!(0,_utilities_js__WEBPACK_IMPORTED_MODULE_0__.is_empty)(key)) {
                    if ((this.cache[type] || {})[key] === undefined) {
                        return false;
                    }
                    delete this.cache[type][key];
                } else {
                    if (this.cache[type] === undefined) {
                        return false;
                    }
                    delete this.cache[type];
                }
                return true;
            }
        },
        {
            /**
	 * Removes all cached objects.
	 *
	 * @returns {boolean}
	 */ key: "flush",
            value: function flush() {
                this.cache = {};
                return true;
            }
        },
        {
            /**
	 * Retrieves a type of objects.
	 *
	 * @param type
	 * @returns {{}}
	 */ key: "get_index",
            value: function get_index() {
                var type1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
                var data = {};
                if (!(0,_utilities_js__WEBPACK_IMPORTED_MODULE_0__.is_empty)(type1) && !(0,_utilities_js__WEBPACK_IMPORTED_MODULE_0__.is_empty)(this.cache[type1])) {
                    data[type1] = Object.keys(this.cache[type1]);
                } else {
                    var _this = this;
                    Object.keys(this.cache).map(function(type) {
                        data[type] = Object.keys(_this.cache[type]);
                    });
                }
                return data;
            }
        }
    ]);
    return Cache;
}();
var _Cache = new Cache();


/***/ }),

/***/ 59709:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Integration": function() { return /* binding */ Integration; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _cache_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74806);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}



/**
 *
 */ var Integration = /*#__PURE__*/ function() {
    "use strict";
    function Integration() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Integration);
        var default_args = {
            "environment": null,
            "application": "tenant",
            "context": null,
            "scope": null,
            "name": "",
            "class_name": "",
            "reference_name": "",
            "description": "",
            "documentation_url": ""
        };
        this.args = _objectSpread({}, default_args, user_args);
        this.configuration = {};
        this.cache = _cache_js__WEBPACK_IMPORTED_MODULE_2__._Cache;
        try {
            this.set_bindings();
        } catch (error) {
            if (this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/integration -> constructor():", {
                    "error": error,
                    "args": {
                        "class": this.args,
                        "method": {
                            "user_args": user_args
                        }
                    }
                });
            }
            if (!(0,_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(error["message"])) {
                throw error["message"];
            } else {
                throw error;
            }
        }
    }
    _createClass(Integration, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.set_configuration = this.set_configuration.bind(this);
                this.get_configuration = this.get_configuration.bind(this);
            }
        },
        {
            key: "set_configuration",
            value: /**
	 * Sets the integration configuration.
	 *
	 * @param configuration
	 * @param fetch_remote_configuration
	 * @returns {boolean}
	 */ function set_configuration() {
                var configuration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.prev = 0;
                                if (!((0,_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_this.args["environment"]) || (0,_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_this.args["application"]))) {
                                    _ctx.next = 3;
                                    break;
                                }
                                return _ctx.abrupt("return", false);
                            case 3:
                                if (!(0,_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(configuration[_this.args["environment"]])) {
                                    _ctx.next = 5;
                                    break;
                                }
                                return _ctx.abrupt("return", false);
                            case 5:
                                if ((0,_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)((configuration[_this.args["environment"]] || {})[_this.args["application"]])) {
                                    _this.configuration = configuration[_this.args["environment"]]["tenant"];
                                } else {
                                    _this.configuration = configuration[_this.args["environment"]][_this.args["application"]];
                                }
                                _ctx.next = 16;
                                break;
                            case 8:
                                _ctx.prev = 8;
                                _ctx.t0 = _ctx["catch"](0);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/integration -> set_configuration():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": {
                                                "configuration": configuration
                                            }
                                        }
                                    });
                                }
                                if ((0,_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(_ctx.t0["message"])) {
                                    _ctx.next = 15;
                                    break;
                                }
                                throw _ctx.t0["message"];
                            case 15:
                                throw _ctx.t0;
                            case 16:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            0,
                            8
                        ]
                    ]);
                }))();
            }
        },
        {
            /**
	 * Gets the integration configuration.
	 *
	 * @returns {*|{}}
	 */ key: "get_configuration",
            value: function get_configuration() {
                return this.configuration;
            }
        }
    ]);
    return Integration;
}();


/***/ }),

/***/ 79523:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Integrations": function() { return /* binding */ Integrations; }
/* harmony export */ });
/* harmony import */ var _utilities__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93909);
/* harmony import */ var _cache_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74806);
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}


/**
 *
 */ var Integrations = /*#__PURE__*/ function() {
    "use strict";
    function Integrations() {
        var integrations = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, user_args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        _classCallCheck(this, Integrations);
        var default_args = {
            "cache": _cache_js__WEBPACK_IMPORTED_MODULE_1__._Cache
        };
        this.args = _objectSpread({}, default_args, user_args);
        try {
            this.set_bindings();
            this.set(integrations);
        } catch (error) {
            if (this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/pim-utilities/integrations -> constructor():", {
                    "error": error,
                    "args": {
                        "class": this.args,
                        "method": {
                            "integrations": integrations,
                            "user_args": user_args
                        }
                    }
                });
            }
            if (!(0,_utilities__WEBPACK_IMPORTED_MODULE_0__.is_empty)(error["message"])) {
                throw error["message"];
            } else {
                throw error;
            }
        }
    }
    _createClass(Integrations, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.get = this.get.bind(this);
                this.set = this.set.bind(this);
                this.get_class_name = this.get_class_name.bind(this);
            }
        },
        {
            /**
	 *
	 * @returns {Integrations}
	 */ key: "get",
            value: function get() {
                return this;
            }
        },
        {
            /**
	 *
	 * @param class_name
	 * @returns {}
	 */ key: "get_class_name",
            value: function get_class_name(class_name) {
                if (class_name.includes("/")) {
                    class_name = class_name.split("/").pop();
                }
                return class_name;
            }
        },
        {
            /**
	 *
	 * @param integration_name
	 * @param module
	 * @returns {null}
	 */ key: "get_module_name",
            value: function get_module_name() {
                var integration_name = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", module = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                var module_name = null;
                if ((0,_utilities__WEBPACK_IMPORTED_MODULE_0__.is_empty)(integration_name) || (0,_utilities__WEBPACK_IMPORTED_MODULE_0__.is_empty)(module)) {
                    return module_name;
                }
                integration_name = integration_name.toLowerCase();
                Object.keys(module).map(function(key) {
                    if (key.toLowerCase() === integration_name) {
                        module_name = key;
                    }
                });
                return module_name;
            }
        },
        {
            /**
	 *
	 * @param integrations
	 * @returns {{}|boolean}
	 */ key: "set",
            value: function set() {
                var integrations = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                try {
                    if ((0,_utilities__WEBPACK_IMPORTED_MODULE_0__.is_empty)(integrations)) {
                        return false;
                    }
                    for(var integration in integrations){
                        if (!(0,_utilities__WEBPACK_IMPORTED_MODULE_0__.is_empty)((integrations[integration] || {})["configuration"])) {
                            this.args = _objectSpread({}, this.args, integrations[integration]["configuration"]);
                        }
                        this[integration] = {};
                        var module = __webpack_require__(7141)("./".concat(integration, "/").concat(integration));
                        var module_name = this.get_module_name(integration, module);
                        this[integration]["base"] = new module[module_name](this.args);
                        var classes = [];
                        if (!(0,_utilities__WEBPACK_IMPORTED_MODULE_0__.is_empty)((integrations[integration] || {})["load"])) {
                            classes = integrations[integration]["load"];
                        }
                        if (!(0,_utilities__WEBPACK_IMPORTED_MODULE_0__.is_empty)(classes)) {
                            for(var i = 0; i < classes.length; i++){
                                module = __webpack_require__(7141)("./".concat(integration, "/").concat(classes[i]));
                                module_name = this.get_module_name(this.get_class_name(classes[i]), module);
                                this[integration][String(module_name).toLowerCase()] = new module[module_name](this.args);
                            }
                        }
                    }
                } catch (error) {
                    if (this.args["environment"] !== "production") {
                        console.log("@imprint-engine/packages/pim-utilities/integrations -> set():", {
                            "error": error,
                            "args": {
                                "class": this.args,
                                "method": integrations
                            }
                        });
                    }
                    if (!(0,_utilities__WEBPACK_IMPORTED_MODULE_0__.is_empty)(error["message"])) {
                        throw error["message"];
                    } else {
                        throw error;
                    }
                }
            }
        }
    ]);
    return Integrations;
}();


/***/ }),

/***/ 93909:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "array_chunk": function() { return /* binding */ array_chunk; },
/* harmony export */   "array_flip": function() { return /* binding */ array_flip; },
/* harmony export */   "array_unique": function() { return /* binding */ array_unique; },
/* harmony export */   "base64_decode": function() { return /* binding */ base64_decode; },
/* harmony export */   "base64_encode": function() { return /* binding */ base64_encode; },
/* harmony export */   "escape_sql_string": function() { return /* binding */ escape_sql_string; },
/* harmony export */   "fetch_in_batches": function() { return /* binding */ fetch_in_batches; },
/* harmony export */   "fetch_in_parallel": function() { return /* binding */ fetch_in_parallel; },
/* harmony export */   "fetch_in_sequence": function() { return /* binding */ fetch_in_sequence; },
/* harmony export */   "get_attribute": function() { return /* binding */ get_attribute; },
/* harmony export */   "get_meta": function() { return /* binding */ get_meta; },
/* harmony export */   "in_range": function() { return /* binding */ in_range; },
/* harmony export */   "is_empty": function() { return /* binding */ is_empty; },
/* harmony export */   "is_json": function() { return /* binding */ is_json; },
/* harmony export */   "is_super_admin": function() { return /* binding */ is_super_admin; },
/* harmony export */   "is_url": function() { return /* binding */ is_url; },
/* harmony export */   "list_pluck": function() { return /* binding */ list_pluck; },
/* harmony export */   "merge": function() { return /* binding */ merge; },
/* harmony export */   "object_filter": function() { return /* binding */ object_filter; },
/* harmony export */   "process_in_batches": function() { return /* binding */ process_in_batches; },
/* harmony export */   "process_in_parallel": function() { return /* binding */ process_in_parallel; },
/* harmony export */   "process_in_sequence": function() { return /* binding */ process_in_sequence; },
/* harmony export */   "sanitize_string": function() { return /* binding */ sanitize_string; },
/* harmony export */   "sanitize_title": function() { return /* binding */ sanitize_title; },
/* harmony export */   "sleep": function() { return /* binding */ sleep; },
/* harmony export */   "stripslashes": function() { return /* binding */ stripslashes; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var deepmerge__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9996);
/* harmony import */ var deepmerge__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(deepmerge__WEBPACK_IMPORTED_MODULE_1__);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/**
 * Merges two objects together.
 *
 * @function deepMerge
 * @param value1
 * @param value2
 * @returns {unknown}
 */ function merge() {
    var value1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, value2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    return deepmerge__WEBPACK_IMPORTED_MODULE_1___default()(value1, value2);
}
/**
 * Check if an object or array is empty.
 *
 * @param value
 * @returns {boolean}
 */ function is_empty(value) {
    if (value === false || value === null || value === undefined || value === "" || value === {} || value === []) {
        return true;
    }
    if (typeof value === "string" || Array.isArray(value)) {
        return value.length <= 0;
    }
    if (typeof value === "object") {
        return Object.keys(value).length <= 0;
    }
    return false;
}
/**
 * Check if a value is JSON or not.
 *
 * @param value
 * @returns {boolean}
 */ function is_json(value) {
    if (typeof value !== "string") {
        value = JSON.stringify(value);
    }
    try {
        value = JSON.parse(value);
    } catch (error) {
        return false;
    }
    return typeof value === "object" && value !== null;
}
/**
 * Check if string is valid URL.
 *
 * @param value
 * @returns {boolean}
 */ function is_url() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var url;
    try {
        url = new URL(value);
    } catch (error) {
        return false;
    }
    return url.protocol === "http:" || url.protocol === "https:";
}
/**
 * Exchanges all keys with their associated values in an array
 *
 * @param data
 * @returns {{}}
 */ function array_flip() {
    var data = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    return Object.keys(data).filter(data.hasOwnProperty.bind(data)).reduce(function(object, key) {
        object[data[key]] = key;
        return object;
    }, {});
}
/**
 * Split an array into chunks
 *
 * @param data
 * @param size
 * @returns {*[]}
 */ function array_chunk(data, size) {
    var output = [];
    if (!Array.isArray(data)) {
        output = {};
    }
    var i = 0;
    var n = 0;
    for(var item in data){
        if (i >= size) {
            i = 0;
            n++;
        }
        if (Array.isArray(data)) {
            if (!output[n] || output[n] === "undefined") {
                output[n] = [];
            }
            output[n][i] = data[item];
        } else {
            if (!output[n] || output[n] === "undefined") {
                output[n] = {};
            }
            output[n][item] = data[item];
        }
        i++;
    }
    return output;
}
/**
 * Removes duplicate values from an array.
 *
 * @param array
 * @returns {*}
 */ function array_unique(array) {
    var a = array.concat();
    var i;
    for(i = 0; i < a.length; ++i){
        var j = void 0;
        for(j = i + 1; j < a.length; ++j){
            if (a[i] === a[j]) {
                a.splice(j--, 1);
            }
        }
    }
    return a;
}
/**
 * Removes empty key/value paired items from an object.
 *
 * @param object
 * @returns {*}
 */ function object_filter(object) {
    Object.keys(object).map(function(property) {
        if (is_empty(object[property])) {
            delete object[property];
        }
    });
    return object;
}
/**
 *
 * @param value
 * @param minimum
 * @param maximum
 * @returns {boolean}
 */ function in_range() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, minimum = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, maximum = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    value = parseInt(value);
    minimum = parseInt(minimum);
    maximum = parseInt(maximum);
    return value >= minimum && value <= maximum;
}
/**
 * @deprecated
 * @param requests
 * @returns {Promise<*[]>}
 */ function fetch_in_sequence() {
    return _fetch_in_sequence.apply(this, arguments);
}
function _fetch_in_sequence() {
    _fetch_in_sequence = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var requests, _args = arguments;
        return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    requests = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    _ctx.next = 3;
                    return process_in_sequence(requests);
                case 3:
                    return _ctx.abrupt("return", _ctx.sent);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetch_in_sequence.apply(this, arguments);
}
/**
 * Makes calls to requested callback functions 1 by 1 in sequential order.
 *
 * @param requests
 * @param delay
 * @returns {Promise<{}>}
 */ function process_in_sequence() {
    return _process_in_sequence.apply(this, arguments);
}
function _process_in_sequence() {
    _process_in_sequence = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var requests, delay, response, key, request, result, _args = arguments;
        return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    requests = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {}, delay = _args.length > 1 && _args[1] !== void 0 ? _args[1] : 0;
                    response = {};
                    _ctx.prev = 2;
                    if (!is_empty(requests)) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", response);
                case 5:
                    _ctx.t0 = regeneratorRuntime.keys(requests);
                case 6:
                    if ((_ctx.t1 = _ctx.t0()).done) {
                        _ctx.next = 32;
                        break;
                    }
                    key = _ctx.t1.value;
                    if (!requests.hasOwnProperty(key)) {
                        _ctx.next = 30;
                        break;
                    }
                    request = requests[key];
                    if (is_empty(request["callback"])) {
                        _ctx.next = 30;
                        break;
                    }
                    result = {};
                    if (is_empty(request["args"])) {
                        _ctx.next = 18;
                        break;
                    }
                    _ctx.next = 15;
                    return request["callback"](request["args"]);
                case 15:
                    result = _ctx.sent;
                    _ctx.next = 21;
                    break;
                case 18:
                    _ctx.next = 20;
                    return request["callback"]();
                case 20:
                    result = _ctx.sent;
                case 21:
                    response[key] = result;
                    if (!(!is_empty(request["delay"]) && request["delay"] > 0)) {
                        _ctx.next = 27;
                        break;
                    }
                    _ctx.next = 25;
                    return sleep(request["delay"]);
                case 25:
                    _ctx.next = 30;
                    break;
                case 27:
                    if (!(delay > 0)) {
                        _ctx.next = 30;
                        break;
                    }
                    _ctx.next = 30;
                    return sleep(delay);
                case 30:
                    _ctx.next = 6;
                    break;
                case 32:
                    return _ctx.abrupt("return", response);
                case 35:
                    _ctx.prev = 35;
                    _ctx.t2 = _ctx["catch"](2);
                    console.log("@imprint-engine/packages/pim-utilities/utilities -> process_in_sequence():", {
                        "error": _ctx.t2,
                        "args": {
                            requests: requests
                        },
                        "response": response
                    });
                    if (is_empty(_ctx.t2["message"])) {
                        _ctx.next = 42;
                        break;
                    }
                    throw _ctx.t2["message"];
                case 42:
                    throw _ctx.t2;
                case 43:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                35
            ]
        ]);
    }));
    return _process_in_sequence.apply(this, arguments);
}
/**
 *
 * @deprecated
 * @param requests
 * @returns {Promise<{}>}
 */ function fetch_in_parallel() {
    return _fetch_in_parallel.apply(this, arguments);
}
function _fetch_in_parallel() {
    _fetch_in_parallel = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var requests, _args = arguments;
        return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    requests = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {};
                    _ctx.next = 3;
                    return process_in_parallel(requests);
                case 3:
                    return _ctx.abrupt("return", _ctx.sent);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetch_in_parallel.apply(this, arguments);
}
/**
 * Makes calls to requested callback functions in any order simultaneously.
 *
 * @param requests
 * @param delay
 * @returns {Promise<{}>}
 */ function process_in_parallel() {
    return _process_in_parallel.apply(this, arguments);
}
function _process_in_parallel() {
    _process_in_parallel = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee1() {
        var requests, delay, response, promises, _args = arguments;
        return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx1) {
            while(1)switch(_ctx1.prev = _ctx1.next){
                case 0:
                    requests = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {}, delay = _args.length > 1 && _args[1] !== void 0 ? _args[1] : 0;
                    response = {};
                    _ctx1.prev = 2;
                    if (!is_empty(requests)) {
                        _ctx1.next = 5;
                        break;
                    }
                    return _ctx1.abrupt("return", response);
                case 5:
                    promises = Object.keys(requests).map(function() {
                        var _ref = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(key) {
                            var request, result;
                            return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                                while(1)switch(_ctx.prev = _ctx.next){
                                    case 0:
                                        request = requests[key];
                                        if (is_empty(request["callback"])) {
                                            _ctx.next = 21;
                                            break;
                                        }
                                        result = {};
                                        if (is_empty(request["args"])) {
                                            _ctx.next = 9;
                                            break;
                                        }
                                        _ctx.next = 6;
                                        return request["callback"](request["args"]);
                                    case 6:
                                        result = _ctx.sent;
                                        _ctx.next = 12;
                                        break;
                                    case 9:
                                        _ctx.next = 11;
                                        return request["callback"]();
                                    case 11:
                                        result = _ctx.sent;
                                    case 12:
                                        response[key] = result;
                                        if (!(!is_empty(request["delay"]) && request["delay"] > 0)) {
                                            _ctx.next = 18;
                                            break;
                                        }
                                        _ctx.next = 16;
                                        return sleep(request["delay"]);
                                    case 16:
                                        _ctx.next = 21;
                                        break;
                                    case 18:
                                        if (!(delay > 0)) {
                                            _ctx.next = 21;
                                            break;
                                        }
                                        _ctx.next = 21;
                                        return sleep(delay);
                                    case 21:
                                    case "end":
                                        return _ctx.stop();
                                }
                            }, _callee);
                        }));
                        return function(key) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    _ctx1.next = 8;
                    return Promise.all(promises);
                case 8:
                    return _ctx1.abrupt("return", response);
                case 11:
                    _ctx1.prev = 11;
                    _ctx1.t0 = _ctx1["catch"](2);
                    console.log("@imprint-engine/packages/pim-utilities/utilities -> process_in_parallel():", {
                        "error": _ctx1.t0,
                        "args": {
                            requests: requests
                        },
                        "response": response
                    });
                    if (is_empty(_ctx1.t0["message"])) {
                        _ctx1.next = 18;
                        break;
                    }
                    throw _ctx1.t0["message"];
                case 18:
                    throw _ctx1.t0;
                case 19:
                case "end":
                    return _ctx1.stop();
            }
        }, _callee1, null, [
            [
                2,
                11
            ]
        ]);
    }));
    return _process_in_parallel.apply(this, arguments);
}
/**
 *
 * @deprecated
 * @param data
 * @param size
 * @returns {Promise<{}|*[]>}
 */ function fetch_in_batches() {
    return _fetch_in_batches.apply(this, arguments);
}
function _fetch_in_batches() {
    _fetch_in_batches = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data, size, _args = arguments;
        return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    data = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {}, size = _args.length > 1 && _args[1] !== void 0 ? _args[1] : 5;
                    _ctx.next = 3;
                    return process_in_batches(data, size);
                case 3:
                    return _ctx.abrupt("return", _ctx.sent);
                case 4:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return _fetch_in_batches.apply(this, arguments);
}
/**
 *
 * @param value
 * @returns {*}
 */ function escape_sql_string() {
    var value = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    if (typeof value !== "string") {
        return value;
    }
    return value.replace(/[\n\r"'\\\%]/g, function(character) {
        switch(character){
            case "\n":
                return "\\n";
            case "\r":
                return "\\r";
            case '"':
            case "'":
            case "\\":
            case "%":
                return "\\" + character; // prepends a backslash to backslash, percent, and double/single quotes
        }
    });
}
/**
 *
 * @param ms
 * @returns {Promise<unknown>}
 */ function sleep() {
    var ms = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    return new Promise(function(resolve) {
        return setTimeout(resolve, ms);
    });
}
/**
 * Splits the requests into batches. Each batch is a sequence, and the batch is processed in parallel by default (optionally: sequence).
 *
 * @param data
 * @param size
 * @param mode
 * @param delay
 * @returns {Promise<{}>}
 */ function process_in_batches() {
    return _process_in_batches.apply(this, arguments);
}
function _process_in_batches() {
    _process_in_batches = _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
        var data, size, mode, delay, response, batches, requests, _args = arguments;
        return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    data = _args.length > 0 && _args[0] !== void 0 ? _args[0] : {}, size = _args.length > 1 && _args[1] !== void 0 ? _args[1] : 5, mode = _args.length > 2 && _args[2] !== void 0 ? _args[2] : "parallel", delay = _args.length > 3 && _args[3] !== void 0 ? _args[3] : 0;
                    response = {};
                    _ctx.prev = 2;
                    if (!is_empty(data)) {
                        _ctx.next = 5;
                        break;
                    }
                    return _ctx.abrupt("return", response);
                case 5:
                    batches = array_chunk(data, size);
                    requests = {};
                    Object.keys(batches).map(function(batch_number) {
                        if (mode === "sequence") {
                            requests[batch_number] = {
                                "callback": process_in_sequence,
                                "args": batches[batch_number],
                                "delay": delay
                            };
                        } else {
                            requests[batch_number] = {
                                "callback": process_in_parallel,
                                "args": batches[batch_number],
                                "delay": delay
                            };
                        }
                    });
                    _ctx.next = 10;
                    return process_in_sequence(requests, delay);
                case 10:
                    response = _ctx.sent;
                    return _ctx.abrupt("return", response);
                case 14:
                    _ctx.prev = 14;
                    _ctx.t0 = _ctx["catch"](2);
                    console.log("@imprint-engine/packages/pim-utilities/utilities -> process_in_batches():", {
                        "error": _ctx.t0,
                        "args": {
                            "data": data,
                            size: size
                        },
                        "response": response
                    });
                    if (is_empty(_ctx.t0["message"])) {
                        _ctx.next = 21;
                        break;
                    }
                    throw _ctx.t0["message"];
                case 21:
                    throw _ctx.t0;
                case 22:
                case "end":
                    return _ctx.stop();
            }
        }, _callee, null, [
            [
                2,
                14
            ]
        ]);
    }));
    return _process_in_batches.apply(this, arguments);
}
/**
 *
 * @param email_address
 * @returns {boolean}
 */ function is_super_admin() {
    var email_address = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return [
        "bflaten@imprintengine.com",
        "caleb@imprintengine.com",
        "dustin@imprintengine.com",
        "mecklund@imprintengine.com",
        "msanders@imprintengine.com",
        "oj@imprintengine.com",
        "prodinis@imprintengine.com",
        "randy@imprintengine.com",
        "scott@imprintengine.com",
        "zm@imprintengine.com"
    ].includes(email_address);
}
/**
 *
 * @param attribute_code
 * @param data
 * @param object_type
 * @param return_type
 * @returns {boolean}
 */ function get_attribute() {
    var attribute_code = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, object_type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "entity", return_type = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "value";
    if (is_empty(data) || attribute_code === null) {
        return false;
    }
    var items = [];
    if (object_type === "meta" && !is_empty(data)) {
        items.push(data);
    }
    if (object_type === "entity" && !is_empty(data["attributes"])) {
        items = data["attributes"];
    }
    if (is_empty(items)) {
        return false;
    }
    var attribute = false;
    items.map(function(attribute_object) {
        if (!is_empty(attribute_object["attribute_code"])) {
            if (attribute_object["attribute_code"] === attribute_code) {
                if (return_type === "value") {
                    attribute = attribute_object["attribute_value"];
                } else {
                    attribute = attribute_object;
                }
            }
        }
    });
    return attribute;
}
/**
 *
 * @param meta_key
 * @param data
 * @param object_type
 * @returns {boolean}
 */ function get_meta() {
    var meta_key = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : null, data = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, object_type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "entity";
    if (is_empty(data) || meta_key === null) {
        return false;
    }
    var items = [];
    if (object_type === "meta" && !is_empty(data)) {
        items = Object.keys(data);
    }
    if (object_type === "entity" && !is_empty(data["metadata"])) {
        items = Object.keys(data["metadata"]);
    }
    if (is_empty(items)) {
        return false;
    }
    var meta = false;
    items.map(function(key) {
        if (key === meta_key) {
            if (object_type === "meta") {
                meta = data[meta_key];
            }
            if (object_type === "entity") {
                meta = data["metadata"][meta_key];
            }
        }
    });
    return meta;
}
/**
 * Pluck a certain field out of each object in a list.
 *
 * @param array Example: `[ { "value": "abc123", "some_field1": 'some_value1' }, { "value": "def456", "some_field2": 'some_value2' } ]`
 * @param field Example: `"value"`
 * @param conditions Example: `{ "some_field1": "some_value1" }`
 * @returns {boolean|*[]}
 */ function list_pluck() {
    var array = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], field = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", conditions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (is_empty(array) || is_empty(field)) {
        return false;
    }
    var data = [];
    array.map(function(item, index) {
        if (!is_empty(conditions)) {
            var matches = 0;
            Object.keys(conditions).map(function(key) {
                if (!is_empty(array[index][key]) && array[index][key] === conditions[key]) {
                    matches++;
                }
            });
            if (matches === Object.keys(conditions).length) {
                data.push(_defineProperty({}, field, item[field]));
            }
        } else {
            data.push(_defineProperty({}, field, item[field]));
        }
    });
    if (data.length === 1) {
        return data[0][field];
    }
    return data;
}
/**
 * Original Source: https://salferrarello.com/wordpress-sanitize-title-javascript/
 *
 * JavaScript function to mimic the WordPress PHP function sanitize_title()
 * See https://codex.wordpress.org/Function_Reference/sanitize_title
 *
 * Note: the WordPress PHP function sanitize_title() accepts two additional
 * optional parameters. At this time, this function does not.
 *
 * @param title The title to be santized.
 * @return string The sanitized string.
 */ function wpFeSanitizeTitle() {
    var title = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var replaceSpacesWithDash = /**
	 * Replace one or more blank spaces (or repeated dashes) with a single dash.
	 *
	 * @param str String that may contain spaces or multiple dashes.
	 * @return String with spaces replaced by dashes and no more than one dash in a row.
	 */ function replaceSpacesWithDash() {
        var str = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        return str.replace(/ +/g, "-") // Replace one or more blank spaces with a single dash (-)
        .replace(/-{2,}/g, "-"); // Replace two or more dashes (-) with a single dash (-).
    };
    var removeSingleTrailingDash = /**
	 * If the string end in a dash, remove it.
	 *
	 * @param str The string which may or may not end in a dash.
	 * @return string The string without a dash on the end.
	 */ function removeSingleTrailingDash() {
        var str = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        if ("-" === str.substr(str.length - 1)) {
            return str.substr(0, str.length - 1);
        }
        return str;
    };
    var getDiacriticsRemovalMap = /* Remove accents/diacritics in a string in JavaScript
	 * from https://stackoverflow.com/a/18391901
	 */ /*
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 */ function getDiacriticsRemovalMap() {
        if (diacriticsMap) {
            return diacriticsMap;
        }
        var defaultDiacriticsRemovalMap = [
            {
                "base": "A",
                "letters": "A\u24B6\uFF21\xc0\xc1\xc2\u1EA6\u1EA4\u1EAA\u1EA8\xc3\u0100\u0102\u1EB0\u1EAE\u1EB4\u1EB2\u0226\u01E0\xc4\u01DE\u1EA2\xc5\u01FA\u01CD\u0200\u0202\u1EA0\u1EAC\u1EB6\u1E00\u0104\u023A\u2C6F"
            },
            {
                "base": "AA",
                "letters": "\uA732"
            },
            {
                "base": "AE",
                "letters": "\xc6\u01FC\u01E2"
            },
            {
                "base": "AO",
                "letters": "\uA734"
            },
            {
                "base": "AU",
                "letters": "\uA736"
            },
            {
                "base": "AV",
                "letters": "\uA738\uA73A"
            },
            {
                "base": "AY",
                "letters": "\uA73C"
            },
            {
                "base": "B",
                "letters": "B\u24B7\uFF22\u1E02\u1E04\u1E06\u0243\u0182\u0181"
            },
            {
                "base": "C",
                "letters": "C\u24B8\uFF23\u0106\u0108\u010A\u010C\xc7\u1E08\u0187\u023B\uA73E"
            },
            {
                "base": "D",
                "letters": "D\u24B9\uFF24\u1E0A\u010E\u1E0C\u1E10\u1E12\u1E0E\u0110\u018B\u018A\u0189\uA779\xd0"
            },
            {
                "base": "DZ",
                "letters": "\u01F1\u01C4"
            },
            {
                "base": "Dz",
                "letters": "\u01F2\u01C5"
            },
            {
                "base": "E",
                "letters": "E\u24BA\uFF25\xc8\xc9\xca\u1EC0\u1EBE\u1EC4\u1EC2\u1EBC\u0112\u1E14\u1E16\u0114\u0116\xcb\u1EBA\u011A\u0204\u0206\u1EB8\u1EC6\u0228\u1E1C\u0118\u1E18\u1E1A\u0190\u018E"
            },
            {
                "base": "F",
                "letters": "F\u24BB\uFF26\u1E1E\u0191\uA77B"
            },
            {
                "base": "G",
                "letters": "G\u24BC\uFF27\u01F4\u011C\u1E20\u011E\u0120\u01E6\u0122\u01E4\u0193\uA7A0\uA77D\uA77E"
            },
            {
                "base": "H",
                "letters": "H\u24BD\uFF28\u0124\u1E22\u1E26\u021E\u1E24\u1E28\u1E2A\u0126\u2C67\u2C75\uA78D"
            },
            {
                "base": "I",
                "letters": "I\u24BE\uFF29\xcc\xcd\xce\u0128\u012A\u012C\u0130\xcf\u1E2E\u1EC8\u01CF\u0208\u020A\u1ECA\u012E\u1E2C\u0197"
            },
            {
                "base": "J",
                "letters": "J\u24BF\uFF2A\u0134\u0248"
            },
            {
                "base": "K",
                "letters": "K\u24C0\uFF2B\u1E30\u01E8\u1E32\u0136\u1E34\u0198\u2C69\uA740\uA742\uA744\uA7A2"
            },
            {
                "base": "L",
                "letters": "L\u24C1\uFF2C\u013F\u0139\u013D\u1E36\u1E38\u013B\u1E3C\u1E3A\u0141\u023D\u2C62\u2C60\uA748\uA746\uA780"
            },
            {
                "base": "LJ",
                "letters": "\u01C7"
            },
            {
                "base": "Lj",
                "letters": "\u01C8"
            },
            {
                "base": "M",
                "letters": "M\u24C2\uFF2D\u1E3E\u1E40\u1E42\u2C6E\u019C"
            },
            {
                "base": "N",
                "letters": "N\u24C3\uFF2E\u01F8\u0143\xd1\u1E44\u0147\u1E46\u0145\u1E4A\u1E48\u0220\u019D\uA790\uA7A4"
            },
            {
                "base": "NJ",
                "letters": "\u01CA"
            },
            {
                "base": "Nj",
                "letters": "\u01CB"
            },
            {
                "base": "O",
                "letters": "O\u24C4\uFF2F\xd2\xd3\xd4\u1ED2\u1ED0\u1ED6\u1ED4\xd5\u1E4C\u022C\u1E4E\u014C\u1E50\u1E52\u014E\u022E\u0230\xd6\u022A\u1ECE\u0150\u01D1\u020C\u020E\u01A0\u1EDC\u1EDA\u1EE0\u1EDE\u1EE2\u1ECC\u1ED8\u01EA\u01EC\xd8\u01FE\u0186\u019F\uA74A\uA74C"
            },
            {
                "base": "OI",
                "letters": "\u01A2"
            },
            {
                "base": "OO",
                "letters": "\uA74E"
            },
            {
                "base": "OU",
                "letters": "\u0222"
            },
            {
                "base": "OE",
                "letters": "\x8c\u0152"
            },
            {
                "base": "oe",
                "letters": "\x9c\u0153"
            },
            {
                "base": "P",
                "letters": "P\u24C5\uFF30\u1E54\u1E56\u01A4\u2C63\uA750\uA752\uA754"
            },
            {
                "base": "Q",
                "letters": "Q\u24C6\uFF31\uA756\uA758\u024A"
            },
            {
                "base": "R",
                "letters": "R\u24C7\uFF32\u0154\u1E58\u0158\u0210\u0212\u1E5A\u1E5C\u0156\u1E5E\u024C\u2C64\uA75A\uA7A6\uA782"
            },
            {
                "base": "S",
                "letters": "S\u24C8\uFF33\u1E9E\u015A\u1E64\u015C\u1E60\u0160\u1E66\u1E62\u1E68\u0218\u015E\u2C7E\uA7A8\uA784"
            },
            {
                "base": "T",
                "letters": "T\u24C9\uFF34\u1E6A\u0164\u1E6C\u021A\u0162\u1E70\u1E6E\u0166\u01AC\u01AE\u023E\uA786"
            },
            {
                "base": "TZ",
                "letters": "\uA728"
            },
            {
                "base": "U",
                "letters": "U\u24CA\uFF35\xd9\xda\xdb\u0168\u1E78\u016A\u1E7A\u016C\xdc\u01DB\u01D7\u01D5\u01D9\u1EE6\u016E\u0170\u01D3\u0214\u0216\u01AF\u1EEA\u1EE8\u1EEE\u1EEC\u1EF0\u1EE4\u1E72\u0172\u1E76\u1E74\u0244"
            },
            {
                "base": "V",
                "letters": "V\u24CB\uFF36\u1E7C\u1E7E\u01B2\uA75E\u0245"
            },
            {
                "base": "VY",
                "letters": "\uA760"
            },
            {
                "base": "W",
                "letters": "W\u24CC\uFF37\u1E80\u1E82\u0174\u1E86\u1E84\u1E88\u2C72"
            },
            {
                "base": "X",
                "letters": "X\u24CD\uFF38\u1E8A\u1E8C"
            },
            {
                "base": "Y",
                "letters": "Y\u24CE\uFF39\u1EF2\xdd\u0176\u1EF8\u0232\u1E8E\u0178\u1EF6\u1EF4\u01B3\u024E\u1EFE"
            },
            {
                "base": "Z",
                "letters": "Z\u24CF\uFF3A\u0179\u1E90\u017B\u017D\u1E92\u1E94\u01B5\u0224\u2C7F\u2C6B\uA762"
            },
            {
                "base": "a",
                "letters": "a\u24D0\uFF41\u1E9A\xe0\xe1\xe2\u1EA7\u1EA5\u1EAB\u1EA9\xe3\u0101\u0103\u1EB1\u1EAF\u1EB5\u1EB3\u0227\u01E1\xe4\u01DF\u1EA3\xe5\u01FB\u01CE\u0201\u0203\u1EA1\u1EAD\u1EB7\u1E01\u0105\u2C65\u0250"
            },
            {
                "base": "aa",
                "letters": "\uA733"
            },
            {
                "base": "ae",
                "letters": "\xe6\u01FD\u01E3"
            },
            {
                "base": "ao",
                "letters": "\uA735"
            },
            {
                "base": "au",
                "letters": "\uA737"
            },
            {
                "base": "av",
                "letters": "\uA739\uA73B"
            },
            {
                "base": "ay",
                "letters": "\uA73D"
            },
            {
                "base": "b",
                "letters": "b\u24D1\uFF42\u1E03\u1E05\u1E07\u0180\u0183\u0253"
            },
            {
                "base": "c",
                "letters": "c\u24D2\uFF43\u0107\u0109\u010B\u010D\xe7\u1E09\u0188\u023C\uA73F\u2184"
            },
            {
                "base": "d",
                "letters": "d\u24D3\uFF44\u1E0B\u010F\u1E0D\u1E11\u1E13\u1E0F\u0111\u018C\u0256\u0257\uA77A"
            },
            {
                "base": "dz",
                "letters": "\u01F3\u01C6"
            },
            {
                "base": "e",
                "letters": "e\u24D4\uFF45\xe8\xe9\xea\u1EC1\u1EBF\u1EC5\u1EC3\u1EBD\u0113\u1E15\u1E17\u0115\u0117\xeb\u1EBB\u011B\u0205\u0207\u1EB9\u1EC7\u0229\u1E1D\u0119\u1E19\u1E1B\u0247\u025B\u01DD"
            },
            {
                "base": "f",
                "letters": "f\u24D5\uFF46\u1E1F\u0192\uA77C"
            },
            {
                "base": "g",
                "letters": "g\u24D6\uFF47\u01F5\u011D\u1E21\u011F\u0121\u01E7\u0123\u01E5\u0260\uA7A1\u1D79\uA77F"
            },
            {
                "base": "h",
                "letters": "h\u24D7\uFF48\u0125\u1E23\u1E27\u021F\u1E25\u1E29\u1E2B\u1E96\u0127\u2C68\u2C76\u0265"
            },
            {
                "base": "hv",
                "letters": "\u0195"
            },
            {
                "base": "i",
                "letters": "i\u24D8\uFF49\xec\xed\xee\u0129\u012B\u012D\xef\u1E2F\u1EC9\u01D0\u0209\u020B\u1ECB\u012F\u1E2D\u0268\u0131"
            },
            {
                "base": "j",
                "letters": "j\u24D9\uFF4A\u0135\u01F0\u0249"
            },
            {
                "base": "k",
                "letters": "k\u24DA\uFF4B\u1E31\u01E9\u1E33\u0137\u1E35\u0199\u2C6A\uA741\uA743\uA745\uA7A3"
            },
            {
                "base": "l",
                "letters": "l\u24DB\uFF4C\u0140\u013A\u013E\u1E37\u1E39\u013C\u1E3D\u1E3B\u017F\u0142\u019A\u026B\u2C61\uA749\uA781\uA747"
            },
            {
                "base": "lj",
                "letters": "\u01C9"
            },
            {
                "base": "m",
                "letters": "m\u24DC\uFF4D\u1E3F\u1E41\u1E43\u0271\u026F"
            },
            {
                "base": "n",
                "letters": "n\u24DD\uFF4E\u01F9\u0144\xf1\u1E45\u0148\u1E47\u0146\u1E4B\u1E49\u019E\u0272\u0149\uA791\uA7A5"
            },
            {
                "base": "nj",
                "letters": "\u01CC"
            },
            {
                "base": "o",
                "letters": "o\u24DE\uFF4F\xf2\xf3\xf4\u1ED3\u1ED1\u1ED7\u1ED5\xf5\u1E4D\u022D\u1E4F\u014D\u1E51\u1E53\u014F\u022F\u0231\xf6\u022B\u1ECF\u0151\u01D2\u020D\u020F\u01A1\u1EDD\u1EDB\u1EE1\u1EDF\u1EE3\u1ECD\u1ED9\u01EB\u01ED\xf8\u01FF\u0254\uA74B\uA74D\u0275"
            },
            {
                "base": "oi",
                "letters": "\u01A3"
            },
            {
                "base": "ou",
                "letters": "\u0223"
            },
            {
                "base": "oo",
                "letters": "\uA74F"
            },
            {
                "base": "p",
                "letters": "p\u24DF\uFF50\u1E55\u1E57\u01A5\u1D7D\uA751\uA753\uA755"
            },
            {
                "base": "q",
                "letters": "q\u24E0\uFF51\u024B\uA757\uA759"
            },
            {
                "base": "r",
                "letters": "r\u24E1\uFF52\u0155\u1E59\u0159\u0211\u0213\u1E5B\u1E5D\u0157\u1E5F\u024D\u027D\uA75B\uA7A7\uA783"
            },
            {
                "base": "s",
                "letters": "s\u24E2\uFF53\xdf\u015B\u1E65\u015D\u1E61\u0161\u1E67\u1E63\u1E69\u0219\u015F\u023F\uA7A9\uA785\u1E9B"
            },
            {
                "base": "t",
                "letters": "t\u24E3\uFF54\u1E6B\u1E97\u0165\u1E6D\u021B\u0163\u1E71\u1E6F\u0167\u01AD\u0288\u2C66\uA787"
            },
            {
                "base": "tz",
                "letters": "\uA729"
            },
            {
                "base": "u",
                "letters": "u\u24E4\uFF55\xf9\xfa\xfb\u0169\u1E79\u016B\u1E7B\u016D\xfc\u01DC\u01D8\u01D6\u01DA\u1EE7\u016F\u0171\u01D4\u0215\u0217\u01B0\u1EEB\u1EE9\u1EEF\u1EED\u1EF1\u1EE5\u1E73\u0173\u1E77\u1E75\u0289"
            },
            {
                "base": "v",
                "letters": "v\u24E5\uFF56\u1E7D\u1E7F\u028B\uA75F\u028C"
            },
            {
                "base": "vy",
                "letters": "\uA761"
            },
            {
                "base": "w",
                "letters": "w\u24E6\uFF57\u1E81\u1E83\u0175\u1E87\u1E85\u1E98\u1E89\u2C73"
            },
            {
                "base": "x",
                "letters": "x\u24E7\uFF58\u1E8B\u1E8D"
            },
            {
                "base": "y",
                "letters": "y\u24E8\uFF59\u1EF3\xfd\u0177\u1EF9\u0233\u1E8F\xff\u1EF7\u1E99\u1EF5\u01B4\u024F\u1EFF"
            },
            {
                "base": "z",
                "letters": "z\u24E9\uFF5A\u017A\u1E91\u017C\u017E\u1E93\u1E95\u01B6\u0225\u0240\u2C6C\uA763"
            }
        ];
        diacriticsMap = {};
        for(var i = 0; i < defaultDiacriticsRemovalMap.length; i++){
            var letters = defaultDiacriticsRemovalMap[i].letters;
            for(var j = 0; j < letters.length; j++){
                diacriticsMap[letters[j]] = defaultDiacriticsRemovalMap[i].base;
            }
        }
        return diacriticsMap;
    };
    var removeAccents = // Remove accent characters/diacritics from the string.
    function removeAccents() {
        var str = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
        diacriticsMap = getDiacriticsRemovalMap();
        return str.replace(/[^\u0000-\u007E]/g, function(a) {
            return diacriticsMap[a] || a;
        });
    };
    var diacriticsMap;
    return removeSingleTrailingDash(replaceSpacesWithDash(removeAccents(title.replace(/<[^>]+>/ig, "") // Strip any HTML tags.
    ).toLowerCase()// Replace anything that is not a:
    // word character
    // space
    // nor a dash (-)
    // with an empty string (i.e. remove it).
    .replace(/[^\w\s-]+/g, "")));
}
/**
 *
 * @param string
 * @param casing
 * @param separator
 * @returns {string|string}
 */ function sanitize_string() {
    var string = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", casing = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "lower", separator = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "-";
    string = String(string);
    string = wpFeSanitizeTitle(string);
    if (casing === "upper") {
        string = string.toUpperCase();
    }
    if (separator !== "-") {
        string = string.replace(/-/g, separator);
    }
    return string;
}
/**
 *
 * @param string
 * @returns {string}
 */ function sanitize_title() {
    var string = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return sanitize_string(string);
}
/**
 *
 * @param string
 * @returns {string}
 */ function stripslashes() {
    var string = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    //       discuss at: https://locutus.io/php/stripslashes/
    //      original by: Kevin van Zonneveld (https://kvz.io)
    //      improved by: Ates Goral (https://magnetiq.com)
    //      improved by: marrtins
    //      improved by: rezna
    //         fixed by: Mick@el
    //      bugfixed by: Onno Marsman (https://twitter.com/onnomarsman)
    //      bugfixed by: Brett Zamir (https://brett-zamir.me)
    //         input by: Rick Waldron
    //         input by: Brant Messenger (https://www.brantmessenger.com/)
    // reimplemented by: Brett Zamir (https://brett-zamir.me)
    //        example 1: stripslashes('Kevin\'s code')
    //        returns 1: "Kevin's code"
    //        example 2: stripslashes('Kevin\\\'s code')
    //        returns 2: "Kevin\'s code"
    return (string + "").replace(/\\(.?)/g, function(s, n1) {
        switch(n1){
            case "\\":
                return "\\";
            case "0":
                return "\0";
            case "":
                return "";
            default:
                return n1;
        }
    });
}
/**
 *
 * @param string
 * @returns {string}
 */ function base64_encode() {
    var string = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var buffer = new Buffer.from(string);
    return buffer.toString("base64");
}
/**
 *
 * @param string
 * @returns {string}
 */ function base64_decode() {
    var string = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    var buffer = new Buffer.from(string, "base64");
    return buffer.toString("ascii");
}


/***/ }),

/***/ 17019:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Attributes": function() { return /* binding */ Attributes; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _woocommerce_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32699);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * WooCommerce Integration
 * @class   Attributes
 * @extends WooCommerce
 */ var Attributes = /*#__PURE__*/ function(WooCommerce1) {
    "use strict";
    _inherits(Attributes, WooCommerce1);
    var _super = _createSuper(Attributes);
    function Attributes() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Attributes);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/woocommerce/attributes -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Attributes, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("post", "/attributes", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/attributes -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 16;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/attributes/".concat(args["id"]));
                            case 14:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                }
                            case 16:
                                return _ctx.abrupt("return", response);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/attributes -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 23:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("get", "/attributes", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/attributes -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0,
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/attributes/".concat(args["id"]), {
                                    "data": args["payload"]
                                });
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/attributes -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/attributes/".concat(args["id"]));
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/attributes -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Attributes;
}(_woocommerce_js__WEBPACK_IMPORTED_MODULE_2__.WooCommerce);


/***/ }),

/***/ 49723:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Categories": function() { return /* binding */ Categories; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _woocommerce_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32699);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * WooCommerce Integration
 * @class   Categories
 * @extends WooCommerce
 */ var Categories = /*#__PURE__*/ function(WooCommerce1) {
    "use strict";
    _inherits(Categories, WooCommerce1);
    var _super = _createSuper(Categories);
    function Categories() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Categories);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/woocommerce/categories -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Categories, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("post", "/categories", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", response);
                            case 12:
                                _ctx.prev = 12;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/categories -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 16:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            12
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<boolean>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 13;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 17;
                                break;
                            case 13:
                                _ctx.next = 15;
                                return _this.request("get", "/categories/".concat(args["id"]));
                            case 15:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                }
                            case 17:
                                return _ctx.abrupt("return", response);
                            case 20:
                                _ctx.prev = 20;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/categories -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 24:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            20
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * List all product categories
	 *
	 * @documentation https://woocommerce.github.io/woocommerce-rest-api-docs/#list-all-product-categories
	 * @endpoint /wp-json/wc/v3/products/categories
	 * @method GET
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "parameters": {
                                        "hide_empty": "true"
                                    },
                                    "data": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(user_args["parameters"])) {
                                    args["parameters"] = _objectSpread({}, default_args["parameters"], user_args["parameters"]);
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(user_args["data"])) {
                                    args["data"] = _objectSpread({}, default_args["data"], user_args["data"]);
                                }
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 13;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 17;
                                break;
                            case 13:
                                _ctx.next = 15;
                                return _this.request("get", "/products/categories", {
                                    "parameters": args["parameters"],
                                    "data": args["data"]
                                });
                            case 15:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                    if (Array.isArray(response) && response["length"] > 0) {
                                        response.map(function(result) {
                                            _this.cache.set(_this.constructor["name"], JSON.stringify({
                                                "id": result["id"]
                                            }), result);
                                        });
                                    }
                                }
                            case 17:
                                return _ctx.abrupt("return", response);
                            case 20:
                                _ctx.prev = 20;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/categories -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 24:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            20
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0,
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/categories/".concat(args["id"]), {
                                    "data": args["payload"]
                                });
                            case 9:
                                response = _ctx.sent;
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", response);
                            case 14:
                                _ctx.prev = 14;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/categories -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 18:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            14
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/categories/".concat(args["id"]));
                            case 9:
                                response = _ctx.sent;
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", response);
                            case 14:
                                _ctx.prev = 14;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/categories -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 18:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            14
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Categories;
}(_woocommerce_js__WEBPACK_IMPORTED_MODULE_2__.WooCommerce);


/***/ }),

/***/ 71217:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Coupons": function() { return /* binding */ Coupons; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _woocommerce_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32699);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * WooCommerce Integration
 * @class   Coupons
 * @extends WooCommerce
 */ var Coupons = /*#__PURE__*/ function(WooCommerce1) {
    "use strict";
    _inherits(Coupons, WooCommerce1);
    var _super = _createSuper(Coupons);
    function Coupons() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Coupons);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/woocommerce/coupons -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Coupons, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("post", "/coupons", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/coupons -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 16;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/coupons/".concat(args["id"]));
                            case 14:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                }
                            case 16:
                                return _ctx.abrupt("return", response);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/coupons -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 23:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("get", "/coupons", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/coupons -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0,
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/coupons/".concat(args["id"]), {
                                    "data": args["payload"]
                                });
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/coupons -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/coupons/".concat(args["id"]));
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/coupons -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Coupons;
}(_woocommerce_js__WEBPACK_IMPORTED_MODULE_2__.WooCommerce);


/***/ }),

/***/ 88074:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Customers": function() { return /* binding */ Customers; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _woocommerce_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32699);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * WooCommerce Integration
 * @class   Customers
 * @extends WooCommerce
 */ var Customers = /*#__PURE__*/ function(WooCommerce1) {
    "use strict";
    _inherits(Customers, WooCommerce1);
    var _super = _createSuper(Customers);
    function Customers() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Customers);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/woocommerce/customers -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Customers, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("post", "/customers", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/customers -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 16;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/customers/".concat(args["id"]));
                            case 14:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                }
                            case 16:
                                return _ctx.abrupt("return", response);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/customers -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 23:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("get", "/customers", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/customers -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0,
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/customers/".concat(args["id"]), {
                                    "data": args["payload"]
                                });
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/customers -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/customers/".concat(args["id"]));
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/customers -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Customers;
}(_woocommerce_js__WEBPACK_IMPORTED_MODULE_2__.WooCommerce);


/***/ }),

/***/ 64996:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Notes": function() { return /* binding */ Notes; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _woocommerce_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32699);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * WooCommerce Integration
 * @class   Notes
 * @extends WooCommerce
 */ var Notes = /*#__PURE__*/ function(WooCommerce1) {
    "use strict";
    _inherits(Notes, WooCommerce1);
    var _super = _createSuper(Notes);
    function Notes() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Notes);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/woocommerce/notes -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Notes, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("post", "/notes", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/notes -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 16;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/notes/".concat(args["id"]));
                            case 14:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                }
                            case 16:
                                return _ctx.abrupt("return", response);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/notes -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 23:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("get", "/notes", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/notes -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0,
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/notes/".concat(args["id"]), {
                                    "data": args["payload"]
                                });
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/notes -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/notes/".concat(args["id"]));
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/notes -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Notes;
}(_woocommerce_js__WEBPACK_IMPORTED_MODULE_2__.WooCommerce);


/***/ }),

/***/ 89322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Orders": function() { return /* binding */ Orders; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _woocommerce_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32699);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * WooCommerce Integration
 * @class   Orders
 * @extends WooCommerce
 */ var Orders = /*#__PURE__*/ function(WooCommerce1) {
    "use strict";
    _inherits(Orders, WooCommerce1);
    var _super = _createSuper(Orders);
    function Orders() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Orders);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/woocommerce/orders -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Orders, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("post", "/orders", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/orders -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 16;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/orders/".concat(args["id"]));
                            case 14:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                }
                            case 16:
                                return _ctx.abrupt("return", response);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/orders -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 23:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("get", "/orders", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/orders -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0,
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/orders/".concat(args["id"]), {
                                    "data": args["payload"]
                                });
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/orders -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/orders/".concat(args["id"]));
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/orders -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Orders;
}(_woocommerce_js__WEBPACK_IMPORTED_MODULE_2__.WooCommerce);


/***/ }),

/***/ 42631:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Products": function() { return /* binding */ Products; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _woocommerce_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32699);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * WooCommerce Integration
 * @class   Products
 * @extends WooCommerce
 */ var Products = /*#__PURE__*/ function(WooCommerce1) {
    "use strict";
    _inherits(Products, WooCommerce1);
    var _super = _createSuper(Products);
    function Products() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Products);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/woocommerce/products -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Products, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("post", "/products", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", response);
                            case 12:
                                _ctx.prev = 12;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/products -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 16:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            12
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<boolean>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 13;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 17;
                                break;
                            case 13:
                                _ctx.next = 15;
                                return _this.request("get", "/products/".concat(args["id"]));
                            case 15:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                }
                            case 17:
                                return _ctx.abrupt("return", response);
                            case 20:
                                _ctx.prev = 20;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/products -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 24:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            20
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @param disable_cache
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, disable_cache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "parameters": {
                                        "status": "publish"
                                    },
                                    "data": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(user_args["parameters"])) {
                                    args["parameters"] = _objectSpread({}, default_args["parameters"], user_args["parameters"]);
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(user_args["data"])) {
                                    args["data"] = _objectSpread({}, default_args["data"], user_args["data"]);
                                }
                                cache = false;
                                if (!disable_cache) {
                                    cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                }
                                if (!cache) {
                                    _ctx.next = 13;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 17;
                                break;
                            case 13:
                                _ctx.next = 15;
                                return _this.request("get", "/products", {
                                    "parameters": args["parameters"],
                                    "data": args["data"]
                                });
                            case 15:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                    if (Array.isArray(response) && response["length"] > 0) {
                                        response.map(function(result) {
                                            _this.cache.set(_this.constructor["name"], JSON.stringify({
                                                "id": result["id"]
                                            }), result);
                                        });
                                    }
                                }
                            case 17:
                                return _ctx.abrupt("return", response);
                            case 20:
                                _ctx.prev = 20;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/products -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 24:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            20
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0,
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/products/".concat(args["id"]), {
                                    "data": args["payload"]
                                });
                            case 9:
                                response = _ctx.sent;
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", response);
                            case 14:
                                _ctx.prev = 14;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/products -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 18:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            14
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/products/".concat(args["id"]));
                            case 9:
                                response = _ctx.sent;
                                _this.cache.remove(_this.constructor["name"]);
                                return _ctx.abrupt("return", response);
                            case 14:
                                _ctx.prev = 14;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/products -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 18:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            14
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Products;
}(_woocommerce_js__WEBPACK_IMPORTED_MODULE_2__.WooCommerce);


/***/ }),

/***/ 94439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Refunds": function() { return /* binding */ Refunds; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _woocommerce_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32699);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * WooCommerce Integration
 * @class   Refunds
 * @extends WooCommerce
 */ var Refunds = /*#__PURE__*/ function(WooCommerce1) {
    "use strict";
    _inherits(Refunds, WooCommerce1);
    var _super = _createSuper(Refunds);
    function Refunds() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Refunds);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/woocommerce/refunds -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Refunds, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("post", "/refunds", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/refunds -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 16;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/refunds/".concat(args["id"]));
                            case 14:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                }
                            case 16:
                                return _ctx.abrupt("return", response);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/refunds -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 23:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("get", "/refunds", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/refunds -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0,
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/refunds/".concat(args["id"]), {
                                    "data": args["payload"]
                                });
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/refunds -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/refunds/".concat(args["id"]));
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/refunds -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Refunds;
}(_woocommerce_js__WEBPACK_IMPORTED_MODULE_2__.WooCommerce);


/***/ }),

/***/ 22379:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Tags": function() { return /* binding */ Tags; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _woocommerce_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32699);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * WooCommerce Integration
 * @class   Tags
 * @extends WooCommerce
 */ var Tags = /*#__PURE__*/ function(WooCommerce1) {
    "use strict";
    _inherits(Tags, WooCommerce1);
    var _super = _createSuper(Tags);
    function Tags() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Tags);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/woocommerce/tags -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Tags, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("post", "/tags", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/tags -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 16;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/tags/".concat(args["id"]));
                            case 14:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                }
                            case 16:
                                return _ctx.abrupt("return", response);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/tags -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 23:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("get", "/tags", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/tags -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0,
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/tags/".concat(args["id"]), {
                                    "data": args["payload"]
                                });
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/tags -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/tags/".concat(args["id"]));
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/tags -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Tags;
}(_woocommerce_js__WEBPACK_IMPORTED_MODULE_2__.WooCommerce);


/***/ }),

/***/ 7974:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Variations": function() { return /* binding */ Variations; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _woocommerce_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32699);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * WooCommerce Integration
 * @class   Variations
 * @extends WooCommerce
 */ var Variations = /*#__PURE__*/ function(WooCommerce1) {
    "use strict";
    _inherits(Variations, WooCommerce1);
    var _super = _createSuper(Variations);
    function Variations() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Variations);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/woocommerce/variations -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Variations, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("post", "/variations", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/variations -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 16;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/variations/".concat(args["id"]));
                            case 14:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                }
                            case 16:
                                return _ctx.abrupt("return", response);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/variations -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 23:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("get", "/variations", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/variations -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0,
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/variations/".concat(args["id"]), {
                                    "data": args["payload"]
                                });
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/variations -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/variations/".concat(args["id"]));
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/woocommerce/variations -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Variations;
}(_woocommerce_js__WEBPACK_IMPORTED_MODULE_2__.WooCommerce);


/***/ }),

/***/ 32699:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Configuration": function() { return /* binding */ Configuration; },
/* harmony export */   "WooCommerce": function() { return /* binding */ WooCommerce; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93909);
/* harmony import */ var _print_engine_utilities_integration_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59709);
/* harmony import */ var _print_engine_netlify_netlify_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(33383);
/* provided dependency */ var process = __webpack_require__(83454);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}





/**
 * WooCommerce Configuration
 *
 * @type {{development: {tenant: {secret: (string|*|string), url: string, key: (string|*|string)}}, production: {tenant: {secret:
 *     (string|*|string), url: string, key: (string|*|string)}}, staging: {tenant: {secret: (string|*|string), url: string,
 *     key: (string|*|string)}}, local: {tenant: {secret: (string|*|string), url: string, key: (string|*|string)}}}}
 */ var Configuration = {
    "production": {
        "tenant": {
            "url": "https://app.printengine.com/wp-json/wc/v3",
            "key": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["P_WC_KEY"]) ? "".concat(process.env["P_WC_KEY"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["WC_KEY"]) ? process.env["WC_KEY"] : "",
            "secret": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["P_WC_SECRET"]) ? "".concat(process.env["P_WC_SECRET"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["WC_SECRET"]) ? process.env["WC_SECRET"] : ""
        }
    },
    "staging": {
        "tenant": {
            "url": "https://app.printenginestage.com/wp-json/wc/v3",
            "key": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["S_WC_KEY"]) ? "".concat(process.env["S_WC_KEY"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["WC_KEY"]) ? process.env["WC_KEY"] : "",
            "secret": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["S_WC_SECRET"]) ? "".concat(process.env["S_WC_SECRET"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["WC_SECRET"]) ? process.env["WC_SECRET"] : ""
        }
    },
    "development": {
        "tenant": {
            "url": "https://app.printenginedev.com/wp-json/wc/v3",
            "key": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["D_WC_KEY"]) ? "".concat(process.env["D_WC_KEY"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["WC_KEY"]) ? process.env["WC_KEY"] : "",
            "secret": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["D_WC_SECRET"]) ? "".concat(process.env["D_WC_SECRET"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["WC_SECRET"]) ? process.env["WC_SECRET"] : ""
        }
    },
    "local": {
        "tenant": {
            "url": "https://app.printenginedev.com/wp-json/wc/v3",
            "key": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["L_WC_KEY"]) ? "".concat(process.env["L_WC_KEY"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["WC_KEY"]) ? process.env["WC_KEY"] : "",
            "secret": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["L_WC_SECRET"]) ? "".concat(process.env["L_WC_SECRET"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["WC_SECRET"]) ? process.env["WC_SECRET"] : ""
        }
    }
};
/**
 * WooCommerce Integration
 * @class   WooCommerce
 * @extends Integration
 */ var WooCommerce = /*#__PURE__*/ function(Integration1) {
    "use strict";
    _inherits(WooCommerce, Integration1);
    var _super = _createSuper(WooCommerce);
    function WooCommerce() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, WooCommerce);
        var _this;
        var default_args = {
            "environment": null,
            "application": "tenant",
            "context": null,
            "scope": null,
            "api_url": "",
            "username": "",
            "password": "",
            "service_token": null
        };
        var args = _objectSpread({}, default_args, user_args);
        _this = _super.call(this, args);
        _this.args = _objectSpread({}, args, {
            "name": "WooCommerce",
            "class_name": _this.constructor["name"],
            "reference_name": "woocommerce",
            "description": "WooCommerce is a customizable, open-source eCommerce platform built on WordPress. Get started now. Start a new store Customize and extend.",
            "documentation_url": "https://woocommerce.github.io/woocommerce-rest-api-docs/"
        });
        try {
            _this.set_bindings();
            _this.set_configuration(Configuration);
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/hasura -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _this;
    }
    _createClass(WooCommerce, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.request = this.request.bind(this);
                this.authorize = this.authorize.bind(this);
            }
        },
        {
            key: "authorize",
            value: /**
	 *
	 * @param payload
	 * @returns {Promise<*|boolean>}
	 */ function authorize() {
                var payload = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var request, response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                request = {};
                                response = false;
                                _ctx.prev = 2;
                                request = {
                                    "baseURL": _print_engine_netlify_netlify_js__WEBPACK_IMPORTED_MODULE_4__.Configuration[_this.args["environment"]][_this.args["application"]]["api"]["url"],
                                    "headers": {
                                        "Content-Type": "application/json"
                                    },
                                    "timeout": 30000,
                                    "url": "/auth/request",
                                    "method": "POST",
                                    "data": {
                                        "integration": "woocommerce",
                                        "payload": payload
                                    }
                                };
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["service_token"])) {
                                    request["headers"]["Authorization"] = "Bearer ".concat(_this.args["service_token"]);
                                }
                                _ctx.next = 7;
                                return axios__WEBPACK_IMPORTED_MODULE_1___default()(request);
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura -> authorize():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": request
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "request",
            value: /**
	 * Performs a network request to WooCommerce.
	 *
	 * @param method
	 * @param endpoint
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function request1() {
                var method = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", endpoint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", user_args = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response, url, username, password, request, remote_response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "parameters": {},
                                    "data": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                if (!((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.configuration) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["context"]) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(method) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(endpoint))) {
                                    _ctx.next = 6;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 6:
                                method = String(method).toUpperCase();
                                url = "";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)((_this.configuration || {})["url"])) {
                                    url = _this.configuration["url"];
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["api_url"])) {
                                    url = _this.args["api_url"];
                                }
                                username = "";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)((_this.configuration || {})["key"])) {
                                    username = _this.configuration["key"];
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["username"])) {
                                    username = _this.args["username"];
                                }
                                password = "";
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)((_this.configuration || {})["secret"])) {
                                    password = _this.configuration["secret"];
                                }
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["password"])) {
                                    password = _this.args["password"];
                                }
                                request = {
                                    "baseURL": url,
                                    "headers": {
                                        "Content-Type": "application/json"
                                    },
                                    "auth": {
                                        "username": username,
                                        "password": password
                                    },
                                    "timeout": 30000,
                                    "url": "".concat(endpoint),
                                    "method": "".concat(method)
                                };
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args)) {
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["parameters"])) {
                                        request["params"] = args["parameters"];
                                    }
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["data"])) {
                                        if ([
                                            "PUT",
                                            "POST",
                                            "DELETE",
                                            "PATCH"
                                        ].includes(method)) {
                                            request["data"] = args["data"];
                                        }
                                    }
                                }
                                remote_response = {};
                                if (!((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(request["auth"]["username"]) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(request["auth"]["password"]))) {
                                    _ctx.next = 25;
                                    break;
                                }
                                _ctx.next = 22;
                                return _this.authorize(request);
                            case 22:
                                remote_response = _ctx.sent;
                                _ctx.next = 28;
                                break;
                            case 25:
                                _ctx.next = 27;
                                return axios__WEBPACK_IMPORTED_MODULE_1___default()(request);
                            case 27:
                                remote_response = _ctx.sent;
                            case 28:
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(remote_response["data"])) {
                                    response = remote_response["data"];
                                }
                                return _ctx.abrupt("return", response);
                            case 32:
                                _ctx.prev = 32;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/hasura -> request():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": {
                                                "method": method,
                                                "endpoint": endpoint,
                                                "user_args": user_args
                                            }
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 36:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            32
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return WooCommerce;
}(_print_engine_utilities_integration_js__WEBPACK_IMPORTED_MODULE_3__.Integration);


/***/ }),

/***/ 17162:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sites": function() { return /* binding */ Sites; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _wordpress_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(124);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * WordPress Integration
 * @class   Sites
 * @extends WordPress
 */ var Sites = /*#__PURE__*/ function(WordPress1) {
    "use strict";
    _inherits(Sites, WordPress1);
    var _super = _createSuper(Sites);
    function Sites() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Sites);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/wordpress/sites -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Sites, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("post", "/sites", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wordpress/sites -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 16;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/sites/".concat(args["id"]));
                            case 14:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                }
                            case 16:
                                return _ctx.abrupt("return", response);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wordpress/sites -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 23:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("get", "/sites", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wordpress/sites -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0,
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/sites/".concat(args["id"]), {
                                    "data": args["payload"]
                                });
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wordpress/sites -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/sites/".concat(args["id"]));
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wordpress/sites -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Sites;
}(_wordpress_js__WEBPACK_IMPORTED_MODULE_2__.WordPress);


/***/ }),

/***/ 124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Configuration": function() { return /* binding */ Configuration; },
/* harmony export */   "WordPress": function() { return /* binding */ WordPress; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93909);
/* harmony import */ var _print_engine_utilities_integration__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59709);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




/**
 * WordPress Configuration
 *
 * @type {{development: {}, production: {}, staging: {}, local: {}}}
 */ var Configuration = {
    "production": {},
    "staging": {},
    "development": {},
    "local": {}
};
/**
 * WordPress Integration
 * @class   WordPress
 * @extends Integration
 */ var WordPress = /*#__PURE__*/ function(Integration1) {
    "use strict";
    _inherits(WordPress, Integration1);
    var _super = _createSuper(WordPress);
    function WordPress() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, WordPress);
        var _this;
        var default_args = {
            "environment": null,
            "application": "tenant",
            "context": null,
            "scope": null,
            "token": null
        };
        var args = _objectSpread({}, default_args, user_args);
        _this = _super.call(this, args);
        _this.args = _objectSpread({}, args, {
            "name": "WordPress",
            "class_name": _this.constructor["name"],
            "reference_name": "wordpress",
            "description": "The REST API is a standardized way to interact with WordPress and is the preferred way to interact with WordPress.",
            "documentation_url": "https://developer.wordpress.org/rest-api/"
        });
        try {
            _this.set_bindings();
            _this.set_configuration(Configuration);
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/wordpress -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _this;
    }
    _createClass(WordPress, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.request = this.request.bind(this);
            }
        },
        {
            key: "request",
            value: /**
	 * Performs a network request to WordPress.
	 *
	 * @param method
	 * @param endpoint
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function request1() {
                var method = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", endpoint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", user_args = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response, token, request, remote_response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "parameters": {},
                                    "data": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                if (!((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["context"]) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.configuration) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(method) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(endpoint))) {
                                    _ctx.next = 6;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 6:
                                method = String(method).toUpperCase();
                                token = !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["token"]) ? "".concat(_this.args["token"]) : "".concat(_this.configuration["token"]);
                                request = {
                                    "baseURL": _this.configuration["url"],
                                    "headers": {
                                        "Authorization": "Bearer ".concat(token),
                                        "Content-Type": "application/json"
                                    },
                                    "timeout": 30000,
                                    "url": "".concat(endpoint),
                                    "method": "".concat(method)
                                };
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args)) {
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["parameters"])) {
                                        request["params"] = args["parameters"];
                                    }
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["data"])) {
                                        if ([
                                            "PUT",
                                            "POST",
                                            "DELETE",
                                            "PATCH"
                                        ].includes(method)) {
                                            request["data"] = args["data"];
                                        }
                                    }
                                }
                                console.log("@imprint-engine/packages/wordpress -> request():", {
                                    "args": {
                                        "class": _this.args,
                                        "method": {
                                            "method": method,
                                            "endpoint": endpoint,
                                            "user_args": user_args
                                        }
                                    },
                                    "configuration": _this.configuration
                                });
                                _ctx.next = 13;
                                return axios__WEBPACK_IMPORTED_MODULE_1___default()(request);
                            case 13:
                                remote_response = _ctx.sent;
                                //console.log( '@imprint-engine/packages/wordpress -> request(): (REMOTE_RESPONSE)', util.inspect( remote_response,
                                // false, null, true ) );
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(remote_response["data"])) {
                                    response = remote_response["data"];
                                }
                                return _ctx.abrupt("return", response);
                            case 18:
                                _ctx.prev = 18;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wordpress -> request():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": {
                                                "method": method,
                                                "endpoint": endpoint,
                                                "user_args": user_args
                                            }
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 22:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            18
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return WordPress;
}(_print_engine_utilities_integration__WEBPACK_IMPORTED_MODULE_3__.Integration);


/***/ }),

/***/ 93304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Accounts": function() { return /* binding */ Accounts; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _wpengine_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64961);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * WP Engine Integration
 * @class   Accounts
 * @extends WPEngine
 */ var Accounts = /*#__PURE__*/ function(WPEngine1) {
    "use strict";
    _inherits(Accounts, WPEngine1);
    var _super = _createSuper(Accounts);
    function Accounts() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Accounts);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/wpengine/accounts -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Accounts, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("post", "/accounts", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/accounts -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 16;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/accounts/".concat(args["id"]));
                            case 14:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                }
                            case 16:
                                return _ctx.abrupt("return", response);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/accounts -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 23:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("get", "/accounts", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/accounts -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0,
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/accounts/".concat(args["id"]), {
                                    "data": args["payload"]
                                });
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/accounts -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/accounts/".concat(args["id"]));
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/accounts -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Accounts;
}(_wpengine_js__WEBPACK_IMPORTED_MODULE_2__.WPEngine);


/***/ }),

/***/ 70936:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Cache": function() { return /* binding */ Cache; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _wpengine_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64961);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * WP Engine Integration
 * @class   Cache
 * @extends WPEngine
 */ var Cache = /*#__PURE__*/ function(WPEngine1) {
    "use strict";
    _inherits(Cache, WPEngine1);
    var _super = _createSuper(Cache);
    function Cache() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Cache);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/wpengine/cache -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Cache, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.purge = this.purge.bind(this);
            }
        },
        {
            key: "purge",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function purge() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("post", "/cache/purge");
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/cache -> purge():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Cache;
}(_wpengine_js__WEBPACK_IMPORTED_MODULE_2__.WPEngine);


/***/ }),

/***/ 68124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Domains": function() { return /* binding */ Domains; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _wpengine_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64961);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * WP Engine Integration
 * @class   Domains
 * @extends WPEngine
 */ var Domains = /*#__PURE__*/ function(WPEngine1) {
    "use strict";
    _inherits(Domains, WPEngine1);
    var _super = _createSuper(Domains);
    function Domains() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Domains);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/wpengine/domains -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Domains, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("post", "/domains", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/domains -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 16;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/domains/".concat(args["id"]));
                            case 14:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                }
                            case 16:
                                return _ctx.abrupt("return", response);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/domains -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 23:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("get", "/domains", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/domains -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0,
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/domains/".concat(args["id"]), {
                                    "data": args["payload"]
                                });
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/domains -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/domains/".concat(args["id"]));
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/domains -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Domains;
}(_wpengine_js__WEBPACK_IMPORTED_MODULE_2__.WPEngine);


/***/ }),

/***/ 97474:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Installs": function() { return /* binding */ Installs; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _wpengine_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64961);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * WP Engine Integration
 * @class   Installs
 * @extends WPEngine
 */ var Installs = /*#__PURE__*/ function(WPEngine1) {
    "use strict";
    _inherits(Installs, WPEngine1);
    var _super = _createSuper(Installs);
    function Installs() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Installs);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/wpengine/installs -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Installs, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("post", "/installs", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/installs -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 16;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/installs/".concat(args["id"]));
                            case 14:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                }
                            case 16:
                                return _ctx.abrupt("return", response);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/installs -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 23:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("get", "/installs", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/installs -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0,
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/installs/".concat(args["id"]), {
                                    "data": args["payload"]
                                });
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/installs -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/installs/".concat(args["id"]));
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/installs -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Installs;
}(_wpengine_js__WEBPACK_IMPORTED_MODULE_2__.WPEngine);


/***/ }),

/***/ 85335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Sites": function() { return /* binding */ Sites; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93909);
/* harmony import */ var _wpengine_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64961);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}



/**
 * WP Engine Integration
 * @class   Sites
 * @extends WPEngine
 */ var Sites = /*#__PURE__*/ function(WPEngine1) {
    "use strict";
    _inherits(Sites, WPEngine1);
    var _super = _createSuper(Sites);
    function Sites() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, Sites);
        var _this;
        try {
            _this = _super.call(this, user_args);
            _this.set_bindings();
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/wpengine/sites -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _possibleConstructorReturn(_this);
    }
    _createClass(Sites, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.create = this.create.bind(this);
                this.get = this.get.bind(this);
                this.list = this.list.bind(this);
                this.update = this.update.bind(this);
                this.delete = this.delete.bind(this);
            }
        },
        {
            key: "create",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method POST
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function create() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("post", "/sites", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/sites -> create():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "get",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean|*>}
	 */ function get() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args, cache;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                cache = _this.cache.get(_this.constructor["name"], JSON.stringify(args));
                                if (!cache) {
                                    _ctx.next = 12;
                                    break;
                                }
                                {
                                    response = cache;
                                }
                                _ctx.next = 16;
                                break;
                            case 12:
                                _ctx.next = 14;
                                return _this.request("get", "/sites/".concat(args["id"]));
                            case 14:
                                response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(response)) {
                                    _this.cache.set(_this.constructor["name"], JSON.stringify(args), response);
                                }
                            case 16:
                                return _ctx.abrupt("return", response);
                            case 19:
                                _ctx.prev = 19;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/sites -> get():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 23:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            19
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "list",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method GET
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function list() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                _ctx.next = 7;
                                return _this.request("get", "/sites", {
                                    "data": args["payload"]
                                });
                            case 7:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 11:
                                _ctx.prev = 11;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/sites -> list():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 15:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            11
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "update",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method PATCH
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function update() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0,
                                    "payload": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("patch", "/sites/".concat(args["id"]), {
                                    "data": args["payload"]
                                });
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/sites -> update():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        },
        {
            key: "delete",
            value: /**
	 * @TODO Needs documentation
	 *
	 * @documentation
	 * @endpoint
	 * @method DELETE
	 *
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function _delete() {
                var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var args, response, default_args;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                args = {};
                                response = false;
                                _ctx.prev = 2;
                                default_args = {
                                    "id": 0
                                };
                                args = _objectSpread({}, default_args, user_args);
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_1__.is_empty)(args["id"])) {
                                    _ctx.next = 7;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 7:
                                _ctx.next = 9;
                                return _this.request("delete", "/sites/".concat(args["id"]));
                            case 9:
                                response = _ctx.sent;
                                return _ctx.abrupt("return", response);
                            case 13:
                                _ctx.prev = 13;
                                _ctx.t0 = _ctx["catch"](2);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine/sites -> delete():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": args
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 17:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            2,
                            13
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return Sites;
}(_wpengine_js__WEBPACK_IMPORTED_MODULE_2__.WPEngine);


/***/ }),

/***/ 64961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Configuration": function() { return /* binding */ Configuration; },
/* harmony export */   "WPEngine": function() { return /* binding */ WPEngine; }
/* harmony export */ });
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9669);
/* harmony import */ var axios__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(axios__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(93909);
/* harmony import */ var _print_engine_utilities_integration_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59709);
/* provided dependency */ var process = __webpack_require__(83454);
function _assertThisInitialized(self) {
    if (self === void 0) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    }
    return self;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _getPrototypeOf(o1) {
    _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _getPrototypeOf(o1);
}
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function");
    }
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) _setPrototypeOf(subClass, superClass);
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _possibleConstructorReturn(self, call) {
    if (call && (_typeof(call) === "object" || typeof call === "function")) {
        return call;
    }
    return _assertThisInitialized(self);
}
function _setPrototypeOf(o2, p1) {
    _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _setPrototypeOf(o2, p1);
}
var _typeof = function(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
};
function _isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function _createSuper(Derived) {
    var hasNativeReflectConstruct = _isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = _getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = _getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else {
            result = Super.apply(this, arguments);
        }
        return _possibleConstructorReturn(this, result);
    };
}




/**
 * WP Engine Configuration
 *
 * @type {{development: {tenant: {password: (string|*|string), url: string, username: (string|*|string)}}, production: {tenant: {password:
 *     (string|*|string), url: string, username: (string|*|string)}}, staging: {tenant: {password: (string|*|string), url: string,
 *     username: (string|*|string)}}, local: {tenant: {password: (string|*|string), url: string, username: (string|*|string)}}}}
 */ var Configuration = {
    "production": {
        "tenant": {
            "url": "https://api.wpengineapi.com/v1",
            "username": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["P_WPENGINE_USERNAME"]) ? "".concat(process.env["P_WPENGINE_USERNAME"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["WPENGINE_USERNAME"]) ? process.env["WPENGINE_USERNAME"] : "",
            "password": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["P_WPENGINE_PASSWORD"]) ? "".concat(process.env["P_WPENGINE_PASSWORD"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["WPENGINE_PASSWORD"]) ? process.env["WPENGINE_PASSWORD"] : ""
        }
    },
    "staging": {
        "tenant": {
            "url": "https://api.wpengineapi.com/v1",
            "username": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["S_WPENGINE_USERNAME"]) ? "".concat(process.env["S_WPENGINE_USERNAME"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["WPENGINE_USERNAME"]) ? process.env["WPENGINE_USERNAME"] : "",
            "password": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["S_WPENGINE_PASSWORD"]) ? "".concat(process.env["S_WPENGINE_PASSWORD"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["WPENGINE_PASSWORD"]) ? process.env["WPENGINE_PASSWORD"] : ""
        }
    },
    "development": {
        "tenant": {
            "url": "https://api.wpengineapi.com/v1",
            "username": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["D_WPENGINE_USERNAME"]) ? "".concat(process.env["D_WPENGINE_USERNAME"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["WPENGINE_USERNAME"]) ? process.env["WPENGINE_USERNAME"] : "",
            "password": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["D_WPENGINE_PASSWORD"]) ? "".concat(process.env["D_WPENGINE_PASSWORD"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["WPENGINE_PASSWORD"]) ? process.env["WPENGINE_PASSWORD"] : ""
        }
    },
    "local": {
        "tenant": {
            "url": "https://api.wpengineapi.com/v1",
            "username": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["L_WPENGINE_USERNAME"]) ? "".concat(process.env["L_WPENGINE_USERNAME"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["WPENGINE_USERNAME"]) ? process.env["WPENGINE_USERNAME"] : "",
            "password": !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["L_WPENGINE_PASSWORD"]) ? "".concat(process.env["L_WPENGINE_PASSWORD"]) : !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(process.env["WPENGINE_PASSWORD"]) ? process.env["WPENGINE_PASSWORD"] : ""
        }
    }
};
/**
 * WP Engine Integration
 * @class   WPEngine
 * @extends Integration
 */ var WPEngine = /*#__PURE__*/ function(Integration1) {
    "use strict";
    _inherits(WPEngine, Integration1);
    var _super = _createSuper(WPEngine);
    function WPEngine() {
        var user_args = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        _classCallCheck(this, WPEngine);
        var _this;
        var default_args = {
            "environment": null,
            "application": "tenant",
            "context": null,
            "scope": null,
            "token": null,
            "tenant_id": null,
            "source_id": null
        };
        var args = _objectSpread({}, default_args, user_args);
        _this = _super.call(this, args);
        _this.args = _objectSpread({}, args, {
            "name": "WP Engine",
            "class_name": _this.constructor["name"],
            "reference_name": "wpengine",
            "description": "WordPress hosting platform, used for WordPress/WooCommerce websites.",
            "documentation_url": "https://wpengineapi.com/"
        });
        try {
            _this.set_bindings();
            _this.set_configuration(Configuration);
        } catch (error) {
            if (_this.args["environment"] !== "production") {
                console.log("@imprint-engine/packages/wpengine -> constructor():", {
                    "error": error,
                    "args": {
                        "class": _this.args,
                        "method": user_args
                    },
                    "configuration": _this.configuration
                });
            }
            throw error;
        }
        return _this;
    }
    _createClass(WPEngine, [
        {
            /**
	 * Helps to maintain class instance context with callbacks.
	 */ key: "set_bindings",
            value: function set_bindings() {
                this.request = this.request.bind(this);
            }
        },
        {
            key: "request",
            value: /**
	 * Performs a network request to WP Engine.
	 *
	 * @param method
	 * @param endpoint
	 * @param user_args
	 * @returns {Promise<boolean>}
	 */ function request1() {
                var method = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", endpoint = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "", user_args = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
                var _this = this;
                return _asyncToGenerator(_opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
                    var default_args, args, response, token, request, remote_response;
                    return _opt_build_repo_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                default_args = {
                                    "parameters": {},
                                    "data": {}
                                };
                                args = _objectSpread({}, default_args, user_args);
                                response = false;
                                _ctx.prev = 3;
                                if (!((0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["context"]) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.configuration) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(method) || (0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(endpoint))) {
                                    _ctx.next = 6;
                                    break;
                                }
                                return _ctx.abrupt("return", response);
                            case 6:
                                method = String(method).toUpperCase();
                                token = !(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(_this.args["token"]) ? "".concat(_this.args["token"]) : "".concat(_this.configuration["token"]);
                                request = {
                                    "baseURL": _this.configuration["url"],
                                    "headers": {
                                        "Authorization": "Basic ".concat(token),
                                        "Content-Type": "application/json"
                                    },
                                    "timeout": 30000,
                                    "url": "".concat(endpoint),
                                    "method": "".concat(method)
                                };
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args)) {
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["parameters"])) {
                                        request["params"] = args["parameters"];
                                    }
                                    if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(args["data"])) {
                                        if ([
                                            "PUT",
                                            "POST",
                                            "DELETE",
                                            "PATCH"
                                        ].includes(method)) {
                                            request["data"] = args["data"];
                                        }
                                    }
                                }
                                console.log("@imprint-engine/packages/wpengine -> request():", {
                                    "args": {
                                        "class": _this.args,
                                        "method": {
                                            "method": method,
                                            "endpoint": endpoint,
                                            "user_args": user_args
                                        }
                                    },
                                    "configuration": _this.configuration
                                });
                                _ctx.next = 13;
                                return axios__WEBPACK_IMPORTED_MODULE_1___default()(request);
                            case 13:
                                remote_response = _ctx.sent;
                                if (!(0,_print_engine_utilities_utilities_js__WEBPACK_IMPORTED_MODULE_2__.is_empty)(remote_response["data"])) {
                                    response = remote_response["data"];
                                }
                                return _ctx.abrupt("return", response);
                            case 18:
                                _ctx.prev = 18;
                                _ctx.t0 = _ctx["catch"](3);
                                if (_this.args["environment"] !== "production") {
                                    console.log("@imprint-engine/packages/wpengine -> request():", {
                                        "error": _ctx.t0,
                                        "args": {
                                            "class": _this.args,
                                            "method": {
                                                "method": method,
                                                "endpoint": endpoint,
                                                "user_args": user_args
                                            }
                                        },
                                        "configuration": _this.configuration,
                                        "response": response
                                    });
                                }
                                throw _ctx.t0;
                            case 22:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee, null, [
                        [
                            3,
                            18
                        ]
                    ]);
                }))();
            }
        }
    ]);
    return WPEngine;
}(_print_engine_utilities_integration_js__WEBPACK_IMPORTED_MODULE_3__.Integration);


/***/ }),

/***/ 27596:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(83454);
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
(function(){var e={901:function(e){e.exports=function(e,r,n){if(e.filter)return e.filter(r,n);if(void 0===e||null===e)throw new TypeError;if("function"!=typeof r)throw new TypeError;var o=[];for(var a=0;a<e.length;a++){if(!t.call(e,a))continue;var i=e[a];if(r.call(n,i,a,e))o.push(i)}return o};var t=Object.prototype.hasOwnProperty},313:function(e,t,r){"use strict";function _typeof(e){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(e){return typeof e}}else{_typeof=function _typeof(e){return e&&typeof Symbol==="function"&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e}}return _typeof(e)}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}var n=r(823),o=n.codes,a=o.ERR_AMBIGUOUS_ARGUMENT,i=o.ERR_INVALID_ARG_TYPE,c=o.ERR_INVALID_ARG_VALUE,u=o.ERR_INVALID_RETURN_VALUE,f=o.ERR_MISSING_ARGS;var s=r(298);var p=r(650),l=p.inspect;var y=r(650).types,d=y.isPromise,g=y.isRegExp;var v=Object.assign?Object.assign:r(274).assign;var b=Object.is?Object.is:r(450);var h=new Map;var m;var A;var S;var E;var P;function lazyLoadComparison(){var e=r(655);m=e.isDeepEqual;A=e.isDeepStrictEqual}var w=/[\x00-\x08\x0b\x0c\x0e-\x1f]/g;var O=null&&0;var j=function escapeFn(e){return O[e.charCodeAt(0)]};var _=false;var x=e.exports=ok;var I={};function innerFail(e){if(e.message instanceof Error)throw e.message;throw new s(e)}function fail(e,t,r,n,o){var a=arguments.length;var i;if(a===0){i="Failed"}else if(a===1){r=e;e=undefined}else{if(_===false){_=true;var c=process.emitWarning?process.emitWarning:console.warn.bind(console);c("assert.fail() with more than one argument is deprecated. "+"Please use assert.strictEqual() instead or only pass a message.","DeprecationWarning","DEP0094")}if(a===2)n="!="}if(r instanceof Error)throw r;var u={actual:e,expected:t,operator:n===undefined?"fail":n,stackStartFn:o||fail};if(r!==undefined){u.message=r}var f=new s(u);if(i){f.message=i;f.generatedMessage=true}throw f}x.fail=fail;x.AssertionError=s;function innerOk(e,t,r,n){if(!r){var o=false;if(t===0){o=true;n="No value argument passed to `assert.ok()`"}else if(n instanceof Error){throw n}var a=new s({actual:r,expected:true,message:n,operator:"==",stackStartFn:e});a.generatedMessage=o;throw a}}function ok(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}innerOk.apply(void 0,[ok,t.length].concat(t))}x.ok=ok;x.equal=function equal(e,t,r){if(arguments.length<2){throw new f("actual","expected")}if(e!=t){innerFail({actual:e,expected:t,message:r,operator:"==",stackStartFn:equal})}};x.notEqual=function notEqual(e,t,r){if(arguments.length<2){throw new f("actual","expected")}if(e==t){innerFail({actual:e,expected:t,message:r,operator:"!=",stackStartFn:notEqual})}};x.deepEqual=function deepEqual(e,t,r){if(arguments.length<2){throw new f("actual","expected")}if(m===undefined)lazyLoadComparison();if(!m(e,t)){innerFail({actual:e,expected:t,message:r,operator:"deepEqual",stackStartFn:deepEqual})}};x.notDeepEqual=function notDeepEqual(e,t,r){if(arguments.length<2){throw new f("actual","expected")}if(m===undefined)lazyLoadComparison();if(m(e,t)){innerFail({actual:e,expected:t,message:r,operator:"notDeepEqual",stackStartFn:notDeepEqual})}};x.deepStrictEqual=function deepStrictEqual(e,t,r){if(arguments.length<2){throw new f("actual","expected")}if(m===undefined)lazyLoadComparison();if(!A(e,t)){innerFail({actual:e,expected:t,message:r,operator:"deepStrictEqual",stackStartFn:deepStrictEqual})}};x.notDeepStrictEqual=notDeepStrictEqual;function notDeepStrictEqual(e,t,r){if(arguments.length<2){throw new f("actual","expected")}if(m===undefined)lazyLoadComparison();if(A(e,t)){innerFail({actual:e,expected:t,message:r,operator:"notDeepStrictEqual",stackStartFn:notDeepStrictEqual})}}x.strictEqual=function strictEqual(e,t,r){if(arguments.length<2){throw new f("actual","expected")}if(!b(e,t)){innerFail({actual:e,expected:t,message:r,operator:"strictEqual",stackStartFn:strictEqual})}};x.notStrictEqual=function notStrictEqual(e,t,r){if(arguments.length<2){throw new f("actual","expected")}if(b(e,t)){innerFail({actual:e,expected:t,message:r,operator:"notStrictEqual",stackStartFn:notStrictEqual})}};var F=function Comparison(e,t,r){var n=this;_classCallCheck(this,Comparison);t.forEach((function(t){if(t in e){if(r!==undefined&&typeof r[t]==="string"&&g(e[t])&&e[t].test(r[t])){n[t]=r[t]}else{n[t]=e[t]}}}))};function compareExceptionKey(e,t,r,n,o,a){if(!(r in e)||!A(e[r],t[r])){if(!n){var i=new F(e,o);var c=new F(t,o,e);var u=new s({actual:i,expected:c,operator:"deepStrictEqual",stackStartFn:a});u.actual=e;u.expected=t;u.operator=a.name;throw u}innerFail({actual:e,expected:t,message:n,operator:a.name,stackStartFn:a})}}function expectedException(e,t,r,n){if(typeof t!=="function"){if(g(t))return t.test(e);if(arguments.length===2){throw new i("expected",["Function","RegExp"],t)}if(_typeof(e)!=="object"||e===null){var o=new s({actual:e,expected:t,message:r,operator:"deepStrictEqual",stackStartFn:n});o.operator=n.name;throw o}var a=Object.keys(t);if(t instanceof Error){a.push("name","message")}else if(a.length===0){throw new c("error",t,"may not be an empty object")}if(m===undefined)lazyLoadComparison();a.forEach((function(o){if(typeof e[o]==="string"&&g(t[o])&&t[o].test(e[o])){return}compareExceptionKey(e,t,o,r,a,n)}));return true}if(t.prototype!==undefined&&e instanceof t){return true}if(Error.isPrototypeOf(t)){return false}return t.call({},e)===true}function getActual(e){if(typeof e!=="function"){throw new i("fn","Function",e)}try{e()}catch(e){return e}return I}function checkIsPromise(e){return d(e)||e!==null&&_typeof(e)==="object"&&typeof e.then==="function"&&typeof e.catch==="function"}function waitForActual(e){return Promise.resolve().then((function(){var t;if(typeof e==="function"){t=e();if(!checkIsPromise(t)){throw new u("instance of Promise","promiseFn",t)}}else if(checkIsPromise(e)){t=e}else{throw new i("promiseFn",["Function","Promise"],e)}return Promise.resolve().then((function(){return t})).then((function(){return I})).catch((function(e){return e}))}))}function expectsError(e,t,r,n){if(typeof r==="string"){if(arguments.length===4){throw new i("error",["Object","Error","Function","RegExp"],r)}if(_typeof(t)==="object"&&t!==null){if(t.message===r){throw new a("error/message",'The error message "'.concat(t.message,'" is identical to the message.'))}}else if(t===r){throw new a("error/message",'The error "'.concat(t,'" is identical to the message.'))}n=r;r=undefined}else if(r!=null&&_typeof(r)!=="object"&&typeof r!=="function"){throw new i("error",["Object","Error","Function","RegExp"],r)}if(t===I){var o="";if(r&&r.name){o+=" (".concat(r.name,")")}o+=n?": ".concat(n):".";var c=e.name==="rejects"?"rejection":"exception";innerFail({actual:undefined,expected:r,operator:e.name,message:"Missing expected ".concat(c).concat(o),stackStartFn:e})}if(r&&!expectedException(t,r,n,e)){throw t}}function expectsNoError(e,t,r,n){if(t===I)return;if(typeof r==="string"){n=r;r=undefined}if(!r||expectedException(t,r)){var o=n?": ".concat(n):".";var a=e.name==="doesNotReject"?"rejection":"exception";innerFail({actual:t,expected:r,operator:e.name,message:"Got unwanted ".concat(a).concat(o,"\n")+'Actual message: "'.concat(t&&t.message,'"'),stackStartFn:e})}throw t}x.throws=function throws(e){for(var t=arguments.length,r=new Array(t>1?t-1:0),n=1;n<t;n++){r[n-1]=arguments[n]}expectsError.apply(void 0,[throws,getActual(e)].concat(r))};x.rejects=function rejects(e){for(var t=arguments.length,r=new Array(t>1?t-1:0),n=1;n<t;n++){r[n-1]=arguments[n]}return waitForActual(e).then((function(e){return expectsError.apply(void 0,[rejects,e].concat(r))}))};x.doesNotThrow=function doesNotThrow(e){for(var t=arguments.length,r=new Array(t>1?t-1:0),n=1;n<t;n++){r[n-1]=arguments[n]}expectsNoError.apply(void 0,[doesNotThrow,getActual(e)].concat(r))};x.doesNotReject=function doesNotReject(e){for(var t=arguments.length,r=new Array(t>1?t-1:0),n=1;n<t;n++){r[n-1]=arguments[n]}return waitForActual(e).then((function(e){return expectsNoError.apply(void 0,[doesNotReject,e].concat(r))}))};x.ifError=function ifError(e){if(e!==null&&e!==undefined){var t="ifError got unwanted exception: ";if(_typeof(e)==="object"&&typeof e.message==="string"){if(e.message.length===0&&e.constructor){t+=e.constructor.name}else{t+=e.message}}else{t+=l(e)}var r=new s({actual:e,expected:null,operator:"ifError",message:t,stackStartFn:ifError});var n=e.stack;if(typeof n==="string"){var o=n.split("\n");o.shift();var a=r.stack.split("\n");for(var i=0;i<o.length;i++){var c=a.indexOf(o[i]);if(c!==-1){a=a.slice(0,c);break}}r.stack="".concat(a.join("\n"),"\n").concat(o.join("\n"))}throw r}};function strict(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}innerOk.apply(void 0,[strict,t.length].concat(t))}x.strict=v(strict,x,{equal:x.strictEqual,deepEqual:x.deepStrictEqual,notEqual:x.notStrictEqual,notDeepEqual:x.notDeepStrictEqual});x.strict.strict=x.strict},298:function(e,t,r){"use strict";function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};var n=Object.keys(r);if(typeof Object.getOwnPropertySymbols==="function"){n=n.concat(Object.getOwnPropertySymbols(r).filter((function(e){return Object.getOwnPropertyDescriptor(r,e).enumerable})))}n.forEach((function(t){_defineProperty(e,t,r[t])}))}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||false;n.configurable=true;if("value"in n)n.writable=true;Object.defineProperty(e,n.key,n)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}function _possibleConstructorReturn(e,t){if(t&&(_typeof(t)==="object"||typeof t==="function")){return t}return _assertThisInitialized(e)}function _assertThisInitialized(e){if(e===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}return e}function _inherits(e,t){if(typeof t!=="function"&&t!==null){throw new TypeError("Super expression must either be null or a function")}e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:true,configurable:true}});if(t)_setPrototypeOf(e,t)}function _wrapNativeSuper(e){var t=typeof Map==="function"?new Map:undefined;_wrapNativeSuper=function _wrapNativeSuper(e){if(e===null||!_isNativeFunction(e))return e;if(typeof e!=="function"){throw new TypeError("Super expression must either be null or a function")}if(typeof t!=="undefined"){if(t.has(e))return t.get(e);t.set(e,Wrapper)}function Wrapper(){return _construct(e,arguments,_getPrototypeOf(this).constructor)}Wrapper.prototype=Object.create(e.prototype,{constructor:{value:Wrapper,enumerable:false,writable:true,configurable:true}});return _setPrototypeOf(Wrapper,e)};return _wrapNativeSuper(e)}function isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Date.prototype.toString.call(Reflect.construct(Date,[],(function(){})));return true}catch(e){return false}}function _construct(e,t,r){if(isNativeReflectConstruct()){_construct=Reflect.construct}else{_construct=function _construct(e,t,r){var n=[null];n.push.apply(n,t);var o=Function.bind.apply(e,n);var a=new o;if(r)_setPrototypeOf(a,r.prototype);return a}}return _construct.apply(null,arguments)}function _isNativeFunction(e){return Function.toString.call(e).indexOf("[native code]")!==-1}function _setPrototypeOf(e,t){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(e,t){e.__proto__=t;return e};return _setPrototypeOf(e,t)}function _getPrototypeOf(e){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(e){return e.__proto__||Object.getPrototypeOf(e)};return _getPrototypeOf(e)}function _typeof(e){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(e){return typeof e}}else{_typeof=function _typeof(e){return e&&typeof Symbol==="function"&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e}}return _typeof(e)}var n=r(650),o=n.inspect;var a=r(823),i=a.codes.ERR_INVALID_ARG_TYPE;function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function repeat(e,t){t=Math.floor(t);if(e.length==0||t==0)return"";var r=e.length*t;t=Math.floor(Math.log(t)/Math.log(2));while(t){e+=e;t--}e+=e.substring(0,r-e.length);return e}var c="";var u="";var f="";var s="";var p={deepStrictEqual:"Expected values to be strictly deep-equal:",strictEqual:"Expected values to be strictly equal:",strictEqualObject:'Expected "actual" to be reference-equal to "expected":',deepEqual:"Expected values to be loosely deep-equal:",equal:"Expected values to be loosely equal:",notDeepStrictEqual:'Expected "actual" not to be strictly deep-equal to:',notStrictEqual:'Expected "actual" to be strictly unequal to:',notStrictEqualObject:'Expected "actual" not to be reference-equal to "expected":',notDeepEqual:'Expected "actual" not to be loosely deep-equal to:',notEqual:'Expected "actual" to be loosely unequal to:',notIdentical:"Values identical but not reference-equal:"};var l=10;function copyError(e){var t=Object.keys(e);var r=Object.create(Object.getPrototypeOf(e));t.forEach((function(t){r[t]=e[t]}));Object.defineProperty(r,"message",{value:e.message});return r}function inspectValue(e){return o(e,{compact:false,customInspect:false,depth:1e3,maxArrayLength:Infinity,showHidden:false,breakLength:Infinity,showProxy:false,sorted:true,getters:true})}function createErrDiff(e,t,r){var n="";var o="";var a=0;var i="";var y=false;var d=inspectValue(e);var g=d.split("\n");var v=inspectValue(t).split("\n");var b=0;var h="";if(r==="strictEqual"&&_typeof(e)==="object"&&_typeof(t)==="object"&&e!==null&&t!==null){r="strictEqualObject"}if(g.length===1&&v.length===1&&g[0]!==v[0]){var m=g[0].length+v[0].length;if(m<=l){if((_typeof(e)!=="object"||e===null)&&(_typeof(t)!=="object"||t===null)&&(e!==0||t!==0)){return"".concat(p[r],"\n\n")+"".concat(g[0]," !== ").concat(v[0],"\n")}}else if(r!=="strictEqualObject"){var A=process.stderr&&process.stderr.isTTY?process.stderr.columns:80;if(m<A){while(g[0][b]===v[0][b]){b++}if(b>2){h="\n  ".concat(repeat(" ",b),"^");b=0}}}}var S=g[g.length-1];var E=v[v.length-1];while(S===E){if(b++<2){i="\n  ".concat(S).concat(i)}else{n=S}g.pop();v.pop();if(g.length===0||v.length===0)break;S=g[g.length-1];E=v[v.length-1]}var P=Math.max(g.length,v.length);if(P===0){var w=d.split("\n");if(w.length>30){w[26]="".concat(c,"...").concat(s);while(w.length>27){w.pop()}}return"".concat(p.notIdentical,"\n\n").concat(w.join("\n"),"\n")}if(b>3){i="\n".concat(c,"...").concat(s).concat(i);y=true}if(n!==""){i="\n  ".concat(n).concat(i);n=""}var O=0;var j=p[r]+"\n".concat(u,"+ actual").concat(s," ").concat(f,"- expected").concat(s);var _=" ".concat(c,"...").concat(s," Lines skipped");for(b=0;b<P;b++){var x=b-a;if(g.length<b+1){if(x>1&&b>2){if(x>4){o+="\n".concat(c,"...").concat(s);y=true}else if(x>3){o+="\n  ".concat(v[b-2]);O++}o+="\n  ".concat(v[b-1]);O++}a=b;n+="\n".concat(f,"-").concat(s," ").concat(v[b]);O++}else if(v.length<b+1){if(x>1&&b>2){if(x>4){o+="\n".concat(c,"...").concat(s);y=true}else if(x>3){o+="\n  ".concat(g[b-2]);O++}o+="\n  ".concat(g[b-1]);O++}a=b;o+="\n".concat(u,"+").concat(s," ").concat(g[b]);O++}else{var I=v[b];var F=g[b];var k=F!==I&&(!endsWith(F,",")||F.slice(0,-1)!==I);if(k&&endsWith(I,",")&&I.slice(0,-1)===F){k=false;F+=","}if(k){if(x>1&&b>2){if(x>4){o+="\n".concat(c,"...").concat(s);y=true}else if(x>3){o+="\n  ".concat(g[b-2]);O++}o+="\n  ".concat(g[b-1]);O++}a=b;o+="\n".concat(u,"+").concat(s," ").concat(F);n+="\n".concat(f,"-").concat(s," ").concat(I);O+=2}else{o+=n;n="";if(x===1||b===0){o+="\n  ".concat(F);O++}}}if(O>20&&b<P-2){return"".concat(j).concat(_,"\n").concat(o,"\n").concat(c,"...").concat(s).concat(n,"\n")+"".concat(c,"...").concat(s)}}return"".concat(j).concat(y?_:"","\n").concat(o).concat(n).concat(i).concat(h)}var y=function(e){_inherits(AssertionError,e);function AssertionError(e){var t;_classCallCheck(this,AssertionError);if(_typeof(e)!=="object"||e===null){throw new i("options","Object",e)}var r=e.message,n=e.operator,o=e.stackStartFn;var a=e.actual,l=e.expected;var y=Error.stackTraceLimit;Error.stackTraceLimit=0;if(r!=null){t=_possibleConstructorReturn(this,_getPrototypeOf(AssertionError).call(this,String(r)))}else{if(process.stderr&&process.stderr.isTTY){if(process.stderr&&process.stderr.getColorDepth&&process.stderr.getColorDepth()!==1){c="[34m";u="[32m";s="[39m";f="[31m"}else{c="";u="";s="";f=""}}if(_typeof(a)==="object"&&a!==null&&_typeof(l)==="object"&&l!==null&&"stack"in a&&a instanceof Error&&"stack"in l&&l instanceof Error){a=copyError(a);l=copyError(l)}if(n==="deepStrictEqual"||n==="strictEqual"){t=_possibleConstructorReturn(this,_getPrototypeOf(AssertionError).call(this,createErrDiff(a,l,n)))}else if(n==="notDeepStrictEqual"||n==="notStrictEqual"){var d=p[n];var g=inspectValue(a).split("\n");if(n==="notStrictEqual"&&_typeof(a)==="object"&&a!==null){d=p.notStrictEqualObject}if(g.length>30){g[26]="".concat(c,"...").concat(s);while(g.length>27){g.pop()}}if(g.length===1){t=_possibleConstructorReturn(this,_getPrototypeOf(AssertionError).call(this,"".concat(d," ").concat(g[0])))}else{t=_possibleConstructorReturn(this,_getPrototypeOf(AssertionError).call(this,"".concat(d,"\n\n").concat(g.join("\n"),"\n")))}}else{var v=inspectValue(a);var b="";var h=p[n];if(n==="notDeepEqual"||n==="notEqual"){v="".concat(p[n],"\n\n").concat(v);if(v.length>1024){v="".concat(v.slice(0,1021),"...")}}else{b="".concat(inspectValue(l));if(v.length>512){v="".concat(v.slice(0,509),"...")}if(b.length>512){b="".concat(b.slice(0,509),"...")}if(n==="deepEqual"||n==="equal"){v="".concat(h,"\n\n").concat(v,"\n\nshould equal\n\n")}else{b=" ".concat(n," ").concat(b)}}t=_possibleConstructorReturn(this,_getPrototypeOf(AssertionError).call(this,"".concat(v).concat(b)))}}Error.stackTraceLimit=y;t.generatedMessage=!r;Object.defineProperty(_assertThisInitialized(t),"name",{value:"AssertionError [ERR_ASSERTION]",enumerable:false,writable:true,configurable:true});t.code="ERR_ASSERTION";t.actual=a;t.expected=l;t.operator=n;if(Error.captureStackTrace){Error.captureStackTrace(_assertThisInitialized(t),o)}t.stack;t.name="AssertionError";return _possibleConstructorReturn(t)}_createClass(AssertionError,[{key:"toString",value:function toString(){return"".concat(this.name," [").concat(this.code,"]: ").concat(this.message)}},{key:o.custom,value:function value(e,t){return o(this,_objectSpread({},t,{customInspect:false,depth:0}))}}]);return AssertionError}(_wrapNativeSuper(Error));e.exports=y},823:function(e,t,r){"use strict";function _typeof(e){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(e){return typeof e}}else{_typeof=function _typeof(e){return e&&typeof Symbol==="function"&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e}}return _typeof(e)}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _possibleConstructorReturn(e,t){if(t&&(_typeof(t)==="object"||typeof t==="function")){return t}return _assertThisInitialized(e)}function _assertThisInitialized(e){if(e===void 0){throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}return e}function _getPrototypeOf(e){_getPrototypeOf=Object.setPrototypeOf?Object.getPrototypeOf:function _getPrototypeOf(e){return e.__proto__||Object.getPrototypeOf(e)};return _getPrototypeOf(e)}function _inherits(e,t){if(typeof t!=="function"&&t!==null){throw new TypeError("Super expression must either be null or a function")}e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:true,configurable:true}});if(t)_setPrototypeOf(e,t)}function _setPrototypeOf(e,t){_setPrototypeOf=Object.setPrototypeOf||function _setPrototypeOf(e,t){e.__proto__=t;return e};return _setPrototypeOf(e,t)}var n={};var o;var a;function createErrorType(e,t,r){if(!r){r=Error}function getMessage(e,r,n){if(typeof t==="string"){return t}else{return t(e,r,n)}}var o=function(t){_inherits(NodeError,t);function NodeError(t,r,n){var o;_classCallCheck(this,NodeError);o=_possibleConstructorReturn(this,_getPrototypeOf(NodeError).call(this,getMessage(t,r,n)));o.code=e;return o}return NodeError}(r);n[e]=o}function oneOf(e,t){if(Array.isArray(e)){var r=e.length;e=e.map((function(e){return String(e)}));if(r>2){return"one of ".concat(t," ").concat(e.slice(0,r-1).join(", "),", or ")+e[r-1]}else if(r===2){return"one of ".concat(t," ").concat(e[0]," or ").concat(e[1])}else{return"of ".concat(t," ").concat(e[0])}}else{return"of ".concat(t," ").concat(String(e))}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_AMBIGUOUS_ARGUMENT",'The "%s" argument is ambiguous. %s',TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,n){if(o===undefined)o=r(313);o(typeof e==="string","'name' must be a string");var a;if(typeof t==="string"&&startsWith(t,"not ")){a="must not be";t=t.replace(/^not /,"")}else{a="must be"}var i;if(endsWith(e," argument")){i="The ".concat(e," ").concat(a," ").concat(oneOf(t,"type"))}else{var c=includes(e,".")?"property":"argument";i='The "'.concat(e,'" ').concat(c," ").concat(a," ").concat(oneOf(t,"type"))}i+=". Received type ".concat(_typeof(n));return i}),TypeError);createErrorType("ERR_INVALID_ARG_VALUE",(function(e,t){var n=arguments.length>2&&arguments[2]!==undefined?arguments[2]:"is invalid";if(a===undefined)a=r(650);var o=a.inspect(t);if(o.length>128){o="".concat(o.slice(0,128),"...")}return"The argument '".concat(e,"' ").concat(n,". Received ").concat(o)}),TypeError,RangeError);createErrorType("ERR_INVALID_RETURN_VALUE",(function(e,t,r){var n;if(r&&r.constructor&&r.constructor.name){n="instance of ".concat(r.constructor.name)}else{n="type ".concat(_typeof(r))}return"Expected ".concat(e,' to be returned from the "').concat(t,'"')+" function but got ".concat(n,".")}),TypeError);createErrorType("ERR_MISSING_ARGS",(function(){for(var e=arguments.length,t=new Array(e),n=0;n<e;n++){t[n]=arguments[n]}if(o===undefined)o=r(313);o(t.length>0,"At least one arg needs to be specified");var a="The ";var i=t.length;t=t.map((function(e){return'"'.concat(e,'"')}));switch(i){case 1:a+="".concat(t[0]," argument");break;case 2:a+="".concat(t[0]," and ").concat(t[1]," arguments");break;default:a+=t.slice(0,i-1).join(", ");a+=", and ".concat(t[i-1]," arguments");break}return"".concat(a," must be specified")}),TypeError);e.exports.codes=n},655:function(e,t,r){"use strict";function _slicedToArray(e,t){return _arrayWithHoles(e)||_iterableToArrayLimit(e,t)||_nonIterableRest()}function _nonIterableRest(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}function _iterableToArrayLimit(e,t){var r=[];var n=true;var o=false;var a=undefined;try{for(var i=e[Symbol.iterator](),c;!(n=(c=i.next()).done);n=true){r.push(c.value);if(t&&r.length===t)break}}catch(e){o=true;a=e}finally{try{if(!n&&i["return"]!=null)i["return"]()}finally{if(o)throw a}}return r}function _arrayWithHoles(e){if(Array.isArray(e))return e}function _typeof(e){if(typeof Symbol==="function"&&typeof Symbol.iterator==="symbol"){_typeof=function _typeof(e){return typeof e}}else{_typeof=function _typeof(e){return e&&typeof Symbol==="function"&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e}}return _typeof(e)}var n=/a/g.flags!==undefined;var o=function arrayFromSet(e){var t=[];e.forEach((function(e){return t.push(e)}));return t};var a=function arrayFromMap(e){var t=[];e.forEach((function(e,r){return t.push([r,e])}));return t};var i=Object.is?Object.is:r(450);var c=Object.getOwnPropertySymbols?Object.getOwnPropertySymbols:function(){return[]};var u=Number.isNaN?Number.isNaN:r(674);function uncurryThis(e){return e.call.bind(e)}var f=uncurryThis(Object.prototype.hasOwnProperty);var s=uncurryThis(Object.prototype.propertyIsEnumerable);var p=uncurryThis(Object.prototype.toString);var l=r(650).types,y=l.isAnyArrayBuffer,d=l.isArrayBufferView,g=l.isDate,v=l.isMap,b=l.isRegExp,h=l.isSet,m=l.isNativeError,A=l.isBoxedPrimitive,S=l.isNumberObject,E=l.isStringObject,P=l.isBooleanObject,w=l.isBigIntObject,O=l.isSymbolObject,j=l.isFloat32Array,_=l.isFloat64Array;function isNonIndex(e){if(e.length===0||e.length>10)return true;for(var t=0;t<e.length;t++){var r=e.charCodeAt(t);if(r<48||r>57)return true}return e.length===10&&e>=Math.pow(2,32)}function getOwnNonIndexProperties(e){return Object.keys(e).filter(isNonIndex).concat(c(e).filter(Object.prototype.propertyIsEnumerable.bind(e)))}
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */function compare(e,t){if(e===t){return 0}var r=e.length;var n=t.length;for(var o=0,a=Math.min(r,n);o<a;++o){if(e[o]!==t[o]){r=e[o];n=t[o];break}}if(r<n){return-1}if(n<r){return 1}return 0}var x=undefined;var I=true;var F=false;var k=0;var R=1;var T=2;var N=3;function areSimilarRegExps(e,t){return n?e.source===t.source&&e.flags===t.flags:RegExp.prototype.toString.call(e)===RegExp.prototype.toString.call(t)}function areSimilarFloatArrays(e,t){if(e.byteLength!==t.byteLength){return false}for(var r=0;r<e.byteLength;r++){if(e[r]!==t[r]){return false}}return true}function areSimilarTypedArrays(e,t){if(e.byteLength!==t.byteLength){return false}return compare(new Uint8Array(e.buffer,e.byteOffset,e.byteLength),new Uint8Array(t.buffer,t.byteOffset,t.byteLength))===0}function areEqualArrayBuffers(e,t){return e.byteLength===t.byteLength&&compare(new Uint8Array(e),new Uint8Array(t))===0}function isEqualBoxedPrimitive(e,t){if(S(e)){return S(t)&&i(Number.prototype.valueOf.call(e),Number.prototype.valueOf.call(t))}if(E(e)){return E(t)&&String.prototype.valueOf.call(e)===String.prototype.valueOf.call(t)}if(P(e)){return P(t)&&Boolean.prototype.valueOf.call(e)===Boolean.prototype.valueOf.call(t)}if(w(e)){return w(t)&&BigInt.prototype.valueOf.call(e)===BigInt.prototype.valueOf.call(t)}return O(t)&&Symbol.prototype.valueOf.call(e)===Symbol.prototype.valueOf.call(t)}function innerDeepEqual(e,t,r,n){if(e===t){if(e!==0)return true;return r?i(e,t):true}if(r){if(_typeof(e)!=="object"){return typeof e==="number"&&u(e)&&u(t)}if(_typeof(t)!=="object"||e===null||t===null){return false}if(Object.getPrototypeOf(e)!==Object.getPrototypeOf(t)){return false}}else{if(e===null||_typeof(e)!=="object"){if(t===null||_typeof(t)!=="object"){return e==t}return false}if(t===null||_typeof(t)!=="object"){return false}}var o=p(e);var a=p(t);if(o!==a){return false}if(Array.isArray(e)){if(e.length!==t.length){return false}var c=getOwnNonIndexProperties(e,x);var f=getOwnNonIndexProperties(t,x);if(c.length!==f.length){return false}return keyCheck(e,t,r,n,R,c)}if(o==="[object Object]"){if(!v(e)&&v(t)||!h(e)&&h(t)){return false}}if(g(e)){if(!g(t)||Date.prototype.getTime.call(e)!==Date.prototype.getTime.call(t)){return false}}else if(b(e)){if(!b(t)||!areSimilarRegExps(e,t)){return false}}else if(m(e)||e instanceof Error){if(e.message!==t.message||e.name!==t.name){return false}}else if(d(e)){if(!r&&(j(e)||_(e))){if(!areSimilarFloatArrays(e,t)){return false}}else if(!areSimilarTypedArrays(e,t)){return false}var s=getOwnNonIndexProperties(e,x);var l=getOwnNonIndexProperties(t,x);if(s.length!==l.length){return false}return keyCheck(e,t,r,n,k,s)}else if(h(e)){if(!h(t)||e.size!==t.size){return false}return keyCheck(e,t,r,n,T)}else if(v(e)){if(!v(t)||e.size!==t.size){return false}return keyCheck(e,t,r,n,N)}else if(y(e)){if(!areEqualArrayBuffers(e,t)){return false}}else if(A(e)&&!isEqualBoxedPrimitive(e,t)){return false}return keyCheck(e,t,r,n,k)}function getEnumerables(e,t){return t.filter((function(t){return s(e,t)}))}function keyCheck(e,t,r,n,o,a){if(arguments.length===5){a=Object.keys(e);var i=Object.keys(t);if(a.length!==i.length){return false}}var u=0;for(;u<a.length;u++){if(!f(t,a[u])){return false}}if(r&&arguments.length===5){var p=c(e);if(p.length!==0){var l=0;for(u=0;u<p.length;u++){var y=p[u];if(s(e,y)){if(!s(t,y)){return false}a.push(y);l++}else if(s(t,y)){return false}}var d=c(t);if(p.length!==d.length&&getEnumerables(t,d).length!==l){return false}}else{var g=c(t);if(g.length!==0&&getEnumerables(t,g).length!==0){return false}}}if(a.length===0&&(o===k||o===R&&e.length===0||e.size===0)){return true}if(n===undefined){n={val1:new Map,val2:new Map,position:0}}else{var v=n.val1.get(e);if(v!==undefined){var b=n.val2.get(t);if(b!==undefined){return v===b}}n.position++}n.val1.set(e,n.position);n.val2.set(t,n.position);var h=objEquiv(e,t,r,a,n,o);n.val1.delete(e);n.val2.delete(t);return h}function setHasEqualElement(e,t,r,n){var a=o(e);for(var i=0;i<a.length;i++){var c=a[i];if(innerDeepEqual(t,c,r,n)){e.delete(c);return true}}return false}function findLooseMatchingPrimitives(e){switch(_typeof(e)){case"undefined":return null;case"object":return undefined;case"symbol":return false;case"string":e=+e;case"number":if(u(e)){return false}}return true}function setMightHaveLoosePrim(e,t,r){var n=findLooseMatchingPrimitives(r);if(n!=null)return n;return t.has(n)&&!e.has(n)}function mapMightHaveLoosePrim(e,t,r,n,o){var a=findLooseMatchingPrimitives(r);if(a!=null){return a}var i=t.get(a);if(i===undefined&&!t.has(a)||!innerDeepEqual(n,i,false,o)){return false}return!e.has(a)&&innerDeepEqual(n,i,false,o)}function setEquiv(e,t,r,n){var a=null;var i=o(e);for(var c=0;c<i.length;c++){var u=i[c];if(_typeof(u)==="object"&&u!==null){if(a===null){a=new Set}a.add(u)}else if(!t.has(u)){if(r)return false;if(!setMightHaveLoosePrim(e,t,u)){return false}if(a===null){a=new Set}a.add(u)}}if(a!==null){var f=o(t);for(var s=0;s<f.length;s++){var p=f[s];if(_typeof(p)==="object"&&p!==null){if(!setHasEqualElement(a,p,r,n))return false}else if(!r&&!e.has(p)&&!setHasEqualElement(a,p,r,n)){return false}}return a.size===0}return true}function mapHasEqualEntry(e,t,r,n,a,i){var c=o(e);for(var u=0;u<c.length;u++){var f=c[u];if(innerDeepEqual(r,f,a,i)&&innerDeepEqual(n,t.get(f),a,i)){e.delete(f);return true}}return false}function mapEquiv(e,t,r,n){var o=null;var i=a(e);for(var c=0;c<i.length;c++){var u=_slicedToArray(i[c],2),f=u[0],s=u[1];if(_typeof(f)==="object"&&f!==null){if(o===null){o=new Set}o.add(f)}else{var p=t.get(f);if(p===undefined&&!t.has(f)||!innerDeepEqual(s,p,r,n)){if(r)return false;if(!mapMightHaveLoosePrim(e,t,f,s,n))return false;if(o===null){o=new Set}o.add(f)}}}if(o!==null){var l=a(t);for(var y=0;y<l.length;y++){var d=_slicedToArray(l[y],2),f=d[0],g=d[1];if(_typeof(f)==="object"&&f!==null){if(!mapHasEqualEntry(o,e,f,g,r,n))return false}else if(!r&&(!e.has(f)||!innerDeepEqual(e.get(f),g,false,n))&&!mapHasEqualEntry(o,e,f,g,false,n)){return false}}return o.size===0}return true}function objEquiv(e,t,r,n,o,a){var i=0;if(a===T){if(!setEquiv(e,t,r,o)){return false}}else if(a===N){if(!mapEquiv(e,t,r,o)){return false}}else if(a===R){for(;i<e.length;i++){if(f(e,i)){if(!f(t,i)||!innerDeepEqual(e[i],t[i],r,o)){return false}}else if(f(t,i)){return false}else{var c=Object.keys(e);for(;i<c.length;i++){var u=c[i];if(!f(t,u)||!innerDeepEqual(e[u],t[u],r,o)){return false}}if(c.length!==Object.keys(t).length){return false}return true}}}for(i=0;i<n.length;i++){var s=n[i];if(!innerDeepEqual(e[s],t[s],r,o)){return false}}return true}function isDeepEqual(e,t){return innerDeepEqual(e,t,F)}function isDeepStrictEqual(e,t){return innerDeepEqual(e,t,I)}e.exports={isDeepEqual:isDeepEqual,isDeepStrictEqual:isDeepStrictEqual}},749:function(e,t,r){"use strict";var n=r(91);var o=r(112);var a=o(n("String.prototype.indexOf"));e.exports=function callBoundIntrinsic(e,t){var r=n(e,!!t);if(typeof r==="function"&&a(e,".prototype.")>-1){return o(r)}return r}},112:function(e,t,r){"use strict";var n=r(517);var o=r(91);var a=o("%Function.prototype.apply%");var i=o("%Function.prototype.call%");var c=o("%Reflect.apply%",true)||n.call(i,a);var u=o("%Object.getOwnPropertyDescriptor%",true);var f=o("%Object.defineProperty%",true);var s=o("%Math.max%");if(f){try{f({},"a",{value:1})}catch(e){f=null}}e.exports=function callBind(e){var t=c(n,i,arguments);if(u&&f){var r=u(t,"length");if(r.configurable){f(t,"length",{value:1+s(0,e.length-(arguments.length-1))})}}return t};var p=function applyBind(){return c(n,a,arguments)};if(f){f(e.exports,"apply",{value:p})}else{e.exports.apply=p}},91:function(e,t,r){"use strict";var n;var o=SyntaxError;var a=Function;var i=TypeError;var getEvalledConstructor=function(e){try{return Function('"use strict"; return ('+e+").constructor;")()}catch(e){}};var c=Object.getOwnPropertyDescriptor;if(c){try{c({},"")}catch(e){c=null}}var throwTypeError=function(){throw new i};var u=c?function(){try{arguments.callee;return throwTypeError}catch(e){try{return c(arguments,"callee").get}catch(e){return throwTypeError}}}():throwTypeError;var f=r(449)();var s=Object.getPrototypeOf||function(e){return e.__proto__};var p=getEvalledConstructor("async function* () {}");var l=p?p.prototype:n;var y=l?l.prototype:n;var d=typeof Uint8Array==="undefined"?n:s(Uint8Array);var g={"%AggregateError%":typeof AggregateError==="undefined"?n:AggregateError,"%Array%":Array,"%ArrayBuffer%":typeof ArrayBuffer==="undefined"?n:ArrayBuffer,"%ArrayIteratorPrototype%":f?s([][Symbol.iterator]()):n,"%AsyncFromSyncIteratorPrototype%":n,"%AsyncFunction%":getEvalledConstructor("async function () {}"),"%AsyncGenerator%":l,"%AsyncGeneratorFunction%":p,"%AsyncIteratorPrototype%":y?s(y):n,"%Atomics%":typeof Atomics==="undefined"?n:Atomics,"%BigInt%":typeof BigInt==="undefined"?n:BigInt,"%Boolean%":Boolean,"%DataView%":typeof DataView==="undefined"?n:DataView,"%Date%":Date,"%decodeURI%":decodeURI,"%decodeURIComponent%":decodeURIComponent,"%encodeURI%":encodeURI,"%encodeURIComponent%":encodeURIComponent,"%Error%":Error,"%eval%":eval,"%EvalError%":EvalError,"%Float32Array%":typeof Float32Array==="undefined"?n:Float32Array,"%Float64Array%":typeof Float64Array==="undefined"?n:Float64Array,"%FinalizationRegistry%":typeof FinalizationRegistry==="undefined"?n:FinalizationRegistry,"%Function%":a,"%GeneratorFunction%":getEvalledConstructor("function* () {}"),"%Int8Array%":typeof Int8Array==="undefined"?n:Int8Array,"%Int16Array%":typeof Int16Array==="undefined"?n:Int16Array,"%Int32Array%":typeof Int32Array==="undefined"?n:Int32Array,"%isFinite%":isFinite,"%isNaN%":isNaN,"%IteratorPrototype%":f?s(s([][Symbol.iterator]())):n,"%JSON%":typeof JSON==="object"?JSON:n,"%Map%":typeof Map==="undefined"?n:Map,"%MapIteratorPrototype%":typeof Map==="undefined"||!f?n:s((new Map)[Symbol.iterator]()),"%Math%":Math,"%Number%":Number,"%Object%":Object,"%parseFloat%":parseFloat,"%parseInt%":parseInt,"%Promise%":typeof Promise==="undefined"?n:Promise,"%Proxy%":typeof Proxy==="undefined"?n:Proxy,"%RangeError%":RangeError,"%ReferenceError%":ReferenceError,"%Reflect%":typeof Reflect==="undefined"?n:Reflect,"%RegExp%":RegExp,"%Set%":typeof Set==="undefined"?n:Set,"%SetIteratorPrototype%":typeof Set==="undefined"||!f?n:s((new Set)[Symbol.iterator]()),"%SharedArrayBuffer%":typeof SharedArrayBuffer==="undefined"?n:SharedArrayBuffer,"%String%":String,"%StringIteratorPrototype%":f?s(""[Symbol.iterator]()):n,"%Symbol%":f?Symbol:n,"%SyntaxError%":o,"%ThrowTypeError%":u,"%TypedArray%":d,"%TypeError%":i,"%Uint8Array%":typeof Uint8Array==="undefined"?n:Uint8Array,"%Uint8ClampedArray%":typeof Uint8ClampedArray==="undefined"?n:Uint8ClampedArray,"%Uint16Array%":typeof Uint16Array==="undefined"?n:Uint16Array,"%Uint32Array%":typeof Uint32Array==="undefined"?n:Uint32Array,"%URIError%":URIError,"%WeakMap%":typeof WeakMap==="undefined"?n:WeakMap,"%WeakRef%":typeof WeakRef==="undefined"?n:WeakRef,"%WeakSet%":typeof WeakSet==="undefined"?n:WeakSet};var v={"%ArrayBufferPrototype%":["ArrayBuffer","prototype"],"%ArrayPrototype%":["Array","prototype"],"%ArrayProto_entries%":["Array","prototype","entries"],"%ArrayProto_forEach%":["Array","prototype","forEach"],"%ArrayProto_keys%":["Array","prototype","keys"],"%ArrayProto_values%":["Array","prototype","values"],"%AsyncFunctionPrototype%":["AsyncFunction","prototype"],"%AsyncGenerator%":["AsyncGeneratorFunction","prototype"],"%AsyncGeneratorPrototype%":["AsyncGeneratorFunction","prototype","prototype"],"%BooleanPrototype%":["Boolean","prototype"],"%DataViewPrototype%":["DataView","prototype"],"%DatePrototype%":["Date","prototype"],"%ErrorPrototype%":["Error","prototype"],"%EvalErrorPrototype%":["EvalError","prototype"],"%Float32ArrayPrototype%":["Float32Array","prototype"],"%Float64ArrayPrototype%":["Float64Array","prototype"],"%FunctionPrototype%":["Function","prototype"],"%Generator%":["GeneratorFunction","prototype"],"%GeneratorPrototype%":["GeneratorFunction","prototype","prototype"],"%Int8ArrayPrototype%":["Int8Array","prototype"],"%Int16ArrayPrototype%":["Int16Array","prototype"],"%Int32ArrayPrototype%":["Int32Array","prototype"],"%JSONParse%":["JSON","parse"],"%JSONStringify%":["JSON","stringify"],"%MapPrototype%":["Map","prototype"],"%NumberPrototype%":["Number","prototype"],"%ObjectPrototype%":["Object","prototype"],"%ObjProto_toString%":["Object","prototype","toString"],"%ObjProto_valueOf%":["Object","prototype","valueOf"],"%PromisePrototype%":["Promise","prototype"],"%PromiseProto_then%":["Promise","prototype","then"],"%Promise_all%":["Promise","all"],"%Promise_reject%":["Promise","reject"],"%Promise_resolve%":["Promise","resolve"],"%RangeErrorPrototype%":["RangeError","prototype"],"%ReferenceErrorPrototype%":["ReferenceError","prototype"],"%RegExpPrototype%":["RegExp","prototype"],"%SetPrototype%":["Set","prototype"],"%SharedArrayBufferPrototype%":["SharedArrayBuffer","prototype"],"%StringPrototype%":["String","prototype"],"%SymbolPrototype%":["Symbol","prototype"],"%SyntaxErrorPrototype%":["SyntaxError","prototype"],"%TypedArrayPrototype%":["TypedArray","prototype"],"%TypeErrorPrototype%":["TypeError","prototype"],"%Uint8ArrayPrototype%":["Uint8Array","prototype"],"%Uint8ClampedArrayPrototype%":["Uint8ClampedArray","prototype"],"%Uint16ArrayPrototype%":["Uint16Array","prototype"],"%Uint32ArrayPrototype%":["Uint32Array","prototype"],"%URIErrorPrototype%":["URIError","prototype"],"%WeakMapPrototype%":["WeakMap","prototype"],"%WeakSetPrototype%":["WeakSet","prototype"]};var b=r(517);var h=r(793);var m=b.call(Function.call,Array.prototype.concat);var A=b.call(Function.apply,Array.prototype.splice);var S=b.call(Function.call,String.prototype.replace);var E=b.call(Function.call,String.prototype.slice);var P=/[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;var w=/\\(\\)?/g;var O=function stringToPath(e){var t=E(e,0,1);var r=E(e,-1);if(t==="%"&&r!=="%"){throw new o("invalid intrinsic syntax, expected closing `%`")}else if(r==="%"&&t!=="%"){throw new o("invalid intrinsic syntax, expected opening `%`")}var n=[];S(e,P,(function(e,t,r,o){n[n.length]=r?S(o,w,"$1"):t||e}));return n};var j=function getBaseIntrinsic(e,t){var r=e;var n;if(h(v,r)){n=v[r];r="%"+n[0]+"%"}if(h(g,r)){var a=g[r];if(typeof a==="undefined"&&!t){throw new i("intrinsic "+e+" exists, but is not available. Please file an issue!")}return{alias:n,name:r,value:a}}throw new o("intrinsic "+e+" does not exist!")};e.exports=function GetIntrinsic(e,t){if(typeof e!=="string"||e.length===0){throw new i("intrinsic name must be a non-empty string")}if(arguments.length>1&&typeof t!=="boolean"){throw new i('"allowMissing" argument must be a boolean')}var r=O(e);var a=r.length>0?r[0]:"";var u=j("%"+a+"%",t);var f=u.name;var s=u.value;var p=false;var l=u.alias;if(l){a=l[0];A(r,m([0,1],l))}for(var y=1,d=true;y<r.length;y+=1){var v=r[y];var b=E(v,0,1);var S=E(v,-1);if((b==='"'||b==="'"||b==="`"||(S==='"'||S==="'"||S==="`"))&&b!==S){throw new o("property names with quotes must have matching quotes")}if(v==="constructor"||!d){p=true}a+="."+v;f="%"+a+"%";if(h(g,f)){s=g[f]}else if(s!=null){if(!(v in s)){if(!t){throw new i("base intrinsic for "+e+" exists, but the property is not available.")}return void n}if(c&&y+1>=r.length){var P=c(s,v);d=!!P;if(d&&"get"in P&&!("originalValue"in P.get)){s=P.get}else{s=s[v]}}else{d=h(s,v);s=s[v]}if(d&&!p){g[f]=s}}}return s}},961:function(e,t,r){"use strict";var n=r(283);var o=typeof Symbol==="function"&&typeof Symbol("foo")==="symbol";var a=Object.prototype.toString;var i=Array.prototype.concat;var c=Object.defineProperty;var isFunction=function(e){return typeof e==="function"&&a.call(e)==="[object Function]"};var arePropertyDescriptorsSupported=function(){var e={};try{c(e,"x",{enumerable:false,value:e});for(var t in e){return false}return e.x===e}catch(e){return false}};var u=c&&arePropertyDescriptorsSupported();var defineProperty=function(e,t,r,n){if(t in e&&(!isFunction(n)||!n())){return}if(u){c(e,t,{configurable:true,enumerable:false,value:r,writable:true})}else{e[t]=r}};var defineProperties=function(e,t){var r=arguments.length>2?arguments[2]:{};var a=n(t);if(o){a=i.call(a,Object.getOwnPropertySymbols(t))}for(var c=0;c<a.length;c+=1){defineProperty(e,a[c],t[a[c]],r[a[c]])}};defineProperties.supportsDescriptors=!!u;e.exports=defineProperties},274:function(e){"use strict";function assign(e,t){if(e===undefined||e===null){throw new TypeError("Cannot convert first argument to object")}var r=Object(e);for(var n=1;n<arguments.length;n++){var o=arguments[n];if(o===undefined||o===null){continue}var a=Object.keys(Object(o));for(var i=0,c=a.length;i<c;i++){var u=a[i];var f=Object.getOwnPropertyDescriptor(o,u);if(f!==undefined&&f.enumerable){r[u]=o[u]}}}return r}function polyfill(){if(!Object.assign){Object.defineProperty(Object,"assign",{enumerable:false,configurable:true,writable:true,value:assign})}}e.exports={assign:assign,polyfill:polyfill}},219:function(e){var t=Object.prototype.hasOwnProperty;var r=Object.prototype.toString;e.exports=function forEach(e,n,o){if(r.call(n)!=="[object Function]"){throw new TypeError("iterator must be a function")}var a=e.length;if(a===+a){for(var i=0;i<a;i++){n.call(o,e[i],i,e)}}else{for(var c in e){if(t.call(e,c)){n.call(o,e[c],c,e)}}}}},733:function(e){"use strict";var t="Function.prototype.bind called on incompatible ";var r=Array.prototype.slice;var n=Object.prototype.toString;var o="[object Function]";e.exports=function bind(e){var a=this;if(typeof a!=="function"||n.call(a)!==o){throw new TypeError(t+a)}var i=r.call(arguments,1);var c;var binder=function(){if(this instanceof c){var t=a.apply(this,i.concat(r.call(arguments)));if(Object(t)===t){return t}return this}else{return a.apply(e,i.concat(r.call(arguments)))}};var u=Math.max(0,a.length-i.length);var f=[];for(var s=0;s<u;s++){f.push("$"+s)}c=Function("binder","return function ("+f.join(",")+"){ return binder.apply(this,arguments); }")(binder);if(a.prototype){var p=function Empty(){};p.prototype=a.prototype;c.prototype=new p;p.prototype=null}return c}},517:function(e,t,r){"use strict";var n=r(733);e.exports=Function.prototype.bind||n},879:function(e,t,r){"use strict";var n;var o=SyntaxError;var a=Function;var i=TypeError;var getEvalledConstructor=function(e){try{return a('"use strict"; return ('+e+").constructor;")()}catch(e){}};var c=Object.getOwnPropertyDescriptor;if(c){try{c({},"")}catch(e){c=null}}var throwTypeError=function(){throw new i};var u=c?function(){try{arguments.callee;return throwTypeError}catch(e){try{return c(arguments,"callee").get}catch(e){return throwTypeError}}}():throwTypeError;var f=r(449)();var s=Object.getPrototypeOf||function(e){return e.__proto__};var p={};var l=typeof Uint8Array==="undefined"?n:s(Uint8Array);var y={"%AggregateError%":typeof AggregateError==="undefined"?n:AggregateError,"%Array%":Array,"%ArrayBuffer%":typeof ArrayBuffer==="undefined"?n:ArrayBuffer,"%ArrayIteratorPrototype%":f?s([][Symbol.iterator]()):n,"%AsyncFromSyncIteratorPrototype%":n,"%AsyncFunction%":p,"%AsyncGenerator%":p,"%AsyncGeneratorFunction%":p,"%AsyncIteratorPrototype%":p,"%Atomics%":typeof Atomics==="undefined"?n:Atomics,"%BigInt%":typeof BigInt==="undefined"?n:BigInt,"%Boolean%":Boolean,"%DataView%":typeof DataView==="undefined"?n:DataView,"%Date%":Date,"%decodeURI%":decodeURI,"%decodeURIComponent%":decodeURIComponent,"%encodeURI%":encodeURI,"%encodeURIComponent%":encodeURIComponent,"%Error%":Error,"%eval%":eval,"%EvalError%":EvalError,"%Float32Array%":typeof Float32Array==="undefined"?n:Float32Array,"%Float64Array%":typeof Float64Array==="undefined"?n:Float64Array,"%FinalizationRegistry%":typeof FinalizationRegistry==="undefined"?n:FinalizationRegistry,"%Function%":a,"%GeneratorFunction%":p,"%Int8Array%":typeof Int8Array==="undefined"?n:Int8Array,"%Int16Array%":typeof Int16Array==="undefined"?n:Int16Array,"%Int32Array%":typeof Int32Array==="undefined"?n:Int32Array,"%isFinite%":isFinite,"%isNaN%":isNaN,"%IteratorPrototype%":f?s(s([][Symbol.iterator]())):n,"%JSON%":typeof JSON==="object"?JSON:n,"%Map%":typeof Map==="undefined"?n:Map,"%MapIteratorPrototype%":typeof Map==="undefined"||!f?n:s((new Map)[Symbol.iterator]()),"%Math%":Math,"%Number%":Number,"%Object%":Object,"%parseFloat%":parseFloat,"%parseInt%":parseInt,"%Promise%":typeof Promise==="undefined"?n:Promise,"%Proxy%":typeof Proxy==="undefined"?n:Proxy,"%RangeError%":RangeError,"%ReferenceError%":ReferenceError,"%Reflect%":typeof Reflect==="undefined"?n:Reflect,"%RegExp%":RegExp,"%Set%":typeof Set==="undefined"?n:Set,"%SetIteratorPrototype%":typeof Set==="undefined"||!f?n:s((new Set)[Symbol.iterator]()),"%SharedArrayBuffer%":typeof SharedArrayBuffer==="undefined"?n:SharedArrayBuffer,"%String%":String,"%StringIteratorPrototype%":f?s(""[Symbol.iterator]()):n,"%Symbol%":f?Symbol:n,"%SyntaxError%":o,"%ThrowTypeError%":u,"%TypedArray%":l,"%TypeError%":i,"%Uint8Array%":typeof Uint8Array==="undefined"?n:Uint8Array,"%Uint8ClampedArray%":typeof Uint8ClampedArray==="undefined"?n:Uint8ClampedArray,"%Uint16Array%":typeof Uint16Array==="undefined"?n:Uint16Array,"%Uint32Array%":typeof Uint32Array==="undefined"?n:Uint32Array,"%URIError%":URIError,"%WeakMap%":typeof WeakMap==="undefined"?n:WeakMap,"%WeakRef%":typeof WeakRef==="undefined"?n:WeakRef,"%WeakSet%":typeof WeakSet==="undefined"?n:WeakSet};var d=function doEval(e){var t;if(e==="%AsyncFunction%"){t=getEvalledConstructor("async function () {}")}else if(e==="%GeneratorFunction%"){t=getEvalledConstructor("function* () {}")}else if(e==="%AsyncGeneratorFunction%"){t=getEvalledConstructor("async function* () {}")}else if(e==="%AsyncGenerator%"){var r=doEval("%AsyncGeneratorFunction%");if(r){t=r.prototype}}else if(e==="%AsyncIteratorPrototype%"){var n=doEval("%AsyncGenerator%");if(n){t=s(n.prototype)}}y[e]=t;return t};var g={"%ArrayBufferPrototype%":["ArrayBuffer","prototype"],"%ArrayPrototype%":["Array","prototype"],"%ArrayProto_entries%":["Array","prototype","entries"],"%ArrayProto_forEach%":["Array","prototype","forEach"],"%ArrayProto_keys%":["Array","prototype","keys"],"%ArrayProto_values%":["Array","prototype","values"],"%AsyncFunctionPrototype%":["AsyncFunction","prototype"],"%AsyncGenerator%":["AsyncGeneratorFunction","prototype"],"%AsyncGeneratorPrototype%":["AsyncGeneratorFunction","prototype","prototype"],"%BooleanPrototype%":["Boolean","prototype"],"%DataViewPrototype%":["DataView","prototype"],"%DatePrototype%":["Date","prototype"],"%ErrorPrototype%":["Error","prototype"],"%EvalErrorPrototype%":["EvalError","prototype"],"%Float32ArrayPrototype%":["Float32Array","prototype"],"%Float64ArrayPrototype%":["Float64Array","prototype"],"%FunctionPrototype%":["Function","prototype"],"%Generator%":["GeneratorFunction","prototype"],"%GeneratorPrototype%":["GeneratorFunction","prototype","prototype"],"%Int8ArrayPrototype%":["Int8Array","prototype"],"%Int16ArrayPrototype%":["Int16Array","prototype"],"%Int32ArrayPrototype%":["Int32Array","prototype"],"%JSONParse%":["JSON","parse"],"%JSONStringify%":["JSON","stringify"],"%MapPrototype%":["Map","prototype"],"%NumberPrototype%":["Number","prototype"],"%ObjectPrototype%":["Object","prototype"],"%ObjProto_toString%":["Object","prototype","toString"],"%ObjProto_valueOf%":["Object","prototype","valueOf"],"%PromisePrototype%":["Promise","prototype"],"%PromiseProto_then%":["Promise","prototype","then"],"%Promise_all%":["Promise","all"],"%Promise_reject%":["Promise","reject"],"%Promise_resolve%":["Promise","resolve"],"%RangeErrorPrototype%":["RangeError","prototype"],"%ReferenceErrorPrototype%":["ReferenceError","prototype"],"%RegExpPrototype%":["RegExp","prototype"],"%SetPrototype%":["Set","prototype"],"%SharedArrayBufferPrototype%":["SharedArrayBuffer","prototype"],"%StringPrototype%":["String","prototype"],"%SymbolPrototype%":["Symbol","prototype"],"%SyntaxErrorPrototype%":["SyntaxError","prototype"],"%TypedArrayPrototype%":["TypedArray","prototype"],"%TypeErrorPrototype%":["TypeError","prototype"],"%Uint8ArrayPrototype%":["Uint8Array","prototype"],"%Uint8ClampedArrayPrototype%":["Uint8ClampedArray","prototype"],"%Uint16ArrayPrototype%":["Uint16Array","prototype"],"%Uint32ArrayPrototype%":["Uint32Array","prototype"],"%URIErrorPrototype%":["URIError","prototype"],"%WeakMapPrototype%":["WeakMap","prototype"],"%WeakSetPrototype%":["WeakSet","prototype"]};var v=r(517);var b=r(793);var h=v.call(Function.call,Array.prototype.concat);var m=v.call(Function.apply,Array.prototype.splice);var A=v.call(Function.call,String.prototype.replace);var S=v.call(Function.call,String.prototype.slice);var E=/[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;var P=/\\(\\)?/g;var w=function stringToPath(e){var t=S(e,0,1);var r=S(e,-1);if(t==="%"&&r!=="%"){throw new o("invalid intrinsic syntax, expected closing `%`")}else if(r==="%"&&t!=="%"){throw new o("invalid intrinsic syntax, expected opening `%`")}var n=[];A(e,E,(function(e,t,r,o){n[n.length]=r?A(o,P,"$1"):t||e}));return n};var O=function getBaseIntrinsic(e,t){var r=e;var n;if(b(g,r)){n=g[r];r="%"+n[0]+"%"}if(b(y,r)){var a=y[r];if(a===p){a=d(r)}if(typeof a==="undefined"&&!t){throw new i("intrinsic "+e+" exists, but is not available. Please file an issue!")}return{alias:n,name:r,value:a}}throw new o("intrinsic "+e+" does not exist!")};e.exports=function GetIntrinsic(e,t){if(typeof e!=="string"||e.length===0){throw new i("intrinsic name must be a non-empty string")}if(arguments.length>1&&typeof t!=="boolean"){throw new i('"allowMissing" argument must be a boolean')}var r=w(e);var a=r.length>0?r[0]:"";var u=O("%"+a+"%",t);var f=u.name;var s=u.value;var p=false;var l=u.alias;if(l){a=l[0];m(r,h([0,1],l))}for(var d=1,g=true;d<r.length;d+=1){var v=r[d];var A=S(v,0,1);var E=S(v,-1);if((A==='"'||A==="'"||A==="`"||(E==='"'||E==="'"||E==="`"))&&A!==E){throw new o("property names with quotes must have matching quotes")}if(v==="constructor"||!g){p=true}a+="."+v;f="%"+a+"%";if(b(y,f)){s=y[f]}else if(s!=null){if(!(v in s)){if(!t){throw new i("base intrinsic for "+e+" exists, but the property is not available.")}return void n}if(c&&d+1>=r.length){var P=c(s,v);g=!!P;if(g&&"get"in P&&!("originalValue"in P.get)){s=P.get}else{s=s[v]}}else{g=b(s,v);s=s[v]}if(g&&!p){y[f]=s}}}return s}},449:function(e,t,r){"use strict";var n=__webpack_require__.g.Symbol;var o=r(545);e.exports=function hasNativeSymbols(){if(typeof n!=="function"){return false}if(typeof Symbol!=="function"){return false}if(typeof n("foo")!=="symbol"){return false}if(typeof Symbol("bar")!=="symbol"){return false}return o()}},545:function(e){"use strict";e.exports=function hasSymbols(){if(typeof Symbol!=="function"||typeof Object.getOwnPropertySymbols!=="function"){return false}if(typeof Symbol.iterator==="symbol"){return true}var e={};var t=Symbol("test");var r=Object(t);if(typeof t==="string"){return false}if(Object.prototype.toString.call(t)!=="[object Symbol]"){return false}if(Object.prototype.toString.call(r)!=="[object Symbol]"){return false}var n=42;e[t]=n;for(t in e){return false}if(typeof Object.keys==="function"&&Object.keys(e).length!==0){return false}if(typeof Object.getOwnPropertyNames==="function"&&Object.getOwnPropertyNames(e).length!==0){return false}var o=Object.getOwnPropertySymbols(e);if(o.length!==1||o[0]!==t){return false}if(!Object.prototype.propertyIsEnumerable.call(e,t)){return false}if(typeof Object.getOwnPropertyDescriptor==="function"){var a=Object.getOwnPropertyDescriptor(e,t);if(a.value!==n||a.enumerable!==true){return false}}return true}},793:function(e,t,r){"use strict";var n=r(517);e.exports=n.call(Function.call,Object.prototype.hasOwnProperty)},526:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},312:function(e){"use strict";var t=typeof Symbol==="function"&&typeof Symbol.toStringTag==="symbol";var r=Object.prototype.toString;var n=function isArguments(e){if(t&&e&&typeof e==="object"&&Symbol.toStringTag in e){return false}return r.call(e)==="[object Arguments]"};var o=function isArguments(e){if(n(e)){return true}return e!==null&&typeof e==="object"&&typeof e.length==="number"&&e.length>=0&&r.call(e)!=="[object Array]"&&r.call(e.callee)==="[object Function]"};var a=function(){return n(arguments)}();n.isLegacyArguments=o;e.exports=a?n:o},906:function(e){"use strict";var t=Object.prototype.toString;var r=Function.prototype.toString;var n=/^\s*(?:function)?\*/;var o=typeof Symbol==="function"&&typeof Symbol.toStringTag==="symbol";var a=Object.getPrototypeOf;var getGeneratorFunc=function(){if(!o){return false}try{return Function("return function*() {}")()}catch(e){}};var i=getGeneratorFunc();var c=i?a(i):{};e.exports=function isGeneratorFunction(e){if(typeof e!=="function"){return false}if(n.test(r.call(e))){return true}if(!o){var i=t.call(e);return i==="[object GeneratorFunction]"}return a(e)===c}},720:function(e){"use strict";e.exports=function isNaN(e){return e!==e}},674:function(e,t,r){"use strict";var n=r(112);var o=r(961);var a=r(720);var i=r(78);var c=r(81);var u=n(i(),Number);o(u,{getPolyfill:i,implementation:a,shim:c});e.exports=u},78:function(e,t,r){"use strict";var n=r(720);e.exports=function getPolyfill(){if(Number.isNaN&&Number.isNaN(NaN)&&!Number.isNaN("a")){return Number.isNaN}return n}},81:function(e,t,r){"use strict";var n=r(961);var o=r(78);e.exports=function shimNumberIsNaN(){var e=o();n(Number,{isNaN:e},{isNaN:function testIsNaN(){return Number.isNaN!==e}});return e}},234:function(e,t,r){"use strict";var n=r(219);var o=r(627);var a=r(749);var i=a("Object.prototype.toString");var c=r(449)();var u=c&&typeof Symbol.toStringTag==="symbol";var f=o();var s=a("Array.prototype.indexOf",true)||function indexOf(e,t){for(var r=0;r<e.length;r+=1){if(e[r]===t){return r}}return-1};var p=a("String.prototype.slice");var l={};var y=r(982);var d=Object.getPrototypeOf;if(u&&y&&d){n(f,(function(e){var t=new __webpack_require__.g[e];if(!(Symbol.toStringTag in t)){throw new EvalError("this engine has support for Symbol.toStringTag, but "+e+" does not have the property! Please report this.")}var r=d(t);var n=y(r,Symbol.toStringTag);if(!n){var o=d(r);n=y(o,Symbol.toStringTag)}l[e]=n.get}))}var g=function tryAllTypedArrays(e){var t=false;n(l,(function(r,n){if(!t){try{t=r.call(e)===n}catch(e){}}}));return t};e.exports=function isTypedArray(e){if(!e||typeof e!=="object"){return false}if(!u){var t=p(i(e),8,-1);return s(f,t)>-1}if(!y){return false}return g(e)}},982:function(e,t,r){"use strict";var n=r(879);var o=n("%Object.getOwnPropertyDescriptor%");if(o){try{o([],"length")}catch(e){o=null}}e.exports=o},450:function(e){"use strict";var numberIsNaN=function(e){return e!==e};e.exports=function is(e,t){if(e===0&&t===0){return 1/e===1/t}if(e===t){return true}if(numberIsNaN(e)&&numberIsNaN(t)){return true}return false}},595:function(e,t,r){"use strict";var n;if(!Object.keys){var o=Object.prototype.hasOwnProperty;var a=Object.prototype.toString;var i=r(750);var c=Object.prototype.propertyIsEnumerable;var u=!c.call({toString:null},"toString");var f=c.call((function(){}),"prototype");var s=["toString","toLocaleString","valueOf","hasOwnProperty","isPrototypeOf","propertyIsEnumerable","constructor"];var equalsConstructorPrototype=function(e){var t=e.constructor;return t&&t.prototype===e};var p={$applicationCache:true,$console:true,$external:true,$frame:true,$frameElement:true,$frames:true,$innerHeight:true,$innerWidth:true,$onmozfullscreenchange:true,$onmozfullscreenerror:true,$outerHeight:true,$outerWidth:true,$pageXOffset:true,$pageYOffset:true,$parent:true,$scrollLeft:true,$scrollTop:true,$scrollX:true,$scrollY:true,$self:true,$webkitIndexedDB:true,$webkitStorageInfo:true,$window:true};var l=function(){if(typeof window==="undefined"){return false}for(var e in window){try{if(!p["$"+e]&&o.call(window,e)&&window[e]!==null&&typeof window[e]==="object"){try{equalsConstructorPrototype(window[e])}catch(e){return true}}}catch(e){return true}}return false}();var equalsConstructorPrototypeIfNotBuggy=function(e){if(typeof window==="undefined"||!l){return equalsConstructorPrototype(e)}try{return equalsConstructorPrototype(e)}catch(e){return false}};n=function keys(e){var t=e!==null&&typeof e==="object";var r=a.call(e)==="[object Function]";var n=i(e);var c=t&&a.call(e)==="[object String]";var p=[];if(!t&&!r&&!n){throw new TypeError("Object.keys called on a non-object")}var l=f&&r;if(c&&e.length>0&&!o.call(e,0)){for(var y=0;y<e.length;++y){p.push(String(y))}}if(n&&e.length>0){for(var d=0;d<e.length;++d){p.push(String(d))}}else{for(var g in e){if(!(l&&g==="prototype")&&o.call(e,g)){p.push(String(g))}}}if(u){var v=equalsConstructorPrototypeIfNotBuggy(e);for(var b=0;b<s.length;++b){if(!(v&&s[b]==="constructor")&&o.call(e,s[b])){p.push(s[b])}}}return p}}e.exports=n},283:function(e,t,r){"use strict";var n=Array.prototype.slice;var o=r(750);var a=Object.keys;var i=a?function keys(e){return a(e)}:r(595);var c=Object.keys;i.shim=function shimObjectKeys(){if(Object.keys){var e=function(){var e=Object.keys(arguments);return e&&e.length===arguments.length}(1,2);if(!e){Object.keys=function keys(e){if(o(e)){return c(n.call(e))}return c(e)}}}else{Object.keys=i}return Object.keys||i};e.exports=i},750:function(e){"use strict";var t=Object.prototype.toString;e.exports=function isArguments(e){var r=t.call(e);var n=r==="[object Arguments]";if(!n){n=r!=="[object Array]"&&e!==null&&typeof e==="object"&&typeof e.length==="number"&&e.length>=0&&t.call(e.callee)==="[object Function]"}return n}},536:function(e){e.exports=function isBuffer(e){return e instanceof Buffer}},3:function(e,t,r){"use strict";var n=r(312);var o=r(906);var a=r(715);var i=r(234);function uncurryThis(e){return e.call.bind(e)}var c=typeof BigInt!=="undefined";var u=typeof Symbol!=="undefined";var f=uncurryThis(Object.prototype.toString);var s=uncurryThis(Number.prototype.valueOf);var p=uncurryThis(String.prototype.valueOf);var l=uncurryThis(Boolean.prototype.valueOf);if(c){var y=uncurryThis(BigInt.prototype.valueOf)}if(u){var d=uncurryThis(Symbol.prototype.valueOf)}function checkBoxedPrimitive(e,t){if(typeof e!=="object"){return false}try{t(e);return true}catch(e){return false}}t.isArgumentsObject=n;t.isGeneratorFunction=o;t.isTypedArray=i;function isPromise(e){return typeof Promise!=="undefined"&&e instanceof Promise||e!==null&&typeof e==="object"&&typeof e.then==="function"&&typeof e.catch==="function"}t.isPromise=isPromise;function isArrayBufferView(e){if(typeof ArrayBuffer!=="undefined"&&ArrayBuffer.isView){return ArrayBuffer.isView(e)}return i(e)||isDataView(e)}t.isArrayBufferView=isArrayBufferView;function isUint8Array(e){return a(e)==="Uint8Array"}t.isUint8Array=isUint8Array;function isUint8ClampedArray(e){return a(e)==="Uint8ClampedArray"}t.isUint8ClampedArray=isUint8ClampedArray;function isUint16Array(e){return a(e)==="Uint16Array"}t.isUint16Array=isUint16Array;function isUint32Array(e){return a(e)==="Uint32Array"}t.isUint32Array=isUint32Array;function isInt8Array(e){return a(e)==="Int8Array"}t.isInt8Array=isInt8Array;function isInt16Array(e){return a(e)==="Int16Array"}t.isInt16Array=isInt16Array;function isInt32Array(e){return a(e)==="Int32Array"}t.isInt32Array=isInt32Array;function isFloat32Array(e){return a(e)==="Float32Array"}t.isFloat32Array=isFloat32Array;function isFloat64Array(e){return a(e)==="Float64Array"}t.isFloat64Array=isFloat64Array;function isBigInt64Array(e){return a(e)==="BigInt64Array"}t.isBigInt64Array=isBigInt64Array;function isBigUint64Array(e){return a(e)==="BigUint64Array"}t.isBigUint64Array=isBigUint64Array;function isMapToString(e){return f(e)==="[object Map]"}isMapToString.working=typeof Map!=="undefined"&&isMapToString(new Map);function isMap(e){if(typeof Map==="undefined"){return false}return isMapToString.working?isMapToString(e):e instanceof Map}t.isMap=isMap;function isSetToString(e){return f(e)==="[object Set]"}isSetToString.working=typeof Set!=="undefined"&&isSetToString(new Set);function isSet(e){if(typeof Set==="undefined"){return false}return isSetToString.working?isSetToString(e):e instanceof Set}t.isSet=isSet;function isWeakMapToString(e){return f(e)==="[object WeakMap]"}isWeakMapToString.working=typeof WeakMap!=="undefined"&&isWeakMapToString(new WeakMap);function isWeakMap(e){if(typeof WeakMap==="undefined"){return false}return isWeakMapToString.working?isWeakMapToString(e):e instanceof WeakMap}t.isWeakMap=isWeakMap;function isWeakSetToString(e){return f(e)==="[object WeakSet]"}isWeakSetToString.working=typeof WeakSet!=="undefined"&&isWeakSetToString(new WeakSet);function isWeakSet(e){return isWeakSetToString(e)}t.isWeakSet=isWeakSet;function isArrayBufferToString(e){return f(e)==="[object ArrayBuffer]"}isArrayBufferToString.working=typeof ArrayBuffer!=="undefined"&&isArrayBufferToString(new ArrayBuffer);function isArrayBuffer(e){if(typeof ArrayBuffer==="undefined"){return false}return isArrayBufferToString.working?isArrayBufferToString(e):e instanceof ArrayBuffer}t.isArrayBuffer=isArrayBuffer;function isDataViewToString(e){return f(e)==="[object DataView]"}isDataViewToString.working=typeof ArrayBuffer!=="undefined"&&typeof DataView!=="undefined"&&isDataViewToString(new DataView(new ArrayBuffer(1),0,1));function isDataView(e){if(typeof DataView==="undefined"){return false}return isDataViewToString.working?isDataViewToString(e):e instanceof DataView}t.isDataView=isDataView;var g=typeof SharedArrayBuffer!=="undefined"?SharedArrayBuffer:undefined;function isSharedArrayBufferToString(e){return f(e)==="[object SharedArrayBuffer]"}function isSharedArrayBuffer(e){if(typeof g==="undefined"){return false}if(typeof isSharedArrayBufferToString.working==="undefined"){isSharedArrayBufferToString.working=isSharedArrayBufferToString(new g)}return isSharedArrayBufferToString.working?isSharedArrayBufferToString(e):e instanceof g}t.isSharedArrayBuffer=isSharedArrayBuffer;function isAsyncFunction(e){return f(e)==="[object AsyncFunction]"}t.isAsyncFunction=isAsyncFunction;function isMapIterator(e){return f(e)==="[object Map Iterator]"}t.isMapIterator=isMapIterator;function isSetIterator(e){return f(e)==="[object Set Iterator]"}t.isSetIterator=isSetIterator;function isGeneratorObject(e){return f(e)==="[object Generator]"}t.isGeneratorObject=isGeneratorObject;function isWebAssemblyCompiledModule(e){return f(e)==="[object WebAssembly.Module]"}t.isWebAssemblyCompiledModule=isWebAssemblyCompiledModule;function isNumberObject(e){return checkBoxedPrimitive(e,s)}t.isNumberObject=isNumberObject;function isStringObject(e){return checkBoxedPrimitive(e,p)}t.isStringObject=isStringObject;function isBooleanObject(e){return checkBoxedPrimitive(e,l)}t.isBooleanObject=isBooleanObject;function isBigIntObject(e){return c&&checkBoxedPrimitive(e,y)}t.isBigIntObject=isBigIntObject;function isSymbolObject(e){return u&&checkBoxedPrimitive(e,d)}t.isSymbolObject=isSymbolObject;function isBoxedPrimitive(e){return isNumberObject(e)||isStringObject(e)||isBooleanObject(e)||isBigIntObject(e)||isSymbolObject(e)}t.isBoxedPrimitive=isBoxedPrimitive;function isAnyArrayBuffer(e){return typeof Uint8Array!=="undefined"&&(isArrayBuffer(e)||isSharedArrayBuffer(e))}t.isAnyArrayBuffer=isAnyArrayBuffer;["isProxy","isExternal","isModuleNamespaceObject"].forEach((function(e){Object.defineProperty(t,e,{enumerable:false,value:function(){throw new Error(e+" is not supported in userland")}})}))},650:function(e,t,r){var n=Object.getOwnPropertyDescriptors||function getOwnPropertyDescriptors(e){var t=Object.keys(e);var r={};for(var n=0;n<t.length;n++){r[t[n]]=Object.getOwnPropertyDescriptor(e,t[n])}return r};var o=/%[sdj%]/g;t.format=function(e){if(!isString(e)){var t=[];for(var r=0;r<arguments.length;r++){t.push(inspect(arguments[r]))}return t.join(" ")}var r=1;var n=arguments;var a=n.length;var i=String(e).replace(o,(function(e){if(e==="%%")return"%";if(r>=a)return e;switch(e){case"%s":return String(n[r++]);case"%d":return Number(n[r++]);case"%j":try{return JSON.stringify(n[r++])}catch(e){return"[Circular]"}default:return e}}));for(var c=n[r];r<a;c=n[++r]){if(isNull(c)||!isObject(c)){i+=" "+c}else{i+=" "+inspect(c)}}return i};t.deprecate=function(e,r){if(typeof process!=="undefined"&&process.noDeprecation===true){return e}if(typeof process==="undefined"){return function(){return t.deprecate(e,r).apply(this,arguments)}}var n=false;function deprecated(){if(!n){if(process.throwDeprecation){throw new Error(r)}else if(process.traceDeprecation){console.trace(r)}else{console.error(r)}n=true}return e.apply(this,arguments)}return deprecated};var a={};var i=/^$/;if(process.env.NODE_DEBUG){var c=process.env.NODE_DEBUG;c=c.replace(/[|\\{}()[\]^$+?.]/g,"\\$&").replace(/\*/g,".*").replace(/,/g,"$|^").toUpperCase();i=new RegExp("^"+c+"$","i")}t.debuglog=function(e){e=e.toUpperCase();if(!a[e]){if(i.test(e)){var r=process.pid;a[e]=function(){var n=t.format.apply(t,arguments);console.error("%s %d: %s",e,r,n)}}else{a[e]=function(){}}}return a[e]};function inspect(e,r){var n={seen:[],stylize:stylizeNoColor};if(arguments.length>=3)n.depth=arguments[2];if(arguments.length>=4)n.colors=arguments[3];if(isBoolean(r)){n.showHidden=r}else if(r){t._extend(n,r)}if(isUndefined(n.showHidden))n.showHidden=false;if(isUndefined(n.depth))n.depth=2;if(isUndefined(n.colors))n.colors=false;if(isUndefined(n.customInspect))n.customInspect=true;if(n.colors)n.stylize=stylizeWithColor;return formatValue(n,e,n.depth)}t.inspect=inspect;inspect.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]};inspect.styles={special:"cyan",number:"yellow",boolean:"yellow",undefined:"grey",null:"bold",string:"green",date:"magenta",regexp:"red"};function stylizeWithColor(e,t){var r=inspect.styles[t];if(r){return"["+inspect.colors[r][0]+"m"+e+"["+inspect.colors[r][1]+"m"}else{return e}}function stylizeNoColor(e,t){return e}function arrayToHash(e){var t={};e.forEach((function(e,r){t[e]=true}));return t}function formatValue(e,r,n){if(e.customInspect&&r&&isFunction(r.inspect)&&r.inspect!==t.inspect&&!(r.constructor&&r.constructor.prototype===r)){var o=r.inspect(n,e);if(!isString(o)){o=formatValue(e,o,n)}return o}var a=formatPrimitive(e,r);if(a){return a}var i=Object.keys(r);var c=arrayToHash(i);if(e.showHidden){i=Object.getOwnPropertyNames(r)}if(isError(r)&&(i.indexOf("message")>=0||i.indexOf("description")>=0)){return formatError(r)}if(i.length===0){if(isFunction(r)){var u=r.name?": "+r.name:"";return e.stylize("[Function"+u+"]","special")}if(isRegExp(r)){return e.stylize(RegExp.prototype.toString.call(r),"regexp")}if(isDate(r)){return e.stylize(Date.prototype.toString.call(r),"date")}if(isError(r)){return formatError(r)}}var f="",s=false,p=["{","}"];if(isArray(r)){s=true;p=["[","]"]}if(isFunction(r)){var l=r.name?": "+r.name:"";f=" [Function"+l+"]"}if(isRegExp(r)){f=" "+RegExp.prototype.toString.call(r)}if(isDate(r)){f=" "+Date.prototype.toUTCString.call(r)}if(isError(r)){f=" "+formatError(r)}if(i.length===0&&(!s||r.length==0)){return p[0]+f+p[1]}if(n<0){if(isRegExp(r)){return e.stylize(RegExp.prototype.toString.call(r),"regexp")}else{return e.stylize("[Object]","special")}}e.seen.push(r);var y;if(s){y=formatArray(e,r,n,c,i)}else{y=i.map((function(t){return formatProperty(e,r,n,c,t,s)}))}e.seen.pop();return reduceToSingleString(y,f,p)}function formatPrimitive(e,t){if(isUndefined(t))return e.stylize("undefined","undefined");if(isString(t)){var r="'"+JSON.stringify(t).replace(/^"|"$/g,"").replace(/'/g,"\\'").replace(/\\"/g,'"')+"'";return e.stylize(r,"string")}if(isNumber(t))return e.stylize(""+t,"number");if(isBoolean(t))return e.stylize(""+t,"boolean");if(isNull(t))return e.stylize("null","null")}function formatError(e){return"["+Error.prototype.toString.call(e)+"]"}function formatArray(e,t,r,n,o){var a=[];for(var i=0,c=t.length;i<c;++i){if(hasOwnProperty(t,String(i))){a.push(formatProperty(e,t,r,n,String(i),true))}else{a.push("")}}o.forEach((function(o){if(!o.match(/^\d+$/)){a.push(formatProperty(e,t,r,n,o,true))}}));return a}function formatProperty(e,t,r,n,o,a){var i,c,u;u=Object.getOwnPropertyDescriptor(t,o)||{value:t[o]};if(u.get){if(u.set){c=e.stylize("[Getter/Setter]","special")}else{c=e.stylize("[Getter]","special")}}else{if(u.set){c=e.stylize("[Setter]","special")}}if(!hasOwnProperty(n,o)){i="["+o+"]"}if(!c){if(e.seen.indexOf(u.value)<0){if(isNull(r)){c=formatValue(e,u.value,null)}else{c=formatValue(e,u.value,r-1)}if(c.indexOf("\n")>-1){if(a){c=c.split("\n").map((function(e){return"  "+e})).join("\n").substr(2)}else{c="\n"+c.split("\n").map((function(e){return"   "+e})).join("\n")}}}else{c=e.stylize("[Circular]","special")}}if(isUndefined(i)){if(a&&o.match(/^\d+$/)){return c}i=JSON.stringify(""+o);if(i.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)){i=i.substr(1,i.length-2);i=e.stylize(i,"name")}else{i=i.replace(/'/g,"\\'").replace(/\\"/g,'"').replace(/(^"|"$)/g,"'");i=e.stylize(i,"string")}}return i+": "+c}function reduceToSingleString(e,t,r){var n=0;var o=e.reduce((function(e,t){n++;if(t.indexOf("\n")>=0)n++;return e+t.replace(/\u001b\[\d\d?m/g,"").length+1}),0);if(o>60){return r[0]+(t===""?"":t+"\n ")+" "+e.join(",\n  ")+" "+r[1]}return r[0]+t+" "+e.join(", ")+" "+r[1]}t.types=r(3);function isArray(e){return Array.isArray(e)}t.isArray=isArray;function isBoolean(e){return typeof e==="boolean"}t.isBoolean=isBoolean;function isNull(e){return e===null}t.isNull=isNull;function isNullOrUndefined(e){return e==null}t.isNullOrUndefined=isNullOrUndefined;function isNumber(e){return typeof e==="number"}t.isNumber=isNumber;function isString(e){return typeof e==="string"}t.isString=isString;function isSymbol(e){return typeof e==="symbol"}t.isSymbol=isSymbol;function isUndefined(e){return e===void 0}t.isUndefined=isUndefined;function isRegExp(e){return isObject(e)&&objectToString(e)==="[object RegExp]"}t.isRegExp=isRegExp;t.types.isRegExp=isRegExp;function isObject(e){return typeof e==="object"&&e!==null}t.isObject=isObject;function isDate(e){return isObject(e)&&objectToString(e)==="[object Date]"}t.isDate=isDate;t.types.isDate=isDate;function isError(e){return isObject(e)&&(objectToString(e)==="[object Error]"||e instanceof Error)}t.isError=isError;t.types.isNativeError=isError;function isFunction(e){return typeof e==="function"}t.isFunction=isFunction;function isPrimitive(e){return e===null||typeof e==="boolean"||typeof e==="number"||typeof e==="string"||typeof e==="symbol"||typeof e==="undefined"}t.isPrimitive=isPrimitive;t.isBuffer=r(536);function objectToString(e){return Object.prototype.toString.call(e)}function pad(e){return e<10?"0"+e.toString(10):e.toString(10)}var u=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];function timestamp(){var e=new Date;var t=[pad(e.getHours()),pad(e.getMinutes()),pad(e.getSeconds())].join(":");return[e.getDate(),u[e.getMonth()],t].join(" ")}t.log=function(){console.log("%s - %s",timestamp(),t.format.apply(t,arguments))};t.inherits=r(526);t._extend=function(e,t){if(!t||!isObject(t))return e;var r=Object.keys(t);var n=r.length;while(n--){e[r[n]]=t[r[n]]}return e};function hasOwnProperty(e,t){return Object.prototype.hasOwnProperty.call(e,t)}var f=typeof Symbol!=="undefined"?Symbol("util.promisify.custom"):undefined;t.promisify=function promisify(e){if(typeof e!=="function")throw new TypeError('The "original" argument must be of type Function');if(f&&e[f]){var t=e[f];if(typeof t!=="function"){throw new TypeError('The "util.promisify.custom" argument must be of type Function')}Object.defineProperty(t,f,{value:t,enumerable:false,writable:false,configurable:true});return t}function t(){var t,r;var n=new Promise((function(e,n){t=e;r=n}));var o=[];for(var a=0;a<arguments.length;a++){o.push(arguments[a])}o.push((function(e,n){if(e){r(e)}else{t(n)}}));try{e.apply(this,o)}catch(e){r(e)}return n}Object.setPrototypeOf(t,Object.getPrototypeOf(e));if(f)Object.defineProperty(t,f,{value:t,enumerable:false,writable:false,configurable:true});return Object.defineProperties(t,n(e))};t.promisify.custom=f;function callbackifyOnRejected(e,t){if(!e){var r=new Error("Promise was rejected with a falsy value");r.reason=e;e=r}return t(e)}function callbackify(e){if(typeof e!=="function"){throw new TypeError('The "original" argument must be of type Function')}function callbackified(){var t=[];for(var r=0;r<arguments.length;r++){t.push(arguments[r])}var n=t.pop();if(typeof n!=="function"){throw new TypeError("The last argument must be of type Function")}var o=this;var cb=function(){return n.apply(o,arguments)};e.apply(this,t).then((function(e){process.nextTick(cb.bind(null,null,e))}),(function(e){process.nextTick(callbackifyOnRejected.bind(null,e,cb))}))}Object.setPrototypeOf(callbackified,Object.getPrototypeOf(e));Object.defineProperties(callbackified,n(e));return callbackified}t.callbackify=callbackify},715:function(e,t,r){"use strict";var n=r(219);var o=r(627);var a=r(749);var i=a("Object.prototype.toString");var c=r(449)();var u=c&&typeof Symbol.toStringTag==="symbol";var f=o();var s=a("String.prototype.slice");var p={};var l=r(850);var y=Object.getPrototypeOf;if(u&&l&&y){n(f,(function(e){if(typeof __webpack_require__.g[e]==="function"){var t=new __webpack_require__.g[e];if(!(Symbol.toStringTag in t)){throw new EvalError("this engine has support for Symbol.toStringTag, but "+e+" does not have the property! Please report this.")}var r=y(t);var n=l(r,Symbol.toStringTag);if(!n){var o=y(r);n=l(o,Symbol.toStringTag)}p[e]=n.get}}))}var d=function tryAllTypedArrays(e){var t=false;n(p,(function(r,n){if(!t){try{var o=r.call(e);if(o===n){t=o}}catch(e){}}}));return t};var g=r(234);e.exports=function whichTypedArray(e){if(!g(e)){return false}if(!u){return s(i(e),8,-1)}return d(e)}},227:function(e,t,r){"use strict";var n;var o=SyntaxError;var a=Function;var i=TypeError;var getEvalledConstructor=function(e){try{return Function('"use strict"; return ('+e+").constructor;")()}catch(e){}};var c=Object.getOwnPropertyDescriptor;if(c){try{c({},"")}catch(e){c=null}}var throwTypeError=function(){throw new i};var u=c?function(){try{arguments.callee;return throwTypeError}catch(e){try{return c(arguments,"callee").get}catch(e){return throwTypeError}}}():throwTypeError;var f=r(449)();var s=Object.getPrototypeOf||function(e){return e.__proto__};var p=getEvalledConstructor("async function* () {}");var l=p?p.prototype:n;var y=l?l.prototype:n;var d=typeof Uint8Array==="undefined"?n:s(Uint8Array);var g={"%AggregateError%":typeof AggregateError==="undefined"?n:AggregateError,"%Array%":Array,"%ArrayBuffer%":typeof ArrayBuffer==="undefined"?n:ArrayBuffer,"%ArrayIteratorPrototype%":f?s([][Symbol.iterator]()):n,"%AsyncFromSyncIteratorPrototype%":n,"%AsyncFunction%":getEvalledConstructor("async function () {}"),"%AsyncGenerator%":l,"%AsyncGeneratorFunction%":p,"%AsyncIteratorPrototype%":y?s(y):n,"%Atomics%":typeof Atomics==="undefined"?n:Atomics,"%BigInt%":typeof BigInt==="undefined"?n:BigInt,"%Boolean%":Boolean,"%DataView%":typeof DataView==="undefined"?n:DataView,"%Date%":Date,"%decodeURI%":decodeURI,"%decodeURIComponent%":decodeURIComponent,"%encodeURI%":encodeURI,"%encodeURIComponent%":encodeURIComponent,"%Error%":Error,"%eval%":eval,"%EvalError%":EvalError,"%Float32Array%":typeof Float32Array==="undefined"?n:Float32Array,"%Float64Array%":typeof Float64Array==="undefined"?n:Float64Array,"%FinalizationRegistry%":typeof FinalizationRegistry==="undefined"?n:FinalizationRegistry,"%Function%":a,"%GeneratorFunction%":getEvalledConstructor("function* () {}"),"%Int8Array%":typeof Int8Array==="undefined"?n:Int8Array,"%Int16Array%":typeof Int16Array==="undefined"?n:Int16Array,"%Int32Array%":typeof Int32Array==="undefined"?n:Int32Array,"%isFinite%":isFinite,"%isNaN%":isNaN,"%IteratorPrototype%":f?s(s([][Symbol.iterator]())):n,"%JSON%":typeof JSON==="object"?JSON:n,"%Map%":typeof Map==="undefined"?n:Map,"%MapIteratorPrototype%":typeof Map==="undefined"||!f?n:s((new Map)[Symbol.iterator]()),"%Math%":Math,"%Number%":Number,"%Object%":Object,"%parseFloat%":parseFloat,"%parseInt%":parseInt,"%Promise%":typeof Promise==="undefined"?n:Promise,"%Proxy%":typeof Proxy==="undefined"?n:Proxy,"%RangeError%":RangeError,"%ReferenceError%":ReferenceError,"%Reflect%":typeof Reflect==="undefined"?n:Reflect,"%RegExp%":RegExp,"%Set%":typeof Set==="undefined"?n:Set,"%SetIteratorPrototype%":typeof Set==="undefined"||!f?n:s((new Set)[Symbol.iterator]()),"%SharedArrayBuffer%":typeof SharedArrayBuffer==="undefined"?n:SharedArrayBuffer,"%String%":String,"%StringIteratorPrototype%":f?s(""[Symbol.iterator]()):n,"%Symbol%":f?Symbol:n,"%SyntaxError%":o,"%ThrowTypeError%":u,"%TypedArray%":d,"%TypeError%":i,"%Uint8Array%":typeof Uint8Array==="undefined"?n:Uint8Array,"%Uint8ClampedArray%":typeof Uint8ClampedArray==="undefined"?n:Uint8ClampedArray,"%Uint16Array%":typeof Uint16Array==="undefined"?n:Uint16Array,"%Uint32Array%":typeof Uint32Array==="undefined"?n:Uint32Array,"%URIError%":URIError,"%WeakMap%":typeof WeakMap==="undefined"?n:WeakMap,"%WeakRef%":typeof WeakRef==="undefined"?n:WeakRef,"%WeakSet%":typeof WeakSet==="undefined"?n:WeakSet};var v={"%ArrayBufferPrototype%":["ArrayBuffer","prototype"],"%ArrayPrototype%":["Array","prototype"],"%ArrayProto_entries%":["Array","prototype","entries"],"%ArrayProto_forEach%":["Array","prototype","forEach"],"%ArrayProto_keys%":["Array","prototype","keys"],"%ArrayProto_values%":["Array","prototype","values"],"%AsyncFunctionPrototype%":["AsyncFunction","prototype"],"%AsyncGenerator%":["AsyncGeneratorFunction","prototype"],"%AsyncGeneratorPrototype%":["AsyncGeneratorFunction","prototype","prototype"],"%BooleanPrototype%":["Boolean","prototype"],"%DataViewPrototype%":["DataView","prototype"],"%DatePrototype%":["Date","prototype"],"%ErrorPrototype%":["Error","prototype"],"%EvalErrorPrototype%":["EvalError","prototype"],"%Float32ArrayPrototype%":["Float32Array","prototype"],"%Float64ArrayPrototype%":["Float64Array","prototype"],"%FunctionPrototype%":["Function","prototype"],"%Generator%":["GeneratorFunction","prototype"],"%GeneratorPrototype%":["GeneratorFunction","prototype","prototype"],"%Int8ArrayPrototype%":["Int8Array","prototype"],"%Int16ArrayPrototype%":["Int16Array","prototype"],"%Int32ArrayPrototype%":["Int32Array","prototype"],"%JSONParse%":["JSON","parse"],"%JSONStringify%":["JSON","stringify"],"%MapPrototype%":["Map","prototype"],"%NumberPrototype%":["Number","prototype"],"%ObjectPrototype%":["Object","prototype"],"%ObjProto_toString%":["Object","prototype","toString"],"%ObjProto_valueOf%":["Object","prototype","valueOf"],"%PromisePrototype%":["Promise","prototype"],"%PromiseProto_then%":["Promise","prototype","then"],"%Promise_all%":["Promise","all"],"%Promise_reject%":["Promise","reject"],"%Promise_resolve%":["Promise","resolve"],"%RangeErrorPrototype%":["RangeError","prototype"],"%ReferenceErrorPrototype%":["ReferenceError","prototype"],"%RegExpPrototype%":["RegExp","prototype"],"%SetPrototype%":["Set","prototype"],"%SharedArrayBufferPrototype%":["SharedArrayBuffer","prototype"],"%StringPrototype%":["String","prototype"],"%SymbolPrototype%":["Symbol","prototype"],"%SyntaxErrorPrototype%":["SyntaxError","prototype"],"%TypedArrayPrototype%":["TypedArray","prototype"],"%TypeErrorPrototype%":["TypeError","prototype"],"%Uint8ArrayPrototype%":["Uint8Array","prototype"],"%Uint8ClampedArrayPrototype%":["Uint8ClampedArray","prototype"],"%Uint16ArrayPrototype%":["Uint16Array","prototype"],"%Uint32ArrayPrototype%":["Uint32Array","prototype"],"%URIErrorPrototype%":["URIError","prototype"],"%WeakMapPrototype%":["WeakMap","prototype"],"%WeakSetPrototype%":["WeakSet","prototype"]};var b=r(517);var h=r(793);var m=b.call(Function.call,Array.prototype.concat);var A=b.call(Function.apply,Array.prototype.splice);var S=b.call(Function.call,String.prototype.replace);var E=/[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;var P=/\\(\\)?/g;var w=function stringToPath(e){var t=[];S(e,E,(function(e,r,n,o){t[t.length]=n?S(o,P,"$1"):r||e}));return t};var O=function getBaseIntrinsic(e,t){var r=e;var n;if(h(v,r)){n=v[r];r="%"+n[0]+"%"}if(h(g,r)){var a=g[r];if(typeof a==="undefined"&&!t){throw new i("intrinsic "+e+" exists, but is not available. Please file an issue!")}return{alias:n,name:r,value:a}}throw new o("intrinsic "+e+" does not exist!")};e.exports=function GetIntrinsic(e,t){if(typeof e!=="string"||e.length===0){throw new i("intrinsic name must be a non-empty string")}if(arguments.length>1&&typeof t!=="boolean"){throw new i('"allowMissing" argument must be a boolean')}var r=w(e);var n=r.length>0?r[0]:"";var o=O("%"+n+"%",t);var a=o.name;var u=o.value;var f=false;var s=o.alias;if(s){n=s[0];A(r,m([0,1],s))}for(var p=1,l=true;p<r.length;p+=1){var y=r[p];if(y==="constructor"||!l){f=true}n+="."+y;a="%"+n+"%";if(h(g,a)){u=g[a]}else if(u!=null){if(c&&p+1>=r.length){var d=c(u,y);l=!!d;if(!t&&!(y in u)){throw new i("base intrinsic for "+e+" exists, but the property is not available.")}if(l&&"get"in d&&!("originalValue"in d.get)){u=d.get}else{u=u[y]}}else{l=h(u,y);u=u[y]}if(l&&!f){g[a]=u}}}return u}},850:function(e,t,r){"use strict";var n=r(227);var o=n("%Object.getOwnPropertyDescriptor%");if(o){try{o([],"length")}catch(e){o=null}}e.exports=o},627:function(e,t,r){"use strict";var n=r(901);e.exports=function availableTypedArrays(){return n(["BigInt64Array","BigUint64Array","Float32Array","Float64Array","Int16Array","Int32Array","Int8Array","Uint16Array","Uint32Array","Uint8Array","Uint8ClampedArray"],(function(e){return typeof __webpack_require__.g[e]==="function"}))}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var o=t[r]={exports:{}};var a=true;try{e[r](o,o.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}return o.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(313);module.exports=r})();

/***/ }),

/***/ 47715:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/* provided dependency */ var process = __webpack_require__(83454);
(function(){"use strict";var e={958:function(e,t,i){var a=i(491);var r=i(944);var n=i(492);var s=i(422);var l=i(234);for(var f in l){t[f]=l[f]}t.NONE=0;t.DEFLATE=1;t.INFLATE=2;t.GZIP=3;t.GUNZIP=4;t.DEFLATERAW=5;t.INFLATERAW=6;t.UNZIP=7;var o=31;var h=139;function Zlib(e){if(typeof e!=="number"||e<t.DEFLATE||e>t.UNZIP){throw new TypeError("Bad argument")}this.dictionary=null;this.err=0;this.flush=0;this.init_done=false;this.level=0;this.memLevel=0;this.mode=e;this.strategy=0;this.windowBits=0;this.write_in_progress=false;this.pending_close=false;this.gzip_id_bytes_read=0}Zlib.prototype.close=function(){if(this.write_in_progress){this.pending_close=true;return}this.pending_close=false;a(this.init_done,"close before init");a(this.mode<=t.UNZIP);if(this.mode===t.DEFLATE||this.mode===t.GZIP||this.mode===t.DEFLATERAW){n.deflateEnd(this.strm)}else if(this.mode===t.INFLATE||this.mode===t.GUNZIP||this.mode===t.INFLATERAW||this.mode===t.UNZIP){s.inflateEnd(this.strm)}this.mode=t.NONE;this.dictionary=null};Zlib.prototype.write=function(e,t,i,a,r,n,s){return this._write(true,e,t,i,a,r,n,s)};Zlib.prototype.writeSync=function(e,t,i,a,r,n,s){return this._write(false,e,t,i,a,r,n,s)};Zlib.prototype._write=function(e,i,r,n,s,l,f,o){a.equal(arguments.length,8);a(this.init_done,"write before init");a(this.mode!==t.NONE,"already finalized");a.equal(false,this.write_in_progress,"write already in progress");a.equal(false,this.pending_close,"close is pending");this.write_in_progress=true;a.equal(false,i===undefined,"must provide flush value");this.write_in_progress=true;if(i!==t.Z_NO_FLUSH&&i!==t.Z_PARTIAL_FLUSH&&i!==t.Z_SYNC_FLUSH&&i!==t.Z_FULL_FLUSH&&i!==t.Z_FINISH&&i!==t.Z_BLOCK){throw new Error("Invalid flush value")}if(r==null){r=Buffer.alloc(0);s=0;n=0}this.strm.avail_in=s;this.strm.input=r;this.strm.next_in=n;this.strm.avail_out=o;this.strm.output=l;this.strm.next_out=f;this.flush=i;if(!e){this._process();if(this._checkError()){return this._afterSync()}return}var h=this;process.nextTick((function(){h._process();h._after()}));return this};Zlib.prototype._afterSync=function(){var e=this.strm.avail_out;var t=this.strm.avail_in;this.write_in_progress=false;return[t,e]};Zlib.prototype._process=function(){var e=null;switch(this.mode){case t.DEFLATE:case t.GZIP:case t.DEFLATERAW:this.err=n.deflate(this.strm,this.flush);break;case t.UNZIP:if(this.strm.avail_in>0){e=this.strm.next_in}switch(this.gzip_id_bytes_read){case 0:if(e===null){break}if(this.strm.input[e]===o){this.gzip_id_bytes_read=1;e++;if(this.strm.avail_in===1){break}}else{this.mode=t.INFLATE;break}case 1:if(e===null){break}if(this.strm.input[e]===h){this.gzip_id_bytes_read=2;this.mode=t.GUNZIP}else{this.mode=t.INFLATE}break;default:throw new Error("invalid number of gzip magic number bytes read")}case t.INFLATE:case t.GUNZIP:case t.INFLATERAW:this.err=s.inflate(this.strm,this.flush);if(this.err===t.Z_NEED_DICT&&this.dictionary){this.err=s.inflateSetDictionary(this.strm,this.dictionary);if(this.err===t.Z_OK){this.err=s.inflate(this.strm,this.flush)}else if(this.err===t.Z_DATA_ERROR){this.err=t.Z_NEED_DICT}}while(this.strm.avail_in>0&&this.mode===t.GUNZIP&&this.err===t.Z_STREAM_END&&this.strm.next_in[0]!==0){this.reset();this.err=s.inflate(this.strm,this.flush)}break;default:throw new Error("Unknown mode "+this.mode)}};Zlib.prototype._checkError=function(){switch(this.err){case t.Z_OK:case t.Z_BUF_ERROR:if(this.strm.avail_out!==0&&this.flush===t.Z_FINISH){this._error("unexpected end of file");return false}break;case t.Z_STREAM_END:break;case t.Z_NEED_DICT:if(this.dictionary==null){this._error("Missing dictionary")}else{this._error("Bad dictionary")}return false;default:this._error("Zlib error");return false}return true};Zlib.prototype._after=function(){if(!this._checkError()){return}var e=this.strm.avail_out;var t=this.strm.avail_in;this.write_in_progress=false;this.callback(t,e);if(this.pending_close){this.close()}};Zlib.prototype._error=function(e){if(this.strm.msg){e=this.strm.msg}this.onerror(e,this.err);this.write_in_progress=false;if(this.pending_close){this.close()}};Zlib.prototype.init=function(e,i,r,n,s){a(arguments.length===4||arguments.length===5,"init(windowBits, level, memLevel, strategy, [dictionary])");a(e>=8&&e<=15,"invalid windowBits");a(i>=-1&&i<=9,"invalid compression level");a(r>=1&&r<=9,"invalid memlevel");a(n===t.Z_FILTERED||n===t.Z_HUFFMAN_ONLY||n===t.Z_RLE||n===t.Z_FIXED||n===t.Z_DEFAULT_STRATEGY,"invalid strategy");this._init(i,e,r,n,s);this._setDictionary()};Zlib.prototype.params=function(){throw new Error("deflateParams Not supported")};Zlib.prototype.reset=function(){this._reset();this._setDictionary()};Zlib.prototype._init=function(e,i,a,l,f){this.level=e;this.windowBits=i;this.memLevel=a;this.strategy=l;this.flush=t.Z_NO_FLUSH;this.err=t.Z_OK;if(this.mode===t.GZIP||this.mode===t.GUNZIP){this.windowBits+=16}if(this.mode===t.UNZIP){this.windowBits+=32}if(this.mode===t.DEFLATERAW||this.mode===t.INFLATERAW){this.windowBits=-1*this.windowBits}this.strm=new r;switch(this.mode){case t.DEFLATE:case t.GZIP:case t.DEFLATERAW:this.err=n.deflateInit2(this.strm,this.level,t.Z_DEFLATED,this.windowBits,this.memLevel,this.strategy);break;case t.INFLATE:case t.GUNZIP:case t.INFLATERAW:case t.UNZIP:this.err=s.inflateInit2(this.strm,this.windowBits);break;default:throw new Error("Unknown mode "+this.mode)}if(this.err!==t.Z_OK){this._error("Init error")}this.dictionary=f;this.write_in_progress=false;this.init_done=true};Zlib.prototype._setDictionary=function(){if(this.dictionary==null){return}this.err=t.Z_OK;switch(this.mode){case t.DEFLATE:case t.DEFLATERAW:this.err=n.deflateSetDictionary(this.strm,this.dictionary);break;default:break}if(this.err!==t.Z_OK){this._error("Failed to set dictionary")}};Zlib.prototype._reset=function(){this.err=t.Z_OK;switch(this.mode){case t.DEFLATE:case t.DEFLATERAW:case t.GZIP:this.err=n.deflateReset(this.strm);break;case t.INFLATE:case t.INFLATERAW:case t.GUNZIP:this.err=s.inflateReset(this.strm);break;default:break}if(this.err!==t.Z_OK){this._error("Failed to reset stream")}};t.Zlib=Zlib},375:function(e,t,i){var a=i(300).Buffer;var r=i(781).Transform;var n=i(958);var s=i(837);var l=i(491).ok;var f=i(300).kMaxLength;var o="Cannot create final Buffer. It would be larger "+"than 0x"+f.toString(16)+" bytes";n.Z_MIN_WINDOWBITS=8;n.Z_MAX_WINDOWBITS=15;n.Z_DEFAULT_WINDOWBITS=15;n.Z_MIN_CHUNK=64;n.Z_MAX_CHUNK=Infinity;n.Z_DEFAULT_CHUNK=16*1024;n.Z_MIN_MEMLEVEL=1;n.Z_MAX_MEMLEVEL=9;n.Z_DEFAULT_MEMLEVEL=8;n.Z_MIN_LEVEL=-1;n.Z_MAX_LEVEL=9;n.Z_DEFAULT_LEVEL=n.Z_DEFAULT_COMPRESSION;var h=Object.keys(n);for(var _=0;_<h.length;_++){var d=h[_];if(d.match(/^Z/)){Object.defineProperty(t,d,{enumerable:true,value:n[d],writable:false})}}var u={Z_OK:n.Z_OK,Z_STREAM_END:n.Z_STREAM_END,Z_NEED_DICT:n.Z_NEED_DICT,Z_ERRNO:n.Z_ERRNO,Z_STREAM_ERROR:n.Z_STREAM_ERROR,Z_DATA_ERROR:n.Z_DATA_ERROR,Z_MEM_ERROR:n.Z_MEM_ERROR,Z_BUF_ERROR:n.Z_BUF_ERROR,Z_VERSION_ERROR:n.Z_VERSION_ERROR};var c=Object.keys(u);for(var v=0;v<c.length;v++){var b=c[v];u[u[b]]=b}Object.defineProperty(t,"codes",{enumerable:true,value:Object.freeze(u),writable:false});t.Deflate=Deflate;t.Inflate=Inflate;t.Gzip=Gzip;t.Gunzip=Gunzip;t.DeflateRaw=DeflateRaw;t.InflateRaw=InflateRaw;t.Unzip=Unzip;t.createDeflate=function(e){return new Deflate(e)};t.createInflate=function(e){return new Inflate(e)};t.createDeflateRaw=function(e){return new DeflateRaw(e)};t.createInflateRaw=function(e){return new InflateRaw(e)};t.createGzip=function(e){return new Gzip(e)};t.createGunzip=function(e){return new Gunzip(e)};t.createUnzip=function(e){return new Unzip(e)};t.deflate=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Deflate(t),e,i)};t.deflateSync=function(e,t){return zlibBufferSync(new Deflate(t),e)};t.gzip=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Gzip(t),e,i)};t.gzipSync=function(e,t){return zlibBufferSync(new Gzip(t),e)};t.deflateRaw=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new DeflateRaw(t),e,i)};t.deflateRawSync=function(e,t){return zlibBufferSync(new DeflateRaw(t),e)};t.unzip=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Unzip(t),e,i)};t.unzipSync=function(e,t){return zlibBufferSync(new Unzip(t),e)};t.inflate=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Inflate(t),e,i)};t.inflateSync=function(e,t){return zlibBufferSync(new Inflate(t),e)};t.gunzip=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new Gunzip(t),e,i)};t.gunzipSync=function(e,t){return zlibBufferSync(new Gunzip(t),e)};t.inflateRaw=function(e,t,i){if(typeof t==="function"){i=t;t={}}return zlibBuffer(new InflateRaw(t),e,i)};t.inflateRawSync=function(e,t){return zlibBufferSync(new InflateRaw(t),e)};function zlibBuffer(e,t,i){var r=[];var n=0;e.on("error",onError);e.on("end",onEnd);e.end(t);flow();function flow(){var t;while(null!==(t=e.read())){r.push(t);n+=t.length}e.once("readable",flow)}function onError(t){e.removeListener("end",onEnd);e.removeListener("readable",flow);i(t)}function onEnd(){var t;var s=null;if(n>=f){s=new RangeError(o)}else{t=a.concat(r,n)}r=[];e.close();i(s,t)}}function zlibBufferSync(e,t){if(typeof t==="string")t=a.from(t);if(!a.isBuffer(t))throw new TypeError("Not a string or buffer");var i=e._finishFlushFlag;return e._processChunk(t,i)}function Deflate(e){if(!(this instanceof Deflate))return new Deflate(e);Zlib.call(this,e,n.DEFLATE)}function Inflate(e){if(!(this instanceof Inflate))return new Inflate(e);Zlib.call(this,e,n.INFLATE)}function Gzip(e){if(!(this instanceof Gzip))return new Gzip(e);Zlib.call(this,e,n.GZIP)}function Gunzip(e){if(!(this instanceof Gunzip))return new Gunzip(e);Zlib.call(this,e,n.GUNZIP)}function DeflateRaw(e){if(!(this instanceof DeflateRaw))return new DeflateRaw(e);Zlib.call(this,e,n.DEFLATERAW)}function InflateRaw(e){if(!(this instanceof InflateRaw))return new InflateRaw(e);Zlib.call(this,e,n.INFLATERAW)}function Unzip(e){if(!(this instanceof Unzip))return new Unzip(e);Zlib.call(this,e,n.UNZIP)}function isValidFlushFlag(e){return e===n.Z_NO_FLUSH||e===n.Z_PARTIAL_FLUSH||e===n.Z_SYNC_FLUSH||e===n.Z_FULL_FLUSH||e===n.Z_FINISH||e===n.Z_BLOCK}function Zlib(e,i){var s=this;this._opts=e=e||{};this._chunkSize=e.chunkSize||t.Z_DEFAULT_CHUNK;r.call(this,e);if(e.flush&&!isValidFlushFlag(e.flush)){throw new Error("Invalid flush flag: "+e.flush)}if(e.finishFlush&&!isValidFlushFlag(e.finishFlush)){throw new Error("Invalid flush flag: "+e.finishFlush)}this._flushFlag=e.flush||n.Z_NO_FLUSH;this._finishFlushFlag=typeof e.finishFlush!=="undefined"?e.finishFlush:n.Z_FINISH;if(e.chunkSize){if(e.chunkSize<t.Z_MIN_CHUNK||e.chunkSize>t.Z_MAX_CHUNK){throw new Error("Invalid chunk size: "+e.chunkSize)}}if(e.windowBits){if(e.windowBits<t.Z_MIN_WINDOWBITS||e.windowBits>t.Z_MAX_WINDOWBITS){throw new Error("Invalid windowBits: "+e.windowBits)}}if(e.level){if(e.level<t.Z_MIN_LEVEL||e.level>t.Z_MAX_LEVEL){throw new Error("Invalid compression level: "+e.level)}}if(e.memLevel){if(e.memLevel<t.Z_MIN_MEMLEVEL||e.memLevel>t.Z_MAX_MEMLEVEL){throw new Error("Invalid memLevel: "+e.memLevel)}}if(e.strategy){if(e.strategy!=t.Z_FILTERED&&e.strategy!=t.Z_HUFFMAN_ONLY&&e.strategy!=t.Z_RLE&&e.strategy!=t.Z_FIXED&&e.strategy!=t.Z_DEFAULT_STRATEGY){throw new Error("Invalid strategy: "+e.strategy)}}if(e.dictionary){if(!a.isBuffer(e.dictionary)){throw new Error("Invalid dictionary: it should be a Buffer instance")}}this._handle=new n.Zlib(i);var l=this;this._hadError=false;this._handle.onerror=function(e,i){_close(l);l._hadError=true;var a=new Error(e);a.errno=i;a.code=t.codes[i];l.emit("error",a)};var f=t.Z_DEFAULT_COMPRESSION;if(typeof e.level==="number")f=e.level;var o=t.Z_DEFAULT_STRATEGY;if(typeof e.strategy==="number")o=e.strategy;this._handle.init(e.windowBits||t.Z_DEFAULT_WINDOWBITS,f,e.memLevel||t.Z_DEFAULT_MEMLEVEL,o,e.dictionary);this._buffer=a.allocUnsafe(this._chunkSize);this._offset=0;this._level=f;this._strategy=o;this.once("end",this.close);Object.defineProperty(this,"_closed",{get:function(){return!s._handle},configurable:true,enumerable:true})}s.inherits(Zlib,r);Zlib.prototype.params=function(e,i,a){if(e<t.Z_MIN_LEVEL||e>t.Z_MAX_LEVEL){throw new RangeError("Invalid compression level: "+e)}if(i!=t.Z_FILTERED&&i!=t.Z_HUFFMAN_ONLY&&i!=t.Z_RLE&&i!=t.Z_FIXED&&i!=t.Z_DEFAULT_STRATEGY){throw new TypeError("Invalid strategy: "+i)}if(this._level!==e||this._strategy!==i){var r=this;this.flush(n.Z_SYNC_FLUSH,(function(){l(r._handle,"zlib binding closed");r._handle.params(e,i);if(!r._hadError){r._level=e;r._strategy=i;if(a)a()}}))}else{process.nextTick(a)}};Zlib.prototype.reset=function(){l(this._handle,"zlib binding closed");return this._handle.reset()};Zlib.prototype._flush=function(e){this._transform(a.alloc(0),"",e)};Zlib.prototype.flush=function(e,t){var i=this;var r=this._writableState;if(typeof e==="function"||e===undefined&&!t){t=e;e=n.Z_FULL_FLUSH}if(r.ended){if(t)process.nextTick(t)}else if(r.ending){if(t)this.once("end",t)}else if(r.needDrain){if(t){this.once("drain",(function(){return i.flush(e,t)}))}}else{this._flushFlag=e;this.write(a.alloc(0),"",t)}};Zlib.prototype.close=function(e){_close(this,e);process.nextTick(emitCloseNT,this)};function _close(e,t){if(t)process.nextTick(t);if(!e._handle)return;e._handle.close();e._handle=null}function emitCloseNT(e){e.emit("close")}Zlib.prototype._transform=function(e,t,i){var r;var s=this._writableState;var l=s.ending||s.ended;var f=l&&(!e||s.length===e.length);if(e!==null&&!a.isBuffer(e))return i(new Error("invalid input"));if(!this._handle)return i(new Error("zlib binding closed"));if(f)r=this._finishFlushFlag;else{r=this._flushFlag;if(e.length>=s.length){this._flushFlag=this._opts.flush||n.Z_NO_FLUSH}}this._processChunk(e,r,i)};Zlib.prototype._processChunk=function(e,t,i){var r=e&&e.length;var n=this._chunkSize-this._offset;var s=0;var h=this;var _=typeof i==="function";if(!_){var d=[];var u=0;var c;this.on("error",(function(e){c=e}));l(this._handle,"zlib binding closed");do{var v=this._handle.writeSync(t,e,s,r,this._buffer,this._offset,n)}while(!this._hadError&&callback(v[0],v[1]));if(this._hadError){throw c}if(u>=f){_close(this);throw new RangeError(o)}var b=a.concat(d,u);_close(this);return b}l(this._handle,"zlib binding closed");var w=this._handle.write(t,e,s,r,this._buffer,this._offset,n);w.buffer=e;w.callback=callback;function callback(f,o){if(this){this.buffer=null;this.callback=null}if(h._hadError)return;var c=n-o;l(c>=0,"have should not go down");if(c>0){var v=h._buffer.slice(h._offset,h._offset+c);h._offset+=c;if(_){h.push(v)}else{d.push(v);u+=v.length}}if(o===0||h._offset>=h._chunkSize){n=h._chunkSize;h._offset=0;h._buffer=a.allocUnsafe(h._chunkSize)}if(o===0){s+=r-f;r=f;if(!_)return true;var b=h._handle.write(t,e,s,r,h._buffer,h._offset,h._chunkSize);b.callback=callback;b.buffer=e;return}if(!_)return false;i()}};s.inherits(Deflate,Zlib);s.inherits(Inflate,Zlib);s.inherits(Gzip,Zlib);s.inherits(Gunzip,Zlib);s.inherits(DeflateRaw,Zlib);s.inherits(InflateRaw,Zlib);s.inherits(Unzip,Zlib)},533:function(e,t){var i=typeof Uint8Array!=="undefined"&&typeof Uint16Array!=="undefined"&&typeof Int32Array!=="undefined";function _has(e,t){return Object.prototype.hasOwnProperty.call(e,t)}t.assign=function(e){var t=Array.prototype.slice.call(arguments,1);while(t.length){var i=t.shift();if(!i){continue}if(typeof i!=="object"){throw new TypeError(i+"must be non-object")}for(var a in i){if(_has(i,a)){e[a]=i[a]}}}return e};t.shrinkBuf=function(e,t){if(e.length===t){return e}if(e.subarray){return e.subarray(0,t)}e.length=t;return e};var a={arraySet:function(e,t,i,a,r){if(t.subarray&&e.subarray){e.set(t.subarray(i,i+a),r);return}for(var n=0;n<a;n++){e[r+n]=t[i+n]}},flattenChunks:function(e){var t,i,a,r,n,s;a=0;for(t=0,i=e.length;t<i;t++){a+=e[t].length}s=new Uint8Array(a);r=0;for(t=0,i=e.length;t<i;t++){n=e[t];s.set(n,r);r+=n.length}return s}};var r={arraySet:function(e,t,i,a,r){for(var n=0;n<a;n++){e[r+n]=t[i+n]}},flattenChunks:function(e){return[].concat.apply([],e)}};t.setTyped=function(e){if(e){t.Buf8=Uint8Array;t.Buf16=Uint16Array;t.Buf32=Int32Array;t.assign(t,a)}else{t.Buf8=Array;t.Buf16=Array;t.Buf32=Array;t.assign(t,r)}};t.setTyped(i)},796:function(e){function adler32(e,t,i,a){var r=e&65535|0,n=e>>>16&65535|0,s=0;while(i!==0){s=i>2e3?2e3:i;i-=s;do{r=r+t[a++]|0;n=n+r|0}while(--s);r%=65521;n%=65521}return r|n<<16|0}e.exports=adler32},234:function(e){e.exports={Z_NO_FLUSH:0,Z_PARTIAL_FLUSH:1,Z_SYNC_FLUSH:2,Z_FULL_FLUSH:3,Z_FINISH:4,Z_BLOCK:5,Z_TREES:6,Z_OK:0,Z_STREAM_END:1,Z_NEED_DICT:2,Z_ERRNO:-1,Z_STREAM_ERROR:-2,Z_DATA_ERROR:-3,Z_BUF_ERROR:-5,Z_NO_COMPRESSION:0,Z_BEST_SPEED:1,Z_BEST_COMPRESSION:9,Z_DEFAULT_COMPRESSION:-1,Z_FILTERED:1,Z_HUFFMAN_ONLY:2,Z_RLE:3,Z_FIXED:4,Z_DEFAULT_STRATEGY:0,Z_BINARY:0,Z_TEXT:1,Z_UNKNOWN:2,Z_DEFLATED:8}},597:function(e){function makeTable(){var e,t=[];for(var i=0;i<256;i++){e=i;for(var a=0;a<8;a++){e=e&1?3988292384^e>>>1:e>>>1}t[i]=e}return t}var t=makeTable();function crc32(e,i,a,r){var n=t,s=r+a;e^=-1;for(var l=r;l<s;l++){e=e>>>8^n[(e^i[l])&255]}return e^-1}e.exports=crc32},492:function(e,t,i){var a=i(533);var r=i(427);var n=i(796);var s=i(597);var l=i(678);var f=0;var o=1;var h=3;var _=4;var d=5;var u=0;var c=1;var v=-2;var b=-3;var w=-5;var p=-1;var g=1;var m=2;var k=3;var y=4;var E=0;var z=2;var Z=8;var x=9;var I=15;var R=8;var S=29;var L=256;var A=L+1+S;var T=30;var F=19;var N=2*A+1;var D=15;var B=3;var U=258;var O=U+B+1;var M=32;var C=42;var G=69;var H=73;var P=91;var K=103;var W=113;var V=666;var q=1;var X=2;var Y=3;var j=4;var J=3;function err(e,t){e.msg=l[t];return t}function rank(e){return(e<<1)-(e>4?9:0)}function zero(e){var t=e.length;while(--t>=0){e[t]=0}}function flush_pending(e){var t=e.state;var i=t.pending;if(i>e.avail_out){i=e.avail_out}if(i===0){return}a.arraySet(e.output,t.pending_buf,t.pending_out,i,e.next_out);e.next_out+=i;t.pending_out+=i;e.total_out+=i;e.avail_out-=i;t.pending-=i;if(t.pending===0){t.pending_out=0}}function flush_block_only(e,t){r._tr_flush_block(e,e.block_start>=0?e.block_start:-1,e.strstart-e.block_start,t);e.block_start=e.strstart;flush_pending(e.strm)}function put_byte(e,t){e.pending_buf[e.pending++]=t}function putShortMSB(e,t){e.pending_buf[e.pending++]=t>>>8&255;e.pending_buf[e.pending++]=t&255}function read_buf(e,t,i,r){var l=e.avail_in;if(l>r){l=r}if(l===0){return 0}e.avail_in-=l;a.arraySet(t,e.input,e.next_in,l,i);if(e.state.wrap===1){e.adler=n(e.adler,t,l,i)}else if(e.state.wrap===2){e.adler=s(e.adler,t,l,i)}e.next_in+=l;e.total_in+=l;return l}function longest_match(e,t){var i=e.max_chain_length;var a=e.strstart;var r;var n;var s=e.prev_length;var l=e.nice_match;var f=e.strstart>e.w_size-O?e.strstart-(e.w_size-O):0;var o=e.window;var h=e.w_mask;var _=e.prev;var d=e.strstart+U;var u=o[a+s-1];var c=o[a+s];if(e.prev_length>=e.good_match){i>>=2}if(l>e.lookahead){l=e.lookahead}do{r=t;if(o[r+s]!==c||o[r+s-1]!==u||o[r]!==o[a]||o[++r]!==o[a+1]){continue}a+=2;r++;do{}while(o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&o[++a]===o[++r]&&a<d);n=U-(d-a);a=d-U;if(n>s){e.match_start=t;s=n;if(n>=l){break}u=o[a+s-1];c=o[a+s]}}while((t=_[t&h])>f&&--i!==0);if(s<=e.lookahead){return s}return e.lookahead}function fill_window(e){var t=e.w_size;var i,r,n,s,l;do{s=e.window_size-e.lookahead-e.strstart;if(e.strstart>=t+(t-O)){a.arraySet(e.window,e.window,t,t,0);e.match_start-=t;e.strstart-=t;e.block_start-=t;r=e.hash_size;i=r;do{n=e.head[--i];e.head[i]=n>=t?n-t:0}while(--r);r=t;i=r;do{n=e.prev[--i];e.prev[i]=n>=t?n-t:0}while(--r);s+=t}if(e.strm.avail_in===0){break}r=read_buf(e.strm,e.window,e.strstart+e.lookahead,s);e.lookahead+=r;if(e.lookahead+e.insert>=B){l=e.strstart-e.insert;e.ins_h=e.window[l];e.ins_h=(e.ins_h<<e.hash_shift^e.window[l+1])&e.hash_mask;while(e.insert){e.ins_h=(e.ins_h<<e.hash_shift^e.window[l+B-1])&e.hash_mask;e.prev[l&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=l;l++;e.insert--;if(e.lookahead+e.insert<B){break}}}}while(e.lookahead<O&&e.strm.avail_in!==0)}function deflate_stored(e,t){var i=65535;if(i>e.pending_buf_size-5){i=e.pending_buf_size-5}for(;;){if(e.lookahead<=1){fill_window(e);if(e.lookahead===0&&t===f){return q}if(e.lookahead===0){break}}e.strstart+=e.lookahead;e.lookahead=0;var a=e.block_start+i;if(e.strstart===0||e.strstart>=a){e.lookahead=e.strstart-a;e.strstart=a;flush_block_only(e,false);if(e.strm.avail_out===0){return q}}if(e.strstart-e.block_start>=e.w_size-O){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}e.insert=0;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.strstart>e.block_start){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return q}function deflate_fast(e,t){var i;var a;for(;;){if(e.lookahead<O){fill_window(e);if(e.lookahead<O&&t===f){return q}if(e.lookahead===0){break}}i=0;if(e.lookahead>=B){e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+B-1])&e.hash_mask;i=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}if(i!==0&&e.strstart-i<=e.w_size-O){e.match_length=longest_match(e,i)}if(e.match_length>=B){a=r._tr_tally(e,e.strstart-e.match_start,e.match_length-B);e.lookahead-=e.match_length;if(e.match_length<=e.max_lazy_match&&e.lookahead>=B){e.match_length--;do{e.strstart++;e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+B-1])&e.hash_mask;i=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}while(--e.match_length!==0);e.strstart++}else{e.strstart+=e.match_length;e.match_length=0;e.ins_h=e.window[e.strstart];e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+1])&e.hash_mask}}else{a=r._tr_tally(e,0,e.window[e.strstart]);e.lookahead--;e.strstart++}if(a){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}e.insert=e.strstart<B-1?e.strstart:B-1;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.last_lit){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return X}function deflate_slow(e,t){var i;var a;var n;for(;;){if(e.lookahead<O){fill_window(e);if(e.lookahead<O&&t===f){return q}if(e.lookahead===0){break}}i=0;if(e.lookahead>=B){e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+B-1])&e.hash_mask;i=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}e.prev_length=e.match_length;e.prev_match=e.match_start;e.match_length=B-1;if(i!==0&&e.prev_length<e.max_lazy_match&&e.strstart-i<=e.w_size-O){e.match_length=longest_match(e,i);if(e.match_length<=5&&(e.strategy===g||e.match_length===B&&e.strstart-e.match_start>4096)){e.match_length=B-1}}if(e.prev_length>=B&&e.match_length<=e.prev_length){n=e.strstart+e.lookahead-B;a=r._tr_tally(e,e.strstart-1-e.prev_match,e.prev_length-B);e.lookahead-=e.prev_length-1;e.prev_length-=2;do{if(++e.strstart<=n){e.ins_h=(e.ins_h<<e.hash_shift^e.window[e.strstart+B-1])&e.hash_mask;i=e.prev[e.strstart&e.w_mask]=e.head[e.ins_h];e.head[e.ins_h]=e.strstart}}while(--e.prev_length!==0);e.match_available=0;e.match_length=B-1;e.strstart++;if(a){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}else if(e.match_available){a=r._tr_tally(e,0,e.window[e.strstart-1]);if(a){flush_block_only(e,false)}e.strstart++;e.lookahead--;if(e.strm.avail_out===0){return q}}else{e.match_available=1;e.strstart++;e.lookahead--}}if(e.match_available){a=r._tr_tally(e,0,e.window[e.strstart-1]);e.match_available=0}e.insert=e.strstart<B-1?e.strstart:B-1;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.last_lit){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return X}function deflate_rle(e,t){var i;var a;var n,s;var l=e.window;for(;;){if(e.lookahead<=U){fill_window(e);if(e.lookahead<=U&&t===f){return q}if(e.lookahead===0){break}}e.match_length=0;if(e.lookahead>=B&&e.strstart>0){n=e.strstart-1;a=l[n];if(a===l[++n]&&a===l[++n]&&a===l[++n]){s=e.strstart+U;do{}while(a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&a===l[++n]&&n<s);e.match_length=U-(s-n);if(e.match_length>e.lookahead){e.match_length=e.lookahead}}}if(e.match_length>=B){i=r._tr_tally(e,1,e.match_length-B);e.lookahead-=e.match_length;e.strstart+=e.match_length;e.match_length=0}else{i=r._tr_tally(e,0,e.window[e.strstart]);e.lookahead--;e.strstart++}if(i){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}e.insert=0;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.last_lit){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return X}function deflate_huff(e,t){var i;for(;;){if(e.lookahead===0){fill_window(e);if(e.lookahead===0){if(t===f){return q}break}}e.match_length=0;i=r._tr_tally(e,0,e.window[e.strstart]);e.lookahead--;e.strstart++;if(i){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}}e.insert=0;if(t===_){flush_block_only(e,true);if(e.strm.avail_out===0){return Y}return j}if(e.last_lit){flush_block_only(e,false);if(e.strm.avail_out===0){return q}}return X}function Config(e,t,i,a,r){this.good_length=e;this.max_lazy=t;this.nice_length=i;this.max_chain=a;this.func=r}var Q;Q=[new Config(0,0,0,0,deflate_stored),new Config(4,4,8,4,deflate_fast),new Config(4,5,16,8,deflate_fast),new Config(4,6,32,32,deflate_fast),new Config(4,4,16,16,deflate_slow),new Config(8,16,32,32,deflate_slow),new Config(8,16,128,128,deflate_slow),new Config(8,32,128,256,deflate_slow),new Config(32,128,258,1024,deflate_slow),new Config(32,258,258,4096,deflate_slow)];function lm_init(e){e.window_size=2*e.w_size;zero(e.head);e.max_lazy_match=Q[e.level].max_lazy;e.good_match=Q[e.level].good_length;e.nice_match=Q[e.level].nice_length;e.max_chain_length=Q[e.level].max_chain;e.strstart=0;e.block_start=0;e.lookahead=0;e.insert=0;e.match_length=e.prev_length=B-1;e.match_available=0;e.ins_h=0}function DeflateState(){this.strm=null;this.status=0;this.pending_buf=null;this.pending_buf_size=0;this.pending_out=0;this.pending=0;this.wrap=0;this.gzhead=null;this.gzindex=0;this.method=Z;this.last_flush=-1;this.w_size=0;this.w_bits=0;this.w_mask=0;this.window=null;this.window_size=0;this.prev=null;this.head=null;this.ins_h=0;this.hash_size=0;this.hash_bits=0;this.hash_mask=0;this.hash_shift=0;this.block_start=0;this.match_length=0;this.prev_match=0;this.match_available=0;this.strstart=0;this.match_start=0;this.lookahead=0;this.prev_length=0;this.max_chain_length=0;this.max_lazy_match=0;this.level=0;this.strategy=0;this.good_match=0;this.nice_match=0;this.dyn_ltree=new a.Buf16(N*2);this.dyn_dtree=new a.Buf16((2*T+1)*2);this.bl_tree=new a.Buf16((2*F+1)*2);zero(this.dyn_ltree);zero(this.dyn_dtree);zero(this.bl_tree);this.l_desc=null;this.d_desc=null;this.bl_desc=null;this.bl_count=new a.Buf16(D+1);this.heap=new a.Buf16(2*A+1);zero(this.heap);this.heap_len=0;this.heap_max=0;this.depth=new a.Buf16(2*A+1);zero(this.depth);this.l_buf=0;this.lit_bufsize=0;this.last_lit=0;this.d_buf=0;this.opt_len=0;this.static_len=0;this.matches=0;this.insert=0;this.bi_buf=0;this.bi_valid=0}function deflateResetKeep(e){var t;if(!e||!e.state){return err(e,v)}e.total_in=e.total_out=0;e.data_type=z;t=e.state;t.pending=0;t.pending_out=0;if(t.wrap<0){t.wrap=-t.wrap}t.status=t.wrap?C:W;e.adler=t.wrap===2?0:1;t.last_flush=f;r._tr_init(t);return u}function deflateReset(e){var t=deflateResetKeep(e);if(t===u){lm_init(e.state)}return t}function deflateSetHeader(e,t){if(!e||!e.state){return v}if(e.state.wrap!==2){return v}e.state.gzhead=t;return u}function deflateInit2(e,t,i,r,n,s){if(!e){return v}var l=1;if(t===p){t=6}if(r<0){l=0;r=-r}else if(r>15){l=2;r-=16}if(n<1||n>x||i!==Z||r<8||r>15||t<0||t>9||s<0||s>y){return err(e,v)}if(r===8){r=9}var f=new DeflateState;e.state=f;f.strm=e;f.wrap=l;f.gzhead=null;f.w_bits=r;f.w_size=1<<f.w_bits;f.w_mask=f.w_size-1;f.hash_bits=n+7;f.hash_size=1<<f.hash_bits;f.hash_mask=f.hash_size-1;f.hash_shift=~~((f.hash_bits+B-1)/B);f.window=new a.Buf8(f.w_size*2);f.head=new a.Buf16(f.hash_size);f.prev=new a.Buf16(f.w_size);f.lit_bufsize=1<<n+6;f.pending_buf_size=f.lit_bufsize*4;f.pending_buf=new a.Buf8(f.pending_buf_size);f.d_buf=1*f.lit_bufsize;f.l_buf=(1+2)*f.lit_bufsize;f.level=t;f.strategy=s;f.method=i;return deflateReset(e)}function deflateInit(e,t){return deflateInit2(e,t,Z,I,R,E)}function deflate(e,t){var i,a;var n,l;if(!e||!e.state||t>d||t<0){return e?err(e,v):v}a=e.state;if(!e.output||!e.input&&e.avail_in!==0||a.status===V&&t!==_){return err(e,e.avail_out===0?w:v)}a.strm=e;i=a.last_flush;a.last_flush=t;if(a.status===C){if(a.wrap===2){e.adler=0;put_byte(a,31);put_byte(a,139);put_byte(a,8);if(!a.gzhead){put_byte(a,0);put_byte(a,0);put_byte(a,0);put_byte(a,0);put_byte(a,0);put_byte(a,a.level===9?2:a.strategy>=m||a.level<2?4:0);put_byte(a,J);a.status=W}else{put_byte(a,(a.gzhead.text?1:0)+(a.gzhead.hcrc?2:0)+(!a.gzhead.extra?0:4)+(!a.gzhead.name?0:8)+(!a.gzhead.comment?0:16));put_byte(a,a.gzhead.time&255);put_byte(a,a.gzhead.time>>8&255);put_byte(a,a.gzhead.time>>16&255);put_byte(a,a.gzhead.time>>24&255);put_byte(a,a.level===9?2:a.strategy>=m||a.level<2?4:0);put_byte(a,a.gzhead.os&255);if(a.gzhead.extra&&a.gzhead.extra.length){put_byte(a,a.gzhead.extra.length&255);put_byte(a,a.gzhead.extra.length>>8&255)}if(a.gzhead.hcrc){e.adler=s(e.adler,a.pending_buf,a.pending,0)}a.gzindex=0;a.status=G}}else{var b=Z+(a.w_bits-8<<4)<<8;var p=-1;if(a.strategy>=m||a.level<2){p=0}else if(a.level<6){p=1}else if(a.level===6){p=2}else{p=3}b|=p<<6;if(a.strstart!==0){b|=M}b+=31-b%31;a.status=W;putShortMSB(a,b);if(a.strstart!==0){putShortMSB(a,e.adler>>>16);putShortMSB(a,e.adler&65535)}e.adler=1}}if(a.status===G){if(a.gzhead.extra){n=a.pending;while(a.gzindex<(a.gzhead.extra.length&65535)){if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}flush_pending(e);n=a.pending;if(a.pending===a.pending_buf_size){break}}put_byte(a,a.gzhead.extra[a.gzindex]&255);a.gzindex++}if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}if(a.gzindex===a.gzhead.extra.length){a.gzindex=0;a.status=H}}else{a.status=H}}if(a.status===H){if(a.gzhead.name){n=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}flush_pending(e);n=a.pending;if(a.pending===a.pending_buf_size){l=1;break}}if(a.gzindex<a.gzhead.name.length){l=a.gzhead.name.charCodeAt(a.gzindex++)&255}else{l=0}put_byte(a,l)}while(l!==0);if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}if(l===0){a.gzindex=0;a.status=P}}else{a.status=P}}if(a.status===P){if(a.gzhead.comment){n=a.pending;do{if(a.pending===a.pending_buf_size){if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}flush_pending(e);n=a.pending;if(a.pending===a.pending_buf_size){l=1;break}}if(a.gzindex<a.gzhead.comment.length){l=a.gzhead.comment.charCodeAt(a.gzindex++)&255}else{l=0}put_byte(a,l)}while(l!==0);if(a.gzhead.hcrc&&a.pending>n){e.adler=s(e.adler,a.pending_buf,a.pending-n,n)}if(l===0){a.status=K}}else{a.status=K}}if(a.status===K){if(a.gzhead.hcrc){if(a.pending+2>a.pending_buf_size){flush_pending(e)}if(a.pending+2<=a.pending_buf_size){put_byte(a,e.adler&255);put_byte(a,e.adler>>8&255);e.adler=0;a.status=W}}else{a.status=W}}if(a.pending!==0){flush_pending(e);if(e.avail_out===0){a.last_flush=-1;return u}}else if(e.avail_in===0&&rank(t)<=rank(i)&&t!==_){return err(e,w)}if(a.status===V&&e.avail_in!==0){return err(e,w)}if(e.avail_in!==0||a.lookahead!==0||t!==f&&a.status!==V){var g=a.strategy===m?deflate_huff(a,t):a.strategy===k?deflate_rle(a,t):Q[a.level].func(a,t);if(g===Y||g===j){a.status=V}if(g===q||g===Y){if(e.avail_out===0){a.last_flush=-1}return u}if(g===X){if(t===o){r._tr_align(a)}else if(t!==d){r._tr_stored_block(a,0,0,false);if(t===h){zero(a.head);if(a.lookahead===0){a.strstart=0;a.block_start=0;a.insert=0}}}flush_pending(e);if(e.avail_out===0){a.last_flush=-1;return u}}}if(t!==_){return u}if(a.wrap<=0){return c}if(a.wrap===2){put_byte(a,e.adler&255);put_byte(a,e.adler>>8&255);put_byte(a,e.adler>>16&255);put_byte(a,e.adler>>24&255);put_byte(a,e.total_in&255);put_byte(a,e.total_in>>8&255);put_byte(a,e.total_in>>16&255);put_byte(a,e.total_in>>24&255)}else{putShortMSB(a,e.adler>>>16);putShortMSB(a,e.adler&65535)}flush_pending(e);if(a.wrap>0){a.wrap=-a.wrap}return a.pending!==0?u:c}function deflateEnd(e){var t;if(!e||!e.state){return v}t=e.state.status;if(t!==C&&t!==G&&t!==H&&t!==P&&t!==K&&t!==W&&t!==V){return err(e,v)}e.state=null;return t===W?err(e,b):u}function deflateSetDictionary(e,t){var i=t.length;var r;var s,l;var f;var o;var h;var _;var d;if(!e||!e.state){return v}r=e.state;f=r.wrap;if(f===2||f===1&&r.status!==C||r.lookahead){return v}if(f===1){e.adler=n(e.adler,t,i,0)}r.wrap=0;if(i>=r.w_size){if(f===0){zero(r.head);r.strstart=0;r.block_start=0;r.insert=0}d=new a.Buf8(r.w_size);a.arraySet(d,t,i-r.w_size,r.w_size,0);t=d;i=r.w_size}o=e.avail_in;h=e.next_in;_=e.input;e.avail_in=i;e.next_in=0;e.input=t;fill_window(r);while(r.lookahead>=B){s=r.strstart;l=r.lookahead-(B-1);do{r.ins_h=(r.ins_h<<r.hash_shift^r.window[s+B-1])&r.hash_mask;r.prev[s&r.w_mask]=r.head[r.ins_h];r.head[r.ins_h]=s;s++}while(--l);r.strstart=s;r.lookahead=B-1;fill_window(r)}r.strstart+=r.lookahead;r.block_start=r.strstart;r.insert=r.lookahead;r.lookahead=0;r.match_length=r.prev_length=B-1;r.match_available=0;e.next_in=h;e.input=_;e.avail_in=o;r.wrap=f;return u}t.deflateInit=deflateInit;t.deflateInit2=deflateInit2;t.deflateReset=deflateReset;t.deflateResetKeep=deflateResetKeep;t.deflateSetHeader=deflateSetHeader;t.deflate=deflate;t.deflateEnd=deflateEnd;t.deflateSetDictionary=deflateSetDictionary;t.deflateInfo="pako deflate (from Nodeca project)"},163:function(e){var t=30;var i=12;e.exports=function inflate_fast(e,a){var r;var n;var s;var l;var f;var o;var h;var _;var d;var u;var c;var v;var b;var w;var p;var g;var m;var k;var y;var E;var z;var Z;var x;var I,R;r=e.state;n=e.next_in;I=e.input;s=n+(e.avail_in-5);l=e.next_out;R=e.output;f=l-(a-e.avail_out);o=l+(e.avail_out-257);h=r.dmax;_=r.wsize;d=r.whave;u=r.wnext;c=r.window;v=r.hold;b=r.bits;w=r.lencode;p=r.distcode;g=(1<<r.lenbits)-1;m=(1<<r.distbits)-1;e:do{if(b<15){v+=I[n++]<<b;b+=8;v+=I[n++]<<b;b+=8}k=w[v&g];t:for(;;){y=k>>>24;v>>>=y;b-=y;y=k>>>16&255;if(y===0){R[l++]=k&65535}else if(y&16){E=k&65535;y&=15;if(y){if(b<y){v+=I[n++]<<b;b+=8}E+=v&(1<<y)-1;v>>>=y;b-=y}if(b<15){v+=I[n++]<<b;b+=8;v+=I[n++]<<b;b+=8}k=p[v&m];i:for(;;){y=k>>>24;v>>>=y;b-=y;y=k>>>16&255;if(y&16){z=k&65535;y&=15;if(b<y){v+=I[n++]<<b;b+=8;if(b<y){v+=I[n++]<<b;b+=8}}z+=v&(1<<y)-1;if(z>h){e.msg="invalid distance too far back";r.mode=t;break e}v>>>=y;b-=y;y=l-f;if(z>y){y=z-y;if(y>d){if(r.sane){e.msg="invalid distance too far back";r.mode=t;break e}}Z=0;x=c;if(u===0){Z+=_-y;if(y<E){E-=y;do{R[l++]=c[Z++]}while(--y);Z=l-z;x=R}}else if(u<y){Z+=_+u-y;y-=u;if(y<E){E-=y;do{R[l++]=c[Z++]}while(--y);Z=0;if(u<E){y=u;E-=y;do{R[l++]=c[Z++]}while(--y);Z=l-z;x=R}}}else{Z+=u-y;if(y<E){E-=y;do{R[l++]=c[Z++]}while(--y);Z=l-z;x=R}}while(E>2){R[l++]=x[Z++];R[l++]=x[Z++];R[l++]=x[Z++];E-=3}if(E){R[l++]=x[Z++];if(E>1){R[l++]=x[Z++]}}}else{Z=l-z;do{R[l++]=R[Z++];R[l++]=R[Z++];R[l++]=R[Z++];E-=3}while(E>2);if(E){R[l++]=R[Z++];if(E>1){R[l++]=R[Z++]}}}}else if((y&64)===0){k=p[(k&65535)+(v&(1<<y)-1)];continue i}else{e.msg="invalid distance code";r.mode=t;break e}break}}else if((y&64)===0){k=w[(k&65535)+(v&(1<<y)-1)];continue t}else if(y&32){r.mode=i;break e}else{e.msg="invalid literal/length code";r.mode=t;break e}break}}while(n<s&&l<o);E=b>>3;n-=E;b-=E<<3;v&=(1<<b)-1;e.next_in=n;e.next_out=l;e.avail_in=n<s?5+(s-n):5-(n-s);e.avail_out=l<o?257+(o-l):257-(l-o);r.hold=v;r.bits=b;return}},422:function(e,t,i){var a=i(533);var r=i(796);var n=i(597);var s=i(163);var l=i(473);var f=0;var o=1;var h=2;var _=4;var d=5;var u=6;var c=0;var v=1;var b=2;var w=-2;var p=-3;var g=-4;var m=-5;var k=8;var y=1;var E=2;var z=3;var Z=4;var x=5;var I=6;var R=7;var S=8;var L=9;var A=10;var T=11;var F=12;var N=13;var D=14;var B=15;var U=16;var O=17;var M=18;var C=19;var G=20;var H=21;var P=22;var K=23;var W=24;var V=25;var q=26;var X=27;var Y=28;var j=29;var J=30;var Q=31;var $=32;var ee=852;var te=592;var ie=15;var ae=ie;function zswap32(e){return(e>>>24&255)+(e>>>8&65280)+((e&65280)<<8)+((e&255)<<24)}function InflateState(){this.mode=0;this.last=false;this.wrap=0;this.havedict=false;this.flags=0;this.dmax=0;this.check=0;this.total=0;this.head=null;this.wbits=0;this.wsize=0;this.whave=0;this.wnext=0;this.window=null;this.hold=0;this.bits=0;this.length=0;this.offset=0;this.extra=0;this.lencode=null;this.distcode=null;this.lenbits=0;this.distbits=0;this.ncode=0;this.nlen=0;this.ndist=0;this.have=0;this.next=null;this.lens=new a.Buf16(320);this.work=new a.Buf16(288);this.lendyn=null;this.distdyn=null;this.sane=0;this.back=0;this.was=0}function inflateResetKeep(e){var t;if(!e||!e.state){return w}t=e.state;e.total_in=e.total_out=t.total=0;e.msg="";if(t.wrap){e.adler=t.wrap&1}t.mode=y;t.last=0;t.havedict=0;t.dmax=32768;t.head=null;t.hold=0;t.bits=0;t.lencode=t.lendyn=new a.Buf32(ee);t.distcode=t.distdyn=new a.Buf32(te);t.sane=1;t.back=-1;return c}function inflateReset(e){var t;if(!e||!e.state){return w}t=e.state;t.wsize=0;t.whave=0;t.wnext=0;return inflateResetKeep(e)}function inflateReset2(e,t){var i;var a;if(!e||!e.state){return w}a=e.state;if(t<0){i=0;t=-t}else{i=(t>>4)+1;if(t<48){t&=15}}if(t&&(t<8||t>15)){return w}if(a.window!==null&&a.wbits!==t){a.window=null}a.wrap=i;a.wbits=t;return inflateReset(e)}function inflateInit2(e,t){var i;var a;if(!e){return w}a=new InflateState;e.state=a;a.window=null;i=inflateReset2(e,t);if(i!==c){e.state=null}return i}function inflateInit(e){return inflateInit2(e,ae)}var re=true;var ne,se;function fixedtables(e){if(re){var t;ne=new a.Buf32(512);se=new a.Buf32(32);t=0;while(t<144){e.lens[t++]=8}while(t<256){e.lens[t++]=9}while(t<280){e.lens[t++]=7}while(t<288){e.lens[t++]=8}l(o,e.lens,0,288,ne,0,e.work,{bits:9});t=0;while(t<32){e.lens[t++]=5}l(h,e.lens,0,32,se,0,e.work,{bits:5});re=false}e.lencode=ne;e.lenbits=9;e.distcode=se;e.distbits=5}function updatewindow(e,t,i,r){var n;var s=e.state;if(s.window===null){s.wsize=1<<s.wbits;s.wnext=0;s.whave=0;s.window=new a.Buf8(s.wsize)}if(r>=s.wsize){a.arraySet(s.window,t,i-s.wsize,s.wsize,0);s.wnext=0;s.whave=s.wsize}else{n=s.wsize-s.wnext;if(n>r){n=r}a.arraySet(s.window,t,i-r,n,s.wnext);r-=n;if(r){a.arraySet(s.window,t,i-r,r,0);s.wnext=r;s.whave=s.wsize}else{s.wnext+=n;if(s.wnext===s.wsize){s.wnext=0}if(s.whave<s.wsize){s.whave+=n}}}return 0}function inflate(e,t){var i;var ee,te;var ie;var ae;var re,ne;var se;var le;var fe,oe;var he;var _e;var de;var ue=0;var ce,ve,be;var we,pe,ge;var me;var ke;var ye=new a.Buf8(4);var Ee;var ze;var Ze=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];if(!e||!e.state||!e.output||!e.input&&e.avail_in!==0){return w}i=e.state;if(i.mode===F){i.mode=N}ae=e.next_out;te=e.output;ne=e.avail_out;ie=e.next_in;ee=e.input;re=e.avail_in;se=i.hold;le=i.bits;fe=re;oe=ne;ke=c;e:for(;;){switch(i.mode){case y:if(i.wrap===0){i.mode=N;break}while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(i.wrap&2&&se===35615){i.check=0;ye[0]=se&255;ye[1]=se>>>8&255;i.check=n(i.check,ye,2,0);se=0;le=0;i.mode=E;break}i.flags=0;if(i.head){i.head.done=false}if(!(i.wrap&1)||(((se&255)<<8)+(se>>8))%31){e.msg="incorrect header check";i.mode=J;break}if((se&15)!==k){e.msg="unknown compression method";i.mode=J;break}se>>>=4;le-=4;me=(se&15)+8;if(i.wbits===0){i.wbits=me}else if(me>i.wbits){e.msg="invalid window size";i.mode=J;break}i.dmax=1<<me;e.adler=i.check=1;i.mode=se&512?A:F;se=0;le=0;break;case E:while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.flags=se;if((i.flags&255)!==k){e.msg="unknown compression method";i.mode=J;break}if(i.flags&57344){e.msg="unknown header flags set";i.mode=J;break}if(i.head){i.head.text=se>>8&1}if(i.flags&512){ye[0]=se&255;ye[1]=se>>>8&255;i.check=n(i.check,ye,2,0)}se=0;le=0;i.mode=z;case z:while(le<32){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(i.head){i.head.time=se}if(i.flags&512){ye[0]=se&255;ye[1]=se>>>8&255;ye[2]=se>>>16&255;ye[3]=se>>>24&255;i.check=n(i.check,ye,4,0)}se=0;le=0;i.mode=Z;case Z:while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(i.head){i.head.xflags=se&255;i.head.os=se>>8}if(i.flags&512){ye[0]=se&255;ye[1]=se>>>8&255;i.check=n(i.check,ye,2,0)}se=0;le=0;i.mode=x;case x:if(i.flags&1024){while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.length=se;if(i.head){i.head.extra_len=se}if(i.flags&512){ye[0]=se&255;ye[1]=se>>>8&255;i.check=n(i.check,ye,2,0)}se=0;le=0}else if(i.head){i.head.extra=null}i.mode=I;case I:if(i.flags&1024){he=i.length;if(he>re){he=re}if(he){if(i.head){me=i.head.extra_len-i.length;if(!i.head.extra){i.head.extra=new Array(i.head.extra_len)}a.arraySet(i.head.extra,ee,ie,he,me)}if(i.flags&512){i.check=n(i.check,ee,he,ie)}re-=he;ie+=he;i.length-=he}if(i.length){break e}}i.length=0;i.mode=R;case R:if(i.flags&2048){if(re===0){break e}he=0;do{me=ee[ie+he++];if(i.head&&me&&i.length<65536){i.head.name+=String.fromCharCode(me)}}while(me&&he<re);if(i.flags&512){i.check=n(i.check,ee,he,ie)}re-=he;ie+=he;if(me){break e}}else if(i.head){i.head.name=null}i.length=0;i.mode=S;case S:if(i.flags&4096){if(re===0){break e}he=0;do{me=ee[ie+he++];if(i.head&&me&&i.length<65536){i.head.comment+=String.fromCharCode(me)}}while(me&&he<re);if(i.flags&512){i.check=n(i.check,ee,he,ie)}re-=he;ie+=he;if(me){break e}}else if(i.head){i.head.comment=null}i.mode=L;case L:if(i.flags&512){while(le<16){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(se!==(i.check&65535)){e.msg="header crc mismatch";i.mode=J;break}se=0;le=0}if(i.head){i.head.hcrc=i.flags>>9&1;i.head.done=true}e.adler=i.check=0;i.mode=F;break;case A:while(le<32){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}e.adler=i.check=zswap32(se);se=0;le=0;i.mode=T;case T:if(i.havedict===0){e.next_out=ae;e.avail_out=ne;e.next_in=ie;e.avail_in=re;i.hold=se;i.bits=le;return b}e.adler=i.check=1;i.mode=F;case F:if(t===d||t===u){break e}case N:if(i.last){se>>>=le&7;le-=le&7;i.mode=X;break}while(le<3){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.last=se&1;se>>>=1;le-=1;switch(se&3){case 0:i.mode=D;break;case 1:fixedtables(i);i.mode=G;if(t===u){se>>>=2;le-=2;break e}break;case 2:i.mode=O;break;case 3:e.msg="invalid block type";i.mode=J}se>>>=2;le-=2;break;case D:se>>>=le&7;le-=le&7;while(le<32){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if((se&65535)!==(se>>>16^65535)){e.msg="invalid stored block lengths";i.mode=J;break}i.length=se&65535;se=0;le=0;i.mode=B;if(t===u){break e}case B:i.mode=U;case U:he=i.length;if(he){if(he>re){he=re}if(he>ne){he=ne}if(he===0){break e}a.arraySet(te,ee,ie,he,ae);re-=he;ie+=he;ne-=he;ae+=he;i.length-=he;break}i.mode=F;break;case O:while(le<14){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.nlen=(se&31)+257;se>>>=5;le-=5;i.ndist=(se&31)+1;se>>>=5;le-=5;i.ncode=(se&15)+4;se>>>=4;le-=4;if(i.nlen>286||i.ndist>30){e.msg="too many length or distance symbols";i.mode=J;break}i.have=0;i.mode=M;case M:while(i.have<i.ncode){while(le<3){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.lens[Ze[i.have++]]=se&7;se>>>=3;le-=3}while(i.have<19){i.lens[Ze[i.have++]]=0}i.lencode=i.lendyn;i.lenbits=7;Ee={bits:i.lenbits};ke=l(f,i.lens,0,19,i.lencode,0,i.work,Ee);i.lenbits=Ee.bits;if(ke){e.msg="invalid code lengths set";i.mode=J;break}i.have=0;i.mode=C;case C:while(i.have<i.nlen+i.ndist){for(;;){ue=i.lencode[se&(1<<i.lenbits)-1];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(be<16){se>>>=ce;le-=ce;i.lens[i.have++]=be}else{if(be===16){ze=ce+2;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=ce;le-=ce;if(i.have===0){e.msg="invalid bit length repeat";i.mode=J;break}me=i.lens[i.have-1];he=3+(se&3);se>>>=2;le-=2}else if(be===17){ze=ce+3;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=ce;le-=ce;me=0;he=3+(se&7);se>>>=3;le-=3}else{ze=ce+7;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=ce;le-=ce;me=0;he=11+(se&127);se>>>=7;le-=7}if(i.have+he>i.nlen+i.ndist){e.msg="invalid bit length repeat";i.mode=J;break}while(he--){i.lens[i.have++]=me}}}if(i.mode===J){break}if(i.lens[256]===0){e.msg="invalid code -- missing end-of-block";i.mode=J;break}i.lenbits=9;Ee={bits:i.lenbits};ke=l(o,i.lens,0,i.nlen,i.lencode,0,i.work,Ee);i.lenbits=Ee.bits;if(ke){e.msg="invalid literal/lengths set";i.mode=J;break}i.distbits=6;i.distcode=i.distdyn;Ee={bits:i.distbits};ke=l(h,i.lens,i.nlen,i.ndist,i.distcode,0,i.work,Ee);i.distbits=Ee.bits;if(ke){e.msg="invalid distances set";i.mode=J;break}i.mode=G;if(t===u){break e}case G:i.mode=H;case H:if(re>=6&&ne>=258){e.next_out=ae;e.avail_out=ne;e.next_in=ie;e.avail_in=re;i.hold=se;i.bits=le;s(e,oe);ae=e.next_out;te=e.output;ne=e.avail_out;ie=e.next_in;ee=e.input;re=e.avail_in;se=i.hold;le=i.bits;if(i.mode===F){i.back=-1}break}i.back=0;for(;;){ue=i.lencode[se&(1<<i.lenbits)-1];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(ve&&(ve&240)===0){we=ce;pe=ve;ge=be;for(;;){ue=i.lencode[ge+((se&(1<<we+pe)-1)>>we)];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(we+ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=we;le-=we;i.back+=we}se>>>=ce;le-=ce;i.back+=ce;i.length=be;if(ve===0){i.mode=q;break}if(ve&32){i.back=-1;i.mode=F;break}if(ve&64){e.msg="invalid literal/length code";i.mode=J;break}i.extra=ve&15;i.mode=P;case P:if(i.extra){ze=i.extra;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.length+=se&(1<<i.extra)-1;se>>>=i.extra;le-=i.extra;i.back+=i.extra}i.was=i.length;i.mode=K;case K:for(;;){ue=i.distcode[se&(1<<i.distbits)-1];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if((ve&240)===0){we=ce;pe=ve;ge=be;for(;;){ue=i.distcode[ge+((se&(1<<we+pe)-1)>>we)];ce=ue>>>24;ve=ue>>>16&255;be=ue&65535;if(we+ce<=le){break}if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}se>>>=we;le-=we;i.back+=we}se>>>=ce;le-=ce;i.back+=ce;if(ve&64){e.msg="invalid distance code";i.mode=J;break}i.offset=be;i.extra=ve&15;i.mode=W;case W:if(i.extra){ze=i.extra;while(le<ze){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}i.offset+=se&(1<<i.extra)-1;se>>>=i.extra;le-=i.extra;i.back+=i.extra}if(i.offset>i.dmax){e.msg="invalid distance too far back";i.mode=J;break}i.mode=V;case V:if(ne===0){break e}he=oe-ne;if(i.offset>he){he=i.offset-he;if(he>i.whave){if(i.sane){e.msg="invalid distance too far back";i.mode=J;break}}if(he>i.wnext){he-=i.wnext;_e=i.wsize-he}else{_e=i.wnext-he}if(he>i.length){he=i.length}de=i.window}else{de=te;_e=ae-i.offset;he=i.length}if(he>ne){he=ne}ne-=he;i.length-=he;do{te[ae++]=de[_e++]}while(--he);if(i.length===0){i.mode=H}break;case q:if(ne===0){break e}te[ae++]=i.length;ne--;i.mode=H;break;case X:if(i.wrap){while(le<32){if(re===0){break e}re--;se|=ee[ie++]<<le;le+=8}oe-=ne;e.total_out+=oe;i.total+=oe;if(oe){e.adler=i.check=i.flags?n(i.check,te,oe,ae-oe):r(i.check,te,oe,ae-oe)}oe=ne;if((i.flags?se:zswap32(se))!==i.check){e.msg="incorrect data check";i.mode=J;break}se=0;le=0}i.mode=Y;case Y:if(i.wrap&&i.flags){while(le<32){if(re===0){break e}re--;se+=ee[ie++]<<le;le+=8}if(se!==(i.total&4294967295)){e.msg="incorrect length check";i.mode=J;break}se=0;le=0}i.mode=j;case j:ke=v;break e;case J:ke=p;break e;case Q:return g;case $:default:return w}}e.next_out=ae;e.avail_out=ne;e.next_in=ie;e.avail_in=re;i.hold=se;i.bits=le;if(i.wsize||oe!==e.avail_out&&i.mode<J&&(i.mode<X||t!==_)){if(updatewindow(e,e.output,e.next_out,oe-e.avail_out)){i.mode=Q;return g}}fe-=e.avail_in;oe-=e.avail_out;e.total_in+=fe;e.total_out+=oe;i.total+=oe;if(i.wrap&&oe){e.adler=i.check=i.flags?n(i.check,te,oe,e.next_out-oe):r(i.check,te,oe,e.next_out-oe)}e.data_type=i.bits+(i.last?64:0)+(i.mode===F?128:0)+(i.mode===G||i.mode===B?256:0);if((fe===0&&oe===0||t===_)&&ke===c){ke=m}return ke}function inflateEnd(e){if(!e||!e.state){return w}var t=e.state;if(t.window){t.window=null}e.state=null;return c}function inflateGetHeader(e,t){var i;if(!e||!e.state){return w}i=e.state;if((i.wrap&2)===0){return w}i.head=t;t.done=false;return c}function inflateSetDictionary(e,t){var i=t.length;var a;var n;var s;if(!e||!e.state){return w}a=e.state;if(a.wrap!==0&&a.mode!==T){return w}if(a.mode===T){n=1;n=r(n,t,i,0);if(n!==a.check){return p}}s=updatewindow(e,t,i,i);if(s){a.mode=Q;return g}a.havedict=1;return c}t.inflateReset=inflateReset;t.inflateReset2=inflateReset2;t.inflateResetKeep=inflateResetKeep;t.inflateInit=inflateInit;t.inflateInit2=inflateInit2;t.inflate=inflate;t.inflateEnd=inflateEnd;t.inflateGetHeader=inflateGetHeader;t.inflateSetDictionary=inflateSetDictionary;t.inflateInfo="pako inflate (from Nodeca project)"},473:function(e,t,i){var a=i(533);var r=15;var n=852;var s=592;var l=0;var f=1;var o=2;var h=[3,4,5,6,7,8,9,10,11,13,15,17,19,23,27,31,35,43,51,59,67,83,99,115,131,163,195,227,258,0,0];var _=[16,16,16,16,16,16,16,16,17,17,17,17,18,18,18,18,19,19,19,19,20,20,20,20,21,21,21,21,16,72,78];var d=[1,2,3,4,5,7,9,13,17,25,33,49,65,97,129,193,257,385,513,769,1025,1537,2049,3073,4097,6145,8193,12289,16385,24577,0,0];var u=[16,16,16,16,17,17,18,18,19,19,20,20,21,21,22,22,23,23,24,24,25,25,26,26,27,27,28,28,29,29,64,64];e.exports=function inflate_table(e,t,i,c,v,b,w,p){var g=p.bits;var m=0;var k=0;var y=0,E=0;var z=0;var Z=0;var x=0;var I=0;var R=0;var S=0;var L;var A;var T;var F;var N;var D=null;var B=0;var U;var O=new a.Buf16(r+1);var M=new a.Buf16(r+1);var C=null;var G=0;var H,P,K;for(m=0;m<=r;m++){O[m]=0}for(k=0;k<c;k++){O[t[i+k]]++}z=g;for(E=r;E>=1;E--){if(O[E]!==0){break}}if(z>E){z=E}if(E===0){v[b++]=1<<24|64<<16|0;v[b++]=1<<24|64<<16|0;p.bits=1;return 0}for(y=1;y<E;y++){if(O[y]!==0){break}}if(z<y){z=y}I=1;for(m=1;m<=r;m++){I<<=1;I-=O[m];if(I<0){return-1}}if(I>0&&(e===l||E!==1)){return-1}M[1]=0;for(m=1;m<r;m++){M[m+1]=M[m]+O[m]}for(k=0;k<c;k++){if(t[i+k]!==0){w[M[t[i+k]]++]=k}}if(e===l){D=C=w;U=19}else if(e===f){D=h;B-=257;C=_;G-=257;U=256}else{D=d;C=u;U=-1}S=0;k=0;m=y;N=b;Z=z;x=0;T=-1;R=1<<z;F=R-1;if(e===f&&R>n||e===o&&R>s){return 1}for(;;){H=m-x;if(w[k]<U){P=0;K=w[k]}else if(w[k]>U){P=C[G+w[k]];K=D[B+w[k]]}else{P=32+64;K=0}L=1<<m-x;A=1<<Z;y=A;do{A-=L;v[N+(S>>x)+A]=H<<24|P<<16|K|0}while(A!==0);L=1<<m-1;while(S&L){L>>=1}if(L!==0){S&=L-1;S+=L}else{S=0}k++;if(--O[m]===0){if(m===E){break}m=t[i+w[k]]}if(m>z&&(S&F)!==T){if(x===0){x=z}N+=y;Z=m-x;I=1<<Z;while(Z+x<E){I-=O[Z+x];if(I<=0){break}Z++;I<<=1}R+=1<<Z;if(e===f&&R>n||e===o&&R>s){return 1}T=S&F;v[T]=z<<24|Z<<16|N-b|0}}if(S!==0){v[N+S]=m-x<<24|64<<16|0}p.bits=z;return 0}},678:function(e){e.exports={2:"need dictionary",1:"stream end",0:"","-1":"file error","-2":"stream error","-3":"data error","-4":"insufficient memory","-5":"buffer error","-6":"incompatible version"}},427:function(e,t,i){var a=i(533);var r=4;var n=0;var s=1;var l=2;function zero(e){var t=e.length;while(--t>=0){e[t]=0}}var f=0;var o=1;var h=2;var _=3;var d=258;var u=29;var c=256;var v=c+1+u;var b=30;var w=19;var p=2*v+1;var g=15;var m=16;var k=7;var y=256;var E=16;var z=17;var Z=18;var x=[0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0];var I=[0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13];var R=[0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,0,2,3,7];var S=[16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15];var L=512;var A=new Array((v+2)*2);zero(A);var T=new Array(b*2);zero(T);var F=new Array(L);zero(F);var N=new Array(d-_+1);zero(N);var D=new Array(u);zero(D);var B=new Array(b);zero(B);function StaticTreeDesc(e,t,i,a,r){this.static_tree=e;this.extra_bits=t;this.extra_base=i;this.elems=a;this.max_length=r;this.has_stree=e&&e.length}var U;var O;var M;function TreeDesc(e,t){this.dyn_tree=e;this.max_code=0;this.stat_desc=t}function d_code(e){return e<256?F[e]:F[256+(e>>>7)]}function put_short(e,t){e.pending_buf[e.pending++]=t&255;e.pending_buf[e.pending++]=t>>>8&255}function send_bits(e,t,i){if(e.bi_valid>m-i){e.bi_buf|=t<<e.bi_valid&65535;put_short(e,e.bi_buf);e.bi_buf=t>>m-e.bi_valid;e.bi_valid+=i-m}else{e.bi_buf|=t<<e.bi_valid&65535;e.bi_valid+=i}}function send_code(e,t,i){send_bits(e,i[t*2],i[t*2+1])}function bi_reverse(e,t){var i=0;do{i|=e&1;e>>>=1;i<<=1}while(--t>0);return i>>>1}function bi_flush(e){if(e.bi_valid===16){put_short(e,e.bi_buf);e.bi_buf=0;e.bi_valid=0}else if(e.bi_valid>=8){e.pending_buf[e.pending++]=e.bi_buf&255;e.bi_buf>>=8;e.bi_valid-=8}}function gen_bitlen(e,t){var i=t.dyn_tree;var a=t.max_code;var r=t.stat_desc.static_tree;var n=t.stat_desc.has_stree;var s=t.stat_desc.extra_bits;var l=t.stat_desc.extra_base;var f=t.stat_desc.max_length;var o;var h,_;var d;var u;var c;var v=0;for(d=0;d<=g;d++){e.bl_count[d]=0}i[e.heap[e.heap_max]*2+1]=0;for(o=e.heap_max+1;o<p;o++){h=e.heap[o];d=i[i[h*2+1]*2+1]+1;if(d>f){d=f;v++}i[h*2+1]=d;if(h>a){continue}e.bl_count[d]++;u=0;if(h>=l){u=s[h-l]}c=i[h*2];e.opt_len+=c*(d+u);if(n){e.static_len+=c*(r[h*2+1]+u)}}if(v===0){return}do{d=f-1;while(e.bl_count[d]===0){d--}e.bl_count[d]--;e.bl_count[d+1]+=2;e.bl_count[f]--;v-=2}while(v>0);for(d=f;d!==0;d--){h=e.bl_count[d];while(h!==0){_=e.heap[--o];if(_>a){continue}if(i[_*2+1]!==d){e.opt_len+=(d-i[_*2+1])*i[_*2];i[_*2+1]=d}h--}}}function gen_codes(e,t,i){var a=new Array(g+1);var r=0;var n;var s;for(n=1;n<=g;n++){a[n]=r=r+i[n-1]<<1}for(s=0;s<=t;s++){var l=e[s*2+1];if(l===0){continue}e[s*2]=bi_reverse(a[l]++,l)}}function tr_static_init(){var e;var t;var i;var a;var r;var n=new Array(g+1);i=0;for(a=0;a<u-1;a++){D[a]=i;for(e=0;e<1<<x[a];e++){N[i++]=a}}N[i-1]=a;r=0;for(a=0;a<16;a++){B[a]=r;for(e=0;e<1<<I[a];e++){F[r++]=a}}r>>=7;for(;a<b;a++){B[a]=r<<7;for(e=0;e<1<<I[a]-7;e++){F[256+r++]=a}}for(t=0;t<=g;t++){n[t]=0}e=0;while(e<=143){A[e*2+1]=8;e++;n[8]++}while(e<=255){A[e*2+1]=9;e++;n[9]++}while(e<=279){A[e*2+1]=7;e++;n[7]++}while(e<=287){A[e*2+1]=8;e++;n[8]++}gen_codes(A,v+1,n);for(e=0;e<b;e++){T[e*2+1]=5;T[e*2]=bi_reverse(e,5)}U=new StaticTreeDesc(A,x,c+1,v,g);O=new StaticTreeDesc(T,I,0,b,g);M=new StaticTreeDesc(new Array(0),R,0,w,k)}function init_block(e){var t;for(t=0;t<v;t++){e.dyn_ltree[t*2]=0}for(t=0;t<b;t++){e.dyn_dtree[t*2]=0}for(t=0;t<w;t++){e.bl_tree[t*2]=0}e.dyn_ltree[y*2]=1;e.opt_len=e.static_len=0;e.last_lit=e.matches=0}function bi_windup(e){if(e.bi_valid>8){put_short(e,e.bi_buf)}else if(e.bi_valid>0){e.pending_buf[e.pending++]=e.bi_buf}e.bi_buf=0;e.bi_valid=0}function copy_block(e,t,i,r){bi_windup(e);if(r){put_short(e,i);put_short(e,~i)}a.arraySet(e.pending_buf,e.window,t,i,e.pending);e.pending+=i}function smaller(e,t,i,a){var r=t*2;var n=i*2;return e[r]<e[n]||e[r]===e[n]&&a[t]<=a[i]}function pqdownheap(e,t,i){var a=e.heap[i];var r=i<<1;while(r<=e.heap_len){if(r<e.heap_len&&smaller(t,e.heap[r+1],e.heap[r],e.depth)){r++}if(smaller(t,a,e.heap[r],e.depth)){break}e.heap[i]=e.heap[r];i=r;r<<=1}e.heap[i]=a}function compress_block(e,t,i){var a;var r;var n=0;var s;var l;if(e.last_lit!==0){do{a=e.pending_buf[e.d_buf+n*2]<<8|e.pending_buf[e.d_buf+n*2+1];r=e.pending_buf[e.l_buf+n];n++;if(a===0){send_code(e,r,t)}else{s=N[r];send_code(e,s+c+1,t);l=x[s];if(l!==0){r-=D[s];send_bits(e,r,l)}a--;s=d_code(a);send_code(e,s,i);l=I[s];if(l!==0){a-=B[s];send_bits(e,a,l)}}}while(n<e.last_lit)}send_code(e,y,t)}function build_tree(e,t){var i=t.dyn_tree;var a=t.stat_desc.static_tree;var r=t.stat_desc.has_stree;var n=t.stat_desc.elems;var s,l;var f=-1;var o;e.heap_len=0;e.heap_max=p;for(s=0;s<n;s++){if(i[s*2]!==0){e.heap[++e.heap_len]=f=s;e.depth[s]=0}else{i[s*2+1]=0}}while(e.heap_len<2){o=e.heap[++e.heap_len]=f<2?++f:0;i[o*2]=1;e.depth[o]=0;e.opt_len--;if(r){e.static_len-=a[o*2+1]}}t.max_code=f;for(s=e.heap_len>>1;s>=1;s--){pqdownheap(e,i,s)}o=n;do{s=e.heap[1];e.heap[1]=e.heap[e.heap_len--];pqdownheap(e,i,1);l=e.heap[1];e.heap[--e.heap_max]=s;e.heap[--e.heap_max]=l;i[o*2]=i[s*2]+i[l*2];e.depth[o]=(e.depth[s]>=e.depth[l]?e.depth[s]:e.depth[l])+1;i[s*2+1]=i[l*2+1]=o;e.heap[1]=o++;pqdownheap(e,i,1)}while(e.heap_len>=2);e.heap[--e.heap_max]=e.heap[1];gen_bitlen(e,t);gen_codes(i,f,e.bl_count)}function scan_tree(e,t,i){var a;var r=-1;var n;var s=t[0*2+1];var l=0;var f=7;var o=4;if(s===0){f=138;o=3}t[(i+1)*2+1]=65535;for(a=0;a<=i;a++){n=s;s=t[(a+1)*2+1];if(++l<f&&n===s){continue}else if(l<o){e.bl_tree[n*2]+=l}else if(n!==0){if(n!==r){e.bl_tree[n*2]++}e.bl_tree[E*2]++}else if(l<=10){e.bl_tree[z*2]++}else{e.bl_tree[Z*2]++}l=0;r=n;if(s===0){f=138;o=3}else if(n===s){f=6;o=3}else{f=7;o=4}}}function send_tree(e,t,i){var a;var r=-1;var n;var s=t[0*2+1];var l=0;var f=7;var o=4;if(s===0){f=138;o=3}for(a=0;a<=i;a++){n=s;s=t[(a+1)*2+1];if(++l<f&&n===s){continue}else if(l<o){do{send_code(e,n,e.bl_tree)}while(--l!==0)}else if(n!==0){if(n!==r){send_code(e,n,e.bl_tree);l--}send_code(e,E,e.bl_tree);send_bits(e,l-3,2)}else if(l<=10){send_code(e,z,e.bl_tree);send_bits(e,l-3,3)}else{send_code(e,Z,e.bl_tree);send_bits(e,l-11,7)}l=0;r=n;if(s===0){f=138;o=3}else if(n===s){f=6;o=3}else{f=7;o=4}}}function build_bl_tree(e){var t;scan_tree(e,e.dyn_ltree,e.l_desc.max_code);scan_tree(e,e.dyn_dtree,e.d_desc.max_code);build_tree(e,e.bl_desc);for(t=w-1;t>=3;t--){if(e.bl_tree[S[t]*2+1]!==0){break}}e.opt_len+=3*(t+1)+5+5+4;return t}function send_all_trees(e,t,i,a){var r;send_bits(e,t-257,5);send_bits(e,i-1,5);send_bits(e,a-4,4);for(r=0;r<a;r++){send_bits(e,e.bl_tree[S[r]*2+1],3)}send_tree(e,e.dyn_ltree,t-1);send_tree(e,e.dyn_dtree,i-1)}function detect_data_type(e){var t=4093624447;var i;for(i=0;i<=31;i++,t>>>=1){if(t&1&&e.dyn_ltree[i*2]!==0){return n}}if(e.dyn_ltree[9*2]!==0||e.dyn_ltree[10*2]!==0||e.dyn_ltree[13*2]!==0){return s}for(i=32;i<c;i++){if(e.dyn_ltree[i*2]!==0){return s}}return n}var C=false;function _tr_init(e){if(!C){tr_static_init();C=true}e.l_desc=new TreeDesc(e.dyn_ltree,U);e.d_desc=new TreeDesc(e.dyn_dtree,O);e.bl_desc=new TreeDesc(e.bl_tree,M);e.bi_buf=0;e.bi_valid=0;init_block(e)}function _tr_stored_block(e,t,i,a){send_bits(e,(f<<1)+(a?1:0),3);copy_block(e,t,i,true)}function _tr_align(e){send_bits(e,o<<1,3);send_code(e,y,A);bi_flush(e)}function _tr_flush_block(e,t,i,a){var n,s;var f=0;if(e.level>0){if(e.strm.data_type===l){e.strm.data_type=detect_data_type(e)}build_tree(e,e.l_desc);build_tree(e,e.d_desc);f=build_bl_tree(e);n=e.opt_len+3+7>>>3;s=e.static_len+3+7>>>3;if(s<=n){n=s}}else{n=s=i+5}if(i+4<=n&&t!==-1){_tr_stored_block(e,t,i,a)}else if(e.strategy===r||s===n){send_bits(e,(o<<1)+(a?1:0),3);compress_block(e,A,T)}else{send_bits(e,(h<<1)+(a?1:0),3);send_all_trees(e,e.l_desc.max_code+1,e.d_desc.max_code+1,f+1);compress_block(e,e.dyn_ltree,e.dyn_dtree)}init_block(e);if(a){bi_windup(e)}}function _tr_tally(e,t,i){e.pending_buf[e.d_buf+e.last_lit*2]=t>>>8&255;e.pending_buf[e.d_buf+e.last_lit*2+1]=t&255;e.pending_buf[e.l_buf+e.last_lit]=i&255;e.last_lit++;if(t===0){e.dyn_ltree[i*2]++}else{e.matches++;t--;e.dyn_ltree[(N[i]+c+1)*2]++;e.dyn_dtree[d_code(t)*2]++}return e.last_lit===e.lit_bufsize-1}t._tr_init=_tr_init;t._tr_stored_block=_tr_stored_block;t._tr_flush_block=_tr_flush_block;t._tr_tally=_tr_tally;t._tr_align=_tr_align},944:function(e){function ZStream(){this.input=null;this.next_in=0;this.avail_in=0;this.total_in=0;this.output=null;this.next_out=0;this.avail_out=0;this.total_out=0;this.msg="";this.state=null;this.data_type=2;this.adler=0}e.exports=ZStream},491:function(e){e.exports=__webpack_require__(27596)},300:function(e){e.exports=__webpack_require__(48764)},781:function(e){e.exports=__webpack_require__(79681)},837:function(e){e.exports=__webpack_require__(79720)}};var t={};function __nccwpck_require__(i){var a=t[i];if(a!==undefined){return a.exports}var r=t[i]={exports:{}};var n=true;try{e[i](r,r.exports,__nccwpck_require__);n=false}finally{if(n)delete t[i]}return r.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var i=__nccwpck_require__(375);module.exports=i})();

/***/ }),

/***/ 42474:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/* provided dependency */ var process = __webpack_require__(83454);
(function(){var e={8557:function(e,t,r){var i=t;i.bignum=r(6884);i.define=r(9636).define;i.base=r(2207);i.constants=r(3503);i.decoders=r(5133);i.encoders=r(9245)},9636:function(e,t,r){var i=r(8557);var n=r(7526);var a=t;a.define=function define(e,t){return new Entity(e,t)};function Entity(e,t){this.name=e;this.body=t;this.decoders={};this.encoders={}}Entity.prototype._createNamed=function createNamed(e){var t;try{t=r(6144).runInThisContext("(function "+this.name+"(entity) {\n"+"  this._initNamed(entity);\n"+"})")}catch(e){t=function(e){this._initNamed(e)}}n(t,e);t.prototype._initNamed=function initnamed(t){e.call(this,t)};return new t(this)};Entity.prototype._getDecoder=function _getDecoder(e){e=e||"der";if(!this.decoders.hasOwnProperty(e))this.decoders[e]=this._createNamed(i.decoders[e]);return this.decoders[e]};Entity.prototype.decode=function decode(e,t,r){return this._getDecoder(t).decode(e,r)};Entity.prototype._getEncoder=function _getEncoder(e){e=e||"der";if(!this.encoders.hasOwnProperty(e))this.encoders[e]=this._createNamed(i.encoders[e]);return this.encoders[e]};Entity.prototype.encode=function encode(e,t,r){return this._getEncoder(t).encode(e,r)}},8483:function(e,t,r){var i=r(7526);var n=r(2207).Reporter;var a=r(4300).Buffer;function DecoderBuffer(e,t){n.call(this,t);if(!a.isBuffer(e)){this.error("Input not Buffer");return}this.base=e;this.offset=0;this.length=e.length}i(DecoderBuffer,n);t.C=DecoderBuffer;DecoderBuffer.prototype.save=function save(){return{offset:this.offset,reporter:n.prototype.save.call(this)}};DecoderBuffer.prototype.restore=function restore(e){var t=new DecoderBuffer(this.base);t.offset=e.offset;t.length=this.offset;this.offset=e.offset;n.prototype.restore.call(this,e.reporter);return t};DecoderBuffer.prototype.isEmpty=function isEmpty(){return this.offset===this.length};DecoderBuffer.prototype.readUInt8=function readUInt8(e){if(this.offset+1<=this.length)return this.base.readUInt8(this.offset++,true);else return this.error(e||"DecoderBuffer overrun")};DecoderBuffer.prototype.skip=function skip(e,t){if(!(this.offset+e<=this.length))return this.error(t||"DecoderBuffer overrun");var r=new DecoderBuffer(this.base);r._reporterState=this._reporterState;r.offset=this.offset;r.length=this.offset+e;this.offset+=e;return r};DecoderBuffer.prototype.raw=function raw(e){return this.base.slice(e?e.offset:this.offset,this.length)};function EncoderBuffer(e,t){if(Array.isArray(e)){this.length=0;this.value=e.map((function(e){if(!(e instanceof EncoderBuffer))e=new EncoderBuffer(e,t);this.length+=e.length;return e}),this)}else if(typeof e==="number"){if(!(0<=e&&e<=255))return t.error("non-byte EncoderBuffer value");this.value=e;this.length=1}else if(typeof e==="string"){this.value=e;this.length=a.byteLength(e)}else if(a.isBuffer(e)){this.value=e;this.length=e.length}else{return t.error("Unsupported type: "+typeof e)}}t.R=EncoderBuffer;EncoderBuffer.prototype.join=function join(e,t){if(!e)e=new a(this.length);if(!t)t=0;if(this.length===0)return e;if(Array.isArray(this.value)){this.value.forEach((function(r){r.join(e,t);t+=r.length}))}else{if(typeof this.value==="number")e[t]=this.value;else if(typeof this.value==="string")e.write(this.value,t);else if(a.isBuffer(this.value))this.value.copy(e,t);t+=this.length}return e}},2207:function(e,t,r){var i=t;i.Reporter=r(2148).b;i.DecoderBuffer=r(8483).C;i.EncoderBuffer=r(8483).R;i.Node=r(211)},211:function(e,t,r){var i=r(2207).Reporter;var n=r(2207).EncoderBuffer;var a=r(2207).DecoderBuffer;var s=r(9036);var o=["seq","seqof","set","setof","objid","bool","gentime","utctime","null_","enum","int","objDesc","bitstr","bmpstr","charstr","genstr","graphstr","ia5str","iso646str","numstr","octstr","printstr","t61str","unistr","utf8str","videostr"];var u=["key","obj","use","optional","explicit","implicit","def","choice","any","contains"].concat(o);var h=["_peekTag","_decodeTag","_use","_decodeStr","_decodeObjid","_decodeTime","_decodeNull","_decodeInt","_decodeBool","_decodeList","_encodeComposite","_encodeStr","_encodeObjid","_encodeTime","_encodeNull","_encodeInt","_encodeBool"];function Node(e,t){var r={};this._baseState=r;r.enc=e;r.parent=t||null;r.children=null;r.tag=null;r.args=null;r.reverseArgs=null;r.choice=null;r.optional=false;r.any=false;r.obj=false;r.use=null;r.useDecoder=null;r.key=null;r["default"]=null;r.explicit=null;r.implicit=null;r.contains=null;if(!r.parent){r.children=[];this._wrap()}}e.exports=Node;var d=["enc","parent","children","tag","args","reverseArgs","choice","optional","any","obj","use","alteredUse","key","default","explicit","implicit","contains"];Node.prototype.clone=function clone(){var e=this._baseState;var t={};d.forEach((function(r){t[r]=e[r]}));var r=new this.constructor(t.parent);r._baseState=t;return r};Node.prototype._wrap=function wrap(){var e=this._baseState;u.forEach((function(t){this[t]=function _wrappedMethod(){var r=new this.constructor(this);e.children.push(r);return r[t].apply(r,arguments)}}),this)};Node.prototype._init=function init(e){var t=this._baseState;s(t.parent===null);e.call(this);t.children=t.children.filter((function(e){return e._baseState.parent===this}),this);s.equal(t.children.length,1,"Root node can have only one child")};Node.prototype._useArgs=function useArgs(e){var t=this._baseState;var r=e.filter((function(e){return e instanceof this.constructor}),this);e=e.filter((function(e){return!(e instanceof this.constructor)}),this);if(r.length!==0){s(t.children===null);t.children=r;r.forEach((function(e){e._baseState.parent=this}),this)}if(e.length!==0){s(t.args===null);t.args=e;t.reverseArgs=e.map((function(e){if(typeof e!=="object"||e.constructor!==Object)return e;var t={};Object.keys(e).forEach((function(r){if(r==(r|0))r|=0;var i=e[r];t[i]=r}));return t}))}};h.forEach((function(e){Node.prototype[e]=function _overrided(){var t=this._baseState;throw new Error(e+" not implemented for encoding: "+t.enc)}}));o.forEach((function(e){Node.prototype[e]=function _tagMethod(){var t=this._baseState;var r=Array.prototype.slice.call(arguments);s(t.tag===null);t.tag=e;this._useArgs(r);return this}}));Node.prototype.use=function use(e){s(e);var t=this._baseState;s(t.use===null);t.use=e;return this};Node.prototype.optional=function optional(){var e=this._baseState;e.optional=true;return this};Node.prototype.def=function def(e){var t=this._baseState;s(t["default"]===null);t["default"]=e;t.optional=true;return this};Node.prototype.explicit=function explicit(e){var t=this._baseState;s(t.explicit===null&&t.implicit===null);t.explicit=e;return this};Node.prototype.implicit=function implicit(e){var t=this._baseState;s(t.explicit===null&&t.implicit===null);t.implicit=e;return this};Node.prototype.obj=function obj(){var e=this._baseState;var t=Array.prototype.slice.call(arguments);e.obj=true;if(t.length!==0)this._useArgs(t);return this};Node.prototype.key=function key(e){var t=this._baseState;s(t.key===null);t.key=e;return this};Node.prototype.any=function any(){var e=this._baseState;e.any=true;return this};Node.prototype.choice=function choice(e){var t=this._baseState;s(t.choice===null);t.choice=e;this._useArgs(Object.keys(e).map((function(t){return e[t]})));return this};Node.prototype.contains=function contains(e){var t=this._baseState;s(t.use===null);t.contains=e;return this};Node.prototype._decode=function decode(e,t){var r=this._baseState;if(r.parent===null)return e.wrapResult(r.children[0]._decode(e,t));var i=r["default"];var n=true;var s=null;if(r.key!==null)s=e.enterKey(r.key);if(r.optional){var o=null;if(r.explicit!==null)o=r.explicit;else if(r.implicit!==null)o=r.implicit;else if(r.tag!==null)o=r.tag;if(o===null&&!r.any){var u=e.save();try{if(r.choice===null)this._decodeGeneric(r.tag,e,t);else this._decodeChoice(e,t);n=true}catch(e){n=false}e.restore(u)}else{n=this._peekTag(e,o,r.any);if(e.isError(n))return n}}var h;if(r.obj&&n)h=e.enterObject();if(n){if(r.explicit!==null){var d=this._decodeTag(e,r.explicit);if(e.isError(d))return d;e=d}var c=e.offset;if(r.use===null&&r.choice===null){if(r.any)var u=e.save();var l=this._decodeTag(e,r.implicit!==null?r.implicit:r.tag,r.any);if(e.isError(l))return l;if(r.any)i=e.raw(u);else e=l}if(t&&t.track&&r.tag!==null)t.track(e.path(),c,e.length,"tagged");if(t&&t.track&&r.tag!==null)t.track(e.path(),e.offset,e.length,"content");if(r.any)i=i;else if(r.choice===null)i=this._decodeGeneric(r.tag,e,t);else i=this._decodeChoice(e,t);if(e.isError(i))return i;if(!r.any&&r.choice===null&&r.children!==null){r.children.forEach((function decodeChildren(r){r._decode(e,t)}))}if(r.contains&&(r.tag==="octstr"||r.tag==="bitstr")){var p=new a(i);i=this._getUse(r.contains,e._reporterState.obj)._decode(p,t)}}if(r.obj&&n)i=e.leaveObject(h);if(r.key!==null&&(i!==null||n===true))e.leaveKey(s,r.key,i);else if(s!==null)e.exitKey(s);return i};Node.prototype._decodeGeneric=function decodeGeneric(e,t,r){var i=this._baseState;if(e==="seq"||e==="set")return null;if(e==="seqof"||e==="setof")return this._decodeList(t,e,i.args[0],r);else if(/str$/.test(e))return this._decodeStr(t,e,r);else if(e==="objid"&&i.args)return this._decodeObjid(t,i.args[0],i.args[1],r);else if(e==="objid")return this._decodeObjid(t,null,null,r);else if(e==="gentime"||e==="utctime")return this._decodeTime(t,e,r);else if(e==="null_")return this._decodeNull(t,r);else if(e==="bool")return this._decodeBool(t,r);else if(e==="objDesc")return this._decodeStr(t,e,r);else if(e==="int"||e==="enum")return this._decodeInt(t,i.args&&i.args[0],r);if(i.use!==null){return this._getUse(i.use,t._reporterState.obj)._decode(t,r)}else{return t.error("unknown tag: "+e)}};Node.prototype._getUse=function _getUse(e,t){var r=this._baseState;r.useDecoder=this._use(e,t);s(r.useDecoder._baseState.parent===null);r.useDecoder=r.useDecoder._baseState.children[0];if(r.implicit!==r.useDecoder._baseState.implicit){r.useDecoder=r.useDecoder.clone();r.useDecoder._baseState.implicit=r.implicit}return r.useDecoder};Node.prototype._decodeChoice=function decodeChoice(e,t){var r=this._baseState;var i=null;var n=false;Object.keys(r.choice).some((function(a){var s=e.save();var o=r.choice[a];try{var u=o._decode(e,t);if(e.isError(u))return false;i={type:a,value:u};n=true}catch(t){e.restore(s);return false}return true}),this);if(!n)return e.error("Choice not matched");return i};Node.prototype._createEncoderBuffer=function createEncoderBuffer(e){return new n(e,this.reporter)};Node.prototype._encode=function encode(e,t,r){var i=this._baseState;if(i["default"]!==null&&i["default"]===e)return;var n=this._encodeValue(e,t,r);if(n===undefined)return;if(this._skipDefault(n,t,r))return;return n};Node.prototype._encodeValue=function encode(e,t,r){var n=this._baseState;if(n.parent===null)return n.children[0]._encode(e,t||new i);var a=null;this.reporter=t;if(n.optional&&e===undefined){if(n["default"]!==null)e=n["default"];else return}var s=null;var o=false;if(n.any){a=this._createEncoderBuffer(e)}else if(n.choice){a=this._encodeChoice(e,t)}else if(n.contains){s=this._getUse(n.contains,r)._encode(e,t);o=true}else if(n.children){s=n.children.map((function(r){if(r._baseState.tag==="null_")return r._encode(null,t,e);if(r._baseState.key===null)return t.error("Child should have a key");var i=t.enterKey(r._baseState.key);if(typeof e!=="object")return t.error("Child expected, but input is not object");var n=r._encode(e[r._baseState.key],t,e);t.leaveKey(i);return n}),this).filter((function(e){return e}));s=this._createEncoderBuffer(s)}else{if(n.tag==="seqof"||n.tag==="setof"){if(!(n.args&&n.args.length===1))return t.error("Too many args for : "+n.tag);if(!Array.isArray(e))return t.error("seqof/setof, but data is not Array");var u=this.clone();u._baseState.implicit=null;s=this._createEncoderBuffer(e.map((function(r){var i=this._baseState;return this._getUse(i.args[0],e)._encode(r,t)}),u))}else if(n.use!==null){a=this._getUse(n.use,r)._encode(e,t)}else{s=this._encodePrimitive(n.tag,e);o=true}}var a;if(!n.any&&n.choice===null){var h=n.implicit!==null?n.implicit:n.tag;var d=n.implicit===null?"universal":"context";if(h===null){if(n.use===null)t.error("Tag could be omitted only for .use()")}else{if(n.use===null)a=this._encodeComposite(h,o,d,s)}}if(n.explicit!==null)a=this._encodeComposite(n.explicit,false,"context",a);return a};Node.prototype._encodeChoice=function encodeChoice(e,t){var r=this._baseState;var i=r.choice[e.type];if(!i){s(false,e.type+" not found in "+JSON.stringify(Object.keys(r.choice)))}return i._encode(e.value,t)};Node.prototype._encodePrimitive=function encodePrimitive(e,t){var r=this._baseState;if(/str$/.test(e))return this._encodeStr(t,e);else if(e==="objid"&&r.args)return this._encodeObjid(t,r.reverseArgs[0],r.args[1]);else if(e==="objid")return this._encodeObjid(t,null,null);else if(e==="gentime"||e==="utctime")return this._encodeTime(t,e);else if(e==="null_")return this._encodeNull();else if(e==="int"||e==="enum")return this._encodeInt(t,r.args&&r.reverseArgs[0]);else if(e==="bool")return this._encodeBool(t);else if(e==="objDesc")return this._encodeStr(t,e);else throw new Error("Unsupported tag: "+e)};Node.prototype._isNumstr=function isNumstr(e){return/^[0-9 ]*$/.test(e)};Node.prototype._isPrintstr=function isPrintstr(e){return/^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(e)}},2148:function(e,t,r){var i=r(7526);function Reporter(e){this._reporterState={obj:null,path:[],options:e||{},errors:[]}}t.b=Reporter;Reporter.prototype.isError=function isError(e){return e instanceof ReporterError};Reporter.prototype.save=function save(){var e=this._reporterState;return{obj:e.obj,pathLen:e.path.length}};Reporter.prototype.restore=function restore(e){var t=this._reporterState;t.obj=e.obj;t.path=t.path.slice(0,e.pathLen)};Reporter.prototype.enterKey=function enterKey(e){return this._reporterState.path.push(e)};Reporter.prototype.exitKey=function exitKey(e){var t=this._reporterState;t.path=t.path.slice(0,e-1)};Reporter.prototype.leaveKey=function leaveKey(e,t,r){var i=this._reporterState;this.exitKey(e);if(i.obj!==null)i.obj[t]=r};Reporter.prototype.path=function path(){return this._reporterState.path.join("/")};Reporter.prototype.enterObject=function enterObject(){var e=this._reporterState;var t=e.obj;e.obj={};return t};Reporter.prototype.leaveObject=function leaveObject(e){var t=this._reporterState;var r=t.obj;t.obj=e;return r};Reporter.prototype.error=function error(e){var t;var r=this._reporterState;var i=e instanceof ReporterError;if(i){t=e}else{t=new ReporterError(r.path.map((function(e){return"["+JSON.stringify(e)+"]"})).join(""),e.message||e,e.stack)}if(!r.options.partial)throw t;if(!i)r.errors.push(t);return t};Reporter.prototype.wrapResult=function wrapResult(e){var t=this._reporterState;if(!t.options.partial)return e;return{result:this.isError(e)?null:e,errors:t.errors}};function ReporterError(e,t){this.path=e;this.rethrow(t)}i(ReporterError,Error);ReporterError.prototype.rethrow=function rethrow(e){this.message=e+" at: "+(this.path||"(shallow)");if(Error.captureStackTrace)Error.captureStackTrace(this,ReporterError);if(!this.stack){try{throw new Error(this.message)}catch(e){this.stack=e.stack}}return this}},8880:function(e,t,r){var i=r(3503);t.tagClass={0:"universal",1:"application",2:"context",3:"private"};t.tagClassByName=i._reverse(t.tagClass);t.tag={0:"end",1:"bool",2:"int",3:"bitstr",4:"octstr",5:"null_",6:"objid",7:"objDesc",8:"external",9:"real",10:"enum",11:"embed",12:"utf8str",13:"relativeOid",16:"seq",17:"set",18:"numstr",19:"printstr",20:"t61str",21:"videostr",22:"ia5str",23:"utctime",24:"gentime",25:"graphstr",26:"iso646str",27:"genstr",28:"unistr",29:"charstr",30:"bmpstr"};t.tagByName=i._reverse(t.tag)},3503:function(e,t,r){var i=t;i._reverse=function reverse(e){var t={};Object.keys(e).forEach((function(r){if((r|0)==r)r=r|0;var i=e[r];t[i]=r}));return t};i.der=r(8880)},359:function(e,t,r){var i=r(7526);var n=r(8557);var a=n.base;var s=n.bignum;var o=n.constants.der;function DERDecoder(e){this.enc="der";this.name=e.name;this.entity=e;this.tree=new DERNode;this.tree._init(e.body)}e.exports=DERDecoder;DERDecoder.prototype.decode=function decode(e,t){if(!(e instanceof a.DecoderBuffer))e=new a.DecoderBuffer(e,t);return this.tree._decode(e,t)};function DERNode(e){a.Node.call(this,"der",e)}i(DERNode,a.Node);DERNode.prototype._peekTag=function peekTag(e,t,r){if(e.isEmpty())return false;var i=e.save();var n=derDecodeTag(e,'Failed to peek tag: "'+t+'"');if(e.isError(n))return n;e.restore(i);return n.tag===t||n.tagStr===t||n.tagStr+"of"===t||r};DERNode.prototype._decodeTag=function decodeTag(e,t,r){var i=derDecodeTag(e,'Failed to decode tag of "'+t+'"');if(e.isError(i))return i;var n=derDecodeLen(e,i.primitive,'Failed to get length of "'+t+'"');if(e.isError(n))return n;if(!r&&i.tag!==t&&i.tagStr!==t&&i.tagStr+"of"!==t){return e.error('Failed to match tag: "'+t+'"')}if(i.primitive||n!==null)return e.skip(n,'Failed to match body of: "'+t+'"');var a=e.save();var s=this._skipUntilEnd(e,'Failed to skip indefinite length body: "'+this.tag+'"');if(e.isError(s))return s;n=e.offset-a.offset;e.restore(a);return e.skip(n,'Failed to match body of: "'+t+'"')};DERNode.prototype._skipUntilEnd=function skipUntilEnd(e,t){while(true){var r=derDecodeTag(e,t);if(e.isError(r))return r;var i=derDecodeLen(e,r.primitive,t);if(e.isError(i))return i;var n;if(r.primitive||i!==null)n=e.skip(i);else n=this._skipUntilEnd(e,t);if(e.isError(n))return n;if(r.tagStr==="end")break}};DERNode.prototype._decodeList=function decodeList(e,t,r,i){var n=[];while(!e.isEmpty()){var a=this._peekTag(e,"end");if(e.isError(a))return a;var s=r.decode(e,"der",i);if(e.isError(s)&&a)break;n.push(s)}return n};DERNode.prototype._decodeStr=function decodeStr(e,t){if(t==="bitstr"){var r=e.readUInt8();if(e.isError(r))return r;return{unused:r,data:e.raw()}}else if(t==="bmpstr"){var i=e.raw();if(i.length%2===1)return e.error("Decoding of string type: bmpstr length mismatch");var n="";for(var a=0;a<i.length/2;a++){n+=String.fromCharCode(i.readUInt16BE(a*2))}return n}else if(t==="numstr"){var s=e.raw().toString("ascii");if(!this._isNumstr(s)){return e.error("Decoding of string type: "+"numstr unsupported characters")}return s}else if(t==="octstr"){return e.raw()}else if(t==="objDesc"){return e.raw()}else if(t==="printstr"){var o=e.raw().toString("ascii");if(!this._isPrintstr(o)){return e.error("Decoding of string type: "+"printstr unsupported characters")}return o}else if(/str$/.test(t)){return e.raw().toString()}else{return e.error("Decoding of string type: "+t+" unsupported")}};DERNode.prototype._decodeObjid=function decodeObjid(e,t,r){var i;var n=[];var a=0;while(!e.isEmpty()){var s=e.readUInt8();a<<=7;a|=s&127;if((s&128)===0){n.push(a);a=0}}if(s&128)n.push(a);var o=n[0]/40|0;var u=n[0]%40;if(r)i=n;else i=[o,u].concat(n.slice(1));if(t){var h=t[i.join(" ")];if(h===undefined)h=t[i.join(".")];if(h!==undefined)i=h}return i};DERNode.prototype._decodeTime=function decodeTime(e,t){var r=e.raw().toString();if(t==="gentime"){var i=r.slice(0,4)|0;var n=r.slice(4,6)|0;var a=r.slice(6,8)|0;var s=r.slice(8,10)|0;var o=r.slice(10,12)|0;var u=r.slice(12,14)|0}else if(t==="utctime"){var i=r.slice(0,2)|0;var n=r.slice(2,4)|0;var a=r.slice(4,6)|0;var s=r.slice(6,8)|0;var o=r.slice(8,10)|0;var u=r.slice(10,12)|0;if(i<70)i=2e3+i;else i=1900+i}else{return e.error("Decoding "+t+" time is not supported yet")}return Date.UTC(i,n-1,a,s,o,u,0)};DERNode.prototype._decodeNull=function decodeNull(e){return null};DERNode.prototype._decodeBool=function decodeBool(e){var t=e.readUInt8();if(e.isError(t))return t;else return t!==0};DERNode.prototype._decodeInt=function decodeInt(e,t){var r=e.raw();var i=new s(r);if(t)i=t[i.toString(10)]||i;return i};DERNode.prototype._use=function use(e,t){if(typeof e==="function")e=e(t);return e._getDecoder("der").tree};function derDecodeTag(e,t){var r=e.readUInt8(t);if(e.isError(r))return r;var i=o.tagClass[r>>6];var n=(r&32)===0;if((r&31)===31){var a=r;r=0;while((a&128)===128){a=e.readUInt8(t);if(e.isError(a))return a;r<<=7;r|=a&127}}else{r&=31}var s=o.tag[r];return{cls:i,primitive:n,tag:r,tagStr:s}}function derDecodeLen(e,t,r){var i=e.readUInt8(r);if(e.isError(i))return i;if(!t&&i===128)return null;if((i&128)===0){return i}var n=i&127;if(n>4)return e.error("length octect is too long");i=0;for(var a=0;a<n;a++){i<<=8;var s=e.readUInt8(r);if(e.isError(s))return s;i|=s}return i}},5133:function(e,t,r){var i=t;i.der=r(359);i.pem=r(1556)},1556:function(e,t,r){var i=r(7526);var n=r(4300).Buffer;var a=r(359);function PEMDecoder(e){a.call(this,e);this.enc="pem"}i(PEMDecoder,a);e.exports=PEMDecoder;PEMDecoder.prototype.decode=function decode(e,t){var r=e.toString().split(/[\r\n]+/g);var i=t.label.toUpperCase();var s=/^-----(BEGIN|END) ([^-]+)-----$/;var o=-1;var u=-1;for(var h=0;h<r.length;h++){var d=r[h].match(s);if(d===null)continue;if(d[2]!==i)continue;if(o===-1){if(d[1]!=="BEGIN")break;o=h}else{if(d[1]!=="END")break;u=h;break}}if(o===-1||u===-1)throw new Error("PEM section not found for: "+i);var c=r.slice(o+1,u).join("");c.replace(/[^a-z0-9\+\/=]+/gi,"");var l=new n(c,"base64");return a.prototype.decode.call(this,l,t)}},6125:function(e,t,r){var i=r(7526);var n=r(4300).Buffer;var a=r(8557);var s=a.base;var o=a.constants.der;function DEREncoder(e){this.enc="der";this.name=e.name;this.entity=e;this.tree=new DERNode;this.tree._init(e.body)}e.exports=DEREncoder;DEREncoder.prototype.encode=function encode(e,t){return this.tree._encode(e,t).join()};function DERNode(e){s.Node.call(this,"der",e)}i(DERNode,s.Node);DERNode.prototype._encodeComposite=function encodeComposite(e,t,r,i){var a=encodeTag(e,t,r,this.reporter);if(i.length<128){var s=new n(2);s[0]=a;s[1]=i.length;return this._createEncoderBuffer([s,i])}var o=1;for(var u=i.length;u>=256;u>>=8)o++;var s=new n(1+1+o);s[0]=a;s[1]=128|o;for(var u=1+o,h=i.length;h>0;u--,h>>=8)s[u]=h&255;return this._createEncoderBuffer([s,i])};DERNode.prototype._encodeStr=function encodeStr(e,t){if(t==="bitstr"){return this._createEncoderBuffer([e.unused|0,e.data])}else if(t==="bmpstr"){var r=new n(e.length*2);for(var i=0;i<e.length;i++){r.writeUInt16BE(e.charCodeAt(i),i*2)}return this._createEncoderBuffer(r)}else if(t==="numstr"){if(!this._isNumstr(e)){return this.reporter.error("Encoding of string type: numstr supports "+"only digits and space")}return this._createEncoderBuffer(e)}else if(t==="printstr"){if(!this._isPrintstr(e)){return this.reporter.error("Encoding of string type: printstr supports "+"only latin upper and lower case letters, "+"digits, space, apostrophe, left and rigth "+"parenthesis, plus sign, comma, hyphen, "+"dot, slash, colon, equal sign, "+"question mark")}return this._createEncoderBuffer(e)}else if(/str$/.test(t)){return this._createEncoderBuffer(e)}else if(t==="objDesc"){return this._createEncoderBuffer(e)}else{return this.reporter.error("Encoding of string type: "+t+" unsupported")}};DERNode.prototype._encodeObjid=function encodeObjid(e,t,r){if(typeof e==="string"){if(!t)return this.reporter.error("string objid given, but no values map found");if(!t.hasOwnProperty(e))return this.reporter.error("objid not found in values map");e=t[e].split(/[\s\.]+/g);for(var i=0;i<e.length;i++)e[i]|=0}else if(Array.isArray(e)){e=e.slice();for(var i=0;i<e.length;i++)e[i]|=0}if(!Array.isArray(e)){return this.reporter.error("objid() should be either array or string, "+"got: "+JSON.stringify(e))}if(!r){if(e[1]>=40)return this.reporter.error("Second objid identifier OOB");e.splice(0,2,e[0]*40+e[1])}var a=0;for(var i=0;i<e.length;i++){var s=e[i];for(a++;s>=128;s>>=7)a++}var o=new n(a);var u=o.length-1;for(var i=e.length-1;i>=0;i--){var s=e[i];o[u--]=s&127;while((s>>=7)>0)o[u--]=128|s&127}return this._createEncoderBuffer(o)};function two(e){if(e<10)return"0"+e;else return e}DERNode.prototype._encodeTime=function encodeTime(e,t){var r;var i=new Date(e);if(t==="gentime"){r=[two(i.getFullYear()),two(i.getUTCMonth()+1),two(i.getUTCDate()),two(i.getUTCHours()),two(i.getUTCMinutes()),two(i.getUTCSeconds()),"Z"].join("")}else if(t==="utctime"){r=[two(i.getFullYear()%100),two(i.getUTCMonth()+1),two(i.getUTCDate()),two(i.getUTCHours()),two(i.getUTCMinutes()),two(i.getUTCSeconds()),"Z"].join("")}else{this.reporter.error("Encoding "+t+" time is not supported yet")}return this._encodeStr(r,"octstr")};DERNode.prototype._encodeNull=function encodeNull(){return this._createEncoderBuffer("")};DERNode.prototype._encodeInt=function encodeInt(e,t){if(typeof e==="string"){if(!t)return this.reporter.error("String int or enum given, but no values map");if(!t.hasOwnProperty(e)){return this.reporter.error("Values map doesn't contain: "+JSON.stringify(e))}e=t[e]}if(typeof e!=="number"&&!n.isBuffer(e)){var r=e.toArray();if(!e.sign&&r[0]&128){r.unshift(0)}e=new n(r)}if(n.isBuffer(e)){var i=e.length;if(e.length===0)i++;var a=new n(i);e.copy(a);if(e.length===0)a[0]=0;return this._createEncoderBuffer(a)}if(e<128)return this._createEncoderBuffer(e);if(e<256)return this._createEncoderBuffer([0,e]);var i=1;for(var s=e;s>=256;s>>=8)i++;var a=new Array(i);for(var s=a.length-1;s>=0;s--){a[s]=e&255;e>>=8}if(a[0]&128){a.unshift(0)}return this._createEncoderBuffer(new n(a))};DERNode.prototype._encodeBool=function encodeBool(e){return this._createEncoderBuffer(e?255:0)};DERNode.prototype._use=function use(e,t){if(typeof e==="function")e=e(t);return e._getEncoder("der").tree};DERNode.prototype._skipDefault=function skipDefault(e,t,r){var i=this._baseState;var n;if(i["default"]===null)return false;var a=e.join();if(i.defaultBuffer===undefined)i.defaultBuffer=this._encodeValue(i["default"],t,r).join();if(a.length!==i.defaultBuffer.length)return false;for(n=0;n<a.length;n++)if(a[n]!==i.defaultBuffer[n])return false;return true};function encodeTag(e,t,r,i){var n;if(e==="seqof")e="seq";else if(e==="setof")e="set";if(o.tagByName.hasOwnProperty(e))n=o.tagByName[e];else if(typeof e==="number"&&(e|0)===e)n=e;else return i.error("Unknown tag: "+e);if(n>=31)return i.error("Multi-octet tag encoding unsupported");if(!t)n|=32;n|=o.tagClassByName[r||"universal"]<<6;return n}},9245:function(e,t,r){var i=t;i.der=r(6125);i.pem=r(4599)},4599:function(e,t,r){var i=r(7526);var n=r(6125);function PEMEncoder(e){n.call(this,e);this.enc="pem"}i(PEMEncoder,n);e.exports=PEMEncoder;PEMEncoder.prototype.encode=function encode(e,t){var r=n.prototype.encode.call(this,e);var i=r.toString("base64");var a=["-----BEGIN "+t.label+"-----"];for(var s=0;s<i.length;s+=64)a.push(i.slice(s,s+64));a.push("-----END "+t.label+"-----");return a.join("\n")}},6884:function(e,t,r){e=r.nmd(e);(function(e,t){"use strict";function assert(e,t){if(!e)throw new Error(t||"Assertion failed")}function inherits(e,t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}function BN(e,t,r){if(BN.isBN(e)){return e}this.negative=0;this.words=null;this.length=0;this.red=null;if(e!==null){if(t==="le"||t==="be"){r=t;t=10}this._init(e||0,t||10,r||"be")}}if(typeof e==="object"){e.exports=BN}else{t.BN=BN}BN.BN=BN;BN.wordSize=26;var i;try{i=r(4300).Buffer}catch(e){}BN.isBN=function isBN(e){if(e instanceof BN){return true}return e!==null&&typeof e==="object"&&e.constructor.wordSize===BN.wordSize&&Array.isArray(e.words)};BN.max=function max(e,t){if(e.cmp(t)>0)return e;return t};BN.min=function min(e,t){if(e.cmp(t)<0)return e;return t};BN.prototype._init=function init(e,t,r){if(typeof e==="number"){return this._initNumber(e,t,r)}if(typeof e==="object"){return this._initArray(e,t,r)}if(t==="hex"){t=16}assert(t===(t|0)&&t>=2&&t<=36);e=e.toString().replace(/\s+/g,"");var i=0;if(e[0]==="-"){i++}if(t===16){this._parseHex(e,i)}else{this._parseBase(e,t,i)}if(e[0]==="-"){this.negative=1}this.strip();if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initNumber=function _initNumber(e,t,r){if(e<0){this.negative=1;e=-e}if(e<67108864){this.words=[e&67108863];this.length=1}else if(e<4503599627370496){this.words=[e&67108863,e/67108864&67108863];this.length=2}else{assert(e<9007199254740992);this.words=[e&67108863,e/67108864&67108863,1];this.length=3}if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initArray=function _initArray(e,t,r){assert(typeof e.length==="number");if(e.length<=0){this.words=[0];this.length=1;return this}this.length=Math.ceil(e.length/3);this.words=new Array(this.length);for(var i=0;i<this.length;i++){this.words[i]=0}var n,a;var s=0;if(r==="be"){for(i=e.length-1,n=0;i>=0;i-=3){a=e[i]|e[i-1]<<8|e[i-2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}else if(r==="le"){for(i=0,n=0;i<e.length;i+=3){a=e[i]|e[i+1]<<8|e[i+2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}return this.strip()};function parseHex(e,t,r){var i=0;var n=Math.min(e.length,r);for(var a=t;a<n;a++){var s=e.charCodeAt(a)-48;i<<=4;if(s>=49&&s<=54){i|=s-49+10}else if(s>=17&&s<=22){i|=s-17+10}else{i|=s&15}}return i}BN.prototype._parseHex=function _parseHex(e,t){this.length=Math.ceil((e.length-t)/6);this.words=new Array(this.length);for(var r=0;r<this.length;r++){this.words[r]=0}var i,n;var a=0;for(r=e.length-6,i=0;r>=t;r-=6){n=parseHex(e,r,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303;a+=24;if(a>=26){a-=26;i++}}if(r+6!==t){n=parseHex(e,t,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303}this.strip()};function parseBase(e,t,r,i){var n=0;var a=Math.min(e.length,r);for(var s=t;s<a;s++){var o=e.charCodeAt(s)-48;n*=i;if(o>=49){n+=o-49+10}else if(o>=17){n+=o-17+10}else{n+=o}}return n}BN.prototype._parseBase=function _parseBase(e,t,r){this.words=[0];this.length=1;for(var i=0,n=1;n<=67108863;n*=t){i++}i--;n=n/t|0;var a=e.length-r;var s=a%i;var o=Math.min(a,a-s)+r;var u=0;for(var h=r;h<o;h+=i){u=parseBase(e,h,h+i,t);this.imuln(n);if(this.words[0]+u<67108864){this.words[0]+=u}else{this._iaddn(u)}}if(s!==0){var d=1;u=parseBase(e,h,e.length,t);for(h=0;h<s;h++){d*=t}this.imuln(d);if(this.words[0]+u<67108864){this.words[0]+=u}else{this._iaddn(u)}}};BN.prototype.copy=function copy(e){e.words=new Array(this.length);for(var t=0;t<this.length;t++){e.words[t]=this.words[t]}e.length=this.length;e.negative=this.negative;e.red=this.red};BN.prototype.clone=function clone(){var e=new BN(null);this.copy(e);return e};BN.prototype._expand=function _expand(e){while(this.length<e){this.words[this.length++]=0}return this};BN.prototype.strip=function strip(){while(this.length>1&&this.words[this.length-1]===0){this.length--}return this._normSign()};BN.prototype._normSign=function _normSign(){if(this.length===1&&this.words[0]===0){this.negative=0}return this};BN.prototype.inspect=function inspect(){return(this.red?"<BN-R: ":"<BN: ")+this.toString(16)+">"};var n=["","0","00","000","0000","00000","000000","0000000","00000000","000000000","0000000000","00000000000","000000000000","0000000000000","00000000000000","000000000000000","0000000000000000","00000000000000000","000000000000000000","0000000000000000000","00000000000000000000","000000000000000000000","0000000000000000000000","00000000000000000000000","000000000000000000000000","0000000000000000000000000"];var a=[0,0,25,16,12,11,10,9,8,8,7,7,7,7,6,6,6,6,6,6,6,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5];var s=[0,0,33554432,43046721,16777216,48828125,60466176,40353607,16777216,43046721,1e7,19487171,35831808,62748517,7529536,11390625,16777216,24137569,34012224,47045881,64e6,4084101,5153632,6436343,7962624,9765625,11881376,14348907,17210368,20511149,243e5,28629151,33554432,39135393,45435424,52521875,60466176];BN.prototype.toString=function toString(e,t){e=e||10;t=t|0||1;var r;if(e===16||e==="hex"){r="";var i=0;var o=0;for(var u=0;u<this.length;u++){var h=this.words[u];var d=((h<<i|o)&16777215).toString(16);o=h>>>24-i&16777215;if(o!==0||u!==this.length-1){r=n[6-d.length]+d+r}else{r=d+r}i+=2;if(i>=26){i-=26;u--}}if(o!==0){r=o.toString(16)+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}if(e===(e|0)&&e>=2&&e<=36){var c=a[e];var l=s[e];r="";var p=this.clone();p.negative=0;while(!p.isZero()){var b=p.modn(l).toString(e);p=p.idivn(l);if(!p.isZero()){r=n[c-b.length]+b+r}else{r=b+r}}if(this.isZero()){r="0"+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}assert(false,"Base should be between 2 and 36")};BN.prototype.toNumber=function toNumber(){var e=this.words[0];if(this.length===2){e+=this.words[1]*67108864}else if(this.length===3&&this.words[2]===1){e+=4503599627370496+this.words[1]*67108864}else if(this.length>2){assert(false,"Number can only safely store up to 53 bits")}return this.negative!==0?-e:e};BN.prototype.toJSON=function toJSON(){return this.toString(16)};BN.prototype.toBuffer=function toBuffer(e,t){assert(typeof i!=="undefined");return this.toArrayLike(i,e,t)};BN.prototype.toArray=function toArray(e,t){return this.toArrayLike(Array,e,t)};BN.prototype.toArrayLike=function toArrayLike(e,t,r){var i=this.byteLength();var n=r||Math.max(1,i);assert(i<=n,"byte array longer than desired length");assert(n>0,"Requested array length <= 0");this.strip();var a=t==="le";var s=new e(n);var o,u;var h=this.clone();if(!a){for(u=0;u<n-i;u++){s[u]=0}for(u=0;!h.isZero();u++){o=h.andln(255);h.iushrn(8);s[n-u-1]=o}}else{for(u=0;!h.isZero();u++){o=h.andln(255);h.iushrn(8);s[u]=o}for(;u<n;u++){s[u]=0}}return s};if(Math.clz32){BN.prototype._countBits=function _countBits(e){return 32-Math.clz32(e)}}else{BN.prototype._countBits=function _countBits(e){var t=e;var r=0;if(t>=4096){r+=13;t>>>=13}if(t>=64){r+=7;t>>>=7}if(t>=8){r+=4;t>>>=4}if(t>=2){r+=2;t>>>=2}return r+t}}BN.prototype._zeroBits=function _zeroBits(e){if(e===0)return 26;var t=e;var r=0;if((t&8191)===0){r+=13;t>>>=13}if((t&127)===0){r+=7;t>>>=7}if((t&15)===0){r+=4;t>>>=4}if((t&3)===0){r+=2;t>>>=2}if((t&1)===0){r++}return r};BN.prototype.bitLength=function bitLength(){var e=this.words[this.length-1];var t=this._countBits(e);return(this.length-1)*26+t};function toBitArray(e){var t=new Array(e.bitLength());for(var r=0;r<t.length;r++){var i=r/26|0;var n=r%26;t[r]=(e.words[i]&1<<n)>>>n}return t}BN.prototype.zeroBits=function zeroBits(){if(this.isZero())return 0;var e=0;for(var t=0;t<this.length;t++){var r=this._zeroBits(this.words[t]);e+=r;if(r!==26)break}return e};BN.prototype.byteLength=function byteLength(){return Math.ceil(this.bitLength()/8)};BN.prototype.toTwos=function toTwos(e){if(this.negative!==0){return this.abs().inotn(e).iaddn(1)}return this.clone()};BN.prototype.fromTwos=function fromTwos(e){if(this.testn(e-1)){return this.notn(e).iaddn(1).ineg()}return this.clone()};BN.prototype.isNeg=function isNeg(){return this.negative!==0};BN.prototype.neg=function neg(){return this.clone().ineg()};BN.prototype.ineg=function ineg(){if(!this.isZero()){this.negative^=1}return this};BN.prototype.iuor=function iuor(e){while(this.length<e.length){this.words[this.length++]=0}for(var t=0;t<e.length;t++){this.words[t]=this.words[t]|e.words[t]}return this.strip()};BN.prototype.ior=function ior(e){assert((this.negative|e.negative)===0);return this.iuor(e)};BN.prototype.or=function or(e){if(this.length>e.length)return this.clone().ior(e);return e.clone().ior(this)};BN.prototype.uor=function uor(e){if(this.length>e.length)return this.clone().iuor(e);return e.clone().iuor(this)};BN.prototype.iuand=function iuand(e){var t;if(this.length>e.length){t=e}else{t=this}for(var r=0;r<t.length;r++){this.words[r]=this.words[r]&e.words[r]}this.length=t.length;return this.strip()};BN.prototype.iand=function iand(e){assert((this.negative|e.negative)===0);return this.iuand(e)};BN.prototype.and=function and(e){if(this.length>e.length)return this.clone().iand(e);return e.clone().iand(this)};BN.prototype.uand=function uand(e){if(this.length>e.length)return this.clone().iuand(e);return e.clone().iuand(this)};BN.prototype.iuxor=function iuxor(e){var t;var r;if(this.length>e.length){t=this;r=e}else{t=e;r=this}for(var i=0;i<r.length;i++){this.words[i]=t.words[i]^r.words[i]}if(this!==t){for(;i<t.length;i++){this.words[i]=t.words[i]}}this.length=t.length;return this.strip()};BN.prototype.ixor=function ixor(e){assert((this.negative|e.negative)===0);return this.iuxor(e)};BN.prototype.xor=function xor(e){if(this.length>e.length)return this.clone().ixor(e);return e.clone().ixor(this)};BN.prototype.uxor=function uxor(e){if(this.length>e.length)return this.clone().iuxor(e);return e.clone().iuxor(this)};BN.prototype.inotn=function inotn(e){assert(typeof e==="number"&&e>=0);var t=Math.ceil(e/26)|0;var r=e%26;this._expand(t);if(r>0){t--}for(var i=0;i<t;i++){this.words[i]=~this.words[i]&67108863}if(r>0){this.words[i]=~this.words[i]&67108863>>26-r}return this.strip()};BN.prototype.notn=function notn(e){return this.clone().inotn(e)};BN.prototype.setn=function setn(e,t){assert(typeof e==="number"&&e>=0);var r=e/26|0;var i=e%26;this._expand(r+1);if(t){this.words[r]=this.words[r]|1<<i}else{this.words[r]=this.words[r]&~(1<<i)}return this.strip()};BN.prototype.iadd=function iadd(e){var t;if(this.negative!==0&&e.negative===0){this.negative=0;t=this.isub(e);this.negative^=1;return this._normSign()}else if(this.negative===0&&e.negative!==0){e.negative=0;t=this.isub(e);e.negative=1;return t._normSign()}var r,i;if(this.length>e.length){r=this;i=e}else{r=e;i=this}var n=0;for(var a=0;a<i.length;a++){t=(r.words[a]|0)+(i.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}for(;n!==0&&a<r.length;a++){t=(r.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}this.length=r.length;if(n!==0){this.words[this.length]=n;this.length++}else if(r!==this){for(;a<r.length;a++){this.words[a]=r.words[a]}}return this};BN.prototype.add=function add(e){var t;if(e.negative!==0&&this.negative===0){e.negative=0;t=this.sub(e);e.negative^=1;return t}else if(e.negative===0&&this.negative!==0){this.negative=0;t=e.sub(this);this.negative=1;return t}if(this.length>e.length)return this.clone().iadd(e);return e.clone().iadd(this)};BN.prototype.isub=function isub(e){if(e.negative!==0){e.negative=0;var t=this.iadd(e);e.negative=1;return t._normSign()}else if(this.negative!==0){this.negative=0;this.iadd(e);this.negative=1;return this._normSign()}var r=this.cmp(e);if(r===0){this.negative=0;this.length=1;this.words[0]=0;return this}var i,n;if(r>0){i=this;n=e}else{i=e;n=this}var a=0;for(var s=0;s<n.length;s++){t=(i.words[s]|0)-(n.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}for(;a!==0&&s<i.length;s++){t=(i.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}if(a===0&&s<i.length&&i!==this){for(;s<i.length;s++){this.words[s]=i.words[s]}}this.length=Math.max(this.length,s);if(i!==this){this.negative=1}return this.strip()};BN.prototype.sub=function sub(e){return this.clone().isub(e)};function smallMulTo(e,t,r){r.negative=t.negative^e.negative;var i=e.length+t.length|0;r.length=i;i=i-1|0;var n=e.words[0]|0;var a=t.words[0]|0;var s=n*a;var o=s&67108863;var u=s/67108864|0;r.words[0]=o;for(var h=1;h<i;h++){var d=u>>>26;var c=u&67108863;var l=Math.min(h,t.length-1);for(var p=Math.max(0,h-e.length+1);p<=l;p++){var b=h-p|0;n=e.words[b]|0;a=t.words[p]|0;s=n*a+c;d+=s/67108864|0;c=s&67108863}r.words[h]=c|0;u=d|0}if(u!==0){r.words[h]=u|0}else{r.length--}return r.strip()}var o=function comb10MulTo(e,t,r){var i=e.words;var n=t.words;var a=r.words;var s=0;var o;var u;var h;var d=i[0]|0;var c=d&8191;var l=d>>>13;var p=i[1]|0;var b=p&8191;var v=p>>>13;var m=i[2]|0;var y=m&8191;var g=m>>>13;var _=i[3]|0;var w=_&8191;var M=_>>>13;var E=i[4]|0;var B=E&8191;var k=E>>>13;var A=i[5]|0;var N=A&8191;var P=A>>>13;var x=i[6]|0;var C=x&8191;var T=x>>>13;var I=i[7]|0;var D=I&8191;var O=I>>>13;var j=i[8]|0;var L=j&8191;var q=j>>>13;var H=i[9]|0;var F=H&8191;var U=H>>>13;var z=n[0]|0;var W=z&8191;var V=z>>>13;var G=n[1]|0;var J=G&8191;var Z=G>>>13;var X=n[2]|0;var Y=X&8191;var $=X>>>13;var Q=n[3]|0;var ee=Q&8191;var te=Q>>>13;var re=n[4]|0;var ie=re&8191;var ne=re>>>13;var ae=n[5]|0;var se=ae&8191;var fe=ae>>>13;var oe=n[6]|0;var ue=oe&8191;var he=oe>>>13;var de=n[7]|0;var ce=de&8191;var le=de>>>13;var pe=n[8]|0;var be=pe&8191;var ve=pe>>>13;var me=n[9]|0;var ye=me&8191;var ge=me>>>13;r.negative=e.negative^t.negative;r.length=19;o=Math.imul(c,W);u=Math.imul(c,V);u=u+Math.imul(l,W)|0;h=Math.imul(l,V);var _e=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(_e>>>26)|0;_e&=67108863;o=Math.imul(b,W);u=Math.imul(b,V);u=u+Math.imul(v,W)|0;h=Math.imul(v,V);o=o+Math.imul(c,J)|0;u=u+Math.imul(c,Z)|0;u=u+Math.imul(l,J)|0;h=h+Math.imul(l,Z)|0;var we=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(we>>>26)|0;we&=67108863;o=Math.imul(y,W);u=Math.imul(y,V);u=u+Math.imul(g,W)|0;h=Math.imul(g,V);o=o+Math.imul(b,J)|0;u=u+Math.imul(b,Z)|0;u=u+Math.imul(v,J)|0;h=h+Math.imul(v,Z)|0;o=o+Math.imul(c,Y)|0;u=u+Math.imul(c,$)|0;u=u+Math.imul(l,Y)|0;h=h+Math.imul(l,$)|0;var Me=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Me>>>26)|0;Me&=67108863;o=Math.imul(w,W);u=Math.imul(w,V);u=u+Math.imul(M,W)|0;h=Math.imul(M,V);o=o+Math.imul(y,J)|0;u=u+Math.imul(y,Z)|0;u=u+Math.imul(g,J)|0;h=h+Math.imul(g,Z)|0;o=o+Math.imul(b,Y)|0;u=u+Math.imul(b,$)|0;u=u+Math.imul(v,Y)|0;h=h+Math.imul(v,$)|0;o=o+Math.imul(c,ee)|0;u=u+Math.imul(c,te)|0;u=u+Math.imul(l,ee)|0;h=h+Math.imul(l,te)|0;var Se=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Se>>>26)|0;Se&=67108863;o=Math.imul(B,W);u=Math.imul(B,V);u=u+Math.imul(k,W)|0;h=Math.imul(k,V);o=o+Math.imul(w,J)|0;u=u+Math.imul(w,Z)|0;u=u+Math.imul(M,J)|0;h=h+Math.imul(M,Z)|0;o=o+Math.imul(y,Y)|0;u=u+Math.imul(y,$)|0;u=u+Math.imul(g,Y)|0;h=h+Math.imul(g,$)|0;o=o+Math.imul(b,ee)|0;u=u+Math.imul(b,te)|0;u=u+Math.imul(v,ee)|0;h=h+Math.imul(v,te)|0;o=o+Math.imul(c,ie)|0;u=u+Math.imul(c,ne)|0;u=u+Math.imul(l,ie)|0;h=h+Math.imul(l,ne)|0;var Ee=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Ee>>>26)|0;Ee&=67108863;o=Math.imul(N,W);u=Math.imul(N,V);u=u+Math.imul(P,W)|0;h=Math.imul(P,V);o=o+Math.imul(B,J)|0;u=u+Math.imul(B,Z)|0;u=u+Math.imul(k,J)|0;h=h+Math.imul(k,Z)|0;o=o+Math.imul(w,Y)|0;u=u+Math.imul(w,$)|0;u=u+Math.imul(M,Y)|0;h=h+Math.imul(M,$)|0;o=o+Math.imul(y,ee)|0;u=u+Math.imul(y,te)|0;u=u+Math.imul(g,ee)|0;h=h+Math.imul(g,te)|0;o=o+Math.imul(b,ie)|0;u=u+Math.imul(b,ne)|0;u=u+Math.imul(v,ie)|0;h=h+Math.imul(v,ne)|0;o=o+Math.imul(c,se)|0;u=u+Math.imul(c,fe)|0;u=u+Math.imul(l,se)|0;h=h+Math.imul(l,fe)|0;var Be=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Be>>>26)|0;Be&=67108863;o=Math.imul(C,W);u=Math.imul(C,V);u=u+Math.imul(T,W)|0;h=Math.imul(T,V);o=o+Math.imul(N,J)|0;u=u+Math.imul(N,Z)|0;u=u+Math.imul(P,J)|0;h=h+Math.imul(P,Z)|0;o=o+Math.imul(B,Y)|0;u=u+Math.imul(B,$)|0;u=u+Math.imul(k,Y)|0;h=h+Math.imul(k,$)|0;o=o+Math.imul(w,ee)|0;u=u+Math.imul(w,te)|0;u=u+Math.imul(M,ee)|0;h=h+Math.imul(M,te)|0;o=o+Math.imul(y,ie)|0;u=u+Math.imul(y,ne)|0;u=u+Math.imul(g,ie)|0;h=h+Math.imul(g,ne)|0;o=o+Math.imul(b,se)|0;u=u+Math.imul(b,fe)|0;u=u+Math.imul(v,se)|0;h=h+Math.imul(v,fe)|0;o=o+Math.imul(c,ue)|0;u=u+Math.imul(c,he)|0;u=u+Math.imul(l,ue)|0;h=h+Math.imul(l,he)|0;var Re=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Re>>>26)|0;Re&=67108863;o=Math.imul(D,W);u=Math.imul(D,V);u=u+Math.imul(O,W)|0;h=Math.imul(O,V);o=o+Math.imul(C,J)|0;u=u+Math.imul(C,Z)|0;u=u+Math.imul(T,J)|0;h=h+Math.imul(T,Z)|0;o=o+Math.imul(N,Y)|0;u=u+Math.imul(N,$)|0;u=u+Math.imul(P,Y)|0;h=h+Math.imul(P,$)|0;o=o+Math.imul(B,ee)|0;u=u+Math.imul(B,te)|0;u=u+Math.imul(k,ee)|0;h=h+Math.imul(k,te)|0;o=o+Math.imul(w,ie)|0;u=u+Math.imul(w,ne)|0;u=u+Math.imul(M,ie)|0;h=h+Math.imul(M,ne)|0;o=o+Math.imul(y,se)|0;u=u+Math.imul(y,fe)|0;u=u+Math.imul(g,se)|0;h=h+Math.imul(g,fe)|0;o=o+Math.imul(b,ue)|0;u=u+Math.imul(b,he)|0;u=u+Math.imul(v,ue)|0;h=h+Math.imul(v,he)|0;o=o+Math.imul(c,ce)|0;u=u+Math.imul(c,le)|0;u=u+Math.imul(l,ce)|0;h=h+Math.imul(l,le)|0;var ke=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(ke>>>26)|0;ke&=67108863;o=Math.imul(L,W);u=Math.imul(L,V);u=u+Math.imul(q,W)|0;h=Math.imul(q,V);o=o+Math.imul(D,J)|0;u=u+Math.imul(D,Z)|0;u=u+Math.imul(O,J)|0;h=h+Math.imul(O,Z)|0;o=o+Math.imul(C,Y)|0;u=u+Math.imul(C,$)|0;u=u+Math.imul(T,Y)|0;h=h+Math.imul(T,$)|0;o=o+Math.imul(N,ee)|0;u=u+Math.imul(N,te)|0;u=u+Math.imul(P,ee)|0;h=h+Math.imul(P,te)|0;o=o+Math.imul(B,ie)|0;u=u+Math.imul(B,ne)|0;u=u+Math.imul(k,ie)|0;h=h+Math.imul(k,ne)|0;o=o+Math.imul(w,se)|0;u=u+Math.imul(w,fe)|0;u=u+Math.imul(M,se)|0;h=h+Math.imul(M,fe)|0;o=o+Math.imul(y,ue)|0;u=u+Math.imul(y,he)|0;u=u+Math.imul(g,ue)|0;h=h+Math.imul(g,he)|0;o=o+Math.imul(b,ce)|0;u=u+Math.imul(b,le)|0;u=u+Math.imul(v,ce)|0;h=h+Math.imul(v,le)|0;o=o+Math.imul(c,be)|0;u=u+Math.imul(c,ve)|0;u=u+Math.imul(l,be)|0;h=h+Math.imul(l,ve)|0;var Ae=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Ae>>>26)|0;Ae&=67108863;o=Math.imul(F,W);u=Math.imul(F,V);u=u+Math.imul(U,W)|0;h=Math.imul(U,V);o=o+Math.imul(L,J)|0;u=u+Math.imul(L,Z)|0;u=u+Math.imul(q,J)|0;h=h+Math.imul(q,Z)|0;o=o+Math.imul(D,Y)|0;u=u+Math.imul(D,$)|0;u=u+Math.imul(O,Y)|0;h=h+Math.imul(O,$)|0;o=o+Math.imul(C,ee)|0;u=u+Math.imul(C,te)|0;u=u+Math.imul(T,ee)|0;h=h+Math.imul(T,te)|0;o=o+Math.imul(N,ie)|0;u=u+Math.imul(N,ne)|0;u=u+Math.imul(P,ie)|0;h=h+Math.imul(P,ne)|0;o=o+Math.imul(B,se)|0;u=u+Math.imul(B,fe)|0;u=u+Math.imul(k,se)|0;h=h+Math.imul(k,fe)|0;o=o+Math.imul(w,ue)|0;u=u+Math.imul(w,he)|0;u=u+Math.imul(M,ue)|0;h=h+Math.imul(M,he)|0;o=o+Math.imul(y,ce)|0;u=u+Math.imul(y,le)|0;u=u+Math.imul(g,ce)|0;h=h+Math.imul(g,le)|0;o=o+Math.imul(b,be)|0;u=u+Math.imul(b,ve)|0;u=u+Math.imul(v,be)|0;h=h+Math.imul(v,ve)|0;o=o+Math.imul(c,ye)|0;u=u+Math.imul(c,ge)|0;u=u+Math.imul(l,ye)|0;h=h+Math.imul(l,ge)|0;var Ne=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Ne>>>26)|0;Ne&=67108863;o=Math.imul(F,J);u=Math.imul(F,Z);u=u+Math.imul(U,J)|0;h=Math.imul(U,Z);o=o+Math.imul(L,Y)|0;u=u+Math.imul(L,$)|0;u=u+Math.imul(q,Y)|0;h=h+Math.imul(q,$)|0;o=o+Math.imul(D,ee)|0;u=u+Math.imul(D,te)|0;u=u+Math.imul(O,ee)|0;h=h+Math.imul(O,te)|0;o=o+Math.imul(C,ie)|0;u=u+Math.imul(C,ne)|0;u=u+Math.imul(T,ie)|0;h=h+Math.imul(T,ne)|0;o=o+Math.imul(N,se)|0;u=u+Math.imul(N,fe)|0;u=u+Math.imul(P,se)|0;h=h+Math.imul(P,fe)|0;o=o+Math.imul(B,ue)|0;u=u+Math.imul(B,he)|0;u=u+Math.imul(k,ue)|0;h=h+Math.imul(k,he)|0;o=o+Math.imul(w,ce)|0;u=u+Math.imul(w,le)|0;u=u+Math.imul(M,ce)|0;h=h+Math.imul(M,le)|0;o=o+Math.imul(y,be)|0;u=u+Math.imul(y,ve)|0;u=u+Math.imul(g,be)|0;h=h+Math.imul(g,ve)|0;o=o+Math.imul(b,ye)|0;u=u+Math.imul(b,ge)|0;u=u+Math.imul(v,ye)|0;h=h+Math.imul(v,ge)|0;var Pe=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Pe>>>26)|0;Pe&=67108863;o=Math.imul(F,Y);u=Math.imul(F,$);u=u+Math.imul(U,Y)|0;h=Math.imul(U,$);o=o+Math.imul(L,ee)|0;u=u+Math.imul(L,te)|0;u=u+Math.imul(q,ee)|0;h=h+Math.imul(q,te)|0;o=o+Math.imul(D,ie)|0;u=u+Math.imul(D,ne)|0;u=u+Math.imul(O,ie)|0;h=h+Math.imul(O,ne)|0;o=o+Math.imul(C,se)|0;u=u+Math.imul(C,fe)|0;u=u+Math.imul(T,se)|0;h=h+Math.imul(T,fe)|0;o=o+Math.imul(N,ue)|0;u=u+Math.imul(N,he)|0;u=u+Math.imul(P,ue)|0;h=h+Math.imul(P,he)|0;o=o+Math.imul(B,ce)|0;u=u+Math.imul(B,le)|0;u=u+Math.imul(k,ce)|0;h=h+Math.imul(k,le)|0;o=o+Math.imul(w,be)|0;u=u+Math.imul(w,ve)|0;u=u+Math.imul(M,be)|0;h=h+Math.imul(M,ve)|0;o=o+Math.imul(y,ye)|0;u=u+Math.imul(y,ge)|0;u=u+Math.imul(g,ye)|0;h=h+Math.imul(g,ge)|0;var xe=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(xe>>>26)|0;xe&=67108863;o=Math.imul(F,ee);u=Math.imul(F,te);u=u+Math.imul(U,ee)|0;h=Math.imul(U,te);o=o+Math.imul(L,ie)|0;u=u+Math.imul(L,ne)|0;u=u+Math.imul(q,ie)|0;h=h+Math.imul(q,ne)|0;o=o+Math.imul(D,se)|0;u=u+Math.imul(D,fe)|0;u=u+Math.imul(O,se)|0;h=h+Math.imul(O,fe)|0;o=o+Math.imul(C,ue)|0;u=u+Math.imul(C,he)|0;u=u+Math.imul(T,ue)|0;h=h+Math.imul(T,he)|0;o=o+Math.imul(N,ce)|0;u=u+Math.imul(N,le)|0;u=u+Math.imul(P,ce)|0;h=h+Math.imul(P,le)|0;o=o+Math.imul(B,be)|0;u=u+Math.imul(B,ve)|0;u=u+Math.imul(k,be)|0;h=h+Math.imul(k,ve)|0;o=o+Math.imul(w,ye)|0;u=u+Math.imul(w,ge)|0;u=u+Math.imul(M,ye)|0;h=h+Math.imul(M,ge)|0;var Ce=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Ce>>>26)|0;Ce&=67108863;o=Math.imul(F,ie);u=Math.imul(F,ne);u=u+Math.imul(U,ie)|0;h=Math.imul(U,ne);o=o+Math.imul(L,se)|0;u=u+Math.imul(L,fe)|0;u=u+Math.imul(q,se)|0;h=h+Math.imul(q,fe)|0;o=o+Math.imul(D,ue)|0;u=u+Math.imul(D,he)|0;u=u+Math.imul(O,ue)|0;h=h+Math.imul(O,he)|0;o=o+Math.imul(C,ce)|0;u=u+Math.imul(C,le)|0;u=u+Math.imul(T,ce)|0;h=h+Math.imul(T,le)|0;o=o+Math.imul(N,be)|0;u=u+Math.imul(N,ve)|0;u=u+Math.imul(P,be)|0;h=h+Math.imul(P,ve)|0;o=o+Math.imul(B,ye)|0;u=u+Math.imul(B,ge)|0;u=u+Math.imul(k,ye)|0;h=h+Math.imul(k,ge)|0;var Te=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Te>>>26)|0;Te&=67108863;o=Math.imul(F,se);u=Math.imul(F,fe);u=u+Math.imul(U,se)|0;h=Math.imul(U,fe);o=o+Math.imul(L,ue)|0;u=u+Math.imul(L,he)|0;u=u+Math.imul(q,ue)|0;h=h+Math.imul(q,he)|0;o=o+Math.imul(D,ce)|0;u=u+Math.imul(D,le)|0;u=u+Math.imul(O,ce)|0;h=h+Math.imul(O,le)|0;o=o+Math.imul(C,be)|0;u=u+Math.imul(C,ve)|0;u=u+Math.imul(T,be)|0;h=h+Math.imul(T,ve)|0;o=o+Math.imul(N,ye)|0;u=u+Math.imul(N,ge)|0;u=u+Math.imul(P,ye)|0;h=h+Math.imul(P,ge)|0;var Ie=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Ie>>>26)|0;Ie&=67108863;o=Math.imul(F,ue);u=Math.imul(F,he);u=u+Math.imul(U,ue)|0;h=Math.imul(U,he);o=o+Math.imul(L,ce)|0;u=u+Math.imul(L,le)|0;u=u+Math.imul(q,ce)|0;h=h+Math.imul(q,le)|0;o=o+Math.imul(D,be)|0;u=u+Math.imul(D,ve)|0;u=u+Math.imul(O,be)|0;h=h+Math.imul(O,ve)|0;o=o+Math.imul(C,ye)|0;u=u+Math.imul(C,ge)|0;u=u+Math.imul(T,ye)|0;h=h+Math.imul(T,ge)|0;var De=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(De>>>26)|0;De&=67108863;o=Math.imul(F,ce);u=Math.imul(F,le);u=u+Math.imul(U,ce)|0;h=Math.imul(U,le);o=o+Math.imul(L,be)|0;u=u+Math.imul(L,ve)|0;u=u+Math.imul(q,be)|0;h=h+Math.imul(q,ve)|0;o=o+Math.imul(D,ye)|0;u=u+Math.imul(D,ge)|0;u=u+Math.imul(O,ye)|0;h=h+Math.imul(O,ge)|0;var Oe=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Oe>>>26)|0;Oe&=67108863;o=Math.imul(F,be);u=Math.imul(F,ve);u=u+Math.imul(U,be)|0;h=Math.imul(U,ve);o=o+Math.imul(L,ye)|0;u=u+Math.imul(L,ge)|0;u=u+Math.imul(q,ye)|0;h=h+Math.imul(q,ge)|0;var je=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(je>>>26)|0;je&=67108863;o=Math.imul(F,ye);u=Math.imul(F,ge);u=u+Math.imul(U,ye)|0;h=Math.imul(U,ge);var Le=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Le>>>26)|0;Le&=67108863;a[0]=_e;a[1]=we;a[2]=Me;a[3]=Se;a[4]=Ee;a[5]=Be;a[6]=Re;a[7]=ke;a[8]=Ae;a[9]=Ne;a[10]=Pe;a[11]=xe;a[12]=Ce;a[13]=Te;a[14]=Ie;a[15]=De;a[16]=Oe;a[17]=je;a[18]=Le;if(s!==0){a[19]=s;r.length++}return r};if(!Math.imul){o=smallMulTo}function bigMulTo(e,t,r){r.negative=t.negative^e.negative;r.length=e.length+t.length;var i=0;var n=0;for(var a=0;a<r.length-1;a++){var s=n;n=0;var o=i&67108863;var u=Math.min(a,t.length-1);for(var h=Math.max(0,a-e.length+1);h<=u;h++){var d=a-h;var c=e.words[d]|0;var l=t.words[h]|0;var p=c*l;var b=p&67108863;s=s+(p/67108864|0)|0;b=b+o|0;o=b&67108863;s=s+(b>>>26)|0;n+=s>>>26;s&=67108863}r.words[a]=o;i=s;s=n}if(i!==0){r.words[a]=i}else{r.length--}return r.strip()}function jumboMulTo(e,t,r){var i=new FFTM;return i.mulp(e,t,r)}BN.prototype.mulTo=function mulTo(e,t){var r;var i=this.length+e.length;if(this.length===10&&e.length===10){r=o(this,e,t)}else if(i<63){r=smallMulTo(this,e,t)}else if(i<1024){r=bigMulTo(this,e,t)}else{r=jumboMulTo(this,e,t)}return r};function FFTM(e,t){this.x=e;this.y=t}FFTM.prototype.makeRBT=function makeRBT(e){var t=new Array(e);var r=BN.prototype._countBits(e)-1;for(var i=0;i<e;i++){t[i]=this.revBin(i,r,e)}return t};FFTM.prototype.revBin=function revBin(e,t,r){if(e===0||e===r-1)return e;var i=0;for(var n=0;n<t;n++){i|=(e&1)<<t-n-1;e>>=1}return i};FFTM.prototype.permute=function permute(e,t,r,i,n,a){for(var s=0;s<a;s++){i[s]=t[e[s]];n[s]=r[e[s]]}};FFTM.prototype.transform=function transform(e,t,r,i,n,a){this.permute(a,e,t,r,i,n);for(var s=1;s<n;s<<=1){var o=s<<1;var u=Math.cos(2*Math.PI/o);var h=Math.sin(2*Math.PI/o);for(var d=0;d<n;d+=o){var c=u;var l=h;for(var p=0;p<s;p++){var b=r[d+p];var v=i[d+p];var m=r[d+p+s];var y=i[d+p+s];var g=c*m-l*y;y=c*y+l*m;m=g;r[d+p]=b+m;i[d+p]=v+y;r[d+p+s]=b-m;i[d+p+s]=v-y;if(p!==o){g=u*c-h*l;l=u*l+h*c;c=g}}}}};FFTM.prototype.guessLen13b=function guessLen13b(e,t){var r=Math.max(t,e)|1;var i=r&1;var n=0;for(r=r/2|0;r;r=r>>>1){n++}return 1<<n+1+i};FFTM.prototype.conjugate=function conjugate(e,t,r){if(r<=1)return;for(var i=0;i<r/2;i++){var n=e[i];e[i]=e[r-i-1];e[r-i-1]=n;n=t[i];t[i]=-t[r-i-1];t[r-i-1]=-n}};FFTM.prototype.normalize13b=function normalize13b(e,t){var r=0;for(var i=0;i<t/2;i++){var n=Math.round(e[2*i+1]/t)*8192+Math.round(e[2*i]/t)+r;e[i]=n&67108863;if(n<67108864){r=0}else{r=n/67108864|0}}return e};FFTM.prototype.convert13b=function convert13b(e,t,r,i){var n=0;for(var a=0;a<t;a++){n=n+(e[a]|0);r[2*a]=n&8191;n=n>>>13;r[2*a+1]=n&8191;n=n>>>13}for(a=2*t;a<i;++a){r[a]=0}assert(n===0);assert((n&~8191)===0)};FFTM.prototype.stub=function stub(e){var t=new Array(e);for(var r=0;r<e;r++){t[r]=0}return t};FFTM.prototype.mulp=function mulp(e,t,r){var i=2*this.guessLen13b(e.length,t.length);var n=this.makeRBT(i);var a=this.stub(i);var s=new Array(i);var o=new Array(i);var u=new Array(i);var h=new Array(i);var d=new Array(i);var c=new Array(i);var l=r.words;l.length=i;this.convert13b(e.words,e.length,s,i);this.convert13b(t.words,t.length,h,i);this.transform(s,a,o,u,i,n);this.transform(h,a,d,c,i,n);for(var p=0;p<i;p++){var b=o[p]*d[p]-u[p]*c[p];u[p]=o[p]*c[p]+u[p]*d[p];o[p]=b}this.conjugate(o,u,i);this.transform(o,u,l,a,i,n);this.conjugate(l,a,i);this.normalize13b(l,i);r.negative=e.negative^t.negative;r.length=e.length+t.length;return r.strip()};BN.prototype.mul=function mul(e){var t=new BN(null);t.words=new Array(this.length+e.length);return this.mulTo(e,t)};BN.prototype.mulf=function mulf(e){var t=new BN(null);t.words=new Array(this.length+e.length);return jumboMulTo(this,e,t)};BN.prototype.imul=function imul(e){return this.clone().mulTo(e,this)};BN.prototype.imuln=function imuln(e){assert(typeof e==="number");assert(e<67108864);var t=0;for(var r=0;r<this.length;r++){var i=(this.words[r]|0)*e;var n=(i&67108863)+(t&67108863);t>>=26;t+=i/67108864|0;t+=n>>>26;this.words[r]=n&67108863}if(t!==0){this.words[r]=t;this.length++}return this};BN.prototype.muln=function muln(e){return this.clone().imuln(e)};BN.prototype.sqr=function sqr(){return this.mul(this)};BN.prototype.isqr=function isqr(){return this.imul(this.clone())};BN.prototype.pow=function pow(e){var t=toBitArray(e);if(t.length===0)return new BN(1);var r=this;for(var i=0;i<t.length;i++,r=r.sqr()){if(t[i]!==0)break}if(++i<t.length){for(var n=r.sqr();i<t.length;i++,n=n.sqr()){if(t[i]===0)continue;r=r.mul(n)}}return r};BN.prototype.iushln=function iushln(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=67108863>>>26-t<<26-t;var n;if(t!==0){var a=0;for(n=0;n<this.length;n++){var s=this.words[n]&i;var o=(this.words[n]|0)-s<<t;this.words[n]=o|a;a=s>>>26-t}if(a){this.words[n]=a;this.length++}}if(r!==0){for(n=this.length-1;n>=0;n--){this.words[n+r]=this.words[n]}for(n=0;n<r;n++){this.words[n]=0}this.length+=r}return this.strip()};BN.prototype.ishln=function ishln(e){assert(this.negative===0);return this.iushln(e)};BN.prototype.iushrn=function iushrn(e,t,r){assert(typeof e==="number"&&e>=0);var i;if(t){i=(t-t%26)/26}else{i=0}var n=e%26;var a=Math.min((e-n)/26,this.length);var s=67108863^67108863>>>n<<n;var o=r;i-=a;i=Math.max(0,i);if(o){for(var u=0;u<a;u++){o.words[u]=this.words[u]}o.length=a}if(a===0){}else if(this.length>a){this.length-=a;for(u=0;u<this.length;u++){this.words[u]=this.words[u+a]}}else{this.words[0]=0;this.length=1}var h=0;for(u=this.length-1;u>=0&&(h!==0||u>=i);u--){var d=this.words[u]|0;this.words[u]=h<<26-n|d>>>n;h=d&s}if(o&&h!==0){o.words[o.length++]=h}if(this.length===0){this.words[0]=0;this.length=1}return this.strip()};BN.prototype.ishrn=function ishrn(e,t,r){assert(this.negative===0);return this.iushrn(e,t,r)};BN.prototype.shln=function shln(e){return this.clone().ishln(e)};BN.prototype.ushln=function ushln(e){return this.clone().iushln(e)};BN.prototype.shrn=function shrn(e){return this.clone().ishrn(e)};BN.prototype.ushrn=function ushrn(e){return this.clone().iushrn(e)};BN.prototype.testn=function testn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r)return false;var n=this.words[r];return!!(n&i)};BN.prototype.imaskn=function imaskn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;assert(this.negative===0,"imaskn works only with positive numbers");if(this.length<=r){return this}if(t!==0){r++}this.length=Math.min(r,this.length);if(t!==0){var i=67108863^67108863>>>t<<t;this.words[this.length-1]&=i}return this.strip()};BN.prototype.maskn=function maskn(e){return this.clone().imaskn(e)};BN.prototype.iaddn=function iaddn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.isubn(-e);if(this.negative!==0){if(this.length===1&&(this.words[0]|0)<e){this.words[0]=e-(this.words[0]|0);this.negative=0;return this}this.negative=0;this.isubn(e);this.negative=1;return this}return this._iaddn(e)};BN.prototype._iaddn=function _iaddn(e){this.words[0]+=e;for(var t=0;t<this.length&&this.words[t]>=67108864;t++){this.words[t]-=67108864;if(t===this.length-1){this.words[t+1]=1}else{this.words[t+1]++}}this.length=Math.max(this.length,t+1);return this};BN.prototype.isubn=function isubn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.iaddn(-e);if(this.negative!==0){this.negative=0;this.iaddn(e);this.negative=1;return this}this.words[0]-=e;if(this.length===1&&this.words[0]<0){this.words[0]=-this.words[0];this.negative=1}else{for(var t=0;t<this.length&&this.words[t]<0;t++){this.words[t]+=67108864;this.words[t+1]-=1}}return this.strip()};BN.prototype.addn=function addn(e){return this.clone().iaddn(e)};BN.prototype.subn=function subn(e){return this.clone().isubn(e)};BN.prototype.iabs=function iabs(){this.negative=0;return this};BN.prototype.abs=function abs(){return this.clone().iabs()};BN.prototype._ishlnsubmul=function _ishlnsubmul(e,t,r){var i=e.length+r;var n;this._expand(i);var a;var s=0;for(n=0;n<e.length;n++){a=(this.words[n+r]|0)+s;var o=(e.words[n]|0)*t;a-=o&67108863;s=(a>>26)-(o/67108864|0);this.words[n+r]=a&67108863}for(;n<this.length-r;n++){a=(this.words[n+r]|0)+s;s=a>>26;this.words[n+r]=a&67108863}if(s===0)return this.strip();assert(s===-1);s=0;for(n=0;n<this.length;n++){a=-(this.words[n]|0)+s;s=a>>26;this.words[n]=a&67108863}this.negative=1;return this.strip()};BN.prototype._wordDiv=function _wordDiv(e,t){var r=this.length-e.length;var i=this.clone();var n=e;var a=n.words[n.length-1]|0;var s=this._countBits(a);r=26-s;if(r!==0){n=n.ushln(r);i.iushln(r);a=n.words[n.length-1]|0}var o=i.length-n.length;var u;if(t!=="mod"){u=new BN(null);u.length=o+1;u.words=new Array(u.length);for(var h=0;h<u.length;h++){u.words[h]=0}}var d=i.clone()._ishlnsubmul(n,1,o);if(d.negative===0){i=d;if(u){u.words[o]=1}}for(var c=o-1;c>=0;c--){var l=(i.words[n.length+c]|0)*67108864+(i.words[n.length+c-1]|0);l=Math.min(l/a|0,67108863);i._ishlnsubmul(n,l,c);while(i.negative!==0){l--;i.negative=0;i._ishlnsubmul(n,1,c);if(!i.isZero()){i.negative^=1}}if(u){u.words[c]=l}}if(u){u.strip()}i.strip();if(t!=="div"&&r!==0){i.iushrn(r)}return{div:u||null,mod:i}};BN.prototype.divmod=function divmod(e,t,r){assert(!e.isZero());if(this.isZero()){return{div:new BN(0),mod:new BN(0)}}var i,n,a;if(this.negative!==0&&e.negative===0){a=this.neg().divmod(e,t);if(t!=="mod"){i=a.div.neg()}if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.iadd(e)}}return{div:i,mod:n}}if(this.negative===0&&e.negative!==0){a=this.divmod(e.neg(),t);if(t!=="mod"){i=a.div.neg()}return{div:i,mod:a.mod}}if((this.negative&e.negative)!==0){a=this.neg().divmod(e.neg(),t);if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.isub(e)}}return{div:a.div,mod:n}}if(e.length>this.length||this.cmp(e)<0){return{div:new BN(0),mod:this}}if(e.length===1){if(t==="div"){return{div:this.divn(e.words[0]),mod:null}}if(t==="mod"){return{div:null,mod:new BN(this.modn(e.words[0]))}}return{div:this.divn(e.words[0]),mod:new BN(this.modn(e.words[0]))}}return this._wordDiv(e,t)};BN.prototype.div=function div(e){return this.divmod(e,"div",false).div};BN.prototype.mod=function mod(e){return this.divmod(e,"mod",false).mod};BN.prototype.umod=function umod(e){return this.divmod(e,"mod",true).mod};BN.prototype.divRound=function divRound(e){var t=this.divmod(e);if(t.mod.isZero())return t.div;var r=t.div.negative!==0?t.mod.isub(e):t.mod;var i=e.ushrn(1);var n=e.andln(1);var a=r.cmp(i);if(a<0||n===1&&a===0)return t.div;return t.div.negative!==0?t.div.isubn(1):t.div.iaddn(1)};BN.prototype.modn=function modn(e){assert(e<=67108863);var t=(1<<26)%e;var r=0;for(var i=this.length-1;i>=0;i--){r=(t*r+(this.words[i]|0))%e}return r};BN.prototype.idivn=function idivn(e){assert(e<=67108863);var t=0;for(var r=this.length-1;r>=0;r--){var i=(this.words[r]|0)+t*67108864;this.words[r]=i/e|0;t=i%e}return this.strip()};BN.prototype.divn=function divn(e){return this.clone().idivn(e)};BN.prototype.egcd=function egcd(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=new BN(0);var s=new BN(1);var o=0;while(t.isEven()&&r.isEven()){t.iushrn(1);r.iushrn(1);++o}var u=r.clone();var h=t.clone();while(!t.isZero()){for(var d=0,c=1;(t.words[0]&c)===0&&d<26;++d,c<<=1);if(d>0){t.iushrn(d);while(d-- >0){if(i.isOdd()||n.isOdd()){i.iadd(u);n.isub(h)}i.iushrn(1);n.iushrn(1)}}for(var l=0,p=1;(r.words[0]&p)===0&&l<26;++l,p<<=1);if(l>0){r.iushrn(l);while(l-- >0){if(a.isOdd()||s.isOdd()){a.iadd(u);s.isub(h)}a.iushrn(1);s.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(a);n.isub(s)}else{r.isub(t);a.isub(i);s.isub(n)}}return{a:a,b:s,gcd:r.iushln(o)}};BN.prototype._invmp=function _invmp(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=r.clone();while(t.cmpn(1)>0&&r.cmpn(1)>0){for(var s=0,o=1;(t.words[0]&o)===0&&s<26;++s,o<<=1);if(s>0){t.iushrn(s);while(s-- >0){if(i.isOdd()){i.iadd(a)}i.iushrn(1)}}for(var u=0,h=1;(r.words[0]&h)===0&&u<26;++u,h<<=1);if(u>0){r.iushrn(u);while(u-- >0){if(n.isOdd()){n.iadd(a)}n.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(n)}else{r.isub(t);n.isub(i)}}var d;if(t.cmpn(1)===0){d=i}else{d=n}if(d.cmpn(0)<0){d.iadd(e)}return d};BN.prototype.gcd=function gcd(e){if(this.isZero())return e.abs();if(e.isZero())return this.abs();var t=this.clone();var r=e.clone();t.negative=0;r.negative=0;for(var i=0;t.isEven()&&r.isEven();i++){t.iushrn(1);r.iushrn(1)}do{while(t.isEven()){t.iushrn(1)}while(r.isEven()){r.iushrn(1)}var n=t.cmp(r);if(n<0){var a=t;t=r;r=a}else if(n===0||r.cmpn(1)===0){break}t.isub(r)}while(true);return r.iushln(i)};BN.prototype.invm=function invm(e){return this.egcd(e).a.umod(e)};BN.prototype.isEven=function isEven(){return(this.words[0]&1)===0};BN.prototype.isOdd=function isOdd(){return(this.words[0]&1)===1};BN.prototype.andln=function andln(e){return this.words[0]&e};BN.prototype.bincn=function bincn(e){assert(typeof e==="number");var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r){this._expand(r+1);this.words[r]|=i;return this}var n=i;for(var a=r;n!==0&&a<this.length;a++){var s=this.words[a]|0;s+=n;n=s>>>26;s&=67108863;this.words[a]=s}if(n!==0){this.words[a]=n;this.length++}return this};BN.prototype.isZero=function isZero(){return this.length===1&&this.words[0]===0};BN.prototype.cmpn=function cmpn(e){var t=e<0;if(this.negative!==0&&!t)return-1;if(this.negative===0&&t)return 1;this.strip();var r;if(this.length>1){r=1}else{if(t){e=-e}assert(e<=67108863,"Number is too big");var i=this.words[0]|0;r=i===e?0:i<e?-1:1}if(this.negative!==0)return-r|0;return r};BN.prototype.cmp=function cmp(e){if(this.negative!==0&&e.negative===0)return-1;if(this.negative===0&&e.negative!==0)return 1;var t=this.ucmp(e);if(this.negative!==0)return-t|0;return t};BN.prototype.ucmp=function ucmp(e){if(this.length>e.length)return 1;if(this.length<e.length)return-1;var t=0;for(var r=this.length-1;r>=0;r--){var i=this.words[r]|0;var n=e.words[r]|0;if(i===n)continue;if(i<n){t=-1}else if(i>n){t=1}break}return t};BN.prototype.gtn=function gtn(e){return this.cmpn(e)===1};BN.prototype.gt=function gt(e){return this.cmp(e)===1};BN.prototype.gten=function gten(e){return this.cmpn(e)>=0};BN.prototype.gte=function gte(e){return this.cmp(e)>=0};BN.prototype.ltn=function ltn(e){return this.cmpn(e)===-1};BN.prototype.lt=function lt(e){return this.cmp(e)===-1};BN.prototype.lten=function lten(e){return this.cmpn(e)<=0};BN.prototype.lte=function lte(e){return this.cmp(e)<=0};BN.prototype.eqn=function eqn(e){return this.cmpn(e)===0};BN.prototype.eq=function eq(e){return this.cmp(e)===0};BN.red=function red(e){return new Red(e)};BN.prototype.toRed=function toRed(e){assert(!this.red,"Already a number in reduction context");assert(this.negative===0,"red works only with positives");return e.convertTo(this)._forceRed(e)};BN.prototype.fromRed=function fromRed(){assert(this.red,"fromRed works only with numbers in reduction context");return this.red.convertFrom(this)};BN.prototype._forceRed=function _forceRed(e){this.red=e;return this};BN.prototype.forceRed=function forceRed(e){assert(!this.red,"Already a number in reduction context");return this._forceRed(e)};BN.prototype.redAdd=function redAdd(e){assert(this.red,"redAdd works only with red numbers");return this.red.add(this,e)};BN.prototype.redIAdd=function redIAdd(e){assert(this.red,"redIAdd works only with red numbers");return this.red.iadd(this,e)};BN.prototype.redSub=function redSub(e){assert(this.red,"redSub works only with red numbers");return this.red.sub(this,e)};BN.prototype.redISub=function redISub(e){assert(this.red,"redISub works only with red numbers");return this.red.isub(this,e)};BN.prototype.redShl=function redShl(e){assert(this.red,"redShl works only with red numbers");return this.red.shl(this,e)};BN.prototype.redMul=function redMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.mul(this,e)};BN.prototype.redIMul=function redIMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.imul(this,e)};BN.prototype.redSqr=function redSqr(){assert(this.red,"redSqr works only with red numbers");this.red._verify1(this);return this.red.sqr(this)};BN.prototype.redISqr=function redISqr(){assert(this.red,"redISqr works only with red numbers");this.red._verify1(this);return this.red.isqr(this)};BN.prototype.redSqrt=function redSqrt(){assert(this.red,"redSqrt works only with red numbers");this.red._verify1(this);return this.red.sqrt(this)};BN.prototype.redInvm=function redInvm(){assert(this.red,"redInvm works only with red numbers");this.red._verify1(this);return this.red.invm(this)};BN.prototype.redNeg=function redNeg(){assert(this.red,"redNeg works only with red numbers");this.red._verify1(this);return this.red.neg(this)};BN.prototype.redPow=function redPow(e){assert(this.red&&!e.red,"redPow(normalNum)");this.red._verify1(this);return this.red.pow(this,e)};var u={k256:null,p224:null,p192:null,p25519:null};function MPrime(e,t){this.name=e;this.p=new BN(t,16);this.n=this.p.bitLength();this.k=new BN(1).iushln(this.n).isub(this.p);this.tmp=this._tmp()}MPrime.prototype._tmp=function _tmp(){var e=new BN(null);e.words=new Array(Math.ceil(this.n/13));return e};MPrime.prototype.ireduce=function ireduce(e){var t=e;var r;do{this.split(t,this.tmp);t=this.imulK(t);t=t.iadd(this.tmp);r=t.bitLength()}while(r>this.n);var i=r<this.n?-1:t.ucmp(this.p);if(i===0){t.words[0]=0;t.length=1}else if(i>0){t.isub(this.p)}else{if(t.strip!==undefined){t.strip()}else{t._strip()}}return t};MPrime.prototype.split=function split(e,t){e.iushrn(this.n,0,t)};MPrime.prototype.imulK=function imulK(e){return e.imul(this.k)};function K256(){MPrime.call(this,"k256","ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f")}inherits(K256,MPrime);K256.prototype.split=function split(e,t){var r=4194303;var i=Math.min(e.length,9);for(var n=0;n<i;n++){t.words[n]=e.words[n]}t.length=i;if(e.length<=9){e.words[0]=0;e.length=1;return}var a=e.words[9];t.words[t.length++]=a&r;for(n=10;n<e.length;n++){var s=e.words[n]|0;e.words[n-10]=(s&r)<<4|a>>>22;a=s}a>>>=22;e.words[n-10]=a;if(a===0&&e.length>10){e.length-=10}else{e.length-=9}};K256.prototype.imulK=function imulK(e){e.words[e.length]=0;e.words[e.length+1]=0;e.length+=2;var t=0;for(var r=0;r<e.length;r++){var i=e.words[r]|0;t+=i*977;e.words[r]=t&67108863;t=i*64+(t/67108864|0)}if(e.words[e.length-1]===0){e.length--;if(e.words[e.length-1]===0){e.length--}}return e};function P224(){MPrime.call(this,"p224","ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001")}inherits(P224,MPrime);function P192(){MPrime.call(this,"p192","ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff")}inherits(P192,MPrime);function P25519(){MPrime.call(this,"25519","7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed")}inherits(P25519,MPrime);P25519.prototype.imulK=function imulK(e){var t=0;for(var r=0;r<e.length;r++){var i=(e.words[r]|0)*19+t;var n=i&67108863;i>>>=26;e.words[r]=n;t=i}if(t!==0){e.words[e.length++]=t}return e};BN._prime=function prime(e){if(u[e])return u[e];var prime;if(e==="k256"){prime=new K256}else if(e==="p224"){prime=new P224}else if(e==="p192"){prime=new P192}else if(e==="p25519"){prime=new P25519}else{throw new Error("Unknown prime "+e)}u[e]=prime;return prime};function Red(e){if(typeof e==="string"){var t=BN._prime(e);this.m=t.p;this.prime=t}else{assert(e.gtn(1),"modulus must be greater than 1");this.m=e;this.prime=null}}Red.prototype._verify1=function _verify1(e){assert(e.negative===0,"red works only with positives");assert(e.red,"red works only with red numbers")};Red.prototype._verify2=function _verify2(e,t){assert((e.negative|t.negative)===0,"red works only with positives");assert(e.red&&e.red===t.red,"red works only with red numbers")};Red.prototype.imod=function imod(e){if(this.prime)return this.prime.ireduce(e)._forceRed(this);return e.umod(this.m)._forceRed(this)};Red.prototype.neg=function neg(e){if(e.isZero()){return e.clone()}return this.m.sub(e)._forceRed(this)};Red.prototype.add=function add(e,t){this._verify2(e,t);var r=e.add(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r._forceRed(this)};Red.prototype.iadd=function iadd(e,t){this._verify2(e,t);var r=e.iadd(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r};Red.prototype.sub=function sub(e,t){this._verify2(e,t);var r=e.sub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r._forceRed(this)};Red.prototype.isub=function isub(e,t){this._verify2(e,t);var r=e.isub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r};Red.prototype.shl=function shl(e,t){this._verify1(e);return this.imod(e.ushln(t))};Red.prototype.imul=function imul(e,t){this._verify2(e,t);return this.imod(e.imul(t))};Red.prototype.mul=function mul(e,t){this._verify2(e,t);return this.imod(e.mul(t))};Red.prototype.isqr=function isqr(e){return this.imul(e,e.clone())};Red.prototype.sqr=function sqr(e){return this.mul(e,e)};Red.prototype.sqrt=function sqrt(e){if(e.isZero())return e.clone();var t=this.m.andln(3);assert(t%2===1);if(t===3){var r=this.m.add(new BN(1)).iushrn(2);return this.pow(e,r)}var i=this.m.subn(1);var n=0;while(!i.isZero()&&i.andln(1)===0){n++;i.iushrn(1)}assert(!i.isZero());var a=new BN(1).toRed(this);var s=a.redNeg();var o=this.m.subn(1).iushrn(1);var u=this.m.bitLength();u=new BN(2*u*u).toRed(this);while(this.pow(u,o).cmp(s)!==0){u.redIAdd(s)}var h=this.pow(u,i);var d=this.pow(e,i.addn(1).iushrn(1));var c=this.pow(e,i);var l=n;while(c.cmp(a)!==0){var p=c;for(var b=0;p.cmp(a)!==0;b++){p=p.redSqr()}assert(b<l);var v=this.pow(h,new BN(1).iushln(l-b-1));d=d.redMul(v);h=v.redSqr();c=c.redMul(h);l=b}return d};Red.prototype.invm=function invm(e){var t=e._invmp(this.m);if(t.negative!==0){t.negative=0;return this.imod(t).redNeg()}else{return this.imod(t)}};Red.prototype.pow=function pow(e,t){if(t.isZero())return new BN(1).toRed(this);if(t.cmpn(1)===0)return e.clone();var r=4;var i=new Array(1<<r);i[0]=new BN(1).toRed(this);i[1]=e;for(var n=2;n<i.length;n++){i[n]=this.mul(i[n-1],e)}var a=i[0];var s=0;var o=0;var u=t.bitLength()%26;if(u===0){u=26}for(n=t.length-1;n>=0;n--){var h=t.words[n];for(var d=u-1;d>=0;d--){var c=h>>d&1;if(a!==i[0]){a=this.sqr(a)}if(c===0&&s===0){o=0;continue}s<<=1;s|=c;o++;if(o!==r&&(n!==0||d!==0))continue;a=this.mul(a,i[s]);o=0;s=0}u=26}return a};Red.prototype.convertTo=function convertTo(e){var t=e.umod(this.m);return t===e?t.clone():t};Red.prototype.convertFrom=function convertFrom(e){var t=e.clone();t.red=null;return t};BN.mont=function mont(e){return new Mont(e)};function Mont(e){Red.call(this,e);this.shift=this.m.bitLength();if(this.shift%26!==0){this.shift+=26-this.shift%26}this.r=new BN(1).iushln(this.shift);this.r2=this.imod(this.r.sqr());this.rinv=this.r._invmp(this.m);this.minv=this.rinv.mul(this.r).isubn(1).div(this.m);this.minv=this.minv.umod(this.r);this.minv=this.r.sub(this.minv)}inherits(Mont,Red);Mont.prototype.convertTo=function convertTo(e){return this.imod(e.ushln(this.shift))};Mont.prototype.convertFrom=function convertFrom(e){var t=this.imod(e.mul(this.rinv));t.red=null;return t};Mont.prototype.imul=function imul(e,t){if(e.isZero()||t.isZero()){e.words[0]=0;e.length=1;return e}var r=e.imul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.mul=function mul(e,t){if(e.isZero()||t.isZero())return new BN(0)._forceRed(this);var r=e.mul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.invm=function invm(e){var t=this.imod(e._invmp(this.m).mul(this.r2));return t._forceRed(this)}})( false||e,this)},6069:function(e,t,r){var i;e.exports=function rand(e){if(!i)i=new Rand(null);return i.generate(e)};function Rand(e){this.rand=e}e.exports.Rand=Rand;Rand.prototype.generate=function generate(e){return this._rand(e)};Rand.prototype._rand=function _rand(e){if(this.rand.getBytes)return this.rand.getBytes(e);var t=new Uint8Array(e);for(var r=0;r<t.length;r++)t[r]=this.rand.getByte();return t};if(typeof self==="object"){if(self.crypto&&self.crypto.getRandomValues){Rand.prototype._rand=function _rand(e){var t=new Uint8Array(e);self.crypto.getRandomValues(t);return t}}else if(self.msCrypto&&self.msCrypto.getRandomValues){Rand.prototype._rand=function _rand(e){var t=new Uint8Array(e);self.msCrypto.getRandomValues(t);return t}}else if(typeof window==="object"){Rand.prototype._rand=function(){throw new Error("Not implemented yet")}}}else{try{var n=r(6113);if(typeof n.randomBytes!=="function")throw new Error("Not supported");Rand.prototype._rand=function _rand(e){return n.randomBytes(e)}}catch(e){}}},9725:function(e,t,r){var i=r(3118).Buffer;function asUInt32Array(e){if(!i.isBuffer(e))e=i.from(e);var t=e.length/4|0;var r=new Array(t);for(var n=0;n<t;n++){r[n]=e.readUInt32BE(n*4)}return r}function scrubVec(e){for(var t=0;t<e.length;e++){e[t]=0}}function cryptBlock(e,t,r,i,n){var a=r[0];var s=r[1];var o=r[2];var u=r[3];var h=e[0]^t[0];var d=e[1]^t[1];var c=e[2]^t[2];var l=e[3]^t[3];var p,b,v,m;var y=4;for(var g=1;g<n;g++){p=a[h>>>24]^s[d>>>16&255]^o[c>>>8&255]^u[l&255]^t[y++];b=a[d>>>24]^s[c>>>16&255]^o[l>>>8&255]^u[h&255]^t[y++];v=a[c>>>24]^s[l>>>16&255]^o[h>>>8&255]^u[d&255]^t[y++];m=a[l>>>24]^s[h>>>16&255]^o[d>>>8&255]^u[c&255]^t[y++];h=p;d=b;c=v;l=m}p=(i[h>>>24]<<24|i[d>>>16&255]<<16|i[c>>>8&255]<<8|i[l&255])^t[y++];b=(i[d>>>24]<<24|i[c>>>16&255]<<16|i[l>>>8&255]<<8|i[h&255])^t[y++];v=(i[c>>>24]<<24|i[l>>>16&255]<<16|i[h>>>8&255]<<8|i[d&255])^t[y++];m=(i[l>>>24]<<24|i[h>>>16&255]<<16|i[d>>>8&255]<<8|i[c&255])^t[y++];p=p>>>0;b=b>>>0;v=v>>>0;m=m>>>0;return[p,b,v,m]}var n=[0,1,2,4,8,16,32,64,128,27,54];var a=function(){var e=new Array(256);for(var t=0;t<256;t++){if(t<128){e[t]=t<<1}else{e[t]=t<<1^283}}var r=[];var i=[];var n=[[],[],[],[]];var a=[[],[],[],[]];var s=0;var o=0;for(var u=0;u<256;++u){var h=o^o<<1^o<<2^o<<3^o<<4;h=h>>>8^h&255^99;r[s]=h;i[h]=s;var d=e[s];var c=e[d];var l=e[c];var p=e[h]*257^h*16843008;n[0][s]=p<<24|p>>>8;n[1][s]=p<<16|p>>>16;n[2][s]=p<<8|p>>>24;n[3][s]=p;p=l*16843009^c*65537^d*257^s*16843008;a[0][h]=p<<24|p>>>8;a[1][h]=p<<16|p>>>16;a[2][h]=p<<8|p>>>24;a[3][h]=p;if(s===0){s=o=1}else{s=d^e[e[e[l^d]]];o^=e[e[o]]}}return{SBOX:r,INV_SBOX:i,SUB_MIX:n,INV_SUB_MIX:a}}();function AES(e){this._key=asUInt32Array(e);this._reset()}AES.blockSize=4*4;AES.keySize=256/8;AES.prototype.blockSize=AES.blockSize;AES.prototype.keySize=AES.keySize;AES.prototype._reset=function(){var e=this._key;var t=e.length;var r=t+6;var i=(r+1)*4;var s=[];for(var o=0;o<t;o++){s[o]=e[o]}for(o=t;o<i;o++){var u=s[o-1];if(o%t===0){u=u<<8|u>>>24;u=a.SBOX[u>>>24]<<24|a.SBOX[u>>>16&255]<<16|a.SBOX[u>>>8&255]<<8|a.SBOX[u&255];u^=n[o/t|0]<<24}else if(t>6&&o%t===4){u=a.SBOX[u>>>24]<<24|a.SBOX[u>>>16&255]<<16|a.SBOX[u>>>8&255]<<8|a.SBOX[u&255]}s[o]=s[o-t]^u}var h=[];for(var d=0;d<i;d++){var c=i-d;var l=s[c-(d%4?0:4)];if(d<4||c<=4){h[d]=l}else{h[d]=a.INV_SUB_MIX[0][a.SBOX[l>>>24]]^a.INV_SUB_MIX[1][a.SBOX[l>>>16&255]]^a.INV_SUB_MIX[2][a.SBOX[l>>>8&255]]^a.INV_SUB_MIX[3][a.SBOX[l&255]]}}this._nRounds=r;this._keySchedule=s;this._invKeySchedule=h};AES.prototype.encryptBlockRaw=function(e){e=asUInt32Array(e);return cryptBlock(e,this._keySchedule,a.SUB_MIX,a.SBOX,this._nRounds)};AES.prototype.encryptBlock=function(e){var t=this.encryptBlockRaw(e);var r=i.allocUnsafe(16);r.writeUInt32BE(t[0],0);r.writeUInt32BE(t[1],4);r.writeUInt32BE(t[2],8);r.writeUInt32BE(t[3],12);return r};AES.prototype.decryptBlock=function(e){e=asUInt32Array(e);var t=e[1];e[1]=e[3];e[3]=t;var r=cryptBlock(e,this._invKeySchedule,a.INV_SUB_MIX,a.INV_SBOX,this._nRounds);var n=i.allocUnsafe(16);n.writeUInt32BE(r[0],0);n.writeUInt32BE(r[3],4);n.writeUInt32BE(r[2],8);n.writeUInt32BE(r[1],12);return n};AES.prototype.scrub=function(){scrubVec(this._keySchedule);scrubVec(this._invKeySchedule);scrubVec(this._key)};e.exports.AES=AES},5112:function(e,t,r){var i=r(9725);var n=r(3118).Buffer;var a=r(8826);var s=r(7526);var o=r(7731);var u=r(5653);var h=r(4630);function xorTest(e,t){var r=0;if(e.length!==t.length)r++;var i=Math.min(e.length,t.length);for(var n=0;n<i;++n){r+=e[n]^t[n]}return r}function calcIv(e,t,r){if(t.length===12){e._finID=n.concat([t,n.from([0,0,0,1])]);return n.concat([t,n.from([0,0,0,2])])}var i=new o(r);var a=t.length;var s=a%16;i.update(t);if(s){s=16-s;i.update(n.alloc(s,0))}i.update(n.alloc(8,0));var u=a*8;var d=n.alloc(8);d.writeUIntBE(u,0,8);i.update(d);e._finID=i.state;var c=n.from(e._finID);h(c);return c}function StreamCipher(e,t,r,s){a.call(this);var u=n.alloc(4,0);this._cipher=new i.AES(t);var h=this._cipher.encryptBlock(u);this._ghash=new o(h);r=calcIv(this,r,h);this._prev=n.from(r);this._cache=n.allocUnsafe(0);this._secCache=n.allocUnsafe(0);this._decrypt=s;this._alen=0;this._len=0;this._mode=e;this._authTag=null;this._called=false}s(StreamCipher,a);StreamCipher.prototype._update=function(e){if(!this._called&&this._alen){var t=16-this._alen%16;if(t<16){t=n.alloc(t,0);this._ghash.update(t)}}this._called=true;var r=this._mode.encrypt(this,e);if(this._decrypt){this._ghash.update(e)}else{this._ghash.update(r)}this._len+=e.length;return r};StreamCipher.prototype._final=function(){if(this._decrypt&&!this._authTag)throw new Error("Unsupported state or unable to authenticate data");var e=u(this._ghash.final(this._alen*8,this._len*8),this._cipher.encryptBlock(this._finID));if(this._decrypt&&xorTest(e,this._authTag))throw new Error("Unsupported state or unable to authenticate data");this._authTag=e;this._cipher.scrub()};StreamCipher.prototype.getAuthTag=function getAuthTag(){if(this._decrypt||!n.isBuffer(this._authTag))throw new Error("Attempting to get auth tag in unsupported state");return this._authTag};StreamCipher.prototype.setAuthTag=function setAuthTag(e){if(!this._decrypt)throw new Error("Attempting to set auth tag in unsupported state");this._authTag=e};StreamCipher.prototype.setAAD=function setAAD(e){if(this._called)throw new Error("Attempting to set AAD in unsupported state");this._ghash.update(e);this._alen+=e.length};e.exports=StreamCipher},7384:function(e,t,r){var i=r(9811);var n=r(8552);var a=r(9234);function getCiphers(){return Object.keys(a)}t.createCipher=t.Cipher=i.createCipher;t.createCipheriv=t.Cipheriv=i.createCipheriv;t.createDecipher=t.Decipher=n.createDecipher;t.createDecipheriv=t.Decipheriv=n.createDecipheriv;t.listCiphers=t.getCiphers=getCiphers},8552:function(e,t,r){var i=r(5112);var n=r(3118).Buffer;var a=r(8963);var s=r(6255);var o=r(8826);var u=r(9725);var h=r(7325);var d=r(7526);function Decipher(e,t,r){o.call(this);this._cache=new Splitter;this._last=void 0;this._cipher=new u.AES(t);this._prev=n.from(r);this._mode=e;this._autopadding=true}d(Decipher,o);Decipher.prototype._update=function(e){this._cache.add(e);var t;var r;var i=[];while(t=this._cache.get(this._autopadding)){r=this._mode.decrypt(this,t);i.push(r)}return n.concat(i)};Decipher.prototype._final=function(){var e=this._cache.flush();if(this._autopadding){return unpad(this._mode.decrypt(this,e))}else if(e){throw new Error("data not multiple of block length")}};Decipher.prototype.setAutoPadding=function(e){this._autopadding=!!e;return this};function Splitter(){this.cache=n.allocUnsafe(0)}Splitter.prototype.add=function(e){this.cache=n.concat([this.cache,e])};Splitter.prototype.get=function(e){var t;if(e){if(this.cache.length>16){t=this.cache.slice(0,16);this.cache=this.cache.slice(16);return t}}else{if(this.cache.length>=16){t=this.cache.slice(0,16);this.cache=this.cache.slice(16);return t}}return null};Splitter.prototype.flush=function(){if(this.cache.length)return this.cache};function unpad(e){var t=e[15];if(t<1||t>16){throw new Error("unable to decrypt data")}var r=-1;while(++r<t){if(e[r+(16-t)]!==t){throw new Error("unable to decrypt data")}}if(t===16)return;return e.slice(0,16-t)}function createDecipheriv(e,t,r){var o=a[e.toLowerCase()];if(!o)throw new TypeError("invalid suite type");if(typeof r==="string")r=n.from(r);if(o.mode!=="GCM"&&r.length!==o.iv)throw new TypeError("invalid iv length "+r.length);if(typeof t==="string")t=n.from(t);if(t.length!==o.key/8)throw new TypeError("invalid key length "+t.length);if(o.type==="stream"){return new s(o.module,t,r,true)}else if(o.type==="auth"){return new i(o.module,t,r,true)}return new Decipher(o.module,t,r)}function createDecipher(e,t){var r=a[e.toLowerCase()];if(!r)throw new TypeError("invalid suite type");var i=h(t,false,r.key,r.iv);return createDecipheriv(e,i.key,i.iv)}t.createDecipher=createDecipher;t.createDecipheriv=createDecipheriv},9811:function(e,t,r){var i=r(8963);var n=r(5112);var a=r(3118).Buffer;var s=r(6255);var o=r(8826);var u=r(9725);var h=r(7325);var d=r(7526);function Cipher(e,t,r){o.call(this);this._cache=new Splitter;this._cipher=new u.AES(t);this._prev=a.from(r);this._mode=e;this._autopadding=true}d(Cipher,o);Cipher.prototype._update=function(e){this._cache.add(e);var t;var r;var i=[];while(t=this._cache.get()){r=this._mode.encrypt(this,t);i.push(r)}return a.concat(i)};var c=a.alloc(16,16);Cipher.prototype._final=function(){var e=this._cache.flush();if(this._autopadding){e=this._mode.encrypt(this,e);this._cipher.scrub();return e}if(!e.equals(c)){this._cipher.scrub();throw new Error("data not multiple of block length")}};Cipher.prototype.setAutoPadding=function(e){this._autopadding=!!e;return this};function Splitter(){this.cache=a.allocUnsafe(0)}Splitter.prototype.add=function(e){this.cache=a.concat([this.cache,e])};Splitter.prototype.get=function(){if(this.cache.length>15){var e=this.cache.slice(0,16);this.cache=this.cache.slice(16);return e}return null};Splitter.prototype.flush=function(){var e=16-this.cache.length;var t=a.allocUnsafe(e);var r=-1;while(++r<e){t.writeUInt8(e,r)}return a.concat([this.cache,t])};function createCipheriv(e,t,r){var o=i[e.toLowerCase()];if(!o)throw new TypeError("invalid suite type");if(typeof t==="string")t=a.from(t);if(t.length!==o.key/8)throw new TypeError("invalid key length "+t.length);if(typeof r==="string")r=a.from(r);if(o.mode!=="GCM"&&r.length!==o.iv)throw new TypeError("invalid iv length "+r.length);if(o.type==="stream"){return new s(o.module,t,r)}else if(o.type==="auth"){return new n(o.module,t,r)}return new Cipher(o.module,t,r)}function createCipher(e,t){var r=i[e.toLowerCase()];if(!r)throw new TypeError("invalid suite type");var n=h(t,false,r.key,r.iv);return createCipheriv(e,n.key,n.iv)}t.createCipheriv=createCipheriv;t.createCipher=createCipher},7731:function(e,t,r){var i=r(3118).Buffer;var n=i.alloc(16,0);function toArray(e){return[e.readUInt32BE(0),e.readUInt32BE(4),e.readUInt32BE(8),e.readUInt32BE(12)]}function fromArray(e){var t=i.allocUnsafe(16);t.writeUInt32BE(e[0]>>>0,0);t.writeUInt32BE(e[1]>>>0,4);t.writeUInt32BE(e[2]>>>0,8);t.writeUInt32BE(e[3]>>>0,12);return t}function GHASH(e){this.h=e;this.state=i.alloc(16,0);this.cache=i.allocUnsafe(0)}GHASH.prototype.ghash=function(e){var t=-1;while(++t<e.length){this.state[t]^=e[t]}this._multiply()};GHASH.prototype._multiply=function(){var e=toArray(this.h);var t=[0,0,0,0];var r,i,n;var a=-1;while(++a<128){i=(this.state[~~(a/8)]&1<<7-a%8)!==0;if(i){t[0]^=e[0];t[1]^=e[1];t[2]^=e[2];t[3]^=e[3]}n=(e[3]&1)!==0;for(r=3;r>0;r--){e[r]=e[r]>>>1|(e[r-1]&1)<<31}e[0]=e[0]>>>1;if(n){e[0]=e[0]^225<<24}}this.state=fromArray(t)};GHASH.prototype.update=function(e){this.cache=i.concat([this.cache,e]);var t;while(this.cache.length>=16){t=this.cache.slice(0,16);this.cache=this.cache.slice(16);this.ghash(t)}};GHASH.prototype.final=function(e,t){if(this.cache.length){this.ghash(i.concat([this.cache,n],16))}this.ghash(fromArray([0,e,0,t]));return this.state};e.exports=GHASH},4630:function(e){function incr32(e){var t=e.length;var r;while(t--){r=e.readUInt8(t);if(r===255){e.writeUInt8(0,t)}else{r++;e.writeUInt8(r,t);break}}}e.exports=incr32},4156:function(e,t,r){var i=r(5653);t.encrypt=function(e,t){var r=i(t,e._prev);e._prev=e._cipher.encryptBlock(r);return e._prev};t.decrypt=function(e,t){var r=e._prev;e._prev=t;var n=e._cipher.decryptBlock(t);return i(n,r)}},2509:function(e,t,r){var i=r(3118).Buffer;var n=r(5653);function encryptStart(e,t,r){var a=t.length;var s=n(t,e._cache);e._cache=e._cache.slice(a);e._prev=i.concat([e._prev,r?t:s]);return s}t.encrypt=function(e,t,r){var n=i.allocUnsafe(0);var a;while(t.length){if(e._cache.length===0){e._cache=e._cipher.encryptBlock(e._prev);e._prev=i.allocUnsafe(0)}if(e._cache.length<=t.length){a=e._cache.length;n=i.concat([n,encryptStart(e,t.slice(0,a),r)]);t=t.slice(a)}else{n=i.concat([n,encryptStart(e,t,r)]);break}}return n}},9010:function(e,t,r){var i=r(3118).Buffer;function encryptByte(e,t,r){var i;var n=-1;var a=8;var s=0;var o,u;while(++n<a){i=e._cipher.encryptBlock(e._prev);o=t&1<<7-n?128:0;u=i[0]^o;s+=(u&128)>>n%8;e._prev=shiftIn(e._prev,r?o:u)}return s}function shiftIn(e,t){var r=e.length;var n=-1;var a=i.allocUnsafe(e.length);e=i.concat([e,i.from([t])]);while(++n<r){a[n]=e[n]<<1|e[n+1]>>7}return a}t.encrypt=function(e,t,r){var n=t.length;var a=i.allocUnsafe(n);var s=-1;while(++s<n){a[s]=encryptByte(e,t[s],r)}return a}},3633:function(e,t,r){var i=r(3118).Buffer;function encryptByte(e,t,r){var n=e._cipher.encryptBlock(e._prev);var a=n[0]^t;e._prev=i.concat([e._prev.slice(1),i.from([r?t:a])]);return a}t.encrypt=function(e,t,r){var n=t.length;var a=i.allocUnsafe(n);var s=-1;while(++s<n){a[s]=encryptByte(e,t[s],r)}return a}},1739:function(e,t,r){var i=r(5653);var n=r(3118).Buffer;var a=r(4630);function getBlock(e){var t=e._cipher.encryptBlockRaw(e._prev);a(e._prev);return t}var s=16;t.encrypt=function(e,t){var r=Math.ceil(t.length/s);var a=e._cache.length;e._cache=n.concat([e._cache,n.allocUnsafe(r*s)]);for(var o=0;o<r;o++){var u=getBlock(e);var h=a+o*s;e._cache.writeUInt32BE(u[0],h+0);e._cache.writeUInt32BE(u[1],h+4);e._cache.writeUInt32BE(u[2],h+8);e._cache.writeUInt32BE(u[3],h+12)}var d=e._cache.slice(0,t.length);e._cache=e._cache.slice(t.length);return i(t,d)}},8288:function(e,t){t.encrypt=function(e,t){return e._cipher.encryptBlock(t)};t.decrypt=function(e,t){return e._cipher.decryptBlock(t)}},8963:function(e,t,r){var i={ECB:r(8288),CBC:r(4156),CFB:r(2509),CFB8:r(3633),CFB1:r(9010),OFB:r(8036),CTR:r(1739),GCM:r(1739)};var n=r(9234);for(var a in n){n[a].module=i[n[a].mode]}e.exports=n},8036:function(e,t,r){var i=r(5653);function getBlock(e){e._prev=e._cipher.encryptBlock(e._prev);return e._prev}t.encrypt=function(e,t){while(e._cache.length<t.length){e._cache=Buffer.concat([e._cache,getBlock(e)])}var r=e._cache.slice(0,t.length);e._cache=e._cache.slice(t.length);return i(t,r)}},6255:function(e,t,r){var i=r(9725);var n=r(3118).Buffer;var a=r(8826);var s=r(7526);function StreamCipher(e,t,r,s){a.call(this);this._cipher=new i.AES(t);this._prev=n.from(r);this._cache=n.allocUnsafe(0);this._secCache=n.allocUnsafe(0);this._decrypt=s;this._mode=e}s(StreamCipher,a);StreamCipher.prototype._update=function(e){return this._mode.encrypt(this,e,this._decrypt)};StreamCipher.prototype._final=function(){this._cipher.scrub()};e.exports=StreamCipher},57:function(e,t,r){var i=r(9917);var n=r(7384);var a=r(8963);var s=r(2334);var o=r(7325);function createCipher(e,t){e=e.toLowerCase();var r,i;if(a[e]){r=a[e].key;i=a[e].iv}else if(s[e]){r=s[e].key*8;i=s[e].iv}else{throw new TypeError("invalid suite type")}var n=o(t,false,r,i);return createCipheriv(e,n.key,n.iv)}function createDecipher(e,t){e=e.toLowerCase();var r,i;if(a[e]){r=a[e].key;i=a[e].iv}else if(s[e]){r=s[e].key*8;i=s[e].iv}else{throw new TypeError("invalid suite type")}var n=o(t,false,r,i);return createDecipheriv(e,n.key,n.iv)}function createCipheriv(e,t,r){e=e.toLowerCase();if(a[e])return n.createCipheriv(e,t,r);if(s[e])return new i({key:t,iv:r,mode:e});throw new TypeError("invalid suite type")}function createDecipheriv(e,t,r){e=e.toLowerCase();if(a[e])return n.createDecipheriv(e,t,r);if(s[e])return new i({key:t,iv:r,mode:e,decrypt:true});throw new TypeError("invalid suite type")}function getCiphers(){return Object.keys(s).concat(n.getCiphers())}t.createCipher=t.Cipher=createCipher;t.createCipheriv=t.Cipheriv=createCipheriv;t.createDecipher=t.Decipher=createDecipher;t.createDecipheriv=t.Decipheriv=createDecipheriv;t.listCiphers=t.getCiphers=getCiphers},9917:function(e,t,r){var i=r(8826);var n=r(7795);var a=r(7526);var s=r(3118).Buffer;var o={"des-ede3-cbc":n.CBC.instantiate(n.EDE),"des-ede3":n.EDE,"des-ede-cbc":n.CBC.instantiate(n.EDE),"des-ede":n.EDE,"des-cbc":n.CBC.instantiate(n.DES),"des-ecb":n.DES};o.des=o["des-cbc"];o.des3=o["des-ede3-cbc"];e.exports=DES;a(DES,i);function DES(e){i.call(this);var t=e.mode.toLowerCase();var r=o[t];var n;if(e.decrypt){n="decrypt"}else{n="encrypt"}var a=e.key;if(!s.isBuffer(a)){a=s.from(a)}if(t==="des-ede"||t==="des-ede-cbc"){a=s.concat([a,a.slice(0,8)])}var u=e.iv;if(!s.isBuffer(u)){u=s.from(u)}this._des=r.create({key:a,iv:u,type:n})}DES.prototype._update=function(e){return s.from(this._des.update(e))};DES.prototype._final=function(){return s.from(this._des.final())}},2334:function(e,t){t["des-ecb"]={key:8,iv:0};t["des-cbc"]=t.des={key:8,iv:8};t["des-ede3-cbc"]=t.des3={key:24,iv:8};t["des-ede3"]={key:24,iv:0};t["des-ede-cbc"]={key:16,iv:8};t["des-ede"]={key:16,iv:0}},6236:function(e,t,r){var i=r(6884);var n=r(2711);e.exports=crt;function blind(e){var t=getr(e);var r=t.toRed(i.mont(e.modulus)).redPow(new i(e.publicExponent)).fromRed();return{blinder:r,unblinder:t.invm(e.modulus)}}function crt(e,t){var r=blind(t);var n=t.modulus.byteLength();var a=i.mont(t.modulus);var s=new i(e).mul(r.blinder).umod(t.modulus);var o=s.toRed(i.mont(t.prime1));var u=s.toRed(i.mont(t.prime2));var h=t.coefficient;var d=t.prime1;var c=t.prime2;var l=o.redPow(t.exponent1);var p=u.redPow(t.exponent2);l=l.fromRed();p=p.fromRed();var b=l.isub(p).imul(h).umod(d);b.imul(c);p.iadd(b);return new Buffer(p.imul(r.unblinder).umod(t.modulus).toArray(false,n))}crt.getr=getr;function getr(e){var t=e.modulus.byteLength();var r=new i(n(t));while(r.cmp(e.modulus)>=0||!r.umod(e.prime1)||!r.umod(e.prime2)){r=new i(n(t))}return r}},5703:function(e,t,r){e.exports=r(26)},1265:function(e,t,r){var i=r(3118).Buffer;var n=r(2539);var a=r(6572);var s=r(7526);var o=r(3596);var u=r(9204);var h=r(26);Object.keys(h).forEach((function(e){h[e].id=i.from(h[e].id,"hex");h[e.toLowerCase()]=h[e]}));function Sign(e){a.Writable.call(this);var t=h[e];if(!t)throw new Error("Unknown message digest");this._hashType=t.hash;this._hash=n(t.hash);this._tag=t.id;this._signType=t.sign}s(Sign,a.Writable);Sign.prototype._write=function _write(e,t,r){this._hash.update(e);r()};Sign.prototype.update=function update(e,t){if(typeof e==="string")e=i.from(e,t);this._hash.update(e);return this};Sign.prototype.sign=function signMethod(e,t){this.end();var r=this._hash.digest();var i=o(r,e,this._hashType,this._signType,this._tag);return t?i.toString(t):i};function Verify(e){a.Writable.call(this);var t=h[e];if(!t)throw new Error("Unknown message digest");this._hash=n(t.hash);this._tag=t.id;this._signType=t.sign}s(Verify,a.Writable);Verify.prototype._write=function _write(e,t,r){this._hash.update(e);r()};Verify.prototype.update=function update(e,t){if(typeof e==="string")e=i.from(e,t);this._hash.update(e);return this};Verify.prototype.verify=function verifyMethod(e,t,r){if(typeof t==="string")t=i.from(t,r);this.end();var n=this._hash.digest();return u(t,n,e,this._signType,this._tag)};function createSign(e){return new Sign(e)}function createVerify(e){return new Verify(e)}e.exports={Sign:createSign,Verify:createVerify,createSign:createSign,createVerify:createVerify}},3596:function(e,t,r){var i=r(3118).Buffer;var n=r(2730);var a=r(6236);var s=r(8818).ec;var o=r(5410);var u=r(569);var h=r(9167);function sign(e,t,r,n,s){var o=u(t);if(o.curve){if(n!=="ecdsa"&&n!=="ecdsa/rsa")throw new Error("wrong private key type");return ecSign(e,o)}else if(o.type==="dsa"){if(n!=="dsa")throw new Error("wrong private key type");return dsaSign(e,o,r)}else{if(n!=="rsa"&&n!=="ecdsa/rsa")throw new Error("wrong private key type")}e=i.concat([s,e]);var h=o.modulus.byteLength();var d=[0,1];while(e.length+d.length+1<h)d.push(255);d.push(0);var c=-1;while(++c<e.length)d.push(e[c]);var l=a(d,o);return l}function ecSign(e,t){var r=h[t.curve.join(".")];if(!r)throw new Error("unknown curve "+t.curve.join("."));var n=new s(r);var a=n.keyFromPrivate(t.privateKey);var o=a.sign(e);return i.from(o.toDER())}function dsaSign(e,t,r){var i=t.params.priv_key;var n=t.params.p;var a=t.params.q;var s=t.params.g;var u=new o(0);var h;var d=bits2int(e,a).mod(a);var c=false;var l=getKey(i,a,e,r);while(c===false){h=makeKey(a,l,r);u=makeR(s,h,n,a);c=h.invm(a).imul(d.add(i.mul(u))).mod(a);if(c.cmpn(0)===0){c=false;u=new o(0)}}return toDER(u,c)}function toDER(e,t){e=e.toArray();t=t.toArray();if(e[0]&128)e=[0].concat(e);if(t[0]&128)t=[0].concat(t);var r=e.length+t.length+4;var n=[48,r,2,e.length];n=n.concat(e,[2,t.length],t);return i.from(n)}function getKey(e,t,r,a){e=i.from(e.toArray());if(e.length<t.byteLength()){var s=i.alloc(t.byteLength()-e.length);e=i.concat([s,e])}var o=r.length;var u=bits2octets(r,t);var h=i.alloc(o);h.fill(1);var d=i.alloc(o);d=n(a,d).update(h).update(i.from([0])).update(e).update(u).digest();h=n(a,d).update(h).digest();d=n(a,d).update(h).update(i.from([1])).update(e).update(u).digest();h=n(a,d).update(h).digest();return{k:d,v:h}}function bits2int(e,t){var r=new o(e);var i=(e.length<<3)-t.bitLength();if(i>0)r.ishrn(i);return r}function bits2octets(e,t){e=bits2int(e,t);e=e.mod(t);var r=i.from(e.toArray());if(r.length<t.byteLength()){var n=i.alloc(t.byteLength()-r.length);r=i.concat([n,r])}return r}function makeKey(e,t,r){var a;var s;do{a=i.alloc(0);while(a.length*8<e.bitLength()){t.v=n(r,t.k).update(t.v).digest();a=i.concat([a,t.v])}s=bits2int(a,e);t.k=n(r,t.k).update(t.v).update(i.from([0])).digest();t.v=n(r,t.k).update(t.v).digest()}while(s.cmp(e)!==-1);return s}function makeR(e,t,r,i){return e.toRed(o.mont(r)).redPow(t).fromRed().mod(i)}e.exports=sign;e.exports.getKey=getKey;e.exports.makeKey=makeKey},9204:function(e,t,r){var i=r(3118).Buffer;var n=r(5410);var a=r(8818).ec;var s=r(569);var o=r(9167);function verify(e,t,r,a,o){var u=s(r);if(u.type==="ec"){if(a!=="ecdsa"&&a!=="ecdsa/rsa")throw new Error("wrong public key type");return ecVerify(e,t,u)}else if(u.type==="dsa"){if(a!=="dsa")throw new Error("wrong public key type");return dsaVerify(e,t,u)}else{if(a!=="rsa"&&a!=="ecdsa/rsa")throw new Error("wrong public key type")}t=i.concat([o,t]);var h=u.modulus.byteLength();var d=[1];var c=0;while(t.length+d.length+2<h){d.push(255);c++}d.push(0);var l=-1;while(++l<t.length){d.push(t[l])}d=i.from(d);var p=n.mont(u.modulus);e=new n(e).toRed(p);e=e.redPow(new n(u.publicExponent));e=i.from(e.fromRed().toArray());var b=c<8?1:0;h=Math.min(e.length,d.length);if(e.length!==d.length)b=1;l=-1;while(++l<h)b|=e[l]^d[l];return b===0}function ecVerify(e,t,r){var i=o[r.data.algorithm.curve.join(".")];if(!i)throw new Error("unknown curve "+r.data.algorithm.curve.join("."));var n=new a(i);var s=r.data.subjectPrivateKey.data;return n.verify(t,e,s)}function dsaVerify(e,t,r){var i=r.data.p;var a=r.data.q;var o=r.data.g;var u=r.data.pub_key;var h=s.signature.decode(e,"der");var d=h.s;var c=h.r;checkValue(d,a);checkValue(c,a);var l=n.mont(i);var p=d.invm(a);var b=o.toRed(l).redPow(new n(t).mul(p).mod(a)).fromRed().mul(u.toRed(l).redPow(c.mul(p).mod(a)).fromRed()).mod(i).mod(a);return b.cmp(c)===0}function checkValue(e,t){if(e.cmpn(0)<=0)throw new Error("invalid sig");if(e.cmp(t)>=t)throw new Error("invalid sig")}e.exports=verify},5410:function(e,t,r){e=r.nmd(e);(function(e,t){"use strict";function assert(e,t){if(!e)throw new Error(t||"Assertion failed")}function inherits(e,t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}function BN(e,t,r){if(BN.isBN(e)){return e}this.negative=0;this.words=null;this.length=0;this.red=null;if(e!==null){if(t==="le"||t==="be"){r=t;t=10}this._init(e||0,t||10,r||"be")}}if(typeof e==="object"){e.exports=BN}else{t.BN=BN}BN.BN=BN;BN.wordSize=26;var i;try{i=r(4300).Buffer}catch(e){}BN.isBN=function isBN(e){if(e instanceof BN){return true}return e!==null&&typeof e==="object"&&e.constructor.wordSize===BN.wordSize&&Array.isArray(e.words)};BN.max=function max(e,t){if(e.cmp(t)>0)return e;return t};BN.min=function min(e,t){if(e.cmp(t)<0)return e;return t};BN.prototype._init=function init(e,t,r){if(typeof e==="number"){return this._initNumber(e,t,r)}if(typeof e==="object"){return this._initArray(e,t,r)}if(t==="hex"){t=16}assert(t===(t|0)&&t>=2&&t<=36);e=e.toString().replace(/\s+/g,"");var i=0;if(e[0]==="-"){i++}if(t===16){this._parseHex(e,i)}else{this._parseBase(e,t,i)}if(e[0]==="-"){this.negative=1}this._strip();if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initNumber=function _initNumber(e,t,r){if(e<0){this.negative=1;e=-e}if(e<67108864){this.words=[e&67108863];this.length=1}else if(e<4503599627370496){this.words=[e&67108863,e/67108864&67108863];this.length=2}else{assert(e<9007199254740992);this.words=[e&67108863,e/67108864&67108863,1];this.length=3}if(r!=="le")return;this._initArray(this.toArray(),t,r)};BN.prototype._initArray=function _initArray(e,t,r){assert(typeof e.length==="number");if(e.length<=0){this.words=[0];this.length=1;return this}this.length=Math.ceil(e.length/3);this.words=new Array(this.length);for(var i=0;i<this.length;i++){this.words[i]=0}var n,a;var s=0;if(r==="be"){for(i=e.length-1,n=0;i>=0;i-=3){a=e[i]|e[i-1]<<8|e[i-2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}else if(r==="le"){for(i=0,n=0;i<e.length;i+=3){a=e[i]|e[i+1]<<8|e[i+2]<<16;this.words[n]|=a<<s&67108863;this.words[n+1]=a>>>26-s&67108863;s+=24;if(s>=26){s-=26;n++}}}return this._strip()};function parseHex(e,t,r){var i=0;var n=Math.min(e.length,r);var a=0;for(var s=t;s<n;s++){var o=e.charCodeAt(s)-48;i<<=4;var u;if(o>=49&&o<=54){u=o-49+10}else if(o>=17&&o<=22){u=o-17+10}else{u=o}i|=u;a|=u}assert(!(a&240),"Invalid character in "+e);return i}BN.prototype._parseHex=function _parseHex(e,t){this.length=Math.ceil((e.length-t)/6);this.words=new Array(this.length);for(var r=0;r<this.length;r++){this.words[r]=0}var i,n;var a=0;for(r=e.length-6,i=0;r>=t;r-=6){n=parseHex(e,r,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303;a+=24;if(a>=26){a-=26;i++}}if(r+6!==t){n=parseHex(e,t,r+6);this.words[i]|=n<<a&67108863;this.words[i+1]|=n>>>26-a&4194303}this._strip()};function parseBase(e,t,r,i){var n=0;var a=0;var s=Math.min(e.length,r);for(var o=t;o<s;o++){var u=e.charCodeAt(o)-48;n*=i;if(u>=49){a=u-49+10}else if(u>=17){a=u-17+10}else{a=u}assert(u>=0&&a<i,"Invalid character");n+=a}return n}BN.prototype._parseBase=function _parseBase(e,t,r){this.words=[0];this.length=1;for(var i=0,n=1;n<=67108863;n*=t){i++}i--;n=n/t|0;var a=e.length-r;var s=a%i;var o=Math.min(a,a-s)+r;var u=0;for(var h=r;h<o;h+=i){u=parseBase(e,h,h+i,t);this.imuln(n);if(this.words[0]+u<67108864){this.words[0]+=u}else{this._iaddn(u)}}if(s!==0){var d=1;u=parseBase(e,h,e.length,t);for(h=0;h<s;h++){d*=t}this.imuln(d);if(this.words[0]+u<67108864){this.words[0]+=u}else{this._iaddn(u)}}};BN.prototype.copy=function copy(e){e.words=new Array(this.length);for(var t=0;t<this.length;t++){e.words[t]=this.words[t]}e.length=this.length;e.negative=this.negative;e.red=this.red};function move(e,t){e.words=t.words;e.length=t.length;e.negative=t.negative;e.red=t.red}BN.prototype._move=function _move(e){move(e,this)};BN.prototype.clone=function clone(){var e=new BN(null);this.copy(e);return e};BN.prototype._expand=function _expand(e){while(this.length<e){this.words[this.length++]=0}return this};BN.prototype._strip=function strip(){while(this.length>1&&this.words[this.length-1]===0){this.length--}return this._normSign()};BN.prototype._normSign=function _normSign(){if(this.length===1&&this.words[0]===0){this.negative=0}return this};if(typeof Symbol!=="undefined"&&typeof Symbol.for==="function"){BN.prototype[Symbol.for("nodejs.util.inspect.custom")]=inspect}else{BN.prototype.inspect=inspect}function inspect(){return(this.red?"<BN-R: ":"<BN: ")+this.toString(16)+">"}var n=["","0","00","000","0000","00000","000000","0000000","00000000","000000000","0000000000","00000000000","000000000000","0000000000000","00000000000000","000000000000000","0000000000000000","00000000000000000","000000000000000000","0000000000000000000","00000000000000000000","000000000000000000000","0000000000000000000000","00000000000000000000000","000000000000000000000000","0000000000000000000000000"];var a=[0,0,25,16,12,11,10,9,8,8,7,7,7,7,6,6,6,6,6,6,6,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5,5];var s=[0,0,33554432,43046721,16777216,48828125,60466176,40353607,16777216,43046721,1e7,19487171,35831808,62748517,7529536,11390625,16777216,24137569,34012224,47045881,64e6,4084101,5153632,6436343,7962624,9765625,11881376,14348907,17210368,20511149,243e5,28629151,33554432,39135393,45435424,52521875,60466176];BN.prototype.toString=function toString(e,t){e=e||10;t=t|0||1;var r;if(e===16||e==="hex"){r="";var i=0;var o=0;for(var u=0;u<this.length;u++){var h=this.words[u];var d=((h<<i|o)&16777215).toString(16);o=h>>>24-i&16777215;if(o!==0||u!==this.length-1){r=n[6-d.length]+d+r}else{r=d+r}i+=2;if(i>=26){i-=26;u--}}if(o!==0){r=o.toString(16)+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}if(e===(e|0)&&e>=2&&e<=36){var c=a[e];var l=s[e];r="";var p=this.clone();p.negative=0;while(!p.isZero()){var b=p.modrn(l).toString(e);p=p.idivn(l);if(!p.isZero()){r=n[c-b.length]+b+r}else{r=b+r}}if(this.isZero()){r="0"+r}while(r.length%t!==0){r="0"+r}if(this.negative!==0){r="-"+r}return r}assert(false,"Base should be between 2 and 36")};BN.prototype.toNumber=function toNumber(){var e=this.words[0];if(this.length===2){e+=this.words[1]*67108864}else if(this.length===3&&this.words[2]===1){e+=4503599627370496+this.words[1]*67108864}else if(this.length>2){assert(false,"Number can only safely store up to 53 bits")}return this.negative!==0?-e:e};BN.prototype.toJSON=function toJSON(){return this.toString(16,2)};if(i){BN.prototype.toBuffer=function toBuffer(e,t){return this.toArrayLike(i,e,t)}}BN.prototype.toArray=function toArray(e,t){return this.toArrayLike(Array,e,t)};var o=function allocate(e,t){if(e.allocUnsafe){return e.allocUnsafe(t)}return new e(t)};BN.prototype.toArrayLike=function toArrayLike(e,t,r){this._strip();var i=this.byteLength();var n=r||Math.max(1,i);assert(i<=n,"byte array longer than desired length");assert(n>0,"Requested array length <= 0");var a=o(e,n);var s=t==="le"?"LE":"BE";this["_toArrayLike"+s](a,i);return a};BN.prototype._toArrayLikeLE=function _toArrayLikeLE(e,t){var r=0;var i=0;for(var n=0,a=0;n<this.length;n++){var s=this.words[n]<<a|i;e[r++]=s&255;if(r<e.length){e[r++]=s>>8&255}if(r<e.length){e[r++]=s>>16&255}if(a===6){if(r<e.length){e[r++]=s>>24&255}i=0;a=0}else{i=s>>>24;a+=2}}if(r<e.length){e[r++]=i;while(r<e.length){e[r++]=0}}};BN.prototype._toArrayLikeBE=function _toArrayLikeBE(e,t){var r=e.length-1;var i=0;for(var n=0,a=0;n<this.length;n++){var s=this.words[n]<<a|i;e[r--]=s&255;if(r>=0){e[r--]=s>>8&255}if(r>=0){e[r--]=s>>16&255}if(a===6){if(r>=0){e[r--]=s>>24&255}i=0;a=0}else{i=s>>>24;a+=2}}if(r>=0){e[r--]=i;while(r>=0){e[r--]=0}}};if(Math.clz32){BN.prototype._countBits=function _countBits(e){return 32-Math.clz32(e)}}else{BN.prototype._countBits=function _countBits(e){var t=e;var r=0;if(t>=4096){r+=13;t>>>=13}if(t>=64){r+=7;t>>>=7}if(t>=8){r+=4;t>>>=4}if(t>=2){r+=2;t>>>=2}return r+t}}BN.prototype._zeroBits=function _zeroBits(e){if(e===0)return 26;var t=e;var r=0;if((t&8191)===0){r+=13;t>>>=13}if((t&127)===0){r+=7;t>>>=7}if((t&15)===0){r+=4;t>>>=4}if((t&3)===0){r+=2;t>>>=2}if((t&1)===0){r++}return r};BN.prototype.bitLength=function bitLength(){var e=this.words[this.length-1];var t=this._countBits(e);return(this.length-1)*26+t};function toBitArray(e){var t=new Array(e.bitLength());for(var r=0;r<t.length;r++){var i=r/26|0;var n=r%26;t[r]=e.words[i]>>>n&1}return t}BN.prototype.zeroBits=function zeroBits(){if(this.isZero())return 0;var e=0;for(var t=0;t<this.length;t++){var r=this._zeroBits(this.words[t]);e+=r;if(r!==26)break}return e};BN.prototype.byteLength=function byteLength(){return Math.ceil(this.bitLength()/8)};BN.prototype.toTwos=function toTwos(e){if(this.negative!==0){return this.abs().inotn(e).iaddn(1)}return this.clone()};BN.prototype.fromTwos=function fromTwos(e){if(this.testn(e-1)){return this.notn(e).iaddn(1).ineg()}return this.clone()};BN.prototype.isNeg=function isNeg(){return this.negative!==0};BN.prototype.neg=function neg(){return this.clone().ineg()};BN.prototype.ineg=function ineg(){if(!this.isZero()){this.negative^=1}return this};BN.prototype.iuor=function iuor(e){while(this.length<e.length){this.words[this.length++]=0}for(var t=0;t<e.length;t++){this.words[t]=this.words[t]|e.words[t]}return this._strip()};BN.prototype.ior=function ior(e){assert((this.negative|e.negative)===0);return this.iuor(e)};BN.prototype.or=function or(e){if(this.length>e.length)return this.clone().ior(e);return e.clone().ior(this)};BN.prototype.uor=function uor(e){if(this.length>e.length)return this.clone().iuor(e);return e.clone().iuor(this)};BN.prototype.iuand=function iuand(e){var t;if(this.length>e.length){t=e}else{t=this}for(var r=0;r<t.length;r++){this.words[r]=this.words[r]&e.words[r]}this.length=t.length;return this._strip()};BN.prototype.iand=function iand(e){assert((this.negative|e.negative)===0);return this.iuand(e)};BN.prototype.and=function and(e){if(this.length>e.length)return this.clone().iand(e);return e.clone().iand(this)};BN.prototype.uand=function uand(e){if(this.length>e.length)return this.clone().iuand(e);return e.clone().iuand(this)};BN.prototype.iuxor=function iuxor(e){var t;var r;if(this.length>e.length){t=this;r=e}else{t=e;r=this}for(var i=0;i<r.length;i++){this.words[i]=t.words[i]^r.words[i]}if(this!==t){for(;i<t.length;i++){this.words[i]=t.words[i]}}this.length=t.length;return this._strip()};BN.prototype.ixor=function ixor(e){assert((this.negative|e.negative)===0);return this.iuxor(e)};BN.prototype.xor=function xor(e){if(this.length>e.length)return this.clone().ixor(e);return e.clone().ixor(this)};BN.prototype.uxor=function uxor(e){if(this.length>e.length)return this.clone().iuxor(e);return e.clone().iuxor(this)};BN.prototype.inotn=function inotn(e){assert(typeof e==="number"&&e>=0);var t=Math.ceil(e/26)|0;var r=e%26;this._expand(t);if(r>0){t--}for(var i=0;i<t;i++){this.words[i]=~this.words[i]&67108863}if(r>0){this.words[i]=~this.words[i]&67108863>>26-r}return this._strip()};BN.prototype.notn=function notn(e){return this.clone().inotn(e)};BN.prototype.setn=function setn(e,t){assert(typeof e==="number"&&e>=0);var r=e/26|0;var i=e%26;this._expand(r+1);if(t){this.words[r]=this.words[r]|1<<i}else{this.words[r]=this.words[r]&~(1<<i)}return this._strip()};BN.prototype.iadd=function iadd(e){var t;if(this.negative!==0&&e.negative===0){this.negative=0;t=this.isub(e);this.negative^=1;return this._normSign()}else if(this.negative===0&&e.negative!==0){e.negative=0;t=this.isub(e);e.negative=1;return t._normSign()}var r,i;if(this.length>e.length){r=this;i=e}else{r=e;i=this}var n=0;for(var a=0;a<i.length;a++){t=(r.words[a]|0)+(i.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}for(;n!==0&&a<r.length;a++){t=(r.words[a]|0)+n;this.words[a]=t&67108863;n=t>>>26}this.length=r.length;if(n!==0){this.words[this.length]=n;this.length++}else if(r!==this){for(;a<r.length;a++){this.words[a]=r.words[a]}}return this};BN.prototype.add=function add(e){var t;if(e.negative!==0&&this.negative===0){e.negative=0;t=this.sub(e);e.negative^=1;return t}else if(e.negative===0&&this.negative!==0){this.negative=0;t=e.sub(this);this.negative=1;return t}if(this.length>e.length)return this.clone().iadd(e);return e.clone().iadd(this)};BN.prototype.isub=function isub(e){if(e.negative!==0){e.negative=0;var t=this.iadd(e);e.negative=1;return t._normSign()}else if(this.negative!==0){this.negative=0;this.iadd(e);this.negative=1;return this._normSign()}var r=this.cmp(e);if(r===0){this.negative=0;this.length=1;this.words[0]=0;return this}var i,n;if(r>0){i=this;n=e}else{i=e;n=this}var a=0;for(var s=0;s<n.length;s++){t=(i.words[s]|0)-(n.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}for(;a!==0&&s<i.length;s++){t=(i.words[s]|0)+a;a=t>>26;this.words[s]=t&67108863}if(a===0&&s<i.length&&i!==this){for(;s<i.length;s++){this.words[s]=i.words[s]}}this.length=Math.max(this.length,s);if(i!==this){this.negative=1}return this._strip()};BN.prototype.sub=function sub(e){return this.clone().isub(e)};function smallMulTo(e,t,r){r.negative=t.negative^e.negative;var i=e.length+t.length|0;r.length=i;i=i-1|0;var n=e.words[0]|0;var a=t.words[0]|0;var s=n*a;var o=s&67108863;var u=s/67108864|0;r.words[0]=o;for(var h=1;h<i;h++){var d=u>>>26;var c=u&67108863;var l=Math.min(h,t.length-1);for(var p=Math.max(0,h-e.length+1);p<=l;p++){var b=h-p|0;n=e.words[b]|0;a=t.words[p]|0;s=n*a+c;d+=s/67108864|0;c=s&67108863}r.words[h]=c|0;u=d|0}if(u!==0){r.words[h]=u|0}else{r.length--}return r._strip()}var u=function comb10MulTo(e,t,r){var i=e.words;var n=t.words;var a=r.words;var s=0;var o;var u;var h;var d=i[0]|0;var c=d&8191;var l=d>>>13;var p=i[1]|0;var b=p&8191;var v=p>>>13;var m=i[2]|0;var y=m&8191;var g=m>>>13;var _=i[3]|0;var w=_&8191;var M=_>>>13;var E=i[4]|0;var B=E&8191;var k=E>>>13;var A=i[5]|0;var N=A&8191;var P=A>>>13;var x=i[6]|0;var C=x&8191;var T=x>>>13;var I=i[7]|0;var D=I&8191;var O=I>>>13;var j=i[8]|0;var L=j&8191;var q=j>>>13;var H=i[9]|0;var F=H&8191;var U=H>>>13;var z=n[0]|0;var W=z&8191;var V=z>>>13;var G=n[1]|0;var J=G&8191;var Z=G>>>13;var X=n[2]|0;var Y=X&8191;var $=X>>>13;var Q=n[3]|0;var ee=Q&8191;var te=Q>>>13;var re=n[4]|0;var ie=re&8191;var ne=re>>>13;var ae=n[5]|0;var se=ae&8191;var fe=ae>>>13;var oe=n[6]|0;var ue=oe&8191;var he=oe>>>13;var de=n[7]|0;var ce=de&8191;var le=de>>>13;var pe=n[8]|0;var be=pe&8191;var ve=pe>>>13;var me=n[9]|0;var ye=me&8191;var ge=me>>>13;r.negative=e.negative^t.negative;r.length=19;o=Math.imul(c,W);u=Math.imul(c,V);u=u+Math.imul(l,W)|0;h=Math.imul(l,V);var _e=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(_e>>>26)|0;_e&=67108863;o=Math.imul(b,W);u=Math.imul(b,V);u=u+Math.imul(v,W)|0;h=Math.imul(v,V);o=o+Math.imul(c,J)|0;u=u+Math.imul(c,Z)|0;u=u+Math.imul(l,J)|0;h=h+Math.imul(l,Z)|0;var we=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(we>>>26)|0;we&=67108863;o=Math.imul(y,W);u=Math.imul(y,V);u=u+Math.imul(g,W)|0;h=Math.imul(g,V);o=o+Math.imul(b,J)|0;u=u+Math.imul(b,Z)|0;u=u+Math.imul(v,J)|0;h=h+Math.imul(v,Z)|0;o=o+Math.imul(c,Y)|0;u=u+Math.imul(c,$)|0;u=u+Math.imul(l,Y)|0;h=h+Math.imul(l,$)|0;var Me=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Me>>>26)|0;Me&=67108863;o=Math.imul(w,W);u=Math.imul(w,V);u=u+Math.imul(M,W)|0;h=Math.imul(M,V);o=o+Math.imul(y,J)|0;u=u+Math.imul(y,Z)|0;u=u+Math.imul(g,J)|0;h=h+Math.imul(g,Z)|0;o=o+Math.imul(b,Y)|0;u=u+Math.imul(b,$)|0;u=u+Math.imul(v,Y)|0;h=h+Math.imul(v,$)|0;o=o+Math.imul(c,ee)|0;u=u+Math.imul(c,te)|0;u=u+Math.imul(l,ee)|0;h=h+Math.imul(l,te)|0;var Se=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Se>>>26)|0;Se&=67108863;o=Math.imul(B,W);u=Math.imul(B,V);u=u+Math.imul(k,W)|0;h=Math.imul(k,V);o=o+Math.imul(w,J)|0;u=u+Math.imul(w,Z)|0;u=u+Math.imul(M,J)|0;h=h+Math.imul(M,Z)|0;o=o+Math.imul(y,Y)|0;u=u+Math.imul(y,$)|0;u=u+Math.imul(g,Y)|0;h=h+Math.imul(g,$)|0;o=o+Math.imul(b,ee)|0;u=u+Math.imul(b,te)|0;u=u+Math.imul(v,ee)|0;h=h+Math.imul(v,te)|0;o=o+Math.imul(c,ie)|0;u=u+Math.imul(c,ne)|0;u=u+Math.imul(l,ie)|0;h=h+Math.imul(l,ne)|0;var Ee=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Ee>>>26)|0;Ee&=67108863;o=Math.imul(N,W);u=Math.imul(N,V);u=u+Math.imul(P,W)|0;h=Math.imul(P,V);o=o+Math.imul(B,J)|0;u=u+Math.imul(B,Z)|0;u=u+Math.imul(k,J)|0;h=h+Math.imul(k,Z)|0;o=o+Math.imul(w,Y)|0;u=u+Math.imul(w,$)|0;u=u+Math.imul(M,Y)|0;h=h+Math.imul(M,$)|0;o=o+Math.imul(y,ee)|0;u=u+Math.imul(y,te)|0;u=u+Math.imul(g,ee)|0;h=h+Math.imul(g,te)|0;o=o+Math.imul(b,ie)|0;u=u+Math.imul(b,ne)|0;u=u+Math.imul(v,ie)|0;h=h+Math.imul(v,ne)|0;o=o+Math.imul(c,se)|0;u=u+Math.imul(c,fe)|0;u=u+Math.imul(l,se)|0;h=h+Math.imul(l,fe)|0;var Be=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Be>>>26)|0;Be&=67108863;o=Math.imul(C,W);u=Math.imul(C,V);u=u+Math.imul(T,W)|0;h=Math.imul(T,V);o=o+Math.imul(N,J)|0;u=u+Math.imul(N,Z)|0;u=u+Math.imul(P,J)|0;h=h+Math.imul(P,Z)|0;o=o+Math.imul(B,Y)|0;u=u+Math.imul(B,$)|0;u=u+Math.imul(k,Y)|0;h=h+Math.imul(k,$)|0;o=o+Math.imul(w,ee)|0;u=u+Math.imul(w,te)|0;u=u+Math.imul(M,ee)|0;h=h+Math.imul(M,te)|0;o=o+Math.imul(y,ie)|0;u=u+Math.imul(y,ne)|0;u=u+Math.imul(g,ie)|0;h=h+Math.imul(g,ne)|0;o=o+Math.imul(b,se)|0;u=u+Math.imul(b,fe)|0;u=u+Math.imul(v,se)|0;h=h+Math.imul(v,fe)|0;o=o+Math.imul(c,ue)|0;u=u+Math.imul(c,he)|0;u=u+Math.imul(l,ue)|0;h=h+Math.imul(l,he)|0;var Re=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Re>>>26)|0;Re&=67108863;o=Math.imul(D,W);u=Math.imul(D,V);u=u+Math.imul(O,W)|0;h=Math.imul(O,V);o=o+Math.imul(C,J)|0;u=u+Math.imul(C,Z)|0;u=u+Math.imul(T,J)|0;h=h+Math.imul(T,Z)|0;o=o+Math.imul(N,Y)|0;u=u+Math.imul(N,$)|0;u=u+Math.imul(P,Y)|0;h=h+Math.imul(P,$)|0;o=o+Math.imul(B,ee)|0;u=u+Math.imul(B,te)|0;u=u+Math.imul(k,ee)|0;h=h+Math.imul(k,te)|0;o=o+Math.imul(w,ie)|0;u=u+Math.imul(w,ne)|0;u=u+Math.imul(M,ie)|0;h=h+Math.imul(M,ne)|0;o=o+Math.imul(y,se)|0;u=u+Math.imul(y,fe)|0;u=u+Math.imul(g,se)|0;h=h+Math.imul(g,fe)|0;o=o+Math.imul(b,ue)|0;u=u+Math.imul(b,he)|0;u=u+Math.imul(v,ue)|0;h=h+Math.imul(v,he)|0;o=o+Math.imul(c,ce)|0;u=u+Math.imul(c,le)|0;u=u+Math.imul(l,ce)|0;h=h+Math.imul(l,le)|0;var ke=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(ke>>>26)|0;ke&=67108863;o=Math.imul(L,W);u=Math.imul(L,V);u=u+Math.imul(q,W)|0;h=Math.imul(q,V);o=o+Math.imul(D,J)|0;u=u+Math.imul(D,Z)|0;u=u+Math.imul(O,J)|0;h=h+Math.imul(O,Z)|0;o=o+Math.imul(C,Y)|0;u=u+Math.imul(C,$)|0;u=u+Math.imul(T,Y)|0;h=h+Math.imul(T,$)|0;o=o+Math.imul(N,ee)|0;u=u+Math.imul(N,te)|0;u=u+Math.imul(P,ee)|0;h=h+Math.imul(P,te)|0;o=o+Math.imul(B,ie)|0;u=u+Math.imul(B,ne)|0;u=u+Math.imul(k,ie)|0;h=h+Math.imul(k,ne)|0;o=o+Math.imul(w,se)|0;u=u+Math.imul(w,fe)|0;u=u+Math.imul(M,se)|0;h=h+Math.imul(M,fe)|0;o=o+Math.imul(y,ue)|0;u=u+Math.imul(y,he)|0;u=u+Math.imul(g,ue)|0;h=h+Math.imul(g,he)|0;o=o+Math.imul(b,ce)|0;u=u+Math.imul(b,le)|0;u=u+Math.imul(v,ce)|0;h=h+Math.imul(v,le)|0;o=o+Math.imul(c,be)|0;u=u+Math.imul(c,ve)|0;u=u+Math.imul(l,be)|0;h=h+Math.imul(l,ve)|0;var Ae=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Ae>>>26)|0;Ae&=67108863;o=Math.imul(F,W);u=Math.imul(F,V);u=u+Math.imul(U,W)|0;h=Math.imul(U,V);o=o+Math.imul(L,J)|0;u=u+Math.imul(L,Z)|0;u=u+Math.imul(q,J)|0;h=h+Math.imul(q,Z)|0;o=o+Math.imul(D,Y)|0;u=u+Math.imul(D,$)|0;u=u+Math.imul(O,Y)|0;h=h+Math.imul(O,$)|0;o=o+Math.imul(C,ee)|0;u=u+Math.imul(C,te)|0;u=u+Math.imul(T,ee)|0;h=h+Math.imul(T,te)|0;o=o+Math.imul(N,ie)|0;u=u+Math.imul(N,ne)|0;u=u+Math.imul(P,ie)|0;h=h+Math.imul(P,ne)|0;o=o+Math.imul(B,se)|0;u=u+Math.imul(B,fe)|0;u=u+Math.imul(k,se)|0;h=h+Math.imul(k,fe)|0;o=o+Math.imul(w,ue)|0;u=u+Math.imul(w,he)|0;u=u+Math.imul(M,ue)|0;h=h+Math.imul(M,he)|0;o=o+Math.imul(y,ce)|0;u=u+Math.imul(y,le)|0;u=u+Math.imul(g,ce)|0;h=h+Math.imul(g,le)|0;o=o+Math.imul(b,be)|0;u=u+Math.imul(b,ve)|0;u=u+Math.imul(v,be)|0;h=h+Math.imul(v,ve)|0;o=o+Math.imul(c,ye)|0;u=u+Math.imul(c,ge)|0;u=u+Math.imul(l,ye)|0;h=h+Math.imul(l,ge)|0;var Ne=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Ne>>>26)|0;Ne&=67108863;o=Math.imul(F,J);u=Math.imul(F,Z);u=u+Math.imul(U,J)|0;h=Math.imul(U,Z);o=o+Math.imul(L,Y)|0;u=u+Math.imul(L,$)|0;u=u+Math.imul(q,Y)|0;h=h+Math.imul(q,$)|0;o=o+Math.imul(D,ee)|0;u=u+Math.imul(D,te)|0;u=u+Math.imul(O,ee)|0;h=h+Math.imul(O,te)|0;o=o+Math.imul(C,ie)|0;u=u+Math.imul(C,ne)|0;u=u+Math.imul(T,ie)|0;h=h+Math.imul(T,ne)|0;o=o+Math.imul(N,se)|0;u=u+Math.imul(N,fe)|0;u=u+Math.imul(P,se)|0;h=h+Math.imul(P,fe)|0;o=o+Math.imul(B,ue)|0;u=u+Math.imul(B,he)|0;u=u+Math.imul(k,ue)|0;h=h+Math.imul(k,he)|0;o=o+Math.imul(w,ce)|0;u=u+Math.imul(w,le)|0;u=u+Math.imul(M,ce)|0;h=h+Math.imul(M,le)|0;o=o+Math.imul(y,be)|0;u=u+Math.imul(y,ve)|0;u=u+Math.imul(g,be)|0;h=h+Math.imul(g,ve)|0;o=o+Math.imul(b,ye)|0;u=u+Math.imul(b,ge)|0;u=u+Math.imul(v,ye)|0;h=h+Math.imul(v,ge)|0;var Pe=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Pe>>>26)|0;Pe&=67108863;o=Math.imul(F,Y);u=Math.imul(F,$);u=u+Math.imul(U,Y)|0;h=Math.imul(U,$);o=o+Math.imul(L,ee)|0;u=u+Math.imul(L,te)|0;u=u+Math.imul(q,ee)|0;h=h+Math.imul(q,te)|0;o=o+Math.imul(D,ie)|0;u=u+Math.imul(D,ne)|0;u=u+Math.imul(O,ie)|0;h=h+Math.imul(O,ne)|0;o=o+Math.imul(C,se)|0;u=u+Math.imul(C,fe)|0;u=u+Math.imul(T,se)|0;h=h+Math.imul(T,fe)|0;o=o+Math.imul(N,ue)|0;u=u+Math.imul(N,he)|0;u=u+Math.imul(P,ue)|0;h=h+Math.imul(P,he)|0;o=o+Math.imul(B,ce)|0;u=u+Math.imul(B,le)|0;u=u+Math.imul(k,ce)|0;h=h+Math.imul(k,le)|0;o=o+Math.imul(w,be)|0;u=u+Math.imul(w,ve)|0;u=u+Math.imul(M,be)|0;h=h+Math.imul(M,ve)|0;o=o+Math.imul(y,ye)|0;u=u+Math.imul(y,ge)|0;u=u+Math.imul(g,ye)|0;h=h+Math.imul(g,ge)|0;var xe=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(xe>>>26)|0;xe&=67108863;o=Math.imul(F,ee);u=Math.imul(F,te);u=u+Math.imul(U,ee)|0;h=Math.imul(U,te);o=o+Math.imul(L,ie)|0;u=u+Math.imul(L,ne)|0;u=u+Math.imul(q,ie)|0;h=h+Math.imul(q,ne)|0;o=o+Math.imul(D,se)|0;u=u+Math.imul(D,fe)|0;u=u+Math.imul(O,se)|0;h=h+Math.imul(O,fe)|0;o=o+Math.imul(C,ue)|0;u=u+Math.imul(C,he)|0;u=u+Math.imul(T,ue)|0;h=h+Math.imul(T,he)|0;o=o+Math.imul(N,ce)|0;u=u+Math.imul(N,le)|0;u=u+Math.imul(P,ce)|0;h=h+Math.imul(P,le)|0;o=o+Math.imul(B,be)|0;u=u+Math.imul(B,ve)|0;u=u+Math.imul(k,be)|0;h=h+Math.imul(k,ve)|0;o=o+Math.imul(w,ye)|0;u=u+Math.imul(w,ge)|0;u=u+Math.imul(M,ye)|0;h=h+Math.imul(M,ge)|0;var Ce=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Ce>>>26)|0;Ce&=67108863;o=Math.imul(F,ie);u=Math.imul(F,ne);u=u+Math.imul(U,ie)|0;h=Math.imul(U,ne);o=o+Math.imul(L,se)|0;u=u+Math.imul(L,fe)|0;u=u+Math.imul(q,se)|0;h=h+Math.imul(q,fe)|0;o=o+Math.imul(D,ue)|0;u=u+Math.imul(D,he)|0;u=u+Math.imul(O,ue)|0;h=h+Math.imul(O,he)|0;o=o+Math.imul(C,ce)|0;u=u+Math.imul(C,le)|0;u=u+Math.imul(T,ce)|0;h=h+Math.imul(T,le)|0;o=o+Math.imul(N,be)|0;u=u+Math.imul(N,ve)|0;u=u+Math.imul(P,be)|0;h=h+Math.imul(P,ve)|0;o=o+Math.imul(B,ye)|0;u=u+Math.imul(B,ge)|0;u=u+Math.imul(k,ye)|0;h=h+Math.imul(k,ge)|0;var Te=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Te>>>26)|0;Te&=67108863;o=Math.imul(F,se);u=Math.imul(F,fe);u=u+Math.imul(U,se)|0;h=Math.imul(U,fe);o=o+Math.imul(L,ue)|0;u=u+Math.imul(L,he)|0;u=u+Math.imul(q,ue)|0;h=h+Math.imul(q,he)|0;o=o+Math.imul(D,ce)|0;u=u+Math.imul(D,le)|0;u=u+Math.imul(O,ce)|0;h=h+Math.imul(O,le)|0;o=o+Math.imul(C,be)|0;u=u+Math.imul(C,ve)|0;u=u+Math.imul(T,be)|0;h=h+Math.imul(T,ve)|0;o=o+Math.imul(N,ye)|0;u=u+Math.imul(N,ge)|0;u=u+Math.imul(P,ye)|0;h=h+Math.imul(P,ge)|0;var Ie=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Ie>>>26)|0;Ie&=67108863;o=Math.imul(F,ue);u=Math.imul(F,he);u=u+Math.imul(U,ue)|0;h=Math.imul(U,he);o=o+Math.imul(L,ce)|0;u=u+Math.imul(L,le)|0;u=u+Math.imul(q,ce)|0;h=h+Math.imul(q,le)|0;o=o+Math.imul(D,be)|0;u=u+Math.imul(D,ve)|0;u=u+Math.imul(O,be)|0;h=h+Math.imul(O,ve)|0;o=o+Math.imul(C,ye)|0;u=u+Math.imul(C,ge)|0;u=u+Math.imul(T,ye)|0;h=h+Math.imul(T,ge)|0;var De=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(De>>>26)|0;De&=67108863;o=Math.imul(F,ce);u=Math.imul(F,le);u=u+Math.imul(U,ce)|0;h=Math.imul(U,le);o=o+Math.imul(L,be)|0;u=u+Math.imul(L,ve)|0;u=u+Math.imul(q,be)|0;h=h+Math.imul(q,ve)|0;o=o+Math.imul(D,ye)|0;u=u+Math.imul(D,ge)|0;u=u+Math.imul(O,ye)|0;h=h+Math.imul(O,ge)|0;var Oe=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Oe>>>26)|0;Oe&=67108863;o=Math.imul(F,be);u=Math.imul(F,ve);u=u+Math.imul(U,be)|0;h=Math.imul(U,ve);o=o+Math.imul(L,ye)|0;u=u+Math.imul(L,ge)|0;u=u+Math.imul(q,ye)|0;h=h+Math.imul(q,ge)|0;var je=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(je>>>26)|0;je&=67108863;o=Math.imul(F,ye);u=Math.imul(F,ge);u=u+Math.imul(U,ye)|0;h=Math.imul(U,ge);var Le=(s+o|0)+((u&8191)<<13)|0;s=(h+(u>>>13)|0)+(Le>>>26)|0;Le&=67108863;a[0]=_e;a[1]=we;a[2]=Me;a[3]=Se;a[4]=Ee;a[5]=Be;a[6]=Re;a[7]=ke;a[8]=Ae;a[9]=Ne;a[10]=Pe;a[11]=xe;a[12]=Ce;a[13]=Te;a[14]=Ie;a[15]=De;a[16]=Oe;a[17]=je;a[18]=Le;if(s!==0){a[19]=s;r.length++}return r};if(!Math.imul){u=smallMulTo}function bigMulTo(e,t,r){r.negative=t.negative^e.negative;r.length=e.length+t.length;var i=0;var n=0;for(var a=0;a<r.length-1;a++){var s=n;n=0;var o=i&67108863;var u=Math.min(a,t.length-1);for(var h=Math.max(0,a-e.length+1);h<=u;h++){var d=a-h;var c=e.words[d]|0;var l=t.words[h]|0;var p=c*l;var b=p&67108863;s=s+(p/67108864|0)|0;b=b+o|0;o=b&67108863;s=s+(b>>>26)|0;n+=s>>>26;s&=67108863}r.words[a]=o;i=s;s=n}if(i!==0){r.words[a]=i}else{r.length--}return r._strip()}function jumboMulTo(e,t,r){return bigMulTo(e,t,r)}BN.prototype.mulTo=function mulTo(e,t){var r;var i=this.length+e.length;if(this.length===10&&e.length===10){r=u(this,e,t)}else if(i<63){r=smallMulTo(this,e,t)}else if(i<1024){r=bigMulTo(this,e,t)}else{r=jumboMulTo(this,e,t)}return r};function FFTM(e,t){this.x=e;this.y=t}FFTM.prototype.makeRBT=function makeRBT(e){var t=new Array(e);var r=BN.prototype._countBits(e)-1;for(var i=0;i<e;i++){t[i]=this.revBin(i,r,e)}return t};FFTM.prototype.revBin=function revBin(e,t,r){if(e===0||e===r-1)return e;var i=0;for(var n=0;n<t;n++){i|=(e&1)<<t-n-1;e>>=1}return i};FFTM.prototype.permute=function permute(e,t,r,i,n,a){for(var s=0;s<a;s++){i[s]=t[e[s]];n[s]=r[e[s]]}};FFTM.prototype.transform=function transform(e,t,r,i,n,a){this.permute(a,e,t,r,i,n);for(var s=1;s<n;s<<=1){var o=s<<1;var u=Math.cos(2*Math.PI/o);var h=Math.sin(2*Math.PI/o);for(var d=0;d<n;d+=o){var c=u;var l=h;for(var p=0;p<s;p++){var b=r[d+p];var v=i[d+p];var m=r[d+p+s];var y=i[d+p+s];var g=c*m-l*y;y=c*y+l*m;m=g;r[d+p]=b+m;i[d+p]=v+y;r[d+p+s]=b-m;i[d+p+s]=v-y;if(p!==o){g=u*c-h*l;l=u*l+h*c;c=g}}}}};FFTM.prototype.guessLen13b=function guessLen13b(e,t){var r=Math.max(t,e)|1;var i=r&1;var n=0;for(r=r/2|0;r;r=r>>>1){n++}return 1<<n+1+i};FFTM.prototype.conjugate=function conjugate(e,t,r){if(r<=1)return;for(var i=0;i<r/2;i++){var n=e[i];e[i]=e[r-i-1];e[r-i-1]=n;n=t[i];t[i]=-t[r-i-1];t[r-i-1]=-n}};FFTM.prototype.normalize13b=function normalize13b(e,t){var r=0;for(var i=0;i<t/2;i++){var n=Math.round(e[2*i+1]/t)*8192+Math.round(e[2*i]/t)+r;e[i]=n&67108863;if(n<67108864){r=0}else{r=n/67108864|0}}return e};FFTM.prototype.convert13b=function convert13b(e,t,r,i){var n=0;for(var a=0;a<t;a++){n=n+(e[a]|0);r[2*a]=n&8191;n=n>>>13;r[2*a+1]=n&8191;n=n>>>13}for(a=2*t;a<i;++a){r[a]=0}assert(n===0);assert((n&~8191)===0)};FFTM.prototype.stub=function stub(e){var t=new Array(e);for(var r=0;r<e;r++){t[r]=0}return t};FFTM.prototype.mulp=function mulp(e,t,r){var i=2*this.guessLen13b(e.length,t.length);var n=this.makeRBT(i);var a=this.stub(i);var s=new Array(i);var o=new Array(i);var u=new Array(i);var h=new Array(i);var d=new Array(i);var c=new Array(i);var l=r.words;l.length=i;this.convert13b(e.words,e.length,s,i);this.convert13b(t.words,t.length,h,i);this.transform(s,a,o,u,i,n);this.transform(h,a,d,c,i,n);for(var p=0;p<i;p++){var b=o[p]*d[p]-u[p]*c[p];u[p]=o[p]*c[p]+u[p]*d[p];o[p]=b}this.conjugate(o,u,i);this.transform(o,u,l,a,i,n);this.conjugate(l,a,i);this.normalize13b(l,i);r.negative=e.negative^t.negative;r.length=e.length+t.length;return r._strip()};BN.prototype.mul=function mul(e){var t=new BN(null);t.words=new Array(this.length+e.length);return this.mulTo(e,t)};BN.prototype.mulf=function mulf(e){var t=new BN(null);t.words=new Array(this.length+e.length);return jumboMulTo(this,e,t)};BN.prototype.imul=function imul(e){return this.clone().mulTo(e,this)};BN.prototype.imuln=function imuln(e){var t=e<0;if(t)e=-e;assert(typeof e==="number");assert(e<67108864);var r=0;for(var i=0;i<this.length;i++){var n=(this.words[i]|0)*e;var a=(n&67108863)+(r&67108863);r>>=26;r+=n/67108864|0;r+=a>>>26;this.words[i]=a&67108863}if(r!==0){this.words[i]=r;this.length++}return t?this.ineg():this};BN.prototype.muln=function muln(e){return this.clone().imuln(e)};BN.prototype.sqr=function sqr(){return this.mul(this)};BN.prototype.isqr=function isqr(){return this.imul(this.clone())};BN.prototype.pow=function pow(e){var t=toBitArray(e);if(t.length===0)return new BN(1);var r=this;for(var i=0;i<t.length;i++,r=r.sqr()){if(t[i]!==0)break}if(++i<t.length){for(var n=r.sqr();i<t.length;i++,n=n.sqr()){if(t[i]===0)continue;r=r.mul(n)}}return r};BN.prototype.iushln=function iushln(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=67108863>>>26-t<<26-t;var n;if(t!==0){var a=0;for(n=0;n<this.length;n++){var s=this.words[n]&i;var o=(this.words[n]|0)-s<<t;this.words[n]=o|a;a=s>>>26-t}if(a){this.words[n]=a;this.length++}}if(r!==0){for(n=this.length-1;n>=0;n--){this.words[n+r]=this.words[n]}for(n=0;n<r;n++){this.words[n]=0}this.length+=r}return this._strip()};BN.prototype.ishln=function ishln(e){assert(this.negative===0);return this.iushln(e)};BN.prototype.iushrn=function iushrn(e,t,r){assert(typeof e==="number"&&e>=0);var i;if(t){i=(t-t%26)/26}else{i=0}var n=e%26;var a=Math.min((e-n)/26,this.length);var s=67108863^67108863>>>n<<n;var o=r;i-=a;i=Math.max(0,i);if(o){for(var u=0;u<a;u++){o.words[u]=this.words[u]}o.length=a}if(a===0){}else if(this.length>a){this.length-=a;for(u=0;u<this.length;u++){this.words[u]=this.words[u+a]}}else{this.words[0]=0;this.length=1}var h=0;for(u=this.length-1;u>=0&&(h!==0||u>=i);u--){var d=this.words[u]|0;this.words[u]=h<<26-n|d>>>n;h=d&s}if(o&&h!==0){o.words[o.length++]=h}if(this.length===0){this.words[0]=0;this.length=1}return this._strip()};BN.prototype.ishrn=function ishrn(e,t,r){assert(this.negative===0);return this.iushrn(e,t,r)};BN.prototype.shln=function shln(e){return this.clone().ishln(e)};BN.prototype.ushln=function ushln(e){return this.clone().iushln(e)};BN.prototype.shrn=function shrn(e){return this.clone().ishrn(e)};BN.prototype.ushrn=function ushrn(e){return this.clone().iushrn(e)};BN.prototype.testn=function testn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r)return false;var n=this.words[r];return!!(n&i)};BN.prototype.imaskn=function imaskn(e){assert(typeof e==="number"&&e>=0);var t=e%26;var r=(e-t)/26;assert(this.negative===0,"imaskn works only with positive numbers");if(this.length<=r){return this}if(t!==0){r++}this.length=Math.min(r,this.length);if(t!==0){var i=67108863^67108863>>>t<<t;this.words[this.length-1]&=i}return this._strip()};BN.prototype.maskn=function maskn(e){return this.clone().imaskn(e)};BN.prototype.iaddn=function iaddn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.isubn(-e);if(this.negative!==0){if(this.length===1&&(this.words[0]|0)<=e){this.words[0]=e-(this.words[0]|0);this.negative=0;return this}this.negative=0;this.isubn(e);this.negative=1;return this}return this._iaddn(e)};BN.prototype._iaddn=function _iaddn(e){this.words[0]+=e;for(var t=0;t<this.length&&this.words[t]>=67108864;t++){this.words[t]-=67108864;if(t===this.length-1){this.words[t+1]=1}else{this.words[t+1]++}}this.length=Math.max(this.length,t+1);return this};BN.prototype.isubn=function isubn(e){assert(typeof e==="number");assert(e<67108864);if(e<0)return this.iaddn(-e);if(this.negative!==0){this.negative=0;this.iaddn(e);this.negative=1;return this}this.words[0]-=e;if(this.length===1&&this.words[0]<0){this.words[0]=-this.words[0];this.negative=1}else{for(var t=0;t<this.length&&this.words[t]<0;t++){this.words[t]+=67108864;this.words[t+1]-=1}}return this._strip()};BN.prototype.addn=function addn(e){return this.clone().iaddn(e)};BN.prototype.subn=function subn(e){return this.clone().isubn(e)};BN.prototype.iabs=function iabs(){this.negative=0;return this};BN.prototype.abs=function abs(){return this.clone().iabs()};BN.prototype._ishlnsubmul=function _ishlnsubmul(e,t,r){var i=e.length+r;var n;this._expand(i);var a;var s=0;for(n=0;n<e.length;n++){a=(this.words[n+r]|0)+s;var o=(e.words[n]|0)*t;a-=o&67108863;s=(a>>26)-(o/67108864|0);this.words[n+r]=a&67108863}for(;n<this.length-r;n++){a=(this.words[n+r]|0)+s;s=a>>26;this.words[n+r]=a&67108863}if(s===0)return this._strip();assert(s===-1);s=0;for(n=0;n<this.length;n++){a=-(this.words[n]|0)+s;s=a>>26;this.words[n]=a&67108863}this.negative=1;return this._strip()};BN.prototype._wordDiv=function _wordDiv(e,t){var r=this.length-e.length;var i=this.clone();var n=e;var a=n.words[n.length-1]|0;var s=this._countBits(a);r=26-s;if(r!==0){n=n.ushln(r);i.iushln(r);a=n.words[n.length-1]|0}var o=i.length-n.length;var u;if(t!=="mod"){u=new BN(null);u.length=o+1;u.words=new Array(u.length);for(var h=0;h<u.length;h++){u.words[h]=0}}var d=i.clone()._ishlnsubmul(n,1,o);if(d.negative===0){i=d;if(u){u.words[o]=1}}for(var c=o-1;c>=0;c--){var l=(i.words[n.length+c]|0)*67108864+(i.words[n.length+c-1]|0);l=Math.min(l/a|0,67108863);i._ishlnsubmul(n,l,c);while(i.negative!==0){l--;i.negative=0;i._ishlnsubmul(n,1,c);if(!i.isZero()){i.negative^=1}}if(u){u.words[c]=l}}if(u){u._strip()}i._strip();if(t!=="div"&&r!==0){i.iushrn(r)}return{div:u||null,mod:i}};BN.prototype.divmod=function divmod(e,t,r){assert(!e.isZero());if(this.isZero()){return{div:new BN(0),mod:new BN(0)}}var i,n,a;if(this.negative!==0&&e.negative===0){a=this.neg().divmod(e,t);if(t!=="mod"){i=a.div.neg()}if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.iadd(e)}}return{div:i,mod:n}}if(this.negative===0&&e.negative!==0){a=this.divmod(e.neg(),t);if(t!=="mod"){i=a.div.neg()}return{div:i,mod:a.mod}}if((this.negative&e.negative)!==0){a=this.neg().divmod(e.neg(),t);if(t!=="div"){n=a.mod.neg();if(r&&n.negative!==0){n.isub(e)}}return{div:a.div,mod:n}}if(e.length>this.length||this.cmp(e)<0){return{div:new BN(0),mod:this}}if(e.length===1){if(t==="div"){return{div:this.divn(e.words[0]),mod:null}}if(t==="mod"){return{div:null,mod:new BN(this.modrn(e.words[0]))}}return{div:this.divn(e.words[0]),mod:new BN(this.modrn(e.words[0]))}}return this._wordDiv(e,t)};BN.prototype.div=function div(e){return this.divmod(e,"div",false).div};BN.prototype.mod=function mod(e){return this.divmod(e,"mod",false).mod};BN.prototype.umod=function umod(e){return this.divmod(e,"mod",true).mod};BN.prototype.divRound=function divRound(e){var t=this.divmod(e);if(t.mod.isZero())return t.div;var r=t.div.negative!==0?t.mod.isub(e):t.mod;var i=e.ushrn(1);var n=e.andln(1);var a=r.cmp(i);if(a<0||n===1&&a===0)return t.div;return t.div.negative!==0?t.div.isubn(1):t.div.iaddn(1)};BN.prototype.modrn=function modrn(e){var t=e<0;if(t)e=-e;assert(e<=67108863);var r=(1<<26)%e;var i=0;for(var n=this.length-1;n>=0;n--){i=(r*i+(this.words[n]|0))%e}return t?-i:i};BN.prototype.modn=function modn(e){return this.modrn(e)};BN.prototype.idivn=function idivn(e){var t=e<0;if(t)e=-e;assert(e<=67108863);var r=0;for(var i=this.length-1;i>=0;i--){var n=(this.words[i]|0)+r*67108864;this.words[i]=n/e|0;r=n%e}this._strip();return t?this.ineg():this};BN.prototype.divn=function divn(e){return this.clone().idivn(e)};BN.prototype.egcd=function egcd(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=new BN(0);var s=new BN(1);var o=0;while(t.isEven()&&r.isEven()){t.iushrn(1);r.iushrn(1);++o}var u=r.clone();var h=t.clone();while(!t.isZero()){for(var d=0,c=1;(t.words[0]&c)===0&&d<26;++d,c<<=1);if(d>0){t.iushrn(d);while(d-- >0){if(i.isOdd()||n.isOdd()){i.iadd(u);n.isub(h)}i.iushrn(1);n.iushrn(1)}}for(var l=0,p=1;(r.words[0]&p)===0&&l<26;++l,p<<=1);if(l>0){r.iushrn(l);while(l-- >0){if(a.isOdd()||s.isOdd()){a.iadd(u);s.isub(h)}a.iushrn(1);s.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(a);n.isub(s)}else{r.isub(t);a.isub(i);s.isub(n)}}return{a:a,b:s,gcd:r.iushln(o)}};BN.prototype._invmp=function _invmp(e){assert(e.negative===0);assert(!e.isZero());var t=this;var r=e.clone();if(t.negative!==0){t=t.umod(e)}else{t=t.clone()}var i=new BN(1);var n=new BN(0);var a=r.clone();while(t.cmpn(1)>0&&r.cmpn(1)>0){for(var s=0,o=1;(t.words[0]&o)===0&&s<26;++s,o<<=1);if(s>0){t.iushrn(s);while(s-- >0){if(i.isOdd()){i.iadd(a)}i.iushrn(1)}}for(var u=0,h=1;(r.words[0]&h)===0&&u<26;++u,h<<=1);if(u>0){r.iushrn(u);while(u-- >0){if(n.isOdd()){n.iadd(a)}n.iushrn(1)}}if(t.cmp(r)>=0){t.isub(r);i.isub(n)}else{r.isub(t);n.isub(i)}}var d;if(t.cmpn(1)===0){d=i}else{d=n}if(d.cmpn(0)<0){d.iadd(e)}return d};BN.prototype.gcd=function gcd(e){if(this.isZero())return e.abs();if(e.isZero())return this.abs();var t=this.clone();var r=e.clone();t.negative=0;r.negative=0;for(var i=0;t.isEven()&&r.isEven();i++){t.iushrn(1);r.iushrn(1)}do{while(t.isEven()){t.iushrn(1)}while(r.isEven()){r.iushrn(1)}var n=t.cmp(r);if(n<0){var a=t;t=r;r=a}else if(n===0||r.cmpn(1)===0){break}t.isub(r)}while(true);return r.iushln(i)};BN.prototype.invm=function invm(e){return this.egcd(e).a.umod(e)};BN.prototype.isEven=function isEven(){return(this.words[0]&1)===0};BN.prototype.isOdd=function isOdd(){return(this.words[0]&1)===1};BN.prototype.andln=function andln(e){return this.words[0]&e};BN.prototype.bincn=function bincn(e){assert(typeof e==="number");var t=e%26;var r=(e-t)/26;var i=1<<t;if(this.length<=r){this._expand(r+1);this.words[r]|=i;return this}var n=i;for(var a=r;n!==0&&a<this.length;a++){var s=this.words[a]|0;s+=n;n=s>>>26;s&=67108863;this.words[a]=s}if(n!==0){this.words[a]=n;this.length++}return this};BN.prototype.isZero=function isZero(){return this.length===1&&this.words[0]===0};BN.prototype.cmpn=function cmpn(e){var t=e<0;if(this.negative!==0&&!t)return-1;if(this.negative===0&&t)return 1;this._strip();var r;if(this.length>1){r=1}else{if(t){e=-e}assert(e<=67108863,"Number is too big");var i=this.words[0]|0;r=i===e?0:i<e?-1:1}if(this.negative!==0)return-r|0;return r};BN.prototype.cmp=function cmp(e){if(this.negative!==0&&e.negative===0)return-1;if(this.negative===0&&e.negative!==0)return 1;var t=this.ucmp(e);if(this.negative!==0)return-t|0;return t};BN.prototype.ucmp=function ucmp(e){if(this.length>e.length)return 1;if(this.length<e.length)return-1;var t=0;for(var r=this.length-1;r>=0;r--){var i=this.words[r]|0;var n=e.words[r]|0;if(i===n)continue;if(i<n){t=-1}else if(i>n){t=1}break}return t};BN.prototype.gtn=function gtn(e){return this.cmpn(e)===1};BN.prototype.gt=function gt(e){return this.cmp(e)===1};BN.prototype.gten=function gten(e){return this.cmpn(e)>=0};BN.prototype.gte=function gte(e){return this.cmp(e)>=0};BN.prototype.ltn=function ltn(e){return this.cmpn(e)===-1};BN.prototype.lt=function lt(e){return this.cmp(e)===-1};BN.prototype.lten=function lten(e){return this.cmpn(e)<=0};BN.prototype.lte=function lte(e){return this.cmp(e)<=0};BN.prototype.eqn=function eqn(e){return this.cmpn(e)===0};BN.prototype.eq=function eq(e){return this.cmp(e)===0};BN.red=function red(e){return new Red(e)};BN.prototype.toRed=function toRed(e){assert(!this.red,"Already a number in reduction context");assert(this.negative===0,"red works only with positives");return e.convertTo(this)._forceRed(e)};BN.prototype.fromRed=function fromRed(){assert(this.red,"fromRed works only with numbers in reduction context");return this.red.convertFrom(this)};BN.prototype._forceRed=function _forceRed(e){this.red=e;return this};BN.prototype.forceRed=function forceRed(e){assert(!this.red,"Already a number in reduction context");return this._forceRed(e)};BN.prototype.redAdd=function redAdd(e){assert(this.red,"redAdd works only with red numbers");return this.red.add(this,e)};BN.prototype.redIAdd=function redIAdd(e){assert(this.red,"redIAdd works only with red numbers");return this.red.iadd(this,e)};BN.prototype.redSub=function redSub(e){assert(this.red,"redSub works only with red numbers");return this.red.sub(this,e)};BN.prototype.redISub=function redISub(e){assert(this.red,"redISub works only with red numbers");return this.red.isub(this,e)};BN.prototype.redShl=function redShl(e){assert(this.red,"redShl works only with red numbers");return this.red.shl(this,e)};BN.prototype.redMul=function redMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.mul(this,e)};BN.prototype.redIMul=function redIMul(e){assert(this.red,"redMul works only with red numbers");this.red._verify2(this,e);return this.red.imul(this,e)};BN.prototype.redSqr=function redSqr(){assert(this.red,"redSqr works only with red numbers");this.red._verify1(this);return this.red.sqr(this)};BN.prototype.redISqr=function redISqr(){assert(this.red,"redISqr works only with red numbers");this.red._verify1(this);return this.red.isqr(this)};BN.prototype.redSqrt=function redSqrt(){assert(this.red,"redSqrt works only with red numbers");this.red._verify1(this);return this.red.sqrt(this)};BN.prototype.redInvm=function redInvm(){assert(this.red,"redInvm works only with red numbers");this.red._verify1(this);return this.red.invm(this)};BN.prototype.redNeg=function redNeg(){assert(this.red,"redNeg works only with red numbers");this.red._verify1(this);return this.red.neg(this)};BN.prototype.redPow=function redPow(e){assert(this.red&&!e.red,"redPow(normalNum)");this.red._verify1(this);return this.red.pow(this,e)};var h={k256:null,p224:null,p192:null,p25519:null};function MPrime(e,t){this.name=e;this.p=new BN(t,16);this.n=this.p.bitLength();this.k=new BN(1).iushln(this.n).isub(this.p);this.tmp=this._tmp()}MPrime.prototype._tmp=function _tmp(){var e=new BN(null);e.words=new Array(Math.ceil(this.n/13));return e};MPrime.prototype.ireduce=function ireduce(e){var t=e;var r;do{this.split(t,this.tmp);t=this.imulK(t);t=t.iadd(this.tmp);r=t.bitLength()}while(r>this.n);var i=r<this.n?-1:t.ucmp(this.p);if(i===0){t.words[0]=0;t.length=1}else if(i>0){t.isub(this.p)}else{if(t.strip!==undefined){t.strip()}else{t._strip()}}return t};MPrime.prototype.split=function split(e,t){e.iushrn(this.n,0,t)};MPrime.prototype.imulK=function imulK(e){return e.imul(this.k)};function K256(){MPrime.call(this,"k256","ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f")}inherits(K256,MPrime);K256.prototype.split=function split(e,t){var r=4194303;var i=Math.min(e.length,9);for(var n=0;n<i;n++){t.words[n]=e.words[n]}t.length=i;if(e.length<=9){e.words[0]=0;e.length=1;return}var a=e.words[9];t.words[t.length++]=a&r;for(n=10;n<e.length;n++){var s=e.words[n]|0;e.words[n-10]=(s&r)<<4|a>>>22;a=s}a>>>=22;e.words[n-10]=a;if(a===0&&e.length>10){e.length-=10}else{e.length-=9}};K256.prototype.imulK=function imulK(e){e.words[e.length]=0;e.words[e.length+1]=0;e.length+=2;var t=0;for(var r=0;r<e.length;r++){var i=e.words[r]|0;t+=i*977;e.words[r]=t&67108863;t=i*64+(t/67108864|0)}if(e.words[e.length-1]===0){e.length--;if(e.words[e.length-1]===0){e.length--}}return e};function P224(){MPrime.call(this,"p224","ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001")}inherits(P224,MPrime);function P192(){MPrime.call(this,"p192","ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff")}inherits(P192,MPrime);function P25519(){MPrime.call(this,"25519","7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed")}inherits(P25519,MPrime);P25519.prototype.imulK=function imulK(e){var t=0;for(var r=0;r<e.length;r++){var i=(e.words[r]|0)*19+t;var n=i&67108863;i>>>=26;e.words[r]=n;t=i}if(t!==0){e.words[e.length++]=t}return e};BN._prime=function prime(e){if(h[e])return h[e];var prime;if(e==="k256"){prime=new K256}else if(e==="p224"){prime=new P224}else if(e==="p192"){prime=new P192}else if(e==="p25519"){prime=new P25519}else{throw new Error("Unknown prime "+e)}h[e]=prime;return prime};function Red(e){if(typeof e==="string"){var t=BN._prime(e);this.m=t.p;this.prime=t}else{assert(e.gtn(1),"modulus must be greater than 1");this.m=e;this.prime=null}}Red.prototype._verify1=function _verify1(e){assert(e.negative===0,"red works only with positives");assert(e.red,"red works only with red numbers")};Red.prototype._verify2=function _verify2(e,t){assert((e.negative|t.negative)===0,"red works only with positives");assert(e.red&&e.red===t.red,"red works only with red numbers")};Red.prototype.imod=function imod(e){if(this.prime)return this.prime.ireduce(e)._forceRed(this);move(e,e.umod(this.m)._forceRed(this));return e};Red.prototype.neg=function neg(e){if(e.isZero()){return e.clone()}return this.m.sub(e)._forceRed(this)};Red.prototype.add=function add(e,t){this._verify2(e,t);var r=e.add(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r._forceRed(this)};Red.prototype.iadd=function iadd(e,t){this._verify2(e,t);var r=e.iadd(t);if(r.cmp(this.m)>=0){r.isub(this.m)}return r};Red.prototype.sub=function sub(e,t){this._verify2(e,t);var r=e.sub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r._forceRed(this)};Red.prototype.isub=function isub(e,t){this._verify2(e,t);var r=e.isub(t);if(r.cmpn(0)<0){r.iadd(this.m)}return r};Red.prototype.shl=function shl(e,t){this._verify1(e);return this.imod(e.ushln(t))};Red.prototype.imul=function imul(e,t){this._verify2(e,t);return this.imod(e.imul(t))};Red.prototype.mul=function mul(e,t){this._verify2(e,t);return this.imod(e.mul(t))};Red.prototype.isqr=function isqr(e){return this.imul(e,e.clone())};Red.prototype.sqr=function sqr(e){return this.mul(e,e)};Red.prototype.sqrt=function sqrt(e){if(e.isZero())return e.clone();var t=this.m.andln(3);assert(t%2===1);if(t===3){var r=this.m.add(new BN(1)).iushrn(2);return this.pow(e,r)}var i=this.m.subn(1);var n=0;while(!i.isZero()&&i.andln(1)===0){n++;i.iushrn(1)}assert(!i.isZero());var a=new BN(1).toRed(this);var s=a.redNeg();var o=this.m.subn(1).iushrn(1);var u=this.m.bitLength();u=new BN(2*u*u).toRed(this);while(this.pow(u,o).cmp(s)!==0){u.redIAdd(s)}var h=this.pow(u,i);var d=this.pow(e,i.addn(1).iushrn(1));var c=this.pow(e,i);var l=n;while(c.cmp(a)!==0){var p=c;for(var b=0;p.cmp(a)!==0;b++){p=p.redSqr()}assert(b<l);var v=this.pow(h,new BN(1).iushln(l-b-1));d=d.redMul(v);h=v.redSqr();c=c.redMul(h);l=b}return d};Red.prototype.invm=function invm(e){var t=e._invmp(this.m);if(t.negative!==0){t.negative=0;return this.imod(t).redNeg()}else{return this.imod(t)}};Red.prototype.pow=function pow(e,t){if(t.isZero())return new BN(1).toRed(this);if(t.cmpn(1)===0)return e.clone();var r=4;var i=new Array(1<<r);i[0]=new BN(1).toRed(this);i[1]=e;for(var n=2;n<i.length;n++){i[n]=this.mul(i[n-1],e)}var a=i[0];var s=0;var o=0;var u=t.bitLength()%26;if(u===0){u=26}for(n=t.length-1;n>=0;n--){var h=t.words[n];for(var d=u-1;d>=0;d--){var c=h>>d&1;if(a!==i[0]){a=this.sqr(a)}if(c===0&&s===0){o=0;continue}s<<=1;s|=c;o++;if(o!==r&&(n!==0||d!==0))continue;a=this.mul(a,i[s]);o=0;s=0}u=26}return a};Red.prototype.convertTo=function convertTo(e){var t=e.umod(this.m);return t===e?t.clone():t};Red.prototype.convertFrom=function convertFrom(e){var t=e.clone();t.red=null;return t};BN.mont=function mont(e){return new Mont(e)};function Mont(e){Red.call(this,e);this.shift=this.m.bitLength();if(this.shift%26!==0){this.shift+=26-this.shift%26}this.r=new BN(1).iushln(this.shift);this.r2=this.imod(this.r.sqr());this.rinv=this.r._invmp(this.m);this.minv=this.rinv.mul(this.r).isubn(1).div(this.m);this.minv=this.minv.umod(this.r);this.minv=this.r.sub(this.minv)}inherits(Mont,Red);Mont.prototype.convertTo=function convertTo(e){return this.imod(e.ushln(this.shift))};Mont.prototype.convertFrom=function convertFrom(e){var t=this.imod(e.mul(this.rinv));t.red=null;return t};Mont.prototype.imul=function imul(e,t){if(e.isZero()||t.isZero()){e.words[0]=0;e.length=1;return e}var r=e.imul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.mul=function mul(e,t){if(e.isZero()||t.isZero())return new BN(0)._forceRed(this);var r=e.mul(t);var i=r.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);var n=r.isub(i).iushrn(this.shift);var a=n;if(n.cmp(this.m)>=0){a=n.isub(this.m)}else if(n.cmpn(0)<0){a=n.iadd(this.m)}return a._forceRed(this)};Mont.prototype.invm=function invm(e){var t=this.imod(e._invmp(this.m).mul(this.r2));return t._forceRed(this)}})( false||e,this)},42:function(e){"use strict";const t={};function createErrorType(e,r,i){if(!i){i=Error}function getMessage(e,t,i){if(typeof r==="string"){return r}else{return r(e,t,i)}}class NodeError extends i{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=i.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let i;if(typeof t==="string"&&startsWith(t,"not ")){i="must not be";t=t.replace(/^not /,"")}else{i="must be"}let n;if(endsWith(e," argument")){n=`The ${e} ${i} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";n=`The "${e}" ${r} ${i} ${oneOf(t,"type")}`}n+=`. Received type ${typeof r}`;return n}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},6744:function(e,t,r){"use strict";var i=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var n=r(8318);var a=r(3877);r(7526)(Duplex,n);{var s=i(a.prototype);for(var o=0;o<s.length;o++){var u=s[o];if(!Duplex.prototype[u])Duplex.prototype[u]=a.prototype[u]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);n.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},6609:function(e,t,r){"use strict";e.exports=PassThrough;var i=r(9482);r(7526)(PassThrough,i);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);i.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},8318:function(e,t,r){"use strict";e.exports=Readable;var i;Readable.ReadableState=ReadableState;var n=r(2361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var s=r(1727);var o=r(4300).Buffer;var u=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof u}var h=r(3837);var d;if(h&&h.debuglog){d=h.debuglog("stream")}else{d=function debug(){}}var c=r(8469);var l=r(9666);var p=r(894),b=p.getHighWaterMark;var v=r(42).q,m=v.ERR_INVALID_ARG_TYPE,y=v.ERR_STREAM_PUSH_AFTER_EOF,g=v.ERR_METHOD_NOT_IMPLEMENTED,_=v.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var w;var M;var E;r(7526)(Readable,s);var B=l.errorOrDestroy;var k=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,n){i=i||r(6744);e=e||{};if(typeof n!=="boolean")n=t instanceof i;this.objectMode=!!e.objectMode;if(n)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=b(this,e,"readableHighWaterMark",n);this.buffer=new c;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!w)w=r(5673).s;this.decoder=new w(e.encoding);this.encoding=e.encoding}}function Readable(e){i=i||r(6744);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof i;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}s.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=l.destroy;Readable.prototype._undestroy=l.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var i;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=o.from(e,t);t=""}i=true}}else{i=true}return readableAddChunk(this,e,t,false,i)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,i,n){d("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var s;if(!n)s=chunkInvalid(a,t);if(s){B(e,s)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==o.prototype){t=_uint8ArrayToBuffer(t)}if(i){if(a.endEmitted)B(e,new _);else addChunk(e,a,t,true)}else if(a.ended){B(e,new y)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!i){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,i){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(i)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new m("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!w)w=r(5673).s;var t=new w(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var i=this._readableState.buffer.head;var n="";while(i!==null){n+=t.write(i.data);i=i.next}this._readableState.buffer.clear();if(n!=="")this._readableState.buffer.push(n);this._readableState.length=n.length;return this};var A=1073741824;function computeNewHighWaterMark(e){if(e>=A){e=A}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){d("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){d("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var i=t.needReadable;d("need readable",i);if(t.length===0||t.length-e<t.highWaterMark){i=true;d("length less than watermark",i)}if(t.ended||t.reading){i=false;d("reading or ended",i)}else if(i){d("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var n;if(e>0)n=fromList(e,t);else n=null;if(n===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(n!==null)this.emit("data",n);return n};function onEofChunk(e,t){d("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;d("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){d("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;d("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;d("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){B(this,new g("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var i=this._readableState;switch(i.pipesCount){case 0:i.pipes=e;break;case 1:i.pipes=[i.pipes,e];break;default:i.pipes.push(e);break}i.pipesCount+=1;d("pipe count=%d opts=%j",i.pipesCount,t);var n=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var s=n?onend:unpipe;if(i.endEmitted)process.nextTick(s);else r.once("end",s);e.on("unpipe",onunpipe);function onunpipe(e,t){d("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){d("onend");e.end()}var o=pipeOnDrain(r);e.on("drain",o);var u=false;function cleanup(){d("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",o);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);u=true;if(i.awaitDrain&&(!e._writableState||e._writableState.needDrain))o()}r.on("data",ondata);function ondata(t){d("ondata");var n=e.write(t);d("dest.write",n);if(n===false){if((i.pipesCount===1&&i.pipes===e||i.pipesCount>1&&indexOf(i.pipes,e)!==-1)&&!u){d("false write response, pause",i.awaitDrain);i.awaitDrain++}r.pause()}}function onerror(t){d("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)B(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){d("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){d("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!i.flowing){d("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;d("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var i=t.pipes;var n=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<n;a++){i[a].emit("unpipe",this,{hasUnpiped:false})}return this}var s=indexOf(t.pipes,e);if(s===-1)return this;t.pipes.splice(s,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=s.prototype.on.call(this,e,t);var i=this._readableState;if(e==="data"){i.readableListening=this.listenerCount("readable")>0;if(i.flowing!==false)this.resume()}else if(e==="readable"){if(!i.endEmitted&&!i.readableListening){i.readableListening=i.needReadable=true;i.flowing=false;i.emittedReadable=false;d("on readable",i.length,i.reading);if(i.length){emitReadable(this)}else if(!i.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=s.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=s.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){d("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){d("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){d("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){d("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){d("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;d("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var i=false;e.on("end",(function(){d("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(n){d("wrapped data");if(r.decoder)n=r.decoder.write(n);if(r.objectMode&&(n===null||n===undefined))return;else if(!r.objectMode&&(!n||!n.length))return;var a=t.push(n);if(!a){i=true;e.pause()}}));for(var n in e){if(this[n]===undefined&&typeof e[n]==="function"){this[n]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(n)}}for(var a=0;a<k.length;a++){e.on(k[a],this.emit.bind(this,k[a]))}this._read=function(t){d("wrapped _read",t);if(i){i=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(M===undefined){M=r(509)}return M(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;d("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){d("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(E===undefined){E=r(6171)}return E(Readable,e,t)}}function indexOf(e,t){for(var r=0,i=e.length;r<i;r++){if(e[r]===t)return r}return-1}},9482:function(e,t,r){"use strict";e.exports=Transform;var i=r(42).q,n=i.ERR_METHOD_NOT_IMPLEMENTED,a=i.ERR_MULTIPLE_CALLBACK,s=i.ERR_TRANSFORM_ALREADY_TRANSFORMING,o=i.ERR_TRANSFORM_WITH_LENGTH_0;var u=r(6744);r(7526)(Transform,u);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var i=r.writecb;if(i===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);i(e);var n=this._readableState;n.reading=false;if(n.needReadable||n.length<n.highWaterMark){this._read(n.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);u.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return u.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new n("_transform()"))};Transform.prototype._write=function(e,t,r){var i=this._transformState;i.writecb=r;i.writechunk=e;i.writeencoding=t;if(!i.transforming){var n=this._readableState;if(i.needTransform||n.needReadable||n.length<n.highWaterMark)this._read(n.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){u.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new o;if(e._transformState.transforming)throw new s;return e.push(null)}},3877:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var i;Writable.WritableState=WritableState;var n={deprecate:r(5121)};var a=r(1727);var s=r(4300).Buffer;var o=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof o}var u=r(9666);var h=r(894),d=h.getHighWaterMark;var c=r(42).q,l=c.ERR_INVALID_ARG_TYPE,p=c.ERR_METHOD_NOT_IMPLEMENTED,b=c.ERR_MULTIPLE_CALLBACK,v=c.ERR_STREAM_CANNOT_PIPE,m=c.ERR_STREAM_DESTROYED,y=c.ERR_STREAM_NULL_VALUES,g=c.ERR_STREAM_WRITE_AFTER_END,_=c.ERR_UNKNOWN_ENCODING;var w=u.errorOrDestroy;r(7526)(Writable,a);function nop(){}function WritableState(e,t,n){i=i||r(6744);e=e||{};if(typeof n!=="boolean")n=t instanceof i;this.objectMode=!!e.objectMode;if(n)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=d(this,e,"writableHighWaterMark",n);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:n.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var M;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){M=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(M.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{M=function realHasInstance(e){return e instanceof this}}function Writable(e){i=i||r(6744);var t=this instanceof i;if(!t&&!M.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){w(this,new v)};function writeAfterEnd(e,t){var r=new g;w(e,r);process.nextTick(t,r)}function validChunk(e,t,r,i){var n;if(r===null){n=new y}else if(typeof r!=="string"&&!t.objectMode){n=new l("chunk",["string","Buffer"],r)}if(n){w(e,n);process.nextTick(i,n);return false}return true}Writable.prototype.write=function(e,t,r){var i=this._writableState;var n=false;var a=!i.objectMode&&_isUint8Array(e);if(a&&!s.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=i.defaultEncoding;if(typeof r!=="function")r=nop;if(i.ending)writeAfterEnd(this,r);else if(a||validChunk(this,i,e,r)){i.pendingcb++;n=writeOrBuffer(this,i,a,e,t,r)}return n};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new _(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=s.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,i,n,a){if(!r){var s=decodeChunk(t,i,n);if(i!==s){r=true;n="buffer";i=s}}var o=t.objectMode?1:i.length;t.length+=o;var u=t.length<t.highWaterMark;if(!u)t.needDrain=true;if(t.writing||t.corked){var h=t.lastBufferedRequest;t.lastBufferedRequest={chunk:i,encoding:n,isBuf:r,callback:a,next:null};if(h){h.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,o,i,n,a)}return u}function doWrite(e,t,r,i,n,a,s){t.writelen=i;t.writecb=s;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new m("write"));else if(r)e._writev(n,t.onwrite);else e._write(n,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,i,n){--t.pendingcb;if(r){process.nextTick(n,i);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;w(e,i)}else{n(i);e._writableState.errorEmitted=true;w(e,i);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var i=r.sync;var n=r.writecb;if(typeof n!=="function")throw new b;onwriteStateUpdate(r);if(t)onwriteError(e,r,i,t,n);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(i){process.nextTick(afterWrite,e,r,a,n)}else{afterWrite(e,r,a,n)}}}function afterWrite(e,t,r,i){if(!r)onwriteDrain(e,t);t.pendingcb--;i();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var i=t.bufferedRequestCount;var n=new Array(i);var a=t.corkedRequestsFree;a.entry=r;var s=0;var o=true;while(r){n[s]=r;if(!r.isBuf)o=false;r=r.next;s+=1}n.allBuffers=o;doWrite(e,t,true,t.length,n,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var u=r.chunk;var h=r.encoding;var d=r.callback;var c=t.objectMode?1:u.length;doWrite(e,t,false,c,u,h,d);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new p("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var i=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(i.corked){i.corked=1;this.uncork()}if(!i.ending)endWritable(this,i,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){w(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var i=e._readableState;if(!i||i.autoDestroy&&i.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var i=e.entry;e.entry=null;while(i){var n=i.callback;t.pendingcb--;n(r);i=i.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=u.destroy;Writable.prototype._undestroy=u.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},509:function(e,t,r){"use strict";var i;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(1785);var a=Symbol("lastResolve");var s=Symbol("lastReject");var o=Symbol("error");var u=Symbol("ended");var h=Symbol("lastPromise");var d=Symbol("handlePromise");var c=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[c].read();if(r!==null){e[h]=null;e[a]=null;e[s]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,i){e.then((function(){if(t[u]){r(createIterResult(undefined,true));return}t[d](r,i)}),i)}}var l=Object.getPrototypeOf((function(){}));var p=Object.setPrototypeOf((i={get stream(){return this[c]},next:function next(){var e=this;var t=this[o];if(t!==null){return Promise.reject(t)}if(this[u]){return Promise.resolve(createIterResult(undefined,true))}if(this[c].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[o]){r(e[o])}else{t(createIterResult(undefined,true))}}))}))}var r=this[h];var i;if(r){i=new Promise(wrapForNext(r,this))}else{var n=this[c].read();if(n!==null){return Promise.resolve(createIterResult(n,false))}i=new Promise(this[d])}this[h]=i;return i}},_defineProperty(i,Symbol.asyncIterator,(function(){return this})),_defineProperty(i,"return",(function _return(){var e=this;return new Promise((function(t,r){e[c].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),i),l);var b=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(p,(t={},_defineProperty(t,c,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,u,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,d,{value:function value(e,t){var i=r[c].read();if(i){r[h]=null;r[a]=null;r[s]=null;e(createIterResult(i,false))}else{r[a]=e;r[s]=t}},writable:true}),t));r[h]=null;n(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[s];if(t!==null){r[h]=null;r[a]=null;r[s]=null;t(e)}r[o]=e;return}var i=r[a];if(i!==null){r[h]=null;r[a]=null;r[s]=null;i(createIterResult(undefined,true))}r[u]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=b},8469:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);if(t)i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,i)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var i=t[r];i.enumerable=i.enumerable||false;i.configurable=true;if("value"in i)i.writable=true;Object.defineProperty(e,i.key,i)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var i=r(4300),n=i.Buffer;var a=r(3837),s=a.inspect;var o=s&&s.custom||"inspect";function copyBuffer(e,t,r){n.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return n.alloc(0);var t=n.allocUnsafe(e>>>0);var r=this.head;var i=0;while(r){copyBuffer(r.data,t,i);i+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var i=t.data;e-=i.length;while(t=t.next){var n=t.data;var a=e>n.length?n.length:e;if(a===n.length)i+=n;else i+=n.slice(0,e);e-=a;if(e===0){if(a===n.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=n.slice(a)}break}++r}this.length-=r;return i}},{key:"_getBuffer",value:function _getBuffer(e){var t=n.allocUnsafe(e);var r=this.head;var i=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var s=e>a.length?a.length:e;a.copy(t,t.length-e,0,s);e-=s;if(e===0){if(s===a.length){++i;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(s)}break}++i}this.length-=i;return t}},{key:o,value:function value(e,t){return s(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},9666:function(e){"use strict";function destroy(e,t){var r=this;var i=this._readableState&&this._readableState.destroyed;var n=this._writableState&&this._writableState.destroyed;if(i||n){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var i=e._writableState;if(r&&r.autoDestroy||i&&i.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},1785:function(e,t,r){"use strict";var i=r(42).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,i=new Array(r),n=0;n<r;n++){i[n]=arguments[n]}e.apply(this,i)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var n=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var s=function onlegacyfinish(){if(!e.writable)u()};var o=e._writableState&&e._writableState.finished;var u=function onfinish(){a=false;o=true;if(!n)r.call(e)};var h=e._readableState&&e._readableState.endEmitted;var d=function onend(){n=false;h=true;if(!a)r.call(e)};var c=function onerror(t){r.call(e,t)};var l=function onclose(){var t;if(n&&!h){if(!e._readableState||!e._readableState.ended)t=new i;return r.call(e,t)}if(a&&!o){if(!e._writableState||!e._writableState.ended)t=new i;return r.call(e,t)}};var p=function onrequest(){e.req.on("finish",u)};if(isRequest(e)){e.on("complete",u);e.on("abort",l);if(e.req)p();else e.on("request",p)}else if(a&&!e._writableState){e.on("end",s);e.on("close",s)}e.on("end",d);e.on("finish",u);if(t.error!==false)e.on("error",c);e.on("close",l);return function(){e.removeListener("complete",u);e.removeListener("abort",l);e.removeListener("request",p);if(e.req)e.req.removeListener("finish",u);e.removeListener("end",s);e.removeListener("close",s);e.removeListener("finish",u);e.removeListener("end",d);e.removeListener("error",c);e.removeListener("close",l)}}e.exports=eos},6171:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,i,n,a,s){try{var o=e[a](s);var u=o.value}catch(e){r(e);return}if(o.done){t(u)}else{Promise.resolve(u).then(i,n)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(i,n){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,i,n,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,i,n,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);if(t)i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,i)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(42).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var n;if(t&&typeof t.next==="function"){n=t}else if(t&&t[Symbol.asyncIterator])n=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])n=t[Symbol.iterator]();else throw new i("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var s=false;a._read=function(){if(!s){s=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield n.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{s=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},7612:function(e,t,r){"use strict";var i;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var n=r(42).q,a=n.ERR_MISSING_ARGS,s=n.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,n,a){a=once(a);var o=false;e.on("close",(function(){o=true}));if(i===undefined)i=r(1785);i(e,{readable:t,writable:n},(function(e){if(e)return a(e);o=true;a()}));var u=false;return function(t){if(o)return;if(u)return;u=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new s("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var i=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var n;var s=t.map((function(e,r){var a=r<t.length-1;var o=r>0;return destroyer(e,a,o,(function(e){if(!n)n=e;if(e)s.forEach(call);if(a)return;s.forEach(call);i(n)}))}));return t.reduce(pipe)}e.exports=pipeline},894:function(e,t,r){"use strict";var i=r(42).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,n){var a=highWaterMarkFrom(t,n,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var s=n?r:"highWaterMark";throw new i(s,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},1727:function(e,t,r){e.exports=r(2781)},6572:function(e,t,r){var i=r(2781);if(process.env.READABLE_STREAM==="disable"&&i){e.exports=i.Readable;Object.assign(e.exports,i);e.exports.Stream=i}else{t=e.exports=r(8318);t.Stream=i||t;t.Readable=t;t.Writable=r(3877);t.Duplex=r(6744);t.Transform=r(9482);t.PassThrough=r(6609);t.finished=r(1785);t.pipeline=r(7612)}},5673:function(e,t,r){"use strict";var i=r(3118).Buffer;var n=i.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(i.isEncoding===n||!n(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=i.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var i=t.length-1;if(i<r)return 0;var n=utf8CheckByte(t[i]);if(n>=0){if(n>0)e.lastNeed=n-1;return n}if(--i<r||n===-2)return 0;n=utf8CheckByte(t[i]);if(n>=0){if(n>0)e.lastNeed=n-2;return n}if(--i<r||n===-2)return 0;n=utf8CheckByte(t[i]);if(n>=0){if(n>0){if(n===2)n=0;else e.lastNeed=n-3}return n}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var i=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,i);return e.toString("utf8",t,i)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var i=r.charCodeAt(r.length-1);if(i>=55296&&i<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},5653:function(e){e.exports=function xor(e,t){var r=Math.min(e.length,t.length);var i=new Buffer(r);for(var n=0;n<r;++n){i[n]=e[n]^t[n]}return i}},8826:function(e,t,r){var i=r(3118).Buffer;var n=r(2781).Transform;var a=r(1576).StringDecoder;var s=r(7526);function CipherBase(e){n.call(this);this.hashMode=typeof e==="string";if(this.hashMode){this[e]=this._finalOrDigest}else{this.final=this._finalOrDigest}if(this._final){this.__final=this._final;this._final=null}this._decoder=null;this._encoding=null}s(CipherBase,n);CipherBase.prototype.update=function(e,t,r){if(typeof e==="string"){e=i.from(e,t)}var n=this._update(e);if(this.hashMode)return this;if(r){n=this._toString(n,r)}return n};CipherBase.prototype.setAutoPadding=function(){};CipherBase.prototype.getAuthTag=function(){throw new Error("trying to get auth tag in unsupported state")};CipherBase.prototype.setAuthTag=function(){throw new Error("trying to set auth tag in unsupported state")};CipherBase.prototype.setAAD=function(){throw new Error("trying to set aad in unsupported state")};CipherBase.prototype._transform=function(e,t,r){var i;try{if(this.hashMode){this._update(e)}else{this.push(this._update(e))}}catch(e){i=e}finally{r(i)}};CipherBase.prototype._flush=function(e){var t;try{this.push(this.__final())}catch(e){t=e}e(t)};CipherBase.prototype._finalOrDigest=function(e){var t=this.__final()||i.alloc(0);if(e){t=this._toString(t,e,true)}return t};CipherBase.prototype._toString=function(e,t,r){if(!this._decoder){this._decoder=new a(t);this._encoding=t}if(this._encoding!==t)throw new Error("can't switch encodings");var i=this._decoder.write(e);if(r){i+=this._decoder.end()}return i};e.exports=CipherBase},7354:function(e,t,r){var i=r(8818);var n=r(6884);e.exports=function createECDH(e){return new ECDH(e)};var a={secp256k1:{name:"secp256k1",byteLength:32},secp224r1:{name:"p224",byteLength:28},prime256v1:{name:"p256",byteLength:32},prime192v1:{name:"p192",byteLength:24},ed25519:{name:"ed25519",byteLength:32},secp384r1:{name:"p384",byteLength:48},secp521r1:{name:"p521",byteLength:66}};a.p224=a.secp224r1;a.p256=a.secp256r1=a.prime256v1;a.p192=a.secp192r1=a.prime192v1;a.p384=a.secp384r1;a.p521=a.secp521r1;function ECDH(e){this.curveType=a[e];if(!this.curveType){this.curveType={name:e}}this.curve=new i.ec(this.curveType.name);this.keys=void 0}ECDH.prototype.generateKeys=function(e,t){this.keys=this.curve.genKeyPair();return this.getPublicKey(e,t)};ECDH.prototype.computeSecret=function(e,t,r){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}var i=this.curve.keyFromPublic(e).getPublic();var n=i.mul(this.keys.getPrivate()).getX();return formatReturnValue(n,r,this.curveType.byteLength)};ECDH.prototype.getPublicKey=function(e,t){var r=this.keys.getPublic(t==="compressed",true);if(t==="hybrid"){if(r[r.length-1]%2){r[0]=7}else{r[0]=6}}return formatReturnValue(r,e)};ECDH.prototype.getPrivateKey=function(e){return formatReturnValue(this.keys.getPrivate(),e)};ECDH.prototype.setPublicKey=function(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this.keys._importPublic(e);return this};ECDH.prototype.setPrivateKey=function(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}var r=new n(e);r=r.toString(16);this.keys=this.curve.genKeyPair();this.keys._importPrivate(r);return this};function formatReturnValue(e,t,r){if(!Array.isArray(e)){e=e.toArray()}var i=new Buffer(e);if(r&&i.length<r){var n=new Buffer(r-i.length);n.fill(0);i=Buffer.concat([n,i])}if(!t){return i}else{return i.toString(t)}}},2539:function(e,t,r){"use strict";var i=r(7526);var n=r(4125);var a=r(7455);var s=r(1862);var o=r(8826);function Hash(e){o.call(this,"digest");this._hash=e}i(Hash,o);Hash.prototype._update=function(e){this._hash.update(e)};Hash.prototype._final=function(){return this._hash.digest()};e.exports=function createHash(e){e=e.toLowerCase();if(e==="md5")return new n;if(e==="rmd160"||e==="ripemd160")return new a;return new Hash(s(e))}},355:function(e,t,r){var i=r(4125);e.exports=function(e){return(new i).update(e).digest()}},2730:function(e,t,r){"use strict";var i=r(7526);var n=r(2734);var a=r(8826);var s=r(3118).Buffer;var o=r(355);var u=r(7455);var h=r(1862);var d=s.alloc(128);function Hmac(e,t){a.call(this,"digest");if(typeof t==="string"){t=s.from(t)}var r=e==="sha512"||e==="sha384"?128:64;this._alg=e;this._key=t;if(t.length>r){var i=e==="rmd160"?new u:h(e);t=i.update(t).digest()}else if(t.length<r){t=s.concat([t,d],r)}var n=this._ipad=s.allocUnsafe(r);var o=this._opad=s.allocUnsafe(r);for(var c=0;c<r;c++){n[c]=t[c]^54;o[c]=t[c]^92}this._hash=e==="rmd160"?new u:h(e);this._hash.update(n)}i(Hmac,a);Hmac.prototype._update=function(e){this._hash.update(e)};Hmac.prototype._final=function(){var e=this._hash.digest();var t=this._alg==="rmd160"?new u:h(this._alg);return t.update(this._opad).update(e).digest()};e.exports=function createHmac(e,t){e=e.toLowerCase();if(e==="rmd160"||e==="ripemd160"){return new Hmac("rmd160",t)}if(e==="md5"){return new n(o,t)}return new Hmac(e,t)}},2734:function(e,t,r){"use strict";var i=r(7526);var n=r(3118).Buffer;var a=r(8826);var s=n.alloc(128);var o=64;function Hmac(e,t){a.call(this,"digest");if(typeof t==="string"){t=n.from(t)}this._alg=e;this._key=t;if(t.length>o){t=e(t)}else if(t.length<o){t=n.concat([t,s],o)}var r=this._ipad=n.allocUnsafe(o);var i=this._opad=n.allocUnsafe(o);for(var u=0;u<o;u++){r[u]=t[u]^54;i[u]=t[u]^92}this._hash=[r]}i(Hmac,a);Hmac.prototype._update=function(e){this._hash.push(e)};Hmac.prototype._final=function(){var e=this._alg(n.concat(this._hash));return this._alg(n.concat([this._opad,e]))};e.exports=Hmac},7795:function(e,t,r){"use strict";t.utils=r(6843);t.Cipher=r(1020);t.DES=r(9670);t.CBC=r(4065);t.EDE=r(2635)},4065:function(e,t,r){"use strict";var i=r(9036);var n=r(7526);var a={};function CBCState(e){i.equal(e.length,8,"Invalid IV length");this.iv=new Array(8);for(var t=0;t<this.iv.length;t++)this.iv[t]=e[t]}function instantiate(e){function CBC(t){e.call(this,t);this._cbcInit()}n(CBC,e);var t=Object.keys(a);for(var r=0;r<t.length;r++){var i=t[r];CBC.prototype[i]=a[i]}CBC.create=function create(e){return new CBC(e)};return CBC}t.instantiate=instantiate;a._cbcInit=function _cbcInit(){var e=new CBCState(this.options.iv);this._cbcState=e};a._update=function _update(e,t,r,i){var n=this._cbcState;var a=this.constructor.super_.prototype;var s=n.iv;if(this.type==="encrypt"){for(var o=0;o<this.blockSize;o++)s[o]^=e[t+o];a._update.call(this,s,0,r,i);for(var o=0;o<this.blockSize;o++)s[o]=r[i+o]}else{a._update.call(this,e,t,r,i);for(var o=0;o<this.blockSize;o++)r[i+o]^=s[o];for(var o=0;o<this.blockSize;o++)s[o]=e[t+o]}}},1020:function(e,t,r){"use strict";var i=r(9036);function Cipher(e){this.options=e;this.type=this.options.type;this.blockSize=8;this._init();this.buffer=new Array(this.blockSize);this.bufferOff=0}e.exports=Cipher;Cipher.prototype._init=function _init(){};Cipher.prototype.update=function update(e){if(e.length===0)return[];if(this.type==="decrypt")return this._updateDecrypt(e);else return this._updateEncrypt(e)};Cipher.prototype._buffer=function _buffer(e,t){var r=Math.min(this.buffer.length-this.bufferOff,e.length-t);for(var i=0;i<r;i++)this.buffer[this.bufferOff+i]=e[t+i];this.bufferOff+=r;return r};Cipher.prototype._flushBuffer=function _flushBuffer(e,t){this._update(this.buffer,0,e,t);this.bufferOff=0;return this.blockSize};Cipher.prototype._updateEncrypt=function _updateEncrypt(e){var t=0;var r=0;var i=(this.bufferOff+e.length)/this.blockSize|0;var n=new Array(i*this.blockSize);if(this.bufferOff!==0){t+=this._buffer(e,t);if(this.bufferOff===this.buffer.length)r+=this._flushBuffer(n,r)}var a=e.length-(e.length-t)%this.blockSize;for(;t<a;t+=this.blockSize){this._update(e,t,n,r);r+=this.blockSize}for(;t<e.length;t++,this.bufferOff++)this.buffer[this.bufferOff]=e[t];return n};Cipher.prototype._updateDecrypt=function _updateDecrypt(e){var t=0;var r=0;var i=Math.ceil((this.bufferOff+e.length)/this.blockSize)-1;var n=new Array(i*this.blockSize);for(;i>0;i--){t+=this._buffer(e,t);r+=this._flushBuffer(n,r)}t+=this._buffer(e,t);return n};Cipher.prototype.final=function final(e){var t;if(e)t=this.update(e);var r;if(this.type==="encrypt")r=this._finalEncrypt();else r=this._finalDecrypt();if(t)return t.concat(r);else return r};Cipher.prototype._pad=function _pad(e,t){if(t===0)return false;while(t<e.length)e[t++]=0;return true};Cipher.prototype._finalEncrypt=function _finalEncrypt(){if(!this._pad(this.buffer,this.bufferOff))return[];var e=new Array(this.blockSize);this._update(this.buffer,0,e,0);return e};Cipher.prototype._unpad=function _unpad(e){return e};Cipher.prototype._finalDecrypt=function _finalDecrypt(){i.equal(this.bufferOff,this.blockSize,"Not enough data to decrypt");var e=new Array(this.blockSize);this._flushBuffer(e,0);return this._unpad(e)}},9670:function(e,t,r){"use strict";var i=r(9036);var n=r(7526);var a=r(6843);var s=r(1020);function DESState(){this.tmp=new Array(2);this.keys=null}function DES(e){s.call(this,e);var t=new DESState;this._desState=t;this.deriveKeys(t,e.key)}n(DES,s);e.exports=DES;DES.create=function create(e){return new DES(e)};var o=[1,1,2,2,2,2,2,2,1,2,2,2,2,2,2,1];DES.prototype.deriveKeys=function deriveKeys(e,t){e.keys=new Array(16*2);i.equal(t.length,this.blockSize,"Invalid key length");var r=a.readUInt32BE(t,0);var n=a.readUInt32BE(t,4);a.pc1(r,n,e.tmp,0);r=e.tmp[0];n=e.tmp[1];for(var s=0;s<e.keys.length;s+=2){var u=o[s>>>1];r=a.r28shl(r,u);n=a.r28shl(n,u);a.pc2(r,n,e.keys,s)}};DES.prototype._update=function _update(e,t,r,i){var n=this._desState;var s=a.readUInt32BE(e,t);var o=a.readUInt32BE(e,t+4);a.ip(s,o,n.tmp,0);s=n.tmp[0];o=n.tmp[1];if(this.type==="encrypt")this._encrypt(n,s,o,n.tmp,0);else this._decrypt(n,s,o,n.tmp,0);s=n.tmp[0];o=n.tmp[1];a.writeUInt32BE(r,s,i);a.writeUInt32BE(r,o,i+4)};DES.prototype._pad=function _pad(e,t){var r=e.length-t;for(var i=t;i<e.length;i++)e[i]=r;return true};DES.prototype._unpad=function _unpad(e){var t=e[e.length-1];for(var r=e.length-t;r<e.length;r++)i.equal(e[r],t);return e.slice(0,e.length-t)};DES.prototype._encrypt=function _encrypt(e,t,r,i,n){var s=t;var o=r;for(var u=0;u<e.keys.length;u+=2){var h=e.keys[u];var d=e.keys[u+1];a.expand(o,e.tmp,0);h^=e.tmp[0];d^=e.tmp[1];var c=a.substitute(h,d);var l=a.permute(c);var p=o;o=(s^l)>>>0;s=p}a.rip(o,s,i,n)};DES.prototype._decrypt=function _decrypt(e,t,r,i,n){var s=r;var o=t;for(var u=e.keys.length-2;u>=0;u-=2){var h=e.keys[u];var d=e.keys[u+1];a.expand(s,e.tmp,0);h^=e.tmp[0];d^=e.tmp[1];var c=a.substitute(h,d);var l=a.permute(c);var p=s;s=(o^l)>>>0;o=p}a.rip(s,o,i,n)}},2635:function(e,t,r){"use strict";var i=r(9036);var n=r(7526);var a=r(1020);var s=r(9670);function EDEState(e,t){i.equal(t.length,24,"Invalid key length");var r=t.slice(0,8);var n=t.slice(8,16);var a=t.slice(16,24);if(e==="encrypt"){this.ciphers=[s.create({type:"encrypt",key:r}),s.create({type:"decrypt",key:n}),s.create({type:"encrypt",key:a})]}else{this.ciphers=[s.create({type:"decrypt",key:a}),s.create({type:"encrypt",key:n}),s.create({type:"decrypt",key:r})]}}function EDE(e){a.call(this,e);var t=new EDEState(this.type,this.options.key);this._edeState=t}n(EDE,a);e.exports=EDE;EDE.create=function create(e){return new EDE(e)};EDE.prototype._update=function _update(e,t,r,i){var n=this._edeState;n.ciphers[0]._update(e,t,r,i);n.ciphers[1]._update(r,i,r,i);n.ciphers[2]._update(r,i,r,i)};EDE.prototype._pad=s.prototype._pad;EDE.prototype._unpad=s.prototype._unpad},6843:function(e,t){"use strict";t.readUInt32BE=function readUInt32BE(e,t){var r=e[0+t]<<24|e[1+t]<<16|e[2+t]<<8|e[3+t];return r>>>0};t.writeUInt32BE=function writeUInt32BE(e,t,r){e[0+r]=t>>>24;e[1+r]=t>>>16&255;e[2+r]=t>>>8&255;e[3+r]=t&255};t.ip=function ip(e,t,r,i){var n=0;var a=0;for(var s=6;s>=0;s-=2){for(var o=0;o<=24;o+=8){n<<=1;n|=t>>>o+s&1}for(var o=0;o<=24;o+=8){n<<=1;n|=e>>>o+s&1}}for(var s=6;s>=0;s-=2){for(var o=1;o<=25;o+=8){a<<=1;a|=t>>>o+s&1}for(var o=1;o<=25;o+=8){a<<=1;a|=e>>>o+s&1}}r[i+0]=n>>>0;r[i+1]=a>>>0};t.rip=function rip(e,t,r,i){var n=0;var a=0;for(var s=0;s<4;s++){for(var o=24;o>=0;o-=8){n<<=1;n|=t>>>o+s&1;n<<=1;n|=e>>>o+s&1}}for(var s=4;s<8;s++){for(var o=24;o>=0;o-=8){a<<=1;a|=t>>>o+s&1;a<<=1;a|=e>>>o+s&1}}r[i+0]=n>>>0;r[i+1]=a>>>0};t.pc1=function pc1(e,t,r,i){var n=0;var a=0;for(var s=7;s>=5;s--){for(var o=0;o<=24;o+=8){n<<=1;n|=t>>o+s&1}for(var o=0;o<=24;o+=8){n<<=1;n|=e>>o+s&1}}for(var o=0;o<=24;o+=8){n<<=1;n|=t>>o+s&1}for(var s=1;s<=3;s++){for(var o=0;o<=24;o+=8){a<<=1;a|=t>>o+s&1}for(var o=0;o<=24;o+=8){a<<=1;a|=e>>o+s&1}}for(var o=0;o<=24;o+=8){a<<=1;a|=e>>o+s&1}r[i+0]=n>>>0;r[i+1]=a>>>0};t.r28shl=function r28shl(e,t){return e<<t&268435455|e>>>28-t};var r=[14,11,17,4,27,23,25,0,13,22,7,18,5,9,16,24,2,20,12,21,1,8,15,26,15,4,25,19,9,1,26,16,5,11,23,8,12,7,17,0,22,3,10,14,6,20,27,24];t.pc2=function pc2(e,t,i,n){var a=0;var s=0;var o=r.length>>>1;for(var u=0;u<o;u++){a<<=1;a|=e>>>r[u]&1}for(var u=o;u<r.length;u++){s<<=1;s|=t>>>r[u]&1}i[n+0]=a>>>0;i[n+1]=s>>>0};t.expand=function expand(e,t,r){var i=0;var n=0;i=(e&1)<<5|e>>>27;for(var a=23;a>=15;a-=4){i<<=6;i|=e>>>a&63}for(var a=11;a>=3;a-=4){n|=e>>>a&63;n<<=6}n|=(e&31)<<1|e>>>31;t[r+0]=i>>>0;t[r+1]=n>>>0};var i=[14,0,4,15,13,7,1,4,2,14,15,2,11,13,8,1,3,10,10,6,6,12,12,11,5,9,9,5,0,3,7,8,4,15,1,12,14,8,8,2,13,4,6,9,2,1,11,7,15,5,12,11,9,3,7,14,3,10,10,0,5,6,0,13,15,3,1,13,8,4,14,7,6,15,11,2,3,8,4,14,9,12,7,0,2,1,13,10,12,6,0,9,5,11,10,5,0,13,14,8,7,10,11,1,10,3,4,15,13,4,1,2,5,11,8,6,12,7,6,12,9,0,3,5,2,14,15,9,10,13,0,7,9,0,14,9,6,3,3,4,15,6,5,10,1,2,13,8,12,5,7,14,11,12,4,11,2,15,8,1,13,1,6,10,4,13,9,0,8,6,15,9,3,8,0,7,11,4,1,15,2,14,12,3,5,11,10,5,14,2,7,12,7,13,13,8,14,11,3,5,0,6,6,15,9,0,10,3,1,4,2,7,8,2,5,12,11,1,12,10,4,14,15,9,10,3,6,15,9,0,0,6,12,10,11,1,7,13,13,8,15,9,1,4,3,5,14,11,5,12,2,7,8,2,4,14,2,14,12,11,4,2,1,12,7,4,10,7,11,13,6,1,8,5,5,0,3,15,15,10,13,3,0,9,14,8,9,6,4,11,2,8,1,12,11,7,10,1,13,14,7,2,8,13,15,6,9,15,12,0,5,9,6,10,3,4,0,5,14,3,12,10,1,15,10,4,15,2,9,7,2,12,6,9,8,5,0,6,13,1,3,13,4,14,14,0,7,11,5,3,11,8,9,4,14,3,15,2,5,12,2,9,8,5,12,15,3,10,7,11,0,14,4,1,10,7,1,6,13,0,11,8,6,13,4,13,11,0,2,11,14,7,15,4,0,9,8,1,13,10,3,14,12,3,9,5,7,12,5,2,10,15,6,8,1,6,1,6,4,11,11,13,13,8,12,1,3,4,7,10,14,7,10,9,15,5,6,0,8,15,0,14,5,2,9,3,2,12,13,1,2,15,8,13,4,8,6,10,15,3,11,7,1,4,10,12,9,5,3,6,14,11,5,0,0,14,12,9,7,2,7,2,11,1,4,14,1,7,9,4,12,10,14,8,2,13,0,15,6,12,10,9,13,0,15,3,3,5,5,6,8,11];t.substitute=function substitute(e,t){var r=0;for(var n=0;n<4;n++){var a=e>>>18-n*6&63;var s=i[n*64+a];r<<=4;r|=s}for(var n=0;n<4;n++){var a=t>>>18-n*6&63;var s=i[4*64+n*64+a];r<<=4;r|=s}return r>>>0};var n=[16,25,12,11,3,20,4,15,31,17,9,6,27,14,1,22,30,24,8,18,0,5,29,23,13,19,2,26,10,21,28,7];t.permute=function permute(e){var t=0;for(var r=0;r<n.length;r++){t<<=1;t|=e>>>n[r]&1}return t>>>0};t.padSplit=function padSplit(e,t,r){var i=e.toString(2);while(i.length<t)i="0"+i;var n=[];for(var a=0;a<t;a+=r)n.push(i.slice(a,a+r));return n.join(" ")}},9977:function(e,t,r){var i=r(8053);var n=r(3418);var a=r(8346);function getDiffieHellman(e){var t=new Buffer(n[e].prime,"hex");var r=new Buffer(n[e].gen,"hex");return new a(t,r)}var s={binary:true,hex:true,base64:true};function createDiffieHellman(e,t,r,n){if(Buffer.isBuffer(t)||s[t]===undefined){return createDiffieHellman(e,"binary",t,r)}t=t||"binary";n=n||"binary";r=r||new Buffer([2]);if(!Buffer.isBuffer(r)){r=new Buffer(r,n)}if(typeof e==="number"){return new a(i(e,r),r,true)}if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}return new a(e,r,true)}t.DiffieHellmanGroup=t.createDiffieHellmanGroup=t.getDiffieHellman=getDiffieHellman;t.createDiffieHellman=t.DiffieHellman=createDiffieHellman},8346:function(e,t,r){var i=r(6884);var n=r(148);var a=new n;var s=new i(24);var o=new i(11);var u=new i(10);var h=new i(3);var d=new i(7);var c=r(8053);var l=r(2711);e.exports=DH;function setPublicKey(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this._pub=new i(e);return this}function setPrivateKey(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this._priv=new i(e);return this}var p={};function checkPrime(e,t){var r=t.toString("hex");var i=[r,e.toString(16)].join("_");if(i in p){return p[i]}var n=0;if(e.isEven()||!c.simpleSieve||!c.fermatTest(e)||!a.test(e)){n+=1;if(r==="02"||r==="05"){n+=8}else{n+=4}p[i]=n;return n}if(!a.test(e.shrn(1))){n+=2}var l;switch(r){case"02":if(e.mod(s).cmp(o)){n+=8}break;case"05":l=e.mod(u);if(l.cmp(h)&&l.cmp(d)){n+=8}break;default:n+=4}p[i]=n;return n}function DH(e,t,r){this.setGenerator(t);this.__prime=new i(e);this._prime=i.mont(this.__prime);this._primeLen=e.length;this._pub=undefined;this._priv=undefined;this._primeCode=undefined;if(r){this.setPublicKey=setPublicKey;this.setPrivateKey=setPrivateKey}else{this._primeCode=8}}Object.defineProperty(DH.prototype,"verifyError",{enumerable:true,get:function(){if(typeof this._primeCode!=="number"){this._primeCode=checkPrime(this.__prime,this.__gen)}return this._primeCode}});DH.prototype.generateKeys=function(){if(!this._priv){this._priv=new i(l(this._primeLen))}this._pub=this._gen.toRed(this._prime).redPow(this._priv).fromRed();return this.getPublicKey()};DH.prototype.computeSecret=function(e){e=new i(e);e=e.toRed(this._prime);var t=e.redPow(this._priv).fromRed();var r=new Buffer(t.toArray());var n=this.getPrime();if(r.length<n.length){var a=new Buffer(n.length-r.length);a.fill(0);r=Buffer.concat([a,r])}return r};DH.prototype.getPublicKey=function getPublicKey(e){return formatReturnValue(this._pub,e)};DH.prototype.getPrivateKey=function getPrivateKey(e){return formatReturnValue(this._priv,e)};DH.prototype.getPrime=function(e){return formatReturnValue(this.__prime,e)};DH.prototype.getGenerator=function(e){return formatReturnValue(this._gen,e)};DH.prototype.setGenerator=function(e,t){t=t||"utf8";if(!Buffer.isBuffer(e)){e=new Buffer(e,t)}this.__gen=e;this._gen=new i(e);return this};function formatReturnValue(e,t){var r=new Buffer(e.toArray());if(!t){return r}else{return r.toString(t)}}},8053:function(e,t,r){var i=r(2711);e.exports=findPrime;findPrime.simpleSieve=simpleSieve;findPrime.fermatTest=fermatTest;var n=r(6884);var a=new n(24);var s=r(148);var o=new s;var u=new n(1);var h=new n(2);var d=new n(5);var c=new n(16);var l=new n(8);var p=new n(10);var b=new n(3);var v=new n(7);var m=new n(11);var y=new n(4);var g=new n(12);var _=null;function _getPrimes(){if(_!==null)return _;var e=1048576;var t=[];t[0]=2;for(var r=1,i=3;i<e;i+=2){var n=Math.ceil(Math.sqrt(i));for(var a=0;a<r&&t[a]<=n;a++)if(i%t[a]===0)break;if(r!==a&&t[a]<=n)continue;t[r++]=i}_=t;return t}function simpleSieve(e){var t=_getPrimes();for(var r=0;r<t.length;r++)if(e.modn(t[r])===0){if(e.cmpn(t[r])===0){return true}else{return false}}return true}function fermatTest(e){var t=n.mont(e);return h.toRed(t).redPow(e.subn(1)).fromRed().cmpn(1)===0}function findPrime(e,t){if(e<16){if(t===2||t===5){return new n([140,123])}else{return new n([140,39])}}t=new n(t);var r,s;while(true){r=new n(i(Math.ceil(e/8)));while(r.bitLength()>e){r.ishrn(1)}if(r.isEven()){r.iadd(u)}if(!r.testn(1)){r.iadd(h)}if(!t.cmp(h)){while(r.mod(a).cmp(m)){r.iadd(y)}}else if(!t.cmp(d)){while(r.mod(p).cmp(b)){r.iadd(y)}}s=r.shrn(1);if(simpleSieve(s)&&simpleSieve(r)&&fermatTest(s)&&fermatTest(r)&&o.test(s)&&o.test(r)){return r}}}},8818:function(e,t,r){"use strict";var i=t;i.version=r(763).i8;i.utils=r(8454);i.rand=r(6069);i.curve=r(954);i.curves=r(2998);i.ec=r(2081);i.eddsa=r(2298)},3005:function(e,t,r){"use strict";var i=r(6884);var n=r(8454);var a=n.getNAF;var s=n.getJSF;var o=n.assert;function BaseCurve(e,t){this.type=e;this.p=new i(t.p,16);this.red=t.prime?i.red(t.prime):i.mont(this.p);this.zero=new i(0).toRed(this.red);this.one=new i(1).toRed(this.red);this.two=new i(2).toRed(this.red);this.n=t.n&&new i(t.n,16);this.g=t.g&&this.pointFromJSON(t.g,t.gRed);this._wnafT1=new Array(4);this._wnafT2=new Array(4);this._wnafT3=new Array(4);this._wnafT4=new Array(4);this._bitLength=this.n?this.n.bitLength():0;var r=this.n&&this.p.div(this.n);if(!r||r.cmpn(100)>0){this.redN=null}else{this._maxwellTrick=true;this.redN=this.n.toRed(this.red)}}e.exports=BaseCurve;BaseCurve.prototype.point=function point(){throw new Error("Not implemented")};BaseCurve.prototype.validate=function validate(){throw new Error("Not implemented")};BaseCurve.prototype._fixedNafMul=function _fixedNafMul(e,t){o(e.precomputed);var r=e._getDoubles();var i=a(t,1,this._bitLength);var n=(1<<r.step+1)-(r.step%2===0?2:1);n/=3;var s=[];for(var u=0;u<i.length;u+=r.step){var h=0;for(var t=u+r.step-1;t>=u;t--)h=(h<<1)+i[t];s.push(h)}var d=this.jpoint(null,null,null);var c=this.jpoint(null,null,null);for(var l=n;l>0;l--){for(var u=0;u<s.length;u++){var h=s[u];if(h===l)c=c.mixedAdd(r.points[u]);else if(h===-l)c=c.mixedAdd(r.points[u].neg())}d=d.add(c)}return d.toP()};BaseCurve.prototype._wnafMul=function _wnafMul(e,t){var r=4;var i=e._getNAFPoints(r);r=i.wnd;var n=i.points;var s=a(t,r,this._bitLength);var u=this.jpoint(null,null,null);for(var h=s.length-1;h>=0;h--){for(var t=0;h>=0&&s[h]===0;h--)t++;if(h>=0)t++;u=u.dblp(t);if(h<0)break;var d=s[h];o(d!==0);if(e.type==="affine"){if(d>0)u=u.mixedAdd(n[d-1>>1]);else u=u.mixedAdd(n[-d-1>>1].neg())}else{if(d>0)u=u.add(n[d-1>>1]);else u=u.add(n[-d-1>>1].neg())}}return e.type==="affine"?u.toP():u};BaseCurve.prototype._wnafMulAdd=function _wnafMulAdd(e,t,r,i,n){var o=this._wnafT1;var u=this._wnafT2;var h=this._wnafT3;var d=0;for(var c=0;c<i;c++){var l=t[c];var p=l._getNAFPoints(e);o[c]=p.wnd;u[c]=p.points}for(var c=i-1;c>=1;c-=2){var b=c-1;var v=c;if(o[b]!==1||o[v]!==1){h[b]=a(r[b],o[b],this._bitLength);h[v]=a(r[v],o[v],this._bitLength);d=Math.max(h[b].length,d);d=Math.max(h[v].length,d);continue}var m=[t[b],null,null,t[v]];if(t[b].y.cmp(t[v].y)===0){m[1]=t[b].add(t[v]);m[2]=t[b].toJ().mixedAdd(t[v].neg())}else if(t[b].y.cmp(t[v].y.redNeg())===0){m[1]=t[b].toJ().mixedAdd(t[v]);m[2]=t[b].add(t[v].neg())}else{m[1]=t[b].toJ().mixedAdd(t[v]);m[2]=t[b].toJ().mixedAdd(t[v].neg())}var y=[-3,-1,-5,-7,0,7,5,1,3];var g=s(r[b],r[v]);d=Math.max(g[0].length,d);h[b]=new Array(d);h[v]=new Array(d);for(var _=0;_<d;_++){var w=g[0][_]|0;var M=g[1][_]|0;h[b][_]=y[(w+1)*3+(M+1)];h[v][_]=0;u[b]=m}}var E=this.jpoint(null,null,null);var B=this._wnafT4;for(var c=d;c>=0;c--){var k=0;while(c>=0){var A=true;for(var _=0;_<i;_++){B[_]=h[_][c]|0;if(B[_]!==0)A=false}if(!A)break;k++;c--}if(c>=0)k++;E=E.dblp(k);if(c<0)break;for(var _=0;_<i;_++){var N=B[_];var l;if(N===0)continue;else if(N>0)l=u[_][N-1>>1];else if(N<0)l=u[_][-N-1>>1].neg();if(l.type==="affine")E=E.mixedAdd(l);else E=E.add(l)}}for(var c=0;c<i;c++)u[c]=null;if(n)return E;else return E.toP()};function BasePoint(e,t){this.curve=e;this.type=t;this.precomputed=null}BaseCurve.BasePoint=BasePoint;BasePoint.prototype.eq=function eq(){throw new Error("Not implemented")};BasePoint.prototype.validate=function validate(){return this.curve.validate(this)};BaseCurve.prototype.decodePoint=function decodePoint(e,t){e=n.toArray(e,t);var r=this.p.byteLength();if((e[0]===4||e[0]===6||e[0]===7)&&e.length-1===2*r){if(e[0]===6)o(e[e.length-1]%2===0);else if(e[0]===7)o(e[e.length-1]%2===1);var i=this.point(e.slice(1,1+r),e.slice(1+r,1+2*r));return i}else if((e[0]===2||e[0]===3)&&e.length-1===r){return this.pointFromX(e.slice(1,1+r),e[0]===3)}throw new Error("Unknown point format")};BasePoint.prototype.encodeCompressed=function encodeCompressed(e){return this.encode(e,true)};BasePoint.prototype._encode=function _encode(e){var t=this.curve.p.byteLength();var r=this.getX().toArray("be",t);if(e)return[this.getY().isEven()?2:3].concat(r);return[4].concat(r,this.getY().toArray("be",t))};BasePoint.prototype.encode=function encode(e,t){return n.encode(this._encode(t),e)};BasePoint.prototype.precompute=function precompute(e){if(this.precomputed)return this;var t={doubles:null,naf:null,beta:null};t.naf=this._getNAFPoints(8);t.doubles=this._getDoubles(4,e);t.beta=this._getBeta();this.precomputed=t;return this};BasePoint.prototype._hasDoubles=function _hasDoubles(e){if(!this.precomputed)return false;var t=this.precomputed.doubles;if(!t)return false;return t.points.length>=Math.ceil((e.bitLength()+1)/t.step)};BasePoint.prototype._getDoubles=function _getDoubles(e,t){if(this.precomputed&&this.precomputed.doubles)return this.precomputed.doubles;var r=[this];var i=this;for(var n=0;n<t;n+=e){for(var a=0;a<e;a++)i=i.dbl();r.push(i)}return{step:e,points:r}};BasePoint.prototype._getNAFPoints=function _getNAFPoints(e){if(this.precomputed&&this.precomputed.naf)return this.precomputed.naf;var t=[this];var r=(1<<e)-1;var i=r===1?null:this.dbl();for(var n=1;n<r;n++)t[n]=t[n-1].add(i);return{wnd:e,points:t}};BasePoint.prototype._getBeta=function _getBeta(){return null};BasePoint.prototype.dblp=function dblp(e){var t=this;for(var r=0;r<e;r++)t=t.dbl();return t}},9224:function(e,t,r){"use strict";var i=r(8454);var n=r(6884);var a=r(7526);var s=r(3005);var o=i.assert;function EdwardsCurve(e){this.twisted=(e.a|0)!==1;this.mOneA=this.twisted&&(e.a|0)===-1;this.extended=this.mOneA;s.call(this,"edwards",e);this.a=new n(e.a,16).umod(this.red.m);this.a=this.a.toRed(this.red);this.c=new n(e.c,16).toRed(this.red);this.c2=this.c.redSqr();this.d=new n(e.d,16).toRed(this.red);this.dd=this.d.redAdd(this.d);o(!this.twisted||this.c.fromRed().cmpn(1)===0);this.oneC=(e.c|0)===1}a(EdwardsCurve,s);e.exports=EdwardsCurve;EdwardsCurve.prototype._mulA=function _mulA(e){if(this.mOneA)return e.redNeg();else return this.a.redMul(e)};EdwardsCurve.prototype._mulC=function _mulC(e){if(this.oneC)return e;else return this.c.redMul(e)};EdwardsCurve.prototype.jpoint=function jpoint(e,t,r,i){return this.point(e,t,r,i)};EdwardsCurve.prototype.pointFromX=function pointFromX(e,t){e=new n(e,16);if(!e.red)e=e.toRed(this.red);var r=e.redSqr();var i=this.c2.redSub(this.a.redMul(r));var a=this.one.redSub(this.c2.redMul(this.d).redMul(r));var s=i.redMul(a.redInvm());var o=s.redSqrt();if(o.redSqr().redSub(s).cmp(this.zero)!==0)throw new Error("invalid point");var u=o.fromRed().isOdd();if(t&&!u||!t&&u)o=o.redNeg();return this.point(e,o)};EdwardsCurve.prototype.pointFromY=function pointFromY(e,t){e=new n(e,16);if(!e.red)e=e.toRed(this.red);var r=e.redSqr();var i=r.redSub(this.c2);var a=r.redMul(this.d).redMul(this.c2).redSub(this.a);var s=i.redMul(a.redInvm());if(s.cmp(this.zero)===0){if(t)throw new Error("invalid point");else return this.point(this.zero,e)}var o=s.redSqrt();if(o.redSqr().redSub(s).cmp(this.zero)!==0)throw new Error("invalid point");if(o.fromRed().isOdd()!==t)o=o.redNeg();return this.point(o,e)};EdwardsCurve.prototype.validate=function validate(e){if(e.isInfinity())return true;e.normalize();var t=e.x.redSqr();var r=e.y.redSqr();var i=t.redMul(this.a).redAdd(r);var n=this.c2.redMul(this.one.redAdd(this.d.redMul(t).redMul(r)));return i.cmp(n)===0};function Point(e,t,r,i,a){s.BasePoint.call(this,e,"projective");if(t===null&&r===null&&i===null){this.x=this.curve.zero;this.y=this.curve.one;this.z=this.curve.one;this.t=this.curve.zero;this.zOne=true}else{this.x=new n(t,16);this.y=new n(r,16);this.z=i?new n(i,16):this.curve.one;this.t=a&&new n(a,16);if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.y.red)this.y=this.y.toRed(this.curve.red);if(!this.z.red)this.z=this.z.toRed(this.curve.red);if(this.t&&!this.t.red)this.t=this.t.toRed(this.curve.red);this.zOne=this.z===this.curve.one;if(this.curve.extended&&!this.t){this.t=this.x.redMul(this.y);if(!this.zOne)this.t=this.t.redMul(this.z.redInvm())}}}a(Point,s.BasePoint);EdwardsCurve.prototype.pointFromJSON=function pointFromJSON(e){return Point.fromJSON(this,e)};EdwardsCurve.prototype.point=function point(e,t,r,i){return new Point(this,e,t,r,i)};Point.fromJSON=function fromJSON(e,t){return new Point(e,t[0],t[1],t[2])};Point.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC Point Infinity>";return"<EC Point x: "+this.x.fromRed().toString(16,2)+" y: "+this.y.fromRed().toString(16,2)+" z: "+this.z.fromRed().toString(16,2)+">"};Point.prototype.isInfinity=function isInfinity(){return this.x.cmpn(0)===0&&(this.y.cmp(this.z)===0||this.zOne&&this.y.cmp(this.curve.c)===0)};Point.prototype._extDbl=function _extDbl(){var e=this.x.redSqr();var t=this.y.redSqr();var r=this.z.redSqr();r=r.redIAdd(r);var i=this.curve._mulA(e);var n=this.x.redAdd(this.y).redSqr().redISub(e).redISub(t);var a=i.redAdd(t);var s=a.redSub(r);var o=i.redSub(t);var u=n.redMul(s);var h=a.redMul(o);var d=n.redMul(o);var c=s.redMul(a);return this.curve.point(u,h,c,d)};Point.prototype._projDbl=function _projDbl(){var e=this.x.redAdd(this.y).redSqr();var t=this.x.redSqr();var r=this.y.redSqr();var i;var n;var a;if(this.curve.twisted){var s=this.curve._mulA(t);var o=s.redAdd(r);if(this.zOne){i=e.redSub(t).redSub(r).redMul(o.redSub(this.curve.two));n=o.redMul(s.redSub(r));a=o.redSqr().redSub(o).redSub(o)}else{var u=this.z.redSqr();var h=o.redSub(u).redISub(u);i=e.redSub(t).redISub(r).redMul(h);n=o.redMul(s.redSub(r));a=o.redMul(h)}}else{var s=t.redAdd(r);var u=this.curve._mulC(this.z).redSqr();var h=s.redSub(u).redSub(u);i=this.curve._mulC(e.redISub(s)).redMul(h);n=this.curve._mulC(s).redMul(t.redISub(r));a=s.redMul(h)}return this.curve.point(i,n,a)};Point.prototype.dbl=function dbl(){if(this.isInfinity())return this;if(this.curve.extended)return this._extDbl();else return this._projDbl()};Point.prototype._extAdd=function _extAdd(e){var t=this.y.redSub(this.x).redMul(e.y.redSub(e.x));var r=this.y.redAdd(this.x).redMul(e.y.redAdd(e.x));var i=this.t.redMul(this.curve.dd).redMul(e.t);var n=this.z.redMul(e.z.redAdd(e.z));var a=r.redSub(t);var s=n.redSub(i);var o=n.redAdd(i);var u=r.redAdd(t);var h=a.redMul(s);var d=o.redMul(u);var c=a.redMul(u);var l=s.redMul(o);return this.curve.point(h,d,l,c)};Point.prototype._projAdd=function _projAdd(e){var t=this.z.redMul(e.z);var r=t.redSqr();var i=this.x.redMul(e.x);var n=this.y.redMul(e.y);var a=this.curve.d.redMul(i).redMul(n);var s=r.redSub(a);var o=r.redAdd(a);var u=this.x.redAdd(this.y).redMul(e.x.redAdd(e.y)).redISub(i).redISub(n);var h=t.redMul(s).redMul(u);var d;var c;if(this.curve.twisted){d=t.redMul(o).redMul(n.redSub(this.curve._mulA(i)));c=s.redMul(o)}else{d=t.redMul(o).redMul(n.redSub(i));c=this.curve._mulC(s).redMul(o)}return this.curve.point(h,d,c)};Point.prototype.add=function add(e){if(this.isInfinity())return e;if(e.isInfinity())return this;if(this.curve.extended)return this._extAdd(e);else return this._projAdd(e)};Point.prototype.mul=function mul(e){if(this._hasDoubles(e))return this.curve._fixedNafMul(this,e);else return this.curve._wnafMul(this,e)};Point.prototype.mulAdd=function mulAdd(e,t,r){return this.curve._wnafMulAdd(1,[this,t],[e,r],2,false)};Point.prototype.jmulAdd=function jmulAdd(e,t,r){return this.curve._wnafMulAdd(1,[this,t],[e,r],2,true)};Point.prototype.normalize=function normalize(){if(this.zOne)return this;var e=this.z.redInvm();this.x=this.x.redMul(e);this.y=this.y.redMul(e);if(this.t)this.t=this.t.redMul(e);this.z=this.curve.one;this.zOne=true;return this};Point.prototype.neg=function neg(){return this.curve.point(this.x.redNeg(),this.y,this.z,this.t&&this.t.redNeg())};Point.prototype.getX=function getX(){this.normalize();return this.x.fromRed()};Point.prototype.getY=function getY(){this.normalize();return this.y.fromRed()};Point.prototype.eq=function eq(e){return this===e||this.getX().cmp(e.getX())===0&&this.getY().cmp(e.getY())===0};Point.prototype.eqXToP=function eqXToP(e){var t=e.toRed(this.curve.red).redMul(this.z);if(this.x.cmp(t)===0)return true;var r=e.clone();var i=this.curve.redN.redMul(this.z);for(;;){r.iadd(this.curve.n);if(r.cmp(this.curve.p)>=0)return false;t.redIAdd(i);if(this.x.cmp(t)===0)return true}};Point.prototype.toP=Point.prototype.normalize;Point.prototype.mixedAdd=Point.prototype.add},954:function(e,t,r){"use strict";var i=t;i.base=r(3005);i.short=r(401);i.mont=r(6103);i.edwards=r(9224)},6103:function(e,t,r){"use strict";var i=r(6884);var n=r(7526);var a=r(3005);var s=r(8454);function MontCurve(e){a.call(this,"mont",e);this.a=new i(e.a,16).toRed(this.red);this.b=new i(e.b,16).toRed(this.red);this.i4=new i(4).toRed(this.red).redInvm();this.two=new i(2).toRed(this.red);this.a24=this.i4.redMul(this.a.redAdd(this.two))}n(MontCurve,a);e.exports=MontCurve;MontCurve.prototype.validate=function validate(e){var t=e.normalize().x;var r=t.redSqr();var i=r.redMul(t).redAdd(r.redMul(this.a)).redAdd(t);var n=i.redSqrt();return n.redSqr().cmp(i)===0};function Point(e,t,r){a.BasePoint.call(this,e,"projective");if(t===null&&r===null){this.x=this.curve.one;this.z=this.curve.zero}else{this.x=new i(t,16);this.z=new i(r,16);if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.z.red)this.z=this.z.toRed(this.curve.red)}}n(Point,a.BasePoint);MontCurve.prototype.decodePoint=function decodePoint(e,t){return this.point(s.toArray(e,t),1)};MontCurve.prototype.point=function point(e,t){return new Point(this,e,t)};MontCurve.prototype.pointFromJSON=function pointFromJSON(e){return Point.fromJSON(this,e)};Point.prototype.precompute=function precompute(){};Point.prototype._encode=function _encode(){return this.getX().toArray("be",this.curve.p.byteLength())};Point.fromJSON=function fromJSON(e,t){return new Point(e,t[0],t[1]||e.one)};Point.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC Point Infinity>";return"<EC Point x: "+this.x.fromRed().toString(16,2)+" z: "+this.z.fromRed().toString(16,2)+">"};Point.prototype.isInfinity=function isInfinity(){return this.z.cmpn(0)===0};Point.prototype.dbl=function dbl(){var e=this.x.redAdd(this.z);var t=e.redSqr();var r=this.x.redSub(this.z);var i=r.redSqr();var n=t.redSub(i);var a=t.redMul(i);var s=n.redMul(i.redAdd(this.curve.a24.redMul(n)));return this.curve.point(a,s)};Point.prototype.add=function add(){throw new Error("Not supported on Montgomery curve")};Point.prototype.diffAdd=function diffAdd(e,t){var r=this.x.redAdd(this.z);var i=this.x.redSub(this.z);var n=e.x.redAdd(e.z);var a=e.x.redSub(e.z);var s=a.redMul(r);var o=n.redMul(i);var u=t.z.redMul(s.redAdd(o).redSqr());var h=t.x.redMul(s.redISub(o).redSqr());return this.curve.point(u,h)};Point.prototype.mul=function mul(e){var t=e.clone();var r=this;var i=this.curve.point(null,null);var n=this;for(var a=[];t.cmpn(0)!==0;t.iushrn(1))a.push(t.andln(1));for(var s=a.length-1;s>=0;s--){if(a[s]===0){r=r.diffAdd(i,n);i=i.dbl()}else{i=r.diffAdd(i,n);r=r.dbl()}}return i};Point.prototype.mulAdd=function mulAdd(){throw new Error("Not supported on Montgomery curve")};Point.prototype.jumlAdd=function jumlAdd(){throw new Error("Not supported on Montgomery curve")};Point.prototype.eq=function eq(e){return this.getX().cmp(e.getX())===0};Point.prototype.normalize=function normalize(){this.x=this.x.redMul(this.z.redInvm());this.z=this.curve.one;return this};Point.prototype.getX=function getX(){this.normalize();return this.x.fromRed()}},401:function(e,t,r){"use strict";var i=r(8454);var n=r(6884);var a=r(7526);var s=r(3005);var o=i.assert;function ShortCurve(e){s.call(this,"short",e);this.a=new n(e.a,16).toRed(this.red);this.b=new n(e.b,16).toRed(this.red);this.tinv=this.two.redInvm();this.zeroA=this.a.fromRed().cmpn(0)===0;this.threeA=this.a.fromRed().sub(this.p).cmpn(-3)===0;this.endo=this._getEndomorphism(e);this._endoWnafT1=new Array(4);this._endoWnafT2=new Array(4)}a(ShortCurve,s);e.exports=ShortCurve;ShortCurve.prototype._getEndomorphism=function _getEndomorphism(e){if(!this.zeroA||!this.g||!this.n||this.p.modn(3)!==1)return;var t;var r;if(e.beta){t=new n(e.beta,16).toRed(this.red)}else{var i=this._getEndoRoots(this.p);t=i[0].cmp(i[1])<0?i[0]:i[1];t=t.toRed(this.red)}if(e.lambda){r=new n(e.lambda,16)}else{var a=this._getEndoRoots(this.n);if(this.g.mul(a[0]).x.cmp(this.g.x.redMul(t))===0){r=a[0]}else{r=a[1];o(this.g.mul(r).x.cmp(this.g.x.redMul(t))===0)}}var s;if(e.basis){s=e.basis.map((function(e){return{a:new n(e.a,16),b:new n(e.b,16)}}))}else{s=this._getEndoBasis(r)}return{beta:t,lambda:r,basis:s}};ShortCurve.prototype._getEndoRoots=function _getEndoRoots(e){var t=e===this.p?this.red:n.mont(e);var r=new n(2).toRed(t).redInvm();var i=r.redNeg();var a=new n(3).toRed(t).redNeg().redSqrt().redMul(r);var s=i.redAdd(a).fromRed();var o=i.redSub(a).fromRed();return[s,o]};ShortCurve.prototype._getEndoBasis=function _getEndoBasis(e){var t=this.n.ushrn(Math.floor(this.n.bitLength()/2));var r=e;var i=this.n.clone();var a=new n(1);var s=new n(0);var o=new n(0);var u=new n(1);var h;var d;var c;var l;var p;var b;var v;var m=0;var y;var g;while(r.cmpn(0)!==0){var _=i.div(r);y=i.sub(_.mul(r));g=o.sub(_.mul(a));var w=u.sub(_.mul(s));if(!c&&y.cmp(t)<0){h=v.neg();d=a;c=y.neg();l=g}else if(c&&++m===2){break}v=y;i=r;r=y;o=a;a=g;u=s;s=w}p=y.neg();b=g;var M=c.sqr().add(l.sqr());var E=p.sqr().add(b.sqr());if(E.cmp(M)>=0){p=h;b=d}if(c.negative){c=c.neg();l=l.neg()}if(p.negative){p=p.neg();b=b.neg()}return[{a:c,b:l},{a:p,b:b}]};ShortCurve.prototype._endoSplit=function _endoSplit(e){var t=this.endo.basis;var r=t[0];var i=t[1];var n=i.b.mul(e).divRound(this.n);var a=r.b.neg().mul(e).divRound(this.n);var s=n.mul(r.a);var o=a.mul(i.a);var u=n.mul(r.b);var h=a.mul(i.b);var d=e.sub(s).sub(o);var c=u.add(h).neg();return{k1:d,k2:c}};ShortCurve.prototype.pointFromX=function pointFromX(e,t){e=new n(e,16);if(!e.red)e=e.toRed(this.red);var r=e.redSqr().redMul(e).redIAdd(e.redMul(this.a)).redIAdd(this.b);var i=r.redSqrt();if(i.redSqr().redSub(r).cmp(this.zero)!==0)throw new Error("invalid point");var a=i.fromRed().isOdd();if(t&&!a||!t&&a)i=i.redNeg();return this.point(e,i)};ShortCurve.prototype.validate=function validate(e){if(e.inf)return true;var t=e.x;var r=e.y;var i=this.a.redMul(t);var n=t.redSqr().redMul(t).redIAdd(i).redIAdd(this.b);return r.redSqr().redISub(n).cmpn(0)===0};ShortCurve.prototype._endoWnafMulAdd=function _endoWnafMulAdd(e,t,r){var i=this._endoWnafT1;var n=this._endoWnafT2;for(var a=0;a<e.length;a++){var s=this._endoSplit(t[a]);var o=e[a];var u=o._getBeta();if(s.k1.negative){s.k1.ineg();o=o.neg(true)}if(s.k2.negative){s.k2.ineg();u=u.neg(true)}i[a*2]=o;i[a*2+1]=u;n[a*2]=s.k1;n[a*2+1]=s.k2}var h=this._wnafMulAdd(1,i,n,a*2,r);for(var d=0;d<a*2;d++){i[d]=null;n[d]=null}return h};function Point(e,t,r,i){s.BasePoint.call(this,e,"affine");if(t===null&&r===null){this.x=null;this.y=null;this.inf=true}else{this.x=new n(t,16);this.y=new n(r,16);if(i){this.x.forceRed(this.curve.red);this.y.forceRed(this.curve.red)}if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.y.red)this.y=this.y.toRed(this.curve.red);this.inf=false}}a(Point,s.BasePoint);ShortCurve.prototype.point=function point(e,t,r){return new Point(this,e,t,r)};ShortCurve.prototype.pointFromJSON=function pointFromJSON(e,t){return Point.fromJSON(this,e,t)};Point.prototype._getBeta=function _getBeta(){if(!this.curve.endo)return;var e=this.precomputed;if(e&&e.beta)return e.beta;var t=this.curve.point(this.x.redMul(this.curve.endo.beta),this.y);if(e){var r=this.curve;var endoMul=function(e){return r.point(e.x.redMul(r.endo.beta),e.y)};e.beta=t;t.precomputed={beta:null,naf:e.naf&&{wnd:e.naf.wnd,points:e.naf.points.map(endoMul)},doubles:e.doubles&&{step:e.doubles.step,points:e.doubles.points.map(endoMul)}}}return t};Point.prototype.toJSON=function toJSON(){if(!this.precomputed)return[this.x,this.y];return[this.x,this.y,this.precomputed&&{doubles:this.precomputed.doubles&&{step:this.precomputed.doubles.step,points:this.precomputed.doubles.points.slice(1)},naf:this.precomputed.naf&&{wnd:this.precomputed.naf.wnd,points:this.precomputed.naf.points.slice(1)}}]};Point.fromJSON=function fromJSON(e,t,r){if(typeof t==="string")t=JSON.parse(t);var i=e.point(t[0],t[1],r);if(!t[2])return i;function obj2point(t){return e.point(t[0],t[1],r)}var n=t[2];i.precomputed={beta:null,doubles:n.doubles&&{step:n.doubles.step,points:[i].concat(n.doubles.points.map(obj2point))},naf:n.naf&&{wnd:n.naf.wnd,points:[i].concat(n.naf.points.map(obj2point))}};return i};Point.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC Point Infinity>";return"<EC Point x: "+this.x.fromRed().toString(16,2)+" y: "+this.y.fromRed().toString(16,2)+">"};Point.prototype.isInfinity=function isInfinity(){return this.inf};Point.prototype.add=function add(e){if(this.inf)return e;if(e.inf)return this;if(this.eq(e))return this.dbl();if(this.neg().eq(e))return this.curve.point(null,null);if(this.x.cmp(e.x)===0)return this.curve.point(null,null);var t=this.y.redSub(e.y);if(t.cmpn(0)!==0)t=t.redMul(this.x.redSub(e.x).redInvm());var r=t.redSqr().redISub(this.x).redISub(e.x);var i=t.redMul(this.x.redSub(r)).redISub(this.y);return this.curve.point(r,i)};Point.prototype.dbl=function dbl(){if(this.inf)return this;var e=this.y.redAdd(this.y);if(e.cmpn(0)===0)return this.curve.point(null,null);var t=this.curve.a;var r=this.x.redSqr();var i=e.redInvm();var n=r.redAdd(r).redIAdd(r).redIAdd(t).redMul(i);var a=n.redSqr().redISub(this.x.redAdd(this.x));var s=n.redMul(this.x.redSub(a)).redISub(this.y);return this.curve.point(a,s)};Point.prototype.getX=function getX(){return this.x.fromRed()};Point.prototype.getY=function getY(){return this.y.fromRed()};Point.prototype.mul=function mul(e){e=new n(e,16);if(this.isInfinity())return this;else if(this._hasDoubles(e))return this.curve._fixedNafMul(this,e);else if(this.curve.endo)return this.curve._endoWnafMulAdd([this],[e]);else return this.curve._wnafMul(this,e)};Point.prototype.mulAdd=function mulAdd(e,t,r){var i=[this,t];var n=[e,r];if(this.curve.endo)return this.curve._endoWnafMulAdd(i,n);else return this.curve._wnafMulAdd(1,i,n,2)};Point.prototype.jmulAdd=function jmulAdd(e,t,r){var i=[this,t];var n=[e,r];if(this.curve.endo)return this.curve._endoWnafMulAdd(i,n,true);else return this.curve._wnafMulAdd(1,i,n,2,true)};Point.prototype.eq=function eq(e){return this===e||this.inf===e.inf&&(this.inf||this.x.cmp(e.x)===0&&this.y.cmp(e.y)===0)};Point.prototype.neg=function neg(e){if(this.inf)return this;var t=this.curve.point(this.x,this.y.redNeg());if(e&&this.precomputed){var r=this.precomputed;var negate=function(e){return e.neg()};t.precomputed={naf:r.naf&&{wnd:r.naf.wnd,points:r.naf.points.map(negate)},doubles:r.doubles&&{step:r.doubles.step,points:r.doubles.points.map(negate)}}}return t};Point.prototype.toJ=function toJ(){if(this.inf)return this.curve.jpoint(null,null,null);var e=this.curve.jpoint(this.x,this.y,this.curve.one);return e};function JPoint(e,t,r,i){s.BasePoint.call(this,e,"jacobian");if(t===null&&r===null&&i===null){this.x=this.curve.one;this.y=this.curve.one;this.z=new n(0)}else{this.x=new n(t,16);this.y=new n(r,16);this.z=new n(i,16)}if(!this.x.red)this.x=this.x.toRed(this.curve.red);if(!this.y.red)this.y=this.y.toRed(this.curve.red);if(!this.z.red)this.z=this.z.toRed(this.curve.red);this.zOne=this.z===this.curve.one}a(JPoint,s.BasePoint);ShortCurve.prototype.jpoint=function jpoint(e,t,r){return new JPoint(this,e,t,r)};JPoint.prototype.toP=function toP(){if(this.isInfinity())return this.curve.point(null,null);var e=this.z.redInvm();var t=e.redSqr();var r=this.x.redMul(t);var i=this.y.redMul(t).redMul(e);return this.curve.point(r,i)};JPoint.prototype.neg=function neg(){return this.curve.jpoint(this.x,this.y.redNeg(),this.z)};JPoint.prototype.add=function add(e){if(this.isInfinity())return e;if(e.isInfinity())return this;var t=e.z.redSqr();var r=this.z.redSqr();var i=this.x.redMul(t);var n=e.x.redMul(r);var a=this.y.redMul(t.redMul(e.z));var s=e.y.redMul(r.redMul(this.z));var o=i.redSub(n);var u=a.redSub(s);if(o.cmpn(0)===0){if(u.cmpn(0)!==0)return this.curve.jpoint(null,null,null);else return this.dbl()}var h=o.redSqr();var d=h.redMul(o);var c=i.redMul(h);var l=u.redSqr().redIAdd(d).redISub(c).redISub(c);var p=u.redMul(c.redISub(l)).redISub(a.redMul(d));var b=this.z.redMul(e.z).redMul(o);return this.curve.jpoint(l,p,b)};JPoint.prototype.mixedAdd=function mixedAdd(e){if(this.isInfinity())return e.toJ();if(e.isInfinity())return this;var t=this.z.redSqr();var r=this.x;var i=e.x.redMul(t);var n=this.y;var a=e.y.redMul(t).redMul(this.z);var s=r.redSub(i);var o=n.redSub(a);if(s.cmpn(0)===0){if(o.cmpn(0)!==0)return this.curve.jpoint(null,null,null);else return this.dbl()}var u=s.redSqr();var h=u.redMul(s);var d=r.redMul(u);var c=o.redSqr().redIAdd(h).redISub(d).redISub(d);var l=o.redMul(d.redISub(c)).redISub(n.redMul(h));var p=this.z.redMul(s);return this.curve.jpoint(c,l,p)};JPoint.prototype.dblp=function dblp(e){if(e===0)return this;if(this.isInfinity())return this;if(!e)return this.dbl();if(this.curve.zeroA||this.curve.threeA){var t=this;for(var r=0;r<e;r++)t=t.dbl();return t}var i=this.curve.a;var n=this.curve.tinv;var a=this.x;var s=this.y;var o=this.z;var u=o.redSqr().redSqr();var h=s.redAdd(s);for(var r=0;r<e;r++){var d=a.redSqr();var c=h.redSqr();var l=c.redSqr();var p=d.redAdd(d).redIAdd(d).redIAdd(i.redMul(u));var b=a.redMul(c);var v=p.redSqr().redISub(b.redAdd(b));var m=b.redISub(v);var y=p.redMul(m);y=y.redIAdd(y).redISub(l);var g=h.redMul(o);if(r+1<e)u=u.redMul(l);a=v;o=g;h=y}return this.curve.jpoint(a,h.redMul(n),o)};JPoint.prototype.dbl=function dbl(){if(this.isInfinity())return this;if(this.curve.zeroA)return this._zeroDbl();else if(this.curve.threeA)return this._threeDbl();else return this._dbl()};JPoint.prototype._zeroDbl=function _zeroDbl(){var e;var t;var r;if(this.zOne){var i=this.x.redSqr();var n=this.y.redSqr();var a=n.redSqr();var s=this.x.redAdd(n).redSqr().redISub(i).redISub(a);s=s.redIAdd(s);var o=i.redAdd(i).redIAdd(i);var u=o.redSqr().redISub(s).redISub(s);var h=a.redIAdd(a);h=h.redIAdd(h);h=h.redIAdd(h);e=u;t=o.redMul(s.redISub(u)).redISub(h);r=this.y.redAdd(this.y)}else{var d=this.x.redSqr();var c=this.y.redSqr();var l=c.redSqr();var p=this.x.redAdd(c).redSqr().redISub(d).redISub(l);p=p.redIAdd(p);var b=d.redAdd(d).redIAdd(d);var v=b.redSqr();var m=l.redIAdd(l);m=m.redIAdd(m);m=m.redIAdd(m);e=v.redISub(p).redISub(p);t=b.redMul(p.redISub(e)).redISub(m);r=this.y.redMul(this.z);r=r.redIAdd(r)}return this.curve.jpoint(e,t,r)};JPoint.prototype._threeDbl=function _threeDbl(){var e;var t;var r;if(this.zOne){var i=this.x.redSqr();var n=this.y.redSqr();var a=n.redSqr();var s=this.x.redAdd(n).redSqr().redISub(i).redISub(a);s=s.redIAdd(s);var o=i.redAdd(i).redIAdd(i).redIAdd(this.curve.a);var u=o.redSqr().redISub(s).redISub(s);e=u;var h=a.redIAdd(a);h=h.redIAdd(h);h=h.redIAdd(h);t=o.redMul(s.redISub(u)).redISub(h);r=this.y.redAdd(this.y)}else{var d=this.z.redSqr();var c=this.y.redSqr();var l=this.x.redMul(c);var p=this.x.redSub(d).redMul(this.x.redAdd(d));p=p.redAdd(p).redIAdd(p);var b=l.redIAdd(l);b=b.redIAdd(b);var v=b.redAdd(b);e=p.redSqr().redISub(v);r=this.y.redAdd(this.z).redSqr().redISub(c).redISub(d);var m=c.redSqr();m=m.redIAdd(m);m=m.redIAdd(m);m=m.redIAdd(m);t=p.redMul(b.redISub(e)).redISub(m)}return this.curve.jpoint(e,t,r)};JPoint.prototype._dbl=function _dbl(){var e=this.curve.a;var t=this.x;var r=this.y;var i=this.z;var n=i.redSqr().redSqr();var a=t.redSqr();var s=r.redSqr();var o=a.redAdd(a).redIAdd(a).redIAdd(e.redMul(n));var u=t.redAdd(t);u=u.redIAdd(u);var h=u.redMul(s);var d=o.redSqr().redISub(h.redAdd(h));var c=h.redISub(d);var l=s.redSqr();l=l.redIAdd(l);l=l.redIAdd(l);l=l.redIAdd(l);var p=o.redMul(c).redISub(l);var b=r.redAdd(r).redMul(i);return this.curve.jpoint(d,p,b)};JPoint.prototype.trpl=function trpl(){if(!this.curve.zeroA)return this.dbl().add(this);var e=this.x.redSqr();var t=this.y.redSqr();var r=this.z.redSqr();var i=t.redSqr();var n=e.redAdd(e).redIAdd(e);var a=n.redSqr();var s=this.x.redAdd(t).redSqr().redISub(e).redISub(i);s=s.redIAdd(s);s=s.redAdd(s).redIAdd(s);s=s.redISub(a);var o=s.redSqr();var u=i.redIAdd(i);u=u.redIAdd(u);u=u.redIAdd(u);u=u.redIAdd(u);var h=n.redIAdd(s).redSqr().redISub(a).redISub(o).redISub(u);var d=t.redMul(h);d=d.redIAdd(d);d=d.redIAdd(d);var c=this.x.redMul(o).redISub(d);c=c.redIAdd(c);c=c.redIAdd(c);var l=this.y.redMul(h.redMul(u.redISub(h)).redISub(s.redMul(o)));l=l.redIAdd(l);l=l.redIAdd(l);l=l.redIAdd(l);var p=this.z.redAdd(s).redSqr().redISub(r).redISub(o);return this.curve.jpoint(c,l,p)};JPoint.prototype.mul=function mul(e,t){e=new n(e,t);return this.curve._wnafMul(this,e)};JPoint.prototype.eq=function eq(e){if(e.type==="affine")return this.eq(e.toJ());if(this===e)return true;var t=this.z.redSqr();var r=e.z.redSqr();if(this.x.redMul(r).redISub(e.x.redMul(t)).cmpn(0)!==0)return false;var i=t.redMul(this.z);var n=r.redMul(e.z);return this.y.redMul(n).redISub(e.y.redMul(i)).cmpn(0)===0};JPoint.prototype.eqXToP=function eqXToP(e){var t=this.z.redSqr();var r=e.toRed(this.curve.red).redMul(t);if(this.x.cmp(r)===0)return true;var i=e.clone();var n=this.curve.redN.redMul(t);for(;;){i.iadd(this.curve.n);if(i.cmp(this.curve.p)>=0)return false;r.redIAdd(n);if(this.x.cmp(r)===0)return true}};JPoint.prototype.inspect=function inspect(){if(this.isInfinity())return"<EC JPoint Infinity>";return"<EC JPoint x: "+this.x.toString(16,2)+" y: "+this.y.toString(16,2)+" z: "+this.z.toString(16,2)+">"};JPoint.prototype.isInfinity=function isInfinity(){return this.z.cmpn(0)===0}},2998:function(e,t,r){"use strict";var i=t;var n=r(9767);var a=r(954);var s=r(8454);var o=s.assert;function PresetCurve(e){if(e.type==="short")this.curve=new a.short(e);else if(e.type==="edwards")this.curve=new a.edwards(e);else this.curve=new a.mont(e);this.g=this.curve.g;this.n=this.curve.n;this.hash=e.hash;o(this.g.validate(),"Invalid curve");o(this.g.mul(this.n).isInfinity(),"Invalid curve, G*N != O")}i.PresetCurve=PresetCurve;function defineCurve(e,t){Object.defineProperty(i,e,{configurable:true,enumerable:true,get:function(){var r=new PresetCurve(t);Object.defineProperty(i,e,{configurable:true,enumerable:true,value:r});return r}})}defineCurve("p192",{type:"short",prime:"p192",p:"ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",a:"ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",b:"64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",n:"ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",hash:n.sha256,gRed:false,g:["188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012","07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"]});defineCurve("p224",{type:"short",prime:"p224",p:"ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",a:"ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",b:"b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",n:"ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",hash:n.sha256,gRed:false,g:["b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21","bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"]});defineCurve("p256",{type:"short",prime:null,p:"ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",a:"ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",b:"5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",n:"ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",hash:n.sha256,gRed:false,g:["6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296","4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"]});defineCurve("p384",{type:"short",prime:null,p:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"fffffffe ffffffff 00000000 00000000 ffffffff",a:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"fffffffe ffffffff 00000000 00000000 fffffffc",b:"b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f "+"5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",n:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 "+"f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",hash:n.sha384,gRed:false,g:["aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 "+"5502f25d bf55296c 3a545e38 72760ab7","3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 "+"0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"]});defineCurve("p521",{type:"short",prime:null,p:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff ffffffff",a:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff ffffffff ffffffff fffffffc",b:"00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b "+"99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd "+"3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",n:"000001ff ffffffff ffffffff ffffffff ffffffff ffffffff "+"ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 "+"f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",hash:n.sha512,gRed:false,g:["000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 "+"053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 "+"a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66","00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 "+"579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 "+"3fad0761 353c7086 a272c240 88be9476 9fd16650"]});defineCurve("curve25519",{type:"mont",prime:"p25519",p:"7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",a:"76d06",b:"1",n:"1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",hash:n.sha256,gRed:false,g:["9"]});defineCurve("ed25519",{type:"edwards",prime:"p25519",p:"7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",a:"-1",c:"1",d:"52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",n:"1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",hash:n.sha256,gRed:false,g:["216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a","6666666666666666666666666666666666666666666666666666666666666658"]});var u;try{u=r(7759)}catch(e){u=undefined}defineCurve("secp256k1",{type:"short",prime:"k256",p:"ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",a:"0",b:"7",n:"ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",h:"1",hash:n.sha256,beta:"7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",lambda:"5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",basis:[{a:"3086d221a7d46bcde86c90e49284eb15",b:"-e4437ed6010e88286f547fa90abfe4c3"},{a:"114ca50f7a8e2f3f657c1108d9d44cfd8",b:"3086d221a7d46bcde86c90e49284eb15"}],gRed:false,g:["79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798","483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",u]})},2081:function(e,t,r){"use strict";var i=r(6884);var n=r(8242);var a=r(8454);var s=r(2998);var o=r(6069);var u=a.assert;var h=r(7044);var d=r(8020);function EC(e){if(!(this instanceof EC))return new EC(e);if(typeof e==="string"){u(s.hasOwnProperty(e),"Unknown curve "+e);e=s[e]}if(e instanceof s.PresetCurve)e={curve:e};this.curve=e.curve.curve;this.n=this.curve.n;this.nh=this.n.ushrn(1);this.g=this.curve.g;this.g=e.curve.g;this.g.precompute(e.curve.n.bitLength()+1);this.hash=e.hash||e.curve.hash}e.exports=EC;EC.prototype.keyPair=function keyPair(e){return new h(this,e)};EC.prototype.keyFromPrivate=function keyFromPrivate(e,t){return h.fromPrivate(this,e,t)};EC.prototype.keyFromPublic=function keyFromPublic(e,t){return h.fromPublic(this,e,t)};EC.prototype.genKeyPair=function genKeyPair(e){if(!e)e={};var t=new n({hash:this.hash,pers:e.pers,persEnc:e.persEnc||"utf8",entropy:e.entropy||o(this.hash.hmacStrength),entropyEnc:e.entropy&&e.entropyEnc||"utf8",nonce:this.n.toArray()});var r=this.n.byteLength();var a=this.n.sub(new i(2));do{var s=new i(t.generate(r));if(s.cmp(a)>0)continue;s.iaddn(1);return this.keyFromPrivate(s)}while(true)};EC.prototype._truncateToN=function truncateToN(e,t){var r=e.byteLength()*8-this.n.bitLength();if(r>0)e=e.ushrn(r);if(!t&&e.cmp(this.n)>=0)return e.sub(this.n);else return e};EC.prototype.sign=function sign(e,t,r,a){if(typeof r==="object"){a=r;r=null}if(!a)a={};t=this.keyFromPrivate(t,r);e=this._truncateToN(new i(e,16));var s=this.n.byteLength();var o=t.getPrivate().toArray("be",s);var u=e.toArray("be",s);var h=new n({hash:this.hash,entropy:o,nonce:u,pers:a.pers,persEnc:a.persEnc||"utf8"});var c=this.n.sub(new i(1));for(var l=0;true;l++){var p=a.k?a.k(l):new i(h.generate(this.n.byteLength()));p=this._truncateToN(p,true);if(p.cmpn(1)<=0||p.cmp(c)>=0)continue;var b=this.g.mul(p);if(b.isInfinity())continue;var v=b.getX();var m=v.umod(this.n);if(m.cmpn(0)===0)continue;var y=p.invm(this.n).mul(m.mul(t.getPrivate()).iadd(e));y=y.umod(this.n);if(y.cmpn(0)===0)continue;var g=(b.getY().isOdd()?1:0)|(v.cmp(m)!==0?2:0);if(a.canonical&&y.cmp(this.nh)>0){y=this.n.sub(y);g^=1}return new d({r:m,s:y,recoveryParam:g})}};EC.prototype.verify=function verify(e,t,r,n){e=this._truncateToN(new i(e,16));r=this.keyFromPublic(r,n);t=new d(t,"hex");var a=t.r;var s=t.s;if(a.cmpn(1)<0||a.cmp(this.n)>=0)return false;if(s.cmpn(1)<0||s.cmp(this.n)>=0)return false;var o=s.invm(this.n);var u=o.mul(e).umod(this.n);var h=o.mul(a).umod(this.n);if(!this.curve._maxwellTrick){var c=this.g.mulAdd(u,r.getPublic(),h);if(c.isInfinity())return false;return c.getX().umod(this.n).cmp(a)===0}var c=this.g.jmulAdd(u,r.getPublic(),h);if(c.isInfinity())return false;return c.eqXToP(a)};EC.prototype.recoverPubKey=function(e,t,r,n){u((3&r)===r,"The recovery param is more than two bits");t=new d(t,n);var a=this.n;var s=new i(e);var o=t.r;var h=t.s;var c=r&1;var l=r>>1;if(o.cmp(this.curve.p.umod(this.curve.n))>=0&&l)throw new Error("Unable to find sencond key candinate");if(l)o=this.curve.pointFromX(o.add(this.curve.n),c);else o=this.curve.pointFromX(o,c);var p=t.r.invm(a);var b=a.sub(s).mul(p).umod(a);var v=h.mul(p).umod(a);return this.g.mulAdd(b,o,v)};EC.prototype.getKeyRecoveryParam=function(e,t,r,i){t=new d(t,i);if(t.recoveryParam!==null)return t.recoveryParam;for(var n=0;n<4;n++){var a;try{a=this.recoverPubKey(e,t,n)}catch(e){continue}if(a.eq(r))return n}throw new Error("Unable to find valid recovery factor")}},7044:function(e,t,r){"use strict";var i=r(6884);var n=r(8454);var a=n.assert;function KeyPair(e,t){this.ec=e;this.priv=null;this.pub=null;if(t.priv)this._importPrivate(t.priv,t.privEnc);if(t.pub)this._importPublic(t.pub,t.pubEnc)}e.exports=KeyPair;KeyPair.fromPublic=function fromPublic(e,t,r){if(t instanceof KeyPair)return t;return new KeyPair(e,{pub:t,pubEnc:r})};KeyPair.fromPrivate=function fromPrivate(e,t,r){if(t instanceof KeyPair)return t;return new KeyPair(e,{priv:t,privEnc:r})};KeyPair.prototype.validate=function validate(){var e=this.getPublic();if(e.isInfinity())return{result:false,reason:"Invalid public key"};if(!e.validate())return{result:false,reason:"Public key is not a point"};if(!e.mul(this.ec.curve.n).isInfinity())return{result:false,reason:"Public key * N != O"};return{result:true,reason:null}};KeyPair.prototype.getPublic=function getPublic(e,t){if(typeof e==="string"){t=e;e=null}if(!this.pub)this.pub=this.ec.g.mul(this.priv);if(!t)return this.pub;return this.pub.encode(t,e)};KeyPair.prototype.getPrivate=function getPrivate(e){if(e==="hex")return this.priv.toString(16,2);else return this.priv};KeyPair.prototype._importPrivate=function _importPrivate(e,t){this.priv=new i(e,t||16);this.priv=this.priv.umod(this.ec.curve.n)};KeyPair.prototype._importPublic=function _importPublic(e,t){if(e.x||e.y){if(this.ec.curve.type==="mont"){a(e.x,"Need x coordinate")}else if(this.ec.curve.type==="short"||this.ec.curve.type==="edwards"){a(e.x&&e.y,"Need both x and y coordinate")}this.pub=this.ec.curve.point(e.x,e.y);return}this.pub=this.ec.curve.decodePoint(e,t)};KeyPair.prototype.derive=function derive(e){return e.mul(this.priv).getX()};KeyPair.prototype.sign=function sign(e,t,r){return this.ec.sign(e,this,t,r)};KeyPair.prototype.verify=function verify(e,t){return this.ec.verify(e,t,this)};KeyPair.prototype.inspect=function inspect(){return"<Key priv: "+(this.priv&&this.priv.toString(16,2))+" pub: "+(this.pub&&this.pub.inspect())+" >"}},8020:function(e,t,r){"use strict";var i=r(6884);var n=r(8454);var a=n.assert;function Signature(e,t){if(e instanceof Signature)return e;if(this._importDER(e,t))return;a(e.r&&e.s,"Signature without r or s");this.r=new i(e.r,16);this.s=new i(e.s,16);if(e.recoveryParam===undefined)this.recoveryParam=null;else this.recoveryParam=e.recoveryParam}e.exports=Signature;function Position(){this.place=0}function getLength(e,t){var r=e[t.place++];if(!(r&128)){return r}var i=r&15;if(i===0||i>4){return false}var n=0;for(var a=0,s=t.place;a<i;a++,s++){n<<=8;n|=e[s];n>>>=0}if(n<=127){return false}t.place=s;return n}function rmPadding(e){var t=0;var r=e.length-1;while(!e[t]&&!(e[t+1]&128)&&t<r){t++}if(t===0){return e}return e.slice(t)}Signature.prototype._importDER=function _importDER(e,t){e=n.toArray(e,t);var r=new Position;if(e[r.place++]!==48){return false}var a=getLength(e,r);if(a===false){return false}if(a+r.place!==e.length){return false}if(e[r.place++]!==2){return false}var s=getLength(e,r);if(s===false){return false}var o=e.slice(r.place,s+r.place);r.place+=s;if(e[r.place++]!==2){return false}var u=getLength(e,r);if(u===false){return false}if(e.length!==u+r.place){return false}var h=e.slice(r.place,u+r.place);if(o[0]===0){if(o[1]&128){o=o.slice(1)}else{return false}}if(h[0]===0){if(h[1]&128){h=h.slice(1)}else{return false}}this.r=new i(o);this.s=new i(h);this.recoveryParam=null;return true};function constructLength(e,t){if(t<128){e.push(t);return}var r=1+(Math.log(t)/Math.LN2>>>3);e.push(r|128);while(--r){e.push(t>>>(r<<3)&255)}e.push(t)}Signature.prototype.toDER=function toDER(e){var t=this.r.toArray();var r=this.s.toArray();if(t[0]&128)t=[0].concat(t);if(r[0]&128)r=[0].concat(r);t=rmPadding(t);r=rmPadding(r);while(!r[0]&&!(r[1]&128)){r=r.slice(1)}var i=[2];constructLength(i,t.length);i=i.concat(t);i.push(2);constructLength(i,r.length);var a=i.concat(r);var s=[48];constructLength(s,a.length);s=s.concat(a);return n.encode(s,e)}},2298:function(e,t,r){"use strict";var i=r(9767);var n=r(2998);var a=r(8454);var s=a.assert;var o=a.parseBytes;var u=r(9285);var h=r(3883);function EDDSA(e){s(e==="ed25519","only tested with ed25519 so far");if(!(this instanceof EDDSA))return new EDDSA(e);var e=n[e].curve;this.curve=e;this.g=e.g;this.g.precompute(e.n.bitLength()+1);this.pointClass=e.point().constructor;this.encodingLength=Math.ceil(e.n.bitLength()/8);this.hash=i.sha512}e.exports=EDDSA;EDDSA.prototype.sign=function sign(e,t){e=o(e);var r=this.keyFromSecret(t);var i=this.hashInt(r.messagePrefix(),e);var n=this.g.mul(i);var a=this.encodePoint(n);var s=this.hashInt(a,r.pubBytes(),e).mul(r.priv());var u=i.add(s).umod(this.curve.n);return this.makeSignature({R:n,S:u,Rencoded:a})};EDDSA.prototype.verify=function verify(e,t,r){e=o(e);t=this.makeSignature(t);var i=this.keyFromPublic(r);var n=this.hashInt(t.Rencoded(),i.pubBytes(),e);var a=this.g.mul(t.S());var s=t.R().add(i.pub().mul(n));return s.eq(a)};EDDSA.prototype.hashInt=function hashInt(){var e=this.hash();for(var t=0;t<arguments.length;t++)e.update(arguments[t]);return a.intFromLE(e.digest()).umod(this.curve.n)};EDDSA.prototype.keyFromPublic=function keyFromPublic(e){return u.fromPublic(this,e)};EDDSA.prototype.keyFromSecret=function keyFromSecret(e){return u.fromSecret(this,e)};EDDSA.prototype.makeSignature=function makeSignature(e){if(e instanceof h)return e;return new h(this,e)};EDDSA.prototype.encodePoint=function encodePoint(e){var t=e.getY().toArray("le",this.encodingLength);t[this.encodingLength-1]|=e.getX().isOdd()?128:0;return t};EDDSA.prototype.decodePoint=function decodePoint(e){e=a.parseBytes(e);var t=e.length-1;var r=e.slice(0,t).concat(e[t]&~128);var i=(e[t]&128)!==0;var n=a.intFromLE(r);return this.curve.pointFromY(n,i)};EDDSA.prototype.encodeInt=function encodeInt(e){return e.toArray("le",this.encodingLength)};EDDSA.prototype.decodeInt=function decodeInt(e){return a.intFromLE(e)};EDDSA.prototype.isPoint=function isPoint(e){return e instanceof this.pointClass}},9285:function(e,t,r){"use strict";var i=r(8454);var n=i.assert;var a=i.parseBytes;var s=i.cachedProperty;function KeyPair(e,t){this.eddsa=e;this._secret=a(t.secret);if(e.isPoint(t.pub))this._pub=t.pub;else this._pubBytes=a(t.pub)}KeyPair.fromPublic=function fromPublic(e,t){if(t instanceof KeyPair)return t;return new KeyPair(e,{pub:t})};KeyPair.fromSecret=function fromSecret(e,t){if(t instanceof KeyPair)return t;return new KeyPair(e,{secret:t})};KeyPair.prototype.secret=function secret(){return this._secret};s(KeyPair,"pubBytes",(function pubBytes(){return this.eddsa.encodePoint(this.pub())}));s(KeyPair,"pub",(function pub(){if(this._pubBytes)return this.eddsa.decodePoint(this._pubBytes);return this.eddsa.g.mul(this.priv())}));s(KeyPair,"privBytes",(function privBytes(){var e=this.eddsa;var t=this.hash();var r=e.encodingLength-1;var i=t.slice(0,e.encodingLength);i[0]&=248;i[r]&=127;i[r]|=64;return i}));s(KeyPair,"priv",(function priv(){return this.eddsa.decodeInt(this.privBytes())}));s(KeyPair,"hash",(function hash(){return this.eddsa.hash().update(this.secret()).digest()}));s(KeyPair,"messagePrefix",(function messagePrefix(){return this.hash().slice(this.eddsa.encodingLength)}));KeyPair.prototype.sign=function sign(e){n(this._secret,"KeyPair can only verify");return this.eddsa.sign(e,this)};KeyPair.prototype.verify=function verify(e,t){return this.eddsa.verify(e,t,this)};KeyPair.prototype.getSecret=function getSecret(e){n(this._secret,"KeyPair is public only");return i.encode(this.secret(),e)};KeyPair.prototype.getPublic=function getPublic(e){return i.encode(this.pubBytes(),e)};e.exports=KeyPair},3883:function(e,t,r){"use strict";var i=r(6884);var n=r(8454);var a=n.assert;var s=n.cachedProperty;var o=n.parseBytes;function Signature(e,t){this.eddsa=e;if(typeof t!=="object")t=o(t);if(Array.isArray(t)){t={R:t.slice(0,e.encodingLength),S:t.slice(e.encodingLength)}}a(t.R&&t.S,"Signature without R or S");if(e.isPoint(t.R))this._R=t.R;if(t.S instanceof i)this._S=t.S;this._Rencoded=Array.isArray(t.R)?t.R:t.Rencoded;this._Sencoded=Array.isArray(t.S)?t.S:t.Sencoded}s(Signature,"S",(function S(){return this.eddsa.decodeInt(this.Sencoded())}));s(Signature,"R",(function R(){return this.eddsa.decodePoint(this.Rencoded())}));s(Signature,"Rencoded",(function Rencoded(){return this.eddsa.encodePoint(this.R())}));s(Signature,"Sencoded",(function Sencoded(){return this.eddsa.encodeInt(this.S())}));Signature.prototype.toBytes=function toBytes(){return this.Rencoded().concat(this.Sencoded())};Signature.prototype.toHex=function toHex(){return n.encode(this.toBytes(),"hex").toUpperCase()};e.exports=Signature},7759:function(e){e.exports={doubles:{step:4,points:[["e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a","f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"],["8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508","11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"],["175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739","d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"],["363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640","4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"],["8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c","4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"],["723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda","96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"],["eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa","5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"],["100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0","cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"],["e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d","9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"],["feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d","e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"],["da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1","9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"],["53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0","5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"],["8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047","10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"],["385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862","283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"],["6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7","7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"],["3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd","56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"],["85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83","7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"],["948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a","53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"],["6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8","bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"],["e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d","4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"],["e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725","7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"],["213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754","4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"],["4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c","17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"],["fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6","6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"],["76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39","c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"],["c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891","893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"],["d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b","febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"],["b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03","2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"],["e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d","eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"],["a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070","7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"],["90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4","e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"],["8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da","662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"],["e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11","1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"],["8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e","efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"],["e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41","2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"],["b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef","67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"],["d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8","db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"],["324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d","648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"],["4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96","35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"],["9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd","ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"],["6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5","9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"],["a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266","40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"],["7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71","34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"],["928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac","c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"],["85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751","1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"],["ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e","493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"],["827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241","c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"],["eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3","be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"],["e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f","4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"],["1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19","aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"],["146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be","b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"],["fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9","6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"],["da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2","8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"],["a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13","7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"],["174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c","ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"],["959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba","2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"],["d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151","e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"],["64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073","d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"],["8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458","38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"],["13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b","69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"],["bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366","d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"],["8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa","40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"],["8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0","620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"],["dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787","7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"],["f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e","ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"]]},naf:{wnd:7,points:[["f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9","388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"],["2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4","d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"],["5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc","6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"],["acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe","cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"],["774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb","d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"],["f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8","ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"],["d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e","581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"],["defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34","4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"],["2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c","85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"],["352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5","321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"],["2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f","2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"],["9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714","73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"],["daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729","a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"],["c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db","2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"],["6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4","e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"],["1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5","b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"],["605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479","2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"],["62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d","80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"],["80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f","1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"],["7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb","d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"],["d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9","eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"],["49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963","758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"],["77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74","958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"],["f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530","e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"],["463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b","5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"],["f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247","cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"],["caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1","cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"],["2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120","4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"],["7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435","91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"],["754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18","673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"],["e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8","59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"],["186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb","3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"],["df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f","55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"],["5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143","efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"],["290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba","e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"],["af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45","f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"],["766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a","744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"],["59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e","c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"],["f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8","e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"],["7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c","30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"],["948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519","e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"],["7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab","100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"],["3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca","ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"],["d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf","8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"],["1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610","68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"],["733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4","f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"],["15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c","d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"],["a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940","edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"],["e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980","a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"],["311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3","66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"],["34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf","9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"],["f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63","4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"],["d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448","fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"],["32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf","5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"],["7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5","8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"],["ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6","8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"],["16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5","5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"],["eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99","f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"],["78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51","f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"],["494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5","42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"],["a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5","204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"],["c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997","4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"],["841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881","73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"],["5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5","39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"],["36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66","d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"],["336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726","ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"],["8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede","6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"],["1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94","60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"],["85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31","3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"],["29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51","b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"],["a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252","ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"],["4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5","cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"],["d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b","6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"],["ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4","322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"],["af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f","6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"],["e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889","2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"],["591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246","b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"],["11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984","998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"],["3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a","b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"],["cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030","bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"],["c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197","6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"],["c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593","c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"],["a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef","21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"],["347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38","60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"],["da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a","49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"],["c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111","5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"],["4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502","7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"],["3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea","be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"],["cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26","8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"],["b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986","39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"],["d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e","62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"],["48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4","25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"],["dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda","ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"],["6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859","cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"],["e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f","f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"],["eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c","6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"],["13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942","fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"],["ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a","1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"],["b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80","5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"],["ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d","438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"],["8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1","cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"],["52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63","c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"],["e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352","6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"],["7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193","ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"],["5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00","9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"],["32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58","ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"],["e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7","d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"],["8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8","c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"],["4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e","67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"],["3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d","cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"],["674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b","299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"],["d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f","f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"],["30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6","462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"],["be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297","62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"],["93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a","7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"],["b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c","ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"],["d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52","4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"],["d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb","bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"],["463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065","bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"],["7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917","603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"],["74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9","cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"],["30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3","553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"],["9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57","712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"],["176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66","ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"],["75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8","9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"],["809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721","9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"],["1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180","4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"]]}}},8454:function(e,t,r){"use strict";var i=t;var n=r(6884);var a=r(9036);var s=r(6249);i.assert=a;i.toArray=s.toArray;i.zero2=s.zero2;i.toHex=s.toHex;i.encode=s.encode;function getNAF(e,t,r){var i=new Array(Math.max(e.bitLength(),r)+1);i.fill(0);var n=1<<t+1;var a=e.clone();for(var s=0;s<i.length;s++){var o;var u=a.andln(n-1);if(a.isOdd()){if(u>(n>>1)-1)o=(n>>1)-u;else o=u;a.isubn(o)}else{o=0}i[s]=o;a.iushrn(1)}return i}i.getNAF=getNAF;function getJSF(e,t){var r=[[],[]];e=e.clone();t=t.clone();var i=0;var n=0;while(e.cmpn(-i)>0||t.cmpn(-n)>0){var a=e.andln(3)+i&3;var s=t.andln(3)+n&3;if(a===3)a=-1;if(s===3)s=-1;var o;if((a&1)===0){o=0}else{var u=e.andln(7)+i&7;if((u===3||u===5)&&s===2)o=-a;else o=a}r[0].push(o);var h;if((s&1)===0){h=0}else{var u=t.andln(7)+n&7;if((u===3||u===5)&&a===2)h=-s;else h=s}r[1].push(h);if(2*i===o+1)i=1-i;if(2*n===h+1)n=1-n;e.iushrn(1);t.iushrn(1)}return r}i.getJSF=getJSF;function cachedProperty(e,t,r){var i="_"+t;e.prototype[t]=function cachedProperty(){return this[i]!==undefined?this[i]:this[i]=r.call(this)}}i.cachedProperty=cachedProperty;function parseBytes(e){return typeof e==="string"?i.toArray(e,"hex"):e}i.parseBytes=parseBytes;function intFromLE(e){return new n(e,"hex","le")}i.intFromLE=intFromLE},7325:function(e,t,r){var i=r(3118).Buffer;var n=r(4125);function EVP_BytesToKey(e,t,r,a){if(!i.isBuffer(e))e=i.from(e,"binary");if(t){if(!i.isBuffer(t))t=i.from(t,"binary");if(t.length!==8)throw new RangeError("salt should be Buffer with 8 byte length")}var s=r/8;var o=i.alloc(s);var u=i.alloc(a||0);var h=i.alloc(0);while(s>0||a>0){var d=new n;d.update(h);d.update(e);if(t)d.update(t);h=d.digest();var c=0;if(s>0){var l=o.length-s;c=Math.min(s,h.length);h.copy(o,l,0,c);s-=c}if(c<h.length&&a>0){var p=u.length-a;var b=Math.min(a,h.length-c);h.copy(u,p,c,c+b);a-=b}}h.fill(0);return{key:o,iv:u}}e.exports=EVP_BytesToKey},3421:function(e,t,r){"use strict";var i=r(3118).Buffer;var n=r(5098).Transform;var a=r(7526);function throwIfNotStringOrBuffer(e,t){if(!i.isBuffer(e)&&typeof e!=="string"){throw new TypeError(t+" must be a string or a buffer")}}function HashBase(e){n.call(this);this._block=i.allocUnsafe(e);this._blockSize=e;this._blockOffset=0;this._length=[0,0,0,0];this._finalized=false}a(HashBase,n);HashBase.prototype._transform=function(e,t,r){var i=null;try{this.update(e,t)}catch(e){i=e}r(i)};HashBase.prototype._flush=function(e){var t=null;try{this.push(this.digest())}catch(e){t=e}e(t)};HashBase.prototype.update=function(e,t){throwIfNotStringOrBuffer(e,"Data");if(this._finalized)throw new Error("Digest already called");if(!i.isBuffer(e))e=i.from(e,t);var r=this._block;var n=0;while(this._blockOffset+e.length-n>=this._blockSize){for(var a=this._blockOffset;a<this._blockSize;)r[a++]=e[n++];this._update();this._blockOffset=0}while(n<e.length)r[this._blockOffset++]=e[n++];for(var s=0,o=e.length*8;o>0;++s){this._length[s]+=o;o=this._length[s]/4294967296|0;if(o>0)this._length[s]-=4294967296*o}return this};HashBase.prototype._update=function(){throw new Error("_update is not implemented")};HashBase.prototype.digest=function(e){if(this._finalized)throw new Error("Digest already called");this._finalized=true;var t=this._digest();if(e!==undefined)t=t.toString(e);this._block.fill(0);this._blockOffset=0;for(var r=0;r<4;++r)this._length[r]=0;return t};HashBase.prototype._digest=function(){throw new Error("_digest is not implemented")};e.exports=HashBase},519:function(e){"use strict";const t={};function createErrorType(e,r,i){if(!i){i=Error}function getMessage(e,t,i){if(typeof r==="string"){return r}else{return r(e,t,i)}}class NodeError extends i{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=i.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let i;if(typeof t==="string"&&startsWith(t,"not ")){i="must not be";t=t.replace(/^not /,"")}else{i="must be"}let n;if(endsWith(e," argument")){n=`The ${e} ${i} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";n=`The "${e}" ${r} ${i} ${oneOf(t,"type")}`}n+=`. Received type ${typeof r}`;return n}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},5077:function(e,t,r){"use strict";var i=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var n=r(279);var a=r(3582);r(7526)(Duplex,n);{var s=i(a.prototype);for(var o=0;o<s.length;o++){var u=s[o];if(!Duplex.prototype[u])Duplex.prototype[u]=a.prototype[u]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);n.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},3880:function(e,t,r){"use strict";e.exports=PassThrough;var i=r(6821);r(7526)(PassThrough,i);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);i.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},279:function(e,t,r){"use strict";e.exports=Readable;var i;Readable.ReadableState=ReadableState;var n=r(2361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var s=r(3917);var o=r(4300).Buffer;var u=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof u}var h=r(3837);var d;if(h&&h.debuglog){d=h.debuglog("stream")}else{d=function debug(){}}var c=r(5206);var l=r(8956);var p=r(4292),b=p.getHighWaterMark;var v=r(519).q,m=v.ERR_INVALID_ARG_TYPE,y=v.ERR_STREAM_PUSH_AFTER_EOF,g=v.ERR_METHOD_NOT_IMPLEMENTED,_=v.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var w;var M;var E;r(7526)(Readable,s);var B=l.errorOrDestroy;var k=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,n){i=i||r(5077);e=e||{};if(typeof n!=="boolean")n=t instanceof i;this.objectMode=!!e.objectMode;if(n)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=b(this,e,"readableHighWaterMark",n);this.buffer=new c;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!w)w=r(9573).s;this.decoder=new w(e.encoding);this.encoding=e.encoding}}function Readable(e){i=i||r(5077);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof i;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}s.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=l.destroy;Readable.prototype._undestroy=l.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var i;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=o.from(e,t);t=""}i=true}}else{i=true}return readableAddChunk(this,e,t,false,i)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,i,n){d("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var s;if(!n)s=chunkInvalid(a,t);if(s){B(e,s)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==o.prototype){t=_uint8ArrayToBuffer(t)}if(i){if(a.endEmitted)B(e,new _);else addChunk(e,a,t,true)}else if(a.ended){B(e,new y)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!i){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,i){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(i)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new m("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!w)w=r(9573).s;var t=new w(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var i=this._readableState.buffer.head;var n="";while(i!==null){n+=t.write(i.data);i=i.next}this._readableState.buffer.clear();if(n!=="")this._readableState.buffer.push(n);this._readableState.length=n.length;return this};var A=1073741824;function computeNewHighWaterMark(e){if(e>=A){e=A}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){d("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){d("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var i=t.needReadable;d("need readable",i);if(t.length===0||t.length-e<t.highWaterMark){i=true;d("length less than watermark",i)}if(t.ended||t.reading){i=false;d("reading or ended",i)}else if(i){d("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var n;if(e>0)n=fromList(e,t);else n=null;if(n===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(n!==null)this.emit("data",n);return n};function onEofChunk(e,t){d("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;d("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){d("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;d("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;d("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){B(this,new g("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var i=this._readableState;switch(i.pipesCount){case 0:i.pipes=e;break;case 1:i.pipes=[i.pipes,e];break;default:i.pipes.push(e);break}i.pipesCount+=1;d("pipe count=%d opts=%j",i.pipesCount,t);var n=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var s=n?onend:unpipe;if(i.endEmitted)process.nextTick(s);else r.once("end",s);e.on("unpipe",onunpipe);function onunpipe(e,t){d("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){d("onend");e.end()}var o=pipeOnDrain(r);e.on("drain",o);var u=false;function cleanup(){d("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",o);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);u=true;if(i.awaitDrain&&(!e._writableState||e._writableState.needDrain))o()}r.on("data",ondata);function ondata(t){d("ondata");var n=e.write(t);d("dest.write",n);if(n===false){if((i.pipesCount===1&&i.pipes===e||i.pipesCount>1&&indexOf(i.pipes,e)!==-1)&&!u){d("false write response, pause",i.awaitDrain);i.awaitDrain++}r.pause()}}function onerror(t){d("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)B(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){d("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){d("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!i.flowing){d("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;d("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var i=t.pipes;var n=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<n;a++){i[a].emit("unpipe",this,{hasUnpiped:false})}return this}var s=indexOf(t.pipes,e);if(s===-1)return this;t.pipes.splice(s,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=s.prototype.on.call(this,e,t);var i=this._readableState;if(e==="data"){i.readableListening=this.listenerCount("readable")>0;if(i.flowing!==false)this.resume()}else if(e==="readable"){if(!i.endEmitted&&!i.readableListening){i.readableListening=i.needReadable=true;i.flowing=false;i.emittedReadable=false;d("on readable",i.length,i.reading);if(i.length){emitReadable(this)}else if(!i.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=s.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=s.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){d("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){d("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){d("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){d("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){d("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;d("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var i=false;e.on("end",(function(){d("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(n){d("wrapped data");if(r.decoder)n=r.decoder.write(n);if(r.objectMode&&(n===null||n===undefined))return;else if(!r.objectMode&&(!n||!n.length))return;var a=t.push(n);if(!a){i=true;e.pause()}}));for(var n in e){if(this[n]===undefined&&typeof e[n]==="function"){this[n]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(n)}}for(var a=0;a<k.length;a++){e.on(k[a],this.emit.bind(this,k[a]))}this._read=function(t){d("wrapped _read",t);if(i){i=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(M===undefined){M=r(1439)}return M(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;d("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){d("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(E===undefined){E=r(1514)}return E(Readable,e,t)}}function indexOf(e,t){for(var r=0,i=e.length;r<i;r++){if(e[r]===t)return r}return-1}},6821:function(e,t,r){"use strict";e.exports=Transform;var i=r(519).q,n=i.ERR_METHOD_NOT_IMPLEMENTED,a=i.ERR_MULTIPLE_CALLBACK,s=i.ERR_TRANSFORM_ALREADY_TRANSFORMING,o=i.ERR_TRANSFORM_WITH_LENGTH_0;var u=r(5077);r(7526)(Transform,u);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var i=r.writecb;if(i===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);i(e);var n=this._readableState;n.reading=false;if(n.needReadable||n.length<n.highWaterMark){this._read(n.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);u.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return u.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new n("_transform()"))};Transform.prototype._write=function(e,t,r){var i=this._transformState;i.writecb=r;i.writechunk=e;i.writeencoding=t;if(!i.transforming){var n=this._readableState;if(i.needTransform||n.needReadable||n.length<n.highWaterMark)this._read(n.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){u.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new o;if(e._transformState.transforming)throw new s;return e.push(null)}},3582:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var i;Writable.WritableState=WritableState;var n={deprecate:r(5121)};var a=r(3917);var s=r(4300).Buffer;var o=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof o}var u=r(8956);var h=r(4292),d=h.getHighWaterMark;var c=r(519).q,l=c.ERR_INVALID_ARG_TYPE,p=c.ERR_METHOD_NOT_IMPLEMENTED,b=c.ERR_MULTIPLE_CALLBACK,v=c.ERR_STREAM_CANNOT_PIPE,m=c.ERR_STREAM_DESTROYED,y=c.ERR_STREAM_NULL_VALUES,g=c.ERR_STREAM_WRITE_AFTER_END,_=c.ERR_UNKNOWN_ENCODING;var w=u.errorOrDestroy;r(7526)(Writable,a);function nop(){}function WritableState(e,t,n){i=i||r(5077);e=e||{};if(typeof n!=="boolean")n=t instanceof i;this.objectMode=!!e.objectMode;if(n)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=d(this,e,"writableHighWaterMark",n);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:n.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var M;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){M=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(M.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{M=function realHasInstance(e){return e instanceof this}}function Writable(e){i=i||r(5077);var t=this instanceof i;if(!t&&!M.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){w(this,new v)};function writeAfterEnd(e,t){var r=new g;w(e,r);process.nextTick(t,r)}function validChunk(e,t,r,i){var n;if(r===null){n=new y}else if(typeof r!=="string"&&!t.objectMode){n=new l("chunk",["string","Buffer"],r)}if(n){w(e,n);process.nextTick(i,n);return false}return true}Writable.prototype.write=function(e,t,r){var i=this._writableState;var n=false;var a=!i.objectMode&&_isUint8Array(e);if(a&&!s.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=i.defaultEncoding;if(typeof r!=="function")r=nop;if(i.ending)writeAfterEnd(this,r);else if(a||validChunk(this,i,e,r)){i.pendingcb++;n=writeOrBuffer(this,i,a,e,t,r)}return n};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new _(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=s.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,i,n,a){if(!r){var s=decodeChunk(t,i,n);if(i!==s){r=true;n="buffer";i=s}}var o=t.objectMode?1:i.length;t.length+=o;var u=t.length<t.highWaterMark;if(!u)t.needDrain=true;if(t.writing||t.corked){var h=t.lastBufferedRequest;t.lastBufferedRequest={chunk:i,encoding:n,isBuf:r,callback:a,next:null};if(h){h.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,o,i,n,a)}return u}function doWrite(e,t,r,i,n,a,s){t.writelen=i;t.writecb=s;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new m("write"));else if(r)e._writev(n,t.onwrite);else e._write(n,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,i,n){--t.pendingcb;if(r){process.nextTick(n,i);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;w(e,i)}else{n(i);e._writableState.errorEmitted=true;w(e,i);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var i=r.sync;var n=r.writecb;if(typeof n!=="function")throw new b;onwriteStateUpdate(r);if(t)onwriteError(e,r,i,t,n);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(i){process.nextTick(afterWrite,e,r,a,n)}else{afterWrite(e,r,a,n)}}}function afterWrite(e,t,r,i){if(!r)onwriteDrain(e,t);t.pendingcb--;i();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var i=t.bufferedRequestCount;var n=new Array(i);var a=t.corkedRequestsFree;a.entry=r;var s=0;var o=true;while(r){n[s]=r;if(!r.isBuf)o=false;r=r.next;s+=1}n.allBuffers=o;doWrite(e,t,true,t.length,n,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var u=r.chunk;var h=r.encoding;var d=r.callback;var c=t.objectMode?1:u.length;doWrite(e,t,false,c,u,h,d);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new p("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var i=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(i.corked){i.corked=1;this.uncork()}if(!i.ending)endWritable(this,i,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){w(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var i=e._readableState;if(!i||i.autoDestroy&&i.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var i=e.entry;e.entry=null;while(i){var n=i.callback;t.pendingcb--;n(r);i=i.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=u.destroy;Writable.prototype._undestroy=u.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},1439:function(e,t,r){"use strict";var i;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(9830);var a=Symbol("lastResolve");var s=Symbol("lastReject");var o=Symbol("error");var u=Symbol("ended");var h=Symbol("lastPromise");var d=Symbol("handlePromise");var c=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[c].read();if(r!==null){e[h]=null;e[a]=null;e[s]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,i){e.then((function(){if(t[u]){r(createIterResult(undefined,true));return}t[d](r,i)}),i)}}var l=Object.getPrototypeOf((function(){}));var p=Object.setPrototypeOf((i={get stream(){return this[c]},next:function next(){var e=this;var t=this[o];if(t!==null){return Promise.reject(t)}if(this[u]){return Promise.resolve(createIterResult(undefined,true))}if(this[c].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[o]){r(e[o])}else{t(createIterResult(undefined,true))}}))}))}var r=this[h];var i;if(r){i=new Promise(wrapForNext(r,this))}else{var n=this[c].read();if(n!==null){return Promise.resolve(createIterResult(n,false))}i=new Promise(this[d])}this[h]=i;return i}},_defineProperty(i,Symbol.asyncIterator,(function(){return this})),_defineProperty(i,"return",(function _return(){var e=this;return new Promise((function(t,r){e[c].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),i),l);var b=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(p,(t={},_defineProperty(t,c,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,u,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,d,{value:function value(e,t){var i=r[c].read();if(i){r[h]=null;r[a]=null;r[s]=null;e(createIterResult(i,false))}else{r[a]=e;r[s]=t}},writable:true}),t));r[h]=null;n(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[s];if(t!==null){r[h]=null;r[a]=null;r[s]=null;t(e)}r[o]=e;return}var i=r[a];if(i!==null){r[h]=null;r[a]=null;r[s]=null;i(createIterResult(undefined,true))}r[u]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=b},5206:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);if(t)i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,i)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var i=t[r];i.enumerable=i.enumerable||false;i.configurable=true;if("value"in i)i.writable=true;Object.defineProperty(e,i.key,i)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var i=r(4300),n=i.Buffer;var a=r(3837),s=a.inspect;var o=s&&s.custom||"inspect";function copyBuffer(e,t,r){n.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return n.alloc(0);var t=n.allocUnsafe(e>>>0);var r=this.head;var i=0;while(r){copyBuffer(r.data,t,i);i+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var i=t.data;e-=i.length;while(t=t.next){var n=t.data;var a=e>n.length?n.length:e;if(a===n.length)i+=n;else i+=n.slice(0,e);e-=a;if(e===0){if(a===n.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=n.slice(a)}break}++r}this.length-=r;return i}},{key:"_getBuffer",value:function _getBuffer(e){var t=n.allocUnsafe(e);var r=this.head;var i=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var s=e>a.length?a.length:e;a.copy(t,t.length-e,0,s);e-=s;if(e===0){if(s===a.length){++i;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(s)}break}++i}this.length-=i;return t}},{key:o,value:function value(e,t){return s(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},8956:function(e){"use strict";function destroy(e,t){var r=this;var i=this._readableState&&this._readableState.destroyed;var n=this._writableState&&this._writableState.destroyed;if(i||n){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var i=e._writableState;if(r&&r.autoDestroy||i&&i.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},9830:function(e,t,r){"use strict";var i=r(519).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,i=new Array(r),n=0;n<r;n++){i[n]=arguments[n]}e.apply(this,i)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var n=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var s=function onlegacyfinish(){if(!e.writable)u()};var o=e._writableState&&e._writableState.finished;var u=function onfinish(){a=false;o=true;if(!n)r.call(e)};var h=e._readableState&&e._readableState.endEmitted;var d=function onend(){n=false;h=true;if(!a)r.call(e)};var c=function onerror(t){r.call(e,t)};var l=function onclose(){var t;if(n&&!h){if(!e._readableState||!e._readableState.ended)t=new i;return r.call(e,t)}if(a&&!o){if(!e._writableState||!e._writableState.ended)t=new i;return r.call(e,t)}};var p=function onrequest(){e.req.on("finish",u)};if(isRequest(e)){e.on("complete",u);e.on("abort",l);if(e.req)p();else e.on("request",p)}else if(a&&!e._writableState){e.on("end",s);e.on("close",s)}e.on("end",d);e.on("finish",u);if(t.error!==false)e.on("error",c);e.on("close",l);return function(){e.removeListener("complete",u);e.removeListener("abort",l);e.removeListener("request",p);if(e.req)e.req.removeListener("finish",u);e.removeListener("end",s);e.removeListener("close",s);e.removeListener("finish",u);e.removeListener("end",d);e.removeListener("error",c);e.removeListener("close",l)}}e.exports=eos},1514:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,i,n,a,s){try{var o=e[a](s);var u=o.value}catch(e){r(e);return}if(o.done){t(u)}else{Promise.resolve(u).then(i,n)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(i,n){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,i,n,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,i,n,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);if(t)i=i.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,i)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(519).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var n;if(t&&typeof t.next==="function"){n=t}else if(t&&t[Symbol.asyncIterator])n=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])n=t[Symbol.iterator]();else throw new i("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var s=false;a._read=function(){if(!s){s=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield n.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{s=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},1586:function(e,t,r){"use strict";var i;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var n=r(519).q,a=n.ERR_MISSING_ARGS,s=n.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,n,a){a=once(a);var o=false;e.on("close",(function(){o=true}));if(i===undefined)i=r(9830);i(e,{readable:t,writable:n},(function(e){if(e)return a(e);o=true;a()}));var u=false;return function(t){if(o)return;if(u)return;u=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new s("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var i=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var n;var s=t.map((function(e,r){var a=r<t.length-1;var o=r>0;return destroyer(e,a,o,(function(e){if(!n)n=e;if(e)s.forEach(call);if(a)return;s.forEach(call);i(n)}))}));return t.reduce(pipe)}e.exports=pipeline},4292:function(e,t,r){"use strict";var i=r(519).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,n){var a=highWaterMarkFrom(t,n,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var s=n?r:"highWaterMark";throw new i(s,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},3917:function(e,t,r){e.exports=r(2781)},5098:function(e,t,r){var i=r(2781);if(process.env.READABLE_STREAM==="disable"&&i){e.exports=i.Readable;Object.assign(e.exports,i);e.exports.Stream=i}else{t=e.exports=r(279);t.Stream=i||t;t.Readable=t;t.Writable=r(3582);t.Duplex=r(5077);t.Transform=r(6821);t.PassThrough=r(3880);t.finished=r(9830);t.pipeline=r(1586)}},9573:function(e,t,r){"use strict";var i=r(3118).Buffer;var n=i.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(i.isEncoding===n||!n(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=i.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var i=t.length-1;if(i<r)return 0;var n=utf8CheckByte(t[i]);if(n>=0){if(n>0)e.lastNeed=n-1;return n}if(--i<r||n===-2)return 0;n=utf8CheckByte(t[i]);if(n>=0){if(n>0)e.lastNeed=n-2;return n}if(--i<r||n===-2)return 0;n=utf8CheckByte(t[i]);if(n>=0){if(n>0){if(n===2)n=0;else e.lastNeed=n-3}return n}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var i=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,i);return e.toString("utf8",t,i)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var i=r.charCodeAt(r.length-1);if(i>=55296&&i<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},9767:function(e,t,r){var i=t;i.utils=r(8911);i.common=r(5169);i.sha=r(9417);i.ripemd=r(5282);i.hmac=r(7890);i.sha1=i.sha.sha1;i.sha256=i.sha.sha256;i.sha224=i.sha.sha224;i.sha384=i.sha.sha384;i.sha512=i.sha.sha512;i.ripemd160=i.ripemd.ripemd160},5169:function(e,t,r){"use strict";var i=r(8911);var n=r(9036);function BlockHash(){this.pending=null;this.pendingTotal=0;this.blockSize=this.constructor.blockSize;this.outSize=this.constructor.outSize;this.hmacStrength=this.constructor.hmacStrength;this.padLength=this.constructor.padLength/8;this.endian="big";this._delta8=this.blockSize/8;this._delta32=this.blockSize/32}t.BlockHash=BlockHash;BlockHash.prototype.update=function update(e,t){e=i.toArray(e,t);if(!this.pending)this.pending=e;else this.pending=this.pending.concat(e);this.pendingTotal+=e.length;if(this.pending.length>=this._delta8){e=this.pending;var r=e.length%this._delta8;this.pending=e.slice(e.length-r,e.length);if(this.pending.length===0)this.pending=null;e=i.join32(e,0,e.length-r,this.endian);for(var n=0;n<e.length;n+=this._delta32)this._update(e,n,n+this._delta32)}return this};BlockHash.prototype.digest=function digest(e){this.update(this._pad());n(this.pending===null);return this._digest(e)};BlockHash.prototype._pad=function pad(){var e=this.pendingTotal;var t=this._delta8;var r=t-(e+this.padLength)%t;var i=new Array(r+this.padLength);i[0]=128;for(var n=1;n<r;n++)i[n]=0;e<<=3;if(this.endian==="big"){for(var a=8;a<this.padLength;a++)i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=e>>>24&255;i[n++]=e>>>16&255;i[n++]=e>>>8&255;i[n++]=e&255}else{i[n++]=e&255;i[n++]=e>>>8&255;i[n++]=e>>>16&255;i[n++]=e>>>24&255;i[n++]=0;i[n++]=0;i[n++]=0;i[n++]=0;for(a=8;a<this.padLength;a++)i[n++]=0}return i}},7890:function(e,t,r){"use strict";var i=r(8911);var n=r(9036);function Hmac(e,t,r){if(!(this instanceof Hmac))return new Hmac(e,t,r);this.Hash=e;this.blockSize=e.blockSize/8;this.outSize=e.outSize/8;this.inner=null;this.outer=null;this._init(i.toArray(t,r))}e.exports=Hmac;Hmac.prototype._init=function init(e){if(e.length>this.blockSize)e=(new this.Hash).update(e).digest();n(e.length<=this.blockSize);for(var t=e.length;t<this.blockSize;t++)e.push(0);for(t=0;t<e.length;t++)e[t]^=54;this.inner=(new this.Hash).update(e);for(t=0;t<e.length;t++)e[t]^=106;this.outer=(new this.Hash).update(e)};Hmac.prototype.update=function update(e,t){this.inner.update(e,t);return this};Hmac.prototype.digest=function digest(e){this.outer.update(this.inner.digest());return this.outer.digest(e)}},5282:function(e,t,r){"use strict";var i=r(8911);var n=r(5169);var a=i.rotl32;var s=i.sum32;var o=i.sum32_3;var u=i.sum32_4;var h=n.BlockHash;function RIPEMD160(){if(!(this instanceof RIPEMD160))return new RIPEMD160;h.call(this);this.h=[1732584193,4023233417,2562383102,271733878,3285377520];this.endian="little"}i.inherits(RIPEMD160,h);t.ripemd160=RIPEMD160;RIPEMD160.blockSize=512;RIPEMD160.outSize=160;RIPEMD160.hmacStrength=192;RIPEMD160.padLength=64;RIPEMD160.prototype._update=function update(e,t){var r=this.h[0];var i=this.h[1];var n=this.h[2];var h=this.h[3];var b=this.h[4];var v=r;var m=i;var y=n;var g=h;var _=b;for(var w=0;w<80;w++){var M=s(a(u(r,f(w,i,n,h),e[d[w]+t],K(w)),l[w]),b);r=b;b=h;h=a(n,10);n=i;i=M;M=s(a(u(v,f(79-w,m,y,g),e[c[w]+t],Kh(w)),p[w]),_);v=_;_=g;g=a(y,10);y=m;m=M}M=o(this.h[1],n,g);this.h[1]=o(this.h[2],h,_);this.h[2]=o(this.h[3],b,v);this.h[3]=o(this.h[4],r,m);this.h[4]=o(this.h[0],i,y);this.h[0]=M};RIPEMD160.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"little");else return i.split32(this.h,"little")};function f(e,t,r,i){if(e<=15)return t^r^i;else if(e<=31)return t&r|~t&i;else if(e<=47)return(t|~r)^i;else if(e<=63)return t&i|r&~i;else return t^(r|~i)}function K(e){if(e<=15)return 0;else if(e<=31)return 1518500249;else if(e<=47)return 1859775393;else if(e<=63)return 2400959708;else return 2840853838}function Kh(e){if(e<=15)return 1352829926;else if(e<=31)return 1548603684;else if(e<=47)return 1836072691;else if(e<=63)return 2053994217;else return 0}var d=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13];var c=[5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11];var l=[11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6];var p=[8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11]},9417:function(e,t,r){"use strict";t.sha1=r(8097);t.sha224=r(9777);t.sha256=r(6072);t.sha384=r(5132);t.sha512=r(5983)},8097:function(e,t,r){"use strict";var i=r(8911);var n=r(5169);var a=r(6509);var s=i.rotl32;var o=i.sum32;var u=i.sum32_5;var h=a.ft_1;var d=n.BlockHash;var c=[1518500249,1859775393,2400959708,3395469782];function SHA1(){if(!(this instanceof SHA1))return new SHA1;d.call(this);this.h=[1732584193,4023233417,2562383102,271733878,3285377520];this.W=new Array(80)}i.inherits(SHA1,d);e.exports=SHA1;SHA1.blockSize=512;SHA1.outSize=160;SHA1.hmacStrength=80;SHA1.padLength=64;SHA1.prototype._update=function _update(e,t){var r=this.W;for(var i=0;i<16;i++)r[i]=e[t+i];for(;i<r.length;i++)r[i]=s(r[i-3]^r[i-8]^r[i-14]^r[i-16],1);var n=this.h[0];var a=this.h[1];var d=this.h[2];var l=this.h[3];var p=this.h[4];for(i=0;i<r.length;i++){var b=~~(i/20);var v=u(s(n,5),h(b,a,d,l),p,r[i],c[b]);p=l;l=d;d=s(a,30);a=n;n=v}this.h[0]=o(this.h[0],n);this.h[1]=o(this.h[1],a);this.h[2]=o(this.h[2],d);this.h[3]=o(this.h[3],l);this.h[4]=o(this.h[4],p)};SHA1.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"big");else return i.split32(this.h,"big")}},9777:function(e,t,r){"use strict";var i=r(8911);var n=r(6072);function SHA224(){if(!(this instanceof SHA224))return new SHA224;n.call(this);this.h=[3238371032,914150663,812702999,4144912697,4290775857,1750603025,1694076839,3204075428]}i.inherits(SHA224,n);e.exports=SHA224;SHA224.blockSize=512;SHA224.outSize=224;SHA224.hmacStrength=192;SHA224.padLength=64;SHA224.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h.slice(0,7),"big");else return i.split32(this.h.slice(0,7),"big")}},6072:function(e,t,r){"use strict";var i=r(8911);var n=r(5169);var a=r(6509);var s=r(9036);var o=i.sum32;var u=i.sum32_4;var h=i.sum32_5;var d=a.ch32;var c=a.maj32;var l=a.s0_256;var p=a.s1_256;var b=a.g0_256;var v=a.g1_256;var m=n.BlockHash;var y=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];function SHA256(){if(!(this instanceof SHA256))return new SHA256;m.call(this);this.h=[1779033703,3144134277,1013904242,2773480762,1359893119,2600822924,528734635,1541459225];this.k=y;this.W=new Array(64)}i.inherits(SHA256,m);e.exports=SHA256;SHA256.blockSize=512;SHA256.outSize=256;SHA256.hmacStrength=192;SHA256.padLength=64;SHA256.prototype._update=function _update(e,t){var r=this.W;for(var i=0;i<16;i++)r[i]=e[t+i];for(;i<r.length;i++)r[i]=u(v(r[i-2]),r[i-7],b(r[i-15]),r[i-16]);var n=this.h[0];var a=this.h[1];var m=this.h[2];var y=this.h[3];var g=this.h[4];var _=this.h[5];var w=this.h[6];var M=this.h[7];s(this.k.length===r.length);for(i=0;i<r.length;i++){var E=h(M,p(g),d(g,_,w),this.k[i],r[i]);var B=o(l(n),c(n,a,m));M=w;w=_;_=g;g=o(y,E);y=m;m=a;a=n;n=o(E,B)}this.h[0]=o(this.h[0],n);this.h[1]=o(this.h[1],a);this.h[2]=o(this.h[2],m);this.h[3]=o(this.h[3],y);this.h[4]=o(this.h[4],g);this.h[5]=o(this.h[5],_);this.h[6]=o(this.h[6],w);this.h[7]=o(this.h[7],M)};SHA256.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"big");else return i.split32(this.h,"big")}},5132:function(e,t,r){"use strict";var i=r(8911);var n=r(5983);function SHA384(){if(!(this instanceof SHA384))return new SHA384;n.call(this);this.h=[3418070365,3238371032,1654270250,914150663,2438529370,812702999,355462360,4144912697,1731405415,4290775857,2394180231,1750603025,3675008525,1694076839,1203062813,3204075428]}i.inherits(SHA384,n);e.exports=SHA384;SHA384.blockSize=1024;SHA384.outSize=384;SHA384.hmacStrength=192;SHA384.padLength=128;SHA384.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h.slice(0,12),"big");else return i.split32(this.h.slice(0,12),"big")}},5983:function(e,t,r){"use strict";var i=r(8911);var n=r(5169);var a=r(9036);var s=i.rotr64_hi;var o=i.rotr64_lo;var u=i.shr64_hi;var h=i.shr64_lo;var d=i.sum64;var c=i.sum64_hi;var l=i.sum64_lo;var p=i.sum64_4_hi;var b=i.sum64_4_lo;var v=i.sum64_5_hi;var m=i.sum64_5_lo;var y=n.BlockHash;var g=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591];function SHA512(){if(!(this instanceof SHA512))return new SHA512;y.call(this);this.h=[1779033703,4089235720,3144134277,2227873595,1013904242,4271175723,2773480762,1595750129,1359893119,2917565137,2600822924,725511199,528734635,4215389547,1541459225,327033209];this.k=g;this.W=new Array(160)}i.inherits(SHA512,y);e.exports=SHA512;SHA512.blockSize=1024;SHA512.outSize=512;SHA512.hmacStrength=192;SHA512.padLength=128;SHA512.prototype._prepareBlock=function _prepareBlock(e,t){var r=this.W;for(var i=0;i<32;i++)r[i]=e[t+i];for(;i<r.length;i+=2){var n=g1_512_hi(r[i-4],r[i-3]);var a=g1_512_lo(r[i-4],r[i-3]);var s=r[i-14];var o=r[i-13];var u=g0_512_hi(r[i-30],r[i-29]);var h=g0_512_lo(r[i-30],r[i-29]);var d=r[i-32];var c=r[i-31];r[i]=p(n,a,s,o,u,h,d,c);r[i+1]=b(n,a,s,o,u,h,d,c)}};SHA512.prototype._update=function _update(e,t){this._prepareBlock(e,t);var r=this.W;var i=this.h[0];var n=this.h[1];var s=this.h[2];var o=this.h[3];var u=this.h[4];var h=this.h[5];var p=this.h[6];var b=this.h[7];var y=this.h[8];var g=this.h[9];var _=this.h[10];var w=this.h[11];var M=this.h[12];var E=this.h[13];var B=this.h[14];var k=this.h[15];a(this.k.length===r.length);for(var A=0;A<r.length;A+=2){var N=B;var P=k;var x=s1_512_hi(y,g);var C=s1_512_lo(y,g);var T=ch64_hi(y,g,_,w,M,E);var I=ch64_lo(y,g,_,w,M,E);var D=this.k[A];var O=this.k[A+1];var j=r[A];var L=r[A+1];var q=v(N,P,x,C,T,I,D,O,j,L);var H=m(N,P,x,C,T,I,D,O,j,L);N=s0_512_hi(i,n);P=s0_512_lo(i,n);x=maj64_hi(i,n,s,o,u,h);C=maj64_lo(i,n,s,o,u,h);var F=c(N,P,x,C);var U=l(N,P,x,C);B=M;k=E;M=_;E=w;_=y;w=g;y=c(p,b,q,H);g=l(b,b,q,H);p=u;b=h;u=s;h=o;s=i;o=n;i=c(q,H,F,U);n=l(q,H,F,U)}d(this.h,0,i,n);d(this.h,2,s,o);d(this.h,4,u,h);d(this.h,6,p,b);d(this.h,8,y,g);d(this.h,10,_,w);d(this.h,12,M,E);d(this.h,14,B,k)};SHA512.prototype._digest=function digest(e){if(e==="hex")return i.toHex32(this.h,"big");else return i.split32(this.h,"big")};function ch64_hi(e,t,r,i,n){var a=e&r^~e&n;if(a<0)a+=4294967296;return a}function ch64_lo(e,t,r,i,n,a){var s=t&i^~t&a;if(s<0)s+=4294967296;return s}function maj64_hi(e,t,r,i,n){var a=e&r^e&n^r&n;if(a<0)a+=4294967296;return a}function maj64_lo(e,t,r,i,n,a){var s=t&i^t&a^i&a;if(s<0)s+=4294967296;return s}function s0_512_hi(e,t){var r=s(e,t,28);var i=s(t,e,2);var n=s(t,e,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function s0_512_lo(e,t){var r=o(e,t,28);var i=o(t,e,2);var n=o(t,e,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function s1_512_hi(e,t){var r=s(e,t,14);var i=s(e,t,18);var n=s(t,e,9);var a=r^i^n;if(a<0)a+=4294967296;return a}function s1_512_lo(e,t){var r=o(e,t,14);var i=o(e,t,18);var n=o(t,e,9);var a=r^i^n;if(a<0)a+=4294967296;return a}function g0_512_hi(e,t){var r=s(e,t,1);var i=s(e,t,8);var n=u(e,t,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function g0_512_lo(e,t){var r=o(e,t,1);var i=o(e,t,8);var n=h(e,t,7);var a=r^i^n;if(a<0)a+=4294967296;return a}function g1_512_hi(e,t){var r=s(e,t,19);var i=s(t,e,29);var n=u(e,t,6);var a=r^i^n;if(a<0)a+=4294967296;return a}function g1_512_lo(e,t){var r=o(e,t,19);var i=o(t,e,29);var n=h(e,t,6);var a=r^i^n;if(a<0)a+=4294967296;return a}},6509:function(e,t,r){"use strict";var i=r(8911);var n=i.rotr32;function ft_1(e,t,r,i){if(e===0)return ch32(t,r,i);if(e===1||e===3)return p32(t,r,i);if(e===2)return maj32(t,r,i)}t.ft_1=ft_1;function ch32(e,t,r){return e&t^~e&r}t.ch32=ch32;function maj32(e,t,r){return e&t^e&r^t&r}t.maj32=maj32;function p32(e,t,r){return e^t^r}t.p32=p32;function s0_256(e){return n(e,2)^n(e,13)^n(e,22)}t.s0_256=s0_256;function s1_256(e){return n(e,6)^n(e,11)^n(e,25)}t.s1_256=s1_256;function g0_256(e){return n(e,7)^n(e,18)^e>>>3}t.g0_256=g0_256;function g1_256(e){return n(e,17)^n(e,19)^e>>>10}t.g1_256=g1_256},8911:function(e,t,r){"use strict";var i=r(9036);var n=r(7526);t.inherits=n;function isSurrogatePair(e,t){if((e.charCodeAt(t)&64512)!==55296){return false}if(t<0||t+1>=e.length){return false}return(e.charCodeAt(t+1)&64512)===56320}function toArray(e,t){if(Array.isArray(e))return e.slice();if(!e)return[];var r=[];if(typeof e==="string"){if(!t){var i=0;for(var n=0;n<e.length;n++){var a=e.charCodeAt(n);if(a<128){r[i++]=a}else if(a<2048){r[i++]=a>>6|192;r[i++]=a&63|128}else if(isSurrogatePair(e,n)){a=65536+((a&1023)<<10)+(e.charCodeAt(++n)&1023);r[i++]=a>>18|240;r[i++]=a>>12&63|128;r[i++]=a>>6&63|128;r[i++]=a&63|128}else{r[i++]=a>>12|224;r[i++]=a>>6&63|128;r[i++]=a&63|128}}}else if(t==="hex"){e=e.replace(/[^a-z0-9]+/gi,"");if(e.length%2!==0)e="0"+e;for(n=0;n<e.length;n+=2)r.push(parseInt(e[n]+e[n+1],16))}}else{for(n=0;n<e.length;n++)r[n]=e[n]|0}return r}t.toArray=toArray;function toHex(e){var t="";for(var r=0;r<e.length;r++)t+=zero2(e[r].toString(16));return t}t.toHex=toHex;function htonl(e){var t=e>>>24|e>>>8&65280|e<<8&16711680|(e&255)<<24;return t>>>0}t.htonl=htonl;function toHex32(e,t){var r="";for(var i=0;i<e.length;i++){var n=e[i];if(t==="little")n=htonl(n);r+=zero8(n.toString(16))}return r}t.toHex32=toHex32;function zero2(e){if(e.length===1)return"0"+e;else return e}t.zero2=zero2;function zero8(e){if(e.length===7)return"0"+e;else if(e.length===6)return"00"+e;else if(e.length===5)return"000"+e;else if(e.length===4)return"0000"+e;else if(e.length===3)return"00000"+e;else if(e.length===2)return"000000"+e;else if(e.length===1)return"0000000"+e;else return e}t.zero8=zero8;function join32(e,t,r,n){var a=r-t;i(a%4===0);var s=new Array(a/4);for(var o=0,u=t;o<s.length;o++,u+=4){var h;if(n==="big")h=e[u]<<24|e[u+1]<<16|e[u+2]<<8|e[u+3];else h=e[u+3]<<24|e[u+2]<<16|e[u+1]<<8|e[u];s[o]=h>>>0}return s}t.join32=join32;function split32(e,t){var r=new Array(e.length*4);for(var i=0,n=0;i<e.length;i++,n+=4){var a=e[i];if(t==="big"){r[n]=a>>>24;r[n+1]=a>>>16&255;r[n+2]=a>>>8&255;r[n+3]=a&255}else{r[n+3]=a>>>24;r[n+2]=a>>>16&255;r[n+1]=a>>>8&255;r[n]=a&255}}return r}t.split32=split32;function rotr32(e,t){return e>>>t|e<<32-t}t.rotr32=rotr32;function rotl32(e,t){return e<<t|e>>>32-t}t.rotl32=rotl32;function sum32(e,t){return e+t>>>0}t.sum32=sum32;function sum32_3(e,t,r){return e+t+r>>>0}t.sum32_3=sum32_3;function sum32_4(e,t,r,i){return e+t+r+i>>>0}t.sum32_4=sum32_4;function sum32_5(e,t,r,i,n){return e+t+r+i+n>>>0}t.sum32_5=sum32_5;function sum64(e,t,r,i){var n=e[t];var a=e[t+1];var s=i+a>>>0;var o=(s<i?1:0)+r+n;e[t]=o>>>0;e[t+1]=s}t.sum64=sum64;function sum64_hi(e,t,r,i){var n=t+i>>>0;var a=(n<t?1:0)+e+r;return a>>>0}t.sum64_hi=sum64_hi;function sum64_lo(e,t,r,i){var n=t+i;return n>>>0}t.sum64_lo=sum64_lo;function sum64_4_hi(e,t,r,i,n,a,s,o){var u=0;var h=t;h=h+i>>>0;u+=h<t?1:0;h=h+a>>>0;u+=h<a?1:0;h=h+o>>>0;u+=h<o?1:0;var d=e+r+n+s+u;return d>>>0}t.sum64_4_hi=sum64_4_hi;function sum64_4_lo(e,t,r,i,n,a,s,o){var u=t+i+a+o;return u>>>0}t.sum64_4_lo=sum64_4_lo;function sum64_5_hi(e,t,r,i,n,a,s,o,u,h){var d=0;var c=t;c=c+i>>>0;d+=c<t?1:0;c=c+a>>>0;d+=c<a?1:0;c=c+o>>>0;d+=c<o?1:0;c=c+h>>>0;d+=c<h?1:0;var l=e+r+n+s+u+d;return l>>>0}t.sum64_5_hi=sum64_5_hi;function sum64_5_lo(e,t,r,i,n,a,s,o,u,h){var d=t+i+a+o+h;return d>>>0}t.sum64_5_lo=sum64_5_lo;function rotr64_hi(e,t,r){var i=t<<32-r|e>>>r;return i>>>0}t.rotr64_hi=rotr64_hi;function rotr64_lo(e,t,r){var i=e<<32-r|t>>>r;return i>>>0}t.rotr64_lo=rotr64_lo;function shr64_hi(e,t,r){return e>>>r}t.shr64_hi=shr64_hi;function shr64_lo(e,t,r){var i=e<<32-r|t>>>r;return i>>>0}t.shr64_lo=shr64_lo},8242:function(e,t,r){"use strict";var i=r(9767);var n=r(6249);var a=r(9036);function HmacDRBG(e){if(!(this instanceof HmacDRBG))return new HmacDRBG(e);this.hash=e.hash;this.predResist=!!e.predResist;this.outLen=this.hash.outSize;this.minEntropy=e.minEntropy||this.hash.hmacStrength;this._reseed=null;this.reseedInterval=null;this.K=null;this.V=null;var t=n.toArray(e.entropy,e.entropyEnc||"hex");var r=n.toArray(e.nonce,e.nonceEnc||"hex");var i=n.toArray(e.pers,e.persEnc||"hex");a(t.length>=this.minEntropy/8,"Not enough entropy. Minimum is: "+this.minEntropy+" bits");this._init(t,r,i)}e.exports=HmacDRBG;HmacDRBG.prototype._init=function init(e,t,r){var i=e.concat(t).concat(r);this.K=new Array(this.outLen/8);this.V=new Array(this.outLen/8);for(var n=0;n<this.V.length;n++){this.K[n]=0;this.V[n]=1}this._update(i);this._reseed=1;this.reseedInterval=281474976710656};HmacDRBG.prototype._hmac=function hmac(){return new i.hmac(this.hash,this.K)};HmacDRBG.prototype._update=function update(e){var t=this._hmac().update(this.V).update([0]);if(e)t=t.update(e);this.K=t.digest();this.V=this._hmac().update(this.V).digest();if(!e)return;this.K=this._hmac().update(this.V).update([1]).update(e).digest();this.V=this._hmac().update(this.V).digest()};HmacDRBG.prototype.reseed=function reseed(e,t,r,i){if(typeof t!=="string"){i=r;r=t;t=null}e=n.toArray(e,t);r=n.toArray(r,i);a(e.length>=this.minEntropy/8,"Not enough entropy. Minimum is: "+this.minEntropy+" bits");this._update(e.concat(r||[]));this._reseed=1};HmacDRBG.prototype.generate=function generate(e,t,r,i){if(this._reseed>this.reseedInterval)throw new Error("Reseed is required");if(typeof t!=="string"){i=r;r=t;t=null}if(r){r=n.toArray(r,i||"hex");this._update(r)}var a=[];while(a.length<e){this.V=this._hmac().update(this.V).digest();a=a.concat(this.V)}var s=a.slice(0,e);this._update(r);this._reseed++;return n.encode(s,t)}},7526:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},4125:function(e,t,r){"use strict";var i=r(7526);var n=r(3421);var a=r(3118).Buffer;var s=new Array(16);function MD5(){n.call(this,64);this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878}i(MD5,n);MD5.prototype._update=function(){var e=s;for(var t=0;t<16;++t)e[t]=this._block.readInt32LE(t*4);var r=this._a;var i=this._b;var n=this._c;var a=this._d;r=fnF(r,i,n,a,e[0],3614090360,7);a=fnF(a,r,i,n,e[1],3905402710,12);n=fnF(n,a,r,i,e[2],606105819,17);i=fnF(i,n,a,r,e[3],3250441966,22);r=fnF(r,i,n,a,e[4],4118548399,7);a=fnF(a,r,i,n,e[5],1200080426,12);n=fnF(n,a,r,i,e[6],2821735955,17);i=fnF(i,n,a,r,e[7],4249261313,22);r=fnF(r,i,n,a,e[8],1770035416,7);a=fnF(a,r,i,n,e[9],2336552879,12);n=fnF(n,a,r,i,e[10],4294925233,17);i=fnF(i,n,a,r,e[11],2304563134,22);r=fnF(r,i,n,a,e[12],1804603682,7);a=fnF(a,r,i,n,e[13],4254626195,12);n=fnF(n,a,r,i,e[14],2792965006,17);i=fnF(i,n,a,r,e[15],1236535329,22);r=fnG(r,i,n,a,e[1],4129170786,5);a=fnG(a,r,i,n,e[6],3225465664,9);n=fnG(n,a,r,i,e[11],643717713,14);i=fnG(i,n,a,r,e[0],3921069994,20);r=fnG(r,i,n,a,e[5],3593408605,5);a=fnG(a,r,i,n,e[10],38016083,9);n=fnG(n,a,r,i,e[15],3634488961,14);i=fnG(i,n,a,r,e[4],3889429448,20);r=fnG(r,i,n,a,e[9],568446438,5);a=fnG(a,r,i,n,e[14],3275163606,9);n=fnG(n,a,r,i,e[3],4107603335,14);i=fnG(i,n,a,r,e[8],1163531501,20);r=fnG(r,i,n,a,e[13],2850285829,5);a=fnG(a,r,i,n,e[2],4243563512,9);n=fnG(n,a,r,i,e[7],1735328473,14);i=fnG(i,n,a,r,e[12],2368359562,20);r=fnH(r,i,n,a,e[5],4294588738,4);a=fnH(a,r,i,n,e[8],2272392833,11);n=fnH(n,a,r,i,e[11],1839030562,16);i=fnH(i,n,a,r,e[14],4259657740,23);r=fnH(r,i,n,a,e[1],2763975236,4);a=fnH(a,r,i,n,e[4],1272893353,11);n=fnH(n,a,r,i,e[7],4139469664,16);i=fnH(i,n,a,r,e[10],3200236656,23);r=fnH(r,i,n,a,e[13],681279174,4);a=fnH(a,r,i,n,e[0],3936430074,11);n=fnH(n,a,r,i,e[3],3572445317,16);i=fnH(i,n,a,r,e[6],76029189,23);r=fnH(r,i,n,a,e[9],3654602809,4);a=fnH(a,r,i,n,e[12],3873151461,11);n=fnH(n,a,r,i,e[15],530742520,16);i=fnH(i,n,a,r,e[2],3299628645,23);r=fnI(r,i,n,a,e[0],4096336452,6);a=fnI(a,r,i,n,e[7],1126891415,10);n=fnI(n,a,r,i,e[14],2878612391,15);i=fnI(i,n,a,r,e[5],4237533241,21);r=fnI(r,i,n,a,e[12],1700485571,6);a=fnI(a,r,i,n,e[3],2399980690,10);n=fnI(n,a,r,i,e[10],4293915773,15);i=fnI(i,n,a,r,e[1],2240044497,21);r=fnI(r,i,n,a,e[8],1873313359,6);a=fnI(a,r,i,n,e[15],4264355552,10);n=fnI(n,a,r,i,e[6],2734768916,15);i=fnI(i,n,a,r,e[13],1309151649,21);r=fnI(r,i,n,a,e[4],4149444226,6);a=fnI(a,r,i,n,e[11],3174756917,10);n=fnI(n,a,r,i,e[2],718787259,15);i=fnI(i,n,a,r,e[9],3951481745,21);this._a=this._a+r|0;this._b=this._b+i|0;this._c=this._c+n|0;this._d=this._d+a|0};MD5.prototype._digest=function(){this._block[this._blockOffset++]=128;if(this._blockOffset>56){this._block.fill(0,this._blockOffset,64);this._update();this._blockOffset=0}this._block.fill(0,this._blockOffset,56);this._block.writeUInt32LE(this._length[0],56);this._block.writeUInt32LE(this._length[1],60);this._update();var e=a.allocUnsafe(16);e.writeInt32LE(this._a,0);e.writeInt32LE(this._b,4);e.writeInt32LE(this._c,8);e.writeInt32LE(this._d,12);return e};function rotl(e,t){return e<<t|e>>>32-t}function fnF(e,t,r,i,n,a,s){return rotl(e+(t&r|~t&i)+n+a|0,s)+t|0}function fnG(e,t,r,i,n,a,s){return rotl(e+(t&i|r&~i)+n+a|0,s)+t|0}function fnH(e,t,r,i,n,a,s){return rotl(e+(t^r^i)+n+a|0,s)+t|0}function fnI(e,t,r,i,n,a,s){return rotl(e+(r^(t|~i))+n+a|0,s)+t|0}e.exports=MD5},148:function(e,t,r){var i=r(6884);var n=r(6069);function MillerRabin(e){this.rand=e||new n.Rand}e.exports=MillerRabin;MillerRabin.create=function create(e){return new MillerRabin(e)};MillerRabin.prototype._randbelow=function _randbelow(e){var t=e.bitLength();var r=Math.ceil(t/8);do{var n=new i(this.rand.generate(r))}while(n.cmp(e)>=0);return n};MillerRabin.prototype._randrange=function _randrange(e,t){var r=t.sub(e);return e.add(this._randbelow(r))};MillerRabin.prototype.test=function test(e,t,r){var n=e.bitLength();var a=i.mont(e);var s=new i(1).toRed(a);if(!t)t=Math.max(1,n/48|0);var o=e.subn(1);for(var u=0;!o.testn(u);u++){}var h=e.shrn(u);var d=o.toRed(a);var c=true;for(;t>0;t--){var l=this._randrange(new i(2),o);if(r)r(l);var p=l.toRed(a).redPow(h);if(p.cmp(s)===0||p.cmp(d)===0)continue;for(var b=1;b<u;b++){p=p.redSqr();if(p.cmp(s)===0)return false;if(p.cmp(d)===0)break}if(b===u)return false}return c};MillerRabin.prototype.getDivisor=function getDivisor(e,t){var r=e.bitLength();var n=i.mont(e);var a=new i(1).toRed(n);if(!t)t=Math.max(1,r/48|0);var s=e.subn(1);for(var o=0;!s.testn(o);o++){}var u=e.shrn(o);var h=s.toRed(n);for(;t>0;t--){var d=this._randrange(new i(2),s);var c=e.gcd(d);if(c.cmpn(1)!==0)return c;var l=d.toRed(n).redPow(u);if(l.cmp(a)===0||l.cmp(h)===0)continue;for(var p=1;p<o;p++){l=l.redSqr();if(l.cmp(a)===0)return l.fromRed().subn(1).gcd(e);if(l.cmp(h)===0)break}if(p===o){l=l.redSqr();return l.fromRed().subn(1).gcd(e)}}return false}},9036:function(e){e.exports=assert;function assert(e,t){if(!e)throw new Error(t||"Assertion failed")}assert.equal=function assertEqual(e,t,r){if(e!=t)throw new Error(r||"Assertion failed: "+e+" != "+t)}},6249:function(e,t){"use strict";var r=t;function toArray(e,t){if(Array.isArray(e))return e.slice();if(!e)return[];var r=[];if(typeof e!=="string"){for(var i=0;i<e.length;i++)r[i]=e[i]|0;return r}if(t==="hex"){e=e.replace(/[^a-z0-9]+/gi,"");if(e.length%2!==0)e="0"+e;for(var i=0;i<e.length;i+=2)r.push(parseInt(e[i]+e[i+1],16))}else{for(var i=0;i<e.length;i++){var n=e.charCodeAt(i);var a=n>>8;var s=n&255;if(a)r.push(a,s);else r.push(s)}}return r}r.toArray=toArray;function zero2(e){if(e.length===1)return"0"+e;else return e}r.zero2=zero2;function toHex(e){var t="";for(var r=0;r<e.length;r++)t+=zero2(e[r].toString(16));return t}r.toHex=toHex;r.encode=function encode(e,t){if(t==="hex")return toHex(e);else return e}},9913:function(e,t,r){"use strict";var i=r(8557);t.certificate=r(8657);var n=i.define("RSAPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("modulus").int(),this.key("publicExponent").int(),this.key("privateExponent").int(),this.key("prime1").int(),this.key("prime2").int(),this.key("exponent1").int(),this.key("exponent2").int(),this.key("coefficient").int())}));t.RSAPrivateKey=n;var a=i.define("RSAPublicKey",(function(){this.seq().obj(this.key("modulus").int(),this.key("publicExponent").int())}));t.RSAPublicKey=a;var s=i.define("SubjectPublicKeyInfo",(function(){this.seq().obj(this.key("algorithm").use(o),this.key("subjectPublicKey").bitstr())}));t.PublicKey=s;var o=i.define("AlgorithmIdentifier",(function(){this.seq().obj(this.key("algorithm").objid(),this.key("none").null_().optional(),this.key("curve").objid().optional(),this.key("params").seq().obj(this.key("p").int(),this.key("q").int(),this.key("g").int()).optional())}));var u=i.define("PrivateKeyInfo",(function(){this.seq().obj(this.key("version").int(),this.key("algorithm").use(o),this.key("subjectPrivateKey").octstr())}));t.PrivateKey=u;var h=i.define("EncryptedPrivateKeyInfo",(function(){this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(),this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(),this.key("kdeparams").seq().obj(this.key("salt").octstr(),this.key("iters").int())),this.key("cipher").seq().obj(this.key("algo").objid(),this.key("iv").octstr()))),this.key("subjectPrivateKey").octstr())}));t.EncryptedPrivateKey=h;var d=i.define("DSAPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("p").int(),this.key("q").int(),this.key("g").int(),this.key("pub_key").int(),this.key("priv_key").int())}));t.DSAPrivateKey=d;t.DSAparam=i.define("DSAparam",(function(){this.int()}));var c=i.define("ECPrivateKey",(function(){this.seq().obj(this.key("version").int(),this.key("privateKey").octstr(),this.key("parameters").optional().explicit(0).use(l),this.key("publicKey").optional().explicit(1).bitstr())}));t.ECPrivateKey=c;var l=i.define("ECParameters",(function(){this.choice({namedCurve:this.objid()})}));t.signature=i.define("signature",(function(){this.seq().obj(this.key("r").int(),this.key("s").int())}))},8657:function(e,t,r){"use strict";var i=r(8557);var n=i.define("Time",(function(){this.choice({utcTime:this.utctime(),generalTime:this.gentime()})}));var a=i.define("AttributeTypeValue",(function(){this.seq().obj(this.key("type").objid(),this.key("value").any())}));var s=i.define("AlgorithmIdentifier",(function(){this.seq().obj(this.key("algorithm").objid(),this.key("parameters").optional(),this.key("curve").objid().optional())}));var o=i.define("SubjectPublicKeyInfo",(function(){this.seq().obj(this.key("algorithm").use(s),this.key("subjectPublicKey").bitstr())}));var u=i.define("RelativeDistinguishedName",(function(){this.setof(a)}));var h=i.define("RDNSequence",(function(){this.seqof(u)}));var d=i.define("Name",(function(){this.choice({rdnSequence:this.use(h)})}));var c=i.define("Validity",(function(){this.seq().obj(this.key("notBefore").use(n),this.key("notAfter").use(n))}));var l=i.define("Extension",(function(){this.seq().obj(this.key("extnID").objid(),this.key("critical").bool().def(false),this.key("extnValue").octstr())}));var p=i.define("TBSCertificate",(function(){this.seq().obj(this.key("version").explicit(0).int().optional(),this.key("serialNumber").int(),this.key("signature").use(s),this.key("issuer").use(d),this.key("validity").use(c),this.key("subject").use(d),this.key("subjectPublicKeyInfo").use(o),this.key("issuerUniqueID").implicit(1).bitstr().optional(),this.key("subjectUniqueID").implicit(2).bitstr().optional(),this.key("extensions").explicit(3).seqof(l).optional())}));var b=i.define("X509Certificate",(function(){this.seq().obj(this.key("tbsCertificate").use(p),this.key("signatureAlgorithm").use(s),this.key("signatureValue").bitstr())}));e.exports=b},4803:function(e,t,r){var i=/Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r\+\/\=]+)[\n\r]+/m;var n=/^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;var a=/^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r\+\/\=]+)-----END \1-----$/m;var s=r(7325);var o=r(7384);var u=r(3118).Buffer;e.exports=function(e,t){var r=e.toString();var h=r.match(i);var d;if(!h){var c=r.match(a);d=new u(c[2].replace(/[\r\n]/g,""),"base64")}else{var l="aes"+h[1];var p=u.from(h[2],"hex");var b=u.from(h[3].replace(/[\r\n]/g,""),"base64");var v=s(t,p.slice(0,8),parseInt(h[1],10)).key;var m=[];var y=o.createDecipheriv(l,v,p);m.push(y.update(b));m.push(y.final());d=u.concat(m)}var g=r.match(n)[1];return{tag:g,data:d}}},569:function(e,t,r){var i=r(9913);var n=r(8675);var a=r(4803);var s=r(7384);var o=r(785);var u=r(3118).Buffer;e.exports=parseKeys;function parseKeys(e){var t;if(typeof e==="object"&&!u.isBuffer(e)){t=e.passphrase;e=e.key}if(typeof e==="string"){e=u.from(e)}var r=a(e,t);var n=r.tag;var s=r.data;var o,h;switch(n){case"CERTIFICATE":h=i.certificate.decode(s,"der").tbsCertificate.subjectPublicKeyInfo;case"PUBLIC KEY":if(!h){h=i.PublicKey.decode(s,"der")}o=h.algorithm.algorithm.join(".");switch(o){case"1.2.840.113549.1.1.1":return i.RSAPublicKey.decode(h.subjectPublicKey.data,"der");case"1.2.840.10045.2.1":h.subjectPrivateKey=h.subjectPublicKey;return{type:"ec",data:h};case"1.2.840.10040.4.1":h.algorithm.params.pub_key=i.DSAparam.decode(h.subjectPublicKey.data,"der");return{type:"dsa",data:h.algorithm.params};default:throw new Error("unknown key id "+o)}throw new Error("unknown key type "+n);case"ENCRYPTED PRIVATE KEY":s=i.EncryptedPrivateKey.decode(s,"der");s=decrypt(s,t);case"PRIVATE KEY":h=i.PrivateKey.decode(s,"der");o=h.algorithm.algorithm.join(".");switch(o){case"1.2.840.113549.1.1.1":return i.RSAPrivateKey.decode(h.subjectPrivateKey,"der");case"1.2.840.10045.2.1":return{curve:h.algorithm.curve,privateKey:i.ECPrivateKey.decode(h.subjectPrivateKey,"der").privateKey};case"1.2.840.10040.4.1":h.algorithm.params.priv_key=i.DSAparam.decode(h.subjectPrivateKey,"der");return{type:"dsa",params:h.algorithm.params};default:throw new Error("unknown key id "+o)}throw new Error("unknown key type "+n);case"RSA PUBLIC KEY":return i.RSAPublicKey.decode(s,"der");case"RSA PRIVATE KEY":return i.RSAPrivateKey.decode(s,"der");case"DSA PRIVATE KEY":return{type:"dsa",params:i.DSAPrivateKey.decode(s,"der")};case"EC PRIVATE KEY":s=i.ECPrivateKey.decode(s,"der");return{curve:s.parameters.value,privateKey:s.privateKey};default:throw new Error("unknown key type "+n)}}parseKeys.signature=i.signature;function decrypt(e,t){var r=e.algorithm.decrypt.kde.kdeparams.salt;var i=parseInt(e.algorithm.decrypt.kde.kdeparams.iters.toString(),10);var a=n[e.algorithm.decrypt.cipher.algo.join(".")];var h=e.algorithm.decrypt.cipher.iv;var d=e.subjectPrivateKey;var c=parseInt(a.split("-")[1],10)/8;var l=o.pbkdf2Sync(t,r,i,c,"sha1");var p=s.createDecipheriv(a,l,h);var b=[];b.push(p.update(d));b.push(p.final());return u.concat(b)}},785:function(e,t,r){var i=r(6113);var n=r(721);var a=r(908);var s=r(7409);function nativePBKDF2(e,t,r,o,u,h){n(r,o);e=s(e,a,"Password");t=s(t,a,"Salt");if(typeof u==="function"){h=u;u="sha1"}if(typeof h!=="function")throw new Error("No callback provided to pbkdf2");return i.pbkdf2(e,t,r,o,u,h)}function nativePBKDF2Sync(e,t,r,o,u){n(r,o);e=s(e,a,"Password");t=s(t,a,"Salt");u=u||"sha1";return i.pbkdf2Sync(e,t,r,o,u)}if(!i.pbkdf2Sync||i.pbkdf2Sync.toString().indexOf("keylen, digest")===-1){t.pbkdf2Sync=r(2419);t.pbkdf2=r(5539)}else{t.pbkdf2Sync=nativePBKDF2Sync;t.pbkdf2=nativePBKDF2}},5539:function(e,t,r){var i=r(3118).Buffer;var n=r(721);var a=r(908);var s=r(2419);var o=r(7409);var u;var h=__webpack_require__.g.crypto&&__webpack_require__.g.crypto.subtle;var d={sha:"SHA-1","sha-1":"SHA-1",sha1:"SHA-1",sha256:"SHA-256","sha-256":"SHA-256",sha384:"SHA-384","sha-384":"SHA-384","sha-512":"SHA-512",sha512:"SHA-512"};var c=[];function checkNative(e){if(__webpack_require__.g.process&&!__webpack_require__.g.process.browser){return Promise.resolve(false)}if(!h||!h.importKey||!h.deriveBits){return Promise.resolve(false)}if(c[e]!==undefined){return c[e]}u=u||i.alloc(8);var t=browserPbkdf2(u,u,10,128,e).then((function(){return true})).catch((function(){return false}));c[e]=t;return t}function browserPbkdf2(e,t,r,n,a){return h.importKey("raw",e,{name:"PBKDF2"},false,["deriveBits"]).then((function(e){return h.deriveBits({name:"PBKDF2",salt:t,iterations:r,hash:{name:a}},e,n<<3)})).then((function(e){return i.from(e)}))}function resolvePromise(e,t){e.then((function(e){process.nextTick((function(){t(null,e)}))}),(function(e){process.nextTick((function(){t(e)}))}))}e.exports=function(e,t,r,i,u,h){if(typeof u==="function"){h=u;u=undefined}u=u||"sha1";var c=d[u.toLowerCase()];if(!c||typeof __webpack_require__.g.Promise!=="function"){return process.nextTick((function(){var n;try{n=s(e,t,r,i,u)}catch(e){return h(e)}h(null,n)}))}n(r,i);e=o(e,a,"Password");t=o(t,a,"Salt");if(typeof h!=="function")throw new Error("No callback provided to pbkdf2");resolvePromise(checkNative(c).then((function(n){if(n)return browserPbkdf2(e,t,r,i,c);return s(e,t,r,i,u)})),h)}},908:function(e){var t;if(true){t="utf-8"}else { var r; }e.exports=t},721:function(e){var t=Math.pow(2,30)-1;e.exports=function(e,r){if(typeof e!=="number"){throw new TypeError("Iterations not a number")}if(e<0){throw new TypeError("Bad iterations")}if(typeof r!=="number"){throw new TypeError("Key length not a number")}if(r<0||r>t||r!==r){throw new TypeError("Bad key length")}}},2419:function(e,t,r){var i={md5:16,sha1:20,sha224:28,sha256:32,sha384:48,sha512:64,rmd160:20,ripemd160:20};var n=r(2730);var a=r(3118).Buffer;var s=r(721);var o=r(908);var u=r(7409);function pbkdf2(e,t,r,h,d){s(r,h);e=u(e,o,"Password");t=u(t,o,"Salt");d=d||"sha1";var c=a.allocUnsafe(h);var l=a.allocUnsafe(t.length+4);t.copy(l,0,0,t.length);var p=0;var b=i[d];var v=Math.ceil(h/b);for(var m=1;m<=v;m++){l.writeUInt32BE(m,t.length);var y=n(d,e).update(l).digest();var g=y;for(var _=1;_<r;_++){g=n(d,e).update(g).digest();for(var w=0;w<b;w++)y[w]^=g[w]}y.copy(c,p);p+=b}return c}e.exports=pbkdf2},7409:function(e,t,r){var i=r(3118).Buffer;e.exports=function(e,t,r){if(i.isBuffer(e)){return e}else if(typeof e==="string"){return i.from(e,t)}else if(ArrayBuffer.isView(e)){return i.from(e.buffer)}else{throw new TypeError(r+" must be a string, a Buffer, a typed array or a DataView")}}},3501:function(e,t,r){t.publicEncrypt=r(3922);t.privateDecrypt=r(2402);t.privateEncrypt=function privateEncrypt(e,r){return t.publicEncrypt(e,r,true)};t.publicDecrypt=function publicDecrypt(e,r){return t.privateDecrypt(e,r,true)}},22:function(e,t,r){var i=r(2539);var n=r(3118).Buffer;e.exports=function(e,t){var r=n.alloc(0);var a=0;var s;while(r.length<t){s=i2ops(a++);r=n.concat([r,i("sha1").update(e).update(s).digest()])}return r.slice(0,t)};function i2ops(e){var t=n.allocUnsafe(4);t.writeUInt32BE(e,0);return t}},2402:function(e,t,r){var i=r(569);var n=r(22);var a=r(9973);var s=r(6884);var o=r(6236);var u=r(2539);var h=r(8992);var d=r(3118).Buffer;e.exports=function privateDecrypt(e,t,r){var n;if(e.padding){n=e.padding}else if(r){n=1}else{n=4}var a=i(e);var u=a.modulus.byteLength();if(t.length>u||new s(t).cmp(a.modulus)>=0){throw new Error("decryption error")}var c;if(r){c=h(new s(t),a)}else{c=o(t,a)}var l=d.alloc(u-c.length);c=d.concat([l,c],u);if(n===4){return oaep(a,c)}else if(n===1){return pkcs1(a,c,r)}else if(n===3){return c}else{throw new Error("unknown padding")}};function oaep(e,t){var r=e.modulus.byteLength();var i=u("sha1").update(d.alloc(0)).digest();var s=i.length;if(t[0]!==0){throw new Error("decryption error")}var o=t.slice(1,s+1);var h=t.slice(s+1);var c=a(o,n(h,s));var l=a(h,n(c,r-s-1));if(compare(i,l.slice(0,s))){throw new Error("decryption error")}var p=s;while(l[p]===0){p++}if(l[p++]!==1){throw new Error("decryption error")}return l.slice(p)}function pkcs1(e,t,r){var i=t.slice(0,2);var n=2;var a=0;while(t[n++]!==0){if(n>=t.length){a++;break}}var s=t.slice(2,n-1);if(i.toString("hex")!=="0002"&&!r||i.toString("hex")!=="0001"&&r){a++}if(s.length<8){a++}if(a){throw new Error("decryption error")}return t.slice(n)}function compare(e,t){e=d.from(e);t=d.from(t);var r=0;var i=e.length;if(e.length!==t.length){r++;i=Math.min(e.length,t.length)}var n=-1;while(++n<i){r+=e[n]^t[n]}return r}},3922:function(e,t,r){var i=r(569);var n=r(2711);var a=r(2539);var s=r(22);var o=r(9973);var u=r(6884);var h=r(8992);var d=r(6236);var c=r(3118).Buffer;e.exports=function publicEncrypt(e,t,r){var n;if(e.padding){n=e.padding}else if(r){n=1}else{n=4}var a=i(e);var s;if(n===4){s=oaep(a,t)}else if(n===1){s=pkcs1(a,t,r)}else if(n===3){s=new u(t);if(s.cmp(a.modulus)>=0){throw new Error("data too long for modulus")}}else{throw new Error("unknown padding")}if(r){return d(s,a)}else{return h(s,a)}};function oaep(e,t){var r=e.modulus.byteLength();var i=t.length;var h=a("sha1").update(c.alloc(0)).digest();var d=h.length;var l=2*d;if(i>r-l-2){throw new Error("message too long")}var p=c.alloc(r-i-l-2);var b=r-d-1;var v=n(d);var m=o(c.concat([h,p,c.alloc(1,1),t],b),s(v,b));var y=o(v,s(m,d));return new u(c.concat([c.alloc(1),y,m],r))}function pkcs1(e,t,r){var i=t.length;var n=e.modulus.byteLength();if(i>n-11){throw new Error("message too long")}var a;if(r){a=c.alloc(n-i-3,255)}else{a=nonZero(n-i-3)}return new u(c.concat([c.from([0,r?1:2]),a,c.alloc(1),t],n))}function nonZero(e){var t=c.allocUnsafe(e);var r=0;var i=n(e*2);var a=0;var s;while(r<e){if(a===i.length){i=n(e*2);a=0}s=i[a++];if(s){t[r++]=s}}return t}},8992:function(e,t,r){var i=r(6884);var n=r(3118).Buffer;function withPublic(e,t){return n.from(e.toRed(i.mont(t.modulus)).redPow(new i(t.publicExponent)).fromRed().toArray())}e.exports=withPublic},9973:function(e){e.exports=function xor(e,t){var r=e.length;var i=-1;while(++i<r){e[i]^=t[i]}return e}},2711:function(e,t,r){"use strict";var i=65536;var n=4294967295;function oldBrowser(){throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11")}var a=r(3118).Buffer;var s=__webpack_require__.g.crypto||__webpack_require__.g.msCrypto;if(s&&s.getRandomValues){e.exports=randomBytes}else{e.exports=oldBrowser}function randomBytes(e,t){if(e>n)throw new RangeError("requested too many random bytes");var r=a.allocUnsafe(e);if(e>0){if(e>i){for(var o=0;o<e;o+=i){s.getRandomValues(r.slice(o,o+i))}}else{s.getRandomValues(r)}}if(typeof t==="function"){return process.nextTick((function(){t(null,r)}))}return r}},9534:function(e,t,r){"use strict";function oldBrowser(){throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11")}var i=r(3118);var n=r(2711);var a=i.Buffer;var s=i.kMaxLength;var o=__webpack_require__.g.crypto||__webpack_require__.g.msCrypto;var u=Math.pow(2,32)-1;function assertOffset(e,t){if(typeof e!=="number"||e!==e){throw new TypeError("offset must be a number")}if(e>u||e<0){throw new TypeError("offset must be a uint32")}if(e>s||e>t){throw new RangeError("offset out of range")}}function assertSize(e,t,r){if(typeof e!=="number"||e!==e){throw new TypeError("size must be a number")}if(e>u||e<0){throw new TypeError("size must be a uint32")}if(e+t>r||e>s){throw new RangeError("buffer too small")}}if(o&&o.getRandomValues||!true){t.randomFill=randomFill;t.randomFillSync=randomFillSync}else{t.randomFill=oldBrowser;t.randomFillSync=oldBrowser}function randomFill(e,t,r,i){if(!a.isBuffer(e)&&!(e instanceof __webpack_require__.g.Uint8Array)){throw new TypeError('"buf" argument must be a Buffer or Uint8Array')}if(typeof t==="function"){i=t;t=0;r=e.length}else if(typeof r==="function"){i=r;r=e.length-t}else if(typeof i!=="function"){throw new TypeError('"cb" argument must be a function')}assertOffset(t,e.length);assertSize(r,t,e.length);return actualFill(e,t,r,i)}function actualFill(e,t,r,i){if(true){var a=e.buffer;var s=new Uint8Array(a,t,r);o.getRandomValues(s);if(i){process.nextTick((function(){i(null,e)}));return}return e}if(i){n(r,(function(r,n){if(r){return i(r)}n.copy(e,t);i(null,e)}));return}var u=n(r);u.copy(e,t);return e}function randomFillSync(e,t,r){if(typeof t==="undefined"){t=0}if(!a.isBuffer(e)&&!(e instanceof __webpack_require__.g.Uint8Array)){throw new TypeError('"buf" argument must be a Buffer or Uint8Array')}assertOffset(t,e.length);if(r===undefined)r=e.length-t;assertSize(r,t,e.length);return actualFill(e,t,r)}},7455:function(e,t,r){"use strict";var i=r(4300).Buffer;var n=r(7526);var a=r(3421);var s=new Array(16);var o=[0,1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,7,4,13,1,10,6,15,3,12,0,9,5,2,14,11,8,3,10,14,4,9,15,8,1,2,7,0,6,13,11,5,12,1,9,11,10,0,8,12,4,13,3,7,15,14,5,6,2,4,0,5,9,7,12,2,10,14,1,3,8,11,6,15,13];var u=[5,14,7,0,9,2,11,4,13,6,15,8,1,10,3,12,6,11,3,7,0,13,5,10,14,15,8,12,4,9,1,2,15,5,1,3,7,14,6,9,11,8,12,2,10,0,4,13,8,6,4,1,3,11,15,0,5,12,2,13,9,7,10,14,12,15,10,4,1,5,8,7,6,2,13,14,0,3,9,11];var h=[11,14,15,12,5,8,7,9,11,13,14,15,6,7,9,8,7,6,8,13,11,9,7,15,7,12,15,9,11,7,13,12,11,13,6,7,14,9,13,15,14,8,13,6,5,12,7,5,11,12,14,15,14,15,9,8,9,14,5,6,8,6,5,12,9,15,5,11,6,8,13,12,5,12,13,14,11,8,5,6];var d=[8,9,9,11,13,15,15,5,7,7,8,11,14,14,12,6,9,13,15,7,12,8,9,11,7,7,12,7,6,15,13,11,9,7,15,11,8,6,6,14,12,13,5,14,13,13,7,5,15,5,8,11,14,14,6,14,6,9,12,9,12,5,15,8,8,5,12,9,12,5,14,6,8,13,6,5,15,13,11,11];var c=[0,1518500249,1859775393,2400959708,2840853838];var l=[1352829926,1548603684,1836072691,2053994217,0];function RIPEMD160(){a.call(this,64);this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878;this._e=3285377520}n(RIPEMD160,a);RIPEMD160.prototype._update=function(){var e=s;for(var t=0;t<16;++t)e[t]=this._block.readInt32LE(t*4);var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var p=this._e|0;var b=this._a|0;var v=this._b|0;var m=this._c|0;var y=this._d|0;var g=this._e|0;for(var _=0;_<80;_+=1){var w;var M;if(_<16){w=fn1(r,i,n,a,p,e[o[_]],c[0],h[_]);M=fn5(b,v,m,y,g,e[u[_]],l[0],d[_])}else if(_<32){w=fn2(r,i,n,a,p,e[o[_]],c[1],h[_]);M=fn4(b,v,m,y,g,e[u[_]],l[1],d[_])}else if(_<48){w=fn3(r,i,n,a,p,e[o[_]],c[2],h[_]);M=fn3(b,v,m,y,g,e[u[_]],l[2],d[_])}else if(_<64){w=fn4(r,i,n,a,p,e[o[_]],c[3],h[_]);M=fn2(b,v,m,y,g,e[u[_]],l[3],d[_])}else{w=fn5(r,i,n,a,p,e[o[_]],c[4],h[_]);M=fn1(b,v,m,y,g,e[u[_]],l[4],d[_])}r=p;p=a;a=rotl(n,10);n=i;i=w;b=g;g=y;y=rotl(m,10);m=v;v=M}var E=this._b+n+y|0;this._b=this._c+a+g|0;this._c=this._d+p+b|0;this._d=this._e+r+v|0;this._e=this._a+i+m|0;this._a=E};RIPEMD160.prototype._digest=function(){this._block[this._blockOffset++]=128;if(this._blockOffset>56){this._block.fill(0,this._blockOffset,64);this._update();this._blockOffset=0}this._block.fill(0,this._blockOffset,56);this._block.writeUInt32LE(this._length[0],56);this._block.writeUInt32LE(this._length[1],60);this._update();var e=i.alloc?i.alloc(20):new i(20);e.writeInt32LE(this._a,0);e.writeInt32LE(this._b,4);e.writeInt32LE(this._c,8);e.writeInt32LE(this._d,12);e.writeInt32LE(this._e,16);return e};function rotl(e,t){return e<<t|e>>>32-t}function fn1(e,t,r,i,n,a,s,o){return rotl(e+(t^r^i)+a+s|0,o)+n|0}function fn2(e,t,r,i,n,a,s,o){return rotl(e+(t&r|~t&i)+a+s|0,o)+n|0}function fn3(e,t,r,i,n,a,s,o){return rotl(e+((t|~r)^i)+a+s|0,o)+n|0}function fn4(e,t,r,i,n,a,s,o){return rotl(e+(t&i|r&~i)+a+s|0,o)+n|0}function fn5(e,t,r,i,n,a,s,o){return rotl(e+(t^(r|~i))+a+s|0,o)+n|0}e.exports=RIPEMD160},3118:function(e,t,r){var i=r(4300);var n=i.Buffer;function copyProps(e,t){for(var r in e){t[r]=e[r]}}if(n.from&&n.alloc&&n.allocUnsafe&&n.allocUnsafeSlow){e.exports=i}else{copyProps(i,t);t.Buffer=SafeBuffer}function SafeBuffer(e,t,r){return n(e,t,r)}SafeBuffer.prototype=Object.create(n.prototype);copyProps(n,SafeBuffer);SafeBuffer.from=function(e,t,r){if(typeof e==="number"){throw new TypeError("Argument must not be a number")}return n(e,t,r)};SafeBuffer.alloc=function(e,t,r){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}var i=n(e);if(t!==undefined){if(typeof r==="string"){i.fill(t,r)}else{i.fill(t)}}else{i.fill(0)}return i};SafeBuffer.allocUnsafe=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return n(e)};SafeBuffer.allocUnsafeSlow=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return i.SlowBuffer(e)}},7782:function(e,t,r){var i=r(3118).Buffer;function Hash(e,t){this._block=i.alloc(e);this._finalSize=t;this._blockSize=e;this._len=0}Hash.prototype.update=function(e,t){if(typeof e==="string"){t=t||"utf8";e=i.from(e,t)}var r=this._block;var n=this._blockSize;var a=e.length;var s=this._len;for(var o=0;o<a;){var u=s%n;var h=Math.min(a-o,n-u);for(var d=0;d<h;d++){r[u+d]=e[o+d]}s+=h;o+=h;if(s%n===0){this._update(r)}}this._len+=a;return this};Hash.prototype.digest=function(e){var t=this._len%this._blockSize;this._block[t]=128;this._block.fill(0,t+1);if(t>=this._finalSize){this._update(this._block);this._block.fill(0)}var r=this._len*8;if(r<=4294967295){this._block.writeUInt32BE(r,this._blockSize-4)}else{var i=(r&4294967295)>>>0;var n=(r-i)/4294967296;this._block.writeUInt32BE(n,this._blockSize-8);this._block.writeUInt32BE(i,this._blockSize-4)}this._update(this._block);var a=this._hash();return e?a.toString(e):a};Hash.prototype._update=function(){throw new Error("_update must be implemented by subclass")};e.exports=Hash},1862:function(e,t,r){var i=e.exports=function SHA(e){e=e.toLowerCase();var t=i[e];if(!t)throw new Error(e+" is not supported (we accept pull requests)");return new t};i.sha=r(2003);i.sha1=r(5645);i.sha224=r(7741);i.sha256=r(9642);i.sha384=r(3869);i.sha512=r(3741)},2003:function(e,t,r){var i=r(7526);var n=r(7782);var a=r(3118).Buffer;var s=[1518500249,1859775393,2400959708|0,3395469782|0];var o=new Array(80);function Sha(){this.init();this._w=o;n.call(this,64,56)}i(Sha,n);Sha.prototype.init=function(){this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878;this._e=3285377520;return this};function rotl5(e){return e<<5|e>>>27}function rotl30(e){return e<<30|e>>>2}function ft(e,t,r,i){if(e===0)return t&r|~t&i;if(e===2)return t&r|t&i|r&i;return t^r^i}Sha.prototype._update=function(e){var t=this._w;var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var o=this._e|0;for(var u=0;u<16;++u)t[u]=e.readInt32BE(u*4);for(;u<80;++u)t[u]=t[u-3]^t[u-8]^t[u-14]^t[u-16];for(var h=0;h<80;++h){var d=~~(h/20);var c=rotl5(r)+ft(d,i,n,a)+o+t[h]+s[d]|0;o=a;a=n;n=rotl30(i);i=r;r=c}this._a=r+this._a|0;this._b=i+this._b|0;this._c=n+this._c|0;this._d=a+this._d|0;this._e=o+this._e|0};Sha.prototype._hash=function(){var e=a.allocUnsafe(20);e.writeInt32BE(this._a|0,0);e.writeInt32BE(this._b|0,4);e.writeInt32BE(this._c|0,8);e.writeInt32BE(this._d|0,12);e.writeInt32BE(this._e|0,16);return e};e.exports=Sha},5645:function(e,t,r){var i=r(7526);var n=r(7782);var a=r(3118).Buffer;var s=[1518500249,1859775393,2400959708|0,3395469782|0];var o=new Array(80);function Sha1(){this.init();this._w=o;n.call(this,64,56)}i(Sha1,n);Sha1.prototype.init=function(){this._a=1732584193;this._b=4023233417;this._c=2562383102;this._d=271733878;this._e=3285377520;return this};function rotl1(e){return e<<1|e>>>31}function rotl5(e){return e<<5|e>>>27}function rotl30(e){return e<<30|e>>>2}function ft(e,t,r,i){if(e===0)return t&r|~t&i;if(e===2)return t&r|t&i|r&i;return t^r^i}Sha1.prototype._update=function(e){var t=this._w;var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var o=this._e|0;for(var u=0;u<16;++u)t[u]=e.readInt32BE(u*4);for(;u<80;++u)t[u]=rotl1(t[u-3]^t[u-8]^t[u-14]^t[u-16]);for(var h=0;h<80;++h){var d=~~(h/20);var c=rotl5(r)+ft(d,i,n,a)+o+t[h]+s[d]|0;o=a;a=n;n=rotl30(i);i=r;r=c}this._a=r+this._a|0;this._b=i+this._b|0;this._c=n+this._c|0;this._d=a+this._d|0;this._e=o+this._e|0};Sha1.prototype._hash=function(){var e=a.allocUnsafe(20);e.writeInt32BE(this._a|0,0);e.writeInt32BE(this._b|0,4);e.writeInt32BE(this._c|0,8);e.writeInt32BE(this._d|0,12);e.writeInt32BE(this._e|0,16);return e};e.exports=Sha1},7741:function(e,t,r){var i=r(7526);var n=r(9642);var a=r(7782);var s=r(3118).Buffer;var o=new Array(64);function Sha224(){this.init();this._w=o;a.call(this,64,56)}i(Sha224,n);Sha224.prototype.init=function(){this._a=3238371032;this._b=914150663;this._c=812702999;this._d=4144912697;this._e=4290775857;this._f=1750603025;this._g=1694076839;this._h=3204075428;return this};Sha224.prototype._hash=function(){var e=s.allocUnsafe(28);e.writeInt32BE(this._a,0);e.writeInt32BE(this._b,4);e.writeInt32BE(this._c,8);e.writeInt32BE(this._d,12);e.writeInt32BE(this._e,16);e.writeInt32BE(this._f,20);e.writeInt32BE(this._g,24);return e};e.exports=Sha224},9642:function(e,t,r){var i=r(7526);var n=r(7782);var a=r(3118).Buffer;var s=[1116352408,1899447441,3049323471,3921009573,961987163,1508970993,2453635748,2870763221,3624381080,310598401,607225278,1426881987,1925078388,2162078206,2614888103,3248222580,3835390401,4022224774,264347078,604807628,770255983,1249150122,1555081692,1996064986,2554220882,2821834349,2952996808,3210313671,3336571891,3584528711,113926993,338241895,666307205,773529912,1294757372,1396182291,1695183700,1986661051,2177026350,2456956037,2730485921,2820302411,3259730800,3345764771,3516065817,3600352804,4094571909,275423344,430227734,506948616,659060556,883997877,958139571,1322822218,1537002063,1747873779,1955562222,2024104815,2227730452,2361852424,2428436474,2756734187,3204031479,3329325298];var o=new Array(64);function Sha256(){this.init();this._w=o;n.call(this,64,56)}i(Sha256,n);Sha256.prototype.init=function(){this._a=1779033703;this._b=3144134277;this._c=1013904242;this._d=2773480762;this._e=1359893119;this._f=2600822924;this._g=528734635;this._h=1541459225;return this};function ch(e,t,r){return r^e&(t^r)}function maj(e,t,r){return e&t|r&(e|t)}function sigma0(e){return(e>>>2|e<<30)^(e>>>13|e<<19)^(e>>>22|e<<10)}function sigma1(e){return(e>>>6|e<<26)^(e>>>11|e<<21)^(e>>>25|e<<7)}function gamma0(e){return(e>>>7|e<<25)^(e>>>18|e<<14)^e>>>3}function gamma1(e){return(e>>>17|e<<15)^(e>>>19|e<<13)^e>>>10}Sha256.prototype._update=function(e){var t=this._w;var r=this._a|0;var i=this._b|0;var n=this._c|0;var a=this._d|0;var o=this._e|0;var u=this._f|0;var h=this._g|0;var d=this._h|0;for(var c=0;c<16;++c)t[c]=e.readInt32BE(c*4);for(;c<64;++c)t[c]=gamma1(t[c-2])+t[c-7]+gamma0(t[c-15])+t[c-16]|0;for(var l=0;l<64;++l){var p=d+sigma1(o)+ch(o,u,h)+s[l]+t[l]|0;var b=sigma0(r)+maj(r,i,n)|0;d=h;h=u;u=o;o=a+p|0;a=n;n=i;i=r;r=p+b|0}this._a=r+this._a|0;this._b=i+this._b|0;this._c=n+this._c|0;this._d=a+this._d|0;this._e=o+this._e|0;this._f=u+this._f|0;this._g=h+this._g|0;this._h=d+this._h|0};Sha256.prototype._hash=function(){var e=a.allocUnsafe(32);e.writeInt32BE(this._a,0);e.writeInt32BE(this._b,4);e.writeInt32BE(this._c,8);e.writeInt32BE(this._d,12);e.writeInt32BE(this._e,16);e.writeInt32BE(this._f,20);e.writeInt32BE(this._g,24);e.writeInt32BE(this._h,28);return e};e.exports=Sha256},3869:function(e,t,r){var i=r(7526);var n=r(3741);var a=r(7782);var s=r(3118).Buffer;var o=new Array(160);function Sha384(){this.init();this._w=o;a.call(this,128,112)}i(Sha384,n);Sha384.prototype.init=function(){this._ah=3418070365;this._bh=1654270250;this._ch=2438529370;this._dh=355462360;this._eh=1731405415;this._fh=2394180231;this._gh=3675008525;this._hh=1203062813;this._al=3238371032;this._bl=914150663;this._cl=812702999;this._dl=4144912697;this._el=4290775857;this._fl=1750603025;this._gl=1694076839;this._hl=3204075428;return this};Sha384.prototype._hash=function(){var e=s.allocUnsafe(48);function writeInt64BE(t,r,i){e.writeInt32BE(t,i);e.writeInt32BE(r,i+4)}writeInt64BE(this._ah,this._al,0);writeInt64BE(this._bh,this._bl,8);writeInt64BE(this._ch,this._cl,16);writeInt64BE(this._dh,this._dl,24);writeInt64BE(this._eh,this._el,32);writeInt64BE(this._fh,this._fl,40);return e};e.exports=Sha384},3741:function(e,t,r){var i=r(7526);var n=r(7782);var a=r(3118).Buffer;var s=[1116352408,3609767458,1899447441,602891725,3049323471,3964484399,3921009573,2173295548,961987163,4081628472,1508970993,3053834265,2453635748,2937671579,2870763221,3664609560,3624381080,2734883394,310598401,1164996542,607225278,1323610764,1426881987,3590304994,1925078388,4068182383,2162078206,991336113,2614888103,633803317,3248222580,3479774868,3835390401,2666613458,4022224774,944711139,264347078,2341262773,604807628,2007800933,770255983,1495990901,1249150122,1856431235,1555081692,3175218132,1996064986,2198950837,2554220882,3999719339,2821834349,766784016,2952996808,2566594879,3210313671,3203337956,3336571891,1034457026,3584528711,2466948901,113926993,3758326383,338241895,168717936,666307205,1188179964,773529912,1546045734,1294757372,1522805485,1396182291,2643833823,1695183700,2343527390,1986661051,1014477480,2177026350,1206759142,2456956037,344077627,2730485921,1290863460,2820302411,3158454273,3259730800,3505952657,3345764771,106217008,3516065817,3606008344,3600352804,1432725776,4094571909,1467031594,275423344,851169720,430227734,3100823752,506948616,1363258195,659060556,3750685593,883997877,3785050280,958139571,3318307427,1322822218,3812723403,1537002063,2003034995,1747873779,3602036899,1955562222,1575990012,2024104815,1125592928,2227730452,2716904306,2361852424,442776044,2428436474,593698344,2756734187,3733110249,3204031479,2999351573,3329325298,3815920427,3391569614,3928383900,3515267271,566280711,3940187606,3454069534,4118630271,4000239992,116418474,1914138554,174292421,2731055270,289380356,3203993006,460393269,320620315,685471733,587496836,852142971,1086792851,1017036298,365543100,1126000580,2618297676,1288033470,3409855158,1501505948,4234509866,1607167915,987167468,1816402316,1246189591];var o=new Array(160);function Sha512(){this.init();this._w=o;n.call(this,128,112)}i(Sha512,n);Sha512.prototype.init=function(){this._ah=1779033703;this._bh=3144134277;this._ch=1013904242;this._dh=2773480762;this._eh=1359893119;this._fh=2600822924;this._gh=528734635;this._hh=1541459225;this._al=4089235720;this._bl=2227873595;this._cl=4271175723;this._dl=1595750129;this._el=2917565137;this._fl=725511199;this._gl=4215389547;this._hl=327033209;return this};function Ch(e,t,r){return r^e&(t^r)}function maj(e,t,r){return e&t|r&(e|t)}function sigma0(e,t){return(e>>>28|t<<4)^(t>>>2|e<<30)^(t>>>7|e<<25)}function sigma1(e,t){return(e>>>14|t<<18)^(e>>>18|t<<14)^(t>>>9|e<<23)}function Gamma0(e,t){return(e>>>1|t<<31)^(e>>>8|t<<24)^e>>>7}function Gamma0l(e,t){return(e>>>1|t<<31)^(e>>>8|t<<24)^(e>>>7|t<<25)}function Gamma1(e,t){return(e>>>19|t<<13)^(t>>>29|e<<3)^e>>>6}function Gamma1l(e,t){return(e>>>19|t<<13)^(t>>>29|e<<3)^(e>>>6|t<<26)}function getCarry(e,t){return e>>>0<t>>>0?1:0}Sha512.prototype._update=function(e){var t=this._w;var r=this._ah|0;var i=this._bh|0;var n=this._ch|0;var a=this._dh|0;var o=this._eh|0;var u=this._fh|0;var h=this._gh|0;var d=this._hh|0;var c=this._al|0;var l=this._bl|0;var p=this._cl|0;var b=this._dl|0;var v=this._el|0;var m=this._fl|0;var y=this._gl|0;var g=this._hl|0;for(var _=0;_<32;_+=2){t[_]=e.readInt32BE(_*4);t[_+1]=e.readInt32BE(_*4+4)}for(;_<160;_+=2){var w=t[_-15*2];var M=t[_-15*2+1];var E=Gamma0(w,M);var B=Gamma0l(M,w);w=t[_-2*2];M=t[_-2*2+1];var k=Gamma1(w,M);var A=Gamma1l(M,w);var N=t[_-7*2];var P=t[_-7*2+1];var x=t[_-16*2];var C=t[_-16*2+1];var T=B+P|0;var I=E+N+getCarry(T,B)|0;T=T+A|0;I=I+k+getCarry(T,A)|0;T=T+C|0;I=I+x+getCarry(T,C)|0;t[_]=I;t[_+1]=T}for(var D=0;D<160;D+=2){I=t[D];T=t[D+1];var O=maj(r,i,n);var j=maj(c,l,p);var L=sigma0(r,c);var q=sigma0(c,r);var H=sigma1(o,v);var F=sigma1(v,o);var U=s[D];var z=s[D+1];var W=Ch(o,u,h);var V=Ch(v,m,y);var G=g+F|0;var J=d+H+getCarry(G,g)|0;G=G+V|0;J=J+W+getCarry(G,V)|0;G=G+z|0;J=J+U+getCarry(G,z)|0;G=G+T|0;J=J+I+getCarry(G,T)|0;var Z=q+j|0;var X=L+O+getCarry(Z,q)|0;d=h;g=y;h=u;y=m;u=o;m=v;v=b+G|0;o=a+J+getCarry(v,b)|0;a=n;b=p;n=i;p=l;i=r;l=c;c=G+Z|0;r=J+X+getCarry(c,G)|0}this._al=this._al+c|0;this._bl=this._bl+l|0;this._cl=this._cl+p|0;this._dl=this._dl+b|0;this._el=this._el+v|0;this._fl=this._fl+m|0;this._gl=this._gl+y|0;this._hl=this._hl+g|0;this._ah=this._ah+r+getCarry(this._al,c)|0;this._bh=this._bh+i+getCarry(this._bl,l)|0;this._ch=this._ch+n+getCarry(this._cl,p)|0;this._dh=this._dh+a+getCarry(this._dl,b)|0;this._eh=this._eh+o+getCarry(this._el,v)|0;this._fh=this._fh+u+getCarry(this._fl,m)|0;this._gh=this._gh+h+getCarry(this._gl,y)|0;this._hh=this._hh+d+getCarry(this._hl,g)|0};Sha512.prototype._hash=function(){var e=a.allocUnsafe(64);function writeInt64BE(t,r,i){e.writeInt32BE(t,i);e.writeInt32BE(r,i+4)}writeInt64BE(this._ah,this._al,0);writeInt64BE(this._bh,this._bl,8);writeInt64BE(this._ch,this._cl,16);writeInt64BE(this._dh,this._dl,24);writeInt64BE(this._eh,this._el,32);writeInt64BE(this._fh,this._fl,40);writeInt64BE(this._gh,this._gl,48);writeInt64BE(this._hh,this._hl,56);return e};e.exports=Sha512},5121:function(e){e.exports=deprecate;function deprecate(e,t){if(config("noDeprecation")){return e}var r=false;function deprecated(){if(!r){if(config("throwDeprecation")){throw new Error(t)}else if(config("traceDeprecation")){console.trace(t)}else{console.warn(t)}r=true}return e.apply(this,arguments)}return deprecated}function config(e){try{if(!__webpack_require__.g.localStorage)return false}catch(e){return false}var t=__webpack_require__.g.localStorage[e];if(null==t)return false;return String(t).toLowerCase()==="true"}},4300:function(e){"use strict";e.exports=__webpack_require__(48764)},6113:function(e){"use strict";e.exports=__webpack_require__(42474)},2361:function(e){"use strict";e.exports=__webpack_require__(17187)},2781:function(e){"use strict";e.exports=__webpack_require__(79681)},1576:function(e){"use strict";e.exports=__webpack_require__(32553)},3837:function(e){"use strict";e.exports=__webpack_require__(79720)},6144:function(e){"use strict";e.exports=__webpack_require__(51951)},9234:function(e){"use strict";e.exports=JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}')},26:function(e){"use strict";e.exports=JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}')},9167:function(e){"use strict";e.exports=JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}')},3418:function(e){"use strict";e.exports=JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}')},763:function(e){"use strict";e.exports={i8:"6.5.3"}},8675:function(e){"use strict";e.exports=JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}')}};var t={};function __nccwpck_require__(r){var i=t[r];if(i!==undefined){return i.exports}var n=t[r]={id:r,loaded:false,exports:{}};var a=true;try{e[r].call(n.exports,n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}n.loaded=true;return n.exports}!function(){__nccwpck_require__.nmd=function(e){e.paths=[];if(!e.children)e.children=[];return e}}();if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r={};!function(){"use strict";var e=r;e.randomBytes=e.rng=e.pseudoRandomBytes=e.prng=__nccwpck_require__(2711);e.createHash=e.Hash=__nccwpck_require__(2539);e.createHmac=e.Hmac=__nccwpck_require__(2730);var t=__nccwpck_require__(5703);var i=Object.keys(t);var n=["sha1","sha224","sha256","sha384","sha512","md5","rmd160"].concat(i);e.getHashes=function(){return n};var a=__nccwpck_require__(785);e.pbkdf2=a.pbkdf2;e.pbkdf2Sync=a.pbkdf2Sync;var s=__nccwpck_require__(57);e.Cipher=s.Cipher;e.createCipher=s.createCipher;e.Cipheriv=s.Cipheriv;e.createCipheriv=s.createCipheriv;e.Decipher=s.Decipher;e.createDecipher=s.createDecipher;e.Decipheriv=s.Decipheriv;e.createDecipheriv=s.createDecipheriv;e.getCiphers=s.getCiphers;e.listCiphers=s.listCiphers;var o=__nccwpck_require__(9977);e.DiffieHellmanGroup=o.DiffieHellmanGroup;e.createDiffieHellmanGroup=o.createDiffieHellmanGroup;e.getDiffieHellman=o.getDiffieHellman;e.createDiffieHellman=o.createDiffieHellman;e.DiffieHellman=o.DiffieHellman;var u=__nccwpck_require__(1265);e.createSign=u.createSign;e.Sign=u.Sign;e.createVerify=u.createVerify;e.Verify=u.Verify;e.createECDH=__nccwpck_require__(7354);var h=__nccwpck_require__(3501);e.publicEncrypt=h.publicEncrypt;e.privateEncrypt=h.privateEncrypt;e.publicDecrypt=h.publicDecrypt;e.privateDecrypt=h.privateDecrypt;var d=__nccwpck_require__(9534);e.randomFill=d.randomFill;e.randomFillSync=d.randomFillSync;e.createCredentials=function(){throw new Error(["sorry, createCredentials is not implemented yet","we accept pull requests","https://github.com/crypto-browserify/crypto-browserify"].join("\n"))};e.constants={DH_CHECK_P_NOT_SAFE_PRIME:2,DH_CHECK_P_NOT_PRIME:1,DH_UNABLE_TO_CHECK_GENERATOR:4,DH_NOT_SUITABLE_GENERATOR:8,NPN_ENABLED:1,ALPN_ENABLED:1,RSA_PKCS1_PADDING:1,RSA_SSLV23_PADDING:2,RSA_NO_PADDING:3,RSA_PKCS1_OAEP_PADDING:4,RSA_X931_PADDING:5,RSA_PKCS1_PSS_PADDING:6,POINT_CONVERSION_COMPRESSED:2,POINT_CONVERSION_UNCOMPRESSED:4,POINT_CONVERSION_HYBRID:6}}();module.exports=r})();

/***/ }),

/***/ 78428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
(function(){var r={750:function(r,e,t){var o=t(685);var a=t(310);var i=r.exports;for(var n in o){if(o.hasOwnProperty(n))i[n]=o[n]}i.request=function(r,e){r=validateParams(r);return o.request.call(this,r,e)};i.get=function(r,e){r=validateParams(r);return o.get.call(this,r,e)};function validateParams(r){if(typeof r==="string"){r=a.parse(r)}if(!r.protocol){r.protocol="https:"}if(r.protocol!=="https:"){throw new Error('Protocol "'+r.protocol+'" not supported. Expected "https:"')}return r}},685:function(r){"use strict";r.exports=__webpack_require__(22321)},310:function(r){"use strict";r.exports=__webpack_require__(11987)}};var e={};function __nccwpck_require__(t){var o=e[t];if(o!==undefined){return o.exports}var a=e[t]={exports:{}};var i=true;try{r[t](a,a.exports,__nccwpck_require__);i=false}finally{if(i)delete e[t]}return a.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(750);module.exports=t})();

/***/ }),

/***/ 52490:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 46848:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 97039:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 11987:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
(function(){var e={477:function(e){"use strict";e.exports=__webpack_require__(97334)}};var t={};function __nccwpck_require__(o){var a=t[o];if(a!==undefined){return a.exports}var s=t[o]={exports:{}};var n=true;try{e[o](s,s.exports,__nccwpck_require__);n=false}finally{if(n)delete t[o]}return s.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var o={};!function(){var e=o;var t,a=(t=__nccwpck_require__(477))&&"object"==typeof t&&"default"in t?t.default:t,s=/https?|ftp|gopher|file/;function r(e){"string"==typeof e&&(e=d(e));var t=function(e,t,o){var a=e.auth,s=e.hostname,n=e.protocol||"",p=e.pathname||"",c=e.hash||"",i=e.query||"",u=!1;a=a?encodeURIComponent(a).replace(/%3A/i,":")+"@":"",e.host?u=a+e.host:s&&(u=a+(~s.indexOf(":")?"["+s+"]":s),e.port&&(u+=":"+e.port)),i&&"object"==typeof i&&(i=t.encode(i));var f=e.search||i&&"?"+i||"";return n&&":"!==n.substr(-1)&&(n+=":"),e.slashes||(!n||o.test(n))&&!1!==u?(u="//"+(u||""),p&&"/"!==p[0]&&(p="/"+p)):u||(u=""),c&&"#"!==c[0]&&(c="#"+c),f&&"?"!==f[0]&&(f="?"+f),{protocol:n,host:u,pathname:p=p.replace(/[?#]/g,encodeURIComponent),search:f=f.replace("#","%23"),hash:c}}(e,a,s);return""+t.protocol+t.host+t.pathname+t.search+t.hash}var n="http://",p="w.w",c=n+p,i=/^([a-z0-9.+-]*:\/\/\/)([a-z0-9.+-]:\/*)?/i,u=/https?|ftp|gopher|file/;function h(e,t){var o="string"==typeof e?d(e):e;e="object"==typeof e?r(e):e;var a=d(t),s="";o.protocol&&!o.slashes&&(s=o.protocol,e=e.replace(o.protocol,""),s+="/"===t[0]||"/"===e[0]?"/":""),s&&a.protocol&&(s="",a.slashes||(s=a.protocol,t=t.replace(a.protocol,"")));var p=e.match(i);p&&!a.protocol&&(e=e.substr((s=p[1]+(p[2]||"")).length),/^\/\/[^/]/.test(t)&&(s=s.slice(0,-1)));var f=new URL(e,c+"/"),m=new URL(t,f).toString().replace(c,""),v=a.protocol||o.protocol;return v+=o.slashes||a.slashes?"//":"",!s&&v?m=m.replace(n,v):s&&(m=m.replace(n,"")),u.test(m)||~t.indexOf(".")||"/"===e.slice(-1)||"/"===t.slice(-1)||"/"!==m.slice(-1)||(m=m.slice(0,-1)),s&&(m=s+("/"===m[0]?m.substr(1):m)),m}function l(){}l.prototype.parse=d,l.prototype.format=r,l.prototype.resolve=h,l.prototype.resolveObject=h;var f=/^https?|ftp|gopher|file/,m=/^(.*?)([#?].*)/,v=/^([a-z0-9.+-]*:)(\/{0,3})(.*)/i,_=/^([a-z0-9.+-]*:)?\/\/\/*/i,b=/^([a-z0-9.+-]*:)(\/{0,2})\[(.*)\]$/i;function d(e,t,o){if(void 0===t&&(t=!1),void 0===o&&(o=!1),e&&"object"==typeof e&&e instanceof l)return e;var s=(e=e.trim()).match(m);e=s?s[1].replace(/\\/g,"/")+s[2]:e.replace(/\\/g,"/"),b.test(e)&&"/"!==e.slice(-1)&&(e+="/");var n=!/(^javascript)/.test(e)&&e.match(v),i=_.test(e),u="";n&&(f.test(n[1])||(u=n[1].toLowerCase(),e=""+n[2]+n[3]),n[2]||(i=!1,f.test(n[1])?(u=n[1],e=""+n[3]):e="//"+n[3]),3!==n[2].length&&1!==n[2].length||(u=n[1],e="/"+n[3]));var g,y=(s?s[1]:e).match(/^https?:\/\/[^/]+(:[0-9]+)(?=\/|$)/),w=y&&y[1],C=new l,U="",j="";try{g=new URL(e)}catch(t){U=t,u||o||!/^\/\//.test(e)||/^\/\/.+[@.]/.test(e)||(j="/",e=e.substr(1));try{g=new URL(e,c)}catch(e){return C.protocol=u,C.href=u,C}}C.slashes=i&&!j,C.host=g.host===p?"":g.host,C.hostname=g.hostname===p?"":g.hostname.replace(/(\[|\])/g,""),C.protocol=U?u||null:g.protocol,C.search=g.search.replace(/\\/g,"%5C"),C.hash=g.hash.replace(/\\/g,"%5C");var x=e.split("#");!C.search&&~x[0].indexOf("?")&&(C.search="?"),C.hash||""!==x[1]||(C.hash="#"),C.query=t?a.decode(g.search.substr(1)):C.search.substr(1),C.pathname=j+(n?function(e){return e.replace(/['^|`]/g,(function(e){return"%"+e.charCodeAt().toString(16).toUpperCase()})).replace(/((?:%[0-9A-F]{2})+)/g,(function(e,t){try{return decodeURIComponent(t).split("").map((function(e){var t=e.charCodeAt();return t>256||/^[a-z0-9]$/i.test(e)?e:"%"+t.toString(16).toUpperCase()})).join("")}catch(e){return t}}))}(g.pathname):g.pathname),"about:"===C.protocol&&"blank"===C.pathname&&(C.protocol="",C.pathname=""),U&&"/"!==e[0]&&(C.pathname=C.pathname.substr(1)),u&&!f.test(u)&&"/"!==e.slice(-1)&&"/"===C.pathname&&(C.pathname=""),C.path=C.pathname+C.search,C.auth=[g.username,g.password].map(decodeURIComponent).filter(Boolean).join(":"),C.port=g.port,w&&!C.host.endsWith(w)&&(C.host+=w,C.port=w.slice(1)),C.href=j?""+C.pathname+C.search+C.hash:r(C);var q=/^(file)/.test(C.href)?["host","hostname"]:[];return Object.keys(C).forEach((function(e){~q.indexOf(e)||(C[e]=C[e]||null)})),C}e.parse=d,e.format=r,e.resolve=h,e.resolveObject=function(e,t){return d(h(e,t))},e.Url=l}();module.exports=o})();

/***/ }),

/***/ 73461:
/***/ (function(module) {

var __dirname = "/";
(function(){if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var n={};!function(){var e=n;e.endianness=function(){return"LE"};e.hostname=function(){if(typeof location!=="undefined"){return location.hostname}else return""};e.loadavg=function(){return[]};e.uptime=function(){return 0};e.freemem=function(){return Number.MAX_VALUE};e.totalmem=function(){return Number.MAX_VALUE};e.cpus=function(){return[]};e.type=function(){return"Browser"};e.release=function(){if(typeof navigator!=="undefined"){return navigator.appVersion}return""};e.networkInterfaces=e.getNetworkInterfaces=function(){return{}};e.arch=function(){return"javascript"};e.platform=function(){return"browser"};e.tmpdir=e.tmpDir=function(){return"/tmp"};e.EOL="\n";e.homedir=function(){return"/"}}();module.exports=n})();

/***/ }),

/***/ 77663:
/***/ (function(module) {

var __dirname = "/";
(function(){var e={162:function(e){var t=e.exports={};var r;var n;function defaultSetTimout(){throw new Error("setTimeout has not been defined")}function defaultClearTimeout(){throw new Error("clearTimeout has not been defined")}(function(){try{if(typeof setTimeout==="function"){r=setTimeout}else{r=defaultSetTimout}}catch(e){r=defaultSetTimout}try{if(typeof clearTimeout==="function"){n=clearTimeout}else{n=defaultClearTimeout}}catch(e){n=defaultClearTimeout}})();function runTimeout(e){if(r===setTimeout){return setTimeout(e,0)}if((r===defaultSetTimout||!r)&&setTimeout){r=setTimeout;return setTimeout(e,0)}try{return r(e,0)}catch(t){try{return r.call(null,e,0)}catch(t){return r.call(this,e,0)}}}function runClearTimeout(e){if(n===clearTimeout){return clearTimeout(e)}if((n===defaultClearTimeout||!n)&&clearTimeout){n=clearTimeout;return clearTimeout(e)}try{return n(e)}catch(t){try{return n.call(null,e)}catch(t){return n.call(this,e)}}}var i=[];var o=false;var u;var a=-1;function cleanUpNextTick(){if(!o||!u){return}o=false;if(u.length){i=u.concat(i)}else{a=-1}if(i.length){drainQueue()}}function drainQueue(){if(o){return}var e=runTimeout(cleanUpNextTick);o=true;var t=i.length;while(t){u=i;i=[];while(++a<t){if(u){u[a].run()}}a=-1;t=i.length}u=null;o=false;runClearTimeout(e)}t.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1){for(var r=1;r<arguments.length;r++){t[r-1]=arguments[r]}}i.push(new Item(e,t));if(i.length===1&&!o){runTimeout(drainQueue)}};function Item(e,t){this.fun=e;this.array=t}Item.prototype.run=function(){this.fun.apply(null,this.array)};t.title="browser";t.browser=true;t.env={};t.argv=[];t.version="";t.versions={};function noop(){}t.on=noop;t.addListener=noop;t.once=noop;t.off=noop;t.removeListener=noop;t.removeAllListeners=noop;t.emit=noop;t.prependListener=noop;t.prependOnceListener=noop;t.listeners=function(e){return[]};t.binding=function(e){throw new Error("process.binding is not supported")};t.cwd=function(){return"/"};t.chdir=function(e){throw new Error("process.chdir is not supported")};t.umask=function(){return 0}}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var o=true;try{e[r](i,i.exports,__nccwpck_require__);o=false}finally{if(o)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(162);module.exports=r})();

/***/ }),

/***/ 97334:
/***/ (function(module) {

var __dirname = "/";
(function(){"use strict";var e={540:function(e){function hasOwnProperty(e,r){return Object.prototype.hasOwnProperty.call(e,r)}e.exports=function(e,n,t,o){n=n||"&";t=t||"=";var a={};if(typeof e!=="string"||e.length===0){return a}var i=/\+/g;e=e.split(n);var u=1e3;if(o&&typeof o.maxKeys==="number"){u=o.maxKeys}var c=e.length;if(u>0&&c>u){c=u}for(var p=0;p<c;++p){var f=e[p].replace(i,"%20"),s=f.indexOf(t),_,l,y,d;if(s>=0){_=f.substr(0,s);l=f.substr(s+1)}else{_=f;l=""}y=decodeURIComponent(_);d=decodeURIComponent(l);if(!hasOwnProperty(a,y)){a[y]=d}else if(r(a[y])){a[y].push(d)}else{a[y]=[a[y],d]}}return a};var r=Array.isArray||function(e){return Object.prototype.toString.call(e)==="[object Array]"}},128:function(e){var stringifyPrimitive=function(e){switch(typeof e){case"string":return e;case"boolean":return e?"true":"false";case"number":return isFinite(e)?e:"";default:return""}};e.exports=function(e,t,o,a){t=t||"&";o=o||"=";if(e===null){e=undefined}if(typeof e==="object"){return map(n(e),(function(n){var a=encodeURIComponent(stringifyPrimitive(n))+o;if(r(e[n])){return map(e[n],(function(e){return a+encodeURIComponent(stringifyPrimitive(e))})).join(t)}else{return a+encodeURIComponent(stringifyPrimitive(e[n]))}})).join(t)}if(!a)return"";return encodeURIComponent(stringifyPrimitive(a))+o+encodeURIComponent(stringifyPrimitive(e))};var r=Array.isArray||function(e){return Object.prototype.toString.call(e)==="[object Array]"};function map(e,r){if(e.map)return e.map(r);var n=[];for(var t=0;t<e.length;t++){n.push(r(e[t],t))}return n}var n=Object.keys||function(e){var r=[];for(var n in e){if(Object.prototype.hasOwnProperty.call(e,n))r.push(n)}return r}}};var r={};function __nccwpck_require__(n){var t=r[n];if(t!==undefined){return t.exports}var o=r[n]={exports:{}};var a=true;try{e[n](o,o.exports,__nccwpck_require__);a=false}finally{if(a)delete r[n]}return o.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var n={};!function(){var e=n;e.decode=e.parse=__nccwpck_require__(540);e.encode=e.stringify=__nccwpck_require__(128)}();module.exports=n})();

/***/ }),

/***/ 79681:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var process = __webpack_require__(83454);
(function(){var e={526:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},118:function(e,t,r){var n=r(300);var i=n.Buffer;function copyProps(e,t){for(var r in e){t[r]=e[r]}}if(i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow){e.exports=n}else{copyProps(n,t);t.Buffer=SafeBuffer}function SafeBuffer(e,t,r){return i(e,t,r)}SafeBuffer.prototype=Object.create(i.prototype);copyProps(i,SafeBuffer);SafeBuffer.from=function(e,t,r){if(typeof e==="number"){throw new TypeError("Argument must not be a number")}return i(e,t,r)};SafeBuffer.alloc=function(e,t,r){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}var n=i(e);if(t!==undefined){if(typeof r==="string"){n.fill(t,r)}else{n.fill(t)}}else{n.fill(0)}return n};SafeBuffer.allocUnsafe=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return i(e)};SafeBuffer.allocUnsafeSlow=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return n.SlowBuffer(e)}},562:function(e,t,r){e.exports=Stream;var n=r(361).EventEmitter;var i=r(526);i(Stream,n);Stream.Readable=r(375);Stream.Writable=r(886);Stream.Duplex=r(239);Stream.Transform=r(786);Stream.PassThrough=r(663);Stream.finished=r(494);Stream.pipeline=r(229);Stream.Stream=Stream;function Stream(){n.call(this)}Stream.prototype.pipe=function(e,t){var r=this;function ondata(t){if(e.writable){if(false===e.write(t)&&r.pause){r.pause()}}}r.on("data",ondata);function ondrain(){if(r.readable&&r.resume){r.resume()}}e.on("drain",ondrain);if(!e._isStdio&&(!t||t.end!==false)){r.on("end",onend);r.on("close",onclose)}var i=false;function onend(){if(i)return;i=true;e.end()}function onclose(){if(i)return;i=true;if(typeof e.destroy==="function")e.destroy()}function onerror(e){cleanup();if(n.listenerCount(this,"error")===0){throw e}}r.on("error",onerror);e.on("error",onerror);function cleanup(){r.removeListener("data",ondata);e.removeListener("drain",ondrain);r.removeListener("end",onend);r.removeListener("close",onclose);r.removeListener("error",onerror);e.removeListener("error",onerror);r.removeListener("end",cleanup);r.removeListener("close",cleanup);e.removeListener("close",cleanup)}r.on("end",cleanup);r.on("close",cleanup);e.on("close",cleanup);e.emit("pipe",r);return e}},833:function(e){"use strict";const t={};function createErrorType(e,r,n){if(!n){n=Error}function getMessage(e,t,n){if(typeof r==="string"){return r}else{return r(e,t,n)}}class NodeError extends n{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=n.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let n;if(typeof t==="string"&&startsWith(t,"not ")){n="must not be";t=t.replace(/^not /,"")}else{n="must be"}let i;if(endsWith(e," argument")){i=`The ${e} ${n} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";i=`The "${e}" ${r} ${n} ${oneOf(t,"type")}`}i+=`. Received type ${typeof r}`;return i}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},239:function(e,t,r){"use strict";var n=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var i=r(375);var a=r(886);r(526)(Duplex,i);{var o=n(a.prototype);for(var s=0;s<o.length;s++){var f=o[s];if(!Duplex.prototype[f])Duplex.prototype[f]=a.prototype[f]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);i.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},663:function(e,t,r){"use strict";e.exports=PassThrough;var n=r(786);r(526)(PassThrough,n);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);n.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},375:function(e,t,r){"use strict";e.exports=Readable;var n;Readable.ReadableState=ReadableState;var i=r(361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var o=r(919);var s=r(300).Buffer;var f=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof f}var l=r(837);var u;if(l&&l.debuglog){u=l.debuglog("stream")}else{u=function debug(){}}var d=r(914);var c=r(364);var h=r(322),p=h.getHighWaterMark;var b=r(833).q,g=b.ERR_INVALID_ARG_TYPE,y=b.ERR_STREAM_PUSH_AFTER_EOF,_=b.ERR_METHOD_NOT_IMPLEMENTED,v=b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var w;var m;var S;r(526)(Readable,o);var R=c.errorOrDestroy;var E=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,i){n=n||r(239);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=p(this,e,"readableHighWaterMark",i);this.buffer=new d;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!w)w=r(313).s;this.decoder=new w(e.encoding);this.encoding=e.encoding}}function Readable(e){n=n||r(239);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof n;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}o.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=c.destroy;Readable.prototype._undestroy=c.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var n;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=s.from(e,t);t=""}n=true}}else{n=true}return readableAddChunk(this,e,t,false,n)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,n,i){u("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var o;if(!i)o=chunkInvalid(a,t);if(o){R(e,o)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==s.prototype){t=_uint8ArrayToBuffer(t)}if(n){if(a.endEmitted)R(e,new v);else addChunk(e,a,t,true)}else if(a.ended){R(e,new y)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!n){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,n){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(n)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new g("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!w)w=r(313).s;var t=new w(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var n=this._readableState.buffer.head;var i="";while(n!==null){i+=t.write(n.data);n=n.next}this._readableState.buffer.clear();if(i!=="")this._readableState.buffer.push(i);this._readableState.length=i.length;return this};var T=1073741824;function computeNewHighWaterMark(e){if(e>=T){e=T}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){u("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){u("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var n=t.needReadable;u("need readable",n);if(t.length===0||t.length-e<t.highWaterMark){n=true;u("length less than watermark",n)}if(t.ended||t.reading){n=false;u("reading or ended",n)}else if(n){u("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var i;if(e>0)i=fromList(e,t);else i=null;if(i===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(i!==null)this.emit("data",i);return i};function onEofChunk(e,t){u("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;u("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){u("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;u("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;u("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){R(this,new _("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var n=this._readableState;switch(n.pipesCount){case 0:n.pipes=e;break;case 1:n.pipes=[n.pipes,e];break;default:n.pipes.push(e);break}n.pipesCount+=1;u("pipe count=%d opts=%j",n.pipesCount,t);var i=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var o=i?onend:unpipe;if(n.endEmitted)process.nextTick(o);else r.once("end",o);e.on("unpipe",onunpipe);function onunpipe(e,t){u("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){u("onend");e.end()}var s=pipeOnDrain(r);e.on("drain",s);var f=false;function cleanup(){u("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",s);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);f=true;if(n.awaitDrain&&(!e._writableState||e._writableState.needDrain))s()}r.on("data",ondata);function ondata(t){u("ondata");var i=e.write(t);u("dest.write",i);if(i===false){if((n.pipesCount===1&&n.pipes===e||n.pipesCount>1&&indexOf(n.pipes,e)!==-1)&&!f){u("false write response, pause",n.awaitDrain);n.awaitDrain++}r.pause()}}function onerror(t){u("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)R(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){u("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){u("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!n.flowing){u("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;u("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var n=t.pipes;var i=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<i;a++){n[a].emit("unpipe",this,{hasUnpiped:false})}return this}var o=indexOf(t.pipes,e);if(o===-1)return this;t.pipes.splice(o,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=o.prototype.on.call(this,e,t);var n=this._readableState;if(e==="data"){n.readableListening=this.listenerCount("readable")>0;if(n.flowing!==false)this.resume()}else if(e==="readable"){if(!n.endEmitted&&!n.readableListening){n.readableListening=n.needReadable=true;n.flowing=false;n.emittedReadable=false;u("on readable",n.length,n.reading);if(n.length){emitReadable(this)}else if(!n.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=o.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=o.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){u("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){u("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){u("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){u("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){u("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;u("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var n=false;e.on("end",(function(){u("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(i){u("wrapped data");if(r.decoder)i=r.decoder.write(i);if(r.objectMode&&(i===null||i===undefined))return;else if(!r.objectMode&&(!i||!i.length))return;var a=t.push(i);if(!a){n=true;e.pause()}}));for(var i in e){if(this[i]===undefined&&typeof e[i]==="function"){this[i]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(i)}}for(var a=0;a<E.length;a++){e.on(E[a],this.emit.bind(this,E[a]))}this._read=function(t){u("wrapped _read",t);if(n){n=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(m===undefined){m=r(771)}return m(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;u("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){u("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(S===undefined){S=r(16)}return S(Readable,e,t)}}function indexOf(e,t){for(var r=0,n=e.length;r<n;r++){if(e[r]===t)return r}return-1}},786:function(e,t,r){"use strict";e.exports=Transform;var n=r(833).q,i=n.ERR_METHOD_NOT_IMPLEMENTED,a=n.ERR_MULTIPLE_CALLBACK,o=n.ERR_TRANSFORM_ALREADY_TRANSFORMING,s=n.ERR_TRANSFORM_WITH_LENGTH_0;var f=r(239);r(526)(Transform,f);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var n=r.writecb;if(n===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);n(e);var i=this._readableState;i.reading=false;if(i.needReadable||i.length<i.highWaterMark){this._read(i.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);f.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return f.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new i("_transform()"))};Transform.prototype._write=function(e,t,r){var n=this._transformState;n.writecb=r;n.writechunk=e;n.writeencoding=t;if(!n.transforming){var i=this._readableState;if(n.needTransform||i.needReadable||i.length<i.highWaterMark)this._read(i.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){f.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new s;if(e._transformState.transforming)throw new o;return e.push(null)}},886:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var n;Writable.WritableState=WritableState;var i={deprecate:r(121)};var a=r(919);var o=r(300).Buffer;var s=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof s}var f=r(364);var l=r(322),u=l.getHighWaterMark;var d=r(833).q,c=d.ERR_INVALID_ARG_TYPE,h=d.ERR_METHOD_NOT_IMPLEMENTED,p=d.ERR_MULTIPLE_CALLBACK,b=d.ERR_STREAM_CANNOT_PIPE,g=d.ERR_STREAM_DESTROYED,y=d.ERR_STREAM_NULL_VALUES,_=d.ERR_STREAM_WRITE_AFTER_END,v=d.ERR_UNKNOWN_ENCODING;var w=f.errorOrDestroy;r(526)(Writable,a);function nop(){}function WritableState(e,t,i){n=n||r(239);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=u(this,e,"writableHighWaterMark",i);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:i.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var m;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){m=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(m.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{m=function realHasInstance(e){return e instanceof this}}function Writable(e){n=n||r(239);var t=this instanceof n;if(!t&&!m.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){w(this,new b)};function writeAfterEnd(e,t){var r=new _;w(e,r);process.nextTick(t,r)}function validChunk(e,t,r,n){var i;if(r===null){i=new y}else if(typeof r!=="string"&&!t.objectMode){i=new c("chunk",["string","Buffer"],r)}if(i){w(e,i);process.nextTick(n,i);return false}return true}Writable.prototype.write=function(e,t,r){var n=this._writableState;var i=false;var a=!n.objectMode&&_isUint8Array(e);if(a&&!o.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=n.defaultEncoding;if(typeof r!=="function")r=nop;if(n.ending)writeAfterEnd(this,r);else if(a||validChunk(this,n,e,r)){n.pendingcb++;i=writeOrBuffer(this,n,a,e,t,r)}return i};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new v(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=o.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,n,i,a){if(!r){var o=decodeChunk(t,n,i);if(n!==o){r=true;i="buffer";n=o}}var s=t.objectMode?1:n.length;t.length+=s;var f=t.length<t.highWaterMark;if(!f)t.needDrain=true;if(t.writing||t.corked){var l=t.lastBufferedRequest;t.lastBufferedRequest={chunk:n,encoding:i,isBuf:r,callback:a,next:null};if(l){l.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,s,n,i,a)}return f}function doWrite(e,t,r,n,i,a,o){t.writelen=n;t.writecb=o;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new g("write"));else if(r)e._writev(i,t.onwrite);else e._write(i,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,n,i){--t.pendingcb;if(r){process.nextTick(i,n);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;w(e,n)}else{i(n);e._writableState.errorEmitted=true;w(e,n);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var n=r.sync;var i=r.writecb;if(typeof i!=="function")throw new p;onwriteStateUpdate(r);if(t)onwriteError(e,r,n,t,i);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(n){process.nextTick(afterWrite,e,r,a,i)}else{afterWrite(e,r,a,i)}}}function afterWrite(e,t,r,n){if(!r)onwriteDrain(e,t);t.pendingcb--;n();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var n=t.bufferedRequestCount;var i=new Array(n);var a=t.corkedRequestsFree;a.entry=r;var o=0;var s=true;while(r){i[o]=r;if(!r.isBuf)s=false;r=r.next;o+=1}i.allBuffers=s;doWrite(e,t,true,t.length,i,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var f=r.chunk;var l=r.encoding;var u=r.callback;var d=t.objectMode?1:f.length;doWrite(e,t,false,d,f,l,u);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new h("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var n=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(n.corked){n.corked=1;this.uncork()}if(!n.ending)endWritable(this,n,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){w(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var n=e._readableState;if(!n||n.autoDestroy&&n.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var n=e.entry;e.entry=null;while(n){var i=n.callback;t.pendingcb--;i(r);n=n.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=f.destroy;Writable.prototype._undestroy=f.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},771:function(e,t,r){"use strict";var n;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(494);var a=Symbol("lastResolve");var o=Symbol("lastReject");var s=Symbol("error");var f=Symbol("ended");var l=Symbol("lastPromise");var u=Symbol("handlePromise");var d=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[d].read();if(r!==null){e[l]=null;e[a]=null;e[o]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,n){e.then((function(){if(t[f]){r(createIterResult(undefined,true));return}t[u](r,n)}),n)}}var c=Object.getPrototypeOf((function(){}));var h=Object.setPrototypeOf((n={get stream(){return this[d]},next:function next(){var e=this;var t=this[s];if(t!==null){return Promise.reject(t)}if(this[f]){return Promise.resolve(createIterResult(undefined,true))}if(this[d].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[s]){r(e[s])}else{t(createIterResult(undefined,true))}}))}))}var r=this[l];var n;if(r){n=new Promise(wrapForNext(r,this))}else{var i=this[d].read();if(i!==null){return Promise.resolve(createIterResult(i,false))}n=new Promise(this[u])}this[l]=n;return n}},_defineProperty(n,Symbol.asyncIterator,(function(){return this})),_defineProperty(n,"return",(function _return(){var e=this;return new Promise((function(t,r){e[d].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),n),c);var p=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(h,(t={},_defineProperty(t,d,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,f,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,u,{value:function value(e,t){var n=r[d].read();if(n){r[l]=null;r[a]=null;r[o]=null;e(createIterResult(n,false))}else{r[a]=e;r[o]=t}},writable:true}),t));r[l]=null;i(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[o];if(t!==null){r[l]=null;r[a]=null;r[o]=null;t(e)}r[s]=e;return}var n=r[a];if(n!==null){r[l]=null;r[a]=null;r[o]=null;n(createIterResult(undefined,true))}r[f]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=p},914:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||false;n.configurable=true;if("value"in n)n.writable=true;Object.defineProperty(e,n.key,n)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var n=r(300),i=n.Buffer;var a=r(837),o=a.inspect;var s=o&&o.custom||"inspect";function copyBuffer(e,t,r){i.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return i.alloc(0);var t=i.allocUnsafe(e>>>0);var r=this.head;var n=0;while(r){copyBuffer(r.data,t,n);n+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var n=t.data;e-=n.length;while(t=t.next){var i=t.data;var a=e>i.length?i.length:e;if(a===i.length)n+=i;else n+=i.slice(0,e);e-=a;if(e===0){if(a===i.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=i.slice(a)}break}++r}this.length-=r;return n}},{key:"_getBuffer",value:function _getBuffer(e){var t=i.allocUnsafe(e);var r=this.head;var n=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var o=e>a.length?a.length:e;a.copy(t,t.length-e,0,o);e-=o;if(e===0){if(o===a.length){++n;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(o)}break}++n}this.length-=n;return t}},{key:s,value:function value(e,t){return o(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},364:function(e){"use strict";function destroy(e,t){var r=this;var n=this._readableState&&this._readableState.destroyed;var i=this._writableState&&this._writableState.destroyed;if(n||i){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var n=e._writableState;if(r&&r.autoDestroy||n&&n.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},494:function(e,t,r){"use strict";var n=r(833).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,n=new Array(r),i=0;i<r;i++){n[i]=arguments[i]}e.apply(this,n)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var i=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var o=function onlegacyfinish(){if(!e.writable)f()};var s=e._writableState&&e._writableState.finished;var f=function onfinish(){a=false;s=true;if(!i)r.call(e)};var l=e._readableState&&e._readableState.endEmitted;var u=function onend(){i=false;l=true;if(!a)r.call(e)};var d=function onerror(t){r.call(e,t)};var c=function onclose(){var t;if(i&&!l){if(!e._readableState||!e._readableState.ended)t=new n;return r.call(e,t)}if(a&&!s){if(!e._writableState||!e._writableState.ended)t=new n;return r.call(e,t)}};var h=function onrequest(){e.req.on("finish",f)};if(isRequest(e)){e.on("complete",f);e.on("abort",c);if(e.req)h();else e.on("request",h)}else if(a&&!e._writableState){e.on("end",o);e.on("close",o)}e.on("end",u);e.on("finish",f);if(t.error!==false)e.on("error",d);e.on("close",c);return function(){e.removeListener("complete",f);e.removeListener("abort",c);e.removeListener("request",h);if(e.req)e.req.removeListener("finish",f);e.removeListener("end",o);e.removeListener("close",o);e.removeListener("finish",f);e.removeListener("end",u);e.removeListener("error",d);e.removeListener("close",c)}}e.exports=eos},16:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,n,i,a,o){try{var s=e[a](o);var f=s.value}catch(e){r(e);return}if(s.done){t(f)}else{Promise.resolve(f).then(n,i)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(n,i){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,n,i,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,n,i,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(833).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var i;if(t&&typeof t.next==="function"){i=t}else if(t&&t[Symbol.asyncIterator])i=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])i=t[Symbol.iterator]();else throw new n("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var o=false;a._read=function(){if(!o){o=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield i.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{o=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},229:function(e,t,r){"use strict";var n;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var i=r(833).q,a=i.ERR_MISSING_ARGS,o=i.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,i,a){a=once(a);var s=false;e.on("close",(function(){s=true}));if(n===undefined)n=r(494);n(e,{readable:t,writable:i},(function(e){if(e)return a(e);s=true;a()}));var f=false;return function(t){if(s)return;if(f)return;f=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new o("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var n=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var i;var o=t.map((function(e,r){var a=r<t.length-1;var s=r>0;return destroyer(e,a,s,(function(e){if(!i)i=e;if(e)o.forEach(call);if(a)return;o.forEach(call);n(i)}))}));return t.reduce(pipe)}e.exports=pipeline},322:function(e,t,r){"use strict";var n=r(833).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,i){var a=highWaterMarkFrom(t,i,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var o=i?r:"highWaterMark";throw new n(o,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},919:function(e,t,r){e.exports=r(781)},313:function(e,t,r){"use strict";var n=r(118).Buffer;var i=n.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(n.isEncoding===i||!i(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=n.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var n=t.length-1;if(n<r)return 0;var i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-1;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-2;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0){if(i===2)i=0;else e.lastNeed=i-3}return i}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var n=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,n);return e.toString("utf8",t,n)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var n=r.charCodeAt(r.length-1);if(n>=55296&&n<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},121:function(e){e.exports=deprecate;function deprecate(e,t){if(config("noDeprecation")){return e}var r=false;function deprecated(){if(!r){if(config("throwDeprecation")){throw new Error(t)}else if(config("traceDeprecation")){console.trace(t)}else{console.warn(t)}r=true}return e.apply(this,arguments)}return deprecated}function config(e){try{if(!__webpack_require__.g.localStorage)return false}catch(e){return false}var t=__webpack_require__.g.localStorage[e];if(null==t)return false;return String(t).toLowerCase()==="true"}},300:function(e){"use strict";e.exports=__webpack_require__(48764)},361:function(e){"use strict";e.exports=__webpack_require__(17187)},781:function(e){"use strict";e.exports=(__webpack_require__(17187).EventEmitter)},837:function(e){"use strict";e.exports=__webpack_require__(79720)}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var a=true;try{e[r](i,i.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(562);module.exports=r})();

/***/ }),

/***/ 22321:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/* provided dependency */ var process = __webpack_require__(83454);
(function(){var e={516:function(e){e.exports={100:"Continue",101:"Switching Protocols",102:"Processing",200:"OK",201:"Created",202:"Accepted",203:"Non-Authoritative Information",204:"No Content",205:"Reset Content",206:"Partial Content",207:"Multi-Status",208:"Already Reported",226:"IM Used",300:"Multiple Choices",301:"Moved Permanently",302:"Found",303:"See Other",304:"Not Modified",305:"Use Proxy",307:"Temporary Redirect",308:"Permanent Redirect",400:"Bad Request",401:"Unauthorized",402:"Payment Required",403:"Forbidden",404:"Not Found",405:"Method Not Allowed",406:"Not Acceptable",407:"Proxy Authentication Required",408:"Request Timeout",409:"Conflict",410:"Gone",411:"Length Required",412:"Precondition Failed",413:"Payload Too Large",414:"URI Too Long",415:"Unsupported Media Type",416:"Range Not Satisfiable",417:"Expectation Failed",418:"I'm a teapot",421:"Misdirected Request",422:"Unprocessable Entity",423:"Locked",424:"Failed Dependency",425:"Unordered Collection",426:"Upgrade Required",428:"Precondition Required",429:"Too Many Requests",431:"Request Header Fields Too Large",451:"Unavailable For Legal Reasons",500:"Internal Server Error",501:"Not Implemented",502:"Bad Gateway",503:"Service Unavailable",504:"Gateway Timeout",505:"HTTP Version Not Supported",506:"Variant Also Negotiates",507:"Insufficient Storage",508:"Loop Detected",509:"Bandwidth Limit Exceeded",510:"Not Extended",511:"Network Authentication Required"}},526:function(e){if(typeof Object.create==="function"){e.exports=function inherits(e,t){if(t){e.super_=t;e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:false,writable:true,configurable:true}})}}}else{e.exports=function inherits(e,t){if(t){e.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;e.prototype=new TempCtor;e.prototype.constructor=e}}}},118:function(e,t,r){var n=r(300);var i=n.Buffer;function copyProps(e,t){for(var r in e){t[r]=e[r]}}if(i.from&&i.alloc&&i.allocUnsafe&&i.allocUnsafeSlow){e.exports=n}else{copyProps(n,t);t.Buffer=SafeBuffer}function SafeBuffer(e,t,r){return i(e,t,r)}SafeBuffer.prototype=Object.create(i.prototype);copyProps(i,SafeBuffer);SafeBuffer.from=function(e,t,r){if(typeof e==="number"){throw new TypeError("Argument must not be a number")}return i(e,t,r)};SafeBuffer.alloc=function(e,t,r){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}var n=i(e);if(t!==undefined){if(typeof r==="string"){n.fill(t,r)}else{n.fill(t)}}else{n.fill(0)}return n};SafeBuffer.allocUnsafe=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return i(e)};SafeBuffer.allocUnsafeSlow=function(e){if(typeof e!=="number"){throw new TypeError("Argument must be a number")}return n.SlowBuffer(e)}},859:function(e,t,r){var n=r(43);var i=r(808);var a=r(738);var o=r(516);var s=r(310);var f=t;f.request=function(e,t){if(typeof e==="string")e=s.parse(e);else e=a(e);var r=__webpack_require__.g.location.protocol.search(/^https?:$/)===-1?"http:":"";var i=e.protocol||r;var o=e.hostname||e.host;var f=e.port;var l=e.path||"/";if(o&&o.indexOf(":")!==-1)o="["+o+"]";e.url=(o?i+"//"+o:"")+(f?":"+f:"")+l;e.method=(e.method||"GET").toUpperCase();e.headers=e.headers||{};var u=new n(e);if(t)u.on("response",t);return u};f.get=function get(e,t){var r=f.request(e,t);r.end();return r};f.ClientRequest=n;f.IncomingMessage=i.IncomingMessage;f.Agent=function(){};f.Agent.defaultMaxSockets=4;f.globalAgent=new f.Agent;f.STATUS_CODES=o;f.METHODS=["CHECKOUT","CONNECT","COPY","DELETE","GET","HEAD","LOCK","M-SEARCH","MERGE","MKACTIVITY","MKCOL","MOVE","NOTIFY","OPTIONS","PATCH","POST","PROPFIND","PROPPATCH","PURGE","PUT","REPORT","SEARCH","SUBSCRIBE","TRACE","UNLOCK","UNSUBSCRIBE"]},569:function(e,t){t.fetch=isFunction(__webpack_require__.g.fetch)&&isFunction(__webpack_require__.g.ReadableStream);t.writableStream=isFunction(__webpack_require__.g.WritableStream);t.abortController=isFunction(__webpack_require__.g.AbortController);var r;function getXHR(){if(r!==undefined)return r;if(__webpack_require__.g.XMLHttpRequest){r=new __webpack_require__.g.XMLHttpRequest;try{r.open("GET",__webpack_require__.g.XDomainRequest?"/":"https://example.com")}catch(e){r=null}}else{r=null}return r}function checkTypeSupport(e){var t=getXHR();if(!t)return false;try{t.responseType=e;return t.responseType===e}catch(e){}return false}t.arraybuffer=t.fetch||checkTypeSupport("arraybuffer");t.msstream=!t.fetch&&checkTypeSupport("ms-stream");t.mozchunkedarraybuffer=!t.fetch&&checkTypeSupport("moz-chunked-arraybuffer");t.overrideMimeType=t.fetch||(getXHR()?isFunction(getXHR().overrideMimeType):false);function isFunction(e){return typeof e==="function"}r=null},43:function(e,t,r){var n=r(569);var i=r(526);var a=r(808);var o=r(121);var s=a.IncomingMessage;var f=a.readyStates;function decideMode(e,t){if(n.fetch&&t){return"fetch"}else if(n.mozchunkedarraybuffer){return"moz-chunked-arraybuffer"}else if(n.msstream){return"ms-stream"}else if(n.arraybuffer&&e){return"arraybuffer"}else{return"text"}}var l=e.exports=function(e){var t=this;o.Writable.call(t);t._opts=e;t._body=[];t._headers={};if(e.auth)t.setHeader("Authorization","Basic "+Buffer.from(e.auth).toString("base64"));Object.keys(e.headers).forEach((function(r){t.setHeader(r,e.headers[r])}));var r;var i=true;if(e.mode==="disable-fetch"||"requestTimeout"in e&&!n.abortController){i=false;r=true}else if(e.mode==="prefer-streaming"){r=false}else if(e.mode==="allow-wrong-content-type"){r=!n.overrideMimeType}else if(!e.mode||e.mode==="default"||e.mode==="prefer-fast"){r=true}else{throw new Error("Invalid value for opts.mode")}t._mode=decideMode(r,i);t._fetchTimer=null;t.on("finish",(function(){t._onFinish()}))};i(l,o.Writable);l.prototype.setHeader=function(e,t){var r=this;var n=e.toLowerCase();if(u.indexOf(n)!==-1)return;r._headers[n]={name:e,value:t}};l.prototype.getHeader=function(e){var t=this._headers[e.toLowerCase()];if(t)return t.value;return null};l.prototype.removeHeader=function(e){var t=this;delete t._headers[e.toLowerCase()]};l.prototype._onFinish=function(){var e=this;if(e._destroyed)return;var t=e._opts;var r=e._headers;var i=null;if(t.method!=="GET"&&t.method!=="HEAD"){i=new Blob(e._body,{type:(r["content-type"]||{}).value||""})}var a=[];Object.keys(r).forEach((function(e){var t=r[e].name;var n=r[e].value;if(Array.isArray(n)){n.forEach((function(e){a.push([t,e])}))}else{a.push([t,n])}}));if(e._mode==="fetch"){var o=null;if(n.abortController){var s=new AbortController;o=s.signal;e._fetchAbortController=s;if("requestTimeout"in t&&t.requestTimeout!==0){e._fetchTimer=__webpack_require__.g.setTimeout((function(){e.emit("requestTimeout");if(e._fetchAbortController)e._fetchAbortController.abort()}),t.requestTimeout)}}__webpack_require__.g.fetch(e._opts.url,{method:e._opts.method,headers:a,body:i||undefined,mode:"cors",credentials:t.withCredentials?"include":"same-origin",signal:o}).then((function(t){e._fetchResponse=t;e._connect()}),(function(t){__webpack_require__.g.clearTimeout(e._fetchTimer);if(!e._destroyed)e.emit("error",t)}))}else{var l=e._xhr=new __webpack_require__.g.XMLHttpRequest;try{l.open(e._opts.method,e._opts.url,true)}catch(t){process.nextTick((function(){e.emit("error",t)}));return}if("responseType"in l)l.responseType=e._mode;if("withCredentials"in l)l.withCredentials=!!t.withCredentials;if(e._mode==="text"&&"overrideMimeType"in l)l.overrideMimeType("text/plain; charset=x-user-defined");if("requestTimeout"in t){l.timeout=t.requestTimeout;l.ontimeout=function(){e.emit("requestTimeout")}}a.forEach((function(e){l.setRequestHeader(e[0],e[1])}));e._response=null;l.onreadystatechange=function(){switch(l.readyState){case f.LOADING:case f.DONE:e._onXHRProgress();break}};if(e._mode==="moz-chunked-arraybuffer"){l.onprogress=function(){e._onXHRProgress()}}l.onerror=function(){if(e._destroyed)return;e.emit("error",new Error("XHR error"))};try{l.send(i)}catch(t){process.nextTick((function(){e.emit("error",t)}));return}}};function statusValid(e){try{var t=e.status;return t!==null&&t!==0}catch(e){return false}}l.prototype._onXHRProgress=function(){var e=this;if(!statusValid(e._xhr)||e._destroyed)return;if(!e._response)e._connect();e._response._onXHRProgress()};l.prototype._connect=function(){var e=this;if(e._destroyed)return;e._response=new s(e._xhr,e._fetchResponse,e._mode,e._fetchTimer);e._response.on("error",(function(t){e.emit("error",t)}));e.emit("response",e._response)};l.prototype._write=function(e,t,r){var n=this;n._body.push(e);r()};l.prototype.abort=l.prototype.destroy=function(){var e=this;e._destroyed=true;__webpack_require__.g.clearTimeout(e._fetchTimer);if(e._response)e._response._destroyed=true;if(e._xhr)e._xhr.abort();else if(e._fetchAbortController)e._fetchAbortController.abort()};l.prototype.end=function(e,t,r){var n=this;if(typeof e==="function"){r=e;e=undefined}o.Writable.prototype.end.call(n,e,t,r)};l.prototype.flushHeaders=function(){};l.prototype.setTimeout=function(){};l.prototype.setNoDelay=function(){};l.prototype.setSocketKeepAlive=function(){};var u=["accept-charset","accept-encoding","access-control-request-headers","access-control-request-method","connection","content-length","cookie","cookie2","date","dnt","expect","host","keep-alive","origin","referer","te","trailer","transfer-encoding","upgrade","via"]},808:function(e,t,r){var n=r(569);var i=r(526);var a=r(121);var o=t.readyStates={UNSENT:0,OPENED:1,HEADERS_RECEIVED:2,LOADING:3,DONE:4};var s=t.IncomingMessage=function(e,t,r,i){var o=this;a.Readable.call(o);o._mode=r;o.headers={};o.rawHeaders=[];o.trailers={};o.rawTrailers=[];o.on("end",(function(){process.nextTick((function(){o.emit("close")}))}));if(r==="fetch"){o._fetchResponse=t;o.url=t.url;o.statusCode=t.status;o.statusMessage=t.statusText;t.headers.forEach((function(e,t){o.headers[t.toLowerCase()]=e;o.rawHeaders.push(t,e)}));if(n.writableStream){var s=new WritableStream({write:function(e){return new Promise((function(t,r){if(o._destroyed){r()}else if(o.push(Buffer.from(e))){t()}else{o._resumeFetch=t}}))},close:function(){__webpack_require__.g.clearTimeout(i);if(!o._destroyed)o.push(null)},abort:function(e){if(!o._destroyed)o.emit("error",e)}});try{t.body.pipeTo(s).catch((function(e){__webpack_require__.g.clearTimeout(i);if(!o._destroyed)o.emit("error",e)}));return}catch(e){}}var f=t.body.getReader();function read(){f.read().then((function(e){if(o._destroyed)return;if(e.done){__webpack_require__.g.clearTimeout(i);o.push(null);return}o.push(Buffer.from(e.value));read()})).catch((function(e){__webpack_require__.g.clearTimeout(i);if(!o._destroyed)o.emit("error",e)}))}read()}else{o._xhr=e;o._pos=0;o.url=e.responseURL;o.statusCode=e.status;o.statusMessage=e.statusText;var l=e.getAllResponseHeaders().split(/\r?\n/);l.forEach((function(e){var t=e.match(/^([^:]+):\s*(.*)/);if(t){var r=t[1].toLowerCase();if(r==="set-cookie"){if(o.headers[r]===undefined){o.headers[r]=[]}o.headers[r].push(t[2])}else if(o.headers[r]!==undefined){o.headers[r]+=", "+t[2]}else{o.headers[r]=t[2]}o.rawHeaders.push(t[1],t[2])}}));o._charset="x-user-defined";if(!n.overrideMimeType){var u=o.rawHeaders["mime-type"];if(u){var d=u.match(/;\s*charset=([^;])(;|$)/);if(d){o._charset=d[1].toLowerCase()}}if(!o._charset)o._charset="utf-8"}}};i(s,a.Readable);s.prototype._read=function(){var e=this;var t=e._resumeFetch;if(t){e._resumeFetch=null;t()}};s.prototype._onXHRProgress=function(){var e=this;var t=e._xhr;var r=null;switch(e._mode){case"text":r=t.responseText;if(r.length>e._pos){var n=r.substr(e._pos);if(e._charset==="x-user-defined"){var i=Buffer.alloc(n.length);for(var a=0;a<n.length;a++)i[a]=n.charCodeAt(a)&255;e.push(i)}else{e.push(n,e._charset)}e._pos=r.length}break;case"arraybuffer":if(t.readyState!==o.DONE||!t.response)break;r=t.response;e.push(Buffer.from(new Uint8Array(r)));break;case"moz-chunked-arraybuffer":r=t.response;if(t.readyState!==o.LOADING||!r)break;e.push(Buffer.from(new Uint8Array(r)));break;case"ms-stream":r=t.response;if(t.readyState!==o.LOADING)break;var s=new __webpack_require__.g.MSStreamReader;s.onprogress=function(){if(s.result.byteLength>e._pos){e.push(Buffer.from(new Uint8Array(s.result.slice(e._pos))));e._pos=s.result.byteLength}};s.onload=function(){e.push(null)};s.readAsArrayBuffer(r);break}if(e._xhr.readyState===o.DONE&&e._mode!=="ms-stream"){e.push(null)}}},558:function(e){"use strict";const t={};function createErrorType(e,r,n){if(!n){n=Error}function getMessage(e,t,n){if(typeof r==="string"){return r}else{return r(e,t,n)}}class NodeError extends n{constructor(e,t,r){super(getMessage(e,t,r))}}NodeError.prototype.name=n.name;NodeError.prototype.code=e;t[e]=NodeError}function oneOf(e,t){if(Array.isArray(e)){const r=e.length;e=e.map((e=>String(e)));if(r>2){return`one of ${t} ${e.slice(0,r-1).join(", ")}, or `+e[r-1]}else if(r===2){return`one of ${t} ${e[0]} or ${e[1]}`}else{return`of ${t} ${e[0]}`}}else{return`of ${t} ${String(e)}`}}function startsWith(e,t,r){return e.substr(!r||r<0?0:+r,t.length)===t}function endsWith(e,t,r){if(r===undefined||r>e.length){r=e.length}return e.substring(r-t.length,r)===t}function includes(e,t,r){if(typeof r!=="number"){r=0}if(r+t.length>e.length){return false}else{return e.indexOf(t,r)!==-1}}createErrorType("ERR_INVALID_OPT_VALUE",(function(e,t){return'The value "'+t+'" is invalid for option "'+e+'"'}),TypeError);createErrorType("ERR_INVALID_ARG_TYPE",(function(e,t,r){let n;if(typeof t==="string"&&startsWith(t,"not ")){n="must not be";t=t.replace(/^not /,"")}else{n="must be"}let i;if(endsWith(e," argument")){i=`The ${e} ${n} ${oneOf(t,"type")}`}else{const r=includes(e,".")?"property":"argument";i=`The "${e}" ${r} ${n} ${oneOf(t,"type")}`}i+=`. Received type ${typeof r}`;return i}),TypeError);createErrorType("ERR_STREAM_PUSH_AFTER_EOF","stream.push() after EOF");createErrorType("ERR_METHOD_NOT_IMPLEMENTED",(function(e){return"The "+e+" method is not implemented"}));createErrorType("ERR_STREAM_PREMATURE_CLOSE","Premature close");createErrorType("ERR_STREAM_DESTROYED",(function(e){return"Cannot call "+e+" after a stream was destroyed"}));createErrorType("ERR_MULTIPLE_CALLBACK","Callback called multiple times");createErrorType("ERR_STREAM_CANNOT_PIPE","Cannot pipe, not readable");createErrorType("ERR_STREAM_WRITE_AFTER_END","write after end");createErrorType("ERR_STREAM_NULL_VALUES","May not write null values to stream",TypeError);createErrorType("ERR_UNKNOWN_ENCODING",(function(e){return"Unknown encoding: "+e}),TypeError);createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT","stream.unshift() after end event");e.exports.q=t},309:function(e,t,r){"use strict";var n=Object.keys||function(e){var t=[];for(var r in e){t.push(r)}return t};e.exports=Duplex;var i=r(903);var a=r(551);r(526)(Duplex,i);{var o=n(a.prototype);for(var s=0;s<o.length;s++){var f=o[s];if(!Duplex.prototype[f])Duplex.prototype[f]=a.prototype[f]}}function Duplex(e){if(!(this instanceof Duplex))return new Duplex(e);i.call(this,e);a.call(this,e);this.allowHalfOpen=true;if(e){if(e.readable===false)this.readable=false;if(e.writable===false)this.writable=false;if(e.allowHalfOpen===false){this.allowHalfOpen=false;this.once("end",onend)}}}Object.defineProperty(Duplex.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});Object.defineProperty(Duplex.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});Object.defineProperty(Duplex.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function onend(){if(this._writableState.ended)return;process.nextTick(onEndNT,this)}function onEndNT(e){e.end()}Object.defineProperty(Duplex.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined||this._writableState===undefined){return false}return this._readableState.destroyed&&this._writableState.destroyed},set:function set(e){if(this._readableState===undefined||this._writableState===undefined){return}this._readableState.destroyed=e;this._writableState.destroyed=e}})},268:function(e,t,r){"use strict";e.exports=PassThrough;var n=r(767);r(526)(PassThrough,n);function PassThrough(e){if(!(this instanceof PassThrough))return new PassThrough(e);n.call(this,e)}PassThrough.prototype._transform=function(e,t,r){r(null,e)}},903:function(e,t,r){"use strict";e.exports=Readable;var n;Readable.ReadableState=ReadableState;var i=r(361).EventEmitter;var a=function EElistenerCount(e,t){return e.listeners(t).length};var o=r(982);var s=r(300).Buffer;var f=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return s.from(e)}function _isUint8Array(e){return s.isBuffer(e)||e instanceof f}var l=r(837);var u;if(l&&l.debuglog){u=l.debuglog("stream")}else{u=function debug(){}}var d=r(446);var c=r(556);var h=r(416),p=h.getHighWaterMark;var b=r(558).q,y=b.ERR_INVALID_ARG_TYPE,g=b.ERR_STREAM_PUSH_AFTER_EOF,_=b.ERR_METHOD_NOT_IMPLEMENTED,v=b.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;var m;var w;var R;r(526)(Readable,o);var S=c.errorOrDestroy;var E=["error","close","destroy","pause","resume"];function prependListener(e,t,r){if(typeof e.prependListener==="function")return e.prependListener(t,r);if(!e._events||!e._events[t])e.on(t,r);else if(Array.isArray(e._events[t]))e._events[t].unshift(r);else e._events[t]=[r,e._events[t]]}function ReadableState(e,t,i){n=n||r(309);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.readableObjectMode;this.highWaterMark=p(this,e,"readableHighWaterMark",i);this.buffer=new d;this.length=0;this.pipes=null;this.pipesCount=0;this.flowing=null;this.ended=false;this.endEmitted=false;this.reading=false;this.sync=true;this.needReadable=false;this.emittedReadable=false;this.readableListening=false;this.resumeScheduled=false;this.paused=true;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.destroyed=false;this.defaultEncoding=e.defaultEncoding||"utf8";this.awaitDrain=0;this.readingMore=false;this.decoder=null;this.encoding=null;if(e.encoding){if(!m)m=r(961).s;this.decoder=new m(e.encoding);this.encoding=e.encoding}}function Readable(e){n=n||r(309);if(!(this instanceof Readable))return new Readable(e);var t=this instanceof n;this._readableState=new ReadableState(e,this,t);this.readable=true;if(e){if(typeof e.read==="function")this._read=e.read;if(typeof e.destroy==="function")this._destroy=e.destroy}o.call(this)}Object.defineProperty(Readable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._readableState===undefined){return false}return this._readableState.destroyed},set:function set(e){if(!this._readableState){return}this._readableState.destroyed=e}});Readable.prototype.destroy=c.destroy;Readable.prototype._undestroy=c.undestroy;Readable.prototype._destroy=function(e,t){t(e)};Readable.prototype.push=function(e,t){var r=this._readableState;var n;if(!r.objectMode){if(typeof e==="string"){t=t||r.defaultEncoding;if(t!==r.encoding){e=s.from(e,t);t=""}n=true}}else{n=true}return readableAddChunk(this,e,t,false,n)};Readable.prototype.unshift=function(e){return readableAddChunk(this,e,null,true,false)};function readableAddChunk(e,t,r,n,i){u("readableAddChunk",t);var a=e._readableState;if(t===null){a.reading=false;onEofChunk(e,a)}else{var o;if(!i)o=chunkInvalid(a,t);if(o){S(e,o)}else if(a.objectMode||t&&t.length>0){if(typeof t!=="string"&&!a.objectMode&&Object.getPrototypeOf(t)!==s.prototype){t=_uint8ArrayToBuffer(t)}if(n){if(a.endEmitted)S(e,new v);else addChunk(e,a,t,true)}else if(a.ended){S(e,new g)}else if(a.destroyed){return false}else{a.reading=false;if(a.decoder&&!r){t=a.decoder.write(t);if(a.objectMode||t.length!==0)addChunk(e,a,t,false);else maybeReadMore(e,a)}else{addChunk(e,a,t,false)}}}else if(!n){a.reading=false;maybeReadMore(e,a)}}return!a.ended&&(a.length<a.highWaterMark||a.length===0)}function addChunk(e,t,r,n){if(t.flowing&&t.length===0&&!t.sync){t.awaitDrain=0;e.emit("data",r)}else{t.length+=t.objectMode?1:r.length;if(n)t.buffer.unshift(r);else t.buffer.push(r);if(t.needReadable)emitReadable(e)}maybeReadMore(e,t)}function chunkInvalid(e,t){var r;if(!_isUint8Array(t)&&typeof t!=="string"&&t!==undefined&&!e.objectMode){r=new y("chunk",["string","Buffer","Uint8Array"],t)}return r}Readable.prototype.isPaused=function(){return this._readableState.flowing===false};Readable.prototype.setEncoding=function(e){if(!m)m=r(961).s;var t=new m(e);this._readableState.decoder=t;this._readableState.encoding=this._readableState.decoder.encoding;var n=this._readableState.buffer.head;var i="";while(n!==null){i+=t.write(n.data);n=n.next}this._readableState.buffer.clear();if(i!=="")this._readableState.buffer.push(i);this._readableState.length=i.length;return this};var T=1073741824;function computeNewHighWaterMark(e){if(e>=T){e=T}else{e--;e|=e>>>1;e|=e>>>2;e|=e>>>4;e|=e>>>8;e|=e>>>16;e++}return e}function howMuchToRead(e,t){if(e<=0||t.length===0&&t.ended)return 0;if(t.objectMode)return 1;if(e!==e){if(t.flowing&&t.length)return t.buffer.head.data.length;else return t.length}if(e>t.highWaterMark)t.highWaterMark=computeNewHighWaterMark(e);if(e<=t.length)return e;if(!t.ended){t.needReadable=true;return 0}return t.length}Readable.prototype.read=function(e){u("read",e);e=parseInt(e,10);var t=this._readableState;var r=e;if(e!==0)t.emittedReadable=false;if(e===0&&t.needReadable&&((t.highWaterMark!==0?t.length>=t.highWaterMark:t.length>0)||t.ended)){u("read: emitReadable",t.length,t.ended);if(t.length===0&&t.ended)endReadable(this);else emitReadable(this);return null}e=howMuchToRead(e,t);if(e===0&&t.ended){if(t.length===0)endReadable(this);return null}var n=t.needReadable;u("need readable",n);if(t.length===0||t.length-e<t.highWaterMark){n=true;u("length less than watermark",n)}if(t.ended||t.reading){n=false;u("reading or ended",n)}else if(n){u("do read");t.reading=true;t.sync=true;if(t.length===0)t.needReadable=true;this._read(t.highWaterMark);t.sync=false;if(!t.reading)e=howMuchToRead(r,t)}var i;if(e>0)i=fromList(e,t);else i=null;if(i===null){t.needReadable=t.length<=t.highWaterMark;e=0}else{t.length-=e;t.awaitDrain=0}if(t.length===0){if(!t.ended)t.needReadable=true;if(r!==e&&t.ended)endReadable(this)}if(i!==null)this.emit("data",i);return i};function onEofChunk(e,t){u("onEofChunk");if(t.ended)return;if(t.decoder){var r=t.decoder.end();if(r&&r.length){t.buffer.push(r);t.length+=t.objectMode?1:r.length}}t.ended=true;if(t.sync){emitReadable(e)}else{t.needReadable=false;if(!t.emittedReadable){t.emittedReadable=true;emitReadable_(e)}}}function emitReadable(e){var t=e._readableState;u("emitReadable",t.needReadable,t.emittedReadable);t.needReadable=false;if(!t.emittedReadable){u("emitReadable",t.flowing);t.emittedReadable=true;process.nextTick(emitReadable_,e)}}function emitReadable_(e){var t=e._readableState;u("emitReadable_",t.destroyed,t.length,t.ended);if(!t.destroyed&&(t.length||t.ended)){e.emit("readable");t.emittedReadable=false}t.needReadable=!t.flowing&&!t.ended&&t.length<=t.highWaterMark;flow(e)}function maybeReadMore(e,t){if(!t.readingMore){t.readingMore=true;process.nextTick(maybeReadMore_,e,t)}}function maybeReadMore_(e,t){while(!t.reading&&!t.ended&&(t.length<t.highWaterMark||t.flowing&&t.length===0)){var r=t.length;u("maybeReadMore read 0");e.read(0);if(r===t.length)break}t.readingMore=false}Readable.prototype._read=function(e){S(this,new _("_read()"))};Readable.prototype.pipe=function(e,t){var r=this;var n=this._readableState;switch(n.pipesCount){case 0:n.pipes=e;break;case 1:n.pipes=[n.pipes,e];break;default:n.pipes.push(e);break}n.pipesCount+=1;u("pipe count=%d opts=%j",n.pipesCount,t);var i=(!t||t.end!==false)&&e!==process.stdout&&e!==process.stderr;var o=i?onend:unpipe;if(n.endEmitted)process.nextTick(o);else r.once("end",o);e.on("unpipe",onunpipe);function onunpipe(e,t){u("onunpipe");if(e===r){if(t&&t.hasUnpiped===false){t.hasUnpiped=true;cleanup()}}}function onend(){u("onend");e.end()}var s=pipeOnDrain(r);e.on("drain",s);var f=false;function cleanup(){u("cleanup");e.removeListener("close",onclose);e.removeListener("finish",onfinish);e.removeListener("drain",s);e.removeListener("error",onerror);e.removeListener("unpipe",onunpipe);r.removeListener("end",onend);r.removeListener("end",unpipe);r.removeListener("data",ondata);f=true;if(n.awaitDrain&&(!e._writableState||e._writableState.needDrain))s()}r.on("data",ondata);function ondata(t){u("ondata");var i=e.write(t);u("dest.write",i);if(i===false){if((n.pipesCount===1&&n.pipes===e||n.pipesCount>1&&indexOf(n.pipes,e)!==-1)&&!f){u("false write response, pause",n.awaitDrain);n.awaitDrain++}r.pause()}}function onerror(t){u("onerror",t);unpipe();e.removeListener("error",onerror);if(a(e,"error")===0)S(e,t)}prependListener(e,"error",onerror);function onclose(){e.removeListener("finish",onfinish);unpipe()}e.once("close",onclose);function onfinish(){u("onfinish");e.removeListener("close",onclose);unpipe()}e.once("finish",onfinish);function unpipe(){u("unpipe");r.unpipe(e)}e.emit("pipe",r);if(!n.flowing){u("pipe resume");r.resume()}return e};function pipeOnDrain(e){return function pipeOnDrainFunctionResult(){var t=e._readableState;u("pipeOnDrain",t.awaitDrain);if(t.awaitDrain)t.awaitDrain--;if(t.awaitDrain===0&&a(e,"data")){t.flowing=true;flow(e)}}}Readable.prototype.unpipe=function(e){var t=this._readableState;var r={hasUnpiped:false};if(t.pipesCount===0)return this;if(t.pipesCount===1){if(e&&e!==t.pipes)return this;if(!e)e=t.pipes;t.pipes=null;t.pipesCount=0;t.flowing=false;if(e)e.emit("unpipe",this,r);return this}if(!e){var n=t.pipes;var i=t.pipesCount;t.pipes=null;t.pipesCount=0;t.flowing=false;for(var a=0;a<i;a++){n[a].emit("unpipe",this,{hasUnpiped:false})}return this}var o=indexOf(t.pipes,e);if(o===-1)return this;t.pipes.splice(o,1);t.pipesCount-=1;if(t.pipesCount===1)t.pipes=t.pipes[0];e.emit("unpipe",this,r);return this};Readable.prototype.on=function(e,t){var r=o.prototype.on.call(this,e,t);var n=this._readableState;if(e==="data"){n.readableListening=this.listenerCount("readable")>0;if(n.flowing!==false)this.resume()}else if(e==="readable"){if(!n.endEmitted&&!n.readableListening){n.readableListening=n.needReadable=true;n.flowing=false;n.emittedReadable=false;u("on readable",n.length,n.reading);if(n.length){emitReadable(this)}else if(!n.reading){process.nextTick(nReadingNextTick,this)}}}return r};Readable.prototype.addListener=Readable.prototype.on;Readable.prototype.removeListener=function(e,t){var r=o.prototype.removeListener.call(this,e,t);if(e==="readable"){process.nextTick(updateReadableListening,this)}return r};Readable.prototype.removeAllListeners=function(e){var t=o.prototype.removeAllListeners.apply(this,arguments);if(e==="readable"||e===undefined){process.nextTick(updateReadableListening,this)}return t};function updateReadableListening(e){var t=e._readableState;t.readableListening=e.listenerCount("readable")>0;if(t.resumeScheduled&&!t.paused){t.flowing=true}else if(e.listenerCount("data")>0){e.resume()}}function nReadingNextTick(e){u("readable nexttick read 0");e.read(0)}Readable.prototype.resume=function(){var e=this._readableState;if(!e.flowing){u("resume");e.flowing=!e.readableListening;resume(this,e)}e.paused=false;return this};function resume(e,t){if(!t.resumeScheduled){t.resumeScheduled=true;process.nextTick(resume_,e,t)}}function resume_(e,t){u("resume",t.reading);if(!t.reading){e.read(0)}t.resumeScheduled=false;e.emit("resume");flow(e);if(t.flowing&&!t.reading)e.read(0)}Readable.prototype.pause=function(){u("call pause flowing=%j",this._readableState.flowing);if(this._readableState.flowing!==false){u("pause");this._readableState.flowing=false;this.emit("pause")}this._readableState.paused=true;return this};function flow(e){var t=e._readableState;u("flow",t.flowing);while(t.flowing&&e.read()!==null){}}Readable.prototype.wrap=function(e){var t=this;var r=this._readableState;var n=false;e.on("end",(function(){u("wrapped end");if(r.decoder&&!r.ended){var e=r.decoder.end();if(e&&e.length)t.push(e)}t.push(null)}));e.on("data",(function(i){u("wrapped data");if(r.decoder)i=r.decoder.write(i);if(r.objectMode&&(i===null||i===undefined))return;else if(!r.objectMode&&(!i||!i.length))return;var a=t.push(i);if(!a){n=true;e.pause()}}));for(var i in e){if(this[i]===undefined&&typeof e[i]==="function"){this[i]=function methodWrap(t){return function methodWrapReturnFunction(){return e[t].apply(e,arguments)}}(i)}}for(var a=0;a<E.length;a++){e.on(E[a],this.emit.bind(this,E[a]))}this._read=function(t){u("wrapped _read",t);if(n){n=false;e.resume()}};return this};if(typeof Symbol==="function"){Readable.prototype[Symbol.asyncIterator]=function(){if(w===undefined){w=r(373)}return w(this)}}Object.defineProperty(Readable.prototype,"readableHighWaterMark",{enumerable:false,get:function get(){return this._readableState.highWaterMark}});Object.defineProperty(Readable.prototype,"readableBuffer",{enumerable:false,get:function get(){return this._readableState&&this._readableState.buffer}});Object.defineProperty(Readable.prototype,"readableFlowing",{enumerable:false,get:function get(){return this._readableState.flowing},set:function set(e){if(this._readableState){this._readableState.flowing=e}}});Readable._fromList=fromList;Object.defineProperty(Readable.prototype,"readableLength",{enumerable:false,get:function get(){return this._readableState.length}});function fromList(e,t){if(t.length===0)return null;var r;if(t.objectMode)r=t.buffer.shift();else if(!e||e>=t.length){if(t.decoder)r=t.buffer.join("");else if(t.buffer.length===1)r=t.buffer.first();else r=t.buffer.concat(t.length);t.buffer.clear()}else{r=t.buffer.consume(e,t.decoder)}return r}function endReadable(e){var t=e._readableState;u("endReadable",t.endEmitted);if(!t.endEmitted){t.ended=true;process.nextTick(endReadableNT,t,e)}}function endReadableNT(e,t){u("endReadableNT",e.endEmitted,e.length);if(!e.endEmitted&&e.length===0){e.endEmitted=true;t.readable=false;t.emit("end");if(e.autoDestroy){var r=t._writableState;if(!r||r.autoDestroy&&r.finished){t.destroy()}}}}if(typeof Symbol==="function"){Readable.from=function(e,t){if(R===undefined){R=r(722)}return R(Readable,e,t)}}function indexOf(e,t){for(var r=0,n=e.length;r<n;r++){if(e[r]===t)return r}return-1}},767:function(e,t,r){"use strict";e.exports=Transform;var n=r(558).q,i=n.ERR_METHOD_NOT_IMPLEMENTED,a=n.ERR_MULTIPLE_CALLBACK,o=n.ERR_TRANSFORM_ALREADY_TRANSFORMING,s=n.ERR_TRANSFORM_WITH_LENGTH_0;var f=r(309);r(526)(Transform,f);function afterTransform(e,t){var r=this._transformState;r.transforming=false;var n=r.writecb;if(n===null){return this.emit("error",new a)}r.writechunk=null;r.writecb=null;if(t!=null)this.push(t);n(e);var i=this._readableState;i.reading=false;if(i.needReadable||i.length<i.highWaterMark){this._read(i.highWaterMark)}}function Transform(e){if(!(this instanceof Transform))return new Transform(e);f.call(this,e);this._transformState={afterTransform:afterTransform.bind(this),needTransform:false,transforming:false,writecb:null,writechunk:null,writeencoding:null};this._readableState.needReadable=true;this._readableState.sync=false;if(e){if(typeof e.transform==="function")this._transform=e.transform;if(typeof e.flush==="function")this._flush=e.flush}this.on("prefinish",prefinish)}function prefinish(){var e=this;if(typeof this._flush==="function"&&!this._readableState.destroyed){this._flush((function(t,r){done(e,t,r)}))}else{done(this,null,null)}}Transform.prototype.push=function(e,t){this._transformState.needTransform=false;return f.prototype.push.call(this,e,t)};Transform.prototype._transform=function(e,t,r){r(new i("_transform()"))};Transform.prototype._write=function(e,t,r){var n=this._transformState;n.writecb=r;n.writechunk=e;n.writeencoding=t;if(!n.transforming){var i=this._readableState;if(n.needTransform||i.needReadable||i.length<i.highWaterMark)this._read(i.highWaterMark)}};Transform.prototype._read=function(e){var t=this._transformState;if(t.writechunk!==null&&!t.transforming){t.transforming=true;this._transform(t.writechunk,t.writeencoding,t.afterTransform)}else{t.needTransform=true}};Transform.prototype._destroy=function(e,t){f.prototype._destroy.call(this,e,(function(e){t(e)}))};function done(e,t,r){if(t)return e.emit("error",t);if(r!=null)e.push(r);if(e._writableState.length)throw new s;if(e._transformState.transforming)throw new o;return e.push(null)}},551:function(e,t,r){"use strict";e.exports=Writable;function WriteReq(e,t,r){this.chunk=e;this.encoding=t;this.callback=r;this.next=null}function CorkedRequest(e){var t=this;this.next=null;this.entry=null;this.finish=function(){onCorkedFinish(t,e)}}var n;Writable.WritableState=WritableState;var i={deprecate:r(989)};var a=r(982);var o=r(300).Buffer;var s=__webpack_require__.g.Uint8Array||function(){};function _uint8ArrayToBuffer(e){return o.from(e)}function _isUint8Array(e){return o.isBuffer(e)||e instanceof s}var f=r(556);var l=r(416),u=l.getHighWaterMark;var d=r(558).q,c=d.ERR_INVALID_ARG_TYPE,h=d.ERR_METHOD_NOT_IMPLEMENTED,p=d.ERR_MULTIPLE_CALLBACK,b=d.ERR_STREAM_CANNOT_PIPE,y=d.ERR_STREAM_DESTROYED,g=d.ERR_STREAM_NULL_VALUES,_=d.ERR_STREAM_WRITE_AFTER_END,v=d.ERR_UNKNOWN_ENCODING;var m=f.errorOrDestroy;r(526)(Writable,a);function nop(){}function WritableState(e,t,i){n=n||r(309);e=e||{};if(typeof i!=="boolean")i=t instanceof n;this.objectMode=!!e.objectMode;if(i)this.objectMode=this.objectMode||!!e.writableObjectMode;this.highWaterMark=u(this,e,"writableHighWaterMark",i);this.finalCalled=false;this.needDrain=false;this.ending=false;this.ended=false;this.finished=false;this.destroyed=false;var a=e.decodeStrings===false;this.decodeStrings=!a;this.defaultEncoding=e.defaultEncoding||"utf8";this.length=0;this.writing=false;this.corked=0;this.sync=true;this.bufferProcessing=false;this.onwrite=function(e){onwrite(t,e)};this.writecb=null;this.writelen=0;this.bufferedRequest=null;this.lastBufferedRequest=null;this.pendingcb=0;this.prefinished=false;this.errorEmitted=false;this.emitClose=e.emitClose!==false;this.autoDestroy=!!e.autoDestroy;this.bufferedRequestCount=0;this.corkedRequestsFree=new CorkedRequest(this)}WritableState.prototype.getBuffer=function getBuffer(){var e=this.bufferedRequest;var t=[];while(e){t.push(e);e=e.next}return t};(function(){try{Object.defineProperty(WritableState.prototype,"buffer",{get:i.deprecate((function writableStateBufferGetter(){return this.getBuffer()}),"_writableState.buffer is deprecated. Use _writableState.getBuffer "+"instead.","DEP0003")})}catch(e){}})();var w;if(typeof Symbol==="function"&&Symbol.hasInstance&&typeof Function.prototype[Symbol.hasInstance]==="function"){w=Function.prototype[Symbol.hasInstance];Object.defineProperty(Writable,Symbol.hasInstance,{value:function value(e){if(w.call(this,e))return true;if(this!==Writable)return false;return e&&e._writableState instanceof WritableState}})}else{w=function realHasInstance(e){return e instanceof this}}function Writable(e){n=n||r(309);var t=this instanceof n;if(!t&&!w.call(Writable,this))return new Writable(e);this._writableState=new WritableState(e,this,t);this.writable=true;if(e){if(typeof e.write==="function")this._write=e.write;if(typeof e.writev==="function")this._writev=e.writev;if(typeof e.destroy==="function")this._destroy=e.destroy;if(typeof e.final==="function")this._final=e.final}a.call(this)}Writable.prototype.pipe=function(){m(this,new b)};function writeAfterEnd(e,t){var r=new _;m(e,r);process.nextTick(t,r)}function validChunk(e,t,r,n){var i;if(r===null){i=new g}else if(typeof r!=="string"&&!t.objectMode){i=new c("chunk",["string","Buffer"],r)}if(i){m(e,i);process.nextTick(n,i);return false}return true}Writable.prototype.write=function(e,t,r){var n=this._writableState;var i=false;var a=!n.objectMode&&_isUint8Array(e);if(a&&!o.isBuffer(e)){e=_uint8ArrayToBuffer(e)}if(typeof t==="function"){r=t;t=null}if(a)t="buffer";else if(!t)t=n.defaultEncoding;if(typeof r!=="function")r=nop;if(n.ending)writeAfterEnd(this,r);else if(a||validChunk(this,n,e,r)){n.pendingcb++;i=writeOrBuffer(this,n,a,e,t,r)}return i};Writable.prototype.cork=function(){this._writableState.corked++};Writable.prototype.uncork=function(){var e=this._writableState;if(e.corked){e.corked--;if(!e.writing&&!e.corked&&!e.bufferProcessing&&e.bufferedRequest)clearBuffer(this,e)}};Writable.prototype.setDefaultEncoding=function setDefaultEncoding(e){if(typeof e==="string")e=e.toLowerCase();if(!(["hex","utf8","utf-8","ascii","binary","base64","ucs2","ucs-2","utf16le","utf-16le","raw"].indexOf((e+"").toLowerCase())>-1))throw new v(e);this._writableState.defaultEncoding=e;return this};Object.defineProperty(Writable.prototype,"writableBuffer",{enumerable:false,get:function get(){return this._writableState&&this._writableState.getBuffer()}});function decodeChunk(e,t,r){if(!e.objectMode&&e.decodeStrings!==false&&typeof t==="string"){t=o.from(t,r)}return t}Object.defineProperty(Writable.prototype,"writableHighWaterMark",{enumerable:false,get:function get(){return this._writableState.highWaterMark}});function writeOrBuffer(e,t,r,n,i,a){if(!r){var o=decodeChunk(t,n,i);if(n!==o){r=true;i="buffer";n=o}}var s=t.objectMode?1:n.length;t.length+=s;var f=t.length<t.highWaterMark;if(!f)t.needDrain=true;if(t.writing||t.corked){var l=t.lastBufferedRequest;t.lastBufferedRequest={chunk:n,encoding:i,isBuf:r,callback:a,next:null};if(l){l.next=t.lastBufferedRequest}else{t.bufferedRequest=t.lastBufferedRequest}t.bufferedRequestCount+=1}else{doWrite(e,t,false,s,n,i,a)}return f}function doWrite(e,t,r,n,i,a,o){t.writelen=n;t.writecb=o;t.writing=true;t.sync=true;if(t.destroyed)t.onwrite(new y("write"));else if(r)e._writev(i,t.onwrite);else e._write(i,a,t.onwrite);t.sync=false}function onwriteError(e,t,r,n,i){--t.pendingcb;if(r){process.nextTick(i,n);process.nextTick(finishMaybe,e,t);e._writableState.errorEmitted=true;m(e,n)}else{i(n);e._writableState.errorEmitted=true;m(e,n);finishMaybe(e,t)}}function onwriteStateUpdate(e){e.writing=false;e.writecb=null;e.length-=e.writelen;e.writelen=0}function onwrite(e,t){var r=e._writableState;var n=r.sync;var i=r.writecb;if(typeof i!=="function")throw new p;onwriteStateUpdate(r);if(t)onwriteError(e,r,n,t,i);else{var a=needFinish(r)||e.destroyed;if(!a&&!r.corked&&!r.bufferProcessing&&r.bufferedRequest){clearBuffer(e,r)}if(n){process.nextTick(afterWrite,e,r,a,i)}else{afterWrite(e,r,a,i)}}}function afterWrite(e,t,r,n){if(!r)onwriteDrain(e,t);t.pendingcb--;n();finishMaybe(e,t)}function onwriteDrain(e,t){if(t.length===0&&t.needDrain){t.needDrain=false;e.emit("drain")}}function clearBuffer(e,t){t.bufferProcessing=true;var r=t.bufferedRequest;if(e._writev&&r&&r.next){var n=t.bufferedRequestCount;var i=new Array(n);var a=t.corkedRequestsFree;a.entry=r;var o=0;var s=true;while(r){i[o]=r;if(!r.isBuf)s=false;r=r.next;o+=1}i.allBuffers=s;doWrite(e,t,true,t.length,i,"",a.finish);t.pendingcb++;t.lastBufferedRequest=null;if(a.next){t.corkedRequestsFree=a.next;a.next=null}else{t.corkedRequestsFree=new CorkedRequest(t)}t.bufferedRequestCount=0}else{while(r){var f=r.chunk;var l=r.encoding;var u=r.callback;var d=t.objectMode?1:f.length;doWrite(e,t,false,d,f,l,u);r=r.next;t.bufferedRequestCount--;if(t.writing){break}}if(r===null)t.lastBufferedRequest=null}t.bufferedRequest=r;t.bufferProcessing=false}Writable.prototype._write=function(e,t,r){r(new h("_write()"))};Writable.prototype._writev=null;Writable.prototype.end=function(e,t,r){var n=this._writableState;if(typeof e==="function"){r=e;e=null;t=null}else if(typeof t==="function"){r=t;t=null}if(e!==null&&e!==undefined)this.write(e,t);if(n.corked){n.corked=1;this.uncork()}if(!n.ending)endWritable(this,n,r);return this};Object.defineProperty(Writable.prototype,"writableLength",{enumerable:false,get:function get(){return this._writableState.length}});function needFinish(e){return e.ending&&e.length===0&&e.bufferedRequest===null&&!e.finished&&!e.writing}function callFinal(e,t){e._final((function(r){t.pendingcb--;if(r){m(e,r)}t.prefinished=true;e.emit("prefinish");finishMaybe(e,t)}))}function prefinish(e,t){if(!t.prefinished&&!t.finalCalled){if(typeof e._final==="function"&&!t.destroyed){t.pendingcb++;t.finalCalled=true;process.nextTick(callFinal,e,t)}else{t.prefinished=true;e.emit("prefinish")}}}function finishMaybe(e,t){var r=needFinish(t);if(r){prefinish(e,t);if(t.pendingcb===0){t.finished=true;e.emit("finish");if(t.autoDestroy){var n=e._readableState;if(!n||n.autoDestroy&&n.endEmitted){e.destroy()}}}}return r}function endWritable(e,t,r){t.ending=true;finishMaybe(e,t);if(r){if(t.finished)process.nextTick(r);else e.once("finish",r)}t.ended=true;e.writable=false}function onCorkedFinish(e,t,r){var n=e.entry;e.entry=null;while(n){var i=n.callback;t.pendingcb--;i(r);n=n.next}t.corkedRequestsFree.next=e}Object.defineProperty(Writable.prototype,"destroyed",{enumerable:false,get:function get(){if(this._writableState===undefined){return false}return this._writableState.destroyed},set:function set(e){if(!this._writableState){return}this._writableState.destroyed=e}});Writable.prototype.destroy=f.destroy;Writable.prototype._undestroy=f.undestroy;Writable.prototype._destroy=function(e,t){t(e)}},373:function(e,t,r){"use strict";var n;function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var i=r(745);var a=Symbol("lastResolve");var o=Symbol("lastReject");var s=Symbol("error");var f=Symbol("ended");var l=Symbol("lastPromise");var u=Symbol("handlePromise");var d=Symbol("stream");function createIterResult(e,t){return{value:e,done:t}}function readAndResolve(e){var t=e[a];if(t!==null){var r=e[d].read();if(r!==null){e[l]=null;e[a]=null;e[o]=null;t(createIterResult(r,false))}}}function onReadable(e){process.nextTick(readAndResolve,e)}function wrapForNext(e,t){return function(r,n){e.then((function(){if(t[f]){r(createIterResult(undefined,true));return}t[u](r,n)}),n)}}var c=Object.getPrototypeOf((function(){}));var h=Object.setPrototypeOf((n={get stream(){return this[d]},next:function next(){var e=this;var t=this[s];if(t!==null){return Promise.reject(t)}if(this[f]){return Promise.resolve(createIterResult(undefined,true))}if(this[d].destroyed){return new Promise((function(t,r){process.nextTick((function(){if(e[s]){r(e[s])}else{t(createIterResult(undefined,true))}}))}))}var r=this[l];var n;if(r){n=new Promise(wrapForNext(r,this))}else{var i=this[d].read();if(i!==null){return Promise.resolve(createIterResult(i,false))}n=new Promise(this[u])}this[l]=n;return n}},_defineProperty(n,Symbol.asyncIterator,(function(){return this})),_defineProperty(n,"return",(function _return(){var e=this;return new Promise((function(t,r){e[d].destroy(null,(function(e){if(e){r(e);return}t(createIterResult(undefined,true))}))}))})),n),c);var p=function createReadableStreamAsyncIterator(e){var t;var r=Object.create(h,(t={},_defineProperty(t,d,{value:e,writable:true}),_defineProperty(t,a,{value:null,writable:true}),_defineProperty(t,o,{value:null,writable:true}),_defineProperty(t,s,{value:null,writable:true}),_defineProperty(t,f,{value:e._readableState.endEmitted,writable:true}),_defineProperty(t,u,{value:function value(e,t){var n=r[d].read();if(n){r[l]=null;r[a]=null;r[o]=null;e(createIterResult(n,false))}else{r[a]=e;r[o]=t}},writable:true}),t));r[l]=null;i(e,(function(e){if(e&&e.code!=="ERR_STREAM_PREMATURE_CLOSE"){var t=r[o];if(t!==null){r[l]=null;r[a]=null;r[o]=null;t(e)}r[s]=e;return}var n=r[a];if(n!==null){r[l]=null;r[a]=null;r[o]=null;n(createIterResult(undefined,true))}r[f]=true}));e.on("readable",onReadable.bind(null,r));return r};e.exports=p},446:function(e,t,r){"use strict";function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}function _classCallCheck(e,t){if(!(e instanceof t)){throw new TypeError("Cannot call a class as a function")}}function _defineProperties(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||false;n.configurable=true;if("value"in n)n.writable=true;Object.defineProperty(e,n.key,n)}}function _createClass(e,t,r){if(t)_defineProperties(e.prototype,t);if(r)_defineProperties(e,r);return e}var n=r(300),i=n.Buffer;var a=r(837),o=a.inspect;var s=o&&o.custom||"inspect";function copyBuffer(e,t,r){i.prototype.copy.call(e,t,r)}e.exports=function(){function BufferList(){_classCallCheck(this,BufferList);this.head=null;this.tail=null;this.length=0}_createClass(BufferList,[{key:"push",value:function push(e){var t={data:e,next:null};if(this.length>0)this.tail.next=t;else this.head=t;this.tail=t;++this.length}},{key:"unshift",value:function unshift(e){var t={data:e,next:this.head};if(this.length===0)this.tail=t;this.head=t;++this.length}},{key:"shift",value:function shift(){if(this.length===0)return;var e=this.head.data;if(this.length===1)this.head=this.tail=null;else this.head=this.head.next;--this.length;return e}},{key:"clear",value:function clear(){this.head=this.tail=null;this.length=0}},{key:"join",value:function join(e){if(this.length===0)return"";var t=this.head;var r=""+t.data;while(t=t.next){r+=e+t.data}return r}},{key:"concat",value:function concat(e){if(this.length===0)return i.alloc(0);var t=i.allocUnsafe(e>>>0);var r=this.head;var n=0;while(r){copyBuffer(r.data,t,n);n+=r.data.length;r=r.next}return t}},{key:"consume",value:function consume(e,t){var r;if(e<this.head.data.length){r=this.head.data.slice(0,e);this.head.data=this.head.data.slice(e)}else if(e===this.head.data.length){r=this.shift()}else{r=t?this._getString(e):this._getBuffer(e)}return r}},{key:"first",value:function first(){return this.head.data}},{key:"_getString",value:function _getString(e){var t=this.head;var r=1;var n=t.data;e-=n.length;while(t=t.next){var i=t.data;var a=e>i.length?i.length:e;if(a===i.length)n+=i;else n+=i.slice(0,e);e-=a;if(e===0){if(a===i.length){++r;if(t.next)this.head=t.next;else this.head=this.tail=null}else{this.head=t;t.data=i.slice(a)}break}++r}this.length-=r;return n}},{key:"_getBuffer",value:function _getBuffer(e){var t=i.allocUnsafe(e);var r=this.head;var n=1;r.data.copy(t);e-=r.data.length;while(r=r.next){var a=r.data;var o=e>a.length?a.length:e;a.copy(t,t.length-e,0,o);e-=o;if(e===0){if(o===a.length){++n;if(r.next)this.head=r.next;else this.head=this.tail=null}else{this.head=r;r.data=a.slice(o)}break}++n}this.length-=n;return t}},{key:s,value:function value(e,t){return o(this,_objectSpread({},t,{depth:0,customInspect:false}))}}]);return BufferList}()},556:function(e){"use strict";function destroy(e,t){var r=this;var n=this._readableState&&this._readableState.destroyed;var i=this._writableState&&this._writableState.destroyed;if(n||i){if(t){t(e)}else if(e){if(!this._writableState){process.nextTick(emitErrorNT,this,e)}else if(!this._writableState.errorEmitted){this._writableState.errorEmitted=true;process.nextTick(emitErrorNT,this,e)}}return this}if(this._readableState){this._readableState.destroyed=true}if(this._writableState){this._writableState.destroyed=true}this._destroy(e||null,(function(e){if(!t&&e){if(!r._writableState){process.nextTick(emitErrorAndCloseNT,r,e)}else if(!r._writableState.errorEmitted){r._writableState.errorEmitted=true;process.nextTick(emitErrorAndCloseNT,r,e)}else{process.nextTick(emitCloseNT,r)}}else if(t){process.nextTick(emitCloseNT,r);t(e)}else{process.nextTick(emitCloseNT,r)}}));return this}function emitErrorAndCloseNT(e,t){emitErrorNT(e,t);emitCloseNT(e)}function emitCloseNT(e){if(e._writableState&&!e._writableState.emitClose)return;if(e._readableState&&!e._readableState.emitClose)return;e.emit("close")}function undestroy(){if(this._readableState){this._readableState.destroyed=false;this._readableState.reading=false;this._readableState.ended=false;this._readableState.endEmitted=false}if(this._writableState){this._writableState.destroyed=false;this._writableState.ended=false;this._writableState.ending=false;this._writableState.finalCalled=false;this._writableState.prefinished=false;this._writableState.finished=false;this._writableState.errorEmitted=false}}function emitErrorNT(e,t){e.emit("error",t)}function errorOrDestroy(e,t){var r=e._readableState;var n=e._writableState;if(r&&r.autoDestroy||n&&n.autoDestroy)e.destroy(t);else e.emit("error",t)}e.exports={destroy:destroy,undestroy:undestroy,errorOrDestroy:errorOrDestroy}},745:function(e,t,r){"use strict";var n=r(558).q.ERR_STREAM_PREMATURE_CLOSE;function once(e){var t=false;return function(){if(t)return;t=true;for(var r=arguments.length,n=new Array(r),i=0;i<r;i++){n[i]=arguments[i]}e.apply(this,n)}}function noop(){}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function eos(e,t,r){if(typeof t==="function")return eos(e,null,t);if(!t)t={};r=once(r||noop);var i=t.readable||t.readable!==false&&e.readable;var a=t.writable||t.writable!==false&&e.writable;var o=function onlegacyfinish(){if(!e.writable)f()};var s=e._writableState&&e._writableState.finished;var f=function onfinish(){a=false;s=true;if(!i)r.call(e)};var l=e._readableState&&e._readableState.endEmitted;var u=function onend(){i=false;l=true;if(!a)r.call(e)};var d=function onerror(t){r.call(e,t)};var c=function onclose(){var t;if(i&&!l){if(!e._readableState||!e._readableState.ended)t=new n;return r.call(e,t)}if(a&&!s){if(!e._writableState||!e._writableState.ended)t=new n;return r.call(e,t)}};var h=function onrequest(){e.req.on("finish",f)};if(isRequest(e)){e.on("complete",f);e.on("abort",c);if(e.req)h();else e.on("request",h)}else if(a&&!e._writableState){e.on("end",o);e.on("close",o)}e.on("end",u);e.on("finish",f);if(t.error!==false)e.on("error",d);e.on("close",c);return function(){e.removeListener("complete",f);e.removeListener("abort",c);e.removeListener("request",h);if(e.req)e.req.removeListener("finish",f);e.removeListener("end",o);e.removeListener("close",o);e.removeListener("finish",f);e.removeListener("end",u);e.removeListener("error",d);e.removeListener("close",c)}}e.exports=eos},722:function(e,t,r){"use strict";function asyncGeneratorStep(e,t,r,n,i,a,o){try{var s=e[a](o);var f=s.value}catch(e){r(e);return}if(s.done){t(f)}else{Promise.resolve(f).then(n,i)}}function _asyncToGenerator(e){return function(){var t=this,r=arguments;return new Promise((function(n,i){var a=e.apply(t,r);function _next(e){asyncGeneratorStep(a,n,i,_next,_throw,"next",e)}function _throw(e){asyncGeneratorStep(a,n,i,_next,_throw,"throw",e)}_next(undefined)}))}}function ownKeys(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);if(t)n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}));r.push.apply(r,n)}return r}function _objectSpread(e){for(var t=1;t<arguments.length;t++){var r=arguments[t]!=null?arguments[t]:{};if(t%2){ownKeys(Object(r),true).forEach((function(t){_defineProperty(e,t,r[t])}))}else if(Object.getOwnPropertyDescriptors){Object.defineProperties(e,Object.getOwnPropertyDescriptors(r))}else{ownKeys(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t))}))}}return e}function _defineProperty(e,t,r){if(t in e){Object.defineProperty(e,t,{value:r,enumerable:true,configurable:true,writable:true})}else{e[t]=r}return e}var n=r(558).q.ERR_INVALID_ARG_TYPE;function from(e,t,r){var i;if(t&&typeof t.next==="function"){i=t}else if(t&&t[Symbol.asyncIterator])i=t[Symbol.asyncIterator]();else if(t&&t[Symbol.iterator])i=t[Symbol.iterator]();else throw new n("iterable",["Iterable"],t);var a=new e(_objectSpread({objectMode:true},r));var o=false;a._read=function(){if(!o){o=true;next()}};function next(){return _next2.apply(this,arguments)}function _next2(){_next2=_asyncToGenerator((function*(){try{var e=yield i.next(),t=e.value,r=e.done;if(r){a.push(null)}else if(a.push(yield t)){next()}else{o=false}}catch(e){a.destroy(e)}}));return _next2.apply(this,arguments)}return a}e.exports=from},921:function(e,t,r){"use strict";var n;function once(e){var t=false;return function(){if(t)return;t=true;e.apply(void 0,arguments)}}var i=r(558).q,a=i.ERR_MISSING_ARGS,o=i.ERR_STREAM_DESTROYED;function noop(e){if(e)throw e}function isRequest(e){return e.setHeader&&typeof e.abort==="function"}function destroyer(e,t,i,a){a=once(a);var s=false;e.on("close",(function(){s=true}));if(n===undefined)n=r(745);n(e,{readable:t,writable:i},(function(e){if(e)return a(e);s=true;a()}));var f=false;return function(t){if(s)return;if(f)return;f=true;if(isRequest(e))return e.abort();if(typeof e.destroy==="function")return e.destroy();a(t||new o("pipe"))}}function call(e){e()}function pipe(e,t){return e.pipe(t)}function popCallback(e){if(!e.length)return noop;if(typeof e[e.length-1]!=="function")return noop;return e.pop()}function pipeline(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++){t[r]=arguments[r]}var n=popCallback(t);if(Array.isArray(t[0]))t=t[0];if(t.length<2){throw new a("streams")}var i;var o=t.map((function(e,r){var a=r<t.length-1;var s=r>0;return destroyer(e,a,s,(function(e){if(!i)i=e;if(e)o.forEach(call);if(a)return;o.forEach(call);n(i)}))}));return t.reduce(pipe)}e.exports=pipeline},416:function(e,t,r){"use strict";var n=r(558).q.ERR_INVALID_OPT_VALUE;function highWaterMarkFrom(e,t,r){return e.highWaterMark!=null?e.highWaterMark:t?e[r]:null}function getHighWaterMark(e,t,r,i){var a=highWaterMarkFrom(t,i,r);if(a!=null){if(!(isFinite(a)&&Math.floor(a)===a)||a<0){var o=i?r:"highWaterMark";throw new n(o,a)}return Math.floor(a)}return e.objectMode?16:16*1024}e.exports={getHighWaterMark:getHighWaterMark}},982:function(e,t,r){e.exports=r(781)},121:function(e,t,r){var n=r(781);if(process.env.READABLE_STREAM==="disable"&&n){e.exports=n.Readable;Object.assign(e.exports,n);e.exports.Stream=n}else{t=e.exports=r(903);t.Stream=n||t;t.Readable=t;t.Writable=r(551);t.Duplex=r(309);t.Transform=r(767);t.PassThrough=r(268);t.finished=r(745);t.pipeline=r(921)}},961:function(e,t,r){"use strict";var n=r(118).Buffer;var i=n.isEncoding||function(e){e=""+e;switch(e&&e.toLowerCase()){case"hex":case"utf8":case"utf-8":case"ascii":case"binary":case"base64":case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":case"raw":return true;default:return false}};function _normalizeEncoding(e){if(!e)return"utf8";var t;while(true){switch(e){case"utf8":case"utf-8":return"utf8";case"ucs2":case"ucs-2":case"utf16le":case"utf-16le":return"utf16le";case"latin1":case"binary":return"latin1";case"base64":case"ascii":case"hex":return e;default:if(t)return;e=(""+e).toLowerCase();t=true}}}function normalizeEncoding(e){var t=_normalizeEncoding(e);if(typeof t!=="string"&&(n.isEncoding===i||!i(e)))throw new Error("Unknown encoding: "+e);return t||e}t.s=StringDecoder;function StringDecoder(e){this.encoding=normalizeEncoding(e);var t;switch(this.encoding){case"utf16le":this.text=utf16Text;this.end=utf16End;t=4;break;case"utf8":this.fillLast=utf8FillLast;t=4;break;case"base64":this.text=base64Text;this.end=base64End;t=3;break;default:this.write=simpleWrite;this.end=simpleEnd;return}this.lastNeed=0;this.lastTotal=0;this.lastChar=n.allocUnsafe(t)}StringDecoder.prototype.write=function(e){if(e.length===0)return"";var t;var r;if(this.lastNeed){t=this.fillLast(e);if(t===undefined)return"";r=this.lastNeed;this.lastNeed=0}else{r=0}if(r<e.length)return t?t+this.text(e,r):this.text(e,r);return t||""};StringDecoder.prototype.end=utf8End;StringDecoder.prototype.text=utf8Text;StringDecoder.prototype.fillLast=function(e){if(this.lastNeed<=e.length){e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,this.lastTotal-this.lastNeed,0,e.length);this.lastNeed-=e.length};function utf8CheckByte(e){if(e<=127)return 0;else if(e>>5===6)return 2;else if(e>>4===14)return 3;else if(e>>3===30)return 4;return e>>6===2?-1:-2}function utf8CheckIncomplete(e,t,r){var n=t.length-1;if(n<r)return 0;var i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-1;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0)e.lastNeed=i-2;return i}if(--n<r||i===-2)return 0;i=utf8CheckByte(t[n]);if(i>=0){if(i>0){if(i===2)i=0;else e.lastNeed=i-3}return i}return 0}function utf8CheckExtraBytes(e,t,r){if((t[0]&192)!==128){e.lastNeed=0;return"�"}if(e.lastNeed>1&&t.length>1){if((t[1]&192)!==128){e.lastNeed=1;return"�"}if(e.lastNeed>2&&t.length>2){if((t[2]&192)!==128){e.lastNeed=2;return"�"}}}}function utf8FillLast(e){var t=this.lastTotal-this.lastNeed;var r=utf8CheckExtraBytes(this,e,t);if(r!==undefined)return r;if(this.lastNeed<=e.length){e.copy(this.lastChar,t,0,this.lastNeed);return this.lastChar.toString(this.encoding,0,this.lastTotal)}e.copy(this.lastChar,t,0,e.length);this.lastNeed-=e.length}function utf8Text(e,t){var r=utf8CheckIncomplete(this,e,t);if(!this.lastNeed)return e.toString("utf8",t);this.lastTotal=r;var n=e.length-(r-this.lastNeed);e.copy(this.lastChar,0,n);return e.toString("utf8",t,n)}function utf8End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+"�";return t}function utf16Text(e,t){if((e.length-t)%2===0){var r=e.toString("utf16le",t);if(r){var n=r.charCodeAt(r.length-1);if(n>=55296&&n<=56319){this.lastNeed=2;this.lastTotal=4;this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1];return r.slice(0,-1)}}return r}this.lastNeed=1;this.lastTotal=2;this.lastChar[0]=e[e.length-1];return e.toString("utf16le",t,e.length-1)}function utf16End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed){var r=this.lastTotal-this.lastNeed;return t+this.lastChar.toString("utf16le",0,r)}return t}function base64Text(e,t){var r=(e.length-t)%3;if(r===0)return e.toString("base64",t);this.lastNeed=3-r;this.lastTotal=3;if(r===1){this.lastChar[0]=e[e.length-1]}else{this.lastChar[0]=e[e.length-2];this.lastChar[1]=e[e.length-1]}return e.toString("base64",t,e.length-r)}function base64End(e){var t=e&&e.length?this.write(e):"";if(this.lastNeed)return t+this.lastChar.toString("base64",0,3-this.lastNeed);return t}function simpleWrite(e){return e.toString(this.encoding)}function simpleEnd(e){return e&&e.length?this.write(e):""}},989:function(e){e.exports=deprecate;function deprecate(e,t){if(config("noDeprecation")){return e}var r=false;function deprecated(){if(!r){if(config("throwDeprecation")){throw new Error(t)}else if(config("traceDeprecation")){console.trace(t)}else{console.warn(t)}r=true}return e.apply(this,arguments)}return deprecated}function config(e){try{if(!__webpack_require__.g.localStorage)return false}catch(e){return false}var t=__webpack_require__.g.localStorage[e];if(null==t)return false;return String(t).toLowerCase()==="true"}},738:function(e){e.exports=extend;var t=Object.prototype.hasOwnProperty;function extend(){var e={};for(var r=0;r<arguments.length;r++){var n=arguments[r];for(var i in n){if(t.call(n,i)){e[i]=n[i]}}}return e}},300:function(e){"use strict";e.exports=__webpack_require__(48764)},361:function(e){"use strict";e.exports=__webpack_require__(17187)},781:function(e){"use strict";e.exports=__webpack_require__(79681)},310:function(e){"use strict";e.exports=__webpack_require__(11987)},837:function(e){"use strict";e.exports=__webpack_require__(79720)}};var t={};function __nccwpck_require__(r){var n=t[r];if(n!==undefined){return n.exports}var i=t[r]={exports:{}};var a=true;try{e[r](i,i.exports,__nccwpck_require__);a=false}finally{if(a)delete t[r]}return i.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var r=__nccwpck_require__(859);module.exports=r})();

/***/ }),

/***/ 82021:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
(function(){"use strict";var e={800:function(e){
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var r=Object.getOwnPropertySymbols;var t=Object.prototype.hasOwnProperty;var u=Object.prototype.propertyIsEnumerable;function toObject(e){if(e===null||e===undefined){throw new TypeError("Object.assign cannot be called with null or undefined")}return Object(e)}function shouldUseNative(){try{if(!Object.assign){return false}var e=new String("abc");e[5]="de";if(Object.getOwnPropertyNames(e)[0]==="5"){return false}var r={};for(var t=0;t<10;t++){r["_"+String.fromCharCode(t)]=t}var u=Object.getOwnPropertyNames(r).map((function(e){return r[e]}));if(u.join("")!=="0123456789"){return false}var n={};"abcdefghijklmnopqrst".split("").forEach((function(e){n[e]=e}));if(Object.keys(Object.assign({},n)).join("")!=="abcdefghijklmnopqrst"){return false}return true}catch(e){return false}}e.exports=shouldUseNative()?Object.assign:function(e,n){var a;var i=toObject(e);var s;for(var c=1;c<arguments.length;c++){a=Object(arguments[c]);for(var o in a){if(t.call(a,o)){i[o]=a[o]}}if(r){s=r(a);for(var f=0;f<s.length;f++){if(u.call(a,s[f])){i[s[f]]=a[s[f]]}}}}return i}},569:function(e,r,t){
/** @license React vundefined
 * use-subscription.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
if(false){}},403:function(e,r,t){
/** @license React vundefined
 * use-subscription.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var u=t(800),n=t(522);r.useSubscription=function(e){var r=e.getCurrentValue,t=e.subscribe,a=n.useState((function(){return{getCurrentValue:r,subscribe:t,value:r()}}));e=a[0];var i=a[1];a=e.value;if(e.getCurrentValue!==r||e.subscribe!==t)a=r(),i({getCurrentValue:r,subscribe:t,value:a});n.useDebugValue(a);n.useEffect((function(){function b(){if(!e){var n=r();i((function(e){return e.getCurrentValue!==r||e.subscribe!==t||e.value===n?e:u({},e,{value:n})}))}}var e=!1,n=t(b);b();return function(){e=!0;n()}}),[r,t]);return a}},138:function(e,r,t){if(true){e.exports=t(403)}else{}},522:function(e){e.exports=__webpack_require__(67294)}};var r={};function __nccwpck_require__(t){var u=r[t];if(u!==undefined){return u.exports}var n=r[t]={exports:{}};var a=true;try{e[t](n,n.exports,__nccwpck_require__);a=false}finally{if(a)delete r[t]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var t=__nccwpck_require__(138);module.exports=t})();

/***/ }),

/***/ 79720:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var __dirname = "/";
/* provided dependency */ var Buffer = __webpack_require__(48764)["Buffer"];
/* provided dependency */ var process = __webpack_require__(83454);
(function(){var r={901:function(r){r.exports=function(r,e,o){if(r.filter)return r.filter(e,o);if(void 0===r||null===r)throw new TypeError;if("function"!=typeof e)throw new TypeError;var n=[];for(var i=0;i<r.length;i++){if(!t.call(r,i))continue;var a=r[i];if(e.call(o,a,i,r))n.push(a)}return n};var t=Object.prototype.hasOwnProperty},749:function(r,t,e){"use strict";var o=e(91);var n=e(112);var i=n(o("String.prototype.indexOf"));r.exports=function callBoundIntrinsic(r,t){var e=o(r,!!t);if(typeof e==="function"&&i(r,".prototype.")>-1){return n(e)}return e}},112:function(r,t,e){"use strict";var o=e(517);var n=e(91);var i=n("%Function.prototype.apply%");var a=n("%Function.prototype.call%");var y=n("%Reflect.apply%",true)||o.call(a,i);var p=n("%Object.getOwnPropertyDescriptor%",true);var f=n("%Object.defineProperty%",true);var u=n("%Math.max%");if(f){try{f({},"a",{value:1})}catch(r){f=null}}r.exports=function callBind(r){var t=y(o,a,arguments);if(p&&f){var e=p(t,"length");if(e.configurable){f(t,"length",{value:1+u(0,r.length-(arguments.length-1))})}}return t};var s=function applyBind(){return y(o,i,arguments)};if(f){f(r.exports,"apply",{value:s})}else{r.exports.apply=s}},91:function(r,t,e){"use strict";var o;var n=SyntaxError;var i=Function;var a=TypeError;var getEvalledConstructor=function(r){try{return Function('"use strict"; return ('+r+").constructor;")()}catch(r){}};var y=Object.getOwnPropertyDescriptor;if(y){try{y({},"")}catch(r){y=null}}var throwTypeError=function(){throw new a};var p=y?function(){try{arguments.callee;return throwTypeError}catch(r){try{return y(arguments,"callee").get}catch(r){return throwTypeError}}}():throwTypeError;var f=e(449)();var u=Object.getPrototypeOf||function(r){return r.__proto__};var s=getEvalledConstructor("async function* () {}");var c=s?s.prototype:o;var l=c?c.prototype:o;var d=typeof Uint8Array==="undefined"?o:u(Uint8Array);var g={"%AggregateError%":typeof AggregateError==="undefined"?o:AggregateError,"%Array%":Array,"%ArrayBuffer%":typeof ArrayBuffer==="undefined"?o:ArrayBuffer,"%ArrayIteratorPrototype%":f?u([][Symbol.iterator]()):o,"%AsyncFromSyncIteratorPrototype%":o,"%AsyncFunction%":getEvalledConstructor("async function () {}"),"%AsyncGenerator%":c,"%AsyncGeneratorFunction%":s,"%AsyncIteratorPrototype%":l?u(l):o,"%Atomics%":typeof Atomics==="undefined"?o:Atomics,"%BigInt%":typeof BigInt==="undefined"?o:BigInt,"%Boolean%":Boolean,"%DataView%":typeof DataView==="undefined"?o:DataView,"%Date%":Date,"%decodeURI%":decodeURI,"%decodeURIComponent%":decodeURIComponent,"%encodeURI%":encodeURI,"%encodeURIComponent%":encodeURIComponent,"%Error%":Error,"%eval%":eval,"%EvalError%":EvalError,"%Float32Array%":typeof Float32Array==="undefined"?o:Float32Array,"%Float64Array%":typeof Float64Array==="undefined"?o:Float64Array,"%FinalizationRegistry%":typeof FinalizationRegistry==="undefined"?o:FinalizationRegistry,"%Function%":i,"%GeneratorFunction%":getEvalledConstructor("function* () {}"),"%Int8Array%":typeof Int8Array==="undefined"?o:Int8Array,"%Int16Array%":typeof Int16Array==="undefined"?o:Int16Array,"%Int32Array%":typeof Int32Array==="undefined"?o:Int32Array,"%isFinite%":isFinite,"%isNaN%":isNaN,"%IteratorPrototype%":f?u(u([][Symbol.iterator]())):o,"%JSON%":typeof JSON==="object"?JSON:o,"%Map%":typeof Map==="undefined"?o:Map,"%MapIteratorPrototype%":typeof Map==="undefined"||!f?o:u((new Map)[Symbol.iterator]()),"%Math%":Math,"%Number%":Number,"%Object%":Object,"%parseFloat%":parseFloat,"%parseInt%":parseInt,"%Promise%":typeof Promise==="undefined"?o:Promise,"%Proxy%":typeof Proxy==="undefined"?o:Proxy,"%RangeError%":RangeError,"%ReferenceError%":ReferenceError,"%Reflect%":typeof Reflect==="undefined"?o:Reflect,"%RegExp%":RegExp,"%Set%":typeof Set==="undefined"?o:Set,"%SetIteratorPrototype%":typeof Set==="undefined"||!f?o:u((new Set)[Symbol.iterator]()),"%SharedArrayBuffer%":typeof SharedArrayBuffer==="undefined"?o:SharedArrayBuffer,"%String%":String,"%StringIteratorPrototype%":f?u(""[Symbol.iterator]()):o,"%Symbol%":f?Symbol:o,"%SyntaxError%":n,"%ThrowTypeError%":p,"%TypedArray%":d,"%TypeError%":a,"%Uint8Array%":typeof Uint8Array==="undefined"?o:Uint8Array,"%Uint8ClampedArray%":typeof Uint8ClampedArray==="undefined"?o:Uint8ClampedArray,"%Uint16Array%":typeof Uint16Array==="undefined"?o:Uint16Array,"%Uint32Array%":typeof Uint32Array==="undefined"?o:Uint32Array,"%URIError%":URIError,"%WeakMap%":typeof WeakMap==="undefined"?o:WeakMap,"%WeakRef%":typeof WeakRef==="undefined"?o:WeakRef,"%WeakSet%":typeof WeakSet==="undefined"?o:WeakSet};var A={"%ArrayBufferPrototype%":["ArrayBuffer","prototype"],"%ArrayPrototype%":["Array","prototype"],"%ArrayProto_entries%":["Array","prototype","entries"],"%ArrayProto_forEach%":["Array","prototype","forEach"],"%ArrayProto_keys%":["Array","prototype","keys"],"%ArrayProto_values%":["Array","prototype","values"],"%AsyncFunctionPrototype%":["AsyncFunction","prototype"],"%AsyncGenerator%":["AsyncGeneratorFunction","prototype"],"%AsyncGeneratorPrototype%":["AsyncGeneratorFunction","prototype","prototype"],"%BooleanPrototype%":["Boolean","prototype"],"%DataViewPrototype%":["DataView","prototype"],"%DatePrototype%":["Date","prototype"],"%ErrorPrototype%":["Error","prototype"],"%EvalErrorPrototype%":["EvalError","prototype"],"%Float32ArrayPrototype%":["Float32Array","prototype"],"%Float64ArrayPrototype%":["Float64Array","prototype"],"%FunctionPrototype%":["Function","prototype"],"%Generator%":["GeneratorFunction","prototype"],"%GeneratorPrototype%":["GeneratorFunction","prototype","prototype"],"%Int8ArrayPrototype%":["Int8Array","prototype"],"%Int16ArrayPrototype%":["Int16Array","prototype"],"%Int32ArrayPrototype%":["Int32Array","prototype"],"%JSONParse%":["JSON","parse"],"%JSONStringify%":["JSON","stringify"],"%MapPrototype%":["Map","prototype"],"%NumberPrototype%":["Number","prototype"],"%ObjectPrototype%":["Object","prototype"],"%ObjProto_toString%":["Object","prototype","toString"],"%ObjProto_valueOf%":["Object","prototype","valueOf"],"%PromisePrototype%":["Promise","prototype"],"%PromiseProto_then%":["Promise","prototype","then"],"%Promise_all%":["Promise","all"],"%Promise_reject%":["Promise","reject"],"%Promise_resolve%":["Promise","resolve"],"%RangeErrorPrototype%":["RangeError","prototype"],"%ReferenceErrorPrototype%":["ReferenceError","prototype"],"%RegExpPrototype%":["RegExp","prototype"],"%SetPrototype%":["Set","prototype"],"%SharedArrayBufferPrototype%":["SharedArrayBuffer","prototype"],"%StringPrototype%":["String","prototype"],"%SymbolPrototype%":["Symbol","prototype"],"%SyntaxErrorPrototype%":["SyntaxError","prototype"],"%TypedArrayPrototype%":["TypedArray","prototype"],"%TypeErrorPrototype%":["TypeError","prototype"],"%Uint8ArrayPrototype%":["Uint8Array","prototype"],"%Uint8ClampedArrayPrototype%":["Uint8ClampedArray","prototype"],"%Uint16ArrayPrototype%":["Uint16Array","prototype"],"%Uint32ArrayPrototype%":["Uint32Array","prototype"],"%URIErrorPrototype%":["URIError","prototype"],"%WeakMapPrototype%":["WeakMap","prototype"],"%WeakSetPrototype%":["WeakSet","prototype"]};var v=e(517);var b=e(793);var S=v.call(Function.call,Array.prototype.concat);var m=v.call(Function.apply,Array.prototype.splice);var P=v.call(Function.call,String.prototype.replace);var h=v.call(Function.call,String.prototype.slice);var O=/[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;var w=/\\(\\)?/g;var E=function stringToPath(r){var t=h(r,0,1);var e=h(r,-1);if(t==="%"&&e!=="%"){throw new n("invalid intrinsic syntax, expected closing `%`")}else if(e==="%"&&t!=="%"){throw new n("invalid intrinsic syntax, expected opening `%`")}var o=[];P(r,O,(function(r,t,e,n){o[o.length]=e?P(n,w,"$1"):t||r}));return o};var j=function getBaseIntrinsic(r,t){var e=r;var o;if(b(A,e)){o=A[e];e="%"+o[0]+"%"}if(b(g,e)){var i=g[e];if(typeof i==="undefined"&&!t){throw new a("intrinsic "+r+" exists, but is not available. Please file an issue!")}return{alias:o,name:e,value:i}}throw new n("intrinsic "+r+" does not exist!")};r.exports=function GetIntrinsic(r,t){if(typeof r!=="string"||r.length===0){throw new a("intrinsic name must be a non-empty string")}if(arguments.length>1&&typeof t!=="boolean"){throw new a('"allowMissing" argument must be a boolean')}var e=E(r);var i=e.length>0?e[0]:"";var p=j("%"+i+"%",t);var f=p.name;var u=p.value;var s=false;var c=p.alias;if(c){i=c[0];m(e,S([0,1],c))}for(var l=1,d=true;l<e.length;l+=1){var A=e[l];var v=h(A,0,1);var P=h(A,-1);if((v==='"'||v==="'"||v==="`"||(P==='"'||P==="'"||P==="`"))&&v!==P){throw new n("property names with quotes must have matching quotes")}if(A==="constructor"||!d){s=true}i+="."+A;f="%"+i+"%";if(b(g,f)){u=g[f]}else if(u!=null){if(!(A in u)){if(!t){throw new a("base intrinsic for "+r+" exists, but the property is not available.")}return void o}if(y&&l+1>=e.length){var O=y(u,A);d=!!O;if(d&&"get"in O&&!("originalValue"in O.get)){u=O.get}else{u=u[A]}}else{d=b(u,A);u=u[A]}if(d&&!s){g[f]=u}}}return u}},219:function(r){var t=Object.prototype.hasOwnProperty;var e=Object.prototype.toString;r.exports=function forEach(r,o,n){if(e.call(o)!=="[object Function]"){throw new TypeError("iterator must be a function")}var i=r.length;if(i===+i){for(var a=0;a<i;a++){o.call(n,r[a],a,r)}}else{for(var y in r){if(t.call(r,y)){o.call(n,r[y],y,r)}}}}},733:function(r){"use strict";var t="Function.prototype.bind called on incompatible ";var e=Array.prototype.slice;var o=Object.prototype.toString;var n="[object Function]";r.exports=function bind(r){var i=this;if(typeof i!=="function"||o.call(i)!==n){throw new TypeError(t+i)}var a=e.call(arguments,1);var y;var binder=function(){if(this instanceof y){var t=i.apply(this,a.concat(e.call(arguments)));if(Object(t)===t){return t}return this}else{return i.apply(r,a.concat(e.call(arguments)))}};var p=Math.max(0,i.length-a.length);var f=[];for(var u=0;u<p;u++){f.push("$"+u)}y=Function("binder","return function ("+f.join(",")+"){ return binder.apply(this,arguments); }")(binder);if(i.prototype){var s=function Empty(){};s.prototype=i.prototype;y.prototype=new s;s.prototype=null}return y}},517:function(r,t,e){"use strict";var o=e(733);r.exports=Function.prototype.bind||o},879:function(r,t,e){"use strict";var o;var n=SyntaxError;var i=Function;var a=TypeError;var getEvalledConstructor=function(r){try{return i('"use strict"; return ('+r+").constructor;")()}catch(r){}};var y=Object.getOwnPropertyDescriptor;if(y){try{y({},"")}catch(r){y=null}}var throwTypeError=function(){throw new a};var p=y?function(){try{arguments.callee;return throwTypeError}catch(r){try{return y(arguments,"callee").get}catch(r){return throwTypeError}}}():throwTypeError;var f=e(449)();var u=Object.getPrototypeOf||function(r){return r.__proto__};var s={};var c=typeof Uint8Array==="undefined"?o:u(Uint8Array);var l={"%AggregateError%":typeof AggregateError==="undefined"?o:AggregateError,"%Array%":Array,"%ArrayBuffer%":typeof ArrayBuffer==="undefined"?o:ArrayBuffer,"%ArrayIteratorPrototype%":f?u([][Symbol.iterator]()):o,"%AsyncFromSyncIteratorPrototype%":o,"%AsyncFunction%":s,"%AsyncGenerator%":s,"%AsyncGeneratorFunction%":s,"%AsyncIteratorPrototype%":s,"%Atomics%":typeof Atomics==="undefined"?o:Atomics,"%BigInt%":typeof BigInt==="undefined"?o:BigInt,"%Boolean%":Boolean,"%DataView%":typeof DataView==="undefined"?o:DataView,"%Date%":Date,"%decodeURI%":decodeURI,"%decodeURIComponent%":decodeURIComponent,"%encodeURI%":encodeURI,"%encodeURIComponent%":encodeURIComponent,"%Error%":Error,"%eval%":eval,"%EvalError%":EvalError,"%Float32Array%":typeof Float32Array==="undefined"?o:Float32Array,"%Float64Array%":typeof Float64Array==="undefined"?o:Float64Array,"%FinalizationRegistry%":typeof FinalizationRegistry==="undefined"?o:FinalizationRegistry,"%Function%":i,"%GeneratorFunction%":s,"%Int8Array%":typeof Int8Array==="undefined"?o:Int8Array,"%Int16Array%":typeof Int16Array==="undefined"?o:Int16Array,"%Int32Array%":typeof Int32Array==="undefined"?o:Int32Array,"%isFinite%":isFinite,"%isNaN%":isNaN,"%IteratorPrototype%":f?u(u([][Symbol.iterator]())):o,"%JSON%":typeof JSON==="object"?JSON:o,"%Map%":typeof Map==="undefined"?o:Map,"%MapIteratorPrototype%":typeof Map==="undefined"||!f?o:u((new Map)[Symbol.iterator]()),"%Math%":Math,"%Number%":Number,"%Object%":Object,"%parseFloat%":parseFloat,"%parseInt%":parseInt,"%Promise%":typeof Promise==="undefined"?o:Promise,"%Proxy%":typeof Proxy==="undefined"?o:Proxy,"%RangeError%":RangeError,"%ReferenceError%":ReferenceError,"%Reflect%":typeof Reflect==="undefined"?o:Reflect,"%RegExp%":RegExp,"%Set%":typeof Set==="undefined"?o:Set,"%SetIteratorPrototype%":typeof Set==="undefined"||!f?o:u((new Set)[Symbol.iterator]()),"%SharedArrayBuffer%":typeof SharedArrayBuffer==="undefined"?o:SharedArrayBuffer,"%String%":String,"%StringIteratorPrototype%":f?u(""[Symbol.iterator]()):o,"%Symbol%":f?Symbol:o,"%SyntaxError%":n,"%ThrowTypeError%":p,"%TypedArray%":c,"%TypeError%":a,"%Uint8Array%":typeof Uint8Array==="undefined"?o:Uint8Array,"%Uint8ClampedArray%":typeof Uint8ClampedArray==="undefined"?o:Uint8ClampedArray,"%Uint16Array%":typeof Uint16Array==="undefined"?o:Uint16Array,"%Uint32Array%":typeof Uint32Array==="undefined"?o:Uint32Array,"%URIError%":URIError,"%WeakMap%":typeof WeakMap==="undefined"?o:WeakMap,"%WeakRef%":typeof WeakRef==="undefined"?o:WeakRef,"%WeakSet%":typeof WeakSet==="undefined"?o:WeakSet};var d=function doEval(r){var t;if(r==="%AsyncFunction%"){t=getEvalledConstructor("async function () {}")}else if(r==="%GeneratorFunction%"){t=getEvalledConstructor("function* () {}")}else if(r==="%AsyncGeneratorFunction%"){t=getEvalledConstructor("async function* () {}")}else if(r==="%AsyncGenerator%"){var e=doEval("%AsyncGeneratorFunction%");if(e){t=e.prototype}}else if(r==="%AsyncIteratorPrototype%"){var o=doEval("%AsyncGenerator%");if(o){t=u(o.prototype)}}l[r]=t;return t};var g={"%ArrayBufferPrototype%":["ArrayBuffer","prototype"],"%ArrayPrototype%":["Array","prototype"],"%ArrayProto_entries%":["Array","prototype","entries"],"%ArrayProto_forEach%":["Array","prototype","forEach"],"%ArrayProto_keys%":["Array","prototype","keys"],"%ArrayProto_values%":["Array","prototype","values"],"%AsyncFunctionPrototype%":["AsyncFunction","prototype"],"%AsyncGenerator%":["AsyncGeneratorFunction","prototype"],"%AsyncGeneratorPrototype%":["AsyncGeneratorFunction","prototype","prototype"],"%BooleanPrototype%":["Boolean","prototype"],"%DataViewPrototype%":["DataView","prototype"],"%DatePrototype%":["Date","prototype"],"%ErrorPrototype%":["Error","prototype"],"%EvalErrorPrototype%":["EvalError","prototype"],"%Float32ArrayPrototype%":["Float32Array","prototype"],"%Float64ArrayPrototype%":["Float64Array","prototype"],"%FunctionPrototype%":["Function","prototype"],"%Generator%":["GeneratorFunction","prototype"],"%GeneratorPrototype%":["GeneratorFunction","prototype","prototype"],"%Int8ArrayPrototype%":["Int8Array","prototype"],"%Int16ArrayPrototype%":["Int16Array","prototype"],"%Int32ArrayPrototype%":["Int32Array","prototype"],"%JSONParse%":["JSON","parse"],"%JSONStringify%":["JSON","stringify"],"%MapPrototype%":["Map","prototype"],"%NumberPrototype%":["Number","prototype"],"%ObjectPrototype%":["Object","prototype"],"%ObjProto_toString%":["Object","prototype","toString"],"%ObjProto_valueOf%":["Object","prototype","valueOf"],"%PromisePrototype%":["Promise","prototype"],"%PromiseProto_then%":["Promise","prototype","then"],"%Promise_all%":["Promise","all"],"%Promise_reject%":["Promise","reject"],"%Promise_resolve%":["Promise","resolve"],"%RangeErrorPrototype%":["RangeError","prototype"],"%ReferenceErrorPrototype%":["ReferenceError","prototype"],"%RegExpPrototype%":["RegExp","prototype"],"%SetPrototype%":["Set","prototype"],"%SharedArrayBufferPrototype%":["SharedArrayBuffer","prototype"],"%StringPrototype%":["String","prototype"],"%SymbolPrototype%":["Symbol","prototype"],"%SyntaxErrorPrototype%":["SyntaxError","prototype"],"%TypedArrayPrototype%":["TypedArray","prototype"],"%TypeErrorPrototype%":["TypeError","prototype"],"%Uint8ArrayPrototype%":["Uint8Array","prototype"],"%Uint8ClampedArrayPrototype%":["Uint8ClampedArray","prototype"],"%Uint16ArrayPrototype%":["Uint16Array","prototype"],"%Uint32ArrayPrototype%":["Uint32Array","prototype"],"%URIErrorPrototype%":["URIError","prototype"],"%WeakMapPrototype%":["WeakMap","prototype"],"%WeakSetPrototype%":["WeakSet","prototype"]};var A=e(517);var v=e(793);var b=A.call(Function.call,Array.prototype.concat);var S=A.call(Function.apply,Array.prototype.splice);var m=A.call(Function.call,String.prototype.replace);var P=A.call(Function.call,String.prototype.slice);var h=/[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;var O=/\\(\\)?/g;var w=function stringToPath(r){var t=P(r,0,1);var e=P(r,-1);if(t==="%"&&e!=="%"){throw new n("invalid intrinsic syntax, expected closing `%`")}else if(e==="%"&&t!=="%"){throw new n("invalid intrinsic syntax, expected opening `%`")}var o=[];m(r,h,(function(r,t,e,n){o[o.length]=e?m(n,O,"$1"):t||r}));return o};var E=function getBaseIntrinsic(r,t){var e=r;var o;if(v(g,e)){o=g[e];e="%"+o[0]+"%"}if(v(l,e)){var i=l[e];if(i===s){i=d(e)}if(typeof i==="undefined"&&!t){throw new a("intrinsic "+r+" exists, but is not available. Please file an issue!")}return{alias:o,name:e,value:i}}throw new n("intrinsic "+r+" does not exist!")};r.exports=function GetIntrinsic(r,t){if(typeof r!=="string"||r.length===0){throw new a("intrinsic name must be a non-empty string")}if(arguments.length>1&&typeof t!=="boolean"){throw new a('"allowMissing" argument must be a boolean')}var e=w(r);var i=e.length>0?e[0]:"";var p=E("%"+i+"%",t);var f=p.name;var u=p.value;var s=false;var c=p.alias;if(c){i=c[0];S(e,b([0,1],c))}for(var d=1,g=true;d<e.length;d+=1){var A=e[d];var m=P(A,0,1);var h=P(A,-1);if((m==='"'||m==="'"||m==="`"||(h==='"'||h==="'"||h==="`"))&&m!==h){throw new n("property names with quotes must have matching quotes")}if(A==="constructor"||!g){s=true}i+="."+A;f="%"+i+"%";if(v(l,f)){u=l[f]}else if(u!=null){if(!(A in u)){if(!t){throw new a("base intrinsic for "+r+" exists, but the property is not available.")}return void o}if(y&&d+1>=e.length){var O=y(u,A);g=!!O;if(g&&"get"in O&&!("originalValue"in O.get)){u=O.get}else{u=u[A]}}else{g=v(u,A);u=u[A]}if(g&&!s){l[f]=u}}}return u}},449:function(r,t,e){"use strict";var o=__webpack_require__.g.Symbol;var n=e(545);r.exports=function hasNativeSymbols(){if(typeof o!=="function"){return false}if(typeof Symbol!=="function"){return false}if(typeof o("foo")!=="symbol"){return false}if(typeof Symbol("bar")!=="symbol"){return false}return n()}},545:function(r){"use strict";r.exports=function hasSymbols(){if(typeof Symbol!=="function"||typeof Object.getOwnPropertySymbols!=="function"){return false}if(typeof Symbol.iterator==="symbol"){return true}var r={};var t=Symbol("test");var e=Object(t);if(typeof t==="string"){return false}if(Object.prototype.toString.call(t)!=="[object Symbol]"){return false}if(Object.prototype.toString.call(e)!=="[object Symbol]"){return false}var o=42;r[t]=o;for(t in r){return false}if(typeof Object.keys==="function"&&Object.keys(r).length!==0){return false}if(typeof Object.getOwnPropertyNames==="function"&&Object.getOwnPropertyNames(r).length!==0){return false}var n=Object.getOwnPropertySymbols(r);if(n.length!==1||n[0]!==t){return false}if(!Object.prototype.propertyIsEnumerable.call(r,t)){return false}if(typeof Object.getOwnPropertyDescriptor==="function"){var i=Object.getOwnPropertyDescriptor(r,t);if(i.value!==o||i.enumerable!==true){return false}}return true}},793:function(r,t,e){"use strict";var o=e(517);r.exports=o.call(Function.call,Object.prototype.hasOwnProperty)},526:function(r){if(typeof Object.create==="function"){r.exports=function inherits(r,t){if(t){r.super_=t;r.prototype=Object.create(t.prototype,{constructor:{value:r,enumerable:false,writable:true,configurable:true}})}}}else{r.exports=function inherits(r,t){if(t){r.super_=t;var TempCtor=function(){};TempCtor.prototype=t.prototype;r.prototype=new TempCtor;r.prototype.constructor=r}}}},312:function(r){"use strict";var t=typeof Symbol==="function"&&typeof Symbol.toStringTag==="symbol";var e=Object.prototype.toString;var o=function isArguments(r){if(t&&r&&typeof r==="object"&&Symbol.toStringTag in r){return false}return e.call(r)==="[object Arguments]"};var n=function isArguments(r){if(o(r)){return true}return r!==null&&typeof r==="object"&&typeof r.length==="number"&&r.length>=0&&e.call(r)!=="[object Array]"&&e.call(r.callee)==="[object Function]"};var i=function(){return o(arguments)}();o.isLegacyArguments=n;r.exports=i?o:n},906:function(r){"use strict";var t=Object.prototype.toString;var e=Function.prototype.toString;var o=/^\s*(?:function)?\*/;var n=typeof Symbol==="function"&&typeof Symbol.toStringTag==="symbol";var i=Object.getPrototypeOf;var getGeneratorFunc=function(){if(!n){return false}try{return Function("return function*() {}")()}catch(r){}};var a=getGeneratorFunc();var y=a?i(a):{};r.exports=function isGeneratorFunction(r){if(typeof r!=="function"){return false}if(o.test(e.call(r))){return true}if(!n){var a=t.call(r);return a==="[object GeneratorFunction]"}return i(r)===y}},234:function(r,t,e){"use strict";var o=e(219);var n=e(627);var i=e(749);var a=i("Object.prototype.toString");var y=e(449)();var p=y&&typeof Symbol.toStringTag==="symbol";var f=n();var u=i("Array.prototype.indexOf",true)||function indexOf(r,t){for(var e=0;e<r.length;e+=1){if(r[e]===t){return e}}return-1};var s=i("String.prototype.slice");var c={};var l=e(982);var d=Object.getPrototypeOf;if(p&&l&&d){o(f,(function(r){var t=new __webpack_require__.g[r];if(!(Symbol.toStringTag in t)){throw new EvalError("this engine has support for Symbol.toStringTag, but "+r+" does not have the property! Please report this.")}var e=d(t);var o=l(e,Symbol.toStringTag);if(!o){var n=d(e);o=l(n,Symbol.toStringTag)}c[r]=o.get}))}var g=function tryAllTypedArrays(r){var t=false;o(c,(function(e,o){if(!t){try{t=e.call(r)===o}catch(r){}}}));return t};r.exports=function isTypedArray(r){if(!r||typeof r!=="object"){return false}if(!p){var t=s(a(r),8,-1);return u(f,t)>-1}if(!l){return false}return g(r)}},982:function(r,t,e){"use strict";var o=e(879);var n=o("%Object.getOwnPropertyDescriptor%");if(n){try{n([],"length")}catch(r){n=null}}r.exports=n},536:function(r){r.exports=function isBuffer(r){return r instanceof Buffer}},3:function(r,t,e){"use strict";var o=e(312);var n=e(906);var i=e(715);var a=e(234);function uncurryThis(r){return r.call.bind(r)}var y=typeof BigInt!=="undefined";var p=typeof Symbol!=="undefined";var f=uncurryThis(Object.prototype.toString);var u=uncurryThis(Number.prototype.valueOf);var s=uncurryThis(String.prototype.valueOf);var c=uncurryThis(Boolean.prototype.valueOf);if(y){var l=uncurryThis(BigInt.prototype.valueOf)}if(p){var d=uncurryThis(Symbol.prototype.valueOf)}function checkBoxedPrimitive(r,t){if(typeof r!=="object"){return false}try{t(r);return true}catch(r){return false}}t.isArgumentsObject=o;t.isGeneratorFunction=n;t.isTypedArray=a;function isPromise(r){return typeof Promise!=="undefined"&&r instanceof Promise||r!==null&&typeof r==="object"&&typeof r.then==="function"&&typeof r.catch==="function"}t.isPromise=isPromise;function isArrayBufferView(r){if(typeof ArrayBuffer!=="undefined"&&ArrayBuffer.isView){return ArrayBuffer.isView(r)}return a(r)||isDataView(r)}t.isArrayBufferView=isArrayBufferView;function isUint8Array(r){return i(r)==="Uint8Array"}t.isUint8Array=isUint8Array;function isUint8ClampedArray(r){return i(r)==="Uint8ClampedArray"}t.isUint8ClampedArray=isUint8ClampedArray;function isUint16Array(r){return i(r)==="Uint16Array"}t.isUint16Array=isUint16Array;function isUint32Array(r){return i(r)==="Uint32Array"}t.isUint32Array=isUint32Array;function isInt8Array(r){return i(r)==="Int8Array"}t.isInt8Array=isInt8Array;function isInt16Array(r){return i(r)==="Int16Array"}t.isInt16Array=isInt16Array;function isInt32Array(r){return i(r)==="Int32Array"}t.isInt32Array=isInt32Array;function isFloat32Array(r){return i(r)==="Float32Array"}t.isFloat32Array=isFloat32Array;function isFloat64Array(r){return i(r)==="Float64Array"}t.isFloat64Array=isFloat64Array;function isBigInt64Array(r){return i(r)==="BigInt64Array"}t.isBigInt64Array=isBigInt64Array;function isBigUint64Array(r){return i(r)==="BigUint64Array"}t.isBigUint64Array=isBigUint64Array;function isMapToString(r){return f(r)==="[object Map]"}isMapToString.working=typeof Map!=="undefined"&&isMapToString(new Map);function isMap(r){if(typeof Map==="undefined"){return false}return isMapToString.working?isMapToString(r):r instanceof Map}t.isMap=isMap;function isSetToString(r){return f(r)==="[object Set]"}isSetToString.working=typeof Set!=="undefined"&&isSetToString(new Set);function isSet(r){if(typeof Set==="undefined"){return false}return isSetToString.working?isSetToString(r):r instanceof Set}t.isSet=isSet;function isWeakMapToString(r){return f(r)==="[object WeakMap]"}isWeakMapToString.working=typeof WeakMap!=="undefined"&&isWeakMapToString(new WeakMap);function isWeakMap(r){if(typeof WeakMap==="undefined"){return false}return isWeakMapToString.working?isWeakMapToString(r):r instanceof WeakMap}t.isWeakMap=isWeakMap;function isWeakSetToString(r){return f(r)==="[object WeakSet]"}isWeakSetToString.working=typeof WeakSet!=="undefined"&&isWeakSetToString(new WeakSet);function isWeakSet(r){return isWeakSetToString(r)}t.isWeakSet=isWeakSet;function isArrayBufferToString(r){return f(r)==="[object ArrayBuffer]"}isArrayBufferToString.working=typeof ArrayBuffer!=="undefined"&&isArrayBufferToString(new ArrayBuffer);function isArrayBuffer(r){if(typeof ArrayBuffer==="undefined"){return false}return isArrayBufferToString.working?isArrayBufferToString(r):r instanceof ArrayBuffer}t.isArrayBuffer=isArrayBuffer;function isDataViewToString(r){return f(r)==="[object DataView]"}isDataViewToString.working=typeof ArrayBuffer!=="undefined"&&typeof DataView!=="undefined"&&isDataViewToString(new DataView(new ArrayBuffer(1),0,1));function isDataView(r){if(typeof DataView==="undefined"){return false}return isDataViewToString.working?isDataViewToString(r):r instanceof DataView}t.isDataView=isDataView;var g=typeof SharedArrayBuffer!=="undefined"?SharedArrayBuffer:undefined;function isSharedArrayBufferToString(r){return f(r)==="[object SharedArrayBuffer]"}function isSharedArrayBuffer(r){if(typeof g==="undefined"){return false}if(typeof isSharedArrayBufferToString.working==="undefined"){isSharedArrayBufferToString.working=isSharedArrayBufferToString(new g)}return isSharedArrayBufferToString.working?isSharedArrayBufferToString(r):r instanceof g}t.isSharedArrayBuffer=isSharedArrayBuffer;function isAsyncFunction(r){return f(r)==="[object AsyncFunction]"}t.isAsyncFunction=isAsyncFunction;function isMapIterator(r){return f(r)==="[object Map Iterator]"}t.isMapIterator=isMapIterator;function isSetIterator(r){return f(r)==="[object Set Iterator]"}t.isSetIterator=isSetIterator;function isGeneratorObject(r){return f(r)==="[object Generator]"}t.isGeneratorObject=isGeneratorObject;function isWebAssemblyCompiledModule(r){return f(r)==="[object WebAssembly.Module]"}t.isWebAssemblyCompiledModule=isWebAssemblyCompiledModule;function isNumberObject(r){return checkBoxedPrimitive(r,u)}t.isNumberObject=isNumberObject;function isStringObject(r){return checkBoxedPrimitive(r,s)}t.isStringObject=isStringObject;function isBooleanObject(r){return checkBoxedPrimitive(r,c)}t.isBooleanObject=isBooleanObject;function isBigIntObject(r){return y&&checkBoxedPrimitive(r,l)}t.isBigIntObject=isBigIntObject;function isSymbolObject(r){return p&&checkBoxedPrimitive(r,d)}t.isSymbolObject=isSymbolObject;function isBoxedPrimitive(r){return isNumberObject(r)||isStringObject(r)||isBooleanObject(r)||isBigIntObject(r)||isSymbolObject(r)}t.isBoxedPrimitive=isBoxedPrimitive;function isAnyArrayBuffer(r){return typeof Uint8Array!=="undefined"&&(isArrayBuffer(r)||isSharedArrayBuffer(r))}t.isAnyArrayBuffer=isAnyArrayBuffer;["isProxy","isExternal","isModuleNamespaceObject"].forEach((function(r){Object.defineProperty(t,r,{enumerable:false,value:function(){throw new Error(r+" is not supported in userland")}})}))},650:function(r,t,e){var o=Object.getOwnPropertyDescriptors||function getOwnPropertyDescriptors(r){var t=Object.keys(r);var e={};for(var o=0;o<t.length;o++){e[t[o]]=Object.getOwnPropertyDescriptor(r,t[o])}return e};var n=/%[sdj%]/g;t.format=function(r){if(!isString(r)){var t=[];for(var e=0;e<arguments.length;e++){t.push(inspect(arguments[e]))}return t.join(" ")}var e=1;var o=arguments;var i=o.length;var a=String(r).replace(n,(function(r){if(r==="%%")return"%";if(e>=i)return r;switch(r){case"%s":return String(o[e++]);case"%d":return Number(o[e++]);case"%j":try{return JSON.stringify(o[e++])}catch(r){return"[Circular]"}default:return r}}));for(var y=o[e];e<i;y=o[++e]){if(isNull(y)||!isObject(y)){a+=" "+y}else{a+=" "+inspect(y)}}return a};t.deprecate=function(r,e){if(typeof process!=="undefined"&&process.noDeprecation===true){return r}if(typeof process==="undefined"){return function(){return t.deprecate(r,e).apply(this,arguments)}}var o=false;function deprecated(){if(!o){if(process.throwDeprecation){throw new Error(e)}else if(process.traceDeprecation){console.trace(e)}else{console.error(e)}o=true}return r.apply(this,arguments)}return deprecated};var i={};var a=/^$/;if(process.env.NODE_DEBUG){var y=process.env.NODE_DEBUG;y=y.replace(/[|\\{}()[\]^$+?.]/g,"\\$&").replace(/\*/g,".*").replace(/,/g,"$|^").toUpperCase();a=new RegExp("^"+y+"$","i")}t.debuglog=function(r){r=r.toUpperCase();if(!i[r]){if(a.test(r)){var e=process.pid;i[r]=function(){var o=t.format.apply(t,arguments);console.error("%s %d: %s",r,e,o)}}else{i[r]=function(){}}}return i[r]};function inspect(r,e){var o={seen:[],stylize:stylizeNoColor};if(arguments.length>=3)o.depth=arguments[2];if(arguments.length>=4)o.colors=arguments[3];if(isBoolean(e)){o.showHidden=e}else if(e){t._extend(o,e)}if(isUndefined(o.showHidden))o.showHidden=false;if(isUndefined(o.depth))o.depth=2;if(isUndefined(o.colors))o.colors=false;if(isUndefined(o.customInspect))o.customInspect=true;if(o.colors)o.stylize=stylizeWithColor;return formatValue(o,r,o.depth)}t.inspect=inspect;inspect.colors={bold:[1,22],italic:[3,23],underline:[4,24],inverse:[7,27],white:[37,39],grey:[90,39],black:[30,39],blue:[34,39],cyan:[36,39],green:[32,39],magenta:[35,39],red:[31,39],yellow:[33,39]};inspect.styles={special:"cyan",number:"yellow",boolean:"yellow",undefined:"grey",null:"bold",string:"green",date:"magenta",regexp:"red"};function stylizeWithColor(r,t){var e=inspect.styles[t];if(e){return"["+inspect.colors[e][0]+"m"+r+"["+inspect.colors[e][1]+"m"}else{return r}}function stylizeNoColor(r,t){return r}function arrayToHash(r){var t={};r.forEach((function(r,e){t[r]=true}));return t}function formatValue(r,e,o){if(r.customInspect&&e&&isFunction(e.inspect)&&e.inspect!==t.inspect&&!(e.constructor&&e.constructor.prototype===e)){var n=e.inspect(o,r);if(!isString(n)){n=formatValue(r,n,o)}return n}var i=formatPrimitive(r,e);if(i){return i}var a=Object.keys(e);var y=arrayToHash(a);if(r.showHidden){a=Object.getOwnPropertyNames(e)}if(isError(e)&&(a.indexOf("message")>=0||a.indexOf("description")>=0)){return formatError(e)}if(a.length===0){if(isFunction(e)){var p=e.name?": "+e.name:"";return r.stylize("[Function"+p+"]","special")}if(isRegExp(e)){return r.stylize(RegExp.prototype.toString.call(e),"regexp")}if(isDate(e)){return r.stylize(Date.prototype.toString.call(e),"date")}if(isError(e)){return formatError(e)}}var f="",u=false,s=["{","}"];if(isArray(e)){u=true;s=["[","]"]}if(isFunction(e)){var c=e.name?": "+e.name:"";f=" [Function"+c+"]"}if(isRegExp(e)){f=" "+RegExp.prototype.toString.call(e)}if(isDate(e)){f=" "+Date.prototype.toUTCString.call(e)}if(isError(e)){f=" "+formatError(e)}if(a.length===0&&(!u||e.length==0)){return s[0]+f+s[1]}if(o<0){if(isRegExp(e)){return r.stylize(RegExp.prototype.toString.call(e),"regexp")}else{return r.stylize("[Object]","special")}}r.seen.push(e);var l;if(u){l=formatArray(r,e,o,y,a)}else{l=a.map((function(t){return formatProperty(r,e,o,y,t,u)}))}r.seen.pop();return reduceToSingleString(l,f,s)}function formatPrimitive(r,t){if(isUndefined(t))return r.stylize("undefined","undefined");if(isString(t)){var e="'"+JSON.stringify(t).replace(/^"|"$/g,"").replace(/'/g,"\\'").replace(/\\"/g,'"')+"'";return r.stylize(e,"string")}if(isNumber(t))return r.stylize(""+t,"number");if(isBoolean(t))return r.stylize(""+t,"boolean");if(isNull(t))return r.stylize("null","null")}function formatError(r){return"["+Error.prototype.toString.call(r)+"]"}function formatArray(r,t,e,o,n){var i=[];for(var a=0,y=t.length;a<y;++a){if(hasOwnProperty(t,String(a))){i.push(formatProperty(r,t,e,o,String(a),true))}else{i.push("")}}n.forEach((function(n){if(!n.match(/^\d+$/)){i.push(formatProperty(r,t,e,o,n,true))}}));return i}function formatProperty(r,t,e,o,n,i){var a,y,p;p=Object.getOwnPropertyDescriptor(t,n)||{value:t[n]};if(p.get){if(p.set){y=r.stylize("[Getter/Setter]","special")}else{y=r.stylize("[Getter]","special")}}else{if(p.set){y=r.stylize("[Setter]","special")}}if(!hasOwnProperty(o,n)){a="["+n+"]"}if(!y){if(r.seen.indexOf(p.value)<0){if(isNull(e)){y=formatValue(r,p.value,null)}else{y=formatValue(r,p.value,e-1)}if(y.indexOf("\n")>-1){if(i){y=y.split("\n").map((function(r){return"  "+r})).join("\n").substr(2)}else{y="\n"+y.split("\n").map((function(r){return"   "+r})).join("\n")}}}else{y=r.stylize("[Circular]","special")}}if(isUndefined(a)){if(i&&n.match(/^\d+$/)){return y}a=JSON.stringify(""+n);if(a.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)){a=a.substr(1,a.length-2);a=r.stylize(a,"name")}else{a=a.replace(/'/g,"\\'").replace(/\\"/g,'"').replace(/(^"|"$)/g,"'");a=r.stylize(a,"string")}}return a+": "+y}function reduceToSingleString(r,t,e){var o=0;var n=r.reduce((function(r,t){o++;if(t.indexOf("\n")>=0)o++;return r+t.replace(/\u001b\[\d\d?m/g,"").length+1}),0);if(n>60){return e[0]+(t===""?"":t+"\n ")+" "+r.join(",\n  ")+" "+e[1]}return e[0]+t+" "+r.join(", ")+" "+e[1]}t.types=e(3);function isArray(r){return Array.isArray(r)}t.isArray=isArray;function isBoolean(r){return typeof r==="boolean"}t.isBoolean=isBoolean;function isNull(r){return r===null}t.isNull=isNull;function isNullOrUndefined(r){return r==null}t.isNullOrUndefined=isNullOrUndefined;function isNumber(r){return typeof r==="number"}t.isNumber=isNumber;function isString(r){return typeof r==="string"}t.isString=isString;function isSymbol(r){return typeof r==="symbol"}t.isSymbol=isSymbol;function isUndefined(r){return r===void 0}t.isUndefined=isUndefined;function isRegExp(r){return isObject(r)&&objectToString(r)==="[object RegExp]"}t.isRegExp=isRegExp;t.types.isRegExp=isRegExp;function isObject(r){return typeof r==="object"&&r!==null}t.isObject=isObject;function isDate(r){return isObject(r)&&objectToString(r)==="[object Date]"}t.isDate=isDate;t.types.isDate=isDate;function isError(r){return isObject(r)&&(objectToString(r)==="[object Error]"||r instanceof Error)}t.isError=isError;t.types.isNativeError=isError;function isFunction(r){return typeof r==="function"}t.isFunction=isFunction;function isPrimitive(r){return r===null||typeof r==="boolean"||typeof r==="number"||typeof r==="string"||typeof r==="symbol"||typeof r==="undefined"}t.isPrimitive=isPrimitive;t.isBuffer=e(536);function objectToString(r){return Object.prototype.toString.call(r)}function pad(r){return r<10?"0"+r.toString(10):r.toString(10)}var p=["Jan","Feb","Mar","Apr","May","Jun","Jul","Aug","Sep","Oct","Nov","Dec"];function timestamp(){var r=new Date;var t=[pad(r.getHours()),pad(r.getMinutes()),pad(r.getSeconds())].join(":");return[r.getDate(),p[r.getMonth()],t].join(" ")}t.log=function(){console.log("%s - %s",timestamp(),t.format.apply(t,arguments))};t.inherits=e(526);t._extend=function(r,t){if(!t||!isObject(t))return r;var e=Object.keys(t);var o=e.length;while(o--){r[e[o]]=t[e[o]]}return r};function hasOwnProperty(r,t){return Object.prototype.hasOwnProperty.call(r,t)}var f=typeof Symbol!=="undefined"?Symbol("util.promisify.custom"):undefined;t.promisify=function promisify(r){if(typeof r!=="function")throw new TypeError('The "original" argument must be of type Function');if(f&&r[f]){var t=r[f];if(typeof t!=="function"){throw new TypeError('The "util.promisify.custom" argument must be of type Function')}Object.defineProperty(t,f,{value:t,enumerable:false,writable:false,configurable:true});return t}function t(){var t,e;var o=new Promise((function(r,o){t=r;e=o}));var n=[];for(var i=0;i<arguments.length;i++){n.push(arguments[i])}n.push((function(r,o){if(r){e(r)}else{t(o)}}));try{r.apply(this,n)}catch(r){e(r)}return o}Object.setPrototypeOf(t,Object.getPrototypeOf(r));if(f)Object.defineProperty(t,f,{value:t,enumerable:false,writable:false,configurable:true});return Object.defineProperties(t,o(r))};t.promisify.custom=f;function callbackifyOnRejected(r,t){if(!r){var e=new Error("Promise was rejected with a falsy value");e.reason=r;r=e}return t(r)}function callbackify(r){if(typeof r!=="function"){throw new TypeError('The "original" argument must be of type Function')}function callbackified(){var t=[];for(var e=0;e<arguments.length;e++){t.push(arguments[e])}var o=t.pop();if(typeof o!=="function"){throw new TypeError("The last argument must be of type Function")}var n=this;var cb=function(){return o.apply(n,arguments)};r.apply(this,t).then((function(r){process.nextTick(cb.bind(null,null,r))}),(function(r){process.nextTick(callbackifyOnRejected.bind(null,r,cb))}))}Object.setPrototypeOf(callbackified,Object.getPrototypeOf(r));Object.defineProperties(callbackified,o(r));return callbackified}t.callbackify=callbackify},715:function(r,t,e){"use strict";var o=e(219);var n=e(627);var i=e(749);var a=i("Object.prototype.toString");var y=e(449)();var p=y&&typeof Symbol.toStringTag==="symbol";var f=n();var u=i("String.prototype.slice");var s={};var c=e(850);var l=Object.getPrototypeOf;if(p&&c&&l){o(f,(function(r){if(typeof __webpack_require__.g[r]==="function"){var t=new __webpack_require__.g[r];if(!(Symbol.toStringTag in t)){throw new EvalError("this engine has support for Symbol.toStringTag, but "+r+" does not have the property! Please report this.")}var e=l(t);var o=c(e,Symbol.toStringTag);if(!o){var n=l(e);o=c(n,Symbol.toStringTag)}s[r]=o.get}}))}var d=function tryAllTypedArrays(r){var t=false;o(s,(function(e,o){if(!t){try{var n=e.call(r);if(n===o){t=n}}catch(r){}}}));return t};var g=e(234);r.exports=function whichTypedArray(r){if(!g(r)){return false}if(!p){return u(a(r),8,-1)}return d(r)}},227:function(r,t,e){"use strict";var o;var n=SyntaxError;var i=Function;var a=TypeError;var getEvalledConstructor=function(r){try{return Function('"use strict"; return ('+r+").constructor;")()}catch(r){}};var y=Object.getOwnPropertyDescriptor;if(y){try{y({},"")}catch(r){y=null}}var throwTypeError=function(){throw new a};var p=y?function(){try{arguments.callee;return throwTypeError}catch(r){try{return y(arguments,"callee").get}catch(r){return throwTypeError}}}():throwTypeError;var f=e(449)();var u=Object.getPrototypeOf||function(r){return r.__proto__};var s=getEvalledConstructor("async function* () {}");var c=s?s.prototype:o;var l=c?c.prototype:o;var d=typeof Uint8Array==="undefined"?o:u(Uint8Array);var g={"%AggregateError%":typeof AggregateError==="undefined"?o:AggregateError,"%Array%":Array,"%ArrayBuffer%":typeof ArrayBuffer==="undefined"?o:ArrayBuffer,"%ArrayIteratorPrototype%":f?u([][Symbol.iterator]()):o,"%AsyncFromSyncIteratorPrototype%":o,"%AsyncFunction%":getEvalledConstructor("async function () {}"),"%AsyncGenerator%":c,"%AsyncGeneratorFunction%":s,"%AsyncIteratorPrototype%":l?u(l):o,"%Atomics%":typeof Atomics==="undefined"?o:Atomics,"%BigInt%":typeof BigInt==="undefined"?o:BigInt,"%Boolean%":Boolean,"%DataView%":typeof DataView==="undefined"?o:DataView,"%Date%":Date,"%decodeURI%":decodeURI,"%decodeURIComponent%":decodeURIComponent,"%encodeURI%":encodeURI,"%encodeURIComponent%":encodeURIComponent,"%Error%":Error,"%eval%":eval,"%EvalError%":EvalError,"%Float32Array%":typeof Float32Array==="undefined"?o:Float32Array,"%Float64Array%":typeof Float64Array==="undefined"?o:Float64Array,"%FinalizationRegistry%":typeof FinalizationRegistry==="undefined"?o:FinalizationRegistry,"%Function%":i,"%GeneratorFunction%":getEvalledConstructor("function* () {}"),"%Int8Array%":typeof Int8Array==="undefined"?o:Int8Array,"%Int16Array%":typeof Int16Array==="undefined"?o:Int16Array,"%Int32Array%":typeof Int32Array==="undefined"?o:Int32Array,"%isFinite%":isFinite,"%isNaN%":isNaN,"%IteratorPrototype%":f?u(u([][Symbol.iterator]())):o,"%JSON%":typeof JSON==="object"?JSON:o,"%Map%":typeof Map==="undefined"?o:Map,"%MapIteratorPrototype%":typeof Map==="undefined"||!f?o:u((new Map)[Symbol.iterator]()),"%Math%":Math,"%Number%":Number,"%Object%":Object,"%parseFloat%":parseFloat,"%parseInt%":parseInt,"%Promise%":typeof Promise==="undefined"?o:Promise,"%Proxy%":typeof Proxy==="undefined"?o:Proxy,"%RangeError%":RangeError,"%ReferenceError%":ReferenceError,"%Reflect%":typeof Reflect==="undefined"?o:Reflect,"%RegExp%":RegExp,"%Set%":typeof Set==="undefined"?o:Set,"%SetIteratorPrototype%":typeof Set==="undefined"||!f?o:u((new Set)[Symbol.iterator]()),"%SharedArrayBuffer%":typeof SharedArrayBuffer==="undefined"?o:SharedArrayBuffer,"%String%":String,"%StringIteratorPrototype%":f?u(""[Symbol.iterator]()):o,"%Symbol%":f?Symbol:o,"%SyntaxError%":n,"%ThrowTypeError%":p,"%TypedArray%":d,"%TypeError%":a,"%Uint8Array%":typeof Uint8Array==="undefined"?o:Uint8Array,"%Uint8ClampedArray%":typeof Uint8ClampedArray==="undefined"?o:Uint8ClampedArray,"%Uint16Array%":typeof Uint16Array==="undefined"?o:Uint16Array,"%Uint32Array%":typeof Uint32Array==="undefined"?o:Uint32Array,"%URIError%":URIError,"%WeakMap%":typeof WeakMap==="undefined"?o:WeakMap,"%WeakRef%":typeof WeakRef==="undefined"?o:WeakRef,"%WeakSet%":typeof WeakSet==="undefined"?o:WeakSet};var A={"%ArrayBufferPrototype%":["ArrayBuffer","prototype"],"%ArrayPrototype%":["Array","prototype"],"%ArrayProto_entries%":["Array","prototype","entries"],"%ArrayProto_forEach%":["Array","prototype","forEach"],"%ArrayProto_keys%":["Array","prototype","keys"],"%ArrayProto_values%":["Array","prototype","values"],"%AsyncFunctionPrototype%":["AsyncFunction","prototype"],"%AsyncGenerator%":["AsyncGeneratorFunction","prototype"],"%AsyncGeneratorPrototype%":["AsyncGeneratorFunction","prototype","prototype"],"%BooleanPrototype%":["Boolean","prototype"],"%DataViewPrototype%":["DataView","prototype"],"%DatePrototype%":["Date","prototype"],"%ErrorPrototype%":["Error","prototype"],"%EvalErrorPrototype%":["EvalError","prototype"],"%Float32ArrayPrototype%":["Float32Array","prototype"],"%Float64ArrayPrototype%":["Float64Array","prototype"],"%FunctionPrototype%":["Function","prototype"],"%Generator%":["GeneratorFunction","prototype"],"%GeneratorPrototype%":["GeneratorFunction","prototype","prototype"],"%Int8ArrayPrototype%":["Int8Array","prototype"],"%Int16ArrayPrototype%":["Int16Array","prototype"],"%Int32ArrayPrototype%":["Int32Array","prototype"],"%JSONParse%":["JSON","parse"],"%JSONStringify%":["JSON","stringify"],"%MapPrototype%":["Map","prototype"],"%NumberPrototype%":["Number","prototype"],"%ObjectPrototype%":["Object","prototype"],"%ObjProto_toString%":["Object","prototype","toString"],"%ObjProto_valueOf%":["Object","prototype","valueOf"],"%PromisePrototype%":["Promise","prototype"],"%PromiseProto_then%":["Promise","prototype","then"],"%Promise_all%":["Promise","all"],"%Promise_reject%":["Promise","reject"],"%Promise_resolve%":["Promise","resolve"],"%RangeErrorPrototype%":["RangeError","prototype"],"%ReferenceErrorPrototype%":["ReferenceError","prototype"],"%RegExpPrototype%":["RegExp","prototype"],"%SetPrototype%":["Set","prototype"],"%SharedArrayBufferPrototype%":["SharedArrayBuffer","prototype"],"%StringPrototype%":["String","prototype"],"%SymbolPrototype%":["Symbol","prototype"],"%SyntaxErrorPrototype%":["SyntaxError","prototype"],"%TypedArrayPrototype%":["TypedArray","prototype"],"%TypeErrorPrototype%":["TypeError","prototype"],"%Uint8ArrayPrototype%":["Uint8Array","prototype"],"%Uint8ClampedArrayPrototype%":["Uint8ClampedArray","prototype"],"%Uint16ArrayPrototype%":["Uint16Array","prototype"],"%Uint32ArrayPrototype%":["Uint32Array","prototype"],"%URIErrorPrototype%":["URIError","prototype"],"%WeakMapPrototype%":["WeakMap","prototype"],"%WeakSetPrototype%":["WeakSet","prototype"]};var v=e(517);var b=e(793);var S=v.call(Function.call,Array.prototype.concat);var m=v.call(Function.apply,Array.prototype.splice);var P=v.call(Function.call,String.prototype.replace);var h=/[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;var O=/\\(\\)?/g;var w=function stringToPath(r){var t=[];P(r,h,(function(r,e,o,n){t[t.length]=o?P(n,O,"$1"):e||r}));return t};var E=function getBaseIntrinsic(r,t){var e=r;var o;if(b(A,e)){o=A[e];e="%"+o[0]+"%"}if(b(g,e)){var i=g[e];if(typeof i==="undefined"&&!t){throw new a("intrinsic "+r+" exists, but is not available. Please file an issue!")}return{alias:o,name:e,value:i}}throw new n("intrinsic "+r+" does not exist!")};r.exports=function GetIntrinsic(r,t){if(typeof r!=="string"||r.length===0){throw new a("intrinsic name must be a non-empty string")}if(arguments.length>1&&typeof t!=="boolean"){throw new a('"allowMissing" argument must be a boolean')}var e=w(r);var o=e.length>0?e[0]:"";var n=E("%"+o+"%",t);var i=n.name;var p=n.value;var f=false;var u=n.alias;if(u){o=u[0];m(e,S([0,1],u))}for(var s=1,c=true;s<e.length;s+=1){var l=e[s];if(l==="constructor"||!c){f=true}o+="."+l;i="%"+o+"%";if(b(g,i)){p=g[i]}else if(p!=null){if(y&&s+1>=e.length){var d=y(p,l);c=!!d;if(!t&&!(l in p)){throw new a("base intrinsic for "+r+" exists, but the property is not available.")}if(c&&"get"in d&&!("originalValue"in d.get)){p=d.get}else{p=p[l]}}else{c=b(p,l);p=p[l]}if(c&&!f){g[i]=p}}}return p}},850:function(r,t,e){"use strict";var o=e(227);var n=o("%Object.getOwnPropertyDescriptor%");if(n){try{n([],"length")}catch(r){n=null}}r.exports=n},627:function(r,t,e){"use strict";var o=e(901);r.exports=function availableTypedArrays(){return o(["BigInt64Array","BigUint64Array","Float32Array","Float64Array","Int16Array","Int32Array","Int8Array","Uint16Array","Uint32Array","Uint8Array","Uint8ClampedArray"],(function(r){return typeof __webpack_require__.g[r]==="function"}))}}};var t={};function __nccwpck_require__(e){var o=t[e];if(o!==undefined){return o.exports}var n=t[e]={exports:{}};var i=true;try{r[e](n,n.exports,__nccwpck_require__);i=false}finally{if(i)delete t[e]}return n.exports}if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var e=__nccwpck_require__(650);module.exports=e})();

/***/ }),

/***/ 51951:
/***/ (function(module) {

var __dirname = "/";
(function(){var __webpack_modules__={742:function(__unused_webpack_module,exports){var indexOf=function(e,t){if(e.indexOf)return e.indexOf(t);else for(var r=0;r<e.length;r++){if(e[r]===t)return r}return-1};var Object_keys=function(e){if(Object.keys)return Object.keys(e);else{var t=[];for(var r in e)t.push(r);return t}};var forEach=function(e,t){if(e.forEach)return e.forEach(t);else for(var r=0;r<e.length;r++){t(e[r],r,e)}};var defineProp=function(){try{Object.defineProperty({},"_",{});return function(e,t,r){Object.defineProperty(e,t,{writable:true,enumerable:false,configurable:true,value:r})}}catch(e){return function(e,t,r){e[t]=r}}}();var globals=["Array","Boolean","Date","Error","EvalError","Function","Infinity","JSON","Math","NaN","Number","Object","RangeError","ReferenceError","RegExp","String","SyntaxError","TypeError","URIError","decodeURI","decodeURIComponent","encodeURI","encodeURIComponent","escape","eval","isFinite","isNaN","parseFloat","parseInt","undefined","unescape"];function Context(){}Context.prototype={};var Script=exports.Script=function NodeScript(e){if(!(this instanceof Script))return new Script(e);this.code=e};Script.prototype.runInContext=function(e){if(!(e instanceof Context)){throw new TypeError("needs a 'context' argument.")}var t=document.createElement("iframe");if(!t.style)t.style={};t.style.display="none";document.body.appendChild(t);var r=t.contentWindow;var n=r.eval,o=r.execScript;if(!n&&o){o.call(r,"null");n=r.eval}forEach(Object_keys(e),(function(t){r[t]=e[t]}));forEach(globals,(function(t){if(e[t]){r[t]=e[t]}}));var c=Object_keys(r);var i=n.call(r,this.code);forEach(Object_keys(r),(function(t){if(t in e||indexOf(c,t)===-1){e[t]=r[t]}}));forEach(globals,(function(t){if(!(t in e)){defineProp(e,t,r[t])}}));document.body.removeChild(t);return i};Script.prototype.runInThisContext=function(){return eval(this.code)};Script.prototype.runInNewContext=function(e){var t=Script.createContext(e);var r=this.runInContext(t);if(e){forEach(Object_keys(t),(function(r){e[r]=t[r]}))}return r};forEach(Object_keys(Script.prototype),(function(e){exports[e]=Script[e]=function(t){var r=Script(t);return r[e].apply(r,[].slice.call(arguments,1))}}));exports.isContext=function(e){return e instanceof Context};exports.createScript=function(e){return exports.Script(e)};exports.createContext=Script.createContext=function(e){var t=new Context;if(typeof e==="object"){forEach(Object_keys(e),(function(r){t[r]=e[r]}))}return t}}};if(typeof __nccwpck_require__!=="undefined")__nccwpck_require__.ab=__dirname+"/";var __webpack_exports__={};__webpack_modules__[742](0,__webpack_exports__);module.exports=__webpack_exports__})();

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(37645)


/***/ }),

/***/ 25675:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(19749)


/***/ }),

/***/ 11163:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(80880)


/***/ }),

/***/ 69246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* provided dependency */ var process = __webpack_require__(83454);
if (process.env.npm_package_name === 'pseudomap' &&
    process.env.npm_lifecycle_script === 'test')
  process.env.TEST_PSEUDOMAP = 'true'

if (typeof Map === 'function' && !process.env.TEST_PSEUDOMAP) {
  module.exports = Map
} else {
  module.exports = __webpack_require__(12477)
}


/***/ }),

/***/ 12477:
/***/ (function(module) {

var hasOwnProperty = Object.prototype.hasOwnProperty

module.exports = PseudoMap

function PseudoMap (set) {
  if (!(this instanceof PseudoMap)) // whyyyyyyy
    throw new TypeError("Constructor PseudoMap requires 'new'")

  this.clear()

  if (set) {
    if ((set instanceof PseudoMap) ||
        (typeof Map === 'function' && set instanceof Map))
      set.forEach(function (value, key) {
        this.set(key, value)
      }, this)
    else if (Array.isArray(set))
      set.forEach(function (kv) {
        this.set(kv[0], kv[1])
      }, this)
    else
      throw new TypeError('invalid argument')
  }
}

PseudoMap.prototype.forEach = function (fn, thisp) {
  thisp = thisp || this
  Object.keys(this._data).forEach(function (k) {
    if (k !== 'size')
      fn.call(thisp, this._data[k].value, this._data[k].key)
  }, this)
}

PseudoMap.prototype.has = function (k) {
  return !!find(this._data, k)
}

PseudoMap.prototype.get = function (k) {
  var res = find(this._data, k)
  return res && res.value
}

PseudoMap.prototype.set = function (k, v) {
  set(this._data, k, v)
}

PseudoMap.prototype.delete = function (k) {
  var res = find(this._data, k)
  if (res) {
    delete this._data[res._index]
    this._data.size--
  }
}

PseudoMap.prototype.clear = function () {
  var data = Object.create(null)
  data.size = 0

  Object.defineProperty(this, '_data', {
    value: data,
    enumerable: false,
    configurable: true,
    writable: false
  })
}

Object.defineProperty(PseudoMap.prototype, 'size', {
  get: function () {
    return this._data.size
  },
  set: function (n) {},
  enumerable: true,
  configurable: true
})

PseudoMap.prototype.values =
PseudoMap.prototype.keys =
PseudoMap.prototype.entries = function () {
  throw new Error('iterators are not implemented in this version')
}

// Either identical, or both NaN
function same (a, b) {
  return a === b || a !== a && b !== b
}

function Entry (k, v, i) {
  this.key = k
  this.value = v
  this._index = i
}

function find (data, k) {
  for (var i = 0, s = '_' + k, key = s;
       hasOwnProperty.call(data, key);
       key = s + i++) {
    if (same(data[key].key, k))
      return data[key]
  }
}

function set (data, k, v) {
  for (var i = 0, s = '_' + k, key = s;
       hasOwnProperty.call(data, key);
       key = s + i++) {
    if (same(data[key].key, k)) {
      data[key].value = v
      return
    }
  }
  data.size++
  data[key] = new Entry(k, v, key)
}


/***/ }),

/***/ 88359:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;
/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden")}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;__webpack_unused_export__=h;__webpack_unused_export__=z;__webpack_unused_export__=A;__webpack_unused_export__=B;__webpack_unused_export__=C;__webpack_unused_export__=D;__webpack_unused_export__=E;__webpack_unused_export__=F;__webpack_unused_export__=G;__webpack_unused_export__=H;
__webpack_unused_export__=I;__webpack_unused_export__=function(){return!1};__webpack_unused_export__=function(){return!1};exports.isContextConsumer=function(a){return y(a)===h};__webpack_unused_export__=function(a){return y(a)===g};__webpack_unused_export__=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===b};__webpack_unused_export__=function(a){return y(a)===k};__webpack_unused_export__=function(a){return y(a)===d};__webpack_unused_export__=function(a){return y(a)===p};__webpack_unused_export__=function(a){return y(a)===n};
__webpack_unused_export__=function(a){return y(a)===c};__webpack_unused_export__=function(a){return y(a)===f};__webpack_unused_export__=function(a){return y(a)===e};__webpack_unused_export__=function(a){return y(a)===l};__webpack_unused_export__=function(a){return"string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
__webpack_unused_export__=y;


/***/ }),

/***/ 72973:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(88359);
} else {}


/***/ }),

/***/ 44815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "PW": function() { return /* binding */ defaultMemoize; }
/* harmony export */ });
/* unused harmony exports defaultEqualityCheck, createCacheKeyComparator */
// Cache implementation based on Erik Rasmussen's `lru-memoize`:
// https://github.com/erikras/lru-memoize
var NOT_FOUND = 'NOT_FOUND';

function createSingletonCache(equals) {
  var entry;
  return {
    get: function get(key) {
      if (entry && equals(entry.key, key)) {
        return entry.value;
      }

      return NOT_FOUND;
    },
    put: function put(key, value) {
      entry = {
        key: key,
        value: value
      };
    },
    getEntries: function getEntries() {
      return entry ? [entry] : [];
    },
    clear: function clear() {
      entry = undefined;
    }
  };
}

function createLruCache(maxSize, equals) {
  var entries = [];

  function get(key) {
    var cacheIndex = entries.findIndex(function (entry) {
      return equals(key, entry.key);
    }); // We found a cached entry

    if (cacheIndex > -1) {
      var entry = entries[cacheIndex]; // Cached entry not at top of cache, move it to the top

      if (cacheIndex > 0) {
        entries.splice(cacheIndex, 1);
        entries.unshift(entry);
      }

      return entry.value;
    } // No entry found in cache, return sentinel


    return NOT_FOUND;
  }

  function put(key, value) {
    if (get(key) === NOT_FOUND) {
      // TODO Is unshift slow?
      entries.unshift({
        key: key,
        value: value
      });

      if (entries.length > maxSize) {
        entries.pop();
      }
    }
  }

  function getEntries() {
    return entries;
  }

  function clear() {
    entries = [];
  }

  return {
    get: get,
    put: put,
    getEntries: getEntries,
    clear: clear
  };
}

var defaultEqualityCheck = function defaultEqualityCheck(a, b) {
  return a === b;
};
function createCacheKeyComparator(equalityCheck) {
  return function areArgumentsShallowlyEqual(prev, next) {
    if (prev === null || next === null || prev.length !== next.length) {
      return false;
    } // Do this in a for loop (and not a `forEach` or an `every`) so we can determine equality as fast as possible.


    var length = prev.length;

    for (var i = 0; i < length; i++) {
      if (!equalityCheck(prev[i], next[i])) {
        return false;
      }
    }

    return true;
  };
}
// defaultMemoize now supports a configurable cache size with LRU behavior,
// and optional comparison of the result value with existing values
function defaultMemoize(func, equalityCheckOrOptions) {
  var providedOptions = typeof equalityCheckOrOptions === 'object' ? equalityCheckOrOptions : {
    equalityCheck: equalityCheckOrOptions
  };
  var _providedOptions$equa = providedOptions.equalityCheck,
      equalityCheck = _providedOptions$equa === void 0 ? defaultEqualityCheck : _providedOptions$equa,
      _providedOptions$maxS = providedOptions.maxSize,
      maxSize = _providedOptions$maxS === void 0 ? 1 : _providedOptions$maxS,
      resultEqualityCheck = providedOptions.resultEqualityCheck;
  var comparator = createCacheKeyComparator(equalityCheck);
  var cache = maxSize === 1 ? createSingletonCache(comparator) : createLruCache(maxSize, comparator); // we reference arguments instead of spreading them for performance reasons

  function memoized() {
    var value = cache.get(arguments);

    if (value === NOT_FOUND) {
      // @ts-ignore
      value = func.apply(null, arguments);

      if (resultEqualityCheck) {
        var entries = cache.getEntries();
        var matchingEntry = entries.find(function (entry) {
          return resultEqualityCheck(entry.value, value);
        });

        if (matchingEntry) {
          value = matchingEntry.value;
        }
      }

      cache.put(arguments, value);
    }

    return value;
  }

  memoized.clearCache = function () {
    return cache.clear();
  };

  return memoized;
}

/***/ }),

/***/ 22222:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P1": function() { return /* binding */ createSelector; }
/* harmony export */ });
/* unused harmony exports createSelectorCreator, createStructuredSelector */
/* harmony import */ var _defaultMemoize__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44815);



function getDependencies(funcs) {
  var dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs;

  if (!dependencies.every(function (dep) {
    return typeof dep === 'function';
  })) {
    var dependencyTypes = dependencies.map(function (dep) {
      return typeof dep === 'function' ? "function " + (dep.name || 'unnamed') + "()" : typeof dep;
    }).join(', ');
    throw new Error("createSelector expects all input-selectors to be functions, but received the following types: [" + dependencyTypes + "]");
  }

  return dependencies;
}

function createSelectorCreator(memoize) {
  for (var _len = arguments.length, memoizeOptionsFromArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    memoizeOptionsFromArgs[_key - 1] = arguments[_key];
  }

  var createSelector = function createSelector() {
    for (var _len2 = arguments.length, funcs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      funcs[_key2] = arguments[_key2];
    }

    var _recomputations = 0;

    var _lastResult; // Due to the intricacies of rest params, we can't do an optional arg after `...funcs`.
    // So, start by declaring the default value here.
    // (And yes, the words 'memoize' and 'options' appear too many times in this next sequence.)


    var directlyPassedOptions = {
      memoizeOptions: undefined
    }; // Normally, the result func or "output selector" is the last arg

    var resultFunc = funcs.pop(); // If the result func is actually an _object_, assume it's our options object

    if (typeof resultFunc === 'object') {
      directlyPassedOptions = resultFunc; // and pop the real result func off

      resultFunc = funcs.pop();
    }

    if (typeof resultFunc !== 'function') {
      throw new Error("createSelector expects an output function after the inputs, but received: [" + typeof resultFunc + "]");
    } // Determine which set of options we're using. Prefer options passed directly,
    // but fall back to options given to createSelectorCreator.


    var _directlyPassedOption = directlyPassedOptions,
        _directlyPassedOption2 = _directlyPassedOption.memoizeOptions,
        memoizeOptions = _directlyPassedOption2 === void 0 ? memoizeOptionsFromArgs : _directlyPassedOption2; // Simplifying assumption: it's unlikely that the first options arg of the provided memoizer
    // is an array. In most libs I've looked at, it's an equality function or options object.
    // Based on that, if `memoizeOptions` _is_ an array, we assume it's a full
    // user-provided array of options. Otherwise, it must be just the _first_ arg, and so
    // we wrap it in an array so we can apply it.

    var finalMemoizeOptions = Array.isArray(memoizeOptions) ? memoizeOptions : [memoizeOptions];
    var dependencies = getDependencies(funcs);
    var memoizedResultFunc = memoize.apply(void 0, [function recomputationWrapper() {
      _recomputations++; // apply arguments instead of spreading for performance.

      return resultFunc.apply(null, arguments);
    }].concat(finalMemoizeOptions)); // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.

    var selector = memoize(function dependenciesChecker() {
      var params = [];
      var length = dependencies.length;

      for (var i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        // @ts-ignore
        params.push(dependencies[i].apply(null, arguments));
      } // apply arguments instead of spreading for performance.


      _lastResult = memoizedResultFunc.apply(null, params);
      return _lastResult;
    });
    Object.assign(selector, {
      resultFunc: resultFunc,
      memoizedResultFunc: memoizedResultFunc,
      dependencies: dependencies,
      lastResult: function lastResult() {
        return _lastResult;
      },
      recomputations: function recomputations() {
        return _recomputations;
      },
      resetRecomputations: function resetRecomputations() {
        return _recomputations = 0;
      }
    });
    return selector;
  }; // @ts-ignore


  return createSelector;
}
var createSelector = /* #__PURE__ */createSelectorCreator(_defaultMemoize__WEBPACK_IMPORTED_MODULE_0__/* .defaultMemoize */ .PW);
// Manual definition of state and output arguments
var createStructuredSelector = function createStructuredSelector(selectors, selectorCreator) {
  if (selectorCreator === void 0) {
    selectorCreator = createSelector;
  }

  if (typeof selectors !== 'object') {
    throw new Error('createStructuredSelector expects first argument to be an object ' + ("where each property is a selector, instead received a " + typeof selectors));
  }

  var objectKeys = Object.keys(selectors);
  var resultSelector = selectorCreator( // @ts-ignore
  objectKeys.map(function (key) {
    return selectors[key];
  }), function () {
    for (var _len3 = arguments.length, values = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      values[_key3] = arguments[_key3];
    }

    return values.reduce(function (composition, value, index) {
      composition[objectKeys[index]] = value;
      return composition;
    }, {});
  });
  return resultSelector;
};

/***/ }),

/***/ 89509:
/***/ (function(module, exports, __webpack_require__) {

/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(48764)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.prototype = Object.create(Buffer.prototype)

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 32553:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.



/*<replacement>*/

var Buffer = (__webpack_require__(40396).Buffer);
/*</replacement>*/

var isEncoding = Buffer.isEncoding || function (encoding) {
  encoding = '' + encoding;
  switch (encoding && encoding.toLowerCase()) {
    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
      return true;
    default:
      return false;
  }
};

function _normalizeEncoding(enc) {
  if (!enc) return 'utf8';
  var retried;
  while (true) {
    switch (enc) {
      case 'utf8':
      case 'utf-8':
        return 'utf8';
      case 'ucs2':
      case 'ucs-2':
      case 'utf16le':
      case 'utf-16le':
        return 'utf16le';
      case 'latin1':
      case 'binary':
        return 'latin1';
      case 'base64':
      case 'ascii':
      case 'hex':
        return enc;
      default:
        if (retried) return; // undefined
        enc = ('' + enc).toLowerCase();
        retried = true;
    }
  }
};

// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function normalizeEncoding(enc) {
  var nenc = _normalizeEncoding(enc);
  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
  return nenc || enc;
}

// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
exports.StringDecoder = StringDecoder;
function StringDecoder(encoding) {
  this.encoding = normalizeEncoding(encoding);
  var nb;
  switch (this.encoding) {
    case 'utf16le':
      this.text = utf16Text;
      this.end = utf16End;
      nb = 4;
      break;
    case 'utf8':
      this.fillLast = utf8FillLast;
      nb = 4;
      break;
    case 'base64':
      this.text = base64Text;
      this.end = base64End;
      nb = 3;
      break;
    default:
      this.write = simpleWrite;
      this.end = simpleEnd;
      return;
  }
  this.lastNeed = 0;
  this.lastTotal = 0;
  this.lastChar = Buffer.allocUnsafe(nb);
}

StringDecoder.prototype.write = function (buf) {
  if (buf.length === 0) return '';
  var r;
  var i;
  if (this.lastNeed) {
    r = this.fillLast(buf);
    if (r === undefined) return '';
    i = this.lastNeed;
    this.lastNeed = 0;
  } else {
    i = 0;
  }
  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
  return r || '';
};

StringDecoder.prototype.end = utf8End;

// Returns only complete characters in a Buffer
StringDecoder.prototype.text = utf8Text;

// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
StringDecoder.prototype.fillLast = function (buf) {
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
  this.lastNeed -= buf.length;
};

// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function utf8CheckByte(byte) {
  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
  return byte >> 6 === 0x02 ? -1 : -2;
}

// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function utf8CheckIncomplete(self, buf, i) {
  var j = buf.length - 1;
  if (j < i) return 0;
  var nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 1;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) self.lastNeed = nb - 2;
    return nb;
  }
  if (--j < i || nb === -2) return 0;
  nb = utf8CheckByte(buf[j]);
  if (nb >= 0) {
    if (nb > 0) {
      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
    }
    return nb;
  }
  return 0;
}

// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function utf8CheckExtraBytes(self, buf, p) {
  if ((buf[0] & 0xC0) !== 0x80) {
    self.lastNeed = 0;
    return '\ufffd';
  }
  if (self.lastNeed > 1 && buf.length > 1) {
    if ((buf[1] & 0xC0) !== 0x80) {
      self.lastNeed = 1;
      return '\ufffd';
    }
    if (self.lastNeed > 2 && buf.length > 2) {
      if ((buf[2] & 0xC0) !== 0x80) {
        self.lastNeed = 2;
        return '\ufffd';
      }
    }
  }
}

// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function utf8FillLast(buf) {
  var p = this.lastTotal - this.lastNeed;
  var r = utf8CheckExtraBytes(this, buf, p);
  if (r !== undefined) return r;
  if (this.lastNeed <= buf.length) {
    buf.copy(this.lastChar, p, 0, this.lastNeed);
    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
  }
  buf.copy(this.lastChar, p, 0, buf.length);
  this.lastNeed -= buf.length;
}

// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function utf8Text(buf, i) {
  var total = utf8CheckIncomplete(this, buf, i);
  if (!this.lastNeed) return buf.toString('utf8', i);
  this.lastTotal = total;
  var end = buf.length - (total - this.lastNeed);
  buf.copy(this.lastChar, 0, end);
  return buf.toString('utf8', i, end);
}

// For UTF-8, a replacement character is added when ending on a partial
// character.
function utf8End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + '\ufffd';
  return r;
}

// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function utf16Text(buf, i) {
  if ((buf.length - i) % 2 === 0) {
    var r = buf.toString('utf16le', i);
    if (r) {
      var c = r.charCodeAt(r.length - 1);
      if (c >= 0xD800 && c <= 0xDBFF) {
        this.lastNeed = 2;
        this.lastTotal = 4;
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
        return r.slice(0, -1);
      }
    }
    return r;
  }
  this.lastNeed = 1;
  this.lastTotal = 2;
  this.lastChar[0] = buf[buf.length - 1];
  return buf.toString('utf16le', i, buf.length - 1);
}

// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function utf16End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) {
    var end = this.lastTotal - this.lastNeed;
    return r + this.lastChar.toString('utf16le', 0, end);
  }
  return r;
}

function base64Text(buf, i) {
  var n = (buf.length - i) % 3;
  if (n === 0) return buf.toString('base64', i);
  this.lastNeed = 3 - n;
  this.lastTotal = 3;
  if (n === 1) {
    this.lastChar[0] = buf[buf.length - 1];
  } else {
    this.lastChar[0] = buf[buf.length - 2];
    this.lastChar[1] = buf[buf.length - 1];
  }
  return buf.toString('base64', i, buf.length - n);
}

function base64End(buf) {
  var r = buf && buf.length ? this.write(buf) : '';
  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
  return r;
}

// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function simpleWrite(buf) {
  return buf.toString(this.encoding);
}

function simpleEnd(buf) {
  return buf && buf.length ? this.write(buf) : '';
}

/***/ }),

/***/ 40396:
/***/ (function(module, exports, __webpack_require__) {

/* eslint-disable node/no-deprecated-api */
var buffer = __webpack_require__(48764)
var Buffer = buffer.Buffer

// alternative to using Object.keys for old browsers
function copyProps (src, dst) {
  for (var key in src) {
    dst[key] = src[key]
  }
}
if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
  module.exports = buffer
} else {
  // Copy properties from require('buffer')
  copyProps(buffer, exports)
  exports.Buffer = SafeBuffer
}

function SafeBuffer (arg, encodingOrOffset, length) {
  return Buffer(arg, encodingOrOffset, length)
}

// Copy static methods from Buffer
copyProps(Buffer, SafeBuffer)

SafeBuffer.from = function (arg, encodingOrOffset, length) {
  if (typeof arg === 'number') {
    throw new TypeError('Argument must not be a number')
  }
  return Buffer(arg, encodingOrOffset, length)
}

SafeBuffer.alloc = function (size, fill, encoding) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  var buf = Buffer(size)
  if (fill !== undefined) {
    if (typeof encoding === 'string') {
      buf.fill(fill, encoding)
    } else {
      buf.fill(fill)
    }
  } else {
    buf.fill(0)
  }
  return buf
}

SafeBuffer.allocUnsafe = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return Buffer(size)
}

SafeBuffer.allocUnsafeSlow = function (size) {
  if (typeof size !== 'number') {
    throw new TypeError('Argument must be a number')
  }
  return buffer.SlowBuffer(size)
}


/***/ }),

/***/ 70655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__assign": function() { return /* binding */ __assign; },
/* harmony export */   "__asyncDelegator": function() { return /* binding */ __asyncDelegator; },
/* harmony export */   "__asyncGenerator": function() { return /* binding */ __asyncGenerator; },
/* harmony export */   "__asyncValues": function() { return /* binding */ __asyncValues; },
/* harmony export */   "__await": function() { return /* binding */ __await; },
/* harmony export */   "__awaiter": function() { return /* binding */ __awaiter; },
/* harmony export */   "__classPrivateFieldGet": function() { return /* binding */ __classPrivateFieldGet; },
/* harmony export */   "__classPrivateFieldIn": function() { return /* binding */ __classPrivateFieldIn; },
/* harmony export */   "__classPrivateFieldSet": function() { return /* binding */ __classPrivateFieldSet; },
/* harmony export */   "__createBinding": function() { return /* binding */ __createBinding; },
/* harmony export */   "__decorate": function() { return /* binding */ __decorate; },
/* harmony export */   "__exportStar": function() { return /* binding */ __exportStar; },
/* harmony export */   "__extends": function() { return /* binding */ __extends; },
/* harmony export */   "__generator": function() { return /* binding */ __generator; },
/* harmony export */   "__importDefault": function() { return /* binding */ __importDefault; },
/* harmony export */   "__importStar": function() { return /* binding */ __importStar; },
/* harmony export */   "__makeTemplateObject": function() { return /* binding */ __makeTemplateObject; },
/* harmony export */   "__metadata": function() { return /* binding */ __metadata; },
/* harmony export */   "__param": function() { return /* binding */ __param; },
/* harmony export */   "__read": function() { return /* binding */ __read; },
/* harmony export */   "__rest": function() { return /* binding */ __rest; },
/* harmony export */   "__spread": function() { return /* binding */ __spread; },
/* harmony export */   "__spreadArray": function() { return /* binding */ __spreadArray; },
/* harmony export */   "__spreadArrays": function() { return /* binding */ __spreadArrays; },
/* harmony export */   "__values": function() { return /* binding */ __values; }
/* harmony export */ });
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends(d, b) {
    if (typeof b !== "function" && b !== null)
        throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    }
    return __assign.apply(this, arguments);
}

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
}

function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});

function __exportStar(m, o) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

/** @deprecated */
function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
    function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
    function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
    function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
    function fulfill(value) { resume("next", value); }
    function reject(value) { resume("throw", value); }
    function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
    function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
};

function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
}

function __importDefault(mod) {
    return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}


/***/ }),

/***/ 87462:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _extends; }
/* harmony export */ });
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),

/***/ 63366:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _objectWithoutPropertiesLoose; }
/* harmony export */ });
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),

/***/ 19376:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toPropertyKey; }
});

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js

function _toPrimitive(input, hint) {
  if (_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return _typeof(key) === "symbol" ? key : String(key);
}

/***/ }),

/***/ 37826:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ devAssert; }
/* harmony export */ });
function devAssert(condition, message) {
  const booleanCondition = Boolean(condition);

  if (!booleanCondition) {
    throw new Error(message);
  }
}


/***/ }),

/***/ 25821:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ inspect; }
/* harmony export */ });
const MAX_ARRAY_LENGTH = 10;
const MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (typeof value) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? `[function ${value.name}]` : '[function]';

    case 'object':
      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (value === null) {
    return 'null';
  }

  if (previouslySeenValues.includes(value)) {
    return '[Circular]';
  }

  const seenValues = [...previouslySeenValues, value];

  if (isJSONable(value)) {
    const jsonValue = value.toJSON(); // check for infinite recursion

    if (jsonValue !== value) {
      return typeof jsonValue === 'string'
        ? jsonValue
        : formatValue(jsonValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function isJSONable(value) {
  return typeof value.toJSON === 'function';
}

function formatObject(object, seenValues) {
  const entries = Object.entries(object);

  if (entries.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  const properties = entries.map(
    ([key, value]) => key + ': ' + formatValue(value, seenValues),
  );
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  const len = Math.min(MAX_ARRAY_LENGTH, array.length);
  const remaining = array.length - len;
  const items = [];

  for (let i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push(`... ${remaining} more items`);
  }

  return '[' + items.join(', ') + ']';
}

function getObjectTag(object) {
  const tag = Object.prototype.toString
    .call(object)
    .replace(/^\[object /, '')
    .replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    const name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


/***/ }),

/***/ 72380:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "UG": function() { return /* binding */ isNode; },
/* harmony export */   "WU": function() { return /* binding */ Token; },
/* harmony export */   "Ye": function() { return /* binding */ Location; },
/* harmony export */   "h8": function() { return /* binding */ QueryDocumentKeys; },
/* harmony export */   "ku": function() { return /* binding */ OperationTypeNode; }
/* harmony export */ });
/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
class Location {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  constructor(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  get [Symbol.toStringTag]() {
    return 'Location';
  }

  toJSON() {
    return {
      start: this.start,
      end: this.end,
    };
  }
}
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

class Token {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(kind, start, end, line, column, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column; // eslint-disable-next-line @typescript-eslint/no-non-null-assertion

    this.value = value;
    this.prev = null;
    this.next = null;
  }

  get [Symbol.toStringTag]() {
    return 'Token';
  }

  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column,
    };
  }
}
/**
 * The list of all possible AST node types.
 */

/**
 * @internal
 */
const QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: [
    'name',
    'variableDefinitions',
    'directives',
    'selectionSet',
  ],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: [
    'name', // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    'variableDefinitions',
    'typeCondition',
    'directives',
    'selectionSet',
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: [
    'description',
    'name',
    'type',
    'defaultValue',
    'directives',
  ],
  InterfaceTypeDefinition: [
    'description',
    'name',
    'interfaces',
    'directives',
    'fields',
  ],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields'],
};
const kindValues = new Set(Object.keys(QueryDocumentKeys));
/**
 * @internal
 */

function isNode(maybeNode) {
  const maybeKind =
    maybeNode === null || maybeNode === void 0 ? void 0 : maybeNode.kind;
  return typeof maybeKind === 'string' && kindValues.has(maybeKind);
}
/** Name */

var OperationTypeNode;

(function (OperationTypeNode) {
  OperationTypeNode['QUERY'] = 'query';
  OperationTypeNode['MUTATION'] = 'mutation';
  OperationTypeNode['SUBSCRIPTION'] = 'subscription';
})(OperationTypeNode || (OperationTypeNode = {}));




/***/ }),

/***/ 87392:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LZ": function() { return /* binding */ printBlockString; },
/* harmony export */   "wv": function() { return /* binding */ dedentBlockStringLines; }
/* harmony export */ });
/* unused harmony export isPrintableAsBlockString */
/* harmony import */ var _characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68297);

/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */

function dedentBlockStringLines(lines) {
  var _firstNonEmptyLine2;

  let commonIndent = Number.MAX_SAFE_INTEGER;
  let firstNonEmptyLine = null;
  let lastNonEmptyLine = -1;

  for (let i = 0; i < lines.length; ++i) {
    var _firstNonEmptyLine;

    const line = lines[i];
    const indent = leadingWhitespace(line);

    if (indent === line.length) {
      continue; // skip empty lines
    }

    firstNonEmptyLine =
      (_firstNonEmptyLine = firstNonEmptyLine) !== null &&
      _firstNonEmptyLine !== void 0
        ? _firstNonEmptyLine
        : i;
    lastNonEmptyLine = i;

    if (i !== 0 && indent < commonIndent) {
      commonIndent = indent;
    }
  }

  return lines // Remove common indentation from all lines but first.
    .map((line, i) => (i === 0 ? line : line.slice(commonIndent))) // Remove leading and trailing blank lines.
    .slice(
      (_firstNonEmptyLine2 = firstNonEmptyLine) !== null &&
        _firstNonEmptyLine2 !== void 0
        ? _firstNonEmptyLine2
        : 0,
      lastNonEmptyLine + 1,
    );
}

function leadingWhitespace(str) {
  let i = 0;

  while (i < str.length && (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(str.charCodeAt(i))) {
    ++i;
  }

  return i;
}
/**
 * @internal
 */

function isPrintableAsBlockString(value) {
  if (value === '') {
    return true; // empty string is printable
  }

  let isEmptyLine = true;
  let hasIndent = false;
  let hasCommonIndent = true;
  let seenNonEmptyLine = false;

  for (let i = 0; i < value.length; ++i) {
    switch (value.codePointAt(i)) {
      case 0x0000:
      case 0x0001:
      case 0x0002:
      case 0x0003:
      case 0x0004:
      case 0x0005:
      case 0x0006:
      case 0x0007:
      case 0x0008:
      case 0x000b:
      case 0x000c:
      case 0x000e:
      case 0x000f:
        return false;
      // Has non-printable characters

      case 0x000d:
        //  \r
        return false;
      // Has \r or \r\n which will be replaced as \n

      case 10:
        //  \n
        if (isEmptyLine && !seenNonEmptyLine) {
          return false; // Has leading new line
        }

        seenNonEmptyLine = true;
        isEmptyLine = true;
        hasIndent = false;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        hasIndent || (hasIndent = isEmptyLine);
        break;

      default:
        hasCommonIndent && (hasCommonIndent = hasIndent);
        isEmptyLine = false;
    }
  }

  if (isEmptyLine) {
    return false; // Has trailing empty lines
  }

  if (hasCommonIndent && seenNonEmptyLine) {
    return false; // Has internal indent
  }

  return true;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value, options) {
  const escapedValue = value.replace(/"""/g, '\\"""'); // Expand a block string's raw value into independent lines.

  const lines = escapedValue.split(/\r\n|[\n\r]/g);
  const isSingleLine = lines.length === 1; // If common indentation is found we can fix some of those cases by adding leading new line

  const forceLeadingNewLine =
    lines.length > 1 &&
    lines
      .slice(1)
      .every((line) => line.length === 0 || (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(line.charCodeAt(0))); // Trailing triple quotes just looks confusing but doesn't force trailing new line

  const hasTrailingTripleQuotes = escapedValue.endsWith('\\"""'); // Trailing quote (single or double) or slash forces trailing new line

  const hasTrailingQuote = value.endsWith('"') && !hasTrailingTripleQuotes;
  const hasTrailingSlash = value.endsWith('\\');
  const forceTrailingNewline = hasTrailingQuote || hasTrailingSlash;
  const printAsMultipleLines =
    !(options !== null && options !== void 0 && options.minimize) && // add leading and trailing new lines only if it improves readability
    (!isSingleLine ||
      value.length > 70 ||
      forceTrailingNewline ||
      forceLeadingNewLine ||
      hasTrailingTripleQuotes);
  let result = ''; // Format a multi-line block quote to account for leading space.

  const skipLeadingNewLine = isSingleLine && (0,_characterClasses_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isWhiteSpace */ .FD)(value.charCodeAt(0));

  if ((printAsMultipleLines && !skipLeadingNewLine) || forceLeadingNewLine) {
    result += '\n';
  }

  result += escapedValue;

  if (printAsMultipleLines || forceTrailingNewline) {
    result += '\n';
  }

  return '"""' + result + '"""';
}


/***/ }),

/***/ 68297:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FD": function() { return /* binding */ isWhiteSpace; },
/* harmony export */   "HQ": function() { return /* binding */ isNameContinue; },
/* harmony export */   "LQ": function() { return /* binding */ isNameStart; },
/* harmony export */   "X1": function() { return /* binding */ isDigit; }
/* harmony export */ });
/* unused harmony export isLetter */
/**
 * ```
 * WhiteSpace ::
 *   - "Horizontal Tab (U+0009)"
 *   - "Space (U+0020)"
 * ```
 * @internal
 */
function isWhiteSpace(code) {
  return code === 0x0009 || code === 0x0020;
}
/**
 * ```
 * Digit :: one of
 *   - `0` `1` `2` `3` `4` `5` `6` `7` `8` `9`
 * ```
 * @internal
 */

function isDigit(code) {
  return code >= 0x0030 && code <= 0x0039;
}
/**
 * ```
 * Letter :: one of
 *   - `A` `B` `C` `D` `E` `F` `G` `H` `I` `J` `K` `L` `M`
 *   - `N` `O` `P` `Q` `R` `S` `T` `U` `V` `W` `X` `Y` `Z`
 *   - `a` `b` `c` `d` `e` `f` `g` `h` `i` `j` `k` `l` `m`
 *   - `n` `o` `p` `q` `r` `s` `t` `u` `v` `w` `x` `y` `z`
 * ```
 * @internal
 */

function isLetter(code) {
  return (
    (code >= 0x0061 && code <= 0x007a) || // A-Z
    (code >= 0x0041 && code <= 0x005a) // a-z
  );
}
/**
 * ```
 * NameStart ::
 *   - Letter
 *   - `_`
 * ```
 * @internal
 */

function isNameStart(code) {
  return isLetter(code) || code === 0x005f;
}
/**
 * ```
 * NameContinue ::
 *   - Letter
 *   - Digit
 *   - `_`
 * ```
 * @internal
 */

function isNameContinue(code) {
  return isLetter(code) || isDigit(code) || code === 0x005f;
}


/***/ }),

/***/ 97359:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Kind; }
/* harmony export */ });
/**
 * The set of allowed kind values for AST nodes.
 */
var Kind;

(function (Kind) {
  Kind['NAME'] = 'Name';
  Kind['DOCUMENT'] = 'Document';
  Kind['OPERATION_DEFINITION'] = 'OperationDefinition';
  Kind['VARIABLE_DEFINITION'] = 'VariableDefinition';
  Kind['SELECTION_SET'] = 'SelectionSet';
  Kind['FIELD'] = 'Field';
  Kind['ARGUMENT'] = 'Argument';
  Kind['FRAGMENT_SPREAD'] = 'FragmentSpread';
  Kind['INLINE_FRAGMENT'] = 'InlineFragment';
  Kind['FRAGMENT_DEFINITION'] = 'FragmentDefinition';
  Kind['VARIABLE'] = 'Variable';
  Kind['INT'] = 'IntValue';
  Kind['FLOAT'] = 'FloatValue';
  Kind['STRING'] = 'StringValue';
  Kind['BOOLEAN'] = 'BooleanValue';
  Kind['NULL'] = 'NullValue';
  Kind['ENUM'] = 'EnumValue';
  Kind['LIST'] = 'ListValue';
  Kind['OBJECT'] = 'ObjectValue';
  Kind['OBJECT_FIELD'] = 'ObjectField';
  Kind['DIRECTIVE'] = 'Directive';
  Kind['NAMED_TYPE'] = 'NamedType';
  Kind['LIST_TYPE'] = 'ListType';
  Kind['NON_NULL_TYPE'] = 'NonNullType';
  Kind['SCHEMA_DEFINITION'] = 'SchemaDefinition';
  Kind['OPERATION_TYPE_DEFINITION'] = 'OperationTypeDefinition';
  Kind['SCALAR_TYPE_DEFINITION'] = 'ScalarTypeDefinition';
  Kind['OBJECT_TYPE_DEFINITION'] = 'ObjectTypeDefinition';
  Kind['FIELD_DEFINITION'] = 'FieldDefinition';
  Kind['INPUT_VALUE_DEFINITION'] = 'InputValueDefinition';
  Kind['INTERFACE_TYPE_DEFINITION'] = 'InterfaceTypeDefinition';
  Kind['UNION_TYPE_DEFINITION'] = 'UnionTypeDefinition';
  Kind['ENUM_TYPE_DEFINITION'] = 'EnumTypeDefinition';
  Kind['ENUM_VALUE_DEFINITION'] = 'EnumValueDefinition';
  Kind['INPUT_OBJECT_TYPE_DEFINITION'] = 'InputObjectTypeDefinition';
  Kind['DIRECTIVE_DEFINITION'] = 'DirectiveDefinition';
  Kind['SCHEMA_EXTENSION'] = 'SchemaExtension';
  Kind['SCALAR_TYPE_EXTENSION'] = 'ScalarTypeExtension';
  Kind['OBJECT_TYPE_EXTENSION'] = 'ObjectTypeExtension';
  Kind['INTERFACE_TYPE_EXTENSION'] = 'InterfaceTypeExtension';
  Kind['UNION_TYPE_EXTENSION'] = 'UnionTypeExtension';
  Kind['ENUM_TYPE_EXTENSION'] = 'EnumTypeExtension';
  Kind['INPUT_OBJECT_TYPE_EXTENSION'] = 'InputObjectTypeExtension';
})(Kind || (Kind = {}));


/**
 * The enum type representing the possible kind values of AST nodes.
 *
 * @deprecated Please use `Kind`. Will be remove in v17.
 */


/***/ }),

/***/ 16918:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "S": function() { return /* binding */ print; }
});

// EXTERNAL MODULE: ./node_modules/graphql/language/blockString.mjs
var blockString = __webpack_require__(87392);
;// CONCATENATED MODULE: ./node_modules/graphql/language/printString.mjs
/**
 * Prints a string as a GraphQL StringValue literal. Replaces control characters
 * and excluded characters (" U+0022 and \\ U+005C) with escape sequences.
 */
function printString(str) {
  return `"${str.replace(escapedRegExp, escapedReplacer)}"`;
} // eslint-disable-next-line no-control-regex

const escapedRegExp = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;

function escapedReplacer(str) {
  return escapeSequences[str.charCodeAt(0)];
} // prettier-ignore

const escapeSequences = [
  '\\u0000',
  '\\u0001',
  '\\u0002',
  '\\u0003',
  '\\u0004',
  '\\u0005',
  '\\u0006',
  '\\u0007',
  '\\b',
  '\\t',
  '\\n',
  '\\u000B',
  '\\f',
  '\\r',
  '\\u000E',
  '\\u000F',
  '\\u0010',
  '\\u0011',
  '\\u0012',
  '\\u0013',
  '\\u0014',
  '\\u0015',
  '\\u0016',
  '\\u0017',
  '\\u0018',
  '\\u0019',
  '\\u001A',
  '\\u001B',
  '\\u001C',
  '\\u001D',
  '\\u001E',
  '\\u001F',
  '',
  '',
  '\\"',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 2F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 3F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 4F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\\\',
  '',
  '',
  '', // 5F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '', // 6F
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '',
  '\\u007F',
  '\\u0080',
  '\\u0081',
  '\\u0082',
  '\\u0083',
  '\\u0084',
  '\\u0085',
  '\\u0086',
  '\\u0087',
  '\\u0088',
  '\\u0089',
  '\\u008A',
  '\\u008B',
  '\\u008C',
  '\\u008D',
  '\\u008E',
  '\\u008F',
  '\\u0090',
  '\\u0091',
  '\\u0092',
  '\\u0093',
  '\\u0094',
  '\\u0095',
  '\\u0096',
  '\\u0097',
  '\\u0098',
  '\\u0099',
  '\\u009A',
  '\\u009B',
  '\\u009C',
  '\\u009D',
  '\\u009E',
  '\\u009F',
];

// EXTERNAL MODULE: ./node_modules/graphql/language/visitor.mjs
var visitor = __webpack_require__(77304);
;// CONCATENATED MODULE: ./node_modules/graphql/language/printer.mjs



/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return (0,visitor/* visit */.Vn)(ast, printDocASTReducer);
}
const MAX_LINE_LENGTH = 80;
const printDocASTReducer = {
  Name: {
    leave: (node) => node.value,
  },
  Variable: {
    leave: (node) => '$' + node.name,
  },
  // Document
  Document: {
    leave: (node) => join(node.definitions, '\n\n'),
  },
  OperationDefinition: {
    leave(node) {
      const varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
      const prefix = join(
        [
          node.operation,
          join([node.name, varDefs]),
          join(node.directives, ' '),
        ],
        ' ',
      ); // Anonymous queries with no directives or variable definitions can use
      // the query short form.

      return (prefix === 'query' ? '' : prefix + ' ') + node.selectionSet;
    },
  },
  VariableDefinition: {
    leave: ({ variable, type, defaultValue, directives }) =>
      variable +
      ': ' +
      type +
      wrap(' = ', defaultValue) +
      wrap(' ', join(directives, ' ')),
  },
  SelectionSet: {
    leave: ({ selections }) => block(selections),
  },
  Field: {
    leave({ alias, name, arguments: args, directives, selectionSet }) {
      const prefix = wrap('', alias, ': ') + name;
      let argsLine = prefix + wrap('(', join(args, ', '), ')');

      if (argsLine.length > MAX_LINE_LENGTH) {
        argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
      }

      return join([argsLine, join(directives, ' '), selectionSet], ' ');
    },
  },
  Argument: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name, directives }) =>
      '...' + name + wrap(' ', join(directives, ' ')),
  },
  InlineFragment: {
    leave: ({ typeCondition, directives, selectionSet }) =>
      join(
        [
          '...',
          wrap('on ', typeCondition),
          join(directives, ' '),
          selectionSet,
        ],
        ' ',
      ),
  },
  FragmentDefinition: {
    leave: (
      { name, typeCondition, variableDefinitions, directives, selectionSet }, // Note: fragment variable definitions are experimental and may be changed
    ) =>
      // or removed in the future.
      `fragment ${name}${wrap('(', join(variableDefinitions, ', '), ')')} ` +
      `on ${typeCondition} ${wrap('', join(directives, ' '), ' ')}` +
      selectionSet,
  },
  // Value
  IntValue: {
    leave: ({ value }) => value,
  },
  FloatValue: {
    leave: ({ value }) => value,
  },
  StringValue: {
    leave: ({ value, block: isBlockString }) =>
      isBlockString ? (0,blockString/* printBlockString */.LZ)(value) : printString(value),
  },
  BooleanValue: {
    leave: ({ value }) => (value ? 'true' : 'false'),
  },
  NullValue: {
    leave: () => 'null',
  },
  EnumValue: {
    leave: ({ value }) => value,
  },
  ListValue: {
    leave: ({ values }) => '[' + join(values, ', ') + ']',
  },
  ObjectValue: {
    leave: ({ fields }) => '{' + join(fields, ', ') + '}',
  },
  ObjectField: {
    leave: ({ name, value }) => name + ': ' + value,
  },
  // Directive
  Directive: {
    leave: ({ name, arguments: args }) =>
      '@' + name + wrap('(', join(args, ', '), ')'),
  },
  // Type
  NamedType: {
    leave: ({ name }) => name,
  },
  ListType: {
    leave: ({ type }) => '[' + type + ']',
  },
  NonNullType: {
    leave: ({ type }) => type + '!',
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description, directives, operationTypes }) =>
      wrap('', description, '\n') +
      join(['schema', join(directives, ' '), block(operationTypes)], ' '),
  },
  OperationTypeDefinition: {
    leave: ({ operation, type }) => operation + ': ' + type,
  },
  ScalarTypeDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') +
      join(['scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  FieldDefinition: {
    leave: ({ description, name, arguments: args, type, directives }) =>
      wrap('', description, '\n') +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      ': ' +
      type +
      wrap(' ', join(directives, ' ')),
  },
  InputValueDefinition: {
    leave: ({ description, name, type, defaultValue, directives }) =>
      wrap('', description, '\n') +
      join(
        [name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')],
        ' ',
      ),
  },
  InterfaceTypeDefinition: {
    leave: ({ description, name, interfaces, directives, fields }) =>
      wrap('', description, '\n') +
      join(
        [
          'interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeDefinition: {
    leave: ({ description, name, directives, types }) =>
      wrap('', description, '\n') +
      join(
        ['union', name, join(directives, ' '), wrap('= ', join(types, ' | '))],
        ' ',
      ),
  },
  EnumTypeDefinition: {
    leave: ({ description, name, directives, values }) =>
      wrap('', description, '\n') +
      join(['enum', name, join(directives, ' '), block(values)], ' '),
  },
  EnumValueDefinition: {
    leave: ({ description, name, directives }) =>
      wrap('', description, '\n') + join([name, join(directives, ' ')], ' '),
  },
  InputObjectTypeDefinition: {
    leave: ({ description, name, directives, fields }) =>
      wrap('', description, '\n') +
      join(['input', name, join(directives, ' '), block(fields)], ' '),
  },
  DirectiveDefinition: {
    leave: ({ description, name, arguments: args, repeatable, locations }) =>
      wrap('', description, '\n') +
      'directive @' +
      name +
      (hasMultilineItems(args)
        ? wrap('(\n', indent(join(args, '\n')), '\n)')
        : wrap('(', join(args, ', '), ')')) +
      (repeatable ? ' repeatable' : '') +
      ' on ' +
      join(locations, ' | '),
  },
  SchemaExtension: {
    leave: ({ directives, operationTypes }) =>
      join(
        ['extend schema', join(directives, ' '), block(operationTypes)],
        ' ',
      ),
  },
  ScalarTypeExtension: {
    leave: ({ name, directives }) =>
      join(['extend scalar', name, join(directives, ' ')], ' '),
  },
  ObjectTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend type',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  InterfaceTypeExtension: {
    leave: ({ name, interfaces, directives, fields }) =>
      join(
        [
          'extend interface',
          name,
          wrap('implements ', join(interfaces, ' & ')),
          join(directives, ' '),
          block(fields),
        ],
        ' ',
      ),
  },
  UnionTypeExtension: {
    leave: ({ name, directives, types }) =>
      join(
        [
          'extend union',
          name,
          join(directives, ' '),
          wrap('= ', join(types, ' | ')),
        ],
        ' ',
      ),
  },
  EnumTypeExtension: {
    leave: ({ name, directives, values }) =>
      join(['extend enum', name, join(directives, ' '), block(values)], ' '),
  },
  InputObjectTypeExtension: {
    leave: ({ name, directives, fields }) =>
      join(['extend input', name, join(directives, ' '), block(fields)], ' '),
  },
};
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */

function join(maybeArray, separator = '') {
  var _maybeArray$filter$jo;

  return (_maybeArray$filter$jo =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.filter((x) => x).join(separator)) !== null &&
    _maybeArray$filter$jo !== void 0
    ? _maybeArray$filter$jo
    : '';
}
/**
 * Given array, print each item on its own line, wrapped in an indented `{ }` block.
 */

function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */

function wrap(start, maybeString, end = '') {
  return maybeString != null && maybeString !== ''
    ? start + maybeString + end
    : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function hasMultilineItems(maybeArray) {
  var _maybeArray$some;

  // FIXME: https://github.com/graphql/graphql-js/issues/2203

  /* c8 ignore next */
  return (_maybeArray$some =
    maybeArray === null || maybeArray === void 0
      ? void 0
      : maybeArray.some((str) => str.includes('\n'))) !== null &&
    _maybeArray$some !== void 0
    ? _maybeArray$some
    : false;
}


/***/ }),

/***/ 51270:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "H": function() { return /* binding */ Source; },
  "T": function() { return /* binding */ isSource; }
});

// EXTERNAL MODULE: ./node_modules/graphql/jsutils/devAssert.mjs
var devAssert = __webpack_require__(37826);
// EXTERNAL MODULE: ./node_modules/graphql/jsutils/inspect.mjs
var inspect = __webpack_require__(25821);
;// CONCATENATED MODULE: ./node_modules/graphql/jsutils/instanceOf.mjs

/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 * See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
 * See: https://webpack.js.org/guides/production/
 */

const instanceOf =
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  // eslint-disable-next-line no-undef
   true
    ? function instanceOf(value, constructor) {
        return value instanceof constructor;
      }
    : 0;

;// CONCATENATED MODULE: ./node_modules/graphql/language/source.mjs




/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
class Source {
  constructor(
    body,
    name = 'GraphQL request',
    locationOffset = {
      line: 1,
      column: 1,
    },
  ) {
    typeof body === 'string' ||
      (0,devAssert/* devAssert */.a)(false, `Body must be a string. Received: ${(0,inspect/* inspect */.X)(body)}.`);
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 ||
      (0,devAssert/* devAssert */.a)(
        false,
        'line in locationOffset is 1-indexed and must be positive.',
      );
    this.locationOffset.column > 0 ||
      (0,devAssert/* devAssert */.a)(
        false,
        'column in locationOffset is 1-indexed and must be positive.',
      );
  }

  get [Symbol.toStringTag]() {
    return 'Source';
  }
}
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

function isSource(source) {
  return instanceOf(source, Source);
}


/***/ }),

/***/ 77304:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": function() { return /* binding */ BREAK; },
/* harmony export */   "Vn": function() { return /* binding */ visit; }
/* harmony export */ });
/* unused harmony exports visitInParallel, getEnterLeaveForKind, getVisitFn */
/* harmony import */ var _jsutils_devAssert_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(37826);
/* harmony import */ var _jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25821);
/* harmony import */ var _ast_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(72380);
/* harmony import */ var _kinds_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97359);




/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

const BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 * ```ts
 * const editedAST = visit(ast, {
 *   enter(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: skip visiting this node
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   },
 *   leave(node, key, parent, path, ancestors) {
 *     // @return
 *     //   undefined: no action
 *     //   false: no action
 *     //   visitor.BREAK: stop visiting altogether
 *     //   null: delete this node
 *     //   any value: replace this node with the returned value
 *   }
 * });
 * ```
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to three permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind(node) {
 *     // enter the "Kind" node
 *   }
 * })
 * ```
 *
 * 2) Named visitors that trigger upon entering and leaving a node of a specific kind.
 *
 * ```ts
 * visit(ast, {
 *   Kind: {
 *     enter(node) {
 *       // enter the "Kind" node
 *     }
 *     leave(node) {
 *       // leave the "Kind" node
 *     }
 *   }
 * })
 * ```
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 * ```ts
 * visit(ast, {
 *   enter(node) {
 *     // enter any node
 *   },
 *   leave(node) {
 *     // leave any node
 *   }
 * })
 * ```
 */

function visit(root, visitor, visitorKeys = _ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .QueryDocumentKeys */ .h8) {
  const enterLeaveMap = new Map();

  for (const kind of Object.values(_kinds_mjs__WEBPACK_IMPORTED_MODULE_1__/* .Kind */ .h)) {
    enterLeaveMap.set(kind, getEnterLeaveForKind(visitor, kind));
  }
  /* eslint-disable no-undef-init */

  let stack = undefined;
  let inArray = Array.isArray(root);
  let keys = [root];
  let index = -1;
  let edits = [];
  let node = root;
  let key = undefined;
  let parent = undefined;
  const path = [];
  const ancestors = [];
  /* eslint-enable no-undef-init */

  do {
    index++;
    const isLeaving = index === keys.length;
    const isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
          let editOffset = 0;

          for (const [editKey, editValue] of edits) {
            const arrayKey = editKey - editOffset;

            if (editValue === null) {
              node.splice(arrayKey, 1);
              editOffset++;
            } else {
              node[arrayKey] = editValue;
            }
          }
        } else {
          node = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(node),
          );

          for (const [editKey, editValue] of edits) {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else if (parent) {
      key = inArray ? index : keys[index];
      node = parent[key];

      if (node === null || node === undefined) {
        continue;
      }

      path.push(key);
    }

    let result;

    if (!Array.isArray(node)) {
      var _enterLeaveMap$get, _enterLeaveMap$get2;

      (0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */ .UG)(node) || (0,_jsutils_devAssert_mjs__WEBPACK_IMPORTED_MODULE_2__/* .devAssert */ .a)(false, `Invalid AST Node: ${(0,_jsutils_inspect_mjs__WEBPACK_IMPORTED_MODULE_3__/* .inspect */ .X)(node)}.`);
      const visitFn = isLeaving
        ? (_enterLeaveMap$get = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get === void 0
          ? void 0
          : _enterLeaveMap$get.leave
        : (_enterLeaveMap$get2 = enterLeaveMap.get(node.kind)) === null ||
          _enterLeaveMap$get2 === void 0
        ? void 0
        : _enterLeaveMap$get2.enter;
      result =
        visitFn === null || visitFn === void 0
          ? void 0
          : visitFn.call(visitor, node, key, parent, path, ancestors);

      if (result === BREAK) {
        break;
      }

      if (result === false) {
        if (!isLeaving) {
          path.pop();
          continue;
        }
      } else if (result !== undefined) {
        edits.push([key, result]);

        if (!isLeaving) {
          if ((0,_ast_mjs__WEBPACK_IMPORTED_MODULE_0__/* .isNode */ .UG)(result)) {
            node = result;
          } else {
            path.pop();
            continue;
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _node$kind;

      stack = {
        inArray,
        index,
        keys,
        edits,
        prev: stack,
      };
      inArray = Array.isArray(node);
      keys = inArray
        ? node
        : (_node$kind = visitorKeys[node.kind]) !== null &&
          _node$kind !== void 0
        ? _node$kind
        : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    // New root
    return edits[edits.length - 1][1];
  }

  return root;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  const skipping = new Array(visitors.length).fill(null);
  const mergedVisitor = Object.create(null);

  for (const kind of Object.values(Kind)) {
    let hasVisitor = false;
    const enterList = new Array(visitors.length).fill(undefined);
    const leaveList = new Array(visitors.length).fill(undefined);

    for (let i = 0; i < visitors.length; ++i) {
      const { enter, leave } = getEnterLeaveForKind(visitors[i], kind);
      hasVisitor || (hasVisitor = enter != null || leave != null);
      enterList[i] = enter;
      leaveList[i] = leave;
    }

    if (!hasVisitor) {
      continue;
    }

    const mergedEnterLeave = {
      enter(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _enterList$i;

            const result =
              (_enterList$i = enterList[i]) === null || _enterList$i === void 0
                ? void 0
                : _enterList$i.apply(visitors[i], args);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      },

      leave(...args) {
        const node = args[0];

        for (let i = 0; i < visitors.length; i++) {
          if (skipping[i] === null) {
            var _leaveList$i;

            const result =
              (_leaveList$i = leaveList[i]) === null || _leaveList$i === void 0
                ? void 0
                : _leaveList$i.apply(visitors[i], args);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          } else if (skipping[i] === node) {
            skipping[i] = null;
          }
        }
      },
    };
    mergedVisitor[kind] = mergedEnterLeave;
  }

  return mergedVisitor;
}
/**
 * Given a visitor instance and a node kind, return EnterLeaveVisitor for that kind.
 */

function getEnterLeaveForKind(visitor, kind) {
  const kindVisitor = visitor[kind];

  if (typeof kindVisitor === 'object') {
    // { Kind: { enter() {}, leave() {} } }
    return kindVisitor;
  } else if (typeof kindVisitor === 'function') {
    // { Kind() {} }
    return {
      enter: kindVisitor,
      leave: undefined,
    };
  } // { enter() {}, leave() {} }

  return {
    enter: visitor.enter,
    leave: visitor.leave,
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 *
 * @deprecated Please use `getEnterLeaveForKind` instead. Will be removed in v17
 */

/* c8 ignore next 8 */

function getVisitFn(visitor, kind, isLeaving) {
  const { enter, leave } = getEnterLeaveForKind(visitor, kind);
  return isLeaving ? leave : enter;
}


/***/ }),

/***/ 12902:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P2": function() { return /* binding */ ln; },
/* harmony export */   "Uy": function() { return /* binding */ fn; },
/* harmony export */   "_x": function() { return /* binding */ dn; },
/* harmony export */   "mv": function() { return /* binding */ r; },
/* harmony export */   "o$": function() { return /* binding */ t; },
/* harmony export */   "pV": function() { return /* binding */ N; }
/* harmony export */ });
/* unused harmony exports Immer, applyPatches, castDraft, castImmutable, current, enableAllPlugins, enableMapSet, enablePatches, freeze, immerable, nothing, original, produceWithPatches, setAutoFreeze, setUseProxies */
function n(n){for(var r=arguments.length,t=Array(r>1?r-1:0),e=1;e<r;e++)t[e-1]=arguments[e];if(false){ var i, o; }throw Error("[Immer] minified error nr: "+n+(t.length?" "+t.map((function(n){return"'"+n+"'"})).join(","):"")+". Find the full error at: https://bit.ly/3cXEKWf")}function r(n){return!!n&&!!n[Q]}function t(n){var r;return!!n&&(function(n){if(!n||"object"!=typeof n)return!1;var r=Object.getPrototypeOf(n);if(null===r)return!0;var t=Object.hasOwnProperty.call(r,"constructor")&&r.constructor;return t===Object||"function"==typeof t&&Function.toString.call(t)===Z}(n)||Array.isArray(n)||!!n[L]||!!(null===(r=n.constructor)||void 0===r?void 0:r[L])||s(n)||v(n))}function e(t){return r(t)||n(23,t),t[Q].t}function i(n,r,t){void 0===t&&(t=!1),0===o(n)?(t?Object.keys:nn)(n).forEach((function(e){t&&"symbol"==typeof e||r(e,n[e],n)})):n.forEach((function(t,e){return r(e,t,n)}))}function o(n){var r=n[Q];return r?r.i>3?r.i-4:r.i:Array.isArray(n)?1:s(n)?2:v(n)?3:0}function u(n,r){return 2===o(n)?n.has(r):Object.prototype.hasOwnProperty.call(n,r)}function a(n,r){return 2===o(n)?n.get(r):n[r]}function f(n,r,t){var e=o(n);2===e?n.set(r,t):3===e?(n.delete(r),n.add(t)):n[r]=t}function c(n,r){return n===r?0!==n||1/n==1/r:n!=n&&r!=r}function s(n){return X&&n instanceof Map}function v(n){return q&&n instanceof Set}function p(n){return n.o||n.t}function l(n){if(Array.isArray(n))return Array.prototype.slice.call(n);var r=rn(n);delete r[Q];for(var t=nn(r),e=0;e<t.length;e++){var i=t[e],o=r[i];!1===o.writable&&(o.writable=!0,o.configurable=!0),(o.get||o.set)&&(r[i]={configurable:!0,writable:!0,enumerable:o.enumerable,value:n[i]})}return Object.create(Object.getPrototypeOf(n),r)}function d(n,e){return void 0===e&&(e=!1),y(n)||r(n)||!t(n)?n:(o(n)>1&&(n.set=n.add=n.clear=n.delete=h),Object.freeze(n),e&&i(n,(function(n,r){return d(r,!0)}),!0),n)}function h(){n(2)}function y(n){return null==n||"object"!=typeof n||Object.isFrozen(n)}function b(r){var t=tn[r];return t||n(18,r),t}function m(n,r){tn[n]||(tn[n]=r)}function _(){return true||0,U}function j(n,r){r&&(b("Patches"),n.u=[],n.s=[],n.v=r)}function O(n){g(n),n.p.forEach(S),n.p=null}function g(n){n===U&&(U=n.l)}function w(n){return U={p:[],l:U,h:n,m:!0,_:0}}function S(n){var r=n[Q];0===r.i||1===r.i?r.j():r.O=!0}function P(r,e){e._=e.p.length;var i=e.p[0],o=void 0!==r&&r!==i;return e.h.g||b("ES5").S(e,r,o),o?(i[Q].P&&(O(e),n(4)),t(r)&&(r=M(e,r),e.l||x(e,r)),e.u&&b("Patches").M(i[Q].t,r,e.u,e.s)):r=M(e,i,[]),O(e),e.u&&e.v(e.u,e.s),r!==H?r:void 0}function M(n,r,t){if(y(r))return r;var e=r[Q];if(!e)return i(r,(function(i,o){return A(n,e,r,i,o,t)}),!0),r;if(e.A!==n)return r;if(!e.P)return x(n,e.t,!0),e.t;if(!e.I){e.I=!0,e.A._--;var o=4===e.i||5===e.i?e.o=l(e.k):e.o;i(3===e.i?new Set(o):o,(function(r,i){return A(n,e,o,r,i,t)})),x(n,o,!1),t&&n.u&&b("Patches").R(e,t,n.u,n.s)}return e.o}function A(e,i,o,a,c,s){if( false&&0,r(c)){var v=M(e,c,s&&i&&3!==i.i&&!u(i.D,a)?s.concat(a):void 0);if(f(o,a,v),!r(v))return;e.m=!1}if(t(c)&&!y(c)){if(!e.h.F&&e._<1)return;M(e,c),i&&i.A.l||x(e,c)}}function x(n,r,t){void 0===t&&(t=!1),n.h.F&&n.m&&d(r,t)}function z(n,r){var t=n[Q];return(t?p(t):n)[r]}function I(n,r){if(r in n)for(var t=Object.getPrototypeOf(n);t;){var e=Object.getOwnPropertyDescriptor(t,r);if(e)return e;t=Object.getPrototypeOf(t)}}function k(n){n.P||(n.P=!0,n.l&&k(n.l))}function E(n){n.o||(n.o=l(n.t))}function R(n,r,t){var e=s(r)?b("MapSet").N(r,t):v(r)?b("MapSet").T(r,t):n.g?function(n,r){var t=Array.isArray(n),e={i:t?1:0,A:r?r.A:_(),P:!1,I:!1,D:{},l:r,t:n,k:null,o:null,j:null,C:!1},i=e,o=en;t&&(i=[e],o=on);var u=Proxy.revocable(i,o),a=u.revoke,f=u.proxy;return e.k=f,e.j=a,f}(r,t):b("ES5").J(r,t);return(t?t.A:_()).p.push(e),e}function D(e){return r(e)||n(22,e),function n(r){if(!t(r))return r;var e,u=r[Q],c=o(r);if(u){if(!u.P&&(u.i<4||!b("ES5").K(u)))return u.t;u.I=!0,e=F(r,c),u.I=!1}else e=F(r,c);return i(e,(function(r,t){u&&a(u.t,r)===t||f(e,r,n(t))})),3===c?new Set(e):e}(e)}function F(n,r){switch(r){case 2:return new Map(n);case 3:return Array.from(n)}return l(n)}function N(){function t(n,r){var t=s[n];return t?t.enumerable=r:s[n]=t={configurable:!0,enumerable:r,get:function(){var r=this[Q];return false&&0,en.get(r,n)},set:function(r){var t=this[Q]; false&&0,en.set(t,n,r)}},t}function e(n){for(var r=n.length-1;r>=0;r--){var t=n[r][Q];if(!t.P)switch(t.i){case 5:a(t)&&k(t);break;case 4:o(t)&&k(t)}}}function o(n){for(var r=n.t,t=n.k,e=nn(t),i=e.length-1;i>=0;i--){var o=e[i];if(o!==Q){var a=r[o];if(void 0===a&&!u(r,o))return!0;var f=t[o],s=f&&f[Q];if(s?s.t!==a:!c(f,a))return!0}}var v=!!r[Q];return e.length!==nn(r).length+(v?0:1)}function a(n){var r=n.k;if(r.length!==n.t.length)return!0;var t=Object.getOwnPropertyDescriptor(r,r.length-1);if(t&&!t.get)return!0;for(var e=0;e<r.length;e++)if(!r.hasOwnProperty(e))return!0;return!1}function f(r){r.O&&n(3,JSON.stringify(p(r)))}var s={};m("ES5",{J:function(n,r){var e=Array.isArray(n),i=function(n,r){if(n){for(var e=Array(r.length),i=0;i<r.length;i++)Object.defineProperty(e,""+i,t(i,!0));return e}var o=rn(r);delete o[Q];for(var u=nn(o),a=0;a<u.length;a++){var f=u[a];o[f]=t(f,n||!!o[f].enumerable)}return Object.create(Object.getPrototypeOf(r),o)}(e,n),o={i:e?5:4,A:r?r.A:_(),P:!1,I:!1,D:{},l:r,t:n,k:i,o:null,O:!1,C:!1};return Object.defineProperty(i,Q,{value:o,writable:!0}),i},S:function(n,t,o){o?r(t)&&t[Q].A===n&&e(n.p):(n.u&&function n(r){if(r&&"object"==typeof r){var t=r[Q];if(t){var e=t.t,o=t.k,f=t.D,c=t.i;if(4===c)i(o,(function(r){r!==Q&&(void 0!==e[r]||u(e,r)?f[r]||n(o[r]):(f[r]=!0,k(t)))})),i(e,(function(n){void 0!==o[n]||u(o,n)||(f[n]=!1,k(t))}));else if(5===c){if(a(t)&&(k(t),f.length=!0),o.length<e.length)for(var s=o.length;s<e.length;s++)f[s]=!1;else for(var v=e.length;v<o.length;v++)f[v]=!0;for(var p=Math.min(o.length,e.length),l=0;l<p;l++)o.hasOwnProperty(l)||(f[l]=!0),void 0===f[l]&&n(o[l])}}}}(n.p[0]),e(n.p))},K:function(n){return 4===n.i?o(n):a(n)}})}function T(){function e(n){if(!t(n))return n;if(Array.isArray(n))return n.map(e);if(s(n))return new Map(Array.from(n.entries()).map((function(n){return[n[0],e(n[1])]})));if(v(n))return new Set(Array.from(n).map(e));var r=Object.create(Object.getPrototypeOf(n));for(var i in n)r[i]=e(n[i]);return u(n,L)&&(r[L]=n[L]),r}function f(n){return r(n)?e(n):n}var c="add";m("Patches",{$:function(r,t){return t.forEach((function(t){for(var i=t.path,u=t.op,f=r,s=0;s<i.length-1;s++){var v=o(f),p=""+i[s];0!==v&&1!==v||"__proto__"!==p&&"constructor"!==p||n(24),"function"==typeof f&&"prototype"===p&&n(24),"object"!=typeof(f=a(f,p))&&n(15,i.join("/"))}var l=o(f),d=e(t.value),h=i[i.length-1];switch(u){case"replace":switch(l){case 2:return f.set(h,d);case 3:n(16);default:return f[h]=d}case c:switch(l){case 1:return"-"===h?f.push(d):f.splice(h,0,d);case 2:return f.set(h,d);case 3:return f.add(d);default:return f[h]=d}case"remove":switch(l){case 1:return f.splice(h,1);case 2:return f.delete(h);case 3:return f.delete(t.value);default:return delete f[h]}default:n(17,u)}})),r},R:function(n,r,t,e){switch(n.i){case 0:case 4:case 2:return function(n,r,t,e){var o=n.t,s=n.o;i(n.D,(function(n,i){var v=a(o,n),p=a(s,n),l=i?u(o,n)?"replace":c:"remove";if(v!==p||"replace"!==l){var d=r.concat(n);t.push("remove"===l?{op:l,path:d}:{op:l,path:d,value:p}),e.push(l===c?{op:"remove",path:d}:"remove"===l?{op:c,path:d,value:f(v)}:{op:"replace",path:d,value:f(v)})}}))}(n,r,t,e);case 5:case 1:return function(n,r,t,e){var i=n.t,o=n.D,u=n.o;if(u.length<i.length){var a=[u,i];i=a[0],u=a[1];var s=[e,t];t=s[0],e=s[1]}for(var v=0;v<i.length;v++)if(o[v]&&u[v]!==i[v]){var p=r.concat([v]);t.push({op:"replace",path:p,value:f(u[v])}),e.push({op:"replace",path:p,value:f(i[v])})}for(var l=i.length;l<u.length;l++){var d=r.concat([l]);t.push({op:c,path:d,value:f(u[l])})}i.length<u.length&&e.push({op:"replace",path:r.concat(["length"]),value:i.length})}(n,r,t,e);case 3:return function(n,r,t,e){var i=n.t,o=n.o,u=0;i.forEach((function(n){if(!o.has(n)){var i=r.concat([u]);t.push({op:"remove",path:i,value:n}),e.unshift({op:c,path:i,value:n})}u++})),u=0,o.forEach((function(n){if(!i.has(n)){var o=r.concat([u]);t.push({op:c,path:o,value:n}),e.unshift({op:"remove",path:o,value:n})}u++}))}(n,r,t,e)}},M:function(n,r,t,e){t.push({op:"replace",path:[],value:r===H?void 0:r}),e.push({op:"replace",path:[],value:n})}})}function C(){function r(n,r){function t(){this.constructor=n}a(n,r),n.prototype=(t.prototype=r.prototype,new t)}function e(n){n.o||(n.D=new Map,n.o=new Map(n.t))}function o(n){n.o||(n.o=new Set,n.t.forEach((function(r){if(t(r)){var e=R(n.A.h,r,n);n.p.set(r,e),n.o.add(e)}else n.o.add(r)})))}function u(r){r.O&&n(3,JSON.stringify(p(r)))}var a=function(n,r){return(a=Object.setPrototypeOf||{__proto__:[]}instanceof Array&&function(n,r){n.__proto__=r}||function(n,r){for(var t in r)r.hasOwnProperty(t)&&(n[t]=r[t])})(n,r)},f=function(){function n(n,r){return this[Q]={i:2,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,D:void 0,t:n,k:this,C:!1,O:!1},this}r(n,Map);var o=n.prototype;return Object.defineProperty(o,"size",{get:function(){return p(this[Q]).size}}),o.has=function(n){return p(this[Q]).has(n)},o.set=function(n,r){var t=this[Q];return u(t),p(t).has(n)&&p(t).get(n)===r||(e(t),k(t),t.D.set(n,!0),t.o.set(n,r),t.D.set(n,!0)),this},o.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),e(r),k(r),r.t.has(n)?r.D.set(n,!1):r.D.delete(n),r.o.delete(n),!0},o.clear=function(){var n=this[Q];u(n),p(n).size&&(e(n),k(n),n.D=new Map,i(n.t,(function(r){n.D.set(r,!1)})),n.o.clear())},o.forEach=function(n,r){var t=this;p(this[Q]).forEach((function(e,i){n.call(r,t.get(i),i,t)}))},o.get=function(n){var r=this[Q];u(r);var i=p(r).get(n);if(r.I||!t(i))return i;if(i!==r.t.get(n))return i;var o=R(r.A.h,i,r);return e(r),r.o.set(n,o),o},o.keys=function(){return p(this[Q]).keys()},o.values=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.values()},n.next=function(){var n=t.next();return n.done?n:{done:!1,value:r.get(n.value)}},n},o.entries=function(){var n,r=this,t=this.keys();return(n={})[V]=function(){return r.entries()},n.next=function(){var n=t.next();if(n.done)return n;var e=r.get(n.value);return{done:!1,value:[n.value,e]}},n},o[V]=function(){return this.entries()},n}(),c=function(){function n(n,r){return this[Q]={i:3,l:r,A:r?r.A:_(),P:!1,I:!1,o:void 0,t:n,k:this,p:new Map,O:!1,C:!1},this}r(n,Set);var t=n.prototype;return Object.defineProperty(t,"size",{get:function(){return p(this[Q]).size}}),t.has=function(n){var r=this[Q];return u(r),r.o?!!r.o.has(n)||!(!r.p.has(n)||!r.o.has(r.p.get(n))):r.t.has(n)},t.add=function(n){var r=this[Q];return u(r),this.has(n)||(o(r),k(r),r.o.add(n)),this},t.delete=function(n){if(!this.has(n))return!1;var r=this[Q];return u(r),o(r),k(r),r.o.delete(n)||!!r.p.has(n)&&r.o.delete(r.p.get(n))},t.clear=function(){var n=this[Q];u(n),p(n).size&&(o(n),k(n),n.o.clear())},t.values=function(){var n=this[Q];return u(n),o(n),n.o.values()},t.entries=function(){var n=this[Q];return u(n),o(n),n.o.entries()},t.keys=function(){return this.values()},t[V]=function(){return this.values()},t.forEach=function(n,r){for(var t=this.values(),e=t.next();!e.done;)n.call(r,e.value,e.value,this),e=t.next()},n}();m("MapSet",{N:function(n,r){return new f(n,r)},T:function(n,r){return new c(n,r)}})}function J(){N(),C(),T()}function K(n){return n}function $(n){return n}var G,U,W="undefined"!=typeof Symbol&&"symbol"==typeof Symbol("x"),X="undefined"!=typeof Map,q="undefined"!=typeof Set,B="undefined"!=typeof Proxy&&void 0!==Proxy.revocable&&"undefined"!=typeof Reflect,H=W?Symbol.for("immer-nothing"):((G={})["immer-nothing"]=!0,G),L=W?Symbol.for("immer-draftable"):"__$immer_draftable",Q=W?Symbol.for("immer-state"):"__$immer_state",V="undefined"!=typeof Symbol&&Symbol.iterator||"@@iterator",Y={0:"Illegal state",1:"Immer drafts cannot have computed properties",2:"This object has been frozen and should not be mutated",3:function(n){return"Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? "+n},4:"An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",5:"Immer forbids circular references",6:"The first or second argument to `produce` must be a function",7:"The third argument to `produce` must be a function or undefined",8:"First argument to `createDraft` must be a plain object, an array, or an immerable object",9:"First argument to `finishDraft` must be a draft returned by `createDraft`",10:"The given draft is already finalized",11:"Object.defineProperty() cannot be used on an Immer draft",12:"Object.setPrototypeOf() cannot be used on an Immer draft",13:"Immer only supports deleting array indices",14:"Immer only supports setting array indices and the 'length' property",15:function(n){return"Cannot apply patch, path doesn't resolve: "+n},16:'Sets cannot have "replace" patches.',17:function(n){return"Unsupported patch operation: "+n},18:function(n){return"The plugin for '"+n+"' has not been loaded into Immer. To enable the plugin, import and call `enable"+n+"()` when initializing your application."},20:"Cannot use proxies if Proxy, Proxy.revocable or Reflect are not available",21:function(n){return"produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '"+n+"'"},22:function(n){return"'current' expects a draft, got: "+n},23:function(n){return"'original' expects a draft, got: "+n},24:"Patching reserved attributes like __proto__, prototype and constructor is not allowed"},Z=""+Object.prototype.constructor,nn="undefined"!=typeof Reflect&&Reflect.ownKeys?Reflect.ownKeys:void 0!==Object.getOwnPropertySymbols?function(n){return Object.getOwnPropertyNames(n).concat(Object.getOwnPropertySymbols(n))}:Object.getOwnPropertyNames,rn=Object.getOwnPropertyDescriptors||function(n){var r={};return nn(n).forEach((function(t){r[t]=Object.getOwnPropertyDescriptor(n,t)})),r},tn={},en={get:function(n,r){if(r===Q)return n;var e=p(n);if(!u(e,r))return function(n,r,t){var e,i=I(r,t);return i?"value"in i?i.value:null===(e=i.get)||void 0===e?void 0:e.call(n.k):void 0}(n,e,r);var i=e[r];return n.I||!t(i)?i:i===z(n.t,r)?(E(n),n.o[r]=R(n.A.h,i,n)):i},has:function(n,r){return r in p(n)},ownKeys:function(n){return Reflect.ownKeys(p(n))},set:function(n,r,t){var e=I(p(n),r);if(null==e?void 0:e.set)return e.set.call(n.k,t),!0;if(!n.P){var i=z(p(n),r),o=null==i?void 0:i[Q];if(o&&o.t===t)return n.o[r]=t,n.D[r]=!1,!0;if(c(t,i)&&(void 0!==t||u(n.t,r)))return!0;E(n),k(n)}return n.o[r]===t&&"number"!=typeof t&&(void 0!==t||r in n.o)||(n.o[r]=t,n.D[r]=!0,!0)},deleteProperty:function(n,r){return void 0!==z(n.t,r)||r in n.t?(n.D[r]=!1,E(n),k(n)):delete n.D[r],n.o&&delete n.o[r],!0},getOwnPropertyDescriptor:function(n,r){var t=p(n),e=Reflect.getOwnPropertyDescriptor(t,r);return e?{writable:!0,configurable:1!==n.i||"length"!==r,enumerable:e.enumerable,value:t[r]}:e},defineProperty:function(){n(11)},getPrototypeOf:function(n){return Object.getPrototypeOf(n.t)},setPrototypeOf:function(){n(12)}},on={};i(en,(function(n,r){on[n]=function(){return arguments[0]=arguments[0][0],r.apply(this,arguments)}})),on.deleteProperty=function(r,t){return false&&0,on.set.call(this,r,t,void 0)},on.set=function(r,t,e){return false&&0,en.set.call(this,r[0],t,e,r[0])};var un=function(){function e(r){var e=this;this.g=B,this.F=!0,this.produce=function(r,i,o){if("function"==typeof r&&"function"!=typeof i){var u=i;i=r;var a=e;return function(n){var r=this;void 0===n&&(n=u);for(var t=arguments.length,e=Array(t>1?t-1:0),o=1;o<t;o++)e[o-1]=arguments[o];return a.produce(n,(function(n){var t;return(t=i).call.apply(t,[r,n].concat(e))}))}}var f;if("function"!=typeof i&&n(6),void 0!==o&&"function"!=typeof o&&n(7),t(r)){var c=w(e),s=R(e,r,void 0),v=!0;try{f=i(s),v=!1}finally{v?O(c):g(c)}return"undefined"!=typeof Promise&&f instanceof Promise?f.then((function(n){return j(c,o),P(n,c)}),(function(n){throw O(c),n})):(j(c,o),P(f,c))}if(!r||"object"!=typeof r){if(void 0===(f=i(r))&&(f=r),f===H&&(f=void 0),e.F&&d(f,!0),o){var p=[],l=[];b("Patches").M(r,f,p,l),o(p,l)}return f}n(21,r)},this.produceWithPatches=function(n,r){if("function"==typeof n)return function(r){for(var t=arguments.length,i=Array(t>1?t-1:0),o=1;o<t;o++)i[o-1]=arguments[o];return e.produceWithPatches(r,(function(r){return n.apply(void 0,[r].concat(i))}))};var t,i,o=e.produce(n,r,(function(n,r){t=n,i=r}));return"undefined"!=typeof Promise&&o instanceof Promise?o.then((function(n){return[n,t,i]})):[o,t,i]},"boolean"==typeof(null==r?void 0:r.useProxies)&&this.setUseProxies(r.useProxies),"boolean"==typeof(null==r?void 0:r.autoFreeze)&&this.setAutoFreeze(r.autoFreeze)}var i=e.prototype;return i.createDraft=function(e){t(e)||n(8),r(e)&&(e=D(e));var i=w(this),o=R(this,e,void 0);return o[Q].C=!0,g(i),o},i.finishDraft=function(r,t){var e=r&&r[Q]; false&&(0);var i=e.A;return j(i,t),P(void 0,i)},i.setAutoFreeze=function(n){this.F=n},i.setUseProxies=function(r){r&&!B&&n(20),this.g=r},i.applyPatches=function(n,t){var e;for(e=t.length-1;e>=0;e--){var i=t[e];if(0===i.path.length&&"replace"===i.op){n=i.value;break}}e>-1&&(t=t.slice(e+1));var o=b("Patches").$;return r(n)?o(n,t):this.produce(n,(function(n){return o(n,t)}))},e}(),an=new un,fn=an.produce,cn=an.produceWithPatches.bind(an),sn=an.setAutoFreeze.bind(an),vn=an.setUseProxies.bind(an),pn=an.applyPatches.bind(an),ln=an.createDraft.bind(an),dn=an.finishDraft.bind(an);/* harmony default export */ __webpack_exports__["ZP"] = (fn);
//# sourceMappingURL=immer.esm.js.map


/***/ }),

/***/ 95194:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"@print-engine/aws-secrets-manager","version":"1.0.2","description":"AWS Secrets Manager Integration JavaScript Package.","author":{"name":"Imprint Engine","url":"https://www.imprintengine.com/"},"contributors":[{"name":"Michael Ecklund","url":"https://www.imprintengine.com/"}],"copyright":"Copyright 2022 Imprint Engine","license":"Proprietary","publishConfig":{"registry":"https://npm.pkg.github.com/print-engine"},"repository":{"type":"git","url":"ssh://git@github.com:print-engine/npm-aws-secrets-manager.git"},"dependencies":{"@print-engine/utilities":"^1.0.6","axios":"^0.27.2","@aws-sdk/client-secrets-manager":"^3.100.0"},"devDependencies":{}}');

/***/ }),

/***/ 99751:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"@print-engine/cloudflare","version":"1.0.1","description":"Cloudflare Integration JavaScript Package.","author":{"name":"Imprint Engine","url":"https://www.imprintengine.com/"},"contributors":[{"name":"Michael Ecklund","url":"https://www.imprintengine.com/"}],"copyright":"Copyright 2022 Imprint Engine","license":"Proprietary","publishConfig":{"registry":"https://npm.pkg.github.com/print-engine"},"repository":{"type":"git","url":"ssh://git@github.com:print-engine/npm-cloudflare.git"},"dependencies":{"@print-engine/utilities":"^1.0.6","axios":"^0.27.2"},"devDependencies":{}}');

/***/ }),

/***/ 74091:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"@print-engine/copper","version":"1.2.2","description":"Copper Integration JavaScript Package.","author":{"name":"Imprint Engine","url":"https://www.imprintengine.com/"},"contributors":[{"name":"Michael Ecklund","url":"https://www.imprintengine.com/"}],"copyright":"Copyright 2022 Imprint Engine","license":"Proprietary","publishConfig":{"registry":"https://npm.pkg.github.com/print-engine"},"repository":{"type":"git","url":"ssh://git@github.com:print-engine/npm-copper.git"},"dependencies":{"@print-engine/utilities":"^1.0.6","@print-engine/netlify":"^1.0.1","@print-engine/google-drive":"^1.1.1","@print-engine/hasura":"^1.0.4","axios":"^0.27.2"}}');

/***/ }),

/***/ 29214:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"@print-engine/doppler","version":"1.0.1","description":"Doppler Integration JavaScript Package.","author":{"name":"Imprint Engine","url":"https://www.imprintengine.com/"},"contributors":[{"name":"Michael Ecklund","url":"https://www.imprintengine.com/"}],"copyright":"Copyright 2022 Imprint Engine","license":"Proprietary","publishConfig":{"registry":"https://npm.pkg.github.com/print-engine"},"repository":{"type":"git","url":"ssh://git@github.com:print-engine/npm-doppler.git"},"dependencies":{"@print-engine/utilities":"^1.0.6","axios":"^0.27.2"},"devDependencies":{}}');

/***/ }),

/***/ 80037:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"@print-engine/frontegg","version":"1.0.2","description":"Frontegg Integration JavaScript Package.","author":{"name":"Imprint Engine","url":"https://www.imprintengine.com/"},"contributors":[{"name":"Michael Ecklund","url":"https://www.imprintengine.com/"}],"copyright":"Copyright 2022 Imprint Engine","license":"Proprietary","publishConfig":{"registry":"https://npm.pkg.github.com/print-engine"},"repository":{"type":"git","url":"ssh://git@github.com:print-engine/npm-frontegg.git"},"dependencies":{"@print-engine/utilities":"^1.0.6","axios":"^0.27.2","jsonwebtoken":"^8.5.1","jwks-rsa":"^2.1.3"},"devDependencies":{}}');

/***/ }),

/***/ 17959:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"@print-engine/google-drive","version":"1.1.2","description":"Google Drive Integration JavaScript Package.","author":{"name":"Imprint Engine","url":"https://www.imprintengine.com/"},"contributors":[{"name":"Michael Ecklund","url":"https://www.imprintengine.com/"}],"copyright":"Copyright 2022 Imprint Engine","license":"Proprietary","publishConfig":{"registry":"https://npm.pkg.github.com/print-engine"},"repository":{"type":"git","url":"ssh://git@github.com:print-engine/npm-google-drive.git"},"dependencies":{"@print-engine/utilities":"^1.0.6","@print-engine/aws-secrets-manager":"^1.0.2","axios":"^0.27.2","jsonwebtoken":"^8.5.1","jwks-rsa":"^2.1.3"},"devDependencies":{}}');

/***/ }),

/***/ 37817:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"@print-engine/hasura","version":"1.0.4","description":"Hasura Integration JavaScript Package.","author":{"name":"Imprint Engine","url":"https://www.imprintengine.com/"},"contributors":[{"name":"Michael Ecklund","url":"https://www.imprintengine.com/"}],"copyright":"Copyright 2022 Imprint Engine","license":"Proprietary","publishConfig":{"registry":"https://npm.pkg.github.com/print-engine"},"repository":{"type":"git","url":"ssh://git@github.com:print-engine/npm-hasura.git"},"dependencies":{"@print-engine/utilities":"^1.0.6","@print-engine/frontegg":"^1.0.2","axios":"^0.27.2","graphql":"^16.5.0","graphql-tag":"^2.12.6"},"devDependencies":{}}');

/***/ }),

/***/ 31405:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"@print-engine/netlify","version":"1.0.1","description":"Netlify Integration JavaScript Package.","author":{"name":"Imprint Engine","url":"https://www.imprintengine.com/"},"contributors":[{"name":"Michael Ecklund","url":"https://www.imprintengine.com/"}],"copyright":"Copyright 2022 Imprint Engine","license":"Proprietary","publishConfig":{"registry":"https://npm.pkg.github.com/print-engine"},"repository":{"type":"git","url":"ssh://git@github.com:print-engine/npm-netlify.git"},"dependencies":{"@print-engine/utilities":"^1.0.6","axios":"^0.27.2"},"devDependencies":{}}');

/***/ }),

/***/ 57867:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"@print-engine/utilities","version":"1.0.6","description":"Various functionality to be used in JavaScript packages.","author":{"name":"Imprint Engine","url":"https://www.imprintengine.com/"},"contributors":[{"name":"Michael Ecklund","url":"https://www.imprintengine.com/"}],"copyright":"Copyright 2022 Imprint Engine","license":"Proprietary","publishConfig":{"registry":"https://npm.pkg.github.com/print-engine"},"repository":{"type":"git","url":"ssh://git@github.com:print-engine/npm-utilities.git","directory":"@print-engine/utilities"},"dependencies":{"deepmerge":"^4.2.2"},"devDependencies":{}}');

/***/ }),

/***/ 36036:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"@print-engine/woocommerce","version":"1.0.1","description":"WooCommerce Integration JavaScript Package.","author":{"name":"Imprint Engine","url":"https://www.imprintengine.com/"},"contributors":[{"name":"Michael Ecklund","url":"https://www.imprintengine.com/"}],"copyright":"Copyright 2022 Imprint Engine","license":"Proprietary","publishConfig":{"registry":"https://npm.pkg.github.com/print-engine"},"repository":{"type":"git","url":"ssh://git@github.com:print-engine/npm-woocommerce.git"},"dependencies":{"@print-engine/utilities":"^1.0.6","@print-engine/netlify":"^1.0.1","axios":"^0.27.2"},"devDependencies":{}}');

/***/ }),

/***/ 37637:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"@print-engine/wordpress","version":"1.0.1","description":"WordPress Integration JavaScript Package.","author":{"name":"Imprint Engine","url":"https://www.imprintengine.com/"},"contributors":[{"name":"Michael Ecklund","url":"https://www.imprintengine.com/"}],"copyright":"Copyright 2022 Imprint Engine","license":"Proprietary","publishConfig":{"registry":"https://npm.pkg.github.com/print-engine"},"repository":{"type":"git","url":"ssh://git@github.com:print-engine/npm-wordpress.git"},"dependencies":{"@print-engine/utilities":"^1.0.6","axios":"^0.27.2"},"devDependencies":{}}');

/***/ }),

/***/ 31678:
/***/ (function(module) {

"use strict";
module.exports = JSON.parse('{"name":"@print-engine/wpengine","version":"1.0.1","description":"Copper Integration JavaScript Package.","author":{"name":"Imprint Engine","url":"https://www.imprintengine.com/"},"contributors":[{"name":"Michael Ecklund","url":"https://www.imprintengine.com/"}],"copyright":"Copyright 2022 Imprint Engine","license":"Proprietary","publishConfig":{"registry":"https://npm.pkg.github.com/print-engine"},"repository":{"type":"git","url":"ssh://git@github.com:print-engine/npm-wpengine.git"},"dependencies":{"@print-engine/utilities":"^1.0.6","axios":"^0.27.2"},"devDependencies":{}}');

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,179], function() { return __webpack_exec__(85813), __webpack_exec__(76815), __webpack_exec__(91118), __webpack_exec__(80880); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);